webpackJsonp([0],[
/* 0 */
/* exports provided: REF_FOR_KEY, COMPONENT_UID_KEY, Vue, mergeData, isVue3, nextTick, extend */
/* exports used: nextTick, Vue, isVue3, extend, COMPONENT_UID_KEY, mergeData, REF_FOR_KEY */
/*!************************************!*\
  !*** ./~/bootstrap-vue/esm/vue.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REF_FOR_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPONENT_UID_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isVue3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nextTick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__ = __webpack_require__(/*! vue-functional-data-merge */ 1250);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_vue___default.a; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__["a"]; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }


 // --- Constants ---

var COMPONENT_UID_KEY = '_uid';
var isVue3 = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.version.startsWith('3');
var REF_FOR_KEY = isVue3 ? 'ref_for' : 'refInFor';
var ALLOWED_FIELDS_IN_DATA = ['class', 'staticClass', 'style', 'attrs', 'props', 'domProps', 'on', 'nativeOn', 'directives', 'scopedSlots', 'slot', 'key', 'ref', 'refInFor'];
var extend = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a);

if (isVue3) {
  var originalExtend = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend;
  var KNOWN_COMPONENTS = ['router-link', 'transition', 'transition-group'];
  var originalVModelDynamicCreated = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.vModelDynamic.created;
  var originalVModelDynamicBeforeUpdate = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.vModelDynamic.beforeUpdate; // See https://github.com/vuejs/vue-next/pull/4121 for details

  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.vModelDynamic.created = function (el, binding, vnode) {
    originalVModelDynamicCreated.call(this, el, binding, vnode);

    if (!el._assign) {
      el._assign = function () {};
    }
  };

  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.vModelDynamic.beforeUpdate = function (el, binding, vnode) {
    originalVModelDynamicBeforeUpdate.call(this, el, binding, vnode);

    if (!el._assign) {
      el._assign = function () {};
    }
  };

  extend = function patchedBootstrapVueExtend(definition) {
    if (_typeof(definition) === 'object' && definition.render && !definition.__alreadyPatched) {
      var originalRender = definition.render;
      definition.__alreadyPatched = true;

      definition.render = function (h) {
        var patchedH = function patchedH(tag, dataObjOrChildren, rawSlots) {
          var slots = rawSlots === undefined ? [] : [Array.isArray(rawSlots) ? rawSlots.filter(Boolean) : rawSlots];
          var isTag = typeof tag === 'string' && !KNOWN_COMPONENTS.includes(tag);
          var isSecondArgumentDataObject = dataObjOrChildren && _typeof(dataObjOrChildren) === 'object' && !Array.isArray(dataObjOrChildren);

          if (!isSecondArgumentDataObject) {
            return h.apply(void 0, [tag, dataObjOrChildren].concat(slots));
          }

          var attrs = dataObjOrChildren.attrs,
              props = dataObjOrChildren.props,
              restData = _objectWithoutProperties(dataObjOrChildren, ["attrs", "props"]);

          var normalizedData = _objectSpread(_objectSpread({}, restData), {}, {
            attrs: attrs,
            props: isTag ? {} : props
          });

          if (tag === 'router-link' && !normalizedData.slots && !normalizedData.scopedSlots) {
            // terrible workaround to fix router-link rendering with compat vue-router
            normalizedData.scopedSlots = {
              $hasNormal: function $hasNormal() {}
            };
          }

          return h.apply(void 0, [tag, normalizedData].concat(slots));
        };

        if (definition.functional) {
          var _ctx$children, _ctx$children$default;

          var ctx = arguments[1];

          var patchedCtx = _objectSpread({}, ctx);

          patchedCtx.data = {
            attrs: _objectSpread({}, ctx.data.attrs || {}),
            props: _objectSpread({}, ctx.data.props || {})
          };
          Object.keys(ctx.data || {}).forEach(function (key) {
            if (ALLOWED_FIELDS_IN_DATA.includes(key)) {
              patchedCtx.data[key] = ctx.data[key];
            } else if (key in ctx.props) {
              patchedCtx.data.props[key] = ctx.data[key];
            } else if (!key.startsWith('on')) {
              patchedCtx.data.attrs[key] = ctx.data[key];
            }
          });
          var IGNORED_CHILDREN_KEYS = ['_ctx'];
          var children = ((_ctx$children = ctx.children) === null || _ctx$children === void 0 ? void 0 : (_ctx$children$default = _ctx$children.default) === null || _ctx$children$default === void 0 ? void 0 : _ctx$children$default.call(_ctx$children)) || ctx.children;

          if (children && Object.keys(patchedCtx.children).filter(function (k) {
            return !IGNORED_CHILDREN_KEYS.includes(k);
          }).length === 0) {
            delete patchedCtx.children;
          } else {
            patchedCtx.children = children;
          }

          patchedCtx.data.on = ctx.listeners;
          return originalRender.call(this, patchedH, patchedCtx);
        }

        return originalRender.call(this, patchedH);
      };
    }

    return originalExtend.call(this, definition);
  }.bind(__WEBPACK_IMPORTED_MODULE_0_vue___default.a);
}

var nextTick = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick;


/***/ }),
/* 1 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./~/moment/moment.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(/*! ./locale */ 1144)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/module.js */ 302)(module)))

/***/ }),
/* 2 */
/* exports provided: prefixPropName, unprefixPropName, suffixPropName, makeProp, copyProps, pluckProps, makePropConfigurable, makePropsConfigurable, hasPropFunction */
/* exports used: makeProp, makePropsConfigurable, pluckProps, hasPropFunction, suffixPropName, unprefixPropName, copyProps, prefixPropName */
/*!********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/props.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return prefixPropName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return unprefixPropName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return suffixPropName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return copyProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pluckProps; });
/* unused harmony export makePropConfigurable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makePropsConfigurable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasPropFunction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clone_deep__ = __webpack_require__(/*! ./clone-deep */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(/*! ./config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__identity__ = __webpack_require__(/*! ./identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(/*! ./object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(/*! ./string */ 23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // Prefix a property

var prefixPropName = function prefixPropName(prefix, value) {
  return prefix + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__string__["c" /* upperFirst */])(value);
}; // Remove a prefix from a property

var unprefixPropName = function unprefixPropName(prefix, value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__string__["d" /* lowerFirst */])(value.replace(prefix, ''));
}; // Suffix can be a falsey value so nothing is appended to string
// (helps when looping over props & some shouldn't change)
// Use data last parameters to allow for currying

var suffixPropName = function suffixPropName(suffix, value) {
  return value + (suffix ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__string__["c" /* upperFirst */])(suffix) : '');
}; // Generates a prop object

var makeProp = function makeProp() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0__constants_props__["f" /* PROP_TYPE_ANY */];
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var requiredOrValidator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var validator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var required = requiredOrValidator === true;
  validator = required ? validator : requiredOrValidator;
  return _objectSpread(_objectSpread(_objectSpread({}, type ? {
    type: type
  } : {}), required ? {
    required: required
  } : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["i" /* isUndefined */])(value) ? {} : {
    default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["d" /* isObject */])(value) ? function () {
      return value;
    } : value
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["i" /* isUndefined */])(validator) ? {} : {
    validator: validator
  });
}; // Copies props from one array/object to a new array/object
// Prop values are also cloned as new references to prevent possible
// mutation of original prop object values
// Optionally accepts a function to transform the prop name

var copyProps = function copyProps(props) {
  var transformFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_3__identity__["a" /* identity */];

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["c" /* isArray */])(props)) {
    return props.map(transformFn);
  }

  var copied = {};

  for (var prop in props) {
    /* istanbul ignore else */
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__object__["c" /* hasOwnProperty */])(props, prop)) {
      // If the prop value is an object, do a shallow clone
      // to prevent potential mutations to the original object
      copied[transformFn(prop)] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["d" /* isObject */])(props[prop]) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__object__["b" /* clone */])(props[prop]) : props[prop];
    }
  }

  return copied;
}; // Given an array of properties or an object of property keys,
// plucks all the values off the target object, returning a new object
// that has props that reference the original prop values

var pluckProps = function pluckProps(keysToPluck, objToPluck) {
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_3__identity__["a" /* identity */];
  return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["c" /* isArray */])(keysToPluck) ? keysToPluck.slice() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__object__["a" /* keys */])(keysToPluck)).reduce(function (memo, prop) {
    memo[transformFn(prop)] = objToPluck[prop];
    return memo;
  }, {});
}; // Make a prop object configurable by global configuration
// Replaces the current `default` key of each prop with a `getComponentConfig()`
// call that falls back to the current default value of the prop

var makePropConfigurable = function makePropConfigurable(prop, key, componentKey) {
  return _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clone_deep__["a" /* cloneDeep */])(prop)), {}, {
    default: function bvConfigurablePropDefault() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* getComponentConfig */])(componentKey, key, prop.default);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["a" /* isFunction */])(value) ? value() : value;
    }
  });
}; // Make a props object configurable by global configuration
// Replaces the current `default` key of each prop with a `getComponentConfig()`
// call that falls back to the current default value of the prop

var makePropsConfigurable = function makePropsConfigurable(props, componentKey) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__object__["a" /* keys */])(props).reduce(function (result, key) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, makePropConfigurable(props[key], key, componentKey)));
  }, {});
}; // Get function name we use in `makePropConfigurable()`
// for the prop default value override to compare
// against in `hasPropFunction()`

var configurablePropDefaultFnName = makePropConfigurable({}, '', '').default.name; // Detect wether the given value is currently a function
// and isn't the props default function

var hasPropFunction = function hasPropFunction(fn) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["a" /* isFunction */])(fn) && fn.name && fn.name !== configurablePropDefaultFnName;
};

/***/ }),
/* 3 */
/* exports provided: PROP_TYPE_ANY, PROP_TYPE_ARRAY, PROP_TYPE_BOOLEAN, PROP_TYPE_DATE, PROP_TYPE_FUNCTION, PROP_TYPE_NUMBER, PROP_TYPE_OBJECT, PROP_TYPE_REG_EXP, PROP_TYPE_STRING, PROP_TYPE_ARRAY_FUNCTION, PROP_TYPE_ARRAY_OBJECT, PROP_TYPE_ARRAY_OBJECT_STRING, PROP_TYPE_ARRAY_STRING, PROP_TYPE_BOOLEAN_NUMBER, PROP_TYPE_BOOLEAN_NUMBER_STRING, PROP_TYPE_BOOLEAN_STRING, PROP_TYPE_DATE_STRING, PROP_TYPE_FUNCTION_STRING, PROP_TYPE_NUMBER_STRING, PROP_TYPE_NUMBER_OBJECT_STRING, PROP_TYPE_OBJECT_FUNCTION, PROP_TYPE_OBJECT_STRING */
/* exports used: PROP_TYPE_BOOLEAN, PROP_TYPE_STRING, PROP_TYPE_NUMBER_STRING, PROP_TYPE_ARRAY_STRING, PROP_TYPE_OBJECT, PROP_TYPE_ANY, PROP_TYPE_NUMBER_OBJECT_STRING, PROP_TYPE_FUNCTION, PROP_TYPE_ARRAY_OBJECT_STRING, PROP_TYPE_OBJECT_STRING, PROP_TYPE_BOOLEAN_NUMBER, PROP_TYPE_NUMBER, PROP_TYPE_BOOLEAN_STRING, PROP_TYPE_OBJECT_FUNCTION, PROP_TYPE_ARRAY, PROP_TYPE_ARRAY_FUNCTION, PROP_TYPE_REG_EXP, PROP_TYPE_BOOLEAN_NUMBER_STRING, PROP_TYPE_FUNCTION_STRING, PROP_TYPE_DATE_STRING, PROP_TYPE_ARRAY_OBJECT */
/*!************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/props.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PROP_TYPE_ANY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PROP_TYPE_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROP_TYPE_BOOLEAN; });
/* unused harmony export PROP_TYPE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROP_TYPE_FUNCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PROP_TYPE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PROP_TYPE_OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PROP_TYPE_REG_EXP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROP_TYPE_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PROP_TYPE_ARRAY_FUNCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PROP_TYPE_ARRAY_OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROP_TYPE_ARRAY_OBJECT_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PROP_TYPE_ARRAY_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PROP_TYPE_BOOLEAN_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PROP_TYPE_BOOLEAN_NUMBER_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PROP_TYPE_BOOLEAN_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PROP_TYPE_DATE_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PROP_TYPE_FUNCTION_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROP_TYPE_NUMBER_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROP_TYPE_NUMBER_OBJECT_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PROP_TYPE_OBJECT_FUNCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PROP_TYPE_OBJECT_STRING; });
// General types
var PROP_TYPE_ANY = undefined;
var PROP_TYPE_ARRAY = Array;
var PROP_TYPE_BOOLEAN = Boolean;
var PROP_TYPE_DATE = Date;
var PROP_TYPE_FUNCTION = Function;
var PROP_TYPE_NUMBER = Number;
var PROP_TYPE_OBJECT = Object;
var PROP_TYPE_REG_EXP = RegExp;
var PROP_TYPE_STRING = String; // Multiple types

var PROP_TYPE_ARRAY_FUNCTION = [PROP_TYPE_ARRAY, PROP_TYPE_FUNCTION];
var PROP_TYPE_ARRAY_OBJECT = [PROP_TYPE_ARRAY, PROP_TYPE_OBJECT];
var PROP_TYPE_ARRAY_OBJECT_STRING = [PROP_TYPE_ARRAY, PROP_TYPE_OBJECT, PROP_TYPE_STRING];
var PROP_TYPE_ARRAY_STRING = [PROP_TYPE_ARRAY, PROP_TYPE_STRING];
var PROP_TYPE_BOOLEAN_NUMBER = [PROP_TYPE_BOOLEAN, PROP_TYPE_NUMBER];
var PROP_TYPE_BOOLEAN_NUMBER_STRING = [PROP_TYPE_BOOLEAN, PROP_TYPE_NUMBER, PROP_TYPE_STRING];
var PROP_TYPE_BOOLEAN_STRING = [PROP_TYPE_BOOLEAN, PROP_TYPE_STRING];
var PROP_TYPE_DATE_STRING = [PROP_TYPE_DATE, PROP_TYPE_STRING];
var PROP_TYPE_FUNCTION_STRING = [PROP_TYPE_FUNCTION, PROP_TYPE_STRING];
var PROP_TYPE_NUMBER_STRING = [PROP_TYPE_NUMBER, PROP_TYPE_STRING];
var PROP_TYPE_NUMBER_OBJECT_STRING = [PROP_TYPE_NUMBER, PROP_TYPE_OBJECT, PROP_TYPE_STRING];
var PROP_TYPE_OBJECT_FUNCTION = [PROP_TYPE_OBJECT, PROP_TYPE_FUNCTION];
var PROP_TYPE_OBJECT_STRING = [PROP_TYPE_OBJECT, PROP_TYPE_STRING];

/***/ }),
/* 4 */
/* exports provided: NAME_ALERT, NAME_ASPECT, NAME_AVATAR, NAME_AVATAR_GROUP, NAME_BADGE, NAME_BREADCRUMB, NAME_BREADCRUMB_ITEM, NAME_BREADCRUMB_LINK, NAME_BUTTON, NAME_BUTTON_CLOSE, NAME_BUTTON_GROUP, NAME_BUTTON_TOOLBAR, NAME_CALENDAR, NAME_CARD, NAME_CARD_BODY, NAME_CARD_FOOTER, NAME_CARD_GROUP, NAME_CARD_HEADER, NAME_CARD_IMG, NAME_CARD_IMG_LAZY, NAME_CARD_SUB_TITLE, NAME_CARD_TEXT, NAME_CARD_TITLE, NAME_CAROUSEL, NAME_CAROUSEL_SLIDE, NAME_COL, NAME_COLLAPSE, NAME_CONTAINER, NAME_DROPDOWN, NAME_DROPDOWN_DIVIDER, NAME_DROPDOWN_FORM, NAME_DROPDOWN_GROUP, NAME_DROPDOWN_HEADER, NAME_DROPDOWN_ITEM, NAME_DROPDOWN_ITEM_BUTTON, NAME_DROPDOWN_TEXT, NAME_EMBED, NAME_FORM, NAME_FORM_CHECKBOX, NAME_FORM_CHECKBOX_GROUP, NAME_FORM_DATALIST, NAME_FORM_DATEPICKER, NAME_FORM_FILE, NAME_FORM_GROUP, NAME_FORM_INPUT, NAME_FORM_INVALID_FEEDBACK, NAME_FORM_RADIO, NAME_FORM_RADIO_GROUP, NAME_FORM_RATING, NAME_FORM_ROW, NAME_FORM_SELECT, NAME_FORM_SELECT_OPTION, NAME_FORM_SELECT_OPTION_GROUP, NAME_FORM_SPINBUTTON, NAME_FORM_TAG, NAME_FORM_TAGS, NAME_FORM_TEXT, NAME_FORM_TEXTAREA, NAME_FORM_TIMEPICKER, NAME_FORM_VALID_FEEDBACK, NAME_ICON, NAME_ICONSTACK, NAME_ICON_BASE, NAME_IMG, NAME_IMG_LAZY, NAME_INPUT_GROUP, NAME_INPUT_GROUP_ADDON, NAME_INPUT_GROUP_APPEND, NAME_INPUT_GROUP_PREPEND, NAME_INPUT_GROUP_TEXT, NAME_JUMBOTRON, NAME_LINK, NAME_LIST_GROUP, NAME_LIST_GROUP_ITEM, NAME_MEDIA, NAME_MEDIA_ASIDE, NAME_MEDIA_BODY, NAME_MODAL, NAME_MSG_BOX, NAME_NAV, NAME_NAVBAR, NAME_NAVBAR_BRAND, NAME_NAVBAR_NAV, NAME_NAVBAR_TOGGLE, NAME_NAV_FORM, NAME_NAV_ITEM, NAME_NAV_ITEM_DROPDOWN, NAME_NAV_TEXT, NAME_OVERLAY, NAME_PAGINATION, NAME_PAGINATION_NAV, NAME_POPOVER, NAME_PROGRESS, NAME_PROGRESS_BAR, NAME_ROW, NAME_SIDEBAR, NAME_SKELETON, NAME_SKELETON_ICON, NAME_SKELETON_IMG, NAME_SKELETON_TABLE, NAME_SKELETON_WRAPPER, NAME_SPINNER, NAME_TAB, NAME_TABLE, NAME_TABLE_CELL, NAME_TABLE_LITE, NAME_TABLE_SIMPLE, NAME_TABS, NAME_TBODY, NAME_TFOOT, NAME_TH, NAME_THEAD, NAME_TIME, NAME_TOAST, NAME_TOASTER, NAME_TOOLTIP, NAME_TR, NAME_COLLAPSE_HELPER, NAME_FORM_BUTTON_LABEL_CONTROL, NAME_FORM_RATING_STAR, NAME_POPOVER_HELPER, NAME_POPOVER_TEMPLATE, NAME_POPPER, NAME_TAB_BUTTON_HELPER, NAME_TOAST_POP, NAME_TOOLTIP_HELPER, NAME_TOOLTIP_TEMPLATE, NAME_TRANSITION, NAME_TRANSPORTER, NAME_TRANSPORTER_TARGET */
/* exports used: NAME_TOOLTIP, NAME_MODAL, NAME_TOOLTIP_HELPER, NAME_TOOLTIP_TEMPLATE, NAME_POPPER, NAME_TRANSITION, NAME_COLLAPSE, NAME_POPOVER, NAME_POPOVER_HELPER, NAME_POPOVER_TEMPLATE, NAME_TOASTER, NAME_TOAST, NAME_LINK, NAME_TIME, NAME_FORM_SPINBUTTON, NAME_TAB, NAME_TAB_BUTTON_HELPER, NAME_TABS, NAME_NAV, NAME_TABLE_CELL, NAME_TH, NAME_TR, NAME_TFOOT, NAME_THEAD, NAME_TBODY, NAME_TABLE_SIMPLE, NAME_TABLE_LITE, NAME_TABLE, NAME_SPINNER, NAME_SKELETON_WRAPPER, NAME_SKELETON_TABLE, NAME_SKELETON_IMG, NAME_SKELETON_ICON, NAME_SKELETON, NAME_SIDEBAR, NAME_PROGRESS_BAR, NAME_PROGRESS, NAME_PAGINATION_NAV, NAME_PAGINATION, NAME_OVERLAY, NAME_NAVBAR_TOGGLE, NAME_NAVBAR_NAV, NAME_NAVBAR_BRAND, NAME_NAVBAR, NAME_NAV_TEXT, NAME_NAV_ITEM_DROPDOWN, NAME_DROPDOWN, NAME_NAV_ITEM, NAME_NAV_FORM, NAME_FORM, NAME_TRANSPORTER_TARGET, NAME_TRANSPORTER, NAME_MEDIA_BODY, NAME_MEDIA_ASIDE, NAME_MEDIA, NAME_LIST_GROUP_ITEM, NAME_LIST_GROUP, NAME_FORM_ROW, NAME_COL, NAME_ROW, NAME_CONTAINER, NAME_JUMBOTRON, NAME_INPUT_GROUP_TEXT, NAME_INPUT_GROUP_PREPEND, NAME_INPUT_GROUP_ADDON, NAME_INPUT_GROUP_APPEND, NAME_INPUT_GROUP, NAME_IMG_LAZY, NAME_IMG, NAME_FORM_TIMEPICKER, NAME_FORM_BUTTON_LABEL_CONTROL, NAME_FORM_TEXTAREA, NAME_FORM_SELECT_OPTION_GROUP, NAME_FORM_SELECT_OPTION, NAME_FORM_SELECT, NAME_FORM_TAG, NAME_FORM_TAGS, NAME_FORM_RATING_STAR, NAME_FORM_RATING, NAME_FORM_RADIO_GROUP, NAME_FORM_RADIO, NAME_FORM_INPUT, NAME_FORM_GROUP, NAME_FORM_FILE, NAME_FORM_DATEPICKER, NAME_CALENDAR, NAME_FORM_CHECKBOX_GROUP, NAME_FORM_CHECKBOX, NAME_FORM_VALID_FEEDBACK, NAME_FORM_INVALID_FEEDBACK, NAME_FORM_TEXT, NAME_FORM_DATALIST, NAME_EMBED, NAME_DROPDOWN_TEXT, NAME_DROPDOWN_HEADER, NAME_DROPDOWN_GROUP, NAME_DROPDOWN_FORM, NAME_DROPDOWN_DIVIDER, NAME_DROPDOWN_ITEM_BUTTON, NAME_DROPDOWN_ITEM, NAME_COLLAPSE_HELPER, NAME_CAROUSEL_SLIDE, NAME_CAROUSEL, NAME_CARD_TITLE, NAME_CARD_TEXT, NAME_CARD_SUB_TITLE, NAME_CARD_IMG_LAZY, NAME_CARD_IMG, NAME_CARD_HEADER, NAME_CARD, NAME_CARD_GROUP, NAME_CARD_FOOTER, NAME_CARD_BODY, NAME_BUTTON_TOOLBAR, NAME_BUTTON_GROUP, NAME_BUTTON, NAME_BUTTON_CLOSE, NAME_BREADCRUMB_ITEM, NAME_BREADCRUMB_LINK, NAME_BREADCRUMB, NAME_BADGE, NAME_AVATAR_GROUP, NAME_AVATAR, NAME_ASPECT, NAME_ALERT, NAME_ICON_BASE, NAME_ICONSTACK, NAME_ICON, NAME_TOAST_POP, NAME_MSG_BOX */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/components.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return NAME_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return NAME_ASPECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return NAME_AVATAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return NAME_AVATAR_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return NAME_BADGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return NAME_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return NAME_BREADCRUMB_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return NAME_BREADCRUMB_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return NAME_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return NAME_BUTTON_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return NAME_BUTTON_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return NAME_BUTTON_TOOLBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return NAME_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return NAME_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return NAME_CARD_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return NAME_CARD_FOOTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return NAME_CARD_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return NAME_CARD_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return NAME_CARD_IMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return NAME_CARD_IMG_LAZY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return NAME_CARD_SUB_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return NAME_CARD_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return NAME_CARD_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return NAME_CAROUSEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return NAME_CAROUSEL_SLIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return NAME_COL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NAME_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return NAME_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return NAME_DROPDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return NAME_DROPDOWN_DIVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return NAME_DROPDOWN_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return NAME_DROPDOWN_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return NAME_DROPDOWN_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return NAME_DROPDOWN_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return NAME_DROPDOWN_ITEM_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return NAME_DROPDOWN_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return NAME_EMBED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return NAME_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return NAME_FORM_CHECKBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return NAME_FORM_CHECKBOX_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return NAME_FORM_DATALIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return NAME_FORM_DATEPICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return NAME_FORM_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return NAME_FORM_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return NAME_FORM_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return NAME_FORM_INVALID_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return NAME_FORM_RADIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return NAME_FORM_RADIO_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return NAME_FORM_RATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return NAME_FORM_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return NAME_FORM_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return NAME_FORM_SELECT_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return NAME_FORM_SELECT_OPTION_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return NAME_FORM_SPINBUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return NAME_FORM_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return NAME_FORM_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return NAME_FORM_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return NAME_FORM_TEXTAREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return NAME_FORM_TIMEPICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return NAME_FORM_VALID_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return NAME_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return NAME_ICONSTACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return NAME_ICON_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return NAME_IMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return NAME_IMG_LAZY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return NAME_INPUT_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return NAME_INPUT_GROUP_ADDON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return NAME_INPUT_GROUP_APPEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return NAME_INPUT_GROUP_PREPEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return NAME_INPUT_GROUP_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return NAME_JUMBOTRON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NAME_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return NAME_LIST_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return NAME_LIST_GROUP_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return NAME_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return NAME_MEDIA_ASIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return NAME_MEDIA_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAME_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return NAME_MSG_BOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return NAME_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return NAME_NAVBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return NAME_NAVBAR_BRAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return NAME_NAVBAR_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return NAME_NAVBAR_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return NAME_NAV_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return NAME_NAV_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return NAME_NAV_ITEM_DROPDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return NAME_NAV_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return NAME_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return NAME_PAGINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return NAME_PAGINATION_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NAME_POPOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return NAME_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return NAME_PROGRESS_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return NAME_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return NAME_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return NAME_SKELETON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return NAME_SKELETON_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return NAME_SKELETON_IMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return NAME_SKELETON_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return NAME_SKELETON_WRAPPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return NAME_SPINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NAME_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return NAME_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return NAME_TABLE_CELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NAME_TABLE_LITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NAME_TABLE_SIMPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return NAME_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return NAME_TBODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return NAME_TFOOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return NAME_TH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return NAME_THEAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NAME_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NAME_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NAME_TOASTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME_TOOLTIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return NAME_TR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return NAME_COLLAPSE_HELPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return NAME_FORM_BUTTON_LABEL_CONTROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return NAME_FORM_RATING_STAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NAME_POPOVER_HELPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NAME_POPOVER_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NAME_POPPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return NAME_TAB_BUTTON_HELPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return NAME_TOAST_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAME_TOOLTIP_HELPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NAME_TOOLTIP_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NAME_TRANSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return NAME_TRANSPORTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return NAME_TRANSPORTER_TARGET; });
// Component names
var NAME_ALERT = 'BAlert';
var NAME_ASPECT = 'BAspect';
var NAME_AVATAR = 'BAvatar';
var NAME_AVATAR_GROUP = 'BAvatarGroup';
var NAME_BADGE = 'BBadge';
var NAME_BREADCRUMB = 'BBreadcrumb';
var NAME_BREADCRUMB_ITEM = 'BBreadcrumbItem';
var NAME_BREADCRUMB_LINK = 'BBreadcrumbLink';
var NAME_BUTTON = 'BButton';
var NAME_BUTTON_CLOSE = 'BButtonClose';
var NAME_BUTTON_GROUP = 'BButtonGroup';
var NAME_BUTTON_TOOLBAR = 'BButtonToolbar';
var NAME_CALENDAR = 'BCalendar';
var NAME_CARD = 'BCard';
var NAME_CARD_BODY = 'BCardBody';
var NAME_CARD_FOOTER = 'BCardFooter';
var NAME_CARD_GROUP = 'BCardGroup';
var NAME_CARD_HEADER = 'BCardHeader';
var NAME_CARD_IMG = 'BCardImg';
var NAME_CARD_IMG_LAZY = 'BCardImgLazy';
var NAME_CARD_SUB_TITLE = 'BCardSubTitle';
var NAME_CARD_TEXT = 'BCardText';
var NAME_CARD_TITLE = 'BCardTitle';
var NAME_CAROUSEL = 'BCarousel';
var NAME_CAROUSEL_SLIDE = 'BCarouselSlide';
var NAME_COL = 'BCol';
var NAME_COLLAPSE = 'BCollapse';
var NAME_CONTAINER = 'BContainer';
var NAME_DROPDOWN = 'BDropdown';
var NAME_DROPDOWN_DIVIDER = 'BDropdownDivider';
var NAME_DROPDOWN_FORM = 'BDropdownForm';
var NAME_DROPDOWN_GROUP = 'BDropdownGroup';
var NAME_DROPDOWN_HEADER = 'BDropdownHeader';
var NAME_DROPDOWN_ITEM = 'BDropdownItem';
var NAME_DROPDOWN_ITEM_BUTTON = 'BDropdownItemButton';
var NAME_DROPDOWN_TEXT = 'BDropdownText';
var NAME_EMBED = 'BEmbed';
var NAME_FORM = 'BForm';
var NAME_FORM_CHECKBOX = 'BFormCheckbox';
var NAME_FORM_CHECKBOX_GROUP = 'BFormCheckboxGroup';
var NAME_FORM_DATALIST = 'BFormDatalist';
var NAME_FORM_DATEPICKER = 'BFormDatepicker';
var NAME_FORM_FILE = 'BFormFile';
var NAME_FORM_GROUP = 'BFormGroup';
var NAME_FORM_INPUT = 'BFormInput';
var NAME_FORM_INVALID_FEEDBACK = 'BFormInvalidFeedback';
var NAME_FORM_RADIO = 'BFormRadio';
var NAME_FORM_RADIO_GROUP = 'BFormRadioGroup';
var NAME_FORM_RATING = 'BFormRating';
var NAME_FORM_ROW = 'BFormRow';
var NAME_FORM_SELECT = 'BFormSelect';
var NAME_FORM_SELECT_OPTION = 'BFormSelectOption';
var NAME_FORM_SELECT_OPTION_GROUP = 'BFormSelectOptionGroup';
var NAME_FORM_SPINBUTTON = 'BFormSpinbutton';
var NAME_FORM_TAG = 'BFormTag';
var NAME_FORM_TAGS = 'BFormTags';
var NAME_FORM_TEXT = 'BFormText';
var NAME_FORM_TEXTAREA = 'BFormTextarea';
var NAME_FORM_TIMEPICKER = 'BFormTimepicker';
var NAME_FORM_VALID_FEEDBACK = 'BFormValidFeedback';
var NAME_ICON = 'BIcon';
var NAME_ICONSTACK = 'BIconstack';
var NAME_ICON_BASE = 'BIconBase';
var NAME_IMG = 'BImg';
var NAME_IMG_LAZY = 'BImgLazy';
var NAME_INPUT_GROUP = 'BInputGroup';
var NAME_INPUT_GROUP_ADDON = 'BInputGroupAddon';
var NAME_INPUT_GROUP_APPEND = 'BInputGroupAppend';
var NAME_INPUT_GROUP_PREPEND = 'BInputGroupPrepend';
var NAME_INPUT_GROUP_TEXT = 'BInputGroupText';
var NAME_JUMBOTRON = 'BJumbotron';
var NAME_LINK = 'BLink';
var NAME_LIST_GROUP = 'BListGroup';
var NAME_LIST_GROUP_ITEM = 'BListGroupItem';
var NAME_MEDIA = 'BMedia';
var NAME_MEDIA_ASIDE = 'BMediaAside';
var NAME_MEDIA_BODY = 'BMediaBody';
var NAME_MODAL = 'BModal';
var NAME_MSG_BOX = 'BMsgBox';
var NAME_NAV = 'BNav';
var NAME_NAVBAR = 'BNavbar';
var NAME_NAVBAR_BRAND = 'BNavbarBrand';
var NAME_NAVBAR_NAV = 'BNavbarNav';
var NAME_NAVBAR_TOGGLE = 'BNavbarToggle';
var NAME_NAV_FORM = 'BNavForm';
var NAME_NAV_ITEM = 'BNavItem';
var NAME_NAV_ITEM_DROPDOWN = 'BNavItemDropdown';
var NAME_NAV_TEXT = 'BNavText';
var NAME_OVERLAY = 'BOverlay';
var NAME_PAGINATION = 'BPagination';
var NAME_PAGINATION_NAV = 'BPaginationNav';
var NAME_POPOVER = 'BPopover';
var NAME_PROGRESS = 'BProgress';
var NAME_PROGRESS_BAR = 'BProgressBar';
var NAME_ROW = 'BRow';
var NAME_SIDEBAR = 'BSidebar';
var NAME_SKELETON = 'BSkeleton';
var NAME_SKELETON_ICON = 'BSkeletonIcon';
var NAME_SKELETON_IMG = 'BSkeletonImg';
var NAME_SKELETON_TABLE = 'BSkeletonTable';
var NAME_SKELETON_WRAPPER = 'BSkeletonWrapper';
var NAME_SPINNER = 'BSpinner';
var NAME_TAB = 'BTab';
var NAME_TABLE = 'BTable';
var NAME_TABLE_CELL = 'BTableCell';
var NAME_TABLE_LITE = 'BTableLite';
var NAME_TABLE_SIMPLE = 'BTableSimple';
var NAME_TABS = 'BTabs';
var NAME_TBODY = 'BTbody';
var NAME_TFOOT = 'BTfoot';
var NAME_TH = 'BTh';
var NAME_THEAD = 'BThead';
var NAME_TIME = 'BTime';
var NAME_TOAST = 'BToast';
var NAME_TOASTER = 'BToaster';
var NAME_TOOLTIP = 'BTooltip';
var NAME_TR = 'BTr'; // Helper component names

var NAME_COLLAPSE_HELPER = 'BVCollapse';
var NAME_FORM_BUTTON_LABEL_CONTROL = 'BVFormBtnLabelControl';
var NAME_FORM_RATING_STAR = 'BVFormRatingStar';
var NAME_POPOVER_HELPER = 'BVPopover';
var NAME_POPOVER_TEMPLATE = 'BVPopoverTemplate';
var NAME_POPPER = 'BVPopper';
var NAME_TAB_BUTTON_HELPER = 'BVTabButton';
var NAME_TOAST_POP = 'BVToastPop';
var NAME_TOOLTIP_HELPER = 'BVTooltip';
var NAME_TOOLTIP_TEMPLATE = 'BVTooltipTemplate';
var NAME_TRANSITION = 'BVTransition';
var NAME_TRANSPORTER = 'BVTransporter';
var NAME_TRANSPORTER_TARGET = 'BVTransporterTarget';

/***/ }),
/* 5 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/vue-loader/lib/component-normalizer.js ***!
  \**************************************************/
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 6 */
/* exports provided: assign, create, defineProperties, defineProperty, freeze, getOwnPropertyNames, getOwnPropertyDescriptor, getOwnPropertySymbols, getPrototypeOf, is, isFrozen, keys, hasOwnProperty, toString, clone, pick, omit, mergeDeep, sortKeys, readonlyDescriptor */
/* exports used: keys, clone, hasOwnProperty, getOwnPropertyNames, assign, defineProperties, readonlyDescriptor, defineProperty, create, toString, pick, sortKeys, omit, mergeDeep */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/object.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defineProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defineProperty; });
/* unused harmony export freeze */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOwnPropertyNames; });
/* unused harmony export getOwnPropertyDescriptor */
/* unused harmony export getOwnPropertySymbols */
/* unused harmony export getPrototypeOf */
/* unused harmony export is */
/* unused harmony export isFrozen */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return omit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return mergeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sortKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return readonlyDescriptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspect__ = __webpack_require__(/*! ./inspect */ 9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // --- Static ---

var assign = function assign() {
  return Object.assign.apply(Object, arguments);
};
var create = function create(proto, optionalProps) {
  return Object.create(proto, optionalProps);
};
var defineProperties = function defineProperties(obj, props) {
  return Object.defineProperties(obj, props);
};
var defineProperty = function defineProperty(obj, prop, descriptor) {
  return Object.defineProperty(obj, prop, descriptor);
};
var freeze = function freeze(obj) {
  return Object.freeze(obj);
};
var getOwnPropertyNames = function getOwnPropertyNames(obj) {
  return Object.getOwnPropertyNames(obj);
};
var getOwnPropertyDescriptor = function getOwnPropertyDescriptor(obj, prop) {
  return Object.getOwnPropertyDescriptor(obj, prop);
};
var getOwnPropertySymbols = function getOwnPropertySymbols(obj) {
  return Object.getOwnPropertySymbols(obj);
};
var getPrototypeOf = function getPrototypeOf(obj) {
  return Object.getPrototypeOf(obj);
};
var is = function is(value1, value2) {
  return Object.is(value1, value2);
};
var isFrozen = function isFrozen(obj) {
  return Object.isFrozen(obj);
};
var keys = function keys(obj) {
  return Object.keys(obj);
}; // --- "Instance" ---

var hasOwnProperty = function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};
var toString = function toString(obj) {
  return Object.prototype.toString.call(obj);
}; // --- Utilities ---
// Shallow copy an object

var clone = function clone(obj) {
  return _objectSpread({}, obj);
}; // Return a shallow copy of object with the specified properties only
// See: https://gist.github.com/bisubus/2da8af7e801ffd813fab7ac221aa7afc

var pick = function pick(obj, props) {
  return keys(obj).filter(function (key) {
    return props.indexOf(key) !== -1;
  }).reduce(function (result, key) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, obj[key]));
  }, {});
}; // Return a shallow copy of object with the specified properties omitted
// See: https://gist.github.com/bisubus/2da8af7e801ffd813fab7ac221aa7afc

var omit = function omit(obj, props) {
  return keys(obj).filter(function (key) {
    return props.indexOf(key) === -1;
  }).reduce(function (result, key) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, obj[key]));
  }, {});
}; // Merges two object deeply together
// See: https://gist.github.com/Salakar/1d7137de9cb8b704e48a

var mergeDeep = function mergeDeep(target, source) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["d" /* isObject */])(target) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["d" /* isObject */])(source)) {
    keys(source).forEach(function (key) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["d" /* isObject */])(source[key])) {
        if (!target[key] || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["d" /* isObject */])(target[key])) {
          target[key] = source[key];
        }

        mergeDeep(target[key], source[key]);
      } else {
        assign(target, _defineProperty({}, key, source[key]));
      }
    });
  }

  return target;
}; // Returns a shallow copy of the object with keys in sorted order

var sortKeys = function sortKeys(obj) {
  return keys(obj).sort().reduce(function (result, key) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, obj[key]));
  }, {});
}; // Convenience method to create a read-only descriptor

var readonlyDescriptor = function readonlyDescriptor() {
  return {
    enumerable: true,
    configurable: false,
    writable: false
  };
};

/***/ }),
/* 7 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./~/css-loader/lib/css-base.js ***!
  \**************************************/
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 8 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader/lib/addStylesClient.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(/*! ./listToStyles */ 1565)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 9 */
/* exports provided: toType, toRawType, toRawTypeLC, isUndefined, isNull, isEmptyString, isUndefinedOrNull, isUndefinedOrNullOrEmpty, isFunction, isBoolean, isString, isNumber, isNumeric, isPrimitive, isArray, isObject, isPlainObject, isDate, isEvent, isFile, isRegExp, isPromise */
/* exports used: isFunction, isDate, isArray, isObject, isNull, isString, isUndefinedOrNull, isPlainObject, isUndefined, isNumber, isBoolean, isEvent, isPromise, isNumeric, isRegExp, isFile */
/*!**********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/inspect.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toType */
/* unused harmony export toRawType */
/* unused harmony export toRawTypeLC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isNull; });
/* unused harmony export isEmptyString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isUndefinedOrNull; });
/* unused harmony export isUndefinedOrNullOrEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isNumeric; });
/* unused harmony export isPrimitive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPlainObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_safe_types__ = __webpack_require__(/*! ../constants/safe-types */ 93);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }


 // --- Convenience inspection utilities ---

var toType = function toType(value) {
  return _typeof(value);
};
var toRawType = function toRawType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
};
var toRawTypeLC = function toRawTypeLC(value) {
  return toRawType(value).toLowerCase();
};
var isUndefined = function isUndefined(value) {
  return value === undefined;
};
var isNull = function isNull(value) {
  return value === null;
};
var isEmptyString = function isEmptyString(value) {
  return value === '';
};
var isUndefinedOrNull = function isUndefinedOrNull(value) {
  return isUndefined(value) || isNull(value);
};
var isUndefinedOrNullOrEmpty = function isUndefinedOrNullOrEmpty(value) {
  return isUndefinedOrNull(value) || isEmptyString(value);
};
var isFunction = function isFunction(value) {
  return toType(value) === 'function';
};
var isBoolean = function isBoolean(value) {
  return toType(value) === 'boolean';
};
var isString = function isString(value) {
  return toType(value) === 'string';
};
var isNumber = function isNumber(value) {
  return toType(value) === 'number';
};
var isNumeric = function isNumeric(value) {
  return __WEBPACK_IMPORTED_MODULE_0__constants_regex__["b" /* RX_NUMBER */].test(String(value));
};
var isPrimitive = function isPrimitive(value) {
  return isBoolean(value) || isString(value) || isNumber(value);
};
var isArray = function isArray(value) {
  return Array.isArray(value);
}; // Quick object check
// This is primarily used to tell Objects from primitive values
// when we know the value is a JSON-compliant type
// Note object could be a complex type like array, Date, etc.

var isObject = function isObject(obj) {
  return obj !== null && _typeof(obj) === 'object';
}; // Strict object type check
// Only returns true for plain JavaScript objects

var isPlainObject = function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
var isDate = function isDate(value) {
  return value instanceof Date;
};
var isEvent = function isEvent(value) {
  return value instanceof Event;
};
var isFile = function isFile(value) {
  return value instanceof __WEBPACK_IMPORTED_MODULE_1__constants_safe_types__["a" /* File */];
};
var isRegExp = function isRegExp(value) {
  return toRawType(value) === 'RegExp';
};
var isPromise = function isPromise(value) {
  return !isUndefinedOrNull(value) && isFunction(value.then) && isFunction(value.catch);
};

/***/ }),
/* 10 */
/* exports provided: checkMultipleVue, installFactory, installFactoryNoConfig, pluginFactory, pluginFactoryNoConfig, registerPlugins, registerComponent, registerComponents, registerDirective, registerDirectives, vueUse */
/* exports used: installFactory, pluginFactory, pluginFactoryNoConfig */
/*!**********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/plugins.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkMultipleVue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return installFactory; });
/* unused harmony export installFactoryNoConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pluginFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pluginFactoryNoConfig; });
/* unused harmony export registerPlugins */
/* unused harmony export registerComponent */
/* unused harmony export registerComponents */
/* unused harmony export registerDirective */
/* unused harmony export registerDirectives */
/* unused harmony export vueUse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_set__ = __webpack_require__(/*! ./config-set */ 956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__warn__ = __webpack_require__(/*! ./warn */ 54);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * Checks if there are multiple instances of Vue, and warns (once) about possible issues.
 * @param {object} Vue
 */

var checkMultipleVue = function () {
  var checkMultipleVueWarned = false;
  var MULTIPLE_VUE_WARNING = ['Multiple instances of Vue detected!', 'You may need to set up an alias for Vue in your bundler config.', 'See: https://bootstrap-vue.org/docs#using-module-bundlers'].join('\n');
  return function (Vue) {
    /* istanbul ignore next */
    if (!checkMultipleVueWarned && __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */] !== Vue && !__WEBPACK_IMPORTED_MODULE_1__constants_env__["d" /* IS_JSDOM */]) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__warn__["a" /* warn */])(MULTIPLE_VUE_WARNING);
    }

    checkMultipleVueWarned = true;
  };
}();
/**
 * Plugin install factory function.
 * @param {object} { components, directives }
 * @returns {function} plugin install function
 */

var installFactory = function installFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      components = _ref.components,
      directives = _ref.directives,
      plugins = _ref.plugins;

  var install = function install(Vue) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (install.installed) {
      /* istanbul ignore next */
      return;
    }

    install.installed = true;
    checkMultipleVue(Vue);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config_set__["a" /* setConfig */])(config, Vue);
    registerComponents(Vue, components);
    registerDirectives(Vue, directives);
    registerPlugins(Vue, plugins);
  };

  install.installed = false;
  return install;
};
/**
 * Plugin install factory function (no plugin config option).
 * @param {object} { components, directives }
 * @returns {function} plugin install function
 */

var installFactoryNoConfig = function installFactoryNoConfig() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      components = _ref2.components,
      directives = _ref2.directives,
      plugins = _ref2.plugins;

  var install = function install(Vue) {
    if (install.installed) {
      /* istanbul ignore next */
      return;
    }

    install.installed = true;
    checkMultipleVue(Vue);
    registerComponents(Vue, components);
    registerDirectives(Vue, directives);
    registerPlugins(Vue, plugins);
  };

  install.installed = false;
  return install;
};
/**
 * Plugin object factory function.
 * @param {object} { components, directives, plugins }
 * @returns {object} plugin install object
 */

var pluginFactory = function pluginFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, extend), {}, {
    install: installFactory(options)
  });
};
/**
 * Plugin object factory function (no config option).
 * @param {object} { components, directives, plugins }
 * @returns {object} plugin install object
 */

var pluginFactoryNoConfig = function pluginFactoryNoConfig() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, extend), {}, {
    install: installFactoryNoConfig(options)
  });
};
/**
 * Load a group of plugins.
 * @param {object} Vue
 * @param {object} Plugin definitions
 */

var registerPlugins = function registerPlugins(Vue) {
  var plugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var plugin in plugins) {
    if (plugin && plugins[plugin]) {
      Vue.use(plugins[plugin]);
    }
  }
};
/**
 * Load a component.
 * @param {object} Vue
 * @param {string} Component name
 * @param {object} Component definition
 */

var registerComponent = function registerComponent(Vue, name, def) {
  if (Vue && name && def) {
    Vue.component(name, def);
  }
};
/**
 * Load a group of components.
 * @param {object} Vue
 * @param {object} Object of component definitions
 */

var registerComponents = function registerComponents(Vue) {
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var component in components) {
    registerComponent(Vue, component, components[component]);
  }
};
/**
 * Load a directive.
 * @param {object} Vue
 * @param {string} Directive name
 * @param {object} Directive definition
 */

var registerDirective = function registerDirective(Vue, name, def) {
  if (Vue && name && def) {
    // Ensure that any leading V is removed from the
    // name, as Vue adds it automatically
    Vue.directive(name.replace(/^VB/, 'B'), def);
  }
};
/**
 * Load a group of directives.
 * @param {object} Vue
 * @param {object} Object of directive definitions
 */

var registerDirectives = function registerDirectives(Vue) {
  var directives = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var directive in directives) {
    registerDirective(Vue, directive, directives[directive]);
  }
};
/**
 * Install plugin if window.Vue available
 * @param {object} Plugin definition
 */

var vueUse = function vueUse(VuePlugin) {
  /* istanbul ignore next */
  if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["a" /* HAS_WINDOW_SUPPORT */] && window.Vue) {
    window.Vue.use(VuePlugin);
  }
  /* istanbul ignore next */


  if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["a" /* HAS_WINDOW_SUPPORT */] && VuePlugin.NAME) {
    window[VuePlugin.NAME] = VuePlugin;
  }
};

/***/ }),
/* 11 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./client/components/buttons/buttonPrimary/ButtonPrimary.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4672dfff","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./ButtonPrimary.vue */ 1510)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ButtonPrimary.vue */ 798),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4672dfff"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./buttonPrimary.pug */ 1408),
  /* scopeId */
  "data-v-4672dfff",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/buttons/buttonPrimary/ButtonPrimary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ButtonPrimary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4672dfff", Component.options)
  } else {
    hotAPI.reload("data-v-4672dfff", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 12 */
/* exports provided: EVENT_NAME_ACTIVATE_TAB, EVENT_NAME_BLUR, EVENT_NAME_CANCEL, EVENT_NAME_CHANGE, EVENT_NAME_CHANGED, EVENT_NAME_CLICK, EVENT_NAME_CLOSE, EVENT_NAME_CONTEXT, EVENT_NAME_CONTEXT_CHANGED, EVENT_NAME_DESTROYED, EVENT_NAME_DISABLE, EVENT_NAME_DISABLED, EVENT_NAME_DISMISSED, EVENT_NAME_DISMISS_COUNT_DOWN, EVENT_NAME_ENABLE, EVENT_NAME_ENABLED, EVENT_NAME_FILTERED, EVENT_NAME_FIRST, EVENT_NAME_FOCUS, EVENT_NAME_FOCUSIN, EVENT_NAME_FOCUSOUT, EVENT_NAME_HEAD_CLICKED, EVENT_NAME_HIDDEN, EVENT_NAME_HIDE, EVENT_NAME_IMG_ERROR, EVENT_NAME_INPUT, EVENT_NAME_LAST, EVENT_NAME_MOUSEENTER, EVENT_NAME_MOUSELEAVE, EVENT_NAME_NEXT, EVENT_NAME_OK, EVENT_NAME_OPEN, EVENT_NAME_PAGE_CLICK, EVENT_NAME_PAUSED, EVENT_NAME_PREV, EVENT_NAME_REFRESH, EVENT_NAME_REFRESHED, EVENT_NAME_REMOVE, EVENT_NAME_ROW_CLICKED, EVENT_NAME_ROW_CONTEXTMENU, EVENT_NAME_ROW_DBLCLICKED, EVENT_NAME_ROW_HOVERED, EVENT_NAME_ROW_MIDDLE_CLICKED, EVENT_NAME_ROW_SELECTED, EVENT_NAME_ROW_UNHOVERED, EVENT_NAME_SELECTED, EVENT_NAME_SHOW, EVENT_NAME_SHOWN, EVENT_NAME_SLIDING_END, EVENT_NAME_SLIDING_START, EVENT_NAME_SORT_CHANGED, EVENT_NAME_TAG_STATE, EVENT_NAME_TOGGLE, EVENT_NAME_UNPAUSED, EVENT_NAME_UPDATE, HOOK_EVENT_NAME_BEFORE_DESTROY, HOOK_EVENT_NAME_DESTROYED, MODEL_EVENT_NAME_PREFIX, ROOT_EVENT_NAME_PREFIX, ROOT_EVENT_NAME_SEPARATOR, EVENT_OPTIONS_PASSIVE, EVENT_OPTIONS_NO_CAPTURE */
/* exports used: EVENT_NAME_SHOW, EVENT_NAME_HIDDEN, HOOK_EVENT_NAME_BEFORE_DESTROY, EVENT_NAME_SHOWN, EVENT_NAME_HIDE, HOOK_EVENT_NAME_DESTROYED, EVENT_NAME_FOCUSIN, EVENT_NAME_FOCUSOUT, EVENT_NAME_MOUSEENTER, EVENT_NAME_MOUSELEAVE, EVENT_NAME_ENABLED, EVENT_NAME_DISABLED, EVENT_OPTIONS_NO_CAPTURE, EVENT_NAME_DISABLE, EVENT_NAME_ENABLE, ROOT_EVENT_NAME_PREFIX, ROOT_EVENT_NAME_SEPARATOR, EVENT_OPTIONS_PASSIVE, MODEL_EVENT_NAME_PREFIX, EVENT_NAME_OPEN, EVENT_NAME_CLOSE, EVENT_NAME_DESTROYED, EVENT_NAME_CHANGE, EVENT_NAME_CLICK, EVENT_NAME_INPUT, EVENT_NAME_CONTEXT, EVENT_NAME_FIRST, EVENT_NAME_PREV, EVENT_NAME_LAST, EVENT_NAME_NEXT, EVENT_NAME_CHANGED, EVENT_NAME_ACTIVATE_TAB, EVENT_NAME_ROW_CLICKED, EVENT_NAME_ROW_MIDDLE_CLICKED, EVENT_NAME_ROW_CONTEXTMENU, EVENT_NAME_ROW_DBLCLICKED, EVENT_NAME_ROW_HOVERED, EVENT_NAME_ROW_UNHOVERED, EVENT_NAME_HEAD_CLICKED, EVENT_NAME_CONTEXT_CHANGED, EVENT_NAME_REFRESHED, EVENT_NAME_REFRESH, EVENT_NAME_ROW_SELECTED, EVENT_NAME_FILTERED, EVENT_NAME_SORT_CHANGED, EVENT_NAME_PAGE_CLICK, EVENT_NAME_TOGGLE, EVENT_NAME_OK, EVENT_NAME_CANCEL, EVENT_NAME_UPDATE, EVENT_NAME_BLUR, EVENT_NAME_REMOVE, EVENT_NAME_TAG_STATE, EVENT_NAME_FOCUS, EVENT_NAME_SELECTED, EVENT_NAME_PAUSED, EVENT_NAME_UNPAUSED, EVENT_NAME_SLIDING_END, EVENT_NAME_SLIDING_START, EVENT_NAME_IMG_ERROR, EVENT_NAME_DISMISS_COUNT_DOWN, EVENT_NAME_DISMISSED */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/events.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return EVENT_NAME_ACTIVATE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return EVENT_NAME_BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return EVENT_NAME_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EVENT_NAME_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return EVENT_NAME_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EVENT_NAME_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return EVENT_NAME_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EVENT_NAME_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return EVENT_NAME_CONTEXT_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return EVENT_NAME_DESTROYED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EVENT_NAME_DISABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EVENT_NAME_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return EVENT_NAME_DISMISSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return EVENT_NAME_DISMISS_COUNT_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EVENT_NAME_ENABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EVENT_NAME_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return EVENT_NAME_FILTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return EVENT_NAME_FIRST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return EVENT_NAME_FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EVENT_NAME_FOCUSIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EVENT_NAME_FOCUSOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return EVENT_NAME_HEAD_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EVENT_NAME_HIDDEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EVENT_NAME_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return EVENT_NAME_IMG_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EVENT_NAME_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return EVENT_NAME_LAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EVENT_NAME_MOUSEENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EVENT_NAME_MOUSELEAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return EVENT_NAME_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return EVENT_NAME_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return EVENT_NAME_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return EVENT_NAME_PAGE_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return EVENT_NAME_PAUSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return EVENT_NAME_PREV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return EVENT_NAME_REFRESH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return EVENT_NAME_REFRESHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return EVENT_NAME_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return EVENT_NAME_ROW_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return EVENT_NAME_ROW_CONTEXTMENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return EVENT_NAME_ROW_DBLCLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return EVENT_NAME_ROW_HOVERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return EVENT_NAME_ROW_MIDDLE_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return EVENT_NAME_ROW_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return EVENT_NAME_ROW_UNHOVERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return EVENT_NAME_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_NAME_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EVENT_NAME_SHOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return EVENT_NAME_SLIDING_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return EVENT_NAME_SLIDING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return EVENT_NAME_SORT_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return EVENT_NAME_TAG_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return EVENT_NAME_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return EVENT_NAME_UNPAUSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return EVENT_NAME_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HOOK_EVENT_NAME_BEFORE_DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HOOK_EVENT_NAME_DESTROYED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MODEL_EVENT_NAME_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ROOT_EVENT_NAME_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ROOT_EVENT_NAME_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return EVENT_OPTIONS_PASSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EVENT_OPTIONS_NO_CAPTURE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);

var EVENT_NAME_ACTIVATE_TAB = 'activate-tab';
var EVENT_NAME_BLUR = 'blur';
var EVENT_NAME_CANCEL = 'cancel';
var EVENT_NAME_CHANGE = 'change';
var EVENT_NAME_CHANGED = 'changed';
var EVENT_NAME_CLICK = 'click';
var EVENT_NAME_CLOSE = 'close';
var EVENT_NAME_CONTEXT = 'context';
var EVENT_NAME_CONTEXT_CHANGED = 'context-changed';
var EVENT_NAME_DESTROYED = 'destroyed';
var EVENT_NAME_DISABLE = 'disable';
var EVENT_NAME_DISABLED = 'disabled';
var EVENT_NAME_DISMISSED = 'dismissed';
var EVENT_NAME_DISMISS_COUNT_DOWN = 'dismiss-count-down';
var EVENT_NAME_ENABLE = 'enable';
var EVENT_NAME_ENABLED = 'enabled';
var EVENT_NAME_FILTERED = 'filtered';
var EVENT_NAME_FIRST = 'first';
var EVENT_NAME_FOCUS = 'focus';
var EVENT_NAME_FOCUSIN = 'focusin';
var EVENT_NAME_FOCUSOUT = 'focusout';
var EVENT_NAME_HEAD_CLICKED = 'head-clicked';
var EVENT_NAME_HIDDEN = 'hidden';
var EVENT_NAME_HIDE = 'hide';
var EVENT_NAME_IMG_ERROR = 'img-error';
var EVENT_NAME_INPUT = 'input';
var EVENT_NAME_LAST = 'last';
var EVENT_NAME_MOUSEENTER = 'mouseenter';
var EVENT_NAME_MOUSELEAVE = 'mouseleave';
var EVENT_NAME_NEXT = 'next';
var EVENT_NAME_OK = 'ok';
var EVENT_NAME_OPEN = 'open';
var EVENT_NAME_PAGE_CLICK = 'page-click';
var EVENT_NAME_PAUSED = 'paused';
var EVENT_NAME_PREV = 'prev';
var EVENT_NAME_REFRESH = 'refresh';
var EVENT_NAME_REFRESHED = 'refreshed';
var EVENT_NAME_REMOVE = 'remove';
var EVENT_NAME_ROW_CLICKED = 'row-clicked';
var EVENT_NAME_ROW_CONTEXTMENU = 'row-contextmenu';
var EVENT_NAME_ROW_DBLCLICKED = 'row-dblclicked';
var EVENT_NAME_ROW_HOVERED = 'row-hovered';
var EVENT_NAME_ROW_MIDDLE_CLICKED = 'row-middle-clicked';
var EVENT_NAME_ROW_SELECTED = 'row-selected';
var EVENT_NAME_ROW_UNHOVERED = 'row-unhovered';
var EVENT_NAME_SELECTED = 'selected';
var EVENT_NAME_SHOW = 'show';
var EVENT_NAME_SHOWN = 'shown';
var EVENT_NAME_SLIDING_END = 'sliding-end';
var EVENT_NAME_SLIDING_START = 'sliding-start';
var EVENT_NAME_SORT_CHANGED = 'sort-changed';
var EVENT_NAME_TAG_STATE = 'tag-state';
var EVENT_NAME_TOGGLE = 'toggle';
var EVENT_NAME_UNPAUSED = 'unpaused';
var EVENT_NAME_UPDATE = 'update';
var HOOK_EVENT_NAME_BEFORE_DESTROY = __WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */] ? 'vnodeBeforeUnmount' : 'hook:beforeDestroy';
var HOOK_EVENT_NAME_DESTROYED = __WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */] ? 'vNodeUnmounted' : 'hook:destroyed';
var MODEL_EVENT_NAME_PREFIX = 'update:';
var ROOT_EVENT_NAME_PREFIX = 'bv';
var ROOT_EVENT_NAME_SEPARATOR = '::';
var EVENT_OPTIONS_PASSIVE = {
  passive: true
};
var EVENT_OPTIONS_NO_CAPTURE = {
  passive: true,
  capture: false
};

/***/ }),
/* 13 */
/* exports provided: matchesEl, closestEl, requestAF, MutationObs, removeNode, isElement, getActiveElement, isTag, isActiveElement, isVisible, isDisabled, reflow, selectAll, select, matches, closest, contains, getById, addClass, removeClass, hasClass, setAttr, removeAttr, getAttr, hasAttr, setStyle, removeStyle, getStyle, getBCR, getCS, getSel, offset, position, getTabables, attemptFocus, attemptBlur */
/* exports used: requestAF, contains, isVisible, getById, isElement, closest, hasClass, select, getAttr, setAttr, removeAttr, hasAttr, isDisabled, attemptFocus, getCS, isTag, removeClass, addClass, setStyle, removeStyle, position, offset, selectAll, getBCR, matches, MutationObs, attemptBlur, getActiveElement, isActiveElement, getSel, getTabables, removeNode, getStyle, reflow */
/*!******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/dom.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export matchesEl */
/* unused harmony export closestEl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestAF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return MutationObs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return removeNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getActiveElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return isActiveElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return reflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return selectAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return matches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return contains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return removeAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return removeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getBCR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getSel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return offset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getTabables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return attemptFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return attemptBlur; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_env__ = __webpack_require__(/*! ../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_safe_types__ = __webpack_require__(/*! ../constants/safe-types */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(/*! ./array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(/*! ./number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__string__ = __webpack_require__(/*! ./string */ 23);





 // --- Constants ---

var ELEMENT_PROTO = __WEBPACK_IMPORTED_MODULE_1__constants_safe_types__["b" /* Element */].prototype;
var TABABLE_SELECTOR = ['button', '[href]:not(.disabled)', 'input', 'select', 'textarea', '[tabindex]', '[contenteditable]'].map(function (s) {
  return "".concat(s, ":not(:disabled):not([disabled])");
}).join(', '); // --- Normalization utils ---
// See: https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill

/* istanbul ignore next */

var matchesEl = ELEMENT_PROTO.matches || ELEMENT_PROTO.msMatchesSelector || ELEMENT_PROTO.webkitMatchesSelector; // See: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest

/* istanbul ignore next */

var closestEl = ELEMENT_PROTO.closest || function (sel) {
  var el = this;

  do {
    // Use our "patched" matches function
    if (matches(el, sel)) {
      return el;
    }

    el = el.parentElement || el.parentNode;
  } while (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__inspect__["e" /* isNull */])(el) && el.nodeType === Node.ELEMENT_NODE);

  return null;
}; // `requestAnimationFrame()` convenience method

/* istanbul ignore next: JSDOM always returns the first option */

var requestAF = (__WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].requestAnimationFrame || __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].webkitRequestAnimationFrame || __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].mozRequestAnimationFrame || __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].msRequestAnimationFrame || __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].oRequestAnimationFrame || // Fallback, but not a true polyfill
// Only needed for Opera Mini

/* istanbul ignore next */
function (cb) {
  return setTimeout(cb, 16);
}).bind(__WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */]);
var MutationObs = __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].MutationObserver || __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].WebKitMutationObserver || __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].MozMutationObserver || null; // --- Utils ---
// Remove a node from DOM

var removeNode = function removeNode(el) {
  return el && el.parentNode && el.parentNode.removeChild(el);
}; // Determine if an element is an HTML element

var isElement = function isElement(el) {
  return !!(el && el.nodeType === Node.ELEMENT_NODE);
}; // Get the currently active HTML element

var getActiveElement = function getActiveElement() {
  var excludes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeElement = __WEBPACK_IMPORTED_MODULE_0__constants_env__["c" /* DOCUMENT */].activeElement;
  return activeElement && !excludes.some(function (el) {
    return el === activeElement;
  }) ? activeElement : null;
}; // Returns `true` if a tag's name equals `name`

var isTag = function isTag(tag, name) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__string__["a" /* toString */])(tag).toLowerCase() === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__string__["a" /* toString */])(name).toLowerCase();
}; // Determine if an HTML element is the currently active element

var isActiveElement = function isActiveElement(el) {
  return isElement(el) && el === getActiveElement();
}; // Determine if an HTML element is visible - Faster than CSS check

var isVisible = function isVisible(el) {
  if (!isElement(el) || !el.parentNode || !contains(__WEBPACK_IMPORTED_MODULE_0__constants_env__["c" /* DOCUMENT */].body, el)) {
    // Note this can fail for shadow dom elements since they
    // are not a direct descendant of document.body
    return false;
  }

  if (getStyle(el, 'display') === 'none') {
    // We do this check to help with vue-test-utils when using v-show

    /* istanbul ignore next */
    return false;
  } // All browsers support getBoundingClientRect(), except JSDOM as it returns all 0's for values :(
  // So any tests that need isVisible will fail in JSDOM
  // Except when we override the getBCR prototype in some tests


  var bcr = getBCR(el);
  return !!(bcr && bcr.height > 0 && bcr.width > 0);
}; // Determine if an element is disabled

var isDisabled = function isDisabled(el) {
  return !isElement(el) || el.disabled || hasAttr(el, 'disabled') || hasClass(el, 'disabled');
}; // Cause/wait-for an element to reflow its content (adjusting its height/width)

var reflow = function reflow(el) {
  // Requesting an elements offsetHight will trigger a reflow of the element content

  /* istanbul ignore next: reflow doesn't happen in JSDOM */
  return isElement(el) && el.offsetHeight;
}; // Select all elements matching selector. Returns `[]` if none found

var selectAll = function selectAll(selector, root) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__array__["a" /* from */])((isElement(root) ? root : __WEBPACK_IMPORTED_MODULE_0__constants_env__["c" /* DOCUMENT */]).querySelectorAll(selector));
}; // Select a single element, returns `null` if not found

var select = function select(selector, root) {
  return (isElement(root) ? root : __WEBPACK_IMPORTED_MODULE_0__constants_env__["c" /* DOCUMENT */]).querySelector(selector) || null;
}; // Determine if an element matches a selector

var matches = function matches(el, selector) {
  return isElement(el) ? matchesEl.call(el, selector) : false;
}; // Finds closest element matching selector. Returns `null` if not found

var closest = function closest(selector, root) {
  var includeRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!isElement(root)) {
    return null;
  }

  var el = closestEl.call(root, selector); // Native closest behaviour when `includeRoot` is truthy,
  // else emulate jQuery closest and return `null` if match is
  // the passed in root element when `includeRoot` is falsey

  return includeRoot ? el : el === root ? null : el;
}; // Returns true if the parent element contains the child element

var contains = function contains(parent, child) {
  return parent && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__inspect__["a" /* isFunction */])(parent.contains) ? parent.contains(child) : false;
}; // Get an element given an ID

var getById = function getById(id) {
  return __WEBPACK_IMPORTED_MODULE_0__constants_env__["c" /* DOCUMENT */].getElementById(/^#/.test(id) ? id.slice(1) : id) || null;
}; // Add a class to an element

var addClass = function addClass(el, className) {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2713
  if (className && isElement(el) && el.classList) {
    el.classList.add(className);
  }
}; // Remove a class from an element

var removeClass = function removeClass(el, className) {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2713
  if (className && isElement(el) && el.classList) {
    el.classList.remove(className);
  }
}; // Test if an element has a class

var hasClass = function hasClass(el, className) {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2713
  if (className && isElement(el) && el.classList) {
    return el.classList.contains(className);
  }

  return false;
}; // Set an attribute on an element

var setAttr = function setAttr(el, attr, value) {
  if (attr && isElement(el)) {
    el.setAttribute(attr, value);
  }
}; // Remove an attribute from an element

var removeAttr = function removeAttr(el, attr) {
  if (attr && isElement(el)) {
    el.removeAttribute(attr);
  }
}; // Get an attribute value from an element
// Returns `null` if not found

var getAttr = function getAttr(el, attr) {
  return attr && isElement(el) ? el.getAttribute(attr) : null;
}; // Determine if an attribute exists on an element
// Returns `true` or `false`, or `null` if element not found

var hasAttr = function hasAttr(el, attr) {
  return attr && isElement(el) ? el.hasAttribute(attr) : null;
}; // Set an style property on an element

var setStyle = function setStyle(el, prop, value) {
  if (prop && isElement(el)) {
    el.style[prop] = value;
  }
}; // Remove an style property from an element

var removeStyle = function removeStyle(el, prop) {
  if (prop && isElement(el)) {
    el.style[prop] = '';
  }
}; // Get an style property value from an element
// Returns `null` if not found

var getStyle = function getStyle(el, prop) {
  return prop && isElement(el) ? el.style[prop] || null : null;
}; // Return the Bounding Client Rect of an element
// Returns `null` if not an element

/* istanbul ignore next: getBoundingClientRect() doesn't work in JSDOM */

var getBCR = function getBCR(el) {
  return isElement(el) ? el.getBoundingClientRect() : null;
}; // Get computed style object for an element

/* istanbul ignore next: getComputedStyle() doesn't work in JSDOM */

var getCS = function getCS(el) {
  var getComputedStyle = __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].getComputedStyle;
  return getComputedStyle && isElement(el) ? getComputedStyle(el) : {};
}; // Returns a `Selection` object representing the range of text selected
// Returns `null` if no window support is given

/* istanbul ignore next: getSelection() doesn't work in JSDOM */

var getSel = function getSel() {
  var getSelection = __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].getSelection;
  return getSelection ? __WEBPACK_IMPORTED_MODULE_0__constants_env__["b" /* WINDOW */].getSelection() : null;
}; // Return an element's offset with respect to document element
// https://j11y.io/jquery/#v=git&fn=jQuery.fn.offset

var offset = function offset(el)
/* istanbul ignore next: getBoundingClientRect(), getClientRects() doesn't work in JSDOM */
{
  var _offset = {
    top: 0,
    left: 0
  };

  if (!isElement(el) || el.getClientRects().length === 0) {
    return _offset;
  }

  var bcr = getBCR(el);

  if (bcr) {
    var win = el.ownerDocument.defaultView;
    _offset.top = bcr.top + win.pageYOffset;
    _offset.left = bcr.left + win.pageXOffset;
  }

  return _offset;
}; // Return an element's offset with respect to to its offsetParent
// https://j11y.io/jquery/#v=git&fn=jQuery.fn.position

var position = function position(el)
/* istanbul ignore next: getBoundingClientRect() doesn't work in JSDOM */
{
  var _offset = {
    top: 0,
    left: 0
  };

  if (!isElement(el)) {
    return _offset;
  }

  var parentOffset = {
    top: 0,
    left: 0
  };
  var elStyles = getCS(el);

  if (elStyles.position === 'fixed') {
    _offset = getBCR(el) || _offset;
  } else {
    _offset = offset(el);
    var doc = el.ownerDocument;
    var offsetParent = el.offsetParent || doc.documentElement;

    while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && getCS(offsetParent).position === 'static') {
      offsetParent = offsetParent.parentNode;
    }

    if (offsetParent && offsetParent !== el && offsetParent.nodeType === Node.ELEMENT_NODE) {
      parentOffset = offset(offsetParent);
      var offsetParentStyles = getCS(offsetParent);
      parentOffset.top += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__number__["a" /* toFloat */])(offsetParentStyles.borderTopWidth, 0);
      parentOffset.left += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__number__["a" /* toFloat */])(offsetParentStyles.borderLeftWidth, 0);
    }
  }

  return {
    top: _offset.top - parentOffset.top - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__number__["a" /* toFloat */])(elStyles.marginTop, 0),
    left: _offset.left - parentOffset.left - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__number__["a" /* toFloat */])(elStyles.marginLeft, 0)
  };
}; // Find all tabable elements in the given element
// Assumes users have not used `tabindex` > `0` on elements

var getTabables = function getTabables() {
  var rootEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  return selectAll(TABABLE_SELECTOR, rootEl).filter(isVisible).filter(function (el) {
    return el.tabIndex > -1 && !el.disabled;
  });
}; // Attempt to focus an element, and return `true` if successful

var attemptFocus = function attemptFocus(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    el.focus(options);
  } catch (_unused) {}

  return isActiveElement(el);
}; // Attempt to blur an element, and return `true` if successful

var attemptBlur = function attemptBlur(el) {
  try {
    el.blur();
  } catch (_unused2) {}

  return !isActiveElement(el);
};

/***/ }),
/* 14 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/babel-runtime/core-js/promise.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/promise */ 970), __esModule: true };

/***/ }),
/* 15 */
/* exports provided: normalizeSlotMixin */
/* exports used: normalizeSlotMixin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/normalize-slot.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeSlotMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_slots__ = __webpack_require__(/*! ../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_normalize_slot__ = __webpack_require__(/*! ../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../utils/array */ 18);



 // @vue/component

var normalizeSlotMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  methods: {
    // Returns `true` if the either a `$scopedSlot` or `$slot` exists with the specified name
    // `name` can be a string name or an array of names
    hasNormalizedSlot: function hasNormalizedSlot() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__constants_slots__["a" /* SLOT_NAME_DEFAULT */];
      var scopedSlots = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$scopedSlots;
      var slots = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$slots;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_normalize_slot__["a" /* hasNormalizedSlot */])(name, scopedSlots, slots);
    },
    // Returns an array of rendered VNodes if slot found, otherwise `undefined`
    // `name` can be a string name or an array of names
    normalizeSlot: function normalizeSlot() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__constants_slots__["a" /* SLOT_NAME_DEFAULT */];
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var scopedSlots = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$scopedSlots;
      var slots = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.$slots;

      var vNodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_normalize_slot__["b" /* normalizeSlot */])(name, scope, scopedSlots, slots);

      return vNodes ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(vNodes) : vNodes;
    }
  }
});

/***/ }),
/* 16 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./~/jquery/dist/jquery.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 17 */
/* exports provided: SLOT_NAME_ADD_BUTTON_TEXT, SLOT_NAME_APPEND, SLOT_NAME_ASIDE, SLOT_NAME_BADGE, SLOT_NAME_BOTTOM_ROW, SLOT_NAME_BUTTON_CONTENT, SLOT_NAME_CUSTOM_FOOT, SLOT_NAME_DECREMENT, SLOT_NAME_DEFAULT, SLOT_NAME_DESCRIPTION, SLOT_NAME_DISMISS, SLOT_NAME_DROP_PLACEHOLDER, SLOT_NAME_ELLIPSIS_TEXT, SLOT_NAME_EMPTY, SLOT_NAME_EMPTYFILTERED, SLOT_NAME_FILE_NAME, SLOT_NAME_FIRST, SLOT_NAME_FIRST_TEXT, SLOT_NAME_FOOTER, SLOT_NAME_HEADER, SLOT_NAME_HEADER_CLOSE, SLOT_NAME_ICON_CLEAR, SLOT_NAME_ICON_EMPTY, SLOT_NAME_ICON_FULL, SLOT_NAME_ICON_HALF, SLOT_NAME_IMG, SLOT_NAME_INCREMENT, SLOT_NAME_INVALID_FEEDBACK, SLOT_NAME_LABEL, SLOT_NAME_LAST_TEXT, SLOT_NAME_LEAD, SLOT_NAME_LOADING, SLOT_NAME_MODAL_BACKDROP, SLOT_NAME_MODAL_CANCEL, SLOT_NAME_MODAL_FOOTER, SLOT_NAME_MODAL_HEADER, SLOT_NAME_MODAL_HEADER_CLOSE, SLOT_NAME_MODAL_OK, SLOT_NAME_MODAL_TITLE, SLOT_NAME_NAV_NEXT_DECADE, SLOT_NAME_NAV_NEXT_MONTH, SLOT_NAME_NAV_NEXT_YEAR, SLOT_NAME_NAV_PEV_DECADE, SLOT_NAME_NAV_PEV_MONTH, SLOT_NAME_NAV_PEV_YEAR, SLOT_NAME_NAV_THIS_MONTH, SLOT_NAME_NEXT_TEXT, SLOT_NAME_OVERLAY, SLOT_NAME_PAGE, SLOT_NAME_PLACEHOLDER, SLOT_NAME_PREPEND, SLOT_NAME_PREV_TEXT, SLOT_NAME_ROW_DETAILS, SLOT_NAME_TABLE_BUSY, SLOT_NAME_TABLE_CAPTION, SLOT_NAME_TABLE_COLGROUP, SLOT_NAME_TABS_END, SLOT_NAME_TABS_START, SLOT_NAME_TEXT, SLOT_NAME_THEAD_TOP, SLOT_NAME_TITLE, SLOT_NAME_TOAST_TITLE, SLOT_NAME_TOP_ROW, SLOT_NAME_VALID_FEEDBACK */
/* exports used: SLOT_NAME_DEFAULT, SLOT_NAME_TOAST_TITLE, SLOT_NAME_INCREMENT, SLOT_NAME_DECREMENT, SLOT_NAME_TITLE, SLOT_NAME_TABS_START, SLOT_NAME_TABS_END, SLOT_NAME_EMPTY, SLOT_NAME_TABLE_COLGROUP, SLOT_NAME_TABLE_CAPTION, SLOT_NAME_ROW_DETAILS, SLOT_NAME_CUSTOM_FOOT, SLOT_NAME_THEAD_TOP, SLOT_NAME_TABLE_BUSY, SLOT_NAME_BOTTOM_ROW, SLOT_NAME_TOP_ROW, SLOT_NAME_EMPTYFILTERED, SLOT_NAME_LABEL, SLOT_NAME_LOADING, SLOT_NAME_HEADER_CLOSE, SLOT_NAME_HEADER, SLOT_NAME_FOOTER, SLOT_NAME_ELLIPSIS_TEXT, SLOT_NAME_PAGE, SLOT_NAME_FIRST_TEXT, SLOT_NAME_PREV_TEXT, SLOT_NAME_NEXT_TEXT, SLOT_NAME_LAST_TEXT, SLOT_NAME_OVERLAY, SLOT_NAME_BUTTON_CONTENT, SLOT_NAME_TEXT, SLOT_NAME_MODAL_TITLE, SLOT_NAME_MODAL_HEADER, SLOT_NAME_MODAL_HEADER_CLOSE, SLOT_NAME_MODAL_FOOTER, SLOT_NAME_MODAL_CANCEL, SLOT_NAME_MODAL_OK, SLOT_NAME_MODAL_BACKDROP, SLOT_NAME_ASIDE, SLOT_NAME_LEAD, SLOT_NAME_PREPEND, SLOT_NAME_APPEND, SLOT_NAME_FIRST, SLOT_NAME_ADD_BUTTON_TEXT, SLOT_NAME_ICON_CLEAR, SLOT_NAME_ICON_EMPTY, SLOT_NAME_ICON_HALF, SLOT_NAME_ICON_FULL, SLOT_NAME_INVALID_FEEDBACK, SLOT_NAME_VALID_FEEDBACK, SLOT_NAME_DESCRIPTION, SLOT_NAME_DROP_PLACEHOLDER, SLOT_NAME_PLACEHOLDER, SLOT_NAME_FILE_NAME, SLOT_NAME_NAV_PEV_DECADE, SLOT_NAME_NAV_PEV_YEAR, SLOT_NAME_NAV_PEV_MONTH, SLOT_NAME_NAV_THIS_MONTH, SLOT_NAME_NAV_NEXT_MONTH, SLOT_NAME_NAV_NEXT_YEAR, SLOT_NAME_NAV_NEXT_DECADE, SLOT_NAME_IMG, SLOT_NAME_BADGE, SLOT_NAME_DISMISS */
/*!************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/slots.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SLOT_NAME_ADD_BUTTON_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SLOT_NAME_APPEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SLOT_NAME_ASIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SLOT_NAME_BADGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SLOT_NAME_BOTTOM_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SLOT_NAME_BUTTON_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SLOT_NAME_CUSTOM_FOOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SLOT_NAME_DECREMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SLOT_NAME_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SLOT_NAME_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SLOT_NAME_DISMISS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SLOT_NAME_DROP_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SLOT_NAME_ELLIPSIS_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SLOT_NAME_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SLOT_NAME_EMPTYFILTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SLOT_NAME_FILE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SLOT_NAME_FIRST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SLOT_NAME_FIRST_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SLOT_NAME_FOOTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SLOT_NAME_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SLOT_NAME_HEADER_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SLOT_NAME_ICON_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SLOT_NAME_ICON_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SLOT_NAME_ICON_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SLOT_NAME_ICON_HALF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SLOT_NAME_IMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SLOT_NAME_INCREMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SLOT_NAME_INVALID_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SLOT_NAME_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SLOT_NAME_LAST_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SLOT_NAME_LEAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SLOT_NAME_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SLOT_NAME_MODAL_BACKDROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SLOT_NAME_MODAL_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SLOT_NAME_MODAL_FOOTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SLOT_NAME_MODAL_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SLOT_NAME_MODAL_HEADER_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SLOT_NAME_MODAL_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SLOT_NAME_MODAL_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SLOT_NAME_NAV_NEXT_DECADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SLOT_NAME_NAV_NEXT_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SLOT_NAME_NAV_NEXT_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SLOT_NAME_NAV_PEV_DECADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SLOT_NAME_NAV_PEV_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SLOT_NAME_NAV_PEV_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SLOT_NAME_NAV_THIS_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SLOT_NAME_NEXT_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SLOT_NAME_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SLOT_NAME_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SLOT_NAME_PLACEHOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SLOT_NAME_PREPEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SLOT_NAME_PREV_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SLOT_NAME_ROW_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SLOT_NAME_TABLE_BUSY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SLOT_NAME_TABLE_CAPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SLOT_NAME_TABLE_COLGROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SLOT_NAME_TABS_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SLOT_NAME_TABS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SLOT_NAME_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SLOT_NAME_THEAD_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SLOT_NAME_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SLOT_NAME_TOAST_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SLOT_NAME_TOP_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SLOT_NAME_VALID_FEEDBACK; });
var SLOT_NAME_ADD_BUTTON_TEXT = 'add-button-text';
var SLOT_NAME_APPEND = 'append';
var SLOT_NAME_ASIDE = 'aside';
var SLOT_NAME_BADGE = 'badge';
var SLOT_NAME_BOTTOM_ROW = 'bottom-row';
var SLOT_NAME_BUTTON_CONTENT = 'button-content';
var SLOT_NAME_CUSTOM_FOOT = 'custom-foot';
var SLOT_NAME_DECREMENT = 'decrement';
var SLOT_NAME_DEFAULT = 'default';
var SLOT_NAME_DESCRIPTION = 'description';
var SLOT_NAME_DISMISS = 'dismiss';
var SLOT_NAME_DROP_PLACEHOLDER = 'drop-placeholder';
var SLOT_NAME_ELLIPSIS_TEXT = 'ellipsis-text';
var SLOT_NAME_EMPTY = 'empty';
var SLOT_NAME_EMPTYFILTERED = 'emptyfiltered';
var SLOT_NAME_FILE_NAME = 'file-name';
var SLOT_NAME_FIRST = 'first';
var SLOT_NAME_FIRST_TEXT = 'first-text';
var SLOT_NAME_FOOTER = 'footer';
var SLOT_NAME_HEADER = 'header';
var SLOT_NAME_HEADER_CLOSE = 'header-close';
var SLOT_NAME_ICON_CLEAR = 'icon-clear';
var SLOT_NAME_ICON_EMPTY = 'icon-empty';
var SLOT_NAME_ICON_FULL = 'icon-full';
var SLOT_NAME_ICON_HALF = 'icon-half';
var SLOT_NAME_IMG = 'img';
var SLOT_NAME_INCREMENT = 'increment';
var SLOT_NAME_INVALID_FEEDBACK = 'invalid-feedback';
var SLOT_NAME_LABEL = 'label';
var SLOT_NAME_LAST_TEXT = 'last-text';
var SLOT_NAME_LEAD = 'lead';
var SLOT_NAME_LOADING = 'loading';
var SLOT_NAME_MODAL_BACKDROP = 'modal-backdrop';
var SLOT_NAME_MODAL_CANCEL = 'modal-cancel';
var SLOT_NAME_MODAL_FOOTER = 'modal-footer';
var SLOT_NAME_MODAL_HEADER = 'modal-header';
var SLOT_NAME_MODAL_HEADER_CLOSE = 'modal-header-close';
var SLOT_NAME_MODAL_OK = 'modal-ok';
var SLOT_NAME_MODAL_TITLE = 'modal-title';
var SLOT_NAME_NAV_NEXT_DECADE = 'nav-next-decade';
var SLOT_NAME_NAV_NEXT_MONTH = 'nav-next-month';
var SLOT_NAME_NAV_NEXT_YEAR = 'nav-next-year';
var SLOT_NAME_NAV_PEV_DECADE = 'nav-prev-decade';
var SLOT_NAME_NAV_PEV_MONTH = 'nav-prev-month';
var SLOT_NAME_NAV_PEV_YEAR = 'nav-prev-year';
var SLOT_NAME_NAV_THIS_MONTH = 'nav-this-month';
var SLOT_NAME_NEXT_TEXT = 'next-text';
var SLOT_NAME_OVERLAY = 'overlay';
var SLOT_NAME_PAGE = 'page';
var SLOT_NAME_PLACEHOLDER = 'placeholder';
var SLOT_NAME_PREPEND = 'prepend';
var SLOT_NAME_PREV_TEXT = 'prev-text';
var SLOT_NAME_ROW_DETAILS = 'row-details';
var SLOT_NAME_TABLE_BUSY = 'table-busy';
var SLOT_NAME_TABLE_CAPTION = 'table-caption';
var SLOT_NAME_TABLE_COLGROUP = 'table-colgroup';
var SLOT_NAME_TABS_END = 'tabs-end';
var SLOT_NAME_TABS_START = 'tabs-start';
var SLOT_NAME_TEXT = 'text';
var SLOT_NAME_THEAD_TOP = 'thead-top';
var SLOT_NAME_TITLE = 'title';
var SLOT_NAME_TOAST_TITLE = 'toast-title';
var SLOT_NAME_TOP_ROW = 'top-row';
var SLOT_NAME_VALID_FEEDBACK = 'valid-feedback';

/***/ }),
/* 18 */
/* exports provided: from, arrayIncludes, concat, createArray, flatten, flattenDeep */
/* exports used: from, concat, arrayIncludes, createArray, flatten, flattenDeep */
/*!********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/array.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return from; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return arrayIncludes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return flatten; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flattenDeep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspect__ = __webpack_require__(/*! ./inspect */ 9);
 // --- Static ---

var from = function from() {
  return Array.from.apply(Array, arguments);
}; // --- Instance ---

var arrayIncludes = function arrayIncludes(array, value) {
  return array.indexOf(value) !== -1;
};
var concat = function concat() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Array.prototype.concat.apply([], args);
}; // --- Utilities ---

var createArray = function createArray(length, fillFn) {
  var mapFn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["a" /* isFunction */])(fillFn) ? fillFn : function () {
    return fillFn;
  };
  return Array.apply(null, {
    length: length
  }).map(mapFn);
};
var flatten = function flatten(array) {
  return array.reduce(function (result, item) {
    return concat(result, item);
  }, []);
};
var flattenDeep = function flattenDeep(array) {
  return array.reduce(function (result, item) {
    return concat(result, Array.isArray(item) ? flattenDeep(item) : item);
  }, []);
};

/***/ }),
/* 19 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./build/language/index.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _locale = __webpack_require__(/*! vuejs-datepicker/dist/locale */ 1727);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MONETARY_SYMBOLS = {
  in: ['', 'k', 'm', 'bn', 'tn'],
  pt: ['', 'k', 'm', 'bi', 'tri'],
  es: ['', 'k', 'm', 'mm', 'bn']
};

exports.default = {
  changeLanguage: function changeLanguage(idioma) {
    if (idioma) {
      if (idioma.match(/^pt/i)) {
        idioma = 'pt';
      } else if (idioma.match(/^(en|in)/i)) {
        idioma = 'in';
      } else if (idioma.match(/^es/i)) {
        idioma = 'es';
      }
      setCookie(idioma);
    } else {
      idioma = this.getCookieByName('language');
    }
    _vue2.default.i18n.set(idioma);
  },

  getCookieByName: function getCookieByName(cookiename) {
    var cookiestring = RegExp('' + cookiename + '[^;]+').exec(document.cookie);
    if (!cookiestring) {
      return undefined;
    } else {
      return unescape(cookiestring.toString().replace(/^[^=]+./, ''));
    }
  },

  getDatePickerLanguage: function getDatePickerLanguage() {
    var idioma = this.getCookieByName('language');
    if (idioma) {
      if (idioma.match(/^pt/i)) {
        idioma = 'pt-br';
      } else if (idioma.match(/^(en|in)/i)) {
        idioma = 'en';
      } else if (idioma.match(/^es/i)) {
        idioma = 'es';
      }
    } else {
      idioma = 'pt-br';
    }
    return idioma;
  },

  getDatePickerLanguageObject: function getDatePickerLanguageObject() {
    var idioma = this.getCookieByName('language');
    switch (idioma) {
      case 'in':
        idioma = _locale.en;
        break;
      case 'es':
        idioma = _locale.es;
        break;
      default:
        idioma = _locale.ptBR;
    }
    return idioma;
  },

  setLanguageEmulatedLogin: function setLanguageEmulatedLogin(language) {
    var idioma = 'pt';
    switch (language) {
      case 'pt_BR':
        idioma = 'pt';
        break;
      case 'en_US':
        idioma = 'in';
        break;
      case 'es_ES':
        idioma = 'es';
        break;
      default:
        idioma = 'pt';
    }
    setCookie(idioma);
    _vue2.default.i18n.set(idioma);
  },

  getMoneyMaskByLanguage: function getMoneyMaskByLanguage() {
    var language = this.getCookieByName('language');
    var moneyMask = {};

    switch (language) {
      case 'es':
        moneyMask = {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          precision: 2,
          masked: true,
          allowBlank: true
        };
        break;
      case 'in':
        moneyMask = {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          precision: 2,
          masked: true,
          allowBlank: true
        };
        break;
      default:
        moneyMask = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          precision: 2,
          masked: true,
          allowBlank: true
        };
    }
    return moneyMask;
  },

  getMonetaryAbbreviation: function getMonetaryAbbreviation(value, language) {
    language = language || this.getCookieByName('language');
    var symbols = MONETARY_SYMBOLS[language];

    var index = Math.floor((value.toString().length - 1) / 3);
    return symbols[index];
  },

  getIntlCurrencyFormatter: function getIntlCurrencyFormatter() {
    var minimumFractionDigits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
    var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    var language = this.getCookieByName('language');
    var config = void 0;
    switch (language) {
      default:
        config = {
          locale: 'pt-BR',
          options: {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
          }
        };
        break;
    }
    return new Intl.NumberFormat(config.locale, config.options).format;
  }
};


function setCookie(idioma) {
  if (idioma) {
    _vue2.default.cookie.set('language', idioma);
  } else {
    _vue2.default.cookie.set('language', 'pt');
  }
}

/***/ }),
/* 20 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./build/http-requests/axios-common.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(/*! axios */ 723);

var _axios2 = _interopRequireDefault(_axios);

var _getNodeMiddlewareUrl = __webpack_require__(/*! ./getNodeMiddlewareUrl */ 313);

var _getNodeMiddlewareUrl2 = _interopRequireDefault(_getNodeMiddlewareUrl);

var _routesMap = __webpack_require__(/*! ../../client/router/routesMap */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

var _store = __webpack_require__(/*! ../../client/store */ 105);

var _store2 = _interopRequireDefault(_store);

var _trueJsonBigint = __webpack_require__(/*! true-json-bigint */ 1154);

var _trueJsonBigint2 = _interopRequireDefault(_trueJsonBigint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axiosCommon = _axios2.default.create({
  baseURL: (0, _getNodeMiddlewareUrl2.default)(),
  withCredentials: true,
  timeout: 300000
});

axiosCommon.CancelToken = _axios2.default.CancelToken;
axiosCommon.isCancel = _axios2.default.isCancel;

axiosCommon.interceptors.request.use(function (config) {
  config.headers = { 'x-access-token': localStorage.getItem('token') };
  config.transformResponse = function (data) {
    if (typeof data === 'string') {
      try {
        data = _trueJsonBigint2.default.parse(data);
      } catch (e) {}
    }
    return data;
  };
  return config;
}, function (error) {
  return _promise2.default.reject(error);
});

axiosCommon.interceptors.response.use(function (res) {
  if (res.headers['x-access-token']) {
    localStorage.setItem('token', res.headers['x-access-token']);
  }

  if (localStorage.getItem('CONNECTION_ERROR')) {
    localStorage.removeItem('CONNECTION_ERROR');
  }

  return _promise2.default.resolve(res);
}, function (error) {
  if (error instanceof _axios2.default.Cancel) {
    error.message = 'user.cancelled';
    return _promise2.default.reject(error);
  }
  if (error && error.message === 'Network Error') {
    _store2.default.dispatch('cleanVuexModules');
    localStorage.setItem('CONNECTION_ERROR', true);
    if (location.pathname !== _routesMap2.default.LOGIN) {
      location.href = _routesMap2.default.LOGIN;
    }
    return _promise2.default.reject(res);
  }
  var res = error.response;
  if (!res || res.status === 401) {
    _store2.default.dispatch('cleanVuexModules').then(function () {
      _store2.default.dispatch('logout').then(function () {
        location.href = _routesMap2.default.LOGIN;
        localStorage.setItem('SESSION_ERR', 'naoAutorizado.labels.mensagem401');
      });
    });
    return _promise2.default.reject(res);
  }
  if (res.status === 403) {
    location.href = _routesMap2.default.UNAUTHORIZED;
    return _promise2.default.reject(res);
  }
  if (!(res.status >= 200 && res.status < 400)) {
    return _promise2.default.reject(res.data);
  }
});

exports.default = axiosCommon;

/***/ }),
/* 21 */
/* exports provided: parseEventOptions, eventOn, eventOff, eventOnOff, stopEvent, getRootEventName, getRootActionEventName */
/* exports used: getRootEventName, eventOn, eventOff, getRootActionEventName, eventOnOff, stopEvent */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/events.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseEventOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return eventOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return eventOnOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stopEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRootEventName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRootActionEventName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_env__ = __webpack_require__(/*! ../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__string__ = __webpack_require__(/*! ./string */ 23);




 // --- Utils ---
// Normalize event options based on support of passive option
// Exported only for testing purposes

var parseEventOptions = function parseEventOptions(options) {
  /* istanbul ignore else: can't test in JSDOM, as it supports passive */
  if (__WEBPACK_IMPORTED_MODULE_0__constants_env__["h" /* HAS_PASSIVE_EVENT_SUPPORT */]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__inspect__["d" /* isObject */])(options) ? options : {
      capture: !!options || false
    };
  } else {
    // Need to translate to actual Boolean value
    return !!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__inspect__["d" /* isObject */])(options) ? options.capture : options);
  }
}; // Attach an event listener to an element

var eventOn = function eventOn(el, eventName, handler, options) {
  if (el && el.addEventListener) {
    el.addEventListener(eventName, handler, parseEventOptions(options));
  }
}; // Remove an event listener from an element

var eventOff = function eventOff(el, eventName, handler, options) {
  if (el && el.removeEventListener) {
    el.removeEventListener(eventName, handler, parseEventOptions(options));
  }
}; // Utility method to add/remove a event listener based on first argument (boolean)
// It passes all other arguments to the `eventOn()` or `eventOff` method

var eventOnOff = function eventOnOff(on) {
  var method = on ? eventOn : eventOff;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  method.apply(void 0, args);
}; // Utility method to prevent the default event handling and propagation

var stopEvent = function stopEvent(event) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$preventDefault = _ref.preventDefault,
      preventDefault = _ref$preventDefault === void 0 ? true : _ref$preventDefault,
      _ref$propagation = _ref.propagation,
      propagation = _ref$propagation === void 0 ? true : _ref$propagation,
      _ref$immediatePropaga = _ref.immediatePropagation,
      immediatePropagation = _ref$immediatePropaga === void 0 ? false : _ref$immediatePropaga;

  if (preventDefault) {
    event.preventDefault();
  }

  if (propagation) {
    event.stopPropagation();
  }

  if (immediatePropagation) {
    event.stopImmediatePropagation();
  }
}; // Helper method to convert a component/directive name to a base event name
// `getBaseEventName('BNavigationItem')` => 'navigation-item'
// `getBaseEventName('BVToggle')` => 'toggle'

var getBaseEventName = function getBaseEventName(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__string__["b" /* kebabCase */])(value.replace(__WEBPACK_IMPORTED_MODULE_2__constants_regex__["l" /* RX_BV_PREFIX */], ''));
}; // Get a root event name by component/directive and event name
// `getBaseEventName('BModal', 'show')` => 'bv::modal::show'


var getRootEventName = function getRootEventName(name, eventName) {
  return [__WEBPACK_IMPORTED_MODULE_1__constants_events__["p" /* ROOT_EVENT_NAME_PREFIX */], getBaseEventName(name), eventName].join(__WEBPACK_IMPORTED_MODULE_1__constants_events__["q" /* ROOT_EVENT_NAME_SEPARATOR */]);
}; // Get a root action event name by component/directive and action name
// `getRootActionEventName('BModal', 'show')` => 'bv::show::modal'

var getRootActionEventName = function getRootActionEventName(name, actionName) {
  return [__WEBPACK_IMPORTED_MODULE_1__constants_events__["p" /* ROOT_EVENT_NAME_PREFIX */], actionName, getBaseEventName(name)].join(__WEBPACK_IMPORTED_MODULE_1__constants_events__["q" /* ROOT_EVENT_NAME_SEPARATOR */]);
};

/***/ }),
/* 22 */
/* exports provided: toInteger, toFloat, toFixed */
/* exports used: toFloat, toInteger, toFixed */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/number.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toFloat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toFixed; });
// Number utilities
// Converts a value (string, number, etc.) to an integer number
// Assumes radix base 10
var toInteger = function toInteger(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
  var integer = parseInt(value, 10);
  return isNaN(integer) ? defaultValue : integer;
}; // Converts a value (string, number, etc.) to a number

var toFloat = function toFloat(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
  var float = parseFloat(value);
  return isNaN(float) ? defaultValue : float;
}; // Converts a value (string, number, etc.) to a string
// representation with `precision` digits after the decimal
// Returns the string 'NaN' if the value cannot be converted

var toFixed = function toFixed(val, precision) {
  return toFloat(val).toFixed(toInteger(precision, 0));
};

/***/ }),
/* 23 */
/* exports provided: kebabCase, pascalCase, startCase, lowerFirst, upperFirst, escapeRegExp, toString, trimLeft, trimRight, trim, lowerCase, upperCase */
/* exports used: toString, kebabCase, upperFirst, lowerFirst, startCase, trim, escapeRegExp, lowerCase, trimLeft, pascalCase */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/string.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return kebabCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pascalCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return startCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lowerFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return upperFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return escapeRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return trimLeft; });
/* unused harmony export trimRight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return lowerCase; });
/* unused harmony export upperCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inspect__ = __webpack_require__(/*! ./inspect */ 9);
// String utilities

 // --- Utilities ---
// Converts PascalCase or camelCase to kebab-case

var kebabCase = function kebabCase(str) {
  return str.replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["c" /* RX_HYPHENATE */], '-$1').toLowerCase();
}; // Converts a kebab-case or camelCase string to PascalCase

var pascalCase = function pascalCase(str) {
  str = kebabCase(str).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["d" /* RX_UN_KEBAB */], function (_, c) {
    return c ? c.toUpperCase() : '';
  });
  return str.charAt(0).toUpperCase() + str.slice(1);
}; // Converts a string, including strings in camelCase or snake_case, into Start Case
// It keeps original single quote and hyphen in the word
// https://github.com/UrbanCompass/to-start-case

var startCase = function startCase(str) {
  return str.replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["e" /* RX_UNDERSCORE */], ' ').replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["f" /* RX_LOWER_UPPER */], function (str, $1, $2) {
    return $1 + ' ' + $2;
  }).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["g" /* RX_START_SPACE_WORD */], function (str, $1, $2) {
    return $1 + $2.toUpperCase();
  });
}; // Lowercases the first letter of a string and returns a new string

var lowerFirst = function lowerFirst(str) {
  str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["f" /* isString */])(str) ? str.trim() : String(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
}; // Uppercases the first letter of a string and returns a new string

var upperFirst = function upperFirst(str) {
  str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["f" /* isString */])(str) ? str.trim() : String(str);
  return str.charAt(0).toUpperCase() + str.slice(1);
}; // Escape characters to be used in building a regular expression

var escapeRegExp = function escapeRegExp(str) {
  return str.replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["h" /* RX_REGEXP_REPLACE */], '\\$&');
}; // Convert a value to a string that can be rendered
// `undefined`/`null` will be converted to `''`
// Plain objects and arrays will be JSON stringified

var toString = function toString(val) {
  var spaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["g" /* isUndefinedOrNull */])(val) ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["c" /* isArray */])(val) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["h" /* isPlainObject */])(val) && val.toString === Object.prototype.toString ? JSON.stringify(val, null, spaces) : String(val);
}; // Remove leading white space from a string

var trimLeft = function trimLeft(str) {
  return toString(str).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["i" /* RX_TRIM_LEFT */], '');
}; // Remove Trailing white space from a string

var trimRight = function trimRight(str) {
  return toString(str).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["j" /* RX_TRIM_RIGHT */], '');
}; // Remove leading and trailing white space from a string

var trim = function trim(str) {
  return toString(str).trim();
}; // Lower case a string

var lowerCase = function lowerCase(str) {
  return toString(str).toLowerCase();
}; // Upper case a string

var upperCase = function upperCase(str) {
  return toString(str).toUpperCase();
};

/***/ }),
/* 24 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./client/router/routesMap.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BANKING = '/banking';
var LOGIN = BANKING;
var PASSWORD_RECOVERY = BANKING + '/recuperacaoSenha';
var NEW_PASSWORD = BANKING + '/novaSenha';
var LOGIN_EMULADO = BANKING + '/loginEmulado';
var TROCA_APLICACAO = BANKING + '/loginTrocaAplicacao';
var HOME = BANKING + '/dashboard';
var BANK_STATEMENT = BANKING + '/extratoBancario';
var BANK_BALANCE = BANKING + '/saldoBancario';
var DIGITAL_WALLET_BALANCE = BANKING + '/saldoCarteiraDigital';
var DUPLICATE_MOVEMENTS_ANALYSIS = BANKING + '/analiseDuplicidade';
var FINANCIAL_MOVEMENT = BANKING + '/movimentosFinanceiros';
var CONCILIATION_REPORT = BANKING + '/relatorioConciliacao';
var CONCILIATION_SUMMARY = BANKING + '/resumoConciliacao';
var CONCILIATION_SUMMARY_CALENDAR = BANKING + '/resumoConciliacao/calendario';
var MANUAL_CONCILIATION = BANKING + '/conciliacaoManual';
var OCCURRENCE_REPORT = BANKING + '/relatorioOcorrencias';
var PROCESSED_FILES = BANKING + '/arquivosProcessados';
var FILE_UPLOAD = BANKING + '/envioArquivos';
var REMITTANCE_INTEGRATION = BANKING + '/remessaIntegracao';
var LIST_BANK_ACCOUNTS = BANKING + '/contasBancarias';
var NEW_BANK_ACCOUNT = BANKING + '/contasBancarias/nova';
var LIST_ESTABLISHMENTS = BANKING + '/estabelecimentos';
var NEW_ESTABLISHMENT = BANKING + '/estabelecimentos/novo';
var MOVE_ESTABLISHMENT = BANKING + '/estabelecimentos/moverEstabelecimento';
var CATEGORIES = BANKING + '/categorias';
var LIST_CONCILIATION_PLANS = BANKING + '/planosConciliacao';
var NEW_CONCILIATION_PLAN = BANKING + '/planosConciliacao/novo';
var LIST_OCCURRENCE_REASONS = BANKING + '/motivosOcorrencia';
var NEW_OCCURRENCE_REASON = BANKING + '/motivosOcorrencia/novo';
var LIST_ATTRIBUTES_SET = BANKING + '/conjuntoAtributos';
var NEW_ATTRIBUTES_SET = BANKING + '/conjuntoAtributos/novo';
var LIST_ACCESS_PROFILE = BANKING + '/perfisAcesso';
var NEW_ACCESS_PROFILE = BANKING + '/perfisAcesso/novo';
var LIST_OPERATORS = BANKING + '/operadores';
var NEW_OPERATOR = BANKING + '/operadores/novo';
var LIST_ASSIGNMENT = BANKING + '/tarefas';
var AUDIT_LOG = BANKING + '/logsAuditoria';
var UNAUTHORIZED = BANKING + '/naoAutorizado';

var OFDA_REG_DEEPLINK = BANKING + '/ofdaRegDeeplink';

exports.default = {
  BANKING: BANKING,
  LOGIN: LOGIN,
  PASSWORD_RECOVERY: PASSWORD_RECOVERY,
  NEW_PASSWORD: NEW_PASSWORD,
  LOGIN_EMULADO: LOGIN_EMULADO,
  TROCA_APLICACAO: TROCA_APLICACAO,
  HOME: HOME,
  BANK_STATEMENT: BANK_STATEMENT,
  BANK_BALANCE: BANK_BALANCE,
  DIGITAL_WALLET_BALANCE: DIGITAL_WALLET_BALANCE,
  DUPLICATE_MOVEMENTS_ANALYSIS: DUPLICATE_MOVEMENTS_ANALYSIS,
  FINANCIAL_MOVEMENT: FINANCIAL_MOVEMENT,
  CONCILIATION_REPORT: CONCILIATION_REPORT,
  CONCILIATION_SUMMARY: CONCILIATION_SUMMARY,
  CONCILIATION_SUMMARY_CALENDAR: CONCILIATION_SUMMARY_CALENDAR,
  MANUAL_CONCILIATION: MANUAL_CONCILIATION,
  OCCURRENCE_REPORT: OCCURRENCE_REPORT,
  PROCESSED_FILES: PROCESSED_FILES,
  FILE_UPLOAD: FILE_UPLOAD,
  REMITTANCE_INTEGRATION: REMITTANCE_INTEGRATION,
  LIST_BANK_ACCOUNTS: LIST_BANK_ACCOUNTS,
  NEW_BANK_ACCOUNT: NEW_BANK_ACCOUNT,
  LIST_ESTABLISHMENTS: LIST_ESTABLISHMENTS,
  NEW_ESTABLISHMENT: NEW_ESTABLISHMENT,
  MOVE_ESTABLISHMENT: MOVE_ESTABLISHMENT,
  CATEGORIES: CATEGORIES,
  LIST_CONCILIATION_PLANS: LIST_CONCILIATION_PLANS,
  NEW_CONCILIATION_PLAN: NEW_CONCILIATION_PLAN,
  LIST_OCCURRENCE_REASONS: LIST_OCCURRENCE_REASONS,
  NEW_OCCURRENCE_REASON: NEW_OCCURRENCE_REASON,
  LIST_ATTRIBUTES_SET: LIST_ATTRIBUTES_SET,
  NEW_ATTRIBUTES_SET: NEW_ATTRIBUTES_SET,
  LIST_ACCESS_PROFILE: LIST_ACCESS_PROFILE,
  NEW_ACCESS_PROFILE: NEW_ACCESS_PROFILE,
  LIST_OPERATORS: LIST_OPERATORS,
  NEW_OPERATOR: NEW_OPERATOR,
  LIST_ASSIGNMENT: LIST_ASSIGNMENT,
  AUDIT_LOG: AUDIT_LOG,
  UNAUTHORIZED: UNAUTHORIZED,
  OFDA_REG_DEEPLINK: OFDA_REG_DEEPLINK
};

/***/ }),
/* 25 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./client/utils/analytics.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var trackAnalyticsEvent = function trackAnalyticsEvent(context, category, action, label) {
  context.$ga.query('send', 'event', {
    'eventCategory': category,
    'eventAction': action,
    'eventLabel': label,
    hitCallback: function hitCallback() {},
    hitCallbackFail: function hitCallbackFail() {}
  });
};

exports.trackAnalyticsEvent = trackAnalyticsEvent;

/***/ }),
/* 26 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./client/components/layout/pageTitle/PageTitle.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-777d8892","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./PageTitle.vue */ 1537)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./PageTitle.vue */ 828),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-777d8892"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./pageTitle.pug */ 1441),
  /* scopeId */
  "data-v-777d8892",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/layout/pageTitle/PageTitle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PageTitle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-777d8892", Component.options)
  } else {
    hotAPI.reload("data-v-777d8892", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 27 */
/* exports provided: props, idMixin */
/* exports used: props, idMixin */
/*!******************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/id.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return idMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
// SSR safe client-side ID attribute generation
// ID's can only be generated client-side, after mount
// `this._uid` is not synched between server and client


 // --- Props ---

var props = {
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */])
}; // --- Mixin ---
// @vue/component

var idMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  data: function data() {
    return {
      localId_: null
    };
  },
  computed: {
    safeId: function safeId() {
      // Computed property that returns a dynamic function for creating the ID
      // Reacts to changes in both `.id` and `.localId_` and regenerates a new function
      var id = this.id || this.localId_; // We return a function that accepts an optional suffix string
      // So this computed prop looks and works like a method
      // but benefits from Vue's computed prop caching

      var fn = function fn(suffix) {
        if (!id) {
          return null;
        }

        suffix = String(suffix || '').replace(/\s+/g, '_');
        return suffix ? id + '_' + suffix : id;
      };

      return fn;
    }
  },
  mounted: function mounted() {
    var _this = this;

    // `mounted()` only occurs client-side
    this.$nextTick(function () {
      // Update DOM with auto-generated ID after mount
      // to prevent SSR hydration errors
      _this.localId_ = "__BVID__".concat(_this[__WEBPACK_IMPORTED_MODULE_0__vue__["e" /* COMPONENT_UID_KEY */]]);
    });
  }
});

/***/ }),
/* 28 */
/* exports provided: identity */
/* exports used: identity */
/*!***********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/identity.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var identity = function identity(x) {
  return x;
};

/***/ }),
/* 29 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./~/vue-select/dist/vue-select.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueSelect=e():t.VueSelect=e()}("undefined"!=typeof self?self:this,(function(){return function(t){var e={};function n(o){if(e[o])return e[o].exports;var i=e[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(o,i,function(e){return t[e]}.bind(null,i));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=8)}([function(t,e,n){var o=n(4),i=n(5),r=n(6);t.exports=function(t){return o(t)||i(t)||r()}},function(t,e){function n(e){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=n=function(t){return typeof t}:t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(e)}t.exports=n},function(t,e,n){},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e){t.exports=function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}},function(t,e){t.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(t,e,n){"use strict";var o=n(2);n.n(o).a},function(t,e,n){"use strict";n.r(e);var o=n(0),i=n.n(o),r=n(1),s=n.n(r),a=n(3),l=n.n(a),c={props:{autoscroll:{type:Boolean,default:!0}},watch:{typeAheadPointer:function(){this.autoscroll&&this.maybeAdjustScroll()}},methods:{maybeAdjustScroll:function(){var t,e=(null===(t=this.$refs.dropdownMenu)||void 0===t?void 0:t.children[this.typeAheadPointer])||!1;if(e){var n=this.getDropdownViewport(),o=e.getBoundingClientRect(),i=o.top,r=o.bottom,s=o.height;if(i<n.top)return this.$refs.dropdownMenu.scrollTop=e.offsetTop;if(r>n.bottom)return this.$refs.dropdownMenu.scrollTop=e.offsetTop-(n.height-s)}},getDropdownViewport:function(){return this.$refs.dropdownMenu?this.$refs.dropdownMenu.getBoundingClientRect():{height:0,top:0,bottom:0}}}},u={data:function(){return{typeAheadPointer:-1}},watch:{filteredOptions:function(){for(var t=0;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}}},methods:{typeAheadUp:function(){for(var t=this.typeAheadPointer-1;t>=0;t--)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadDown:function(){for(var t=this.typeAheadPointer+1;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadSelect:function(){var t=this.filteredOptions[this.typeAheadPointer];t&&this.select(t)}}},p={props:{loading:{type:Boolean,default:!1}},data:function(){return{mutableLoading:!1}},watch:{search:function(){this.$emit("search",this.search,this.toggleLoading)},loading:function(t){this.mutableLoading=t}},methods:{toggleLoading:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.mutableLoading=null==t?!this.mutableLoading:t}}};function h(t,e,n,o,i,r,s,a){var l,c="function"==typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=n,c._compiled=!0),o&&(c.functional=!0),r&&(c._scopeId="data-v-"+r),s?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(s)},c._ssrRegister=l):i&&(l=a?function(){i.call(this,this.$root.$options.shadowRoot)}:i),l)if(c.functional){c._injectStyles=l;var u=c.render;c.render=function(t,e){return l.call(e),u(t,e)}}else{var p=c.beforeCreate;c.beforeCreate=p?[].concat(p,l):[l]}return{exports:t,options:c}}var d={Deselect:h({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"10"}},[e("path",{attrs:{d:"M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"}})])}),[],!1,null,null,null).exports,OpenIndicator:h({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"10"}},[e("path",{attrs:{d:"M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"}})])}),[],!1,null,null,null).exports},f={inserted:function(t,e,n){var o=n.context;if(o.appendToBody){var i=o.$refs.toggle.getBoundingClientRect(),r=i.height,s=i.top,a=i.left,l=i.width,c=window.scrollX||window.pageXOffset,u=window.scrollY||window.pageYOffset;t.unbindPosition=o.calculatePosition(t,o,{width:l+"px",left:c+a+"px",top:u+s+r+"px"}),document.body.appendChild(t)}},unbind:function(t,e,n){n.context.appendToBody&&(t.unbindPosition&&"function"==typeof t.unbindPosition&&t.unbindPosition(),t.parentNode&&t.parentNode.removeChild(t))}};var y=function(t){var e={};return Object.keys(t).sort().forEach((function(n){e[n]=t[n]})),JSON.stringify(e)},b=0;var g=function(){return++b};function v(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,o)}return n}function m(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?v(Object(n),!0).forEach((function(e){l()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var _={components:m({},d),mixins:[c,u,p],directives:{appendToBody:f},props:{value:{},components:{type:Object,default:function(){return{}}},options:{type:Array,default:function(){return[]}},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},searchable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},placeholder:{type:String,default:""},transition:{type:String,default:"vs__fade"},clearSearchOnSelect:{type:Boolean,default:!0},closeOnSelect:{type:Boolean,default:!0},label:{type:String,default:"label"},autocomplete:{type:String,default:"off"},reduce:{type:Function,default:function(t){return t}},selectable:{type:Function,default:function(t){return!0}},getOptionLabel:{type:Function,default:function(t){return"object"===s()(t)?t.hasOwnProperty(this.label)?t[this.label]:console.warn('[vue-select warn]: Label key "option.'.concat(this.label,'" does not')+" exist in options object ".concat(JSON.stringify(t),".\n")+"https://vue-select.org/api/props.html#getoptionlabel"):t}},getOptionKey:{type:Function,default:function(t){if("object"!==s()(t))return t;try{return t.hasOwnProperty("id")?t.id:y(t)}catch(e){return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey",t,e)}}},onTab:{type:Function,default:function(){this.selectOnTab&&!this.isComposing&&this.typeAheadSelect()}},taggable:{type:Boolean,default:!1},tabindex:{type:Number,default:null},pushTags:{type:Boolean,default:!1},filterable:{type:Boolean,default:!0},filterBy:{type:Function,default:function(t,e,n){return(e||"").toLowerCase().indexOf(n.toLowerCase())>-1}},filter:{type:Function,default:function(t,e){var n=this;return t.filter((function(t){var o=n.getOptionLabel(t);return"number"==typeof o&&(o=o.toString()),n.filterBy(t,o,e)}))}},createOption:{type:Function,default:function(t){return"object"===s()(this.optionList[0])?l()({},this.label,t):t}},resetOnOptionsChange:{default:!1,validator:function(t){return["function","boolean"].includes(s()(t))}},clearSearchOnBlur:{type:Function,default:function(t){var e=t.clearSearchOnSelect,n=t.multiple;return e&&!n}},noDrop:{type:Boolean,default:!1},inputId:{type:String},dir:{type:String,default:"auto"},selectOnTab:{type:Boolean,default:!1},selectOnKeyCodes:{type:Array,default:function(){return[13]}},searchInputQuerySelector:{type:String,default:"[type=search]"},mapKeydown:{type:Function,default:function(t,e){return t}},appendToBody:{type:Boolean,default:!1},calculatePosition:{type:Function,default:function(t,e,n){var o=n.width,i=n.top,r=n.left;t.style.top=i,t.style.left=r,t.style.width=o}}},data:function(){return{uid:g(),search:"",open:!1,isComposing:!1,pushedTags:[],_value:[]}},watch:{options:function(t,e){var n=this;!this.taggable&&("function"==typeof n.resetOnOptionsChange?n.resetOnOptionsChange(t,e,n.selectedValue):n.resetOnOptionsChange)&&this.clearSelection(),this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value)},value:function(t){this.isTrackingValues&&this.setInternalValueFromOptions(t)},multiple:function(){this.clearSelection()},open:function(t){this.$emit(t?"open":"close")}},created:function(){this.mutableLoading=this.loading,void 0!==this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value),this.$on("option:created",this.pushTag)},methods:{setInternalValueFromOptions:function(t){var e=this;Array.isArray(t)?this.$data._value=t.map((function(t){return e.findOptionFromReducedValue(t)})):this.$data._value=this.findOptionFromReducedValue(t)},select:function(t){this.isOptionSelected(t)||(this.taggable&&!this.optionExists(t)&&this.$emit("option:created",t),this.multiple&&(t=this.selectedValue.concat(t)),this.updateValue(t)),this.onAfterSelect(t)},deselect:function(t){var e=this;this.updateValue(this.selectedValue.filter((function(n){return!e.optionComparator(n,t)})))},clearSelection:function(){this.updateValue(this.multiple?[]:null)},onAfterSelect:function(t){this.closeOnSelect&&(this.open=!this.open,this.searchEl.blur()),this.clearSearchOnSelect&&(this.search="")},updateValue:function(t){var e=this;void 0===this.value&&(this.$data._value=t),null!==t&&(t=Array.isArray(t)?t.map((function(t){return e.reduce(t)})):this.reduce(t)),this.$emit("input",t)},toggleDropdown:function(t){var e=t.target!==this.searchEl;e&&t.preventDefault(),[].concat(i()(this.$refs.deselectButtons||[]),i()([this.$refs.clearButton]||!1)).some((function(e){return e.contains(t.target)||e===t.target}))?t.preventDefault():this.open&&e?this.searchEl.blur():this.disabled||(this.open=!0,this.searchEl.focus())},isOptionSelected:function(t){var e=this;return this.selectedValue.some((function(n){return e.optionComparator(n,t)}))},optionComparator:function(t,e){return this.getOptionKey(t)===this.getOptionKey(e)},findOptionFromReducedValue:function(t){var e=this,n=[].concat(i()(this.options),i()(this.pushedTags)).filter((function(n){return JSON.stringify(e.reduce(n))===JSON.stringify(t)}));return 1===n.length?n[0]:n.find((function(t){return e.optionComparator(t,e.$data._value)}))||t},closeSearchOptions:function(){this.open=!1,this.$emit("search:blur")},maybeDeleteValue:function(){if(!this.searchEl.value.length&&this.selectedValue&&this.selectedValue.length&&this.clearable){var t=null;this.multiple&&(t=i()(this.selectedValue.slice(0,this.selectedValue.length-1))),this.updateValue(t)}},optionExists:function(t){var e=this;return this.optionList.some((function(n){return e.optionComparator(n,t)}))},normalizeOptionForSlot:function(t){return"object"===s()(t)?t:l()({},this.label,t)},pushTag:function(t){this.pushedTags.push(t)},onEscape:function(){this.search.length?this.search="":this.searchEl.blur()},onSearchBlur:function(){if(!this.mousedown||this.searching){var t=this.clearSearchOnSelect,e=this.multiple;return this.clearSearchOnBlur({clearSearchOnSelect:t,multiple:e})&&(this.search=""),void this.closeSearchOptions()}this.mousedown=!1,0!==this.search.length||0!==this.options.length||this.closeSearchOptions()},onSearchFocus:function(){this.open=!0,this.$emit("search:focus")},onMousedown:function(){this.mousedown=!0},onMouseUp:function(){this.mousedown=!1},onSearchKeyDown:function(t){var e=this,n=function(t){return t.preventDefault(),!e.isComposing&&e.typeAheadSelect()},o={8:function(t){return e.maybeDeleteValue()},9:function(t){return e.onTab()},27:function(t){return e.onEscape()},38:function(t){return t.preventDefault(),e.typeAheadUp()},40:function(t){return t.preventDefault(),e.typeAheadDown()}};this.selectOnKeyCodes.forEach((function(t){return o[t]=n}));var i=this.mapKeydown(o,this);if("function"==typeof i[t.keyCode])return i[t.keyCode](t)}},computed:{isTrackingValues:function(){return void 0===this.value||this.$options.propsData.hasOwnProperty("reduce")},selectedValue:function(){var t=this.value;return this.isTrackingValues&&(t=this.$data._value),t?[].concat(t):[]},optionList:function(){return this.options.concat(this.pushTags?this.pushedTags:[])},searchEl:function(){return this.$scopedSlots.search?this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector):this.$refs.search},scope:function(){var t=this,e={search:this.search,loading:this.loading,searching:this.searching,filteredOptions:this.filteredOptions};return{search:{attributes:m({disabled:this.disabled,placeholder:this.searchPlaceholder,tabindex:this.tabindex,readonly:!this.searchable,id:this.inputId,"aria-autocomplete":"list","aria-labelledby":"vs".concat(this.uid,"__combobox"),"aria-controls":"vs".concat(this.uid,"__listbox"),ref:"search",type:"search",autocomplete:this.autocomplete,value:this.search},this.dropdownOpen&&this.filteredOptions[this.typeAheadPointer]?{"aria-activedescendant":"vs".concat(this.uid,"__option-").concat(this.typeAheadPointer)}:{}),events:{compositionstart:function(){return t.isComposing=!0},compositionend:function(){return t.isComposing=!1},keydown:this.onSearchKeyDown,blur:this.onSearchBlur,focus:this.onSearchFocus,input:function(e){return t.search=e.target.value}}},spinner:{loading:this.mutableLoading},noOptions:{search:this.search,loading:this.loading,searching:this.searching},openIndicator:{attributes:{ref:"openIndicator",role:"presentation",class:"vs__open-indicator"}},listHeader:e,listFooter:e,header:m({},e,{deselect:this.deselect}),footer:m({},e,{deselect:this.deselect})}},childComponents:function(){return m({},d,{},this.components)},stateClasses:function(){return{"vs--open":this.dropdownOpen,"vs--single":!this.multiple,"vs--searching":this.searching&&!this.noDrop,"vs--searchable":this.searchable&&!this.noDrop,"vs--unsearchable":!this.searchable,"vs--loading":this.mutableLoading,"vs--disabled":this.disabled}},searching:function(){return!!this.search},dropdownOpen:function(){return!this.noDrop&&(this.open&&!this.mutableLoading)},searchPlaceholder:function(){if(this.isValueEmpty&&this.placeholder)return this.placeholder},filteredOptions:function(){var t=[].concat(this.optionList);if(!this.filterable&&!this.taggable)return t;var e=this.search.length?this.filter(t,this.search,this):t;if(this.taggable&&this.search.length){var n=this.createOption(this.search);this.optionExists(n)||e.unshift(n)}return e},isValueEmpty:function(){return 0===this.selectedValue.length},showClearButton:function(){return!this.multiple&&this.clearable&&!this.open&&!this.isValueEmpty}}},O=(n(7),h(_,(function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"v-select",class:t.stateClasses,attrs:{dir:t.dir}},[t._t("header",null,null,t.scope.header),t._v(" "),n("div",{ref:"toggle",staticClass:"vs__dropdown-toggle",attrs:{id:"vs"+t.uid+"__combobox",role:"combobox","aria-expanded":t.dropdownOpen.toString(),"aria-owns":"vs"+t.uid+"__listbox","aria-label":"Search for option"},on:{mousedown:function(e){return t.toggleDropdown(e)}}},[n("div",{ref:"selectedOptions",staticClass:"vs__selected-options"},[t._l(t.selectedValue,(function(e){return t._t("selected-option-container",[n("span",{key:t.getOptionKey(e),staticClass:"vs__selected"},[t._t("selected-option",[t._v("\n            "+t._s(t.getOptionLabel(e))+"\n          ")],null,t.normalizeOptionForSlot(e)),t._v(" "),t.multiple?n("button",{ref:"deselectButtons",refInFor:!0,staticClass:"vs__deselect",attrs:{disabled:t.disabled,type:"button",title:"Deselect "+t.getOptionLabel(e),"aria-label":"Deselect "+t.getOptionLabel(e)},on:{click:function(n){return t.deselect(e)}}},[n(t.childComponents.Deselect,{tag:"component"})],1):t._e()],2)],{option:t.normalizeOptionForSlot(e),deselect:t.deselect,multiple:t.multiple,disabled:t.disabled})})),t._v(" "),t._t("search",[n("input",t._g(t._b({staticClass:"vs__search"},"input",t.scope.search.attributes,!1),t.scope.search.events))],null,t.scope.search)],2),t._v(" "),n("div",{ref:"actions",staticClass:"vs__actions"},[n("button",{directives:[{name:"show",rawName:"v-show",value:t.showClearButton,expression:"showClearButton"}],ref:"clearButton",staticClass:"vs__clear",attrs:{disabled:t.disabled,type:"button",title:"Clear Selected","aria-label":"Clear Selected"},on:{click:t.clearSelection}},[n(t.childComponents.Deselect,{tag:"component"})],1),t._v(" "),t._t("open-indicator",[t.noDrop?t._e():n(t.childComponents.OpenIndicator,t._b({tag:"component"},"component",t.scope.openIndicator.attributes,!1))],null,t.scope.openIndicator),t._v(" "),t._t("spinner",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.mutableLoading,expression:"mutableLoading"}],staticClass:"vs__spinner"},[t._v("Loading...")])],null,t.scope.spinner)],2)]),t._v(" "),n("transition",{attrs:{name:t.transition}},[t.dropdownOpen?n("ul",{directives:[{name:"append-to-body",rawName:"v-append-to-body"}],key:"vs"+t.uid+"__listbox",ref:"dropdownMenu",staticClass:"vs__dropdown-menu",attrs:{id:"vs"+t.uid+"__listbox",role:"listbox"},on:{mousedown:function(e){return e.preventDefault(),t.onMousedown(e)},mouseup:t.onMouseUp}},[t._t("list-header",null,null,t.scope.listHeader),t._v(" "),t._l(t.filteredOptions,(function(e,o){return n("li",{key:t.getOptionKey(e),staticClass:"vs__dropdown-option",class:{"vs__dropdown-option--selected":t.isOptionSelected(e),"vs__dropdown-option--highlight":o===t.typeAheadPointer,"vs__dropdown-option--disabled":!t.selectable(e)},attrs:{role:"option",id:"vs"+t.uid+"__option-"+o,"aria-selected":o===t.typeAheadPointer||null},on:{mouseover:function(n){t.selectable(e)&&(t.typeAheadPointer=o)},mousedown:function(n){n.preventDefault(),n.stopPropagation(),t.selectable(e)&&t.select(e)}}},[t._t("option",[t._v("\n          "+t._s(t.getOptionLabel(e))+"\n        ")],null,t.normalizeOptionForSlot(e))],2)})),t._v(" "),0===t.filteredOptions.length?n("li",{staticClass:"vs__no-options"},[t._t("no-options",[t._v("Sorry, no matching options.")],null,t.scope.noOptions)],2):t._e(),t._v(" "),t._t("list-footer",null,null,t.scope.listFooter)],2):n("ul",{staticStyle:{display:"none",visibility:"hidden"},attrs:{id:"vs"+t.uid+"__listbox",role:"listbox"}})]),t._v(" "),t._t("footer",null,null,t.scope.footer)],2)}),[],!1,null,null,null).exports),w={ajax:p,pointer:u,pointerScroll:c};n.d(e,"VueSelect",(function(){return O})),n.d(e,"mixins",(function(){return w}));e.default=O}])}));
//# sourceMappingURL=vue-select.js.map

/***/ }),
/* 30 */
/* exports provided: HAS_WINDOW_SUPPORT, HAS_DOCUMENT_SUPPORT, HAS_NAVIGATOR_SUPPORT, HAS_PROMISE_SUPPORT, HAS_MUTATION_OBSERVER_SUPPORT, IS_BROWSER, WINDOW, DOCUMENT, NAVIGATOR, USER_AGENT, IS_JSDOM, IS_IE, HAS_PASSIVE_EVENT_SUPPORT, HAS_TOUCH_SUPPORT, HAS_POINTER_EVENT_SUPPORT, HAS_INTERACTION_OBSERVER_SUPPORT */
/* exports used: HAS_WINDOW_SUPPORT, WINDOW, DOCUMENT, IS_JSDOM, IS_BROWSER, HAS_PROMISE_SUPPORT, HAS_MUTATION_OBSERVER_SUPPORT, HAS_PASSIVE_EVENT_SUPPORT, HAS_TOUCH_SUPPORT, HAS_INTERACTION_OBSERVER_SUPPORT, HAS_POINTER_EVENT_SUPPORT */
/*!**********************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/env.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HAS_WINDOW_SUPPORT; });
/* unused harmony export HAS_DOCUMENT_SUPPORT */
/* unused harmony export HAS_NAVIGATOR_SUPPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HAS_PROMISE_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HAS_MUTATION_OBSERVER_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IS_BROWSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WINDOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOCUMENT; });
/* unused harmony export NAVIGATOR */
/* unused harmony export USER_AGENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IS_JSDOM; });
/* unused harmony export IS_IE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HAS_PASSIVE_EVENT_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HAS_TOUCH_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return HAS_POINTER_EVENT_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HAS_INTERACTION_OBSERVER_SUPPORT; });
var HAS_WINDOW_SUPPORT = typeof window !== 'undefined';
var HAS_DOCUMENT_SUPPORT = typeof document !== 'undefined';
var HAS_NAVIGATOR_SUPPORT = typeof navigator !== 'undefined';
var HAS_PROMISE_SUPPORT = typeof Promise !== 'undefined';
/* istanbul ignore next: JSDOM always returns false */

var HAS_MUTATION_OBSERVER_SUPPORT = typeof MutationObserver !== 'undefined' || typeof WebKitMutationObserver !== 'undefined' || typeof MozMutationObserver !== 'undefined';
var IS_BROWSER = HAS_WINDOW_SUPPORT && HAS_DOCUMENT_SUPPORT && HAS_NAVIGATOR_SUPPORT;
var WINDOW = HAS_WINDOW_SUPPORT ? window : {};
var DOCUMENT = HAS_DOCUMENT_SUPPORT ? document : {};
var NAVIGATOR = HAS_NAVIGATOR_SUPPORT ? navigator : {};
var USER_AGENT = (NAVIGATOR.userAgent || '').toLowerCase();
var IS_JSDOM = USER_AGENT.indexOf('jsdom') > 0;
var IS_IE = /msie|trident/.test(USER_AGENT); // Determine if the browser supports the option passive for events

var HAS_PASSIVE_EVENT_SUPPORT = function () {
  var passiveEventSupported = false;

  if (IS_BROWSER) {
    try {
      var options = {
        // This function will be called when the browser
        // attempts to access the passive property
        get passive() {
          /* istanbul ignore next: will never be called in JSDOM */
          passiveEventSupported = true;
        }

      };
      WINDOW.addEventListener('test', options, options);
      WINDOW.removeEventListener('test', options, options);
    } catch (_unused) {
      /* istanbul ignore next: will never be called in JSDOM */
      passiveEventSupported = false;
    }
  }

  return passiveEventSupported;
}();
var HAS_TOUCH_SUPPORT = IS_BROWSER && ('ontouchstart' in DOCUMENT.documentElement || NAVIGATOR.maxTouchPoints > 0);
var HAS_POINTER_EVENT_SUPPORT = IS_BROWSER && Boolean(WINDOW.PointerEvent || WINDOW.MSPointerEvent);
/* istanbul ignore next: JSDOM only checks for 'IntersectionObserver' */

var HAS_INTERACTION_OBSERVER_SUPPORT = IS_BROWSER && 'IntersectionObserver' in WINDOW && 'IntersectionObserverEntry' in WINDOW && // Edge 15 and UC Browser lack support for `isIntersecting`
// but we an use `intersectionRatio > 0` instead
// 'isIntersecting' in window.IntersectionObserverEntry.prototype &&
'intersectionRatio' in WINDOW.IntersectionObserverEntry.prototype;

/***/ }),
/* 31 */
/* no static exports found */
/* all exports used */
/*!***************************!*\
  !*** ./~/vue/dist/vue.js ***!
  \***************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.7.16
 * (c) 2014-2023 Evan You
 * Released under the MIT License.
 */
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Vue = factory());
})(this, (function () { 'use strict';

  var emptyObject = Object.freeze({});
  var isArray = Array.isArray;
  // These helpers produce better VM code in JS engines due to their
  // explicitness and function inlining.
  function isUndef(v) {
      return v === undefined || v === null;
  }
  function isDef(v) {
      return v !== undefined && v !== null;
  }
  function isTrue(v) {
      return v === true;
  }
  function isFalse(v) {
      return v === false;
  }
  /**
   * Check if value is primitive.
   */
  function isPrimitive(value) {
      return (typeof value === 'string' ||
          typeof value === 'number' ||
          // $flow-disable-line
          typeof value === 'symbol' ||
          typeof value === 'boolean');
  }
  function isFunction(value) {
      return typeof value === 'function';
  }
  /**
   * Quick object check - this is primarily used to tell
   * objects from primitive values when we know the value
   * is a JSON-compliant type.
   */
  function isObject(obj) {
      return obj !== null && typeof obj === 'object';
  }
  /**
   * Get the raw type string of a value, e.g., [object Object].
   */
  var _toString = Object.prototype.toString;
  function toRawType(value) {
      return _toString.call(value).slice(8, -1);
  }
  /**
   * Strict object type check. Only returns true
   * for plain JavaScript objects.
   */
  function isPlainObject(obj) {
      return _toString.call(obj) === '[object Object]';
  }
  function isRegExp(v) {
      return _toString.call(v) === '[object RegExp]';
  }
  /**
   * Check if val is a valid array index.
   */
  function isValidArrayIndex(val) {
      var n = parseFloat(String(val));
      return n >= 0 && Math.floor(n) === n && isFinite(val);
  }
  function isPromise(val) {
      return (isDef(val) &&
          typeof val.then === 'function' &&
          typeof val.catch === 'function');
  }
  /**
   * Convert a value to a string that is actually rendered.
   */
  function toString(val) {
      return val == null
          ? ''
          : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
              ? JSON.stringify(val, replacer, 2)
              : String(val);
  }
  function replacer(_key, val) {
      // avoid circular deps from v3
      if (val && val.__v_isRef) {
          return val.value;
      }
      return val;
  }
  /**
   * Convert an input value to a number for persistence.
   * If the conversion fails, return original string.
   */
  function toNumber(val) {
      var n = parseFloat(val);
      return isNaN(n) ? val : n;
  }
  /**
   * Make a map and return a function for checking if a key
   * is in that map.
   */
  function makeMap(str, expectsLowerCase) {
      var map = Object.create(null);
      var list = str.split(',');
      for (var i = 0; i < list.length; i++) {
          map[list[i]] = true;
      }
      return expectsLowerCase ? function (val) { return map[val.toLowerCase()]; } : function (val) { return map[val]; };
  }
  /**
   * Check if a tag is a built-in tag.
   */
  var isBuiltInTag = makeMap('slot,component', true);
  /**
   * Check if an attribute is a reserved attribute.
   */
  var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
  /**
   * Remove an item from an array.
   */
  function remove$2(arr, item) {
      var len = arr.length;
      if (len) {
          // fast path for the only / last item
          if (item === arr[len - 1]) {
              arr.length = len - 1;
              return;
          }
          var index = arr.indexOf(item);
          if (index > -1) {
              return arr.splice(index, 1);
          }
      }
  }
  /**
   * Check whether an object has the property.
   */
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  function hasOwn(obj, key) {
      return hasOwnProperty.call(obj, key);
  }
  /**
   * Create a cached version of a pure function.
   */
  function cached(fn) {
      var cache = Object.create(null);
      return function cachedFn(str) {
          var hit = cache[str];
          return hit || (cache[str] = fn(str));
      };
  }
  /**
   * Camelize a hyphen-delimited string.
   */
  var camelizeRE = /-(\w)/g;
  var camelize = cached(function (str) {
      return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
  });
  /**
   * Capitalize a string.
   */
  var capitalize = cached(function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
  });
  /**
   * Hyphenate a camelCase string.
   */
  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cached(function (str) {
      return str.replace(hyphenateRE, '-$1').toLowerCase();
  });
  /**
   * Simple bind polyfill for environments that do not support it,
   * e.g., PhantomJS 1.x. Technically, we don't need this anymore
   * since native bind is now performant enough in most browsers.
   * But removing it would mean breaking code that was able to run in
   * PhantomJS 1.x, so this must be kept for backward compatibility.
   */
  /* istanbul ignore next */
  function polyfillBind(fn, ctx) {
      function boundFn(a) {
          var l = arguments.length;
          return l
              ? l > 1
                  ? fn.apply(ctx, arguments)
                  : fn.call(ctx, a)
              : fn.call(ctx);
      }
      boundFn._length = fn.length;
      return boundFn;
  }
  function nativeBind(fn, ctx) {
      return fn.bind(ctx);
  }
  // @ts-expect-error bind cannot be `undefined`
  var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
  /**
   * Convert an Array-like object to a real Array.
   */
  function toArray(list, start) {
      start = start || 0;
      var i = list.length - start;
      var ret = new Array(i);
      while (i--) {
          ret[i] = list[i + start];
      }
      return ret;
  }
  /**
   * Mix properties into target object.
   */
  function extend(to, _from) {
      for (var key in _from) {
          to[key] = _from[key];
      }
      return to;
  }
  /**
   * Merge an Array of Objects into a single Object.
   */
  function toObject(arr) {
      var res = {};
      for (var i = 0; i < arr.length; i++) {
          if (arr[i]) {
              extend(res, arr[i]);
          }
      }
      return res;
  }
  /* eslint-disable no-unused-vars */
  /**
   * Perform no operation.
   * Stubbing args to make Flow happy without leaving useless transpiled code
   * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
   */
  function noop(a, b, c) { }
  /**
   * Always return false.
   */
  var no = function (a, b, c) { return false; };
  /* eslint-enable no-unused-vars */
  /**
   * Return the same value.
   */
  var identity = function (_) { return _; };
  /**
   * Generate a string containing static keys from compiler modules.
   */
  function genStaticKeys$1(modules) {
      return modules
          .reduce(function (keys, m) { return keys.concat(m.staticKeys || []); }, [])
          .join(',');
  }
  /**
   * Check if two values are loosely equal - that is,
   * if they are plain objects, do they have the same shape?
   */
  function looseEqual(a, b) {
      if (a === b)
          return true;
      var isObjectA = isObject(a);
      var isObjectB = isObject(b);
      if (isObjectA && isObjectB) {
          try {
              var isArrayA = Array.isArray(a);
              var isArrayB = Array.isArray(b);
              if (isArrayA && isArrayB) {
                  return (a.length === b.length &&
                      a.every(function (e, i) {
                          return looseEqual(e, b[i]);
                      }));
              }
              else if (a instanceof Date && b instanceof Date) {
                  return a.getTime() === b.getTime();
              }
              else if (!isArrayA && !isArrayB) {
                  var keysA = Object.keys(a);
                  var keysB = Object.keys(b);
                  return (keysA.length === keysB.length &&
                      keysA.every(function (key) {
                          return looseEqual(a[key], b[key]);
                      }));
              }
              else {
                  /* istanbul ignore next */
                  return false;
              }
          }
          catch (e) {
              /* istanbul ignore next */
              return false;
          }
      }
      else if (!isObjectA && !isObjectB) {
          return String(a) === String(b);
      }
      else {
          return false;
      }
  }
  /**
   * Return the first index at which a loosely equal value can be
   * found in the array (if value is a plain object, the array must
   * contain an object of the same shape), or -1 if it is not present.
   */
  function looseIndexOf(arr, val) {
      for (var i = 0; i < arr.length; i++) {
          if (looseEqual(arr[i], val))
              return i;
      }
      return -1;
  }
  /**
   * Ensure a function is called only once.
   */
  function once(fn) {
      var called = false;
      return function () {
          if (!called) {
              called = true;
              fn.apply(this, arguments);
          }
      };
  }
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
  function hasChanged(x, y) {
      if (x === y) {
          return x === 0 && 1 / x !== 1 / y;
      }
      else {
          return x === x || y === y;
      }
  }

  var SSR_ATTR = 'data-server-rendered';
  var ASSET_TYPES = ['component', 'directive', 'filter'];
  var LIFECYCLE_HOOKS = [
      'beforeCreate',
      'created',
      'beforeMount',
      'mounted',
      'beforeUpdate',
      'updated',
      'beforeDestroy',
      'destroyed',
      'activated',
      'deactivated',
      'errorCaptured',
      'serverPrefetch',
      'renderTracked',
      'renderTriggered'
  ];

  var config = {
      /**
       * Option merge strategies (used in core/util/options)
       */
      // $flow-disable-line
      optionMergeStrategies: Object.create(null),
      /**
       * Whether to suppress warnings.
       */
      silent: false,
      /**
       * Show production mode tip message on boot?
       */
      productionTip: true,
      /**
       * Whether to enable devtools
       */
      devtools: true,
      /**
       * Whether to record perf
       */
      performance: false,
      /**
       * Error handler for watcher errors
       */
      errorHandler: null,
      /**
       * Warn handler for watcher warns
       */
      warnHandler: null,
      /**
       * Ignore certain custom elements
       */
      ignoredElements: [],
      /**
       * Custom user key aliases for v-on
       */
      // $flow-disable-line
      keyCodes: Object.create(null),
      /**
       * Check if a tag is reserved so that it cannot be registered as a
       * component. This is platform-dependent and may be overwritten.
       */
      isReservedTag: no,
      /**
       * Check if an attribute is reserved so that it cannot be used as a component
       * prop. This is platform-dependent and may be overwritten.
       */
      isReservedAttr: no,
      /**
       * Check if a tag is an unknown element.
       * Platform-dependent.
       */
      isUnknownElement: no,
      /**
       * Get the namespace of an element
       */
      getTagNamespace: noop,
      /**
       * Parse the real tag name for the specific platform.
       */
      parsePlatformTagName: identity,
      /**
       * Check if an attribute must be bound using property, e.g. value
       * Platform-dependent.
       */
      mustUseProp: no,
      /**
       * Perform updates asynchronously. Intended to be used by Vue Test Utils
       * This will significantly reduce performance if set to false.
       */
      async: true,
      /**
       * Exposed for legacy reasons
       */
      _lifecycleHooks: LIFECYCLE_HOOKS
  };

  /**
   * unicode letters used for parsing html tags, component names and property paths.
   * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
   * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
   */
  var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
  /**
   * Check if a string starts with $ or _
   */
  function isReserved(str) {
      var c = (str + '').charCodeAt(0);
      return c === 0x24 || c === 0x5f;
  }
  /**
   * Define a property.
   */
  function def(obj, key, val, enumerable) {
      Object.defineProperty(obj, key, {
          value: val,
          enumerable: !!enumerable,
          writable: true,
          configurable: true
      });
  }
  /**
   * Parse simple path.
   */
  var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
  function parsePath(path) {
      if (bailRE.test(path)) {
          return;
      }
      var segments = path.split('.');
      return function (obj) {
          for (var i = 0; i < segments.length; i++) {
              if (!obj)
                  return;
              obj = obj[segments[i]];
          }
          return obj;
      };
  }

  // can we use __proto__?
  var hasProto = '__proto__' in {};
  // Browser environment sniffing
  var inBrowser = typeof window !== 'undefined';
  var UA = inBrowser && window.navigator.userAgent.toLowerCase();
  var isIE = UA && /msie|trident/.test(UA);
  var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
  var isEdge = UA && UA.indexOf('edge/') > 0;
  UA && UA.indexOf('android') > 0;
  var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
  UA && /chrome\/\d+/.test(UA) && !isEdge;
  UA && /phantomjs/.test(UA);
  var isFF = UA && UA.match(/firefox\/(\d+)/);
  // Firefox has a "watch" function on Object.prototype...
  // @ts-expect-error firebox support
  var nativeWatch = {}.watch;
  var supportsPassive = false;
  if (inBrowser) {
      try {
          var opts = {};
          Object.defineProperty(opts, 'passive', {
              get: function () {
                  /* istanbul ignore next */
                  supportsPassive = true;
              }
          }); // https://github.com/facebook/flow/issues/285
          window.addEventListener('test-passive', null, opts);
      }
      catch (e) { }
  }
  // this needs to be lazy-evaled because vue may be required before
  // vue-server-renderer can set VUE_ENV
  var _isServer;
  var isServerRendering = function () {
      if (_isServer === undefined) {
          /* istanbul ignore if */
          if (!inBrowser && typeof global !== 'undefined') {
              // detect presence of vue-server-renderer and avoid
              // Webpack shimming the process
              _isServer =
                  global['process'] && global['process'].env.VUE_ENV === 'server';
          }
          else {
              _isServer = false;
          }
      }
      return _isServer;
  };
  // detect devtools
  var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
  /* istanbul ignore next */
  function isNative(Ctor) {
      return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
  }
  var hasSymbol = typeof Symbol !== 'undefined' &&
      isNative(Symbol) &&
      typeof Reflect !== 'undefined' &&
      isNative(Reflect.ownKeys);
  var _Set; // $flow-disable-line
  /* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
      // use native Set when available.
      _Set = Set;
  }
  else {
      // a non-standard Set polyfill that only works with primitive keys.
      _Set = /** @class */ (function () {
          function Set() {
              this.set = Object.create(null);
          }
          Set.prototype.has = function (key) {
              return this.set[key] === true;
          };
          Set.prototype.add = function (key) {
              this.set[key] = true;
          };
          Set.prototype.clear = function () {
              this.set = Object.create(null);
          };
          return Set;
      }());
  }

  var currentInstance = null;
  /**
   * This is exposed for compatibility with v3 (e.g. some functions in VueUse
   * relies on it). Do not use this internally, just use `currentInstance`.
   *
   * @internal this function needs manual type declaration because it relies
   * on previously manually authored types from Vue 2
   */
  function getCurrentInstance() {
      return currentInstance && { proxy: currentInstance };
  }
  /**
   * @internal
   */
  function setCurrentInstance(vm) {
      if (vm === void 0) { vm = null; }
      if (!vm)
          currentInstance && currentInstance._scope.off();
      currentInstance = vm;
      vm && vm._scope.on();
  }

  /**
   * @internal
   */
  var VNode = /** @class */ (function () {
      function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
          this.tag = tag;
          this.data = data;
          this.children = children;
          this.text = text;
          this.elm = elm;
          this.ns = undefined;
          this.context = context;
          this.fnContext = undefined;
          this.fnOptions = undefined;
          this.fnScopeId = undefined;
          this.key = data && data.key;
          this.componentOptions = componentOptions;
          this.componentInstance = undefined;
          this.parent = undefined;
          this.raw = false;
          this.isStatic = false;
          this.isRootInsert = true;
          this.isComment = false;
          this.isCloned = false;
          this.isOnce = false;
          this.asyncFactory = asyncFactory;
          this.asyncMeta = undefined;
          this.isAsyncPlaceholder = false;
      }
      Object.defineProperty(VNode.prototype, "child", {
          // DEPRECATED: alias for componentInstance for backwards compat.
          /* istanbul ignore next */
          get: function () {
              return this.componentInstance;
          },
          enumerable: false,
          configurable: true
      });
      return VNode;
  }());
  var createEmptyVNode = function (text) {
      if (text === void 0) { text = ''; }
      var node = new VNode();
      node.text = text;
      node.isComment = true;
      return node;
  };
  function createTextVNode(val) {
      return new VNode(undefined, undefined, undefined, String(val));
  }
  // optimized shallow clone
  // used for static nodes and slot nodes because they may be reused across
  // multiple renders, cloning them avoids errors when DOM manipulations rely
  // on their elm reference.
  function cloneVNode(vnode) {
      var cloned = new VNode(vnode.tag, vnode.data, 
      // #7975
      // clone children array to avoid mutating original in case of cloning
      // a child.
      vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
      cloned.ns = vnode.ns;
      cloned.isStatic = vnode.isStatic;
      cloned.key = vnode.key;
      cloned.isComment = vnode.isComment;
      cloned.fnContext = vnode.fnContext;
      cloned.fnOptions = vnode.fnOptions;
      cloned.fnScopeId = vnode.fnScopeId;
      cloned.asyncMeta = vnode.asyncMeta;
      cloned.isCloned = true;
      return cloned;
  }

  /* not type checking this file because flow doesn't play well with Proxy */
  var initProxy;
  {
      var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' +
          'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
          'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
          'require' // for Webpack/Browserify
      );
      var warnNonPresent_1 = function (target, key) {
          warn$2("Property or method \"".concat(key, "\" is not defined on the instance but ") +
              'referenced during render. Make sure that this property is reactive, ' +
              'either in the data option, or for class-based components, by ' +
              'initializing the property. ' +
              'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
      };
      var warnReservedPrefix_1 = function (target, key) {
          warn$2("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") +
              'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
              'prevent conflicts with Vue internals. ' +
              'See: https://v2.vuejs.org/v2/api/#data', target);
      };
      var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
      if (hasProxy_1) {
          var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
          config.keyCodes = new Proxy(config.keyCodes, {
              set: function (target, key, value) {
                  if (isBuiltInModifier_1(key)) {
                      warn$2("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                      return false;
                  }
                  else {
                      target[key] = value;
                      return true;
                  }
              }
          });
      }
      var hasHandler_1 = {
          has: function (target, key) {
              var has = key in target;
              var isAllowed = allowedGlobals_1(key) ||
                  (typeof key === 'string' &&
                      key.charAt(0) === '_' &&
                      !(key in target.$data));
              if (!has && !isAllowed) {
                  if (key in target.$data)
                      warnReservedPrefix_1(target, key);
                  else
                      warnNonPresent_1(target, key);
              }
              return has || !isAllowed;
          }
      };
      var getHandler_1 = {
          get: function (target, key) {
              if (typeof key === 'string' && !(key in target)) {
                  if (key in target.$data)
                      warnReservedPrefix_1(target, key);
                  else
                      warnNonPresent_1(target, key);
              }
              return target[key];
          }
      };
      initProxy = function initProxy(vm) {
          if (hasProxy_1) {
              // determine which proxy handler to use
              var options = vm.$options;
              var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
              vm._renderProxy = new Proxy(vm, handlers);
          }
          else {
              vm._renderProxy = vm;
          }
      };
  }

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
      var e = new Error(message);
      return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
  };

  var uid$2 = 0;
  var pendingCleanupDeps = [];
  var cleanupDeps = function () {
      for (var i = 0; i < pendingCleanupDeps.length; i++) {
          var dep = pendingCleanupDeps[i];
          dep.subs = dep.subs.filter(function (s) { return s; });
          dep._pending = false;
      }
      pendingCleanupDeps.length = 0;
  };
  /**
   * A dep is an observable that can have multiple
   * directives subscribing to it.
   * @internal
   */
  var Dep = /** @class */ (function () {
      function Dep() {
          // pending subs cleanup
          this._pending = false;
          this.id = uid$2++;
          this.subs = [];
      }
      Dep.prototype.addSub = function (sub) {
          this.subs.push(sub);
      };
      Dep.prototype.removeSub = function (sub) {
          // #12696 deps with massive amount of subscribers are extremely slow to
          // clean up in Chromium
          // to workaround this, we unset the sub for now, and clear them on
          // next scheduler flush.
          this.subs[this.subs.indexOf(sub)] = null;
          if (!this._pending) {
              this._pending = true;
              pendingCleanupDeps.push(this);
          }
      };
      Dep.prototype.depend = function (info) {
          if (Dep.target) {
              Dep.target.addDep(this);
              if (info && Dep.target.onTrack) {
                  Dep.target.onTrack(__assign({ effect: Dep.target }, info));
              }
          }
      };
      Dep.prototype.notify = function (info) {
          // stabilize the subscriber list first
          var subs = this.subs.filter(function (s) { return s; });
          if (!config.async) {
              // subs aren't sorted in scheduler if not running async
              // we need to sort them now to make sure they fire in correct
              // order
              subs.sort(function (a, b) { return a.id - b.id; });
          }
          for (var i = 0, l = subs.length; i < l; i++) {
              var sub = subs[i];
              if (info) {
                  sub.onTrigger &&
                      sub.onTrigger(__assign({ effect: subs[i] }, info));
              }
              sub.update();
          }
      };
      return Dep;
  }());
  // The current target watcher being evaluated.
  // This is globally unique because only one watcher
  // can be evaluated at a time.
  Dep.target = null;
  var targetStack = [];
  function pushTarget(target) {
      targetStack.push(target);
      Dep.target = target;
  }
  function popTarget() {
      targetStack.pop();
      Dep.target = targetStack[targetStack.length - 1];
  }

  /*
   * not type checking this file because flow doesn't play well with
   * dynamically accessing methods on Array prototype
   */
  var arrayProto = Array.prototype;
  var arrayMethods = Object.create(arrayProto);
  var methodsToPatch = [
      'push',
      'pop',
      'shift',
      'unshift',
      'splice',
      'sort',
      'reverse'
  ];
  /**
   * Intercept mutating methods and emit events
   */
  methodsToPatch.forEach(function (method) {
      // cache original method
      var original = arrayProto[method];
      def(arrayMethods, method, function mutator() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
          }
          var result = original.apply(this, args);
          var ob = this.__ob__;
          var inserted;
          switch (method) {
              case 'push':
              case 'unshift':
                  inserted = args;
                  break;
              case 'splice':
                  inserted = args.slice(2);
                  break;
          }
          if (inserted)
              ob.observeArray(inserted);
          // notify change
          {
              ob.dep.notify({
                  type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
                  target: this,
                  key: method
              });
          }
          return result;
      });
  });

  var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
  var NO_INITIAL_VALUE = {};
  /**
   * In some cases we may want to disable observation inside a component's
   * update computation.
   */
  var shouldObserve = true;
  function toggleObserving(value) {
      shouldObserve = value;
  }
  // ssr mock dep
  var mockDep = {
      notify: noop,
      depend: noop,
      addSub: noop,
      removeSub: noop
  };
  /**
   * Observer class that is attached to each observed
   * object. Once attached, the observer converts the target
   * object's property keys into getter/setters that
   * collect dependencies and dispatch updates.
   */
  var Observer = /** @class */ (function () {
      function Observer(value, shallow, mock) {
          if (shallow === void 0) { shallow = false; }
          if (mock === void 0) { mock = false; }
          this.value = value;
          this.shallow = shallow;
          this.mock = mock;
          // this.value = value
          this.dep = mock ? mockDep : new Dep();
          this.vmCount = 0;
          def(value, '__ob__', this);
          if (isArray(value)) {
              if (!mock) {
                  if (hasProto) {
                      value.__proto__ = arrayMethods;
                      /* eslint-enable no-proto */
                  }
                  else {
                      for (var i = 0, l = arrayKeys.length; i < l; i++) {
                          var key = arrayKeys[i];
                          def(value, key, arrayMethods[key]);
                      }
                  }
              }
              if (!shallow) {
                  this.observeArray(value);
              }
          }
          else {
              /**
               * Walk through all properties and convert them into
               * getter/setters. This method should only be called when
               * value type is Object.
               */
              var keys = Object.keys(value);
              for (var i = 0; i < keys.length; i++) {
                  var key = keys[i];
                  defineReactive(value, key, NO_INITIAL_VALUE, undefined, shallow, mock);
              }
          }
      }
      /**
       * Observe a list of Array items.
       */
      Observer.prototype.observeArray = function (value) {
          for (var i = 0, l = value.length; i < l; i++) {
              observe(value[i], false, this.mock);
          }
      };
      return Observer;
  }());
  // helpers
  /**
   * Attempt to create an observer instance for a value,
   * returns the new observer if successfully observed,
   * or the existing observer if the value already has one.
   */
  function observe(value, shallow, ssrMockReactivity) {
      if (value && hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
          return value.__ob__;
      }
      if (shouldObserve &&
          (ssrMockReactivity || !isServerRendering()) &&
          (isArray(value) || isPlainObject(value)) &&
          Object.isExtensible(value) &&
          !value.__v_skip /* ReactiveFlags.SKIP */ &&
          !isRef(value) &&
          !(value instanceof VNode)) {
          return new Observer(value, shallow, ssrMockReactivity);
      }
  }
  /**
   * Define a reactive property on an Object.
   */
  function defineReactive(obj, key, val, customSetter, shallow, mock, observeEvenIfShallow) {
      if (observeEvenIfShallow === void 0) { observeEvenIfShallow = false; }
      var dep = new Dep();
      var property = Object.getOwnPropertyDescriptor(obj, key);
      if (property && property.configurable === false) {
          return;
      }
      // cater for pre-defined getter/setters
      var getter = property && property.get;
      var setter = property && property.set;
      if ((!getter || setter) &&
          (val === NO_INITIAL_VALUE || arguments.length === 2)) {
          val = obj[key];
      }
      var childOb = shallow ? val && val.__ob__ : observe(val, false, mock);
      Object.defineProperty(obj, key, {
          enumerable: true,
          configurable: true,
          get: function reactiveGetter() {
              var value = getter ? getter.call(obj) : val;
              if (Dep.target) {
                  {
                      dep.depend({
                          target: obj,
                          type: "get" /* TrackOpTypes.GET */,
                          key: key
                      });
                  }
                  if (childOb) {
                      childOb.dep.depend();
                      if (isArray(value)) {
                          dependArray(value);
                      }
                  }
              }
              return isRef(value) && !shallow ? value.value : value;
          },
          set: function reactiveSetter(newVal) {
              var value = getter ? getter.call(obj) : val;
              if (!hasChanged(value, newVal)) {
                  return;
              }
              if (customSetter) {
                  customSetter();
              }
              if (setter) {
                  setter.call(obj, newVal);
              }
              else if (getter) {
                  // #7981: for accessor properties without setter
                  return;
              }
              else if (!shallow && isRef(value) && !isRef(newVal)) {
                  value.value = newVal;
                  return;
              }
              else {
                  val = newVal;
              }
              childOb = shallow ? newVal && newVal.__ob__ : observe(newVal, false, mock);
              {
                  dep.notify({
                      type: "set" /* TriggerOpTypes.SET */,
                      target: obj,
                      key: key,
                      newValue: newVal,
                      oldValue: value
                  });
              }
          }
      });
      return dep;
  }
  function set(target, key, val) {
      if ((isUndef(target) || isPrimitive(target))) {
          warn$2("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
      }
      if (isReadonly(target)) {
          warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
          return;
      }
      var ob = target.__ob__;
      if (isArray(target) && isValidArrayIndex(key)) {
          target.length = Math.max(target.length, key);
          target.splice(key, 1, val);
          // when mocking for SSR, array methods are not hijacked
          if (ob && !ob.shallow && ob.mock) {
              observe(val, false, true);
          }
          return val;
      }
      if (key in target && !(key in Object.prototype)) {
          target[key] = val;
          return val;
      }
      if (target._isVue || (ob && ob.vmCount)) {
          warn$2('Avoid adding reactive properties to a Vue instance or its root $data ' +
                  'at runtime - declare it upfront in the data option.');
          return val;
      }
      if (!ob) {
          target[key] = val;
          return val;
      }
      defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
      {
          ob.dep.notify({
              type: "add" /* TriggerOpTypes.ADD */,
              target: target,
              key: key,
              newValue: val,
              oldValue: undefined
          });
      }
      return val;
  }
  function del(target, key) {
      if ((isUndef(target) || isPrimitive(target))) {
          warn$2("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
      }
      if (isArray(target) && isValidArrayIndex(key)) {
          target.splice(key, 1);
          return;
      }
      var ob = target.__ob__;
      if (target._isVue || (ob && ob.vmCount)) {
          warn$2('Avoid deleting properties on a Vue instance or its root $data ' +
                  '- just set it to null.');
          return;
      }
      if (isReadonly(target)) {
          warn$2("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
          return;
      }
      if (!hasOwn(target, key)) {
          return;
      }
      delete target[key];
      if (!ob) {
          return;
      }
      {
          ob.dep.notify({
              type: "delete" /* TriggerOpTypes.DELETE */,
              target: target,
              key: key
          });
      }
  }
  /**
   * Collect dependencies on array elements when the array is touched, since
   * we cannot intercept array element access like property getters.
   */
  function dependArray(value) {
      for (var e = void 0, i = 0, l = value.length; i < l; i++) {
          e = value[i];
          if (e && e.__ob__) {
              e.__ob__.dep.depend();
          }
          if (isArray(e)) {
              dependArray(e);
          }
      }
  }

  function reactive(target) {
      makeReactive(target, false);
      return target;
  }
  /**
   * Return a shallowly-reactive copy of the original object, where only the root
   * level properties are reactive. It also does not auto-unwrap refs (even at the
   * root level).
   */
  function shallowReactive(target) {
      makeReactive(target, true);
      def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
      return target;
  }
  function makeReactive(target, shallow) {
      // if trying to observe a readonly proxy, return the readonly version.
      if (!isReadonly(target)) {
          {
              if (isArray(target)) {
                  warn$2("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
              }
              var existingOb = target && target.__ob__;
              if (existingOb && existingOb.shallow !== shallow) {
                  warn$2("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
              }
          }
          var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
          if (!ob) {
              if (target == null || isPrimitive(target)) {
                  warn$2("value cannot be made reactive: ".concat(String(target)));
              }
              if (isCollectionType(target)) {
                  warn$2("Vue 2 does not support reactive collection types such as Map or Set.");
              }
          }
      }
  }
  function isReactive(value) {
      if (isReadonly(value)) {
          return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
      }
      return !!(value && value.__ob__);
  }
  function isShallow(value) {
      return !!(value && value.__v_isShallow);
  }
  function isReadonly(value) {
      return !!(value && value.__v_isReadonly);
  }
  function isProxy(value) {
      return isReactive(value) || isReadonly(value);
  }
  function toRaw(observed) {
      var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
      return raw ? toRaw(raw) : observed;
  }
  function markRaw(value) {
      // non-extensible objects won't be observed anyway
      if (Object.isExtensible(value)) {
          def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
      }
      return value;
  }
  /**
   * @internal
   */
  function isCollectionType(value) {
      var type = toRawType(value);
      return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
  }

  /**
   * @internal
   */
  var RefFlag = "__v_isRef";
  function isRef(r) {
      return !!(r && r.__v_isRef === true);
  }
  function ref$1(value) {
      return createRef(value, false);
  }
  function shallowRef(value) {
      return createRef(value, true);
  }
  function createRef(rawValue, shallow) {
      if (isRef(rawValue)) {
          return rawValue;
      }
      var ref = {};
      def(ref, RefFlag, true);
      def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
      def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
      return ref;
  }
  function triggerRef(ref) {
      if (!ref.dep) {
          warn$2("received object is not a triggerable ref.");
      }
      {
          ref.dep &&
              ref.dep.notify({
                  type: "set" /* TriggerOpTypes.SET */,
                  target: ref,
                  key: 'value'
              });
      }
  }
  function unref(ref) {
      return isRef(ref) ? ref.value : ref;
  }
  function proxyRefs(objectWithRefs) {
      if (isReactive(objectWithRefs)) {
          return objectWithRefs;
      }
      var proxy = {};
      var keys = Object.keys(objectWithRefs);
      for (var i = 0; i < keys.length; i++) {
          proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
      }
      return proxy;
  }
  function proxyWithRefUnwrap(target, source, key) {
      Object.defineProperty(target, key, {
          enumerable: true,
          configurable: true,
          get: function () {
              var val = source[key];
              if (isRef(val)) {
                  return val.value;
              }
              else {
                  var ob = val && val.__ob__;
                  if (ob)
                      ob.dep.depend();
                  return val;
              }
          },
          set: function (value) {
              var oldValue = source[key];
              if (isRef(oldValue) && !isRef(value)) {
                  oldValue.value = value;
              }
              else {
                  source[key] = value;
              }
          }
      });
  }
  function customRef(factory) {
      var dep = new Dep();
      var _a = factory(function () {
          {
              dep.depend({
                  target: ref,
                  type: "get" /* TrackOpTypes.GET */,
                  key: 'value'
              });
          }
      }, function () {
          {
              dep.notify({
                  target: ref,
                  type: "set" /* TriggerOpTypes.SET */,
                  key: 'value'
              });
          }
      }), get = _a.get, set = _a.set;
      var ref = {
          get value() {
              return get();
          },
          set value(newVal) {
              set(newVal);
          }
      };
      def(ref, RefFlag, true);
      return ref;
  }
  function toRefs(object) {
      if (!isReactive(object)) {
          warn$2("toRefs() expects a reactive object but received a plain one.");
      }
      var ret = isArray(object) ? new Array(object.length) : {};
      for (var key in object) {
          ret[key] = toRef(object, key);
      }
      return ret;
  }
  function toRef(object, key, defaultValue) {
      var val = object[key];
      if (isRef(val)) {
          return val;
      }
      var ref = {
          get value() {
              var val = object[key];
              return val === undefined ? defaultValue : val;
          },
          set value(newVal) {
              object[key] = newVal;
          }
      };
      def(ref, RefFlag, true);
      return ref;
  }

  var rawToReadonlyFlag = "__v_rawToReadonly";
  var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
  function readonly(target) {
      return createReadonly(target, false);
  }
  function createReadonly(target, shallow) {
      if (!isPlainObject(target)) {
          {
              if (isArray(target)) {
                  warn$2("Vue 2 does not support readonly arrays.");
              }
              else if (isCollectionType(target)) {
                  warn$2("Vue 2 does not support readonly collection types such as Map or Set.");
              }
              else {
                  warn$2("value cannot be made readonly: ".concat(typeof target));
              }
          }
          return target;
      }
      if (!Object.isExtensible(target)) {
          warn$2("Vue 2 does not support creating readonly proxy for non-extensible object.");
      }
      // already a readonly object
      if (isReadonly(target)) {
          return target;
      }
      // already has a readonly proxy
      var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
      var existingProxy = target[existingFlag];
      if (existingProxy) {
          return existingProxy;
      }
      var proxy = Object.create(Object.getPrototypeOf(target));
      def(target, existingFlag, proxy);
      def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
      def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
      if (isRef(target)) {
          def(proxy, RefFlag, true);
      }
      if (shallow || isShallow(target)) {
          def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
      }
      var keys = Object.keys(target);
      for (var i = 0; i < keys.length; i++) {
          defineReadonlyProperty(proxy, target, keys[i], shallow);
      }
      return proxy;
  }
  function defineReadonlyProperty(proxy, target, key, shallow) {
      Object.defineProperty(proxy, key, {
          enumerable: true,
          configurable: true,
          get: function () {
              var val = target[key];
              return shallow || !isPlainObject(val) ? val : readonly(val);
          },
          set: function () {
              warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
          }
      });
  }
  /**
   * Returns a reactive-copy of the original object, where only the root level
   * properties are readonly, and does NOT unwrap refs nor recursively convert
   * returned properties.
   * This is used for creating the props proxy object for stateful components.
   */
  function shallowReadonly(target) {
      return createReadonly(target, true);
  }

  function computed(getterOrOptions, debugOptions) {
      var getter;
      var setter;
      var onlyGetter = isFunction(getterOrOptions);
      if (onlyGetter) {
          getter = getterOrOptions;
          setter = function () {
                  warn$2('Write operation failed: computed value is readonly');
              }
              ;
      }
      else {
          getter = getterOrOptions.get;
          setter = getterOrOptions.set;
      }
      var watcher = isServerRendering()
          ? null
          : new Watcher(currentInstance, getter, noop, { lazy: true });
      if (watcher && debugOptions) {
          watcher.onTrack = debugOptions.onTrack;
          watcher.onTrigger = debugOptions.onTrigger;
      }
      var ref = {
          // some libs rely on the presence effect for checking computed refs
          // from normal refs, but the implementation doesn't matter
          effect: watcher,
          get value() {
              if (watcher) {
                  if (watcher.dirty) {
                      watcher.evaluate();
                  }
                  if (Dep.target) {
                      if (Dep.target.onTrack) {
                          Dep.target.onTrack({
                              effect: Dep.target,
                              target: ref,
                              type: "get" /* TrackOpTypes.GET */,
                              key: 'value'
                          });
                      }
                      watcher.depend();
                  }
                  return watcher.value;
              }
              else {
                  return getter();
              }
          },
          set value(newVal) {
              setter(newVal);
          }
      };
      def(ref, RefFlag, true);
      def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
      return ref;
  }

  var mark;
  var measure;
  {
      var perf_1 = inBrowser && window.performance;
      /* istanbul ignore if */
      if (perf_1 &&
          // @ts-ignore
          perf_1.mark &&
          // @ts-ignore
          perf_1.measure &&
          // @ts-ignore
          perf_1.clearMarks &&
          // @ts-ignore
          perf_1.clearMeasures) {
          mark = function (tag) { return perf_1.mark(tag); };
          measure = function (name, startTag, endTag) {
              perf_1.measure(name, startTag, endTag);
              perf_1.clearMarks(startTag);
              perf_1.clearMarks(endTag);
              // perf.clearMeasures(name)
          };
      }
  }

  var normalizeEvent = cached(function (name) {
      var passive = name.charAt(0) === '&';
      name = passive ? name.slice(1) : name;
      var once = name.charAt(0) === '~'; // Prefixed last, checked first
      name = once ? name.slice(1) : name;
      var capture = name.charAt(0) === '!';
      name = capture ? name.slice(1) : name;
      return {
          name: name,
          once: once,
          capture: capture,
          passive: passive
      };
  });
  function createFnInvoker(fns, vm) {
      function invoker() {
          var fns = invoker.fns;
          if (isArray(fns)) {
              var cloned = fns.slice();
              for (var i = 0; i < cloned.length; i++) {
                  invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
              }
          }
          else {
              // return handler return value for single handlers
              return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
          }
      }
      invoker.fns = fns;
      return invoker;
  }
  function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
      var name, cur, old, event;
      for (name in on) {
          cur = on[name];
          old = oldOn[name];
          event = normalizeEvent(name);
          if (isUndef(cur)) {
              warn$2("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
          }
          else if (isUndef(old)) {
              if (isUndef(cur.fns)) {
                  cur = on[name] = createFnInvoker(cur, vm);
              }
              if (isTrue(event.once)) {
                  cur = on[name] = createOnceHandler(event.name, cur, event.capture);
              }
              add(event.name, cur, event.capture, event.passive, event.params);
          }
          else if (cur !== old) {
              old.fns = cur;
              on[name] = old;
          }
      }
      for (name in oldOn) {
          if (isUndef(on[name])) {
              event = normalizeEvent(name);
              remove(event.name, oldOn[name], event.capture);
          }
      }
  }

  function mergeVNodeHook(def, hookKey, hook) {
      if (def instanceof VNode) {
          def = def.data.hook || (def.data.hook = {});
      }
      var invoker;
      var oldHook = def[hookKey];
      function wrappedHook() {
          hook.apply(this, arguments);
          // important: remove merged hook to ensure it's called only once
          // and prevent memory leak
          remove$2(invoker.fns, wrappedHook);
      }
      if (isUndef(oldHook)) {
          // no existing hook
          invoker = createFnInvoker([wrappedHook]);
      }
      else {
          /* istanbul ignore if */
          if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
              // already a merged invoker
              invoker = oldHook;
              invoker.fns.push(wrappedHook);
          }
          else {
              // existing plain hook
              invoker = createFnInvoker([oldHook, wrappedHook]);
          }
      }
      invoker.merged = true;
      def[hookKey] = invoker;
  }

  function extractPropsFromVNodeData(data, Ctor, tag) {
      // we are only extracting raw values here.
      // validation and default values are handled in the child
      // component itself.
      var propOptions = Ctor.options.props;
      if (isUndef(propOptions)) {
          return;
      }
      var res = {};
      var attrs = data.attrs, props = data.props;
      if (isDef(attrs) || isDef(props)) {
          for (var key in propOptions) {
              var altKey = hyphenate(key);
              {
                  var keyInLowerCase = key.toLowerCase();
                  if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                      tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") +
                          "".concat(formatComponentName(
                          // @ts-expect-error tag is string
                          tag || Ctor), ", but the declared prop name is") +
                          " \"".concat(key, "\". ") +
                          "Note that HTML attributes are case-insensitive and camelCased " +
                          "props need to use their kebab-case equivalents when using in-DOM " +
                          "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                  }
              }
              checkProp(res, props, key, altKey, true) ||
                  checkProp(res, attrs, key, altKey, false);
          }
      }
      return res;
  }
  function checkProp(res, hash, key, altKey, preserve) {
      if (isDef(hash)) {
          if (hasOwn(hash, key)) {
              res[key] = hash[key];
              if (!preserve) {
                  delete hash[key];
              }
              return true;
          }
          else if (hasOwn(hash, altKey)) {
              res[key] = hash[altKey];
              if (!preserve) {
                  delete hash[altKey];
              }
              return true;
          }
      }
      return false;
  }

  // The template compiler attempts to minimize the need for normalization by
  // statically analyzing the template at compile time.
  //
  // For plain HTML markup, normalization can be completely skipped because the
  // generated render function is guaranteed to return Array<VNode>. There are
  // two cases where extra normalization is needed:
  // 1. When the children contains components - because a functional component
  // may return an Array instead of a single root. In this case, just a simple
  // normalization is needed - if any child is an Array, we flatten the whole
  // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
  // because functional components already normalize their own children.
  function simpleNormalizeChildren(children) {
      for (var i = 0; i < children.length; i++) {
          if (isArray(children[i])) {
              return Array.prototype.concat.apply([], children);
          }
      }
      return children;
  }
  // 2. When the children contains constructs that always generated nested Arrays,
  // e.g. <template>, <slot>, v-for, or when the children is provided by user
  // with hand-written render functions / JSX. In such cases a full normalization
  // is needed to cater to all possible types of children values.
  function normalizeChildren(children) {
      return isPrimitive(children)
          ? [createTextVNode(children)]
          : isArray(children)
              ? normalizeArrayChildren(children)
              : undefined;
  }
  function isTextNode(node) {
      return isDef(node) && isDef(node.text) && isFalse(node.isComment);
  }
  function normalizeArrayChildren(children, nestedIndex) {
      var res = [];
      var i, c, lastIndex, last;
      for (i = 0; i < children.length; i++) {
          c = children[i];
          if (isUndef(c) || typeof c === 'boolean')
              continue;
          lastIndex = res.length - 1;
          last = res[lastIndex];
          //  nested
          if (isArray(c)) {
              if (c.length > 0) {
                  c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                  // merge adjacent text nodes
                  if (isTextNode(c[0]) && isTextNode(last)) {
                      res[lastIndex] = createTextVNode(last.text + c[0].text);
                      c.shift();
                  }
                  res.push.apply(res, c);
              }
          }
          else if (isPrimitive(c)) {
              if (isTextNode(last)) {
                  // merge adjacent text nodes
                  // this is necessary for SSR hydration because text nodes are
                  // essentially merged when rendered to HTML strings
                  res[lastIndex] = createTextVNode(last.text + c);
              }
              else if (c !== '') {
                  // convert primitive to vnode
                  res.push(createTextVNode(c));
              }
          }
          else {
              if (isTextNode(c) && isTextNode(last)) {
                  // merge adjacent text nodes
                  res[lastIndex] = createTextVNode(last.text + c.text);
              }
              else {
                  // default key for nested array children (likely generated by v-for)
                  if (isTrue(children._isVList) &&
                      isDef(c.tag) &&
                      isUndef(c.key) &&
                      isDef(nestedIndex)) {
                      c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                  }
                  res.push(c);
              }
          }
      }
      return res;
  }

  var SIMPLE_NORMALIZE = 1;
  var ALWAYS_NORMALIZE = 2;
  // wrapper function for providing a more flexible interface
  // without getting yelled at by flow
  function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
      if (isArray(data) || isPrimitive(data)) {
          normalizationType = children;
          children = data;
          data = undefined;
      }
      if (isTrue(alwaysNormalize)) {
          normalizationType = ALWAYS_NORMALIZE;
      }
      return _createElement(context, tag, data, children, normalizationType);
  }
  function _createElement(context, tag, data, children, normalizationType) {
      if (isDef(data) && isDef(data.__ob__)) {
          warn$2("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
          return createEmptyVNode();
      }
      // object syntax in v-bind
      if (isDef(data) && isDef(data.is)) {
          tag = data.is;
      }
      if (!tag) {
          // in case of component :is set to falsy value
          return createEmptyVNode();
      }
      // warn against non-primitive key
      if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)) {
          warn$2('Avoid using non-primitive value as key, ' +
              'use string/number value instead.', context);
      }
      // support single function children as default scoped slot
      if (isArray(children) && isFunction(children[0])) {
          data = data || {};
          data.scopedSlots = { default: children[0] };
          children.length = 0;
      }
      if (normalizationType === ALWAYS_NORMALIZE) {
          children = normalizeChildren(children);
      }
      else if (normalizationType === SIMPLE_NORMALIZE) {
          children = simpleNormalizeChildren(children);
      }
      var vnode, ns;
      if (typeof tag === 'string') {
          var Ctor = void 0;
          ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
          if (config.isReservedTag(tag)) {
              // platform built-in elements
              if (isDef(data) &&
                  isDef(data.nativeOn) &&
                  data.tag !== 'component') {
                  warn$2("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
              }
              vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
          }
          else if ((!data || !data.pre) &&
              isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
              // component
              vnode = createComponent(Ctor, data, context, children, tag);
          }
          else {
              // unknown or unlisted namespaced elements
              // check at runtime because it may get assigned a namespace when its
              // parent normalizes children
              vnode = new VNode(tag, data, children, undefined, undefined, context);
          }
      }
      else {
          // direct component options / constructor
          vnode = createComponent(tag, data, context, children);
      }
      if (isArray(vnode)) {
          return vnode;
      }
      else if (isDef(vnode)) {
          if (isDef(ns))
              applyNS(vnode, ns);
          if (isDef(data))
              registerDeepBindings(data);
          return vnode;
      }
      else {
          return createEmptyVNode();
      }
  }
  function applyNS(vnode, ns, force) {
      vnode.ns = ns;
      if (vnode.tag === 'foreignObject') {
          // use default namespace inside foreignObject
          ns = undefined;
          force = true;
      }
      if (isDef(vnode.children)) {
          for (var i = 0, l = vnode.children.length; i < l; i++) {
              var child = vnode.children[i];
              if (isDef(child.tag) &&
                  (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
                  applyNS(child, ns, force);
              }
          }
      }
  }
  // ref #5318
  // necessary to ensure parent re-render when deep bindings like :style and
  // :class are used on slot nodes
  function registerDeepBindings(data) {
      if (isObject(data.style)) {
          traverse(data.style);
      }
      if (isObject(data.class)) {
          traverse(data.class);
      }
  }

  /**
   * Runtime helper for rendering v-for lists.
   */
  function renderList(val, render) {
      var ret = null, i, l, keys, key;
      if (isArray(val) || typeof val === 'string') {
          ret = new Array(val.length);
          for (i = 0, l = val.length; i < l; i++) {
              ret[i] = render(val[i], i);
          }
      }
      else if (typeof val === 'number') {
          ret = new Array(val);
          for (i = 0; i < val; i++) {
              ret[i] = render(i + 1, i);
          }
      }
      else if (isObject(val)) {
          if (hasSymbol && val[Symbol.iterator]) {
              ret = [];
              var iterator = val[Symbol.iterator]();
              var result = iterator.next();
              while (!result.done) {
                  ret.push(render(result.value, ret.length));
                  result = iterator.next();
              }
          }
          else {
              keys = Object.keys(val);
              ret = new Array(keys.length);
              for (i = 0, l = keys.length; i < l; i++) {
                  key = keys[i];
                  ret[i] = render(val[key], key, i);
              }
          }
      }
      if (!isDef(ret)) {
          ret = [];
      }
      ret._isVList = true;
      return ret;
  }

  /**
   * Runtime helper for rendering <slot>
   */
  function renderSlot(name, fallbackRender, props, bindObject) {
      var scopedSlotFn = this.$scopedSlots[name];
      var nodes;
      if (scopedSlotFn) {
          // scoped slot
          props = props || {};
          if (bindObject) {
              if (!isObject(bindObject)) {
                  warn$2('slot v-bind without argument expects an Object', this);
              }
              props = extend(extend({}, bindObject), props);
          }
          nodes =
              scopedSlotFn(props) ||
                  (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
      }
      else {
          nodes =
              this.$slots[name] ||
                  (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
      }
      var target = props && props.slot;
      if (target) {
          return this.$createElement('template', { slot: target }, nodes);
      }
      else {
          return nodes;
      }
  }

  /**
   * Runtime helper for resolving filters
   */
  function resolveFilter(id) {
      return resolveAsset(this.$options, 'filters', id, true) || identity;
  }

  function isKeyNotMatch(expect, actual) {
      if (isArray(expect)) {
          return expect.indexOf(actual) === -1;
      }
      else {
          return expect !== actual;
      }
  }
  /**
   * Runtime helper for checking keyCodes from config.
   * exposed as Vue.prototype._k
   * passing in eventKeyName as last argument separately for backwards compat
   */
  function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
      var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
      if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
          return isKeyNotMatch(builtInKeyName, eventKeyName);
      }
      else if (mappedKeyCode) {
          return isKeyNotMatch(mappedKeyCode, eventKeyCode);
      }
      else if (eventKeyName) {
          return hyphenate(eventKeyName) !== key;
      }
      return eventKeyCode === undefined;
  }

  /**
   * Runtime helper for merging v-bind="object" into a VNode's data.
   */
  function bindObjectProps(data, tag, value, asProp, isSync) {
      if (value) {
          if (!isObject(value)) {
              warn$2('v-bind without argument expects an Object or Array value', this);
          }
          else {
              if (isArray(value)) {
                  value = toObject(value);
              }
              var hash = void 0;
              var _loop_1 = function (key) {
                  if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                      hash = data;
                  }
                  else {
                      var type = data.attrs && data.attrs.type;
                      hash =
                          asProp || config.mustUseProp(tag, type, key)
                              ? data.domProps || (data.domProps = {})
                              : data.attrs || (data.attrs = {});
                  }
                  var camelizedKey = camelize(key);
                  var hyphenatedKey = hyphenate(key);
                  if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                      hash[key] = value[key];
                      if (isSync) {
                          var on = data.on || (data.on = {});
                          on["update:".concat(key)] = function ($event) {
                              value[key] = $event;
                          };
                      }
                  }
              };
              for (var key in value) {
                  _loop_1(key);
              }
          }
      }
      return data;
  }

  /**
   * Runtime helper for rendering static trees.
   */
  function renderStatic(index, isInFor) {
      var cached = this._staticTrees || (this._staticTrees = []);
      var tree = cached[index];
      // if has already-rendered static tree and not inside v-for,
      // we can reuse the same tree.
      if (tree && !isInFor) {
          return tree;
      }
      // otherwise, render a fresh tree.
      tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
      );
      markStatic$1(tree, "__static__".concat(index), false);
      return tree;
  }
  /**
   * Runtime helper for v-once.
   * Effectively it means marking the node as static with a unique key.
   */
  function markOnce(tree, index, key) {
      markStatic$1(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
      return tree;
  }
  function markStatic$1(tree, key, isOnce) {
      if (isArray(tree)) {
          for (var i = 0; i < tree.length; i++) {
              if (tree[i] && typeof tree[i] !== 'string') {
                  markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
              }
          }
      }
      else {
          markStaticNode(tree, key, isOnce);
      }
  }
  function markStaticNode(node, key, isOnce) {
      node.isStatic = true;
      node.key = key;
      node.isOnce = isOnce;
  }

  function bindObjectListeners(data, value) {
      if (value) {
          if (!isPlainObject(value)) {
              warn$2('v-on without argument expects an Object value', this);
          }
          else {
              var on = (data.on = data.on ? extend({}, data.on) : {});
              for (var key in value) {
                  var existing = on[key];
                  var ours = value[key];
                  on[key] = existing ? [].concat(existing, ours) : ours;
              }
          }
      }
      return data;
  }

  function resolveScopedSlots(fns, res, 
  // the following are added in 2.6
  hasDynamicKeys, contentHashKey) {
      res = res || { $stable: !hasDynamicKeys };
      for (var i = 0; i < fns.length; i++) {
          var slot = fns[i];
          if (isArray(slot)) {
              resolveScopedSlots(slot, res, hasDynamicKeys);
          }
          else if (slot) {
              // marker for reverse proxying v-slot without scope on this.$slots
              // @ts-expect-error
              if (slot.proxy) {
                  // @ts-expect-error
                  slot.fn.proxy = true;
              }
              res[slot.key] = slot.fn;
          }
      }
      if (contentHashKey) {
          res.$key = contentHashKey;
      }
      return res;
  }

  // helper to process dynamic keys for dynamic arguments in v-bind and v-on.
  function bindDynamicKeys(baseObj, values) {
      for (var i = 0; i < values.length; i += 2) {
          var key = values[i];
          if (typeof key === 'string' && key) {
              baseObj[values[i]] = values[i + 1];
          }
          else if (key !== '' && key !== null) {
              // null is a special value for explicitly removing a binding
              warn$2("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
          }
      }
      return baseObj;
  }
  // helper to dynamically append modifier runtime markers to event names.
  // ensure only append when value is already string, otherwise it will be cast
  // to string and cause the type check to miss.
  function prependModifier(value, symbol) {
      return typeof value === 'string' ? symbol + value : value;
  }

  function installRenderHelpers(target) {
      target._o = markOnce;
      target._n = toNumber;
      target._s = toString;
      target._l = renderList;
      target._t = renderSlot;
      target._q = looseEqual;
      target._i = looseIndexOf;
      target._m = renderStatic;
      target._f = resolveFilter;
      target._k = checkKeyCodes;
      target._b = bindObjectProps;
      target._v = createTextVNode;
      target._e = createEmptyVNode;
      target._u = resolveScopedSlots;
      target._g = bindObjectListeners;
      target._d = bindDynamicKeys;
      target._p = prependModifier;
  }

  /**
   * Runtime helper for resolving raw children VNodes into a slot object.
   */
  function resolveSlots(children, context) {
      if (!children || !children.length) {
          return {};
      }
      var slots = {};
      for (var i = 0, l = children.length; i < l; i++) {
          var child = children[i];
          var data = child.data;
          // remove slot attribute if the node is resolved as a Vue slot node
          if (data && data.attrs && data.attrs.slot) {
              delete data.attrs.slot;
          }
          // named slots should only be respected if the vnode was rendered in the
          // same context.
          if ((child.context === context || child.fnContext === context) &&
              data &&
              data.slot != null) {
              var name_1 = data.slot;
              var slot = slots[name_1] || (slots[name_1] = []);
              if (child.tag === 'template') {
                  slot.push.apply(slot, child.children || []);
              }
              else {
                  slot.push(child);
              }
          }
          else {
              (slots.default || (slots.default = [])).push(child);
          }
      }
      // ignore slots that contains only whitespace
      for (var name_2 in slots) {
          if (slots[name_2].every(isWhitespace)) {
              delete slots[name_2];
          }
      }
      return slots;
  }
  function isWhitespace(node) {
      return (node.isComment && !node.asyncFactory) || node.text === ' ';
  }

  function isAsyncPlaceholder(node) {
      // @ts-expect-error not really boolean type
      return node.isComment && node.asyncFactory;
  }

  function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
      var res;
      var hasNormalSlots = Object.keys(normalSlots).length > 0;
      var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
      var key = scopedSlots && scopedSlots.$key;
      if (!scopedSlots) {
          res = {};
      }
      else if (scopedSlots._normalized) {
          // fast path 1: child component re-render only, parent did not change
          return scopedSlots._normalized;
      }
      else if (isStable &&
          prevScopedSlots &&
          prevScopedSlots !== emptyObject &&
          key === prevScopedSlots.$key &&
          !hasNormalSlots &&
          !prevScopedSlots.$hasNormal) {
          // fast path 2: stable scoped slots w/ no normal slots to proxy,
          // only need to normalize once
          return prevScopedSlots;
      }
      else {
          res = {};
          for (var key_1 in scopedSlots) {
              if (scopedSlots[key_1] && key_1[0] !== '$') {
                  res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
              }
          }
      }
      // expose normal slots on scopedSlots
      for (var key_2 in normalSlots) {
          if (!(key_2 in res)) {
              res[key_2] = proxyNormalSlot(normalSlots, key_2);
          }
      }
      // avoriaz seems to mock a non-extensible $scopedSlots object
      // and when that is passed down this would cause an error
      if (scopedSlots && Object.isExtensible(scopedSlots)) {
          scopedSlots._normalized = res;
      }
      def(res, '$stable', isStable);
      def(res, '$key', key);
      def(res, '$hasNormal', hasNormalSlots);
      return res;
  }
  function normalizeScopedSlot(vm, normalSlots, key, fn) {
      var normalized = function () {
          var cur = currentInstance;
          setCurrentInstance(vm);
          var res = arguments.length ? fn.apply(null, arguments) : fn({});
          res =
              res && typeof res === 'object' && !isArray(res)
                  ? [res] // single vnode
                  : normalizeChildren(res);
          var vnode = res && res[0];
          setCurrentInstance(cur);
          return res &&
              (!vnode ||
                  (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
              ? undefined
              : res;
      };
      // this is a slot using the new v-slot syntax without scope. although it is
      // compiled as a scoped slot, render fn users would expect it to be present
      // on this.$slots because the usage is semantically a normal slot.
      if (fn.proxy) {
          Object.defineProperty(normalSlots, key, {
              get: normalized,
              enumerable: true,
              configurable: true
          });
      }
      return normalized;
  }
  function proxyNormalSlot(slots, key) {
      return function () { return slots[key]; };
  }

  function initSetup(vm) {
      var options = vm.$options;
      var setup = options.setup;
      if (setup) {
          var ctx = (vm._setupContext = createSetupContext(vm));
          setCurrentInstance(vm);
          pushTarget();
          var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
          popTarget();
          setCurrentInstance();
          if (isFunction(setupResult)) {
              // render function
              // @ts-ignore
              options.render = setupResult;
          }
          else if (isObject(setupResult)) {
              // bindings
              if (setupResult instanceof VNode) {
                  warn$2("setup() should not return VNodes directly - " +
                      "return a render function instead.");
              }
              vm._setupState = setupResult;
              // __sfc indicates compiled bindings from <script setup>
              if (!setupResult.__sfc) {
                  for (var key in setupResult) {
                      if (!isReserved(key)) {
                          proxyWithRefUnwrap(vm, setupResult, key);
                      }
                      else {
                          warn$2("Avoid using variables that start with _ or $ in setup().");
                      }
                  }
              }
              else {
                  // exposed for compiled render fn
                  var proxy = (vm._setupProxy = {});
                  for (var key in setupResult) {
                      if (key !== '__sfc') {
                          proxyWithRefUnwrap(proxy, setupResult, key);
                      }
                  }
              }
          }
          else if (setupResult !== undefined) {
              warn$2("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult));
          }
      }
  }
  function createSetupContext(vm) {
      var exposeCalled = false;
      return {
          get attrs() {
              if (!vm._attrsProxy) {
                  var proxy = (vm._attrsProxy = {});
                  def(proxy, '_v_attr_proxy', true);
                  syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
              }
              return vm._attrsProxy;
          },
          get listeners() {
              if (!vm._listenersProxy) {
                  var proxy = (vm._listenersProxy = {});
                  syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
              }
              return vm._listenersProxy;
          },
          get slots() {
              return initSlotsProxy(vm);
          },
          emit: bind$1(vm.$emit, vm),
          expose: function (exposed) {
              {
                  if (exposeCalled) {
                      warn$2("expose() should be called only once per setup().", vm);
                  }
                  exposeCalled = true;
              }
              if (exposed) {
                  Object.keys(exposed).forEach(function (key) {
                      return proxyWithRefUnwrap(vm, exposed, key);
                  });
              }
          }
      };
  }
  function syncSetupProxy(to, from, prev, instance, type) {
      var changed = false;
      for (var key in from) {
          if (!(key in to)) {
              changed = true;
              defineProxyAttr(to, key, instance, type);
          }
          else if (from[key] !== prev[key]) {
              changed = true;
          }
      }
      for (var key in to) {
          if (!(key in from)) {
              changed = true;
              delete to[key];
          }
      }
      return changed;
  }
  function defineProxyAttr(proxy, key, instance, type) {
      Object.defineProperty(proxy, key, {
          enumerable: true,
          configurable: true,
          get: function () {
              return instance[type][key];
          }
      });
  }
  function initSlotsProxy(vm) {
      if (!vm._slotsProxy) {
          syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
      }
      return vm._slotsProxy;
  }
  function syncSetupSlots(to, from) {
      for (var key in from) {
          to[key] = from[key];
      }
      for (var key in to) {
          if (!(key in from)) {
              delete to[key];
          }
      }
  }
  /**
   * @internal use manual type def because public setup context type relies on
   * legacy VNode types
   */
  function useSlots() {
      return getContext().slots;
  }
  /**
   * @internal use manual type def because public setup context type relies on
   * legacy VNode types
   */
  function useAttrs() {
      return getContext().attrs;
  }
  /**
   * Vue 2 only
   * @internal use manual type def because public setup context type relies on
   * legacy VNode types
   */
  function useListeners() {
      return getContext().listeners;
  }
  function getContext() {
      if (!currentInstance) {
          warn$2("useContext() called without active instance.");
      }
      var vm = currentInstance;
      return vm._setupContext || (vm._setupContext = createSetupContext(vm));
  }
  /**
   * Runtime helper for merging default declarations. Imported by compiled code
   * only.
   * @internal
   */
  function mergeDefaults(raw, defaults) {
      var props = isArray(raw)
          ? raw.reduce(function (normalized, p) { return ((normalized[p] = {}), normalized); }, {})
          : raw;
      for (var key in defaults) {
          var opt = props[key];
          if (opt) {
              if (isArray(opt) || isFunction(opt)) {
                  props[key] = { type: opt, default: defaults[key] };
              }
              else {
                  opt.default = defaults[key];
              }
          }
          else if (opt === null) {
              props[key] = { default: defaults[key] };
          }
          else {
              warn$2("props default key \"".concat(key, "\" has no corresponding declaration."));
          }
      }
      return props;
  }

  function initRender(vm) {
      vm._vnode = null; // the root of the child tree
      vm._staticTrees = null; // v-once cached trees
      var options = vm.$options;
      var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
      var renderContext = parentVnode && parentVnode.context;
      vm.$slots = resolveSlots(options._renderChildren, renderContext);
      vm.$scopedSlots = parentVnode
          ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
          : emptyObject;
      // bind the createElement fn to this instance
      // so that we get proper render context inside it.
      // args order: tag, data, children, normalizationType, alwaysNormalize
      // internal version is used by render functions compiled from templates
      // @ts-expect-error
      vm._c = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, false); };
      // normalization is always applied for the public version, used in
      // user-written render functions.
      // @ts-expect-error
      vm.$createElement = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, true); };
      // $attrs & $listeners are exposed for easier HOC creation.
      // they need to be reactive so that HOCs using them are always updated
      var parentData = parentVnode && parentVnode.data;
      /* istanbul ignore else */
      {
          defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, function () {
              !isUpdatingChildComponent && warn$2("$attrs is readonly.", vm);
          }, true);
          defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
              !isUpdatingChildComponent && warn$2("$listeners is readonly.", vm);
          }, true);
      }
  }
  var currentRenderingInstance = null;
  function renderMixin(Vue) {
      // install runtime convenience helpers
      installRenderHelpers(Vue.prototype);
      Vue.prototype.$nextTick = function (fn) {
          return nextTick(fn, this);
      };
      Vue.prototype._render = function () {
          var vm = this;
          var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
          if (_parentVnode && vm._isMounted) {
              vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
              if (vm._slotsProxy) {
                  syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
              }
          }
          // set parent vnode. this allows render functions to have access
          // to the data on the placeholder node.
          vm.$vnode = _parentVnode;
          // render self
          var prevInst = currentInstance;
          var prevRenderInst = currentRenderingInstance;
          var vnode;
          try {
              setCurrentInstance(vm);
              currentRenderingInstance = vm;
              vnode = render.call(vm._renderProxy, vm.$createElement);
          }
          catch (e) {
              handleError(e, vm, "render");
              // return error render result,
              // or previous vnode to prevent render error causing blank component
              /* istanbul ignore else */
              if (vm.$options.renderError) {
                  try {
                      vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                  }
                  catch (e) {
                      handleError(e, vm, "renderError");
                      vnode = vm._vnode;
                  }
              }
              else {
                  vnode = vm._vnode;
              }
          }
          finally {
              currentRenderingInstance = prevRenderInst;
              setCurrentInstance(prevInst);
          }
          // if the returned array contains only a single node, allow it
          if (isArray(vnode) && vnode.length === 1) {
              vnode = vnode[0];
          }
          // return empty vnode in case the render function errored out
          if (!(vnode instanceof VNode)) {
              if (isArray(vnode)) {
                  warn$2('Multiple root nodes returned from render function. Render function ' +
                      'should return a single root node.', vm);
              }
              vnode = createEmptyVNode();
          }
          // set parent
          vnode.parent = _parentVnode;
          return vnode;
      };
  }

  function ensureCtor(comp, base) {
      if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
          comp = comp.default;
      }
      return isObject(comp) ? base.extend(comp) : comp;
  }
  function createAsyncPlaceholder(factory, data, context, children, tag) {
      var node = createEmptyVNode();
      node.asyncFactory = factory;
      node.asyncMeta = { data: data, context: context, children: children, tag: tag };
      return node;
  }
  function resolveAsyncComponent(factory, baseCtor) {
      if (isTrue(factory.error) && isDef(factory.errorComp)) {
          return factory.errorComp;
      }
      if (isDef(factory.resolved)) {
          return factory.resolved;
      }
      var owner = currentRenderingInstance;
      if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
          // already pending
          factory.owners.push(owner);
      }
      if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
          return factory.loadingComp;
      }
      if (owner && !isDef(factory.owners)) {
          var owners_1 = (factory.owners = [owner]);
          var sync_1 = true;
          var timerLoading_1 = null;
          var timerTimeout_1 = null;
          owner.$on('hook:destroyed', function () { return remove$2(owners_1, owner); });
          var forceRender_1 = function (renderCompleted) {
              for (var i = 0, l = owners_1.length; i < l; i++) {
                  owners_1[i].$forceUpdate();
              }
              if (renderCompleted) {
                  owners_1.length = 0;
                  if (timerLoading_1 !== null) {
                      clearTimeout(timerLoading_1);
                      timerLoading_1 = null;
                  }
                  if (timerTimeout_1 !== null) {
                      clearTimeout(timerTimeout_1);
                      timerTimeout_1 = null;
                  }
              }
          };
          var resolve = once(function (res) {
              // cache resolved
              factory.resolved = ensureCtor(res, baseCtor);
              // invoke callbacks only if this is not a synchronous resolve
              // (async resolves are shimmed as synchronous during SSR)
              if (!sync_1) {
                  forceRender_1(true);
              }
              else {
                  owners_1.length = 0;
              }
          });
          var reject_1 = once(function (reason) {
              warn$2("Failed to resolve async component: ".concat(String(factory)) +
                      (reason ? "\nReason: ".concat(reason) : ''));
              if (isDef(factory.errorComp)) {
                  factory.error = true;
                  forceRender_1(true);
              }
          });
          var res_1 = factory(resolve, reject_1);
          if (isObject(res_1)) {
              if (isPromise(res_1)) {
                  // () => Promise
                  if (isUndef(factory.resolved)) {
                      res_1.then(resolve, reject_1);
                  }
              }
              else if (isPromise(res_1.component)) {
                  res_1.component.then(resolve, reject_1);
                  if (isDef(res_1.error)) {
                      factory.errorComp = ensureCtor(res_1.error, baseCtor);
                  }
                  if (isDef(res_1.loading)) {
                      factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                      if (res_1.delay === 0) {
                          factory.loading = true;
                      }
                      else {
                          // @ts-expect-error NodeJS timeout type
                          timerLoading_1 = setTimeout(function () {
                              timerLoading_1 = null;
                              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                  factory.loading = true;
                                  forceRender_1(false);
                              }
                          }, res_1.delay || 200);
                      }
                  }
                  if (isDef(res_1.timeout)) {
                      // @ts-expect-error NodeJS timeout type
                      timerTimeout_1 = setTimeout(function () {
                          timerTimeout_1 = null;
                          if (isUndef(factory.resolved)) {
                              reject_1("timeout (".concat(res_1.timeout, "ms)") );
                          }
                      }, res_1.timeout);
                  }
              }
          }
          sync_1 = false;
          // return in case resolved synchronously
          return factory.loading ? factory.loadingComp : factory.resolved;
      }
  }

  function getFirstComponentChild(children) {
      if (isArray(children)) {
          for (var i = 0; i < children.length; i++) {
              var c = children[i];
              if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                  return c;
              }
          }
      }
  }

  function initEvents(vm) {
      vm._events = Object.create(null);
      vm._hasHookEvent = false;
      // init parent attached events
      var listeners = vm.$options._parentListeners;
      if (listeners) {
          updateComponentListeners(vm, listeners);
      }
  }
  var target$1;
  function add$1(event, fn) {
      target$1.$on(event, fn);
  }
  function remove$1(event, fn) {
      target$1.$off(event, fn);
  }
  function createOnceHandler$1(event, fn) {
      var _target = target$1;
      return function onceHandler() {
          var res = fn.apply(null, arguments);
          if (res !== null) {
              _target.$off(event, onceHandler);
          }
      };
  }
  function updateComponentListeners(vm, listeners, oldListeners) {
      target$1 = vm;
      updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
      target$1 = undefined;
  }
  function eventsMixin(Vue) {
      var hookRE = /^hook:/;
      Vue.prototype.$on = function (event, fn) {
          var vm = this;
          if (isArray(event)) {
              for (var i = 0, l = event.length; i < l; i++) {
                  vm.$on(event[i], fn);
              }
          }
          else {
              (vm._events[event] || (vm._events[event] = [])).push(fn);
              // optimize hook:event cost by using a boolean flag marked at registration
              // instead of a hash lookup
              if (hookRE.test(event)) {
                  vm._hasHookEvent = true;
              }
          }
          return vm;
      };
      Vue.prototype.$once = function (event, fn) {
          var vm = this;
          function on() {
              vm.$off(event, on);
              fn.apply(vm, arguments);
          }
          on.fn = fn;
          vm.$on(event, on);
          return vm;
      };
      Vue.prototype.$off = function (event, fn) {
          var vm = this;
          // all
          if (!arguments.length) {
              vm._events = Object.create(null);
              return vm;
          }
          // array of events
          if (isArray(event)) {
              for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                  vm.$off(event[i_1], fn);
              }
              return vm;
          }
          // specific event
          var cbs = vm._events[event];
          if (!cbs) {
              return vm;
          }
          if (!fn) {
              vm._events[event] = null;
              return vm;
          }
          // specific handler
          var cb;
          var i = cbs.length;
          while (i--) {
              cb = cbs[i];
              if (cb === fn || cb.fn === fn) {
                  cbs.splice(i, 1);
                  break;
              }
          }
          return vm;
      };
      Vue.prototype.$emit = function (event) {
          var vm = this;
          {
              var lowerCaseEvent = event.toLowerCase();
              if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                  tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") +
                      "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") +
                      "Note that HTML attributes are case-insensitive and you cannot use " +
                      "v-on to listen to camelCase events when using in-DOM templates. " +
                      "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
              }
          }
          var cbs = vm._events[event];
          if (cbs) {
              cbs = cbs.length > 1 ? toArray(cbs) : cbs;
              var args = toArray(arguments, 1);
              var info = "event handler for \"".concat(event, "\"");
              for (var i = 0, l = cbs.length; i < l; i++) {
                  invokeWithErrorHandling(cbs[i], vm, args, vm, info);
              }
          }
          return vm;
      };
  }

  var activeEffectScope;
  var EffectScope = /** @class */ (function () {
      function EffectScope(detached) {
          if (detached === void 0) { detached = false; }
          this.detached = detached;
          /**
           * @internal
           */
          this.active = true;
          /**
           * @internal
           */
          this.effects = [];
          /**
           * @internal
           */
          this.cleanups = [];
          this.parent = activeEffectScope;
          if (!detached && activeEffectScope) {
              this.index =
                  (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
          }
      }
      EffectScope.prototype.run = function (fn) {
          if (this.active) {
              var currentEffectScope = activeEffectScope;
              try {
                  activeEffectScope = this;
                  return fn();
              }
              finally {
                  activeEffectScope = currentEffectScope;
              }
          }
          else {
              warn$2("cannot run an inactive effect scope.");
          }
      };
      /**
       * This should only be called on non-detached scopes
       * @internal
       */
      EffectScope.prototype.on = function () {
          activeEffectScope = this;
      };
      /**
       * This should only be called on non-detached scopes
       * @internal
       */
      EffectScope.prototype.off = function () {
          activeEffectScope = this.parent;
      };
      EffectScope.prototype.stop = function (fromParent) {
          if (this.active) {
              var i = void 0, l = void 0;
              for (i = 0, l = this.effects.length; i < l; i++) {
                  this.effects[i].teardown();
              }
              for (i = 0, l = this.cleanups.length; i < l; i++) {
                  this.cleanups[i]();
              }
              if (this.scopes) {
                  for (i = 0, l = this.scopes.length; i < l; i++) {
                      this.scopes[i].stop(true);
                  }
              }
              // nested scope, dereference from parent to avoid memory leaks
              if (!this.detached && this.parent && !fromParent) {
                  // optimized O(1) removal
                  var last = this.parent.scopes.pop();
                  if (last && last !== this) {
                      this.parent.scopes[this.index] = last;
                      last.index = this.index;
                  }
              }
              this.parent = undefined;
              this.active = false;
          }
      };
      return EffectScope;
  }());
  function effectScope(detached) {
      return new EffectScope(detached);
  }
  /**
   * @internal
   */
  function recordEffectScope(effect, scope) {
      if (scope === void 0) { scope = activeEffectScope; }
      if (scope && scope.active) {
          scope.effects.push(effect);
      }
  }
  function getCurrentScope() {
      return activeEffectScope;
  }
  function onScopeDispose(fn) {
      if (activeEffectScope) {
          activeEffectScope.cleanups.push(fn);
      }
      else {
          warn$2("onScopeDispose() is called when there is no active effect scope" +
              " to be associated with.");
      }
  }

  var activeInstance = null;
  var isUpdatingChildComponent = false;
  function setActiveInstance(vm) {
      var prevActiveInstance = activeInstance;
      activeInstance = vm;
      return function () {
          activeInstance = prevActiveInstance;
      };
  }
  function initLifecycle(vm) {
      var options = vm.$options;
      // locate first non-abstract parent
      var parent = options.parent;
      if (parent && !options.abstract) {
          while (parent.$options.abstract && parent.$parent) {
              parent = parent.$parent;
          }
          parent.$children.push(vm);
      }
      vm.$parent = parent;
      vm.$root = parent ? parent.$root : vm;
      vm.$children = [];
      vm.$refs = {};
      vm._provided = parent ? parent._provided : Object.create(null);
      vm._watcher = null;
      vm._inactive = null;
      vm._directInactive = false;
      vm._isMounted = false;
      vm._isDestroyed = false;
      vm._isBeingDestroyed = false;
  }
  function lifecycleMixin(Vue) {
      Vue.prototype._update = function (vnode, hydrating) {
          var vm = this;
          var prevEl = vm.$el;
          var prevVnode = vm._vnode;
          var restoreActiveInstance = setActiveInstance(vm);
          vm._vnode = vnode;
          // Vue.prototype.__patch__ is injected in entry points
          // based on the rendering backend used.
          if (!prevVnode) {
              // initial render
              vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
          }
          else {
              // updates
              vm.$el = vm.__patch__(prevVnode, vnode);
          }
          restoreActiveInstance();
          // update __vue__ reference
          if (prevEl) {
              prevEl.__vue__ = null;
          }
          if (vm.$el) {
              vm.$el.__vue__ = vm;
          }
          // if parent is an HOC, update its $el as well
          var wrapper = vm;
          while (wrapper &&
              wrapper.$vnode &&
              wrapper.$parent &&
              wrapper.$vnode === wrapper.$parent._vnode) {
              wrapper.$parent.$el = wrapper.$el;
              wrapper = wrapper.$parent;
          }
          // updated hook is called by the scheduler to ensure that children are
          // updated in a parent's updated hook.
      };
      Vue.prototype.$forceUpdate = function () {
          var vm = this;
          if (vm._watcher) {
              vm._watcher.update();
          }
      };
      Vue.prototype.$destroy = function () {
          var vm = this;
          if (vm._isBeingDestroyed) {
              return;
          }
          callHook$1(vm, 'beforeDestroy');
          vm._isBeingDestroyed = true;
          // remove self from parent
          var parent = vm.$parent;
          if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
              remove$2(parent.$children, vm);
          }
          // teardown scope. this includes both the render watcher and other
          // watchers created
          vm._scope.stop();
          // remove reference from data ob
          // frozen object may not have observer.
          if (vm._data.__ob__) {
              vm._data.__ob__.vmCount--;
          }
          // call the last hook...
          vm._isDestroyed = true;
          // invoke destroy hooks on current rendered tree
          vm.__patch__(vm._vnode, null);
          // fire destroyed hook
          callHook$1(vm, 'destroyed');
          // turn off all instance listeners.
          vm.$off();
          // remove __vue__ reference
          if (vm.$el) {
              vm.$el.__vue__ = null;
          }
          // release circular reference (#6759)
          if (vm.$vnode) {
              vm.$vnode.parent = null;
          }
      };
  }
  function mountComponent(vm, el, hydrating) {
      vm.$el = el;
      if (!vm.$options.render) {
          // @ts-expect-error invalid type
          vm.$options.render = createEmptyVNode;
          {
              /* istanbul ignore if */
              if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
                  vm.$options.el ||
                  el) {
                  warn$2('You are using the runtime-only build of Vue where the template ' +
                      'compiler is not available. Either pre-compile the templates into ' +
                      'render functions, or use the compiler-included build.', vm);
              }
              else {
                  warn$2('Failed to mount component: template or render function not defined.', vm);
              }
          }
      }
      callHook$1(vm, 'beforeMount');
      var updateComponent;
      /* istanbul ignore if */
      if (config.performance && mark) {
          updateComponent = function () {
              var name = vm._name;
              var id = vm._uid;
              var startTag = "vue-perf-start:".concat(id);
              var endTag = "vue-perf-end:".concat(id);
              mark(startTag);
              var vnode = vm._render();
              mark(endTag);
              measure("vue ".concat(name, " render"), startTag, endTag);
              mark(startTag);
              vm._update(vnode, hydrating);
              mark(endTag);
              measure("vue ".concat(name, " patch"), startTag, endTag);
          };
      }
      else {
          updateComponent = function () {
              vm._update(vm._render(), hydrating);
          };
      }
      var watcherOptions = {
          before: function () {
              if (vm._isMounted && !vm._isDestroyed) {
                  callHook$1(vm, 'beforeUpdate');
              }
          }
      };
      {
          watcherOptions.onTrack = function (e) { return callHook$1(vm, 'renderTracked', [e]); };
          watcherOptions.onTrigger = function (e) { return callHook$1(vm, 'renderTriggered', [e]); };
      }
      // we set this to vm._watcher inside the watcher's constructor
      // since the watcher's initial patch may call $forceUpdate (e.g. inside child
      // component's mounted hook), which relies on vm._watcher being already defined
      new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
      hydrating = false;
      // flush buffer for flush: "pre" watchers queued in setup()
      var preWatchers = vm._preWatchers;
      if (preWatchers) {
          for (var i = 0; i < preWatchers.length; i++) {
              preWatchers[i].run();
          }
      }
      // manually mounted instance, call mounted on self
      // mounted is called for render-created child components in its inserted hook
      if (vm.$vnode == null) {
          vm._isMounted = true;
          callHook$1(vm, 'mounted');
      }
      return vm;
  }
  function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
      {
          isUpdatingChildComponent = true;
      }
      // determine whether component has slot children
      // we need to do this before overwriting $options._renderChildren.
      // check if there are dynamic scopedSlots (hand-written or compiled but with
      // dynamic slot names). Static scoped slots compiled from template has the
      // "$stable" marker.
      var newScopedSlots = parentVnode.data.scopedSlots;
      var oldScopedSlots = vm.$scopedSlots;
      var hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
          (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
          (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
          (!newScopedSlots && vm.$scopedSlots.$key));
      // Any static slot children from the parent may have changed during parent's
      // update. Dynamic scoped slots may also have changed. In such cases, a forced
      // update is necessary to ensure correctness.
      var needsForceUpdate = !!(renderChildren || // has new static slots
          vm.$options._renderChildren || // has old static slots
          hasDynamicScopedSlot);
      var prevVNode = vm.$vnode;
      vm.$options._parentVnode = parentVnode;
      vm.$vnode = parentVnode; // update vm's placeholder node without re-render
      if (vm._vnode) {
          // update child tree's parent
          vm._vnode.parent = parentVnode;
      }
      vm.$options._renderChildren = renderChildren;
      // update $attrs and $listeners hash
      // these are also reactive so they may trigger child update if the child
      // used them during render
      var attrs = parentVnode.data.attrs || emptyObject;
      if (vm._attrsProxy) {
          // force update if attrs are accessed and has changed since it may be
          // passed to a child component.
          if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
              needsForceUpdate = true;
          }
      }
      vm.$attrs = attrs;
      // update listeners
      listeners = listeners || emptyObject;
      var prevListeners = vm.$options._parentListeners;
      if (vm._listenersProxy) {
          syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
      }
      vm.$listeners = vm.$options._parentListeners = listeners;
      updateComponentListeners(vm, listeners, prevListeners);
      // update props
      if (propsData && vm.$options.props) {
          toggleObserving(false);
          var props = vm._props;
          var propKeys = vm.$options._propKeys || [];
          for (var i = 0; i < propKeys.length; i++) {
              var key = propKeys[i];
              var propOptions = vm.$options.props; // wtf flow?
              props[key] = validateProp(key, propOptions, propsData, vm);
          }
          toggleObserving(true);
          // keep a copy of raw propsData
          vm.$options.propsData = propsData;
      }
      // resolve slots + force update if has children
      if (needsForceUpdate) {
          vm.$slots = resolveSlots(renderChildren, parentVnode.context);
          vm.$forceUpdate();
      }
      {
          isUpdatingChildComponent = false;
      }
  }
  function isInInactiveTree(vm) {
      while (vm && (vm = vm.$parent)) {
          if (vm._inactive)
              return true;
      }
      return false;
  }
  function activateChildComponent(vm, direct) {
      if (direct) {
          vm._directInactive = false;
          if (isInInactiveTree(vm)) {
              return;
          }
      }
      else if (vm._directInactive) {
          return;
      }
      if (vm._inactive || vm._inactive === null) {
          vm._inactive = false;
          for (var i = 0; i < vm.$children.length; i++) {
              activateChildComponent(vm.$children[i]);
          }
          callHook$1(vm, 'activated');
      }
  }
  function deactivateChildComponent(vm, direct) {
      if (direct) {
          vm._directInactive = true;
          if (isInInactiveTree(vm)) {
              return;
          }
      }
      if (!vm._inactive) {
          vm._inactive = true;
          for (var i = 0; i < vm.$children.length; i++) {
              deactivateChildComponent(vm.$children[i]);
          }
          callHook$1(vm, 'deactivated');
      }
  }
  function callHook$1(vm, hook, args, setContext) {
      if (setContext === void 0) { setContext = true; }
      // #7573 disable dep collection when invoking lifecycle hooks
      pushTarget();
      var prevInst = currentInstance;
      var prevScope = getCurrentScope();
      setContext && setCurrentInstance(vm);
      var handlers = vm.$options[hook];
      var info = "".concat(hook, " hook");
      if (handlers) {
          for (var i = 0, j = handlers.length; i < j; i++) {
              invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
          }
      }
      if (vm._hasHookEvent) {
          vm.$emit('hook:' + hook);
      }
      if (setContext) {
          setCurrentInstance(prevInst);
          prevScope && prevScope.on();
      }
      popTarget();
  }

  var MAX_UPDATE_COUNT = 100;
  var queue = [];
  var activatedChildren = [];
  var has = {};
  var circular = {};
  var waiting = false;
  var flushing = false;
  var index$1 = 0;
  /**
   * Reset the scheduler's state.
   */
  function resetSchedulerState() {
      index$1 = queue.length = activatedChildren.length = 0;
      has = {};
      {
          circular = {};
      }
      waiting = flushing = false;
  }
  // Async edge case #6566 requires saving the timestamp when event listeners are
  // attached. However, calling performance.now() has a perf overhead especially
  // if the page has thousands of event listeners. Instead, we take a timestamp
  // every time the scheduler flushes and use that for all event listeners
  // attached during that flush.
  var currentFlushTimestamp = 0;
  // Async edge case fix requires storing an event listener's attach timestamp.
  var getNow = Date.now;
  // Determine what event timestamp the browser is using. Annoyingly, the
  // timestamp can either be hi-res (relative to page load) or low-res
  // (relative to UNIX epoch), so in order to compare time we have to use the
  // same timestamp type when saving the flush timestamp.
  // All IE versions use low-res event timestamps, and have problematic clock
  // implementations (#9632)
  if (inBrowser && !isIE) {
      var performance_1 = window.performance;
      if (performance_1 &&
          typeof performance_1.now === 'function' &&
          getNow() > document.createEvent('Event').timeStamp) {
          // if the event timestamp, although evaluated AFTER the Date.now(), is
          // smaller than it, it means the event is using a hi-res timestamp,
          // and we need to use the hi-res version for event listener timestamps as
          // well.
          getNow = function () { return performance_1.now(); };
      }
  }
  var sortCompareFn = function (a, b) {
      if (a.post) {
          if (!b.post)
              return 1;
      }
      else if (b.post) {
          return -1;
      }
      return a.id - b.id;
  };
  /**
   * Flush both queues and run the watchers.
   */
  function flushSchedulerQueue() {
      currentFlushTimestamp = getNow();
      flushing = true;
      var watcher, id;
      // Sort queue before flush.
      // This ensures that:
      // 1. Components are updated from parent to child. (because parent is always
      //    created before the child)
      // 2. A component's user watchers are run before its render watcher (because
      //    user watchers are created before the render watcher)
      // 3. If a component is destroyed during a parent component's watcher run,
      //    its watchers can be skipped.
      queue.sort(sortCompareFn);
      // do not cache length because more watchers might be pushed
      // as we run existing watchers
      for (index$1 = 0; index$1 < queue.length; index$1++) {
          watcher = queue[index$1];
          if (watcher.before) {
              watcher.before();
          }
          id = watcher.id;
          has[id] = null;
          watcher.run();
          // in dev build, check and stop circular updates.
          if (has[id] != null) {
              circular[id] = (circular[id] || 0) + 1;
              if (circular[id] > MAX_UPDATE_COUNT) {
                  warn$2('You may have an infinite update loop ' +
                      (watcher.user
                          ? "in watcher with expression \"".concat(watcher.expression, "\"")
                          : "in a component render function."), watcher.vm);
                  break;
              }
          }
      }
      // keep copies of post queues before resetting state
      var activatedQueue = activatedChildren.slice();
      var updatedQueue = queue.slice();
      resetSchedulerState();
      // call component updated and activated hooks
      callActivatedHooks(activatedQueue);
      callUpdatedHooks(updatedQueue);
      cleanupDeps();
      // devtool hook
      /* istanbul ignore if */
      if (devtools && config.devtools) {
          devtools.emit('flush');
      }
  }
  function callUpdatedHooks(queue) {
      var i = queue.length;
      while (i--) {
          var watcher = queue[i];
          var vm = watcher.vm;
          if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
              callHook$1(vm, 'updated');
          }
      }
  }
  /**
   * Queue a kept-alive component that was activated during patch.
   * The queue will be processed after the entire tree has been patched.
   */
  function queueActivatedComponent(vm) {
      // setting _inactive to false here so that a render function can
      // rely on checking whether it's in an inactive tree (e.g. router-view)
      vm._inactive = false;
      activatedChildren.push(vm);
  }
  function callActivatedHooks(queue) {
      for (var i = 0; i < queue.length; i++) {
          queue[i]._inactive = true;
          activateChildComponent(queue[i], true /* true */);
      }
  }
  /**
   * Push a watcher into the watcher queue.
   * Jobs with duplicate IDs will be skipped unless it's
   * pushed when the queue is being flushed.
   */
  function queueWatcher(watcher) {
      var id = watcher.id;
      if (has[id] != null) {
          return;
      }
      if (watcher === Dep.target && watcher.noRecurse) {
          return;
      }
      has[id] = true;
      if (!flushing) {
          queue.push(watcher);
      }
      else {
          // if already flushing, splice the watcher based on its id
          // if already past its id, it will be run next immediately.
          var i = queue.length - 1;
          while (i > index$1 && queue[i].id > watcher.id) {
              i--;
          }
          queue.splice(i + 1, 0, watcher);
      }
      // queue the flush
      if (!waiting) {
          waiting = true;
          if (!config.async) {
              flushSchedulerQueue();
              return;
          }
          nextTick(flushSchedulerQueue);
      }
  }

  var WATCHER = "watcher";
  var WATCHER_CB = "".concat(WATCHER, " callback");
  var WATCHER_GETTER = "".concat(WATCHER, " getter");
  var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
  // Simple effect.
  function watchEffect(effect, options) {
      return doWatch(effect, null, options);
  }
  function watchPostEffect(effect, options) {
      return doWatch(effect, null, (__assign(__assign({}, options), { flush: 'post' }) ));
  }
  function watchSyncEffect(effect, options) {
      return doWatch(effect, null, (__assign(__assign({}, options), { flush: 'sync' }) ));
  }
  // initial value for watchers to trigger on undefined initial values
  var INITIAL_WATCHER_VALUE = {};
  // implementation
  function watch(source, cb, options) {
      if (typeof cb !== 'function') {
          warn$2("`watch(fn, options?)` signature has been moved to a separate API. " +
              "Use `watchEffect(fn, options?)` instead. `watch` now only " +
              "supports `watch(source, cb, options?) signature.");
      }
      return doWatch(source, cb, options);
  }
  function doWatch(source, cb, _a) {
      var _b = _a === void 0 ? emptyObject : _a, immediate = _b.immediate, deep = _b.deep, _c = _b.flush, flush = _c === void 0 ? 'pre' : _c, onTrack = _b.onTrack, onTrigger = _b.onTrigger;
      if (!cb) {
          if (immediate !== undefined) {
              warn$2("watch() \"immediate\" option is only respected when using the " +
                  "watch(source, callback, options?) signature.");
          }
          if (deep !== undefined) {
              warn$2("watch() \"deep\" option is only respected when using the " +
                  "watch(source, callback, options?) signature.");
          }
      }
      var warnInvalidSource = function (s) {
          warn$2("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") +
              "function, a ref, a reactive object, or an array of these types.");
      };
      var instance = currentInstance;
      var call = function (fn, type, args) {
          if (args === void 0) { args = null; }
          var res = invokeWithErrorHandling(fn, null, args, instance, type);
          if (deep && res && res.__ob__)
              res.__ob__.dep.depend();
          return res;
      };
      var getter;
      var forceTrigger = false;
      var isMultiSource = false;
      if (isRef(source)) {
          getter = function () { return source.value; };
          forceTrigger = isShallow(source);
      }
      else if (isReactive(source)) {
          getter = function () {
              source.__ob__.dep.depend();
              return source;
          };
          deep = true;
      }
      else if (isArray(source)) {
          isMultiSource = true;
          forceTrigger = source.some(function (s) { return isReactive(s) || isShallow(s); });
          getter = function () {
              return source.map(function (s) {
                  if (isRef(s)) {
                      return s.value;
                  }
                  else if (isReactive(s)) {
                      s.__ob__.dep.depend();
                      return traverse(s);
                  }
                  else if (isFunction(s)) {
                      return call(s, WATCHER_GETTER);
                  }
                  else {
                      warnInvalidSource(s);
                  }
              });
          };
      }
      else if (isFunction(source)) {
          if (cb) {
              // getter with cb
              getter = function () { return call(source, WATCHER_GETTER); };
          }
          else {
              // no cb -> simple effect
              getter = function () {
                  if (instance && instance._isDestroyed) {
                      return;
                  }
                  if (cleanup) {
                      cleanup();
                  }
                  return call(source, WATCHER, [onCleanup]);
              };
          }
      }
      else {
          getter = noop;
          warnInvalidSource(source);
      }
      if (cb && deep) {
          var baseGetter_1 = getter;
          getter = function () { return traverse(baseGetter_1()); };
      }
      var cleanup;
      var onCleanup = function (fn) {
          cleanup = watcher.onStop = function () {
              call(fn, WATCHER_CLEANUP);
          };
      };
      // in SSR there is no need to setup an actual effect, and it should be noop
      // unless it's eager
      if (isServerRendering()) {
          // we will also not call the invalidate callback (+ runner is not set up)
          onCleanup = noop;
          if (!cb) {
              getter();
          }
          else if (immediate) {
              call(cb, WATCHER_CB, [
                  getter(),
                  isMultiSource ? [] : undefined,
                  onCleanup
              ]);
          }
          return noop;
      }
      var watcher = new Watcher(currentInstance, getter, noop, {
          lazy: true
      });
      watcher.noRecurse = !cb;
      var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
      // overwrite default run
      watcher.run = function () {
          if (!watcher.active) {
              return;
          }
          if (cb) {
              // watch(source, cb)
              var newValue = watcher.get();
              if (deep ||
                  forceTrigger ||
                  (isMultiSource
                      ? newValue.some(function (v, i) {
                          return hasChanged(v, oldValue[i]);
                      })
                      : hasChanged(newValue, oldValue))) {
                  // cleanup before running cb again
                  if (cleanup) {
                      cleanup();
                  }
                  call(cb, WATCHER_CB, [
                      newValue,
                      // pass undefined as the old value when it's changed for the first time
                      oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                      onCleanup
                  ]);
                  oldValue = newValue;
              }
          }
          else {
              // watchEffect
              watcher.get();
          }
      };
      if (flush === 'sync') {
          watcher.update = watcher.run;
      }
      else if (flush === 'post') {
          watcher.post = true;
          watcher.update = function () { return queueWatcher(watcher); };
      }
      else {
          // pre
          watcher.update = function () {
              if (instance && instance === currentInstance && !instance._isMounted) {
                  // pre-watcher triggered before
                  var buffer = instance._preWatchers || (instance._preWatchers = []);
                  if (buffer.indexOf(watcher) < 0)
                      buffer.push(watcher);
              }
              else {
                  queueWatcher(watcher);
              }
          };
      }
      {
          watcher.onTrack = onTrack;
          watcher.onTrigger = onTrigger;
      }
      // initial run
      if (cb) {
          if (immediate) {
              watcher.run();
          }
          else {
              oldValue = watcher.get();
          }
      }
      else if (flush === 'post' && instance) {
          instance.$once('hook:mounted', function () { return watcher.get(); });
      }
      else {
          watcher.get();
      }
      return function () {
          watcher.teardown();
      };
  }

  function provide(key, value) {
      if (!currentInstance) {
          {
              warn$2("provide() can only be used inside setup().");
          }
      }
      else {
          // TS doesn't allow symbol as index type
          resolveProvided(currentInstance)[key] = value;
      }
  }
  function resolveProvided(vm) {
      // by default an instance inherits its parent's provides object
      // but when it needs to provide values of its own, it creates its
      // own provides object using parent provides object as prototype.
      // this way in `inject` we can simply look up injections from direct
      // parent and let the prototype chain do the work.
      var existing = vm._provided;
      var parentProvides = vm.$parent && vm.$parent._provided;
      if (parentProvides === existing) {
          return (vm._provided = Object.create(parentProvides));
      }
      else {
          return existing;
      }
  }
  function inject(key, defaultValue, treatDefaultAsFactory) {
      if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
      // fallback to `currentRenderingInstance` so that this can be called in
      // a functional component
      var instance = currentInstance;
      if (instance) {
          // #2400
          // to support `app.use` plugins,
          // fallback to appContext's `provides` if the instance is at root
          var provides = instance.$parent && instance.$parent._provided;
          if (provides && key in provides) {
              // TS doesn't allow symbol as index type
              return provides[key];
          }
          else if (arguments.length > 1) {
              return treatDefaultAsFactory && isFunction(defaultValue)
                  ? defaultValue.call(instance)
                  : defaultValue;
          }
          else {
              warn$2("injection \"".concat(String(key), "\" not found."));
          }
      }
      else {
          warn$2("inject() can only be used inside setup() or functional components.");
      }
  }

  /**
   * @internal this function needs manual public type declaration because it relies
   * on previously manually authored types from Vue 2
   */
  function h(type, props, children) {
      if (!currentInstance) {
          warn$2("globally imported h() can only be invoked when there is an active " +
                  "component instance, e.g. synchronously in a component's render or setup function.");
      }
      return createElement$1(currentInstance, type, props, children, 2, true);
  }

  function handleError(err, vm, info) {
      // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
      // See: https://github.com/vuejs/vuex/issues/1505
      pushTarget();
      try {
          if (vm) {
              var cur = vm;
              while ((cur = cur.$parent)) {
                  var hooks = cur.$options.errorCaptured;
                  if (hooks) {
                      for (var i = 0; i < hooks.length; i++) {
                          try {
                              var capture = hooks[i].call(cur, err, vm, info) === false;
                              if (capture)
                                  return;
                          }
                          catch (e) {
                              globalHandleError(e, cur, 'errorCaptured hook');
                          }
                      }
                  }
              }
          }
          globalHandleError(err, vm, info);
      }
      finally {
          popTarget();
      }
  }
  function invokeWithErrorHandling(handler, context, args, vm, info) {
      var res;
      try {
          res = args ? handler.apply(context, args) : handler.call(context);
          if (res && !res._isVue && isPromise(res) && !res._handled) {
              res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
              res._handled = true;
          }
      }
      catch (e) {
          handleError(e, vm, info);
      }
      return res;
  }
  function globalHandleError(err, vm, info) {
      if (config.errorHandler) {
          try {
              return config.errorHandler.call(null, err, vm, info);
          }
          catch (e) {
              // if the user intentionally throws the original error in the handler,
              // do not log it twice
              if (e !== err) {
                  logError(e, null, 'config.errorHandler');
              }
          }
      }
      logError(err, vm, info);
  }
  function logError(err, vm, info) {
      {
          warn$2("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
      }
      /* istanbul ignore else */
      if (inBrowser && typeof console !== 'undefined') {
          console.error(err);
      }
      else {
          throw err;
      }
  }

  /* globals MutationObserver */
  var isUsingMicroTask = false;
  var callbacks = [];
  var pending = false;
  function flushCallbacks() {
      pending = false;
      var copies = callbacks.slice(0);
      callbacks.length = 0;
      for (var i = 0; i < copies.length; i++) {
          copies[i]();
      }
  }
  // Here we have async deferring wrappers using microtasks.
  // In 2.5 we used (macro) tasks (in combination with microtasks).
  // However, it has subtle problems when state is changed right before repaint
  // (e.g. #6813, out-in transitions).
  // Also, using (macro) tasks in event handler would cause some weird behaviors
  // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
  // So we now use microtasks everywhere, again.
  // A major drawback of this tradeoff is that there are some scenarios
  // where microtasks have too high a priority and fire in between supposedly
  // sequential events (e.g. #4521, #6690, which have workarounds)
  // or even between bubbling of the same event (#6566).
  var timerFunc;
  // The nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore next, $flow-disable-line */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
      var p_1 = Promise.resolve();
      timerFunc = function () {
          p_1.then(flushCallbacks);
          // In problematic UIWebViews, Promise.then doesn't completely break, but
          // it can get stuck in a weird state where callbacks are pushed into the
          // microtask queue but the queue isn't being flushed, until the browser
          // needs to do some other work, e.g. handle a timer. Therefore we can
          // "force" the microtask queue to be flushed by adding an empty timer.
          if (isIOS)
              setTimeout(noop);
      };
      isUsingMicroTask = true;
  }
  else if (!isIE &&
      typeof MutationObserver !== 'undefined' &&
      (isNative(MutationObserver) ||
          // PhantomJS and iOS 7.x
          MutationObserver.toString() === '[object MutationObserverConstructor]')) {
      // Use MutationObserver where native Promise is not available,
      // e.g. PhantomJS, iOS7, Android 4.4
      // (#6466 MutationObserver is unreliable in IE11)
      var counter_1 = 1;
      var observer = new MutationObserver(flushCallbacks);
      var textNode_1 = document.createTextNode(String(counter_1));
      observer.observe(textNode_1, {
          characterData: true
      });
      timerFunc = function () {
          counter_1 = (counter_1 + 1) % 2;
          textNode_1.data = String(counter_1);
      };
      isUsingMicroTask = true;
  }
  else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
      // Fallback to setImmediate.
      // Technically it leverages the (macro) task queue,
      // but it is still a better choice than setTimeout.
      timerFunc = function () {
          setImmediate(flushCallbacks);
      };
  }
  else {
      // Fallback to setTimeout.
      timerFunc = function () {
          setTimeout(flushCallbacks, 0);
      };
  }
  /**
   * @internal
   */
  function nextTick(cb, ctx) {
      var _resolve;
      callbacks.push(function () {
          if (cb) {
              try {
                  cb.call(ctx);
              }
              catch (e) {
                  handleError(e, ctx, 'nextTick');
              }
          }
          else if (_resolve) {
              _resolve(ctx);
          }
      });
      if (!pending) {
          pending = true;
          timerFunc();
      }
      // $flow-disable-line
      if (!cb && typeof Promise !== 'undefined') {
          return new Promise(function (resolve) {
              _resolve = resolve;
          });
      }
  }

  function useCssModule(name) {
      /* istanbul ignore else */
      {
          {
              warn$2("useCssModule() is not supported in the global build.");
          }
          return emptyObject;
      }
  }

  /**
   * Runtime helper for SFC's CSS variable injection feature.
   * @private
   */
  function useCssVars(getter) {
      if (!inBrowser && !false)
          return;
      var instance = currentInstance;
      if (!instance) {
          warn$2("useCssVars is called without current active component instance.");
          return;
      }
      watchPostEffect(function () {
          var el = instance.$el;
          var vars = getter(instance, instance._setupProxy);
          if (el && el.nodeType === 1) {
              var style = el.style;
              for (var key in vars) {
                  style.setProperty("--".concat(key), vars[key]);
              }
          }
      });
  }

  /**
   * v3-compatible async component API.
   * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
   * because it relies on existing manual types
   */
  function defineAsyncComponent(source) {
      if (isFunction(source)) {
          source = { loader: source };
      }
      var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
      _b = source.suspensible, // undefined = never times out
      suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
      userOnError = source.onError;
      if (suspensible) {
          warn$2("The suspensible option for async components is not supported in Vue2. It is ignored.");
      }
      var pendingRequest = null;
      var retries = 0;
      var retry = function () {
          retries++;
          pendingRequest = null;
          return load();
      };
      var load = function () {
          var thisRequest;
          return (pendingRequest ||
              (thisRequest = pendingRequest =
                  loader()
                      .catch(function (err) {
                      err = err instanceof Error ? err : new Error(String(err));
                      if (userOnError) {
                          return new Promise(function (resolve, reject) {
                              var userRetry = function () { return resolve(retry()); };
                              var userFail = function () { return reject(err); };
                              userOnError(err, userRetry, userFail, retries + 1);
                          });
                      }
                      else {
                          throw err;
                      }
                  })
                      .then(function (comp) {
                      if (thisRequest !== pendingRequest && pendingRequest) {
                          return pendingRequest;
                      }
                      if (!comp) {
                          warn$2("Async component loader resolved to undefined. " +
                              "If you are using retry(), make sure to return its return value.");
                      }
                      // interop module default
                      if (comp &&
                          (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                          comp = comp.default;
                      }
                      if (comp && !isObject(comp) && !isFunction(comp)) {
                          throw new Error("Invalid async component load result: ".concat(comp));
                      }
                      return comp;
                  })));
      };
      return function () {
          var component = load();
          return {
              component: component,
              delay: delay,
              timeout: timeout,
              error: errorComponent,
              loading: loadingComponent
          };
      };
  }

  function createLifeCycle(hookName) {
      return function (fn, target) {
          if (target === void 0) { target = currentInstance; }
          if (!target) {
              warn$2("".concat(formatName(hookName), " is called when there is no active component instance to be ") +
                      "associated with. " +
                      "Lifecycle injection APIs can only be used during execution of setup().");
              return;
          }
          return injectHook(target, hookName, fn);
      };
  }
  function formatName(name) {
      if (name === 'beforeDestroy') {
          name = 'beforeUnmount';
      }
      else if (name === 'destroyed') {
          name = 'unmounted';
      }
      return "on".concat(name[0].toUpperCase() + name.slice(1));
  }
  function injectHook(instance, hookName, fn) {
      var options = instance.$options;
      options[hookName] = mergeLifecycleHook(options[hookName], fn);
  }
  var onBeforeMount = createLifeCycle('beforeMount');
  var onMounted = createLifeCycle('mounted');
  var onBeforeUpdate = createLifeCycle('beforeUpdate');
  var onUpdated = createLifeCycle('updated');
  var onBeforeUnmount = createLifeCycle('beforeDestroy');
  var onUnmounted = createLifeCycle('destroyed');
  var onActivated = createLifeCycle('activated');
  var onDeactivated = createLifeCycle('deactivated');
  var onServerPrefetch = createLifeCycle('serverPrefetch');
  var onRenderTracked = createLifeCycle('renderTracked');
  var onRenderTriggered = createLifeCycle('renderTriggered');
  var injectErrorCapturedHook = createLifeCycle('errorCaptured');
  function onErrorCaptured(hook, target) {
      if (target === void 0) { target = currentInstance; }
      injectErrorCapturedHook(hook, target);
  }

  /**
   * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
   */
  var version = '2.7.16';
  /**
   * @internal type is manually declared in <root>/types/v3-define-component.d.ts
   */
  function defineComponent(options) {
      return options;
  }

  var vca = /*#__PURE__*/Object.freeze({
    __proto__: null,
    version: version,
    defineComponent: defineComponent,
    ref: ref$1,
    shallowRef: shallowRef,
    isRef: isRef,
    toRef: toRef,
    toRefs: toRefs,
    unref: unref,
    proxyRefs: proxyRefs,
    customRef: customRef,
    triggerRef: triggerRef,
    reactive: reactive,
    isReactive: isReactive,
    isReadonly: isReadonly,
    isShallow: isShallow,
    isProxy: isProxy,
    shallowReactive: shallowReactive,
    markRaw: markRaw,
    toRaw: toRaw,
    readonly: readonly,
    shallowReadonly: shallowReadonly,
    computed: computed,
    watch: watch,
    watchEffect: watchEffect,
    watchPostEffect: watchPostEffect,
    watchSyncEffect: watchSyncEffect,
    EffectScope: EffectScope,
    effectScope: effectScope,
    onScopeDispose: onScopeDispose,
    getCurrentScope: getCurrentScope,
    provide: provide,
    inject: inject,
    h: h,
    getCurrentInstance: getCurrentInstance,
    useSlots: useSlots,
    useAttrs: useAttrs,
    useListeners: useListeners,
    mergeDefaults: mergeDefaults,
    nextTick: nextTick,
    set: set,
    del: del,
    useCssModule: useCssModule,
    useCssVars: useCssVars,
    defineAsyncComponent: defineAsyncComponent,
    onBeforeMount: onBeforeMount,
    onMounted: onMounted,
    onBeforeUpdate: onBeforeUpdate,
    onUpdated: onUpdated,
    onBeforeUnmount: onBeforeUnmount,
    onUnmounted: onUnmounted,
    onActivated: onActivated,
    onDeactivated: onDeactivated,
    onServerPrefetch: onServerPrefetch,
    onRenderTracked: onRenderTracked,
    onRenderTriggered: onRenderTriggered,
    onErrorCaptured: onErrorCaptured
  });

  var seenObjects = new _Set();
  /**
   * Recursively traverse an object to evoke all converted
   * getters, so that every nested property inside the object
   * is collected as a "deep" dependency.
   */
  function traverse(val) {
      _traverse(val, seenObjects);
      seenObjects.clear();
      return val;
  }
  function _traverse(val, seen) {
      var i, keys;
      var isA = isArray(val);
      if ((!isA && !isObject(val)) ||
          val.__v_skip /* ReactiveFlags.SKIP */ ||
          Object.isFrozen(val) ||
          val instanceof VNode) {
          return;
      }
      if (val.__ob__) {
          var depId = val.__ob__.dep.id;
          if (seen.has(depId)) {
              return;
          }
          seen.add(depId);
      }
      if (isA) {
          i = val.length;
          while (i--)
              _traverse(val[i], seen);
      }
      else if (isRef(val)) {
          _traverse(val.value, seen);
      }
      else {
          keys = Object.keys(val);
          i = keys.length;
          while (i--)
              _traverse(val[keys[i]], seen);
      }
  }

  var uid$1 = 0;
  /**
   * A watcher parses an expression, collects dependencies,
   * and fires callback when the expression value changes.
   * This is used for both the $watch() api and directives.
   * @internal
   */
  var Watcher = /** @class */ (function () {
      function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
          recordEffectScope(this, 
          // if the active effect scope is manually created (not a component scope),
          // prioritize it
          activeEffectScope && !activeEffectScope._vm
              ? activeEffectScope
              : vm
                  ? vm._scope
                  : undefined);
          if ((this.vm = vm) && isRenderWatcher) {
              vm._watcher = this;
          }
          // options
          if (options) {
              this.deep = !!options.deep;
              this.user = !!options.user;
              this.lazy = !!options.lazy;
              this.sync = !!options.sync;
              this.before = options.before;
              {
                  this.onTrack = options.onTrack;
                  this.onTrigger = options.onTrigger;
              }
          }
          else {
              this.deep = this.user = this.lazy = this.sync = false;
          }
          this.cb = cb;
          this.id = ++uid$1; // uid for batching
          this.active = true;
          this.post = false;
          this.dirty = this.lazy; // for lazy watchers
          this.deps = [];
          this.newDeps = [];
          this.depIds = new _Set();
          this.newDepIds = new _Set();
          this.expression = expOrFn.toString() ;
          // parse expression for getter
          if (isFunction(expOrFn)) {
              this.getter = expOrFn;
          }
          else {
              this.getter = parsePath(expOrFn);
              if (!this.getter) {
                  this.getter = noop;
                  warn$2("Failed watching path: \"".concat(expOrFn, "\" ") +
                          'Watcher only accepts simple dot-delimited paths. ' +
                          'For full control, use a function instead.', vm);
              }
          }
          this.value = this.lazy ? undefined : this.get();
      }
      /**
       * Evaluate the getter, and re-collect dependencies.
       */
      Watcher.prototype.get = function () {
          pushTarget(this);
          var value;
          var vm = this.vm;
          try {
              value = this.getter.call(vm, vm);
          }
          catch (e) {
              if (this.user) {
                  handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
              }
              else {
                  throw e;
              }
          }
          finally {
              // "touch" every property so they are all tracked as
              // dependencies for deep watching
              if (this.deep) {
                  traverse(value);
              }
              popTarget();
              this.cleanupDeps();
          }
          return value;
      };
      /**
       * Add a dependency to this directive.
       */
      Watcher.prototype.addDep = function (dep) {
          var id = dep.id;
          if (!this.newDepIds.has(id)) {
              this.newDepIds.add(id);
              this.newDeps.push(dep);
              if (!this.depIds.has(id)) {
                  dep.addSub(this);
              }
          }
      };
      /**
       * Clean up for dependency collection.
       */
      Watcher.prototype.cleanupDeps = function () {
          var i = this.deps.length;
          while (i--) {
              var dep = this.deps[i];
              if (!this.newDepIds.has(dep.id)) {
                  dep.removeSub(this);
              }
          }
          var tmp = this.depIds;
          this.depIds = this.newDepIds;
          this.newDepIds = tmp;
          this.newDepIds.clear();
          tmp = this.deps;
          this.deps = this.newDeps;
          this.newDeps = tmp;
          this.newDeps.length = 0;
      };
      /**
       * Subscriber interface.
       * Will be called when a dependency changes.
       */
      Watcher.prototype.update = function () {
          /* istanbul ignore else */
          if (this.lazy) {
              this.dirty = true;
          }
          else if (this.sync) {
              this.run();
          }
          else {
              queueWatcher(this);
          }
      };
      /**
       * Scheduler job interface.
       * Will be called by the scheduler.
       */
      Watcher.prototype.run = function () {
          if (this.active) {
              var value = this.get();
              if (value !== this.value ||
                  // Deep watchers and watchers on Object/Arrays should fire even
                  // when the value is the same, because the value may
                  // have mutated.
                  isObject(value) ||
                  this.deep) {
                  // set new value
                  var oldValue = this.value;
                  this.value = value;
                  if (this.user) {
                      var info = "callback for watcher \"".concat(this.expression, "\"");
                      invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                  }
                  else {
                      this.cb.call(this.vm, value, oldValue);
                  }
              }
          }
      };
      /**
       * Evaluate the value of the watcher.
       * This only gets called for lazy watchers.
       */
      Watcher.prototype.evaluate = function () {
          this.value = this.get();
          this.dirty = false;
      };
      /**
       * Depend on all deps collected by this watcher.
       */
      Watcher.prototype.depend = function () {
          var i = this.deps.length;
          while (i--) {
              this.deps[i].depend();
          }
      };
      /**
       * Remove self from all dependencies' subscriber list.
       */
      Watcher.prototype.teardown = function () {
          if (this.vm && !this.vm._isBeingDestroyed) {
              remove$2(this.vm._scope.effects, this);
          }
          if (this.active) {
              var i = this.deps.length;
              while (i--) {
                  this.deps[i].removeSub(this);
              }
              this.active = false;
              if (this.onStop) {
                  this.onStop();
              }
          }
      };
      return Watcher;
  }());

  var sharedPropertyDefinition = {
      enumerable: true,
      configurable: true,
      get: noop,
      set: noop
  };
  function proxy(target, sourceKey, key) {
      sharedPropertyDefinition.get = function proxyGetter() {
          return this[sourceKey][key];
      };
      sharedPropertyDefinition.set = function proxySetter(val) {
          this[sourceKey][key] = val;
      };
      Object.defineProperty(target, key, sharedPropertyDefinition);
  }
  function initState(vm) {
      var opts = vm.$options;
      if (opts.props)
          initProps$1(vm, opts.props);
      // Composition API
      initSetup(vm);
      if (opts.methods)
          initMethods(vm, opts.methods);
      if (opts.data) {
          initData(vm);
      }
      else {
          var ob = observe((vm._data = {}));
          ob && ob.vmCount++;
      }
      if (opts.computed)
          initComputed$1(vm, opts.computed);
      if (opts.watch && opts.watch !== nativeWatch) {
          initWatch(vm, opts.watch);
      }
  }
  function initProps$1(vm, propsOptions) {
      var propsData = vm.$options.propsData || {};
      var props = (vm._props = shallowReactive({}));
      // cache prop keys so that future props updates can iterate using Array
      // instead of dynamic object key enumeration.
      var keys = (vm.$options._propKeys = []);
      var isRoot = !vm.$parent;
      // root instance props should be converted
      if (!isRoot) {
          toggleObserving(false);
      }
      var _loop_1 = function (key) {
          keys.push(key);
          var value = validateProp(key, propsOptions, propsData, vm);
          /* istanbul ignore else */
          {
              var hyphenatedKey = hyphenate(key);
              if (isReservedAttribute(hyphenatedKey) ||
                  config.isReservedAttr(hyphenatedKey)) {
                  warn$2("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
              }
              defineReactive(props, key, value, function () {
                  if (!isRoot && !isUpdatingChildComponent) {
                      warn$2("Avoid mutating a prop directly since the value will be " +
                          "overwritten whenever the parent component re-renders. " +
                          "Instead, use a data or computed property based on the prop's " +
                          "value. Prop being mutated: \"".concat(key, "\""), vm);
                  }
              }, true /* shallow */);
          }
          // static props are already proxied on the component's prototype
          // during Vue.extend(). We only need to proxy props defined at
          // instantiation here.
          if (!(key in vm)) {
              proxy(vm, "_props", key);
          }
      };
      for (var key in propsOptions) {
          _loop_1(key);
      }
      toggleObserving(true);
  }
  function initData(vm) {
      var data = vm.$options.data;
      data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
      if (!isPlainObject(data)) {
          data = {};
          warn$2('data functions should return an object:\n' +
                  'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
      }
      // proxy data on instance
      var keys = Object.keys(data);
      var props = vm.$options.props;
      var methods = vm.$options.methods;
      var i = keys.length;
      while (i--) {
          var key = keys[i];
          {
              if (methods && hasOwn(methods, key)) {
                  warn$2("Method \"".concat(key, "\" has already been defined as a data property."), vm);
              }
          }
          if (props && hasOwn(props, key)) {
              warn$2("The data property \"".concat(key, "\" is already declared as a prop. ") +
                      "Use prop default value instead.", vm);
          }
          else if (!isReserved(key)) {
              proxy(vm, "_data", key);
          }
      }
      // observe data
      var ob = observe(data);
      ob && ob.vmCount++;
  }
  function getData(data, vm) {
      // #7573 disable dep collection when invoking data getters
      pushTarget();
      try {
          return data.call(vm, vm);
      }
      catch (e) {
          handleError(e, vm, "data()");
          return {};
      }
      finally {
          popTarget();
      }
  }
  var computedWatcherOptions = { lazy: true };
  function initComputed$1(vm, computed) {
      // $flow-disable-line
      var watchers = (vm._computedWatchers = Object.create(null));
      // computed properties are just getters during SSR
      var isSSR = isServerRendering();
      for (var key in computed) {
          var userDef = computed[key];
          var getter = isFunction(userDef) ? userDef : userDef.get;
          if (getter == null) {
              warn$2("Getter is missing for computed property \"".concat(key, "\"."), vm);
          }
          if (!isSSR) {
              // create internal watcher for the computed property.
              watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
          }
          // component-defined computed properties are already defined on the
          // component prototype. We only need to define computed properties defined
          // at instantiation here.
          if (!(key in vm)) {
              defineComputed(vm, key, userDef);
          }
          else {
              if (key in vm.$data) {
                  warn$2("The computed property \"".concat(key, "\" is already defined in data."), vm);
              }
              else if (vm.$options.props && key in vm.$options.props) {
                  warn$2("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
              }
              else if (vm.$options.methods && key in vm.$options.methods) {
                  warn$2("The computed property \"".concat(key, "\" is already defined as a method."), vm);
              }
          }
      }
  }
  function defineComputed(target, key, userDef) {
      var shouldCache = !isServerRendering();
      if (isFunction(userDef)) {
          sharedPropertyDefinition.get = shouldCache
              ? createComputedGetter(key)
              : createGetterInvoker(userDef);
          sharedPropertyDefinition.set = noop;
      }
      else {
          sharedPropertyDefinition.get = userDef.get
              ? shouldCache && userDef.cache !== false
                  ? createComputedGetter(key)
                  : createGetterInvoker(userDef.get)
              : noop;
          sharedPropertyDefinition.set = userDef.set || noop;
      }
      if (sharedPropertyDefinition.set === noop) {
          sharedPropertyDefinition.set = function () {
              warn$2("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
          };
      }
      Object.defineProperty(target, key, sharedPropertyDefinition);
  }
  function createComputedGetter(key) {
      return function computedGetter() {
          var watcher = this._computedWatchers && this._computedWatchers[key];
          if (watcher) {
              if (watcher.dirty) {
                  watcher.evaluate();
              }
              if (Dep.target) {
                  if (Dep.target.onTrack) {
                      Dep.target.onTrack({
                          effect: Dep.target,
                          target: this,
                          type: "get" /* TrackOpTypes.GET */,
                          key: key
                      });
                  }
                  watcher.depend();
              }
              return watcher.value;
          }
      };
  }
  function createGetterInvoker(fn) {
      return function computedGetter() {
          return fn.call(this, this);
      };
  }
  function initMethods(vm, methods) {
      var props = vm.$options.props;
      for (var key in methods) {
          {
              if (typeof methods[key] !== 'function') {
                  warn$2("Method \"".concat(key, "\" has type \"").concat(typeof methods[key], "\" in the component definition. ") +
                      "Did you reference the function correctly?", vm);
              }
              if (props && hasOwn(props, key)) {
                  warn$2("Method \"".concat(key, "\" has already been defined as a prop."), vm);
              }
              if (key in vm && isReserved(key)) {
                  warn$2("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") +
                      "Avoid defining component methods that start with _ or $.");
              }
          }
          vm[key] = typeof methods[key] !== 'function' ? noop : bind$1(methods[key], vm);
      }
  }
  function initWatch(vm, watch) {
      for (var key in watch) {
          var handler = watch[key];
          if (isArray(handler)) {
              for (var i = 0; i < handler.length; i++) {
                  createWatcher(vm, key, handler[i]);
              }
          }
          else {
              createWatcher(vm, key, handler);
          }
      }
  }
  function createWatcher(vm, expOrFn, handler, options) {
      if (isPlainObject(handler)) {
          options = handler;
          handler = handler.handler;
      }
      if (typeof handler === 'string') {
          handler = vm[handler];
      }
      return vm.$watch(expOrFn, handler, options);
  }
  function stateMixin(Vue) {
      // flow somehow has problems with directly declared definition object
      // when using Object.defineProperty, so we have to procedurally build up
      // the object here.
      var dataDef = {};
      dataDef.get = function () {
          return this._data;
      };
      var propsDef = {};
      propsDef.get = function () {
          return this._props;
      };
      {
          dataDef.set = function () {
              warn$2('Avoid replacing instance root $data. ' +
                  'Use nested data properties instead.', this);
          };
          propsDef.set = function () {
              warn$2("$props is readonly.", this);
          };
      }
      Object.defineProperty(Vue.prototype, '$data', dataDef);
      Object.defineProperty(Vue.prototype, '$props', propsDef);
      Vue.prototype.$set = set;
      Vue.prototype.$delete = del;
      Vue.prototype.$watch = function (expOrFn, cb, options) {
          var vm = this;
          if (isPlainObject(cb)) {
              return createWatcher(vm, expOrFn, cb, options);
          }
          options = options || {};
          options.user = true;
          var watcher = new Watcher(vm, expOrFn, cb, options);
          if (options.immediate) {
              var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
              pushTarget();
              invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
              popTarget();
          }
          return function unwatchFn() {
              watcher.teardown();
          };
      };
  }

  function initProvide(vm) {
      var provideOption = vm.$options.provide;
      if (provideOption) {
          var provided = isFunction(provideOption)
              ? provideOption.call(vm)
              : provideOption;
          if (!isObject(provided)) {
              return;
          }
          var source = resolveProvided(vm);
          // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
          // iterate the keys ourselves.
          var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
          for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
          }
      }
  }
  function initInjections(vm) {
      var result = resolveInject(vm.$options.inject, vm);
      if (result) {
          toggleObserving(false);
          Object.keys(result).forEach(function (key) {
              /* istanbul ignore else */
              {
                  defineReactive(vm, key, result[key], function () {
                      warn$2("Avoid mutating an injected value directly since the changes will be " +
                          "overwritten whenever the provided component re-renders. " +
                          "injection being mutated: \"".concat(key, "\""), vm);
                  });
              }
          });
          toggleObserving(true);
      }
  }
  function resolveInject(inject, vm) {
      if (inject) {
          // inject is :any because flow is not smart enough to figure out cached
          var result = Object.create(null);
          var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
          for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              // #6574 in case the inject object is observed...
              if (key === '__ob__')
                  continue;
              var provideKey = inject[key].from;
              if (provideKey in vm._provided) {
                  result[key] = vm._provided[provideKey];
              }
              else if ('default' in inject[key]) {
                  var provideDefault = inject[key].default;
                  result[key] = isFunction(provideDefault)
                      ? provideDefault.call(vm)
                      : provideDefault;
              }
              else {
                  warn$2("Injection \"".concat(key, "\" not found"), vm);
              }
          }
          return result;
      }
  }

  var uid = 0;
  function initMixin$1(Vue) {
      Vue.prototype._init = function (options) {
          var vm = this;
          // a uid
          vm._uid = uid++;
          var startTag, endTag;
          /* istanbul ignore if */
          if (config.performance && mark) {
              startTag = "vue-perf-start:".concat(vm._uid);
              endTag = "vue-perf-end:".concat(vm._uid);
              mark(startTag);
          }
          // a flag to mark this as a Vue instance without having to do instanceof
          // check
          vm._isVue = true;
          // avoid instances from being observed
          vm.__v_skip = true;
          // effect scope
          vm._scope = new EffectScope(true /* detached */);
          // #13134 edge case where a child component is manually created during the
          // render of a parent component
          vm._scope.parent = undefined;
          vm._scope._vm = true;
          // merge options
          if (options && options._isComponent) {
              // optimize internal component instantiation
              // since dynamic options merging is pretty slow, and none of the
              // internal component options needs special treatment.
              initInternalComponent(vm, options);
          }
          else {
              vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
          }
          /* istanbul ignore else */
          {
              initProxy(vm);
          }
          // expose real self
          vm._self = vm;
          initLifecycle(vm);
          initEvents(vm);
          initRender(vm);
          callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
          initInjections(vm); // resolve injections before data/props
          initState(vm);
          initProvide(vm); // resolve provide after data/props
          callHook$1(vm, 'created');
          /* istanbul ignore if */
          if (config.performance && mark) {
              vm._name = formatComponentName(vm, false);
              mark(endTag);
              measure("vue ".concat(vm._name, " init"), startTag, endTag);
          }
          if (vm.$options.el) {
              vm.$mount(vm.$options.el);
          }
      };
  }
  function initInternalComponent(vm, options) {
      var opts = (vm.$options = Object.create(vm.constructor.options));
      // doing this because it's faster than dynamic enumeration.
      var parentVnode = options._parentVnode;
      opts.parent = options.parent;
      opts._parentVnode = parentVnode;
      var vnodeComponentOptions = parentVnode.componentOptions;
      opts.propsData = vnodeComponentOptions.propsData;
      opts._parentListeners = vnodeComponentOptions.listeners;
      opts._renderChildren = vnodeComponentOptions.children;
      opts._componentTag = vnodeComponentOptions.tag;
      if (options.render) {
          opts.render = options.render;
          opts.staticRenderFns = options.staticRenderFns;
      }
  }
  function resolveConstructorOptions(Ctor) {
      var options = Ctor.options;
      if (Ctor.super) {
          var superOptions = resolveConstructorOptions(Ctor.super);
          var cachedSuperOptions = Ctor.superOptions;
          if (superOptions !== cachedSuperOptions) {
              // super option changed,
              // need to resolve new options.
              Ctor.superOptions = superOptions;
              // check if there are any late-modified/attached options (#4976)
              var modifiedOptions = resolveModifiedOptions(Ctor);
              // update base extend options
              if (modifiedOptions) {
                  extend(Ctor.extendOptions, modifiedOptions);
              }
              options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
              if (options.name) {
                  options.components[options.name] = Ctor;
              }
          }
      }
      return options;
  }
  function resolveModifiedOptions(Ctor) {
      var modified;
      var latest = Ctor.options;
      var sealed = Ctor.sealedOptions;
      for (var key in latest) {
          if (latest[key] !== sealed[key]) {
              if (!modified)
                  modified = {};
              modified[key] = latest[key];
          }
      }
      return modified;
  }

  function FunctionalRenderContext(data, props, children, parent, Ctor) {
      var _this = this;
      var options = Ctor.options;
      // ensure the createElement function in functional components
      // gets a unique context - this is necessary for correct named slot check
      var contextVm;
      if (hasOwn(parent, '_uid')) {
          contextVm = Object.create(parent);
          contextVm._original = parent;
      }
      else {
          // the context vm passed in is a functional context as well.
          // in this case we want to make sure we are able to get a hold to the
          // real context instance.
          contextVm = parent;
          // @ts-ignore
          parent = parent._original;
      }
      var isCompiled = isTrue(options._compiled);
      var needNormalization = !isCompiled;
      this.data = data;
      this.props = props;
      this.children = children;
      this.parent = parent;
      this.listeners = data.on || emptyObject;
      this.injections = resolveInject(options.inject, parent);
      this.slots = function () {
          if (!_this.$slots) {
              normalizeScopedSlots(parent, data.scopedSlots, (_this.$slots = resolveSlots(children, parent)));
          }
          return _this.$slots;
      };
      Object.defineProperty(this, 'scopedSlots', {
          enumerable: true,
          get: function () {
              return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
          }
      });
      // support for compiled functional template
      if (isCompiled) {
          // exposing $options for renderStatic()
          this.$options = options;
          // pre-resolve slots for renderSlot()
          this.$slots = this.slots();
          this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
      }
      if (options._scopeId) {
          this._c = function (a, b, c, d) {
              var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
              if (vnode && !isArray(vnode)) {
                  vnode.fnScopeId = options._scopeId;
                  vnode.fnContext = parent;
              }
              return vnode;
          };
      }
      else {
          this._c = function (a, b, c, d) {
              return createElement$1(contextVm, a, b, c, d, needNormalization);
          };
      }
  }
  installRenderHelpers(FunctionalRenderContext.prototype);
  function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
      var options = Ctor.options;
      var props = {};
      var propOptions = options.props;
      if (isDef(propOptions)) {
          for (var key in propOptions) {
              props[key] = validateProp(key, propOptions, propsData || emptyObject);
          }
      }
      else {
          if (isDef(data.attrs))
              mergeProps(props, data.attrs);
          if (isDef(data.props))
              mergeProps(props, data.props);
      }
      var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
      var vnode = options.render.call(null, renderContext._c, renderContext);
      if (vnode instanceof VNode) {
          return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
      }
      else if (isArray(vnode)) {
          var vnodes = normalizeChildren(vnode) || [];
          var res = new Array(vnodes.length);
          for (var i = 0; i < vnodes.length; i++) {
              res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
          }
          return res;
      }
  }
  function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
      // #7817 clone node before setting fnContext, otherwise if the node is reused
      // (e.g. it was from a cached normal slot) the fnContext causes named slots
      // that should not be matched to match.
      var clone = cloneVNode(vnode);
      clone.fnContext = contextVm;
      clone.fnOptions = options;
      {
          (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
              renderContext;
      }
      if (data.slot) {
          (clone.data || (clone.data = {})).slot = data.slot;
      }
      return clone;
  }
  function mergeProps(to, from) {
      for (var key in from) {
          to[camelize(key)] = from[key];
      }
  }

  function getComponentName(options) {
      return options.name || options.__name || options._componentTag;
  }
  // inline hooks to be invoked on component VNodes during patch
  var componentVNodeHooks = {
      init: function (vnode, hydrating) {
          if (vnode.componentInstance &&
              !vnode.componentInstance._isDestroyed &&
              vnode.data.keepAlive) {
              // kept-alive components, treat as a patch
              var mountedNode = vnode; // work around flow
              componentVNodeHooks.prepatch(mountedNode, mountedNode);
          }
          else {
              var child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
              child.$mount(hydrating ? vnode.elm : undefined, hydrating);
          }
      },
      prepatch: function (oldVnode, vnode) {
          var options = vnode.componentOptions;
          var child = (vnode.componentInstance = oldVnode.componentInstance);
          updateChildComponent(child, options.propsData, // updated props
          options.listeners, // updated listeners
          vnode, // new parent vnode
          options.children // new children
          );
      },
      insert: function (vnode) {
          var context = vnode.context, componentInstance = vnode.componentInstance;
          if (!componentInstance._isMounted) {
              componentInstance._isMounted = true;
              callHook$1(componentInstance, 'mounted');
          }
          if (vnode.data.keepAlive) {
              if (context._isMounted) {
                  // vue-router#1212
                  // During updates, a kept-alive component's child components may
                  // change, so directly walking the tree here may call activated hooks
                  // on incorrect children. Instead we push them into a queue which will
                  // be processed after the whole patch process ended.
                  queueActivatedComponent(componentInstance);
              }
              else {
                  activateChildComponent(componentInstance, true /* direct */);
              }
          }
      },
      destroy: function (vnode) {
          var componentInstance = vnode.componentInstance;
          if (!componentInstance._isDestroyed) {
              if (!vnode.data.keepAlive) {
                  componentInstance.$destroy();
              }
              else {
                  deactivateChildComponent(componentInstance, true /* direct */);
              }
          }
      }
  };
  var hooksToMerge = Object.keys(componentVNodeHooks);
  function createComponent(Ctor, data, context, children, tag) {
      if (isUndef(Ctor)) {
          return;
      }
      var baseCtor = context.$options._base;
      // plain options object: turn it into a constructor
      if (isObject(Ctor)) {
          Ctor = baseCtor.extend(Ctor);
      }
      // if at this stage it's not a constructor or an async component factory,
      // reject.
      if (typeof Ctor !== 'function') {
          {
              warn$2("Invalid Component definition: ".concat(String(Ctor)), context);
          }
          return;
      }
      // async component
      var asyncFactory;
      // @ts-expect-error
      if (isUndef(Ctor.cid)) {
          asyncFactory = Ctor;
          Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
          if (Ctor === undefined) {
              // return a placeholder node for async component, which is rendered
              // as a comment node but preserves all the raw information for the node.
              // the information will be used for async server-rendering and hydration.
              return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
          }
      }
      data = data || {};
      // resolve constructor options in case global mixins are applied after
      // component constructor creation
      resolveConstructorOptions(Ctor);
      // transform component v-model data into props & events
      if (isDef(data.model)) {
          // @ts-expect-error
          transformModel(Ctor.options, data);
      }
      // extract props
      // @ts-expect-error
      var propsData = extractPropsFromVNodeData(data, Ctor, tag);
      // functional component
      // @ts-expect-error
      if (isTrue(Ctor.options.functional)) {
          return createFunctionalComponent(Ctor, propsData, data, context, children);
      }
      // extract listeners, since these needs to be treated as
      // child component listeners instead of DOM listeners
      var listeners = data.on;
      // replace with listeners with .native modifier
      // so it gets processed during parent component patch.
      data.on = data.nativeOn;
      // @ts-expect-error
      if (isTrue(Ctor.options.abstract)) {
          // abstract components do not keep anything
          // other than props & listeners & slot
          // work around flow
          var slot = data.slot;
          data = {};
          if (slot) {
              data.slot = slot;
          }
      }
      // install component management hooks onto the placeholder node
      installComponentHooks(data);
      // return a placeholder vnode
      // @ts-expect-error
      var name = getComponentName(Ctor.options) || tag;
      var vnode = new VNode(
      // @ts-expect-error
      "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context, 
      // @ts-expect-error
      { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
      return vnode;
  }
  function createComponentInstanceForVnode(
  // we know it's MountedComponentVNode but flow doesn't
  vnode, 
  // activeInstance in lifecycle state
  parent) {
      var options = {
          _isComponent: true,
          _parentVnode: vnode,
          parent: parent
      };
      // check inline-template render functions
      var inlineTemplate = vnode.data.inlineTemplate;
      if (isDef(inlineTemplate)) {
          options.render = inlineTemplate.render;
          options.staticRenderFns = inlineTemplate.staticRenderFns;
      }
      return new vnode.componentOptions.Ctor(options);
  }
  function installComponentHooks(data) {
      var hooks = data.hook || (data.hook = {});
      for (var i = 0; i < hooksToMerge.length; i++) {
          var key = hooksToMerge[i];
          var existing = hooks[key];
          var toMerge = componentVNodeHooks[key];
          // @ts-expect-error
          if (existing !== toMerge && !(existing && existing._merged)) {
              hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
          }
      }
  }
  function mergeHook(f1, f2) {
      var merged = function (a, b) {
          // flow complains about extra args which is why we use any
          f1(a, b);
          f2(a, b);
      };
      merged._merged = true;
      return merged;
  }
  // transform component v-model info (value and callback) into
  // prop and event handler respectively.
  function transformModel(options, data) {
      var prop = (options.model && options.model.prop) || 'value';
      var event = (options.model && options.model.event) || 'input';
      (data.attrs || (data.attrs = {}))[prop] = data.model.value;
      var on = data.on || (data.on = {});
      var existing = on[event];
      var callback = data.model.callback;
      if (isDef(existing)) {
          if (isArray(existing)
              ? existing.indexOf(callback) === -1
              : existing !== callback) {
              on[event] = [callback].concat(existing);
          }
      }
      else {
          on[event] = callback;
      }
  }

  var warn$2 = noop;
  var tip = noop;
  var generateComponentTrace; // work around flow check
  var formatComponentName;
  {
      var hasConsole_1 = typeof console !== 'undefined';
      var classifyRE_1 = /(?:^|[-_])(\w)/g;
      var classify_1 = function (str) {
          return str.replace(classifyRE_1, function (c) { return c.toUpperCase(); }).replace(/[-_]/g, '');
      };
      warn$2 = function (msg, vm) {
          if (vm === void 0) { vm = currentInstance; }
          var trace = vm ? generateComponentTrace(vm) : '';
          if (config.warnHandler) {
              config.warnHandler.call(null, msg, vm, trace);
          }
          else if (hasConsole_1 && !config.silent) {
              console.error("[Vue warn]: ".concat(msg).concat(trace));
          }
      };
      tip = function (msg, vm) {
          if (hasConsole_1 && !config.silent) {
              console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
          }
      };
      formatComponentName = function (vm, includeFile) {
          if (vm.$root === vm) {
              return '<Root>';
          }
          var options = isFunction(vm) && vm.cid != null
              ? vm.options
              : vm._isVue
                  ? vm.$options || vm.constructor.options
                  : vm;
          var name = getComponentName(options);
          var file = options.__file;
          if (!name && file) {
              var match = file.match(/([^/\\]+)\.vue$/);
              name = match && match[1];
          }
          return ((name ? "<".concat(classify_1(name), ">") : "<Anonymous>") +
              (file && includeFile !== false ? " at ".concat(file) : ''));
      };
      var repeat_1 = function (str, n) {
          var res = '';
          while (n) {
              if (n % 2 === 1)
                  res += str;
              if (n > 1)
                  str += str;
              n >>= 1;
          }
          return res;
      };
      generateComponentTrace = function (vm) {
          if (vm._isVue && vm.$parent) {
              var tree = [];
              var currentRecursiveSequence = 0;
              while (vm) {
                  if (tree.length > 0) {
                      var last = tree[tree.length - 1];
                      if (last.constructor === vm.constructor) {
                          currentRecursiveSequence++;
                          vm = vm.$parent;
                          continue;
                      }
                      else if (currentRecursiveSequence > 0) {
                          tree[tree.length - 1] = [last, currentRecursiveSequence];
                          currentRecursiveSequence = 0;
                      }
                  }
                  tree.push(vm);
                  vm = vm.$parent;
              }
              return ('\n\nfound in\n\n' +
                  tree
                      .map(function (vm, i) {
                      return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm)
                          ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)")
                          : formatComponentName(vm));
                  })
                      .join('\n'));
          }
          else {
              return "\n\n(found in ".concat(formatComponentName(vm), ")");
          }
      };
  }

  /**
   * Option overwriting strategies are functions that handle
   * how to merge a parent option value and a child option
   * value into the final value.
   */
  var strats = config.optionMergeStrategies;
  /**
   * Options with restrictions
   */
  {
      strats.el = strats.propsData = function (parent, child, vm, key) {
          if (!vm) {
              warn$2("option \"".concat(key, "\" can only be used during instance ") +
                  'creation with the `new` keyword.');
          }
          return defaultStrat(parent, child);
      };
  }
  /**
   * Helper that recursively merges two data objects together.
   */
  function mergeData(to, from, recursive) {
      if (recursive === void 0) { recursive = true; }
      if (!from)
          return to;
      var key, toVal, fromVal;
      var keys = hasSymbol
          ? Reflect.ownKeys(from)
          : Object.keys(from);
      for (var i = 0; i < keys.length; i++) {
          key = keys[i];
          // in case the object is already observed...
          if (key === '__ob__')
              continue;
          toVal = to[key];
          fromVal = from[key];
          if (!recursive || !hasOwn(to, key)) {
              set(to, key, fromVal);
          }
          else if (toVal !== fromVal &&
              isPlainObject(toVal) &&
              isPlainObject(fromVal)) {
              mergeData(toVal, fromVal);
          }
      }
      return to;
  }
  /**
   * Data
   */
  function mergeDataOrFn(parentVal, childVal, vm) {
      if (!vm) {
          // in a Vue.extend merge, both should be functions
          if (!childVal) {
              return parentVal;
          }
          if (!parentVal) {
              return childVal;
          }
          // when parentVal & childVal are both present,
          // we need to return a function that returns the
          // merged result of both functions... no need to
          // check if parentVal is a function here because
          // it has to be a function to pass previous merges.
          return function mergedDataFn() {
              return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
          };
      }
      else {
          return function mergedInstanceDataFn() {
              // instance merge
              var instanceData = isFunction(childVal)
                  ? childVal.call(vm, vm)
                  : childVal;
              var defaultData = isFunction(parentVal)
                  ? parentVal.call(vm, vm)
                  : parentVal;
              if (instanceData) {
                  return mergeData(instanceData, defaultData);
              }
              else {
                  return defaultData;
              }
          };
      }
  }
  strats.data = function (parentVal, childVal, vm) {
      if (!vm) {
          if (childVal && typeof childVal !== 'function') {
              warn$2('The "data" option should be a function ' +
                      'that returns a per-instance value in component ' +
                      'definitions.', vm);
              return parentVal;
          }
          return mergeDataOrFn(parentVal, childVal);
      }
      return mergeDataOrFn(parentVal, childVal, vm);
  };
  /**
   * Hooks and props are merged as arrays.
   */
  function mergeLifecycleHook(parentVal, childVal) {
      var res = childVal
          ? parentVal
              ? parentVal.concat(childVal)
              : isArray(childVal)
                  ? childVal
                  : [childVal]
          : parentVal;
      return res ? dedupeHooks(res) : res;
  }
  function dedupeHooks(hooks) {
      var res = [];
      for (var i = 0; i < hooks.length; i++) {
          if (res.indexOf(hooks[i]) === -1) {
              res.push(hooks[i]);
          }
      }
      return res;
  }
  LIFECYCLE_HOOKS.forEach(function (hook) {
      strats[hook] = mergeLifecycleHook;
  });
  /**
   * Assets
   *
   * When a vm is present (instance creation), we need to do
   * a three-way merge between constructor options, instance
   * options and parent options.
   */
  function mergeAssets(parentVal, childVal, vm, key) {
      var res = Object.create(parentVal || null);
      if (childVal) {
          assertObjectType(key, childVal, vm);
          return extend(res, childVal);
      }
      else {
          return res;
      }
  }
  ASSET_TYPES.forEach(function (type) {
      strats[type + 's'] = mergeAssets;
  });
  /**
   * Watchers.
   *
   * Watchers hashes should not overwrite one
   * another, so we merge them as arrays.
   */
  strats.watch = function (parentVal, childVal, vm, key) {
      // work around Firefox's Object.prototype.watch...
      //@ts-expect-error work around
      if (parentVal === nativeWatch)
          parentVal = undefined;
      //@ts-expect-error work around
      if (childVal === nativeWatch)
          childVal = undefined;
      /* istanbul ignore if */
      if (!childVal)
          return Object.create(parentVal || null);
      {
          assertObjectType(key, childVal, vm);
      }
      if (!parentVal)
          return childVal;
      var ret = {};
      extend(ret, parentVal);
      for (var key_1 in childVal) {
          var parent_1 = ret[key_1];
          var child = childVal[key_1];
          if (parent_1 && !isArray(parent_1)) {
              parent_1 = [parent_1];
          }
          ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
      }
      return ret;
  };
  /**
   * Other object hashes.
   */
  strats.props =
      strats.methods =
          strats.inject =
              strats.computed =
                  function (parentVal, childVal, vm, key) {
                      if (childVal && true) {
                          assertObjectType(key, childVal, vm);
                      }
                      if (!parentVal)
                          return childVal;
                      var ret = Object.create(null);
                      extend(ret, parentVal);
                      if (childVal)
                          extend(ret, childVal);
                      return ret;
                  };
  strats.provide = function (parentVal, childVal) {
      if (!parentVal)
          return childVal;
      return function () {
          var ret = Object.create(null);
          mergeData(ret, isFunction(parentVal) ? parentVal.call(this) : parentVal);
          if (childVal) {
              mergeData(ret, isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
              );
          }
          return ret;
      };
  };
  /**
   * Default strategy.
   */
  var defaultStrat = function (parentVal, childVal) {
      return childVal === undefined ? parentVal : childVal;
  };
  /**
   * Validate component names
   */
  function checkComponents(options) {
      for (var key in options.components) {
          validateComponentName(key);
      }
  }
  function validateComponentName(name) {
      if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
          warn$2('Invalid component name: "' +
              name +
              '". Component names ' +
              'should conform to valid custom element name in html5 specification.');
      }
      if (isBuiltInTag(name) || config.isReservedTag(name)) {
          warn$2('Do not use built-in or reserved HTML elements as component ' +
              'id: ' +
              name);
      }
  }
  /**
   * Ensure all props option syntax are normalized into the
   * Object-based format.
   */
  function normalizeProps(options, vm) {
      var props = options.props;
      if (!props)
          return;
      var res = {};
      var i, val, name;
      if (isArray(props)) {
          i = props.length;
          while (i--) {
              val = props[i];
              if (typeof val === 'string') {
                  name = camelize(val);
                  res[name] = { type: null };
              }
              else {
                  warn$2('props must be strings when using array syntax.');
              }
          }
      }
      else if (isPlainObject(props)) {
          for (var key in props) {
              val = props[key];
              name = camelize(key);
              res[name] = isPlainObject(val) ? val : { type: val };
          }
      }
      else {
          warn$2("Invalid value for option \"props\": expected an Array or an Object, " +
              "but got ".concat(toRawType(props), "."), vm);
      }
      options.props = res;
  }
  /**
   * Normalize all injections into Object-based format
   */
  function normalizeInject(options, vm) {
      var inject = options.inject;
      if (!inject)
          return;
      var normalized = (options.inject = {});
      if (isArray(inject)) {
          for (var i = 0; i < inject.length; i++) {
              normalized[inject[i]] = { from: inject[i] };
          }
      }
      else if (isPlainObject(inject)) {
          for (var key in inject) {
              var val = inject[key];
              normalized[key] = isPlainObject(val)
                  ? extend({ from: key }, val)
                  : { from: val };
          }
      }
      else {
          warn$2("Invalid value for option \"inject\": expected an Array or an Object, " +
              "but got ".concat(toRawType(inject), "."), vm);
      }
  }
  /**
   * Normalize raw function directives into object format.
   */
  function normalizeDirectives$1(options) {
      var dirs = options.directives;
      if (dirs) {
          for (var key in dirs) {
              var def = dirs[key];
              if (isFunction(def)) {
                  dirs[key] = { bind: def, update: def };
              }
          }
      }
  }
  function assertObjectType(name, value, vm) {
      if (!isPlainObject(value)) {
          warn$2("Invalid value for option \"".concat(name, "\": expected an Object, ") +
              "but got ".concat(toRawType(value), "."), vm);
      }
  }
  /**
   * Merge two option objects into a new one.
   * Core utility used in both instantiation and inheritance.
   */
  function mergeOptions(parent, child, vm) {
      {
          checkComponents(child);
      }
      if (isFunction(child)) {
          // @ts-expect-error
          child = child.options;
      }
      normalizeProps(child, vm);
      normalizeInject(child, vm);
      normalizeDirectives$1(child);
      // Apply extends and mixins on the child options,
      // but only if it is a raw options object that isn't
      // the result of another mergeOptions call.
      // Only merged options has the _base property.
      if (!child._base) {
          if (child.extends) {
              parent = mergeOptions(parent, child.extends, vm);
          }
          if (child.mixins) {
              for (var i = 0, l = child.mixins.length; i < l; i++) {
                  parent = mergeOptions(parent, child.mixins[i], vm);
              }
          }
      }
      var options = {};
      var key;
      for (key in parent) {
          mergeField(key);
      }
      for (key in child) {
          if (!hasOwn(parent, key)) {
              mergeField(key);
          }
      }
      function mergeField(key) {
          var strat = strats[key] || defaultStrat;
          options[key] = strat(parent[key], child[key], vm, key);
      }
      return options;
  }
  /**
   * Resolve an asset.
   * This function is used because child instances need access
   * to assets defined in its ancestor chain.
   */
  function resolveAsset(options, type, id, warnMissing) {
      /* istanbul ignore if */
      if (typeof id !== 'string') {
          return;
      }
      var assets = options[type];
      // check local registration variations first
      if (hasOwn(assets, id))
          return assets[id];
      var camelizedId = camelize(id);
      if (hasOwn(assets, camelizedId))
          return assets[camelizedId];
      var PascalCaseId = capitalize(camelizedId);
      if (hasOwn(assets, PascalCaseId))
          return assets[PascalCaseId];
      // fallback to prototype chain
      var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
      if (warnMissing && !res) {
          warn$2('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
      }
      return res;
  }

  function validateProp(key, propOptions, propsData, vm) {
      var prop = propOptions[key];
      var absent = !hasOwn(propsData, key);
      var value = propsData[key];
      // boolean casting
      var booleanIndex = getTypeIndex(Boolean, prop.type);
      if (booleanIndex > -1) {
          if (absent && !hasOwn(prop, 'default')) {
              value = false;
          }
          else if (value === '' || value === hyphenate(key)) {
              // only cast empty string / same name to boolean if
              // boolean has higher priority
              var stringIndex = getTypeIndex(String, prop.type);
              if (stringIndex < 0 || booleanIndex < stringIndex) {
                  value = true;
              }
          }
      }
      // check default value
      if (value === undefined) {
          value = getPropDefaultValue(vm, prop, key);
          // since the default value is a fresh copy,
          // make sure to observe it.
          var prevShouldObserve = shouldObserve;
          toggleObserving(true);
          observe(value);
          toggleObserving(prevShouldObserve);
      }
      {
          assertProp(prop, key, value, vm, absent);
      }
      return value;
  }
  /**
   * Get the default value of a prop.
   */
  function getPropDefaultValue(vm, prop, key) {
      // no default, return undefined
      if (!hasOwn(prop, 'default')) {
          return undefined;
      }
      var def = prop.default;
      // warn against non-factory defaults for Object & Array
      if (isObject(def)) {
          warn$2('Invalid default value for prop "' +
              key +
              '": ' +
              'Props with type Object/Array must use a factory function ' +
              'to return the default value.', vm);
      }
      // the raw prop value was also undefined from previous render,
      // return previous default value to avoid unnecessary watcher trigger
      if (vm &&
          vm.$options.propsData &&
          vm.$options.propsData[key] === undefined &&
          vm._props[key] !== undefined) {
          return vm._props[key];
      }
      // call factory function for non-Function types
      // a value is Function if its prototype is function even across different execution context
      return isFunction(def) && getType(prop.type) !== 'Function'
          ? def.call(vm)
          : def;
  }
  /**
   * Assert whether a prop is valid.
   */
  function assertProp(prop, name, value, vm, absent) {
      if (prop.required && absent) {
          warn$2('Missing required prop: "' + name + '"', vm);
          return;
      }
      if (value == null && !prop.required) {
          return;
      }
      var type = prop.type;
      var valid = !type || type === true;
      var expectedTypes = [];
      if (type) {
          if (!isArray(type)) {
              type = [type];
          }
          for (var i = 0; i < type.length && !valid; i++) {
              var assertedType = assertType(value, type[i], vm);
              expectedTypes.push(assertedType.expectedType || '');
              valid = assertedType.valid;
          }
      }
      var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
      if (!valid && haveExpectedTypes) {
          warn$2(getInvalidTypeMessage(name, value, expectedTypes), vm);
          return;
      }
      var validator = prop.validator;
      if (validator) {
          if (!validator(value)) {
              warn$2('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
          }
      }
  }
  var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
  function assertType(value, type, vm) {
      var valid;
      var expectedType = getType(type);
      if (simpleCheckRE.test(expectedType)) {
          var t = typeof value;
          valid = t === expectedType.toLowerCase();
          // for primitive wrapper objects
          if (!valid && t === 'object') {
              valid = value instanceof type;
          }
      }
      else if (expectedType === 'Object') {
          valid = isPlainObject(value);
      }
      else if (expectedType === 'Array') {
          valid = isArray(value);
      }
      else {
          try {
              valid = value instanceof type;
          }
          catch (e) {
              warn$2('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
              valid = false;
          }
      }
      return {
          valid: valid,
          expectedType: expectedType
      };
  }
  var functionTypeCheckRE = /^\s*function (\w+)/;
  /**
   * Use function string name to check built-in types,
   * because a simple equality check will fail when running
   * across different vms / iframes.
   */
  function getType(fn) {
      var match = fn && fn.toString().match(functionTypeCheckRE);
      return match ? match[1] : '';
  }
  function isSameType(a, b) {
      return getType(a) === getType(b);
  }
  function getTypeIndex(type, expectedTypes) {
      if (!isArray(expectedTypes)) {
          return isSameType(expectedTypes, type) ? 0 : -1;
      }
      for (var i = 0, len = expectedTypes.length; i < len; i++) {
          if (isSameType(expectedTypes[i], type)) {
              return i;
          }
      }
      return -1;
  }
  function getInvalidTypeMessage(name, value, expectedTypes) {
      var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") +
          " Expected ".concat(expectedTypes.map(capitalize).join(', '));
      var expectedType = expectedTypes[0];
      var receivedType = toRawType(value);
      // check if we need to specify expected value
      if (expectedTypes.length === 1 &&
          isExplicable(expectedType) &&
          isExplicable(typeof value) &&
          !isBoolean(expectedType, receivedType)) {
          message += " with value ".concat(styleValue(value, expectedType));
      }
      message += ", got ".concat(receivedType, " ");
      // check if we need to specify received value
      if (isExplicable(receivedType)) {
          message += "with value ".concat(styleValue(value, receivedType), ".");
      }
      return message;
  }
  function styleValue(value, type) {
      if (type === 'String') {
          return "\"".concat(value, "\"");
      }
      else if (type === 'Number') {
          return "".concat(Number(value));
      }
      else {
          return "".concat(value);
      }
  }
  var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
  function isExplicable(value) {
      return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; });
  }
  function isBoolean() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
      }
      return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; });
  }

  function Vue(options) {
      if (!(this instanceof Vue)) {
          warn$2('Vue is a constructor and should be called with the `new` keyword');
      }
      this._init(options);
  }
  //@ts-expect-error Vue has function type
  initMixin$1(Vue);
  //@ts-expect-error Vue has function type
  stateMixin(Vue);
  //@ts-expect-error Vue has function type
  eventsMixin(Vue);
  //@ts-expect-error Vue has function type
  lifecycleMixin(Vue);
  //@ts-expect-error Vue has function type
  renderMixin(Vue);

  function initUse(Vue) {
      Vue.use = function (plugin) {
          var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
          if (installedPlugins.indexOf(plugin) > -1) {
              return this;
          }
          // additional parameters
          var args = toArray(arguments, 1);
          args.unshift(this);
          if (isFunction(plugin.install)) {
              plugin.install.apply(plugin, args);
          }
          else if (isFunction(plugin)) {
              plugin.apply(null, args);
          }
          installedPlugins.push(plugin);
          return this;
      };
  }

  function initMixin(Vue) {
      Vue.mixin = function (mixin) {
          this.options = mergeOptions(this.options, mixin);
          return this;
      };
  }

  function initExtend(Vue) {
      /**
       * Each instance constructor, including Vue, has a unique
       * cid. This enables us to create wrapped "child
       * constructors" for prototypal inheritance and cache them.
       */
      Vue.cid = 0;
      var cid = 1;
      /**
       * Class inheritance
       */
      Vue.extend = function (extendOptions) {
          extendOptions = extendOptions || {};
          var Super = this;
          var SuperId = Super.cid;
          var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
          if (cachedCtors[SuperId]) {
              return cachedCtors[SuperId];
          }
          var name = getComponentName(extendOptions) || getComponentName(Super.options);
          if (name) {
              validateComponentName(name);
          }
          var Sub = function VueComponent(options) {
              this._init(options);
          };
          Sub.prototype = Object.create(Super.prototype);
          Sub.prototype.constructor = Sub;
          Sub.cid = cid++;
          Sub.options = mergeOptions(Super.options, extendOptions);
          Sub['super'] = Super;
          // For props and computed properties, we define the proxy getters on
          // the Vue instances at extension time, on the extended prototype. This
          // avoids Object.defineProperty calls for each instance created.
          if (Sub.options.props) {
              initProps(Sub);
          }
          if (Sub.options.computed) {
              initComputed(Sub);
          }
          // allow further extension/mixin/plugin usage
          Sub.extend = Super.extend;
          Sub.mixin = Super.mixin;
          Sub.use = Super.use;
          // create asset registers, so extended classes
          // can have their private assets too.
          ASSET_TYPES.forEach(function (type) {
              Sub[type] = Super[type];
          });
          // enable recursive self-lookup
          if (name) {
              Sub.options.components[name] = Sub;
          }
          // keep a reference to the super options at extension time.
          // later at instantiation we can check if Super's options have
          // been updated.
          Sub.superOptions = Super.options;
          Sub.extendOptions = extendOptions;
          Sub.sealedOptions = extend({}, Sub.options);
          // cache constructor
          cachedCtors[SuperId] = Sub;
          return Sub;
      };
  }
  function initProps(Comp) {
      var props = Comp.options.props;
      for (var key in props) {
          proxy(Comp.prototype, "_props", key);
      }
  }
  function initComputed(Comp) {
      var computed = Comp.options.computed;
      for (var key in computed) {
          defineComputed(Comp.prototype, key, computed[key]);
      }
  }

  function initAssetRegisters(Vue) {
      /**
       * Create asset registration methods.
       */
      ASSET_TYPES.forEach(function (type) {
          // @ts-expect-error function is not exact same type
          Vue[type] = function (id, definition) {
              if (!definition) {
                  return this.options[type + 's'][id];
              }
              else {
                  /* istanbul ignore if */
                  if (type === 'component') {
                      validateComponentName(id);
                  }
                  if (type === 'component' && isPlainObject(definition)) {
                      // @ts-expect-error
                      definition.name = definition.name || id;
                      definition = this.options._base.extend(definition);
                  }
                  if (type === 'directive' && isFunction(definition)) {
                      definition = { bind: definition, update: definition };
                  }
                  this.options[type + 's'][id] = definition;
                  return definition;
              }
          };
      });
  }

  function _getComponentName(opts) {
      return opts && (getComponentName(opts.Ctor.options) || opts.tag);
  }
  function matches(pattern, name) {
      if (isArray(pattern)) {
          return pattern.indexOf(name) > -1;
      }
      else if (typeof pattern === 'string') {
          return pattern.split(',').indexOf(name) > -1;
      }
      else if (isRegExp(pattern)) {
          return pattern.test(name);
      }
      /* istanbul ignore next */
      return false;
  }
  function pruneCache(keepAliveInstance, filter) {
      var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode, $vnode = keepAliveInstance.$vnode;
      for (var key in cache) {
          var entry = cache[key];
          if (entry) {
              var name_1 = entry.name;
              if (name_1 && !filter(name_1)) {
                  pruneCacheEntry(cache, key, keys, _vnode);
              }
          }
      }
      $vnode.componentOptions.children = undefined;
  }
  function pruneCacheEntry(cache, key, keys, current) {
      var entry = cache[key];
      if (entry && (!current || entry.tag !== current.tag)) {
          // @ts-expect-error can be undefined
          entry.componentInstance.$destroy();
      }
      cache[key] = null;
      remove$2(keys, key);
  }
  var patternTypes = [String, RegExp, Array];
  // TODO defineComponent
  var KeepAlive = {
      name: 'keep-alive',
      abstract: true,
      props: {
          include: patternTypes,
          exclude: patternTypes,
          max: [String, Number]
      },
      methods: {
          cacheVNode: function () {
              var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
              if (vnodeToCache) {
                  var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                  cache[keyToCache] = {
                      name: _getComponentName(componentOptions),
                      tag: tag,
                      componentInstance: componentInstance
                  };
                  keys.push(keyToCache);
                  // prune oldest entry
                  if (this.max && keys.length > parseInt(this.max)) {
                      pruneCacheEntry(cache, keys[0], keys, this._vnode);
                  }
                  this.vnodeToCache = null;
              }
          }
      },
      created: function () {
          this.cache = Object.create(null);
          this.keys = [];
      },
      destroyed: function () {
          for (var key in this.cache) {
              pruneCacheEntry(this.cache, key, this.keys);
          }
      },
      mounted: function () {
          var _this = this;
          this.cacheVNode();
          this.$watch('include', function (val) {
              pruneCache(_this, function (name) { return matches(val, name); });
          });
          this.$watch('exclude', function (val) {
              pruneCache(_this, function (name) { return !matches(val, name); });
          });
      },
      updated: function () {
          this.cacheVNode();
      },
      render: function () {
          var slot = this.$slots.default;
          var vnode = getFirstComponentChild(slot);
          var componentOptions = vnode && vnode.componentOptions;
          if (componentOptions) {
              // check pattern
              var name_2 = _getComponentName(componentOptions);
              var _a = this, include = _a.include, exclude = _a.exclude;
              if (
              // not included
              (include && (!name_2 || !matches(include, name_2))) ||
                  // excluded
                  (exclude && name_2 && matches(exclude, name_2))) {
                  return vnode;
              }
              var _b = this, cache = _b.cache, keys = _b.keys;
              var key = vnode.key == null
                  ? // same constructor may get registered as different local components
                      // so cid alone is not enough (#3269)
                      componentOptions.Ctor.cid +
                          (componentOptions.tag ? "::".concat(componentOptions.tag) : '')
                  : vnode.key;
              if (cache[key]) {
                  vnode.componentInstance = cache[key].componentInstance;
                  // make current key freshest
                  remove$2(keys, key);
                  keys.push(key);
              }
              else {
                  // delay setting the cache until update
                  this.vnodeToCache = vnode;
                  this.keyToCache = key;
              }
              // @ts-expect-error can vnode.data can be undefined
              vnode.data.keepAlive = true;
          }
          return vnode || (slot && slot[0]);
      }
  };

  var builtInComponents = {
      KeepAlive: KeepAlive
  };

  function initGlobalAPI(Vue) {
      // config
      var configDef = {};
      configDef.get = function () { return config; };
      {
          configDef.set = function () {
              warn$2('Do not replace the Vue.config object, set individual fields instead.');
          };
      }
      Object.defineProperty(Vue, 'config', configDef);
      // exposed util methods.
      // NOTE: these are not considered part of the public API - avoid relying on
      // them unless you are aware of the risk.
      Vue.util = {
          warn: warn$2,
          extend: extend,
          mergeOptions: mergeOptions,
          defineReactive: defineReactive
      };
      Vue.set = set;
      Vue.delete = del;
      Vue.nextTick = nextTick;
      // 2.6 explicit observable API
      Vue.observable = function (obj) {
          observe(obj);
          return obj;
      };
      Vue.options = Object.create(null);
      ASSET_TYPES.forEach(function (type) {
          Vue.options[type + 's'] = Object.create(null);
      });
      // this is used to identify the "base" constructor to extend all plain-object
      // components with in Weex's multi-instance scenarios.
      Vue.options._base = Vue;
      extend(Vue.options.components, builtInComponents);
      initUse(Vue);
      initMixin(Vue);
      initExtend(Vue);
      initAssetRegisters(Vue);
  }

  initGlobalAPI(Vue);
  Object.defineProperty(Vue.prototype, '$isServer', {
      get: isServerRendering
  });
  Object.defineProperty(Vue.prototype, '$ssrContext', {
      get: function () {
          /* istanbul ignore next */
          return this.$vnode && this.$vnode.ssrContext;
      }
  });
  // expose FunctionalRenderContext for ssr runtime helper installation
  Object.defineProperty(Vue, 'FunctionalRenderContext', {
      value: FunctionalRenderContext
  });
  Vue.version = version;

  // these are reserved for web because they are directly compiled away
  // during template compilation
  var isReservedAttr = makeMap('style,class');
  // attributes that should be using props for binding
  var acceptValue = makeMap('input,textarea,option,select,progress');
  var mustUseProp = function (tag, type, attr) {
      return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
          (attr === 'selected' && tag === 'option') ||
          (attr === 'checked' && tag === 'input') ||
          (attr === 'muted' && tag === 'video'));
  };
  var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
  var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
  var convertEnumeratedValue = function (key, value) {
      return isFalsyAttrValue(value) || value === 'false'
          ? 'false'
          : // allow arbitrary string value for contenteditable
              key === 'contenteditable' && isValidContentEditableValue(value)
                  ? value
                  : 'true';
  };
  var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
      'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
      'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
      'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
      'required,reversed,scoped,seamless,selected,sortable,' +
      'truespeed,typemustmatch,visible');
  var xlinkNS = 'http://www.w3.org/1999/xlink';
  var isXlink = function (name) {
      return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
  };
  var getXlinkProp = function (name) {
      return isXlink(name) ? name.slice(6, name.length) : '';
  };
  var isFalsyAttrValue = function (val) {
      return val == null || val === false;
  };

  function genClassForVnode(vnode) {
      var data = vnode.data;
      var parentNode = vnode;
      var childNode = vnode;
      while (isDef(childNode.componentInstance)) {
          childNode = childNode.componentInstance._vnode;
          if (childNode && childNode.data) {
              data = mergeClassData(childNode.data, data);
          }
      }
      // @ts-expect-error parentNode.parent not VNodeWithData
      while (isDef((parentNode = parentNode.parent))) {
          if (parentNode && parentNode.data) {
              data = mergeClassData(data, parentNode.data);
          }
      }
      return renderClass(data.staticClass, data.class);
  }
  function mergeClassData(child, parent) {
      return {
          staticClass: concat(child.staticClass, parent.staticClass),
          class: isDef(child.class) ? [child.class, parent.class] : parent.class
      };
  }
  function renderClass(staticClass, dynamicClass) {
      if (isDef(staticClass) || isDef(dynamicClass)) {
          return concat(staticClass, stringifyClass(dynamicClass));
      }
      /* istanbul ignore next */
      return '';
  }
  function concat(a, b) {
      return a ? (b ? a + ' ' + b : a) : b || '';
  }
  function stringifyClass(value) {
      if (Array.isArray(value)) {
          return stringifyArray(value);
      }
      if (isObject(value)) {
          return stringifyObject(value);
      }
      if (typeof value === 'string') {
          return value;
      }
      /* istanbul ignore next */
      return '';
  }
  function stringifyArray(value) {
      var res = '';
      var stringified;
      for (var i = 0, l = value.length; i < l; i++) {
          if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
              if (res)
                  res += ' ';
              res += stringified;
          }
      }
      return res;
  }
  function stringifyObject(value) {
      var res = '';
      for (var key in value) {
          if (value[key]) {
              if (res)
                  res += ' ';
              res += key;
          }
      }
      return res;
  }

  var namespaceMap = {
      svg: 'http://www.w3.org/2000/svg',
      math: 'http://www.w3.org/1998/Math/MathML'
  };
  var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
      'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
      'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
      'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
      's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
      'embed,object,param,source,canvas,script,noscript,del,ins,' +
      'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
      'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
      'output,progress,select,textarea,' +
      'details,dialog,menu,menuitem,summary,' +
      'content,element,shadow,template,blockquote,iframe,tfoot');
  // this map is intentionally selective, only covering SVG elements that may
  // contain child elements.
  var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
      'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
      'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
  var isPreTag = function (tag) { return tag === 'pre'; };
  var isReservedTag = function (tag) {
      return isHTMLTag(tag) || isSVG(tag);
  };
  function getTagNamespace(tag) {
      if (isSVG(tag)) {
          return 'svg';
      }
      // basic support for MathML
      // note it doesn't support other MathML elements being component roots
      if (tag === 'math') {
          return 'math';
      }
  }
  var unknownElementCache = Object.create(null);
  function isUnknownElement(tag) {
      /* istanbul ignore if */
      if (!inBrowser) {
          return true;
      }
      if (isReservedTag(tag)) {
          return false;
      }
      tag = tag.toLowerCase();
      /* istanbul ignore if */
      if (unknownElementCache[tag] != null) {
          return unknownElementCache[tag];
      }
      var el = document.createElement(tag);
      if (tag.indexOf('-') > -1) {
          // https://stackoverflow.com/a/28210364/1070244
          return (unknownElementCache[tag] =
              el.constructor === window.HTMLUnknownElement ||
                  el.constructor === window.HTMLElement);
      }
      else {
          return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
      }
  }
  var isTextInputType = makeMap('text,number,password,search,email,tel,url');

  /**
   * Query an element selector if it's not an element already.
   */
  function query(el) {
      if (typeof el === 'string') {
          var selected = document.querySelector(el);
          if (!selected) {
              warn$2('Cannot find element: ' + el);
              return document.createElement('div');
          }
          return selected;
      }
      else {
          return el;
      }
  }

  function createElement(tagName, vnode) {
      var elm = document.createElement(tagName);
      if (tagName !== 'select') {
          return elm;
      }
      // false or null will remove the attribute but undefined will not
      if (vnode.data &&
          vnode.data.attrs &&
          vnode.data.attrs.multiple !== undefined) {
          elm.setAttribute('multiple', 'multiple');
      }
      return elm;
  }
  function createElementNS(namespace, tagName) {
      return document.createElementNS(namespaceMap[namespace], tagName);
  }
  function createTextNode(text) {
      return document.createTextNode(text);
  }
  function createComment(text) {
      return document.createComment(text);
  }
  function insertBefore(parentNode, newNode, referenceNode) {
      parentNode.insertBefore(newNode, referenceNode);
  }
  function removeChild(node, child) {
      node.removeChild(child);
  }
  function appendChild(node, child) {
      node.appendChild(child);
  }
  function parentNode(node) {
      return node.parentNode;
  }
  function nextSibling(node) {
      return node.nextSibling;
  }
  function tagName(node) {
      return node.tagName;
  }
  function setTextContent(node, text) {
      node.textContent = text;
  }
  function setStyleScope(node, scopeId) {
      node.setAttribute(scopeId, '');
  }

  var nodeOps = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createElement: createElement,
    createElementNS: createElementNS,
    createTextNode: createTextNode,
    createComment: createComment,
    insertBefore: insertBefore,
    removeChild: removeChild,
    appendChild: appendChild,
    parentNode: parentNode,
    nextSibling: nextSibling,
    tagName: tagName,
    setTextContent: setTextContent,
    setStyleScope: setStyleScope
  });

  var ref = {
      create: function (_, vnode) {
          registerRef(vnode);
      },
      update: function (oldVnode, vnode) {
          if (oldVnode.data.ref !== vnode.data.ref) {
              registerRef(oldVnode, true);
              registerRef(vnode);
          }
      },
      destroy: function (vnode) {
          registerRef(vnode, true);
      }
  };
  function registerRef(vnode, isRemoval) {
      var ref = vnode.data.ref;
      if (!isDef(ref))
          return;
      var vm = vnode.context;
      var refValue = vnode.componentInstance || vnode.elm;
      var value = isRemoval ? null : refValue;
      var $refsValue = isRemoval ? undefined : refValue;
      if (isFunction(ref)) {
          invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
          return;
      }
      var isFor = vnode.data.refInFor;
      var _isString = typeof ref === 'string' || typeof ref === 'number';
      var _isRef = isRef(ref);
      var refs = vm.$refs;
      if (_isString || _isRef) {
          if (isFor) {
              var existing = _isString ? refs[ref] : ref.value;
              if (isRemoval) {
                  isArray(existing) && remove$2(existing, refValue);
              }
              else {
                  if (!isArray(existing)) {
                      if (_isString) {
                          refs[ref] = [refValue];
                          setSetupRef(vm, ref, refs[ref]);
                      }
                      else {
                          ref.value = [refValue];
                      }
                  }
                  else if (!existing.includes(refValue)) {
                      existing.push(refValue);
                  }
              }
          }
          else if (_isString) {
              if (isRemoval && refs[ref] !== refValue) {
                  return;
              }
              refs[ref] = $refsValue;
              setSetupRef(vm, ref, value);
          }
          else if (_isRef) {
              if (isRemoval && ref.value !== refValue) {
                  return;
              }
              ref.value = value;
          }
          else {
              warn$2("Invalid template ref type: ".concat(typeof ref));
          }
      }
  }
  function setSetupRef(_a, key, val) {
      var _setupState = _a._setupState;
      if (_setupState && hasOwn(_setupState, key)) {
          if (isRef(_setupState[key])) {
              _setupState[key].value = val;
          }
          else {
              _setupState[key] = val;
          }
      }
  }

  /**
   * Virtual DOM patching algorithm based on Snabbdom by
   * Simon Friis Vindum (@paldepind)
   * Licensed under the MIT License
   * https://github.com/paldepind/snabbdom/blob/master/LICENSE
   *
   * modified by Evan You (@yyx990803)
   *
   * Not type-checking this because this file is perf-critical and the cost
   * of making flow understand it is not worth it.
   */
  var emptyNode = new VNode('', {}, []);
  var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
  function sameVnode(a, b) {
      return (a.key === b.key &&
          a.asyncFactory === b.asyncFactory &&
          ((a.tag === b.tag &&
              a.isComment === b.isComment &&
              isDef(a.data) === isDef(b.data) &&
              sameInputType(a, b)) ||
              (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
  }
  function sameInputType(a, b) {
      if (a.tag !== 'input')
          return true;
      var i;
      var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
      var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
      return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
  }
  function createKeyToOldIdx(children, beginIdx, endIdx) {
      var i, key;
      var map = {};
      for (i = beginIdx; i <= endIdx; ++i) {
          key = children[i].key;
          if (isDef(key))
              map[key] = i;
      }
      return map;
  }
  function createPatchFunction(backend) {
      var i, j;
      var cbs = {};
      var modules = backend.modules, nodeOps = backend.nodeOps;
      for (i = 0; i < hooks.length; ++i) {
          cbs[hooks[i]] = [];
          for (j = 0; j < modules.length; ++j) {
              if (isDef(modules[j][hooks[i]])) {
                  cbs[hooks[i]].push(modules[j][hooks[i]]);
              }
          }
      }
      function emptyNodeAt(elm) {
          return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
      }
      function createRmCb(childElm, listeners) {
          function remove() {
              if (--remove.listeners === 0) {
                  removeNode(childElm);
              }
          }
          remove.listeners = listeners;
          return remove;
      }
      function removeNode(el) {
          var parent = nodeOps.parentNode(el);
          // element may have already been removed due to v-html / v-text
          if (isDef(parent)) {
              nodeOps.removeChild(parent, el);
          }
      }
      function isUnknownElement(vnode, inVPre) {
          return (!inVPre &&
              !vnode.ns &&
              !(config.ignoredElements.length &&
                  config.ignoredElements.some(function (ignore) {
                      return isRegExp(ignore)
                          ? ignore.test(vnode.tag)
                          : ignore === vnode.tag;
                  })) &&
              config.isUnknownElement(vnode.tag));
      }
      var creatingElmInVPre = 0;
      function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
          if (isDef(vnode.elm) && isDef(ownerArray)) {
              // This vnode was used in a previous render!
              // now it's used as a new node, overwriting its elm would cause
              // potential patch errors down the road when it's used as an insertion
              // reference node. Instead, we clone the node on-demand before creating
              // associated DOM element for it.
              vnode = ownerArray[index] = cloneVNode(vnode);
          }
          vnode.isRootInsert = !nested; // for transition enter check
          if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
              return;
          }
          var data = vnode.data;
          var children = vnode.children;
          var tag = vnode.tag;
          if (isDef(tag)) {
              {
                  if (data && data.pre) {
                      creatingElmInVPre++;
                  }
                  if (isUnknownElement(vnode, creatingElmInVPre)) {
                      warn$2('Unknown custom element: <' +
                          tag +
                          '> - did you ' +
                          'register the component correctly? For recursive components, ' +
                          'make sure to provide the "name" option.', vnode.context);
                  }
              }
              vnode.elm = vnode.ns
                  ? nodeOps.createElementNS(vnode.ns, tag)
                  : nodeOps.createElement(tag, vnode);
              setScope(vnode);
              createChildren(vnode, children, insertedVnodeQueue);
              if (isDef(data)) {
                  invokeCreateHooks(vnode, insertedVnodeQueue);
              }
              insert(parentElm, vnode.elm, refElm);
              if (data && data.pre) {
                  creatingElmInVPre--;
              }
          }
          else if (isTrue(vnode.isComment)) {
              vnode.elm = nodeOps.createComment(vnode.text);
              insert(parentElm, vnode.elm, refElm);
          }
          else {
              vnode.elm = nodeOps.createTextNode(vnode.text);
              insert(parentElm, vnode.elm, refElm);
          }
      }
      function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
          var i = vnode.data;
          if (isDef(i)) {
              var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
              if (isDef((i = i.hook)) && isDef((i = i.init))) {
                  i(vnode, false /* hydrating */);
              }
              // after calling the init hook, if the vnode is a child component
              // it should've created a child instance and mounted it. the child
              // component also has set the placeholder vnode's elm.
              // in that case we can just return the element and be done.
              if (isDef(vnode.componentInstance)) {
                  initComponent(vnode, insertedVnodeQueue);
                  insert(parentElm, vnode.elm, refElm);
                  if (isTrue(isReactivated)) {
                      reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                  }
                  return true;
              }
          }
      }
      function initComponent(vnode, insertedVnodeQueue) {
          if (isDef(vnode.data.pendingInsert)) {
              insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
              vnode.data.pendingInsert = null;
          }
          vnode.elm = vnode.componentInstance.$el;
          if (isPatchable(vnode)) {
              invokeCreateHooks(vnode, insertedVnodeQueue);
              setScope(vnode);
          }
          else {
              // empty component root.
              // skip all element-related modules except for ref (#3455)
              registerRef(vnode);
              // make sure to invoke the insert hook
              insertedVnodeQueue.push(vnode);
          }
      }
      function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
          var i;
          // hack for #4339: a reactivated component with inner transition
          // does not trigger because the inner node's created hooks are not called
          // again. It's not ideal to involve module-specific logic in here but
          // there doesn't seem to be a better way to do it.
          var innerNode = vnode;
          while (innerNode.componentInstance) {
              innerNode = innerNode.componentInstance._vnode;
              if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                  for (i = 0; i < cbs.activate.length; ++i) {
                      cbs.activate[i](emptyNode, innerNode);
                  }
                  insertedVnodeQueue.push(innerNode);
                  break;
              }
          }
          // unlike a newly created component,
          // a reactivated keep-alive component doesn't insert itself
          insert(parentElm, vnode.elm, refElm);
      }
      function insert(parent, elm, ref) {
          if (isDef(parent)) {
              if (isDef(ref)) {
                  if (nodeOps.parentNode(ref) === parent) {
                      nodeOps.insertBefore(parent, elm, ref);
                  }
              }
              else {
                  nodeOps.appendChild(parent, elm);
              }
          }
      }
      function createChildren(vnode, children, insertedVnodeQueue) {
          if (isArray(children)) {
              {
                  checkDuplicateKeys(children);
              }
              for (var i_1 = 0; i_1 < children.length; ++i_1) {
                  createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
              }
          }
          else if (isPrimitive(vnode.text)) {
              nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
          }
      }
      function isPatchable(vnode) {
          while (vnode.componentInstance) {
              vnode = vnode.componentInstance._vnode;
          }
          return isDef(vnode.tag);
      }
      function invokeCreateHooks(vnode, insertedVnodeQueue) {
          for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
              cbs.create[i_2](emptyNode, vnode);
          }
          i = vnode.data.hook; // Reuse variable
          if (isDef(i)) {
              if (isDef(i.create))
                  i.create(emptyNode, vnode);
              if (isDef(i.insert))
                  insertedVnodeQueue.push(vnode);
          }
      }
      // set scope id attribute for scoped CSS.
      // this is implemented as a special case to avoid the overhead
      // of going through the normal attribute patching process.
      function setScope(vnode) {
          var i;
          if (isDef((i = vnode.fnScopeId))) {
              nodeOps.setStyleScope(vnode.elm, i);
          }
          else {
              var ancestor = vnode;
              while (ancestor) {
                  if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
                      nodeOps.setStyleScope(vnode.elm, i);
                  }
                  ancestor = ancestor.parent;
              }
          }
          // for slot content they should also get the scopeId from the host instance.
          if (isDef((i = activeInstance)) &&
              i !== vnode.context &&
              i !== vnode.fnContext &&
              isDef((i = i.$options._scopeId))) {
              nodeOps.setStyleScope(vnode.elm, i);
          }
      }
      function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
          for (; startIdx <= endIdx; ++startIdx) {
              createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
          }
      }
      function invokeDestroyHook(vnode) {
          var i, j;
          var data = vnode.data;
          if (isDef(data)) {
              if (isDef((i = data.hook)) && isDef((i = i.destroy)))
                  i(vnode);
              for (i = 0; i < cbs.destroy.length; ++i)
                  cbs.destroy[i](vnode);
          }
          if (isDef((i = vnode.children))) {
              for (j = 0; j < vnode.children.length; ++j) {
                  invokeDestroyHook(vnode.children[j]);
              }
          }
      }
      function removeVnodes(vnodes, startIdx, endIdx) {
          for (; startIdx <= endIdx; ++startIdx) {
              var ch = vnodes[startIdx];
              if (isDef(ch)) {
                  if (isDef(ch.tag)) {
                      removeAndInvokeRemoveHook(ch);
                      invokeDestroyHook(ch);
                  }
                  else {
                      // Text node
                      removeNode(ch.elm);
                  }
              }
          }
      }
      function removeAndInvokeRemoveHook(vnode, rm) {
          if (isDef(rm) || isDef(vnode.data)) {
              var i_3;
              var listeners = cbs.remove.length + 1;
              if (isDef(rm)) {
                  // we have a recursively passed down rm callback
                  // increase the listeners count
                  rm.listeners += listeners;
              }
              else {
                  // directly removing
                  rm = createRmCb(vnode.elm, listeners);
              }
              // recursively invoke hooks on child component root node
              if (isDef((i_3 = vnode.componentInstance)) &&
                  isDef((i_3 = i_3._vnode)) &&
                  isDef(i_3.data)) {
                  removeAndInvokeRemoveHook(i_3, rm);
              }
              for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                  cbs.remove[i_3](vnode, rm);
              }
              if (isDef((i_3 = vnode.data.hook)) && isDef((i_3 = i_3.remove))) {
                  i_3(vnode, rm);
              }
              else {
                  rm();
              }
          }
          else {
              removeNode(vnode.elm);
          }
      }
      function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
          var oldStartIdx = 0;
          var newStartIdx = 0;
          var oldEndIdx = oldCh.length - 1;
          var oldStartVnode = oldCh[0];
          var oldEndVnode = oldCh[oldEndIdx];
          var newEndIdx = newCh.length - 1;
          var newStartVnode = newCh[0];
          var newEndVnode = newCh[newEndIdx];
          var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
          // removeOnly is a special flag used only by <transition-group>
          // to ensure removed elements stay in correct relative positions
          // during leaving transitions
          var canMove = !removeOnly;
          {
              checkDuplicateKeys(newCh);
          }
          while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
              if (isUndef(oldStartVnode)) {
                  oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
              }
              else if (isUndef(oldEndVnode)) {
                  oldEndVnode = oldCh[--oldEndIdx];
              }
              else if (sameVnode(oldStartVnode, newStartVnode)) {
                  patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                  oldStartVnode = oldCh[++oldStartIdx];
                  newStartVnode = newCh[++newStartIdx];
              }
              else if (sameVnode(oldEndVnode, newEndVnode)) {
                  patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                  oldEndVnode = oldCh[--oldEndIdx];
                  newEndVnode = newCh[--newEndIdx];
              }
              else if (sameVnode(oldStartVnode, newEndVnode)) {
                  // Vnode moved right
                  patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                  canMove &&
                      nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                  oldStartVnode = oldCh[++oldStartIdx];
                  newEndVnode = newCh[--newEndIdx];
              }
              else if (sameVnode(oldEndVnode, newStartVnode)) {
                  // Vnode moved left
                  patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                  canMove &&
                      nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                  oldEndVnode = oldCh[--oldEndIdx];
                  newStartVnode = newCh[++newStartIdx];
              }
              else {
                  if (isUndef(oldKeyToIdx))
                      oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                  idxInOld = isDef(newStartVnode.key)
                      ? oldKeyToIdx[newStartVnode.key]
                      : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                  if (isUndef(idxInOld)) {
                      // New element
                      createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                  }
                  else {
                      vnodeToMove = oldCh[idxInOld];
                      if (sameVnode(vnodeToMove, newStartVnode)) {
                          patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                          oldCh[idxInOld] = undefined;
                          canMove &&
                              nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                      }
                      else {
                          // same key but different element. treat as new element
                          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                      }
                  }
                  newStartVnode = newCh[++newStartIdx];
              }
          }
          if (oldStartIdx > oldEndIdx) {
              refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
              addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
          }
          else if (newStartIdx > newEndIdx) {
              removeVnodes(oldCh, oldStartIdx, oldEndIdx);
          }
      }
      function checkDuplicateKeys(children) {
          var seenKeys = {};
          for (var i_4 = 0; i_4 < children.length; i_4++) {
              var vnode = children[i_4];
              var key = vnode.key;
              if (isDef(key)) {
                  if (seenKeys[key]) {
                      warn$2("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                  }
                  else {
                      seenKeys[key] = true;
                  }
              }
          }
      }
      function findIdxInOld(node, oldCh, start, end) {
          for (var i_5 = start; i_5 < end; i_5++) {
              var c = oldCh[i_5];
              if (isDef(c) && sameVnode(node, c))
                  return i_5;
          }
      }
      function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
          if (oldVnode === vnode) {
              return;
          }
          if (isDef(vnode.elm) && isDef(ownerArray)) {
              // clone reused vnode
              vnode = ownerArray[index] = cloneVNode(vnode);
          }
          var elm = (vnode.elm = oldVnode.elm);
          if (isTrue(oldVnode.isAsyncPlaceholder)) {
              if (isDef(vnode.asyncFactory.resolved)) {
                  hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
              }
              else {
                  vnode.isAsyncPlaceholder = true;
              }
              return;
          }
          // reuse element for static trees.
          // note we only do this if the vnode is cloned -
          // if the new node is not cloned it means the render functions have been
          // reset by the hot-reload-api and we need to do a proper re-render.
          if (isTrue(vnode.isStatic) &&
              isTrue(oldVnode.isStatic) &&
              vnode.key === oldVnode.key &&
              (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
              vnode.componentInstance = oldVnode.componentInstance;
              return;
          }
          var i;
          var data = vnode.data;
          if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
              i(oldVnode, vnode);
          }
          var oldCh = oldVnode.children;
          var ch = vnode.children;
          if (isDef(data) && isPatchable(vnode)) {
              for (i = 0; i < cbs.update.length; ++i)
                  cbs.update[i](oldVnode, vnode);
              if (isDef((i = data.hook)) && isDef((i = i.update)))
                  i(oldVnode, vnode);
          }
          if (isUndef(vnode.text)) {
              if (isDef(oldCh) && isDef(ch)) {
                  if (oldCh !== ch)
                      updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
              }
              else if (isDef(ch)) {
                  {
                      checkDuplicateKeys(ch);
                  }
                  if (isDef(oldVnode.text))
                      nodeOps.setTextContent(elm, '');
                  addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
              }
              else if (isDef(oldCh)) {
                  removeVnodes(oldCh, 0, oldCh.length - 1);
              }
              else if (isDef(oldVnode.text)) {
                  nodeOps.setTextContent(elm, '');
              }
          }
          else if (oldVnode.text !== vnode.text) {
              nodeOps.setTextContent(elm, vnode.text);
          }
          if (isDef(data)) {
              if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                  i(oldVnode, vnode);
          }
      }
      function invokeInsertHook(vnode, queue, initial) {
          // delay insert hooks for component root nodes, invoke them after the
          // element is really inserted
          if (isTrue(initial) && isDef(vnode.parent)) {
              vnode.parent.data.pendingInsert = queue;
          }
          else {
              for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                  queue[i_6].data.hook.insert(queue[i_6]);
              }
          }
      }
      var hydrationBailed = false;
      // list of modules that can skip create hook during hydration because they
      // are already rendered on the client or has no need for initialization
      // Note: style is excluded because it relies on initial clone for future
      // deep updates (#7063).
      var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
      // Note: this is a browser-only function so we can assume elms are DOM nodes.
      function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
          var i;
          var tag = vnode.tag, data = vnode.data, children = vnode.children;
          inVPre = inVPre || (data && data.pre);
          vnode.elm = elm;
          if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
              vnode.isAsyncPlaceholder = true;
              return true;
          }
          // assert node match
          {
              if (!assertNodeMatch(elm, vnode, inVPre)) {
                  return false;
              }
          }
          if (isDef(data)) {
              if (isDef((i = data.hook)) && isDef((i = i.init)))
                  i(vnode, true /* hydrating */);
              if (isDef((i = vnode.componentInstance))) {
                  // child component. it should have hydrated its own tree.
                  initComponent(vnode, insertedVnodeQueue);
                  return true;
              }
          }
          if (isDef(tag)) {
              if (isDef(children)) {
                  // empty element, allow client to pick up and populate children
                  if (!elm.hasChildNodes()) {
                      createChildren(vnode, children, insertedVnodeQueue);
                  }
                  else {
                      // v-html and domProps: innerHTML
                      if (isDef((i = data)) &&
                          isDef((i = i.domProps)) &&
                          isDef((i = i.innerHTML))) {
                          if (i !== elm.innerHTML) {
                              /* istanbul ignore if */
                              if (typeof console !== 'undefined' &&
                                  !hydrationBailed) {
                                  hydrationBailed = true;
                                  console.warn('Parent: ', elm);
                                  console.warn('server innerHTML: ', i);
                                  console.warn('client innerHTML: ', elm.innerHTML);
                              }
                              return false;
                          }
                      }
                      else {
                          // iterate and compare children lists
                          var childrenMatch = true;
                          var childNode = elm.firstChild;
                          for (var i_7 = 0; i_7 < children.length; i_7++) {
                              if (!childNode ||
                                  !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                  childrenMatch = false;
                                  break;
                              }
                              childNode = childNode.nextSibling;
                          }
                          // if childNode is not null, it means the actual childNodes list is
                          // longer than the virtual children list.
                          if (!childrenMatch || childNode) {
                              /* istanbul ignore if */
                              if (typeof console !== 'undefined' &&
                                  !hydrationBailed) {
                                  hydrationBailed = true;
                                  console.warn('Parent: ', elm);
                                  console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                              }
                              return false;
                          }
                      }
                  }
              }
              if (isDef(data)) {
                  var fullInvoke = false;
                  for (var key in data) {
                      if (!isRenderedModule(key)) {
                          fullInvoke = true;
                          invokeCreateHooks(vnode, insertedVnodeQueue);
                          break;
                      }
                  }
                  if (!fullInvoke && data['class']) {
                      // ensure collecting deps for deep class bindings for future updates
                      traverse(data['class']);
                  }
              }
          }
          else if (elm.data !== vnode.text) {
              elm.data = vnode.text;
          }
          return true;
      }
      function assertNodeMatch(node, vnode, inVPre) {
          if (isDef(vnode.tag)) {
              return (vnode.tag.indexOf('vue-component') === 0 ||
                  (!isUnknownElement(vnode, inVPre) &&
                      vnode.tag.toLowerCase() ===
                          (node.tagName && node.tagName.toLowerCase())));
          }
          else {
              return node.nodeType === (vnode.isComment ? 8 : 3);
          }
      }
      return function patch(oldVnode, vnode, hydrating, removeOnly) {
          if (isUndef(vnode)) {
              if (isDef(oldVnode))
                  invokeDestroyHook(oldVnode);
              return;
          }
          var isInitialPatch = false;
          var insertedVnodeQueue = [];
          if (isUndef(oldVnode)) {
              // empty mount (likely as component), create new root element
              isInitialPatch = true;
              createElm(vnode, insertedVnodeQueue);
          }
          else {
              var isRealElement = isDef(oldVnode.nodeType);
              if (!isRealElement && sameVnode(oldVnode, vnode)) {
                  // patch existing root node
                  patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
              }
              else {
                  if (isRealElement) {
                      // mounting to a real element
                      // check if this is server-rendered content and if we can perform
                      // a successful hydration.
                      if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                          oldVnode.removeAttribute(SSR_ATTR);
                          hydrating = true;
                      }
                      if (isTrue(hydrating)) {
                          if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                              invokeInsertHook(vnode, insertedVnodeQueue, true);
                              return oldVnode;
                          }
                          else {
                              warn$2('The client-side rendered virtual DOM tree is not matching ' +
                                  'server-rendered content. This is likely caused by incorrect ' +
                                  'HTML markup, for example nesting block-level elements inside ' +
                                  '<p>, or missing <tbody>. Bailing hydration and performing ' +
                                  'full client-side render.');
                          }
                      }
                      // either not server-rendered, or hydration failed.
                      // create an empty node and replace it
                      oldVnode = emptyNodeAt(oldVnode);
                  }
                  // replacing existing element
                  var oldElm = oldVnode.elm;
                  var parentElm = nodeOps.parentNode(oldElm);
                  // create new node
                  createElm(vnode, insertedVnodeQueue, 
                  // extremely rare edge case: do not insert if old element is in a
                  // leaving transition. Only happens when combining transition +
                  // keep-alive + HOCs. (#4590)
                  oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                  // update parent placeholder node element, recursively
                  if (isDef(vnode.parent)) {
                      var ancestor = vnode.parent;
                      var patchable = isPatchable(vnode);
                      while (ancestor) {
                          for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                              cbs.destroy[i_8](ancestor);
                          }
                          ancestor.elm = vnode.elm;
                          if (patchable) {
                              for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                  cbs.create[i_9](emptyNode, ancestor);
                              }
                              // #6513
                              // invoke insert hooks that may have been merged by create hooks.
                              // e.g. for directives that uses the "inserted" hook.
                              var insert_1 = ancestor.data.hook.insert;
                              if (insert_1.merged) {
                                  // start at index 1 to avoid re-invoking component mounted hook
                                  // clone insert hooks to avoid being mutated during iteration.
                                  // e.g. for customed directives under transition group.
                                  var cloned = insert_1.fns.slice(1);
                                  for (var i_10 = 0; i_10 < cloned.length; i_10++) {
                                      cloned[i_10]();
                                  }
                              }
                          }
                          else {
                              registerRef(ancestor);
                          }
                          ancestor = ancestor.parent;
                      }
                  }
                  // destroy old node
                  if (isDef(parentElm)) {
                      removeVnodes([oldVnode], 0, 0);
                  }
                  else if (isDef(oldVnode.tag)) {
                      invokeDestroyHook(oldVnode);
                  }
              }
          }
          invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
          return vnode.elm;
      };
  }

  var directives$1 = {
      create: updateDirectives,
      update: updateDirectives,
      destroy: function unbindDirectives(vnode) {
          // @ts-expect-error emptyNode is not VNodeWithData
          updateDirectives(vnode, emptyNode);
      }
  };
  function updateDirectives(oldVnode, vnode) {
      if (oldVnode.data.directives || vnode.data.directives) {
          _update(oldVnode, vnode);
      }
  }
  function _update(oldVnode, vnode) {
      var isCreate = oldVnode === emptyNode;
      var isDestroy = vnode === emptyNode;
      var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
      var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
      var dirsWithInsert = [];
      var dirsWithPostpatch = [];
      var key, oldDir, dir;
      for (key in newDirs) {
          oldDir = oldDirs[key];
          dir = newDirs[key];
          if (!oldDir) {
              // new directive, bind
              callHook(dir, 'bind', vnode, oldVnode);
              if (dir.def && dir.def.inserted) {
                  dirsWithInsert.push(dir);
              }
          }
          else {
              // existing directive, update
              dir.oldValue = oldDir.value;
              dir.oldArg = oldDir.arg;
              callHook(dir, 'update', vnode, oldVnode);
              if (dir.def && dir.def.componentUpdated) {
                  dirsWithPostpatch.push(dir);
              }
          }
      }
      if (dirsWithInsert.length) {
          var callInsert = function () {
              for (var i = 0; i < dirsWithInsert.length; i++) {
                  callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
              }
          };
          if (isCreate) {
              mergeVNodeHook(vnode, 'insert', callInsert);
          }
          else {
              callInsert();
          }
      }
      if (dirsWithPostpatch.length) {
          mergeVNodeHook(vnode, 'postpatch', function () {
              for (var i = 0; i < dirsWithPostpatch.length; i++) {
                  callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
              }
          });
      }
      if (!isCreate) {
          for (key in oldDirs) {
              if (!newDirs[key]) {
                  // no longer present, unbind
                  callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
              }
          }
      }
  }
  var emptyModifiers = Object.create(null);
  function normalizeDirectives(dirs, vm) {
      var res = Object.create(null);
      if (!dirs) {
          // $flow-disable-line
          return res;
      }
      var i, dir;
      for (i = 0; i < dirs.length; i++) {
          dir = dirs[i];
          if (!dir.modifiers) {
              // $flow-disable-line
              dir.modifiers = emptyModifiers;
          }
          res[getRawDirName(dir)] = dir;
          if (vm._setupState && vm._setupState.__sfc) {
              var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
              if (typeof setupDef === 'function') {
                  dir.def = {
                      bind: setupDef,
                      update: setupDef,
                  };
              }
              else {
                  dir.def = setupDef;
              }
          }
          dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
      }
      // $flow-disable-line
      return res;
  }
  function getRawDirName(dir) {
      return (dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.')));
  }
  function callHook(dir, hook, vnode, oldVnode, isDestroy) {
      var fn = dir.def && dir.def[hook];
      if (fn) {
          try {
              fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
          }
          catch (e) {
              handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
          }
      }
  }

  var baseModules = [ref, directives$1];

  function updateAttrs(oldVnode, vnode) {
      var opts = vnode.componentOptions;
      if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
          return;
      }
      if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
          return;
      }
      var key, cur, old;
      var elm = vnode.elm;
      var oldAttrs = oldVnode.data.attrs || {};
      var attrs = vnode.data.attrs || {};
      // clone observed objects, as the user probably wants to mutate it
      if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
          attrs = vnode.data.attrs = extend({}, attrs);
      }
      for (key in attrs) {
          cur = attrs[key];
          old = oldAttrs[key];
          if (old !== cur) {
              setAttr(elm, key, cur, vnode.data.pre);
          }
      }
      // #4391: in IE9, setting type can reset value for input[type=radio]
      // #6666: IE/Edge forces progress value down to 1 before setting a max
      /* istanbul ignore if */
      if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
          setAttr(elm, 'value', attrs.value);
      }
      for (key in oldAttrs) {
          if (isUndef(attrs[key])) {
              if (isXlink(key)) {
                  elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
              }
              else if (!isEnumeratedAttr(key)) {
                  elm.removeAttribute(key);
              }
          }
      }
  }
  function setAttr(el, key, value, isInPre) {
      if (isInPre || el.tagName.indexOf('-') > -1) {
          baseSetAttr(el, key, value);
      }
      else if (isBooleanAttr(key)) {
          // set attribute for blank value
          // e.g. <option disabled>Select one</option>
          if (isFalsyAttrValue(value)) {
              el.removeAttribute(key);
          }
          else {
              // technically allowfullscreen is a boolean attribute for <iframe>,
              // but Flash expects a value of "true" when used on <embed> tag
              value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
              el.setAttribute(key, value);
          }
      }
      else if (isEnumeratedAttr(key)) {
          el.setAttribute(key, convertEnumeratedValue(key, value));
      }
      else if (isXlink(key)) {
          if (isFalsyAttrValue(value)) {
              el.removeAttributeNS(xlinkNS, getXlinkProp(key));
          }
          else {
              el.setAttributeNS(xlinkNS, key, value);
          }
      }
      else {
          baseSetAttr(el, key, value);
      }
  }
  function baseSetAttr(el, key, value) {
      if (isFalsyAttrValue(value)) {
          el.removeAttribute(key);
      }
      else {
          // #7138: IE10 & 11 fires input event when setting placeholder on
          // <textarea>... block the first input event and remove the blocker
          // immediately.
          /* istanbul ignore if */
          if (isIE &&
              !isIE9 &&
              el.tagName === 'TEXTAREA' &&
              key === 'placeholder' &&
              value !== '' &&
              !el.__ieph) {
              var blocker_1 = function (e) {
                  e.stopImmediatePropagation();
                  el.removeEventListener('input', blocker_1);
              };
              el.addEventListener('input', blocker_1);
              // $flow-disable-line
              el.__ieph = true; /* IE placeholder patched */
          }
          el.setAttribute(key, value);
      }
  }
  var attrs = {
      create: updateAttrs,
      update: updateAttrs
  };

  function updateClass(oldVnode, vnode) {
      var el = vnode.elm;
      var data = vnode.data;
      var oldData = oldVnode.data;
      if (isUndef(data.staticClass) &&
          isUndef(data.class) &&
          (isUndef(oldData) ||
              (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
          return;
      }
      var cls = genClassForVnode(vnode);
      // handle transition classes
      var transitionClass = el._transitionClasses;
      if (isDef(transitionClass)) {
          cls = concat(cls, stringifyClass(transitionClass));
      }
      // set the class
      if (cls !== el._prevClass) {
          el.setAttribute('class', cls);
          el._prevClass = cls;
      }
  }
  var klass$1 = {
      create: updateClass,
      update: updateClass
  };

  var validDivisionCharRE = /[\w).+\-_$\]]/;
  function parseFilters(exp) {
      var inSingle = false;
      var inDouble = false;
      var inTemplateString = false;
      var inRegex = false;
      var curly = 0;
      var square = 0;
      var paren = 0;
      var lastFilterIndex = 0;
      var c, prev, i, expression, filters;
      for (i = 0; i < exp.length; i++) {
          prev = c;
          c = exp.charCodeAt(i);
          if (inSingle) {
              if (c === 0x27 && prev !== 0x5c)
                  inSingle = false;
          }
          else if (inDouble) {
              if (c === 0x22 && prev !== 0x5c)
                  inDouble = false;
          }
          else if (inTemplateString) {
              if (c === 0x60 && prev !== 0x5c)
                  inTemplateString = false;
          }
          else if (inRegex) {
              if (c === 0x2f && prev !== 0x5c)
                  inRegex = false;
          }
          else if (c === 0x7c && // pipe
              exp.charCodeAt(i + 1) !== 0x7c &&
              exp.charCodeAt(i - 1) !== 0x7c &&
              !curly &&
              !square &&
              !paren) {
              if (expression === undefined) {
                  // first filter, end of expression
                  lastFilterIndex = i + 1;
                  expression = exp.slice(0, i).trim();
              }
              else {
                  pushFilter();
              }
          }
          else {
              switch (c) {
                  case 0x22:
                      inDouble = true;
                      break; // "
                  case 0x27:
                      inSingle = true;
                      break; // '
                  case 0x60:
                      inTemplateString = true;
                      break; // `
                  case 0x28:
                      paren++;
                      break; // (
                  case 0x29:
                      paren--;
                      break; // )
                  case 0x5b:
                      square++;
                      break; // [
                  case 0x5d:
                      square--;
                      break; // ]
                  case 0x7b:
                      curly++;
                      break; // {
                  case 0x7d:
                      curly--;
                      break; // }
              }
              if (c === 0x2f) {
                  // /
                  var j = i - 1;
                  var p 
                  // find first non-whitespace prev char
                  = void 0;
                  // find first non-whitespace prev char
                  for (; j >= 0; j--) {
                      p = exp.charAt(j);
                      if (p !== ' ')
                          break;
                  }
                  if (!p || !validDivisionCharRE.test(p)) {
                      inRegex = true;
                  }
              }
          }
      }
      if (expression === undefined) {
          expression = exp.slice(0, i).trim();
      }
      else if (lastFilterIndex !== 0) {
          pushFilter();
      }
      function pushFilter() {
          (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
          lastFilterIndex = i + 1;
      }
      if (filters) {
          for (i = 0; i < filters.length; i++) {
              expression = wrapFilter(expression, filters[i]);
          }
      }
      return expression;
  }
  function wrapFilter(exp, filter) {
      var i = filter.indexOf('(');
      if (i < 0) {
          // _f: resolveFilter
          return "_f(\"".concat(filter, "\")(").concat(exp, ")");
      }
      else {
          var name_1 = filter.slice(0, i);
          var args = filter.slice(i + 1);
          return "_f(\"".concat(name_1, "\")(").concat(exp).concat(args !== ')' ? ',' + args : args);
      }
  }

  /* eslint-disable no-unused-vars */
  function baseWarn(msg, range) {
      console.error("[Vue compiler]: ".concat(msg));
  }
  /* eslint-enable no-unused-vars */
  function pluckModuleFunction(modules, key) {
      return modules ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; }) : [];
  }
  function addProp(el, name, value, range, dynamic) {
      (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
      el.plain = false;
  }
  function addAttr(el, name, value, range, dynamic) {
      var attrs = dynamic
          ? el.dynamicAttrs || (el.dynamicAttrs = [])
          : el.attrs || (el.attrs = []);
      attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
      el.plain = false;
  }
  // add a raw attr (use this in preTransforms)
  function addRawAttr(el, name, value, range) {
      el.attrsMap[name] = value;
      el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
  }
  function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
      (el.directives || (el.directives = [])).push(rangeSetItem({
          name: name,
          rawName: rawName,
          value: value,
          arg: arg,
          isDynamicArg: isDynamicArg,
          modifiers: modifiers
      }, range));
      el.plain = false;
  }
  function prependModifierMarker(symbol, name, dynamic) {
      return dynamic ? "_p(".concat(name, ",\"").concat(symbol, "\")") : symbol + name; // mark the event as captured
  }
  function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
      modifiers = modifiers || emptyObject;
      // warn prevent and passive modifier
      /* istanbul ignore if */
      if (warn && modifiers.prevent && modifiers.passive) {
          warn("passive and prevent can't be used together. " +
              "Passive handler can't prevent default event.", range);
      }
      // normalize click.right and click.middle since they don't actually fire
      // this is technically browser-specific, but at least for now browsers are
      // the only target envs that have right/middle clicks.
      if (modifiers.right) {
          if (dynamic) {
              name = "(".concat(name, ")==='click'?'contextmenu':(").concat(name, ")");
          }
          else if (name === 'click') {
              name = 'contextmenu';
              delete modifiers.right;
          }
      }
      else if (modifiers.middle) {
          if (dynamic) {
              name = "(".concat(name, ")==='click'?'mouseup':(").concat(name, ")");
          }
          else if (name === 'click') {
              name = 'mouseup';
          }
      }
      // check capture modifier
      if (modifiers.capture) {
          delete modifiers.capture;
          name = prependModifierMarker('!', name, dynamic);
      }
      if (modifiers.once) {
          delete modifiers.once;
          name = prependModifierMarker('~', name, dynamic);
      }
      /* istanbul ignore if */
      if (modifiers.passive) {
          delete modifiers.passive;
          name = prependModifierMarker('&', name, dynamic);
      }
      var events;
      if (modifiers.native) {
          delete modifiers.native;
          events = el.nativeEvents || (el.nativeEvents = {});
      }
      else {
          events = el.events || (el.events = {});
      }
      var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
      if (modifiers !== emptyObject) {
          newHandler.modifiers = modifiers;
      }
      var handlers = events[name];
      /* istanbul ignore if */
      if (Array.isArray(handlers)) {
          important ? handlers.unshift(newHandler) : handlers.push(newHandler);
      }
      else if (handlers) {
          events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
      }
      else {
          events[name] = newHandler;
      }
      el.plain = false;
  }
  function getRawBindingAttr(el, name) {
      return (el.rawAttrsMap[':' + name] ||
          el.rawAttrsMap['v-bind:' + name] ||
          el.rawAttrsMap[name]);
  }
  function getBindingAttr(el, name, getStatic) {
      var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
      if (dynamicValue != null) {
          return parseFilters(dynamicValue);
      }
      else if (getStatic !== false) {
          var staticValue = getAndRemoveAttr(el, name);
          if (staticValue != null) {
              return JSON.stringify(staticValue);
          }
      }
  }
  // note: this only removes the attr from the Array (attrsList) so that it
  // doesn't get processed by processAttrs.
  // By default it does NOT remove it from the map (attrsMap) because the map is
  // needed during codegen.
  function getAndRemoveAttr(el, name, removeFromMap) {
      var val;
      if ((val = el.attrsMap[name]) != null) {
          var list = el.attrsList;
          for (var i = 0, l = list.length; i < l; i++) {
              if (list[i].name === name) {
                  list.splice(i, 1);
                  break;
              }
          }
      }
      if (removeFromMap) {
          delete el.attrsMap[name];
      }
      return val;
  }
  function getAndRemoveAttrByRegex(el, name) {
      var list = el.attrsList;
      for (var i = 0, l = list.length; i < l; i++) {
          var attr = list[i];
          if (name.test(attr.name)) {
              list.splice(i, 1);
              return attr;
          }
      }
  }
  function rangeSetItem(item, range) {
      if (range) {
          if (range.start != null) {
              item.start = range.start;
          }
          if (range.end != null) {
              item.end = range.end;
          }
      }
      return item;
  }

  /**
   * Cross-platform code generation for component v-model
   */
  function genComponentModel(el, value, modifiers) {
      var _a = modifiers || {}, number = _a.number, trim = _a.trim;
      var baseValueExpression = '$$v';
      var valueExpression = baseValueExpression;
      if (trim) {
          valueExpression =
              "(typeof ".concat(baseValueExpression, " === 'string'") +
                  "? ".concat(baseValueExpression, ".trim()") +
                  ": ".concat(baseValueExpression, ")");
      }
      if (number) {
          valueExpression = "_n(".concat(valueExpression, ")");
      }
      var assignment = genAssignmentCode(value, valueExpression);
      el.model = {
          value: "(".concat(value, ")"),
          expression: JSON.stringify(value),
          callback: "function (".concat(baseValueExpression, ") {").concat(assignment, "}")
      };
  }
  /**
   * Cross-platform codegen helper for generating v-model value assignment code.
   */
  function genAssignmentCode(value, assignment) {
      var res = parseModel(value);
      if (res.key === null) {
          return "".concat(value, "=").concat(assignment);
      }
      else {
          return "$set(".concat(res.exp, ", ").concat(res.key, ", ").concat(assignment, ")");
      }
  }
  /**
   * Parse a v-model expression into a base path and a final key segment.
   * Handles both dot-path and possible square brackets.
   *
   * Possible cases:
   *
   * - test
   * - test[key]
   * - test[test1[key]]
   * - test["a"][key]
   * - xxx.test[a[a].test1[key]]
   * - test.xxx.a["asa"][test1[key]]
   *
   */
  var len, str, chr, index, expressionPos, expressionEndPos;
  function parseModel(val) {
      // Fix https://github.com/vuejs/vue/pull/7730
      // allow v-model="obj.val " (trailing whitespace)
      val = val.trim();
      len = val.length;
      if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
          index = val.lastIndexOf('.');
          if (index > -1) {
              return {
                  exp: val.slice(0, index),
                  key: '"' + val.slice(index + 1) + '"'
              };
          }
          else {
              return {
                  exp: val,
                  key: null
              };
          }
      }
      str = val;
      index = expressionPos = expressionEndPos = 0;
      while (!eof()) {
          chr = next();
          /* istanbul ignore if */
          if (isStringStart(chr)) {
              parseString(chr);
          }
          else if (chr === 0x5b) {
              parseBracket(chr);
          }
      }
      return {
          exp: val.slice(0, expressionPos),
          key: val.slice(expressionPos + 1, expressionEndPos)
      };
  }
  function next() {
      return str.charCodeAt(++index);
  }
  function eof() {
      return index >= len;
  }
  function isStringStart(chr) {
      return chr === 0x22 || chr === 0x27;
  }
  function parseBracket(chr) {
      var inBracket = 1;
      expressionPos = index;
      while (!eof()) {
          chr = next();
          if (isStringStart(chr)) {
              parseString(chr);
              continue;
          }
          if (chr === 0x5b)
              inBracket++;
          if (chr === 0x5d)
              inBracket--;
          if (inBracket === 0) {
              expressionEndPos = index;
              break;
          }
      }
  }
  function parseString(chr) {
      var stringQuote = chr;
      while (!eof()) {
          chr = next();
          if (chr === stringQuote) {
              break;
          }
      }
  }

  var warn$1;
  // in some cases, the event used has to be determined at runtime
  // so we used some reserved tokens during compile.
  var RANGE_TOKEN = '__r';
  var CHECKBOX_RADIO_TOKEN = '__c';
  function model$1(el, dir, _warn) {
      warn$1 = _warn;
      var value = dir.value;
      var modifiers = dir.modifiers;
      var tag = el.tag;
      var type = el.attrsMap.type;
      {
          // inputs with type="file" are read only and setting the input's
          // value will throw an error.
          if (tag === 'input' && type === 'file') {
              warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\" type=\"file\">:\n") +
                  "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
          }
      }
      if (el.component) {
          genComponentModel(el, value, modifiers);
          // component v-model doesn't need extra runtime
          return false;
      }
      else if (tag === 'select') {
          genSelect(el, value, modifiers);
      }
      else if (tag === 'input' && type === 'checkbox') {
          genCheckboxModel(el, value, modifiers);
      }
      else if (tag === 'input' && type === 'radio') {
          genRadioModel(el, value, modifiers);
      }
      else if (tag === 'input' || tag === 'textarea') {
          genDefaultModel(el, value, modifiers);
      }
      else if (!config.isReservedTag(tag)) {
          genComponentModel(el, value, modifiers);
          // component v-model doesn't need extra runtime
          return false;
      }
      else {
          warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
              "v-model is not supported on this element type. " +
              "If you are working with contenteditable, it's recommended to " +
              'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
      }
      // ensure runtime directive metadata
      return true;
  }
  function genCheckboxModel(el, value, modifiers) {
      var number = modifiers && modifiers.number;
      var valueBinding = getBindingAttr(el, 'value') || 'null';
      var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
      var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
      addProp(el, 'checked', "Array.isArray(".concat(value, ")") +
          "?_i(".concat(value, ",").concat(valueBinding, ")>-1") +
          (trueValueBinding === 'true'
              ? ":(".concat(value, ")")
              : ":_q(".concat(value, ",").concat(trueValueBinding, ")")));
      addHandler(el, 'change', "var $$a=".concat(value, ",") +
          '$$el=$event.target,' +
          "$$c=$$el.checked?(".concat(trueValueBinding, "):(").concat(falseValueBinding, ");") +
          'if(Array.isArray($$a)){' +
          "var $$v=".concat(number ? '_n(' + valueBinding + ')' : valueBinding, ",") +
          '$$i=_i($$a,$$v);' +
          "if($$el.checked){$$i<0&&(".concat(genAssignmentCode(value, '$$a.concat([$$v])'), ")}") +
          "else{$$i>-1&&(".concat(genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))'), ")}") +
          "}else{".concat(genAssignmentCode(value, '$$c'), "}"), null, true);
  }
  function genRadioModel(el, value, modifiers) {
      var number = modifiers && modifiers.number;
      var valueBinding = getBindingAttr(el, 'value') || 'null';
      valueBinding = number ? "_n(".concat(valueBinding, ")") : valueBinding;
      addProp(el, 'checked', "_q(".concat(value, ",").concat(valueBinding, ")"));
      addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
  }
  function genSelect(el, value, modifiers) {
      var number = modifiers && modifiers.number;
      var selectedVal = "Array.prototype.filter" +
          ".call($event.target.options,function(o){return o.selected})" +
          ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
          "return ".concat(number ? '_n(val)' : 'val', "})");
      var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
      var code = "var $$selectedVal = ".concat(selectedVal, ";");
      code = "".concat(code, " ").concat(genAssignmentCode(value, assignment));
      addHandler(el, 'change', code, null, true);
  }
  function genDefaultModel(el, value, modifiers) {
      var type = el.attrsMap.type;
      // warn if v-bind:value conflicts with v-model
      // except for inputs with v-bind:type
      {
          var value_1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
          var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
          if (value_1 && !typeBinding) {
              var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
              warn$1("".concat(binding, "=\"").concat(value_1, "\" conflicts with v-model on the same element ") +
                  'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
          }
      }
      var _a = modifiers || {}, lazy = _a.lazy, number = _a.number, trim = _a.trim;
      var needCompositionGuard = !lazy && type !== 'range';
      var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
      var valueExpression = '$event.target.value';
      if (trim) {
          valueExpression = "$event.target.value.trim()";
      }
      if (number) {
          valueExpression = "_n(".concat(valueExpression, ")");
      }
      var code = genAssignmentCode(value, valueExpression);
      if (needCompositionGuard) {
          code = "if($event.target.composing)return;".concat(code);
      }
      addProp(el, 'value', "(".concat(value, ")"));
      addHandler(el, event, code, null, true);
      if (trim || number) {
          addHandler(el, 'blur', '$forceUpdate()');
      }
  }

  // normalize v-model event tokens that can only be determined at runtime.
  // it's important to place the event as the first in the array because
  // the whole point is ensuring the v-model callback gets called before
  // user-attached handlers.
  function normalizeEvents(on) {
      /* istanbul ignore if */
      if (isDef(on[RANGE_TOKEN])) {
          // IE input[type=range] only supports `change` event
          var event_1 = isIE ? 'change' : 'input';
          on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
          delete on[RANGE_TOKEN];
      }
      // This was originally intended to fix #4521 but no longer necessary
      // after 2.5. Keeping it for backwards compat with generated code from < 2.4
      /* istanbul ignore if */
      if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
          on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
          delete on[CHECKBOX_RADIO_TOKEN];
      }
  }
  var target;
  function createOnceHandler(event, handler, capture) {
      var _target = target; // save current target element in closure
      return function onceHandler() {
          var res = handler.apply(null, arguments);
          if (res !== null) {
              remove(event, onceHandler, capture, _target);
          }
      };
  }
  // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
  // implementation and does not fire microtasks in between event propagation, so
  // safe to exclude.
  var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
  function add(name, handler, capture, passive) {
      // async edge case #6566: inner click event triggers patch, event handler
      // attached to outer element during patch, and triggered again. This
      // happens because browsers fire microtask ticks between event propagation.
      // the solution is simple: we save the timestamp when a handler is attached,
      // and the handler would only fire if the event passed to it was fired
      // AFTER it was attached.
      if (useMicrotaskFix) {
          var attachedTimestamp_1 = currentFlushTimestamp;
          var original_1 = handler;
          //@ts-expect-error
          handler = original_1._wrapper = function (e) {
              if (
              // no bubbling, should always fire.
              // this is just a safety net in case event.timeStamp is unreliable in
              // certain weird environments...
              e.target === e.currentTarget ||
                  // event is fired after handler attachment
                  e.timeStamp >= attachedTimestamp_1 ||
                  // bail for environments that have buggy event.timeStamp implementations
                  // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                  // #9681 QtWebEngine event.timeStamp is negative value
                  e.timeStamp <= 0 ||
                  // #9448 bail if event is fired in another document in a multi-page
                  // electron/nw.js app, since event.timeStamp will be using a different
                  // starting reference
                  e.target.ownerDocument !== document) {
                  return original_1.apply(this, arguments);
              }
          };
      }
      target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
  }
  function remove(name, handler, capture, _target) {
      (_target || target).removeEventListener(name, 
      //@ts-expect-error
      handler._wrapper || handler, capture);
  }
  function updateDOMListeners(oldVnode, vnode) {
      if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
          return;
      }
      var on = vnode.data.on || {};
      var oldOn = oldVnode.data.on || {};
      // vnode is empty when removing all listeners,
      // and use old vnode dom element
      target = vnode.elm || oldVnode.elm;
      normalizeEvents(on);
      updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
      target = undefined;
  }
  var events = {
      create: updateDOMListeners,
      update: updateDOMListeners,
      // @ts-expect-error emptyNode has actually data
      destroy: function (vnode) { return updateDOMListeners(vnode, emptyNode); }
  };

  var svgContainer;
  function updateDOMProps(oldVnode, vnode) {
      if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
          return;
      }
      var key, cur;
      var elm = vnode.elm;
      var oldProps = oldVnode.data.domProps || {};
      var props = vnode.data.domProps || {};
      // clone observed objects, as the user probably wants to mutate it
      if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
          props = vnode.data.domProps = extend({}, props);
      }
      for (key in oldProps) {
          if (!(key in props)) {
              elm[key] = '';
          }
      }
      for (key in props) {
          cur = props[key];
          // ignore children if the node has textContent or innerHTML,
          // as these will throw away existing DOM nodes and cause removal errors
          // on subsequent patches (#3360)
          if (key === 'textContent' || key === 'innerHTML') {
              if (vnode.children)
                  vnode.children.length = 0;
              if (cur === oldProps[key])
                  continue;
              // #6601 work around Chrome version <= 55 bug where single textNode
              // replaced by innerHTML/textContent retains its parentNode property
              if (elm.childNodes.length === 1) {
                  elm.removeChild(elm.childNodes[0]);
              }
          }
          if (key === 'value' && elm.tagName !== 'PROGRESS') {
              // store value as _value as well since
              // non-string values will be stringified
              elm._value = cur;
              // avoid resetting cursor position when value is the same
              var strCur = isUndef(cur) ? '' : String(cur);
              if (shouldUpdateValue(elm, strCur)) {
                  elm.value = strCur;
              }
          }
          else if (key === 'innerHTML' &&
              isSVG(elm.tagName) &&
              isUndef(elm.innerHTML)) {
              // IE doesn't support innerHTML for SVG elements
              svgContainer = svgContainer || document.createElement('div');
              svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
              var svg = svgContainer.firstChild;
              while (elm.firstChild) {
                  elm.removeChild(elm.firstChild);
              }
              while (svg.firstChild) {
                  elm.appendChild(svg.firstChild);
              }
          }
          else if (
          // skip the update if old and new VDOM state is the same.
          // `value` is handled separately because the DOM value may be temporarily
          // out of sync with VDOM state due to focus, composition and modifiers.
          // This  #4521 by skipping the unnecessary `checked` update.
          cur !== oldProps[key]) {
              // some property updates can throw
              // e.g. `value` on <progress> w/ non-finite value
              try {
                  elm[key] = cur;
              }
              catch (e) { }
          }
      }
  }
  function shouldUpdateValue(elm, checkVal) {
      return (
      //@ts-expect-error
      !elm.composing &&
          (elm.tagName === 'OPTION' ||
              isNotInFocusAndDirty(elm, checkVal) ||
              isDirtyWithModifiers(elm, checkVal)));
  }
  function isNotInFocusAndDirty(elm, checkVal) {
      // return true when textbox (.number and .trim) loses focus and its value is
      // not equal to the updated value
      var notInFocus = true;
      // #6157
      // work around IE bug when accessing document.activeElement in an iframe
      try {
          notInFocus = document.activeElement !== elm;
      }
      catch (e) { }
      return notInFocus && elm.value !== checkVal;
  }
  function isDirtyWithModifiers(elm, newVal) {
      var value = elm.value;
      var modifiers = elm._vModifiers; // injected by v-model runtime
      if (isDef(modifiers)) {
          if (modifiers.number) {
              return toNumber(value) !== toNumber(newVal);
          }
          if (modifiers.trim) {
              return value.trim() !== newVal.trim();
          }
      }
      return value !== newVal;
  }
  var domProps = {
      create: updateDOMProps,
      update: updateDOMProps
  };

  var parseStyleText = cached(function (cssText) {
      var res = {};
      var listDelimiter = /;(?![^(]*\))/g;
      var propertyDelimiter = /:(.+)/;
      cssText.split(listDelimiter).forEach(function (item) {
          if (item) {
              var tmp = item.split(propertyDelimiter);
              tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
          }
      });
      return res;
  });
  // merge static and dynamic style data on the same vnode
  function normalizeStyleData(data) {
      var style = normalizeStyleBinding(data.style);
      // static style is pre-processed into an object during compilation
      // and is always a fresh object, so it's safe to merge into it
      return data.staticStyle ? extend(data.staticStyle, style) : style;
  }
  // normalize possible array / string values into Object
  function normalizeStyleBinding(bindingStyle) {
      if (Array.isArray(bindingStyle)) {
          return toObject(bindingStyle);
      }
      if (typeof bindingStyle === 'string') {
          return parseStyleText(bindingStyle);
      }
      return bindingStyle;
  }
  /**
   * parent component style should be after child's
   * so that parent component's style could override it
   */
  function getStyle(vnode, checkChild) {
      var res = {};
      var styleData;
      if (checkChild) {
          var childNode = vnode;
          while (childNode.componentInstance) {
              childNode = childNode.componentInstance._vnode;
              if (childNode &&
                  childNode.data &&
                  (styleData = normalizeStyleData(childNode.data))) {
                  extend(res, styleData);
              }
          }
      }
      if ((styleData = normalizeStyleData(vnode.data))) {
          extend(res, styleData);
      }
      var parentNode = vnode;
      // @ts-expect-error parentNode.parent not VNodeWithData
      while ((parentNode = parentNode.parent)) {
          if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
              extend(res, styleData);
          }
      }
      return res;
  }

  var cssVarRE = /^--/;
  var importantRE = /\s*!important$/;
  var setProp = function (el, name, val) {
      /* istanbul ignore if */
      if (cssVarRE.test(name)) {
          el.style.setProperty(name, val);
      }
      else if (importantRE.test(val)) {
          el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
      }
      else {
          var normalizedName = normalize(name);
          if (Array.isArray(val)) {
              // Support values array created by autoprefixer, e.g.
              // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
              // Set them one by one, and the browser will only set those it can recognize
              for (var i = 0, len = val.length; i < len; i++) {
                  el.style[normalizedName] = val[i];
              }
          }
          else {
              el.style[normalizedName] = val;
          }
      }
  };
  var vendorNames = ['Webkit', 'Moz', 'ms'];
  var emptyStyle;
  var normalize = cached(function (prop) {
      emptyStyle = emptyStyle || document.createElement('div').style;
      prop = camelize(prop);
      if (prop !== 'filter' && prop in emptyStyle) {
          return prop;
      }
      var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
      for (var i = 0; i < vendorNames.length; i++) {
          var name_1 = vendorNames[i] + capName;
          if (name_1 in emptyStyle) {
              return name_1;
          }
      }
  });
  function updateStyle(oldVnode, vnode) {
      var data = vnode.data;
      var oldData = oldVnode.data;
      if (isUndef(data.staticStyle) &&
          isUndef(data.style) &&
          isUndef(oldData.staticStyle) &&
          isUndef(oldData.style)) {
          return;
      }
      var cur, name;
      var el = vnode.elm;
      var oldStaticStyle = oldData.staticStyle;
      var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
      // if static style exists, stylebinding already merged into it when doing normalizeStyleData
      var oldStyle = oldStaticStyle || oldStyleBinding;
      var style = normalizeStyleBinding(vnode.data.style) || {};
      // store normalized style under a different key for next diff
      // make sure to clone it if it's reactive, since the user likely wants
      // to mutate it.
      vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
      var newStyle = getStyle(vnode, true);
      for (name in oldStyle) {
          if (isUndef(newStyle[name])) {
              setProp(el, name, '');
          }
      }
      for (name in newStyle) {
          cur = newStyle[name];
          // ie9 setting to null has no effect, must use empty string
          setProp(el, name, cur == null ? '' : cur);
      }
  }
  var style$1 = {
      create: updateStyle,
      update: updateStyle
  };

  var whitespaceRE$1 = /\s+/;
  /**
   * Add class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */
  function addClass(el, cls) {
      /* istanbul ignore if */
      if (!cls || !(cls = cls.trim())) {
          return;
      }
      /* istanbul ignore else */
      if (el.classList) {
          if (cls.indexOf(' ') > -1) {
              cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.add(c); });
          }
          else {
              el.classList.add(cls);
          }
      }
      else {
          var cur = " ".concat(el.getAttribute('class') || '', " ");
          if (cur.indexOf(' ' + cls + ' ') < 0) {
              el.setAttribute('class', (cur + cls).trim());
          }
      }
  }
  /**
   * Remove class with compatibility for SVG since classList is not supported on
   * SVG elements in IE
   */
  function removeClass(el, cls) {
      /* istanbul ignore if */
      if (!cls || !(cls = cls.trim())) {
          return;
      }
      /* istanbul ignore else */
      if (el.classList) {
          if (cls.indexOf(' ') > -1) {
              cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.remove(c); });
          }
          else {
              el.classList.remove(cls);
          }
          if (!el.classList.length) {
              el.removeAttribute('class');
          }
      }
      else {
          var cur = " ".concat(el.getAttribute('class') || '', " ");
          var tar = ' ' + cls + ' ';
          while (cur.indexOf(tar) >= 0) {
              cur = cur.replace(tar, ' ');
          }
          cur = cur.trim();
          if (cur) {
              el.setAttribute('class', cur);
          }
          else {
              el.removeAttribute('class');
          }
      }
  }

  function resolveTransition(def) {
      if (!def) {
          return;
      }
      /* istanbul ignore else */
      if (typeof def === 'object') {
          var res = {};
          if (def.css !== false) {
              extend(res, autoCssTransition(def.name || 'v'));
          }
          extend(res, def);
          return res;
      }
      else if (typeof def === 'string') {
          return autoCssTransition(def);
      }
  }
  var autoCssTransition = cached(function (name) {
      return {
          enterClass: "".concat(name, "-enter"),
          enterToClass: "".concat(name, "-enter-to"),
          enterActiveClass: "".concat(name, "-enter-active"),
          leaveClass: "".concat(name, "-leave"),
          leaveToClass: "".concat(name, "-leave-to"),
          leaveActiveClass: "".concat(name, "-leave-active")
      };
  });
  var hasTransition = inBrowser && !isIE9;
  var TRANSITION = 'transition';
  var ANIMATION = 'animation';
  // Transition property/event sniffing
  var transitionProp = 'transition';
  var transitionEndEvent = 'transitionend';
  var animationProp = 'animation';
  var animationEndEvent = 'animationend';
  if (hasTransition) {
      /* istanbul ignore if */
      if (window.ontransitionend === undefined &&
          window.onwebkittransitionend !== undefined) {
          transitionProp = 'WebkitTransition';
          transitionEndEvent = 'webkitTransitionEnd';
      }
      if (window.onanimationend === undefined &&
          window.onwebkitanimationend !== undefined) {
          animationProp = 'WebkitAnimation';
          animationEndEvent = 'webkitAnimationEnd';
      }
  }
  // binding to window is necessary to make hot reload work in IE in strict mode
  var raf = inBrowser
      ? window.requestAnimationFrame
          ? window.requestAnimationFrame.bind(window)
          : setTimeout
      : /* istanbul ignore next */ function (/* istanbul ignore next */ fn) { return fn(); };
  function nextFrame(fn) {
      raf(function () {
          // @ts-expect-error
          raf(fn);
      });
  }
  function addTransitionClass(el, cls) {
      var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
      if (transitionClasses.indexOf(cls) < 0) {
          transitionClasses.push(cls);
          addClass(el, cls);
      }
  }
  function removeTransitionClass(el, cls) {
      if (el._transitionClasses) {
          remove$2(el._transitionClasses, cls);
      }
      removeClass(el, cls);
  }
  function whenTransitionEnds(el, expectedType, cb) {
      var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
      if (!type)
          return cb();
      var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
      var ended = 0;
      var end = function () {
          el.removeEventListener(event, onEnd);
          cb();
      };
      var onEnd = function (e) {
          if (e.target === el) {
              if (++ended >= propCount) {
                  end();
              }
          }
      };
      setTimeout(function () {
          if (ended < propCount) {
              end();
          }
      }, timeout + 1);
      el.addEventListener(event, onEnd);
  }
  var transformRE = /\b(transform|all)(,|$)/;
  function getTransitionInfo(el, expectedType) {
      var styles = window.getComputedStyle(el);
      // JSDOM may return undefined for transition properties
      var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
      var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
      var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
      var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
      var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
      var animationTimeout = getTimeout(animationDelays, animationDurations);
      var type;
      var timeout = 0;
      var propCount = 0;
      /* istanbul ignore if */
      if (expectedType === TRANSITION) {
          if (transitionTimeout > 0) {
              type = TRANSITION;
              timeout = transitionTimeout;
              propCount = transitionDurations.length;
          }
      }
      else if (expectedType === ANIMATION) {
          if (animationTimeout > 0) {
              type = ANIMATION;
              timeout = animationTimeout;
              propCount = animationDurations.length;
          }
      }
      else {
          timeout = Math.max(transitionTimeout, animationTimeout);
          type =
              timeout > 0
                  ? transitionTimeout > animationTimeout
                      ? TRANSITION
                      : ANIMATION
                  : null;
          propCount = type
              ? type === TRANSITION
                  ? transitionDurations.length
                  : animationDurations.length
              : 0;
      }
      var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
      return {
          type: type,
          timeout: timeout,
          propCount: propCount,
          hasTransform: hasTransform
      };
  }
  function getTimeout(delays, durations) {
      /* istanbul ignore next */
      while (delays.length < durations.length) {
          delays = delays.concat(delays);
      }
      return Math.max.apply(null, durations.map(function (d, i) {
          return toMs(d) + toMs(delays[i]);
      }));
  }
  // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
  // in a locale-dependent way, using a comma instead of a dot.
  // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
  // as a floor function) causing unexpected behaviors
  function toMs(s) {
      return Number(s.slice(0, -1).replace(',', '.')) * 1000;
  }

  function enter(vnode, toggleDisplay) {
      var el = vnode.elm;
      // call leave callback now
      if (isDef(el._leaveCb)) {
          el._leaveCb.cancelled = true;
          el._leaveCb();
      }
      var data = resolveTransition(vnode.data.transition);
      if (isUndef(data)) {
          return;
      }
      /* istanbul ignore if */
      if (isDef(el._enterCb) || el.nodeType !== 1) {
          return;
      }
      var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
      // activeInstance will always be the <transition> component managing this
      // transition. One edge case to check is when the <transition> is placed
      // as the root node of a child component. In that case we need to check
      // <transition>'s parent for appear check.
      var context = activeInstance;
      var transitionNode = activeInstance.$vnode;
      while (transitionNode && transitionNode.parent) {
          context = transitionNode.context;
          transitionNode = transitionNode.parent;
      }
      var isAppear = !context._isMounted || !vnode.isRootInsert;
      if (isAppear && !appear && appear !== '') {
          return;
      }
      var startClass = isAppear && appearClass ? appearClass : enterClass;
      var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
      var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
      var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
      var enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
      var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
      var enterCancelledHook = isAppear
          ? appearCancelled || enterCancelled
          : enterCancelled;
      var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
      if (explicitEnterDuration != null) {
          checkDuration(explicitEnterDuration, 'enter', vnode);
      }
      var expectsCSS = css !== false && !isIE9;
      var userWantsControl = getHookArgumentsLength(enterHook);
      var cb = (el._enterCb = once(function () {
          if (expectsCSS) {
              removeTransitionClass(el, toClass);
              removeTransitionClass(el, activeClass);
          }
          // @ts-expect-error
          if (cb.cancelled) {
              if (expectsCSS) {
                  removeTransitionClass(el, startClass);
              }
              enterCancelledHook && enterCancelledHook(el);
          }
          else {
              afterEnterHook && afterEnterHook(el);
          }
          el._enterCb = null;
      }));
      if (!vnode.data.show) {
          // remove pending leave element on enter by injecting an insert hook
          mergeVNodeHook(vnode, 'insert', function () {
              var parent = el.parentNode;
              var pendingNode = parent && parent._pending && parent._pending[vnode.key];
              if (pendingNode &&
                  pendingNode.tag === vnode.tag &&
                  pendingNode.elm._leaveCb) {
                  pendingNode.elm._leaveCb();
              }
              enterHook && enterHook(el, cb);
          });
      }
      // start enter transition
      beforeEnterHook && beforeEnterHook(el);
      if (expectsCSS) {
          addTransitionClass(el, startClass);
          addTransitionClass(el, activeClass);
          nextFrame(function () {
              removeTransitionClass(el, startClass);
              // @ts-expect-error
              if (!cb.cancelled) {
                  addTransitionClass(el, toClass);
                  if (!userWantsControl) {
                      if (isValidDuration(explicitEnterDuration)) {
                          setTimeout(cb, explicitEnterDuration);
                      }
                      else {
                          whenTransitionEnds(el, type, cb);
                      }
                  }
              }
          });
      }
      if (vnode.data.show) {
          toggleDisplay && toggleDisplay();
          enterHook && enterHook(el, cb);
      }
      if (!expectsCSS && !userWantsControl) {
          cb();
      }
  }
  function leave(vnode, rm) {
      var el = vnode.elm;
      // call enter callback now
      if (isDef(el._enterCb)) {
          el._enterCb.cancelled = true;
          el._enterCb();
      }
      var data = resolveTransition(vnode.data.transition);
      if (isUndef(data) || el.nodeType !== 1) {
          return rm();
      }
      /* istanbul ignore if */
      if (isDef(el._leaveCb)) {
          return;
      }
      var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
      var expectsCSS = css !== false && !isIE9;
      var userWantsControl = getHookArgumentsLength(leave);
      var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
      if (isDef(explicitLeaveDuration)) {
          checkDuration(explicitLeaveDuration, 'leave', vnode);
      }
      var cb = (el._leaveCb = once(function () {
          if (el.parentNode && el.parentNode._pending) {
              el.parentNode._pending[vnode.key] = null;
          }
          if (expectsCSS) {
              removeTransitionClass(el, leaveToClass);
              removeTransitionClass(el, leaveActiveClass);
          }
          // @ts-expect-error
          if (cb.cancelled) {
              if (expectsCSS) {
                  removeTransitionClass(el, leaveClass);
              }
              leaveCancelled && leaveCancelled(el);
          }
          else {
              rm();
              afterLeave && afterLeave(el);
          }
          el._leaveCb = null;
      }));
      if (delayLeave) {
          delayLeave(performLeave);
      }
      else {
          performLeave();
      }
      function performLeave() {
          // the delayed leave may have already been cancelled
          // @ts-expect-error
          if (cb.cancelled) {
              return;
          }
          // record leaving element
          if (!vnode.data.show && el.parentNode) {
              (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
                  vnode;
          }
          beforeLeave && beforeLeave(el);
          if (expectsCSS) {
              addTransitionClass(el, leaveClass);
              addTransitionClass(el, leaveActiveClass);
              nextFrame(function () {
                  removeTransitionClass(el, leaveClass);
                  // @ts-expect-error
                  if (!cb.cancelled) {
                      addTransitionClass(el, leaveToClass);
                      if (!userWantsControl) {
                          if (isValidDuration(explicitLeaveDuration)) {
                              setTimeout(cb, explicitLeaveDuration);
                          }
                          else {
                              whenTransitionEnds(el, type, cb);
                          }
                      }
                  }
              });
          }
          leave && leave(el, cb);
          if (!expectsCSS && !userWantsControl) {
              cb();
          }
      }
  }
  // only used in dev mode
  function checkDuration(val, name, vnode) {
      if (typeof val !== 'number') {
          warn$2("<transition> explicit ".concat(name, " duration is not a valid number - ") +
              "got ".concat(JSON.stringify(val), "."), vnode.context);
      }
      else if (isNaN(val)) {
          warn$2("<transition> explicit ".concat(name, " duration is NaN - ") +
              'the duration expression might be incorrect.', vnode.context);
      }
  }
  function isValidDuration(val) {
      return typeof val === 'number' && !isNaN(val);
  }
  /**
   * Normalize a transition hook's argument length. The hook may be:
   * - a merged hook (invoker) with the original in .fns
   * - a wrapped component method (check ._length)
   * - a plain function (.length)
   */
  function getHookArgumentsLength(fn) {
      if (isUndef(fn)) {
          return false;
      }
      // @ts-expect-error
      var invokerFns = fn.fns;
      if (isDef(invokerFns)) {
          // invoker
          return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
      }
      else {
          // @ts-expect-error
          return (fn._length || fn.length) > 1;
      }
  }
  function _enter(_, vnode) {
      if (vnode.data.show !== true) {
          enter(vnode);
      }
  }
  var transition = inBrowser
      ? {
          create: _enter,
          activate: _enter,
          remove: function (vnode, rm) {
              /* istanbul ignore else */
              if (vnode.data.show !== true) {
                  // @ts-expect-error
                  leave(vnode, rm);
              }
              else {
                  rm();
              }
          }
      }
      : {};

  var platformModules = [attrs, klass$1, events, domProps, style$1, transition];

  // the directive module should be applied last, after all
  // built-in modules have been applied.
  var modules$1 = platformModules.concat(baseModules);
  var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules$1 });

  /**
   * Not type checking this file because flow doesn't like attaching
   * properties to Elements.
   */
  /* istanbul ignore if */
  if (isIE9) {
      // http://www.matts411.com/post/internet-explorer-9-oninput/
      document.addEventListener('selectionchange', function () {
          var el = document.activeElement;
          // @ts-expect-error
          if (el && el.vmodel) {
              trigger(el, 'input');
          }
      });
  }
  var directive = {
      inserted: function (el, binding, vnode, oldVnode) {
          if (vnode.tag === 'select') {
              // #6903
              if (oldVnode.elm && !oldVnode.elm._vOptions) {
                  mergeVNodeHook(vnode, 'postpatch', function () {
                      directive.componentUpdated(el, binding, vnode);
                  });
              }
              else {
                  setSelected(el, binding, vnode.context);
              }
              el._vOptions = [].map.call(el.options, getValue);
          }
          else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
              el._vModifiers = binding.modifiers;
              if (!binding.modifiers.lazy) {
                  el.addEventListener('compositionstart', onCompositionStart);
                  el.addEventListener('compositionend', onCompositionEnd);
                  // Safari < 10.2 & UIWebView doesn't fire compositionend when
                  // switching focus before confirming composition choice
                  // this also fixes the issue where some browsers e.g. iOS Chrome
                  // fires "change" instead of "input" on autocomplete.
                  el.addEventListener('change', onCompositionEnd);
                  /* istanbul ignore if */
                  if (isIE9) {
                      el.vmodel = true;
                  }
              }
          }
      },
      componentUpdated: function (el, binding, vnode) {
          if (vnode.tag === 'select') {
              setSelected(el, binding, vnode.context);
              // in case the options rendered by v-for have changed,
              // it's possible that the value is out-of-sync with the rendered options.
              // detect such cases and filter out values that no longer has a matching
              // option in the DOM.
              var prevOptions_1 = el._vOptions;
              var curOptions_1 = (el._vOptions = [].map.call(el.options, getValue));
              if (curOptions_1.some(function (o, i) { return !looseEqual(o, prevOptions_1[i]); })) {
                  // trigger change event if
                  // no matching option found for at least one value
                  var needReset = el.multiple
                      ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions_1); })
                      : binding.value !== binding.oldValue &&
                          hasNoMatchingOption(binding.value, curOptions_1);
                  if (needReset) {
                      trigger(el, 'change');
                  }
              }
          }
      }
  };
  function setSelected(el, binding, vm) {
      actuallySetSelected(el, binding, vm);
      /* istanbul ignore if */
      if (isIE || isEdge) {
          setTimeout(function () {
              actuallySetSelected(el, binding, vm);
          }, 0);
      }
  }
  function actuallySetSelected(el, binding, vm) {
      var value = binding.value;
      var isMultiple = el.multiple;
      if (isMultiple && !Array.isArray(value)) {
          warn$2("<select multiple v-model=\"".concat(binding.expression, "\"> ") +
                  "expects an Array value for its binding, but got ".concat(Object.prototype.toString
                      .call(value)
                      .slice(8, -1)), vm);
          return;
      }
      var selected, option;
      for (var i = 0, l = el.options.length; i < l; i++) {
          option = el.options[i];
          if (isMultiple) {
              selected = looseIndexOf(value, getValue(option)) > -1;
              if (option.selected !== selected) {
                  option.selected = selected;
              }
          }
          else {
              if (looseEqual(getValue(option), value)) {
                  if (el.selectedIndex !== i) {
                      el.selectedIndex = i;
                  }
                  return;
              }
          }
      }
      if (!isMultiple) {
          el.selectedIndex = -1;
      }
  }
  function hasNoMatchingOption(value, options) {
      return options.every(function (o) { return !looseEqual(o, value); });
  }
  function getValue(option) {
      return '_value' in option ? option._value : option.value;
  }
  function onCompositionStart(e) {
      e.target.composing = true;
  }
  function onCompositionEnd(e) {
      // prevent triggering an input event for no reason
      if (!e.target.composing)
          return;
      e.target.composing = false;
      trigger(e.target, 'input');
  }
  function trigger(el, type) {
      var e = document.createEvent('HTMLEvents');
      e.initEvent(type, true, true);
      el.dispatchEvent(e);
  }

  // recursively search for possible transition defined inside the component root
  function locateNode(vnode) {
      // @ts-expect-error
      return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
          ? locateNode(vnode.componentInstance._vnode)
          : vnode;
  }
  var show = {
      bind: function (el, _a, vnode) {
          var value = _a.value;
          vnode = locateNode(vnode);
          var transition = vnode.data && vnode.data.transition;
          var originalDisplay = (el.__vOriginalDisplay =
              el.style.display === 'none' ? '' : el.style.display);
          if (value && transition) {
              vnode.data.show = true;
              enter(vnode, function () {
                  el.style.display = originalDisplay;
              });
          }
          else {
              el.style.display = value ? originalDisplay : 'none';
          }
      },
      update: function (el, _a, vnode) {
          var value = _a.value, oldValue = _a.oldValue;
          /* istanbul ignore if */
          if (!value === !oldValue)
              return;
          vnode = locateNode(vnode);
          var transition = vnode.data && vnode.data.transition;
          if (transition) {
              vnode.data.show = true;
              if (value) {
                  enter(vnode, function () {
                      el.style.display = el.__vOriginalDisplay;
                  });
              }
              else {
                  leave(vnode, function () {
                      el.style.display = 'none';
                  });
              }
          }
          else {
              el.style.display = value ? el.__vOriginalDisplay : 'none';
          }
      },
      unbind: function (el, binding, vnode, oldVnode, isDestroy) {
          if (!isDestroy) {
              el.style.display = el.__vOriginalDisplay;
          }
      }
  };

  var platformDirectives = {
      model: directive,
      show: show
  };

  // Provides transition support for a single element/component.
  var transitionProps = {
      name: String,
      appear: Boolean,
      css: Boolean,
      mode: String,
      type: String,
      enterClass: String,
      leaveClass: String,
      enterToClass: String,
      leaveToClass: String,
      enterActiveClass: String,
      leaveActiveClass: String,
      appearClass: String,
      appearActiveClass: String,
      appearToClass: String,
      duration: [Number, String, Object]
  };
  // in case the child is also an abstract component, e.g. <keep-alive>
  // we want to recursively retrieve the real component to be rendered
  function getRealChild(vnode) {
      var compOptions = vnode && vnode.componentOptions;
      if (compOptions && compOptions.Ctor.options.abstract) {
          return getRealChild(getFirstComponentChild(compOptions.children));
      }
      else {
          return vnode;
      }
  }
  function extractTransitionData(comp) {
      var data = {};
      var options = comp.$options;
      // props
      for (var key in options.propsData) {
          data[key] = comp[key];
      }
      // events.
      // extract listeners and pass them directly to the transition methods
      var listeners = options._parentListeners;
      for (var key in listeners) {
          data[camelize(key)] = listeners[key];
      }
      return data;
  }
  function placeholder(h, rawChild) {
      // @ts-expect-error
      if (/\d-keep-alive$/.test(rawChild.tag)) {
          return h('keep-alive', {
              props: rawChild.componentOptions.propsData
          });
      }
  }
  function hasParentTransition(vnode) {
      while ((vnode = vnode.parent)) {
          if (vnode.data.transition) {
              return true;
          }
      }
  }
  function isSameChild(child, oldChild) {
      return oldChild.key === child.key && oldChild.tag === child.tag;
  }
  var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
  var isVShowDirective = function (d) { return d.name === 'show'; };
  var Transition = {
      name: 'transition',
      props: transitionProps,
      abstract: true,
      render: function (h) {
          var _this = this;
          var children = this.$slots.default;
          if (!children) {
              return;
          }
          // filter out text nodes (possible whitespaces)
          children = children.filter(isNotTextNode);
          /* istanbul ignore if */
          if (!children.length) {
              return;
          }
          // warn multiple elements
          if (children.length > 1) {
              warn$2('<transition> can only be used on a single element. Use ' +
                  '<transition-group> for lists.', this.$parent);
          }
          var mode = this.mode;
          // warn invalid mode
          if (mode && mode !== 'in-out' && mode !== 'out-in') {
              warn$2('invalid <transition> mode: ' + mode, this.$parent);
          }
          var rawChild = children[0];
          // if this is a component root node and the component's
          // parent container node also has transition, skip.
          if (hasParentTransition(this.$vnode)) {
              return rawChild;
          }
          // apply transition data to child
          // use getRealChild() to ignore abstract components e.g. keep-alive
          var child = getRealChild(rawChild);
          /* istanbul ignore if */
          if (!child) {
              return rawChild;
          }
          if (this._leaving) {
              return placeholder(h, rawChild);
          }
          // ensure a key that is unique to the vnode type and to this transition
          // component instance. This key will be used to remove pending leaving nodes
          // during entering.
          var id = "__transition-".concat(this._uid, "-");
          child.key =
              child.key == null
                  ? child.isComment
                      ? id + 'comment'
                      : id + child.tag
                  : isPrimitive(child.key)
                      ? String(child.key).indexOf(id) === 0
                          ? child.key
                          : id + child.key
                      : child.key;
          var data = ((child.data || (child.data = {})).transition =
              extractTransitionData(this));
          var oldRawChild = this._vnode;
          var oldChild = getRealChild(oldRawChild);
          // mark v-show
          // so that the transition module can hand over the control to the directive
          if (child.data.directives && child.data.directives.some(isVShowDirective)) {
              child.data.show = true;
          }
          if (oldChild &&
              oldChild.data &&
              !isSameChild(child, oldChild) &&
              !isAsyncPlaceholder(oldChild) &&
              // #6687 component root is a comment node
              !(oldChild.componentInstance &&
                  oldChild.componentInstance._vnode.isComment)) {
              // replace old child transition data with fresh one
              // important for dynamic transitions!
              var oldData = (oldChild.data.transition = extend({}, data));
              // handle transition mode
              if (mode === 'out-in') {
                  // return placeholder node and queue update when leave finishes
                  this._leaving = true;
                  mergeVNodeHook(oldData, 'afterLeave', function () {
                      _this._leaving = false;
                      _this.$forceUpdate();
                  });
                  return placeholder(h, rawChild);
              }
              else if (mode === 'in-out') {
                  if (isAsyncPlaceholder(child)) {
                      return oldRawChild;
                  }
                  var delayedLeave_1;
                  var performLeave = function () {
                      delayedLeave_1();
                  };
                  mergeVNodeHook(data, 'afterEnter', performLeave);
                  mergeVNodeHook(data, 'enterCancelled', performLeave);
                  mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                      delayedLeave_1 = leave;
                  });
              }
          }
          return rawChild;
      }
  };

  // Provides transition support for list items.
  var props = extend({
      tag: String,
      moveClass: String
  }, transitionProps);
  delete props.mode;
  var TransitionGroup = {
      props: props,
      beforeMount: function () {
          var _this = this;
          var update = this._update;
          this._update = function (vnode, hydrating) {
              var restoreActiveInstance = setActiveInstance(_this);
              // force removing pass
              _this.__patch__(_this._vnode, _this.kept, false, // hydrating
              true // removeOnly (!important, avoids unnecessary moves)
              );
              _this._vnode = _this.kept;
              restoreActiveInstance();
              update.call(_this, vnode, hydrating);
          };
      },
      render: function (h) {
          var tag = this.tag || this.$vnode.data.tag || 'span';
          var map = Object.create(null);
          var prevChildren = (this.prevChildren = this.children);
          var rawChildren = this.$slots.default || [];
          var children = (this.children = []);
          var transitionData = extractTransitionData(this);
          for (var i = 0; i < rawChildren.length; i++) {
              var c = rawChildren[i];
              if (c.tag) {
                  if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                      children.push(c);
                      map[c.key] = c;
                      (c.data || (c.data = {})).transition = transitionData;
                  }
                  else {
                      var opts = c.componentOptions;
                      var name_1 = opts
                          ? getComponentName(opts.Ctor.options) || opts.tag || ''
                          : c.tag;
                      warn$2("<transition-group> children must be keyed: <".concat(name_1, ">"));
                  }
              }
          }
          if (prevChildren) {
              var kept = [];
              var removed = [];
              for (var i = 0; i < prevChildren.length; i++) {
                  var c = prevChildren[i];
                  c.data.transition = transitionData;
                  // @ts-expect-error .getBoundingClientRect is not typed in Node
                  c.data.pos = c.elm.getBoundingClientRect();
                  if (map[c.key]) {
                      kept.push(c);
                  }
                  else {
                      removed.push(c);
                  }
              }
              this.kept = h(tag, null, kept);
              this.removed = removed;
          }
          return h(tag, null, children);
      },
      updated: function () {
          var children = this.prevChildren;
          var moveClass = this.moveClass || (this.name || 'v') + '-move';
          if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
              return;
          }
          // we divide the work into three loops to avoid mixing DOM reads and writes
          // in each iteration - which helps prevent layout thrashing.
          children.forEach(callPendingCbs);
          children.forEach(recordPosition);
          children.forEach(applyTranslation);
          // force reflow to put everything in position
          // assign to this to avoid being removed in tree-shaking
          // $flow-disable-line
          this._reflow = document.body.offsetHeight;
          children.forEach(function (c) {
              if (c.data.moved) {
                  var el_1 = c.elm;
                  var s = el_1.style;
                  addTransitionClass(el_1, moveClass);
                  s.transform = s.WebkitTransform = s.transitionDuration = '';
                  el_1.addEventListener(transitionEndEvent, (el_1._moveCb = function cb(e) {
                      if (e && e.target !== el_1) {
                          return;
                      }
                      if (!e || /transform$/.test(e.propertyName)) {
                          el_1.removeEventListener(transitionEndEvent, cb);
                          el_1._moveCb = null;
                          removeTransitionClass(el_1, moveClass);
                      }
                  }));
              }
          });
      },
      methods: {
          hasMove: function (el, moveClass) {
              /* istanbul ignore if */
              if (!hasTransition) {
                  return false;
              }
              /* istanbul ignore if */
              if (this._hasMove) {
                  return this._hasMove;
              }
              // Detect whether an element with the move class applied has
              // CSS transitions. Since the element may be inside an entering
              // transition at this very moment, we make a clone of it and remove
              // all other transition classes applied to ensure only the move class
              // is applied.
              var clone = el.cloneNode();
              if (el._transitionClasses) {
                  el._transitionClasses.forEach(function (cls) {
                      removeClass(clone, cls);
                  });
              }
              addClass(clone, moveClass);
              clone.style.display = 'none';
              this.$el.appendChild(clone);
              var info = getTransitionInfo(clone);
              this.$el.removeChild(clone);
              return (this._hasMove = info.hasTransform);
          }
      }
  };
  function callPendingCbs(c) {
      /* istanbul ignore if */
      if (c.elm._moveCb) {
          c.elm._moveCb();
      }
      /* istanbul ignore if */
      if (c.elm._enterCb) {
          c.elm._enterCb();
      }
  }
  function recordPosition(c) {
      c.data.newPos = c.elm.getBoundingClientRect();
  }
  function applyTranslation(c) {
      var oldPos = c.data.pos;
      var newPos = c.data.newPos;
      var dx = oldPos.left - newPos.left;
      var dy = oldPos.top - newPos.top;
      if (dx || dy) {
          c.data.moved = true;
          var s = c.elm.style;
          s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
          s.transitionDuration = '0s';
      }
  }

  var platformComponents = {
      Transition: Transition,
      TransitionGroup: TransitionGroup
  };

  // install platform specific utils
  Vue.config.mustUseProp = mustUseProp;
  Vue.config.isReservedTag = isReservedTag;
  Vue.config.isReservedAttr = isReservedAttr;
  Vue.config.getTagNamespace = getTagNamespace;
  Vue.config.isUnknownElement = isUnknownElement;
  // install platform runtime directives & components
  extend(Vue.options.directives, platformDirectives);
  extend(Vue.options.components, platformComponents);
  // install platform patch function
  Vue.prototype.__patch__ = inBrowser ? patch : noop;
  // public mount method
  Vue.prototype.$mount = function (el, hydrating) {
      el = el && inBrowser ? query(el) : undefined;
      return mountComponent(this, el, hydrating);
  };
  // devtools global hook
  /* istanbul ignore next */
  if (inBrowser) {
      setTimeout(function () {
          if (config.devtools) {
              if (devtools) {
                  devtools.emit('init', Vue);
              }
              else {
                  // @ts-expect-error
                  console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' +
                      'https://github.com/vuejs/vue-devtools');
              }
          }
          if (config.productionTip !== false &&
              typeof console !== 'undefined') {
              // @ts-expect-error
              console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" +
                  "Make sure to turn on production mode when deploying for production.\n" +
                  "See more tips at https://vuejs.org/guide/deployment.html");
          }
      }, 0);
  }

  var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
  var buildRegex = cached(function (delimiters) {
      var open = delimiters[0].replace(regexEscapeRE, '\\$&');
      var close = delimiters[1].replace(regexEscapeRE, '\\$&');
      return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
  });
  function parseText(text, delimiters) {
      //@ts-expect-error
      var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
      if (!tagRE.test(text)) {
          return;
      }
      var tokens = [];
      var rawTokens = [];
      var lastIndex = (tagRE.lastIndex = 0);
      var match, index, tokenValue;
      while ((match = tagRE.exec(text))) {
          index = match.index;
          // push text token
          if (index > lastIndex) {
              rawTokens.push((tokenValue = text.slice(lastIndex, index)));
              tokens.push(JSON.stringify(tokenValue));
          }
          // tag token
          var exp = parseFilters(match[1].trim());
          tokens.push("_s(".concat(exp, ")"));
          rawTokens.push({ '@binding': exp });
          lastIndex = index + match[0].length;
      }
      if (lastIndex < text.length) {
          rawTokens.push((tokenValue = text.slice(lastIndex)));
          tokens.push(JSON.stringify(tokenValue));
      }
      return {
          expression: tokens.join('+'),
          tokens: rawTokens
      };
  }

  function transformNode$1(el, options) {
      var warn = options.warn || baseWarn;
      var staticClass = getAndRemoveAttr(el, 'class');
      if (staticClass) {
          var res = parseText(staticClass, options.delimiters);
          if (res) {
              warn("class=\"".concat(staticClass, "\": ") +
                  'Interpolation inside attributes has been removed. ' +
                  'Use v-bind or the colon shorthand instead. For example, ' +
                  'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
          }
      }
      if (staticClass) {
          el.staticClass = JSON.stringify(staticClass.replace(/\s+/g, ' ').trim());
      }
      var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
      if (classBinding) {
          el.classBinding = classBinding;
      }
  }
  function genData$2(el) {
      var data = '';
      if (el.staticClass) {
          data += "staticClass:".concat(el.staticClass, ",");
      }
      if (el.classBinding) {
          data += "class:".concat(el.classBinding, ",");
      }
      return data;
  }
  var klass = {
      staticKeys: ['staticClass'],
      transformNode: transformNode$1,
      genData: genData$2
  };

  function transformNode(el, options) {
      var warn = options.warn || baseWarn;
      var staticStyle = getAndRemoveAttr(el, 'style');
      if (staticStyle) {
          /* istanbul ignore if */
          {
              var res = parseText(staticStyle, options.delimiters);
              if (res) {
                  warn("style=\"".concat(staticStyle, "\": ") +
                      'Interpolation inside attributes has been removed. ' +
                      'Use v-bind or the colon shorthand instead. For example, ' +
                      'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
              }
          }
          el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
      }
      var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
      if (styleBinding) {
          el.styleBinding = styleBinding;
      }
  }
  function genData$1(el) {
      var data = '';
      if (el.staticStyle) {
          data += "staticStyle:".concat(el.staticStyle, ",");
      }
      if (el.styleBinding) {
          data += "style:(".concat(el.styleBinding, "),");
      }
      return data;
  }
  var style = {
      staticKeys: ['staticStyle'],
      transformNode: transformNode,
      genData: genData$1
  };

  var decoder;
  var he = {
      decode: function (html) {
          decoder = decoder || document.createElement('div');
          decoder.innerHTML = html;
          return decoder.textContent;
      }
  };

  var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
      'link,meta,param,source,track,wbr');
  // Elements that you can, intentionally, leave open
  // (and which close themselves)
  var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');
  // HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
  // Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
  var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
      'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
      'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
      'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
      'title,tr,track');

  /**
   * Not type-checking this file because it's mostly vendor code.
   */
  // Regular Expressions for parsing tags and attributes
  var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
  var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(unicodeRegExp.source, "]*");
  var qnameCapture = "((?:".concat(ncname, "\\:)?").concat(ncname, ")");
  var startTagOpen = new RegExp("^<".concat(qnameCapture));
  var startTagClose = /^\s*(\/?)>/;
  var endTag = new RegExp("^<\\/".concat(qnameCapture, "[^>]*>"));
  var doctype = /^<!DOCTYPE [^>]+>/i;
  // #7298: escape - to avoid being passed as HTML comment when inlined in page
  var comment = /^<!\--/;
  var conditionalComment = /^<!\[/;
  // Special Elements (can contain anything)
  var isPlainTextElement = makeMap('script,style,textarea', true);
  var reCache = {};
  var decodingMap = {
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&amp;': '&',
      '&#10;': '\n',
      '&#9;': '\t',
      '&#39;': "'"
  };
  var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
  var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
  // #5992
  var isIgnoreNewlineTag = makeMap('pre,textarea', true);
  var shouldIgnoreFirstNewline = function (tag, html) {
      return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
  };
  function decodeAttr(value, shouldDecodeNewlines) {
      var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
      return value.replace(re, function (match) { return decodingMap[match]; });
  }
  function parseHTML(html, options) {
      var stack = [];
      var expectHTML = options.expectHTML;
      var isUnaryTag = options.isUnaryTag || no;
      var canBeLeftOpenTag = options.canBeLeftOpenTag || no;
      var index = 0;
      var last, lastTag;
      var _loop_1 = function () {
          last = html;
          // Make sure we're not in a plaintext content element like script/style
          if (!lastTag || !isPlainTextElement(lastTag)) {
              var textEnd = html.indexOf('<');
              if (textEnd === 0) {
                  // Comment:
                  if (comment.test(html)) {
                      var commentEnd = html.indexOf('-->');
                      if (commentEnd >= 0) {
                          if (options.shouldKeepComment && options.comment) {
                              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                          }
                          advance(commentEnd + 3);
                          return "continue";
                      }
                  }
                  // https://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                  if (conditionalComment.test(html)) {
                      var conditionalEnd = html.indexOf(']>');
                      if (conditionalEnd >= 0) {
                          advance(conditionalEnd + 2);
                          return "continue";
                      }
                  }
                  // Doctype:
                  var doctypeMatch = html.match(doctype);
                  if (doctypeMatch) {
                      advance(doctypeMatch[0].length);
                      return "continue";
                  }
                  // End tag:
                  var endTagMatch = html.match(endTag);
                  if (endTagMatch) {
                      var curIndex = index;
                      advance(endTagMatch[0].length);
                      parseEndTag(endTagMatch[1], curIndex, index);
                      return "continue";
                  }
                  // Start tag:
                  var startTagMatch = parseStartTag();
                  if (startTagMatch) {
                      handleStartTag(startTagMatch);
                      if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                          advance(1);
                      }
                      return "continue";
                  }
              }
              var text = void 0, rest = void 0, next = void 0;
              if (textEnd >= 0) {
                  rest = html.slice(textEnd);
                  while (!endTag.test(rest) &&
                      !startTagOpen.test(rest) &&
                      !comment.test(rest) &&
                      !conditionalComment.test(rest)) {
                      // < in plain text, be forgiving and treat it as text
                      next = rest.indexOf('<', 1);
                      if (next < 0)
                          break;
                      textEnd += next;
                      rest = html.slice(textEnd);
                  }
                  text = html.substring(0, textEnd);
              }
              if (textEnd < 0) {
                  text = html;
              }
              if (text) {
                  advance(text.length);
              }
              if (options.chars && text) {
                  options.chars(text, index - text.length, index);
              }
          }
          else {
              var endTagLength_1 = 0;
              var stackedTag_1 = lastTag.toLowerCase();
              var reStackedTag = reCache[stackedTag_1] ||
                  (reCache[stackedTag_1] = new RegExp('([\\s\\S]*?)(</' + stackedTag_1 + '[^>]*>)', 'i'));
              var rest = html.replace(reStackedTag, function (all, text, endTag) {
                  endTagLength_1 = endTag.length;
                  if (!isPlainTextElement(stackedTag_1) && stackedTag_1 !== 'noscript') {
                      text = text
                          .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                          .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
                  }
                  if (shouldIgnoreFirstNewline(stackedTag_1, text)) {
                      text = text.slice(1);
                  }
                  if (options.chars) {
                      options.chars(text);
                  }
                  return '';
              });
              index += html.length - rest.length;
              html = rest;
              parseEndTag(stackedTag_1, index - endTagLength_1, index);
          }
          if (html === last) {
              options.chars && options.chars(html);
              if (!stack.length && options.warn) {
                  options.warn("Mal-formatted tag at end of template: \"".concat(html, "\""), {
                      start: index + html.length
                  });
              }
              return "break";
          }
      };
      while (html) {
          var state_1 = _loop_1();
          if (state_1 === "break")
              break;
      }
      // Clean up any remaining tags
      parseEndTag();
      function advance(n) {
          index += n;
          html = html.substring(n);
      }
      function parseStartTag() {
          var start = html.match(startTagOpen);
          if (start) {
              var match = {
                  tagName: start[1],
                  attrs: [],
                  start: index
              };
              advance(start[0].length);
              var end = void 0, attr = void 0;
              while (!(end = html.match(startTagClose)) &&
                  (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
                  attr.start = index;
                  advance(attr[0].length);
                  attr.end = index;
                  match.attrs.push(attr);
              }
              if (end) {
                  match.unarySlash = end[1];
                  advance(end[0].length);
                  match.end = index;
                  return match;
              }
          }
      }
      function handleStartTag(match) {
          var tagName = match.tagName;
          var unarySlash = match.unarySlash;
          if (expectHTML) {
              if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
                  parseEndTag(lastTag);
              }
              if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
                  parseEndTag(tagName);
              }
          }
          var unary = isUnaryTag(tagName) || !!unarySlash;
          var l = match.attrs.length;
          var attrs = new Array(l);
          for (var i = 0; i < l; i++) {
              var args = match.attrs[i];
              var value = args[3] || args[4] || args[5] || '';
              var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
                  ? options.shouldDecodeNewlinesForHref
                  : options.shouldDecodeNewlines;
              attrs[i] = {
                  name: args[1],
                  value: decodeAttr(value, shouldDecodeNewlines)
              };
              if (options.outputSourceRange) {
                  attrs[i].start = args.start + args[0].match(/^\s*/).length;
                  attrs[i].end = args.end;
              }
          }
          if (!unary) {
              stack.push({
                  tag: tagName,
                  lowerCasedTag: tagName.toLowerCase(),
                  attrs: attrs,
                  start: match.start,
                  end: match.end
              });
              lastTag = tagName;
          }
          if (options.start) {
              options.start(tagName, attrs, unary, match.start, match.end);
          }
      }
      function parseEndTag(tagName, start, end) {
          var pos, lowerCasedTagName;
          if (start == null)
              start = index;
          if (end == null)
              end = index;
          // Find the closest opened tag of the same type
          if (tagName) {
              lowerCasedTagName = tagName.toLowerCase();
              for (pos = stack.length - 1; pos >= 0; pos--) {
                  if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                      break;
                  }
              }
          }
          else {
              // If no tag name is provided, clean shop
              pos = 0;
          }
          if (pos >= 0) {
              // Close all the open elements, up the stack
              for (var i = stack.length - 1; i >= pos; i--) {
                  if ((i > pos || !tagName) && options.warn) {
                      options.warn("tag <".concat(stack[i].tag, "> has no matching end tag."), {
                          start: stack[i].start,
                          end: stack[i].end
                      });
                  }
                  if (options.end) {
                      options.end(stack[i].tag, start, end);
                  }
              }
              // Remove the open elements from the stack
              stack.length = pos;
              lastTag = pos && stack[pos - 1].tag;
          }
          else if (lowerCasedTagName === 'br') {
              if (options.start) {
                  options.start(tagName, [], true, start, end);
              }
          }
          else if (lowerCasedTagName === 'p') {
              if (options.start) {
                  options.start(tagName, [], false, start, end);
              }
              if (options.end) {
                  options.end(tagName, start, end);
              }
          }
      }
  }

  var onRE = /^@|^v-on:/;
  var dirRE = /^v-|^@|^:|^#/;
  var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
  var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  var stripParensRE = /^\(|\)$/g;
  var dynamicArgRE = /^\[.*\]$/;
  var argRE = /:(.*)$/;
  var bindRE = /^:|^\.|^v-bind:/;
  var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
  var slotRE = /^v-slot(:|$)|^#/;
  var lineBreakRE = /[\r\n]/;
  var whitespaceRE = /[ \f\t\r\n]+/g;
  var invalidAttributeRE = /[\s"'<>\/=]/;
  var decodeHTMLCached = cached(he.decode);
  var emptySlotScopeToken = "_empty_";
  // configurable state
  var warn;
  var delimiters;
  var transforms;
  var preTransforms;
  var postTransforms;
  var platformIsPreTag;
  var platformMustUseProp;
  var platformGetTagNamespace;
  var maybeComponent;
  function createASTElement(tag, attrs, parent) {
      return {
          type: 1,
          tag: tag,
          attrsList: attrs,
          attrsMap: makeAttrsMap(attrs),
          rawAttrsMap: {},
          parent: parent,
          children: []
      };
  }
  /**
   * Convert HTML string to AST.
   */
  function parse(template, options) {
      warn = options.warn || baseWarn;
      platformIsPreTag = options.isPreTag || no;
      platformMustUseProp = options.mustUseProp || no;
      platformGetTagNamespace = options.getTagNamespace || no;
      var isReservedTag = options.isReservedTag || no;
      maybeComponent = function (el) {
          return !!(el.component ||
              el.attrsMap[':is'] ||
              el.attrsMap['v-bind:is'] ||
              !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
      };
      transforms = pluckModuleFunction(options.modules, 'transformNode');
      preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
      postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
      delimiters = options.delimiters;
      var stack = [];
      var preserveWhitespace = options.preserveWhitespace !== false;
      var whitespaceOption = options.whitespace;
      var root;
      var currentParent;
      var inVPre = false;
      var inPre = false;
      var warned = false;
      function warnOnce(msg, range) {
          if (!warned) {
              warned = true;
              warn(msg, range);
          }
      }
      function closeElement(element) {
          trimEndingWhitespace(element);
          if (!inVPre && !element.processed) {
              element = processElement(element, options);
          }
          // tree management
          if (!stack.length && element !== root) {
              // allow root elements with v-if, v-else-if and v-else
              if (root.if && (element.elseif || element.else)) {
                  {
                      checkRootConstraints(element);
                  }
                  addIfCondition(root, {
                      exp: element.elseif,
                      block: element
                  });
              }
              else {
                  warnOnce("Component template should contain exactly one root element. " +
                      "If you are using v-if on multiple elements, " +
                      "use v-else-if to chain them instead.", { start: element.start });
              }
          }
          if (currentParent && !element.forbidden) {
              if (element.elseif || element.else) {
                  processIfConditions(element, currentParent);
              }
              else {
                  if (element.slotScope) {
                      // scoped slot
                      // keep it in the children list so that v-else(-if) conditions can
                      // find it as the prev node.
                      var name_1 = element.slotTarget || '"default"';
                      (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name_1] = element;
                  }
                  currentParent.children.push(element);
                  element.parent = currentParent;
              }
          }
          // final children cleanup
          // filter out scoped slots
          element.children = element.children.filter(function (c) { return !c.slotScope; });
          // remove trailing whitespace node again
          trimEndingWhitespace(element);
          // check pre state
          if (element.pre) {
              inVPre = false;
          }
          if (platformIsPreTag(element.tag)) {
              inPre = false;
          }
          // apply post-transforms
          for (var i = 0; i < postTransforms.length; i++) {
              postTransforms[i](element, options);
          }
      }
      function trimEndingWhitespace(el) {
          // remove trailing whitespace node
          if (!inPre) {
              var lastNode = void 0;
              while ((lastNode = el.children[el.children.length - 1]) &&
                  lastNode.type === 3 &&
                  lastNode.text === ' ') {
                  el.children.pop();
              }
          }
      }
      function checkRootConstraints(el) {
          if (el.tag === 'slot' || el.tag === 'template') {
              warnOnce("Cannot use <".concat(el.tag, "> as component root element because it may ") +
                  'contain multiple nodes.', { start: el.start });
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
              warnOnce('Cannot use v-for on stateful component root element because ' +
                  'it renders multiple elements.', el.rawAttrsMap['v-for']);
          }
      }
      parseHTML(template, {
          warn: warn,
          expectHTML: options.expectHTML,
          isUnaryTag: options.isUnaryTag,
          canBeLeftOpenTag: options.canBeLeftOpenTag,
          shouldDecodeNewlines: options.shouldDecodeNewlines,
          shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
          shouldKeepComment: options.comments,
          outputSourceRange: options.outputSourceRange,
          start: function (tag, attrs, unary, start, end) {
              // check namespace.
              // inherit parent ns if there is one
              var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
              // handle IE svg bug
              /* istanbul ignore if */
              if (isIE && ns === 'svg') {
                  attrs = guardIESVGBug(attrs);
              }
              var element = createASTElement(tag, attrs, currentParent);
              if (ns) {
                  element.ns = ns;
              }
              {
                  if (options.outputSourceRange) {
                      element.start = start;
                      element.end = end;
                      element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
                          cumulated[attr.name] = attr;
                          return cumulated;
                      }, {});
                  }
                  attrs.forEach(function (attr) {
                      if (invalidAttributeRE.test(attr.name)) {
                          warn("Invalid dynamic argument expression: attribute names cannot contain " +
                              "spaces, quotes, <, >, / or =.", options.outputSourceRange
                              ? {
                                  start: attr.start + attr.name.indexOf("["),
                                  end: attr.start + attr.name.length
                              }
                              : undefined);
                      }
                  });
              }
              if (isForbiddenTag(element) && !isServerRendering()) {
                  element.forbidden = true;
                  warn('Templates should only be responsible for mapping the state to the ' +
                          'UI. Avoid placing tags with side-effects in your templates, such as ' +
                          "<".concat(tag, ">") +
                          ', as they will not be parsed.', { start: element.start });
              }
              // apply pre-transforms
              for (var i = 0; i < preTransforms.length; i++) {
                  element = preTransforms[i](element, options) || element;
              }
              if (!inVPre) {
                  processPre(element);
                  if (element.pre) {
                      inVPre = true;
                  }
              }
              if (platformIsPreTag(element.tag)) {
                  inPre = true;
              }
              if (inVPre) {
                  processRawAttrs(element);
              }
              else if (!element.processed) {
                  // structural directives
                  processFor(element);
                  processIf(element);
                  processOnce(element);
              }
              if (!root) {
                  root = element;
                  {
                      checkRootConstraints(root);
                  }
              }
              if (!unary) {
                  currentParent = element;
                  stack.push(element);
              }
              else {
                  closeElement(element);
              }
          },
          end: function (tag, start, end) {
              var element = stack[stack.length - 1];
              // pop stack
              stack.length -= 1;
              currentParent = stack[stack.length - 1];
              if (options.outputSourceRange) {
                  element.end = end;
              }
              closeElement(element);
          },
          chars: function (text, start, end) {
              if (!currentParent) {
                  {
                      if (text === template) {
                          warnOnce('Component template requires a root element, rather than just text.', { start: start });
                      }
                      else if ((text = text.trim())) {
                          warnOnce("text \"".concat(text, "\" outside root element will be ignored."), {
                              start: start
                          });
                      }
                  }
                  return;
              }
              // IE textarea placeholder bug
              /* istanbul ignore if */
              if (isIE &&
                  currentParent.tag === 'textarea' &&
                  currentParent.attrsMap.placeholder === text) {
                  return;
              }
              var children = currentParent.children;
              if (inPre || text.trim()) {
                  text = isTextTag(currentParent)
                      ? text
                      : decodeHTMLCached(text);
              }
              else if (!children.length) {
                  // remove the whitespace-only node right after an opening tag
                  text = '';
              }
              else if (whitespaceOption) {
                  if (whitespaceOption === 'condense') {
                      // in condense mode, remove the whitespace node if it contains
                      // line break, otherwise condense to a single space
                      text = lineBreakRE.test(text) ? '' : ' ';
                  }
                  else {
                      text = ' ';
                  }
              }
              else {
                  text = preserveWhitespace ? ' ' : '';
              }
              if (text) {
                  if (!inPre && whitespaceOption === 'condense') {
                      // condense consecutive whitespaces into single space
                      text = text.replace(whitespaceRE, ' ');
                  }
                  var res = void 0;
                  var child = void 0;
                  if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
                      child = {
                          type: 2,
                          expression: res.expression,
                          tokens: res.tokens,
                          text: text
                      };
                  }
                  else if (text !== ' ' ||
                      !children.length ||
                      children[children.length - 1].text !== ' ') {
                      child = {
                          type: 3,
                          text: text
                      };
                  }
                  if (child) {
                      if (options.outputSourceRange) {
                          child.start = start;
                          child.end = end;
                      }
                      children.push(child);
                  }
              }
          },
          comment: function (text, start, end) {
              // adding anything as a sibling to the root node is forbidden
              // comments should still be allowed, but ignored
              if (currentParent) {
                  var child = {
                      type: 3,
                      text: text,
                      isComment: true
                  };
                  if (options.outputSourceRange) {
                      child.start = start;
                      child.end = end;
                  }
                  currentParent.children.push(child);
              }
          }
      });
      return root;
  }
  function processPre(el) {
      if (getAndRemoveAttr(el, 'v-pre') != null) {
          el.pre = true;
      }
  }
  function processRawAttrs(el) {
      var list = el.attrsList;
      var len = list.length;
      if (len) {
          var attrs = (el.attrs = new Array(len));
          for (var i = 0; i < len; i++) {
              attrs[i] = {
                  name: list[i].name,
                  value: JSON.stringify(list[i].value)
              };
              if (list[i].start != null) {
                  attrs[i].start = list[i].start;
                  attrs[i].end = list[i].end;
              }
          }
      }
      else if (!el.pre) {
          // non root node in pre blocks with no attributes
          el.plain = true;
      }
  }
  function processElement(element, options) {
      processKey(element);
      // determine whether this is a plain element after
      // removing structural attributes
      element.plain =
          !element.key && !element.scopedSlots && !element.attrsList.length;
      processRef(element);
      processSlotContent(element);
      processSlotOutlet(element);
      processComponent(element);
      for (var i = 0; i < transforms.length; i++) {
          element = transforms[i](element, options) || element;
      }
      processAttrs(element);
      return element;
  }
  function processKey(el) {
      var exp = getBindingAttr(el, 'key');
      if (exp) {
          {
              if (el.tag === 'template') {
                  warn("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
              }
              if (el.for) {
                  var iterator = el.iterator2 || el.iterator1;
                  var parent_1 = el.parent;
                  if (iterator &&
                      iterator === exp &&
                      parent_1 &&
                      parent_1.tag === 'transition-group') {
                      warn("Do not use v-for index as key on <transition-group> children, " +
                          "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true /* tip */);
                  }
              }
          }
          el.key = exp;
      }
  }
  function processRef(el) {
      var ref = getBindingAttr(el, 'ref');
      if (ref) {
          el.ref = ref;
          el.refInFor = checkInFor(el);
      }
  }
  function processFor(el) {
      var exp;
      if ((exp = getAndRemoveAttr(el, 'v-for'))) {
          var res = parseFor(exp);
          if (res) {
              extend(el, res);
          }
          else {
              warn("Invalid v-for expression: ".concat(exp), el.rawAttrsMap['v-for']);
          }
      }
  }
  function parseFor(exp) {
      var inMatch = exp.match(forAliasRE);
      if (!inMatch)
          return;
      var res = {};
      res.for = inMatch[2].trim();
      var alias = inMatch[1].trim().replace(stripParensRE, '');
      var iteratorMatch = alias.match(forIteratorRE);
      if (iteratorMatch) {
          res.alias = alias.replace(forIteratorRE, '').trim();
          res.iterator1 = iteratorMatch[1].trim();
          if (iteratorMatch[2]) {
              res.iterator2 = iteratorMatch[2].trim();
          }
      }
      else {
          res.alias = alias;
      }
      return res;
  }
  function processIf(el) {
      var exp = getAndRemoveAttr(el, 'v-if');
      if (exp) {
          el.if = exp;
          addIfCondition(el, {
              exp: exp,
              block: el
          });
      }
      else {
          if (getAndRemoveAttr(el, 'v-else') != null) {
              el.else = true;
          }
          var elseif = getAndRemoveAttr(el, 'v-else-if');
          if (elseif) {
              el.elseif = elseif;
          }
      }
  }
  function processIfConditions(el, parent) {
      var prev = findPrevElement(parent.children);
      if (prev && prev.if) {
          addIfCondition(prev, {
              exp: el.elseif,
              block: el
          });
      }
      else {
          warn("v-".concat(el.elseif ? 'else-if="' + el.elseif + '"' : 'else', " ") +
              "used on element <".concat(el.tag, "> without corresponding v-if."), el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
      }
  }
  function findPrevElement(children) {
      var i = children.length;
      while (i--) {
          if (children[i].type === 1) {
              return children[i];
          }
          else {
              if (children[i].text !== ' ') {
                  warn("text \"".concat(children[i].text.trim(), "\" between v-if and v-else(-if) ") +
                      "will be ignored.", children[i]);
              }
              children.pop();
          }
      }
  }
  function addIfCondition(el, condition) {
      if (!el.ifConditions) {
          el.ifConditions = [];
      }
      el.ifConditions.push(condition);
  }
  function processOnce(el) {
      var once = getAndRemoveAttr(el, 'v-once');
      if (once != null) {
          el.once = true;
      }
  }
  // handle content being passed to a component as slot,
  // e.g. <template slot="xxx">, <div slot-scope="xxx">
  function processSlotContent(el) {
      var slotScope;
      if (el.tag === 'template') {
          slotScope = getAndRemoveAttr(el, 'scope');
          /* istanbul ignore if */
          if (slotScope) {
              warn("the \"scope\" attribute for scoped slots have been deprecated and " +
                  "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
                  "can also be used on plain elements in addition to <template> to " +
                  "denote scoped slots.", el.rawAttrsMap['scope'], true);
          }
          el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
      }
      else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
          /* istanbul ignore if */
          if (el.attrsMap['v-for']) {
              warn("Ambiguous combined usage of slot-scope and v-for on <".concat(el.tag, "> ") +
                  "(v-for takes higher priority). Use a wrapper <template> for the " +
                  "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
          }
          el.slotScope = slotScope;
      }
      // slot="xxx"
      var slotTarget = getBindingAttr(el, 'slot');
      if (slotTarget) {
          el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
          el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
          // preserve slot as an attribute for native shadow DOM compat
          // only for non-scoped slots.
          if (el.tag !== 'template' && !el.slotScope) {
              addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
          }
      }
      // 2.6 v-slot syntax
      {
          if (el.tag === 'template') {
              // v-slot on <template>
              var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
              if (slotBinding) {
                  {
                      if (el.slotTarget || el.slotScope) {
                          warn("Unexpected mixed usage of different slot syntaxes.", el);
                      }
                      if (el.parent && !maybeComponent(el.parent)) {
                          warn("<template v-slot> can only appear at the root level inside " +
                              "the receiving component", el);
                      }
                  }
                  var _a = getSlotName(slotBinding), name_2 = _a.name, dynamic = _a.dynamic;
                  el.slotTarget = name_2;
                  el.slotTargetDynamic = dynamic;
                  el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
              }
          }
          else {
              // v-slot on component, denotes default slot
              var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
              if (slotBinding) {
                  {
                      if (!maybeComponent(el)) {
                          warn("v-slot can only be used on components or <template>.", slotBinding);
                      }
                      if (el.slotScope || el.slotTarget) {
                          warn("Unexpected mixed usage of different slot syntaxes.", el);
                      }
                      if (el.scopedSlots) {
                          warn("To avoid scope ambiguity, the default slot should also use " +
                              "<template> syntax when there are other named slots.", slotBinding);
                      }
                  }
                  // add the component's children to its default slot
                  var slots = el.scopedSlots || (el.scopedSlots = {});
                  var _b = getSlotName(slotBinding), name_3 = _b.name, dynamic = _b.dynamic;
                  var slotContainer_1 = (slots[name_3] = createASTElement('template', [], el));
                  slotContainer_1.slotTarget = name_3;
                  slotContainer_1.slotTargetDynamic = dynamic;
                  slotContainer_1.children = el.children.filter(function (c) {
                      if (!c.slotScope) {
                          c.parent = slotContainer_1;
                          return true;
                      }
                  });
                  slotContainer_1.slotScope = slotBinding.value || emptySlotScopeToken;
                  // remove children as they are returned from scopedSlots now
                  el.children = [];
                  // mark el non-plain so data gets generated
                  el.plain = false;
              }
          }
      }
  }
  function getSlotName(binding) {
      var name = binding.name.replace(slotRE, '');
      if (!name) {
          if (binding.name[0] !== '#') {
              name = 'default';
          }
          else {
              warn("v-slot shorthand syntax requires a slot name.", binding);
          }
      }
      return dynamicArgRE.test(name)
          ? // dynamic [name]
              { name: name.slice(1, -1), dynamic: true }
          : // static name
              { name: "\"".concat(name, "\""), dynamic: false };
  }
  // handle <slot/> outlets
  function processSlotOutlet(el) {
      if (el.tag === 'slot') {
          el.slotName = getBindingAttr(el, 'name');
          if (el.key) {
              warn("`key` does not work on <slot> because slots are abstract outlets " +
                  "and can possibly expand into multiple elements. " +
                  "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
          }
      }
  }
  function processComponent(el) {
      var binding;
      if ((binding = getBindingAttr(el, 'is'))) {
          el.component = binding;
      }
      if (getAndRemoveAttr(el, 'inline-template') != null) {
          el.inlineTemplate = true;
      }
  }
  function processAttrs(el) {
      var list = el.attrsList;
      var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
      for (i = 0, l = list.length; i < l; i++) {
          name = rawName = list[i].name;
          value = list[i].value;
          if (dirRE.test(name)) {
              // mark element as dynamic
              el.hasBindings = true;
              // modifiers
              modifiers = parseModifiers(name.replace(dirRE, ''));
              // support .foo shorthand syntax for the .prop modifier
              if (modifiers) {
                  name = name.replace(modifierRE, '');
              }
              if (bindRE.test(name)) {
                  // v-bind
                  name = name.replace(bindRE, '');
                  value = parseFilters(value);
                  isDynamic = dynamicArgRE.test(name);
                  if (isDynamic) {
                      name = name.slice(1, -1);
                  }
                  if (value.trim().length === 0) {
                      warn("The value for a v-bind expression cannot be empty. Found in \"v-bind:".concat(name, "\""));
                  }
                  if (modifiers) {
                      if (modifiers.prop && !isDynamic) {
                          name = camelize(name);
                          if (name === 'innerHtml')
                              name = 'innerHTML';
                      }
                      if (modifiers.camel && !isDynamic) {
                          name = camelize(name);
                      }
                      if (modifiers.sync) {
                          syncGen = genAssignmentCode(value, "$event");
                          if (!isDynamic) {
                              addHandler(el, "update:".concat(camelize(name)), syncGen, null, false, warn, list[i]);
                              if (hyphenate(name) !== camelize(name)) {
                                  addHandler(el, "update:".concat(hyphenate(name)), syncGen, null, false, warn, list[i]);
                              }
                          }
                          else {
                              // handler w/ dynamic event name
                              addHandler(el, "\"update:\"+(".concat(name, ")"), syncGen, null, false, warn, list[i], true // dynamic
                              );
                          }
                      }
                  }
                  if ((modifiers && modifiers.prop) ||
                      (!el.component && platformMustUseProp(el.tag, el.attrsMap.type, name))) {
                      addProp(el, name, value, list[i], isDynamic);
                  }
                  else {
                      addAttr(el, name, value, list[i], isDynamic);
                  }
              }
              else if (onRE.test(name)) {
                  // v-on
                  name = name.replace(onRE, '');
                  isDynamic = dynamicArgRE.test(name);
                  if (isDynamic) {
                      name = name.slice(1, -1);
                  }
                  addHandler(el, name, value, modifiers, false, warn, list[i], isDynamic);
              }
              else {
                  // normal directives
                  name = name.replace(dirRE, '');
                  // parse arg
                  var argMatch = name.match(argRE);
                  var arg = argMatch && argMatch[1];
                  isDynamic = false;
                  if (arg) {
                      name = name.slice(0, -(arg.length + 1));
                      if (dynamicArgRE.test(arg)) {
                          arg = arg.slice(1, -1);
                          isDynamic = true;
                      }
                  }
                  addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
                  if (name === 'model') {
                      checkForAliasModel(el, value);
                  }
              }
          }
          else {
              // literal attribute
              {
                  var res = parseText(value, delimiters);
                  if (res) {
                      warn("".concat(name, "=\"").concat(value, "\": ") +
                          'Interpolation inside attributes has been removed. ' +
                          'Use v-bind or the colon shorthand instead. For example, ' +
                          'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
                  }
              }
              addAttr(el, name, JSON.stringify(value), list[i]);
              // #6887 firefox doesn't update muted state if set via attribute
              // even immediately after element creation
              if (!el.component &&
                  name === 'muted' &&
                  platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                  addProp(el, name, 'true', list[i]);
              }
          }
      }
  }
  function checkInFor(el) {
      var parent = el;
      while (parent) {
          if (parent.for !== undefined) {
              return true;
          }
          parent = parent.parent;
      }
      return false;
  }
  function parseModifiers(name) {
      var match = name.match(modifierRE);
      if (match) {
          var ret_1 = {};
          match.forEach(function (m) {
              ret_1[m.slice(1)] = true;
          });
          return ret_1;
      }
  }
  function makeAttrsMap(attrs) {
      var map = {};
      for (var i = 0, l = attrs.length; i < l; i++) {
          if (map[attrs[i].name] && !isIE && !isEdge) {
              warn('duplicate attribute: ' + attrs[i].name, attrs[i]);
          }
          map[attrs[i].name] = attrs[i].value;
      }
      return map;
  }
  // for script (e.g. type="x/template") or style, do not decode content
  function isTextTag(el) {
      return el.tag === 'script' || el.tag === 'style';
  }
  function isForbiddenTag(el) {
      return (el.tag === 'style' ||
          (el.tag === 'script' &&
              (!el.attrsMap.type || el.attrsMap.type === 'text/javascript')));
  }
  var ieNSBug = /^xmlns:NS\d+/;
  var ieNSPrefix = /^NS\d+:/;
  /* istanbul ignore next */
  function guardIESVGBug(attrs) {
      var res = [];
      for (var i = 0; i < attrs.length; i++) {
          var attr = attrs[i];
          if (!ieNSBug.test(attr.name)) {
              attr.name = attr.name.replace(ieNSPrefix, '');
              res.push(attr);
          }
      }
      return res;
  }
  function checkForAliasModel(el, value) {
      var _el = el;
      while (_el) {
          if (_el.for && _el.alias === value) {
              warn("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
                  "You are binding v-model directly to a v-for iteration alias. " +
                  "This will not be able to modify the v-for source array because " +
                  "writing to the alias is like modifying a function local variable. " +
                  "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
          }
          _el = _el.parent;
      }
  }

  /**
   * Expand input[v-model] with dynamic type bindings into v-if-else chains
   * Turn this:
   *   <input v-model="data[type]" :type="type">
   * into this:
   *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
   *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
   *   <input v-else :type="type" v-model="data[type]">
   */
  function preTransformNode(el, options) {
      if (el.tag === 'input') {
          var map = el.attrsMap;
          if (!map['v-model']) {
              return;
          }
          var typeBinding = void 0;
          if (map[':type'] || map['v-bind:type']) {
              typeBinding = getBindingAttr(el, 'type');
          }
          if (!map.type && !typeBinding && map['v-bind']) {
              typeBinding = "(".concat(map['v-bind'], ").type");
          }
          if (typeBinding) {
              var ifCondition = getAndRemoveAttr(el, 'v-if', true);
              var ifConditionExtra = ifCondition ? "&&(".concat(ifCondition, ")") : "";
              var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
              var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
              // 1. checkbox
              var branch0 = cloneASTElement(el);
              // process for on the main node
              processFor(branch0);
              addRawAttr(branch0, 'type', 'checkbox');
              processElement(branch0, options);
              branch0.processed = true; // prevent it from double-processed
              branch0.if = "(".concat(typeBinding, ")==='checkbox'") + ifConditionExtra;
              addIfCondition(branch0, {
                  exp: branch0.if,
                  block: branch0
              });
              // 2. add radio else-if condition
              var branch1 = cloneASTElement(el);
              getAndRemoveAttr(branch1, 'v-for', true);
              addRawAttr(branch1, 'type', 'radio');
              processElement(branch1, options);
              addIfCondition(branch0, {
                  exp: "(".concat(typeBinding, ")==='radio'") + ifConditionExtra,
                  block: branch1
              });
              // 3. other
              var branch2 = cloneASTElement(el);
              getAndRemoveAttr(branch2, 'v-for', true);
              addRawAttr(branch2, ':type', typeBinding);
              processElement(branch2, options);
              addIfCondition(branch0, {
                  exp: ifCondition,
                  block: branch2
              });
              if (hasElse) {
                  branch0.else = true;
              }
              else if (elseIfCondition) {
                  branch0.elseif = elseIfCondition;
              }
              return branch0;
          }
      }
  }
  function cloneASTElement(el) {
      return createASTElement(el.tag, el.attrsList.slice(), el.parent);
  }
  var model = {
      preTransformNode: preTransformNode
  };

  var modules = [klass, style, model];

  function text(el, dir) {
      if (dir.value) {
          addProp(el, 'textContent', "_s(".concat(dir.value, ")"), dir);
      }
  }

  function html(el, dir) {
      if (dir.value) {
          addProp(el, 'innerHTML', "_s(".concat(dir.value, ")"), dir);
      }
  }

  var directives = {
      model: model$1,
      text: text,
      html: html
  };

  var baseOptions = {
      expectHTML: true,
      modules: modules,
      directives: directives,
      isPreTag: isPreTag,
      isUnaryTag: isUnaryTag,
      mustUseProp: mustUseProp,
      canBeLeftOpenTag: canBeLeftOpenTag,
      isReservedTag: isReservedTag,
      getTagNamespace: getTagNamespace,
      staticKeys: genStaticKeys$1(modules)
  };

  var isStaticKey;
  var isPlatformReservedTag;
  var genStaticKeysCached = cached(genStaticKeys);
  /**
   * Goal of the optimizer: walk the generated template AST tree
   * and detect sub-trees that are purely static, i.e. parts of
   * the DOM that never needs to change.
   *
   * Once we detect these sub-trees, we can:
   *
   * 1. Hoist them into constants, so that we no longer need to
   *    create fresh nodes for them on each re-render;
   * 2. Completely skip them in the patching process.
   */
  function optimize(root, options) {
      if (!root)
          return;
      isStaticKey = genStaticKeysCached(options.staticKeys || '');
      isPlatformReservedTag = options.isReservedTag || no;
      // first pass: mark all non-static nodes.
      markStatic(root);
      // second pass: mark static roots.
      markStaticRoots(root, false);
  }
  function genStaticKeys(keys) {
      return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
          (keys ? ',' + keys : ''));
  }
  function markStatic(node) {
      node.static = isStatic(node);
      if (node.type === 1) {
          // do not make component slot content static. this avoids
          // 1. components not able to mutate slot nodes
          // 2. static slot content fails for hot-reloading
          if (!isPlatformReservedTag(node.tag) &&
              node.tag !== 'slot' &&
              node.attrsMap['inline-template'] == null) {
              return;
          }
          for (var i = 0, l = node.children.length; i < l; i++) {
              var child = node.children[i];
              markStatic(child);
              if (!child.static) {
                  node.static = false;
              }
          }
          if (node.ifConditions) {
              for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                  var block = node.ifConditions[i].block;
                  markStatic(block);
                  if (!block.static) {
                      node.static = false;
                  }
              }
          }
      }
  }
  function markStaticRoots(node, isInFor) {
      if (node.type === 1) {
          if (node.static || node.once) {
              node.staticInFor = isInFor;
          }
          // For a node to qualify as a static root, it should have children that
          // are not just static text. Otherwise the cost of hoisting out will
          // outweigh the benefits and it's better off to just always render it fresh.
          if (node.static &&
              node.children.length &&
              !(node.children.length === 1 && node.children[0].type === 3)) {
              node.staticRoot = true;
              return;
          }
          else {
              node.staticRoot = false;
          }
          if (node.children) {
              for (var i = 0, l = node.children.length; i < l; i++) {
                  markStaticRoots(node.children[i], isInFor || !!node.for);
              }
          }
          if (node.ifConditions) {
              for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                  markStaticRoots(node.ifConditions[i].block, isInFor);
              }
          }
      }
  }
  function isStatic(node) {
      if (node.type === 2) {
          // expression
          return false;
      }
      if (node.type === 3) {
          // text
          return true;
      }
      return !!(node.pre ||
          (!node.hasBindings && // no dynamic bindings
              !node.if &&
              !node.for && // not v-if or v-for or v-else
              !isBuiltInTag(node.tag) && // not a built-in
              isPlatformReservedTag(node.tag) && // not a component
              !isDirectChildOfTemplateFor(node) &&
              Object.keys(node).every(isStaticKey)));
  }
  function isDirectChildOfTemplateFor(node) {
      while (node.parent) {
          node = node.parent;
          if (node.tag !== 'template') {
              return false;
          }
          if (node.for) {
              return true;
          }
      }
      return false;
  }

  var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
  var fnInvokeRE = /\([^)]*?\);*$/;
  var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
  // KeyboardEvent.keyCode aliases
  var keyCodes = {
      esc: 27,
      tab: 9,
      enter: 13,
      space: 32,
      up: 38,
      left: 37,
      right: 39,
      down: 40,
      delete: [8, 46]
  };
  // KeyboardEvent.key aliases
  var keyNames = {
      // #7880: IE11 and Edge use `Esc` for Escape key name.
      esc: ['Esc', 'Escape'],
      tab: 'Tab',
      enter: 'Enter',
      // #9112: IE11 uses `Spacebar` for Space key name.
      space: [' ', 'Spacebar'],
      // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
      up: ['Up', 'ArrowUp'],
      left: ['Left', 'ArrowLeft'],
      right: ['Right', 'ArrowRight'],
      down: ['Down', 'ArrowDown'],
      // #9112: IE11 uses `Del` for Delete key name.
      delete: ['Backspace', 'Delete', 'Del']
  };
  // #4868: modifiers that prevent the execution of the listener
  // need to explicitly return null so that we can determine whether to remove
  // the listener for .once
  var genGuard = function (condition) { return "if(".concat(condition, ")return null;"); };
  var modifierCode = {
      stop: '$event.stopPropagation();',
      prevent: '$event.preventDefault();',
      self: genGuard("$event.target !== $event.currentTarget"),
      ctrl: genGuard("!$event.ctrlKey"),
      shift: genGuard("!$event.shiftKey"),
      alt: genGuard("!$event.altKey"),
      meta: genGuard("!$event.metaKey"),
      left: genGuard("'button' in $event && $event.button !== 0"),
      middle: genGuard("'button' in $event && $event.button !== 1"),
      right: genGuard("'button' in $event && $event.button !== 2")
  };
  function genHandlers(events, isNative) {
      var prefix = isNative ? 'nativeOn:' : 'on:';
      var staticHandlers = "";
      var dynamicHandlers = "";
      for (var name_1 in events) {
          var handlerCode = genHandler(events[name_1]);
          //@ts-expect-error
          if (events[name_1] && events[name_1].dynamic) {
              dynamicHandlers += "".concat(name_1, ",").concat(handlerCode, ",");
          }
          else {
              staticHandlers += "\"".concat(name_1, "\":").concat(handlerCode, ",");
          }
      }
      staticHandlers = "{".concat(staticHandlers.slice(0, -1), "}");
      if (dynamicHandlers) {
          return prefix + "_d(".concat(staticHandlers, ",[").concat(dynamicHandlers.slice(0, -1), "])");
      }
      else {
          return prefix + staticHandlers;
      }
  }
  function genHandler(handler) {
      if (!handler) {
          return 'function(){}';
      }
      if (Array.isArray(handler)) {
          return "[".concat(handler.map(function (handler) { return genHandler(handler); }).join(','), "]");
      }
      var isMethodPath = simplePathRE.test(handler.value);
      var isFunctionExpression = fnExpRE.test(handler.value);
      var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
      if (!handler.modifiers) {
          if (isMethodPath || isFunctionExpression) {
              return handler.value;
          }
          return "function($event){".concat(isFunctionInvocation ? "return ".concat(handler.value) : handler.value, "}"); // inline statement
      }
      else {
          var code = '';
          var genModifierCode = '';
          var keys = [];
          var _loop_1 = function (key) {
              if (modifierCode[key]) {
                  genModifierCode += modifierCode[key];
                  // left/right
                  if (keyCodes[key]) {
                      keys.push(key);
                  }
              }
              else if (key === 'exact') {
                  var modifiers_1 = handler.modifiers;
                  genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta']
                      .filter(function (keyModifier) { return !modifiers_1[keyModifier]; })
                      .map(function (keyModifier) { return "$event.".concat(keyModifier, "Key"); })
                      .join('||'));
              }
              else {
                  keys.push(key);
              }
          };
          for (var key in handler.modifiers) {
              _loop_1(key);
          }
          if (keys.length) {
              code += genKeyFilter(keys);
          }
          // Make sure modifiers like prevent and stop get executed after key filtering
          if (genModifierCode) {
              code += genModifierCode;
          }
          var handlerCode = isMethodPath
              ? "return ".concat(handler.value, ".apply(null, arguments)")
              : isFunctionExpression
                  ? "return (".concat(handler.value, ").apply(null, arguments)")
                  : isFunctionInvocation
                      ? "return ".concat(handler.value)
                      : handler.value;
          return "function($event){".concat(code).concat(handlerCode, "}");
      }
  }
  function genKeyFilter(keys) {
      return (
      // make sure the key filters only apply to KeyboardEvents
      // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
      // key events that do not have keyCode property...
      "if(!$event.type.indexOf('key')&&" +
          "".concat(keys.map(genFilterCode).join('&&'), ")return null;"));
  }
  function genFilterCode(key) {
      var keyVal = parseInt(key, 10);
      if (keyVal) {
          return "$event.keyCode!==".concat(keyVal);
      }
      var keyCode = keyCodes[key];
      var keyName = keyNames[key];
      return ("_k($event.keyCode," +
          "".concat(JSON.stringify(key), ",") +
          "".concat(JSON.stringify(keyCode), ",") +
          "$event.key," +
          "".concat(JSON.stringify(keyName)) +
          ")");
  }

  function on(el, dir) {
      if (dir.modifiers) {
          warn$2("v-on without argument does not support modifiers.");
      }
      el.wrapListeners = function (code) { return "_g(".concat(code, ",").concat(dir.value, ")"); };
  }

  function bind(el, dir) {
      el.wrapData = function (code) {
          return "_b(".concat(code, ",'").concat(el.tag, "',").concat(dir.value, ",").concat(dir.modifiers && dir.modifiers.prop ? 'true' : 'false').concat(dir.modifiers && dir.modifiers.sync ? ',true' : '', ")");
      };
  }

  var baseDirectives = {
      on: on,
      bind: bind,
      cloak: noop
  };

  var CodegenState = /** @class */ (function () {
      function CodegenState(options) {
          this.options = options;
          this.warn = options.warn || baseWarn;
          this.transforms = pluckModuleFunction(options.modules, 'transformCode');
          this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
          this.directives = extend(extend({}, baseDirectives), options.directives);
          var isReservedTag = options.isReservedTag || no;
          this.maybeComponent = function (el) {
              return !!el.component || !isReservedTag(el.tag);
          };
          this.onceId = 0;
          this.staticRenderFns = [];
          this.pre = false;
      }
      return CodegenState;
  }());
  function generate(ast, options) {
      var state = new CodegenState(options);
      // fix #11483, Root level <script> tags should not be rendered.
      var code = ast
          ? ast.tag === 'script'
              ? 'null'
              : genElement(ast, state)
          : '_c("div")';
      return {
          render: "with(this){return ".concat(code, "}"),
          staticRenderFns: state.staticRenderFns
      };
  }
  function genElement(el, state) {
      if (el.parent) {
          el.pre = el.pre || el.parent.pre;
      }
      if (el.staticRoot && !el.staticProcessed) {
          return genStatic(el, state);
      }
      else if (el.once && !el.onceProcessed) {
          return genOnce(el, state);
      }
      else if (el.for && !el.forProcessed) {
          return genFor(el, state);
      }
      else if (el.if && !el.ifProcessed) {
          return genIf(el, state);
      }
      else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
          return genChildren(el, state) || 'void 0';
      }
      else if (el.tag === 'slot') {
          return genSlot(el, state);
      }
      else {
          // component or element
          var code = void 0;
          if (el.component) {
              code = genComponent(el.component, el, state);
          }
          else {
              var data = void 0;
              var maybeComponent = state.maybeComponent(el);
              if (!el.plain || (el.pre && maybeComponent)) {
                  data = genData(el, state);
              }
              var tag 
              // check if this is a component in <script setup>
              = void 0;
              // check if this is a component in <script setup>
              var bindings = state.options.bindings;
              if (maybeComponent && bindings && bindings.__isScriptSetup !== false) {
                  tag = checkBindingType(bindings, el.tag);
              }
              if (!tag)
                  tag = "'".concat(el.tag, "'");
              var children = el.inlineTemplate ? null : genChildren(el, state, true);
              code = "_c(".concat(tag).concat(data ? ",".concat(data) : '' // data
              ).concat(children ? ",".concat(children) : '' // children
              , ")");
          }
          // module transforms
          for (var i = 0; i < state.transforms.length; i++) {
              code = state.transforms[i](el, code);
          }
          return code;
      }
  }
  function checkBindingType(bindings, key) {
      var camelName = camelize(key);
      var PascalName = capitalize(camelName);
      var checkType = function (type) {
          if (bindings[key] === type) {
              return key;
          }
          if (bindings[camelName] === type) {
              return camelName;
          }
          if (bindings[PascalName] === type) {
              return PascalName;
          }
      };
      var fromConst = checkType("setup-const" /* BindingTypes.SETUP_CONST */) ||
          checkType("setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */);
      if (fromConst) {
          return fromConst;
      }
      var fromMaybeRef = checkType("setup-let" /* BindingTypes.SETUP_LET */) ||
          checkType("setup-ref" /* BindingTypes.SETUP_REF */) ||
          checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */);
      if (fromMaybeRef) {
          return fromMaybeRef;
      }
  }
  // hoist static sub-trees out
  function genStatic(el, state) {
      el.staticProcessed = true;
      // Some elements (templates) need to behave differently inside of a v-pre
      // node.  All pre nodes are static roots, so we can use this as a location to
      // wrap a state change and reset it upon exiting the pre node.
      var originalPreState = state.pre;
      if (el.pre) {
          state.pre = el.pre;
      }
      state.staticRenderFns.push("with(this){return ".concat(genElement(el, state), "}"));
      state.pre = originalPreState;
      return "_m(".concat(state.staticRenderFns.length - 1).concat(el.staticInFor ? ',true' : '', ")");
  }
  // v-once
  function genOnce(el, state) {
      el.onceProcessed = true;
      if (el.if && !el.ifProcessed) {
          return genIf(el, state);
      }
      else if (el.staticInFor) {
          var key = '';
          var parent_1 = el.parent;
          while (parent_1) {
              if (parent_1.for) {
                  key = parent_1.key;
                  break;
              }
              parent_1 = parent_1.parent;
          }
          if (!key) {
              state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
              return genElement(el, state);
          }
          return "_o(".concat(genElement(el, state), ",").concat(state.onceId++, ",").concat(key, ")");
      }
      else {
          return genStatic(el, state);
      }
  }
  function genIf(el, state, altGen, altEmpty) {
      el.ifProcessed = true; // avoid recursion
      return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
  }
  function genIfConditions(conditions, state, altGen, altEmpty) {
      if (!conditions.length) {
          return altEmpty || '_e()';
      }
      var condition = conditions.shift();
      if (condition.exp) {
          return "(".concat(condition.exp, ")?").concat(genTernaryExp(condition.block), ":").concat(genIfConditions(conditions, state, altGen, altEmpty));
      }
      else {
          return "".concat(genTernaryExp(condition.block));
      }
      // v-if with v-once should generate code like (a)?_m(0):_m(1)
      function genTernaryExp(el) {
          return altGen
              ? altGen(el, state)
              : el.once
                  ? genOnce(el, state)
                  : genElement(el, state);
      }
  }
  function genFor(el, state, altGen, altHelper) {
      var exp = el.for;
      var alias = el.alias;
      var iterator1 = el.iterator1 ? ",".concat(el.iterator1) : '';
      var iterator2 = el.iterator2 ? ",".concat(el.iterator2) : '';
      if (state.maybeComponent(el) &&
          el.tag !== 'slot' &&
          el.tag !== 'template' &&
          !el.key) {
          state.warn("<".concat(el.tag, " v-for=\"").concat(alias, " in ").concat(exp, "\">: component lists rendered with ") +
              "v-for should have explicit keys. " +
              "See https://v2.vuejs.org/v2/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true /* tip */);
      }
      el.forProcessed = true; // avoid recursion
      return ("".concat(altHelper || '_l', "((").concat(exp, "),") +
          "function(".concat(alias).concat(iterator1).concat(iterator2, "){") +
          "return ".concat((altGen || genElement)(el, state)) +
          '})');
  }
  function genData(el, state) {
      var data = '{';
      // directives first.
      // directives may mutate the el's other properties before they are generated.
      var dirs = genDirectives(el, state);
      if (dirs)
          data += dirs + ',';
      // key
      if (el.key) {
          data += "key:".concat(el.key, ",");
      }
      // ref
      if (el.ref) {
          data += "ref:".concat(el.ref, ",");
      }
      if (el.refInFor) {
          data += "refInFor:true,";
      }
      // pre
      if (el.pre) {
          data += "pre:true,";
      }
      // record original tag name for components using "is" attribute
      if (el.component) {
          data += "tag:\"".concat(el.tag, "\",");
      }
      // module data generation functions
      for (var i = 0; i < state.dataGenFns.length; i++) {
          data += state.dataGenFns[i](el);
      }
      // attributes
      if (el.attrs) {
          data += "attrs:".concat(genProps(el.attrs), ",");
      }
      // DOM props
      if (el.props) {
          data += "domProps:".concat(genProps(el.props), ",");
      }
      // event handlers
      if (el.events) {
          data += "".concat(genHandlers(el.events, false), ",");
      }
      if (el.nativeEvents) {
          data += "".concat(genHandlers(el.nativeEvents, true), ",");
      }
      // slot target
      // only for non-scoped slots
      if (el.slotTarget && !el.slotScope) {
          data += "slot:".concat(el.slotTarget, ",");
      }
      // scoped slots
      if (el.scopedSlots) {
          data += "".concat(genScopedSlots(el, el.scopedSlots, state), ",");
      }
      // component v-model
      if (el.model) {
          data += "model:{value:".concat(el.model.value, ",callback:").concat(el.model.callback, ",expression:").concat(el.model.expression, "},");
      }
      // inline-template
      if (el.inlineTemplate) {
          var inlineTemplate = genInlineTemplate(el, state);
          if (inlineTemplate) {
              data += "".concat(inlineTemplate, ",");
          }
      }
      data = data.replace(/,$/, '') + '}';
      // v-bind dynamic argument wrap
      // v-bind with dynamic arguments must be applied using the same v-bind object
      // merge helper so that class/style/mustUseProp attrs are handled correctly.
      if (el.dynamicAttrs) {
          data = "_b(".concat(data, ",\"").concat(el.tag, "\",").concat(genProps(el.dynamicAttrs), ")");
      }
      // v-bind data wrap
      if (el.wrapData) {
          data = el.wrapData(data);
      }
      // v-on data wrap
      if (el.wrapListeners) {
          data = el.wrapListeners(data);
      }
      return data;
  }
  function genDirectives(el, state) {
      var dirs = el.directives;
      if (!dirs)
          return;
      var res = 'directives:[';
      var hasRuntime = false;
      var i, l, dir, needRuntime;
      for (i = 0, l = dirs.length; i < l; i++) {
          dir = dirs[i];
          needRuntime = true;
          var gen = state.directives[dir.name];
          if (gen) {
              // compile-time directive that manipulates AST.
              // returns true if it also needs a runtime counterpart.
              needRuntime = !!gen(el, dir, state.warn);
          }
          if (needRuntime) {
              hasRuntime = true;
              res += "{name:\"".concat(dir.name, "\",rawName:\"").concat(dir.rawName, "\"").concat(dir.value
                  ? ",value:(".concat(dir.value, "),expression:").concat(JSON.stringify(dir.value))
                  : '').concat(dir.arg ? ",arg:".concat(dir.isDynamicArg ? dir.arg : "\"".concat(dir.arg, "\"")) : '').concat(dir.modifiers ? ",modifiers:".concat(JSON.stringify(dir.modifiers)) : '', "},");
          }
      }
      if (hasRuntime) {
          return res.slice(0, -1) + ']';
      }
  }
  function genInlineTemplate(el, state) {
      var ast = el.children[0];
      if ((el.children.length !== 1 || ast.type !== 1)) {
          state.warn('Inline-template components must have exactly one child element.', { start: el.start });
      }
      if (ast && ast.type === 1) {
          var inlineRenderFns = generate(ast, state.options);
          return "inlineTemplate:{render:function(){".concat(inlineRenderFns.render, "},staticRenderFns:[").concat(inlineRenderFns.staticRenderFns
              .map(function (code) { return "function(){".concat(code, "}"); })
              .join(','), "]}");
      }
  }
  function genScopedSlots(el, slots, state) {
      // by default scoped slots are considered "stable", this allows child
      // components with only scoped slots to skip forced updates from parent.
      // but in some cases we have to bail-out of this optimization
      // for example if the slot contains dynamic names, has v-if or v-for on them...
      var needsForceUpdate = el.for ||
          Object.keys(slots).some(function (key) {
              var slot = slots[key];
              return (slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
              );
          });
      // #9534: if a component with scoped slots is inside a conditional branch,
      // it's possible for the same component to be reused but with different
      // compiled slot content. To avoid that, we generate a unique key based on
      // the generated code of all the slot contents.
      var needsKey = !!el.if;
      // OR when it is inside another scoped slot or v-for (the reactivity may be
      // disconnected due to the intermediate scope variable)
      // #9438, #9506
      // TODO: this can be further optimized by properly analyzing in-scope bindings
      // and skip force updating ones that do not actually use scope variables.
      if (!needsForceUpdate) {
          var parent_2 = el.parent;
          while (parent_2) {
              if ((parent_2.slotScope && parent_2.slotScope !== emptySlotScopeToken) ||
                  parent_2.for) {
                  needsForceUpdate = true;
                  break;
              }
              if (parent_2.if) {
                  needsKey = true;
              }
              parent_2 = parent_2.parent;
          }
      }
      var generatedSlots = Object.keys(slots)
          .map(function (key) { return genScopedSlot(slots[key], state); })
          .join(',');
      return "scopedSlots:_u([".concat(generatedSlots, "]").concat(needsForceUpdate ? ",null,true" : "").concat(!needsForceUpdate && needsKey ? ",null,false,".concat(hash(generatedSlots)) : "", ")");
  }
  function hash(str) {
      var hash = 5381;
      var i = str.length;
      while (i) {
          hash = (hash * 33) ^ str.charCodeAt(--i);
      }
      return hash >>> 0;
  }
  function containsSlotChild(el) {
      if (el.type === 1) {
          if (el.tag === 'slot') {
              return true;
          }
          return el.children.some(containsSlotChild);
      }
      return false;
  }
  function genScopedSlot(el, state) {
      var isLegacySyntax = el.attrsMap['slot-scope'];
      if (el.if && !el.ifProcessed && !isLegacySyntax) {
          return genIf(el, state, genScopedSlot, "null");
      }
      if (el.for && !el.forProcessed) {
          return genFor(el, state, genScopedSlot);
      }
      var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
      var fn = "function(".concat(slotScope, "){") +
          "return ".concat(el.tag === 'template'
              ? el.if && isLegacySyntax
                  ? "(".concat(el.if, ")?").concat(genChildren(el, state) || 'undefined', ":undefined")
                  : genChildren(el, state) || 'undefined'
              : genElement(el, state), "}");
      // reverse proxy v-slot without scope on this.$slots
      var reverseProxy = slotScope ? "" : ",proxy:true";
      return "{key:".concat(el.slotTarget || "\"default\"", ",fn:").concat(fn).concat(reverseProxy, "}");
  }
  function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
      var children = el.children;
      if (children.length) {
          var el_1 = children[0];
          // optimize single v-for
          if (children.length === 1 &&
              el_1.for &&
              el_1.tag !== 'template' &&
              el_1.tag !== 'slot') {
              var normalizationType_1 = checkSkip
                  ? state.maybeComponent(el_1)
                      ? ",1"
                      : ",0"
                  : "";
              return "".concat((altGenElement || genElement)(el_1, state)).concat(normalizationType_1);
          }
          var normalizationType = checkSkip
              ? getNormalizationType(children, state.maybeComponent)
              : 0;
          var gen_1 = altGenNode || genNode;
          return "[".concat(children.map(function (c) { return gen_1(c, state); }).join(','), "]").concat(normalizationType ? ",".concat(normalizationType) : '');
      }
  }
  // determine the normalization needed for the children array.
  // 0: no normalization needed
  // 1: simple normalization needed (possible 1-level deep nested array)
  // 2: full normalization needed
  function getNormalizationType(children, maybeComponent) {
      var res = 0;
      for (var i = 0; i < children.length; i++) {
          var el = children[i];
          if (el.type !== 1) {
              continue;
          }
          if (needsNormalization(el) ||
              (el.ifConditions &&
                  el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
              res = 2;
              break;
          }
          if (maybeComponent(el) ||
              (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
              res = 1;
          }
      }
      return res;
  }
  function needsNormalization(el) {
      return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
  }
  function genNode(node, state) {
      if (node.type === 1) {
          return genElement(node, state);
      }
      else if (node.type === 3 && node.isComment) {
          return genComment(node);
      }
      else {
          return genText(node);
      }
  }
  function genText(text) {
      return "_v(".concat(text.type === 2
          ? text.expression // no need for () because already wrapped in _s()
          : transformSpecialNewlines(JSON.stringify(text.text)), ")");
  }
  function genComment(comment) {
      return "_e(".concat(JSON.stringify(comment.text), ")");
  }
  function genSlot(el, state) {
      var slotName = el.slotName || '"default"';
      var children = genChildren(el, state);
      var res = "_t(".concat(slotName).concat(children ? ",function(){return ".concat(children, "}") : '');
      var attrs = el.attrs || el.dynamicAttrs
          ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
              // slot props are camelized
              name: camelize(attr.name),
              value: attr.value,
              dynamic: attr.dynamic
          }); }))
          : null;
      var bind = el.attrsMap['v-bind'];
      if ((attrs || bind) && !children) {
          res += ",null";
      }
      if (attrs) {
          res += ",".concat(attrs);
      }
      if (bind) {
          res += "".concat(attrs ? '' : ',null', ",").concat(bind);
      }
      return res + ')';
  }
  // componentName is el.component, take it as argument to shun flow's pessimistic refinement
  function genComponent(componentName, el, state) {
      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      return "_c(".concat(componentName, ",").concat(genData(el, state)).concat(children ? ",".concat(children) : '', ")");
  }
  function genProps(props) {
      var staticProps = "";
      var dynamicProps = "";
      for (var i = 0; i < props.length; i++) {
          var prop = props[i];
          var value = transformSpecialNewlines(prop.value);
          if (prop.dynamic) {
              dynamicProps += "".concat(prop.name, ",").concat(value, ",");
          }
          else {
              staticProps += "\"".concat(prop.name, "\":").concat(value, ",");
          }
      }
      staticProps = "{".concat(staticProps.slice(0, -1), "}");
      if (dynamicProps) {
          return "_d(".concat(staticProps, ",[").concat(dynamicProps.slice(0, -1), "])");
      }
      else {
          return staticProps;
      }
  }
  // #3895, #4268
  function transformSpecialNewlines(text) {
      return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
  }

  // these keywords should not appear inside expressions, but operators like
  // typeof, instanceof and in are allowed
  var prohibitedKeywordRE = new RegExp('\\b' +
      ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
          'super,throw,while,yield,delete,export,import,return,switch,default,' +
          'extends,finally,continue,debugger,function,arguments')
          .split(',')
          .join('\\b|\\b') +
      '\\b');
  // these unary operators should not be used as property/method names
  var unaryOperatorsRE = new RegExp('\\b' +
      'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') +
      '\\s*\\([^\\)]*\\)');
  // strip strings in expressions
  var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
  // detect problematic expressions in a template
  function detectErrors(ast, warn) {
      if (ast) {
          checkNode(ast, warn);
      }
  }
  function checkNode(node, warn) {
      if (node.type === 1) {
          for (var name_1 in node.attrsMap) {
              if (dirRE.test(name_1)) {
                  var value = node.attrsMap[name_1];
                  if (value) {
                      var range = node.rawAttrsMap[name_1];
                      if (name_1 === 'v-for') {
                          checkFor(node, "v-for=\"".concat(value, "\""), warn, range);
                      }
                      else if (name_1 === 'v-slot' || name_1[0] === '#') {
                          checkFunctionParameterExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                      }
                      else if (onRE.test(name_1)) {
                          checkEvent(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                      }
                      else {
                          checkExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                      }
                  }
              }
          }
          if (node.children) {
              for (var i = 0; i < node.children.length; i++) {
                  checkNode(node.children[i], warn);
              }
          }
      }
      else if (node.type === 2) {
          checkExpression(node.expression, node.text, warn, node);
      }
  }
  function checkEvent(exp, text, warn, range) {
      var stripped = exp.replace(stripStringRE, '');
      var keywordMatch = stripped.match(unaryOperatorsRE);
      if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
          warn("avoid using JavaScript unary operator as property name: " +
              "\"".concat(keywordMatch[0], "\" in expression ").concat(text.trim()), range);
      }
      checkExpression(exp, text, warn, range);
  }
  function checkFor(node, text, warn, range) {
      checkExpression(node.for || '', text, warn, range);
      checkIdentifier(node.alias, 'v-for alias', text, warn, range);
      checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
      checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
  }
  function checkIdentifier(ident, type, text, warn, range) {
      if (typeof ident === 'string') {
          try {
              new Function("var ".concat(ident, "=_"));
          }
          catch (e) {
              warn("invalid ".concat(type, " \"").concat(ident, "\" in expression: ").concat(text.trim()), range);
          }
      }
  }
  function checkExpression(exp, text, warn, range) {
      try {
          new Function("return ".concat(exp));
      }
      catch (e) {
          var keywordMatch = exp
              .replace(stripStringRE, '')
              .match(prohibitedKeywordRE);
          if (keywordMatch) {
              warn("avoid using JavaScript keyword as property name: " +
                  "\"".concat(keywordMatch[0], "\"\n  Raw expression: ").concat(text.trim()), range);
          }
          else {
              warn("invalid expression: ".concat(e.message, " in\n\n") +
                  "    ".concat(exp, "\n\n") +
                  "  Raw expression: ".concat(text.trim(), "\n"), range);
          }
      }
  }
  function checkFunctionParameterExpression(exp, text, warn, range) {
      try {
          new Function(exp, '');
      }
      catch (e) {
          warn("invalid function parameter expression: ".concat(e.message, " in\n\n") +
              "    ".concat(exp, "\n\n") +
              "  Raw expression: ".concat(text.trim(), "\n"), range);
      }
  }

  var range = 2;
  function generateCodeFrame(source, start, end) {
      if (start === void 0) { start = 0; }
      if (end === void 0) { end = source.length; }
      var lines = source.split(/\r?\n/);
      var count = 0;
      var res = [];
      for (var i = 0; i < lines.length; i++) {
          count += lines[i].length + 1;
          if (count >= start) {
              for (var j = i - range; j <= i + range || end > count; j++) {
                  if (j < 0 || j >= lines.length)
                      continue;
                  res.push("".concat(j + 1).concat(repeat(" ", 3 - String(j + 1).length), "|  ").concat(lines[j]));
                  var lineLength = lines[j].length;
                  if (j === i) {
                      // push underline
                      var pad = start - (count - lineLength) + 1;
                      var length_1 = end > count ? lineLength - pad : end - start;
                      res.push("   |  " + repeat(" ", pad) + repeat("^", length_1));
                  }
                  else if (j > i) {
                      if (end > count) {
                          var length_2 = Math.min(end - count, lineLength);
                          res.push("   |  " + repeat("^", length_2));
                      }
                      count += lineLength + 1;
                  }
              }
              break;
          }
      }
      return res.join('\n');
  }
  function repeat(str, n) {
      var result = '';
      if (n > 0) {
          // eslint-disable-next-line no-constant-condition
          while (true) {
              // eslint-disable-line
              if (n & 1)
                  result += str;
              n >>>= 1;
              if (n <= 0)
                  break;
              str += str;
          }
      }
      return result;
  }

  function createFunction(code, errors) {
      try {
          return new Function(code);
      }
      catch (err) {
          errors.push({ err: err, code: code });
          return noop;
      }
  }
  function createCompileToFunctionFn(compile) {
      var cache = Object.create(null);
      return function compileToFunctions(template, options, vm) {
          options = extend({}, options);
          var warn = options.warn || warn$2;
          delete options.warn;
          /* istanbul ignore if */
          {
              // detect possible CSP restriction
              try {
                  new Function('return 1');
              }
              catch (e) {
                  if (e.toString().match(/unsafe-eval|CSP/)) {
                      warn('It seems you are using the standalone build of Vue.js in an ' +
                          'environment with Content Security Policy that prohibits unsafe-eval. ' +
                          'The template compiler cannot work in this environment. Consider ' +
                          'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
                          'templates into render functions.');
                  }
              }
          }
          // check cache
          var key = options.delimiters
              ? String(options.delimiters) + template
              : template;
          if (cache[key]) {
              return cache[key];
          }
          // compile
          var compiled = compile(template, options);
          // check compilation errors/tips
          {
              if (compiled.errors && compiled.errors.length) {
                  if (options.outputSourceRange) {
                      compiled.errors.forEach(function (e) {
                          warn("Error compiling template:\n\n".concat(e.msg, "\n\n") +
                              generateCodeFrame(template, e.start, e.end), vm);
                      });
                  }
                  else {
                      warn("Error compiling template:\n\n".concat(template, "\n\n") +
                          compiled.errors.map(function (e) { return "- ".concat(e); }).join('\n') +
                          '\n', vm);
                  }
              }
              if (compiled.tips && compiled.tips.length) {
                  if (options.outputSourceRange) {
                      compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
                  }
                  else {
                      compiled.tips.forEach(function (msg) { return tip(msg, vm); });
                  }
              }
          }
          // turn code into functions
          var res = {};
          var fnGenErrors = [];
          res.render = createFunction(compiled.render, fnGenErrors);
          res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
              return createFunction(code, fnGenErrors);
          });
          // check function generation errors.
          // this should only happen if there is a bug in the compiler itself.
          // mostly for codegen development use
          /* istanbul ignore if */
          {
              if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
                  warn("Failed to generate render function:\n\n" +
                      fnGenErrors
                          .map(function (_a) {
                          var err = _a.err, code = _a.code;
                          return "".concat(err.toString(), " in\n\n").concat(code, "\n");
                      })
                          .join('\n'), vm);
              }
          }
          return (cache[key] = res);
      };
  }

  function createCompilerCreator(baseCompile) {
      return function createCompiler(baseOptions) {
          function compile(template, options) {
              var finalOptions = Object.create(baseOptions);
              var errors = [];
              var tips = [];
              var warn = function (msg, range, tip) {
                  (tip ? tips : errors).push(msg);
              };
              if (options) {
                  if (options.outputSourceRange) {
                      // $flow-disable-line
                      var leadingSpaceLength_1 = template.match(/^\s*/)[0].length;
                      warn = function (msg, range, tip) {
                          var data = typeof msg === 'string' ? { msg: msg } : msg;
                          if (range) {
                              if (range.start != null) {
                                  data.start = range.start + leadingSpaceLength_1;
                              }
                              if (range.end != null) {
                                  data.end = range.end + leadingSpaceLength_1;
                              }
                          }
                          (tip ? tips : errors).push(data);
                      };
                  }
                  // merge custom modules
                  if (options.modules) {
                      finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                  }
                  // merge custom directives
                  if (options.directives) {
                      finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
                  }
                  // copy other options
                  for (var key in options) {
                      if (key !== 'modules' && key !== 'directives') {
                          finalOptions[key] = options[key];
                      }
                  }
              }
              finalOptions.warn = warn;
              var compiled = baseCompile(template.trim(), finalOptions);
              {
                  detectErrors(compiled.ast, warn);
              }
              compiled.errors = errors;
              compiled.tips = tips;
              return compiled;
          }
          return {
              compile: compile,
              compileToFunctions: createCompileToFunctionFn(compile)
          };
      };
  }

  // `createCompilerCreator` allows creating compilers that use alternative
  // parser/optimizer/codegen, e.g the SSR optimizing compiler.
  // Here we just export a default compiler using the default parts.
  var createCompiler = createCompilerCreator(function baseCompile(template, options) {
      var ast = parse(template.trim(), options);
      if (options.optimize !== false) {
          optimize(ast, options);
      }
      var code = generate(ast, options);
      return {
          ast: ast,
          render: code.render,
          staticRenderFns: code.staticRenderFns
      };
  });

  var _a = createCompiler(baseOptions), compileToFunctions = _a.compileToFunctions;

  // check whether current browser encodes a char inside attribute values
  var div;
  function getShouldDecode(href) {
      div = div || document.createElement('div');
      div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
      return div.innerHTML.indexOf('&#10;') > 0;
  }
  // #3663: IE encodes newlines inside attribute values while other browsers don't
  var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
  // #6828: chrome encodes content in a[href]
  var shouldDecodeNewlinesForHref = inBrowser
      ? getShouldDecode(true)
      : false;

  var idToTemplate = cached(function (id) {
      var el = query(id);
      return el && el.innerHTML;
  });
  var mount = Vue.prototype.$mount;
  Vue.prototype.$mount = function (el, hydrating) {
      el = el && query(el);
      /* istanbul ignore if */
      if (el === document.body || el === document.documentElement) {
          warn$2("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
          return this;
      }
      var options = this.$options;
      // resolve template/el and convert to render function
      if (!options.render) {
          var template = options.template;
          if (template) {
              if (typeof template === 'string') {
                  if (template.charAt(0) === '#') {
                      template = idToTemplate(template);
                      /* istanbul ignore if */
                      if (!template) {
                          warn$2("Template element not found or is empty: ".concat(options.template), this);
                      }
                  }
              }
              else if (template.nodeType) {
                  template = template.innerHTML;
              }
              else {
                  {
                      warn$2('invalid template option:' + template, this);
                  }
                  return this;
              }
          }
          else if (el) {
              // @ts-expect-error
              template = getOuterHTML(el);
          }
          if (template) {
              /* istanbul ignore if */
              if (config.performance && mark) {
                  mark('compile');
              }
              var _a = compileToFunctions(template, {
                  outputSourceRange: true,
                  shouldDecodeNewlines: shouldDecodeNewlines,
                  shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                  delimiters: options.delimiters,
                  comments: options.comments
              }, this), render = _a.render, staticRenderFns = _a.staticRenderFns;
              options.render = render;
              options.staticRenderFns = staticRenderFns;
              /* istanbul ignore if */
              if (config.performance && mark) {
                  mark('compile end');
                  measure("vue ".concat(this._name, " compile"), 'compile', 'compile end');
              }
          }
      }
      return mount.call(this, el, hydrating);
  };
  /**
   * Get outerHTML of elements, taking care
   * of SVG elements in IE as well.
   */
  function getOuterHTML(el) {
      if (el.outerHTML) {
          return el.outerHTML;
      }
      else {
          var container = document.createElement('div');
          container.appendChild(el.cloneNode(true));
          return container.innerHTML;
      }
  }
  Vue.compile = compileToFunctions;

  // export type EffectScheduler = (...args: any[]) => any
  /**
   * @internal since we are not exposing this in Vue 2, it's used only for
   * internal testing.
   */
  function effect(fn, scheduler) {
      var watcher = new Watcher(currentInstance, fn, noop, {
          sync: true
      });
      if (scheduler) {
          watcher.update = function () {
              scheduler(function () { return watcher.run(); });
          };
      }
  }

  extend(Vue, vca);
  Vue.effect = effect;

  return Vue;

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../webpack/buildin/global.js */ 102), __webpack_require__(/*! ./../../timers-browserify/main.js */ 1151).setImmediate))

/***/ }),
/* 32 */
/* exports provided: VERSION, root, ArrayProto, ObjProto, SymbolProto, push, slice, toString, hasOwnProperty, supportsArrayBuffer, supportsDataView, nativeIsArray, nativeKeys, nativeCreate, nativeIsView, _isNaN, _isFinite, hasEnumBug, nonEnumerableProps, MAX_ARRAY_INDEX */
/* exports used: VERSION, ArrayProto, push, slice, MAX_ARRAY_INDEX, hasOwnProperty, nativeCreate, hasEnumBug, nonEnumerableProps, ObjProto, nativeKeys, toString, supportsDataView, SymbolProto, nativeIsView, supportsArrayBuffer, _isNaN, _isFinite, root, nativeIsArray */
/*!****************************************!*\
  !*** ./~/underscore/modules/_setup.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArrayProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SymbolProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return supportsArrayBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return supportsDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return nativeIsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return nativeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return nativeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return nativeIsView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _isFinite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasEnumBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return nonEnumerableProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MAX_ARRAY_INDEX; });
// Current version.
var VERSION = '1.13.6';

// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root = (typeof self == 'object' && self.self === self && self) ||
          (typeof global == 'object' && global.global === global && global) ||
          Function('return this')() ||
          {};

// Save bytes in the minified (but not gzipped) version:
var ArrayProto = Array.prototype, ObjProto = Object.prototype;
var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

// Create quick reference variables for speed access to core prototypes.
var push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

// Modern feature detection.
var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
    supportsDataView = typeof DataView !== 'undefined';

// All **ECMAScript 5+** native function implementations that we hope to use
// are declared here.
var nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create,
    nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

// Create references to these builtin functions because we override them.
var _isNaN = isNaN,
    _isFinite = isFinite;

// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
  'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

// The largest integer that can be represented exactly.
var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../webpack/buildin/global.js */ 102)))

/***/ }),
/* 33 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./client/components/layout/filterPortlet/FilterPortlet.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-c75fdef8","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./FilterPortlet.vue */ 1551)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./FilterPortlet.vue */ 823),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-c75fdef8"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./filterPortlet.pug */ 1457),
  /* scopeId */
  "data-v-c75fdef8",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/layout/filterPortlet/FilterPortlet.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FilterPortlet.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c75fdef8", Component.options)
  } else {
    hotAPI.reload("data-v-c75fdef8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 34 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./client/utils/grid-load-transition.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateLoadingRows = exports.stopTreeGridLoading = exports.startTreeGridLoading = undefined;

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _LoadingPlaceholder = __webpack_require__(/*! ../components/loading/LoadingPlaceholder.vue */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingGif = __webpack_require__(/*! ../assets/loading-gif/loading.svg */ 67);

var intervals = {};

var appendMessageToLoading = function appendMessageToLoading(target, messages) {
  var length = messages.length;
  if (length === 0) {
    return;
  }
  var translatedMessages = messages.map(function (message) {
    return _vue2.default.i18n.translate(message);
  });

  var span = document.createElement('span');
  span.id = 'span-' + target.id;

  span.style.cssText = '\n    position: relative;\n    display: block;\n    color: #13556A;\n    font-family: \'Inter\', sans-serif;\nfont-weight: 700;\n    font-size: 25px;\n    top: 65%;\n    width: 100%;\n    text-align: center;\n    z-index: 1000000;';

  target.appendChild(span);

  var counter = 1;
  span.innerText = translatedMessages[0];
  intervals[span.id] = setInterval(function () {
    span.innerText = translatedMessages[counter % length];
    counter++;
  }, 2500);
};

var startTreeGridLoading = function startTreeGridLoading(idGrid) {
  var messages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['geral.loading.andamento', 'geral.loading.preparandoGrid'];
  var isScrollable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var element = document.querySelector(idGrid);
  if (element) {
    if (document.getElementById('botoesExportacoes')) {
      document.getElementById('botoesExportacoes').style.display = 'none';
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(element.children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;

        child.remove();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    element.style.background = 'url(' + loadingGif + ') 50% 50% no-repeat';
    element.style.backgroundSize = '100px';
    element.style.cursor = 'wait';

    appendMessageToLoading(element, messages);

    if (isScrollable) {
      setTimeout(function () {
        element.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  }
};

var stopTreeGridLoading = function stopTreeGridLoading(idGrid) {
  var element = document.querySelector(idGrid);
  if (element) {
    if (document.getElementById('botoesExportacoes')) {
      document.getElementById('botoesExportacoes').style.display = 'block';
    }

    element.style.background = 'inherit';
    element.style.cursor = 'initial';
    var spanMessages = element.querySelector('#span-' + element.id);
    if (spanMessages) {
      if (intervals[spanMessages.id]) {
        clearInterval(intervals[spanMessages.id]);
        delete intervals[spanMessages.id];
      }
      spanMessages.remove();
    }
    setTimeout(function () {
      element.scrollIntoView({ behavior: 'smooth' });
    }, 200);
  }
};

var generateLoadingRows = function generateLoadingRows(number) {
  return Array(number).fill(_LoadingPlaceholder2.default, 0, number);
};

exports.startTreeGridLoading = startTreeGridLoading;
exports.stopTreeGridLoading = stopTreeGridLoading;
exports.generateLoadingRows = generateLoadingRows;

/***/ }),
/* 35 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/babel-runtime/core-js/object/assign.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/assign */ 966), __esModule: true };

/***/ }),
/* 36 */
/* exports provided: mathMin, mathMax, mathAbs, mathCeil, mathFloor, mathPow, mathRound */
/* exports used: mathMax, mathRound, mathFloor, mathPow, mathMin, mathCeil, mathAbs */
/*!*******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/math.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mathMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mathMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return mathAbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return mathCeil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mathFloor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mathPow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mathRound; });
// Math utilty functions
var mathMin = Math.min;
var mathMax = Math.max;
var mathAbs = Math.abs;
var mathCeil = Math.ceil;
var mathFloor = Math.floor;
var mathPow = Math.pow;
var mathRound = Math.round;

/***/ }),
/* 37 */
/* exports provided: makeModelMixin */
/* exports used: makeModelMixin */
/*!********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/model.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeModelMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__props__ = __webpack_require__(/*! ./props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var makeModelMixin = function makeModelMixin(prop) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? __WEBPACK_IMPORTED_MODULE_2__constants_props__["f" /* PROP_TYPE_ANY */] : _ref$type,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? undefined : _ref$defaultValue,
      _ref$validator = _ref.validator,
      validator = _ref$validator === void 0 ? undefined : _ref$validator,
      _ref$event = _ref.event,
      event = _ref$event === void 0 ? __WEBPACK_IMPORTED_MODULE_1__constants_events__["y" /* EVENT_NAME_INPUT */] : _ref$event;

  var props = _defineProperty({}, prop, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__props__["a" /* makeProp */])(type, defaultValue, validator)); // @vue/component


  var mixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
    model: {
      prop: prop,
      event: event
    },
    props: props
  });
  return {
    mixin: mixin,
    props: props,
    prop: prop,
    event: event
  };
};

/***/ }),
/* 38 */
/* exports provided: looseEqual */
/* exports used: looseEqual */
/*!**************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/loose-equal.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return looseEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(/*! ./object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inspect__ = __webpack_require__(/*! ./inspect */ 9);

 // Assumes both a and b are arrays!
// Handles when arrays are "sparse" (array.every(...) doesn't handle sparse)

var compareArrays = function compareArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var equal = true;

  for (var i = 0; equal && i < a.length; i++) {
    equal = looseEqual(a[i], b[i]);
  }

  return equal;
};
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 * Returns boolean true or false
 */


var looseEqual = function looseEqual(a, b) {
  if (a === b) {
    return true;
  }

  var aValidType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["b" /* isDate */])(a);
  var bValidType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["b" /* isDate */])(b);

  if (aValidType || bValidType) {
    return aValidType && bValidType ? a.getTime() === b.getTime() : false;
  }

  aValidType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["c" /* isArray */])(a);
  bValidType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["c" /* isArray */])(b);

  if (aValidType || bValidType) {
    return aValidType && bValidType ? compareArrays(a, b) : false;
  }

  aValidType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["d" /* isObject */])(a);
  bValidType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__inspect__["d" /* isObject */])(b);

  if (aValidType || bValidType) {
    /* istanbul ignore if: this if will probably never be called */
    if (!aValidType || !bValidType) {
      return false;
    }

    var aKeysCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["a" /* keys */])(a).length;
    var bKeysCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["a" /* keys */])(b).length;

    if (aKeysCount !== bKeysCount) {
      return false;
    }

    for (var key in a) {
      var aHasKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["c" /* hasOwnProperty */])(a, key);
      var bHasKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["c" /* hasOwnProperty */])(b, key);

      if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) {
        return false;
      }
    }
  }

  return String(a) === String(b);
};

/***/ }),
/* 39 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/core-js/library/modules/_core.js ***!
  \********************************************/
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 40 */
/* exports provided: RX_ARRAY_NOTATION, RX_BV_PREFIX, RX_DIGITS, RX_EXTENSION, RX_HASH, RX_HASH_ID, RX_HTML_TAGS, RX_HYPHENATE, RX_LOWER_UPPER, RX_NUMBER, RX_PLUS, RX_REGEXP_REPLACE, RX_SPACES, RX_SPACE_SPLIT, RX_STAR, RX_START_SPACE_WORD, RX_TRIM_LEFT, RX_TRIM_RIGHT, RX_UNDERSCORE, RX_UN_KEBAB, RX_DATE, RX_DATE_SPLIT, RX_TIME, RX_HREF, RX_ENCODED_COMMA, RX_ENCODE_REVERSE, RX_QUERY_START, RX_ASPECT, RX_ASPECT_SEPARATOR, RX_COL_CLASS, RX_ICON_PREFIX, RX_STRIP_LOCALE_MODS */
/* exports used: RX_DIGITS, RX_NUMBER, RX_HYPHENATE, RX_UN_KEBAB, RX_UNDERSCORE, RX_LOWER_UPPER, RX_START_SPACE_WORD, RX_REGEXP_REPLACE, RX_TRIM_LEFT, RX_TRIM_RIGHT, RX_ARRAY_NOTATION, RX_BV_PREFIX, RX_SPACE_SPLIT, RX_HASH_ID, RX_HASH, RX_HREF, RX_ENCODE_REVERSE, RX_ENCODED_COMMA, RX_QUERY_START, RX_PLUS, RX_TIME, RX_DATE, RX_DATE_SPLIT, RX_STRIP_LOCALE_MODS, RX_HTML_TAGS, RX_SPACES, RX_COL_CLASS, RX_EXTENSION, RX_STAR, RX_ASPECT, RX_ASPECT_SEPARATOR, RX_ICON_PREFIX */
/*!************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/regex.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RX_ARRAY_NOTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RX_BV_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RX_DIGITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return RX_EXTENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RX_HASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RX_HASH_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return RX_HTML_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RX_HYPHENATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RX_LOWER_UPPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RX_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RX_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RX_REGEXP_REPLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return RX_SPACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RX_SPACE_SPLIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RX_STAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RX_START_SPACE_WORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RX_TRIM_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RX_TRIM_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RX_UNDERSCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RX_UN_KEBAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return RX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return RX_DATE_SPLIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RX_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RX_HREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RX_ENCODED_COMMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RX_ENCODE_REVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RX_QUERY_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RX_ASPECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return RX_ASPECT_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return RX_COL_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return RX_ICON_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RX_STRIP_LOCALE_MODS; });
// --- General ---
var RX_ARRAY_NOTATION = /\[(\d+)]/g;
var RX_BV_PREFIX = /^(BV?)/;
var RX_DIGITS = /^\d+$/;
var RX_EXTENSION = /^\..+/;
var RX_HASH = /^#/;
var RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/;
var RX_HTML_TAGS = /(<([^>]+)>)/gi;
var RX_HYPHENATE = /\B([A-Z])/g;
var RX_LOWER_UPPER = /([a-z])([A-Z])/g;
var RX_NUMBER = /^[0-9]*\.?[0-9]+$/;
var RX_PLUS = /\+/g;
var RX_REGEXP_REPLACE = /[-/\\^$*+?.()|[\]{}]/g;
var RX_SPACES = /[\s\uFEFF\xA0]+/g;
var RX_SPACE_SPLIT = /\s+/;
var RX_STAR = /\/\*$/;
var RX_START_SPACE_WORD = /(\s|^)(\w)/g;
var RX_TRIM_LEFT = /^\s+/;
var RX_TRIM_RIGHT = /\s+$/;
var RX_UNDERSCORE = /_/g;
var RX_UN_KEBAB = /-(\w)/g; // --- Date ---
// Loose YYYY-MM-DD matching, ignores any appended time inforation
// Matches '1999-12-20', '1999-1-1', '1999-01-20T22:51:49.118Z', '1999-01-02 13:00:00'

var RX_DATE = /^\d+-\d\d?-\d\d?(?:\s|T|$)/; // Used to split off the date parts of the YYYY-MM-DD string

var RX_DATE_SPLIT = /-|\s|T/; // Time string RegEx (optional seconds)

var RX_TIME = /^([0-1]?[0-9]|2[0-3]):[0-5]?[0-9](:[0-5]?[0-9])?$/; // --- URL ---
// HREFs must end with a hash followed by at least one non-hash character

var RX_HREF = /^.*(#[^#]+)$/;
var RX_ENCODED_COMMA = /%2C/g;
var RX_ENCODE_REVERSE = /[!'()*]/g;
var RX_QUERY_START = /^(\?|#|&)/; // --- Aspect ---

var RX_ASPECT = /^\d+(\.\d*)?[/:]\d+(\.\d*)?$/;
var RX_ASPECT_SEPARATOR = /[/:]/; // --- Grid ---

var RX_COL_CLASS = /^col-/; // --- Icon ---

var RX_ICON_PREFIX = /^BIcon/; // --- Locale ---

var RX_STRIP_LOCALE_MODS = /-u-.+/;

/***/ }),
/* 41 */
/* exports provided: attrsMixin */
/* exports used: attrsMixin */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/attrs.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attrsMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_cache__ = __webpack_require__(/*! ../utils/cache */ 463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue__ = __webpack_require__(/*! ../vue */ 0);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var attrsMixinVue2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_cache__["a" /* makePropCacheMixin */])('$attrs', 'bvAttrs');
var attrsMixinVue3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue__["d" /* extend */])({
  computed: {
    bvAttrs: function bvAttrs() {
      var bvAttrs = _objectSpread({}, this.$attrs);

      Object.keys(bvAttrs).forEach(function (key) {
        if (bvAttrs[key] === undefined) {
          delete bvAttrs[key];
        }
      });
      return bvAttrs;
    }
  }
});
var attrsMixin = __WEBPACK_IMPORTED_MODULE_1__vue__["c" /* isVue3 */] ? attrsMixinVue3 : attrsMixinVue2;

/***/ }),
/* 42 */
/* exports provided: stripTags, htmlOrText */
/* exports used: htmlOrText, stripTags */
/*!*******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/html.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stripTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlOrText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
 // Removes anything that looks like an HTML tag from the supplied string

var stripTags = function stripTags() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(text).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["y" /* RX_HTML_TAGS */], '');
}; // Generate a `domProps` object for either `innerHTML`, `textContent` or an empty object

var htmlOrText = function htmlOrText(innerHTML, textContent) {
  return innerHTML ? {
    innerHTML: innerHTML
  } : textContent ? {
    textContent: textContent
  } : {};
};

/***/ }),
/* 43 */
/* exports provided: CODE_BACKSPACE, CODE_BREAK, CODE_DELETE, CODE_DOWN, CODE_END, CODE_ENTER, CODE_ESC, CODE_HOME, CODE_LEFT, CODE_PAGEDOWN, CODE_PAGEUP, CODE_RIGHT, CODE_SPACE, CODE_UP */
/* exports used: CODE_ENTER, CODE_SPACE, CODE_LEFT, CODE_RIGHT, CODE_UP, CODE_DOWN, CODE_HOME, CODE_END, CODE_PAGEUP, CODE_PAGEDOWN, CODE_ESC, CODE_DELETE, CODE_BACKSPACE */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/key-codes.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CODE_BACKSPACE; });
/* unused harmony export CODE_BREAK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CODE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CODE_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CODE_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CODE_ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CODE_ESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CODE_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CODE_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CODE_PAGEDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CODE_PAGEUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CODE_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CODE_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CODE_UP; });
var CODE_BACKSPACE = 8;
var CODE_BREAK = 19;
var CODE_DELETE = 46;
var CODE_DOWN = 40;
var CODE_END = 35;
var CODE_ENTER = 13;
var CODE_ESC = 27;
var CODE_HOME = 36;
var CODE_LEFT = 37;
var CODE_PAGEDOWN = 34;
var CODE_PAGEUP = 33;
var CODE_RIGHT = 39;
var CODE_SPACE = 32;
var CODE_UP = 38;

/***/ }),
/* 44 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/keys.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(/*! ./isObject.js */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(/*! ./_has.js */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__ = __webpack_require__(/*! ./_collectNonEnumProps.js */ 635);





// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys(obj) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["k" /* nativeKeys */]) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__setup_js__["k" /* nativeKeys */])(obj);
  var keys = [];
  for (var key in obj) if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, key)) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 45 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./build/jsonToExcel/exportRoutes.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SERVER_NODE = 'http://' + location.hostname + ':8089/banking-api';

var EXPORT_TREEGRID = SERVER_NODE + '/treegrid/exportTreeGrid';

module.exports = {
  EXPORT_TREEGRID: EXPORT_TREEGRID
};

/***/ }),
/* 46 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./client/utils/customSorter.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  stringSorter: function stringSorter(ascending, a, b, columnName) {
    var regexMap = {
      a: new RegExp('[ÁÀÂÃ]', 'gi'),
      e: new RegExp('[ÉÈÊ&]', 'gi'),
      i: new RegExp('[ÍÌÎ]', 'gi'),
      o: new RegExp('[ÓÒÔÕ]', 'gi'),
      u: new RegExp('[ÚÙÛ]', 'gi'),
      c: new RegExp('[Ç]', 'gi')
    };

    var comparableStringA = a && a[columnName] ? a[columnName].toLowerCase() : '';
    var comparableStringB = b && b[columnName] ? b[columnName].toLowerCase() : '';
    for (var regex in regexMap) {
      comparableStringA = comparableStringA.replace(regexMap[regex], regex);
      comparableStringB = comparableStringB.replace(regexMap[regex], regex);
    }
    if (ascending) {
      return comparableStringA >= comparableStringB ? 1 : -1;
    }
    return comparableStringA <= comparableStringB ? 1 : -1;
  },

  booleanSorter: function booleanSorter(ascending, a, b, columnName) {
    var comparableStringA = a[columnName] ? 1 : 0;
    var comparableStringB = b[columnName] ? 1 : 0;
    if (ascending) {
      return comparableStringA >= comparableStringB ? 1 : -1;
    }
    return comparableStringA <= comparableStringB ? 1 : -1;
  },

  dateSorter: function dateSorter(ascending, a, b, columnName) {
    var dateA = new Date(a[columnName]);
    var dateB = new Date(b[columnName]);
    if (ascending) {
      return dateA - dateB;
    }
    return dateB - dateA;
  },

  cleanLowerString: function cleanLowerString(name) {
    var regexMap = {
      a: new RegExp('[ÁÀÂÃ@]', 'gi'),
      e: new RegExp('[ÉÈÊẼ&]', 'gi'),
      i: new RegExp('[ÍÌÎĨ]', 'gi'),
      o: new RegExp('[ÓÒÔÕ]', 'gi'),
      u: new RegExp('[ÚÙÛŨ]', 'gi'),
      c: new RegExp('[Ç]', 'gi')
    };

    var cleanString = name ? name.toLowerCase() : '';
    for (var regex in regexMap) {
      cleanString = cleanString.replace(regexMap[regex], regex);
    }
    return cleanString;
  },

  cleanUpperString: function cleanUpperString(name) {
    var regexMap = {
      A: new RegExp('[ÁÀÂÃ@]', 'gi'),
      E: new RegExp('[ÉÈÊẼ&]', 'gi'),
      I: new RegExp('[ÍÌÎĨ]', 'gi'),
      O: new RegExp('[ÓÒÔÕ]', 'gi'),
      U: new RegExp('[ÚÙÛŨ]', 'gi'),
      C: new RegExp('[Ç]', 'gi')
    };

    var cleanString = name ? name.toUpperCase() : '';
    for (var regex in regexMap) {
      cleanString = cleanString.replace(regexMap[regex], regex);
    }

    return cleanString.replace(new RegExp('[^0-9a-zA-Z]+'), '');
  },

  arrayDottedSorter: function arrayDottedSorter(data, field, order) {
    var isNumber = function isNumber(v) {
      return (+v).toString() === v;
    };

    var sort = {
      asc: function asc(a, b) {
        var i = 0;
        var l = Math.min(a.value.length, b.value.length);

        while (i < l && a.value[i] === b.value[i]) {
          i++;
        }
        if (i === l) {
          return a.value.length - b.value.length;
        }
        if (isNumber(a.value[i]) && isNumber(b.value[i])) {
          return a.value[i] - b.value[i];
        }
        return a.value[i].localeCompare(b.value[i]);
      },
      desc: function desc(a, b) {
        return sort.asc(b, a);
      }
    };
    var mapped = data.map(function (el, i) {
      return { index: i, value: el[field].split('.') };
    });

    mapped.sort(sort[order] || sort.asc);
    return mapped.map(function (el) {
      return data[el.index];
    });
  }
};

/***/ }),
/* 47 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/babel-runtime/core-js/get-iterator.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/get-iterator */ 961), __esModule: true };

/***/ }),
/* 48 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/babel-runtime/helpers/toConsumableArray.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(/*! ../core-js/array/from */ 164);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 49 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/modules/_export.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ./_global */ 55);
var core = __webpack_require__(/*! ./_core */ 39);
var ctx = __webpack_require__(/*! ./_ctx */ 96);
var hide = __webpack_require__(/*! ./_hide */ 97);
var has = __webpack_require__(/*! ./_has */ 112);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 50 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/_tagTester.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tagTester;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// Internal function for creating a `toString`-based type tester.
function tagTester(name) {
  var tag = '[object ' + name + ']';
  return function(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* toString */].call(obj) === tag;
  };
}


/***/ }),
/* 51 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./client/components/input/dateRange/DateRange.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-44b39af4","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./DateRange.vue */ 1509)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./DateRange.vue */ 816),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-44b39af4"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./dateRange.pug */ 1407),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/input/dateRange/DateRange.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DateRange.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44b39af4", Component.options)
  } else {
    hotAPI.reload("data-v-44b39af4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 52 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./client/components/treeGrid/TreeGrid.vue ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-dd048d2a","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./TreeGrid.vue */ 1555)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./TreeGrid.vue */ 874),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-dd048d2a"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./treeGrid.pug */ 1461),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/treeGrid/TreeGrid.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TreeGrid.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dd048d2a", Component.options)
  } else {
    hotAPI.reload("data-v-dd048d2a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 53 */
/* exports provided: routerLinkProps, nuxtLinkProps, props, BLink */
/* exports used: BLink, props */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/link/link.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routerLinkProps */
/* unused harmony export nuxtLinkProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_router__ = __webpack_require__(/*! ../../utils/router */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















 // --- Constants ---

var ROOT_EVENT_NAME_CLICKED = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["m" /* NAME_LINK */], 'clicked'); // --- Props ---
// `<router-link>` specific props

var routerLinkProps = {
  activeClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  append: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  event: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  exact: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  exactActiveClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  exactPath: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  exactPathActiveClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  replace: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  routerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["j" /* PROP_TYPE_OBJECT_STRING */])
}; // `<nuxt-link>` specific props

var nuxtLinkProps = {
  noPrefetch: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Must be `null` to fall back to the value defined in the
  // `nuxt.config.js` configuration file for `router.prefetchLinks`
  // We convert `null` to `undefined`, so that Nuxt.js will use the
  // compiled default
  // Vue treats `undefined` as default of `false` for Boolean props,
  // so we must set it as `null` here to be a true tri-state prop
  prefetch: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null)
}; // All `<b-link>` props

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, nuxtLinkProps), routerLinkProps), {}, {
  active: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  href: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Must be `null` if no value provided
  rel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], null),
  // To support 3rd party router links based on `<router-link>` (i.e. `g-link` for Gridsome)
  // Default is to auto choose between `<router-link>` and `<nuxt-link>`
  // Gridsome doesn't provide a mechanism to auto detect and has caveats
  // such as not supporting FQDN URLs or hash only URLs
  routerComponentName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], '_self')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["m" /* NAME_LINK */]); // --- Main component ---
// @vue/component

var BLink = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["m" /* NAME_LINK */],
  // Mixin order is important!
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inheritAttrs: false,
  props: props,
  computed: {
    computedTag: function computedTag() {
      // We don't pass `this` as the first arg as we need reactivity of the props
      var to = this.to,
          disabled = this.disabled,
          routerComponentName = this.routerComponentName;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_router__["b" /* computeTag */])({
        to: to,
        disabled: disabled,
        routerComponentName: routerComponentName
      }, this);
    },
    isRouterLink: function isRouterLink() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_router__["c" /* isRouterLink */])(this.computedTag);
    },
    computedRel: function computedRel() {
      // We don't pass `this` as the first arg as we need reactivity of the props
      var target = this.target,
          rel = this.rel;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_router__["d" /* computeRel */])({
        target: target,
        rel: rel
      });
    },
    computedHref: function computedHref() {
      // We don't pass `this` as the first arg as we need reactivity of the props
      var to = this.to,
          href = this.href;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_router__["e" /* computeHref */])({
        to: to,
        href: href
      }, this.computedTag);
    },
    computedProps: function computedProps() {
      var event = this.event,
          prefetch = this.prefetch,
          routerTag = this.routerTag;
      return this.isRouterLink ? _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["c" /* pluckProps */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(_objectSpread(_objectSpread({}, routerLinkProps), this.computedTag === 'nuxt-link' ? nuxtLinkProps : {}), ['event', 'prefetch', 'routerTag']), this)), event ? {
        event: event
      } : {}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["k" /* isBoolean */])(prefetch) ? {
        prefetch: prefetch
      } : {}), routerTag ? {
        tag: routerTag
      } : {}) : {};
    },
    computedAttrs: function computedAttrs() {
      var bvAttrs = this.bvAttrs,
          href = this.computedHref,
          rel = this.computedRel,
          disabled = this.disabled,
          target = this.target,
          routerTag = this.routerTag,
          isRouterLink = this.isRouterLink;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, bvAttrs), href ? {
        href: href
      } : {}), isRouterLink && routerTag && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["p" /* isTag */])(routerTag, 'a') ? {} : {
        rel: rel,
        target: target
      }), {}, {
        tabindex: disabled ? '-1' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["i" /* isUndefined */])(bvAttrs.tabindex) ? null : bvAttrs.tabindex,
        'aria-disabled': disabled ? 'true' : null
      });
    },
    computedListeners: function computedListeners() {
      return _objectSpread(_objectSpread({}, this.bvListeners), {}, {
        // We want to overwrite any click handler since our callback
        // will invoke the user supplied handler(s) if `!this.disabled`
        click: this.onClick
      });
    }
  },
  methods: {
    onClick: function onClick(event) {
      var _arguments = arguments;
      var eventIsEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["l" /* isEvent */])(event);
      var isRouterLink = this.isRouterLink;
      var suppliedHandler = this.bvListeners.click;

      if (eventIsEvent && this.disabled) {
        // Stop event from bubbling up
        // Kill the event loop attached to this specific `EventTarget`
        // Needed to prevent `vue-router` for doing its thing
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["f" /* stopEvent */])(event, {
          immediatePropagation: true
        });
      } else {
        // Router links do not emit instance `click` events, so we
        // add in an `$emit('click', event)` on its Vue instance
        //
        // seems not to be required for Vue3 compat build

        /* istanbul ignore next: difficult to test, but we know it works */
        if (isRouterLink) {
          var _event$currentTarget$;

          (_event$currentTarget$ = event.currentTarget.__vue__) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["x" /* EVENT_NAME_CLICK */], event);
        } // Call the suppliedHandler(s), if any provided


        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["b" /* concat */])(suppliedHandler).filter(function (h) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["a" /* isFunction */])(h);
        }).forEach(function (handler) {
          handler.apply(void 0, _toConsumableArray(_arguments));
        }); // Emit the global `$root` click event

        this.emitOnRoot(ROOT_EVENT_NAME_CLICKED, event); // TODO: Remove deprecated 'clicked::link' event with next major release

        this.emitOnRoot('clicked::link', event);
      } // Stop scroll-to-top behavior or navigation on
      // regular links when href is just '#'


      if (eventIsEvent && !isRouterLink && this.computedHref === '#') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
      }
    },
    focus: function focus() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(this.$el);
    },
    blur: function blur() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["A" /* attemptBlur */])(this.$el);
    }
  },
  render: function render(h) {
    var active = this.active,
        disabled = this.disabled;
    return h(this.computedTag, _defineProperty({
      class: {
        active: active,
        disabled: disabled
      },
      attrs: this.computedAttrs,
      props: this.computedProps
    }, this.isRouterLink ? 'nativeOn' : 'on', this.computedListeners), this.normalizeSlot());
  }
});

/***/ }),
/* 54 */
/* exports provided: warn, warnNotClient, warnNoPromiseSupport, warnNoMutationObserverSupport */
/* exports used: warn, warnNoMutationObserverSupport, warnNotClient, warnNoPromiseSupport */
/*!*******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/warn.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return warnNotClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return warnNoPromiseSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return warnNoMutationObserverSupport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_env__ = __webpack_require__(/*! ../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(/*! ./env */ 957);


/**
 * Log a warning message to the console with BootstrapVue formatting
 * @param {string} message
 */

var warn = function warn(message)
/* istanbul ignore next */
{
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__env__["a" /* getNoWarn */])()) {
    console.warn("[BootstrapVue warn]: ".concat(source ? "".concat(source, " - ") : '').concat(message));
  }
};
/**
 * Warn when no Promise support is given
 * @param {string} source
 * @returns {boolean} warned
 */

var warnNotClient = function warnNotClient(source) {
  /* istanbul ignore else */
  if (__WEBPACK_IMPORTED_MODULE_0__constants_env__["e" /* IS_BROWSER */]) {
    return false;
  } else {
    warn("".concat(source, ": Can not be called during SSR."));
    return true;
  }
};
/**
 * Warn when no Promise support is given
 * @param {string} source
 * @returns {boolean} warned
 */

var warnNoPromiseSupport = function warnNoPromiseSupport(source) {
  /* istanbul ignore else */
  if (__WEBPACK_IMPORTED_MODULE_0__constants_env__["f" /* HAS_PROMISE_SUPPORT */]) {
    return false;
  } else {
    warn("".concat(source, ": Requires Promise support."));
    return true;
  }
};
/**
 * Warn when no MutationObserver support is given
 * @param {string} source
 * @returns {boolean} warned
 */

var warnNoMutationObserverSupport = function warnNoMutationObserverSupport(source) {
  /* istanbul ignore else */
  if (__WEBPACK_IMPORTED_MODULE_0__constants_env__["g" /* HAS_MUTATION_OBSERVER_SUPPORT */]) {
    return false;
  } else {
    warn("".concat(source, ": Requires MutationObserver support."));
    return true;
  }
};

/***/ }),
/* 55 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/modules/_global.js ***!
  \**********************************************/
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 56 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/core-js/library/modules/_wks.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(/*! ./_shared */ 269)('wks');
var uid = __webpack_require__(/*! ./_uid */ 188);
var Symbol = __webpack_require__(/*! ./_global */ 55).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 57 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/merge/lib/src/index.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlainObject = exports.clone = exports.recursive = exports.merge = exports.main = void 0;
module.exports = exports = main;
exports.default = main;
function main() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return merge.apply(void 0, items);
}
exports.main = main;
main.clone = clone;
main.isPlainObject = isPlainObject;
main.recursive = recursive;
function merge() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return _merge(items[0] === true, false, items);
}
exports.merge = merge;
function recursive() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return _merge(items[0] === true, true, items);
}
exports.recursive = recursive;
function clone(input) {
    if (Array.isArray(input)) {
        var output = [];
        for (var index = 0; index < input.length; ++index)
            output.push(clone(input[index]));
        return output;
    }
    else if (isPlainObject(input)) {
        var output = {};
        for (var index in input)
            output[index] = clone(input[index]);
        return output;
    }
    else {
        return input;
    }
}
exports.clone = clone;
function isPlainObject(input) {
    return input && typeof input === 'object' && !Array.isArray(input);
}
exports.isPlainObject = isPlainObject;
function _recursiveMerge(base, extend) {
    if (!isPlainObject(base))
        return extend;
    for (var key in extend) {
        if (key === '__proto__' || key === 'constructor' || key === 'prototype')
            continue;
        base[key] = (isPlainObject(base[key]) && isPlainObject(extend[key])) ?
            _recursiveMerge(base[key], extend[key]) :
            extend[key];
    }
    return base;
}
function _merge(isClone, isRecursive, items) {
    var result;
    if (isClone || !isPlainObject(result = items.shift()))
        result = {};
    for (var index = 0; index < items.length; ++index) {
        var item = items[index];
        if (!isPlainObject(item))
            continue;
        for (var key in item) {
            if (key === '__proto__' || key === 'constructor' || key === 'prototype')
                continue;
            var value = isClone ? clone(item[key]) : item[key];
            result[key] = isRecursive ? _recursiveMerge(result[key], value) : value;
        }
    }
    return result;
}


/***/ }),
/* 58 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/_cb.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(/*! ./_baseIteratee.js */ 633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iteratee_js__ = __webpack_require__(/*! ./iteratee.js */ 667);




// The function we call internally to generate a callback. It invokes
// `_.iteratee` if overridden, otherwise `baseIteratee`.
function cb(value, context, argCount) {
  if (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee !== __WEBPACK_IMPORTED_MODULE_2__iteratee_js__["a" /* default */]) return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee(value, context);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, argCount);
}


/***/ }),
/* 59 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./client/components/modals/confirmModal/ConfirmModal.vue ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-bb3b5fcc","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./ConfirmModal.vue */ 1549)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ConfirmModal.vue */ 834),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-bb3b5fcc"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./confirmModal.pug */ 1454),
  /* scopeId */
  "data-v-bb3b5fcc",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/confirmModal/ConfirmModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConfirmModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bb3b5fcc", Component.options)
  } else {
    hotAPI.reload("data-v-bb3b5fcc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 60 */
/* no static exports found */
/* all exports used */
/*!******************************!*\
  !*** ./~/axios/lib/utils.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ 311);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 61 */
/* exports provided: BIconBlank, BIconAlarm, BIconAlarmFill, BIconAlignBottom, BIconAlignCenter, BIconAlignEnd, BIconAlignMiddle, BIconAlignStart, BIconAlignTop, BIconAlt, BIconApp, BIconAppIndicator, BIconArchive, BIconArchiveFill, BIconArrow90degDown, BIconArrow90degLeft, BIconArrow90degRight, BIconArrow90degUp, BIconArrowBarDown, BIconArrowBarLeft, BIconArrowBarRight, BIconArrowBarUp, BIconArrowClockwise, BIconArrowCounterclockwise, BIconArrowDown, BIconArrowDownCircle, BIconArrowDownCircleFill, BIconArrowDownLeft, BIconArrowDownLeftCircle, BIconArrowDownLeftCircleFill, BIconArrowDownLeftSquare, BIconArrowDownLeftSquareFill, BIconArrowDownRight, BIconArrowDownRightCircle, BIconArrowDownRightCircleFill, BIconArrowDownRightSquare, BIconArrowDownRightSquareFill, BIconArrowDownShort, BIconArrowDownSquare, BIconArrowDownSquareFill, BIconArrowDownUp, BIconArrowLeft, BIconArrowLeftCircle, BIconArrowLeftCircleFill, BIconArrowLeftRight, BIconArrowLeftShort, BIconArrowLeftSquare, BIconArrowLeftSquareFill, BIconArrowRepeat, BIconArrowReturnLeft, BIconArrowReturnRight, BIconArrowRight, BIconArrowRightCircle, BIconArrowRightCircleFill, BIconArrowRightShort, BIconArrowRightSquare, BIconArrowRightSquareFill, BIconArrowUp, BIconArrowUpCircle, BIconArrowUpCircleFill, BIconArrowUpLeft, BIconArrowUpLeftCircle, BIconArrowUpLeftCircleFill, BIconArrowUpLeftSquare, BIconArrowUpLeftSquareFill, BIconArrowUpRight, BIconArrowUpRightCircle, BIconArrowUpRightCircleFill, BIconArrowUpRightSquare, BIconArrowUpRightSquareFill, BIconArrowUpShort, BIconArrowUpSquare, BIconArrowUpSquareFill, BIconArrowsAngleContract, BIconArrowsAngleExpand, BIconArrowsCollapse, BIconArrowsExpand, BIconArrowsFullscreen, BIconArrowsMove, BIconAspectRatio, BIconAspectRatioFill, BIconAsterisk, BIconAt, BIconAward, BIconAwardFill, BIconBack, BIconBackspace, BIconBackspaceFill, BIconBackspaceReverse, BIconBackspaceReverseFill, BIconBadge3d, BIconBadge3dFill, BIconBadge4k, BIconBadge4kFill, BIconBadge8k, BIconBadge8kFill, BIconBadgeAd, BIconBadgeAdFill, BIconBadgeAr, BIconBadgeArFill, BIconBadgeCc, BIconBadgeCcFill, BIconBadgeHd, BIconBadgeHdFill, BIconBadgeTm, BIconBadgeTmFill, BIconBadgeVo, BIconBadgeVoFill, BIconBadgeVr, BIconBadgeVrFill, BIconBadgeWc, BIconBadgeWcFill, BIconBag, BIconBagCheck, BIconBagCheckFill, BIconBagDash, BIconBagDashFill, BIconBagFill, BIconBagPlus, BIconBagPlusFill, BIconBagX, BIconBagXFill, BIconBank, BIconBank2, BIconBarChart, BIconBarChartFill, BIconBarChartLine, BIconBarChartLineFill, BIconBarChartSteps, BIconBasket, BIconBasket2, BIconBasket2Fill, BIconBasket3, BIconBasket3Fill, BIconBasketFill, BIconBattery, BIconBatteryCharging, BIconBatteryFull, BIconBatteryHalf, BIconBell, BIconBellFill, BIconBellSlash, BIconBellSlashFill, BIconBezier, BIconBezier2, BIconBicycle, BIconBinoculars, BIconBinocularsFill, BIconBlockquoteLeft, BIconBlockquoteRight, BIconBook, BIconBookFill, BIconBookHalf, BIconBookmark, BIconBookmarkCheck, BIconBookmarkCheckFill, BIconBookmarkDash, BIconBookmarkDashFill, BIconBookmarkFill, BIconBookmarkHeart, BIconBookmarkHeartFill, BIconBookmarkPlus, BIconBookmarkPlusFill, BIconBookmarkStar, BIconBookmarkStarFill, BIconBookmarkX, BIconBookmarkXFill, BIconBookmarks, BIconBookmarksFill, BIconBookshelf, BIconBootstrap, BIconBootstrapFill, BIconBootstrapReboot, BIconBorder, BIconBorderAll, BIconBorderBottom, BIconBorderCenter, BIconBorderInner, BIconBorderLeft, BIconBorderMiddle, BIconBorderOuter, BIconBorderRight, BIconBorderStyle, BIconBorderTop, BIconBorderWidth, BIconBoundingBox, BIconBoundingBoxCircles, BIconBox, BIconBoxArrowDown, BIconBoxArrowDownLeft, BIconBoxArrowDownRight, BIconBoxArrowInDown, BIconBoxArrowInDownLeft, BIconBoxArrowInDownRight, BIconBoxArrowInLeft, BIconBoxArrowInRight, BIconBoxArrowInUp, BIconBoxArrowInUpLeft, BIconBoxArrowInUpRight, BIconBoxArrowLeft, BIconBoxArrowRight, BIconBoxArrowUp, BIconBoxArrowUpLeft, BIconBoxArrowUpRight, BIconBoxSeam, BIconBraces, BIconBricks, BIconBriefcase, BIconBriefcaseFill, BIconBrightnessAltHigh, BIconBrightnessAltHighFill, BIconBrightnessAltLow, BIconBrightnessAltLowFill, BIconBrightnessHigh, BIconBrightnessHighFill, BIconBrightnessLow, BIconBrightnessLowFill, BIconBroadcast, BIconBroadcastPin, BIconBrush, BIconBrushFill, BIconBucket, BIconBucketFill, BIconBug, BIconBugFill, BIconBuilding, BIconBullseye, BIconCalculator, BIconCalculatorFill, BIconCalendar, BIconCalendar2, BIconCalendar2Check, BIconCalendar2CheckFill, BIconCalendar2Date, BIconCalendar2DateFill, BIconCalendar2Day, BIconCalendar2DayFill, BIconCalendar2Event, BIconCalendar2EventFill, BIconCalendar2Fill, BIconCalendar2Minus, BIconCalendar2MinusFill, BIconCalendar2Month, BIconCalendar2MonthFill, BIconCalendar2Plus, BIconCalendar2PlusFill, BIconCalendar2Range, BIconCalendar2RangeFill, BIconCalendar2Week, BIconCalendar2WeekFill, BIconCalendar2X, BIconCalendar2XFill, BIconCalendar3, BIconCalendar3Event, BIconCalendar3EventFill, BIconCalendar3Fill, BIconCalendar3Range, BIconCalendar3RangeFill, BIconCalendar3Week, BIconCalendar3WeekFill, BIconCalendar4, BIconCalendar4Event, BIconCalendar4Range, BIconCalendar4Week, BIconCalendarCheck, BIconCalendarCheckFill, BIconCalendarDate, BIconCalendarDateFill, BIconCalendarDay, BIconCalendarDayFill, BIconCalendarEvent, BIconCalendarEventFill, BIconCalendarFill, BIconCalendarMinus, BIconCalendarMinusFill, BIconCalendarMonth, BIconCalendarMonthFill, BIconCalendarPlus, BIconCalendarPlusFill, BIconCalendarRange, BIconCalendarRangeFill, BIconCalendarWeek, BIconCalendarWeekFill, BIconCalendarX, BIconCalendarXFill, BIconCamera, BIconCamera2, BIconCameraFill, BIconCameraReels, BIconCameraReelsFill, BIconCameraVideo, BIconCameraVideoFill, BIconCameraVideoOff, BIconCameraVideoOffFill, BIconCapslock, BIconCapslockFill, BIconCardChecklist, BIconCardHeading, BIconCardImage, BIconCardList, BIconCardText, BIconCaretDown, BIconCaretDownFill, BIconCaretDownSquare, BIconCaretDownSquareFill, BIconCaretLeft, BIconCaretLeftFill, BIconCaretLeftSquare, BIconCaretLeftSquareFill, BIconCaretRight, BIconCaretRightFill, BIconCaretRightSquare, BIconCaretRightSquareFill, BIconCaretUp, BIconCaretUpFill, BIconCaretUpSquare, BIconCaretUpSquareFill, BIconCart, BIconCart2, BIconCart3, BIconCart4, BIconCartCheck, BIconCartCheckFill, BIconCartDash, BIconCartDashFill, BIconCartFill, BIconCartPlus, BIconCartPlusFill, BIconCartX, BIconCartXFill, BIconCash, BIconCashCoin, BIconCashStack, BIconCast, BIconChat, BIconChatDots, BIconChatDotsFill, BIconChatFill, BIconChatLeft, BIconChatLeftDots, BIconChatLeftDotsFill, BIconChatLeftFill, BIconChatLeftQuote, BIconChatLeftQuoteFill, BIconChatLeftText, BIconChatLeftTextFill, BIconChatQuote, BIconChatQuoteFill, BIconChatRight, BIconChatRightDots, BIconChatRightDotsFill, BIconChatRightFill, BIconChatRightQuote, BIconChatRightQuoteFill, BIconChatRightText, BIconChatRightTextFill, BIconChatSquare, BIconChatSquareDots, BIconChatSquareDotsFill, BIconChatSquareFill, BIconChatSquareQuote, BIconChatSquareQuoteFill, BIconChatSquareText, BIconChatSquareTextFill, BIconChatText, BIconChatTextFill, BIconCheck, BIconCheck2, BIconCheck2All, BIconCheck2Circle, BIconCheck2Square, BIconCheckAll, BIconCheckCircle, BIconCheckCircleFill, BIconCheckLg, BIconCheckSquare, BIconCheckSquareFill, BIconChevronBarContract, BIconChevronBarDown, BIconChevronBarExpand, BIconChevronBarLeft, BIconChevronBarRight, BIconChevronBarUp, BIconChevronCompactDown, BIconChevronCompactLeft, BIconChevronCompactRight, BIconChevronCompactUp, BIconChevronContract, BIconChevronDoubleDown, BIconChevronDoubleLeft, BIconChevronDoubleRight, BIconChevronDoubleUp, BIconChevronDown, BIconChevronExpand, BIconChevronLeft, BIconChevronRight, BIconChevronUp, BIconCircle, BIconCircleFill, BIconCircleHalf, BIconCircleSquare, BIconClipboard, BIconClipboardCheck, BIconClipboardData, BIconClipboardMinus, BIconClipboardPlus, BIconClipboardX, BIconClock, BIconClockFill, BIconClockHistory, BIconCloud, BIconCloudArrowDown, BIconCloudArrowDownFill, BIconCloudArrowUp, BIconCloudArrowUpFill, BIconCloudCheck, BIconCloudCheckFill, BIconCloudDownload, BIconCloudDownloadFill, BIconCloudDrizzle, BIconCloudDrizzleFill, BIconCloudFill, BIconCloudFog, BIconCloudFog2, BIconCloudFog2Fill, BIconCloudFogFill, BIconCloudHail, BIconCloudHailFill, BIconCloudHaze, BIconCloudHaze1, BIconCloudHaze2Fill, BIconCloudHazeFill, BIconCloudLightning, BIconCloudLightningFill, BIconCloudLightningRain, BIconCloudLightningRainFill, BIconCloudMinus, BIconCloudMinusFill, BIconCloudMoon, BIconCloudMoonFill, BIconCloudPlus, BIconCloudPlusFill, BIconCloudRain, BIconCloudRainFill, BIconCloudRainHeavy, BIconCloudRainHeavyFill, BIconCloudSlash, BIconCloudSlashFill, BIconCloudSleet, BIconCloudSleetFill, BIconCloudSnow, BIconCloudSnowFill, BIconCloudSun, BIconCloudSunFill, BIconCloudUpload, BIconCloudUploadFill, BIconClouds, BIconCloudsFill, BIconCloudy, BIconCloudyFill, BIconCode, BIconCodeSlash, BIconCodeSquare, BIconCoin, BIconCollection, BIconCollectionFill, BIconCollectionPlay, BIconCollectionPlayFill, BIconColumns, BIconColumnsGap, BIconCommand, BIconCompass, BIconCompassFill, BIconCone, BIconConeStriped, BIconController, BIconCpu, BIconCpuFill, BIconCreditCard, BIconCreditCard2Back, BIconCreditCard2BackFill, BIconCreditCard2Front, BIconCreditCard2FrontFill, BIconCreditCardFill, BIconCrop, BIconCup, BIconCupFill, BIconCupStraw, BIconCurrencyBitcoin, BIconCurrencyDollar, BIconCurrencyEuro, BIconCurrencyExchange, BIconCurrencyPound, BIconCurrencyYen, BIconCursor, BIconCursorFill, BIconCursorText, BIconDash, BIconDashCircle, BIconDashCircleDotted, BIconDashCircleFill, BIconDashLg, BIconDashSquare, BIconDashSquareDotted, BIconDashSquareFill, BIconDiagram2, BIconDiagram2Fill, BIconDiagram3, BIconDiagram3Fill, BIconDiamond, BIconDiamondFill, BIconDiamondHalf, BIconDice1, BIconDice1Fill, BIconDice2, BIconDice2Fill, BIconDice3, BIconDice3Fill, BIconDice4, BIconDice4Fill, BIconDice5, BIconDice5Fill, BIconDice6, BIconDice6Fill, BIconDisc, BIconDiscFill, BIconDiscord, BIconDisplay, BIconDisplayFill, BIconDistributeHorizontal, BIconDistributeVertical, BIconDoorClosed, BIconDoorClosedFill, BIconDoorOpen, BIconDoorOpenFill, BIconDot, BIconDownload, BIconDroplet, BIconDropletFill, BIconDropletHalf, BIconEarbuds, BIconEasel, BIconEaselFill, BIconEgg, BIconEggFill, BIconEggFried, BIconEject, BIconEjectFill, BIconEmojiAngry, BIconEmojiAngryFill, BIconEmojiDizzy, BIconEmojiDizzyFill, BIconEmojiExpressionless, BIconEmojiExpressionlessFill, BIconEmojiFrown, BIconEmojiFrownFill, BIconEmojiHeartEyes, BIconEmojiHeartEyesFill, BIconEmojiLaughing, BIconEmojiLaughingFill, BIconEmojiNeutral, BIconEmojiNeutralFill, BIconEmojiSmile, BIconEmojiSmileFill, BIconEmojiSmileUpsideDown, BIconEmojiSmileUpsideDownFill, BIconEmojiSunglasses, BIconEmojiSunglassesFill, BIconEmojiWink, BIconEmojiWinkFill, BIconEnvelope, BIconEnvelopeFill, BIconEnvelopeOpen, BIconEnvelopeOpenFill, BIconEraser, BIconEraserFill, BIconExclamation, BIconExclamationCircle, BIconExclamationCircleFill, BIconExclamationDiamond, BIconExclamationDiamondFill, BIconExclamationLg, BIconExclamationOctagon, BIconExclamationOctagonFill, BIconExclamationSquare, BIconExclamationSquareFill, BIconExclamationTriangle, BIconExclamationTriangleFill, BIconExclude, BIconEye, BIconEyeFill, BIconEyeSlash, BIconEyeSlashFill, BIconEyedropper, BIconEyeglasses, BIconFacebook, BIconFile, BIconFileArrowDown, BIconFileArrowDownFill, BIconFileArrowUp, BIconFileArrowUpFill, BIconFileBarGraph, BIconFileBarGraphFill, BIconFileBinary, BIconFileBinaryFill, BIconFileBreak, BIconFileBreakFill, BIconFileCheck, BIconFileCheckFill, BIconFileCode, BIconFileCodeFill, BIconFileDiff, BIconFileDiffFill, BIconFileEarmark, BIconFileEarmarkArrowDown, BIconFileEarmarkArrowDownFill, BIconFileEarmarkArrowUp, BIconFileEarmarkArrowUpFill, BIconFileEarmarkBarGraph, BIconFileEarmarkBarGraphFill, BIconFileEarmarkBinary, BIconFileEarmarkBinaryFill, BIconFileEarmarkBreak, BIconFileEarmarkBreakFill, BIconFileEarmarkCheck, BIconFileEarmarkCheckFill, BIconFileEarmarkCode, BIconFileEarmarkCodeFill, BIconFileEarmarkDiff, BIconFileEarmarkDiffFill, BIconFileEarmarkEasel, BIconFileEarmarkEaselFill, BIconFileEarmarkExcel, BIconFileEarmarkExcelFill, BIconFileEarmarkFill, BIconFileEarmarkFont, BIconFileEarmarkFontFill, BIconFileEarmarkImage, BIconFileEarmarkImageFill, BIconFileEarmarkLock, BIconFileEarmarkLock2, BIconFileEarmarkLock2Fill, BIconFileEarmarkLockFill, BIconFileEarmarkMedical, BIconFileEarmarkMedicalFill, BIconFileEarmarkMinus, BIconFileEarmarkMinusFill, BIconFileEarmarkMusic, BIconFileEarmarkMusicFill, BIconFileEarmarkPdf, BIconFileEarmarkPdfFill, BIconFileEarmarkPerson, BIconFileEarmarkPersonFill, BIconFileEarmarkPlay, BIconFileEarmarkPlayFill, BIconFileEarmarkPlus, BIconFileEarmarkPlusFill, BIconFileEarmarkPost, BIconFileEarmarkPostFill, BIconFileEarmarkPpt, BIconFileEarmarkPptFill, BIconFileEarmarkRichtext, BIconFileEarmarkRichtextFill, BIconFileEarmarkRuled, BIconFileEarmarkRuledFill, BIconFileEarmarkSlides, BIconFileEarmarkSlidesFill, BIconFileEarmarkSpreadsheet, BIconFileEarmarkSpreadsheetFill, BIconFileEarmarkText, BIconFileEarmarkTextFill, BIconFileEarmarkWord, BIconFileEarmarkWordFill, BIconFileEarmarkX, BIconFileEarmarkXFill, BIconFileEarmarkZip, BIconFileEarmarkZipFill, BIconFileEasel, BIconFileEaselFill, BIconFileExcel, BIconFileExcelFill, BIconFileFill, BIconFileFont, BIconFileFontFill, BIconFileImage, BIconFileImageFill, BIconFileLock, BIconFileLock2, BIconFileLock2Fill, BIconFileLockFill, BIconFileMedical, BIconFileMedicalFill, BIconFileMinus, BIconFileMinusFill, BIconFileMusic, BIconFileMusicFill, BIconFilePdf, BIconFilePdfFill, BIconFilePerson, BIconFilePersonFill, BIconFilePlay, BIconFilePlayFill, BIconFilePlus, BIconFilePlusFill, BIconFilePost, BIconFilePostFill, BIconFilePpt, BIconFilePptFill, BIconFileRichtext, BIconFileRichtextFill, BIconFileRuled, BIconFileRuledFill, BIconFileSlides, BIconFileSlidesFill, BIconFileSpreadsheet, BIconFileSpreadsheetFill, BIconFileText, BIconFileTextFill, BIconFileWord, BIconFileWordFill, BIconFileX, BIconFileXFill, BIconFileZip, BIconFileZipFill, BIconFiles, BIconFilesAlt, BIconFilm, BIconFilter, BIconFilterCircle, BIconFilterCircleFill, BIconFilterLeft, BIconFilterRight, BIconFilterSquare, BIconFilterSquareFill, BIconFlag, BIconFlagFill, BIconFlower1, BIconFlower2, BIconFlower3, BIconFolder, BIconFolder2, BIconFolder2Open, BIconFolderCheck, BIconFolderFill, BIconFolderMinus, BIconFolderPlus, BIconFolderSymlink, BIconFolderSymlinkFill, BIconFolderX, BIconFonts, BIconForward, BIconForwardFill, BIconFront, BIconFullscreen, BIconFullscreenExit, BIconFunnel, BIconFunnelFill, BIconGear, BIconGearFill, BIconGearWide, BIconGearWideConnected, BIconGem, BIconGenderAmbiguous, BIconGenderFemale, BIconGenderMale, BIconGenderTrans, BIconGeo, BIconGeoAlt, BIconGeoAltFill, BIconGeoFill, BIconGift, BIconGiftFill, BIconGithub, BIconGlobe, BIconGlobe2, BIconGoogle, BIconGraphDown, BIconGraphUp, BIconGrid, BIconGrid1x2, BIconGrid1x2Fill, BIconGrid3x2, BIconGrid3x2Gap, BIconGrid3x2GapFill, BIconGrid3x3, BIconGrid3x3Gap, BIconGrid3x3GapFill, BIconGridFill, BIconGripHorizontal, BIconGripVertical, BIconHammer, BIconHandIndex, BIconHandIndexFill, BIconHandIndexThumb, BIconHandIndexThumbFill, BIconHandThumbsDown, BIconHandThumbsDownFill, BIconHandThumbsUp, BIconHandThumbsUpFill, BIconHandbag, BIconHandbagFill, BIconHash, BIconHdd, BIconHddFill, BIconHddNetwork, BIconHddNetworkFill, BIconHddRack, BIconHddRackFill, BIconHddStack, BIconHddStackFill, BIconHeadphones, BIconHeadset, BIconHeadsetVr, BIconHeart, BIconHeartFill, BIconHeartHalf, BIconHeptagon, BIconHeptagonFill, BIconHeptagonHalf, BIconHexagon, BIconHexagonFill, BIconHexagonHalf, BIconHourglass, BIconHourglassBottom, BIconHourglassSplit, BIconHourglassTop, BIconHouse, BIconHouseDoor, BIconHouseDoorFill, BIconHouseFill, BIconHr, BIconHurricane, BIconImage, BIconImageAlt, BIconImageFill, BIconImages, BIconInbox, BIconInboxFill, BIconInboxes, BIconInboxesFill, BIconInfo, BIconInfoCircle, BIconInfoCircleFill, BIconInfoLg, BIconInfoSquare, BIconInfoSquareFill, BIconInputCursor, BIconInputCursorText, BIconInstagram, BIconIntersect, BIconJournal, BIconJournalAlbum, BIconJournalArrowDown, BIconJournalArrowUp, BIconJournalBookmark, BIconJournalBookmarkFill, BIconJournalCheck, BIconJournalCode, BIconJournalMedical, BIconJournalMinus, BIconJournalPlus, BIconJournalRichtext, BIconJournalText, BIconJournalX, BIconJournals, BIconJoystick, BIconJustify, BIconJustifyLeft, BIconJustifyRight, BIconKanban, BIconKanbanFill, BIconKey, BIconKeyFill, BIconKeyboard, BIconKeyboardFill, BIconLadder, BIconLamp, BIconLampFill, BIconLaptop, BIconLaptopFill, BIconLayerBackward, BIconLayerForward, BIconLayers, BIconLayersFill, BIconLayersHalf, BIconLayoutSidebar, BIconLayoutSidebarInset, BIconLayoutSidebarInsetReverse, BIconLayoutSidebarReverse, BIconLayoutSplit, BIconLayoutTextSidebar, BIconLayoutTextSidebarReverse, BIconLayoutTextWindow, BIconLayoutTextWindowReverse, BIconLayoutThreeColumns, BIconLayoutWtf, BIconLifePreserver, BIconLightbulb, BIconLightbulbFill, BIconLightbulbOff, BIconLightbulbOffFill, BIconLightning, BIconLightningCharge, BIconLightningChargeFill, BIconLightningFill, BIconLink, BIconLink45deg, BIconLinkedin, BIconList, BIconListCheck, BIconListNested, BIconListOl, BIconListStars, BIconListTask, BIconListUl, BIconLock, BIconLockFill, BIconMailbox, BIconMailbox2, BIconMap, BIconMapFill, BIconMarkdown, BIconMarkdownFill, BIconMask, BIconMastodon, BIconMegaphone, BIconMegaphoneFill, BIconMenuApp, BIconMenuAppFill, BIconMenuButton, BIconMenuButtonFill, BIconMenuButtonWide, BIconMenuButtonWideFill, BIconMenuDown, BIconMenuUp, BIconMessenger, BIconMic, BIconMicFill, BIconMicMute, BIconMicMuteFill, BIconMinecart, BIconMinecartLoaded, BIconMoisture, BIconMoon, BIconMoonFill, BIconMoonStars, BIconMoonStarsFill, BIconMouse, BIconMouse2, BIconMouse2Fill, BIconMouse3, BIconMouse3Fill, BIconMouseFill, BIconMusicNote, BIconMusicNoteBeamed, BIconMusicNoteList, BIconMusicPlayer, BIconMusicPlayerFill, BIconNewspaper, BIconNodeMinus, BIconNodeMinusFill, BIconNodePlus, BIconNodePlusFill, BIconNut, BIconNutFill, BIconOctagon, BIconOctagonFill, BIconOctagonHalf, BIconOption, BIconOutlet, BIconPaintBucket, BIconPalette, BIconPalette2, BIconPaletteFill, BIconPaperclip, BIconParagraph, BIconPatchCheck, BIconPatchCheckFill, BIconPatchExclamation, BIconPatchExclamationFill, BIconPatchMinus, BIconPatchMinusFill, BIconPatchPlus, BIconPatchPlusFill, BIconPatchQuestion, BIconPatchQuestionFill, BIconPause, BIconPauseBtn, BIconPauseBtnFill, BIconPauseCircle, BIconPauseCircleFill, BIconPauseFill, BIconPeace, BIconPeaceFill, BIconPen, BIconPenFill, BIconPencil, BIconPencilFill, BIconPencilSquare, BIconPentagon, BIconPentagonFill, BIconPentagonHalf, BIconPeople, BIconPeopleFill, BIconPercent, BIconPerson, BIconPersonBadge, BIconPersonBadgeFill, BIconPersonBoundingBox, BIconPersonCheck, BIconPersonCheckFill, BIconPersonCircle, BIconPersonDash, BIconPersonDashFill, BIconPersonFill, BIconPersonLinesFill, BIconPersonPlus, BIconPersonPlusFill, BIconPersonSquare, BIconPersonX, BIconPersonXFill, BIconPhone, BIconPhoneFill, BIconPhoneLandscape, BIconPhoneLandscapeFill, BIconPhoneVibrate, BIconPhoneVibrateFill, BIconPieChart, BIconPieChartFill, BIconPiggyBank, BIconPiggyBankFill, BIconPin, BIconPinAngle, BIconPinAngleFill, BIconPinFill, BIconPinMap, BIconPinMapFill, BIconPip, BIconPipFill, BIconPlay, BIconPlayBtn, BIconPlayBtnFill, BIconPlayCircle, BIconPlayCircleFill, BIconPlayFill, BIconPlug, BIconPlugFill, BIconPlus, BIconPlusCircle, BIconPlusCircleDotted, BIconPlusCircleFill, BIconPlusLg, BIconPlusSquare, BIconPlusSquareDotted, BIconPlusSquareFill, BIconPower, BIconPrinter, BIconPrinterFill, BIconPuzzle, BIconPuzzleFill, BIconQuestion, BIconQuestionCircle, BIconQuestionCircleFill, BIconQuestionDiamond, BIconQuestionDiamondFill, BIconQuestionLg, BIconQuestionOctagon, BIconQuestionOctagonFill, BIconQuestionSquare, BIconQuestionSquareFill, BIconRainbow, BIconReceipt, BIconReceiptCutoff, BIconReception0, BIconReception1, BIconReception2, BIconReception3, BIconReception4, BIconRecord, BIconRecord2, BIconRecord2Fill, BIconRecordBtn, BIconRecordBtnFill, BIconRecordCircle, BIconRecordCircleFill, BIconRecordFill, BIconRecycle, BIconReddit, BIconReply, BIconReplyAll, BIconReplyAllFill, BIconReplyFill, BIconRss, BIconRssFill, BIconRulers, BIconSafe, BIconSafe2, BIconSafe2Fill, BIconSafeFill, BIconSave, BIconSave2, BIconSave2Fill, BIconSaveFill, BIconScissors, BIconScrewdriver, BIconSdCard, BIconSdCardFill, BIconSearch, BIconSegmentedNav, BIconServer, BIconShare, BIconShareFill, BIconShield, BIconShieldCheck, BIconShieldExclamation, BIconShieldFill, BIconShieldFillCheck, BIconShieldFillExclamation, BIconShieldFillMinus, BIconShieldFillPlus, BIconShieldFillX, BIconShieldLock, BIconShieldLockFill, BIconShieldMinus, BIconShieldPlus, BIconShieldShaded, BIconShieldSlash, BIconShieldSlashFill, BIconShieldX, BIconShift, BIconShiftFill, BIconShop, BIconShopWindow, BIconShuffle, BIconSignpost, BIconSignpost2, BIconSignpost2Fill, BIconSignpostFill, BIconSignpostSplit, BIconSignpostSplitFill, BIconSim, BIconSimFill, BIconSkipBackward, BIconSkipBackwardBtn, BIconSkipBackwardBtnFill, BIconSkipBackwardCircle, BIconSkipBackwardCircleFill, BIconSkipBackwardFill, BIconSkipEnd, BIconSkipEndBtn, BIconSkipEndBtnFill, BIconSkipEndCircle, BIconSkipEndCircleFill, BIconSkipEndFill, BIconSkipForward, BIconSkipForwardBtn, BIconSkipForwardBtnFill, BIconSkipForwardCircle, BIconSkipForwardCircleFill, BIconSkipForwardFill, BIconSkipStart, BIconSkipStartBtn, BIconSkipStartBtnFill, BIconSkipStartCircle, BIconSkipStartCircleFill, BIconSkipStartFill, BIconSkype, BIconSlack, BIconSlash, BIconSlashCircle, BIconSlashCircleFill, BIconSlashLg, BIconSlashSquare, BIconSlashSquareFill, BIconSliders, BIconSmartwatch, BIconSnow, BIconSnow2, BIconSnow3, BIconSortAlphaDown, BIconSortAlphaDownAlt, BIconSortAlphaUp, BIconSortAlphaUpAlt, BIconSortDown, BIconSortDownAlt, BIconSortNumericDown, BIconSortNumericDownAlt, BIconSortNumericUp, BIconSortNumericUpAlt, BIconSortUp, BIconSortUpAlt, BIconSoundwave, BIconSpeaker, BIconSpeakerFill, BIconSpeedometer, BIconSpeedometer2, BIconSpellcheck, BIconSquare, BIconSquareFill, BIconSquareHalf, BIconStack, BIconStar, BIconStarFill, BIconStarHalf, BIconStars, BIconStickies, BIconStickiesFill, BIconSticky, BIconStickyFill, BIconStop, BIconStopBtn, BIconStopBtnFill, BIconStopCircle, BIconStopCircleFill, BIconStopFill, BIconStoplights, BIconStoplightsFill, BIconStopwatch, BIconStopwatchFill, BIconSubtract, BIconSuitClub, BIconSuitClubFill, BIconSuitDiamond, BIconSuitDiamondFill, BIconSuitHeart, BIconSuitHeartFill, BIconSuitSpade, BIconSuitSpadeFill, BIconSun, BIconSunFill, BIconSunglasses, BIconSunrise, BIconSunriseFill, BIconSunset, BIconSunsetFill, BIconSymmetryHorizontal, BIconSymmetryVertical, BIconTable, BIconTablet, BIconTabletFill, BIconTabletLandscape, BIconTabletLandscapeFill, BIconTag, BIconTagFill, BIconTags, BIconTagsFill, BIconTelegram, BIconTelephone, BIconTelephoneFill, BIconTelephoneForward, BIconTelephoneForwardFill, BIconTelephoneInbound, BIconTelephoneInboundFill, BIconTelephoneMinus, BIconTelephoneMinusFill, BIconTelephoneOutbound, BIconTelephoneOutboundFill, BIconTelephonePlus, BIconTelephonePlusFill, BIconTelephoneX, BIconTelephoneXFill, BIconTerminal, BIconTerminalFill, BIconTextCenter, BIconTextIndentLeft, BIconTextIndentRight, BIconTextLeft, BIconTextParagraph, BIconTextRight, BIconTextarea, BIconTextareaResize, BIconTextareaT, BIconThermometer, BIconThermometerHalf, BIconThermometerHigh, BIconThermometerLow, BIconThermometerSnow, BIconThermometerSun, BIconThreeDots, BIconThreeDotsVertical, BIconToggle2Off, BIconToggle2On, BIconToggleOff, BIconToggleOn, BIconToggles, BIconToggles2, BIconTools, BIconTornado, BIconTranslate, BIconTrash, BIconTrash2, BIconTrash2Fill, BIconTrashFill, BIconTree, BIconTreeFill, BIconTriangle, BIconTriangleFill, BIconTriangleHalf, BIconTrophy, BIconTrophyFill, BIconTropicalStorm, BIconTruck, BIconTruckFlatbed, BIconTsunami, BIconTv, BIconTvFill, BIconTwitch, BIconTwitter, BIconType, BIconTypeBold, BIconTypeH1, BIconTypeH2, BIconTypeH3, BIconTypeItalic, BIconTypeStrikethrough, BIconTypeUnderline, BIconUiChecks, BIconUiChecksGrid, BIconUiRadios, BIconUiRadiosGrid, BIconUmbrella, BIconUmbrellaFill, BIconUnion, BIconUnlock, BIconUnlockFill, BIconUpc, BIconUpcScan, BIconUpload, BIconVectorPen, BIconViewList, BIconViewStacked, BIconVinyl, BIconVinylFill, BIconVoicemail, BIconVolumeDown, BIconVolumeDownFill, BIconVolumeMute, BIconVolumeMuteFill, BIconVolumeOff, BIconVolumeOffFill, BIconVolumeUp, BIconVolumeUpFill, BIconVr, BIconWallet, BIconWallet2, BIconWalletFill, BIconWatch, BIconWater, BIconWhatsapp, BIconWifi, BIconWifi1, BIconWifi2, BIconWifiOff, BIconWind, BIconWindow, BIconWindowDock, BIconWindowSidebar, BIconWrench, BIconX, BIconXCircle, BIconXCircleFill, BIconXDiamond, BIconXDiamondFill, BIconXLg, BIconXOctagon, BIconXOctagonFill, BIconXSquare, BIconXSquareFill, BIconYoutube, BIconZoomIn, BIconZoomOut */
/* exports used: BIconBlank, BIconAlarm, BIconAlarmFill, BIconAlignBottom, BIconAlignCenter, BIconAlignEnd, BIconAlignMiddle, BIconAlignStart, BIconAlignTop, BIconAlt, BIconApp, BIconAppIndicator, BIconArchive, BIconArchiveFill, BIconArrow90degDown, BIconArrow90degLeft, BIconArrow90degRight, BIconArrow90degUp, BIconArrowBarDown, BIconArrowBarLeft, BIconArrowBarRight, BIconArrowBarUp, BIconArrowClockwise, BIconArrowCounterclockwise, BIconArrowDown, BIconArrowDownCircle, BIconArrowDownCircleFill, BIconArrowDownLeft, BIconArrowDownLeftCircle, BIconArrowDownLeftCircleFill, BIconArrowDownLeftSquare, BIconArrowDownLeftSquareFill, BIconArrowDownRight, BIconArrowDownRightCircle, BIconArrowDownRightCircleFill, BIconArrowDownRightSquare, BIconArrowDownRightSquareFill, BIconArrowDownShort, BIconArrowDownSquare, BIconArrowDownSquareFill, BIconArrowDownUp, BIconArrowLeft, BIconArrowLeftCircle, BIconArrowLeftCircleFill, BIconArrowLeftRight, BIconArrowLeftShort, BIconArrowLeftSquare, BIconArrowLeftSquareFill, BIconArrowRepeat, BIconArrowReturnLeft, BIconArrowReturnRight, BIconArrowRight, BIconArrowRightCircle, BIconArrowRightCircleFill, BIconArrowRightShort, BIconArrowRightSquare, BIconArrowRightSquareFill, BIconArrowUp, BIconArrowUpCircle, BIconArrowUpCircleFill, BIconArrowUpLeft, BIconArrowUpLeftCircle, BIconArrowUpLeftCircleFill, BIconArrowUpLeftSquare, BIconArrowUpLeftSquareFill, BIconArrowUpRight, BIconArrowUpRightCircle, BIconArrowUpRightCircleFill, BIconArrowUpRightSquare, BIconArrowUpRightSquareFill, BIconArrowUpShort, BIconArrowUpSquare, BIconArrowUpSquareFill, BIconArrowsAngleContract, BIconArrowsAngleExpand, BIconArrowsCollapse, BIconArrowsExpand, BIconArrowsFullscreen, BIconArrowsMove, BIconAspectRatio, BIconAspectRatioFill, BIconAsterisk, BIconAt, BIconAward, BIconAwardFill, BIconBack, BIconBackspace, BIconBackspaceFill, BIconBackspaceReverse, BIconBackspaceReverseFill, BIconBadge3d, BIconBadge3dFill, BIconBadge4k, BIconBadge4kFill, BIconBadge8k, BIconBadge8kFill, BIconBadgeAd, BIconBadgeAdFill, BIconBadgeAr, BIconBadgeArFill, BIconBadgeCc, BIconBadgeCcFill, BIconBadgeHd, BIconBadgeHdFill, BIconBadgeTm, BIconBadgeTmFill, BIconBadgeVo, BIconBadgeVoFill, BIconBadgeVr, BIconBadgeVrFill, BIconBadgeWc, BIconBadgeWcFill, BIconBag, BIconBagCheck, BIconBagCheckFill, BIconBagDash, BIconBagDashFill, BIconBagFill, BIconBagPlus, BIconBagPlusFill, BIconBagX, BIconBagXFill, BIconBank, BIconBank2, BIconBarChart, BIconBarChartFill, BIconBarChartLine, BIconBarChartLineFill, BIconBarChartSteps, BIconBasket, BIconBasket2, BIconBasket2Fill, BIconBasket3, BIconBasket3Fill, BIconBasketFill, BIconBattery, BIconBatteryCharging, BIconBatteryFull, BIconBatteryHalf, BIconBell, BIconBellFill, BIconBellSlash, BIconBellSlashFill, BIconBezier, BIconBezier2, BIconBicycle, BIconBinoculars, BIconBinocularsFill, BIconBlockquoteLeft, BIconBlockquoteRight, BIconBook, BIconBookFill, BIconBookHalf, BIconBookmark, BIconBookmarkCheck, BIconBookmarkCheckFill, BIconBookmarkDash, BIconBookmarkDashFill, BIconBookmarkFill, BIconBookmarkHeart, BIconBookmarkHeartFill, BIconBookmarkPlus, BIconBookmarkPlusFill, BIconBookmarkStar, BIconBookmarkStarFill, BIconBookmarkX, BIconBookmarkXFill, BIconBookmarks, BIconBookmarksFill, BIconBookshelf, BIconBootstrap, BIconBootstrapFill, BIconBootstrapReboot, BIconBorder, BIconBorderAll, BIconBorderBottom, BIconBorderCenter, BIconBorderInner, BIconBorderLeft, BIconBorderMiddle, BIconBorderOuter, BIconBorderRight, BIconBorderStyle, BIconBorderTop, BIconBorderWidth, BIconBoundingBox, BIconBoundingBoxCircles, BIconBox, BIconBoxArrowDown, BIconBoxArrowDownLeft, BIconBoxArrowDownRight, BIconBoxArrowInDown, BIconBoxArrowInDownLeft, BIconBoxArrowInDownRight, BIconBoxArrowInLeft, BIconBoxArrowInRight, BIconBoxArrowInUp, BIconBoxArrowInUpLeft, BIconBoxArrowInUpRight, BIconBoxArrowLeft, BIconBoxArrowRight, BIconBoxArrowUp, BIconBoxArrowUpLeft, BIconBoxArrowUpRight, BIconBoxSeam, BIconBraces, BIconBricks, BIconBriefcase, BIconBriefcaseFill, BIconBrightnessAltHigh, BIconBrightnessAltHighFill, BIconBrightnessAltLow, BIconBrightnessAltLowFill, BIconBrightnessHigh, BIconBrightnessHighFill, BIconBrightnessLow, BIconBrightnessLowFill, BIconBroadcast, BIconBroadcastPin, BIconBrush, BIconBrushFill, BIconBucket, BIconBucketFill, BIconBug, BIconBugFill, BIconBuilding, BIconBullseye, BIconCalculator, BIconCalculatorFill, BIconCalendar, BIconCalendar2, BIconCalendar2Check, BIconCalendar2CheckFill, BIconCalendar2Date, BIconCalendar2DateFill, BIconCalendar2Day, BIconCalendar2DayFill, BIconCalendar2Event, BIconCalendar2EventFill, BIconCalendar2Fill, BIconCalendar2Minus, BIconCalendar2MinusFill, BIconCalendar2Month, BIconCalendar2MonthFill, BIconCalendar2Plus, BIconCalendar2PlusFill, BIconCalendar2Range, BIconCalendar2RangeFill, BIconCalendar2Week, BIconCalendar2WeekFill, BIconCalendar2X, BIconCalendar2XFill, BIconCalendar3, BIconCalendar3Event, BIconCalendar3EventFill, BIconCalendar3Fill, BIconCalendar3Range, BIconCalendar3RangeFill, BIconCalendar3Week, BIconCalendar3WeekFill, BIconCalendar4, BIconCalendar4Event, BIconCalendar4Range, BIconCalendar4Week, BIconCalendarCheck, BIconCalendarCheckFill, BIconCalendarDate, BIconCalendarDateFill, BIconCalendarDay, BIconCalendarDayFill, BIconCalendarEvent, BIconCalendarEventFill, BIconCalendarFill, BIconCalendarMinus, BIconCalendarMinusFill, BIconCalendarMonth, BIconCalendarMonthFill, BIconCalendarPlus, BIconCalendarPlusFill, BIconCalendarRange, BIconCalendarRangeFill, BIconCalendarWeek, BIconCalendarWeekFill, BIconCalendarX, BIconCalendarXFill, BIconCamera, BIconCamera2, BIconCameraFill, BIconCameraReels, BIconCameraReelsFill, BIconCameraVideo, BIconCameraVideoFill, BIconCameraVideoOff, BIconCameraVideoOffFill, BIconCapslock, BIconCapslockFill, BIconCardChecklist, BIconCardHeading, BIconCardImage, BIconCardList, BIconCardText, BIconCaretDown, BIconCaretDownFill, BIconCaretDownSquare, BIconCaretDownSquareFill, BIconCaretLeft, BIconCaretLeftFill, BIconCaretLeftSquare, BIconCaretLeftSquareFill, BIconCaretRight, BIconCaretRightFill, BIconCaretRightSquare, BIconCaretRightSquareFill, BIconCaretUp, BIconCaretUpFill, BIconCaretUpSquare, BIconCaretUpSquareFill, BIconCart, BIconCart2, BIconCart3, BIconCart4, BIconCartCheck, BIconCartCheckFill, BIconCartDash, BIconCartDashFill, BIconCartFill, BIconCartPlus, BIconCartPlusFill, BIconCartX, BIconCartXFill, BIconCash, BIconCashCoin, BIconCashStack, BIconCast, BIconChat, BIconChatDots, BIconChatDotsFill, BIconChatFill, BIconChatLeft, BIconChatLeftDots, BIconChatLeftDotsFill, BIconChatLeftFill, BIconChatLeftQuote, BIconChatLeftQuoteFill, BIconChatLeftText, BIconChatLeftTextFill, BIconChatQuote, BIconChatQuoteFill, BIconChatRight, BIconChatRightDots, BIconChatRightDotsFill, BIconChatRightFill, BIconChatRightQuote, BIconChatRightQuoteFill, BIconChatRightText, BIconChatRightTextFill, BIconChatSquare, BIconChatSquareDots, BIconChatSquareDotsFill, BIconChatSquareFill, BIconChatSquareQuote, BIconChatSquareQuoteFill, BIconChatSquareText, BIconChatSquareTextFill, BIconChatText, BIconChatTextFill, BIconCheck, BIconCheck2, BIconCheck2All, BIconCheck2Circle, BIconCheck2Square, BIconCheckAll, BIconCheckCircle, BIconCheckCircleFill, BIconCheckLg, BIconCheckSquare, BIconCheckSquareFill, BIconChevronBarContract, BIconChevronBarDown, BIconChevronBarExpand, BIconChevronBarLeft, BIconChevronBarRight, BIconChevronBarUp, BIconChevronCompactDown, BIconChevronCompactLeft, BIconChevronCompactRight, BIconChevronCompactUp, BIconChevronContract, BIconChevronDoubleDown, BIconChevronDoubleLeft, BIconChevronDoubleRight, BIconChevronDoubleUp, BIconChevronDown, BIconChevronExpand, BIconChevronLeft, BIconChevronRight, BIconChevronUp, BIconCircle, BIconCircleFill, BIconCircleHalf, BIconCircleSquare, BIconClipboard, BIconClipboardCheck, BIconClipboardData, BIconClipboardMinus, BIconClipboardPlus, BIconClipboardX, BIconClock, BIconClockFill, BIconClockHistory, BIconCloud, BIconCloudArrowDown, BIconCloudArrowDownFill, BIconCloudArrowUp, BIconCloudArrowUpFill, BIconCloudCheck, BIconCloudCheckFill, BIconCloudDownload, BIconCloudDownloadFill, BIconCloudDrizzle, BIconCloudDrizzleFill, BIconCloudFill, BIconCloudFog, BIconCloudFog2, BIconCloudFog2Fill, BIconCloudFogFill, BIconCloudHail, BIconCloudHailFill, BIconCloudHaze, BIconCloudHaze1, BIconCloudHaze2Fill, BIconCloudHazeFill, BIconCloudLightning, BIconCloudLightningFill, BIconCloudLightningRain, BIconCloudLightningRainFill, BIconCloudMinus, BIconCloudMinusFill, BIconCloudMoon, BIconCloudMoonFill, BIconCloudPlus, BIconCloudPlusFill, BIconCloudRain, BIconCloudRainFill, BIconCloudRainHeavy, BIconCloudRainHeavyFill, BIconCloudSlash, BIconCloudSlashFill, BIconCloudSleet, BIconCloudSleetFill, BIconCloudSnow, BIconCloudSnowFill, BIconCloudSun, BIconCloudSunFill, BIconCloudUpload, BIconCloudUploadFill, BIconClouds, BIconCloudsFill, BIconCloudy, BIconCloudyFill, BIconCode, BIconCodeSlash, BIconCodeSquare, BIconCoin, BIconCollection, BIconCollectionFill, BIconCollectionPlay, BIconCollectionPlayFill, BIconColumns, BIconColumnsGap, BIconCommand, BIconCompass, BIconCompassFill, BIconCone, BIconConeStriped, BIconController, BIconCpu, BIconCpuFill, BIconCreditCard, BIconCreditCard2Back, BIconCreditCard2BackFill, BIconCreditCard2Front, BIconCreditCard2FrontFill, BIconCreditCardFill, BIconCrop, BIconCup, BIconCupFill, BIconCupStraw, BIconCurrencyBitcoin, BIconCurrencyDollar, BIconCurrencyEuro, BIconCurrencyExchange, BIconCurrencyPound, BIconCurrencyYen, BIconCursor, BIconCursorFill, BIconCursorText, BIconDash, BIconDashCircle, BIconDashCircleDotted, BIconDashCircleFill, BIconDashLg, BIconDashSquare, BIconDashSquareDotted, BIconDashSquareFill, BIconDiagram2, BIconDiagram2Fill, BIconDiagram3, BIconDiagram3Fill, BIconDiamond, BIconDiamondFill, BIconDiamondHalf, BIconDice1, BIconDice1Fill, BIconDice2, BIconDice2Fill, BIconDice3, BIconDice3Fill, BIconDice4, BIconDice4Fill, BIconDice5, BIconDice5Fill, BIconDice6, BIconDice6Fill, BIconDisc, BIconDiscFill, BIconDiscord, BIconDisplay, BIconDisplayFill, BIconDistributeHorizontal, BIconDistributeVertical, BIconDoorClosed, BIconDoorClosedFill, BIconDoorOpen, BIconDoorOpenFill, BIconDot, BIconDownload, BIconDroplet, BIconDropletFill, BIconDropletHalf, BIconEarbuds, BIconEasel, BIconEaselFill, BIconEgg, BIconEggFill, BIconEggFried, BIconEject, BIconEjectFill, BIconEmojiAngry, BIconEmojiAngryFill, BIconEmojiDizzy, BIconEmojiDizzyFill, BIconEmojiExpressionless, BIconEmojiExpressionlessFill, BIconEmojiFrown, BIconEmojiFrownFill, BIconEmojiHeartEyes, BIconEmojiHeartEyesFill, BIconEmojiLaughing, BIconEmojiLaughingFill, BIconEmojiNeutral, BIconEmojiNeutralFill, BIconEmojiSmile, BIconEmojiSmileFill, BIconEmojiSmileUpsideDown, BIconEmojiSmileUpsideDownFill, BIconEmojiSunglasses, BIconEmojiSunglassesFill, BIconEmojiWink, BIconEmojiWinkFill, BIconEnvelope, BIconEnvelopeFill, BIconEnvelopeOpen, BIconEnvelopeOpenFill, BIconEraser, BIconEraserFill, BIconExclamation, BIconExclamationCircle, BIconExclamationCircleFill, BIconExclamationDiamond, BIconExclamationDiamondFill, BIconExclamationLg, BIconExclamationOctagon, BIconExclamationOctagonFill, BIconExclamationSquare, BIconExclamationSquareFill, BIconExclamationTriangle, BIconExclamationTriangleFill, BIconExclude, BIconEye, BIconEyeFill, BIconEyeSlash, BIconEyeSlashFill, BIconEyedropper, BIconEyeglasses, BIconFacebook, BIconFile, BIconFileArrowDown, BIconFileArrowDownFill, BIconFileArrowUp, BIconFileArrowUpFill, BIconFileBarGraph, BIconFileBarGraphFill, BIconFileBinary, BIconFileBinaryFill, BIconFileBreak, BIconFileBreakFill, BIconFileCheck, BIconFileCheckFill, BIconFileCode, BIconFileCodeFill, BIconFileDiff, BIconFileDiffFill, BIconFileEarmark, BIconFileEarmarkArrowDown, BIconFileEarmarkArrowDownFill, BIconFileEarmarkArrowUp, BIconFileEarmarkArrowUpFill, BIconFileEarmarkBarGraph, BIconFileEarmarkBarGraphFill, BIconFileEarmarkBinary, BIconFileEarmarkBinaryFill, BIconFileEarmarkBreak, BIconFileEarmarkBreakFill, BIconFileEarmarkCheck, BIconFileEarmarkCheckFill, BIconFileEarmarkCode, BIconFileEarmarkCodeFill, BIconFileEarmarkDiff, BIconFileEarmarkDiffFill, BIconFileEarmarkEasel, BIconFileEarmarkEaselFill, BIconFileEarmarkExcel, BIconFileEarmarkExcelFill, BIconFileEarmarkFill, BIconFileEarmarkFont, BIconFileEarmarkFontFill, BIconFileEarmarkImage, BIconFileEarmarkImageFill, BIconFileEarmarkLock, BIconFileEarmarkLock2, BIconFileEarmarkLock2Fill, BIconFileEarmarkLockFill, BIconFileEarmarkMedical, BIconFileEarmarkMedicalFill, BIconFileEarmarkMinus, BIconFileEarmarkMinusFill, BIconFileEarmarkMusic, BIconFileEarmarkMusicFill, BIconFileEarmarkPdf, BIconFileEarmarkPdfFill, BIconFileEarmarkPerson, BIconFileEarmarkPersonFill, BIconFileEarmarkPlay, BIconFileEarmarkPlayFill, BIconFileEarmarkPlus, BIconFileEarmarkPlusFill, BIconFileEarmarkPost, BIconFileEarmarkPostFill, BIconFileEarmarkPpt, BIconFileEarmarkPptFill, BIconFileEarmarkRichtext, BIconFileEarmarkRichtextFill, BIconFileEarmarkRuled, BIconFileEarmarkRuledFill, BIconFileEarmarkSlides, BIconFileEarmarkSlidesFill, BIconFileEarmarkSpreadsheet, BIconFileEarmarkSpreadsheetFill, BIconFileEarmarkText, BIconFileEarmarkTextFill, BIconFileEarmarkWord, BIconFileEarmarkWordFill, BIconFileEarmarkX, BIconFileEarmarkXFill, BIconFileEarmarkZip, BIconFileEarmarkZipFill, BIconFileEasel, BIconFileEaselFill, BIconFileExcel, BIconFileExcelFill, BIconFileFill, BIconFileFont, BIconFileFontFill, BIconFileImage, BIconFileImageFill, BIconFileLock, BIconFileLock2, BIconFileLock2Fill, BIconFileLockFill, BIconFileMedical, BIconFileMedicalFill, BIconFileMinus, BIconFileMinusFill, BIconFileMusic, BIconFileMusicFill, BIconFilePdf, BIconFilePdfFill, BIconFilePerson, BIconFilePersonFill, BIconFilePlay, BIconFilePlayFill, BIconFilePlus, BIconFilePlusFill, BIconFilePost, BIconFilePostFill, BIconFilePpt, BIconFilePptFill, BIconFileRichtext, BIconFileRichtextFill, BIconFileRuled, BIconFileRuledFill, BIconFileSlides, BIconFileSlidesFill, BIconFileSpreadsheet, BIconFileSpreadsheetFill, BIconFileText, BIconFileTextFill, BIconFileWord, BIconFileWordFill, BIconFileX, BIconFileXFill, BIconFileZip, BIconFileZipFill, BIconFiles, BIconFilesAlt, BIconFilm, BIconFilter, BIconFilterCircle, BIconFilterCircleFill, BIconFilterLeft, BIconFilterRight, BIconFilterSquare, BIconFilterSquareFill, BIconFlag, BIconFlagFill, BIconFlower1, BIconFlower2, BIconFlower3, BIconFolder, BIconFolder2, BIconFolder2Open, BIconFolderCheck, BIconFolderFill, BIconFolderMinus, BIconFolderPlus, BIconFolderSymlink, BIconFolderSymlinkFill, BIconFolderX, BIconFonts, BIconForward, BIconForwardFill, BIconFront, BIconFullscreen, BIconFullscreenExit, BIconFunnel, BIconFunnelFill, BIconGear, BIconGearFill, BIconGearWide, BIconGearWideConnected, BIconGem, BIconGenderAmbiguous, BIconGenderFemale, BIconGenderMale, BIconGenderTrans, BIconGeo, BIconGeoAlt, BIconGeoAltFill, BIconGeoFill, BIconGift, BIconGiftFill, BIconGithub, BIconGlobe, BIconGlobe2, BIconGoogle, BIconGraphDown, BIconGraphUp, BIconGrid, BIconGrid1x2, BIconGrid1x2Fill, BIconGrid3x2, BIconGrid3x2Gap, BIconGrid3x2GapFill, BIconGrid3x3, BIconGrid3x3Gap, BIconGrid3x3GapFill, BIconGridFill, BIconGripHorizontal, BIconGripVertical, BIconHammer, BIconHandIndex, BIconHandIndexFill, BIconHandIndexThumb, BIconHandIndexThumbFill, BIconHandThumbsDown, BIconHandThumbsDownFill, BIconHandThumbsUp, BIconHandThumbsUpFill, BIconHandbag, BIconHandbagFill, BIconHash, BIconHdd, BIconHddFill, BIconHddNetwork, BIconHddNetworkFill, BIconHddRack, BIconHddRackFill, BIconHddStack, BIconHddStackFill, BIconHeadphones, BIconHeadset, BIconHeadsetVr, BIconHeart, BIconHeartFill, BIconHeartHalf, BIconHeptagon, BIconHeptagonFill, BIconHeptagonHalf, BIconHexagon, BIconHexagonFill, BIconHexagonHalf, BIconHourglass, BIconHourglassBottom, BIconHourglassSplit, BIconHourglassTop, BIconHouse, BIconHouseDoor, BIconHouseDoorFill, BIconHouseFill, BIconHr, BIconHurricane, BIconImage, BIconImageAlt, BIconImageFill, BIconImages, BIconInbox, BIconInboxFill, BIconInboxes, BIconInboxesFill, BIconInfo, BIconInfoCircle, BIconInfoCircleFill, BIconInfoLg, BIconInfoSquare, BIconInfoSquareFill, BIconInputCursor, BIconInputCursorText, BIconInstagram, BIconIntersect, BIconJournal, BIconJournalAlbum, BIconJournalArrowDown, BIconJournalArrowUp, BIconJournalBookmark, BIconJournalBookmarkFill, BIconJournalCheck, BIconJournalCode, BIconJournalMedical, BIconJournalMinus, BIconJournalPlus, BIconJournalRichtext, BIconJournalText, BIconJournalX, BIconJournals, BIconJoystick, BIconJustify, BIconJustifyLeft, BIconJustifyRight, BIconKanban, BIconKanbanFill, BIconKey, BIconKeyFill, BIconKeyboard, BIconKeyboardFill, BIconLadder, BIconLamp, BIconLampFill, BIconLaptop, BIconLaptopFill, BIconLayerBackward, BIconLayerForward, BIconLayers, BIconLayersFill, BIconLayersHalf, BIconLayoutSidebar, BIconLayoutSidebarInset, BIconLayoutSidebarInsetReverse, BIconLayoutSidebarReverse, BIconLayoutSplit, BIconLayoutTextSidebar, BIconLayoutTextSidebarReverse, BIconLayoutTextWindow, BIconLayoutTextWindowReverse, BIconLayoutThreeColumns, BIconLayoutWtf, BIconLifePreserver, BIconLightbulb, BIconLightbulbFill, BIconLightbulbOff, BIconLightbulbOffFill, BIconLightning, BIconLightningCharge, BIconLightningChargeFill, BIconLightningFill, BIconLink, BIconLink45deg, BIconLinkedin, BIconList, BIconListCheck, BIconListNested, BIconListOl, BIconListStars, BIconListTask, BIconListUl, BIconLock, BIconLockFill, BIconMailbox, BIconMailbox2, BIconMap, BIconMapFill, BIconMarkdown, BIconMarkdownFill, BIconMask, BIconMastodon, BIconMegaphone, BIconMegaphoneFill, BIconMenuApp, BIconMenuAppFill, BIconMenuButton, BIconMenuButtonFill, BIconMenuButtonWide, BIconMenuButtonWideFill, BIconMenuDown, BIconMenuUp, BIconMessenger, BIconMic, BIconMicFill, BIconMicMute, BIconMicMuteFill, BIconMinecart, BIconMinecartLoaded, BIconMoisture, BIconMoon, BIconMoonFill, BIconMoonStars, BIconMoonStarsFill, BIconMouse, BIconMouse2, BIconMouse2Fill, BIconMouse3, BIconMouse3Fill, BIconMouseFill, BIconMusicNote, BIconMusicNoteBeamed, BIconMusicNoteList, BIconMusicPlayer, BIconMusicPlayerFill, BIconNewspaper, BIconNodeMinus, BIconNodeMinusFill, BIconNodePlus, BIconNodePlusFill, BIconNut, BIconNutFill, BIconOctagon, BIconOctagonFill, BIconOctagonHalf, BIconOption, BIconOutlet, BIconPaintBucket, BIconPalette, BIconPalette2, BIconPaletteFill, BIconPaperclip, BIconParagraph, BIconPatchCheck, BIconPatchCheckFill, BIconPatchExclamation, BIconPatchExclamationFill, BIconPatchMinus, BIconPatchMinusFill, BIconPatchPlus, BIconPatchPlusFill, BIconPatchQuestion, BIconPatchQuestionFill, BIconPause, BIconPauseBtn, BIconPauseBtnFill, BIconPauseCircle, BIconPauseCircleFill, BIconPauseFill, BIconPeace, BIconPeaceFill, BIconPen, BIconPenFill, BIconPencil, BIconPencilFill, BIconPencilSquare, BIconPentagon, BIconPentagonFill, BIconPentagonHalf, BIconPeople, BIconPeopleFill, BIconPercent, BIconPerson, BIconPersonBadge, BIconPersonBadgeFill, BIconPersonBoundingBox, BIconPersonCheck, BIconPersonCheckFill, BIconPersonCircle, BIconPersonDash, BIconPersonDashFill, BIconPersonFill, BIconPersonLinesFill, BIconPersonPlus, BIconPersonPlusFill, BIconPersonSquare, BIconPersonX, BIconPersonXFill, BIconPhone, BIconPhoneFill, BIconPhoneLandscape, BIconPhoneLandscapeFill, BIconPhoneVibrate, BIconPhoneVibrateFill, BIconPieChart, BIconPieChartFill, BIconPiggyBank, BIconPiggyBankFill, BIconPin, BIconPinAngle, BIconPinAngleFill, BIconPinFill, BIconPinMap, BIconPinMapFill, BIconPip, BIconPipFill, BIconPlay, BIconPlayBtn, BIconPlayBtnFill, BIconPlayCircle, BIconPlayCircleFill, BIconPlayFill, BIconPlug, BIconPlugFill, BIconPlus, BIconPlusCircle, BIconPlusCircleDotted, BIconPlusCircleFill, BIconPlusLg, BIconPlusSquare, BIconPlusSquareDotted, BIconPlusSquareFill, BIconPower, BIconPrinter, BIconPrinterFill, BIconPuzzle, BIconPuzzleFill, BIconQuestion, BIconQuestionCircle, BIconQuestionCircleFill, BIconQuestionDiamond, BIconQuestionDiamondFill, BIconQuestionLg, BIconQuestionOctagon, BIconQuestionOctagonFill, BIconQuestionSquare, BIconQuestionSquareFill, BIconRainbow, BIconReceipt, BIconReceiptCutoff, BIconReception0, BIconReception1, BIconReception2, BIconReception3, BIconReception4, BIconRecord, BIconRecord2, BIconRecord2Fill, BIconRecordBtn, BIconRecordBtnFill, BIconRecordCircle, BIconRecordCircleFill, BIconRecordFill, BIconRecycle, BIconReddit, BIconReply, BIconReplyAll, BIconReplyAllFill, BIconReplyFill, BIconRss, BIconRssFill, BIconRulers, BIconSafe, BIconSafe2, BIconSafe2Fill, BIconSafeFill, BIconSave, BIconSave2, BIconSave2Fill, BIconSaveFill, BIconScissors, BIconScrewdriver, BIconSdCard, BIconSdCardFill, BIconSearch, BIconSegmentedNav, BIconServer, BIconShare, BIconShareFill, BIconShield, BIconShieldCheck, BIconShieldExclamation, BIconShieldFill, BIconShieldFillCheck, BIconShieldFillExclamation, BIconShieldFillMinus, BIconShieldFillPlus, BIconShieldFillX, BIconShieldLock, BIconShieldLockFill, BIconShieldMinus, BIconShieldPlus, BIconShieldShaded, BIconShieldSlash, BIconShieldSlashFill, BIconShieldX, BIconShift, BIconShiftFill, BIconShop, BIconShopWindow, BIconShuffle, BIconSignpost, BIconSignpost2, BIconSignpost2Fill, BIconSignpostFill, BIconSignpostSplit, BIconSignpostSplitFill, BIconSim, BIconSimFill, BIconSkipBackward, BIconSkipBackwardBtn, BIconSkipBackwardBtnFill, BIconSkipBackwardCircle, BIconSkipBackwardCircleFill, BIconSkipBackwardFill, BIconSkipEnd, BIconSkipEndBtn, BIconSkipEndBtnFill, BIconSkipEndCircle, BIconSkipEndCircleFill, BIconSkipEndFill, BIconSkipForward, BIconSkipForwardBtn, BIconSkipForwardBtnFill, BIconSkipForwardCircle, BIconSkipForwardCircleFill, BIconSkipForwardFill, BIconSkipStart, BIconSkipStartBtn, BIconSkipStartBtnFill, BIconSkipStartCircle, BIconSkipStartCircleFill, BIconSkipStartFill, BIconSkype, BIconSlack, BIconSlash, BIconSlashCircle, BIconSlashCircleFill, BIconSlashLg, BIconSlashSquare, BIconSlashSquareFill, BIconSliders, BIconSmartwatch, BIconSnow, BIconSnow2, BIconSnow3, BIconSortAlphaDown, BIconSortAlphaDownAlt, BIconSortAlphaUp, BIconSortAlphaUpAlt, BIconSortDown, BIconSortDownAlt, BIconSortNumericDown, BIconSortNumericDownAlt, BIconSortNumericUp, BIconSortNumericUpAlt, BIconSortUp, BIconSortUpAlt, BIconSoundwave, BIconSpeaker, BIconSpeakerFill, BIconSpeedometer, BIconSpeedometer2, BIconSpellcheck, BIconSquare, BIconSquareFill, BIconSquareHalf, BIconStack, BIconStar, BIconStarFill, BIconStarHalf, BIconStars, BIconStickies, BIconStickiesFill, BIconSticky, BIconStickyFill, BIconStop, BIconStopBtn, BIconStopBtnFill, BIconStopCircle, BIconStopCircleFill, BIconStopFill, BIconStoplights, BIconStoplightsFill, BIconStopwatch, BIconStopwatchFill, BIconSubtract, BIconSuitClub, BIconSuitClubFill, BIconSuitDiamond, BIconSuitDiamondFill, BIconSuitHeart, BIconSuitHeartFill, BIconSuitSpade, BIconSuitSpadeFill, BIconSun, BIconSunFill, BIconSunglasses, BIconSunrise, BIconSunriseFill, BIconSunset, BIconSunsetFill, BIconSymmetryHorizontal, BIconSymmetryVertical, BIconTable, BIconTablet, BIconTabletFill, BIconTabletLandscape, BIconTabletLandscapeFill, BIconTag, BIconTagFill, BIconTags, BIconTagsFill, BIconTelegram, BIconTelephone, BIconTelephoneFill, BIconTelephoneForward, BIconTelephoneForwardFill, BIconTelephoneInbound, BIconTelephoneInboundFill, BIconTelephoneMinus, BIconTelephoneMinusFill, BIconTelephoneOutbound, BIconTelephoneOutboundFill, BIconTelephonePlus, BIconTelephonePlusFill, BIconTelephoneX, BIconTelephoneXFill, BIconTerminal, BIconTerminalFill, BIconTextCenter, BIconTextIndentLeft, BIconTextIndentRight, BIconTextLeft, BIconTextParagraph, BIconTextRight, BIconTextarea, BIconTextareaResize, BIconTextareaT, BIconThermometer, BIconThermometerHalf, BIconThermometerHigh, BIconThermometerLow, BIconThermometerSnow, BIconThermometerSun, BIconThreeDots, BIconThreeDotsVertical, BIconToggle2Off, BIconToggle2On, BIconToggleOff, BIconToggleOn, BIconToggles, BIconToggles2, BIconTools, BIconTornado, BIconTranslate, BIconTrash, BIconTrash2, BIconTrash2Fill, BIconTrashFill, BIconTree, BIconTreeFill, BIconTriangle, BIconTriangleFill, BIconTriangleHalf, BIconTrophy, BIconTrophyFill, BIconTropicalStorm, BIconTruck, BIconTruckFlatbed, BIconTsunami, BIconTv, BIconTvFill, BIconTwitch, BIconTwitter, BIconType, BIconTypeBold, BIconTypeH1, BIconTypeH2, BIconTypeH3, BIconTypeItalic, BIconTypeStrikethrough, BIconTypeUnderline, BIconUiChecks, BIconUiChecksGrid, BIconUiRadios, BIconUiRadiosGrid, BIconUmbrella, BIconUmbrellaFill, BIconUnion, BIconUnlock, BIconUnlockFill, BIconUpc, BIconUpcScan, BIconUpload, BIconVectorPen, BIconViewList, BIconViewStacked, BIconVinyl, BIconVinylFill, BIconVoicemail, BIconVolumeDown, BIconVolumeDownFill, BIconVolumeMute, BIconVolumeMuteFill, BIconVolumeOff, BIconVolumeOffFill, BIconVolumeUp, BIconVolumeUpFill, BIconVr, BIconWallet, BIconWallet2, BIconWalletFill, BIconWatch, BIconWater, BIconWhatsapp, BIconWifi, BIconWifi1, BIconWifi2, BIconWifiOff, BIconWind, BIconWindow, BIconWindowDock, BIconWindowSidebar, BIconWrench, BIconX, BIconXCircle, BIconXCircleFill, BIconXDiamond, BIconXDiamondFill, BIconXLg, BIconXOctagon, BIconXOctagonFill, BIconXSquare, BIconXSquareFill, BIconYoutube, BIconZoomIn, BIconZoomOut */
/*!********************************************!*\
  !*** ./~/bootstrap-vue/esm/icons/icons.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BIconBlank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BIconAlarm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BIconAlarmFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BIconAlignBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BIconAlignCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BIconAlignEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BIconAlignMiddle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BIconAlignStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BIconAlignTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BIconAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BIconApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BIconAppIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BIconArchive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BIconArchiveFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BIconArrow90degDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return BIconArrow90degLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BIconArrow90degRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return BIconArrow90degUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return BIconArrowBarDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return BIconArrowBarLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return BIconArrowBarRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return BIconArrowBarUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return BIconArrowClockwise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return BIconArrowCounterclockwise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return BIconArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return BIconArrowDownCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return BIconArrowDownCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return BIconArrowDownLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return BIconArrowDownLeftCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return BIconArrowDownLeftCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return BIconArrowDownLeftSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return BIconArrowDownLeftSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return BIconArrowDownRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return BIconArrowDownRightCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return BIconArrowDownRightCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return BIconArrowDownRightSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return BIconArrowDownRightSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return BIconArrowDownShort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return BIconArrowDownSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return BIconArrowDownSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return BIconArrowDownUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return BIconArrowLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return BIconArrowLeftCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return BIconArrowLeftCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return BIconArrowLeftRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return BIconArrowLeftShort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return BIconArrowLeftSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return BIconArrowLeftSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return BIconArrowRepeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return BIconArrowReturnLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return BIconArrowReturnRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return BIconArrowRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return BIconArrowRightCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return BIconArrowRightCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return BIconArrowRightShort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return BIconArrowRightSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return BIconArrowRightSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return BIconArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return BIconArrowUpCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return BIconArrowUpCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return BIconArrowUpLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return BIconArrowUpLeftCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return BIconArrowUpLeftCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return BIconArrowUpLeftSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return BIconArrowUpLeftSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return BIconArrowUpRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return BIconArrowUpRightCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return BIconArrowUpRightCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return BIconArrowUpRightSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return BIconArrowUpRightSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return BIconArrowUpShort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return BIconArrowUpSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return BIconArrowUpSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return BIconArrowsAngleContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return BIconArrowsAngleExpand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return BIconArrowsCollapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return BIconArrowsExpand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return BIconArrowsFullscreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return BIconArrowsMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return BIconAspectRatio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return BIconAspectRatioFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return BIconAsterisk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return BIconAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return BIconAward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return BIconAwardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return BIconBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return BIconBackspace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return BIconBackspaceFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return BIconBackspaceReverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return BIconBackspaceReverseFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return BIconBadge3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return BIconBadge3dFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return BIconBadge4k; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return BIconBadge4kFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return BIconBadge8k; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return BIconBadge8kFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return BIconBadgeAd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return BIconBadgeAdFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return BIconBadgeAr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return BIconBadgeArFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return BIconBadgeCc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return BIconBadgeCcFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return BIconBadgeHd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return BIconBadgeHdFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return BIconBadgeTm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return BIconBadgeTmFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return BIconBadgeVo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return BIconBadgeVoFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return BIconBadgeVr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return BIconBadgeVrFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return BIconBadgeWc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return BIconBadgeWcFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return BIconBag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return BIconBagCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return BIconBagCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return BIconBagDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return BIconBagDashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return BIconBagFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return BIconBagPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return BIconBagPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return BIconBagX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return BIconBagXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return BIconBank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return BIconBank2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return BIconBarChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return BIconBarChartFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return BIconBarChartLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return BIconBarChartLineFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return BIconBarChartSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return BIconBasket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return BIconBasket2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return BIconBasket2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return BIconBasket3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return BIconBasket3Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return BIconBasketFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return BIconBattery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return BIconBatteryCharging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return BIconBatteryFull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return BIconBatteryHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return BIconBell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return BIconBellFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return BIconBellSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return BIconBellSlashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return BIconBezier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return BIconBezier2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return BIconBicycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return BIconBinoculars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return BIconBinocularsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return BIconBlockquoteLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return BIconBlockquoteRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return BIconBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return BIconBookFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return BIconBookHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return BIconBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return BIconBookmarkCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return BIconBookmarkCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return BIconBookmarkDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return BIconBookmarkDashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return BIconBookmarkFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return BIconBookmarkHeart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return BIconBookmarkHeartFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return BIconBookmarkPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return BIconBookmarkPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return BIconBookmarkStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return BIconBookmarkStarFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return BIconBookmarkX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return BIconBookmarkXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return BIconBookmarks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return BIconBookmarksFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return BIconBookshelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return BIconBootstrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return BIconBootstrapFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return BIconBootstrapReboot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return BIconBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return BIconBorderAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return BIconBorderBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return BIconBorderCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return BIconBorderInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return BIconBorderLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return BIconBorderMiddle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return BIconBorderOuter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return BIconBorderRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return BIconBorderStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return BIconBorderTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return BIconBorderWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return BIconBoundingBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return BIconBoundingBoxCircles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return BIconBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return BIconBoxArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return BIconBoxArrowDownLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return BIconBoxArrowDownRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return BIconBoxArrowInDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return BIconBoxArrowInDownLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return BIconBoxArrowInDownRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return BIconBoxArrowInLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return BIconBoxArrowInRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return BIconBoxArrowInUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return BIconBoxArrowInUpLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return BIconBoxArrowInUpRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return BIconBoxArrowLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return BIconBoxArrowRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return BIconBoxArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return BIconBoxArrowUpLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return BIconBoxArrowUpRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return BIconBoxSeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return BIconBraces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return BIconBricks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return BIconBriefcase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return BIconBriefcaseFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return BIconBrightnessAltHigh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return BIconBrightnessAltHighFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return BIconBrightnessAltLow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return BIconBrightnessAltLowFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return BIconBrightnessHigh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return BIconBrightnessHighFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return BIconBrightnessLow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return BIconBrightnessLowFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return BIconBroadcast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return BIconBroadcastPin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return BIconBrush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return BIconBrushFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return BIconBucket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return BIconBucketFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return BIconBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return BIconBugFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return BIconBuilding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return BIconBullseye; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return BIconCalculator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return BIconCalculatorFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return BIconCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return BIconCalendar2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return BIconCalendar2Check; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return BIconCalendar2CheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return BIconCalendar2Date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return BIconCalendar2DateFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return BIconCalendar2Day; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return BIconCalendar2DayFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return BIconCalendar2Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return BIconCalendar2EventFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return BIconCalendar2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return BIconCalendar2Minus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return BIconCalendar2MinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return BIconCalendar2Month; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return BIconCalendar2MonthFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return BIconCalendar2Plus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return BIconCalendar2PlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return BIconCalendar2Range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return BIconCalendar2RangeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return BIconCalendar2Week; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return BIconCalendar2WeekFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return BIconCalendar2X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return BIconCalendar2XFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return BIconCalendar3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return BIconCalendar3Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return BIconCalendar3EventFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return BIconCalendar3Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return BIconCalendar3Range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return BIconCalendar3RangeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return BIconCalendar3Week; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return BIconCalendar3WeekFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return BIconCalendar4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return BIconCalendar4Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return BIconCalendar4Range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return BIconCalendar4Week; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return BIconCalendarCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return BIconCalendarCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return BIconCalendarDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return BIconCalendarDateFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return BIconCalendarDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return BIconCalendarDayFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return BIconCalendarEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return BIconCalendarEventFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return BIconCalendarFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return BIconCalendarMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return BIconCalendarMinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return BIconCalendarMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return BIconCalendarMonthFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return BIconCalendarPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return BIconCalendarPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return BIconCalendarRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return BIconCalendarRangeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return BIconCalendarWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return BIconCalendarWeekFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return BIconCalendarX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return BIconCalendarXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return BIconCamera; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return BIconCamera2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return BIconCameraFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return BIconCameraReels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return BIconCameraReelsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return BIconCameraVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return BIconCameraVideoFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return BIconCameraVideoOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return BIconCameraVideoOffFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return BIconCapslock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return BIconCapslockFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return BIconCardChecklist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return BIconCardHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return BIconCardImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return BIconCardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return BIconCardText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return BIconCaretDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return BIconCaretDownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return BIconCaretDownSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return BIconCaretDownSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return BIconCaretLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return BIconCaretLeftFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return BIconCaretLeftSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return BIconCaretLeftSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return BIconCaretRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return BIconCaretRightFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return BIconCaretRightSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return BIconCaretRightSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return BIconCaretUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return BIconCaretUpFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return BIconCaretUpSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return BIconCaretUpSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return BIconCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return BIconCart2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return BIconCart3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return BIconCart4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return BIconCartCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return BIconCartCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return BIconCartDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return BIconCartDashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return BIconCartFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return BIconCartPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return BIconCartPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return BIconCartX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return BIconCartXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return BIconCash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return BIconCashCoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return BIconCashStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return BIconCast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return BIconChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return BIconChatDots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return BIconChatDotsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return BIconChatFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return BIconChatLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return BIconChatLeftDots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return BIconChatLeftDotsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return BIconChatLeftFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return BIconChatLeftQuote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return BIconChatLeftQuoteFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return BIconChatLeftText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return BIconChatLeftTextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return BIconChatQuote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return BIconChatQuoteFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return BIconChatRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return BIconChatRightDots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_298", function() { return BIconChatRightDotsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_299", function() { return BIconChatRightFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_300", function() { return BIconChatRightQuote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_301", function() { return BIconChatRightQuoteFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_302", function() { return BIconChatRightText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_303", function() { return BIconChatRightTextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_304", function() { return BIconChatSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_305", function() { return BIconChatSquareDots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_306", function() { return BIconChatSquareDotsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_307", function() { return BIconChatSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_308", function() { return BIconChatSquareQuote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_309", function() { return BIconChatSquareQuoteFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_310", function() { return BIconChatSquareText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_311", function() { return BIconChatSquareTextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_312", function() { return BIconChatText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_313", function() { return BIconChatTextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_314", function() { return BIconCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_315", function() { return BIconCheck2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_316", function() { return BIconCheck2All; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_317", function() { return BIconCheck2Circle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_318", function() { return BIconCheck2Square; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_319", function() { return BIconCheckAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_320", function() { return BIconCheckCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_321", function() { return BIconCheckCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_322", function() { return BIconCheckLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_323", function() { return BIconCheckSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_324", function() { return BIconCheckSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_325", function() { return BIconChevronBarContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_326", function() { return BIconChevronBarDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_327", function() { return BIconChevronBarExpand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_328", function() { return BIconChevronBarLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_329", function() { return BIconChevronBarRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_330", function() { return BIconChevronBarUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_331", function() { return BIconChevronCompactDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_332", function() { return BIconChevronCompactLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_333", function() { return BIconChevronCompactRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_334", function() { return BIconChevronCompactUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_335", function() { return BIconChevronContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_336", function() { return BIconChevronDoubleDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_337", function() { return BIconChevronDoubleLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_338", function() { return BIconChevronDoubleRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_339", function() { return BIconChevronDoubleUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_340", function() { return BIconChevronDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_341", function() { return BIconChevronExpand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_342", function() { return BIconChevronLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_343", function() { return BIconChevronRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_344", function() { return BIconChevronUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_345", function() { return BIconCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_346", function() { return BIconCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_347", function() { return BIconCircleHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_348", function() { return BIconCircleSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_349", function() { return BIconClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_350", function() { return BIconClipboardCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_351", function() { return BIconClipboardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_352", function() { return BIconClipboardMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_353", function() { return BIconClipboardPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_354", function() { return BIconClipboardX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_355", function() { return BIconClock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_356", function() { return BIconClockFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_357", function() { return BIconClockHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_358", function() { return BIconCloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_359", function() { return BIconCloudArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_360", function() { return BIconCloudArrowDownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_361", function() { return BIconCloudArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_362", function() { return BIconCloudArrowUpFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_363", function() { return BIconCloudCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_364", function() { return BIconCloudCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_365", function() { return BIconCloudDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_366", function() { return BIconCloudDownloadFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_367", function() { return BIconCloudDrizzle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_368", function() { return BIconCloudDrizzleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_369", function() { return BIconCloudFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_370", function() { return BIconCloudFog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_371", function() { return BIconCloudFog2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_372", function() { return BIconCloudFog2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_373", function() { return BIconCloudFogFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_374", function() { return BIconCloudHail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_375", function() { return BIconCloudHailFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_376", function() { return BIconCloudHaze; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_377", function() { return BIconCloudHaze1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_378", function() { return BIconCloudHaze2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_379", function() { return BIconCloudHazeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_380", function() { return BIconCloudLightning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_381", function() { return BIconCloudLightningFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_382", function() { return BIconCloudLightningRain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_383", function() { return BIconCloudLightningRainFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_384", function() { return BIconCloudMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_385", function() { return BIconCloudMinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_386", function() { return BIconCloudMoon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_387", function() { return BIconCloudMoonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_388", function() { return BIconCloudPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_389", function() { return BIconCloudPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_390", function() { return BIconCloudRain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_391", function() { return BIconCloudRainFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_392", function() { return BIconCloudRainHeavy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_393", function() { return BIconCloudRainHeavyFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_394", function() { return BIconCloudSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_395", function() { return BIconCloudSlashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_396", function() { return BIconCloudSleet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_397", function() { return BIconCloudSleetFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_398", function() { return BIconCloudSnow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_399", function() { return BIconCloudSnowFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_400", function() { return BIconCloudSun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_401", function() { return BIconCloudSunFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_402", function() { return BIconCloudUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_403", function() { return BIconCloudUploadFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_404", function() { return BIconClouds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_405", function() { return BIconCloudsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_406", function() { return BIconCloudy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_407", function() { return BIconCloudyFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_408", function() { return BIconCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_409", function() { return BIconCodeSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_410", function() { return BIconCodeSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_411", function() { return BIconCoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_412", function() { return BIconCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_413", function() { return BIconCollectionFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_414", function() { return BIconCollectionPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_415", function() { return BIconCollectionPlayFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_416", function() { return BIconColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_417", function() { return BIconColumnsGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_418", function() { return BIconCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_419", function() { return BIconCompass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_420", function() { return BIconCompassFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_421", function() { return BIconCone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_422", function() { return BIconConeStriped; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_423", function() { return BIconController; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_424", function() { return BIconCpu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_425", function() { return BIconCpuFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_426", function() { return BIconCreditCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_427", function() { return BIconCreditCard2Back; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_428", function() { return BIconCreditCard2BackFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_429", function() { return BIconCreditCard2Front; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_430", function() { return BIconCreditCard2FrontFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_431", function() { return BIconCreditCardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_432", function() { return BIconCrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_433", function() { return BIconCup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_434", function() { return BIconCupFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_435", function() { return BIconCupStraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_436", function() { return BIconCurrencyBitcoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_437", function() { return BIconCurrencyDollar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_438", function() { return BIconCurrencyEuro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_439", function() { return BIconCurrencyExchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_440", function() { return BIconCurrencyPound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_441", function() { return BIconCurrencyYen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_442", function() { return BIconCursor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_443", function() { return BIconCursorFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_444", function() { return BIconCursorText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_445", function() { return BIconDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_446", function() { return BIconDashCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_447", function() { return BIconDashCircleDotted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_448", function() { return BIconDashCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_449", function() { return BIconDashLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_450", function() { return BIconDashSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_451", function() { return BIconDashSquareDotted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_452", function() { return BIconDashSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_453", function() { return BIconDiagram2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_454", function() { return BIconDiagram2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_455", function() { return BIconDiagram3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_456", function() { return BIconDiagram3Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_457", function() { return BIconDiamond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_458", function() { return BIconDiamondFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_459", function() { return BIconDiamondHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_460", function() { return BIconDice1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_461", function() { return BIconDice1Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_462", function() { return BIconDice2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_463", function() { return BIconDice2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_464", function() { return BIconDice3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_465", function() { return BIconDice3Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_466", function() { return BIconDice4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_467", function() { return BIconDice4Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_468", function() { return BIconDice5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_469", function() { return BIconDice5Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_470", function() { return BIconDice6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_471", function() { return BIconDice6Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_472", function() { return BIconDisc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_473", function() { return BIconDiscFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_474", function() { return BIconDiscord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_475", function() { return BIconDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_476", function() { return BIconDisplayFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_477", function() { return BIconDistributeHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_478", function() { return BIconDistributeVertical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_479", function() { return BIconDoorClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_480", function() { return BIconDoorClosedFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_481", function() { return BIconDoorOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_482", function() { return BIconDoorOpenFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_483", function() { return BIconDot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_484", function() { return BIconDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_485", function() { return BIconDroplet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_486", function() { return BIconDropletFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_487", function() { return BIconDropletHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_488", function() { return BIconEarbuds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_489", function() { return BIconEasel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_490", function() { return BIconEaselFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_491", function() { return BIconEgg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_492", function() { return BIconEggFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_493", function() { return BIconEggFried; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_494", function() { return BIconEject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_495", function() { return BIconEjectFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_496", function() { return BIconEmojiAngry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_497", function() { return BIconEmojiAngryFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_498", function() { return BIconEmojiDizzy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_499", function() { return BIconEmojiDizzyFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_500", function() { return BIconEmojiExpressionless; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_501", function() { return BIconEmojiExpressionlessFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_502", function() { return BIconEmojiFrown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_503", function() { return BIconEmojiFrownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_504", function() { return BIconEmojiHeartEyes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_505", function() { return BIconEmojiHeartEyesFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_506", function() { return BIconEmojiLaughing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_507", function() { return BIconEmojiLaughingFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_508", function() { return BIconEmojiNeutral; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_509", function() { return BIconEmojiNeutralFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_510", function() { return BIconEmojiSmile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_511", function() { return BIconEmojiSmileFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_512", function() { return BIconEmojiSmileUpsideDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_513", function() { return BIconEmojiSmileUpsideDownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_514", function() { return BIconEmojiSunglasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_515", function() { return BIconEmojiSunglassesFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_516", function() { return BIconEmojiWink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_517", function() { return BIconEmojiWinkFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_518", function() { return BIconEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_519", function() { return BIconEnvelopeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_520", function() { return BIconEnvelopeOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_521", function() { return BIconEnvelopeOpenFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_522", function() { return BIconEraser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_523", function() { return BIconEraserFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_524", function() { return BIconExclamation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_525", function() { return BIconExclamationCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_526", function() { return BIconExclamationCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_527", function() { return BIconExclamationDiamond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_528", function() { return BIconExclamationDiamondFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_529", function() { return BIconExclamationLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_530", function() { return BIconExclamationOctagon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_531", function() { return BIconExclamationOctagonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_532", function() { return BIconExclamationSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_533", function() { return BIconExclamationSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_534", function() { return BIconExclamationTriangle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_535", function() { return BIconExclamationTriangleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_536", function() { return BIconExclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_537", function() { return BIconEye; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_538", function() { return BIconEyeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_539", function() { return BIconEyeSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_540", function() { return BIconEyeSlashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_541", function() { return BIconEyedropper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_542", function() { return BIconEyeglasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_543", function() { return BIconFacebook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_544", function() { return BIconFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_545", function() { return BIconFileArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_546", function() { return BIconFileArrowDownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_547", function() { return BIconFileArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_548", function() { return BIconFileArrowUpFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_549", function() { return BIconFileBarGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_550", function() { return BIconFileBarGraphFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_551", function() { return BIconFileBinary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_552", function() { return BIconFileBinaryFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_553", function() { return BIconFileBreak; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_554", function() { return BIconFileBreakFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_555", function() { return BIconFileCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_556", function() { return BIconFileCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_557", function() { return BIconFileCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_558", function() { return BIconFileCodeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_559", function() { return BIconFileDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_560", function() { return BIconFileDiffFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_561", function() { return BIconFileEarmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_562", function() { return BIconFileEarmarkArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_563", function() { return BIconFileEarmarkArrowDownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_564", function() { return BIconFileEarmarkArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_565", function() { return BIconFileEarmarkArrowUpFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_566", function() { return BIconFileEarmarkBarGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_567", function() { return BIconFileEarmarkBarGraphFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_568", function() { return BIconFileEarmarkBinary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_569", function() { return BIconFileEarmarkBinaryFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_570", function() { return BIconFileEarmarkBreak; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_571", function() { return BIconFileEarmarkBreakFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_572", function() { return BIconFileEarmarkCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_573", function() { return BIconFileEarmarkCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_574", function() { return BIconFileEarmarkCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_575", function() { return BIconFileEarmarkCodeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_576", function() { return BIconFileEarmarkDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_577", function() { return BIconFileEarmarkDiffFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_578", function() { return BIconFileEarmarkEasel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_579", function() { return BIconFileEarmarkEaselFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_580", function() { return BIconFileEarmarkExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_581", function() { return BIconFileEarmarkExcelFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_582", function() { return BIconFileEarmarkFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_583", function() { return BIconFileEarmarkFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_584", function() { return BIconFileEarmarkFontFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_585", function() { return BIconFileEarmarkImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_586", function() { return BIconFileEarmarkImageFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_587", function() { return BIconFileEarmarkLock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_588", function() { return BIconFileEarmarkLock2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_589", function() { return BIconFileEarmarkLock2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_590", function() { return BIconFileEarmarkLockFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_591", function() { return BIconFileEarmarkMedical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_592", function() { return BIconFileEarmarkMedicalFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_593", function() { return BIconFileEarmarkMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_594", function() { return BIconFileEarmarkMinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_595", function() { return BIconFileEarmarkMusic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_596", function() { return BIconFileEarmarkMusicFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_597", function() { return BIconFileEarmarkPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_598", function() { return BIconFileEarmarkPdfFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_599", function() { return BIconFileEarmarkPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_600", function() { return BIconFileEarmarkPersonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_601", function() { return BIconFileEarmarkPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_602", function() { return BIconFileEarmarkPlayFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_603", function() { return BIconFileEarmarkPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_604", function() { return BIconFileEarmarkPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_605", function() { return BIconFileEarmarkPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_606", function() { return BIconFileEarmarkPostFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_607", function() { return BIconFileEarmarkPpt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_608", function() { return BIconFileEarmarkPptFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_609", function() { return BIconFileEarmarkRichtext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_610", function() { return BIconFileEarmarkRichtextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_611", function() { return BIconFileEarmarkRuled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_612", function() { return BIconFileEarmarkRuledFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_613", function() { return BIconFileEarmarkSlides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_614", function() { return BIconFileEarmarkSlidesFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_615", function() { return BIconFileEarmarkSpreadsheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_616", function() { return BIconFileEarmarkSpreadsheetFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_617", function() { return BIconFileEarmarkText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_618", function() { return BIconFileEarmarkTextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_619", function() { return BIconFileEarmarkWord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_620", function() { return BIconFileEarmarkWordFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_621", function() { return BIconFileEarmarkX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_622", function() { return BIconFileEarmarkXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_623", function() { return BIconFileEarmarkZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_624", function() { return BIconFileEarmarkZipFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_625", function() { return BIconFileEasel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_626", function() { return BIconFileEaselFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_627", function() { return BIconFileExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_628", function() { return BIconFileExcelFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_629", function() { return BIconFileFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_630", function() { return BIconFileFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_631", function() { return BIconFileFontFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_632", function() { return BIconFileImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_633", function() { return BIconFileImageFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_634", function() { return BIconFileLock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_635", function() { return BIconFileLock2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_636", function() { return BIconFileLock2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_637", function() { return BIconFileLockFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_638", function() { return BIconFileMedical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_639", function() { return BIconFileMedicalFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_640", function() { return BIconFileMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_641", function() { return BIconFileMinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_642", function() { return BIconFileMusic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_643", function() { return BIconFileMusicFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_644", function() { return BIconFilePdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_645", function() { return BIconFilePdfFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_646", function() { return BIconFilePerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_647", function() { return BIconFilePersonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_648", function() { return BIconFilePlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_649", function() { return BIconFilePlayFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_650", function() { return BIconFilePlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_651", function() { return BIconFilePlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_652", function() { return BIconFilePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_653", function() { return BIconFilePostFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_654", function() { return BIconFilePpt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_655", function() { return BIconFilePptFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_656", function() { return BIconFileRichtext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_657", function() { return BIconFileRichtextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_658", function() { return BIconFileRuled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_659", function() { return BIconFileRuledFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_660", function() { return BIconFileSlides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_661", function() { return BIconFileSlidesFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_662", function() { return BIconFileSpreadsheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_663", function() { return BIconFileSpreadsheetFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_664", function() { return BIconFileText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_665", function() { return BIconFileTextFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_666", function() { return BIconFileWord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_667", function() { return BIconFileWordFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_668", function() { return BIconFileX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_669", function() { return BIconFileXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_670", function() { return BIconFileZip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_671", function() { return BIconFileZipFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_672", function() { return BIconFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_673", function() { return BIconFilesAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_674", function() { return BIconFilm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_675", function() { return BIconFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_676", function() { return BIconFilterCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_677", function() { return BIconFilterCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_678", function() { return BIconFilterLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_679", function() { return BIconFilterRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_680", function() { return BIconFilterSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_681", function() { return BIconFilterSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_682", function() { return BIconFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_683", function() { return BIconFlagFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_684", function() { return BIconFlower1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_685", function() { return BIconFlower2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_686", function() { return BIconFlower3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_687", function() { return BIconFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_688", function() { return BIconFolder2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_689", function() { return BIconFolder2Open; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_690", function() { return BIconFolderCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_691", function() { return BIconFolderFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_692", function() { return BIconFolderMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_693", function() { return BIconFolderPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_694", function() { return BIconFolderSymlink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_695", function() { return BIconFolderSymlinkFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_696", function() { return BIconFolderX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_697", function() { return BIconFonts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_698", function() { return BIconForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_699", function() { return BIconForwardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_700", function() { return BIconFront; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_701", function() { return BIconFullscreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_702", function() { return BIconFullscreenExit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_703", function() { return BIconFunnel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_704", function() { return BIconFunnelFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_705", function() { return BIconGear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_706", function() { return BIconGearFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_707", function() { return BIconGearWide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_708", function() { return BIconGearWideConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_709", function() { return BIconGem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_710", function() { return BIconGenderAmbiguous; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_711", function() { return BIconGenderFemale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_712", function() { return BIconGenderMale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_713", function() { return BIconGenderTrans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_714", function() { return BIconGeo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_715", function() { return BIconGeoAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_716", function() { return BIconGeoAltFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_717", function() { return BIconGeoFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_718", function() { return BIconGift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_719", function() { return BIconGiftFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_720", function() { return BIconGithub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_721", function() { return BIconGlobe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_722", function() { return BIconGlobe2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_723", function() { return BIconGoogle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_724", function() { return BIconGraphDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_725", function() { return BIconGraphUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_726", function() { return BIconGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_727", function() { return BIconGrid1x2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_728", function() { return BIconGrid1x2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_729", function() { return BIconGrid3x2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_730", function() { return BIconGrid3x2Gap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_731", function() { return BIconGrid3x2GapFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_732", function() { return BIconGrid3x3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_733", function() { return BIconGrid3x3Gap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_734", function() { return BIconGrid3x3GapFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_735", function() { return BIconGridFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_736", function() { return BIconGripHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_737", function() { return BIconGripVertical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_738", function() { return BIconHammer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_739", function() { return BIconHandIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_740", function() { return BIconHandIndexFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_741", function() { return BIconHandIndexThumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_742", function() { return BIconHandIndexThumbFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_743", function() { return BIconHandThumbsDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_744", function() { return BIconHandThumbsDownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_745", function() { return BIconHandThumbsUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_746", function() { return BIconHandThumbsUpFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_747", function() { return BIconHandbag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_748", function() { return BIconHandbagFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_749", function() { return BIconHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_750", function() { return BIconHdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_751", function() { return BIconHddFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_752", function() { return BIconHddNetwork; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_753", function() { return BIconHddNetworkFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_754", function() { return BIconHddRack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_755", function() { return BIconHddRackFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_756", function() { return BIconHddStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_757", function() { return BIconHddStackFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_758", function() { return BIconHeadphones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_759", function() { return BIconHeadset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_760", function() { return BIconHeadsetVr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_761", function() { return BIconHeart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_762", function() { return BIconHeartFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_763", function() { return BIconHeartHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_764", function() { return BIconHeptagon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_765", function() { return BIconHeptagonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_766", function() { return BIconHeptagonHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_767", function() { return BIconHexagon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_768", function() { return BIconHexagonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_769", function() { return BIconHexagonHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_770", function() { return BIconHourglass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_771", function() { return BIconHourglassBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_772", function() { return BIconHourglassSplit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_773", function() { return BIconHourglassTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_774", function() { return BIconHouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_775", function() { return BIconHouseDoor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_776", function() { return BIconHouseDoorFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_777", function() { return BIconHouseFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_778", function() { return BIconHr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_779", function() { return BIconHurricane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_780", function() { return BIconImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_781", function() { return BIconImageAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_782", function() { return BIconImageFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_783", function() { return BIconImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_784", function() { return BIconInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_785", function() { return BIconInboxFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_786", function() { return BIconInboxes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_787", function() { return BIconInboxesFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_788", function() { return BIconInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_789", function() { return BIconInfoCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_790", function() { return BIconInfoCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_791", function() { return BIconInfoLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_792", function() { return BIconInfoSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_793", function() { return BIconInfoSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_794", function() { return BIconInputCursor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_795", function() { return BIconInputCursorText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_796", function() { return BIconInstagram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_797", function() { return BIconIntersect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_798", function() { return BIconJournal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_799", function() { return BIconJournalAlbum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_800", function() { return BIconJournalArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_801", function() { return BIconJournalArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_802", function() { return BIconJournalBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_803", function() { return BIconJournalBookmarkFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_804", function() { return BIconJournalCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_805", function() { return BIconJournalCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_806", function() { return BIconJournalMedical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_807", function() { return BIconJournalMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_808", function() { return BIconJournalPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_809", function() { return BIconJournalRichtext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_810", function() { return BIconJournalText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_811", function() { return BIconJournalX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_812", function() { return BIconJournals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_813", function() { return BIconJoystick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_814", function() { return BIconJustify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_815", function() { return BIconJustifyLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_816", function() { return BIconJustifyRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_817", function() { return BIconKanban; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_818", function() { return BIconKanbanFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_819", function() { return BIconKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_820", function() { return BIconKeyFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_821", function() { return BIconKeyboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_822", function() { return BIconKeyboardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_823", function() { return BIconLadder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_824", function() { return BIconLamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_825", function() { return BIconLampFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_826", function() { return BIconLaptop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_827", function() { return BIconLaptopFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_828", function() { return BIconLayerBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_829", function() { return BIconLayerForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_830", function() { return BIconLayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_831", function() { return BIconLayersFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_832", function() { return BIconLayersHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_833", function() { return BIconLayoutSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_834", function() { return BIconLayoutSidebarInset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_835", function() { return BIconLayoutSidebarInsetReverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_836", function() { return BIconLayoutSidebarReverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_837", function() { return BIconLayoutSplit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_838", function() { return BIconLayoutTextSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_839", function() { return BIconLayoutTextSidebarReverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_840", function() { return BIconLayoutTextWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_841", function() { return BIconLayoutTextWindowReverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_842", function() { return BIconLayoutThreeColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_843", function() { return BIconLayoutWtf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_844", function() { return BIconLifePreserver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_845", function() { return BIconLightbulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_846", function() { return BIconLightbulbFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_847", function() { return BIconLightbulbOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_848", function() { return BIconLightbulbOffFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_849", function() { return BIconLightning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_850", function() { return BIconLightningCharge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_851", function() { return BIconLightningChargeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_852", function() { return BIconLightningFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_853", function() { return BIconLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_854", function() { return BIconLink45deg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_855", function() { return BIconLinkedin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_856", function() { return BIconList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_857", function() { return BIconListCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_858", function() { return BIconListNested; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_859", function() { return BIconListOl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_860", function() { return BIconListStars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_861", function() { return BIconListTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_862", function() { return BIconListUl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_863", function() { return BIconLock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_864", function() { return BIconLockFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_865", function() { return BIconMailbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_866", function() { return BIconMailbox2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_867", function() { return BIconMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_868", function() { return BIconMapFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_869", function() { return BIconMarkdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_870", function() { return BIconMarkdownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_871", function() { return BIconMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_872", function() { return BIconMastodon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_873", function() { return BIconMegaphone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_874", function() { return BIconMegaphoneFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_875", function() { return BIconMenuApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_876", function() { return BIconMenuAppFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_877", function() { return BIconMenuButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_878", function() { return BIconMenuButtonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_879", function() { return BIconMenuButtonWide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_880", function() { return BIconMenuButtonWideFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_881", function() { return BIconMenuDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_882", function() { return BIconMenuUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_883", function() { return BIconMessenger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_884", function() { return BIconMic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_885", function() { return BIconMicFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_886", function() { return BIconMicMute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_887", function() { return BIconMicMuteFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_888", function() { return BIconMinecart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_889", function() { return BIconMinecartLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_890", function() { return BIconMoisture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_891", function() { return BIconMoon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_892", function() { return BIconMoonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_893", function() { return BIconMoonStars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_894", function() { return BIconMoonStarsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_895", function() { return BIconMouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_896", function() { return BIconMouse2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_897", function() { return BIconMouse2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_898", function() { return BIconMouse3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_899", function() { return BIconMouse3Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_900", function() { return BIconMouseFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_901", function() { return BIconMusicNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_902", function() { return BIconMusicNoteBeamed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_903", function() { return BIconMusicNoteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_904", function() { return BIconMusicPlayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_905", function() { return BIconMusicPlayerFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_906", function() { return BIconNewspaper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_907", function() { return BIconNodeMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_908", function() { return BIconNodeMinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_909", function() { return BIconNodePlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_910", function() { return BIconNodePlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_911", function() { return BIconNut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_912", function() { return BIconNutFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_913", function() { return BIconOctagon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_914", function() { return BIconOctagonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_915", function() { return BIconOctagonHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_916", function() { return BIconOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_917", function() { return BIconOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_918", function() { return BIconPaintBucket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_919", function() { return BIconPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_920", function() { return BIconPalette2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_921", function() { return BIconPaletteFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_922", function() { return BIconPaperclip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_923", function() { return BIconParagraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_924", function() { return BIconPatchCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_925", function() { return BIconPatchCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_926", function() { return BIconPatchExclamation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_927", function() { return BIconPatchExclamationFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_928", function() { return BIconPatchMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_929", function() { return BIconPatchMinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_930", function() { return BIconPatchPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_931", function() { return BIconPatchPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_932", function() { return BIconPatchQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_933", function() { return BIconPatchQuestionFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_934", function() { return BIconPause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_935", function() { return BIconPauseBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_936", function() { return BIconPauseBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_937", function() { return BIconPauseCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_938", function() { return BIconPauseCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_939", function() { return BIconPauseFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_940", function() { return BIconPeace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_941", function() { return BIconPeaceFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_942", function() { return BIconPen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_943", function() { return BIconPenFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_944", function() { return BIconPencil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_945", function() { return BIconPencilFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_946", function() { return BIconPencilSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_947", function() { return BIconPentagon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_948", function() { return BIconPentagonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_949", function() { return BIconPentagonHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_950", function() { return BIconPeople; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_951", function() { return BIconPeopleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_952", function() { return BIconPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_953", function() { return BIconPerson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_954", function() { return BIconPersonBadge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_955", function() { return BIconPersonBadgeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_956", function() { return BIconPersonBoundingBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_957", function() { return BIconPersonCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_958", function() { return BIconPersonCheckFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_959", function() { return BIconPersonCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_960", function() { return BIconPersonDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_961", function() { return BIconPersonDashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_962", function() { return BIconPersonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_963", function() { return BIconPersonLinesFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_964", function() { return BIconPersonPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_965", function() { return BIconPersonPlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_966", function() { return BIconPersonSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_967", function() { return BIconPersonX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_968", function() { return BIconPersonXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_969", function() { return BIconPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_970", function() { return BIconPhoneFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_971", function() { return BIconPhoneLandscape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_972", function() { return BIconPhoneLandscapeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_973", function() { return BIconPhoneVibrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_974", function() { return BIconPhoneVibrateFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_975", function() { return BIconPieChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_976", function() { return BIconPieChartFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_977", function() { return BIconPiggyBank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_978", function() { return BIconPiggyBankFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_979", function() { return BIconPin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_980", function() { return BIconPinAngle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_981", function() { return BIconPinAngleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_982", function() { return BIconPinFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_983", function() { return BIconPinMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_984", function() { return BIconPinMapFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_985", function() { return BIconPip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_986", function() { return BIconPipFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_987", function() { return BIconPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_988", function() { return BIconPlayBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_989", function() { return BIconPlayBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_990", function() { return BIconPlayCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_991", function() { return BIconPlayCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_992", function() { return BIconPlayFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_993", function() { return BIconPlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_994", function() { return BIconPlugFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_995", function() { return BIconPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_996", function() { return BIconPlusCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_997", function() { return BIconPlusCircleDotted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_998", function() { return BIconPlusCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_999", function() { return BIconPlusLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1000", function() { return BIconPlusSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1001", function() { return BIconPlusSquareDotted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1002", function() { return BIconPlusSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1003", function() { return BIconPower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1004", function() { return BIconPrinter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1005", function() { return BIconPrinterFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1006", function() { return BIconPuzzle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1007", function() { return BIconPuzzleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1008", function() { return BIconQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1009", function() { return BIconQuestionCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1010", function() { return BIconQuestionCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1011", function() { return BIconQuestionDiamond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1012", function() { return BIconQuestionDiamondFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1013", function() { return BIconQuestionLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1014", function() { return BIconQuestionOctagon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1015", function() { return BIconQuestionOctagonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1016", function() { return BIconQuestionSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1017", function() { return BIconQuestionSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1018", function() { return BIconRainbow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1019", function() { return BIconReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1020", function() { return BIconReceiptCutoff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1021", function() { return BIconReception0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1022", function() { return BIconReception1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1023", function() { return BIconReception2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1024", function() { return BIconReception3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1025", function() { return BIconReception4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1026", function() { return BIconRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1027", function() { return BIconRecord2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1028", function() { return BIconRecord2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1029", function() { return BIconRecordBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1030", function() { return BIconRecordBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1031", function() { return BIconRecordCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1032", function() { return BIconRecordCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1033", function() { return BIconRecordFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1034", function() { return BIconRecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1035", function() { return BIconReddit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1036", function() { return BIconReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1037", function() { return BIconReplyAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1038", function() { return BIconReplyAllFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1039", function() { return BIconReplyFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1040", function() { return BIconRss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1041", function() { return BIconRssFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1042", function() { return BIconRulers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1043", function() { return BIconSafe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1044", function() { return BIconSafe2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1045", function() { return BIconSafe2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1046", function() { return BIconSafeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1047", function() { return BIconSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1048", function() { return BIconSave2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1049", function() { return BIconSave2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1050", function() { return BIconSaveFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1051", function() { return BIconScissors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1052", function() { return BIconScrewdriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1053", function() { return BIconSdCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1054", function() { return BIconSdCardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1055", function() { return BIconSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1056", function() { return BIconSegmentedNav; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1057", function() { return BIconServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1058", function() { return BIconShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1059", function() { return BIconShareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1060", function() { return BIconShield; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1061", function() { return BIconShieldCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1062", function() { return BIconShieldExclamation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1063", function() { return BIconShieldFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1064", function() { return BIconShieldFillCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1065", function() { return BIconShieldFillExclamation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1066", function() { return BIconShieldFillMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1067", function() { return BIconShieldFillPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1068", function() { return BIconShieldFillX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1069", function() { return BIconShieldLock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1070", function() { return BIconShieldLockFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1071", function() { return BIconShieldMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1072", function() { return BIconShieldPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1073", function() { return BIconShieldShaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1074", function() { return BIconShieldSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1075", function() { return BIconShieldSlashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1076", function() { return BIconShieldX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1077", function() { return BIconShift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1078", function() { return BIconShiftFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1079", function() { return BIconShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1080", function() { return BIconShopWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1081", function() { return BIconShuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1082", function() { return BIconSignpost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1083", function() { return BIconSignpost2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1084", function() { return BIconSignpost2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1085", function() { return BIconSignpostFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1086", function() { return BIconSignpostSplit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1087", function() { return BIconSignpostSplitFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1088", function() { return BIconSim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1089", function() { return BIconSimFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1090", function() { return BIconSkipBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1091", function() { return BIconSkipBackwardBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1092", function() { return BIconSkipBackwardBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1093", function() { return BIconSkipBackwardCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1094", function() { return BIconSkipBackwardCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1095", function() { return BIconSkipBackwardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1096", function() { return BIconSkipEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1097", function() { return BIconSkipEndBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1098", function() { return BIconSkipEndBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1099", function() { return BIconSkipEndCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1100", function() { return BIconSkipEndCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1101", function() { return BIconSkipEndFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1102", function() { return BIconSkipForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1103", function() { return BIconSkipForwardBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1104", function() { return BIconSkipForwardBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1105", function() { return BIconSkipForwardCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1106", function() { return BIconSkipForwardCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1107", function() { return BIconSkipForwardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1108", function() { return BIconSkipStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1109", function() { return BIconSkipStartBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1110", function() { return BIconSkipStartBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1111", function() { return BIconSkipStartCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1112", function() { return BIconSkipStartCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1113", function() { return BIconSkipStartFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1114", function() { return BIconSkype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1115", function() { return BIconSlack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1116", function() { return BIconSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1117", function() { return BIconSlashCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1118", function() { return BIconSlashCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1119", function() { return BIconSlashLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1120", function() { return BIconSlashSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1121", function() { return BIconSlashSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1122", function() { return BIconSliders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1123", function() { return BIconSmartwatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1124", function() { return BIconSnow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1125", function() { return BIconSnow2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1126", function() { return BIconSnow3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1127", function() { return BIconSortAlphaDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1128", function() { return BIconSortAlphaDownAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1129", function() { return BIconSortAlphaUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1130", function() { return BIconSortAlphaUpAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1131", function() { return BIconSortDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1132", function() { return BIconSortDownAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1133", function() { return BIconSortNumericDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1134", function() { return BIconSortNumericDownAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1135", function() { return BIconSortNumericUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1136", function() { return BIconSortNumericUpAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1137", function() { return BIconSortUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1138", function() { return BIconSortUpAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1139", function() { return BIconSoundwave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1140", function() { return BIconSpeaker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1141", function() { return BIconSpeakerFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1142", function() { return BIconSpeedometer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1143", function() { return BIconSpeedometer2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1144", function() { return BIconSpellcheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1145", function() { return BIconSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1146", function() { return BIconSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1147", function() { return BIconSquareHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1148", function() { return BIconStack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1149", function() { return BIconStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1150", function() { return BIconStarFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1151", function() { return BIconStarHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1152", function() { return BIconStars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1153", function() { return BIconStickies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1154", function() { return BIconStickiesFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1155", function() { return BIconSticky; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1156", function() { return BIconStickyFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1157", function() { return BIconStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1158", function() { return BIconStopBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1159", function() { return BIconStopBtnFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1160", function() { return BIconStopCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1161", function() { return BIconStopCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1162", function() { return BIconStopFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1163", function() { return BIconStoplights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1164", function() { return BIconStoplightsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1165", function() { return BIconStopwatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1166", function() { return BIconStopwatchFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1167", function() { return BIconSubtract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1168", function() { return BIconSuitClub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1169", function() { return BIconSuitClubFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1170", function() { return BIconSuitDiamond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1171", function() { return BIconSuitDiamondFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1172", function() { return BIconSuitHeart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1173", function() { return BIconSuitHeartFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1174", function() { return BIconSuitSpade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1175", function() { return BIconSuitSpadeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1176", function() { return BIconSun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1177", function() { return BIconSunFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1178", function() { return BIconSunglasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1179", function() { return BIconSunrise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1180", function() { return BIconSunriseFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1181", function() { return BIconSunset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1182", function() { return BIconSunsetFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1183", function() { return BIconSymmetryHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1184", function() { return BIconSymmetryVertical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1185", function() { return BIconTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1186", function() { return BIconTablet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1187", function() { return BIconTabletFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1188", function() { return BIconTabletLandscape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1189", function() { return BIconTabletLandscapeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1190", function() { return BIconTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1191", function() { return BIconTagFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1192", function() { return BIconTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1193", function() { return BIconTagsFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1194", function() { return BIconTelegram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1195", function() { return BIconTelephone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1196", function() { return BIconTelephoneFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1197", function() { return BIconTelephoneForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1198", function() { return BIconTelephoneForwardFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1199", function() { return BIconTelephoneInbound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1200", function() { return BIconTelephoneInboundFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1201", function() { return BIconTelephoneMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1202", function() { return BIconTelephoneMinusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1203", function() { return BIconTelephoneOutbound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1204", function() { return BIconTelephoneOutboundFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1205", function() { return BIconTelephonePlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1206", function() { return BIconTelephonePlusFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1207", function() { return BIconTelephoneX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1208", function() { return BIconTelephoneXFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1209", function() { return BIconTerminal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1210", function() { return BIconTerminalFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1211", function() { return BIconTextCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1212", function() { return BIconTextIndentLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1213", function() { return BIconTextIndentRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1214", function() { return BIconTextLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1215", function() { return BIconTextParagraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1216", function() { return BIconTextRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1217", function() { return BIconTextarea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1218", function() { return BIconTextareaResize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1219", function() { return BIconTextareaT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1220", function() { return BIconThermometer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1221", function() { return BIconThermometerHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1222", function() { return BIconThermometerHigh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1223", function() { return BIconThermometerLow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1224", function() { return BIconThermometerSnow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1225", function() { return BIconThermometerSun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1226", function() { return BIconThreeDots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1227", function() { return BIconThreeDotsVertical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1228", function() { return BIconToggle2Off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1229", function() { return BIconToggle2On; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1230", function() { return BIconToggleOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1231", function() { return BIconToggleOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1232", function() { return BIconToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1233", function() { return BIconToggles2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1234", function() { return BIconTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1235", function() { return BIconTornado; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1236", function() { return BIconTranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1237", function() { return BIconTrash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1238", function() { return BIconTrash2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1239", function() { return BIconTrash2Fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1240", function() { return BIconTrashFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1241", function() { return BIconTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1242", function() { return BIconTreeFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1243", function() { return BIconTriangle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1244", function() { return BIconTriangleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1245", function() { return BIconTriangleHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1246", function() { return BIconTrophy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1247", function() { return BIconTrophyFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1248", function() { return BIconTropicalStorm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1249", function() { return BIconTruck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1250", function() { return BIconTruckFlatbed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1251", function() { return BIconTsunami; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1252", function() { return BIconTv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1253", function() { return BIconTvFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1254", function() { return BIconTwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1255", function() { return BIconTwitter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1256", function() { return BIconType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1257", function() { return BIconTypeBold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1258", function() { return BIconTypeH1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1259", function() { return BIconTypeH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1260", function() { return BIconTypeH3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1261", function() { return BIconTypeItalic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1262", function() { return BIconTypeStrikethrough; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1263", function() { return BIconTypeUnderline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1264", function() { return BIconUiChecks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1265", function() { return BIconUiChecksGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1266", function() { return BIconUiRadios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1267", function() { return BIconUiRadiosGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1268", function() { return BIconUmbrella; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1269", function() { return BIconUmbrellaFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1270", function() { return BIconUnion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1271", function() { return BIconUnlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1272", function() { return BIconUnlockFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1273", function() { return BIconUpc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1274", function() { return BIconUpcScan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1275", function() { return BIconUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1276", function() { return BIconVectorPen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1277", function() { return BIconViewList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1278", function() { return BIconViewStacked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1279", function() { return BIconVinyl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1280", function() { return BIconVinylFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1281", function() { return BIconVoicemail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1282", function() { return BIconVolumeDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1283", function() { return BIconVolumeDownFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1284", function() { return BIconVolumeMute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1285", function() { return BIconVolumeMuteFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1286", function() { return BIconVolumeOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1287", function() { return BIconVolumeOffFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1288", function() { return BIconVolumeUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1289", function() { return BIconVolumeUpFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1290", function() { return BIconVr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1291", function() { return BIconWallet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1292", function() { return BIconWallet2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1293", function() { return BIconWalletFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1294", function() { return BIconWatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1295", function() { return BIconWater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1296", function() { return BIconWhatsapp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1297", function() { return BIconWifi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1298", function() { return BIconWifi1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1299", function() { return BIconWifi2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1300", function() { return BIconWifiOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1301", function() { return BIconWind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1302", function() { return BIconWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1303", function() { return BIconWindowDock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1304", function() { return BIconWindowSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1305", function() { return BIconWrench; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1306", function() { return BIconX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1307", function() { return BIconXCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1308", function() { return BIconXCircleFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1309", function() { return BIconXDiamond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1310", function() { return BIconXDiamondFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1311", function() { return BIconXLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1312", function() { return BIconXOctagon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1313", function() { return BIconXOctagonFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1314", function() { return BIconXSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1315", function() { return BIconXSquareFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1316", function() { return BIconYoutube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1317", function() { return BIconZoomIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1318", function() { return BIconZoomOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__ = __webpack_require__(/*! ./helpers/make-icon */ 948);
// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.5.0
// @Generated: 2022-10-26T01:10:52.933Z
//
// This file is generated on each build. Do not edit this file!
/*!
 * BootstrapVue Icons, generated from Bootstrap Icons 1.5.0
 *
 * @link https://icons.getbootstrap.com/
 * @license MIT
 * https://github.com/twbs/icons/blob/master/LICENSE.md
 */// --- BootstrapVue custom icons ---
var BIconBlank=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Blank','');// --- Bootstrap Icons ---
// eslint-disable-next-line
var BIconAlarm=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Alarm','<path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z"/><path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z"/>');// eslint-disable-next-line
var BIconAlarmFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AlarmFill','<path d="M6 .5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H9v1.07a7.001 7.001 0 0 1 3.274 12.474l.601.602a.5.5 0 0 1-.707.708l-.746-.746A6.97 6.97 0 0 1 8 16a6.97 6.97 0 0 1-3.422-.892l-.746.746a.5.5 0 0 1-.707-.708l.602-.602A7.001 7.001 0 0 1 7 2.07V1h-.5A.5.5 0 0 1 6 .5zm2.5 5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5zM.86 5.387A2.5 2.5 0 1 1 4.387 1.86 8.035 8.035 0 0 0 .86 5.387zM11.613 1.86a2.5 2.5 0 1 1 3.527 3.527 8.035 8.035 0 0 0-3.527-3.527z"/>');// eslint-disable-next-line
var BIconAlignBottom=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AlignBottom','<rect width="4" height="12" x="6" y="1" rx="1"/><path d="M1.5 14a.5.5 0 0 0 0 1v-1zm13 1a.5.5 0 0 0 0-1v1zm-13 0h13v-1h-13v1z"/>');// eslint-disable-next-line
var BIconAlignCenter=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AlignCenter','<path d="M8 1a.5.5 0 0 1 .5.5V6h-1V1.5A.5.5 0 0 1 8 1zm0 14a.5.5 0 0 1-.5-.5V10h1v4.5a.5.5 0 0 1-.5.5zM2 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7z"/>');// eslint-disable-next-line
var BIconAlignEnd=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AlignEnd','<path fill-rule="evenodd" d="M14.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"/><path d="M13 7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z"/>');// eslint-disable-next-line
var BIconAlignMiddle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AlignMiddle','<path d="M6 13a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10zM1 8a.5.5 0 0 0 .5.5H6v-1H1.5A.5.5 0 0 0 1 8zm14 0a.5.5 0 0 1-.5.5H10v-1h4.5a.5.5 0 0 1 .5.5z"/>');// eslint-disable-next-line
var BIconAlignStart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AlignStart','<path fill-rule="evenodd" d="M1.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"/><path d="M3 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7z"/>');// eslint-disable-next-line
var BIconAlignTop=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AlignTop','<rect width="4" height="12" rx="1" transform="matrix(1 0 0 -1 6 15)"/><path d="M1.5 2a.5.5 0 0 1 0-1v1zm13-1a.5.5 0 0 1 0 1V1zm-13 0h13v1h-13V1z"/>');// eslint-disable-next-line
var BIconAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Alt','<path d="M1 13.5a.5.5 0 0 0 .5.5h3.797a.5.5 0 0 0 .439-.26L11 3h3.5a.5.5 0 0 0 0-1h-3.797a.5.5 0 0 0-.439.26L5 13H1.5a.5.5 0 0 0-.5.5zm10 0a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5z"/>');// eslint-disable-next-line
var BIconApp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('App','<path d="M11 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6zM5 1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4H5z"/>');// eslint-disable-next-line
var BIconAppIndicator=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AppIndicator','<path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z"/><path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>');// eslint-disable-next-line
var BIconArchive=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Archive','<path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1V2zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5H2zm13-3H1v2h14V2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconArchiveFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArchiveFill','<path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"/>');// eslint-disable-next-line
var BIconArrow90degDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Arrow90degDown','<path fill-rule="evenodd" d="M4.854 14.854a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V3.5A2.5 2.5 0 0 1 6.5 1h8a.5.5 0 0 1 0 1h-8A1.5 1.5 0 0 0 5 3.5v9.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4z"/>');// eslint-disable-next-line
var BIconArrow90degLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Arrow90degLeft','<path fill-rule="evenodd" d="M1.146 4.854a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H12.5A2.5 2.5 0 0 1 15 6.5v8a.5.5 0 0 1-1 0v-8A1.5 1.5 0 0 0 12.5 5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4z"/>');// eslint-disable-next-line
var BIconArrow90degRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Arrow90degRight','<path fill-rule="evenodd" d="M14.854 4.854a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 4H3.5A2.5 2.5 0 0 0 1 6.5v8a.5.5 0 0 0 1 0v-8A1.5 1.5 0 0 1 3.5 5h9.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4z"/>');// eslint-disable-next-line
var BIconArrow90degUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Arrow90degUp','<path fill-rule="evenodd" d="M4.854 1.146a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L4 2.707V12.5A2.5 2.5 0 0 0 6.5 15h8a.5.5 0 0 0 0-1h-8A1.5 1.5 0 0 1 5 12.5V2.707l3.146 3.147a.5.5 0 1 0 .708-.708l-4-4z"/>');// eslint-disable-next-line
var BIconArrowBarDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowBarDown','<path fill-rule="evenodd" d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z"/>');// eslint-disable-next-line
var BIconArrowBarLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowBarLeft','<path fill-rule="evenodd" d="M12.5 15a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5zM10 8a.5.5 0 0 1-.5.5H3.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L3.707 7.5H9.5a.5.5 0 0 1 .5.5z"/>');// eslint-disable-next-line
var BIconArrowBarRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowBarRight','<path fill-rule="evenodd" d="M6 8a.5.5 0 0 0 .5.5h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L12.293 7.5H6.5A.5.5 0 0 0 6 8zm-2.5 7a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 1 0v13a.5.5 0 0 1-.5.5z"/>');// eslint-disable-next-line
var BIconArrowBarUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowBarUp','<path fill-rule="evenodd" d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconArrowClockwise=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowClockwise','<path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/><path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>');// eslint-disable-next-line
var BIconArrowCounterclockwise=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowCounterclockwise','<path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>');// eslint-disable-next-line
var BIconArrowDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDown','<path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>');// eslint-disable-next-line
var BIconArrowDownCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/>');// eslint-disable-next-line
var BIconArrowDownCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/>');// eslint-disable-next-line
var BIconArrowDownLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownLeft','<path fill-rule="evenodd" d="M2 13.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1H3.707L13.854 2.854a.5.5 0 0 0-.708-.708L3 12.293V7.5a.5.5 0 0 0-1 0v6z"/>');// eslint-disable-next-line
var BIconArrowDownLeftCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownLeftCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-5.904-2.854a.5.5 0 1 1 .707.708L6.707 9.95h2.768a.5.5 0 1 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.475a.5.5 0 1 1 1 0v2.768l4.096-4.097z"/>');// eslint-disable-next-line
var BIconArrowDownLeftCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownLeftCircleFill','<path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-5.904-2.803a.5.5 0 1 1 .707.707L6.707 10h2.768a.5.5 0 0 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.525a.5.5 0 0 1 1 0v2.768l4.096-4.096z"/>');// eslint-disable-next-line
var BIconArrowDownLeftSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownLeftSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.096 3.146a.5.5 0 1 1 .707.708L6.707 9.95h2.768a.5.5 0 1 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.475a.5.5 0 1 1 1 0v2.768l4.096-4.097z"/>');// eslint-disable-next-line
var BIconArrowDownLeftSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownLeftSquareFill','<path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm8.096-10.803L6 9.293V6.525a.5.5 0 0 0-1 0V10.5a.5.5 0 0 0 .5.5h3.975a.5.5 0 0 0 0-1H6.707l4.096-4.096a.5.5 0 1 0-.707-.707z"/>');// eslint-disable-next-line
var BIconArrowDownRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownRight','<path fill-rule="evenodd" d="M14 13.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.793L2.146 2.854a.5.5 0 1 1 .708-.708L13 12.293V7.5a.5.5 0 0 1 1 0v6z"/>');// eslint-disable-next-line
var BIconArrowDownRightCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownRightCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>');// eslint-disable-next-line
var BIconArrowDownRightCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownRightCircleFill','<path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm5.904-2.803a.5.5 0 1 0-.707.707L9.293 10H6.525a.5.5 0 0 0 0 1H10.5a.5.5 0 0 0 .5-.5V6.525a.5.5 0 0 0-1 0v2.768L5.904 5.197z"/>');// eslint-disable-next-line
var BIconArrowDownRightSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownRightSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.854 3.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>');// eslint-disable-next-line
var BIconArrowDownRightSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownRightSquareFill','<path d="M14 16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12zM5.904 5.197 10 9.293V6.525a.5.5 0 0 1 1 0V10.5a.5.5 0 0 1-.5.5H6.525a.5.5 0 0 1 0-1h2.768L5.197 5.904a.5.5 0 0 1 .707-.707z"/>');// eslint-disable-next-line
var BIconArrowDownShort=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownShort','<path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>');// eslint-disable-next-line
var BIconArrowDownSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"/>');// eslint-disable-next-line
var BIconArrowDownSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconArrowDownUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowDownUp','<path fill-rule="evenodd" d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5zm-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconArrowLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowLeft','<path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>');// eslint-disable-next-line
var BIconArrowLeftCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowLeftCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>');// eslint-disable-next-line
var BIconArrowLeftCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowLeftCircleFill','<path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>');// eslint-disable-next-line
var BIconArrowLeftRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowLeftRight','<path fill-rule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"/>');// eslint-disable-next-line
var BIconArrowLeftShort=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowLeftShort','<path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>');// eslint-disable-next-line
var BIconArrowLeftSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowLeftSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm11.5 5.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>');// eslint-disable-next-line
var BIconArrowLeftSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowLeftSquareFill','<path d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z"/>');// eslint-disable-next-line
var BIconArrowRepeat=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowRepeat','<path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/><path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>');// eslint-disable-next-line
var BIconArrowReturnLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowReturnLeft','<path fill-rule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconArrowReturnRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowReturnRight','<path fill-rule="evenodd" d="M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5z"/>');// eslint-disable-next-line
var BIconArrowRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowRight','<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>');// eslint-disable-next-line
var BIconArrowRightCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowRightCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>');// eslint-disable-next-line
var BIconArrowRightCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowRightCircleFill','<path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>');// eslint-disable-next-line
var BIconArrowRightShort=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowRightShort','<path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>');// eslint-disable-next-line
var BIconArrowRightSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowRightSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>');// eslint-disable-next-line
var BIconArrowRightSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowRightSquareFill','<path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconArrowUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUp','<path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/>');// eslint-disable-next-line
var BIconArrowUpCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>');// eslint-disable-next-line
var BIconArrowUpCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpCircleFill','<path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>');// eslint-disable-next-line
var BIconArrowUpLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpLeft','<path fill-rule="evenodd" d="M2 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H3.707l10.147 10.146a.5.5 0 0 1-.708.708L3 3.707V8.5a.5.5 0 0 1-1 0v-6z"/>');// eslint-disable-next-line
var BIconArrowUpLeftCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpLeftCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-5.904 2.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"/>');// eslint-disable-next-line
var BIconArrowUpLeftCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpLeftCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-5.904 2.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"/>');// eslint-disable-next-line
var BIconArrowUpLeftSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpLeftSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.096 8.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"/>');// eslint-disable-next-line
var BIconArrowUpLeftSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpLeftSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm8.096 10.803L6 6.707v2.768a.5.5 0 0 1-1 0V5.5a.5.5 0 0 1 .5-.5h3.975a.5.5 0 1 1 0 1H6.707l4.096 4.096a.5.5 0 1 1-.707.707z"/>');// eslint-disable-next-line
var BIconArrowUpRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpRight','<path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"/>');// eslint-disable-next-line
var BIconArrowUpRightCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpRightCircle','<path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>');// eslint-disable-next-line
var BIconArrowUpRightCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpRightCircleFill','<path d="M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8zm5.904 2.803a.5.5 0 1 1-.707-.707L9.293 6H6.525a.5.5 0 1 1 0-1H10.5a.5.5 0 0 1 .5.5v3.975a.5.5 0 0 1-1 0V6.707l-4.096 4.096z"/>');// eslint-disable-next-line
var BIconArrowUpRightSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpRightSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>');// eslint-disable-next-line
var BIconArrowUpRightSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpRightSquareFill','<path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707z"/>');// eslint-disable-next-line
var BIconArrowUpShort=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpShort','<path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>');// eslint-disable-next-line
var BIconArrowUpSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpSquare','<path fill-rule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"/>');// eslint-disable-next-line
var BIconArrowUpSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowUpSquareFill','<path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>');// eslint-disable-next-line
var BIconArrowsAngleContract=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowsAngleContract','<path fill-rule="evenodd" d="M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707zM15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707z"/>');// eslint-disable-next-line
var BIconArrowsAngleExpand=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowsAngleExpand','<path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z"/>');// eslint-disable-next-line
var BIconArrowsCollapse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowsCollapse','<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z"/>');// eslint-disable-next-line
var BIconArrowsExpand=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowsExpand','<path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z"/>');// eslint-disable-next-line
var BIconArrowsFullscreen=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowsFullscreen','<path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z"/>');// eslint-disable-next-line
var BIconArrowsMove=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ArrowsMove','<path fill-rule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10zM.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708l-2-2zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8z"/>');// eslint-disable-next-line
var BIconAspectRatio=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AspectRatio','<path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"/><path d="M2 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3zm12 7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H13V8.5a.5.5 0 0 1 1 0v3z"/>');// eslint-disable-next-line
var BIconAspectRatioFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AspectRatioFill','<path d="M0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5zM2.5 4a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0V5h2.5a.5.5 0 0 0 0-1h-3zm11 8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0V11h-2.5a.5.5 0 0 0 0 1h3z"/>');// eslint-disable-next-line
var BIconAsterisk=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Asterisk','<path d="M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconAt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('At','<path d="M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z"/>');// eslint-disable-next-line
var BIconAward=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Award','<path d="M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702 1.509.229z"/><path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>');// eslint-disable-next-line
var BIconAwardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('AwardFill','<path d="m8 0 1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z"/><path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>');// eslint-disable-next-line
var BIconBack=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Back','<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"/>');// eslint-disable-next-line
var BIconBackspace=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Backspace','<path d="M5.83 5.146a.5.5 0 0 0 0 .708L7.975 8l-2.147 2.146a.5.5 0 0 0 .707.708l2.147-2.147 2.146 2.147a.5.5 0 0 0 .707-.708L9.39 8l2.146-2.146a.5.5 0 0 0-.707-.708L8.683 7.293 6.536 5.146a.5.5 0 0 0-.707 0z"/><path d="M13.683 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7.08a2 2 0 0 1-1.519-.698L.241 8.65a1 1 0 0 1 0-1.302L5.084 1.7A2 2 0 0 1 6.603 1h7.08zm-7.08 1a1 1 0 0 0-.76.35L1 8l4.844 5.65a1 1 0 0 0 .759.35h7.08a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-7.08z"/>');// eslint-disable-next-line
var BIconBackspaceFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BackspaceFill','<path d="M15.683 3a2 2 0 0 0-2-2h-7.08a2 2 0 0 0-1.519.698L.241 7.35a1 1 0 0 0 0 1.302l4.843 5.65A2 2 0 0 0 6.603 15h7.08a2 2 0 0 0 2-2V3zM5.829 5.854a.5.5 0 1 1 .707-.708l2.147 2.147 2.146-2.147a.5.5 0 1 1 .707.708L9.39 8l2.146 2.146a.5.5 0 0 1-.707.708L8.683 8.707l-2.147 2.147a.5.5 0 0 1-.707-.708L7.976 8 5.829 5.854z"/>');// eslint-disable-next-line
var BIconBackspaceReverse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BackspaceReverse','<path d="M9.854 5.146a.5.5 0 0 1 0 .708L7.707 8l2.147 2.146a.5.5 0 0 1-.708.708L7 8.707l-2.146 2.147a.5.5 0 0 1-.708-.708L6.293 8 4.146 5.854a.5.5 0 1 1 .708-.708L7 7.293l2.146-2.147a.5.5 0 0 1 .708 0z"/><path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.08a2 2 0 0 0 1.519-.698l4.843-5.651a1 1 0 0 0 0-1.302L10.6 1.7A2 2 0 0 0 9.08 1H2zm7.08 1a1 1 0 0 1 .76.35L14.682 8l-4.844 5.65a1 1 0 0 1-.759.35H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h7.08z"/>');// eslint-disable-next-line
var BIconBackspaceReverseFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BackspaceReverseFill','<path d="M0 3a2 2 0 0 1 2-2h7.08a2 2 0 0 1 1.519.698l4.843 5.651a1 1 0 0 1 0 1.302L10.6 14.3a2 2 0 0 1-1.52.7H2a2 2 0 0 1-2-2V3zm9.854 2.854a.5.5 0 0 0-.708-.708L7 7.293 4.854 5.146a.5.5 0 1 0-.708.708L6.293 8l-2.147 2.146a.5.5 0 0 0 .708.708L7 8.707l2.146 2.147a.5.5 0 0 0 .708-.708L7.707 8l2.147-2.146z"/>');// eslint-disable-next-line
var BIconBadge3d=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Badge3d','<path d="M4.52 8.368h.664c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914zm3.606-3.367V11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984H8.126zm1.187.967h.844c1.112 0 1.621.686 1.621 2.04 0 1.353-.505 2.02-1.621 2.02h-.844v-4.06z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadge3dFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Badge3dFill','<path d="M10.157 5.968h-.844v4.06h.844c1.116 0 1.621-.667 1.621-2.02 0-1.354-.51-2.04-1.621-2.04z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.184 4.368c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914h.663zM8.126 11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984H8.126V11z"/>');// eslint-disable-next-line
var BIconBadge4k=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Badge4k','<path d="M4.807 5.001C4.021 6.298 3.203 7.6 2.5 8.917v.971h2.905V11h1.112V9.888h.733V8.93h-.733V5.001h-1.71zm-1.23 3.93v-.032a46.781 46.781 0 0 1 1.766-3.001h.062V8.93H3.577zm9.831-3.93h-1.306L9.835 7.687h-.057V5H8.59v6h1.187V9.075l.615-.699L12.072 11H13.5l-2.232-3.415 2.14-2.584z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadge4kFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Badge4kFill','<path d="M3.577 8.9v.03h1.828V5.898h-.062a46.781 46.781 0 0 0-1.766 3.001z"/><path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm2.372 3.715.435-.714h1.71v3.93h.733v.957h-.733V11H5.405V9.888H2.5v-.971c.574-1.077 1.225-2.142 1.872-3.202zm7.73-.714h1.306l-2.14 2.584L13.5 11h-1.428l-1.679-2.624-.615.7V11H8.59V5.001h1.187v2.686h.057L12.102 5z"/>');// eslint-disable-next-line
var BIconBadge8k=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Badge8k','<path d="M4.837 11.114c1.406 0 2.333-.725 2.333-1.766 0-.945-.712-1.38-1.256-1.49v-.053c.496-.15 1.02-.55 1.02-1.331 0-.914-.831-1.587-2.084-1.587-1.257 0-2.087.673-2.087 1.587 0 .773.51 1.177 1.02 1.331v.053c-.546.11-1.258.54-1.258 1.494 0 1.042.906 1.762 2.312 1.762zm.013-3.643c-.545 0-.95-.356-.95-.866s.405-.852.95-.852c.545 0 .945.343.945.852 0 .51-.4.866-.945.866zm0 2.786c-.65 0-1.142-.395-1.142-.984S4.2 8.28 4.85 8.28c.646 0 1.143.404 1.143.993s-.497.984-1.143.984zM13.408 5h-1.306L9.835 7.685h-.057V5H8.59v5.998h1.187V9.075l.615-.699 1.679 2.623H13.5l-2.232-3.414L13.408 5z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadge8kFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Badge8kFill','<path d="M3.9 6.605c0 .51.405.866.95.866.545 0 .945-.356.945-.866s-.4-.852-.945-.852c-.545 0-.95.343-.95.852zm-.192 2.668c0 .589.492.984 1.142.984.646 0 1.143-.395 1.143-.984S5.496 8.28 4.85 8.28c-.65 0-1.142.404-1.142.993z"/><path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm5.17 7.348c0 1.041-.927 1.766-2.333 1.766-1.406 0-2.312-.72-2.312-1.762 0-.954.712-1.384 1.257-1.494v-.053c-.51-.154-1.02-.558-1.02-1.331 0-.914.831-1.587 2.088-1.587 1.253 0 2.083.673 2.083 1.587 0 .782-.523 1.182-1.02 1.331v.053c.545.11 1.257.545 1.257 1.49zM12.102 5h1.306l-2.14 2.584 2.232 3.415h-1.428l-1.679-2.624-.615.699v1.925H8.59V5h1.187v2.685h.057L12.102 5z"/>');// eslint-disable-next-line
var BIconBadgeAd=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeAd','<path d="m3.7 11 .47-1.542h2.004L6.644 11h1.261L5.901 5.001H4.513L2.5 11h1.2zm1.503-4.852.734 2.426H4.416l.734-2.426h.053zm4.759.128c-1.059 0-1.753.765-1.753 2.043v.695c0 1.279.685 2.043 1.74 2.043.677 0 1.222-.33 1.367-.804h.057V11h1.138V4.685h-1.16v2.36h-.053c-.18-.475-.68-.77-1.336-.77zm.387.923c.58 0 1.002.44 1.002 1.138v.602c0 .76-.396 1.2-.984 1.2-.598 0-.972-.449-.972-1.248v-.453c0-.795.37-1.24.954-1.24z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadgeAdFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeAdFill','<path d="M11.35 8.337c0-.699-.42-1.138-1.001-1.138-.584 0-.954.444-.954 1.239v.453c0 .8.374 1.248.972 1.248.588 0 .984-.44.984-1.2v-.602zm-5.413.237-.734-2.426H5.15l-.734 2.426h1.52z"/><path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm6.209 6.32c0-1.28.694-2.044 1.753-2.044.655 0 1.156.294 1.336.769h.053v-2.36h1.16V11h-1.138v-.747h-.057c-.145.474-.69.804-1.367.804-1.055 0-1.74-.764-1.74-2.043v-.695zm-4.04 1.138L3.7 11H2.5l2.013-5.999H5.9L7.905 11H6.644l-.47-1.542H4.17z"/>');// eslint-disable-next-line
var BIconBadgeAr=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeAr','<path d="m3.794 11 .47-1.542H6.27L6.739 11H8L5.996 5.001H4.607L2.595 11h1.2zm1.503-4.852.734 2.426h-1.52l.734-2.426h.052zm5.598-1.147H8.5V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9zm-1.222 2.87V5.933h1.05c.63 0 1.05.347 1.05.989 0 .633-.408.95-1.067.95H9.673z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadgeArFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeArFill','<path d="m6.031 8.574-.734-2.426h-.052L4.51 8.574h1.52zm3.642-2.641v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm4.265 5.458h2.004L6.739 11H8L5.996 5.001H4.607L2.595 11h1.2l.47-1.542zM8.5 5v6h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z"/>');// eslint-disable-next-line
var BIconBadgeCc=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeCc','<path d="M3.708 7.755c0-1.111.488-1.753 1.319-1.753.681 0 1.138.47 1.186 1.107H7.36V7c-.052-1.186-1.024-2-2.342-2C3.414 5 2.5 6.05 2.5 7.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114H6.213c-.048.615-.496 1.05-1.186 1.05-.84 0-1.319-.62-1.319-1.727v-.743zm6.14 0c0-1.111.488-1.753 1.318-1.753.682 0 1.139.47 1.187 1.107H13.5V7c-.053-1.186-1.024-2-2.342-2C9.554 5 8.64 6.05 8.64 7.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.497 1.05-1.187 1.05-.839 0-1.318-.62-1.318-1.727v-.743z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadgeCcFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeCcFill','<path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm3.027 4.002c-.83 0-1.319.642-1.319 1.753v.743c0 1.107.48 1.727 1.319 1.727.69 0 1.138-.435 1.186-1.05H7.36v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747C2.5 6.051 3.414 5 5.018 5c1.318 0 2.29.813 2.342 2v.11H6.213c-.048-.638-.505-1.108-1.186-1.108zm6.14 0c-.831 0-1.319.642-1.319 1.753v.743c0 1.107.48 1.727 1.318 1.727.69 0 1.139-.435 1.187-1.05H13.5v.114c-.057 1.147-1.028 1.938-2.342 1.938-1.613 0-2.518-1.028-2.518-2.729v-.747c0-1.7.914-2.751 2.518-2.751 1.318 0 2.29.813 2.342 2v.11h-1.147c-.048-.638-.505-1.108-1.187-1.108z"/>');// eslint-disable-next-line
var BIconBadgeHd=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeHd','<path d="M7.396 11V5.001H6.209v2.44H3.687V5H2.5v6h1.187V8.43h2.522V11h1.187zM8.5 5.001V11h2.188c1.811 0 2.685-1.107 2.685-3.015 0-1.894-.86-2.984-2.684-2.984H8.5zm1.187.967h.843c1.112 0 1.622.686 1.622 2.04 0 1.353-.505 2.02-1.622 2.02h-.843v-4.06z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadgeHdFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeHdFill','<path d="M10.53 5.968h-.843v4.06h.843c1.117 0 1.622-.667 1.622-2.02 0-1.354-.51-2.04-1.622-2.04z"/><path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm5.396 3.001V11H6.209V8.43H3.687V11H2.5V5.001h1.187v2.44h2.522V5h1.187zM8.5 11V5.001h2.188c1.824 0 2.685 1.09 2.685 2.984C13.373 9.893 12.5 11 10.69 11H8.5z"/>');// eslint-disable-next-line
var BIconBadgeTm=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeTm','<path d="M5.295 11V5.995H7V5H2.403v.994h1.701V11h1.19zm3.397 0V7.01h.058l1.428 3.239h.773l1.42-3.24h.057V11H13.5V5.001h-1.2l-1.71 3.894h-.039l-1.71-3.894H7.634V11h1.06z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadgeTmFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeTmFill','<path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm3.295 3.995V11H4.104V5.995h-1.7V5H7v.994H5.295zM8.692 7.01V11H7.633V5.001h1.209l1.71 3.894h.039l1.71-3.894H13.5V11h-1.072V7.01h-.057l-1.42 3.239h-.773L8.75 7.008h-.058z"/>');// eslint-disable-next-line
var BIconBadgeVo=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeVo','<path d="M4.508 11h1.429l1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11zM13.5 8.39v-.77c0-1.696-.962-2.733-2.566-2.733-1.604 0-2.571 1.029-2.571 2.734v.769c0 1.691.967 2.724 2.57 2.724 1.605 0 2.567-1.033 2.567-2.724zm-1.204-.778v.782c0 1.156-.571 1.732-1.362 1.732-.796 0-1.363-.576-1.363-1.732v-.782c0-1.156.567-1.736 1.363-1.736.79 0 1.362.58 1.362 1.736z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadgeVoFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeVoFill','<path d="M12.296 8.394v-.782c0-1.156-.571-1.736-1.362-1.736-.796 0-1.363.58-1.363 1.736v.782c0 1.156.567 1.732 1.363 1.732.79 0 1.362-.576 1.362-1.732z"/><path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm11.5 5.62v.77c0 1.691-.962 2.724-2.566 2.724-1.604 0-2.571-1.033-2.571-2.724v-.77c0-1.704.967-2.733 2.57-2.733 1.605 0 2.567 1.037 2.567 2.734zM5.937 11H4.508L2.5 5.001h1.375L5.22 9.708h.057L6.61 5.001h1.318L5.937 11z"/>');// eslint-disable-next-line
var BIconBadgeVr=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeVr','<path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path d="M4.508 11h1.429l1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11zm6.387-5.999H8.5V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9zm-1.222 2.87V5.933h1.05c.63 0 1.05.347 1.05.989 0 .633-.408.95-1.067.95H9.673z"/>');// eslint-disable-next-line
var BIconBadgeVrFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeVrFill','<path d="M9.673 5.933v1.938h1.033c.66 0 1.068-.316 1.068-.95 0-.64-.422-.988-1.05-.988h-1.05z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm5.937 7 1.99-5.999H6.61L5.277 9.708H5.22L3.875 5.001H2.5L4.508 11h1.429zM8.5 5.001V11h1.173V8.763h1.064L11.787 11h1.327L11.91 8.583C12.455 8.373 13 7.779 13 6.9c0-1.147-.773-1.9-2.105-1.9H8.5z"/>');// eslint-disable-next-line
var BIconBadgeWc=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeWc','<path d="M10.348 7.643c0-1.112.488-1.754 1.318-1.754.682 0 1.139.47 1.187 1.108H14v-.11c-.053-1.187-1.024-2-2.342-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.497 1.05-1.187 1.05-.839 0-1.318-.62-1.318-1.727v-.742zM4.457 11l1.02-4.184h.045L6.542 11h1.006L9 5.001H7.818l-.82 4.355h-.056L5.97 5.001h-.94l-.972 4.355h-.053l-.827-4.355H2L3.452 11h1.005z"/><path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconBadgeWcFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BadgeWcFill','<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11.666 1.89c.682 0 1.139.47 1.187 1.107H14v-.11c-.053-1.187-1.024-2-2.342-2-1.604 0-2.518 1.05-2.518 2.751v.747c0 1.7.905 2.73 2.518 2.73 1.314 0 2.285-.792 2.342-1.939v-.114h-1.147c-.048.615-.497 1.05-1.187 1.05-.839 0-1.318-.62-1.318-1.727v-.742c0-1.112.488-1.754 1.318-1.754zm-6.188.926h.044L6.542 11h1.006L9 5.001H7.818l-.82 4.355h-.056L5.97 5.001h-.94l-.972 4.355h-.053l-.827-4.355H2L3.452 11h1.005l1.02-4.184z"/>');// eslint-disable-next-line
var BIconBag=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bag','<path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>');// eslint-disable-next-line
var BIconBagCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagCheck','<path fill-rule="evenodd" d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>');// eslint-disable-next-line
var BIconBagCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagCheckFill','<path fill-rule="evenodd" d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zm-.646 5.354a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/>');// eslint-disable-next-line
var BIconBagDash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagDash','<path fill-rule="evenodd" d="M5.5 10a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>');// eslint-disable-next-line
var BIconBagDashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagDashFill','<path fill-rule="evenodd" d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM6 9.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"/>');// eslint-disable-next-line
var BIconBagFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagFill','<path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5z"/>');// eslint-disable-next-line
var BIconBagPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagPlus','<path fill-rule="evenodd" d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"/><path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>');// eslint-disable-next-line
var BIconBagPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagPlusFill','<path fill-rule="evenodd" d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM8.5 8a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V12a.5.5 0 0 0 1 0v-1.5H10a.5.5 0 0 0 0-1H8.5V8z"/>');// eslint-disable-next-line
var BIconBagX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagX','<path fill-rule="evenodd" d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708z"/><path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>');// eslint-disable-next-line
var BIconBagXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BagXFill','<path fill-rule="evenodd" d="M10.5 3.5a2.5 2.5 0 0 0-5 0V4h5v-.5zm1 0V4H15v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4h3.5v-.5a3.5 3.5 0 1 1 7 0zM6.854 8.146a.5.5 0 1 0-.708.708L7.293 10l-1.147 1.146a.5.5 0 0 0 .708.708L8 10.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 10l1.147-1.146a.5.5 0 0 0-.708-.708L8 9.293 6.854 8.146z"/>');// eslint-disable-next-line
var BIconBank=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bank','<path d="M8 .95 14.61 4h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.379l.5 2A.5.5 0 0 1 15.5 17H.5a.5.5 0 0 1-.485-.621l.5-2A.5.5 0 0 1 1 14V7H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 4h.89L8 .95zM3.776 4h8.447L8 2.05 3.776 4zM2 7v7h1V7H2zm2 0v7h2.5V7H4zm3.5 0v7h1V7h-1zm2 0v7H12V7H9.5zM13 7v7h1V7h-1zm2-1V5H1v1h14zm-.39 9H1.39l-.25 1h13.72l-.25-1z"/>');// eslint-disable-next-line
var BIconBank2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bank2','<path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z"/>');// eslint-disable-next-line
var BIconBarChart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BarChart','<path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z"/>');// eslint-disable-next-line
var BIconBarChartFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BarChartFill','<path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"/>');// eslint-disable-next-line
var BIconBarChartLine=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BarChartLine','<path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2zm1 12h2V2h-2v12zm-3 0V7H7v7h2zm-5 0v-3H2v3h2z"/>');// eslint-disable-next-line
var BIconBarChartLineFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BarChartLineFill','<path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z"/>');// eslint-disable-next-line
var BIconBarChartSteps=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BarChartSteps','<path d="M.5 0a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 .5 0zM2 1.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1zm2 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1z"/>');// eslint-disable-next-line
var BIconBasket=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Basket','<path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v4.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 13.5V9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.217L5.07 1.243a.5.5 0 0 1 .686-.172zM2 9v4.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V9H2zM1 7v1h14V7H1zm3 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 4 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 6 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 8 10zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5zm2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconBasket2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Basket2','<path d="M4 10a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0v-2zm3 0a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0v-2z"/><path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.623l-1.844 6.456a.75.75 0 0 1-.722.544H3.69a.75.75 0 0 1-.722-.544L1.123 8H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM2.163 8l1.714 6h8.246l1.714-6H2.163z"/>');// eslint-disable-next-line
var BIconBasket2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Basket2Fill','<path d="M5.929 1.757a.5.5 0 1 0-.858-.514L2.217 6H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.623l1.844 6.456A.75.75 0 0 0 3.69 15h8.622a.75.75 0 0 0 .722-.544L14.877 8h.623a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.717L10.93 1.243a.5.5 0 1 0-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm3 0a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2zm4-1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconBasket3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Basket3','<path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM3.394 15l-1.48-6h-.97l1.525 6.426a.75.75 0 0 0 .729.574h9.606a.75.75 0 0 0 .73-.574L15.056 9h-.972l-1.479 6h-9.21z"/>');// eslint-disable-next-line
var BIconBasket3Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Basket3Fill','<path d="M5.757 1.071a.5.5 0 0 1 .172.686L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 6h1.717L5.07 1.243a.5.5 0 0 1 .686-.172zM2.468 15.426.943 9h14.114l-1.525 6.426a.75.75 0 0 1-.729.574H3.197a.75.75 0 0 1-.73-.574z"/>');// eslint-disable-next-line
var BIconBasketFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BasketFill','<path d="M5.071 1.243a.5.5 0 0 1 .858.514L3.383 6h9.234L10.07 1.757a.5.5 0 1 1 .858-.514L13.783 6H15.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 6h1.717L5.07 1.243zM3.5 10.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3zm2.5 0a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3z"/>');// eslint-disable-next-line
var BIconBattery=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Battery','<path d="M0 6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm2-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2zm14 3a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"/>');// eslint-disable-next-line
var BIconBatteryCharging=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BatteryCharging','<path d="M9.585 2.568a.5.5 0 0 1 .226.58L8.677 6.832h1.99a.5.5 0 0 1 .364.843l-5.334 5.667a.5.5 0 0 1-.842-.49L5.99 9.167H4a.5.5 0 0 1-.364-.843l5.333-5.667a.5.5 0 0 1 .616-.09z"/><path d="M2 4h4.332l-.94 1H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.38l-.308 1H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><path d="M2 6h2.45L2.908 7.639A1.5 1.5 0 0 0 3.313 10H2V6zm8.595-2-.308 1H12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9.276l-.942 1H12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.405z"/><path d="M12 10h-1.783l1.542-1.639c.097-.103.178-.218.241-.34V10zm0-3.354V6h-.646a1.5 1.5 0 0 1 .646.646zM16 8a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"/>');// eslint-disable-next-line
var BIconBatteryFull=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BatteryFull','<path d="M2 6h10v4H2V6z"/><path d="M2 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2zm10 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10zm4 3a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"/>');// eslint-disable-next-line
var BIconBatteryHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BatteryHalf','<path d="M2 6h5v4H2V6z"/><path d="M2 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2zm10 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10zm4 3a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8z"/>');// eslint-disable-next-line
var BIconBell=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bell','<path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>');// eslint-disable-next-line
var BIconBellFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BellFill','<path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"/>');// eslint-disable-next-line
var BIconBellSlash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BellSlash','<path d="M5.164 14H15c-.299-.199-.557-.553-.78-1-.9-1.8-1.22-5.12-1.22-6 0-.264-.02-.523-.06-.776l-.938.938c.02.708.157 2.154.457 3.58.161.767.377 1.566.663 2.258H6.164l-1 1zm5.581-9.91a3.986 3.986 0 0 0-1.948-1.01L8 2.917l-.797.161A4.002 4.002 0 0 0 4 7c0 .628-.134 2.197-.459 3.742-.05.238-.105.479-.166.718l-1.653 1.653c.02-.037.04-.074.059-.113C2.679 11.2 3 7.88 3 7c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0c.942.19 1.788.645 2.457 1.284l-.707.707zM10 15a2 2 0 1 1-4 0h4zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75L.625 15.625z"/>');// eslint-disable-next-line
var BIconBellSlashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BellSlashFill','<path d="M5.164 14H15c-1.5-1-2-5.902-2-7 0-.264-.02-.523-.06-.776L5.164 14zm6.288-10.617A4.988 4.988 0 0 0 8.995 2.1a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 7c0 .898-.335 4.342-1.278 6.113l9.73-9.73zM10 15a2 2 0 1 1-4 0h4zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75L.625 15.625z"/>');// eslint-disable-next-line
var BIconBezier=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bezier','<path fill-rule="evenodd" d="M0 10.5A1.5 1.5 0 0 1 1.5 9h1A1.5 1.5 0 0 1 4 10.5v1A1.5 1.5 0 0 1 2.5 13h-1A1.5 1.5 0 0 1 0 11.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm10.5.5A1.5 1.5 0 0 1 13.5 9h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM6 4.5A1.5 1.5 0 0 1 7.5 3h1A1.5 1.5 0 0 1 10 4.5v1A1.5 1.5 0 0 1 8.5 7h-1A1.5 1.5 0 0 1 6 5.5v-1zM7.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"/><path d="M6 4.5H1.866a1 1 0 1 0 0 1h2.668A6.517 6.517 0 0 0 1.814 9H2.5c.123 0 .244.015.358.043a5.517 5.517 0 0 1 3.185-3.185A1.503 1.503 0 0 1 6 5.5v-1zm3.957 1.358A1.5 1.5 0 0 0 10 5.5v-1h4.134a1 1 0 1 1 0 1h-2.668a6.517 6.517 0 0 1 2.72 3.5H13.5c-.123 0-.243.015-.358.043a5.517 5.517 0 0 0-3.185-3.185z"/>');// eslint-disable-next-line
var BIconBezier2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bezier2','<path fill-rule="evenodd" d="M1 2.5A1.5 1.5 0 0 1 2.5 1h1A1.5 1.5 0 0 1 5 2.5h4.134a1 1 0 1 1 0 1h-2.01c.18.18.34.381.484.605.638.992.892 2.354.892 3.895 0 1.993.257 3.092.713 3.7.356.476.895.721 1.787.784A1.5 1.5 0 0 1 12.5 11h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5H6.866a1 1 0 1 1 0-1h1.711a2.839 2.839 0 0 1-.165-.2C7.743 11.407 7.5 10.007 7.5 8c0-1.46-.246-2.597-.733-3.355-.39-.605-.952-1-1.767-1.112A1.5 1.5 0 0 1 3.5 5h-1A1.5 1.5 0 0 1 1 3.5v-1zM2.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm10 10a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"/>');// eslint-disable-next-line
var BIconBicycle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bicycle','<path d="M4 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 0 1v.5h4.14l.386-1.158A.5.5 0 0 1 11 4h1a.5.5 0 0 1 0 1h-.64l-.311.935.807 1.29a3 3 0 1 1-.848.53l-.508-.812-2.076 3.322A.5.5 0 0 1 8 10.5H5.959a3 3 0 1 1-1.815-3.274L5 5.856V5h-.5a.5.5 0 0 1-.5-.5zm1.5 2.443-.508.814c.5.444.85 1.054.967 1.743h1.139L5.5 6.943zM8 9.057 9.598 6.5H6.402L8 9.057zM4.937 9.5a1.997 1.997 0 0 0-.487-.877l-.548.877h1.035zM3.603 8.092A2 2 0 1 0 4.937 10.5H3a.5.5 0 0 1-.424-.765l1.027-1.643zm7.947.53a2 2 0 1 0 .848-.53l1.026 1.643a.5.5 0 1 1-.848.53L11.55 8.623z"/>');// eslint-disable-next-line
var BIconBinoculars=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Binoculars','<path d="M3 2.5A1.5 1.5 0 0 1 4.5 1h1A1.5 1.5 0 0 1 7 2.5V5h2V2.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5v2.382a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V14.5a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 14.5v-3a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5v3A1.5 1.5 0 0 1 5.5 16h-3A1.5 1.5 0 0 1 1 14.5V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V2.5zM4.5 2a.5.5 0 0 0-.5.5V3h2v-.5a.5.5 0 0 0-.5-.5h-1zM6 4H4v.882a1.5 1.5 0 0 1-.83 1.342l-.894.447A.5.5 0 0 0 2 7.118V13h4v-1.293l-.854-.853A.5.5 0 0 1 5 10.5v-1A1.5 1.5 0 0 1 6.5 8h3A1.5 1.5 0 0 1 11 9.5v1a.5.5 0 0 1-.146.354l-.854.853V13h4V7.118a.5.5 0 0 0-.276-.447l-.895-.447A1.5 1.5 0 0 1 12 4.882V4h-2v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4zm4-1h2v-.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V3zm4 11h-4v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14zm-8 0H2v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14z"/>');// eslint-disable-next-line
var BIconBinocularsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BinocularsFill','<path d="M4.5 1A1.5 1.5 0 0 0 3 2.5V3h4v-.5A1.5 1.5 0 0 0 5.5 1h-1zM7 4v1h2V4h4v.882a.5.5 0 0 0 .276.447l.895.447A1.5 1.5 0 0 1 15 7.118V13H9v-1.5a.5.5 0 0 1 .146-.354l.854-.853V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v.793l.854.853A.5.5 0 0 1 7 11.5V13H1V7.118a1.5 1.5 0 0 1 .83-1.342l.894-.447A.5.5 0 0 0 3 4.882V4h4zM1 14v.5A1.5 1.5 0 0 0 2.5 16h3A1.5 1.5 0 0 0 7 14.5V14H1zm8 0v.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V14H9zm4-11H9v-.5A1.5 1.5 0 0 1 10.5 1h1A1.5 1.5 0 0 1 13 2.5V3z"/>');// eslint-disable-next-line
var BIconBlockquoteLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BlockquoteLeft','<path d="M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm5 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm-5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm.79-5.373c.112-.078.26-.17.444-.275L3.524 6c-.122.074-.272.17-.452.287-.18.117-.35.26-.51.428a2.425 2.425 0 0 0-.398.562c-.11.207-.164.438-.164.692 0 .36.072.65.217.873.144.219.385.328.72.328.215 0 .383-.07.504-.211a.697.697 0 0 0 .188-.463c0-.23-.07-.404-.211-.521-.137-.121-.326-.182-.568-.182h-.282c.024-.203.065-.37.123-.498a1.38 1.38 0 0 1 .252-.37 1.94 1.94 0 0 1 .346-.298zm2.167 0c.113-.078.262-.17.445-.275L5.692 6c-.122.074-.272.17-.452.287-.18.117-.35.26-.51.428a2.425 2.425 0 0 0-.398.562c-.11.207-.164.438-.164.692 0 .36.072.65.217.873.144.219.385.328.72.328.215 0 .383-.07.504-.211a.697.697 0 0 0 .188-.463c0-.23-.07-.404-.211-.521-.137-.121-.326-.182-.568-.182h-.282a1.75 1.75 0 0 1 .118-.492c.058-.13.144-.254.257-.375a1.94 1.94 0 0 1 .346-.3z"/>');// eslint-disable-next-line
var BIconBlockquoteRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BlockquoteRight','<path d="M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm0 3a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm0 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11zm10.113-5.373a6.59 6.59 0 0 0-.445-.275l.21-.352c.122.074.272.17.452.287.18.117.35.26.51.428.156.164.289.351.398.562.11.207.164.438.164.692 0 .36-.072.65-.216.873-.145.219-.385.328-.721.328-.215 0-.383-.07-.504-.211a.697.697 0 0 1-.188-.463c0-.23.07-.404.211-.521.137-.121.326-.182.569-.182h.281a1.686 1.686 0 0 0-.123-.498 1.379 1.379 0 0 0-.252-.37 1.94 1.94 0 0 0-.346-.298zm-2.168 0A6.59 6.59 0 0 0 10 6.352L10.21 6c.122.074.272.17.452.287.18.117.35.26.51.428.156.164.289.351.398.562.11.207.164.438.164.692 0 .36-.072.65-.216.873-.145.219-.385.328-.721.328-.215 0-.383-.07-.504-.211a.697.697 0 0 1-.188-.463c0-.23.07-.404.211-.521.137-.121.327-.182.569-.182h.281a1.749 1.749 0 0 0-.117-.492 1.402 1.402 0 0 0-.258-.375 1.94 1.94 0 0 0-.346-.3z"/>');// eslint-disable-next-line
var BIconBook=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Book','<path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"/>');// eslint-disable-next-line
var BIconBookFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookFill','<path d="M8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"/>');// eslint-disable-next-line
var BIconBookHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookHalf','<path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"/>');// eslint-disable-next-line
var BIconBookmark=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bookmark','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>');// eslint-disable-next-line
var BIconBookmarkCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkCheck','<path fill-rule="evenodd" d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>');// eslint-disable-next-line
var BIconBookmarkCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkCheckFill','<path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/>');// eslint-disable-next-line
var BIconBookmarkDash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkDash','<path fill-rule="evenodd" d="M5.5 6.5A.5.5 0 0 1 6 6h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>');// eslint-disable-next-line
var BIconBookmarkDashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkDashFill','<path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM6 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"/>');// eslint-disable-next-line
var BIconBookmarkFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkFill','<path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"/>');// eslint-disable-next-line
var BIconBookmarkHeart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkHeart','<path fill-rule="evenodd" d="M8 4.41c1.387-1.425 4.854 1.07 0 4.277C3.146 5.48 6.613 2.986 8 4.412z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>');// eslint-disable-next-line
var BIconBookmarkHeartFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkHeartFill','<path d="M2 15.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v13.5zM8 4.41c1.387-1.425 4.854 1.07 0 4.277C3.146 5.48 6.613 2.986 8 4.412z"/>');// eslint-disable-next-line
var BIconBookmarkPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkPlus','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/><path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4z"/>');// eslint-disable-next-line
var BIconBookmarkPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkPlusFill','<path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm6.5-11a.5.5 0 0 0-1 0V6H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V7H10a.5.5 0 0 0 0-1H8.5V4.5z"/>');// eslint-disable-next-line
var BIconBookmarkStar=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkStar','<path d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.178.178 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.178.178 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.178.178 0 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.178.178 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.178.178 0 0 0 .134-.098L7.84 4.1z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>');// eslint-disable-next-line
var BIconBookmarkStarFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkStarFill','<path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM8.16 4.1a.178.178 0 0 0-.32 0l-.634 1.285a.178.178 0 0 1-.134.098l-1.42.206a.178.178 0 0 0-.098.303L6.58 6.993c.042.041.061.1.051.158L6.39 8.565a.178.178 0 0 0 .258.187l1.27-.668a.178.178 0 0 1 .165 0l1.27.668a.178.178 0 0 0 .257-.187L9.368 7.15a.178.178 0 0 1 .05-.158l1.028-1.001a.178.178 0 0 0-.098-.303l-1.42-.206a.178.178 0 0 1-.134-.098L8.16 4.1z"/>');// eslint-disable-next-line
var BIconBookmarkX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkX','<path fill-rule="evenodd" d="M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>');// eslint-disable-next-line
var BIconBookmarkXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarkXFill','<path fill-rule="evenodd" d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zM6.854 5.146a.5.5 0 1 0-.708.708L7.293 7 6.146 8.146a.5.5 0 1 0 .708.708L8 7.707l1.146 1.147a.5.5 0 1 0 .708-.708L8.707 7l1.147-1.146a.5.5 0 0 0-.708-.708L8 6.293 6.854 5.146z"/>');// eslint-disable-next-line
var BIconBookmarks=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bookmarks','<path d="M2 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L7 13.101l-4.223 2.815A.5.5 0 0 1 2 15.5V4zm2-1a1 1 0 0 0-1 1v10.566l3.723-2.482a.5.5 0 0 1 .554 0L11 14.566V4a1 1 0 0 0-1-1H4z"/><path d="M4.268 1H12a1 1 0 0 1 1 1v11.768l.223.148A.5.5 0 0 0 14 13.5V2a2 2 0 0 0-2-2H6a2 2 0 0 0-1.732 1z"/>');// eslint-disable-next-line
var BIconBookmarksFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BookmarksFill','<path d="M2 4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L7 13.101l-4.223 2.815A.5.5 0 0 1 2 15.5V4z"/><path d="M4.268 1A2 2 0 0 1 6 0h6a2 2 0 0 1 2 2v11.5a.5.5 0 0 1-.777.416L13 13.768V2a1 1 0 0 0-1-1H4.268z"/>');// eslint-disable-next-line
var BIconBookshelf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bookshelf','<path d="M2.5 0a.5.5 0 0 1 .5.5V2h10V.5a.5.5 0 0 1 1 0v15a.5.5 0 0 1-1 0V15H3v.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5zM3 14h10v-3H3v3zm0-4h10V7H3v3zm0-4h10V3H3v3z"/>');// eslint-disable-next-line
var BIconBootstrap=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bootstrap','<path d="M5.062 12h3.475c1.804 0 2.888-.908 2.888-2.396 0-1.102-.761-1.916-1.904-2.034v-.1c.832-.14 1.482-.93 1.482-1.816 0-1.3-.955-2.11-2.542-2.11H5.062V12zm1.313-4.875V4.658h1.78c.973 0 1.542.457 1.542 1.237 0 .802-.604 1.23-1.764 1.23H6.375zm0 3.762V8.162h1.822c1.236 0 1.887.463 1.887 1.348 0 .896-.627 1.377-1.811 1.377H6.375z"/><path d="M0 4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4zm4-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3H4z"/>');// eslint-disable-next-line
var BIconBootstrapFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BootstrapFill','<path d="M6.375 7.125V4.658h1.78c.973 0 1.542.457 1.542 1.237 0 .802-.604 1.23-1.764 1.23H6.375zm0 3.762h1.898c1.184 0 1.81-.48 1.81-1.377 0-.885-.65-1.348-1.886-1.348H6.375v2.725z"/><path d="M4.002 0a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4h-8zm1.06 12V3.545h3.399c1.587 0 2.543.809 2.543 2.11 0 .884-.65 1.675-1.483 1.816v.1c1.143.117 1.904.931 1.904 2.033 0 1.488-1.084 2.396-2.888 2.396H5.062z"/>');// eslint-disable-next-line
var BIconBootstrapReboot=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BootstrapReboot','<path d="M1.161 8a6.84 6.84 0 1 0 6.842-6.84.58.58 0 1 1 0-1.16 8 8 0 1 1-6.556 3.412l-.663-.577a.58.58 0 0 1 .227-.997l2.52-.69a.58.58 0 0 1 .728.633l-.332 2.592a.58.58 0 0 1-.956.364l-.643-.56A6.812 6.812 0 0 0 1.16 8z"/><path d="M6.641 11.671V8.843h1.57l1.498 2.828h1.314L9.377 8.665c.897-.3 1.427-1.106 1.427-2.1 0-1.37-.943-2.246-2.456-2.246H5.5v7.352h1.141zm0-3.75V5.277h1.57c.881 0 1.416.499 1.416 1.32 0 .84-.504 1.324-1.386 1.324h-1.6z"/>');// eslint-disable-next-line
var BIconBorder=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Border','<path d="M0 0h.969v.5H1v.469H.969V1H.5V.969H0V0zm2.844 1h-.938V0h.938v1zm1.875 0H3.78V0h.938v1zm1.875 0h-.938V0h.938v1zm.937 0V.969H7.5V.5h.031V0h.938v.5H8.5v.469h-.031V1H7.53zm2.813 0h-.938V0h.938v1zm1.875 0h-.938V0h.938v1zm1.875 0h-.938V0h.938v1zM15.5 1h-.469V.969H15V.5h.031V0H16v.969h-.5V1zM1 1.906v.938H0v-.938h1zm6.5.938v-.938h1v.938h-1zm7.5 0v-.938h1v.938h-1zM1 3.78v.938H0V3.78h1zm6.5.938V3.78h1v.938h-1zm7.5 0V3.78h1v.938h-1zM1 5.656v.938H0v-.938h1zm6.5.938v-.938h1v.938h-1zm7.5 0v-.938h1v.938h-1zM.969 8.5H.5v-.031H0V7.53h.5V7.5h.469v.031H1v.938H.969V8.5zm1.875 0h-.938v-1h.938v1zm1.875 0H3.78v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.875-.031V8.5H7.53v-.031H7.5V7.53h.031V7.5h.938v.031H8.5v.938h-.031zm1.875.031h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.406 0h-.469v-.031H15V7.53h.031V7.5h.469v.031h.5v.938h-.5V8.5zM0 10.344v-.938h1v.938H0zm7.5 0v-.938h1v.938h-1zm8.5-.938v.938h-1v-.938h1zM0 12.22v-.938h1v.938H0zm7.5 0v-.938h1v.938h-1zm8.5-.938v.938h-1v-.938h1zM0 14.094v-.938h1v.938H0zm7.5 0v-.938h1v.938h-1zm8.5-.938v.938h-1v-.938h1zM.969 16H0v-.969h.5V15h.469v.031H1v.469H.969v.5zm1.875 0h-.938v-1h.938v1zm1.875 0H3.78v-1h.938v1zm1.875 0h-.938v-1h.938v1zm.937 0v-.5H7.5v-.469h.031V15h.938v.031H8.5v.469h-.031v.5H7.53zm2.813 0h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm1.875 0h-.938v-1h.938v1zm.937 0v-.5H15v-.469h.031V15h.469v.031h.5V16h-.969z"/>');// eslint-disable-next-line
var BIconBorderAll=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderAll','<path d="M0 0h16v16H0V0zm1 1v6.5h6.5V1H1zm7.5 0v6.5H15V1H8.5zM15 8.5H8.5V15H15V8.5zM7.5 15V8.5H1V15h6.5z"/>');// eslint-disable-next-line
var BIconBorderBottom=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderBottom','<path d="M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM0 9.406v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM0 15h16v1H0v-1z"/>');// eslint-disable-next-line
var BIconBorderCenter=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderCenter','<path d="M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM0 8.5v-1h16v1H0zm0 .906v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"/>');// eslint-disable-next-line
var BIconBorderInner=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderInner','<path d="M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1z"/><path d="M8.5 7.5H16v1H8.5V16h-1V8.5H0v-1h7.5V0h1v7.5z"/><path d="M9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm14-.938v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM0 9.406v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm3.75 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"/>');// eslint-disable-next-line
var BIconBorderLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderLeft','<path d="M0 0v16h1V0H0zm1.906 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM7.5 1.906v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM7.5 3.781v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM7.5 5.656v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1.906 8.5h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM7.5 9.406v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-8.5.937v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-8.5.937v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM1.906 16h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"/>');// eslint-disable-next-line
var BIconBorderMiddle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderMiddle','<path d="M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM8.5 16h-1V0h1v16zm.906-15h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.469V.969h.5V0h-.969v.5H15v.469h.031V1zM1 2.844v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm14-.938v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm14-.938v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm3.75 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM0 9.406v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm16 .938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm3.75 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"/>');// eslint-disable-next-line
var BIconBorderOuter=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderOuter','<path d="M7.5 1.906v.938h1v-.938h-1zm0 1.875v.938h1V3.78h-1zm0 1.875v.938h1v-.938h-1zM1.906 8.5h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zM7.5 9.406v.938h1v-.938h-1zm0 1.875v.938h1v-.938h-1zm0 1.875v.938h1v-.938h-1z"/><path d="M0 0v16h16V0H0zm1 1h14v14H1V1z"/>');// eslint-disable-next-line
var BIconBorderRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderRight','<path d="M.969 0H0v.969h.5V1h.469V.969H1V.5H.969V0zm.937 1h.938V0h-.938v1zm1.875 0h.938V0H3.78v1zm1.875 0h.938V0h-.938v1zM7.531.969V1h.938V.969H8.5V.5h-.031V0H7.53v.5H7.5v.469h.031zM9.406 1h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zm1.875 0h.938V0h-.938v1zM16 0h-1v16h1V0zM1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zM0 9.406v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zM0 11.281v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zM0 13.156v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1z"/>');// eslint-disable-next-line
var BIconBorderStyle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderStyle','<path d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm8 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-4-4a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1z"/>');// eslint-disable-next-line
var BIconBorderTop=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderTop','<path d="M0 0v1h16V0H0zm1 2.844v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM1 4.719V3.78H0v.938h1zm6.5-.938v.938h1V3.78h-1zm7.5 0v.938h1V3.78h-1zM1 6.594v-.938H0v.938h1zm6.5-.938v.938h1v-.938h-1zm7.5 0v.938h1v-.938h-1zM.5 8.5h.469v-.031H1V7.53H.969V7.5H.5v.031H0v.938h.5V8.5zm1.406 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm2.813 0v-.031H8.5V7.53h-.031V7.5H7.53v.031H7.5v.938h.031V8.5h.938zm.937 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.469v-.031h.5V7.53h-.5V7.5h-.469v.031H15v.938h.031V8.5zM0 9.406v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zm-16 .937v.938h1v-.938H0zm7.5 0v.938h1v-.938h-1zm8.5.938v-.938h-1v.938h1zM0 16h.969v-.5H1v-.469H.969V15H.5v.031H0V16zm1.906 0h.938v-1h-.938v1zm1.875 0h.938v-1H3.78v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5h.938v-.5H8.5v-.469h-.031V15H7.53v.031H7.5v.469h.031zm1.875.5h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875 0h.938v-1h-.938v1zm1.875-.5v.5H16v-.969h-.5V15h-.469v.031H15v.469h.031z"/>');// eslint-disable-next-line
var BIconBorderWidth=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BorderWidth','<path d="M0 3.5A.5.5 0 0 1 .5 3h15a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-2zm0 5A.5.5 0 0 1 .5 8h15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1zm0 4a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconBoundingBox=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoundingBox','<path d="M5 2V0H0v5h2v6H0v5h5v-2h6v2h5v-5h-2V5h2V0h-5v2H5zm6 1v2h2v6h-2v2H5v-2H3V5h2V3h6zm1-2h3v3h-3V1zm3 11v3h-3v-3h3zM4 15H1v-3h3v3zM1 4V1h3v3H1z"/>');// eslint-disable-next-line
var BIconBoundingBoxCircles=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoundingBoxCircles','<path d="M2 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM0 2a2 2 0 0 1 3.937-.5h8.126A2 2 0 1 1 14.5 3.937v8.126a2 2 0 1 1-2.437 2.437H3.937A2 2 0 1 1 1.5 12.063V3.937A2 2 0 0 1 0 2zm2.5 1.937v8.126c.703.18 1.256.734 1.437 1.437h8.126a2.004 2.004 0 0 1 1.437-1.437V3.937A2.004 2.004 0 0 1 12.063 2.5H3.937A2.004 2.004 0 0 1 2.5 3.937zM14 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>');// eslint-disable-next-line
var BIconBox=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Box','<path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"/>');// eslint-disable-next-line
var BIconBoxArrowDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowDown','<path fill-rule="evenodd" d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"/><path fill-rule="evenodd" d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>');// eslint-disable-next-line
var BIconBoxArrowDownLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowDownLeft','<path fill-rule="evenodd" d="M7.364 12.5a.5.5 0 0 0 .5.5H14.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 14.5 0h-10A1.5 1.5 0 0 0 3 1.5v6.636a.5.5 0 1 0 1 0V1.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H7.864a.5.5 0 0 0-.5.5z"/><path fill-rule="evenodd" d="M0 15.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H1.707l8.147-8.146a.5.5 0 0 0-.708-.708L1 14.293V10.5a.5.5 0 0 0-1 0v5z"/>');// eslint-disable-next-line
var BIconBoxArrowDownRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowDownRight','<path fill-rule="evenodd" d="M8.636 12.5a.5.5 0 0 1-.5.5H1.5A1.5 1.5 0 0 1 0 11.5v-10A1.5 1.5 0 0 1 1.5 0h10A1.5 1.5 0 0 1 13 1.5v6.636a.5.5 0 0 1-1 0V1.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6.636a.5.5 0 0 1 .5.5z"/><path fill-rule="evenodd" d="M16 15.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.793L6.146 6.854a.5.5 0 1 1 .708-.708L15 14.293V10.5a.5.5 0 0 1 1 0v5z"/>');// eslint-disable-next-line
var BIconBoxArrowInDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInDown','<path fill-rule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"/><path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>');// eslint-disable-next-line
var BIconBoxArrowInDownLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInDownLeft','<path fill-rule="evenodd" d="M9.636 2.5a.5.5 0 0 0-.5-.5H2.5A1.5 1.5 0 0 0 1 3.5v10A1.5 1.5 0 0 0 2.5 15h10a1.5 1.5 0 0 0 1.5-1.5V6.864a.5.5 0 0 0-1 0V13.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/><path fill-rule="evenodd" d="M5 10.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H6.707l8.147-8.146a.5.5 0 0 0-.708-.708L6 9.293V5.5a.5.5 0 0 0-1 0v5z"/>');// eslint-disable-next-line
var BIconBoxArrowInDownRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInDownRight','<path fill-rule="evenodd" d="M6.364 2.5a.5.5 0 0 1 .5-.5H13.5A1.5 1.5 0 0 1 15 3.5v10a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 2 13.5V6.864a.5.5 0 1 1 1 0V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H6.864a.5.5 0 0 1-.5-.5z"/><path fill-rule="evenodd" d="M11 10.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.793L1.146 1.854a.5.5 0 1 1 .708-.708L10 9.293V5.5a.5.5 0 0 1 1 0v5z"/>');// eslint-disable-next-line
var BIconBoxArrowInLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInLeft','<path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h8A1.5 1.5 0 0 1 11 3.5v2a.5.5 0 0 1-1 0v-2z"/><path fill-rule="evenodd" d="M4.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H14.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>');// eslint-disable-next-line
var BIconBoxArrowInRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInRight','<path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"/><path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>');// eslint-disable-next-line
var BIconBoxArrowInUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInUp','<path fill-rule="evenodd" d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1h-2z"/><path fill-rule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>');// eslint-disable-next-line
var BIconBoxArrowInUpLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInUpLeft','<path fill-rule="evenodd" d="M9.636 13.5a.5.5 0 0 1-.5.5H2.5A1.5 1.5 0 0 1 1 12.5v-10A1.5 1.5 0 0 1 2.5 1h10A1.5 1.5 0 0 1 14 2.5v6.636a.5.5 0 0 1-1 0V2.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6.636a.5.5 0 0 1 .5.5z"/><path fill-rule="evenodd" d="M5 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H6.707l8.147 8.146a.5.5 0 0 1-.708.708L6 6.707V10.5a.5.5 0 0 1-1 0v-5z"/>');// eslint-disable-next-line
var BIconBoxArrowInUpRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowInUpRight','<path fill-rule="evenodd" d="M6.364 13.5a.5.5 0 0 0 .5.5H13.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 13.5 1h-10A1.5 1.5 0 0 0 2 2.5v6.636a.5.5 0 1 0 1 0V2.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H6.864a.5.5 0 0 0-.5.5z"/><path fill-rule="evenodd" d="M11 5.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793l-8.147 8.146a.5.5 0 0 0 .708.708L10 6.707V10.5a.5.5 0 0 0 1 0v-5z"/>');// eslint-disable-next-line
var BIconBoxArrowLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowLeft','<path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"/><path fill-rule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>');// eslint-disable-next-line
var BIconBoxArrowRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowRight','<path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/><path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>');// eslint-disable-next-line
var BIconBoxArrowUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowUp','<path fill-rule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"/><path fill-rule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708l3-3z"/>');// eslint-disable-next-line
var BIconBoxArrowUpLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowUpLeft','<path fill-rule="evenodd" d="M7.364 3.5a.5.5 0 0 1 .5-.5H14.5A1.5 1.5 0 0 1 16 4.5v10a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 3 14.5V7.864a.5.5 0 1 1 1 0V14.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5H7.864a.5.5 0 0 1-.5-.5z"/><path fill-rule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h5a.5.5 0 0 1 0 1H1.707l8.147 8.146a.5.5 0 0 1-.708.708L1 1.707V5.5a.5.5 0 0 1-1 0v-5z"/>');// eslint-disable-next-line
var BIconBoxArrowUpRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxArrowUpRight','<path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/><path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>');// eslint-disable-next-line
var BIconBoxSeam=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BoxSeam','<path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"/>');// eslint-disable-next-line
var BIconBraces=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Braces','<path d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6zM13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6z"/>');// eslint-disable-next-line
var BIconBricks=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bricks','<path d="M0 .5A.5.5 0 0 1 .5 0h15a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H14v2h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H2v-2H.5a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 .5 6H2V4H.5a.5.5 0 0 1-.5-.5v-3zM3 4v2h4.5V4H3zm5.5 0v2H13V4H8.5zM3 10v2h4.5v-2H3zm5.5 0v2H13v-2H8.5zM1 1v2h3.5V1H1zm4.5 0v2h5V1h-5zm6 0v2H15V1h-3.5zM1 7v2h3.5V7H1zm4.5 0v2h5V7h-5zm6 0v2H15V7h-3.5zM1 13v2h3.5v-2H1zm4.5 0v2h5v-2h-5zm6 0v2H15v-2h-3.5z"/>');// eslint-disable-next-line
var BIconBriefcase=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Briefcase','<path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconBriefcaseFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BriefcaseFill','<path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5z"/><path d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85v5.65z"/>');// eslint-disable-next-line
var BIconBrightnessAltHigh=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessAltHigh','<path d="M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3zm8 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm-13.5.5a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1h2zm11.157-6.157a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm-9.9 2.121a.5.5 0 0 0 .707-.707L3.05 5.343a.5.5 0 1 0-.707.707l1.414 1.414zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4zm0 1a3 3 0 0 1 2.959 2.5H5.04A3 3 0 0 1 8 8z"/>');// eslint-disable-next-line
var BIconBrightnessAltHighFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessAltHighFill','<path d="M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3zm8 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zm-13.5.5a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1h2zm11.157-6.157a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm-9.9 2.121a.5.5 0 0 0 .707-.707L3.05 5.343a.5.5 0 1 0-.707.707l1.414 1.414zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4z"/>');// eslint-disable-next-line
var BIconBrightnessAltLow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessAltLow','<path d="M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 11a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm10.243-3.536a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-8.486-.707a.5.5 0 1 0 .707.707.5.5 0 0 0-.707-.707zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4zm0 1a3 3 0 0 1 2.959 2.5H5.04A3 3 0 0 1 8 8z"/>');// eslint-disable-next-line
var BIconBrightnessAltLowFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessAltLowFill','<path d="M8.5 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 11a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0zm10.243-3.536a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-8.486-.707a.5.5 0 1 0 .707.707.5.5 0 0 0-.707-.707zM8 7a4 4 0 0 0-4 4 .5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 4 4 0 0 0-4-4z"/>');// eslint-disable-next-line
var BIconBrightnessHigh=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessHigh','<path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>');// eslint-disable-next-line
var BIconBrightnessHighFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessHighFill','<path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>');// eslint-disable-next-line
var BIconBrightnessLow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessLow','<path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm.5-9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-11 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9.743-4.036a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-7.779 7.779a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm7.072 0a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707zM3.757 4.464a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707z"/>');// eslint-disable-next-line
var BIconBrightnessLowFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrightnessLowFill','<path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM8.5 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm5-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-11 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9.743-4.036a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm-7.779 7.779a.5.5 0 1 1-.707-.707.5.5 0 0 1 .707.707zm7.072 0a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707zM3.757 4.464a.5.5 0 1 1 .707-.707.5.5 0 0 1-.707.707z"/>');// eslint-disable-next-line
var BIconBroadcast=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Broadcast','<path d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707zm2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708zm5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708zm2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>');// eslint-disable-next-line
var BIconBroadcastPin=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BroadcastPin','<path d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707zm2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708zm5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708zm2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM6 8a2 2 0 1 1 2.5 1.937V15.5a.5.5 0 0 1-1 0V9.937A2 2 0 0 1 6 8z"/>');// eslint-disable-next-line
var BIconBrush=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Brush','<path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04zM4.705 11.912a1.23 1.23 0 0 0-.419-.1c-.246-.013-.573.05-.879.479-.197.275-.355.532-.5.777l-.105.177c-.106.181-.213.362-.32.528a3.39 3.39 0 0 1-.76.861c.69.112 1.736.111 2.657-.12.559-.139.843-.569.993-1.06a3.122 3.122 0 0 0 .126-.75l-.793-.792zm1.44.026c.12-.04.277-.1.458-.183a5.068 5.068 0 0 0 1.535-1.1c1.9-1.996 4.412-5.57 6.052-8.631-2.59 1.927-5.566 4.66-7.302 6.792-.442.543-.795 1.243-1.042 1.826-.121.288-.214.54-.275.72v.001l.575.575zm-4.973 3.04.007-.005a.031.031 0 0 1-.007.004zm3.582-3.043.002.001h-.002z"/>');// eslint-disable-next-line
var BIconBrushFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BrushFill','<path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"/>');// eslint-disable-next-line
var BIconBucket=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bucket','<path d="M2.522 5H2a.5.5 0 0 0-.494.574l1.372 9.149A1.5 1.5 0 0 0 4.36 16h7.278a1.5 1.5 0 0 0 1.483-1.277l1.373-9.149A.5.5 0 0 0 14 5h-.522A5.5 5.5 0 0 0 2.522 5zm1.005 0a4.5 4.5 0 0 1 8.945 0H3.527zm9.892 1-1.286 8.574a.5.5 0 0 1-.494.426H4.36a.5.5 0 0 1-.494-.426L2.58 6h10.838z"/>');// eslint-disable-next-line
var BIconBucketFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BucketFill','<path d="M2.522 5H2a.5.5 0 0 0-.494.574l1.372 9.149A1.5 1.5 0 0 0 4.36 16h7.278a1.5 1.5 0 0 0 1.483-1.277l1.373-9.149A.5.5 0 0 0 14 5h-.522A5.5 5.5 0 0 0 2.522 5zm1.005 0a4.5 4.5 0 0 1 8.945 0H3.527z"/>');// eslint-disable-next-line
var BIconBug=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bug','<path d="M4.355.522a.5.5 0 0 1 .623.333l.291.956A4.979 4.979 0 0 1 8 1c1.007 0 1.946.298 2.731.811l.29-.956a.5.5 0 1 1 .957.29l-.41 1.352A4.985 4.985 0 0 1 13 6h.5a.5.5 0 0 0 .5-.5V5a.5.5 0 0 1 1 0v.5A1.5 1.5 0 0 1 13.5 7H13v1h1.5a.5.5 0 0 1 0 1H13v1h.5a1.5 1.5 0 0 1 1.5 1.5v.5a.5.5 0 1 1-1 0v-.5a.5.5 0 0 0-.5-.5H13a5 5 0 0 1-10 0h-.5a.5.5 0 0 0-.5.5v.5a.5.5 0 1 1-1 0v-.5A1.5 1.5 0 0 1 2.5 10H3V9H1.5a.5.5 0 0 1 0-1H3V7h-.5A1.5 1.5 0 0 1 1 5.5V5a.5.5 0 0 1 1 0v.5a.5.5 0 0 0 .5.5H3c0-1.364.547-2.601 1.432-3.503l-.41-1.352a.5.5 0 0 1 .333-.623zM4 7v4a4 4 0 0 0 3.5 3.97V7H4zm4.5 0v7.97A4 4 0 0 0 12 11V7H8.5zM12 6a3.989 3.989 0 0 0-1.334-2.982A3.983 3.983 0 0 0 8 2a3.983 3.983 0 0 0-2.667 1.018A3.989 3.989 0 0 0 4 6h8z"/>');// eslint-disable-next-line
var BIconBugFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('BugFill','<path d="M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z"/><path d="M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z"/>');// eslint-disable-next-line
var BIconBuilding=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Building','<path fill-rule="evenodd" d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"/><path d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"/>');// eslint-disable-next-line
var BIconBullseye=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Bullseye','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10zm0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/><path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/><path d="M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconCalculator=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calculator','<path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/><path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"/>');// eslint-disable-next-line
var BIconCalculatorFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalculatorFill','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2 .5v2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5zm0 4v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM4.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM4 12.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM7.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM7 9.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM10 6.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm.5 2.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-1z"/>');// eslint-disable-next-line
var BIconCalendar=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendar2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2Check=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Check','<path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2CheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2CheckFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.6 5.854a.5.5 0 0 0-.708-.708L7.5 10.793 6.354 9.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/>');// eslint-disable-next-line
var BIconCalendar2Date=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Date','<path d="M6.445 12.688V7.354h-.633A12.6 12.6 0 0 0 4.5 8.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2DateFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2DateFill','<path d="M9.402 10.246c.625 0 1.184-.484 1.184-1.18 0-.832-.527-1.23-1.16-1.23-.586 0-1.168.387-1.168 1.21 0 .817.543 1.2 1.144 1.2z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-4.118 9.79c1.258 0 2-1.067 2-2.872 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684c.047.64.594 1.406 1.703 1.406zm-2.89-5.435h-.633A12.6 12.6 0 0 0 4.5 8.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675V7.354z"/>');// eslint-disable-next-line
var BIconCalendar2Day=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Day','<path d="M4.684 12.523v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105zm2.805-5.093c0 .238.192.425.43.425a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43zm.094 5.093h.672V8.418h-.672v4.105z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2DayFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2DayFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-2.24 4.855a.428.428 0 1 0 0-.855.426.426 0 0 0-.429.43c0 .238.192.425.43.425zm.337.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"/>');// eslint-disable-next-line
var BIconCalendar2Event=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Event','<path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2EventFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2EventFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM11.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"/>');// eslint-disable-next-line
var BIconCalendar2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Fill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM2.545 3h10.91c.3 0 .545.224.545.5v1c0 .276-.244.5-.546.5H2.545C2.245 5 2 4.776 2 4.5v-1c0-.276.244-.5.545-.5z"/>');// eslint-disable-next-line
var BIconCalendar2Minus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Minus','<path d="M5.5 10.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2MinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2MinusFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM6 10a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6z"/>');// eslint-disable-next-line
var BIconCalendar2Month=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Month','<path d="m2.56 12.332.54-1.602h1.984l.54 1.602h.718L4.444 7h-.696L1.85 12.332h.71zm1.544-4.527L4.9 10.18H3.284l.8-2.375h.02zm5.746.422h-.676v2.543c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V8.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V8.227zm2.258 5.046c-.563 0-.91-.304-.985-.636h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V8.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023zm.008-4.53c.648 0 1.062.527 1.062 1.359v.253c0 .848-.39 1.364-1.062 1.364-.692 0-1.098-.512-1.098-1.364v-.253c0-.868.406-1.36 1.098-1.36z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2MonthFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2MonthFill','<path d="M4.104 7.805 4.9 10.18H3.284l.8-2.375h.02zm9.074 2.297c0-.832-.414-1.36-1.062-1.36-.692 0-1.098.492-1.098 1.36v.253c0 .852.406 1.364 1.098 1.364.671 0 1.062-.516 1.062-1.364v-.253z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM2.561 12.332 3.1 10.73h1.984l.54 1.602h.718L4.444 7h-.696L1.85 12.332h.71zM9.85 8.227h-.676v2.543c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V8.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V8.227zm1.273 4.41h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V8.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023-.563 0-.91-.304-.985-.636z"/>');// eslint-disable-next-line
var BIconCalendar2Plus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Plus','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM8 8a.5.5 0 0 1 .5.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5A.5.5 0 0 1 8 8z"/>');// eslint-disable-next-line
var BIconCalendar2PlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2PlusFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 3.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5H2.545c-.3 0-.545.224-.545.5zm6.5 5a.5.5 0 0 0-1 0V10H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V11H10a.5.5 0 0 0 0-1H8.5V8.5z"/>');// eslint-disable-next-line
var BIconCalendar2Range=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Range','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM9 8a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1zm-8 2h4a1 1 0 1 1 0 2H1v-2z"/>');// eslint-disable-next-line
var BIconCalendar2RangeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2RangeFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM10 7a1 1 0 0 0 0 2h5V7h-5zm-4 4a1 1 0 0 0-1-1H1v2h4a1 1 0 0 0 1-1z"/>');// eslint-disable-next-line
var BIconCalendar2Week=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2Week','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>');// eslint-disable-next-line
var BIconCalendar2WeekFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2WeekFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zM8.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM3 10.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"/>');// eslint-disable-next-line
var BIconCalendar2X=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2X','<path d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z"/>');// eslint-disable-next-line
var BIconCalendar2XFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar2XFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zm9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5zm-6.6 5.146a.5.5 0 1 0-.708.708L7.293 10l-1.147 1.146a.5.5 0 0 0 .708.708L8 10.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 10l1.147-1.146a.5.5 0 0 0-.708-.708L8 9.293 6.854 8.146z"/>');// eslint-disable-next-line
var BIconCalendar3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3','<path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/><path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconCalendar3Event=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3Event','<path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/><path d="M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconCalendar3EventFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3EventFill','<path fill-rule="evenodd" d="M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 14V3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-8a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"/>');// eslint-disable-next-line
var BIconCalendar3Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3Fill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2H0zm0 1v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3H0z"/>');// eslint-disable-next-line
var BIconCalendar3Range=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3Range','<path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/><path d="M7 10a1 1 0 0 0 0-2H1v2h6zm2-3h6V5H9a1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconCalendar3RangeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3RangeFill','<path fill-rule="evenodd" d="M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 8V3h16v2h-6a1 1 0 1 0 0 2h6v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4h6a1 1 0 1 0 0-2H0z"/>');// eslint-disable-next-line
var BIconCalendar3Week=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3Week','<path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/><path d="M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-5 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconCalendar3WeekFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar3WeekFill','<path fill-rule="evenodd" d="M2 0a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H2zM0 14V3h16v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-8a1 1 0 1 0 2 0 1 1 0 0 0-2 0zM5 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm5-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM2 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"/>');// eslint-disable-next-line
var BIconCalendar4=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar4','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"/>');// eslint-disable-next-line
var BIconCalendar4Event=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar4Event','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"/><path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>');// eslint-disable-next-line
var BIconCalendar4Range=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar4Range','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"/><path d="M9 7.5a.5.5 0 0 1 .5-.5H15v2H9.5a.5.5 0 0 1-.5-.5v-1zm-2 3v1a.5.5 0 0 1-.5.5H1v-2h5.5a.5.5 0 0 1 .5.5z"/>');// eslint-disable-next-line
var BIconCalendar4Week=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Calendar4Week','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"/><path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>');// eslint-disable-next-line
var BIconCalendarCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarCheck','<path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarCheckFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconCalendarDate=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarDate','<path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarDateFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarDateFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zm5.402 9.746c.625 0 1.184-.484 1.184-1.18 0-.832-.527-1.23-1.16-1.23-.586 0-1.168.387-1.168 1.21 0 .817.543 1.2 1.144 1.2z"/><path d="M16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-6.664-1.21c-1.11 0-1.656-.767-1.703-1.407h.683c.043.37.387.82 1.051.82.844 0 1.301-.848 1.305-2.164h-.027c-.153.414-.637.79-1.383.79-.852 0-1.676-.61-1.676-1.77 0-1.137.871-1.809 1.797-1.809 1.172 0 1.953.734 1.953 2.668 0 1.805-.742 2.871-2 2.871zm-2.89-5.435v5.332H5.77V8.079h-.012c-.29.156-.883.52-1.258.777V8.16a12.6 12.6 0 0 1 1.313-.805h.632z"/>');// eslint-disable-next-line
var BIconCalendarDay=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarDay','<path d="M4.684 11.523v-2.3h2.261v-.61H4.684V6.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V8.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105zm2.805-5.093c0 .238.192.425.43.425a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43zm.094 5.093h.672V7.418h-.672v4.105z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarDayFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarDayFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16v9zm-4.785-6.145a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43c0 .238.192.425.43.425zm.336.563h-.672v4.105h.672V8.418zm-6.867 4.105v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105z"/>');// eslint-disable-next-line
var BIconCalendarEvent=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarEvent','<path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarEventFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarEventFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconCalendarFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarFill','<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconCalendarMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarMinus','<path d="M5.5 9.5A.5.5 0 0 1 6 9h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarMinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarMinusFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconCalendarMonth=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarMonth','<path d="M2.56 11.332 3.1 9.73h1.984l.54 1.602h.718L4.444 6h-.696L1.85 11.332h.71zm1.544-4.527L4.9 9.18H3.284l.8-2.375h.02zm5.746.422h-.676V9.77c0 .652-.414 1.023-1.004 1.023-.539 0-.98-.246-.98-1.012V7.227h-.676v2.746c0 .941.606 1.425 1.453 1.425.656 0 1.043-.28 1.188-.605h.027v.539h.668V7.227zm2.258 5.046c-.563 0-.91-.304-.985-.636h-.687c.094.683.625 1.199 1.668 1.199.93 0 1.746-.527 1.746-1.578V7.227h-.649v.578h-.019c-.191-.348-.637-.64-1.195-.64-.965 0-1.64.679-1.64 1.886v.34c0 1.23.683 1.902 1.64 1.902.558 0 1.008-.293 1.172-.648h.02v.605c0 .645-.423 1.023-1.071 1.023zm.008-4.53c.648 0 1.062.527 1.062 1.359v.253c0 .848-.39 1.364-1.062 1.364-.692 0-1.098-.512-1.098-1.364v-.253c0-.868.406-1.36 1.098-1.36z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarMonthFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarMonthFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zm.104 7.305L4.9 10.18H3.284l.8-2.375h.02zm9.074 2.297c0-.832-.414-1.36-1.062-1.36-.692 0-1.098.492-1.098 1.36v.253c0 .852.406 1.364 1.098 1.364.671 0 1.062-.516 1.062-1.364v-.253z"/><path d="M16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM2.56 12.332h-.71L3.748 7h.696l1.898 5.332h-.719l-.539-1.602H3.1l-.54 1.602zm7.29-4.105v4.105h-.668v-.539h-.027c-.145.324-.532.605-1.188.605-.847 0-1.453-.484-1.453-1.425V8.227h.676v2.554c0 .766.441 1.012.98 1.012.59 0 1.004-.371 1.004-1.023V8.227h.676zm1.273 4.41c.075.332.422.636.985.636.648 0 1.07-.378 1.07-1.023v-.605h-.02c-.163.355-.613.648-1.171.648-.957 0-1.64-.672-1.64-1.902v-.34c0-1.207.675-1.887 1.64-1.887.558 0 1.004.293 1.195.64h.02v-.577h.648v4.03c0 1.052-.816 1.579-1.746 1.579-1.043 0-1.574-.516-1.668-1.2h.687z"/>');// eslint-disable-next-line
var BIconCalendarPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarPlus','<path d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarPlusFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.5 8.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconCalendarRange=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarRange','<path d="M9 7a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1zM1 9h4a1 1 0 0 1 0 2H1V9z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarRangeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarRangeFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 7V5H0v5h5a1 1 0 1 1 0 2H0v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9h-6a1 1 0 1 1 0-2h6z"/>');// eslint-disable-next-line
var BIconCalendarWeek=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarWeek','<path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarWeekFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarWeekFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM9.5 7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm3 0h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zM2 10.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconCalendarX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarX','<path d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>');// eslint-disable-next-line
var BIconCalendarXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CalendarXFill','<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM6.854 8.146 8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconCamera=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Camera','<path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/><path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconCamera2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Camera2','<path d="M5 8c0-1.657 2.343-3 4-3V4a4 4 0 0 0-4 4z"/><path d="M12.318 3h2.015C15.253 3 16 3.746 16 4.667v6.666c0 .92-.746 1.667-1.667 1.667h-2.015A5.97 5.97 0 0 1 9 14a5.972 5.972 0 0 1-3.318-1H1.667C.747 13 0 12.254 0 11.333V4.667C0 3.747.746 3 1.667 3H2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1h.682A5.97 5.97 0 0 1 9 2c1.227 0 2.367.368 3.318 1zM2 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0zM14 8A5 5 0 1 0 4 8a5 5 0 0 0 10 0z"/>');// eslint-disable-next-line
var BIconCameraFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CameraFill','<path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/><path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>');// eslint-disable-next-line
var BIconCameraReels=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CameraReels','<path d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM1 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0z"/><path d="M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h7zm6 8.73V7.27l-3.5 1.555v4.35l3.5 1.556zM1 8v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z"/><path d="M9 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM7 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"/>');// eslint-disable-next-line
var BIconCameraReelsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CameraReelsFill','<path d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path d="M9 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/><path d="M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h7z"/>');// eslint-disable-next-line
var BIconCameraVideo=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CameraVideo','<path fill-rule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556v4.35zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2z"/>');// eslint-disable-next-line
var BIconCameraVideoFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CameraVideoFill','<path fill-rule="evenodd" d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"/>');// eslint-disable-next-line
var BIconCameraVideoOff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CameraVideoOff','<path fill-rule="evenodd" d="M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l.714 1H9.5a1 1 0 0 1 1 1v6a1 1 0 0 1-.144.518l.605.847zM1.428 4.18A.999.999 0 0 0 1 5v6a1 1 0 0 0 1 1h5.014l.714 1H2a2 2 0 0 1-2-2V5c0-.675.334-1.272.847-1.634l.58.814zM15 11.73l-3.5-1.555v-4.35L15 4.269v7.462zm-4.407 3.56-10-14 .814-.58 10 14-.814.58z"/>');// eslint-disable-next-line
var BIconCameraVideoOffFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CameraVideoOffFill','<path fill-rule="evenodd" d="M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l6.69 9.365zm-10.114-9A2.001 2.001 0 0 0 0 5v6a2 2 0 0 0 2 2h5.728L.847 3.366zm9.746 11.925-10-14 .814-.58 10 14-.814.58z"/>');// eslint-disable-next-line
var BIconCapslock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Capslock','<path fill-rule="evenodd" d="M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1H1.654C.78 9.5.326 8.455.924 7.816L7.27 1.047zM14.346 8.5 8 1.731 1.654 8.5H4.5a1 1 0 0 1 1 1v1h5v-1a1 1 0 0 1 1-1h2.846zm-9.846 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1zm6 0h-5v1h5v-1z"/>');// eslint-disable-next-line
var BIconCapslockFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CapslockFill','<path d="M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1H1.654C.78 9.5.326 8.455.924 7.816L7.27 1.047zM4.5 13.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1z"/>');// eslint-disable-next-line
var BIconCardChecklist=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CardChecklist','<path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/><path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconCardHeading=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CardHeading','<path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/><path d="M3 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1z"/>');// eslint-disable-next-line
var BIconCardImage=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CardImage','<path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z"/>');// eslint-disable-next-line
var BIconCardList=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CardList','<path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/><path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconCardText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CardText','<path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/><path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconCaretDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretDown','<path d="M3.204 5h9.592L8 10.481 3.204 5zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659z"/>');// eslint-disable-next-line
var BIconCaretDownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretDownFill','<path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>');// eslint-disable-next-line
var BIconCaretDownSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretDownSquare','<path d="M3.626 6.832A.5.5 0 0 1 4 6h8a.5.5 0 0 1 .374.832l-4 4.5a.5.5 0 0 1-.748 0l-4-4.5z"/><path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2z"/>');// eslint-disable-next-line
var BIconCaretDownSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretDownSquareFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 4a.5.5 0 0 0-.374.832l4 4.5a.5.5 0 0 0 .748 0l4-4.5A.5.5 0 0 0 12 6H4z"/>');// eslint-disable-next-line
var BIconCaretLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretLeft','<path d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"/>');// eslint-disable-next-line
var BIconCaretLeftFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretLeftFill','<path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>');// eslint-disable-next-line
var BIconCaretLeftSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretLeftSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M10.205 12.456A.5.5 0 0 0 10.5 12V4a.5.5 0 0 0-.832-.374l-4.5 4a.5.5 0 0 0 0 .748l4.5 4a.5.5 0 0 0 .537.082z"/>');// eslint-disable-next-line
var BIconCaretLeftSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretLeftSquareFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.5 10V4a.5.5 0 0 0-.832-.374l-4.5 4a.5.5 0 0 0 0 .748l4.5 4A.5.5 0 0 0 10.5 12z"/>');// eslint-disable-next-line
var BIconCaretRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretRight','<path d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"/>');// eslint-disable-next-line
var BIconCaretRightFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretRightFill','<path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>');// eslint-disable-next-line
var BIconCaretRightSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretRightSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M5.795 12.456A.5.5 0 0 1 5.5 12V4a.5.5 0 0 1 .832-.374l4.5 4a.5.5 0 0 1 0 .748l-4.5 4a.5.5 0 0 1-.537.082z"/>');// eslint-disable-next-line
var BIconCaretRightSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretRightSquareFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.5 10a.5.5 0 0 0 .832.374l4.5-4a.5.5 0 0 0 0-.748l-4.5-4A.5.5 0 0 0 5.5 4v8z"/>');// eslint-disable-next-line
var BIconCaretUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretUp','<path d="M3.204 11h9.592L8 5.519 3.204 11zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659z"/>');// eslint-disable-next-line
var BIconCaretUpFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretUpFill','<path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>');// eslint-disable-next-line
var BIconCaretUpSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretUpSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M3.544 10.705A.5.5 0 0 0 4 11h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5a.5.5 0 0 0-.082.537z"/>');// eslint-disable-next-line
var BIconCaretUpSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CaretUpSquareFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 9h8a.5.5 0 0 0 .374-.832l-4-4.5a.5.5 0 0 0-.748 0l-4 4.5A.5.5 0 0 0 4 11z"/>');// eslint-disable-next-line
var BIconCart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cart','<path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconCart2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cart2','<path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"/>');// eslint-disable-next-line
var BIconCart3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cart3','<path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l.84 4.479 9.144-.459L13.89 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconCart4=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cart4','<path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l.5 2H5V5H3.14zM6 5v2h2V5H6zm3 0v2h2V5H9zm3 0v2h1.36l.5-2H12zm1.11 3H12v2h.61l.5-2zM11 8H9v2h2V8zM8 8H6v2h2V8zM5 8H3.89l.5 2H5V8zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"/>');// eslint-disable-next-line
var BIconCartCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartCheck','<path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/><path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconCartCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartCheckFill','<path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconCartDash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartDash','<path d="M6.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z"/><path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconCartDashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartDashFill','<path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM6.5 7h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconCartFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartFill','<path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconCartPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartPlus','<path d="M9 5.5a.5.5 0 0 0-1 0V7H6.5a.5.5 0 0 0 0 1H8v1.5a.5.5 0 0 0 1 0V8h1.5a.5.5 0 0 0 0-1H9V5.5z"/><path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconCartPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartPlusFill','<path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9 5.5V7h1.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1 0-1H8V5.5a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconCartX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartX','<path d="M7.354 5.646a.5.5 0 1 0-.708.708L7.793 7.5 6.646 8.646a.5.5 0 1 0 .708.708L8.5 8.207l1.146 1.147a.5.5 0 0 0 .708-.708L9.207 7.5l1.147-1.146a.5.5 0 0 0-.708-.708L8.5 6.793 7.354 5.646z"/><path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zm3.915 10L3.102 4h10.796l-1.313 7h-8.17zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconCartXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CartXFill','<path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1H.5zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7.354 5.646 8.5 6.793l1.146-1.147a.5.5 0 0 1 .708.708L9.207 7.5l1.147 1.146a.5.5 0 0 1-.708.708L8.5 8.207 7.354 9.354a.5.5 0 1 1-.708-.708L7.793 7.5 6.646 6.354a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconCash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cash','<path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/><path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z"/>');// eslint-disable-next-line
var BIconCashCoin=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CashCoin','<path fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"/><path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"/><path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"/><path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"/>');// eslint-disable-next-line
var BIconCashStack=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CashStack','<path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/><path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z"/>');// eslint-disable-next-line
var BIconCast=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cast','<path d="m7.646 9.354-3.792 3.792a.5.5 0 0 0 .353.854h7.586a.5.5 0 0 0 .354-.854L8.354 9.354a.5.5 0 0 0-.708 0z"/><path d="M11.414 11H14.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h3.086l-1 1H1.5A1.5 1.5 0 0 1 0 10.5v-7A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v7a1.5 1.5 0 0 1-1.5 1.5h-2.086l-1-1z"/>');// eslint-disable-next-line
var BIconChat=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Chat','<path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"/>');// eslint-disable-next-line
var BIconChatDots=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatDots','<path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/><path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z"/>');// eslint-disable-next-line
var BIconChatDotsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatDotsFill','<path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconChatFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatFill','<path d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15z"/>');// eslint-disable-next-line
var BIconChatLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeft','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconChatLeftDots=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeftDots','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconChatLeftDotsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeftDotsFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconChatLeftFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeftFill','<path d="M2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconChatLeftQuote=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeftQuote','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"/>');// eslint-disable-next-line
var BIconChatLeftQuoteFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeftQuoteFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm7.194 2.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 4C4.776 4 4 4.746 4 5.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 7.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 4c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/>');// eslint-disable-next-line
var BIconChatLeftText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeftText','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconChatLeftTextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatLeftTextFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/>');// eslint-disable-next-line
var BIconChatQuote=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatQuote','<path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"/><path d="M7.066 6.76A1.665 1.665 0 0 0 4 7.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 0 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 7.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 0 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"/>');// eslint-disable-next-line
var BIconChatQuoteFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatQuoteFill','<path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/>');// eslint-disable-next-line
var BIconChatRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRight','<path d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"/>');// eslint-disable-next-line
var BIconChatRightDots=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRightDots','<path d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"/><path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconChatRightDotsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRightDotsFill','<path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>');// eslint-disable-next-line
var BIconChatRightFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRightFill','<path d="M14 0a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"/>');// eslint-disable-next-line
var BIconChatRightQuote=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRightQuote','<path d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"/><path d="M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"/>');// eslint-disable-next-line
var BIconChatRightQuoteFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRightQuoteFill','<path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM7.194 4.766c.087.124.163.26.227.401.428.948.393 2.377-.942 3.706a.446.446 0 0 1-.612.01.405.405 0 0 1-.011-.59c.419-.416.672-.831.809-1.22-.269.165-.588.26-.93.26C4.775 7.333 4 6.587 4 5.667 4 4.747 4.776 4 5.734 4c.271 0 .528.06.756.166l.008.004c.169.07.327.182.469.324.085.083.161.174.227.272zM11 7.073c-.269.165-.588.26-.93.26-.958 0-1.735-.746-1.735-1.666 0-.92.777-1.667 1.734-1.667.271 0 .528.06.756.166l.008.004c.17.07.327.182.469.324.085.083.161.174.227.272.087.124.164.26.228.401.428.948.392 2.377-.942 3.706a.446.446 0 0 1-.613.01.405.405 0 0 1-.011-.59c.42-.416.672-.831.81-1.22z"/>');// eslint-disable-next-line
var BIconChatRightText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRightText','<path d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"/><path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconChatRightTextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatRightTextFill','<path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353V2zM3.5 3h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 2.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconChatSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquare','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconChatSquareDots=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquareDots','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconChatSquareDotsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquareDotsFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconChatSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquareFill','<path d="M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconChatSquareQuote=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquareQuote','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"/>');// eslint-disable-next-line
var BIconChatSquareQuoteFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquareQuoteFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm7.194 2.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 4C4.776 4 4 4.746 4 5.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 7.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 4c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/>');// eslint-disable-next-line
var BIconChatSquareText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquareText','<path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconChatSquareTextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatSquareTextFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/>');// eslint-disable-next-line
var BIconChatText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatText','<path d="M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"/><path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconChatTextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChatTextFill','<path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM4.5 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm0 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z"/>');// eslint-disable-next-line
var BIconCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Check','<path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>');// eslint-disable-next-line
var BIconCheck2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Check2','<path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconCheck2All=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Check2All','<path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z"/><path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconCheck2Circle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Check2Circle','<path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"/><path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"/>');// eslint-disable-next-line
var BIconCheck2Square=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Check2Square','<path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"/><path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>');// eslint-disable-next-line
var BIconCheckAll=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CheckAll','<path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z"/>');// eslint-disable-next-line
var BIconCheckCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CheckCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>');// eslint-disable-next-line
var BIconCheckCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CheckCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>');// eslint-disable-next-line
var BIconCheckLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CheckLg','<path d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z"/>');// eslint-disable-next-line
var BIconCheckSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CheckSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"/>');// eslint-disable-next-line
var BIconCheckSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CheckSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z"/>');// eslint-disable-next-line
var BIconChevronBarContract=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronBarContract','<path fill-rule="evenodd" d="M3.646 14.854a.5.5 0 0 0 .708 0L8 11.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zm0-13.708a.5.5 0 0 1 .708 0L8 4.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zM1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8z"/>');// eslint-disable-next-line
var BIconChevronBarDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronBarDown','<path fill-rule="evenodd" d="M3.646 4.146a.5.5 0 0 1 .708 0L8 7.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zM1 11.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconChevronBarExpand=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronBarExpand','<path fill-rule="evenodd" d="M3.646 10.146a.5.5 0 0 1 .708 0L8 13.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-4.292a.5.5 0 0 0 .708 0L8 2.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zM1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8z"/>');// eslint-disable-next-line
var BIconChevronBarLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronBarLeft','<path fill-rule="evenodd" d="M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0zM4.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"/>');// eslint-disable-next-line
var BIconChevronBarRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronBarRight','<path fill-rule="evenodd" d="M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0zM11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconChevronBarUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronBarUp','<path fill-rule="evenodd" d="M3.646 11.854a.5.5 0 0 0 .708 0L8 8.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zM2.4 5.2c0 .22.18.4.4.4h10.4a.4.4 0 0 0 0-.8H2.8a.4.4 0 0 0-.4.4z"/>');// eslint-disable-next-line
var BIconChevronCompactDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronCompactDown','<path fill-rule="evenodd" d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z"/>');// eslint-disable-next-line
var BIconChevronCompactLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronCompactLeft','<path fill-rule="evenodd" d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223z"/>');// eslint-disable-next-line
var BIconChevronCompactRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronCompactRight','<path fill-rule="evenodd" d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671z"/>');// eslint-disable-next-line
var BIconChevronCompactUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronCompactUp','<path fill-rule="evenodd" d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z"/>');// eslint-disable-next-line
var BIconChevronContract=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronContract','<path fill-rule="evenodd" d="M3.646 13.854a.5.5 0 0 0 .708 0L8 10.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708zm0-11.708a.5.5 0 0 1 .708 0L8 5.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconChevronDoubleDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronDoubleDown','<path fill-rule="evenodd" d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/><path fill-rule="evenodd" d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconChevronDoubleLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronDoubleLeft','<path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/><path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconChevronDoubleRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronDoubleRight','<path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/><path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconChevronDoubleUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronDoubleUp','<path fill-rule="evenodd" d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708l6-6z"/><path fill-rule="evenodd" d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>');// eslint-disable-next-line
var BIconChevronDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronDown','<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconChevronExpand=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronExpand','<path fill-rule="evenodd" d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"/>');// eslint-disable-next-line
var BIconChevronLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronLeft','<path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconChevronRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronRight','<path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconChevronUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ChevronUp','<path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>');// eslint-disable-next-line
var BIconCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Circle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>');// eslint-disable-next-line
var BIconCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CircleFill','<circle cx="8" cy="8" r="8"/>');// eslint-disable-next-line
var BIconCircleHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CircleHalf','<path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"/>');// eslint-disable-next-line
var BIconCircleSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CircleSquare','<path d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6z"/><path d="M12.93 5h1.57a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1.57a6.953 6.953 0 0 1-1-.22v1.79A1.5 1.5 0 0 0 5.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 4h-1.79c.097.324.17.658.22 1z"/>');// eslint-disable-next-line
var BIconClipboard=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Clipboard','<path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>');// eslint-disable-next-line
var BIconClipboardCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ClipboardCheck','<path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>');// eslint-disable-next-line
var BIconClipboardData=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ClipboardData','<path d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"/><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>');// eslint-disable-next-line
var BIconClipboardMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ClipboardMinus','<path fill-rule="evenodd" d="M5.5 9.5A.5.5 0 0 1 6 9h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>');// eslint-disable-next-line
var BIconClipboardPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ClipboardPlus','<path fill-rule="evenodd" d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"/><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>');// eslint-disable-next-line
var BIconClipboardX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ClipboardX','<path fill-rule="evenodd" d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"/><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>');// eslint-disable-next-line
var BIconClock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Clock','<path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>');// eslint-disable-next-line
var BIconClockFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ClockFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>');// eslint-disable-next-line
var BIconClockHistory=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ClockHistory','<path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/><path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/><path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconCloud=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cloud','<path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>');// eslint-disable-next-line
var BIconCloudArrowDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudArrowDown','<path fill-rule="evenodd" d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"/><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>');// eslint-disable-next-line
var BIconCloudArrowDownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudArrowDownFill','<path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconCloudArrowUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudArrowUp','<path fill-rule="evenodd" d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"/><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>');// eslint-disable-next-line
var BIconCloudArrowUpFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudArrowUpFill','<path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2z"/>');// eslint-disable-next-line
var BIconCloudCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudCheck','<path fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>');// eslint-disable-next-line
var BIconCloudCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudCheckFill','<path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 4.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconCloudDownload=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudDownload','<path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/><path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>');// eslint-disable-next-line
var BIconCloudDownloadFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudDownloadFill','<path fill-rule="evenodd" d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z"/>');// eslint-disable-next-line
var BIconCloudDrizzle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudDrizzle','<path d="M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm-3.5 1.5a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm.747-8.498a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973zM8.5 2a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 2z"/>');// eslint-disable-next-line
var BIconCloudDrizzleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudDrizzleFill','<path d="M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm-3.5 1.5a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm6 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm.747-8.498a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudFill','<path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>');// eslint-disable-next-line
var BIconCloudFog=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudFog','<path d="M3 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm10.405-9.473a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 12H13a3 3 0 0 0 .405-5.973zM8.5 3a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 3z"/>');// eslint-disable-next-line
var BIconCloudFog2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudFog2','<path d="M8.5 4a4.002 4.002 0 0 0-3.8 2.745.5.5 0 1 1-.949-.313 5.002 5.002 0 0 1 9.654.595A3 3 0 0 1 13 13H.5a.5.5 0 0 1 0-1H13a2 2 0 0 0 .001-4h-.026a.5.5 0 0 1-.5-.445A4 4 0 0 0 8.5 4zM0 8.5A.5.5 0 0 1 .5 8h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconCloudFog2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudFog2Fill','<path d="M8.5 3a5.001 5.001 0 0 1 4.905 4.027A3 3 0 0 1 13 13h-1.5a.5.5 0 0 0 0-1H1.05a3.51 3.51 0 0 1-.713-1H9.5a.5.5 0 0 0 0-1H.035a3.53 3.53 0 0 1 0-1H7.5a.5.5 0 0 0 0-1H.337a3.5 3.5 0 0 1 3.57-1.977A5.001 5.001 0 0 1 8.5 3z"/>');// eslint-disable-next-line
var BIconCloudFogFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudFogFill','<path d="M3 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm10.405-9.473a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 12H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudHail=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudHail','<path d="M13.405 4.527a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.5H13a3 3 0 0 0 .405-5.973zM8.5 1.5a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1-.001 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1.5zM3.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zM7.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm3.592 3.724a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316z"/>');// eslint-disable-next-line
var BIconCloudHailFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudHailFill','<path d="M3.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zM7.75 15.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm3.592 3.724a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm.408-3.724a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm1.247-6.999a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.5H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudHaze=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudHaze','<path d="M8.5 3a4.002 4.002 0 0 0-3.8 2.745.5.5 0 1 1-.949-.313 5.002 5.002 0 0 1 9.654.595A3 3 0 0 1 13 12H4.5a.5.5 0 0 1 0-1H13a2 2 0 0 0 .001-4h-.026a.5.5 0 0 1-.5-.445A4 4 0 0 0 8.5 3zM0 7.5A.5.5 0 0 1 .5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-2 4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconCloudHaze1=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudHaze1','<path d="M4 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm2 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1z"/>');// eslint-disable-next-line
var BIconCloudHaze2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudHaze2Fill','<path d="M8.5 2a5.001 5.001 0 0 1 4.905 4.027A3 3 0 0 1 13 12H3.5A3.5 3.5 0 0 1 .035 9H5.5a.5.5 0 0 0 0-1H.035a3.5 3.5 0 0 1 3.871-2.977A5.001 5.001 0 0 1 8.5 2zm-6 8a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zM0 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconCloudHazeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudHazeFill','<path d="M4 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm2 2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudLightning=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudLightning','<path d="M13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1zM7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2z"/>');// eslint-disable-next-line
var BIconCloudLightningFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudLightningFill','<path d="M7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2zm6.352-7.249a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudLightningRain=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudLightningRain','<path d="M2.658 11.026a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.5 1.5a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-.753-8.499a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1zM7.053 11.276A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2z"/>');// eslint-disable-next-line
var BIconCloudLightningRainFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudLightningRainFill','<path d="M2.658 11.026a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.5 1.5a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm9.5 0a.5.5 0 0 1 .316.632l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.316zm-7.105-1.25A.5.5 0 0 1 7.5 11h1a.5.5 0 0 1 .474.658l-.28.842H9.5a.5.5 0 0 1 .39.812l-2 2.5a.5.5 0 0 1-.875-.433L7.36 14H6.5a.5.5 0 0 1-.447-.724l1-2zm6.352-7.249a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudMinus','<path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>');// eslint-disable-next-line
var BIconCloudMinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudMinusFill','<path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconCloudMoon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudMoon','<path d="M7 8a3.5 3.5 0 0 1 3.5 3.555.5.5 0 0 0 .625.492A1.503 1.503 0 0 1 13 13.5a1.5 1.5 0 0 1-1.5 1.5H3a2 2 0 1 1 .1-3.998.5.5 0 0 0 .509-.375A3.502 3.502 0 0 1 7 8zm4.473 3a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"/><path d="M11.286 1.778a.5.5 0 0 0-.565-.755 4.595 4.595 0 0 0-3.18 5.003 5.46 5.46 0 0 1 1.055.209A3.603 3.603 0 0 1 9.83 2.617a4.593 4.593 0 0 0 4.31 5.744 3.576 3.576 0 0 1-2.241.634c.162.317.295.652.394 1a4.59 4.59 0 0 0 3.624-2.04.5.5 0 0 0-.565-.755 3.593 3.593 0 0 1-4.065-5.422z"/>');// eslint-disable-next-line
var BIconCloudMoonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudMoonFill','<path d="M11.473 11a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"/><path d="M11.286 1.778a.5.5 0 0 0-.565-.755 4.595 4.595 0 0 0-3.18 5.003 5.46 5.46 0 0 1 1.055.209A3.603 3.603 0 0 1 9.83 2.617a4.593 4.593 0 0 0 4.31 5.744 3.576 3.576 0 0 1-2.241.634c.162.317.295.652.394 1a4.59 4.59 0 0 0 3.624-2.04.5.5 0 0 0-.565-.755 3.593 3.593 0 0 1-4.065-5.422z"/>');// eslint-disable-next-line
var BIconCloudPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudPlus','<path fill-rule="evenodd" d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"/><path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>');// eslint-disable-next-line
var BIconCloudPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudPlusFill','<path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm.5 4v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconCloudRain=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudRain','<path d="M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 0 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 0 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm.247-6.998a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973zM8.5 2a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 2z"/>');// eslint-disable-next-line
var BIconCloudRainFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudRainFill','<path d="M4.158 12.025a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-.5 1.5a.5.5 0 1 1-.948-.316l.5-1.5a.5.5 0 0 1 .632-.317zm3 0a.5.5 0 0 1 .316.633l-1 3a.5.5 0 1 1-.948-.316l1-3a.5.5 0 0 1 .632-.317zm.247-6.998a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 11H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudRainHeavy=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudRainHeavy','<path d="M4.176 11.032a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 1 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 1 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 1 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm.229-7.005a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1z"/>');// eslint-disable-next-line
var BIconCloudRainHeavyFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudRainHeavyFill','<path d="M4.176 11.032a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm3 0a.5.5 0 0 1 .292.643l-1.5 4a.5.5 0 0 1-.936-.35l1.5-4a.5.5 0 0 1 .644-.293zm.229-7.005a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudSlash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSlash','<path fill-rule="evenodd" d="M3.112 5.112a3.125 3.125 0 0 0-.17.613C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13H11l-1-1H3.781C2.231 12 1 10.785 1 9.318c0-1.365 1.064-2.513 2.46-2.666l.446-.05v-.447c0-.075.006-.152.018-.231l-.812-.812zm2.55-1.45-.725-.725A5.512 5.512 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773a3.2 3.2 0 0 1-1.516 2.711l-.733-.733C14.498 11.378 15 10.626 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3c-.875 0-1.678.26-2.339.661z"/><path d="m13.646 14.354-12-12 .708-.708 12 12-.707.707z"/>');// eslint-disable-next-line
var BIconCloudSlashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSlashFill','<path fill-rule="evenodd" d="M3.112 5.112a3.125 3.125 0 0 0-.17.613C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13H11L3.112 5.112zm11.372 7.372L4.937 2.937A5.512 5.512 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773a3.2 3.2 0 0 1-1.516 2.711zm-.838 1.87-12-12 .708-.708 12 12-.707.707z"/>');// eslint-disable-next-line
var BIconCloudSleet=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSleet','<path d="M13.405 4.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973zM8.5 1a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1 0 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1zM2.375 13.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zM6.375 13.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm2.151 2.447a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223z"/>');// eslint-disable-next-line
var BIconCloudSleetFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSleetFill','<path d="M2.375 13.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 0 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zM6.375 13.5a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 0 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm2.151 2.447a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 1 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 1 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm1.849-2.447a.5.5 0 0 1 .223.67l-.5 1a.5.5 0 1 1-.894-.447l.5-1a.5.5 0 0 1 .67-.223zm1.181-7.026a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudSnow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSnow','<path d="M13.405 4.277a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.25H13a3 3 0 0 0 .405-5.973zM8.5 1.25a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1-.001 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 1.25zM2.625 11.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm2.75 2a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-2.75-2a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25z"/>');// eslint-disable-next-line
var BIconCloudSnowFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSnowFill','<path d="M2.625 11.5a.25.25 0 0 1 .25.25v.57l.501-.287a.25.25 0 0 1 .248.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm2.75 2a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-2.75-2a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 1 1-.5 0v-.57l-.501.287a.25.25 0 0 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm5.5 0a.25.25 0 0 1 .25.25v.57l.5-.287a.25.25 0 0 1 .249.434l-.495.283.495.283a.25.25 0 0 1-.248.434l-.501-.286v.569a.25.25 0 0 1-.5 0v-.57l-.501.287a.25.25 0 1 1-.248-.434l.495-.283-.495-.283a.25.25 0 0 1 .248-.434l.501.286v-.569a.25.25 0 0 1 .25-.25zm-.22-7.223a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 10.25H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCloudSun=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSun','<path d="M7 8a3.5 3.5 0 0 1 3.5 3.555.5.5 0 0 0 .624.492A1.503 1.503 0 0 1 13 13.5a1.5 1.5 0 0 1-1.5 1.5H3a2 2 0 1 1 .1-3.998.5.5 0 0 0 .51-.375A3.502 3.502 0 0 1 7 8zm4.473 3a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"/><path d="M10.5 1.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1zm3.743 1.964a.5.5 0 1 0-.707-.707l-.708.707a.5.5 0 0 0 .708.708l.707-.708zm-7.779-.707a.5.5 0 0 0-.707.707l.707.708a.5.5 0 1 0 .708-.708l-.708-.707zm1.734 3.374a2 2 0 1 1 3.296 2.198c.199.281.372.582.516.898a3 3 0 1 0-4.84-3.225c.352.011.696.055 1.028.129zm4.484 4.074c.6.215 1.125.59 1.522 1.072a.5.5 0 0 0 .039-.742l-.707-.707a.5.5 0 0 0-.854.377zM14.5 6.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>');// eslint-disable-next-line
var BIconCloudSunFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudSunFill','<path d="M11.473 11a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 16h8.5a2.5 2.5 0 0 0 0-5h-.027z"/><path d="M10.5 1.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1zm3.743 1.964a.5.5 0 1 0-.707-.707l-.708.707a.5.5 0 0 0 .708.708l.707-.708zm-7.779-.707a.5.5 0 0 0-.707.707l.707.708a.5.5 0 1 0 .708-.708l-.708-.707zm1.734 3.374a2 2 0 1 1 3.296 2.198c.199.281.372.582.516.898a3 3 0 1 0-4.84-3.225c.352.011.696.055 1.028.129zm4.484 4.074c.6.215 1.125.59 1.522 1.072a.5.5 0 0 0 .039-.742l-.707-.707a.5.5 0 0 0-.854.377zM14.5 6.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>');// eslint-disable-next-line
var BIconCloudUpload=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudUpload','<path fill-rule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/><path fill-rule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>');// eslint-disable-next-line
var BIconCloudUploadFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudUploadFill','<path fill-rule="evenodd" d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0zm-.5 14.5V11h1v3.5a.5.5 0 0 1-1 0z"/>');// eslint-disable-next-line
var BIconClouds=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Clouds','<path d="M16 7.5a2.5 2.5 0 0 1-1.456 2.272 3.513 3.513 0 0 0-.65-.824 1.5 1.5 0 0 0-.789-2.896.5.5 0 0 1-.627-.421 3 3 0 0 0-5.22-1.625 5.587 5.587 0 0 0-1.276.088 4.002 4.002 0 0 1 7.392.91A2.5 2.5 0 0 1 16 7.5z"/><path d="M7 5a4.5 4.5 0 0 1 4.473 4h.027a2.5 2.5 0 0 1 0 5H3a3 3 0 0 1-.247-5.99A4.502 4.502 0 0 1 7 5zm3.5 4.5a3.5 3.5 0 0 0-6.89-.873.5.5 0 0 1-.51.375A2 2 0 1 0 3 13h8.5a1.5 1.5 0 1 0-.376-2.953.5.5 0 0 1-.624-.492V9.5z"/>');// eslint-disable-next-line
var BIconCloudsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudsFill','<path d="M11.473 9a4.5 4.5 0 0 0-8.72-.99A3 3 0 0 0 3 14h8.5a2.5 2.5 0 1 0-.027-5z"/><path d="M14.544 9.772a3.506 3.506 0 0 0-2.225-1.676 5.502 5.502 0 0 0-6.337-4.002 4.002 4.002 0 0 1 7.392.91 2.5 2.5 0 0 1 1.17 4.769z"/>');// eslint-disable-next-line
var BIconCloudy=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cloudy','<path d="M13.405 8.527a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 14.5H13a3 3 0 0 0 .405-5.973zM8.5 5.5a4 4 0 0 1 3.976 3.555.5.5 0 0 0 .5.445H13a2 2 0 0 1-.001 4H3.5a2.5 2.5 0 1 1 .605-4.926.5.5 0 0 0 .596-.329A4.002 4.002 0 0 1 8.5 5.5z"/>');// eslint-disable-next-line
var BIconCloudyFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CloudyFill','<path d="M13.405 7.027a5.001 5.001 0 0 0-9.499-1.004A3.5 3.5 0 1 0 3.5 13H13a3 3 0 0 0 .405-5.973z"/>');// eslint-disable-next-line
var BIconCode=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Code','<path d="M5.854 4.854a.5.5 0 1 0-.708-.708l-3.5 3.5a.5.5 0 0 0 0 .708l3.5 3.5a.5.5 0 0 0 .708-.708L2.707 8l3.147-3.146zm4.292 0a.5.5 0 0 1 .708-.708l3.5 3.5a.5.5 0 0 1 0 .708l-3.5 3.5a.5.5 0 0 1-.708-.708L13.293 8l-3.147-3.146z"/>');// eslint-disable-next-line
var BIconCodeSlash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CodeSlash','<path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z"/>');// eslint-disable-next-line
var BIconCodeSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CodeSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M6.854 4.646a.5.5 0 0 1 0 .708L4.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0zm2.292 0a.5.5 0 0 0 0 .708L11.793 8l-2.647 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708 0z"/>');// eslint-disable-next-line
var BIconCoin=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Coin','<path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z"/><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path fill-rule="evenodd" d="M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/>');// eslint-disable-next-line
var BIconCollection=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Collection','<path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z"/>');// eslint-disable-next-line
var BIconCollectionFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CollectionFill','<path d="M0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zM2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3zm2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1z"/>');// eslint-disable-next-line
var BIconCollectionPlay=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CollectionPlay','<path d="M2 3a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11A.5.5 0 0 0 2 3zm2-2a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7A.5.5 0 0 0 4 1zm2.765 5.576A.5.5 0 0 0 6 7v5a.5.5 0 0 0 .765.424l4-2.5a.5.5 0 0 0 0-.848l-4-2.5z"/><path d="M1.5 14.5A1.5 1.5 0 0 1 0 13V6a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 16 6v7a1.5 1.5 0 0 1-1.5 1.5h-13zm13-1a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-13A.5.5 0 0 0 1 6v7a.5.5 0 0 0 .5.5h13z"/>');// eslint-disable-next-line
var BIconCollectionPlayFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CollectionPlayFill','<path d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm6.258-6.437a.5.5 0 0 1 .507.013l4 2.5a.5.5 0 0 1 0 .848l-4 2.5A.5.5 0 0 1 6 12V7a.5.5 0 0 1 .258-.437z"/>');// eslint-disable-next-line
var BIconColumns=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Columns','<path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2zm8.5 0v8H15V2H8.5zm0 9v3H15v-3H8.5zm-1-9H1v3h6.5V2zM1 14h6.5V6H1v8z"/>');// eslint-disable-next-line
var BIconColumnsGap=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ColumnsGap','<path d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"/>');// eslint-disable-next-line
var BIconCommand=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Command','<path d="M3.5 2A1.5 1.5 0 0 1 5 3.5V5H3.5a1.5 1.5 0 1 1 0-3zM6 5V3.5A2.5 2.5 0 1 0 3.5 6H5v4H3.5A2.5 2.5 0 1 0 6 12.5V11h4v1.5a2.5 2.5 0 1 0 2.5-2.5H11V6h1.5A2.5 2.5 0 1 0 10 3.5V5H6zm4 1v4H6V6h4zm1-1V3.5A1.5 1.5 0 1 1 12.5 5H11zm0 6h1.5a1.5 1.5 0 1 1-1.5 1.5V11zm-6 0v1.5A1.5 1.5 0 1 1 3.5 11H5z"/>');// eslint-disable-next-line
var BIconCompass=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Compass','<path d="M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016zm6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="m6.94 7.44 4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z"/>');// eslint-disable-next-line
var BIconCompassFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CompassFill','<path d="M15.5 8.516a7.5 7.5 0 1 1-9.462-7.24A1 1 0 0 1 7 0h2a1 1 0 0 1 .962 1.276 7.503 7.503 0 0 1 5.538 7.24zm-3.61-3.905L6.94 7.439 4.11 12.39l4.95-2.828 2.828-4.95z"/>');// eslint-disable-next-line
var BIconCone=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cone','<path d="M7.03 1.88c.252-1.01 1.688-1.01 1.94 0l2.905 11.62H14a.5.5 0 0 1 0 1H2a.5.5 0 0 1 0-1h2.125L7.03 1.88z"/>');// eslint-disable-next-line
var BIconConeStriped=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ConeStriped','<path d="m9.97 4.88.953 3.811C10.159 8.878 9.14 9 8 9c-1.14 0-2.158-.122-2.923-.309L6.03 4.88C6.635 4.957 7.3 5 8 5s1.365-.043 1.97-.12zm-.245-.978L8.97.88C8.718-.13 7.282-.13 7.03.88L6.275 3.9C6.8 3.965 7.382 4 8 4c.618 0 1.2-.036 1.725-.098zm4.396 8.613a.5.5 0 0 1 .037.96l-6 2a.5.5 0 0 1-.316 0l-6-2a.5.5 0 0 1 .037-.96l2.391-.598.565-2.257c.862.212 1.964.339 3.165.339s2.303-.127 3.165-.339l.565 2.257 2.391.598z"/>');// eslint-disable-next-line
var BIconController=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Controller','<path d="M11.5 6.027a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm-6.5-3h1v1h1v1h-1v1h-1v-1h-1v-1h1v-1z"/><path d="M3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .62.39c.655-.079 1.35-.117 2.043-.117.72 0 1.443.041 2.12.126a.5.5 0 0 1 .622-.399l1.932.518a.5.5 0 0 1 .306.729c.14.09.266.19.373.297.408.408.78 1.05 1.095 1.772.32.733.599 1.591.805 2.466.206.875.34 1.78.364 2.606.024.816-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773-.245-.232-.496-.526-.739-.808-.126-.148-.25-.292-.368-.423-.728-.804-1.597-1.527-3.224-1.527-1.627 0-2.496.723-3.224 1.527-.119.131-.242.275-.368.423-.243.282-.494.575-.739.808-.398.38-.877.706-1.513.773a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772a2.34 2.34 0 0 1 .433-.335.504.504 0 0 1-.028-.079zm2.036.412c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a13.748 13.748 0 0 0-.748 2.295 12.351 12.351 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.504C4.861 9.969 5.978 9.027 8 9.027s3.139.942 3.965 1.855c.164.181.307.348.44.504.214.251.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.354 12.354 0 0 0-.339-2.406 13.753 13.753 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27-1.036 0-2.063.091-2.913.27z"/>');// eslint-disable-next-line
var BIconCpu=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cpu','<path d="M5 0a.5.5 0 0 1 .5.5V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2h1V.5a.5.5 0 0 1 1 0V2A2.5 2.5 0 0 1 14 4.5h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14v1h1.5a.5.5 0 0 1 0 1H14a2.5 2.5 0 0 1-2.5 2.5v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14h-1v1.5a.5.5 0 0 1-1 0V14A2.5 2.5 0 0 1 2 11.5H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2v-1H.5a.5.5 0 0 1 0-1H2A2.5 2.5 0 0 1 4.5 2V.5A.5.5 0 0 1 5 0zm-.5 3A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7zM5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3zM6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/>');// eslint-disable-next-line
var BIconCpuFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CpuFill','<path d="M6.5 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/><path d="M5.5.5a.5.5 0 0 0-1 0V2A2.5 2.5 0 0 0 2 4.5H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2v1H.5a.5.5 0 0 0 0 1H2A2.5 2.5 0 0 0 4.5 14v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14h1v1.5a.5.5 0 0 0 1 0V14a2.5 2.5 0 0 0 2.5-2.5h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14v-1h1.5a.5.5 0 0 0 0-1H14A2.5 2.5 0 0 0 11.5 2V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5a.5.5 0 0 0-1 0V2h-1V.5zm1 4.5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3A1.5 1.5 0 0 1 6.5 5z"/>');// eslint-disable-next-line
var BIconCreditCard=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CreditCard','<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/><path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>');// eslint-disable-next-line
var BIconCreditCard2Back=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CreditCard2Back','<path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1z"/><path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1z"/>');// eslint-disable-next-line
var BIconCreditCard2BackFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CreditCard2BackFill','<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5H0V4zm11.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zM0 11v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1H0z"/>');// eslint-disable-next-line
var BIconCreditCard2Front=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CreditCard2Front','<path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconCreditCard2FrontFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CreditCard2FrontFill','<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>');// eslint-disable-next-line
var BIconCreditCardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CreditCardFill','<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0V4zm0 3v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7H0zm3 2h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconCrop=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Crop','<path d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5zm2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconCup=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cup','<path d="M1 2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1h.5A1.5 1.5 0 0 1 16 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-.55a2.5 2.5 0 0 1-2.45 2h-8A2.5 2.5 0 0 1 1 12.5V2zm13 10h.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5H14v8zM13 2H2v10.5A1.5 1.5 0 0 0 3.5 14h8a1.5 1.5 0 0 0 1.5-1.5V2z"/>');// eslint-disable-next-line
var BIconCupFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CupFill','<path d="M1 2a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1h.5A1.5 1.5 0 0 1 16 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-.55a2.5 2.5 0 0 1-2.45 2h-8A2.5 2.5 0 0 1 1 12.5V2zm13 10h.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5H14v8z"/>');// eslint-disable-next-line
var BIconCupStraw=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CupStraw','<path d="M13.902.334a.5.5 0 0 1-.28.65l-2.254.902-.4 1.927c.376.095.715.215.972.367.228.135.56.396.56.82 0 .046-.004.09-.011.132l-.962 9.068a1.28 1.28 0 0 1-.524.93c-.488.34-1.494.87-3.01.87-1.516 0-2.522-.53-3.01-.87a1.28 1.28 0 0 1-.524-.93L3.51 5.132A.78.78 0 0 1 3.5 5c0-.424.332-.685.56-.82.262-.154.607-.276.99-.372C5.824 3.614 6.867 3.5 8 3.5c.712 0 1.389.045 1.985.127l.464-2.215a.5.5 0 0 1 .303-.356l2.5-1a.5.5 0 0 1 .65.278zM9.768 4.607A13.991 13.991 0 0 0 8 4.5c-1.076 0-2.033.11-2.707.278A3.284 3.284 0 0 0 4.645 5c.146.073.362.15.648.222C5.967 5.39 6.924 5.5 8 5.5c.571 0 1.109-.03 1.588-.085l.18-.808zm.292 1.756C9.445 6.45 8.742 6.5 8 6.5c-1.133 0-2.176-.114-2.95-.308a5.514 5.514 0 0 1-.435-.127l.838 8.03c.013.121.06.186.102.215.357.249 1.168.69 2.438.69 1.27 0 2.081-.441 2.438-.69.042-.029.09-.094.102-.215l.852-8.03a5.517 5.517 0 0 1-.435.127 8.88 8.88 0 0 1-.89.17zM4.467 4.884s.003.002.005.006l-.005-.006zm7.066 0-.005.006c.002-.004.005-.006.005-.006zM11.354 5a3.174 3.174 0 0 0-.604-.21l-.099.445.055-.013c.286-.072.502-.149.648-.222z"/>');// eslint-disable-next-line
var BIconCurrencyBitcoin=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CurrencyBitcoin','<path d="M5.5 13v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.5v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V13h.084c1.992 0 3.416-1.033 3.416-2.82 0-1.502-1.007-2.323-2.186-2.44v-.088c.97-.242 1.683-.974 1.683-2.19C11.997 3.93 10.847 3 9.092 3H9V1.75a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25V3h-.573V1.75a.25.25 0 0 0-.25-.25H5.75a.25.25 0 0 0-.25.25V3l-1.998.011a.25.25 0 0 0-.25.25v.989c0 .137.11.25.248.25l.755-.005a.75.75 0 0 1 .745.75v5.505a.75.75 0 0 1-.75.75l-.748.011a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25L5.5 13zm1.427-8.513h1.719c.906 0 1.438.498 1.438 1.312 0 .871-.575 1.362-1.877 1.362h-1.28V4.487zm0 4.051h1.84c1.137 0 1.756.58 1.756 1.524 0 .953-.626 1.45-2.158 1.45H6.927V8.539z"/>');// eslint-disable-next-line
var BIconCurrencyDollar=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CurrencyDollar','<path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/>');// eslint-disable-next-line
var BIconCurrencyEuro=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CurrencyEuro','<path d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936c0-.11 0-.219.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.617 6.617 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"/>');// eslint-disable-next-line
var BIconCurrencyExchange=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CurrencyExchange','<path d="M0 5a5.002 5.002 0 0 0 4.027 4.905 6.46 6.46 0 0 1 .544-2.073C3.695 7.536 3.132 6.864 3 5.91h-.5v-.426h.466V5.05c0-.046 0-.093.004-.135H2.5v-.427h.511C3.236 3.24 4.213 2.5 5.681 2.5c.316 0 .59.031.819.085v.733a3.46 3.46 0 0 0-.815-.082c-.919 0-1.538.466-1.734 1.252h1.917v.427h-1.98c-.003.046-.003.097-.003.147v.422h1.983v.427H3.93c.118.602.468 1.03 1.005 1.229a6.5 6.5 0 0 1 4.97-3.113A5.002 5.002 0 0 0 0 5zm16 5.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0zm-7.75 1.322c.069.835.746 1.485 1.964 1.562V14h.54v-.62c1.259-.086 1.996-.74 1.996-1.69 0-.865-.563-1.31-1.57-1.54l-.426-.1V8.374c.54.06.884.347.966.745h.948c-.07-.804-.779-1.433-1.914-1.502V7h-.54v.629c-1.076.103-1.808.732-1.808 1.622 0 .787.544 1.288 1.45 1.493l.358.085v1.78c-.554-.08-.92-.376-1.003-.787H8.25zm1.96-1.895c-.532-.12-.82-.364-.82-.732 0-.41.311-.719.824-.809v1.54h-.005zm.622 1.044c.645.145.943.38.943.796 0 .474-.37.8-1.02.86v-1.674l.077.018z"/>');// eslint-disable-next-line
var BIconCurrencyPound=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CurrencyPound','<path d="M4 8.585h1.969c.115.465.186.939.186 1.43 0 1.385-.736 2.496-2.075 2.771V14H12v-1.24H6.492v-.129c.825-.525 1.135-1.446 1.135-2.694 0-.465-.07-.913-.168-1.352h3.29v-.972H7.22c-.186-.723-.372-1.455-.372-2.247 0-1.274 1.047-2.066 2.58-2.066a5.32 5.32 0 0 1 2.103.465V2.456A5.629 5.629 0 0 0 9.348 2C6.865 2 5.322 3.291 5.322 5.366c0 .775.195 1.515.399 2.247H4v.972z"/>');// eslint-disable-next-line
var BIconCurrencyYen=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CurrencyYen','<path d="M8.75 14v-2.629h2.446v-.967H8.75v-1.31h2.445v-.967H9.128L12.5 2h-1.699L8.047 7.327h-.086L5.207 2H3.5l3.363 6.127H4.778v.968H7.25v1.31H4.78v.966h2.47V14h1.502z"/>');// eslint-disable-next-line
var BIconCursor=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Cursor','<path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103zM2.25 8.184l3.897 1.67a.5.5 0 0 1 .262.263l1.67 3.897L12.743 3.52 2.25 8.184z"/>');// eslint-disable-next-line
var BIconCursorFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CursorFill','<path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103z"/>');// eslint-disable-next-line
var BIconCursorText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('CursorText','<path d="M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.165 4.165 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.49 3.49 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.165 4.165 0 0 1-2.06-.566A4.561 4.561 0 0 1 8 13.65a4.561 4.561 0 0 1-.44.285 4.165 4.165 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.49 3.49 0 0 0-.436-.294A3.166 3.166 0 0 0 5.5 2.5.5.5 0 0 1 5 2zm3.352 1.355zm-.704 9.29z"/>');// eslint-disable-next-line
var BIconDash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dash','<path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>');// eslint-disable-next-line
var BIconDashCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DashCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>');// eslint-disable-next-line
var BIconDashCircleDotted=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DashCircleDotted','<path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"/>');// eslint-disable-next-line
var BIconDashCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DashCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"/>');// eslint-disable-next-line
var BIconDashLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DashLg','<path d="M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z"/>');// eslint-disable-next-line
var BIconDashSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DashSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>');// eslint-disable-next-line
var BIconDashSquareDotted=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DashSquareDotted','<path d="M2.5 0c-.166 0-.33.016-.487.048l.194.98A1.51 1.51 0 0 1 2.5 1h.458V0H2.5zm2.292 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zm1.833 0h-.916v1h.916V0zm1.834 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zM13.5 0h-.458v1h.458c.1 0 .199.01.293.029l.194-.981A2.51 2.51 0 0 0 13.5 0zm2.079 1.11a2.511 2.511 0 0 0-.69-.689l-.556.831c.164.11.305.251.415.415l.83-.556zM1.11.421a2.511 2.511 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415L1.11.422zM16 2.5c0-.166-.016-.33-.048-.487l-.98.194c.018.094.028.192.028.293v.458h1V2.5zM.048 2.013A2.51 2.51 0 0 0 0 2.5v.458h1V2.5c0-.1.01-.199.029-.293l-.981-.194zM0 3.875v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 5.708v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 7.542v.916h1v-.916H0zm15 .916h1v-.916h-1v.916zM0 9.375v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .916v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .917v.458c0 .166.016.33.048.487l.98-.194A1.51 1.51 0 0 1 1 13.5v-.458H0zm16 .458v-.458h-1v.458c0 .1-.01.199-.029.293l.981.194c.032-.158.048-.32.048-.487zM.421 14.89c.183.272.417.506.69.689l.556-.831a1.51 1.51 0 0 1-.415-.415l-.83.556zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373c.158.032.32.048.487.048h.458v-1H2.5c-.1 0-.199-.01-.293-.029l-.194.981zM13.5 16c.166 0 .33-.016.487-.048l-.194-.98A1.51 1.51 0 0 1 13.5 15h-.458v1h.458zm-9.625 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zm1.834 0h.916v-1h-.916v1zm1.833 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z"/>');// eslint-disable-next-line
var BIconDashSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DashSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconDiagram2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Diagram2','<path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5v-1zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zM3 11.5A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"/>');// eslint-disable-next-line
var BIconDiagram2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Diagram2Fill','<path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 5 7h2.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-3 8A1.5 1.5 0 0 1 4.5 10h1A1.5 1.5 0 0 1 7 11.5v1A1.5 1.5 0 0 1 5.5 14h-1A1.5 1.5 0 0 1 3 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1A1.5 1.5 0 0 1 9 12.5v-1z"/>');// eslint-disable-next-line
var BIconDiagram3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Diagram3','<path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zM0 11.5A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"/>');// eslint-disable-next-line
var BIconDiagram3Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Diagram3Fill','<path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"/>');// eslint-disable-next-line
var BIconDiamond=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Diamond','<path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"/>');// eslint-disable-next-line
var BIconDiamondFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DiamondFill','<path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435z"/>');// eslint-disable-next-line
var BIconDiamondHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DiamondHalf','<path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM8 .989c.127 0 .253.049.35.145l6.516 6.516a.495.495 0 0 1 0 .7L8.35 14.866a.493.493 0 0 1-.35.145V.989z"/>');// eslint-disable-next-line
var BIconDice1=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice1','<circle cx="8" cy="8" r="1.5"/><path d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"/>');// eslint-disable-next-line
var BIconDice1Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice1Fill','<path d="M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm5 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconDice2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice2','<path d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"/><path d="M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconDice2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice2Fill','<path d="M0 3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3zm5.5 1a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm6.5 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>');// eslint-disable-next-line
var BIconDice3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice3','<path d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"/><path d="M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-4-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconDice3Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice3Fill','<path d="M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm2.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconDice4=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice4','<path d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"/><path d="M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconDice4Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice4Fill','<path d="M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm1 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM4 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconDice5=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice5','<path d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"/><path d="M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm4-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconDice5Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice5Fill','<path d="M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm2.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconDice6=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice6','<path d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3z"/><path d="M5.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-8 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconDice6Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dice6Fill','<path d="M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm1 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM4 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconDisc=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Disc','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 4a4 4 0 0 0-4 4 .5.5 0 0 1-1 0 5 5 0 0 1 5-5 .5.5 0 0 1 0 1zm4.5 3.5a.5.5 0 0 1 .5.5 5 5 0 0 1-5 5 .5.5 0 0 1 0-1 4 4 0 0 0 4-4 .5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconDiscFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DiscFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-6 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM4 8a4 4 0 0 1 4-4 .5.5 0 0 0 0-1 5 5 0 0 0-5 5 .5.5 0 0 0 1 0zm9 0a.5.5 0 1 0-1 0 4 4 0 0 1-4 4 .5.5 0 0 0 0 1 5 5 0 0 0 5-5z"/>');// eslint-disable-next-line
var BIconDiscord=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Discord','<path d="M6.552 6.712c-.456 0-.816.4-.816.888s.368.888.816.888c.456 0 .816-.4.816-.888.008-.488-.36-.888-.816-.888zm2.92 0c-.456 0-.816.4-.816.888s.368.888.816.888c.456 0 .816-.4.816-.888s-.36-.888-.816-.888z"/><path d="M13.36 0H2.64C1.736 0 1 .736 1 1.648v10.816c0 .912.736 1.648 1.64 1.648h9.072l-.424-1.48 1.024.952.968.896L15 16V1.648C15 .736 14.264 0 13.36 0zm-3.088 10.448s-.288-.344-.528-.648c1.048-.296 1.448-.952 1.448-.952-.328.216-.64.368-.92.472-.4.168-.784.28-1.16.344a5.604 5.604 0 0 1-2.072-.008 6.716 6.716 0 0 1-1.176-.344 4.688 4.688 0 0 1-.584-.272c-.024-.016-.048-.024-.072-.04-.016-.008-.024-.016-.032-.024-.144-.08-.224-.136-.224-.136s.384.64 1.4.944c-.24.304-.536.664-.536.664-1.768-.056-2.44-1.216-2.44-1.216 0-2.576 1.152-4.664 1.152-4.664 1.152-.864 2.248-.84 2.248-.84l.08.096c-1.44.416-2.104 1.048-2.104 1.048s.176-.096.472-.232c.856-.376 1.536-.48 1.816-.504.048-.008.088-.016.136-.016a6.521 6.521 0 0 1 4.024.752s-.632-.6-1.992-1.016l.112-.128s1.096-.024 2.248.84c0 0 1.152 2.088 1.152 4.664 0 0-.68 1.16-2.448 1.216z"/>');// eslint-disable-next-line
var BIconDisplay=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Display','<path d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z"/>');// eslint-disable-next-line
var BIconDisplayFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DisplayFill','<path d="M6 12c0 .667-.083 1.167-.25 1.5H5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-.75c-.167-.333-.25-.833-.25-1.5h4c2 0 2-2 2-2V4c0-2-2-2-2-2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h4z"/>');// eslint-disable-next-line
var BIconDistributeHorizontal=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DistributeHorizontal','<path fill-rule="evenodd" d="M14.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5zm-13 0a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"/><path d="M6 13a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v10z"/>');// eslint-disable-next-line
var BIconDistributeVertical=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DistributeVertical','<path fill-rule="evenodd" d="M1 1.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5zm0 13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5z"/><path d="M2 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7z"/>');// eslint-disable-next-line
var BIconDoorClosed=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DoorClosed','<path d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2zm1 13h8V2H4v13z"/><path d="M9 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z"/>');// eslint-disable-next-line
var BIconDoorClosedFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DoorClosedFill','<path d="M12 1a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2a1 1 0 0 1 1-1h8zm-2 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconDoorOpen=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DoorOpen','<path d="M8.5 10c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z"/><path d="M10.828.122A.5.5 0 0 1 11 .5V1h.5A1.5 1.5 0 0 1 13 2.5V15h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V1.5a.5.5 0 0 1 .43-.495l7-1a.5.5 0 0 1 .398.117zM11.5 2H11v13h1V2.5a.5.5 0 0 0-.5-.5zM4 1.934V15h6V1.077l-6 .857z"/>');// eslint-disable-next-line
var BIconDoorOpenFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DoorOpenFill','<path d="M1.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1H13V2.5A1.5 1.5 0 0 0 11.5 1H11V.5a.5.5 0 0 0-.57-.495l-7 1A.5.5 0 0 0 3 1.5V15H1.5zM11 2h.5a.5.5 0 0 1 .5.5V15h-1V2zm-2.5 8c-.276 0-.5-.448-.5-1s.224-1 .5-1 .5.448.5 1-.224 1-.5 1z"/>');// eslint-disable-next-line
var BIconDot=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Dot','<path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>');// eslint-disable-next-line
var BIconDownload=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Download','<path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>');// eslint-disable-next-line
var BIconDroplet=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Droplet','<path fill-rule="evenodd" d="M7.21.8C7.69.295 8 0 8 0c.109.363.234.708.371 1.038.812 1.946 2.073 3.35 3.197 4.6C12.878 7.096 14 8.345 14 10a6 6 0 0 1-12 0C2 6.668 5.58 2.517 7.21.8zm.413 1.021A31.25 31.25 0 0 0 5.794 3.99c-.726.95-1.436 2.008-1.96 3.07C3.304 8.133 3 9.138 3 10a5 5 0 0 0 10 0c0-1.201-.796-2.157-2.181-3.7l-.03-.032C9.75 5.11 8.5 3.72 7.623 1.82z"/><path fill-rule="evenodd" d="M4.553 7.776c.82-1.641 1.717-2.753 2.093-3.13l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448z"/>');// eslint-disable-next-line
var BIconDropletFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DropletFill','<path fill-rule="evenodd" d="M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6zM6.646 4.646c-.376.377-1.272 1.489-2.093 3.13l.894.448c.78-1.559 1.616-2.58 1.907-2.87l-.708-.708z"/>');// eslint-disable-next-line
var BIconDropletHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('DropletHalf','<path fill-rule="evenodd" d="M7.21.8C7.69.295 8 0 8 0c.109.363.234.708.371 1.038.812 1.946 2.073 3.35 3.197 4.6C12.878 7.096 14 8.345 14 10a6 6 0 0 1-12 0C2 6.668 5.58 2.517 7.21.8zm.413 1.021A31.25 31.25 0 0 0 5.794 3.99c-.726.95-1.436 2.008-1.96 3.07C3.304 8.133 3 9.138 3 10c0 0 2.5 1.5 5 .5s5-.5 5-.5c0-1.201-.796-2.157-2.181-3.7l-.03-.032C9.75 5.11 8.5 3.72 7.623 1.82z"/><path fill-rule="evenodd" d="M4.553 7.776c.82-1.641 1.717-2.753 2.093-3.13l.708.708c-.29.29-1.128 1.311-1.907 2.87l-.894-.448z"/>');// eslint-disable-next-line
var BIconEarbuds=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Earbuds','<path fill-rule="evenodd" d="M6.825 4.138c.596 2.141-.36 3.593-2.389 4.117a4.432 4.432 0 0 1-2.018.054c-.048-.01.9 2.778 1.522 4.61l.41 1.205a.52.52 0 0 1-.346.659l-.593.19a.548.548 0 0 1-.69-.34L.184 6.99c-.696-2.137.662-4.309 2.564-4.8 2.029-.523 3.402 0 4.076 1.948zm-.868 2.221c.43-.112.561-.993.292-1.969-.269-.975-.836-1.675-1.266-1.563-.43.112-.561.994-.292 1.969.269.975.836 1.675 1.266 1.563zm3.218-2.221c-.596 2.141.36 3.593 2.389 4.117a4.434 4.434 0 0 0 2.018.054c.048-.01-.9 2.778-1.522 4.61l-.41 1.205a.52.52 0 0 0 .346.659l.593.19c.289.092.6-.06.69-.34l2.536-7.643c.696-2.137-.662-4.309-2.564-4.8-2.029-.523-3.402 0-4.076 1.948zm.868 2.221c-.43-.112-.561-.993-.292-1.969.269-.975.836-1.675 1.266-1.563.43.112.561.994.292 1.969-.269.975-.836 1.675-1.266 1.563z"/>');// eslint-disable-next-line
var BIconEasel=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Easel','<path d="M8 0a.5.5 0 0 1 .473.337L9.046 2H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L11.092 11H8.5v3a.5.5 0 0 1-1 0v-3H4.908l-1.435 4.163a.5.5 0 1 1-.946-.326L3.85 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L7.527.337A.5.5 0 0 1 8 0zM2 3v7h12V3H2z"/>');// eslint-disable-next-line
var BIconEaselFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EaselFill','<path d="M8.473.337a.5.5 0 0 0-.946 0L6.954 2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1.85l-1.323 3.837a.5.5 0 1 0 .946.326L4.908 11H7.5v2.5a.5.5 0 0 0 1 0V11h2.592l1.435 4.163a.5.5 0 0 0 .946-.326L12.15 11H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9.046L8.473.337z"/>');// eslint-disable-next-line
var BIconEgg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Egg','<path d="M8 15a5 5 0 0 1-5-5c0-1.956.69-4.286 1.742-6.12.524-.913 1.112-1.658 1.704-2.164C7.044 1.206 7.572 1 8 1c.428 0 .956.206 1.554.716.592.506 1.18 1.251 1.704 2.164C12.31 5.714 13 8.044 13 10a5 5 0 0 1-5 5zm0 1a6 6 0 0 0 6-6c0-4.314-3-10-6-10S2 5.686 2 10a6 6 0 0 0 6 6z"/>');// eslint-disable-next-line
var BIconEggFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EggFill','<path d="M14 10a6 6 0 0 1-12 0C2 5.686 5 0 8 0s6 5.686 6 10z"/>');// eslint-disable-next-line
var BIconEggFried=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EggFried','<path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/><path d="M13.997 5.17a5 5 0 0 0-8.101-4.09A5 5 0 0 0 1.28 9.342a5 5 0 0 0 8.336 5.109 3.5 3.5 0 0 0 5.201-4.065 3.001 3.001 0 0 0-.822-5.216zm-1-.034a1 1 0 0 0 .668.977 2.001 2.001 0 0 1 .547 3.478 1 1 0 0 0-.341 1.113 2.5 2.5 0 0 1-3.715 2.905 1 1 0 0 0-1.262.152 4 4 0 0 1-6.67-4.087 1 1 0 0 0-.2-1 4 4 0 0 1 3.693-6.61 1 1 0 0 0 .8-.2 4 4 0 0 1 6.48 3.273z"/>');// eslint-disable-next-line
var BIconEject=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Eject','<path d="M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H1.656C.78 9.5.326 8.455.926 7.816L7.27 1.047zM14.346 8.5 8 1.731 1.654 8.5h12.692zM.5 11.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-1zm14 0h-13v1h13v-1z"/>');// eslint-disable-next-line
var BIconEjectFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EjectFill','<path d="M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H1.656C.78 9.5.326 8.455.926 7.816L7.27 1.047zM.5 11.5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-1z"/>');// eslint-disable-next-line
var BIconEmojiAngry=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiAngry','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4.285 12.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 10.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 9.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zm6.991-8.38a.5.5 0 1 1 .448.894l-1.009.504c.176.27.285.64.285 1.049 0 .828-.448 1.5-1 1.5s-1-.672-1-1.5c0-.247.04-.48.11-.686a.502.502 0 0 1 .166-.761l2-1zm-6.552 0a.5.5 0 0 0-.448.894l1.009.504A1.94 1.94 0 0 0 5 6.5C5 7.328 5.448 8 6 8s1-.672 1-1.5c0-.247-.04-.48-.11-.686a.502.502 0 0 0-.166-.761l-2-1z"/>');// eslint-disable-next-line
var BIconEmojiAngryFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiAngryFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.053 4.276a.5.5 0 0 1 .67-.223l2 1a.5.5 0 0 1 .166.76c.071.206.111.44.111.687C7 7.328 6.552 8 6 8s-1-.672-1-1.5c0-.408.109-.778.285-1.049l-1.009-.504a.5.5 0 0 1-.223-.67zm.232 8.157a.5.5 0 0 1-.183-.683A4.498 4.498 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 1 1-.866.5A3.498 3.498 0 0 0 8 10.5a3.498 3.498 0 0 0-3.032 1.75.5.5 0 0 1-.683.183zM10 8c-.552 0-1-.672-1-1.5 0-.247.04-.48.11-.686a.502.502 0 0 1 .166-.761l2-1a.5.5 0 1 1 .448.894l-1.009.504c.176.27.285.64.285 1.049 0 .828-.448 1.5-1 1.5z"/>');// eslint-disable-next-line
var BIconEmojiDizzy=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiDizzy','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M9.146 5.146a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zm-5 0a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 1 1 .708.708l-.647.646.647.646a.5.5 0 1 1-.708.708L5.5 7.207l-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zM10 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>');// eslint-disable-next-line
var BIconEmojiDizzyFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiDizzyFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.146 5.146a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 1 1 .708.708l-.647.646.647.646a.5.5 0 1 1-.708.708L5.5 7.207l-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zm5 0a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 1 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 0-.708zM8 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>');// eslint-disable-next-line
var BIconEmojiExpressionless=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiExpressionless','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm5 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconEmojiExpressionlessFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiExpressionlessFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconEmojiFrown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiFrown','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4.285 12.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 10.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 9.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"/>');// eslint-disable-next-line
var BIconEmojiFrownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiFrownFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm-2.715 5.933a.5.5 0 0 1-.183-.683A4.498 4.498 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.498 3.498 0 0 0 8 10.5a3.498 3.498 0 0 0-3.032 1.75.5.5 0 0 1-.683.183zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"/>');// eslint-disable-next-line
var BIconEmojiHeartEyes=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiHeartEyes','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M11.315 10.014a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.488 0c1.398-.864 3.544 1.838-.952 3.434-3.067-3.554.19-4.858.952-3.434z"/>');// eslint-disable-next-line
var BIconEmojiHeartEyesFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiHeartEyesFill','<path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z"/>');// eslint-disable-next-line
var BIconEmojiLaughing=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiLaughing','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M12.331 9.5a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zM7 6.5c0 .828-.448 0-1 0s-1 .828-1 0S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 0-1 0s-1 .828-1 0S9.448 5 10 5s1 .672 1 1.5z"/>');// eslint-disable-next-line
var BIconEmojiLaughingFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiLaughingFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z"/>');// eslint-disable-next-line
var BIconEmojiNeutral=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiNeutral','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4 10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5zm3-4C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5S9.448 8 10 8s1-.672 1-1.5z"/>');// eslint-disable-next-line
var BIconEmojiNeutralFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiNeutralFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"/>');// eslint-disable-next-line
var BIconEmojiSmile=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiSmile','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"/>');// eslint-disable-next-line
var BIconEmojiSmileFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiSmileFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"/>');// eslint-disable-next-line
var BIconEmojiSmileUpsideDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiSmileUpsideDown','<path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0-1a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"/><path d="M4.285 6.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 4.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 3.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM7 9.5C7 8.672 6.552 8 6 8s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5z"/>');// eslint-disable-next-line
var BIconEmojiSmileUpsideDownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiSmileUpsideDownFill','<path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7 9.5C7 8.672 6.552 8 6 8s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5zM4.285 6.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 4.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 3.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM10 8c-.552 0-1 .672-1 1.5s.448 1.5 1 1.5 1-.672 1-1.5S10.552 8 10 8z"/>');// eslint-disable-next-line
var BIconEmojiSunglasses=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiSunglasses','<path d="M4.968 9.75a.5.5 0 1 0-.866.5A4.498 4.498 0 0 0 8 12.5a4.5 4.5 0 0 0 3.898-2.25.5.5 0 1 0-.866-.5A3.498 3.498 0 0 1 8 11.5a3.498 3.498 0 0 1-3.032-1.75zM7 5.116V5a1 1 0 0 0-1-1H3.28a1 1 0 0 0-.97 1.243l.311 1.242A2 2 0 0 0 4.561 8H5a2 2 0 0 0 1.994-1.839A2.99 2.99 0 0 1 8 6c.393 0 .74.064 1.006.161A2 2 0 0 0 11 8h.438a2 2 0 0 0 1.94-1.515l.311-1.242A1 1 0 0 0 12.72 4H10a1 1 0 0 0-1 1v.116A4.22 4.22 0 0 0 8 5c-.35 0-.69.04-1 .116z"/><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-1 0A7 7 0 1 0 1 8a7 7 0 0 0 14 0z"/>');// eslint-disable-next-line
var BIconEmojiSunglassesFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiSunglassesFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM2.31 5.243A1 1 0 0 1 3.28 4H6a1 1 0 0 1 1 1v.116A4.22 4.22 0 0 1 8 5c.35 0 .69.04 1 .116V5a1 1 0 0 1 1-1h2.72a1 1 0 0 1 .97 1.243l-.311 1.242A2 2 0 0 1 11.439 8H11a2 2 0 0 1-1.994-1.839A2.99 2.99 0 0 0 8 6c-.393 0-.74.064-1.006.161A2 2 0 0 1 5 8h-.438a2 2 0 0 1-1.94-1.515L2.31 5.243zM4.969 9.75A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .866-.5z"/>');// eslint-disable-next-line
var BIconEmojiWink=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiWink','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm1.757-.437a.5.5 0 0 1 .68.194.934.934 0 0 0 .813.493c.339 0 .645-.19.813-.493a.5.5 0 1 1 .874.486A1.934 1.934 0 0 1 10.25 7.75c-.73 0-1.356-.412-1.687-1.007a.5.5 0 0 1 .194-.68z"/>');// eslint-disable-next-line
var BIconEmojiWinkFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EmojiWinkFill','<path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM7 6.5C7 5.672 6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8s1-.672 1-1.5zM4.285 9.567a.5.5 0 0 0-.183.683A4.498 4.498 0 0 0 8 12.5a4.5 4.5 0 0 0 3.898-2.25.5.5 0 1 0-.866-.5A3.498 3.498 0 0 1 8 11.5a3.498 3.498 0 0 1-3.032-1.75.5.5 0 0 0-.683-.183zm5.152-3.31a.5.5 0 0 0-.874.486c.33.595.958 1.007 1.687 1.007.73 0 1.356-.412 1.687-1.007a.5.5 0 0 0-.874-.486.934.934 0 0 1-.813.493.934.934 0 0 1-.813-.493z"/>');// eslint-disable-next-line
var BIconEnvelope=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Envelope','<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>');// eslint-disable-next-line
var BIconEnvelopeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EnvelopeFill','<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>');// eslint-disable-next-line
var BIconEnvelopeOpen=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EnvelopeOpen','<path d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.818l5.724 3.465L8 8.917l1.276.766L15 6.218V5.4a1 1 0 0 0-.53-.882l-6-3.2zM15 7.388l-4.754 2.877L15 13.117v-5.73zm-.035 6.874L8 10.083l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738zM1 13.117l4.754-2.852L1 7.387v5.73zM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2z"/>');// eslint-disable-next-line
var BIconEnvelopeOpenFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EnvelopeOpenFill','<path d="M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.313l6.709 3.933L8 8.928l1.291.717L16 5.715V5.4a2 2 0 0 0-1.059-1.765l-6-3.2zM16 6.873l-5.693 3.337L16 13.372v-6.5zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516zM0 13.373l5.693-3.163L0 6.873v6.5z"/>');// eslint-disable-next-line
var BIconEraser=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Eraser','<path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"/>');// eslint-disable-next-line
var BIconEraserFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EraserFill','<path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm.66 11.34L3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"/>');// eslint-disable-next-line
var BIconExclamation=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Exclamation','<path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"/>');// eslint-disable-next-line
var BIconExclamationCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>');// eslint-disable-next-line
var BIconExclamationCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>');// eslint-disable-next-line
var BIconExclamationDiamond=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationDiamond','<path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"/><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>');// eslint-disable-next-line
var BIconExclamationDiamondFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationDiamondFill','<path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconExclamationLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationLg','<path d="M6.002 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm.195-12.01a1.81 1.81 0 1 1 3.602 0l-.701 7.015a1.105 1.105 0 0 1-2.2 0l-.7-7.015z"/>');// eslint-disable-next-line
var BIconExclamationOctagon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationOctagon','<path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"/><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>');// eslint-disable-next-line
var BIconExclamationOctagonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationOctagonFill','<path d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconExclamationSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>');// eslint-disable-next-line
var BIconExclamationSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconExclamationTriangle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationTriangle','<path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/><path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>');// eslint-disable-next-line
var BIconExclamationTriangleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ExclamationTriangleFill','<path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconExclude=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Exclude','<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm12 2H5a1 1 0 0 0-1 1v7h7a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconEye=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Eye','<path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>');// eslint-disable-next-line
var BIconEyeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EyeFill','<path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/><path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>');// eslint-disable-next-line
var BIconEyeSlash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EyeSlash','<path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/><path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/><path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>');// eslint-disable-next-line
var BIconEyeSlashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('EyeSlashFill','<path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/><path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>');// eslint-disable-next-line
var BIconEyedropper=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Eyedropper','<path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"/>');// eslint-disable-next-line
var BIconEyeglasses=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Eyeglasses','<path d="M4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 7 8a1 1 0 0 1 2 0 3 3 0 0 0 5.959.5h.541a.5.5 0 0 0 0-1h-.541a3 3 0 0 0-5.584-.953A1.993 1.993 0 0 0 8 6c-.532 0-1.016.208-1.375.547zM14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>');// eslint-disable-next-line
var BIconFacebook=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Facebook','<path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>');// eslint-disable-next-line
var BIconFile=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('File','<path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileArrowDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileArrowDown','<path d="M8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileArrowDownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileArrowDownFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5z"/>');// eslint-disable-next-line
var BIconFileArrowUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileArrowUp','<path d="M8 11a.5.5 0 0 0 .5-.5V6.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 6.707V10.5a.5.5 0 0 0 .5.5z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileArrowUpFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileArrowUpFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7.5 6.707 6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707z"/>');// eslint-disable-next-line
var BIconFileBarGraph=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileBarGraph','<path d="M4.5 12a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1zm3 0a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm3 0a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileBarGraphFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileBarGraphFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 11.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/>');// eslint-disable-next-line
var BIconFileBinary=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileBinary','<path d="M5.526 13.09c.976 0 1.524-.79 1.524-2.205 0-1.412-.548-2.203-1.524-2.203-.978 0-1.526.79-1.526 2.203 0 1.415.548 2.206 1.526 2.206zm-.832-2.205c0-1.05.29-1.612.832-1.612.358 0 .607.247.733.721L4.7 11.137a6.749 6.749 0 0 1-.006-.252zm.832 1.614c-.36 0-.606-.246-.732-.718l1.556-1.145c.003.079.005.164.005.249 0 1.052-.29 1.614-.829 1.614zm5.329.501v-.595H9.73V8.772h-.69l-1.19.786v.688L8.986 9.5h.05v2.906h-1.18V13h3z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileBinaryFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileBinaryFill','<path d="M5.526 9.273c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.56-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146z"/><path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7.05 10.885c0 1.415-.548 2.206-1.524 2.206C4.548 13.09 4 12.3 4 10.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm3.805 1.52V13h-3v-.595h1.181V9.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"/>');// eslint-disable-next-line
var BIconFileBreak=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileBreak','<path d="M0 10.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zM12 0H4a2 2 0 0 0-2 2v7h1V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7h1V2a2 2 0 0 0-2-2zm2 12h-1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2H2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2z"/>');// eslint-disable-next-line
var BIconFileBreakFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileBreakFill','<path d="M4 0h8a2 2 0 0 1 2 2v7H2V2a2 2 0 0 1 2-2zM2 12h12v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"/>');// eslint-disable-next-line
var BIconFileCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileCheck','<path d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileCheckFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-1.146 6.854-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconFileCode=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileCode','<path d="M6.646 5.646a.5.5 0 1 1 .708.708L5.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0a.5.5 0 1 0-.708.708L10.293 8 8.646 9.646a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFileCodeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileCodeFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6.646 5.646a.5.5 0 1 1 .708.708L5.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconFileDiff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileDiff','<path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4zm-2.5 6.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFileDiffFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileDiffFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 4.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5a.5.5 0 0 1 1 0zM6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileEarmark=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmark','<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>');// eslint-disable-next-line
var BIconFileEarmarkArrowDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkArrowDown','<path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkArrowDownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkArrowDownFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconFileEarmarkArrowUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkArrowUp','<path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkArrowUpFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkArrowUpFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.354 9.854a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 8.707V12.5a.5.5 0 0 1-1 0V8.707L6.354 9.854z"/>');// eslint-disable-next-line
var BIconFileEarmarkBarGraph=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkBarGraph','<path d="M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkBarGraphFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkBarGraphFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm.5 10v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/>');// eslint-disable-next-line
var BIconFileEarmarkBinary=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkBinary','<path d="M7.05 11.885c0 1.415-.548 2.206-1.524 2.206C4.548 14.09 4 13.3 4 11.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm-1.524-1.612c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.559-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146zm6.061.624V14h-3v-.595h1.181V10.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkBinaryFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkBinaryFill','<path d="M5.526 10.273c-.542 0-.832.563-.832 1.612 0 .088.003.173.006.252l1.559-1.143c-.126-.474-.375-.72-.733-.72zm-.732 2.508c.126.472.372.718.732.718.54 0 .83-.563.83-1.614 0-.085-.003-.17-.006-.25l-1.556 1.146z"/><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-2.45 8.385c0 1.415-.548 2.206-1.524 2.206C4.548 14.09 4 13.3 4 11.885c0-1.412.548-2.203 1.526-2.203.976 0 1.524.79 1.524 2.203zm3.805 1.52V14h-3v-.595h1.181V10.5h-.05l-1.136.747v-.688l1.19-.786h.69v3.633h1.125z"/>');// eslint-disable-next-line
var BIconFileEarmarkBreak=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkBreak','<path d="M14 4.5V9h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v7H2V2a2 2 0 0 1 2-2h5.5L14 4.5zM13 12h1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2h1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"/>');// eslint-disable-next-line
var BIconFileEarmarkBreakFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkBreakFill','<path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V9H2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM2 12h12v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2zM.5 10a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"/>');// eslint-disable-next-line
var BIconFileEarmarkCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkCheck','<path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkCheckFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconFileEarmarkCode=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkCode','<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/><path d="M8.646 6.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 9 8.646 7.354a.5.5 0 0 1 0-.708zm-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 9l1.647-1.646a.5.5 0 0 0 0-.708z"/>');// eslint-disable-next-line
var BIconFileEarmarkCodeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkCodeFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.646 7.646a.5.5 0 1 1 .708.708L5.707 10l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zm2.708 0 2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 10 8.646 8.354a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconFileEarmarkDiff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkDiff','<path d="M8 5a.5.5 0 0 1 .5.5V7H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V8H6a.5.5 0 0 1 0-1h1.5V5.5A.5.5 0 0 1 8 5zm-2.5 6.5A.5.5 0 0 1 6 11h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkDiffFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkDiffFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8 6a.5.5 0 0 1 .5.5V8H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V9H6a.5.5 0 0 1 0-1h1.5V6.5A.5.5 0 0 1 8 6zm-2.5 6.5A.5.5 0 0 1 6 12h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFileEarmarkEasel=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkEasel','<path d="M8.5 6a.5.5 0 1 0-1 0h-2A1.5 1.5 0 0 0 4 7.5v2A1.5 1.5 0 0 0 5.5 11h.473l-.447 1.342a.5.5 0 1 0 .948.316L7.027 11H7.5v1a.5.5 0 0 0 1 0v-1h.473l.553 1.658a.5.5 0 1 0 .948-.316L10.027 11h.473A1.5 1.5 0 0 0 12 9.5v-2A1.5 1.5 0 0 0 10.5 6h-2zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkEaselFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkEaselFill','<path d="M5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"/><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 6h2A1.5 1.5 0 0 1 12 7.5v2a1.5 1.5 0 0 1-1.5 1.5h-.473l.447 1.342a.5.5 0 0 1-.948.316L8.973 11H8.5v1a.5.5 0 0 1-1 0v-1h-.473l-.553 1.658a.5.5 0 1 1-.948-.316L5.973 11H5.5A1.5 1.5 0 0 1 4 9.5v-2A1.5 1.5 0 0 1 5.5 6h2a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconFileEarmarkExcel=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkExcel','<path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkExcelFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkExcelFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>');// eslint-disable-next-line
var BIconFileEarmarkFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkFill','<path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z"/>');// eslint-disable-next-line
var BIconFileEarmarkFont=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkFont','<path d="M10.943 6H5.057L5 8h.5c.18-1.096.356-1.192 1.694-1.235l.293-.01v5.09c0 .47-.1.582-.898.655v.5H9.41v-.5c-.803-.073-.903-.184-.903-.654V6.755l.298.01c1.338.043 1.514.14 1.694 1.235h.5l-.057-2z"/><path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>');// eslint-disable-next-line
var BIconFileEarmarkFontFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkFontFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.057 6h5.886L11 8h-.5c-.18-1.096-.356-1.192-1.694-1.235l-.298-.01v5.09c0 .47.1.582.903.655v.5H6.59v-.5c.799-.073.898-.184.898-.654V6.755l-.293.01C5.856 6.808 5.68 6.905 5.5 8H5l.057-2z"/>');// eslint-disable-next-line
var BIconFileEarmarkImage=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkImage','<path d="M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path d="M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5V14zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4z"/>');// eslint-disable-next-line
var BIconFileEarmarkImageFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkImageFill','<path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/><path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"/>');// eslint-disable-next-line
var BIconFileEarmarkLock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkLock','<path d="M10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0zM7 7v1h2V7a1 1 0 0 0-2 0zM6 9.3v2.4c0 .042.02.107.105.175A.637.637 0 0 0 6.5 12h3a.64.64 0 0 0 .395-.125c.085-.068.105-.133.105-.175V9.3c0-.042-.02-.107-.105-.175A.637.637 0 0 0 9.5 9h-3a.637.637 0 0 0-.395.125C6.02 9.193 6 9.258 6 9.3z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkLock2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkLock2','<path d="M10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0zM7 7v1h2V7a1 1 0 0 0-2 0z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkLock2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkLock2Fill','<path d="M7 7a1 1 0 0 1 2 0v1H7V7z"/><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0z"/>');// eslint-disable-next-line
var BIconFileEarmarkLockFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkLockFill','<path d="M7 7a1 1 0 0 1 2 0v1H7V7zM6 9.3c0-.042.02-.107.105-.175A.637.637 0 0 1 6.5 9h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 12h-3a.637.637 0 0 1-.395-.125C6.02 11.807 6 11.742 6 11.7V9.3z"/><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0z"/>');// eslint-disable-next-line
var BIconFileEarmarkMedical=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkMedical','<path d="M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V5.5zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkMedicalFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkMedicalFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-3 2v.634l.549-.317a.5.5 0 1 1 .5.866L7 7l.549.317a.5.5 0 1 1-.5.866L6.5 7.866V8.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L5 7l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V5.5a.5.5 0 1 1 1 0zm-2 4.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileEarmarkMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkMinus','<path d="M5.5 9a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>');// eslint-disable-next-line
var BIconFileEarmarkMinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkMinusFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 8.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileEarmarkMusic=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkMusic','<path d="M11 6.64a1 1 0 0 0-1.243-.97l-1 .25A1 1 0 0 0 8 6.89v4.306A2.572 2.572 0 0 0 7 11c-.5 0-.974.134-1.338.377-.36.24-.662.628-.662 1.123s.301.883.662 1.123c.364.243.839.377 1.338.377.5 0 .974-.134 1.338-.377.36-.24.662-.628.662-1.123V8.89l2-.5V6.64z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkMusicFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkMusicFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 6.64v1.75l-2 .5v3.61c0 .495-.301.883-.662 1.123C7.974 13.866 7.499 14 7 14c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 11.134 6.501 11 7 11c.356 0 .7.068 1 .196V6.89a1 1 0 0 1 .757-.97l1-.25A1 1 0 0 1 11 6.64z"/>');// eslint-disable-next-line
var BIconFileEarmarkPdf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPdf','<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/><path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"/>');// eslint-disable-next-line
var BIconFileEarmarkPdfFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPdfFill','<path d="M5.523 12.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.148 21.148 0 0 0 .5-1.05 12.045 12.045 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.881 3.881 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 6.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"/><path fill-rule="evenodd" d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.651 11.651 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.697 19.697 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"/>');// eslint-disable-next-line
var BIconFileEarmarkPerson=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPerson','<path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2v9.255S12 12 8 12s-5 1.755-5 1.755V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkPersonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPersonFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.245S4 12 8 12s5 1.755 5 1.755z"/>');// eslint-disable-next-line
var BIconFileEarmarkPlay=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPlay','<path d="M6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkPlayFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPlayFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6 6.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V6.884z"/>');// eslint-disable-next-line
var BIconFileEarmarkPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPlus','<path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5z"/><path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>');// eslint-disable-next-line
var BIconFileEarmarkPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPlusFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconFileEarmarkPost=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPost','<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/><path d="M4 6.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7zm0-3a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFileEarmarkPostFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPostFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-5-.5H7a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1 0-1zm0 3h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconFileEarmarkPpt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPpt','<path d="M7 5.5a1 1 0 0 0-1 1V13a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7zM8.188 10H7V6.5h1.188a1.75 1.75 0 1 1 0 3.5z"/><path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>');// eslint-disable-next-line
var BIconFileEarmarkPptFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkPptFill','<path d="M8.188 10H7V6.5h1.188a1.75 1.75 0 1 1 0 3.5z"/><path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM7 5.5a1 1 0 0 0-1 1V13a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7z"/>');// eslint-disable-next-line
var BIconFileEarmarkRichtext=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkRichtext','<path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/><path d="M4.5 12.5A.5.5 0 0 1 5 12h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 10h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm1.639-3.708 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V8.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8s1.54-1.274 1.639-1.208zM6.25 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z"/>');// eslint-disable-next-line
var BIconFileEarmarkRichtextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkRichtextFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM7 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V9.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V9s1.54-1.274 1.639-1.208zM5 11h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileEarmarkRuled=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkRuled','<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h7v1a1 1 0 0 1-1 1H6zm7-3H6v-2h7v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkRuledFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkRuledFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1H6v2h7v1H6v2H5v-2H3v-1h2v-2H3V9z"/>');// eslint-disable-next-line
var BIconFileEarmarkSlides=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkSlides','<path d="M5 6a.5.5 0 0 0-.496.438l-.5 4A.5.5 0 0 0 4.5 11h3v2.016c-.863.055-1.5.251-1.5.484 0 .276.895.5 2 .5s2-.224 2-.5c0-.233-.637-.429-1.5-.484V11h3a.5.5 0 0 0 .496-.562l-.5-4A.5.5 0 0 0 11 6H5zm2 3.78V7.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 9.778z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkSlidesFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkSlidesFill','<path d="M7 9.78V7.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 9.778z"/><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5 6h6a.5.5 0 0 1 .496.438l.5 4A.5.5 0 0 1 11.5 11h-3v2.016c.863.055 1.5.251 1.5.484 0 .276-.895.5-2 .5s-2-.224-2-.5c0-.233.637-.429 1.5-.484V11h-3a.5.5 0 0 1-.496-.562l.5-4A.5.5 0 0 1 5 6z"/>');// eslint-disable-next-line
var BIconFileEarmarkSpreadsheet=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkSpreadsheet','<path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z"/>');// eslint-disable-next-line
var BIconFileEarmarkSpreadsheetFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkSpreadsheetFill','<path d="M6 12v-2h3v2H6z"/><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3V9z"/>');// eslint-disable-next-line
var BIconFileEarmarkText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkText','<path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/><path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>');// eslint-disable-next-line
var BIconFileEarmarkTextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkTextFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1h-4z"/>');// eslint-disable-next-line
var BIconFileEarmarkWord=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkWord','<path d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkWordFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkWordFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.485 6.879l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 9.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 1 1 .97-.242z"/>');// eslint-disable-next-line
var BIconFileEarmarkX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkX','<path d="M6.854 7.146a.5.5 0 1 0-.708.708L7.293 9l-1.147 1.146a.5.5 0 0 0 .708.708L8 9.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 9l1.147-1.146a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146z"/><path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>');// eslint-disable-next-line
var BIconFileEarmarkXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkXFill','<path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM6.854 7.146 8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconFileEarmarkZip=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkZip','<path d="M5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.11 0l-.929-.62a1 1 0 0 1-.415-1.074L5 8.438V7.5zm2 0H6v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.929-.62-.4-1.598A1 1 0 0 1 7 8.438V7.5z"/><path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1h-2v1h-1v1h1v1h-1v1h1v1H6V5H5V4h1V3H5V2h1V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>');// eslint-disable-next-line
var BIconFileEarmarkZipFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEarmarkZipFill','<path d="M5.5 9.438V8.5h1v.938a1 1 0 0 0 .03.243l.4 1.598-.93.62-.93-.62.4-1.598a1 1 0 0 0 .03-.243z"/><path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-4-.5V2h-1V1H6v1h1v1H6v1h1v1H6v1h1v1H5.5V6h-1V5h1V4h-1V3h1zm0 4.5h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599V8.5a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileEasel=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEasel','<path d="M8.5 5a.5.5 0 1 0-1 0h-2A1.5 1.5 0 0 0 4 6.5v2A1.5 1.5 0 0 0 5.5 10h.473l-.447 1.342a.5.5 0 1 0 .948.316L7.027 10H7.5v1a.5.5 0 0 0 1 0v-1h.473l.553 1.658a.5.5 0 1 0 .948-.316L10.027 10h.473A1.5 1.5 0 0 0 12 8.5v-2A1.5 1.5 0 0 0 10.5 5h-2zM5 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFileEaselFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileEaselFill','<path d="M5 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2z"/><path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 5h2A1.5 1.5 0 0 1 12 6.5v2a1.5 1.5 0 0 1-1.5 1.5h-.473l.447 1.342a.5.5 0 0 1-.948.316L8.973 10H8.5v1a.5.5 0 0 1-1 0v-1h-.473l-.553 1.658a.5.5 0 1 1-.948-.316L5.973 10H5.5A1.5 1.5 0 0 1 4 8.5v-2A1.5 1.5 0 0 1 5.5 5h2a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconFileExcel=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileExcel','<path d="M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileExcelFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileExcelFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.884 4.68 8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 1 1 .768-.64z"/>');// eslint-disable-next-line
var BIconFileFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileFill','<path fill-rule="evenodd" d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"/>');// eslint-disable-next-line
var BIconFileFont=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileFont','<path d="M10.943 4H5.057L5 6h.5c.18-1.096.356-1.192 1.694-1.235l.293-.01v6.09c0 .47-.1.582-.898.655v.5H9.41v-.5c-.803-.073-.903-.184-.903-.654V4.755l.298.01c1.338.043 1.514.14 1.694 1.235h.5l-.057-2z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileFontFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileFontFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.057 4h5.886L11 6h-.5c-.18-1.096-.356-1.192-1.694-1.235l-.298-.01v6.09c0 .47.1.582.903.655v.5H6.59v-.5c.799-.073.898-.184.898-.654V4.755l-.293.01C5.856 4.808 5.68 4.905 5.5 6H5l.057-2z"/>');// eslint-disable-next-line
var BIconFileImage=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileImage','<path d="M8.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8l-2.083-2.083a.5.5 0 0 0-.76.063L8 11 5.835 9.7a.5.5 0 0 0-.611.076L3 12V2z"/>');// eslint-disable-next-line
var BIconFileImageFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileImageFill','<path d="M4 0h8a2 2 0 0 1 2 2v8.293l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm4.002 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/><path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z"/>');// eslint-disable-next-line
var BIconFileLock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileLock','<path d="M8 5a1 1 0 0 1 1 1v1H7V6a1 1 0 0 1 1-1zm2 2.076V6a2 2 0 1 0-4 0v1.076c-.54.166-1 .597-1 1.224v2.4c0 .816.781 1.3 1.5 1.3h3c.719 0 1.5-.484 1.5-1.3V8.3c0-.627-.46-1.058-1-1.224zM6.105 8.125A.637.637 0 0 1 6.5 8h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 11h-3a.637.637 0 0 1-.395-.125C6.02 10.807 6 10.742 6 10.7V8.3c0-.042.02-.107.105-.175z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileLock2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileLock2','<path d="M8 5a1 1 0 0 1 1 1v1H7V6a1 1 0 0 1 1-1zm2 2.076V6a2 2 0 1 0-4 0v1.076c-.54.166-1 .597-1 1.224v2.4c0 .816.781 1.3 1.5 1.3h3c.719 0 1.5-.484 1.5-1.3V8.3c0-.627-.46-1.058-1-1.224z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileLock2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileLock2Fill','<path d="M7 6a1 1 0 0 1 2 0v1H7V6z"/><path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 6v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V8.3c0-.627.46-1.058 1-1.224V6a2 2 0 1 1 4 0z"/>');// eslint-disable-next-line
var BIconFileLockFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileLockFill','<path d="M7 6a1 1 0 0 1 2 0v1H7V6zM6 8.3c0-.042.02-.107.105-.175A.637.637 0 0 1 6.5 8h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 11h-3a.637.637 0 0 1-.395-.125C6.02 10.807 6 10.742 6 10.7V8.3z"/><path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 6v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V8.3c0-.627.46-1.058 1-1.224V6a2 2 0 1 1 4 0z"/>');// eslint-disable-next-line
var BIconFileMedical=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileMedical','<path d="M8.5 4.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L7 6l-.549.317a.5.5 0 1 0 .5.866l.549-.317V7.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L9 6l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V4.5zM5.5 9a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFileMedicalFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileMedicalFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 4.5v.634l.549-.317a.5.5 0 1 1 .5.866L9 6l.549.317a.5.5 0 1 1-.5.866L8.5 6.866V7.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L7 6l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V4.5a.5.5 0 1 1 1 0zM5.5 9h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileMinus','<path d="M5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileMinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileMinusFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileMusic=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileMusic','<path d="M10.304 3.13a1 1 0 0 1 1.196.98v1.8l-2.5.5v5.09c0 .495-.301.883-.662 1.123C7.974 12.866 7.499 13 7 13c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 10.134 6.501 10 7 10c.356 0 .7.068 1 .196V4.41a1 1 0 0 1 .804-.98l1.5-.3z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileMusicFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileMusicFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-.5 4.11v1.8l-2.5.5v5.09c0 .495-.301.883-.662 1.123C7.974 12.866 7.499 13 7 13c-.5 0-.974-.134-1.338-.377-.36-.24-.662-.628-.662-1.123s.301-.883.662-1.123C6.026 10.134 6.501 10 7 10c.356 0 .7.068 1 .196V4.41a1 1 0 0 1 .804-.98l1.5-.3a1 1 0 0 1 1.196.98z"/>');// eslint-disable-next-line
var BIconFilePdf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePdf','<path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/><path d="M4.603 12.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.701 19.701 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.187-.012.395-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.065.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.716 5.716 0 0 1-.911-.95 11.642 11.642 0 0 0-1.997.406 11.311 11.311 0 0 1-1.021 1.51c-.29.35-.608.655-.926.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.27.27 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.647 12.647 0 0 1 1.01-.193 11.666 11.666 0 0 1-.51-.858 20.741 20.741 0 0 1-.5 1.05zm2.446.45c.15.162.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.881 3.881 0 0 0-.612-.053zM8.078 5.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z"/>');// eslint-disable-next-line
var BIconFilePdfFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePdfFill','<path d="M5.523 10.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.035 21.035 0 0 0 .5-1.05 11.96 11.96 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.888 3.888 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 4.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"/><path fill-rule="evenodd" d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm.165 11.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.64 11.64 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.707 19.707 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"/>');// eslint-disable-next-line
var BIconFilePerson=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePerson','<path d="M12 1a1 1 0 0 1 1 1v10.755S12 11 8 11s-5 1.755-5 1.755V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/><path d="M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>');// eslint-disable-next-line
var BIconFilePersonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePersonFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-1 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 4c2.623 0 4.146.826 5 1.755V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1.245C3.854 11.825 5.377 11 8 11z"/>');// eslint-disable-next-line
var BIconFilePlay=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePlay','<path d="M6 10.117V5.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFilePlayFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePlayFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6 5.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V5.884z"/>');// eslint-disable-next-line
var BIconFilePlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePlus','<path d="M8.5 6a.5.5 0 0 0-1 0v1.5H6a.5.5 0 0 0 0 1h1.5V10a.5.5 0 0 0 1 0V8.5H10a.5.5 0 0 0 0-1H8.5V6z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFilePlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePlusFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconFilePost=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePost','<path d="M4 3.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-8z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFilePostFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePostFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM4.5 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 2h7a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconFilePpt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePpt','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/><path d="M6 5a1 1 0 0 1 1-1h1.188a2.75 2.75 0 0 1 0 5.5H7v2a.5.5 0 0 1-1 0V5zm1 3.5h1.188a1.75 1.75 0 1 0 0-3.5H7v3.5z"/>');// eslint-disable-next-line
var BIconFilePptFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilePptFill','<path d="M8.188 8.5H7V5h1.188a1.75 1.75 0 1 1 0 3.5z"/><path d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm3 4a1 1 0 0 0-1 1v6.5a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5H7z"/>');// eslint-disable-next-line
var BIconFileRichtext=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileRichtext','<path d="M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFileRichtextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileRichtextFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileRuled=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileRuled','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v4h10V2a1 1 0 0 0-1-1H4zm9 6H6v2h7V7zm0 3H6v2h7v-2zm0 3H6v2h6a1 1 0 0 0 1-1v-1zm-8 2v-2H3v1a1 1 0 0 0 1 1h1zm-2-3h2v-2H3v2zm0-3h2V7H3v2z"/>');// eslint-disable-next-line
var BIconFileRuledFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileRuledFill','<path d="M12 0H4a2 2 0 0 0-2 2v4h12V2a2 2 0 0 0-2-2zm2 7H6v2h8V7zm0 3H6v2h8v-2zm0 3H6v3h6a2 2 0 0 0 2-2v-1zm-9 3v-3H2v1a2 2 0 0 0 2 2h1zm-3-4h3v-2H2v2zm0-3h3V7H2v2z"/>');// eslint-disable-next-line
var BIconFileSlides=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileSlides','<path d="M5 4a.5.5 0 0 0-.496.438l-.5 4A.5.5 0 0 0 4.5 9h3v2.016c-.863.055-1.5.251-1.5.484 0 .276.895.5 2 .5s2-.224 2-.5c0-.233-.637-.429-1.5-.484V9h3a.5.5 0 0 0 .496-.562l-.5-4A.5.5 0 0 0 11 4H5zm2 3.78V5.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 7.778z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFileSlidesFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileSlidesFill','<path d="M7 7.78V5.22c0-.096.106-.156.19-.106l2.13 1.279a.125.125 0 0 1 0 .214l-2.13 1.28A.125.125 0 0 1 7 7.778z"/><path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4h6a.5.5 0 0 1 .496.438l.5 4A.5.5 0 0 1 11.5 9h-3v2.016c.863.055 1.5.251 1.5.484 0 .276-.895.5-2 .5s-2-.224-2-.5c0-.233.637-.429 1.5-.484V9h-3a.5.5 0 0 1-.496-.562l.5-4A.5.5 0 0 1 5 4z"/>');// eslint-disable-next-line
var BIconFileSpreadsheet=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileSpreadsheet','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v4h10V2a1 1 0 0 0-1-1H4zm9 6h-3v2h3V7zm0 3h-3v2h3v-2zm0 3h-3v2h2a1 1 0 0 0 1-1v-1zm-4 2v-2H6v2h3zm-4 0v-2H3v1a1 1 0 0 0 1 1h1zm-2-3h2v-2H3v2zm0-3h2V7H3v2zm3-2v2h3V7H6zm3 3H6v2h3v-2z"/>');// eslint-disable-next-line
var BIconFileSpreadsheetFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileSpreadsheetFill','<path d="M12 0H4a2 2 0 0 0-2 2v4h12V2a2 2 0 0 0-2-2zm2 7h-4v2h4V7zm0 3h-4v2h4v-2zm0 3h-4v3h2a2 2 0 0 0 2-2v-1zm-5 3v-3H6v3h3zm-4 0v-3H2v1a2 2 0 0 0 2 2h1zm-3-4h3v-2H2v2zm0-3h3V7H2v2zm4 0V7h3v2H6zm0 1h3v2H6v-2z"/>');// eslint-disable-next-line
var BIconFileText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileText','<path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconFileTextFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileTextFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5 4h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1zm0 2h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconFileWord=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileWord','<path d="M4.879 4.515a.5.5 0 0 1 .606.364l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 7.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 0 1 .364-.606z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileWordFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileWordFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM5.485 4.879l1.036 4.144.997-3.655a.5.5 0 0 1 .964 0l.997 3.655 1.036-4.144a.5.5 0 0 1 .97.242l-1.5 6a.5.5 0 0 1-.967.01L8 7.402l-1.018 3.73a.5.5 0 0 1-.967-.01l-1.5-6a.5.5 0 1 1 .97-.242z"/>');// eslint-disable-next-line
var BIconFileX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileX','<path d="M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconFileXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileXFill','<path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM6.854 6.146 8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconFileZip=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileZip','<path d="M6.5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.109 0l-.93-.62a1 1 0 0 1-.415-1.074l.4-1.599V7.5zm2 0h-1v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 0 1-.03-.243V7.5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm5.5-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9v1H8v1h1v1H8v1h1v1H7.5V5h-1V4h1V3h-1V2h1V1z"/>');// eslint-disable-next-line
var BIconFileZipFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FileZipFill','<path d="M8.5 9.438V8.5h-1v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.93-.62-.4-1.598a1 1 0 0 1-.03-.243z"/><path d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm2.5 8.5v.938l-.4 1.599a1 1 0 0 0 .416 1.074l.93.62a1 1 0 0 0 1.109 0l.93-.62a1 1 0 0 0 .415-1.074l-.4-1.599V8.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1zm1-5.5h-1v1h1v1h-1v1h1v1H9V6H8V5h1V4H8V3h1V2H8V1H6.5v1h1v1z"/>');// eslint-disable-next-line
var BIconFiles=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Files','<path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>');// eslint-disable-next-line
var BIconFilesAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilesAlt','<path d="M11 0H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2 2 2 0 0 0 2-2V4a2 2 0 0 0-2-2 2 2 0 0 0-2-2zm2 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1V3zM2 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2z"/>');// eslint-disable-next-line
var BIconFilm=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Film','<path d="M0 1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm4 0v6h8V1H4zm8 8H4v6h8V9zM1 1v2h2V1H1zm2 3H1v2h2V4zM1 7v2h2V7H1zm2 3H1v2h2v-2zm-2 3v2h2v-2H1zM15 1h-2v2h2V1zm-2 3v2h2V4h-2zm2 3h-2v2h2V7zm-2 3v2h2v-2h-2zm2 3h-2v2h2v-2z"/>');// eslint-disable-next-line
var BIconFilter=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Filter','<path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFilterCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilterCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M7 11.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFilterCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilterCircleFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM3.5 5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zM5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFilterLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilterLeft','<path d="M2 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFilterRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilterRight','<path d="M14 10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 .5-.5zm0-3a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0 0 1h11a.5.5 0 0 0 .5-.5z"/>');// eslint-disable-next-line
var BIconFilterSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilterSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M6 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFilterSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FilterSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm.5 5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zM4 8.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFlag=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Flag','<path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21.317 21.317 0 0 0 14 7.655V1.222z"/>');// eslint-disable-next-line
var BIconFlagFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FlagFill','<path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001"/>');// eslint-disable-next-line
var BIconFlower1=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Flower1','<path d="M6.174 1.184a2 2 0 0 1 3.652 0A2 2 0 0 1 12.99 3.01a2 2 0 0 1 1.826 3.164 2 2 0 0 1 0 3.652 2 2 0 0 1-1.826 3.164 2 2 0 0 1-3.164 1.826 2 2 0 0 1-3.652 0A2 2 0 0 1 3.01 12.99a2 2 0 0 1-1.826-3.164 2 2 0 0 1 0-3.652A2 2 0 0 1 3.01 3.01a2 2 0 0 1 3.164-1.826zM8 1a1 1 0 0 0-.998 1.03l.01.091c.012.077.029.176.054.296.049.241.122.542.213.887.182.688.428 1.513.676 2.314L8 5.762l.045-.144c.248-.8.494-1.626.676-2.314.091-.345.164-.646.213-.887a4.997 4.997 0 0 0 .064-.386L9 2a1 1 0 0 0-1-1zM2 9l.03-.002.091-.01a4.99 4.99 0 0 0 .296-.054c.241-.049.542-.122.887-.213a60.59 60.59 0 0 0 2.314-.676L5.762 8l-.144-.045a60.59 60.59 0 0 0-2.314-.676 16.705 16.705 0 0 0-.887-.213 4.99 4.99 0 0 0-.386-.064L2 7a1 1 0 1 0 0 2zm7 5-.002-.03a5.005 5.005 0 0 0-.064-.386 16.398 16.398 0 0 0-.213-.888 60.582 60.582 0 0 0-.676-2.314L8 10.238l-.045.144c-.248.8-.494 1.626-.676 2.314-.091.345-.164.646-.213.887a4.996 4.996 0 0 0-.064.386L7 14a1 1 0 1 0 2 0zm-5.696-2.134.025-.017a5.001 5.001 0 0 0 .303-.248c.184-.164.408-.377.661-.629A60.614 60.614 0 0 0 5.96 9.23l.103-.111-.147.033a60.88 60.88 0 0 0-2.343.572c-.344.093-.64.18-.874.258a5.063 5.063 0 0 0-.367.138l-.027.014a1 1 0 1 0 1 1.732zM4.5 14.062a1 1 0 0 0 1.366-.366l.014-.027c.01-.02.021-.048.036-.084a5.09 5.09 0 0 0 .102-.283c.078-.233.165-.53.258-.874a60.6 60.6 0 0 0 .572-2.343l.033-.147-.11.102a60.848 60.848 0 0 0-1.743 1.667 17.07 17.07 0 0 0-.629.66 5.06 5.06 0 0 0-.248.304l-.017.025a1 1 0 0 0 .366 1.366zm9.196-8.196a1 1 0 0 0-1-1.732l-.025.017a4.951 4.951 0 0 0-.303.248 16.69 16.69 0 0 0-.661.629A60.72 60.72 0 0 0 10.04 6.77l-.102.111.147-.033a60.6 60.6 0 0 0 2.342-.572c.345-.093.642-.18.875-.258a4.993 4.993 0 0 0 .367-.138.53.53 0 0 0 .027-.014zM11.5 1.938a1 1 0 0 0-1.366.366l-.014.027c-.01.02-.021.048-.036.084a5.09 5.09 0 0 0-.102.283c-.078.233-.165.53-.258.875a60.62 60.62 0 0 0-.572 2.342l-.033.147.11-.102a60.848 60.848 0 0 0 1.743-1.667c.252-.253.465-.477.629-.66a5.001 5.001 0 0 0 .248-.304l.017-.025a1 1 0 0 0-.366-1.366zM14 9a1 1 0 0 0 0-2l-.03.002a4.996 4.996 0 0 0-.386.064c-.242.049-.543.122-.888.213-.688.182-1.513.428-2.314.676L10.238 8l.144.045c.8.248 1.626.494 2.314.676.345.091.646.164.887.213a4.996 4.996 0 0 0 .386.064L14 9zM1.938 4.5a1 1 0 0 0 .393 1.38l.084.035c.072.03.166.064.283.103.233.078.53.165.874.258a60.88 60.88 0 0 0 2.343.572l.147.033-.103-.111a60.584 60.584 0 0 0-1.666-1.742 16.705 16.705 0 0 0-.66-.629 4.996 4.996 0 0 0-.304-.248l-.025-.017a1 1 0 0 0-1.366.366zm2.196-1.196.017.025a4.996 4.996 0 0 0 .248.303c.164.184.377.408.629.661A60.597 60.597 0 0 0 6.77 5.96l.111.102-.033-.147a60.602 60.602 0 0 0-.572-2.342c-.093-.345-.18-.642-.258-.875a5.006 5.006 0 0 0-.138-.367l-.014-.027a1 1 0 1 0-1.732 1zm9.928 8.196a1 1 0 0 0-.366-1.366l-.027-.014a5 5 0 0 0-.367-.138c-.233-.078-.53-.165-.875-.258a60.619 60.619 0 0 0-2.342-.572l-.147-.033.102.111a60.73 60.73 0 0 0 1.667 1.742c.253.252.477.465.66.629a4.946 4.946 0 0 0 .304.248l.025.017a1 1 0 0 0 1.366-.366zm-3.928 2.196a1 1 0 0 0 1.732-1l-.017-.025a5.065 5.065 0 0 0-.248-.303 16.705 16.705 0 0 0-.629-.661A60.462 60.462 0 0 0 9.23 10.04l-.111-.102.033.147a60.6 60.6 0 0 0 .572 2.342c.093.345.18.642.258.875a4.985 4.985 0 0 0 .138.367.575.575 0 0 0 .014.027zM8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>');// eslint-disable-next-line
var BIconFlower2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Flower2','<path d="M8 16a4 4 0 0 0 4-4 4 4 0 0 0 0-8 4 4 0 0 0-8 0 4 4 0 1 0 0 8 4 4 0 0 0 4 4zm3-12c0 .073-.01.155-.03.247-.544.241-1.091.638-1.598 1.084A2.987 2.987 0 0 0 8 5c-.494 0-.96.12-1.372.331-.507-.446-1.054-.843-1.597-1.084A1.117 1.117 0 0 1 5 4a3 3 0 0 1 6 0zm-.812 6.052A2.99 2.99 0 0 0 11 8a2.99 2.99 0 0 0-.812-2.052c.215-.18.432-.346.647-.487C11.34 5.131 11.732 5 12 5a3 3 0 1 1 0 6c-.268 0-.66-.13-1.165-.461a6.833 6.833 0 0 1-.647-.487zm-3.56.617a3.001 3.001 0 0 0 2.744 0c.507.446 1.054.842 1.598 1.084.02.091.03.174.03.247a3 3 0 1 1-6 0c0-.073.01-.155.03-.247.544-.242 1.091-.638 1.598-1.084zm-.816-4.721A2.99 2.99 0 0 0 5 8c0 .794.308 1.516.812 2.052a6.83 6.83 0 0 1-.647.487C4.66 10.869 4.268 11 4 11a3 3 0 0 1 0-6c.268 0 .66.13 1.165.461.215.141.432.306.647.487zM8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>');// eslint-disable-next-line
var BIconFlower3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Flower3','<path d="M11.424 8c.437-.052.811-.136 1.04-.268a2 2 0 0 0-2-3.464c-.229.132-.489.414-.752.767C9.886 4.63 10 4.264 10 4a2 2 0 1 0-4 0c0 .264.114.63.288 1.035-.263-.353-.523-.635-.752-.767a2 2 0 0 0-2 3.464c.229.132.603.216 1.04.268-.437.052-.811.136-1.04.268a2 2 0 1 0 2 3.464c.229-.132.489-.414.752-.767C6.114 11.37 6 11.736 6 12a2 2 0 1 0 4 0c0-.264-.114-.63-.288-1.035.263.353.523.635.752.767a2 2 0 1 0 2-3.464c-.229-.132-.603-.216-1.04-.268zM9 4a1.468 1.468 0 0 1-.045.205c-.039.132-.1.295-.183.484a12.88 12.88 0 0 1-.637 1.223L8 6.142a21.73 21.73 0 0 1-.135-.23 12.88 12.88 0 0 1-.637-1.223 4.216 4.216 0 0 1-.183-.484A1.473 1.473 0 0 1 7 4a1 1 0 1 1 2 0zM3.67 5.5a1 1 0 0 1 1.366-.366 1.472 1.472 0 0 1 .156.142c.094.1.204.233.326.4.245.333.502.747.742 1.163l.13.232a21.86 21.86 0 0 1-.265.002 12.88 12.88 0 0 1-1.379-.06 4.214 4.214 0 0 1-.51-.083 1.47 1.47 0 0 1-.2-.064A1 1 0 0 1 3.67 5.5zm1.366 5.366a1 1 0 0 1-1-1.732c.001 0 .016-.008.047-.02.037-.013.087-.028.153-.044.134-.032.305-.06.51-.083a12.88 12.88 0 0 1 1.379-.06c.09 0 .178 0 .266.002a21.82 21.82 0 0 1-.131.232c-.24.416-.497.83-.742 1.163a4.1 4.1 0 0 1-.327.4 1.483 1.483 0 0 1-.155.142zM9 12a1 1 0 0 1-2 0 1.476 1.476 0 0 1 .045-.206c.039-.131.1-.294.183-.483.166-.378.396-.808.637-1.223L8 9.858l.135.23c.241.415.47.845.637 1.223.083.19.144.352.183.484A1.338 1.338 0 0 1 9 12zm3.33-6.5a1 1 0 0 1-.366 1.366 1.478 1.478 0 0 1-.2.064c-.134.032-.305.06-.51.083-.412.045-.898.061-1.379.06-.09 0-.178 0-.266-.002l.131-.232c.24-.416.497-.83.742-1.163a4.1 4.1 0 0 1 .327-.4c.046-.05.085-.086.114-.11.026-.022.04-.03.041-.032a1 1 0 0 1 1.366.366zm-1.366 5.366a1.494 1.494 0 0 1-.155-.141 4.225 4.225 0 0 1-.327-.4A12.88 12.88 0 0 1 9.74 9.16a22 22 0 0 1-.13-.232l.265-.002c.48-.001.967.015 1.379.06.205.023.376.051.51.083.066.016.116.031.153.044l.048.02a1 1 0 1 1-1 1.732zM8 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>');// eslint-disable-next-line
var BIconFolder=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Folder','<path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4H2.19zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/>');// eslint-disable-next-line
var BIconFolder2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Folder2','<path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5v-9zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V7z"/>');// eslint-disable-next-line
var BIconFolder2Open=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Folder2Open','<path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14V3.5zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5V6zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7H1.633z"/>');// eslint-disable-next-line
var BIconFolderCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FolderCheck','<path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"/><path d="M15.854 10.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .707-.708l1.146 1.147 2.646-2.647a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconFolderFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FolderFill','<path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/>');// eslint-disable-next-line
var BIconFolderMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FolderMinus','<path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"/><path d="M11 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconFolderPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FolderPlus','<path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"/><path d="M13.5 10a.5.5 0 0 1 .5.5V12h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V13h-1.5a.5.5 0 0 1 0-1H13v-1.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconFolderSymlink=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FolderSymlink','<path d="m11.798 8.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z"/><path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm.694 2.09A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09l-.636 7a1 1 0 0 1-.996.91H2.826a1 1 0 0 1-.995-.91l-.637-7zM6.172 2a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z"/>');// eslint-disable-next-line
var BIconFolderSymlinkFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FolderSymlinkFill','<path d="M13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2l.04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14h10.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 13.81 3zM2.19 3c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672a1 1 0 0 1 .707.293L7.586 3H2.19zm9.608 5.271-3.182 1.97c-.27.166-.616-.036-.616-.372V9.1s-2.571-.3-4 2.4c.571-4.8 3.143-4.8 4-4.8v-.769c0-.336.346-.538.616-.371l3.182 1.969c.27.166.27.576 0 .742z"/>');// eslint-disable-next-line
var BIconFolderX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FolderX','<path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181L15.546 8H14.54l.265-2.91A1 1 0 0 0 13.81 4H2.19a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91H9v1H2.826a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31zm6.339-1.577A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707z"/><path d="M11.854 10.146a.5.5 0 0 0-.707.708L12.293 12l-1.146 1.146a.5.5 0 0 0 .707.708L13 12.707l1.146 1.147a.5.5 0 0 0 .708-.708L13.707 12l1.147-1.146a.5.5 0 0 0-.707-.708L13 11.293l-1.146-1.147z"/>');// eslint-disable-next-line
var BIconFonts=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Fonts','<path d="M12.258 3h-8.51l-.083 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.431.013c1.934.062 2.434.301 2.693 1.846h.479L12.258 3z"/>');// eslint-disable-next-line
var BIconForward=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Forward','<path d="M9.502 5.513a.144.144 0 0 0-.202.134V6.65a.5.5 0 0 1-.5.5H2.5v2.9h6.3a.5.5 0 0 1 .5.5v1.003c0 .108.11.176.202.134l3.984-2.933a.51.51 0 0 1 .042-.028.147.147 0 0 0 0-.252.51.51 0 0 1-.042-.028L9.502 5.513zM8.3 5.647a1.144 1.144 0 0 1 1.767-.96l3.994 2.94a1.147 1.147 0 0 1 0 1.946l-3.994 2.94a1.144 1.144 0 0 1-1.767-.96v-.503H2a.5.5 0 0 1-.5-.5v-3.9a.5.5 0 0 1 .5-.5h6.3v-.503z"/>');// eslint-disable-next-line
var BIconForwardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ForwardFill','<path d="m9.77 12.11 4.012-2.953a.647.647 0 0 0 0-1.114L9.771 5.09a.644.644 0 0 0-.971.557V6.65H2v3.9h6.8v1.003c0 .505.545.808.97.557z"/>');// eslint-disable-next-line
var BIconFront=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Front','<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5z"/>');// eslint-disable-next-line
var BIconFullscreen=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Fullscreen','<path d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconFullscreenExit=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FullscreenExit','<path d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zm10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4z"/>');// eslint-disable-next-line
var BIconFunnel=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Funnel','<path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"/>');// eslint-disable-next-line
var BIconFunnelFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('FunnelFill','<path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>');// eslint-disable-next-line
var BIconGear=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Gear','<path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/><path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>');// eslint-disable-next-line
var BIconGearFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GearFill','<path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>');// eslint-disable-next-line
var BIconGearWide=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GearWide','<path d="M8.932.727c-.243-.97-1.62-.97-1.864 0l-.071.286a.96.96 0 0 1-1.622.434l-.205-.211c-.695-.719-1.888-.03-1.613.931l.08.284a.96.96 0 0 1-1.186 1.187l-.284-.081c-.96-.275-1.65.918-.931 1.613l.211.205a.96.96 0 0 1-.434 1.622l-.286.071c-.97.243-.97 1.62 0 1.864l.286.071a.96.96 0 0 1 .434 1.622l-.211.205c-.719.695-.03 1.888.931 1.613l.284-.08a.96.96 0 0 1 1.187 1.187l-.081.283c-.275.96.918 1.65 1.613.931l.205-.211a.96.96 0 0 1 1.622.434l.071.286c.243.97 1.62.97 1.864 0l.071-.286a.96.96 0 0 1 1.622-.434l.205.211c.695.719 1.888.03 1.613-.931l-.08-.284a.96.96 0 0 1 1.187-1.187l.283.081c.96.275 1.65-.918.931-1.613l-.211-.205a.96.96 0 0 1 .434-1.622l.286-.071c.97-.243.97-1.62 0-1.864l-.286-.071a.96.96 0 0 1-.434-1.622l.211-.205c.719-.695.03-1.888-.931-1.613l-.284.08a.96.96 0 0 1-1.187-1.186l.081-.284c.275-.96-.918-1.65-1.613-.931l-.205.211a.96.96 0 0 1-1.622-.434L8.932.727zM8 12.997a4.998 4.998 0 1 1 0-9.995 4.998 4.998 0 0 1 0 9.996z"/>');// eslint-disable-next-line
var BIconGearWideConnected=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GearWideConnected','<path d="M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434l.071-.286zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5zm0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78h4.723zM5.048 3.967c-.03.021-.058.043-.087.065l.087-.065zm-.431.355A4.984 4.984 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8 4.617 4.322zm.344 7.646.087.065-.087-.065z"/>');// eslint-disable-next-line
var BIconGem=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Gem','<path d="M3.1.7a.5.5 0 0 1 .4-.2h9a.5.5 0 0 1 .4.2l2.976 3.974c.149.185.156.45.01.644L8.4 15.3a.5.5 0 0 1-.8 0L.1 5.3a.5.5 0 0 1 0-.6l3-4zm11.386 3.785-1.806-2.41-.776 2.413 2.582-.003zm-3.633.004.961-2.989H4.186l.963 2.995 5.704-.006zM5.47 5.495 8 13.366l2.532-7.876-5.062.005zm-1.371-.999-.78-2.422-1.818 2.425 2.598-.003zM1.499 5.5l5.113 6.817-2.192-6.82L1.5 5.5zm7.889 6.817 5.123-6.83-2.928.002-2.195 6.828z"/>');// eslint-disable-next-line
var BIconGenderAmbiguous=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GenderAmbiguous','<path fill-rule="evenodd" d="M11.5 1a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-3.45 3.45A4 4 0 0 1 8.5 10.97V13H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V14H6a.5.5 0 0 1 0-1h1.5v-2.03a4 4 0 1 1 3.471-6.648L14.293 1H11.5zm-.997 4.346a3 3 0 1 0-5.006 3.309 3 3 0 0 0 5.006-3.31z"/>');// eslint-disable-next-line
var BIconGenderFemale=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GenderFemale','<path fill-rule="evenodd" d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5z"/>');// eslint-disable-next-line
var BIconGenderMale=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GenderMale','<path fill-rule="evenodd" d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2H9.5zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/>');// eslint-disable-next-line
var BIconGenderTrans=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GenderTrans','<path fill-rule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1.707L3.5 2.793l.646-.647a.5.5 0 1 1 .708.708l-.647.646.822.822A3.99 3.99 0 0 1 8 3c1.18 0 2.239.51 2.971 1.322L14.293 1H11.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-3.45 3.45A4 4 0 0 1 8.5 10.97V13H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V14H6a.5.5 0 0 1 0-1h1.5v-2.03a4 4 0 0 1-3.05-5.814l-.95-.949-.646.647a.5.5 0 1 1-.708-.708l.647-.646L1 1.707V3.5a.5.5 0 0 1-1 0v-3zm5.49 4.856a3 3 0 1 0 5.02 3.288 3 3 0 0 0-5.02-3.288z"/>');// eslint-disable-next-line
var BIconGeo=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Geo','<path fill-rule="evenodd" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/>');// eslint-disable-next-line
var BIconGeoAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GeoAlt','<path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"/><path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>');// eslint-disable-next-line
var BIconGeoAltFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GeoAltFill','<path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>');// eslint-disable-next-line
var BIconGeoFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GeoFill','<path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.319 1.319 0 0 0-.37.265.301.301 0 0 0-.057.09V14l.002.008a.147.147 0 0 0 .016.033.617.617 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.619.619 0 0 0 .146-.15.148.148 0 0 0 .015-.033L12 14v-.004a.301.301 0 0 0-.057-.09 1.318 1.318 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465-1.281 0-2.462-.172-3.34-.465-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411z"/>');// eslint-disable-next-line
var BIconGift=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Gift','<path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zM1 4v2h6V4H1zm8 0v2h6V4H9zm5 3H9v8h4.5a.5.5 0 0 0 .5-.5V7zm-7 8V7H2v7.5a.5.5 0 0 0 .5.5H7z"/>');// eslint-disable-next-line
var BIconGiftFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GiftFill','<path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7h6zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9H2.5z"/>');// eslint-disable-next-line
var BIconGithub=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Github','<path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z"/>');// eslint-disable-next-line
var BIconGlobe=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Globe','<path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"/>');// eslint-disable-next-line
var BIconGlobe2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Globe2','<path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 0 1 7.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.963 6.963 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"/>');// eslint-disable-next-line
var BIconGoogle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Google','<path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"/>');// eslint-disable-next-line
var BIconGraphDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GraphDown','<path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0zm10 11.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v2.6l-3.613-4.417a.5.5 0 0 0-.74-.037L7.06 8.233 3.404 3.206a.5.5 0 0 0-.808.588l4 5.5a.5.5 0 0 0 .758.06l2.609-2.61L13.445 11H10.5a.5.5 0 0 0-.5.5z"/>');// eslint-disable-next-line
var BIconGraphUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GraphUp','<path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconGrid=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid','<path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"/>');// eslint-disable-next-line
var BIconGrid1x2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid1x2','<path d="M6 1H1v14h5V1zm9 0h-5v5h5V1zm0 9v5h-5v-5h5zM0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V1zm1 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-5z"/>');// eslint-disable-next-line
var BIconGrid1x2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid1x2Fill','<path d="M0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V1zm0 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5z"/>');// eslint-disable-next-line
var BIconGrid3x2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid3x2','<path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5v-8zM1.5 3a.5.5 0 0 0-.5.5V7h4V3H1.5zM5 8H1v3.5a.5.5 0 0 0 .5.5H5V8zm1 0v4h4V8H6zm4-1V3H6v4h4zm1 1v4h3.5a.5.5 0 0 0 .5-.5V8h-4zm0-1h4V3.5a.5.5 0 0 0-.5-.5H11v4z"/>');// eslint-disable-next-line
var BIconGrid3x2Gap=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid3x2Gap','<path d="M4 4v2H2V4h2zm1 7V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 5V9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 4v2H7V4h2zm5 0h-2v2h2V4zM4 9v2H2V9h2zm5 0v2H7V9h2zm5 0v2h-2V9h2zm-3-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-2z"/>');// eslint-disable-next-line
var BIconGrid3x2GapFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid3x2GapFill','<path d="M1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9z"/>');// eslint-disable-next-line
var BIconGrid3x3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid3x3','<path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13zM1.5 1a.5.5 0 0 0-.5.5V5h4V1H1.5zM5 6H1v4h4V6zm1 4h4V6H6v4zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5v-4zm1 0v4h4v-4H6zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11h-4zm0-1h4V6h-4v4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11v4zm-1 0V1H6v4h4z"/>');// eslint-disable-next-line
var BIconGrid3x3Gap=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid3x3Gap','<path d="M4 2v2H2V2h2zm1 12v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 10v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 2v2H7V2h2zm5 0v2h-2V2h2zM4 7v2H2V7h2zm5 0v2H7V7h2zm5 0h-2v2h2V7zM4 12v2H2v-2h2zm5 0v2H7v-2h2zm5 0v2h-2v-2h2zM12 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2z"/>');// eslint-disable-next-line
var BIconGrid3x3GapFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Grid3x3GapFill','<path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"/>');// eslint-disable-next-line
var BIconGridFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GridFill','<path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"/>');// eslint-disable-next-line
var BIconGripHorizontal=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GripHorizontal','<path d="M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconGripVertical=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('GripVertical','<path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconHammer=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Hammer','<path d="M9.972 2.508a.5.5 0 0 0-.16-.556l-.178-.129a5.009 5.009 0 0 0-2.076-.783C6.215.862 4.504 1.229 2.84 3.133H1.786a.5.5 0 0 0-.354.147L.146 4.567a.5.5 0 0 0 0 .706l2.571 2.579a.5.5 0 0 0 .708 0l1.286-1.29a.5.5 0 0 0 .146-.353V5.57l8.387 8.873A.5.5 0 0 0 14 14.5l1.5-1.5a.5.5 0 0 0 .017-.689l-9.129-8.63c.747-.456 1.772-.839 3.112-.839a.5.5 0 0 0 .472-.334z"/>');// eslint-disable-next-line
var BIconHandIndex=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandIndex','<path d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 1 0 1 0V6.435a4.9 4.9 0 0 1 .106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 0 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.035a.5.5 0 0 1-.416-.223l-1.433-2.15a1.5 1.5 0 0 1-.243-.666l-.345-3.105a.5.5 0 0 1 .399-.546L5 8.11V9a.5.5 0 0 0 1 0V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v5.34l-1.2.24a1.5 1.5 0 0 0-1.196 1.636l.345 3.106a2.5 2.5 0 0 0 .405 1.11l1.433 2.15A1.5 1.5 0 0 0 6.035 16h6.385a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002zm2.094 2.025z"/>');// eslint-disable-next-line
var BIconHandIndexFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandIndexFill','<path d="M8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v5.34l-1.2.24a1.5 1.5 0 0 0-1.196 1.636l.345 3.106a2.5 2.5 0 0 0 .405 1.11l1.433 2.15A1.5 1.5 0 0 0 6.035 16h6.385a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002z"/>');// eslint-disable-next-line
var BIconHandIndexThumb=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandIndexThumb','<path d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002zm2.094 2.025z"/>');// eslint-disable-next-line
var BIconHandIndexThumbFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandIndexThumbFill','<path d="M8.5 1.75v2.716l.047-.002c.312-.012.742-.016 1.051.046.28.056.543.18.738.288.273.152.456.385.56.642l.132-.012c.312-.024.794-.038 1.158.108.37.148.689.487.88.716.075.09.141.175.195.248h.582a2 2 0 0 1 1.99 2.199l-.272 2.715a3.5 3.5 0 0 1-.444 1.389l-1.395 2.441A1.5 1.5 0 0 1 12.42 16H6.118a1.5 1.5 0 0 1-1.342-.83l-1.215-2.43L1.07 8.589a1.517 1.517 0 0 1 2.373-1.852L5 8.293V1.75a1.75 1.75 0 0 1 3.5 0z"/>');// eslint-disable-next-line
var BIconHandThumbsDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandThumbsDown','<path d="M8.864 15.674c-.956.24-1.843-.484-1.908-1.42-.072-1.05-.23-2.015-.428-2.59-.125-.36-.479-1.012-1.04-1.638-.557-.624-1.282-1.179-2.131-1.41C2.685 8.432 2 7.85 2 7V3c0-.845.682-1.464 1.448-1.546 1.07-.113 1.564-.415 2.068-.723l.048-.029c.272-.166.578-.349.97-.484C6.931.08 7.395 0 8 0h3.5c.937 0 1.599.478 1.934 1.064.164.287.254.607.254.913 0 .152-.023.312-.077.464.201.262.38.577.488.9.11.33.172.762.004 1.15.069.13.12.268.159.403.077.27.113.567.113.856 0 .289-.036.586-.113.856-.035.12-.08.244-.138.363.394.571.418 1.2.234 1.733-.206.592-.682 1.1-1.2 1.272-.847.283-1.803.276-2.516.211a9.877 9.877 0 0 1-.443-.05 9.364 9.364 0 0 1-.062 4.51c-.138.508-.55.848-1.012.964l-.261.065zM11.5 1H8c-.51 0-.863.068-1.14.163-.281.097-.506.229-.776.393l-.04.025c-.555.338-1.198.73-2.49.868-.333.035-.554.29-.554.55V7c0 .255.226.543.62.65 1.095.3 1.977.997 2.614 1.709.635.71 1.064 1.475 1.238 1.977.243.7.407 1.768.482 2.85.025.362.36.595.667.518l.262-.065c.16-.04.258-.144.288-.255a8.34 8.34 0 0 0-.145-4.726.5.5 0 0 1 .595-.643h.003l.014.004.058.013a8.912 8.912 0 0 0 1.036.157c.663.06 1.457.054 2.11-.163.175-.059.45-.301.57-.651.107-.308.087-.67-.266-1.021L12.793 7l.353-.354c.043-.042.105-.14.154-.315.048-.167.075-.37.075-.581 0-.211-.027-.414-.075-.581-.05-.174-.111-.273-.154-.315l-.353-.354.353-.354c.047-.047.109-.176.005-.488a2.224 2.224 0 0 0-.505-.804l-.353-.354.353-.354c.006-.005.041-.05.041-.17a.866.866 0 0 0-.121-.415C12.4 1.272 12.063 1 11.5 1z"/>');// eslint-disable-next-line
var BIconHandThumbsDownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandThumbsDownFill','<path d="M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.378 1.378 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51.136.02.285.037.443.051.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.896 1.896 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2.094 2.094 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.162 3.162 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.823 4.823 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591z"/>');// eslint-disable-next-line
var BIconHandThumbsUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandThumbsUp','<path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z"/>');// eslint-disable-next-line
var BIconHandThumbsUpFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandThumbsUpFill','<path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a9.84 9.84 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733.058.119.103.242.138.363.077.27.113.567.113.856 0 .289-.036.586-.113.856-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.163 3.163 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.82 4.82 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z"/>');// eslint-disable-next-line
var BIconHandbag=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Handbag','<path d="M8 1a2 2 0 0 1 2 2v2H6V3a2 2 0 0 1 2-2zm3 4V3a3 3 0 1 0-6 0v2H3.36a1.5 1.5 0 0 0-1.483 1.277L.85 13.13A2.5 2.5 0 0 0 3.322 16h9.355a2.5 2.5 0 0 0 2.473-2.87l-1.028-6.853A1.5 1.5 0 0 0 12.64 5H11zm-1 1v1.5a.5.5 0 0 0 1 0V6h1.639a.5.5 0 0 1 .494.426l1.028 6.851A1.5 1.5 0 0 1 12.678 15H3.322a1.5 1.5 0 0 1-1.483-1.723l1.028-6.851A.5.5 0 0 1 3.36 6H5v1.5a.5.5 0 1 0 1 0V6h4z"/>');// eslint-disable-next-line
var BIconHandbagFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HandbagFill','<path d="M8 1a2 2 0 0 0-2 2v2H5V3a3 3 0 1 1 6 0v2h-1V3a2 2 0 0 0-2-2zM5 5H3.36a1.5 1.5 0 0 0-1.483 1.277L.85 13.13A2.5 2.5 0 0 0 3.322 16h9.355a2.5 2.5 0 0 0 2.473-2.87l-1.028-6.853A1.5 1.5 0 0 0 12.64 5H11v1.5a.5.5 0 0 1-1 0V5H6v1.5a.5.5 0 0 1-1 0V5z"/>');// eslint-disable-next-line
var BIconHash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Hash','<path d="M8.39 12.648a1.32 1.32 0 0 0-.015.18c0 .305.21.508.5.508.266 0 .492-.172.555-.477l.554-2.703h1.204c.421 0 .617-.234.617-.547 0-.312-.188-.53-.617-.53h-.985l.516-2.524h1.265c.43 0 .618-.227.618-.547 0-.313-.188-.524-.618-.524h-1.046l.476-2.304a1.06 1.06 0 0 0 .016-.164.51.51 0 0 0-.516-.516.54.54 0 0 0-.539.43l-.523 2.554H7.617l.477-2.304c.008-.04.015-.118.015-.164a.512.512 0 0 0-.523-.516.539.539 0 0 0-.531.43L6.53 5.484H5.414c-.43 0-.617.22-.617.532 0 .312.187.539.617.539h.906l-.515 2.523H4.609c-.421 0-.609.219-.609.531 0 .313.188.547.61.547h.976l-.516 2.492c-.008.04-.015.125-.015.18 0 .305.21.508.5.508.265 0 .492-.172.554-.477l.555-2.703h2.242l-.515 2.492zm-1-6.109h2.266l-.515 2.563H6.859l.532-2.563z"/>');// eslint-disable-next-line
var BIconHdd=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Hdd','<path d="M4.5 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM3 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M16 11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9.51c0-.418.105-.83.305-1.197l2.472-4.531A1.5 1.5 0 0 1 4.094 3h7.812a1.5 1.5 0 0 1 1.317.782l2.472 4.53c.2.368.305.78.305 1.198V11zM3.655 4.26 1.592 8.043C1.724 8.014 1.86 8 2 8h12c.14 0 .276.014.408.042L12.345 4.26a.5.5 0 0 0-.439-.26H4.094a.5.5 0 0 0-.44.26zM1 10v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z"/>');// eslint-disable-next-line
var BIconHddFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HddFill','<path d="M0 10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2 0a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM.91 7.204A2.993 2.993 0 0 1 2 7h12c.384 0 .752.072 1.09.204l-1.867-3.422A1.5 1.5 0 0 0 11.906 3H4.094a1.5 1.5 0 0 0-1.317.782L.91 7.204z"/>');// eslint-disable-next-line
var BIconHddNetwork=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HddNetwork','<path d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2V4zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1zm6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5z"/>');// eslint-disable-next-line
var BIconHddNetworkFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HddNetworkFill','<path d="M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h5.5v3A1.5 1.5 0 0 0 6 11.5H.5a.5.5 0 0 0 0 1H6A1.5 1.5 0 0 0 7.5 14h1a1.5 1.5 0 0 0 1.5-1.5h5.5a.5.5 0 0 0 0-1H10A1.5 1.5 0 0 0 8.5 10V7H14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"/>');// eslint-disable-next-line
var BIconHddRack=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HddRack','<path d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/><path d="M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v2H2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-1V7h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm0 7v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-3-4v2H4V7h8z"/>');// eslint-disable-next-line
var BIconHddRackFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HddRackFill','<path d="M2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1v2H2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-1V7h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm-2 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM12 7v2H4V7h8z"/>');// eslint-disable-next-line
var BIconHddStack=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HddStack','<path d="M14 10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12zM2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2z"/><path d="M5 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM14 3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path d="M5 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconHddStackFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HddStackFill','<path d="M2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"/>');// eslint-disable-next-line
var BIconHeadphones=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Headphones','<path d="M8 3a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1V8a5 5 0 0 0-5-5z"/>');// eslint-disable-next-line
var BIconHeadset=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Headset','<path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"/>');// eslint-disable-next-line
var BIconHeadsetVr=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HeadsetVr','<path d="M8 1.248c1.857 0 3.526.641 4.65 1.794a4.978 4.978 0 0 1 2.518 1.09C13.907 1.482 11.295 0 8 0 4.75 0 2.12 1.48.844 4.122a4.979 4.979 0 0 1 2.289-1.047C4.236 1.872 5.974 1.248 8 1.248z"/><path d="M12 12a3.988 3.988 0 0 1-2.786-1.13l-.002-.002a1.612 1.612 0 0 0-.276-.167A2.164 2.164 0 0 0 8 10.5c-.414 0-.729.103-.935.201a1.612 1.612 0 0 0-.277.167l-.002.002A4 4 0 1 1 4 4h8a4 4 0 0 1 0 8z"/>');// eslint-disable-next-line
var BIconHeart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Heart','<path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>');// eslint-disable-next-line
var BIconHeartFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HeartFill','<path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>');// eslint-disable-next-line
var BIconHeartHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HeartHalf','<path d="M8 2.748v11.047c3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>');// eslint-disable-next-line
var BIconHeptagon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Heptagon','<path d="M7.779.052a.5.5 0 0 1 .442 0l6.015 2.97a.5.5 0 0 1 .267.34l1.485 6.676a.5.5 0 0 1-.093.415l-4.162 5.354a.5.5 0 0 1-.395.193H4.662a.5.5 0 0 1-.395-.193L.105 10.453a.5.5 0 0 1-.093-.415l1.485-6.676a.5.5 0 0 1 .267-.34L7.779.053zM2.422 3.813l-1.383 6.212L4.907 15h6.186l3.868-4.975-1.383-6.212L8 1.058 2.422 3.813z"/>');// eslint-disable-next-line
var BIconHeptagonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HeptagonFill','<path fill-rule="evenodd" d="M7.779.052a.5.5 0 0 1 .442 0l6.015 2.97a.5.5 0 0 1 .267.34l1.485 6.676a.5.5 0 0 1-.093.415l-4.162 5.354a.5.5 0 0 1-.395.193H4.662a.5.5 0 0 1-.395-.193L.105 10.453a.5.5 0 0 1-.093-.415l1.485-6.676a.5.5 0 0 1 .267-.34L7.779.053z"/>');// eslint-disable-next-line
var BIconHeptagonHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HeptagonHalf','<path d="M7.779.052a.5.5 0 0 1 .442 0l6.015 2.97a.5.5 0 0 1 .267.34l1.485 6.676a.5.5 0 0 1-.093.415l-4.162 5.354a.5.5 0 0 1-.395.193H4.662a.5.5 0 0 1-.395-.193L.105 10.453a.5.5 0 0 1-.093-.415l1.485-6.676a.5.5 0 0 1 .267-.34L7.779.053zM8 15h3.093l3.868-4.975-1.383-6.212L8 1.058V15z"/>');// eslint-disable-next-line
var BIconHexagon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Hexagon','<path d="M14 4.577v6.846L8 15l-6-3.577V4.577L8 1l6 3.577zM8.5.134a1 1 0 0 0-1 0l-6 3.577a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866l6 3.577a1 1 0 0 0 1 0l6-3.577a1 1 0 0 0 .5-.866V4.577a1 1 0 0 0-.5-.866L8.5.134z"/>');// eslint-disable-next-line
var BIconHexagonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HexagonFill','<path fill-rule="evenodd" d="M8.5.134a1 1 0 0 0-1 0l-6 3.577a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866l6 3.577a1 1 0 0 0 1 0l6-3.577a1 1 0 0 0 .5-.866V4.577a1 1 0 0 0-.5-.866L8.5.134z"/>');// eslint-disable-next-line
var BIconHexagonHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HexagonHalf','<path d="M14 4.577v6.846L8 15V1l6 3.577zM8.5.134a1 1 0 0 0-1 0l-6 3.577a1 1 0 0 0-.5.866v6.846a1 1 0 0 0 .5.866l6 3.577a1 1 0 0 0 1 0l6-3.577a1 1 0 0 0 .5-.866V4.577a1 1 0 0 0-.5-.866L8.5.134z"/>');// eslint-disable-next-line
var BIconHourglass=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Hourglass','<path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702c0 .7-.478 1.235-1.011 1.491A3.5 3.5 0 0 0 4.5 13v1h7v-1a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351v-.702c0-.7.478-1.235 1.011-1.491A3.5 3.5 0 0 0 11.5 3V2h-7z"/>');// eslint-disable-next-line
var BIconHourglassBottom=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HourglassBottom','<path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702s.18.149.5.149.5-.15.5-.15v-.7c0-.701.478-1.236 1.011-1.492A3.5 3.5 0 0 0 11.5 3V2h-7z"/>');// eslint-disable-next-line
var BIconHourglassSplit=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HourglassSplit','<path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>');// eslint-disable-next-line
var BIconHourglassTop=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HourglassTop','<path d="M2 14.5a.5.5 0 0 0 .5.5h11a.5.5 0 1 0 0-1h-1v-1a4.5 4.5 0 0 0-2.557-4.06c-.29-.139-.443-.377-.443-.59v-.7c0-.213.154-.451.443-.59A4.5 4.5 0 0 0 12.5 3V2h1a.5.5 0 0 0 0-1h-11a.5.5 0 0 0 0 1h1v1a4.5 4.5 0 0 0 2.557 4.06c.29.139.443.377.443.59v.7c0 .213-.154.451-.443.59A4.5 4.5 0 0 0 3.5 13v1h-1a.5.5 0 0 0-.5.5zm2.5-.5v-1a3.5 3.5 0 0 1 1.989-3.158c.533-.256 1.011-.79 1.011-1.491v-.702s.18.101.5.101.5-.1.5-.1v.7c0 .701.478 1.236 1.011 1.492A3.5 3.5 0 0 1 11.5 13v1h-7z"/>');// eslint-disable-next-line
var BIconHouse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('House','<path fill-rule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/><path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>');// eslint-disable-next-line
var BIconHouseDoor=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HouseDoor','<path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z"/>');// eslint-disable-next-line
var BIconHouseDoorFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HouseDoorFill','<path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5z"/>');// eslint-disable-next-line
var BIconHouseFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('HouseFill','<path fill-rule="evenodd" d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/><path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>');// eslint-disable-next-line
var BIconHr=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Hr','<path d="M12 3H4a1 1 0 0 0-1 1v2.5H2V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2.5h-1V4a1 1 0 0 0-1-1zM2 9.5h1V12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9.5h1V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5zm-1.5-2a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H.5z"/>');// eslint-disable-next-line
var BIconHurricane=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Hurricane','<path d="M6.999 2.6A5.5 5.5 0 0 1 15 7.5a.5.5 0 0 0 1 0 6.5 6.5 0 1 0-13 0 5 5 0 0 0 6.001 4.9A5.5 5.5 0 0 1 1 7.5a.5.5 0 0 0-1 0 6.5 6.5 0 1 0 13 0 5 5 0 0 0-6.001-4.9zM10 7.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>');// eslint-disable-next-line
var BIconImage=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Image','<path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>');// eslint-disable-next-line
var BIconImageAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ImageAlt','<path d="M7 2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm4.225 4.053a.5.5 0 0 0-.577.093l-3.71 4.71-2.66-2.772a.5.5 0 0 0-.63.062L.002 13v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4.5l-4.777-3.947z"/>');// eslint-disable-next-line
var BIconImageFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ImageFill','<path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>');// eslint-disable-next-line
var BIconImages=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Images','<path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z"/>');// eslint-disable-next-line
var BIconInbox=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Inbox','<path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm9.954 5H10.45a2.5 2.5 0 0 1-4.9 0H1.066l.32 2.562a.5.5 0 0 0 .497.438h12.234a.5.5 0 0 0 .496-.438L14.933 9zM3.809 3.563A1.5 1.5 0 0 1 4.981 3h6.038a1.5 1.5 0 0 1 1.172.563l3.7 4.625a.5.5 0 0 1 .105.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z"/>');// eslint-disable-next-line
var BIconInboxFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InboxFill','<path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm-1.17-.437A1.5 1.5 0 0 1 4.98 3h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z"/>');// eslint-disable-next-line
var BIconInboxes=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Inboxes','<path d="M4.98 1a.5.5 0 0 0-.39.188L1.54 5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0A.5.5 0 0 1 10 5h4.46l-3.05-3.812A.5.5 0 0 0 11.02 1H4.98zm9.954 5H10.45a2.5 2.5 0 0 1-4.9 0H1.066l.32 2.562A.5.5 0 0 0 1.884 9h12.234a.5.5 0 0 0 .496-.438L14.933 6zM3.809.563A1.5 1.5 0 0 1 4.981 0h6.038a1.5 1.5 0 0 1 1.172.563l3.7 4.625a.5.5 0 0 1 .105.374l-.39 3.124A1.5 1.5 0 0 1 14.117 10H1.883A1.5 1.5 0 0 1 .394 8.686l-.39-3.124a.5.5 0 0 1 .106-.374L3.81.563zM.125 11.17A.5.5 0 0 1 .5 11H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 16H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .121-.393zm.941.83.32 2.562a.5.5 0 0 0 .497.438h12.234a.5.5 0 0 0 .496-.438l.32-2.562H10.45a2.5 2.5 0 0 1-4.9 0H1.066z"/>');// eslint-disable-next-line
var BIconInboxesFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InboxesFill','<path d="M4.98 1a.5.5 0 0 0-.39.188L1.54 5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0A.5.5 0 0 1 10 5h4.46l-3.05-3.812A.5.5 0 0 0 11.02 1H4.98zM3.81.563A1.5 1.5 0 0 1 4.98 0h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 10H1.883A1.5 1.5 0 0 1 .394 8.686l-.39-3.124a.5.5 0 0 1 .106-.374L3.81.563zM.125 11.17A.5.5 0 0 1 .5 11H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 16H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .121-.393z"/>');// eslint-disable-next-line
var BIconInfo=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Info','<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconInfoCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InfoCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconInfoCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InfoCircleFill','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>');// eslint-disable-next-line
var BIconInfoLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InfoLg','<path d="m10.277 5.433-4.031.505-.145.67.794.145c.516.123.619.309.505.824L6.101 13.68c-.34 1.578.186 2.32 1.423 2.32.959 0 2.072-.443 2.577-1.052l.155-.732c-.35.31-.866.434-1.206.434-.485 0-.66-.34-.536-.939l1.763-8.278zm.122-3.673a1.76 1.76 0 1 1-3.52 0 1.76 1.76 0 0 1 3.52 0z"/>');// eslint-disable-next-line
var BIconInfoSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InfoSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconInfoSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InfoSquareFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconInputCursor=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InputCursor','<path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/><path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"/>');// eslint-disable-next-line
var BIconInputCursorText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('InputCursorText','<path fill-rule="evenodd" d="M5 2a.5.5 0 0 1 .5-.5c.862 0 1.573.287 2.06.566.174.099.321.198.44.286.119-.088.266-.187.44-.286A4.165 4.165 0 0 1 10.5 1.5a.5.5 0 0 1 0 1c-.638 0-1.177.213-1.564.434a3.49 3.49 0 0 0-.436.294V7.5H9a.5.5 0 0 1 0 1h-.5v4.272c.1.08.248.187.436.294.387.221.926.434 1.564.434a.5.5 0 0 1 0 1 4.165 4.165 0 0 1-2.06-.566A4.561 4.561 0 0 1 8 13.65a4.561 4.561 0 0 1-.44.285 4.165 4.165 0 0 1-2.06.566.5.5 0 0 1 0-1c.638 0 1.177-.213 1.564-.434.188-.107.335-.214.436-.294V8.5H7a.5.5 0 0 1 0-1h.5V3.228a3.49 3.49 0 0 0-.436-.294A3.166 3.166 0 0 0 5.5 2.5.5.5 0 0 1 5 2z"/><path d="M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z"/>');// eslint-disable-next-line
var BIconInstagram=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Instagram','<path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/>');// eslint-disable-next-line
var BIconIntersect=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Intersect','<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm5 10v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2v5a2 2 0 0 1-2 2H5zm6-8V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2V6a2 2 0 0 1 2-2h5z"/>');// eslint-disable-next-line
var BIconJournal=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Journal','<path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalAlbum=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalAlbum','<path d="M5.5 4a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5zm1 7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalArrowDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalArrowDown','<path fill-rule="evenodd" d="M8 5a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5A.5.5 0 0 1 8 5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalArrowUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalArrowUp','<path fill-rule="evenodd" d="M8 11a.5.5 0 0 0 .5-.5V6.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 6.707V10.5a.5.5 0 0 0 .5.5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalBookmark=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalBookmark','<path fill-rule="evenodd" d="M6 8V1h1v6.117L8.743 6.07a.5.5 0 0 1 .514 0L11 7.117V1h1v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalBookmarkFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalBookmarkFill','<path fill-rule="evenodd" d="M6 1h6v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8V1z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalCheck','<path fill-rule="evenodd" d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalCode=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalCode','<path fill-rule="evenodd" d="M8.646 5.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 0 1 0-.708zm-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 8l1.647-1.646a.5.5 0 0 0 0-.708z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalMedical=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalMedical','<path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v.634l.549-.317a.5.5 0 1 1 .5.866L9 6l.549.317a.5.5 0 1 1-.5.866L8.5 6.866V7.5a.5.5 0 0 1-1 0v-.634l-.549.317a.5.5 0 1 1-.5-.866L7 6l-.549-.317a.5.5 0 0 1 .5-.866l.549.317V4.5A.5.5 0 0 1 8 4zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalMinus','<path fill-rule="evenodd" d="M5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalPlus','<path fill-rule="evenodd" d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalRichtext=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalRichtext','<path d="M7.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047L11 4.75V7a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 7v-.5s1.54-1.274 1.639-1.208zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalText=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalText','<path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournalX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JournalX','<path fill-rule="evenodd" d="M6.146 6.146a.5.5 0 0 1 .708 0L8 7.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 8l1.147 1.146a.5.5 0 0 1-.708.708L8 8.707 6.854 9.854a.5.5 0 0 1-.708-.708L7.293 8 6.146 6.854a.5.5 0 0 1 0-.708z"/><path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/><path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>');// eslint-disable-next-line
var BIconJournals=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Journals','<path d="M5 0h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2 2 2 0 0 1-2 2H3a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1H1a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1H3a2 2 0 0 1 2-2z"/><path d="M1 6v-.5a.5.5 0 0 1 1 0V6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V9h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 2.5v.5H.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H2v-.5a.5.5 0 0 0-1 0z"/>');// eslint-disable-next-line
var BIconJoystick=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Joystick','<path d="M10 2a2 2 0 0 1-1.5 1.937v5.087c.863.083 1.5.377 1.5.726 0 .414-.895.75-2 .75s-2-.336-2-.75c0-.35.637-.643 1.5-.726V3.937A2 2 0 1 1 10 2z"/><path d="M0 9.665v1.717a1 1 0 0 0 .553.894l6.553 3.277a2 2 0 0 0 1.788 0l6.553-3.277a1 1 0 0 0 .553-.894V9.665c0-.1-.06-.19-.152-.23L9.5 6.715v.993l5.227 2.178a.125.125 0 0 1 .001.23l-5.94 2.546a2 2 0 0 1-1.576 0l-5.94-2.546a.125.125 0 0 1 .001-.23L6.5 7.708l-.013-.988L.152 9.435a.25.25 0 0 0-.152.23z"/>');// eslint-disable-next-line
var BIconJustify=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Justify','<path fill-rule="evenodd" d="M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconJustifyLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JustifyLeft','<path fill-rule="evenodd" d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconJustifyRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('JustifyRight','<path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconKanban=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Kanban','<path d="M13.5 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h11zm-11-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11z"/><path d="M6.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm-4 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm8 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3z"/>');// eslint-disable-next-line
var BIconKanbanFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('KanbanFill','<path d="M2.5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11zm5 2h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-5 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm9-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconKey=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Key','<path d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z"/><path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconKeyFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('KeyFill','<path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconKeyboard=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Keyboard','<path d="M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12zM2 4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2z"/><path d="M13 10.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm0-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5 0A.25.25 0 0 1 8.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 8 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.5zm1 2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5-2A.25.25 0 0 1 6.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 8.75v-.5zm-2 0A.25.25 0 0 1 4.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 4 8.75v-.5zm-2 0A.25.25 0 0 1 2.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 8.75v-.5zm11-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0A.25.25 0 0 1 9.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 9 6.75v-.5zm-2 0A.25.25 0 0 1 7.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 7 6.75v-.5zm-2 0A.25.25 0 0 1 5.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 5 6.75v-.5zm-3 0A.25.25 0 0 1 2.25 6h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 2 6.75v-.5zm0 4a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm2 0a.25.25 0 0 1 .25-.25h5.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-5.5a.25.25 0 0 1-.25-.25v-.5z"/>');// eslint-disable-next-line
var BIconKeyboardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('KeyboardFill','<path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm13 .25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM2.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 8.75v-.5A.25.25 0 0 0 2.75 8h-.5zM4 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 5 8.75v-.5A.25.25 0 0 0 4.75 8h-.5a.25.25 0 0 0-.25.25zM6.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 7 8.75v-.5A.25.25 0 0 0 6.75 8h-.5zM8 8.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 9 8.75v-.5A.25.25 0 0 0 8.75 8h-.5a.25.25 0 0 0-.25.25zM13.25 8a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zm-3-2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-1.5zm.75 2.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM11.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5zM9 6.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5A.25.25 0 0 0 9.75 6h-.5a.25.25 0 0 0-.25.25zM7.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 8 6.75v-.5A.25.25 0 0 0 7.75 6h-.5zM5 6.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 6 6.75v-.5A.25.25 0 0 0 5.75 6h-.5a.25.25 0 0 0-.25.25zM2.25 6a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 4 6.75v-.5A.25.25 0 0 0 3.75 6h-1.5zM2 10.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25zM4.25 10a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h5.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-5.5z"/>');// eslint-disable-next-line
var BIconLadder=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Ladder','<path d="M4.5 1a.5.5 0 0 1 .5.5V2h6v-.5a.5.5 0 0 1 1 0v14a.5.5 0 0 1-1 0V15H5v.5a.5.5 0 0 1-1 0v-14a.5.5 0 0 1 .5-.5zM5 14h6v-2H5v2zm0-3h6V9H5v2zm0-3h6V6H5v2zm0-3h6V3H5v2z"/>');// eslint-disable-next-line
var BIconLamp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Lamp','<path d="M13 3v4H3V3h10zM3 2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm4.5-1 .276-.553a.25.25 0 0 1 .448 0L8.5 1h-1zm-.012 9h1.024c.337.646.677 1.33.95 1.949.176.396.318.75.413 1.042.048.146.081.266.102.36A1.347 1.347 0 0 1 10 13.5c0 .665-.717 1.5-2 1.5s-2-.835-2-1.5c0 0 0-.013.004-.039.003-.027.01-.063.02-.11.02-.094.053-.214.1-.36.096-.291.238-.646.413-1.042.274-.62.614-1.303.95-1.949zm1.627-1h-2.23C6.032 10.595 5 12.69 5 13.5 5 14.88 6.343 16 8 16s3-1.12 3-2.5c0-.81-1.032-2.905-1.885-4.5z"/>');// eslint-disable-next-line
var BIconLampFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LampFill','<path d="M2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3zm5.5-2 .276-.553a.25.25 0 0 1 .448 0L8.5 1h-1zm-.615 8h2.23C9.968 10.595 11 12.69 11 13.5c0 1.38-1.343 2.5-3 2.5s-3-1.12-3-2.5c0-.81 1.032-2.905 1.885-4.5z"/>');// eslint-disable-next-line
var BIconLaptop=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Laptop','<path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>');// eslint-disable-next-line
var BIconLaptopFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LaptopFill','<path d="M2.5 2A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>');// eslint-disable-next-line
var BIconLayerBackward=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayerBackward','<path d="M8.354 15.854a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708l1-1a.5.5 0 0 1 .708 0l.646.647V4H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9v7.793l.646-.647a.5.5 0 0 1 .708 0l1 1a.5.5 0 0 1 0 .708l-3 3z"/><path d="M1 9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4.5a.5.5 0 0 1 0 1H1v2h4.5a.5.5 0 0 1 0 1H1zm9.5 0a.5.5 0 0 1 0-1H15V6h-4.5a.5.5 0 0 1 0-1H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4.5z"/>');// eslint-disable-next-line
var BIconLayerForward=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayerForward','<path d="M8.354.146a.5.5 0 0 0-.708 0l-3 3a.5.5 0 0 0 0 .708l1 1a.5.5 0 0 0 .708 0L7 4.207V12H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H9V4.207l.646.647a.5.5 0 0 0 .708 0l1-1a.5.5 0 0 0 0-.708l-3-3z"/><path d="M1 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4.5a.5.5 0 0 0 0-1H1V8h4.5a.5.5 0 0 0 0-1H1zm9.5 0a.5.5 0 0 0 0 1H15v2h-4.5a.5.5 0 0 0 0 1H15a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4.5z"/>');// eslint-disable-next-line
var BIconLayers=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Layers','<path d="M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882l-7.5-4zm3.515 7.008L14.438 10 8 13.433 1.562 10 4.25 8.567l3.515 1.874a.5.5 0 0 0 .47 0l3.515-1.874zM8 9.433 1.562 6 8 2.567 14.438 6 8 9.433z"/>');// eslint-disable-next-line
var BIconLayersFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayersFill','<path d="M7.765 1.559a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882l7.5-4z"/><path d="m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0l-5.17-2.756z"/>');// eslint-disable-next-line
var BIconLayersHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayersHalf','<path d="M8.235 1.559a.5.5 0 0 0-.47 0l-7.5 4a.5.5 0 0 0 0 .882L3.188 8 .264 9.559a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882L12.813 8l2.922-1.559a.5.5 0 0 0 0-.882l-7.5-4zM8 9.433 1.562 6 8 2.567 14.438 6 8 9.433z"/>');// eslint-disable-next-line
var BIconLayoutSidebar=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutSidebar','<path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm5-1v12h9a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H5zM4 2H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2V2z"/>');// eslint-disable-next-line
var BIconLayoutSidebarInset=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutSidebarInset','<path d="M14 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12zM2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2z"/><path d="M3 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>');// eslint-disable-next-line
var BIconLayoutSidebarInsetReverse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutSidebarInsetReverse','<path d="M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12z"/><path d="M13 4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconLayoutSidebarReverse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutSidebarReverse','<path d="M16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3zm-5-1v12H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9zm1 0h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2V2z"/>');// eslint-disable-next-line
var BIconLayoutSplit=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutSplit','<path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm8.5-1v12H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8.5zm-1 0H2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5.5V2z"/>');// eslint-disable-next-line
var BIconLayoutTextSidebar=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutTextSidebar','<path d="M3.5 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM3 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/><path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm12-1v14h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 0H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9V1z"/>');// eslint-disable-next-line
var BIconLayoutTextSidebarReverse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutTextSidebarReverse','<path d="M12.5 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm.5 3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"/><path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2zM4 1v14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2zm1 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5V1z"/>');// eslint-disable-next-line
var BIconLayoutTextWindow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutTextWindow','<path d="M3 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/><path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v1H1V2a1 1 0 0 1 1-1h12zm1 3v10a1 1 0 0 1-1 1h-2V4h3zm-4 0v11H2a1 1 0 0 1-1-1V4h10z"/>');// eslint-disable-next-line
var BIconLayoutTextWindowReverse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutTextWindowReverse','<path d="M13 6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm0 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"/><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM2 1a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1H2zM1 4v10a1 1 0 0 0 1 1h2V4H1zm4 0v11h9a1 1 0 0 0 1-1V4H5z"/>');// eslint-disable-next-line
var BIconLayoutThreeColumns=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutThreeColumns','<path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13zM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H5V1H1.5zM10 15V1H6v14h4zm1 0h3.5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H11v14z"/>');// eslint-disable-next-line
var BIconLayoutWtf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LayoutWtf','<path d="M5 1v8H1V1h4zM1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm13 2v5H9V2h5zM9 1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9zM5 13v2H3v-2h2zm-2-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3zm12-1v2H9v-2h6zm-6-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H9z"/>');// eslint-disable-next-line
var BIconLifePreserver=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LifePreserver','<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm6.43-5.228a7.025 7.025 0 0 1-3.658 3.658l-1.115-2.788a4.015 4.015 0 0 0 1.985-1.985l2.788 1.115zM5.228 14.43a7.025 7.025 0 0 1-3.658-3.658l2.788-1.115a4.015 4.015 0 0 0 1.985 1.985L5.228 14.43zm9.202-9.202-2.788 1.115a4.015 4.015 0 0 0-1.985-1.985l1.115-2.788a7.025 7.025 0 0 1 3.658 3.658zm-8.087-.87a4.015 4.015 0 0 0-1.985 1.985L1.57 5.228A7.025 7.025 0 0 1 5.228 1.57l1.115 2.788zM8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>');// eslint-disable-next-line
var BIconLightbulb=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Lightbulb','<path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z"/>');// eslint-disable-next-line
var BIconLightbulbFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LightbulbFill','<path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconLightbulbOff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LightbulbOff','<path fill-rule="evenodd" d="M2.23 4.35A6.004 6.004 0 0 0 2 6c0 1.691.7 3.22 1.826 4.31.203.196.359.4.453.619l.762 1.769A.5.5 0 0 0 5.5 13a.5.5 0 0 0 0 1 .5.5 0 0 0 0 1l.224.447a1 1 0 0 0 .894.553h2.764a1 1 0 0 0 .894-.553L10.5 15a.5.5 0 0 0 0-1 .5.5 0 0 0 0-1 .5.5 0 0 0 .288-.091L9.878 12H5.83l-.632-1.467a2.954 2.954 0 0 0-.676-.941 4.984 4.984 0 0 1-1.455-4.405l-.837-.836zm1.588-2.653.708.707a5 5 0 0 1 7.07 7.07l.707.707a6 6 0 0 0-8.484-8.484zm-2.172-.051a.5.5 0 0 1 .708 0l12 12a.5.5 0 0 1-.708.708l-12-12a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconLightbulbOffFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LightbulbOffFill','<path d="M2 6c0-.572.08-1.125.23-1.65l8.558 8.559A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm10.303 4.181L3.818 1.697a6 6 0 0 1 8.484 8.484zM5 14.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5zM2.354 1.646a.5.5 0 1 0-.708.708l12 12a.5.5 0 0 0 .708-.708l-12-12z"/>');// eslint-disable-next-line
var BIconLightning=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Lightning','<path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5zM6.374 1 4.168 8.5H7.5a.5.5 0 0 1 .478.647L6.78 13.04 11.478 7H8a.5.5 0 0 1-.474-.658L9.306 1H6.374z"/>');// eslint-disable-next-line
var BIconLightningCharge=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LightningCharge','<path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09zM4.157 8.5H7a.5.5 0 0 1 .478.647L6.11 13.59l5.732-6.09H9a.5.5 0 0 1-.478-.647L9.89 2.41 4.157 8.5z"/>');// eslint-disable-next-line
var BIconLightningChargeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LightningChargeFill','<path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z"/>');// eslint-disable-next-line
var BIconLightningFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LightningFill','<path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641l2.5-8.5z"/>');// eslint-disable-next-line
var BIconLink=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Link','<path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"/><path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z"/>');// eslint-disable-next-line
var BIconLink45deg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Link45deg','<path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/><path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>');// eslint-disable-next-line
var BIconLinkedin=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Linkedin','<path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>');// eslint-disable-next-line
var BIconList=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('List','<path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconListCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ListCheck','<path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0zm0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconListNested=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ListNested','<path fill-rule="evenodd" d="M4.5 11.5A.5.5 0 0 1 5 11h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-2-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm-2-4A.5.5 0 0 1 1 3h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconListOl=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ListOl','<path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"/><path d="M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 0 1-.492.594v.033a.615.615 0 0 1 .569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 0 0-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z"/>');// eslint-disable-next-line
var BIconListStars=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ListStars','<path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"/><path d="M2.242 2.194a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.256-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53zm0 4a.27.27 0 0 1 .516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 0 0-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 0 0-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 0 0-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 0 0 .259-.194l.162-.53z"/>');// eslint-disable-next-line
var BIconListTask=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ListTask','<path fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2zM3 3H2v1h1V3z"/><path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z"/><path fill-rule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V7zM2 7h1v1H2V7zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H2zm1 .5H2v1h1v-1z"/>');// eslint-disable-next-line
var BIconListUl=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ListUl','<path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconLock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Lock','<path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconLockFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('LockFill','<path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>');// eslint-disable-next-line
var BIconMailbox=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mailbox','<path d="M4 4a3 3 0 0 0-3 3v6h6V7a3 3 0 0 0-3-3zm0-1h8a4 4 0 0 1 4 4v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a4 4 0 0 1 4-4zm2.646 1A3.99 3.99 0 0 1 8 7v6h7V7a3 3 0 0 0-3-3H6.646z"/><path d="M11.793 8.5H9v-1h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.354-.146l-.853-.854zM5 7c0 .552-.448 0-1 0s-1 .552-1 0a1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconMailbox2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mailbox2','<path d="M9 8.5h2.793l.853.854A.5.5 0 0 0 13 9.5h1a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H9v1z"/><path d="M12 3H4a4 4 0 0 0-4 4v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a4 4 0 0 0-4-4zM8 7a3.99 3.99 0 0 0-1.354-3H12a3 3 0 0 1 3 3v6H8V7zm-3.415.157C4.42 7.087 4.218 7 4 7c-.218 0-.42.086-.585.157C3.164 7.264 3 7.334 3 7a1 1 0 0 1 2 0c0 .334-.164.264-.415.157z"/>');// eslint-disable-next-line
var BIconMap=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Map','<path fill-rule="evenodd" d="M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.502.502 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103zM10 1.91l-4-.8v12.98l4 .8V1.91zm1 12.98 4-.8V1.11l-4 .8v12.98zm-6-.8V1.11l-4 .8v12.98l4-.8z"/>');// eslint-disable-next-line
var BIconMapFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MapFill','<path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.598-.49L10.5.99 5.598.01a.5.5 0 0 0-.196 0l-5 1A.5.5 0 0 0 0 1.5v14a.5.5 0 0 0 .598.49l4.902-.98 4.902.98a.502.502 0 0 0 .196 0l5-1A.5.5 0 0 0 16 14.5V.5zM5 14.09V1.11l.5-.1.5.1v12.98l-.402-.08a.498.498 0 0 0-.196 0L5 14.09zm5 .8V1.91l.402.08a.5.5 0 0 0 .196 0L11 1.91v12.98l-.5.1-.5-.1z"/>');// eslint-disable-next-line
var BIconMarkdown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Markdown','<path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/><path fill-rule="evenodd" d="M9.146 8.146a.5.5 0 0 1 .708 0L11.5 9.793l1.646-1.647a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 0-.708z"/><path fill-rule="evenodd" d="M11.5 5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5z"/><path d="M3.56 11V7.01h.056l1.428 3.239h.774l1.42-3.24h.056V11h1.073V5.001h-1.2l-1.71 3.894h-.039l-1.71-3.894H2.5V11h1.06z"/>');// eslint-disable-next-line
var BIconMarkdownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MarkdownFill','<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm11.5 1a.5.5 0 0 0-.5.5v3.793L9.854 8.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L12 9.293V5.5a.5.5 0 0 0-.5-.5zM3.56 7.01h.056l1.428 3.239h.774l1.42-3.24h.056V11h1.073V5.001h-1.2l-1.71 3.894h-.039l-1.71-3.894H2.5V11h1.06V7.01z"/>');// eslint-disable-next-line
var BIconMask=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mask','<path d="M6.225 1.227A7.5 7.5 0 0 1 10.5 8a7.5 7.5 0 0 1-4.275 6.773 7 7 0 1 0 0-13.546zM4.187.966a8 8 0 1 1 7.627 14.069A8 8 0 0 1 4.186.964z"/>');// eslint-disable-next-line
var BIconMastodon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mastodon','<path d="M11.19 12.195c2.016-.24 3.77-1.475 3.99-2.603.348-1.778.32-4.339.32-4.339 0-3.47-2.286-4.488-2.286-4.488C12.062.238 10.083.017 8.027 0h-.05C5.92.017 3.942.238 2.79.765c0 0-2.285 1.017-2.285 4.488l-.002.662c-.004.64-.007 1.35.011 2.091.083 3.394.626 6.74 3.78 7.57 1.454.383 2.703.463 3.709.408 1.823-.1 2.847-.647 2.847-.647l-.06-1.317s-1.303.41-2.767.36c-1.45-.05-2.98-.156-3.215-1.928a3.614 3.614 0 0 1-.033-.496s1.424.346 3.228.428c1.103.05 2.137-.064 3.188-.189zm1.613-2.47H11.13v-4.08c0-.859-.364-1.295-1.091-1.295-.804 0-1.207.517-1.207 1.541v2.233H7.168V5.89c0-1.024-.403-1.541-1.207-1.541-.727 0-1.091.436-1.091 1.296v4.079H3.197V5.522c0-.859.22-1.541.66-2.046.456-.505 1.052-.764 1.793-.764.856 0 1.504.328 1.933.983L8 4.39l.417-.695c.429-.655 1.077-.983 1.934-.983.74 0 1.336.259 1.791.764.442.505.661 1.187.661 2.046v4.203z"/>');// eslint-disable-next-line
var BIconMegaphone=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Megaphone','<path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49a68.14 68.14 0 0 0-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 74.663 74.663 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199V2.5zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0zm-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233c.18.01.359.022.537.036 2.568.189 5.093.744 7.463 1.993V3.85zm-9 6.215v-4.13a95.09 95.09 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A60.49 60.49 0 0 1 4 10.065zm-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68.019 68.019 0 0 0-1.722-.082z"/>');// eslint-disable-next-line
var BIconMegaphoneFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MegaphoneFill','<path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"/>');// eslint-disable-next-line
var BIconMenuApp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuApp','<path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h2A1.5 1.5 0 0 1 5 1.5v2A1.5 1.5 0 0 1 3.5 5h-2A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMenuAppFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuAppFill','<path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h2A1.5 1.5 0 0 1 5 1.5v2A1.5 1.5 0 0 1 3.5 5h-2A1.5 1.5 0 0 1 0 3.5v-2zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMenuButton=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuButton','<path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h8A1.5 1.5 0 0 1 11 1.5v2A1.5 1.5 0 0 1 9.5 5h-8A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-8z"/><path d="m7.823 2.823-.396-.396A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMenuButtonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuButtonFill','<path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h8A1.5 1.5 0 0 0 11 3.5v-2A1.5 1.5 0 0 0 9.5 0h-8zm5.927 2.427A.25.25 0 0 1 7.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMenuButtonWide=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuButtonWide','<path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v2A1.5 1.5 0 0 1 14.5 5h-13A1.5 1.5 0 0 1 0 3.5v-2zM1.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-13z"/><path d="M2 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm10.823.323-.396-.396A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMenuButtonWideFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuButtonWideFill','<path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zm9.927.427A.25.25 0 0 1 12.604 2h.792a.25.25 0 0 1 .177.427l-.396.396a.25.25 0 0 1-.354 0l-.396-.396zM0 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8zm1 3v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H1zm14-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2h14zM2 8.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMenuDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuDown','<path d="M7.646.146a.5.5 0 0 1 .708 0L10.207 2H14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3.793L7.646.146zM1 7v3h14V7H1zm14-1V4a1 1 0 0 0-1-1h-3.793a1 1 0 0 1-.707-.293L8 1.207l-1.5 1.5A1 1 0 0 1 5.793 3H2a1 1 0 0 0-1 1v2h14zm0 5H1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2zM2 4.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMenuUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MenuUp','<path d="M7.646 15.854a.5.5 0 0 0 .708 0L10.207 14H14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3.793l1.853 1.854zM1 9V6h14v3H1zm14 1v2a1 1 0 0 1-1 1h-3.793a1 1 0 0 0-.707.293l-1.5 1.5-1.5-1.5A1 1 0 0 0 5.793 13H2a1 1 0 0 1-1-1v-2h14zm0-5H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2zM2 11.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 0-1h-8a.5.5 0 0 0-.5.5zm0-4a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11a.5.5 0 0 0-.5.5zm0-4a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5z"/>');// eslint-disable-next-line
var BIconMessenger=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Messenger','<path d="M0 7.76C0 3.301 3.493 0 8 0s8 3.301 8 7.76-3.493 7.76-8 7.76c-.81 0-1.586-.107-2.316-.307a.639.639 0 0 0-.427.03l-1.588.702a.64.64 0 0 1-.898-.566l-.044-1.423a.639.639 0 0 0-.215-.456C.956 12.108 0 10.092 0 7.76zm5.546-1.459-2.35 3.728c-.225.358.214.761.551.506l2.525-1.916a.48.48 0 0 1 .578-.002l1.869 1.402a1.2 1.2 0 0 0 1.735-.32l2.35-3.728c.226-.358-.214-.761-.551-.506L9.728 7.381a.48.48 0 0 1-.578.002L7.281 5.98a1.2 1.2 0 0 0-1.735.32z"/>');// eslint-disable-next-line
var BIconMic=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mic','<path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/><path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0v5zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3z"/>');// eslint-disable-next-line
var BIconMicFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MicFill','<path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z"/><path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconMicMute=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MicMute','<path d="M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879l-1-1V3a2 2 0 0 0-3.997-.118l-.845-.845A3.001 3.001 0 0 1 11 3z"/><path d="m9.486 10.607-.748-.748A2 2 0 0 1 6 8v-.878l-1-1V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z"/>');// eslint-disable-next-line
var BIconMicMuteFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MicMuteFill','<path d="M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z"/><path d="M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z"/>');// eslint-disable-next-line
var BIconMinecart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Minecart','<path d="M4 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm8-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM.115 3.18A.5.5 0 0 1 .5 3h15a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 14 12H2a.5.5 0 0 1-.491-.408l-1.5-8a.5.5 0 0 1 .106-.411zm.987.82 1.313 7h11.17l1.313-7H1.102z"/>');// eslint-disable-next-line
var BIconMinecartLoaded=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MinecartLoaded','<path d="M4 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm8-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM.115 3.18A.5.5 0 0 1 .5 3h15a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 14 12H2a.5.5 0 0 1-.491-.408l-1.5-8a.5.5 0 0 1 .106-.411zm.987.82 1.313 7h11.17l1.313-7H1.102z"/><path fill-rule="evenodd" d="M6 1a2.498 2.498 0 0 1 4 0c.818 0 1.545.394 2 1 .67 0 1.552.57 2 1h-2c-.314 0-.611-.15-.8-.4-.274-.365-.71-.6-1.2-.6-.314 0-.611-.15-.8-.4a1.497 1.497 0 0 0-2.4 0c-.189.25-.486.4-.8.4-.507 0-.955.251-1.228.638-.09.13-.194.25-.308.362H3c.13-.147.401-.432.562-.545a1.63 1.63 0 0 0 .393-.393A2.498 2.498 0 0 1 6 1z"/>');// eslint-disable-next-line
var BIconMoisture=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Moisture','<path d="M13.5 0a.5.5 0 0 0 0 1H15v2.75h-.5a.5.5 0 0 0 0 1h.5V7.5h-1.5a.5.5 0 0 0 0 1H15v2.75h-.5a.5.5 0 0 0 0 1h.5V15h-1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5h-2zM7 1.5l.364-.343a.5.5 0 0 0-.728 0l-.002.002-.006.007-.022.023-.08.088a28.458 28.458 0 0 0-1.274 1.517c-.769.983-1.714 2.325-2.385 3.727C2.368 7.564 2 8.682 2 9.733 2 12.614 4.212 15 7 15s5-2.386 5-5.267c0-1.05-.368-2.169-.867-3.212-.671-1.402-1.616-2.744-2.385-3.727a28.458 28.458 0 0 0-1.354-1.605l-.022-.023-.006-.007-.002-.001L7 1.5zm0 0-.364-.343L7 1.5zm-.016.766L7 2.247l.016.019c.24.274.572.667.944 1.144.611.781 1.32 1.776 1.901 2.827H4.14c.58-1.051 1.29-2.046 1.9-2.827.373-.477.706-.87.945-1.144zM3 9.733c0-.755.244-1.612.638-2.496h6.724c.395.884.638 1.741.638 2.496C11 12.117 9.182 14 7 14s-4-1.883-4-4.267z"/>');// eslint-disable-next-line
var BIconMoon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Moon','<path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"/>');// eslint-disable-next-line
var BIconMoonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MoonFill','<path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/>');// eslint-disable-next-line
var BIconMoonStars=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MoonStars','<path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z"/><path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"/>');// eslint-disable-next-line
var BIconMoonStarsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MoonStarsFill','<path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"/><path d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"/>');// eslint-disable-next-line
var BIconMouse=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mouse','<path d="M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3zm4 8a4 4 0 0 1-8 0V5a4 4 0 1 1 8 0v6zM8 0a5 5 0 0 0-5 5v6a5 5 0 0 0 10 0V5a5 5 0 0 0-5-5z"/>');// eslint-disable-next-line
var BIconMouse2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mouse2','<path d="M3 5.188C3 2.341 5.22 0 8 0s5 2.342 5 5.188v5.625C13 13.658 10.78 16 8 16s-5-2.342-5-5.188V5.189zm4.5-4.155C5.541 1.289 4 3.035 4 5.188V5.5h3.5V1.033zm1 0V5.5H12v-.313c0-2.152-1.541-3.898-3.5-4.154zM12 6.5H4v4.313C4 13.145 5.81 15 8 15s4-1.855 4-4.188V6.5z"/>');// eslint-disable-next-line
var BIconMouse2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mouse2Fill','<path d="M7.5.026C4.958.286 3 2.515 3 5.188V5.5h4.5V.026zm1 0V5.5H13v-.312C13 2.515 11.042.286 8.5.026zM13 6.5H3v4.313C3 13.658 5.22 16 8 16s5-2.342 5-5.188V6.5z"/>');// eslint-disable-next-line
var BIconMouse3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mouse3','<path d="M7 0c-.593 0-1.104.157-1.527.463-.418.302-.717.726-.93 1.208C4.123 2.619 4 3.879 4 5.187v.504L3.382 6A2.5 2.5 0 0 0 2 8.236v2.576C2 13.659 4.22 16 7 16h2c2.78 0 5-2.342 5-5.188V7.51a.71.71 0 0 0 0-.02V5.186c0-1.13-.272-2.044-.748-2.772-.474-.726-1.13-1.235-1.849-1.59C9.981.123 8.26 0 7 0zm2.5 6.099V1.232c.51.11 1.008.267 1.46.49.596.293 1.099.694 1.455 1.24.355.543.585 1.262.585 2.225v1.69l-3.5-.778zm-1-5.025v4.803L5 5.099c.006-1.242.134-2.293.457-3.024.162-.366.363-.63.602-.801C6.292 1.105 6.593 1 7 1c.468 0 .98.018 1.5.074zM5 6.124 13 7.9v2.912C13 13.145 11.19 15 9 15H7c-2.19 0-4-1.855-4-4.188V8.236a1.5 1.5 0 0 1 .83-1.342l.187-.093c.01.265.024.58.047.92.062.938.19 2.12.462 2.937a.5.5 0 1 0 .948-.316c-.227-.683-.35-1.75-.413-2.688a29.17 29.17 0 0 1-.06-1.528v-.002z"/>');// eslint-disable-next-line
var BIconMouse3Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Mouse3Fill','<path d="M8.5.069A15.328 15.328 0 0 0 7 0c-.593 0-1.104.157-1.527.463-.418.302-.717.726-.93 1.208-.386.873-.522 2.01-.54 3.206l4.497 1V.069zM3.71 5.836 3.381 6A2.5 2.5 0 0 0 2 8.236v2.576C2 13.659 4.22 16 7 16h2c2.78 0 5-2.342 5-5.188V8.123l-9-2v.003l.008.353c.007.3.023.715.053 1.175.063.937.186 2.005.413 2.688a.5.5 0 1 1-.948.316c-.273-.817-.4-2-.462-2.937A30.16 30.16 0 0 1 4 6.003c0-.034.003-.067.01-.1l-.3-.067zM14 7.1V5.187c0-1.13-.272-2.044-.748-2.772-.474-.726-1.13-1.235-1.849-1.59A7.495 7.495 0 0 0 9.5.212v5.887l4.5 1z"/>');// eslint-disable-next-line
var BIconMouseFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MouseFill','<path d="M3 5a5 5 0 0 1 10 0v6a5 5 0 0 1-10 0V5zm5.5-1.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2z"/>');// eslint-disable-next-line
var BIconMusicNote=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MusicNote','<path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2z"/><path fill-rule="evenodd" d="M9 3v10H8V3h1z"/><path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5V2.82z"/>');// eslint-disable-next-line
var BIconMusicNoteBeamed=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MusicNoteBeamed','<path d="M6 13c0 1.105-1.12 2-2.5 2S1 14.105 1 13c0-1.104 1.12-2 2.5-2s2.5.896 2.5 2zm9-2c0 1.105-1.12 2-2.5 2s-2.5-.895-2.5-2 1.12-2 2.5-2 2.5.895 2.5 2z"/><path fill-rule="evenodd" d="M14 11V2h1v9h-1zM6 3v10H5V3h1z"/><path d="M5 2.905a1 1 0 0 1 .9-.995l8-.8a1 1 0 0 1 1.1.995V3L5 4V2.905z"/>');// eslint-disable-next-line
var BIconMusicNoteList=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MusicNoteList','<path d="M12 13c0 1.105-1.12 2-2.5 2S7 14.105 7 13s1.12-2 2.5-2 2.5.895 2.5 2z"/><path fill-rule="evenodd" d="M12 3v10h-1V3h1z"/><path d="M11 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 16 2.22V4l-5 1V2.82z"/><path fill-rule="evenodd" d="M0 11.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 7H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 3H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconMusicPlayer=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MusicPlayer','<path d="M4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3zm1 0v3h6V3H5zm3 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/><path d="M11 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4z"/>');// eslint-disable-next-line
var BIconMusicPlayerFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('MusicPlayerFill','<path d="M8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm1 2h6a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm3 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>');// eslint-disable-next-line
var BIconNewspaper=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Newspaper','<path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5v-11zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5H12z"/><path d="M2 3h10v2H2V3zm0 3h4v3H2V6zm0 4h4v1H2v-1zm0 2h4v1H2v-1zm5-6h2v1H7V6zm3 0h2v1h-2V6zM7 8h2v1H7V8zm3 0h2v1h-2V8zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1zm-3 2h2v1H7v-1zm3 0h2v1h-2v-1z"/>');// eslint-disable-next-line
var BIconNodeMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('NodeMinus','<path fill-rule="evenodd" d="M11 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM6.025 7.5a5 5 0 1 1 0 1H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025zM1.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1zM8 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 8 8z"/>');// eslint-disable-next-line
var BIconNodeMinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('NodeMinusFill','<path fill-rule="evenodd" d="M16 8a5 5 0 0 1-9.975.5H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025A5 5 0 0 1 16 8zm-2 0a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5A.5.5 0 0 0 14 8z"/>');// eslint-disable-next-line
var BIconNodePlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('NodePlus','<path fill-rule="evenodd" d="M11 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM6.025 7.5a5 5 0 1 1 0 1H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5h2.025zM11 5a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 11 5zM1.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1z"/>');// eslint-disable-next-line
var BIconNodePlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('NodePlusFill','<path d="M11 13a5 5 0 1 0-4.975-5.5H4A1.5 1.5 0 0 0 2.5 6h-1A1.5 1.5 0 0 0 0 7.5v1A1.5 1.5 0 0 0 1.5 10h1A1.5 1.5 0 0 0 4 8.5h2.025A5 5 0 0 0 11 13zm.5-7.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconNut=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Nut','<path d="m11.42 2 3.428 6-3.428 6H4.58L1.152 8 4.58 2h6.84zM4.58 1a1 1 0 0 0-.868.504l-3.428 6a1 1 0 0 0 0 .992l3.428 6A1 1 0 0 0 4.58 15h6.84a1 1 0 0 0 .868-.504l3.429-6a1 1 0 0 0 0-.992l-3.429-6A1 1 0 0 0 11.42 1H4.58z"/><path d="M6.848 5.933a2.5 2.5 0 1 0 2.5 4.33 2.5 2.5 0 0 0-2.5-4.33zm-1.78 3.915a3.5 3.5 0 1 1 6.061-3.5 3.5 3.5 0 0 1-6.062 3.5z"/>');// eslint-disable-next-line
var BIconNutFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('NutFill','<path d="M4.58 1a1 1 0 0 0-.868.504l-3.428 6a1 1 0 0 0 0 .992l3.428 6A1 1 0 0 0 4.58 15h6.84a1 1 0 0 0 .868-.504l3.429-6a1 1 0 0 0 0-.992l-3.429-6A1 1 0 0 0 11.42 1H4.58zm5.018 9.696a3 3 0 1 1-3-5.196 3 3 0 0 1 3 5.196z"/>');// eslint-disable-next-line
var BIconOctagon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Octagon','<path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"/>');// eslint-disable-next-line
var BIconOctagonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('OctagonFill','<path d="M11.107 0a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146A.5.5 0 0 1 4.893 0h6.214z"/>');// eslint-disable-next-line
var BIconOctagonHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('OctagonHalf','<path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM8 15h2.9l4.1-4.1V5.1L10.9 1H8v14z"/>');// eslint-disable-next-line
var BIconOption=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Option','<path d="M1 2.5a.5.5 0 0 1 .5-.5h3.797a.5.5 0 0 1 .439.26L11 13h3.5a.5.5 0 0 1 0 1h-3.797a.5.5 0 0 1-.439-.26L5 3H1.5a.5.5 0 0 1-.5-.5zm10 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconOutlet=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Outlet','<path d="M3.34 2.994c.275-.338.68-.494 1.074-.494h7.172c.393 0 .798.156 1.074.494.578.708 1.84 2.534 1.84 5.006 0 2.472-1.262 4.297-1.84 5.006-.276.338-.68.494-1.074.494H4.414c-.394 0-.799-.156-1.074-.494C2.762 12.297 1.5 10.472 1.5 8c0-2.472 1.262-4.297 1.84-5.006zm1.074.506a.376.376 0 0 0-.299.126C3.599 4.259 2.5 5.863 2.5 8c0 2.137 1.099 3.74 1.615 4.374.06.073.163.126.3.126h7.17c.137 0 .24-.053.3-.126.516-.633 1.615-2.237 1.615-4.374 0-2.137-1.099-3.74-1.615-4.374a.376.376 0 0 0-.3-.126h-7.17z"/><path d="M6 5.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zM7 10v1h2v-1a1 1 0 0 0-2 0z"/>');// eslint-disable-next-line
var BIconPaintBucket=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PaintBucket','<path d="M6.192 2.78c-.458-.677-.927-1.248-1.35-1.643a2.972 2.972 0 0 0-.71-.515c-.217-.104-.56-.205-.882-.02-.367.213-.427.63-.43.896-.003.304.064.664.173 1.044.196.687.556 1.528 1.035 2.402L.752 8.22c-.277.277-.269.656-.218.918.055.283.187.593.36.903.348.627.92 1.361 1.626 2.068.707.707 1.441 1.278 2.068 1.626.31.173.62.305.903.36.262.05.64.059.918-.218l5.615-5.615c.118.257.092.512.05.939-.03.292-.068.665-.073 1.176v.123h.003a1 1 0 0 0 1.993 0H14v-.057a1.01 1.01 0 0 0-.004-.117c-.055-1.25-.7-2.738-1.86-3.494a4.322 4.322 0 0 0-.211-.434c-.349-.626-.92-1.36-1.627-2.067-.707-.707-1.441-1.279-2.068-1.627-.31-.172-.62-.304-.903-.36-.262-.05-.64-.058-.918.219l-.217.216zM4.16 1.867c.381.356.844.922 1.311 1.632l-.704.705c-.382-.727-.66-1.402-.813-1.938a3.283 3.283 0 0 1-.131-.673c.091.061.204.15.337.274zm.394 3.965c.54.852 1.107 1.567 1.607 2.033a.5.5 0 1 0 .682-.732c-.453-.422-1.017-1.136-1.564-2.027l1.088-1.088c.054.12.115.243.183.365.349.627.92 1.361 1.627 2.068.706.707 1.44 1.278 2.068 1.626.122.068.244.13.365.183l-4.861 4.862a.571.571 0 0 1-.068-.01c-.137-.027-.342-.104-.608-.252-.524-.292-1.186-.8-1.846-1.46-.66-.66-1.168-1.32-1.46-1.846-.147-.265-.225-.47-.251-.607a.573.573 0 0 1-.01-.068l3.048-3.047zm2.87-1.935a2.44 2.44 0 0 1-.241-.561c.135.033.324.11.562.241.524.292 1.186.8 1.846 1.46.45.45.83.901 1.118 1.31a3.497 3.497 0 0 0-1.066.091 11.27 11.27 0 0 1-.76-.694c-.66-.66-1.167-1.322-1.458-1.847z"/>');// eslint-disable-next-line
var BIconPalette=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Palette','<path d="M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path d="M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z"/>');// eslint-disable-next-line
var BIconPalette2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Palette2','<path d="M0 .5A.5.5 0 0 1 .5 0h5a.5.5 0 0 1 .5.5v5.277l4.147-4.131a.5.5 0 0 1 .707 0l3.535 3.536a.5.5 0 0 1 0 .708L10.261 10H15.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H3a2.99 2.99 0 0 1-2.121-.879A2.99 2.99 0 0 1 0 13.044m6-.21 7.328-7.3-2.829-2.828L6 7.188v5.647zM4.5 13a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zM15 15v-4H9.258l-4.015 4H15zM0 .5v12.495V.5z"/><path d="M0 12.995V13a3.07 3.07 0 0 0 0-.005z"/>');// eslint-disable-next-line
var BIconPaletteFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PaletteFill','<path d="M12.433 10.07C14.133 10.585 16 11.15 16 8a8 8 0 1 0-8 8c1.996 0 1.826-1.504 1.649-3.08-.124-1.101-.252-2.237.351-2.92.465-.527 1.42-.237 2.433.07zM8 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconPaperclip=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Paperclip','<path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>');// eslint-disable-next-line
var BIconParagraph=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Paragraph','<path d="M10.5 15a.5.5 0 0 1-.5-.5V2H9v12.5a.5.5 0 0 1-1 0V9H7a4 4 0 1 1 0-8h5.5a.5.5 0 0 1 0 1H11v12.5a.5.5 0 0 1-.5.5z"/>');// eslint-disable-next-line
var BIconPatchCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchCheck','<path fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/>');// eslint-disable-next-line
var BIconPatchCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchCheckFill','<path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconPatchExclamation=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchExclamation','<path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"/><path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/>');// eslint-disable-next-line
var BIconPatchExclamationFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchExclamationFill','<path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>');// eslint-disable-next-line
var BIconPatchMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchMinus','<path fill-rule="evenodd" d="M5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/><path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/>');// eslint-disable-next-line
var BIconPatchMinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchMinusFill','<path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM6 7.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1z"/>');// eslint-disable-next-line
var BIconPatchPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchPlus','<path fill-rule="evenodd" d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"/><path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/>');// eslint-disable-next-line
var BIconPatchPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchPlusFill','<path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zM8.5 6v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconPatchQuestion=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchQuestion','<path d="M8.05 9.6c.336 0 .504-.24.554-.627.04-.534.198-.815.847-1.26.673-.475 1.049-1.09 1.049-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745z"/><path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/><path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"/>');// eslint-disable-next-line
var BIconPatchQuestionFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PatchQuestionFill','<path d="M5.933.87a2.89 2.89 0 0 1 4.134 0l.622.638.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636zM7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm1.602-2.027c.04-.534.198-.815.846-1.26.674-.475 1.05-1.09 1.05-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745.336 0 .504-.24.554-.627z"/>');// eslint-disable-next-line
var BIconPause=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Pause','<path d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconPauseBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PauseBtn','<path d="M6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconPauseBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PauseBtnFill','<path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.25-7C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"/>');// eslint-disable-next-line
var BIconPauseCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PauseCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z"/>');// eslint-disable-next-line
var BIconPauseCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PauseCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.25 5C5.56 5 5 5.56 5 6.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C7.5 5.56 6.94 5 6.25 5zm3.5 0c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 1 0 2.5 0v-3.5C11 5.56 10.44 5 9.75 5z"/>');// eslint-disable-next-line
var BIconPauseFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PauseFill','<path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>');// eslint-disable-next-line
var BIconPeace=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Peace','<path d="M7.5 1.018a7 7 0 0 0-4.79 11.566L7.5 7.793V1.018zm1 0v6.775l4.79 4.79A7 7 0 0 0 8.5 1.018zm4.084 12.273L8.5 9.207v5.775a6.97 6.97 0 0 0 4.084-1.691zM7.5 14.982V9.207l-4.084 4.084A6.97 6.97 0 0 0 7.5 14.982zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"/>');// eslint-disable-next-line
var BIconPeaceFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PeaceFill','<path d="M14 13.292A8 8 0 0 0 8.5.015v7.778l5.5 5.5zm-.708.708L8.5 9.206v6.778a7.967 7.967 0 0 0 4.792-1.986zM7.5 15.985V9.207L2.708 14A7.967 7.967 0 0 0 7.5 15.985zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5z"/>');// eslint-disable-next-line
var BIconPen=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Pen','<path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>');// eslint-disable-next-line
var BIconPenFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PenFill','<path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>');// eslint-disable-next-line
var BIconPencil=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Pencil','<path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>');// eslint-disable-next-line
var BIconPencilFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PencilFill','<path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>');// eslint-disable-next-line
var BIconPencilSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PencilSquare','<path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>');// eslint-disable-next-line
var BIconPentagon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Pentagon','<path d="m8 1.288 6.842 5.56L12.267 15H3.733L1.158 6.847 8 1.288zM16 6.5 8 0 0 6.5 3 16h10l3-9.5z"/>');// eslint-disable-next-line
var BIconPentagonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PentagonFill','<path d="m8 0 8 6.5-3 9.5H3L0 6.5 8 0z"/>');// eslint-disable-next-line
var BIconPentagonHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PentagonHalf','<path d="m8 1.288 6.842 5.56L12.267 15H8V1.288zM16 6.5 8 0 0 6.5 3 16h10l3-9.5z"/>');// eslint-disable-next-line
var BIconPeople=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('People','<path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>');// eslint-disable-next-line
var BIconPeopleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PeopleFill','<path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/><path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/><path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>');// eslint-disable-next-line
var BIconPercent=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Percent','<path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>');// eslint-disable-next-line
var BIconPerson=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Person','<path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>');// eslint-disable-next-line
var BIconPersonBadge=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonBadge','<path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0h-7zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492V2.5z"/>');// eslint-disable-next-line
var BIconPersonBadgeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonBadgeFill','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm4.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm5 2.755C12.146 12.825 10.623 12 8 12s-4.146.826-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z"/>');// eslint-disable-next-line
var BIconPersonBoundingBox=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonBoundingBox','<path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"/><path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>');// eslint-disable-next-line
var BIconPersonCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonCheck','<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconPersonCheckFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonCheckFill','<path fill-rule="evenodd" d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/><path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>');// eslint-disable-next-line
var BIconPersonCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonCircle','<path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>');// eslint-disable-next-line
var BIconPersonDash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonDash','<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M11 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconPersonDashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonDashFill','<path fill-rule="evenodd" d="M11 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"/><path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>');// eslint-disable-next-line
var BIconPersonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonFill','<path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>');// eslint-disable-next-line
var BIconPersonLinesFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonLinesFill','<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"/>');// eslint-disable-next-line
var BIconPersonPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonPlus','<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconPersonPlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonPlusFill','<path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/><path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconPersonSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonSquare','<path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1v-1c0-1-1-4-6-4s-6 3-6 4v1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12z"/>');// eslint-disable-next-line
var BIconPersonX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonX','<path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/><path fill-rule="evenodd" d="M12.146 5.146a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconPersonXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PersonXFill','<path fill-rule="evenodd" d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm6.146-2.854a.5.5 0 0 1 .708 0L14 6.293l1.146-1.147a.5.5 0 0 1 .708.708L14.707 7l1.147 1.146a.5.5 0 0 1-.708.708L14 7.707l-1.146 1.147a.5.5 0 0 1-.708-.708L13.293 7l-1.147-1.146a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconPhone=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Phone','<path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/><path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconPhoneFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PhoneFill','<path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"/>');// eslint-disable-next-line
var BIconPhoneLandscape=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PhoneLandscape','<path d="M1 4.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-6zm-1 6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v6z"/><path d="M14 7.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"/>');// eslint-disable-next-line
var BIconPhoneLandscapeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PhoneLandscapeFill','<path d="M2 12.5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2zm11-6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>');// eslint-disable-next-line
var BIconPhoneVibrate=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PhoneVibrate','<path d="M10 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4zM6 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6z"/><path d="M8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM1.599 4.058a.5.5 0 0 1 .208.676A6.967 6.967 0 0 0 1 8c0 1.18.292 2.292.807 3.266a.5.5 0 0 1-.884.468A7.968 7.968 0 0 1 0 8c0-1.347.334-2.619.923-3.734a.5.5 0 0 1 .676-.208zm12.802 0a.5.5 0 0 1 .676.208A7.967 7.967 0 0 1 16 8a7.967 7.967 0 0 1-.923 3.734.5.5 0 0 1-.884-.468A6.967 6.967 0 0 0 15 8c0-1.18-.292-2.292-.807-3.266a.5.5 0 0 1 .208-.676zM3.057 5.534a.5.5 0 0 1 .284.648A4.986 4.986 0 0 0 3 8c0 .642.12 1.255.34 1.818a.5.5 0 1 1-.93.364A5.986 5.986 0 0 1 2 8c0-.769.145-1.505.41-2.182a.5.5 0 0 1 .647-.284zm9.886 0a.5.5 0 0 1 .648.284C13.855 6.495 14 7.231 14 8c0 .769-.145 1.505-.41 2.182a.5.5 0 0 1-.93-.364C12.88 9.255 13 8.642 13 8c0-.642-.12-1.255-.34-1.818a.5.5 0 0 1 .283-.648z"/>');// eslint-disable-next-line
var BIconPhoneVibrateFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PhoneVibrateFill','<path d="M4 4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4zm5 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0zM1.807 4.734a.5.5 0 1 0-.884-.468A7.967 7.967 0 0 0 0 8c0 1.347.334 2.618.923 3.734a.5.5 0 1 0 .884-.468A6.967 6.967 0 0 1 1 8c0-1.18.292-2.292.807-3.266zm13.27-.468a.5.5 0 0 0-.884.468C14.708 5.708 15 6.819 15 8c0 1.18-.292 2.292-.807 3.266a.5.5 0 0 0 .884.468A7.967 7.967 0 0 0 16 8a7.967 7.967 0 0 0-.923-3.734zM3.34 6.182a.5.5 0 1 0-.93-.364A5.986 5.986 0 0 0 2 8c0 .769.145 1.505.41 2.182a.5.5 0 1 0 .93-.364A4.986 4.986 0 0 1 3 8c0-.642.12-1.255.34-1.818zm10.25-.364a.5.5 0 0 0-.93.364c.22.563.34 1.176.34 1.818 0 .642-.12 1.255-.34 1.818a.5.5 0 0 0 .93.364C13.856 9.505 14 8.769 14 8c0-.769-.145-1.505-.41-2.182z"/>');// eslint-disable-next-line
var BIconPieChart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PieChart','<path d="M7.5 1.018a7 7 0 0 0-4.79 11.566L7.5 7.793V1.018zm1 0V7.5h6.482A7.001 7.001 0 0 0 8.5 1.018zM14.982 8.5H8.207l-4.79 4.79A7 7 0 0 0 14.982 8.5zM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8z"/>');// eslint-disable-next-line
var BIconPieChartFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PieChartFill','<path d="M15.985 8.5H8.207l-5.5 5.5a8 8 0 0 0 13.277-5.5zM2 13.292A8 8 0 0 1 7.5.015v7.778l-5.5 5.5zM8.5.015V7.5h7.485A8.001 8.001 0 0 0 8.5.015z"/>');// eslint-disable-next-line
var BIconPiggyBank=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PiggyBank','<path d="M5 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm1.138-1.496A6.613 6.613 0 0 1 7.964 4.5c.666 0 1.303.097 1.893.273a.5.5 0 0 0 .286-.958A7.602 7.602 0 0 0 7.964 3.5c-.734 0-1.441.103-2.102.292a.5.5 0 1 0 .276.962z"/><path fill-rule="evenodd" d="M7.964 1.527c-2.977 0-5.571 1.704-6.32 4.125h-.55A1 1 0 0 0 .11 6.824l.254 1.46a1.5 1.5 0 0 0 1.478 1.243h.263c.3.513.688.978 1.145 1.382l-.729 2.477a.5.5 0 0 0 .48.641h2a.5.5 0 0 0 .471-.332l.482-1.351c.635.173 1.31.267 2.011.267.707 0 1.388-.095 2.028-.272l.543 1.372a.5.5 0 0 0 .465.316h2a.5.5 0 0 0 .478-.645l-.761-2.506C13.81 9.895 14.5 8.559 14.5 7.069c0-.145-.007-.29-.02-.431.261-.11.508-.266.705-.444.315.306.815.306.815-.417 0 .223-.5.223-.461-.026a.95.95 0 0 0 .09-.255.7.7 0 0 0-.202-.645.58.58 0 0 0-.707-.098.735.735 0 0 0-.375.562c-.024.243.082.48.32.654a2.112 2.112 0 0 1-.259.153c-.534-2.664-3.284-4.595-6.442-4.595zM2.516 6.26c.455-2.066 2.667-3.733 5.448-3.733 3.146 0 5.536 2.114 5.536 4.542 0 1.254-.624 2.41-1.67 3.248a.5.5 0 0 0-.165.535l.66 2.175h-.985l-.59-1.487a.5.5 0 0 0-.629-.288c-.661.23-1.39.359-2.157.359a6.558 6.558 0 0 1-2.157-.359.5.5 0 0 0-.635.304l-.525 1.471h-.979l.633-2.15a.5.5 0 0 0-.17-.534 4.649 4.649 0 0 1-1.284-1.541.5.5 0 0 0-.446-.275h-.56a.5.5 0 0 1-.492-.414l-.254-1.46h.933a.5.5 0 0 0 .488-.393zm12.621-.857a.565.565 0 0 1-.098.21.704.704 0 0 1-.044-.025c-.146-.09-.157-.175-.152-.223a.236.236 0 0 1 .117-.173c.049-.027.08-.021.113.012a.202.202 0 0 1 .064.199z"/>');// eslint-disable-next-line
var BIconPiggyBankFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PiggyBankFill','<path fill-rule="evenodd" d="M7.964 1.527c-2.977 0-5.571 1.704-6.32 4.125h-.55A1 1 0 0 0 .11 6.824l.254 1.46a1.5 1.5 0 0 0 1.478 1.243h.263c.3.513.688.978 1.145 1.382l-.729 2.477a.5.5 0 0 0 .48.641h2a.5.5 0 0 0 .471-.332l.482-1.351c.635.173 1.31.267 2.011.267.707 0 1.388-.095 2.028-.272l.543 1.372a.5.5 0 0 0 .465.316h2a.5.5 0 0 0 .478-.645l-.761-2.506C13.81 9.895 14.5 8.559 14.5 7.069c0-.145-.007-.29-.02-.431.261-.11.508-.266.705-.444.315.306.815.306.815-.417 0 .223-.5.223-.461-.026a.95.95 0 0 0 .09-.255.7.7 0 0 0-.202-.645.58.58 0 0 0-.707-.098.735.735 0 0 0-.375.562c-.024.243.082.48.32.654a2.112 2.112 0 0 1-.259.153c-.534-2.664-3.284-4.595-6.442-4.595zm7.173 3.876a.565.565 0 0 1-.098.21.704.704 0 0 1-.044-.025c-.146-.09-.157-.175-.152-.223a.236.236 0 0 1 .117-.173c.049-.027.08-.021.113.012a.202.202 0 0 1 .064.199zm-8.999-.65A6.613 6.613 0 0 1 7.964 4.5c.666 0 1.303.097 1.893.273a.5.5 0 1 0 .286-.958A7.601 7.601 0 0 0 7.964 3.5c-.734 0-1.441.103-2.102.292a.5.5 0 1 0 .276.962zM5 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0z"/>');// eslint-disable-next-line
var BIconPin=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Pin','<path d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354zm1.58 1.408-.002-.001.002.001zm-.002-.001.002.001A.5.5 0 0 1 6 2v5a.5.5 0 0 1-.276.447h-.002l-.012.007-.054.03a4.922 4.922 0 0 0-.827.58c-.318.278-.585.596-.725.936h7.792c-.14-.34-.407-.658-.725-.936a4.915 4.915 0 0 0-.881-.61l-.012-.006h-.002A.5.5 0 0 1 10 7V2a.5.5 0 0 1 .295-.458 1.775 1.775 0 0 0 .351-.271c.08-.08.155-.17.214-.271H5.14c.06.1.133.191.214.271a1.78 1.78 0 0 0 .37.282z"/>');// eslint-disable-next-line
var BIconPinAngle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PinAngle','<path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146zm.122 2.112v-.002.002zm0-.002v.002a.5.5 0 0 1-.122.51L6.293 6.878a.5.5 0 0 1-.511.12H5.78l-.014-.004a4.507 4.507 0 0 0-.288-.076 4.922 4.922 0 0 0-.765-.116c-.422-.028-.836.008-1.175.15l5.51 5.509c.141-.34.177-.753.149-1.175a4.924 4.924 0 0 0-.192-1.054l-.004-.013v-.001a.5.5 0 0 1 .12-.512l3.536-3.535a.5.5 0 0 1 .532-.115l.096.022c.087.017.208.034.344.034.114 0 .23-.011.343-.04L9.927 2.028c-.029.113-.04.23-.04.343a1.779 1.779 0 0 0 .062.46z"/>');// eslint-disable-next-line
var BIconPinAngleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PinAngleFill','<path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a5.927 5.927 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707-.195-.195.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a5.922 5.922 0 0 1 1.013.16l3.134-3.133a2.772 2.772 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146z"/>');// eslint-disable-next-line
var BIconPinFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PinFill','<path d="M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354z"/>');// eslint-disable-next-line
var BIconPinMap=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PinMap','<path fill-rule="evenodd" d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"/><path fill-rule="evenodd" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"/>');// eslint-disable-next-line
var BIconPinMapFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PinMapFill','<path fill-rule="evenodd" d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"/><path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"/>');// eslint-disable-next-line
var BIconPip=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Pip','<path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"/><path d="M8 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-3z"/>');// eslint-disable-next-line
var BIconPipFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PipFill','<path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm7 6h5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconPlay=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Play','<path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"/>');// eslint-disable-next-line
var BIconPlayBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlayBtn','<path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconPlayBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlayBtnFill','<path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>');// eslint-disable-next-line
var BIconPlayCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlayCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>');// eslint-disable-next-line
var BIconPlayCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlayCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>');// eslint-disable-next-line
var BIconPlayFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlayFill','<path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>');// eslint-disable-next-line
var BIconPlug=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Plug','<path d="M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0zM5 4v2.5A2.5 2.5 0 0 0 7.5 9h1A2.5 2.5 0 0 0 11 6.5V4H5z"/>');// eslint-disable-next-line
var BIconPlugFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlugFill','<path d="M6 0a.5.5 0 0 1 .5.5V3h3V.5a.5.5 0 0 1 1 0V3h1a.5.5 0 0 1 .5.5v3A3.5 3.5 0 0 1 8.5 10c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 0 1-.97 1.028C6.725 13.9 6.169 14 5.5 14c-.998 0-1.61.33-1.974.718A1.922 1.922 0 0 0 3 16H2c0-.616.232-1.367.797-1.968C3.374 13.42 4.261 13 5.5 13c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 0 1 4 6.5v-3a.5.5 0 0 1 .5-.5h1V.5A.5.5 0 0 1 6 0z"/>');// eslint-disable-next-line
var BIconPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Plus','<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>');// eslint-disable-next-line
var BIconPlusCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlusCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>');// eslint-disable-next-line
var BIconPlusCircleDotted=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlusCircleDotted','<path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>');// eslint-disable-next-line
var BIconPlusCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlusCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>');// eslint-disable-next-line
var BIconPlusLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlusLg','<path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconPlusSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlusSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>');// eslint-disable-next-line
var BIconPlusSquareDotted=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlusSquareDotted','<path d="M2.5 0c-.166 0-.33.016-.487.048l.194.98A1.51 1.51 0 0 1 2.5 1h.458V0H2.5zm2.292 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zm1.833 0h-.916v1h.916V0zm1.834 0h-.917v1h.917V0zm1.833 0h-.917v1h.917V0zM13.5 0h-.458v1h.458c.1 0 .199.01.293.029l.194-.981A2.51 2.51 0 0 0 13.5 0zm2.079 1.11a2.511 2.511 0 0 0-.69-.689l-.556.831c.164.11.305.251.415.415l.83-.556zM1.11.421a2.511 2.511 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415L1.11.422zM16 2.5c0-.166-.016-.33-.048-.487l-.98.194c.018.094.028.192.028.293v.458h1V2.5zM.048 2.013A2.51 2.51 0 0 0 0 2.5v.458h1V2.5c0-.1.01-.199.029-.293l-.981-.194zM0 3.875v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 5.708v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zM0 7.542v.916h1v-.916H0zm15 .916h1v-.916h-1v.916zM0 9.375v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .916v.917h1v-.917H0zm16 .917v-.917h-1v.917h1zm-16 .917v.458c0 .166.016.33.048.487l.98-.194A1.51 1.51 0 0 1 1 13.5v-.458H0zm16 .458v-.458h-1v.458c0 .1-.01.199-.029.293l.981.194c.032-.158.048-.32.048-.487zM.421 14.89c.183.272.417.506.69.689l.556-.831a1.51 1.51 0 0 1-.415-.415l-.83.556zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373c.158.032.32.048.487.048h.458v-1H2.5c-.1 0-.199-.01-.293-.029l-.194.981zM13.5 16c.166 0 .33-.016.487-.048l-.194-.98A1.51 1.51 0 0 1 13.5 15h-.458v1h.458zm-9.625 0h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zm1.834-1v1h.916v-1h-.916zm1.833 1h.917v-1h-.917v1zm1.833 0h.917v-1h-.917v1zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>');// eslint-disable-next-line
var BIconPlusSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PlusSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconPower=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Power','<path d="M7.5 1v7h1V1h-1z"/><path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z"/>');// eslint-disable-next-line
var BIconPrinter=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Printer','<path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/><path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>');// eslint-disable-next-line
var BIconPrinterFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PrinterFill','<path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/><path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>');// eslint-disable-next-line
var BIconPuzzle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Puzzle','<path d="M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .039-.063v-.009a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003a.214.214 0 0 0-.039-.064.859.859 0 0 0-.27-.193C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.039.063v.003l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855zM4.605 3a.5.5 0 0 0-.498.55l.001.007.29 3.4A.5.5 0 0 1 3.9 7.5h-.782c-.696 0-1.182-.497-1.469-.872a.459.459 0 0 0-.118-.115.112.112 0 0 0-.025-.012L1.5 6.5h-.003a.213.213 0 0 0-.064.039.86.86 0 0 0-.193.27C1.1 7.09 1 7.51 1 8c0 .491.1.912.24 1.19.07.14.14.225.194.271a.213.213 0 0 0 .063.039H1.5l.006-.001a.112.112 0 0 0 .025-.012.459.459 0 0 0 .118-.115c.287-.375.773-.872 1.469-.872H3.9a.5.5 0 0 1 .498.542l-.29 3.408a.5.5 0 0 0 .497.55h1.878c-.048-.166-.195-.352-.463-.557-.274-.21-.52-.528-.52-.943 0-.568.447-.947.862-1.154C6.807 10.123 7.387 10 8 10s1.193.123 1.638.346c.415.207.862.586.862 1.154 0 .415-.246.733-.52.943-.268.205-.415.39-.463.557h1.878a.5.5 0 0 0 .498-.55l-.001-.007-.29-3.4A.5.5 0 0 1 12.1 8.5h.782c.696 0 1.182.497 1.469.872.05.065.091.099.118.115.013.008.021.01.025.012a.02.02 0 0 0 .006.001h.003a.214.214 0 0 0 .064-.039.86.86 0 0 0 .193-.27c.14-.28.24-.7.24-1.191 0-.492-.1-.912-.24-1.19a.86.86 0 0 0-.194-.271.215.215 0 0 0-.063-.039H14.5l-.006.001a.113.113 0 0 0-.025.012.459.459 0 0 0-.118.115c-.287.375-.773.872-1.469.872H12.1a.5.5 0 0 1-.498-.543l.29-3.407a.5.5 0 0 0-.497-.55H9.517c.048.166.195.352.463.557.274.21.52.528.52.943 0 .568-.447.947-.862 1.154C9.193 5.877 8.613 6 8 6s-1.193-.123-1.638-.346C5.947 5.447 5.5 5.068 5.5 4.5c0-.415.246-.733.52-.943.268-.205.415-.39.463-.557H4.605z"/>');// eslint-disable-next-line
var BIconPuzzleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('PuzzleFill','<path d="M3.112 3.645A1.5 1.5 0 0 1 4.605 2H7a.5.5 0 0 1 .5.5v.382c0 .696-.497 1.182-.872 1.469a.459.459 0 0 0-.115.118.113.113 0 0 0-.012.025L6.5 4.5v.003l.003.01c.004.01.014.028.036.053a.86.86 0 0 0 .27.194C7.09 4.9 7.51 5 8 5c.492 0 .912-.1 1.19-.24a.86.86 0 0 0 .271-.194.213.213 0 0 0 .036-.054l.003-.01v-.008a.112.112 0 0 0-.012-.025.459.459 0 0 0-.115-.118c-.375-.287-.872-.773-.872-1.469V2.5A.5.5 0 0 1 9 2h2.395a1.5 1.5 0 0 1 1.493 1.645L12.645 6.5h.237c.195 0 .42-.147.675-.48.21-.274.528-.52.943-.52.568 0 .947.447 1.154.862C15.877 6.807 16 7.387 16 8s-.123 1.193-.346 1.638c-.207.415-.586.862-1.154.862-.415 0-.733-.246-.943-.52-.255-.333-.48-.48-.675-.48h-.237l.243 2.855A1.5 1.5 0 0 1 11.395 14H9a.5.5 0 0 1-.5-.5v-.382c0-.696.497-1.182.872-1.469a.459.459 0 0 0 .115-.118.113.113 0 0 0 .012-.025L9.5 11.5v-.003l-.003-.01a.214.214 0 0 0-.036-.053.859.859 0 0 0-.27-.194C8.91 11.1 8.49 11 8 11c-.491 0-.912.1-1.19.24a.859.859 0 0 0-.271.194.214.214 0 0 0-.036.054l-.003.01v.002l.001.006a.113.113 0 0 0 .012.025c.016.027.05.068.115.118.375.287.872.773.872 1.469v.382a.5.5 0 0 1-.5.5H4.605a1.5 1.5 0 0 1-1.493-1.645L3.356 9.5h-.238c-.195 0-.42.147-.675.48-.21.274-.528.52-.943.52-.568 0-.947-.447-1.154-.862C.123 9.193 0 8.613 0 8s.123-1.193.346-1.638C.553 5.947.932 5.5 1.5 5.5c.415 0 .733.246.943.52.255.333.48.48.675.48h.238l-.244-2.855z"/>');// eslint-disable-next-line
var BIconQuestion=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Question','<path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>');// eslint-disable-next-line
var BIconQuestionCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>');// eslint-disable-next-line
var BIconQuestionCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"/>');// eslint-disable-next-line
var BIconQuestionDiamond=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionDiamond','<path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.482 1.482 0 0 1 0-2.098L6.95.435zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z"/><path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>');// eslint-disable-next-line
var BIconQuestionDiamondFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionDiamondFill','<path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098L9.05.435zM5.495 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"/>');// eslint-disable-next-line
var BIconQuestionLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionLg','<path d="M3 4.075a.423.423 0 0 0 .43.44H4.9c.247 0 .442-.2.475-.445.159-1.17.962-2.022 2.393-2.022 1.222 0 2.342.611 2.342 2.082 0 1.132-.668 1.652-1.72 2.444-1.2.872-2.15 1.89-2.082 3.542l.005.386c.003.244.202.44.446.44h1.445c.247 0 .446-.2.446-.446v-.188c0-1.278.487-1.652 1.8-2.647 1.086-.826 2.217-1.743 2.217-3.667C12.667 1.301 10.393 0 7.903 0 5.645 0 3.17 1.053 3.001 4.075zm2.776 10.273c0 .95.758 1.652 1.8 1.652 1.085 0 1.832-.702 1.832-1.652 0-.985-.747-1.675-1.833-1.675-1.04 0-1.799.69-1.799 1.675z"/>');// eslint-disable-next-line
var BIconQuestionOctagon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionOctagon','<path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"/><path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>');// eslint-disable-next-line
var BIconQuestionOctagonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionOctagonFill','<path d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zM5.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"/>');// eslint-disable-next-line
var BIconQuestionSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>');// eslint-disable-next-line
var BIconQuestionSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('QuestionSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927z"/>');// eslint-disable-next-line
var BIconRainbow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Rainbow','<path d="M8 4.5a7 7 0 0 0-7 7 .5.5 0 0 1-1 0 8 8 0 1 1 16 0 .5.5 0 0 1-1 0 7 7 0 0 0-7-7zm0 2a5 5 0 0 0-5 5 .5.5 0 0 1-1 0 6 6 0 1 1 12 0 .5.5 0 0 1-1 0 5 5 0 0 0-5-5zm0 2a3 3 0 0 0-3 3 .5.5 0 0 1-1 0 4 4 0 1 1 8 0 .5.5 0 0 1-1 0 3 3 0 0 0-3-3zm0 2a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 2 2 0 1 1 4 0 .5.5 0 0 1-1 0 1 1 0 0 0-1-1z"/>');// eslint-disable-next-line
var BIconReceipt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Receipt','<path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z"/><path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconReceiptCutoff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ReceiptCutoff','<path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zM11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/><path d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293 2.354.646zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118l.137-.274z"/>');// eslint-disable-next-line
var BIconReception0=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Reception0','<path d="M0 13.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconReception1=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Reception1','<path d="M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconReception2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Reception2','<path d="M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5zm4 5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm4 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconReception3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Reception3','<path d="M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-8zm4 8a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconReception4=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Reception4','<path d="M0 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-5zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-8zm4-3a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>');// eslint-disable-next-line
var BIconRecord=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Record','<path d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"/>');// eslint-disable-next-line
var BIconRecord2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Record2','<path d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"/><path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/>');// eslint-disable-next-line
var BIconRecord2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Record2Fill','<path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/><path d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>');// eslint-disable-next-line
var BIconRecordBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('RecordBtn','<path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconRecordBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('RecordBtnFill','<path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8-1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>');// eslint-disable-next-line
var BIconRecordCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('RecordCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>');// eslint-disable-next-line
var BIconRecordCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('RecordCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>');// eslint-disable-next-line
var BIconRecordFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('RecordFill','<path fill-rule="evenodd" d="M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"/>');// eslint-disable-next-line
var BIconRecycle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Recycle','<path d="M9.302 1.256a1.5 1.5 0 0 0-2.604 0l-1.704 2.98a.5.5 0 0 0 .869.497l1.703-2.981a.5.5 0 0 1 .868 0l2.54 4.444-1.256-.337a.5.5 0 1 0-.26.966l2.415.647a.5.5 0 0 0 .613-.353l.647-2.415a.5.5 0 1 0-.966-.259l-.333 1.242-2.532-4.431zM2.973 7.773l-1.255.337a.5.5 0 1 1-.26-.966l2.416-.647a.5.5 0 0 1 .612.353l.647 2.415a.5.5 0 0 1-.966.259l-.333-1.242-2.545 4.454a.5.5 0 0 0 .434.748H5a.5.5 0 0 1 0 1H1.723A1.5 1.5 0 0 1 .421 12.24l2.552-4.467zm10.89 1.463a.5.5 0 1 0-.868.496l1.716 3.004a.5.5 0 0 1-.434.748h-5.57l.647-.646a.5.5 0 1 0-.708-.707l-1.5 1.5a.498.498 0 0 0 0 .707l1.5 1.5a.5.5 0 1 0 .708-.707l-.647-.647h5.57a1.5 1.5 0 0 0 1.302-2.244l-1.716-3.004z"/>');// eslint-disable-next-line
var BIconReddit=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Reddit','<path d="M6.167 8a.831.831 0 0 0-.83.83c0 .459.372.84.83.831a.831.831 0 0 0 0-1.661zm1.843 3.647c.315 0 1.403-.038 1.976-.611a.232.232 0 0 0 0-.306.213.213 0 0 0-.306 0c-.353.363-1.126.487-1.67.487-.545 0-1.308-.124-1.671-.487a.213.213 0 0 0-.306 0 .213.213 0 0 0 0 .306c.564.563 1.652.61 1.977.61zm.992-2.807c0 .458.373.83.831.83.458 0 .83-.381.83-.83a.831.831 0 0 0-1.66 0z"/><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.828-1.165c-.315 0-.602.124-.812.325-.801-.573-1.9-.945-3.121-.993l.534-2.501 1.738.372a.83.83 0 1 0 .83-.869.83.83 0 0 0-.744.468l-1.938-.41a.203.203 0 0 0-.153.028.186.186 0 0 0-.086.134l-.592 2.788c-1.24.038-2.358.41-3.17.992-.21-.2-.496-.324-.81-.324a1.163 1.163 0 0 0-.478 2.224c-.02.115-.029.23-.029.353 0 1.795 2.091 3.256 4.669 3.256 2.577 0 4.668-1.451 4.668-3.256 0-.114-.01-.238-.029-.353.401-.181.688-.592.688-1.069 0-.65-.525-1.165-1.165-1.165z"/>');// eslint-disable-next-line
var BIconReply=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Reply','<path d="M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z"/>');// eslint-disable-next-line
var BIconReplyAll=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ReplyAll','<path d="M8.098 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L8.8 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L4.114 8.254a.502.502 0 0 0-.042-.028.147.147 0 0 1 0-.252.497.497 0 0 0 .042-.028l3.984-2.933zM9.3 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z"/><path d="M5.232 4.293a.5.5 0 0 0-.7-.106L.54 7.127a1.147 1.147 0 0 0 0 1.946l3.994 2.94a.5.5 0 1 0 .593-.805L1.114 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.5.5 0 0 0 .042-.028l4.012-2.954a.5.5 0 0 0 .106-.699z"/>');// eslint-disable-next-line
var BIconReplyAllFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ReplyAllFill','<path d="M8.021 11.9 3.453 8.62a.719.719 0 0 1 0-1.238L8.021 4.1a.716.716 0 0 1 1.079.619V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"/><path d="M5.232 4.293a.5.5 0 0 1-.106.7L1.114 7.945a.5.5 0 0 1-.042.028.147.147 0 0 0 0 .252.503.503 0 0 1 .042.028l4.012 2.954a.5.5 0 1 1-.593.805L.539 9.073a1.147 1.147 0 0 1 0-1.946l3.994-2.94a.5.5 0 0 1 .699.106z"/>');// eslint-disable-next-line
var BIconReplyFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ReplyFill','<path d="M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"/>');// eslint-disable-next-line
var BIconRss=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Rss','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-3-8.5a1 1 0 0 1 1-1c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1 6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1-1-1z"/>');// eslint-disable-next-line
var BIconRssFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('RssFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm1.5 2.5c5.523 0 10 4.477 10 10a1 1 0 1 1-2 0 8 8 0 0 0-8-8 1 1 0 0 1 0-2zm0 4a6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4 1 1 0 0 1 0-2zm.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconRulers=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Rulers','<path d="M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v-1H2v-1h4v-1H4v-1h2v-1H2v-1h4V9H4V8h2V7H2V6h4V2h1v4h1V4h1v2h1V2h1v4h1V4h1v2h1V2h1v4h1V1a1 1 0 0 0-1-1H1z"/>');// eslint-disable-next-line
var BIconSafe=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Safe','<path d="M1 1.5A1.5 1.5 0 0 1 2.5 0h12A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 1 14.5V13H.5a.5.5 0 0 1 0-1H1V8.5H.5a.5.5 0 0 1 0-1H1V4H.5a.5.5 0 0 1 0-1H1V1.5zM2.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-12z"/><path d="M13.5 6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5zM4.828 4.464a.5.5 0 0 1 .708 0l1.09 1.09a3.003 3.003 0 0 1 3.476 0l1.09-1.09a.5.5 0 1 1 .707.708l-1.09 1.09c.74 1.037.74 2.44 0 3.476l1.09 1.09a.5.5 0 1 1-.707.708l-1.09-1.09a3.002 3.002 0 0 1-3.476 0l-1.09 1.09a.5.5 0 1 1-.708-.708l1.09-1.09a3.003 3.003 0 0 1 0-3.476l-1.09-1.09a.5.5 0 0 1 0-.708zM6.95 6.586a2 2 0 1 0 2.828 2.828A2 2 0 0 0 6.95 6.586z"/>');// eslint-disable-next-line
var BIconSafe2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Safe2','<path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h12A1.5 1.5 0 0 1 16 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 1 14.5V14H.5a.5.5 0 0 1 0-1H1V9H.5a.5.5 0 0 1 0-1H1V4H.5a.5.5 0 0 1 0-1H1v-.5zM2.5 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-12z"/><path d="M5.035 8h1.528c.047-.184.12-.357.214-.516l-1.08-1.08A3.482 3.482 0 0 0 5.035 8zm1.369-2.303 1.08 1.08c.16-.094.332-.167.516-.214V5.035a3.482 3.482 0 0 0-1.596.662zM9 5.035v1.528c.184.047.357.12.516.214l1.08-1.08A3.482 3.482 0 0 0 9 5.035zm2.303 1.369-1.08 1.08c.094.16.167.332.214.516h1.528a3.483 3.483 0 0 0-.662-1.596zM11.965 9h-1.528c-.047.184-.12.357-.214.516l1.08 1.08A3.483 3.483 0 0 0 11.965 9zm-1.369 2.303-1.08-1.08c-.16.094-.332.167-.516.214v1.528a3.483 3.483 0 0 0 1.596-.662zM8 11.965v-1.528a1.989 1.989 0 0 1-.516-.214l-1.08 1.08A3.483 3.483 0 0 0 8 11.965zm-2.303-1.369 1.08-1.08A1.988 1.988 0 0 1 6.563 9H5.035c.085.593.319 1.138.662 1.596zM4 8.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0zm4.5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>');// eslint-disable-next-line
var BIconSafe2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Safe2Fill','<path d="M6.563 8H5.035a3.482 3.482 0 0 1 .662-1.596l1.08 1.08c-.094.16-.167.332-.214.516zm.921-1.223-1.08-1.08A3.482 3.482 0 0 1 8 5.035v1.528c-.184.047-.357.12-.516.214zM9 6.563V5.035a3.482 3.482 0 0 1 1.596.662l-1.08 1.08A1.988 1.988 0 0 0 9 6.563zm1.223.921 1.08-1.08c.343.458.577 1.003.662 1.596h-1.528a1.989 1.989 0 0 0-.214-.516zM10.437 9h1.528a3.483 3.483 0 0 1-.662 1.596l-1.08-1.08c.094-.16.167-.332.214-.516zm-.921 1.223 1.08 1.08A3.483 3.483 0 0 1 9 11.965v-1.528c.184-.047.357-.12.516-.214zM8 10.437v1.528a3.483 3.483 0 0 1-1.596-.662l1.08-1.08c.16.094.332.167.516.214zm-1.223-.921-1.08 1.08A3.482 3.482 0 0 1 5.035 9h1.528c.047.184.12.357.214.516zM7.5 8.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"/><path d="M2.5 1A1.5 1.5 0 0 0 1 2.5V3H.5a.5.5 0 0 0 0 1H1v4H.5a.5.5 0 0 0 0 1H1v4H.5a.5.5 0 0 0 0 1H1v.5A1.5 1.5 0 0 0 2.5 16h12a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 14.5 1h-12zm6 3a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9z"/>');// eslint-disable-next-line
var BIconSafeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SafeFill','<path d="M9.778 9.414A2 2 0 1 1 6.95 6.586a2 2 0 0 1 2.828 2.828z"/><path d="M2.5 0A1.5 1.5 0 0 0 1 1.5V3H.5a.5.5 0 0 0 0 1H1v3.5H.5a.5.5 0 0 0 0 1H1V12H.5a.5.5 0 0 0 0 1H1v1.5A1.5 1.5 0 0 0 2.5 16h12a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 14.5 0h-12zm3.036 4.464 1.09 1.09a3.003 3.003 0 0 1 3.476 0l1.09-1.09a.5.5 0 1 1 .707.708l-1.09 1.09c.74 1.037.74 2.44 0 3.476l1.09 1.09a.5.5 0 1 1-.707.708l-1.09-1.09a3.002 3.002 0 0 1-3.476 0l-1.09 1.09a.5.5 0 1 1-.708-.708l1.09-1.09a3.003 3.003 0 0 1 0-3.476l-1.09-1.09a.5.5 0 1 1 .708-.708zM14 6.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconSave=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Save','<path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"/>');// eslint-disable-next-line
var BIconSave2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Save2','<path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"/>');// eslint-disable-next-line
var BIconSave2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Save2Fill','<path d="M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v6h-2a.5.5 0 0 0-.354.854l2.5 2.5a.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 10.5 7.5h-2v-6z"/>');// eslint-disable-next-line
var BIconSaveFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SaveFill','<path d="M8.5 1.5A1.5 1.5 0 0 1 10 0h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h6c-.314.418-.5.937-.5 1.5v7.793L4.854 6.646a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0-.708-.708L8.5 9.293V1.5z"/>');// eslint-disable-next-line
var BIconScissors=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Scissors','<path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>');// eslint-disable-next-line
var BIconScrewdriver=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Screwdriver','<path d="m0 1 1-1 3.081 2.2a1 1 0 0 1 .419.815v.07a1 1 0 0 0 .293.708L10.5 9.5l.914-.305a1 1 0 0 1 1.023.242l3.356 3.356a1 1 0 0 1 0 1.414l-1.586 1.586a1 1 0 0 1-1.414 0l-3.356-3.356a1 1 0 0 1-.242-1.023L9.5 10.5 3.793 4.793a1 1 0 0 0-.707-.293h-.071a1 1 0 0 1-.814-.419L0 1zm11.354 9.646a.5.5 0 0 0-.708.708l3 3a.5.5 0 0 0 .708-.708l-3-3z"/>');// eslint-disable-next-line
var BIconSdCard=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SdCard','<path d="M6.25 3.5a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm2 0a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2z"/><path fill-rule="evenodd" d="M5.914 0H12.5A1.5 1.5 0 0 1 14 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5V3.914c0-.398.158-.78.44-1.06L4.853.439A1.5 1.5 0 0 1 5.914 0zM13 1.5a.5.5 0 0 0-.5-.5H5.914a.5.5 0 0 0-.353.146L3.146 3.561A.5.5 0 0 0 3 3.914V14.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-13z"/>');// eslint-disable-next-line
var BIconSdCardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SdCardFill','<path fill-rule="evenodd" d="M12.5 0H5.914a1.5 1.5 0 0 0-1.06.44L2.439 2.853A1.5 1.5 0 0 0 2 3.914V14.5A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0zm-7 2.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75zm2 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75zm2.75.75a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2zm1.25-.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75z"/>');// eslint-disable-next-line
var BIconSearch=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Search','<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>');// eslint-disable-next-line
var BIconSegmentedNav=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SegmentedNav','<path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6zm6 3h4V5H6v4zm9-1V6a1 1 0 0 0-1-1h-3v4h3a1 1 0 0 0 1-1z"/>');// eslint-disable-next-line
var BIconServer=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Server','<path d="M1.333 2.667C1.333 1.194 4.318 0 8 0s6.667 1.194 6.667 2.667V4c0 1.473-2.985 2.667-6.667 2.667S1.333 5.473 1.333 4V2.667z"/><path d="M1.333 6.334v3C1.333 10.805 4.318 12 8 12s6.667-1.194 6.667-2.667V6.334a6.51 6.51 0 0 1-1.458.79C11.81 7.684 9.967 8 8 8c-1.966 0-3.809-.317-5.208-.876a6.508 6.508 0 0 1-1.458-.79z"/><path d="M14.667 11.668a6.51 6.51 0 0 1-1.458.789c-1.4.56-3.242.876-5.21.876-1.966 0-3.809-.316-5.208-.876a6.51 6.51 0 0 1-1.458-.79v1.666C1.333 14.806 4.318 16 8 16s6.667-1.194 6.667-2.667v-1.665z"/>');// eslint-disable-next-line
var BIconShare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Share','<path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/>');// eslint-disable-next-line
var BIconShareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShareFill','<path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>');// eslint-disable-next-line
var BIconShield=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Shield','<path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>');// eslint-disable-next-line
var BIconShieldCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldCheck','<path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/><path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconShieldExclamation=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldExclamation','<path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/><path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z"/>');// eslint-disable-next-line
var BIconShieldFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldFill','<path d="M5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>');// eslint-disable-next-line
var BIconShieldFillCheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldFillCheck','<path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z"/>');// eslint-disable-next-line
var BIconShieldFillExclamation=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldFillExclamation','<path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm-.55 8.502L7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0zM8.002 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>');// eslint-disable-next-line
var BIconShieldFillMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldFillMinus','<path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zM6 7.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1H6z"/>');// eslint-disable-next-line
var BIconShieldFillPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldFillPlus','<path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm-.5 5a.5.5 0 0 1 1 0v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5z"/>');// eslint-disable-next-line
var BIconShieldFillX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldFillX','<path d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zM6.854 5.146 8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconShieldLock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldLock','<path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/><path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z"/>');// eslint-disable-next-line
var BIconShieldLockFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldLockFill','<path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z"/>');// eslint-disable-next-line
var BIconShieldMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldMinus','<path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/><path d="M5.5 7a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconShieldPlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldPlus','<path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/><path d="M8 4.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V9a.5.5 0 0 1-1 0V7.5H6a.5.5 0 0 1 0-1h1.5V5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconShieldShaded=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldShaded','<path fill-rule="evenodd" d="M8 14.933a.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067v13.866zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>');// eslint-disable-next-line
var BIconShieldSlash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldSlash','<path fill-rule="evenodd" d="M1.093 3.093c-.465 4.275.885 7.46 2.513 9.589a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.32 11.32 0 0 0 1.733-1.525l-.745-.745a10.27 10.27 0 0 1-1.578 1.392c-.346.244-.652.42-.893.533-.12.057-.218.095-.293.118a.55.55 0 0 1-.101.025.615.615 0 0 1-.1-.025 2.348 2.348 0 0 1-.294-.118 6.141 6.141 0 0 1-.893-.533 10.725 10.725 0 0 1-2.287-2.233C3.053 10.228 1.879 7.594 2.06 4.06l-.967-.967zM3.98 1.98l-.852-.852A58.935 58.935 0 0 1 5.072.559C6.157.266 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.483 3.626-.332 6.491-1.551 8.616l-.77-.77c1.042-1.915 1.72-4.469 1.29-7.702a.48.48 0 0 0-.33-.39c-.65-.213-1.75-.56-2.836-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524a49.7 49.7 0 0 0-1.357.39zm9.666 12.374-13-13 .708-.708 13 13-.707.707z"/>');// eslint-disable-next-line
var BIconShieldSlashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldSlashFill','<path fill-rule="evenodd" d="M1.093 3.093c-.465 4.275.885 7.46 2.513 9.589a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.32 11.32 0 0 0 1.733-1.525L1.093 3.093zm12.215 8.215L3.128 1.128A61.369 61.369 0 0 1 5.073.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.483 3.626-.332 6.491-1.551 8.616zm.338 3.046-13-13 .708-.708 13 13-.707.707z"/>');// eslint-disable-next-line
var BIconShieldX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShieldX','<path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/><path d="M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconShift=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Shift','<path d="M7.27 2.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3H1.654C.78 10.5.326 9.455.924 8.816L7.27 2.047zM14.346 9.5 8 2.731 1.654 9.5H4.5a1 1 0 0 1 1 1v3h5v-3a1 1 0 0 1 1-1h2.846z"/>');// eslint-disable-next-line
var BIconShiftFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShiftFill','<path d="M7.27 2.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3H1.654C.78 10.5.326 9.455.924 8.816L7.27 2.047z"/>');// eslint-disable-next-line
var BIconShop=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Shop','<path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z"/>');// eslint-disable-next-line
var BIconShopWindow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ShopWindow','<path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h12V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zm2 .5a.5.5 0 0 1 .5.5V13h8V9.5a.5.5 0 0 1 1 0V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconShuffle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Shuffle','<path fill-rule="evenodd" d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z"/><path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z"/>');// eslint-disable-next-line
var BIconSignpost=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Signpost','<path d="M7 1.414V4H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5v6h2v-6h3.532a1 1 0 0 0 .768-.36l1.933-2.32a.5.5 0 0 0 0-.64L13.3 4.36a1 1 0 0 0-.768-.36H9V1.414a1 1 0 0 0-2 0zM12.532 5l1.666 2-1.666 2H2V5h10.532z"/>');// eslint-disable-next-line
var BIconSignpost2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Signpost2','<path d="M7 1.414V2H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v1H2.5a1 1 0 0 0-.8.4L.725 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4H7v5h2v-5h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9V6h4.5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.3 2.4a1 1 0 0 0-.8-.4H9v-.586a1 1 0 0 0-2 0zM13.5 3l.75 1-.75 1H2V3h11.5zm.5 5v2H2.5l-.75-1 .75-1H14z"/>');// eslint-disable-next-line
var BIconSignpost2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Signpost2Fill','<path d="M7.293.707A1 1 0 0 0 7 1.414V2H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5v1H2.5a1 1 0 0 0-.8.4L.725 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4H7v5h2v-5h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9V6h4.5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.3 2.4a1 1 0 0 0-.8-.4H9v-.586A1 1 0 0 0 7.293.707z"/>');// eslint-disable-next-line
var BIconSignpostFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SignpostFill','<path d="M7.293.707A1 1 0 0 0 7 1.414V4H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5v6h2v-6h3.532a1 1 0 0 0 .768-.36l1.933-2.32a.5.5 0 0 0 0-.64L13.3 4.36a1 1 0 0 0-.768-.36H9V1.414A1 1 0 0 0 7.293.707z"/>');// eslint-disable-next-line
var BIconSignpostSplit=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SignpostSplit','<path d="M7 7V1.414a1 1 0 0 1 2 0V2h5a1 1 0 0 1 .8.4l.975 1.3a.5.5 0 0 1 0 .6L14.8 5.6a1 1 0 0 1-.8.4H9v10H7v-5H2a1 1 0 0 1-.8-.4L.225 9.3a.5.5 0 0 1 0-.6L1.2 7.4A1 1 0 0 1 2 7h5zm1 3V8H2l-.75 1L2 10h6zm0-5h6l.75-1L14 3H8v2z"/>');// eslint-disable-next-line
var BIconSignpostSplitFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SignpostSplitFill','<path d="M7 16h2V6h5a1 1 0 0 0 .8-.4l.975-1.3a.5.5 0 0 0 0-.6L14.8 2.4A1 1 0 0 0 14 2H9v-.586a1 1 0 0 0-2 0V7H2a1 1 0 0 0-.8.4L.225 8.7a.5.5 0 0 0 0 .6l.975 1.3a1 1 0 0 0 .8.4h5v5z"/>');// eslint-disable-next-line
var BIconSim=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Sim','<path d="M2 1.5A1.5 1.5 0 0 1 3.5 0h7.086a1.5 1.5 0 0 1 1.06.44l1.915 1.914A1.5 1.5 0 0 1 14 3.414V14.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-13zM3.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3.414a.5.5 0 0 0-.146-.353l-1.915-1.915A.5.5 0 0 0 10.586 1H3.5z"/><path d="M5.5 4a.5.5 0 0 0-.5.5V6h2.5V4h-2zm3 0v2H11V4.5a.5.5 0 0 0-.5-.5h-2zM11 7H5v2h6V7zm0 3H8.5v2h2a.5.5 0 0 0 .5-.5V10zm-3.5 2v-2H5v1.5a.5.5 0 0 0 .5.5h2zM4 4.5A1.5 1.5 0 0 1 5.5 3h5A1.5 1.5 0 0 1 12 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5v-7z"/>');// eslint-disable-next-line
var BIconSimFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SimFill','<path d="M5 4.5a.5.5 0 0 1 .5-.5h2v2H5V4.5zM8.5 6V4h2a.5.5 0 0 1 .5.5V6H8.5zM5 7h6v2H5V7zm3.5 3H11v1.5a.5.5 0 0 1-.5.5h-2v-2zm-1 0v2h-2a.5.5 0 0 1-.5-.5V10h2.5z"/><path d="M3.5 0A1.5 1.5 0 0 0 2 1.5v13A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5V3.414a1.5 1.5 0 0 0-.44-1.06L11.647.439A1.5 1.5 0 0 0 10.586 0H3.5zm2 3h5A1.5 1.5 0 0 1 12 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 11.5v-7A1.5 1.5 0 0 1 5.5 3z"/>');// eslint-disable-next-line
var BIconSkipBackward=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipBackward','<path d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"/>');// eslint-disable-next-line
var BIconSkipBackwardBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipBackwardBtn','<path d="M11.21 5.093A.5.5 0 0 1 12 5.5v5a.5.5 0 0 1-.79.407L8.5 8.972V10.5a.5.5 0 0 1-.79.407L5 8.972V10.5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 1 0v1.528l2.71-1.935a.5.5 0 0 1 .79.407v1.528l2.71-1.935z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconSkipBackwardBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipBackwardBtnFill','<path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm11.21-6.907L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407z"/>');// eslint-disable-next-line
var BIconSkipBackwardCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipBackwardCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M11.729 5.055a.5.5 0 0 0-.52.038L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.271-.445z"/>');// eslint-disable-next-line
var BIconSkipBackwardCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipBackwardCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.79-2.907L8.5 7.028V5.5a.5.5 0 0 0-.79-.407L5 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407V8.972l2.71 1.935A.5.5 0 0 0 12 10.5v-5a.5.5 0 0 0-.79-.407z"/>');// eslint-disable-next-line
var BIconSkipBackwardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipBackwardFill','<path d="M.5 3.5A.5.5 0 0 0 0 4v8a.5.5 0 0 0 1 0V8.753l6.267 3.636c.54.313 1.233-.066 1.233-.697v-2.94l6.267 3.636c.54.314 1.233-.065 1.233-.696V4.308c0-.63-.693-1.01-1.233-.696L8.5 7.248v-2.94c0-.63-.692-1.01-1.233-.696L1 7.248V4a.5.5 0 0 0-.5-.5z"/>');// eslint-disable-next-line
var BIconSkipEnd=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipEnd','<path d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.713 3.31 4 3.655 4 4.308v7.384c0 .653.713.998 1.233.696L11.5 8.752V12a.5.5 0 0 0 1 0V4zM5 4.633 10.804 8 5 11.367V4.633z"/>');// eslint-disable-next-line
var BIconSkipEndBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipEndBtn','<path d="M6.79 5.093 9.5 7.028V5.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V8.972l-2.71 1.935A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .79-.407z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconSkipEndBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipEndBtnFill','<path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407L9.5 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L6.79 5.093z"/>');// eslint-disable-next-line
var BIconSkipEndCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipEndCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M6.271 5.055a.5.5 0 0 1 .52.038L9.5 7.028V5.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V8.972l-2.71 1.935A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>');// eslint-disable-next-line
var BIconSkipEndCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipEndCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407L9.5 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L6.79 5.093z"/>');// eslint-disable-next-line
var BIconSkipEndFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipEndFill','<path d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0V4z"/>');// eslint-disable-next-line
var BIconSkipForward=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipForward','<path d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.752l-6.267 3.636c-.52.302-1.233-.043-1.233-.696v-2.94l-6.267 3.636C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696L7.5 7.248v-2.94c0-.653.713-.998 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5zM1 4.633v6.734L6.804 8 1 4.633zm7.5 0v6.734L14.304 8 8.5 4.633z"/>');// eslint-disable-next-line
var BIconSkipForwardBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipForwardBtn','<path d="M4.79 5.093A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconSkipForwardBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipForwardBtnFill','<path d="M0 10V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm4.79-6.907A.5.5 0 0 0 4 3.5v5a.5.5 0 0 0 .79.407L7.5 6.972V8.5a.5.5 0 0 0 .79.407L11 6.972V8.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 3.093a.5.5 0 0 0-.79.407v1.528L4.79 3.093z"/>');// eslint-disable-next-line
var BIconSkipForwardCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipForwardCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4.271 5.055a.5.5 0 0 1 .52.038L7.5 7.028V5.5a.5.5 0 0 1 .79-.407L11 7.028V5.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V8.972l-2.71 1.935a.5.5 0 0 1-.79-.407V8.972l-2.71 1.935A.5.5 0 0 1 4 10.5v-5a.5.5 0 0 1 .271-.445z"/>');// eslint-disable-next-line
var BIconSkipForwardCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipForwardCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.79 5.093A.5.5 0 0 0 4 5.5v5a.5.5 0 0 0 .79.407L7.5 8.972V10.5a.5.5 0 0 0 .79.407L11 8.972V10.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v1.528L8.29 5.093a.5.5 0 0 0-.79.407v1.528L4.79 5.093z"/>');// eslint-disable-next-line
var BIconSkipForwardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipForwardFill','<path d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.753l-6.267 3.636c-.54.313-1.233-.066-1.233-.697v-2.94l-6.267 3.636C.693 12.703 0 12.324 0 11.693V4.308c0-.63.693-1.01 1.233-.696L7.5 7.248v-2.94c0-.63.693-1.01 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconSkipStart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipStart','<path d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L5 8.752V12a.5.5 0 0 1-1 0V4zm7.5.633L5.696 8l5.804 3.367V4.633z"/>');// eslint-disable-next-line
var BIconSkipStartBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipStartBtn','<path d="M9.71 5.093a.5.5 0 0 1 .79.407v5a.5.5 0 0 1-.79.407L7 8.972V10.5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 1 0v1.528l2.71-1.935z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconSkipStartBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipStartBtnFill','<path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm9.71-6.907L7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.79-.407z"/>');// eslint-disable-next-line
var BIconSkipStartCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipStartCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M10.229 5.055a.5.5 0 0 0-.52.038L7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.271-.445z"/>');// eslint-disable-next-line
var BIconSkipStartCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipStartCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM9.71 5.093 7 7.028V5.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V8.972l2.71 1.935a.5.5 0 0 0 .79-.407v-5a.5.5 0 0 0-.79-.407z"/>');// eslint-disable-next-line
var BIconSkipStartFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SkipStartFill','<path d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0V4z"/>');// eslint-disable-next-line
var BIconSkype=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Skype','<path d="M4.671 0c.88 0 1.733.247 2.468.702a7.423 7.423 0 0 1 6.02 2.118 7.372 7.372 0 0 1 2.167 5.215c0 .344-.024.687-.072 1.026a4.662 4.662 0 0 1 .6 2.281 4.645 4.645 0 0 1-1.37 3.294A4.673 4.673 0 0 1 11.18 16c-.84 0-1.658-.226-2.37-.644a7.423 7.423 0 0 1-6.114-2.107A7.374 7.374 0 0 1 .529 8.035c0-.363.026-.724.08-1.081a4.644 4.644 0 0 1 .76-5.59A4.68 4.68 0 0 1 4.67 0zm.447 7.01c.18.309.43.572.729.769a7.07 7.07 0 0 0 1.257.653c.492.205.873.38 1.145.523.229.112.437.264.615.448.135.142.21.331.21.528a.872.872 0 0 1-.335.723c-.291.196-.64.289-.99.264a2.618 2.618 0 0 1-1.048-.206 11.44 11.44 0 0 1-.532-.253 1.284 1.284 0 0 0-.587-.15.717.717 0 0 0-.501.176.63.63 0 0 0-.195.491.796.796 0 0 0 .148.482 1.2 1.2 0 0 0 .456.354 5.113 5.113 0 0 0 2.212.419 4.554 4.554 0 0 0 1.624-.265 2.296 2.296 0 0 0 1.08-.801c.267-.39.402-.855.386-1.327a2.09 2.09 0 0 0-.279-1.101 2.53 2.53 0 0 0-.772-.792A7.198 7.198 0 0 0 8.486 7.3a1.05 1.05 0 0 0-.145-.058 18.182 18.182 0 0 1-1.013-.447 1.827 1.827 0 0 1-.54-.387.727.727 0 0 1-.2-.508.805.805 0 0 1 .385-.723 1.76 1.76 0 0 1 .968-.247c.26-.003.52.03.772.096.274.079.542.177.802.293.105.049.22.075.336.076a.6.6 0 0 0 .453-.19.69.69 0 0 0 .18-.496.717.717 0 0 0-.17-.476 1.374 1.374 0 0 0-.556-.354 3.69 3.69 0 0 0-.708-.183 5.963 5.963 0 0 0-1.022-.078 4.53 4.53 0 0 0-1.536.258 2.71 2.71 0 0 0-1.174.784 1.91 1.91 0 0 0-.45 1.287c-.01.37.076.736.25 1.063z"/>');// eslint-disable-next-line
var BIconSlack=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Slack','<path d="M3.362 10.11c0 .926-.756 1.681-1.681 1.681S0 11.036 0 10.111C0 9.186.756 8.43 1.68 8.43h1.682v1.68zm.846 0c0-.924.756-1.68 1.681-1.68s1.681.756 1.681 1.68v4.21c0 .924-.756 1.68-1.68 1.68a1.685 1.685 0 0 1-1.682-1.68v-4.21zM5.89 3.362c-.926 0-1.682-.756-1.682-1.681S4.964 0 5.89 0s1.68.756 1.68 1.68v1.682H5.89zm0 .846c.924 0 1.68.756 1.68 1.681S6.814 7.57 5.89 7.57H1.68C.757 7.57 0 6.814 0 5.89c0-.926.756-1.682 1.68-1.682h4.21zm6.749 1.682c0-.926.755-1.682 1.68-1.682.925 0 1.681.756 1.681 1.681s-.756 1.681-1.68 1.681h-1.681V5.89zm-.848 0c0 .924-.755 1.68-1.68 1.68A1.685 1.685 0 0 1 8.43 5.89V1.68C8.43.757 9.186 0 10.11 0c.926 0 1.681.756 1.681 1.68v4.21zm-1.681 6.748c.926 0 1.682.756 1.682 1.681S11.036 16 10.11 16s-1.681-.756-1.681-1.68v-1.682h1.68zm0-.847c-.924 0-1.68-.755-1.68-1.68 0-.925.756-1.681 1.68-1.681h4.21c.924 0 1.68.756 1.68 1.68 0 .926-.756 1.681-1.68 1.681h-4.21z"/>');// eslint-disable-next-line
var BIconSlash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Slash','<path d="M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconSlashCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SlashCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M11.354 4.646a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 .708.708l6-6a.5.5 0 0 0 0-.708z"/>');// eslint-disable-next-line
var BIconSlashCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SlashCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.646-2.646a.5.5 0 0 0-.708-.708l-6 6a.5.5 0 0 0 .708.708l6-6z"/>');// eslint-disable-next-line
var BIconSlashLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SlashLg','<path d="M14.707 1.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0z"/>');// eslint-disable-next-line
var BIconSlashSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SlashSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M11.354 4.646a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconSlashSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SlashSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm9.354 5.354-6 6a.5.5 0 0 1-.708-.708l6-6a.5.5 0 0 1 .708.708z"/>');// eslint-disable-next-line
var BIconSliders=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Sliders','<path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/>');// eslint-disable-next-line
var BIconSmartwatch=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Smartwatch','<path d="M9 5a.5.5 0 0 0-1 0v3H6a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 .5-.5V5z"/><path d="M4 1.667v.383A2.5 2.5 0 0 0 2 4.5v7a2.5 2.5 0 0 0 2 2.45v.383C4 15.253 4.746 16 5.667 16h4.666c.92 0 1.667-.746 1.667-1.667v-.383a2.5 2.5 0 0 0 2-2.45V8h.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H14v-.5a2.5 2.5 0 0 0-2-2.45v-.383C12 .747 11.254 0 10.333 0H5.667C4.747 0 4 .746 4 1.667zM4.5 3h7A1.5 1.5 0 0 1 13 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7A1.5 1.5 0 0 1 4.5 3z"/>');// eslint-disable-next-line
var BIconSnow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Snow','<path d="M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793V8.866l-3.4 1.963-.496 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.884-.237a.5.5 0 1 1 .26-.966l1.848.495L7 8 3.6 6.037l-1.85.495a.5.5 0 0 1-.258-.966l.883-.237-1.12-.646a.5.5 0 1 1 .5-.866l1.12.646-.237-.883a.5.5 0 1 1 .966-.258l.495 1.849L7.5 7.134V3.207L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 1 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v3.927l3.4-1.963.496-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495L9 8l3.4 1.963 1.849-.495a.5.5 0 0 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-3.4-1.963v3.927l1.353 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5z"/>');// eslint-disable-next-line
var BIconSnow2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Snow2','<path d="M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793v-1.086l-.646.647a.5.5 0 0 1-.707-.708L7.5 10.293V8.866l-1.236.713-.495 1.85a.5.5 0 1 1-.966-.26l.237-.882-.94.542-.496 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.884-.237a.5.5 0 1 1 .26-.966l1.848.495.94-.542-.882-.237a.5.5 0 1 1 .258-.966l1.85.495L7 8l-1.236-.713-1.849.495a.5.5 0 1 1-.258-.966l.883-.237-.94-.542-1.85.495a.5.5 0 0 1-.258-.966l.883-.237-1.12-.646a.5.5 0 1 1 .5-.866l1.12.646-.237-.883a.5.5 0 0 1 .966-.258l.495 1.849.94.542-.236-.883a.5.5 0 0 1 .966-.258l.495 1.849 1.236.713V5.707L6.147 4.354a.5.5 0 1 1 .707-.708l.646.647V3.207L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 0 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v1.086l.647-.647a.5.5 0 1 1 .707.708L8.5 5.707v1.427l1.236-.713.495-1.85a.5.5 0 1 1 .966.26l-.236.882.94-.542.495-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495-.94.542.883.237a.5.5 0 1 1-.26.966l-1.848-.495L9 8l1.236.713 1.849-.495a.5.5 0 0 1 .259.966l-.883.237.94.542 1.849-.495a.5.5 0 0 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-.94-.542.236.883a.5.5 0 0 1-.966.258L9.736 9.58 8.5 8.866v1.427l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647v1.086l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5z"/>');// eslint-disable-next-line
var BIconSnow3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Snow3','<path d="M8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"/><path d="M8 16a.5.5 0 0 1-.5-.5v-1.293l-.646.647a.5.5 0 0 1-.707-.708L7.5 12.793v-1.51l-2.053-1.232-1.348.778-.495 1.85a.5.5 0 1 1-.966-.26l.237-.882-1.12.646a.5.5 0 0 1-.5-.866l1.12-.646-.883-.237a.5.5 0 1 1 .258-.966l1.85.495L5 9.155v-2.31l-1.4-.808-1.85.495a.5.5 0 1 1-.259-.966l.884-.237-1.12-.646a.5.5 0 0 1 .5-.866l1.12.646-.237-.883a.5.5 0 1 1 .966-.258l.495 1.849 1.348.778L7.5 4.717v-1.51L6.147 1.854a.5.5 0 1 1 .707-.708l.646.647V.5a.5.5 0 0 1 1 0v1.293l.647-.647a.5.5 0 1 1 .707.708L8.5 3.207v1.51l2.053 1.232 1.348-.778.495-1.85a.5.5 0 1 1 .966.26l-.236.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.883.237a.5.5 0 1 1-.26.966l-1.848-.495-1.4.808v2.31l1.4.808 1.849-.495a.5.5 0 1 1 .259.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.236.883a.5.5 0 1 1-.966.258l-.495-1.849-1.348-.778L8.5 11.283v1.51l1.354 1.353a.5.5 0 0 1-.707.708l-.647-.647V15.5a.5.5 0 0 1-.5.5zm2-6.783V6.783l-2-1.2-2 1.2v2.434l2 1.2 2-1.2z"/>');// eslint-disable-next-line
var BIconSortAlphaDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortAlphaDown','<path fill-rule="evenodd" d="M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371h-1.781zm1.57-.785L11 2.687h-.047l-.652 2.157h1.351z"/><path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V14zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"/>');// eslint-disable-next-line
var BIconSortAlphaDownAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortAlphaDownAlt','<path d="M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V7z"/><path fill-rule="evenodd" d="M10.082 12.629 9.664 14H8.598l1.789-5.332h1.234L13.402 14h-1.12l-.419-1.371h-1.781zm1.57-.785L11 9.688h-.047l-.652 2.156h1.351z"/><path d="M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"/>');// eslint-disable-next-line
var BIconSortAlphaUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortAlphaUp','<path fill-rule="evenodd" d="M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371h-1.781zm1.57-.785L11 2.687h-.047l-.652 2.157h1.351z"/><path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V14zm-8.46-.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"/>');// eslint-disable-next-line
var BIconSortAlphaUpAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortAlphaUpAlt','<path d="M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V7z"/><path fill-rule="evenodd" d="M10.082 12.629 9.664 14H8.598l1.789-5.332h1.234L13.402 14h-1.12l-.419-1.371h-1.781zm1.57-.785L11 9.688h-.047l-.652 2.156h1.351z"/><path d="M4.5 13.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"/>');// eslint-disable-next-line
var BIconSortDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortDown','<path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>');// eslint-disable-next-line
var BIconSortDownAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortDownAlt','<path d="M3.5 3.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 12.293V3.5zm4 .5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"/>');// eslint-disable-next-line
var BIconSortNumericDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortNumericDown','<path d="M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z"/><path fill-rule="evenodd" d="M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"/><path d="M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"/>');// eslint-disable-next-line
var BIconSortNumericDownAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortNumericDownAlt','<path fill-rule="evenodd" d="M11.36 7.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.836 1.973-1.836 1.09 0 2.063.637 2.063 2.688 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"/><path d="M12.438 8.668V14H11.39V9.684h-.051l-1.211.859v-.969l1.262-.906h1.046zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293V2.5z"/>');// eslint-disable-next-line
var BIconSortNumericUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortNumericUp','<path d="M12.438 1.668V7H11.39V2.684h-.051l-1.211.859v-.969l1.262-.906h1.046z"/><path fill-rule="evenodd" d="M11.36 14.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.835 1.973-1.835 1.09 0 2.063.636 2.063 2.687 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"/><path d="M4.5 13.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"/>');// eslint-disable-next-line
var BIconSortNumericUpAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortNumericUpAlt','<path fill-rule="evenodd" d="M11.36 7.098c-1.137 0-1.708-.657-1.762-1.278h1.004c.058.223.343.45.773.45.824 0 1.164-.829 1.133-1.856h-.059c-.148.39-.57.742-1.261.742-.91 0-1.72-.613-1.72-1.758 0-1.148.848-1.836 1.973-1.836 1.09 0 2.063.637 2.063 2.688 0 1.867-.723 2.848-2.145 2.848zm.062-2.735c.504 0 .933-.336.933-.972 0-.633-.398-1.008-.94-1.008-.52 0-.927.375-.927 1 0 .64.418.98.934.98z"/><path d="M12.438 8.668V14H11.39V9.684h-.051l-1.211.859v-.969l1.262-.906h1.046zM4.5 13.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707V13.5z"/>');// eslint-disable-next-line
var BIconSortUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortUp','<path d="M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"/>');// eslint-disable-next-line
var BIconSortUpAlt=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SortUpAlt','<path d="M3.5 13.5a.5.5 0 0 1-1 0V4.707L1.354 5.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 4.707V13.5zm4-9.5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"/>');// eslint-disable-next-line
var BIconSoundwave=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Soundwave','<path fill-rule="evenodd" d="M8.5 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5zm-2 2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zm-6 1.5A.5.5 0 0 1 5 6v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm8 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm-10 1A.5.5 0 0 1 3 7v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5zm12 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconSpeaker=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Speaker','<path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/><path d="M8 4.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zM8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-3.5 1.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>');// eslint-disable-next-line
var BIconSpeakerFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SpeakerFill','<path d="M9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z"/><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM8 7a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"/>');// eslint-disable-next-line
var BIconSpeedometer=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Speedometer','<path d="M8 2a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.5A.5.5 0 0 1 8 2zM3.732 3.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 8a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 7.31A.91.91 0 1 0 8.85 8.569l3.434-4.297a.389.389 0 0 0-.029-.518z"/><path fill-rule="evenodd" d="M6.664 15.889A8 8 0 1 1 9.336.11a8 8 0 0 1-2.672 15.78zm-4.665-4.283A11.945 11.945 0 0 1 8 10c2.186 0 4.236.585 6.001 1.606a7 7 0 1 0-12.002 0z"/>');// eslint-disable-next-line
var BIconSpeedometer2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Speedometer2','<path d="M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4zM3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.389.389 0 0 0-.029-.518z"/><path fill-rule="evenodd" d="M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A7.988 7.988 0 0 1 0 10zm8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3z"/>');// eslint-disable-next-line
var BIconSpellcheck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Spellcheck','<path d="M8.217 11.068c1.216 0 1.948-.869 1.948-2.31v-.702c0-1.44-.727-2.305-1.929-2.305-.742 0-1.328.347-1.499.889h-.063V3.983h-1.29V11h1.27v-.791h.064c.21.532.776.86 1.499.86zm-.43-1.025c-.66 0-1.113-.518-1.113-1.28V8.12c0-.825.42-1.343 1.098-1.343.684 0 1.075.518 1.075 1.416v.45c0 .888-.386 1.401-1.06 1.401zm-5.583 1.035c.767 0 1.201-.356 1.406-.737h.059V11h1.216V7.519c0-1.314-.947-1.783-2.11-1.783C1.355 5.736.75 6.42.69 7.27h1.216c.064-.323.313-.552.84-.552.527 0 .864.249.864.771v.464H2.346C1.145 7.953.5 8.568.5 9.496c0 .977.693 1.582 1.704 1.582zm.42-.947c-.44 0-.845-.235-.845-.718 0-.395.269-.684.84-.684h.991v.538c0 .503-.444.864-.986.864zm8.897.567c-.577-.4-.9-1.088-.9-1.983v-.65c0-1.42.894-2.338 2.305-2.338 1.352 0 2.119.82 2.139 1.806h-1.187c-.04-.351-.283-.776-.918-.776-.674 0-1.045.517-1.045 1.328v.625c0 .468.121.834.343 1.067l-.737.92z"/><path d="M14.469 9.414a.75.75 0 0 1 .117 1.055l-4 5a.75.75 0 0 1-1.116.061l-2.5-2.5a.75.75 0 1 1 1.06-1.06l1.908 1.907 3.476-4.346a.75.75 0 0 1 1.055-.117z"/>');// eslint-disable-next-line
var BIconSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Square','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>');// eslint-disable-next-line
var BIconSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SquareFill','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"/>');// eslint-disable-next-line
var BIconSquareHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SquareHalf','<path d="M8 15V1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H8zm6 1a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12z"/>');// eslint-disable-next-line
var BIconStack=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Stack','<path d="m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.598.598 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535L7.733.063z"/><path d="m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z"/>');// eslint-disable-next-line
var BIconStar=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Star','<path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"/>');// eslint-disable-next-line
var BIconStarFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StarFill','<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>');// eslint-disable-next-line
var BIconStarHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StarHalf','<path d="M5.354 5.119 7.538.792A.516.516 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0 1 16 6.32a.548.548 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.58.58 0 0 1 .085-.302.513.513 0 0 1 .37-.245l4.898-.696zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.565.565 0 0 1 .162-.505l2.907-2.77-4.052-.576a.525.525 0 0 1-.393-.288L8.001 2.223 8 2.226v9.8z"/>');// eslint-disable-next-line
var BIconStars=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Stars','<path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828l.645-1.937zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.734 1.734 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.734 1.734 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.734 1.734 0 0 0 3.407 2.31l.387-1.162zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L10.863.1z"/>');// eslint-disable-next-line
var BIconStickies=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Stickies','<path d="M1.5 0A1.5 1.5 0 0 0 0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5z"/><path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2h-11zM3 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V9h-4.5A1.5 1.5 0 0 0 9 10.5V15H3.5a.5.5 0 0 1-.5-.5v-11zm7 11.293V10.5a.5.5 0 0 1 .5-.5h4.293L10 14.793z"/>');// eslint-disable-next-line
var BIconStickiesFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StickiesFill','<path d="M0 1.5V13a1 1 0 0 0 1 1V1.5a.5.5 0 0 1 .5-.5H14a1 1 0 0 0-1-1H1.5A1.5 1.5 0 0 0 0 1.5z"/><path d="M3.5 2A1.5 1.5 0 0 0 2 3.5v11A1.5 1.5 0 0 0 3.5 16h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 16 9.586V3.5A1.5 1.5 0 0 0 14.5 2h-11zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177V10.5z"/>');// eslint-disable-next-line
var BIconSticky=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Sticky','<path d="M2.5 1A1.5 1.5 0 0 0 1 2.5v11A1.5 1.5 0 0 0 2.5 15h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 15 8.586V2.5A1.5 1.5 0 0 0 13.5 1h-11zM2 2.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V8H9.5A1.5 1.5 0 0 0 8 9.5V14H2.5a.5.5 0 0 1-.5-.5v-11zm7 11.293V9.5a.5.5 0 0 1 .5-.5h4.293L9 13.793z"/>');// eslint-disable-next-line
var BIconStickyFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StickyFill','<path d="M2.5 1A1.5 1.5 0 0 0 1 2.5v11A1.5 1.5 0 0 0 2.5 15h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 15 8.586V2.5A1.5 1.5 0 0 0 13.5 1h-11zm6 8.5a1 1 0 0 1 1-1h4.396a.25.25 0 0 1 .177.427l-5.146 5.146a.25.25 0 0 1-.427-.177V9.5z"/>');// eslint-disable-next-line
var BIconStop=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Stop','<path d="M3.5 5A1.5 1.5 0 0 1 5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5zM5 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5H5z"/>');// eslint-disable-next-line
var BIconStopBtn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StopBtn','<path d="M6.5 5A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"/><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>');// eslint-disable-next-line
var BIconStopBtnFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StopBtnFill','<path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.5-7A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"/>');// eslint-disable-next-line
var BIconStopCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StopCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5v-3z"/>');// eslint-disable-next-line
var BIconStopCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StopCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.5 5A1.5 1.5 0 0 0 5 6.5v3A1.5 1.5 0 0 0 6.5 11h3A1.5 1.5 0 0 0 11 9.5v-3A1.5 1.5 0 0 0 9.5 5h-3z"/>');// eslint-disable-next-line
var BIconStopFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StopFill','<path d="M5 3.5h6A1.5 1.5 0 0 1 12.5 5v6a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 11V5A1.5 1.5 0 0 1 5 3.5z"/>');// eslint-disable-next-line
var BIconStoplights=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Stoplights','<path d="M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1.5 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><path d="M4 2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2h2c-.167.5-.8 1.6-2 2v2h2c-.167.5-.8 1.6-2 2v2h2c-.167.5-.8 1.6-2 2v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1c-1.2-.4-1.833-1.5-2-2h2V8c-1.2-.4-1.833-1.5-2-2h2V4c-1.2-.4-1.833-1.5-2-2h2zm2-1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6z"/>');// eslint-disable-next-line
var BIconStoplightsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StoplightsFill','<path fill-rule="evenodd" d="M6 0a2 2 0 0 0-2 2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1c1.2-.4 1.833-1.5 2-2h-2V8c1.2-.4 1.833-1.5 2-2h-2V4c1.2-.4 1.833-1.5 2-2h-2a2 2 0 0 0-2-2H6zm3.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconStopwatch=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Stopwatch','<path d="M8.5 5.6a.5.5 0 1 0-1 0v2.9h-3a.5.5 0 0 0 0 1H8a.5.5 0 0 0 .5-.5V5.6z"/><path d="M6.5 1A.5.5 0 0 1 7 .5h2a.5.5 0 0 1 0 1v.57c1.36.196 2.594.78 3.584 1.64a.715.715 0 0 1 .012-.013l.354-.354-.354-.353a.5.5 0 0 1 .707-.708l1.414 1.415a.5.5 0 1 1-.707.707l-.353-.354-.354.354a.512.512 0 0 1-.013.012A7 7 0 1 1 7 2.071V1.5a.5.5 0 0 1-.5-.5zM8 3a6 6 0 1 0 .001 12A6 6 0 0 0 8 3z"/>');// eslint-disable-next-line
var BIconStopwatchFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('StopwatchFill','<path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07A7.001 7.001 0 0 0 8 16a7 7 0 0 0 5.29-11.584.531.531 0 0 0 .013-.012l.354-.354.353.354a.5.5 0 1 0 .707-.707l-1.414-1.415a.5.5 0 1 0-.707.707l.354.354-.354.354a.717.717 0 0 0-.012.012A6.973 6.973 0 0 0 9 2.071V1h.5a.5.5 0 0 0 0-1h-3zm2 5.6V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 1 1 1 0z"/>');// eslint-disable-next-line
var BIconSubtract=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Subtract','<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z"/>');// eslint-disable-next-line
var BIconSuitClub=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitClub','<path d="M8 1a3.25 3.25 0 0 0-3.25 3.25c0 .186 0 .29.016.41.014.12.045.27.12.527l.19.665-.692-.028a3.25 3.25 0 1 0 2.357 5.334.5.5 0 0 1 .844.518l-.003.005-.006.015-.024.055a21.893 21.893 0 0 1-.438.92 22.38 22.38 0 0 1-1.266 2.197c-.013.018-.02.05.001.09.01.02.021.03.03.036A.036.036 0 0 0 5.9 15h4.2c.01 0 .016-.002.022-.006a.092.092 0 0 0 .029-.035c.02-.04.014-.073.001-.091a22.875 22.875 0 0 1-1.704-3.117l-.024-.054-.006-.015-.002-.004a.5.5 0 0 1 .838-.524c.601.7 1.516 1.168 2.496 1.168a3.25 3.25 0 1 0-.139-6.498l-.699.03.199-.671c.14-.47.14-.745.139-.927V4.25A3.25 3.25 0 0 0 8 1zm2.207 12.024c.225.405.487.848.78 1.294C11.437 15 10.975 16 10.1 16H5.9c-.876 0-1.338-1-.887-1.683.291-.442.552-.88.776-1.283a4.25 4.25 0 1 1-2.007-8.187 2.79 2.79 0 0 1-.009-.064c-.023-.187-.023-.348-.023-.52V4.25a4.25 4.25 0 0 1 8.5 0c0 .14 0 .333-.04.596a4.25 4.25 0 0 1-.46 8.476 4.186 4.186 0 0 1-1.543-.298z"/>');// eslint-disable-next-line
var BIconSuitClubFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitClubFill','<path d="M11.5 12.5a3.493 3.493 0 0 1-2.684-1.254 19.92 19.92 0 0 0 1.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 0 0 1.582-2.907 3.5 3.5 0 1 1-2.538-5.743 3.5 3.5 0 1 1 6.708 0A3.5 3.5 0 1 1 11.5 12.5z"/>');// eslint-disable-next-line
var BIconSuitDiamond=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitDiamond','<path d="M8.384 1.226a.463.463 0 0 0-.768 0l-4.56 6.468a.537.537 0 0 0 0 .612l4.56 6.469a.463.463 0 0 0 .768 0l4.56-6.469a.537.537 0 0 0 0-.612l-4.56-6.468zM6.848.613a1.39 1.39 0 0 1 2.304 0l4.56 6.468a1.61 1.61 0 0 1 0 1.838l-4.56 6.468a1.39 1.39 0 0 1-2.304 0L2.288 8.92a1.61 1.61 0 0 1 0-1.838L6.848.613z"/>');// eslint-disable-next-line
var BIconSuitDiamondFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitDiamondFill','<path d="M2.45 7.4 7.2 1.067a1 1 0 0 1 1.6 0L13.55 7.4a1 1 0 0 1 0 1.2L8.8 14.933a1 1 0 0 1-1.6 0L2.45 8.6a1 1 0 0 1 0-1.2z"/>');// eslint-disable-next-line
var BIconSuitHeart=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitHeart','<path d="m8 6.236-.894-1.789c-.222-.443-.607-1.08-1.152-1.595C5.418 2.345 4.776 2 4 2 2.324 2 1 3.326 1 4.92c0 1.211.554 2.066 1.868 3.37.337.334.721.695 1.146 1.093C5.122 10.423 6.5 11.717 8 13.447c1.5-1.73 2.878-3.024 3.986-4.064.425-.398.81-.76 1.146-1.093C14.446 6.986 15 6.131 15 4.92 15 3.326 13.676 2 12 2c-.777 0-1.418.345-1.954.852-.545.515-.93 1.152-1.152 1.595L8 6.236zm.392 8.292a.513.513 0 0 1-.784 0c-1.601-1.902-3.05-3.262-4.243-4.381C1.3 8.208 0 6.989 0 4.92 0 2.755 1.79 1 4 1c1.6 0 2.719 1.05 3.404 2.008.26.365.458.716.596.992a7.55 7.55 0 0 1 .596-.992C9.281 2.049 10.4 1 12 1c2.21 0 4 1.755 4 3.92 0 2.069-1.3 3.288-3.365 5.227-1.193 1.12-2.642 2.48-4.243 4.38z"/>');// eslint-disable-next-line
var BIconSuitHeartFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitHeartFill','<path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z"/>');// eslint-disable-next-line
var BIconSuitSpade=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitSpade','<path d="M8 0a.5.5 0 0 1 .429.243c1.359 2.265 2.925 3.682 4.25 4.882.096.086.19.17.282.255C14.308 6.604 15.5 7.747 15.5 9.5a4 4 0 0 1-5.406 3.746c.235.39.491.782.722 1.131.434.659-.01 1.623-.856 1.623H6.04c-.845 0-1.29-.964-.856-1.623.263-.397.51-.777.728-1.134A4 4 0 0 1 .5 9.5c0-1.753 1.192-2.896 2.539-4.12l.281-.255c1.326-1.2 2.892-2.617 4.251-4.882A.5.5 0 0 1 8 0zM3.711 6.12C2.308 7.396 1.5 8.253 1.5 9.5a3 3 0 0 0 5.275 1.956.5.5 0 0 1 .868.43c-.094.438-.33.932-.611 1.428a29.247 29.247 0 0 1-1.013 1.614.03.03 0 0 0-.005.018.074.074 0 0 0 .024.054h3.924a.074.074 0 0 0 .024-.054.03.03 0 0 0-.005-.018c-.3-.455-.658-1.005-.96-1.535-.294-.514-.57-1.064-.664-1.507a.5.5 0 0 1 .868-.43A3 3 0 0 0 14.5 9.5c0-1.247-.808-2.104-2.211-3.38L12 5.86c-1.196-1.084-2.668-2.416-4-4.424-1.332 2.008-2.804 3.34-4 4.422l-.289.261z"/>');// eslint-disable-next-line
var BIconSuitSpadeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SuitSpadeFill','<path d="M7.184 11.246A3.5 3.5 0 0 1 1 9c0-1.602 1.14-2.633 2.66-4.008C4.986 3.792 6.602 2.33 8 0c1.398 2.33 3.014 3.792 4.34 4.992C13.86 6.367 15 7.398 15 9a3.5 3.5 0 0 1-6.184 2.246 19.92 19.92 0 0 0 1.582 2.907c.231.35-.02.847-.438.847H6.04c-.419 0-.67-.497-.438-.847a19.919 19.919 0 0 0 1.582-2.907z"/>');// eslint-disable-next-line
var BIconSun=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Sun','<path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>');// eslint-disable-next-line
var BIconSunFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SunFill','<path d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/>');// eslint-disable-next-line
var BIconSunglasses=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Sunglasses','<path d="M3 5a2 2 0 0 0-2 2v.5H.5a.5.5 0 0 0 0 1H1V9a2 2 0 0 0 2 2h1a3 3 0 0 0 3-3 1 1 0 1 1 2 0 3 3 0 0 0 3 3h1a2 2 0 0 0 2-2v-.5h.5a.5.5 0 0 0 0-1H15V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-1.888 1.338A1.99 1.99 0 0 0 8 6a1.99 1.99 0 0 0-1.112.338A2 2 0 0 0 5 5H3zm0 1h.941c.264 0 .348.356.112.474l-.457.228a2 2 0 0 0-.894.894l-.228.457C2.356 8.289 2 8.205 2 7.94V7a1 1 0 0 1 1-1z"/>');// eslint-disable-next-line
var BIconSunrise=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Sunrise','<path d="M7.646 1.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1-.708.708L8.5 2.707V4.5a.5.5 0 0 1-1 0V2.707l-.646.647a.5.5 0 1 1-.708-.708l1.5-1.5zM2.343 4.343a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM8 7a3 3 0 0 1 2.599 4.5H5.4A3 3 0 0 1 8 7zm3.71 4.5a4 4 0 1 0-7.418 0H.499a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconSunriseFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SunriseFill','<path d="M7.646 1.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1-.708.708L8.5 2.707V4.5a.5.5 0 0 1-1 0V2.707l-.646.647a.5.5 0 1 1-.708-.708l1.5-1.5zM2.343 4.343a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM11.709 11.5a4 4 0 1 0-7.418 0H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconSunset=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Sunset','<path d="M7.646 4.854a.5.5 0 0 0 .708 0l1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V1.5a.5.5 0 0 0-1 0v1.793l-.646-.647a.5.5 0 1 0-.708.708l1.5 1.5zm-5.303-.51a.5.5 0 0 1 .707 0l1.414 1.413a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .706l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM8 7a3 3 0 0 1 2.599 4.5H5.4A3 3 0 0 1 8 7zm3.71 4.5a4 4 0 1 0-7.418 0H.499a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconSunsetFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SunsetFill','<path d="M7.646 4.854a.5.5 0 0 0 .708 0l1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V1.5a.5.5 0 0 0-1 0v1.793l-.646-.647a.5.5 0 1 0-.708.708l1.5 1.5zm-5.303-.51a.5.5 0 0 1 .707 0l1.414 1.413a.5.5 0 0 1-.707.707L2.343 5.05a.5.5 0 0 1 0-.707zm11.314 0a.5.5 0 0 1 0 .706l-1.414 1.414a.5.5 0 1 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zM11.709 11.5a4 4 0 1 0-7.418 0H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-3.79zM0 10a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 0 10zm13 0a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconSymmetryHorizontal=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SymmetryHorizontal','<path d="M13.5 7a.5.5 0 0 0 .24-.939l-11-6A.5.5 0 0 0 2 .5v6a.5.5 0 0 0 .5.5h11zm.485 2.376a.5.5 0 0 1-.246.563l-11 6A.5.5 0 0 1 2 15.5v-6a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .485.376zM11.539 10H3v4.658L11.54 10z"/>');// eslint-disable-next-line
var BIconSymmetryVertical=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('SymmetryVertical','<path d="M7 2.5a.5.5 0 0 0-.939-.24l-6 11A.5.5 0 0 0 .5 14h6a.5.5 0 0 0 .5-.5v-11zm2.376-.484a.5.5 0 0 1 .563.245l6 11A.5.5 0 0 1 15.5 14h-6a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .376-.484zM10 4.46V13h4.658L10 4.46z"/>');// eslint-disable-next-line
var BIconTable=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Table','<path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"/>');// eslint-disable-next-line
var BIconTablet=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tablet','<path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/><path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>');// eslint-disable-next-line
var BIconTabletFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TabletFill','<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"/>');// eslint-disable-next-line
var BIconTabletLandscape=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TabletLandscape','<path d="M1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm-1 8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8z"/><path d="M14 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"/>');// eslint-disable-next-line
var BIconTabletLandscapeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TabletLandscapeFill','<path d="M2 14a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2zm11-7a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>');// eslint-disable-next-line
var BIconTag=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tag','<path d="M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0z"/><path d="M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1zm0 5.586 7 7L13.586 9l-7-7H2v4.586z"/>');// eslint-disable-next-line
var BIconTagFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TagFill','<path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconTags=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tags','<path d="M3 2v4.586l7 7L14.586 9l-7-7H3zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2z"/><path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1v5.086z"/>');// eslint-disable-next-line
var BIconTagsFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TagsFill','<path d="M2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2zm3.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path d="M1.293 7.793A1 1 0 0 1 1 7.086V2a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l.043-.043-7.457-7.457z"/>');// eslint-disable-next-line
var BIconTelegram=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Telegram','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z"/>');// eslint-disable-next-line
var BIconTelephone=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Telephone','<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>');// eslint-disable-next-line
var BIconTelephoneFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneFill','<path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>');// eslint-disable-next-line
var BIconTelephoneForward=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneForward','<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconTelephoneForwardFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneForwardFill','<path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconTelephoneInbound=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneInbound','<path d="M15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0zm-12.2 1.182a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>');// eslint-disable-next-line
var BIconTelephoneInboundFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneInboundFill','<path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconTelephoneMinus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneMinus','<path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"/><path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>');// eslint-disable-next-line
var BIconTelephoneMinusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneMinusFill','<path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTelephoneOutbound=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneOutbound','<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTelephoneOutboundFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneOutboundFill','<path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTelephonePlus=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephonePlus','<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/><path fill-rule="evenodd" d="M12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconTelephonePlusFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephonePlusFill','<path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconTelephoneX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneX','<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/><path fill-rule="evenodd" d="M11.146 1.646a.5.5 0 0 1 .708 0L13 2.793l1.146-1.147a.5.5 0 0 1 .708.708L13.707 3.5l1.147 1.146a.5.5 0 0 1-.708.708L13 4.207l-1.146 1.147a.5.5 0 0 1-.708-.708L12.293 3.5l-1.147-1.146a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconTelephoneXFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TelephoneXFill','<path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm9.261 1.135a.5.5 0 0 1 .708 0L13 2.793l1.146-1.147a.5.5 0 0 1 .708.708L13.707 3.5l1.147 1.146a.5.5 0 0 1-.708.708L13 4.207l-1.146 1.147a.5.5 0 0 1-.708-.708L12.293 3.5l-1.147-1.146a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconTerminal=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Terminal','<path d="M6 9a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 9zM3.854 4.146a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2z"/><path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12z"/>');// eslint-disable-next-line
var BIconTerminalFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TerminalFill','<path d="M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3zm9.5 5.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm-6.354-.354a.5.5 0 1 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 1 0-.708.708L4.793 6.5 3.146 8.146z"/>');// eslint-disable-next-line
var BIconTextCenter=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextCenter','<path fill-rule="evenodd" d="M4 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTextIndentLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextIndentLeft','<path d="M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm.646 2.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L4.293 8 2.646 6.354a.5.5 0 0 1 0-.708zM7 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm-5 3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTextIndentRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextIndentRight','<path d="M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm10.646 2.146a.5.5 0 0 1 .708.708L11.707 8l1.647 1.646a.5.5 0 0 1-.708.708l-2-2a.5.5 0 0 1 0-.708l2-2zM2 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTextLeft=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextLeft','<path fill-rule="evenodd" d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTextParagraph=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextParagraph','<path fill-rule="evenodd" d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTextRight=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextRight','<path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconTextarea=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Textarea','<path d="M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874V2.5zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5v3.563zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>');// eslint-disable-next-line
var BIconTextareaResize=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextareaResize','<path d="M.5 4A2.5 2.5 0 0 1 3 1.5h12A2.5 2.5 0 0 1 17.5 4v8a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 12V4zM3 2.5A1.5 1.5 0 0 0 1.5 4v8A1.5 1.5 0 0 0 3 13.5h12a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 15 2.5H3zm11.854 5.646a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l3-3a.5.5 0 0 1 .708 0zm0 2.5a.5.5 0 0 1 0 .708l-.5.5a.5.5 0 0 1-.708-.708l.5-.5a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconTextareaT=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TextareaT','<path d="M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874V2.5zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5v3.563zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/><path d="M11.434 4H4.566L4.5 5.994h.386c.21-1.252.612-1.446 2.173-1.495l.343-.011v6.343c0 .537-.116.665-1.049.748V12h3.294v-.421c-.938-.083-1.054-.21-1.054-.748V4.488l.348.01c1.56.05 1.963.244 2.173 1.496h.386L11.434 4z"/>');// eslint-disable-next-line
var BIconThermometer=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Thermometer','<path d="M8 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/><path d="M8 0a2.5 2.5 0 0 0-2.5 2.5v7.55a3.5 3.5 0 1 0 5 0V2.5A2.5 2.5 0 0 0 8 0zM6.5 2.5a1.5 1.5 0 1 1 3 0v7.987l.167.15a2.5 2.5 0 1 1-3.333 0l.166-.15V2.5z"/>');// eslint-disable-next-line
var BIconThermometerHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ThermometerHalf','<path d="M9.5 12.5a1.5 1.5 0 1 1-2-1.415V6.5a.5.5 0 0 1 1 0v4.585a1.5 1.5 0 0 1 1 1.415z"/><path d="M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0l-.166-.15V2.5A1.5 1.5 0 0 0 8 1z"/>');// eslint-disable-next-line
var BIconThermometerHigh=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ThermometerHigh','<path d="M9.5 12.5a1.5 1.5 0 1 1-2-1.415V2.5a.5.5 0 0 1 1 0v8.585a1.5 1.5 0 0 1 1 1.415z"/><path d="M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0l-.166-.15V2.5A1.5 1.5 0 0 0 8 1z"/>');// eslint-disable-next-line
var BIconThermometerLow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ThermometerLow','<path d="M9.5 12.5a1.5 1.5 0 1 1-2-1.415V9.5a.5.5 0 0 1 1 0v1.585a1.5 1.5 0 0 1 1 1.415z"/><path d="M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0l-.166-.15V2.5A1.5 1.5 0 0 0 8 1z"/>');// eslint-disable-next-line
var BIconThermometerSnow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ThermometerSnow','<path d="M5 12.5a1.5 1.5 0 1 1-2-1.415V9.5a.5.5 0 0 1 1 0v1.585A1.5 1.5 0 0 1 5 12.5z"/><path d="M1 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM3.5 1A1.5 1.5 0 0 0 2 2.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0L5 10.486V2.5A1.5 1.5 0 0 0 3.5 1zm5 1a.5.5 0 0 1 .5.5v1.293l.646-.647a.5.5 0 0 1 .708.708L9 5.207v1.927l1.669-.963.495-1.85a.5.5 0 1 1 .966.26l-.237.882 1.12-.646a.5.5 0 0 1 .5.866l-1.12.646.884.237a.5.5 0 1 1-.26.966l-1.848-.495L9.5 8l1.669.963 1.849-.495a.5.5 0 1 1 .258.966l-.883.237 1.12.646a.5.5 0 0 1-.5.866l-1.12-.646.237.883a.5.5 0 1 1-.966.258L10.67 9.83 9 8.866v1.927l1.354 1.353a.5.5 0 0 1-.708.708L9 12.207V13.5a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconThermometerSun=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ThermometerSun','<path d="M5 12.5a1.5 1.5 0 1 1-2-1.415V2.5a.5.5 0 0 1 1 0v8.585A1.5 1.5 0 0 1 5 12.5z"/><path d="M1 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM3.5 1A1.5 1.5 0 0 0 2 2.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0L5 10.486V2.5A1.5 1.5 0 0 0 3.5 1zm5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5zm4.243 1.757a.5.5 0 0 1 0 .707l-.707.708a.5.5 0 1 1-.708-.708l.708-.707a.5.5 0 0 1 .707 0zM8 5.5a.5.5 0 0 1 .5-.5 3 3 0 1 1 0 6 .5.5 0 0 1 0-1 2 2 0 0 0 0-4 .5.5 0 0 1-.5-.5zM12.5 8a.5.5 0 0 1 .5-.5h1a.5.5 0 1 1 0 1h-1a.5.5 0 0 1-.5-.5zm-1.172 2.828a.5.5 0 0 1 .708 0l.707.708a.5.5 0 0 1-.707.707l-.708-.707a.5.5 0 0 1 0-.708zM8.5 12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconThreeDots=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ThreeDots','<path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconThreeDotsVertical=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ThreeDotsVertical','<path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>');// eslint-disable-next-line
var BIconToggle2Off=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Toggle2Off','<path d="M9 11c.628-.836 1-1.874 1-3a4.978 4.978 0 0 0-1-3h4a3 3 0 1 1 0 6H9z"/><path d="M5 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1A5 5 0 1 0 5 3a5 5 0 0 0 0 10z"/>');// eslint-disable-next-line
var BIconToggle2On=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Toggle2On','<path d="M7 5H3a3 3 0 0 0 0 6h4a4.995 4.995 0 0 1-.584-1H3a2 2 0 1 1 0-4h3.416c.156-.357.352-.692.584-1z"/><path d="M16 8A5 5 0 1 1 6 8a5 5 0 0 1 10 0z"/>');// eslint-disable-next-line
var BIconToggleOff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ToggleOff','<path d="M11 4a4 4 0 0 1 0 8H8a4.992 4.992 0 0 0 2-4 4.992 4.992 0 0 0-2-4h3zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zM0 8a5 5 0 0 0 5 5h6a5 5 0 0 0 0-10H5a5 5 0 0 0-5 5z"/>');// eslint-disable-next-line
var BIconToggleOn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ToggleOn','<path d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"/>');// eslint-disable-next-line
var BIconToggles=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Toggles','<path d="M4.5 9a3.5 3.5 0 1 0 0 7h7a3.5 3.5 0 1 0 0-7h-7zm7 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-7-14a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm2.45 0A3.49 3.49 0 0 1 8 3.5 3.49 3.49 0 0 1 6.95 6h4.55a2.5 2.5 0 0 0 0-5H6.95zM4.5 0h7a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7z"/>');// eslint-disable-next-line
var BIconToggles2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Toggles2','<path d="M9.465 10H12a2 2 0 1 1 0 4H9.465c.34-.588.535-1.271.535-2 0-.729-.195-1.412-.535-2z"/><path d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm.535-10a3.975 3.975 0 0 1-.409-1H4a1 1 0 0 1 0-2h2.126c.091-.355.23-.69.41-1H4a2 2 0 1 0 0 4h2.535z"/><path d="M14 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"/>');// eslint-disable-next-line
var BIconTools=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tools','<path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.356 3.356a1 1 0 0 0 1.414 0l1.586-1.586a1 1 0 0 0 0-1.414l-3.356-3.356a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814L1 0zm9.646 10.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708zM3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026L3 11z"/>');// eslint-disable-next-line
var BIconTornado=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tornado','<path d="M1.125 2.45A.892.892 0 0 1 1 2c0-.26.116-.474.258-.634a1.9 1.9 0 0 1 .513-.389c.387-.21.913-.385 1.52-.525C4.514.17 6.18 0 8 0c1.821 0 3.486.17 4.709.452.607.14 1.133.314 1.52.525.193.106.374.233.513.389.141.16.258.374.258.634 0 1.011-.35 1.612-.634 2.102-.04.07-.08.137-.116.203a2.55 2.55 0 0 0-.313.809 2.938 2.938 0 0 0-.011.891.5.5 0 0 1 .428.849c-.06.06-.133.126-.215.195.204 1.116.088 1.99-.3 2.711-.453.84-1.231 1.383-2.02 1.856-.204.123-.412.243-.62.364-1.444.832-2.928 1.689-3.735 3.706a.5.5 0 0 1-.748.226l-.001-.001-.002-.001-.004-.003-.01-.008a2.142 2.142 0 0 1-.147-.115 4.095 4.095 0 0 1-1.179-1.656 3.786 3.786 0 0 1-.247-1.296A.498.498 0 0 1 5 12.5v-.018a.62.62 0 0 1 .008-.079.728.728 0 0 1 .188-.386c.09-.489.272-1.014.573-1.574a.5.5 0 0 1 .073-.918 3.29 3.29 0 0 1 .617-.144l.15-.193c.285-.356.404-.639.437-.861a.948.948 0 0 0-.122-.619c-.249-.455-.815-.903-1.613-1.43-.193-.127-.398-.258-.609-.394l-.119-.076a12.307 12.307 0 0 1-1.241-.334.5.5 0 0 1-.285-.707l-.23-.18C2.117 4.01 1.463 3.32 1.125 2.45zm1.973 1.051c.113.104.233.207.358.308.472.381.99.722 1.515 1.06 1.54.317 3.632.5 5.43.14a.5.5 0 0 1 .197.981c-1.216.244-2.537.26-3.759.157.399.326.744.682.963 1.081.203.373.302.79.233 1.247-.05.33-.182.657-.39.985.075.017.148.035.22.053l.006.002c.481.12.863.213 1.47.01a.5.5 0 1 1 .317.95c-.888.295-1.505.141-2.023.012l-.006-.002a3.894 3.894 0 0 0-.644-.123c-.37.55-.598 1.05-.726 1.497.142.045.296.11.465.194a.5.5 0 1 1-.448.894 3.11 3.11 0 0 0-.148-.07c.012.345.084.643.18.895.14.369.342.666.528.886.992-1.903 2.583-2.814 3.885-3.56.203-.116.399-.228.584-.34.775-.464 1.34-.89 1.653-1.472.212-.393.33-.9.26-1.617A6.74 6.74 0 0 1 10 8.5a.5.5 0 0 1 0-1 5.76 5.76 0 0 0 3.017-.872.515.515 0 0 1-.007-.03c-.135-.673-.14-1.207-.056-1.665.084-.46.253-.81.421-1.113l.131-.23c.065-.112.126-.22.182-.327-.29.107-.62.202-.98.285C11.487 3.83 9.822 4 8 4c-1.821 0-3.486-.17-4.709-.452-.065-.015-.13-.03-.193-.047zM13.964 2a1.12 1.12 0 0 0-.214-.145c-.272-.148-.697-.297-1.266-.428C11.354 1.166 9.769 1 8 1c-1.769 0-3.354.166-4.484.427-.569.13-.994.28-1.266.428A1.12 1.12 0 0 0 2.036 2c.04.038.109.087.214.145.272.148.697.297 1.266.428C4.646 2.834 6.231 3 8 3c1.769 0 3.354-.166 4.484-.427.569-.13.994-.28 1.266-.428A1.12 1.12 0 0 0 13.964 2z"/>');// eslint-disable-next-line
var BIconTranslate=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Translate','<path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z"/><path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"/>');// eslint-disable-next-line
var BIconTrash=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Trash','<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>');// eslint-disable-next-line
var BIconTrash2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Trash2','<path d="M14 3a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2zM3.215 4.207l1.493 8.957a1 1 0 0 0 .986.836h4.612a1 1 0 0 0 .986-.836l1.493-8.957C11.69 4.689 9.954 5 8 5c-1.954 0-3.69-.311-4.785-.793z"/>');// eslint-disable-next-line
var BIconTrash2Fill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Trash2Fill','<path d="M2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225zm9.89-.69C10.966 2.214 9.578 2 8 2c-1.58 0-2.968.215-3.926.534-.477.16-.795.327-.975.466.18.14.498.307.975.466C5.032 3.786 6.42 4 8 4s2.967-.215 3.926-.534c.477-.16.795-.327.975-.466-.18-.14-.498-.307-.975-.466z"/>');// eslint-disable-next-line
var BIconTrashFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TrashFill','<path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>');// eslint-disable-next-line
var BIconTree=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tree','<path d="M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5zM6.437 4.758A.5.5 0 0 0 6 4.5h-.066L8 1.401 10.066 4.5H10a.5.5 0 0 0-.424.765L11.598 8.5H11.5a.5.5 0 0 0-.447.724L12.69 12.5H3.309l1.638-3.276A.5.5 0 0 0 4.5 8.5h-.098l2.022-3.235a.5.5 0 0 0 .013-.507z"/>');// eslint-disable-next-line
var BIconTreeFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TreeFill','<path d="M8.416.223a.5.5 0 0 0-.832 0l-3 4.5A.5.5 0 0 0 5 5.5h.098L3.076 8.735A.5.5 0 0 0 3.5 9.5h.191l-1.638 3.276a.5.5 0 0 0 .447.724H7V16h2v-2.5h4.5a.5.5 0 0 0 .447-.724L12.31 9.5h.191a.5.5 0 0 0 .424-.765L10.902 5.5H11a.5.5 0 0 0 .416-.777l-3-4.5z"/>');// eslint-disable-next-line
var BIconTriangle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Triangle','<path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>');// eslint-disable-next-line
var BIconTriangleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TriangleFill','<path fill-rule="evenodd" d="M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767L7.022 1.566z"/>');// eslint-disable-next-line
var BIconTriangleHalf=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TriangleHalf','<path d="M8.065 2.016A.13.13 0 0 0 8.002 2v11.983l6.856.017a.12.12 0 0 0 .066-.017.162.162 0 0 0 .054-.06.176.176 0 0 0-.002-.183L8.12 2.073a.146.146 0 0 0-.054-.057zm-1.043-.45a1.13 1.13 0 0 1 1.96 0l6.856 11.667c.458.778-.091 1.767-.98 1.767H1.146c-.889 0-1.437-.99-.98-1.767L7.022 1.566z"/>');// eslint-disable-next-line
var BIconTrophy=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Trophy','<path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935zM3.504 1c.007.517.026 1.006.056 1.469.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.501.501 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667.03-.463.049-.952.056-1.469H3.504z"/>');// eslint-disable-next-line
var BIconTrophyFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TrophyFill','<path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z"/>');// eslint-disable-next-line
var BIconTropicalStorm=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TropicalStorm','<path d="M8 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/><path d="M9.5 2c-.9 0-1.75.216-2.501.6A5 5 0 0 1 13 7.5a6.5 6.5 0 1 1-13 0 .5.5 0 0 1 1 0 5.5 5.5 0 0 0 8.001 4.9A5 5 0 0 1 3 7.5a6.5 6.5 0 0 1 13 0 .5.5 0 0 1-1 0A5.5 5.5 0 0 0 9.5 2zM8 3.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/>');// eslint-disable-next-line
var BIconTruck=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Truck','<path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>');// eslint-disable-next-line
var BIconTruckFlatbed=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TruckFlatbed','<path d="M11.5 4a.5.5 0 0 1 .5.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-4 0 1 1 0 0 1-1-1v-1h11V4.5a.5.5 0 0 1 .5-.5zM3 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm1.732 0h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4a2 2 0 0 1 1.732 1z"/>');// eslint-disable-next-line
var BIconTsunami=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tsunami','<path d="M.036 12.314a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.757-.703a.5.5 0 0 1-.278-.65zm0 2a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.757-.703a.5.5 0 0 1-.278-.65zM2.662 8.08c-.456 1.063-.994 2.098-1.842 2.804a.5.5 0 0 1-.64-.768c.652-.544 1.114-1.384 1.564-2.43.14-.328.281-.68.427-1.044.302-.754.624-1.559 1.01-2.308C3.763 3.2 4.528 2.105 5.7 1.299 6.877.49 8.418 0 10.5 0c1.463 0 2.511.4 3.179 1.058.67.66.893 1.518.819 2.302-.074.771-.441 1.516-1.02 1.965a1.878 1.878 0 0 1-1.904.27c-.65.642-.907 1.679-.71 2.614C11.076 9.215 11.784 10 13 10h2.5a.5.5 0 0 1 0 1H13c-1.784 0-2.826-1.215-3.114-2.585-.232-1.1.005-2.373.758-3.284L10.5 5.06l-.777.388a.5.5 0 0 1-.447 0l-1-.5a.5.5 0 0 1 .447-.894l.777.388.776-.388a.5.5 0 0 1 .447 0l1 .5a.493.493 0 0 1 .034.018c.44.264.81.195 1.108-.036.328-.255.586-.729.637-1.27.05-.529-.1-1.076-.525-1.495-.426-.42-1.19-.77-2.477-.77-1.918 0-3.252.448-4.232 1.123C5.283 2.8 4.61 3.738 4.07 4.79c-.365.71-.655 1.433-.945 2.16-.15.376-.301.753-.463 1.13z"/>');// eslint-disable-next-line
var BIconTv=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Tv','<path d="M2.5 13.5A.5.5 0 0 1 3 13h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zM13.991 3l.024.001a1.46 1.46 0 0 1 .538.143.757.757 0 0 1 .302.254c.067.1.145.277.145.602v5.991l-.001.024a1.464 1.464 0 0 1-.143.538.758.758 0 0 1-.254.302c-.1.067-.277.145-.602.145H2.009l-.024-.001a1.464 1.464 0 0 1-.538-.143.758.758 0 0 1-.302-.254C1.078 10.502 1 10.325 1 10V4.009l.001-.024a1.46 1.46 0 0 1 .143-.538.758.758 0 0 1 .254-.302C1.498 3.078 1.675 3 2 3h11.991zM14 2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h12c2 0 2-2 2-2V4c0-2-2-2-2-2z"/>');// eslint-disable-next-line
var BIconTvFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TvFill','<path d="M2.5 13.5A.5.5 0 0 1 3 13h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zM2 2h12s2 0 2 2v6s0 2-2 2H2s-2 0-2-2V4s0-2 2-2z"/>');// eslint-disable-next-line
var BIconTwitch=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Twitch','<path d="M3.857 0 1 2.857v10.286h3.429V16l2.857-2.857H9.57L14.714 8V0H3.857zm9.714 7.429-2.285 2.285H9l-2 2v-2H4.429V1.143h9.142v6.286z"/><path d="M11.857 3.143h-1.143V6.57h1.143V3.143zm-3.143 0H7.571V6.57h1.143V3.143z"/>');// eslint-disable-next-line
var BIconTwitter=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Twitter','<path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>');// eslint-disable-next-line
var BIconType=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Type','<path d="m2.244 13.081.943-2.803H6.66l.944 2.803H8.86L5.54 3.75H4.322L1 13.081h1.244zm2.7-7.923L6.34 9.314H3.51l1.4-4.156h.034zm9.146 7.027h.035v.896h1.128V8.125c0-1.51-1.114-2.345-2.646-2.345-1.736 0-2.59.916-2.666 2.174h1.108c.068-.718.595-1.19 1.517-1.19.971 0 1.518.52 1.518 1.464v.731H12.19c-1.647.007-2.522.8-2.522 2.058 0 1.319.957 2.18 2.345 2.18 1.06 0 1.716-.43 2.078-1.011zm-1.763.035c-.752 0-1.456-.397-1.456-1.244 0-.65.424-1.115 1.408-1.115h1.805v.834c0 .896-.752 1.525-1.757 1.525z"/>');// eslint-disable-next-line
var BIconTypeBold=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TypeBold','<path d="M8.21 13c2.106 0 3.412-1.087 3.412-2.823 0-1.306-.984-2.283-2.324-2.386v-.055a2.176 2.176 0 0 0 1.852-2.14c0-1.51-1.162-2.46-3.014-2.46H3.843V13H8.21zM5.908 4.674h1.696c.963 0 1.517.451 1.517 1.244 0 .834-.629 1.32-1.73 1.32H5.908V4.673zm0 6.788V8.598h1.73c1.217 0 1.88.492 1.88 1.415 0 .943-.643 1.449-1.832 1.449H5.907z"/>');// eslint-disable-next-line
var BIconTypeH1=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TypeH1','<path d="M8.637 13V3.669H7.379V7.62H2.758V3.67H1.5V13h1.258V8.728h4.62V13h1.259zm5.329 0V3.669h-1.244L10.5 5.316v1.265l2.16-1.565h.062V13h1.244z"/>');// eslint-disable-next-line
var BIconTypeH2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TypeH2','<path d="M7.638 13V3.669H6.38V7.62H1.759V3.67H.5V13h1.258V8.728h4.62V13h1.259zm3.022-6.733v-.048c0-.889.63-1.668 1.716-1.668.957 0 1.675.608 1.675 1.572 0 .855-.554 1.504-1.067 2.085l-3.513 3.999V13H15.5v-1.094h-4.245v-.075l2.481-2.844c.875-.998 1.586-1.784 1.586-2.953 0-1.463-1.155-2.556-2.919-2.556-1.941 0-2.966 1.326-2.966 2.74v.049h1.223z"/>');// eslint-disable-next-line
var BIconTypeH3=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TypeH3','<path d="M7.637 13V3.669H6.379V7.62H1.758V3.67H.5V13h1.258V8.728h4.62V13h1.259zm3.625-4.272h1.018c1.142 0 1.935.67 1.949 1.674.013 1.005-.78 1.737-2.01 1.73-1.08-.007-1.853-.588-1.935-1.32H9.108c.069 1.327 1.224 2.386 3.083 2.386 1.935 0 3.343-1.155 3.309-2.789-.027-1.51-1.251-2.16-2.037-2.249v-.068c.704-.123 1.764-.91 1.723-2.229-.035-1.353-1.176-2.4-2.954-2.385-1.873.006-2.857 1.162-2.898 2.358h1.196c.062-.69.711-1.299 1.696-1.299.998 0 1.695.622 1.695 1.525.007.922-.718 1.592-1.695 1.592h-.964v1.074z"/>');// eslint-disable-next-line
var BIconTypeItalic=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TypeItalic','<path d="M7.991 11.674 9.53 4.455c.123-.595.246-.71 1.347-.807l.11-.52H7.211l-.11.52c1.06.096 1.128.212 1.005.807L6.57 11.674c-.123.595-.246.71-1.346.806l-.11.52h3.774l.11-.52c-1.06-.095-1.129-.211-1.006-.806z"/>');// eslint-disable-next-line
var BIconTypeStrikethrough=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TypeStrikethrough','<path d="M6.333 5.686c0 .31.083.581.27.814H5.166a2.776 2.776 0 0 1-.099-.76c0-1.627 1.436-2.768 3.48-2.768 1.969 0 3.39 1.175 3.445 2.85h-1.23c-.11-1.08-.964-1.743-2.25-1.743-1.23 0-2.18.602-2.18 1.607zm2.194 7.478c-2.153 0-3.589-1.107-3.705-2.81h1.23c.144 1.06 1.129 1.703 2.544 1.703 1.34 0 2.31-.705 2.31-1.675 0-.827-.547-1.374-1.914-1.675L8.046 8.5H1v-1h14v1h-3.504c.468.437.675.994.675 1.697 0 1.826-1.436 2.967-3.644 2.967z"/>');// eslint-disable-next-line
var BIconTypeUnderline=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('TypeUnderline','<path d="M5.313 3.136h-1.23V9.54c0 2.105 1.47 3.623 3.917 3.623s3.917-1.518 3.917-3.623V3.136h-1.23v6.323c0 1.49-.978 2.57-2.687 2.57-1.709 0-2.687-1.08-2.687-2.57V3.136zM12.5 15h-9v-1h9v1z"/>');// eslint-disable-next-line
var BIconUiChecks=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('UiChecks','<path d="M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zM2 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H2zm.854-3.646a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 1 1 .708.708l-2 2zm0 8a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708.708l-2 2zM7 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconUiChecksGrid=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('UiChecksGrid','<path d="M2 10h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm9-9h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3zm0-10a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3zM2 9a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H2zm7 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3zM0 2a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.354.854a.5.5 0 1 0-.708-.708L3 3.793l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0l2-2z"/>');// eslint-disable-next-line
var BIconUiRadios=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('UiRadios','<path d="M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zM0 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm7-1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zM3 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>');// eslint-disable-next-line
var BIconUiRadiosGrid=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('UiRadiosGrid','<path d="M3.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm9-9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zM16 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-9 9a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm5.5 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm-9-11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>');// eslint-disable-next-line
var BIconUmbrella=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Umbrella','<path d="M8 0a.5.5 0 0 1 .5.5v.514C12.625 1.238 16 4.22 16 8c0 0 0 .5-.5.5-.149 0-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394A3.166 3.166 0 0 0 13 7.5c-.638 0-1.178.213-1.564.434a3.484 3.484 0 0 0-.555.394l-.025.023-.003.003s-.204.146-.353.146-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394 3.3 3.3 0 0 0-1.064-.39V13.5H8h.5v.039l-.005.083a2.958 2.958 0 0 1-.298 1.102 2.257 2.257 0 0 1-.763.88C7.06 15.851 6.587 16 6 16s-1.061-.148-1.434-.396a2.255 2.255 0 0 1-.763-.88 2.958 2.958 0 0 1-.302-1.185v-.025l-.001-.009v-.003s0-.002.5-.002h-.5V13a.5.5 0 0 1 1 0v.506l.003.044a1.958 1.958 0 0 0 .195.726c.095.191.23.367.423.495.19.127.466.229.879.229s.689-.102.879-.229c.193-.128.328-.304.424-.495a1.958 1.958 0 0 0 .197-.77V7.544a3.3 3.3 0 0 0-1.064.39 3.482 3.482 0 0 0-.58.417l-.004.004S5.65 8.5 5.5 8.5c-.149 0-.352-.145-.352-.145l-.004-.004a3.482 3.482 0 0 0-.58-.417A3.166 3.166 0 0 0 3 7.5c-.638 0-1.177.213-1.564.434a3.482 3.482 0 0 0-.58.417l-.004.004S.65 8.5.5 8.5C0 8.5 0 8 0 8c0-3.78 3.375-6.762 7.5-6.986V.5A.5.5 0 0 1 8 0zM6.577 2.123c-2.833.5-4.99 2.458-5.474 4.854A4.124 4.124 0 0 1 3 6.5c.806 0 1.48.25 1.962.511a9.706 9.706 0 0 1 .344-2.358c.242-.868.64-1.765 1.271-2.53zm-.615 4.93A4.16 4.16 0 0 1 8 6.5a4.16 4.16 0 0 1 2.038.553 8.688 8.688 0 0 0-.307-2.13C9.434 3.858 8.898 2.83 8 2.117c-.898.712-1.434 1.74-1.731 2.804a8.687 8.687 0 0 0-.307 2.131zm3.46-4.93c.631.765 1.03 1.662 1.272 2.53.233.833.328 1.66.344 2.358A4.14 4.14 0 0 1 13 6.5c.77 0 1.42.23 1.897.477-.484-2.396-2.641-4.355-5.474-4.854z"/>');// eslint-disable-next-line
var BIconUmbrellaFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('UmbrellaFill','<path fill-rule="evenodd" d="M8 0a.5.5 0 0 1 .5.5v.514C12.625 1.238 16 4.22 16 8c0 0 0 .5-.5.5-.149 0-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394A3.166 3.166 0 0 0 13 7.5c-.638 0-1.178.213-1.564.434a3.484 3.484 0 0 0-.555.394l-.025.023-.003.003s-.204.146-.353.146-.352-.145-.352-.145l-.004-.004-.025-.023a3.484 3.484 0 0 0-.555-.394 3.3 3.3 0 0 0-1.064-.39V13.5H8h.5v.039l-.005.083a2.958 2.958 0 0 1-.298 1.102 2.257 2.257 0 0 1-.763.88C7.06 15.851 6.587 16 6 16s-1.061-.148-1.434-.396a2.255 2.255 0 0 1-.763-.88 2.958 2.958 0 0 1-.302-1.185v-.025l-.001-.009v-.003s0-.002.5-.002h-.5V13a.5.5 0 0 1 1 0v.506l.003.044a1.958 1.958 0 0 0 .195.726c.095.191.23.367.423.495.19.127.466.229.879.229s.689-.102.879-.229c.193-.128.328-.304.424-.495a1.958 1.958 0 0 0 .197-.77V7.544a3.3 3.3 0 0 0-1.064.39 3.482 3.482 0 0 0-.58.417l-.004.004S5.65 8.5 5.5 8.5c-.149 0-.352-.145-.352-.145l-.004-.004a3.482 3.482 0 0 0-.58-.417A3.166 3.166 0 0 0 3 7.5c-.638 0-1.177.213-1.564.434a3.482 3.482 0 0 0-.58.417l-.004.004S.65 8.5.5 8.5C0 8.5 0 8 0 8c0-3.78 3.375-6.762 7.5-6.986V.5A.5.5 0 0 1 8 0z"/>');// eslint-disable-next-line
var BIconUnion=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Union','<path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2z"/>');// eslint-disable-next-line
var BIconUnlock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Unlock','<path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z"/>');// eslint-disable-next-line
var BIconUnlockFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('UnlockFill','<path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2z"/>');// eslint-disable-next-line
var BIconUpc=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Upc','<path d="M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"/>');// eslint-disable-next-line
var BIconUpcScan=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('UpcScan','<path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"/>');// eslint-disable-next-line
var BIconUpload=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Upload','<path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>');// eslint-disable-next-line
var BIconVectorPen=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VectorPen','<path fill-rule="evenodd" d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828L10.646.646zm-1.8 2.908-3.173.793a.5.5 0 0 0-.358.342l-2.57 8.565 8.567-2.57a.5.5 0 0 0 .34-.357l.794-3.174-3.6-3.6z"/><path fill-rule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1l-4.228 5.168-.026.086.086-.026z"/>');// eslint-disable-next-line
var BIconViewList=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ViewList','<path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2zm0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14z"/>');// eslint-disable-next-line
var BIconViewStacked=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ViewStacked','<path d="M3 0h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3zm0 8h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3z"/>');// eslint-disable-next-line
var BIconVinyl=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Vinyl','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0z"/><path d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>');// eslint-disable-next-line
var BIconVinylFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VinylFill','<path d="M8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4 8a4 4 0 1 0 8 0 4 4 0 0 0-8 0z"/>');// eslint-disable-next-line
var BIconVoicemail=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Voicemail','<path d="M7 8.5A3.49 3.49 0 0 1 5.95 11h4.1a3.5 3.5 0 1 1 2.45 1h-9A3.5 3.5 0 1 1 7 8.5zm-6 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0zm14 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/>');// eslint-disable-next-line
var BIconVolumeDown=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeDown','<path d="M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zM6.312 6.39 8 5.04v5.92L6.312 9.61A.5.5 0 0 0 6 9.5H4v-3h2a.5.5 0 0 0 .312-.11zM12.025 8a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z"/>');// eslint-disable-next-line
var BIconVolumeDownFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeDownFill','<path d="M9 4a.5.5 0 0 0-.812-.39L5.825 5.5H3.5A.5.5 0 0 0 3 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 9 12V4zm3.025 4a4.486 4.486 0 0 1-1.318 3.182L10 10.475A3.489 3.489 0 0 0 11.025 8 3.49 3.49 0 0 0 10 5.525l.707-.707A4.486 4.486 0 0 1 12.025 8z"/>');// eslint-disable-next-line
var BIconVolumeMute=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeMute','<path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM6 5.04 4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96V5.04zm7.854.606a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconVolumeMuteFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeMuteFill','<path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zm7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z"/>');// eslint-disable-next-line
var BIconVolumeOff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeOff','<path d="M10.717 3.55A.5.5 0 0 1 11 4v8a.5.5 0 0 1-.812.39L7.825 10.5H5.5A.5.5 0 0 1 5 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM10 5.04 8.312 6.39A.5.5 0 0 1 8 6.5H6v3h2a.5.5 0 0 1 .312.11L10 10.96V5.04z"/>');// eslint-disable-next-line
var BIconVolumeOffFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeOffFill','<path d="M10.717 3.55A.5.5 0 0 1 11 4v8a.5.5 0 0 1-.812.39L7.825 10.5H5.5A.5.5 0 0 1 5 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"/>');// eslint-disable-next-line
var BIconVolumeUp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeUp','<path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"/><path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"/><path d="M10.025 8a4.486 4.486 0 0 1-1.318 3.182L8 10.475A3.489 3.489 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.486 4.486 0 0 1 10.025 8zM7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12V4zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11z"/>');// eslint-disable-next-line
var BIconVolumeUpFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('VolumeUpFill','<path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"/><path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"/><path d="M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06z"/>');// eslint-disable-next-line
var BIconVr=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Vr','<path d="M3 12V4a1 1 0 0 1 1-1h2.5V2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5v-1H4a1 1 0 0 1-1-1zm6.5 1v1H12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9.5v1H12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9.5zM8 16a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 1 0v15a.5.5 0 0 1-.5.5z"/>');// eslint-disable-next-line
var BIconWallet=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Wallet','<path d="M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5V3zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a1.99 1.99 0 0 1-1-.268zM1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1z"/>');// eslint-disable-next-line
var BIconWallet2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Wallet2','<path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"/>');// eslint-disable-next-line
var BIconWalletFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('WalletFill','<path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z"/><path d="M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z"/>');// eslint-disable-next-line
var BIconWatch=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Watch','<path d="M8.5 5a.5.5 0 0 0-1 0v2.5H6a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5V5z"/><path d="M5.667 16C4.747 16 4 15.254 4 14.333v-1.86A5.985 5.985 0 0 1 2 8c0-1.777.772-3.374 2-4.472V1.667C4 .747 4.746 0 5.667 0h4.666C11.253 0 12 .746 12 1.667v1.86a5.99 5.99 0 0 1 1.918 3.48.502.502 0 0 1 .582.493v1a.5.5 0 0 1-.582.493A5.99 5.99 0 0 1 12 12.473v1.86c0 .92-.746 1.667-1.667 1.667H5.667zM13 8A5 5 0 1 0 3 8a5 5 0 0 0 10 0z"/>');// eslint-disable-next-line
var BIconWater=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Water','<path d="M.036 3.314a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0L.314 3.964a.5.5 0 0 1-.278-.65zm0 3a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0L.314 6.964a.5.5 0 0 1-.278-.65zm0 3a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0L.314 9.964a.5.5 0 0 1-.278-.65zm0 3a.5.5 0 0 1 .65-.278l1.757.703a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.014-.406a2.5 2.5 0 0 1 1.857 0l1.015.406a1.5 1.5 0 0 0 1.114 0l1.757-.703a.5.5 0 1 1 .372.928l-1.758.703a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.014-.406a1.5 1.5 0 0 0-1.114 0l-1.015.406a2.5 2.5 0 0 1-1.857 0l-1.757-.703a.5.5 0 0 1-.278-.65z"/>');// eslint-disable-next-line
var BIconWhatsapp=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Whatsapp','<path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>');// eslint-disable-next-line
var BIconWifi=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Wifi','<path d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.444 12.444 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049z"/><path d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.455 9.455 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091l.016-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"/>');// eslint-disable-next-line
var BIconWifi1=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Wifi1','<path d="M11.046 10.454c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.611-.091l.015-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.708-.707z"/>');// eslint-disable-next-line
var BIconWifi2=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Wifi2','<path d="M13.229 8.271c.216-.216.194-.578-.063-.745A9.456 9.456 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.577 1.336c.205.132.48.108.652-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.408.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.611-.091l.015-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .708 0l.707-.707z"/>');// eslint-disable-next-line
var BIconWifiOff=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('WifiOff','<path d="M10.706 3.294A12.545 12.545 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c.63 0 1.249.05 1.852.148l.854-.854zM8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065 8.448 8.448 0 0 1 3.51-1.27L8 6zm2.596 1.404.785-.785c.63.24 1.227.545 1.785.907a.482.482 0 0 1 .063.745.525.525 0 0 1-.652.065 8.462 8.462 0 0 0-1.98-.932zM8 10l.933-.933a6.455 6.455 0 0 1 2.013.637c.285.145.326.524.1.75l-.015.015a.532.532 0 0 1-.611.09A5.478 5.478 0 0 0 8 10zm4.905-4.905.747-.747c.59.3 1.153.645 1.685 1.03a.485.485 0 0 1 .047.737.518.518 0 0 1-.668.05 11.493 11.493 0 0 0-1.811-1.07zM9.02 11.78c.238.14.236.464.04.66l-.707.706a.5.5 0 0 1-.707 0l-.707-.707c-.195-.195-.197-.518.04-.66A1.99 1.99 0 0 1 8 11.5c.374 0 .723.102 1.021.28zm4.355-9.905a.53.53 0 0 1 .75.75l-10.75 10.75a.53.53 0 0 1-.75-.75l10.75-10.75z"/>');// eslint-disable-next-line
var BIconWind=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Wind','<path d="M12.5 2A2.5 2.5 0 0 0 10 4.5a.5.5 0 0 1-1 0A3.5 3.5 0 1 1 12.5 8H.5a.5.5 0 0 1 0-1h12a2.5 2.5 0 0 0 0-5zm-7 1a1 1 0 0 0-1 1 .5.5 0 0 1-1 0 2 2 0 1 1 2 2h-5a.5.5 0 0 1 0-1h5a1 1 0 0 0 0-2zM0 9.5A.5.5 0 0 1 .5 9h10.042a3 3 0 1 1-3 3 .5.5 0 0 1 1 0 2 2 0 1 0 2-2H.5a.5.5 0 0 1-.5-.5z"/>');// eslint-disable-next-line
var BIconWindow=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Window','<path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/><path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm13 2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zM2 14a1 1 0 0 1-1-1V6h14v7a1 1 0 0 1-1 1H2z"/>');// eslint-disable-next-line
var BIconWindowDock=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('WindowDock','<path fill-rule="evenodd" d="M15 5H1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5zm0-1H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1zm1-1a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3z"/><path d="M3 11.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm4 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>');// eslint-disable-next-line
var BIconWindowSidebar=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('WindowSidebar','<path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/><path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm12 1a1 1 0 0 1 1 1v2H1V3a1 1 0 0 1 1-1h12zM1 13V6h4v8H2a1 1 0 0 1-1-1zm5 1V6h9v7a1 1 0 0 1-1 1H6z"/>');// eslint-disable-next-line
var BIconWrench=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Wrench','<path d="M.102 2.223A3.004 3.004 0 0 0 3.78 5.897l6.341 6.252A3.003 3.003 0 0 0 13 16a3 3 0 1 0-.851-5.878L5.897 3.781A3.004 3.004 0 0 0 2.223.1l2.141 2.142L4 4l-1.757.364L.102 2.223zm13.37 9.019.528.026.287.445.445.287.026.529L15 13l-.242.471-.026.529-.445.287-.287.445-.529.026L13 15l-.471-.242-.529-.026-.287-.445-.445-.287-.026-.529L11 13l.242-.471.026-.529.445-.287.287-.445.529-.026L13 11l.471.242z"/>');// eslint-disable-next-line
var BIconX=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('X','<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconXCircle=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XCircle','<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconXCircleFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XCircleFill','<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>');// eslint-disable-next-line
var BIconXDiamond=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XDiamond','<path d="M7.987 16a1.526 1.526 0 0 1-1.07-.448L.45 9.082a1.531 1.531 0 0 1 0-2.165L6.917.45a1.531 1.531 0 0 1 2.166 0l6.469 6.468A1.526 1.526 0 0 1 16 8.013a1.526 1.526 0 0 1-.448 1.07l-6.47 6.469A1.526 1.526 0 0 1 7.988 16zM7.639 1.17 4.766 4.044 8 7.278l3.234-3.234L8.361 1.17a.51.51 0 0 0-.722 0zM8.722 8l3.234 3.234 2.873-2.873c.2-.2.2-.523 0-.722l-2.873-2.873L8.722 8zM8 8.722l-3.234 3.234 2.873 2.873c.2.2.523.2.722 0l2.873-2.873L8 8.722zM7.278 8 4.044 4.766 1.17 7.639a.511.511 0 0 0 0 .722l2.874 2.873L7.278 8z"/>');// eslint-disable-next-line
var BIconXDiamondFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XDiamondFill','<path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L4.047 3.339 8 7.293l3.954-3.954L9.049.435zm3.61 3.611L8.708 8l3.954 3.954 2.904-2.905c.58-.58.58-1.519 0-2.098l-2.904-2.905zm-.706 8.614L8 8.708l-3.954 3.954 2.905 2.904c.58.58 1.519.58 2.098 0l2.905-2.904zm-8.614-.706L7.292 8 3.339 4.046.435 6.951c-.58.58-.58 1.519 0 2.098l2.904 2.905z"/>');// eslint-disable-next-line
var BIconXLg=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XLg','<path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/>');// eslint-disable-next-line
var BIconXOctagon=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XOctagon','<path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"/><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconXOctagonFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XOctagonFill','<path d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconXSquare=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XSquare','<path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>');// eslint-disable-next-line
var BIconXSquareFill=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('XSquareFill','<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"/>');// eslint-disable-next-line
var BIconYoutube=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('Youtube','<path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"/>');// eslint-disable-next-line
var BIconZoomIn=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ZoomIn','<path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>');// eslint-disable-next-line
var BIconZoomOut=/*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_make_icon__["a" /* makeIcon */])('ZoomOut','<path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/><path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/><path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>');// --- END AUTO-GENERATED FILE ---

/***/ }),
/* 62 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./~/underscore/modules/_isArrayLike.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(/*! ./_createSizePropertyCheck.js */ 640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);



// Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]));


/***/ }),
/* 63 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/restArguments.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = restArguments;
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function restArguments(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}


/***/ }),
/* 64 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/underscore.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// If Underscore is called as a function, it returns a wrapped object that can
// be used OO-style. This wrapper holds altered versions of all functions added
// through `_.mixin`. Wrapped objects may be chained.
function _(obj) {
  if (obj instanceof _) return obj;
  if (!(this instanceof _)) return new _(obj);
  this._wrapped = obj;
}

_.VERSION = __WEBPACK_IMPORTED_MODULE_0__setup_js__["a" /* VERSION */];

// Extracts the result from a wrapped and chained object.
_.prototype.value = function() {
  return this._wrapped;
};

// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
_.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

_.prototype.toString = function() {
  return String(this._wrapped);
};


/***/ }),
/* 65 */
/* exports provided: safeVueInstance */
/* exports used: safeVueInstance */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/safe-vue-instance.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = safeVueInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);

function safeVueInstance(target) {
  if (!__WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */]) {
    return target;
  }

  return new Proxy(target, {
    get: function get(target, prop) {
      return prop in target ? target[prop] : undefined;
    }
  });
}

/***/ }),
/* 66 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_descriptors.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(/*! ./_fails */ 111)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 67 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/assets/loading-gif/loading.svg ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "loading.svg?4035b30200eb82aca8f12e79a5fc7925";

/***/ }),
/* 68 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/_getLength.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(/*! ./_shallowProperty.js */ 643);


// Internal helper to obtain the `length` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('length'));


/***/ }),
/* 69 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/isFunction.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);



var isFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Function');

// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist = __WEBPACK_IMPORTED_MODULE_1__setup_js__["s" /* root */].document && __WEBPACK_IMPORTED_MODULE_1__setup_js__["s" /* root */].document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 70 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./client/components/input/betterInputTag/BetterInputTag.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-169f7ba6","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./BetterInputTag.vue */ 1485)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./BetterInputTag.vue */ 815),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-169f7ba6"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./betterInputTag.pug */ 1374),
  /* scopeId */
  "data-v-169f7ba6",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/input/betterInputTag/BetterInputTag.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BetterInputTag.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-169f7ba6", Component.options)
  } else {
    hotAPI.reload("data-v-169f7ba6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 71 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./client/utils/numberMasker.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var maskThousand = function maskThousand(valueF) {
  var value = parseFloat(valueF).toFixed(2);
  var signal = value.toString().indexOf('-');
  if (signal >= 0) {
    value = value.replace('-', '');
  }
  var num = value.split('.');
  num[0] = num[0].split(/(?=(?:...)*$)/).join('.');
  return signal >= 0 ? '-' + num.join(',') : num.join(',');
};

var maskThousandNoFixed = function maskThousandNoFixed(valueF) {
  var value = valueF.toString();
  var signal = value.indexOf('-');
  if (signal >= 0) {
    value = value.replace('-', '');
  }
  var num = value.split('.');
  num[0] = num[0].split(/(?=(?:...)*$)/).join('.');
  return signal >= 0 ? '-' + num.join(',') : num.join(',');
};

exports.maskThousand = maskThousand;
exports.maskThousandNoFixed = maskThousandNoFixed;

/***/ }),
/* 72 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/babel-runtime/helpers/asyncToGenerator.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(/*! ../core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 73 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/babel-runtime/regenerator/index.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! regenerator-runtime */ 1146);


/***/ }),
/* 74 */
/* exports provided: listenOnRootMixin */
/* exports used: listenOnRootMixin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/listen-on-root.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listenOnRootMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(/*! ../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_get_event_root__ = __webpack_require__(/*! ../utils/get-event-root */ 122);



 // --- Constants ---

var PROP = '$_rootListeners'; // --- Mixin ---
// @vue/component

var listenOnRootMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  computed: {
    bvEventRoot: function bvEventRoot() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_get_event_root__["a" /* getEventRoot */])(this);
    }
  },
  created: function created() {
    // Define non-reactive property
    // Object of arrays, keyed by event name,
    // where value is an array of callbacks
    this[PROP] = {};
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    // Unregister all registered listeners
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(this[PROP] || {}).forEach(function (event) {
      _this[PROP][event].forEach(function (callback) {
        _this.listenOffRoot(event, callback);
      });
    });
    this[PROP] = null;
  },
  methods: {
    registerRootListener: function registerRootListener(event, callback) {
      if (this[PROP]) {
        this[PROP][event] = this[PROP][event] || [];

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["c" /* arrayIncludes */])(this[PROP][event], callback)) {
          this[PROP][event].push(callback);
        }
      }
    },
    unregisterRootListener: function unregisterRootListener(event, callback) {
      if (this[PROP] && this[PROP][event]) {
        this[PROP][event] = this[PROP][event].filter(function (cb) {
          return cb !== callback;
        });
      }
    },

    /**
     * Safely register event listeners on the root Vue node
     * While Vue automatically removes listeners for individual components,
     * when a component registers a listener on `$root` and is destroyed,
     * this orphans a callback because the node is gone, but the `$root`
     * does not clear the callback
     *
     * When registering a `$root` listener, it also registers the listener
     * to be removed in the component's `beforeDestroy()` hook
     *
     * @param {string} event
     * @param {function} callback
     */
    listenOnRoot: function listenOnRoot(event, callback) {
      if (this.bvEventRoot) {
        this.bvEventRoot.$on(event, callback);
        this.registerRootListener(event, callback);
      }
    },

    /**
     * Safely register a `$once()` event listener on the root Vue node
     * While Vue automatically removes listeners for individual components,
     * when a component registers a listener on `$root` and is destroyed,
     * this orphans a callback because the node is gone, but the `$root`
     * does not clear the callback
     *
     * When registering a `$root` listener, it also registers the listener
     * to be removed in the component's `beforeDestroy()` hook
     *
     * @param {string} event
     * @param {function} callback
     */
    listenOnRootOnce: function listenOnRootOnce(event, callback) {
      var _this2 = this;

      if (this.bvEventRoot) {
        var _callback = function _callback() {
          _this2.unregisterRootListener(_callback); // eslint-disable-next-line node/no-callback-literal


          callback.apply(void 0, arguments);
        };

        this.bvEventRoot.$once(event, _callback);
        this.registerRootListener(event, _callback);
      }
    },

    /**
     * Safely unregister event listeners from the root Vue node
     *
     * @param {string} event
     * @param {function} callback
     */
    listenOffRoot: function listenOffRoot(event, callback) {
      this.unregisterRootListener(event, callback);

      if (this.bvEventRoot) {
        this.bvEventRoot.$off(event, callback);
      }
    },

    /**
     * Convenience method for calling `vm.$emit()` on `$root`
     *
     * @param {string} event
     * @param {*} args
     */
    emitOnRoot: function emitOnRoot(event) {
      if (this.bvEventRoot) {
        var _this$bvEventRoot;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_this$bvEventRoot = this.bvEventRoot).$emit.apply(_this$bvEventRoot, [event].concat(args));
      }
    }
  }
});

/***/ }),
/* 75 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_object-dp.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ./_an-object */ 89);
var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ 469);
var toPrimitive = __webpack_require__(/*! ./_to-primitive */ 271);
var dP = Object.defineProperty;

exports.f = __webpack_require__(/*! ./_descriptors */ 66) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 76 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./client/components/form/formSearch/FormSearch.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-7dbbcb98","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./FormSearch.vue */ 1540)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./FormSearch.vue */ 814),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7dbbcb98"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./formSearch.pug */ 1446),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/form/formSearch/FormSearch.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FormSearch.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7dbbcb98", Component.options)
  } else {
    hotAPI.reload("data-v-7dbbcb98", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 77 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./client/components/loading/LoadingPlaceholder.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-b8e2c004","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./LoadingPlaceholder.vue */ 1548)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./LoadingPlaceholder.vue */ 830),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-b8e2c004"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../~/vue-loader/lib/selector?type=template&index=0!./LoadingPlaceholder.vue */ 1453),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/loading/LoadingPlaceholder.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoadingPlaceholder.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b8e2c004", Component.options)
  } else {
    hotAPI.reload("data-v-b8e2c004", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 78 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./client/utils/looseDeepEqual.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNan = __webpack_require__(/*! babel-runtime/core-js/number/is-nan */ 918);

var _isNan2 = _interopRequireDefault(_isNan);

var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 137);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _isTypeOf(type, a, b) {
  return [typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a), typeof b === 'undefined' ? 'undefined' : (0, _typeof3.default)(b)].includes(type);
}

function _areStringsAndEquals(a, b) {
  if ((typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a)) === (typeof b === 'undefined' ? 'undefined' : (0, _typeof3.default)(b))) {
    return a === b;
  }
  return !!a === !!b;
}

function _areNumbersAndEquals(a, b) {
  if (typeof a === 'number' && !(0, _isNan2.default)(a)) {
    return a === Number(b);
  }
  if (typeof b === 'number' && !(0, _isNan2.default)(b)) {
    return Number(a) === b;
  }
  return false;
}

function _areBooleanAndEquals(a, b) {
  if ('undefined'.includes(typeof a === 'undefined' ? 'undefined' : (0, _typeof3.default)(a), typeof b === 'undefined' ? 'undefined' : (0, _typeof3.default)(b)) || a === null || b === null) {
    return false;
  }
  return a === b;
}

function _arePrimitivesAndEquals(a, b) {
  if (_isTypeOf('number', a, b)) {
    return _areNumbersAndEquals(a, b);
  }
  if (_isTypeOf('string', a, b)) {
    return _areStringsAndEquals(a, b);
  }
  return _areBooleanAndEquals(a, b);
}

function _isObjectFalsy(obj) {
  if (obj === null) return true;
  if (obj instanceof Date) return false;

  for (var key in obj) {
    if (!!obj[key] === true) {
      return false;
    }
  }
  return true;
}

function _isLooseEqual(prop, a, b, propsToIgnore) {
  if (prop in b) {
    if ((0, _typeof3.default)(a[prop]) === 'object' && (0, _typeof3.default)(b[prop]) === 'object') {
      if (a[prop] === null && b[prop] === null) {
        return true;
      }
      if (a[prop] === null) {
        return _isObjectFalsy(b[prop]);
      }
      if (b[prop] === null) {
        return _isObjectFalsy(a[prop]);
      }
      if (a[prop] instanceof Date && b[prop] instanceof Date) {
        return a[prop].getTime() === b[prop].getTime();
      }
      return _isLooseDeepEqual(a[prop], b[prop], propsToIgnore);
    } else if (a[prop] !== b[prop]) {
      return _arePrimitivesAndEquals(a[prop], b[prop]);
    }
  } else if ((0, _typeof3.default)(a[prop]) === 'object') {
    return _isObjectFalsy(a[prop]);
  } else if (!a[prop]) {
    return false;
  }
  return true;
}

function _isLooseDeepEqual(a, b, propsToIgnore) {
  if (Array.isArray(a) && Array.isArray(b) && a.length !== b.length) {
    return false;
  }
  for (var prop in a) {
    if (propsToIgnore.includes(prop)) {
      continue;
    }
    if (!_isLooseEqual(prop, a, b, propsToIgnore)) {
      return false;
    }
  }
  for (var _prop in b) {
    if (propsToIgnore.includes(_prop)) {
      continue;
    }
    if (!_isLooseEqual(_prop, a, b, propsToIgnore)) {
      return false;
    }
  }
  return true;
}

function looseDeepEqual(a, b) {
  var propsToIgnore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (a === undefined || b === undefined) {
    return true;
  }
  return _isLooseDeepEqual(a, b, propsToIgnore);
}

exports.default = looseDeepEqual;

/***/ }),
/* 79 */
/* exports provided: props, formControlMixin */
/* exports used: props, formControlMixin */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-control.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formControlMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(/*! ../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);



 // --- Constants ---

var SELECTOR = 'input, textarea, select'; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  autofocus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  form: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, 'formControls'); // --- Mixin ---
// @vue/component

var formControlMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  mounted: function mounted() {
    this.handleAutofocus();
  },

  /* istanbul ignore next */
  activated: function activated() {
    this.handleAutofocus();
  },
  methods: {
    handleAutofocus: function handleAutofocus() {
      var _this = this;

      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* requestAF */])(function () {
          var el = _this.$el;

          if (_this.autofocus && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c" /* isVisible */])(el)) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["y" /* matches */])(el, SELECTOR)) {
              el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["h" /* select */])(SELECTOR, el);
            }

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["n" /* attemptFocus */])(el);
          }
        });
      });
    }
  }
});

/***/ }),
/* 80 */
/* exports provided: props, formSizeMixin */
/* exports used: props, formSizeMixin */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-size.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formSizeMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);


 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["b" /* makePropsConfigurable */])({
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */])
}, 'formControls'); // --- Mixin ---
// @vue/component

var formSizeMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  computed: {
    sizeFormClass: function sizeFormClass() {
      return [this.size ? "form-control-".concat(this.size) : null];
    }
  }
});

/***/ }),
/* 81 */
/* exports provided: props, formStateMixin */
/* exports used: props, formStateMixin */
/*!**************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-state.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formStateMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_inspect__ = __webpack_require__(/*! ../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_safe_vue_instance__ = __webpack_require__(/*! ../utils/safe-vue-instance */ 65);
/* Form control contextual state class computation
 *
 * Returned class is either 'is-valid' or 'is-invalid' based on the 'state' prop
 * state can be one of five values:
 *  - true for is-valid
 *  - false for is-invalid
 *  - null for no contextual state
 */




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  // Tri-state prop: true, false, null (or undefined)
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null)
}, 'formState'); // --- Mixin ---
// @vue/component

var formStateMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  computed: {
    computedState: function computedState() {
      // If not a boolean, ensure that value is null
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["k" /* isBoolean */])(this.state) ? this.state : null;
    },
    stateClass: function stateClass() {
      var state = this.computedState;
      return state === true ? 'is-valid' : state === false ? 'is-invalid' : null;
    },
    computedAriaInvalid: function computedAriaInvalid() {
      var ariaInvalid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_safe_vue_instance__["a" /* safeVueInstance */])(this).ariaInvalid;

      if (ariaInvalid === true || ariaInvalid === 'true' || ariaInvalid === '') {
        return 'true';
      }

      return this.computedState === false ? 'true' : ariaInvalid;
    }
  }
});

/***/ }),
/* 82 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_is-object.js ***!
  \*************************************************/
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 83 */
/* exports provided: default, VERSION, restArguments, isObject, isNull, isUndefined, isBoolean, isElement, isString, isNumber, isDate, isRegExp, isError, isSymbol, isArrayBuffer, isDataView, isArray, isFunction, isArguments, isFinite, isNaN, isTypedArray, isEmpty, isMatch, isEqual, isMap, isWeakMap, isSet, isWeakSet, keys, allKeys, values, pairs, invert, functions, methods, extend, extendOwn, assign, defaults, create, clone, tap, get, has, mapObject, identity, constant, noop, toPath, property, propertyOf, matcher, matches, times, random, now, escape, unescape, templateSettings, template, result, uniqueId, chain, iteratee, partial, bind, bindAll, memoize, delay, defer, throttle, debounce, wrap, negate, compose, after, before, once, findKey, findIndex, findLastIndex, sortedIndex, indexOf, lastIndexOf, find, detect, findWhere, each, forEach, map, collect, reduce, foldl, inject, reduceRight, foldr, filter, select, reject, every, all, some, any, contains, includes, include, invoke, pluck, where, max, min, shuffle, sample, sortBy, groupBy, indexBy, countBy, partition, toArray, size, pick, omit, first, head, take, initial, last, rest, tail, drop, compact, flatten, without, uniq, unique, union, intersection, difference, unzip, transpose, zip, object, range, chunk, mixin */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/underscore/modules/index-all.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_default_js__ = __webpack_require__(/*! ./index-default.js */ 1180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__index_default_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(/*! ./index.js */ 289);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["VERSION"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["restArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNull"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isUndefined"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isBoolean"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isElement"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isString"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNumber"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isRegExp"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSymbol"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArrayBuffer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isDataView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFunction"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isArguments"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isFinite"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isNaN"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isTypedArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEmpty"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMatch"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isEqual"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakMap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["isWeakSet"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["keys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["allKeys"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["values"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pairs"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invert"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["functions"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["methods"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extend"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["extendOwn"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["assign"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defaults"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["create"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["clone"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["get"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["has"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mapObject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["identity"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["constant"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["noop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toPath"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["property"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["propertyOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matcher"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["matches"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["times"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["random"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["now"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["escape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unescape"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["templateSettings"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["template"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["result"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniqueId"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chain"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["iteratee"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bind"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["bindAll"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["memoize"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["delay"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["defer"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["throttle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["debounce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["wrap"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["negate"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["after"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["before"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["once"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findKey"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findLastIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortedIndex"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["lastIndexOf"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["find"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["detect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["findWhere"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["each"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["forEach"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["map"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["collect"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduce"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldl"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["inject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reduceRight"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["foldr"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["filter"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["select"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["reject"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["every"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["all"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["some"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["any"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["contains"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["includes"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["include"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["invoke"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pluck"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["where"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["max"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["min"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["shuffle"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sample"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["sortBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["groupBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["indexBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["countBy"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["partition"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["toArray"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["size"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["pick"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["omit"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["first"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["head"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["take"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["initial"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["last"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["rest"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["tail"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["drop"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["compact"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["flatten"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["without"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["uniq"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unique"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["union"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["intersection"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["difference"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["unzip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["transpose"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["zip"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["object"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["range"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["chunk"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_1__index_js__["mixin"]; });
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.




/***/ }),
/* 84 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./client/components/modals/multiSelectModal/MultiSelectModal.vue ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-8bfa890c","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./MultiSelectModal.vue */ 1543)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MultiSelectModal.vue */ 845),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-8bfa890c"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./multiSelectModal.pug */ 1449),
  /* scopeId */
  "data-v-8bfa890c",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/multiSelectModal/MultiSelectModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MultiSelectModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8bfa890c", Component.options)
  } else {
    hotAPI.reload("data-v-8bfa890c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 85 */
/* exports provided: props, BButton */
/* exports used: BButton, props */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/button/button.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_router__ = __webpack_require__(/*! ../../utils/router */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












 // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_11__link_link__["b" /* props */], ['event', 'routerTag']);
delete linkProps.href.default;
delete linkProps.to.default;
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, linkProps), {}, {
  block: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  pill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Tri-state: `true`, `false` or `null`
  // => On, off, not a toggle
  pressed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  squared: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'button'),
  type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'button'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_63" /* NAME_BUTTON */]); // --- Helper methods ---
// Focus handler for toggle buttons
// Needs class of 'focus' when focused

var handleFocus = function handleFocus(event) {
  if (event.type === 'focusin') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["r" /* addClass */])(event.target, 'focus');
  } else if (event.type === 'focusout') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["q" /* removeClass */])(event.target, 'focus');
  }
}; // Is the requested button a link?
// If tag prop is set to `a`, we use a <b-link> to get proper disabled handling


var isLink = function isLink(props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_router__["a" /* isLink */])(props) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["p" /* isTag */])(props.tag, 'a');
}; // Is the button to be a toggle button?


var isToggle = function isToggle(props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["k" /* isBoolean */])(props.pressed);
}; // Is the button "really" a button?


var isButton = function isButton(props) {
  return !(isLink(props) || props.tag && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["p" /* isTag */])(props.tag, 'button'));
}; // Is the requested tag not a button or link?


var isNonStandardTag = function isNonStandardTag(props) {
  return !isLink(props) && !isButton(props);
}; // Compute required classes (non static classes)


var computeClass = function computeClass(props) {
  var _ref;

  return ["btn-".concat(props.variant || 'secondary'), (_ref = {}, _defineProperty(_ref, "btn-".concat(props.size), props.size), _defineProperty(_ref, 'btn-block', props.block), _defineProperty(_ref, 'rounded-pill', props.pill), _defineProperty(_ref, 'rounded-0', props.squared && !props.pill), _defineProperty(_ref, "disabled", props.disabled), _defineProperty(_ref, "active", props.pressed), _ref)];
}; // Compute the link props to pass to b-link (if required)


var computeLinkProps = function computeLinkProps(props) {
  return isLink(props) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["c" /* pluckProps */])(linkProps, props) : {};
}; // Compute the attributes for a button


var computeAttrs = function computeAttrs(props, data) {
  var button = isButton(props);
  var link = isLink(props);
  var toggle = isToggle(props);
  var nonStandardTag = isNonStandardTag(props);
  var hashLink = link && props.href === '#';
  var role = data.attrs && data.attrs.role ? data.attrs.role : null;
  var tabindex = data.attrs ? data.attrs.tabindex : null;

  if (nonStandardTag || hashLink) {
    tabindex = '0';
  }

  return {
    // Type only used for "real" buttons
    type: button && !link ? props.type : null,
    // Disabled only set on "real" buttons
    disabled: button ? props.disabled : null,
    // We add a role of button when the tag is not a link or button for ARIA
    // Don't bork any role provided in `data.attrs` when `isLink` or `isButton`
    // Except when link has `href` of `#`
    role: nonStandardTag || hashLink ? 'button' : role,
    // We set the `aria-disabled` state for non-standard tags
    'aria-disabled': nonStandardTag ? String(props.disabled) : null,
    // For toggles, we need to set the pressed state for ARIA
    'aria-pressed': toggle ? String(props.pressed) : null,
    // `autocomplete="off"` is needed in toggle mode to prevent some browsers
    // from remembering the previous setting when using the back button
    autocomplete: toggle ? 'off' : null,
    // `tabindex` is used when the component is not a button
    // Links are tabbable, but don't allow disabled, while non buttons or links
    // are not tabbable, so we mimic that functionality by disabling tabbing
    // when disabled, and adding a `tabindex="0"` to non buttons or non links
    tabindex: props.disabled && !button ? '-1' : tabindex
  };
}; // --- Main component ---
// @vue/component


var BButton = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_63" /* NAME_BUTTON */],
  functional: true,
  props: props,
  render: function render(h, _ref2) {
    var props = _ref2.props,
        data = _ref2.data,
        listeners = _ref2.listeners,
        children = _ref2.children;
    var toggle = isToggle(props);
    var link = isLink(props);
    var nonStandardTag = isNonStandardTag(props);
    var hashLink = link && props.href === '#';
    var on = {
      keydown: function keydown(event) {
        // When the link is a `href="#"` or a non-standard tag (has `role="button"`),
        // we add a keydown handlers for CODE_SPACE/CODE_ENTER

        /* istanbul ignore next */
        if (props.disabled || !(nonStandardTag || hashLink)) {
          return;
        }

        var keyCode = event.keyCode; // Add CODE_SPACE handler for `href="#"` and CODE_ENTER handler for non-standard tags

        if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["b" /* CODE_SPACE */] || keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["a" /* CODE_ENTER */] && nonStandardTag) {
          var target = event.currentTarget || event.target;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["f" /* stopEvent */])(event, {
            propagation: false
          });
          target.click();
        }
      },
      click: function click(event) {
        /* istanbul ignore if: blink/button disabled should handle this */
        if (props.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["l" /* isEvent */])(event)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["f" /* stopEvent */])(event);
        } else if (toggle && listeners && listeners['update:pressed']) {
          // Send `.sync` updates to any "pressed" prop (if `.sync` listeners)
          // `concat()` will normalize the value to an array without
          // double wrapping an array value in an array
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["b" /* concat */])(listeners['update:pressed']).forEach(function (fn) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["a" /* isFunction */])(fn)) {
              fn(!props.pressed);
            }
          });
        }
      }
    };

    if (toggle) {
      on.focusin = handleFocus;
      on.focusout = handleFocus;
    }

    var componentData = {
      staticClass: 'btn',
      class: computeClass(props),
      props: computeLinkProps(props),
      attrs: computeAttrs(props, data),
      on: on
    };
    return h(link ? __WEBPACK_IMPORTED_MODULE_11__link_link__["a" /* BLink */] : props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(_objectSpread(_objectSpread({}, data), {}, {
      props: undefined
    }), componentData), children);
  }
});

/***/ }),
/* 86 */
/* exports provided: listenersMixin */
/* exports used: listenersMixin */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/listeners.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listenersMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_cache__ = __webpack_require__(/*! ../utils/cache */ 463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue__ = __webpack_require__(/*! ../vue */ 0);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var listenersMixinVue2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_cache__["a" /* makePropCacheMixin */])('$listeners', 'bvListeners');
var listenersMixinVue3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue__["d" /* extend */])({
  data: function data() {
    return {
      bvListeners: {}
    };
  },
  created: function created() {
    this.bvListeners = _objectSpread({}, this.$listeners);
  },
  beforeUpdate: function beforeUpdate() {
    this.bvListeners = _objectSpread({}, this.$listeners);
  }
});
var listenersMixin = __WEBPACK_IMPORTED_MODULE_1__vue__["c" /* isVue3 */] ? listenersMixinVue3 : listenersMixinVue2;

/***/ }),
/* 87 */
/* exports provided: getConfig, getConfigValue, getComponentConfig, getBreakpoints, getBreakpointsCached, getBreakpointsUp, getBreakpointsUpCached, getBreakpointsDown, getBreakpointsDownCached */
/* exports used: getComponentConfig, getBreakpoints, getBreakpointsUpCached */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/config.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getConfig */
/* unused harmony export getConfigValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getComponentConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBreakpoints; });
/* unused harmony export getBreakpointsCached */
/* unused harmony export getBreakpointsUp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBreakpointsUpCached; });
/* unused harmony export getBreakpointsDown */
/* unused harmony export getBreakpointsDownCached */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_config__ = __webpack_require__(/*! ../constants/config */ 447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clone_deep__ = __webpack_require__(/*! ./clone-deep */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__memoize__ = __webpack_require__(/*! ./memoize */ 255);



 // --- Constants ---

var VueProto = __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].prototype; // --- Getter methods ---
// All methods return a deep clone (immutable) copy of the config value,
// to prevent mutation of the user config object
// Get the current config

var getConfig = function getConfig() {
  var bvConfig = VueProto[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]];
  return bvConfig ? bvConfig.getConfig() : {};
}; // Method to grab a config value based on a dotted/array notation key

var getConfigValue = function getConfigValue(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var bvConfig = VueProto[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]];
  return bvConfig ? bvConfig.getConfigValue(key, defaultValue) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clone_deep__["a" /* cloneDeep */])(defaultValue);
}; // Method to grab a config value for a particular component

var getComponentConfig = function getComponentConfig(key) {
  var propKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  // Return the particular config value for key if specified,
  // otherwise we return the full config (or an empty object if not found)
  return propKey ? getConfigValue("".concat(key, ".").concat(propKey), defaultValue) : getConfigValue(key, {});
}; // Get all breakpoint names

var getBreakpoints = function getBreakpoints() {
  return getConfigValue('breakpoints', __WEBPACK_IMPORTED_MODULE_1__constants_config__["c" /* DEFAULT_BREAKPOINT */]);
}; // Private method for caching breakpoint names

var _getBreakpointsCached = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__memoize__["a" /* memoize */])(function () {
  return getBreakpoints();
}); // Get all breakpoint names (cached)


var getBreakpointsCached = function getBreakpointsCached() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clone_deep__["a" /* cloneDeep */])(_getBreakpointsCached());
}; // Get breakpoints with the smallest breakpoint set as ''
// Useful for components that create breakpoint specific props

var getBreakpointsUp = function getBreakpointsUp() {
  var breakpoints = getBreakpoints();
  breakpoints[0] = '';
  return breakpoints;
}; // Get breakpoints with the smallest breakpoint set as '' (cached)
// Useful for components that create breakpoint specific props

var getBreakpointsUpCached = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__memoize__["a" /* memoize */])(function () {
  var breakpoints = getBreakpointsCached();
  breakpoints[0] = '';
  return breakpoints;
}); // Get breakpoints with the largest breakpoint set as ''

var getBreakpointsDown = function getBreakpointsDown() {
  var breakpoints = getBreakpoints();
  breakpoints[breakpoints.length - 1] = '';
  return breakpoints;
}; // Get breakpoints with the largest breakpoint set as '' (cached)
// Useful for components that create breakpoint specific props

/* istanbul ignore next: we don't use this method anywhere, yet */

var getBreakpointsDownCached = function getBreakpointsDownCached() {
  var breakpoints = getBreakpointsCached();
  breakpoints[breakpoints.length - 1] = '';
  return breakpoints;
};

/***/ }),
/* 88 */
/* exports provided: hasNormalizedSlot, normalizeSlot */
/* exports used: hasNormalizedSlot, normalizeSlot */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/normalize-slot.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasNormalizedSlot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeSlot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(/*! ./array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(/*! ./identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inspect__ = __webpack_require__(/*! ./inspect */ 9);


 // Note for functional components:
// In functional components, `slots` is a function so it must be called
// first before passing to the below methods. `scopedSlots` is always an
// object and may be undefined (for Vue < 2.6.x)

/**
 * Returns true if either scoped or unscoped named slot exists
 *
 * @param {String, Array} name or name[]
 * @param {Object} scopedSlots
 * @param {Object} slots
 * @returns {Array|undefined} VNodes
 */

var hasNormalizedSlot = function hasNormalizedSlot(names) {
  var $scopedSlots = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $slots = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // Ensure names is an array
  names = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* concat */])(names).filter(__WEBPACK_IMPORTED_MODULE_1__identity__["a" /* identity */]); // Returns true if the either a $scopedSlot or $slot exists with the specified name

  return names.some(function (name) {
    return $scopedSlots[name] || $slots[name];
  });
};
/**
 * Returns VNodes for named slot either scoped or unscoped
 *
 * @param {String, Array} name or name[]
 * @param {String} scope
 * @param {Object} scopedSlots
 * @param {Object} slots
 * @returns {Array|undefined} VNodes
 */

var normalizeSlot = function normalizeSlot(names) {
  var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $scopedSlots = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var $slots = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // Ensure names is an array
  names = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* concat */])(names).filter(__WEBPACK_IMPORTED_MODULE_1__identity__["a" /* identity */]);
  var slot;

  for (var i = 0; i < names.length && !slot; i++) {
    var name = names[i];
    slot = $scopedSlots[name] || $slots[name];
  } // Note: in Vue 2.6.x, all named slots are also scoped slots


  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["a" /* isFunction */])(slot) ? slot(scope) : slot;
};

/***/ }),
/* 89 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_an-object.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./_is-object */ 82);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 90 */
/* exports provided: Functions */
/* exports used: Functions */
/*!************************************!*\
  !*** ./~/dayspan/lib/Functions.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Functions; });

/**
 * The class which contains commonly used functions by the library. These
 * functions and variables exist in a class so they may be overridden if
 * desired.
 */
var Functions = (function () {
    function Functions() {
    }
    /**
     * Determines whether the given input is an array.
     *
     * @param input The variable to test.
     * @returns `true` if the variable is an array, otherwise `false`.
     */
    Functions.isArray = function (input) {
        return input instanceof Array;
    };
    /**
     * Determines whether the two arrays given are stricly equivalent. If the
     * arrays are not the same length or contain the same values in the same order
     * then `false` is returned.
     *
     * @param x The first array to test.
     * @param y The second array to test.
     * @returns `true` if they have the same exact values, otherwise `false`.
     */
    Functions.isArrayEquals = function (x, y) {
        if (x === y)
            return true;
        if (x.length !== y.length)
            return false;
        for (var i = 0; i < x.length; i++) {
            if (x[i] !== y[i]) {
                return false;
            }
        }
        return true;
    };
    /**
     * Determines whether the given input is a string.
     *
     * @param input The variable to test.
     * @returns `true` if the variable is a string, otherwise `false`.
     */
    Functions.isString = function (input) {
        return typeof (input) === 'string';
    };
    /**
     * Determines whether the given input is a finite number (a number which is
     * not infinite or not the result of a divide-by-zero operation).
     *
     * @param input The variable to test.
     * @returns `true` if the variable is a finite number, otherwise `false`.
     */
    Functions.isNumber = function (input) {
        return isFinite(input) && typeof input === 'number';
    };
    /**
     * Determines whether the given input is an object and NOT an array.
     *
     * @param input The variable to test.
     * @returns `true` if the variable is a plain object, otherwise `false`.
     */
    Functions.isObject = function (input) {
        return input !== null && !this.isArray(input) && typeof (input) === 'object';
    };
    /**
     * Determines whether the given input is defined.
     *
     * @param input The variable to test.
     * @return `true` if the variable is defined, otherwise `false`.
     */
    Functions.isDefined = function (input) {
        return typeof (input) !== 'undefined';
    };
    /**
     * Determines whether the given input is defined and not null.
     *
     * @param input The variable to test.
     * @return `true` if the variable is defined and not null, otherwise `false`.
     */
    Functions.isValue = function (input) {
        return input !== null && typeof (input) !== 'undefined';
    };
    /**
     * Determines whether the given input appears to be a valid
     * [[FrequencyValueEvery]].
     *
     * ```typescript
     * Functions.isFrequencyValueEvery({});                   // false
     * Functions.isFrequencyValueEvery([]);                   // false
     * Functions.isFrequencyValueEvery([1]);                  // false
     * Functions.isFrequencyValueEvery(null);                 // false
     * Functions.isFrequencyValueEvery({every:2});            // true
     * Functions.isFrequencyValueEvery({offset:1});           // false
     * Functions.isFrequencyValueEvery({every:2, offset:1});  // true
     * ```
     *
     * @param input The variable to test.
     * @returns `true` if the variable appears to be a [[FrequencyValueEvery]],
     *    otherwise false.
     */
    Functions.isFrequencyValueEvery = function (input) {
        return this.isObject(input) && this.isNumber(input.every);
    };
    /**
     * Determines whether the given input appears to be a valid
     * [[FrequencyValueOneOf]].
     *
     * ```typescript
     * Functions.isFrequencyValueOneOf({});    // false
     * Functions.isFrequencyValueOneOf([]);    // false
     * Functions.isFrequencyValueOneOf([1]);   // true
     * Functions.isFrequencyValueOneOf(null);  // false
     * ```
     *
     * @param input The variable to test.
     * @returns `true` if the variable appears to be a [[FrequencyValueOneOf]],
     *    otherwise false.
     */
    Functions.isFrequencyValueOneOf = function (input) {
        return this.isArray(input) && input.length > 0;
    };
    /**
     * Returns the first argument which is defined.
     *
     * ```typescript
     * Functions.coalesce(3, 4);                // 3
     * Functions.coalesce(undefined, 4);        // 4
     * Functions.coalesce(null, 4);             // null
     * Functions.coalesce(void 0, void 0, 5);   // 5
     * ```
     *
     * @param a The first argument to look at.
     * @param b The second argument to look at.
     * @returns The first defined argument.
     * @see [[Functions.isDefined]]
     */
    Functions.coalesce = function (a, b, c) {
        return this.isDefined(a) ? a : (this.isDefined(b) ? b : c);
    };
    /**
     * Copies values from `from` object and sets them to the `target` object.
     *
     * @param target The object to set values to.
     * @param from The object to copy value references from.
     * @returns The reference to `target`.
     */
    Functions.extend = function (target, from) {
        for (var prop in from) {
            target[prop] = from[prop];
        }
        return target;
    };
    /**
     * Pads the string `x` up to `length` characters with the given `padding`
     * optionally placing the `padding` `before` `x`.
     *
     * ```typescript
     * Functions.pad('hey', 5, '_', false);   // 'hey__'
     * Functions.pad('hey', 5, '_', true);    // '__hey'
     * Functions.pad('heyman', 5, '_', true); // 'heyman'
     * ```
     *
     * @param x The string to pad.
     * @param length The length to pad to.
     * @param padding The string to pad with.
     * @param before If the padding should go before the string to pad.
     * @returns The padded string if any padding needed be added.
     */
    Functions.pad = function (x, length, padding, before) {
        while (x.length < length) {
            before ? x = padding + x : x = x + padding;
        }
        return x;
    };
    /**
     * Pads the number `x` up to `length` digits where the padding is `0` and it
     * goes before `x`. This function will only return the first `length`
     * characters of the padding string representation of the number but can return
     * an alternative number of `first` characters.
     *
     * ```typescript
     * Functions.padNumber(29, 3);      // '029'
     * Functions.padNumber(29, 3, 2);   // '02'
     * Functions.padNumber(9573, 3);    // '957'
     * ```
     *
     * @param x The number to pad with zeros in the beginning.
     * @param length The number of digits the number should be padded to.
     * @param first The number of digits to return from the start of the string.
     * @returns A padded number.
     */
    Functions.padNumber = function (x, length, first) {
        if (first === void 0) { first = length; }
        return this.pad(x + '', length, '0', true).substring(0, first);
    };
    return Functions;
}());

//# sourceMappingURL=Functions.js.map

/***/ }),
/* 91 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/vue-nav-tabs/dist/vue-tabs.common.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * vue-nav-tabs v0.5.4
 * (c) 2017-present cristij <joracristi@gmail.com>
 * Released under the MIT License.
 */


Object.defineProperty(exports, '__esModule', { value: true });

var VueTabs = {
    name: 'vue-tabs',
    props: {
        activeTabColor: String,
        activeTextColor: String,
        disabledColor: String,
        disabledTextColor: String,
        /**
         * Tab title position: center | bottom | top
         */
        textPosition: {
            type: String,
            default: 'center'
        },
        /**
         * Tab type: tabs | pills
         */
        type: {
            type: String,
            default: 'tabs'
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        /**
         * Centers the tabs and makes the container div full width
         */
        centered: Boolean,
        value: [String, Number, Object]
    },
    data: function data() {
        return {
            activeTabIndex: 0,
            tabs: []
        };
    },

    computed: {
        isTabShape: function isTabShape() {
            return this.type === 'tabs';
        },
        isStacked: function isStacked() {
            return this.direction === 'vertical';
        },
        classList: function classList() {
            var navType = this.isTabShape ? 'nav-tabs' : 'nav-pills';
            var centerClass = this.centered ? 'nav-justified' : '';
            var isStacked = this.isStacked ? 'nav-stacked' : '';
            return 'nav ' + navType + ' ' + centerClass + ' ' + isStacked;
        },
        stackedClass: function stackedClass() {
            return this.isStacked ? 'stacked' : '';
        },
        activeTabStyle: function activeTabStyle() {
            return {
                backgroundColor: this.activeTabColor,
                color: this.activeTextColor
            };
        }
    },
    methods: {
        navigateToTab: function navigateToTab(index, route) {
            this.changeTab(this.activeTabIndex, index, route);
        },
        activateTab: function activateTab(index) {
            this.activeTabIndex = index;
            var tab = this.tabs[index];
            tab.active = true;
            this.$emit('input', tab.title);
        },
        changeTab: function changeTab(oldIndex, newIndex, route) {
            var oldTab = this.tabs[oldIndex];
            var newTab = this.tabs[newIndex];
            if (newTab.disabled) return;
            this.activeTabIndex = newIndex;
            oldTab.active = false;
            newTab.active = true;
            this.$emit('input', this.tabs[newIndex].title);
            this.$emit('tab-change', newIndex, newTab, oldTab);
            this.tryChangeRoute(route);
        },
        tryChangeRoute: function tryChangeRoute(route) {
            if (this.$router && route) {
                this.$router.push(route);
            }
        },
        addTab: function addTab(item) {
            var index = this.$slots.default.indexOf(item.$vnode);
            this.tabs.splice(index, 0, item);
        },
        removeTab: function removeTab(item) {
            var tabs = this.tabs;
            var index = tabs.indexOf(item);
            if (index > -1) {
                tabs.splice(index, 1);
            }
        },
        getTabs: function getTabs() {
            if (this.$slots.default) {
                return this.$slots.default.filter(function (comp) {
                    return comp.componentOptions;
                });
            }
            return [];
        },
        findTabAndActivate: function findTabAndActivate(tabNameOrIndex) {
            var indexToActivate = this.tabs.findIndex(function (tab, index) {
                return tab.title === tabNameOrIndex || index === tabNameOrIndex;
            });
            if (indexToActivate === this.activeTabIndex) return;
            if (indexToActivate !== -1) {
                this.changeTab(this.activeTabIndex, indexToActivate);
            } else {
                this.changeTab(this.activeTabIndex, 0);
            }
        },
        renderTabTitle: function renderTabTitle(index) {
            var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
            var h = this.$createElement;

            if (this.tabs.length === 0) return;
            var tab = this.tabs[index];
            var active = tab.active,
                title = tab.title;

            var titleStyles = { color: this.activeTabColor };
            if (position === 'center') titleStyles.color = this.activeTextColor;
            var simpleTitle = h(
                'span',
                { 'class': 'title title_' + position, style: active ? titleStyles : {} },
                [position === 'center' && this.renderIcon(index), title]
            );

            if (tab.$slots.title) return tab.$slots.title;
            return simpleTitle;
        },
        renderIcon: function renderIcon(index) {
            var h = this.$createElement;

            if (this.tabs.length === 0) return;
            var tab = this.tabs[index];
            var icon = tab.icon;

            var simpleIcon = h(
                'i',
                { 'class': icon },
                ['\xA0']
            );
            if (!tab.$slots.title && icon) return simpleIcon;
        },
        tabStyles: function tabStyles(tab) {
            if (tab.disabled) {
                return {
                    backgroundColor: this.disabledColor,
                    color: this.disabledTextColor
                };
            }
            return {};
        },
        renderTabs: function renderTabs() {
            var _this = this;

            var h = this.$createElement;

            return this.tabs.map(function (tab, index) {
                if (!tab) return;
                var route = tab.route,
                    id = tab.id,
                    title = tab.title,
                    icon = tab.icon;

                var active = _this.activeTabIndex === index;
                return h(
                    'li',
                    {
                        attrs: { name: 'tab',
                            role: 'presentation' },
                        on: {
                            'click': function click() {
                                return !tab.disabled && _this.navigateToTab(index, route);
                            }
                        },

                        'class': ['tab', { active: active }, { disabled: tab.disabled }],
                        key: title },
                    [_this.textPosition === 'top' && _this.renderTabTitle(index, _this.textPosition), h(
                        'a',
                        {
                            attrs: { href: 'javascript:void(0)',

                                'aria-selected': active,
                                'aria-controls': '#' + id,
                                role: 'tab' },
                            style: active ? _this.activeTabStyle : _this.tabStyles(tab),
                            'class': { 'active_tab': active } },
                        [_this.textPosition !== 'center' && !tab.$slots.title && _this.renderIcon(index), _this.textPosition === 'center' && _this.renderTabTitle(index, _this.textPosition)]
                    ), _this.textPosition === 'bottom' && _this.renderTabTitle(index, _this.textPosition)]
                );
            });
        }
    },
    render: function render() {
        var h = arguments[0];

        var tabList = this.renderTabs();
        return h(
            'div',
            { 'class': ['vue-tabs', this.stackedClass] },
            [h(
                'div',
                { 'class': [{ 'nav-tabs-navigation': !this.isStacked }, { 'left-vertical-tabs': this.isStacked }] },
                [h(
                    'div',
                    { 'class': ['nav-tabs-wrapper', this.stackedClass] },
                    [h(
                        'ul',
                        { 'class': this.classList, attrs: { role: 'tablist' }
                        },
                        [tabList]
                    )]
                )]
            ), h(
                'div',
                { 'class': ['tab-content', { 'right-text-tabs': this.isStacked }] },
                [this.$slots.default]
            )]
        );
    },

    watch: {
        tabs: function tabs(newList) {
            if (newList.length > 0 && !this.value) {
                this.activateTab(this.activeTabIndex);
            }
            if (newList.length > 0 && this.value) {
                this.findTabAndActivate(this.value);
            }
        },
        value: function value(newVal) {
            this.findTabAndActivate(newVal);
        }
    }
};

var VTab = {
    name: 'v-tab',
    props: {
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        /***
         * Function to execute before tab switch. Return value must be boolean
         * If the return result is false, tab switch is restricted
         */
        beforeChange: {
            type: Function
        },
        id: String,
        route: {
            type: [String, Object]
        },
        disabled: Boolean,
        transitionName: String,
        transitionMode: String
    },
    computed: {
        isValidParent: function isValidParent() {
            return this.$parent.$options.name === 'vue-tabs';
        },
        hash: function hash() {
            return '#' + this.id;
        }
    },
    data: function data() {
        return {
            active: false,
            validationError: null
        };
    },
    mounted: function mounted() {
        this.$parent.addTab(this);
    },
    destroyed: function destroyed() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
        this.$parent.removeTab(this);
    },
    render: function render() {
        var h = arguments[0];

        return h(
            'section',
            { 'class': 'tab-container',
                attrs: { role: 'tabpanel' },
                directives: [{
                    name: 'show',
                    value: this.active
                }]
            },
            [this.$slots.default]
        );
    }
};

var VueTabsPlugin = {
  install: function install(Vue) {
    Vue.component('vue-tabs', VueTabs);
    Vue.component('v-tab', VTab);
  }
};
// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueTabsPlugin);
  window.VueTabs = VueTabsPlugin;
}

exports['default'] = VueTabsPlugin;
exports.VueTabs = VueTabs;
exports.VTab = VTab;


/***/ }),
/* 92 */
/* exports provided: props, BTr */
/* exports used: BTr */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/tr.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Constants ---

var LIGHT = 'light';
var DARK = 'dark'; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["v" /* NAME_TR */]); // --- Main component ---
// TODO:
//   In Bootstrap v5, we won't need "sniffing" as table element variants properly inherit
//   to the child elements, so this can be converted to a functional component
// @vue/component

var BTr = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["v" /* NAME_TR */],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvTableTr: function getBvTableTr() {
        return _this;
      }
    };
  },
  inject: {
    getBvTableRowGroup: {
      default:
      /* istanbul ignore next */
      function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  inheritAttrs: false,
  props: props,
  computed: {
    bvTableRowGroup: function bvTableRowGroup() {
      return this.getBvTableRowGroup();
    },
    // Sniffed by `<b-td>` / `<b-th>`
    inTbody: function inTbody() {
      return this.bvTableRowGroup.isTbody;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    inThead: function inThead() {
      return this.bvTableRowGroup.isThead;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    inTfoot: function inTfoot() {
      return this.bvTableRowGroup.isTfoot;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    isDark: function isDark() {
      return this.bvTableRowGroup.isDark;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    isStacked: function isStacked() {
      return this.bvTableRowGroup.isStacked;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    isResponsive: function isResponsive() {
      return this.bvTableRowGroup.isResponsive;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    // Sticky headers are only supported in thead
    isStickyHeader: function isStickyHeader() {
      return this.bvTableRowGroup.isStickyHeader;
    },
    // Sniffed by <b-tr> / `<b-td>` / `<b-th>`
    // Needed to handle header background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    hasStickyHeader: function hasStickyHeader() {
      return !this.isStacked && this.bvTableRowGroup.hasStickyHeader;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    tableVariant: function tableVariant() {
      return this.bvTableRowGroup.tableVariant;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    headVariant: function headVariant() {
      return this.inThead ? this.bvTableRowGroup.headVariant : null;
    },
    // Sniffed by `<b-td>` / `<b-th>`
    footVariant: function footVariant() {
      return this.inTfoot ? this.bvTableRowGroup.footVariant : null;
    },
    isRowDark: function isRowDark() {
      return this.headVariant === LIGHT || this.footVariant === LIGHT ?
      /* istanbul ignore next */
      false : this.headVariant === DARK || this.footVariant === DARK ?
      /* istanbul ignore next */
      true : this.isDark;
    },
    trClasses: function trClasses() {
      var variant = this.variant;
      return [variant ? "".concat(this.isRowDark ? 'bg' : 'table', "-").concat(variant) : null];
    },
    trAttrs: function trAttrs() {
      return _objectSpread({
        role: 'row'
      }, this.bvAttrs);
    }
  },
  render: function render(h) {
    return h('tr', {
      class: this.trClasses,
      attrs: this.trAttrs,
      // Pass native listeners to child
      on: this.bvListeners
    }, this.normalizeSlot());
  }
});

/***/ }),
/* 93 */
/* exports provided: Element, HTMLElement, SVGElement, File */
/* exports used: File, Element, HTMLElement, SVGElement */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/safe-types.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Element; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HTMLElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SVGElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return File; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(/*! ./env */ 30);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


/* istanbul ignore next */

var Element = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* HAS_WINDOW_SUPPORT */] ? __WEBPACK_IMPORTED_MODULE_0__env__["b" /* WINDOW */].Element : /*#__PURE__*/function (_Object) {
  _inherits(Element, _Object);

  var _super = _createSuper(Element);

  function Element() {
    _classCallCheck(this, Element);

    return _super.apply(this, arguments);
  }

  return Element;
}( /*#__PURE__*/_wrapNativeSuper(Object));
/* istanbul ignore next */

var HTMLElement = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* HAS_WINDOW_SUPPORT */] ? __WEBPACK_IMPORTED_MODULE_0__env__["b" /* WINDOW */].HTMLElement : /*#__PURE__*/function (_Element) {
  _inherits(HTMLElement, _Element);

  var _super2 = _createSuper(HTMLElement);

  function HTMLElement() {
    _classCallCheck(this, HTMLElement);

    return _super2.apply(this, arguments);
  }

  return HTMLElement;
}(Element);
/* istanbul ignore next */

var SVGElement = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* HAS_WINDOW_SUPPORT */] ? __WEBPACK_IMPORTED_MODULE_0__env__["b" /* WINDOW */].SVGElement : /*#__PURE__*/function (_Element2) {
  _inherits(SVGElement, _Element2);

  var _super3 = _createSuper(SVGElement);

  function SVGElement() {
    _classCallCheck(this, SVGElement);

    return _super3.apply(this, arguments);
  }

  return SVGElement;
}(Element);
/* istanbul ignore next */

var File = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* HAS_WINDOW_SUPPORT */] ? __WEBPACK_IMPORTED_MODULE_0__env__["b" /* WINDOW */].File : /*#__PURE__*/function (_Object2) {
  _inherits(File, _Object2);

  var _super4 = _createSuper(File);

  function File() {
    _classCallCheck(this, File);

    return _super4.apply(this, arguments);
  }

  return File;
}( /*#__PURE__*/_wrapNativeSuper(Object));

/***/ }),
/* 94 */
/* exports provided: useParentMixin */
/* exports used: useParentMixin */
/*!**************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/use-parent.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useParentMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
 // --- Mixin ---
// @vue/component

var useParentMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  computed: {
    bvParent: function bvParent() {
      return this.$parent || this.$root === this && this.$options.bvParent;
    }
  }
});

/***/ }),
/* 95 */
/* exports provided: createNewChildComponent */
/* exports used: createNewChildComponent */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/create-new-child-component.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createNewChildComponent; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createNewChildComponent = function createNewChildComponent(parent, Component) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var bvEventRoot = parent.$root ? parent.$root.$options.bvEventRoot || parent.$root : null;
  return new Component(_objectSpread(_objectSpread({}, config), {}, {
    parent: parent,
    bvParent: parent,
    bvEventRoot: bvEventRoot
  }));
};

/***/ }),
/* 96 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/core-js/library/modules/_ctx.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(/*! ./_a-function */ 142);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 97 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/core-js/library/modules/_hide.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(/*! ./_object-dp */ 75);
var createDesc = __webpack_require__(/*! ./_property-desc */ 147);
module.exports = __webpack_require__(/*! ./_descriptors */ 66) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 98 */
/* exports provided: Constants */
/* exports used: Constants */
/*!************************************!*\
  !*** ./~/dayspan/lib/Constants.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Constants; });

/**
 * A class that stores commonly used values.
 */
var Constants = (function () {
    function Constants() {
    }
    /**
     * The number of milliseconds in a second.
     */
    Constants.MILLIS_IN_SECOND = 1000;
    /**
     * The number of milliseconds in a minute.
     */
    Constants.MILLIS_IN_MINUTE = Constants.MILLIS_IN_SECOND * 60;
    /**
     * The number of milliseconds in an hour.
     */
    Constants.MILLIS_IN_HOUR = Constants.MILLIS_IN_MINUTE * 60;
    /**
     * The number of milliseconds in a day (not including DST days).
     */
    Constants.MILLIS_IN_DAY = Constants.MILLIS_IN_HOUR * 24;
    /**
     * The number of milliseconds in a week (not including ones that include DST).
     */
    Constants.MILLIS_IN_WEEK = Constants.MILLIS_IN_DAY * 7;
    /**
     * The number of minutes in an hour.
     */
    Constants.MINUTES_IN_HOUR = 60;
    /**
     * The number of minutes in a day (not including DST days).
     */
    Constants.MINUTES_IN_DAY = 60 * 24;
    /**
     * The number of days in a week.
     */
    Constants.DAYS_IN_WEEK = 7;
    /**
     * The number of months in a year.
     */
    Constants.MONTHS_IN_YEAR = 12;
    /**
     * The number of hours in a day (not including DST days).
     */
    Constants.HOURS_IN_DAY = 24;
    /**
     * The first month of the year.
     */
    Constants.MONTH_MIN = 0;
    /**
     * The last month of the year.
     */
    Constants.MONTH_MAX = 11;
    /**
     * The first day of a month.
     */
    Constants.DAY_MIN = 1;
    /**
     * The last day of the longest month.
     */
    Constants.DAY_MAX = 31;
    /**
     * The first hour of the day.
     */
    Constants.HOUR_MIN = 0;
    /**
     * The last hour of the day.
     */
    Constants.HOUR_MAX = 23;
    /**
     * The first minute of the hour.
     */
    Constants.MINUTE_MIN = 0;
    /**
     * The last minute of the hour.
     */
    Constants.MINUTE_MAX = 59;
    /**
     * The first second of the minute.
     */
    Constants.SECOND_MIN = 0;
    /**
     * The last second of the minute.
     */
    Constants.SECOND_MAX = 59;
    /**
     * The first millisecond of the second.
     */
    Constants.MILLIS_MIN = 0;
    /**
     * The last millisecond of the second.
     */
    Constants.MILLIS_MAX = 999;
    /**
     * The first day of the week.
     */
    Constants.WEEKDAY_MIN = 0;
    /**
     * The last day of the week.
     */
    Constants.WEEKDAY_MAX = 6;
    /**
     * The default duration for an event.
     */
    Constants.DURATION_DEFAULT = 1;
    /**
     * The default duration unit for an all day event.
     */
    Constants.DURATION_DEFAULT_UNIT_ALL = 'days';
    /**
     * The default duration unit for an event at a given time.
     */
    Constants.DURATION_DEFAULT_UNIT_TIMES = 'hours';
    /**
     * Computes the duration unit given its for an all day event.
     *
     * @param all If the event is all day.
     * @return The default unit for the event.
     */
    Constants.DURATION_DEFAULT_UNIT = function (all) { return all ? Constants.DURATION_DEFAULT_UNIT_ALL :
        Constants.DURATION_DEFAULT_UNIT_TIMES; };
    /**
     * The number of milliseconds for various duration units. These are worse case
     * scenario and do not include DST changes.
     */
    Constants.DURATION_TO_MILLIS = {
        minute: Constants.MILLIS_IN_MINUTE,
        minutes: Constants.MILLIS_IN_MINUTE,
        hour: Constants.MILLIS_IN_HOUR,
        hours: Constants.MILLIS_IN_HOUR,
        day: Constants.MILLIS_IN_DAY,
        days: Constants.MILLIS_IN_DAY,
        week: Constants.MILLIS_IN_WEEK,
        weeks: Constants.MILLIS_IN_WEEK,
        month: Constants.MILLIS_IN_DAY * Constants.DAY_MAX,
        months: Constants.MILLIS_IN_DAY * Constants.DAY_MAX
    };
    /**
     * The maximum estimated number of events per day. This is used to calculate
     * [[CalendarEvent.id]] to give each event a unique ID. If you think you will
     * have more events than this per day, you can enlarge the value.
     */
    Constants.MAX_EVENTS_PER_DAY = 24;
    /**
     * The day of the week which determines the first week of the year or month.
     * By default this day is Thursday.
     */
    Constants.WEEK_OF_MONTH_MINIMUM_WEEKDAY = 4;
    return Constants;
}());

//# sourceMappingURL=Constants.js.map

/***/ }),
/* 99 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/_has.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// Internal function to check whether `key` is an own property name of `obj`.
function has(obj, key) {
  return obj != null && __WEBPACK_IMPORTED_MODULE_0__setup_js__["f" /* hasOwnProperty */].call(obj, key);
}


/***/ }),
/* 100 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/components/modals/modal/Modal.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-13215916","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Modal.vue */ 1483)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Modal.vue */ 844),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-13215916"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./modal.pug */ 1370),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/modal/Modal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Modal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13215916", Component.options)
  } else {
    hotAPI.reload("data-v-13215916", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 101 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vuejs-datepicker/dist/vuejs-datepicker.esm.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__ = __webpack_require__(/*! vue-the-mask */ 133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_the_mask__);
/*!
 * vuejs-datepicker v1.5.4
 * (c) 2016-2019 Charlie Kassel
 * Released under the MIT License.
 */


var Language = function Language (language, months, monthsAbbr, days) {
  this.language = language;
  this.months = months;
  this.monthsAbbr = monthsAbbr;
  this.days = days;
  this.rtl = false;
  this.ymd = false;
  this.yearSuffix = '';
};

var prototypeAccessors = { language: { configurable: true },months: { configurable: true },monthsAbbr: { configurable: true },days: { configurable: true } };

prototypeAccessors.language.get = function () {
  return this._language
};

prototypeAccessors.language.set = function (language) {
  if (typeof language !== 'string') {
    throw new TypeError('Language must be a string')
  }
  this._language = language;
};

prototypeAccessors.months.get = function () {
  return this._months
};

prototypeAccessors.months.set = function (months) {
  if (months.length !== 12) {
    throw new RangeError(("There must be 12 months for " + (this.language) + " language"))
  }
  this._months = months;
};

prototypeAccessors.monthsAbbr.get = function () {
  return this._monthsAbbr
};

prototypeAccessors.monthsAbbr.set = function (monthsAbbr) {
  if (monthsAbbr.length !== 12) {
    throw new RangeError(("There must be 12 abbreviated months for " + (this.language) + " language"))
  }
  this._monthsAbbr = monthsAbbr;
};

prototypeAccessors.days.get = function () {
  return this._days
};

prototypeAccessors.days.set = function (days) {
  if (days.length !== 7) {
    throw new RangeError(("There must be 7 days for " + (this.language) + " language"))
  }
  this._days = days;
};

Object.defineProperties( Language.prototype, prototypeAccessors );

var en = new Language(
  'English',
  ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
)
// eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,
  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear (date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear()
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth (date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth()
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate (date) {
    return this.useUtc ? date.getUTCDate() : date.getDate()
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay (date) {
    return this.useUtc ? date.getUTCDay() : date.getDay()
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours (date) {
    return this.useUtc ? date.getUTCHours() : date.getHours()
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes (date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes()
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear (date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value)
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth (date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value)
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate (date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value)
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates (date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }
    return d1.getTime() === d2.getTime()
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate (date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false
    }
    return !isNaN(date.getTime())
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr (date, days) {
    if (typeof date !== 'object') {
      throw TypeError('Invalid Type')
    }
    return days[this.getDay(date)]
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName (month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array')
    }
    if (typeof month === 'object') {
      return months[this.getMonth(month)]
    }
    if (typeof month === 'number') {
      return months[month]
    }
    throw TypeError('Invalid type')
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr (month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array')
    }
    if (typeof month === 'object') {
      return monthsAbbr[this.getMonth(month)]
    }
    if (typeof month === 'number') {
      return monthsAbbr[month]
    }
    throw TypeError('Invalid type')
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth (year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? (!(year % 4) && year % 100) || !(year % 400) ? 29 : 28 : 31
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix (day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st'
      case 2:
      case 22:
        return 'nd'
      case 3:
      case 23:
        return 'rd'
      default:
        return 'th'
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate (date, format, translation) {
    translation = (!translation) ? en : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format
      .replace(/dd/, ('0' + day).slice(-2))
      .replace(/d/, day)
      .replace(/yyyy/, year)
      .replace(/yy/, String(year).slice(2))
      .replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months))
      .replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr))
      .replace(/MM/, ('0' + month).slice(-2))
      .replace(/M(?!a|ä|e)/, month)
      .replace(/su/, this.getNthSuffix(this.getDate(date)))
      .replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray (start, end) {
    var this$1 = this;

    var dates = [];
    while (start <= end) {
      dates.push(new Date(start));
      start = this$1.setDate(new Date(start), this$1.getDate(new Date(start)) + 1);
    }
    return dates
  },

  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function validateDateInput (val) {
    return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number'
  }
};

var makeDateUtils = function (useUtc) { return (Object.assign({}, utils, {useUtc: useUtc})); };

var utils$1 = Object.assign({}, utils)
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var DateInput = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'input-group' : _vm.bootstrapStyling}},[(_vm.useMask())?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.vMaskPattern),expression:"vMaskPattern"}],ref:_vm.refName,class:_vm.computedInputClass,attrs:{"type":_vm.inline ? 'hidden' : 'text',"name":_vm.name,"id":_vm.id,"open-date":_vm.openDate,"placeholder":_vm.placeholder,"clear-button":_vm.clearButton,"disabled":_vm.disabled,"required":_vm.required,"readonly":!_vm.typeable,"autocomplete":"off"},domProps:{"value":_vm.formattedValue},on:{"keyup":_vm.parseTypedDate,"blur":_vm.inputBlurred}}):_c('input',{ref:_vm.refName,class:_vm.computedInputClass,attrs:{"type":_vm.inline ? 'hidden' : 'text',"name":_vm.name,"id":_vm.id,"open-date":_vm.openDate,"placeholder":_vm.placeholder,"clear-button":_vm.clearButton,"disabled":_vm.disabled,"required":_vm.required,"readonly":!_vm.typeable,"autocomplete":"off"},domProps:{"value":_vm.formattedValue},on:{"keyup":_vm.parseTypedDate,"blur":_vm.inputBlurred}}),_vm._v(" "),(_vm.calendarButton)?_c('span',{staticClass:"vdp-datepicker__calendar-button",class:{'input-group-prepend' : _vm.bootstrapStyling},style:({'cursor:not-allowed;' : _vm.disabled}),on:{"click":_vm.showCalendar}},[_c('span',{class:{'input-group-text' : _vm.bootstrapStyling}},[_c('i',{class:_vm.calendarButtonIcon},[_vm._v(" "+_vm._s(_vm.calendarButtonIconContent)+" "),(!_vm.calendarButtonIcon)?_c('span',[_vm._v("…")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.clearButton && _vm.selectedDate)?_c('span',{staticClass:"vdp-datepicker__clear-button",class:{'input-group-append' : _vm.bootstrapStyling},on:{"click":function($event){_vm.clearDate();}}},[_c('span',{class:{'input-group-text' : _vm.bootstrapStyling}},[_c('i',{class:_vm.clearButtonIcon},[(!_vm.clearButtonIcon)?_c('span',[_vm._v("×")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_vm._t("afterDateInput")],2)},staticRenderFns: [],
  directives: {mask: __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__["mask"]},
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean,
    vMaskPattern: String

  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    }
  },
  computed: {
    formattedValue: function formattedValue () {
      if (!this.selectedDate) {
        return null
      }
      if (this.typedDate) {
        return this.typedDate
      }
      return typeof this.format === 'function'
        ? this.format(this.selectedDate)
        : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation)
    },

    computedInputClass: function computedInputClass () {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ')
        }
        return Object.assign({}, {'form-control': true}, this.inputClass)
      }
      return this.inputClass
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate () {
      this.typedDate = false;
    }
  },
  methods: {
    useMask: function useMask () {
      return (this.vMaskPattern && this.vMaskPattern !== '')
    },
    showCalendar: function showCalendar () {
      this.input.focus();
      this.$emit('showCalendar');
    },
    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate (event) {
      // close calendar if escape or enter are pressed
      if ([
        27, // escape
        13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }
      var inp = event.key;
      var rgx = /[a-zA-Z0-9-_ ]/;
      if (this.typeable && rgx.test(inp)) {
        var parseableDate = this.parseableDate(this.input.value, this.format);
        var parsedDate = Date.parse(parseableDate);
        if (!isNaN(parsedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(parsedDate));
        }
      }
    },

    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred () {
      var parseableDate = this.parseableDate(this.input.value, this.format);
      if (isNaN(Date.parse(parseableDate))) {
        if (this.openDate) {
          this.typedDate = this.utils.formatDate(this.openDate, this.format, this.translation);
          this.input.value = this.typedDate;
          this.$emit('typedDate', this.openDate);
        } else {
          this.clearDate();
          this.input.value = null;
          this.typedDate = null;
        }
      }

      this.$emit('closeCalendar');
    },

    /**
     * emit a clearDate event
     */
    clearDate: function clearDate () {
      this.$emit('clearDate');
    },

     /**
     * makes date parseable
     * to use with international dates
     */
    parseableDate: function parseableDate (datestr, formatstr) {
      if (!(datestr && formatstr)) { return datestr }
      var splitter = formatstr.match(/-|\/|\s|\./) || ['-'];
      var df = formatstr.split(splitter[0]);
      var ds = datestr.split(splitter[0]);
      var ymd = [0, 0, 0];
      var dat;
      for (var i = 0; i < df.length; i++) {
        if (/yyyy/i.test(df[i])) {
          ymd[0] = ds[i];
        } else if (/mm/i.test(df[i])) {
          ymd[1] = ds[i];
        } else if (/m/i.test(df[i])) {
          ymd[1] = ds[i];
        } else if (/dd/i.test(df[i])) {
          ymd[2] = ds[i];
        } else if (/d/i.test(df[i])) {
          ymd[2] = ds[i];
        }
      }
      dat = ymd.join('-') + 'T00:00:00';
      if (isNaN(Date.parse(dat))) {
        return null
      }
      return dat
    }

  },
  mounted: function mounted () {
    this.input = this.$el.querySelector('input');
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerDay = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDayView),expression:"showDayView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();}}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"day__month_btn",class:_vm.allowedToShowView('month') ? 'up' : '',on:{"click":_vm.showMonthCalendar}},[_vm._v(_vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName)+" "+_vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();}}},[_vm._v(">")])]),_vm._v(" "),_c('div',{class:_vm.isRtl ? 'flex-rtl' : ''},[_vm._l((_vm.daysOfWeek),function(d){return _c('span',{key:d.timestamp,staticClass:"cell day-header"},[_vm._v(_vm._s(d))])}),_vm._v(" "),(_vm.blankDays > 0)?_vm._l((_vm.blankDays),function(d){return _c('span',{key:d.timestamp,staticClass:"cell day blank"})}):_vm._e(),_vm._l((_vm.days),function(day){return _c('span',{key:day.timestamp,staticClass:"cell day",class:_vm.dayClasses(day),domProps:{"innerHTML":_vm._s(_vm.dayCellContent(day))},on:{"click":function($event){_vm.selectDate(day);}}})})],2)],2)},staticRenderFns: [],
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      default: function (day) { return day.date; }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek () {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays
      }
      return this.translation.days
    },
    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays () {
      var d = this.pageDate;
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1))
        : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6
      }
      return this.utils.getDay(dObj)
    },
    /**
     * @return {Object[]}
     */
    days: function days () {
      var this$1 = this;

      var d = this.pageDate;
      var days = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1))
        : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));
      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this$1.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedDate(dObj),
          isDisabled: this$1.isDisabledDate(dObj),
          isHighlighted: this$1.isHighlightedDate(dObj),
          isHighlightStart: this$1.isHighlightStart(dObj),
          isHighlightEnd: this$1.isHighlightEnd(dObj),
          isToday: this$1.utils.compareDates(dObj, new Date()),
          isWeekend: this$1.utils.getDay(dObj) === 0 || this$1.utils.getDay(dObj) === 6,
          isSaturday: this$1.utils.getDay(dObj) === 6,
          isSunday: this$1.utils.getDay(dObj) === 0
        });
        this$1.utils.setDate(dObj, this$1.utils.getDate(dObj) + 1);
      }
      return days
    },
    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName () {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName)
    },
    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName () {
      var yearSuffix = this.translation.yearSuffix;
      return ("" + (this.utils.getFullYear(this.pageDate)) + yearSuffix)
    },
    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd () {
      return this.translation.ymd && this.translation.ymd === true
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextMonthDisabled(this.pageTimestamp)
        : this.isPreviousMonthDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousMonthDisabled(this.pageTimestamp)
        : this.isNextMonthDisabled(this.pageTimestamp)
    }
  },
  methods: {
    selectDate: function selectDate (date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false
      }
      this.$emit('selectDate', date);
    },
    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth () {
      return this.utils.getMonth(this.pageDate)
    },
    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar () {
      this.$emit('showMonthCalendar');
    },
    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth (incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },
    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth () {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },
    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) &&
        this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d)
    },
    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth () {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },
    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) &&
        this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d)
    },
    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate (dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj)
    },
    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate (date) {
      var this$1 = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            disabledDates = true;
            return true
          }
        });
      }
      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true
            }
          }
        });
      }
      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }
      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates
    },
    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate (date) {
      var this$1 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (this$1.utils.compareDates(date, d)) {
            highlighted = true;
            return true
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted
    },
    dayClasses: function dayClasses (day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      }
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart (date) {
      return this.isHighlightedDate(date) &&
        (this.highlighted.from instanceof Date) &&
        (this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date)) &&
        (this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date)) &&
        (this.utils.getDate(this.highlighted.from) === this.utils.getDate(date))
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd (date) {
      return this.isHighlightedDate(date) &&
        (this.highlighted.to instanceof Date) &&
        (this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date)) &&
        (this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date)) &&
        (this.utils.getDate(this.highlighted.to) === this.utils.getDate(date))
    },
    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined (prop) {
      return typeof prop !== 'undefined' && prop
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerMonth = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMonthView),expression:"showMonthView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextYear() : _vm.previousYear();}}},[_vm._v("<")]),_vm._v(" "),_c('span',{staticClass:"month__year_btn",class:_vm.allowedToShowView('year') ? 'up' : '',on:{"click":_vm.showYearCalendar}},[_vm._v(_vm._s(_vm.pageYearName))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousYear() : _vm.nextYear();}}},[_vm._v(">")])]),_vm._v(" "),_vm._l((_vm.months),function(month){return _c('span',{key:month.timestamp,staticClass:"cell month",class:{'selected': month.isSelected, 'disabled': month.isDisabled},on:{"click":function($event){$event.stopPropagation();_vm.selectMonth(month);}}},[_vm._v(_vm._s(month.month))])})],2)},staticRenderFns: [],
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  computed: {
    months: function months () {
      var this$1 = this;

      var d = this.pageDate;
      var months = [];
      // set up a new date object to the beginning of the current 'page'
      var dObj = this.useUtc
        ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate()))
        : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 12; i++) {
        months.push({
          month: this$1.utils.getMonthName(i, this$1.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedMonth(dObj),
          isDisabled: this$1.isDisabledMonth(dObj)
        });
        this$1.utils.setMonth(dObj, this$1.utils.getMonth(dObj) + 1);
      }
      return months
    },
    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName () {
      var yearSuffix = this.translation.yearSuffix;
      return ("" + (this.utils.getFullYear(this.pageDate)) + yearSuffix)
    },
    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextYearDisabled(this.pageTimestamp)
        : this.isPreviousYearDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousYearDisabled(this.pageTimestamp)
        : this.isNextYearDisabled(this.pageTimestamp)
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth (month) {
      if (month.isDisabled) {
        return false
      }
      this.$emit('selectMonth', month);
    },
    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear (incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },
    /**
     * Decrements the year
     */
    previousYear: function previousYear () {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },
    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate)
    },
    /**
     * Increments the year
     */
    nextYear: function nextYear () {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },
    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate)
    },
    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar () {
      this.$emit('showYearCalendar');
    },
    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth (date) {
      return (this.selectedDate &&
        this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) &&
        this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date))
    },
    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth (date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (
          (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to)) ||
          this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)
        ) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (
          (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from)) ||
          this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)
        ) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }
      return disabledDates
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var PickerYear = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showYearView),expression:"showYearView"}],class:[_vm.calendarClass, 'vdp-datepicker__calendar'],style:(_vm.calendarStyle),on:{"mousedown":function($event){$event.preventDefault();}}},[_vm._t("beforeCalendarHeader"),_vm._v(" "),_c('header',[_c('span',{staticClass:"prev",class:{'disabled': _vm.isLeftNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();}}},[_vm._v("<")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getPageDecade))]),_vm._v(" "),_c('span',{staticClass:"next",class:{'disabled': _vm.isRightNavDisabled},on:{"click":function($event){_vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();}}},[_vm._v(">")])]),_vm._v(" "),_vm._l((_vm.years),function(year){return _c('span',{key:year.timestamp,staticClass:"cell year",class:{ 'selected': year.isSelected, 'disabled': year.isDisabled },on:{"click":function($event){$event.stopPropagation();_vm.selectYear(year);}}},[_vm._v(_vm._s(year.year))])})],2)},staticRenderFns: [],
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years () {
      var this$1 = this;

      var d = this.pageDate;
      var years = [];
      // set up a new date object to the beginning of the current 'page'7
      var dObj = this.useUtc
        ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate()))
        : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
      for (var i = 0; i < 10; i++) {
        years.push({
          year: this$1.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this$1.isSelectedYear(dObj),
          isDisabled: this$1.isDisabledYear(dObj)
        });
        this$1.utils.setFullYear(dObj, this$1.utils.getFullYear(dObj) + 1);
      }
      return years
    },
    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade () {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return (decadeStart + " - " + decadeEnd + yearSuffix)
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled () {
      return this.isRtl
        ? this.isNextDecadeDisabled(this.pageTimestamp)
        : this.isPreviousDecadeDisabled(this.pageTimestamp)
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled () {
      return this.isRtl
        ? this.isPreviousDecadeDisabled(this.pageTimestamp)
        : this.isNextDecadeDisabled(this.pageTimestamp)
    }
  },
  data: function data () {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    }
  },
  methods: {
    selectYear: function selectYear (year) {
      if (year.isDisabled) {
        return false
      }
      this.$emit('selectYear', year);
    },
    changeYear: function changeYear (incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade () {
      if (this.isPreviousDecadeDisabled()) {
        return false
      }
      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled () {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false
      }
      var disabledYear = this.utils.getFullYear(this.disabledDates.to);
      var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return disabledYear > lastYearInPreviousPage
    },
    nextDecade: function nextDecade () {
      if (this.isNextDecadeDisabled()) {
        return false
      }
      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled () {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false
      }
      var disabledYear = this.utils.getFullYear(this.disabledDates.from);
      var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return disabledYear < firstYearInNextPage
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear (date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date)
    },
    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear (date) {
      var disabledDates = false;
      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }
      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates
    }
  }
}
// eslint-disable-next-line
;

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=".rtl { direction: rtl; } .vdp-datepicker { position: relative; text-align: left; } .vdp-datepicker * { box-sizing: border-box; } .vdp-datepicker__calendar { position: absolute; z-index: 100; background: #fff; width: 300px; border: 1px solid #ccc; } .vdp-datepicker__calendar header { display: block; line-height: 40px; } .vdp-datepicker__calendar header span { display: inline-block; text-align: center; width: 71.42857142857143%; float: left; } .vdp-datepicker__calendar header .prev, .vdp-datepicker__calendar header .next { width: 14.285714285714286%; float: left; text-indent: -10000px; position: relative; } .vdp-datepicker__calendar header .prev:after, .vdp-datepicker__calendar header .next:after { content: ''; position: absolute; left: 50%; top: 50%; -webkit-transform: translateX(-50%) translateY(-50%); transform: translateX(-50%) translateY(-50%); border: 6px solid transparent; } .vdp-datepicker__calendar header .prev:after { border-right: 10px solid #000; margin-left: -5px; } .vdp-datepicker__calendar header .prev.disabled:after { border-right: 10px solid #ddd; } .vdp-datepicker__calendar header .next:after { border-left: 10px solid #000; margin-left: 5px; } .vdp-datepicker__calendar header .next.disabled:after { border-left: 10px solid #ddd; } .vdp-datepicker__calendar header .prev:not(.disabled), .vdp-datepicker__calendar header .next:not(.disabled), .vdp-datepicker__calendar header .up:not(.disabled) { cursor: pointer; } .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover { background: #eee; } .vdp-datepicker__calendar .disabled { color: #ddd; cursor: default; } .vdp-datepicker__calendar .flex-rtl { display: flex; width: inherit; flex-wrap: wrap; } .vdp-datepicker__calendar .cell { display: inline-block; padding: 0 5px; width: 14.285714285714286%; height: 40px; line-height: 40px; text-align: center; vertical-align: middle; border: 1px solid transparent; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year { cursor: pointer; } .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover { border: 1px solid #4bd; } .vdp-datepicker__calendar .cell.selected { background: #4bd; } .vdp-datepicker__calendar .cell.selected:hover { background: #4bd; } .vdp-datepicker__calendar .cell.selected.highlighted { background: #4bd; } .vdp-datepicker__calendar .cell.highlighted { background: #cae5ed; } .vdp-datepicker__calendar .cell.highlighted.disabled { color: #a3a3a3; } .vdp-datepicker__calendar .cell.grey { color: #888; } .vdp-datepicker__calendar .cell.grey:hover { background: inherit; } .vdp-datepicker__calendar .cell.day-header { font-size: 75%; white-space: nowrap; cursor: inherit; } .vdp-datepicker__calendar .cell.day-header:hover { background: inherit; } .vdp-datepicker__calendar .month, .vdp-datepicker__calendar .year { width: 33.333%; } .vdp-datepicker__clear-button, .vdp-datepicker__calendar-button { cursor: pointer; font-style: normal; } .vdp-datepicker__clear-button.disabled, .vdp-datepicker__calendar-button.disabled { color: #999; cursor: default; } "; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();
var Datepicker = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vdp-datepicker",class:[_vm.wrapperClass, _vm.isRtl ? 'rtl' : '']},[_c('date-input',{attrs:{"selectedDate":_vm.selectedDate,"resetTypedDate":_vm.resetTypedDate,"format":_vm.format,"translation":_vm.translation,"inline":_vm.inline,"id":_vm.id,"name":_vm.name,"refName":_vm.refName,"openDate":_vm.openDate,"placeholder":_vm.placeholder,"inputClass":_vm.inputClass,"typeable":_vm.typeable,"clearButton":_vm.clearButton,"clearButtonIcon":_vm.clearButtonIcon,"calendarButton":_vm.calendarButton,"calendarButtonIcon":_vm.calendarButtonIcon,"calendarButtonIconContent":_vm.calendarButtonIconContent,"disabled":_vm.disabled,"required":_vm.required,"bootstrapStyling":_vm.bootstrapStyling,"use-utc":_vm.useUtc,"vMaskPattern":_vm.vMaskPattern},on:{"showCalendar":_vm.showCalendar,"closeCalendar":_vm.close,"typedDate":_vm.setTypedDate,"clearDate":_vm.clearDate}},[_vm._t("afterDateInput",null,{slot:"afterDateInput"})],2),_vm._v(" "),(_vm.allowedToShowView('day'))?_c('picker-day',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showDayView":_vm.showDayView,"fullMonthName":_vm.fullMonthName,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"highlighted":_vm.highlighted,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"pageTimestamp":_vm.pageTimestamp,"isRtl":_vm.isRtl,"mondayFirst":_vm.mondayFirst,"dayCellContent":_vm.dayCellContent,"use-utc":_vm.useUtc},on:{"changedMonth":_vm.handleChangedMonthFromDayPicker,"selectDate":_vm.selectDate,"showMonthCalendar":_vm.showMonthCalendar,"selectedDisabled":_vm.selectDisabledDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e(),_vm._v(" "),(_vm.allowedToShowView('month'))?_c('picker-month',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showMonthView":_vm.showMonthView,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"isRtl":_vm.isRtl,"use-utc":_vm.useUtc},on:{"selectMonth":_vm.selectMonth,"showYearCalendar":_vm.showYearCalendar,"changedYear":_vm.setPageDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e(),_vm._v(" "),(_vm.allowedToShowView('year'))?_c('picker-year',{attrs:{"pageDate":_vm.pageDate,"selectedDate":_vm.selectedDate,"showYearView":_vm.showYearView,"allowedToShowView":_vm.allowedToShowView,"disabledDates":_vm.disabledDates,"calendarClass":_vm.calendarClass,"calendarStyle":_vm.calendarStyle,"translation":_vm.translation,"isRtl":_vm.isRtl,"use-utc":_vm.useUtc},on:{"selectYear":_vm.selectYear,"changedDecade":_vm.setPageDate}},[_vm._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):_vm._e()],1)},staticRenderFns: [],
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function (val) { return utils$1.validateDateInput(val); }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      default: 'dd MMM yyyy'
    },
    language: {
      type: Object,
      default: function () { return en; }
    },
    openDate: {
      validator: function (val) { return utils$1.validateDateInput(val); }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    vMaskPattern: String,
    minimumView: {
      type: String,
      default: 'day'
    },
    maximumView: {
      type: String,
      default: 'year'
    }
  },
  data: function data () {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,
      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,
      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,
      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    }
  },
  watch: {
    value: function value (value$1) {
      this.setValue(value$1);
    },
    openDate: function openDate () {
      this.setPageDate();
    },
    initialView: function initialView () {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView () {
      if (!this.initialView) {
        return this.minimumView
      }

      return this.initialView
    },
    pageDate: function pageDate () {
      return new Date(this.pageTimestamp)
    },

    translation: function translation () {
      return this.language
    },

    calendarStyle: function calendarStyle () {
      return {
        position: this.isInline ? 'static' : undefined
      }
    },
    isOpen: function isOpen () {
      return this.showDayView || this.showMonthView || this.showYearView
    },
    isInline: function isInline () {
      return !!this.inline
    },
    isRtl: function isRtl () {
      return this.translation.rtl === true
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate () {
      if (this.selectedDate === null) {
        this.setPageDate();
        return
      }
      this.setPageDate(this.selectedDate);
    },
    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar () {
      if (this.disabled || this.isInline) {
        return false
      }
      if (this.isOpen) {
        return this.close(true)
      }
      this.setInitialView();
    },
    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView () {
      var initialView = this.computedInitialView;
      if (!this.allowedToShowView(initialView)) {
        throw new Error(("initialView '" + (this.initialView) + "' cannot be rendered based on minimum '" + (this.minimumView) + "' and maximum '" + (this.maximumView) + "'"))
      }
      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break
        case 'month':
          this.showMonthCalendar();
          break
        default:
          this.showDayCalendar();
          break
      }
    },
    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView (view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);

      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex
    },
    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar () {
      if (!this.allowedToShowView('day')) {
        return false
      }
      this.close();
      this.showDayView = true;
      return true
    },
    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar () {
      if (!this.allowedToShowView('month')) {
        return false
      }
      this.close();
      this.showMonthView = true;
      return true
    },
    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar () {
      if (!this.allowedToShowView('year')) {
        return false
      }
      this.close();
      this.showYearView = true;
      return true
    },
    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate (timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },
    /**
     * Clear the selected date
     */
    clearDate: function clearDate () {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },
    /**
     * @param {Object} date
     */
    selectDate: function selectDate (date) {
      this.setDate(date.timestamp);
      if (!this.isInline) {
        this.close(true);
      }
      this.resetTypedDate = new Date();
    },
    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate (date) {
      this.$emit('selectedDisabled', date);
    },
    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth (month) {
      var date = new Date(month.timestamp);
      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },
    /**
     * @param {Object} year
     */
    selectYear: function selectYear (year) {
      var date = new Date(year.timestamp);
      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },
    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue (date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }
      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return
      }
      this.selectedDate = date;
      this.setPageDate(date);
    },
    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate (date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }
      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },
    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker (date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },
    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate (date) {
      this.setDate(date.getTime());
    },
    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function close (emitEvent) {
      this.showDayView = this.showMonthView = this.showYearView = false;
      if (!this.isInline) {
        if (emitEvent) {
          this.$emit('closed');
        }
        document.removeEventListener('click', this.clickOutside, false);
      }
    },
    /**
     * Initiate the component
     */
    init: function init () {
      if (this.value) {
        this.setValue(this.value);
      }
      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted () {
    this.init();
  }
}
// eslint-disable-next-line
;

/* harmony default export */ __webpack_exports__["default"] = (Datepicker);


/***/ }),
/* 102 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 103 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./client/enum/graficoId.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GraficoIdEnum = {
  RESUMO_SITUACAO_CONCILIACAO: 213,
  RESUMO_FINANCEIRO_PLANO_CONCILIACAO: 211,
  DISTRIBUICAO_CONCILIACAO_LOTE: 212,
  SALDO_BANCARIO: 214,
  GADGET_TAREFAS: 209,
  SALDO_CARTEIRA_DIGITAL: 4005
};

exports.default = GraficoIdEnum;

/***/ }),
/* 104 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./client/events/closeModal.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var closeModal = new _vue2.default();
exports.default = closeModal;

/***/ }),
/* 105 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(/*! vuex */ 301);

var _vuex2 = _interopRequireDefault(_vuex);

var _vuexPersistedstate = __webpack_require__(/*! vuex-persistedstate */ 1729);

var _vuexPersistedstate2 = _interopRequireDefault(_vuexPersistedstate);

var _state = __webpack_require__(/*! ./state */ 787);

var _state2 = _interopRequireDefault(_state);

var _vuexModules = __webpack_require__(/*! ./vuex-modules */ 317);

var _vuexModules2 = _interopRequireDefault(_vuexModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: _state2.default,
  plugins: [(0, _vuexPersistedstate2.default)()],
  modules: _vuexModules2.default
});

exports.default = store;

/***/ }),
/* 106 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./client/utils/customValidator.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(/*! babel-runtime/helpers/slicedToArray */ 323);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  validateCnpj: function validateCnpj(cnpj) {
    cnpj = cnpj.replace(/[.\-/]/g, '').toUpperCase();

    if (cnpj.length !== 14) {
      return false;
    }

    if (/^(.)\1+$/.test(cnpj)) {
      return false;
    }

    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) {
      return false;
    }

    var pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    var charToValue = function charToValue(char) {
      return char.charCodeAt(0) - 48;
    };

    var soma = 0;

    for (var i = 0; i < 12; i++) {
      soma += charToValue(cnpj[i]) * pesos[i + 1];
    }

    var dv1 = soma % 11;
    dv1 = dv1 < 2 ? 0 : 11 - dv1;

    if (Number(cnpj[12]) !== dv1) {
      return false;
    }

    soma = 0;

    for (var _i = 0; _i < 13; _i++) {
      soma += charToValue(cnpj[_i]) * pesos[_i];
    }

    var dv2 = soma % 11;
    dv2 = dv2 < 2 ? 0 : 11 - dv2;

    if (Number(cnpj[13]) !== dv2) {
      return false;
    }

    return true;
  },

  validateCpf: function validateCpf(cpf) {
    if (/0{11}/.test(cpf)) {
      return false;
    }

    if ((cpf = cpf.replace(/[^\d]/g, '')).length !== 11) {
      return false;
    }

    function calcularDigito(cpf, pesoInicial) {
      var soma = 0;
      for (var i = 0; i < pesoInicial - 1; i++) {
        soma += parseInt(cpf[i]) * (pesoInicial - i);
      }
      var resto = soma * 10 % 11;
      return resto === 10 ? 0 : resto;
    }

    var digito1 = calcularDigito(cpf, 10);
    var digito2 = calcularDigito(cpf, 11);

    return digito1 === parseInt(cpf[9]) && digito2 === parseInt(cpf[10]);
  },

  isValidDate: function isValidDate(date) {
    var _date$split = date.split('/'),
        _date$split2 = (0, _slicedToArray3.default)(_date$split, 3),
        inputDay = _date$split2[0],
        inputMonth = _date$split2[1],
        inputYear = _date$split2[2];

    var isLeapYear = !(inputYear % 4) && inputYear % 100 || !(inputYear % 400);

    if (inputDay < 1 || inputDay > 31) {
      return false;
    }

    if (inputMonth < 1 || inputMonth > 12) {
      return false;
    }

    if (inputMonth === '02' && (isLeapYear ? inputDay > 29 : inputDay > 28)) {
      return false;
    }

    if (/4|6|9|11/.test(inputMonth) && inputDay > 30) {
      return false;
    }

    if (inputYear.length !== 4) {
      return false;
    }

    if (inputYear < 2010) {
      return false;
    }

    return true;
  }
};

/***/ }),
/* 107 */
/* exports provided: props, BButtonClose */
/* exports used: BButtonClose */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/button/button-close.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BButtonClose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  ariaLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'Close'),
  content: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], '&times;'),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  textVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_64" /* NAME_BUTTON_CLOSE */]); // --- Main component ---
// @vue/component

var BButtonClose = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_64" /* NAME_BUTTON_CLOSE */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots;
    var $slots = slots();
    var $scopedSlots = scopedSlots || {};
    var componentData = {
      staticClass: 'close',
      class: _defineProperty({}, "text-".concat(props.textVariant), props.textVariant),
      attrs: {
        type: 'button',
        disabled: props.disabled,
        'aria-label': props.ariaLabel ? String(props.ariaLabel) : null
      },
      on: {
        click: function click(event) {
          // Ensure click on button HTML content is also disabled

          /* istanbul ignore if: bug in JSDOM still emits click on inner element */
          if (props.disabled && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["l" /* isEvent */])(event)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["f" /* stopEvent */])(event);
          }
        }
      }
    }; // Careful not to override the default slot with innerHTML

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], $scopedSlots, $slots)) {
      componentData.domProps = {
        innerHTML: props.content
      };
    }

    return h('button', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, componentData), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], {}, $scopedSlots, $slots));
  }
});

/***/ }),
/* 108 */
/* exports provided: props, BVTransition */
/* exports used: BVTransition */
/*!********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/transition/bv-transition.js ***!
  \********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Generic Bootstrap v4 fade (no-fade) transition component
//
// Assumes that `show` class is not required when
// the transition has finished the enter transition
// (show and fade classes are only applied during transition)




 // --- Constants ---

var NO_FADE_PROPS = {
  name: '',
  enterClass: '',
  enterActiveClass: '',
  enterToClass: 'show',
  leaveClass: 'show',
  leaveActiveClass: '',
  leaveToClass: ''
};

var FADE_PROPS = _objectSpread(_objectSpread({}, NO_FADE_PROPS), {}, {
  enterActiveClass: 'fade',
  leaveActiveClass: 'fade'
}); // --- Props ---


var props = {
  // Has no effect if `trans-props` provided
  appear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Can be overridden by user supplied `trans-props`
  mode: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Only applicable to the built in transition
  // Has no effect if `trans-props` provided
  noFade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // For user supplied transitions (if needed)
  transProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */])
}; // --- Main component ---
// @vue/component

var BVTransition = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["f" /* NAME_TRANSITION */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var children = _ref.children,
        data = _ref.data,
        props = _ref.props;
    var transProps = props.transProps;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["h" /* isPlainObject */])(transProps)) {
      transProps = props.noFade ? NO_FADE_PROPS : FADE_PROPS;

      if (props.appear) {
        // Default the appear classes to equal the enter classes
        transProps = _objectSpread(_objectSpread({}, transProps), {}, {
          appear: true,
          appearClass: transProps.enterClass,
          appearActiveClass: transProps.enterActiveClass,
          appearToClass: transProps.enterToClass
        });
      }
    }

    transProps = _objectSpread(_objectSpread({
      mode: props.mode
    }, transProps), {}, {
      // We always need `css` true
      css: true
    });

    var dataCopy = _objectSpread({}, data);

    delete dataCopy.props;
    return h('transition', // Any transition event listeners will get merged here
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(dataCopy, {
      props: transProps
    }), children);
  }
});

/***/ }),
/* 109 */
/* exports provided: BvEvent */
/* exports used: BvEvent */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/bv-event.class.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BvEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(/*! ./object */ 6);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


var BvEvent = /*#__PURE__*/function () {
  function BvEvent(type) {
    var eventInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, BvEvent);

    // Start by emulating native Event constructor
    if (!type) {
      /* istanbul ignore next */
      throw new TypeError("Failed to construct '".concat(this.constructor.name, "'. 1 argument required, ").concat(arguments.length, " given."));
    } // Merge defaults first, the eventInit, and the type last
    // so it can't be overwritten


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["e" /* assign */])(this, BvEvent.Defaults, this.constructor.Defaults, eventInit, {
      type: type
    }); // Freeze some props as readonly, but leave them enumerable

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["f" /* defineProperties */])(this, {
      type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["g" /* readonlyDescriptor */])(),
      cancelable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["g" /* readonlyDescriptor */])(),
      nativeEvent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["g" /* readonlyDescriptor */])(),
      target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["g" /* readonlyDescriptor */])(),
      relatedTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["g" /* readonlyDescriptor */])(),
      vueTarget: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["g" /* readonlyDescriptor */])(),
      componentId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["g" /* readonlyDescriptor */])()
    }); // Create a private variable using closure scoping

    var defaultPrevented = false; // Recreate preventDefault method. One way setter

    this.preventDefault = function preventDefault() {
      if (this.cancelable) {
        defaultPrevented = true;
      }
    }; // Create `defaultPrevented` publicly accessible prop that
    // can only be altered by the preventDefault method


    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["h" /* defineProperty */])(this, 'defaultPrevented', {
      enumerable: true,
      get: function get() {
        return defaultPrevented;
      }
    });
  }

  _createClass(BvEvent, null, [{
    key: "Defaults",
    get: function get() {
      return {
        type: '',
        cancelable: true,
        nativeEvent: null,
        target: null,
        relatedTarget: null,
        vueTarget: null,
        componentId: null
      };
    }
  }]);

  return BvEvent;
}();

/***/ }),
/* 110 */
/* exports provided: stringifyQueryObj, parseQuery, isLink, isRouterLink, computeTag, computeRel, computeHref */
/* exports used: isLink, computeTag, isRouterLink, computeRel, computeHref, parseQuery */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/router.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stringifyQueryObj */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return parseQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isRouterLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return computeTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return computeRel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return computeHref; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom__ = __webpack_require__(/*! ./dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__object__ = __webpack_require__(/*! ./object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__safe_vue_instance__ = __webpack_require__(/*! ./safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__string__ = __webpack_require__(/*! ./string */ 23);






var ANCHOR_TAG = 'a'; // Method to replace reserved chars

var encodeReserveReplacer = function encodeReserveReplacer(c) {
  return '%' + c.charCodeAt(0).toString(16);
}; // Fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas


var encode = function encode(str) {
  return encodeURIComponent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__string__["a" /* toString */])(str)).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["q" /* RX_ENCODE_REVERSE */], encodeReserveReplacer).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["r" /* RX_ENCODED_COMMA */], ',');
};

var decode = decodeURIComponent; // Stringifies an object of query parameters
// See: https://github.com/vuejs/vue-router/blob/dev/src/util/query.js

var stringifyQueryObj = function stringifyQueryObj(obj) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["h" /* isPlainObject */])(obj)) {
    return '';
  }

  var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__object__["a" /* keys */])(obj).map(function (key) {
    var value = obj[key];

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["i" /* isUndefined */])(value)) {
      return '';
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["e" /* isNull */])(value)) {
      return encode(key);
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["c" /* isArray */])(value)) {
      return value.reduce(function (results, value2) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["e" /* isNull */])(value2)) {
          results.push(encode(key));
        } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["i" /* isUndefined */])(value2)) {
          // Faster than string interpolation
          results.push(encode(key) + '=' + encode(value2));
        }

        return results;
      }, []).join('&');
    } // Faster than string interpolation


    return encode(key) + '=' + encode(value);
  })
  /* must check for length, as we only want to filter empty strings, not things that look falsey! */
  .filter(function (x) {
    return x.length > 0;
  }).join('&');
  return query ? "?".concat(query) : '';
};
var parseQuery = function parseQuery(query) {
  var parsed = {};
  query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__string__["a" /* toString */])(query).trim().replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["s" /* RX_QUERY_START */], '');

  if (!query) {
    return parsed;
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["t" /* RX_PLUS */], ' ').split('=');
    var key = decode(parts.shift());
    var value = parts.length > 0 ? decode(parts.join('=')) : null;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["i" /* isUndefined */])(parsed[key])) {
      parsed[key] = value;
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["c" /* isArray */])(parsed[key])) {
      parsed[key].push(value);
    } else {
      parsed[key] = [parsed[key], value];
    }
  });
  return parsed;
};
var isLink = function isLink(props) {
  return !!(props.href || props.to);
};
var isRouterLink = function isRouterLink(tag) {
  return !!(tag && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom__["p" /* isTag */])(tag, 'a'));
};
var computeTag = function computeTag(_ref, thisOrParent) {
  var to = _ref.to,
      disabled = _ref.disabled,
      routerComponentName = _ref.routerComponentName;
  var hasRouter = !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__safe_vue_instance__["a" /* safeVueInstance */])(thisOrParent).$router;
  var hasNuxt = !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__safe_vue_instance__["a" /* safeVueInstance */])(thisOrParent).$nuxt;

  if (!hasRouter || hasRouter && (disabled || !to)) {
    return ANCHOR_TAG;
  } // TODO:
  //   Check registered components for existence of user supplied router link component name
  //   We would need to check PascalCase, kebab-case, and camelCase versions of name:
  //   const name = routerComponentName
  //   const names = [name, PascalCase(name), KebabCase(name), CamelCase(name)]
  //   exists = names.some(name => !!thisOrParent.$options.components[name])
  //   And may want to cache the result for performance or we just let the render fail
  //   if the component is not registered


  return routerComponentName || (hasNuxt ? 'nuxt-link' : 'router-link');
};
var computeRel = function computeRel() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      target = _ref2.target,
      rel = _ref2.rel;

  return target === '_blank' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["e" /* isNull */])(rel) ? 'noopener' : rel || null;
};
var computeHref = function computeHref() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      href = _ref3.href,
      to = _ref3.to;

  var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ANCHOR_TAG;
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#';
  var toFallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';

  // Return `href` when explicitly provided
  if (href) {
    return href;
  } // We've checked for `$router` in `computeTag()`, so `isRouterLink()` indicates a live router
  // When deferring to Vue Router's `<router-link>`, don't use the `href` attribute at all
  // We return `null`, and then remove `href` from the attributes passed to `<router-link>`


  if (isRouterLink(tag)) {
    return null;
  } // Fallback to `to` prop (if `to` is a string)


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["f" /* isString */])(to)) {
    return to || toFallback;
  } // Fallback to `to.path' + `to.query` + `to.hash` prop (if `to` is an object)


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["h" /* isPlainObject */])(to) && (to.path || to.query || to.hash)) {
    var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__string__["a" /* toString */])(to.path);
    var query = stringifyQueryObj(to.query);
    var hash = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__string__["a" /* toString */])(to.hash);
    hash = !hash || hash.charAt(0) === '#' ? hash : "#".concat(hash);
    return "".concat(path).concat(query).concat(hash) || toFallback;
  } // If nothing is provided return the fallback


  return fallback;
};

/***/ }),
/* 111 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/core-js/library/modules/_fails.js ***!
  \*********************************************/
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 112 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/core-js/library/modules/_has.js ***!
  \*******************************************/
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 113 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_to-iobject.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(/*! ./_iobject */ 261);
var defined = __webpack_require__(/*! ./_defined */ 258);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 114 */
/* exports provided: Day */
/* exports used: Day */
/*!******************************!*\
  !*** ./~/dayspan/lib/Day.js ***!
  \******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Day; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Identifier__ = __webpack_require__(/*! ./Identifier */ 190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(/*! ./Constants */ 98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Operation__ = __webpack_require__(/*! ./Operation */ 151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Parse__ = __webpack_require__(/*! ./Parse */ 152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Time__ = __webpack_require__(/*! ./Time */ 279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(/*! moment */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);






// @ts-ignore

/**
 * A class which represents a point in time as
 */
var Day = (function () {
    /**
     *
     */
    function Day(date) {
        this.date = date;
        this.time = date.valueOf();
        this.millis = date.millisecond();
        this.seconds = date.second();
        this.minute = date.minute();
        this.hour = date.hour();
        this.month = date.month();
        this.year = date.year();
        this.quarter = date.quarter();
        this.dayOfWeek = date.day();
        this.dayOfMonth = date.date();
        this.dayOfYear = date.dayOfYear();
        this.week = date.week();
        this.lastDayOfMonth = Day.getLastDayOfMonth(date);
        this.weekOfYear = Day.getWeekOfYear(date);
        this.weekspanOfYear = Day.getWeekspanOfYear(date);
        this.fullWeekOfYear = Day.getFullWeekOfYear(date);
        this.lastWeekspanOfYear = Day.getLastWeekspanOfYear(date);
        this.lastFullWeekOfYear = Day.getLastFullWeekOfYear(date);
        this.weekOfMonth = Day.getWeekOfMonth(date);
        this.weekspanOfMonth = Day.getWeekspanOfMonth(date);
        this.fullWeekOfMonth = Day.getFullWeekOfMonth(date);
        this.lastWeekspanOfMonth = Day.getLastWeekspanOfMonth(date);
        this.lastFullWeekOfMonth = Day.getLastFullWeekOfMonth(date);
        this.timeIdentifier = __WEBPACK_IMPORTED_MODULE_0__Identifier__["a" /* Identifier */].Time.get(this);
        this.dayIdentifier = __WEBPACK_IMPORTED_MODULE_0__Identifier__["a" /* Identifier */].Day.get(this);
        this.weekIdentifier = __WEBPACK_IMPORTED_MODULE_0__Identifier__["a" /* Identifier */].Week.get(this);
        this.monthIdentifier = __WEBPACK_IMPORTED_MODULE_0__Identifier__["a" /* Identifier */].Month.get(this);
        this.quarterIdentifier = __WEBPACK_IMPORTED_MODULE_0__Identifier__["a" /* Identifier */].Quarter.get(this);
    }
    // Same
    /**
     *
     */
    Day.prototype.sameDay = function (day) {
        return this.dayIdentifier === day.dayIdentifier;
    };
    /**
     *
     */
    Day.prototype.sameMonth = function (day) {
        return this.monthIdentifier === day.monthIdentifier;
    };
    /**
     *
     */
    Day.prototype.sameWeek = function (day) {
        return this.weekIdentifier === day.weekIdentifier;
    };
    /**
     *
     */
    Day.prototype.sameYear = function (day) {
        return this.year === day.year;
    };
    /**
     *
     */
    Day.prototype.sameQuarter = function (day) {
        return this.quarterIdentifier === day.quarterIdentifier;
    };
    /**
     *
     */
    Day.prototype.sameHour = function (day) {
        return this.dayIdentifier === day.dayIdentifier && this.hour === day.hour;
    };
    /**
     *
     */
    Day.prototype.sameMinute = function (day) {
        return this.timeIdentifier === day.timeIdentifier;
    };
    /**
     *
     */
    Day.prototype.sameTime = function (time) {
        return this.hour === time.hour && this.minute === time.minute && this.seconds === time.second && this.millis === time.millisecond;
    };
    // Comparison
    /**
     *
     */
    Day.prototype.isBefore = function (day, precision) {
        return this.date.isBefore(day.date, precision);
    };
    /**
     *
     */
    Day.prototype.isSameOrBefore = function (day, precision) {
        return this.date.isSameOrBefore(day.date, precision);
    };
    /**
     *
     */
    Day.prototype.isAfter = function (day, precision) {
        return this.date.isAfter(day.date, precision);
    };
    /**
     *
     */
    Day.prototype.isSameOrAfter = function (day, precision) {
        return this.date.isSameOrAfter(day.date, precision);
    };
    /**
     *
     */
    Day.prototype.max = function (day) {
        return this.date.isAfter(day.date) ? this : day;
    };
    /**
     *
     */
    Day.prototype.min = function (day) {
        return this.date.isBefore(day.date) ? this : day;
    };
    // Between
    Day.prototype.millisBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'milliseconds', true), op, absolute);
    };
    Day.prototype.secondsBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'seconds', true), op, absolute);
    };
    Day.prototype.minutesBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'minutes', true), op, absolute);
    };
    Day.prototype.hoursBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'hours', true), op, absolute);
    };
    Day.prototype.daysBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'days', true), op, absolute);
    };
    Day.prototype.weeksBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'weeks', true), op, absolute);
    };
    Day.prototype.monthsBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'months', true), op, absolute);
    };
    Day.prototype.yearsBetween = function (day, op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_2__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Operation__["b" /* operate */])(this.date.diff(day.date, 'years', true), op, absolute);
    };
    Day.prototype.isBetween = function (start, end, inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        return this.date.isBetween(start.date, end.date, null, inclusive ? '[]' : '[)');
    };
    Day.prototype.mutate = function (mutator) {
        var d = this.toMoment();
        mutator(d);
        return new Day(d);
    };
    Day.prototype.add = function (amount, unit) {
        return this.mutate(function (d) { return d.add(amount, unit); });
    };
    Day.prototype.relative = function (millis) {
        return this.mutate(function (d) { return d.add(millis, 'milliseconds'); });
    };
    // Days
    Day.prototype.relativeDays = function (days) {
        return this.mutate(function (d) { return d.add(days, 'days'); });
    };
    Day.prototype.prev = function (days) {
        if (days === void 0) { days = 1; }
        return this.relativeDays(-days);
    };
    Day.prototype.next = function (days) {
        if (days === void 0) { days = 1; }
        return this.relativeDays(days);
    };
    Day.prototype.withDayOfMonth = function (day) {
        return this.mutate(function (d) { return d.date(day); });
    };
    Day.prototype.withDayOfWeek = function (dayOfWeek) {
        return this.mutate(function (d) { return d.day(dayOfWeek); });
    };
    Day.prototype.withDayOfYear = function (dayOfYear) {
        return this.mutate(function (d) { return d.dayOfYear(dayOfYear); });
    };
    // Month
    Day.prototype.withMonth = function (month) {
        return this.mutate(function (d) { return d.month(month); });
    };
    Day.prototype.relativeMonths = function (months) {
        return this.mutate(function (d) { return d.add(months, 'months'); });
    };
    Day.prototype.prevMonth = function (months) {
        if (months === void 0) { months = 1; }
        return this.relativeMonths(-months);
    };
    Day.prototype.nextMonth = function (months) {
        if (months === void 0) { months = 1; }
        return this.relativeMonths(months);
    };
    // Week Of Year
    Day.prototype.withWeek = function (week, relativeWeek) {
        if (relativeWeek === void 0) { relativeWeek = this.week; }
        return this.mutate(function (d) { return d.add((week - relativeWeek) * __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK, 'days'); });
    };
    Day.prototype.withWeekOfYear = function (week) {
        return this.withWeek(week, this.weekOfYear);
    };
    Day.prototype.withFullWeekOfYear = function (week) {
        return this.withWeek(week, this.fullWeekOfYear);
    };
    Day.prototype.withWeekspanOfYear = function (week) {
        return this.withWeek(week, this.weekspanOfYear);
    };
    Day.prototype.withWeekOfMonth = function (week) {
        return this.withWeek(week, this.weekOfMonth);
    };
    Day.prototype.withWeekspanOfMonth = function (week) {
        return this.withWeek(week, this.weekspanOfMonth);
    };
    Day.prototype.withFullWeekOfMonth = function (week) {
        return this.withWeek(week, this.fullWeekOfMonth);
    };
    Day.prototype.relativeWeeks = function (weeks) {
        return this.mutate(function (d) { return d.add(weeks, 'weeks'); });
    };
    Day.prototype.prevWeek = function (weeks) {
        if (weeks === void 0) { weeks = 1; }
        return this.relativeWeeks(-weeks);
    };
    Day.prototype.nextWeek = function (weeks) {
        if (weeks === void 0) { weeks = 1; }
        return this.relativeWeeks(weeks);
    };
    // Year
    Day.prototype.withYear = function (year) {
        return this.mutate(function (d) { return d.year(year); });
    };
    Day.prototype.relativeYears = function (years) {
        return this.mutate(function (d) { return d.add(years, 'year'); });
    };
    Day.prototype.prevYear = function (years) {
        if (years === void 0) { years = 1; }
        return this.relativeYears(-years);
    };
    Day.prototype.nextYear = function (years) {
        if (years === void 0) { years = 1; }
        return this.relativeYears(years);
    };
    // Hour
    Day.prototype.withHour = function (hour) {
        return this.mutate(function (d) { return d.hour(hour); });
    };
    Day.prototype.relativeHours = function (hours) {
        return this.mutate(function (d) { return d.add(hours, 'hours'); });
    };
    Day.prototype.prevHour = function (hours) {
        if (hours === void 0) { hours = 1; }
        return this.relativeHours(-hours);
    };
    Day.prototype.nextHour = function (hours) {
        if (hours === void 0) { hours = 1; }
        return this.relativeHours(hours);
    };
    // Time
    Day.prototype.withTimes = function (hour, minute, second, millisecond) {
        if (hour === void 0) { hour = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].HOUR_MIN; }
        if (minute === void 0) { minute = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MIN; }
        if (second === void 0) { second = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MIN; }
        if (millisecond === void 0) { millisecond = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MIN; }
        return this.mutate(function (d) { return d.set({ hour: hour, minute: minute, second: second, millisecond: millisecond }); });
    };
    Day.prototype.withTime = function (time) {
        return this.withTimes(time.hour, time.minute, time.second, time.millisecond);
    };
    Day.prototype.asTime = function () {
        return new __WEBPACK_IMPORTED_MODULE_4__Time__["a" /* Time */](this.hour, this.minute, this.seconds, this.millis);
    };
    // Start & End
    // Time
    Day.prototype.start = function () {
        return this.mutate(function (d) { return d.startOf('day'); });
    };
    Day.prototype.isStart = function () {
        return this.hour === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].HOUR_MIN &&
            this.minute === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MIN &&
            this.seconds === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MIN &&
            this.millis === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MIN;
    };
    Day.prototype.end = function (inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        return inclusive ?
            this.mutate(function (d) { return d.endOf('day'); }) :
            this.mutate(function (d) { return d.startOf('day').add(1, 'day'); });
    };
    Day.prototype.isEnd = function () {
        return this.hour === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].HOUR_MAX &&
            this.minute === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MAX &&
            this.seconds === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MAX &&
            this.millis === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MAX;
    };
    // Hour
    Day.prototype.startOfHour = function () {
        return this.mutate(function (d) { return d.startOf('hour'); });
    };
    Day.prototype.isStartOfHour = function () {
        return this.minute === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MIN &&
            this.seconds === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MIN &&
            this.millis === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MIN;
    };
    Day.prototype.endOfHour = function (inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        return inclusive ?
            this.mutate(function (d) { return d.endOf('hour'); }) :
            this.mutate(function (d) { return d.startOf('hour').add(1, 'hour'); });
    };
    Day.prototype.isEndOfHour = function () {
        return this.minute === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MAX &&
            this.seconds === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MAX &&
            this.millis === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MAX;
    };
    // Week
    Day.prototype.startOfWeek = function () {
        return this.mutate(function (d) { return d.startOf('week'); });
    };
    Day.prototype.isStartOfWeek = function () {
        return this.dayOfWeek === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].WEEKDAY_MIN;
    };
    Day.prototype.endOfWeek = function (inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        return inclusive ?
            this.mutate(function (d) { return d.endOf('week'); }) :
            this.mutate(function (d) { return d.startOf('week').add(1, 'week'); });
    };
    Day.prototype.isEndOfWeek = function () {
        return this.dayOfWeek === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].WEEKDAY_MAX;
    };
    // Month
    Day.prototype.startOfMonth = function () {
        return this.mutate(function (d) { return d.startOf('month'); });
    };
    Day.prototype.isStartOfMonth = function () {
        return this.dayOfMonth === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAY_MIN;
    };
    Day.prototype.endOfMonth = function (inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        return inclusive ?
            this.mutate(function (d) { return d.endOf('month'); }) :
            this.mutate(function (d) { return d.startOf('month').add(1, 'month'); });
    };
    Day.prototype.isEndOfMonth = function () {
        return this.dayOfMonth === this.daysInMonth();
    };
    // Year
    Day.prototype.startOfYear = function () {
        return this.mutate(function (d) { return d.startOf('year'); });
    };
    Day.prototype.isStartOfYear = function () {
        return this.month === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MONTH_MIN && this.dayOfMonth === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAY_MIN;
    };
    Day.prototype.endOfYear = function (inclusive) {
        if (inclusive === void 0) { inclusive = true; }
        return inclusive ?
            this.mutate(function (d) { return d.endOf('year'); }) :
            this.mutate(function (d) { return d.startOf('year').add(1, 'year'); });
    };
    Day.prototype.isEndOfYear = function () {
        return this.month === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MONTH_MAX && this.dayOfMonth === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAY_MAX;
    };
    // Days In X
    Day.prototype.daysInMonth = function () {
        return this.date.daysInMonth();
    };
    Day.prototype.daysInYear = function () {
        return this.endOfYear().dayOfYear;
    };
    Day.prototype.weeksInYear = function () {
        return this.date.weeksInYear();
    };
    // Display
    Day.prototype.format = function (format) {
        return this.date.format(format);
    };
    Day.prototype.utc = function (keepLocalTime) {
        return this.mutate(function (d) { return d.utc(keepLocalTime); });
    };
    Day.prototype.toMoment = function () {
        return this.date.clone();
    };
    Day.prototype.toDate = function () {
        return this.date.toDate();
    };
    Day.prototype.toArray = function () {
        return this.date.toArray();
    };
    Day.prototype.toJSON = function () {
        return this.date.toJSON();
    };
    Day.prototype.toISOString = function (keepOffset) {
        if (keepOffset === void 0) { keepOffset = false; }
        return this.date.toISOString(keepOffset);
    };
    Day.prototype.toObject = function () {
        return this.date.toObject();
    };
    Day.prototype.toString = function () {
        return this.date.toString();
    };
    // State
    Day.prototype.isDST = function () {
        return this.date.isDST();
    };
    Day.prototype.isLeapYear = function () {
        return this.date.isLeapYear();
    };
    // Instances
    Day.now = function () {
        return new Day(__WEBPACK_IMPORTED_MODULE_5_moment__());
    };
    Day.today = function () {
        return this.now().start();
    };
    Day.tomorrow = function () {
        return this.today().next();
    };
    Day.fromMoment = function (moment) {
        return moment && moment.isValid() ? new Day(moment) : null;
    };
    Day.unix = function (millis) {
        return this.fromMoment(__WEBPACK_IMPORTED_MODULE_5_moment__(millis));
    };
    Day.unixSeconds = function (millis) {
        return this.fromMoment(__WEBPACK_IMPORTED_MODULE_5_moment__["unix"](millis));
    };
    Day.parse = function (input) {
        return __WEBPACK_IMPORTED_MODULE_3__Parse__["a" /* Parse */].day(input);
    };
    Day.fromString = function (input) {
        return this.fromMoment(__WEBPACK_IMPORTED_MODULE_5_moment__(input));
    };
    Day.fromFormat = function (input, formats) {
        return this.fromMoment(__WEBPACK_IMPORTED_MODULE_5_moment__(input, formats));
    };
    Day.fromObject = function (input) {
        return this.fromMoment(__WEBPACK_IMPORTED_MODULE_5_moment__(input));
    };
    Day.fromDate = function (input) {
        return this.fromMoment(__WEBPACK_IMPORTED_MODULE_5_moment__(input));
    };
    Day.fromArray = function (input) {
        return this.fromMoment(__WEBPACK_IMPORTED_MODULE_5_moment__(input));
    };
    Day.fromDayIdentifier = function (id) {
        var date = id % 100;
        var month = (Math.floor(id / 100) % 100) - 1;
        var year = Math.floor(id / 10000);
        return this.build(year, month, date);
    };
    Day.build = function (year, month, date, hour, minute, second, millisecond) {
        if (date === void 0) { date = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAY_MIN; }
        if (hour === void 0) { hour = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].HOUR_MIN; }
        if (minute === void 0) { minute = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MIN; }
        if (second === void 0) { second = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MIN; }
        if (millisecond === void 0) { millisecond = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MIN; }
        return new Day(__WEBPACK_IMPORTED_MODULE_5_moment__({ year: year, month: month, date: date, hour: hour, minute: minute, second: second, millisecond: millisecond }));
    };
    Day.getWeekspanOfYear = function (date) {
        return Math.floor((date.dayOfYear() - 1) / __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK);
    };
    Day.getLastWeekspanOfYear = function (date) {
        var lastOfYear = date.clone().endOf('year');
        var daysInYear = lastOfYear.dayOfYear();
        return Math.floor((daysInYear - date.dayOfYear()) / __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK);
    };
    Day.getWeekOfYear = function (date) {
        var firstOfYear = date.clone().startOf('year');
        var weeks = date.week();
        return firstOfYear.day() > __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].WEEK_OF_MONTH_MINIMUM_WEEKDAY ? weeks - 1 : weeks;
    };
    Day.getFullWeekOfYear = function (date) {
        var firstOfYear = date.clone().startOf('year');
        var weeks = date.week();
        return firstOfYear.day() === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].WEEKDAY_MIN ? weeks : weeks - 1;
    };
    Day.getLastFullWeekOfYear = function (date) {
        var firstOfYear = date.clone().startOf('year');
        var weeks = date.week();
        var weeksMax = date.weeksInYear();
        var lastWeek = weeksMax - weeks;
        return firstOfYear.day() === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].WEEKDAY_MIN ? lastWeek + 1 : lastWeek;
    };
    Day.getWeekspanOfMonth = function (date) {
        return Math.floor((date.date() - 1) / __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK);
    };
    Day.getLastWeekspanOfMonth = function (date) {
        return Math.floor((date.daysInMonth() - date.date()) / __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK);
    };
    Day.getFullWeekOfMonth = function (date) {
        return Math.floor((date.date() - 1 - date.day() + __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK) / __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK);
    };
    Day.getLastFullWeekOfMonth = function (date) {
        return Math.floor((date.daysInMonth() - date.date() - (__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].WEEKDAY_MAX - date.day()) + __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK) / __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK);
    };
    Day.getWeekOfMonth = function (date) {
        var dom = date.date();
        var dow = date.day();
        var sundayDate = dom - dow;
        return Math.floor((sundayDate + __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].WEEK_OF_MONTH_MINIMUM_WEEKDAY + 5) / __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].DAYS_IN_WEEK);
    };
    Day.getLastDayOfMonth = function (date) {
        return date.daysInMonth() - date.date() + 1;
    };
    return Day;
}());

//# sourceMappingURL=Day.js.map

/***/ }),
/* 115 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/each.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = each;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(/*! ./_optimizeCb.js */ 153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);




// The cornerstone for collection functions, an `each`
// implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj, iteratee, context) {
  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context);
  var i, length;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj);
    for (i = 0, length = _keys.length; i < length; i++) {
      iteratee(obj[_keys[i]], _keys[i], obj);
    }
  }
  return obj;
}


/***/ }),
/* 116 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/isArray.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);



// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["t" /* nativeIsArray */] || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tagTester_js__["a" /* default */])('Array'));


/***/ }),
/* 117 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/isObject.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
// Is a given variable an object?
function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || (type === 'object' && !!obj);
}


/***/ }),
/* 118 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-style-loader/lib/addStylesClient.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(/*! ./listToStyles */ 1583)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 119 */
/* exports provided: props, BImg */
/* exports used: BImg, props */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/image/img.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BImg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









 // --- Constants --
// Blank image with fill template

var BLANK_TEMPLATE = '<svg width="%{w}" height="%{h}" ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'viewBox="0 0 %{w} %{h}" preserveAspectRatio="none">' + '<rect width="100%" height="100%" style="fill:%{f};"></rect>' + '</svg>'; // --- Helper methods ---

var makeBlankImgSrc = function makeBlankImgSrc(width, height, color) {
  var src = encodeURIComponent(BLANK_TEMPLATE.replace('%{w}', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_string__["a" /* toString */])(width)).replace('%{h}', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_string__["a" /* toString */])(height)).replace('%{f}', color));
  return "data:image/svg+xml;charset=UTF-8,".concat(src);
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["b" /* makePropsConfigurable */])({
  alt: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  blank: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  blankColor: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'transparent'),
  block: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  fluid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Gives fluid images class `w-100` to make them grow to fit container
  fluidGrow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  left: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  right: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Possible values:
  //   `false`: no rounding of corners
  //   `true`: slightly rounded corners
  //   'top': top corners rounded
  //   'right': right corners rounded
  //   'bottom': bottom corners rounded
  //   'left': left corners rounded
  //   'circle': circle/oval
  //   '0': force rounding off
  rounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  sizes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  src: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  srcset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  thumbnail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_16" /* NAME_IMG */]); // --- Main component ---
// @vue/component

var BImg = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_16" /* NAME_IMG */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data;
    var alt = props.alt,
        src = props.src,
        block = props.block,
        fluidGrow = props.fluidGrow,
        rounded = props.rounded;
    var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["b" /* toInteger */])(props.width) || null;
    var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["b" /* toInteger */])(props.height) || null;
    var align = null;
    var srcset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(props.srcset).filter(__WEBPACK_IMPORTED_MODULE_4__utils_identity__["a" /* identity */]).join(',');
    var sizes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(props.sizes).filter(__WEBPACK_IMPORTED_MODULE_4__utils_identity__["a" /* identity */]).join(',');

    if (props.blank) {
      if (!height && width) {
        height = width;
      } else if (!width && height) {
        width = height;
      }

      if (!width && !height) {
        width = 1;
        height = 1;
      } // Make a blank SVG image


      src = makeBlankImgSrc(width, height, props.blankColor || 'transparent'); // Disable srcset and sizes

      srcset = null;
      sizes = null;
    }

    if (props.left) {
      align = 'float-left';
    } else if (props.right) {
      align = 'float-right';
    } else if (props.center) {
      align = 'mx-auto';
      block = true;
    }

    return h('img', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      attrs: {
        src: src,
        alt: alt,
        width: width ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_string__["a" /* toString */])(width) : null,
        height: height ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_string__["a" /* toString */])(height) : null,
        srcset: srcset || null,
        sizes: sizes || null
      },
      class: (_class = {
        'img-thumbnail': props.thumbnail,
        'img-fluid': props.fluid || fluidGrow,
        'w-100': fluidGrow,
        rounded: rounded === '' || rounded === true
      }, _defineProperty(_class, "rounded-".concat(rounded), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["f" /* isString */])(rounded) && rounded !== ''), _defineProperty(_class, align, align), _defineProperty(_class, 'd-block', block), _class)
    }));
  }
});

/***/ }),
/* 120 */
/* exports provided: props, BTd */
/* exports used: BTd, props */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/td.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











 // --- Helper methods ---
// Parse a rowspan or colspan into a digit (or `null` if < `1` )

var parseSpan = function parseSpan(value) {
  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_number__["b" /* toInteger */])(value, 0);
  return value > 0 ? value : null;
};
/* istanbul ignore next */


var spanValidator = function spanValidator(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["g" /* isUndefinedOrNull */])(value) || parseSpan(value) > 0;
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  colspan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], null, spanValidator),
  rowspan: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], null, spanValidator),
  stackedHeading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  stickyColumn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["t" /* NAME_TABLE_CELL */]); // --- Main component ---
// TODO:
//   In Bootstrap v5, we won't need "sniffing" as table element variants properly inherit
//   to the child elements, so this can be converted to a functional component
// @vue/component

var BTd = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["t" /* NAME_TABLE_CELL */],
  // Mixin order is important!
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_9__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inject: {
    getBvTableTr: {
      default:
      /* istanbul ignore next */
      function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  inheritAttrs: false,
  props: props,
  computed: {
    bvTableTr: function bvTableTr() {
      return this.getBvTableTr();
    },
    // Overridden by `<b-th>`
    tag: function tag() {
      return 'td';
    },
    inTbody: function inTbody() {
      return this.bvTableTr.inTbody;
    },
    inThead: function inThead() {
      return this.bvTableTr.inThead;
    },
    inTfoot: function inTfoot() {
      return this.bvTableTr.inTfoot;
    },
    isDark: function isDark() {
      return this.bvTableTr.isDark;
    },
    isStacked: function isStacked() {
      return this.bvTableTr.isStacked;
    },
    // We only support stacked-heading in tbody in stacked mode
    isStackedCell: function isStackedCell() {
      return this.inTbody && this.isStacked;
    },
    isResponsive: function isResponsive() {
      return this.bvTableTr.isResponsive;
    },
    // Needed to handle header background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    // Sticky headers only apply to cells in table `thead`
    isStickyHeader: function isStickyHeader() {
      return this.bvTableTr.isStickyHeader;
    },
    // Needed to handle header background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    hasStickyHeader: function hasStickyHeader() {
      return this.bvTableTr.hasStickyHeader;
    },
    // Needed to handle background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    // Sticky column cells are only available in responsive
    // mode (horizontal scrolling) or when sticky header mode
    // Applies to cells in `thead`, `tbody` and `tfoot`
    isStickyColumn: function isStickyColumn() {
      return !this.isStacked && (this.isResponsive || this.hasStickyHeader) && this.stickyColumn;
    },
    rowVariant: function rowVariant() {
      return this.bvTableTr.variant;
    },
    headVariant: function headVariant() {
      return this.bvTableTr.headVariant;
    },
    footVariant: function footVariant() {
      return this.bvTableTr.footVariant;
    },
    tableVariant: function tableVariant() {
      return this.bvTableTr.tableVariant;
    },
    computedColspan: function computedColspan() {
      return parseSpan(this.colspan);
    },
    computedRowspan: function computedRowspan() {
      return parseSpan(this.rowspan);
    },
    // We use computed props here for improved performance by caching
    // the results of the string interpolation
    cellClasses: function cellClasses() {
      var variant = this.variant,
          headVariant = this.headVariant,
          isStickyColumn = this.isStickyColumn;

      if (!variant && this.isStickyHeader && !headVariant || !variant && isStickyColumn && this.inTfoot && !this.footVariant || !variant && isStickyColumn && this.inThead && !headVariant || !variant && isStickyColumn && this.inTbody) {
        // Needed for sticky-header mode as Bootstrap v4 table cells do
        // not inherit parent's `background-color`
        variant = this.rowVariant || this.tableVariant || 'b-table-default';
      }

      return [variant ? "".concat(this.isDark ? 'bg' : 'table', "-").concat(variant) : null, isStickyColumn ? 'b-table-sticky-column' : null];
    },
    cellAttrs: function cellAttrs() {
      var stackedHeading = this.stackedHeading; // We use computed props here for improved performance by caching
      // the results of the object spread (Object.assign)

      var headOrFoot = this.inThead || this.inTfoot; // Make sure col/rowspan's are > 0 or null

      var colspan = this.computedColspan;
      var rowspan = this.computedRowspan; // Default role and scope

      var role = 'cell';
      var scope = null; // Compute role and scope
      // We only add scopes with an explicit span of 1 or greater

      if (headOrFoot) {
        // Header or footer cells
        role = 'columnheader';
        scope = colspan > 0 ? 'colspan' : 'col';
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["p" /* isTag */])(this.tag, 'th')) {
        // th's in tbody
        role = 'rowheader';
        scope = rowspan > 0 ? 'rowgroup' : 'row';
      }

      return _objectSpread(_objectSpread({
        colspan: colspan,
        rowspan: rowspan,
        role: role,
        scope: scope
      }, this.bvAttrs), {}, {
        // Add in the stacked cell label data-attribute if in
        // stacked mode (if a stacked heading label is provided)
        'data-label': this.isStackedCell && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["g" /* isUndefinedOrNull */])(stackedHeading) ?
        /* istanbul ignore next */
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_string__["a" /* toString */])(stackedHeading) : null
      });
    }
  },
  render: function render(h) {
    var $content = [this.normalizeSlot()];
    return h(this.tag, {
      class: this.cellClasses,
      attrs: this.cellAttrs,
      // Transfer any native listeners
      on: this.bvListeners
    }, [this.isStackedCell ? h('div', [$content]) : $content]);
  }
});

/***/ }),
/* 121 */
/* exports provided: cloneDeep */
/* exports used: cloneDeep */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/clone-deep.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cloneDeep; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(/*! ./object */ 6);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var cloneDeep = function cloneDeep(obj) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : obj;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["c" /* isArray */])(obj)) {
    return obj.reduce(function (result, val) {
      return [].concat(_toConsumableArray(result), [cloneDeep(val, val)]);
    }, []);
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["h" /* isPlainObject */])(obj)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__object__["a" /* keys */])(obj).reduce(function (result, key) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, cloneDeep(obj[key], obj[key])));
    }, {});
  }

  return defaultValue;
};

/***/ }),
/* 122 */
/* exports provided: getEventRoot */
/* exports used: getEventRoot */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/get-event-root.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEventRoot; });
var getEventRoot = function getEventRoot(vm) {
  return vm.$root.$options.bvEventRoot || vm.$root;
};

/***/ }),
/* 123 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_iterators.js ***!
  \*************************************************/
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 124 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_object-keys.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(/*! ./_object-keys-internal */ 476);
var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ 260);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 125 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_to-object.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(/*! ./_defined */ 258);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 126 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/core-js/library/modules/es6.string.iterator.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(/*! ./_string-at */ 997)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(/*! ./_iter-define */ 262)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 127 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/_flatten.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(/*! ./isArray.js */ 116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(/*! ./isArguments.js */ 290);





// Internal implementation of a recursive `flatten` function.
function flatten(input, depth, strict, output) {
  output = output || [];
  if (!depth && depth !== 0) {
    depth = Infinity;
  } else if (depth <= 0) {
    return output.concat(input);
  }
  var idx = output.length;
  for (var i = 0, length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(input); i < length; i++) {
    var value = input[i];
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(value) && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(value))) {
      // Flatten current level of array or arguments object.
      if (depth > 1) {
        flatten(value, depth - 1, strict, output);
        idx = output.length;
      } else {
        var j = 0, len = value.length;
        while (j < len) output[idx++] = value[j++];
      }
    } else if (!strict) {
      output[idx++] = value;
    }
  }
  return output;
}


/***/ }),
/* 128 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/map.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);




// Return the results of applying the iteratee to each element.
function map(obj, iteratee, context) {
  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length,
      results = Array(length);
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    results[index] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 129 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/values.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = values;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);


// Retrieve the values of an object's properties.
function values(obj) {
  var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}


/***/ }),
/* 130 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./client/components/input/inputEstablishment/InputEstablishment.vue ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./InputEstablishment.vue */ 818),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-676cf406"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./inputEstablishment.pug */ 1429),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/input/inputEstablishment/InputEstablishment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] InputEstablishment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-676cf406", Component.options)
  } else {
    hotAPI.reload("data-v-676cf406", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 131 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./client/components/modals/betterModal/BetterModal.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-ea2dd414","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./BetterModal.vue */ 1558)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./BetterModal.vue */ 831),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-ea2dd414"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./betterModal.pug */ 1466),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/betterModal/BetterModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BetterModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ea2dd414", Component.options)
  } else {
    hotAPI.reload("data-v-ea2dd414", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 132 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./~/vue-tables-2/compiled/index.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__(/*! ./bus */ 160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ClientTable = __webpack_require__(/*! ./v-client-table */ 1724);

var ServerTable = __webpack_require__(/*! ./v-server-table */ 1725);

module.exports = {
  ClientTable: ClientTable,
  ServerTable: ServerTable,
  Event: _bus["default"]
};

/***/ }),
/* 133 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/vue-the-mask/dist/vue-the-mask.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueTheMask=t():e.VueTheMask=t()})(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p=".",t(t.s=10)}([function(e,t){e.exports={"#":{pattern:/\d/},X:{pattern:/[0-9a-zA-Z]/},S:{pattern:/[a-zA-Z]/},A:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleUpperCase()}},a:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleLowerCase()}},"!":{escape:!0}}},function(e,t,n){"use strict";function r(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}var a=n(2),o=n(0),i=n.n(o);t.a=function(e,t){var o=t.value;if((Array.isArray(o)||"string"==typeof o)&&(o={mask:o,tokens:i.a}),"INPUT"!==e.tagName.toLocaleUpperCase()){var u=e.getElementsByTagName("input");if(1!==u.length)throw new Error("v-mask directive requires 1 input, found "+u.length);e=u[0]}e.oninput=function(t){if(t.isTrusted){var i=e.selectionEnd,u=e.value[i-1];for(e.value=n.i(a.a)(e.value,o.mask,!0,o.tokens);i<e.value.length&&e.value.charAt(i-1)!==u;)i++;e===document.activeElement&&(e.setSelectionRange(i,i),setTimeout(function(){e.setSelectionRange(i,i)},0)),e.dispatchEvent(r("input"))}};var s=n.i(a.a)(e.value,o.mask,!0,o.tokens);s!==e.value&&(e.value=s,e.dispatchEvent(r("input")))}},function(e,t,n){"use strict";var r=n(6),a=n(5);t.a=function(e,t){var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=arguments[3];return Array.isArray(t)?n.i(a.a)(r.a,t,i)(e,t,o,i):n.i(r.a)(e,t,o,i)}},function(e,t,n){"use strict";function r(e){e.component(s.a.name,s.a),e.directive("mask",i.a)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),o=n.n(a),i=n(1),u=n(7),s=n.n(u);n.d(t,"TheMask",function(){return s.a}),n.d(t,"mask",function(){return i.a}),n.d(t,"tokens",function(){return o.a}),n.d(t,"version",function(){return c});var c="0.11.1";t.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),a=n(0),o=n.n(a),i=n(2);t.default={name:"TheMask",props:{value:[String,Number],mask:{type:[String,Array],required:!0},masked:{type:Boolean,default:!1},tokens:{type:Object,default:function(){return o.a}}},directives:{mask:r.a},data:function(){return{lastValue:null,display:this.value}},watch:{value:function(e){e!==this.lastValue&&(this.display=e)},masked:function(){this.refresh(this.display)}},computed:{config:function(){return{mask:this.mask,tokens:this.tokens,masked:this.masked}}},methods:{onInput:function(e){e.isTrusted||this.refresh(e.target.value)},refresh:function(e){this.display=e;var e=n.i(i.a)(e,this.mask,this.masked,this.tokens);e!==this.lastValue&&(this.lastValue=e,this.$emit("input",e))}}}},function(e,t,n){"use strict";function r(e,t,n){return t=t.sort(function(e,t){return e.length-t.length}),function(r,a){for(var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=0;i<t.length;){var u=t[i];i++;var s=t[i];if(!(s&&e(r,s,!0,n).length>u.length))return e(r,u,o,n)}return""}}t.a=r},function(e,t,n){"use strict";function r(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=arguments[3];e=e||"",t=t||"";for(var a=0,o=0,i="";a<t.length&&o<e.length;){var u=t[a],s=r[u],c=e[o];s&&!s.escape?(s.pattern.test(c)&&(i+=s.transform?s.transform(c):c,a++),o++):(s&&s.escape&&(a++,u=t[a]),n&&(i+=u),c===u&&o++,a++)}for(var f="";a<t.length&&n;){var u=t[a];if(r[u]){f="";break}f+=u,a++}return i+f}t.a=r},function(e,t,n){var r=n(8)(n(4),n(9),null,null);e.exports=r.exports},function(e,t){e.exports=function(e,t,n,r){var a,o=e=e||{},i=typeof e.default;"object"!==i&&"function"!==i||(a=e,o=e.default);var u="function"==typeof o?o.options:o;if(t&&(u.render=t.render,u.staticRenderFns=t.staticRenderFns),n&&(u._scopeId=n),r){var s=u.computed||(u.computed={});Object.keys(r).forEach(function(e){var t=r[e];s[e]=function(){return t}})}return{esModule:a,exports:o,options:u}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{directives:[{name:"mask",rawName:"v-mask",value:e.config,expression:"config"}],attrs:{type:"text"},domProps:{value:e.display},on:{input:e.onInput}})},staticRenderFns:[]}},function(e,t,n){e.exports=n(3)}])});

/***/ }),
/* 134 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./client/enum/funcionalidadeId.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FuncionalidadeIdEnum = {
  TAREFAS: 209,
  RETOMAR_CONCILIACAO: 5011
};

exports.default = FuncionalidadeIdEnum;

/***/ }),
/* 135 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./client/utils/customFilters.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var filterString = function filterString(value, query) {
  return value.trim().match(new RegExp(query.trim(), 'i'));
};

var filterByBank = function filterByBank(row, query) {
  return filterString(row.banco.codigo + '-' + row.banco.nomeFantasia, query);
};
var filterByAgency = function filterByAgency(row, query) {
  return filterString(row.numAgencia + (row.digAgencia ? '-' + row.digAgencia : ''), query);
};
var filterByAccount = function filterByAccount(row, query) {
  return filterString(row.conta + (row.digConta ? '-' + row.digConta : ''), query);
};
var filterByAccessProfileName = function filterByAccessProfileName(row, query) {
  if (row.perfilAcesso) {
    if (row.perfilAcesso.nomePerfilAcesso) {
      return filterString(row.perfilAcesso ? row.perfilAcesso.nomePerfilAcesso : '-', query);
    } else if (row.perfilAcesso.nome) {
      return filterString(row.perfilAcesso ? row.perfilAcesso.nome : '-', query);
    }
  } else if (row.nomePerfilAcesso) {
    return filterString(row.nomePerfilAcesso ? row.nomePerfilAcesso : '-', query);
  } else if (row.nome) {
    return filterString(row.nome ? row.nome : '-', query);
  }
};
var filterBySituation = function filterBySituation(row, query) {
  return filterString(row.ativo ? 'Ativo' : 'Inativo', query);
};
var filterByCategory = function filterByCategory(row, query) {
  return filterString(row.categoria ? row.categoria.numero + ' - ' + row.categoria.nome : ' - ', query);
};
var filterByEmail = function filterByEmail(row, query) {
  return row.email.toLowerCase().includes(query.toLowerCase());
};
var filterByStatus = function filterByStatus(row, query) {
  return row.statusText.toLowerCase().includes(query.toLowerCase());
};

exports.filterByBank = filterByBank;
exports.filterByAgency = filterByAgency;
exports.filterByAccount = filterByAccount;
exports.filterByAccessProfileName = filterByAccessProfileName;
exports.filterBySituation = filterBySituation;
exports.filterByCategory = filterByCategory;
exports.filterByEmail = filterByEmail;
exports.filterByStatus = filterByStatus;

/***/ }),
/* 136 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/babel-runtime/core-js/json/stringify.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/json/stringify */ 963), __esModule: true };

/***/ }),
/* 137 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/babel-runtime/helpers/typeof.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(/*! ../core-js/symbol/iterator */ 921);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(/*! ../core-js/symbol */ 920);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 138 */
/* exports provided: props, BIcon */
/* exports used: BIcon */
/*!*******************************************!*\
  !*** ./~/bootstrap-vue/esm/icons/icon.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_string__ = __webpack_require__(/*! ../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons__ = __webpack_require__(/*! ./icons */ 61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_icon_base__ = __webpack_require__(/*! ./helpers/icon-base */ 249);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









 // --- Helper methods ---

var findIconComponent = function findIconComponent(ctx, iconName) {
  if (!ctx) {
    return __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].component(iconName);
  }

  var components = (ctx.$options || {}).components;
  var iconComponent = components && components[iconName];
  return iconComponent || findIconComponent(ctx.$parent, iconName);
}; // --- Props ---


var iconProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_8__helpers_icon_base__["a" /* props */], ['content']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, iconProps), {}, {
  icon: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_75" /* NAME_ICON */]); // --- Main component ---
// Helper BIcon component
// Requires the requested icon component to be installed
// @vue/component

var BIcon = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_75" /* NAME_ICON */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        parent = _ref.parent;
    var icon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_string__["j" /* pascalCase */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_string__["f" /* trim */])(props.icon || '')).replace(__WEBPACK_IMPORTED_MODULE_3__constants_regex__["F" /* RX_ICON_PREFIX */], ''); // If parent context exists, we check to see if the icon has been registered
    // either locally in the parent component, or globally at the `$root` level
    // If not registered, we render a blank icon

    return h(icon ? findIconComponent(parent, "BIcon".concat(icon)) || __WEBPACK_IMPORTED_MODULE_7__icons__["a" /* BIconBlank */] : __WEBPACK_IMPORTED_MODULE_7__icons__["a" /* BIconBlank */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["c" /* pluckProps */])(iconProps, props)
    }));
  }
});

/***/ }),
/* 139 */
/* exports provided: getInstanceFromDirective */
/* exports used: getInstanceFromDirective */
/*!******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/get-instance-from-directive.js ***!
  \******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInstanceFromDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);

var getInstanceFromDirective = function getInstanceFromDirective(vnode, bindings) {
  return __WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */] ? bindings.instance : vnode.context;
};

/***/ }),
/* 140 */
/* exports provided: getScopeId */
/* exports used: getScopeId */
/*!***************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/get-scope-id.js ***!
  \***************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getScopeId; });
// This method returns a component's scoped style attribute name: `data-v-xxxxxxx`
// The `_scopeId` options property is added by vue-loader when using scoped styles
// and will be `undefined` if no scoped styles are in use
var getScopeId = function getScopeId(vm) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return vm ? vm.$options._scopeId || defaultValue : defaultValue;
};

/***/ }),
/* 141 */
/* exports provided: getRaw, get */
/* exports used: getRaw, get */
/*!******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/get.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(/*! ./identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inspect__ = __webpack_require__(/*! ./inspect */ 9);



/**
 * Get property defined by dot/array notation in string, returns undefined if not found
 *
 * @link https://gist.github.com/jeneg/9767afdcca45601ea44930ea03e0febf#gistcomment-1935901
 *
 * @param {Object} obj
 * @param {string|Array} path
 * @return {*}
 */

var getRaw = function getRaw(obj, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  // Handle array of path values
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["c" /* isArray */])(path) ? path.join('.') : path; // If no path or no object passed

  if (!path || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["d" /* isObject */])(obj)) {
    return defaultValue;
  } // Handle edge case where user has dot(s) in top-level item field key
  // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2762
  // Switched to `in` operator vs `hasOwnProperty` to handle obj.prototype getters
  // https://github.com/bootstrap-vue/bootstrap-vue/issues/3463


  if (path in obj) {
    return obj[path];
  } // Handle string array notation (numeric indices only)


  path = String(path).replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["k" /* RX_ARRAY_NOTATION */], '.$1');
  var steps = path.split('.').filter(__WEBPACK_IMPORTED_MODULE_1__identity__["a" /* identity */]); // Handle case where someone passes a string of only dots

  if (steps.length === 0) {
    return defaultValue;
  } // Traverse path in object to find result
  // Switched to `in` operator vs `hasOwnProperty` to handle obj.prototype getters
  // https://github.com/bootstrap-vue/bootstrap-vue/issues/3463


  return steps.every(function (step) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["d" /* isObject */])(obj) && step in obj && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["g" /* isUndefinedOrNull */])(obj = obj[step]);
  }) ? obj : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["e" /* isNull */])(obj) ? null : defaultValue;
};
/**
 * Get property defined by dot/array notation in string.
 *
 * @link https://gist.github.com/jeneg/9767afdcca45601ea44930ea03e0febf#gistcomment-1935901
 *
 * @param {Object} obj
 * @param {string|Array} path
 * @param {*} defaultValue (optional)
 * @return {*}
 */

var get = function get(obj, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var value = getRaw(obj, path);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__inspect__["g" /* isUndefinedOrNull */])(value) ? defaultValue : value;
};

/***/ }),
/* 142 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_a-function.js ***!
  \**************************************************/
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 143 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/core-js/library/modules/_cof.js ***!
  \*******************************************/
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 144 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/modules/_for-of.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(/*! ./_ctx */ 96);
var call = __webpack_require__(/*! ./_iter-call */ 472);
var isArrayIter = __webpack_require__(/*! ./_is-array-iter */ 470);
var anObject = __webpack_require__(/*! ./_an-object */ 89);
var toLength = __webpack_require__(/*! ./_to-length */ 187);
var getIterFn = __webpack_require__(/*! ./core.get-iterator-method */ 274);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 145 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/modules/_library.js ***!
  \***********************************************/
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 146 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_object-pie.js ***!
  \**************************************************/
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 147 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/core-js/library/modules/_property-desc.js ***!
  \*****************************************************/
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 148 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/core-js/library/modules/_set-to-string-tag.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(/*! ./_object-dp */ 75).f;
var has = __webpack_require__(/*! ./_has */ 112);
var TAG = __webpack_require__(/*! ./_wks */ 56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 149 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/core-js/library/modules/web.dom.iterable.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./es6.array.iterator */ 1003);
var global = __webpack_require__(/*! ./_global */ 55);
var hide = __webpack_require__(/*! ./_hide */ 97);
var Iterators = __webpack_require__(/*! ./_iterators */ 123);
var TO_STRING_TAG = __webpack_require__(/*! ./_wks */ 56)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 150 */
/* exports provided: IteratorAction, Iterator */
/* exports used: IteratorAction, Iterator */
/*!***********************************!*\
  !*** ./~/dayspan/lib/Iterator.js ***!
  \***********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IteratorAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Iterator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);


/**
 * An action to perform on the source as instructed by the iterator.
 */
var IteratorAction;
(function (IteratorAction) {
    /**
     * Continue iteration.
     */
    IteratorAction[IteratorAction["Continue"] = 0] = "Continue";
    /**
     * Stop iteration.
     */
    IteratorAction[IteratorAction["Stop"] = 1] = "Stop";
    /**
     * Remove the current item if possible, and continue iteration.
     */
    IteratorAction[IteratorAction["Remove"] = 2] = "Remove";
    /**
     * Replace the current item with the provided value.
     */
    IteratorAction[IteratorAction["Replace"] = 3] = "Replace";
})(IteratorAction = IteratorAction || (IteratorAction = {}));
/**
 * A class that allows an iteratable source to be iterated any number of times
 * by providing the following functionality:
 *
 * - [[Iterator.isEmpty]]: Determines whether the source contains any items.
 * - [[Iterator.first]]: Gets the first item in the source.
 * - [[Iterator.count]]: Counds the number of items in the source.
 * - [[Iterator.list]]: Builds a list of the items in the source.
 * - [[Iterator.object]]: Builds an object of the items in the source.
 * - [[Iterator.reduce]]: Reduces the items in the source down to a single value.
 * - [[Iterator.purge]]: Removes items from the source which meet some criteria.
 * - [[Iterator.filter]]: Returns a subset of items that meet some criteria by
 *    returning a new Iterator.
 * - [[Iterator.map]]: Maps each item in the source to another item by returning
 *    a new Iterator.
 * - [[Iterator.iterate]]: Invokes a function for each item in the source.
 *
 * The following static functions exist to help iterate simple sources:
 *
 * - [[Iterator.forArray]]: Iterates an array, optionally reverse
 * - [[Iterator.forObject]]: Iterates the properties of an object, optionally
 *    just the properties explicitly set on the object.
 *
 * ```typescript
 * let iter = object.iterateThings();
 * iter.isEmpty();              // no items?
 * iter.isEmpty(d => d.flag);   // no items that meet some criteria?
 * iter.count();                // number of items
 * iter.count(d => d.flag);     // number of items that meet some criteria
 * iter.first();                // first item
 * iter.first(d => d.flag);     // first item that meets some criteria
 * iter.list();                 // get all items as array
 * iter.list(myArray);          // add all items to given array
 * iter.list([], d => d.flag);  // get all items as array that meet some criteria
 * iter.object(d => d.id);      // get all items as an object keyed by a value (ex: id)
 * iter.object(d => d.id, {},
 *    d => d.flag);             // get all items as an object keyed by a value where the item meets some criteria (ex: key id if flag is truthy)
 * iter.purge(d => d.flag);     // remove all items from source that meet some criteria
 * iter.filter(d => d.flag);    // returns an iterator which iterates a subset of items which meet some criteria
 * iter.reduce<number>(0,
 *   (d, t) => t + d.size);     // reduces all items to a single value (ex: sums all size)
 * iter.reduce<number>(0,
 *   (d, t) => t + d.size,
 *   d => d.flag);              // reduces all items to a single value (ex: sums all size) where the item meets some criteria
 * iter.map<S>(d => d.subitem); // return an iterator for subitems if they exist
 * iter.iterate(d => log(d));   // do something for each item
 * ```
 *
 * @typeparam T The type of item being iterated.
 */
var Iterator = (function () {
    /**
     * Creates a new Iterator given a source.
     *
     * @param source The source of items to iterator.
     */
    function Iterator(source) {
        /**
         * A result of the iteration passed to [[Iterator.stop]].
         */
        this.result = null;
        this.source = source;
    }
    /**
     * Returns a clone of this iterator with the same source. This is necessary
     * if you want to iterate all or a portion of the source while already
     * iterating it (like a nested loop).
     */
    Iterator.prototype.clone = function () {
        return new Iterator(this.source);
    };
    /**
     * Passes the given item to the iterator callback and returns the action
     * requested at this point in iteration.
     *
     * @param item The current item being iterated.
     */
    Iterator.prototype.act = function (item) {
        this.action = IteratorAction.Continue;
        this.replaceWith = null;
        this.callback(item, this);
        return this.action;
    };
    /**
     * Stops iteration and optionally sets the result of the iteration.
     *
     * @param result The result of the iteration.
     */
    Iterator.prototype.stop = function (result) {
        this.result = result;
        this.action = IteratorAction.Stop;
        return this;
    };
    /**
     * Stops iteration and optionally sets the result of the iteration.
     *
     * @param result The result of the iteration.
     */
    Iterator.prototype.replace = function (replaceWith) {
        this.replaceWith = replaceWith;
        this.action = IteratorAction.Replace;
        return this;
    };
    /**
     * Signals to the iterator source that the current item wants to be removed.
     */
    Iterator.prototype.remove = function () {
        this.action = IteratorAction.Remove;
        return this;
    };
    /**
     * Determines with this iterator is empty. A filter function can be specified
     * to only check for items which match certain criteria.
     *
     * @param filter A function to the checks items for certain criteria.
     * @returns `true` if no valid items exist in the source.
     */
    Iterator.prototype.isEmpty = function (filter) {
        if (filter === void 0) { filter = null; }
        var empty = true;
        this.iterate(function (item, iterator) {
            if (filter && !filter(item)) {
                return;
            }
            empty = false;
            iterator.stop();
        });
        return empty;
    };
    /**
     * Counts the number of items in the iterator. A filter function can be
     * specified to only count items which match certain criteria.
     *
     * @param filter A function to count items for certain criteria.
     * @returns The number of items in the source that optionally match the given
     *    criteria.
     */
    Iterator.prototype.count = function (filter) {
        if (filter === void 0) { filter = null; }
        var total = 0;
        this.iterate(function (item, iterator) {
            if (filter && !filter(item)) {
                return;
            }
            total++;
        });
        return total;
    };
    /**
     * Returns the first item in the iterator. A filter function can be specified
     * to only return the first item which matches certain criteria.
     *
     * @param filter A function to compare items to to match certain criteria.
     * @returns The first item found that optonally matches the given criteria.
     */
    Iterator.prototype.first = function (filter) {
        if (filter === void 0) { filter = null; }
        var first = null;
        this.iterate(function (item, iterator) {
            if (filter && !filter(item)) {
                return;
            }
            first = item;
            iterator.stop();
        });
        return first;
    };
    /**
     * Builds a list of items from the source. A filter function can be specified
     * so the resulting list only contain items that match certain criteria.
     *
     * @param out The array to place the items in.
     * @param filter The function which determines which items are added to the list.
     * @returns The reference to `out` which has had items added to it which
     *    optionally match the given criteria.
     */
    Iterator.prototype.list = function (out, filter) {
        if (out === void 0) { out = []; }
        if (filter === void 0) { filter = null; }
        this.iterate(function (item, iterator) {
            if (filter && !filter(item)) {
                return;
            }
            out.push(item);
        });
        return out;
    };
    /**
     * Builds an object of items from the source keyed by a result returned by
     * a `getKey` function.
     *
     * @param getKey The function which returns the key of the object.
     * @param out The object to place the items in.
     * @param filter The function which determines which items are set on the object.
     * @returns The reference to `out` which has had items set to it which
     *    optionally match the given criteria.
     */
    Iterator.prototype.object = function (getKey, out, filter) {
        if (out === void 0) { out = {}; }
        if (filter === void 0) { filter = null; }
        this.iterate(function (item, iterator) {
            if (filter && !filter(item)) {
                return;
            }
            var key = getKey(item);
            out[key] = item;
        });
        return out;
    };
    /**
     * Returns a new iterator that only returns a maximum number of items.
     *
     * @param amount The maximum number of items to return.
     * @returns A new iterator which returns a maximum number of items.
     */
    Iterator.prototype.take = function (amount) {
        var _this = this;
        return new Iterator(function (next) {
            _this.iterate(function (item, prev) {
                switch (next.act(item)) {
                    case IteratorAction.Stop:
                        prev.stop();
                        break;
                    case IteratorAction.Remove:
                        prev.remove();
                        break;
                    case IteratorAction.Replace:
                        prev.replace(next.replaceWith);
                        break;
                }
                if (--amount <= 0) {
                    prev.stop();
                }
            });
        });
    };
    /**
     * Returns a new iterator that skips the given number of items from the items
     * in this iterator.
     *
     * @param amount The number of items to skip.
     * @returns A new iterator which skipped the given number of items.
     */
    Iterator.prototype.skip = function (amount) {
        var _this = this;
        return new Iterator(function (next) {
            var skipped = 0;
            _this.iterate(function (item, prev) {
                if (skipped >= amount) {
                    switch (next.act(item)) {
                        case IteratorAction.Stop:
                            prev.stop();
                            break;
                        case IteratorAction.Remove:
                            prev.remove();
                            break;
                        case IteratorAction.Replace:
                            prev.replace(next.replaceWith);
                            break;
                    }
                }
                skipped++;
            });
        });
    };
    /**
     * Returns a new iterator thats items are the items in this iterator followed
     * by the items in the given iterators.
     *
     * @param iterators The iterators to append after this one.
     * @returns A new iterator based on this iterator followed by the given.
     */
    Iterator.prototype.append = function () {
        var iterators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            iterators[_i] = arguments[_i];
        }
        return Iterator.join.apply(Iterator, [this].concat(iterators));
    };
    /**
     * Returns a new iterator thats items are the items in the given iterators
     * followed by the items in this iterator.
     *
     * @param iterators The iterators to prepend before this one.
     * @returns A new iterator based on the given iterators followed by this.
     */
    Iterator.prototype.prepend = function () {
        var iterators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            iterators[_i] = arguments[_i];
        }
        return Iterator.join.apply(Iterator, iterators.concat([this]));
    };
    /**
     * Removes items from the source that match certain criteria.
     *
     * @param filter The function which determines which items to remove.
     */
    Iterator.prototype.purge = function (filter) {
        this.iterate(function (item, iterator) {
            if (filter(item)) {
                iterator.remove();
            }
        });
        return this;
    };
    /**
     * Returns an iterator which takes items from this iterator and presents them
     * in reverse.
     *
     * @returns A new iterator with the items in this iterator in reverse.
     */
    Iterator.prototype.reverse = function () {
        var _this = this;
        return new Iterator(function (iterator) {
            var items = _this.list();
            var modifies = false;
            var actions = [];
            var replaces = [];
            for (var i = items.length - 1; i >= 0; i--) {
                var item = items[i];
                var action = iterator.act(item);
                if (action === IteratorAction.Stop) {
                    break;
                }
                if (action !== IteratorAction.Continue) {
                    modifies = true;
                    actions[i] = action;
                    replaces[i] = iterator.replaceWith;
                }
            }
            if (modifies) {
                var index_1 = 0;
                _this.iterate(function (item, iterator) {
                    switch (actions[index_1]) {
                        case IteratorAction.Remove:
                            iterator.remove();
                            break;
                        case IteratorAction.Replace:
                            iterator.replace(replaces[index_1]);
                            break;
                    }
                    index_1++;
                });
            }
        });
    };
    /**
     * Reduces all the items in the source to a single value given the initial
     * value and a function to convert an item and the current reduced value
     */
    Iterator.prototype.reduce = function (initial, reducer, filter) {
        if (filter === void 0) { filter = null; }
        var reduced = initial;
        this.iterate(function (item, iterator) {
            if (filter && !filter(item)) {
                return;
            }
            reduced = reducer(item, reduced);
        });
        return reduced;
    };
    /**
     * Returns an iterator where this iterator is the source and the returned
     * iterator is built on a subset of items which pass a `filter` function.
     *
     * @param filter The function which determines if an item should be iterated.
     * @returns A new iterator for the filtered items from this iterator.
     */
    Iterator.prototype.filter = function (filter) {
        var _this = this;
        return new Iterator(function (next) {
            _this.iterate(function (prevItem, prev) {
                if (filter(prevItem)) {
                    switch (next.act(prevItem)) {
                        case IteratorAction.Stop:
                            prev.stop();
                            break;
                        case IteratorAction.Remove:
                            prev.remove();
                            break;
                        case IteratorAction.Replace:
                            prev.replace(next.replaceWith);
                            break;
                    }
                }
            });
        });
    };
    /**
     * Returns an iterator where this iterator is the source and the returned
     * iterator is built from mapped items pulled from items in the source
     * of this iterator. If the given callback `outerCallback` does not return
     * a mapped value then the returned iterator will not see the item. A filter
     * function can be specified to only look at mapping items which match
     * certain criteria.
     *
     * @param mapper The function which maps an item to another.
     * @param filter The function which determines if an item should be mapped.
     * @param unmapper The function which unmaps a value when replace is called.
     * @returns A new iterator for the mapped items from this iterator.
     */
    Iterator.prototype.map = function (mapper, filter, unmapper) {
        var _this = this;
        if (filter === void 0) { filter = null; }
        if (unmapper === void 0) { unmapper = null; }
        return new Iterator(function (next) {
            _this.iterate(function (prevItem, prev) {
                if (filter && !filter(prevItem)) {
                    return;
                }
                var nextItem = mapper(prevItem, prev);
                if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(nextItem)) {
                    switch (next.act(nextItem)) {
                        case IteratorAction.Stop:
                            prev.stop();
                            break;
                        case IteratorAction.Remove:
                            prev.remove();
                            break;
                        case IteratorAction.Replace:
                            if (unmapper) {
                                prev.replace(unmapper(next.replaceWith, nextItem, prevItem));
                            }
                            break;
                    }
                }
            });
        });
    };
    /**
     * Invokes the callback for each item in the source of this iterator. The
     * second argument in the callback is the reference to this iterator and
     * [[Iterator.stop]] can be called at anytime to cease iteration.
     *
     * @param callback The function to invoke for each item in this iterator.
     */
    Iterator.prototype.iterate = function (callback) {
        this.result = undefined;
        this.callback = callback;
        this.action = IteratorAction.Continue;
        this.source(this);
        this.callback = null;
        return this;
    };
    /**
     * Passes the result of the iteration to the given function if a truthy
     * result was passed to [[Iterator.stop]].
     *
     * @param getResult The function to pass the result to if it exists.
     */
    Iterator.prototype.withResult = function (getResult) {
        if (this.result) {
            getResult(this.result);
        }
        return this;
    };
    /**
     * Returns an iterator for the given array optionally iterating it in reverse.
     *
     * @param items The array of items to iterate.
     * @param reverse If the array should be iterated in reverse.
     * @returns A new iterator for the given array.
     */
    Iterator.forArray = function (items, reverse) {
        if (reverse === void 0) { reverse = false; }
        return new Iterator(function (iterator) {
            if (reverse) {
                for (var i = items.length - 1; i >= 0; i--) {
                    switch (iterator.act(items[i])) {
                        case IteratorAction.Stop:
                            return;
                        case IteratorAction.Remove:
                            items.splice(i, 1);
                            break;
                        case IteratorAction.Replace:
                            items.splice(i, 1, iterator.replaceWith);
                            break;
                    }
                }
            }
            else {
                for (var i = 0; i < items.length; i++) {
                    switch (iterator.act(items[i])) {
                        case IteratorAction.Stop:
                            return;
                        case IteratorAction.Remove:
                            items.splice(i, 1);
                            i--;
                            break;
                        case IteratorAction.Replace:
                            items.splice(i, 1, iterator.replaceWith);
                            break;
                    }
                }
            }
        });
    };
    /**
     * Returns an iterator for the given object optionally checking the
     * `hasOwnProperty` function on the given object.
     *
     * @param items The object to iterate.
     * @param hasOwnProperty If `hasOwnProperty` should be checked.
     * @returns A new iterator for the given object.
     */
    Iterator.forObject = function (items, hasOwnProperty) {
        if (hasOwnProperty === void 0) { hasOwnProperty = true; }
        return new Iterator(function (iterator) {
            for (var key in items) {
                if (hasOwnProperty && !items.hasOwnProperty(key)) {
                    continue;
                }
                switch (iterator.act(items[key])) {
                    case IteratorAction.Stop:
                        return;
                    case IteratorAction.Remove:
                        delete items[key];
                        break;
                    case IteratorAction.Replace:
                        items[key] = iterator.replaceWith;
                        break;
                }
            }
        });
    };
    /**
     * Joins all the given iterators into a single iterator where the items
     * returned are in the same order as passed to this function. If any items
     * are removed from the returned iterator they will be removed from the given
     * iterator if it supports removal.
     *
     * @param iterators The array of iterators to join as one.
     * @returns A new iterator for the given iterators.
     */
    Iterator.join = function () {
        var iterators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            iterators[_i] = arguments[_i];
        }
        return new Iterator(function (parent) {
            for (var _i = 0, iterators_1 = iterators; _i < iterators_1.length; _i++) {
                var child = iterators_1[_i];
                child.iterate(function (item, childIterator) {
                    switch (parent.act(item)) {
                        case IteratorAction.Remove:
                            childIterator.remove();
                            break;
                        case IteratorAction.Stop:
                            childIterator.stop();
                            break;
                        case IteratorAction.Replace:
                            childIterator.replace(parent.replaceWith);
                            break;
                    }
                });
                if (child.action === IteratorAction.Stop) {
                    return;
                }
            }
        });
    };
    /**
     * Returns a new iterator with no items.
     *
     * @returns A new iterator with no items.
     */
    Iterator.empty = function () {
        return new Iterator(function (parent) { });
    };
    return Iterator;
}());

//# sourceMappingURL=Iterator.js.map

/***/ }),
/* 151 */
/* exports provided: Op, operate */
/* exports used: Op, operate */
/*!************************************!*\
  !*** ./~/dayspan/lib/Operation.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Op; });
/* harmony export (immutable) */ __webpack_exports__["b"] = operate;

/**
 * An operation that can be performed on a single number.
 */
var Op;
(function (Op) {
    /**
     * The number is returned unmodified.
     */
    Op[Op["NONE"] = 0] = "NONE";
    /**
     * The number is rounded down to the nearest whole number.
     */
    Op[Op["FLOOR"] = 1] = "FLOOR";
    /**
     * The number is rounded up to the nearest whole number.
     */
    Op[Op["CEIL"] = 2] = "CEIL";
    /**
     * The number is rounded up or down depending on if the fractional value is
     * greater than or less than 0.5 respectively.
     */
    Op[Op["ROUND"] = 3] = "ROUND";
    /**
     * The fractional part of the number is dropped.
     */
    Op[Op["TRUNCATE"] = 4] = "TRUNCATE";
    /**
     * The number is rounded up when positive and down when negative. This is
     * effectively ceiling the absolute value where the result preserves the sign.
     */
    Op[Op["UP"] = 5] = "UP";
    /**
     * The number is rounded down when positive and up when negative. This is
     * effectively floor the absolute value where the result preserves the sign.
     */
    Op[Op["DOWN"] = 6] = "DOWN";
})(Op = Op || (Op = {}));
/**
 * Performs the requested operation on the given number, optionally taking
 * the absolute value of the number before the operation.
 *
 * @param value The number to operate on.
 * @param op The operation to perform.
 * @param absolute If the number should be positive before the operation.
 * @return The operated result, or the original value if its not a valid number.
 */
function operate(value, op, absolute) {
    if (absolute === void 0) { absolute = false; }
    if (isFinite(value)) {
        if (absolute) {
            value = Math.abs(value);
        }
        switch (op) {
            case Op.NONE:
                return value;
            case Op.FLOOR:
                return Math.floor(value);
            case Op.CEIL:
                return Math.ceil(value);
            case Op.ROUND:
                return Math.round(value);
            case Op.TRUNCATE:
            case Op.DOWN:
                return value < 0 ? Math.ceil(value) : Math.floor(value);
            case Op.UP:
                return value < 0 ? Math.floor(value) : Math.ceil(value);
        }
    }
    return value;
}
//# sourceMappingURL=Operation.js.map

/***/ }),
/* 152 */
/* exports provided: Parse */
/* exports used: Parse */
/*!********************************!*\
  !*** ./~/dayspan/lib/Parse.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Parse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Schedule__ = __webpack_require__(/*! ./Schedule */ 276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScheduleModifier__ = __webpack_require__(/*! ./ScheduleModifier */ 277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(/*! ./Constants */ 98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Day__ = __webpack_require__(/*! ./Day */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Event__ = __webpack_require__(/*! ./Event */ 487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Time__ = __webpack_require__(/*! ./Time */ 279);








/**
 * The class which takes user input and parses it to specific structures.
 */
var Parse = (function () {
    function Parse() {
    }
    /**
     * Parses a value and converts it to a [[FrequencyCheck]].
     *
     * @param input The input to parse into a function.
     * @param property The [[Day]] property the frequency is for.
     * @returns A function which determines whether a value matches a frequency.
     * @see [[Schedule]]
     */
    Parse.frequency = function (input, property) {
        var check = function (value) {
            return true;
        };
        check.given = false;
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isFrequencyValueEvery(input)) {
            var every_1 = input.every;
            var offset_1 = (input.offset || 0) % every_1;
            check = function (value) {
                return value % every_1 === offset_1;
            };
            check.given = true;
        }
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isFrequencyValueOneOf(input)) {
            var map_1 = {};
            for (var i = 0; i < input.length; i++) {
                map_1[input[i]] = true;
            }
            check = function (value) {
                return !!map_1[value];
            };
            check.given = true;
        }
        check.input = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input, null);
        check.property = property;
        return check;
    };
    /**
     * Parses [[DayInput]] into a [[Day]] instance.
     *
     * ```typescript
     * Parse.day( 65342300 );               // UTC timestamp
     * Parse.day( '01/02/2014' );           // strings in many formats
     * Parse.day( day );                    // return a passed instance
     * Parse.day( [2018, 0, 2] );           // array: 01/02/2018
     * Parse.day( {year: 2018, month: 2} ); // object: 03/01/2018
     * Parse.day( true );                   // today
     * ```
     *
     * @param input The input to parse.
     * @returns The Day parsed or `null` if the value is not valid.
     */
    Parse.day = function (input) {
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isNumber(input)) {
            return __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* Day */].unix(input);
        }
        else if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isString(input)) {
            return __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* Day */].fromString(input);
        }
        else if (input instanceof __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* Day */]) {
            return input;
        }
        else if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(input)) {
            return __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* Day */].fromArray(input);
        }
        else if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isObject(input)) {
            return __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* Day */].fromObject(input);
        }
        else if (input === true) {
            return __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* Day */].today();
        }
        return null;
    };
    /**
     * Parses a value and tries to convert it to a Time instance.
     *
     * ```typescript
     * Parse.time( time );      // return a passed instance
     * Parse.time( 9 );         // 09:00:00.000
     * Parse.time( 3009 );      // 09:30:00.000
     * Parse.time( 593009 );    // 09:30:59.000
     * Parsetime( '09' );       // 09:00:00.000
     * Parse.time( '9:30' );    // 09:30:00.000
     * Parse.time( '9:30:59' ); // 09:30:59.000
     * Parse.time( {hour: 2} ); // 02:00:00.000
     * ```
     *
     * @param input The input to parse.
     * @returns The instance parsed or `null` if it was invalid.
     * @see [[Time.fromIdentifier]]
     * @see [[Time.fromString]]
     */
    Parse.time = function (input) {
        if (input instanceof __WEBPACK_IMPORTED_MODULE_6__Time__["a" /* Time */]) {
            return input;
        }
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isNumber(input)) {
            return __WEBPACK_IMPORTED_MODULE_6__Time__["a" /* Time */].fromIdentifier(input);
        }
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isString(input)) {
            return __WEBPACK_IMPORTED_MODULE_6__Time__["a" /* Time */].fromString(input);
        }
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isObject(input) && __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isNumber(input.hour)) {
            return new __WEBPACK_IMPORTED_MODULE_6__Time__["a" /* Time */](input.hour, input.minute, input.second, input.millisecond);
        }
        return null;
    };
    /**
     * Parses a value and tries to convert it to an array of Time instances.
     * If any of the given values are not a valid time value then the resulting
     * array will not contain a time instance.
     *
     * @param input The input to parse.
     * @returns A non-null array of time instances.
     * @see [[Parse.time]]
     */
    Parse.times = function (input) {
        var times = [];
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(input)) {
            for (var _i = 0, input_1 = input; _i < input_1.length; _i++) {
                var timeInput = input_1[_i];
                var time = this.time(timeInput);
                if (time) {
                    times.push(time);
                }
            }
            // Sort times from earliest to latest.
            times.sort(function (a, b) {
                return a.toMilliseconds() - b.toMilliseconds();
            });
        }
        return times;
    };
    /**
     * Parses an array of excluded days into a map of excluded days where the
     * array value and returned object key are [[Day.dayIdentifier]].
     *
     * ```typescript
     * Parse.modifier( [ 20180101, 20140506 ] );            // {'20180101': true, '20140506': true}
     * Parse.modifier( [ 20180101, Day.build(2014,4,6) ] ); // {'20180101': true, '20140506': true}
     * ```
     *
     * @param input The input to parse.
     * @param value The default value if the input given is an array of identifiers.
     * @param parseMeta A function to use to parse a modifier.
     * @param out The modifier to set the identifiers and values of and return.
     * @returns The object with identifier keys and `true` values.
     * @see [[Day.dayIdentifier]]
     */
    Parse.modifier = function (input, value, parseMeta, out) {
        if (parseMeta === void 0) { parseMeta = (function (x) { return x; }); }
        if (out === void 0) { out = new __WEBPACK_IMPORTED_MODULE_2__ScheduleModifier__["a" /* ScheduleModifier */](); }
        var map = {};
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(input)) {
            for (var _i = 0, input_2 = input; _i < input_2.length; _i++) {
                var identifier = input_2[_i];
                if (identifier instanceof __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* Day */]) {
                    map[identifier.dayIdentifier] = value;
                }
                else if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isNumber(identifier)) {
                    map[identifier] = value;
                }
                else if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isString(identifier)) {
                    map[identifier] = value;
                }
            }
        }
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isObject(input)) {
            for (var identifier in input) {
                map[identifier] = parseMeta(input[identifier]);
            }
        }
        out.map = map;
        return out;
    };
    /**
     * Parses an object which specifies a schedule where events may or may not
     * repeat and they may be all day events or at specific times.
     *
     * @param input The input to parse into a schedule.
     * @param parseMeta A function to use when parsing meta input into the desired type.
     * @param out The schedule to set the values of and return.
     * @returns An instance of the parsed [[Schedule]].
     */
    Parse.schedule = function (input, parseMeta, out) {
        if (parseMeta === void 0) { parseMeta = (function (x) { return x; }); }
        if (out === void 0) { out = new __WEBPACK_IMPORTED_MODULE_1__Schedule__["a" /* Schedule */](); }
        if (input instanceof __WEBPACK_IMPORTED_MODULE_1__Schedule__["a" /* Schedule */]) {
            return input;
        }
        var on = this.day(input.on);
        var times = this.times(input.times);
        var fullDay = times.length === 0;
        if (on) {
            input.start = on.start();
            input.end = on.end();
            input.year = [on.year];
            input.month = [on.month];
            input.dayOfMonth = [on.dayOfMonth];
        }
        out.times = times;
        out.duration = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.duration, __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].DURATION_DEFAULT);
        out.durationUnit = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.durationUnit, __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].DURATION_DEFAULT_UNIT(fullDay));
        out.start = this.day(input.start);
        out.end = this.day(input.end);
        out.exclude = this.modifier(input.exclude, true, undefined, out.exclude);
        out.include = this.modifier(input.include, true, undefined, out.include);
        out.cancel = this.modifier(input.cancel, true, undefined, out.cancel);
        out.meta = this.modifier(input.meta, null, parseMeta, out.meta);
        out.year = this.frequency(input.year, 'year');
        out.month = this.frequency(input.month, 'month');
        out.week = this.frequency(input.week, 'week');
        out.weekOfYear = this.frequency(input.weekOfYear, 'weekOfYear');
        out.weekspanOfYear = this.frequency(input.weekspanOfYear, 'weekspanOfYear');
        out.fullWeekOfYear = this.frequency(input.fullWeekOfYear, 'fullWeekOfYear');
        out.lastWeekspanOfYear = this.frequency(input.lastWeekspanOfYear, 'lastWeekspanOfYear');
        out.lastFullWeekOfYear = this.frequency(input.lastFullWeekOfYear, 'lastFullWeekOfYear');
        out.weekOfMonth = this.frequency(input.weekOfMonth, 'weekOfMonth');
        out.weekspanOfMonth = this.frequency(input.weekspanOfMonth, 'weekspanOfMonth');
        out.fullWeekOfMonth = this.frequency(input.fullWeekOfMonth, 'fullWeekOfMonth');
        out.lastWeekspanOfMonth = this.frequency(input.lastWeekspanOfMonth, 'lastWeekspanOfMonth');
        out.lastFullWeekOfMonth = this.frequency(input.lastFullWeekOfMonth, 'lastFullWeekOfMonth');
        out.dayOfWeek = this.frequency(input.dayOfWeek, 'dayOfWeek');
        out.dayOfMonth = this.frequency(input.dayOfMonth, 'dayOfMonth');
        out.lastDayOfMonth = this.frequency(input.lastDayOfMonth, 'lastDayOfMonth');
        out.dayOfYear = this.frequency(input.dayOfYear, 'dayOfYear');
        out.updateDurationInDays();
        out.updateChecks();
        return out;
    };
    /**
     * Parses an array of [[FrequencyCheck]] functions and returns an array of
     * functions for only the checks that were specified by the user.
     *
     * @param checks The array of check functions to filter through.
     * @returns The array of user specified checks.
     */
    Parse.givenFrequency = function (checks) {
        var out = [];
        for (var _i = 0, checks_1 = checks; _i < checks_1.length; _i++) {
            var check = checks_1[_i];
            if (check.given) {
                out.push(check);
            }
        }
        return out;
    };
    /**
     * Parses [[EventInput]] and returns an [[Event]].
     *
     * @param input The input to parse.
     * @param parseData A function to use when parsing data input into the desired type.
     * @param parseMeta A function to use when parsing meta input into the desired type.
     * @returns The parsed value.
     */
    Parse.event = function (input, parseData, parseMeta) {
        if (parseData === void 0) { parseData = (function (x) { return x; }); }
        if (parseMeta === void 0) { parseMeta = (function (x) { return x; }); }
        if (input instanceof __WEBPACK_IMPORTED_MODULE_5__Event__["a" /* Event */]) {
            return input;
        }
        if (!input.schedule) {
            return null;
        }
        var schedule = this.schedule(input.schedule, parseMeta);
        return new __WEBPACK_IMPORTED_MODULE_5__Event__["a" /* Event */](schedule, parseData(input.data), input.id, input.visible);
    };
    /**
     * Parses a schedule from a CRON pattern. TODO
     */
    Parse.cron = function (pattern, out) {
        if (out === void 0) { out = new __WEBPACK_IMPORTED_MODULE_1__Schedule__["a" /* Schedule */](); }
        return out;
    };
    return Parse;
}());

//# sourceMappingURL=Parse.js.map

/***/ }),
/* 153 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./~/underscore/modules/_optimizeCb.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optimizeCb;
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function optimizeCb(func, context, argCount) {
  if (context === void 0) return func;
  switch (argCount == null ? 3 : argCount) {
    case 1: return function(value) {
      return func.call(context, value);
    };
    // The 2-argument case is omitted because we’re not using it.
    case 3: return function(value, index, collection) {
      return func.call(context, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(context, accumulator, value, index, collection);
    };
  }
  return function() {
    return func.apply(context, arguments);
  };
}


/***/ }),
/* 154 */
/* exports provided: hasStringTagBug, isIE11 */
/* exports used: isIE11, hasStringTagBug */
/*!***********************************************!*\
  !*** ./~/underscore/modules/_stringTagBug.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasStringTagBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIE11; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__ = __webpack_require__(/*! ./_hasObjectTag.js */ 1157);



// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
var hasStringTagBug = (
      __WEBPACK_IMPORTED_MODULE_0__setup_js__["m" /* supportsDataView */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new DataView(new ArrayBuffer(8)))
    ),
    isIE11 = (typeof Map !== 'undefined' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasObjectTag_js__["a" /* default */])(new Map));


/***/ }),
/* 155 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/_toPath.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(/*! ./toPath.js */ 677);



// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function toPath(path) {
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath(path);
}


/***/ }),
/* 156 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/allKeys.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(/*! ./isObject.js */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__ = __webpack_require__(/*! ./_collectNonEnumProps.js */ 635);




// Retrieve all the enumerable property names of an object.
function allKeys(obj) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return [];
  var keys = [];
  for (var key in obj) keys.push(key);
  // Ahem, IE < 9.
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["h" /* hasEnumBug */]) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__collectNonEnumProps_js__["a" /* default */])(obj, keys);
  return keys;
}


/***/ }),
/* 157 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/contains.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(/*! ./values.js */ 129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indexOf_js__ = __webpack_require__(/*! ./indexOf.js */ 656);




// Determine if the array or object contains a given item (using `===`).
function contains(obj, item, fromIndex, guard) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
  if (typeof fromIndex != 'number' || guard) fromIndex = 0;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__indexOf_js__["a" /* default */])(obj, item, fromIndex) >= 0;
}


/***/ }),
/* 158 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/filter.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(/*! ./each.js */ 115);



// Return all the elements that pass a truth test.
function filter(obj, predicate, context) {
  var results = [];
  predicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index, list) {
    if (predicate(value, index, list)) results.push(value);
  });
  return results;
}


/***/ }),
/* 159 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./client/components/dashboard/filter/FiltersCommon.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-f46bd904","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./FiltersCommon.vue */ 1562)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./FiltersCommon.vue */ 811),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-f46bd904"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./filtersCommon.pug */ 1470),
  /* scopeId */
  "data-v-f46bd904",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/filter/FiltersCommon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FiltersCommon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f46bd904", Component.options)
  } else {
    hotAPI.reload("data-v-f46bd904", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 160 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./~/vue-tables-2/compiled/bus.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vue = _interopRequireDefault(__webpack_require__(/*! vue */ 31));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var bus = new _vue["default"]();
var _default = bus;
exports["default"] = _default;

/***/ }),
/* 161 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./client/utils/popExitingConfirmation.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popExitingConfirmation = function popExitingConfirmation() {
  var $t = _vue2.default.i18n.translate;
  return window.confirm($t('geral.perguntas.sairPagina'));
};

exports.default = popExitingConfirmation;

/***/ }),
/* 162 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/utils/statusesTranslator.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taskStatusesTranslate = exports.taskBondTypeTranslate = exports.originTranslate = exports.conciliationStatusTranslate = exports.typeTranslate = undefined;

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var originTranslate = function originTranslate(value) {
  var title = '';
  var $t = _vue2.default.i18n.translate;
  switch (value) {
    case 'I':
      title = $t('modalDetalhesLanc.tabItegrations.labels.origemInterno');
      break;
    case 'E':
      title = $t('modalDetalhesLanc.tabItegrations.labels.origemExterno');
      break;
    default:
      title = value;
      break;
  }
  return title;
};

var typeTranslate = function typeTranslate(value) {
  var title = '';
  var $t = _vue2.default.i18n.translate;
  switch (value) {
    case 'C':
      title = $t('categoria.labels.credito');
      break;
    case 'D':
      title = $t('categoria.labels.debito');
      break;
    default:
      title = value;
      break;
  }
  return title;
};

var conciliationStatusTranslate = function conciliationStatusTranslate(value) {
  var title = '';
  var $t = _vue2.default.i18n.translate;
  switch (value) {
    case 'C':
      title = $t('statusConciliacao.conciliado');
      break;
    case 'M':
      title = $t('statusConciliacao.conciliadoManualmente');
      break;
    case 'D':
      title = $t('statusConciliacao.divergente');
      break;
    case 'N':
      title = $t('statusConciliacao.naoAplicavel');
      break;
    case 'A':
      title = $t('statusConciliacao.aberto');
      break;
    default:
      title = value;
      break;
  }
  return title;
};

var taskBondTypeTranslate = function taskBondTypeTranslate(value) {
  var title = '';
  var $t = _vue2.default.i18n.translate;
  switch (value) {
    case 'CL':
      title = $t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoCL');
      break;
    case 'MF':
      title = $t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoMF');
      break;
    default:
      title = value;
      break;
  }
  return title;
};

var taskStatusesTranslate = function taskStatusesTranslate(value) {
  var title = '';
  var $t = _vue2.default.i18n.translate;
  switch (value) {
    case 0:
      title = $t('tarefaEmMassa.tarefaStatuses.pendente');
      break;
    case 10:
      title = $t('tarefaEmMassa.tarefaStatuses.emAndamento');
      break;
    case 20:
      title = $t('tarefaEmMassa.tarefaStatuses.aguardando');
      break;
    case 90:
      title = $t('tarefaEmMassa.tarefaStatuses.concluido');
      break;
    case 99:
      title = $t('tarefaEmMassa.tarefaStatuses.cancelada');
      break;
    default:
      title = value;
      break;
  }
  return title;
};
exports.typeTranslate = typeTranslate;
exports.conciliationStatusTranslate = conciliationStatusTranslate;
exports.originTranslate = originTranslate;
exports.taskBondTypeTranslate = taskBondTypeTranslate;
exports.taskStatusesTranslate = taskStatusesTranslate;

/***/ }),
/* 163 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/utils/transformationData.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateAccountEntryFromNode = exports.generateBankStatFromNode = exports.generateFinMovFromNode = exports.generateBankStatFromRow = exports.generateFinMovFromRow = undefined;

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _index = __webpack_require__(/*! ../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _numberMasker = __webpack_require__(/*! ../utils/numberMasker */ 71);

var _statusesTranslator = __webpack_require__(/*! ../utils/statusesTranslator */ 162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

var getValueByType = function getValueByType(item) {
  var values = {
    debito: 0.00,
    credito: 0.00,
    saldo: '-'
  };
  switch (item.tipo) {
    case 'D':
      values.debito = item.valor;
      break;
    case 'C':
      values.credito = item.valor;
      break;
  }
  return values;
};

var generateFinMovFromRow = function generateFinMovFromRow(row) {
  var data = row;
  var list = [];
  window.Grids.Active.ColNames.forEach(function (groupCol) {
    groupCol.forEach(function (col) {
      if (col !== 'Check' && col !== 'Acao' && col !== 'Panel' && col !== '_ConstWidth' && col !== '' && col !== 'DSComentario') {
        var typeCol = window.Grids.Active.Cols[col].Type;
        var value = null;
        if (typeCol === 'Float') {
          value = data[col] !== null && data[col] !== '' && data[col] !== ' - ' ? (0, _numberMasker.maskThousand)(data[col]) : '0,00';
        } else if (typeCol === 'Date') {
          value = data[col] ? (0, _moment2.default)(data[col]).utc().format('L') : ' - ';
        } else if (typeCol === 'Enum') {
          if (col === 'Tipo') {
            value = data[col] ? (0, _statusesTranslator.typeTranslate)(data[col]) : ' - ';
          } else {
            value = data[col] ? (0, _statusesTranslator.conciliationStatusTranslate)(data[col]) : ' - ';
          }
        } else {
          value = data[col] ? data[col].toString() : ' - ';
        }
        var classCss = '';
        if (col === 'VlOriginal') {
          classCss = row.VlOriginal && row.VlOriginal > 0 ? 'detail-status font-C' : row.VlOriginal && row.VlOriginal < 0 ? 'detail-status font-D' : 'detail-status font-N';
        }
        var obj = {
          title: window.Grids.Active.Header[col],
          value: value,
          order: window.Grids.Active.Cols[col].OrderDetail,
          class: classCss
        };
        list.push(obj);
      }
    });
  });
  list = _underscore2.default.sortBy(list, 'order');
  var $t = _vue2.default.i18n.translate;
  return {
    mainValuesList: list,
    commentary: {
      title: $t('modalDetalhesLanc.details.titulos.comentario'),
      value: row.DSComentario ? row.DSComentario : ' - '
    },
    monetaryValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
      value: row.VlLancamento ? (0, _numberMasker.maskThousand)(row.VlLancamento) : '0,00',
      class: row.VlLancamento && row.VlLancamento > 0 ? 'detail-status font-C' : row.VlLancamento && row.VlLancamento < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
      value: row.VLBRUTO ? (0, _numberMasker.maskThousand)(row.VLBRUTO) : '0,00',
      class: row.VLBRUTO && row.VLBRUTO > 0 ? 'detail-status font-C' : row.VLBRUTO && row.VLBRUTO < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
      value: row.VLLIQUIDO ? (0, _numberMasker.maskThousand)(row.VLLIQUIDO) : '0,00',
      class: row.VLLIQUIDO && row.VLLIQUIDO > 0 ? 'detail-status font-C' : row.VLLIQUIDO && row.VLLIQUIDO < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }],
    statusValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(row.SituacaoConciliacao),
      class: 'detail-status font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
      value: row.DSMotivoOcorrencia,
      class: 'detail-value'
    }],
    integrationValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(row.DtLanc).utc().format('L'),
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(row.SituacaoConciliacao),
      class: 'detail-value font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.lote'),
      value: row.IdConciliacaoLote ? row.IdConciliacaoLote : ' - ',
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
      value: row.VlLancamento ? (0, _numberMasker.maskThousand)(row.VlLancamento) : '0,00',
      class: row.VlLancamento && row.VlLancamento > 0 ? 'detail-value font-C' : row.VlLancamento && row.VlLancamento < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
      value: row.VLBRUTO ? (0, _numberMasker.maskThousand)(row.VLBRUTO) : '0,00',
      class: row.VLBRUTO && row.VLBRUTO > 0 ? 'detail-value font-C' : row.VLBRUTO && row.VLBRUTO < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
      value: row.VLLIQUIDO ? (0, _numberMasker.maskThousand)(row.VLLIQUIDO) : '0,00',
      class: row.VLLIQUIDO && row.VLLIQUIDO > 0 ? 'detail-value font-C' : row.VLLIQUIDO && row.VLLIQUIDO < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }],
    idProcessamento: row.IdProcessamento
  };
};

var generateBankStatFromRow = function generateBankStatFromRow(row) {
  var $t = _vue2.default.i18n.translate;
  return {
    establishtmentValue: {
      title: $t('estabelecimentos.labels.estabelecimento'),
      value: row.Estabelecimento ? row.Estabelecimento : ' - '
    },
    mainValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.idlanc'),
      value: row.IdLancamento.toString()
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(row.DtLanc).utc().format('L')
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtCont'),
      value: (0, _moment2.default)(row.DtContabil).utc().format('L')
    }, {
      title: $t('modalDetalhesLanc.details.titulos.banco'),
      value: row.Banco
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agencia'),
      value: row.Agencia
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nmConta'),
      value: row.NomeConta
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrConta'),
      value: row.NrConta
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
      value: (0, _statusesTranslator.typeTranslate)(row.Tipo)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdHist'),
      value: row.CodHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsHist'),
      value: row.DsHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
      value: row.Documento
    }, {
      title: $t('modalDetalhesLanc.details.titulos.localizador'),
      value: row.Localizador
    }, {
      title: $t('modalDetalhesLanc.details.titulos.complemento'),
      value: row.Complemento
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdCat'),
      value: row.CodCategoria
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsCat'),
      value: row.DsCategoria
    }, {
      title: $t('modalDetalhesLanc.details.titulos.bancoOrig'),
      value: row.BancoOrigem
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agenciaOrig'),
      value: row.DsAgenciaOrigem
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrAgOrig'),
      value: row.NrAgenciaOrigem
    }, {
      title: $t('modalDetalhesLanc.details.titulos.processamento'),
      value: row.IdProcessamento ? row.IdProcessamento : ' - '
    }],
    monetaryValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: row.VlLancDeb ? (0, _numberMasker.maskThousand)(row.VlLancDeb) : '0,00',
      class: row.VlLancDeb && row.VlLancDeb > 0 ? 'detail-status font-C' : row.VlLancDeb && row.VlLancDeb < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlCred'),
      value: row.VlLancCred ? (0, _numberMasker.maskThousand)(row.VlLancCred) : '0,00',
      class: row.VlLancCred && row.VlLancCred > 0 ? 'detail-status font-C' : row.VlLancCred && row.VlLancCred < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
      value: row.VlSaldo ? (0, _numberMasker.maskThousand)(row.VlSaldo) : '0,00',
      class: row.VlSaldo && row.VlSaldo > 0 ? 'detail-status font-C' : row.VlSaldo && row.VlSaldo < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }],
    statusValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(row.SituacaoConciliacao),
      class: 'detail-status font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
      value: row.DSMotivoOcorrencia,
      class: 'detail-value'
    }],
    integrationValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(row.DtLanc).utc().format('L'),
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(row.SituacaoConciliacao),
      class: 'detail-value font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.lote'),
      value: row.IdConciliacaoLote ? row.IdConciliacaoLote : ' - ',
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: row.VlLancDeb ? (0, _numberMasker.maskThousand)(row.VlLancDeb) : '0,00',
      class: row.VlLancDeb && row.VlLancDeb > 0 ? 'detail-value font-C' : row.VlLancDeb && row.VlLancDeb < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlCred'),
      value: row.VlLancCred ? (0, _numberMasker.maskThousand)(row.VlLancCred) : '0,00',
      class: row.VlLancCred && row.VlLancCred > 0 ? 'detail-value font-C' : row.VlLancCred && row.VlLancCred < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
      value: row.VlSaldo ? (0, _numberMasker.maskThousand)(row.VlSaldo) : '0,00',
      class: row.VlSaldo && row.VlSaldo > 0 ? 'detail-value font-C' : row.VlSaldo && row.VlSaldo < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }],
    idProcessamento: row.IdProcessamento,
    classificationValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.idlanc'),
      value: row.IdLancamento.toString()
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(row.DtLanc).utc().format('L')
    }, {
      title: row.VlLancCred ? $t('modalDetalhesLanc.details.titulos.vlCred') : $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: row.VlLancCred ? (0, _numberMasker.maskThousand)(row.VlLancCred) : (0, _numberMasker.maskThousand)(row.VlLancDeb)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdHist'),
      value: row.CodHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsHist'),
      value: row.DsHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.complemento'),
      value: row.Complemento
    }, {
      title: $t('modalDetalhesLanc.details.titulos.banco'),
      value: row.Banco
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agencia'),
      value: row.Agencia
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrConta'),
      value: row.NrConta
    }, {
      title: $t('modalDetalhesLanc.tabClassif.critClassif'),
      value: row.CritClassif
    }]
  };
};

var generateFinMovFromNode = function generateFinMovFromNode(item) {
  var $t = _vue2.default.i18n.translate;
  var obj = {
    idMovimentoFinanceiro: item.id,
    concSituation: item.situacaoConciliacao,
    mainValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.idMovimento'),
      value: item.id
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(item.dataLancamento).utc().format('L')
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtCont'),
      value: (0, _moment2.default)(item.dataContabil).utc().format('L')
    }, {
      title: $t('estabelecimentos.labels.estabelecimento'),
      value: item.nomeFantasiaEstabelecimento ? item.nomeFantasiaEstabelecimento : ' - '
    }, {
      title: $t('estabelecimentos.labels.grupoEstabelecimento'),
      value: item.nomeGrupoEstabelecimento ? item.nomeGrupoEstabelecimento : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
      value: item.documento ? item.documento : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsCat'),
      value: item.nomeCategoria ? item.nomeCategoria : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.planoConciliacao'),
      value: item.nomePlanoConciliacao ? item.nomePlanoConciliacao : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
      value: item.valorLancamento ? (0, _numberMasker.maskThousand)(item.valorLancamento) : '0,00'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorOrigem'),
      value: item.valorOriginal ? (0, _numberMasker.maskThousand)(item.valorOriginal) : '0,00',
      class: item.valorOriginal && item.valorOriginal > 0 ? 'detail-status font-C' : item.valorOriginal && item.valorOriginal < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
      value: item.descricaoMotivoOcorrencia ? item.descricaoMotivoOcorrencia : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.processamento'),
      value: item.idProcessamento ? item.idProcessamento : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nomeTarefa'),
      value: item.nomeUltimaTarefa ? item.nomeUltimaTarefa : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(item.situacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.situacaoTarefa'),
      value: item.situacaoUltimaTarefa ? (0, _statusesTranslator.taskStatusesTranslate)(item.situacaoUltimaTarefa) : ' - '
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
      value: (0, _statusesTranslator.typeTranslate)(item.tipoLancamento)
    }],
    monetaryValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
      value: item.valorLancamento ? (0, _numberMasker.maskThousand)(item.valorLancamento) : '0,00',
      class: item.valorLancamento && item.valorLancamento > 0 ? 'detail-status font-C' : item.valorLancamento && item.valorLancamento < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }],
    statusValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(item.situacaoConciliacao),
      class: 'detail-status font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
      value: item.descricaoMotivoOcorrencia ? item.descricaoMotivoOcorrencia : '-',
      class: 'detail-value'
    }],
    integrationValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(item.dataLancamento).utc().format('L'),
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(item.situacaoConciliacao),
      class: 'detail-value font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.lote'),
      value: item.idLote ? item.idLote : ' - ',
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
      value: item.valorLancamento ? (0, _numberMasker.maskThousand)(item.valorLancamento) : '0,00',
      class: item.valorLancamento && item.valorLancamento > 0 ? 'detail-value font-C' : item.valorLancamento && item.valorLancamento < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }],
    commentary: {
      title: $t('modalDetalhesLanc.details.titulos.comentario'),
      value: item.comentario ? item.comentario : ' - '
    },
    idProcessamento: item.idProcessamento
  };
  if (item && item.atributosValores && item.atributosValores.length > 0) {
    item.atributosValores.forEach(function (att) {
      switch (att.nome) {
        case 'IDEMPRESA':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.idEmpresa'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'CDBANCO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.banco'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'DSCONTABANCARIA':
          obj.mainValuesList.push({
            title: $t('contaBancaria.titulos.contaBancaria'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'FLIDENTIFICADO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.identificado'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'NMADQUIRENTE':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.adquirente'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'NMBANDEIRA':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.bandeira'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'NMTIPOPRODUTO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.tipoProduto'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'SGORIGEM':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.origem'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'NRLANCAMENTO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.lancCaixa'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'NRTICKET':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.nrTicket'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          });
          break;
        case 'VLBRUTO':
          obj.monetaryValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
            value: att.valorOriginal ? (0, _numberMasker.maskThousand)(att.valorOriginal.replace(',', '.')) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0 ? 'detail-status font-C' : att.valorOriginal && att.valorOriginal < 0 ? 'detail-status font-D' : 'detail-status font-N'
          });
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorBruto'),
            value: att.valorOriginal ? (0, _numberMasker.maskThousand)(att.valorOriginal.replace(',', '.')) : '0,00'
          });
          obj.integrationValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
            value: att.valorOriginal ? (0, _numberMasker.maskThousand)(parseFloat(att.valorOriginal)) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0 ? 'detail-value font-C' : att.valorOriginal && att.valorOriginal < 0 ? 'detail-value font-D' : 'detail-value font-N'
          });
          break;
        case 'VLCOMISSAO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorComissao'),
            value: att.valorOriginal ? (0, _numberMasker.maskThousand)(att.valorOriginal.replace(',', '.')) : '0,00'
          });
          break;
        case 'VLLIQUIDO':
          obj.monetaryValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
            value: att.valorOriginal ? (0, _numberMasker.maskThousand)(parseFloat(att.valorOriginal)) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0 ? 'detail-status font-C' : att.valorOriginal && att.valorOriginal < 0 ? 'detail-status font-D' : 'detail-status font-N'
          });
          obj.integrationValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
            value: att.valorOriginal ? (0, _numberMasker.maskThousand)(parseFloat(att.valorOriginal)) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0 ? 'detail-value font-C' : att.valorOriginal && att.valorOriginal < 0 ? 'detail-value font-D' : 'detail-value font-N'
          });
          break;
      }
    });
  } else {
    obj.monetaryValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
      value: '-',
      class: 'detail-status'
    });
    obj.integrationValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
      value: '-',
      class: 'detail-value'
    });
    obj.monetaryValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
      value: '-',
      class: 'detail-status'
    });
    obj.integrationValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
      value: '-',
      class: 'detail-value'
    });
  }

  if (item && item.atributosValoresEstabelecimento && item.atributosValoresEstabelecimento.length > 0) {
    item.atributosValoresEstabelecimento.forEach(function (att) {
      obj.mainValuesList.push({
        title: att.descricao,
        value: att.valorOriginal ? att.valorOriginal : ' - '
      });
    });
  }

  return obj;
};

var generateBankStatFromNode = function generateBankStatFromNode(item) {
  var $t = _vue2.default.i18n.translate;
  var monetary = {
    tipo: item.tipo,
    valor: item.valor
  };
  var itemValues = getValueByType(monetary);
  var labelCritClassif = null;
  if (item.criterioClassificacao) {
    if (item.ordemCriterio) {
      labelCritClassif = item.ordemCriterio + ' - ';
    }
    labelCritClassif += item.criterioClassificacao;
  }

  return {
    idMovimentoBancario: item.id,
    establishtmentValue: {
      title: $t('estabelecimentos.labels.estabelecimento'),
      value: item.nomeFantasiaEstabelecimento ? item.nomeFantasiaEstabelecimento : ' - '
    },
    mainValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.idMovimento'),
      value: item.id
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(item.dataLancamento).utc().format('L')
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtCont'),
      value: (0, _moment2.default)(item.dataContabil).utc().format('L')
    }, {
      title: $t('modalDetalhesLanc.details.titulos.banco'),
      value: item.codigoBanco + '-' + item.nomeFantasiaBanco
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agencia'),
      value: item.numeroAgencia ? item.numeroAgencia : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nmConta'),
      value: item.nomeConta ? item.nomeConta : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrConta'),
      value: item.numeroConta ? item.numeroConta : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
      value: (0, _statusesTranslator.typeTranslate)(item.tipo)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdHist'),
      value: item.codigoHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsHist'),
      value: item.descricaoHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
      value: item.numeroDocumento ? item.numeroDocumento : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.localizador'),
      value: item.localizador ? item.localizador : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.complemento'),
      value: item.complemento ? item.complemento : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdCat'),
      value: item.codigoContaLancamentoCategoria ? item.codigoContaLancamentoCategoria : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsCat'),
      value: item.descricaoContaLancamentoCategoria ? item.descricaoContaLancamentoCategoria : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.bancoOrig'),
      value: item.codigoBancoOrigem && item.nomeFantasiaBancoOrigem ? item.codigoBancoOrigem + '-' + item.nomeFantasiaBancoOrigem : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agenciaOrig'),
      value: item.nomeAgenciaOrigem ? item.nomeAgenciaOrigem : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrAgOrig'),
      value: item.numeroAgenciaOrigem ? item.numeroAgenciaOrigem : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.processamento'),
      value: item.idProcessamento ? item.idProcessamento : ' - '
    }],
    commentary: {
      title: $t('modalDetalhesLanc.details.titulos.comentario'),
      value: item.comentario ? item.comentario : ' - '
    },
    monetaryValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: itemValues.debito ? (0, _numberMasker.maskThousand)(itemValues.debito) : '0,00',
      class: itemValues.debito && itemValues.debito > 0 ? 'detail-status font-C' : itemValues.debito && itemValues.debito < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlCred'),
      value: itemValues.credito ? (0, _numberMasker.maskThousand)(itemValues.credito) : '0,00',
      class: itemValues.credito && itemValues.credito > 0 ? 'detail-status font-C' : itemValues.credito && itemValues.credito < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
      value: itemValues.saldo ? itemValues.saldo : '0,00',
      class: itemValues.saldo && itemValues.saldo > 0 ? 'detail-status font-C' : itemValues.saldo && itemValues.saldo < 0 ? 'detail-status font-D' : 'detail-status'
    }],
    statusValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(item.situacaoConciliacao),
      class: 'detail-status font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
      value: item.descricaoMotivoOcorrencia ? item.descricaoMotivoOcorrencia : '-',
      class: 'detail-value'
    }],
    integrationValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(item.dataLancamento).utc().format('L'),
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
      value: (0, _statusesTranslator.conciliationStatusTranslate)(item.situacaoConciliacao),
      class: 'detail-value font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.lote'),
      value: item.idLote ? item.idLote : '-',
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: itemValues.debito ? (0, _numberMasker.maskThousand)(itemValues.debito) : '0,00',
      class: itemValues.debito && itemValues.debito > 0 ? 'detail-value font-C' : itemValues.debito && itemValues.debito < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlCred'),
      value: itemValues.credito ? (0, _numberMasker.maskThousand)(itemValues.credito) : '0,00',
      class: itemValues.credito && itemValues.credito > 0 ? 'detail-value font-C' : itemValues.credito && itemValues.credito < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
      value: itemValues.saldo ? itemValues.saldo : '0,00',
      class: itemValues.saldo && itemValues.saldo > 0 ? 'detail-value font-C' : itemValues.saldo && itemValues.saldo < 0 ? 'detail-value font-D' : 'detail-value'
    }],
    idProcessamento: item.idProcessamento,
    classificationValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.idlanc'),
      value: item.idContaLancamento
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(item.dataLancamento).utc().format('L')
    }, {
      title: itemValues.credito ? $t('modalDetalhesLanc.details.titulos.vlCred') : $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: itemValues.credito ? (0, _numberMasker.maskThousand)(itemValues.credito) : (0, _numberMasker.maskThousand)(itemValues.debito)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdHist'),
      value: item.codigoHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsHist'),
      value: item.descricaoHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.complemento'),
      value: item.complemento
    }, {
      title: $t('modalDetalhesLanc.details.titulos.banco'),
      value: item.codigoBanco + '-' + item.nomeFantasiaBanco
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agencia'),
      value: item.numeroAgencia ? item.numeroAgencia : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrConta'),
      value: item.numeroConta ? item.numeroConta : '-'
    }, {
      title: $t('modalDetalhesLanc.tabClassif.critClassif'),
      value: labelCritClassif
    }]
  };
};

var generateAccountEntryFromNode = function generateAccountEntryFromNode(item) {
  var $t = _vue2.default.i18n.translate;
  var itemValues = getValueByType(item);
  return {
    establishtmentValue: {
      title: $t('estabelecimentos.labels.estabelecimento'),
      value: item.estabelecimento ? item.estabelecimento.nome : ' - '
    },
    mainValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.idlanc'),
      value: item.id
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(item.dataLancamento).utc().format('L')
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dtCont'),
      value: (0, _moment2.default)(item.dataContabil).utc().format('L')
    }, {
      title: $t('modalDetalhesLanc.details.titulos.banco'),
      value: item.codigoBanco && item.nomeFantasiaBanco ? item.codigoBanco + '-' + item.nomeFantasiaBanco : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agencia'),
      value: item.numeroAgencia ? item.numeroAgencia : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nmConta'),
      value: item.nomeConta ? item.nomeConta : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrConta'),
      value: item.numeroConta ? item.numeroConta : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
      value: (0, _statusesTranslator.typeTranslate)(item.tipo)
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdHist'),
      value: item.codigoHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsHist'),
      value: item.descricaoHistorico
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
      value: item.numeroDocumento ? item.numeroDocumento : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.complemento'),
      value: item.complemento ? item.complemento : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.cdCat'),
      value: item.codigoContaLancamentoCategoria ? item.codigoContaLancamentoCategoria : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.dsCat'),
      value: item.descricaoContaLancamentoCategoria ? item.descricaoContaLancamentoCategoria : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.bancoOrig'),
      value: item.codigoBancoOrigem ? item.codigoBancoOrigem + '-' + item.nomeFantasiaBancoOrigem : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.agenciaOrig'),
      value: item.nomeAgenciaOrigem ? item.nomeAgenciaOrigem : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.nrAgOrig'),
      value: item.numeroAgenciaOrigem ? item.numeroAgenciaOrigem : '-'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.processamento'),
      value: item.idProcessamento ? item.idProcessamento : ' - '
    }],
    monetaryValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: itemValues.debito ? (0, _numberMasker.maskThousand)(itemValues.debito) : '0,00',
      class: itemValues.debito && itemValues.debito > 0 ? 'detail-status font-C' : itemValues.debito && itemValues.debito < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlCred'),
      value: itemValues.credito ? (0, _numberMasker.maskThousand)(itemValues.credito) : '0,00',
      class: itemValues.credito && itemValues.credito > 0 ? 'detail-status font-C' : itemValues.credito && itemValues.credito < 0 ? 'detail-status font-D' : 'detail-status font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
      value: itemValues.saldo ? itemValues.saldo : '0,00',
      class: itemValues.saldo && itemValues.saldo > 0 ? 'detail-status font-C' : itemValues.saldo && itemValues.saldo < 0 ? 'detail-status font-D' : 'detail-status'
    }],
    integrationValuesList: [{
      title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
      value: (0, _moment2.default)(item.dataLancamento).utc().format('L'),
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.lote'),
      value: item.lote ? item.lote.id : '-',
      class: 'detail-value'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
      value: itemValues.debito ? (0, _numberMasker.maskThousand)(itemValues.debito) : '0,00',
      class: itemValues.debito && itemValues.debito > 0 ? 'detail-value font-C' : itemValues.debito && itemValues.debito < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlCred'),
      value: itemValues.credito ? (0, _numberMasker.maskThousand)(itemValues.credito) : '0,00',
      class: itemValues.credito && itemValues.credito > 0 ? 'detail-value font-C' : itemValues.credito && itemValues.credito < 0 ? 'detail-value font-D' : 'detail-value font-N'
    }, {
      title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
      value: itemValues.saldo ? itemValues.saldo : '0,00',
      class: itemValues.saldo && itemValues.saldo > 0 ? 'detail-value font-C' : itemValues.saldo && itemValues.saldo < 0 ? 'detail-value font-D' : 'detail-value'
    }],
    idProcessamento: item.idProcessamento
  };
};

exports.generateFinMovFromRow = generateFinMovFromRow;
exports.generateBankStatFromRow = generateBankStatFromRow;
exports.generateFinMovFromNode = generateFinMovFromNode;
exports.generateBankStatFromNode = generateBankStatFromNode;
exports.generateAccountEntryFromNode = generateAccountEntryFromNode;

/***/ }),
/* 164 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/babel-runtime/core-js/array/from.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/array/from */ 960), __esModule: true };

/***/ }),
/* 165 */
/* exports provided: props, BCardImg */
/* exports used: BCardImg, props */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-img.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardImg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__image_img__ = __webpack_require__(/*! ../image/img */ 119);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["k" /* pick */])(__WEBPACK_IMPORTED_MODULE_5__image_img__["b" /* props */], ['src', 'alt', 'width', 'height', 'left', 'right'])), {}, {
  bottom: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  end: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  start: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  top: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_55" /* NAME_CARD_IMG */]); // --- Main component ---
// @vue/component

var BCardImg = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_55" /* NAME_CARD_IMG */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    var src = props.src,
        alt = props.alt,
        width = props.width,
        height = props.height;
    var baseClass = 'card-img';

    if (props.top) {
      baseClass += '-top';
    } else if (props.right || props.end) {
      baseClass += '-right';
    } else if (props.bottom) {
      baseClass += '-bottom';
    } else if (props.left || props.start) {
      baseClass += '-left';
    }

    return h('img', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: baseClass,
      attrs: {
        src: src,
        alt: alt,
        width: width,
        height: height
      }
    }));
  }
});

/***/ }),
/* 166 */
/* exports provided: DropdownPlugin, BDropdown, BDropdownItem, BDropdownItemButton, BDropdownHeader, BDropdownDivider, BDropdownForm, BDropdownText, BDropdownGroup */
/* exports used: DropdownPlugin */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/index.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropdown__ = __webpack_require__(/*! ./dropdown */ 216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_item__ = __webpack_require__(/*! ./dropdown-item */ 354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__ = __webpack_require__(/*! ./dropdown-item-button */ 353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropdown_header__ = __webpack_require__(/*! ./dropdown-header */ 352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__ = __webpack_require__(/*! ./dropdown-divider */ 349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dropdown_form__ = __webpack_require__(/*! ./dropdown-form */ 350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dropdown_text__ = __webpack_require__(/*! ./dropdown-text */ 355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropdown_group__ = __webpack_require__(/*! ./dropdown-group */ 351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BDropdown */
/* unused harmony reexport BDropdownItem */
/* unused harmony reexport BDropdownItemButton */
/* unused harmony reexport BDropdownHeader */
/* unused harmony reexport BDropdownDivider */
/* unused harmony reexport BDropdownForm */
/* unused harmony reexport BDropdownText */
/* unused harmony reexport BDropdownGroup */









var DropdownPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BDropdown: __WEBPACK_IMPORTED_MODULE_0__dropdown__["a" /* BDropdown */],
    BDd: __WEBPACK_IMPORTED_MODULE_0__dropdown__["a" /* BDropdown */],
    BDropdownItem: __WEBPACK_IMPORTED_MODULE_1__dropdown_item__["a" /* BDropdownItem */],
    BDdItem: __WEBPACK_IMPORTED_MODULE_1__dropdown_item__["a" /* BDropdownItem */],
    BDropdownItemButton: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* BDropdownItemButton */],
    BDropdownItemBtn: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* BDropdownItemButton */],
    BDdItemButton: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* BDropdownItemButton */],
    BDdItemBtn: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* BDropdownItemButton */],
    BDropdownHeader: __WEBPACK_IMPORTED_MODULE_3__dropdown_header__["a" /* BDropdownHeader */],
    BDdHeader: __WEBPACK_IMPORTED_MODULE_3__dropdown_header__["a" /* BDropdownHeader */],
    BDropdownDivider: __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__["a" /* BDropdownDivider */],
    BDdDivider: __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__["a" /* BDropdownDivider */],
    BDropdownForm: __WEBPACK_IMPORTED_MODULE_5__dropdown_form__["a" /* BDropdownForm */],
    BDdForm: __WEBPACK_IMPORTED_MODULE_5__dropdown_form__["a" /* BDropdownForm */],
    BDropdownText: __WEBPACK_IMPORTED_MODULE_6__dropdown_text__["a" /* BDropdownText */],
    BDdText: __WEBPACK_IMPORTED_MODULE_6__dropdown_text__["a" /* BDropdownText */],
    BDropdownGroup: __WEBPACK_IMPORTED_MODULE_7__dropdown_group__["a" /* BDropdownGroup */],
    BDdGroup: __WEBPACK_IMPORTED_MODULE_7__dropdown_group__["a" /* BDropdownGroup */]
  }
});


/***/ }),
/* 167 */
/* exports provided: props, BFormSelectOption */
/* exports used: BFormSelectOption */
/*!**************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-select/form-select-option.js ***!
  \**************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormSelectOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["f" /* PROP_TYPE_ANY */], undefined, true) // Required

}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_21" /* NAME_FORM_SELECT_OPTION */]); // --- Main component ---
// @vue/component

var BFormSelectOption = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_21" /* NAME_FORM_SELECT_OPTION */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var value = props.value,
        disabled = props.disabled;
    return h('option', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      attrs: {
        disabled: disabled
      },
      domProps: {
        value: value
      }
    }), children);
  }
});

/***/ }),
/* 168 */
/* exports provided: props, BFormInvalidFeedback */
/* exports used: BFormInvalidFeedback */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form/form-invalid-feedback.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormInvalidFeedback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  ariaLive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  forceShow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Tri-state prop: `true`, `false`, or `null`
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  tooltip: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_37" /* NAME_FORM_INVALID_FEEDBACK */]); // --- Main component ---
// @vue/component

var BFormInvalidFeedback = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_37" /* NAME_FORM_INVALID_FEEDBACK */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var tooltip = props.tooltip,
        ariaLive = props.ariaLive;
    var show = props.forceShow === true || props.state === false;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: {
        'd-block': show,
        'invalid-feedback': !tooltip,
        'invalid-tooltip': tooltip
      },
      attrs: {
        id: props.id || null,
        role: props.role || null,
        'aria-live': ariaLive || null,
        'aria-atomic': ariaLive ? 'true' : null
      }
    }), children);
  }
});

/***/ }),
/* 169 */
/* exports provided: props, BFormText */
/* exports used: BFormText */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form/form-text.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  inline: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'small'),
  textVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'muted')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_38" /* NAME_FORM_TEXT */]); // --- Main component ---
// @vue/component

var BFormText = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_38" /* NAME_FORM_TEXT */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: _defineProperty({
        'form-text': !props.inline
      }, "text-".concat(props.textVariant), props.textVariant),
      attrs: {
        id: props.id
      }
    }), children);
  }
});

/***/ }),
/* 170 */
/* exports provided: props, BForm */
/* exports used: BForm, props */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form/form.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  inline: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  novalidate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  validated: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["X" /* NAME_FORM */]); // --- Main component ---
// @vue/component

var BForm = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["X" /* NAME_FORM */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h('form', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: {
        'form-inline': props.inline,
        'was-validated': props.validated
      },
      attrs: {
        id: props.id,
        novalidate: props.novalidate
      }
    }), children);
  }
});

/***/ }),
/* 171 */
/* exports provided: props, BInputGroupAddon */
/* exports used: BInputGroupAddon, props */
/*!*************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/input-group/input-group-addon.js ***!
  \*************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BInputGroupAddon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input_group_text__ = __webpack_require__(/*! ./input-group-text */ 172);




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  append: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  isText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_12" /* NAME_INPUT_GROUP_ADDON */]); // --- Main component ---
// @vue/component

var BInputGroupAddon = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_12" /* NAME_INPUT_GROUP_ADDON */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var append = props.append;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: {
        'input-group-append': append,
        'input-group-prepend': !append
      },
      attrs: {
        id: props.id
      }
    }), props.isText ? [h(__WEBPACK_IMPORTED_MODULE_4__input_group_text__["a" /* BInputGroupText */], children)] : children);
  }
});

/***/ }),
/* 172 */
/* exports provided: props, BInputGroupText */
/* exports used: BInputGroupText */
/*!************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/input-group/input-group-text.js ***!
  \************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BInputGroupText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_10" /* NAME_INPUT_GROUP_TEXT */]); // --- Main component ---
// @vue/component

var BInputGroupText = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_10" /* NAME_INPUT_GROUP_TEXT */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'input-group-text'
    }), children);
  }
});

/***/ }),
/* 173 */
/* exports provided: props, BFormRow */
/* exports used: BFormRow */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/layout/form-row.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_5" /* NAME_FORM_ROW */]); // --- Main component ---
// @vue/component

var BFormRow = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_5" /* NAME_FORM_ROW */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'form-row'
    }), children);
  }
});

/***/ }),
/* 174 */
/* exports provided: props, BNav */
/* exports used: BNav, props */
/*!***************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/nav/nav.js ***!
  \***************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // --- Helper methods ---

var computeJustifyContent = function computeJustifyContent(value) {
  value = value === 'left' ? 'start' : value === 'right' ? 'end' : value;
  return "justify-content-".concat(value);
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  align: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Set to `true` if placing in a card header
  cardHeader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  fill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  justified: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  pills: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  small: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tabs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'ul'),
  vertical: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["s" /* NAME_NAV */]); // --- Main component ---
// @vue/component

var BNav = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["s" /* NAME_NAV */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var tabs = props.tabs,
        pills = props.pills,
        vertical = props.vertical,
        align = props.align,
        cardHeader = props.cardHeader;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'nav',
      class: (_class = {
        'nav-tabs': tabs,
        'nav-pills': pills && !tabs,
        'card-header-tabs': !vertical && cardHeader && tabs,
        'card-header-pills': !vertical && cardHeader && pills && !tabs,
        'flex-column': vertical,
        'nav-fill': !vertical && props.fill,
        'nav-justified': !vertical && props.justified
      }, _defineProperty(_class, computeJustifyContent(align), !vertical && align), _defineProperty(_class, "small", props.small), _class)
    }), children);
  }
});

/***/ }),
/* 175 */
/* exports provided: props, BSkeleton */
/* exports used: BSkeleton */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/skeleton/skeleton.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSkeleton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  animation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'wave'),
  height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'text'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["H" /* NAME_SKELETON */]); // --- Main component ---
// @vue/component

var BSkeleton = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["H" /* NAME_SKELETON */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var data = _ref.data,
        props = _ref.props;
    var size = props.size,
        animation = props.animation,
        variant = props.variant;
    return h('div', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'b-skeleton',
      style: {
        width: size || props.width,
        height: size || props.height
      },
      class: (_class = {}, _defineProperty(_class, "b-skeleton-".concat(props.type), true), _defineProperty(_class, "b-skeleton-animate-".concat(animation), animation), _defineProperty(_class, "bg-".concat(variant), variant), _class)
    }));
  }
});

/***/ }),
/* 176 */
/* exports provided: FIELD_KEY_CELL_VARIANT, FIELD_KEY_ROW_VARIANT, FIELD_KEY_SHOW_DETAILS, IGNORED_FIELD_KEYS, EVENT_FILTER */
/* exports used: EVENT_FILTER, FIELD_KEY_SHOW_DETAILS, FIELD_KEY_CELL_VARIANT, FIELD_KEY_ROW_VARIANT, IGNORED_FIELD_KEYS */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/constants.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIELD_KEY_CELL_VARIANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIELD_KEY_ROW_VARIANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FIELD_KEY_SHOW_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IGNORED_FIELD_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENT_FILTER; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Constants used by table helpers
var FIELD_KEY_CELL_VARIANT = '_cellVariants';
var FIELD_KEY_ROW_VARIANT = '_rowVariant';
var FIELD_KEY_SHOW_DETAILS = '_showDetails'; // Object of item keys that should be ignored for headers and
// stringification and filter events

var IGNORED_FIELD_KEYS = [FIELD_KEY_CELL_VARIANT, FIELD_KEY_ROW_VARIANT, FIELD_KEY_SHOW_DETAILS].reduce(function (result, key) {
  return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, true));
}, {}); // Filter CSS selector for click/dblclick/etc. events
// If any of these selectors match the clicked element, we ignore the event

var EVENT_FILTER = ['a', 'a *', // Include content inside links
'button', 'button *', // Include content inside buttons
'input:not(.disabled):not([disabled])', 'select:not(.disabled):not([disabled])', 'textarea:not(.disabled):not([disabled])', '[role="link"]', '[role="link"] *', '[role="button"]', '[role="button"] *', '[tabindex]:not(.disabled):not([disabled])'].join(',');

/***/ }),
/* 177 */
/* exports provided: props, BTfoot */
/* exports used: BTfoot */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/tfoot.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTfoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  // Supported values: 'lite', 'dark', or null
  footVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["w" /* NAME_TFOOT */]); // --- Main component ---
// TODO:
//   In Bootstrap v5, we won't need "sniffing" as table element variants properly inherit
//   to the child elements, so this can be converted to a functional component
// @vue/component

var BTfoot = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["w" /* NAME_TFOOT */],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvTableRowGroup: function getBvTableRowGroup() {
        return _this;
      }
    };
  },
  inject: {
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    getBvTable: {
      default:
      /* istanbul ignore next */
      function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  inheritAttrs: false,
  props: props,
  computed: {
    bvTable: function bvTable() {
      return this.getBvTable();
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isTfoot: function isTfoot() {
      return true;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isDark: function isDark() {
      return this.bvTable.dark;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isStacked: function isStacked() {
      return this.bvTable.isStacked;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isResponsive: function isResponsive() {
      return this.bvTable.isResponsive;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    // Sticky headers are only supported in thead
    isStickyHeader: function isStickyHeader() {
      return false;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    // Needed to handle header background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    hasStickyHeader: function hasStickyHeader() {
      return !this.isStacked && this.bvTable.stickyHeader;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    tableVariant: function tableVariant() {
      return this.bvTable.tableVariant;
    },
    tfootClasses: function tfootClasses() {
      return [this.footVariant ? "thead-".concat(this.footVariant) : null];
    },
    tfootAttrs: function tfootAttrs() {
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        role: 'rowgroup'
      });
    }
  },
  render: function render(h) {
    return h('tfoot', {
      class: this.tfootClasses,
      attrs: this.tfootAttrs,
      // Pass down any native listeners
      on: this.bvListeners
    }, this.normalizeSlot());
  }
});

/***/ }),
/* 178 */
/* exports provided: props, BTh */
/* exports used: BTh */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/th.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTh; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__td__ = __webpack_require__(/*! ./td */ 120);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["b" /* makePropsConfigurable */])(__WEBPACK_IMPORTED_MODULE_3__td__["b" /* props */], __WEBPACK_IMPORTED_MODULE_1__constants_components__["u" /* NAME_TH */]); // --- Main component ---
// TODO:
//   In Bootstrap v5, we won't need "sniffing" as table element variants properly inherit
//   to the child elements, so this can be converted to a functional component
// @vue/component

var BTh = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["u" /* NAME_TH */],
  extends: __WEBPACK_IMPORTED_MODULE_3__td__["a" /* BTd */],
  props: props,
  computed: {
    tag: function tag() {
      return 'th';
    }
  }
});

/***/ }),
/* 179 */
/* exports provided: VBTogglePlugin, VBToggle */
/* exports used: VBTogglePlugin */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/toggle/index.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBTogglePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toggle__ = __webpack_require__(/*! ./toggle */ 247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport VBToggle */


var VBTogglePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  directives: {
    VBToggle: __WEBPACK_IMPORTED_MODULE_0__toggle__["a" /* VBToggle */]
  }
});


/***/ }),
/* 180 */
/* exports provided: VBVisible */
/* exports used: VBVisible */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/visible/visible.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBVisible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue__ = __webpack_require__(/*! ../../vue */ 0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// v-b-visible
// Private visibility check directive
// Based on IntersectionObserver
//
// Usage:
//  v-b-visibility.<margin>.<once>="<callback>"
//
//  Value:
//  <callback>: method to be called when visibility state changes, receives one arg:
//     true:  element is visible
//     false: element is not visible
//     null:  IntersectionObserver not supported
//
//  Modifiers:
//    <margin>: a positive decimal value of pixels away from viewport edge
//              before being considered "visible". default is 0
//    <once>:   keyword 'once', meaning when the element becomes visible and
//              callback is called observation/notification will stop.
//
// When used in a render function:
// export default {
//   directives: { 'b-visible': VBVisible },
//   render(h) {
//     h(
//       'div',
//       {
//         directives: [
//           { name: 'b-visible', value=this.callback, modifiers: { '123':true, 'once':true } }
//         ]
//       }
//     )
//   }






var OBSERVER_PROP_NAME = '__bv__visibility_observer';

var VisibilityObserver = /*#__PURE__*/function () {
  function VisibilityObserver(el, options) {
    _classCallCheck(this, VisibilityObserver);

    this.el = el;
    this.callback = options.callback;
    this.margin = options.margin || 0;
    this.once = options.once || false;
    this.observer = null;
    this.visible = undefined;
    this.doneOnce = false; // Create the observer instance (if possible)

    this.createObserver();
  }

  _createClass(VisibilityObserver, [{
    key: "createObserver",
    value: function createObserver() {
      var _this = this;

      // Remove any previous observer
      if (this.observer) {
        /* istanbul ignore next */
        this.stop();
      } // Should only be called once and `callback` prop should be a function


      if (this.doneOnce || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(this.callback)) {
        /* istanbul ignore next */
        return;
      } // Create the observer instance


      try {
        // Future: Possibly add in other modifiers for left/right/top/bottom
        // offsets, root element reference, and thresholds
        this.observer = new IntersectionObserver(this.handler.bind(this), {
          // `null` = 'viewport'
          root: null,
          // Pixels away from view port to consider "visible"
          rootMargin: this.margin,
          // Intersection ratio of el and root (as a value from 0 to 1)
          threshold: 0
        });
      } catch (_unused) {
        // No IntersectionObserver support, so just stop trying to observe
        this.doneOnce = true;
        this.observer = undefined;
        this.callback(null);
        return;
      } // Start observing in a `$nextTick()` (to allow DOM to complete rendering)

      /* istanbul ignore next: IntersectionObserver not supported in JSDOM */


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__vue__["a" /* nextTick */])(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* requestAF */])(function () {
          // Placed in an `if` just in case we were destroyed before
          // this `requestAnimationFrame` runs
          if (_this.observer) {
            _this.observer.observe(_this.el);
          }
        });
      });
    }
    /* istanbul ignore next */

  }, {
    key: "handler",
    value: function handler(entries) {
      var entry = entries ? entries[0] : {};
      var isIntersecting = Boolean(entry.isIntersecting || entry.intersectionRatio > 0.0);

      if (isIntersecting !== this.visible) {
        this.visible = isIntersecting;
        this.callback(isIntersecting);

        if (this.once && this.visible) {
          this.doneOnce = true;
          this.stop();
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      /* istanbul ignore next */
      this.observer && this.observer.disconnect();
      this.observer = null;
    }
  }]);

  return VisibilityObserver;
}();

var destroy = function destroy(el) {
  var observer = el[OBSERVER_PROP_NAME];

  if (observer && observer.stop) {
    observer.stop();
  }

  delete el[OBSERVER_PROP_NAME];
};

var bind = function bind(el, _ref) {
  var value = _ref.value,
      modifiers = _ref.modifiers;
  // `value` is the callback function
  var options = {
    margin: '0px',
    once: false,
    callback: value
  }; // Parse modifiers

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["a" /* keys */])(modifiers).forEach(function (mod) {
    /* istanbul ignore else: Until <b-img-lazy> is switched to use this directive */
    if (__WEBPACK_IMPORTED_MODULE_0__constants_regex__["a" /* RX_DIGITS */].test(mod)) {
      options.margin = "".concat(mod, "px");
    } else if (mod.toLowerCase() === 'once') {
      options.once = true;
    }
  }); // Destroy any previous observer

  destroy(el); // Create new observer

  el[OBSERVER_PROP_NAME] = new VisibilityObserver(el, options); // Store the current modifiers on the object (cloned)

  el[OBSERVER_PROP_NAME]._prevModifiers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["b" /* clone */])(modifiers);
}; // When the directive options may have been updated (or element)


var componentUpdated = function componentUpdated(el, _ref2, vnode) {
  var value = _ref2.value,
      oldValue = _ref2.oldValue,
      modifiers = _ref2.modifiers;
  // Compare value/oldValue and modifiers to see if anything has changed
  // and if so, destroy old observer and create new observer

  /* istanbul ignore next */
  modifiers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["b" /* clone */])(modifiers);
  /* istanbul ignore next */

  if (el && (value !== oldValue || !el[OBSERVER_PROP_NAME] || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_loose_equal__["a" /* looseEqual */])(modifiers, el[OBSERVER_PROP_NAME]._prevModifiers))) {
    // Re-bind on element
    bind(el, {
      value: value,
      modifiers: modifiers
    }, vnode);
  }
}; // When directive un-binds from element


var unbind = function unbind(el) {
  // Remove the observer
  destroy(el);
}; // Export the directive


var VBVisible = {
  bind: bind,
  componentUpdated: componentUpdated,
  unbind: unbind
};

/***/ }),
/* 181 */
/* exports provided: props, cardMixin */
/* exports used: props */
/*!********************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/card.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* unused harmony export cardMixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  bgVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  borderVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  textVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_57" /* NAME_CARD */]); // --- Mixin ---
// @vue/component

var cardMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props
});

/***/ }),
/* 182 */
/* exports provided: props, formCustomMixin */
/* exports used: props, formCustomMixin */
/*!***************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-custom.js ***!
  \***************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formCustomMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);


 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["b" /* makePropsConfigurable */])({
  plain: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, 'formControls'); // --- Mixin ---
// @vue/component

var formCustomMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  computed: {
    custom: function custom() {
      return !this.plain;
    }
  }
});

/***/ }),
/* 183 */
/* exports provided: props, formOptionsMixin */
/* exports used: props, formOptionsMixin */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-options.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formOptionsMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_get__ = __webpack_require__(/*! ../utils/get */ 141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_warn__ = __webpack_require__(/*! ../utils/warn */ 54);







 // --- Constants ---

var OPTIONS_OBJECT_DEPRECATED_MSG = 'Setting prop "options" to an object is deprecated. Use the array format instead.'; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  disabledField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'disabled'),
  htmlField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'html'),
  options: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["u" /* PROP_TYPE_ARRAY_OBJECT */], []),
  textField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'text'),
  valueField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'value')
}, 'formOptionControls'); // --- Mixin ---
// @vue/component

var formOptionsMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  computed: {
    formOptions: function formOptions() {
      return this.normalizeOptions(this.options);
    }
  },
  methods: {
    normalizeOption: function normalizeOption(option) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // When the option is an object, normalize it
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["h" /* isPlainObject */])(option)) {
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.valueField);
        var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.textField);
        return {
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["i" /* isUndefined */])(value) ? key || text : value,
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["b" /* stripTags */])(String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["i" /* isUndefined */])(text) ? key : text)),
          html: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.htmlField),
          disabled: Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.disabledField))
        };
      } // Otherwise create an `<option>` object from the given value


      return {
        value: key || option,
        text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["b" /* stripTags */])(String(option)),
        disabled: false
      };
    },
    normalizeOptions: function normalizeOptions(options) {
      var _this = this;

      // Normalize the given options array
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["c" /* isArray */])(options)) {
        return options.map(function (option) {
          return _this.normalizeOption(option);
        });
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["h" /* isPlainObject */])(options)) {
        // Deprecate the object options format
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_warn__["a" /* warn */])(OPTIONS_OBJECT_DEPRECATED_MSG, this.$options.name); // Normalize a `options` object to an array of options

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["a" /* keys */])(options).map(function (key) {
          return _this.normalizeOption(options[key] || {}, key);
        });
      } // If not an array or object, return an empty array

      /* istanbul ignore next */


      return [];
    }
  }
});

/***/ }),
/* 184 */
/* exports provided: isLocaleRTL */
/* exports used: isLocaleRTL */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/locale.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isLocaleRTL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(/*! ./array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__string__ = __webpack_require__(/*! ./string */ 23);
// Localization utilities


 // Languages that are RTL

var RTL_LANGS = ['ar', 'az', 'ckb', 'fa', 'he', 'ks', 'lrc', 'mzn', 'ps', 'sd', 'te', 'ug', 'ur', 'yi'].map(function (locale) {
  return locale.toLowerCase();
}); // Returns true if the locale is RTL

var isLocaleRTL = function isLocaleRTL(locale) {
  // Determines if the locale is RTL (only single locale supported)
  var parts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__string__["a" /* toString */])(locale).toLowerCase().replace(__WEBPACK_IMPORTED_MODULE_0__constants_regex__["x" /* RX_STRIP_LOCALE_MODS */], '').split('-');
  var locale1 = parts.slice(0, 2).join('-');
  var locale2 = parts[0];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* arrayIncludes */])(RTL_LANGS, locale1) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["c" /* arrayIncludes */])(RTL_LANGS, locale2);
};

/***/ }),
/* 185 */
/* exports provided: observeDom */
/* exports used: observeDom */
/*!**************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/observe-dom.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observeDom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__(/*! ./dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warn__ = __webpack_require__(/*! ./warn */ 54);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * Observe a DOM element changes, falls back to eventListener mode
 * @param {Element} el The DOM element to observe
 * @param {Function} callback callback to be called on change
 * @param {object} [options={childList: true, subtree: true}] observe options
 * @see https://stackoverflow.com/questions/3219758
 */

var observeDom = function observeDom(el, callback, options)
/* istanbul ignore next: difficult to test in JSDOM */
{
  // Handle cases where we might be passed a Vue instance
  el = el ? el.$el || el : null; // Early exit when we have no element

  /* istanbul ignore next: difficult to test in JSDOM */

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom__["e" /* isElement */])(el)) {
    return null;
  } // Exit and throw a warning when `MutationObserver` isn't available


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warn__["b" /* warnNoMutationObserverSupport */])('observeDom')) {
    return null;
  } // Define a new observer


  var obs = new __WEBPACK_IMPORTED_MODULE_0__dom__["z" /* MutationObs */](function (mutations) {
    var changed = false; // A mutation can contain several change records, so we loop
    // through them to see what has changed
    // We break out of the loop early if any "significant" change
    // has been detected

    for (var i = 0; i < mutations.length && !changed; i++) {
      // The mutation record
      var mutation = mutations[i]; // Mutation type

      var type = mutation.type; // DOM node (could be any DOM node type - HTMLElement, Text, comment, etc.)

      var target = mutation.target; // Detect whether a change happened based on type and target

      if (type === 'characterData' && target.nodeType === Node.TEXT_NODE) {
        // We ignore nodes that are not TEXT (i.e. comments, etc.)
        // as they don't change layout
        changed = true;
      } else if (type === 'attributes') {
        changed = true;
      } else if (type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
        // This includes HTMLElement and text nodes being
        // added/removed/re-arranged
        changed = true;
      }
    } // We only call the callback if a change that could affect
    // layout/size truly happened


    if (changed) {
      callback();
    }
  }); // Have the observer observe foo for changes in children, etc

  obs.observe(el, _objectSpread({
    childList: true,
    subtree: true
  }, options)); // We return a reference to the observer so that `obs.disconnect()`
  // can be called if necessary
  // To reduce overhead when the root element is hidden

  return obs;
};

/***/ }),
/* 186 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/modules/_classof.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(/*! ./_cof */ 143);
var TAG = __webpack_require__(/*! ./_wks */ 56)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 187 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_to-length.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(/*! ./_to-integer */ 270);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 188 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/core-js/library/modules/_uid.js ***!
  \*******************************************/
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 189 */
/* exports provided: DaySpan */
/* exports used: DaySpan */
/*!**********************************!*\
  !*** ./~/dayspan/lib/DaySpan.js ***!
  \**********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DaySpan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Day__ = __webpack_require__(/*! ./Day */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Operation__ = __webpack_require__(/*! ./Operation */ 151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Units__ = __webpack_require__(/*! ./Units */ 191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(/*! ./Constants */ 98);





/**
 * A class for a range of time between two [[Day]] timestamps.
 */
var DaySpan = (function () {
    /**
     * Creates a new span of time.
     *
     * @param start The starting timestamp.
     * @param end The ending timestamp.
     */
    function DaySpan(start, end) {
        this.start = start;
        this.end = end;
    }
    Object.defineProperty(DaySpan.prototype, "isPoint", {
        /**
         * Whether this span starts and ends on the same timestamp.
         */
        get: function () {
            return this.start.time === this.end.time;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Determines whether the given timestamp lies between the start and end
     * timestamp.
     *
     * @param day The timestamp to test.
     * @returns True if the day is >= the start and <= the end of this span.
     */
    DaySpan.prototype.contains = function (day) {
        return day.time >= this.start.time && day.time <= this.end.time;
    };
    /**
     * Compares the given timestamp to this span. If the timestamp is before this
     * span then `-1` is returned, if the timestamp is after this span then `1`
     * us returned, otherwise `0` is returned when the timestamp is in this span.
     *
     * @param day The timestamp to compare to.
     * @returns `-1`, `0`, or `1` depending on the given timestamp relative to
     *    this span.
     */
    DaySpan.prototype.compareTo = function (day) {
        return day.time < this.start.time ? -1 : (day.time > this.end.time ? 1 : 0);
    };
    /**
     * Determines whether the given timestamp is between the start and end
     * timestamp or lies on the same day as the start or end timestamp.
     *
     * @param day The timestamp to test.
     * @see [[Day.sameDay]]
     */
    DaySpan.prototype.matchesDay = function (day) {
        return this.contains(day) || day.sameDay(this.start) || day.sameDay(this.end);
    };
    /**
     * Determines whether the given timestamp is between the start and end
     * timestamp or lies on the same week as the start or end timestamp.
     *
     * @param day The timestamp to test.
     * @see [[Day.sameWeek]]
     */
    DaySpan.prototype.matchesWeek = function (day) {
        return this.contains(day) || day.sameWeek(this.start) || day.sameWeek(this.end);
    };
    /**
     * Determines whether the given timestamp is between the start and end
     * timestamp or lies on the same month as the start or end timestamp.
     *
     * @param day The timestamp to test.
     * @see [[Day.sameMonth]]
     */
    DaySpan.prototype.matchesMonth = function (day) {
        return this.contains(day) || day.sameMonth(this.start) || day.sameMonth(this.end);
    };
    /**
     * Determines whether the given timestamp is between the start and end
     * timestamp or lies on the same year as the start or end timestamp.
     *
     * @param day The timestamp to test.
     * @see [[Day.sameYear]]
     */
    DaySpan.prototype.matchesYear = function (day) {
        return this.contains(day) || day.sameYear(this.start) || day.sameYear(this.end);
    };
    /**
     * Calculates the number of milliseconds between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.millisBetween]]
     */
    DaySpan.prototype.millis = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.millisBetween(this.end, op, absolute);
    };
    /**
     * Calculates the number of seconds between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.secondsBetween]]
     */
    DaySpan.prototype.seconds = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.secondsBetween(this.end, op, absolute);
    };
    /**
     * Calculates the number of minutes between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.minutesBetween]]
     */
    DaySpan.prototype.minutes = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.minutesBetween(this.end, op, absolute);
    };
    /**
     * Calculates the number of hours between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.hoursBetween]]
     */
    DaySpan.prototype.hours = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.hoursBetween(this.end, op, absolute);
    };
    /**
     * Calculates the number of days between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.daysBetween]]
     */
    DaySpan.prototype.days = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.daysBetween(this.end, op, absolute);
    };
    /**
     * Calculates the number of weeks between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.weeksBetween]]
     */
    DaySpan.prototype.weeks = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.weeksBetween(this.end, op, absolute);
    };
    /**
     * Calculates the number of months between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.monthsBetween]]
     */
    DaySpan.prototype.months = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.monthsBetween(this.end, op, absolute);
    };
    /**
     * Calculates the number of years between the start and end timestamp.
     *
     * @param op The operation to perform on the result.
     * @param absolute Whether the result should always be positive.
     * @returns The time between the start and end timestamp.
     * @see [[Day.yearsBetween]]
     */
    DaySpan.prototype.years = function (op, absolute) {
        if (op === void 0) { op = __WEBPACK_IMPORTED_MODULE_1__Operation__["a" /* Op */].DOWN; }
        if (absolute === void 0) { absolute = true; }
        return this.start.yearsBetween(this.end, op, absolute);
    };
    /**
     * Returns a delta value between 0 and 1 which represents where the
     * [[DaySpan.start]] is relative to the given day. The delta value would
     * be less than 0 if the start of the event is before the given day.
     *
     * @param relativeTo The day to find the start delta relative to.
     * @return A number between 0 and 1 if the start of this span is in the
     *    24-hour period starting at the given timestamp, otherwise the value
     *    returned may be less than 0 or greater than 1.
     */
    DaySpan.prototype.startDelta = function (relativeTo) {
        return (this.start.time - relativeTo.time) / __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].MILLIS_IN_DAY;
    };
    /**
     * Returns a delta value between 0 and 1 which represents where the
     * [[DaySpan.end]] is relative to the given day. The delta value would
     * be greater than 1 if the end of the event is after the given day.
     *
     * @param relativeTo The day to find the end delta relative to.
     * @return A number between 0 and 1 if the end of this span is in the
     *    24-hour period starting at the given timestamp, otherwise the value
     *    returned may be less than 0 or greater than 1.
     */
    DaySpan.prototype.endDelta = function (relativeTo) {
        return (this.end.time - relativeTo.time) / __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].MILLIS_IN_DAY;
    };
    /**
     * Calculates the bounds for span event if it were placed in a rectangle which
     * represents a day (24 hour period). By default the returned values are
     * between 0 and 1 and can be scaled by the proper rectangle dimensions or the
     * rectangle dimensions can be passed to this function.
     *
     * @param relativeTo The day to find the bounds relative to. If this is not the
     *    start of the day the returned bounds is relative to the given time.
     * @param dayHeight The height of the rectangle of the day.
     * @param dayWidth The width of the rectangle of the day.
     * @param columnOffset The offset in the rectangle of the day to adjust this
     *    span by. This also reduces the width of the returned bounds to keep the
     *    bounds in the rectangle of the day.
     * @param clip `true` if the bounds should stay in the day rectangle, `false`
     *    and the bounds may go outside the rectangle of the day for multi-day
     *    spans.
     * @param offsetX How much to translate the left & right properties by.
     * @param offsetY How much to translate the top & bottom properties by.
     * @returns The calculated bounds for this span.
     */
    DaySpan.prototype.getBounds = function (relativeTo, dayHeight, dayWidth, columnOffset, clip, offsetX, offsetY) {
        if (dayHeight === void 0) { dayHeight = 1; }
        if (dayWidth === void 0) { dayWidth = 1; }
        if (columnOffset === void 0) { columnOffset = 0; }
        if (clip === void 0) { clip = true; }
        if (offsetX === void 0) { offsetX = 0; }
        if (offsetY === void 0) { offsetY = 0; }
        var startRaw = this.startDelta(relativeTo);
        var endRaw = this.endDelta(relativeTo);
        var start = clip ? Math.max(0, startRaw) : startRaw;
        var end = clip ? Math.min(1, endRaw) : endRaw;
        var left = columnOffset;
        var right = dayWidth - left;
        var top = start * dayHeight;
        var bottom = end * dayHeight;
        return {
            top: top + offsetY,
            bottom: bottom + offsetY,
            height: bottom - top,
            left: left + offsetX,
            right: right + offsetX,
            width: right
        };
    };
    /**
     * Summarizes this span given an approximate unit of time and a few other
     * options. If the start and end are on the same unit, a single value will
     * be returned. Otherwise a start and end will be returned with a `delimiter`.
     *
     * @param type The unit of time this span is for.
     * @param dayOfWeek When `true` the weekday of the start and end are included.
     * @param short When `true` the short form of weekdays and months will be used.
     * @param repeat When `true` the year will be repeated on the start and end
     *  timestamp even if they are the same year.
     * @param contextual When `true` the year will be hidden if it's the current
     *  year.
     * @param delimiter The string to separate the start and end timestamps with.
     * @returns The summary of this span.
     */
    DaySpan.prototype.summary = function (type, dayOfWeek, short, repeat, contextual, delimiter) {
        if (dayOfWeek === void 0) { dayOfWeek = true; }
        if (short === void 0) { short = false; }
        if (repeat === void 0) { repeat = false; }
        if (contextual === void 0) { contextual = true; }
        if (delimiter === void 0) { delimiter = ' - '; }
        var formats = DaySpan.SUMMARY_FORMATS[type];
        var today = __WEBPACK_IMPORTED_MODULE_0__Day__["a" /* Day */].today();
        var showStartYear = !contextual || !this.start.sameYear(today);
        var showEndYear = !contextual || !this.end.sameYear(today);
        var start = this.start.format(formats(short, dayOfWeek, showStartYear));
        var end = this.end.format(formats(short, dayOfWeek, showEndYear));
        var summary = start;
        if (start !== end) {
            if (!repeat) {
                summary = this.start.format(formats(short, dayOfWeek, !this.start.sameYear(this.end)));
            }
            summary += delimiter;
            summary += end;
        }
        else {
            summary = start;
        }
        return summary;
    };
    /**
     * Determines whether the gven span intersects with this span.
     *
     * @param span The span to test.
     * @returns `true` if the spans intersect, otherwise `false`.
     */
    DaySpan.prototype.intersects = function (span) {
        return !(this.end.time < span.start.time ||
            this.start.time > span.end.time);
    };
    /**
     * Calculates the intersection between this span and the given span. If there
     * is no intersection between the two spans then `null` is returned.
     *
     * @param span The span to calculate the intersection with.
     * @returns The intersection or `null` if none exists.
     */
    DaySpan.prototype.intersection = function (span) {
        var start = this.start.max(span.start);
        var end = this.end.min(span.end);
        return start.isAfter(end) ? null : new DaySpan(start, end);
    };
    /**
     * Calculates the union between this span and the given span.
     *
     * @param span The span to calculate the union with.
     * @returns The union of the two spans.
     */
    DaySpan.prototype.union = function (span) {
        var start = this.start.min(span.start);
        var end = this.end.max(span.end);
        return new DaySpan(start, end);
    };
    /**
     * Returns a point [[DaySpan]] with the same start and end timestamp.
     *
     * @param day The timestamp which will be the start and end.
     * @returns The new instance.
     * @see [[DaySpan.isPoint]]
     */
    DaySpan.point = function (day) {
        return new DaySpan(day, day);
    };
    /**
     * Formatting functions which assist the [[DaySpan.summary]] function.
     */
    DaySpan.SUMMARY_FORMATS = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_2__Units__["a" /* Units */].DAY] = function (short, dayOfWeek, year) {
            return (dayOfWeek ? (short ? 'ddd, ' : 'dddd, ') : '') + (short ? 'MMM ' : 'MMMM ') + 'Do' + (year ? ' YYYY' : '');
        },
        _a[__WEBPACK_IMPORTED_MODULE_2__Units__["a" /* Units */].WEEK] = function (short, dayOfWeek, year) {
            return (dayOfWeek ? (short ? 'ddd, ' : 'dddd, ') : '') + (short ? 'MMM ' : 'MMMM ') + 'Do' + (year ? ' YYYY' : '');
        },
        _a[__WEBPACK_IMPORTED_MODULE_2__Units__["a" /* Units */].MONTH] = function (short, dayOfWeek, year) {
            return (short ? 'MMM' : 'MMMM') + (year ? ' YYYY' : '');
        },
        _a[__WEBPACK_IMPORTED_MODULE_2__Units__["a" /* Units */].YEAR] = function (short, dayOfWeek, year) {
            return (year ? 'YYYY' : '');
        },
        _a);
    return DaySpan;
}());

var _a;
//# sourceMappingURL=DaySpan.js.map

/***/ }),
/* 190 */
/* exports provided: Identifier */
/* exports used: Identifier */
/*!*************************************!*\
  !*** ./~/dayspan/lib/Identifier.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Identifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Day__ = __webpack_require__(/*! ./Day */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DaySpan__ = __webpack_require__(/*! ./DaySpan */ 189);

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * A class for detecting, parsing, and building identifiers to and from days.
 *
 * An identifier is a simple value which represents a span of time. It may
 * represent an entire year, a quarter (3 months) of a year, a week of a year,
 * a month in a year, a specific day of a month of a year, or a specific hour,
 * minute, day, and month of a year.
 *
 * For example:
 * - `2018`: The year 2018
 * - `201801`: January 2018
 * - `2014023`: The 23rd week of 2014
 * - `20170311`: March 11th, 2017
 * - `201406151651`: June 15th 2016 at 4:51 pm
 * - `'0525'`: Year 525 of the first age, Elrond and Elros are born
 */
var Identifier = (function () {
    function Identifier() {
    }
    /**
     * Determines whether the given identifier is this type.
     *
     * @param id The identifier to test.
     * @returns `true` if the identifier is this type, otherwise `false`.
     */
    Identifier.prototype.is = function (id) {
        return (id + '').length === this.getLength();
    };
    /**
     * Computes the identifier given values taken from a [[Day]].
     *
     * @param values The values to compute.
     * @returns The computed identifier.
     */
    Identifier.prototype.compute = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var scales = this.getScales();
        var total = 0;
        for (var i = 0; i < values.length; i++) {
            total += values[i] * scales[i];
        }
        return this.is(total) ? total : __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(total, this.getLength());
    };
    /**
     * Decomputes the given identifier and returns values which describe a span
     * of time.
     *
     * @param id The identifier to decompute.
     * @returns The original values which computed the identifier.
     */
    Identifier.prototype.decompute = function (id) {
        var scales = this.getScales();
        var total = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isNumber(id) ? id : parseInt(id);
        var values = [];
        for (var i = 0; i < scales.length - 1; i++) {
            var curr = scales[i + 0];
            var next = scales[i + 1];
            var mod = next / curr;
            var value = total % mod;
            values.push(value);
            total = Math.floor(total / mod);
        }
        values.push(total);
        return values;
    };
    /**
     * Finds which identifier type matches the given identifier, if any.
     *
     * @param id The identifier to find the type of.
     * @returns The found identifier type, otherwise `null` if none exists.
     */
    Identifier.find = function (id) {
        if (this.Time.is(id))
            return this.Time;
        if (this.Day.is(id))
            return this.Day;
        if (this.Week.is(id))
            return this.Week;
        if (this.Month.is(id))
            return this.Month;
        if (this.Year.is(id))
            return this.Year;
        return null;
    };
    /**
     * Determines whether the given time span `outer` contains the time span
     * `inner`.
     *
     * @param outer The potentially larger time span `inner` must be contained in.
     * @param inner The time span to test is contained inside `outer`.
     * @returns `true` if `inner` is equal to or contained in `outer`, otherwise
     *    `false`.
     */
    Identifier.contains = function (outer, inner) {
        var outerString = outer + '';
        return (inner + '').substring(0, outerString.length) === outerString;
    };
    /**
     * The identifier type for an hour of time on a specific day.
     */
    Identifier.Time = null;
    /**
     * The identifier type for a specific day.
     */
    Identifier.Day = null;
    /**
     * The identifier type for a specific week of a year.
     */
    Identifier.Week = null;
    /**
     * The identifier type for a specific month of a year.
     */
    Identifier.Month = null;
    /**
     * The identifier type for a specific quarter of a year.
     */
    Identifier.Quarter = null;
    /**
     * The identifier type for a specific year.
     */
    Identifier.Year = null;
    return Identifier;
}());

// YYYYMMddHHmm (12)
var IdentifierTime = (function (_super) {
    __extends(IdentifierTime, _super);
    function IdentifierTime() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdentifierTime.prototype.getScales = function () {
        return IdentifierTime.SCALES;
    };
    IdentifierTime.prototype.getLength = function () {
        return IdentifierTime.LENGTH;
    };
    IdentifierTime.prototype.get = function (day) {
        return this.compute(day.minute, day.hour, day.dayOfMonth, day.month + 1, day.year);
    };
    IdentifierTime.prototype.object = function (id) {
        var values = this.decompute(id);
        return {
            minute: values[0],
            hour: values[1],
            day: values[2],
            month: values[3] - 1,
            year: values[4]
        };
    };
    IdentifierTime.prototype.start = function (id) {
        var obj = this.object(id);
        var start = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].build(obj.year, obj.month, obj.day, obj.hour, obj.minute);
        return start;
    };
    IdentifierTime.prototype.span = function (id, endInclusive) {
        if (endInclusive === void 0) { endInclusive = false; }
        var start = this.start(id);
        var end = start.endOfHour(endInclusive);
        return new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
    };
    IdentifierTime.prototype.describe = function (id, short) {
        if (short === void 0) { short = false; }
        var start = this.start(id);
        var format = short ? IdentifierTime.DESCRIBE_FORMAT_SHORT : IdentifierTime.DESCRIBE_FORMAT_LONG;
        return start.format(format);
    };
    IdentifierTime.prototype.matches = function (day, id) {
        return day.timeIdentifier === id;
        /*
        let obj: IdentifierObject = this.object(id);
    
        return (
          day.year === obj.year &&
          day.month === obj.month &&
          day.dayOfMonth === obj.day &&
          day.hour === obj.hour &&
          day.minute === obj.minute
        );
        */
    };
    IdentifierTime.DESCRIBE_FORMAT_LONG = 'LLL';
    IdentifierTime.DESCRIBE_FORMAT_SHORT = 'lll';
    IdentifierTime.SCALES = [
        1 /* minute */,
        100 /* hour   */,
        10000 /* day    */,
        1000000 /* month  */,
        100000000 /* year   */
    ];
    IdentifierTime.LENGTH = 12;
    return IdentifierTime;
}(Identifier));
// YYYYMMdd (8)
var IdentifierDay = (function (_super) {
    __extends(IdentifierDay, _super);
    function IdentifierDay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdentifierDay.prototype.getScales = function () {
        return IdentifierDay.SCALES;
    };
    IdentifierDay.prototype.getLength = function () {
        return IdentifierDay.LENGTH;
    };
    IdentifierDay.prototype.get = function (day) {
        return this.compute(day.dayOfMonth, day.month + 1, day.year);
    };
    IdentifierDay.prototype.object = function (id) {
        var values = this.decompute(id);
        return {
            day: values[0],
            month: values[1] - 1,
            year: values[2]
        };
    };
    IdentifierDay.prototype.start = function (id) {
        var obj = this.object(id);
        var start = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].build(obj.year, obj.month, obj.day);
        return start;
    };
    IdentifierDay.prototype.span = function (id, endInclusive) {
        if (endInclusive === void 0) { endInclusive = false; }
        var start = this.start(id);
        var end = start.end(endInclusive);
        return new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
    };
    IdentifierDay.prototype.describe = function (id, short) {
        if (short === void 0) { short = false; }
        var start = this.start(id);
        var format = short ? IdentifierDay.DESCRIBE_FORMAT_SHORT : IdentifierDay.DESCRIBE_FORMAT_LONG;
        return start.format(format);
    };
    IdentifierDay.prototype.matches = function (day, id) {
        return day.dayIdentifier === id;
        /*
        let obj: IdentifierObject = this.object(id);
    
        return (
          day.year === obj.year &&
          day.month === obj.month &&
          day.dayOfMonth === obj.day
        );
        */
    };
    IdentifierDay.DESCRIBE_FORMAT_LONG = 'LL';
    IdentifierDay.DESCRIBE_FORMAT_SHORT = 'll';
    IdentifierDay.SCALES = [
        1 /* day     */,
        100 /* month   */,
        10000 /* year    */
    ];
    IdentifierDay.LENGTH = 8;
    return IdentifierDay;
}(Identifier));
// YYYY0ww (7)
var IdentifierWeek = (function (_super) {
    __extends(IdentifierWeek, _super);
    function IdentifierWeek() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdentifierWeek.prototype.getScales = function () {
        return IdentifierWeek.SCALES;
    };
    IdentifierWeek.prototype.getLength = function () {
        return IdentifierWeek.LENGTH;
    };
    IdentifierWeek.prototype.get = function (day) {
        return this.compute(day.week, day.year);
    };
    IdentifierWeek.prototype.object = function (id) {
        var values = this.decompute(id);
        return {
            week: values[0],
            year: values[1]
        };
    };
    IdentifierWeek.prototype.start = function (id) {
        var obj = this.object(id);
        var start = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].build(obj.year, 0).withWeek(obj.week);
        return start;
    };
    IdentifierWeek.prototype.span = function (id, endInclusive) {
        if (endInclusive === void 0) { endInclusive = false; }
        var start = this.start(id);
        var end = start.endOfWeek(endInclusive);
        return new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
    };
    IdentifierWeek.prototype.describe = function (id, short) {
        if (short === void 0) { short = false; }
        var start = this.start(id);
        var format = short ? IdentifierWeek.DESCRIBE_FORMAT_SHORT : IdentifierWeek.DESCRIBE_FORMAT_LONG;
        return start.format(format);
    };
    IdentifierWeek.prototype.matches = function (day, id) {
        return day.weekIdentifier === id;
        /*
        let obj: IdentifierObject = this.object(id);
    
        return (
          day.year === obj.year &&
          day.week === obj.week
        );
        */
    };
    IdentifierWeek.DESCRIBE_FORMAT_LONG = 'wo [week of] YYYY';
    IdentifierWeek.DESCRIBE_FORMAT_SHORT = 'wo [week of] YYYY';
    IdentifierWeek.SCALES = [
        1 /* week   */,
        1000 /* year   */
    ];
    IdentifierWeek.LENGTH = 7;
    return IdentifierWeek;
}(Identifier));
// YYYYMM (6)
var IdentifierMonth = (function (_super) {
    __extends(IdentifierMonth, _super);
    function IdentifierMonth() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdentifierMonth.prototype.getScales = function () {
        return IdentifierMonth.SCALES;
    };
    IdentifierMonth.prototype.getLength = function () {
        return IdentifierMonth.LENGTH;
    };
    IdentifierMonth.prototype.get = function (day) {
        return this.compute(day.month + 1, day.year);
    };
    IdentifierMonth.prototype.object = function (id) {
        var values = this.decompute(id);
        return {
            month: values[0] - 1,
            year: values[1]
        };
    };
    IdentifierMonth.prototype.start = function (id) {
        var obj = this.object(id);
        var start = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].build(obj.year, obj.month);
        return start;
    };
    IdentifierMonth.prototype.span = function (id, endInclusive) {
        if (endInclusive === void 0) { endInclusive = false; }
        var start = this.start(id);
        var end = start.endOfMonth(endInclusive);
        return new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
    };
    IdentifierMonth.prototype.describe = function (id, short) {
        if (short === void 0) { short = false; }
        var start = this.start(id);
        var format = short ? IdentifierMonth.DESCRIBE_FORMAT_SHORT : IdentifierMonth.DESCRIBE_FORMAT_LONG;
        return start.format(format);
    };
    IdentifierMonth.prototype.matches = function (day, id) {
        return day.monthIdentifier === id;
        /*
        let obj: IdentifierObject = this.object(id);
    
        return (
          day.year === obj.year &&
          day.month === obj.month
        );
        */
    };
    IdentifierMonth.DESCRIBE_FORMAT_LONG = 'MMMM YYYY';
    IdentifierMonth.DESCRIBE_FORMAT_SHORT = 'MMM YYYY';
    IdentifierMonth.SCALES = [
        1 /* month  */,
        100 /* year   */
    ];
    IdentifierMonth.LENGTH = 6;
    return IdentifierMonth;
}(Identifier));
// YYYYQ (5)
var IdentifierQuarter = (function (_super) {
    __extends(IdentifierQuarter, _super);
    function IdentifierQuarter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdentifierQuarter.prototype.getScales = function () {
        return IdentifierQuarter.SCALES;
    };
    IdentifierQuarter.prototype.getLength = function () {
        return IdentifierQuarter.LENGTH;
    };
    IdentifierQuarter.prototype.get = function (day) {
        return this.compute(day.quarter, day.year);
    };
    IdentifierQuarter.prototype.object = function (id) {
        var values = this.decompute(id);
        return {
            quarter: values[0],
            year: values[1]
        };
    };
    IdentifierQuarter.prototype.start = function (id) {
        var obj = this.object(id);
        var start = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].build(obj.year, (obj.quarter - 1) * 3);
        return start;
    };
    IdentifierQuarter.prototype.span = function (id, endInclusive) {
        if (endInclusive === void 0) { endInclusive = false; }
        var start = this.start(id);
        var end = start.relativeMonths(3).endOfMonth(endInclusive);
        return new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
    };
    IdentifierQuarter.prototype.describe = function (id, short) {
        if (short === void 0) { short = false; }
        var start = this.start(id);
        var format = short ? IdentifierQuarter.DESCRIBE_FORMAT_SHORT : IdentifierQuarter.DESCRIBE_FORMAT_LONG;
        return start.format(format);
    };
    IdentifierQuarter.prototype.matches = function (day, id) {
        return day.quarterIdentifier === id;
        /*
        let obj: IdentifierObject = this.object(id);
    
        return (
          day.year === obj.year &&
          day.quarter === obj.quarter
        );
        */
    };
    IdentifierQuarter.DESCRIBE_FORMAT_LONG = 'Qo [quarter] YYYY';
    IdentifierQuarter.DESCRIBE_FORMAT_SHORT = 'Qo [quarter] YYYY';
    IdentifierQuarter.SCALES = [
        1 /* quarter  */,
        10 /* year   */
    ];
    IdentifierQuarter.LENGTH = 5;
    return IdentifierQuarter;
}(Identifier));
// YYYY (4)
var IdentifierYear = (function (_super) {
    __extends(IdentifierYear, _super);
    function IdentifierYear() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IdentifierYear.prototype.getScales = function () {
        return IdentifierYear.SCALES;
    };
    IdentifierYear.prototype.getLength = function () {
        return IdentifierYear.LENGTH;
    };
    IdentifierYear.prototype.get = function (day) {
        return this.compute(day.year);
    };
    IdentifierYear.prototype.object = function (id) {
        var values = this.decompute(id);
        return {
            year: values[0]
        };
    };
    IdentifierYear.prototype.start = function (id) {
        var obj = this.object(id);
        var start = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].build(obj.year, 0);
        return start;
    };
    IdentifierYear.prototype.span = function (id, endInclusive) {
        if (endInclusive === void 0) { endInclusive = false; }
        var start = this.start(id);
        var end = start.endOfYear(endInclusive);
        return new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
    };
    IdentifierYear.prototype.describe = function (id, short) {
        if (short === void 0) { short = false; }
        var start = this.start(id);
        var format = short ? IdentifierYear.DESCRIBE_FORMAT_SHORT : IdentifierYear.DESCRIBE_FORMAT_LONG;
        return start.format(format);
    };
    IdentifierYear.prototype.matches = function (day, id) {
        return day.year === id;
        /*
        let obj: IdentifierObject = this.object(id);
    
        return (
          day.year === obj.year
        );
        */
    };
    IdentifierYear.DESCRIBE_FORMAT_LONG = 'YYYY';
    IdentifierYear.DESCRIBE_FORMAT_SHORT = 'YYYY';
    IdentifierYear.SCALES = [
        1 /* year  */
    ];
    IdentifierYear.LENGTH = 4;
    return IdentifierYear;
}(Identifier));
// Sets the Identifier types
Identifier.Time = new IdentifierTime();
Identifier.Day = new IdentifierDay();
Identifier.Week = new IdentifierWeek();
Identifier.Month = new IdentifierMonth();
Identifier.Quarter = new IdentifierQuarter();
Identifier.Year = new IdentifierYear();
//# sourceMappingURL=Identifier.js.map

/***/ }),
/* 191 */
/* exports provided: Units */
/* exports used: Units */
/*!********************************!*\
  !*** ./~/dayspan/lib/Units.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Units; });

/**
 * Units of time that are compromised of 1 or more days for the [[Calendar]] class.
 */
var Units;
(function (Units) {
    Units[Units["DAY"] = 0] = "DAY";
    Units[Units["WEEK"] = 1] = "WEEK";
    Units[Units["MONTH"] = 2] = "MONTH";
    Units[Units["YEAR"] = 3] = "YEAR";
})(Units = Units || (Units = {}));
//# sourceMappingURL=Units.js.map

/***/ }),
/* 192 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/_group.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = group;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(/*! ./each.js */ 115);



// An internal function used for aggregate "group by" operations.
function group(behavior, partition) {
  return function(obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(obj, function(value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}


/***/ }),
/* 193 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/matcher.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendOwn_js__ = __webpack_require__(/*! ./extendOwn.js */ 286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMatch_js__ = __webpack_require__(/*! ./isMatch.js */ 661);



// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher(attrs) {
  attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extendOwn_js__["a" /* default */])({}, attrs);
  return function(obj) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isMatch_js__["a" /* default */])(obj, attrs);
  };
}


/***/ }),
/* 194 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/partial.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__executeBound_js__ = __webpack_require__(/*! ./_executeBound.js */ 642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);




// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var partial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, boundArgs) {
  var placeholder = partial.placeholder;
  var bound = function() {
    var position = 0, length = boundArgs.length;
    var args = Array(length);
    for (var i = 0; i < length; i++) {
      args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
    }
    while (position < arguments.length) args.push(arguments[position++]);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__executeBound_js__["a" /* default */])(func, bound, this, this, args);
  };
  return bound;
});

partial.placeholder = __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (partial);


/***/ }),
/* 195 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./~/v-money/dist/v-money.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

(function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.VMoney=n():e.VMoney=n()})(this,function(){return function(e){function n(r){if(t[r])return t[r].exports;var i=t[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}var t={};return n.m=e,n.c=t,n.i=function(e){return e},n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:r})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},n.p=".",n(n.s=9)}([function(e,n,t){"use strict";n.a={prefix:"",suffix:"",thousands:",",decimal:".",precision:2,allowBlank:!1}},function(e,n,t){"use strict";var r=t(2),i=t(5),o=t(0);n.a=function(e,n){if(n.value){var u=t.i(i.a)(o.a,n.value);if("INPUT"!==e.tagName.toLocaleUpperCase()){var a=e.getElementsByTagName("input");1!==a.length||(e=a[0])}e.onkeydown=function(n){var i=8==n.which||46==n.which,o=e.value.length-e.selectionEnd==0;u.allowBlank&&i&&o&&0===t.i(r.a)(e.value,0)&&(e.value="",e.dispatchEvent(t.i(r.b)("change")))},e.oninput=function(){var n=e.value.length-e.selectionEnd;e.value=t.i(r.c)(e.value,u),n=Math.max(n,u.suffix.length),n=e.value.length-n,n=Math.max(n,u.prefix.length+1),t.i(r.d)(e,n),e.dispatchEvent(t.i(r.b)("change"))},e.onfocus=function(){t.i(r.d)(e,e.value.length-u.suffix.length)},e.oninput(),e.dispatchEvent(t.i(r.b)("input"))}}},function(e,n,t){"use strict";function r(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:v.a;if(n.allowBlank&&""==e)return"";"number"==typeof e&&(e=e.toFixed(u(n.precision)));var t=e.indexOf("-")>=0?"-":"",r=o(e),i=c(r,n.precision),a=l(i).split("."),d=a[0],p=a[1];return d=f(d,n.thousands),n.prefix+t+s(d,p,n.decimal)+n.suffix}function i(e,n){var t=e.indexOf("-")>=0?-1:1,r=o(e),i=c(r,n);return parseFloat(i)*t}function o(e){return l(e).replace(/\D+/g,"")||"0"}function u(e){return a(0,e,20)}function a(e,n,t){return Math.max(e,Math.min(n,t))}function c(e,n){var t=Math.pow(10,n);return(parseFloat(e)/t).toFixed(u(n))}function f(e,n){return e.replace(/(\d)(?=(?:\d{3})+\b)/gm,"$1"+n)}function s(e,n,t){return n?e+t+n:e}function l(e){return e?e.toString():""}function d(e,n){var t=function(){e.setSelectionRange(n,n)};e===document.activeElement&&(t(),setTimeout(t,1))}function p(e){var n=document.createEvent("Event");return n.initEvent(e,!0,!0),n}t.d(n,"c",function(){return r}),t.d(n,"a",function(){return i}),t.d(n,"d",function(){return d}),t.d(n,"b",function(){return p});var v=t(0)},function(e,n,t){"use strict";function r(e,n){n&&Object.keys(n).map(function(e){a.a[e]=n[e]}),e.directive("money",u.a),e.component("money",o.a)}Object.defineProperty(n,"__esModule",{value:!0}),t.d(n,"VERSION",function(){return c});var i=t(6),o=t.n(i),u=t(1),a=t(0);t.d(n,"Money",function(){return o.a}),t.d(n,"VMoney",function(){return u.a}),t.d(n,"options",function(){return a.a});var c="0.8.3";n.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,n,t){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var r=t(1),i=t(0),o=t(2);n.default={name:"Money",props:{value:{required:!0,type:[Number,String],default:0},masked:{type:Boolean,default:!1},precision:{type:Number,default:function(){return i.a.precision}},decimal:{type:String,default:function(){return i.a.decimal}},thousands:{type:String,default:function(){return i.a.thousands}},prefix:{type:String,default:function(){return i.a.prefix}},suffix:{type:String,default:function(){return i.a.suffix}},allowBlank:{type:Boolean,default:function(){return i.a.allowBlank}}},directives:{money:r.a},data:function(){return{formattedValue:""}},watch:{value:{immediate:!0,handler:function(e,n){var r=t.i(o.c)(e,this.$props);r!==this.formattedValue&&(this.formattedValue=r)}}},methods:{change:function(e){this.$emit("input",this.masked?e.target.value:t.i(o.a)(e.target.value,this.precision))}}}},function(e,n,t){"use strict";n.a=function(e,n){return e=e||{},n=n||{},Object.keys(e).concat(Object.keys(n)).reduce(function(t,r){return t[r]=void 0===n[r]?e[r]:n[r],t},{})}},function(e,n,t){var r=t(7)(t(4),t(8),null,null);e.exports=r.exports},function(e,n){e.exports=function(e,n,t,r){var i,o=e=e||{},u=typeof e.default;"object"!==u&&"function"!==u||(i=e,o=e.default);var a="function"==typeof o?o.options:o;if(n&&(a.render=n.render,a.staticRenderFns=n.staticRenderFns),t&&(a._scopeId=t),r){var c=a.computed||(a.computed={});Object.keys(r).forEach(function(e){var n=r[e];c[e]=function(){return n}})}return{esModule:i,exports:o,options:a}}},function(e,n){e.exports={render:function(){var e=this,n=e.$createElement;return(e._self._c||n)("input",{directives:[{name:"money",rawName:"v-money",value:{precision:e.precision,decimal:e.decimal,thousands:e.thousands,prefix:e.prefix,suffix:e.suffix,allowBlank:e.allowBlank},expression:"{precision, decimal, thousands, prefix, suffix, allowBlank}"}],staticClass:"v-money",attrs:{type:"tel"},domProps:{value:e.formattedValue},on:{change:e.change}})},staticRenderFns:[]}},function(e,n,t){e.exports=t(3)}])});

/***/ }),
/* 196 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./client/components/modals/gridDetailsModal/GridDetailsModal.vue ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-44a5b89a","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./GridDetailsModal.vue */ 1508)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./GridDetailsModal.vue */ 835),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-44a5b89a"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./gridDetailsModal.pug */ 1406),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/gridDetailsModal/GridDetailsModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GridDetailsModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44a5b89a", Component.options)
  } else {
    hotAPI.reload("data-v-44a5b89a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 197 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/vuedraggable/dist/vuedraggable.umd.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(/*! sortablejs */ 1150));
	else if(typeof define === 'function' && define.amd)
		define(["sortablejs"], factory);
	else if(typeof exports === 'object')
		exports["vuedraggable"] = factory(require("sortablejs"));
	else
		root["vuedraggable"] = factory(root["Sortable"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),
/* 198 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./~/axios/lib/defaults.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(/*! ./utils */ 60);
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ 737);
var enhanceError = __webpack_require__(/*! ./core/enhanceError */ 309);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ 305);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ 305);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../process/browser.js */ 281)))

/***/ }),
/* 199 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./client/enum/filtroPeriodo.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FiltroPeriodoEnum = {
  ESTA_SEMANA: 'ESTA_SEMANA',
  ULTIMOS_SETE_DIAS: 'ULTIMOS_SETE_DIAS',
  ESTE_MES: 'ESTE_MES',
  ULTIMOS_TRINTA_DIAS: 'ULTIMOS_TRINTA_DIAS',
  MES_ANTERIOR: 'MES_ANTERIOR',
  PERSONALIZADO: 'PERSONALIZADO'
};

exports.default = FiltroPeriodoEnum;

/***/ }),
/* 200 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./client/enum/idSituacaoTarefa.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IdSituacaoTarefaEnum = {
  PENDENTE: 0,
  EM_ANDAMENTO: 10,
  AGUARDANDO: 20,
  CONCLUIDO: 90,
  CANCELADO: 99
};

exports.default = IdSituacaoTarefaEnum;

/***/ }),
/* 201 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./client/enum/perfilAcessoEnum.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PerfilAcessoIdEnum = {
  MASTER: 2
};

exports.default = PerfilAcessoIdEnum;

/***/ }),
/* 202 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./client/utils/generateDateTime.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function generateDateTime() {
  var currentDate = new Date();
  return currentDate.getDate().toString() + (currentDate.getMonth() + 1).toString() + currentDate.getFullYear().toString() + '_' + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds();
}

exports.default = generateDateTime;

/***/ }),
/* 203 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/babel-runtime/core-js/number/max-safe-integer.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/number/max-safe-integer */ 965), __esModule: true };

/***/ }),
/* 204 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./~/babel-runtime/core-js/set.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/set */ 971), __esModule: true };

/***/ }),
/* 205 */
/* exports provided: AspectPlugin, BAspect */
/* exports used: AspectPlugin, BAspect */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/aspect/index.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AspectPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aspect__ = __webpack_require__(/*! ./aspect */ 327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__aspect__["a"]; });


var AspectPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BAspect: __WEBPACK_IMPORTED_MODULE_0__aspect__["a" /* BAspect */]
  }
});


/***/ }),
/* 206 */
/* exports provided: computeSize, props, BAvatar */
/* exports used: BAvatar, computeSize */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/avatar/avatar.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return computeSize; });
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAvatar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_router__ = __webpack_require__(/*! ../../utils/router */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_icon__ = __webpack_require__(/*! ../../icons/icon */ 138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__button_button__ = __webpack_require__(/*! ../button/button */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















 // --- Constants ---

var CLASS_NAME = 'b-avatar';
var SIZES = ['sm', null, 'lg'];
var FONT_SIZE_SCALE = 0.4;
var BADGE_FONT_SIZE_SCALE = FONT_SIZE_SCALE * 0.7; // --- Helper methods ---

var computeSize = function computeSize(value) {
  // Parse to number when value is a float-like string
  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["f" /* isString */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["n" /* isNumeric */])(value) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(value, 0) : value; // Convert all numbers to pixel values

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["j" /* isNumber */])(value) ? "".concat(value, "px") : value || null;
}; // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_14__link_link__["b" /* props */], ['active', 'event', 'routerTag']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, linkProps), {}, {
  alt: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'avatar'),
  ariaLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  badge: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  badgeLeft: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  badgeOffset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  badgeTop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  badgeVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'primary'),
  button: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  buttonType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'button'),
  icon: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  rounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  square: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  src: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_70" /* NAME_AVATAR */]); // --- Main component ---
// @vue/component

var BAvatar = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_70" /* NAME_AVATAR */],
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inject: {
    getBvAvatarGroup: {
      default: function _default() {
        return function () {
          return null;
        };
      }
    }
  },
  props: props,
  data: function data() {
    return {
      localSrc: this.src || null
    };
  },
  computed: {
    bvAvatarGroup: function bvAvatarGroup() {
      return this.getBvAvatarGroup();
    },
    computedSize: function computedSize() {
      // Always use the avatar group size
      var bvAvatarGroup = this.bvAvatarGroup;
      return computeSize(bvAvatarGroup ? bvAvatarGroup.size : this.size);
    },
    computedVariant: function computedVariant() {
      var bvAvatarGroup = this.bvAvatarGroup;
      return bvAvatarGroup && bvAvatarGroup.variant ? bvAvatarGroup.variant : this.variant;
    },
    computedRounded: function computedRounded() {
      var bvAvatarGroup = this.bvAvatarGroup;
      var square = bvAvatarGroup && bvAvatarGroup.square ? true : this.square;
      var rounded = bvAvatarGroup && bvAvatarGroup.rounded ? bvAvatarGroup.rounded : this.rounded;
      return square ? '0' : rounded === '' ? true : rounded || 'circle';
    },
    fontStyle: function fontStyle() {
      var size = this.computedSize;
      var fontSize = SIZES.indexOf(size) === -1 ? "calc(".concat(size, " * ").concat(FONT_SIZE_SCALE, ")") : null;
      return fontSize ? {
        fontSize: fontSize
      } : {};
    },
    marginStyle: function marginStyle() {
      var size = this.computedSize,
          bvAvatarGroup = this.bvAvatarGroup;
      var overlapScale = bvAvatarGroup ? bvAvatarGroup.overlapScale : 0;
      var value = size && overlapScale ? "calc(".concat(size, " * -").concat(overlapScale, ")") : null;
      return value ? {
        marginLeft: value,
        marginRight: value
      } : {};
    },
    badgeStyle: function badgeStyle() {
      var size = this.computedSize,
          badgeTop = this.badgeTop,
          badgeLeft = this.badgeLeft,
          badgeOffset = this.badgeOffset;
      var offset = badgeOffset || '0px';
      return {
        fontSize: SIZES.indexOf(size) === -1 ? "calc(".concat(size, " * ").concat(BADGE_FONT_SIZE_SCALE, " )") : null,
        top: badgeTop ? offset : null,
        bottom: badgeTop ? null : offset,
        left: badgeLeft ? offset : null,
        right: badgeLeft ? null : offset
      };
    }
  },
  watch: {
    src: function src(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.localSrc = newValue || null;
      }
    }
  },
  methods: {
    onImgError: function onImgError(event) {
      this.localSrc = null;
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["_7" /* EVENT_NAME_IMG_ERROR */], event);
    },
    onClick: function onClick(event) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["x" /* EVENT_NAME_CLICK */], event);
    }
  },
  render: function render(h) {
    var _class2;

    var variant = this.computedVariant,
        disabled = this.disabled,
        rounded = this.computedRounded,
        icon = this.icon,
        src = this.localSrc,
        text = this.text,
        fontStyle = this.fontStyle,
        marginStyle = this.marginStyle,
        size = this.computedSize,
        button = this.button,
        type = this.buttonType,
        badge = this.badge,
        badgeVariant = this.badgeVariant,
        badgeStyle = this.badgeStyle;
    var link = !button && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_router__["a" /* isLink */])(this);
    var tag = button ? __WEBPACK_IMPORTED_MODULE_13__button_button__["a" /* BButton */] : link ? __WEBPACK_IMPORTED_MODULE_14__link_link__["a" /* BLink */] : 'span';
    var alt = this.alt;
    var ariaLabel = this.ariaLabel || null;
    var $content = null;

    if (this.hasNormalizedSlot()) {
      // Default slot overrides props
      $content = h('span', {
        staticClass: 'b-avatar-custom'
      }, [this.normalizeSlot()]);
    } else if (src) {
      $content = h('img', {
        style: variant ? {} : {
          width: '100%',
          height: '100%'
        },
        attrs: {
          src: src,
          alt: alt
        },
        on: {
          error: this.onImgError
        }
      });
      $content = h('span', {
        staticClass: 'b-avatar-img'
      }, [$content]);
    } else if (icon) {
      $content = h(__WEBPACK_IMPORTED_MODULE_11__icons_icon__["a" /* BIcon */], {
        props: {
          icon: icon
        },
        attrs: {
          'aria-hidden': 'true',
          alt: alt
        }
      });
    } else if (text) {
      $content = h('span', {
        staticClass: 'b-avatar-text',
        style: fontStyle
      }, [h('span', text)]);
    } else {
      // Fallback default avatar content
      $content = h(__WEBPACK_IMPORTED_MODULE_12__icons_icons__["_962" /* BIconPersonFill */], {
        attrs: {
          'aria-hidden': 'true',
          alt: alt
        }
      });
    }

    var $badge = h();
    var hasBadgeSlot = this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["_10" /* SLOT_NAME_BADGE */]);

    if (badge || badge === '' || hasBadgeSlot) {
      var badgeText = badge === true ? '' : badge;
      $badge = h('span', {
        staticClass: 'b-avatar-badge',
        class: _defineProperty({}, "badge-".concat(badgeVariant), badgeVariant),
        style: badgeStyle
      }, [hasBadgeSlot ? this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["_10" /* SLOT_NAME_BADGE */]) : badgeText]);
    }

    var componentData = {
      staticClass: CLASS_NAME,
      class: (_class2 = {}, _defineProperty(_class2, "".concat(CLASS_NAME, "-").concat(size), size && SIZES.indexOf(size) !== -1), _defineProperty(_class2, "badge-".concat(variant), !button && variant), _defineProperty(_class2, "rounded", rounded === true), _defineProperty(_class2, "rounded-".concat(rounded), rounded && rounded !== true), _defineProperty(_class2, "disabled", disabled), _class2),
      style: _objectSpread(_objectSpread({}, marginStyle), {}, {
        width: size,
        height: size
      }),
      attrs: {
        'aria-label': ariaLabel || null
      },
      props: button ? {
        variant: variant,
        disabled: disabled,
        type: type
      } : link ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["c" /* pluckProps */])(linkProps, this) : {},
      on: button || link ? {
        click: this.onClick
      } : {}
    };
    return h(tag, componentData, [$content, $badge]);
  }
});

/***/ }),
/* 207 */
/* exports provided: props, BBadge */
/* exports used: BBadge */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/badge/badge.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BBadge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_router__ = __webpack_require__(/*! ../../utils/router */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_6__link_link__["b" /* props */], ['event', 'routerTag']);
delete linkProps.href.default;
delete linkProps.to.default;
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, linkProps), {}, {
  pill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'span'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_68" /* NAME_BADGE */]); // --- Main component ---
// @vue/component

var BBadge = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_68" /* NAME_BADGE */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var active = props.active,
        disabled = props.disabled;
    var link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_router__["a" /* isLink */])(props);
    var tag = link ? __WEBPACK_IMPORTED_MODULE_6__link_link__["a" /* BLink */] : props.tag;
    var variant = props.variant || 'secondary';
    return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'badge',
      class: ["badge-".concat(variant), {
        'badge-pill': props.pill,
        active: active,
        disabled: disabled
      }],
      props: link ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["c" /* pluckProps */])(linkProps, props) : {}
    }), children);
  }
});

/***/ }),
/* 208 */
/* exports provided: props, BBreadcrumbItem */
/* exports used: BBreadcrumbItem */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/breadcrumb/breadcrumb-item.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BBreadcrumbItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breadcrumb_link__ = __webpack_require__(/*! ./breadcrumb-link */ 331);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["b" /* makePropsConfigurable */])(__WEBPACK_IMPORTED_MODULE_3__breadcrumb_link__["a" /* props */], __WEBPACK_IMPORTED_MODULE_1__constants_components__["_65" /* NAME_BREADCRUMB_ITEM */]); // --- Main component ---
// @vue/component

var BBreadcrumbItem = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_65" /* NAME_BREADCRUMB_ITEM */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'breadcrumb-item',
      class: {
        active: props.active
      }
    }), [h(__WEBPACK_IMPORTED_MODULE_3__breadcrumb_link__["b" /* BBreadcrumbLink */], {
      props: props
    }, children)]);
  }
});

/***/ }),
/* 209 */
/* exports provided: props, BCalendar */
/* exports used: BCalendar, props */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/calendar/calendar.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCalendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_date__ = __webpack_require__(/*! ../../constants/date */ 448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_date__ = __webpack_require__(/*! ../../utils/date */ 254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_locale__ = __webpack_require__(/*! ../../utils/locale */ 184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_5__constants_props__["t" /* PROP_TYPE_DATE_STRING */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_22__mixins_id__["a" /* props */]), modelProps), {}, {
  ariaControls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Makes calendar the full width of its parent container
  block: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  dateDisabledFn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  // `Intl.DateTimeFormat` object
  dateFormatOptions: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["e" /* PROP_TYPE_OBJECT */], {
    year: __WEBPACK_IMPORTED_MODULE_2__constants_date__["b" /* DATE_FORMAT_NUMERIC */],
    month: __WEBPACK_IMPORTED_MODULE_2__constants_date__["c" /* CALENDAR_LONG */],
    day: __WEBPACK_IMPORTED_MODULE_2__constants_date__["b" /* DATE_FORMAT_NUMERIC */],
    weekday: __WEBPACK_IMPORTED_MODULE_2__constants_date__["c" /* CALENDAR_LONG */]
  }),
  // Function to set a class of (classes) on the date cell
  // if passed a string or an array
  // TODO:
  //   If the function returns an object, look for class prop for classes,
  //   and other props for handling events/details/descriptions
  dateInfoFn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  // 'ltr', 'rtl', or `null` (for auto detect)
  direction: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  headerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'header'),
  // When `true`, renders a comment node, but keeps the component instance active
  // Mainly for <b-form-date>, so that we can get the component's value and locale
  // But we might just use separate date formatters, using the resolved locale
  // (adjusted for the gregorian calendar)
  hidden: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // When `true` makes the selected date header `sr-only`
  hideHeader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // This specifies the calendar year/month/day that will be shown when
  // first opening the datepicker if no v-model value is provided
  // Default is the current date (or `min`/`max`)
  initialDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["t" /* PROP_TYPE_DATE_STRING */]),
  // Labels for buttons and keyboard shortcuts
  labelCalendar: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Calendar'),
  labelCurrentMonth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Current month'),
  labelHelp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Use cursor keys to navigate calendar dates'),
  labelNav: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Calendar navigation'),
  labelNextDecade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Next decade'),
  labelNextMonth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Next month'),
  labelNextYear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Next year'),
  labelNoDateSelected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'No date selected'),
  labelPrevDecade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Previous decade'),
  labelPrevMonth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Previous month'),
  labelPrevYear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Previous year'),
  labelSelected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Selected date'),
  labelToday: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Today'),
  // Locale(s) to use
  // Default is to use page/browser default setting
  locale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  max: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["t" /* PROP_TYPE_DATE_STRING */]),
  min: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["t" /* PROP_TYPE_DATE_STRING */]),
  // Variant color to use for the navigation buttons
  navButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary'),
  // Disable highlighting today's date
  noHighlightToday: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noKeyNav: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  readonly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  roleDescription: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Variant color to use for the selected date
  selectedVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'primary'),
  // When `true` enables the decade navigation buttons
  showDecadeNav: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Day of week to start calendar on
  // `0` (Sunday), `1` (Monday), ... `6` (Saturday)
  startWeekday: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  // Variant color to use for today's date (defaults to `selectedVariant`)
  todayVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Always return the `v-model` value as a date object
  valueAsDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Format of the weekday names at the top of the calendar
  // `short` is typically a 3 letter abbreviation,
  // `narrow` is typically a single letter
  // `long` is the full week day name
  // Although some locales may override this (i.e `ar`, etc.)
  weekdayHeaderFormat: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], __WEBPACK_IMPORTED_MODULE_2__constants_date__["d" /* CALENDAR_SHORT */], function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])([__WEBPACK_IMPORTED_MODULE_2__constants_date__["c" /* CALENDAR_LONG */], __WEBPACK_IMPORTED_MODULE_2__constants_date__["d" /* CALENDAR_SHORT */], __WEBPACK_IMPORTED_MODULE_2__constants_date__["e" /* CALENDAR_NARROW */]], value);
  }),
  // Has no effect if prop `block` is set
  width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], '270px')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_33" /* NAME_CALENDAR */]); // --- Main component ---
// @vue/component

var BCalendar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_33" /* NAME_CALENDAR */],
  // Mixin order is important!
  mixins: [__WEBPACK_IMPORTED_MODULE_21__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_22__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_23__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    var selected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this[MODEL_PROP_NAME]) || '';
    return {
      // Selected date
      selectedYMD: selected,
      // Date in calendar grid that has `tabindex` of `0`
      activeYMD: selected || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["d" /* constrainDate */])(this.initialDate || this.getToday()), this.min, this.max),
      // Will be true if the calendar grid has/contains focus
      gridHasFocus: false,
      // Flag to enable the `aria-live` region(s) after mount
      // to prevent screen reader "outbursts" when mounting
      isLive: false
    };
  },
  computed: {
    valueId: function valueId() {
      return this.safeId();
    },
    widgetId: function widgetId() {
      return this.safeId('_calendar-wrapper_');
    },
    navId: function navId() {
      return this.safeId('_calendar-nav_');
    },
    gridId: function gridId() {
      return this.safeId('_calendar-grid_');
    },
    gridCaptionId: function gridCaptionId() {
      return this.safeId('_calendar-grid-caption_');
    },
    gridHelpId: function gridHelpId() {
      return this.safeId('_calendar-grid-help_');
    },
    activeId: function activeId() {
      return this.activeYMD ? this.safeId("_cell-".concat(this.activeYMD, "_")) : null;
    },
    // TODO: Use computed props to convert `YYYY-MM-DD` to `Date` object
    selectedDate: function selectedDate() {
      // Selected as a `Date` object
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(this.selectedYMD);
    },
    activeDate: function activeDate() {
      // Active as a `Date` object
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(this.activeYMD);
    },
    computedMin: function computedMin() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(this.min);
    },
    computedMax: function computedMax() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(this.max);
    },
    computedWeekStarts: function computedWeekStarts() {
      // `startWeekday` is a prop (constrained to `0` through `6`)
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_number__["b" /* toInteger */])(this.startWeekday, 0), 0) % 7;
    },
    computedLocale: function computedLocale() {
      // Returns the resolved locale used by the calendar
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["f" /* resolveLocale */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b" /* concat */])(this.locale).filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]), __WEBPACK_IMPORTED_MODULE_2__constants_date__["a" /* CALENDAR_GREGORY */]);
    },
    computedDateDisabledFn: function computedDateDisabledFn() {
      var dateDisabledFn = this.dateDisabledFn;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["d" /* hasPropFunction */])(dateDisabledFn) ? dateDisabledFn : function () {
        return false;
      };
    },
    // TODO: Change `dateInfoFn` to handle events and notes as well as classes
    computedDateInfoFn: function computedDateInfoFn() {
      var dateInfoFn = this.dateInfoFn;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["d" /* hasPropFunction */])(dateInfoFn) ? dateInfoFn : function () {
        return {};
      };
    },
    calendarLocale: function calendarLocale() {
      // This locale enforces the gregorian calendar (for use in formatter functions)
      // Needed because IE 11 resolves `ar-IR` as islamic-civil calendar
      // and IE 11 (and some other browsers) do not support the `calendar` option
      // And we currently only support the gregorian calendar
      var fmt = new Intl.DateTimeFormat(this.computedLocale, {
        calendar: __WEBPACK_IMPORTED_MODULE_2__constants_date__["a" /* CALENDAR_GREGORY */]
      });
      var calendar = fmt.resolvedOptions().calendar;
      var locale = fmt.resolvedOptions().locale;
      /* istanbul ignore if: mainly for IE 11 and a few other browsers, hard to test in JSDOM */

      if (calendar !== __WEBPACK_IMPORTED_MODULE_2__constants_date__["a" /* CALENDAR_GREGORY */]) {
        // Ensure the locale requests the gregorian calendar
        // Mainly for IE 11, and currently we can't handle non-gregorian calendars
        // TODO: Should we always return this value?
        locale = locale.replace(/-u-.+$/i, '').concat('-u-ca-gregory');
      }

      return locale;
    },
    calendarYear: function calendarYear() {
      return this.activeDate.getFullYear();
    },
    calendarMonth: function calendarMonth() {
      return this.activeDate.getMonth();
    },
    calendarFirstDay: function calendarFirstDay() {
      // We set the time for this date to 12pm to work around
      // date formatting issues in Firefox and Safari
      // See: https://github.com/bootstrap-vue/bootstrap-vue/issues/5818
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(this.calendarYear, this.calendarMonth, 1, 12);
    },
    calendarDaysInMonth: function calendarDaysInMonth() {
      // We create a new date as to not mutate the original
      var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(this.calendarFirstDay);
      date.setMonth(date.getMonth() + 1, 0);
      return date.getDate();
    },
    computedVariant: function computedVariant() {
      return "btn-".concat(this.selectedVariant || 'primary');
    },
    computedTodayVariant: function computedTodayVariant() {
      return "btn-outline-".concat(this.todayVariant || this.selectedVariant || 'primary');
    },
    computedNavButtonVariant: function computedNavButtonVariant() {
      return "btn-outline-".concat(this.navButtonVariant || 'primary');
    },
    isRTL: function isRTL() {
      // `true` if the language requested is RTL
      var dir = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_string__["a" /* toString */])(this.direction).toLowerCase();

      if (dir === 'rtl') {
        /* istanbul ignore next */
        return true;
      } else if (dir === 'ltr') {
        /* istanbul ignore next */
        return false;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_locale__["a" /* isLocaleRTL */])(this.computedLocale);
    },
    context: function context() {
      var selectedYMD = this.selectedYMD,
          activeYMD = this.activeYMD;
      var selectedDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(selectedYMD);
      var activeDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(activeYMD);
      return {
        // The current value of the `v-model`
        selectedYMD: selectedYMD,
        selectedDate: selectedDate,
        selectedFormatted: selectedDate ? this.formatDateString(selectedDate) : this.labelNoDateSelected,
        // Which date cell is considered active due to navigation
        activeYMD: activeYMD,
        activeDate: activeDate,
        activeFormatted: activeDate ? this.formatDateString(activeDate) : '',
        // `true` if the date is disabled (when using keyboard navigation)
        disabled: this.dateDisabled(activeDate),
        // Locales used in formatting dates
        locale: this.computedLocale,
        calendarLocale: this.calendarLocale,
        rtl: this.isRTL
      };
    },
    // Computed props that return a function reference
    dateOutOfRange: function dateOutOfRange() {
      // Check whether a date is within the min/max range
      // Returns a new function ref if the pops change
      // We do this as we need to trigger the calendar computed prop
      // to update when these props update
      var min = this.computedMin,
          max = this.computedMax;
      return function (date) {
        // Handle both `YYYY-MM-DD` and `Date` objects
        date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(date);
        return min && date < min || max && date > max;
      };
    },
    dateDisabled: function dateDisabled() {
      var _this = this;

      // Returns a function for validating if a date is within range
      // We grab this variables first to ensure a new function ref
      // is generated when the props value changes
      // We do this as we need to trigger the calendar computed prop
      // to update when these props update
      var rangeFn = this.dateOutOfRange; // Return the function ref

      return function (date) {
        // Handle both `YYYY-MM-DD` and `Date` objects
        date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(date);
        var ymd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(date);
        return !!(rangeFn(date) || _this.computedDateDisabledFn(ymd, date));
      };
    },
    // Computed props that return date formatter functions
    formatDateString: function formatDateString() {
      // Returns a date formatter function
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["a" /* createDateFormatter */])(this.calendarLocale, _objectSpread(_objectSpread({
        // Ensure we have year, month, day shown for screen readers/ARIA
        // If users really want to leave one of these out, they can
        // pass `undefined` for the property value
        year: __WEBPACK_IMPORTED_MODULE_2__constants_date__["b" /* DATE_FORMAT_NUMERIC */],
        month: __WEBPACK_IMPORTED_MODULE_2__constants_date__["f" /* DATE_FORMAT_2_DIGIT */],
        day: __WEBPACK_IMPORTED_MODULE_2__constants_date__["f" /* DATE_FORMAT_2_DIGIT */]
      }, this.dateFormatOptions), {}, {
        // Ensure hours/minutes/seconds are not shown
        // As we do not support the time portion (yet)
        hour: undefined,
        minute: undefined,
        second: undefined,
        // Ensure calendar is gregorian
        calendar: __WEBPACK_IMPORTED_MODULE_2__constants_date__["a" /* CALENDAR_GREGORY */]
      }));
    },
    formatYearMonth: function formatYearMonth() {
      // Returns a date formatter function
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["a" /* createDateFormatter */])(this.calendarLocale, {
        year: __WEBPACK_IMPORTED_MODULE_2__constants_date__["b" /* DATE_FORMAT_NUMERIC */],
        month: __WEBPACK_IMPORTED_MODULE_2__constants_date__["c" /* CALENDAR_LONG */],
        calendar: __WEBPACK_IMPORTED_MODULE_2__constants_date__["a" /* CALENDAR_GREGORY */]
      });
    },
    formatWeekdayName: function formatWeekdayName() {
      // Long weekday name for weekday header aria-label
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["a" /* createDateFormatter */])(this.calendarLocale, {
        weekday: __WEBPACK_IMPORTED_MODULE_2__constants_date__["c" /* CALENDAR_LONG */],
        calendar: __WEBPACK_IMPORTED_MODULE_2__constants_date__["a" /* CALENDAR_GREGORY */]
      });
    },
    formatWeekdayNameShort: function formatWeekdayNameShort() {
      // Weekday header cell format
      // defaults to 'short' 3 letter days, where possible
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["a" /* createDateFormatter */])(this.calendarLocale, {
        weekday: this.weekdayHeaderFormat || __WEBPACK_IMPORTED_MODULE_2__constants_date__["d" /* CALENDAR_SHORT */],
        calendar: __WEBPACK_IMPORTED_MODULE_2__constants_date__["a" /* CALENDAR_GREGORY */]
      });
    },
    formatDay: function formatDay() {
      // Calendar grid day number formatter
      // We don't use DateTimeFormatter here as it can place extra
      // character(s) after the number (i.e the `zh` locale)
      var nf = new Intl.NumberFormat([this.computedLocale], {
        style: 'decimal',
        minimumIntegerDigits: 1,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        notation: 'standard'
      }); // Return a formatter function instance

      return function (date) {
        return nf.format(date.getDate());
      };
    },
    // Disabled states for the nav buttons
    prevDecadeDisabled: function prevDecadeDisabled() {
      var min = this.computedMin;
      return this.disabled || min && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["g" /* lastDateOfMonth */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["h" /* oneDecadeAgo */])(this.activeDate)) < min;
    },
    prevYearDisabled: function prevYearDisabled() {
      var min = this.computedMin;
      return this.disabled || min && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["g" /* lastDateOfMonth */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["i" /* oneYearAgo */])(this.activeDate)) < min;
    },
    prevMonthDisabled: function prevMonthDisabled() {
      var min = this.computedMin;
      return this.disabled || min && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["g" /* lastDateOfMonth */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["j" /* oneMonthAgo */])(this.activeDate)) < min;
    },
    thisMonthDisabled: function thisMonthDisabled() {
      // TODO: We could/should check if today is out of range
      return this.disabled;
    },
    nextMonthDisabled: function nextMonthDisabled() {
      var max = this.computedMax;
      return this.disabled || max && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["k" /* firstDateOfMonth */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["l" /* oneMonthAhead */])(this.activeDate)) > max;
    },
    nextYearDisabled: function nextYearDisabled() {
      var max = this.computedMax;
      return this.disabled || max && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["k" /* firstDateOfMonth */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["m" /* oneYearAhead */])(this.activeDate)) > max;
    },
    nextDecadeDisabled: function nextDecadeDisabled() {
      var max = this.computedMax;
      return this.disabled || max && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["k" /* firstDateOfMonth */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["n" /* oneDecadeAhead */])(this.activeDate)) > max;
    },
    // Calendar dates generation
    calendar: function calendar() {
      var matrix = [];
      var firstDay = this.calendarFirstDay;
      var calendarYear = firstDay.getFullYear();
      var calendarMonth = firstDay.getMonth();
      var daysInMonth = this.calendarDaysInMonth;
      var startIndex = firstDay.getDay(); // `0`..`6`

      var weekOffset = (this.computedWeekStarts > startIndex ? 7 : 0) - this.computedWeekStarts; // Build the calendar matrix

      var currentDay = 0 - weekOffset - startIndex;

      for (var week = 0; week < 6 && currentDay < daysInMonth; week++) {
        // For each week
        matrix[week] = []; // The following could be a map function

        for (var j = 0; j < 7; j++) {
          // For each day in week
          currentDay++;
          var date = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(calendarYear, calendarMonth, currentDay);
          var month = date.getMonth();
          var dayYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(date);
          var dayDisabled = this.dateDisabled(date); // TODO: This could be a normalizer method

          var dateInfo = this.computedDateInfoFn(dayYMD, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(dayYMD));
          dateInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["f" /* isString */])(dateInfo) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["c" /* isArray */])(dateInfo) ?
          /* istanbul ignore next */
          {
            class: dateInfo
          } : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["h" /* isPlainObject */])(dateInfo) ? _objectSpread({
            class: ''
          }, dateInfo) :
          /* istanbul ignore next */
          {
            class: ''
          };
          matrix[week].push({
            ymd: dayYMD,
            // Cell content
            day: this.formatDay(date),
            label: this.formatDateString(date),
            // Flags for styling
            isThisMonth: month === calendarMonth,
            isDisabled: dayDisabled,
            // TODO: Handle other dateInfo properties such as notes/events
            info: dateInfo
          });
        }
      }

      return matrix;
    },
    calendarHeadings: function calendarHeadings() {
      var _this2 = this;

      return this.calendar[0].map(function (d) {
        return {
          text: _this2.formatWeekdayNameShort(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(d.ymd)),
          label: _this2.formatWeekdayName(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(d.ymd))
        };
      });
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue, oldValue) {
    var selected = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(newValue) || '';
    var old = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(oldValue) || '';

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["o" /* datesEqual */])(selected, old)) {
      this.activeYMD = selected || this.activeYMD;
      this.selectedYMD = selected;
    }
  }), _defineProperty(_watch, "selectedYMD", function selectedYMD(newYMD, oldYMD) {
    // TODO:
    //   Should we compare to `formatYMD(this.value)` and emit
    //   only if they are different?
    if (newYMD !== oldYMD) {
      this.$emit(MODEL_EVENT_NAME, this.valueAsDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(newYMD) || null : newYMD || '');
    }
  }), _defineProperty(_watch, "context", function context(newValue, oldValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["z" /* EVENT_NAME_CONTEXT */], newValue);
    }
  }), _defineProperty(_watch, "hidden", function hidden(newValue) {
    // Reset the active focused day when hidden
    this.activeYMD = this.selectedYMD || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this[MODEL_PROP_NAME] || this.constrainDate(this.initialDate || this.getToday())); // Enable/disable the live regions

    this.setLive(!newValue);
  }), _watch),
  created: function created() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["z" /* EVENT_NAME_CONTEXT */], _this3.context);
    });
  },
  mounted: function mounted() {
    this.setLive(true);
  },

  /* istanbul ignore next */
  activated: function activated() {
    this.setLive(true);
  },

  /* istanbul ignore next */
  deactivated: function deactivated() {
    this.setLive(false);
  },
  beforeDestroy: function beforeDestroy() {
    this.setLive(false);
  },
  methods: {
    // Public method(s)
    focus: function focus() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(this.$refs.grid);
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["A" /* attemptBlur */])(this.$refs.grid);
      }
    },
    // Private methods
    setLive: function setLive(on) {
      var _this4 = this;

      if (on) {
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
            _this4.isLive = true;
          });
        });
      } else {
        this.isLive = false;
      }
    },
    getToday: function getToday() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])());
    },
    constrainDate: function constrainDate(date) {
      // Constrains a date between min and max
      // returns a new `Date` object instance
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["d" /* constrainDate */])(date, this.computedMin, this.computedMax);
    },
    emitSelected: function emitSelected(date) {
      var _this5 = this;

      // Performed in a `$nextTick()` to (probably) ensure
      // the input event has emitted first
      this.$nextTick(function () {
        _this5.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["_2" /* EVENT_NAME_SELECTED */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(date) || '', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(date) || null);
      });
    },
    // Event handlers
    setGridFocusFlag: function setGridFocusFlag(event) {
      // Sets the gridHasFocus flag to make date "button" look focused
      this.gridHasFocus = !this.disabled && event.type === 'focus';
    },
    onKeydownWrapper: function onKeydownWrapper(event) {
      // Calendar keyboard navigation
      // Handles PAGEUP/PAGEDOWN/END/HOME/LEFT/UP/RIGHT/DOWN
      // Focuses grid after updating
      if (this.noKeyNav) {
        /* istanbul ignore next */
        return;
      }

      var altKey = event.altKey,
          ctrlKey = event.ctrlKey,
          keyCode = event.keyCode;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])([__WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["i" /* CODE_PAGEUP */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["j" /* CODE_PAGEDOWN */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["h" /* CODE_END */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["g" /* CODE_HOME */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["c" /* CODE_LEFT */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["d" /* CODE_RIGHT */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */]], keyCode)) {
        /* istanbul ignore next */
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event);
      var activeDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(this.activeDate);
      var checkDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(this.activeDate);
      var day = activeDate.getDate();
      var constrainedToday = this.constrainDate(this.getToday());
      var isRTL = this.isRTL;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["i" /* CODE_PAGEUP */]) {
        // PAGEUP - Previous month/year
        activeDate = (altKey ? ctrlKey ? __WEBPACK_IMPORTED_MODULE_8__utils_date__["h" /* oneDecadeAgo */] : __WEBPACK_IMPORTED_MODULE_8__utils_date__["i" /* oneYearAgo */] : __WEBPACK_IMPORTED_MODULE_8__utils_date__["j" /* oneMonthAgo */])(activeDate); // We check the first day of month to be in rage

        checkDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(activeDate);
        checkDate.setDate(1);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["j" /* CODE_PAGEDOWN */]) {
        // PAGEDOWN - Next month/year
        activeDate = (altKey ? ctrlKey ? __WEBPACK_IMPORTED_MODULE_8__utils_date__["n" /* oneDecadeAhead */] : __WEBPACK_IMPORTED_MODULE_8__utils_date__["m" /* oneYearAhead */] : __WEBPACK_IMPORTED_MODULE_8__utils_date__["l" /* oneMonthAhead */])(activeDate); // We check the last day of month to be in rage

        checkDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(activeDate);
        checkDate.setMonth(checkDate.getMonth() + 1);
        checkDate.setDate(0);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["c" /* CODE_LEFT */]) {
        // LEFT - Previous day (or next day for RTL)
        activeDate.setDate(day + (isRTL ? 1 : -1));
        activeDate = this.constrainDate(activeDate);
        checkDate = activeDate;
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["d" /* CODE_RIGHT */]) {
        // RIGHT - Next day (or previous day for RTL)
        activeDate.setDate(day + (isRTL ? -1 : 1));
        activeDate = this.constrainDate(activeDate);
        checkDate = activeDate;
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */]) {
        // UP - Previous week
        activeDate.setDate(day - 7);
        activeDate = this.constrainDate(activeDate);
        checkDate = activeDate;
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */]) {
        // DOWN - Next week
        activeDate.setDate(day + 7);
        activeDate = this.constrainDate(activeDate);
        checkDate = activeDate;
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["g" /* CODE_HOME */]) {
        // HOME - Today
        activeDate = constrainedToday;
        checkDate = activeDate;
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["h" /* CODE_END */]) {
        // END - Selected date, or today if no selected date
        activeDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(this.selectedDate) || constrainedToday;
        checkDate = activeDate;
      }

      if (!this.dateOutOfRange(checkDate) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["o" /* datesEqual */])(activeDate, this.activeDate)) {
        // We only jump to date if within min/max
        // We don't check for individual disabled dates though (via user function)
        this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(activeDate);
      } // Ensure grid is focused


      this.focus();
    },
    onKeydownGrid: function onKeydownGrid(event) {
      // Pressing enter/space on grid to select active date
      var keyCode = event.keyCode;
      var activeDate = this.activeDate;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["a" /* CODE_ENTER */] || keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["b" /* CODE_SPACE */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event);

        if (!this.disabled && !this.readonly && !this.dateDisabled(activeDate)) {
          this.selectedYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(activeDate);
          this.emitSelected(activeDate);
        } // Ensure grid is focused


        this.focus();
      }
    },
    onClickDay: function onClickDay(day) {
      // Clicking on a date "button" to select it
      var selectedDate = this.selectedDate,
          activeDate = this.activeDate;
      var clickedDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["e" /* parseYMD */])(day.ymd);

      if (!this.disabled && !day.isDisabled && !this.dateDisabled(clickedDate)) {
        if (!this.readonly) {
          // If readonly mode, we don't set the selected date, just the active date
          // If the clicked date is equal to the already selected date, we don't update the model
          this.selectedYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["o" /* datesEqual */])(clickedDate, selectedDate) ? selectedDate : clickedDate);
          this.emitSelected(clickedDate);
        }

        this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["o" /* datesEqual */])(clickedDate, activeDate) ? activeDate : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["b" /* createDate */])(clickedDate)); // Ensure grid is focused

        this.focus();
      }
    },
    gotoPrevDecade: function gotoPrevDecade() {
      this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.constrainDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["h" /* oneDecadeAgo */])(this.activeDate)));
    },
    gotoPrevYear: function gotoPrevYear() {
      this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.constrainDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["i" /* oneYearAgo */])(this.activeDate)));
    },
    gotoPrevMonth: function gotoPrevMonth() {
      this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.constrainDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["j" /* oneMonthAgo */])(this.activeDate)));
    },
    gotoCurrentMonth: function gotoCurrentMonth() {
      // TODO: Maybe this goto date should be configurable?
      this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.constrainDate(this.getToday()));
    },
    gotoNextMonth: function gotoNextMonth() {
      this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.constrainDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["l" /* oneMonthAhead */])(this.activeDate)));
    },
    gotoNextYear: function gotoNextYear() {
      this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.constrainDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["m" /* oneYearAhead */])(this.activeDate)));
    },
    gotoNextDecade: function gotoNextDecade() {
      this.activeYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.constrainDate(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["n" /* oneDecadeAhead */])(this.activeDate)));
    },
    onHeaderClick: function onHeaderClick() {
      if (!this.disabled) {
        this.activeYMD = this.selectedYMD || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.getToday());
        this.focus();
      }
    }
  },
  render: function render(h) {
    var _this6 = this;

    // If `hidden` prop is set, render just a placeholder node
    if (this.hidden) {
      return h();
    }

    var valueId = this.valueId,
        widgetId = this.widgetId,
        navId = this.navId,
        gridId = this.gridId,
        gridCaptionId = this.gridCaptionId,
        gridHelpId = this.gridHelpId,
        activeId = this.activeId,
        disabled = this.disabled,
        noKeyNav = this.noKeyNav,
        isLive = this.isLive,
        isRTL = this.isRTL,
        activeYMD = this.activeYMD,
        selectedYMD = this.selectedYMD,
        safeId = this.safeId;
    var hideDecadeNav = !this.showDecadeNav;
    var todayYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_date__["c" /* formatYMD */])(this.getToday());
    var highlightToday = !this.noHighlightToday; // Header showing current selected date

    var $header = h('output', {
      staticClass: 'form-control form-control-sm text-center',
      class: {
        'text-muted': disabled,
        readonly: this.readonly || disabled
      },
      attrs: {
        id: valueId,
        for: gridId,
        role: 'status',
        tabindex: disabled ? null : '-1',
        // Mainly for testing purposes, as we do not know
        // the exact format `Intl` will format the date string
        'data-selected': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_string__["a" /* toString */])(selectedYMD),
        // We wait until after mount to enable `aria-live`
        // to prevent initial announcement on page render
        'aria-live': isLive ? 'polite' : 'off',
        'aria-atomic': isLive ? 'true' : null
      },
      on: {
        // Transfer focus/click to focus grid
        // and focus active date (or today if no selection)
        click: this.onHeaderClick,
        focus: this.onHeaderClick
      }
    }, this.selectedDate ? [// We use `bdi` elements here in case the label doesn't match the locale
    // Although IE 11 does not deal with <BDI> at all (equivalent to a span)
    h('bdi', {
      staticClass: 'sr-only'
    }, " (".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_string__["a" /* toString */])(this.labelSelected), ") ")), h('bdi', this.formatDateString(this.selectedDate))] : this.labelNoDateSelected || "\xA0" // '&nbsp;'
    );
    $header = h(this.headerTag, {
      staticClass: 'b-calendar-header',
      class: {
        'sr-only': this.hideHeader
      },
      attrs: {
        title: this.selectedDate ? this.labelSelected || null : null
      }
    }, [$header]); // Content for the date navigation buttons

    var navScope = {
      isRTL: isRTL
    };
    var navProps = {
      shiftV: 0.5
    };

    var navPrevProps = _objectSpread(_objectSpread({}, navProps), {}, {
      flipH: isRTL
    });

    var navNextProps = _objectSpread(_objectSpread({}, navProps), {}, {
      flipH: !isRTL
    });

    var $prevDecadeIcon = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["_2" /* SLOT_NAME_NAV_PEV_DECADE */], navScope) || h(__WEBPACK_IMPORTED_MODULE_24__icons_icons__["_328" /* BIconChevronBarLeft */], {
      props: navPrevProps
    });
    var $prevYearIcon = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["_3" /* SLOT_NAME_NAV_PEV_YEAR */], navScope) || h(__WEBPACK_IMPORTED_MODULE_24__icons_icons__["_337" /* BIconChevronDoubleLeft */], {
      props: navPrevProps
    });
    var $prevMonthIcon = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["_4" /* SLOT_NAME_NAV_PEV_MONTH */], navScope) || h(__WEBPACK_IMPORTED_MODULE_24__icons_icons__["_342" /* BIconChevronLeft */], {
      props: navPrevProps
    });
    var $thisMonthIcon = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["_5" /* SLOT_NAME_NAV_THIS_MONTH */], navScope) || h(__WEBPACK_IMPORTED_MODULE_24__icons_icons__["_346" /* BIconCircleFill */], {
      props: navProps
    });
    var $nextMonthIcon = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["_6" /* SLOT_NAME_NAV_NEXT_MONTH */], navScope) || h(__WEBPACK_IMPORTED_MODULE_24__icons_icons__["_342" /* BIconChevronLeft */], {
      props: navNextProps
    });
    var $nextYearIcon = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["_7" /* SLOT_NAME_NAV_NEXT_YEAR */], navScope) || h(__WEBPACK_IMPORTED_MODULE_24__icons_icons__["_337" /* BIconChevronDoubleLeft */], {
      props: navNextProps
    });
    var $nextDecadeIcon = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["_8" /* SLOT_NAME_NAV_NEXT_DECADE */], navScope) || h(__WEBPACK_IMPORTED_MODULE_24__icons_icons__["_328" /* BIconChevronBarLeft */], {
      props: navNextProps
    }); // Utility to create the date navigation buttons

    var makeNavBtn = function makeNavBtn(content, label, handler, btnDisabled, shortcut) {
      return h('button', {
        staticClass: 'btn btn-sm border-0 flex-fill',
        class: [_this6.computedNavButtonVariant, {
          disabled: btnDisabled
        }],
        attrs: {
          title: label || null,
          type: 'button',
          tabindex: noKeyNav ? '-1' : null,
          'aria-label': label || null,
          'aria-disabled': btnDisabled ? 'true' : null,
          'aria-keyshortcuts': shortcut || null
        },
        on: btnDisabled ? {} : {
          click: handler
        }
      }, [h('div', {
        attrs: {
          'aria-hidden': 'true'
        }
      }, [content])]);
    }; // Generate the date navigation buttons


    var $nav = h('div', {
      staticClass: 'b-calendar-nav d-flex',
      attrs: {
        id: navId,
        role: 'group',
        tabindex: noKeyNav ? '-1' : null,
        'aria-hidden': disabled ? 'true' : null,
        'aria-label': this.labelNav || null,
        'aria-controls': gridId
      }
    }, [hideDecadeNav ? h() : makeNavBtn($prevDecadeIcon, this.labelPrevDecade, this.gotoPrevDecade, this.prevDecadeDisabled, 'Ctrl+Alt+PageDown'), makeNavBtn($prevYearIcon, this.labelPrevYear, this.gotoPrevYear, this.prevYearDisabled, 'Alt+PageDown'), makeNavBtn($prevMonthIcon, this.labelPrevMonth, this.gotoPrevMonth, this.prevMonthDisabled, 'PageDown'), makeNavBtn($thisMonthIcon, this.labelCurrentMonth, this.gotoCurrentMonth, this.thisMonthDisabled, 'Home'), makeNavBtn($nextMonthIcon, this.labelNextMonth, this.gotoNextMonth, this.nextMonthDisabled, 'PageUp'), makeNavBtn($nextYearIcon, this.labelNextYear, this.gotoNextYear, this.nextYearDisabled, 'Alt+PageUp'), hideDecadeNav ? h() : makeNavBtn($nextDecadeIcon, this.labelNextDecade, this.gotoNextDecade, this.nextDecadeDisabled, 'Ctrl+Alt+PageUp')]); // Caption for calendar grid

    var $gridCaption = h('div', {
      staticClass: 'b-calendar-grid-caption text-center font-weight-bold',
      class: {
        'text-muted': disabled
      },
      attrs: {
        id: gridCaptionId,
        'aria-live': isLive ? 'polite' : null,
        'aria-atomic': isLive ? 'true' : null
      },
      key: 'grid-caption'
    }, this.formatYearMonth(this.calendarFirstDay)); // Calendar weekday headings

    var $gridWeekDays = h('div', {
      staticClass: 'b-calendar-grid-weekdays row no-gutters border-bottom',
      attrs: {
        'aria-hidden': 'true'
      }
    }, this.calendarHeadings.map(function (d, idx) {
      return h('small', {
        staticClass: 'col text-truncate',
        class: {
          'text-muted': disabled
        },
        attrs: {
          title: d.label === d.text ? null : d.label,
          'aria-label': d.label
        },
        key: idx
      }, d.text);
    })); // Calendar day grid

    var $gridBody = this.calendar.map(function (week) {
      var $cells = week.map(function (day, dIndex) {
        var _class;

        var isSelected = day.ymd === selectedYMD;
        var isActive = day.ymd === activeYMD;
        var isToday = day.ymd === todayYMD;
        var idCell = safeId("_cell-".concat(day.ymd, "_")); // "fake" button

        var $btn = h('span', {
          staticClass: 'btn border-0 rounded-circle text-nowrap',
          // Should we add some classes to signify if today/selected/etc?
          class: (_class = {
            // Give the fake button a focus ring
            focus: isActive && _this6.gridHasFocus,
            // Styling
            disabled: day.isDisabled || disabled,
            active: isSelected
          }, _defineProperty(_class, _this6.computedVariant, isSelected), _defineProperty(_class, _this6.computedTodayVariant, isToday && highlightToday && !isSelected && day.isThisMonth), _defineProperty(_class, 'btn-outline-light', !(isToday && highlightToday) && !isSelected && !isActive), _defineProperty(_class, 'btn-light', !(isToday && highlightToday) && !isSelected && isActive), _defineProperty(_class, 'text-muted', !day.isThisMonth && !isSelected), _defineProperty(_class, 'text-dark', !(isToday && highlightToday) && !isSelected && !isActive && day.isThisMonth), _defineProperty(_class, 'font-weight-bold', (isSelected || day.isThisMonth) && !day.isDisabled), _class),
          on: {
            click: function click() {
              return _this6.onClickDay(day);
            }
          }
        }, day.day);
        return h('div', // Cell with button
        {
          staticClass: 'col p-0',
          class: day.isDisabled ? 'bg-light' : day.info.class || '',
          attrs: {
            id: idCell,
            role: 'button',
            'data-date': day.ymd,
            // Primarily for testing purposes
            // Only days in the month are presented as buttons to screen readers
            'aria-hidden': day.isThisMonth ? null : 'true',
            'aria-disabled': day.isDisabled || disabled ? 'true' : null,
            'aria-label': [day.label, isSelected ? "(".concat(_this6.labelSelected, ")") : null, isToday ? "(".concat(_this6.labelToday, ")") : null].filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]).join(' '),
            // NVDA doesn't convey `aria-selected`, but does `aria-current`,
            // ChromeVox doesn't convey `aria-current`, but does `aria-selected`,
            // so we set both attributes for robustness
            'aria-selected': isSelected ? 'true' : null,
            'aria-current': isSelected ? 'date' : null
          },
          key: dIndex
        }, [$btn]);
      }); // Return the week "row"
      // We use the first day of the weeks YMD value as a
      // key for efficient DOM patching / element re-use

      return h('div', {
        staticClass: 'row no-gutters',
        key: week[0].ymd
      }, $cells);
    });
    $gridBody = h('div', {
      // A key is only required on the body if we add in transition support
      staticClass: 'b-calendar-grid-body',
      style: disabled ? {
        pointerEvents: 'none'
      } : {} // key: this.activeYMD.slice(0, -3)

    }, $gridBody);
    var $gridHelp = h('div', {
      staticClass: 'b-calendar-grid-help border-top small text-muted text-center bg-light',
      attrs: {
        id: gridHelpId
      }
    }, [h('div', {
      staticClass: 'small'
    }, this.labelHelp)]);
    var $grid = h('div', {
      staticClass: 'b-calendar-grid form-control h-auto text-center',
      attrs: {
        id: gridId,
        role: 'application',
        tabindex: noKeyNav ? '-1' : disabled ? null : '0',
        'data-month': activeYMD.slice(0, -3),
        // `YYYY-MM`, mainly for testing
        'aria-roledescription': this.labelCalendar || null,
        'aria-labelledby': gridCaptionId,
        'aria-describedby': gridHelpId,
        // `aria-readonly` is not considered valid on `role="application"`
        // https://www.w3.org/TR/wai-aria-1.1/#aria-readonly
        // 'aria-readonly': this.readonly && !disabled ? 'true' : null,
        'aria-disabled': disabled ? 'true' : null,
        'aria-activedescendant': activeId
      },
      on: {
        keydown: this.onKeydownGrid,
        focus: this.setGridFocusFlag,
        blur: this.setGridFocusFlag
      },
      ref: 'grid'
    }, [$gridCaption, $gridWeekDays, $gridBody, $gridHelp]); // Optional bottom slot

    var $slot = this.normalizeSlot();
    $slot = $slot ? h('footer', {
      staticClass: 'b-calendar-footer'
    }, $slot) : h();
    var $widget = h('div', {
      staticClass: 'b-calendar-inner',
      style: this.block ? {} : {
        width: this.width
      },
      attrs: {
        id: widgetId,
        dir: isRTL ? 'rtl' : 'ltr',
        lang: this.computedLocale || null,
        role: 'group',
        'aria-disabled': disabled ? 'true' : null,
        // If datepicker controls an input, this will specify the ID of the input
        'aria-controls': this.ariaControls || null,
        // This should be a prop (so it can be changed to Date picker, etc, localized
        'aria-roledescription': this.roleDescription || null,
        'aria-describedby': [// Should the attr (if present) go last?
        // Or should this attr be a prop?
        this.bvAttrs['aria-describedby'], valueId, gridHelpId].filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]).join(' ')
      },
      on: {
        keydown: this.onKeydownWrapper
      }
    }, [$header, $nav, $grid, $slot]); // Wrap in an outer div that can be styled

    return h('div', {
      staticClass: 'b-calendar',
      class: {
        'd-block': this.block
      }
    }, [$widget]);
  }
});

/***/ }),
/* 210 */
/* exports provided: props, BCardBody */
/* exports used: BCardBody, props */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-body.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_card__ = __webpack_require__(/*! ../../mixins/card */ 181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_title__ = __webpack_require__(/*! ./card-title */ 214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card_sub_title__ = __webpack_require__(/*! ./card-sub-title */ 213);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__card_title__["b" /* props */]), __WEBPACK_IMPORTED_MODULE_7__card_sub_title__["b" /* props */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["g" /* copyProps */])(__WEBPACK_IMPORTED_MODULE_5__mixins_card__["a" /* props */], __WEBPACK_IMPORTED_MODULE_4__utils_props__["h" /* prefixPropName */].bind(null, 'body'))), {}, {
  bodyClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  overlay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_60" /* NAME_CARD_BODY */]); // --- Main component ---
// @vue/component

var BCardBody = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_60" /* NAME_CARD_BODY */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var bodyBgVariant = props.bodyBgVariant,
        bodyBorderVariant = props.bodyBorderVariant,
        bodyTextVariant = props.bodyTextVariant;
    var $title = h();

    if (props.title) {
      $title = h(__WEBPACK_IMPORTED_MODULE_6__card_title__["a" /* BCardTitle */], {
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["c" /* pluckProps */])(__WEBPACK_IMPORTED_MODULE_6__card_title__["b" /* props */], props)
      });
    }

    var $subTitle = h();

    if (props.subTitle) {
      $subTitle = h(__WEBPACK_IMPORTED_MODULE_7__card_sub_title__["a" /* BCardSubTitle */], {
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["c" /* pluckProps */])(__WEBPACK_IMPORTED_MODULE_7__card_sub_title__["b" /* props */], props),
        class: ['mb-2']
      });
    }

    return h(props.bodyTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'card-body',
      class: [(_ref2 = {
        'card-img-overlay': props.overlay
      }, _defineProperty(_ref2, "bg-".concat(bodyBgVariant), bodyBgVariant), _defineProperty(_ref2, "border-".concat(bodyBorderVariant), bodyBorderVariant), _defineProperty(_ref2, "text-".concat(bodyTextVariant), bodyTextVariant), _ref2), props.bodyClass]
    }), [$title, $subTitle, children]);
  }
});

/***/ }),
/* 211 */
/* exports provided: props, BCardFooter */
/* exports used: BCardFooter, props */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-footer.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_card__ = __webpack_require__(/*! ../../mixins/card */ 181);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["g" /* copyProps */])(__WEBPACK_IMPORTED_MODULE_6__mixins_card__["a" /* props */], __WEBPACK_IMPORTED_MODULE_5__utils_props__["h" /* prefixPropName */].bind(null, 'footer'))), {}, {
  footer: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  footerClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  footerHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_59" /* NAME_CARD_FOOTER */]); // --- Main component ---
// @vue/component

var BCardFooter = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_59" /* NAME_CARD_FOOTER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var footerBgVariant = props.footerBgVariant,
        footerBorderVariant = props.footerBorderVariant,
        footerTextVariant = props.footerTextVariant;
    return h(props.footerTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'card-footer',
      class: [props.footerClass, (_ref2 = {}, _defineProperty(_ref2, "bg-".concat(footerBgVariant), footerBgVariant), _defineProperty(_ref2, "border-".concat(footerBorderVariant), footerBorderVariant), _defineProperty(_ref2, "text-".concat(footerTextVariant), footerTextVariant), _ref2)],
      domProps: children ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(props.footerHtml, props.footer)
    }), children);
  }
});

/***/ }),
/* 212 */
/* exports provided: props, BCardHeader */
/* exports used: BCardHeader, props */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-header.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_card__ = __webpack_require__(/*! ../../mixins/card */ 181);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["g" /* copyProps */])(__WEBPACK_IMPORTED_MODULE_6__mixins_card__["a" /* props */], __WEBPACK_IMPORTED_MODULE_5__utils_props__["h" /* prefixPropName */].bind(null, 'header'))), {}, {
  header: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  headerHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_56" /* NAME_CARD_HEADER */]); // --- Main component ---
// @vue/component

var BCardHeader = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_56" /* NAME_CARD_HEADER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var headerBgVariant = props.headerBgVariant,
        headerBorderVariant = props.headerBorderVariant,
        headerTextVariant = props.headerTextVariant;
    return h(props.headerTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'card-header',
      class: [props.headerClass, (_ref2 = {}, _defineProperty(_ref2, "bg-".concat(headerBgVariant), headerBgVariant), _defineProperty(_ref2, "border-".concat(headerBorderVariant), headerBorderVariant), _defineProperty(_ref2, "text-".concat(headerTextVariant), headerTextVariant), _ref2)],
      domProps: children ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(props.headerHtml, props.header)
    }), children);
  }
});

/***/ }),
/* 213 */
/* exports provided: props, BCardSubTitle */
/* exports used: BCardSubTitle, props */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-sub-title.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardSubTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  subTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  subTitleTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'h6'),
  subTitleTextVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'muted')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_53" /* NAME_CARD_SUB_TITLE */]); // --- Main component ---
// @vue/component

var BCardSubTitle = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_53" /* NAME_CARD_SUB_TITLE */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.subTitleTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'card-subtitle',
      class: [props.subTitleTextVariant ? "text-".concat(props.subTitleTextVariant) : null]
    }), children || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_string__["a" /* toString */])(props.subTitle));
  }
});

/***/ }),
/* 214 */
/* exports provided: props, BCardTitle */
/* exports used: BCardTitle, props */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-title.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  titleTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'h4')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_51" /* NAME_CARD_TITLE */]); // --- Main component ---
// @vue/component

var BCardTitle = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_51" /* NAME_CARD_TITLE */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.titleTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'card-title'
    }), children || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_string__["a" /* toString */])(props.title));
  }
});

/***/ }),
/* 215 */
/* exports provided: CollapsePlugin, BCollapse */
/* exports used: CollapsePlugin */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/collapse/index.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__collapse__ = __webpack_require__(/*! ./collapse */ 348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_toggle__ = __webpack_require__(/*! ../../directives/toggle */ 179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BCollapse */



var CollapsePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BCollapse: __WEBPACK_IMPORTED_MODULE_0__collapse__["a" /* BCollapse */]
  },
  plugins: {
    VBTogglePlugin: __WEBPACK_IMPORTED_MODULE_1__directives_toggle__["a" /* VBTogglePlugin */]
  }
});


/***/ }),
/* 216 */
/* exports provided: props, BDropdown */
/* exports used: BDropdown, props */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_dropdown__ = __webpack_require__(/*! ../../mixins/dropdown */ 251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__button_button__ = __webpack_require__(/*! ../button/button */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_8__mixins_dropdown__["a" /* props */]), {}, {
  block: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  html: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // If `true`, only render menu contents when open
  lazy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  menuClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  noCaret: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'menu'),
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  split: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  splitButtonType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'button', function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(['button', 'submit', 'reset'], value);
  }),
  splitClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  splitHref: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  splitTo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["j" /* PROP_TYPE_OBJECT_STRING */]),
  splitVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  toggleAttrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */], {}),
  toggleClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  toggleTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'button'),
  // TODO: This really should be `toggleLabel`
  toggleText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'Toggle dropdown'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["U" /* NAME_DROPDOWN */]); // --- Main component ---
// @vue/component

var BDropdown = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["U" /* NAME_DROPDOWN */],
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_8__mixins_dropdown__["b" /* dropdownMixin */], __WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  computed: {
    dropdownClasses: function dropdownClasses() {
      var block = this.block,
          split = this.split;
      return [this.directionClass, this.boundaryClass, {
        show: this.visible,
        // The 'btn-group' class is required in `split` mode for button alignment
        // It needs also to be applied when `block` is disabled to allow multiple
        // dropdowns to be aligned one line
        'btn-group': split || !block,
        // When `block` is enabled and we are in `split` mode the 'd-flex' class
        // needs to be applied to allow the buttons to stretch to full width
        'd-flex': block && split
      }];
    },
    menuClasses: function menuClasses() {
      return [this.menuClass, {
        'dropdown-menu-right': this.right,
        show: this.visible
      }];
    },
    toggleClasses: function toggleClasses() {
      var split = this.split;
      return [this.toggleClass, {
        'dropdown-toggle-split': split,
        'dropdown-toggle-no-caret': this.noCaret && !split
      }];
    }
  },
  render: function render(h) {
    var visible = this.visible,
        variant = this.variant,
        size = this.size,
        block = this.block,
        disabled = this.disabled,
        split = this.split,
        role = this.role,
        hide = this.hide,
        toggle = this.toggle;
    var commonProps = {
      variant: variant,
      size: size,
      block: block,
      disabled: disabled
    };
    var $buttonChildren = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */]);
    var buttonContentDomProps = this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */]) ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_html__["a" /* htmlOrText */])(this.html, this.text);
    var $split = h();

    if (split) {
      var splitTo = this.splitTo,
          splitHref = this.splitHref,
          splitButtonType = this.splitButtonType;

      var btnProps = _objectSpread(_objectSpread({}, commonProps), {}, {
        variant: this.splitVariant || variant
      }); // We add these as needed due to <router-link> issues with
      // defined property with `undefined`/`null` values


      if (splitTo) {
        btnProps.to = splitTo;
      } else if (splitHref) {
        btnProps.href = splitHref;
      } else if (splitButtonType) {
        btnProps.type = splitButtonType;
      }

      $split = h(__WEBPACK_IMPORTED_MODULE_11__button_button__["a" /* BButton */], {
        class: this.splitClass,
        attrs: {
          id: this.safeId('_BV_button_')
        },
        props: btnProps,
        domProps: buttonContentDomProps,
        on: {
          click: this.onSplitClick
        },
        ref: 'button'
      }, $buttonChildren); // Overwrite button content for the toggle when in `split` mode

      $buttonChildren = [h('span', {
        class: ['sr-only']
      }, [this.toggleText])];
      buttonContentDomProps = {};
    }

    var ariaHasPopupRoles = ['menu', 'listbox', 'tree', 'grid', 'dialog'];
    var $toggle = h(__WEBPACK_IMPORTED_MODULE_11__button_button__["a" /* BButton */], {
      staticClass: 'dropdown-toggle',
      class: this.toggleClasses,
      attrs: _objectSpread(_objectSpread({}, this.toggleAttrs), {}, {
        // Must have attributes
        id: this.safeId('_BV_toggle_'),
        'aria-haspopup': ariaHasPopupRoles.includes(role) ? role : 'false',
        'aria-expanded': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_string__["a" /* toString */])(visible)
      }),
      props: _objectSpread(_objectSpread({}, commonProps), {}, {
        tag: this.toggleTag,
        block: block && !split
      }),
      domProps: buttonContentDomProps,
      on: {
        mousedown: this.onMousedown,
        click: toggle,
        keydown: toggle // Handle ENTER, SPACE and DOWN

      },
      ref: 'toggle'
    }, $buttonChildren);
    var $menu = h('ul', {
      staticClass: 'dropdown-menu',
      class: this.menuClasses,
      attrs: {
        role: role,
        tabindex: '-1',
        'aria-labelledby': this.safeId(split ? '_BV_button_' : '_BV_toggle_')
      },
      on: {
        keydown: this.onKeydown // Handle UP, DOWN and ESC

      },
      ref: 'menu'
    }, [!this.lazy || visible ? this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], {
      hide: hide
    }) : h()]);
    return h('div', {
      staticClass: 'dropdown b-dropdown',
      class: this.dropdownClasses,
      attrs: {
        id: this.safeId()
      }
    }, [$split, $toggle, $menu]);
  }
});

/***/ }),
/* 217 */
/* exports provided: props, BFormCheckbox */
/* exports used: BFormCheckbox */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-checkbox/form-checkbox.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormCheckbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_loose_index_of__ = __webpack_require__(/*! ../../utils/loose-index-of */ 958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_form_radio_check__ = __webpack_require__(/*! ../../mixins/form-radio-check */ 458);
var _objectSpread2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Constants ---

var MODEL_PROP_NAME_INDETERMINATE = 'indeterminate';
var MODEL_EVENT_NAME_INDETERMINATE = __WEBPACK_IMPORTED_MODULE_2__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_INDETERMINATE; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__mixins_form_radio_check__["a" /* props */]), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, MODEL_PROP_NAME_INDETERMINATE, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_objectSpread2, "switch", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_objectSpread2, "uncheckedValue", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["f" /* PROP_TYPE_ANY */], false)), _defineProperty(_objectSpread2, "value", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["f" /* PROP_TYPE_ANY */], true)), _objectSpread2))), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_35" /* NAME_FORM_CHECKBOX */]); // --- Main component ---
// @vue/component

var BFormCheckbox = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_35" /* NAME_FORM_CHECKBOX */],
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_form_radio_check__["b" /* formRadioCheckMixin */]],
  inject: {
    getBvGroup: {
      from: 'getBvCheckGroup',
      default: function _default() {
        return function () {
          return null;
        };
      }
    }
  },
  props: props,
  computed: {
    bvGroup: function bvGroup() {
      return this.getBvGroup();
    },
    isChecked: function isChecked() {
      var value = this.value,
          checked = this.computedLocalChecked;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["c" /* isArray */])(checked) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_loose_index_of__["a" /* looseIndexOf */])(checked, value) > -1 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(checked, value);
    },
    isRadio: function isRadio() {
      return false;
    }
  },
  watch: _defineProperty({}, MODEL_PROP_NAME_INDETERMINATE, function (newValue, oldValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      this.setIndeterminate(newValue);
    }
  }),
  mounted: function mounted() {
    // Set initial indeterminate state
    this.setIndeterminate(this[MODEL_PROP_NAME_INDETERMINATE]);
  },
  methods: {
    computedLocalCheckedWatcher: function computedLocalCheckedWatcher(newValue, oldValue) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_9__mixins_form_radio_check__["c" /* MODEL_EVENT_NAME */], newValue);
        var $input = this.$refs.input;

        if ($input) {
          this.$emit(MODEL_EVENT_NAME_INDETERMINATE, $input.indeterminate);
        }
      }
    },
    handleChange: function handleChange(_ref) {
      var _this = this;

      var _ref$target = _ref.target,
          checked = _ref$target.checked,
          indeterminate = _ref$target.indeterminate;
      var value = this.value,
          uncheckedValue = this.uncheckedValue; // Update `computedLocalChecked`

      var localChecked = this.computedLocalChecked;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["c" /* isArray */])(localChecked)) {
        var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_loose_index_of__["a" /* looseIndexOf */])(localChecked, value);

        if (checked && index < 0) {
          // Add value to array
          localChecked = localChecked.concat(value);
        } else if (!checked && index > -1) {
          // Remove value from array
          localChecked = localChecked.slice(0, index).concat(localChecked.slice(index + 1));
        }
      } else {
        localChecked = checked ? value : uncheckedValue;
      }

      this.computedLocalChecked = localChecked; // Fire events in a `$nextTick()` to ensure the `v-model` is updated

      this.$nextTick(function () {
        // Change is only emitted on user interaction
        _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */], localChecked); // If this is a child of a group, we emit a change event on it as well


        if (_this.isGroup) {
          _this.bvGroup.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */], localChecked);
        }

        _this.$emit(MODEL_EVENT_NAME_INDETERMINATE, indeterminate);
      });
    },
    setIndeterminate: function setIndeterminate(state) {
      // Indeterminate only supported in single checkbox mode
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["c" /* isArray */])(this.computedLocalChecked)) {
        state = false;
      }

      var $input = this.$refs.input;

      if ($input) {
        $input.indeterminate = state; // Emit update event to prop

        this.$emit(MODEL_EVENT_NAME_INDETERMINATE, state);
      }
    }
  }
});

/***/ }),
/* 218 */
/* exports provided: props, BFormRadio */
/* exports used: BFormRadio */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-radio/form-radio.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormRadio; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check__ = __webpack_require__(/*! ../../mixins/form-radio-check */ 458);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["b" /* makePropsConfigurable */])(__WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check__["a" /* props */], __WEBPACK_IMPORTED_MODULE_1__constants_components__["_28" /* NAME_FORM_RADIO */]); // --- Main component ---
// @vue/component

var BFormRadio = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_28" /* NAME_FORM_RADIO */],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check__["b" /* formRadioCheckMixin */]],
  inject: {
    getBvGroup: {
      from: 'getBvRadioGroup',
      default: function _default() {
        return function () {
          return null;
        };
      }
    }
  },
  props: props,
  computed: {
    bvGroup: function bvGroup() {
      return this.getBvGroup();
    }
  }
});

/***/ }),
/* 219 */
/* exports provided: props, BFormSelectOptionGroup */
/* exports used: BFormSelectOptionGroup */
/*!********************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-select/form-select-option-group.js ***!
  \********************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormSelectOptionGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_form_options__ = __webpack_require__(/*! ../../mixins/form-options */ 183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_select_option__ = __webpack_require__(/*! ./form-select-option */ 167);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__mixins_form_options__["a" /* props */]), {}, {
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], undefined, true) // Required

})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_20" /* NAME_FORM_SELECT_OPTION_GROUP */]); // --- Main component ---
// @vue/component

var BFormSelectOptionGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_20" /* NAME_FORM_SELECT_OPTION_GROUP */],
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_form_options__["b" /* formOptionsMixin */]],
  props: props,
  render: function render(h) {
    var label = this.label;
    var $options = this.formOptions.map(function (option, index) {
      var value = option.value,
          text = option.text,
          html = option.html,
          disabled = option.disabled;
      return h(__WEBPACK_IMPORTED_MODULE_9__form_select_option__["a" /* BFormSelectOption */], {
        attrs: {
          value: value,
          disabled: disabled
        },
        domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_html__["a" /* htmlOrText */])(html, text),
        key: "option_".concat(index)
      });
    });
    return h('optgroup', {
      attrs: {
        label: label
      }
    }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["Q" /* SLOT_NAME_FIRST */]), $options, this.normalizeSlot()]);
  }
});

/***/ }),
/* 220 */
/* exports provided: props, BFormSpinbutton */
/* exports used: BFormSpinbutton, props */
/*!***************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-spinbutton/form-spinbutton.js ***!
  \***************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormSpinbutton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_locale__ = __webpack_require__(/*! ../../utils/locale */ 184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_model__["a" /* makeModelMixin */])('value', {
  // Should this really be String, to match native number inputs?
  type: __WEBPACK_IMPORTED_MODULE_3__constants_props__["k" /* PROP_TYPE_BOOLEAN_NUMBER */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // Default for spin button range and step


var DEFAULT_MIN = 1;
var DEFAULT_MAX = 100;
var DEFAULT_STEP = 1; // Delay before auto-repeat in ms

var DEFAULT_REPEAT_DELAY = 500; // Repeat interval in ms

var DEFAULT_REPEAT_INTERVAL = 100; // Repeat rate increased after number of repeats

var DEFAULT_REPEAT_THRESHOLD = 10; // Repeat speed multiplier (step multiplier, must be an integer)

var DEFAULT_REPEAT_MULTIPLIER = 4;
var KEY_CODES = [__WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["g" /* CODE_HOME */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["h" /* CODE_END */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["i" /* CODE_PAGEUP */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["j" /* CODE_PAGEDOWN */]]; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_21__mixins_id__["a" /* props */]), modelProps), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_23__mixins_form_control__["a" /* props */], ['required', 'autofocus'])), __WEBPACK_IMPORTED_MODULE_19__mixins_form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_20__mixins_form_state__["a" /* props */]), {}, {
  ariaControls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  ariaLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  formatterFn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  inline: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  labelDecrement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Decrement'),
  labelIncrement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Increment'),
  locale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  max: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_MAX),
  min: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_MIN),
  placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  readonly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  repeatDelay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_REPEAT_DELAY),
  repeatInterval: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_REPEAT_INTERVAL),
  repeatStepMultiplier: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_REPEAT_MULTIPLIER),
  repeatThreshold: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_REPEAT_THRESHOLD),
  step: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_STEP),
  vertical: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  wrap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["o" /* NAME_FORM_SPINBUTTON */]); // --- Main Component ---
// @vue/component

var BFormSpinbutton = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["o" /* NAME_FORM_SPINBUTTON */],
  // Mixin order is important!
  mixins: [__WEBPACK_IMPORTED_MODULE_18__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_21__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_19__mixins_form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_20__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_22__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      localValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(this[MODEL_PROP_NAME], null),
      hasFocus: false
    };
  },
  computed: {
    required: function required() {
      return false;
    },
    spinId: function spinId() {
      return this.safeId();
    },
    computedInline: function computedInline() {
      return this.inline && !this.vertical;
    },
    computedReadonly: function computedReadonly() {
      return this.readonly && !this.disabled;
    },
    computedRequired: function computedRequired() {
      return this.required && !this.computedReadonly && !this.disabled;
    },
    computedStep: function computedStep() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(this.step, DEFAULT_STEP);
    },
    computedMin: function computedMin() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(this.min, DEFAULT_MIN);
    },
    computedMax: function computedMax() {
      // We round down to the nearest maximum step value
      var max = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(this.max, DEFAULT_MAX);
      var step = this.computedStep;
      var min = this.computedMin;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["c" /* mathFloor */])((max - min) / step) * step + min;
    },
    computedDelay: function computedDelay() {
      var delay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.repeatDelay, 0);
      return delay > 0 ? delay : DEFAULT_REPEAT_DELAY;
    },
    computedInterval: function computedInterval() {
      var interval = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.repeatInterval, 0);
      return interval > 0 ? interval : DEFAULT_REPEAT_INTERVAL;
    },
    computedThreshold: function computedThreshold() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.repeatThreshold, DEFAULT_REPEAT_THRESHOLD), 1);
    },
    computedStepMultiplier: function computedStepMultiplier() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.repeatStepMultiplier, DEFAULT_REPEAT_MULTIPLIER), 1);
    },
    computedPrecision: function computedPrecision() {
      // Quick and dirty way to get the number of decimals
      var step = this.computedStep;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["c" /* mathFloor */])(step) === step ? 0 : (step.toString().split('.')[1] || '').length;
    },
    computedMultiplier: function computedMultiplier() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["d" /* mathPow */])(10, this.computedPrecision || 0);
    },
    valueAsFixed: function valueAsFixed() {
      var value = this.localValue;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value) ? '' : value.toFixed(this.computedPrecision);
    },
    computedLocale: function computedLocale() {
      var locales = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["b" /* concat */])(this.locale).filter(__WEBPACK_IMPORTED_MODULE_9__utils_identity__["a" /* identity */]);
      var nf = new Intl.NumberFormat(locales);
      return nf.resolvedOptions().locale;
    },
    computedRTL: function computedRTL() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_locale__["a" /* isLocaleRTL */])(this.computedLocale);
    },
    defaultFormatter: function defaultFormatter() {
      // Returns and `Intl.NumberFormat` formatter method reference
      var precision = this.computedPrecision;
      var nf = new Intl.NumberFormat(this.computedLocale, {
        style: 'decimal',
        useGrouping: false,
        minimumIntegerDigits: 1,
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
        notation: 'standard'
      }); // Return the format method reference

      return nf.format;
    },
    computedFormatter: function computedFormatter() {
      var formatterFn = this.formatterFn;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["d" /* hasPropFunction */])(formatterFn) ? formatterFn : this.defaultFormatter;
    },
    computedAttrs: function computedAttrs() {
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        role: 'group',
        lang: this.computedLocale,
        tabindex: this.disabled ? null : '-1',
        title: this.ariaLabel
      });
    },
    computedSpinAttrs: function computedSpinAttrs() {
      var spinId = this.spinId,
          value = this.localValue,
          required = this.computedRequired,
          disabled = this.disabled,
          state = this.state,
          computedFormatter = this.computedFormatter;
      var hasValue = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value);
      return _objectSpread(_objectSpread({
        dir: this.computedRTL ? 'rtl' : 'ltr'
      }, this.bvAttrs), {}, {
        id: spinId,
        role: 'spinbutton',
        tabindex: disabled ? null : '0',
        'aria-live': 'off',
        'aria-label': this.ariaLabel || null,
        'aria-controls': this.ariaControls || null,
        // TODO: May want to check if the value is in range
        'aria-invalid': state === false || !hasValue && required ? 'true' : null,
        'aria-required': required ? 'true' : null,
        // These attrs are required for role spinbutton
        'aria-valuemin': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(this.computedMin),
        'aria-valuemax': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(this.computedMax),
        // These should be `null` if the value is out of range
        // They must also be non-existent attrs if the value is out of range or `null`
        'aria-valuenow': hasValue ? value : null,
        'aria-valuetext': hasValue ? computedFormatter(value) : null
      });
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (value) {
    this.localValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(value, null);
  }), _defineProperty(_watch, "localValue", function localValue(value) {
    this.$emit(MODEL_EVENT_NAME, value);
  }), _defineProperty(_watch, "disabled", function disabled(_disabled) {
    if (_disabled) {
      this.clearRepeat();
    }
  }), _defineProperty(_watch, "readonly", function readonly(_readonly) {
    if (_readonly) {
      this.clearRepeat();
    }
  }), _watch),
  created: function created() {
    // Create non reactive properties
    this.$_autoDelayTimer = null;
    this.$_autoRepeatTimer = null;
    this.$_keyIsDown = false;
  },
  beforeDestroy: function beforeDestroy() {
    this.clearRepeat();
  },

  /* istanbul ignore next */
  deactivated: function deactivated() {
    this.clearRepeat();
  },
  methods: {
    // --- Public methods ---
    focus: function focus() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["n" /* attemptFocus */])(this.$refs.spinner);
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["A" /* attemptBlur */])(this.$refs.spinner);
      }
    },
    // --- Private methods ---
    emitChange: function emitChange() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */], this.localValue);
    },
    stepValue: function stepValue(direction) {
      // Sets a new incremented or decremented value, supporting optional wrapping
      // Direction is either +1 or -1 (or a multiple thereof)
      var value = this.localValue;

      if (!this.disabled && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value)) {
        var step = this.computedStep * direction;
        var min = this.computedMin;
        var max = this.computedMax;
        var multiplier = this.computedMultiplier;
        var wrap = this.wrap; // We ensure that the value steps like a native input

        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["b" /* mathRound */])((value - min) / step) * step + min + step; // We ensure that precision is maintained (decimals)

        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["b" /* mathRound */])(value * multiplier) / multiplier; // Handle if wrapping is enabled

        this.localValue = value > max ? wrap ? min : max : value < min ? wrap ? max : min : value;
      }
    },
    onFocusBlur: function onFocusBlur(event) {
      this.hasFocus = this.disabled ? false : event.type === 'focus';
    },
    stepUp: function stepUp() {
      var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var value = this.localValue;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value)) {
        this.localValue = this.computedMin;
      } else {
        this.stepValue(+1 * multiplier);
      }
    },
    stepDown: function stepDown() {
      var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var value = this.localValue;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value)) {
        this.localValue = this.wrap ? this.computedMax : this.computedMin;
      } else {
        this.stepValue(-1 * multiplier);
      }
    },
    onKeydown: function onKeydown(event) {
      var keyCode = event.keyCode,
          altKey = event.altKey,
          ctrlKey = event.ctrlKey,
          metaKey = event.metaKey;
      /* istanbul ignore if */

      if (this.disabled || this.readonly || altKey || ctrlKey || metaKey) {
        return;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["c" /* arrayIncludes */])(KEY_CODES, keyCode)) {
        // https://w3c.github.io/aria-practices/#spinbutton
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        /* istanbul ignore if */

        if (this.$_keyIsDown) {
          // Keypress is already in progress
          return;
        }

        this.resetTimers();

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["c" /* arrayIncludes */])([__WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */]], keyCode)) {
          // The following use the custom auto-repeat handling
          this.$_keyIsDown = true;

          if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */]) {
            this.handleStepRepeat(event, this.stepUp);
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */]) {
            this.handleStepRepeat(event, this.stepDown);
          }
        } else {
          // These use native OS key repeating
          if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["i" /* CODE_PAGEUP */]) {
            this.stepUp(this.computedStepMultiplier);
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["j" /* CODE_PAGEDOWN */]) {
            this.stepDown(this.computedStepMultiplier);
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["g" /* CODE_HOME */]) {
            this.localValue = this.computedMin;
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["h" /* CODE_END */]) {
            this.localValue = this.computedMax;
          }
        }
      }
    },
    onKeyup: function onKeyup(event) {
      // Emit a change event when the keyup happens
      var keyCode = event.keyCode,
          altKey = event.altKey,
          ctrlKey = event.ctrlKey,
          metaKey = event.metaKey;
      /* istanbul ignore if */

      if (this.disabled || this.readonly || altKey || ctrlKey || metaKey) {
        return;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["c" /* arrayIncludes */])(KEY_CODES, keyCode)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        this.resetTimers();
        this.$_keyIsDown = false;
        this.emitChange();
      }
    },
    handleStepRepeat: function handleStepRepeat(event, stepper) {
      var _this = this;

      var _ref = event || {},
          type = _ref.type,
          button = _ref.button;

      if (!this.disabled && !this.readonly) {
        /* istanbul ignore if */
        if (type === 'mousedown' && button) {
          // We only respond to left (main === 0) button clicks
          return;
        }

        this.resetTimers(); // Step the counter initially

        stepper(1);
        var threshold = this.computedThreshold;
        var multiplier = this.computedStepMultiplier;
        var delay = this.computedDelay;
        var interval = this.computedInterval; // Initiate the delay/repeat interval

        this.$_autoDelayTimer = setTimeout(function () {
          var count = 0;
          _this.$_autoRepeatTimer = setInterval(function () {
            // After N initial repeats, we increase the incrementing step amount
            // We do this to minimize screen reader announcements of the value
            // (values are announced every change, which can be chatty for SR users)
            // And to make it easer to select a value when the range is large
            stepper(count < threshold ? 1 : multiplier);
            count++;
          }, interval);
        }, delay);
      }
    },
    onMouseup: function onMouseup(event) {
      // `<body>` listener, only enabled when mousedown starts
      var _ref2 = event || {},
          type = _ref2.type,
          button = _ref2.button;
      /* istanbul ignore if */


      if (type === 'mouseup' && button) {
        // Ignore non left button (main === 0) mouse button click
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["f" /* stopEvent */])(event, {
        propagation: false
      });
      this.resetTimers();
      this.setMouseup(false); // Trigger the change event

      this.emitChange();
    },
    setMouseup: function setMouseup(on) {
      // Enable or disabled the body mouseup/touchend handlers
      // Use try/catch to handle case when called server side
      try {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["e" /* eventOnOff */])(on, document.body, 'mouseup', this.onMouseup, false);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["e" /* eventOnOff */])(on, document.body, 'touchend', this.onMouseup, false);
      } catch (_unused) {}
    },
    resetTimers: function resetTimers() {
      clearTimeout(this.$_autoDelayTimer);
      clearInterval(this.$_autoRepeatTimer);
      this.$_autoDelayTimer = null;
      this.$_autoRepeatTimer = null;
    },
    clearRepeat: function clearRepeat() {
      this.resetTimers();
      this.setMouseup(false);
      this.$_keyIsDown = false;
    }
  },
  render: function render(h) {
    var _this2 = this;

    var spinId = this.spinId,
        value = this.localValue,
        inline = this.computedInline,
        readonly = this.computedReadonly,
        vertical = this.vertical,
        disabled = this.disabled,
        computedFormatter = this.computedFormatter;
    var hasValue = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value);

    var makeButton = function makeButton(stepper, label, IconCmp, keyRef, shortcut, btnDisabled, slotName) {
      var $icon = h(IconCmp, {
        props: {
          scale: _this2.hasFocus ? 1.5 : 1.25
        },
        attrs: {
          'aria-hidden': 'true'
        }
      });
      var scope = {
        hasFocus: _this2.hasFocus
      };

      var handler = function handler(event) {
        if (!disabled && !readonly) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["f" /* stopEvent */])(event, {
            propagation: false
          });

          _this2.setMouseup(true); // Since we `preventDefault()`, we must manually focus the button


          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["n" /* attemptFocus */])(event.currentTarget);

          _this2.handleStepRepeat(event, stepper);
        }
      };

      return h('button', {
        staticClass: 'btn btn-sm border-0 rounded-0',
        class: {
          'py-0': !vertical
        },
        attrs: {
          tabindex: '-1',
          type: 'button',
          disabled: disabled || readonly || btnDisabled,
          'aria-disabled': disabled || readonly || btnDisabled ? 'true' : null,
          'aria-controls': spinId,
          'aria-label': label || null,
          'aria-keyshortcuts': shortcut || null
        },
        on: {
          mousedown: handler,
          touchstart: handler
        },
        key: keyRef || null,
        ref: keyRef
      }, [_this2.normalizeSlot(slotName, scope) || $icon]);
    }; // TODO: Add button disabled state when `wrap` is `false` and at value max/min


    var $increment = makeButton(this.stepUp, this.labelIncrement, __WEBPACK_IMPORTED_MODULE_24__icons_icons__["_995" /* BIconPlus */], 'inc', 'ArrowUp', false, __WEBPACK_IMPORTED_MODULE_5__constants_slots__["c" /* SLOT_NAME_INCREMENT */]);
    var $decrement = makeButton(this.stepDown, this.labelDecrement, __WEBPACK_IMPORTED_MODULE_24__icons_icons__["_445" /* BIconDash */], 'dec', 'ArrowDown', false, __WEBPACK_IMPORTED_MODULE_5__constants_slots__["d" /* SLOT_NAME_DECREMENT */]);
    var $hidden = h();

    if (this.name && !disabled) {
      $hidden = h('input', {
        attrs: {
          type: 'hidden',
          name: this.name,
          form: this.form || null,
          // TODO: Should this be set to '' if value is out of range?
          value: this.valueAsFixed
        },
        key: 'hidden'
      });
    }

    var $spin = h( // We use 'output' element to make this accept a `<label for="id">` (Except IE)
    'output', {
      staticClass: 'flex-grow-1',
      class: {
        'd-flex': vertical,
        'align-self-center': !vertical,
        'align-items-center': vertical,
        'border-top': vertical,
        'border-bottom': vertical,
        'border-left': !vertical,
        'border-right': !vertical
      },
      attrs: this.computedSpinAttrs,
      key: 'output',
      ref: 'spinner'
    }, [h('bdi', hasValue ? computedFormatter(value) : this.placeholder || '')]);
    return h('div', {
      staticClass: 'b-form-spinbutton form-control',
      class: [{
        disabled: disabled,
        readonly: readonly,
        focus: this.hasFocus,
        'd-inline-flex': inline || vertical,
        'd-flex': !inline && !vertical,
        'align-items-stretch': !vertical,
        'flex-column': vertical
      }, this.sizeFormClass, this.stateClass],
      attrs: this.computedAttrs,
      on: {
        keydown: this.onKeydown,
        keyup: this.onKeyup,
        // We use capture phase (`!` prefix) since focus and blur do not bubble
        '!focus': this.onFocusBlur,
        '!blur': this.onFocusBlur
      }
    }, vertical ? [$increment, $hidden, $spin, $decrement] : [$decrement, $hidden, $spin, $increment]);
  }
});

/***/ }),
/* 221 */
/* exports provided: props, BFormTag */
/* exports used: BFormTag */
/*!**************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-tags/form-tag.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__badge_badge__ = __webpack_require__(/*! ../badge/badge */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__button_button_close__ = __webpack_require__(/*! ../button/button-close */ 107);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__mixins_id__["a" /* props */]), {}, {
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noRemove: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  pill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  removeLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Remove tag'),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'span'),
  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_23" /* NAME_FORM_TAG */]); // --- Main component ---
// @vue/component

var BFormTag = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_23" /* NAME_FORM_TAG */],
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  methods: {
    onRemove: function onRemove(event) {
      var type = event.type,
          keyCode = event.keyCode;

      if (!this.disabled && (type === 'click' || type === 'keydown' && keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["l" /* CODE_DELETE */])) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["Z" /* EVENT_NAME_REMOVE */]);
      }
    }
  },
  render: function render(h) {
    var title = this.title,
        tag = this.tag,
        variant = this.variant,
        pill = this.pill,
        disabled = this.disabled;
    var tagId = this.safeId();
    var tagLabelId = this.safeId('_taglabel_');
    var $remove = h();

    if (!this.noRemove && !disabled) {
      $remove = h(__WEBPACK_IMPORTED_MODULE_10__button_button_close__["a" /* BButtonClose */], {
        staticClass: 'b-form-tag-remove',
        props: {
          ariaLabel: this.removeLabel
        },
        attrs: {
          'aria-controls': tagId,
          'aria-describedby': tagLabelId,
          'aria-keyshortcuts': 'Delete'
        },
        on: {
          click: this.onRemove,
          keydown: this.onRemove
        }
      });
    }

    var $tag = h('span', {
      staticClass: 'b-form-tag-content flex-grow-1 text-truncate',
      attrs: {
        id: tagLabelId
      }
    }, this.normalizeSlot() || title);
    return h(__WEBPACK_IMPORTED_MODULE_9__badge_badge__["a" /* BBadge */], {
      staticClass: 'b-form-tag d-inline-flex align-items-baseline mw-100',
      class: {
        disabled: disabled
      },
      props: {
        tag: tag,
        variant: variant,
        pill: pill
      },
      attrs: {
        id: tagId,
        title: title || null,
        'aria-labelledby': tagLabelId
      }
    }, [$tag, $remove]);
  }
});

/***/ }),
/* 222 */
/* exports provided: props, BFormValidFeedback */
/* exports used: BFormValidFeedback */
/*!********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form/form-valid-feedback.js ***!
  \********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormValidFeedback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  ariaLive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  forceShow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Tri-state prop: `true`, `false`, or `null`
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  tooltip: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_36" /* NAME_FORM_VALID_FEEDBACK */]); // --- Main component ---
// @vue/component

var BFormValidFeedback = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_36" /* NAME_FORM_VALID_FEEDBACK */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var tooltip = props.tooltip,
        ariaLive = props.ariaLive;
    var show = props.forceShow === true || props.state === true;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: {
        'd-block': show,
        'valid-feedback': !tooltip,
        'valid-tooltip': tooltip
      },
      attrs: {
        id: props.id || null,
        role: props.role || null,
        'aria-live': ariaLive || null,
        'aria-atomic': ariaLive ? 'true' : null
      }
    }), children);
  }
});

/***/ }),
/* 223 */
/* exports provided: props, BImgLazy */
/* exports used: BImgLazy, props */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/image/img-lazy.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BImgLazy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_visible_visible__ = __webpack_require__(/*! ../../directives/visible/visible */ 180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img__ = __webpack_require__(/*! ./img */ 119);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













 // --- Constants ---

var MODEL_PROP_NAME_SHOW = 'show';
var MODEL_EVENT_NAME_SHOW = __WEBPACK_IMPORTED_MODULE_3__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_SHOW; // --- Props ---

var imgProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_12__img__["b" /* props */], ['blank']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["b" /* makePropsConfigurable */])(_objectSpread(_objectSpread({}, imgProps), {}, _defineProperty({
  blankHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  // If `null`, a blank image is generated
  blankSrc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], null),
  blankWidth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  // Distance away from viewport (in pixels)
  // before being considered "visible"
  offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 360)
}, MODEL_PROP_NAME_SHOW, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false))), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_15" /* NAME_IMG_LAZY */]); // --- Main component ---
// @vue/component

var BImgLazy = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_15" /* NAME_IMG_LAZY */],
  directives: {
    'b-visible': __WEBPACK_IMPORTED_MODULE_11__directives_visible_visible__["a" /* VBVisible */]
  },
  props: props,
  data: function data() {
    return {
      isShown: this[MODEL_PROP_NAME_SHOW]
    };
  },
  computed: {
    computedSrc: function computedSrc() {
      var blankSrc = this.blankSrc;
      return !blankSrc || this.isShown ? this.src : blankSrc;
    },
    computedBlank: function computedBlank() {
      return !(this.isShown || this.blankSrc);
    },
    computedWidth: function computedWidth() {
      var width = this.width;
      return this.isShown ? width : this.blankWidth || width;
    },
    computedHeight: function computedHeight() {
      var height = this.height;
      return this.isShown ? height : this.blankHeight || height;
    },
    computedSrcset: function computedSrcset() {
      var srcset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(this.srcset).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]).join(',');
      return srcset && (!this.blankSrc || this.isShown) ? srcset : null;
    },
    computedSizes: function computedSizes() {
      var sizes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(this.sizes).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]).join(',');
      return sizes && (!this.blankSrc || this.isShown) ? sizes : null;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME_SHOW, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      // If `IntersectionObserver` support is not available, image is always shown
      var visible = __WEBPACK_IMPORTED_MODULE_2__constants_env__["j" /* HAS_INTERACTION_OBSERVER_SUPPORT */] ? newValue : true;
      this.isShown = visible; // Ensure the show prop is synced (when no `IntersectionObserver`)

      if (newValue !== visible) {
        this.$nextTick(this.updateShowProp);
      }
    }
  }), _defineProperty(_watch, "isShown", function isShown(newValue, oldValue) {
    // Update synched show prop
    if (newValue !== oldValue) {
      this.updateShowProp();
    }
  }), _watch),
  mounted: function mounted() {
    var _this = this;

    // If `IntersectionObserver` is not available, image is always shown
    this.$nextTick(function () {
      _this.isShown = __WEBPACK_IMPORTED_MODULE_2__constants_env__["j" /* HAS_INTERACTION_OBSERVER_SUPPORT */] ? _this[MODEL_PROP_NAME_SHOW] : true;
    });
  },
  methods: {
    updateShowProp: function updateShowProp() {
      this.$emit(MODEL_EVENT_NAME_SHOW, this.isShown);
    },
    doShow: function doShow(visible) {
      var _this2 = this;

      // If IntersectionObserver is not supported, the callback
      // will be called with `null` rather than `true` or `false`
      if ((visible || visible === null) && !this.isShown) {
        // In a `requestAF()` to render the `blank` placeholder properly
        // for fast loading images in some browsers (i.e. Firefox)
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* requestAF */])(function () {
          _this2.isShown = true;
        });
      }
    }
  },
  render: function render(h) {
    var directives = [];

    if (!this.isShown) {
      var _modifiers;

      // We only add the visible directive if we are not shown
      directives.push({
        // Visible directive will silently do nothing if
        // `IntersectionObserver` is not supported
        name: 'b-visible',
        // Value expects a callback (passed one arg of `visible` = `true` or `false`)
        value: this.doShow,
        modifiers: (_modifiers = {}, _defineProperty(_modifiers, "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(this.offset, 0)), true), _defineProperty(_modifiers, "once", true), _modifiers)
      });
    }

    return h(__WEBPACK_IMPORTED_MODULE_12__img__["a" /* BImg */], {
      directives: directives,
      props: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["c" /* pluckProps */])(imgProps, this.$props)), {}, {
        // Computed value props
        src: this.computedSrc,
        blank: this.computedBlank,
        width: this.computedWidth,
        height: this.computedHeight,
        srcset: this.computedSrcset,
        sizes: this.computedSizes
      })
    });
  }
});

/***/ }),
/* 224 */
/* exports provided: props, BInputGroupAppend */
/* exports used: BInputGroupAppend */
/*!**************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/input-group/input-group-append.js ***!
  \**************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BInputGroupAppend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input_group_addon__ = __webpack_require__(/*! ./input-group-addon */ 171);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_4__input_group_addon__["b" /* props */], ['append']), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_13" /* NAME_INPUT_GROUP_APPEND */]); // --- Main component ---
// @vue/component

var BInputGroupAppend = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_13" /* NAME_INPUT_GROUP_APPEND */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    // Pass all our data down to child, and set `append` to `true`
    return h(__WEBPACK_IMPORTED_MODULE_4__input_group_addon__["a" /* BInputGroupAddon */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      props: _objectSpread(_objectSpread({}, props), {}, {
        append: true
      })
    }), children);
  }
});

/***/ }),
/* 225 */
/* exports provided: props, BInputGroupPrepend */
/* exports used: BInputGroupPrepend */
/*!***************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/input-group/input-group-prepend.js ***!
  \***************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BInputGroupPrepend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input_group_addon__ = __webpack_require__(/*! ./input-group-addon */ 171);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_4__input_group_addon__["b" /* props */], ['append']), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_11" /* NAME_INPUT_GROUP_PREPEND */]); // --- Main component ---
// @vue/component

var BInputGroupPrepend = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_11" /* NAME_INPUT_GROUP_PREPEND */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    // Pass all our data down to child, and set `append` to `true`
    return h(__WEBPACK_IMPORTED_MODULE_4__input_group_addon__["a" /* BInputGroupAddon */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      props: _objectSpread(_objectSpread({}, props), {}, {
        append: false
      })
    }), children);
  }
});

/***/ }),
/* 226 */
/* exports provided: generateProps, BCol */
/* exports used: BCol */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/layout/col.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_config__ = __webpack_require__(/*! ../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_memoize__ = __webpack_require__(/*! ../../utils/memoize */ 255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












 // --- Constants ---

var ALIGN_SELF_VALUES = ['auto', 'start', 'end', 'center', 'baseline', 'stretch']; // --- Helper methods ---
// Compute a breakpoint class name

var computeBreakpoint = function computeBreakpoint(type, breakpoint, value) {
  var className = type;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["g" /* isUndefinedOrNull */])(value) || value === false) {
    return undefined;
  }

  if (breakpoint) {
    className += "-".concat(breakpoint);
  } // Handling the boolean style prop when accepting `[Boolean, String, Number]`
  // means Vue will not convert `<b-col sm></b-col>` to `sm: true` for us
  // Since the default is `false`, '' indicates the prop's presence


  if (type === 'col' && (value === '' || value === true)) {
    // .col-md
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_string__["h" /* lowerCase */])(className);
  } // .order-md-6


  className += "-".concat(value);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_string__["h" /* lowerCase */])(className);
}; // Memoized function for better performance on generating class names


var computeBreakpointClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_memoize__["a" /* memoize */])(computeBreakpoint); // Cached copy of the breakpoint prop names

var breakpointPropMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["i" /* create */])(null); // --- Props ---
// Prop generator for lazy generation of props

var generateProps = function generateProps() {
  // Grab the breakpoints from the cached config (exclude the '' (xs) breakpoint)
  var breakpoints = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_config__["c" /* getBreakpointsUpCached */])().filter(__WEBPACK_IMPORTED_MODULE_6__utils_identity__["a" /* identity */]); // i.e. 'col-sm', 'col-md-6', 'col-lg-auto', ...

  var breakpointCol = breakpoints.reduce(function (props, breakpoint) {
    props[breakpoint] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["r" /* PROP_TYPE_BOOLEAN_NUMBER_STRING */]);
    return props;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["i" /* create */])(null)); // i.e. 'offset-md-1', 'offset-lg-12', ...

  var breakpointOffset = breakpoints.reduce(function (props, breakpoint) {
    props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["e" /* suffixPropName */])(breakpoint, 'offset')] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]);
    return props;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["i" /* create */])(null)); // i.e. 'order-md-1', 'order-lg-12', ...

  var breakpointOrder = breakpoints.reduce(function (props, breakpoint) {
    props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["e" /* suffixPropName */])(breakpoint, 'order')] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]);
    return props;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["i" /* create */])(null)); // For loop doesn't need to check `.hasOwnProperty()`
  // when using an object created from `null`

  breakpointPropMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["e" /* assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["i" /* create */])(null), {
    col: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["a" /* keys */])(breakpointCol),
    offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["a" /* keys */])(breakpointOffset),
    order: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["a" /* keys */])(breakpointOrder)
  }); // Return the generated props

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, breakpointCol), breakpointOffset), breakpointOrder), {}, {
    // Flex alignment
    alignSelf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], null, function (value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(ALIGN_SELF_VALUES, value);
    }),
    // Generic flexbox 'col' (xs)
    col: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    // i.e. 'col-1', 'col-2', 'col-auto', ...
    cols: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
    offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
    order: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
    tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
  })), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_6" /* NAME_COL */]);
}; // --- Main component ---
// We do not use extend here as that would evaluate the props
// immediately, which we do not want to happen
// @vue/component

var BCol = {
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_6" /* NAME_COL */],
  functional: true,

  get props() {
    // Allow props to be lazy evaled on first access and
    // then they become a non-getter afterwards.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get#Smart_self-overwriting_lazy_getters
    delete this.props; // eslint-disable-next-line no-return-assign

    return this.props = generateProps();
  },

  render: function render(h, _ref) {
    var _classList$push;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var cols = props.cols,
        offset = props.offset,
        order = props.order,
        alignSelf = props.alignSelf;
    var classList = []; // Loop through `col`, `offset`, `order` breakpoint props

    for (var type in breakpointPropMap) {
      // Returns colSm, offset, offsetSm, orderMd, etc.
      var _keys = breakpointPropMap[type];

      for (var i = 0; i < _keys.length; i++) {
        // computeBreakpoint(col, colSm => Sm, value=[String, Number, Boolean])
        var c = computeBreakpointClass(type, _keys[i].replace(type, ''), props[_keys[i]]); // If a class is returned, push it onto the array.

        if (c) {
          classList.push(c);
        }
      }
    }

    var hasColClasses = classList.some(function (className) {
      return __WEBPACK_IMPORTED_MODULE_3__constants_regex__["A" /* RX_COL_CLASS */].test(className);
    });
    classList.push((_classList$push = {
      // Default to .col if no other col-{bp}-* classes generated nor `cols` specified.
      col: props.col || !hasColClasses && !cols
    }, _defineProperty(_classList$push, "col-".concat(cols), cols), _defineProperty(_classList$push, "offset-".concat(offset), offset), _defineProperty(_classList$push, "order-".concat(order), order), _defineProperty(_classList$push, "align-self-".concat(alignSelf), alignSelf), _classList$push));
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: classList
    }), children);
  }
};

/***/ }),
/* 227 */
/* exports provided: props, BContainer */
/* exports used: BContainer */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/layout/container.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  // String breakpoint name new in Bootstrap v4.4.x
  fluid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_8" /* NAME_CONTAINER */]); // --- Main component ---
// @vue/component

var BContainer = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_8" /* NAME_CONTAINER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var fluid = props.fluid;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: _defineProperty({
        container: !(fluid || fluid === ''),
        'container-fluid': fluid === true || fluid === ''
      }, "container-".concat(fluid), fluid && fluid !== true)
    }), children);
  }
});

/***/ }),
/* 228 */
/* exports provided: props, BMediaAside */
/* exports used: BMediaAside */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/media/media-aside.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BMediaAside; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  right: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  verticalAlign: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'top')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_1" /* NAME_MEDIA_ASIDE */]); // --- Main component ---
// @vue/component

var BMediaAside = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_1" /* NAME_MEDIA_ASIDE */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var verticalAlign = props.verticalAlign;
    var align = verticalAlign === 'top' ? 'start' : verticalAlign === 'bottom' ? 'end' :
    /* istanbul ignore next */
    verticalAlign;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'media-aside',
      class: _defineProperty({
        'media-aside-right': props.right
      }, "align-self-".concat(align), align)
    }), children);
  }
});

/***/ }),
/* 229 */
/* exports provided: props, BMediaBody */
/* exports used: BMediaBody */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/media/media-body.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BMediaBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_0" /* NAME_MEDIA_BODY */]); // --- Main component ---
// @vue/component

var BMediaBody = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_0" /* NAME_MEDIA_BODY */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'media-body'
    }), children);
  }
});

/***/ }),
/* 230 */
/* exports provided: props, BModal */
/* exports used: BModal, props */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/modal/modal.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_safe_types__ = __webpack_require__(/*! ../../constants/safe-types */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_observe_dom__ = __webpack_require__(/*! ../../utils/observe-dom */ 185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_listen_on_document__ = __webpack_require__(/*! ../../mixins/listen-on-document */ 953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_listen_on_window__ = __webpack_require__(/*! ../../mixins/listen-on-window */ 954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mixins_scoped_style__ = __webpack_require__(/*! ../../mixins/scoped-style */ 253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__button_button__ = __webpack_require__(/*! ../button/button */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__button_button_close__ = __webpack_require__(/*! ../button/button-close */ 107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__transition_bv_transition__ = __webpack_require__(/*! ../transition/bv-transition */ 108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__transporter_transporter__ = __webpack_require__(/*! ../transporter/transporter */ 943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_bv_modal_event_class__ = __webpack_require__(/*! ./helpers/bv-modal-event.class */ 926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__helpers_modal_manager__ = __webpack_require__(/*! ./helpers/modal-manager */ 927);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }































 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_model__["a" /* makeModelMixin */])('visible', {
  type: __WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */],
  defaultValue: false,
  event: __WEBPACK_IMPORTED_MODULE_3__constants_events__["w" /* EVENT_NAME_CHANGE */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

var TRIGGER_BACKDROP = 'backdrop';
var TRIGGER_ESC = 'esc';
var TRIGGER_FORCE = 'FORCE';
var TRIGGER_TOGGLE = 'toggle';
var BUTTON_CANCEL = 'cancel'; // TODO: This should be renamed to 'close'

var BUTTON_CLOSE = 'headerclose';
var BUTTON_OK = 'ok';
var BUTTONS = [BUTTON_CANCEL, BUTTON_CLOSE, BUTTON_OK]; // `ObserveDom` config to detect changes in modal content
// so that we can adjust the modal padding if needed

var OBSERVER_CONFIG = {
  subtree: true,
  childList: true,
  characterData: true,
  attributes: true,
  attributeFilter: ['style', 'class']
}; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_19__mixins_id__["a" /* props */]), modelProps), {}, {
  ariaLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  autoFocusButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], null,
  /* istanbul ignore next */
  function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["g" /* isUndefinedOrNull */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["c" /* arrayIncludes */])(BUTTONS, value);
  }),
  bodyBgVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  bodyClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  bodyTextVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  busy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  buttonSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  cancelDisabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  cancelTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Cancel'),
  cancelTitleHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  cancelVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary'),
  centered: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  contentClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  dialogClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  footerBgVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  footerBorderVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  footerClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  footerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'footer'),
  footerTextVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerBgVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerBorderVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  headerCloseContent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], '&times;'),
  headerCloseLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Close'),
  headerCloseVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'header'),
  headerTextVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  // TODO: Rename to `noBackdrop` and deprecate `hideBackdrop`
  hideBackdrop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // TODO: Rename to `noFooter` and deprecate `hideFooter`
  hideFooter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // TODO: Rename to `noHeader` and deprecate `hideHeader`
  hideHeader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // TODO: Rename to `noHeaderClose` and deprecate `hideHeaderClose`
  hideHeaderClose: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  ignoreEnforceFocusSelector: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  lazy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  modalClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  noCloseOnBackdrop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noCloseOnEsc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noEnforceFocus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noFade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noStacking: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  okDisabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  okOnly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  okTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'OK'),
  okTitleHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  okVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'primary'),
  // HTML Element, CSS selector string or Vue component instance
  returnFocus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_6__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_5__constants_props__["e" /* PROP_TYPE_OBJECT */], __WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]]),
  scrollable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'md'),
  static: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  titleClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  titleHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  titleSrOnly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  titleTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'h5')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */]); // --- Main component ---
// @vue/component

var BModal = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */],
  mixins: [__WEBPACK_IMPORTED_MODULE_18__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_19__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_20__mixins_listen_on_document__["a" /* listenOnDocumentMixin */], __WEBPACK_IMPORTED_MODULE_21__mixins_listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_22__mixins_listen_on_window__["a" /* listenOnWindowMixin */], __WEBPACK_IMPORTED_MODULE_23__mixins_normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_24__mixins_scoped_style__["a" /* scopedStyleMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      isHidden: true,
      // If modal should not be in document
      isVisible: false,
      // Controls modal visible state
      isTransitioning: false,
      // Used for style control
      isShow: false,
      // Used for style control
      isBlock: false,
      // Used for style control
      isOpening: false,
      // To signal that the modal is in the process of opening
      isClosing: false,
      // To signal that the modal is in the process of closing
      ignoreBackdropClick: false,
      // Used to signify if click out listener should ignore the click
      isModalOverflowing: false,
      // The following items are controlled by the modalManager instance
      scrollbarWidth: 0,
      zIndex: __WEBPACK_IMPORTED_MODULE_30__helpers_modal_manager__["a" /* modalManager */].getBaseZIndex(),
      isTop: true,
      isBodyOverflowing: false
    };
  },
  computed: {
    modalId: function modalId() {
      return this.safeId();
    },
    modalOuterId: function modalOuterId() {
      return this.safeId('__BV_modal_outer_');
    },
    modalHeaderId: function modalHeaderId() {
      return this.safeId('__BV_modal_header_');
    },
    modalBodyId: function modalBodyId() {
      return this.safeId('__BV_modal_body_');
    },
    modalTitleId: function modalTitleId() {
      return this.safeId('__BV_modal_title_');
    },
    modalContentId: function modalContentId() {
      return this.safeId('__BV_modal_content_');
    },
    modalFooterId: function modalFooterId() {
      return this.safeId('__BV_modal_footer_');
    },
    modalBackdropId: function modalBackdropId() {
      return this.safeId('__BV_modal_backdrop_');
    },
    modalClasses: function modalClasses() {
      return [{
        fade: !this.noFade,
        show: this.isShow
      }, this.modalClass];
    },
    modalStyles: function modalStyles() {
      var sbWidth = "".concat(this.scrollbarWidth, "px");
      return {
        paddingLeft: !this.isBodyOverflowing && this.isModalOverflowing ? sbWidth : '',
        paddingRight: this.isBodyOverflowing && !this.isModalOverflowing ? sbWidth : '',
        // Needed to fix issue https://github.com/bootstrap-vue/bootstrap-vue/issues/3457
        // Even though we are using v-show, we must ensure 'none' is restored in the styles
        display: this.isBlock ? 'block' : 'none'
      };
    },
    dialogClasses: function dialogClasses() {
      var _ref;

      return [(_ref = {}, _defineProperty(_ref, "modal-".concat(this.size), this.size), _defineProperty(_ref, 'modal-dialog-centered', this.centered), _defineProperty(_ref, 'modal-dialog-scrollable', this.scrollable), _ref), this.dialogClass];
    },
    headerClasses: function headerClasses() {
      var _ref2;

      return [(_ref2 = {}, _defineProperty(_ref2, "bg-".concat(this.headerBgVariant), this.headerBgVariant), _defineProperty(_ref2, "text-".concat(this.headerTextVariant), this.headerTextVariant), _defineProperty(_ref2, "border-".concat(this.headerBorderVariant), this.headerBorderVariant), _ref2), this.headerClass];
    },
    titleClasses: function titleClasses() {
      return [{
        'sr-only': this.titleSrOnly
      }, this.titleClass];
    },
    bodyClasses: function bodyClasses() {
      var _ref3;

      return [(_ref3 = {}, _defineProperty(_ref3, "bg-".concat(this.bodyBgVariant), this.bodyBgVariant), _defineProperty(_ref3, "text-".concat(this.bodyTextVariant), this.bodyTextVariant), _ref3), this.bodyClass];
    },
    footerClasses: function footerClasses() {
      var _ref4;

      return [(_ref4 = {}, _defineProperty(_ref4, "bg-".concat(this.footerBgVariant), this.footerBgVariant), _defineProperty(_ref4, "text-".concat(this.footerTextVariant), this.footerTextVariant), _defineProperty(_ref4, "border-".concat(this.footerBorderVariant), this.footerBorderVariant), _ref4), this.footerClass];
    },
    modalOuterStyle: function modalOuterStyle() {
      // Styles needed for proper stacking of modals
      return {
        position: 'absolute',
        zIndex: this.zIndex
      };
    },
    slotScope: function slotScope() {
      return {
        cancel: this.onCancel,
        close: this.onClose,
        hide: this.hide,
        ok: this.onOk,
        visible: this.isVisible
      };
    },
    computeIgnoreEnforceFocusSelector: function computeIgnoreEnforceFocusSelector() {
      // Normalize to an single selector with selectors separated by `,`
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["b" /* concat */])(this.ignoreEnforceFocusSelector).filter(__WEBPACK_IMPORTED_MODULE_12__utils_identity__["a" /* identity */]).join(',').trim();
    },
    computedAttrs: function computedAttrs() {
      // If the parent has a scoped style attribute, and the modal
      // is portalled, add the scoped attribute to the modal wrapper
      var scopedStyleAttrs = !this.static ? this.scopedStyleAttrs : {};
      return _objectSpread(_objectSpread(_objectSpread({}, scopedStyleAttrs), this.bvAttrs), {}, {
        id: this.modalOuterId
      });
    },
    computedModalAttrs: function computedModalAttrs() {
      var isVisible = this.isVisible,
          ariaLabel = this.ariaLabel;
      return {
        id: this.modalId,
        role: 'dialog',
        'aria-hidden': isVisible ? null : 'true',
        'aria-modal': isVisible ? 'true' : null,
        'aria-label': ariaLabel,
        'aria-labelledby': this.hideHeader || ariaLabel || // TODO: Rename slot to `title` and deprecate `modal-title`
        !(this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["F" /* SLOT_NAME_MODAL_TITLE */]) || this.titleHtml || this.title) ? null : this.modalTitleId,
        'aria-describedby': this.modalBodyId
      };
    }
  },
  watch: _defineProperty({}, MODEL_PROP_NAME, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      this[newValue ? 'show' : 'hide']();
    }
  }),
  created: function created() {
    // Define non-reactive properties
    this.$_observer = null;
    this.$_returnFocus = this.returnFocus || null;
  },
  mounted: function mounted() {
    // Set initial z-index as queried from the DOM
    this.zIndex = __WEBPACK_IMPORTED_MODULE_30__helpers_modal_manager__["a" /* modalManager */].getBaseZIndex(); // Listen for events from others to either open or close ourselves
    // and listen to all modals to enable/disable enforce focus

    this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["a" /* EVENT_NAME_SHOW */]), this.showHandler);
    this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["e" /* EVENT_NAME_HIDE */]), this.hideHandler);
    this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["U" /* EVENT_NAME_TOGGLE */]), this.toggleHandler); // Listen for `bv:modal::show events`, and close ourselves if the
    // opening modal not us

    this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["a" /* EVENT_NAME_SHOW */]), this.modalListener); // Initially show modal?

    if (this[MODEL_PROP_NAME] === true) {
      this.$nextTick(this.show);
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Ensure everything is back to normal
    __WEBPACK_IMPORTED_MODULE_30__helpers_modal_manager__["a" /* modalManager */].unregisterModal(this);
    this.setObserver(false);

    if (this.isVisible) {
      this.isVisible = false;
      this.isShow = false;
      this.isTransitioning = false;
    }
  },
  methods: {
    setObserver: function setObserver() {
      var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$_observer && this.$_observer.disconnect();
      this.$_observer = null;

      if (on) {
        this.$_observer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_observe_dom__["a" /* observeDom */])(this.$refs.content, this.checkModalOverflow.bind(this), OBSERVER_CONFIG);
      }
    },
    // Private method to update the v-model
    updateModel: function updateModel(value) {
      if (value !== this[MODEL_PROP_NAME]) {
        this.$emit(MODEL_EVENT_NAME, value);
      }
    },
    // Private method to create a BvModalEvent object
    buildEvent: function buildEvent(type) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new __WEBPACK_IMPORTED_MODULE_29__helpers_bv_modal_event_class__["a" /* BvModalEvent */](type, _objectSpread(_objectSpread({
        // Default options
        cancelable: false,
        target: this.$refs.modal || this.$el || null,
        relatedTarget: null,
        trigger: null
      }, options), {}, {
        // Options that can't be overridden
        vueTarget: this,
        componentId: this.modalId
      }));
    },
    // Public method to show modal
    show: function show() {
      if (this.isVisible || this.isOpening) {
        // If already open, or in the process of opening, do nothing

        /* istanbul ignore next */
        return;
      }
      /* istanbul ignore next */


      if (this.isClosing) {
        // If we are in the process of closing, wait until hidden before re-opening

        /* istanbul ignore next */
        this.$once(__WEBPACK_IMPORTED_MODULE_3__constants_events__["b" /* EVENT_NAME_HIDDEN */], this.show);
        /* istanbul ignore next */

        return;
      }

      this.isOpening = true; // Set the element to return focus to when closed

      this.$_returnFocus = this.$_returnFocus || this.getActiveElement();
      var showEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["a" /* EVENT_NAME_SHOW */], {
        cancelable: true
      });
      this.emitEvent(showEvent); // Don't show if canceled

      if (showEvent.defaultPrevented || this.isVisible) {
        this.isOpening = false; // Ensure the v-model reflects the current state

        this.updateModel(false);
        return;
      } // Show the modal


      this.doShow();
    },
    // Public method to hide modal
    hide: function hide() {
      var trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!this.isVisible || this.isClosing) {
        /* istanbul ignore next */
        return;
      }

      this.isClosing = true;
      var hideEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["e" /* EVENT_NAME_HIDE */], {
        cancelable: trigger !== TRIGGER_FORCE,
        trigger: trigger || null
      }); // We emit specific event for one of the three built-in buttons

      if (trigger === BUTTON_OK) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["V" /* EVENT_NAME_OK */], hideEvent);
      } else if (trigger === BUTTON_CANCEL) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["W" /* EVENT_NAME_CANCEL */], hideEvent);
      } else if (trigger === BUTTON_CLOSE) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["u" /* EVENT_NAME_CLOSE */], hideEvent);
      }

      this.emitEvent(hideEvent); // Hide if not canceled

      if (hideEvent.defaultPrevented || !this.isVisible) {
        this.isClosing = false; // Ensure v-model reflects current state

        this.updateModel(true);
        return;
      } // Stop observing for content changes


      this.setObserver(false); // Trigger the hide transition

      this.isVisible = false; // Update the v-model

      this.updateModel(false);
    },
    // Public method to toggle modal visibility
    toggle: function toggle(triggerEl) {
      if (triggerEl) {
        this.$_returnFocus = triggerEl;
      }

      if (this.isVisible) {
        this.hide(TRIGGER_TOGGLE);
      } else {
        this.show();
      }
    },
    // Private method to get the current document active element
    getActiveElement: function getActiveElement() {
      // Returning focus to `document.body` may cause unwanted scrolls,
      // so we exclude setting focus on body
      var activeElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["B" /* getActiveElement */])(__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] ? [document.body] : []); // Preset the fallback return focus value if it is not set
      // `document.activeElement` should be the trigger element that was clicked or
      // in the case of using the v-model, which ever element has current focus
      // Will be overridden by some commands such as toggle, etc.
      // Note: On IE 11, `document.activeElement` may be `null`
      // So we test it for truthiness first
      // https://github.com/bootstrap-vue/bootstrap-vue/issues/3206


      return activeElement && activeElement.focus ? activeElement : null;
    },
    // Private method to finish showing modal
    doShow: function doShow() {
      var _this = this;

      /* istanbul ignore next: commenting out for now until we can test stacking */
      if (__WEBPACK_IMPORTED_MODULE_30__helpers_modal_manager__["a" /* modalManager */].modalsAreOpen && this.noStacking) {
        // If another modal(s) is already open, wait for it(them) to close
        this.listenOnRootOnce(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["b" /* EVENT_NAME_HIDDEN */]), this.doShow);
        return;
      }

      __WEBPACK_IMPORTED_MODULE_30__helpers_modal_manager__["a" /* modalManager */].registerModal(this); // Place modal in DOM

      this.isHidden = false;
      this.$nextTick(function () {
        // We do this in `$nextTick()` to ensure the modal is in DOM first
        // before we show it
        _this.isVisible = true;
        _this.isOpening = false; // Update the v-model

        _this.updateModel(true);

        _this.$nextTick(function () {
          // Observe changes in modal content and adjust if necessary
          // In a `$nextTick()` in case modal content is lazy
          _this.setObserver(true);
        });
      });
    },
    // Transition handlers
    onBeforeEnter: function onBeforeEnter() {
      this.isTransitioning = true;
      this.setResizeEvent(true);
    },
    onEnter: function onEnter() {
      var _this2 = this;

      this.isBlock = true; // We add the `show` class 1 frame later
      // `requestAF()` runs the callback before the next repaint, so we need
      // two calls to guarantee the next frame has been rendered

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
          _this2.isShow = true;
        });
      });
    },
    onAfterEnter: function onAfterEnter() {
      var _this3 = this;

      this.checkModalOverflow();
      this.isTransitioning = false; // We use `requestAF()` to allow transition hooks to complete
      // before passing control over to the other handlers
      // This will allow users to not have to use `$nextTick()` or `requestAF()`
      // when trying to pre-focus an element

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
        _this3.emitEvent(_this3.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["d" /* EVENT_NAME_SHOWN */]));

        _this3.setEnforceFocus(true);

        _this3.$nextTick(function () {
          // Delayed in a `$nextTick()` to allow users time to pre-focus
          // an element if the wish
          _this3.focusFirst();
        });
      });
    },
    onBeforeLeave: function onBeforeLeave() {
      this.isTransitioning = true;
      this.setResizeEvent(false);
      this.setEnforceFocus(false);
    },
    onLeave: function onLeave() {
      // Remove the 'show' class
      this.isShow = false;
    },
    onAfterLeave: function onAfterLeave() {
      var _this4 = this;

      this.isBlock = false;
      this.isTransitioning = false;
      this.isModalOverflowing = false;
      this.isHidden = true;
      this.$nextTick(function () {
        _this4.isClosing = false;
        __WEBPACK_IMPORTED_MODULE_30__helpers_modal_manager__["a" /* modalManager */].unregisterModal(_this4);

        _this4.returnFocusTo(); // TODO: Need to find a way to pass the `trigger` property
        //       to the `hidden` event, not just only the `hide` event


        _this4.emitEvent(_this4.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["b" /* EVENT_NAME_HIDDEN */]));
      });
    },
    emitEvent: function emitEvent(bvEvent) {
      var type = bvEvent.type; // We emit on `$root` first in case a global listener wants to cancel
      // the event first before the instance emits its event

      this.emitOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */], type), bvEvent, bvEvent.componentId);
      this.$emit(type, bvEvent);
    },
    // UI event handlers
    onDialogMousedown: function onDialogMousedown() {
      var _this5 = this;

      // Watch to see if the matching mouseup event occurs outside the dialog
      // And if it does, cancel the clickOut handler
      var modal = this.$refs.modal;

      var onceModalMouseup = function onceModalMouseup(event) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["c" /* eventOff */])(modal, 'mouseup', onceModalMouseup, __WEBPACK_IMPORTED_MODULE_3__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);

        if (event.target === modal) {
          _this5.ignoreBackdropClick = true;
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["b" /* eventOn */])(modal, 'mouseup', onceModalMouseup, __WEBPACK_IMPORTED_MODULE_3__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
    },
    onClickOut: function onClickOut(event) {
      if (this.ignoreBackdropClick) {
        // Click was initiated inside the modal content, but finished outside.
        // Set by the above onDialogMousedown handler
        this.ignoreBackdropClick = false;
        return;
      } // Do nothing if not visible, backdrop click disabled, or element
      // that generated click event is no longer in document body


      if (!this.isVisible || this.noCloseOnBackdrop || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["b" /* contains */])(document.body, event.target)) {
        return;
      } // If backdrop clicked, hide modal


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["b" /* contains */])(this.$refs.content, event.target)) {
        this.hide(TRIGGER_BACKDROP);
      }
    },
    onOk: function onOk() {
      this.hide(BUTTON_OK);
    },
    onCancel: function onCancel() {
      this.hide(BUTTON_CANCEL);
    },
    onClose: function onClose() {
      this.hide(BUTTON_CLOSE);
    },
    onEsc: function onEsc(event) {
      // If ESC pressed, hide modal
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["k" /* CODE_ESC */] && this.isVisible && !this.noCloseOnEsc) {
        this.hide(TRIGGER_ESC);
      }
    },
    // Document focusin listener
    focusHandler: function focusHandler(event) {
      // If focus leaves modal content, bring it back
      var content = this.$refs.content;
      var target = event.target;

      if (this.noEnforceFocus || !this.isTop || !this.isVisible || !content || document === target || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["b" /* contains */])(content, target) || this.computeIgnoreEnforceFocusSelector && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["f" /* closest */])(this.computeIgnoreEnforceFocusSelector, target, true)) {
        return;
      }

      var tabables = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["E" /* getTabables */])(this.$refs.content);
      var bottomTrap = this.$refs['bottom-trap'];
      var topTrap = this.$refs['top-trap'];

      if (bottomTrap && target === bottomTrap) {
        // If user pressed TAB out of modal into our bottom trab trap element
        // Find the first tabable element in the modal content and focus it
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(tabables[0])) {
          // Focus was successful
          return;
        }
      } else if (topTrap && target === topTrap) {
        // If user pressed CTRL-TAB out of modal and into our top tab trap element
        // Find the last tabable element in the modal content and focus it
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(tabables[tabables.length - 1])) {
          // Focus was successful
          return;
        }
      } // Otherwise focus the modal content container


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(content, {
        preventScroll: true
      });
    },
    // Turn on/off focusin listener
    setEnforceFocus: function setEnforceFocus(on) {
      this.listenDocument(on, 'focusin', this.focusHandler);
    },
    // Resize listener
    setResizeEvent: function setResizeEvent(on) {
      this.listenWindow(on, 'resize', this.checkModalOverflow);
      this.listenWindow(on, 'orientationchange', this.checkModalOverflow);
    },
    // Root listener handlers
    showHandler: function showHandler(id, triggerEl) {
      if (id === this.modalId) {
        this.$_returnFocus = triggerEl || this.getActiveElement();
        this.show();
      }
    },
    hideHandler: function hideHandler(id) {
      if (id === this.modalId) {
        this.hide('event');
      }
    },
    toggleHandler: function toggleHandler(id, triggerEl) {
      if (id === this.modalId) {
        this.toggle(triggerEl);
      }
    },
    modalListener: function modalListener(bvEvent) {
      // If another modal opens, close this one if stacking not permitted
      if (this.noStacking && bvEvent.vueTarget !== this) {
        this.hide();
      }
    },
    // Focus control handlers
    focusFirst: function focusFirst() {
      var _this6 = this;

      // Don't try and focus if we are SSR
      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
          var modal = _this6.$refs.modal;
          var content = _this6.$refs.content;

          var activeElement = _this6.getActiveElement(); // If the modal contains the activeElement, we don't do anything


          if (modal && content && !(activeElement && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["b" /* contains */])(content, activeElement))) {
            var ok = _this6.$refs['ok-button'];
            var cancel = _this6.$refs['cancel-button'];
            var close = _this6.$refs['close-button']; // Focus the appropriate button or modal content wrapper

            var autoFocus = _this6.autoFocusButton;
            /* istanbul ignore next */

            var el = autoFocus === BUTTON_OK && ok ? ok.$el || ok : autoFocus === BUTTON_CANCEL && cancel ? cancel.$el || cancel : autoFocus === BUTTON_CLOSE && close ? close.$el || close : content; // Focus the element

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(el);

            if (el === content) {
              // Make sure top of modal is showing (if longer than the viewport)
              _this6.$nextTick(function () {
                modal.scrollTop = 0;
              });
            }
          }
        });
      }
    },
    returnFocusTo: function returnFocusTo() {
      // Prefer `returnFocus` prop over event specified
      // `return_focus` value
      var el = this.returnFocus || this.$_returnFocus || null;
      this.$_returnFocus = null;
      this.$nextTick(function () {
        // Is el a string CSS selector?
        el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["f" /* isString */])(el) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["h" /* select */])(el) : el;

        if (el) {
          // Possibly could be a component reference
          el = el.$el || el;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(el);
        }
      });
    },
    checkModalOverflow: function checkModalOverflow() {
      if (this.isVisible) {
        var modal = this.$refs.modal;
        this.isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
      }
    },
    makeModal: function makeModal(h) {
      // Modal header
      var $header = h();

      if (!this.hideHeader) {
        // TODO: Rename slot to `header` and deprecate `modal-header`
        var $modalHeader = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["G" /* SLOT_NAME_MODAL_HEADER */], this.slotScope);

        if (!$modalHeader) {
          var $closeButton = h();

          if (!this.hideHeaderClose) {
            $closeButton = h(__WEBPACK_IMPORTED_MODULE_26__button_button_close__["a" /* BButtonClose */], {
              props: {
                content: this.headerCloseContent,
                disabled: this.isTransitioning,
                ariaLabel: this.headerCloseLabel,
                textVariant: this.headerCloseVariant || this.headerTextVariant
              },
              on: {
                click: this.onClose
              },
              ref: 'close-button'
            }, // TODO: Rename slot to `header-close` and deprecate `modal-header-close`
            [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["H" /* SLOT_NAME_MODAL_HEADER_CLOSE */])]);
          }

          $modalHeader = [h(this.titleTag, {
            staticClass: 'modal-title',
            class: this.titleClasses,
            attrs: {
              id: this.modalTitleId
            },
            // TODO: Rename slot to `title` and deprecate `modal-title`
            domProps: this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["F" /* SLOT_NAME_MODAL_TITLE */]) ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_html__["a" /* htmlOrText */])(this.titleHtml, this.title)
          }, // TODO: Rename slot to `title` and deprecate `modal-title`
          this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["F" /* SLOT_NAME_MODAL_TITLE */], this.slotScope)), $closeButton];
        }

        $header = h(this.headerTag, {
          staticClass: 'modal-header',
          class: this.headerClasses,
          attrs: {
            id: this.modalHeaderId
          },
          ref: 'header'
        }, [$modalHeader]);
      } // Modal body


      var $body = h('div', {
        staticClass: 'modal-body',
        class: this.bodyClasses,
        attrs: {
          id: this.modalBodyId
        },
        ref: 'body'
      }, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["a" /* SLOT_NAME_DEFAULT */], this.slotScope)); // Modal footer

      var $footer = h();

      if (!this.hideFooter) {
        // TODO: Rename slot to `footer` and deprecate `modal-footer`
        var $modalFooter = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["I" /* SLOT_NAME_MODAL_FOOTER */], this.slotScope);

        if (!$modalFooter) {
          var $cancelButton = h();

          if (!this.okOnly) {
            $cancelButton = h(__WEBPACK_IMPORTED_MODULE_25__button_button__["a" /* BButton */], {
              props: {
                variant: this.cancelVariant,
                size: this.buttonSize,
                disabled: this.cancelDisabled || this.busy || this.isTransitioning
              },
              // TODO: Rename slot to `cancel-button` and deprecate `modal-cancel`
              domProps: this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["J" /* SLOT_NAME_MODAL_CANCEL */]) ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_html__["a" /* htmlOrText */])(this.cancelTitleHtml, this.cancelTitle),
              on: {
                click: this.onCancel
              },
              ref: 'cancel-button'
            }, // TODO: Rename slot to `cancel-button` and deprecate `modal-cancel`
            this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["J" /* SLOT_NAME_MODAL_CANCEL */]));
          }

          var $okButton = h(__WEBPACK_IMPORTED_MODULE_25__button_button__["a" /* BButton */], {
            props: {
              variant: this.okVariant,
              size: this.buttonSize,
              disabled: this.okDisabled || this.busy || this.isTransitioning
            },
            // TODO: Rename slot to `ok-button` and deprecate `modal-ok`
            domProps: this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["K" /* SLOT_NAME_MODAL_OK */]) ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_html__["a" /* htmlOrText */])(this.okTitleHtml, this.okTitle),
            on: {
              click: this.onOk
            },
            ref: 'ok-button'
          }, // TODO: Rename slot to `ok-button` and deprecate `modal-ok`
          this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["K" /* SLOT_NAME_MODAL_OK */]));
          $modalFooter = [$cancelButton, $okButton];
        }

        $footer = h(this.footerTag, {
          staticClass: 'modal-footer',
          class: this.footerClasses,
          attrs: {
            id: this.modalFooterId
          },
          ref: 'footer'
        }, [$modalFooter]);
      } // Assemble modal content


      var $modalContent = h('div', {
        staticClass: 'modal-content',
        class: this.contentClass,
        attrs: {
          id: this.modalContentId,
          tabindex: '-1'
        },
        ref: 'content'
      }, [$header, $body, $footer]); // Tab traps to prevent page from scrolling to next element in
      // tab index during enforce-focus tab cycle

      var $tabTrapTop = h();
      var $tabTrapBottom = h();

      if (this.isVisible && !this.noEnforceFocus) {
        $tabTrapTop = h('span', {
          attrs: {
            tabindex: '0'
          },
          ref: 'top-trap'
        });
        $tabTrapBottom = h('span', {
          attrs: {
            tabindex: '0'
          },
          ref: 'bottom-trap'
        });
      } // Modal dialog wrapper


      var $modalDialog = h('div', {
        staticClass: 'modal-dialog',
        class: this.dialogClasses,
        on: {
          mousedown: this.onDialogMousedown
        },
        ref: 'dialog'
      }, [$tabTrapTop, $modalContent, $tabTrapBottom]); // Modal

      var $modal = h('div', {
        staticClass: 'modal',
        class: this.modalClasses,
        style: this.modalStyles,
        attrs: this.computedModalAttrs,
        on: {
          keydown: this.onEsc,
          click: this.onClickOut
        },
        directives: [{
          name: 'show',
          value: this.isVisible
        }],
        ref: 'modal'
      }, [$modalDialog]); // Wrap modal in transition
      // Sadly, we can't use `BVTransition` here due to the differences in
      // transition durations for `.modal` and `.modal-dialog`
      // At least until https://github.com/vuejs/vue/issues/9986 is resolved

      $modal = h('transition', {
        props: {
          enterClass: '',
          enterToClass: '',
          enterActiveClass: '',
          leaveClass: '',
          leaveActiveClass: '',
          leaveToClass: ''
        },
        on: {
          beforeEnter: this.onBeforeEnter,
          enter: this.onEnter,
          afterEnter: this.onAfterEnter,
          beforeLeave: this.onBeforeLeave,
          leave: this.onLeave,
          afterLeave: this.onAfterLeave
        }
      }, [$modal]); // Modal backdrop

      var $backdrop = h();

      if (!this.hideBackdrop && this.isVisible) {
        $backdrop = h('div', {
          staticClass: 'modal-backdrop',
          attrs: {
            id: this.modalBackdropId
          }
        }, // TODO: Rename slot to `backdrop` and deprecate `modal-backdrop`
        this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_7__constants_slots__["L" /* SLOT_NAME_MODAL_BACKDROP */]));
      }

      $backdrop = h(__WEBPACK_IMPORTED_MODULE_27__transition_bv_transition__["a" /* BVTransition */], {
        props: {
          noFade: this.noFade
        }
      }, [$backdrop]); // Assemble modal and backdrop in an outer <div>

      return h('div', {
        style: this.modalOuterStyle,
        attrs: this.computedAttrs,
        key: "modal-outer-".concat(this[__WEBPACK_IMPORTED_MODULE_0__vue__["e" /* COMPONENT_UID_KEY */]])
      }, [$modal, $backdrop]);
    }
  },
  render: function render(h) {
    if (this.static) {
      return this.lazy && this.isHidden ? h() : this.makeModal(h);
    } else {
      return this.isHidden ? h() : h(__WEBPACK_IMPORTED_MODULE_28__transporter_transporter__["a" /* BVTransporter */], [this.makeModal(h)]);
    }
  }
});

/***/ }),
/* 231 */
/* exports provided: NavPlugin, BNav, BNavItem, BNavText, BNavForm, BNavItemDropdown */
/* exports used: NavPlugin */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/nav/index.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(/*! ./nav */ 174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav_item__ = __webpack_require__(/*! ./nav-item */ 401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_text__ = __webpack_require__(/*! ./nav-text */ 402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_form__ = __webpack_require__(/*! ./nav-form */ 399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__ = __webpack_require__(/*! ./nav-item-dropdown */ 400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dropdown__ = __webpack_require__(/*! ../dropdown */ 166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BNav */
/* unused harmony reexport BNavItem */
/* unused harmony reexport BNavText */
/* unused harmony reexport BNavForm */
/* unused harmony reexport BNavItemDropdown */







var NavPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BNav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* BNav */],
    BNavItem: __WEBPACK_IMPORTED_MODULE_1__nav_item__["a" /* BNavItem */],
    BNavText: __WEBPACK_IMPORTED_MODULE_2__nav_text__["a" /* BNavText */],
    BNavForm: __WEBPACK_IMPORTED_MODULE_3__nav_form__["a" /* BNavForm */],
    BNavItemDropdown: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* BNavItemDropdown */],
    BNavItemDd: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* BNavItemDropdown */],
    BNavDropdown: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* BNavItemDropdown */],
    BNavDd: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* BNavItemDropdown */]
  },
  plugins: {
    DropdownPlugin: __WEBPACK_IMPORTED_MODULE_5__dropdown__["a" /* DropdownPlugin */]
  }
});


/***/ }),
/* 232 */
/* exports provided: props, BProgressBar */
/* exports used: BProgressBar, props */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/progress/progress-bar.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BProgressBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);









 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["b" /* makePropsConfigurable */])({
  animated: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  labelHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  max: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], null),
  precision: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], null),
  showProgress: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  showValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  striped: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["J" /* NAME_PROGRESS_BAR */]); // --- Main component ---
// @vue/component

var BProgressBar = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["J" /* NAME_PROGRESS_BAR */],
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inject: {
    getBvProgress: {
      default:
      /* istanbul ignore next */
      function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  props: props,
  computed: {
    bvProgress: function bvProgress() {
      return this.getBvProgress();
    },
    progressBarClasses: function progressBarClasses() {
      var computedAnimated = this.computedAnimated,
          computedVariant = this.computedVariant;
      return [computedVariant ? "bg-".concat(computedVariant) : '', this.computedStriped || computedAnimated ? 'progress-bar-striped' : '', computedAnimated ? 'progress-bar-animated' : ''];
    },
    progressBarStyles: function progressBarStyles() {
      return {
        width: 100 * (this.computedValue / this.computedMax) + '%'
      };
    },
    computedValue: function computedValue() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(this.value, 0);
    },
    computedMax: function computedMax() {
      // Prefer our max over parent setting
      // Default to `100` for invalid values (`-x`, `0`, `NaN`)
      var max = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(this.max) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(this.bvProgress.max, 0);
      return max > 0 ? max : 100;
    },
    computedPrecision: function computedPrecision() {
      // Prefer our precision over parent setting
      // Default to `0` for invalid values (`-x`, `NaN`)
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["b" /* toInteger */])(this.precision, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["b" /* toInteger */])(this.bvProgress.precision, 0)), 0);
    },
    computedProgress: function computedProgress() {
      var precision = this.computedPrecision;
      var p = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["d" /* mathPow */])(10, precision);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["c" /* toFixed */])(100 * p * this.computedValue / this.computedMax / p, precision);
    },
    computedVariant: function computedVariant() {
      // Prefer our variant over parent setting
      return this.variant || this.bvProgress.variant;
    },
    computedStriped: function computedStriped() {
      // Prefer our striped over parent setting
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["k" /* isBoolean */])(this.striped) ? this.striped : this.bvProgress.striped || false;
    },
    computedAnimated: function computedAnimated() {
      // Prefer our animated over parent setting
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["k" /* isBoolean */])(this.animated) ? this.animated : this.bvProgress.animated || false;
    },
    computedShowProgress: function computedShowProgress() {
      // Prefer our showProgress over parent setting
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["k" /* isBoolean */])(this.showProgress) ? this.showProgress : this.bvProgress.showProgress || false;
    },
    computedShowValue: function computedShowValue() {
      // Prefer our showValue over parent setting
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["k" /* isBoolean */])(this.showValue) ? this.showValue : this.bvProgress.showValue || false;
    }
  },
  render: function render(h) {
    var label = this.label,
        labelHtml = this.labelHtml,
        computedValue = this.computedValue,
        computedPrecision = this.computedPrecision;
    var $children;
    var domProps = {};

    if (this.hasNormalizedSlot()) {
      $children = this.normalizeSlot();
    } else if (label || labelHtml) {
      domProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(labelHtml, label);
    } else if (this.computedShowProgress) {
      $children = this.computedProgress;
    } else if (this.computedShowValue) {
      $children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["c" /* toFixed */])(computedValue, computedPrecision);
    }

    return h('div', {
      staticClass: 'progress-bar',
      class: this.progressBarClasses,
      style: this.progressBarStyles,
      attrs: {
        role: 'progressbar',
        'aria-valuemin': '0',
        'aria-valuemax': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_string__["a" /* toString */])(this.computedMax),
        'aria-valuenow': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["c" /* toFixed */])(computedValue, computedPrecision)
      },
      domProps: domProps
    }, $children);
  }
});

/***/ }),
/* 233 */
/* exports provided: props, BSpinner */
/* exports used: BSpinner */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/spinner/spinner.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])({
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'status'),
  small: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'span'),
  type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'border'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["C" /* NAME_SPINNER */]); // --- Main component ---
// @vue/component

var BSpinner = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["C" /* NAME_SPINNER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots;
    var $slots = slots();
    var $scopedSlots = scopedSlots || {};
    var $label = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["r" /* SLOT_NAME_LABEL */], {}, $scopedSlots, $slots) || props.label;

    if ($label) {
      $label = h('span', {
        staticClass: 'sr-only'
      }, $label);
    }

    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      attrs: {
        role: $label ? props.role || 'status' : null,
        'aria-hidden': $label ? null : 'true'
      },
      class: (_class = {}, _defineProperty(_class, "spinner-".concat(props.type), props.type), _defineProperty(_class, "spinner-".concat(props.type, "-sm"), props.small), _defineProperty(_class, "text-".concat(props.variant), props.variant), _class)
    }), [$label || h()]);
  }
});

/***/ }),
/* 234 */
/* exports provided: props, stackedMixin */
/* exports used: props, stackedMixin */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-stacked.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stackedMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // --- Props ---

var props = {
  stacked: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false)
}; // --- Mixin ---
// @vue/component

var stackedMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  computed: {
    isStacked: function isStacked() {
      var stacked = this.stacked; // `true` when always stacked, or returns breakpoint specified

      return stacked === '' ? true : stacked;
    },
    isStackedAlways: function isStackedAlways() {
      return this.isStacked === true;
    },
    stackedTableClasses: function stackedTableClasses() {
      var isStackedAlways = this.isStackedAlways;
      return _defineProperty({
        'b-table-stacked': isStackedAlways
      }, "b-table-stacked-".concat(this.stacked), !isStackedAlways && this.isStacked);
    }
  }
});

/***/ }),
/* 235 */
/* exports provided: props, tableRendererMixin */
/* exports used: props, tableRendererMixin */
/*!******************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-table-renderer.js ***!
  \******************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tableRendererMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_identity__ = __webpack_require__(/*! ../../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_string__ = __webpack_require__(/*! ../../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_attrs__ = __webpack_require__(/*! ../../../mixins/attrs */ 41);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // Main `<table>` render mixin
// Includes all main table styling options
// --- Props ---

var props = {
  bordered: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  borderless: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  captionTop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  dark: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  fixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  hover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noBorderCollapse: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  outlined: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  responsive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  small: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // If a string, it is assumed to be the table `max-height` value
  stickyHeader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  striped: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tableClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  tableVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */])
}; // --- Mixin ---
// @vue/component

var tableRendererMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_attrs__["a" /* attrsMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvTable: function getBvTable() {
        return _this;
      }
    };
  },
  // Don't place attributes on root element automatically,
  // as table could be wrapped in responsive `<div>`
  inheritAttrs: false,
  props: props,
  computed: {
    isTableSimple: function isTableSimple() {
      return false;
    },
    // Layout related computed props
    isResponsive: function isResponsive() {
      var responsive = this.responsive;
      return responsive === '' ? true : responsive;
    },
    isStickyHeader: function isStickyHeader() {
      var stickyHeader = this.stickyHeader;
      stickyHeader = stickyHeader === '' ? true : stickyHeader;
      return this.isStacked ? false : stickyHeader;
    },
    wrapperClasses: function wrapperClasses() {
      var isResponsive = this.isResponsive;
      return [this.isStickyHeader ? 'b-table-sticky-header' : '', isResponsive === true ? 'table-responsive' : isResponsive ? "table-responsive-".concat(this.responsive) : ''].filter(__WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* identity */]);
    },
    wrapperStyles: function wrapperStyles() {
      var isStickyHeader = this.isStickyHeader;
      return isStickyHeader && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["k" /* isBoolean */])(isStickyHeader) ? {
        maxHeight: isStickyHeader
      } : {};
    },
    tableClasses: function tableClasses() {
      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          hover = _safeVueInstance.hover,
          tableVariant = _safeVueInstance.tableVariant,
          selectableTableClasses = _safeVueInstance.selectableTableClasses,
          stackedTableClasses = _safeVueInstance.stackedTableClasses,
          tableClass = _safeVueInstance.tableClass,
          computedBusy = _safeVueInstance.computedBusy;

      hover = this.isTableSimple ? hover : hover && this.computedItems.length > 0 && !computedBusy;
      return [// User supplied classes
      tableClass, // Styling classes
      {
        'table-striped': this.striped,
        'table-hover': hover,
        'table-dark': this.dark,
        'table-bordered': this.bordered,
        'table-borderless': this.borderless,
        'table-sm': this.small,
        // The following are b-table custom styles
        border: this.outlined,
        'b-table-fixed': this.fixed,
        'b-table-caption-top': this.captionTop,
        'b-table-no-border-collapse': this.noBorderCollapse
      }, tableVariant ? "".concat(this.dark ? 'bg' : 'table', "-").concat(tableVariant) : '', // Stacked table classes
      stackedTableClasses, // Selectable classes
      selectableTableClasses];
    },
    tableAttrs: function tableAttrs() {
      var _safeVueInstance2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          items = _safeVueInstance2.computedItems,
          filteredItems = _safeVueInstance2.filteredItems,
          fields = _safeVueInstance2.computedFields,
          selectableTableAttrs = _safeVueInstance2.selectableTableAttrs,
          computedBusy = _safeVueInstance2.computedBusy;

      var ariaAttrs = this.isTableSimple ? {} : {
        'aria-busy': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_string__["a" /* toString */])(computedBusy),
        'aria-colcount': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_string__["a" /* toString */])(fields.length),
        // Preserve user supplied `aria-describedby`, if provided
        'aria-describedby': this.bvAttrs['aria-describedby'] || this.$refs.caption ? this.captionId : null
      };
      var rowCount = items && filteredItems && filteredItems.length > items.length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_string__["a" /* toString */])(filteredItems.length) : null;
      return _objectSpread(_objectSpread(_objectSpread({
        // We set `aria-rowcount` before merging in `$attrs`,
        // in case user has supplied their own
        'aria-rowcount': rowCount
      }, this.bvAttrs), {}, {
        // Now we can override any `$attrs` here
        id: this.safeId(),
        role: this.bvAttrs.role || 'table'
      }, ariaAttrs), selectableTableAttrs);
    }
  },
  render: function render(h) {
    var _safeVueInstance3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
        wrapperClasses = _safeVueInstance3.wrapperClasses,
        renderCaption = _safeVueInstance3.renderCaption,
        renderColgroup = _safeVueInstance3.renderColgroup,
        renderThead = _safeVueInstance3.renderThead,
        renderTbody = _safeVueInstance3.renderTbody,
        renderTfoot = _safeVueInstance3.renderTfoot;

    var $content = [];

    if (this.isTableSimple) {
      $content.push(this.normalizeSlot());
    } else {
      // Build the `<caption>` (from caption mixin)
      $content.push(renderCaption ? renderCaption() : null); // Build the `<colgroup>`

      $content.push(renderColgroup ? renderColgroup() : null); // Build the `<thead>`

      $content.push(renderThead ? renderThead() : null); // Build the `<tbody>`

      $content.push(renderTbody ? renderTbody() : null); // Build the `<tfoot>`

      $content.push(renderTfoot ? renderTfoot() : null);
    } // Assemble `<table>`


    var $table = h('table', {
      staticClass: 'table b-table',
      class: this.tableClasses,
      attrs: this.tableAttrs,
      key: 'b-table'
    }, $content.filter(__WEBPACK_IMPORTED_MODULE_2__utils_identity__["a" /* identity */])); // Add responsive/sticky wrapper if needed and return table

    return wrapperClasses.length > 0 ? h('div', {
      class: wrapperClasses,
      style: this.wrapperStyles,
      key: 'wrap'
    }, [$table]) : $table;
  }
});

/***/ }),
/* 236 */
/* exports provided: TablePlugin, TableLitePlugin, TableSimplePlugin, BTable, BTableLite, BTableSimple, BTbody, BThead, BTfoot, BTr, BTd, BTh */
/* exports used: TablePlugin, TableLitePlugin, TableSimplePlugin, BTableSimple */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TablePlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableLitePlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TableSimplePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(/*! ./table */ 438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table_lite__ = __webpack_require__(/*! ./table-lite */ 436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__table_simple__ = __webpack_require__(/*! ./table-simple */ 437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tbody__ = __webpack_require__(/*! ./tbody */ 237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__thead__ = __webpack_require__(/*! ./thead */ 238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tfoot__ = __webpack_require__(/*! ./tfoot */ 177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tr__ = __webpack_require__(/*! ./tr */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__td__ = __webpack_require__(/*! ./td */ 120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__th__ = __webpack_require__(/*! ./th */ 178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BTable */
/* unused harmony reexport BTableLite */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__table_simple__["a"]; });
/* unused harmony reexport BTbody */
/* unused harmony reexport BThead */
/* unused harmony reexport BTfoot */
/* unused harmony reexport BTr */
/* unused harmony reexport BTd */
/* unused harmony reexport BTh */










var TableLitePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BTableLite: __WEBPACK_IMPORTED_MODULE_1__table_lite__["a" /* BTableLite */]
  }
});
var TableSimplePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BTableSimple: __WEBPACK_IMPORTED_MODULE_2__table_simple__["a" /* BTableSimple */],
    BTbody: __WEBPACK_IMPORTED_MODULE_3__tbody__["a" /* BTbody */],
    BThead: __WEBPACK_IMPORTED_MODULE_4__thead__["a" /* BThead */],
    BTfoot: __WEBPACK_IMPORTED_MODULE_5__tfoot__["a" /* BTfoot */],
    BTr: __WEBPACK_IMPORTED_MODULE_6__tr__["a" /* BTr */],
    BTd: __WEBPACK_IMPORTED_MODULE_7__td__["a" /* BTd */],
    BTh: __WEBPACK_IMPORTED_MODULE_8__th__["a" /* BTh */]
  }
});
var TablePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BTable: __WEBPACK_IMPORTED_MODULE_0__table__["a" /* BTable */]
  },
  plugins: {
    TableLitePlugin: TableLitePlugin,
    TableSimplePlugin: TableSimplePlugin
  }
});


/***/ }),
/* 237 */
/* exports provided: props, BTbody */
/* exports used: BTbody, props */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/tbody.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTbody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  tbodyTransitionHandlers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */]),
  tbodyTransitionProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["y" /* NAME_TBODY */]); // --- Main component ---
// TODO:
//   In Bootstrap v5, we won't need "sniffing" as table element variants properly inherit
//   to the child elements, so this can be converted to a functional component
// @vue/component

var BTbody = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["y" /* NAME_TBODY */],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvTableRowGroup: function getBvTableRowGroup() {
        return _this;
      }
    };
  },
  inject: {
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    getBvTable: {
      default:
      /* istanbul ignore next */
      function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  inheritAttrs: false,
  props: props,
  computed: {
    bvTable: function bvTable() {
      return this.getBvTable();
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isTbody: function isTbody() {
      return true;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isDark: function isDark() {
      return this.bvTable.dark;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isStacked: function isStacked() {
      return this.bvTable.isStacked;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isResponsive: function isResponsive() {
      return this.bvTable.isResponsive;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    // Sticky headers are only supported in thead
    isStickyHeader: function isStickyHeader() {
      return false;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    // Needed to handle header background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    hasStickyHeader: function hasStickyHeader() {
      return !this.isStacked && this.bvTable.stickyHeader;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    tableVariant: function tableVariant() {
      return this.bvTable.tableVariant;
    },
    isTransitionGroup: function isTransitionGroup() {
      return this.tbodyTransitionProps || this.tbodyTransitionHandlers;
    },
    tbodyAttrs: function tbodyAttrs() {
      return _objectSpread({
        role: 'rowgroup'
      }, this.bvAttrs);
    },
    tbodyProps: function tbodyProps() {
      var tbodyTransitionProps = this.tbodyTransitionProps;
      return tbodyTransitionProps ? _objectSpread(_objectSpread({}, tbodyTransitionProps), {}, {
        tag: 'tbody'
      }) : {};
    }
  },
  render: function render(h) {
    var data = {
      props: this.tbodyProps,
      attrs: this.tbodyAttrs
    };

    if (this.isTransitionGroup) {
      // We use native listeners if a transition group for any delegated events
      data.on = this.tbodyTransitionHandlers || {};
      data.nativeOn = this.bvListeners;
    } else {
      // Otherwise we place any listeners on the tbody element
      data.on = this.bvListeners;
    }

    return h(this.isTransitionGroup ? 'transition-group' : 'tbody', data, this.normalizeSlot());
  }
});

/***/ }),
/* 238 */
/* exports provided: props, BThead */
/* exports used: BThead */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/thead.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BThead; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  // Also sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
  // Supported values: 'lite', 'dark', or `null`
  headVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["x" /* NAME_THEAD */]); // --- Main component ---
// TODO:
//   In Bootstrap v5, we won't need "sniffing" as table element variants properly inherit
//   to the child elements, so this can be converted to a functional component
// @vue/component

var BThead = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["x" /* NAME_THEAD */],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvTableRowGroup: function getBvTableRowGroup() {
        return _this;
      }
    };
  },
  inject: {
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    getBvTable: {
      default:
      /* istanbul ignore next */
      function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  inheritAttrs: false,
  props: props,
  computed: {
    bvTable: function bvTable() {
      return this.getBvTable();
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isThead: function isThead() {
      return true;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isDark: function isDark() {
      return this.bvTable.dark;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isStacked: function isStacked() {
      return this.bvTable.isStacked;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    isResponsive: function isResponsive() {
      return this.bvTable.isResponsive;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    // Needed to handle header background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    // Sticky headers only apply to cells in table `thead`
    isStickyHeader: function isStickyHeader() {
      return !this.isStacked && this.bvTable.stickyHeader;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    // Needed to handle header background classes, due to lack of
    // background color inheritance with Bootstrap v4 table CSS
    hasStickyHeader: function hasStickyHeader() {
      return !this.isStacked && this.bvTable.stickyHeader;
    },
    // Sniffed by `<b-tr>` / `<b-td>` / `<b-th>`
    tableVariant: function tableVariant() {
      return this.bvTable.tableVariant;
    },
    theadClasses: function theadClasses() {
      return [this.headVariant ? "thead-".concat(this.headVariant) : null];
    },
    theadAttrs: function theadAttrs() {
      return _objectSpread({
        role: 'rowgroup'
      }, this.bvAttrs);
    }
  },
  render: function render(h) {
    return h('thead', {
      class: this.theadClasses,
      attrs: this.theadAttrs,
      // Pass down any native listeners
      on: this.bvListeners
    }, this.normalizeSlot());
  }
});

/***/ }),
/* 239 */
/* exports provided: props, BTime */
/* exports used: BTime, props */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/time/time.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_date__ = __webpack_require__(/*! ../../utils/date */ 254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_locale__ = __webpack_require__(/*! ../../utils/locale */ 184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__form_spinbutton_form_spinbutton__ = __webpack_require__(/*! ../form-spinbutton/form-spinbutton */ 220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// BTime control (not form input control)






















 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */],
  defaultValue: ''
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

var NUMERIC = 'numeric'; // --- Helper methods ---

var padLeftZeros = function padLeftZeros(value) {
  return "00".concat(value || '').slice(-2);
};

var parseHMS = function parseHMS(value) {
  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_string__["a" /* toString */])(value);
  var hh = null,
      mm = null,
      ss = null;

  if (__WEBPACK_IMPORTED_MODULE_5__constants_regex__["u" /* RX_TIME */].test(value)) {
    ;

    var _value$split$map = value.split(':').map(function (v) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_number__["b" /* toInteger */])(v, null);
    });

    var _value$split$map2 = _slicedToArray(_value$split$map, 3);

    hh = _value$split$map2[0];
    mm = _value$split$map2[1];
    ss = _value$split$map2[2];
  }

  return {
    hours: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["g" /* isUndefinedOrNull */])(hh) ? null : hh,
    minutes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["g" /* isUndefinedOrNull */])(mm) ? null : mm,
    seconds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["g" /* isUndefinedOrNull */])(ss) ? null : ss,
    ampm: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["g" /* isUndefinedOrNull */])(hh) || hh < 12 ? 0 : 1
  };
};

var formatHMS = function formatHMS(_ref) {
  var hours = _ref.hours,
      minutes = _ref.minutes,
      seconds = _ref.seconds;
  var requireSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["e" /* isNull */])(hours) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["e" /* isNull */])(minutes) || requireSeconds && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["e" /* isNull */])(seconds)) {
    return '';
  }

  var hms = [hours, minutes, requireSeconds ? seconds : 0];
  return hms.map(padLeftZeros).join(':');
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_19__mixins_id__["a" /* props */]), modelProps), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_object__["k" /* pick */])(__WEBPACK_IMPORTED_MODULE_21__form_spinbutton_form_spinbutton__["b" /* props */], ['labelIncrement', 'labelDecrement'])), {}, {
  // ID of label element
  ariaLabelledby: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */]),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  footerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'footer'),
  headerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'header'),
  hidden: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  hideHeader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Explicitly force 12 or 24 hour time
  // Default is to use resolved locale for 12/24 hour display
  // Tri-state: `true` = 12, `false` = 24, `null` = auto
  hour12: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  labelAm: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'AM'),
  labelAmpm: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'AM/PM'),
  labelHours: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Hours'),
  labelMinutes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Minutes'),
  labelNoTimeSelected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'No time selected'),
  labelPm: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'PM'),
  labelSeconds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Seconds'),
  labelSelected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Selected time'),
  locale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  minutesStep: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 1),
  readonly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  secondsStep: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 1),
  // If `true`, show the second spinbutton
  showSeconds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["n" /* NAME_TIME */]); // --- Main component ---
// @vue/component

var BTime = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["n" /* NAME_TIME */],
  mixins: [__WEBPACK_IMPORTED_MODULE_19__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_20__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    var parsed = parseHMS(this[MODEL_PROP_NAME] || '');
    return {
      // Spin button models
      modelHours: parsed.hours,
      modelMinutes: parsed.minutes,
      modelSeconds: parsed.seconds,
      modelAmpm: parsed.ampm,
      // Internal flag to enable aria-live regions
      isLive: false
    };
  },
  computed: {
    computedHMS: function computedHMS() {
      var hours = this.modelHours;
      var minutes = this.modelMinutes;
      var seconds = this.modelSeconds;
      return formatHMS({
        hours: hours,
        minutes: minutes,
        seconds: seconds
      }, this.showSeconds);
    },
    resolvedOptions: function resolvedOptions() {
      // Resolved locale options
      var locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["b" /* concat */])(this.locale).filter(__WEBPACK_IMPORTED_MODULE_10__utils_identity__["a" /* identity */]);
      var options = {
        hour: NUMERIC,
        minute: NUMERIC,
        second: NUMERIC
      };

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["g" /* isUndefinedOrNull */])(this.hour12)) {
        // Force 12 or 24 hour clock
        options.hour12 = !!this.hour12;
      }

      var dtf = new Intl.DateTimeFormat(locale, options);
      var resolved = dtf.resolvedOptions();
      var hour12 = resolved.hour12 || false; // IE 11 doesn't resolve the hourCycle, so we make
      // an assumption and fall back to common values

      var hourCycle = resolved.hourCycle || (hour12 ? 'h12' : 'h23');
      return {
        locale: resolved.locale,
        hour12: hour12,
        hourCycle: hourCycle
      };
    },
    computedLocale: function computedLocale() {
      return this.resolvedOptions.locale;
    },
    computedLang: function computedLang() {
      return (this.computedLocale || '').replace(/-u-.*$/, '');
    },
    computedRTL: function computedRTL() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_locale__["a" /* isLocaleRTL */])(this.computedLang);
    },
    computedHourCycle: function computedHourCycle() {
      // h11, h12, h23, or h24
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Locale/hourCycle
      // h12 - Hour system using 1–12. Corresponds to 'h' in patterns. The 12 hour clock, with midnight starting at 12:00 am
      // h23 - Hour system using 0–23. Corresponds to 'H' in patterns. The 24 hour clock, with midnight starting at 0:00
      // h11 - Hour system using 0–11. Corresponds to 'K' in patterns. The 12 hour clock, with midnight starting at 0:00 am
      // h24 - Hour system using 1–24. Corresponds to 'k' in pattern. The 24 hour clock, with midnight starting at 24:00
      // For h12 or h24, we visually format 00 hours as 12
      return this.resolvedOptions.hourCycle;
    },
    is12Hour: function is12Hour() {
      return !!this.resolvedOptions.hour12;
    },
    context: function context() {
      return {
        locale: this.computedLocale,
        isRTL: this.computedRTL,
        hourCycle: this.computedHourCycle,
        hour12: this.is12Hour,
        hours: this.modelHours,
        minutes: this.modelMinutes,
        seconds: this.showSeconds ? this.modelSeconds : 0,
        value: this.computedHMS,
        formatted: this.formattedTimeString
      };
    },
    valueId: function valueId() {
      return this.safeId() || null;
    },
    computedAriaLabelledby: function computedAriaLabelledby() {
      return [this.ariaLabelledby, this.valueId].filter(__WEBPACK_IMPORTED_MODULE_10__utils_identity__["a" /* identity */]).join(' ') || null;
    },
    timeFormatter: function timeFormatter() {
      // Returns a formatter function reference
      // The formatter converts the time to a localized string
      var options = {
        hour12: this.is12Hour,
        hourCycle: this.computedHourCycle,
        hour: NUMERIC,
        minute: NUMERIC,
        timeZone: 'UTC'
      };

      if (this.showSeconds) {
        options.second = NUMERIC;
      } // Formats the time as a localized string


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_date__["a" /* createDateFormatter */])(this.computedLocale, options);
    },
    numberFormatter: function numberFormatter() {
      // Returns a formatter function reference
      // The formatter always formats as 2 digits and is localized
      var nf = new Intl.NumberFormat(this.computedLocale, {
        style: 'decimal',
        minimumIntegerDigits: 2,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        notation: 'standard'
      });
      return nf.format;
    },
    formattedTimeString: function formattedTimeString() {
      var hours = this.modelHours;
      var minutes = this.modelMinutes;
      var seconds = this.showSeconds ? this.modelSeconds || 0 : 0;

      if (this.computedHMS) {
        return this.timeFormatter(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_date__["b" /* createDate */])(Date.UTC(0, 0, 1, hours, minutes, seconds)));
      }

      return this.labelNoTimeSelected || ' ';
    },
    spinScopedSlots: function spinScopedSlots() {
      var h = this.$createElement;
      return {
        increment: function increment(_ref2) {
          var hasFocus = _ref2.hasFocus;
          return h(__WEBPACK_IMPORTED_MODULE_22__icons_icons__["_344" /* BIconChevronUp */], {
            props: {
              scale: hasFocus ? 1.5 : 1.25
            },
            attrs: {
              'aria-hidden': 'true'
            }
          });
        },
        decrement: function decrement(_ref3) {
          var hasFocus = _ref3.hasFocus;
          return h(__WEBPACK_IMPORTED_MODULE_22__icons_icons__["_344" /* BIconChevronUp */], {
            props: {
              flipV: true,
              scale: hasFocus ? 1.5 : 1.25
            },
            attrs: {
              'aria-hidden': 'true'
            }
          });
        }
      };
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue, oldValue) {
    if (newValue !== oldValue && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_loose_equal__["a" /* looseEqual */])(parseHMS(newValue), parseHMS(this.computedHMS))) {
      var _parseHMS = parseHMS(newValue),
          hours = _parseHMS.hours,
          minutes = _parseHMS.minutes,
          seconds = _parseHMS.seconds,
          ampm = _parseHMS.ampm;

      this.modelHours = hours;
      this.modelMinutes = minutes;
      this.modelSeconds = seconds;
      this.modelAmpm = ampm;
    }
  }), _defineProperty(_watch, "computedHMS", function computedHMS(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.$emit(MODEL_EVENT_NAME, newValue);
    }
  }), _defineProperty(_watch, "context", function context(newValue, oldValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["z" /* EVENT_NAME_CONTEXT */], newValue);
    }
  }), _defineProperty(_watch, "modelAmpm", function modelAmpm(newValue, oldValue) {
    var _this = this;

    if (newValue !== oldValue) {
      var hours = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_inspect__["e" /* isNull */])(this.modelHours) ? 0 : this.modelHours;
      this.$nextTick(function () {
        if (newValue === 0 && hours > 11) {
          // Switched to AM
          _this.modelHours = hours - 12;
        } else if (newValue === 1 && hours < 12) {
          // Switched to PM
          _this.modelHours = hours + 12;
        }
      });
    }
  }), _defineProperty(_watch, "modelHours", function modelHours(newHours, oldHours) {
    if (newHours !== oldHours) {
      this.modelAmpm = newHours > 11 ? 1 : 0;
    }
  }), _watch),
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["z" /* EVENT_NAME_CONTEXT */], _this2.context);
    });
  },
  mounted: function mounted() {
    this.setLive(true);
  },

  /* istanbul ignore next */
  activated: function activated() {
    this.setLive(true);
  },

  /* istanbul ignore next */
  deactivated: function deactivated() {
    this.setLive(false);
  },
  beforeDestroy: function beforeDestroy() {
    this.setLive(false);
  },
  methods: {
    // Public methods
    focus: function focus() {
      if (!this.disabled) {
        // We focus the first spin button
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["n" /* attemptFocus */])(this.$refs.spinners[0]);
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        var activeElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["B" /* getActiveElement */])();

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["b" /* contains */])(this.$el, activeElement)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["A" /* attemptBlur */])(activeElement);
        }
      }
    },
    // Formatters for the spin buttons
    formatHours: function formatHours(hh) {
      var hourCycle = this.computedHourCycle; // We always store 0-23, but format based on h11/h12/h23/h24 formats

      hh = this.is12Hour && hh > 12 ? hh - 12 : hh; // Determine how 00:00 and 12:00 are shown

      hh = hh === 0 && hourCycle === 'h12' ? 12 : hh === 0 && hourCycle === 'h24' ?
      /* istanbul ignore next */
      24 : hh === 12 && hourCycle === 'h11' ?
      /* istanbul ignore next */
      0 : hh;
      return this.numberFormatter(hh);
    },
    formatMinutes: function formatMinutes(mm) {
      return this.numberFormatter(mm);
    },
    formatSeconds: function formatSeconds(ss) {
      return this.numberFormatter(ss);
    },
    formatAmpm: function formatAmpm(ampm) {
      // These should come from label props???
      // `ampm` should always be a value of `0` or `1`
      return ampm === 0 ? this.labelAm : ampm === 1 ? this.labelPm : '';
    },
    // Spinbutton on change handlers
    setHours: function setHours(value) {
      this.modelHours = value;
    },
    setMinutes: function setMinutes(value) {
      this.modelMinutes = value;
    },
    setSeconds: function setSeconds(value) {
      this.modelSeconds = value;
    },
    setAmpm: function setAmpm(value) {
      this.modelAmpm = value;
    },
    onSpinLeftRight: function onSpinLeftRight() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var type = event.type,
          keyCode = event.keyCode;

      if (!this.disabled && type === 'keydown' && (keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["c" /* CODE_LEFT */] || keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["d" /* CODE_RIGHT */])) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_events__["f" /* stopEvent */])(event);
        var spinners = this.$refs.spinners || [];
        var index = spinners.map(function (cmp) {
          return !!cmp.hasFocus;
        }).indexOf(true);
        index = index + (keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["c" /* CODE_LEFT */] ? -1 : 1);
        index = index >= spinners.length ? 0 : index < 0 ? spinners.length - 1 : index;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["n" /* attemptFocus */])(spinners[index]);
      }
    },
    setLive: function setLive(on) {
      var _this3 = this;

      if (on) {
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["a" /* requestAF */])(function () {
            _this3.isLive = true;
          });
        });
      } else {
        this.isLive = false;
      }
    }
  },
  render: function render(h) {
    var _this4 = this;

    // If hidden, we just render a placeholder comment

    /* istanbul ignore if */
    if (this.hidden) {
      return h();
    }

    var disabled = this.disabled,
        readonly = this.readonly,
        locale = this.computedLocale,
        ariaLabelledby = this.computedAriaLabelledby,
        labelIncrement = this.labelIncrement,
        labelDecrement = this.labelDecrement,
        valueId = this.valueId,
        focusHandler = this.focus;
    var spinIds = []; // Helper method to render a spinbutton

    var makeSpinbutton = function makeSpinbutton(handler, key, classes) {
      var spinbuttonProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var id = _this4.safeId("_spinbutton_".concat(key, "_")) || null;
      spinIds.push(id);
      return h(__WEBPACK_IMPORTED_MODULE_21__form_spinbutton_form_spinbutton__["a" /* BFormSpinbutton */], _defineProperty({
        class: classes,
        props: _objectSpread({
          id: id,
          placeholder: '--',
          vertical: true,
          required: true,
          disabled: disabled,
          readonly: readonly,
          locale: locale,
          labelIncrement: labelIncrement,
          labelDecrement: labelDecrement,
          wrap: true,
          ariaControls: valueId,
          min: 0
        }, spinbuttonProps),
        scopedSlots: _this4.spinScopedSlots,
        on: {
          // We use `change` event to minimize SR verbosity
          // As the spinbutton will announce each value change
          // and we don't want the formatted time to be announced
          // on each value input if repeat is happening
          change: handler
        },
        key: key,
        ref: 'spinners'
      }, __WEBPACK_IMPORTED_MODULE_0__vue__["g" /* REF_FOR_KEY */], true));
    }; // Helper method to return a "colon" separator


    var makeColon = function makeColon() {
      return h('div', {
        staticClass: 'd-flex flex-column',
        class: {
          'text-muted': disabled || readonly
        },
        attrs: {
          'aria-hidden': 'true'
        }
      }, [h(__WEBPACK_IMPORTED_MODULE_22__icons_icons__["_346" /* BIconCircleFill */], {
        props: {
          shiftV: 4,
          scale: 0.5
        }
      }), h(__WEBPACK_IMPORTED_MODULE_22__icons_icons__["_346" /* BIconCircleFill */], {
        props: {
          shiftV: -4,
          scale: 0.5
        }
      })]);
    };

    var $spinners = []; // Hours

    $spinners.push(makeSpinbutton(this.setHours, 'hours', 'b-time-hours', {
      value: this.modelHours,
      max: 23,
      step: 1,
      formatterFn: this.formatHours,
      ariaLabel: this.labelHours
    })); // Spacer

    $spinners.push(makeColon()); // Minutes

    $spinners.push(makeSpinbutton(this.setMinutes, 'minutes', 'b-time-minutes', {
      value: this.modelMinutes,
      max: 59,
      step: this.minutesStep || 1,
      formatterFn: this.formatMinutes,
      ariaLabel: this.labelMinutes
    }));

    if (this.showSeconds) {
      // Spacer
      $spinners.push(makeColon()); // Seconds

      $spinners.push(makeSpinbutton(this.setSeconds, 'seconds', 'b-time-seconds', {
        value: this.modelSeconds,
        max: 59,
        step: this.secondsStep || 1,
        formatterFn: this.formatSeconds,
        ariaLabel: this.labelSeconds
      }));
    } // AM/PM ?
    // depends on client settings, shouldn't be rendered on server


    if (this.isLive && this.is12Hour) {
      // TODO:
      //   If locale is RTL, unshift this instead of push?
      //   And switch class `ml-2` to `mr-2`
      //   Note some LTR locales (i.e. zh) also place AM/PM to the left
      $spinners.push(makeSpinbutton(this.setAmpm, 'ampm', 'b-time-ampm', {
        value: this.modelAmpm,
        max: 1,
        formatterFn: this.formatAmpm,
        ariaLabel: this.labelAmpm,
        // We set `required` as `false`, since this always has a value
        required: false
      }));
    } // Assemble spinners


    $spinners = h('div', {
      staticClass: 'd-flex align-items-center justify-content-center mx-auto',
      attrs: {
        role: 'group',
        tabindex: disabled || readonly ? null : '-1',
        'aria-labelledby': ariaLabelledby
      },
      on: {
        keydown: this.onSpinLeftRight,
        click:
        /* istanbul ignore next */
        function click(event) {
          if (event.target === event.currentTarget) {
            focusHandler();
          }
        }
      }
    }, $spinners); // Selected type display

    var $value = h('output', {
      staticClass: 'form-control form-control-sm text-center',
      class: {
        disabled: disabled || readonly
      },
      attrs: {
        id: valueId,
        role: 'status',
        for: spinIds.filter(__WEBPACK_IMPORTED_MODULE_10__utils_identity__["a" /* identity */]).join(' ') || null,
        tabindex: disabled ? null : '-1',
        'aria-live': this.isLive ? 'polite' : 'off',
        'aria-atomic': 'true'
      },
      on: {
        // Transfer focus/click to focus hours spinner
        click: focusHandler,
        focus: focusHandler
      }
    }, [h('bdi', this.formattedTimeString), this.computedHMS ? h('span', {
      staticClass: 'sr-only'
    }, " (".concat(this.labelSelected, ") ")) : '']);
    var $header = h(this.headerTag, {
      staticClass: 'b-time-header',
      class: {
        'sr-only': this.hideHeader
      }
    }, [$value]);
    var $content = this.normalizeSlot();
    var $footer = $content ? h(this.footerTag, {
      staticClass: 'b-time-footer'
    }, $content) : h();
    return h('div', {
      staticClass: 'b-time d-inline-flex flex-column text-center',
      attrs: {
        role: 'group',
        lang: this.computedLang || null,
        'aria-labelledby': ariaLabelledby || null,
        'aria-disabled': disabled ? 'true' : null,
        'aria-readonly': readonly && !disabled ? 'true' : null
      }
    }, [$header, $spinners, $footer]);
  }
});

/***/ }),
/* 240 */
/* exports provided: props, BToast */
/* exports used: BToast, props */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/toast/toast.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BToast; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portal_vue__ = __webpack_require__(/*! portal-vue */ 631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bv_event_class__ = __webpack_require__(/*! ../../utils/bv-event.class */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_router__ = __webpack_require__(/*! ../../utils/router */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_create_new_child_component__ = __webpack_require__(/*! ../../utils/create-new-child-component */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_scoped_style__ = __webpack_require__(/*! ../../mixins/scoped-style */ 253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__button_button_close__ = __webpack_require__(/*! ../button/button-close */ 107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__link_link__ = __webpack_require__(/*! ../link/link */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__transition_bv_transition__ = __webpack_require__(/*! ../transition/bv-transition */ 108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__toaster__ = __webpack_require__(/*! ./toaster */ 241);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_model__["a" /* makeModelMixin */])('visible', {
  type: __WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */],
  defaultValue: false,
  event: __WEBPACK_IMPORTED_MODULE_3__constants_events__["w" /* EVENT_NAME_CHANGE */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

var MIN_DURATION = 1000; // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["k" /* pick */])(__WEBPACK_IMPORTED_MODULE_22__link_link__["b" /* props */], ['href', 'to']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_17__mixins_id__["a" /* props */]), modelProps), linkProps), {}, {
  appendToast: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  autoHideDelay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 5000),
  bodyClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  headerClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  headerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'header'),
  // Switches role to 'status' and aria-live to 'polite'
  isStatus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noAutoHide: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noCloseButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noFade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noHoverPause: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  solid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Render the toast in place, rather than in a portal-target
  static: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */]),
  toastClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  toaster: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'b-toaster-top-right'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_2__constants_components__["l" /* NAME_TOAST */]); // --- Main component ---
// @vue/component

var BToast = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_2__constants_components__["l" /* NAME_TOAST */],
  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_17__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_18__mixins_listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_19__mixins_normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_20__mixins_scoped_style__["a" /* scopedStyleMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      isMounted: false,
      doRender: false,
      localShow: false,
      isTransitioning: false,
      isHiding: false,
      order: 0,
      dismissStarted: 0,
      resumeDismiss: 0
    };
  },
  computed: {
    toastClasses: function toastClasses() {
      var appendToast = this.appendToast,
          variant = this.variant;
      return _defineProperty({
        'b-toast-solid': this.solid,
        'b-toast-append': appendToast,
        'b-toast-prepend': !appendToast
      }, "b-toast-".concat(variant), variant);
    },
    slotScope: function slotScope() {
      var hide = this.hide;
      return {
        hide: hide
      };
    },
    computedDuration: function computedDuration() {
      // Minimum supported duration is 1 second
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(this.autoHideDelay, 0), MIN_DURATION);
    },
    computedToaster: function computedToaster() {
      return String(this.toaster);
    },
    transitionHandlers: function transitionHandlers() {
      return {
        beforeEnter: this.onBeforeEnter,
        afterEnter: this.onAfterEnter,
        beforeLeave: this.onBeforeLeave,
        afterLeave: this.onAfterLeave
      };
    },
    computedAttrs: function computedAttrs() {
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        id: this.safeId(),
        tabindex: '0'
      });
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    this[newValue ? 'show' : 'hide']();
  }), _defineProperty(_watch, "localShow", function localShow(newValue) {
    if (newValue !== this[MODEL_PROP_NAME]) {
      this.$emit(MODEL_EVENT_NAME, newValue);
    }
  }), _defineProperty(_watch, "toaster", function toaster() {
    // If toaster target changed, make sure toaster exists
    this.$nextTick(this.ensureToaster);
  }), _defineProperty(_watch, "static", function _static(newValue) {
    // If static changes to true, and the toast is showing,
    // ensure the toaster target exists
    if (newValue && this.localShow) {
      this.ensureToaster();
    }
  }), _watch),
  created: function created() {
    // Create private non-reactive props
    this.$_dismissTimer = null;
  },
  mounted: function mounted() {
    var _this = this;

    this.isMounted = true;
    this.$nextTick(function () {
      if (_this[MODEL_PROP_NAME]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["a" /* requestAF */])(function () {
          _this.show();
        });
      }
    }); // Listen for global $root show events

    this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["l" /* NAME_TOAST */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["a" /* EVENT_NAME_SHOW */]), function (id) {
      if (id === _this.safeId()) {
        _this.show();
      }
    }); // Listen for global $root hide events

    this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["l" /* NAME_TOAST */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["e" /* EVENT_NAME_HIDE */]), function (id) {
      if (!id || id === _this.safeId()) {
        _this.hide();
      }
    }); // Make sure we hide when toaster is destroyed

    /* istanbul ignore next: difficult to test */

    this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["k" /* NAME_TOASTER */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["v" /* EVENT_NAME_DESTROYED */]), function (toaster) {
      /* istanbul ignore next */
      if (toaster === _this.computedToaster) {
        _this.hide();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearDismissTimer();
  },
  methods: {
    show: function show() {
      var _this2 = this;

      if (!this.localShow) {
        this.ensureToaster();
        var showEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["a" /* EVENT_NAME_SHOW */]);
        this.emitEvent(showEvent);
        this.dismissStarted = this.resumeDismiss = 0;
        this.order = Date.now() * (this.appendToast ? 1 : -1);
        this.isHiding = false;
        this.doRender = true;
        this.$nextTick(function () {
          // We show the toast after we have rendered the portal and b-toast wrapper
          // so that screen readers will properly announce the toast
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["a" /* requestAF */])(function () {
            _this2.localShow = true;
          });
        });
      }
    },
    hide: function hide() {
      var _this3 = this;

      if (this.localShow) {
        var hideEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["e" /* EVENT_NAME_HIDE */]);
        this.emitEvent(hideEvent);
        this.setHoverHandler(false);
        this.dismissStarted = this.resumeDismiss = 0;
        this.clearDismissTimer();
        this.isHiding = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["a" /* requestAF */])(function () {
          _this3.localShow = false;
        });
      }
    },
    buildEvent: function buildEvent(type) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new __WEBPACK_IMPORTED_MODULE_6__utils_bv_event_class__["a" /* BvEvent */](type, _objectSpread(_objectSpread({
        cancelable: false,
        target: this.$el || null,
        relatedTarget: null
      }, options), {}, {
        vueTarget: this,
        componentId: this.safeId()
      }));
    },
    emitEvent: function emitEvent(bvEvent) {
      var type = bvEvent.type;
      this.emitOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["l" /* NAME_TOAST */], type), bvEvent);
      this.$emit(type, bvEvent);
    },
    ensureToaster: function ensureToaster() {
      if (this.static) {
        return;
      }

      var computedToaster = this.computedToaster;

      if (!__WEBPACK_IMPORTED_MODULE_0_portal_vue__["Wormhole"].hasTarget(computedToaster)) {
        var div = document.createElement('div');
        document.body.appendChild(div);
        var toaster = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_create_new_child_component__["a" /* createNewChildComponent */])(this.bvEventRoot, __WEBPACK_IMPORTED_MODULE_24__toaster__["a" /* BToaster */], {
          propsData: {
            name: computedToaster
          }
        });
        toaster.$mount(div);
      }
    },
    startDismissTimer: function startDismissTimer() {
      this.clearDismissTimer();

      if (!this.noAutoHide) {
        this.$_dismissTimer = setTimeout(this.hide, this.resumeDismiss || this.computedDuration);
        this.dismissStarted = Date.now();
        this.resumeDismiss = 0;
      }
    },
    clearDismissTimer: function clearDismissTimer() {
      clearTimeout(this.$_dismissTimer);
      this.$_dismissTimer = null;
    },
    setHoverHandler: function setHoverHandler(on) {
      var el = this.$refs['b-toast'];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["e" /* eventOnOff */])(on, el, 'mouseenter', this.onPause, __WEBPACK_IMPORTED_MODULE_3__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["e" /* eventOnOff */])(on, el, 'mouseleave', this.onUnPause, __WEBPACK_IMPORTED_MODULE_3__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
    },
    onPause: function onPause() {
      // Determine time remaining, and then pause timer
      if (this.noAutoHide || this.noHoverPause || !this.$_dismissTimer || this.resumeDismiss) {
        return;
      }

      var passed = Date.now() - this.dismissStarted;

      if (passed > 0) {
        this.clearDismissTimer();
        this.resumeDismiss = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["a" /* mathMax */])(this.computedDuration - passed, MIN_DURATION);
      }
    },
    onUnPause: function onUnPause() {
      // Restart timer with max of time remaining or 1 second
      if (this.noAutoHide || this.noHoverPause || !this.resumeDismiss) {
        this.resumeDismiss = this.dismissStarted = 0;
        return;
      }

      this.startDismissTimer();
    },
    onLinkClick: function onLinkClick() {
      var _this4 = this;

      // We delay the close to allow time for the
      // browser to process the link click
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["a" /* requestAF */])(function () {
          _this4.hide();
        });
      });
    },
    onBeforeEnter: function onBeforeEnter() {
      this.isTransitioning = true;
    },
    onAfterEnter: function onAfterEnter() {
      this.isTransitioning = false;
      var hiddenEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["d" /* EVENT_NAME_SHOWN */]);
      this.emitEvent(hiddenEvent);
      this.startDismissTimer();
      this.setHoverHandler(true);
    },
    onBeforeLeave: function onBeforeLeave() {
      this.isTransitioning = true;
    },
    onAfterLeave: function onAfterLeave() {
      this.isTransitioning = false;
      this.order = 0;
      this.resumeDismiss = this.dismissStarted = 0;
      var hiddenEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_3__constants_events__["b" /* EVENT_NAME_HIDDEN */]);
      this.emitEvent(hiddenEvent);
      this.doRender = false;
    },
    // Render helper for generating the toast
    makeToast: function makeToast(h) {
      var _this5 = this;

      var title = this.title,
          slotScope = this.slotScope;
      var link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_router__["a" /* isLink */])(this);
      var $headerContent = [];
      var $title = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_5__constants_slots__["b" /* SLOT_NAME_TOAST_TITLE */], slotScope);

      if ($title) {
        $headerContent.push($title);
      } else if (title) {
        $headerContent.push(h('strong', {
          staticClass: 'mr-2'
        }, title));
      }

      if (!this.noCloseButton) {
        $headerContent.push(h(__WEBPACK_IMPORTED_MODULE_21__button_button_close__["a" /* BButtonClose */], {
          staticClass: 'ml-auto mb-1',
          on: {
            click: function click() {
              _this5.hide();
            }
          }
        }));
      }

      var $header = h();

      if ($headerContent.length > 0) {
        $header = h(this.headerTag, {
          staticClass: 'toast-header',
          class: this.headerClass
        }, $headerContent);
      }

      var $body = h(link ? __WEBPACK_IMPORTED_MODULE_22__link_link__["a" /* BLink */] : 'div', {
        staticClass: 'toast-body',
        class: this.bodyClass,
        props: link ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["c" /* pluckProps */])(linkProps, this) : {},
        on: link ? {
          click: this.onLinkClick
        } : {}
      }, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_5__constants_slots__["a" /* SLOT_NAME_DEFAULT */], slotScope));
      return h('div', {
        staticClass: 'toast',
        class: this.toastClass,
        attrs: this.computedAttrs,
        key: "toast-".concat(this[__WEBPACK_IMPORTED_MODULE_1__vue__["e" /* COMPONENT_UID_KEY */]]),
        ref: 'toast'
      }, [$header, $body]);
    }
  },
  render: function render(h) {
    if (!this.doRender || !this.isMounted) {
      return h();
    }

    var order = this.order,
        isStatic = this.static,
        isHiding = this.isHiding,
        isStatus = this.isStatus;
    var name = "b-toast-".concat(this[__WEBPACK_IMPORTED_MODULE_1__vue__["e" /* COMPONENT_UID_KEY */]]);
    var $toast = h('div', {
      staticClass: 'b-toast',
      class: this.toastClasses,
      attrs: _objectSpread(_objectSpread({}, isStatic ? {} : this.scopedStyleAttrs), {}, {
        id: this.safeId('_toast_outer'),
        role: isHiding ? null : isStatus ? 'status' : 'alert',
        'aria-live': isHiding ? null : isStatus ? 'polite' : 'assertive',
        'aria-atomic': isHiding ? null : 'true'
      }),
      key: name,
      ref: 'b-toast'
    }, [h(__WEBPACK_IMPORTED_MODULE_23__transition_bv_transition__["a" /* BVTransition */], {
      props: {
        noFade: this.noFade
      },
      on: this.transitionHandlers
    }, [this.localShow ? this.makeToast(h) : h()])]);
    return h(__WEBPACK_IMPORTED_MODULE_0_portal_vue__["Portal"], {
      props: {
        name: name,
        to: this.computedToaster,
        order: order,
        slim: true,
        disabled: isStatic
      }
    }, [$toast]);
  }
});

/***/ }),
/* 241 */
/* exports provided: DefaultTransition, props, BToaster */
/* exports used: BToaster */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/toast/toaster.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultTransition */
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BToaster; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portal_vue__ = __webpack_require__(/*! portal-vue */ 631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_warn__ = __webpack_require__(/*! ../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);










 // --- Helper components ---
// @vue/component

var DefaultTransition = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  data: function data() {
    return {
      // Transition classes base name
      name: 'b-toaster'
    };
  },
  methods: {
    onAfterEnter: function onAfterEnter(el) {
      var _this = this;

      // Work around a Vue.js bug where `*-enter-to` class is not removed
      // See: https://github.com/vuejs/vue/pull/7901
      // The `*-move` class is also stuck on elements that moved,
      // but there are no JavaScript hooks to handle after move
      // See: https://github.com/vuejs/vue/pull/7906
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["a" /* requestAF */])(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["q" /* removeClass */])(el, "".concat(_this.name, "-enter-to"));
      });
    }
  },
  render: function render(h) {
    return h('transition-group', {
      props: {
        tag: 'div',
        name: this.name
      },
      on: {
        afterEnter: this.onAfterEnter
      }
    }, this.normalizeSlot());
  }
}); // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["b" /* makePropsConfigurable */])({
  // Allowed: 'true' or 'false' or `null`
  ariaAtomic: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */]),
  ariaLive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */]),
  name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], undefined, true),
  // Required
  // Aria role
  role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_2__constants_components__["k" /* NAME_TOASTER */]); // --- Main component ---
// @vue/component

var BToaster = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_2__constants_components__["k" /* NAME_TOASTER */],
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_listen_on_root__["a" /* listenOnRootMixin */]],
  props: props,
  data: function data() {
    return {
      // We don't render on SSR or if a an existing target found
      doRender: false,
      dead: false,
      // Toaster names cannot change once created
      staticName: this.name
    };
  },
  beforeMount: function beforeMount() {
    var name = this.name;
    this.staticName = name;
    /* istanbul ignore if */

    if (__WEBPACK_IMPORTED_MODULE_0_portal_vue__["Wormhole"].hasTarget(name)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_warn__["a" /* warn */])("A \"<portal-target>\" with name \"".concat(name, "\" already exists in the document."), __WEBPACK_IMPORTED_MODULE_2__constants_components__["k" /* NAME_TOASTER */]);
      this.dead = true;
    } else {
      this.doRender = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Let toasts made with `this.$bvToast.toast()` know that this toaster
    // is being destroyed and should should also destroy/hide themselves
    if (this.doRender) {
      this.emitOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["k" /* NAME_TOASTER */], __WEBPACK_IMPORTED_MODULE_3__constants_events__["v" /* EVENT_NAME_DESTROYED */]), this.name);
    }
  },
  destroyed: function destroyed() {
    // Remove from DOM if needed
    var $el = this.$el;
    /* istanbul ignore next: difficult to test */

    if ($el && $el.parentNode) {
      $el.parentNode.removeChild($el);
    }
  },
  render: function render(h) {
    var $toaster = h('div', {
      class: ['d-none', {
        'b-dead-toaster': this.dead
      }]
    });

    if (this.doRender) {
      var $target = h(__WEBPACK_IMPORTED_MODULE_0_portal_vue__["PortalTarget"], {
        staticClass: 'b-toaster-slot',
        props: {
          name: this.staticName,
          multiple: true,
          tag: 'div',
          slim: false,
          // transition: this.transition || DefaultTransition
          transition: DefaultTransition
        }
      });
      $toaster = h('div', {
        staticClass: 'b-toaster',
        class: [this.staticName],
        attrs: {
          id: this.staticName,
          // Fallback to null to make sure attribute doesn't exist
          role: this.role || null,
          'aria-live': this.ariaLive,
          'aria-atomic': this.ariaAtomic
        }
      }, [$target]);
    }

    return $toaster;
  }
});

/***/ }),
/* 242 */
/* exports provided: BVTooltip */
/* exports used: BVTooltip */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tooltip/helpers/bv-tooltip.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_use_parent__ = __webpack_require__(/*! ../../../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_element_to_vue_instance_registry__ = __webpack_require__(/*! ../../../utils/element-to-vue-instance-registry */ 465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_get_scope_id__ = __webpack_require__(/*! ../../../utils/get-scope-id */ 140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_identity__ = __webpack_require__(/*! ../../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_loose_equal__ = __webpack_require__(/*! ../../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_math__ = __webpack_require__(/*! ../../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_noop__ = __webpack_require__(/*! ../../../utils/noop */ 256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_warn__ = __webpack_require__(/*! ../../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_bv_event_class__ = __webpack_require__(/*! ../../../utils/bv-event.class */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_create_new_child_component__ = __webpack_require__(/*! ../../../utils/create-new-child-component */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_listen_on_root__ = __webpack_require__(/*! ../../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__bv_tooltip_template__ = __webpack_require__(/*! ./bv-tooltip-template */ 445);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Tooltip "Class" (Built as a renderless Vue instance)
//
// Handles trigger events, etc.
// Instantiates template on demand




















 // --- Constants ---
// Modal container selector for appending tooltip/popover

var MODAL_SELECTOR = '.modal-content'; // Modal `$root` hidden event

var ROOT_EVENT_NAME_MODAL_HIDDEN = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["b" /* NAME_MODAL */], __WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */]); // Sidebar container selector for appending tooltip/popover

var SIDEBAR_SELECTOR = '.b-sidebar'; // For finding the container to append to

var CONTAINER_SELECTOR = [MODAL_SELECTOR, SIDEBAR_SELECTOR].join(', '); // For dropdown sniffing

var DROPDOWN_CLASS = 'dropdown';
var DROPDOWN_OPEN_SELECTOR = '.dropdown-menu.show'; // Data attribute to temporary store the `title` attribute's value

var DATA_TITLE_ATTR = 'data-original-title'; // Data specific to popper and template
// We don't use props, as we need reactivity (we can't pass reactive props)

var templateData = {
  // Text string or Scoped slot function
  title: '',
  // Text string or Scoped slot function
  content: '',
  // String
  variant: null,
  // String, Array, Object
  customClass: null,
  // String or array of Strings (overwritten by BVPopper)
  triggers: '',
  // String (overwritten by BVPopper)
  placement: 'auto',
  // String or array of strings
  fallbackPlacement: 'flip',
  // Element or Component reference (or function that returns element) of
  // the element that will have the trigger events bound, and is also
  // default element for positioning
  target: null,
  // HTML ID, Element or Component reference
  container: null,
  // 'body'
  // Boolean
  noFade: false,
  // 'scrollParent', 'viewport', 'window', Element, or Component reference
  boundary: 'scrollParent',
  // Tooltip/popover will try and stay away from
  // boundary edge by this many pixels (Number)
  boundaryPadding: 5,
  // Arrow offset (Number)
  offset: 0,
  // Hover/focus delay (Number or Object)
  delay: 0,
  // Arrow of Tooltip/popover will try and stay away from
  // the edge of tooltip/popover edge by this many pixels
  arrowPadding: 6,
  // Interactive state (Boolean)
  interactive: true,
  // Disabled state (Boolean)
  disabled: false,
  // ID to use for tooltip/popover
  id: null,
  // Flag used by directives only, for HTML content
  html: false
}; // --- Main component ---
// @vue/component

var BVTooltip = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["c" /* NAME_TOOLTIP_HELPER */],
  mixins: [__WEBPACK_IMPORTED_MODULE_19__mixins_listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins_use_parent__["a" /* useParentMixin */]],
  data: function data() {
    return _objectSpread(_objectSpread({}, templateData), {}, {
      // State management data
      activeTrigger: {
        // manual: false,
        hover: false,
        click: false,
        focus: false
      },
      localShow: false
    });
  },
  computed: {
    templateType: function templateType() {
      // Overwritten by BVPopover
      return 'tooltip';
    },
    computedId: function computedId() {
      return this.id || "__bv_".concat(this.templateType, "_").concat(this[__WEBPACK_IMPORTED_MODULE_0__vue__["e" /* COMPONENT_UID_KEY */]], "__");
    },
    computedDelay: function computedDelay() {
      // Normalizes delay into object form
      var delay = {
        show: 0,
        hide: 0
      };

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["h" /* isPlainObject */])(this.delay)) {
        delay.show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.delay.show, 0), 0);
        delay.hide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.delay.hide, 0), 0);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["j" /* isNumber */])(this.delay) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["f" /* isString */])(this.delay)) {
        delay.show = delay.hide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.delay, 0), 0);
      }

      return delay;
    },
    computedTriggers: function computedTriggers() {
      // Returns the triggers in sorted array form
      // TODO: Switch this to object form for easier lookup
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["b" /* concat */])(this.triggers).filter(__WEBPACK_IMPORTED_MODULE_9__utils_identity__["a" /* identity */]).join(' ').trim().toLowerCase().split(/\s+/).sort();
    },
    isWithActiveTrigger: function isWithActiveTrigger() {
      for (var trigger in this.activeTrigger) {
        if (this.activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    },
    computedTemplateData: function computedTemplateData() {
      var title = this.title,
          content = this.content,
          variant = this.variant,
          customClass = this.customClass,
          noFade = this.noFade,
          interactive = this.interactive;
      return {
        title: title,
        content: content,
        variant: variant,
        customClass: customClass,
        noFade: noFade,
        interactive: interactive
      };
    }
  },
  watch: {
    computedTriggers: function computedTriggers(newTriggers, oldTriggers) {
      var _this = this;

      // Triggers have changed, so re-register them

      /* istanbul ignore next */
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_loose_equal__["a" /* looseEqual */])(newTriggers, oldTriggers)) {
        this.$nextTick(function () {
          // Disable trigger listeners
          _this.unListen(); // Clear any active triggers that are no longer in the list of triggers


          oldTriggers.forEach(function (trigger) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(newTriggers, trigger)) {
              if (_this.activeTrigger[trigger]) {
                _this.activeTrigger[trigger] = false;
              }
            }
          }); // Re-enable the trigger listeners

          _this.listen();
        });
      }
    },
    computedTemplateData: function computedTemplateData() {
      // If any of the while open reactive "props" change,
      // ensure that the template updates accordingly
      this.handleTemplateUpdate();
    },
    title: function title(newValue, oldValue) {
      // Make sure to hide the tooltip when the title is set empty
      if (newValue !== oldValue && !newValue) {
        this.hide();
      }
    },
    disabled: function disabled(newValue) {
      if (newValue) {
        this.disable();
      } else {
        this.enable();
      }
    }
  },
  created: function created() {
    var _this2 = this;

    // Create non-reactive properties
    this.$_tip = null;
    this.$_hoverTimeout = null;
    this.$_hoverState = '';
    this.$_visibleInterval = null;
    this.$_enabled = !this.disabled;
    this.$_noop = __WEBPACK_IMPORTED_MODULE_13__utils_noop__["a" /* noop */].bind(this); // Destroy ourselves when the parent is destroyed

    if (this.bvParent) {
      this.bvParent.$once(__WEBPACK_IMPORTED_MODULE_2__constants_events__["c" /* HOOK_EVENT_NAME_BEFORE_DESTROY */], function () {
        _this2.$nextTick(function () {
          // In a `requestAF()` to release control back to application
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* requestAF */])(function () {
            _this2.$destroy();
          });
        });
      });
    }

    this.$nextTick(function () {
      var target = _this2.getTarget();

      if (target && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(document.body, target)) {
        // Copy the parent's scoped style attribute
        _this2.scopeId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_get_scope_id__["a" /* getScopeId */])(_this2.bvParent); // Set up all trigger handlers and listeners

        _this2.listen();
      } else {
        /* istanbul ignore next */
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_warn__["a" /* warn */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["f" /* isString */])(_this2.target) ? "Unable to find target element by ID \"#".concat(_this2.target, "\" in document.") : 'The provided target is no valid HTML element.', _this2.templateType);
      }
    });
  },

  /* istanbul ignore next */
  updated: function updated() {
    // Usually called when the slots/data changes
    this.$nextTick(this.handleTemplateUpdate);
  },

  /* istanbul ignore next */
  deactivated: function deactivated() {
    // In a keepalive that has been deactivated, so hide
    // the tooltip/popover if it is showing
    this.forceHide();
  },
  beforeDestroy: function beforeDestroy() {
    // Remove all handler/listeners
    this.unListen();
    this.setWhileOpenListeners(false); // Clear any timeouts/intervals

    this.clearHoverTimeout();
    this.clearVisibilityInterval(); // Destroy the template

    this.destroyTemplate(); // Remove any other private properties created during create

    this.$_noop = null;
  },
  methods: {
    // --- Methods for creating and destroying the template ---
    getTemplate: function getTemplate() {
      // Overridden by BVPopover
      return __WEBPACK_IMPORTED_MODULE_20__bv_tooltip_template__["a" /* BVTooltipTemplate */];
    },
    updateData: function updateData() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Method for updating popper/template data
      // We only update data if it exists, and has not changed
      var titleUpdated = false;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["a" /* keys */])(templateData).forEach(function (prop) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["i" /* isUndefined */])(data[prop]) && _this3[prop] !== data[prop]) {
          _this3[prop] = data[prop];

          if (prop === 'title') {
            titleUpdated = true;
          }
        }
      }); // If the title has updated, we may need to handle the `title`
      // attribute on the trigger target
      // We only do this while the template is open

      if (titleUpdated && this.localShow) {
        this.fixTitle();
      }
    },
    createTemplateAndShow: function createTemplateAndShow() {
      // Creates the template instance and show it
      var container = this.getContainer();
      var Template = this.getTemplate();
      var $tip = this.$_tip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_create_new_child_component__["a" /* createNewChildComponent */])(this, Template, {
        // The following is not reactive to changes in the props data
        propsData: {
          // These values cannot be changed while template is showing
          id: this.computedId,
          html: this.html,
          placement: this.placement,
          fallbackPlacement: this.fallbackPlacement,
          target: this.getPlacementTarget(),
          boundary: this.getBoundary(),
          // Ensure the following are integers
          offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.offset, 0),
          arrowPadding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.arrowPadding, 0),
          boundaryPadding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.boundaryPadding, 0)
        }
      }); // We set the initial reactive data (values that can be changed while open)

      this.handleTemplateUpdate(); // Template transition phase events (handled once only)
      // When the template has mounted, but not visibly shown yet

      $tip.$once(__WEBPACK_IMPORTED_MODULE_2__constants_events__["a" /* EVENT_NAME_SHOW */], this.onTemplateShow); // When the template has completed showing

      $tip.$once(__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */], this.onTemplateShown); // When the template has started to hide

      $tip.$once(__WEBPACK_IMPORTED_MODULE_2__constants_events__["e" /* EVENT_NAME_HIDE */], this.onTemplateHide); // When the template has completed hiding

      $tip.$once(__WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */], this.onTemplateHidden); // When the template gets destroyed for any reason

      $tip.$once(__WEBPACK_IMPORTED_MODULE_2__constants_events__["f" /* HOOK_EVENT_NAME_DESTROYED */], this.destroyTemplate); // Convenience events from template
      // To save us from manually adding/removing DOM
      // listeners to tip element when it is open

      $tip.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["g" /* EVENT_NAME_FOCUSIN */], this.handleEvent);
      $tip.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["h" /* EVENT_NAME_FOCUSOUT */], this.handleEvent);
      $tip.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["i" /* EVENT_NAME_MOUSEENTER */], this.handleEvent);
      $tip.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["j" /* EVENT_NAME_MOUSELEAVE */], this.handleEvent); // Mount (which triggers the `show`)

      $tip.$mount(container.appendChild(document.createElement('div'))); // Template will automatically remove its markup from DOM when hidden
    },
    hideTemplate: function hideTemplate() {
      // Trigger the template to start hiding
      // The template will emit the `hide` event after this and
      // then emit the `hidden` event once it is fully hidden
      // The `hook:destroyed` will also be called (safety measure)
      this.$_tip && this.$_tip.hide(); // Clear out any stragging active triggers

      this.clearActiveTriggers(); // Reset the hover state

      this.$_hoverState = '';
    },
    // Destroy the template instance and reset state
    destroyTemplate: function destroyTemplate() {
      this.setWhileOpenListeners(false);
      this.clearHoverTimeout();
      this.$_hoverState = '';
      this.clearActiveTriggers();
      this.localPlacementTarget = null;

      try {
        this.$_tip.$destroy();
      } catch (_unused) {}

      this.$_tip = null;
      this.removeAriaDescribedby();
      this.restoreTitle();
      this.localShow = false;
    },
    getTemplateElement: function getTemplateElement() {
      return this.$_tip ? this.$_tip.$el : null;
    },
    handleTemplateUpdate: function handleTemplateUpdate() {
      var _this4 = this;

      // Update our template title/content "props"
      // So that the template updates accordingly
      var $tip = this.$_tip;

      if ($tip) {
        var props = ['title', 'content', 'variant', 'customClass', 'noFade', 'interactive']; // Only update the values if they have changed

        props.forEach(function (prop) {
          if ($tip[prop] !== _this4[prop]) {
            $tip[prop] = _this4[prop];
          }
        });
      }
    },
    // --- Show/Hide handlers ---
    // Show the tooltip
    show: function show() {
      var target = this.getTarget();

      if (!target || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(document.body, target) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["c" /* isVisible */])(target) || this.dropdownOpen() || (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["g" /* isUndefinedOrNull */])(this.title) || this.title === '') && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["g" /* isUndefinedOrNull */])(this.content) || this.content === '')) {
        // If trigger element isn't in the DOM or is not visible, or
        // is on an open dropdown toggle, or has no content, then
        // we exit without showing
        return;
      } // If tip already exists, exit early


      if (this.$_tip || this.localShow) {
        /* istanbul ignore next */
        return;
      } // In the process of showing


      this.localShow = true; // Create a cancelable BvEvent

      var showEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_2__constants_events__["a" /* EVENT_NAME_SHOW */], {
        cancelable: true
      });
      this.emitEvent(showEvent); // Don't show if event cancelled

      /* istanbul ignore if */

      if (showEvent.defaultPrevented) {
        // Destroy the template (if for some reason it was created)
        this.destroyTemplate();
        return;
      } // Fix the title attribute on target


      this.fixTitle(); // Set aria-describedby on target

      this.addAriaDescribedby(); // Create and show the tooltip

      this.createTemplateAndShow();
    },
    hide: function hide() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Hide the tooltip
      var tip = this.getTemplateElement();
      /* istanbul ignore if */

      if (!tip || !this.localShow) {
        this.restoreTitle();
        return;
      } // Emit cancelable BvEvent 'hide'
      // We disable cancelling if `force` is true


      var hideEvent = this.buildEvent(__WEBPACK_IMPORTED_MODULE_2__constants_events__["e" /* EVENT_NAME_HIDE */], {
        cancelable: !force
      });
      this.emitEvent(hideEvent);
      /* istanbul ignore if: ignore for now */

      if (hideEvent.defaultPrevented) {
        // Don't hide if event cancelled
        return;
      } // Tell the template to hide


      this.hideTemplate();
    },
    forceHide: function forceHide() {
      // Forcefully hides/destroys the template, regardless of any active triggers
      var tip = this.getTemplateElement();

      if (!tip || !this.localShow) {
        /* istanbul ignore next */
        return;
      } // Disable while open listeners/watchers
      // This is also done in the template `hide` event handler


      this.setWhileOpenListeners(false); // Clear any hover enter/leave event

      this.clearHoverTimeout();
      this.$_hoverState = '';
      this.clearActiveTriggers(); // Disable the fade animation on the template

      if (this.$_tip) {
        this.$_tip.noFade = true;
      } // Hide the tip (with force = true)


      this.hide(true);
    },
    enable: function enable() {
      this.$_enabled = true; // Create a non-cancelable BvEvent

      this.emitEvent(this.buildEvent(__WEBPACK_IMPORTED_MODULE_2__constants_events__["k" /* EVENT_NAME_ENABLED */]));
    },
    disable: function disable() {
      this.$_enabled = false; // Create a non-cancelable BvEvent

      this.emitEvent(this.buildEvent(__WEBPACK_IMPORTED_MODULE_2__constants_events__["l" /* EVENT_NAME_DISABLED */]));
    },
    // --- Handlers for template events ---
    // When template is inserted into DOM, but not yet shown
    onTemplateShow: function onTemplateShow() {
      // Enable while open listeners/watchers
      this.setWhileOpenListeners(true);
    },
    // When template show transition completes
    onTemplateShown: function onTemplateShown() {
      var prevHoverState = this.$_hoverState;
      this.$_hoverState = '';
      /* istanbul ignore next: occasional Node 10 coverage error */

      if (prevHoverState === 'out') {
        this.leave(null);
      } // Emit a non-cancelable BvEvent 'shown'


      this.emitEvent(this.buildEvent(__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */]));
    },
    // When template is starting to hide
    onTemplateHide: function onTemplateHide() {
      // Disable while open listeners/watchers
      this.setWhileOpenListeners(false);
    },
    // When template has completed closing (just before it self destructs)
    onTemplateHidden: function onTemplateHidden() {
      // Destroy the template
      this.destroyTemplate(); // Emit a non-cancelable BvEvent 'shown'

      this.emitEvent(this.buildEvent(__WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */]));
    },
    // --- Helper methods ---
    getTarget: function getTarget() {
      var target = this.target;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["f" /* isString */])(target)) {
        target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["d" /* getById */])(target.replace(/^#/, ''));
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["a" /* isFunction */])(target)) {
        target = target();
      } else if (target) {
        target = target.$el || target;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* isElement */])(target) ? target : null;
    },
    getPlacementTarget: function getPlacementTarget() {
      // This is the target that the tooltip will be placed on, which may not
      // necessarily be the same element that has the trigger event listeners
      // For now, this is the same as target
      // TODO:
      //   Add in child selector support
      //   Add in visibility checks for this element
      //   Fallback to target if not found
      return this.getTarget();
    },
    getTargetId: function getTargetId() {
      // Returns the ID of the trigger element
      var target = this.getTarget();
      return target && target.id ? target.id : null;
    },
    getContainer: function getContainer() {
      // Handle case where container may be a component ref
      var container = this.container ? this.container.$el || this.container : false;
      var body = document.body;
      var target = this.getTarget(); // If we are in a modal, we append to the modal, If we
      // are in a sidebar, we append to the sidebar, else append
      // to body, unless a container is specified
      // TODO:
      //   Template should periodically check to see if it is in dom
      //   And if not, self destruct (if container got v-if'ed out of DOM)
      //   Or this could possibly be part of the visibility check

      return container === false ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["f" /* closest */])(CONTAINER_SELECTOR, target) || body :
      /*istanbul ignore next */
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["f" /* isString */])(container) ?
      /*istanbul ignore next */
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["d" /* getById */])(container.replace(/^#/, '')) || body :
      /*istanbul ignore next */
      body;
    },
    getBoundary: function getBoundary() {
      return this.boundary ? this.boundary.$el || this.boundary : 'scrollParent';
    },
    isInModal: function isInModal() {
      var target = this.getTarget();
      return target && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["f" /* closest */])(MODAL_SELECTOR, target);
    },
    isDropdown: function isDropdown() {
      // Returns true if trigger is a dropdown
      var target = this.getTarget();
      return target && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["g" /* hasClass */])(target, DROPDOWN_CLASS);
    },
    dropdownOpen: function dropdownOpen() {
      // Returns true if trigger is a dropdown and the dropdown menu is open
      var target = this.getTarget();
      return this.isDropdown() && target && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["h" /* select */])(DROPDOWN_OPEN_SELECTOR, target);
    },
    clearHoverTimeout: function clearHoverTimeout() {
      clearTimeout(this.$_hoverTimeout);
      this.$_hoverTimeout = null;
    },
    clearVisibilityInterval: function clearVisibilityInterval() {
      clearInterval(this.$_visibleInterval);
      this.$_visibleInterval = null;
    },
    clearActiveTriggers: function clearActiveTriggers() {
      for (var trigger in this.activeTrigger) {
        this.activeTrigger[trigger] = false;
      }
    },
    addAriaDescribedby: function addAriaDescribedby() {
      // Add aria-describedby on trigger element, without removing any other IDs
      var target = this.getTarget();
      var desc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* getAttr */])(target, 'aria-describedby') || '';
      desc = desc.split(/\s+/).concat(this.computedId).join(' ').trim(); // Update/add aria-described by

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(target, 'aria-describedby', desc);
    },
    removeAriaDescribedby: function removeAriaDescribedby() {
      var _this5 = this;

      // Remove aria-describedby on trigger element, without removing any other IDs
      var target = this.getTarget();
      var desc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* getAttr */])(target, 'aria-describedby') || '';
      desc = desc.split(/\s+/).filter(function (d) {
        return d !== _this5.computedId;
      }).join(' ').trim(); // Update or remove aria-describedby

      if (desc) {
        /* istanbul ignore next */
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(target, 'aria-describedby', desc);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["k" /* removeAttr */])(target, 'aria-describedby');
      }
    },
    fixTitle: function fixTitle() {
      // If the target has a `title` attribute,
      // remove it and store it on a data attribute
      var target = this.getTarget();

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["l" /* hasAttr */])(target, 'title')) {
        // Get `title` attribute value and remove it from target
        var title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* getAttr */])(target, 'title');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(target, 'title', ''); // Only set the data attribute when the value is truthy

        if (title) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(target, DATA_TITLE_ATTR, title);
        }
      }
    },
    restoreTitle: function restoreTitle() {
      // If the target had a `title` attribute,
      // restore it and remove the data attribute
      var target = this.getTarget();

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["l" /* hasAttr */])(target, DATA_TITLE_ATTR)) {
        // Get data attribute value and remove it from target
        var title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* getAttr */])(target, DATA_TITLE_ATTR);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["k" /* removeAttr */])(target, DATA_TITLE_ATTR); // Only restore the `title` attribute when the value is truthy

        if (title) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(target, 'title', title);
        }
      }
    },
    // --- BvEvent helpers ---
    buildEvent: function buildEvent(type) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Defaults to a non-cancellable event
      return new __WEBPACK_IMPORTED_MODULE_17__utils_bv_event_class__["a" /* BvEvent */](type, _objectSpread({
        cancelable: false,
        target: this.getTarget(),
        relatedTarget: this.getTemplateElement() || null,
        componentId: this.computedId,
        vueTarget: this
      }, options));
    },
    emitEvent: function emitEvent(bvEvent) {
      var type = bvEvent.type;
      this.emitOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["a" /* getRootEventName */])(this.templateType, type), bvEvent);
      this.$emit(type, bvEvent);
    },
    // --- Event handler setup methods ---
    listen: function listen() {
      var _this6 = this;

      // Enable trigger event handlers
      var el = this.getTarget();

      if (!el) {
        /* istanbul ignore next */
        return;
      } // Listen for global show/hide events


      this.setRootListener(true); // Set up our listeners on the target trigger element

      this.computedTriggers.forEach(function (trigger) {
        if (trigger === 'click') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["b" /* eventOn */])(el, 'click', _this6.handleEvent, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        } else if (trigger === 'focus') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["b" /* eventOn */])(el, 'focusin', _this6.handleEvent, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["b" /* eventOn */])(el, 'focusout', _this6.handleEvent, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        } else if (trigger === 'blur') {
          // Used to close $tip when element loses focus

          /* istanbul ignore next */
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["b" /* eventOn */])(el, 'focusout', _this6.handleEvent, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        } else if (trigger === 'hover') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["b" /* eventOn */])(el, 'mouseenter', _this6.handleEvent, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["b" /* eventOn */])(el, 'mouseleave', _this6.handleEvent, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        }
      }, this);
    },

    /* istanbul ignore next */
    unListen: function unListen() {
      var _this7 = this;

      // Remove trigger event handlers
      var events = ['click', 'focusin', 'focusout', 'mouseenter', 'mouseleave'];
      var target = this.getTarget(); // Stop listening for global show/hide/enable/disable events

      this.setRootListener(false); // Clear out any active target listeners

      events.forEach(function (event) {
        target && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["c" /* eventOff */])(target, event, _this7.handleEvent, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      }, this);
    },
    setRootListener: function setRootListener(on) {
      // Listen for global `bv::{hide|show}::{tooltip|popover}` hide request event
      var method = on ? 'listenOnRoot' : 'listenOffRoot';
      var type = this.templateType;
      this[method](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["d" /* getRootActionEventName */])(type, __WEBPACK_IMPORTED_MODULE_2__constants_events__["e" /* EVENT_NAME_HIDE */]), this.doHide);
      this[method](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["d" /* getRootActionEventName */])(type, __WEBPACK_IMPORTED_MODULE_2__constants_events__["a" /* EVENT_NAME_SHOW */]), this.doShow);
      this[method](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["d" /* getRootActionEventName */])(type, __WEBPACK_IMPORTED_MODULE_2__constants_events__["n" /* EVENT_NAME_DISABLE */]), this.doDisable);
      this[method](__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["d" /* getRootActionEventName */])(type, __WEBPACK_IMPORTED_MODULE_2__constants_events__["o" /* EVENT_NAME_ENABLE */]), this.doEnable);
    },
    setWhileOpenListeners: function setWhileOpenListeners(on) {
      // Events that are only registered when the template is showing
      // Modal close events
      this.setModalListener(on); // Dropdown open events (if we are attached to a dropdown)

      this.setDropdownListener(on); // Periodic $element visibility check
      // For handling when tip target is in <keepalive>, tabs, carousel, etc

      this.visibleCheck(on); // On-touch start listeners

      this.setOnTouchStartListener(on);
    },
    // Handler for periodic visibility check
    visibleCheck: function visibleCheck(on) {
      var _this8 = this;

      this.clearVisibilityInterval();
      var target = this.getTarget();

      if (on) {
        this.$_visibleInterval = setInterval(function () {
          var tip = _this8.getTemplateElement();

          if (tip && _this8.localShow && (!target.parentNode || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["c" /* isVisible */])(target))) {
            // Target element is no longer visible or not in DOM, so force-hide the tooltip
            _this8.forceHide();
          }
        }, 100);
      }
    },
    setModalListener: function setModalListener(on) {
      // Handle case where tooltip/target is in a modal
      if (this.isInModal()) {
        // We can listen for modal hidden events on `$root`
        this[on ? 'listenOnRoot' : 'listenOffRoot'](ROOT_EVENT_NAME_MODAL_HIDDEN, this.forceHide);
      }
    },

    /* istanbul ignore next: JSDOM doesn't support `ontouchstart` */
    setOnTouchStartListener: function setOnTouchStartListener(on) {
      var _this9 = this;

      // If this is a touch-enabled device we add extra empty
      // `mouseover` listeners to the body's immediate children
      // Only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
      if ('ontouchstart' in document.documentElement) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["a" /* from */])(document.body.children).forEach(function (el) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["e" /* eventOnOff */])(on, el, 'mouseover', _this9.$_noop);
        });
      }
    },
    setDropdownListener: function setDropdownListener(on) {
      var target = this.getTarget();

      if (!target || !this.bvEventRoot || !this.isDropdown) {
        return;
      } // We can listen for dropdown shown events on its instance
      // TODO:
      //   We could grab the ID from the dropdown, and listen for
      //   $root events for that particular dropdown id
      //   Dropdown shown and hidden events will need to emit
      //   Note: Dropdown auto-ID happens in a `$nextTick()` after mount
      //         So the ID lookup would need to be done in a `$nextTick()`


      var instance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_element_to_vue_instance_registry__["a" /* getInstanceFromElement */])(target);

      if (instance) {
        instance[on ? '$on' : '$off'](__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */], this.forceHide);
      }
    },
    // --- Event handlers ---
    handleEvent: function handleEvent(event) {
      // General trigger event handler
      // target is the trigger element
      var target = this.getTarget();

      if (!target || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isDisabled */])(target) || !this.$_enabled || this.dropdownOpen()) {
        // If disabled or not enabled, or if a dropdown that is open, don't do anything
        // If tip is shown before element gets disabled, then tip will not
        // close until no longer disabled or forcefully closed
        return;
      }

      var type = event.type;
      var triggers = this.computedTriggers;

      if (type === 'click' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(triggers, 'click')) {
        this.click(event);
      } else if (type === 'mouseenter' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(triggers, 'hover')) {
        // `mouseenter` is a non-bubbling event
        this.enter(event);
      } else if (type === 'focusin' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(triggers, 'focus')) {
        // `focusin` is a bubbling event
        // `event` includes `relatedTarget` (element losing focus)
        this.enter(event);
      } else if (type === 'focusout' && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(triggers, 'focus') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(triggers, 'blur')) || type === 'mouseleave' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(triggers, 'hover')) {
        // `focusout` is a bubbling event
        // `mouseleave` is a non-bubbling event
        // `tip` is the template (will be null if not open)
        var tip = this.getTemplateElement(); // `eventTarget` is the element which is losing focus/hover and

        var eventTarget = event.target; // `relatedTarget` is the element gaining focus/hover

        var relatedTarget = event.relatedTarget;
        /* istanbul ignore next */

        if ( // From tip to target
        tip && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(tip, eventTarget) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(target, relatedTarget) || // From target to tip
        tip && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(target, eventTarget) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(tip, relatedTarget) || // Within tip
        tip && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(tip, eventTarget) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(tip, relatedTarget) || // Within target
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(target, eventTarget) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["b" /* contains */])(target, relatedTarget)) {
          // If focus/hover moves within `tip` and `target`, don't trigger a leave
          return;
        } // Otherwise trigger a leave


        this.leave(event);
      }
    },
    doHide: function doHide(id) {
      // Programmatically hide tooltip or popover
      if (!id || this.getTargetId() === id || this.computedId === id) {
        // Close all tooltips or popovers, or this specific tip (with ID)
        this.forceHide();
      }
    },
    doShow: function doShow(id) {
      // Programmatically show tooltip or popover
      if (!id || this.getTargetId() === id || this.computedId === id) {
        // Open all tooltips or popovers, or this specific tip (with ID)
        this.show();
      }
    },

    /*istanbul ignore next: ignore for now */
    doDisable: function doDisable(id)
    /*istanbul ignore next: ignore for now */
    {
      // Programmatically disable tooltip or popover
      if (!id || this.getTargetId() === id || this.computedId === id) {
        // Disable all tooltips or popovers (no ID), or this specific tip (with ID)
        this.disable();
      }
    },

    /*istanbul ignore next: ignore for now */
    doEnable: function doEnable(id)
    /*istanbul ignore next: ignore for now */
    {
      // Programmatically enable tooltip or popover
      if (!id || this.getTargetId() === id || this.computedId === id) {
        // Enable all tooltips or popovers (no ID), or this specific tip (with ID)
        this.enable();
      }
    },
    click: function click(event) {
      if (!this.$_enabled || this.dropdownOpen()) {
        /* istanbul ignore next */
        return;
      } // Get around a WebKit bug where `click` does not trigger focus events
      // On most browsers, `click` triggers a `focusin`/`focus` event first
      // Needed so that trigger 'click blur' works on iOS
      // https://github.com/bootstrap-vue/bootstrap-vue/issues/5099
      // We use `currentTarget` rather than `target` to trigger on the
      // element, not the inner content


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(event.currentTarget);
      this.activeTrigger.click = !this.activeTrigger.click;

      if (this.isWithActiveTrigger) {
        this.enter(null);
      } else {
        /* istanbul ignore next */
        this.leave(null);
      }
    },

    /* istanbul ignore next */
    toggle: function toggle() {
      // Manual toggle handler
      if (!this.$_enabled || this.dropdownOpen()) {
        /* istanbul ignore next */
        return;
      } // Should we register as an active trigger?
      // this.activeTrigger.manual = !this.activeTrigger.manual


      if (this.localShow) {
        this.leave(null);
      } else {
        this.enter(null);
      }
    },
    enter: function enter() {
      var _this10 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      // Opening trigger handler
      // Note: Click events are sent with event === null
      if (event) {
        this.activeTrigger[event.type === 'focusin' ? 'focus' : 'hover'] = true;
      }
      /* istanbul ignore next */


      if (this.localShow || this.$_hoverState === 'in') {
        this.$_hoverState = 'in';
        return;
      }

      this.clearHoverTimeout();
      this.$_hoverState = 'in';

      if (!this.computedDelay.show) {
        this.show();
      } else {
        // Hide any title attribute while enter delay is active
        this.fixTitle();
        this.$_hoverTimeout = setTimeout(function () {
          /* istanbul ignore else */
          if (_this10.$_hoverState === 'in') {
            _this10.show();
          } else if (!_this10.localShow) {
            _this10.restoreTitle();
          }
        }, this.computedDelay.show);
      }
    },
    leave: function leave() {
      var _this11 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      // Closing trigger handler
      // Note: Click events are sent with event === null
      if (event) {
        this.activeTrigger[event.type === 'focusout' ? 'focus' : 'hover'] = false;
        /* istanbul ignore next */

        if (event.type === 'focusout' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(this.computedTriggers, 'blur')) {
          // Special case for `blur`: we clear out the other triggers
          this.activeTrigger.click = false;
          this.activeTrigger.hover = false;
        }
      }
      /* istanbul ignore next: ignore for now */


      if (this.isWithActiveTrigger) {
        return;
      }

      this.clearHoverTimeout();
      this.$_hoverState = 'out';

      if (!this.computedDelay.hide) {
        this.hide();
      } else {
        this.$_hoverTimeout = setTimeout(function () {
          if (_this11.$_hoverState === 'out') {
            _this11.hide();
          }
        }, this.computedDelay.hide);
      }
    }
  }
});

/***/ }),
/* 243 */
/* exports provided: props, BTooltip */
/* exports used: BTooltip, props */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tooltip/tooltip.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_safe_types__ = __webpack_require__(/*! ../../constants/safe-types */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_use_parent__ = __webpack_require__(/*! ../../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_get_scope_id__ = __webpack_require__(/*! ../../utils/get-scope-id */ 140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_create_new_child_component__ = __webpack_require__(/*! ../../utils/create-new-child-component */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_bv_tooltip__ = __webpack_require__(/*! ./helpers/bv-tooltip */ 242);
var _makePropsConfigurabl, _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













 // --- Constants ---

var MODEL_PROP_NAME_ENABLED = 'disabled';
var MODEL_EVENT_NAME_ENABLED = __WEBPACK_IMPORTED_MODULE_2__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_ENABLED;
var MODEL_PROP_NAME_SHOW = 'show';
var MODEL_EVENT_NAME_SHOW = __WEBPACK_IMPORTED_MODULE_2__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_SHOW; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["b" /* makePropsConfigurable */])((_makePropsConfigurabl = {
  // String: scrollParent, window, or viewport
  // Element: element reference
  // Object: Vue component
  boundary: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_4__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["e" /* PROP_TYPE_OBJECT */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]], 'scrollParent'),
  boundaryPadding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 50),
  // String: HTML ID of container, if null body is used (default)
  // HTMLElement: element reference reference
  // Object: Vue Component
  container: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_4__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["e" /* PROP_TYPE_OBJECT */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]]),
  customClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  delay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["g" /* PROP_TYPE_NUMBER_OBJECT_STRING */], 50)
}, _defineProperty(_makePropsConfigurabl, MODEL_PROP_NAME_ENABLED, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_makePropsConfigurabl, "fallbackPlacement", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */], 'flip')), _defineProperty(_makePropsConfigurabl, "id", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])), _defineProperty(_makePropsConfigurabl, "noFade", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_makePropsConfigurabl, "noninteractive", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_makePropsConfigurabl, "offset", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0)), _defineProperty(_makePropsConfigurabl, "placement", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'top')), _defineProperty(_makePropsConfigurabl, MODEL_PROP_NAME_SHOW, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_makePropsConfigurabl, "target", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_4__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_4__constants_safe_types__["d" /* SVGElement */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["h" /* PROP_TYPE_FUNCTION */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["e" /* PROP_TYPE_OBJECT */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]], undefined, true)), _defineProperty(_makePropsConfigurabl, "title", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])), _defineProperty(_makePropsConfigurabl, "triggers", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */], 'hover focus')), _defineProperty(_makePropsConfigurabl, "variant", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])), _makePropsConfigurabl), __WEBPACK_IMPORTED_MODULE_1__constants_components__["a" /* NAME_TOOLTIP */]); // --- Main component ---
// @vue/component

var BTooltip = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["a" /* NAME_TOOLTIP */],
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_use_parent__["a" /* useParentMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      localShow: this[MODEL_PROP_NAME_SHOW],
      localTitle: '',
      localContent: ''
    };
  },
  computed: {
    // Data that will be passed to the template and popper
    templateData: function templateData() {
      return _objectSpread({
        title: this.localTitle,
        content: this.localContent,
        interactive: !this.noninteractive
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["k" /* pick */])(this.$props, ['boundary', 'boundaryPadding', 'container', 'customClass', 'delay', 'fallbackPlacement', 'id', 'noFade', 'offset', 'placement', 'target', 'target', 'triggers', 'variant', MODEL_PROP_NAME_ENABLED]));
    },
    // Used to watch for changes to the title and content props
    templateTitleContent: function templateTitleContent() {
      var title = this.title,
          content = this.content;
      return {
        title: title,
        content: content
      };
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME_SHOW, function (newValue, oldValue) {
    if (newValue !== oldValue && newValue !== this.localShow && this.$_toolpop) {
      if (newValue) {
        this.$_toolpop.show();
      } else {
        // We use `forceHide()` to override any active triggers
        this.$_toolpop.forceHide();
      }
    }
  }), _defineProperty(_watch, MODEL_PROP_NAME_ENABLED, function (newValue) {
    if (newValue) {
      this.doDisable();
    } else {
      this.doEnable();
    }
  }), _defineProperty(_watch, "localShow", function localShow(newValue) {
    // TODO: May need to be done in a `$nextTick()`
    this.$emit(MODEL_EVENT_NAME_SHOW, newValue);
  }), _defineProperty(_watch, "templateData", function templateData() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.$_toolpop) {
        _this.$_toolpop.updateData(_this.templateData);
      }
    });
  }), _defineProperty(_watch, "templateTitleContent", function templateTitleContent() {
    this.$nextTick(this.updateContent);
  }), _watch),
  created: function created() {
    // Create private non-reactive props
    this.$_toolpop = null;
  },
  updated: function updated() {
    // Update the `propData` object
    // Done in a `$nextTick()` to ensure slot(s) have updated
    this.$nextTick(this.updateContent);
  },
  beforeDestroy: function beforeDestroy() {
    // Shutdown our local event listeners
    this.$off(__WEBPACK_IMPORTED_MODULE_2__constants_events__["t" /* EVENT_NAME_OPEN */], this.doOpen);
    this.$off(__WEBPACK_IMPORTED_MODULE_2__constants_events__["u" /* EVENT_NAME_CLOSE */], this.doClose);
    this.$off(__WEBPACK_IMPORTED_MODULE_2__constants_events__["n" /* EVENT_NAME_DISABLE */], this.doDisable);
    this.$off(__WEBPACK_IMPORTED_MODULE_2__constants_events__["o" /* EVENT_NAME_ENABLE */], this.doEnable); // Destroy the tip instance

    if (this.$_toolpop) {
      this.$_toolpop.$destroy();
      this.$_toolpop = null;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // Instantiate a new BVTooltip instance
    // Done in a `$nextTick()` to ensure DOM has completed rendering
    // so that target can be found
    this.$nextTick(function () {
      // Load the on demand child instance
      var Component = _this2.getComponent(); // Ensure we have initial content


      _this2.updateContent(); // Pass down the scoped style attribute if available


      var scopeId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_scope_id__["a" /* getScopeId */])(_this2) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_scope_id__["a" /* getScopeId */])(_this2.bvParent); // Create the instance

      var $toolpop = _this2.$_toolpop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_create_new_child_component__["a" /* createNewChildComponent */])(_this2, Component, {
        // Pass down the scoped style ID
        _scopeId: scopeId || undefined
      }); // Set the initial data

      $toolpop.updateData(_this2.templateData); // Set listeners

      $toolpop.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["a" /* EVENT_NAME_SHOW */], _this2.onShow);
      $toolpop.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */], _this2.onShown);
      $toolpop.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["e" /* EVENT_NAME_HIDE */], _this2.onHide);
      $toolpop.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */], _this2.onHidden);
      $toolpop.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["l" /* EVENT_NAME_DISABLED */], _this2.onDisabled);
      $toolpop.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["k" /* EVENT_NAME_ENABLED */], _this2.onEnabled); // Initially disabled?

      if (_this2[MODEL_PROP_NAME_ENABLED]) {
        // Initially disabled
        _this2.doDisable();
      } // Listen to open signals from others


      _this2.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["t" /* EVENT_NAME_OPEN */], _this2.doOpen); // Listen to close signals from others


      _this2.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["u" /* EVENT_NAME_CLOSE */], _this2.doClose); // Listen to disable signals from others


      _this2.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["n" /* EVENT_NAME_DISABLE */], _this2.doDisable); // Listen to enable signals from others


      _this2.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["o" /* EVENT_NAME_ENABLE */], _this2.doEnable); // Initially show tooltip?


      if (_this2.localShow) {
        $toolpop.show();
      }
    });
  },
  methods: {
    getComponent: function getComponent() {
      // Overridden by BPopover
      return __WEBPACK_IMPORTED_MODULE_12__helpers_bv_tooltip__["a" /* BVTooltip */];
    },
    updateContent: function updateContent() {
      // Overridden by BPopover
      // Tooltip: Default slot is `title`
      // Popover: Default slot is `content`, `title` slot is title
      // We pass a scoped slot function reference by default (Vue v2.6x)
      // And pass the title prop as a fallback
      this.setTitle(this.normalizeSlot() || this.title);
    },
    // Helper methods for `updateContent()`
    setTitle: function setTitle(value) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["g" /* isUndefinedOrNull */])(value) ? '' : value; // We only update the value if it has changed

      if (this.localTitle !== value) {
        this.localTitle = value;
      }
    },
    setContent: function setContent(value) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["g" /* isUndefinedOrNull */])(value) ? '' : value; // We only update the value if it has changed

      if (this.localContent !== value) {
        this.localContent = value;
      }
    },
    // --- Template event handlers ---
    onShow: function onShow(bvEvent) {
      // Placeholder
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["a" /* EVENT_NAME_SHOW */], bvEvent);

      if (bvEvent) {
        this.localShow = !bvEvent.defaultPrevented;
      }
    },
    onShown: function onShown(bvEvent) {
      // Tip is now showing
      this.localShow = true;
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */], bvEvent);
    },
    onHide: function onHide(bvEvent) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["e" /* EVENT_NAME_HIDE */], bvEvent);
    },
    onHidden: function onHidden(bvEvent) {
      // Tip is no longer showing
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */], bvEvent);
      this.localShow = false;
    },
    onDisabled: function onDisabled(bvEvent) {
      // Prevent possible endless loop if user mistakenly
      // fires `disabled` instead of `disable`
      if (bvEvent && bvEvent.type === __WEBPACK_IMPORTED_MODULE_2__constants_events__["l" /* EVENT_NAME_DISABLED */]) {
        this.$emit(MODEL_EVENT_NAME_ENABLED, true);
        this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["l" /* EVENT_NAME_DISABLED */], bvEvent);
      }
    },
    onEnabled: function onEnabled(bvEvent) {
      // Prevent possible endless loop if user mistakenly
      // fires `enabled` instead of `enable`
      if (bvEvent && bvEvent.type === __WEBPACK_IMPORTED_MODULE_2__constants_events__["k" /* EVENT_NAME_ENABLED */]) {
        this.$emit(MODEL_EVENT_NAME_ENABLED, false);
        this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["k" /* EVENT_NAME_ENABLED */], bvEvent);
      }
    },
    // --- Local event listeners ---
    doOpen: function doOpen() {
      !this.localShow && this.$_toolpop && this.$_toolpop.show();
    },
    doClose: function doClose() {
      this.localShow && this.$_toolpop && this.$_toolpop.hide();
    },
    doDisable: function doDisable() {
      this.$_toolpop && this.$_toolpop.disable();
    },
    doEnable: function doEnable() {
      this.$_toolpop && this.$_toolpop.enable();
    }
  },
  render: function render(h) {
    // Always renders a comment node
    // TODO:
    //   Future: Possibly render a target slot (single root element)
    //   which we can apply the listeners to (pass `this.$el` to BVTooltip)
    return h();
  }
});

/***/ }),
/* 244 */
/* exports provided: VBHover */
/* exports used: VBHover */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/hover/hover.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBHover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
// v-b-hover directive



 // --- Constants ---

var PROP = '__BV_hover_handler__';
var MOUSEENTER = 'mouseenter';
var MOUSELEAVE = 'mouseleave'; // --- Helper methods ---

var createListener = function createListener(handler) {
  var listener = function listener(event) {
    handler(event.type === MOUSEENTER, event);
  };

  listener.fn = handler;
  return listener;
};

var updateListeners = function updateListeners(on, el, listener) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_events__["e" /* eventOnOff */])(on, el, MOUSEENTER, listener, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_events__["e" /* eventOnOff */])(on, el, MOUSELEAVE, listener, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
}; // --- Directive bind/unbind/update handler ---


var directive = function directive(el, _ref) {
  var _ref$value = _ref.value,
      handler = _ref$value === void 0 ? null : _ref$value;

  if (__WEBPACK_IMPORTED_MODULE_0__constants_env__["e" /* IS_BROWSER */]) {
    var listener = el[PROP];
    var hasListener = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["a" /* isFunction */])(listener);
    var handlerChanged = !(hasListener && listener.fn === handler);

    if (hasListener && handlerChanged) {
      updateListeners(false, el, listener);
      delete el[PROP];
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["a" /* isFunction */])(handler) && handlerChanged) {
      el[PROP] = createListener(handler);
      updateListeners(true, el, el[PROP]);
    }
  }
}; // VBHover directive


var VBHover = {
  bind: directive,
  componentUpdated: directive,
  unbind: function unbind(el) {
    directive(el, {
      value: null
    });
  }
};

/***/ }),
/* 245 */
/* exports provided: VBModal */
/* exports used: VBModal */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/modal/modal.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_get_event_root__ = __webpack_require__(/*! ../../utils/get-event-root */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_get_instance_from_directive__ = __webpack_require__(/*! ../../utils/get-instance-from-directive */ 139);








 // Emitted show event for modal

var ROOT_ACTION_EVENT_NAME_SHOW = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["b" /* NAME_MODAL */], __WEBPACK_IMPORTED_MODULE_1__constants_events__["a" /* EVENT_NAME_SHOW */]); // Prop name we use to store info on root element

var PROPERTY = '__bv_modal_directive__';

var getTarget = function getTarget(_ref) {
  var _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? {} : _ref$modifiers,
      arg = _ref.arg,
      value = _ref.value;
  // Try value, then arg, otherwise pick last modifier
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["f" /* isString */])(value) ? value : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["f" /* isString */])(arg) ? arg : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["a" /* keys */])(modifiers).reverse()[0];
};

var getTriggerElement = function getTriggerElement(el) {
  // If root element is a dropdown-item or nav-item, we
  // need to target the inner link or button instead
  return el && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["y" /* matches */])(el, '.dropdown-menu > li, li.nav-item') ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["h" /* select */])('a, button', el) || el : el;
};

var setRole = function setRole(trigger) {
  // Ensure accessibility on non button elements
  if (trigger && trigger.tagName !== 'BUTTON') {
    // Only set a role if the trigger element doesn't have one
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["l" /* hasAttr */])(trigger, 'role')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["j" /* setAttr */])(trigger, 'role', 'button');
    } // Add a tabindex is not a button or link, and tabindex is not provided


    if (trigger.tagName !== 'A' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["l" /* hasAttr */])(trigger, 'tabindex')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["j" /* setAttr */])(trigger, 'tabindex', '0');
    }
  }
};

var bind = function bind(el, binding, vnode) {
  var target = getTarget(binding);
  var trigger = getTriggerElement(el);

  if (target && trigger) {
    var handler = function handler(event) {
      // `currentTarget` is the element with the listener on it
      var currentTarget = event.currentTarget;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["m" /* isDisabled */])(currentTarget)) {
        var type = event.type;
        var key = event.keyCode; // Open modal only if trigger is not disabled

        if (type === 'click' || type === 'keydown' && (key === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["a" /* CODE_ENTER */] || key === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["b" /* CODE_SPACE */])) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_get_event_root__["a" /* getEventRoot */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, binding)).$emit(ROOT_ACTION_EVENT_NAME_SHOW, target, currentTarget);
        }
      }
    };

    el[PROPERTY] = {
      handler: handler,
      target: target,
      trigger: trigger
    }; // If element is not a button, we add `role="button"` for accessibility

    setRole(trigger); // Listen for click events

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["b" /* eventOn */])(trigger, 'click', handler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);

    if (trigger.tagName !== 'BUTTON' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["i" /* getAttr */])(trigger, 'role') === 'button') {
      // If trigger isn't a button but has role button,
      // we also listen for `keydown.space` && `keydown.enter`
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["b" /* eventOn */])(trigger, 'keydown', handler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    }
  }
};

var unbind = function unbind(el) {
  var oldProp = el[PROPERTY] || {};
  var trigger = oldProp.trigger;
  var handler = oldProp.handler;

  if (trigger && handler) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["c" /* eventOff */])(trigger, 'click', handler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["c" /* eventOff */])(trigger, 'keydown', handler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["c" /* eventOff */])(el, 'click', handler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["c" /* eventOff */])(el, 'keydown', handler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
  }

  delete el[PROPERTY];
};

var componentUpdated = function componentUpdated(el, binding, vnode) {
  var oldProp = el[PROPERTY] || {};
  var target = getTarget(binding);
  var trigger = getTriggerElement(el);

  if (target !== oldProp.target || trigger !== oldProp.trigger) {
    // We bind and rebind if the target or trigger changes
    unbind(el, binding, vnode);
    bind(el, binding, vnode);
  } // If trigger element is not a button, ensure `role="button"`
  // is still set for accessibility


  setRole(trigger);
};

var updated = function updated() {};
/*
 * Export our directive
 */


var VBModal = {
  inserted: componentUpdated,
  updated: updated,
  componentUpdated: componentUpdated,
  unbind: unbind
};

/***/ }),
/* 246 */
/* exports provided: VBPopoverPlugin, VBPopover */
/* exports used: VBPopoverPlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/popover/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBPopoverPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popover__ = __webpack_require__(/*! ./popover */ 451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport VBPopover */


var VBPopoverPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  directives: {
    VBPopover: __WEBPACK_IMPORTED_MODULE_0__popover__["a" /* VBPopover */]
  }
});


/***/ }),
/* 247 */
/* exports provided: VBToggle */
/* exports used: VBToggle */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/toggle/toggle.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBToggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__ = __webpack_require__(/*! ../../utils/get-instance-from-directive */ 139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__ = __webpack_require__(/*! ../../utils/get-event-root */ 122);












 // --- Constants ---
// Classes to apply to trigger element

var CLASS_BV_TOGGLE_COLLAPSED = 'collapsed';
var CLASS_BV_TOGGLE_NOT_COLLAPSED = 'not-collapsed'; // Property key for handler storage

var BV_BASE = '__BV_toggle'; // Root event listener property (Function)

var BV_TOGGLE_ROOT_HANDLER = "".concat(BV_BASE, "_HANDLER__"); // Trigger element click handler property (Function)

var BV_TOGGLE_CLICK_HANDLER = "".concat(BV_BASE, "_CLICK__"); // Target visibility state property (Boolean)

var BV_TOGGLE_STATE = "".concat(BV_BASE, "_STATE__"); // Target ID list property (Array)

var BV_TOGGLE_TARGETS = "".concat(BV_BASE, "_TARGETS__"); // Commonly used strings

var STRING_FALSE = 'false';
var STRING_TRUE = 'true'; // Commonly used attribute names

var ATTR_ARIA_CONTROLS = 'aria-controls';
var ATTR_ARIA_EXPANDED = 'aria-expanded';
var ATTR_ROLE = 'role';
var ATTR_TABINDEX = 'tabindex'; // Commonly used style properties

var STYLE_OVERFLOW_ANCHOR = 'overflow-anchor'; // Emitted control event for collapse (emitted to collapse)

var ROOT_ACTION_EVENT_NAME_TOGGLE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["g" /* NAME_COLLAPSE */], 'toggle'); // Listen to event for toggle state update (emitted by collapse)

var ROOT_EVENT_NAME_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["g" /* NAME_COLLAPSE */], 'state'); // Private event emitted on `$root` to ensure the toggle state is always synced
// Gets emitted even if the state of b-collapse has not changed
// This event is NOT to be documented as people should not be using it

var ROOT_EVENT_NAME_SYNC_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["g" /* NAME_COLLAPSE */], 'sync-state'); // Private event we send to collapse to request state update sync event

var ROOT_ACTION_EVENT_NAME_REQUEST_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["g" /* NAME_COLLAPSE */], 'request-state');
var KEYDOWN_KEY_CODES = [__WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["a" /* CODE_ENTER */], __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["b" /* CODE_SPACE */]]; // --- Helper methods ---

var isNonStandardTag = function isNonStandardTag(el) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["c" /* arrayIncludes */])(['button', 'a'], el.tagName.toLowerCase());
};

var getTargets = function getTargets(_ref, el) {
  var modifiers = _ref.modifiers,
      arg = _ref.arg,
      value = _ref.value;
  // Any modifiers are considered target IDs
  var targets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["a" /* keys */])(modifiers || {}); // If value is a string, split out individual targets (if space delimited)

  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["f" /* isString */])(value) ? value.split(__WEBPACK_IMPORTED_MODULE_4__constants_regex__["m" /* RX_SPACE_SPLIT */]) : value; // Support target ID as link href (`href="#id"`)

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["p" /* isTag */])(el.tagName, 'a')) {
    var href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["i" /* getAttr */])(el, 'href') || '';

    if (__WEBPACK_IMPORTED_MODULE_4__constants_regex__["n" /* RX_HASH_ID */].test(href)) {
      targets.push(href.replace(__WEBPACK_IMPORTED_MODULE_4__constants_regex__["o" /* RX_HASH */], ''));
    }
  } // Add ID from `arg` (if provided), and support value
  // as a single string ID or an array of string IDs
  // If `value` is not an array or string, then it gets filtered out


  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(arg, value).forEach(function (t) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["f" /* isString */])(t) && targets.push(t);
  }); // Return only unique and truthy target IDs

  return targets.filter(function (t, index, arr) {
    return t && arr.indexOf(t) === index;
  });
};

var removeClickListener = function removeClickListener(el) {
  var handler = el[BV_TOGGLE_CLICK_HANDLER];

  if (handler) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["c" /* eventOff */])(el, 'click', handler, __WEBPACK_IMPORTED_MODULE_2__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["c" /* eventOff */])(el, 'keydown', handler, __WEBPACK_IMPORTED_MODULE_2__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
  }

  el[BV_TOGGLE_CLICK_HANDLER] = null;
};

var addClickListener = function addClickListener(el, instance) {
  removeClickListener(el);

  if (instance) {
    var handler = function handler(event) {
      if (!(event.type === 'keydown' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["c" /* arrayIncludes */])(KEYDOWN_KEY_CODES, event.keyCode)) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["m" /* isDisabled */])(el)) {
        var targets = el[BV_TOGGLE_TARGETS] || [];
        targets.forEach(function (target) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__["a" /* getEventRoot */])(instance).$emit(ROOT_ACTION_EVENT_NAME_TOGGLE, target);
        });
      }
    };

    el[BV_TOGGLE_CLICK_HANDLER] = handler;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["b" /* eventOn */])(el, 'click', handler, __WEBPACK_IMPORTED_MODULE_2__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);

    if (isNonStandardTag(el)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["b" /* eventOn */])(el, 'keydown', handler, __WEBPACK_IMPORTED_MODULE_2__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    }
  }
};

var removeRootListeners = function removeRootListeners(el, instance) {
  if (el[BV_TOGGLE_ROOT_HANDLER] && instance) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__["a" /* getEventRoot */])(instance).$off([ROOT_EVENT_NAME_STATE, ROOT_EVENT_NAME_SYNC_STATE], el[BV_TOGGLE_ROOT_HANDLER]);
  }

  el[BV_TOGGLE_ROOT_HANDLER] = null;
};

var addRootListeners = function addRootListeners(el, instance) {
  removeRootListeners(el, instance);

  if (instance) {
    var handler = function handler(id, state) {
      // `state` will be `true` if target is expanded
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["c" /* arrayIncludes */])(el[BV_TOGGLE_TARGETS] || [], id)) {
        // Set/Clear 'collapsed' visibility class state
        el[BV_TOGGLE_STATE] = state; // Set `aria-expanded` and class state on trigger element

        setToggleState(el, state);
      }
    };

    el[BV_TOGGLE_ROOT_HANDLER] = handler; // Listen for toggle state changes (public) and sync (private)

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__["a" /* getEventRoot */])(instance).$on([ROOT_EVENT_NAME_STATE, ROOT_EVENT_NAME_SYNC_STATE], handler);
  }
};

var setToggleState = function setToggleState(el, state) {
  // State refers to the visibility of the collapse/sidebar
  if (state) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["q" /* removeClass */])(el, CLASS_BV_TOGGLE_COLLAPSED);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["r" /* addClass */])(el, CLASS_BV_TOGGLE_NOT_COLLAPSED);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["j" /* setAttr */])(el, ATTR_ARIA_EXPANDED, STRING_TRUE);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["q" /* removeClass */])(el, CLASS_BV_TOGGLE_NOT_COLLAPSED);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["r" /* addClass */])(el, CLASS_BV_TOGGLE_COLLAPSED);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["j" /* setAttr */])(el, ATTR_ARIA_EXPANDED, STRING_FALSE);
  }
}; // Reset and remove a property from the provided element


var resetProp = function resetProp(el, prop) {
  el[prop] = null;
  delete el[prop];
}; // Handle directive updates


var handleUpdate = function handleUpdate(el, binding, vnode) {
  /* istanbul ignore next: should never happen */
  if (!__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */] || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, binding)) {
    return;
  } // If element is not a button or link, we add `role="button"`
  // and `tabindex="0"` for accessibility reasons


  if (isNonStandardTag(el)) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["l" /* hasAttr */])(el, ATTR_ROLE)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["j" /* setAttr */])(el, ATTR_ROLE, 'button');
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["l" /* hasAttr */])(el, ATTR_TABINDEX)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["j" /* setAttr */])(el, ATTR_TABINDEX, '0');
    }
  } // Ensure the collapse class and `aria-*` attributes persist
  // after element is updated (either by parent re-rendering
  // or changes to this element or its contents)


  setToggleState(el, el[BV_TOGGLE_STATE]); // Parse list of target IDs

  var targets = getTargets(binding, el); // Ensure the `aria-controls` hasn't been overwritten
  // or removed when vnode updates
  // Also ensure to set `overflow-anchor` to `none` to prevent
  // the browser's scroll anchoring behavior

  /* istanbul ignore else */

  if (targets.length > 0) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["j" /* setAttr */])(el, ATTR_ARIA_CONTROLS, targets.join(' '));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["s" /* setStyle */])(el, STYLE_OVERFLOW_ANCHOR, 'none');
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["k" /* removeAttr */])(el, ATTR_ARIA_CONTROLS);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["t" /* removeStyle */])(el, STYLE_OVERFLOW_ANCHOR);
  } // Add/Update our click listener(s)
  // Wrap in a `requestAF()` to allow any previous
  // click handling to occur first


  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["a" /* requestAF */])(function () {
    addClickListener(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, binding));
  }); // If targets array has changed, update

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_loose_equal__["a" /* looseEqual */])(targets, el[BV_TOGGLE_TARGETS])) {
    // Update targets array to element storage
    el[BV_TOGGLE_TARGETS] = targets; // Ensure `aria-controls` is up to date
    // Request a state update from targets so that we can
    // ensure expanded state is correct (in most cases)

    targets.forEach(function (target) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__["a" /* getEventRoot */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, binding)).$emit(ROOT_ACTION_EVENT_NAME_REQUEST_STATE, target);
    });
  }
};
/*
 * Export our directive
 */


var VBToggle = {
  bind: function bind(el, binding, vnode) {
    // State is initially collapsed until we receive a state event
    el[BV_TOGGLE_STATE] = false; // Assume no targets initially

    el[BV_TOGGLE_TARGETS] = []; // Add our root listeners

    addRootListeners(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, binding)); // Initial update of trigger

    handleUpdate(el, binding, vnode);
  },
  componentUpdated: handleUpdate,
  updated: handleUpdate,
  unbind: function unbind(el, binding, vnode) {
    removeClickListener(el); // Remove our $root listener

    removeRootListeners(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, binding)); // Reset custom props

    resetProp(el, BV_TOGGLE_ROOT_HANDLER);
    resetProp(el, BV_TOGGLE_CLICK_HANDLER);
    resetProp(el, BV_TOGGLE_STATE);
    resetProp(el, BV_TOGGLE_TARGETS); // Reset classes/attrs/styles

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["q" /* removeClass */])(el, CLASS_BV_TOGGLE_COLLAPSED);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["q" /* removeClass */])(el, CLASS_BV_TOGGLE_NOT_COLLAPSED);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["k" /* removeAttr */])(el, ATTR_ARIA_EXPANDED);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["k" /* removeAttr */])(el, ATTR_ARIA_CONTROLS);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["k" /* removeAttr */])(el, ATTR_ROLE);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["t" /* removeStyle */])(el, STYLE_OVERFLOW_ANCHOR);
  }
};

/***/ }),
/* 248 */
/* exports provided: VBTooltipPlugin, VBTooltip */
/* exports used: VBTooltipPlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/tooltip/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBTooltipPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(/*! ./tooltip */ 454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport VBTooltip */


var VBTooltipPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  directives: {
    VBTooltip: __WEBPACK_IMPORTED_MODULE_0__tooltip__["a" /* VBTooltip */]
  }
});


/***/ }),
/* 249 */
/* exports provided: props, BVIconBase */
/* exports used: props, BVIconBase */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/icons/helpers/icon-base.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BVIconBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // --- Constants ---
// Base attributes needed on all icons

var BASE_ATTRS = {
  viewBox: '0 0 16 16',
  width: '1em',
  height: '1em',
  focusable: 'false',
  role: 'img',
  'aria-label': 'icon'
}; // Attributes that are nulled out when stacked

var STACKED_ATTRS = {
  width: null,
  height: null,
  focusable: null,
  role: null,
  'aria-label': null
}; // --- Props ---

var props = {
  animation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  content: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  flipH: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  flipV: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  fontScale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 1),
  rotate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  scale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 1),
  shiftH: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  shiftV: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  stacked: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}; // --- Main component ---
// Shared private base component to reduce bundle/runtime size
// @vue/component

var BVIconBase = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_73" /* NAME_ICON_BASE */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;
    var animation = props.animation,
        content = props.content,
        flipH = props.flipH,
        flipV = props.flipV,
        stacked = props.stacked,
        title = props.title,
        variant = props.variant;
    var fontScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(props.fontScale, 1), 0) || 1;
    var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(props.scale, 1), 0) || 1;
    var rotate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(props.rotate, 0);
    var shiftH = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(props.shiftH, 0);
    var shiftV = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(props.shiftV, 0); // Compute the transforms
    // Note that order is important as SVG transforms are applied in order from
    // left to right and we want flipping/scale to occur before rotation
    // Note shifting is applied separately
    // Assumes that the viewbox is `0 0 16 16` (`8 8` is the center)

    var hasScale = flipH || flipV || scale !== 1;
    var hasTransforms = hasScale || rotate;
    var hasShift = shiftH || shiftV;
    var hasContent = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["g" /* isUndefinedOrNull */])(content);
    var transforms = [hasTransforms ? 'translate(8 8)' : null, hasScale ? "scale(".concat((flipH ? -1 : 1) * scale, " ").concat((flipV ? -1 : 1) * scale, ")") : null, rotate ? "rotate(".concat(rotate, ")") : null, hasTransforms ? 'translate(-8 -8)' : null].filter(__WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* identity */]); // We wrap the content in a `<g>` for handling the transforms (except shift)

    var $inner = h('g', {
      attrs: {
        transform: transforms.join(' ') || null
      },
      domProps: hasContent ? {
        innerHTML: content || ''
      } : {}
    }, children); // If needed, we wrap in an additional `<g>` in order to handle the shifting

    if (hasShift) {
      $inner = h('g', {
        attrs: {
          transform: "translate(".concat(16 * shiftH / 16, " ").concat(-16 * shiftV / 16, ")")
        }
      }, [$inner]);
    } // Wrap in an additional `<g>` for proper animation handling if stacked


    if (stacked) {
      $inner = h('g', [$inner]);
    }

    var $title = title ? h('title', title) : null;
    var $content = [$title, $inner].filter(__WEBPACK_IMPORTED_MODULE_3__utils_identity__["a" /* identity */]);
    return h('svg', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])({
      staticClass: 'b-icon bi',
      class: (_class = {}, _defineProperty(_class, "text-".concat(variant), variant), _defineProperty(_class, "b-icon-animation-".concat(animation), animation), _class),
      attrs: BASE_ATTRS,
      style: stacked ? {} : {
        fontSize: fontScale === 1 ? null : "".concat(fontScale * 100, "%")
      }
    }, // Merge in user supplied data
    data, // If icon is stacked, null-out some attrs
    stacked ? {
      attrs: STACKED_ATTRS
    } : {}, // These cannot be overridden by users
    {
      attrs: {
        xmlns: stacked ? null : 'http://www.w3.org/2000/svg',
        fill: 'currentColor'
      }
    }), $content);
  }
});

/***/ }),
/* 250 */
/* exports provided: props, BIconstack */
/* exports used: BIconstack */
/*!************************************************!*\
  !*** ./~/bootstrap-vue/esm/icons/iconstack.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BIconstack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_icon_base__ = __webpack_require__(/*! ./helpers/icon-base */ 249);




 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_4__helpers_icon_base__["a" /* props */], ['content', 'stacked']), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_74" /* NAME_ICONSTACK */]); // --- Main component ---
// @vue/component

var BIconstack = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_74" /* NAME_ICONSTACK */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;
    return h(__WEBPACK_IMPORTED_MODULE_4__helpers_icon_base__["b" /* BVIconBase */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'b-iconstack',
      props: props
    }), children);
  }
});

/***/ }),
/* 251 */
/* exports provided: props, dropdownMixin */
/* exports used: props, dropdownMixin */
/*!************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/dropdown.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dropdownMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(/*! popper.js */ 630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_components__ = __webpack_require__(/*! ../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_env__ = __webpack_require__(/*! ../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_key_codes__ = __webpack_require__(/*! ../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_popper__ = __webpack_require__(/*! ../constants/popper */ 945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_safe_types__ = __webpack_require__(/*! ../constants/safe-types */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bv_event_class__ = __webpack_require__(/*! ../utils/bv-event.class */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_dom__ = __webpack_require__(/*! ../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_events__ = __webpack_require__(/*! ../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_inspect__ = __webpack_require__(/*! ../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_warn__ = __webpack_require__(/*! ../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__click_out__ = __webpack_require__(/*! ./click-out */ 951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__focus_in__ = __webpack_require__(/*! ./focus-in */ 952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__id__ = __webpack_require__(/*! ./id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__listen_on_root__ = __webpack_require__(/*! ./listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_element_to_vue_instance_registry__ = __webpack_require__(/*! ../utils/element-to-vue-instance-registry */ 465);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















 // --- Constants ---

var ROOT_EVENT_NAME_SHOWN = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["U" /* NAME_DROPDOWN */], __WEBPACK_IMPORTED_MODULE_4__constants_events__["d" /* EVENT_NAME_SHOWN */]);
var ROOT_EVENT_NAME_HIDDEN = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["U" /* NAME_DROPDOWN */], __WEBPACK_IMPORTED_MODULE_4__constants_events__["b" /* EVENT_NAME_HIDDEN */]); // CSS selectors

var SELECTOR_FORM_CHILD = '.dropdown form';
var SELECTOR_ITEM = ['.dropdown-item', '.b-dropdown-form'].map(function (selector) {
  return "".concat(selector, ":not(.disabled):not([disabled])");
}).join(', '); // --- Helper methods ---
// Return an array of visible items

var filterVisibles = function filterVisibles(els) {
  return (els || []).filter(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["c" /* isVisible */]);
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_18__id__["a" /* props */]), {}, {
  // String: `scrollParent`, `window` or `viewport`
  // HTMLElement: HTML Element reference
  boundary: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_8__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_7__constants_props__["b" /* PROP_TYPE_STRING */]], 'scrollParent'),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Place left if possible
  dropleft: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Place right if possible
  dropright: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Place on top if possible
  dropup: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Disable auto-flipping of menu from bottom <=> top
  noFlip: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Number of pixels or a CSS unit value to offset menu
  // (i.e. `1px`, `1rem`, etc.)
  offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  popperOpts: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["e" /* PROP_TYPE_OBJECT */], {}),
  // Right align menu (default is left align)
  right: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_7__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_2__constants_components__["U" /* NAME_DROPDOWN */]); // --- Mixin ---
// @vue/component

var dropdownMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_18__id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_19__listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_16__click_out__["a" /* clickOutMixin */], __WEBPACK_IMPORTED_MODULE_17__focus_in__["a" /* focusInMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvDropdown: function getBvDropdown() {
        return _this;
      }
    };
  },
  inject: {
    getBvNavbar: {
      default: function _default() {
        return function () {
          return null;
        };
      }
    }
  },
  props: props,
  data: function data() {
    return {
      visible: false,
      visibleChangePrevented: false
    };
  },
  computed: {
    bvNavbar: function bvNavbar() {
      return this.getBvNavbar();
    },
    inNavbar: function inNavbar() {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["e" /* isNull */])(this.bvNavbar);
    },
    toggler: function toggler() {
      var toggle = this.$refs.toggle;
      return toggle ? toggle.$el || toggle : null;
    },
    directionClass: function directionClass() {
      if (this.dropup) {
        return 'dropup';
      } else if (this.dropright) {
        return 'dropright';
      } else if (this.dropleft) {
        return 'dropleft';
      }

      return '';
    },
    boundaryClass: function boundaryClass() {
      // Position `static` is needed to allow menu to "breakout" of the `scrollParent`
      // boundaries when boundary is anything other than `scrollParent`
      // See: https://github.com/twbs/bootstrap/issues/24251#issuecomment-341413786
      return this.boundary !== 'scrollParent' && !this.inNavbar ? 'position-static' : '';
    },
    hideDelay: function hideDelay() {
      return this.inNavbar ? __WEBPACK_IMPORTED_MODULE_3__constants_env__["i" /* HAS_TOUCH_SUPPORT */] ? 300 : 50 : 0;
    }
  },
  watch: {
    visible: function visible(newValue, oldValue) {
      if (this.visibleChangePrevented) {
        this.visibleChangePrevented = false;
        return;
      }

      if (newValue !== oldValue) {
        var eventName = newValue ? __WEBPACK_IMPORTED_MODULE_4__constants_events__["a" /* EVENT_NAME_SHOW */] : __WEBPACK_IMPORTED_MODULE_4__constants_events__["e" /* EVENT_NAME_HIDE */];
        var bvEvent = new __WEBPACK_IMPORTED_MODULE_9__utils_bv_event_class__["a" /* BvEvent */](eventName, {
          cancelable: true,
          vueTarget: this,
          target: this.$refs.menu,
          relatedTarget: null,
          componentId: this.safeId ? this.safeId() : this.id || null
        });
        this.emitEvent(bvEvent);

        if (bvEvent.defaultPrevented) {
          // Reset value and exit if canceled
          this.visibleChangePrevented = true;
          this.visible = oldValue; // Just in case a child element triggered `this.hide(true)`

          this.$off(__WEBPACK_IMPORTED_MODULE_4__constants_events__["b" /* EVENT_NAME_HIDDEN */], this.focusToggler);
          return;
        }

        if (newValue) {
          this.showMenu();
        } else {
          this.hideMenu();
        }
      }
    },
    disabled: function disabled(newValue, oldValue) {
      if (newValue !== oldValue && newValue && this.visible) {
        // Hide dropdown if disabled changes to true
        this.visible = false;
      }
    }
  },
  created: function created() {
    // Create private non-reactive props
    this.$_popper = null;
    this.$_hideTimeout = null;
  },

  /* istanbul ignore next */
  deactivated: function deactivated() {
    // In case we are inside a `<keep-alive>`
    this.visible = false;
    this.whileOpenListen(false);
    this.destroyPopper();
  },
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_element_to_vue_instance_registry__["b" /* registerElementToInstance */])(this.$el, this);
  },
  beforeDestroy: function beforeDestroy() {
    this.visible = false;
    this.whileOpenListen(false);
    this.destroyPopper();
    this.clearHideTimeout();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_element_to_vue_instance_registry__["c" /* removeElementToInstance */])(this.$el);
  },
  methods: {
    // Event emitter
    emitEvent: function emitEvent(bvEvent) {
      var type = bvEvent.type;
      this.emitOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_2__constants_components__["U" /* NAME_DROPDOWN */], type), bvEvent);
      this.$emit(type, bvEvent);
    },
    showMenu: function showMenu() {
      var _this2 = this;

      if (this.disabled) {
        /* istanbul ignore next */
        return;
      } // Only instantiate Popper.js when dropdown is not in `<b-navbar>`


      if (!this.inNavbar) {
        if (typeof __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */] === 'undefined') {
          /* istanbul ignore next */
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_warn__["a" /* warn */])('Popper.js not found. Falling back to CSS positioning', __WEBPACK_IMPORTED_MODULE_2__constants_components__["U" /* NAME_DROPDOWN */]);
        } else {
          // For dropup with alignment we use the parent element as popper container
          var el = this.dropup && this.right || this.split ? this.$el : this.$refs.toggle; // Make sure we have a reference to an element, not a component!

          el = el.$el || el; // Instantiate Popper.js

          this.createPopper(el);
        }
      } // Ensure other menus are closed


      this.emitOnRoot(ROOT_EVENT_NAME_SHOWN, this); // Enable listeners

      this.whileOpenListen(true); // Wrap in `$nextTick()` to ensure menu is fully rendered/shown

      this.$nextTick(function () {
        // Focus on the menu container on show
        _this2.focusMenu(); // Emit the shown event


        _this2.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["d" /* EVENT_NAME_SHOWN */]);
      });
    },
    hideMenu: function hideMenu() {
      this.whileOpenListen(false);
      this.emitOnRoot(ROOT_EVENT_NAME_HIDDEN, this);
      this.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["b" /* EVENT_NAME_HIDDEN */]);
      this.destroyPopper();
    },
    createPopper: function createPopper(element) {
      this.destroyPopper();
      this.$_popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](element, this.$refs.menu, this.getPopperConfig());
    },
    // Ensure popper event listeners are removed cleanly
    destroyPopper: function destroyPopper() {
      this.$_popper && this.$_popper.destroy();
      this.$_popper = null;
    },
    // Instructs popper to re-computes the dropdown position
    // useful if the content changes size
    updatePopper: function updatePopper() {
      try {
        this.$_popper.scheduleUpdate();
      } catch (_unused) {}
    },
    clearHideTimeout: function clearHideTimeout() {
      clearTimeout(this.$_hideTimeout);
      this.$_hideTimeout = null;
    },
    getPopperConfig: function getPopperConfig() {
      var placement = __WEBPACK_IMPORTED_MODULE_6__constants_popper__["a" /* PLACEMENT_BOTTOM_START */];

      if (this.dropup) {
        placement = this.right ? __WEBPACK_IMPORTED_MODULE_6__constants_popper__["b" /* PLACEMENT_TOP_END */] : __WEBPACK_IMPORTED_MODULE_6__constants_popper__["c" /* PLACEMENT_TOP_START */];
      } else if (this.dropright) {
        placement = __WEBPACK_IMPORTED_MODULE_6__constants_popper__["d" /* PLACEMENT_RIGHT_START */];
      } else if (this.dropleft) {
        placement = __WEBPACK_IMPORTED_MODULE_6__constants_popper__["e" /* PLACEMENT_LEFT_START */];
      } else if (this.right) {
        placement = __WEBPACK_IMPORTED_MODULE_6__constants_popper__["f" /* PLACEMENT_BOTTOM_END */];
      }

      var popperConfig = {
        placement: placement,
        modifiers: {
          offset: {
            offset: this.offset || 0
          },
          flip: {
            enabled: !this.noFlip
          }
        }
      };
      var boundariesElement = this.boundary;

      if (boundariesElement) {
        popperConfig.modifiers.preventOverflow = {
          boundariesElement: boundariesElement
        };
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_object__["n" /* mergeDeep */])(popperConfig, this.popperOpts || {});
    },
    // Turn listeners on/off while open
    whileOpenListen: function whileOpenListen(isOpen) {
      // Hide the dropdown when clicked outside
      this.listenForClickOut = isOpen; // Hide the dropdown when it loses focus

      this.listenForFocusIn = isOpen; // Hide the dropdown when another dropdown is opened

      var method = isOpen ? 'listenOnRoot' : 'listenOffRoot';
      this[method](ROOT_EVENT_NAME_SHOWN, this.rootCloseListener);
    },
    rootCloseListener: function rootCloseListener(vm) {
      if (vm !== this) {
        this.visible = false;
      }
    },
    // Public method to show dropdown
    show: function show() {
      var _this3 = this;

      if (this.disabled) {
        return;
      } // Wrap in a `requestAF()` to allow any previous
      // click handling to occur first


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["a" /* requestAF */])(function () {
        _this3.visible = true;
      });
    },
    // Public method to hide dropdown
    hide: function hide() {
      var refocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      /* istanbul ignore next */
      if (this.disabled) {
        return;
      }

      this.visible = false;

      if (refocus) {
        // Child element is closing the dropdown on click
        this.$once(__WEBPACK_IMPORTED_MODULE_4__constants_events__["b" /* EVENT_NAME_HIDDEN */], this.focusToggler);
      }
    },
    // Called only by a button that toggles the menu
    toggle: function toggle(event) {
      event = event || {}; // Early exit when not a click event or ENTER, SPACE or DOWN were pressed

      var _event = event,
          type = _event.type,
          keyCode = _event.keyCode;

      if (type !== 'click' && !(type === 'keydown' && [__WEBPACK_IMPORTED_MODULE_5__constants_key_codes__["a" /* CODE_ENTER */], __WEBPACK_IMPORTED_MODULE_5__constants_key_codes__["b" /* CODE_SPACE */], __WEBPACK_IMPORTED_MODULE_5__constants_key_codes__["f" /* CODE_DOWN */]].indexOf(keyCode) !== -1)) {
        /* istanbul ignore next */
        return;
      }
      /* istanbul ignore next */


      if (this.disabled) {
        this.visible = false;
        return;
      }

      this.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["U" /* EVENT_NAME_TOGGLE */], event);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event); // Toggle visibility

      if (this.visible) {
        this.hide(true);
      } else {
        this.show();
      }
    },
    // Mousedown handler for the toggle

    /* istanbul ignore next */
    onMousedown: function onMousedown(event) {
      // We prevent the 'mousedown' event for the toggle to stop the
      // 'focusin' event from being fired
      // The event would otherwise be picked up by the global 'focusin'
      // listener and there is no cross-browser solution to detect it
      // relates to the toggle click
      // The 'click' event will still be fired and we handle closing
      // other dropdowns there too
      // See https://github.com/bootstrap-vue/bootstrap-vue/issues/4328
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event, {
        propagation: false
      });
    },
    // Called from dropdown menu context
    onKeydown: function onKeydown(event) {
      var keyCode = event.keyCode;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_5__constants_key_codes__["k" /* CODE_ESC */]) {
        // Close on ESC
        this.onEsc(event);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5__constants_key_codes__["f" /* CODE_DOWN */]) {
        // Down Arrow
        this.focusNext(event, false);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_5__constants_key_codes__["e" /* CODE_UP */]) {
        // Up Arrow
        this.focusNext(event, true);
      }
    },
    // If user presses ESC, close the menu
    onEsc: function onEsc(event) {
      if (this.visible) {
        this.visible = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event); // Return focus to original trigger button

        this.$once(__WEBPACK_IMPORTED_MODULE_4__constants_events__["b" /* EVENT_NAME_HIDDEN */], this.focusToggler);
      }
    },
    // Called only in split button mode, for the split button
    onSplitClick: function onSplitClick(event) {
      /* istanbul ignore next */
      if (this.disabled) {
        this.visible = false;
        return;
      }

      this.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["x" /* EVENT_NAME_CLICK */], event);
    },
    // Shared hide handler between click-out and focus-in events
    hideHandler: function hideHandler(event) {
      var _this4 = this;

      var target = event.target;

      if (this.visible && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["b" /* contains */])(this.$refs.menu, target) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["b" /* contains */])(this.toggler, target)) {
        this.clearHideTimeout();
        this.$_hideTimeout = setTimeout(function () {
          return _this4.hide();
        }, this.hideDelay);
      }
    },
    // Document click-out listener
    clickOutHandler: function clickOutHandler(event) {
      this.hideHandler(event);
    },
    // Document focus-in listener
    focusInHandler: function focusInHandler(event) {
      this.hideHandler(event);
    },
    // Keyboard nav
    focusNext: function focusNext(event, up) {
      var _this5 = this;

      // Ignore key up/down on form elements
      var target = event.target;

      if (!this.visible || event && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["f" /* closest */])(SELECTOR_FORM_CHILD, target)) {
        /* istanbul ignore next: should never happen */
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event);
      this.$nextTick(function () {
        var items = _this5.getItems();

        if (items.length < 1) {
          /* istanbul ignore next: should never happen */
          return;
        }

        var index = items.indexOf(target);

        if (up && index > 0) {
          index--;
        } else if (!up && index < items.length - 1) {
          index++;
        }

        if (index < 0) {
          /* istanbul ignore next: should never happen */
          index = 0;
        }

        _this5.focusItem(index, items);
      });
    },
    focusItem: function focusItem(index, items) {
      var el = items.find(function (el, i) {
        return i === index;
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["n" /* attemptFocus */])(el);
    },
    getItems: function getItems() {
      // Get all items
      return filterVisibles(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["w" /* selectAll */])(SELECTOR_ITEM, this.$refs.menu));
    },
    focusMenu: function focusMenu() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["n" /* attemptFocus */])(this.$refs.menu);
    },
    focusToggler: function focusToggler() {
      var _this6 = this;

      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["n" /* attemptFocus */])(_this6.toggler);
      });
    }
  }
});

/***/ }),
/* 252 */
/* exports provided: hasListenerMixin */
/* exports used: hasListenerMixin */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/has-listener.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasListenerMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_inspect__ = __webpack_require__(/*! ../utils/inspect */ 9);
// Mixin to determine if an event listener has been registered
// either via `v-on:name` (in the parent) or programmatically
// via `vm.$on('name', ...)`
// See: https://github.com/vuejs/vue/issues/10825

 // @vue/component

var hasListenerMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  methods: {
    hasListener: function hasListener(name) {
      if (__WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */]) {
        return true;
      } // Only includes listeners registered via `v-on:name`


      var $listeners = this.$listeners || {}; // Includes `v-on:name` and `this.$on('name')` registered listeners
      // Note this property is not part of the public Vue API, but it is
      // the only way to determine if a listener was added via `vm.$on`

      var $events = this._events || {}; // Registered listeners in `this._events` are always an array,
      // but might be zero length

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["i" /* isUndefined */])($listeners[name]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["c" /* isArray */])($events[name]) && $events[name].length > 0;
    }
  }
});

/***/ }),
/* 253 */
/* exports provided: scopedStyleMixin */
/* exports used: scopedStyleMixin */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/scoped-style.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scopedStyleMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_use_parent__ = __webpack_require__(/*! ../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_get_scope_id__ = __webpack_require__(/*! ../utils/get-scope-id */ 140);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // @vue/component

var scopedStyleMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_use_parent__["a" /* useParentMixin */]],
  computed: {
    scopedStyleAttrs: function scopedStyleAttrs() {
      var scopeId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get_scope_id__["a" /* getScopeId */])(this.bvParent);
      return scopeId ? _defineProperty({}, scopeId, '') : {};
    }
  }
});

/***/ }),
/* 254 */
/* exports provided: createDate, parseYMD, formatYMD, resolveLocale, createDateFormatter, datesEqual, firstDateOfMonth, lastDateOfMonth, addYears, oneMonthAgo, oneMonthAhead, oneYearAgo, oneYearAhead, oneDecadeAgo, oneDecadeAhead, constrainDate */
/* exports used: createDateFormatter, createDate, formatYMD, constrainDate, parseYMD, resolveLocale, lastDateOfMonth, oneDecadeAgo, oneYearAgo, oneMonthAgo, firstDateOfMonth, oneMonthAhead, oneYearAhead, oneDecadeAhead, datesEqual */
/*!*******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/date.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseYMD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatYMD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resolveLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createDateFormatter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return datesEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return firstDateOfMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lastDateOfMonth; });
/* unused harmony export addYears */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return oneMonthAgo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return oneMonthAhead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return oneYearAgo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return oneYearAhead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return oneDecadeAgo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return oneDecadeAhead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return constrainDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_date__ = __webpack_require__(/*! ../constants/date */ 448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_regex__ = __webpack_require__(/*! ../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(/*! ./array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__identity__ = __webpack_require__(/*! ./identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__number__ = __webpack_require__(/*! ./number */ 22);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Date utility functions





 // --- Date utility methods ---
// Create or clone a date (`new Date(...)` shortcut)

var createDate = function createDate() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return _construct(Date, args);
}; // Parse a date sting, or Date object, into a Date object (with no time information)

var parseYMD = function parseYMD(date) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["f" /* isString */])(date) && __WEBPACK_IMPORTED_MODULE_1__constants_regex__["v" /* RX_DATE */].test(date.trim())) {
    var _date$split$map = date.split(__WEBPACK_IMPORTED_MODULE_1__constants_regex__["w" /* RX_DATE_SPLIT */]).map(function (v) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__number__["b" /* toInteger */])(v, 1);
    }),
        _date$split$map2 = _slicedToArray(_date$split$map, 3),
        year = _date$split$map2[0],
        month = _date$split$map2[1],
        day = _date$split$map2[2];

    return createDate(year, month - 1, day);
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["b" /* isDate */])(date)) {
    return createDate(date.getFullYear(), date.getMonth(), date.getDate());
  }

  return null;
}; // Format a date object as `YYYY-MM-DD` format

var formatYMD = function formatYMD(date) {
  date = parseYMD(date);

  if (!date) {
    return null;
  }

  var year = date.getFullYear();
  var month = "0".concat(date.getMonth() + 1).slice(-2);
  var day = "0".concat(date.getDate()).slice(-2);
  return "".concat(year, "-").concat(month, "-").concat(day);
}; // Given a locale (or locales), resolve the browser available locale

var resolveLocale = function resolveLocale(locales)
/* istanbul ignore next */
{
  var calendar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__constants_date__["a" /* CALENDAR_GREGORY */];
  locales = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__array__["b" /* concat */])(locales).filter(__WEBPACK_IMPORTED_MODULE_3__identity__["a" /* identity */]);
  var fmt = new Intl.DateTimeFormat(locales, {
    calendar: calendar
  });
  return fmt.resolvedOptions().locale;
}; // Create a `Intl.DateTimeFormat` formatter function

var createDateFormatter = function createDateFormatter(locale, options)
/* istanbul ignore next */
{
  var dtf = new Intl.DateTimeFormat(locale, options);
  return dtf.format;
}; // Determine if two dates are the same date (ignoring time portion)

var datesEqual = function datesEqual(date1, date2) {
  // Returns true of the date portion of two date objects are equal
  // We don't compare the time portion
  return formatYMD(date1) === formatYMD(date2);
}; // --- Date "math" utility methods (for BCalendar component mainly) ---

var firstDateOfMonth = function firstDateOfMonth(date) {
  date = createDate(date);
  date.setDate(1);
  return date;
};
var lastDateOfMonth = function lastDateOfMonth(date) {
  date = createDate(date);
  date.setMonth(date.getMonth() + 1);
  date.setDate(0);
  return date;
};
var addYears = function addYears(date, numberOfYears) {
  date = createDate(date);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear() + numberOfYears); // Handle Feb 29th for leap years

  if (date.getMonth() !== month) {
    date.setDate(0);
  }

  return date;
};
var oneMonthAgo = function oneMonthAgo(date) {
  date = createDate(date);
  var month = date.getMonth();
  date.setMonth(month - 1); // Handle when days in month are different

  if (date.getMonth() === month) {
    date.setDate(0);
  }

  return date;
};
var oneMonthAhead = function oneMonthAhead(date) {
  date = createDate(date);
  var month = date.getMonth();
  date.setMonth(month + 1); // Handle when days in month are different

  if (date.getMonth() === (month + 2) % 12) {
    date.setDate(0);
  }

  return date;
};
var oneYearAgo = function oneYearAgo(date) {
  return addYears(date, -1);
};
var oneYearAhead = function oneYearAhead(date) {
  return addYears(date, 1);
};
var oneDecadeAgo = function oneDecadeAgo(date) {
  return addYears(date, -10);
};
var oneDecadeAhead = function oneDecadeAhead(date) {
  return addYears(date, 10);
}; // Helper function to constrain a date between two values
// Always returns a `Date` object or `null` if no date passed

var constrainDate = function constrainDate(date) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  // Ensure values are `Date` objects (or `null`)
  date = parseYMD(date);
  min = parseYMD(min) || date;
  max = parseYMD(max) || date; // Return a new `Date` object (or `null`)

  return date ? date < min ? min : date > max ? max : date : null;
};

/***/ }),
/* 255 */
/* exports provided: memoize */
/* exports used: memoize */
/*!**********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/memoize.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return memoize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(/*! ./object */ 6);

var memoize = function memoize(fn) {
  var cache = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object__["i" /* create */])(null);
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsKey = JSON.stringify(args);
    return cache[argsKey] = cache[argsKey] || fn.apply(null, args);
  };
};

/***/ }),
/* 256 */
/* exports provided: noop */
/* exports used: noop */
/*!*******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/noop.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noop; });
var noop = function noop() {};

/***/ }),
/* 257 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_an-instance.js ***!
  \***************************************************/
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 258 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/modules/_defined.js ***!
  \***********************************************/
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 259 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_dom-create.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./_is-object */ 82);
var document = __webpack_require__(/*! ./_global */ 55).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 260 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/core-js/library/modules/_enum-bug-keys.js ***!
  \*****************************************************/
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 261 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/modules/_iobject.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(/*! ./_cof */ 143);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 262 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_iter-define.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(/*! ./_library */ 145);
var $export = __webpack_require__(/*! ./_export */ 49);
var redefine = __webpack_require__(/*! ./_redefine */ 479);
var hide = __webpack_require__(/*! ./_hide */ 97);
var Iterators = __webpack_require__(/*! ./_iterators */ 123);
var $iterCreate = __webpack_require__(/*! ./_iter-create */ 986);
var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ 148);
var getPrototypeOf = __webpack_require__(/*! ./_object-gpo */ 992);
var ITERATOR = __webpack_require__(/*! ./_wks */ 56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 263 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/core-js/library/modules/_meta.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(/*! ./_uid */ 188)('meta');
var isObject = __webpack_require__(/*! ./_is-object */ 82);
var has = __webpack_require__(/*! ./_has */ 112);
var setDesc = __webpack_require__(/*! ./_object-dp */ 75).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(/*! ./_fails */ 111)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 264 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./~/core-js/library/modules/_new-promise-capability.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(/*! ./_a-function */ 142);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 265 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/core-js/library/modules/_object-create.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(/*! ./_an-object */ 89);
var dPs = __webpack_require__(/*! ./_object-dps */ 989);
var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */ 260);
var IE_PROTO = __webpack_require__(/*! ./_shared-key */ 268)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(/*! ./_dom-create */ 259)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(/*! ./_html */ 468).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 266 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_object-gops.js ***!
  \***************************************************/
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 267 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/core-js/library/modules/_redefine-all.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(/*! ./_hide */ 97);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 268 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_shared-key.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(/*! ./_shared */ 269)('keys');
var uid = __webpack_require__(/*! ./_uid */ 188);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 269 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/modules/_shared.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(/*! ./_core */ 39);
var global = __webpack_require__(/*! ./_global */ 55);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(/*! ./_library */ 145) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 270 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_to-integer.js ***!
  \**************************************************/
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 271 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/core-js/library/modules/_to-primitive.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(/*! ./_is-object */ 82);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 272 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_wks-define.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ./_global */ 55);
var core = __webpack_require__(/*! ./_core */ 39);
var LIBRARY = __webpack_require__(/*! ./_library */ 145);
var wksExt = __webpack_require__(/*! ./_wks-ext */ 273);
var defineProperty = __webpack_require__(/*! ./_object-dp */ 75).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 273 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/modules/_wks-ext.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(/*! ./_wks */ 56);


/***/ }),
/* 274 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/core-js/library/modules/core.get-iterator-method.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ./_classof */ 186);
var ITERATOR = __webpack_require__(/*! ./_wks */ 56)('iterator');
var Iterators = __webpack_require__(/*! ./_iterators */ 123);
module.exports = __webpack_require__(/*! ./_core */ 39).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 275 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/core-js/library/modules/es6.object.to-string.js ***!
  \***********************************************************/
/***/ (function(module, exports) {



/***/ }),
/* 276 */
/* exports provided: Schedule */
/* exports used: Schedule */
/*!***********************************!*\
  !*** ./~/dayspan/lib/Schedule.js ***!
  \***********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Schedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Day__ = __webpack_require__(/*! ./Day */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Identifier__ = __webpack_require__(/*! ./Identifier */ 190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DaySpan__ = __webpack_require__(/*! ./DaySpan */ 189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(/*! ./Constants */ 98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Parse__ = __webpack_require__(/*! ./Parse */ 152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Suffix__ = __webpack_require__(/*! ./Suffix */ 278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ScheduleModifier__ = __webpack_require__(/*! ./ScheduleModifier */ 277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Units__ = __webpack_require__(/*! ./Units */ 191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Iterator__ = __webpack_require__(/*! ./Iterator */ 150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(/*! moment */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);











// @ts-ignore

/**
 * A class which describes when an event occurs over what time and if it repeats.
 *
 * @typeparam M The type of metadata stored in the schedule.
 */
var Schedule = (function () {
    /**
     * Creates a schedule based on the given input.
     *
     * @param input The input which describes the schedule of events.
     */
    function Schedule(input) {
        this.exclude = new __WEBPACK_IMPORTED_MODULE_7__ScheduleModifier__["a" /* ScheduleModifier */]();
        this.include = new __WEBPACK_IMPORTED_MODULE_7__ScheduleModifier__["a" /* ScheduleModifier */]();
        this.cancel = new __WEBPACK_IMPORTED_MODULE_7__ScheduleModifier__["a" /* ScheduleModifier */]();
        this.meta = new __WEBPACK_IMPORTED_MODULE_7__ScheduleModifier__["a" /* ScheduleModifier */]();
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(input)) {
            this.set(input);
        }
    }
    /**
     * Sets the schedule with the given input.
     *
     * @param input The input or schedule which describes the schedule of events.
     * @param parseMeta A function to use when parsing meta input into the desired type.
     * @see [[Parse.schedule]]
     */
    Schedule.prototype.set = function (input, parseMeta) {
        if (parseMeta === void 0) { parseMeta = (function (x) { return x; }); }
        if (input instanceof Schedule) {
            __WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].schedule(input.toInput(), undefined, this);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].schedule(input, __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.parseMeta, parseMeta), this);
        }
        return this;
    };
    Object.defineProperty(Schedule.prototype, "lastTime", {
        /**
         * Returns the last event time specified or `undefined` if this schedule is
         * for an all day event.
         */
        get: function () {
            return this.times[this.times.length - 1];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schedule.prototype, "identifierType", {
        /**
         * The [[Identifier]] for this schedule. Either [[Identifier.Day]] or
         * [[Identifier.Time]].
         */
        get: function () {
            return this.isFullDay() ? __WEBPACK_IMPORTED_MODULE_2__Identifier__["a" /* Identifier */].Day : __WEBPACK_IMPORTED_MODULE_2__Identifier__["a" /* Identifier */].Time;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Updates the [[Schedule.durationInDays]] variable based on the
     * [[Schedule.lastTime]] (if any), the [[Schedule.duration]] and it's
     * [[Schedule.durationUnit]].
     */
    Schedule.prototype.updateDurationInDays = function () {
        var start = this.lastTime ? this.lastTime.toMilliseconds() : 0;
        var duration = this.duration * (__WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].DURATION_TO_MILLIS[this.durationUnit] || 0);
        var exclude = __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].MILLIS_IN_DAY;
        var day = __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].MILLIS_IN_DAY;
        this.durationInDays = Math.max(0, Math.ceil((start + duration - exclude) / day));
        return this;
    };
    /**
     * Updates [[Schedule.checks]] based on the frequencies that were specified
     * in the schedule input.
     */
    Schedule.prototype.updateChecks = function () {
        this.checks = __WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].givenFrequency([
            this.year,
            this.month,
            this.week,
            this.weekOfYear,
            this.fullWeekOfYear,
            this.weekspanOfYear,
            this.lastFullWeekOfYear,
            this.lastWeekspanOfYear,
            this.weekOfMonth,
            this.weekspanOfMonth,
            this.fullWeekOfMonth,
            this.lastWeekspanOfMonth,
            this.lastFullWeekOfMonth,
            this.dayOfWeek,
            this.dayOfMonth,
            this.lastDayOfMonth,
            this.dayOfYear
        ]);
        return this;
    };
    /**
     * Determines whether the given day lies between the earliest and latest
     * valid day in the schedule.
     *
     * @param day The day to test.
     * @returns `true` if the day lies in the schedule, otherwise `false`.
     * @see [[Schedule.start]]
     * @see [[Schedule.end]]
     */
    Schedule.prototype.matchesSpan = function (day) {
        return (this.start === null || day.isSameOrAfter(this.start)) &&
            (this.end === null || day.isBefore(this.end));
    };
    /**
     * Determines whether the given range overlaps with the earliest and latest
     * valid days in this schedule (if any).
     *
     * @param start The first day in the range.
     * @param end The last day in the range.
     * @returns `true` if the range intersects with the schedule, otherwise `false`.
     * @see [[Schedule.start]]
     * @see [[Schedule.end]]
     */
    Schedule.prototype.matchesRange = function (start, end) {
        if (this.start && end.isBefore(this.start)) {
            return false;
        }
        if (this.end && start.isAfter(this.end)) {
            return false;
        }
        return true;
    };
    /**
     * Determines whether the given day is explicitly excluded in the schedule.
     *
     * @param day The day to test.
     * @param lookAtTime lookAtTime If the specific time of the given day should
     *    be looked at.
     * @returns `true` if the day was excluded, otherwise `false`.
     */
    Schedule.prototype.isExcluded = function (day, lookAtTime) {
        if (lookAtTime === void 0) { lookAtTime = true; }
        return this.exclude.get(day, false, lookAtTime);
    };
    /**
     * Determines whether the given day is explicitly included in the schedule.
     *
     * @param day The day to test.
     * @param lookAtTime lookAtTime If the specific time of the given day should
     *    be looked at.
     * @returns `true` if the day is NOT explicitly included, otherwise `false`.
     */
    Schedule.prototype.isIncluded = function (day, lookAtTime) {
        if (lookAtTime === void 0) { lookAtTime = true; }
        return this.include.get(day, false, lookAtTime);
    };
    /**
     * Determines whether the given day is cancelled in the schedule.
     *
     * @param day The day to test.
     * @param lookAtTime lookAtTime If the specific time of the given day should
     *    be looked at.
     * @returns `true` if the day was cancelled, otherwise `false`.
     */
    Schedule.prototype.isCancelled = function (day, lookAtTime) {
        if (lookAtTime === void 0) { lookAtTime = true; }
        return this.cancel.get(day, false, lookAtTime);
    };
    /**
     * Returns the metadata for the given day or `null` if there is none.
     *
     * @param day The day to return the metadata for.
     * @param otherwise The data to return if none exists for the given day.
     * @param lookAtTime lookAtTime If the specific time of the given day should
     *    be looked at.
     * @returns The metadata or `null`.
     */
    Schedule.prototype.getMeta = function (day, otherwise, lookAtTime) {
        if (otherwise === void 0) { otherwise = null; }
        if (lookAtTime === void 0) { lookAtTime = true; }
        return this.meta.get(day, otherwise, lookAtTime);
    };
    /**
     * Returns all metadata for the given day or an empty array if there is none.
     *
     * @param day The day to return the metadata for.
     * @returns The array of metadata ordered by priority or an empty array.
     */
    Schedule.prototype.getMetas = function (day) {
        return this.meta.getAll(day);
    };
    /**
     * Returns whether the events in the schedule are all day long or start at
     * specific times. Full day events start at the start of the day and end at
     * the start of the next day (if the duration = `1` and durationUnit = 'days').
     * Full day events have no times specified and should have a durationUnit of
     * either `days` or `weeks`.
     */
    Schedule.prototype.isFullDay = function () {
        return this.times.length === 0;
    };
    /**
     * Sets whether this schedule is a full day event if it is not already. If
     * this schedule is a full day event and `false` is passed to this function
     * a single timed event will be added based on `defaultTime`. If this schedule
     * has timed events and `true` is passed to make the schedule full day, the
     * timed events are removed from this schedule. If the durationUnit is not the
     * expected unit based on the new full day flag - the duration is reset to 1
     * and the duration unit is set to the expected unit.
     *
     * @param fullDay Whether this schedule should represent a full day event or
     *    timed events.
     * @param defaultTime If `fullDay` is `false` and this schedule is currently
     *    a full day event - this time will be used as the time of the first event.
     */
    Schedule.prototype.setFullDay = function (fullDay, defaultTime) {
        if (fullDay === void 0) { fullDay = true; }
        if (defaultTime === void 0) { defaultTime = '08:00'; }
        if (fullDay !== this.isFullDay()) {
            if (fullDay) {
                this.times = [];
                if (this.durationUnit !== 'days' && this.durationUnit !== 'day') {
                    this.duration = 1;
                    this.durationUnit = 'days';
                }
            }
            else {
                this.times = [__WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].time(defaultTime)];
                if (this.durationUnit !== 'hours' && this.durationUnit !== 'hour') {
                    this.duration = 1;
                    this.durationUnit = 'hours';
                }
            }
        }
        return this;
    };
    /**
     * Adjusts the [[Schedule.start]] and [[Schedule.end]] dates specified on this
     * schedule if this schedule represents a single event and the `start` and
     * `end` are already set or `addSpan` is `true`.
     *
     * @param addSpan If `true`, the `start` and `end` dates will always be
     *    adjusted if this schedule is a single event.
     */
    Schedule.prototype.adjustDefinedSpan = function (addSpan) {
        if (addSpan === void 0) { addSpan = false; }
        var single = this.getSingleEventSpan();
        if (single && (addSpan || (this.start && this.end))) {
            this.start = single.start.start();
            this.end = single.end.end();
        }
        return this;
    };
    /**
     * Returns a span of time for a schedule with full day events starting on the
     * start of the given day with the desired duration in days or weeks.
     *
     * @param day The day the span starts on.
     * @returns The span of time starting on the given day.
     */
    Schedule.prototype.getFullSpan = function (day) {
        var start = day.start();
        var end = start.add(this.duration, this.durationUnit);
        return new __WEBPACK_IMPORTED_MODULE_3__DaySpan__["a" /* DaySpan */](start, end);
    };
    /**
     * Returns a span of time starting on the given day at the given day with the
     * duration specified on this schedule.
     *
     * @param day The day the span starts on.
     * @param time The time of day the span starts.
     * @returns The span of time calculated.
     */
    Schedule.prototype.getTimeSpan = function (day, time) {
        var start = day.withTime(time);
        var end = start.add(this.duration, this.durationUnit);
        return new __WEBPACK_IMPORTED_MODULE_3__DaySpan__["a" /* DaySpan */](start, end);
    };
    /**
     * Determines whether the given day is a day on the schedule for the start
     * of an event. If an event is more than one day and the day given is not the
     * start this may return `false`. This does not test for event instances
     * that exist through [[Schedule.include]].
     *
     * @param day The day to test.
     * @returns `true` if the day marks the start of an event on the schedule.
     * @see [[Schedule.isIncluded]]
     * @see [[Schedule.isFullyExcluded]]
     * @see [[Schedule.matchesSpan]]
     */
    Schedule.prototype.matchesDay = function (day) {
        if (this.isIncluded(day, false)) {
            return true;
        }
        if (!this.matchesSpan(day) || this.isFullyExcluded(day)) {
            return false;
        }
        for (var _i = 0, _a = this.checks; _i < _a.length; _i++) {
            var check = _a[_i];
            if (!check(day[check.property])) {
                return false;
            }
        }
        return true;
    };
    /**
     * Determines whether the given day has events added through
     * [[Schedule.include]].
     *
     * @param day The day to look for included times on.
     * @returns `true` if there are included event instances on the given day,
     *    otherwise `false`.
     */
    Schedule.prototype.hasIncludedTime = function (day) {
        return !this.iterateIncludeTimes(day).isEmpty();
    };
    /**
     * Determines whether the given day is fully excluded from the schedule. A
     * fully excluded day is one that has a day-wide exclusion, or the schedule
     * is not an all-day event and all times in the schedule are specifically
     * excluded.
     *
     * @param day The day to test.*
     * @returns `true` if he day is fully excluded, otherwise `false`.
     */
    Schedule.prototype.isFullyExcluded = function (day) {
        if (this.isExcluded(day, false)) {
            return true;
        }
        if (this.isFullDay()) {
            return false;
        }
        for (var _i = 0, _a = this.times; _i < _a.length; _i++) {
            var time = _a[_i];
            if (!this.isExcluded(day.withTime(time))) {
                return false;
            }
        }
        return true;
    };
    /**
     * Finds the next day an event occurs on the schedule given a day to start,
     * optionally including it, and a maximum number of days to look ahead.
     *
     * @param day The day to start to search from.
     * @param includeDay If the given day should be included in the search.
     * @param lookAhead The maximum number of days to look ahead from the given
     *     day for event occurrences.
     * @returns The next day on the schedule or `null` if none exists.
     */
    Schedule.prototype.nextDay = function (day, includeDay, lookAhead) {
        if (includeDay === void 0) { includeDay = false; }
        if (lookAhead === void 0) { lookAhead = 366; }
        return this.iterateDaycast(day, 1, true, includeDay, lookAhead).first();
    };
    /**
     * Finds the next specified number of days that events occur on the schedule
     * given a day to start, optionally including it, and a maximum number of days
     * to look ahead.
     *
     * @param day The day to start to search from.
     * @param max The maximum number of days to return in the result.
     * @param includeDay If the given day should be included in the search.
     * @param lookAhead The maximum number of days to look ahead from the given
     *     day for event occurrences.
     * @returns An array containing the next days on the schedule that events
     *    start or an empty array if there are none.
     */
    Schedule.prototype.nextDays = function (day, max, includeDay, lookAhead) {
        if (includeDay === void 0) { includeDay = false; }
        if (lookAhead === void 0) { lookAhead = 366; }
        return this.iterateDaycast(day, max, true, includeDay, lookAhead);
    };
    /**
     * Finds the previous day an event occurs on the schedule given a day to start,
     * optionally including it, and a maximum number of days to look behind.
     *
     * @param day The day to start to search from.
     * @param includeDay If the given day should be included in the search.
     * @param lookBack The maximum number of days to look behind from the given
     *     day for event occurrences.
     * @returns The previous day on the schedule or `null` if none exists.
     */
    Schedule.prototype.prevDay = function (day, includeDay, lookBack) {
        if (includeDay === void 0) { includeDay = false; }
        if (lookBack === void 0) { lookBack = 366; }
        return this.iterateDaycast(day, 1, false, includeDay, lookBack).first();
    };
    /**
     * Finds the previous specified number of days that events occur on the
     * schedule given a day to start, optionally including it, and a maximum
     * number of days to look behind.
     *
     * @param day The day to start to search from.
     * @param max The maximum number of days to return in the result.
     * @param includeDay If the given day should be included in the search.
     * @param lookAhead The maximum number of days to look behind from the given
     *     day for event occurrences.
     * @returns An array containing the previous days on the schedule that events
     *    start or an empty array if there are none.
     */
    Schedule.prototype.prevDays = function (day, max, includeDay, lookBack) {
        if (includeDay === void 0) { includeDay = false; }
        if (lookBack === void 0) { lookBack = 366; }
        return this.iterateDaycast(day, max, false, includeDay, lookBack);
    };
    /**
     * Iterates over days that events start in the schedule given a day to start,
     * a maximum number of days to find, and a direction to look.
     *
     * @param day The day to start to search from.
     * @param max The maximum number of days to iterate.
     * @param next If `true` this searches forward, otherwise `false` is backwards.
     * @param includeDay If the given day should be included in the search.
     * @param lookup The maximum number of days to look through from the given
     *     day for event occurrences.
     * @returns A new Iterator for the days found in the cast.
     * @see [[Schedule.iterateSpans]]
     */
    Schedule.prototype.iterateDaycast = function (day, max, next, includeDay, lookup) {
        var _this = this;
        if (includeDay === void 0) { includeDay = false; }
        if (lookup === void 0) { lookup = 366; }
        return new __WEBPACK_IMPORTED_MODULE_9__Iterator__["b" /* Iterator */](function (iterator) {
            var iterated = 0;
            for (var days = 0; days < lookup; days++) {
                if (!includeDay || days > 0) {
                    day = next ? day.next() : day.prev();
                }
                if (!_this.iterateSpans(day, false).isEmpty()) {
                    var action = iterator.act(day);
                    if (action === __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop || ++iterated >= max) {
                        return;
                    }
                }
            }
        });
    };
    /**
     * Iterates through the spans (event instances) that start on or covers the
     * given day.
     *
     * @param day The day to look for spans on.
     * @param covers If `true` spans which span multiple days will be looked at
     *    to see if they intersect with the given day, otherwise `false` will
     *    only look at the given day for the start of events.
     * @returns A new Iterator for all the spans found.
     */
    Schedule.prototype.iterateSpans = function (day, covers) {
        var _this = this;
        if (covers === void 0) { covers = false; }
        return new __WEBPACK_IMPORTED_MODULE_9__Iterator__["b" /* Iterator */](function (iterator) {
            var current = day;
            var lookBehind = covers ? _this.durationInDays : 0;
            // If the events start at the end of the day and may last multiple days....
            if (_this.isFullDay()) {
                // If the schedule has events which span multiple days we need to look
                // backwards for events that overlap with the given day.
                while (lookBehind >= 0) {
                    // If the current day matches the schedule rules...
                    if (_this.matchesDay(current)) {
                        // Build a DaySpan with the given start day and the schedules duration.
                        var span = _this.getFullSpan(current);
                        // If that dayspan intersects with the given day, it's a winner!
                        if (span.matchesDay(day)) {
                            switch (iterator.act(span)) {
                                case __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop:
                                    return;
                            }
                        }
                    }
                    current = current.prev();
                    lookBehind--;
                }
            }
            else {
                // If the schedule has events which span multiple days we need to look
                // backwards for events that overlap with the given day.
                while (lookBehind >= 0) {
                    // If the current day matches the schedule rules...
                    if (_this.matchesDay(current)) {
                        // Iterate through each daily occurrence in the schedule...
                        for (var _i = 0, _a = _this.times; _i < _a.length; _i++) {
                            var time = _a[_i];
                            var span = _this.getTimeSpan(current, time);
                            // If the event intersects with the given day and the occurrence
                            // has not specifically been excluded...
                            if (span.matchesDay(day) && !_this.isExcluded(span.start, true)) {
                                switch (iterator.act(span)) {
                                    case __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop:
                                        return;
                                }
                            }
                        }
                    }
                    else {
                        // The current day does not match the schedule, however the schedule
                        // might have moved/random event occurrents on the current day.
                        // We only want the ones that overlap with the given day.
                        _this.iterateIncludeTimes(current, day).iterate(function (span, timeIterator) {
                            switch (iterator.act(span)) {
                                case __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop:
                                    timeIterator.stop();
                                    break;
                            }
                        });
                        if (iterator.action === __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop) {
                            return;
                        }
                    }
                    current = current.prev();
                    lookBehind--;
                }
            }
        });
    };
    /**
     * Determines if the given day is on the schedule and the time specified on
     * the day matches one of the times on the schedule.
     *
     * @param day The day to test.
     * @returns `true` if the day and time match the schedule, otherwise false.
     */
    Schedule.prototype.matchesTime = function (day) {
        return !!this.iterateSpans(day, true).first(function (span) { return span.start.sameMinute(day); });
    };
    /**
     * Determines if the given day is covered by this schedule. A schedule can
     * specify events that span multiple days - so even though the day does not
     * match the starting day of a span - it can be a day that is within the
     * schedule.
     *
     * @param day The day to test.
     * @returns `true` if the day is covered by an event on this schedule,
     *    otherwise `false`.
     */
    Schedule.prototype.coversDay = function (day) {
        return !this.iterateSpans(day, true).isEmpty();
    };
    /**
     * Determines if the given timestamp lies in an event occurrence on this
     * schedule.
     *
     * @param day The timestamp to test against the schedule.
     * @return `true` if the timestamp lies in an event occurrent start and end
     *    timestamps, otherwise `false`.
     */
    Schedule.prototype.coversTime = function (day) {
        return !!this.iterateSpans(day, true).first(function (span) { return span.contains(day); });
    };
    /**
     * Sets the frequency for the given property. This does not update the
     * [[Schedule.checks]] array, the [[Schedule.updateChecks]] function needs
     * to be called.
     *
     * @param property The frequency to update.
     * @param frequency The new frequency.
     */
    Schedule.prototype.setFrequency = function (property, frequency) {
        this[property] = __WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].frequency(frequency, property);
        return this;
    };
    /**
     * Changes the exclusion status of the event at the given time. By default
     * this excludes this event - but `false`  may be passed to undo an exclusion.
     *
     * @param time The start time of the event occurrence to exclude or include.
     * @param excluded Whether the event should be excluded.
     */
    Schedule.prototype.setExcluded = function (time, excluded) {
        if (excluded === void 0) { excluded = true; }
        var type = this.identifierType;
        this.exclude.set(time, excluded, type);
        this.include.set(time, !excluded, type);
        return this;
    };
    /**
     * Changes the cancellation status of the event at the given start time. By
     * default this cancels the event occurrence - but `false` may be passed to
     * undo a cancellation.
     *
     * @param time The start time of the event occurrence to cancel or uncancel.
     * @param cancelled Whether the event should be cancelled.
     */
    Schedule.prototype.setCancelled = function (time, cancelled) {
        if (cancelled === void 0) { cancelled = true; }
        this.cancel.set(time, cancelled, this.identifierType);
        return this;
    };
    /**
     * Removes the time from this schedule and all related included, excluded,
     * cancelled instances as well as metadata.
     *
     * @param time The time to remove from the schedule.
     * @param removeInclude If any included instances should be removed as well.
     * @returns `true` if the time was removed, otherwise `false`.
     */
    Schedule.prototype.removeTime = function (time, removeInclude) {
        if (removeInclude === void 0) { removeInclude = true; }
        var found = false;
        for (var i = 0; i < this.times.length && !found; i++) {
            if (found = time.matches(this.times[i])) {
                this.times.splice(i, 1);
            }
        }
        if (found) {
            if (removeInclude) {
                this.include.removeTime(time);
            }
            this.exclude.removeTime(time);
            this.cancel.removeTime(time);
            this.meta.removeTime(time);
        }
        return found;
    };
    /**
     * Moves the event instance starting at `fromTime` to `toTime` optionally
     * placing `meta` in the schedules metadata for the new time `toTime`.
     * If this schedule has a single event ([[Schedule.isSingleEvent]]) then the
     * only value needed is `toTime` and not `fromTime`.
     *
     * @param toTime The timestamp of the new event.
     * @param fromTime The timestamp of the event on the schedule to move if this
     *    schedule generates multiple events.
     * @returns `true` if the schedule had the event moved, otherwise `false`.
     */
    Schedule.prototype.move = function (toTime, fromTime, meta) {
        if (!this.moveSingleEvent(toTime) && fromTime) {
            return this.moveInstance(fromTime, toTime);
        }
        return false;
    };
    /**
     * Moves a time specified in this schedule to the given time, adjusting
     * any cancelled event instances, metadata, and any excluded and included
     * event instances.
     *
     * @param fromTime The time to move.
     * @param toTime The new time in the schedule.
     * @returns `true` if time was moved, otherwise `false`.
     */
    Schedule.prototype.moveTime = function (fromTime, toTime) {
        var found = false;
        for (var i = 0; i < this.times.length && !found; i++) {
            if (found = fromTime.matches(this.times[i])) {
                this.times.splice(i, 1, toTime);
            }
        }
        if (found) {
            this.include.moveTime(fromTime, toTime);
            this.exclude.moveTime(fromTime, toTime);
            this.cancel.moveTime(fromTime, toTime);
            this.meta.moveTime(fromTime, toTime);
            this.adjustDefinedSpan(false);
        }
        return found;
    };
    /**
     * Moves the event instance starting at `fromTime` to `toTime` optionally
     * placing `meta` in the schedules metadata for the new time `toTime`. A move
     * is accomplished by excluding the current event and adding an inclusion of
     * the new day & time.
     *
     * @param fromTime The timestamp of the event on the schedule to move.
     * @param toTime The timestamp of the new event.
     * @returns `true`.
     * @see [[Schedule.move]]
     */
    Schedule.prototype.moveInstance = function (fromTime, toTime) {
        var type = this.identifierType;
        this.exclude.set(fromTime, true, type);
        this.exclude.set(toTime, false, type);
        this.include.set(toTime, true, type);
        this.include.set(fromTime, false, type);
        if (this.cancel.get(fromTime, false) && !this.cancel.get(toTime, false)) {
            this.cancel.set(toTime, true, type);
            if (this.cancel.getIdentifier(fromTime) === type) {
                this.cancel.unset(fromTime, type);
            }
        }
        var meta = this.meta.get(fromTime, null);
        if (meta && meta !== this.meta.get(toTime, null)) {
            this.meta.set(toTime, meta, type);
            if (this.meta.getIdentifier(fromTime) === type) {
                this.meta.unset(fromTime, type);
            }
        }
        return true;
    };
    /**
     * Moves the single event in this schedule to the given day/time if applicable.
     * If this schedule is not a single event schedule then `false` is returned.
     * If this schedule is a timed event the time will take the time of the given
     * `toTime` of `takeTime` is `true`.
     *
     * @param toTime The time to move the single event to.
     * @param takeTime If this schedule has a single timed event, should the time
     *    of the event be changed to the time of the given `toTime`?
     * @returns `true` if the schedule was adjusted, otherwise `false`.
     * @see [[Schedule.move]]
     */
    Schedule.prototype.moveSingleEvent = function (toTime, takeTime) {
        if (takeTime === void 0) { takeTime = true; }
        if (!this.isSingleEvent()) {
            return false;
        }
        for (var _i = 0, _a = this.checks; _i < _a.length; _i++) {
            var check = _a[_i];
            var prop = check.property;
            var value = toTime[prop];
            var frequency = __WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].frequency([value], prop);
            this[prop] = frequency;
        }
        if (this.times.length === 1 && takeTime) {
            this.times = [toTime.asTime()];
        }
        this.updateChecks();
        var span = this.getSingleEventSpan();
        if (this.start) {
            this.start = span.start.start();
        }
        if (this.end) {
            this.end = span.end.end();
        }
        return true;
    };
    /**
     * Returns the span of the single event in this schedule if it's that type of
     * schedule, otherwise `null` is returned.
     *
     * @returns A span of the single event, otherwise `null`.
     * @see [[Schedule.isSingleEvent]]
     */
    Schedule.prototype.getSingleEventSpan = function () {
        if (!this.isSingleEvent()) {
            return null;
        }
        var startOfYear = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].build(this.year.input[0], 0, 1);
        var start = this.iterateDaycast(startOfYear, 1, true, true, 366).first();
        if (!start) {
            return null;
        }
        return this.isFullDay() ?
            this.getFullSpan(start) :
            this.getTimeSpan(start, this.times[0]);
    };
    /**
     * Determines whether this schedule produces a single event, and no more.
     * If this schedule has any includes, it's assumed to be a multiple event
     * schedule. A single event can be detected in the following scenarios where
     * each frequency has a single occurrence (see [[Schedule.isSingleFrequency]]).
     *
     * - year, day of year
     * - year, month, day of month
     * - year, month, week of month, day of week
     * - year, week of year, day of week
     *
     * @returns `true` if this schedule produces a single event, otherwise `false`.
     */
    Schedule.prototype.isSingleEvent = function () {
        // 0 = full day, 1 = once a day, 1+ = multiple events a day
        if (this.times.length > 1) {
            return false;
        }
        // Let's assume if there are includes, this is not a single event.
        if (!this.include.isEmpty()) {
            return false;
        }
        // If this can occur on multiple years, not a single event.
        if (!this.isSingleYear()) {
            return false;
        }
        // If this is a specific year and day of the year: single!
        if (this.isSingleDayOfYear()) {
            return true;
        }
        // If this is a specific year, month, and day of month: single!
        if (this.isSingleMonth() && this.isSingleDayOfMonth()) {
            return true;
        }
        // If this is a specific year, month, week of the month, day of the week: single!
        if (this.isSingleMonth() && this.isSingleWeekOfMonth() && this.isSingleDayOfWeek()) {
            return true;
        }
        // If this is a specific year, week of the year, day of the week: single!
        if (this.isSingleWeekOfYear() && this.isSingleDayOfWeek()) {
            return true;
        }
        // Doesn't look like a single event.
        return false;
    };
    /**
     * @returns `true` if this schedule produces events only in a specific year.
     * @see [[Schedule.year]]
     */
    Schedule.prototype.isSingleYear = function () {
        return this.isSingleFrequency(this.year);
    };
    /**
     * @returns `true` if this schedule produces events only in a specific month.
     * @see [[Schedule.month]]
     */
    Schedule.prototype.isSingleMonth = function () {
        return this.isSingleFrequency(this.month);
    };
    /**
     * @returns `true` if this schedule produces events only in a specific day of
     *    the month.
     * @see [[Schedule.dayOfMonth]]
     * @see [[Schedule.lastDayOfMonth]]
     */
    Schedule.prototype.isSingleDayOfMonth = function () {
        return this.isSingleFrequency(this.dayOfMonth) ||
            this.isSingleFrequency(this.lastDayOfMonth);
    };
    /**
     * @returns `true` if this schedule produces events only in a specific day of
     *    the week.
     * @see [[Schedule.dayOfWeek]]
     */
    Schedule.prototype.isSingleDayOfWeek = function () {
        return this.isSingleFrequency(this.dayOfWeek);
    };
    /**
     * @returns `true` if this schedule produces events only in a specific day of
     *    the year.
     * @see [[Schedule.dayOfYear]]
     */
    Schedule.prototype.isSingleDayOfYear = function () {
        return this.isSingleFrequency(this.dayOfYear);
    };
    /**
     * @returns `true` if this schedule produces events only in a specific week of
     *    the month.
     * @see [[Schedule.weekspanOfMonth]]
     * @see [[Schedule.fullWeekOfMonth]]
     * @see [[Schedule.weekOfMonth]]
     * @see [[Schedule.lastFullWeekOfMonth]]
     * @see [[Schedule.lastWeekspanOfMonth]]
     */
    Schedule.prototype.isSingleWeekOfMonth = function () {
        return this.isSingleFrequency(this.weekspanOfMonth) ||
            this.isSingleFrequency(this.fullWeekOfMonth) ||
            this.isSingleFrequency(this.weekOfMonth) ||
            this.isSingleFrequency(this.lastFullWeekOfMonth) ||
            this.isSingleFrequency(this.lastWeekspanOfMonth);
    };
    /**
     * @returns `true` if this schedule produces events only in a specific week of
     *    the year.
     * @see [[Schedule.weekspanOfYear]]
     * @see [[Schedule.fullWeekOfYear]]
     * @see [[Schedule.week]]
     * @see [[Schedule.weekOfYear]]
     * @see [[Schedule.lastFullWeekOfYear]]
     * @see [[Schedule.lastWeekspanOfYear]]
     */
    Schedule.prototype.isSingleWeekOfYear = function () {
        return this.isSingleFrequency(this.weekspanOfYear) ||
            this.isSingleFrequency(this.fullWeekOfYear) ||
            this.isSingleFrequency(this.week) ||
            this.isSingleFrequency(this.weekOfYear) ||
            this.isSingleFrequency(this.lastFullWeekOfYear) ||
            this.isSingleFrequency(this.lastWeekspanOfYear);
    };
    /**
     * Determines if the given [[FrequencyCheck]] results in a single occurrence.
     *
     * @returns `true` if the frequency results in a single event, otherwise `false`.
     */
    Schedule.prototype.isSingleFrequency = function (frequency) {
        return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(frequency.input) && frequency.input.length === 1;
    };
    /**
     * Creates a forecast for this schedule which returns a number of event
     * occurrences around a given day. A single item could be returned per day, or
     * you could get an item for each timed event occurrence.
     *
     * @param around The day to find a forecast around.
     * @param covers If `true` spans which span multiple days will be looked at
     *    to see if they intersect with the given day, otherwise `false` will
     *    only look at the given day for the start of events.
     * @param daysAfter The number of events to return before the given day.
     * @param daysBefore The number of events to return after the given day.
     * @param times If timed events should be returned, or only one for each day.
     * @param lookAround How many days to look before and after the given day for
     *    event occurrences.
     * @returns A new iterator which provides the event occurence span, the day it
     *    starts (or is covered if `covers` is `true`), and the identifier for the
     *    event.
     */
    Schedule.prototype.forecast = function (around, covers, daysAfter, daysBefore, times, lookAround) {
        var _this = this;
        if (covers === void 0) { covers = true; }
        if (daysBefore === void 0) { daysBefore = daysAfter; }
        if (times === void 0) { times = false; }
        if (lookAround === void 0) { lookAround = 366; }
        var type = this.identifierType;
        var tuplesForDay = function (day, tuples) {
            var spans = _this.iterateSpans(day, covers).list();
            var last = times ? spans.length : Math.min(1, spans.length);
            var offset = times ? 0 : spans.length - 1;
            for (var i = 0; i < last; i++) {
                var span = spans[i + offset];
                var id = type.get(span.start);
                if (tuples.act([span, day, id]) === __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop) {
                    return false;
                }
            }
            return true;
        };
        var prev = new __WEBPACK_IMPORTED_MODULE_9__Iterator__["b" /* Iterator */](function (iterator) {
            var curr = around;
            for (var i = 0; i < lookAround; i++) {
                if (!tuplesForDay(curr, iterator)) {
                    break;
                }
                curr = curr.prev();
            }
        });
        var next = new __WEBPACK_IMPORTED_MODULE_9__Iterator__["b" /* Iterator */](function (iterator) {
            var curr = around;
            for (var i = 0; i < lookAround; i++) {
                curr = curr.next();
                if (!tuplesForDay(curr, iterator)) {
                    break;
                }
            }
        });
        return prev.take(daysBefore + 1).reverse().append(next.take(daysAfter));
    };
    /**
     * Iterates timed events that were explicitly specified on the given day.
     * Those events could span multiple days so may be tested against another day.
     *
     * @param day The day to look for included timed events.
     * @param matchAgainst The day to test against the timed event.
     * @returns A new Iterator for all the included spans found.
     */
    Schedule.prototype.iterateIncludeTimes = function (day, matchAgainst) {
        var _this = this;
        if (matchAgainst === void 0) { matchAgainst = day; }
        var isIncludedTime = function (result) {
            var id = result[0], included = result[1];
            return included && __WEBPACK_IMPORTED_MODULE_2__Identifier__["a" /* Identifier */].Time.is(id);
        };
        var getSpan = function (result) {
            var id = result[0];
            var time = __WEBPACK_IMPORTED_MODULE_2__Identifier__["a" /* Identifier */].Time.start(id);
            var span = _this.getTimeSpan(time, time.asTime());
            if (span.matchesDay(matchAgainst)) {
                return span;
            }
        };
        return this.include.query(day.dayIdentifier).map(getSpan, isIncludedTime);
    };
    /**
     * Clones this schedule.
     *
     * @returns A new schedule which matches this schedule.
     */
    Schedule.prototype.clone = function () {
        return new Schedule(this.toInput());
    };
    /**
     * Converts the schedule instance back into input.
     *
     * @param returnDays When `true` the start, end, and array of exclusions will
     *    have [[Day]] instances, otherwise the UTC timestamp and dayIdentifiers
     *    will be used when `false`.
     * @param returnTimes When `true` the times returned in the input will be
     *    instances of [[Time]] otherwise the `timeFormat` is used to convert the
     *    times to strings.
     * @param timeFormat The time format to use when returning the times as strings.
     * @param alwaysDuration If the duration values (`duration` and
     *    `durationUnit`) should always be returned in the input.
     * @returns The input that describes this schedule.
     * @see [[Time.format]]
     */
    Schedule.prototype.toInput = function (returnDays, returnTimes, timeFormat, alwaysDuration) {
        if (returnDays === void 0) { returnDays = false; }
        if (returnTimes === void 0) { returnTimes = false; }
        if (timeFormat === void 0) { timeFormat = ''; }
        if (alwaysDuration === void 0) { alwaysDuration = false; }
        var defaultUnit = __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].DURATION_DEFAULT_UNIT(this.isFullDay());
        var exclusions = this.exclude.identifiers(function (v) { return v; }).list();
        var inclusions = this.include.identifiers(function (v) { return v; }).list();
        var cancels = this.cancel.identifiers(function (v) { return v; }).list();
        var hasMeta = !this.meta.isEmpty();
        var out = {};
        var times = [];
        for (var _i = 0, _a = this.times; _i < _a.length; _i++) {
            var time = _a[_i];
            times.push(returnTimes ? time : (timeFormat ? time.format(timeFormat) : time.toString()));
        }
        if (this.start)
            out.start = returnDays ? this.start : this.start.time;
        if (this.end)
            out.end = returnDays ? this.end : this.end.time;
        if (times.length)
            out.times = times;
        if (alwaysDuration || this.duration !== __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].DURATION_DEFAULT)
            out.duration = this.duration;
        if (alwaysDuration || this.durationUnit !== defaultUnit)
            out.durationUnit = this.durationUnit;
        if (exclusions.length)
            out.exclude = exclusions;
        if (inclusions.length)
            out.include = inclusions;
        if (cancels.length)
            out.cancel = cancels;
        if (hasMeta)
            out.meta = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].extend({}, this.meta.map);
        if (this.dayOfWeek.input)
            out.dayOfWeek = this.dayOfWeek.input;
        if (this.dayOfMonth.input)
            out.dayOfMonth = this.dayOfMonth.input;
        if (this.lastDayOfMonth.input)
            out.lastDayOfMonth = this.lastDayOfMonth.input;
        if (this.dayOfYear.input)
            out.dayOfYear = this.dayOfYear.input;
        if (this.year.input)
            out.year = this.year.input;
        if (this.month.input)
            out.month = this.month.input;
        if (this.week.input)
            out.week = this.week.input;
        if (this.weekOfYear.input)
            out.weekOfYear = this.weekOfYear.input;
        if (this.weekspanOfYear.input)
            out.weekspanOfYear = this.weekspanOfYear.input;
        if (this.fullWeekOfYear.input)
            out.fullWeekOfYear = this.fullWeekOfYear.input;
        if (this.lastWeekspanOfYear.input)
            out.lastWeekspanOfYear = this.lastWeekspanOfYear.input;
        if (this.lastFullWeekOfYear.input)
            out.lastFullWeekOfYear = this.lastFullWeekOfYear.input;
        if (this.weekOfMonth.input)
            out.weekOfMonth = this.weekOfMonth.input;
        if (this.weekspanOfMonth.input)
            out.weekspanOfMonth = this.weekspanOfMonth.input;
        if (this.fullWeekOfMonth.input)
            out.fullWeekOfMonth = this.fullWeekOfMonth.input;
        if (this.lastWeekspanOfMonth.input)
            out.lastWeekspanOfMonth = this.lastWeekspanOfMonth.input;
        if (this.lastFullWeekOfMonth.input)
            out.lastFullWeekOfMonth = this.lastFullWeekOfMonth.input;
        return out;
    };
    /**
     * Describes the schedule in a human friendly string taking into account all
     * possible values specified in this schedule.
     *
     * @param thing A brief description of the things (events) on the schedule.
     * @param includeRange When `true` the [[Schedule.start]] and [[Schedule.end]]
     *    are possibly included in the description if they have values.
     * @param includeTimes When `true` the [[Schedule.times]] are possibly included
     *    in the description.
     * @param includeDuration When `true` the [[Schedule.duration]] and
     *    [[Schedule.durationUnit]] are added to the description if
     *    [[Schedule.duration]] is not equal to `1`.
     * @param includeExcludes When `true` the [[Schedule.exclude]] are added
     *    to the description if there are any.
     * @param includeIncludes When `true` the [[Schedule.include]] are added
     *    to the description if there are any.
     * @param includeCancels When `true` the [[Schedule.cancel]] are added
     *    to the description if there are any.
     * @returns The descroption of the schedule.
     */
    Schedule.prototype.describe = function (thing, includeRange, includeTimes, includeDuration, includeExcludes, includeIncludes, includeCancels) {
        if (thing === void 0) { thing = 'event'; }
        if (includeRange === void 0) { includeRange = true; }
        if (includeTimes === void 0) { includeTimes = true; }
        if (includeDuration === void 0) { includeDuration = false; }
        if (includeExcludes === void 0) { includeExcludes = false; }
        if (includeIncludes === void 0) { includeIncludes = false; }
        if (includeCancels === void 0) { includeCancels = false; }
        var out = '';
        if (includeRange) {
            if (this.start) {
                out += 'Starting on ' + this.start.format('dddd Do, YYYY');
                if (this.end) {
                    out += ' and ending on ' + this.end.format('dddd Do, YYYY');
                }
            }
            else if (this.end) {
                out += 'Up until ' + this.end.format('dddd Do, YYYY');
            }
        }
        if (out) {
            out += ' the ' + thing + ' will occur';
        }
        else {
            out += 'The ' + thing + ' will occur';
        }
        out += this.describeRule(this.dayOfWeek.input, 'day of the week', function (x) { return __WEBPACK_IMPORTED_MODULE_10_moment__["weekdays"]()[x]; }, 1, false);
        out += this.describeRule(this.lastDayOfMonth.input, 'last day of the month', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.dayOfMonth.input, 'day of the month', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.dayOfYear.input, 'day of the year', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; }, 1);
        out += this.describeRule(this.year.input, 'year', function (x) { return x; }, 0, false, ' in ');
        out += this.describeRule(this.month.input, 'month', function (x) { return __WEBPACK_IMPORTED_MODULE_10_moment__["months"]()[x]; }, 0, false, ' in ');
        out += this.describeRule(this.weekOfYear.input, 'week of the year', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.weekspanOfYear.input, 'weekspan of the year', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x + 1]; }, 1);
        out += this.describeRule(this.fullWeekOfYear.input, 'full week of the year', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.lastWeekspanOfYear.input, 'last weekspan of the year', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x + 1]; }, 1);
        out += this.describeRule(this.lastFullWeekOfYear.input, 'last full week of the year', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.weekOfMonth.input, 'week of the month', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.fullWeekOfMonth.input, 'full week of the month', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.weekspanOfMonth.input, 'weekspan of the month', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x + 1]; }, 1);
        out += this.describeRule(this.lastFullWeekOfMonth.input, 'last full week of the month', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x]; });
        out += this.describeRule(this.lastWeekspanOfMonth.input, 'last weekspan of the month', function (x) { return __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[x + 1]; }, 1);
        if (includeTimes && this.times.length) {
            out += ' at ';
            out += this.describeArray(this.times, function (x) { return x.format('hh:mm a'); });
        }
        if (includeDuration && this.duration !== __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].DURATION_DEFAULT) {
            out += ' lasting ' + this.duration + ' ';
            if (this.durationUnit) {
                out += this.durationUnit + ' ';
            }
        }
        if (includeExcludes) {
            var excludes = this.exclude.spans().list();
            if (excludes.length) {
                out += ' excluding ';
                out += this.describeArray(excludes, function (x) { return x.span.summary(__WEBPACK_IMPORTED_MODULE_8__Units__["a" /* Units */].DAY); });
            }
        }
        if (includeIncludes) {
            var includes = this.include.spans().list();
            if (includes.length) {
                out += ' including ';
                out += this.describeArray(includes, function (x) { return x.span.summary(__WEBPACK_IMPORTED_MODULE_8__Units__["a" /* Units */].DAY); });
            }
        }
        if (includeCancels) {
            var cancels = this.cancel.spans().list();
            if (cancels.length) {
                out += ' with cancellations on ';
                out += this.describeArray(cancels, function (x) { return x.span.summary(__WEBPACK_IMPORTED_MODULE_8__Units__["a" /* Units */].DAY); });
            }
        }
        return out;
    };
    /**
     * Describes the given frequency.
     *
     * @param value The frequency to describe.
     * @param unit The unit of the frequency.
     * @param map How the values in the frequency should be described.
     * @param everyOffset A value to add to a [[FrequencyValueEvery]] offset to
     *    account for zero-based values that should be shifted for human
     *    friendliness.
     * @param the If the word 'the' should be used to describe the unit.
     * @param on The word which preceeds values of the given unit.
     * @param required If the description should always return a non-empty string
     *    even if the frequency was not specified in the original input.
     * @returns A string description of the frequency.
     */
    Schedule.prototype.describeRule = function (value, unit, map, everyOffset, the, on, required) {
        if (everyOffset === void 0) { everyOffset = 0; }
        if (the === void 0) { the = true; }
        if (on === void 0) { on = ' on '; }
        if (required === void 0) { required = false; }
        var out = '';
        var suffix = the ? ' ' + unit : '';
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isFrequencyValueEvery(value)) {
            var valueEvery = value;
            out += ' every ' + __WEBPACK_IMPORTED_MODULE_6__Suffix__["a" /* Suffix */].CACHE[valueEvery.every] + ' ' + unit;
            if (valueEvery.offset) {
                out += ' starting at ' + map(valueEvery.offset + everyOffset) + suffix;
            }
        }
        else if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isFrequencyValueOneOf(value)) {
            var valueOne = value;
            if (valueOne.length) {
                out += on + (the ? 'the ' : '');
                out += this.describeArray(valueOne, map);
                out += suffix;
            }
        }
        else if (required) {
            out += on + 'any ' + unit;
        }
        return out;
    };
    /**
     * Describes the array by adding commas where appropriate and 'and' before the
     * last value of the array (if its more than `1`).
     *
     * @param array The array of items to describe.
     * @param map The function which converts an item to a string.
     * @returns The final description of the array items.
     */
    Schedule.prototype.describeArray = function (array, map) {
        var out = '';
        var last = array.length - 1;
        out += map(array[0]);
        for (var i = 1; i < last; i++) {
            out += ', ' + map(array[i]);
        }
        if (last > 0) {
            out += ' and ' + map(array[last]);
        }
        return out;
    };
    /**
     * Generates a schedule for an event which occurs once all day for a given day
     * optionally spanning multiple days starting on the given day.
     *
     * @param input The day the event starts.
     * @param days The number of days the event lasts.
     * @returns A new schedule that starts on the given day.
     */
    Schedule.forDay = function (input, days) {
        if (days === void 0) { days = 1; }
        var day = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].parse(input);
        if (!day) {
            return null;
        }
        return new Schedule({
            year: [day.year],
            month: [day.month],
            dayOfMonth: [day.dayOfMonth],
            duration: days,
            durationUnit: 'days'
        });
    };
    /**
     * Generates a schedule for an event which occurs once at a given time on a
     * given day optionally spanning any amount of time (default is 1 hour).
     *
     * @param input The day the event starts.
     * @param time The time the event starts.
     * @param duration The duration of the event.
     * @param durationUnit The unit for the duration of the event.
     * @returns A new schedule that starts on the given day and time.
     */
    Schedule.forTime = function (input, time, duration, durationUnit) {
        if (duration === void 0) { duration = 1; }
        if (durationUnit === void 0) { durationUnit = 'hours'; }
        var day = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].parse(input);
        if (!day) {
            return null;
        }
        return new Schedule({
            year: [day.year],
            month: [day.month],
            dayOfMonth: [day.dayOfMonth],
            times: [time],
            duration: duration,
            durationUnit: durationUnit
        });
    };
    /**
     * Generates a schedule for an event which occurs once over a given span.
     *
     * @param span The span of the event.
     * @returns A new schedule that starts and ends at the given timestamps.
     */
    Schedule.forSpan = function (span) {
        var start = span.start;
        var minutes = span.minutes();
        var isDay = minutes % __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].MINUTES_IN_DAY === 0;
        var isHour = minutes % __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].MINUTES_IN_HOUR === 0;
        var duration = isDay ? minutes / __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].MINUTES_IN_DAY : (isHour ? minutes / __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* Constants */].MINUTES_IN_HOUR : minutes);
        var durationUnit = isDay ? 'days' : (isHour ? 'hours' : 'minutes');
        return this.forTime(start, start.asTime(), duration, durationUnit);
    };
    return Schedule;
}());

//# sourceMappingURL=Schedule.js.map

/***/ }),
/* 277 */
/* exports provided: ScheduleModifier */
/* exports used: ScheduleModifier */
/*!*******************************************!*\
  !*** ./~/dayspan/lib/ScheduleModifier.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScheduleModifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Identifier__ = __webpack_require__(/*! ./Identifier */ 190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Iterator__ = __webpack_require__(/*! ./Iterator */ 150);




/**
 * A class that can modify the events of a schedule by storing [[Identifier]]s
 * and an associated value.
 *
 * @typeparam T The type of data that modifies the schedule.
 */
var ScheduleModifier = (function () {
    /**
     * Creates a new schedule modifier.
     */
    function ScheduleModifier() {
        this.map = {};
    }
    /**
     * Clears the modifier of all modifications.
     */
    ScheduleModifier.prototype.clear = function () {
        this.map = {};
        return this;
    };
    /**
     * Returns `true` if this modifier lacks any modifications, otherwise `false`.
     */
    ScheduleModifier.prototype.isEmpty = function () {
        // @ts-ignore
        for (var id in this.map) {
            return !id;
        }
        return true;
    };
    /**
     * Gets the most specific value in this modifier for the given day, if none
     * exists `otherwise` is returned. A modifier can have multiple values for a
     * given day because [[Identifier]]s represent a span of time.
     *
     * @param day The day to get a value for.
     * @param otherwise What to return if no value exists for the given day.
     * @param lookAtTime If the specific time of the given day should be looked at.
     * @returns The most specific value for the given day, or `otherwise`.
     */
    ScheduleModifier.prototype.get = function (day, otherwise, lookAtTime) {
        if (lookAtTime === void 0) { lookAtTime = true; }
        var map = this.map;
        return (lookAtTime && map[day.timeIdentifier]) ||
            map[day.dayIdentifier] ||
            map[day.monthIdentifier] ||
            map[day.weekIdentifier] ||
            map[day.quarterIdentifier] ||
            otherwise;
    };
    /**
     * Gets the most specific identifier type for the span over the given day.
     * If the day does not have a modification, `null` is returned.
     *
     * @param day The day to get the type for.
     * @param lookAtTime If the specific time of the given day should be looked at.
     * @returns The most specific identifier for the given day, otherwise `null`.
     */
    ScheduleModifier.prototype.getIdentifier = function (day, lookAtTime) {
        if (lookAtTime === void 0) { lookAtTime = true; }
        var map = this.map;
        if (lookAtTime && __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(map[day.timeIdentifier]))
            return __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Time;
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(map[day.dayIdentifier]))
            return __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Day;
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(map[day.monthIdentifier]))
            return __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Month;
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(map[day.weekIdentifier]))
            return __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Week;
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(map[day.quarterIdentifier]))
            return __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Quarter;
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(map[day.year]))
            return __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Year;
        return null;
    };
    /**
     * Gets all values in this modifier for the given day. If none exist, an empty
     * array is returned. The values returned in the array are returned in most
     * specific to least specific.
     *
     * @param day The day to get the values for.
     * @returns An array of values (modifications) for the given day.
     */
    ScheduleModifier.prototype.getAll = function (day) {
        var map = this.map;
        var all = [];
        if (map[day.timeIdentifier])
            all.push(map[day.timeIdentifier]);
        if (map[day.dayIdentifier])
            all.push(map[day.dayIdentifier]);
        if (map[day.monthIdentifier])
            all.push(map[day.monthIdentifier]);
        if (map[day.weekIdentifier])
            all.push(map[day.weekIdentifier]);
        if (map[day.quarterIdentifier])
            all.push(map[day.quarterIdentifier]);
        return all;
    };
    /**
     * Moves the value/modification from one identifier to another.
     *
     * @param from The day to take the identifier from.
     * @param fromType The identifier type.
     * @param to The day to move the value to.
     * @param toType The identifier type to move the value to.
     */
    ScheduleModifier.prototype.move = function (from, fromType, to, toType) {
        var fromIdentifier = fromType.get(from);
        var toIdentifier = toType.get(to);
        this.map[toIdentifier] = this.map[fromIdentifier];
        delete this.map[fromIdentifier];
        return this;
    };
    /**
     * Moves any identifiers with the matching time `fromTime` to `toTime` and
     * returns the number of moves.
     *
     * @param fromTime The time to move from.
     * @param toTime The time to move to.
     * @returns The number of modifiers moved.
     */
    ScheduleModifier.prototype.moveTime = function (fromTime, toTime) {
        var type = __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Time;
        var moveIds = [];
        this.iterate().iterate(function (_a) {
            var id = _a[0], value = _a[1];
            if (type.is(id)) {
                var start = type.start(id);
                if (start.sameTime(fromTime)) {
                    moveIds.push(id);
                }
            }
        });
        var moved = 0;
        for (var _i = 0, moveIds_1 = moveIds; _i < moveIds_1.length; _i++) {
            var id = moveIds_1[_i];
            var value = this.map[id];
            var start = type.start(id);
            var newStart = start.withTime(toTime);
            var newId = type.get(newStart);
            if (!this.map[newId]) {
                this.map[newId] = value;
                delete this.map[id];
                moved++;
            }
        }
        return moved;
    };
    /**
     * Removes any identifiers and modifications that are at the given time.
     *
     * @param time The time to remove.
     * @returns The number of modifiers removed.
     */
    ScheduleModifier.prototype.removeTime = function (time) {
        var type = __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].Time;
        var removed = 0;
        this.iterate().iterate(function (_a, iterator) {
            var id = _a[0];
            if (type.is(id)) {
                var start = type.start(id);
                if (start.sameTime(time)) {
                    iterator.remove();
                    removed++;
                }
            }
        });
        return removed;
    };
    /**
     * Sets the value/modification in this map given a day, the value, and the
     * identifier type.
     *
     * @param day The day to take an identifier from.
     * @param value The value/modification to set.
     * @param type The identifier type.
     */
    ScheduleModifier.prototype.set = function (day, value, type) {
        this.map[type.get(day)] = value;
        return this;
    };
    /**
     * Removes the value/modification from this modifier based on the identifier
     * pulled from the day.
     *
     * @param day The day to take an identifier from.
     * @param type The identifier type.
     */
    ScheduleModifier.prototype.unset = function (day, type) {
        delete this.map[type.get(day)];
        return this;
    };
    /**
     * Iterates through the modifiers passing the identifier and the related value.
     *
     * @returns A new instance of an [[Iterator]].
     */
    ScheduleModifier.prototype.iterate = function () {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_2__Iterator__["b" /* Iterator */](function (iterator) {
            var map = _this.map;
            for (var rawId in map) {
                var asNumber = parseInt(rawId);
                var validAsNumber = asNumber + '' === rawId;
                var id = validAsNumber ? asNumber : rawId;
                switch (iterator.act([id, map[rawId]])) {
                    case __WEBPACK_IMPORTED_MODULE_2__Iterator__["a" /* IteratorAction */].Stop:
                        return;
                    case __WEBPACK_IMPORTED_MODULE_2__Iterator__["a" /* IteratorAction */].Remove:
                        delete map[rawId];
                        break;
                }
            }
        });
    };
    /**
     * Queries the modifier for all values/modifications which fall in the time
     * span that the given identifier represents. All identifiers and their value
     * are passed to the given callback.
     *
     * @param prefix The identifier
     * @returns A new instance of an [[Iterator]].
     */
    ScheduleModifier.prototype.query = function (query) {
        return this.iterate()
            .filter(function (_a) {
            var id = _a[0], value = _a[1];
            return __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].contains(query, id);
        });
        ;
    };
    /**
     * Returns all identifiers stored in this modifier.
     */
    ScheduleModifier.prototype.identifiers = function (filter) {
        return this.iterate()
            .filter(function (_a) {
            var id = _a[0], value = _a[1];
            return !filter || filter(value, id);
        })
            .map(function (_a) {
            var id = _a[0];
            return id;
        });
    };
    /**
     * Builds a list of spans and the associated values. The spans are calculated
     * from the identiier key via [[Identifier.span]].
     *
     * @param endInclusive If the end date in the spans should be the last
     *    millisecond of the timespan or the first millisecond of the next.
     * @returns An array of spans calculated from the identifiers with the
     *    associated values/modifications.
     */
    ScheduleModifier.prototype.spans = function (endInclusive) {
        if (endInclusive === void 0) { endInclusive = false; }
        return this.iterate()
            .map(function (_a) {
            var id = _a[0], value = _a[1];
            var type = __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].find(id);
            if (type) {
                var span = type.span(id, endInclusive);
                return { span: span, value: value };
            }
        });
    };
    /**
     * Builds a list of the descriptions of the identifiers in this modifier.
     *
     * @param short If the description should use shorter language or longer.
     * @returns The built list of descriptions.
     */
    ScheduleModifier.prototype.describe = function (short) {
        if (short === void 0) { short = false; }
        return this.iterate()
            .map(function (_a) {
            var id = _a[0];
            var type = __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].find(id);
            if (type) {
                return type.describe(id, short);
            }
        });
    };
    /**
     * Builds a map of the values/modifications keyed by the descripton of the
     * identifier computed via [[Identifier.describe]].
     *
     * @param short If the description should use shorter language or longer.
     * @returns The built map of description to values/modifications.
     */
    ScheduleModifier.prototype.describeMap = function (short) {
        if (short === void 0) { short = false; }
        var map = this.map;
        var out = {};
        for (var id in map) {
            var type = __WEBPACK_IMPORTED_MODULE_1__Identifier__["a" /* Identifier */].find(id);
            if (type) {
                out[type.describe(id, short)] = map[id];
            }
        }
        return out;
    };
    return ScheduleModifier;
}());

//# sourceMappingURL=ScheduleModifier.js.map

/***/ }),
/* 278 */
/* exports provided: Suffix */
/* exports used: Suffix */
/*!*********************************!*\
  !*** ./~/dayspan/lib/Suffix.js ***!
  \*********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Suffix; });

/**
 * A class which takes a number and determines the suffix for that number.
 *
 * ```typescript
 * Suffix.CACHE[ 2 ];         // 2nd
 * Suffix.determine( 3 );     // rd
 * Suffix.get( 4 );           // th
 * Suffix.get( 4, true );     // 4th
 * ```
 */
var Suffix = (function () {
    function Suffix() {
    }
    Object.defineProperty(Suffix, "CACHE", {
        /**
         * The cache of number & suffix pairs.
         */
        get: function () {
            if (!this._CACHE) {
                this._CACHE = [];
                for (var i = 0; i <= this._CACHE_SIZE; i++) {
                    this._CACHE[i] = this.get(i, true);
                }
            }
            return this._CACHE;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Determines the suffix for a given number.
     *
     * @param value The number to find the suffix for.
     * @returns The suffix determined.
     */
    Suffix.determine = function (value) {
        return value >= 11 && value <= 13 ? 'th' : this.MAP[value % this.MAP.length];
    };
    /**
     * Gets the suffix for a number and optionally appends it before the suffix.
     *
     * @param value The number to get the suffix for.
     * @param prepend When `true` the value is prepended to the suffix.
     * @returns The suffix or value & suffix pair determined.
     */
    Suffix.get = function (value, prepend) {
        if (prepend === void 0) { prepend = false; }
        var suffix = this.determine(value);
        return prepend ? value + suffix : suffix;
    };
    /**
     * The array of suffixes used.
     */
    Suffix.MAP = [
        'th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'
    ];
    /**
     * The number of values to store in the cache (inclusive).
     */
    Suffix._CACHE_SIZE = 366;
    return Suffix;
}());

//# sourceMappingURL=Suffix.js.map

/***/ }),
/* 279 */
/* exports provided: Time */
/* exports used: Time */
/*!*******************************!*\
  !*** ./~/dayspan/lib/Time.js ***!
  \*******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Time; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(/*! ./Constants */ 98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Parse__ = __webpack_require__(/*! ./Parse */ 152);




/**
 * A class which holds a specific time during in any day.
 */
var Time = (function () {
    /**
     * Creates a new Time instance given an hour and optionally a minute, second,
     * and millisecond. If they have not been specified they default to 0.
     *
     * @param hour The hour.
     * @param minute The minute.
     * @param second The second.
     * @param millisecond The millisecond.
     */
    function Time(hour, minute, second, millisecond) {
        if (minute === void 0) { minute = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MIN; }
        if (second === void 0) { second = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MIN; }
        if (millisecond === void 0) { millisecond = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MIN; }
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
    }
    /**
     * Formats this time into a string. The following list describes the available
     * formatting patterns:
     *
     * ### Hour
     * - H: 0-23
     * - HH: 00-23
     * - h: 12,1-12,1-11
     * - hh: 12,01-12,01-11
     * - k: 1-24
     * - kk: 01-24
     * - a: am,pm
     * - A: AM,PM
     * ### Minute
     * - m: 0-59
     * - mm: 00-59
     * ### Second
     * - s: 0-59
     * - ss: 00-59
     * ### Millisecond
     * - S: 0-9
     * - SS: 00-99
     * - SSS: 000-999
     *
     * @param format The format to output.
     * @returns The formatted time.
     */
    Time.prototype.format = function (format) {
        var formatterEntries = Time.FORMATTERS;
        var out = '';
        for (var i = 0; i < format.length; i++) {
            var handled = false;
            for (var k = 0; k < formatterEntries.length && !handled; k++) {
                var entry = formatterEntries[k];
                var part = format.substring(i, i + entry.size);
                if (part.length === entry.size) {
                    var formatter = entry.formats[part];
                    if (formatter) {
                        out += formatter(this);
                        i += entry.size - 1;
                        handled = true;
                    }
                }
            }
            if (!handled) {
                out += format.charAt(i);
            }
        }
        return out;
    };
    /**
     * Determines whether this time is an exact match for the given time.
     *
     * @param time The given time to test against.
     * @returns `true` if the time matches this time, otherwise `false`.
     */
    Time.prototype.matches = function (time) {
        return this.hour === time.hour &&
            this.minute === time.minute &&
            this.second === time.second &&
            this.millisecond === time.millisecond;
    };
    /**
     * Determines whether this time has the same hour as the given time.
     *
     * @param time The given time to test against.
     * @returns `true` if the given hour matches this hour, otherwise `false`.
     */
    Time.prototype.matchesHour = function (time) {
        return this.hour === time.hour;
    };
    /**
     * Determines whether this time has the same hour and minute as the given time.
     *
     * @param time The given time to test against.
     * @returns `true` if the given hour and minute matches, otherwise `false`.
     */
    Time.prototype.matchesMinute = function (time) {
        return this.hour === time.hour &&
            this.minute === time.minute;
    };
    /**
     * Determines whether this time has the same hour, minute, and second as the
     * given time.
     *
     * @param time The given time to test against.
     * @returns `true` if the given hour, minute, and second matches, otherwise
     *    `false`.
     */
    Time.prototype.matchesSecond = function (time) {
        return this.hour === time.hour &&
            this.minute === time.minute &&
            this.second === time.second;
    };
    /**
     * Sets the time of this instance to the same time of the given input.
     *
     * @param input The time to set this to.
     * @returns `true` if this time was set, otherwise `false` (invalid input).
     */
    Time.prototype.set = function (input) {
        var parsed = Time.parse(input);
        var valid = !!parsed;
        if (valid) {
            this.hour = parsed.hour;
            this.minute = parsed.minute;
            this.second = parsed.second;
            this.millisecond = parsed.millisecond;
        }
        return valid;
    };
    /**
     * @returns The number of milliseconds from the start of the day until this
     *  time.
     */
    Time.prototype.toMilliseconds = function () {
        return this.hour * __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_IN_HOUR +
            this.minute * __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_IN_MINUTE +
            this.second * __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_IN_SECOND +
            this.millisecond;
    };
    /**
     * @returns The time formatted using the smallest format that completely
     *  represents this time.
     */
    Time.prototype.toString = function () {
        if (this.millisecond)
            return this.format('HH:mm:ss.SSS');
        if (this.second)
            return this.format('HH:mm:ss');
        if (this.minute)
            return this.format('HH:mm');
        return this.format('HH');
    };
    /**
     * @returns A unique identifier for this time. The number returned is in the
     *  following format: SSSssmmHH
     */
    Time.prototype.toIdentifier = function () {
        return this.hour +
            this.minute * 100 +
            this.second * 10000 +
            this.millisecond * 10000000;
    };
    /**
     * @returns An object with hour, minute, second, a millisecond properties if
     *  they are non-zero on this time.
     */
    Time.prototype.toObject = function () {
        var out = {
            hour: this.hour
        };
        if (this.minute)
            out.minute = this.minute;
        if (this.second)
            out.second = this.second;
        if (this.millisecond)
            out.millisecond = this.millisecond;
        return out;
    };
    /**
     * Parses a value and tries to convert it to a Time instance.
     *
     * @param input The input to parse.
     * @returns The instance parsed or `null` if it was invalid.
     * @see [[Parse.time]]
     */
    Time.parse = function (input) {
        return __WEBPACK_IMPORTED_MODULE_2__Parse__["a" /* Parse */].time(input);
    };
    /**
     * Parses a string and converts it to a Time instance. If the string is not
     * in a valid format `null` is returned.
     *
     * @param time The string to parse.
     * @returns The instance parsed or `null` if it was invalid.
     * @see [[Time.REGEX]]
     */
    Time.fromString = function (time) {
        var matches = this.REGEX.exec(time);
        if (!matches) {
            return null;
        }
        var h = parseInt(matches[1]) || 0;
        var m = parseInt(matches[2]) || 0;
        var s = parseInt(matches[3]) || 0;
        var l = parseInt(matches[4]) || 0;
        return this.build(h, m, s, l);
    };
    /**
     * Parses a number and converts it to a Time instance. The number is assumed
     * to be in the [[Time.toIdentifier]] format.
     *
     * @param time The number to parse.
     * @returns The instance parsed.
     */
    Time.fromIdentifier = function (time) {
        var h = time % 100;
        var m = Math.floor(time / 100) % 100;
        var s = Math.floor(time / 10000) % 100;
        var l = Math.floor(time / 10000000) % 1000;
        return this.build(h, m, s, l);
    };
    /**
     * Returns a new instance given an hour and optionally a minute, second,
     * and millisecond. If they have not been specified they default to 0.
     *
     * @param hour The hour.
     * @param minute The minute.
     * @param second The second.
     * @param millisecond The millisecond.
     * @returns A new instance.
     */
    Time.build = function (hour, minute, second, millisecond) {
        if (minute === void 0) { minute = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MINUTE_MIN; }
        if (second === void 0) { second = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SECOND_MIN; }
        if (millisecond === void 0) { millisecond = __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].MILLIS_MIN; }
        return new Time(hour, minute, second, millisecond);
    };
    /**
     * The regular expression used to parse a time from a string.
     *
     * - ## = hour
     * - ##:## = hour & minute
     * - ##:##:## = hour, minute, & second
     * - ##:##:##.### = hour, minute, second, and milliseconds
     */
    Time.REGEX = /^(\d\d?):?(\d\d)?:?(\d\d)?\.?(\d\d\d)?$/;
    /**
     * A set of formatting functions keyed by their format string.
     */
    Time.FORMATTERS = [
        {
            size: 3,
            formats: {
                SSS: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(t.millisecond, 3); }
            }
        },
        {
            size: 2,
            formats: {
                HH: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(t.hour, 2); },
                hh: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber((t.hour % 12) || 12, 2); },
                kk: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(t.hour + 1, 2); },
                mm: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(t.minute, 2); },
                ss: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(t.second, 2); },
                SS: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(t.millisecond, 3, 2); }
            }
        },
        {
            size: 1,
            formats: {
                A: function (t) { return t.hour < 12 ? 'AM' : 'PM'; },
                a: function (t) { return t.hour < 12 ? 'am' : 'pm'; },
                H: function (t) { return t.hour + ''; },
                h: function (t) { return ((t.hour % 12) || 12) + ''; },
                k: function (t) { return (t.hour + 1) + ''; },
                m: function (t) { return t.minute + ''; },
                s: function (t) { return t.second + ''; },
                S: function (t) { return __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].padNumber(t.millisecond, 3, 1); }
            }
        }
    ];
    return Time;
}());

//# sourceMappingURL=Time.js.map

/***/ }),
/* 280 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./~/highcharts/highcharts.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v8.2.2 (2020-10-22)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(X,N){"object"===typeof module&&module.exports?(N["default"]=N,module.exports=X.document?N(X):N): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return N(X)}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(X.Highcharts&&X.Highcharts.error(16,!0),X.Highcharts=N(X))})("undefined"!==typeof window?window:this,function(X){function N(f,h,m,z){f.hasOwnProperty(h)||(f[h]=z.apply(null,m))}var m={};N(m,"Core/Globals.js",[],function(){var f="undefined"!==typeof X?X:"undefined"!==typeof window?window:{},h=f.document,
m=f.navigator&&f.navigator.userAgent||"",z=h&&h.createElementNS&&!!h.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,F=/(edge|msie|trident)/i.test(m)&&!f.opera,L=-1!==m.indexOf("Firefox"),K=-1!==m.indexOf("Chrome"),C=L&&4>parseInt(m.split("Firefox/")[1],10);return{product:"Highcharts",version:"8.2.2",deg2rad:2*Math.PI/360,doc:h,hasBidiBug:C,hasTouch:!!f.TouchEvent,isMS:F,isWebKit:-1!==m.indexOf("AppleWebKit"),isFirefox:L,isChrome:K,isSafari:!K&&-1!==m.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(m),
SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:z,win:f,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});N(m,"Core/Utilities.js",[m["Core/Globals.js"]],function(f){function h(b,k,t,a){var u=k?"Highcharts error":"Highcharts warning";32===b&&(b=u+": Deprecated member");var c=l(b),H=c?u+" #"+b+": www.highcharts.com/errors/"+b+"/":b.toString();u=function(){if(k)throw Error(H);e.console&&-1===h.messages.indexOf(H)&&
console.log(H)};if("undefined"!==typeof a){var d="";c&&(H+="?");S(a,function(b,k){d+="\n - "+k+": "+b;c&&(H+=encodeURI(k)+"="+encodeURI(b))});H+=d}t?ca(t,"displayError",{code:b,message:H,params:a},u):u();h.messages.push(H)}function m(){var b,k=arguments,t={},a=function(b,k){"object"!==typeof b&&(b={});S(k,function(t,u){!z(t,!0)||n(t)||D(t)?b[u]=k[u]:b[u]=a(b[u]||{},t)});return b};!0===k[0]&&(t=k[1],k=Array.prototype.slice.call(k,2));var u=k.length;for(b=0;b<u;b++)t=a(t,k[b]);return t}function z(b,
k){return!!b&&"object"===typeof b&&(!k||!x(b))}function F(b,k,t){var a;v(k)?w(t)?b.setAttribute(k,t):b&&b.getAttribute&&((a=b.getAttribute(k))||"class"!==k||(a=b.getAttribute(k+"Name"))):S(k,function(k,t){b.setAttribute(t,k)});return a}function L(){for(var b=arguments,k=b.length,t=0;t<k;t++){var a=b[t];if("undefined"!==typeof a&&null!==a)return a}}function K(b,k){if(!b)return k;var t=b.split(".").reverse();if(1===t.length)return k[b];for(b=t.pop();"undefined"!==typeof b&&"undefined"!==typeof k&&null!==
k;)k=k[b],b=t.pop();return k}f.timers=[];var C=f.charts,y=f.doc,e=f.win;(h||(h={})).messages=[];f.error=h;f.merge=m;var I=f.pInt=function(b,k){return parseInt(b,k||10)},v=f.isString=function(b){return"string"===typeof b},x=f.isArray=function(b){b=Object.prototype.toString.call(b);return"[object Array]"===b||"[object Array Iterator]"===b};f.isObject=z;var D=f.isDOMElement=function(b){return z(b)&&"number"===typeof b.nodeType},n=f.isClass=function(b){var k=b&&b.constructor;return!(!z(b,!0)||D(b)||!k||
!k.name||"Object"===k.name)},l=f.isNumber=function(b){return"number"===typeof b&&!isNaN(b)&&Infinity>b&&-Infinity<b},J=f.erase=function(b,k){for(var t=b.length;t--;)if(b[t]===k){b.splice(t,1);break}},w=f.defined=function(b){return"undefined"!==typeof b&&null!==b};f.attr=F;var r=f.splat=function(b){return x(b)?b:[b]},d=f.syncTimeout=function(b,k,t){if(0<k)return setTimeout(b,k,t);b.call(0,t);return-1},g=f.clearTimeout=function(b){w(b)&&clearTimeout(b)},c=f.extend=function(b,k){var t;b||(b={});for(t in k)b[t]=
k[t];return b};f.pick=L;var a=f.css=function(b,k){f.isMS&&!f.svg&&k&&"undefined"!==typeof k.opacity&&(k.filter="alpha(opacity="+100*k.opacity+")");c(b.style,k)},q=f.createElement=function(b,k,t,u,H){b=y.createElement(b);k&&c(b,k);H&&a(b,{padding:"0",border:"none",margin:"0"});t&&a(b,t);u&&u.appendChild(b);return b},p=f.extendClass=function(b,k){var t=function(){};t.prototype=new b;c(t.prototype,k);return t},B=f.pad=function(b,k,t){return Array((k||2)+1-String(b).replace("-","").length).join(t||"0")+
b},A=f.relativeLength=function(b,k,t){return/%$/.test(b)?k*parseFloat(b)/100+(t||0):parseFloat(b)},G=f.wrap=function(b,k,t){var a=b[k];b[k]=function(){var b=Array.prototype.slice.call(arguments),k=arguments,u=this;u.proceed=function(){a.apply(u,arguments.length?arguments:k)};b.unshift(a);b=t.apply(this,b);u.proceed=null;return b}},M=f.format=function(b,k,t){var a="{",u=!1,H=[],c=/f$/,d=/\.([0-9])/,g=f.defaultOptions.lang,p=t&&t.time||f.time;for(t=t&&t.numberFormatter||R;b;){var q=b.indexOf(a);if(-1===
q)break;var U=b.slice(0,q);if(u){U=U.split(":");a=K(U.shift()||"",k);if(U.length&&"number"===typeof a)if(U=U.join(":"),c.test(U)){var r=parseInt((U.match(d)||["","-1"])[1],10);null!==a&&(a=t(a,r,g.decimalPoint,-1<U.indexOf(",")?g.thousandsSep:""))}else a=p.dateFormat(U,a);H.push(a)}else H.push(U);b=b.slice(q+1);a=(u=!u)?"}":"{"}H.push(b);return H.join("")},T=f.getMagnitude=function(b){return Math.pow(10,Math.floor(Math.log(b)/Math.LN10))},Q=f.normalizeTickInterval=function(b,k,a,u,H){var c=b;a=L(a,
1);var d=b/a;k||(k=H?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===u&&(1===a?k=k.filter(function(b){return 0===b%1}):.1>=a&&(k=[1/a])));for(u=0;u<k.length&&!(c=k[u],H&&c*a>=b||!H&&d<=(k[u]+(k[u+1]||k[u]))/2);u++);return c=t(c*a,-Math.round(Math.log(.001)/Math.LN10))},O=f.stableSort=function(b,k){var t=b.length,a,u;for(u=0;u<t;u++)b[u].safeI=u;b.sort(function(b,t){a=k(b,t);return 0===a?b.safeI-t.safeI:a});for(u=0;u<t;u++)delete b[u].safeI},E=f.arrayMin=function(b){for(var k=b.length,t=b[0];k--;)b[k]<
t&&(t=b[k]);return t},u=f.arrayMax=function(b){for(var k=b.length,t=b[0];k--;)b[k]>t&&(t=b[k]);return t},b=f.destroyObjectProperties=function(b,k){S(b,function(t,a){t&&t!==k&&t.destroy&&t.destroy();delete b[a]})},k=f.discardElement=function(b){var k=f.garbageBin;k||(k=q("div"));b&&k.appendChild(b);k.innerHTML=""},t=f.correctFloat=function(b,k){return parseFloat(b.toPrecision(k||14))},H=f.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5},R=
f.numberFormat=function(b,k,t,a){b=+b||0;k=+k;var u=f.defaultOptions.lang,H=(b.toString().split(".")[1]||"").split("e")[0].length,c=b.toString().split("e");if(-1===k)k=Math.min(H,20);else if(!l(k))k=2;else if(k&&c[1]&&0>c[1]){var d=k+ +c[1];0<=d?(c[0]=(+c[0]).toExponential(d).split("e")[0],k=d):(c[0]=c[0].split(".")[0]||0,b=20>k?(c[0]*Math.pow(10,c[1])).toFixed(k):0,c[1]=0)}var g=(Math.abs(c[1]?c[0]:b)+Math.pow(10,-Math.max(k,H)-1)).toFixed(k);H=String(I(g));d=3<H.length?H.length%3:0;t=L(t,u.decimalPoint);
a=L(a,u.thousandsSep);b=(0>b?"-":"")+(d?H.substr(0,d)+a:"");b+=H.substr(d).replace(/(\d{3})(?=\d)/g,"$1"+a);k&&(b+=t+g.slice(-k));c[1]&&0!==+b&&(b+="e"+c[1]);return b};Math.easeInOutSine=function(b){return-.5*(Math.cos(Math.PI*b)-1)};var U=f.getStyle=function(b,k,t){if("width"===k)return k=Math.min(b.offsetWidth,b.scrollWidth),t=b.getBoundingClientRect&&b.getBoundingClientRect().width,t<k&&t>=k-1&&(k=Math.floor(t)),Math.max(0,k-f.getStyle(b,"padding-left")-f.getStyle(b,"padding-right"));if("height"===
k)return Math.max(0,Math.min(b.offsetHeight,b.scrollHeight)-f.getStyle(b,"padding-top")-f.getStyle(b,"padding-bottom"));e.getComputedStyle||h(27,!0);if(b=e.getComputedStyle(b,void 0))b=b.getPropertyValue(k),L(t,"opacity"!==k)&&(b=I(b));return b},Z=f.inArray=function(b,k,t){h(32,!1,void 0,{"Highcharts.inArray":"use Array.indexOf"});return k.indexOf(b,t)},aa=f.find=Array.prototype.find?function(b,k){return b.find(k)}:function(b,k){var t,a=b.length;for(t=0;t<a;t++)if(k(b[t],t))return b[t]};f.keys=function(b){h(32,
!1,void 0,{"Highcharts.keys":"use Object.keys"});return Object.keys(b)};var ba=f.offset=function(b){var k=y.documentElement;b=b.parentElement||b.parentNode?b.getBoundingClientRect():{top:0,left:0};return{top:b.top+(e.pageYOffset||k.scrollTop)-(k.clientTop||0),left:b.left+(e.pageXOffset||k.scrollLeft)-(k.clientLeft||0)}},S=f.objectEach=function(b,k,t){for(var a in b)Object.hasOwnProperty.call(b,a)&&k.call(t||b[a],b[a],a,b)};S({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(b,
k){f[k]=function(t){var a;h(32,!1,void 0,(a={},a["Highcharts."+k]="use Array."+b,a));return Array.prototype[b].apply(t,[].slice.call(arguments,1))}});var Y=f.addEvent=function(b,k,t,a){void 0===a&&(a={});var u=b.addEventListener||f.addEventListenerPolyfill;var c="function"===typeof b&&b.prototype?b.prototype.protoEvents=b.prototype.protoEvents||{}:b.hcEvents=b.hcEvents||{};f.Point&&b instanceof f.Point&&b.series&&b.series.chart&&(b.series.chart.runTrackerClick=!0);u&&u.call(b,k,t,!1);c[k]||(c[k]=
[]);c[k].push({fn:t,order:"number"===typeof a.order?a.order:Infinity});c[k].sort(function(b,k){return b.order-k.order});return function(){W(b,k,t)}},W=f.removeEvent=function(b,k,t){function a(k,t){var a=b.removeEventListener||f.removeEventListenerPolyfill;a&&a.call(b,k,t,!1)}function u(t){var u;if(b.nodeName){if(k){var c={};c[k]=!0}else c=t;S(c,function(b,k){if(t[k])for(u=t[k].length;u--;)a(k,t[k][u].fn)})}}var c;["protoEvents","hcEvents"].forEach(function(H,d){var g=(d=d?b:b.prototype)&&d[H];g&&
(k?(c=g[k]||[],t?(g[k]=c.filter(function(b){return t!==b.fn}),a(k,t)):(u(g),g[k]=[])):(u(g),d[H]={}))})},ca=f.fireEvent=function(b,k,t,a){var u;t=t||{};if(y.createEvent&&(b.dispatchEvent||b.fireEvent)){var H=y.createEvent("Events");H.initEvent(k,!0,!0);c(H,t);b.dispatchEvent?b.dispatchEvent(H):b.fireEvent(k,H)}else t.target||c(t,{preventDefault:function(){t.defaultPrevented=!0},target:b,type:k}),function(k,a){void 0===k&&(k=[]);void 0===a&&(a=[]);var c=0,H=0,d=k.length+a.length;for(u=0;u<d;u++)!1===
(k[c]?a[H]?k[c].order<=a[H].order?k[c++]:a[H++]:k[c++]:a[H++]).fn.call(b,t)&&t.preventDefault()}(b.protoEvents&&b.protoEvents[k],b.hcEvents&&b.hcEvents[k]);a&&!t.defaultPrevented&&a.call(b,t)},V,da=f.uniqueKey=function(){var b=Math.random().toString(36).substring(2,9)+"-",k=0;return function(){return"highcharts-"+(V?"":b)+k++}}(),ea=f.useSerialIds=function(b){return V=L(b,V)},fa=f.isFunction=function(b){return"function"===typeof b},ha=f.getOptions=function(){return f.defaultOptions},ia=f.setOptions=
function(b){f.defaultOptions=m(!0,f.defaultOptions,b);(b.time||b.global)&&f.time.update(m(f.defaultOptions.global,f.defaultOptions.time,b.global,b.time));return f.defaultOptions};e.jQuery&&(e.jQuery.fn.highcharts=function(){var b=[].slice.call(arguments);if(this[0])return b[0]?(new (f[v(b[0])?b.shift():"Chart"])(this[0],b[0],b[1]),this):C[F(this[0],"data-highcharts-chart")]});return{addEvent:Y,arrayMax:u,arrayMin:E,attr:F,clamp:function(b,k,t){return b>k?b<t?b:t:k},clearTimeout:g,correctFloat:t,createElement:q,
css:a,defined:w,destroyObjectProperties:b,discardElement:k,erase:J,error:h,extend:c,extendClass:p,find:aa,fireEvent:ca,format:M,getMagnitude:T,getNestedProperty:K,getOptions:ha,getStyle:U,inArray:Z,isArray:x,isClass:n,isDOMElement:D,isFunction:fa,isNumber:l,isObject:z,isString:v,merge:m,normalizeTickInterval:Q,numberFormat:R,objectEach:S,offset:ba,pad:B,pick:L,pInt:I,relativeLength:A,removeEvent:W,setOptions:ia,splat:r,stableSort:O,syncTimeout:d,timeUnits:H,uniqueKey:da,useSerialIds:ea,wrap:G}});
N(m,"Core/Color/Color.js",[m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h){var m=h.isNumber,z=h.merge,F=h.pInt;"";h=function(){function h(K){this.parsers=[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(h){return[F(h[1]),F(h[2]),F(h[3]),parseFloat(h[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(h){return[F(h[1]),F(h[2]),F(h[3]),1]}}];this.rgba=[];if(f.Color!==h)return new f.Color(K);
if(!(this instanceof h))return new h(K);this.init(K)}h.parse=function(f){return new h(f)};h.prototype.init=function(f){var C,y;if((this.input=f=h.names[f&&f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=f.stops.map(function(v){return new h(v[1])});else{if(f&&f.charAt&&"#"===f.charAt()){var e=f.length;f=parseInt(f.substr(1),16);7===e?C=[(f&16711680)>>16,(f&65280)>>8,f&255,1]:4===e&&(C=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])}if(!C)for(y=this.parsers.length;y--&&!C;){var I=
this.parsers[y];(e=I.regex.exec(f))&&(C=I.parse(e))}}this.rgba=C||[]};h.prototype.get=function(f){var h=this.input,y=this.rgba;if("undefined"!==typeof this.stops){var e=z(h);e.stops=[].concat(e.stops);this.stops.forEach(function(I,v){e.stops[v]=[e.stops[v][0],I.get(f)]})}else e=y&&m(y[0])?"rgb"===f||!f&&1===y[3]?"rgb("+y[0]+","+y[1]+","+y[2]+")":"a"===f?y[3]:"rgba("+y.join(",")+")":h;return e};h.prototype.brighten=function(f){var h,y=this.rgba;if(this.stops)this.stops.forEach(function(e){e.brighten(f)});
else if(m(f)&&0!==f)for(h=0;3>h;h++)y[h]+=F(255*f),0>y[h]&&(y[h]=0),255<y[h]&&(y[h]=255);return this};h.prototype.setOpacity=function(f){this.rgba[3]=f;return this};h.prototype.tweenTo=function(f,h){var y=this.rgba,e=f.rgba;e.length&&y&&y.length?(f=1!==e[3]||1!==y[3],h=(f?"rgba(":"rgb(")+Math.round(e[0]+(y[0]-e[0])*(1-h))+","+Math.round(e[1]+(y[1]-e[1])*(1-h))+","+Math.round(e[2]+(y[2]-e[2])*(1-h))+(f?","+(e[3]+(y[3]-e[3])*(1-h)):"")+")"):h=f.input||"none";return h};h.names={white:"#ffffff",black:"#000000"};
return h}();f.Color=h;f.color=h.parse;return h});N(m,"Core/Animation/Fx.js",[m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h){var m=f.win,z=h.isNumber,F=h.objectEach;h=function(){function h(f,h,y){this.pos=NaN;this.options=h;this.elem=f;this.prop=y}h.prototype.dSetter=function(){var f=this.paths,h=f&&f[0];f=f&&f[1];var y=[],e=this.now||0;if(1!==e&&h&&f)if(h.length===f.length&&1>e)for(var I=0;I<f.length;I++){for(var v=h[I],x=f[I],D=[],n=0;n<x.length;n++){var l=v[n],J=x[n];D[n]="number"===
typeof l&&"number"===typeof J&&("A"!==x[0]||4!==n&&5!==n)?l+e*(J-l):J}y.push(D)}else y=f;else y=this.toD||[];this.elem.attr("d",y,void 0,!0)};h.prototype.update=function(){var f=this.elem,h=this.prop,y=this.now,e=this.options.step;if(this[h+"Setter"])this[h+"Setter"]();else f.attr?f.element&&f.attr(h,y,null,!0):f.style[h]=y+this.unit;e&&e.call(f,y,this)};h.prototype.run=function(h,C,y){var e=this,I=e.options,v=function(n){return v.stopped?!1:e.step(n)},x=m.requestAnimationFrame||function(n){setTimeout(n,
13)},D=function(){for(var n=0;n<f.timers.length;n++)f.timers[n]()||f.timers.splice(n--,1);f.timers.length&&x(D)};h!==C||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=h,this.end=C,this.unit=y,this.now=this.start,this.pos=0,v.elem=this.elem,v.prop=this.prop,v()&&1===f.timers.push(v)&&x(D)):(delete I.curAnim[this.prop],I.complete&&0===Object.keys(I.curAnim).length&&I.complete.call(this.elem))};h.prototype.step=function(f){var h=+new Date,y=this.options,e=this.elem,I=y.complete,
v=y.duration,x=y.curAnim;if(e.attr&&!e.element)f=!1;else if(f||h>=v+this.startTime){this.now=this.end;this.pos=1;this.update();var D=x[this.prop]=!0;F(x,function(n){!0!==n&&(D=!1)});D&&I&&I.call(e);f=!1}else this.pos=y.easing((h-this.startTime)/v),this.now=this.start+(this.end-this.start)*this.pos,this.update(),f=!0;return f};h.prototype.initPath=function(f,h,y){function e(r,d){for(;r.length<w;){var g=r[0],c=d[w-r.length];c&&"M"===g[0]&&(r[0]="C"===c[0]?["C",g[1],g[2],g[1],g[2],g[1],g[2]]:["L",g[1],
g[2]]);r.unshift(g);D&&r.push(r[r.length-1])}}function I(r,d){for(;r.length<w;)if(d=r[r.length/n-1].slice(),"C"===d[0]&&(d[1]=d[5],d[2]=d[6]),D){var g=r[r.length/n].slice();r.splice(r.length/2,0,d,g)}else r.push(d)}var v=f.startX,x=f.endX;h=h&&h.slice();y=y.slice();var D=f.isArea,n=D?2:1;if(!h)return[y,y];if(v&&x){for(f=0;f<v.length;f++)if(v[f]===x[0]){var l=f;break}else if(v[0]===x[x.length-v.length+f]){l=f;var J=!0;break}else if(v[v.length-1]===x[x.length-v.length+f]){l=v.length-f;break}"undefined"===
typeof l&&(h=[])}if(h.length&&z(l)){var w=y.length+l*n;J?(e(h,y),I(y,h)):(e(y,h),I(h,y))}return[h,y]};h.prototype.fillSetter=function(){h.prototype.strokeSetter.apply(this,arguments)};h.prototype.strokeSetter=function(){this.elem.attr(this.prop,f.color(this.start).tweenTo(f.color(this.end),this.pos),null,!0)};return h}();return f.Fx=h});N(m,"Core/Animation/AnimationUtilities.js",[m["Core/Animation/Fx.js"],m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h,m){var z=m.defined,P=m.getStyle,L=
m.isArray,K=m.isNumber,C=m.isObject,y=m.merge,e=m.objectEach,I=m.pick;m=h.setAnimation=function(l,n){n.renderer.globalAnimation=I(l,n.options.chart.animation,!0)};var v=h.animObject=function(l){return C(l)?h.merge({duration:500,defer:0},l):{duration:l?500:0,defer:0}},x=h.getDeferredAnimation=function(l,n,w){var r=v(n),d=0,g=0;(w?[w]:l.series).forEach(function(c){c=v(c.options.animation);d=n&&z(n.defer)?r.defer:Math.max(d,c.duration+c.defer);g=Math.min(r.duration,c.duration)});l.renderer.forExport&&
(d=0);return{defer:Math.max(0,d-g),duration:Math.min(d,g)}},D=h.animate=function(l,v,w){var r,d="",g,c;if(!C(w)){var a=arguments;w={duration:a[2],easing:a[3],complete:a[4]}}K(w.duration)||(w.duration=400);w.easing="function"===typeof w.easing?w.easing:Math[w.easing]||Math.easeInOutSine;w.curAnim=y(v);e(v,function(a,p){n(l,p);c=new f(l,w,p);g=null;"d"===p&&L(v.d)?(c.paths=c.initPath(l,l.pathArray,v.d),c.toD=v.d,r=0,g=1):l.attr?r=l.attr(p):(r=parseFloat(P(l,p))||0,"opacity"!==p&&(d="px"));g||(g=a);
g&&g.match&&g.match("px")&&(g=g.replace(/px/g,""));c.run(r,g,d)})},n=h.stop=function(l,n){for(var w=h.timers.length;w--;)h.timers[w].elem!==l||n&&n!==h.timers[w].prop||(h.timers[w].stopped=!0)};return{animate:D,animObject:v,getDeferredAnimation:x,setAnimation:m,stop:n}});N(m,"Core/Renderer/SVG/SVGElement.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Color/Color.js"],m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h,m,z){var F=f.animate,P=f.animObject,K=f.stop,C=m.deg2rad,y=m.doc,
e=m.hasTouch,I=m.isFirefox,v=m.noop,x=m.svg,D=m.SVG_NS,n=m.win,l=z.attr,J=z.createElement,w=z.css,r=z.defined,d=z.erase,g=z.extend,c=z.fireEvent,a=z.isArray,q=z.isFunction,p=z.isNumber,B=z.isString,A=z.merge,G=z.objectEach,M=z.pick,T=z.pInt,Q=z.syncTimeout,O=z.uniqueKey;"";f=function(){function E(){this.height=this.element=void 0;this.opacity=1;this.renderer=void 0;this.SVG_NS=D;this.symbolCustomAttribs="x y width height r start end innerR anchorX anchorY rounded".split(" ");this.width=void 0}E.prototype._defaultGetter=
function(a){a=M(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a};E.prototype._defaultSetter=function(a,b,k){k.setAttribute(b,a)};E.prototype.add=function(a){var b=this.renderer,k=this.element;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;"undefined"!==typeof this.textStr&&"text"===this.element.nodeName&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)var t=this.zIndexSetter();t||(a?a.element:b.box).appendChild(k);
if(this.onAdd)this.onAdd();return this};E.prototype.addClass=function(a,b){var k=b?"":this.attr("class")||"";a=(a||"").split(/ /g).reduce(function(b,a){-1===k.indexOf(a)&&b.push(a);return b},k?[k]:[]).join(" ");a!==k&&this.attr("class",a);return this};E.prototype.afterSetters=function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)};E.prototype.align=function(a,b,k){var t,c={};var u=this.renderer;var g=u.alignedObjects;var p,q;if(a){if(this.alignOptions=a,this.alignByTranslate=b,
!k||B(k))this.alignTo=t=k||"renderer",d(g,this),g.push(this),k=void 0}else a=this.alignOptions,b=this.alignByTranslate,t=this.alignTo;k=M(k,u[t],u);t=a.align;u=a.verticalAlign;g=(k.x||0)+(a.x||0);var r=(k.y||0)+(a.y||0);"right"===t?p=1:"center"===t&&(p=2);p&&(g+=(k.width-(a.width||0))/p);c[b?"translateX":"x"]=Math.round(g);"bottom"===u?q=1:"middle"===u&&(q=2);q&&(r+=(k.height-(a.height||0))/q);c[b?"translateY":"y"]=Math.round(r);this[this.placed?"animate":"attr"](c);this.placed=!0;this.alignAttr=
c;return this};E.prototype.alignSetter=function(a){var b={left:"start",center:"middle",right:"end"};b[a]&&(this.alignValue=a,this.element.setAttribute("text-anchor",b[a]))};E.prototype.animate=function(a,b,k){var t=this,c=P(M(b,this.renderer.globalAnimation,!0));b=c.defer;M(y.hidden,y.msHidden,y.webkitHidden,!1)&&(c.duration=0);0!==c.duration?(k&&(c.complete=k),Q(function(){t.element&&F(t,a,c)},b)):(this.attr(a,void 0,k),G(a,function(b,k){c.step&&c.step.call(this,b,{prop:k,pos:1})},this));return this};
E.prototype.applyTextOutline=function(a){var b=this.element,k;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(b.style.fill)));a=a.split(" ");var t=a[a.length-1];if((k=a[0])&&"none"!==k&&m.svg){this.fakeTS=!0;a=[].slice.call(b.getElementsByTagName("tspan"));this.ySetter=this.xSetter;k=k.replace(/(^[\d\.]+)(.*?)$/g,function(b,k,t){return 2*k+t});this.removeTextOutline(a);var c=b.textContent?/^[\u0591-\u065F\u066A-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(b.textContent):
!1;var u=b.firstChild;a.forEach(function(a,H){0===H&&(a.setAttribute("x",b.getAttribute("x")),H=b.getAttribute("y"),a.setAttribute("y",H||0),null===H&&b.setAttribute("y",0));H=a.cloneNode(!0);l(c&&!I?a:H,{"class":"highcharts-text-outline",fill:t,stroke:t,"stroke-width":k,"stroke-linejoin":"round"});b.insertBefore(H,u)});c&&I&&a[0]&&(a=a[0].cloneNode(!0),a.textContent=" ",b.insertBefore(a,u))}};E.prototype.attr=function(a,b,k,t){var c=this.element,u,d=this,g,p,q=this.symbolCustomAttribs;if("string"===
typeof a&&"undefined"!==typeof b){var r=a;a={};a[r]=b}"string"===typeof a?d=(this[a+"Getter"]||this._defaultGetter).call(this,a,c):(G(a,function(b,k){g=!1;t||K(this,k);this.symbolName&&-1!==q.indexOf(k)&&(u||(this.symbolAttr(a),u=!0),g=!0);!this.rotation||"x"!==k&&"y"!==k||(this.doTransform=!0);g||(p=this[k+"Setter"]||this._defaultSetter,p.call(this,b,k,c),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(k)&&this.updateShadows(k,b,p))},this),this.afterSetters());
k&&k.call(this);return d};E.prototype.clip=function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")};E.prototype.crisp=function(a,b){b=b||a.strokeWidth||0;var k=Math.round(b)%2/2;a.x=Math.floor(a.x||this.x||0)+k;a.y=Math.floor(a.y||this.y||0)+k;a.width=Math.floor((a.width||this.width||0)-2*k);a.height=Math.floor((a.height||this.height||0)-2*k);r(a.strokeWidth)&&(a.strokeWidth=b);return a};E.prototype.complexColor=function(u,b,k){var t=this.renderer,H,d,g,p,q,B,l,n,
w,E,V=[],v;c(this.renderer,"complexColor",{args:arguments},function(){u.radialGradient?d="radialGradient":u.linearGradient&&(d="linearGradient");if(d){g=u[d];q=t.gradients;B=u.stops;w=k.radialReference;a(g)&&(u[d]=g={x1:g[0],y1:g[1],x2:g[2],y2:g[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===d&&w&&!r(g.gradientUnits)&&(p=g,g=A(g,t.getRadialAttr(w,p),{gradientUnits:"userSpaceOnUse"}));G(g,function(b,k){"id"!==k&&V.push(k,b)});G(B,function(b){V.push(b)});V=V.join(",");if(q[V])E=q[V].attr("id");
else{g.id=E=O();var c=q[V]=t.createElement(d).attr(g).add(t.defs);c.radAttr=p;c.stops=[];B.forEach(function(b){0===b[1].indexOf("rgba")?(H=h.parse(b[1]),l=H.get("rgb"),n=H.get("a")):(l=b[1],n=1);b=t.createElement("stop").attr({offset:b[0],"stop-color":l,"stop-opacity":n}).add(c);c.stops.push(b)})}v="url("+t.url+"#"+E+")";k.setAttribute(b,v);k.gradient=V;u.toString=function(){return v}}})};E.prototype.css=function(a){var b=this.styles,k={},t=this.element,c="",d=!b,u=["textOutline","textOverflow","width"];
a&&a.color&&(a.fill=a.color);b&&G(a,function(a,t){b&&b[t]!==a&&(k[t]=a,d=!0)});if(d){b&&(a=g(b,k));if(a)if(null===a.width||"auto"===a.width)delete this.textWidth;else if("text"===t.nodeName.toLowerCase()&&a.width)var p=this.textWidth=T(a.width);this.styles=a;p&&!x&&this.renderer.forExport&&delete a.width;if(t.namespaceURI===this.SVG_NS){var q=function(b,k){return"-"+k.toLowerCase()};G(a,function(b,k){-1===u.indexOf(k)&&(c+=k.replace(/([A-Z])/g,q)+":"+b+";")});c&&l(t,"style",c)}else w(t,a);this.added&&
("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this};E.prototype.dashstyleSetter=function(a){var b=this["stroke-width"];"inherit"===b&&(b=1);if(a=a&&a.toLowerCase()){var k=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(a=k.length;a--;)k[a]=
""+T(k[a])*M(b,NaN);a=k.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}};E.prototype.destroy=function(){var a=this,b=a.element||{},k=a.renderer,t=k.isSVG&&"SPAN"===b.nodeName&&a.parentGroup||void 0,c=b.ownerSVGElement;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;K(a);if(a.clipPath&&c){var g=a.clipPath;[].forEach.call(c.querySelectorAll("[clip-path],[CLIP-PATH]"),function(b){-1<b.getAttribute("clip-path").indexOf(g.element.id)&&b.removeAttribute("clip-path")});
a.clipPath=g.destroy()}if(a.stops){for(c=0;c<a.stops.length;c++)a.stops[c].destroy();a.stops.length=0;a.stops=void 0}a.safeRemoveChild(b);for(k.styledMode||a.destroyShadows();t&&t.div&&0===t.div.childNodes.length;)b=t.parentGroup,a.safeRemoveChild(t.div),delete t.div,t=b;a.alignTo&&d(k.alignedObjects,a);G(a,function(b,k){a[k]&&a[k].parentGroup===a&&a[k].destroy&&a[k].destroy();delete a[k]})};E.prototype.destroyShadows=function(){(this.shadows||[]).forEach(function(a){this.safeRemoveChild(a)},this);
this.shadows=void 0};E.prototype.destroyTextPath=function(a,b){var k=a.getElementsByTagName("text")[0];if(k){if(k.removeAttribute("dx"),k.removeAttribute("dy"),b.element.setAttribute("id",""),this.textPathWrapper&&k.getElementsByTagName("textPath").length){for(a=this.textPathWrapper.element.childNodes;a.length;)k.appendChild(a[0]);k.removeChild(this.textPathWrapper.element)}}else if(a.getAttribute("dx")||a.getAttribute("dy"))a.removeAttribute("dx"),a.removeAttribute("dy");this.textPathWrapper&&(this.textPathWrapper=
this.textPathWrapper.destroy())};E.prototype.dSetter=function(c,b,k){a(c)&&("string"===typeof c[0]&&(c=this.renderer.pathToSegments(c)),this.pathArray=c,c=c.reduce(function(b,k,a){return k&&k.join?(a?b+" ":"")+k.join(" "):(k||"").toString()},""));/(NaN| {2}|^$)/.test(c)&&(c="M 0 0");this[b]!==c&&(k.setAttribute(b,c),this[b]=c)};E.prototype.fadeOut=function(a){var b=this;b.animate({opacity:0},{duration:M(a,150),complete:function(){b.attr({y:-9999}).hide()}})};E.prototype.fillSetter=function(a,b,k){"string"===
typeof a?k.setAttribute(b,a):a&&this.complexColor(a,b,k)};E.prototype.getBBox=function(a,b){var k,t=this.renderer,c=this.element,d=this.styles,p=this.textStr,u=t.cache,B=t.cacheKeys,A=c.namespaceURI===this.SVG_NS;b=M(b,this.rotation,0);var l=t.styledMode?c&&E.prototype.getStyle.call(c,"font-size"):d&&d.fontSize;if(r(p)){var n=p.toString();-1===n.indexOf("<")&&(n=n.replace(/[0-9]/g,"0"));n+=["",b,l,this.textWidth,d&&d.textOverflow,d&&d.fontWeight].join()}n&&!a&&(k=u[n]);if(!k){if(A||t.forExport){try{var w=
this.fakeTS&&function(b){[].forEach.call(c.querySelectorAll(".highcharts-text-outline"),function(k){k.style.display=b})};q(w)&&w("none");k=c.getBBox?g({},c.getBBox()):{width:c.offsetWidth,height:c.offsetHeight};q(w)&&w("")}catch(ca){""}if(!k||0>k.width)k={width:0,height:0}}else k=this.htmlGetBBox();t.isSVG&&(a=k.width,t=k.height,A&&(k.height=t={"11px,17":14,"13px,20":16}[d&&d.fontSize+","+Math.round(t)]||t),b&&(d=b*C,k.width=Math.abs(t*Math.sin(d))+Math.abs(a*Math.cos(d)),k.height=Math.abs(t*Math.cos(d))+
Math.abs(a*Math.sin(d))));if(n&&0<k.height){for(;250<B.length;)delete u[B.shift()];u[n]||B.push(n);u[n]=k}}return k};E.prototype.getStyle=function(a){return n.getComputedStyle(this.element||this,"").getPropertyValue(a)};E.prototype.hasClass=function(a){return-1!==(""+this.attr("class")).split(" ").indexOf(a)};E.prototype.hide=function(a){a?this.attr({y:-9999}):this.attr({visibility:"hidden"});return this};E.prototype.htmlGetBBox=function(){return{height:0,width:0,x:0,y:0}};E.prototype.init=function(a,
b){this.element="span"===b?J(b):y.createElementNS(this.SVG_NS,b);this.renderer=a;c(this,"afterInit")};E.prototype.invert=function(a){this.inverted=a;this.updateTransform();return this};E.prototype.on=function(a,b){var k,t,c=this.element,d;e&&"click"===a?(c.ontouchstart=function(b){k=b.touches[0].clientX;t=b.touches[0].clientY},c.ontouchend=function(a){k&&4<=Math.sqrt(Math.pow(k-a.changedTouches[0].clientX,2)+Math.pow(t-a.changedTouches[0].clientY,2))||b.call(c,a);d=!0;!1!==a.cancelable&&a.preventDefault()},
c.onclick=function(k){d||b.call(c,k)}):c["on"+a]=b;return this};E.prototype.opacitySetter=function(a,b,k){this.opacity=a=Number(Number(a).toFixed(3));k.setAttribute(b,a)};E.prototype.removeClass=function(a){return this.attr("class",(""+this.attr("class")).replace(B(a)?new RegExp("(^| )"+a+"( |$)"):a," ").replace(/ +/g," ").trim())};E.prototype.removeTextOutline=function(a){for(var b=a.length,k;b--;)k=a[b],"highcharts-text-outline"===k.getAttribute("class")&&d(a,this.element.removeChild(k))};E.prototype.safeRemoveChild=
function(a){var b=a.parentNode;b&&b.removeChild(a)};E.prototype.setRadialReference=function(a){var b=this.element.gradient&&this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,b.radAttr));return this};E.prototype.setTextPath=function(a,b){var k=this.element,t={textAnchor:"text-anchor"},c=!1,d=this.textPathWrapper,g=!d;b=A(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},b);var q=b.attributes;if(a&&
b&&b.enabled){d&&null===d.element.parentNode?(g=!0,d=d.destroy()):d&&this.removeTextOutline.call(d.parentGroup,[].slice.call(k.getElementsByTagName("tspan")));this.options&&this.options.padding&&(q.dx=-this.options.padding);d||(this.textPathWrapper=d=this.renderer.createElement("textPath"),c=!0);var u=d.element;(b=a.element.getAttribute("id"))||a.element.setAttribute("id",b=O());if(g)for(a=k.getElementsByTagName("tspan");a.length;)a[0].setAttribute("y",0),p(q.dx)&&a[0].setAttribute("x",-q.dx),u.appendChild(a[0]);
c&&d&&d.add({element:this.text?this.text.element:k});u.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+b);r(q.dy)&&(u.parentNode.setAttribute("dy",q.dy),delete q.dy);r(q.dx)&&(u.parentNode.setAttribute("dx",q.dx),delete q.dx);G(q,function(b,k){u.setAttribute(t[k]||k,b)});k.removeAttribute("transform");this.removeTextOutline.call(d,[].slice.call(k.getElementsByTagName("tspan")));this.text&&!this.renderer.styledMode&&this.attr({fill:"none","stroke-width":0});this.applyTextOutline=
this.updateTransform=v}else d&&(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(k,a),this.updateTransform(),this.options&&this.options.rotation&&this.applyTextOutline(this.options.style.textOutline));return this};E.prototype.shadow=function(a,b,k){var t=[],c=this.element,d=!1,p=this.oldShadowOptions;var q={color:"#000000",offsetX:1,offsetY:1,opacity:.15,width:3};var u;!0===a?u=q:"object"===typeof a&&(u=g(q,a));u&&(u&&p&&G(u,function(b,k){b!==p[k]&&(d=!0)}),d&&this.destroyShadows(),
this.oldShadowOptions=u);if(!u)this.destroyShadows();else if(!this.shadows){var r=u.opacity/u.width;var B=this.parentInverted?"translate(-1,-1)":"translate("+u.offsetX+", "+u.offsetY+")";for(q=1;q<=u.width;q++){var A=c.cloneNode(!1);var n=2*u.width+1-2*q;l(A,{stroke:a.color||"#000000","stroke-opacity":r*q,"stroke-width":n,transform:B,fill:"none"});A.setAttribute("class",(A.getAttribute("class")||"")+" highcharts-shadow");k&&(l(A,"height",Math.max(l(A,"height")-n,0)),A.cutHeight=n);b?b.element.appendChild(A):
c.parentNode&&c.parentNode.insertBefore(A,c);t.push(A)}this.shadows=t}return this};E.prototype.show=function(a){return this.attr({visibility:a?"inherit":"visible"})};E.prototype.strokeSetter=function(a,b,k){this[b]=a;this.stroke&&this["stroke-width"]?(E.prototype.fillSetter.call(this,this.stroke,"stroke",k),k.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===b&&0===a&&this.hasStroke?(k.removeAttribute("stroke"),this.hasStroke=!1):this.renderer.styledMode&&this["stroke-width"]&&
(k.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0)};E.prototype.strokeWidth=function(){if(!this.renderer.styledMode)return this["stroke-width"]||0;var a=this.getStyle("stroke-width"),b=0;if(a.indexOf("px")===a.length-2)b=T(a);else if(""!==a){var k=y.createElementNS(D,"rect");l(k,{width:a,"stroke-width":0});this.element.parentNode.appendChild(k);b=k.getBBox().width;k.parentNode.removeChild(k)}return b};E.prototype.symbolAttr=function(a){var b=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(k){b[k]=
M(a[k],b[k])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})};E.prototype.textSetter=function(a){a!==this.textStr&&(delete this.textPxLength,this.textStr=a,this.added&&this.renderer.buildText(this))};E.prototype.titleSetter=function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=y.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(y.createTextNode(String(M(a,"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,
"<").replace(/&gt;/g,">")))};E.prototype.toFront=function(){var a=this.element;a.parentNode.appendChild(a);return this};E.prototype.translate=function(a,b){return this.attr({translateX:a,translateY:b})};E.prototype.updateShadows=function(a,b,k){var t=this.shadows;if(t)for(var c=t.length;c--;)k.call(t[c],"height"===a?Math.max(b-(t[c].cutHeight||0),0):"d"===a?this.d:b,a,t[c])};E.prototype.updateTransform=function(){var a=this.translateX||0,b=this.translateY||0,k=this.scaleX,t=this.scaleY,c=this.inverted,
d=this.rotation,g=this.matrix,p=this.element;c&&(a+=this.width,b+=this.height);a=["translate("+a+","+b+")"];r(g)&&a.push("matrix("+g.join(",")+")");c?a.push("rotate(90) scale(-1,1)"):d&&a.push("rotate("+d+" "+M(this.rotationOriginX,p.getAttribute("x"),0)+" "+M(this.rotationOriginY,p.getAttribute("y")||0)+")");(r(k)||r(t))&&a.push("scale("+M(k,1)+" "+M(t,1)+")");a.length&&p.setAttribute("transform",a.join(" "))};E.prototype.visibilitySetter=function(a,b,k){"inherit"===a?k.removeAttribute(b):this[b]!==
a&&k.setAttribute(b,a);this[b]=a};E.prototype.xGetter=function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)};E.prototype.zIndexSetter=function(a,b){var k=this.renderer,t=this.parentGroup,c=(t||k).element||k.box,d=this.element,g=!1;k=c===k.box;var p=this.added;var q;r(a)?(d.setAttribute("data-z-index",a),a=+a,this[b]===a&&(p=!1)):r(this[b])&&d.removeAttribute("data-z-index");this[b]=a;if(p){(a=this.zIndex)&&t&&(t.handleZ=!0);b=c.childNodes;for(q=
b.length-1;0<=q&&!g;q--){t=b[q];p=t.getAttribute("data-z-index");var u=!r(p);if(t!==d)if(0>a&&u&&!k&&!q)c.insertBefore(d,b[q]),g=!0;else if(T(p)<=a||u&&(!r(a)||0<=a))c.insertBefore(d,b[q+1]||null),g=!0}g||(c.insertBefore(d,b[k?3:0]||null),g=!0)}return g};return E}();f.prototype["stroke-widthSetter"]=f.prototype.strokeSetter;f.prototype.yGetter=f.prototype.xGetter;f.prototype.matrixSetter=f.prototype.rotationOriginXSetter=f.prototype.rotationOriginYSetter=f.prototype.rotationSetter=f.prototype.scaleXSetter=
f.prototype.scaleYSetter=f.prototype.translateXSetter=f.prototype.translateYSetter=f.prototype.verticalAlignSetter=function(a,c){this[c]=a;this.doTransform=!0};m.SVGElement=f;return m.SVGElement});N(m,"Core/Renderer/SVG/SVGLabel.js",[m["Core/Renderer/SVG/SVGElement.js"],m["Core/Utilities.js"]],function(f,h){var m=this&&this.__extends||function(){var f=function(e,I){f=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(v,e){v.__proto__=e}||function(v,e){for(var f in e)e.hasOwnProperty(f)&&
(v[f]=e[f])};return f(e,I)};return function(e,I){function v(){this.constructor=e}f(e,I);e.prototype=null===I?Object.create(I):(v.prototype=I.prototype,new v)}}(),z=h.defined,F=h.extend,L=h.isNumber,K=h.merge,C=h.removeEvent;return function(h){function e(f,v,x,D,n,l,J,w,r,d){var g=h.call(this)||this;g.init(f,"g");g.textStr=v;g.x=x;g.y=D;g.anchorX=l;g.anchorY=J;g.baseline=r;g.className=d;"button"!==d&&g.addClass("highcharts-label");d&&g.addClass("highcharts-"+d);g.text=f.text("",0,0,w).attr({zIndex:1});
if("string"===typeof n){var c=/^url\((.*?)\)$/.test(n);if(g.renderer.symbols[n]||c)g.symbolKey=n}g.bBox=e.emptyBBox;g.padding=3;g.paddingLeft=0;g.baselineOffset=0;g.needsBox=f.styledMode||c;g.deferredAttr={};g.alignFactor=0;return g}m(e,h);e.prototype.alignSetter=function(e){e={left:0,center:.5,right:1}[e];e!==this.alignFactor&&(this.alignFactor=e,this.bBox&&L(this.xSetting)&&this.attr({x:this.xSetting}))};e.prototype.anchorXSetter=function(e,v){this.anchorX=e;this.boxAttr(v,Math.round(e)-this.getCrispAdjust()-
this.xSetting)};e.prototype.anchorYSetter=function(e,v){this.anchorY=e;this.boxAttr(v,e-this.ySetting)};e.prototype.boxAttr=function(e,v){this.box?this.box.attr(e,v):this.deferredAttr[e]=v};e.prototype.css=function(h){if(h){var v={};h=K(h);e.textProps.forEach(function(e){"undefined"!==typeof h[e]&&(v[e]=h[e],delete h[e])});this.text.css(v);var I="fontSize"in v||"fontWeight"in v;if("width"in v||I)this.updateBoxSize(),I&&this.updateTextPadding()}return f.prototype.css.call(this,h)};e.prototype.destroy=
function(){C(this.element,"mouseenter");C(this.element,"mouseleave");this.text&&this.text.destroy();this.box&&(this.box=this.box.destroy());f.prototype.destroy.call(this)};e.prototype.fillSetter=function(e,v){e&&(this.needsBox=!0);this.fill=e;this.boxAttr(v,e)};e.prototype.getBBox=function(){var e=this.bBox,v=this.padding;return{width:e.width+2*v,height:e.height+2*v,x:e.x-v,y:e.y-v}};e.prototype.getCrispAdjust=function(){return this.renderer.styledMode&&this.box?this.box.strokeWidth()%2/2:(this["stroke-width"]?
parseInt(this["stroke-width"],10):0)%2/2};e.prototype.heightSetter=function(e){this.heightSetting=e};e.prototype.on=function(e,v){var h=this,D=h.text,n=D&&"SPAN"===D.element.tagName?D:void 0;if(n){var l=function(l){("mouseenter"===e||"mouseleave"===e)&&l.relatedTarget instanceof Element&&(h.element.contains(l.relatedTarget)||n.element.contains(l.relatedTarget))||v.call(h.element,l)};n.on(e,l)}f.prototype.on.call(h,e,l||v);return h};e.prototype.onAdd=function(){var e=this.textStr;this.text.add(this);
this.attr({text:z(e)?e:"",x:this.x,y:this.y});this.box&&z(this.anchorX)&&this.attr({anchorX:this.anchorX,anchorY:this.anchorY})};e.prototype.paddingSetter=function(e){z(e)&&e!==this.padding&&(this.padding=e,this.updateTextPadding())};e.prototype.paddingLeftSetter=function(e){z(e)&&e!==this.paddingLeft&&(this.paddingLeft=e,this.updateTextPadding())};e.prototype.rSetter=function(e,v){this.boxAttr(v,e)};e.prototype.shadow=function(e){e&&!this.renderer.styledMode&&(this.updateBoxSize(),this.box&&this.box.shadow(e));
return this};e.prototype.strokeSetter=function(e,v){this.stroke=e;this.boxAttr(v,e)};e.prototype["stroke-widthSetter"]=function(e,v){e&&(this.needsBox=!0);this["stroke-width"]=e;this.boxAttr(v,e)};e.prototype["text-alignSetter"]=function(e){this.textAlign=e};e.prototype.textSetter=function(e){"undefined"!==typeof e&&this.text.attr({text:e});this.updateBoxSize();this.updateTextPadding()};e.prototype.updateBoxSize=function(){var f=this.text.element.style,v={},h=this.padding,D=this.paddingLeft,n=L(this.widthSetting)&&
L(this.heightSetting)&&!this.textAlign||!z(this.text.textStr)?e.emptyBBox:this.text.getBBox();this.width=(this.widthSetting||n.width||0)+2*h+D;this.height=(this.heightSetting||n.height||0)+2*h;this.baselineOffset=h+Math.min(this.renderer.fontMetrics(f&&f.fontSize,this.text).b,n.height||Infinity);this.needsBox&&(this.box||(f=this.box=this.symbolKey?this.renderer.symbol(this.symbolKey):this.renderer.rect(),f.addClass(("button"===this.className?"":"highcharts-label-box")+(this.className?" highcharts-"+
this.className+"-box":"")),f.add(this),f=this.getCrispAdjust(),v.x=f,v.y=(this.baseline?-this.baselineOffset:0)+f),v.width=Math.round(this.width),v.height=Math.round(this.height),this.box.attr(F(v,this.deferredAttr)),this.deferredAttr={});this.bBox=n};e.prototype.updateTextPadding=function(){var e=this.text,f=this.baseline?0:this.baselineOffset,h=this.paddingLeft+this.padding;z(this.widthSetting)&&this.bBox&&("center"===this.textAlign||"right"===this.textAlign)&&(h+={center:.5,right:1}[this.textAlign]*
(this.widthSetting-this.bBox.width));if(h!==e.x||f!==e.y)e.attr("x",h),e.hasBoxWidthChanged&&(this.bBox=e.getBBox(!0),this.updateBoxSize()),"undefined"!==typeof f&&e.attr("y",f);e.x=h;e.y=f};e.prototype.widthSetter=function(e){this.widthSetting=L(e)?e:void 0};e.prototype.xSetter=function(e){this.x=e;this.alignFactor&&(e-=this.alignFactor*((this.widthSetting||this.bBox.width)+2*this.padding),this["forceAnimate:x"]=!0);this.xSetting=Math.round(e);this.attr("translateX",this.xSetting)};e.prototype.ySetter=
function(e){this.ySetting=this.y=Math.round(e);this.attr("translateY",this.ySetting)};e.emptyBBox={width:0,height:0,x:0,y:0};e.textProps="color cursor direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" ");return e}(f)});N(m,"Core/Renderer/SVG/SVGRenderer.js",[m["Core/Color/Color.js"],m["Core/Globals.js"],m["Core/Renderer/SVG/SVGElement.js"],m["Core/Renderer/SVG/SVGLabel.js"],m["Core/Utilities.js"]],function(f,h,m,z,F){var P=
F.addEvent,K=F.attr,C=F.createElement,y=F.css,e=F.defined,I=F.destroyObjectProperties,v=F.extend,x=F.isArray,D=F.isNumber,n=F.isObject,l=F.isString,J=F.merge,w=F.objectEach,r=F.pick,d=F.pInt,g=F.splat,c=F.uniqueKey,a=h.charts,q=h.deg2rad,p=h.doc,B=h.isFirefox,A=h.isMS,G=h.isWebKit;F=h.noop;var M=h.svg,T=h.SVG_NS,Q=h.symbolSizes,O=h.win,E=function(){function u(b,k,a,c,d,g,p){this.width=this.url=this.style=this.isSVG=this.imgCount=this.height=this.gradients=this.globalAnimation=this.defs=this.chartIndex=
this.cacheKeys=this.cache=this.boxWrapper=this.box=this.alignedObjects=void 0;this.init(b,k,a,c,d,g,p)}u.prototype.init=function(b,k,a,c,d,g,q){var t=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});q||t.css(this.getStyle(c));c=t.element;b.appendChild(c);K(b,"dir","ltr");-1===b.innerHTML.indexOf("xmlns")&&K(c,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=c;this.boxWrapper=t;this.alignedObjects=[];this.url=(B||G)&&p.getElementsByTagName("base").length?O.location.href.split("#")[0].replace(/<[^>]*>/g,
"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 8.2.2"));this.defs=this.createElement("defs").add();this.allowHTML=g;this.forExport=d;this.styledMode=q;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(k,a,!1);var H;B&&b.getBoundingClientRect&&(k=function(){y(b,{left:0,top:0});H=b.getBoundingClientRect();y(b,{left:Math.ceil(H.left)-H.left+"px",top:Math.ceil(H.top)-H.top+
"px"})},k(),this.unSubPixelFix=P(O,"resize",k))};u.prototype.definition=function(b){function k(b,t){var c;g(b).forEach(function(b){var d=a.createElement(b.tagName),g={};w(b,function(b,k){"tagName"!==k&&"children"!==k&&"textContent"!==k&&(g[k]=b)});d.attr(g);d.add(t||a.defs);b.textContent&&d.element.appendChild(p.createTextNode(b.textContent));k(b.children||[],d);c=d});return c}var a=this;return k(b)};u.prototype.getStyle=function(b){return this.style=v({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
fontSize:"12px"},b)};u.prototype.setStyle=function(b){this.boxWrapper.css(this.getStyle(b))};u.prototype.isHidden=function(){return!this.boxWrapper.getBBox().width};u.prototype.destroy=function(){var b=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();I(this.gradients||{});this.gradients=null;b&&(this.defs=b.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null};u.prototype.createElement=function(b){var k=new this.Element;k.init(this,b);return k};u.prototype.getRadialAttr=
function(b,k){return{cx:b[0]-b[2]/2+k.cx*b[2],cy:b[1]-b[2]/2+k.cy*b[2],r:k.r*b[2]}};u.prototype.truncate=function(b,k,a,c,d,g,q){var t=this,H=b.rotation,R,u=c?1:0,A=(a||c).length,r=A,B=[],n=function(b){k.firstChild&&k.removeChild(k.firstChild);b&&k.appendChild(p.createTextNode(b))},l=function(g,p){p=p||g;if("undefined"===typeof B[p])if(k.getSubStringLength)try{B[p]=d+k.getSubStringLength(0,c?p+1:p)}catch(ja){""}else t.getSpanWidth&&(n(q(a||c,g)),B[p]=d+t.getSpanWidth(b,k));return B[p]},e;b.rotation=
0;var w=l(k.textContent.length);if(e=d+w>g){for(;u<=A;)r=Math.ceil((u+A)/2),c&&(R=q(c,r)),w=l(r,R&&R.length-1),u===A?u=A+1:w>g?A=r-1:u=r;0===A?n(""):a&&A===a.length-1||n(R||q(a||c,r))}c&&c.splice(0,r);b.actualWidth=w;b.rotation=H;return e};u.prototype.buildText=function(b){var k=b.element,a=this,c=a.forExport,g=r(b.textStr,"").toString(),q=-1!==g.indexOf("<"),u=k.childNodes,A,B=K(k,"x"),n=b.styles,e=b.textWidth,G=n&&n.lineHeight,f=n&&n.textOutline,V=n&&"ellipsis"===n.textOverflow,E=n&&"nowrap"===
n.whiteSpace,h=n&&n.fontSize,v,D=u.length;n=e&&!b.added&&this.box;var O=function(b){var t;a.styledMode||(t=/(px|em)$/.test(b&&b.style.fontSize)?b.style.fontSize:h||a.style.fontSize||12);return G?d(G):a.fontMetrics(t,b.getAttribute("style")?b:k).h},J=function(b,k){w(a.escapes,function(a,t){k&&-1!==k.indexOf(a)||(b=b.toString().replace(new RegExp(a,"g"),t))});return b},x=function(b,k){var a=b.indexOf("<");b=b.substring(a,b.indexOf(">")-a);a=b.indexOf(k+"=");if(-1!==a&&(a=a+k.length+1,k=b.charAt(a),
'"'===k||"'"===k))return b=b.substring(a+1),b.substring(0,b.indexOf(k))},I=/<br.*?>/g;var m=[g,V,E,G,f,h,e].join();if(m!==b.textCache){for(b.textCache=m;D--;)k.removeChild(u[D]);q||f||V||e||-1!==g.indexOf(" ")&&(!E||I.test(g))?(n&&n.appendChild(k),q?(g=a.styledMode?g.replace(/<(b|strong)>/g,'<span class="highcharts-strong">').replace(/<(i|em)>/g,'<span class="highcharts-emphasized">'):g.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">'),
g=g.replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(I)):g=[g],g=g.filter(function(b){return""!==b}),g.forEach(function(t,d){var g=0,H=0;t=t.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");var q=t.split("|||");q.forEach(function(t){if(""!==t||1===q.length){var R={},u=p.createElementNS(a.SVG_NS,"tspan"),n,r;(n=x(t,"class"))&&K(u,"class",n);if(n=x(t,"style"))n=n.replace(/(;| |^)color([ :])/,"$1fill$2"),K(u,"style",n);if((r=x(t,"href"))&&
!c&&-1===r.split(":")[0].toLowerCase().indexOf("javascript")){var l=p.createElementNS(a.SVG_NS,"a");K(l,"href",r);K(u,"class","highcharts-anchor");l.appendChild(u);a.styledMode||y(u,{cursor:"pointer"})}t=J(t.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==t){u.appendChild(p.createTextNode(t));g?R.dx=0:d&&null!==B&&(R.x=B);K(u,R);k.appendChild(l||u);!g&&v&&(!M&&c&&y(u,{display:"block"}),K(u,"dy",O(u)));if(e){var w=t.replace(/([^\^])-/g,"$1- ").split(" ");R=!E&&(1<q.length||d||1<w.length);l=0;r=
O(u);if(V)A=a.truncate(b,u,t,void 0,0,Math.max(0,e-parseInt(h||12,10)),function(b,k){return b.substring(0,k)+"\u2026"});else if(R)for(;w.length;)w.length&&!E&&0<l&&(u=p.createElementNS(T,"tspan"),K(u,{dy:r,x:B}),n&&K(u,"style",n),u.appendChild(p.createTextNode(w.join(" ").replace(/- /g,"-"))),k.appendChild(u)),a.truncate(b,u,null,w,0===l?H:0,e,function(b,k){return w.slice(0,k).join(" ").replace(/- /g,"-")}),H=b.actualWidth,l++}g++}}});v=v||k.childNodes.length}),V&&A&&b.attr("title",J(b.textStr||"",
["&lt;","&gt;"])),n&&n.removeChild(k),l(f)&&b.applyTextOutline&&b.applyTextOutline(f)):k.appendChild(p.createTextNode(J(g)))}};u.prototype.getContrast=function(b){b=f.parse(b).rgba;b[0]*=1;b[1]*=1.2;b[2]*=.5;return 459<b[0]+b[1]+b[2]?"#000000":"#FFFFFF"};u.prototype.button=function(b,k,a,c,d,g,p,q,u,n){var t=this.label(b,k,a,u,void 0,void 0,n,void 0,"button"),H=0,R=this.styledMode;b=(d=d?J(d):d)&&d.style||{};d&&d.style&&delete d.style;t.attr(J({padding:8,r:2},d));if(!R){d=J({fill:"#f7f7f7",stroke:"#cccccc",
"stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},{style:b},d);var r=d.style;delete d.style;g=J(d,{fill:"#e6e6e6"},g);var B=g.style;delete g.style;p=J(d,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},p);var l=p.style;delete p.style;q=J(d,{style:{color:"#cccccc"}},q);var e=q.style;delete q.style}P(t.element,A?"mouseover":"mouseenter",function(){3!==H&&t.setState(1)});P(t.element,A?"mouseout":"mouseleave",function(){3!==H&&t.setState(H)});t.setState=function(b){1!==
b&&(t.state=H=b);t.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][b||0]);R||t.attr([d,g,p,q][b||0]).css([r,B,l,e][b||0])};R||t.attr(d).css(v({cursor:"default"},r));return t.on("click",function(b){3!==H&&c.call(t,b)})};u.prototype.crispLine=function(b,k,a){void 0===a&&(a="round");var t=b[0],c=b[1];t[1]===c[1]&&(t[1]=c[1]=Math[a](t[1])-k%2/2);t[2]===c[2]&&(t[2]=c[2]=Math[a](t[2])+k%2/2);return b};u.prototype.path=
function(b){var k=this.styledMode?{}:{fill:"none"};x(b)?k.d=b:n(b)&&v(k,b);return this.createElement("path").attr(k)};u.prototype.circle=function(b,k,a){b=n(b)?b:"undefined"===typeof b?{}:{x:b,y:k,r:a};k=this.createElement("circle");k.xSetter=k.ySetter=function(b,k,a){a.setAttribute("c"+k,b)};return k.attr(b)};u.prototype.arc=function(b,k,a,c,d,g){n(b)?(c=b,k=c.y,a=c.r,b=c.x):c={innerR:c,start:d,end:g};b=this.symbol("arc",b,k,a,a,c);b.r=a;return b};u.prototype.rect=function(b,k,a,c,d,g){d=n(b)?b.r:
d;var t=this.createElement("rect");b=n(b)?b:"undefined"===typeof b?{}:{x:b,y:k,width:Math.max(a,0),height:Math.max(c,0)};this.styledMode||("undefined"!==typeof g&&(b.strokeWidth=g,b=t.crisp(b)),b.fill="none");d&&(b.r=d);t.rSetter=function(b,k,a){t.r=b;K(a,{rx:b,ry:b})};t.rGetter=function(){return t.r};return t.attr(b)};u.prototype.setSize=function(b,k,a){var t=this.alignedObjects,c=t.length;this.width=b;this.height=k;for(this.boxWrapper.animate({width:b,height:k},{step:function(){this.attr({viewBox:"0 0 "+
this.attr("width")+" "+this.attr("height")})},duration:r(a,!0)?void 0:0});c--;)t[c].align()};u.prototype.g=function(b){var k=this.createElement("g");return b?k.attr({"class":"highcharts-"+b}):k};u.prototype.image=function(b,k,a,c,d,g){var t={preserveAspectRatio:"none"},p=function(b,k){b.setAttributeNS?b.setAttributeNS("http://www.w3.org/1999/xlink","href",k):b.setAttribute("hc-svg-href",k)},q=function(k){p(H.element,b);g.call(H,k)};1<arguments.length&&v(t,{x:k,y:a,width:c,height:d});var H=this.createElement("image").attr(t);
g?(p(H.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),t=new O.Image,P(t,"load",q),t.src=b,t.complete&&q({})):p(H.element,b);return H};u.prototype.symbol=function(b,k,t,c,d,g){var q=this,H=/^url\((.*?)\)$/,u=H.test(b),R=!u&&(this.symbols[b]?b:"circle"),n=R&&this.symbols[R],A;if(n){"number"===typeof k&&(A=n.call(this.symbols,Math.round(k||0),Math.round(t||0),c||0,d||0,g));var B=this.path(A);q.styledMode||B.attr("fill","none");v(B,{symbolName:R,x:k,y:t,width:c,
height:d});g&&v(B,g)}else if(u){var l=b.match(H)[1];B=this.image(l);B.imgwidth=r(Q[l]&&Q[l].width,g&&g.width);B.imgheight=r(Q[l]&&Q[l].height,g&&g.height);var w=function(){B.attr({width:B.width,height:B.height})};["width","height"].forEach(function(b){B[b+"Setter"]=function(b,k){var a={},t=this["img"+k],c="width"===k?"translateX":"translateY";this[k]=b;e(t)&&(g&&"within"===g.backgroundSize&&this.width&&this.height&&(t=Math.round(t*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),this.element&&
this.element.setAttribute(k,t),this.alignByTranslate||(a[c]=((this[k]||0)-t)/2,this.attr(a)))}});e(k)&&B.attr({x:k,y:t});B.isImg=!0;e(B.imgwidth)&&e(B.imgheight)?w():(B.attr({width:0,height:0}),C("img",{onload:function(){var b=a[q.chartIndex];0===this.width&&(y(this,{position:"absolute",top:"-999em"}),p.body.appendChild(this));Q[l]={width:this.width,height:this.height};B.imgwidth=this.width;B.imgheight=this.height;B.element&&w();this.parentNode&&this.parentNode.removeChild(this);q.imgCount--;if(!q.imgCount&&
b&&!b.hasLoaded)b.onload()},src:l}),this.imgCount++)}return B};u.prototype.clipRect=function(b,k,a,d){var t=c()+"-",g=this.createElement("clipPath").attr({id:t}).add(this.defs);b=this.rect(b,k,a,d,0).add(g);b.id=t;b.clipPath=g;b.count=0;return b};u.prototype.text=function(b,k,a,c){var t={};if(c&&(this.allowHTML||!this.forExport))return this.html(b,k,a);t.x=Math.round(k||0);a&&(t.y=Math.round(a));e(b)&&(t.text=b);b=this.createElement("text").attr(t);c||(b.xSetter=function(b,k,a){var t=a.getElementsByTagName("tspan"),
c=a.getAttribute(k),d;for(d=0;d<t.length;d++){var g=t[d];g.getAttribute(k)===c&&g.setAttribute(k,b)}a.setAttribute(k,b)});return b};u.prototype.fontMetrics=function(b,k){b=!this.styledMode&&/px/.test(b)||!O.getComputedStyle?b||k&&k.style&&k.style.fontSize||this.style&&this.style.fontSize:k&&m.prototype.getStyle.call(k,"font-size");b=/px/.test(b)?d(b):12;k=24>b?b+3:Math.round(1.2*b);return{h:k,b:Math.round(.8*k),f:b}};u.prototype.rotCorr=function(b,k,a){var t=b;k&&a&&(t=Math.max(t*Math.cos(k*q),4));
return{x:-b/3*Math.sin(k*q),y:t}};u.prototype.pathToSegments=function(b){for(var k=[],a=[],c={A:8,C:7,H:2,L:3,M:3,Q:5,S:5,T:3,V:2},d=0;d<b.length;d++)l(a[0])&&D(b[d])&&a.length===c[a[0].toUpperCase()]&&b.splice(d,0,a[0].replace("M","L").replace("m","l")),"string"===typeof b[d]&&(a.length&&k.push(a.slice(0)),a.length=0),a.push(b[d]);k.push(a.slice(0));return k};u.prototype.label=function(b,k,a,c,d,g,p,q,u){return new z(this,b,k,a,c,d,g,p,q,u)};return u}();E.prototype.Element=m;E.prototype.SVG_NS=T;
E.prototype.draw=F;E.prototype.escapes={"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"};E.prototype.symbols={circle:function(a,b,k,t){return this.arc(a+k/2,b+t/2,k/2,t/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(a,b,k,t){return[["M",a,b],["L",a+k,b],["L",a+k,b+t],["L",a,b+t],["Z"]]},triangle:function(a,b,k,t){return[["M",a+k/2,b],["L",a+k,b+t],["L",a,b+t],["Z"]]},"triangle-down":function(a,b,k,t){return[["M",a,b],["L",a+k,b],["L",a+k/2,b+t],["Z"]]},diamond:function(a,
b,k,t){return[["M",a+k/2,b],["L",a+k,b+t/2],["L",a+k/2,b+t],["L",a,b+t/2],["Z"]]},arc:function(a,b,k,t,c){var d=[];if(c){var g=c.start||0,p=c.end||0,q=c.r||k;k=c.r||t||k;var H=.001>Math.abs(p-g-2*Math.PI);p-=.001;t=c.innerR;H=r(c.open,H);var u=Math.cos(g),B=Math.sin(g),n=Math.cos(p),A=Math.sin(p);g=r(c.longArc,.001>p-g-Math.PI?0:1);d.push(["M",a+q*u,b+k*B],["A",q,k,0,g,r(c.clockwise,1),a+q*n,b+k*A]);e(t)&&d.push(H?["M",a+t*n,b+t*A]:["L",a+t*n,b+t*A],["A",t,t,0,g,e(c.clockwise)?1-c.clockwise:0,a+t*
u,b+t*B]);H||d.push(["Z"])}return d},callout:function(a,b,k,t,c){var d=Math.min(c&&c.r||0,k,t),g=d+6,p=c&&c.anchorX||0;c=c&&c.anchorY||0;var q=[["M",a+d,b],["L",a+k-d,b],["C",a+k,b,a+k,b,a+k,b+d],["L",a+k,b+t-d],["C",a+k,b+t,a+k,b+t,a+k-d,b+t],["L",a+d,b+t],["C",a,b+t,a,b+t,a,b+t-d],["L",a,b+d],["C",a,b,a,b,a+d,b]];p&&p>k?c>b+g&&c<b+t-g?q.splice(3,1,["L",a+k,c-6],["L",a+k+6,c],["L",a+k,c+6],["L",a+k,b+t-d]):q.splice(3,1,["L",a+k,t/2],["L",p,c],["L",a+k,t/2],["L",a+k,b+t-d]):p&&0>p?c>b+g&&c<b+t-g?
q.splice(7,1,["L",a,c+6],["L",a-6,c],["L",a,c-6],["L",a,b+d]):q.splice(7,1,["L",a,t/2],["L",p,c],["L",a,t/2],["L",a,b+d]):c&&c>t&&p>a+g&&p<a+k-g?q.splice(5,1,["L",p+6,b+t],["L",p,b+t+6],["L",p-6,b+t],["L",a+d,b+t]):c&&0>c&&p>a+g&&p<a+k-g&&q.splice(1,1,["L",p-6,b],["L",p,b-6],["L",p+6,b],["L",k-d,b]);return q}};h.SVGRenderer=E;h.Renderer=h.SVGRenderer;return h.Renderer});N(m,"Core/Renderer/HTML/HTMLElement.js",[m["Core/Globals.js"],m["Core/Renderer/SVG/SVGElement.js"],m["Core/Utilities.js"]],function(f,
h,m){var z=m.css,F=m.defined,P=m.extend,K=m.pick,C=m.pInt,y=f.isFirefox;P(h.prototype,{htmlCss:function(e){var f="SPAN"===this.element.tagName&&e&&"width"in e,h=K(f&&e.width,void 0);if(f){delete e.width;this.textWidth=h;var x=!0}e&&"ellipsis"===e.textOverflow&&(e.whiteSpace="nowrap",e.overflow="hidden");this.styles=P(this.styles,e);z(this.element,e);x&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var e=this.element;return{x:e.offsetLeft,y:e.offsetTop,width:e.offsetWidth,height:e.offsetHeight}},
htmlUpdateTransform:function(){if(this.added){var e=this.renderer,f=this.element,h=this.translateX||0,x=this.translateY||0,D=this.x||0,n=this.y||0,l=this.textAlign||"left",J={left:0,center:.5,right:1}[l],w=this.styles,r=w&&w.whiteSpace;z(f,{marginLeft:h,marginTop:x});!e.styledMode&&this.shadows&&this.shadows.forEach(function(a){z(a,{marginLeft:h+1,marginTop:x+1})});this.inverted&&[].forEach.call(f.childNodes,function(a){e.invertChild(a,f)});if("SPAN"===f.tagName){w=this.rotation;var d=this.textWidth&&
C(this.textWidth),g=[w,l,f.innerHTML,this.textWidth,this.textAlign].join(),c;(c=d!==this.oldTextWidth)&&!(c=d>this.oldTextWidth)&&((c=this.textPxLength)||(z(f,{width:"",whiteSpace:r||"nowrap"}),c=f.offsetWidth),c=c>d);c&&(/[ \-]/.test(f.textContent||f.innerText)||"ellipsis"===f.style.textOverflow)?(z(f,{width:d+"px",display:"block",whiteSpace:r||"normal"}),this.oldTextWidth=d,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;g!==this.cTT&&(r=e.fontMetrics(f.style.fontSize,f).b,!F(w)||w===(this.oldRotation||
0)&&l===this.oldAlign||this.setSpanRotation(w,J,r),this.getSpanCorrection(!F(w)&&this.textPxLength||f.offsetWidth,r,J,w,l));z(f,{left:D+(this.xCorr||0)+"px",top:n+(this.yCorr||0)+"px"});this.cTT=g;this.oldRotation=w;this.oldAlign=l}}else this.alignOnAdd=!0},setSpanRotation:function(e,f,h){var v={},D=this.renderer.getTransformKey();v[D]=v.transform="rotate("+e+"deg)";v[D+(y?"Origin":"-origin")]=v.transformOrigin=100*f+"% "+h+"px";z(this.element,v)},getSpanCorrection:function(e,f,h){this.xCorr=-e*h;
this.yCorr=-f}});return h});N(m,"Core/Renderer/HTML/HTMLRenderer.js",[m["Core/Globals.js"],m["Core/Renderer/SVG/SVGElement.js"],m["Core/Renderer/SVG/SVGRenderer.js"],m["Core/Utilities.js"]],function(f,h,m,z){var F=f.isFirefox,P=f.isMS,K=f.isWebKit,C=f.win,y=z.attr,e=z.createElement,I=z.extend,v=z.pick;I(m.prototype,{getTransformKey:function(){return P&&!/Edge/.test(C.navigator.userAgent)?"-ms-transform":K?"-webkit-transform":F?"MozTransform":C.opera?"-o-transform":""},html:function(f,D,n){var l=this.createElement("span"),
J=l.element,w=l.renderer,r=w.isSVG,d=function(d,c){["opacity","visibility"].forEach(function(a){d[a+"Setter"]=function(g,p,B){var q=d.div?d.div.style:c;h.prototype[a+"Setter"].call(this,g,p,B);q&&(q[p]=g)}});d.addedSetters=!0};l.textSetter=function(d){d!==J.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=d;J.innerHTML=v(d,"");l.doTransform=!0};r&&d(l,l.element.style);l.xSetter=l.ySetter=l.alignSetter=l.rotationSetter=function(d,c){"align"===c?l.alignValue=l.textAlign=d:l[c]=d;
l.doTransform=!0};l.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};l.attr({text:f,x:Math.round(D),y:Math.round(n)}).css({position:"absolute"});w.styledMode||l.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});J.style.whiteSpace="nowrap";l.css=l.htmlCss;r&&(l.add=function(g){var c=w.box.parentNode,a=[];if(this.parentGroup=g){var q=g.div;if(!q){for(;g;)a.push(g),g=g.parentGroup;a.reverse().forEach(function(g){function p(a,c){g[c]=a;"translateX"===
c?r.left=a+"px":r.top=a+"px";g.doTransform=!0}var n=y(g.element,"class");q=g.div=g.div||e("div",n?{className:n}:void 0,{position:"absolute",left:(g.translateX||0)+"px",top:(g.translateY||0)+"px",display:g.display,opacity:g.opacity,pointerEvents:g.styles&&g.styles.pointerEvents},q||c);var r=q.style;I(g,{classSetter:function(a){return function(c){this.element.setAttribute("class",c);a.className=c}}(q),on:function(){a[0].div&&l.on.apply({element:a[0].div},arguments);return g},translateXSetter:p,translateYSetter:p});
g.addedSetters||d(g)})}}else q=c;q.appendChild(J);l.added=!0;l.alignOnAdd&&l.htmlUpdateTransform();return l});return l}});return m});N(m,"Core/Axis/Tick.js",[m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h){var m=h.clamp,z=h.correctFloat,F=h.defined,L=h.destroyObjectProperties,K=h.extend,C=h.fireEvent,y=h.isNumber,e=h.merge,I=h.objectEach,v=h.pick,x=f.deg2rad;h=function(){function f(n,l,e,w,r){this.isNewLabel=this.isNew=!0;this.axis=n;this.pos=l;this.type=e||"";this.parameters=r||{};this.tickmarkOffset=
this.parameters.tickmarkOffset;this.options=this.parameters.options;C(this,"init");e||w||this.addLabel()}f.prototype.addLabel=function(){var n=this,l=n.axis,e=l.options,w=l.chart,r=l.categories,d=l.logarithmic,g=l.names,c=n.pos,a=v(n.options&&n.options.labels,e.labels),q=l.tickPositions,p=c===q[0],B=c===q[q.length-1];g=this.parameters.category||(r?v(r[c],g[c],c):c);var A=n.label;r=(!a.step||1===a.step)&&1===l.tickInterval;q=q.info;var f,h;if(l.dateTime&&q){var D=w.time.resolveDTLFormat(e.dateTimeLabelFormats[!e.grid&&
q.higherRanks[c]||q.unitName]);var x=D.main}n.isFirst=p;n.isLast=B;n.formatCtx={axis:l,chart:w,isFirst:p,isLast:B,dateTimeLabelFormat:x,tickPositionInfo:q,value:d?z(d.lin2log(g)):g,pos:c};e=l.labelFormatter.call(n.formatCtx,this.formatCtx);if(h=D&&D.list)n.shortenLabel=function(){for(f=0;f<h.length;f++)if(A.attr({text:l.labelFormatter.call(K(n.formatCtx,{dateTimeLabelFormat:h[f]}))}),A.getBBox().width<l.getSlotWidth(n)-2*v(a.padding,5))return;A.attr({text:""})};r&&l._addedPlotLB&&n.moveLabel(e,a);
F(A)||n.movedLabel?A&&A.textStr!==e&&!r&&(!A.textWidth||a.style&&a.style.width||A.styles.width||A.css({width:null}),A.attr({text:e}),A.textPxLength=A.getBBox().width):(n.label=A=n.createLabel({x:0,y:0},e,a),n.rotation=0)};f.prototype.createLabel=function(n,l,f){var w=this.axis,r=w.chart;if(n=F(l)&&f.enabled?r.renderer.text(l,n.x,n.y,f.useHTML).add(w.labelGroup):null)r.styledMode||n.css(e(f.style)),n.textPxLength=n.getBBox().width;return n};f.prototype.destroy=function(){L(this,this.axis)};f.prototype.getPosition=
function(n,l,e,w){var r=this.axis,d=r.chart,g=w&&d.oldChartHeight||d.chartHeight;n={x:n?z(r.translate(l+e,null,null,w)+r.transB):r.left+r.offset+(r.opposite?(w&&d.oldChartWidth||d.chartWidth)-r.right-r.left:0),y:n?g-r.bottom+r.offset-(r.opposite?r.height:0):z(g-r.translate(l+e,null,null,w)-r.transB)};n.y=m(n.y,-1E5,1E5);C(this,"afterGetPosition",{pos:n});return n};f.prototype.getLabelPosition=function(n,l,e,w,r,d,g,c){var a=this.axis,q=a.transA,p=a.isLinked&&a.linkedParent?a.linkedParent.reversed:
a.reversed,B=a.staggerLines,A=a.tickRotCorr||{x:0,y:0},f=r.y,h=w||a.reserveSpaceDefault?0:-a.labelOffset*("center"===a.labelAlign?.5:1),v={};F(f)||(f=0===a.side?e.rotation?-8:-e.getBBox().height:2===a.side?A.y+8:Math.cos(e.rotation*x)*(A.y-e.getBBox(!1,0).height/2));n=n+r.x+h+A.x-(d&&w?d*q*(p?-1:1):0);l=l+f-(d&&!w?d*q*(p?1:-1):0);B&&(e=g/(c||1)%B,a.opposite&&(e=B-e-1),l+=a.labelOffset/B*e);v.x=n;v.y=Math.round(l);C(this,"afterGetLabelPosition",{pos:v,tickmarkOffset:d,index:g});return v};f.prototype.getLabelSize=
function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0};f.prototype.getMarkPath=function(n,e,f,w,r,d){return d.crispLine([["M",n,e],["L",n+(r?0:-f),e+(r?f:0)]],w)};f.prototype.handleOverflow=function(n){var e=this.axis,f=e.options.labels,w=n.x,r=e.chart.chartWidth,d=e.chart.spacing,g=v(e.labelLeft,Math.min(e.pos,d[3]));d=v(e.labelRight,Math.max(e.isRadial?0:e.pos+e.len,r-d[1]));var c=this.label,a=this.rotation,q={left:0,center:.5,right:1}[e.labelAlign||c.attr("align")],
p=c.getBBox().width,B=e.getSlotWidth(this),A=B,G=1,h,D={};if(a||"justify"!==v(f.overflow,"justify"))0>a&&w-q*p<g?h=Math.round(w/Math.cos(a*x)-g):0<a&&w+q*p>d&&(h=Math.round((r-w)/Math.cos(a*x)));else if(r=w+(1-q)*p,w-q*p<g?A=n.x+A*(1-q)-g:r>d&&(A=d-n.x+A*q,G=-1),A=Math.min(B,A),A<B&&"center"===e.labelAlign&&(n.x+=G*(B-A-q*(B-Math.min(p,A)))),p>A||e.autoRotation&&(c.styles||{}).width)h=A;h&&(this.shortenLabel?this.shortenLabel():(D.width=Math.floor(h)+"px",(f.style||{}).textOverflow||(D.textOverflow=
"ellipsis"),c.css(D)))};f.prototype.moveLabel=function(n,e){var l=this,w=l.label,r=!1,d=l.axis,g=d.reversed;w&&w.textStr===n?(l.movedLabel=w,r=!0,delete l.label):I(d.ticks,function(a){r||a.isNew||a===l||!a.label||a.label.textStr!==n||(l.movedLabel=a.label,r=!0,a.labelPos=l.movedLabel.xy,delete a.label)});if(!r&&(l.labelPos||w)){var c=l.labelPos||w.xy;w=d.horiz?g?0:d.width+d.left:c.x;d=d.horiz?c.y:g?d.width+d.left:0;l.movedLabel=l.createLabel({x:w,y:d},n,e);l.movedLabel&&l.movedLabel.attr({opacity:0})}};
f.prototype.render=function(e,l,f){var n=this.axis,r=n.horiz,d=this.pos,g=v(this.tickmarkOffset,n.tickmarkOffset);d=this.getPosition(r,d,g,l);g=d.x;var c=d.y;n=r&&g===n.pos+n.len||!r&&c===n.pos?-1:1;f=v(f,1);this.isActive=!0;this.renderGridLine(l,f,n);this.renderMark(d,f,n);this.renderLabel(d,l,f,e);this.isNew=!1;C(this,"afterRender")};f.prototype.renderGridLine=function(n,e,f){var l=this.axis,r=l.options,d=this.gridLine,g={},c=this.pos,a=this.type,q=v(this.tickmarkOffset,l.tickmarkOffset),p=l.chart.renderer,
B=a?a+"Grid":"grid",A=r[B+"LineWidth"],G=r[B+"LineColor"];r=r[B+"LineDashStyle"];d||(l.chart.styledMode||(g.stroke=G,g["stroke-width"]=A,r&&(g.dashstyle=r)),a||(g.zIndex=1),n&&(e=0),this.gridLine=d=p.path().attr(g).addClass("highcharts-"+(a?a+"-":"")+"grid-line").add(l.gridGroup));if(d&&(f=l.getPlotLinePath({value:c+q,lineWidth:d.strokeWidth()*f,force:"pass",old:n})))d[n||this.isNew?"attr":"animate"]({d:f,opacity:e})};f.prototype.renderMark=function(n,e,f){var l=this.axis,r=l.options,d=l.chart.renderer,
g=this.type,c=g?g+"Tick":"tick",a=l.tickSize(c),q=this.mark,p=!q,B=n.x;n=n.y;var A=v(r[c+"Width"],!g&&l.isXAxis?1:0);r=r[c+"Color"];a&&(l.opposite&&(a[0]=-a[0]),p&&(this.mark=q=d.path().addClass("highcharts-"+(g?g+"-":"")+"tick").add(l.axisGroup),l.chart.styledMode||q.attr({stroke:r,"stroke-width":A})),q[p?"attr":"animate"]({d:this.getMarkPath(B,n,a[0],q.strokeWidth()*f,l.horiz,d),opacity:e}))};f.prototype.renderLabel=function(e,l,f,w){var n=this.axis,d=n.horiz,g=n.options,c=this.label,a=g.labels,
q=a.step;n=v(this.tickmarkOffset,n.tickmarkOffset);var p=!0,B=e.x;e=e.y;c&&y(B)&&(c.xy=e=this.getLabelPosition(B,e,c,d,a,n,w,q),this.isFirst&&!this.isLast&&!v(g.showFirstLabel,1)||this.isLast&&!this.isFirst&&!v(g.showLastLabel,1)?p=!1:!d||a.step||a.rotation||l||0===f||this.handleOverflow(e),q&&w%q&&(p=!1),p&&y(e.y)?(e.opacity=f,c[this.isNewLabel?"attr":"animate"](e),this.isNewLabel=!1):(c.attr("y",-9999),this.isNewLabel=!0))};f.prototype.replaceMovedLabel=function(){var e=this.label,l=this.axis,f=
l.reversed;if(e&&!this.isNew){var w=l.horiz?f?l.left:l.width+l.left:e.xy.x;f=l.horiz?e.xy.y:f?l.width+l.top:l.top;e.animate({x:w,y:f,opacity:0},void 0,e.destroy);delete this.label}l.isDirty=!0;this.label=this.movedLabel;delete this.movedLabel};return f}();f.Tick=h;return f.Tick});N(m,"Core/Time.js",[m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h){var m=h.defined,z=h.error,F=h.extend,L=h.isObject,K=h.merge,C=h.objectEach,y=h.pad,e=h.pick,I=h.splat,v=h.timeUnits,x=f.win;h=function(){function h(e){this.options=
{};this.variableTimezone=this.useUTC=!1;this.Date=x.Date;this.getTimezoneOffset=this.timezoneOffsetFunction();this.update(e)}h.prototype.get=function(e,l){if(this.variableTimezone||this.timezoneOffset){var n=l.getTime(),f=n-this.getTimezoneOffset(l);l.setTime(f);e=l["getUTC"+e]();l.setTime(n);return e}return this.useUTC?l["getUTC"+e]():l["get"+e]()};h.prototype.set=function(e,l,f){if(this.variableTimezone||this.timezoneOffset){if("Milliseconds"===e||"Seconds"===e||"Minutes"===e)return l["setUTC"+
e](f);var n=this.getTimezoneOffset(l);n=l.getTime()-n;l.setTime(n);l["setUTC"+e](f);e=this.getTimezoneOffset(l);n=l.getTime()+e;return l.setTime(n)}return this.useUTC?l["setUTC"+e](f):l["set"+e](f)};h.prototype.update=function(n){var l=e(n&&n.useUTC,!0);this.options=n=K(!0,this.options||{},n);this.Date=n.Date||x.Date||Date;this.timezoneOffset=(this.useUTC=l)&&n.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();this.variableTimezone=!(l&&!n.getTimezoneOffset&&!n.timezone)};h.prototype.makeTime=
function(n,l,h,w,r,d){if(this.useUTC){var g=this.Date.UTC.apply(0,arguments);var c=this.getTimezoneOffset(g);g+=c;var a=this.getTimezoneOffset(g);c!==a?g+=a-c:c-36E5!==this.getTimezoneOffset(g-36E5)||f.isSafari||(g-=36E5)}else g=(new this.Date(n,l,e(h,1),e(w,0),e(r,0),e(d,0))).getTime();return g};h.prototype.timezoneOffsetFunction=function(){var e=this,l=this.options,f=l.moment||x.moment;if(!this.useUTC)return function(e){return 6E4*(new Date(e.toString())).getTimezoneOffset()};if(l.timezone){if(f)return function(e){return 6E4*
-f.tz(e,l.timezone).utcOffset()};z(25)}return this.useUTC&&l.getTimezoneOffset?function(e){return 6E4*l.getTimezoneOffset(e.valueOf())}:function(){return 6E4*(e.timezoneOffset||0)}};h.prototype.dateFormat=function(n,l,h){var w;if(!m(l)||isNaN(l))return(null===(w=f.defaultOptions.lang)||void 0===w?void 0:w.invalidDate)||"";n=e(n,"%Y-%m-%d %H:%M:%S");var r=this;w=new this.Date(l);var d=this.get("Hours",w),g=this.get("Day",w),c=this.get("Date",w),a=this.get("Month",w),q=this.get("FullYear",w),p=f.defaultOptions.lang,
B=null===p||void 0===p?void 0:p.weekdays,A=null===p||void 0===p?void 0:p.shortWeekdays;w=F({a:A?A[g]:B[g].substr(0,3),A:B[g],d:y(c),e:y(c,2," "),w:g,b:p.shortMonths[a],B:p.months[a],m:y(a+1),o:a+1,y:q.toString().substr(2,2),Y:q,H:y(d),k:d,I:y(d%12||12),l:d%12||12,M:y(this.get("Minutes",w)),p:12>d?"AM":"PM",P:12>d?"am":"pm",S:y(w.getSeconds()),L:y(Math.floor(l%1E3),3)},f.dateFormats);C(w,function(a,c){for(;-1!==n.indexOf("%"+c);)n=n.replace("%"+c,"function"===typeof a?a.call(r,l):a)});return h?n.substr(0,
1).toUpperCase()+n.substr(1):n};h.prototype.resolveDTLFormat=function(e){return L(e,!0)?e:(e=I(e),{main:e[0],from:e[1],to:e[2]})};h.prototype.getTimeTicks=function(n,l,f,h){var r=this,d=[],g={};var c=new r.Date(l);var a=n.unitRange,q=n.count||1,p;h=e(h,1);if(m(l)){r.set("Milliseconds",c,a>=v.second?0:q*Math.floor(r.get("Milliseconds",c)/q));a>=v.second&&r.set("Seconds",c,a>=v.minute?0:q*Math.floor(r.get("Seconds",c)/q));a>=v.minute&&r.set("Minutes",c,a>=v.hour?0:q*Math.floor(r.get("Minutes",c)/q));
a>=v.hour&&r.set("Hours",c,a>=v.day?0:q*Math.floor(r.get("Hours",c)/q));a>=v.day&&r.set("Date",c,a>=v.month?1:Math.max(1,q*Math.floor(r.get("Date",c)/q)));if(a>=v.month){r.set("Month",c,a>=v.year?0:q*Math.floor(r.get("Month",c)/q));var B=r.get("FullYear",c)}a>=v.year&&r.set("FullYear",c,B-B%q);a===v.week&&(B=r.get("Day",c),r.set("Date",c,r.get("Date",c)-B+h+(B<h?-7:0)));B=r.get("FullYear",c);h=r.get("Month",c);var A=r.get("Date",c),w=r.get("Hours",c);l=c.getTime();r.variableTimezone&&(p=f-l>4*v.month||
r.getTimezoneOffset(l)!==r.getTimezoneOffset(f));l=c.getTime();for(c=1;l<f;)d.push(l),l=a===v.year?r.makeTime(B+c*q,0):a===v.month?r.makeTime(B,h+c*q):!p||a!==v.day&&a!==v.week?p&&a===v.hour&&1<q?r.makeTime(B,h,A,w+c*q):l+a*q:r.makeTime(B,h,A+c*q*(a===v.day?1:7)),c++;d.push(l);a<=v.hour&&1E4>d.length&&d.forEach(function(a){0===a%18E5&&"000000000"===r.dateFormat("%H%M%S%L",a)&&(g[a]="day")})}d.info=F(n,{higherRanks:g,totalRange:a*q});return d};return h}();f.Time=h;return f.Time});N(m,"Core/Options.js",
[m["Core/Globals.js"],m["Core/Color/Color.js"],m["Core/Time.js"],m["Core/Utilities.js"]],function(f,h,m,z){var F=f.isTouchDevice,P=f.svg;h=h.parse;z=z.merge;"";f.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:{Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0},chart:{styledMode:!1,borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,
height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},caption:{margin:15,text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",
inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,
textAlign:"center"}},tooltip:{enabled:!0,animation:P,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:F?25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:h("#f7f7f7").setOpacity(.85).get(),
borderWidth:1,shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};"";f.time=new m(z(f.defaultOptions.global,f.defaultOptions.time));f.dateFormat=function(h,m,y){return f.time.dateFormat(h,m,y)};return{dateFormat:f.dateFormat,defaultOptions:f.defaultOptions,time:f.time}});
N(m,"Core/Axis/Axis.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Color/Color.js"],m["Core/Globals.js"],m["Core/Axis/Tick.js"],m["Core/Utilities.js"],m["Core/Options.js"]],function(f,h,m,z,F,L){var K=f.animObject,C=F.addEvent,y=F.arrayMax,e=F.arrayMin,I=F.clamp,v=F.correctFloat,x=F.defined,D=F.destroyObjectProperties,n=F.error,l=F.extend,J=F.fireEvent,w=F.format,r=F.getMagnitude,d=F.isArray,g=F.isFunction,c=F.isNumber,a=F.isString,q=F.merge,p=F.normalizeTickInterval,B=F.objectEach,A=F.pick,
G=F.relativeLength,M=F.removeEvent,T=F.splat,Q=F.syncTimeout,O=L.defaultOptions,E=m.deg2rad;f=function(){function u(b,k){this.zoomEnabled=this.width=this.visible=this.userOptions=this.translationSlope=this.transB=this.transA=this.top=this.ticks=this.tickRotCorr=this.tickPositions=this.tickmarkOffset=this.tickInterval=this.tickAmount=this.side=this.series=this.right=this.positiveValuesOnly=this.pos=this.pointRangePadding=this.pointRange=this.plotLinesAndBandsGroups=this.plotLinesAndBands=this.paddedTicks=
this.overlap=this.options=this.oldMin=this.oldMax=this.offset=this.names=this.minPixelPadding=this.minorTicks=this.minorTickInterval=this.min=this.maxLabelLength=this.max=this.len=this.left=this.labelFormatter=this.labelEdge=this.isLinked=this.height=this.hasVisibleSeries=this.hasNames=this.coll=this.closestPointRange=this.chart=this.categories=this.bottom=this.alternateBands=void 0;this.init(b,k)}u.prototype.init=function(b,k){var a=k.isX,c=this;c.chart=b;c.horiz=b.inverted&&!c.isZAxis?!a:a;c.isXAxis=
a;c.coll=c.coll||(a?"xAxis":"yAxis");J(this,"init",{userOptions:k});c.opposite=k.opposite;c.side=k.side||(c.horiz?c.opposite?0:2:c.opposite?1:3);c.setOptions(k);var d=this.options,p=d.type;c.labelFormatter=d.labels.formatter||c.defaultLabelFormatter;c.userOptions=k;c.minPixelPadding=0;c.reversed=d.reversed;c.visible=!1!==d.visible;c.zoomEnabled=!1!==d.zoomEnabled;c.hasNames="category"===p||!0===d.categories;c.categories=d.categories||c.hasNames;c.names||(c.names=[],c.names.keys={});c.plotLinesAndBandsGroups=
{};c.positiveValuesOnly=!!c.logarithmic;c.isLinked=x(d.linkedTo);c.ticks={};c.labelEdge=[];c.minorTicks={};c.plotLinesAndBands=[];c.alternateBands={};c.len=0;c.minRange=c.userMinRange=d.minRange||d.maxZoom;c.range=d.range;c.offset=d.offset||0;c.max=null;c.min=null;c.crosshair=A(d.crosshair,T(b.options.tooltip.crosshairs)[a?0:1],!1);k=c.options.events;-1===b.axes.indexOf(c)&&(a?b.axes.splice(b.xAxis.length,0,c):b.axes.push(c),b[c.coll].push(c));c.series=c.series||[];b.inverted&&!c.isZAxis&&a&&"undefined"===
typeof c.reversed&&(c.reversed=!0);c.labelRotation=c.options.labels.rotation;B(k,function(b,k){g(b)&&C(c,k,b)});J(this,"afterInit")};u.prototype.setOptions=function(b){this.options=q(u.defaultOptions,"yAxis"===this.coll&&u.defaultYAxisOptions,[u.defaultTopAxisOptions,u.defaultRightAxisOptions,u.defaultBottomAxisOptions,u.defaultLeftAxisOptions][this.side],q(O[this.coll],b));J(this,"afterSetOptions",{userOptions:b})};u.prototype.defaultLabelFormatter=function(){var b=this.axis,k=c(this.value)?this.value:
NaN,a=b.chart.time,d=b.categories,g=this.dateTimeLabelFormat,p=O.lang,q=p.numericSymbols;p=p.numericSymbolMagnitude||1E3;var e=q&&q.length,u=b.options.labels.format;b=b.logarithmic?Math.abs(k):b.tickInterval;var B=this.chart,l=B.numberFormatter;if(u)var A=w(u,this,B);else if(d)A=""+this.value;else if(g)A=a.dateFormat(g,k);else if(e&&1E3<=b)for(;e--&&"undefined"===typeof A;)a=Math.pow(p,e+1),b>=a&&0===10*k%a&&null!==q[e]&&0!==k&&(A=l(k/a,-1)+q[e]);"undefined"===typeof A&&(A=1E4<=Math.abs(k)?l(k,-1):
l(k,-1,void 0,""));return A};u.prototype.getSeriesExtremes=function(){var b=this,k=b.chart,a;J(this,"getSeriesExtremes",null,function(){b.hasVisibleSeries=!1;b.dataMin=b.dataMax=b.threshold=null;b.softThreshold=!b.isXAxis;b.stacking&&b.stacking.buildStacks();b.series.forEach(function(t){if(t.visible||!k.options.chart.ignoreHiddenSeries){var d=t.options,g=d.threshold;b.hasVisibleSeries=!0;b.positiveValuesOnly&&0>=g&&(g=null);if(b.isXAxis){if(d=t.xData,d.length){d=b.logarithmic?d.filter(b.validatePositiveValue):
d;a=t.getXExtremes(d);var p=a.min;var q=a.max;c(p)||p instanceof Date||(d=d.filter(c),a=t.getXExtremes(d),p=a.min,q=a.max);d.length&&(b.dataMin=Math.min(A(b.dataMin,p),p),b.dataMax=Math.max(A(b.dataMax,q),q))}}else if(t=t.applyExtremes(),c(t.dataMin)&&(p=t.dataMin,b.dataMin=Math.min(A(b.dataMin,p),p)),c(t.dataMax)&&(q=t.dataMax,b.dataMax=Math.max(A(b.dataMax,q),q)),x(g)&&(b.threshold=g),!d.softThreshold||b.positiveValuesOnly)b.softThreshold=!1}})});J(this,"afterGetSeriesExtremes")};u.prototype.translate=
function(b,a,t,d,g,p){var k=this.linkedParent||this,q=1,e=0,H=d?k.oldTransA:k.transA;d=d?k.oldMin:k.min;var u=k.minPixelPadding;g=(k.isOrdinal||k.brokenAxis&&k.brokenAxis.hasBreaks||k.logarithmic&&g)&&k.lin2val;H||(H=k.transA);t&&(q*=-1,e=k.len);k.reversed&&(q*=-1,e-=q*(k.sector||k.len));a?(b=(b*q+e-u)/H+d,g&&(b=k.lin2val(b))):(g&&(b=k.val2lin(b)),b=c(d)?q*(b-d)*H+e+q*u+(c(p)?H*p:0):void 0);return b};u.prototype.toPixels=function(b,k){return this.translate(b,!1,!this.horiz,null,!0)+(k?0:this.pos)};
u.prototype.toValue=function(b,k){return this.translate(b-(k?0:this.pos),!0,!this.horiz,null,!0)};u.prototype.getPlotLinePath=function(b){function k(b,a,k){if("pass"!==l&&b<a||b>k)l?b=I(b,a,k):E=!0;return b}var a=this,d=a.chart,g=a.left,p=a.top,q=b.old,e=b.value,u=b.translatedValue,B=b.lineWidth,l=b.force,r,n,f,h,w=q&&d.oldChartHeight||d.chartHeight,G=q&&d.oldChartWidth||d.chartWidth,E,v=a.transB;b={value:e,lineWidth:B,old:q,force:l,acrossPanes:b.acrossPanes,translatedValue:u};J(this,"getPlotLinePath",
b,function(b){u=A(u,a.translate(e,null,null,q));u=I(u,-1E5,1E5);r=f=Math.round(u+v);n=h=Math.round(w-u-v);c(u)?a.horiz?(n=p,h=w-a.bottom,r=f=k(r,g,g+a.width)):(r=g,f=G-a.right,n=h=k(n,p,p+a.height)):(E=!0,l=!1);b.path=E&&!l?null:d.renderer.crispLine([["M",r,n],["L",f,h]],B||1)});return b.path};u.prototype.getLinearTickPositions=function(b,a,c){var k=v(Math.floor(a/b)*b);c=v(Math.ceil(c/b)*b);var t=[],d;v(k+b)===k&&(d=20);if(this.single)return[a];for(a=k;a<=c;){t.push(a);a=v(a+b,d);if(a===g)break;
var g=a}return t};u.prototype.getMinorTickInterval=function(){var b=this.options;return!0===b.minorTicks?A(b.minorTickInterval,"auto"):!1===b.minorTicks?null:b.minorTickInterval};u.prototype.getMinorTickPositions=function(){var b=this.options,a=this.tickPositions,c=this.minorTickInterval,d=[],g=this.pointRangePadding||0,p=this.min-g;g=this.max+g;var q=g-p;if(q&&q/c<this.len/3){var e=this.logarithmic;if(e)this.paddedTicks.forEach(function(b,a,k){a&&d.push.apply(d,e.getLogTickPositions(c,k[a-1],k[a],
!0))});else if(this.dateTime&&"auto"===this.getMinorTickInterval())d=d.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(c),p,g,b.startOfWeek));else for(b=p+(a[0]-p)%c;b<=g&&b!==d[0];b+=c)d.push(b)}0!==d.length&&this.trimTicks(d);return d};u.prototype.adjustForMinRange=function(){var b=this.options,a=this.min,c=this.max,d=this.logarithmic,g,p,q,u,B;this.isXAxis&&"undefined"===typeof this.minRange&&!d&&(x(b.min)||x(b.max)?this.minRange=null:(this.series.forEach(function(b){u=b.xData;
for(p=B=b.xIncrement?1:u.length-1;0<p;p--)if(q=u[p]-u[p-1],"undefined"===typeof g||q<g)g=q}),this.minRange=Math.min(5*g,this.dataMax-this.dataMin)));if(c-a<this.minRange){var l=this.dataMax-this.dataMin>=this.minRange;var r=this.minRange;var n=(r-c+a)/2;n=[a-n,A(b.min,a-n)];l&&(n[2]=this.logarithmic?this.logarithmic.log2lin(this.dataMin):this.dataMin);a=y(n);c=[a+r,A(b.max,a+r)];l&&(c[2]=d?d.log2lin(this.dataMax):this.dataMax);c=e(c);c-a<r&&(n[0]=c-r,n[1]=A(b.min,c-r),a=y(n))}this.min=a;this.max=
c};u.prototype.getClosest=function(){var b;this.categories?b=1:this.series.forEach(function(a){var k=a.closestPointRange,c=a.visible||!a.chart.options.chart.ignoreHiddenSeries;!a.noSharedTooltip&&x(k)&&c&&(b=x(b)?Math.min(b,k):k)});return b};u.prototype.nameToX=function(b){var a=d(this.categories),c=a?this.categories:this.names,g=b.options.x;b.series.requireSorting=!1;x(g)||(g=!1===this.options.uniqueNames?b.series.autoIncrement():a?c.indexOf(b.name):A(c.keys[b.name],-1));if(-1===g){if(!a)var p=c.length}else p=
g;"undefined"!==typeof p&&(this.names[p]=b.name,this.names.keys[b.name]=p);return p};u.prototype.updateNames=function(){var b=this,a=this.names;0<a.length&&(Object.keys(a.keys).forEach(function(b){delete a.keys[b]}),a.length=0,this.minRange=this.userMinRange,(this.series||[]).forEach(function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)b.max=Math.max(b.max,a.xData.length-1),a.processData(),a.generatePoints();a.data.forEach(function(k,c){if(k&&k.options&&"undefined"!==typeof k.name){var d=b.nameToX(k);
"undefined"!==typeof d&&d!==k.x&&(k.x=d,a.xData[c]=d)}})}))};u.prototype.setAxisTranslation=function(b){var k=this,c=k.max-k.min,d=k.axisPointRange||0,g=0,p=0,q=k.linkedParent,e=!!k.categories,u=k.transA,B=k.isXAxis;if(B||e||d){var l=k.getClosest();q?(g=q.minPointOffset,p=q.pointRangePadding):k.series.forEach(function(b){var c=e?1:B?A(b.options.pointRange,l,0):k.axisPointRange||0,t=b.options.pointPlacement;d=Math.max(d,c);if(!k.single||e)b=b.is("xrange")?!B:B,g=Math.max(g,b&&a(t)?0:c/2),p=Math.max(p,
b&&"on"===t?0:c)});q=k.ordinal&&k.ordinal.slope&&l?k.ordinal.slope/l:1;k.minPointOffset=g*=q;k.pointRangePadding=p*=q;k.pointRange=Math.min(d,k.single&&e?1:c);B&&(k.closestPointRange=l)}b&&(k.oldTransA=u);k.translationSlope=k.transA=u=k.staticScale||k.len/(c+p||1);k.transB=k.horiz?k.left:k.bottom;k.minPixelPadding=u*g;J(this,"afterSetAxisTranslation")};u.prototype.minFromRange=function(){return this.max-this.range};u.prototype.setTickInterval=function(b){var a=this,d=a.chart,g=a.logarithmic,q=a.options,
e=a.isXAxis,u=a.isLinked,B=q.maxPadding,l=q.minPadding,f=q.tickInterval,h=q.tickPixelInterval,w=a.categories,G=c(a.threshold)?a.threshold:null,E=a.softThreshold;a.dateTime||w||u||this.getTickAmount();var O=A(a.userMin,q.min);var D=A(a.userMax,q.max);if(u){a.linkedParent=d[a.coll][q.linkedTo];var M=a.linkedParent.getExtremes();a.min=A(M.min,M.dataMin);a.max=A(M.max,M.dataMax);q.type!==a.linkedParent.options.type&&n(11,1,d)}else{if(E&&x(G))if(a.dataMin>=G)M=G,l=0;else if(a.dataMax<=G){var m=G;B=0}a.min=
A(O,M,a.dataMin);a.max=A(D,m,a.dataMax)}g&&(a.positiveValuesOnly&&!b&&0>=Math.min(a.min,A(a.dataMin,a.min))&&n(10,1,d),a.min=v(g.log2lin(a.min),16),a.max=v(g.log2lin(a.max),16));a.range&&x(a.max)&&(a.userMin=a.min=O=Math.max(a.dataMin,a.minFromRange()),a.userMax=D=a.max,a.range=null);J(a,"foundExtremes");a.beforePadding&&a.beforePadding();a.adjustForMinRange();!(w||a.axisPointRange||a.stacking&&a.stacking.usePercentage||u)&&x(a.min)&&x(a.max)&&(d=a.max-a.min)&&(!x(O)&&l&&(a.min-=d*l),!x(D)&&B&&(a.max+=
d*B));c(a.userMin)||(c(q.softMin)&&q.softMin<a.min&&(a.min=O=q.softMin),c(q.floor)&&(a.min=Math.max(a.min,q.floor)));c(a.userMax)||(c(q.softMax)&&q.softMax>a.max&&(a.max=D=q.softMax),c(q.ceiling)&&(a.max=Math.min(a.max,q.ceiling)));E&&x(a.dataMin)&&(G=G||0,!x(O)&&a.min<G&&a.dataMin>=G?a.min=a.options.minRange?Math.min(G,a.max-a.minRange):G:!x(D)&&a.max>G&&a.dataMax<=G&&(a.max=a.options.minRange?Math.max(G,a.min+a.minRange):G));a.tickInterval=a.min===a.max||"undefined"===typeof a.min||"undefined"===
typeof a.max?1:u&&!f&&h===a.linkedParent.options.tickPixelInterval?f=a.linkedParent.tickInterval:A(f,this.tickAmount?(a.max-a.min)/Math.max(this.tickAmount-1,1):void 0,w?1:(a.max-a.min)*h/Math.max(a.len,h));e&&!b&&a.series.forEach(function(b){b.processData(a.min!==a.oldMin||a.max!==a.oldMax)});a.setAxisTranslation(!0);J(this,"initialAxisTranslation");a.pointRange&&!f&&(a.tickInterval=Math.max(a.pointRange,a.tickInterval));b=A(q.minTickInterval,a.dateTime&&!a.series.some(function(b){return b.noSharedTooltip})?
a.closestPointRange:0);!f&&a.tickInterval<b&&(a.tickInterval=b);a.dateTime||a.logarithmic||f||(a.tickInterval=p(a.tickInterval,void 0,r(a.tickInterval),A(q.allowDecimals,.5>a.tickInterval||void 0!==this.tickAmount),!!this.tickAmount));this.tickAmount||(a.tickInterval=a.unsquish());this.setTickPositions()};u.prototype.setTickPositions=function(){var b=this.options,a=b.tickPositions;var c=this.getMinorTickInterval();var d=b.tickPositioner,g=this.hasVerticalPanning(),p="colorAxis"===this.coll,q=(p||
!g)&&b.startOnTick;g=(p||!g)&&b.endOnTick;this.tickmarkOffset=this.categories&&"between"===b.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===c&&this.tickInterval?this.tickInterval/5:c;this.single=this.min===this.max&&x(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==b.allowDecimals);this.tickPositions=c=a&&a.slice();!c&&(this.ordinal&&this.ordinal.positions||!((this.max-this.min)/this.tickInterval>Math.max(2*this.len,200))?c=this.dateTime?this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval,
b.units),this.min,this.max,b.startOfWeek,this.ordinal&&this.ordinal.positions,this.closestPointRange,!0):this.logarithmic?this.logarithmic.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max):(c=[this.min,this.max],n(19,!1,this.chart)),c.length>this.len&&(c=[c[0],c.pop()],c[0]===c[1]&&(c.length=1)),this.tickPositions=c,d&&(d=d.apply(this,[this.min,this.max])))&&(this.tickPositions=c=d);this.paddedTicks=c.slice(0);this.trimTicks(c,
q,g);this.isLinked||(this.single&&2>c.length&&!this.categories&&!this.series.some(function(b){return b.is("heatmap")&&"between"===b.options.pointPlacement})&&(this.min-=.5,this.max+=.5),a||d||this.adjustTickAmount());J(this,"afterSetTickPositions")};u.prototype.trimTicks=function(b,a,c){var k=b[0],d=b[b.length-1],t=!this.isOrdinal&&this.minPointOffset||0;J(this,"trimTicks");if(!this.isLinked){if(a&&-Infinity!==k)this.min=k;else for(;this.min-t>b[0];)b.shift();if(c)this.max=d;else for(;this.max+t<
b[b.length-1];)b.pop();0===b.length&&x(k)&&!this.options.tickPositions&&b.push((d+k)/2)}};u.prototype.alignToOthers=function(){var b={},a,c=this.options;!1===this.chart.options.chart.alignTicks||!1===c.alignTicks||!1===c.startOnTick||!1===c.endOnTick||this.logarithmic||this.chart[this.coll].forEach(function(k){var c=k.options;c=[k.horiz?c.left:c.top,c.width,c.height,c.pane].join();k.series.length&&(b[c]?a=!0:b[c]=1)});return a};u.prototype.getTickAmount=function(){var b=this.options,a=b.tickAmount,
c=b.tickPixelInterval;!x(b.tickInterval)&&!a&&this.len<c&&!this.isRadial&&!this.logarithmic&&b.startOnTick&&b.endOnTick&&(a=2);!a&&this.alignToOthers()&&(a=Math.ceil(this.len/c)+1);4>a&&(this.finalTickAmt=a,a=5);this.tickAmount=a};u.prototype.adjustTickAmount=function(){var b=this.options,a=this.tickInterval,c=this.tickPositions,d=this.tickAmount,g=this.finalTickAmt,p=c&&c.length,q=A(this.threshold,this.softThreshold?0:null),e;if(this.hasData()){if(p<d){for(e=this.min;c.length<d;)c.length%2||e===
q?c.push(v(c[c.length-1]+a)):c.unshift(v(c[0]-a));this.transA*=(p-1)/(d-1);this.min=b.startOnTick?c[0]:Math.min(this.min,c[0]);this.max=b.endOnTick?c[c.length-1]:Math.max(this.max,c[c.length-1])}else p>d&&(this.tickInterval*=2,this.setTickPositions());if(x(g)){for(a=b=c.length;a--;)(3===g&&1===a%2||2>=g&&0<a&&a<b-1)&&c.splice(a,1);this.finalTickAmt=void 0}}};u.prototype.setScale=function(){var b,a=!1,c=!1;this.series.forEach(function(b){var k;a=a||b.isDirtyData||b.isDirty;c=c||(null===(k=b.xAxis)||
void 0===k?void 0:k.isDirty)||!1});this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();(b=this.len!==this.oldAxisLength)||a||c||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.stacking&&this.stacking.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||
this.max!==this.oldMax)):this.stacking&&this.stacking.cleanStacks();a&&this.panningState&&(this.panningState.isDirty=!0);J(this,"afterSetScale")};u.prototype.setExtremes=function(b,a,c,d,g){var k=this,t=k.chart;c=A(c,!0);k.series.forEach(function(b){delete b.kdTree});g=l(g,{min:b,max:a});J(k,"setExtremes",g,function(){k.userMin=b;k.userMax=a;k.eventArgs=g;c&&t.redraw(d)})};u.prototype.zoom=function(b,a){var k=this,c=this.dataMin,d=this.dataMax,g=this.options,p=Math.min(c,A(g.min,c)),q=Math.max(d,
A(g.max,d));b={newMin:b,newMax:a};J(this,"zoom",b,function(b){var a=b.newMin,g=b.newMax;if(a!==k.min||g!==k.max)k.allowZoomOutside||(x(c)&&(a<p&&(a=p),a>q&&(a=q)),x(d)&&(g<p&&(g=p),g>q&&(g=q))),k.displayBtn="undefined"!==typeof a||"undefined"!==typeof g,k.setExtremes(a,g,!1,void 0,{trigger:"zoom"});b.zoomed=!0});return b.zoomed};u.prototype.setAxisSize=function(){var b=this.chart,a=this.options,c=a.offsets||[0,0,0,0],d=this.horiz,g=this.width=Math.round(G(A(a.width,b.plotWidth-c[3]+c[1]),b.plotWidth)),
p=this.height=Math.round(G(A(a.height,b.plotHeight-c[0]+c[2]),b.plotHeight)),q=this.top=Math.round(G(A(a.top,b.plotTop+c[0]),b.plotHeight,b.plotTop));a=this.left=Math.round(G(A(a.left,b.plotLeft+c[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-p-q;this.right=b.chartWidth-g-a;this.len=Math.max(d?g:p,0);this.pos=d?a:q};u.prototype.getExtremes=function(){var b=this.logarithmic;return{min:b?v(b.lin2log(this.min)):this.min,max:b?v(b.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,
userMin:this.userMin,userMax:this.userMax}};u.prototype.getThreshold=function(b){var a=this.logarithmic,c=a?a.lin2log(this.min):this.min;a=a?a.lin2log(this.max):this.max;null===b||-Infinity===b?b=c:Infinity===b?b=a:c>b?b=c:a<b&&(b=a);return this.translate(b,0,1,0,1)};u.prototype.autoLabelAlign=function(b){var a=(A(b,0)-90*this.side+720)%360;b={align:"center"};J(this,"autoLabelAlign",b,function(b){15<a&&165>a?b.align="right":195<a&&345>a&&(b.align="left")});return b.align};u.prototype.tickSize=function(b){var a=
this.options,c=a["tick"===b?"tickLength":"minorTickLength"],d=A(a["tick"===b?"tickWidth":"minorTickWidth"],"tick"===b&&this.isXAxis&&!this.categories?1:0);if(d&&c){"inside"===a[b+"Position"]&&(c=-c);var g=[c,d]}b={tickSize:g};J(this,"afterTickSize",b);return b.tickSize};u.prototype.labelMetrics=function(){var b=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[b]&&this.ticks[b].label)};u.prototype.unsquish=
function(){var b=this.options.labels,a=this.horiz,c=this.tickInterval,d=c,g=this.len/(((this.categories?1:0)+this.max-this.min)/c),p,q=b.rotation,e=this.labelMetrics(),u,B=Number.MAX_VALUE,l,r=this.max-this.min,n=function(b){var a=b/(g||1);a=1<a?Math.ceil(a):1;a*c>r&&Infinity!==b&&Infinity!==g&&r&&(a=Math.ceil(r/c));return v(a*c)};a?(l=!b.staggerLines&&!b.step&&(x(q)?[q]:g<A(b.autoRotationLimit,80)&&b.autoRotation))&&l.forEach(function(b){if(b===q||b&&-90<=b&&90>=b){u=n(Math.abs(e.h/Math.sin(E*b)));
var a=u+Math.abs(b/360);a<B&&(B=a,p=b,d=u)}}):b.step||(d=n(e.h));this.autoRotation=l;this.labelRotation=A(p,q);return d};u.prototype.getSlotWidth=function(b){var a,d=this.chart,g=this.horiz,p=this.options.labels,q=Math.max(this.tickPositions.length-(this.categories?0:1),1),e=d.margin[3];if(b&&c(b.slotWidth))return b.slotWidth;if(g&&p&&2>(p.step||0))return p.rotation?0:(this.staggerLines||1)*this.len/q;if(!g){b=null===(a=null===p||void 0===p?void 0:p.style)||void 0===a?void 0:a.width;if(void 0!==b)return parseInt(b,
10);if(e)return e-d.spacing[3]}return.33*d.chartWidth};u.prototype.renderUnsquish=function(){var b=this.chart,k=b.renderer,c=this.tickPositions,d=this.ticks,g=this.options.labels,p=g&&g.style||{},q=this.horiz,e=this.getSlotWidth(),u=Math.max(1,Math.round(e-2*(g.padding||5))),B={},l=this.labelMetrics(),r=g.style&&g.style.textOverflow,n=0;a(g.rotation)||(B.rotation=g.rotation||0);c.forEach(function(b){b=d[b];b.movedLabel&&b.replaceMovedLabel();b&&b.label&&b.label.textPxLength>n&&(n=b.label.textPxLength)});
this.maxLabelLength=n;if(this.autoRotation)n>u&&n>l.h?B.rotation=this.labelRotation:this.labelRotation=0;else if(e){var A=u;if(!r){var f="clip";for(u=c.length;!q&&u--;){var h=c[u];if(h=d[h].label)h.styles&&"ellipsis"===h.styles.textOverflow?h.css({textOverflow:"clip"}):h.textPxLength>e&&h.css({width:e+"px"}),h.getBBox().height>this.len/c.length-(l.h-l.f)&&(h.specificTextOverflow="ellipsis")}}}B.rotation&&(A=n>.5*b.chartHeight?.33*b.chartHeight:n,r||(f="ellipsis"));if(this.labelAlign=g.align||this.autoLabelAlign(this.labelRotation))B.align=
this.labelAlign;c.forEach(function(b){var a=(b=d[b])&&b.label,k=p.width,c={};a&&(a.attr(B),b.shortenLabel?b.shortenLabel():A&&!k&&"nowrap"!==p.whiteSpace&&(A<a.textPxLength||"SPAN"===a.element.tagName)?(c.width=A+"px",r||(c.textOverflow=a.specificTextOverflow||f),a.css(c)):a.styles&&a.styles.width&&!c.width&&!k&&a.css({width:null}),delete a.specificTextOverflow,b.rotation=B.rotation)},this);this.tickRotCorr=k.rotCorr(l.b,this.labelRotation||0,0!==this.side)};u.prototype.hasData=function(){return this.series.some(function(b){return b.hasData()})||
this.options.showEmpty&&x(this.min)&&x(this.max)};u.prototype.addTitle=function(b){var a=this.chart.renderer,c=this.horiz,d=this.opposite,g=this.options.title,p,e=this.chart.styledMode;this.axisTitle||((p=g.textAlign)||(p=(c?{low:"left",middle:"center",high:"right"}:{low:d?"right":"left",middle:"center",high:d?"left":"right"})[g.align]),this.axisTitle=a.text(g.text,0,0,g.useHTML).attr({zIndex:7,rotation:g.rotation||0,align:p}).addClass("highcharts-axis-title"),e||this.axisTitle.css(q(g.style)),this.axisTitle.add(this.axisGroup),
this.axisTitle.isNew=!0);e||g.style.width||this.isRadial||this.axisTitle.css({width:this.len+"px"});this.axisTitle[b?"show":"hide"](b)};u.prototype.generateTick=function(b){var a=this.ticks;a[b]?a[b].addLabel():a[b]=new z(this,b)};u.prototype.getOffset=function(){var b=this,a=b.chart,c=a.renderer,d=b.options,g=b.tickPositions,p=b.ticks,q=b.horiz,e=b.side,u=a.inverted&&!b.isZAxis?[1,0,3,2][e]:e,l,n=0,r=0,f=d.title,h=d.labels,G=0,w=a.axisOffset;a=a.clipOffset;var E=[-1,1,1,-1][e],v=d.className,O=b.axisParent;
var D=b.hasData();b.showAxis=l=D||A(d.showEmpty,!0);b.staggerLines=b.horiz&&h.staggerLines;b.axisGroup||(b.gridGroup=c.g("grid").attr({zIndex:d.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(v||"")).add(O),b.axisGroup=c.g("axis").attr({zIndex:d.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(v||"")).add(O),b.labelGroup=c.g("axis-labels").attr({zIndex:h.zIndex||7}).addClass("highcharts-"+b.coll.toLowerCase()+"-labels "+(v||"")).add(O));D||b.isLinked?(g.forEach(function(a,
c){b.generateTick(a,c)}),b.renderUnsquish(),b.reserveSpaceDefault=0===e||2===e||{1:"left",3:"right"}[e]===b.labelAlign,A(h.reserveSpace,"center"===b.labelAlign?!0:null,b.reserveSpaceDefault)&&g.forEach(function(b){G=Math.max(p[b].getLabelSize(),G)}),b.staggerLines&&(G*=b.staggerLines),b.labelOffset=G*(b.opposite?-1:1)):B(p,function(b,a){b.destroy();delete p[a]});if(f&&f.text&&!1!==f.enabled&&(b.addTitle(l),l&&!1!==f.reserveSpace)){b.titleOffset=n=b.axisTitle.getBBox()[q?"height":"width"];var M=f.offset;
r=x(M)?0:A(f.margin,q?5:10)}b.renderLine();b.offset=E*A(d.offset,w[e]?w[e]+(d.margin||0):0);b.tickRotCorr=b.tickRotCorr||{x:0,y:0};c=0===e?-b.labelMetrics().h:2===e?b.tickRotCorr.y:0;r=Math.abs(G)+r;G&&(r=r-c+E*(q?A(h.y,b.tickRotCorr.y+8*E):h.x));b.axisTitleMargin=A(M,r);b.getMaxLabelDimensions&&(b.maxLabelDimensions=b.getMaxLabelDimensions(p,g));q=this.tickSize("tick");w[e]=Math.max(w[e],b.axisTitleMargin+n+E*b.offset,r,g&&g.length&&q?q[0]+E*b.offset:0);d=d.offset?0:2*Math.floor(b.axisLine.strokeWidth()/
2);a[u]=Math.max(a[u],d);J(this,"afterGetOffset")};u.prototype.getLinePath=function(b){var a=this.chart,c=this.opposite,d=this.offset,g=this.horiz,p=this.left+(c?this.width:0)+d;d=a.chartHeight-this.bottom-(c?this.height:0)+d;c&&(b*=-1);return a.renderer.crispLine([["M",g?this.left:p,g?d:this.top],["L",g?a.chartWidth-this.right:p,g?d:a.chartHeight-this.bottom]],b)};u.prototype.renderLine=function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),
this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))};u.prototype.getTitlePosition=function(){var b=this.horiz,a=this.left,c=this.top,d=this.len,g=this.options.title,p=b?a:c,q=this.opposite,e=this.offset,u=g.x||0,B=g.y||0,l=this.axisTitle,r=this.chart.renderer.fontMetrics(g.style&&g.style.fontSize,l);l=Math.max(l.getBBox(null,0).height-r.h-1,0);d={low:p+(b?0:d),middle:p+d/2,high:p+(b?d:0)}[g.align];a=(b?c+this.height:a)+(b?1:-1)*
(q?-1:1)*this.axisTitleMargin+[-l,l,r.f,-l][this.side];b={x:b?d+u:a+(q?this.width:0)+e+u,y:b?a+B-(q?this.height:0)+e:d+B};J(this,"afterGetTitlePosition",{titlePosition:b});return b};u.prototype.renderMinorTick=function(b){var a=this.chart.hasRendered&&c(this.oldMin),d=this.minorTicks;d[b]||(d[b]=new z(this,b,"minor"));a&&d[b].isNew&&d[b].render(null,!0);d[b].render(null,!1,1)};u.prototype.renderTick=function(b,a){var k,d=this.isLinked,g=this.ticks,p=this.chart.hasRendered&&c(this.oldMin);if(!d||b>=
this.min&&b<=this.max||(null===(k=this.grid)||void 0===k?0:k.isColumn))g[b]||(g[b]=new z(this,b)),p&&g[b].isNew&&g[b].render(a,!0,-1),g[b].render(a)};u.prototype.render=function(){var b=this,a=b.chart,d=b.logarithmic,g=b.options,p=b.isLinked,q=b.tickPositions,e=b.axisTitle,u=b.ticks,l=b.minorTicks,r=b.alternateBands,n=g.stackLabels,f=g.alternateGridColor,A=b.tickmarkOffset,h=b.axisLine,G=b.showAxis,w=K(a.renderer.globalAnimation),E,v;b.labelEdge.length=0;b.overlap=!1;[u,l,r].forEach(function(b){B(b,
function(b){b.isActive=!1})});if(b.hasData()||p)b.minorTickInterval&&!b.categories&&b.getMinorTickPositions().forEach(function(a){b.renderMinorTick(a)}),q.length&&(q.forEach(function(a,c){b.renderTick(a,c)}),A&&(0===b.min||b.single)&&(u[-1]||(u[-1]=new z(b,-1,null,!0)),u[-1].render(-1))),f&&q.forEach(function(c,k){v="undefined"!==typeof q[k+1]?q[k+1]+A:b.max-A;0===k%2&&c<b.max&&v<=b.max+(a.polar?-A:A)&&(r[c]||(r[c]=new m.PlotLineOrBand(b)),E=c+A,r[c].options={from:d?d.lin2log(E):E,to:d?d.lin2log(v):
v,color:f,className:"highcharts-alternate-grid"},r[c].render(),r[c].isActive=!0)}),b._addedPlotLB||((g.plotLines||[]).concat(g.plotBands||[]).forEach(function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);[u,l,r].forEach(function(b){var c,k=[],d=w.duration;B(b,function(b,a){b.isActive||(b.render(a,!1,0),b.isActive=!1,k.push(a))});Q(function(){for(c=k.length;c--;)b[k[c]]&&!b[k[c]].isActive&&(b[k[c]].destroy(),delete b[k[c]])},b!==r&&a.hasRendered&&d?d:0)});h&&(h[h.isPlaced?"animate":"attr"]({d:this.getLinePath(h.strokeWidth())}),
h.isPlaced=!0,h[G?"show":"hide"](G));e&&G&&(g=b.getTitlePosition(),c(g.y)?(e[e.isNew?"attr":"animate"](g),e.isNew=!1):(e.attr("y",-9999),e.isNew=!0));n&&n.enabled&&b.stacking&&b.stacking.renderStackTotals();b.isDirty=!1;J(this,"afterRender")};u.prototype.redraw=function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(b){b.render()}));this.series.forEach(function(b){b.isDirty=!0})};u.prototype.getKeepProps=function(){return this.keepProps||u.keepProps};u.prototype.destroy=function(b){var a=
this,c=a.plotLinesAndBands,d;J(this,"destroy",{keepEvents:b});b||M(a);[a.ticks,a.minorTicks,a.alternateBands].forEach(function(b){D(b)});if(c)for(b=c.length;b--;)c[b].destroy();"axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(b){a[b]&&(a[b]=a[b].destroy())});for(d in a.plotLinesAndBandsGroups)a.plotLinesAndBandsGroups[d]=a.plotLinesAndBandsGroups[d].destroy();B(a,function(b,c){-1===a.getKeepProps().indexOf(c)&&delete a[c]})};u.prototype.drawCrosshair=
function(b,a){var c=this.crosshair,k=A(c.snap,!0),d,g=this.cross,p=this.chart;J(this,"drawCrosshair",{e:b,point:a});b||(b=this.cross&&this.cross.e);if(this.crosshair&&!1!==(x(a)||!k)){k?x(a)&&(d=A("colorAxis"!==this.coll?a.crosshairPos:null,this.isXAxis?a.plotX:this.len-a.plotY)):d=b&&(this.horiz?b.chartX-this.pos:this.len-b.chartY+this.pos);if(x(d)){var q={value:a&&(this.isXAxis?a.x:A(a.stackY,a.y)),translatedValue:d};p.polar&&l(q,{isCrosshair:!0,chartX:b&&b.chartX,chartY:b&&b.chartY,point:a});q=
this.getPlotLinePath(q)||null}if(!x(q)){this.hideCrosshair();return}k=this.categories&&!this.isRadial;g||(this.cross=g=p.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(k?"category ":"thin ")+c.className).attr({zIndex:A(c.zIndex,2)}).add(),p.styledMode||(g.attr({stroke:c.color||(k?h.parse("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":A(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&g.attr({dashstyle:c.dashStyle})));g.show().attr({d:q});k&&!c.width&&g.attr({"stroke-width":this.transA});
this.cross.e=b}else this.hideCrosshair();J(this,"afterDrawCrosshair",{e:b,point:a})};u.prototype.hideCrosshair=function(){this.cross&&this.cross.hide();J(this,"afterHideCrosshair")};u.prototype.hasVerticalPanning=function(){var b,a;return/y/.test((null===(a=null===(b=this.chart.options.chart)||void 0===b?void 0:b.panning)||void 0===a?void 0:a.type)||"")};u.prototype.validatePositiveValue=function(b){return c(b)&&0<b};u.defaultOptions={dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",range:!1},
second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"};u.defaultYAxisOptions={endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{animation:{},allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){var b=this.axis.chart.numberFormatter;return b(this.total,
-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0};u.defaultLeftAxisOptions={labels:{x:-15},title:{rotation:270}};u.defaultRightAxisOptions={labels:{x:15},title:{rotation:90}};u.defaultBottomAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}};u.defaultTopAxisOptions={labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}};u.keepProps="extKey hcEvents names series userMax userMin".split(" ");return u}();
m.Axis=f;return m.Axis});N(m,"Core/Axis/DateTimeAxis.js",[m["Core/Axis/Axis.js"],m["Core/Utilities.js"]],function(f,h){var m=h.addEvent,z=h.getMagnitude,F=h.normalizeTickInterval,L=h.timeUnits,K=function(){function f(f){this.axis=f}f.prototype.normalizeTimeTickInterval=function(f,e){var h=e||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];e=h[h.length-
1];var v=L[e[0]],x=e[1],D;for(D=0;D<h.length&&!(e=h[D],v=L[e[0]],x=e[1],h[D+1]&&f<=(v*x[x.length-1]+L[h[D+1][0]])/2);D++);v===L.year&&f<5*v&&(x=[1,2,5]);f=F(f/v,x,"year"===e[0]?Math.max(z(f/v),1):1);return{unitRange:v,count:f,unitName:e[0]}};return f}();h=function(){function f(){}f.compose=function(f){f.keepProps.push("dateTime");f.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};m(f,"init",function(e){"datetime"!==e.userOptions.type?this.dateTime=
void 0:this.dateTime||(this.dateTime=new K(this))})};f.AdditionsClass=K;return f}();h.compose(f);return h});N(m,"Core/Axis/LogarithmicAxis.js",[m["Core/Axis/Axis.js"],m["Core/Utilities.js"]],function(f,h){var m=h.addEvent,z=h.getMagnitude,F=h.normalizeTickInterval,L=h.pick,K=function(){function f(f){this.axis=f}f.prototype.getLogTickPositions=function(f,e,h,v){var x=this.axis,D=x.len,n=x.options,l=[];v||(this.minorAutoInterval=void 0);if(.5<=f)f=Math.round(f),l=x.getLinearTickPositions(f,e,h);else if(.08<=
f){n=Math.floor(e);var m,w;for(D=.3<f?[1,2,4]:.15<f?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];n<h+1&&!w;n++){var r=D.length;for(m=0;m<r&&!w;m++){var d=this.log2lin(this.lin2log(n)*D[m]);d>e&&(!v||g<=h)&&"undefined"!==typeof g&&l.push(g);g>h&&(w=!0);var g=d}}}else e=this.lin2log(e),h=this.lin2log(h),f=v?x.getMinorTickInterval():n.tickInterval,f=L("auto"===f?null:f,this.minorAutoInterval,n.tickPixelInterval/(v?5:1)*(h-e)/((v?D/x.tickPositions.length:D)||1)),f=F(f,void 0,z(f)),l=x.getLinearTickPositions(f,e,h).map(this.log2lin),
v||(this.minorAutoInterval=f/5);v||(x.tickInterval=f);return l};f.prototype.lin2log=function(f){return Math.pow(10,f)};f.prototype.log2lin=function(f){return Math.log(f)/Math.LN10};return f}();h=function(){function f(){}f.compose=function(f){f.keepProps.push("logarithmic");var e=f.prototype,h=K.prototype;e.log2lin=h.log2lin;e.lin2log=h.lin2log;m(f,"init",function(e){var f=this.logarithmic;"logarithmic"!==e.userOptions.type?this.logarithmic=void 0:(f||(f=this.logarithmic=new K(this)),this.log2lin!==
f.log2lin&&(f.log2lin=this.log2lin.bind(this)),this.lin2log!==f.lin2log&&(f.lin2log=this.lin2log.bind(this)))});m(f,"afterInit",function(){var e=this.logarithmic;e&&(this.lin2val=function(f){return e.lin2log(f)},this.val2lin=function(f){return e.log2lin(f)})})};return f}();h.compose(f);return h});N(m,"Core/Axis/PlotLineOrBand.js",[m["Core/Axis/Axis.js"],m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h,m){var z=m.arrayMax,F=m.arrayMin,P=m.defined,K=m.destroyObjectProperties,C=m.erase,y=m.extend,
e=m.merge,I=m.objectEach,v=m.pick;m=function(){function f(e,f){this.axis=e;f&&(this.options=f,this.id=f.id)}f.prototype.render=function(){h.fireEvent(this,"render");var f=this,n=f.axis,l=n.horiz,m=n.logarithmic,w=f.options,r=w.label,d=f.label,g=w.to,c=w.from,a=w.value,q=P(c)&&P(g),p=P(a),B=f.svgElem,A=!B,G=[],M=w.color,x=v(w.zIndex,0),Q=w.events;G={"class":"highcharts-plot-"+(q?"band ":"line ")+(w.className||"")};var O={},E=n.chart.renderer,u=q?"bands":"lines";m&&(c=m.log2lin(c),g=m.log2lin(g),a=
m.log2lin(a));n.chart.styledMode||(p?(G.stroke=M||"#999999",G["stroke-width"]=v(w.width,1),w.dashStyle&&(G.dashstyle=w.dashStyle)):q&&(G.fill=M||"#e6ebf5",w.borderWidth&&(G.stroke=w.borderColor,G["stroke-width"]=w.borderWidth)));O.zIndex=x;u+="-"+x;(m=n.plotLinesAndBandsGroups[u])||(n.plotLinesAndBandsGroups[u]=m=E.g("plot-"+u).attr(O).add());A&&(f.svgElem=B=E.path().attr(G).add(m));if(p)G=n.getPlotLinePath({value:a,lineWidth:B.strokeWidth(),acrossPanes:w.acrossPanes});else if(q)G=n.getPlotBandPath(c,
g,w);else return;!f.eventsAdded&&Q&&(I(Q,function(b,a){B.on(a,function(b){Q[a].apply(f,[b])})}),f.eventsAdded=!0);(A||!B.d)&&G&&G.length?B.attr({d:G}):B&&(G?(B.show(!0),B.animate({d:G})):B.d&&(B.hide(),d&&(f.label=d=d.destroy())));r&&(P(r.text)||P(r.formatter))&&G&&G.length&&0<n.width&&0<n.height&&!G.isFlat?(r=e({align:l&&q&&"center",x:l?!q&&4:10,verticalAlign:!l&&q&&"middle",y:l?q?16:10:q?6:-4,rotation:l&&!q&&90},r),this.renderLabel(r,G,q,x)):d&&d.hide();return f};f.prototype.renderLabel=function(e,
f,l,h){var n=this.label,r=this.axis.chart.renderer;n||(n={align:e.textAlign||e.align,rotation:e.rotation,"class":"highcharts-plot-"+(l?"band":"line")+"-label "+(e.className||"")},n.zIndex=h,h=this.getLabelText(e),this.label=n=r.text(h,0,0,e.useHTML).attr(n).add(),this.axis.chart.styledMode||n.css(e.style));r=f.xBounds||[f[0][1],f[1][1],l?f[2][1]:f[0][1]];f=f.yBounds||[f[0][2],f[1][2],l?f[2][2]:f[0][2]];l=F(r);h=F(f);n.align(e,!1,{x:l,y:h,width:z(r)-l,height:z(f)-h});n.show(!0)};f.prototype.getLabelText=
function(e){return P(e.formatter)?e.formatter.call(this):e.text};f.prototype.destroy=function(){C(this.axis.plotLinesAndBands,this);delete this.axis;K(this)};return f}();y(f.prototype,{getPlotBandPath:function(e,f,n){void 0===n&&(n=this.options);var l=this.getPlotLinePath({value:f,force:!0,acrossPanes:n.acrossPanes});n=this.getPlotLinePath({value:e,force:!0,acrossPanes:n.acrossPanes});var h=[],w=this.horiz,r=1;e=e<this.min&&f<this.min||e>this.max&&f>this.max;if(n&&l){if(e){var d=n.toString()===l.toString();
r=0}for(e=0;e<n.length;e+=2){f=n[e];var g=n[e+1],c=l[e],a=l[e+1];"M"!==f[0]&&"L"!==f[0]||"M"!==g[0]&&"L"!==g[0]||"M"!==c[0]&&"L"!==c[0]||"M"!==a[0]&&"L"!==a[0]||(w&&c[1]===f[1]?(c[1]+=r,a[1]+=r):w||c[2]!==f[2]||(c[2]+=r,a[2]+=r),h.push(["M",f[1],f[2]],["L",g[1],g[2]],["L",a[1],a[2]],["L",c[1],c[2]],["Z"]));h.isFlat=d}}return h},addPlotBand:function(e){return this.addPlotBandOrLine(e,"plotBands")},addPlotLine:function(e){return this.addPlotBandOrLine(e,"plotLines")},addPlotBandOrLine:function(e,f){var n=
new h.PlotLineOrBand(this,e),l=this.userOptions;this.visible&&(n=n.render());if(n){if(f){var v=l[f]||[];v.push(e);l[f]=v}this.plotLinesAndBands.push(n);this._addedPlotLB=!0}return n},removePlotBandOrLine:function(e){for(var f=this.plotLinesAndBands,n=this.options,l=this.userOptions,h=f.length;h--;)f[h].id===e&&f[h].destroy();[n.plotLines||[],l.plotLines||[],n.plotBands||[],l.plotBands||[]].forEach(function(f){for(h=f.length;h--;)(f[h]||{}).id===e&&C(f,f[h])})},removePlotBand:function(e){this.removePlotBandOrLine(e)},
removePlotLine:function(e){this.removePlotBandOrLine(e)}});h.PlotLineOrBand=m;return h.PlotLineOrBand});N(m,"Core/Tooltip.js",[m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h){var m=f.doc,z=h.clamp,F=h.css,L=h.defined,K=h.discardElement,C=h.extend,y=h.fireEvent,e=h.format,I=h.isNumber,v=h.isString,x=h.merge,D=h.pick,n=h.splat,l=h.syncTimeout,J=h.timeUnits;"";var w=function(){function r(d,g){this.container=void 0;this.crosshairs=[];this.distance=0;this.isHidden=!0;this.isSticky=!1;this.now=
{};this.options={};this.outside=!1;this.chart=d;this.init(d,g)}r.prototype.applyFilter=function(){var d=this.chart;d.renderer.definition({tagName:"filter",id:"drop-shadow-"+d.index,opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});d.renderer.definition({tagName:"style",
textContent:".highcharts-tooltip-"+d.index+"{filter:url(#drop-shadow-"+d.index+")}"})};r.prototype.bodyFormatter=function(d){return d.map(function(d){var c=d.series.tooltipOptions;return(c[(d.point.formatPrefix||"point")+"Formatter"]||d.point.tooltipFormatter).call(d.point,c[(d.point.formatPrefix||"point")+"Format"]||"")})};r.prototype.cleanSplit=function(d){this.chart.series.forEach(function(g){var c=g&&g.tt;c&&(!c.isActive||d?g.tt=c.destroy():c.isActive=!1)})};r.prototype.defaultFormatter=function(d){var g=
this.points||n(this);var c=[d.tooltipFooterHeaderFormatter(g[0])];c=c.concat(d.bodyFormatter(g));c.push(d.tooltipFooterHeaderFormatter(g[0],!0));return c};r.prototype.destroy=function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),K(this.container));h.clearTimeout(this.hideTimer);h.clearTimeout(this.tooltipTimeout)};r.prototype.getAnchor=function(d,g){var c=this.chart,
a=c.pointer,q=c.inverted,p=c.plotTop,e=c.plotLeft,f=0,l=0,r,h;d=n(d);this.followPointer&&g?("undefined"===typeof g.chartX&&(g=a.normalize(g)),d=[g.chartX-e,g.chartY-p]):d[0].tooltipPos?d=d[0].tooltipPos:(d.forEach(function(a){r=a.series.yAxis;h=a.series.xAxis;f+=a.plotX+(!q&&h?h.left-e:0);l+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!q&&r?r.top-p:0)}),f/=d.length,l/=d.length,d=[q?c.plotWidth-l:f,this.shared&&!q&&1<d.length&&g?g.chartY-p:q?c.plotHeight-f:l]);return d.map(Math.round)};r.prototype.getDateFormat=
function(d,g,c,a){var q=this.chart.time,p=q.dateFormat("%m-%d %H:%M:%S.%L",g),e={millisecond:15,second:12,minute:9,hour:6,day:3},f="millisecond";for(l in J){if(d===J.week&&+q.dateFormat("%w",g)===c&&"00:00:00.000"===p.substr(6)){var l="week";break}if(J[l]>d){l=f;break}if(e[l]&&p.substr(e[l])!=="01-01 00:00:00.000".substr(e[l]))break;"week"!==l&&(f=l)}if(l)var r=q.resolveDTLFormat(a[l]).main;return r};r.prototype.getLabel=function(){var d,g,c=this,a=this.chart.renderer,q=this.chart.styledMode,p=this.options,
e="tooltip"+(L(p.className)?" "+p.className:""),l=(null===(d=p.style)||void 0===d?void 0:d.pointerEvents)||(!this.followPointer&&p.stickOnContact?"auto":"none"),r;d=function(){c.inContact=!0};var n=function(){var a=c.chart.hoverSeries;c.inContact=!1;if(a&&a.onMouseOut)a.onMouseOut()};if(!this.label){this.outside&&(this.container=r=f.doc.createElement("div"),r.className="highcharts-tooltip-container",F(r,{position:"absolute",top:"1px",pointerEvents:l,zIndex:3}),f.doc.body.appendChild(r),this.renderer=
a=new f.Renderer(r,0,0,null===(g=this.chart.options.chart)||void 0===g?void 0:g.style,void 0,void 0,a.styledMode));this.split?this.label=a.g(e):(this.label=a.label("",0,0,p.shape||"callout",null,null,p.useHTML,null,e).attr({padding:p.padding,r:p.borderRadius}),q||this.label.attr({fill:p.backgroundColor,"stroke-width":p.borderWidth}).css(p.style).css({pointerEvents:l}).shadow(p.shadow));q&&(this.applyFilter(),this.label.addClass("highcharts-tooltip-"+this.chart.index));if(c.outside&&!c.split){var h=
this.label,w=h.xSetter,v=h.ySetter;h.xSetter=function(a){w.call(h,c.distance);r.style.left=a+"px"};h.ySetter=function(a){v.call(h,c.distance);r.style.top=a+"px"}}this.label.on("mouseenter",d).on("mouseleave",n).attr({zIndex:8}).add()}return this.label};r.prototype.getPosition=function(d,g,c){var a=this.chart,q=this.distance,p={},e=a.inverted&&c.h||0,f,l=this.outside,r=l?m.documentElement.clientWidth-2*q:a.chartWidth,n=l?Math.max(m.body.scrollHeight,m.documentElement.scrollHeight,m.body.offsetHeight,
m.documentElement.offsetHeight,m.documentElement.clientHeight):a.chartHeight,h=a.pointer.getChartPosition(),w=a.containerScaling,E=function(b){return w?b*w.scaleX:b},u=function(b){return w?b*w.scaleY:b},b=function(b){var k="x"===b;return[b,k?r:n,k?d:g].concat(l?[k?E(d):u(g),k?h.left-q+E(c.plotX+a.plotLeft):h.top-q+u(c.plotY+a.plotTop),0,k?r:n]:[k?d:g,k?c.plotX+a.plotLeft:c.plotY+a.plotTop,k?a.plotLeft:a.plotTop,k?a.plotLeft+a.plotWidth:a.plotTop+a.plotHeight])},k=b("y"),t=b("x"),H=!this.followPointer&&
D(c.ttBelow,!a.inverted===!!c.negative),v=function(b,a,c,k,d,g,t){var f="y"===b?u(q):E(q),l=(c-k)/2,r=k<d-q,B=d+q+k<a,n=d-f-c+l;d=d+f-l;if(H&&B)p[b]=d;else if(!H&&r)p[b]=n;else if(r)p[b]=Math.min(t-k,0>n-e?n:n-e);else if(B)p[b]=Math.max(g,d+e+c>a?d:d+e);else return!1},U=function(b,a,c,k,d){var g;d<q||d>a-q?g=!1:p[b]=d<c/2?1:d>a-k/2?a-k-2:d-c/2;return g},x=function(b){var a=k;k=t;t=a;f=b},I=function(){!1!==v.apply(0,k)?!1!==U.apply(0,t)||f||(x(!0),I()):f?p.x=p.y=0:(x(!0),I())};(a.inverted||1<this.len)&&
x();I();return p};r.prototype.getXDateFormat=function(d,g,c){g=g.dateTimeLabelFormats;var a=c&&c.closestPointRange;return(a?this.getDateFormat(a,d.x,c.options.startOfWeek,g):g.day)||g.year};r.prototype.hide=function(d){var g=this;h.clearTimeout(this.hideTimer);d=D(d,this.options.hideDelay,500);this.isHidden||(this.hideTimer=l(function(){g.getLabel().fadeOut(d?void 0:d);g.isHidden=!0},d))};r.prototype.init=function(d,g){this.chart=d;this.options=g;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=
!0;this.split=g.split&&!d.inverted&&!d.polar;this.shared=g.shared||this.split;this.outside=D(g.outside,!(!d.scrollablePixelsX&&!d.scrollablePixelsY))};r.prototype.isStickyOnContact=function(){return!(this.followPointer||!this.options.stickOnContact||!this.inContact)};r.prototype.move=function(d,g,c,a){var q=this,p=q.now,e=!1!==q.options.animation&&!q.isHidden&&(1<Math.abs(d-p.x)||1<Math.abs(g-p.y)),f=q.followPointer||1<q.len;C(p,{x:e?(2*p.x+d)/3:d,y:e?(p.y+g)/2:g,anchorX:f?void 0:e?(2*p.anchorX+c)/
3:c,anchorY:f?void 0:e?(p.anchorY+a)/2:a});q.getLabel().attr(p);q.drawTracker();e&&(h.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){q&&q.move(d,g,c,a)},32))};r.prototype.refresh=function(d,g){var c=this.chart,a=this.options,q=d,p={},e=[],f=a.formatter||this.defaultFormatter;p=this.shared;var l=c.styledMode;if(a.enabled){h.clearTimeout(this.hideTimer);this.followPointer=n(q)[0].series.tooltipOptions.followPointer;var r=this.getAnchor(q,g);g=r[0];var w=r[1];!p||q.series&&
q.series.noSharedTooltip?p=q.getLabelConfig():(c.pointer.applyInactiveState(q),q.forEach(function(a){a.setState("hover");e.push(a.getLabelConfig())}),p={x:q[0].category,y:q[0].y},p.points=e,q=q[0]);this.len=e.length;c=f.call(p,this);f=q.series;this.distance=D(f.tooltipOptions.distance,16);!1===c?this.hide():(this.split?this.renderSplit(c,n(d)):(d=this.getLabel(),a.style.width&&!l||d.css({width:this.chart.spacingBox.width+"px"}),d.attr({text:c&&c.join?c.join(""):c}),d.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+
D(q.colorIndex,f.colorIndex)),l||d.attr({stroke:a.borderColor||q.color||f.color||"#666666"}),this.updatePosition({plotX:g,plotY:w,negative:q.negative,ttBelow:q.ttBelow,h:r[2]||0})),this.isHidden&&this.label&&this.label.attr({opacity:1}).show(),this.isHidden=!1);y(this,"refresh")}};r.prototype.renderSplit=function(d,g){function c(b,a,c,d,g){void 0===g&&(g=!0);c?(a=I?0:F,b=z(b-d/2,m.left,m.right-d)):(a-=y,b=g?b-d-k:b+k,b=z(b,g?b:m.left,m.right));return{x:b,y:a}}var a=this,q=a.chart,p=a.chart,e=p.plotHeight,
l=p.plotLeft,r=p.plotTop,n=p.pointer,h=p.renderer,w=p.scrollablePixelsY,O=void 0===w?0:w;w=p.scrollingContainer;w=void 0===w?{scrollLeft:0,scrollTop:0}:w;var E=w.scrollLeft,u=w.scrollTop,b=p.styledMode,k=a.distance,t=a.options,H=a.options.positioner,m={left:E,right:E+p.chartWidth,top:u,bottom:u+p.chartHeight},x=a.getLabel(),I=!(!q.xAxis[0]||!q.xAxis[0].opposite),y=r+u,J=0,F=e-O;v(d)&&(d=[!1,d]);d=d.slice(0,g.length+1).reduce(function(d,p,q){if(!1!==p&&""!==p){q=g[q-1]||{isHeader:!0,plotX:g[0].plotX,
plotY:e,series:{}};var f=q.isHeader,n=f?a:q.series,B=n.tt,A=q.isHeader;var w=q.series;var E="highcharts-color-"+D(q.colorIndex,w.colorIndex,"none");B||(B={padding:t.padding,r:t.borderRadius},b||(B.fill=t.backgroundColor,B["stroke-width"]=t.borderWidth),B=h.label("",0,0,t[A?"headerShape":"shape"]||"callout",void 0,void 0,t.useHTML).addClass((A?"highcharts-tooltip-header ":"")+"highcharts-tooltip-box "+E).attr(B).add(x));B.isActive=!0;B.attr({text:p});b||B.css(t.style).shadow(t.shadow).attr({stroke:t.borderColor||
q.color||w.color||"#333333"});p=n.tt=B;A=p.getBBox();n=A.width+p.strokeWidth();f&&(J=A.height,F+=J,I&&(y-=J));w=q.plotX;w=void 0===w?0:w;E=q.plotY;E=void 0===E?0:E;var v=q.series;if(q.isHeader){w=l+w;var G=r+e/2}else B=v.xAxis,v=v.yAxis,w=B.pos+z(w,-k,B.len+k),v.pos+E>=u+r&&v.pos+E<=u+r+e-O&&(G=v.pos+E);w=z(w,m.left-k,m.right+k);"number"===typeof G?(A=A.height+1,E=H?H.call(a,n,A,q):c(w,G,f,n),d.push({align:H?0:void 0,anchorX:w,anchorY:G,boxWidth:n,point:q,rank:D(E.rank,f?1:0),size:A,target:E.y,tt:p,
x:E.x})):p.isActive=!1}return d},[]);!H&&d.some(function(b){return b.x<m.left})&&(d=d.map(function(b){var a=c(b.anchorX,b.anchorY,b.point.isHeader,b.boxWidth,!1);return C(b,{target:a.y,x:a.x})}));a.cleanSplit();f.distribute(d,F);d.forEach(function(b){var a=b.pos;b.tt.attr({visibility:"undefined"===typeof a?"hidden":"inherit",x:b.x,y:a+y,anchorX:b.anchorX,anchorY:b.anchorY})});d=a.container;q=a.renderer;a.outside&&d&&q&&(p=x.getBBox(),q.setSize(p.width+p.x,p.height+p.y,!1),n=n.getChartPosition(),d.style.left=
n.left+"px",d.style.top=n.top+"px")};r.prototype.drawTracker=function(){if(this.followPointer||!this.options.stickOnContact)this.tracker&&this.tracker.destroy();else{var d=this.chart,g=this.label,c=d.hoverPoint;if(g&&c){var a={x:0,y:0,width:0,height:0};c=this.getAnchor(c);var q=g.getBBox();c[0]+=d.plotLeft-g.translateX;c[1]+=d.plotTop-g.translateY;a.x=Math.min(0,c[0]);a.y=Math.min(0,c[1]);a.width=0>c[0]?Math.max(Math.abs(c[0]),q.width-c[0]):Math.max(Math.abs(c[0]),q.width);a.height=0>c[1]?Math.max(Math.abs(c[1]),
q.height-Math.abs(c[1])):Math.max(Math.abs(c[1]),q.height);this.tracker?this.tracker.attr(a):(this.tracker=g.renderer.rect(a).addClass("highcharts-tracker").add(g),d.styledMode||this.tracker.attr({fill:"rgba(0,0,0,0)"}))}}};r.prototype.styledModeFormat=function(d){return d.replace('style="font-size: 10px"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex}"')};r.prototype.tooltipFooterHeaderFormatter=function(d,g){var c=g?"footer":
"header",a=d.series,q=a.tooltipOptions,p=q.xDateFormat,f=a.xAxis,l=f&&"datetime"===f.options.type&&I(d.key),r=q[c+"Format"];g={isFooter:g,labelConfig:d};y(this,"headerFormatter",g,function(c){l&&!p&&(p=this.getXDateFormat(d,q,f));l&&p&&(d.point&&d.point.tooltipDateKeys||["key"]).forEach(function(a){r=r.replace("{point."+a+"}","{point."+a+":"+p+"}")});a.chart.styledMode&&(r=this.styledModeFormat(r));c.text=e(r,{point:d,series:a},this.chart)});return g.text};r.prototype.update=function(d){this.destroy();
x(!0,this.chart.options.tooltip.userOptions,d);this.init(this.chart,x(!0,this.options,d))};r.prototype.updatePosition=function(d){var g=this.chart,c=g.pointer,a=this.getLabel(),q=d.plotX+g.plotLeft,p=d.plotY+g.plotTop;c=c.getChartPosition();d=(this.options.positioner||this.getPosition).call(this,a.width,a.height,d);if(this.outside){var e=(this.options.borderWidth||0)+2*this.distance;this.renderer.setSize(a.width+e,a.height+e,!1);if(g=g.containerScaling)F(this.container,{transform:"scale("+g.scaleX+
", "+g.scaleY+")"}),q*=g.scaleX,p*=g.scaleY;q+=c.left-d.x;p+=c.top-d.y}this.move(Math.round(d.x),Math.round(d.y||0),q,p)};return r}();f.Tooltip=w;return f.Tooltip});N(m,"Core/Pointer.js",[m["Core/Color/Color.js"],m["Core/Globals.js"],m["Core/Tooltip.js"],m["Core/Utilities.js"]],function(f,h,m,z){var F=f.parse,P=h.charts,K=h.noop,C=z.addEvent,y=z.attr,e=z.css,I=z.defined,v=z.extend,x=z.find,D=z.fireEvent,n=z.isNumber,l=z.isObject,J=z.objectEach,w=z.offset,r=z.pick,d=z.splat;"";f=function(){function g(c,
a){this.lastValidTouch={};this.pinchDown=[];this.runChartClick=!1;this.chart=c;this.hasDragged=!1;this.options=a;this.unbindContainerMouseLeave=function(){};this.unbindContainerMouseEnter=function(){};this.init(c,a)}g.prototype.applyInactiveState=function(c){var a=[],d;(c||[]).forEach(function(c){d=c.series;a.push(d);d.linkedParent&&a.push(d.linkedParent);d.linkedSeries&&(a=a.concat(d.linkedSeries));d.navigatorSeries&&a.push(d.navigatorSeries)});this.chart.series.forEach(function(c){-1===a.indexOf(c)?
c.setState("inactive",!0):c.options.inactiveOtherPoints&&c.setAllPointsToState("inactive")})};g.prototype.destroy=function(){var c=this;"undefined"!==typeof c.unDocMouseMove&&c.unDocMouseMove();this.unbindContainerMouseLeave();h.chartCount||(h.unbindDocumentMouseUp&&(h.unbindDocumentMouseUp=h.unbindDocumentMouseUp()),h.unbindDocumentTouchEnd&&(h.unbindDocumentTouchEnd=h.unbindDocumentTouchEnd()));clearInterval(c.tooltipTimeout);J(c,function(a,d){c[d]=void 0})};g.prototype.drag=function(c){var a=this.chart,
d=a.options.chart,g=c.chartX,e=c.chartY,f=this.zoomHor,r=this.zoomVert,n=a.plotLeft,h=a.plotTop,w=a.plotWidth,v=a.plotHeight,E=this.selectionMarker,u=this.mouseDownX||0,b=this.mouseDownY||0,k=l(d.panning)?d.panning&&d.panning.enabled:d.panning,t=d.panKey&&c[d.panKey+"Key"];if(!E||!E.touch)if(g<n?g=n:g>n+w&&(g=n+w),e<h?e=h:e>h+v&&(e=h+v),this.hasDragged=Math.sqrt(Math.pow(u-g,2)+Math.pow(b-e,2)),10<this.hasDragged){var H=a.isInsidePlot(u-n,b-h);a.hasCartesianSeries&&(this.zoomX||this.zoomY)&&H&&!t&&
!E&&(this.selectionMarker=E=a.renderer.rect(n,h,f?1:w,r?1:v,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),a.styledMode||E.attr({fill:d.selectionMarkerFill||F("#335cad").setOpacity(.25).get()}));E&&f&&(g-=u,E.attr({width:Math.abs(g),x:(0<g?0:g)+u}));E&&r&&(g=e-b,E.attr({height:Math.abs(g),y:(0<g?0:g)+b}));H&&!E&&k&&a.pan(c,d.panning)}};g.prototype.dragStart=function(c){var a=this.chart;a.mouseIsDown=c.type;a.cancelClick=!1;a.mouseDownX=this.mouseDownX=c.chartX;a.mouseDownY=this.mouseDownY=
c.chartY};g.prototype.drop=function(c){var a=this,d=this.chart,g=this.hasPinched;if(this.selectionMarker){var f={originalEvent:c,xAxis:[],yAxis:[]},l=this.selectionMarker,r=l.attr?l.attr("x"):l.x,h=l.attr?l.attr("y"):l.y,w=l.attr?l.attr("width"):l.width,m=l.attr?l.attr("height"):l.height,O;if(this.hasDragged||g)d.axes.forEach(function(d){if(d.zoomEnabled&&I(d.min)&&(g||a[{xAxis:"zoomX",yAxis:"zoomY"}[d.coll]])&&n(r)&&n(h)){var p=d.horiz,b="touchend"===c.type?d.minPixelPadding:0,k=d.toValue((p?r:h)+
b);p=d.toValue((p?r+w:h+m)-b);f[d.coll].push({axis:d,min:Math.min(k,p),max:Math.max(k,p)});O=!0}}),O&&D(d,"selection",f,function(a){d.zoom(v(a,g?{animation:!1}:null))});n(d.index)&&(this.selectionMarker=this.selectionMarker.destroy());g&&this.scaleGroups()}d&&n(d.index)&&(e(d.container,{cursor:d._cursor}),d.cancelClick=10<this.hasDragged,d.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])};g.prototype.findNearestKDPoint=function(c,a,d){var g=this.chart,q=g.hoverPoint;g=g.tooltip;if(q&&
g&&g.isStickyOnContact())return q;var e;c.forEach(function(c){var g=!(c.noSharedTooltip&&a)&&0>c.options.findNearestPointBy.indexOf("y");c=c.searchPoint(d,g);if((g=l(c,!0))&&!(g=!l(e,!0))){g=e.distX-c.distX;var p=e.dist-c.dist,q=(c.series.group&&c.series.group.zIndex)-(e.series.group&&e.series.group.zIndex);g=0<(0!==g&&a?g:0!==p?p:0!==q?q:e.series.index>c.series.index?-1:1)}g&&(e=c)});return e};g.prototype.getChartCoordinatesFromPoint=function(c,a){var d=c.series,g=d.xAxis;d=d.yAxis;var e=r(c.clientX,
c.plotX),f=c.shapeArgs;if(g&&d)return a?{chartX:g.len+g.pos-e,chartY:d.len+d.pos-c.plotY}:{chartX:e+g.pos,chartY:c.plotY+d.pos};if(f&&f.x&&f.y)return{chartX:f.x,chartY:f.y}};g.prototype.getChartPosition=function(){return this.chartPosition||(this.chartPosition=w(this.chart.container))};g.prototype.getCoordinates=function(c){var a={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(d){a[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(c[d.horiz?"chartX":"chartY"])})});return a};g.prototype.getHoverData=
function(c,a,d,g,e,f){var p,q=[];g=!(!g||!c);var n=a&&!a.stickyTracking,h={chartX:f?f.chartX:void 0,chartY:f?f.chartY:void 0,shared:e};D(this,"beforeGetHoverData",h);n=n?[a]:d.filter(function(a){return h.filter?h.filter(a):a.visible&&!(!e&&a.directTouch)&&r(a.options.enableMouseTracking,!0)&&a.stickyTracking});a=(p=g||!f?c:this.findNearestKDPoint(n,e,f))&&p.series;p&&(e&&!a.noSharedTooltip?(n=d.filter(function(a){return h.filter?h.filter(a):a.visible&&!(!e&&a.directTouch)&&r(a.options.enableMouseTracking,
!0)&&!a.noSharedTooltip}),n.forEach(function(a){var c=x(a.points,function(a){return a.x===p.x&&!a.isNull});l(c)&&(a.chart.isBoosting&&(c=a.getPoint(c)),q.push(c))})):q.push(p));h={hoverPoint:p};D(this,"afterGetHoverData",h);return{hoverPoint:h.hoverPoint,hoverSeries:a,hoverPoints:q}};g.prototype.getPointFromEvent=function(c){c=c.target;for(var a;c&&!a;)a=c.point,c=c.parentNode;return a};g.prototype.onTrackerMouseOut=function(c){c=c.relatedTarget||c.toElement;var a=this.chart.hoverSeries;this.isDirectTouch=
!1;if(!(!a||!c||a.stickyTracking||this.inClass(c,"highcharts-tooltip")||this.inClass(c,"highcharts-series-"+a.index)&&this.inClass(c,"highcharts-tracker")))a.onMouseOut()};g.prototype.inClass=function(c,a){for(var d;c;){if(d=y(c,"class")){if(-1!==d.indexOf(a))return!0;if(-1!==d.indexOf("highcharts-container"))return!1}c=c.parentNode}};g.prototype.init=function(c,a){this.options=a;this.chart=c;this.runChartClick=a.chart.events&&!!a.chart.events.click;this.pinchDown=[];this.lastValidTouch={};m&&(c.tooltip=
new m(c,a.tooltip),this.followTouchMove=r(a.tooltip.followTouchMove,!0));this.setDOMEvents()};g.prototype.normalize=function(c,a){var d=c.touches,g=d?d.length?d.item(0):r(d.changedTouches,c.changedTouches)[0]:c;a||(a=this.getChartPosition());d=g.pageX-a.left;a=g.pageY-a.top;if(g=this.chart.containerScaling)d/=g.scaleX,a/=g.scaleY;return v(c,{chartX:Math.round(d),chartY:Math.round(a)})};g.prototype.onContainerClick=function(c){var a=this.chart,d=a.hoverPoint;c=this.normalize(c);var g=a.plotLeft,e=
a.plotTop;a.cancelClick||(d&&this.inClass(c.target,"highcharts-tracker")?(D(d.series,"click",v(c,{point:d})),a.hoverPoint&&d.firePointEvent("click",c)):(v(c,this.getCoordinates(c)),a.isInsidePlot(c.chartX-g,c.chartY-e)&&D(a,"click",c)))};g.prototype.onContainerMouseDown=function(c){var a=1===((c.buttons||c.button)&1);c=this.normalize(c);if(h.isFirefox&&0!==c.button)this.onContainerMouseMove(c);if("undefined"===typeof c.button||a)this.zoomOption(c),a&&c.preventDefault&&c.preventDefault(),this.dragStart(c)};
g.prototype.onContainerMouseLeave=function(c){var a=P[r(h.hoverChartIndex,-1)],d=this.chart.tooltip;c=this.normalize(c);a&&(c.relatedTarget||c.toElement)&&(a.pointer.reset(),a.pointer.chartPosition=void 0);d&&!d.isHidden&&this.reset()};g.prototype.onContainerMouseEnter=function(c){delete this.chartPosition};g.prototype.onContainerMouseMove=function(c){var a=this.chart;c=this.normalize(c);this.setHoverChartIndex();c.preventDefault||(c.returnValue=!1);"mousedown"===a.mouseIsDown&&this.drag(c);a.openMenu||
!this.inClass(c.target,"highcharts-tracker")&&!a.isInsidePlot(c.chartX-a.plotLeft,c.chartY-a.plotTop)||this.runPointActions(c)};g.prototype.onDocumentTouchEnd=function(c){P[h.hoverChartIndex]&&P[h.hoverChartIndex].pointer.drop(c)};g.prototype.onContainerTouchMove=function(c){this.touch(c)};g.prototype.onContainerTouchStart=function(c){this.zoomOption(c);this.touch(c,!0)};g.prototype.onDocumentMouseMove=function(c){var a=this.chart,d=this.chartPosition;c=this.normalize(c,d);var g=a.tooltip;!d||g&&
g.isStickyOnContact()||a.isInsidePlot(c.chartX-a.plotLeft,c.chartY-a.plotTop)||this.inClass(c.target,"highcharts-tracker")||this.reset()};g.prototype.onDocumentMouseUp=function(c){var a=P[r(h.hoverChartIndex,-1)];a&&a.pointer.drop(c)};g.prototype.pinch=function(c){var a=this,d=a.chart,g=a.pinchDown,e=c.touches||[],f=e.length,l=a.lastValidTouch,n=a.hasZoom,h=a.selectionMarker,w={},m=1===f&&(a.inClass(c.target,"highcharts-tracker")&&d.runTrackerClick||a.runChartClick),E={};1<f&&(a.initiated=!0);n&&
a.initiated&&!m&&!1!==c.cancelable&&c.preventDefault();[].map.call(e,function(c){return a.normalize(c)});"touchstart"===c.type?([].forEach.call(e,function(a,b){g[b]={chartX:a.chartX,chartY:a.chartY}}),l.x=[g[0].chartX,g[1]&&g[1].chartX],l.y=[g[0].chartY,g[1]&&g[1].chartY],d.axes.forEach(function(a){if(a.zoomEnabled){var b=d.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,g=a.toPixels(Math.min(r(a.options.min,a.dataMin),a.dataMin)),p=a.toPixels(Math.max(r(a.options.max,a.dataMax),a.dataMax)),q=Math.max(g,
p);b.min=Math.min(a.pos,Math.min(g,p)-c);b.max=Math.max(a.pos+a.len,q+c)}}),a.res=!0):a.followTouchMove&&1===f?this.runPointActions(a.normalize(c)):g.length&&(h||(a.selectionMarker=h=v({destroy:K,touch:!0},d.plotBox)),a.pinchTranslate(g,e,w,h,E,l),a.hasPinched=n,a.scaleGroups(w,E),a.res&&(a.res=!1,this.reset(!1,0)))};g.prototype.pinchTranslate=function(c,a,d,g,e,f){this.zoomHor&&this.pinchTranslateDirection(!0,c,a,d,g,e,f);this.zoomVert&&this.pinchTranslateDirection(!1,c,a,d,g,e,f)};g.prototype.pinchTranslateDirection=
function(c,a,d,g,e,f,l,r){var p=this.chart,q=c?"x":"y",n=c?"X":"Y",h="chart"+n,u=c?"width":"height",b=p["plot"+(c?"Left":"Top")],k,t,B=r||1,w=p.inverted,A=p.bounds[c?"h":"v"],v=1===a.length,G=a[0][h],m=d[0][h],D=!v&&a[1][h],M=!v&&d[1][h];d=function(){"number"===typeof M&&20<Math.abs(G-D)&&(B=r||Math.abs(m-M)/Math.abs(G-D));t=(b-m)/B+G;k=p["plot"+(c?"Width":"Height")]/B};d();a=t;if(a<A.min){a=A.min;var x=!0}else a+k>A.max&&(a=A.max-k,x=!0);x?(m-=.8*(m-l[q][0]),"number"===typeof M&&(M-=.8*(M-l[q][1])),
d()):l[q]=[m,M];w||(f[q]=t-b,f[u]=k);f=w?1/B:B;e[u]=k;e[q]=a;g[w?c?"scaleY":"scaleX":"scale"+n]=B;g["translate"+n]=f*b+(m-f*G)};g.prototype.reset=function(c,a){var g=this.chart,p=g.hoverSeries,e=g.hoverPoint,f=g.hoverPoints,l=g.tooltip,r=l&&l.shared?f:e;c&&r&&d(r).forEach(function(a){a.series.isCartesian&&"undefined"===typeof a.plotX&&(c=!1)});if(c)l&&r&&d(r).length&&(l.refresh(r),l.shared&&f?f.forEach(function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,
a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):e&&(e.setState(e.state,!0),g.axes.forEach(function(a){a.crosshair&&e.series[a.coll]===a&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();f&&f.forEach(function(a){a.setState()});if(p)p.onMouseOut();l&&l.hide(a);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());g.axes.forEach(function(a){a.hideCrosshair()});this.hoverX=g.hoverPoints=g.hoverPoint=null}};g.prototype.runPointActions=function(c,a){var d=this.chart,
g=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,e=g?g.shared:!1,f=a||d.hoverPoint,l=f&&f.series||d.hoverSeries;l=this.getHoverData(f,l,d.series,(!c||"touchmove"!==c.type)&&(!!a||l&&l.directTouch&&this.isDirectTouch),e,c);f=l.hoverPoint;var n=l.hoverPoints;a=(l=l.hoverSeries)&&l.tooltipOptions.followPointer;e=e&&l&&!l.noSharedTooltip;if(f&&(f!==d.hoverPoint||g&&g.isHidden)){(d.hoverPoints||[]).forEach(function(a){-1===n.indexOf(a)&&a.setState()});if(d.hoverSeries!==l)l.onMouseOver();this.applyInactiveState(n);
(n||[]).forEach(function(a){a.setState("hover")});d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!f.series)return;d.hoverPoints=n;d.hoverPoint=f;f.firePointEvent("mouseOver");g&&g.refresh(e?n:f,c)}else a&&g&&!g.isHidden&&(f=g.getAnchor([{}],c),g.updatePosition({plotX:f[0],plotY:f[1]}));this.unDocMouseMove||(this.unDocMouseMove=C(d.container.ownerDocument,"mousemove",function(a){var c=P[h.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(a)}));d.axes.forEach(function(a){var g=r((a.crosshair||
{}).snap,!0),p;g&&((p=d.hoverPoint)&&p.series[a.coll]===a||(p=x(n,function(c){return c.series[a.coll]===a})));p||!g?a.drawCrosshair(c,p):a.hideCrosshair()})};g.prototype.scaleGroups=function(c,a){var d=this.chart,g;d.series.forEach(function(p){g=c||p.getPlotBox();p.xAxis&&p.xAxis.zoomEnabled&&p.group&&(p.group.attr(g),p.markerGroup&&(p.markerGroup.attr(g),p.markerGroup.clip(a?d.clipRect:null)),p.dataLabelsGroup&&p.dataLabelsGroup.attr(g))});d.clipRect.attr(a||d.clipBox)};g.prototype.setDOMEvents=
function(){var c=this.chart.container,a=c.ownerDocument;c.onmousedown=this.onContainerMouseDown.bind(this);c.onmousemove=this.onContainerMouseMove.bind(this);c.onclick=this.onContainerClick.bind(this);this.unbindContainerMouseEnter=C(c,"mouseenter",this.onContainerMouseEnter.bind(this));this.unbindContainerMouseLeave=C(c,"mouseleave",this.onContainerMouseLeave.bind(this));h.unbindDocumentMouseUp||(h.unbindDocumentMouseUp=C(a,"mouseup",this.onDocumentMouseUp.bind(this)));h.hasTouch&&(C(c,"touchstart",
this.onContainerTouchStart.bind(this)),C(c,"touchmove",this.onContainerTouchMove.bind(this)),h.unbindDocumentTouchEnd||(h.unbindDocumentTouchEnd=C(a,"touchend",this.onDocumentTouchEnd.bind(this))))};g.prototype.setHoverChartIndex=function(){var c=this.chart,a=h.charts[r(h.hoverChartIndex,-1)];if(a&&a!==c)a.pointer.onContainerMouseLeave({relatedTarget:!0});a&&a.mouseIsDown||(h.hoverChartIndex=c.index)};g.prototype.touch=function(c,a){var d=this.chart,g;this.setHoverChartIndex();if(1===c.touches.length)if(c=
this.normalize(c),(g=d.isInsidePlot(c.chartX-d.plotLeft,c.chartY-d.plotTop))&&!d.openMenu){a&&this.runPointActions(c);if("touchmove"===c.type){a=this.pinchDown;var e=a[0]?4<=Math.sqrt(Math.pow(a[0].chartX-c.chartX,2)+Math.pow(a[0].chartY-c.chartY,2)):!1}r(e,!0)&&this.pinch(c)}else a&&this.reset();else 2===c.touches.length&&this.pinch(c)};g.prototype.zoomOption=function(c){var a=this.chart,d=a.options.chart,g=d.zoomType||"";a=a.inverted;/touch/.test(c.type)&&(g=r(d.pinchType,g));this.zoomX=c=/x/.test(g);
this.zoomY=g=/y/.test(g);this.zoomHor=c&&!a||g&&a;this.zoomVert=g&&!a||c&&a;this.hasZoom=c||g};return g}();return h.Pointer=f});N(m,"Core/MSPointer.js",[m["Core/Globals.js"],m["Core/Pointer.js"],m["Core/Utilities.js"]],function(f,h,m){function z(){var e=[];e.item=function(e){return this[e]};v(D,function(f){e.push({pageX:f.pageX,pageY:f.pageY,target:f.target})});return e}function F(e,n,h,r){"touch"!==e.pointerType&&e.pointerType!==e.MSPOINTER_TYPE_TOUCH||!K[f.hoverChartIndex]||(r(e),r=K[f.hoverChartIndex].pointer,
r[n]({type:h,target:e.currentTarget,preventDefault:y,touches:z()}))}var P=this&&this.__extends||function(){var e=function(f,l){e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,d){e.__proto__=d}||function(e,d){for(var g in d)d.hasOwnProperty(g)&&(e[g]=d[g])};return e(f,l)};return function(f,l){function r(){this.constructor=f}e(f,l);f.prototype=null===l?Object.create(l):(r.prototype=l.prototype,new r)}}(),K=f.charts,C=f.doc,y=f.noop,e=m.addEvent,I=m.css,v=m.objectEach,x=m.removeEvent,
D={},n=!!f.win.PointerEvent;return function(f){function l(){return null!==f&&f.apply(this,arguments)||this}P(l,f);l.prototype.batchMSEvents=function(e){e(this.chart.container,n?"pointerdown":"MSPointerDown",this.onContainerPointerDown);e(this.chart.container,n?"pointermove":"MSPointerMove",this.onContainerPointerMove);e(C,n?"pointerup":"MSPointerUp",this.onDocumentPointerUp)};l.prototype.destroy=function(){this.batchMSEvents(x);f.prototype.destroy.call(this)};l.prototype.init=function(e,l){f.prototype.init.call(this,
e,l);this.hasZoom&&I(e.container,{"-ms-touch-action":"none","touch-action":"none"})};l.prototype.onContainerPointerDown=function(e){F(e,"onContainerTouchStart","touchstart",function(e){D[e.pointerId]={pageX:e.pageX,pageY:e.pageY,target:e.currentTarget}})};l.prototype.onContainerPointerMove=function(e){F(e,"onContainerTouchMove","touchmove",function(e){D[e.pointerId]={pageX:e.pageX,pageY:e.pageY};D[e.pointerId].target||(D[e.pointerId].target=e.currentTarget)})};l.prototype.onDocumentPointerUp=function(e){F(e,
"onDocumentTouchEnd","touchend",function(e){delete D[e.pointerId]})};l.prototype.setDOMEvents=function(){f.prototype.setDOMEvents.call(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(e)};return l}(h)});N(m,"Core/Legend.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h,m){var z=f.animObject,F=f.setAnimation,L=m.addEvent,K=m.css,C=m.defined,y=m.discardElement,e=m.find,I=m.fireEvent,v=m.format,x=m.isNumber,D=m.merge,n=m.pick,l=m.relativeLength,
J=m.stableSort,w=m.syncTimeout;f=m.wrap;m=h.isFirefox;var r=h.marginNames,d=h.win,g=function(){function c(a,c){this.allItems=[];this.contentGroup=this.box=void 0;this.display=!1;this.group=void 0;this.offsetWidth=this.maxLegendWidth=this.maxItemWidth=this.legendWidth=this.legendHeight=this.lastLineHeight=this.lastItemY=this.itemY=this.itemX=this.itemMarginTop=this.itemMarginBottom=this.itemHeight=this.initialItemY=0;this.options={};this.padding=0;this.pages=[];this.proximate=!1;this.scrollGroup=void 0;
this.widthOption=this.totalItemWidth=this.titleHeight=this.symbolWidth=this.symbolHeight=0;this.chart=a;this.init(a,c)}c.prototype.init=function(a,c){this.chart=a;this.setOptions(c);c.enabled&&(this.render(),L(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=L(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())};c.prototype.setOptions=function(a){var c=n(a.padding,
8);this.options=a;this.chart.styledMode||(this.itemStyle=a.itemStyle,this.itemHiddenStyle=D(this.itemStyle,a.itemHiddenStyle));this.itemMarginTop=a.itemMarginTop||0;this.itemMarginBottom=a.itemMarginBottom||0;this.padding=c;this.initialItemY=c-5;this.symbolWidth=n(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted;this.baseline=void 0};c.prototype.update=function(a,c){var d=this.chart;this.setOptions(D(!0,this.options,a));this.destroy();d.isDirtyLegend=d.isDirtyBox=
!0;n(c,!0)&&d.redraw();I(this,"afterUpdate")};c.prototype.colorizeItem=function(a,c){a.legendGroup[c?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var d=this.options,g=a.legendItem,e=a.legendLine,f=a.legendSymbol,q=this.itemHiddenStyle.color;d=c?d.itemStyle.color:q;var l=c?a.color||q:q,r=a.options&&a.options.marker,n={fill:l};g&&g.css({fill:d,color:d});e&&e.attr({stroke:l});f&&(r&&f.isMarker&&(n=a.pointAttribs(),c||(n.stroke=n.fill=q)),f.attr(n))}I(this,"afterColorizeItem",
{item:a,visible:c})};c.prototype.positionItems=function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()};c.prototype.positionItem=function(a){var c=this,d=this.options,g=d.symbolPadding,e=!d.rtl,f=a._legendItemPos;d=f[0];f=f[1];var l=a.checkbox,n=a.legendGroup;n&&n.element&&(g={translateX:e?d:this.legendWidth-d-2*g-4,translateY:f},e=function(){I(c,"afterPositionItem",{item:a})},C(n.translateY)?n.animate(g,void 0,e):(n.attr(g),e()));l&&(l.x=d,l.y=f)};
c.prototype.destroyItem=function(a){var c=a.checkbox;["legendItem","legendLine","legendSymbol","legendGroup"].forEach(function(c){a[c]&&(a[c]=a[c].destroy())});c&&y(a.checkbox)};c.prototype.destroy=function(){function a(a){this[a]&&(this[a]=this[a].destroy())}this.getAllItems().forEach(function(c){["legendItem","legendGroup"].forEach(a,c)});"clipRect up down pager nav box title group".split(" ").forEach(a,this);this.display=null};c.prototype.positionCheckboxes=function(){var a=this.group&&this.group.alignAttr,
c=this.clipHeight||this.legendHeight,d=this.titleHeight;if(a){var g=a.translateY;this.allItems.forEach(function(e){var p=e.checkbox;if(p){var f=g+d+p.y+(this.scrollOffset||0)+3;K(p,{left:a.translateX+e.checkboxOffset+p.x-20+"px",top:f+"px",display:this.proximate||f>g-6&&f<g+c-6?"":"none"})}},this)}};c.prototype.renderTitle=function(){var a=this.options,c=this.padding,d=a.title,g=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,c-3,c-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}),
this.chart.styledMode||this.title.css(d.style),this.title.add(this.group)),d.width||this.title.css({width:this.maxLegendWidth+"px"}),a=this.title.getBBox(),g=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:g}));this.titleHeight=g};c.prototype.setText=function(a){var c=this.options;a.legendItem.attr({text:c.labelFormat?v(c.labelFormat,a,this.chart):c.labelFormatter.call(a)})};c.prototype.renderItem=function(a){var c=this.chart,d=c.renderer,g=this.options,e=this.symbolWidth,f=g.symbolPadding,
l=this.itemStyle,r=this.itemHiddenStyle,h="horizontal"===g.layout?n(g.itemDistance,20):0,w=!g.rtl,v=a.legendItem,u=!a.series,b=!u&&a.series.drawLegendSymbol?a.series:a,k=b.options;k=this.createCheckboxForItem&&k&&k.showCheckbox;h=e+f+h+(k?20:0);var t=g.useHTML,H=a.options.className;v||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+b.type+"-series highcharts-color-"+a.colorIndex+(H?" "+H:"")+(u?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=v=d.text("",
w?e+f:-f,this.baseline||0,t),c.styledMode||v.css(D(a.visible?l:r)),v.attr({align:w?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(this.fontMetrics=d.fontMetrics(c.styledMode?12:l.fontSize,v),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,v.attr("y",this.baseline)),this.symbolHeight=g.symbolHeight||this.fontMetrics.f,b.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,v,t));k&&!a.checkbox&&this.createCheckboxForItem&&this.createCheckboxForItem(a);this.colorizeItem(a,
a.visible);!c.styledMode&&l.width||v.css({width:(g.itemWidth||this.widthOption||c.spacingBox.width)-h+"px"});this.setText(a);c=v.getBBox();a.itemWidth=a.checkboxOffset=g.itemWidth||a.legendItemWidth||c.width+h;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||c.height||this.symbolHeight)};c.prototype.layoutItem=function(a){var c=this.options,d=this.padding,g="horizontal"===c.layout,e=a.itemHeight,
f=this.itemMarginBottom,l=this.itemMarginTop,r=g?n(c.itemDistance,20):0,h=this.maxLegendWidth;c=c.alignColumns&&this.totalItemWidth>h?this.maxItemWidth:a.itemWidth;g&&this.itemX-d+c>h&&(this.itemX=d,this.lastLineHeight&&(this.itemY+=l+this.lastLineHeight+f),this.lastLineHeight=0);this.lastItemY=l+this.itemY+f;this.lastLineHeight=Math.max(e,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];g?this.itemX+=c:(this.itemY+=l+e+f,this.lastLineHeight=e);this.offsetWidth=this.widthOption||Math.max((g?
this.itemX-d-(a.checkbox?0:r):c)+d,this.offsetWidth)};c.prototype.getAllItems=function(){var a=[];this.chart.series.forEach(function(c){var d=c&&c.options;c&&n(d.showInLegend,C(d.linkedTo)?!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===d.legendType?c.data:c)))});I(this,"afterGetAllItems",{allItems:a});return a};c.prototype.getAlignment=function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)};c.prototype.adjustMargins=
function(a,c){var d=this.chart,g=this.options,e=this.getAlignment();e&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(f,p){f.test(e)&&!C(a[p])&&(d[r[p]]=Math.max(d[r[p]],d.legend[(p+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][p]*g[p%2?"x":"y"]+n(g.margin,12)+c[p]+(d.titleOffset[p]||0)))})};c.prototype.proximatePositions=function(){var a=this.chart,c=[],d="left"===this.options.align;this.allItems.forEach(function(g){var f;var p=d;if(g.yAxis){g.xAxis.options.reversed&&
(p=!p);g.points&&(f=e(p?g.points:g.points.slice(0).reverse(),function(a){return x(a.plotY)}));p=this.itemMarginTop+g.legendItem.getBBox().height+this.itemMarginBottom;var q=g.yAxis.top-a.plotTop;g.visible?(f=f?f.plotY:g.yAxis.height,f+=q-.3*p):f=q+g.yAxis.height;c.push({target:f,size:p,item:g})}},this);h.distribute(c,a.plotHeight);c.forEach(function(c){c.item._legendItemPos[1]=a.plotTop-a.spacing[0]+c.pos})};c.prototype.render=function(){var a=this.chart,c=a.renderer,d=this.group,g=this.box,e=this.options,
f=this.padding;this.itemX=f;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;this.widthOption=l(e.width,a.spacingBox.width-f);var n=a.spacingBox.width-2*f-e.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(n/=2);this.maxLegendWidth=this.widthOption||n;d||(this.group=d=c.g("legend").attr({zIndex:7}).add(),this.contentGroup=c.g().attr({zIndex:1}).add(d),this.scrollGroup=c.g().add(this.contentGroup));this.renderTitle();var r=this.getAllItems();J(r,function(a,c){return(a.options&&
a.options.legendIndex||0)-(c.options&&c.options.legendIndex||0)});e.reversed&&r.reverse();this.allItems=r;this.display=n=!!r.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;r.forEach(this.renderItem,this);r.forEach(this.layoutItem,this);r=(this.widthOption||this.offsetWidth)+f;var h=this.lastItemY+this.lastLineHeight+this.titleHeight;h=this.handleOverflow(h);h+=f;g||(this.box=g=c.rect().addClass("highcharts-legend-box").attr({r:e.borderRadius}).add(d),g.isNew=!0);
a.styledMode||g.attr({stroke:e.borderColor,"stroke-width":e.borderWidth||0,fill:e.backgroundColor||"none"}).shadow(e.shadow);0<r&&0<h&&(g[g.isNew?"attr":"animate"](g.crisp.call({},{x:0,y:0,width:r,height:h},g.strokeWidth())),g.isNew=!1);g[n?"show":"hide"]();a.styledMode&&"none"===d.getStyle("display")&&(r=h=0);this.legendWidth=r;this.legendHeight=h;n&&this.align();this.proximate||this.positionItems();I(this,"afterRender")};c.prototype.align=function(a){void 0===a&&(a=this.chart.spacingBox);var c=
this.chart,d=this.options,g=a.y;/(lth|ct|rth)/.test(this.getAlignment())&&0<c.titleOffset[0]?g+=c.titleOffset[0]:/(lbh|cb|rbh)/.test(this.getAlignment())&&0<c.titleOffset[2]&&(g-=c.titleOffset[2]);g!==a.y&&(a=D(a,{y:g}));this.group.align(D(d,{width:this.legendWidth,height:this.legendHeight,verticalAlign:this.proximate?"top":d.verticalAlign}),!0,a)};c.prototype.handleOverflow=function(a){var c=this,d=this.chart,g=d.renderer,e=this.options,f=e.y,l=this.padding;f=d.spacingBox.height+("top"===e.verticalAlign?
-f:f)-l;var r=e.maxHeight,h,w=this.clipRect,v=e.navigation,u=n(v.animation,!0),b=v.arrowSize||12,k=this.nav,t=this.pages,H,m=this.allItems,D=function(a){"number"===typeof a?w.attr({height:a}):w&&(c.clipRect=w.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=a?"rect("+l+"px,9999px,"+(l+a)+"px,0)":"auto")},x=function(a){c[a]=g.circle(0,0,1.3*b).translate(b/2,b/2).add(k);d.styledMode||c[a].attr("fill","rgba(0,0,0,0.0001)");return c[a]};"horizontal"!==e.layout||"middle"===
e.verticalAlign||e.floating||(f/=2);r&&(f=Math.min(f,r));t.length=0;a>f&&!1!==v.enabled?(this.clipHeight=h=Math.max(f-20-this.titleHeight-l,0),this.currentPage=n(this.currentPage,1),this.fullHeight=a,m.forEach(function(a,b){var c=a._legendItemPos[1],d=Math.round(a.legendItem.getBBox().height),g=t.length;if(!g||c-t[g-1]>h&&(H||c)!==t[g-1])t.push(H||c),g++;a.pageIx=g-1;H&&(m[b-1].pageIx=g-1);b===m.length-1&&c+d-t[g-1]>h&&c!==H&&(t.push(c),a.pageIx=g);c!==H&&(H=c)}),w||(w=c.clipRect=g.clipRect(0,l,9999,
0),c.contentGroup.clip(w)),D(h),k||(this.nav=k=g.g().attr({zIndex:1}).add(this.group),this.up=g.symbol("triangle",0,0,b,b).add(k),x("upTracker").on("click",function(){c.scroll(-1,u)}),this.pager=g.text("",15,10).addClass("highcharts-legend-navigation"),d.styledMode||this.pager.css(v.style),this.pager.add(k),this.down=g.symbol("triangle-down",0,0,b,b).add(k),x("downTracker").on("click",function(){c.scroll(1,u)})),c.scroll(0),a=f):k&&(D(),this.nav=k.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=
0);return a};c.prototype.scroll=function(a,c){var d=this,g=this.chart,e=this.pages,f=e.length,l=this.currentPage+a;a=this.clipHeight;var q=this.options.navigation,r=this.pager,h=this.padding;l>f&&(l=f);0<l&&("undefined"!==typeof c&&F(c,g),this.nav.attr({translateX:h,translateY:a+this.padding+7+this.titleHeight,visibility:"visible"}),[this.up,this.upTracker].forEach(function(a){a.attr({"class":1===l?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),r.attr({text:l+"/"+f}),[this.down,
this.downTracker].forEach(function(a){a.attr({x:18+this.pager.getBBox().width,"class":l===f?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),g.styledMode||(this.up.attr({fill:1===l?q.inactiveColor:q.activeColor}),this.upTracker.css({cursor:1===l?"default":"pointer"}),this.down.attr({fill:l===f?q.inactiveColor:q.activeColor}),this.downTracker.css({cursor:l===f?"default":"pointer"})),this.scrollOffset=-e[l-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),
this.currentPage=l,this.positionCheckboxes(),c=z(n(c,g.renderer.globalAnimation,!0)),w(function(){I(d,"afterScroll",{currentPage:l})},c.duration))};return c}();(/Trident\/7\.0/.test(d.navigator&&d.navigator.userAgent)||m)&&f(g.prototype,"positionItem",function(c,a){var d=this,g=function(){a._legendItemPos&&c.call(d,a)};g();d.bubbleLegend||setTimeout(g)});h.Legend=g;return h.Legend});N(m,"Core/Series/Point.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Globals.js"],m["Core/Utilities.js"]],
function(f,h,m){var z=f.animObject,F=m.defined,L=m.erase,K=m.extend,C=m.fireEvent,y=m.format,e=m.getNestedProperty,I=m.isArray,v=m.isNumber,x=m.isObject,D=m.syncTimeout,n=m.pick,l=m.removeEvent,J=m.uniqueKey;"";f=function(){function f(){this.colorIndex=this.category=void 0;this.formatPrefix="point";this.id=void 0;this.isNull=!1;this.percentage=this.options=this.name=void 0;this.selected=!1;this.total=this.series=void 0;this.visible=!0;this.x=void 0}f.prototype.animateBeforeDestroy=function(){var e=
this,d={x:e.startXPos,opacity:0},g,c=e.getGraphicalProps();c.singular.forEach(function(a){g="dataLabel"===a;e[a]=e[a].animate(g?{x:e[a].startXPos,y:e[a].startYPos,opacity:0}:d)});c.plural.forEach(function(a){e[a].forEach(function(a){a.element&&a.animate(K({x:e.startXPos},a.startYPos?{x:a.startXPos,y:a.startYPos}:{}))})})};f.prototype.applyOptions=function(e,d){var g=this.series,c=g.options.pointValKey||g.pointValKey;e=f.prototype.optionsToObject.call(this,e);K(this,e);this.options=this.options?K(this.options,
e):e;e.group&&delete this.group;e.dataLabels&&delete this.dataLabels;c&&(this.y=f.prototype.getNestedProperty.call(this,c));this.formatPrefix=(this.isNull=n(this.isValid&&!this.isValid(),null===this.x||!v(this.y)))?"null":"point";this.selected&&(this.state="select");"name"in this&&"undefined"===typeof d&&g.xAxis&&g.xAxis.hasNames&&(this.x=g.xAxis.nameToX(this));"undefined"===typeof this.x&&g&&(this.x="undefined"===typeof d?g.autoIncrement(this):d);return this};f.prototype.destroy=function(){function e(){if(d.graphic||
d.dataLabel||d.dataLabels)l(d),d.destroyElements();for(p in d)d[p]=null}var d=this,g=d.series,c=g.chart;g=g.options.dataSorting;var a=c.hoverPoints,f=z(d.series.chart.renderer.globalAnimation),p;d.legendItem&&c.legend.destroyItem(d);a&&(d.setState(),L(a,d),a.length||(c.hoverPoints=null));if(d===c.hoverPoint)d.onMouseOut();g&&g.enabled?(this.animateBeforeDestroy(),D(e,f.duration)):e();c.pointCount--};f.prototype.destroyElements=function(e){var d=this;e=d.getGraphicalProps(e);e.singular.forEach(function(g){d[g]=
d[g].destroy()});e.plural.forEach(function(g){d[g].forEach(function(c){c.element&&c.destroy()});delete d[g]})};f.prototype.firePointEvent=function(e,d,g){var c=this,a=this.series.options;(a.point.events[e]||c.options&&c.options.events&&c.options.events[e])&&c.importEvents();"click"===e&&a.allowPointSelect&&(g=function(a){c.select&&c.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});C(c,e,d,g)};f.prototype.getClassName=function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+
(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+("undefined"!==typeof this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")};f.prototype.getGraphicalProps=function(e){var d=this,g=[],c,a={singular:[],plural:[]};e=e||{graphic:1,dataLabel:1};e.graphic&&g.push("graphic","shadowGroup");e.dataLabel&&g.push("dataLabel",
"dataLabelUpper","connector");for(c=g.length;c--;){var f=g[c];d[f]&&a.singular.push(f)}["dataLabel","connector"].forEach(function(c){var g=c+"s";e[c]&&d[g]&&a.plural.push(g)});return a};f.prototype.getLabelConfig=function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}};f.prototype.getNestedProperty=function(f){if(f)return 0===f.indexOf("custom.")?
e(f,this.options):this[f]};f.prototype.getZone=function(){var e=this.series,d=e.zones;e=e.zoneAxis||"y";var g=0,c;for(c=d[g];this[e]>=c.value;)c=d[++g];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=c&&c.color&&!this.options.color?c.color:this.nonZonedColor;return c};f.prototype.hasNewShapeType=function(){return(this.graphic&&(this.graphic.symbolName||this.graphic.element.nodeName))!==this.shapeType};f.prototype.init=function(e,d,g){this.series=e;this.applyOptions(d,g);this.id=F(this.id)?
this.id:J();this.resolveColor();e.chart.pointCount++;C(this,"afterInit");return this};f.prototype.optionsToObject=function(e){var d={},g=this.series,c=g.options.keys,a=c||g.pointArrayMap||["y"],l=a.length,p=0,n=0;if(v(e)||null===e)d[a[0]]=e;else if(I(e))for(!c&&e.length>l&&(g=typeof e[0],"string"===g?d.name=e[0]:"number"===g&&(d.x=e[0]),p++);n<l;)c&&"undefined"===typeof e[p]||(0<a[n].indexOf(".")?f.prototype.setNestedProperty(d,e[p],a[n]):d[a[n]]=e[p]),p++,n++;else"object"===typeof e&&(d=e,e.dataLabels&&
(g._hasPointLabels=!0),e.marker&&(g._hasPointMarkers=!0));return d};f.prototype.resolveColor=function(){var e=this.series;var d=e.chart.options.chart.colorCount;var g=e.chart.styledMode;delete this.nonZonedColor;g||this.options.color||(this.color=e.color);e.options.colorByPoint?(g||(d=e.options.colors||e.chart.options.colors,this.color=this.color||d[e.colorCounter],d=d.length),g=e.colorCounter,e.colorCounter++,e.colorCounter===d&&(e.colorCounter=0)):g=e.colorIndex;this.colorIndex=n(this.colorIndex,
g)};f.prototype.setNestedProperty=function(e,d,g){g.split(".").reduce(function(c,a,g,e){c[a]=e.length-1===g?d:x(c[a],!0)?c[a]:{};return c[a]},e);return e};f.prototype.tooltipFormatter=function(e){var d=this.series,g=d.tooltipOptions,c=n(g.valueDecimals,""),a=g.valuePrefix||"",f=g.valueSuffix||"";d.chart.styledMode&&(e=d.chart.tooltip.styledModeFormat(e));(d.pointArrayMap||["y"]).forEach(function(d){d="{point."+d;if(a||f)e=e.replace(RegExp(d+"}","g"),a+d+"}"+f);e=e.replace(RegExp(d+"}","g"),d+":,."+
c+"f}")});return y(e,{point:this,series:this.series},d.chart)};return f}();return h.Point=f});N(m,"Core/Series/Series.js",[m["Core/Globals.js"],m["Core/Series/Point.js"],m["Core/Utilities.js"]],function(f,h,m){var z=m.error,F=m.extendClass,L=m.fireEvent,K=m.getOptions,C=m.isObject,y=m.merge,e=m.objectEach;m=function(){function f(e,h){var v=y(f.defaultOptions,h);this.chart=e;this._i=e.series.length;e.series.push(this);this.options=v;this.userOptions=y(h)}f.addSeries=function(e,h){f.seriesTypes[e]=
h};f.cleanRecursively=function(h,m){var v={};e(h,function(e,l){if(C(h[l],!0)&&!h.nodeType&&m[l])e=f.cleanRecursively(h[l],m[l]),Object.keys(e).length&&(v[l]=e);else if(C(h[l])||h[l]!==m[l])v[l]=h[l]});return v};f.getSeries=function(e,h){void 0===h&&(h={});var v=e.options.chart;v=h.type||v.type||v.defaultSeriesType||"";var n=f.seriesTypes[v];n||z(17,!0,e,{missingModuleFor:v});return new n(e,h)};f.seriesType=function(e,m,D,n,l){var v=K().plotOptions||{},w=f.seriesTypes;m=m||"";v[e]=y(v[m],D);f.addSeries(e,
F(w[m]||function(){},n));w[e].prototype.type=e;l&&(w[e].prototype.pointClass=F(h,l));return w[e]};f.prototype.update=function(e,h){void 0===h&&(h=!0);var m=this;e=f.cleanRecursively(e,this.userOptions);var n=e.type;"undefined"!==typeof n&&n!==m.type&&(m=f.getSeries(m.chart,e));L(m,"update",{newOptions:e});m.userOptions=y(e);L(m,"afterUpdate",{newOptions:e});h&&m.chart.redraw();return m};f.defaultOptions={type:"base"};f.seriesTypes={};return f}();m.prototype.pointClass=h;f.seriesType=m.seriesType;
f.seriesTypes=m.seriesTypes;return m});N(m,"Core/Chart/Chart.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Axis/Axis.js"],m["Core/Series/Series.js"],m["Core/Globals.js"],m["Core/Legend.js"],m["Core/MSPointer.js"],m["Core/Options.js"],m["Core/Pointer.js"],m["Core/Time.js"],m["Core/Utilities.js"]],function(f,h,m,z,F,L,K,C,y,e){var I=f.animate,v=f.animObject,x=f.setAnimation,D=z.charts,n=z.doc,l=z.win,J=K.defaultOptions,w=e.addEvent,r=e.attr,d=e.createElement,g=e.css,c=e.defined,a=e.discardElement,
q=e.erase,p=e.error,B=e.extend,A=e.find,G=e.fireEvent,M=e.getStyle,T=e.isArray,Q=e.isFunction,O=e.isNumber,E=e.isObject,u=e.isString,b=e.merge,k=e.numberFormat,t=e.objectEach,H=e.pick,R=e.pInt,U=e.relativeLength,Z=e.removeEvent,aa=e.splat,ba=e.syncTimeout,S=e.uniqueKey,Y=z.marginNames,W=function(){function f(a,b,c){this.yAxis=this.xAxis=this.userOptions=this.titleOffset=this.time=this.symbolCounter=this.spacingBox=this.spacing=this.series=this.renderTo=this.renderer=this.pointer=this.pointCount=this.plotWidth=
this.plotTop=this.plotLeft=this.plotHeight=this.plotBox=this.options=this.numberFormatter=this.margin=this.legend=this.labelCollectors=this.isResizing=this.index=this.container=this.colorCounter=this.clipBox=this.chartWidth=this.chartHeight=this.bounds=this.axisOffset=this.axes=void 0;this.getArgs(a,b,c)}f.prototype.getArgs=function(a,b,c){u(a)||a.nodeName?(this.renderTo=a,this.init(b,c)):this.init(a,b)};f.prototype.init=function(a,c){var d,g=a.series,e=a.plotOptions||{};G(this,"init",{args:arguments},
function(){a.series=null;d=b(J,a);var f=d.chart||{};t(d.plotOptions,function(a,c){E(a)&&(a.tooltip=e[c]&&b(e[c].tooltip)||void 0)});d.tooltip.userOptions=a.chart&&a.chart.forExport&&a.tooltip.userOptions||a.tooltip;d.series=a.series=g;this.userOptions=a;var p=f.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=d;this.axes=[];this.series=[];this.time=a.time&&Object.keys(a.time).length?new y(a.time):z.time;this.numberFormatter=
f.numberFormatter||k;this.styledMode=f.styledMode;this.hasCartesianSeries=f.showAxes;var l=this;l.index=D.length;D.push(l);z.chartCount++;p&&t(p,function(a,b){Q(a)&&w(l,b,a)});l.xAxis=[];l.yAxis=[];l.pointCount=l.colorCounter=l.symbolCounter=0;G(l,"afterInit");l.firstRender()})};f.prototype.initSeries=function(a){var b=this.options.chart;b=a.type||b.type||b.defaultSeriesType;var c=m.seriesTypes[b];c||p(17,!0,this,{missingModuleFor:b});b=new c(this,a);"function"===typeof b.init&&b.init(this,a);return b};
f.prototype.setSeriesData=function(){this.getSeriesOrderByLinks().forEach(function(a){a.points||a.data||!a.enabledDataSorting||a.setData(a.options.data,!1)})};f.prototype.getSeriesOrderByLinks=function(){return this.series.concat().sort(function(a,b){return a.linkedSeries.length||b.linkedSeries.length?b.linkedSeries.length-a.linkedSeries.length:0})};f.prototype.orderSeries=function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())};f.prototype.isInsidePlot=
function(a,b,c){var d=c?b:a;a=c?a:b;d={x:d,y:a,isInsidePlot:0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight};G(this,"afterIsInsidePlot",d);return d.isInsidePlot};f.prototype.redraw=function(a){G(this,"beforeRedraw");var b=this,c=b.axes,d=b.series,g=b.pointer,k=b.legend,e=b.userOptions.legend,f=b.isDirtyLegend,t=b.hasCartesianSeries,p=b.isDirtyBox,l=b.renderer,q=l.isHidden(),h=[];b.setResponsive&&b.setResponsive(!1);x(b.hasRendered?a:!1,b);q&&b.temporaryDisplay();b.layOutTitles();for(a=d.length;a--;){var n=
d[a];if(n.options.stacking){var u=!0;if(n.isDirty){var r=!0;break}}}if(r)for(a=d.length;a--;)n=d[a],n.options.stacking&&(n.isDirty=!0);d.forEach(function(a){a.isDirty&&("point"===a.options.legendType?("function"===typeof a.updateTotals&&a.updateTotals(),f=!0):e&&(e.labelFormatter||e.labelFormat)&&(f=!0));a.isDirtyData&&G(a,"updatedData")});f&&k&&k.options.enabled&&(k.render(),b.isDirtyLegend=!1);u&&b.getStacks();t&&c.forEach(function(a){b.isResizing&&O(a.min)||(a.updateNames(),a.setScale())});b.getMargins();
t&&(c.forEach(function(a){a.isDirty&&(p=!0)}),c.forEach(function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,h.push(function(){G(a,"afterSetExtremes",B(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(p||u)&&a.redraw()}));p&&b.drawChartBox();G(b,"predraw");d.forEach(function(a){(p||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});g&&g.reset(!0);l.draw();G(b,"redraw");G(b,"render");q&&b.temporaryDisplay(!0);h.forEach(function(a){a.call()})};f.prototype.get=function(a){function b(b){return b.id===
a||b.options&&b.options.id===a}var c=this.series,d;var g=A(this.axes,b)||A(this.series,b);for(d=0;!g&&d<c.length;d++)g=A(c[d].points||[],b);return g};f.prototype.getAxes=function(){var a=this,b=this.options,c=b.xAxis=aa(b.xAxis||{});b=b.yAxis=aa(b.yAxis||{});G(this,"getAxes");c.forEach(function(a,b){a.index=b;a.isX=!0});b.forEach(function(a,b){a.index=b});c.concat(b).forEach(function(b){new h(a,b)});G(this,"afterGetAxes")};f.prototype.getSelectedPoints=function(){var a=[];this.series.forEach(function(b){a=
a.concat(b.getPointsCollection().filter(function(a){return H(a.selectedStaging,a.selected)}))});return a};f.prototype.getSelectedSeries=function(){return this.series.filter(function(a){return a.selected})};f.prototype.setTitle=function(a,b,c){this.applyDescription("title",a);this.applyDescription("subtitle",b);this.applyDescription("caption",void 0);this.layOutTitles(c)};f.prototype.applyDescription=function(a,c){var d=this,g="title"===a?{color:"#333333",fontSize:this.options.isStock?"16px":"18px"}:
{color:"#666666"};g=this.options[a]=b(!this.styledMode&&{style:g},this.options[a],c);var k=this[a];k&&c&&(this[a]=k=k.destroy());g&&!k&&(k=this.renderer.text(g.text,0,0,g.useHTML).attr({align:g.align,"class":"highcharts-"+a,zIndex:g.zIndex||4}).add(),k.update=function(b){d[{title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"}[a]](b)},this.styledMode||k.css(g.style),this[a]=k)};f.prototype.layOutTitles=function(a){var b=[0,0,0],c=this.renderer,d=this.spacingBox;["title","subtitle","caption"].forEach(function(a){var g=
this[a],k=this.options[a],e=k.verticalAlign||"top";a="title"===a?-3:"top"===e?b[0]+2:0;if(g){if(!this.styledMode)var f=k.style.fontSize;f=c.fontMetrics(f,g).b;g.css({width:(k.width||d.width+(k.widthAdjust||0))+"px"});var t=Math.round(g.getBBox(k.useHTML).height);g.align(B({y:"bottom"===e?f:a+f,height:t},k),!1,"spacingBox");k.floating||("top"===e?b[0]=Math.ceil(b[0]+t):"bottom"===e&&(b[2]=Math.ceil(b[2]+t)))}},this);b[0]&&"top"===(this.options.title.verticalAlign||"top")&&(b[0]+=this.options.title.margin);
b[2]&&"bottom"===this.options.caption.verticalAlign&&(b[2]+=this.options.caption.margin);var g=!this.titleOffset||this.titleOffset.join(",")!==b.join(",");this.titleOffset=b;G(this,"afterLayOutTitles");!this.isDirtyBox&&g&&(this.isDirtyBox=this.isDirtyLegend=g,this.hasRendered&&H(a,!0)&&this.isDirtyBox&&this.redraw())};f.prototype.getChartSize=function(){var a=this.options.chart,b=a.width;a=a.height;var d=this.renderTo;c(b)||(this.containerWidth=M(d,"width"));c(a)||(this.containerHeight=M(d,"height"));
this.chartWidth=Math.max(0,b||this.containerWidth||600);this.chartHeight=Math.max(0,U(a,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))};f.prototype.temporaryDisplay=function(a){var b=this.renderTo;if(a)for(;b&&b.style;)b.hcOrigStyle&&(g(b,b.hcOrigStyle),delete b.hcOrigStyle),b.hcOrigDetached&&(n.body.removeChild(b),b.hcOrigDetached=!1),b=b.parentNode;else for(;b&&b.style;){n.body.contains(b)||b.parentNode||(b.hcOrigDetached=!0,n.body.appendChild(b));if("none"===M(b,"display",
!1)||b.hcOricDetached)b.hcOrigStyle={display:b.style.display,height:b.style.height,overflow:b.style.overflow},a={display:"block",overflow:"hidden"},b!==this.renderTo&&(a.height=0),g(b,a),b.offsetWidth||b.style.setProperty("display","block","important");b=b.parentNode;if(b===n.body)break}};f.prototype.setClassName=function(a){this.container.className="highcharts-container "+(a||"")};f.prototype.getContainer=function(){var a=this.options,b=a.chart;var c=this.renderTo;var k=S(),e,f;c||(this.renderTo=
c=b.renderTo);u(c)&&(this.renderTo=c=n.getElementById(c));c||p(13,!0,this);var t=R(r(c,"data-highcharts-chart"));O(t)&&D[t]&&D[t].hasRendered&&D[t].destroy();r(c,"data-highcharts-chart",this.index);c.innerHTML="";b.skipClone||c.offsetWidth||this.temporaryDisplay();this.getChartSize();t=this.chartWidth;var l=this.chartHeight;g(c,{overflow:"hidden"});this.styledMode||(e=B({position:"relative",overflow:"hidden",width:t+"px",height:l+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)",
userSelect:"none"},b.style));this.container=c=d("div",{id:k},e,c);this._cursor=c.style.cursor;this.renderer=new (z[b.renderer]||z.Renderer)(c,t,l,null,b.forExport,a.exporting&&a.exporting.allowHTML,this.styledMode);x(void 0,this);this.setClassName(b.className);if(this.styledMode)for(f in a.defs)this.renderer.definition(a.defs[f]);else this.renderer.setStyle(b.style);this.renderer.chartIndex=this.index;G(this,"afterGetContainer")};f.prototype.getMargins=function(a){var b=this.spacing,d=this.margin,
g=this.titleOffset;this.resetMargins();g[0]&&!c(d[0])&&(this.plotTop=Math.max(this.plotTop,g[0]+b[0]));g[2]&&!c(d[2])&&(this.marginBottom=Math.max(this.marginBottom,g[2]+b[2]));this.legend&&this.legend.display&&this.legend.adjustMargins(d,b);G(this,"getMargins");a||this.getAxisMargins()};f.prototype.getAxisMargins=function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.colorAxis,g=a.margin,k=function(a){a.forEach(function(a){a.visible&&a.getOffset()})};a.hasCartesianSeries?k(a.axes):d&&d.length&&k(d);
Y.forEach(function(d,k){c(g[k])||(a[d]+=b[k])});a.setChartSize()};f.prototype.reflow=function(a){var b=this,d=b.options.chart,g=b.renderTo,k=c(d.width)&&c(d.height),f=d.width||M(g,"width");d=d.height||M(g,"height");g=a?a.target:l;if(!k&&!b.isPrinting&&f&&d&&(g===l||g===n)){if(f!==b.containerWidth||d!==b.containerHeight)e.clearTimeout(b.reflowTimeout),b.reflowTimeout=ba(function(){b.container&&b.setSize(void 0,void 0,!1)},a?100:0);b.containerWidth=f;b.containerHeight=d}};f.prototype.setReflow=function(a){var b=
this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=w(l,"resize",function(a){b.options&&b.reflow(a)}),w(this,"destroy",this.unbindReflow))};f.prototype.setSize=function(a,b,c){var d=this,k=d.renderer;d.isResizing+=1;x(c,d);c=k.globalAnimation;d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;"undefined"!==typeof a&&(d.options.chart.width=a);"undefined"!==typeof b&&(d.options.chart.height=b);d.getChartSize();d.styledMode||(c?
I:g)(d.container,{width:d.chartWidth+"px",height:d.chartHeight+"px"},c);d.setChartSize(!0);k.setSize(d.chartWidth,d.chartHeight,c);d.axes.forEach(function(a){a.isDirty=!0;a.setScale()});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(c);d.oldChartHeight=null;G(d,"resize");ba(function(){d&&G(d,"endResize",null,function(){--d.isResizing})},v(c).duration)};f.prototype.setChartSize=function(a){var b=this.inverted,c=this.renderer,d=this.chartWidth,g=this.chartHeight,k=this.options.chart,
e=this.spacing,f=this.clipOffset,t,p,l,q;this.plotLeft=t=Math.round(this.plotLeft);this.plotTop=p=Math.round(this.plotTop);this.plotWidth=l=Math.max(0,Math.round(d-t-this.marginRight));this.plotHeight=q=Math.max(0,Math.round(g-p-this.marginBottom));this.plotSizeX=b?q:l;this.plotSizeY=b?l:q;this.plotBorderWidth=k.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:e[3],y:e[0],width:d-e[3]-e[1],height:g-e[0]-e[2]};this.plotBox=c.plotBox={x:t,y:p,width:l,height:q};d=2*Math.floor(this.plotBorderWidth/
2);b=Math.ceil(Math.max(d,f[3])/2);c=Math.ceil(Math.max(d,f[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(d,f[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(d,f[2])/2-c))};a||this.axes.forEach(function(a){a.setAxisSize();a.setAxisTranslation()});G(this,"afterSetChartSize",{skipAxes:a})};f.prototype.resetMargins=function(){G(this,"resetMargins");var a=this,b=a.options.chart;["margin","spacing"].forEach(function(c){var d=b[c],g=E(d)?d:[d,d,d,d];["Top","Right",
"Bottom","Left"].forEach(function(d,k){a[c][k]=H(b[c+d],g[k])})});Y.forEach(function(b,c){a[b]=H(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]};f.prototype.drawChartBox=function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,d=this.chartHeight,g=this.chartBackground,k=this.plotBackground,e=this.plotBorder,f=this.styledMode,t=this.plotBGImage,p=a.backgroundColor,l=a.plotBackgroundColor,q=a.plotBackgroundImage,h,n=this.plotLeft,u=this.plotTop,r=this.plotWidth,
m=this.plotHeight,w=this.plotBox,v=this.clipRect,H=this.clipBox,B="animate";g||(this.chartBackground=g=b.rect().addClass("highcharts-background").add(),B="attr");if(f)var A=h=g.strokeWidth();else{A=a.borderWidth||0;h=A+(a.shadow?8:0);p={fill:p||"none"};if(A||g["stroke-width"])p.stroke=a.borderColor,p["stroke-width"]=A;g.attr(p).shadow(a.shadow)}g[B]({x:h/2,y:h/2,width:c-h-A%2,height:d-h-A%2,r:a.borderRadius});B="animate";k||(B="attr",this.plotBackground=k=b.rect().addClass("highcharts-plot-background").add());
k[B](w);f||(k.attr({fill:l||"none"}).shadow(a.plotShadow),q&&(t?(q!==t.attr("href")&&t.attr("href",q),t.animate(w)):this.plotBGImage=b.image(q,n,u,r,m).add()));v?v.animate({width:H.width,height:H.height}):this.clipRect=b.clipRect(H);B="animate";e||(B="attr",this.plotBorder=e=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());f||e.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});e[B](e.crisp({x:n,y:u,width:r,height:m},-e.strokeWidth()));this.isDirtyBox=
!1;G(this,"afterDrawChartBox")};f.prototype.propFromSeries=function(){var a=this,b=a.options.chart,c,d=a.options.series,g,k;["inverted","angular","polar"].forEach(function(e){c=m.seriesTypes[b.type||b.defaultSeriesType];k=b[e]||c&&c.prototype[e];for(g=d&&d.length;!k&&g--;)(c=m.seriesTypes[d[g].type])&&c.prototype[e]&&(k=!0);a[e]=k})};f.prototype.linkSeries=function(){var a=this,b=a.series;b.forEach(function(a){a.linkedSeries.length=0});b.forEach(function(b){var c=b.options.linkedTo;u(c)&&(c=":previous"===
c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,c.enabledDataSorting&&b.setDataSortingOptions(),b.visible=H(b.options.visible,c.options.visible,b.visible))});G(this,"afterLinkSeries")};f.prototype.renderSeries=function(){this.series.forEach(function(a){a.translate();a.render()})};f.prototype.renderLabels=function(){var a=this,b=a.options.labels;b.items&&b.items.forEach(function(c){var d=B(b.style,c.style),g=R(d.left)+a.plotLeft,k=R(d.top)+a.plotTop+12;
delete d.left;delete d.top;a.renderer.text(c.html,g,k).attr({zIndex:2}).css(d).add()})};f.prototype.render=function(){var a=this.axes,b=this.colorAxis,c=this.renderer,d=this.options,g=0,k=function(a){a.forEach(function(a){a.visible&&a.render()})};this.setTitle();this.legend=new F(this,d.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();d=this.plotWidth;a.some(function(a){if(a.horiz&&a.visible&&a.options.labels.enabled&&a.series.length)return g=21,!0});var e=this.plotHeight=
Math.max(this.plotHeight-g,0);a.forEach(function(a){a.setScale()});this.getAxisMargins();var f=1.1<d/this.plotWidth;var t=1.05<e/this.plotHeight;if(f||t)a.forEach(function(a){(a.horiz&&f||!a.horiz&&t)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries?k(a):b&&b.length&&k(b);this.seriesGroup||(this.seriesGroup=c.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.updateContainerScaling();
this.hasRendered=!0};f.prototype.addCredits=function(a){var c=this,d=b(!0,this.options.credits,a);d.enabled&&!this.credits&&(this.credits=this.renderer.text(d.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){d.href&&(l.location.href=d.href)}).attr({align:d.position.align,zIndex:8}),c.styledMode||this.credits.css(d.style),this.credits.add().align(d.position),this.credits.update=function(a){c.credits=c.credits.destroy();c.addCredits(a)})};f.prototype.updateContainerScaling=
function(){var a=this.container;if(2<a.offsetWidth&&2<a.offsetHeight&&a.getBoundingClientRect){var b=a.getBoundingClientRect(),c=b.width/a.offsetWidth;a=b.height/a.offsetHeight;1!==c||1!==a?this.containerScaling={scaleX:c,scaleY:a}:delete this.containerScaling}};f.prototype.destroy=function(){var b=this,c=b.axes,d=b.series,g=b.container,k,e=g&&g.parentNode;G(b,"destroy");b.renderer.forExport?q(D,b):D[b.index]=void 0;z.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");Z(b);for(k=c.length;k--;)c[k]=
c[k].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(k=d.length;k--;)d[k]=d[k].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});g&&(g.innerHTML="",Z(g),e&&a(g));t(b,function(a,c){delete b[c]})};f.prototype.firstRender=function(){var a=this,b=a.options;if(!a.isReadyToRender||
a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();(T(b.series)?b.series:[]).forEach(function(b){a.initSeries(b)});a.linkSeries();a.setSeriesData();G(a,"beforeRender");C&&(a.pointer=z.hasTouch||!l.PointerEvent&&!l.MSPointerEvent?new C(a,b):new L(a,b));a.render();if(!a.renderer.imgCount&&!a.hasLoaded)a.onload();a.temporaryDisplay(!0)}};f.prototype.onload=function(){this.callbacks.concat([this.callback]).forEach(function(a){a&&"undefined"!==typeof this.index&&
a.apply(this,[this])},this);G(this,"load");G(this,"render");c(this.index)&&this.setReflow(this.options.chart.reflow);this.hasLoaded=!0};return f}();W.prototype.callbacks=[];z.chart=function(a,b,c){return new W(a,b,c)};return z.Chart=W});N(m,"Extensions/ScrollablePlotArea.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Chart/Chart.js"],m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h,m,z){var F=f.stop,L=z.addEvent,K=z.createElement,C=z.pick;"";L(h,"afterSetChartSize",function(f){var e=
this.options.chart.scrollablePlotArea,h=e&&e.minWidth;e=e&&e.minHeight;if(!this.renderer.forExport){if(h){if(this.scrollablePixelsX=h=Math.max(0,h-this.chartWidth)){this.plotWidth+=h;this.inverted?(this.clipBox.height+=h,this.plotBox.height+=h):(this.clipBox.width+=h,this.plotBox.width+=h);var v={1:{name:"right",value:h}}}}else e&&(this.scrollablePixelsY=h=Math.max(0,e-this.chartHeight))&&(this.plotHeight+=h,this.inverted?(this.clipBox.width+=h,this.plotBox.width+=h):(this.clipBox.height+=h,this.plotBox.height+=
h),v={2:{name:"bottom",value:h}});v&&!f.skipAxes&&this.axes.forEach(function(e){v[e.side]?e.getPlotLinePath=function(){var f=v[e.side].name,h=this[f];this[f]=h-v[e.side].value;var l=m.Axis.prototype.getPlotLinePath.apply(this,arguments);this[f]=h;return l}:(e.setAxisSize(),e.setAxisTranslation())})}});L(h,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});h.prototype.setUpScrolling=function(){var f=
this,e={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(e.overflowX="auto");this.scrollablePixelsY&&(e.overflowY="auto");this.scrollingParent=K("div",{className:"highcharts-scrolling-parent"},{position:"relative"},this.renderTo);this.scrollingContainer=K("div",{className:"highcharts-scrolling"},e,this.scrollingParent);L(this.scrollingContainer,"scroll",function(){f.pointer&&delete f.pointer.chartPosition});this.innerContainer=K("div",{className:"highcharts-inner-container"},
null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};h.prototype.moveFixedElements=function(){var f=this.container,e=this.fixedRenderer,h=".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),m;this.scrollablePixelsX&&
!this.inverted?m=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?m=".highcharts-xaxis":this.scrollablePixelsY&&!this.inverted?m=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(m=".highcharts-yaxis");h.push(m,m+"-labels");h.forEach(function(h){[].forEach.call(f.querySelectorAll(h),function(f){(f.namespaceURI===e.SVG_NS?e.box:e.box.parentNode).appendChild(f);f.style.pointerEvents="auto"})})};h.prototype.applyFixed=function(){var f,e,h=!this.fixedDiv,v=this.options.chart.scrollablePlotArea;
h?(this.fixedDiv=K("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2,top:0},null,!0),null===(f=this.scrollingContainer)||void 0===f?void 0:f.parentNode.insertBefore(this.fixedDiv,this.scrollingContainer),this.renderTo.style.overflow="visible",this.fixedRenderer=f=new m.Renderer(this.fixedDiv,this.chartWidth,this.chartHeight,null===(e=this.options.chart)||void 0===e?void 0:e.style),this.scrollableMask=f.path().attr({fill:this.options.chart.backgroundColor||
"#fff","fill-opacity":C(v.opacity,.85),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),this.moveFixedElements(),L(this,"afterShowResetZoom",this.moveFixedElements),L(this,"afterLayOutTitles",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);e=this.chartWidth+(this.scrollablePixelsX||0);f=this.chartHeight+(this.scrollablePixelsY||0);F(this.container);this.container.style.width=e+"px";this.container.style.height=f+"px";this.renderer.boxWrapper.attr({width:e,
height:f,viewBox:[0,0,e,f].join(" ")});this.chartBackground.attr({width:e,height:f});this.scrollingContainer.style.height=this.chartHeight+"px";h&&(v.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*v.scrollPositionX),v.scrollPositionY&&(this.scrollingContainer.scrollTop=this.scrollablePixelsY*v.scrollPositionY));f=this.axisOffset;h=this.plotTop-f[0]-1;v=this.plotLeft-f[3]-1;e=this.plotTop+this.plotHeight+f[2]+1;f=this.plotLeft+this.plotWidth+f[1]+1;var x=this.plotLeft+
this.plotWidth-(this.scrollablePixelsX||0),D=this.plotTop+this.plotHeight-(this.scrollablePixelsY||0);h=this.scrollablePixelsX?[["M",0,h],["L",this.plotLeft-1,h],["L",this.plotLeft-1,e],["L",0,e],["Z"],["M",x,h],["L",this.chartWidth,h],["L",this.chartWidth,e],["L",x,e],["Z"]]:this.scrollablePixelsY?[["M",v,0],["L",v,this.plotTop-1],["L",f,this.plotTop-1],["L",f,0],["Z"],["M",v,D],["L",v,this.chartHeight],["L",f,this.chartHeight],["L",f,D],["Z"]]:[["M",0,0]];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:h})}});
N(m,"Core/Axis/StackingAxis.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Utilities.js"]],function(f,h){var m=f.getDeferredAnimation,z=h.addEvent,F=h.destroyObjectProperties,L=h.fireEvent,K=h.objectEach,C=h.pick,y=function(){function e(e){this.oldStacks={};this.stacks={};this.stacksTouched=0;this.axis=e}e.prototype.buildStacks=function(){var e=this.axis,f=e.series,h=C(e.options.reversedStacks,!0),m=f.length,n;if(!e.isXAxis){this.usePercentage=!1;for(n=m;n--;){var l=f[h?n:m-n-1];l.setStackedPoints();
l.setGroupedPoints()}for(n=0;n<m;n++)f[n].modifyStacks();L(e,"afterBuildStacks")}};e.prototype.cleanStacks=function(){if(!this.axis.isXAxis){if(this.oldStacks)var e=this.stacks=this.oldStacks;K(e,function(e){K(e,function(e){e.cumulative=e.total})})}};e.prototype.resetStacks=function(){var e=this,f=e.stacks;e.axis.isXAxis||K(f,function(f){K(f,function(h,n){h.touched<e.stacksTouched?(h.destroy(),delete f[n]):(h.total=null,h.cumulative=null)})})};e.prototype.renderStackTotals=function(){var e=this.axis,
f=e.chart,h=f.renderer,D=this.stacks;e=m(f,e.options.stackLabels.animation);var n=this.stackTotalGroup=this.stackTotalGroup||h.g("stack-labels").attr({visibility:"visible",zIndex:6,opacity:0}).add();n.translate(f.plotLeft,f.plotTop);K(D,function(e){K(e,function(e){e.render(n)})});n.animate({opacity:1},e)};return e}();return function(){function e(){}e.compose=function(f){z(f,"init",e.onInit);z(f,"destroy",e.onDestroy)};e.onDestroy=function(){var e=this.stacking;if(e){var f=e.stacks;K(f,function(e,
h){F(e);f[h]=null});e&&e.stackTotalGroup&&e.stackTotalGroup.destroy()}};e.onInit=function(){this.stacking||(this.stacking=new y(this))};return e}()});N(m,"Mixins/LegendSymbol.js",[m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h){var m=h.merge,z=h.pick;return f.LegendSymbolMixin={drawRectangle:function(f,h){var m=f.symbolHeight,C=f.options.squareSymbol;h.legendSymbol=this.chart.renderer.rect(C?(f.symbolWidth-m)/2:0,f.baseline-m+1,C?m:f.symbolWidth,m,z(f.options.symbolRadius,m/2)).addClass("highcharts-point").attr({zIndex:3}).add(h.legendGroup)},
drawLineMarker:function(f){var h=this.options,F=h.marker,C=f.symbolWidth,y=f.symbolHeight,e=y/2,I=this.chart.renderer,v=this.legendGroup;f=f.baseline-Math.round(.3*f.fontMetrics.b);var x={};this.chart.styledMode||(x={"stroke-width":h.lineWidth||0},h.dashStyle&&(x.dashstyle=h.dashStyle));this.legendLine=I.path([["M",0,f],["L",C,f]]).addClass("highcharts-graph").attr(x).add(v);F&&!1!==F.enabled&&C&&(h=Math.min(z(F.radius,e),e),0===this.symbol.indexOf("url")&&(F=m(F,{width:y,height:y}),h=0),this.legendSymbol=
F=I.symbol(this.symbol,C/2-h,f-h,2*h,2*h,F).addClass("highcharts-point").add(v),F.isMarker=!0)}}});N(m,"Core/Series/CartesianSeries.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Series/Series.js"],m["Core/Globals.js"],m["Mixins/LegendSymbol.js"],m["Core/Options.js"],m["Core/Series/Point.js"],m["Core/Renderer/SVG/SVGElement.js"],m["Core/Utilities.js"]],function(f,h,m,z,F,L,K,C){var y=f.animObject,e=F.defaultOptions,I=C.addEvent,v=C.arrayMax,x=C.arrayMin,D=C.clamp,n=C.correctFloat,l=C.defined,
J=C.erase,w=C.error,r=C.extend,d=C.find,g=C.fireEvent,c=C.getNestedProperty,a=C.isArray,q=C.isFunction,p=C.isNumber,B=C.isString,A=C.merge,G=C.objectEach,M=C.pick,T=C.removeEvent,Q=C.splat,O=C.syncTimeout;"";var E=h.seriesTypes,u=m.win;f=h.seriesType("line",void 0,{lineWidth:2,allowPointSelect:!1,crisp:!0,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{enabledThreshold:2,lineColor:"#ffffff",lineWidth:0,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,
lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{animation:{},align:"center",defer:!0,formatter:function(){var a=this.series.chart.numberFormatter;return"number"!==typeof this.y?"":a(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},
lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{axisTypes:["xAxis","yAxis"],coll:"series",colorCounter:0,cropShoulder:1,directTouch:!1,isCartesian:!0,parallelArrays:["x","y"],pointClass:L,requireSorting:!0,sorted:!0,init:function(a,c){g(this,"init",{options:c});var b=this,d=a.series,k;this.eventOptions=this.eventOptions||{};this.eventsToUnbind=[];b.chart=
a;b.options=c=b.setOptions(c);b.linkedSeries=[];b.bindAxes();r(b,{name:c.name,state:"",visible:!1!==c.visible,selected:!0===c.selected});var e=c.events;G(e,function(a,c){q(a)&&b.eventOptions[c]!==a&&(q(b.eventOptions[c])&&T(b,c,b.eventOptions[c]),b.eventOptions[c]=a,I(b,c,a))});if(e&&e.click||c.point&&c.point.events&&c.point.events.click||c.allowPointSelect)a.runTrackerClick=!0;b.getColor();b.getSymbol();b.parallelArrays.forEach(function(a){b[a+"Data"]||(b[a+"Data"]=[])});b.isCartesian&&(a.hasCartesianSeries=
!0);d.length&&(k=d[d.length-1]);b._i=M(k&&k._i,-1)+1;b.opacity=b.options.opacity;a.orderSeries(this.insert(d));c.dataSorting&&c.dataSorting.enabled?b.setDataSortingOptions():b.points||b.data||b.setData(c.data,!1);g(this,"afterInit")},is:function(a){return E[a]&&this instanceof E[a]},insert:function(a){var b=this.options.index,c;if(p(b)){for(c=a.length;c--;)if(b>=M(a[c].options.index,a[c]._i)){a.splice(c+1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return M(c,a.length-1)},bindAxes:function(){var a=
this,c=a.options,d=a.chart,e;g(this,"bindAxes",null,function(){(a.axisTypes||[]).forEach(function(b){d[b].forEach(function(d){e=d.options;if(c[b]===e.index||"undefined"!==typeof c[b]&&c[b]===e.id||"undefined"===typeof c[b]&&0===e.index)a.insert(d.series),a[b]=d,d.isDirty=!0});a[b]||a.optionalAxis===b||w(18,!0,d)})});g(this,"afterBindAxes")},updateParallelArrays:function(a,c){var b=a.series,d=arguments,g=p(c)?function(d){var g="y"===d&&b.toYData?b.toYData(a):a[d];b[d+"Data"][c]=g}:function(a){Array.prototype[c].apply(b[a+
"Data"],Array.prototype.slice.call(d,2))};b.parallelArrays.forEach(g)},hasData:function(){return this.visible&&"undefined"!==typeof this.dataMax&&"undefined"!==typeof this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var a=this.options,c=this.xIncrement,d,g=a.pointIntervalUnit,e=this.chart.time;c=M(c,a.pointStart,0);this.pointInterval=d=M(this.pointInterval,a.pointInterval,1);g&&(a=new e.Date(c),"day"===g?e.set("Date",a,e.get("Date",a)+d):"month"===g?e.set("Month",
a,e.get("Month",a)+d):"year"===g&&e.set("FullYear",a,e.get("FullYear",a)+d),d=a.getTime()-c);this.xIncrement=c+d;return c},setDataSortingOptions:function(){var a=this.options;r(this,{requireSorting:!1,sorted:!1,enabledDataSorting:!0,allowDG:!1});l(a.pointRange)||(a.pointRange=1)},setOptions:function(a){var b=this.chart,c=b.options,d=c.plotOptions,f=b.userOptions||{};a=A(a);b=b.styledMode;var p={plotOptions:d,userOptions:a};g(this,"setOptions",p);var h=p.plotOptions[this.type],q=f.plotOptions||{};
this.userOptions=p.userOptions;f=A(h,d.series,f.plotOptions&&f.plotOptions[this.type],a);this.tooltipOptions=A(e.tooltip,e.plotOptions.series&&e.plotOptions.series.tooltip,e.plotOptions[this.type].tooltip,c.tooltip.userOptions,d.series&&d.series.tooltip,d[this.type].tooltip,a.tooltip);this.stickyTracking=M(a.stickyTracking,q[this.type]&&q[this.type].stickyTracking,q.series&&q.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:f.stickyTracking);null===h.marker&&delete f.marker;
this.zoneAxis=f.zoneAxis;c=this.zones=(f.zones||[]).slice();!f.negativeColor&&!f.negativeFillColor||f.zones||(d={value:f[this.zoneAxis+"Threshold"]||f.threshold||0,className:"highcharts-negative"},b||(d.color=f.negativeColor,d.fillColor=f.negativeFillColor),c.push(d));c.length&&l(c[c.length-1].value)&&c.push(b?{}:{color:this.color,fillColor:this.fillColor});g(this,"afterSetOptions",{options:f});return f},getName:function(){return M(this.options.name,"Series "+(this.index+1))},getCyclic:function(a,
c,d){var b=this.chart,g=this.userOptions,k=a+"Index",e=a+"Counter",f=d?d.length:M(b.options.chart[a+"Count"],b[a+"Count"]);if(!c){var p=M(g[k],g["_"+k]);l(p)||(b.series.length||(b[e]=0),g["_"+k]=p=b[e]%f,b[e]+=1);d&&(c=d[p])}"undefined"!==typeof p&&(this[k]=p);this[a]=c},getColor:function(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||e.plotOptions[this.type].color,this.chart.options.colors)},getPointsCollection:function(){return(this.hasGroupedData?
this.points:this.data)||[]},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(a,c){var b=a.id,g=a.x,k=this.points,e,f=this.options.dataSorting;if(b)var l=this.chart.get(b);else if(this.linkedParent||this.enabledDataSorting){var h=f&&f.matchByName?"name":"index";l=d(k,function(b){return!b.touched&&b[h]===a[h]});if(!l)return}if(l){var q=l&&l.index;"undefined"!==typeof q&&(e=!0)}"undefined"===typeof q&&p(g)&&(q=this.xData.indexOf(g,
c));-1!==q&&"undefined"!==typeof q&&this.cropped&&(q=q>=this.cropStart?q-this.cropStart:q);!e&&k[q]&&k[q].touched&&(q=void 0);return q},drawLegendSymbol:z.drawLineMarker,updateData:function(a,c){var b=this.options,d=b.dataSorting,g=this.points,k=[],e,f,h,q=this.requireSorting,n=a.length===g.length,u=!0;this.xIncrement=null;a.forEach(function(a,c){var f=l(a)&&this.pointClass.prototype.optionsToObject.call({series:this},a)||{};var t=f.x;if(f.id||p(t)){if(t=this.findPointIndex(f,h),-1===t||"undefined"===
typeof t?k.push(a):g[t]&&a!==b.data[t]?(g[t].update(a,!1,null,!1),g[t].touched=!0,q&&(h=t+1)):g[t]&&(g[t].touched=!0),!n||c!==t||d&&d.enabled||this.hasDerivedData)e=!0}else k.push(a)},this);if(e)for(a=g.length;a--;)(f=g[a])&&!f.touched&&f.remove&&f.remove(!1,c);else!n||d&&d.enabled?u=!1:(a.forEach(function(a,b){g[b].update&&a!==g[b].y&&g[b].update(a,!1,null,!1)}),k.length=0);g.forEach(function(a){a&&(a.touched=!1)});if(!u)return!1;k.forEach(function(a){this.addPoint(a,!1,null,null,!1)},this);null===
this.xIncrement&&this.xData&&this.xData.length&&(this.xIncrement=v(this.xData),this.autoIncrement());return!0},setData:function(b,c,d,g){var k=this,e=k.points,f=e&&e.length||0,t,l=k.options,h=k.chart,q=l.dataSorting,n=null,u=k.xAxis;n=l.turboThreshold;var r=this.xData,m=this.yData,A=(t=k.pointArrayMap)&&t.length,v=l.keys,E=0,H=1,O;b=b||[];t=b.length;c=M(c,!0);q&&q.enabled&&(b=this.sortData(b));!1!==g&&t&&f&&!k.cropped&&!k.hasGroupedData&&k.visible&&!k.isSeriesBoosting&&(O=this.updateData(b,d));if(!O){k.xIncrement=
null;k.colorCounter=0;this.parallelArrays.forEach(function(a){k[a+"Data"].length=0});if(n&&t>n)if(n=k.getFirstValidPoint(b),p(n))for(d=0;d<t;d++)r[d]=this.autoIncrement(),m[d]=b[d];else if(a(n))if(A)for(d=0;d<t;d++)g=b[d],r[d]=g[0],m[d]=g.slice(1,A+1);else for(v&&(E=v.indexOf("x"),H=v.indexOf("y"),E=0<=E?E:0,H=0<=H?H:1),d=0;d<t;d++)g=b[d],r[d]=g[E],m[d]=g[H];else w(12,!1,h);else for(d=0;d<t;d++)"undefined"!==typeof b[d]&&(g={series:k},k.pointClass.prototype.applyOptions.apply(g,[b[d]]),k.updateParallelArrays(g,
d));m&&B(m[0])&&w(14,!0,h);k.data=[];k.options.data=k.userOptions.data=b;for(d=f;d--;)e[d]&&e[d].destroy&&e[d].destroy();u&&(u.minRange=u.userMinRange);k.isDirty=h.isDirtyBox=!0;k.isDirtyData=!!e;d=!1}"point"===l.legendType&&(this.processData(),this.generatePoints());c&&h.redraw(d)},sortData:function(a){var b=this,d=b.options.dataSorting.sortKey||"y",g=function(a,b){return l(b)&&a.pointClass.prototype.optionsToObject.call({series:a},b)||{}};a.forEach(function(c,d){a[d]=g(b,c);a[d].index=d},this);
a.concat().sort(function(a,b){a=c(d,a);b=c(d,b);return b<a?-1:b>a?1:0}).forEach(function(a,b){a.x=b},this);b.linkedSeries&&b.linkedSeries.forEach(function(b){var c=b.options,d=c.data;c.dataSorting&&c.dataSorting.enabled||!d||(d.forEach(function(c,k){d[k]=g(b,c);a[k]&&(d[k].x=a[k].x,d[k].index=k)}),b.setData(d,!1))});return a},getProcessedData:function(a){var b=this.xData,c=this.yData,d=b.length;var g=0;var e=this.xAxis,f=this.options;var p=f.cropThreshold;var l=a||this.getExtremesFromAll||f.getExtremesFromAll,
h=this.isCartesian;a=e&&e.val2lin;f=!(!e||!e.logarithmic);var q=this.requireSorting;if(e){e=e.getExtremes();var n=e.min;var u=e.max}if(h&&this.sorted&&!l&&(!p||d>p||this.forceCrop))if(b[d-1]<n||b[0]>u)b=[],c=[];else if(this.yData&&(b[0]<n||b[d-1]>u)){g=this.cropData(this.xData,this.yData,n,u);b=g.xData;c=g.yData;g=g.start;var r=!0}for(p=b.length||1;--p;)if(d=f?a(b[p])-a(b[p-1]):b[p]-b[p-1],0<d&&("undefined"===typeof m||d<m))var m=d;else 0>d&&q&&(w(15,!1,this.chart),q=!1);return{xData:b,yData:c,cropped:r,
cropStart:g,closestPointRange:m}},processData:function(a){var b=this.xAxis;if(this.isCartesian&&!this.isDirty&&!b.isDirty&&!this.yAxis.isDirty&&!a)return!1;a=this.getProcessedData();this.cropped=a.cropped;this.cropStart=a.cropStart;this.processedXData=a.xData;this.processedYData=a.yData;this.closestPointRange=this.basePointRange=a.closestPointRange},cropData:function(a,c,d,g,e){var b=a.length,k=0,f=b,p;e=M(e,this.cropShoulder);for(p=0;p<b;p++)if(a[p]>=d){k=Math.max(0,p-e);break}for(d=p;d<b;d++)if(a[d]>
g){f=d+e;break}return{xData:a.slice(k,f),yData:c.slice(k,f),start:k,end:f}},generatePoints:function(){var a=this.options,c=a.data,d=this.data,e,f=this.processedXData,p=this.processedYData,l=this.pointClass,h=f.length,q=this.cropStart||0,n=this.hasGroupedData;a=a.keys;var u=[],m;d||n||(d=[],d.length=c.length,d=this.data=d);a&&n&&(this.options.keys=!1);for(m=0;m<h;m++){var w=q+m;if(n){var v=(new l).init(this,[f[m]].concat(Q(p[m])));v.dataGroup=this.groupMap[m];v.dataGroup.options&&(v.options=v.dataGroup.options,
r(v,v.dataGroup.options),delete v.dataLabels)}else(v=d[w])||"undefined"===typeof c[w]||(d[w]=v=(new l).init(this,c[w],f[m]));v&&(v.index=w,u[m]=v)}this.options.keys=a;if(d&&(h!==(e=d.length)||n))for(m=0;m<e;m++)m!==q||n||(m+=h),d[m]&&(d[m].destroyElements(),d[m].plotX=void 0);this.data=d;this.points=u;g(this,"afterGeneratePoints")},getXExtremes:function(a){return{min:x(a),max:v(a)}},getExtremes:function(b,c){var d=this.xAxis,k=this.yAxis,e=this.processedXData||this.xData,f=[],l=0,h=0;var q=0;var n=
this.requireSorting?this.cropShoulder:0,u=k?k.positiveValuesOnly:!1,r;b=b||this.stackedYData||this.processedYData||[];k=b.length;d&&(q=d.getExtremes(),h=q.min,q=q.max);for(r=0;r<k;r++){var m=e[r];var w=b[r];var A=(p(w)||a(w))&&(w.length||0<w||!u);m=c||this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||!d||(e[r+n]||m)>=h&&(e[r-n]||m)<=q;if(A&&m)if(A=w.length)for(;A--;)p(w[A])&&(f[l++]=w[A]);else f[l++]=w}b={dataMin:x(f),dataMax:v(f)};g(this,"afterGetExtremes",{dataExtremes:b});
return b},applyExtremes:function(){var a=this.getExtremes();this.dataMin=a.dataMin;this.dataMax=a.dataMax;return a},getFirstValidPoint:function(a){for(var b=null,c=a.length,d=0;null===b&&d<c;)b=a[d],d++;return b},translate:function(){this.processedXData||this.processData();this.generatePoints();var b=this.options,c=b.stacking,d=this.xAxis,e=d.categories,f=this.enabledDataSorting,h=this.yAxis,q=this.points,u=q.length,r=!!this.modifyValue,m,w=this.pointPlacementToXValue(),v=!!w,A=b.threshold,B=b.startFromThreshold?
A:0,E,O=this.zoneAxis||"y",G=Number.MAX_VALUE;for(m=0;m<u;m++){var x=q[m],y=x.x,z=x.y,C=x.low,J=c&&h.stacking&&h.stacking.stacks[(this.negStacks&&z<(B?0:A)?"-":"")+this.stackKey];if(h.positiveValuesOnly&&!h.validatePositiveValue(z)||d.positiveValuesOnly&&!d.validatePositiveValue(y))x.isNull=!0;x.plotX=E=n(D(d.translate(y,0,0,0,1,w,"flags"===this.type),-1E5,1E5));if(c&&this.visible&&J&&J[y]){var F=this.getStackIndicator(F,y,this.index);if(!x.isNull){var Q=J[y];var I=Q.points[F.key]}}a(I)&&(C=I[0],
z=I[1],C===B&&F.key===J[y].base&&(C=M(p(A)&&A,h.min)),h.positiveValuesOnly&&0>=C&&(C=null),x.total=x.stackTotal=Q.total,x.percentage=Q.total&&x.y/Q.total*100,x.stackY=z,this.irregularWidths||Q.setOffset(this.pointXOffset||0,this.barW||0));x.yBottom=l(C)?D(h.translate(C,0,1,0,1),-1E5,1E5):null;r&&(z=this.modifyValue(z,x));x.plotY="number"===typeof z&&Infinity!==z?D(h.translate(z,0,1,0,1),-1E5,1E5):void 0;x.isInside=this.isPointInside(x);x.clientX=v?n(d.translate(y,0,0,0,1,w)):E;x.negative=x[O]<(b[O+
"Threshold"]||A||0);x.category=e&&"undefined"!==typeof e[x.x]?e[x.x]:x.x;if(!x.isNull&&!1!==x.visible){"undefined"!==typeof K&&(G=Math.min(G,Math.abs(E-K)));var K=E}x.zone=this.zones.length&&x.getZone();!x.graphic&&this.group&&f&&(x.isNew=!0)}this.closestPointRangePx=G;g(this,"afterTranslate")},getValidPoints:function(a,c,d){var b=this.chart;return(a||this.points||[]).filter(function(a){return c&&!b.isInsidePlot(a.plotX,a.plotY,b.inverted)?!1:!1!==a.visible&&(d||!a.isNull)})},getClipBox:function(a,
c){var b=this.options,d=this.chart,g=d.inverted,k=this.xAxis,e=k&&this.yAxis,f=d.options.chart.scrollablePlotArea||{};a&&!1===b.clip&&e?a=g?{y:-d.chartWidth+e.len+e.pos,height:d.chartWidth,width:d.chartHeight,x:-d.chartHeight+k.len+k.pos}:{y:-e.pos,height:d.chartHeight,width:d.chartWidth,x:-k.pos}:(a=this.clipBox||d.clipBox,c&&(a.width=d.plotSizeX,a.x=(d.scrollablePixelsX||0)*(f.scrollPositionX||0)));return c?{width:a.width,x:a.x}:a},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,
g=b.inverted,e=this.clipBox,f=this.getClipBox(a),p=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,f.height,c.xAxis,c.yAxis].join(),l=b[p],h=b[p+"m"];a&&(f.width=0,g&&(f.x=b.plotHeight+(!1!==c.clip?0:b.plotTop)));l?b.hasLoaded||l.attr(f):(a&&(b[p+"m"]=h=d.clipRect(g?b.plotSizeX+99:-99,g?-b.plotLeft:-b.plotTop,99,g?b.chartWidth:b.chartHeight)),b[p]=l=d.clipRect(f),l.count={length:0});a&&!l.count[this.index]&&(l.count[this.index]=!0,l.count.length+=1);if(!1!==c.clip||a)this.group.clip(a||
e?l:b.clipRect),this.markerGroup.clip(h),this.sharedClipKey=p;a||(l.count[this.index]&&(delete l.count[this.index],--l.count.length),0===l.count.length&&p&&b[p]&&(e||(b[p]=b[p].destroy()),b[p+"m"]&&(b[p+"m"]=b[p+"m"].destroy())))},animate:function(a){var b=this.chart,c=y(this.options.animation);if(!b.hasRendered)if(a)this.setClip(c);else{var d=this.sharedClipKey;a=b[d];var g=this.getClipBox(c,!0);a&&a.animate(g,c);b[d+"m"]&&b[d+"m"].animate({width:g.width+99,x:g.x-(b.inverted?0:99)},c)}},afterAnimate:function(){this.setClip();
g(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,c=this.chart,d,g,e=this.options.marker,f=this[this.specialGroup]||this.markerGroup,p=this.xAxis,l=M(e.enabled,!p||p.isRadial?!0:null,this.closestPointRangePx>=e.enabledThreshold*e.radius);if(!1!==e.enabled||this._hasPointMarkers)for(d=0;d<a.length;d++){var h=a[d];var q=(g=h.graphic)?"animate":"attr";var n=h.marker||{};var u=!!h.marker;if((l&&"undefined"===typeof n.enabled||n.enabled)&&!h.isNull&&!1!==h.visible){var r=
M(n.symbol,this.symbol);var m=this.markerAttribs(h,h.selected&&"select");this.enabledDataSorting&&(h.startXPos=p.reversed?-m.width:p.width);var w=!1!==h.isInside;g?g[w?"show":"hide"](w).animate(m):w&&(0<m.width||h.hasImage)&&(h.graphic=g=c.renderer.symbol(r,m.x,m.y,m.width,m.height,u?n:e).add(f),this.enabledDataSorting&&c.hasRendered&&(g.attr({x:h.startXPos}),q="animate"));g&&"animate"===q&&g[w?"show":"hide"](w).animate(m);if(g&&!c.styledMode)g[q](this.pointAttribs(h,h.selected&&"select"));g&&g.addClass(h.getClassName(),
!0)}else g&&(h.graphic=g.destroy())}},markerAttribs:function(a,c){var b=this.options,d=b.marker,g=a.marker||{},e=g.symbol||d.symbol,k=M(g.radius,d.radius);c&&(d=d.states[c],c=g.states&&g.states[c],k=M(c&&c.radius,d&&d.radius,k+(d&&d.radiusPlus||0)));a.hasImage=e&&0===e.indexOf("url");a.hasImage&&(k=0);a={x:b.crisp?Math.floor(a.plotX)-k:a.plotX-k,y:a.plotY-k};k&&(a.width=a.height=2*k);return a},pointAttribs:function(a,c){var b=this.options.marker,d=a&&a.options,g=d&&d.marker||{},e=this.color,k=d&&
d.color,f=a&&a.color;d=M(g.lineWidth,b.lineWidth);var p=a&&a.zone&&a.zone.color;a=1;e=k||p||f||e;k=g.fillColor||b.fillColor||e;e=g.lineColor||b.lineColor||e;c=c||"normal";b=b.states[c];c=g.states&&g.states[c]||{};d=M(c.lineWidth,b.lineWidth,d+M(c.lineWidthPlus,b.lineWidthPlus,0));k=c.fillColor||b.fillColor||k;e=c.lineColor||b.lineColor||e;a=M(c.opacity,b.opacity,a);return{stroke:e,"stroke-width":d,fill:k,opacity:a}},destroy:function(a){var b=this,c=b.chart,d=/AppleWebKit\/533/.test(u.navigator.userAgent),
e,f,p=b.data||[],h,l;g(b,"destroy");this.removeEvents(a);(b.axisTypes||[]).forEach(function(a){(l=b[a])&&l.series&&(J(l.series,b),l.isDirty=l.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(f=p.length;f--;)(h=p[f])&&h.destroy&&h.destroy();b.points=null;C.clearTimeout(b.animationTimeout);G(b,function(a,b){a instanceof K&&!a.survive&&(e=d&&"group"===b?"hide":"destroy",a[e]())});c.hoverSeries===b&&(c.hoverSeries=null);J(c.series,b);c.orderSeries();G(b,function(c,d){a&&"hcEvents"===
d||delete b[d]})},getGraphPath:function(a,c,d){var b=this,g=b.options,e=g.step,k,f=[],p=[],h;a=a||b.points;(k=a.reversed)&&a.reverse();(e={right:1,center:2}[e]||e&&3)&&k&&(e=4-e);a=this.getValidPoints(a,!1,!(g.connectNulls&&!c&&!d));a.forEach(function(k,q){var t=k.plotX,n=k.plotY,u=a[q-1];(k.leftCliff||u&&u.rightCliff)&&!d&&(h=!0);k.isNull&&!l(c)&&0<q?h=!g.connectNulls:k.isNull&&!c?h=!0:(0===q||h?q=[["M",k.plotX,k.plotY]]:b.getPointSpline?q=[b.getPointSpline(a,k,q)]:e?(q=1===e?[["L",u.plotX,n]]:2===
e?[["L",(u.plotX+t)/2,u.plotY],["L",(u.plotX+t)/2,n]]:[["L",t,u.plotY]],q.push(["L",t,n])):q=[["L",t,n]],p.push(k.x),e&&(p.push(k.x),2===e&&p.push(k.x)),f.push.apply(f,q),h=!1)});f.xMap=p;return b.graphPath=f},drawGraph:function(){var a=this,c=this.options,d=(this.gappedPath||this.getGraphPath).call(this),g=this.chart.styledMode,e=[["graph","highcharts-graph"]];g||e[0].push(c.lineColor||this.color||"#cccccc",c.dashStyle);e=a.getZonesGraphs(e);e.forEach(function(b,e){var k=b[0],f=a[k],p=f?"animate":
"attr";f?(f.endX=a.preventGraphAnimation?null:d.xMap,f.animate({d:d})):d.length&&(a[k]=f=a.chart.renderer.path(d).addClass(b[1]).attr({zIndex:1}).add(a.group));f&&!g&&(k={stroke:b[2],"stroke-width":c.lineWidth,fill:a.fillGraph&&a.color||"none"},b[3]?k.dashstyle=b[3]:"square"!==c.linecap&&(k["stroke-linecap"]=k["stroke-linejoin"]="round"),f[p](k).shadow(2>e&&c.shadow));f&&(f.startX=d.xMap,f.isArea=d.isArea)})},getZonesGraphs:function(a){this.zones.forEach(function(b,c){c=["zone-graph-"+c,"highcharts-graph highcharts-zone-graph-"+
c+" "+(b.className||"")];this.chart.styledMode||c.push(b.color||this.color,b.dashStyle||this.options.dashStyle);a.push(c)},this);return a},applyZones:function(){var a=this,c=this.chart,d=c.renderer,g=this.zones,e,f,p=this.clips||[],h,l=this.graph,q=this.area,n=Math.max(c.chartWidth,c.chartHeight),u=this[(this.zoneAxis||"y")+"Axis"],r=c.inverted,m,w,v,A=!1,B,E;if(g.length&&(l||q)&&u&&"undefined"!==typeof u.min){var O=u.reversed;var G=u.horiz;l&&!this.showLine&&l.hide();q&&q.hide();var x=u.getExtremes();
g.forEach(function(b,g){e=O?G?c.plotWidth:0:G?0:u.toPixels(x.min)||0;e=D(M(f,e),0,n);f=D(Math.round(u.toPixels(M(b.value,x.max),!0)||0),0,n);A&&(e=f=u.toPixels(x.max));m=Math.abs(e-f);w=Math.min(e,f);v=Math.max(e,f);u.isXAxis?(h={x:r?v:w,y:0,width:m,height:n},G||(h.x=c.plotHeight-h.x)):(h={x:0,y:r?v:w,width:n,height:m},G&&(h.y=c.plotWidth-h.y));r&&d.isVML&&(h=u.isXAxis?{x:0,y:O?w:v,height:h.width,width:c.chartWidth}:{x:h.y-c.plotLeft-c.spacingBox.x,y:0,width:h.height,height:c.chartHeight});p[g]?p[g].animate(h):
p[g]=d.clipRect(h);B=a["zone-area-"+g];E=a["zone-graph-"+g];l&&E&&E.clip(p[g]);q&&B&&B.clip(p[g]);A=b.value>x.max;a.resetZones&&0===f&&(f=void 0)});this.clips=p}else a.visible&&(l&&l.show(!0),q&&q.show(!0))},invertGroups:function(a){function b(){["group","markerGroup"].forEach(function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(c.isRadialSeries?!1:a))})}var c=this,d=c.chart;c.xAxis&&(c.eventsToUnbind.push(I(d,
"resize",b)),b(),c.invertGroups=b)},plotGroup:function(a,c,d,g,e){var b=this[a],k=!b;d={visibility:d,zIndex:g||.1};"undefined"===typeof this.opacity||this.chart.styledMode||"inactive"===this.state||(d.opacity=this.opacity);k&&(this[a]=b=this.chart.renderer.g().add(e));b.addClass("highcharts-"+c+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(l(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(b.hasClass("highcharts-tracker")?" highcharts-tracker":
""),!0);b.attr(d)[k?"attr":"animate"](this.getPlotBox());return b},getPlotBox:function(){var a=this.chart,c=this.xAxis,d=this.yAxis;a.inverted&&(c=d,d=this.xAxis);return{translateX:c?c.left:a.plotLeft,translateY:d?d.top:a.plotTop,scaleX:1,scaleY:1}},removeEvents:function(a){a?this.eventsToUnbind.length&&(this.eventsToUnbind.forEach(function(a){a()}),this.eventsToUnbind.length=0):T(this)},render:function(){var a=this,c=a.chart,d=a.options,e=y(d.animation),f=!a.finishedAnimating&&c.renderer.isSVG&&
e.duration,p=a.visible?"inherit":"hidden",h=d.zIndex,l=a.hasRendered,q=c.seriesGroup,n=c.inverted;g(this,"render");var u=a.plotGroup("group","series",p,h,q);a.markerGroup=a.plotGroup("markerGroup","markers",p,h,q);f&&a.animate&&a.animate(!0);u.inverted=a.isCartesian||a.invertable?n:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.visible&&a.drawPoints();a.drawDataLabels&&a.drawDataLabels();a.redrawPoints&&a.redrawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(n);
!1===d.clip||a.sharedClipKey||l||u.clip(c.clipRect);f&&a.animate&&a.animate();l||(f&&e.defer&&(f+=e.defer),a.animationTimeout=O(function(){a.afterAnimate()},f||0));a.isDirty=!1;a.hasRendered=!0;g(a,"afterRender")},redraw:function(){var a=this.chart,c=this.isDirty||this.isDirtyData,d=this.group,g=this.xAxis,e=this.yAxis;d&&(a.inverted&&d.attr({width:a.plotWidth,height:a.plotHeight}),d.animate({translateX:M(g&&g.left,a.plotLeft),translateY:M(e&&e.top,a.plotTop)}));this.translate();this.render();c&&
delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,c){var b=this.xAxis,d=this.yAxis,g=this.chart.inverted;return this.searchKDTree({clientX:g?b.len-a.chartY+b.pos:a.chartX-b.pos,plotY:g?d.len-a.chartX+d.pos:a.chartY-d.pos},c,a)},buildKDTree:function(a){function b(a,d,g){var e;if(e=a&&a.length){var f=c.kdAxisArray[d%g];a.sort(function(a,b){return a[f]-b[f]});e=Math.floor(e/2);return{point:a[e],left:b(a.slice(0,e),d+1,g),right:b(a.slice(e+1),d+1,g)}}}this.buildingKdTree=!0;var c=
this,d=-1<c.options.findNearestPointBy.indexOf("y")?2:1;delete c.kdTree;O(function(){c.kdTree=b(c.getValidPoints(null,!c.directTouch),d,d);c.buildingKdTree=!1},c.options.kdNow||a&&"touchstart"===a.type?0:1)},searchKDTree:function(a,c,d){function b(a,c,d,p){var h=c.point,q=g.kdAxisArray[d%p],n=h;var u=l(a[e])&&l(h[e])?Math.pow(a[e]-h[e],2):null;var t=l(a[f])&&l(h[f])?Math.pow(a[f]-h[f],2):null;t=(u||0)+(t||0);h.dist=l(t)?Math.sqrt(t):Number.MAX_VALUE;h.distX=l(u)?Math.sqrt(u):Number.MAX_VALUE;q=a[q]-
h[q];t=0>q?"left":"right";u=0>q?"right":"left";c[t]&&(t=b(a,c[t],d+1,p),n=t[k]<n[k]?t:h);c[u]&&Math.sqrt(q*q)<n[k]&&(a=b(a,c[u],d+1,p),n=a[k]<n[k]?a:n);return n}var g=this,e=this.kdAxisArray[0],f=this.kdAxisArray[1],k=c?"distX":"dist";c=-1<g.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree(d);if(this.kdTree)return b(a,this.kdTree,c,c)},pointPlacementToXValue:function(){var a=this.options,c=a.pointRange,d=this.xAxis;a=a.pointPlacement;"between"===a&&(a=
d.reversed?-.5:.5);return p(a)?a*M(c,d.pointRange):0},isPointInside:function(a){return"undefined"!==typeof a.plotY&&"undefined"!==typeof a.plotX&&0<=a.plotY&&a.plotY<=this.yAxis.len&&0<=a.plotX&&a.plotX<=this.xAxis.len}});"";return f});N(m,"Series/LineSeries.js",[m["Core/Series/CartesianSeries.js"],m["Core/Globals.js"]],function(f,h){h.Series=f;return h.Series});N(m,"Extensions/Stacking.js",[m["Core/Axis/Axis.js"],m["Core/Chart/Chart.js"],m["Core/Globals.js"],m["Core/Axis/StackingAxis.js"],m["Core/Utilities.js"]],
function(f,h,m,z,F){var L=F.correctFloat,K=F.defined,C=F.destroyObjectProperties,y=F.format,e=F.isNumber,I=F.pick;"";var v=m.Series,x=function(){function f(e,f,h,m,r){var d=e.chart.inverted;this.axis=e;this.isNegative=h;this.options=f=f||{};this.x=m;this.total=null;this.points={};this.hasValidPoints=!1;this.stack=r;this.rightCliff=this.leftCliff=0;this.alignOptions={align:f.align||(d?h?"left":"right":"center"),verticalAlign:f.verticalAlign||(d?"middle":h?"bottom":"top"),y:f.y,x:f.x};this.textAlign=
f.textAlign||(d?h?"right":"left":"center")}f.prototype.destroy=function(){C(this,this.axis)};f.prototype.render=function(e){var f=this.axis.chart,h=this.options,n=h.format;n=n?y(n,this,f):h.formatter.call(this);this.label?this.label.attr({text:n,visibility:"hidden"}):(this.label=f.renderer.label(n,null,null,h.shape,null,null,h.useHTML,!1,"stack-labels"),n={r:h.borderRadius||0,text:n,rotation:h.rotation,padding:I(h.padding,5),visibility:"hidden"},f.styledMode||(n.fill=h.backgroundColor,n.stroke=h.borderColor,
n["stroke-width"]=h.borderWidth,this.label.css(h.style)),this.label.attr(n),this.label.added||this.label.add(e));this.label.labelrank=f.plotHeight};f.prototype.setOffset=function(f,h,m,w,r){var d=this.axis,g=d.chart;w=d.translate(d.stacking.usePercentage?100:w?w:this.total,0,0,0,1);m=d.translate(m?m:0);m=K(w)&&Math.abs(w-m);f=I(r,g.xAxis[0].translate(this.x))+f;d=K(w)&&this.getStackBox(g,this,f,w,h,m,d);h=this.label;m=this.isNegative;f="justify"===I(this.options.overflow,"justify");var c=this.textAlign;
h&&d&&(r=h.getBBox(),w=h.padding,c="left"===c?g.inverted?-w:w:"right"===c?r.width:g.inverted&&"center"===c?r.width/2:g.inverted?m?r.width+w:-w:r.width/2,m=g.inverted?r.height/2:m?-w:r.height,this.alignOptions.x=I(this.options.x,0),this.alignOptions.y=I(this.options.y,0),d.x-=c,d.y-=m,h.align(this.alignOptions,null,d),g.isInsidePlot(h.alignAttr.x+c-this.alignOptions.x,h.alignAttr.y+m-this.alignOptions.y)?h.show():(h.alignAttr.y=-9999,f=!1),f&&v.prototype.justifyDataLabel.call(this.axis,h,this.alignOptions,
h.alignAttr,r,d),h.attr({x:h.alignAttr.x,y:h.alignAttr.y}),I(!f&&this.options.crop,!0)&&((g=e(h.x)&&e(h.y)&&g.isInsidePlot(h.x-w+h.width,h.y)&&g.isInsidePlot(h.x+w,h.y))||h.hide()))};f.prototype.getStackBox=function(e,f,h,m,r,d,g){var c=f.axis.reversed,a=e.inverted,q=g.height+g.pos-(a?e.plotLeft:e.plotTop);f=f.isNegative&&!c||!f.isNegative&&c;return{x:a?f?m-g.right:m-d+g.pos-e.plotLeft:h+e.xAxis[0].transB-e.plotLeft,y:a?g.height-h-r:f?q-m-d:q-m,width:a?d:r,height:a?r:d}};return f}();h.prototype.getStacks=
function(){var e=this,f=e.inverted;e.yAxis.forEach(function(e){e.stacking&&e.stacking.stacks&&e.hasVisibleSeries&&(e.stacking.oldStacks=e.stacking.stacks)});e.series.forEach(function(h){var l=h.xAxis&&h.xAxis.options||{};!h.options.stacking||!0!==h.visible&&!1!==e.options.chart.ignoreHiddenSeries||(h.stackKey=[h.type,I(h.options.stack,""),f?l.top:l.left,f?l.height:l.width].join())})};z.compose(f);v.prototype.setGroupedPoints=function(){this.options.centerInCategory&&(this.is("column")||this.is("columnrange"))&&
!this.options.stacking&&1<this.chart.series.length&&v.prototype.setStackedPoints.call(this,"group")};v.prototype.setStackedPoints=function(e){var f=e||this.options.stacking;if(f&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var h=this.processedXData,m=this.processedYData,w=[],r=m.length,d=this.options,g=d.threshold,c=I(d.startFromThreshold&&g,0);d=d.stack;e=e?this.type+","+f:this.stackKey;var a="-"+e,q=this.negStacks,p=this.yAxis,v=p.stacking.stacks,A=p.stacking.oldStacks,
G,D;p.stacking.stacksTouched+=1;for(D=0;D<r;D++){var y=h[D];var z=m[D];var O=this.getStackIndicator(O,y,this.index);var E=O.key;var u=(G=q&&z<(c?0:g))?a:e;v[u]||(v[u]={});v[u][y]||(A[u]&&A[u][y]?(v[u][y]=A[u][y],v[u][y].total=null):v[u][y]=new x(p,p.options.stackLabels,G,y,d));u=v[u][y];null!==z?(u.points[E]=u.points[this.index]=[I(u.cumulative,c)],K(u.cumulative)||(u.base=E),u.touched=p.stacking.stacksTouched,0<O.index&&!1===this.singleStacks&&(u.points[E][0]=u.points[this.index+","+y+",0"][0])):
u.points[E]=u.points[this.index]=null;"percent"===f?(G=G?e:a,q&&v[G]&&v[G][y]?(G=v[G][y],u.total=G.total=Math.max(G.total,u.total)+Math.abs(z)||0):u.total=L(u.total+(Math.abs(z)||0))):"group"===f?null!==z&&(u.total=(u.total||0)+1):u.total=L(u.total+(z||0));u.cumulative="group"===f?(u.total||1)-1:I(u.cumulative,c)+(z||0);null!==z&&(u.points[E].push(u.cumulative),w[D]=u.cumulative,u.hasValidPoints=!0)}"percent"===f&&(p.stacking.usePercentage=!0);"group"!==f&&(this.stackedYData=w);p.stacking.oldStacks=
{}}};v.prototype.modifyStacks=function(){var e=this,f=e.stackKey,h=e.yAxis.stacking.stacks,m=e.processedXData,w,r=e.options.stacking;e[r+"Stacker"]&&[f,"-"+f].forEach(function(d){for(var g=m.length,c,a;g--;)if(c=m[g],w=e.getStackIndicator(w,c,e.index,d),a=(c=h[d]&&h[d][c])&&c.points[w.key])e[r+"Stacker"](a,c,g)})};v.prototype.percentStacker=function(e,f,h){f=f.total?100/f.total:0;e[0]=L(e[0]*f);e[1]=L(e[1]*f);this.stackedYData[h]=e[1]};v.prototype.getStackIndicator=function(e,f,h,m){!K(e)||e.x!==
f||m&&e.key!==m?e={x:f,index:0,key:m}:e.index++;e.key=[h,f,e.index].join();return e};m.StackItem=x;return m.StackItem});N(m,"Core/Dynamics.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Axis/Axis.js"],m["Core/Series/Series.js"],m["Core/Chart/Chart.js"],m["Core/Globals.js"],m["Series/LineSeries.js"],m["Core/Options.js"],m["Core/Series/Point.js"],m["Core/Time.js"],m["Core/Utilities.js"]],function(f,h,m,z,F,L,K,C,y,e){var I=f.animate,v=f.setAnimation,x=m.seriesTypes,D=K.time,n=e.addEvent,l=e.createElement,
J=e.css,w=e.defined,r=e.erase,d=e.error,g=e.extend,c=e.fireEvent,a=e.isArray,q=e.isNumber,p=e.isObject,B=e.isString,A=e.merge,G=e.objectEach,M=e.pick,T=e.relativeLength,Q=e.splat;F.cleanRecursively=function(a,c){var d={};G(a,function(b,g){if(p(a[g],!0)&&!a.nodeType&&c[g])b=F.cleanRecursively(a[g],c[g]),Object.keys(b).length&&(d[g]=b);else if(p(a[g])||a[g]!==c[g])d[g]=a[g]});return d};g(z.prototype,{addSeries:function(a,d,g){var b,e=this;a&&(d=M(d,!0),c(e,"addSeries",{options:a},function(){b=e.initSeries(a);
e.isDirtyLegend=!0;e.linkSeries();b.enabledDataSorting&&b.setData(a.data,!1);c(e,"afterAddSeries",{series:b});d&&e.redraw(g)}));return b},addAxis:function(a,c,d,b){return this.createAxis(c?"xAxis":"yAxis",{axis:a,redraw:d,animation:b})},addColorAxis:function(a,c,d){return this.createAxis("colorAxis",{axis:a,redraw:c,animation:d})},createAxis:function(a,c){var d=this.options,b="colorAxis"===a,g=c.redraw,e=c.animation;c=A(c.axis,{index:this[a].length,isX:"xAxis"===a});var f=b?new F.ColorAxis(this,c):
new h(this,c);d[a]=Q(d[a]||{});d[a].push(c);b&&(this.isDirtyLegend=!0,this.axes.forEach(function(a){a.series=[]}),this.series.forEach(function(a){a.bindAxes();a.isDirtyData=!0}));M(g,!0)&&this.redraw(e);return f},showLoading:function(a){var c=this,d=c.options,b=c.loadingDiv,e=d.loading,f=function(){b&&J(b,{left:c.plotLeft+"px",top:c.plotTop+"px",width:c.plotWidth+"px",height:c.plotHeight+"px"})};b||(c.loadingDiv=b=l("div",{className:"highcharts-loading highcharts-loading-hidden"},null,c.container),
c.loadingSpan=l("span",{className:"highcharts-loading-inner"},null,b),n(c,"redraw",f));b.className="highcharts-loading";c.loadingSpan.innerHTML=M(a,d.lang.loading,"");c.styledMode||(J(b,g(e.style,{zIndex:10})),J(c.loadingSpan,e.labelStyle),c.loadingShown||(J(b,{opacity:0,display:""}),I(b,{opacity:e.style.opacity||.5},{duration:e.showDuration||0})));c.loadingShown=!0;f()},hideLoading:function(){var a=this.options,c=this.loadingDiv;c&&(c.className="highcharts-loading highcharts-loading-hidden",this.styledMode||
I(c,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){J(c,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),
collectionsWithUpdate:["xAxis","yAxis","zAxis","series"],update:function(a,d,g,b){var e=this,f={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},p,h,l,n=a.isResponsiveOptions,u=[];c(e,"update",{options:a});n||e.setResponsive(!1,!0);a=F.cleanRecursively(a,e.options);A(!0,e.userOptions,a);if(p=a.chart){A(!0,e.options.chart,p);"className"in p&&e.setClassName(p.className);"reflow"in p&&e.setReflow(p.reflow);if("inverted"in p||"polar"in p||"type"in p){e.propFromSeries();
var m=!0}"alignTicks"in p&&(m=!0);G(p,function(a,b){-1!==e.propsRequireUpdateSeries.indexOf("chart."+b)&&(h=!0);-1!==e.propsRequireDirtyBox.indexOf(b)&&(e.isDirtyBox=!0);-1!==e.propsRequireReflow.indexOf(b)&&(n?e.isDirtyBox=!0:l=!0)});!e.styledMode&&"style"in p&&e.renderer.setStyle(p.style)}!e.styledMode&&a.colors&&(this.options.colors=a.colors);a.time&&(this.time===D&&(this.time=new y(a.time)),A(!0,e.options.time,a.time));G(a,function(b,c){if(e[c]&&"function"===typeof e[c].update)e[c].update(b,!1);
else if("function"===typeof e[f[c]])e[f[c]](b);else"color"!==c&&-1===e.collectionsWithUpdate.indexOf(c)&&A(!0,e.options[c],a[c]);"chart"!==c&&-1!==e.propsRequireUpdateSeries.indexOf(c)&&(h=!0)});this.collectionsWithUpdate.forEach(function(b){if(a[b]){if("series"===b){var c=[];e[b].forEach(function(a,b){a.options.isInternal||c.push(M(a.options.index,b))})}Q(a[b]).forEach(function(a,d){var f=w(a.id),k;f&&(k=e.get(a.id));k||(k=e[b][c?c[d]:d])&&f&&w(k.options.id)&&(k=void 0);k&&k.coll===b&&(k.update(a,
!1),g&&(k.touched=!0));!k&&g&&e.collectionsWithInit[b]&&(e.collectionsWithInit[b][0].apply(e,[a].concat(e.collectionsWithInit[b][1]||[]).concat([!1])).touched=!0)});g&&e[b].forEach(function(a){a.touched||a.options.isInternal?delete a.touched:u.push(a)})}});u.forEach(function(a){a.remove&&a.remove(!1)});m&&e.axes.forEach(function(a){a.update({},!1)});h&&e.getSeriesOrderByLinks().forEach(function(a){a.chart&&a.update({},!1)},this);m=p&&p.width;p=p&&p.height;B(p)&&(p=T(p,m||e.chartWidth));l||q(m)&&m!==
e.chartWidth||q(p)&&p!==e.chartHeight?e.setSize(m,p,b):M(d,!0)&&e.redraw(b);c(e,"afterUpdate",{options:a,redraw:d,animation:b})},setSubtitle:function(a,c){this.applyDescription("subtitle",a);this.layOutTitles(c)},setCaption:function(a,c){this.applyDescription("caption",a);this.layOutTitles(c)}});z.prototype.collectionsWithInit={xAxis:[z.prototype.addAxis,[!0]],yAxis:[z.prototype.addAxis,[!1]],series:[z.prototype.addSeries]};g(C.prototype,{update:function(a,c,d,b){function g(){e.applyOptions(a);var b=
h&&e.hasDummyGraphic;b=null===e.y?!b:b;h&&b&&(e.graphic=h.destroy(),delete e.hasDummyGraphic);p(a,!0)&&(h&&h.element&&a&&a.marker&&"undefined"!==typeof a.marker.symbol&&(e.graphic=h.destroy()),a&&a.dataLabels&&e.dataLabel&&(e.dataLabel=e.dataLabel.destroy()),e.connector&&(e.connector=e.connector.destroy()));q=e.index;f.updateParallelArrays(e,q);n.data[q]=p(n.data[q],!0)||p(a,!0)?e.options:M(a,n.data[q]);f.isDirty=f.isDirtyData=!0;!f.fixedBox&&f.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===n.legendType&&
(l.isDirtyLegend=!0);c&&l.redraw(d)}var e=this,f=e.series,h=e.graphic,q,l=f.chart,n=f.options;c=M(c,!0);!1===b?g():e.firePointEvent("update",{options:a},g)},remove:function(a,c){this.series.removePoint(this.series.data.indexOf(this),a,c)}});g(L.prototype,{addPoint:function(a,d,g,b,e){var f=this.options,k=this.data,p=this.chart,h=this.xAxis;h=h&&h.hasNames&&h.names;var q=f.data,l=this.xData,n;d=M(d,!0);var u={series:this};this.pointClass.prototype.applyOptions.apply(u,[a]);var m=u.x;var r=l.length;
if(this.requireSorting&&m<l[r-1])for(n=!0;r&&l[r-1]>m;)r--;this.updateParallelArrays(u,"splice",r,0,0);this.updateParallelArrays(u,r);h&&u.name&&(h[m]=u.name);q.splice(r,0,a);n&&(this.data.splice(r,0,null),this.processData());"point"===f.legendType&&this.generatePoints();g&&(k[0]&&k[0].remove?k[0].remove(!1):(k.shift(),this.updateParallelArrays(u,"shift"),q.shift()));!1!==e&&c(this,"addPoint",{point:u});this.isDirtyData=this.isDirty=!0;d&&p.redraw(b)},removePoint:function(a,c,d){var b=this,g=b.data,
e=g[a],f=b.points,p=b.chart,h=function(){f&&f.length===g.length&&f.splice(a,1);g.splice(a,1);b.options.data.splice(a,1);b.updateParallelArrays(e||{series:b},"splice",a,1);e&&e.destroy();b.isDirty=!0;b.isDirtyData=!0;c&&p.redraw()};v(d,p);c=M(c,!0);e?e.firePointEvent("remove",null,h):h()},remove:function(a,d,g,b){function e(){f.destroy(b);f.remove=null;p.isDirtyLegend=p.isDirtyBox=!0;p.linkSeries();M(a,!0)&&p.redraw(d)}var f=this,p=f.chart;!1!==g?c(f,"remove",null,e):e()},update:function(a,e){a=F.cleanRecursively(a,
this.userOptions);c(this,"update",{options:a});var f=this,b=f.chart,k=f.userOptions,p=f.initialType||f.type,h=b.options.plotOptions,q=a.type||k.type||b.options.chart.type,l=!(this.hasDerivedData||q&&q!==this.type||"undefined"!==typeof a.pointStart||"undefined"!==typeof a.pointInterval||f.hasOptionChanged("dataGrouping")||f.hasOptionChanged("pointStart")||f.hasOptionChanged("pointInterval")||f.hasOptionChanged("pointIntervalUnit")||f.hasOptionChanged("keys")),n=x[p].prototype,m,r=["eventOptions","navigatorSeries",
"baseSeries"],w=f.finishedAnimating&&{animation:!1},v={};l&&(r.push("data","isDirtyData","points","processedXData","processedYData","xIncrement","cropped","_hasPointMarkers","_hasPointLabels","mapMap","mapData","minY","maxY","minX","maxX"),!1!==a.visible&&r.push("area","graph"),f.parallelArrays.forEach(function(a){r.push(a+"Data")}),a.data&&(a.dataSorting&&g(f.options.dataSorting,a.dataSorting),this.setData(a.data,!1)));a=A(k,w,{index:"undefined"===typeof k.index?f.index:k.index,pointStart:M(h&&h.series&&
h.series.pointStart,k.pointStart,f.xData[0])},!l&&{data:f.options.data},a);l&&a.data&&(a.data=f.options.data);r=["group","markerGroup","dataLabelsGroup","transformGroup"].concat(r);r.forEach(function(a){r[a]=f[a];delete f[a]});f.remove(!1,null,!1,!0);for(m in n)f[m]=void 0;x[q||p]?g(f,x[q||p].prototype):d(17,!0,b,{missingModuleFor:q||p});r.forEach(function(a){f[a]=r[a]});f.init(b,a);if(l&&this.points){var B=f.options;!1===B.visible?(v.graphic=1,v.dataLabel=1):f._hasPointLabels||(a=B.marker,k=B.dataLabels,
a&&(!1===a.enabled||"symbol"in a)&&(v.graphic=1),k&&!1===k.enabled&&(v.dataLabel=1));this.points.forEach(function(a){a&&a.series&&(a.resolveColor(),Object.keys(v).length&&a.destroyElements(v),!1===B.showInLegend&&a.legendItem&&b.legend.destroyItem(a))},this)}f.initialType=p;b.linkSeries();c(this,"afterUpdate");M(e,!0)&&b.redraw(l?void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0},hasOptionChanged:function(a){var c=this.options[a],d=this.chart.options.plotOptions,
b=this.userOptions[a];return b?c!==b:c!==M(d&&d[this.type]&&d[this.type][a],d&&d.series&&d.series[a],c)}});g(h.prototype,{update:function(a,c){var d=this.chart,b=a&&a.events||{};a=A(this.userOptions,a);d.options[this.coll].indexOf&&(d.options[this.coll][d.options[this.coll].indexOf(this.userOptions)]=a);G(d.options[this.coll].events,function(a,c){"undefined"===typeof b[c]&&(b[c]=void 0)});this.destroy(!0);this.init(d,g(a,{events:b}));d.isDirtyBox=!0;M(c,!0)&&d.redraw()},remove:function(c){for(var d=
this.chart,g=this.coll,b=this.series,e=b.length;e--;)b[e]&&b[e].remove(!1);r(d.axes,this);r(d[g],this);a(d.options[g])?d.options[g].splice(this.options.index,1):delete d.options[g];d[g].forEach(function(a,b){a.options.index=a.userOptions.index=b});this.destroy();d.isDirtyBox=!0;M(c,!0)&&d.redraw()},setTitle:function(a,c){this.update({title:a},c)},setCategories:function(a,c){this.update({categories:a},c)}})});N(m,"Series/AreaSeries.js",[m["Core/Series/Series.js"],m["Core/Color/Color.js"],m["Core/Globals.js"],
m["Mixins/LegendSymbol.js"],m["Core/Utilities.js"]],function(f,h,m,z,F){var L=h.parse,K=F.objectEach,C=F.pick,y=m.Series;f.seriesType("area","line",{threshold:0},{singleStacks:!1,getStackPoints:function(e){var f=[],h=[],m=this.xAxis,D=this.yAxis,n=D.stacking.stacks[this.stackKey],l={},y=this.index,w=D.series,r=w.length,d=C(D.options.reversedStacks,!0)?1:-1,g;e=e||this.points;if(this.options.stacking){for(g=0;g<e.length;g++)e[g].leftNull=e[g].rightNull=void 0,l[e[g].x]=e[g];K(n,function(a,c){null!==
a.total&&h.push(c)});h.sort(function(a,c){return a-c});var c=w.map(function(a){return a.visible});h.forEach(function(a,e){var p=0,q,w;if(l[a]&&!l[a].isNull)f.push(l[a]),[-1,1].forEach(function(f){var p=1===f?"rightNull":"leftNull",m=0,v=n[h[e+f]];if(v)for(g=y;0<=g&&g<r;)q=v.points[g],q||(g===y?l[a][p]=!0:c[g]&&(w=n[a].points[g])&&(m-=w[1]-w[0])),g+=d;l[a][1===f?"rightCliff":"leftCliff"]=m});else{for(g=y;0<=g&&g<r;){if(q=n[a].points[g]){p=q[1];break}g+=d}p=D.translate(p,0,1,0,1);f.push({isNull:!0,
plotX:m.translate(a,0,0,0,1),x:a,plotY:p,yBottom:p})}})}return f},getGraphPath:function(e){var f=y.prototype.getGraphPath,h=this.options,m=h.stacking,D=this.yAxis,n,l=[],z=[],w=this.index,r=D.stacking.stacks[this.stackKey],d=h.threshold,g=Math.round(D.getThreshold(h.threshold));h=C(h.connectNulls,"percent"===m);var c=function(a,c,f){var p=e[a];a=m&&r[p.x].points[w];var h=p[f+"Null"]||0;f=p[f+"Cliff"]||0;p=!0;if(f||h){var n=(h?a[0]:a[1])+f;var v=a[0]+f;p=!!h}else!m&&e[c]&&e[c].isNull&&(n=v=d);"undefined"!==
typeof n&&(z.push({plotX:q,plotY:null===n?g:D.getThreshold(n),isNull:p,isCliff:!0}),l.push({plotX:q,plotY:null===v?g:D.getThreshold(v),doCurve:!1}))};e=e||this.points;m&&(e=this.getStackPoints(e));for(n=0;n<e.length;n++){m||(e[n].leftCliff=e[n].rightCliff=e[n].leftNull=e[n].rightNull=void 0);var a=e[n].isNull;var q=C(e[n].rectPlotX,e[n].plotX);var p=m?e[n].yBottom:g;if(!a||h)h||c(n,n-1,"left"),a&&!m&&h||(z.push(e[n]),l.push({x:n,plotX:q,plotY:p})),h||c(n,n+1,"right")}n=f.call(this,z,!0,!0);l.reversed=
!0;a=f.call(this,l,!0,!0);(p=a[0])&&"M"===p[0]&&(a[0]=["L",p[1],p[2]]);a=n.concat(a);f=f.call(this,z,!1,h);a.xMap=n.xMap;this.areaPath=a;return f},drawGraph:function(){this.areaPath=[];y.prototype.drawGraph.apply(this);var e=this,f=this.areaPath,h=this.options,m=[["area","highcharts-area",this.color,h.fillColor]];this.zones.forEach(function(f,n){m.push(["zone-area-"+n,"highcharts-area highcharts-zone-area-"+n+" "+f.className,f.color||e.color,f.fillColor||h.fillColor])});m.forEach(function(m){var n=
m[0],l=e[n],v=l?"animate":"attr",w={};l?(l.endX=e.preventGraphAnimation?null:f.xMap,l.animate({d:f})):(w.zIndex=0,l=e[n]=e.chart.renderer.path(f).addClass(m[1]).add(e.group),l.isArea=!0);e.chart.styledMode||(w.fill=C(m[3],L(m[2]).setOpacity(C(h.fillOpacity,.75)).get()));l[v](w);l.startX=f.xMap;l.shiftUnit=h.step?2:1})},drawLegendSymbol:z.drawRectangle});""});N(m,"Series/SplineSeries.js",[m["Core/Series/Series.js"],m["Core/Utilities.js"]],function(f,h){var m=h.pick;f.seriesType("spline","line",{},
{getPointSpline:function(f,h,L){var z=h.plotX||0,C=h.plotY||0,y=f[L-1];L=f[L+1];if(y&&!y.isNull&&!1!==y.doCurve&&!h.isCliff&&L&&!L.isNull&&!1!==L.doCurve&&!h.isCliff){f=y.plotY||0;var e=L.plotX||0;L=L.plotY||0;var F=0;var v=(1.5*z+(y.plotX||0))/2.5;var x=(1.5*C+f)/2.5;e=(1.5*z+e)/2.5;var D=(1.5*C+L)/2.5;e!==v&&(F=(D-x)*(e-z)/(e-v)+C-D);x+=F;D+=F;x>f&&x>C?(x=Math.max(f,C),D=2*C-x):x<f&&x<C&&(x=Math.min(f,C),D=2*C-x);D>L&&D>C?(D=Math.max(L,C),x=2*C-D):D<L&&D<C&&(D=Math.min(L,C),x=2*C-D);h.rightContX=
e;h.rightContY=D}h=["C",m(y.rightContX,y.plotX,0),m(y.rightContY,y.plotY,0),m(v,z,0),m(x,C,0),z,C];y.rightContX=y.rightContY=void 0;return h}});""});N(m,"Series/AreaSplineSeries.js",[m["Core/Series/Series.js"],m["Mixins/LegendSymbol.js"],m["Core/Options.js"]],function(f,h,m){var z=f.seriesTypes.area.prototype;f.seriesType("areaspline","spline",m.defaultOptions.plotOptions.area,{getStackPoints:z.getStackPoints,getGraphPath:z.getGraphPath,drawGraph:z.drawGraph,drawLegendSymbol:h.drawRectangle});""});
N(m,"Series/ColumnSeries.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Series/Series.js"],m["Core/Color/Color.js"],m["Core/Globals.js"],m["Mixins/LegendSymbol.js"],m["Series/LineSeries.js"],m["Core/Utilities.js"]],function(f,h,m,z,F,L,K){var C=f.animObject,y=m.parse;f=z.noop;var e=K.clamp,I=K.defined,v=K.extend,x=K.isArray,D=K.isNumber,n=K.merge,l=K.pick,J=K.objectEach;"";h=h.seriesType("column","line",{borderRadius:0,centerInCategory:!1,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,
cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:void 0,verticalAlign:void 0,y:void 0},startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){L.prototype.init.apply(this,arguments);var e=this,f=e.chart;f.hasRendered&&f.series.forEach(function(d){d.type===e.type&&(d.isDirty=
!0)})},getColumnMetrics:function(){var e=this,f=e.options,d=e.xAxis,g=e.yAxis,c=d.options.reversedStacks;c=d.reversed&&!c||!d.reversed&&c;var a,h={},p=0;!1===f.grouping?p=1:e.chart.series.forEach(function(c){var d=c.yAxis,f=c.options;if(c.type===e.type&&(c.visible||!e.chart.options.chart.ignoreHiddenSeries)&&g.len===d.len&&g.pos===d.pos){if(f.stacking&&"group"!==f.stacking){a=c.stackKey;"undefined"===typeof h[a]&&(h[a]=p++);var q=h[a]}else!1!==f.grouping&&(q=p++);c.columnIndex=q}});var n=Math.min(Math.abs(d.transA)*
(d.ordinal&&d.ordinal.slope||f.pointRange||d.closestPointRange||d.tickInterval||1),d.len),m=n*f.groupPadding,v=(n-2*m)/(p||1);f=Math.min(f.maxPointWidth||d.len,l(f.pointWidth,v*(1-2*f.pointPadding)));e.columnMetrics={width:f,offset:(v-f)/2+(m+((e.columnIndex||0)+(c?1:0))*v-n/2)*(c?-1:1),paddedWidth:v,columnCount:p};return e.columnMetrics},crispCol:function(e,f,d,g){var c=this.chart,a=this.borderWidth,h=-(a%2?.5:0);a=a%2?.5:1;c.inverted&&c.renderer.isVML&&(a+=1);this.options.crisp&&(d=Math.round(e+
d)+h,e=Math.round(e)+h,d-=e);g=Math.round(f+g)+a;h=.5>=Math.abs(f)&&.5<g;f=Math.round(f)+a;g-=f;h&&g&&(--f,g+=1);return{x:e,y:f,width:d,height:g}},adjustForMissingColumns:function(e,f,d,g){var c=this,a=this.options.stacking;if(!d.isNull&&1<g.columnCount){var h=0,p=0;J(this.yAxis.stacking&&this.yAxis.stacking.stacks,function(g){if("number"===typeof d.x&&(g=g[d.x.toString()])){var e=g.points[c.index],f=g.total;a?(e&&(h=p),g.hasValidPoints&&p++):x(e)&&(h=e[1],p=f||0)}});e=(d.plotX||0)+((p-1)*g.paddedWidth+
f)/2-f-h*g.paddedWidth}return e},translate:function(){var f=this,h=f.chart,d=f.options,g=f.dense=2>f.closestPointRange*f.xAxis.transA;g=f.borderWidth=l(d.borderWidth,g?0:1);var c=f.xAxis,a=f.yAxis,q=d.threshold,p=f.translatedThreshold=a.getThreshold(q),n=l(d.minPointLength,5),m=f.getColumnMetrics(),v=m.width,x=f.barW=Math.max(v,1+2*g),y=f.pointXOffset=m.offset,z=f.dataMin,C=f.dataMax;h.inverted&&(p-=.5);d.pointPadding&&(x=Math.ceil(x));L.prototype.translate.apply(f);f.points.forEach(function(g){var u=
l(g.yBottom,p),b=999+Math.abs(u),k=v,t=g.plotX||0;b=e(g.plotY,-b,a.len+b);var r=t+y,w=x,A=Math.min(b,u),B=Math.max(b,u)-A;if(n&&Math.abs(B)<n){B=n;var E=!a.reversed&&!g.negative||a.reversed&&g.negative;D(q)&&D(C)&&g.y===q&&C<=q&&(a.min||0)<q&&z!==C&&(E=!E);A=Math.abs(A-p)>n?u-n:p-(E?n:0)}I(g.options.pointWidth)&&(k=w=Math.ceil(g.options.pointWidth),r-=Math.round((k-v)/2));d.centerInCategory&&(r=f.adjustForMissingColumns(r,k,g,m));g.barX=r;g.pointWidth=k;g.tooltipPos=h.inverted?[a.len+a.pos-h.plotLeft-
b,c.len+c.pos-h.plotTop-(t||0)-y-w/2,B]:[r+w/2,b+a.pos-h.plotTop,B];g.shapeType=f.pointClass.prototype.shapeType||"rect";g.shapeArgs=f.crispCol.apply(f,g.isNull?[r,p,w,0]:[r,A,w,B])})},getSymbol:f,drawLegendSymbol:F.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(e,f){var d=this.options,g=this.pointAttrToOptions||{};var c=g.stroke||"borderColor";var a=g["stroke-width"]||"borderWidth",h=e&&e.color||this.color,p=e&&e[c]||
d[c]||this.color||h,m=e&&e[a]||d[a]||this[a]||0;g=e&&e.options.dashStyle||d.dashStyle;var r=l(e&&e.opacity,d.opacity,1);if(e&&this.zones.length){var v=e.getZone();h=e.options.color||v&&(v.color||e.nonZonedColor)||this.color;v&&(p=v.borderColor||p,g=v.dashStyle||g,m=v.borderWidth||m)}f&&e&&(e=n(d.states[f],e.options.states&&e.options.states[f]||{}),f=e.brightness,h=e.color||"undefined"!==typeof f&&y(h).brighten(e.brightness).get()||h,p=e[c]||p,m=e[a]||m,g=e.dashStyle||g,r=l(e.opacity,r));c={fill:h,
stroke:p,"stroke-width":m,opacity:r};g&&(c.dashstyle=g);return c},drawPoints:function(){var e=this,f=this.chart,d=e.options,g=f.renderer,c=d.animationLimit||250,a;e.points.forEach(function(h){var p=h.graphic,l=!!p,q=p&&f.pointCount<c?"animate":"attr";if(D(h.plotY)&&null!==h.y){a=h.shapeArgs;p&&h.hasNewShapeType()&&(p=p.destroy());e.enabledDataSorting&&(h.startXPos=e.xAxis.reversed?-(a?a.width:0):e.xAxis.width);p||(h.graphic=p=g[h.shapeType](a).add(h.group||e.group))&&e.enabledDataSorting&&f.hasRendered&&
f.pointCount<c&&(p.attr({x:h.startXPos}),l=!0,q="animate");if(p&&l)p[q](n(a));if(d.borderRadius)p[q]({r:d.borderRadius});f.styledMode||p[q](e.pointAttribs(h,h.selected&&"select")).shadow(!1!==h.allowShadow&&d.shadow,null,d.stacking&&!d.borderRadius);p.addClass(h.getClassName(),!0)}else p&&(h.graphic=p.destroy())})},animate:function(f){var h=this,d=this.yAxis,g=h.options,c=this.chart.inverted,a={},l=c?"translateX":"translateY";if(f)a.scaleY=.001,f=e(d.toPixels(g.threshold),d.pos,d.pos+d.len),c?a.translateX=
f-d.len:a.translateY=f,h.clipBox&&h.setClip(),h.group.attr(a);else{var p=h.group.attr(l);h.group.animate({scaleY:1},v(C(h.options.animation),{step:function(c,g){h.group&&(a[l]=p+g.pos*(d.pos-p),h.group.attr(a))}}))}},remove:function(){var e=this,f=e.chart;f.hasRendered&&f.series.forEach(function(d){d.type===e.type&&(d.isDirty=!0)});L.prototype.remove.apply(e,arguments)}});"";return h});N(m,"Series/BarSeries.js",[m["Core/Series/Series.js"]],function(f){f.seriesType("bar","column",null,{inverted:!0});
""});N(m,"Series/ScatterSeries.js",[m["Core/Series/Series.js"],m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h,m){m=m.addEvent;var z=h.Series;f.seriesType("scatter","line",{lineWidth:0,findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group",
"markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){(this.options.lineWidth||0===this.options.lineWidth&&this.graph&&this.graph.strokeWidth())&&z.prototype.drawGraph.call(this)},applyJitter:function(){var f=this,h=this.options.jitter,m=this.points.length;h&&this.points.forEach(function(z,y){["x","y"].forEach(function(e,C){var v="plot"+e.toUpperCase();if(h[e]&&!z.isNull){var x=f[e+"Axis"];var D=h[e]*x.transA;if(x&&!x.isLog){var n=Math.max(0,z[v]-D);x=Math.min(x.len,z[v]+D);
C=1E4*Math.sin(y+C*m);z[v]=n+(x-n)*(C-Math.floor(C));"x"===e&&(z.clientX=z.plotX)}}})})}});m(z,"afterTranslate",function(){this.applyJitter&&this.applyJitter()});""});N(m,"Mixins/CenteredSeries.js",[m["Core/Globals.js"],m["Core/Utilities.js"]],function(f,h){var m=h.isNumber,z=h.pick,F=h.relativeLength,L=f.deg2rad;return f.CenteredSeriesMixin={getCenter:function(){var h=this.options,m=this.chart,y=2*(h.slicedOffset||0),e=m.plotWidth-2*y,I=m.plotHeight-2*y,v=h.center,x=Math.min(e,I),D=h.size,n=h.innerSize||
0;"string"===typeof D&&(D=parseFloat(D));"string"===typeof n&&(n=parseFloat(n));h=[z(v[0],"50%"),z(v[1],"50%"),z(D&&0>D?void 0:h.size,"100%"),z(n&&0>n?void 0:h.innerSize||0,"0%")];!m.angular||this instanceof f.Series||(h[3]=0);for(v=0;4>v;++v)D=h[v],m=2>v||2===v&&/%$/.test(D),h[v]=F(D,[e,I,x,h[2]][v])+(m?y:0);h[3]>h[2]&&(h[3]=h[2]);return h},getStartAndEndRadians:function(f,h){f=m(f)?f:0;h=m(h)&&h>f&&360>h-f?h:f+360;return{start:L*(f+-90),end:L*(h+-90)}}}});N(m,"Series/PieSeries.js",[m["Core/Animation/AnimationUtilities.js"],
m["Core/Series/Series.js"],m["Mixins/CenteredSeries.js"],m["Core/Globals.js"],m["Mixins/LegendSymbol.js"],m["Series/LineSeries.js"],m["Core/Series/Point.js"],m["Core/Renderer/SVG/SVGRenderer.js"],m["Core/Utilities.js"]],function(f,h,m,z,F,L,K,C,y){var e=f.setAnimation,I=m.getStartAndEndRadians;f=z.noop;var v=y.addEvent,x=y.clamp,D=y.defined,n=y.fireEvent,l=y.isNumber,J=y.merge,w=y.pick,r=y.relativeLength;h.seriesType("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,
connectorPadding:5,connectorShape:"fixedOffset",crookDistance:"70%",distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},softConnector:!0,x:0},fillColor:void 0,ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,
trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:h.seriesTypes.column.prototype.pointAttribs,animate:function(d){var g=this,c=g.points,a=g.startAngleRad;d||c.forEach(function(c){var d=c.graphic,e=c.shapeArgs;d&&e&&(d.attr({r:w(c.startR,g.center&&g.center[3]/2),start:a,end:a}),d.animate({r:e.r,start:e.start,end:e.end},g.options.animation))})},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var d,g=0,c=this.points,a=c.length,e=this.options.ignoreHiddenPoint;
for(d=0;d<a;d++){var f=c[d];g+=e&&!f.visible?0:f.isNull?0:f.y}this.total=g;for(d=0;d<a;d++)f=c[d],f.percentage=0<g&&(f.visible||!e)?f.y/g*100:0,f.total=g},generatePoints:function(){L.prototype.generatePoints.call(this);this.updateTotals()},getX:function(d,g,c){var a=this.center,e=this.radii?this.radii[c.index]:a[2]/2;d=Math.asin(x((d-a[1])/(e+c.labelDistance),-1,1));return a[0]+(g?-1:1)*Math.cos(d)*(e+c.labelDistance)+(0<c.labelDistance?(g?-1:1)*this.options.dataLabels.padding:0)},translate:function(d){this.generatePoints();
var g=0,c=this.options,a=c.slicedOffset,e=a+(c.borderWidth||0),f=I(c.startAngle,c.endAngle),h=this.startAngleRad=f.start;f=(this.endAngleRad=f.end)-h;var l=this.points,m=c.dataLabels.distance;c=c.ignoreHiddenPoint;var v,x=l.length;d||(this.center=d=this.getCenter());for(v=0;v<x;v++){var y=l[v];var z=h+g*f;if(!c||y.visible)g+=y.percentage/100;var E=h+g*f;y.shapeType="arc";y.shapeArgs={x:d[0],y:d[1],r:d[2]/2,innerR:d[3]/2,start:Math.round(1E3*z)/1E3,end:Math.round(1E3*E)/1E3};y.labelDistance=w(y.options.dataLabels&&
y.options.dataLabels.distance,m);y.labelDistance=r(y.labelDistance,y.shapeArgs.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,y.labelDistance);E=(E+z)/2;E>1.5*Math.PI?E-=2*Math.PI:E<-Math.PI/2&&(E+=2*Math.PI);y.slicedTranslation={translateX:Math.round(Math.cos(E)*a),translateY:Math.round(Math.sin(E)*a)};var u=Math.cos(E)*d[2]/2;var b=Math.sin(E)*d[2]/2;y.tooltipPos=[d[0]+.7*u,d[1]+.7*b];y.half=E<-Math.PI/2||E>Math.PI/2?1:0;y.angle=E;z=Math.min(e,y.labelDistance/5);y.labelPosition={natural:{x:d[0]+
u+Math.cos(E)*y.labelDistance,y:d[1]+b+Math.sin(E)*y.labelDistance},"final":{},alignment:0>y.labelDistance?"center":y.half?"right":"left",connectorPosition:{breakAt:{x:d[0]+u+Math.cos(E)*z,y:d[1]+b+Math.sin(E)*z},touchingSliceAt:{x:d[0]+u,y:d[1]+b}}}}n(this,"afterTranslate")},drawEmpty:function(){var d=this.startAngleRad,g=this.endAngleRad,c=this.options;if(0===this.total&&this.center){var a=this.center[0];var e=this.center[1];this.graph||(this.graph=this.chart.renderer.arc(a,e,this.center[1]/2,0,
d,g).addClass("highcharts-empty-series").add(this.group));this.graph.attr({d:C.prototype.symbols.arc(a,e,this.center[2]/2,0,{start:d,end:g,innerR:this.center[3]/2})});this.chart.styledMode||this.graph.attr({"stroke-width":c.borderWidth,fill:c.fillColor||"none",stroke:c.color||"#cccccc"})}else this.graph&&(this.graph=this.graph.destroy())},redrawPoints:function(){var d=this,e=d.chart,c=e.renderer,a,f,h,l,n=d.options.shadow;this.drawEmpty();!n||d.shadowGroup||e.styledMode||(d.shadowGroup=c.g("shadow").attr({zIndex:-1}).add(d.group));
d.points.forEach(function(g){var p={};f=g.graphic;if(!g.isNull&&f){l=g.shapeArgs;a=g.getTranslate();if(!e.styledMode){var q=g.shadowGroup;n&&!q&&(q=g.shadowGroup=c.g("shadow").add(d.shadowGroup));q&&q.attr(a);h=d.pointAttribs(g,g.selected&&"select")}g.delayedRendering?(f.setRadialReference(d.center).attr(l).attr(a),e.styledMode||f.attr(h).attr({"stroke-linejoin":"round"}).shadow(n,q),g.delayedRendering=!1):(f.setRadialReference(d.center),e.styledMode||J(!0,p,h),J(!0,p,l,a),f.animate(p));f.attr({visibility:g.visible?
"inherit":"hidden"});f.addClass(g.getClassName())}else f&&(g.graphic=f.destroy())})},drawPoints:function(){var d=this.chart.renderer;this.points.forEach(function(e){e.graphic&&e.hasNewShapeType()&&(e.graphic=e.graphic.destroy());e.graphic||(e.graphic=d[e.shapeType](e.shapeArgs).add(e.series.group),e.delayedRendering=!0)})},searchPoint:f,sortByAngle:function(d,e){d.sort(function(c,a){return"undefined"!==typeof c.angle&&(a.angle-c.angle)*e})},drawLegendSymbol:F.drawRectangle,getCenter:m.getCenter,getSymbol:f,
drawGraph:null},{init:function(){K.prototype.init.apply(this,arguments);var d=this;d.name=w(d.name,"Slice");var e=function(c){d.slice("select"===c.type)};v(d,"select",e);v(d,"unselect",e);return d},isValid:function(){return l(this.y)&&0<=this.y},setVisible:function(d,e){var c=this,a=c.series,g=a.chart,f=a.options.ignoreHiddenPoint;e=w(e,f);d!==c.visible&&(c.visible=c.options.visible=d="undefined"===typeof d?!c.visible:d,a.options.data[a.data.indexOf(c)]=c.options,["graphic","dataLabel","connector",
"shadowGroup"].forEach(function(a){if(c[a])c[a][d?"show":"hide"](!0)}),c.legendItem&&g.legend.colorizeItem(c,d),d||"hover"!==c.state||c.setState(""),f&&(a.isDirty=!0),e&&g.redraw())},slice:function(d,g,c){var a=this.series;e(c,a.chart);w(g,!0);this.sliced=this.options.sliced=D(d)?d:!this.sliced;a.options.data[a.data.indexOf(this)]=this.options;this.graphic&&this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?
this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(d){var e=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(e.x,e.y,e.r+d,e.r+d,{innerR:e.r-1,start:e.start,end:e.end})},connectorShapes:{fixedOffset:function(d,e,c){var a=e.breakAt;e=e.touchingSliceAt;return[["M",d.x,d.y],c.softConnector?["C",d.x+("left"===d.alignment?-5:5),d.y,2*a.x-e.x,2*a.y-e.y,a.x,a.y]:["L",a.x,a.y],["L",e.x,e.y]]},straight:function(d,e){e=e.touchingSliceAt;return[["M",
d.x,d.y],["L",e.x,e.y]]},crookedLine:function(d,e,c){e=e.touchingSliceAt;var a=this.series,g=a.center[0],f=a.chart.plotWidth,h=a.chart.plotLeft;a=d.alignment;var l=this.shapeArgs.r;c=r(c.crookDistance,1);f="left"===a?g+l+(f+h-g-l)*(1-c):h+(g-l)*c;c=["L",f,d.y];g=!0;if("left"===a?f>d.x||f<e.x:f<d.x||f>e.x)g=!1;d=[["M",d.x,d.y]];g&&d.push(c);d.push(["L",e.x,e.y]);return d}},getConnectorPath:function(){var d=this.labelPosition,e=this.series.options.dataLabels,c=e.connectorShape,a=this.connectorShapes;
a[c]&&(c=a[c]);return c.call(this,{x:d.final.x,y:d.final.y,alignment:d.alignment},d.connectorPosition,e)}});""});N(m,"Core/Series/DataLabels.js",[m["Core/Animation/AnimationUtilities.js"],m["Core/Globals.js"],m["Core/Series/CartesianSeries.js"],m["Core/Utilities.js"]],function(f,h,m,z){var F=f.getDeferredAnimation;f=h.noop;var L=h.seriesTypes,K=z.arrayMax,C=z.clamp,y=z.defined,e=z.extend,I=z.fireEvent,v=z.format,x=z.isArray,D=z.merge,n=z.objectEach,l=z.pick,J=z.relativeLength,w=z.splat,r=z.stableSort;
"";h.distribute=function(d,e,c){function a(a,c){return a.target-c.target}var f,g=!0,n=d,m=[];var v=0;var w=n.reducedLen||e;for(f=d.length;f--;)v+=d[f].size;if(v>w){r(d,function(a,c){return(c.rank||0)-(a.rank||0)});for(v=f=0;v<=w;)v+=d[f].size,f++;m=d.splice(f-1,d.length)}r(d,a);for(d=d.map(function(a){return{size:a.size,targets:[a.target],align:l(a.align,.5)}});g;){for(f=d.length;f--;)g=d[f],v=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/2,g.pos=C(v-g.size*g.align,0,e-g.size);f=d.length;
for(g=!1;f--;)0<f&&d[f-1].pos+d[f-1].size>d[f].pos&&(d[f-1].size+=d[f].size,d[f-1].targets=d[f-1].targets.concat(d[f].targets),d[f-1].align=.5,d[f-1].pos+d[f-1].size>e&&(d[f-1].pos=e-d[f-1].size),d.splice(f,1),g=!0)}n.push.apply(n,m);f=0;d.some(function(a){var d=0;if(a.targets.some(function(){n[f].pos=a.pos+d;if("undefined"!==typeof c&&Math.abs(n[f].pos-n[f].target)>c)return n.slice(0,f+1).forEach(function(a){delete a.pos}),n.reducedLen=(n.reducedLen||e)-.1*e,n.reducedLen>.1*e&&h.distribute(n,e,c),
!0;d+=n[f].size;f++}))return!0});r(n,a)};m.prototype.drawDataLabels=function(){function d(a,c){var d=c.filter;return d?(c=d.operator,a=a[d.property],d=d.value,">"===c&&a>d||"<"===c&&a<d||">="===c&&a>=d||"<="===c&&a<=d||"=="===c&&a==d||"==="===c&&a===d?!0:!1):!0}function e(a,c){var d=[],b;if(x(a)&&!x(c))d=a.map(function(a){return D(a,c)});else if(x(c)&&!x(a))d=c.map(function(b){return D(a,b)});else if(x(a)||x(c))for(b=Math.max(a.length,c.length);b--;)d[b]=D(a[b],c[b]);else d=D(a,c);return d}var c=
this,a=c.chart,f=c.options,h=f.dataLabels,m=c.points,r,G=c.hasRendered||0,z=h.animation;z=h.defer?F(a,z,c):{defer:0,duration:0};var C=a.renderer;h=e(e(a.options.plotOptions&&a.options.plotOptions.series&&a.options.plotOptions.series.dataLabels,a.options.plotOptions&&a.options.plotOptions[c.type]&&a.options.plotOptions[c.type].dataLabels),h);I(this,"drawDataLabels");if(x(h)||h.enabled||c._hasPointLabels){var J=c.plotGroup("dataLabelsGroup","data-labels",G?"inherit":"hidden",h.zIndex||6);J.attr({opacity:+G});
!G&&(G=c.dataLabelsGroup)&&(c.visible&&J.show(!0),G[f.animation?"animate":"attr"]({opacity:1},z));m.forEach(function(g){r=w(e(h,g.dlOptions||g.options&&g.options.dataLabels));r.forEach(function(e,h){var b=e.enabled&&(!g.isNull||g.dataLabelOnNull)&&d(g,e),k=g.dataLabels?g.dataLabels[h]:g.dataLabel,p=g.connectors?g.connectors[h]:g.connector,m=l(e.distance,g.labelDistance),q=!k;if(b){var u=g.getLabelConfig();var r=l(e[g.formatPrefix+"Format"],e.format);u=y(r)?v(r,u,a):(e[g.formatPrefix+"Formatter"]||
e.formatter).call(u,e);r=e.style;var A=e.rotation;a.styledMode||(r.color=l(e.color,r.color,c.color,"#000000"),"contrast"===r.color?(g.contrastColor=C.getContrast(g.color||c.color),r.color=!y(m)&&e.inside||0>m||f.stacking?g.contrastColor:"#000000"):delete g.contrastColor,f.cursor&&(r.cursor=f.cursor));var w={r:e.borderRadius||0,rotation:A,padding:e.padding,zIndex:1};a.styledMode||(w.fill=e.backgroundColor,w.stroke=e.borderColor,w["stroke-width"]=e.borderWidth);n(w,function(a,b){"undefined"===typeof a&&
delete w[b]})}!k||b&&y(u)?b&&y(u)&&(k?w.text=u:(g.dataLabels=g.dataLabels||[],k=g.dataLabels[h]=A?C.text(u,0,-9999,e.useHTML).addClass("highcharts-data-label"):C.label(u,0,-9999,e.shape,null,null,e.useHTML,null,"data-label"),h||(g.dataLabel=k),k.addClass(" highcharts-data-label-color-"+g.colorIndex+" "+(e.className||"")+(e.useHTML?" highcharts-tracker":""))),k.options=e,k.attr(w),a.styledMode||k.css(r).shadow(e.shadow),k.added||k.add(J),e.textPath&&!e.useHTML&&(k.setTextPath(g.getDataLabelPath&&g.getDataLabelPath(k)||
g.graphic,e.textPath),g.dataLabelPath&&!e.textPath.enabled&&(g.dataLabelPath=g.dataLabelPath.destroy())),c.alignDataLabel(g,k,e,null,q)):(g.dataLabel=g.dataLabel&&g.dataLabel.destroy(),g.dataLabels&&(1===g.dataLabels.length?delete g.dataLabels:delete g.dataLabels[h]),h||delete g.dataLabel,p&&(g.connector=g.connector.destroy(),g.connectors&&(1===g.connectors.length?delete g.connectors:delete g.connectors[h])))})})}I(this,"afterDrawDataLabels")};m.prototype.alignDataLabel=function(d,g,c,a,f){var h=
this,n=this.chart,m=this.isCartesian&&n.inverted,q=this.enabledDataSorting,r=l(d.dlBox&&d.dlBox.centerX,d.plotX,-9999),v=l(d.plotY,-9999),w=g.getBBox(),x=c.rotation,y=c.align,u=n.isInsidePlot(r,Math.round(v),m),b="justify"===l(c.overflow,q?"none":"justify"),k=this.visible&&!1!==d.visible&&(d.series.forceDL||q&&!b||u||c.inside&&a&&n.isInsidePlot(r,m?a.x+1:a.y+a.height-1,m));var t=function(a){q&&h.xAxis&&!b&&h.setDataLabelStartPos(d,g,f,u,a)};if(k){var z=n.renderer.fontMetrics(n.styledMode?void 0:c.style.fontSize,
g).b;a=e({x:m?this.yAxis.len-v:r,y:Math.round(m?this.xAxis.len-r:v),width:0,height:0},a);e(c,{width:w.width,height:w.height});x?(b=!1,r=n.renderer.rotCorr(z,x),r={x:a.x+(c.x||0)+a.width/2+r.x,y:a.y+(c.y||0)+{top:0,middle:.5,bottom:1}[c.verticalAlign]*a.height},t(r),g[f?"attr":"animate"](r).attr({align:y}),t=(x+720)%360,t=180<t&&360>t,"left"===y?r.y-=t?w.height:0:"center"===y?(r.x-=w.width/2,r.y-=w.height/2):"right"===y&&(r.x-=w.width,r.y-=t?0:w.height),g.placed=!0,g.alignAttr=r):(t(a),g.align(c,null,
a),r=g.alignAttr);b&&0<=a.height?this.justifyDataLabel(g,c,r,w,a,f):l(c.crop,!0)&&(k=n.isInsidePlot(r.x,r.y)&&n.isInsidePlot(r.x+w.width,r.y+w.height));if(c.shape&&!x)g[f?"attr":"animate"]({anchorX:m?n.plotWidth-d.plotY:d.plotX,anchorY:m?n.plotHeight-d.plotX:d.plotY})}f&&q&&(g.placed=!1);k||q&&!b||(g.hide(!0),g.placed=!1)};m.prototype.setDataLabelStartPos=function(d,e,c,a,f){var g=this.chart,h=g.inverted,l=this.xAxis,n=l.reversed,m=h?e.height/2:e.width/2;d=(d=d.pointWidth)?d/2:0;l=h?f.x:n?-m-d:l.width-
m+d;f=h?n?this.yAxis.height-m+d:-m-d:f.y;e.startXPos=l;e.startYPos=f;a?"hidden"===e.visibility&&(e.show(),e.attr({opacity:0}).animate({opacity:1})):e.attr({opacity:1}).animate({opacity:0},void 0,e.hide);g.hasRendered&&(c&&e.attr({x:e.startXPos,y:e.startYPos}),e.placed=!0)};m.prototype.justifyDataLabel=function(d,e,c,a,f,h){var g=this.chart,p=e.align,l=e.verticalAlign,n=d.box?0:d.padding||0,m=e.x;m=void 0===m?0:m;var q=e.y;var r=void 0===q?0:q;q=c.x+n;if(0>q){"right"===p&&0<=m?(e.align="left",e.inside=
!0):m-=q;var v=!0}q=c.x+a.width-n;q>g.plotWidth&&("left"===p&&0>=m?(e.align="right",e.inside=!0):m+=g.plotWidth-q,v=!0);q=c.y+n;0>q&&("bottom"===l&&0<=r?(e.verticalAlign="top",e.inside=!0):r-=q,v=!0);q=c.y+a.height-n;q>g.plotHeight&&("top"===l&&0>=r?(e.verticalAlign="bottom",e.inside=!0):r+=g.plotHeight-q,v=!0);v&&(e.x=m,e.y=r,d.placed=!h,d.align(e,void 0,f));return v};L.pie&&(L.pie.prototype.dataLabelPositioners={radialDistributionY:function(d){return d.top+d.distributeBox.pos},radialDistributionX:function(d,
e,c,a){return d.getX(c<e.top+2||c>e.bottom-2?a:c,e.half,e)},justify:function(d,e,c){return c[0]+(d.half?-1:1)*(e+d.labelDistance)},alignToPlotEdges:function(d,e,c,a){d=d.getBBox().width;return e?d+a:c-d-a},alignToConnectors:function(d,e,c,a){var f=0,g;d.forEach(function(a){g=a.dataLabel.getBBox().width;g>f&&(f=g)});return e?f+a:c-f-a}},L.pie.prototype.drawDataLabels=function(){var d=this,e=d.data,c,a=d.chart,f=d.options.dataLabels||{},p=f.connectorPadding,n,r=a.plotWidth,v=a.plotHeight,w=a.plotLeft,
x=Math.round(a.chartWidth/3),z,C=d.center,E=C[2]/2,u=C[1],b,k,t,F,I=[[],[]],J,L,N,P,S=[0,0,0,0],Y=d.dataLabelPositioners,W;d.visible&&(f.enabled||d._hasPointLabels)&&(e.forEach(function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),m.prototype.drawDataLabels.apply(d),e.forEach(function(a){a.dataLabel&&(a.visible?(I[a.half].push(a),a.dataLabel._pos=null,!y(f.style.width)&&!y(a.options.dataLabels&&
a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>x&&(a.dataLabel.css({width:Math.round(.7*x)+"px"}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&1===a.dataLabels.length&&delete a.dataLabels))}),I.forEach(function(e,g){var n=e.length,m=[],q;if(n){d.sortByAngle(e,g-.5);if(0<d.maxLabelDistance){var A=Math.max(0,u-E-d.maxLabelDistance);var B=Math.min(u+E+d.maxLabelDistance,a.plotHeight);e.forEach(function(b){0<b.labelDistance&&b.dataLabel&&
(b.top=Math.max(0,u-E-b.labelDistance),b.bottom=Math.min(u+E+b.labelDistance,a.plotHeight),q=b.dataLabel.getBBox().height||21,b.distributeBox={target:b.labelPosition.natural.y-b.top+q/2,size:q,rank:b.y},m.push(b.distributeBox))});A=B+q-A;h.distribute(m,A,A/5)}for(P=0;P<n;P++){c=e[P];t=c.labelPosition;b=c.dataLabel;N=!1===c.visible?"hidden":"inherit";L=A=t.natural.y;m&&y(c.distributeBox)&&("undefined"===typeof c.distributeBox.pos?N="hidden":(F=c.distributeBox.size,L=Y.radialDistributionY(c)));delete c.positionIndex;
if(f.justify)J=Y.justify(c,E,C);else switch(f.alignTo){case "connectors":J=Y.alignToConnectors(e,g,r,w);break;case "plotEdges":J=Y.alignToPlotEdges(b,g,r,w);break;default:J=Y.radialDistributionX(d,c,L,A)}b._attr={visibility:N,align:t.alignment};W=c.options.dataLabels||{};b._pos={x:J+l(W.x,f.x)+({left:p,right:-p}[t.alignment]||0),y:L+l(W.y,f.y)-10};t.final.x=J;t.final.y=L;l(f.crop,!0)&&(k=b.getBBox().width,A=null,J-k<p&&1===g?(A=Math.round(k-J+p),S[3]=Math.max(A,S[3])):J+k>r-p&&0===g&&(A=Math.round(J+
k-r+p),S[1]=Math.max(A,S[1])),0>L-F/2?S[0]=Math.max(Math.round(-L+F/2),S[0]):L+F/2>v&&(S[2]=Math.max(Math.round(L+F/2-v),S[2])),b.sideOverflow=A)}}}),0===K(S)||this.verifyDataLabelOverflow(S))&&(this.placeDataLabels(),this.points.forEach(function(c){W=D(f,c.options.dataLabels);if(n=l(W.connectorWidth,1)){var e;z=c.connector;if((b=c.dataLabel)&&b._pos&&c.visible&&0<c.labelDistance){N=b._attr.visibility;if(e=!z)c.connector=z=a.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+
c.colorIndex+(c.className?" "+c.className:"")).add(d.dataLabelsGroup),a.styledMode||z.attr({"stroke-width":n,stroke:W.connectorColor||c.color||"#666666"});z[e?"attr":"animate"]({d:c.getConnectorPath()});z.attr("visibility",N)}else z&&(c.connector=z.destroy())}}))},L.pie.prototype.placeDataLabels=function(){this.points.forEach(function(d){var e=d.dataLabel,c;e&&d.visible&&((c=e._pos)?(e.sideOverflow&&(e._attr.width=Math.max(e.getBBox().width-e.sideOverflow,0),e.css({width:e._attr.width+"px",textOverflow:(this.options.dataLabels.style||
{}).textOverflow||"ellipsis"}),e.shortened=!0),e.attr(e._attr),e[e.moved?"animate":"attr"](c),e.moved=!0):e&&e.attr({y:-9999}));delete d.distributeBox},this)},L.pie.prototype.alignDataLabel=f,L.pie.prototype.verifyDataLabelOverflow=function(d){var e=this.center,c=this.options,a=c.center,f=c.minSize||80,h=null!==c.size;if(!h){if(null!==a[0])var l=Math.max(e[2]-Math.max(d[1],d[3]),f);else l=Math.max(e[2]-d[1]-d[3],f),e[0]+=(d[3]-d[1])/2;null!==a[1]?l=C(l,f,e[2]-Math.max(d[0],d[2])):(l=C(l,f,e[2]-d[0]-
d[2]),e[1]+=(d[0]-d[2])/2);l<e[2]?(e[2]=l,e[3]=Math.min(J(c.innerSize||0,l),l),this.translate(e),this.drawDataLabels&&this.drawDataLabels()):h=!0}return h});L.column&&(L.column.prototype.alignDataLabel=function(d,e,c,a,f){var g=this.chart.inverted,h=d.series,n=d.dlBox||d.shapeArgs,q=l(d.below,d.plotY>l(this.translatedThreshold,h.yAxis.len)),r=l(c.inside,!!this.options.stacking);n&&(a=D(n),0>a.y&&(a.height+=a.y,a.y=0),n=a.y+a.height-h.yAxis.len,0<n&&n<a.height&&(a.height-=n),g&&(a={x:h.yAxis.len-a.y-
a.height,y:h.xAxis.len-a.x-a.width,width:a.height,height:a.width}),r||(g?(a.x+=q?0:a.width,a.width=0):(a.y+=q?a.height:0,a.height=0)));c.align=l(c.align,!g||r?"center":q?"right":"left");c.verticalAlign=l(c.verticalAlign,g||r?"middle":q?"top":"bottom");m.prototype.alignDataLabel.call(this,d,e,c,a,f);c.inside&&d.contrastColor&&e.css({color:d.contrastColor})})});N(m,"Extensions/OverlappingDataLabels.js",[m["Core/Chart/Chart.js"],m["Core/Utilities.js"]],function(f,h){var m=h.addEvent,z=h.fireEvent,F=
h.isArray,L=h.isNumber,K=h.objectEach,C=h.pick;m(f,"render",function(){var f=[];(this.labelCollectors||[]).forEach(function(e){f=f.concat(e())});(this.yAxis||[]).forEach(function(e){e.stacking&&e.options.stackLabels&&!e.options.stackLabels.allowOverlap&&K(e.stacking.stacks,function(e){K(e,function(e){f.push(e.label)})})});(this.series||[]).forEach(function(e){var h=e.options.dataLabels;e.visible&&(!1!==h.enabled||e._hasPointLabels)&&(e.nodes||e.points).forEach(function(e){e.visible&&(F(e.dataLabels)?
e.dataLabels:e.dataLabel?[e.dataLabel]:[]).forEach(function(h){var m=h.options;h.labelrank=C(m.labelrank,e.labelrank,e.shapeArgs&&e.shapeArgs.height);m.allowOverlap||f.push(h)})})});this.hideOverlappingLabels(f)});f.prototype.hideOverlappingLabels=function(f){var e=this,h=f.length,m=e.renderer,x,y,n,l=!1;var C=function(d){var e,c=d.box?0:d.padding||0,a=e=0,f;if(d&&(!d.alignAttr||d.placed)){var h=d.alignAttr||{x:d.attr("x"),y:d.attr("y")};var l=d.parentGroup;d.width||(e=d.getBBox(),d.width=e.width,
d.height=e.height,e=m.fontMetrics(null,d.element).h);var n=d.width-2*c;(f={left:"0",center:"0.5",right:"1"}[d.alignValue])?a=+f*n:L(d.x)&&Math.round(d.x)!==d.translateX&&(a=d.x-d.translateX);return{x:h.x+(l.translateX||0)+c-(a||0),y:h.y+(l.translateY||0)+c-e,width:d.width-2*c,height:d.height-2*c}}};for(y=0;y<h;y++)if(x=f[y])x.oldOpacity=x.opacity,x.newOpacity=1,x.absoluteBox=C(x);f.sort(function(d,e){return(e.labelrank||0)-(d.labelrank||0)});for(y=0;y<h;y++){var w=(C=f[y])&&C.absoluteBox;for(x=y+
1;x<h;++x){var r=(n=f[x])&&n.absoluteBox;!w||!r||C===n||0===C.newOpacity||0===n.newOpacity||r.x>=w.x+w.width||r.x+r.width<=w.x||r.y>=w.y+w.height||r.y+r.height<=w.y||((C.labelrank<n.labelrank?C:n).newOpacity=0)}}f.forEach(function(d){if(d){var f=d.newOpacity;d.oldOpacity!==f&&(d.alignAttr&&d.placed?(d[f?"removeClass":"addClass"]("highcharts-data-label-hidden"),l=!0,d.alignAttr.opacity=f,d[d.isOld?"animate":"attr"](d.alignAttr,null,function(){e.styledMode||d.css({pointerEvents:f?"auto":"none"});d.visibility=
f?"inherit":"hidden"}),z(e,"afterHideOverlappingLabel")):d.attr({opacity:f}));d.isOld=!0}});l&&z(e,"afterHideAllOverlappingLabels")}});N(m,"Core/Interaction.js",[m["Core/Series/Series.js"],m["Core/Chart/Chart.js"],m["Core/Globals.js"],m["Core/Legend.js"],m["Series/LineSeries.js"],m["Core/Options.js"],m["Core/Series/Point.js"],m["Core/Utilities.js"]],function(f,h,m,z,F,L,K,C){f=f.seriesTypes;var y=m.hasTouch,e=m.svg,I=L.defaultOptions,v=C.addEvent,x=C.createElement,D=C.css,n=C.defined,l=C.extend,J=
C.fireEvent,w=C.isArray,r=C.isFunction,d=C.isNumber,g=C.isObject,c=C.merge,a=C.objectEach,q=C.pick;"";m=m.TrackerMixin={drawTrackerPoint:function(){var a=this,c=a.chart,d=c.pointer,e=function(a){var c=d.getPointFromEvent(a);"undefined"!==typeof c&&(d.isDirectTouch=!0,c.onMouseOver(a))},f;a.points.forEach(function(a){f=w(a.dataLabels)?a.dataLabels:a.dataLabel?[a.dataLabel]:[];a.graphic&&(a.graphic.element.point=a);f.forEach(function(c){c.div?c.div.point=a:c.element.point=a})});a._hasTracking||(a.trackerGroups.forEach(function(f){if(a[f]){a[f].addClass("highcharts-tracker").on("mouseover",
e).on("mouseout",function(a){d.onTrackerMouseOut(a)});if(y)a[f].on("touchstart",e);!c.styledMode&&a.options.cursor&&a[f].css(D).css({cursor:a.options.cursor})}}),a._hasTracking=!0);J(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,c=a.options,d=c.trackByArea,f=[].concat(d?a.areaPath:a.graphPath),g=a.chart,h=g.pointer,l=g.renderer,n=g.options.tooltip.snap,m=a.tracker,q=function(b){if(g.hoverSeries!==a)a.onMouseOver()},b="rgba(192,192,192,"+(e?.0001:.002)+")";m?m.attr({d:f}):a.graph&&
(a.tracker=l.path(f).attr({visibility:a.visible?"visible":"hidden",zIndex:2}).addClass(d?"highcharts-tracker-area":"highcharts-tracker-line").add(a.group),g.styledMode||a.tracker.attr({"stroke-linecap":"round","stroke-linejoin":"round",stroke:b,fill:d?b:"none","stroke-width":a.graph.strokeWidth()+(d?0:2*n)}),[a.tracker,a.markerGroup].forEach(function(a){a.addClass("highcharts-tracker").on("mouseover",q).on("mouseout",function(a){h.onTrackerMouseOut(a)});c.cursor&&!g.styledMode&&a.css({cursor:c.cursor});
if(y)a.on("touchstart",q)}));J(this,"afterDrawTracker")}};f.column&&(f.column.prototype.drawTracker=m.drawTrackerPoint);f.pie&&(f.pie.prototype.drawTracker=m.drawTrackerPoint);f.scatter&&(f.scatter.prototype.drawTracker=m.drawTrackerPoint);l(z.prototype,{setItemEvents:function(a,d,e){var f=this,g=f.chart.renderer.boxWrapper,h=a instanceof K,p="highcharts-legend-"+(h?"point":"series")+"-active",l=f.chart.styledMode;(e?[d,a.legendSymbol]:[a.legendGroup]).forEach(function(e){if(e)e.on("mouseover",function(){a.visible&&
f.allItems.forEach(function(c){a!==c&&c.setState("inactive",!h)});a.setState("hover");a.visible&&g.addClass(p);l||d.css(f.options.itemHoverStyle)}).on("mouseout",function(){f.chart.styledMode||d.css(c(a.visible?f.itemStyle:f.itemHiddenStyle));f.allItems.forEach(function(c){a!==c&&c.setState("",!h)});g.removeClass(p);a.setState()}).on("click",function(c){var b=function(){a.setVisible&&a.setVisible();f.allItems.forEach(function(b){a!==b&&b.setState(a.visible?"inactive":"",!h)})};g.removeClass(p);c=
{browserEvent:c};a.firePointEvent?a.firePointEvent("legendItemClick",c,b):J(a,"legendItemClick",c,b)})})},createCheckboxForItem:function(a){a.checkbox=x("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);v(a.checkbox,"click",function(c){J(a.series||a,"checkboxClick",{checked:c.target.checked,item:a},function(){a.select()})})}});l(h.prototype,{showResetZoom:function(){function a(){c.zoomOut()}
var c=this,d=I.lang,e=c.options.chart.resetZoomButton,f=e.theme,g=f.states,h="chart"===e.relativeTo||"spaceBox"===e.relativeTo?null:"plotBox";J(this,"beforeShowResetZoom",null,function(){c.resetZoomButton=c.renderer.button(d.resetZoom,null,null,a,f,g&&g.hover).attr({align:e.position.align,title:d.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(e.position,!1,h)});J(this,"afterShowResetZoom")},zoomOut:function(){J(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var c=
this,d,e=c.pointer,f=!1,h=c.inverted?e.mouseDownX:e.mouseDownY;!a||a.resetSelection?(c.axes.forEach(function(a){d=a.zoom()}),e.initiated=!1):a.xAxis.concat(a.yAxis).forEach(function(a){var g=a.axis,p=c.inverted?g.left:g.top,b=c.inverted?p+g.width:p+g.height,k=g.isXAxis,l=!1;if(!k&&h>=p&&h<=b||k||!n(h))l=!0;e[k?"zoomX":"zoomY"]&&l&&(d=g.zoom(a.min,a.max),g.displayBtn&&(f=!0))});var p=c.resetZoomButton;f&&!p?c.showResetZoom():!f&&g(p)&&(c.resetZoomButton=p.destroy());d&&c.redraw(q(c.options.chart.animation,
a&&a.animation,100>c.pointCount))},pan:function(a,c){var e=this,f=e.hoverPoints,g=e.options.chart,h=e.options.mapNavigation&&e.options.mapNavigation.enabled,p;c="object"===typeof c?c:{enabled:c,type:"x"};g&&g.panning&&(g.panning=c);var l=c.type;J(this,"pan",{originalEvent:a},function(){f&&f.forEach(function(a){a.setState()});var c=[1];"xy"===l?c=[1,0]:"y"===l&&(c=[0]);c.forEach(function(c){var b=e[c?"xAxis":"yAxis"][0],f=b.horiz,g=a[f?"chartX":"chartY"];f=f?"mouseDownX":"mouseDownY";var n=e[f],m=
(b.pointRange||0)/2,r=b.reversed&&!e.inverted||!b.reversed&&e.inverted?-1:1,u=b.getExtremes(),v=b.toValue(n-g,!0)+m*r;r=b.toValue(n+b.len-g,!0)-m*r;var w=r<v;n=w?r:v;v=w?v:r;var A=b.hasVerticalPanning(),x=b.panningState;b.series.forEach(function(a){if(A&&!c&&(!x||x.isDirty)){var b=a.getProcessedData(!0);a=a.getExtremes(b.yData,!0);x||(x={startMin:Number.MAX_VALUE,startMax:-Number.MAX_VALUE});d(a.dataMin)&&d(a.dataMax)&&(x.startMin=Math.min(a.dataMin,x.startMin),x.startMax=Math.max(a.dataMax,x.startMax))}});
r=Math.min(q(null===x||void 0===x?void 0:x.startMin,u.dataMin),m?u.min:b.toValue(b.toPixels(u.min)-b.minPixelPadding));m=Math.max(q(null===x||void 0===x?void 0:x.startMax,u.dataMax),m?u.max:b.toValue(b.toPixels(u.max)+b.minPixelPadding));b.panningState=x;b.isOrdinal||(w=r-n,0<w&&(v+=w,n=r),w=v-m,0<w&&(v=m,n-=w),b.series.length&&n!==u.min&&v!==u.max&&n>=r&&v<=m&&(b.setExtremes(n,v,!1,!1,{trigger:"pan"}),e.resetZoomButton||h||n===r||v===m||!l.match("y")||(e.showResetZoom(),b.displayBtn=!1),p=!0),e[f]=
g)});p&&e.redraw(!1);D(e.container,{cursor:"move"})})}});l(K.prototype,{select:function(a,c){var d=this,e=d.series,f=e.chart;this.selectedStaging=a=q(a,!d.selected);d.firePointEvent(a?"select":"unselect",{accumulate:c},function(){d.selected=d.options.selected=a;e.options.data[e.data.indexOf(d)]=d.options;d.setState(a&&"select");c||f.getSelectedPoints().forEach(function(a){var c=a.series;a.selected&&a!==d&&(a.selected=a.options.selected=!1,c.options.data[c.data.indexOf(a)]=a.options,a.setState(f.hoverPoints&&
c.options.inactiveOtherPoints?"inactive":""),a.firePointEvent("unselect"))})});delete this.selectedStaging},onMouseOver:function(a){var c=this.series.chart,d=c.pointer;a=a?d.normalize(a):d.getChartCoordinatesFromPoint(this,c.inverted);d.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(a.hoverPoints||[]).forEach(function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var d=
this,e=c(d.series.options.point,d.options).events;d.events=e;a(e,function(a,c){r(a)&&v(d,c,a)});this.hasImportedEvents=!0}},setState:function(a,c){var d=this.series,e=this.state,f=d.options.states[a||"normal"]||{},g=I.plotOptions[d.type].marker&&d.options.marker,h=g&&!1===g.enabled,p=g&&g.states&&g.states[a||"normal"]||{},n=!1===p.enabled,m=d.stateMarkerGraphic,b=this.marker||{},k=d.chart,r=d.halo,v,w=g&&d.markerAttribs;a=a||"";if(!(a===this.state&&!c||this.selected&&"select"!==a||!1===f.enabled||
a&&(n||h&&!1===p.enabled)||a&&b.states&&b.states[a]&&!1===b.states[a].enabled)){this.state=a;w&&(v=d.markerAttribs(this,a));if(this.graphic){e&&this.graphic.removeClass("highcharts-point-"+e);a&&this.graphic.addClass("highcharts-point-"+a);if(!k.styledMode){var x=d.pointAttribs(this,a);var y=q(k.options.chart.animation,f.animation);d.options.inactiveOtherPoints&&x.opacity&&((this.dataLabels||[]).forEach(function(a){a&&a.animate({opacity:x.opacity},y)}),this.connector&&this.connector.animate({opacity:x.opacity},
y));this.graphic.animate(x,y)}v&&this.graphic.animate(v,q(k.options.chart.animation,p.animation,g.animation));m&&m.hide()}else{if(a&&p){e=b.symbol||d.symbol;m&&m.currentSymbol!==e&&(m=m.destroy());if(v)if(m)m[c?"animate":"attr"]({x:v.x,y:v.y});else e&&(d.stateMarkerGraphic=m=k.renderer.symbol(e,v.x,v.y,v.width,v.height).add(d.markerGroup),m.currentSymbol=e);!k.styledMode&&m&&m.attr(d.pointAttribs(this,a))}m&&(m[a&&this.isInside?"show":"hide"](),m.element.point=this)}a=f.halo;f=(m=this.graphic||m)&&
m.visibility||"inherit";a&&a.size&&m&&"hidden"!==f&&!this.isCluster?(r||(d.halo=r=k.renderer.path().add(m.parentGroup)),r.show()[c?"animate":"attr"]({d:this.haloPath(a.size)}),r.attr({"class":"highcharts-halo highcharts-color-"+q(this.colorIndex,d.colorIndex)+(this.className?" "+this.className:""),visibility:f,zIndex:-1}),r.point=this,k.styledMode||r.attr(l({fill:this.color||d.color,"fill-opacity":a.opacity},a.attributes))):r&&r.point&&r.point.haloPath&&r.animate({d:r.point.haloPath(0)},null,r.hide);
J(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});l(F.prototype,{onMouseOver:function(){var a=this.chart,c=a.hoverSeries;a.pointer.setHoverChartIndex();if(c&&c!==this)c.onMouseOut();this.options.events.mouseOver&&J(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,c=this.chart,d=c.tooltip,e=c.hoverPoint;c.hoverSeries=null;if(e)e.onMouseOut();this&&a.events.mouseOut&&
J(this,"mouseOut");!d||this.stickyTracking||d.shared&&!this.noSharedTooltip||d.hide();c.series.forEach(function(a){a.setState("",!0)})},setState:function(a,c){var d=this,e=d.options,f=d.graph,g=e.inactiveOtherPoints,h=e.states,l=e.lineWidth,m=e.opacity,n=q(h[a||"normal"]&&h[a||"normal"].animation,d.chart.options.chart.animation);e=0;a=a||"";if(d.state!==a&&([d.group,d.markerGroup,d.dataLabelsGroup].forEach(function(b){b&&(d.state&&b.removeClass("highcharts-series-"+d.state),a&&b.addClass("highcharts-series-"+
a))}),d.state=a,!d.chart.styledMode)){if(h[a]&&!1===h[a].enabled)return;a&&(l=h[a].lineWidth||l+(h[a].lineWidthPlus||0),m=q(h[a].opacity,m));if(f&&!f.dashstyle)for(h={"stroke-width":l},f.animate(h,n);d["zone-graph-"+e];)d["zone-graph-"+e].attr(h),e+=1;g||[d.group,d.markerGroup,d.dataLabelsGroup,d.labelBySeries].forEach(function(a){a&&a.animate({opacity:m},n)})}c&&g&&d.points&&d.setAllPointsToState(a)},setAllPointsToState:function(a){this.points.forEach(function(c){c.setState&&c.setState(a)})},setVisible:function(a,
c){var d=this,e=d.chart,f=d.legendItem,g=e.options.chart.ignoreHiddenSeries,h=d.visible;var l=(d.visible=a=d.options.visible=d.userOptions.visible="undefined"===typeof a?!h:a)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(a){if(d[a])d[a][l]()});if(e.hoverSeries===d||(e.hoverPoint&&e.hoverPoint.series)===d)d.onMouseOut();f&&e.legend.colorizeItem(d,a);d.isDirty=!0;d.options.stacking&&e.series.forEach(function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});
d.linkedSeries.forEach(function(c){c.setVisible(a,!1)});g&&(e.isDirtyBox=!0);J(d,l);!1!==c&&e.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=this.options.selected="undefined"===typeof a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);J(this,a?"select":"unselect")},drawTracker:m.drawTrackerGraph})});N(m,"Core/Responsive.js",[m["Core/Chart/Chart.js"],m["Core/Utilities.js"]],function(f,h){var m=h.find,z=h.isArray,F=h.isObject,
L=h.merge,K=h.objectEach,C=h.pick,y=h.splat,e=h.uniqueKey;f.prototype.setResponsive=function(f,h){var v=this.options.responsive,y=[],n=this.currentResponsive;!h&&v&&v.rules&&v.rules.forEach(function(f){"undefined"===typeof f._id&&(f._id=e());this.matchResponsiveRule(f,y)},this);h=L.apply(0,y.map(function(e){return m(v.rules,function(f){return f._id===e}).chartOptions}));h.isResponsiveOptions=!0;y=y.toString()||void 0;y!==(n&&n.ruleIds)&&(n&&this.update(n.undoOptions,f,!0),y?(n=this.currentOptions(h),
n.isResponsiveOptions=!0,this.currentResponsive={ruleIds:y,mergedOptions:h,undoOptions:n},this.update(h,f,!0)):this.currentResponsive=void 0)};f.prototype.matchResponsiveRule=function(e,f){var h=e.condition;(h.callback||function(){return this.chartWidth<=C(h.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=C(h.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=C(h.minWidth,0)&&this.chartHeight>=C(h.minHeight,0)}).call(this)&&f.push(e._id)};f.prototype.currentOptions=function(e){function f(e,l,m,v){var n;
K(e,function(d,e){if(!v&&-1<h.collectionsWithUpdate.indexOf(e))for(d=y(d),m[e]=[],n=0;n<Math.max(d.length,l[e].length);n++)l[e][n]&&(void 0===d[n]?m[e][n]=l[e][n]:(m[e][n]={},f(d[n],l[e][n],m[e][n],v+1)));else F(d)?(m[e]=z(d)?[]:{},f(d,l[e]||{},m[e],v+1)):m[e]="undefined"===typeof l[e]?null:l[e]})}var h=this,m={};f(e,this.options,m,0);return m}});N(m,"masters/highcharts.src.js",[m["Core/Globals.js"]],function(f){return f});m["masters/highcharts.src.js"]._modules=m;return m["masters/highcharts.src.js"]});
//# sourceMappingURL=highcharts.js.map

/***/ }),
/* 281 */
/* no static exports found */
/* all exports used */
/*!******************************!*\
  !*** ./~/process/browser.js ***!
  \******************************/
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 282 */
/* exports provided: default */
/* exports used: default */
/*!*************************************************!*\
  !*** ./~/underscore/modules/_createAssigner.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAssigner;
// An internal function for creating assigner functions.
function createAssigner(keysFunc, defaults) {
  return function(obj) {
    var length = arguments.length;
    if (defaults) obj = Object(obj);
    if (length < 2 || obj == null) return obj;
    for (var index = 1; index < length; index++) {
      var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
      for (var i = 0; i < l; i++) {
        var key = keys[i];
        if (!defaults || obj[key] === void 0) obj[key] = source[key];
      }
    }
    return obj;
  };
}


/***/ }),
/* 283 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/_deepGet.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deepGet;
// Internal function to obtain a nested property in `obj` along `path`.
function deepGet(obj, path) {
  var length = path.length;
  for (var i = 0; i < length; i++) {
    if (obj == null) return void 0;
    obj = obj[path[i]];
  }
  return length ? obj : void 0;
}


/***/ }),
/* 284 */
/* exports provided: default */
/* exports used: default */
/*!************************************************!*\
  !*** ./~/underscore/modules/_getByteLength.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__ = __webpack_require__(/*! ./_shallowProperty.js */ 643);


// Internal helper to obtain the `byteLength` property of an object.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shallowProperty_js__["a" /* default */])('byteLength'));


/***/ }),
/* 285 */
/* exports provided: ie11fingerprint, mapMethods, weakMapMethods, setMethods */
/* exports used: ie11fingerprint, setMethods, weakMapMethods, mapMethods */
/*!****************************************************!*\
  !*** ./~/underscore/modules/_methodFingerprint.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ie11fingerprint;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return weakMapMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setMethods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__allKeys_js__ = __webpack_require__(/*! ./allKeys.js */ 156);




// Since the regular `Object.prototype.toString` type tests don't work for
// some types in IE 11, we use a fingerprinting heuristic instead, based
// on the methods. It's not great, but it's the best we got.
// The fingerprint method lists are defined below.
function ie11fingerprint(methods) {
  var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(methods);
  return function(obj) {
    if (obj == null) return false;
    // `Map`, `WeakMap` and `Set` have no enumerable keys.
    var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__allKeys_js__["a" /* default */])(obj);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(keys)) return false;
    for (var i = 0; i < length; i++) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[methods[i]])) return false;
    }
    // If we are testing against `WeakMap`, we need to ensure that
    // `obj` doesn't have a `forEach` method in order to distinguish
    // it from a regular `Map`.
    return methods !== weakMapMethods || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj[forEachName]);
  };
}

// In the interest of compact minification, we write
// each string in the fingerprints only once.
var forEachName = 'forEach',
    hasName = 'has',
    commonInit = ['clear', 'delete'],
    mapTail = ['get', hasName, 'set'];

// `Map`, `WeakMap` and `Set` each have slightly different
// combinations of the above sublists.
var mapMethods = commonInit.concat(forEachName, mapTail),
    weakMapMethods = commonInit.concat(mapTail),
    setMethods = ['add'].concat(commonInit, forEachName, hasName);


/***/ }),
/* 286 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/extendOwn.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(/*! ./_createAssigner.js */ 282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);



// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]));


/***/ }),
/* 287 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/findIndex.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(/*! ./_createPredicateIndexFinder.js */ 638);


// Returns the first index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(1));


/***/ }),
/* 288 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/identity.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
// Keep the identity function around for default iteratees.
function identity(value) {
  return value;
}


/***/ }),
/* 289 */
/* exports provided: VERSION, restArguments, isObject, isNull, isUndefined, isBoolean, isElement, isString, isNumber, isDate, isRegExp, isError, isSymbol, isArrayBuffer, isDataView, isArray, isFunction, isArguments, isFinite, isNaN, isTypedArray, isEmpty, isMatch, isEqual, isMap, isWeakMap, isSet, isWeakSet, keys, allKeys, values, pairs, invert, functions, methods, extend, extendOwn, assign, defaults, create, clone, tap, get, has, mapObject, identity, constant, noop, toPath, property, propertyOf, matcher, matches, times, random, now, escape, unescape, templateSettings, template, result, uniqueId, chain, iteratee, partial, bind, bindAll, memoize, delay, defer, throttle, debounce, wrap, negate, compose, after, before, once, findKey, findIndex, findLastIndex, sortedIndex, indexOf, lastIndexOf, find, detect, findWhere, each, forEach, map, collect, reduce, foldl, inject, reduceRight, foldr, filter, select, reject, every, all, some, any, contains, includes, include, invoke, pluck, where, max, min, shuffle, sample, sortBy, groupBy, indexBy, countBy, partition, toArray, size, pick, omit, first, head, take, initial, last, rest, tail, drop, compact, flatten, without, uniq, unique, union, intersection, difference, unzip, transpose, zip, object, range, chunk, mixin, default */
/* all exports used */
/*!***************************************!*\
  !*** ./~/underscore/modules/index.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__setup_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "restArguments", function() { return __WEBPACK_IMPORTED_MODULE_1__restArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(/*! ./isObject.js */ 117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return __WEBPACK_IMPORTED_MODULE_2__isObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isNull_js__ = __webpack_require__(/*! ./isNull.js */ 1191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return __WEBPACK_IMPORTED_MODULE_3__isNull_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__ = __webpack_require__(/*! ./isUndefined.js */ 666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_4__isUndefined_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__ = __webpack_require__(/*! ./isBoolean.js */ 660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isBoolean", function() { return __WEBPACK_IMPORTED_MODULE_5__isBoolean_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isElement_js__ = __webpack_require__(/*! ./isElement.js */ 1185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return __WEBPACK_IMPORTED_MODULE_6__isElement_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isString_js__ = __webpack_require__(/*! ./isString.js */ 292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return __WEBPACK_IMPORTED_MODULE_7__isString_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isNumber_js__ = __webpack_require__(/*! ./isNumber.js */ 663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNumber", function() { return __WEBPACK_IMPORTED_MODULE_8__isNumber_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isDate_js__ = __webpack_require__(/*! ./isDate.js */ 1184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDate", function() { return __WEBPACK_IMPORTED_MODULE_9__isDate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__ = __webpack_require__(/*! ./isRegExp.js */ 1192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isRegExp", function() { return __WEBPACK_IMPORTED_MODULE_10__isRegExp_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isError_js__ = __webpack_require__(/*! ./isError.js */ 1188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_11__isError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__ = __webpack_require__(/*! ./isSymbol.js */ 664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSymbol", function() { return __WEBPACK_IMPORTED_MODULE_12__isSymbol_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__ = __webpack_require__(/*! ./isArrayBuffer.js */ 659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return __WEBPACK_IMPORTED_MODULE_13__isArrayBuffer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isDataView_js__ = __webpack_require__(/*! ./isDataView.js */ 291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDataView", function() { return __WEBPACK_IMPORTED_MODULE_14__isDataView_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(/*! ./isArray.js */ 116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_15__isArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return __WEBPACK_IMPORTED_MODULE_16__isFunction_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isArguments_js__ = __webpack_require__(/*! ./isArguments.js */ 290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isArguments", function() { return __WEBPACK_IMPORTED_MODULE_17__isArguments_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isFinite_js__ = __webpack_require__(/*! ./isFinite.js */ 1189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFinite", function() { return __WEBPACK_IMPORTED_MODULE_18__isFinite_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isNaN_js__ = __webpack_require__(/*! ./isNaN.js */ 662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return __WEBPACK_IMPORTED_MODULE_19__isNaN_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__ = __webpack_require__(/*! ./isTypedArray.js */ 665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return __WEBPACK_IMPORTED_MODULE_20__isTypedArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__ = __webpack_require__(/*! ./isEmpty.js */ 1186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_21__isEmpty_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__isMatch_js__ = __webpack_require__(/*! ./isMatch.js */ 661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMatch", function() { return __WEBPACK_IMPORTED_MODULE_22__isMatch_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isEqual_js__ = __webpack_require__(/*! ./isEqual.js */ 1187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_23__isEqual_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isMap_js__ = __webpack_require__(/*! ./isMap.js */ 1190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMap", function() { return __WEBPACK_IMPORTED_MODULE_24__isMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__ = __webpack_require__(/*! ./isWeakMap.js */ 1194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return __WEBPACK_IMPORTED_MODULE_25__isWeakMap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isSet_js__ = __webpack_require__(/*! ./isSet.js */ 1193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSet", function() { return __WEBPACK_IMPORTED_MODULE_26__isSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__ = __webpack_require__(/*! ./isWeakSet.js */ 1195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return __WEBPACK_IMPORTED_MODULE_27__isWeakSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_28__keys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__allKeys_js__ = __webpack_require__(/*! ./allKeys.js */ 156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "allKeys", function() { return __WEBPACK_IMPORTED_MODULE_29__allKeys_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__values_js__ = __webpack_require__(/*! ./values.js */ 129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_30__values_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pairs_js__ = __webpack_require__(/*! ./pairs.js */ 1205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_31__pairs_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__invert_js__ = __webpack_require__(/*! ./invert.js */ 658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return __WEBPACK_IMPORTED_MODULE_32__invert_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__functions_js__ = __webpack_require__(/*! ./functions.js */ 654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "functions", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "methods", function() { return __WEBPACK_IMPORTED_MODULE_33__functions_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__extend_js__ = __webpack_require__(/*! ./extend.js */ 650);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return __WEBPACK_IMPORTED_MODULE_34__extend_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__ = __webpack_require__(/*! ./extendOwn.js */ 286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extendOwn", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return __WEBPACK_IMPORTED_MODULE_35__extendOwn_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__defaults_js__ = __webpack_require__(/*! ./defaults.js */ 647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_36__defaults_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__create_js__ = __webpack_require__(/*! ./create.js */ 1170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return __WEBPACK_IMPORTED_MODULE_37__create_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__clone_js__ = __webpack_require__(/*! ./clone.js */ 1166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return __WEBPACK_IMPORTED_MODULE_38__clone_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__tap_js__ = __webpack_require__(/*! ./tap.js */ 1217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tap", function() { return __WEBPACK_IMPORTED_MODULE_39__tap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__get_js__ = __webpack_require__(/*! ./get.js */ 655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return __WEBPACK_IMPORTED_MODULE_40__get_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__has_js__ = __webpack_require__(/*! ./has.js */ 1179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return __WEBPACK_IMPORTED_MODULE_41__has_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__mapObject_js__ = __webpack_require__(/*! ./mapObject.js */ 1198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mapObject", function() { return __WEBPACK_IMPORTED_MODULE_42__mapObject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__identity_js__ = __webpack_require__(/*! ./identity.js */ 288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "identity", function() { return __WEBPACK_IMPORTED_MODULE_43__identity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__constant_js__ = __webpack_require__(/*! ./constant.js */ 646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "constant", function() { return __WEBPACK_IMPORTED_MODULE_44__constant_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__noop_js__ = __webpack_require__(/*! ./noop.js */ 669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_45__noop_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__toPath_js__ = __webpack_require__(/*! ./toPath.js */ 677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toPath", function() { return __WEBPACK_IMPORTED_MODULE_46__toPath_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__property_js__ = __webpack_require__(/*! ./property.js */ 296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "property", function() { return __WEBPACK_IMPORTED_MODULE_47__property_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__ = __webpack_require__(/*! ./propertyOf.js */ 1207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propertyOf", function() { return __WEBPACK_IMPORTED_MODULE_48__propertyOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__matcher_js__ = __webpack_require__(/*! ./matcher.js */ 193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matcher", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matches", function() { return __WEBPACK_IMPORTED_MODULE_49__matcher_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__times_js__ = __webpack_require__(/*! ./times.js */ 1220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "times", function() { return __WEBPACK_IMPORTED_MODULE_50__times_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__random_js__ = __webpack_require__(/*! ./random.js */ 671);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "random", function() { return __WEBPACK_IMPORTED_MODULE_51__random_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__now_js__ = __webpack_require__(/*! ./now.js */ 294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_52__now_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__escape_js__ = __webpack_require__(/*! ./escape.js */ 1173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "escape", function() { return __WEBPACK_IMPORTED_MODULE_53__escape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__unescape_js__ = __webpack_require__(/*! ./unescape.js */ 1222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unescape", function() { return __WEBPACK_IMPORTED_MODULE_54__unescape_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__ = __webpack_require__(/*! ./templateSettings.js */ 675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "templateSettings", function() { return __WEBPACK_IMPORTED_MODULE_55__templateSettings_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__template_js__ = __webpack_require__(/*! ./template.js */ 1218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "template", function() { return __WEBPACK_IMPORTED_MODULE_56__template_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__result_js__ = __webpack_require__(/*! ./result.js */ 1212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "result", function() { return __WEBPACK_IMPORTED_MODULE_57__result_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__ = __webpack_require__(/*! ./uniqueId.js */ 1224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniqueId", function() { return __WEBPACK_IMPORTED_MODULE_58__uniqueId_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__chain_js__ = __webpack_require__(/*! ./chain.js */ 1164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chain", function() { return __WEBPACK_IMPORTED_MODULE_59__chain_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__iteratee_js__ = __webpack_require__(/*! ./iteratee.js */ 667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "iteratee", function() { return __WEBPACK_IMPORTED_MODULE_60__iteratee_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__partial_js__ = __webpack_require__(/*! ./partial.js */ 194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partial", function() { return __WEBPACK_IMPORTED_MODULE_61__partial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__bind_js__ = __webpack_require__(/*! ./bind.js */ 645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bind", function() { return __WEBPACK_IMPORTED_MODULE_62__bind_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__bindAll_js__ = __webpack_require__(/*! ./bindAll.js */ 1163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindAll", function() { return __WEBPACK_IMPORTED_MODULE_63__bindAll_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__memoize_js__ = __webpack_require__(/*! ./memoize.js */ 1199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "memoize", function() { return __WEBPACK_IMPORTED_MODULE_64__memoize_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__delay_js__ = __webpack_require__(/*! ./delay.js */ 648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "delay", function() { return __WEBPACK_IMPORTED_MODULE_65__delay_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__defer_js__ = __webpack_require__(/*! ./defer.js */ 1172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defer", function() { return __WEBPACK_IMPORTED_MODULE_66__defer_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__throttle_js__ = __webpack_require__(/*! ./throttle.js */ 1219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return __WEBPACK_IMPORTED_MODULE_67__throttle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__debounce_js__ = __webpack_require__(/*! ./debounce.js */ 1171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_68__debounce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__wrap_js__ = __webpack_require__(/*! ./wrap.js */ 1227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_69__wrap_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__negate_js__ = __webpack_require__(/*! ./negate.js */ 293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "negate", function() { return __WEBPACK_IMPORTED_MODULE_70__negate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__compose_js__ = __webpack_require__(/*! ./compose.js */ 1168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_71__compose_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__after_js__ = __webpack_require__(/*! ./after.js */ 1162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "after", function() { return __WEBPACK_IMPORTED_MODULE_72__after_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__before_js__ = __webpack_require__(/*! ./before.js */ 644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "before", function() { return __WEBPACK_IMPORTED_MODULE_73__before_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__once_js__ = __webpack_require__(/*! ./once.js */ 1204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_74__once_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__findKey_js__ = __webpack_require__(/*! ./findKey.js */ 652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findKey", function() { return __WEBPACK_IMPORTED_MODULE_75__findKey_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__findIndex_js__ = __webpack_require__(/*! ./findIndex.js */ 287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return __WEBPACK_IMPORTED_MODULE_76__findIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__ = __webpack_require__(/*! ./findLastIndex.js */ 653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return __WEBPACK_IMPORTED_MODULE_77__findLastIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__ = __webpack_require__(/*! ./sortedIndex.js */ 674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return __WEBPACK_IMPORTED_MODULE_78__sortedIndex_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__indexOf_js__ = __webpack_require__(/*! ./indexOf.js */ 656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return __WEBPACK_IMPORTED_MODULE_79__indexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__ = __webpack_require__(/*! ./lastIndexOf.js */ 1197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return __WEBPACK_IMPORTED_MODULE_80__lastIndexOf_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__find_js__ = __webpack_require__(/*! ./find.js */ 651);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detect", function() { return __WEBPACK_IMPORTED_MODULE_81__find_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__findWhere_js__ = __webpack_require__(/*! ./findWhere.js */ 1175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "findWhere", function() { return __WEBPACK_IMPORTED_MODULE_82__findWhere_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__each_js__ = __webpack_require__(/*! ./each.js */ 115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return __WEBPACK_IMPORTED_MODULE_83__each_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__map_js__ = __webpack_require__(/*! ./map.js */ 128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "collect", function() { return __WEBPACK_IMPORTED_MODULE_84__map_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__reduce_js__ = __webpack_require__(/*! ./reduce.js */ 1209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduce", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldl", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return __WEBPACK_IMPORTED_MODULE_85__reduce_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__ = __webpack_require__(/*! ./reduceRight.js */ 1210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduceRight", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "foldr", function() { return __WEBPACK_IMPORTED_MODULE_86__reduceRight_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__filter_js__ = __webpack_require__(/*! ./filter.js */ 158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_87__filter_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__reject_js__ = __webpack_require__(/*! ./reject.js */ 1211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reject", function() { return __WEBPACK_IMPORTED_MODULE_88__reject_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__every_js__ = __webpack_require__(/*! ./every.js */ 1174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "every", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return __WEBPACK_IMPORTED_MODULE_89__every_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__some_js__ = __webpack_require__(/*! ./some.js */ 1215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "some", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "any", function() { return __WEBPACK_IMPORTED_MODULE_90__some_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__contains_js__ = __webpack_require__(/*! ./contains.js */ 157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "include", function() { return __WEBPACK_IMPORTED_MODULE_91__contains_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__invoke_js__ = __webpack_require__(/*! ./invoke.js */ 1183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "invoke", function() { return __WEBPACK_IMPORTED_MODULE_92__invoke_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__pluck_js__ = __webpack_require__(/*! ./pluck.js */ 295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return __WEBPACK_IMPORTED_MODULE_93__pluck_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__where_js__ = __webpack_require__(/*! ./where.js */ 1225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "where", function() { return __WEBPACK_IMPORTED_MODULE_94__where_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__max_js__ = __webpack_require__(/*! ./max.js */ 668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_95__max_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__min_js__ = __webpack_require__(/*! ./min.js */ 1200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_96__min_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__shuffle_js__ = __webpack_require__(/*! ./shuffle.js */ 1213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_97__shuffle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__sample_js__ = __webpack_require__(/*! ./sample.js */ 673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sample", function() { return __WEBPACK_IMPORTED_MODULE_98__sample_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__sortBy_js__ = __webpack_require__(/*! ./sortBy.js */ 1216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return __WEBPACK_IMPORTED_MODULE_99__sortBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__groupBy_js__ = __webpack_require__(/*! ./groupBy.js */ 1178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "groupBy", function() { return __WEBPACK_IMPORTED_MODULE_100__groupBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__indexBy_js__ = __webpack_require__(/*! ./indexBy.js */ 1181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "indexBy", function() { return __WEBPACK_IMPORTED_MODULE_101__indexBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__countBy_js__ = __webpack_require__(/*! ./countBy.js */ 1169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "countBy", function() { return __WEBPACK_IMPORTED_MODULE_102__countBy_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__partition_js__ = __webpack_require__(/*! ./partition.js */ 1206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "partition", function() { return __WEBPACK_IMPORTED_MODULE_103__partition_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__toArray_js__ = __webpack_require__(/*! ./toArray.js */ 676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return __WEBPACK_IMPORTED_MODULE_104__toArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__size_js__ = __webpack_require__(/*! ./size.js */ 1214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return __WEBPACK_IMPORTED_MODULE_105__size_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__pick_js__ = __webpack_require__(/*! ./pick.js */ 670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return __WEBPACK_IMPORTED_MODULE_106__pick_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__omit_js__ = __webpack_require__(/*! ./omit.js */ 1203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "omit", function() { return __WEBPACK_IMPORTED_MODULE_107__omit_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__first_js__ = __webpack_require__(/*! ./first.js */ 1176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "first", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "head", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "take", function() { return __WEBPACK_IMPORTED_MODULE_108__first_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__initial_js__ = __webpack_require__(/*! ./initial.js */ 657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initial", function() { return __WEBPACK_IMPORTED_MODULE_109__initial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__last_js__ = __webpack_require__(/*! ./last.js */ 1196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "last", function() { return __WEBPACK_IMPORTED_MODULE_110__last_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__rest_js__ = __webpack_require__(/*! ./rest.js */ 672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tail", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "drop", function() { return __WEBPACK_IMPORTED_MODULE_111__rest_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__compact_js__ = __webpack_require__(/*! ./compact.js */ 1167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compact", function() { return __WEBPACK_IMPORTED_MODULE_112__compact_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__flatten_js__ = __webpack_require__(/*! ./flatten.js */ 1177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return __WEBPACK_IMPORTED_MODULE_113__flatten_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__without_js__ = __webpack_require__(/*! ./without.js */ 1226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "without", function() { return __WEBPACK_IMPORTED_MODULE_114__without_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__uniq_js__ = __webpack_require__(/*! ./uniq.js */ 678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniq", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return __WEBPACK_IMPORTED_MODULE_115__uniq_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__union_js__ = __webpack_require__(/*! ./union.js */ 1223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return __WEBPACK_IMPORTED_MODULE_116__union_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__intersection_js__ = __webpack_require__(/*! ./intersection.js */ 1182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return __WEBPACK_IMPORTED_MODULE_117__intersection_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__difference_js__ = __webpack_require__(/*! ./difference.js */ 649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "difference", function() { return __WEBPACK_IMPORTED_MODULE_118__difference_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__unzip_js__ = __webpack_require__(/*! ./unzip.js */ 679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unzip", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_119__unzip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__zip_js__ = __webpack_require__(/*! ./zip.js */ 1228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_120__zip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__object_js__ = __webpack_require__(/*! ./object.js */ 1202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_121__object_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__range_js__ = __webpack_require__(/*! ./range.js */ 1208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_122__range_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__chunk_js__ = __webpack_require__(/*! ./chunk.js */ 1165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "chunk", function() { return __WEBPACK_IMPORTED_MODULE_123__chunk_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__mixin_js__ = __webpack_require__(/*! ./mixin.js */ 1201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return __WEBPACK_IMPORTED_MODULE_124__mixin_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__ = __webpack_require__(/*! ./underscore-array-methods.js */ 1221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_125__underscore_array_methods_js__["a"]; });
// Named Exports
// =============

//     Underscore.js 1.13.6
//     https://underscorejs.org
//     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

// Baseline setup.



// Object Functions
// ----------------
// Our most fundamental functions operate on any JavaScript object.
// Most functions in Underscore depend on at least one function in this section.

// A group of functions that check the types of core JavaScript values.
// These are often informally referred to as the "isType" functions.



























// Functions that treat an object as a dictionary of key-value pairs.
















// Utility Functions
// -----------------
// A bit of a grab bag: Predicate-generating functions for use with filters and
// loops, string escaping and templating, create random numbers and unique ids,
// and functions that facilitate Underscore's chaining and iteration conventions.



















// Function (ahem) Functions
// -------------------------
// These functions take a function as an argument and return a new function
// as the result. Also known as higher-order functions.















// Finders
// -------
// Functions that extract (the position of) a single element from an object
// or array based on some criterion.









// Collection Functions
// --------------------
// Functions that work on any collection of elements: either an array, or
// an object of key-value pairs.
























// `_.pick` and `_.omit` are actually object functions, but we put
// them here in order to create a more natural reading order in the
// monolithic build as they depend on `_.contains`.



// Array Functions
// ---------------
// Functions that operate on arrays (and array-likes) only, because they’re
// expressed in terms of operations on an ordered list of values.

















// OOP
// ---
// These modules support the "object-oriented" calling style. See also
// `underscore.js` and `index-default.js`.




/***/ }),
/* 290 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./~/underscore/modules/isArguments.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(/*! ./_has.js */ 99);



var isArguments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Arguments');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(obj, 'callee');
    };
  }
}());

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 291 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/isDataView.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__ = __webpack_require__(/*! ./isArrayBuffer.js */ 659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__ = __webpack_require__(/*! ./_stringTagBug.js */ 154);





var isDataView = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('DataView');

// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function ie10IsDataView(obj) {
  return obj != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(obj.getInt8) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayBuffer_js__["a" /* default */])(obj.buffer);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__stringTagBug_js__["b" /* hasStringTagBug */] ? ie10IsDataView : isDataView);


/***/ }),
/* 292 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/isString.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('String'));


/***/ }),
/* 293 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/negate.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = negate;
// Returns a negated version of the passed-in predicate.
function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}


/***/ }),
/* 294 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/now.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A (possibly faster) way to get the current timestamp as an integer.
/* harmony default export */ __webpack_exports__["a"] = (Date.now || function() {
  return new Date().getTime();
});


/***/ }),
/* 295 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/pluck.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map_js__ = __webpack_require__(/*! ./map.js */ 128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__property_js__ = __webpack_require__(/*! ./property.js */ 296);



// Convenience version of a common use case of `_.map`: fetching a property.
function pluck(obj, key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map_js__["a" /* default */])(obj, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__property_js__["a" /* default */])(key));
}


/***/ }),
/* 296 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/property.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = property;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deepGet_js__ = __webpack_require__(/*! ./_deepGet.js */ 283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(/*! ./_toPath.js */ 155);



// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  return function(obj) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deepGet_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 297 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/assets/login/img/fechar.png ***!
  \********************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAAAXNSR0IArs4c6QAAAuhJREFUSA2lVUlrFFEQrqqZSTJgBkRQExPTRA2iEIgXiQSMGEW8eFBcbmIWPKq/IH9APGqWAS8ukKM3FxiXTC4hOQlmn0zGKAQEJ8KEzMwrqxp6eDavY9B36K6uqvfV61q+hxCxmBm9s4OeYexAYzwGagTgJACWEMwmG8pRgudz78dyiMguGHQpW3r7j2KZ+iTAQZfd1hHyN2PgXWEqvWjrVY7ZiuHhYVosH7sEVbgs+j22LUpmwEZA7Ey1dTU8uHNlOZPJ1P6iBq7A42++3gLmziigHfWMLTMrP5skwOcgQA3cP/G/AgdRGffN5jbrivmZJVWRPjTHcuLTKv/v4ip3t54ZOqI4pF2hxXOBShd8l3wal011iLDtsiGZ86onbTdXVyjw2uTYE0iY50hYsUH873jsWX0q+RCByrZNZemeZq/3rkfax2GjfkvJ92u6Cpn0IsfNyyCA/zb4ovBhZKFarEj/m4Rrf3XbdBAa9FxGqYGcl27aAYhgCwR4LTu61N4z2FGB8nXnXlHKoHmx1OFT50SuczrJWCLTiVR717r+wd72zun8x/SGApeZbzD/OSdhDOkWHenoxYbjVMFrXu/thlzm6VZL9/1kheHq34Dl7EkBx1I0tFglOcIjEwFwYepRySTMRFCD6L1cIiWhKIegeEGOiX7ds2uwUwAELBIT5VzgYWDNsWGuDxc5cg6QcyQVm3eCG/4SnNguntbADoDMG679MeZ5sTG29QwMSb832U46fYi0wGyOO4snk6vAMg8H7H0qSyHX89nxUVKiVz4OOwhgnTHmpBNYnWUOXMA+DiXe6ttnxWJh9ofyMQht+sb/eAgdZNcmR6YVwmdFFQb6Wl8LjTnzr/bdLCSY67/Y7J9a/Wt8rgSvRK98LMTSuhsw20dP3H/h0Cu5dGos6rxDlY+VNpXdbACXrMUDyXH+0+PlsN0JHjgpbSq7KQlJ8RqFaZJgWG5/LMrduRqH6txKNr0a+IffvwH7mm33UeHaXQAAAABJRU5ErkJggg=="

/***/ }),
/* 298 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/assets/login/img/idioma-ativo.png ***!
  \**************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 299 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/assets/login/img/idioma.png ***!
  \********************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 300 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/assets/login/img/logado-ok.png ***!
  \***********************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 301 */
/* exports provided: Store, install, mapState, mapMutations, mapGetters, mapActions, createNamespacedHelpers, default */
/* all exports used */
/*!*********************************!*\
  !*** ./~/vuex/dist/vuex.esm.js ***!
  \*********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapState", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapMutations", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapGetters", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapActions", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNamespacedHelpers", function() { return createNamespacedHelpers; });
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (true) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (true) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (true) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (true) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (true) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    "production-oci" !== 'production' &&
    options && options.silent
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (true) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (true) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (true) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("production-oci" !== 'production' && !store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ("production-oci" !== 'production' && !store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (true) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (true) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (true) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (true) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if ("production-oci" !== 'production' && !(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if ("production-oci" !== 'production' && !module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["default"] = (index_esm);


/***/ }),
/* 302 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 303 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/assets/login/img ^\.\/.*\.png$ ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ambiente-seguro-es.png": 1229,
	"./ambiente-seguro-in.png": 1230,
	"./ambiente-seguro-pt.png": 1231,
	"./borda-body-bottom.png": 1232,
	"./certificado-saae18-es.png": 1233,
	"./certificado-saae18-in.png": 1234,
	"./certificado-saae18-pt.png": 1235,
	"./fechar.png": 297,
	"./gestao-financeira-inteligente-es.png": 1236,
	"./gestao-financeira-inteligente-in.png": 1237,
	"./gestao-financeira-inteligente-pt.png": 1238,
	"./idioma-ativo.png": 298,
	"./idioma.png": 299,
	"./logado-ok.png": 300,
	"./password.png": 681,
	"./premio-br-week-es.png": 1239,
	"./premio-br-week-in.png": 1240,
	"./premio-br-week-pt.png": 1241,
	"./user.png": 682,
	"./voltar.png": 683
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;

/***/ }),
/* 304 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/array-intersect/dist/array-intersect.module.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var intersect = function intersect(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return rest.reduce(function (accum, current) {
    return accum.filter(function (x) {
      return current.indexOf(x) !== -1;
    });
  }, first);
};

/* harmony default export */ __webpack_exports__["default"] = (intersect);


/***/ }),
/* 305 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/axios/lib/adapters/xhr.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);
var settle = __webpack_require__(/*! ./../core/settle */ 730);
var cookies = __webpack_require__(/*! ./../helpers/cookies */ 733);
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ 312);
var buildFullPath = __webpack_require__(/*! ../core/buildFullPath */ 728);
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ 738);
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ 736);
var createError = __webpack_require__(/*! ../core/createError */ 308);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 306 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./~/axios/lib/cancel/Cancel.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 307 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./~/axios/lib/cancel/isCancel.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 308 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./~/axios/lib/core/createError.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ 309);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 309 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./~/axios/lib/core/enhanceError.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 310 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./~/axios/lib/core/mergeConfig.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ 60);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 311 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/axios/lib/helpers/bind.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 312 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./~/axios/lib/helpers/buildURL.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 313 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./build/http-requests/getNodeMiddlewareUrl.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (false) {
    return 'http://localhost:8089/banking-api';
  }
  if (false) {
    return 'http://192.168.121.222:8089/banking-api';
  }

  if (false) {
    return 'http://192.168.111.245:8089/banking-api';
  }

  if (false) {
    return 'https://api-banking-vinhedo.equals.com.br/banking-api';
  }

  if (false) {
    return 'https://banking.equals.com.br/api/banking-api';
  }

  if (true) {
    return 'https://api-banking.equals.com.br/banking-api';
  }
};

/***/ }),
/* 314 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/enum/tipoFiltroSituacaoTarefas.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FiltroSituacaoTarefaEnum = {
  C: 'CONCLUIDAS',
  NC: 'NAO_CONCLUIDAS'
};

exports.default = FiltroSituacaoTarefaEnum;

/***/ }),
/* 315 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./client/events/openMenu.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openMenu = new _vue2.default();
exports.default = openMenu;

/***/ }),
/* 316 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./client/events/selectTag.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectTag = new _vue2.default();
exports.default = selectTag;

/***/ }),
/* 317 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./client/store/vuex-modules.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _login = __webpack_require__(/*! ./modules/login */ 774);

var _login2 = _interopRequireDefault(_login);

var _accessProfile = __webpack_require__(/*! ./modules/accessProfile */ 753);

var _accessProfile2 = _interopRequireDefault(_accessProfile);

var _client = __webpack_require__(/*! ./modules/client */ 761);

var _client2 = _interopRequireDefault(_client);

var _sidebarMenu = __webpack_require__(/*! ./modules/sidebarMenu */ 783);

var _sidebarMenu2 = _interopRequireDefault(_sidebarMenu);

var _operator = __webpack_require__(/*! ./modules/operator */ 780);

var _operator2 = _interopRequireDefault(_operator);

var _conciliationPlan = __webpack_require__(/*! ./modules/conciliationPlan */ 762);

var _conciliationPlan2 = _interopRequireDefault(_conciliationPlan);

var _token = __webpack_require__(/*! ./modules/token */ 786);

var _token2 = _interopRequireDefault(_token);

var _auditLog = __webpack_require__(/*! ./modules/auditLog */ 756);

var _auditLog2 = _interopRequireDefault(_auditLog);

var _establishment = __webpack_require__(/*! ./modules/establishment */ 767);

var _establishment2 = _interopRequireDefault(_establishment);

var _cities = __webpack_require__(/*! ./modules/cities */ 760);

var _cities2 = _interopRequireDefault(_cities);

var _states = __webpack_require__(/*! ./modules/states */ 784);

var _states2 = _interopRequireDefault(_states);

var _bankAccounts = __webpack_require__(/*! ./modules/bankAccounts */ 757);

var _bankAccounts2 = _interopRequireDefault(_bankAccounts);

var _occurrenceReason = __webpack_require__(/*! ./modules/occurrenceReason */ 778);

var _occurrenceReason2 = _interopRequireDefault(_occurrenceReason);

var _financialMovements = __webpack_require__(/*! ./modules/financialMovements */ 771);

var _financialMovements2 = _interopRequireDefault(_financialMovements);

var _processedFiles = __webpack_require__(/*! ./modules/processedFiles */ 781);

var _processedFiles2 = _interopRequireDefault(_processedFiles);

var _conciliationReport = __webpack_require__(/*! ./modules/conciliationReport */ 763);

var _conciliationReport2 = _interopRequireDefault(_conciliationReport);

var _manualConciliation = __webpack_require__(/*! ./modules/manualConciliation */ 775);

var _manualConciliation2 = _interopRequireDefault(_manualConciliation);

var _occurrenceReport = __webpack_require__(/*! ./modules/occurrenceReport */ 779);

var _occurrenceReport2 = _interopRequireDefault(_occurrenceReport);

var _categories = __webpack_require__(/*! ./modules/categories */ 759);

var _categories2 = _interopRequireDefault(_categories);

var _fileUploader = __webpack_require__(/*! ./modules/fileUploader */ 769);

var _fileUploader2 = _interopRequireDefault(_fileUploader);

var _conciliationSummary = __webpack_require__(/*! ./modules/conciliationSummary */ 764);

var _conciliationSummary2 = _interopRequireDefault(_conciliationSummary);

var _myAccount = __webpack_require__(/*! ./modules/myAccount */ 777);

var _myAccount2 = _interopRequireDefault(_myAccount);

var _menu = __webpack_require__(/*! ./modules/menu */ 776);

var _menu2 = _interopRequireDefault(_menu);

var _bankStatement = __webpack_require__(/*! ./modules/bankStatement */ 758);

var _bankStatement2 = _interopRequireDefault(_bankStatement);

var _attributesSet = __webpack_require__(/*! ./modules/attributesSet */ 755);

var _attributesSet2 = _interopRequireDefault(_attributesSet);

var _assignment = __webpack_require__(/*! ./modules/assignment */ 754);

var _assignment2 = _interopRequireDefault(_assignment);

var _task = __webpack_require__(/*! ./modules/task */ 785);

var _task2 = _interopRequireDefault(_task);

var _dashboard = __webpack_require__(/*! ./modules/dashboard */ 765);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _loading = __webpack_require__(/*! ./modules/loading */ 772);

var _loading2 = _interopRequireDefault(_loading);

var _loadingFullPage = __webpack_require__(/*! ./modules/loadingFullPage */ 773);

var _loadingFullPage2 = _interopRequireDefault(_loadingFullPage);

var _filter = __webpack_require__(/*! ./modules/filter */ 770);

var _filter2 = _interopRequireDefault(_filter);

var _exitingWithUnsavedChanges = __webpack_require__(/*! ./modules/exitingWithUnsavedChanges */ 768);

var _exitingWithUnsavedChanges2 = _interopRequireDefault(_exitingWithUnsavedChanges);

var _remittanceIntegration = __webpack_require__(/*! ./modules/remittanceIntegration */ 782);

var _remittanceIntegration2 = _interopRequireDefault(_remittanceIntegration);

var _duplicateMovementsAnalysis = __webpack_require__(/*! ./modules/duplicateMovementsAnalysis */ 766);

var _duplicateMovementsAnalysis2 = _interopRequireDefault(_duplicateMovementsAnalysis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  loginModule: _login2.default,
  accessProfileModule: _accessProfile2.default,
  clientModule: _client2.default,
  sidebarMenuModule: _sidebarMenu2.default,
  operatorModule: _operator2.default,
  conciliationPlanModule: _conciliationPlan2.default,
  tokenModule: _token2.default,
  auditLogModule: _auditLog2.default,
  establishmentModule: _establishment2.default,
  citiesModule: _cities2.default,
  statesModule: _states2.default,
  bankAccountsModule: _bankAccounts2.default,
  occurrenceReasonModule: _occurrenceReason2.default,
  financialMovementsModule: _financialMovements2.default,
  processedFilesModule: _processedFiles2.default,
  conciliationReportModule: _conciliationReport2.default,
  manualConciliationModule: _manualConciliation2.default,
  occurrenceReportModule: _occurrenceReport2.default,
  categoriesModule: _categories2.default,
  fileUploaderModule: _fileUploader2.default,
  conciliationSummaryModule: _conciliationSummary2.default,
  myAccountModule: _myAccount2.default,
  menu: _menu2.default,
  bankStatement: _bankStatement2.default,
  attributesSet: _attributesSet2.default,
  assignment: _assignment2.default,
  tasks: _task2.default,
  dashboard: _dashboard2.default,
  loading: _loading2.default,
  loadingFullPage: _loadingFullPage2.default,
  filter: _filter2.default,
  exitingWithUnsavedChanges: _exitingWithUnsavedChanges2.default,
  remittanceIntegration: _remittanceIntegration2.default,
  duplicateMovementsAnalysis: _duplicateMovementsAnalysis2.default
};

/***/ }),
/* 318 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./client/utils/helpers.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var debounce = function debounce() {
  var id = 0;
  var map = {};
  return function (fn, wait) {
    var cancelPrevious = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (cancelPrevious) {
      for (var key in map) {
        delete map[key];
      }
    }

    var currentId = id;

    map[currentId] = setTimeout(function () {
      if (map[currentId]) {
        fn();
      }
    }, wait);
    id++;
  };
};

exports.debounce = debounce;

/***/ }),
/* 319 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./client/utils/stringUtils.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var normalize = function normalize(str) {
  if (!str) {
    return str;
  }
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

var removeNonAlphanumeric = function removeNonAlphanumeric(str) {
  return str.replace(/[^A-Z0-9]/gi, '');
};

var areStringContained = function areStringContained(a, b) {
  return normalize(a).toLowerCase().includes(normalize(b).toLowerCase());
};

var compareStrings = function compareStrings(a, b) {
  return normalize(a).toLowerCase().localeCompare(normalize(b).toLowerCase());
};

exports.normalize = normalize;
exports.removeNonAlphanumeric = removeNonAlphanumeric;
exports.areStringContained = areStringContained;
exports.compareStrings = compareStrings;

/***/ }),
/* 320 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/babel-runtime/core-js/object/entries.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/entries */ 968), __esModule: true };

/***/ }),
/* 321 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/babel-runtime/core-js/object/keys.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/keys */ 969), __esModule: true };

/***/ }),
/* 322 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/babel-runtime/helpers/defineProperty.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(/*! ../core-js/object/define-property */ 919);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 323 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/babel-runtime/helpers/slicedToArray.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(/*! ../core-js/is-iterable */ 917);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(/*! ../core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 324 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/bignumber.js/bignumber.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function (globalObject) {
  'use strict';

/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */


  var BigNumber,
    isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
    mathceil = Math.ceil,
    mathfloor = Math.floor,

    bignumberError = '[BigNumber Error] ',
    tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',

    BASE = 1e14,
    LOG_BASE = 14,
    MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
    // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
    SQRT_BASE = 1e7,

    // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9;                                   // 0 to MAX_INT32


  /*
   * Create and return a BigNumber constructor.
   */
  function clone(configObject) {
    var div, convertBase, parseNumeric,
      P = BigNumber.prototype = { constructor: BigNumber, toString: null, valueOf: null },
      ONE = new BigNumber(1),


      //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------


      // The default values below must be integers within the inclusive ranges stated.
      // The values can also be changed at run-time using BigNumber.set.

      // The maximum number of decimal places for operations involving division.
      DECIMAL_PLACES = 20,                     // 0 to MAX

      // The rounding mode used when rounding to the above decimal places, and when using
      // toExponential, toFixed, toFormat and toPrecision, and round (default value).
      // UP         0 Away from zero.
      // DOWN       1 Towards zero.
      // CEIL       2 Towards +Infinity.
      // FLOOR      3 Towards -Infinity.
      // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      ROUNDING_MODE = 4,                       // 0 to 8

      // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

      // The exponent value at and beneath which toString returns exponential notation.
      // Number type: -7
      TO_EXP_NEG = -7,                         // 0 to -MAX

      // The exponent value at and above which toString returns exponential notation.
      // Number type: 21
      TO_EXP_POS = 21,                         // 0 to MAX

      // RANGE : [MIN_EXP, MAX_EXP]

      // The minimum exponent value, beneath which underflow to zero occurs.
      // Number type: -324  (5e-324)
      MIN_EXP = -1e7,                          // -1 to -MAX

      // The maximum exponent value, above which overflow to Infinity occurs.
      // Number type:  308  (1.7976931348623157e+308)
      // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
      MAX_EXP = 1e7,                           // 1 to MAX

      // Whether to use cryptographically-secure random number generation, if available.
      CRYPTO = false,                          // true or false

      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP        0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN      1 The remainder has the same sign as the dividend.
      //             This modulo mode is commonly known as 'truncated division' and is
      //             equivalent to (a % n) in JavaScript.
      // FLOOR     3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
      // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
      //             The remainder is always positive.
      //
      // The truncated division, floored division, Euclidian division and IEEE 754 remainder
      // modes are commonly used for the modulus operation.
      // Although the other rounding modes can also be used, they may not give useful results.
      MODULO_MODE = 1,                         // 0 to 9

      // The maximum number of significant digits of the result of the exponentiatedBy operation.
      // If POW_PRECISION is 0, there will be unlimited significant digits.
      POW_PRECISION = 0,                       // 0 to MAX

      // The format specification used by the BigNumber.prototype.toFormat method.
      FORMAT = {
        prefix: '',
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ',',
        decimalSeparator: '.',
        fractionGroupSize: 0,
        fractionGroupSeparator: '\xA0',        // non-breaking space
        suffix: ''
      },

      // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
      // '-', '.', whitespace, or repeated character.
      // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
      ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz',
      alphabetHasNormalDecimalDigits = true;


    //------------------------------------------------------------------------------------------


    // CONSTRUCTOR


    /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */
    function BigNumber(v, b) {
      var alphabet, c, caseChanged, e, i, isNum, len, str,
        x = this;

      // Enable constructor call without `new`.
      if (!(x instanceof BigNumber)) return new BigNumber(v, b);

      if (b == null) {

        if (v && v._isBigNumber === true) {
          x.s = v.s;

          if (!v.c || v.e > MAX_EXP) {
            x.c = x.e = null;
          } else if (v.e < MIN_EXP) {
            x.c = [x.e = 0];
          } else {
            x.e = v.e;
            x.c = v.c.slice();
          }

          return;
        }

        if ((isNum = typeof v == 'number') && v * 0 == 0) {

          // Use `1 / n` to handle minus zero also.
          x.s = 1 / v < 0 ? (v = -v, -1) : 1;

          // Fast path for integers, where n < 2147483648 (2**31).
          if (v === ~~v) {
            for (e = 0, i = v; i >= 10; i /= 10, e++);

            if (e > MAX_EXP) {
              x.c = x.e = null;
            } else {
              x.e = e;
              x.c = [v];
            }

            return;
          }

          str = String(v);
        } else {

          if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);

          x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
        }

        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {

          // Determine exponent.
          if (e < 0) e = i;
          e += +str.slice(i + 1);
          str = str.substring(0, i);
        } else if (e < 0) {

          // Integer.
          e = str.length;
        }

      } else {

        // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
        intCheck(b, 2, ALPHABET.length, 'Base');

        // Allow exponential notation to be used with base 10 argument, while
        // also rounding to DECIMAL_PLACES as with other bases.
        if (b == 10 && alphabetHasNormalDecimalDigits) {
          x = new BigNumber(v);
          return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
        }

        str = String(v);

        if (isNum = typeof v == 'number') {

          // Avoid potential interpretation of Infinity and NaN as base 44+ values.
          if (v * 0 != 0) return parseNumeric(x, str, isNum, b);

          x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;

          // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
          if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) {
            throw Error
             (tooManyDigits + v);
          }
        } else {
          x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
        }

        alphabet = ALPHABET.slice(0, b);
        e = i = 0;

        // Check that str is a valid base b number.
        // Don't use RegExp, so alphabet can contain special characters.
        for (len = str.length; i < len; i++) {
          if (alphabet.indexOf(c = str.charAt(i)) < 0) {
            if (c == '.') {

              // If '.' is not the first character and it has not be found before.
              if (i > e) {
                e = len;
                continue;
              }
            } else if (!caseChanged) {

              // Allow e.g. hexadecimal 'FF' as well as 'ff'.
              if (str == str.toUpperCase() && (str = str.toLowerCase()) ||
                  str == str.toLowerCase() && (str = str.toUpperCase())) {
                caseChanged = true;
                i = -1;
                e = 0;
                continue;
              }
            }

            return parseNumeric(x, String(v), isNum, b);
          }
        }

        // Prevent later check for length on converted number.
        isNum = false;
        str = convertBase(str, b, 10, x.s);

        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        else e = str.length;
      }

      // Determine leading zeros.
      for (i = 0; str.charCodeAt(i) === 48; i++);

      // Determine trailing zeros.
      for (len = str.length; str.charCodeAt(--len) === 48;);

      if (str = str.slice(i, ++len)) {
        len -= i;

        // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
        if (isNum && BigNumber.DEBUG &&
          len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) {
            throw Error
             (tooManyDigits + (x.s * v));
        }

         // Overflow?
        if ((e = e - i - 1) > MAX_EXP) {

          // Infinity.
          x.c = x.e = null;

        // Underflow?
        } else if (e < MIN_EXP) {

          // Zero.
          x.c = [x.e = 0];
        } else {
          x.e = e;
          x.c = [];

          // Transform base

          // e is the base 10 exponent.
          // i is where to slice str to get the first element of the coefficient array.
          i = (e + 1) % LOG_BASE;
          if (e < 0) i += LOG_BASE;  // i < 1

          if (i < len) {
            if (i) x.c.push(+str.slice(0, i));

            for (len -= LOG_BASE; i < len;) {
              x.c.push(+str.slice(i, i += LOG_BASE));
            }

            i = LOG_BASE - (str = str.slice(i)).length;
          } else {
            i -= len;
          }

          for (; i--; str += '0');
          x.c.push(+str);
        }
      } else {

        // Zero.
        x.c = [x.e = 0];
      }
    }


    // CONSTRUCTOR PROPERTIES


    BigNumber.clone = clone;

    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;


    /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */
    BigNumber.config = BigNumber.set = function (obj) {
      var p, v;

      if (obj != null) {

        if (typeof obj == 'object') {

          // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
          // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
            v = obj[p];
            intCheck(v, 0, MAX, p);
            DECIMAL_PLACES = v;
          }

          // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
          // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
            v = obj[p];
            intCheck(v, 0, 8, p);
            ROUNDING_MODE = v;
          }

          // EXPONENTIAL_AT {number|number[]}
          // Integer, -MAX to MAX inclusive or
          // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
          // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
            v = obj[p];
            if (v && v.pop) {
              intCheck(v[0], -MAX, 0, p);
              intCheck(v[1], 0, MAX, p);
              TO_EXP_NEG = v[0];
              TO_EXP_POS = v[1];
            } else {
              intCheck(v, -MAX, MAX, p);
              TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
            }
          }

          // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
          // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
          // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
          if (obj.hasOwnProperty(p = 'RANGE')) {
            v = obj[p];
            if (v && v.pop) {
              intCheck(v[0], -MAX, -1, p);
              intCheck(v[1], 1, MAX, p);
              MIN_EXP = v[0];
              MAX_EXP = v[1];
            } else {
              intCheck(v, -MAX, MAX, p);
              if (v) {
                MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
              } else {
                throw Error
                 (bignumberError + p + ' cannot be zero: ' + v);
              }
            }
          }

          // CRYPTO {boolean} true or false.
          // '[BigNumber Error] CRYPTO not true or false: {v}'
          // '[BigNumber Error] crypto unavailable'
          if (obj.hasOwnProperty(p = 'CRYPTO')) {
            v = obj[p];
            if (v === !!v) {
              if (v) {
                if (typeof crypto != 'undefined' && crypto &&
                 (crypto.getRandomValues || crypto.randomBytes)) {
                  CRYPTO = v;
                } else {
                  CRYPTO = !v;
                  throw Error
                   (bignumberError + 'crypto unavailable');
                }
              } else {
                CRYPTO = v;
              }
            } else {
              throw Error
               (bignumberError + p + ' not true or false: ' + v);
            }
          }

          // MODULO_MODE {number} Integer, 0 to 9 inclusive.
          // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
            v = obj[p];
            intCheck(v, 0, 9, p);
            MODULO_MODE = v;
          }

          // POW_PRECISION {number} Integer, 0 to MAX inclusive.
          // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
          if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
            v = obj[p];
            intCheck(v, 0, MAX, p);
            POW_PRECISION = v;
          }

          // FORMAT {object}
          // '[BigNumber Error] FORMAT not an object: {v}'
          if (obj.hasOwnProperty(p = 'FORMAT')) {
            v = obj[p];
            if (typeof v == 'object') FORMAT = v;
            else throw Error
             (bignumberError + p + ' not an object: ' + v);
          }

          // ALPHABET {string}
          // '[BigNumber Error] ALPHABET invalid: {v}'
          if (obj.hasOwnProperty(p = 'ALPHABET')) {
            v = obj[p];

            // Disallow if less than two characters,
            // or if it contains '+', '-', '.', whitespace, or a repeated character.
            if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
              alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
              ALPHABET = v;
            } else {
              throw Error
               (bignumberError + p + ' invalid: ' + v);
            }
          }

        } else {

          // '[BigNumber Error] Object expected: {v}'
          throw Error
           (bignumberError + 'Object expected: ' + obj);
        }
      }

      return {
        DECIMAL_PLACES: DECIMAL_PLACES,
        ROUNDING_MODE: ROUNDING_MODE,
        EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
        RANGE: [MIN_EXP, MAX_EXP],
        CRYPTO: CRYPTO,
        MODULO_MODE: MODULO_MODE,
        POW_PRECISION: POW_PRECISION,
        FORMAT: FORMAT,
        ALPHABET: ALPHABET
      };
    };


    /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */
    BigNumber.isBigNumber = function (v) {
      if (!v || v._isBigNumber !== true) return false;
      if (!BigNumber.DEBUG) return true;

      var i, n,
        c = v.c,
        e = v.e,
        s = v.s;

      out: if ({}.toString.call(c) == '[object Array]') {

        if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {

          // If the first element is zero, the BigNumber value must be zero.
          if (c[0] === 0) {
            if (e === 0 && c.length === 1) return true;
            break out;
          }

          // Calculate number of digits that c[0] should have, based on the exponent.
          i = (e + 1) % LOG_BASE;
          if (i < 1) i += LOG_BASE;

          // Calculate number of digits of c[0].
          //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
          if (String(c[0]).length == i) {

            for (i = 0; i < c.length; i++) {
              n = c[i];
              if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
            }

            // Last element cannot be zero, unless it is the only element.
            if (n !== 0) return true;
          }
        }

      // Infinity/NaN
      } else if (c === null && e === null && (s === null || s === 1 || s === -1)) {
        return true;
      }

      throw Error
        (bignumberError + 'Invalid BigNumber: ' + v);
    };


    /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.maximum = BigNumber.max = function () {
      return maxOrMin(arguments, -1);
    };


    /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.minimum = BigNumber.min = function () {
      return maxOrMin(arguments, 1);
    };


    /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */
    BigNumber.random = (function () {
      var pow2_53 = 0x20000000000000;

      // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
      // Check if Math.random() produces more than 32 bits of randomness.
      // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
      // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
      var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
       ? function () { return mathfloor(Math.random() * pow2_53); }
       : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
         (Math.random() * 0x800000 | 0); };

      return function (dp) {
        var a, b, e, k, v,
          i = 0,
          c = [],
          rand = new BigNumber(ONE);

        if (dp == null) dp = DECIMAL_PLACES;
        else intCheck(dp, 0, MAX);

        k = mathceil(dp / LOG_BASE);

        if (CRYPTO) {

          // Browsers supporting crypto.getRandomValues.
          if (crypto.getRandomValues) {

            a = crypto.getRandomValues(new Uint32Array(k *= 2));

            for (; i < k;) {

              // 53 bits:
              // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
              // 11111 11111111 11111111 11111111 11100000 00000000 00000000
              // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
              //                                     11111 11111111 11111111
              // 0x20000 is 2^21.
              v = a[i] * 0x20000 + (a[i + 1] >>> 11);

              // Rejection sampling:
              // 0 <= v < 9007199254740992
              // Probability that v >= 9e15, is
              // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
              if (v >= 9e15) {
                b = crypto.getRandomValues(new Uint32Array(2));
                a[i] = b[0];
                a[i + 1] = b[1];
              } else {

                // 0 <= v <= 8999999999999999
                // 0 <= (v % 1e14) <= 99999999999999
                c.push(v % 1e14);
                i += 2;
              }
            }
            i = k / 2;

          // Node.js supporting crypto.randomBytes.
          } else if (crypto.randomBytes) {

            // buffer
            a = crypto.randomBytes(k *= 7);

            for (; i < k;) {

              // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
              // 0x100000000 is 2^32, 0x1000000 is 2^24
              // 11111 11111111 11111111 11111111 11111111 11111111 11111111
              // 0 <= v < 9007199254740992
              v = ((a[i] & 31) * 0x1000000000000) + (a[i + 1] * 0x10000000000) +
                 (a[i + 2] * 0x100000000) + (a[i + 3] * 0x1000000) +
                 (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];

              if (v >= 9e15) {
                crypto.randomBytes(7).copy(a, i);
              } else {

                // 0 <= (v % 1e14) <= 99999999999999
                c.push(v % 1e14);
                i += 7;
              }
            }
            i = k / 7;
          } else {
            CRYPTO = false;
            throw Error
             (bignumberError + 'crypto unavailable');
          }
        }

        // Use Math.random.
        if (!CRYPTO) {

          for (; i < k;) {
            v = random53bitInt();
            if (v < 9e15) c[i++] = v % 1e14;
          }
        }

        k = c[--i];
        dp %= LOG_BASE;

        // Convert trailing digits to zeros according to dp.
        if (k && dp) {
          v = POWS_TEN[LOG_BASE - dp];
          c[i] = mathfloor(k / v) * v;
        }

        // Remove trailing elements which are zero.
        for (; c[i] === 0; c.pop(), i--);

        // Zero?
        if (i < 0) {
          c = [e = 0];
        } else {

          // Remove leading elements which are zero and adjust exponent accordingly.
          for (e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

          // Count the digits of the first element of c to determine leading zeros, and...
          for (i = 1, v = c[0]; v >= 10; v /= 10, i++);

          // adjust the exponent accordingly.
          if (i < LOG_BASE) e -= LOG_BASE - i;
        }

        rand.e = e;
        rand.c = c;
        return rand;
      };
    })();


    /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */
    BigNumber.sum = function () {
      var i = 1,
        args = arguments,
        sum = new BigNumber(args[0]);
      for (; i < args.length;) sum = sum.plus(args[i++]);
      return sum;
    };


    // PRIVATE FUNCTIONS


    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = (function () {
      var decimal = '0123456789';

      /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */
      function toBaseOut(str, baseIn, baseOut, alphabet) {
        var j,
          arr = [0],
          arrL,
          i = 0,
          len = str.length;

        for (; i < len;) {
          for (arrL = arr.length; arrL--; arr[arrL] *= baseIn);

          arr[0] += alphabet.indexOf(str.charAt(i++));

          for (j = 0; j < arr.length; j++) {

            if (arr[j] > baseOut - 1) {
              if (arr[j + 1] == null) arr[j + 1] = 0;
              arr[j + 1] += arr[j] / baseOut | 0;
              arr[j] %= baseOut;
            }
          }
        }

        return arr.reverse();
      }

      // Convert a numeric string of baseIn to a numeric string of baseOut.
      // If the caller is toString, we are converting from base 10 to baseOut.
      // If the caller is BigNumber, we are converting from baseIn to base 10.
      return function (str, baseIn, baseOut, sign, callerIsToString) {
        var alphabet, d, e, k, r, x, xc, y,
          i = str.indexOf('.'),
          dp = DECIMAL_PLACES,
          rm = ROUNDING_MODE;

        // Non-integer.
        if (i >= 0) {
          k = POW_PRECISION;

          // Unlimited precision.
          POW_PRECISION = 0;
          str = str.replace('.', '');
          y = new BigNumber(baseIn);
          x = y.pow(str.length - i);
          POW_PRECISION = k;

          // Convert str as if an integer, then restore the fraction part by dividing the
          // result by its base raised to a power.

          y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'),
           10, baseOut, decimal);
          y.e = y.c.length;
        }

        // Convert the number as integer.

        xc = toBaseOut(str, baseIn, baseOut, callerIsToString
         ? (alphabet = ALPHABET, decimal)
         : (alphabet = decimal, ALPHABET));

        // xc now represents str as an integer and converted to baseOut. e is the exponent.
        e = k = xc.length;

        // Remove trailing zeros.
        for (; xc[--k] == 0; xc.pop());

        // Zero?
        if (!xc[0]) return alphabet.charAt(0);

        // Does str represent an integer? If so, no need for the division.
        if (i < 0) {
          --e;
        } else {
          x.c = xc;
          x.e = e;

          // The sign is needed for correct rounding.
          x.s = sign;
          x = div(x, y, dp, rm, baseOut);
          xc = x.c;
          r = x.r;
          e = x.e;
        }

        // xc now represents str converted to baseOut.

        // THe index of the rounding digit.
        d = e + dp + 1;

        // The rounding digit: the digit to the right of the digit that may be rounded up.
        i = xc[d];

        // Look at the rounding digits and mode to determine whether to round up.

        k = baseOut / 2;
        r = r || d < 0 || xc[d + 1] != null;

        r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
              : i > k || i == k &&(rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
               rm == (x.s < 0 ? 8 : 7));

        // If the index of the rounding digit is not greater than zero, or xc represents
        // zero, then the result of the base conversion is zero or, if rounding up, a value
        // such as 0.00001.
        if (d < 1 || !xc[0]) {

          // 1^-dp or 0
          str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
        } else {

          // Truncate xc to the required number of decimal places.
          xc.length = d;

          // Round up?
          if (r) {

            // Rounding up may mean the previous digit has to be rounded up and so on.
            for (--baseOut; ++xc[--d] > baseOut;) {
              xc[d] = 0;

              if (!d) {
                ++e;
                xc = [1].concat(xc);
              }
            }
          }

          // Determine trailing zeros.
          for (k = xc.length; !xc[--k];);

          // E.g. [4, 11, 15] becomes 4bf.
          for (i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));

          // Add leading zeros, decimal point and trailing zeros as required.
          str = toFixedPoint(str, e, alphabet.charAt(0));
        }

        // The caller will add the sign.
        return str;
      };
    })();


    // Perform division in the specified base. Called by div and convertBase.
    div = (function () {

      // Assume non-zero x and k.
      function multiply(x, k, base) {
        var m, temp, xlo, xhi,
          carry = 0,
          i = x.length,
          klo = k % SQRT_BASE,
          khi = k / SQRT_BASE | 0;

        for (x = x.slice(); i--;) {
          xlo = x[i] % SQRT_BASE;
          xhi = x[i] / SQRT_BASE | 0;
          m = khi * xlo + xhi * klo;
          temp = klo * xlo + ((m % SQRT_BASE) * SQRT_BASE) + carry;
          carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
          x[i] = temp % base;
        }

        if (carry) x = [carry].concat(x);

        return x;
      }

      function compare(a, b, aL, bL) {
        var i, cmp;

        if (aL != bL) {
          cmp = aL > bL ? 1 : -1;
        } else {

          for (i = cmp = 0; i < aL; i++) {

            if (a[i] != b[i]) {
              cmp = a[i] > b[i] ? 1 : -1;
              break;
            }
          }
        }

        return cmp;
      }

      function subtract(a, b, aL, base) {
        var i = 0;

        // Subtract b from a.
        for (; aL--;) {
          a[aL] -= i;
          i = a[aL] < b[aL] ? 1 : 0;
          a[aL] = i * base + a[aL] - b[aL];
        }

        // Remove leading zeros.
        for (; !a[0] && a.length > 1; a.splice(0, 1));
      }

      // x: dividend, y: divisor.
      return function (x, y, dp, rm, base) {
        var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
          yL, yz,
          s = x.s == y.s ? 1 : -1,
          xc = x.c,
          yc = y.c;

        // Either NaN, Infinity or 0?
        if (!xc || !xc[0] || !yc || !yc[0]) {

          return new BigNumber(

           // Return NaN if either NaN, or both Infinity or 0.
           !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN :

            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0
         );
        }

        q = new BigNumber(s);
        qc = q.c = [];
        e = x.e - y.e;
        s = dp + e + 1;

        if (!base) {
          base = BASE;
          e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
          s = s / LOG_BASE | 0;
        }

        // Result exponent may be one less then the current value of e.
        // The coefficients of the BigNumbers from convertBase may have trailing zeros.
        for (i = 0; yc[i] == (xc[i] || 0); i++);

        if (yc[i] > (xc[i] || 0)) e--;

        if (s < 0) {
          qc.push(1);
          more = true;
        } else {
          xL = xc.length;
          yL = yc.length;
          i = 0;
          s += 2;

          // Normalise xc and yc so highest order digit of yc is >= base / 2.

          n = mathfloor(base / (yc[0] + 1));

          // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
          // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
          if (n > 1) {
            yc = multiply(yc, n, base);
            xc = multiply(xc, n, base);
            yL = yc.length;
            xL = xc.length;
          }

          xi = yL;
          rem = xc.slice(0, yL);
          remL = rem.length;

          // Add zeros to make remainder as long as divisor.
          for (; remL < yL; rem[remL++] = 0);
          yz = yc.slice();
          yz = [0].concat(yz);
          yc0 = yc[0];
          if (yc[1] >= base / 2) yc0++;
          // Not necessary, but to prevent trial digit n > base, when using base 3.
          // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;

          do {
            n = 0;

            // Compare divisor and remainder.
            cmp = compare(yc, rem, yL, remL);

            // If divisor < remainder.
            if (cmp < 0) {

              // Calculate trial digit, n.

              rem0 = rem[0];
              if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

              // n is how many times the divisor goes into the current remainder.
              n = mathfloor(rem0 / yc0);

              //  Algorithm:
              //  product = divisor multiplied by trial digit (n).
              //  Compare product and remainder.
              //  If product is greater than remainder:
              //    Subtract divisor from product, decrement trial digit.
              //  Subtract product from remainder.
              //  If product was less than remainder at the last compare:
              //    Compare new remainder and divisor.
              //    If remainder is greater than divisor:
              //      Subtract divisor from remainder, increment trial digit.

              if (n > 1) {

                // n may be > base only when base is 3.
                if (n >= base) n = base - 1;

                // product = divisor * trial digit.
                prod = multiply(yc, n, base);
                prodL = prod.length;
                remL = rem.length;

                // Compare product and remainder.
                // If product > remainder then trial digit n too high.
                // n is 1 too high about 5% of the time, and is not known to have
                // ever been more than 1 too high.
                while (compare(prod, rem, prodL, remL) == 1) {
                  n--;

                  // Subtract divisor from product.
                  subtract(prod, yL < prodL ? yz : yc, prodL, base);
                  prodL = prod.length;
                  cmp = 1;
                }
              } else {

                // n is 0 or 1, cmp is -1.
                // If n is 0, there is no need to compare yc and rem again below,
                // so change cmp to 1 to avoid it.
                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                if (n == 0) {

                  // divisor < remainder, so n must be at least 1.
                  cmp = n = 1;
                }

                // product = divisor
                prod = yc.slice();
                prodL = prod.length;
              }

              if (prodL < remL) prod = [0].concat(prod);

              // Subtract product from remainder.
              subtract(rem, prod, remL, base);
              remL = rem.length;

               // If product was < remainder.
              if (cmp == -1) {

                // Compare divisor and new remainder.
                // If divisor < new remainder, subtract divisor from remainder.
                // Trial digit n too low.
                // n is 1 too low about 5% of the time, and very rarely 2 too low.
                while (compare(yc, rem, yL, remL) < 1) {
                  n++;

                  // Subtract divisor from remainder.
                  subtract(rem, yL < remL ? yz : yc, remL, base);
                  remL = rem.length;
                }
              }
            } else if (cmp === 0) {
              n++;
              rem = [0];
            } // else cmp === 1 and n will be 0

            // Add the next digit, n, to the result array.
            qc[i++] = n;

            // Update the remainder.
            if (rem[0]) {
              rem[remL++] = xc[xi] || 0;
            } else {
              rem = [xc[xi]];
              remL = 1;
            }
          } while ((xi++ < xL || rem[0] != null) && s--);

          more = rem[0] != null;

          // Leading zero?
          if (!qc[0]) qc.splice(0, 1);
        }

        if (base == BASE) {

          // To calculate q.e, first get the number of digits of qc[0].
          for (i = 1, s = qc[0]; s >= 10; s /= 10, i++);

          round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);

        // Caller is convertBase.
        } else {
          q.e = e;
          q.r = +more;
        }

        return q;
      };
    })();


    /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */
    function format(n, i, rm, id) {
      var c0, e, ne, len, str;

      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      if (!n.c) return n.toString();

      c0 = n.c[0];
      ne = n.e;

      if (i == null) {
        str = coeffToString(n.c);
        str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS)
         ? toExponential(str, ne)
         : toFixedPoint(str, ne, '0');
      } else {
        n = round(new BigNumber(n), i, rm);

        // n.e may have changed if the value was rounded up.
        e = n.e;

        str = coeffToString(n.c);
        len = str.length;

        // toPrecision returns exponential notation if the number of significant digits
        // specified is less than the number of digits necessary to represent the integer
        // part of the value in fixed-point notation.

        // Exponential notation.
        if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {

          // Append zeros?
          for (; len < i; str += '0', len++);
          str = toExponential(str, e);

        // Fixed-point notation.
        } else {
          i -= ne;
          str = toFixedPoint(str, e, '0');

          // Append zeros?
          if (e + 1 > len) {
            if (--i > 0) for (str += '.'; i--; str += '0');
          } else {
            i += e - len;
            if (i > 0) {
              if (e + 1 == len) str += '.';
              for (; i--; str += '0');
            }
          }
        }
      }

      return n.s < 0 && c0 ? '-' + str : str;
    }


    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
      var k, y,
        i = 1,
        x = new BigNumber(args[0]);

      for (; i < args.length; i++) {
        y = new BigNumber(args[i]);
        if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) {
          x = y;
        }
      }

      return x;
    }


    /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */
    function normalise(n, c, e) {
      var i = 1,
        j = c.length;

       // Remove trailing zeros.
      for (; !c[--j]; c.pop());

      // Calculate the base 10 exponent. First get the number of digits of c[0].
      for (j = c[0]; j >= 10; j /= 10, i++);

      // Overflow?
      if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {

        // Infinity.
        n.c = n.e = null;

      // Underflow?
      } else if (e < MIN_EXP) {

        // Zero.
        n.c = [n.e = 0];
      } else {
        n.e = e;
        n.c = c;
      }

      return n;
    }


    // Handle values that fail the validity test in BigNumber.
    parseNumeric = (function () {
      var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
        dotAfter = /^([^.]+)\.$/,
        dotBefore = /^\.([^.]+)$/,
        isInfinityOrNaN = /^-?(Infinity|NaN)$/,
        whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

      return function (x, str, isNum, b) {
        var base,
          s = isNum ? str : str.replace(whitespaceOrPlus, '');

        // No exception on ±Infinity or NaN.
        if (isInfinityOrNaN.test(s)) {
          x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
        } else {
          if (!isNum) {

            // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
            s = s.replace(basePrefix, function (m, p1, p2) {
              base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
              return !b || b == base ? p1 : m;
            });

            if (b) {
              base = b;

              // E.g. '1.' to '1', '.1' to '0.1'
              s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
            }

            if (str != s) return new BigNumber(s, base);
          }

          // '[BigNumber Error] Not a number: {n}'
          // '[BigNumber Error] Not a base {b} number: {n}'
          if (BigNumber.DEBUG) {
            throw Error
              (bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
          }

          // NaN
          x.s = null;
        }

        x.c = x.e = null;
      }
    })();


    /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */
    function round(x, sd, rm, r) {
      var d, i, j, k, n, ni, rd,
        xc = x.c,
        pows10 = POWS_TEN;

      // if x is not Infinity or NaN...
      if (xc) {

        // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
        // n is a base 1e14 number, the value of the element of array x.c containing rd.
        // ni is the index of n within x.c.
        // d is the number of digits of n.
        // i is the index of rd within n including leading zeros.
        // j is the actual index of rd within n (if < 0, rd is a leading zero).
        out: {

          // Get the number of digits of the first element of xc.
          for (d = 1, k = xc[0]; k >= 10; k /= 10, d++);
          i = sd - d;

          // If the rounding digit is in the first element of xc...
          if (i < 0) {
            i += LOG_BASE;
            j = sd;
            n = xc[ni = 0];

            // Get the rounding digit at index j of n.
            rd = mathfloor(n / pows10[d - j - 1] % 10);
          } else {
            ni = mathceil((i + 1) / LOG_BASE);

            if (ni >= xc.length) {

              if (r) {

                // Needed by sqrt.
                for (; xc.length <= ni; xc.push(0));
                n = rd = 0;
                d = 1;
                i %= LOG_BASE;
                j = i - LOG_BASE + 1;
              } else {
                break out;
              }
            } else {
              n = k = xc[ni];

              // Get the number of digits of n.
              for (d = 1; k >= 10; k /= 10, d++);

              // Get the index of rd within n.
              i %= LOG_BASE;

              // Get the index of rd within n, adjusted for leading zeros.
              // The number of leading zeros of n is given by LOG_BASE - d.
              j = i - LOG_BASE + d;

              // Get the rounding digit at index j of n.
              rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
            }
          }

          r = r || sd < 0 ||

          // Are there any non-zero digits after the rounding digit?
          // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
          // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
           xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);

          r = rm < 4
           ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
           : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 &&

            // Check whether the digit to the left of the rounding digit is odd.
            ((i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10) & 1 ||
             rm == (x.s < 0 ? 8 : 7));

          if (sd < 1 || !xc[0]) {
            xc.length = 0;

            if (r) {

              // Convert sd to decimal places.
              sd -= x.e + 1;

              // 1, 0.1, 0.01, 0.001, 0.0001 etc.
              xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
              x.e = -sd || 0;
            } else {

              // Zero.
              xc[0] = x.e = 0;
            }

            return x;
          }

          // Remove excess digits.
          if (i == 0) {
            xc.length = ni;
            k = 1;
            ni--;
          } else {
            xc.length = ni + 1;
            k = pows10[LOG_BASE - i];

            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of n.
            xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
          }

          // Round up?
          if (r) {

            for (; ;) {

              // If the digit to be rounded up is in the first element of xc...
              if (ni == 0) {

                // i will be the length of xc[0] before k is added.
                for (i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                j = xc[0] += k;
                for (k = 1; j >= 10; j /= 10, k++);

                // if i != k the length has increased.
                if (i != k) {
                  x.e++;
                  if (xc[0] == BASE) xc[0] = 1;
                }

                break;
              } else {
                xc[ni] += k;
                if (xc[ni] != BASE) break;
                xc[ni--] = 0;
                k = 1;
              }
            }
          }

          // Remove trailing zeros.
          for (i = xc.length; xc[--i] === 0; xc.pop());
        }

        // Overflow? Infinity.
        if (x.e > MAX_EXP) {
          x.c = x.e = null;

        // Underflow? Zero.
        } else if (x.e < MIN_EXP) {
          x.c = [x.e = 0];
        }
      }

      return x;
    }


    function valueOf(n) {
      var str,
        e = n.e;

      if (e === null) return n.toString();

      str = coeffToString(n.c);

      str = e <= TO_EXP_NEG || e >= TO_EXP_POS
        ? toExponential(str, e)
        : toFixedPoint(str, e, '0');

      return n.s < 0 ? '-' + str : str;
    }


    // PROTOTYPE/INSTANCE METHODS


    /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */
    P.absoluteValue = P.abs = function () {
      var x = new BigNumber(this);
      if (x.s < 0) x.s = 1;
      return x;
    };


    /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */
    P.comparedTo = function (y, b) {
      return compare(this, new BigNumber(y, b));
    };


    /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.decimalPlaces = P.dp = function (dp, rm) {
      var c, n, v,
        x = this;

      if (dp != null) {
        intCheck(dp, 0, MAX);
        if (rm == null) rm = ROUNDING_MODE;
        else intCheck(rm, 0, 8);

        return round(new BigNumber(x), dp + x.e + 1, rm);
      }

      if (!(c = x.c)) return null;
      n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;

      // Subtract the number of trailing zeros of the last number.
      if (v = c[v]) for (; v % 10 == 0; v /= 10, n--);
      if (n < 0) n = 0;

      return n;
    };


    /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */
    P.dividedBy = P.div = function (y, b) {
      return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };


    /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */
    P.dividedToIntegerBy = P.idiv = function (y, b) {
      return div(this, new BigNumber(y, b), 0, 1);
    };


    /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */
    P.exponentiatedBy = P.pow = function (n, m) {
      var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y,
        x = this;

      n = new BigNumber(n);

      // Allow NaN and ±Infinity, but not other non-integers.
      if (n.c && !n.isInteger()) {
        throw Error
          (bignumberError + 'Exponent not an integer: ' + valueOf(n));
      }

      if (m != null) m = new BigNumber(m);

      // Exponent of MAX_SAFE_INTEGER is 15.
      nIsBig = n.e > 14;

      // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
      if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {

        // The sign of the result of pow when x is negative depends on the evenness of n.
        // If +n overflows to ±Infinity, the evenness of n would be not be known.
        y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
        return m ? y.mod(m) : y;
      }

      nIsNeg = n.s < 0;

      if (m) {

        // x % m returns NaN if abs(m) is zero, or m is NaN.
        if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);

        isModExp = !nIsNeg && x.isInteger() && m.isInteger();

        if (isModExp) x = x.mod(m);

      // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
      // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
      } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0
        // [1, 240000000]
        ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7
        // [80000000000000]  [99999750000000]
        : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {

        // If x is negative and n is odd, k = -0, else k = 0.
        k = x.s < 0 && isOdd(n) ? -0 : 0;

        // If x >= 1, k = ±Infinity.
        if (x.e > -1) k = 1 / k;

        // If n is negative return ±0, else return ±Infinity.
        return new BigNumber(nIsNeg ? 1 / k : k);

      } else if (POW_PRECISION) {

        // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = mathceil(POW_PRECISION / LOG_BASE + 2);
      }

      if (nIsBig) {
        half = new BigNumber(0.5);
        if (nIsNeg) n.s = 1;
        nIsOdd = isOdd(n);
      } else {
        i = Math.abs(+valueOf(n));
        nIsOdd = i % 2;
      }

      y = new BigNumber(ONE);

      // Performs 54 loop iterations for n of 9007199254740991.
      for (; ;) {

        if (nIsOdd) {
          y = y.times(x);
          if (!y.c) break;

          if (k) {
            if (y.c.length > k) y.c.length = k;
          } else if (isModExp) {
            y = y.mod(m);    //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
          }
        }

        if (i) {
          i = mathfloor(i / 2);
          if (i === 0) break;
          nIsOdd = i % 2;
        } else {
          n = n.times(half);
          round(n, n.e + 1, 1);

          if (n.e > 14) {
            nIsOdd = isOdd(n);
          } else {
            i = +valueOf(n);
            if (i === 0) break;
            nIsOdd = i % 2;
          }
        }

        x = x.times(x);

        if (k) {
          if (x.c && x.c.length > k) x.c.length = k;
        } else if (isModExp) {
          x = x.mod(m);    //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
      }

      if (isModExp) return y;
      if (nIsNeg) y = ONE.div(y);

      return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */
    P.integerValue = function (rm) {
      var n = new BigNumber(this);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);
      return round(n, n.e + 1, rm);
    };


    /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isEqualTo = P.eq = function (y, b) {
      return compare(this, new BigNumber(y, b)) === 0;
    };


    /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */
    P.isFinite = function () {
      return !!this.c;
    };


    /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isGreaterThan = P.gt = function (y, b) {
      return compare(this, new BigNumber(y, b)) > 0;
    };


    /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */
    P.isGreaterThanOrEqualTo = P.gte = function (y, b) {
      return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;

    };


    /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */
    P.isInteger = function () {
      return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
    };


    /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */
    P.isLessThan = P.lt = function (y, b) {
      return compare(this, new BigNumber(y, b)) < 0;
    };


    /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */
    P.isLessThanOrEqualTo = P.lte = function (y, b) {
      return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };


    /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */
    P.isNaN = function () {
      return !this.s;
    };


    /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */
    P.isNegative = function () {
      return this.s < 0;
    };


    /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */
    P.isPositive = function () {
      return this.s > 0;
    };


    /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */
    P.isZero = function () {
      return !!this.c && this.c[0] == 0;
    };


    /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */
    P.minus = function (y, b) {
      var i, j, t, xLTy,
        x = this,
        a = x.s;

      y = new BigNumber(y, b);
      b = y.s;

      // Either NaN?
      if (!a || !b) return new BigNumber(NaN);

      // Signs differ?
      if (a != b) {
        y.s = -b;
        return x.plus(y);
      }

      var xe = x.e / LOG_BASE,
        ye = y.e / LOG_BASE,
        xc = x.c,
        yc = y.c;

      if (!xe || !ye) {

        // Either Infinity?
        if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);

        // Either zero?
        if (!xc[0] || !yc[0]) {

          // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
          return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x :

           // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
           ROUNDING_MODE == 3 ? -0 : 0);
        }
      }

      xe = bitFloor(xe);
      ye = bitFloor(ye);
      xc = xc.slice();

      // Determine which is the bigger number.
      if (a = xe - ye) {

        if (xLTy = a < 0) {
          a = -a;
          t = xc;
        } else {
          ye = xe;
          t = yc;
        }

        t.reverse();

        // Prepend zeros to equalise exponents.
        for (b = a; b--; t.push(0));
        t.reverse();
      } else {

        // Exponents equal. Check digit by digit.
        j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;

        for (a = b = 0; b < j; b++) {

          if (xc[b] != yc[b]) {
            xLTy = xc[b] < yc[b];
            break;
          }
        }
      }

      // x < y? Point xc to the array of the bigger number.
      if (xLTy) {
        t = xc;
        xc = yc;
        yc = t;
        y.s = -y.s;
      }

      b = (j = yc.length) - (i = xc.length);

      // Append zeros to xc if shorter.
      // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
      if (b > 0) for (; b--; xc[i++] = 0);
      b = BASE - 1;

      // Subtract yc from xc.
      for (; j > a;) {

        if (xc[--j] < yc[j]) {
          for (i = j; i && !xc[--i]; xc[i] = b);
          --xc[i];
          xc[j] += BASE;
        }

        xc[j] -= yc[j];
      }

      // Remove leading zeros and adjust exponent accordingly.
      for (; xc[0] == 0; xc.splice(0, 1), --ye);

      // Zero?
      if (!xc[0]) {

        // Following IEEE 754 (2008) 6.3,
        // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
        y.s = ROUNDING_MODE == 3 ? -1 : 1;
        y.c = [y.e = 0];
        return y;
      }

      // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
      // for finite x and y.
      return normalise(y, xc, ye);
    };


    /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */
    P.modulo = P.mod = function (y, b) {
      var q, s,
        x = this;

      y = new BigNumber(y, b);

      // Return NaN if x is Infinity or NaN, or y is NaN or zero.
      if (!x.c || !y.s || y.c && !y.c[0]) {
        return new BigNumber(NaN);

      // Return x if y is Infinity or x is zero.
      } else if (!y.c || x.c && !x.c[0]) {
        return new BigNumber(x);
      }

      if (MODULO_MODE == 9) {

        // Euclidian division: q = sign(y) * floor(x / abs(y))
        // r = x - qy    where  0 <= r < abs(y)
        s = y.s;
        y.s = 1;
        q = div(x, y, 0, 3);
        y.s = s;
        q.s *= s;
      } else {
        q = div(x, y, 0, MODULO_MODE);
      }

      y = x.minus(q.times(y));

      // To match JavaScript %, ensure sign of zero is sign of dividend.
      if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;

      return y;
    };


    /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */
    P.multipliedBy = P.times = function (y, b) {
      var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
        base, sqrtBase,
        x = this,
        xc = x.c,
        yc = (y = new BigNumber(y, b)).c;

      // Either NaN, ±Infinity or ±0?
      if (!xc || !yc || !xc[0] || !yc[0]) {

        // Return NaN if either is NaN, or one is 0 and the other is Infinity.
        if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
          y.c = y.e = y.s = null;
        } else {
          y.s *= x.s;

          // Return ±Infinity if either is ±Infinity.
          if (!xc || !yc) {
            y.c = y.e = null;

          // Return ±0 if either is ±0.
          } else {
            y.c = [0];
            y.e = 0;
          }
        }

        return y;
      }

      e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
      y.s *= x.s;
      xcL = xc.length;
      ycL = yc.length;

      // Ensure xc points to longer array and xcL to its length.
      if (xcL < ycL) {
        zc = xc;
        xc = yc;
        yc = zc;
        i = xcL;
        xcL = ycL;
        ycL = i;
      }

      // Initialise the result array with zeros.
      for (i = xcL + ycL, zc = []; i--; zc.push(0));

      base = BASE;
      sqrtBase = SQRT_BASE;

      for (i = ycL; --i >= 0;) {
        c = 0;
        ylo = yc[i] % sqrtBase;
        yhi = yc[i] / sqrtBase | 0;

        for (k = xcL, j = i + k; j > i;) {
          xlo = xc[--k] % sqrtBase;
          xhi = xc[k] / sqrtBase | 0;
          m = yhi * xlo + xhi * ylo;
          xlo = ylo * xlo + ((m % sqrtBase) * sqrtBase) + zc[j] + c;
          c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
          zc[j--] = xlo % base;
        }

        zc[j] = c;
      }

      if (c) {
        ++e;
      } else {
        zc.splice(0, 1);
      }

      return normalise(y, zc, e);
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */
    P.negated = function () {
      var x = new BigNumber(this);
      x.s = -x.s || null;
      return x;
    };


    /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */
    P.plus = function (y, b) {
      var t,
        x = this,
        a = x.s;

      y = new BigNumber(y, b);
      b = y.s;

      // Either NaN?
      if (!a || !b) return new BigNumber(NaN);

      // Signs differ?
       if (a != b) {
        y.s = -b;
        return x.minus(y);
      }

      var xe = x.e / LOG_BASE,
        ye = y.e / LOG_BASE,
        xc = x.c,
        yc = y.c;

      if (!xe || !ye) {

        // Return ±Infinity if either ±Infinity.
        if (!xc || !yc) return new BigNumber(a / 0);

        // Either zero?
        // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
        if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
      }

      xe = bitFloor(xe);
      ye = bitFloor(ye);
      xc = xc.slice();

      // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
      if (a = xe - ye) {
        if (a > 0) {
          ye = xe;
          t = yc;
        } else {
          a = -a;
          t = xc;
        }

        t.reverse();
        for (; a--; t.push(0));
        t.reverse();
      }

      a = xc.length;
      b = yc.length;

      // Point xc to the longer array, and b to the shorter length.
      if (a - b < 0) {
        t = yc;
        yc = xc;
        xc = t;
        b = a;
      }

      // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
      for (a = 0; b;) {
        a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
        xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
      }

      if (a) {
        xc = [a].concat(xc);
        ++ye;
      }

      // No need to check for zero, as +x + +y != 0 && -x + -y != 0
      // ye = MAX_EXP + 1 possible
      return normalise(y, xc, ye);
    };


    /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */
    P.precision = P.sd = function (sd, rm) {
      var c, n, v,
        x = this;

      if (sd != null && sd !== !!sd) {
        intCheck(sd, 1, MAX);
        if (rm == null) rm = ROUNDING_MODE;
        else intCheck(rm, 0, 8);

        return round(new BigNumber(x), sd, rm);
      }

      if (!(c = x.c)) return null;
      v = c.length - 1;
      n = v * LOG_BASE + 1;

      if (v = c[v]) {

        // Subtract the number of trailing zeros of the last element.
        for (; v % 10 == 0; v /= 10, n--);

        // Add the number of digits of the first element.
        for (v = c[0]; v >= 10; v /= 10, n++);
      }

      if (sd && x.e + 1 > n) n = x.e + 1;

      return n;
    };


    /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */
    P.shiftedBy = function (k) {
      intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
      return this.times('1e' + k);
    };


    /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */
    P.squareRoot = P.sqrt = function () {
      var m, n, r, rep, t,
        x = this,
        c = x.c,
        s = x.s,
        e = x.e,
        dp = DECIMAL_PLACES + 4,
        half = new BigNumber('0.5');

      // Negative/NaN/Infinity/zero?
      if (s !== 1 || !c || !c[0]) {
        return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
      }

      // Initial estimate.
      s = Math.sqrt(+valueOf(x));

      // Math.sqrt underflow/overflow?
      // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
      if (s == 0 || s == 1 / 0) {
        n = coeffToString(c);
        if ((n.length + e) % 2 == 0) n += '0';
        s = Math.sqrt(+n);
        e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);

        if (s == 1 / 0) {
          n = '5e' + e;
        } else {
          n = s.toExponential();
          n = n.slice(0, n.indexOf('e') + 1) + e;
        }

        r = new BigNumber(n);
      } else {
        r = new BigNumber(s + '');
      }

      // Check for zero.
      // r could be zero if MIN_EXP is changed after the this value was created.
      // This would cause a division by zero (x/t) and hence Infinity below, which would cause
      // coeffToString to throw.
      if (r.c[0]) {
        e = r.e;
        s = e + dp;
        if (s < 3) s = 0;

        // Newton-Raphson iteration.
        for (; ;) {
          t = r;
          r = half.times(t.plus(div(x, t, dp, 1)));

          if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {

            // The exponent of r may here be one less than the final result exponent,
            // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
            // are indexed correctly.
            if (r.e < e) --s;
            n = n.slice(s - 3, s + 1);

            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
            // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
            // iteration.
            if (n == '9999' || !rep && n == '4999') {

              // On the first iteration only, check to see if rounding up gives the
              // exact result as the nines may infinitely repeat.
              if (!rep) {
                round(t, t.e + DECIMAL_PLACES + 2, 0);

                if (t.times(t).eq(x)) {
                  r = t;
                  break;
                }
              }

              dp += 4;
              s += 4;
              rep = 1;
            } else {

              // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
              // result. If not, then there are further digits and m will be truthy.
              if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

                // Truncate to the first rounding digit.
                round(r, r.e + DECIMAL_PLACES + 2, 1);
                m = !r.times(r).eq(x);
              }

              break;
            }
          }
        }
      }

      return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };


    /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.toExponential = function (dp, rm) {
      if (dp != null) {
        intCheck(dp, 0, MAX);
        dp++;
      }
      return format(this, dp, rm, 1);
    };


    /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */
    P.toFixed = function (dp, rm) {
      if (dp != null) {
        intCheck(dp, 0, MAX);
        dp = dp + this.e + 1;
      }
      return format(this, dp, rm);
    };


    /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */
    P.toFormat = function (dp, rm, format) {
      var str,
        x = this;

      if (format == null) {
        if (dp != null && rm && typeof rm == 'object') {
          format = rm;
          rm = null;
        } else if (dp && typeof dp == 'object') {
          format = dp;
          dp = rm = null;
        } else {
          format = FORMAT;
        }
      } else if (typeof format != 'object') {
        throw Error
          (bignumberError + 'Argument not an object: ' + format);
      }

      str = x.toFixed(dp, rm);

      if (x.c) {
        var i,
          arr = str.split('.'),
          g1 = +format.groupSize,
          g2 = +format.secondaryGroupSize,
          groupSeparator = format.groupSeparator || '',
          intPart = arr[0],
          fractionPart = arr[1],
          isNeg = x.s < 0,
          intDigits = isNeg ? intPart.slice(1) : intPart,
          len = intDigits.length;

        if (g2) {
          i = g1;
          g1 = g2;
          g2 = i;
          len -= i;
        }

        if (g1 > 0 && len > 0) {
          i = len % g1 || g1;
          intPart = intDigits.substr(0, i);
          for (; i < len; i += g1) intPart += groupSeparator + intDigits.substr(i, g1);
          if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
          if (isNeg) intPart = '-' + intPart;
        }

        str = fractionPart
         ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize)
          ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'),
           '$&' + (format.fractionGroupSeparator || ''))
          : fractionPart)
         : intPart;
      }

      return (format.prefix || '') + str + (format.suffix || '');
    };


    /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */
    P.toFraction = function (md) {
      var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s,
        x = this,
        xc = x.c;

      if (md != null) {
        n = new BigNumber(md);

        // Throw if md is less than one or is not an integer, unless it is Infinity.
        if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
          throw Error
            (bignumberError + 'Argument ' +
              (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
        }
      }

      if (!xc) return new BigNumber(x);

      d = new BigNumber(ONE);
      n1 = d0 = new BigNumber(ONE);
      d1 = n0 = new BigNumber(ONE);
      s = coeffToString(xc);

      // Determine initial denominator.
      // d is a power of 10 and the minimum max denominator that specifies the value exactly.
      e = d.e = s.length - x.e - 1;
      d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
      md = !md || n.comparedTo(d) > 0 ? (e > 0 ? d : n1) : n;

      exp = MAX_EXP;
      MAX_EXP = 1 / 0;
      n = new BigNumber(s);

      // n0 = d1 = 0
      n0.c[0] = 0;

      for (; ;)  {
        q = div(n, d, 0, 1);
        d2 = d0.plus(q.times(d1));
        if (d2.comparedTo(md) == 1) break;
        d0 = d1;
        d1 = d2;
        n1 = n0.plus(q.times(d2 = n1));
        n0 = d2;
        d = n.minus(q.times(d2 = d));
        n = d2;
      }

      d2 = div(md.minus(d0), d1, 0, 1);
      n0 = n0.plus(d2.times(n1));
      d0 = d0.plus(d2.times(d1));
      n0.s = n1.s = x.s;
      e = e * 2;

      // Determine which fraction is closer to x, n0/d0 or n1/d1
      r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(
          div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];

      MAX_EXP = exp;

      return r;
    };


    /*
     * Return the value of this BigNumber converted to a number primitive.
     */
    P.toNumber = function () {
      return +valueOf(this);
    };


    /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */
    P.toPrecision = function (sd, rm) {
      if (sd != null) intCheck(sd, 1, MAX);
      return format(this, sd, rm, 2);
    };


    /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */
    P.toString = function (b) {
      var str,
        n = this,
        s = n.s,
        e = n.e;

      // Infinity or NaN?
      if (e === null) {
        if (s) {
          str = 'Infinity';
          if (s < 0) str = '-' + str;
        } else {
          str = 'NaN';
        }
      } else {
        if (b == null) {
          str = e <= TO_EXP_NEG || e >= TO_EXP_POS
           ? toExponential(coeffToString(n.c), e)
           : toFixedPoint(coeffToString(n.c), e, '0');
        } else if (b === 10 && alphabetHasNormalDecimalDigits) {
          n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
          str = toFixedPoint(coeffToString(n.c), n.e, '0');
        } else {
          intCheck(b, 2, ALPHABET.length, 'Base');
          str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
        }

        if (s < 0 && n.c[0]) str = '-' + str;
      }

      return str;
    };


    /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */
    P.valueOf = P.toJSON = function () {
      return valueOf(this);
    };


    P._isBigNumber = true;

    if (configObject != null) BigNumber.set(configObject);

    return BigNumber;
  }


  // PRIVATE HELPER FUNCTIONS

  // These functions don't need access to variables,
  // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.


  function bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
  }


  // Return a coefficient array as a string of base 10 digits.
  function coeffToString(a) {
    var s, z,
      i = 1,
      j = a.length,
      r = a[0] + '';

    for (; i < j;) {
      s = a[i++] + '';
      z = LOG_BASE - s.length;
      for (; z--; s = '0' + s);
      r += s;
    }

    // Determine trailing zeros.
    for (j = r.length; r.charCodeAt(--j) === 48;);

    return r.slice(0, j + 1 || 1);
  }


  // Compare the value of BigNumbers x and y.
  function compare(x, y) {
    var a, b,
      xc = x.c,
      yc = y.c,
      i = x.s,
      j = y.s,
      k = x.e,
      l = y.e;

    // Either NaN?
    if (!i || !j) return null;

    a = xc && !xc[0];
    b = yc && !yc[0];

    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;

    // Signs differ?
    if (i != j) return i;

    a = i < 0;
    b = k == l;

    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;

    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;

    j = (k = xc.length) < (l = yc.length) ? k : l;

    // Compare digit by digit.
    for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;

    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
  }


  /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */
  function intCheck(n, min, max, name) {
    if (n < min || n > max || n !== mathfloor(n)) {
      throw Error
       (bignumberError + (name || 'Argument') + (typeof n == 'number'
         ? n < min || n > max ? ' out of range: ' : ' not an integer: '
         : ' not a primitive number: ') + String(n));
    }
  }


  // Assumes finite n.
  function isOdd(n) {
    var k = n.c.length - 1;
    return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
  }


  function toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) +
     (e < 0 ? 'e' : 'e+') + e;
  }


  function toFixedPoint(str, e, z) {
    var len, zs;

    // Negative exponent?
    if (e < 0) {

      // Prepend zeros.
      for (zs = z + '.'; ++e; zs += z);
      str = zs + str;

    // Positive exponent
    } else {
      len = str.length;

      // Append zeros.
      if (++e > len) {
        for (zs = z, e -= len; --e; zs += z);
        str += zs;
      } else if (e < len) {
        str = str.slice(0, e) + '.' + str.slice(e);
      }
    }

    return str;
  }


  // EXPORT


  BigNumber = clone();
  BigNumber['default'] = BigNumber.BigNumber = BigNumber;

  // AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return BigNumber; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node.js and other environments that support module.exports.
  } else if (typeof module != 'undefined' && module.exports) {
    module.exports = BigNumber;

  // Browser.
  } else {
    if (!globalObject) {
      globalObject = typeof self != 'undefined' && self ? self : window;
    }

    globalObject.BigNumber = BigNumber;
  }
})(this);


/***/ }),
/* 325 */
/* exports provided: props, BAlert */
/* exports used: BAlert */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/alert/alert.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__button_button_close__ = __webpack_require__(/*! ../button/button-close */ 107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__transition_bv_transition__ = __webpack_require__(/*! ../transition/bv-transition */ 108);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_model__["a" /* makeModelMixin */])('show', {
  type: __WEBPACK_IMPORTED_MODULE_2__constants_props__["r" /* PROP_TYPE_BOOLEAN_NUMBER_STRING */],
  defaultValue: false
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // --- Helper methods ---
// Convert `show` value to a number


var parseCountDown = function parseCountDown(show) {
  if (show === '' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["k" /* isBoolean */])(show)) {
    return 0;
  }

  show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(show, 0);
  return show > 0 ? show : 0;
}; // Convert `show` value to a boolean


var parseShow = function parseShow(show) {
  if (show === '' || show === true) {
    return true;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(show, 0) < 1) {
    // Boolean will always return false for the above comparison
    return false;
  }

  return !!show;
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, modelProps), {}, {
  dismissLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'Close'),
  dismissible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  fade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'info')
})), __WEBPACK_IMPORTED_MODULE_0__constants_components__["_72" /* NAME_ALERT */]); // --- Main component ---
// @vue/component

var BAlert = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_0__constants_components__["_72" /* NAME_ALERT */],
  mixins: [modelMixin, __WEBPACK_IMPORTED_MODULE_4__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    return {
      countDown: 0,
      // If initially shown, we need to set these for SSR
      localShow: parseShow(this[MODEL_PROP_NAME])
    };
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    this.countDown = parseCountDown(newValue);
    this.localShow = parseShow(newValue);
  }), _defineProperty(_watch, "countDown", function countDown(newValue) {
    var _this = this;

    this.clearCountDownInterval();
    var show = this[MODEL_PROP_NAME]; // Ignore if `show` transitions to a boolean value

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["n" /* isNumeric */])(show)) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["_8" /* EVENT_NAME_DISMISS_COUNT_DOWN */], newValue); // Update the v-model if needed

      if (show !== newValue) {
        this.$emit(MODEL_EVENT_NAME, newValue);
      }

      if (newValue > 0) {
        this.localShow = true;
        this.$_countDownTimeout = setTimeout(function () {
          _this.countDown--;
        }, 1000);
      } else {
        // Slightly delay the hide to allow any UI updates
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["a" /* requestAF */])(function () {
            _this.localShow = false;
          });
        });
      }
    }
  }), _defineProperty(_watch, "localShow", function localShow(newValue) {
    var show = this[MODEL_PROP_NAME]; // Only emit dismissed events for dismissible or auto-dismissing alerts

    if (!newValue && (this.dismissible || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["n" /* isNumeric */])(show))) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["_9" /* EVENT_NAME_DISMISSED */]);
    } // Only emit booleans if we weren't passed a number via v-model


    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["n" /* isNumeric */])(show) && show !== newValue) {
      this.$emit(MODEL_EVENT_NAME, newValue);
    }
  }), _watch),
  created: function created() {
    // Create private non-reactive props
    this.$_filterTimer = null;
    var show = this[MODEL_PROP_NAME];
    this.countDown = parseCountDown(show);
    this.localShow = parseShow(show);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearCountDownInterval();
  },
  methods: {
    dismiss: function dismiss() {
      this.clearCountDownInterval();
      this.countDown = 0;
      this.localShow = false;
    },
    clearCountDownInterval: function clearCountDownInterval() {
      clearTimeout(this.$_countDownTimeout);
      this.$_countDownTimeout = null;
    }
  },
  render: function render(h) {
    var $alert = h();

    if (this.localShow) {
      var dismissible = this.dismissible,
          variant = this.variant;
      var $dismissButton = h();

      if (dismissible) {
        // Add dismiss button
        $dismissButton = h(__WEBPACK_IMPORTED_MODULE_12__button_button_close__["a" /* BButtonClose */], {
          attrs: {
            'aria-label': this.dismissLabel
          },
          on: {
            click: this.dismiss
          }
        }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["_11" /* SLOT_NAME_DISMISS */])]);
      }

      $alert = h('div', {
        staticClass: 'alert',
        class: _defineProperty({
          'alert-dismissible': dismissible
        }, "alert-".concat(variant), variant),
        attrs: {
          role: 'alert',
          'aria-live': 'polite',
          'aria-atomic': true
        },
        key: this[__WEBPACK_IMPORTED_MODULE_11__vue__["e" /* COMPONENT_UID_KEY */]]
      }, [$dismissButton, this.normalizeSlot()]);
    }

    return h(__WEBPACK_IMPORTED_MODULE_13__transition_bv_transition__["a" /* BVTransition */], {
      props: {
        noFade: !this.fade
      }
    }, [$alert]);
  }
});

/***/ }),
/* 326 */
/* exports provided: AlertPlugin, BAlert */
/* exports used: AlertPlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/alert/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert__ = __webpack_require__(/*! ./alert */ 325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BAlert */


var AlertPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BAlert: __WEBPACK_IMPORTED_MODULE_0__alert__["a" /* BAlert */]
  }
});


/***/ }),
/* 327 */
/* exports provided: props, BAspect */
/* exports used: BAspect */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/aspect/aspect.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAspect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








 // --- Constants ---

var CLASS_NAME = 'b-aspect'; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  // Accepts a number (i.e. `16 / 9`, `1`, `4 / 3`)
  // Or a string (i.e. '16/9', '16:9', '4:3' '1:1')
  aspect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], '1:1'),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_71" /* NAME_ASPECT */]); // --- Main component ---
// @vue/component

var BAspect = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_71" /* NAME_ASPECT */],
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  computed: {
    padding: function padding() {
      var aspect = this.aspect;
      var ratio = 1;

      if (__WEBPACK_IMPORTED_MODULE_3__constants_regex__["D" /* RX_ASPECT */].test(aspect)) {
        // Width and/or Height can be a decimal value below `1`, so
        // we only fallback to `1` if the value is `0` or `NaN`
        var _aspect$split$map = aspect.split(__WEBPACK_IMPORTED_MODULE_3__constants_regex__["E" /* RX_ASPECT_SEPARATOR */]).map(function (v) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_number__["a" /* toFloat */])(v) || 1;
        }),
            _aspect$split$map2 = _slicedToArray(_aspect$split$map, 2),
            width = _aspect$split$map2[0],
            height = _aspect$split$map2[1];

        ratio = width / height;
      } else {
        ratio = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_number__["a" /* toFloat */])(aspect) || 1;
      }

      return "".concat(100 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_math__["g" /* mathAbs */])(ratio), "%");
    }
  },
  render: function render(h) {
    var $sizer = h('div', {
      staticClass: "".concat(CLASS_NAME, "-sizer flex-grow-1"),
      style: {
        paddingBottom: this.padding,
        height: 0
      }
    });
    var $content = h('div', {
      staticClass: "".concat(CLASS_NAME, "-content flex-grow-1 w-100 mw-100"),
      style: {
        marginLeft: '-100%'
      }
    }, this.normalizeSlot());
    return h(this.tag, {
      staticClass: "".concat(CLASS_NAME, " d-flex")
    }, [$sizer, $content]);
  }
});

/***/ }),
/* 328 */
/* exports provided: props, BAvatarGroup */
/* exports used: BAvatarGroup */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/avatar/avatar-group.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAvatarGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__avatar__ = __webpack_require__(/*! ./avatar */ 206);







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])({
  overlap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0.3),
  // Child avatars will prefer this prop (if set) over their own
  rounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  // Child avatars will always use this over their own size
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Child avatars will prefer this prop (if set) over their own
  square: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  // Child avatars will prefer this variant over their own
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_0__constants_components__["_69" /* NAME_AVATAR_GROUP */]); // --- Main component ---
// @vue/component

var BAvatarGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_0__constants_components__["_69" /* NAME_AVATAR_GROUP */],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvAvatarGroup: function getBvAvatarGroup() {
        return _this;
      }
    };
  },
  props: props,
  computed: {
    computedSize: function computedSize() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__avatar__["b" /* computeSize */])(this.size);
    },
    overlapScale: function overlapScale() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_math__["e" /* mathMin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_number__["a" /* toFloat */])(this.overlap, 0), 0), 1) / 2;
    },
    paddingStyle: function paddingStyle() {
      var value = this.computedSize;
      value = value ? "calc(".concat(value, " * ").concat(this.overlapScale, ")") : null;
      return value ? {
        paddingLeft: value,
        paddingRight: value
      } : {};
    }
  },
  render: function render(h) {
    var $inner = h('div', {
      staticClass: 'b-avatar-group-inner',
      style: this.paddingStyle
    }, this.normalizeSlot());
    return h(this.tag, {
      staticClass: 'b-avatar-group',
      attrs: {
        role: 'group'
      }
    }, [$inner]);
  }
});

/***/ }),
/* 329 */
/* exports provided: AvatarPlugin, BAvatar, BAvatarGroup */
/* exports used: AvatarPlugin */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/avatar/index.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__avatar__ = __webpack_require__(/*! ./avatar */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__avatar_group__ = __webpack_require__(/*! ./avatar-group */ 328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BAvatar */
/* unused harmony reexport BAvatarGroup */



var AvatarPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BAvatar: __WEBPACK_IMPORTED_MODULE_0__avatar__["a" /* BAvatar */],
    BAvatarGroup: __WEBPACK_IMPORTED_MODULE_1__avatar_group__["a" /* BAvatarGroup */]
  }
});


/***/ }),
/* 330 */
/* exports provided: BadgePlugin, BBadge */
/* exports used: BadgePlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/badge/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BadgePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(/*! ./badge */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BBadge */


var BadgePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BBadge: __WEBPACK_IMPORTED_MODULE_0__badge__["a" /* BBadge */]
  }
});


/***/ }),
/* 331 */
/* exports provided: props, BBreadcrumbLink */
/* exports used: props, BBreadcrumbLink */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/breadcrumb/breadcrumb-link.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BBreadcrumbLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_6__link_link__["b" /* props */], ['event', 'routerTag'])), {}, {
  ariaCurrent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'location'),
  html: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_66" /* NAME_BREADCRUMB_LINK */]); // --- Main component ---
// @vue/component

var BBreadcrumbLink = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_66" /* NAME_BREADCRUMB_LINK */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var suppliedProps = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var active = suppliedProps.active;
    var tag = active ? 'span' : __WEBPACK_IMPORTED_MODULE_6__link_link__["a" /* BLink */];
    var componentData = {
      attrs: {
        'aria-current': active ? suppliedProps.ariaCurrent : null
      },
      props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["c" /* pluckProps */])(props, suppliedProps)
    };

    if (!children) {
      componentData.domProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(suppliedProps.html, suppliedProps.text);
    }

    return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, componentData), children);
  }
});

/***/ }),
/* 332 */
/* exports provided: props, BBreadcrumb */
/* exports used: BBreadcrumb */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/breadcrumb/breadcrumb.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BBreadcrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__breadcrumb_item__ = __webpack_require__(/*! ./breadcrumb-item */ 208);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])({
  items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["o" /* PROP_TYPE_ARRAY */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_67" /* NAME_BREADCRUMB */]); // --- Main component ---
// @vue/component

var BBreadcrumb = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_67" /* NAME_BREADCRUMB */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var items = props.items; // Build child nodes from items, if given

    var childNodes = children;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["c" /* isArray */])(items)) {
      var activeDefined = false;
      childNodes = items.map(function (item, idx) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["d" /* isObject */])(item)) {
          item = {
            text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_string__["a" /* toString */])(item)
          };
        } // Copy the value here so we can normalize it


        var _item = item,
            active = _item.active;

        if (active) {
          activeDefined = true;
        } // Auto-detect active by position in list


        if (!active && !activeDefined) {
          active = idx + 1 === items.length;
        }

        return h(__WEBPACK_IMPORTED_MODULE_6__breadcrumb_item__["a" /* BBreadcrumbItem */], {
          props: _objectSpread(_objectSpread({}, item), {}, {
            active: active
          })
        });
      });
    }

    return h('ol', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'breadcrumb'
    }), childNodes);
  }
});

/***/ }),
/* 333 */
/* exports provided: BreadcrumbPlugin, BBreadcrumb, BBreadcrumbItem, BBreadcrumbLink */
/* exports used: BreadcrumbPlugin */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/breadcrumb/index.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__breadcrumb__ = __webpack_require__(/*! ./breadcrumb */ 332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breadcrumb_item__ = __webpack_require__(/*! ./breadcrumb-item */ 208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__ = __webpack_require__(/*! ./breadcrumb-link */ 331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BBreadcrumb */
/* unused harmony reexport BBreadcrumbItem */
/* unused harmony reexport BBreadcrumbLink */




var BreadcrumbPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BBreadcrumb: __WEBPACK_IMPORTED_MODULE_0__breadcrumb__["a" /* BBreadcrumb */],
    BBreadcrumbItem: __WEBPACK_IMPORTED_MODULE_1__breadcrumb_item__["a" /* BBreadcrumbItem */],
    BBreadcrumbLink: __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["b" /* BBreadcrumbLink */]
  }
});


/***/ }),
/* 334 */
/* exports provided: props, BButtonGroup */
/* exports used: BButtonGroup */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/button-group/button-group.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BButtonGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_button__ = __webpack_require__(/*! ../button/button */ 85);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["k" /* pick */])(__WEBPACK_IMPORTED_MODULE_5__button_button__["b" /* props */], ['size'])), {}, {
  ariaRole: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'group'),
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  vertical: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_62" /* NAME_BUTTON_GROUP */]); // --- Main component ---
// @vue/component

var BButtonGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_62" /* NAME_BUTTON_GROUP */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: _defineProperty({
        'btn-group': !props.vertical,
        'btn-group-vertical': props.vertical
      }, "btn-group-".concat(props.size), props.size),
      attrs: {
        role: props.ariaRole
      }
    }), children);
  }
});

/***/ }),
/* 335 */
/* exports provided: ButtonGroupPlugin, BButtonGroup */
/* exports used: ButtonGroupPlugin */
/*!**************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/button-group/index.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonGroupPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_group__ = __webpack_require__(/*! ./button-group */ 334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BButtonGroup */


var ButtonGroupPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BButtonGroup: __WEBPACK_IMPORTED_MODULE_0__button_group__["a" /* BButtonGroup */],
    BBtnGroup: __WEBPACK_IMPORTED_MODULE_0__button_group__["a" /* BButtonGroup */]
  }
});


/***/ }),
/* 336 */
/* exports provided: props, BButtonToolbar */
/* exports used: BButtonToolbar */
/*!*************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/button-toolbar/button-toolbar.js ***!
  \*************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BButtonToolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);







 // --- Constants ---

var ITEM_SELECTOR = ['.btn:not(.disabled):not([disabled]):not(.dropdown-item)', '.form-control:not(.disabled):not([disabled])', 'select:not(.disabled):not([disabled])', 'input[type="checkbox"]:not(.disabled)', 'input[type="radio"]:not(.disabled)'].join(','); // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  justify: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  keyNav: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_61" /* NAME_BUTTON_TOOLBAR */]); // --- Main component ---
// @vue/component

var BButtonToolbar = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_61" /* NAME_BUTTON_TOOLBAR */],
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  mounted: function mounted() {
    // Pre-set the tabindexes if the markup does not include
    // `tabindex="-1"` on the toolbar items
    if (this.keyNav) {
      this.getItems();
    }
  },
  methods: {
    getItems: function getItems() {
      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["w" /* selectAll */])(ITEM_SELECTOR, this.$el); // Ensure `tabindex="-1"` is set on every item

      items.forEach(function (item) {
        item.tabIndex = -1;
      });
      return items.filter(function (el) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["c" /* isVisible */])(el);
      });
    },
    focusFirst: function focusFirst() {
      var items = this.getItems();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["n" /* attemptFocus */])(items[0]);
    },
    focusPrev: function focusPrev(event) {
      var items = this.getItems();
      var index = items.indexOf(event.target);

      if (index > -1) {
        items = items.slice(0, index).reverse();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["n" /* attemptFocus */])(items[0]);
      }
    },
    focusNext: function focusNext(event) {
      var items = this.getItems();
      var index = items.indexOf(event.target);

      if (index > -1) {
        items = items.slice(index + 1);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["n" /* attemptFocus */])(items[0]);
      }
    },
    focusLast: function focusLast() {
      var items = this.getItems().reverse();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["n" /* attemptFocus */])(items[0]);
    },
    onFocusin: function onFocusin(event) {
      var $el = this.$el;

      if (event.target === $el && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["b" /* contains */])($el, event.relatedTarget)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["f" /* stopEvent */])(event);
        this.focusFirst(event);
      }
    },
    onKeydown: function onKeydown(event) {
      var keyCode = event.keyCode,
          shiftKey = event.shiftKey;

      if (keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["e" /* CODE_UP */] || keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["c" /* CODE_LEFT */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["f" /* stopEvent */])(event);
        shiftKey ? this.focusFirst(event) : this.focusPrev(event);
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["f" /* CODE_DOWN */] || keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["d" /* CODE_RIGHT */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["f" /* stopEvent */])(event);
        shiftKey ? this.focusLast(event) : this.focusNext(event);
      }
    }
  },
  render: function render(h) {
    var keyNav = this.keyNav;
    return h('div', {
      staticClass: 'btn-toolbar',
      class: {
        'justify-content-between': this.justify
      },
      attrs: {
        role: 'toolbar',
        tabindex: keyNav ? '0' : null
      },
      on: keyNav ? {
        focusin: this.onFocusin,
        keydown: this.onKeydown
      } : {}
    }, [this.normalizeSlot()]);
  }
});

/***/ }),
/* 337 */
/* exports provided: ButtonToolbarPlugin, BButtonToolbar */
/* exports used: ButtonToolbarPlugin */
/*!****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/button-toolbar/index.js ***!
  \****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonToolbarPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_toolbar__ = __webpack_require__(/*! ./button-toolbar */ 336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BButtonToolbar */


var ButtonToolbarPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BButtonToolbar: __WEBPACK_IMPORTED_MODULE_0__button_toolbar__["a" /* BButtonToolbar */],
    BBtnToolbar: __WEBPACK_IMPORTED_MODULE_0__button_toolbar__["a" /* BButtonToolbar */]
  }
});


/***/ }),
/* 338 */
/* exports provided: ButtonPlugin, BButton, BButtonClose */
/* exports used: ButtonPlugin */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/button/index.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(/*! ./button */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_close__ = __webpack_require__(/*! ./button-close */ 107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BButton */
/* unused harmony reexport BButtonClose */



var ButtonPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BButton: __WEBPACK_IMPORTED_MODULE_0__button__["a" /* BButton */],
    BBtn: __WEBPACK_IMPORTED_MODULE_0__button__["a" /* BButton */],
    BButtonClose: __WEBPACK_IMPORTED_MODULE_1__button_close__["a" /* BButtonClose */],
    BBtnClose: __WEBPACK_IMPORTED_MODULE_1__button_close__["a" /* BButtonClose */]
  }
});


/***/ }),
/* 339 */
/* exports provided: CalendarPlugin, BCalendar */
/* exports used: CalendarPlugin */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/calendar/index.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar__ = __webpack_require__(/*! ./calendar */ 209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BCalendar */


var CalendarPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BCalendar: __WEBPACK_IMPORTED_MODULE_0__calendar__["a" /* BCalendar */]
  }
});


/***/ }),
/* 340 */
/* exports provided: props, BCardGroup */
/* exports used: BCardGroup */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-group.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  columns: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  deck: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_58" /* NAME_CARD_GROUP */]); // --- Main component ---
// @vue/component

var BCardGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_58" /* NAME_CARD_GROUP */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: props.deck ? 'card-deck' : props.columns ? 'card-columns' : 'card-group'
    }), children);
  }
});

/***/ }),
/* 341 */
/* exports provided: props, BCardImgLazy */
/* exports used: BCardImgLazy */
/*!**************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-img-lazy.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardImgLazy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_img__ = __webpack_require__(/*! ../image/img */ 119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__image_img_lazy__ = __webpack_require__(/*! ../image/img-lazy */ 223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_img__ = __webpack_require__(/*! ./card-img */ 165);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_5__image_img_lazy__["b" /* props */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(__WEBPACK_IMPORTED_MODULE_4__image_img__["b" /* props */]))), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_6__card_img__["b" /* props */], ['src', 'alt', 'width', 'height']))), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_54" /* NAME_CARD_IMG_LAZY */]); // --- Main component ---
// @vue/component

var BCardImgLazy = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_54" /* NAME_CARD_IMG_LAZY */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    var baseClass = 'card-img';

    if (props.top) {
      baseClass += '-top';
    } else if (props.right || props.end) {
      baseClass += '-right';
    } else if (props.bottom) {
      baseClass += '-bottom';
    } else if (props.left || props.start) {
      baseClass += '-left';
    }

    return h(__WEBPACK_IMPORTED_MODULE_5__image_img_lazy__["a" /* BImgLazy */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      class: [baseClass],
      // Exclude `left` and `right` props before passing to `<b-img-lazy>`
      props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["m" /* omit */])(props, ['left', 'right'])
    }));
  }
});

/***/ }),
/* 342 */
/* exports provided: props, BCardText */
/* exports used: BCardText */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card-text.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCardText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  textTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'p')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_52" /* NAME_CARD_TEXT */]); // --- Main component ---
// @vue/component

var BCardText = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_52" /* NAME_CARD_TEXT */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h(props.textTag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'card-text'
    }), children);
  }
});

/***/ }),
/* 343 */
/* exports provided: props, BCard */
/* exports used: BCard */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/card.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_card__ = __webpack_require__(/*! ../../mixins/card */ 181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__card_body__ = __webpack_require__(/*! ./card-body */ 210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__card_header__ = __webpack_require__(/*! ./card-header */ 212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__card_footer__ = __webpack_require__(/*! ./card-footer */ 211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__card_img__ = __webpack_require__(/*! ./card-img */ 165);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













 // --- Props ---

var cardImgProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["g" /* copyProps */])(__WEBPACK_IMPORTED_MODULE_12__card_img__["b" /* props */], __WEBPACK_IMPORTED_MODULE_7__utils_props__["h" /* prefixPropName */].bind(null, 'img'));
cardImgProps.imgSrc.required = false;
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__card_body__["b" /* props */]), __WEBPACK_IMPORTED_MODULE_10__card_header__["b" /* props */]), __WEBPACK_IMPORTED_MODULE_11__card_footer__["b" /* props */]), cardImgProps), __WEBPACK_IMPORTED_MODULE_8__mixins_card__["a" /* props */]), {}, {
  align: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  noBody: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_57" /* NAME_CARD */]); // --- Main component ---
// @vue/component

var BCard = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_57" /* NAME_CARD */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots;
    var imgSrc = props.imgSrc,
        imgLeft = props.imgLeft,
        imgRight = props.imgRight,
        imgStart = props.imgStart,
        imgEnd = props.imgEnd,
        imgBottom = props.imgBottom,
        header = props.header,
        headerHtml = props.headerHtml,
        footer = props.footer,
        footerHtml = props.footerHtml,
        align = props.align,
        textVariant = props.textVariant,
        bgVariant = props.bgVariant,
        borderVariant = props.borderVariant;
    var $scopedSlots = scopedSlots || {};
    var $slots = slots();
    var slotScope = {};
    var $imgFirst = h();
    var $imgLast = h();

    if (imgSrc) {
      var $img = h(__WEBPACK_IMPORTED_MODULE_12__card_img__["a" /* BCardImg */], {
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["c" /* pluckProps */])(cardImgProps, props, __WEBPACK_IMPORTED_MODULE_7__utils_props__["f" /* unprefixPropName */].bind(null, 'img'))
      });

      if (imgBottom) {
        $imgLast = $img;
      } else {
        $imgFirst = $img;
      }
    }

    var $header = h();
    var hasHeaderSlot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["u" /* SLOT_NAME_HEADER */], $scopedSlots, $slots);

    if (hasHeaderSlot || header || headerHtml) {
      $header = h(__WEBPACK_IMPORTED_MODULE_10__card_header__["a" /* BCardHeader */], {
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["c" /* pluckProps */])(__WEBPACK_IMPORTED_MODULE_10__card_header__["b" /* props */], props),
        domProps: hasHeaderSlot ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_html__["a" /* htmlOrText */])(headerHtml, header)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["u" /* SLOT_NAME_HEADER */], slotScope, $scopedSlots, $slots));
    }

    var $content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], slotScope, $scopedSlots, $slots); // Wrap content in `<card-body>` when `noBody` prop set

    if (!props.noBody) {
      $content = h(__WEBPACK_IMPORTED_MODULE_9__card_body__["a" /* BCardBody */], {
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["c" /* pluckProps */])(__WEBPACK_IMPORTED_MODULE_9__card_body__["b" /* props */], props)
      }, $content); // When the `overlap` prop is set we need to wrap the `<b-card-img>` and `<b-card-body>`
      // into a relative positioned wrapper to don't distract a potential header or footer

      if (props.overlay && imgSrc) {
        $content = h('div', {
          staticClass: 'position-relative'
        }, [$imgFirst, $content, $imgLast]); // Reset image variables since they are already in the wrapper

        $imgFirst = h();
        $imgLast = h();
      }
    }

    var $footer = h();
    var hasFooterSlot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["v" /* SLOT_NAME_FOOTER */], $scopedSlots, $slots);

    if (hasFooterSlot || footer || footerHtml) {
      $footer = h(__WEBPACK_IMPORTED_MODULE_11__card_footer__["a" /* BCardFooter */], {
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["c" /* pluckProps */])(__WEBPACK_IMPORTED_MODULE_11__card_footer__["b" /* props */], props),
        domProps: hasHeaderSlot ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_html__["a" /* htmlOrText */])(footerHtml, footer)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["v" /* SLOT_NAME_FOOTER */], slotScope, $scopedSlots, $slots));
    }

    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'card',
      class: (_class = {
        'flex-row': imgLeft || imgStart,
        'flex-row-reverse': (imgRight || imgEnd) && !(imgLeft || imgStart)
      }, _defineProperty(_class, "text-".concat(align), align), _defineProperty(_class, "bg-".concat(bgVariant), bgVariant), _defineProperty(_class, "border-".concat(borderVariant), borderVariant), _defineProperty(_class, "text-".concat(textVariant), textVariant), _class)
    }), [$imgFirst, $header, $content, $footer, $imgLast]);
  }
});

/***/ }),
/* 344 */
/* exports provided: CardPlugin, BCard, BCardHeader, BCardBody, BCardTitle, BCardSubTitle, BCardFooter, BCardImg, BCardImgLazy, BCardText, BCardGroup */
/* exports used: CardPlugin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/card/index.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(/*! ./card */ 343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_header__ = __webpack_require__(/*! ./card-header */ 212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_body__ = __webpack_require__(/*! ./card-body */ 210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__card_title__ = __webpack_require__(/*! ./card-title */ 214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_sub_title__ = __webpack_require__(/*! ./card-sub-title */ 213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__card_footer__ = __webpack_require__(/*! ./card-footer */ 211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_img__ = __webpack_require__(/*! ./card-img */ 165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card_img_lazy__ = __webpack_require__(/*! ./card-img-lazy */ 341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__card_text__ = __webpack_require__(/*! ./card-text */ 342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__card_group__ = __webpack_require__(/*! ./card-group */ 340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BCard */
/* unused harmony reexport BCardHeader */
/* unused harmony reexport BCardBody */
/* unused harmony reexport BCardTitle */
/* unused harmony reexport BCardSubTitle */
/* unused harmony reexport BCardFooter */
/* unused harmony reexport BCardImg */
/* unused harmony reexport BCardImgLazy */
/* unused harmony reexport BCardText */
/* unused harmony reexport BCardGroup */











var CardPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BCard: __WEBPACK_IMPORTED_MODULE_0__card__["a" /* BCard */],
    BCardHeader: __WEBPACK_IMPORTED_MODULE_1__card_header__["a" /* BCardHeader */],
    BCardBody: __WEBPACK_IMPORTED_MODULE_2__card_body__["a" /* BCardBody */],
    BCardTitle: __WEBPACK_IMPORTED_MODULE_3__card_title__["a" /* BCardTitle */],
    BCardSubTitle: __WEBPACK_IMPORTED_MODULE_4__card_sub_title__["a" /* BCardSubTitle */],
    BCardFooter: __WEBPACK_IMPORTED_MODULE_5__card_footer__["a" /* BCardFooter */],
    BCardImg: __WEBPACK_IMPORTED_MODULE_6__card_img__["a" /* BCardImg */],
    BCardImgLazy: __WEBPACK_IMPORTED_MODULE_7__card_img_lazy__["a" /* BCardImgLazy */],
    BCardText: __WEBPACK_IMPORTED_MODULE_8__card_text__["a" /* BCardText */],
    BCardGroup: __WEBPACK_IMPORTED_MODULE_9__card_group__["a" /* BCardGroup */]
  }
});


/***/ }),
/* 345 */
/* exports provided: props, BCarouselSlide */
/* exports used: BCarouselSlide */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/carousel/carousel-slide.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCarouselSlide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__image_img__ = __webpack_require__(/*! ../image/img */ 119);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













 // --- Props ---

var imgProps = {
  imgAlt: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  imgBlank: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  imgBlankColor: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'transparent'),
  imgHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  imgSrc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  imgWidth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */])
};
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_10__mixins_id__["a" /* props */]), imgProps), {}, {
  background: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  caption: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  captionHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  captionTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'h3'),
  contentTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  contentVisibleUp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  textHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  textTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'p')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_49" /* NAME_CAROUSEL_SLIDE */]); // --- Main component ---
// @vue/component

var BCarouselSlide = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_49" /* NAME_CAROUSEL_SLIDE */],
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_11__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inject: {
    getBvCarousel: {
      // Explicitly disable touch if not a child of carousel
      default: function _default() {
        return function () {
          return {
            noTouch: true
          };
        };
      }
    }
  },
  props: props,
  computed: {
    bvCarousel: function bvCarousel() {
      return this.getBvCarousel();
    },
    contentClasses: function contentClasses() {
      return [this.contentVisibleUp ? 'd-none' : '', this.contentVisibleUp ? "d-".concat(this.contentVisibleUp, "-block") : ''];
    },
    computedWidth: function computedWidth() {
      // Use local width, or try parent width
      return this.imgWidth || this.bvCarousel.imgWidth || null;
    },
    computedHeight: function computedHeight() {
      // Use local height, or try parent height
      return this.imgHeight || this.bvCarousel.imgHeight || null;
    }
  },
  render: function render(h) {
    var $img = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["_9" /* SLOT_NAME_IMG */]);

    if (!$img && (this.imgSrc || this.imgBlank)) {
      var on = {}; // Touch support event handler

      /* istanbul ignore if: difficult to test in JSDOM */

      if (!this.bvCarousel.noTouch && __WEBPACK_IMPORTED_MODULE_2__constants_env__["i" /* HAS_TOUCH_SUPPORT */]) {
        on.dragstart = function (event) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["f" /* stopEvent */])(event, {
            propagation: false
          });
        };
      }

      $img = h(__WEBPACK_IMPORTED_MODULE_12__image_img__["a" /* BImg */], {
        props: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["c" /* pluckProps */])(imgProps, this.$props, __WEBPACK_IMPORTED_MODULE_9__utils_props__["f" /* unprefixPropName */].bind(null, 'img'))), {}, {
          width: this.computedWidth,
          height: this.computedHeight,
          fluidGrow: true,
          block: true
        }),
        on: on
      });
    }

    var $contentChildren = [// Caption
    this.caption || this.captionHtml ? h(this.captionTag, {
      domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_html__["a" /* htmlOrText */])(this.captionHtml, this.caption)
    }) : false, // Text
    this.text || this.textHtml ? h(this.textTag, {
      domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_html__["a" /* htmlOrText */])(this.textHtml, this.text)
    }) : false, // Children
    this.normalizeSlot() || false];
    var $content = h();

    if ($contentChildren.some(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */])) {
      $content = h(this.contentTag, {
        staticClass: 'carousel-caption',
        class: this.contentClasses
      }, $contentChildren.map(function ($child) {
        return $child || h();
      }));
    }

    return h('div', {
      staticClass: 'carousel-item',
      style: {
        background: this.background || this.bvCarousel.background || null
      },
      attrs: {
        id: this.safeId(),
        role: 'listitem'
      }
    }, [$img, $content]);
  }
});

/***/ }),
/* 346 */
/* exports provided: props, BCarousel */
/* exports used: BCarousel */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/carousel/carousel.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCarousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_noop__ = __webpack_require__(/*! ../../utils/noop */ 256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_observe_dom__ = __webpack_require__(/*! ../../utils/observe-dom */ 185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_5__constants_props__["l" /* PROP_TYPE_NUMBER */],
  defaultValue: 0
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // Slide directional classes


var DIRECTION = {
  next: {
    dirClass: 'carousel-item-left',
    overlayClass: 'carousel-item-next'
  },
  prev: {
    dirClass: 'carousel-item-right',
    overlayClass: 'carousel-item-prev'
  }
}; // Fallback Transition duration (with a little buffer) in ms

var TRANS_DURATION = 600 + 50; // Time for mouse compat events to fire after touch

var TOUCH_EVENT_COMPAT_WAIT = 500; // Number of pixels to consider touch move a swipe

var SWIPE_THRESHOLD = 40; // PointerEvent pointer types

var PointerType = {
  TOUCH: 'touch',
  PEN: 'pen'
}; // Transition Event names

var TransitionEndEvents = {
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  OTransition: 'otransitionend oTransitionEnd',
  transition: 'transitionend'
}; // --- Helper methods ---
// Return the browser specific transitionEnd event name

var getTransitionEndEvent = function getTransitionEndEvent(el) {
  for (var name in TransitionEndEvents) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["i" /* isUndefined */])(el.style[name])) {
      return TransitionEndEvents[name];
    }
  } // Fallback

  /* istanbul ignore next */


  return null;
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__mixins_id__["a" /* props */]), modelProps), {}, {
  background: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  controls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Enable cross-fade animation instead of slide animation
  fade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Sniffed by carousel-slide
  imgHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  // Sniffed by carousel-slide
  imgWidth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  indicators: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  interval: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["l" /* PROP_TYPE_NUMBER */], 5000),
  labelGotoSlide: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Goto slide'),
  labelIndicators: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Select a slide to display'),
  labelNext: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Next slide'),
  labelPrev: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'Previous slide'),
  // Disable slide/fade animation
  noAnimation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Disable pause on hover
  noHoverPause: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Sniffed by carousel-slide
  noTouch: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Disable wrapping/looping when start/end is reached
  noWrap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_50" /* NAME_CAROUSEL */]); // --- Main component ---
// @vue/component

var BCarousel = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_50" /* NAME_CAROUSEL */],
  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_17__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvCarousel: function getBvCarousel() {
        return _this;
      }
    };
  },
  props: props,
  data: function data() {
    return {
      index: this[MODEL_PROP_NAME] || 0,
      isSliding: false,
      transitionEndEvent: null,
      slides: [],
      direction: null,
      isPaused: !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(this.interval, 0) > 0),
      // Touch event handling values
      touchStartX: 0,
      touchDeltaX: 0
    };
  },
  computed: {
    numSlides: function numSlides() {
      return this.slides.length;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      this.setSlide(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(newValue, 0));
    }
  }), _defineProperty(_watch, "interval", function interval(newValue, oldValue) {
    /* istanbul ignore next */
    if (newValue === oldValue) {
      return;
    }

    if (!newValue) {
      // Pausing slide show
      this.pause(false);
    } else {
      // Restarting or Changing interval
      this.pause(true);
      this.start(false);
    }
  }), _defineProperty(_watch, "isPaused", function isPaused(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.$emit(newValue ? __WEBPACK_IMPORTED_MODULE_3__constants_events__["_3" /* EVENT_NAME_PAUSED */] : __WEBPACK_IMPORTED_MODULE_3__constants_events__["_4" /* EVENT_NAME_UNPAUSED */]);
    }
  }), _defineProperty(_watch, "index", function index(to, from) {
    /* istanbul ignore next */
    if (to === from || this.isSliding) {
      return;
    }

    this.doSlide(to, from);
  }), _watch),
  created: function created() {
    // Create private non-reactive props
    this.$_interval = null;
    this.$_animationTimeout = null;
    this.$_touchTimeout = null;
    this.$_observer = null; // Set initial paused state

    this.isPaused = !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(this.interval, 0) > 0);
  },
  mounted: function mounted() {
    // Cache current browser transitionend event name
    this.transitionEndEvent = getTransitionEndEvent(this.$el) || null; // Get all slides

    this.updateSlides(); // Observe child changes so we can update slide list

    this.setObserver(true);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearInterval();
    this.clearAnimationTimeout();
    this.clearTouchTimeout();
    this.setObserver(false);
  },
  methods: {
    clearInterval: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.$_interval);
      this.$_interval = null;
    }),
    clearAnimationTimeout: function clearAnimationTimeout() {
      clearTimeout(this.$_animationTimeout);
      this.$_animationTimeout = null;
    },
    clearTouchTimeout: function clearTouchTimeout() {
      clearTimeout(this.$_touchTimeout);
      this.$_touchTimeout = null;
    },
    setObserver: function setObserver() {
      var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$_observer && this.$_observer.disconnect();
      this.$_observer = null;

      if (on) {
        this.$_observer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_observe_dom__["a" /* observeDom */])(this.$refs.inner, this.updateSlides.bind(this), {
          subtree: false,
          childList: true,
          attributes: true,
          attributeFilter: ['id']
        });
      }
    },
    // Set slide
    setSlide: function setSlide(slide) {
      var _this2 = this;

      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // Don't animate when page is not visible

      /* istanbul ignore if: difficult to test */
      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] && document.visibilityState && document.hidden) {
        return;
      }

      var noWrap = this.noWrap;
      var numSlides = this.numSlides; // Make sure we have an integer (you never know!)

      slide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["c" /* mathFloor */])(slide); // Don't do anything if nothing to slide to

      if (numSlides === 0) {
        return;
      } // Don't change slide while transitioning, wait until transition is done


      if (this.isSliding) {
        // Schedule slide after sliding complete
        this.$once(__WEBPACK_IMPORTED_MODULE_3__constants_events__["_5" /* EVENT_NAME_SLIDING_END */], function () {
          // Wrap in `requestAF()` to allow the slide to properly finish to avoid glitching
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* requestAF */])(function () {
            return _this2.setSlide(slide, direction);
          });
        });
        return;
      }

      this.direction = direction; // Set new slide index
      // Wrap around if necessary (if no-wrap not enabled)

      this.index = slide >= numSlides ? noWrap ? numSlides - 1 : 0 : slide < 0 ? noWrap ? 0 : numSlides - 1 : slide; // Ensure the v-model is synched up if no-wrap is enabled
      // and user tried to slide pass either ends

      if (noWrap && this.index !== slide && this.index !== this[MODEL_PROP_NAME]) {
        this.$emit(MODEL_EVENT_NAME, this.index);
      }
    },
    // Previous slide
    prev: function prev() {
      this.setSlide(this.index - 1, 'prev');
    },
    // Next slide
    next: function next() {
      this.setSlide(this.index + 1, 'next');
    },
    // Pause auto rotation
    pause: function pause(event) {
      if (!event) {
        this.isPaused = true;
      }

      this.clearInterval();
    },
    // Start auto rotate slides
    start: function start(event) {
      if (!event) {
        this.isPaused = false;
      }
      /* istanbul ignore next: most likely will never happen, but just in case */


      this.clearInterval(); // Don't start if no interval, or less than 2 slides

      if (this.interval && this.numSlides > 1) {
        this.$_interval = setInterval(this.next, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["a" /* mathMax */])(1000, this.interval));
      }
    },
    // Restart auto rotate slides when focus/hover leaves the carousel

    /* istanbul ignore next */
    restart: function restart() {
      if (!this.$el.contains(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["B" /* getActiveElement */])())) {
        this.start();
      }
    },
    doSlide: function doSlide(to, from) {
      var _this3 = this;

      var isCycling = Boolean(this.interval); // Determine sliding direction

      var direction = this.calcDirection(this.direction, from, to);
      var overlayClass = direction.overlayClass;
      var dirClass = direction.dirClass; // Determine current and next slides

      var currentSlide = this.slides[from];
      var nextSlide = this.slides[to]; // Don't do anything if there aren't any slides to slide to

      if (!currentSlide || !nextSlide) {
        /* istanbul ignore next */
        return;
      } // Start animating


      this.isSliding = true;

      if (isCycling) {
        this.pause(false);
      }

      this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["_6" /* EVENT_NAME_SLIDING_START */], to); // Update v-model

      this.$emit(MODEL_EVENT_NAME, this.index);

      if (this.noAnimation) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* addClass */])(nextSlide, 'active');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* removeClass */])(currentSlide, 'active');
        this.isSliding = false; // Notify ourselves that we're done sliding (slid)

        this.$nextTick(function () {
          return _this3.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["_5" /* EVENT_NAME_SLIDING_END */], to);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* addClass */])(nextSlide, overlayClass); // Trigger a reflow of next slide

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["H" /* reflow */])(nextSlide);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* addClass */])(currentSlide, dirClass);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* addClass */])(nextSlide, dirClass); // Transition End handler

        var called = false;
        /* istanbul ignore next: difficult to test */

        var onceTransEnd = function onceTransEnd() {
          if (called) {
            return;
          }

          called = true;
          /* istanbul ignore if: transition events cant be tested in JSDOM */

          if (_this3.transitionEndEvent) {
            var events = _this3.transitionEndEvent.split(/\s+/);

            events.forEach(function (event) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["c" /* eventOff */])(nextSlide, event, onceTransEnd, __WEBPACK_IMPORTED_MODULE_3__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
            });
          }

          _this3.clearAnimationTimeout();

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* removeClass */])(nextSlide, dirClass);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* removeClass */])(nextSlide, overlayClass);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* addClass */])(nextSlide, 'active');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* removeClass */])(currentSlide, 'active');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* removeClass */])(currentSlide, dirClass);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* removeClass */])(currentSlide, overlayClass);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(currentSlide, 'aria-current', 'false');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(nextSlide, 'aria-current', 'true');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(currentSlide, 'aria-hidden', 'true');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(nextSlide, 'aria-hidden', 'false');
          _this3.isSliding = false;
          _this3.direction = null; // Notify ourselves that we're done sliding (slid)

          _this3.$nextTick(function () {
            return _this3.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["_5" /* EVENT_NAME_SLIDING_END */], to);
          });
        }; // Set up transitionend handler

        /* istanbul ignore if: transition events cant be tested in JSDOM */


        if (this.transitionEndEvent) {
          var events = this.transitionEndEvent.split(/\s+/);
          events.forEach(function (event) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["b" /* eventOn */])(nextSlide, event, onceTransEnd, __WEBPACK_IMPORTED_MODULE_3__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
          });
        } // Fallback to setTimeout()


        this.$_animationTimeout = setTimeout(onceTransEnd, TRANS_DURATION);
      }

      if (isCycling) {
        this.start(false);
      }
    },
    // Update slide list
    updateSlides: function updateSlides() {
      this.pause(true); // Get all slides as DOM elements

      this.slides = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["w" /* selectAll */])('.carousel-item', this.$refs.inner);
      var numSlides = this.slides.length; // Keep slide number in range

      var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["a" /* mathMax */])(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["e" /* mathMin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["c" /* mathFloor */])(this.index), numSlides - 1));
      this.slides.forEach(function (slide, idx) {
        var n = idx + 1;

        if (idx === index) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* addClass */])(slide, 'active');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(slide, 'aria-current', 'true');
        } else {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["q" /* removeClass */])(slide, 'active');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(slide, 'aria-current', 'false');
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(slide, 'aria-posinset', String(n));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* setAttr */])(slide, 'aria-setsize', String(numSlides));
      }); // Set slide as active

      this.setSlide(index);
      this.start(this.isPaused);
    },
    calcDirection: function calcDirection() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var curIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var nextIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (!direction) {
        return nextIndex > curIndex ? DIRECTION.next : DIRECTION.prev;
      }

      return DIRECTION[direction];
    },
    handleClick: function handleClick(event, fn) {
      var keyCode = event.keyCode;

      if (event.type === 'click' || keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["b" /* CODE_SPACE */] || keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["a" /* CODE_ENTER */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event);
        fn();
      }
    },

    /* istanbul ignore next: JSDOM doesn't support touch events */
    handleSwipe: function handleSwipe() {
      var absDeltaX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["g" /* mathAbs */])(this.touchDeltaX);

      if (absDeltaX <= SWIPE_THRESHOLD) {
        return;
      }

      var direction = absDeltaX / this.touchDeltaX; // Reset touch delta X
      // https://github.com/twbs/bootstrap/pull/28558

      this.touchDeltaX = 0;

      if (direction > 0) {
        // Swipe left
        this.prev();
      } else if (direction < 0) {
        // Swipe right
        this.next();
      }
    },

    /* istanbul ignore next: JSDOM doesn't support touch events */
    touchStart: function touchStart(event) {
      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["k" /* HAS_POINTER_EVENT_SUPPORT */] && PointerType[event.pointerType.toUpperCase()]) {
        this.touchStartX = event.clientX;
      } else if (!__WEBPACK_IMPORTED_MODULE_2__constants_env__["k" /* HAS_POINTER_EVENT_SUPPORT */]) {
        this.touchStartX = event.touches[0].clientX;
      }
    },

    /* istanbul ignore next: JSDOM doesn't support touch events */
    touchMove: function touchMove(event) {
      // Ensure swiping with one touch and not pinching
      if (event.touches && event.touches.length > 1) {
        this.touchDeltaX = 0;
      } else {
        this.touchDeltaX = event.touches[0].clientX - this.touchStartX;
      }
    },

    /* istanbul ignore next: JSDOM doesn't support touch events */
    touchEnd: function touchEnd(event) {
      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["k" /* HAS_POINTER_EVENT_SUPPORT */] && PointerType[event.pointerType.toUpperCase()]) {
        this.touchDeltaX = event.clientX - this.touchStartX;
      }

      this.handleSwipe(); // If it's a touch-enabled device, mouseenter/leave are fired as
      // part of the mouse compatibility events on first tap - the carousel
      // would stop cycling until user tapped out of it;
      // here, we listen for touchend, explicitly pause the carousel
      // (as if it's the second time we tap on it, mouseenter compat event
      // is NOT fired) and after a timeout (to allow for mouse compatibility
      // events to fire) we explicitly restart cycling

      this.pause(false);
      this.clearTouchTimeout();
      this.$_touchTimeout = setTimeout(this.start, TOUCH_EVENT_COMPAT_WAIT + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["a" /* mathMax */])(1000, this.interval));
    }
  },
  render: function render(h) {
    var _this4 = this;

    var indicators = this.indicators,
        background = this.background,
        noAnimation = this.noAnimation,
        noHoverPause = this.noHoverPause,
        noTouch = this.noTouch,
        index = this.index,
        isSliding = this.isSliding,
        pause = this.pause,
        restart = this.restart,
        touchStart = this.touchStart,
        touchEnd = this.touchEnd;
    var idInner = this.safeId('__BV_inner_'); // Wrapper for slides

    var $inner = h('div', {
      staticClass: 'carousel-inner',
      attrs: {
        id: idInner,
        role: 'list'
      },
      ref: 'inner'
    }, [this.normalizeSlot()]); // Prev and next controls

    var $controls = h();

    if (this.controls) {
      var makeControl = function makeControl(direction, label, handler) {
        var handlerWrapper = function handlerWrapper(event) {
          /* istanbul ignore next */
          if (!isSliding) {
            _this4.handleClick(event, handler);
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event, {
              propagation: false
            });
          }
        };

        return h('a', {
          staticClass: "carousel-control-".concat(direction),
          attrs: {
            href: '#',
            role: 'button',
            'aria-controls': idInner,
            'aria-disabled': isSliding ? 'true' : null
          },
          on: {
            click: handlerWrapper,
            keydown: handlerWrapper
          }
        }, [h('span', {
          staticClass: "carousel-control-".concat(direction, "-icon"),
          attrs: {
            'aria-hidden': 'true'
          }
        }), h('span', {
          class: 'sr-only'
        }, [label])]);
      };

      $controls = [makeControl('prev', this.labelPrev, this.prev), makeControl('next', this.labelNext, this.next)];
    } // Indicators


    var $indicators = h('ol', {
      staticClass: 'carousel-indicators',
      directives: [{
        name: 'show',
        value: indicators
      }],
      attrs: {
        id: this.safeId('__BV_indicators_'),
        'aria-hidden': indicators ? 'false' : 'true',
        'aria-label': this.labelIndicators,
        'aria-owns': idInner
      }
    }, this.slides.map(function (slide, i) {
      var handler = function handler(event) {
        _this4.handleClick(event, function () {
          _this4.setSlide(i);
        });
      };

      return h('li', {
        class: {
          active: i === index
        },
        attrs: {
          role: 'button',
          id: _this4.safeId("__BV_indicator_".concat(i + 1, "_")),
          tabindex: indicators ? '0' : '-1',
          'aria-current': i === index ? 'true' : 'false',
          'aria-label': "".concat(_this4.labelGotoSlide, " ").concat(i + 1),
          'aria-describedby': slide.id || null,
          'aria-controls': idInner
        },
        on: {
          click: handler,
          keydown: handler
        },
        key: "slide_".concat(i)
      });
    }));
    var on = {
      mouseenter: noHoverPause ? __WEBPACK_IMPORTED_MODULE_12__utils_noop__["a" /* noop */] : pause,
      mouseleave: noHoverPause ? __WEBPACK_IMPORTED_MODULE_12__utils_noop__["a" /* noop */] : restart,
      focusin: pause,
      focusout: restart,
      keydown: function keydown(event) {
        /* istanbul ignore next */
        if (/input|textarea/i.test(event.target.tagName)) {
          return;
        }

        var keyCode = event.keyCode;

        if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["c" /* CODE_LEFT */] || keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["d" /* CODE_RIGHT */]) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event);

          _this4[keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["c" /* CODE_LEFT */] ? 'prev' : 'next']();
        }
      }
    }; // Touch support event handlers for environment

    if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["i" /* HAS_TOUCH_SUPPORT */] && !noTouch) {
      // Attach appropriate listeners (prepend event name with '&' for passive mode)

      /* istanbul ignore next: JSDOM doesn't support touch events */
      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["k" /* HAS_POINTER_EVENT_SUPPORT */]) {
        on['&pointerdown'] = touchStart;
        on['&pointerup'] = touchEnd;
      } else {
        on['&touchstart'] = touchStart;
        on['&touchmove'] = this.touchMove;
        on['&touchend'] = touchEnd;
      }
    } // Return the carousel


    return h('div', {
      staticClass: 'carousel',
      class: {
        slide: !noAnimation,
        'carousel-fade': !noAnimation && this.fade,
        'pointer-event': __WEBPACK_IMPORTED_MODULE_2__constants_env__["i" /* HAS_TOUCH_SUPPORT */] && __WEBPACK_IMPORTED_MODULE_2__constants_env__["k" /* HAS_POINTER_EVENT_SUPPORT */] && !noTouch
      },
      style: {
        background: background
      },
      attrs: {
        role: 'region',
        id: this.safeId(),
        'aria-busy': isSliding ? 'true' : 'false'
      },
      on: on
    }, [$inner, $controls, $indicators]);
  }
});

/***/ }),
/* 347 */
/* exports provided: CarouselPlugin, BCarousel, BCarouselSlide */
/* exports used: CarouselPlugin */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/carousel/index.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel__ = __webpack_require__(/*! ./carousel */ 346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__carousel_slide__ = __webpack_require__(/*! ./carousel-slide */ 345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BCarousel */
/* unused harmony reexport BCarouselSlide */



var CarouselPlugin =
/*#__PURE*/
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BCarousel: __WEBPACK_IMPORTED_MODULE_0__carousel__["a" /* BCarousel */],
    BCarouselSlide: __WEBPACK_IMPORTED_MODULE_1__carousel_slide__["a" /* BCarouselSlide */]
  }
});


/***/ }),
/* 348 */
/* exports provided: props, BCollapse */
/* exports used: BCollapse */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/collapse/collapse.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BCollapse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_classes__ = __webpack_require__(/*! ../../constants/classes */ 944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_bv_collapse__ = __webpack_require__(/*! ./helpers/bv-collapse */ 923);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















 // --- Constants ---

var ROOT_ACTION_EVENT_NAME_TOGGLE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'toggle');
var ROOT_ACTION_EVENT_NAME_REQUEST_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'request-state');
var ROOT_EVENT_NAME_ACCORDION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'accordion');
var ROOT_EVENT_NAME_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'state');
var ROOT_EVENT_NAME_SYNC_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'sync-state');

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_model__["a" /* makeModelMixin */])('visible', {
  type: __WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */],
  defaultValue: false
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_12__mixins_id__["a" /* props */]), modelProps), {}, {
  // If `true` (and `visible` is `true` on mount), animate initially visible
  accordion: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  appear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  isNav: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */]); // --- Main component ---
// @vue/component

var BCollapse = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */],
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_14__mixins_normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_listen_on_root__["a" /* listenOnRootMixin */]],
  props: props,
  data: function data() {
    return {
      show: this[MODEL_PROP_NAME],
      transitioning: false
    };
  },
  computed: {
    classObject: function classObject() {
      var transitioning = this.transitioning;
      return {
        'navbar-collapse': this.isNav,
        collapse: !transitioning,
        show: this.show && !transitioning
      };
    },
    slotScope: function slotScope() {
      var _this = this;

      return {
        visible: this.show,
        close: function close() {
          _this.show = false;
        }
      };
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    if (newValue !== this.show) {
      this.show = newValue;
    }
  }), _defineProperty(_watch, "show", function show(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.emitState();
    }
  }), _watch),
  created: function created() {
    this.show = this[MODEL_PROP_NAME];
  },
  mounted: function mounted() {
    var _this2 = this;

    this.show = this[MODEL_PROP_NAME]; // Listen for toggle events to open/close us

    this.listenOnRoot(ROOT_ACTION_EVENT_NAME_TOGGLE, this.handleToggleEvent); // Listen to other collapses for accordion events

    this.listenOnRoot(ROOT_EVENT_NAME_ACCORDION, this.handleAccordionEvent);

    if (this.isNav) {
      // Set up handlers
      this.setWindowEvents(true);
      this.handleResize();
    }

    this.$nextTick(function () {
      _this2.emitState();
    }); // Listen for "Sync state" requests from `v-b-toggle`

    this.listenOnRoot(ROOT_ACTION_EVENT_NAME_REQUEST_STATE, function (id) {
      if (id === _this2.safeId()) {
        _this2.$nextTick(_this2.emitSync);
      }
    });
  },
  updated: function updated() {
    // Emit a private event every time this component updates to ensure
    // the toggle button is in sync with the collapse's state
    // It is emitted regardless if the visible state changes
    this.emitSync();
  },

  /* istanbul ignore next */
  deactivated: function deactivated() {
    if (this.isNav) {
      this.setWindowEvents(false);
    }
  },

  /* istanbul ignore next */
  activated: function activated() {
    if (this.isNav) {
      this.setWindowEvents(true);
    }

    this.emitSync();
  },
  beforeDestroy: function beforeDestroy() {
    // Trigger state emit if needed
    this.show = false;

    if (this.isNav && __WEBPACK_IMPORTED_MODULE_3__constants_env__["e" /* IS_BROWSER */]) {
      this.setWindowEvents(false);
    }
  },
  methods: {
    setWindowEvents: function setWindowEvents(on) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["e" /* eventOnOff */])(on, window, 'resize', this.handleResize, __WEBPACK_IMPORTED_MODULE_4__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["e" /* eventOnOff */])(on, window, 'orientationchange', this.handleResize, __WEBPACK_IMPORTED_MODULE_4__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
    },
    toggle: function toggle() {
      this.show = !this.show;
    },
    onEnter: function onEnter() {
      this.transitioning = true; // This should be moved out so we can add cancellable events

      this.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["a" /* EVENT_NAME_SHOW */]);
    },
    onAfterEnter: function onAfterEnter() {
      this.transitioning = false;
      this.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["d" /* EVENT_NAME_SHOWN */]);
    },
    onLeave: function onLeave() {
      this.transitioning = true; // This should be moved out so we can add cancellable events

      this.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["e" /* EVENT_NAME_HIDE */]);
    },
    onAfterLeave: function onAfterLeave() {
      this.transitioning = false;
      this.$emit(__WEBPACK_IMPORTED_MODULE_4__constants_events__["b" /* EVENT_NAME_HIDDEN */]);
    },
    emitState: function emitState() {
      var show = this.show,
          accordion = this.accordion;
      var id = this.safeId();
      this.$emit(MODEL_EVENT_NAME, show); // Let `v-b-toggle` know the state of this collapse

      this.emitOnRoot(ROOT_EVENT_NAME_STATE, id, show);

      if (accordion && show) {
        // Tell the other collapses in this accordion to close
        this.emitOnRoot(ROOT_EVENT_NAME_ACCORDION, id, accordion);
      }
    },
    emitSync: function emitSync() {
      // Emit a private event every time this component updates to ensure
      // the toggle button is in sync with the collapse's state
      // It is emitted regardless if the visible state changes
      this.emitOnRoot(ROOT_EVENT_NAME_SYNC_STATE, this.safeId(), this.show);
    },
    checkDisplayBlock: function checkDisplayBlock() {
      // Check to see if the collapse has `display: block !important` set
      // We can't set `display: none` directly on `this.$el`, as it would
      // trigger a new transition to start (or cancel a current one)
      var $el = this.$el;
      var restore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["g" /* hasClass */])($el, __WEBPACK_IMPORTED_MODULE_2__constants_classes__["a" /* CLASS_NAME_SHOW */]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["q" /* removeClass */])($el, __WEBPACK_IMPORTED_MODULE_2__constants_classes__["a" /* CLASS_NAME_SHOW */]);
      var isBlock = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["o" /* getCS */])($el).display === 'block';

      if (restore) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["r" /* addClass */])($el, __WEBPACK_IMPORTED_MODULE_2__constants_classes__["a" /* CLASS_NAME_SHOW */]);
      }

      return isBlock;
    },
    clickHandler: function clickHandler(event) {
      var el = event.target; // If we are in a nav/navbar, close the collapse when non-disabled link clicked

      /* istanbul ignore next: can't test `getComputedStyle()` in JSDOM */

      if (!this.isNav || !el || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["o" /* getCS */])(this.$el).display !== 'block') {
        return;
      } // Only close the collapse if it is not forced to be `display: block !important`


      if ((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["y" /* matches */])(el, '.nav-link,.dropdown-item') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["f" /* closest */])('.nav-link,.dropdown-item', el)) && !this.checkDisplayBlock()) {
        this.show = false;
      }
    },
    handleToggleEvent: function handleToggleEvent(id) {
      if (id === this.safeId()) {
        this.toggle();
      }
    },
    handleAccordionEvent: function handleAccordionEvent(openedId, openAccordion) {
      var accordion = this.accordion,
          show = this.show;

      if (!accordion || accordion !== openAccordion) {
        return;
      }

      var isThis = openedId === this.safeId(); // Open this collapse if not shown or
      // close this collapse if shown

      if (isThis && !show || !isThis && show) {
        this.toggle();
      }
    },
    handleResize: function handleResize() {
      // Handler for orientation/resize to set collapsed state in nav/navbar
      this.show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["o" /* getCS */])(this.$el).display === 'block';
    }
  },
  render: function render(h) {
    var appear = this.appear;
    var $content = h(this.tag, {
      class: this.classObject,
      directives: [{
        name: 'show',
        value: this.show
      }],
      attrs: {
        id: this.safeId()
      },
      on: {
        click: this.clickHandler
      }
    }, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["a" /* SLOT_NAME_DEFAULT */], this.slotScope));
    return h(__WEBPACK_IMPORTED_MODULE_15__helpers_bv_collapse__["a" /* BVCollapse */], {
      props: {
        appear: appear
      },
      on: {
        enter: this.onEnter,
        afterEnter: this.onAfterEnter,
        leave: this.onLeave,
        afterLeave: this.onAfterLeave
      }
    }, [$content]);
  }
});

/***/ }),
/* 349 */
/* exports provided: props, BDropdownDivider */
/* exports used: BDropdownDivider */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown-divider.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdownDivider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'hr')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_45" /* NAME_DROPDOWN_DIVIDER */]); // --- Main component ---
// @vue/component

var BDropdownDivider = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_45" /* NAME_DROPDOWN_DIVIDER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["m" /* omit */])(data, ['attrs']), {
      attrs: {
        role: 'presentation'
      }
    }), [h(props.tag, {
      staticClass: 'dropdown-divider',
      attrs: _objectSpread(_objectSpread({}, data.attrs || {}), {}, {
        role: 'separator',
        'aria-orientation': 'horizontal'
      }),
      ref: 'divider'
    })]);
  }
});

/***/ }),
/* 350 */
/* exports provided: props, BDropdownForm */
/* exports used: BDropdownForm */
/*!******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown-form.js ***!
  \******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdownForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_form__ = __webpack_require__(/*! ../form/form */ 170);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__form_form__["b" /* props */]), {}, {
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  formClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_44" /* NAME_DROPDOWN_FORM */]); // --- Main component ---
// @vue/component

var BDropdownForm = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_44" /* NAME_DROPDOWN_FORM */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        listeners = _ref.listeners,
        children = _ref.children;
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(data, ['attrs', 'on']), {
      attrs: {
        role: 'presentation'
      }
    }), [h(__WEBPACK_IMPORTED_MODULE_5__form_form__["a" /* BForm */], {
      staticClass: 'b-dropdown-form',
      class: [props.formClass, {
        disabled: props.disabled
      }],
      props: props,
      attrs: _objectSpread(_objectSpread({}, data.attrs || {}), {}, {
        disabled: props.disabled,
        // Tab index of -1 for keyboard navigation
        tabindex: props.disabled ? null : '-1'
      }),
      on: listeners,
      ref: 'form'
    }, children)]);
  }
});

/***/ }),
/* 351 */
/* exports provided: props, BDropdownGroup */
/* exports used: BDropdownGroup */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown-group.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdownGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["b" /* makePropsConfigurable */])({
  ariaDescribedby: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  header: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerClasses: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  headerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'header'),
  headerVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_43" /* NAME_DROPDOWN_GROUP */]); // --- Main component ---
// @vue/component

var BDropdownGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_43" /* NAME_DROPDOWN_GROUP */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots;
    var id = props.id,
        variant = props.variant,
        header = props.header,
        headerTag = props.headerTag;
    var $slots = slots();
    var $scopedSlots = scopedSlots || {};
    var slotScope = {};
    var headerId = id ? "_bv_".concat(id, "_group_dd_header") : null;
    var $header = h();

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["u" /* SLOT_NAME_HEADER */], $scopedSlots, $slots) || header) {
      $header = h(headerTag, {
        staticClass: 'dropdown-header',
        class: [props.headerClasses, _defineProperty({}, "text-".concat(variant), variant)],
        attrs: {
          id: headerId,
          role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["p" /* isTag */])(headerTag, 'header') ? null : 'heading'
        }
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["u" /* SLOT_NAME_HEADER */], slotScope, $scopedSlots, $slots) || header);
    }

    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["m" /* omit */])(data, ['attrs']), {
      attrs: {
        role: 'presentation'
      }
    }), [$header, h('ul', {
      staticClass: 'list-unstyled',
      attrs: _objectSpread(_objectSpread({}, data.attrs || {}), {}, {
        id: id,
        role: 'group',
        'aria-describedby': [headerId, props.ariaDescribedBy].filter(__WEBPACK_IMPORTED_MODULE_5__utils_identity__["a" /* identity */]).join(' ').trim() || null
      })
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], slotScope, $scopedSlots, $slots))]);
  }
});

/***/ }),
/* 352 */
/* exports provided: props, BDropdownHeader */
/* exports used: BDropdownHeader */
/*!********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown-header.js ***!
  \********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdownHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])({
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'header'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_42" /* NAME_DROPDOWN_HEADER */]); // --- Main component ---
// @vue/component

var BDropdownHeader = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_42" /* NAME_DROPDOWN_HEADER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var tag = props.tag,
        variant = props.variant;
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["m" /* omit */])(data, ['attrs']), {
      attrs: {
        role: 'presentation'
      }
    }), [h(tag, {
      staticClass: 'dropdown-header',
      class: _defineProperty({}, "text-".concat(variant), variant),
      attrs: _objectSpread(_objectSpread({}, data.attrs || {}), {}, {
        id: props.id || null,
        role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["p" /* isTag */])(tag, 'header') ? null : 'heading'
      }),
      ref: 'header'
    }, children)]);
  }
});

/***/ }),
/* 353 */
/* exports provided: props, BDropdownItemButton */
/* exports used: BDropdownItemButton */
/*!*************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown-item-button.js ***!
  \*************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdownItemButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])({
  active: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  activeClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'active'),
  buttonClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_46" /* NAME_DROPDOWN_ITEM_BUTTON */]); // --- Main component ---
// @vue/component

var BDropdownItemButton = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_46" /* NAME_DROPDOWN_ITEM_BUTTON */],
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inject: {
    getBvDropdown: {
      default: function _default() {
        return function () {
          return null;
        };
      }
    }
  },
  inheritAttrs: false,
  props: props,
  computed: {
    bvDropdown: function bvDropdown() {
      return this.getBvDropdown();
    },
    computedAttrs: function computedAttrs() {
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        role: 'menuitem',
        type: 'button',
        disabled: this.disabled
      });
    }
  },
  methods: {
    closeDropdown: function closeDropdown() {
      if (this.bvDropdown) {
        this.bvDropdown.hide(true);
      }
    },
    onClick: function onClick(event) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["x" /* EVENT_NAME_CLICK */], event);
      this.closeDropdown();
    }
  },
  render: function render(h) {
    var _ref;

    var active = this.active,
        variant = this.variant,
        bvAttrs = this.bvAttrs;
    return h('li', {
      class: bvAttrs.class,
      style: bvAttrs.style,
      attrs: {
        role: 'presentation'
      }
    }, [h('button', {
      staticClass: 'dropdown-item',
      class: [this.buttonClass, (_ref = {}, _defineProperty(_ref, this.activeClass, active), _defineProperty(_ref, "text-".concat(variant), variant && !(active || this.disabled)), _ref)],
      attrs: this.computedAttrs,
      on: {
        click: this.onClick
      },
      ref: 'button'
    }, this.normalizeSlot())]);
  }
});

/***/ }),
/* 354 */
/* exports provided: props, BDropdownItem */
/* exports used: BDropdownItem */
/*!******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown-item.js ***!
  \******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdownItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_9__link_link__["b" /* props */], ['event', 'routerTag']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, linkProps), {}, {
  linkClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_47" /* NAME_DROPDOWN_ITEM */]); // --- Main component ---
// @vue/component

var BDropdownItem = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_47" /* NAME_DROPDOWN_ITEM */],
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inject: {
    getBvDropdown: {
      default: function _default() {
        return function () {
          return null;
        };
      }
    }
  },
  inheritAttrs: false,
  props: props,
  computed: {
    bvDropdown: function bvDropdown() {
      return this.getBvDropdown();
    },
    computedAttrs: function computedAttrs() {
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        role: 'menuitem'
      });
    }
  },
  methods: {
    closeDropdown: function closeDropdown() {
      var _this = this;

      // Close on next animation frame to allow <b-link> time to process
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["a" /* requestAF */])(function () {
        if (_this.bvDropdown) {
          _this.bvDropdown.hide(true);
        }
      });
    },
    onClick: function onClick(event) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["x" /* EVENT_NAME_CLICK */], event);
      this.closeDropdown();
    }
  },
  render: function render(h) {
    var linkClass = this.linkClass,
        variant = this.variant,
        active = this.active,
        disabled = this.disabled,
        onClick = this.onClick,
        bvAttrs = this.bvAttrs;
    return h('li', {
      class: bvAttrs.class,
      style: bvAttrs.style,
      attrs: {
        role: 'presentation'
      }
    }, [h(__WEBPACK_IMPORTED_MODULE_9__link_link__["a" /* BLink */], {
      staticClass: 'dropdown-item',
      class: [linkClass, _defineProperty({}, "text-".concat(variant), variant && !(active || disabled))],
      props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["c" /* pluckProps */])(linkProps, this.$props),
      attrs: this.computedAttrs,
      on: {
        click: onClick
      },
      ref: 'item'
    }, this.normalizeSlot())]);
  }
});

/***/ }),
/* 355 */
/* exports provided: props, BDropdownText */
/* exports used: BDropdownText */
/*!******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/dropdown/dropdown-text.js ***!
  \******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BDropdownText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])({
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'p'),
  textClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_41" /* NAME_DROPDOWN_TEXT */]); // --- Main component ---
// @vue/component

var BDropdownText = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_41" /* NAME_DROPDOWN_TEXT */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var tag = props.tag,
        textClass = props.textClass,
        variant = props.variant;
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(data, ['attrs']), {
      attrs: {
        role: 'presentation'
      }
    }), [h(tag, {
      staticClass: 'b-dropdown-text',
      class: [textClass, _defineProperty({}, "text-".concat(variant), variant)],
      props: props,
      attrs: data.attrs || {},
      ref: 'text'
    }, children)]);
  }
});

/***/ }),
/* 356 */
/* exports provided: props, BEmbed */
/* exports used: BEmbed */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/embed/embed.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BEmbed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Constants ---

var TYPES = ['iframe', 'embed', 'video', 'object', 'img', 'b-img', 'b-img-lazy']; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])({
  aspect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], '16by9'),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'iframe', function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(TYPES, value);
  })
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_40" /* NAME_EMBED */]); // --- Main component ---
// @vue/component

var BEmbed = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_40" /* NAME_EMBED */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var aspect = props.aspect;
    return h(props.tag, {
      staticClass: 'embed-responsive',
      class: _defineProperty({}, "embed-responsive-".concat(aspect), aspect),
      ref: data.ref
    }, [h(props.type, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["m" /* omit */])(data, ['ref']), {
      staticClass: 'embed-responsive-item'
    }), children)]);
  }
});

/***/ }),
/* 357 */
/* exports provided: EmbedPlugin, BEmbed */
/* exports used: EmbedPlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/embed/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmbedPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__embed__ = __webpack_require__(/*! ./embed */ 356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BEmbed */


var EmbedPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BEmbed: __WEBPACK_IMPORTED_MODULE_0__embed__["a" /* BEmbed */]
  }
});


/***/ }),
/* 358 */
/* exports provided: props, BVFormBtnLabelControl */
/* exports used: props, BVFormBtnLabelControl */
/*!********************************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-btn-label-control/bv-form-btn-label-control.js ***!
  \********************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BVFormBtnLabelControl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_dropdown__ = __webpack_require__(/*! ../../mixins/dropdown */ 251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_hover_hover__ = __webpack_require__(/*! ../../directives/hover/hover */ 244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
// Private component used by `b-form-datepicker` and `b-form-timepicker`
//
















 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_13__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__mixins_form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__mixins_form_state__["a" /* props */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_9__mixins_dropdown__["a" /* props */], ['disabled'])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_10__mixins_form_control__["a" /* props */], ['autofocus'])), {}, {
  // When `true`, renders a `btn-group` wrapper and visually hides the label
  buttonOnly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Applicable in button mode only
  buttonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary'),
  // This is the value shown in the label
  // Defaults back to `value`
  formattedValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Value placed in `.sr-only` span inside label when value is present
  labelSelected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  lang: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Extra classes to apply to the `dropdown-menu` div
  menuClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  // This is the value placed on the hidden input when no value selected
  placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  readonly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Tri-state prop: `true`, `false` or `null`
  rtl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], null),
  value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], '')
})); // --- Main component ---
// @vue/component

var BVFormBtnLabelControl = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_18" /* NAME_FORM_BUTTON_LABEL_CONTROL */],
  directives: {
    'b-hover': __WEBPACK_IMPORTED_MODULE_15__directives_hover_hover__["a" /* VBHover */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_11__mixins_form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_9__mixins_dropdown__["b" /* dropdownMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    return {
      isHovered: false,
      hasFocus: false
    };
  },
  computed: {
    idButton: function idButton() {
      return this.safeId();
    },
    idLabel: function idLabel() {
      return this.safeId('_value_');
    },
    idMenu: function idMenu() {
      return this.safeId('_dialog_');
    },
    idWrapper: function idWrapper() {
      return this.safeId('_outer_');
    },
    computedDir: function computedDir() {
      return this.rtl === true ? 'rtl' : this.rtl === false ? 'ltr' : null;
    }
  },
  methods: {
    focus: function focus() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["n" /* attemptFocus */])(this.$refs.toggle);
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["A" /* attemptBlur */])(this.$refs.toggle);
      }
    },
    setFocus: function setFocus(event) {
      this.hasFocus = event.type === 'focus';
    },
    handleHover: function handleHover(hovered) {
      this.isHovered = hovered;
    }
  },
  render: function render(h) {
    var _class;

    var idButton = this.idButton,
        idLabel = this.idLabel,
        idMenu = this.idMenu,
        idWrapper = this.idWrapper,
        disabled = this.disabled,
        readonly = this.readonly,
        required = this.required,
        name = this.name,
        state = this.state,
        visible = this.visible,
        size = this.size,
        isHovered = this.isHovered,
        hasFocus = this.hasFocus,
        labelSelected = this.labelSelected,
        buttonVariant = this.buttonVariant,
        buttonOnly = this.buttonOnly;
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_string__["a" /* toString */])(this.value) || '';
    var invalid = state === false || required && !value;
    var btnScope = {
      isHovered: isHovered,
      hasFocus: hasFocus,
      state: state,
      opened: visible
    };
    var $button = h('button', {
      staticClass: 'btn',
      class: (_class = {}, _defineProperty(_class, "btn-".concat(buttonVariant), buttonOnly), _defineProperty(_class, "btn-".concat(size), size), _defineProperty(_class, 'h-auto', !buttonOnly), _defineProperty(_class, 'dropdown-toggle', buttonOnly), _defineProperty(_class, 'dropdown-toggle-no-caret', buttonOnly), _class),
      attrs: {
        id: idButton,
        type: 'button',
        disabled: disabled,
        'aria-haspopup': 'dialog',
        'aria-expanded': visible ? 'true' : 'false',
        'aria-invalid': invalid ? 'true' : null,
        'aria-required': required ? 'true' : null
      },
      directives: [{
        name: 'b-hover',
        value: this.handleHover
      }],
      on: {
        mousedown: this.onMousedown,
        click: this.toggle,
        keydown: this.toggle,
        // Handle ENTER, SPACE and DOWN
        '!focus': this.setFocus,
        '!blur': this.setFocus
      },
      ref: 'toggle'
    }, [this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */]) ? this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */], btnScope) :
    /* istanbul ignore next */
    h(__WEBPACK_IMPORTED_MODULE_16__icons_icons__["_340" /* BIconChevronDown */], {
      props: {
        scale: 1.25
      }
    })]); // Hidden input

    var $hidden = h();

    if (name && !disabled) {
      $hidden = h('input', {
        attrs: {
          type: 'hidden',
          name: name || null,
          form: this.form || null,
          value: value
        }
      });
    } // Dropdown content


    var $menu = h('div', {
      staticClass: 'dropdown-menu',
      class: [this.menuClass, {
        show: visible,
        'dropdown-menu-right': this.right
      }],
      attrs: {
        id: idMenu,
        role: 'dialog',
        tabindex: '-1',
        'aria-modal': 'false',
        'aria-labelledby': idLabel
      },
      on: {
        keydown: this.onKeydown // Handle ESC

      },
      ref: 'menu'
    }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], {
      opened: visible
    })]); // Value label

    var $label = h('label', {
      class: buttonOnly ? 'sr-only' // Hidden in button only mode
      : ['form-control', // Mute the text if showing the placeholder
      {
        'text-muted': !value
      }, this.stateClass, this.sizeFormClass],
      attrs: {
        id: idLabel,
        for: idButton,
        'aria-invalid': invalid ? 'true' : null,
        'aria-required': required ? 'true' : null
      },
      directives: [{
        name: 'b-hover',
        value: this.handleHover
      }],
      on: {
        // Disable bubbling of the click event to
        // prevent menu from closing and re-opening
        '!click':
        /* istanbul ignore next */
        function click(event) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["f" /* stopEvent */])(event, {
            preventDefault: false
          });
        }
      }
    }, [value ? this.formattedValue || value : this.placeholder || '', // Add the selected label for screen readers when a value is provided
    value && labelSelected ? h('bdi', {
      staticClass: 'sr-only'
    }, labelSelected) : '']); // Return the custom form control wrapper

    return h('div', {
      staticClass: 'b-form-btn-label-control dropdown',
      class: [this.directionClass, this.boundaryClass, [{
        'btn-group': buttonOnly,
        'form-control': !buttonOnly,
        focus: hasFocus && !buttonOnly,
        show: visible,
        'is-valid': state === true,
        'is-invalid': state === false
      }, buttonOnly ? null : this.sizeFormClass]],
      attrs: {
        id: idWrapper,
        role: buttonOnly ? null : 'group',
        lang: this.lang || null,
        dir: this.computedDir,
        'aria-disabled': disabled,
        'aria-readonly': readonly && !disabled,
        'aria-labelledby': idLabel,
        'aria-invalid': state === false || required && !value ? 'true' : null,
        'aria-required': required ? 'true' : null
      }
    }, [$button, $hidden, $menu, $label]);
  }
});

/***/ }),
/* 359 */
/* exports provided: props, BFormCheckboxGroup */
/* exports used: BFormCheckboxGroup */
/*!*****************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-checkbox/form-checkbox-group.js ***!
  \*****************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormCheckboxGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_form_radio_check_group__ = __webpack_require__(/*! ../../mixins/form-radio-check-group */ 457);
var _objectSpread2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__mixins_form_radio_check_group__["a" /* props */]), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, __WEBPACK_IMPORTED_MODULE_5__mixins_form_radio_check_group__["c" /* MODEL_PROP_NAME */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["o" /* PROP_TYPE_ARRAY */], [])), _defineProperty(_objectSpread2, "switches", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _objectSpread2))), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_34" /* NAME_FORM_CHECKBOX_GROUP */]); // --- Main component ---
// @vue/component

var BFormCheckboxGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_34" /* NAME_FORM_CHECKBOX_GROUP */],
  // Includes render function
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_form_radio_check_group__["b" /* formRadioCheckGroupMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvCheckGroup: function getBvCheckGroup() {
        return _this;
      }
    };
  },
  props: props,
  computed: {
    isRadioGroup: function isRadioGroup() {
      return false;
    }
  }
});

/***/ }),
/* 360 */
/* exports provided: FormCheckboxPlugin, BFormCheckbox, BFormCheckboxGroup */
/* exports used: FormCheckboxPlugin */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-checkbox/index.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormCheckboxPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_checkbox__ = __webpack_require__(/*! ./form-checkbox */ 217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__ = __webpack_require__(/*! ./form-checkbox-group */ 359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormCheckbox */
/* unused harmony reexport BFormCheckboxGroup */



var FormCheckboxPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormCheckbox: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a" /* BFormCheckbox */],
    BCheckbox: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a" /* BFormCheckbox */],
    BCheck: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a" /* BFormCheckbox */],
    BFormCheckboxGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a" /* BFormCheckboxGroup */],
    BCheckboxGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a" /* BFormCheckboxGroup */],
    BCheckGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a" /* BFormCheckboxGroup */]
  }
});


/***/ }),
/* 361 */
/* exports provided: props, BFormDatepicker */
/* exports used: BFormDatepicker */
/*!***************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-datepicker/form-datepicker.js ***!
  \***************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormDatepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_date__ = __webpack_require__(/*! ../../utils/date */ 254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__button_button__ = __webpack_require__(/*! ../button/button */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__calendar_calendar__ = __webpack_require__(/*! ../calendar/calendar */ 209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_btn_label_control_bv_form_btn_label_control__ = __webpack_require__(/*! ../form-btn-label-control/bv-form-btn-label-control */ 358);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_3__constants_props__["t" /* PROP_TYPE_DATE_STRING */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // --- Props ---


var calendarProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_14__calendar_calendar__["b" /* props */], ['block', 'hidden', 'id', 'noKeyNav', 'roleDescription', 'value', 'width']);
var formBtnLabelControlProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_15__form_btn_label_control_bv_form_btn_label_control__["a" /* props */], ['formattedValue', 'id', 'lang', 'rtl', 'value']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_11__mixins_id__["a" /* props */]), modelProps), calendarProps), formBtnLabelControlProps), {}, {
  // Width of the calendar dropdown
  calendarWidth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], '270px'),
  closeButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  closeButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'outline-secondary'),
  // Dark mode
  dark: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  labelCloseButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Close'),
  labelResetButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Reset'),
  labelTodayButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Select today'),
  noCloseOnSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  resetButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  resetButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'outline-danger'),
  resetValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["t" /* PROP_TYPE_DATE_STRING */]),
  todayButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  todayButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'outline-primary')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_32" /* NAME_FORM_DATEPICKER */]); // --- Main component ---
// @vue/component

var BFormDatepicker = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_32" /* NAME_FORM_DATEPICKER */],
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_id__["b" /* idMixin */], modelMixin],
  props: props,
  data: function data() {
    return {
      // We always use `YYYY-MM-DD` value internally
      localYMD: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["c" /* formatYMD */])(this[MODEL_PROP_NAME]) || '',
      // If the popup is open
      isVisible: false,
      // Context data from BCalendar
      localLocale: null,
      isRTL: false,
      formattedValue: '',
      activeYMD: ''
    };
  },
  computed: {
    calendarYM: function calendarYM() {
      // Returns the calendar year/month
      // Returns the `YYYY-MM` portion of the active calendar date
      return this.activeYMD.slice(0, -3);
    },
    computedLang: function computedLang() {
      return (this.localLocale || '').replace(/-u-.*$/i, '') || null;
    },
    computedResetValue: function computedResetValue() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["c" /* formatYMD */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["d" /* constrainDate */])(this.resetValue)) || '';
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    this.localYMD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["c" /* formatYMD */])(newValue) || '';
  }), _defineProperty(_watch, "localYMD", function localYMD(newValue) {
    // We only update the v-model when the datepicker is open
    if (this.isVisible) {
      this.$emit(MODEL_EVENT_NAME, this.valueAsDate ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["e" /* parseYMD */])(newValue) || null : newValue || '');
    }
  }), _defineProperty(_watch, "calendarYM", function calendarYM(newValue, oldValue) {
    // Displayed calendar month has changed
    // So possibly the calendar height has changed...
    // We need to update popper computed position
    if (newValue !== oldValue && oldValue) {
      try {
        this.$refs.control.updatePopper();
      } catch (_unused) {}
    }
  }), _watch),
  methods: {
    // Public methods
    focus: function focus() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(this.$refs.control);
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["A" /* attemptBlur */])(this.$refs.control);
      }
    },
    // Private methods
    setAndClose: function setAndClose(ymd) {
      var _this = this;

      this.localYMD = ymd; // Close calendar popup, unless `noCloseOnSelect`

      if (!this.noCloseOnSelect) {
        this.$nextTick(function () {
          _this.$refs.control.hide(true);
        });
      }
    },
    onSelected: function onSelected(ymd) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.setAndClose(ymd);
      });
    },
    onInput: function onInput(ymd) {
      if (this.localYMD !== ymd) {
        this.localYMD = ymd;
      }
    },
    onContext: function onContext(ctx) {
      var activeYMD = ctx.activeYMD,
          isRTL = ctx.isRTL,
          locale = ctx.locale,
          selectedYMD = ctx.selectedYMD,
          selectedFormatted = ctx.selectedFormatted;
      this.isRTL = isRTL;
      this.localLocale = locale;
      this.formattedValue = selectedFormatted;
      this.localYMD = selectedYMD;
      this.activeYMD = activeYMD; // Re-emit the context event

      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["z" /* EVENT_NAME_CONTEXT */], ctx);
    },
    onTodayButton: function onTodayButton() {
      // Set to today (or min/max if today is out of range)
      this.setAndClose(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["c" /* formatYMD */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["d" /* constrainDate */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_date__["b" /* createDate */])(), this.min, this.max)));
    },
    onResetButton: function onResetButton() {
      this.setAndClose(this.computedResetValue);
    },
    onCloseButton: function onCloseButton() {
      this.$refs.control.hide(true);
    },
    // Menu handlers
    onShow: function onShow() {
      this.isVisible = true;
    },
    onShown: function onShown() {
      var _this3 = this;

      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(_this3.$refs.calendar);

        _this3.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */]);
      });
    },
    onHidden: function onHidden() {
      this.isVisible = false;
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */]);
    },
    // Render helpers
    defaultButtonFn: function defaultButtonFn(_ref) {
      var isHovered = _ref.isHovered,
          hasFocus = _ref.hasFocus;
      return this.$createElement(isHovered || hasFocus ? __WEBPACK_IMPORTED_MODULE_12__icons_icons__["_220" /* BIconCalendarFill */] : __WEBPACK_IMPORTED_MODULE_12__icons_icons__["_177" /* BIconCalendar */], {
        attrs: {
          'aria-hidden': 'true'
        }
      });
    }
  },
  render: function render(h) {
    var localYMD = this.localYMD,
        disabled = this.disabled,
        readonly = this.readonly,
        dark = this.dark,
        $props = this.$props,
        $scopedSlots = this.$scopedSlots;
    var placeholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["g" /* isUndefinedOrNull */])(this.placeholder) ? this.labelNoDateSelected : this.placeholder; // Optional footer buttons

    var $footer = [];

    if (this.todayButton) {
      var label = this.labelTodayButton;
      $footer.push(h(__WEBPACK_IMPORTED_MODULE_13__button_button__["a" /* BButton */], {
        props: {
          disabled: disabled || readonly,
          size: 'sm',
          variant: this.todayButtonVariant
        },
        attrs: {
          'aria-label': label || null
        },
        on: {
          click: this.onTodayButton
        }
      }, label));
    }

    if (this.resetButton) {
      var _label = this.labelResetButton;
      $footer.push(h(__WEBPACK_IMPORTED_MODULE_13__button_button__["a" /* BButton */], {
        props: {
          disabled: disabled || readonly,
          size: 'sm',
          variant: this.resetButtonVariant
        },
        attrs: {
          'aria-label': _label || null
        },
        on: {
          click: this.onResetButton
        }
      }, _label));
    }

    if (this.closeButton) {
      var _label2 = this.labelCloseButton;
      $footer.push(h(__WEBPACK_IMPORTED_MODULE_13__button_button__["a" /* BButton */], {
        props: {
          disabled: disabled,
          size: 'sm',
          variant: this.closeButtonVariant
        },
        attrs: {
          'aria-label': _label2 || null
        },
        on: {
          click: this.onCloseButton
        }
      }, _label2));
    }

    if ($footer.length > 0) {
      $footer = [h('div', {
        staticClass: 'b-form-date-controls d-flex flex-wrap',
        class: {
          'justify-content-between': $footer.length > 1,
          'justify-content-end': $footer.length < 2
        }
      }, $footer)];
    }

    var $calendar = h(__WEBPACK_IMPORTED_MODULE_14__calendar_calendar__["a" /* BCalendar */], {
      staticClass: 'b-form-date-calendar w-100',
      props: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["c" /* pluckProps */])(calendarProps, $props)), {}, {
        hidden: !this.isVisible,
        value: localYMD,
        valueAsDate: false,
        width: this.calendarWidth
      }),
      on: {
        selected: this.onSelected,
        input: this.onInput,
        context: this.onContext
      },
      scopedSlots: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["k" /* pick */])($scopedSlots, ['nav-prev-decade', 'nav-prev-year', 'nav-prev-month', 'nav-this-month', 'nav-next-month', 'nav-next-year', 'nav-next-decade']),
      key: 'calendar',
      ref: 'calendar'
    }, $footer);
    return h(__WEBPACK_IMPORTED_MODULE_15__form_btn_label_control_bv_form_btn_label_control__["b" /* BVFormBtnLabelControl */], {
      staticClass: 'b-form-datepicker',
      props: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["c" /* pluckProps */])(formBtnLabelControlProps, $props)), {}, {
        formattedValue: localYMD ? this.formattedValue : '',
        id: this.safeId(),
        lang: this.computedLang,
        menuClass: [{
          'bg-dark': dark,
          'text-light': dark
        }, this.menuClass],
        placeholder: placeholder,
        rtl: this.isRTL,
        value: localYMD
      }),
      on: {
        show: this.onShow,
        shown: this.onShown,
        hidden: this.onHidden
      },
      scopedSlots: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */], $scopedSlots[__WEBPACK_IMPORTED_MODULE_4__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */]] || this.defaultButtonFn),
      ref: 'control'
    }, [$calendar]);
  }
});

/***/ }),
/* 362 */
/* exports provided: FormDatepickerPlugin, BFormDatepicker */
/* exports used: FormDatepickerPlugin */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-datepicker/index.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormDatepickerPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_datepicker__ = __webpack_require__(/*! ./form-datepicker */ 361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormDatepicker */


var FormDatepickerPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormDatepicker: __WEBPACK_IMPORTED_MODULE_0__form_datepicker__["a" /* BFormDatepicker */],
    BDatepicker: __WEBPACK_IMPORTED_MODULE_0__form_datepicker__["a" /* BFormDatepicker */]
  }
});


/***/ }),
/* 363 */
/* exports provided: BFormFile */
/* exports used: BFormFile */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-file/form-file.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_safe_types__ = __webpack_require__(/*! ../../constants/safe-types */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_clone_deep__ = __webpack_require__(/*! ../../utils/clone-deep */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_warn__ = __webpack_require__(/*! ../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_form_custom__ = __webpack_require__(/*! ../../mixins/form-custom */ 182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



























 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_model__["a" /* makeModelMixin */])('value', {
  type: [__WEBPACK_IMPORTED_MODULE_4__constants_props__["o" /* PROP_TYPE_ARRAY */], __WEBPACK_IMPORTED_MODULE_7__constants_safe_types__["a" /* File */]],
  defaultValue: null,
  validator: function validator(value) {
    /* istanbul ignore next */
    if (value === '') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_warn__["a" /* warn */])(VALUE_EMPTY_DEPRECATED_MSG, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_31" /* NAME_FORM_FILE */]);
      return true;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["g" /* isUndefinedOrNull */])(value) || isValidValue(value);
  }
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

var VALUE_EMPTY_DEPRECATED_MSG = 'Setting "value"/"v-model" to an empty string for reset is deprecated. Set to "null" instead.'; // --- Helper methods ---

var isValidValue = function isValidValue(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["p" /* isFile */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["c" /* isArray */])(value) && value.every(function (v) {
    return isValidValue(v);
  });
}; // Helper method to "safely" get the entry from a data-transfer item

/* istanbul ignore next: not supported in JSDOM */


var getDataTransferItemEntry = function getDataTransferItemEntry(item) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["a" /* isFunction */])(item.getAsEntry) ? item.getAsEntry() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["a" /* isFunction */])(item.webkitGetAsEntry) ? item.webkitGetAsEntry() : null;
}; // Drop handler function to get all files

/* istanbul ignore next: not supported in JSDOM */


var getAllFileEntries = function getAllFileEntries(dataTransferItemList) {
  var traverseDirectories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return Promise.all(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["a" /* from */])(dataTransferItemList).filter(function (item) {
    return item.kind === 'file';
  }).map(function (item) {
    var entry = getDataTransferItemEntry(item);

    if (entry) {
      if (entry.isDirectory && traverseDirectories) {
        return getAllFileEntriesInDirectory(entry.createReader(), "".concat(entry.name, "/"));
      } else if (entry.isFile) {
        return new Promise(function (resolve) {
          entry.file(function (file) {
            file.$path = '';
            resolve(file);
          });
        });
      }
    }

    return null;
  }).filter(__WEBPACK_IMPORTED_MODULE_12__utils_identity__["a" /* identity */]));
}; // Get all the file entries (recursive) in a directory

/* istanbul ignore next: not supported in JSDOM */


var getAllFileEntriesInDirectory = function getAllFileEntriesInDirectory(directoryReader) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return new Promise(function (resolve) {
    var entryPromises = [];

    var readDirectoryEntries = function readDirectoryEntries() {
      directoryReader.readEntries(function (entries) {
        if (entries.length === 0) {
          resolve(Promise.all(entryPromises).then(function (entries) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["e" /* flatten */])(entries);
          }));
        } else {
          entryPromises.push(Promise.all(entries.map(function (entry) {
            if (entry) {
              if (entry.isDirectory) {
                return getAllFileEntriesInDirectory(entry.createReader(), "".concat(path).concat(entry.name, "/"));
              } else if (entry.isFile) {
                return new Promise(function (resolve) {
                  entry.file(function (file) {
                    file.$path = "".concat(path).concat(file.name);
                    resolve(file);
                  });
                });
              }
            }

            return null;
          }).filter(__WEBPACK_IMPORTED_MODULE_12__utils_identity__["a" /* identity */])));
          readDirectoryEntries();
        }
      });
    };

    readDirectoryEntries();
  });
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_24__mixins_id__["a" /* props */]), modelProps), __WEBPACK_IMPORTED_MODULE_21__mixins_form_control__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_22__mixins_form_custom__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_23__mixins_form_state__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_26__mixins_form_size__["a" /* props */]), {}, {
  accept: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], ''),
  browseText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Browse'),
  // Instruct input to capture from camera
  capture: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  directory: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  dropPlaceholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Drop files here'),
  fileNameFormatter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  multiple: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noDrop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noDropPlaceholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Not allowed'),
  // TODO:
  //   Should we deprecate this and only support flat file structures?
  //   Nested file structures are only supported when files are dropped
  //   A Chromium "bug" prevents `webkitEntries` from being populated
  //   on the file input's `change` event and is marked as "WontFix"
  //   Mozilla implemented the behavior the same way as Chromium
  //   See: https://bugs.chromium.org/p/chromium/issues/detail?id=138987
  //   See: https://bugzilla.mozilla.org/show_bug.cgi?id=1326031
  noTraverse: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'No file chosen')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_31" /* NAME_FORM_FILE */]); // --- Main component ---
// @vue/component

var BFormFile = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_31" /* NAME_FORM_FILE */],
  mixins: [__WEBPACK_IMPORTED_MODULE_20__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_24__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_25__mixins_normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_21__mixins_form_control__["b" /* formControlMixin */], __WEBPACK_IMPORTED_MODULE_23__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_22__mixins_form_custom__["b" /* formCustomMixin */], __WEBPACK_IMPORTED_MODULE_25__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      files: [],
      dragging: false,
      // IE 11 doesn't respect setting `event.dataTransfer.dropEffect`,
      // so we handle it ourselves as well
      // https://stackoverflow.com/a/46915971/2744776
      dropAllowed: !this.noDrop,
      hasFocus: false
    };
  },
  computed: {
    // Convert `accept` to an array of `[{ RegExpr, isMime }, ...]`
    computedAccept: function computedAccept() {
      var accept = this.accept;
      accept = (accept || '').trim().split(/[,\s]+/).filter(__WEBPACK_IMPORTED_MODULE_12__utils_identity__["a" /* identity */]); // Allow any file type/extension

      if (accept.length === 0) {
        return null;
      }

      return accept.map(function (extOrType) {
        var prop = 'name';
        var startMatch = '^';
        var endMatch = '$';

        if (__WEBPACK_IMPORTED_MODULE_6__constants_regex__["B" /* RX_EXTENSION */].test(extOrType)) {
          // File extension /\.ext$/
          startMatch = '';
        } else {
          // MIME type /^mime\/.+$/ or /^mime\/type$/
          prop = 'type';

          if (__WEBPACK_IMPORTED_MODULE_6__constants_regex__["C" /* RX_STAR */].test(extOrType)) {
            endMatch = '.+$'; // Remove trailing `*`

            extOrType = extOrType.slice(0, -1);
          }
        } // Escape all RegExp special chars


        extOrType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_string__["g" /* escapeRegExp */])(extOrType);
        var rx = new RegExp("".concat(startMatch).concat(extOrType).concat(endMatch));
        return {
          rx: rx,
          prop: prop
        };
      });
    },
    computedCapture: function computedCapture() {
      var capture = this.capture;
      return capture === true || capture === '' ? true : capture || null;
    },
    computedAttrs: function computedAttrs() {
      var name = this.name,
          disabled = this.disabled,
          required = this.required,
          form = this.form,
          computedCapture = this.computedCapture,
          accept = this.accept,
          multiple = this.multiple,
          directory = this.directory;
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        type: 'file',
        id: this.safeId(),
        name: name,
        disabled: disabled,
        required: required,
        form: form || null,
        capture: computedCapture,
        accept: accept || null,
        multiple: multiple,
        directory: directory,
        webkitdirectory: directory,
        'aria-required': required ? 'true' : null
      });
    },
    computedFileNameFormatter: function computedFileNameFormatter() {
      var fileNameFormatter = this.fileNameFormatter;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_props__["d" /* hasPropFunction */])(fileNameFormatter) ? fileNameFormatter : this.defaultFileNameFormatter;
    },
    clonedFiles: function clonedFiles() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_clone_deep__["a" /* cloneDeep */])(this.files);
    },
    flattenedFiles: function flattenedFiles() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["f" /* flattenDeep */])(this.files);
    },
    fileNames: function fileNames() {
      return this.flattenedFiles.map(function (file) {
        return file.name;
      });
    },
    labelContent: function labelContent() {
      // Draging active

      /* istanbul ignore next: used by drag/drop which can't be tested easily */
      if (this.dragging && !this.noDrop) {
        return (// TODO: Add additional scope with file count, and other not-allowed reasons
          this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_5__constants_slots__["Z" /* SLOT_NAME_DROP_PLACEHOLDER */], {
            allowed: this.dropAllowed
          }) || (this.dropAllowed ? this.dropPlaceholder : this.$createElement('span', {
            staticClass: 'text-danger'
          }, this.noDropPlaceholder))
        );
      } // No file chosen


      if (this.files.length === 0) {
        return this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_5__constants_slots__["_0" /* SLOT_NAME_PLACEHOLDER */]) || this.placeholder;
      }

      var flattenedFiles = this.flattenedFiles,
          clonedFiles = this.clonedFiles,
          fileNames = this.fileNames,
          computedFileNameFormatter = this.computedFileNameFormatter; // There is a slot for formatting the files/names

      if (this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_5__constants_slots__["_1" /* SLOT_NAME_FILE_NAME */])) {
        return this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_5__constants_slots__["_1" /* SLOT_NAME_FILE_NAME */], {
          files: flattenedFiles,
          filesTraversed: clonedFiles,
          names: fileNames
        });
      }

      return computedFileNameFormatter(flattenedFiles, clonedFiles, fileNames);
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    if (!newValue || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["c" /* isArray */])(newValue) && newValue.length === 0) {
      this.reset();
    }
  }), _defineProperty(_watch, "files", function files(newValue, oldValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      var multiple = this.multiple,
          noTraverse = this.noTraverse;
      var files = !multiple || noTraverse ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["f" /* flattenDeep */])(newValue) : newValue;
      this.$emit(MODEL_EVENT_NAME, multiple ? files : files[0] || null);
    }
  }), _watch),
  created: function created() {
    // Create private non-reactive props
    this.$_form = null;
  },
  mounted: function mounted() {
    // Listen for form reset events, to reset the file input
    var $form = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_dom__["f" /* closest */])('form', this.$el);

    if ($form) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["b" /* eventOn */])($form, 'reset', this.reset, __WEBPACK_IMPORTED_MODULE_3__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
      this.$_form = $form;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var $form = this.$_form;

    if ($form) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["c" /* eventOff */])($form, 'reset', this.reset, __WEBPACK_IMPORTED_MODULE_3__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    }
  },
  methods: {
    isFileValid: function isFileValid(file) {
      if (!file) {
        return false;
      }

      var accept = this.computedAccept;
      return accept ? accept.some(function (a) {
        return a.rx.test(file[a.prop]);
      }) : true;
    },
    isFilesArrayValid: function isFilesArrayValid(files) {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["c" /* isArray */])(files) ? files.every(function (file) {
        return _this.isFileValid(file);
      }) : this.isFileValid(files);
    },
    defaultFileNameFormatter: function defaultFileNameFormatter(flattenedFiles, clonedFiles, fileNames) {
      return fileNames.join(', ');
    },
    setFiles: function setFiles(files) {
      // Reset the dragging flags
      this.dropAllowed = !this.noDrop;
      this.dragging = false; // Set the selected files

      this.files = this.multiple ? this.directory ? files : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["f" /* flattenDeep */])(files) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["f" /* flattenDeep */])(files).slice(0, 1);
    },

    /* istanbul ignore next: used by Drag/Drop */
    setInputFiles: function setInputFiles(files) {
      // Try an set the file input files array so that `required`
      // constraint works for dropped files (will fail in IE11 though)
      // To be used only when dropping files
      try {
        // Firefox < 62 workaround exploiting https://bugzilla.mozilla.org/show_bug.cgi?id=1422655
        var dataTransfer = new ClipboardEvent('').clipboardData || new DataTransfer(); // Add flattened files to temp `dataTransfer` object to get a true `FileList` array

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["f" /* flattenDeep */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_clone_deep__["a" /* cloneDeep */])(files)).forEach(function (file) {
          // Make sure to remove the custom `$path` attribute
          delete file.$path;
          dataTransfer.items.add(file);
        });
        this.$refs.input.files = dataTransfer.files;
      } catch (_unused) {}
    },
    reset: function reset() {
      // IE 11 doesn't support setting `$input.value` to `''` or `null`
      // So we use this little extra hack to reset the value, just in case
      // This also appears to work on modern browsers as well
      // Wrapped in try in case IE 11 or mobile Safari crap out
      try {
        var $input = this.$refs.input;
        $input.value = '';
        $input.type = '';
        $input.type = 'file';
      } catch (_unused2) {}

      this.files = [];
    },
    handleFiles: function handleFiles(files) {
      var isDrop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (isDrop) {
        // When dropped, make sure to filter files with the internal `accept` logic
        var filteredFiles = files.filter(this.isFilesArrayValid); // Only update files when we have any after filtering

        if (filteredFiles.length > 0) {
          this.setFiles(filteredFiles); // Try an set the file input's files array so that `required`
          // constraint works for dropped files (will fail in IE 11 though)

          this.setInputFiles(filteredFiles);
        }
      } else {
        // We always update the files from the `change` event
        this.setFiles(files);
      }
    },
    focusHandler: function focusHandler(event) {
      // Bootstrap v4 doesn't have focus styling for custom file input
      // Firefox has a `[type=file]:focus ~ sibling` selector issue,
      // so we add a `focus` class to get around these bugs
      if (this.plain || event.type === 'focusout') {
        this.hasFocus = false;
      } else {
        // Add focus styling for custom file input
        this.hasFocus = true;
      }
    },
    onChange: function onChange(event) {
      var _this2 = this;

      var type = event.type,
          target = event.target,
          _event$dataTransfer = event.dataTransfer,
          dataTransfer = _event$dataTransfer === void 0 ? {} : _event$dataTransfer;
      var isDrop = type === 'drop'; // Always emit original event

      this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["w" /* EVENT_NAME_CHANGE */], event);
      var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["a" /* from */])(dataTransfer.items || []);

      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["f" /* HAS_PROMISE_SUPPORT */] && items.length > 0 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_inspect__["e" /* isNull */])(getDataTransferItemEntry(items[0]))) {
        // Drop handling for modern browsers
        // Supports nested directory structures in `directory` mode

        /* istanbul ignore next: not supported in JSDOM */
        getAllFileEntries(items, this.directory).then(function (files) {
          return _this2.handleFiles(files, isDrop);
        });
      } else {
        // Standard file input handling (native file input change event),
        // or fallback drop mode (IE 11 / Opera) which don't support `directory` mode
        var files = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_array__["a" /* from */])(target.files || dataTransfer.files || []).map(function (file) {
          // Add custom `$path` property to each file (to be consistent with drop mode)
          file.$path = file.webkitRelativePath || '';
          return file;
        });
        this.handleFiles(files, isDrop);
      }
    },
    onDragenter: function onDragenter(event) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event);
      this.dragging = true;
      var _event$dataTransfer2 = event.dataTransfer,
          dataTransfer = _event$dataTransfer2 === void 0 ? {} : _event$dataTransfer2; // Early exit when the input or dropping is disabled

      if (this.noDrop || this.disabled || !this.dropAllowed) {
        // Show deny feedback

        /* istanbul ignore next: not supported in JSDOM */
        dataTransfer.dropEffect = 'none';
        this.dropAllowed = false;
        return;
      }
      /* istanbul ignore next: not supported in JSDOM */


      dataTransfer.dropEffect = 'copy';
    },
    // Note this event fires repeatedly while the mouse is over the dropzone at
    // intervals in the milliseconds, so avoid doing much processing in here
    onDragover: function onDragover(event) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event);
      this.dragging = true;
      var _event$dataTransfer3 = event.dataTransfer,
          dataTransfer = _event$dataTransfer3 === void 0 ? {} : _event$dataTransfer3; // Early exit when the input or dropping is disabled

      if (this.noDrop || this.disabled || !this.dropAllowed) {
        // Show deny feedback

        /* istanbul ignore next: not supported in JSDOM */
        dataTransfer.dropEffect = 'none';
        this.dropAllowed = false;
        return;
      }
      /* istanbul ignore next: not supported in JSDOM */


      dataTransfer.dropEffect = 'copy';
    },
    onDragleave: function onDragleave(event) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event);
      this.$nextTick(function () {
        _this3.dragging = false; // Reset `dropAllowed` to default

        _this3.dropAllowed = !_this3.noDrop;
      });
    },
    // Triggered by a file drop onto drop target
    onDrop: function onDrop(event) {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_events__["f" /* stopEvent */])(event);
      this.dragging = false; // Early exit when the input or dropping is disabled

      if (this.noDrop || this.disabled || !this.dropAllowed) {
        this.$nextTick(function () {
          // Reset `dropAllowed` to default
          _this4.dropAllowed = !_this4.noDrop;
        });
        return;
      }

      this.onChange(event);
    }
  },
  render: function render(h) {
    var custom = this.custom,
        plain = this.plain,
        size = this.size,
        dragging = this.dragging,
        stateClass = this.stateClass,
        bvAttrs = this.bvAttrs; // Form Input

    var $input = h('input', {
      class: [{
        'form-control-file': plain,
        'custom-file-input': custom,
        focus: custom && this.hasFocus
      }, stateClass],
      // With IE 11, the input gets in the "way" of the drop events,
      // so we move it out of the way by putting it behind the label
      // Bootstrap v4 has it in front
      style: custom ? {
        zIndex: -5
      } : {},
      attrs: this.computedAttrs,
      on: {
        change: this.onChange,
        focusin: this.focusHandler,
        focusout: this.focusHandler,
        reset: this.reset
      },
      ref: 'input'
    });

    if (plain) {
      return $input;
    } // Overlay label


    var $label = h('label', {
      staticClass: 'custom-file-label',
      class: {
        dragging: dragging
      },
      attrs: {
        for: this.safeId(),
        // This goes away in Bootstrap v5
        'data-browse': this.browseText || null
      }
    }, [h('span', {
      staticClass: 'd-block form-file-text',
      // `pointer-events: none` is used to make sure
      // the drag events fire only on the label
      style: {
        pointerEvents: 'none'
      }
    }, [this.labelContent])]); // Return rendered custom file input

    return h('div', {
      staticClass: 'custom-file b-form-file',
      class: [_defineProperty({}, "b-custom-control-".concat(size), size), stateClass, bvAttrs.class],
      style: bvAttrs.style,
      attrs: {
        id: this.safeId('_BV_file_outer_')
      },
      on: {
        dragenter: this.onDragenter,
        dragover: this.onDragover,
        dragleave: this.onDragleave,
        drop: this.onDrop
      }
    }, [$input, $label]);
  }
});

/***/ }),
/* 364 */
/* exports provided: FormFilePlugin, BFormFile */
/* exports used: FormFilePlugin */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-file/index.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFilePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(/*! ./form-file */ 363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormFile */


var FormFilePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormFile: __WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* BFormFile */],
    BFile: __WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* BFormFile */]
  }
});


/***/ }),
/* 365 */
/* exports provided: generateProps, BFormGroup */
/* exports used: BFormGroup */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-group/form-group.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_config__ = __webpack_require__(/*! ../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_css_escape__ = __webpack_require__(/*! ../../utils/css-escape */ 464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__layout_col__ = __webpack_require__(/*! ../layout/col */ 226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__layout_form_row__ = __webpack_require__(/*! ../layout/form-row */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_form_text__ = __webpack_require__(/*! ../form/form-text */ 169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__form_form_invalid_feedback__ = __webpack_require__(/*! ../form/form-invalid-feedback */ 168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__form_form_valid_feedback__ = __webpack_require__(/*! ../form/form-valid-feedback */ 222);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






















 // --- Constants ---

var INPUTS = ['input', 'select', 'textarea']; // Selector for finding first input in the form group

var INPUT_SELECTOR = INPUTS.map(function (v) {
  return "".concat(v, ":not([disabled])");
}).join(); // A list of interactive elements (tag names) inside `<b-form-group>`'s legend

var LEGEND_INTERACTIVE_ELEMENTS = [].concat(INPUTS, ['a', 'button', 'label']); // --- Props ---
// Prop generator for lazy generation of props

var generateProps = function generateProps() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_15__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_14__mixins_form_state__["a" /* props */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_config__["c" /* getBreakpointsUpCached */])().reduce(function (props, breakpoint) {
    // i.e. 'content-cols', 'content-cols-sm', 'content-cols-md', ...
    props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["e" /* suffixPropName */])(breakpoint, 'contentCols')] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["r" /* PROP_TYPE_BOOLEAN_NUMBER_STRING */]); // i.e. 'label-align', 'label-align-sm', 'label-align-md', ...

    props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["e" /* suffixPropName */])(breakpoint, 'labelAlign')] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]); // i.e. 'label-cols', 'label-cols-sm', 'label-cols-md', ...

    props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["e" /* suffixPropName */])(breakpoint, 'labelCols')] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["r" /* PROP_TYPE_BOOLEAN_NUMBER_STRING */]);
    return props;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["i" /* create */])(null))), {}, {
    description: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
    disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    feedbackAriaLive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'assertive'),
    invalidFeedback: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
    label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
    labelClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
    labelFor: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
    labelSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
    labelSrOnly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    tooltip: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    validFeedback: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
    validated: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
  })), __WEBPACK_IMPORTED_MODULE_0__constants_components__["_30" /* NAME_FORM_GROUP */]);
}; // --- Main component ---
// We do not use `extend()` here as that would evaluate the props
// immediately, which we do not want to happen
// @vue/component

var BFormGroup = {
  name: __WEBPACK_IMPORTED_MODULE_0__constants_components__["_30" /* NAME_FORM_GROUP */],
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_16__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],

  get props() {
    // Allow props to be lazy evaled on first access and
    // then they become a non-getter afterwards
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get#Smart_self-overwriting_lazy_getters
    delete this.props; // eslint-disable-next-line no-return-assign

    return this.props = generateProps();
  },

  data: function data() {
    return {
      ariaDescribedby: null
    };
  },
  computed: {
    contentColProps: function contentColProps() {
      return this.getColProps(this.$props, 'content');
    },
    labelAlignClasses: function labelAlignClasses() {
      return this.getAlignClasses(this.$props, 'label');
    },
    labelColProps: function labelColProps() {
      return this.getColProps(this.$props, 'label');
    },
    isHorizontal: function isHorizontal() {
      // Determine if the form group will be rendered horizontal
      // based on the existence of 'content-col' or 'label-col' props
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["a" /* keys */])(this.contentColProps).length > 0 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["a" /* keys */])(this.labelColProps).length > 0;
    }
  },
  watch: {
    ariaDescribedby: function ariaDescribedby(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateAriaDescribedby(newValue, oldValue);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      // Set `aria-describedby` on the input specified by `labelFor`
      // We do this in a `$nextTick()` to ensure the children have finished rendering
      _this.updateAriaDescribedby(_this.ariaDescribedby);
    });
  },
  methods: {
    getAlignClasses: function getAlignClasses(props, prefix) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_config__["c" /* getBreakpointsUpCached */])().reduce(function (result, breakpoint) {
        var propValue = props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["e" /* suffixPropName */])(breakpoint, "".concat(prefix, "Align"))] || null;

        if (propValue) {
          result.push(['text', breakpoint, propValue].filter(__WEBPACK_IMPORTED_MODULE_9__utils_identity__["a" /* identity */]).join('-'));
        }

        return result;
      }, []);
    },
    getColProps: function getColProps(props, prefix) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_config__["c" /* getBreakpointsUpCached */])().reduce(function (result, breakpoint) {
        var propValue = props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["e" /* suffixPropName */])(breakpoint, "".concat(prefix, "Cols"))]; // Handle case where the prop's value is an empty string,
        // which represents `true`

        propValue = propValue === '' ? true : propValue || false;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["k" /* isBoolean */])(propValue) && propValue !== 'auto') {
          // Convert to column size to number
          propValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(propValue, 0); // Ensure column size is greater than `0`

          propValue = propValue > 0 ? propValue : false;
        } // Add the prop to the list of props to give to `<b-col>`
        // If breakpoint is '' (`${prefix}Cols` is `true`), then we use
        // the 'col' prop to make equal width at 'xs'


        if (propValue) {
          result[breakpoint || (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["k" /* isBoolean */])(propValue) ? 'col' : 'cols')] = propValue;
        }

        return result;
      }, {});
    },
    // Sets the `aria-describedby` attribute on the input if `labelFor` is set
    // Optionally accepts a string of IDs to remove as the second parameter
    // Preserves any `aria-describedby` value(s) user may have on input
    updateAriaDescribedby: function updateAriaDescribedby(newValue, oldValue) {
      var labelFor = this.labelFor;

      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */] && labelFor) {
        // We need to escape `labelFor` since it can be user-provided
        var $input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["h" /* select */])("#".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_css_escape__["a" /* cssEscape */])(labelFor)), this.$refs.content);

        if ($input) {
          var attr = 'aria-describedby';
          var newIds = (newValue || '').split(__WEBPACK_IMPORTED_MODULE_3__constants_regex__["m" /* RX_SPACE_SPLIT */]);
          var oldIds = (oldValue || '').split(__WEBPACK_IMPORTED_MODULE_3__constants_regex__["m" /* RX_SPACE_SPLIT */]); // Update ID list, preserving any original IDs
          // and ensuring the ID's are unique

          var ids = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["i" /* getAttr */])($input, attr) || '').split(__WEBPACK_IMPORTED_MODULE_3__constants_regex__["m" /* RX_SPACE_SPLIT */]).filter(function (id) {
            return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["c" /* arrayIncludes */])(oldIds, id);
          }).concat(newIds).filter(function (id, index, ids) {
            return ids.indexOf(id) === index;
          }).filter(__WEBPACK_IMPORTED_MODULE_9__utils_identity__["a" /* identity */]).join(' ').trim();

          if (ids) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["j" /* setAttr */])($input, attr, ids);
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["k" /* removeAttr */])($input, attr);
          }
        }
      }
    },
    onLegendClick: function onLegendClick(event) {
      // Don't do anything if `labelFor` is set

      /* istanbul ignore next: clicking a label will focus the input, so no need to test */
      if (this.labelFor) {
        return;
      }

      var target = event.target;
      var tagName = target ? target.tagName : ''; // If clicked an interactive element inside legend,
      // we just let the default happen

      /* istanbul ignore next */

      if (LEGEND_INTERACTIVE_ELEMENTS.indexOf(tagName) !== -1) {
        return;
      } // If only a single input, focus it, emulating label behaviour


      var inputs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["w" /* selectAll */])(INPUT_SELECTOR, this.$refs.content).filter(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["c" /* isVisible */]);

      if (inputs.length === 1) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["n" /* attemptFocus */])(inputs[0]);
      }
    }
  },
  render: function render(h) {
    var state = this.computedState,
        feedbackAriaLive = this.feedbackAriaLive,
        isHorizontal = this.isHorizontal,
        labelFor = this.labelFor,
        normalizeSlot = this.normalizeSlot,
        safeId = this.safeId,
        tooltip = this.tooltip;
    var id = safeId();
    var isFieldset = !labelFor;
    var $label = h();
    var labelContent = normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["r" /* SLOT_NAME_LABEL */]) || this.label;
    var labelId = labelContent ? safeId('_BV_label_') : null;

    if (labelContent || isHorizontal) {
      var labelSize = this.labelSize,
          labelColProps = this.labelColProps;
      var labelTag = isFieldset ? 'legend' : 'label';

      if (this.labelSrOnly) {
        if (labelContent) {
          $label = h(labelTag, {
            class: 'sr-only',
            attrs: {
              id: labelId,
              for: labelFor || null
            }
          }, [labelContent]);
        }

        $label = h(isHorizontal ? __WEBPACK_IMPORTED_MODULE_17__layout_col__["a" /* BCol */] : 'div', {
          props: isHorizontal ? labelColProps : {}
        }, [$label]);
      } else {
        $label = h(isHorizontal ? __WEBPACK_IMPORTED_MODULE_17__layout_col__["a" /* BCol */] : labelTag, {
          on: isFieldset ? {
            click: this.onLegendClick
          } : {},
          props: isHorizontal ? _objectSpread(_objectSpread({}, labelColProps), {}, {
            tag: labelTag
          }) : {},
          attrs: {
            id: labelId,
            for: labelFor || null,
            // We add a `tabindex` to legend so that screen readers
            // will properly read the `aria-labelledby` in IE
            tabindex: isFieldset ? '-1' : null
          },
          class: [// Hide the focus ring on the legend
          isFieldset ? 'bv-no-focus-ring' : '', // When horizontal or if a legend is rendered, add 'col-form-label' class
          // for correct sizing as Bootstrap has inconsistent font styling for
          // legend in non-horizontal form groups
          // See: https://github.com/twbs/bootstrap/issues/27805
          isHorizontal || isFieldset ? 'col-form-label' : '', // Emulate label padding top of `0` on legend when not horizontal
          !isHorizontal && isFieldset ? 'pt-0' : '', // If not horizontal and not a legend, we add 'd-block' class to label
          // so that label-align works
          !isHorizontal && !isFieldset ? 'd-block' : '', labelSize ? "col-form-label-".concat(labelSize) : '', this.labelAlignClasses, this.labelClass]
        }, [labelContent]);
      }
    }

    var $invalidFeedback = h();
    var invalidFeedbackContent = normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["W" /* SLOT_NAME_INVALID_FEEDBACK */]) || this.invalidFeedback;
    var invalidFeedbackId = invalidFeedbackContent ? safeId('_BV_feedback_invalid_') : null;

    if (invalidFeedbackContent) {
      $invalidFeedback = h(__WEBPACK_IMPORTED_MODULE_20__form_form_invalid_feedback__["a" /* BFormInvalidFeedback */], {
        props: {
          ariaLive: feedbackAriaLive,
          id: invalidFeedbackId,
          // If state is explicitly `false`, always show the feedback
          state: state,
          tooltip: tooltip
        },
        attrs: {
          tabindex: invalidFeedbackContent ? '-1' : null
        }
      }, [invalidFeedbackContent]);
    }

    var $validFeedback = h();
    var validFeedbackContent = normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["X" /* SLOT_NAME_VALID_FEEDBACK */]) || this.validFeedback;
    var validFeedbackId = validFeedbackContent ? safeId('_BV_feedback_valid_') : null;

    if (validFeedbackContent) {
      $validFeedback = h(__WEBPACK_IMPORTED_MODULE_21__form_form_valid_feedback__["a" /* BFormValidFeedback */], {
        props: {
          ariaLive: feedbackAriaLive,
          id: validFeedbackId,
          // If state is explicitly `true`, always show the feedback
          state: state,
          tooltip: tooltip
        },
        attrs: {
          tabindex: validFeedbackContent ? '-1' : null
        }
      }, [validFeedbackContent]);
    }

    var $description = h();
    var descriptionContent = normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["Y" /* SLOT_NAME_DESCRIPTION */]) || this.description;
    var descriptionId = descriptionContent ? safeId('_BV_description_') : null;

    if (descriptionContent) {
      $description = h(__WEBPACK_IMPORTED_MODULE_19__form_form_text__["a" /* BFormText */], {
        attrs: {
          id: descriptionId,
          tabindex: '-1'
        }
      }, [descriptionContent]);
    } // Update `ariaDescribedby`
    // Screen readers will read out any content linked to by `aria-describedby`
    // even if the content is hidden with `display: none;`, hence we only include
    // feedback IDs if the form group's state is explicitly valid or invalid


    var ariaDescribedby = this.ariaDescribedby = [descriptionId, state === false ? invalidFeedbackId : null, state === true ? validFeedbackId : null].filter(__WEBPACK_IMPORTED_MODULE_9__utils_identity__["a" /* identity */]).join(' ') || null;
    var $content = h(isHorizontal ? __WEBPACK_IMPORTED_MODULE_17__layout_col__["a" /* BCol */] : 'div', {
      props: isHorizontal ? this.contentColProps : {},
      ref: 'content'
    }, [normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["a" /* SLOT_NAME_DEFAULT */], {
      ariaDescribedby: ariaDescribedby,
      descriptionId: descriptionId,
      id: id,
      labelId: labelId
    }) || h(), $invalidFeedback, $validFeedback, $description]); // Return it wrapped in a form group
    // Note: Fieldsets do not support adding `row` or `form-row` directly
    // to them due to browser specific render issues, so we move the `form-row`
    // to an inner wrapper div when horizontal and using a fieldset

    return h(isFieldset ? 'fieldset' : isHorizontal ? __WEBPACK_IMPORTED_MODULE_18__layout_form_row__["a" /* BFormRow */] : 'div', {
      staticClass: 'form-group',
      class: [{
        'was-validated': this.validated
      }, this.stateClass],
      attrs: {
        id: id,
        disabled: isFieldset ? this.disabled : null,
        role: isFieldset ? null : 'group',
        'aria-invalid': this.computedAriaInvalid,
        // Only apply `aria-labelledby` if we are a horizontal fieldset
        // as the legend is no longer a direct child of fieldset
        'aria-labelledby': isFieldset && isHorizontal ? labelId : null
      }
    }, isHorizontal && isFieldset ? [h(__WEBPACK_IMPORTED_MODULE_18__layout_form_row__["a" /* BFormRow */], [$label, $content])] : [$label, $content]);
  }
};

/***/ }),
/* 366 */
/* exports provided: FormGroupPlugin, BFormGroup */
/* exports used: FormGroupPlugin */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-group/index.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormGroupPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_group__ = __webpack_require__(/*! ./form-group */ 365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormGroup */


var FormGroupPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0__form_group__["a" /* BFormGroup */],
    BFormFieldset: __WEBPACK_IMPORTED_MODULE_0__form_group__["a" /* BFormGroup */]
  }
});


/***/ }),
/* 367 */
/* exports provided: props, BFormInput */
/* exports used: BFormInput */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-input/form-input.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_form_selection__ = __webpack_require__(/*! ../../mixins/form-selection */ 459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_form_text__ = __webpack_require__(/*! ../../mixins/form-text */ 460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_form_validity__ = __webpack_require__(/*! ../../mixins/form-validity */ 461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















 // --- Constants ---
// Valid supported input types

var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week']; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_14__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_8__mixins_form_control__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_10__mixins_form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__mixins_form_state__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__mixins_form_text__["a" /* props */]), {}, {
  list: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  max: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  min: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  // Disable mousewheel to prevent wheel from changing values (i.e. number/date)
  noWheel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  step: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'text', function (type) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(TYPES, type);
  })
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_29" /* NAME_FORM_INPUT */]); // --- Main component ---
// @vue/component

var BFormInput = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_29" /* NAME_FORM_INPUT */],
  // Mixin order is important!
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_8__mixins_form_control__["b" /* formControlMixin */], __WEBPACK_IMPORTED_MODULE_10__mixins_form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_11__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_form_text__["b" /* formTextMixin */], __WEBPACK_IMPORTED_MODULE_9__mixins_form_selection__["a" /* formSelectionMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_form_validity__["a" /* formValidityMixin */]],
  props: props,
  computed: {
    localType: function localType() {
      // We only allow certain types
      var type = this.type;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(TYPES, type) ? type : 'text';
    },
    computedAttrs: function computedAttrs() {
      var type = this.localType,
          name = this.name,
          form = this.form,
          disabled = this.disabled,
          placeholder = this.placeholder,
          required = this.required,
          min = this.min,
          max = this.max,
          step = this.step;
      return {
        id: this.safeId(),
        name: name,
        form: form,
        type: type,
        disabled: disabled,
        placeholder: placeholder,
        required: required,
        autocomplete: this.autocomplete || null,
        readonly: this.readonly || this.plaintext,
        min: min,
        max: max,
        step: step,
        list: type !== 'password' ? this.list : null,
        'aria-required': required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid
      };
    },
    computedListeners: function computedListeners() {
      return _objectSpread(_objectSpread({}, this.bvListeners), {}, {
        input: this.onInput,
        change: this.onChange,
        blur: this.onBlur
      });
    }
  },
  watch: {
    noWheel: function noWheel(newValue) {
      this.setWheelStopper(newValue);
    }
  },
  mounted: function mounted() {
    this.setWheelStopper(this.noWheel);
  },

  /* istanbul ignore next */
  deactivated: function deactivated() {
    // Turn off listeners when keep-alive component deactivated

    /* istanbul ignore next */
    this.setWheelStopper(false);
  },

  /* istanbul ignore next */
  activated: function activated() {
    // Turn on listeners (if no-wheel) when keep-alive component activated

    /* istanbul ignore next */
    this.setWheelStopper(this.noWheel);
  },
  beforeDestroy: function beforeDestroy() {
    /* istanbul ignore next */
    this.setWheelStopper(false);
  },
  methods: {
    setWheelStopper: function setWheelStopper(on) {
      var input = this.$el; // We use native events, so that we don't interfere with propagation

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["e" /* eventOnOff */])(on, input, 'focus', this.onWheelFocus);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["e" /* eventOnOff */])(on, input, 'blur', this.onWheelBlur);

      if (!on) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["c" /* eventOff */])(document, 'wheel', this.stopWheel);
      }
    },
    onWheelFocus: function onWheelFocus() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["b" /* eventOn */])(document, 'wheel', this.stopWheel);
    },
    onWheelBlur: function onWheelBlur() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["c" /* eventOff */])(document, 'wheel', this.stopWheel);
    },
    stopWheel: function stopWheel(event) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["f" /* stopEvent */])(event, {
        propagation: false
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["A" /* attemptBlur */])(this.$el);
    }
  },
  render: function render(h) {
    return h('input', {
      class: this.computedClass,
      attrs: this.computedAttrs,
      domProps: {
        value: this.localValue
      },
      on: this.computedListeners,
      ref: 'input'
    });
  }
});

/***/ }),
/* 368 */
/* exports provided: FormInputPlugin, BFormInput */
/* exports used: FormInputPlugin */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-input/index.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormInputPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(/*! ./form-input */ 367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormInput */


var FormInputPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormInput: __WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* BFormInput */],
    BInput: __WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* BFormInput */]
  }
});


/***/ }),
/* 369 */
/* exports provided: props, BFormRadioGroup */
/* exports used: BFormRadioGroup */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-radio/form-radio-group.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormRadioGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check_group__ = __webpack_require__(/*! ../../mixins/form-radio-check-group */ 457);



 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_props__["b" /* makePropsConfigurable */])(__WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check_group__["a" /* props */], __WEBPACK_IMPORTED_MODULE_1__constants_components__["_27" /* NAME_FORM_RADIO_GROUP */]); // --- Main component ---
// @vue/component

var BFormRadioGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_27" /* NAME_FORM_RADIO_GROUP */],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check_group__["b" /* formRadioCheckGroupMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvRadioGroup: function getBvRadioGroup() {
        return _this;
      }
    };
  },
  props: props,
  computed: {
    isRadioGroup: function isRadioGroup() {
      return true;
    }
  }
});

/***/ }),
/* 370 */
/* exports provided: FormRadioPlugin, BFormRadio, BFormRadioGroup */
/* exports used: FormRadioPlugin */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-radio/index.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormRadioPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_radio__ = __webpack_require__(/*! ./form-radio */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_radio_group__ = __webpack_require__(/*! ./form-radio-group */ 369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormRadio */
/* unused harmony reexport BFormRadioGroup */



var FormRadioPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormRadio: __WEBPACK_IMPORTED_MODULE_0__form_radio__["a" /* BFormRadio */],
    BRadio: __WEBPACK_IMPORTED_MODULE_0__form_radio__["a" /* BFormRadio */],
    BFormRadioGroup: __WEBPACK_IMPORTED_MODULE_1__form_radio_group__["a" /* BFormRadioGroup */],
    BRadioGroup: __WEBPACK_IMPORTED_MODULE_1__form_radio_group__["a" /* BFormRadioGroup */]
  }
});


/***/ }),
/* 371 */
/* exports provided: props, BFormRating */
/* exports used: BFormRating */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-rating/form-rating.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormRating; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_locale__ = __webpack_require__(/*! ../../utils/locale */ 184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__icons_icon__ = __webpack_require__(/*! ../../icons/icon */ 138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
























 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */],
  event: __WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

var MIN_STARS = 3;
var DEFAULT_STARS = 5; // --- Helper methods ---

var computeStars = function computeStars(stars) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["a" /* mathMax */])(MIN_STARS, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(stars, DEFAULT_STARS));
};

var clampValue = function clampValue(value, min, max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_math__["e" /* mathMin */])(value, max), min);
}; // --- Helper components ---
// @vue/component


var BVFormRatingStar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_25" /* NAME_FORM_RATING_STAR */],
  mixins: [__WEBPACK_IMPORTED_MODULE_20__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: {
    disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    // If parent is focused
    focused: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    hasClear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    rating: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["l" /* PROP_TYPE_NUMBER */], 0),
    readonly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    star: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["l" /* PROP_TYPE_NUMBER */], 0),
    variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])
  },
  methods: {
    onClick: function onClick(event) {
      if (!this.disabled && !this.readonly) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["_2" /* EVENT_NAME_SELECTED */], this.star);
      }
    }
  },
  render: function render(h) {
    var rating = this.rating,
        star = this.star,
        focused = this.focused,
        hasClear = this.hasClear,
        variant = this.variant,
        disabled = this.disabled,
        readonly = this.readonly;
    var minStar = hasClear ? 0 : 1;
    var type = rating >= star ? 'full' : rating >= star - 0.5 ? 'half' : 'empty';
    var slotScope = {
      variant: variant,
      disabled: disabled,
      readonly: readonly
    };
    return h('span', {
      staticClass: 'b-rating-star',
      class: {
        // When not hovered, we use this class to focus the current (or first) star
        focused: focused && rating === star || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(rating) && star === minStar,
        // We add type classes to we can handle RTL styling
        'b-rating-star-empty': type === 'empty',
        'b-rating-star-half': type === 'half',
        'b-rating-star-full': type === 'full'
      },
      attrs: {
        tabindex: !disabled && !readonly ? '-1' : null
      },
      on: {
        click: this.onClick
      }
    }, [h('span', {
      staticClass: 'b-rating-icon'
    }, [this.normalizeSlot(type, slotScope)])]);
  }
}); // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_19__mixins_id__["a" /* props */]), modelProps), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_21__mixins_form_control__["a" /* props */], ['required', 'autofocus'])), __WEBPACK_IMPORTED_MODULE_18__mixins_form_size__["a" /* props */]), {}, {
  // CSS color string (overrides variant)
  color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  iconClear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'x'),
  iconEmpty: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'star'),
  iconFull: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'star-fill'),
  iconHalf: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'star-half'),
  inline: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Locale for the formatted value (if shown)
  // Defaults to the browser locale. Falls back to `en`
  locale: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  noBorder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  precision: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  readonly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  showClear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  showValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  showValueMax: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  stars: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_STARS, function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(value) >= MIN_STARS;
  }),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_26" /* NAME_FORM_RATING */]); // --- Main component ---
// @vue/component

var BFormRating = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_26" /* NAME_FORM_RATING */],
  components: {
    BIconStar: __WEBPACK_IMPORTED_MODULE_23__icons_icons__["_1149" /* BIconStar */],
    BIconStarHalf: __WEBPACK_IMPORTED_MODULE_23__icons_icons__["_1151" /* BIconStarHalf */],
    BIconStarFill: __WEBPACK_IMPORTED_MODULE_23__icons_icons__["_1150" /* BIconStarFill */],
    BIconX: __WEBPACK_IMPORTED_MODULE_23__icons_icons__["_1306" /* BIconX */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_19__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_18__mixins_form_size__["b" /* formSizeMixin */]],
  props: props,
  data: function data() {
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(this[MODEL_PROP_NAME], null);
    var stars = computeStars(this.stars);
    return {
      localValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value) ? null : clampValue(value, 0, stars),
      hasFocus: false
    };
  },
  computed: {
    computedStars: function computedStars() {
      return computeStars(this.stars);
    },
    computedRating: function computedRating() {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(this.localValue, 0);
      var precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.precision, 3); // We clamp the value between `0` and stars

      return clampValue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(value.toFixed(precision)), 0, this.computedStars);
    },
    computedLocale: function computedLocale() {
      var locales = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["b" /* concat */])(this.locale).filter(__WEBPACK_IMPORTED_MODULE_9__utils_identity__["a" /* identity */]);
      var nf = new Intl.NumberFormat(locales);
      return nf.resolvedOptions().locale;
    },
    isInteractive: function isInteractive() {
      return !this.disabled && !this.readonly;
    },
    isRTL: function isRTL() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_locale__["a" /* isLocaleRTL */])(this.computedLocale);
    },
    formattedRating: function formattedRating() {
      var precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.precision);
      var showValueMax = this.showValueMax;
      var locale = this.computedLocale;
      var formatOptions = {
        notation: 'standard',
        minimumFractionDigits: isNaN(precision) ? 0 : precision,
        maximumFractionDigits: isNaN(precision) ? 3 : precision
      };
      var stars = this.computedStars.toLocaleString(locale);
      var value = this.localValue;
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value) ? showValueMax ? '-' : '' : value.toLocaleString(locale, formatOptions);
      return showValueMax ? "".concat(value, "/").concat(stars) : value;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["a" /* toFloat */])(newValue, null);
      this.localValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(value) ? null : clampValue(value, 0, this.computedStars);
    }
  }), _defineProperty(_watch, "localValue", function localValue(newValue, oldValue) {
    if (newValue !== oldValue && newValue !== (this.value || 0)) {
      this.$emit(MODEL_EVENT_NAME, newValue || null);
    }
  }), _defineProperty(_watch, "disabled", function disabled(newValue) {
    if (newValue) {
      this.hasFocus = false;
      this.blur();
    }
  }), _watch),
  methods: {
    // --- Public methods ---
    focus: function focus() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["n" /* attemptFocus */])(this.$el);
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["A" /* attemptBlur */])(this.$el);
      }
    },
    // --- Private methods ---
    onKeydown: function onKeydown(event) {
      var keyCode = event.keyCode;

      if (this.isInteractive && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_array__["c" /* arrayIncludes */])([__WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["c" /* CODE_LEFT */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["d" /* CODE_RIGHT */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */]], keyCode)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_number__["b" /* toInteger */])(this.localValue, 0);
        var min = this.showClear ? 0 : 1;
        var stars = this.computedStars; // In RTL mode, LEFT/RIGHT are swapped

        var amountRtl = this.isRTL ? -1 : 1;

        if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["c" /* CODE_LEFT */]) {
          this.localValue = clampValue(value - amountRtl, min, stars) || null;
        } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["d" /* CODE_RIGHT */]) {
          this.localValue = clampValue(value + amountRtl, min, stars);
        } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */]) {
          this.localValue = clampValue(value - 1, min, stars) || null;
        } else if (keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */]) {
          this.localValue = clampValue(value + 1, min, stars);
        }
      }
    },
    onSelected: function onSelected(value) {
      if (this.isInteractive) {
        this.localValue = value;
      }
    },
    onFocus: function onFocus(event) {
      this.hasFocus = !this.isInteractive ? false : event.type === 'focus';
    },
    // --- Render methods ---
    renderIcon: function renderIcon(icon) {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_22__icons_icon__["a" /* BIcon */], {
        props: {
          icon: icon,
          variant: this.disabled || this.color ? null : this.variant || null
        }
      });
    },
    iconEmptyFn: function iconEmptyFn() {
      return this.renderIcon(this.iconEmpty);
    },
    iconHalfFn: function iconHalfFn() {
      return this.renderIcon(this.iconHalf);
    },
    iconFullFn: function iconFullFn() {
      return this.renderIcon(this.iconFull);
    },
    iconClearFn: function iconClearFn() {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_22__icons_icon__["a" /* BIcon */], {
        props: {
          icon: this.iconClear
        }
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var disabled = this.disabled,
        readonly = this.readonly,
        name = this.name,
        form = this.form,
        inline = this.inline,
        variant = this.variant,
        color = this.color,
        noBorder = this.noBorder,
        hasFocus = this.hasFocus,
        computedRating = this.computedRating,
        computedStars = this.computedStars,
        formattedRating = this.formattedRating,
        showClear = this.showClear,
        isRTL = this.isRTL,
        isInteractive = this.isInteractive,
        $scopedSlots = this.$scopedSlots;
    var $content = [];

    if (showClear && !disabled && !readonly) {
      var $icon = h('span', {
        staticClass: 'b-rating-icon'
      }, [($scopedSlots[__WEBPACK_IMPORTED_MODULE_5__constants_slots__["S" /* SLOT_NAME_ICON_CLEAR */]] || this.iconClearFn)()]);
      $content.push(h('span', {
        staticClass: 'b-rating-star b-rating-star-clear flex-grow-1',
        class: {
          focused: hasFocus && computedRating === 0
        },
        attrs: {
          tabindex: isInteractive ? '-1' : null
        },
        on: {
          click: function click() {
            return _this.onSelected(null);
          }
        },
        key: 'clear'
      }, [$icon]));
    }

    for (var index = 0; index < computedStars; index++) {
      var value = index + 1;
      $content.push(h(BVFormRatingStar, {
        staticClass: 'flex-grow-1',
        style: color && !disabled ? {
          color: color
        } : {},
        props: {
          rating: computedRating,
          star: value,
          variant: disabled ? null : variant || null,
          disabled: disabled,
          readonly: readonly,
          focused: hasFocus,
          hasClear: showClear
        },
        on: {
          selected: this.onSelected
        },
        scopedSlots: {
          empty: $scopedSlots[__WEBPACK_IMPORTED_MODULE_5__constants_slots__["T" /* SLOT_NAME_ICON_EMPTY */]] || this.iconEmptyFn,
          half: $scopedSlots[__WEBPACK_IMPORTED_MODULE_5__constants_slots__["U" /* SLOT_NAME_ICON_HALF */]] || this.iconHalfFn,
          full: $scopedSlots[__WEBPACK_IMPORTED_MODULE_5__constants_slots__["V" /* SLOT_NAME_ICON_FULL */]] || this.iconFullFn
        },
        key: index
      }));
    }

    if (name) {
      $content.push(h('input', {
        attrs: {
          type: 'hidden',
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_inspect__["e" /* isNull */])(this.localValue) ? '' : computedRating,
          name: name,
          form: form || null
        },
        key: 'hidden'
      }));
    }

    if (this.showValue) {
      $content.push(h('b', {
        staticClass: 'b-rating-value flex-grow-1',
        attrs: {
          'aria-hidden': 'true'
        },
        key: 'value'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(formattedRating)));
    }

    return h('output', {
      staticClass: 'b-rating form-control align-items-center',
      class: [{
        'd-inline-flex': inline,
        'd-flex': !inline,
        'border-0': noBorder,
        disabled: disabled,
        readonly: !disabled && readonly
      }, this.sizeFormClass],
      attrs: {
        id: this.safeId(),
        dir: isRTL ? 'rtl' : 'ltr',
        tabindex: disabled ? null : '0',
        disabled: disabled,
        role: 'slider',
        'aria-disabled': disabled ? 'true' : null,
        'aria-readonly': !disabled && readonly ? 'true' : null,
        'aria-live': 'off',
        'aria-valuemin': showClear ? '0' : '1',
        'aria-valuemax': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(computedStars),
        'aria-valuenow': computedRating ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(computedRating) : null
      },
      on: {
        keydown: this.onKeydown,
        focus: this.onFocus,
        blur: this.onFocus
      }
    }, $content);
  }
});

/***/ }),
/* 372 */
/* exports provided: FormRatingPlugin, BFormRating */
/* exports used: FormRatingPlugin */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-rating/index.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormRatingPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_rating__ = __webpack_require__(/*! ./form-rating */ 371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormRating */


var FormRatingPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormRating: __WEBPACK_IMPORTED_MODULE_0__form_rating__["a" /* BFormRating */],
    BRating: __WEBPACK_IMPORTED_MODULE_0__form_rating__["a" /* BFormRating */]
  }
});


/***/ }),
/* 373 */
/* exports provided: props, BFormSelect */
/* exports used: BFormSelect */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-select/form-select.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_form_custom__ = __webpack_require__(/*! ../../mixins/form-custom */ 182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_model__ = __webpack_require__(/*! ../../mixins/model */ 955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_mixin_options__ = __webpack_require__(/*! ./helpers/mixin-options */ 924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_select_option__ = __webpack_require__(/*! ./form-select-option */ 167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__form_select_option_group__ = __webpack_require__(/*! ./form-select-option-group */ 219);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





















 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_15__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_16__mixins_model__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__mixins_form_control__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__mixins_form_custom__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_13__mixins_form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_14__mixins_form_state__["a" /* props */]), {}, {
  ariaInvalid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  multiple: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Browsers default size to `0`, which shows 4 rows in most browsers in multiple mode
  // Size of `1` can bork out Firefox
  selectSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["l" /* PROP_TYPE_NUMBER */], 0)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_22" /* NAME_FORM_SELECT */]); // --- Main component ---
// @vue/component

var BFormSelect = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_22" /* NAME_FORM_SELECT */],
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_16__mixins_model__["b" /* modelMixin */], __WEBPACK_IMPORTED_MODULE_11__mixins_form_control__["b" /* formControlMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_form_custom__["b" /* formCustomMixin */], __WEBPACK_IMPORTED_MODULE_18__helpers_mixin_options__["a" /* optionsMixin */], __WEBPACK_IMPORTED_MODULE_17__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    return {
      localValue: this[__WEBPACK_IMPORTED_MODULE_16__mixins_model__["c" /* MODEL_PROP_NAME */]]
    };
  },
  computed: {
    computedSelectSize: function computedSelectSize() {
      // Custom selects with a size of zero causes the arrows to be hidden,
      // so dont render the size attribute in this case
      return !this.plain && this.selectSize === 0 ? null : this.selectSize;
    },
    inputClass: function inputClass() {
      return [this.plain ? 'form-control' : 'custom-select', this.size && this.plain ? "form-control-".concat(this.size) : null, this.size && !this.plain ? "custom-select-".concat(this.size) : null, this.stateClass];
    }
  },
  watch: {
    value: function value(newValue) {
      this.localValue = newValue;
    },
    localValue: function localValue() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_16__mixins_model__["d" /* MODEL_EVENT_NAME */], this.localValue);
    }
  },
  methods: {
    focus: function focus() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(this.$refs.input);
    },
    blur: function blur() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["A" /* attemptBlur */])(this.$refs.input);
    },
    onChange: function onChange(event) {
      var _this = this;

      var target = event.target;
      var selectedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["a" /* from */])(target.options).filter(function (o) {
        return o.selected;
      }).map(function (o) {
        return '_value' in o ? o._value : o.value;
      });
      this.localValue = target.multiple ? selectedValue : selectedValue[0];
      this.$nextTick(function () {
        _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */], _this.localValue);
      });
    }
  },
  render: function render(h) {
    var name = this.name,
        disabled = this.disabled,
        required = this.required,
        size = this.computedSelectSize,
        value = this.localValue;
    var $options = this.formOptions.map(function (option, index) {
      var value = option.value,
          label = option.label,
          options = option.options,
          disabled = option.disabled;
      var key = "option_".concat(index);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["c" /* isArray */])(options) ? h(__WEBPACK_IMPORTED_MODULE_20__form_select_option_group__["a" /* BFormSelectOptionGroup */], {
        props: {
          label: label,
          options: options
        },
        key: key
      }) : h(__WEBPACK_IMPORTED_MODULE_19__form_select_option__["a" /* BFormSelectOption */], {
        props: {
          value: value,
          disabled: disabled
        },
        domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_html__["a" /* htmlOrText */])(option.html, option.text),
        key: key
      });
    });
    return h('select', {
      class: this.inputClass,
      attrs: {
        id: this.safeId(),
        name: name,
        form: this.form || null,
        multiple: this.multiple || null,
        size: size,
        disabled: disabled,
        required: required,
        'aria-required': required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid
      },
      on: {
        change: this.onChange
      },
      directives: [{
        name: 'model',
        value: value
      }],
      ref: 'input'
    }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["Q" /* SLOT_NAME_FIRST */]), $options, this.normalizeSlot()]);
  }
});

/***/ }),
/* 374 */
/* exports provided: FormSelectPlugin, BFormSelect, BFormSelectOption, BFormSelectOptionGroup */
/* exports used: FormSelectPlugin */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-select/index.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormSelectPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_select__ = __webpack_require__(/*! ./form-select */ 373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_select_option__ = __webpack_require__(/*! ./form-select-option */ 167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_select_option_group__ = __webpack_require__(/*! ./form-select-option-group */ 219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormSelect */
/* unused harmony reexport BFormSelectOption */
/* unused harmony reexport BFormSelectOptionGroup */




var FormSelectPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormSelect: __WEBPACK_IMPORTED_MODULE_0__form_select__["a" /* BFormSelect */],
    BFormSelectOption: __WEBPACK_IMPORTED_MODULE_1__form_select_option__["a" /* BFormSelectOption */],
    BFormSelectOptionGroup: __WEBPACK_IMPORTED_MODULE_2__form_select_option_group__["a" /* BFormSelectOptionGroup */],
    BSelect: __WEBPACK_IMPORTED_MODULE_0__form_select__["a" /* BFormSelect */],
    BSelectOption: __WEBPACK_IMPORTED_MODULE_1__form_select_option__["a" /* BFormSelectOption */],
    BSelectOptionGroup: __WEBPACK_IMPORTED_MODULE_2__form_select_option_group__["a" /* BFormSelectOptionGroup */]
  }
});


/***/ }),
/* 375 */
/* exports provided: FormSpinbuttonPlugin, BFormSpinbutton */
/* exports used: FormSpinbuttonPlugin */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-spinbutton/index.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormSpinbuttonPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_spinbutton__ = __webpack_require__(/*! ./form-spinbutton */ 220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormSpinbutton */


var FormSpinbuttonPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormSpinbutton: __WEBPACK_IMPORTED_MODULE_0__form_spinbutton__["a" /* BFormSpinbutton */],
    BSpinbutton: __WEBPACK_IMPORTED_MODULE_0__form_spinbutton__["a" /* BFormSpinbutton */]
  }
});


/***/ }),
/* 376 */
/* exports provided: BFormTags */
/* exports used: BFormTags */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-tags/form-tags.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_regex__ = __webpack_require__(/*! ../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_css_escape__ = __webpack_require__(/*! ../../utils/css-escape */ 464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__button_button__ = __webpack_require__(/*! ../button/button */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__form_form_invalid_feedback__ = __webpack_require__(/*! ../form/form-invalid-feedback */ 168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__form_form_text__ = __webpack_require__(/*! ../form/form-text */ 169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__form_tag__ = __webpack_require__(/*! ./form-tag */ 221);
var _watch;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Tagged input form control
// Based loosely on https://adamwathan.me/renderless-components-in-vuejs/



























 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_4__constants_props__["o" /* PROP_TYPE_ARRAY */],
  defaultValue: []
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // Supported input types (for built in input)


var TYPES = ['text', 'email', 'tel', 'url', 'number']; // Default ignore input focus selector

var DEFAULT_INPUT_FOCUS_SELECTOR = ['.b-form-tag', 'button', 'input', 'select'].join(' '); // --- Helper methods ---
// Escape special chars in string and replace
// contiguous spaces with a whitespace match

var escapeRegExpChars = function escapeRegExpChars(str) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["g" /* escapeRegExp */])(str).replace(__WEBPACK_IMPORTED_MODULE_5__constants_regex__["z" /* RX_SPACES */], '\\s');
}; // Remove leading/trailing spaces from array of tags and remove duplicates


var cleanTags = function cleanTags(tags) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b" /* concat */])(tags).map(function (tag) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["f" /* trim */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(tag));
  }).filter(function (tag, index, arr) {
    return tag.length > 0 && arr.indexOf(tag) === index;
  });
}; // Processes an input/change event, normalizing string or event argument


var processEventValue = function processEventValue(event) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["f" /* isString */])(event) ? event : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["l" /* isEvent */])(event) ? event.target.value || '' : '';
}; // Returns a fresh empty `tagsState` object


var cleanTagsState = function cleanTagsState() {
  return {
    all: [],
    valid: [],
    invalid: [],
    duplicate: []
  };
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_21__mixins_id__["a" /* props */]), modelProps), __WEBPACK_IMPORTED_MODULE_18__mixins_form_control__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_19__mixins_form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_20__mixins_form_state__["a" /* props */]), {}, {
  addButtonText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Add'),
  addButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'outline-secondary'),
  // Enable change event triggering tag addition
  // Handy if using <select> as the input
  addOnChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  duplicateTagText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Duplicate tag(s)'),
  feedbackAriaLive: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'assertive'),
  // Disable the input focus behavior when clicking
  // on element matching the selector (or selectors)
  ignoreInputFocusSelector: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */], DEFAULT_INPUT_FOCUS_SELECTOR),
  // Additional attributes to add to the input element
  inputAttrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["e" /* PROP_TYPE_OBJECT */], {}),
  inputClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  inputId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */]),
  inputType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'text', function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(TYPES, value);
  }),
  invalidTagText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Invalid tag(s)'),
  limit: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["l" /* PROP_TYPE_NUMBER */]),
  limitTagsText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Tag limit reached'),
  // Disable ENTER key from triggering tag addition
  noAddOnEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Disable the focus ring on the root element
  noOuterFocus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noTagRemove: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Add tag...'),
  // Enable deleting last tag in list when CODE_BACKSPACE is
  // pressed and input is empty
  removeOnDelete: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Character (or characters) that trigger adding tags
  separator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */]),
  tagClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  tagPills: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tagRemoveLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Remove tag'),
  tagRemovedLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'Tag removed'),
  tagValidator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  tagVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'secondary')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_24" /* NAME_FORM_TAGS */]); // --- Main component ---
// @vue/component

var BFormTags = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_24" /* NAME_FORM_TAGS */],
  mixins: [__WEBPACK_IMPORTED_MODULE_22__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_21__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_18__mixins_form_control__["b" /* formControlMixin */], __WEBPACK_IMPORTED_MODULE_19__mixins_form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_20__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_23__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    return {
      hasFocus: false,
      newTag: '',
      tags: [],
      // Tags that were removed
      removedTags: [],
      // Populated when tags are parsed
      tagsState: cleanTagsState(),
      focusState: null
    };
  },
  computed: {
    computedInputId: function computedInputId() {
      return this.inputId || this.safeId('__input__');
    },
    computedInputType: function computedInputType() {
      // We only allow certain types
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(TYPES, this.inputType) ? this.inputType : 'text';
    },
    computedInputAttrs: function computedInputAttrs() {
      var disabled = this.disabled,
          form = this.form;
      return _objectSpread(_objectSpread({}, this.inputAttrs), {}, {
        // Must have attributes
        id: this.computedInputId,
        value: this.newTag,
        disabled: disabled,
        form: form
      });
    },
    computedInputHandlers: function computedInputHandlers() {
      return _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["m" /* omit */])(this.bvListeners, [__WEBPACK_IMPORTED_MODULE_2__constants_events__["g" /* EVENT_NAME_FOCUSIN */], __WEBPACK_IMPORTED_MODULE_2__constants_events__["h" /* EVENT_NAME_FOCUSOUT */]])), {}, {
        blur: this.onInputBlur,
        change: this.onInputChange,
        focus: this.onInputFocus,
        input: this.onInputInput,
        keydown: this.onInputKeydown,
        reset: this.reset
      });
    },
    computedSeparator: function computedSeparator() {
      // Merge the array into a string
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b" /* concat */])(this.separator).filter(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["f" /* isString */]).filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]).join('');
    },
    computedSeparatorRegExp: function computedSeparatorRegExp() {
      // We use a computed prop here to precompile the RegExp
      // The RegExp is a character class RE in the form of `/[abc]+/`
      // where a, b, and c are the valid separator characters
      // -> `tags = str.split(/[abc]+/).filter(t => t)`
      var separator = this.computedSeparator;
      return separator ? new RegExp("[".concat(escapeRegExpChars(separator), "]+")) : null;
    },
    computedJoiner: function computedJoiner() {
      // When tag(s) are invalid or duplicate, we leave them
      // in the input so that the user can see them
      // If there are more than one tag in the input, we use the
      // first separator character as the separator in the input
      // We append a space if the first separator is not a space
      var joiner = this.computedSeparator.charAt(0);
      return joiner !== ' ' ? "".concat(joiner, " ") : joiner;
    },
    computeIgnoreInputFocusSelector: function computeIgnoreInputFocusSelector() {
      // Normalize to an single selector with selectors separated by `,`
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b" /* concat */])(this.ignoreInputFocusSelector).filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]).join(',').trim();
    },
    disableAddButton: function disableAddButton() {
      var _this = this;

      // If 'Add' button should be disabled
      // If the input contains at least one tag that can
      // be added, then the 'Add' button should be enabled
      var newTag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["f" /* trim */])(this.newTag);
      return newTag === '' || !this.splitTags(newTag).some(function (t) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(_this.tags, t) && _this.validateTag(t);
      });
    },
    duplicateTags: function duplicateTags() {
      return this.tagsState.duplicate;
    },
    hasDuplicateTags: function hasDuplicateTags() {
      return this.duplicateTags.length > 0;
    },
    invalidTags: function invalidTags() {
      return this.tagsState.invalid;
    },
    hasInvalidTags: function hasInvalidTags() {
      return this.invalidTags.length > 0;
    },
    isLimitReached: function isLimitReached() {
      var limit = this.limit;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["j" /* isNumber */])(limit) && limit >= 0 && this.tags.length >= limit;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    this.tags = cleanTags(newValue);
  }), _defineProperty(_watch, "tags", function tags(newValue, oldValue) {
    // Update the `v-model` (if it differs from the value prop)
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_loose_equal__["a" /* looseEqual */])(newValue, this[MODEL_PROP_NAME])) {
      this.$emit(MODEL_EVENT_NAME, newValue);
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b" /* concat */])(newValue).filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]);
      oldValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b" /* concat */])(oldValue).filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]);
      this.removedTags = oldValue.filter(function (old) {
        return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(newValue, old);
      });
    }
  }), _defineProperty(_watch, "tagsState", function tagsState(newValue, oldValue) {
    // Emit a tag-state event when the `tagsState` object changes
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["_0" /* EVENT_NAME_TAG_STATE */], newValue.valid, newValue.invalid, newValue.duplicate);
    }
  }), _watch),
  created: function created() {
    // We do this in created to make sure an input event emits
    // if the cleaned tags are not equal to the value prop
    this.tags = cleanTags(this[MODEL_PROP_NAME]);
  },
  mounted: function mounted() {
    // Listen for form reset events, to reset the tags input
    var $form = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["f" /* closest */])('form', this.$el);

    if ($form) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["b" /* eventOn */])($form, 'reset', this.reset, __WEBPACK_IMPORTED_MODULE_2__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var $form = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["f" /* closest */])('form', this.$el);

    if ($form) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["c" /* eventOff */])($form, 'reset', this.reset, __WEBPACK_IMPORTED_MODULE_2__constants_events__["r" /* EVENT_OPTIONS_PASSIVE */]);
    }
  },
  methods: {
    addTag: function addTag(newTag) {
      newTag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["f" /* isString */])(newTag) ? newTag : this.newTag;
      /* istanbul ignore next */

      if (this.disabled || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["f" /* trim */])(newTag) === '' || this.isLimitReached) {
        // Early exit
        return;
      }

      var parsed = this.parseTags(newTag); // Add any new tags to the `tags` array, or if the
      // array of `allTags` is empty, we clear the input

      if (parsed.valid.length > 0 || parsed.all.length === 0) {
        // Clear the user input element (and leave in any invalid/duplicate tag(s)

        /* istanbul ignore if: full testing to be added later */
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["y" /* matches */])(this.getInput(), 'select')) {
          // The following is needed to properly
          // work with `<select>` elements
          this.newTag = '';
        } else {
          var invalidAndDuplicates = [].concat(_toConsumableArray(parsed.invalid), _toConsumableArray(parsed.duplicate));
          this.newTag = parsed.all.filter(function (tag) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(invalidAndDuplicates, tag);
          }).join(this.computedJoiner).concat(invalidAndDuplicates.length > 0 ? this.computedJoiner.charAt(0) : '');
        }
      }

      if (parsed.valid.length > 0) {
        // We add the new tags in one atomic operation
        // to trigger reactivity once (instead of once per tag)
        // We do this after we update the new tag input value
        // `concat()` can be faster than array spread, when both args are arrays
        this.tags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["b" /* concat */])(this.tags, parsed.valid);
      }

      this.tagsState = parsed; // Attempt to re-focus the input (specifically for when using the Add
      // button, as the button disappears after successfully adding a tag

      this.focus();
    },
    removeTag: function removeTag(tag) {
      /* istanbul ignore next */
      if (this.disabled) {
        return;
      } // TODO:
      //   Add `onRemoveTag(tag)` user method, which if returns `false`
      //   will prevent the tag from being removed (i.e. confirmation)
      //   Or emit cancelable `BvEvent`


      this.tags = this.tags.filter(function (t) {
        return t !== tag;
      });
    },
    reset: function reset() {
      var _this2 = this;

      this.newTag = '';
      this.tags = [];
      this.$nextTick(function () {
        _this2.removedTags = [];
        _this2.tagsState = cleanTagsState();
      });
    },
    // --- Input element event handlers ---
    onInputInput: function onInputInput(event) {
      /* istanbul ignore next: hard to test composition events */
      if (this.disabled || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["l" /* isEvent */])(event) && event.target.composing) {
        // `event.target.composing` is set by Vue (`v-model` directive)
        // https://github.com/vuejs/vue/blob/dev/src/platforms/web/runtime/directives/model.js
        return;
      }

      var newTag = processEventValue(event);
      var separatorRe = this.computedSeparatorRegExp;

      if (this.newTag !== newTag) {
        this.newTag = newTag;
      } // We ignore leading whitespace for the following


      newTag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["i" /* trimLeft */])(newTag);

      if (separatorRe && separatorRe.test(newTag.slice(-1))) {
        // A trailing separator character was entered, so add the tag(s)
        // Note: More than one tag on input event is possible via copy/paste
        this.addTag();
      } else {
        // Validate (parse tags) on input event
        this.tagsState = newTag === '' ? cleanTagsState() : this.parseTags(newTag);
      }
    },
    onInputChange: function onInputChange(event) {
      // Change is triggered on `<input>` blur, or `<select>` selected
      // This event is opt-in
      if (!this.disabled && this.addOnChange) {
        var newTag = processEventValue(event);
        /* istanbul ignore next */

        if (this.newTag !== newTag) {
          this.newTag = newTag;
        }

        this.addTag();
      }
    },
    onInputKeydown: function onInputKeydown(event) {
      // Early exit

      /* istanbul ignore next */
      if (this.disabled || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["l" /* isEvent */])(event)) {
        return;
      }

      var keyCode = event.keyCode;
      var value = event.target.value || '';
      /* istanbul ignore else: testing to be added later */

      if (!this.noAddOnEnter && keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["a" /* CODE_ENTER */]) {
        // Attempt to add the tag when user presses enter
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        this.addTag();
      } else if (this.removeOnDelete && (keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["m" /* CODE_BACKSPACE */] || keyCode === __WEBPACK_IMPORTED_MODULE_3__constants_key_codes__["l" /* CODE_DELETE */]) && value === '') {
        // Remove the last tag if the user pressed backspace/delete and the input is empty
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        this.tags = this.tags.slice(0, -1);
      }
    },
    // --- Wrapper event handlers ---
    onClick: function onClick(event) {
      var _this3 = this;

      var ignoreFocusSelector = this.computeIgnoreInputFocusSelector;

      if (!ignoreFocusSelector || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["f" /* closest */])(ignoreFocusSelector, event.target, true)) {
        this.$nextTick(function () {
          _this3.focus();
        });
      }
    },
    onInputFocus: function onInputFocus(event) {
      var _this4 = this;

      if (this.focusState !== 'out') {
        this.focusState = 'in';
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
            if (_this4.hasFocus) {
              _this4.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["_1" /* EVENT_NAME_FOCUS */], event);

              _this4.focusState = null;
            }
          });
        });
      }
    },
    onInputBlur: function onInputBlur(event) {
      var _this5 = this;

      if (this.focusState !== 'in') {
        this.focusState = 'out';
        this.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
            if (!_this5.hasFocus) {
              _this5.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["Y" /* EVENT_NAME_BLUR */], event);

              _this5.focusState = null;
            }
          });
        });
      }
    },
    onFocusin: function onFocusin(event) {
      this.hasFocus = true;
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["g" /* EVENT_NAME_FOCUSIN */], event);
    },
    onFocusout: function onFocusout(event) {
      this.hasFocus = false;
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["h" /* EVENT_NAME_FOCUSOUT */], event);
    },
    handleAutofocus: function handleAutofocus() {
      var _this6 = this;

      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
          if (_this6.autofocus) {
            _this6.focus();
          }
        });
      });
    },
    // --- Public methods ---
    focus: function focus() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(this.getInput());
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["A" /* attemptBlur */])(this.getInput());
      }
    },
    // --- Private methods ---
    splitTags: function splitTags(newTag) {
      // Split the input into an array of raw tags
      newTag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(newTag);
      var separatorRe = this.computedSeparatorRegExp; // Split the tag(s) via the optional separator
      // Normally only a single tag is provided, but copy/paste
      // can enter multiple tags in a single operation

      return (separatorRe ? newTag.split(separatorRe) : [newTag]).map(__WEBPACK_IMPORTED_MODULE_17__utils_string__["f" /* trim */]).filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]);
    },
    parseTags: function parseTags(newTag) {
      var _this7 = this;

      // Takes `newTag` value and parses it into `validTags`,
      // `invalidTags`, and duplicate tags as an object
      // Split the input into raw tags
      var tags = this.splitTags(newTag); // Base results

      var parsed = {
        all: tags,
        valid: [],
        invalid: [],
        duplicate: []
      }; // Parse the unique tags

      tags.forEach(function (tag) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(_this7.tags, tag) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(parsed.valid, tag)) {
          // Unique duplicate tags
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(parsed.duplicate, tag)) {
            parsed.duplicate.push(tag);
          }
        } else if (_this7.validateTag(tag)) {
          // We only add unique/valid tags
          parsed.valid.push(tag);
        } else {
          // Unique invalid tags
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(parsed.invalid, tag)) {
            parsed.invalid.push(tag);
          }
        }
      });
      return parsed;
    },
    validateTag: function validateTag(tag) {
      var tagValidator = this.tagValidator;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_props__["d" /* hasPropFunction */])(tagValidator) ? tagValidator(tag) : true;
    },
    getInput: function getInput() {
      // Returns the input element reference (or null if not found)
      // We need to escape `computedInputId` since it can be user-provided
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["h" /* select */])("#".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_css_escape__["a" /* cssEscape */])(this.computedInputId)), this.$el);
    },
    // Default User Interface render
    defaultRender: function defaultRender(_ref) {
      var addButtonText = _ref.addButtonText,
          addButtonVariant = _ref.addButtonVariant,
          addTag = _ref.addTag,
          disableAddButton = _ref.disableAddButton,
          disabled = _ref.disabled,
          duplicateTagText = _ref.duplicateTagText,
          inputAttrs = _ref.inputAttrs,
          inputClass = _ref.inputClass,
          inputHandlers = _ref.inputHandlers,
          inputType = _ref.inputType,
          invalidTagText = _ref.invalidTagText,
          isDuplicate = _ref.isDuplicate,
          isInvalid = _ref.isInvalid,
          isLimitReached = _ref.isLimitReached,
          limitTagsText = _ref.limitTagsText,
          noTagRemove = _ref.noTagRemove,
          placeholder = _ref.placeholder,
          removeTag = _ref.removeTag,
          tagClass = _ref.tagClass,
          tagPills = _ref.tagPills,
          tagRemoveLabel = _ref.tagRemoveLabel,
          tagVariant = _ref.tagVariant,
          tags = _ref.tags;
      var h = this.$createElement; // Make the list of tags

      var $tags = tags.map(function (tag) {
        tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_string__["a" /* toString */])(tag);
        return h(__WEBPACK_IMPORTED_MODULE_27__form_tag__["a" /* BFormTag */], {
          class: tagClass,
          // `BFormTag` will auto generate an ID
          // so we do not need to set the ID prop
          props: {
            disabled: disabled,
            noRemove: noTagRemove,
            pill: tagPills,
            removeLabel: tagRemoveLabel,
            tag: 'li',
            title: tag,
            variant: tagVariant
          },
          on: {
            remove: function remove() {
              return removeTag(tag);
            }
          },
          key: "tags_".concat(tag)
        }, tag);
      }); // Feedback IDs if needed

      var invalidFeedbackId = invalidTagText && isInvalid ? this.safeId('__invalid_feedback__') : null;
      var duplicateFeedbackId = duplicateTagText && isDuplicate ? this.safeId('__duplicate_feedback__') : null;
      var limitFeedbackId = limitTagsText && isLimitReached ? this.safeId('__limit_feedback__') : null; // Compute the `aria-describedby` attribute value

      var ariaDescribedby = [inputAttrs['aria-describedby'], invalidFeedbackId, duplicateFeedbackId, limitFeedbackId].filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]).join(' '); // Input

      var $input = h('input', {
        staticClass: 'b-form-tags-input w-100 flex-grow-1 p-0 m-0 bg-transparent border-0',
        class: inputClass,
        style: {
          outline: 0,
          minWidth: '5rem'
        },
        attrs: _objectSpread(_objectSpread({}, inputAttrs), {}, {
          'aria-describedby': ariaDescribedby || null,
          type: inputType,
          placeholder: placeholder || null
        }),
        domProps: {
          value: inputAttrs.value
        },
        on: inputHandlers,
        // Directive needed to get `event.target.composing` set (if needed)
        directives: [{
          name: 'model',
          value: inputAttrs.value
        }],
        ref: 'input'
      }); // Add button

      var $button = h(__WEBPACK_IMPORTED_MODULE_24__button_button__["a" /* BButton */], {
        staticClass: 'b-form-tags-button py-0',
        class: {
          // Only show the button if the tag can be added
          // We use the `invisible` class instead of not rendering
          // the button, so that we maintain layout to prevent
          // the user input from jumping around
          invisible: disableAddButton
        },
        style: {
          fontSize: '90%'
        },
        props: {
          disabled: disableAddButton || isLimitReached,
          variant: addButtonVariant
        },
        on: {
          click: function click() {
            return addTag();
          }
        },
        ref: 'button'
      }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["R" /* SLOT_NAME_ADD_BUTTON_TEXT */]) || addButtonText]); // ID of the tags + input `<ul>` list
      // Note we could concatenate `inputAttrs.id` with '__tag_list__'
      // but `inputId` may be `null` until after mount
      // `safeId()` returns `null`, if no user provided ID,
      // until after mount when a unique ID is generated

      var tagListId = this.safeId('__tag_list__');
      var $field = h('li', {
        staticClass: 'b-form-tags-field flex-grow-1',
        attrs: {
          role: 'none',
          'aria-live': 'off',
          'aria-controls': tagListId
        },
        key: 'tags_field'
      }, [h('div', {
        staticClass: 'd-flex',
        attrs: {
          role: 'group'
        }
      }, [$input, $button])]); // Wrap in an unordered list element (we use a list for accessibility)

      var $ul = h('ul', {
        staticClass: 'b-form-tags-list list-unstyled mb-0 d-flex flex-wrap align-items-center',
        attrs: {
          id: tagListId
        },
        key: 'tags_list'
      }, [$tags, $field]); // Assemble the feedback

      var $feedback = h();

      if (invalidTagText || duplicateTagText || limitTagsText) {
        // Add an aria live region for the invalid/duplicate tag
        // messages if the user has not disabled the messages
        var ariaLive = this.feedbackAriaLive,
            joiner = this.computedJoiner; // Invalid tag feedback if needed (error)

        var $invalid = h();

        if (invalidFeedbackId) {
          $invalid = h(__WEBPACK_IMPORTED_MODULE_25__form_form_invalid_feedback__["a" /* BFormInvalidFeedback */], {
            props: {
              id: invalidFeedbackId,
              ariaLive: ariaLive,
              forceShow: true
            },
            key: 'tags_invalid_feedback'
          }, [this.invalidTagText, ': ', this.invalidTags.join(joiner)]);
        } // Duplicate tag feedback if needed (warning, not error)


        var $duplicate = h();

        if (duplicateFeedbackId) {
          $duplicate = h(__WEBPACK_IMPORTED_MODULE_26__form_form_text__["a" /* BFormText */], {
            props: {
              id: duplicateFeedbackId,
              ariaLive: ariaLive
            },
            key: 'tags_duplicate_feedback'
          }, [this.duplicateTagText, ': ', this.duplicateTags.join(joiner)]);
        } // Limit tags feedback if needed (warning, not error)


        var $limit = h();

        if (limitFeedbackId) {
          $limit = h(__WEBPACK_IMPORTED_MODULE_26__form_form_text__["a" /* BFormText */], {
            props: {
              id: limitFeedbackId,
              ariaLive: ariaLive
            },
            key: 'tags_limit_feedback'
          }, [limitTagsText]);
        }

        $feedback = h('div', {
          attrs: {
            'aria-live': 'polite',
            'aria-atomic': 'true'
          },
          key: 'tags_feedback'
        }, [$invalid, $duplicate, $limit]);
      } // Return the content


      return [$ul, $feedback];
    }
  },
  render: function render(h) {
    var name = this.name,
        disabled = this.disabled,
        required = this.required,
        form = this.form,
        tags = this.tags,
        computedInputId = this.computedInputId,
        hasFocus = this.hasFocus,
        noOuterFocus = this.noOuterFocus; // Scoped slot properties

    var scope = _objectSpread({
      // Array of tags (shallow copy to prevent mutations)
      tags: tags.slice(),
      // <input> v-bind:inputAttrs
      inputAttrs: this.computedInputAttrs,
      // We don't include this in the attrs, as users may want to override this
      inputType: this.computedInputType,
      // <input> v-on:inputHandlers
      inputHandlers: this.computedInputHandlers,
      // Methods
      removeTag: this.removeTag,
      addTag: this.addTag,
      reset: this.reset,
      // <input> :id="inputId"
      inputId: computedInputId,
      // Invalid/Duplicate state information
      isInvalid: this.hasInvalidTags,
      invalidTags: this.invalidTags.slice(),
      isDuplicate: this.hasDuplicateTags,
      duplicateTags: this.duplicateTags.slice(),
      isLimitReached: this.isLimitReached,
      // If the 'Add' button should be disabled
      disableAddButton: this.disableAddButton
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_object__["k" /* pick */])(this.$props, ['addButtonText', 'addButtonVariant', 'disabled', 'duplicateTagText', 'form', 'inputClass', 'invalidTagText', 'limit', 'limitTagsText', 'noTagRemove', 'placeholder', 'required', 'separator', 'size', 'state', 'tagClass', 'tagPills', 'tagRemoveLabel', 'tagVariant'])); // Generate the user interface


    var $content = this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["a" /* SLOT_NAME_DEFAULT */], scope) || this.defaultRender(scope); // Generate the `aria-live` region for the current value(s)

    var $output = h('output', {
      staticClass: 'sr-only',
      attrs: {
        id: this.safeId('__selected_tags__'),
        role: 'status',
        for: computedInputId,
        'aria-live': hasFocus ? 'polite' : 'off',
        'aria-atomic': 'true',
        'aria-relevant': 'additions text'
      }
    }, this.tags.join(', ')); // Removed tag live region

    var $removed = h('div', {
      staticClass: 'sr-only',
      attrs: {
        id: this.safeId('__removed_tags__'),
        role: 'status',
        'aria-live': hasFocus ? 'assertive' : 'off',
        'aria-atomic': 'true'
      }
    }, this.removedTags.length > 0 ? "(".concat(this.tagRemovedLabel, ") ").concat(this.removedTags.join(', ')) : ''); // Add hidden inputs for form submission

    var $hidden = h();

    if (name && !disabled) {
      // We add hidden inputs for each tag if a name is provided
      // When there are currently no tags, a visually hidden input
      // with empty value is rendered for proper required handling
      var hasTags = tags.length > 0;
      $hidden = (hasTags ? tags : ['']).map(function (tag) {
        return h('input', {
          class: {
            'sr-only': !hasTags
          },
          attrs: {
            type: hasTags ? 'hidden' : 'text',
            value: tag,
            required: required,
            name: name,
            form: form
          },
          key: "tag_input_".concat(tag)
        });
      });
    } // Return the rendered output


    return h('div', {
      staticClass: 'b-form-tags form-control h-auto',
      class: [{
        focus: hasFocus && !noOuterFocus && !disabled,
        disabled: disabled
      }, this.sizeFormClass, this.stateClass],
      attrs: {
        id: this.safeId(),
        role: 'group',
        tabindex: disabled || noOuterFocus ? null : '-1',
        'aria-describedby': this.safeId('__selected_tags__')
      },
      on: {
        click: this.onClick,
        focusin: this.onFocusin,
        focusout: this.onFocusout
      }
    }, [$output, $removed, $content, $hidden]);
  }
});

/***/ }),
/* 377 */
/* exports provided: FormTagsPlugin, BFormTags, BFormTag */
/* exports used: FormTagsPlugin */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-tags/index.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormTagsPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_tags__ = __webpack_require__(/*! ./form-tags */ 376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_tag__ = __webpack_require__(/*! ./form-tag */ 221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormTags */
/* unused harmony reexport BFormTag */



var FormTagsPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormTags: __WEBPACK_IMPORTED_MODULE_0__form_tags__["a" /* BFormTags */],
    BTags: __WEBPACK_IMPORTED_MODULE_0__form_tags__["a" /* BFormTags */],
    BFormTag: __WEBPACK_IMPORTED_MODULE_1__form_tag__["a" /* BFormTag */],
    BTag: __WEBPACK_IMPORTED_MODULE_1__form_tag__["a" /* BFormTag */]
  }
});


/***/ }),
/* 378 */
/* exports provided: props, BFormTextarea */
/* exports used: BFormTextarea */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-textarea/form-textarea.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormTextarea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_form_control__ = __webpack_require__(/*! ../../mixins/form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_form_selection__ = __webpack_require__(/*! ../../mixins/form-selection */ 459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_form_size__ = __webpack_require__(/*! ../../mixins/form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_form_state__ = __webpack_require__(/*! ../../mixins/form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_form_text__ = __webpack_require__(/*! ../../mixins/form-text */ 460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_form_validity__ = __webpack_require__(/*! ../../mixins/form-validity */ 461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_listeners__ = __webpack_require__(/*! ../../mixins/listeners */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_visible_visible__ = __webpack_require__(/*! ../../directives/visible/visible */ 180);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_15__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_9__mixins_form_control__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__mixins_form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__mixins_form_state__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_13__mixins_form_text__["a" /* props */]), {}, {
  maxRows: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]),
  // When in auto resize mode, disable shrinking to content height
  noAutoShrink: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Disable the resize handle of textarea
  noResize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  rows: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 2),
  // 'soft', 'hard' or 'off'
  // Browser default is 'soft'
  wrap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'soft')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_19" /* NAME_FORM_TEXTAREA */]); // --- Main component ---
// @vue/component

var BFormTextarea = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_19" /* NAME_FORM_TEXTAREA */],
  directives: {
    'b-visible': __WEBPACK_IMPORTED_MODULE_18__directives_visible_visible__["a" /* VBVisible */]
  },
  // Mixin order is important!
  mixins: [__WEBPACK_IMPORTED_MODULE_17__mixins_listeners__["a" /* listenersMixin */], __WEBPACK_IMPORTED_MODULE_15__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_16__mixins_listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_9__mixins_form_control__["b" /* formControlMixin */], __WEBPACK_IMPORTED_MODULE_11__mixins_form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_12__mixins_form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_form_text__["b" /* formTextMixin */], __WEBPACK_IMPORTED_MODULE_10__mixins_form_selection__["a" /* formSelectionMixin */], __WEBPACK_IMPORTED_MODULE_14__mixins_form_validity__["a" /* formValidityMixin */]],
  props: props,
  data: function data() {
    return {
      heightInPx: null
    };
  },
  computed: {
    type: function type() {
      return null;
    },
    computedStyle: function computedStyle() {
      var styles = {
        // Setting `noResize` to true will disable the ability for the user to
        // manually resize the textarea. We also disable when in auto height mode
        resize: !this.computedRows || this.noResize ? 'none' : null
      };

      if (!this.computedRows) {
        // Conditionally set the computed CSS height when auto rows/height is enabled
        // We avoid setting the style to `null`, which can override user manual resize handle
        styles.height = this.heightInPx; // We always add a vertical scrollbar to the textarea when auto-height is
        // enabled so that the computed height calculation returns a stable value

        styles.overflowY = 'scroll';
      }

      return styles;
    },
    computedMinRows: function computedMinRows() {
      // Ensure rows is at least 2 and positive (2 is the native textarea value)
      // A value of 1 can cause issues in some browsers, and most browsers
      // only support 2 as the smallest value
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["b" /* toInteger */])(this.rows, 2), 2);
    },
    computedMaxRows: function computedMaxRows() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(this.computedMinRows, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["b" /* toInteger */])(this.maxRows, 0));
    },
    computedRows: function computedRows() {
      // This is used to set the attribute 'rows' on the textarea
      // If auto-height is enabled, then we return `null` as we use CSS to control height
      return this.computedMinRows === this.computedMaxRows ? this.computedMinRows : null;
    },
    computedAttrs: function computedAttrs() {
      var disabled = this.disabled,
          required = this.required;
      return {
        id: this.safeId(),
        name: this.name || null,
        form: this.form || null,
        disabled: disabled,
        placeholder: this.placeholder || null,
        required: required,
        autocomplete: this.autocomplete || null,
        readonly: this.readonly || this.plaintext,
        rows: this.computedRows,
        wrap: this.wrap || null,
        'aria-required': this.required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid
      };
    },
    computedListeners: function computedListeners() {
      return _objectSpread(_objectSpread({}, this.bvListeners), {}, {
        input: this.onInput,
        change: this.onChange,
        blur: this.onBlur
      });
    }
  },
  watch: {
    localValue: function localValue() {
      this.setHeight();
    }
  },
  mounted: function mounted() {
    this.setHeight();
  },
  methods: {
    // Called by intersection observer directive

    /* istanbul ignore next */
    visibleCallback: function visibleCallback(visible) {
      if (visible) {
        // We use a `$nextTick()` here just to make sure any
        // transitions or portalling have completed
        this.$nextTick(this.setHeight);
      }
    },
    setHeight: function setHeight() {
      var _this = this;

      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a" /* requestAF */])(function () {
          _this.heightInPx = _this.computeHeight();
        });
      });
    },

    /* istanbul ignore next: can't test getComputedStyle in JSDOM */
    computeHeight: function computeHeight() {
      if (this.$isServer || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["e" /* isNull */])(this.computedRows)) {
        return null;
      }

      var el = this.$el; // Element must be visible (not hidden) and in document
      // Must be checked after above checks

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* isVisible */])(el)) {
        return null;
      } // Get current computed styles


      var computedStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["o" /* getCS */])(el); // Height of one line of text in px

      var lineHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(computedStyle.lineHeight, 1); // Calculate height of border and padding

      var border = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(computedStyle.borderTopWidth, 0) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(computedStyle.borderBottomWidth, 0);
      var padding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(computedStyle.paddingTop, 0) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(computedStyle.paddingBottom, 0); // Calculate offset

      var offset = border + padding; // Minimum height for min rows (which must be 2 rows or greater for cross-browser support)

      var minHeight = lineHeight * this.computedMinRows + offset; // Get the current style height (with `px` units)

      var oldHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["G" /* getStyle */])(el, 'height') || computedStyle.height; // Probe scrollHeight by temporarily changing the height to `auto`

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'height', 'auto');
      var scrollHeight = el.scrollHeight; // Place the original old height back on the element, just in case `computedProp`
      // returns the same value as before

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'height', oldHeight); // Calculate content height in 'rows' (scrollHeight includes padding but not border)

      var contentRows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])((scrollHeight - padding) / lineHeight, 2); // Calculate number of rows to display (limited within min/max rows)

      var rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["e" /* mathMin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(contentRows, this.computedMinRows), this.computedMaxRows); // Calculate the required height of the textarea including border and padding (in pixels)

      var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["f" /* mathCeil */])(rows * lineHeight + offset), minHeight); // Computed height remains the larger of `oldHeight` and new `height`,
      // when height is in `sticky` mode (prop `no-auto-shrink` is true)

      if (this.noAutoShrink && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_number__["a" /* toFloat */])(oldHeight, 0) > height) {
        return oldHeight;
      } // Return the new computed CSS height in px units


      return "".concat(height, "px");
    }
  },
  render: function render(h) {
    return h('textarea', {
      class: this.computedClass,
      style: this.computedStyle,
      directives: [{
        name: 'b-visible',
        value: this.visibleCallback,
        // If textarea is within 640px of viewport, consider it visible
        modifiers: {
          '640': true
        }
      }],
      attrs: this.computedAttrs,
      domProps: {
        value: this.localValue
      },
      on: this.computedListeners,
      ref: 'input'
    });
  }
});

/***/ }),
/* 379 */
/* exports provided: FormTextareaPlugin, BFormTextarea */
/* exports used: FormTextareaPlugin */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-textarea/index.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormTextareaPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_textarea__ = __webpack_require__(/*! ./form-textarea */ 378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormTextarea */


var FormTextareaPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormTextarea: __WEBPACK_IMPORTED_MODULE_0__form_textarea__["a" /* BFormTextarea */],
    BTextarea: __WEBPACK_IMPORTED_MODULE_0__form_textarea__["a" /* BFormTextarea */]
  }
});


/***/ }),
/* 380 */
/* exports provided: props, BFormTimepicker */
/* exports used: BFormTimepicker */
/*!***************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-timepicker/form-timepicker.js ***!
  \***************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormTimepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__button_button__ = __webpack_require__(/*! ../button/button */ 85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_btn_label_control_bv_form_btn_label_control__ = __webpack_require__(/*! ../form-btn-label-control/bv-form-btn-label-control */ 358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__time_time__ = __webpack_require__(/*! ../time/time */ 239);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */],
  defaultValue: ''
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // --- Props ---


var timeProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_14__time_time__["b" /* props */], ['hidden', 'id', 'value']);
var formBtnLabelControlProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_13__form_btn_label_control_bv_form_btn_label_control__["a" /* props */], ['formattedValue', 'id', 'lang', 'rtl', 'value']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_10__mixins_id__["a" /* props */]), modelProps), timeProps), formBtnLabelControlProps), {}, {
  closeButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'outline-secondary'),
  labelCloseButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Close'),
  labelNowButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Select now'),
  labelResetButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Reset'),
  noCloseButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  nowButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  nowButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'outline-primary'),
  resetButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  resetButtonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'outline-danger'),
  resetValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["t" /* PROP_TYPE_DATE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_17" /* NAME_FORM_TIMEPICKER */]); // --- Main component ---
// @vue/component

var BFormTimepicker = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_17" /* NAME_FORM_TIMEPICKER */],
  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_id__["b" /* idMixin */], modelMixin],
  props: props,
  data: function data() {
    return {
      // We always use `HH:mm:ss` value internally
      localHMS: this[MODEL_PROP_NAME] || '',
      // Context data from BTime
      localLocale: null,
      isRTL: false,
      formattedValue: '',
      // If the menu is opened
      isVisible: false
    };
  },
  computed: {
    computedLang: function computedLang() {
      return (this.localLocale || '').replace(/-u-.*$/i, '') || null;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    this.localHMS = newValue || '';
  }), _defineProperty(_watch, "localHMS", function localHMS(newValue) {
    // We only update the v-model value when the timepicker
    // is open, to prevent cursor jumps when bound to a
    // text input in button only mode
    if (this.isVisible) {
      this.$emit(MODEL_EVENT_NAME, newValue || '');
    }
  }), _watch),
  methods: {
    // Public methods
    focus: function focus() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(this.$refs.control);
      }
    },
    blur: function blur() {
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["A" /* attemptBlur */])(this.$refs.control);
      }
    },
    // Private methods
    setAndClose: function setAndClose(value) {
      var _this = this;

      this.localHMS = value;
      this.$nextTick(function () {
        _this.$refs.control.hide(true);
      });
    },
    onInput: function onInput(hms) {
      if (this.localHMS !== hms) {
        this.localHMS = hms;
      }
    },
    onContext: function onContext(ctx) {
      var isRTL = ctx.isRTL,
          locale = ctx.locale,
          value = ctx.value,
          formatted = ctx.formatted;
      this.isRTL = isRTL;
      this.localLocale = locale;
      this.formattedValue = formatted;
      this.localHMS = value || ''; // Re-emit the context event

      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["z" /* EVENT_NAME_CONTEXT */], ctx);
    },
    onNowButton: function onNowButton() {
      var now = new Date();
      var hours = now.getHours();
      var minutes = now.getMinutes();
      var seconds = this.showSeconds ? now.getSeconds() : 0;
      var value = [hours, minutes, seconds].map(function (v) {
        return "00".concat(v || '').slice(-2);
      }).join(':');
      this.setAndClose(value);
    },
    onResetButton: function onResetButton() {
      this.setAndClose(this.resetValue);
    },
    onCloseButton: function onCloseButton() {
      this.$refs.control.hide(true);
    },
    onShow: function onShow() {
      this.isVisible = true;
    },
    onShown: function onShown() {
      var _this2 = this;

      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(_this2.$refs.time);

        _this2.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */]);
      });
    },
    onHidden: function onHidden() {
      this.isVisible = false;
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */]);
    },
    // Render function helpers
    defaultButtonFn: function defaultButtonFn(_ref) {
      var isHovered = _ref.isHovered,
          hasFocus = _ref.hasFocus;
      return this.$createElement(isHovered || hasFocus ? __WEBPACK_IMPORTED_MODULE_11__icons_icons__["_356" /* BIconClockFill */] : __WEBPACK_IMPORTED_MODULE_11__icons_icons__["_355" /* BIconClock */], {
        attrs: {
          'aria-hidden': 'true'
        }
      });
    }
  },
  render: function render(h) {
    var localHMS = this.localHMS,
        disabled = this.disabled,
        readonly = this.readonly,
        $props = this.$props;
    var placeholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["g" /* isUndefinedOrNull */])(this.placeholder) ? this.labelNoTimeSelected : this.placeholder; // Footer buttons

    var $footer = [];

    if (this.nowButton) {
      var label = this.labelNowButton;
      $footer.push(h(__WEBPACK_IMPORTED_MODULE_12__button_button__["a" /* BButton */], {
        props: {
          size: 'sm',
          disabled: disabled || readonly,
          variant: this.nowButtonVariant
        },
        attrs: {
          'aria-label': label || null
        },
        on: {
          click: this.onNowButton
        },
        key: 'now-btn'
      }, label));
    }

    if (this.resetButton) {
      if ($footer.length > 0) {
        // Add a "spacer" between buttons ('&nbsp;')
        $footer.push(h('span', "\xA0"));
      }

      var _label = this.labelResetButton;
      $footer.push(h(__WEBPACK_IMPORTED_MODULE_12__button_button__["a" /* BButton */], {
        props: {
          size: 'sm',
          disabled: disabled || readonly,
          variant: this.resetButtonVariant
        },
        attrs: {
          'aria-label': _label || null
        },
        on: {
          click: this.onResetButton
        },
        key: 'reset-btn'
      }, _label));
    }

    if (!this.noCloseButton) {
      // Add a "spacer" between buttons ('&nbsp;')
      if ($footer.length > 0) {
        $footer.push(h('span', "\xA0"));
      }

      var _label2 = this.labelCloseButton;
      $footer.push(h(__WEBPACK_IMPORTED_MODULE_12__button_button__["a" /* BButton */], {
        props: {
          size: 'sm',
          disabled: disabled,
          variant: this.closeButtonVariant
        },
        attrs: {
          'aria-label': _label2 || null
        },
        on: {
          click: this.onCloseButton
        },
        key: 'close-btn'
      }, _label2));
    }

    if ($footer.length > 0) {
      $footer = [h('div', {
        staticClass: 'b-form-date-controls d-flex flex-wrap',
        class: {
          'justify-content-between': $footer.length > 1,
          'justify-content-end': $footer.length < 2
        }
      }, $footer)];
    }

    var $time = h(__WEBPACK_IMPORTED_MODULE_14__time_time__["a" /* BTime */], {
      staticClass: 'b-form-time-control',
      props: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["c" /* pluckProps */])(timeProps, $props)), {}, {
        value: localHMS,
        hidden: !this.isVisible
      }),
      on: {
        input: this.onInput,
        context: this.onContext
      },
      ref: 'time'
    }, $footer);
    return h(__WEBPACK_IMPORTED_MODULE_13__form_btn_label_control_bv_form_btn_label_control__["b" /* BVFormBtnLabelControl */], {
      staticClass: 'b-form-timepicker',
      props: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["c" /* pluckProps */])(formBtnLabelControlProps, $props)), {}, {
        id: this.safeId(),
        value: localHMS,
        formattedValue: localHMS ? this.formattedValue : '',
        placeholder: placeholder,
        rtl: this.isRTL,
        lang: this.computedLang
      }),
      on: {
        show: this.onShow,
        shown: this.onShown,
        hidden: this.onHidden
      },
      scopedSlots: _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */], this.$scopedSlots[__WEBPACK_IMPORTED_MODULE_4__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */]] || this.defaultButtonFn),
      ref: 'control'
    }, [$time]);
  }
});

/***/ }),
/* 381 */
/* exports provided: FormTimepickerPlugin, BFormTimepicker */
/* exports used: FormTimepickerPlugin */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-timepicker/index.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormTimepickerPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_timepicker__ = __webpack_require__(/*! ./form-timepicker */ 380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BFormTimepicker */


var FormTimepickerPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BFormTimepicker: __WEBPACK_IMPORTED_MODULE_0__form_timepicker__["a" /* BFormTimepicker */],
    BTimepicker: __WEBPACK_IMPORTED_MODULE_0__form_timepicker__["a" /* BFormTimepicker */]
  }
});


/***/ }),
/* 382 */
/* exports provided: props, BFormDatalist */
/* exports used: BFormDatalist */
/*!**************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form/form-datalist.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFormDatalist; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_form_options__ = __webpack_require__(/*! ../../mixins/form-options */ 183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__mixins_form_options__["a" /* props */]), {}, {
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], undefined, true) // Required

})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_39" /* NAME_FORM_DATALIST */]); // --- Main component ---
// @vue/component

var BFormDatalist = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_39" /* NAME_FORM_DATALIST */],
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_form_options__["b" /* formOptionsMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  render: function render(h) {
    var id = this.id;
    var $options = this.formOptions.map(function (option, index) {
      var value = option.value,
          text = option.text,
          html = option.html,
          disabled = option.disabled;
      return h('option', {
        attrs: {
          value: value,
          disabled: disabled
        },
        domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(html, text),
        key: "option_".concat(index)
      });
    });
    return h('datalist', {
      attrs: {
        id: id
      }
    }, [$options, this.normalizeSlot()]);
  }
});

/***/ }),
/* 383 */
/* exports provided: FormPlugin, BForm, BFormDatalist, BFormText, BFormInvalidFeedback, BFormValidFeedback */
/* exports used: FormPlugin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form/index.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(/*! ./form */ 170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_datalist__ = __webpack_require__(/*! ./form-datalist */ 382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_text__ = __webpack_require__(/*! ./form-text */ 169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__ = __webpack_require__(/*! ./form-invalid-feedback */ 168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_valid_feedback__ = __webpack_require__(/*! ./form-valid-feedback */ 222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_form_row__ = __webpack_require__(/*! ../layout/form-row */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BForm */
/* unused harmony reexport BFormDatalist */
/* unused harmony reexport BFormText */
/* unused harmony reexport BFormInvalidFeedback */
/* unused harmony reexport BFormValidFeedback */







var FormPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BForm: __WEBPACK_IMPORTED_MODULE_0__form__["a" /* BForm */],
    BFormDatalist: __WEBPACK_IMPORTED_MODULE_1__form_datalist__["a" /* BFormDatalist */],
    BDatalist: __WEBPACK_IMPORTED_MODULE_1__form_datalist__["a" /* BFormDatalist */],
    BFormText: __WEBPACK_IMPORTED_MODULE_2__form_text__["a" /* BFormText */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__["a" /* BFormInvalidFeedback */],
    BFormFeedback: __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__["a" /* BFormInvalidFeedback */],
    BFormValidFeedback: __WEBPACK_IMPORTED_MODULE_4__form_valid_feedback__["a" /* BFormValidFeedback */],
    // Added here for convenience
    BFormRow: __WEBPACK_IMPORTED_MODULE_5__layout_form_row__["a" /* BFormRow */]
  }
}); // BFormRow is not exported here as a named export, as it is exported by Layout



/***/ }),
/* 384 */
/* exports provided: ImagePlugin, BImg, BImgLazy */
/* exports used: ImagePlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/image/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImagePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img__ = __webpack_require__(/*! ./img */ 119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_lazy__ = __webpack_require__(/*! ./img-lazy */ 223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BImg */
/* unused harmony reexport BImgLazy */



var ImagePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BImg: __WEBPACK_IMPORTED_MODULE_0__img__["a" /* BImg */],
    BImgLazy: __WEBPACK_IMPORTED_MODULE_1__img_lazy__["a" /* BImgLazy */]
  }
});


/***/ }),
/* 385 */
/* exports provided: InputGroupPlugin, BInputGroup, BInputGroupAddon, BInputGroupPrepend, BInputGroupAppend, BInputGroupText */
/* exports used: InputGroupPlugin */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/input-group/index.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputGroupPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_group__ = __webpack_require__(/*! ./input-group */ 386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_group_addon__ = __webpack_require__(/*! ./input-group-addon */ 171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_group_prepend__ = __webpack_require__(/*! ./input-group-prepend */ 225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_group_append__ = __webpack_require__(/*! ./input-group-append */ 224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input_group_text__ = __webpack_require__(/*! ./input-group-text */ 172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BInputGroup */
/* unused harmony reexport BInputGroupAddon */
/* unused harmony reexport BInputGroupPrepend */
/* unused harmony reexport BInputGroupAppend */
/* unused harmony reexport BInputGroupText */






var InputGroupPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BInputGroup: __WEBPACK_IMPORTED_MODULE_0__input_group__["a" /* BInputGroup */],
    BInputGroupAddon: __WEBPACK_IMPORTED_MODULE_1__input_group_addon__["a" /* BInputGroupAddon */],
    BInputGroupPrepend: __WEBPACK_IMPORTED_MODULE_2__input_group_prepend__["a" /* BInputGroupPrepend */],
    BInputGroupAppend: __WEBPACK_IMPORTED_MODULE_3__input_group_append__["a" /* BInputGroupAppend */],
    BInputGroupText: __WEBPACK_IMPORTED_MODULE_4__input_group_text__["a" /* BInputGroupText */]
  }
});


/***/ }),
/* 386 */
/* exports provided: props, BInputGroup */
/* exports used: BInputGroup */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/input-group/input-group.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BInputGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__input_group_append__ = __webpack_require__(/*! ./input-group-append */ 224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__input_group_prepend__ = __webpack_require__(/*! ./input-group-prepend */ 225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__input_group_text__ = __webpack_require__(/*! ./input-group-text */ 172);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  append: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  appendHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  prepend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  prependHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_14" /* NAME_INPUT_GROUP */]); // --- Main component ---
// @vue/component

var BInputGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_14" /* NAME_INPUT_GROUP */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots;
    var prepend = props.prepend,
        prependHtml = props.prependHtml,
        append = props.append,
        appendHtml = props.appendHtml,
        size = props.size;
    var $scopedSlots = scopedSlots || {};
    var $slots = slots();
    var slotScope = {};
    var $prepend = h();
    var hasPrependSlot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["O" /* SLOT_NAME_PREPEND */], $scopedSlots, $slots);

    if (hasPrependSlot || prepend || prependHtml) {
      $prepend = h(__WEBPACK_IMPORTED_MODULE_8__input_group_prepend__["a" /* BInputGroupPrepend */], [hasPrependSlot ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["O" /* SLOT_NAME_PREPEND */], slotScope, $scopedSlots, $slots) : h(__WEBPACK_IMPORTED_MODULE_9__input_group_text__["a" /* BInputGroupText */], {
        domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_html__["a" /* htmlOrText */])(prependHtml, prepend)
      })]);
    }

    var $append = h();
    var hasAppendSlot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["P" /* SLOT_NAME_APPEND */], $scopedSlots, $slots);

    if (hasAppendSlot || append || appendHtml) {
      $append = h(__WEBPACK_IMPORTED_MODULE_7__input_group_append__["a" /* BInputGroupAppend */], [hasAppendSlot ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["P" /* SLOT_NAME_APPEND */], slotScope, $scopedSlots, $slots) : h(__WEBPACK_IMPORTED_MODULE_9__input_group_text__["a" /* BInputGroupText */], {
        domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_html__["a" /* htmlOrText */])(appendHtml, append)
      })]);
    }

    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'input-group',
      class: _defineProperty({}, "input-group-".concat(size), size),
      attrs: {
        id: props.id || null,
        role: 'group'
      }
    }), [$prepend, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], slotScope, $scopedSlots, $slots), $append]);
  }
});

/***/ }),
/* 387 */
/* exports provided: JumbotronPlugin, BJumbotron */
/* exports used: JumbotronPlugin */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/jumbotron/index.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JumbotronPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jumbotron__ = __webpack_require__(/*! ./jumbotron */ 388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BJumbotron */


var JumbotronPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BJumbotron: __WEBPACK_IMPORTED_MODULE_0__jumbotron__["a" /* BJumbotron */]
  }
});


/***/ }),
/* 388 */
/* exports provided: props, BJumbotron */
/* exports used: BJumbotron */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/jumbotron/jumbotron.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BJumbotron; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_container__ = __webpack_require__(/*! ../layout/container */ 227);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  bgVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  borderVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  containerFluid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  fluid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  header: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  headerLevel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 3),
  headerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'h1'),
  lead: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  leadHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  leadTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'p'),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  textVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_9" /* NAME_JUMBOTRON */]); // --- Main component ---
// @vue/component

var BJumbotron = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_9" /* NAME_JUMBOTRON */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots;
    var header = props.header,
        headerHtml = props.headerHtml,
        lead = props.lead,
        leadHtml = props.leadHtml,
        textVariant = props.textVariant,
        bgVariant = props.bgVariant,
        borderVariant = props.borderVariant;
    var $scopedSlots = scopedSlots || {};
    var $slots = slots();
    var slotScope = {};
    var $header = h();
    var hasHeaderSlot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["u" /* SLOT_NAME_HEADER */], $scopedSlots, $slots);

    if (hasHeaderSlot || header || headerHtml) {
      var headerLevel = props.headerLevel;
      $header = h(props.headerTag, {
        class: _defineProperty({}, "display-".concat(headerLevel), headerLevel),
        domProps: hasHeaderSlot ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_html__["a" /* htmlOrText */])(headerHtml, header)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["u" /* SLOT_NAME_HEADER */], slotScope, $scopedSlots, $slots));
    }

    var $lead = h();
    var hasLeadSlot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["a" /* hasNormalizedSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["N" /* SLOT_NAME_LEAD */], $scopedSlots, $slots);

    if (hasLeadSlot || lead || leadHtml) {
      $lead = h(props.leadTag, {
        staticClass: 'lead',
        domProps: hasLeadSlot ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_html__["a" /* htmlOrText */])(leadHtml, lead)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["N" /* SLOT_NAME_LEAD */], slotScope, $scopedSlots, $slots));
    }

    var $children = [$header, $lead, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], slotScope, $scopedSlots, $slots)]; // If fluid, wrap content in a container

    if (props.fluid) {
      $children = [h(__WEBPACK_IMPORTED_MODULE_7__layout_container__["a" /* BContainer */], {
        props: {
          fluid: props.containerFluid
        }
      }, $children)];
    }

    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'jumbotron',
      class: (_class2 = {
        'jumbotron-fluid': props.fluid
      }, _defineProperty(_class2, "text-".concat(textVariant), textVariant), _defineProperty(_class2, "bg-".concat(bgVariant), bgVariant), _defineProperty(_class2, "border-".concat(borderVariant), borderVariant), _defineProperty(_class2, "border", borderVariant), _class2)
    }), $children);
  }
});

/***/ }),
/* 389 */
/* exports provided: LayoutPlugin, BContainer, BRow, BCol, BFormRow */
/* exports used: LayoutPlugin */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/layout/index.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(/*! ./container */ 227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__row__ = __webpack_require__(/*! ./row */ 390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__col__ = __webpack_require__(/*! ./col */ 226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_row__ = __webpack_require__(/*! ./form-row */ 173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BContainer */
/* unused harmony reexport BRow */
/* unused harmony reexport BCol */
/* unused harmony reexport BFormRow */





var LayoutPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BContainer: __WEBPACK_IMPORTED_MODULE_0__container__["a" /* BContainer */],
    BRow: __WEBPACK_IMPORTED_MODULE_1__row__["a" /* BRow */],
    BCol: __WEBPACK_IMPORTED_MODULE_2__col__["a" /* BCol */],
    BFormRow: __WEBPACK_IMPORTED_MODULE_3__form_row__["a" /* BFormRow */]
  }
});


/***/ }),
/* 390 */
/* exports provided: generateProps, BRow */
/* exports used: BRow */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/layout/row.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generateProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_config__ = __webpack_require__(/*! ../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_memoize__ = __webpack_require__(/*! ../../utils/memoize */ 255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Constants ---

var COMMON_ALIGNMENT = ['start', 'end', 'center']; // --- Helper methods ---
// Compute a `row-cols-{breakpoint}-{cols}` class name
// Memoized function for better performance on generating class names

var computeRowColsClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_memoize__["a" /* memoize */])(function (breakpoint, cols) {
  cols = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["f" /* trim */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["a" /* toString */])(cols));
  return cols ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["h" /* lowerCase */])(['row-cols', breakpoint, cols].filter(__WEBPACK_IMPORTED_MODULE_5__utils_identity__["a" /* identity */]).join('-')) : null;
}); // Get the breakpoint name from the `rowCols` prop name
// Memoized function for better performance on extracting breakpoint names

var computeRowColsBreakpoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_memoize__["a" /* memoize */])(function (prop) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["h" /* lowerCase */])(prop.replace('cols', ''));
}); // Cached copy of the `row-cols` breakpoint prop names
// Will be populated when the props are generated

var rowColsPropList = []; // --- Props ---
// Prop generator for lazy generation of props

var generateProps = function generateProps() {
  // i.e. 'row-cols-2', 'row-cols-md-4', 'row-cols-xl-6', ...
  var rowColsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["c" /* getBreakpointsUpCached */])().reduce(function (props, breakpoint) {
    props[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["e" /* suffixPropName */])(breakpoint, 'cols')] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */]);
    return props;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["i" /* create */])(null)); // Cache the row-cols prop names

  rowColsPropList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["a" /* keys */])(rowColsProps); // Return the generated props

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, rowColsProps), {}, {
    alignContent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], null, function (value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(COMMON_ALIGNMENT, 'between', 'around', 'stretch'), value);
    }),
    alignH: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], null, function (value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(COMMON_ALIGNMENT, 'between', 'around'), value);
    }),
    alignV: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], null, function (value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(COMMON_ALIGNMENT, 'baseline', 'stretch'), value);
    }),
    noGutters: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
  })), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_7" /* NAME_ROW */]);
}; // --- Main component ---
// We do not use `extend()` here as that would evaluate the props
// immediately, which we do not want to happen
// @vue/component

var BRow = {
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_7" /* NAME_ROW */],
  functional: true,

  get props() {
    // Allow props to be lazy evaled on first access and
    // then they become a non-getter afterwards
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get#Smart_self-overwriting_lazy_getters
    delete this.props;
    this.props = generateProps();
    return this.props;
  },

  render: function render(h, _ref) {
    var _classList$push;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var alignV = props.alignV,
        alignH = props.alignH,
        alignContent = props.alignContent; // Loop through row-cols breakpoint props and generate the classes

    var classList = [];
    rowColsPropList.forEach(function (prop) {
      var c = computeRowColsClass(computeRowColsBreakpoint(prop), props[prop]); // If a class is returned, push it onto the array

      if (c) {
        classList.push(c);
      }
    });
    classList.push((_classList$push = {
      'no-gutters': props.noGutters
    }, _defineProperty(_classList$push, "align-items-".concat(alignV), alignV), _defineProperty(_classList$push, "justify-content-".concat(alignH), alignH), _defineProperty(_classList$push, "align-content-".concat(alignContent), alignContent), _classList$push));
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'row',
      class: classList
    }), children);
  }
};

/***/ }),
/* 391 */
/* exports provided: LinkPlugin, BLink */
/* exports used: LinkPlugin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/link/index.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(/*! ./link */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BLink */


var LinkPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BLink: __WEBPACK_IMPORTED_MODULE_0__link__["a" /* BLink */]
  }
});


/***/ }),
/* 392 */
/* exports provided: ListGroupPlugin, BListGroup, BListGroupItem */
/* exports used: ListGroupPlugin */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/list-group/index.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListGroupPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_group__ = __webpack_require__(/*! ./list-group */ 394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list_group_item__ = __webpack_require__(/*! ./list-group-item */ 393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BListGroup */
/* unused harmony reexport BListGroupItem */



var ListGroupPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BListGroup: __WEBPACK_IMPORTED_MODULE_0__list_group__["a" /* BListGroup */],
    BListGroupItem: __WEBPACK_IMPORTED_MODULE_1__list_group_item__["a" /* BListGroupItem */]
  }
});


/***/ }),
/* 393 */
/* exports provided: props, BListGroupItem */
/* exports used: BListGroupItem */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/list-group/list-group-item.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BListGroupItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_router__ = __webpack_require__(/*! ../../utils/router */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









 // --- Constants ---

var actionTags = ['a', 'router-link', 'button', 'b-link']; // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_8__link_link__["b" /* props */], ['event', 'routerTag']);
delete linkProps.href.default;
delete linkProps.to.default;
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, linkProps), {}, {
  action: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  button: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["_3" /* NAME_LIST_GROUP_ITEM */]); // --- Main component ---
// @vue/component

var BListGroupItem = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_3" /* NAME_LIST_GROUP_ITEM */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var button = props.button,
        variant = props.variant,
        active = props.active,
        disabled = props.disabled;
    var link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_router__["a" /* isLink */])(props);
    var tag = button ? 'button' : !link ? props.tag : __WEBPACK_IMPORTED_MODULE_8__link_link__["a" /* BLink */];
    var action = !!(props.action || link || button || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(actionTags, props.tag));
    var attrs = {};
    var itemProps = {};

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["p" /* isTag */])(tag, 'button')) {
      if (!data.attrs || !data.attrs.type) {
        // Add a type for button is one not provided in passed attributes
        attrs.type = 'button';
      }

      if (props.disabled) {
        // Set disabled attribute if button and disabled
        attrs.disabled = true;
      }
    } else {
      itemProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["c" /* pluckProps */])(linkProps, props);
    }

    return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      attrs: attrs,
      props: itemProps,
      staticClass: 'list-group-item',
      class: (_class = {}, _defineProperty(_class, "list-group-item-".concat(variant), variant), _defineProperty(_class, 'list-group-item-action', action), _defineProperty(_class, "active", active), _defineProperty(_class, "disabled", disabled), _class)
    }), children);
  }
});

/***/ }),
/* 394 */
/* exports provided: props, BListGroup */
/* exports used: BListGroup */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/list-group/list-group.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BListGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])({
  flush: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  horizontal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_4" /* NAME_LIST_GROUP */]); // --- Main component ---
// @vue/component

var BListGroup = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_4" /* NAME_LIST_GROUP */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var horizontal = props.horizontal === '' ? true : props.horizontal;
    horizontal = props.flush ? false : horizontal;
    var componentData = {
      staticClass: 'list-group',
      class: _defineProperty({
        'list-group-flush': props.flush,
        'list-group-horizontal': horizontal === true
      }, "list-group-horizontal-".concat(horizontal), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["f" /* isString */])(horizontal))
    };
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, componentData), children);
  }
});

/***/ }),
/* 395 */
/* exports provided: MediaPlugin, BMedia, BMediaAside, BMediaBody */
/* exports used: MediaPlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/media/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media__ = __webpack_require__(/*! ./media */ 396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_aside__ = __webpack_require__(/*! ./media-aside */ 228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_body__ = __webpack_require__(/*! ./media-body */ 229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BMedia */
/* unused harmony reexport BMediaAside */
/* unused harmony reexport BMediaBody */




var MediaPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BMedia: __WEBPACK_IMPORTED_MODULE_0__media__["a" /* BMedia */],
    BMediaAside: __WEBPACK_IMPORTED_MODULE_1__media_aside__["a" /* BMediaAside */],
    BMediaBody: __WEBPACK_IMPORTED_MODULE_2__media_body__["a" /* BMediaBody */]
  }
});


/***/ }),
/* 396 */
/* exports provided: props, BMedia */
/* exports used: BMedia */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/media/media.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BMedia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_aside__ = __webpack_require__(/*! ./media-aside */ 228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_body__ = __webpack_require__(/*! ./media-body */ 229);







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])({
  noBody: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  rightAlign: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  verticalAlign: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'top')
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["_2" /* NAME_MEDIA */]); // --- Main component ---
// @vue/component

var BMedia = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_2" /* NAME_MEDIA */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots,
        children = _ref.children;
    var noBody = props.noBody,
        rightAlign = props.rightAlign,
        verticalAlign = props.verticalAlign;
    var $children = noBody ? children : [];

    if (!noBody) {
      var slotScope = {};
      var $slots = slots();
      var $scopedSlots = scopedSlots || {};
      $children.push(h(__WEBPACK_IMPORTED_MODULE_7__media_body__["a" /* BMediaBody */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], slotScope, $scopedSlots, $slots)));
      var $aside = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["M" /* SLOT_NAME_ASIDE */], slotScope, $scopedSlots, $slots);

      if ($aside) {
        $children[rightAlign ? 'push' : 'unshift'](h(__WEBPACK_IMPORTED_MODULE_6__media_aside__["a" /* BMediaAside */], {
          props: {
            right: rightAlign,
            verticalAlign: verticalAlign
          }
        }, $aside));
      }
    }

    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'media'
    }), $children);
  }
});

/***/ }),
/* 397 */
/* exports provided: BVModalPlugin */
/* exports used: BVModalPlugin */
/*!******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/modal/helpers/bv-modal.js ***!
  \******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVModalPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_use_parent__ = __webpack_require__(/*! ../../../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_config__ = __webpack_require__(/*! ../../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_plugins__ = __webpack_require__(/*! ../../../utils/plugins */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_warn__ = __webpack_require__(/*! ../../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_create_new_child_component__ = __webpack_require__(/*! ../../../utils/create-new-child-component */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__ = __webpack_require__(/*! ../../../utils/get-event-root */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal__ = __webpack_require__(/*! ../modal */ 230);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Plugin for adding `$bvModal` property to all Vue instances













 // --- Constants ---

var PROP_NAME = '$bvModal';
var PROP_NAME_PRIV = '_bv__modal'; // Base modal props that are allowed
// Some may be ignored or overridden on some message boxes
// Prop ID is allowed, but really only should be used for testing
// We need to add it in explicitly as it comes from the `idMixin`

var BASE_PROPS = ['id'].concat(_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["a" /* keys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_13__modal__["b" /* props */], ['busy', 'lazy', 'noStacking', 'static', 'visible'])))); // Fallback event resolver (returns undefined)

var defaultResolver = function defaultResolver() {}; // Map prop names to modal slot names


var propsToSlots = {
  msgBoxContent: 'default',
  title: 'modal-title',
  okTitle: 'modal-ok',
  cancelTitle: 'modal-cancel'
}; // --- Helper methods ---
// Method to filter only recognized props that are not undefined

var filterOptions = function filterOptions(options) {
  return BASE_PROPS.reduce(function (memo, key) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["i" /* isUndefined */])(options[key])) {
      memo[key] = options[key];
    }

    return memo;
  }, {});
}; // Method to install `$bvModal` VM injection


var plugin = function plugin(Vue) {
  // Create a private sub-component that extends BModal
  // which self-destructs after hidden
  // @vue/component
  var BMsgBox = Vue.extend({
    name: __WEBPACK_IMPORTED_MODULE_0__constants_components__["_77" /* NAME_MSG_BOX */],
    extends: __WEBPACK_IMPORTED_MODULE_13__modal__["a" /* BModal */],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_use_parent__["a" /* useParentMixin */]],
    destroyed: function destroyed() {
      // Make sure we not in document any more
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    mounted: function mounted() {
      var _this = this;

      // Self destruct handler
      var handleDestroy = function handleDestroy() {
        _this.$nextTick(function () {
          // In a `requestAF()` to release control back to application
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["a" /* requestAF */])(function () {
            _this.$destroy();
          });
        });
      }; // Self destruct if parent destroyed


      this.bvParent.$once(__WEBPACK_IMPORTED_MODULE_1__constants_events__["f" /* HOOK_EVENT_NAME_DESTROYED */], handleDestroy); // Self destruct after hidden

      this.$once(__WEBPACK_IMPORTED_MODULE_1__constants_events__["b" /* EVENT_NAME_HIDDEN */], handleDestroy); // Self destruct on route change

      /* istanbul ignore if */

      if (this.$router && this.$route) {
        // Destroy ourselves if route changes

        /* istanbul ignore next */
        this.$once(__WEBPACK_IMPORTED_MODULE_1__constants_events__["c" /* HOOK_EVENT_NAME_BEFORE_DESTROY */], this.$watch('$router', handleDestroy));
      } // Show the `BMsgBox`


      this.show();
    }
  }); // Method to generate the on-demand modal message box
  // Returns a promise that resolves to a value returned by the resolve

  var asyncMsgBox = function asyncMsgBox(parent, props) {
    var resolver = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultResolver;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["c" /* warnNotClient */])(PROP_NAME) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["d" /* warnNoPromiseSupport */])(PROP_NAME)) {
      /* istanbul ignore next */
      return;
    } // Create an instance of `BMsgBox` component
    // We set parent as the local VM so these modals can emit events on
    // the app `$root`, as needed by things like tooltips and popovers
    // And it helps to ensure `BMsgBox` is destroyed when parent is destroyed


    var msgBox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_create_new_child_component__["a" /* createNewChildComponent */])(parent, BMsgBox, {
      // Preset the prop values
      propsData: _objectSpread(_objectSpread(_objectSpread({}, filterOptions(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["b" /* NAME_MODAL */]))), {}, {
        // Defaults that user can override
        hideHeaderClose: true,
        hideHeader: !(props.title || props.titleHtml)
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["a" /* keys */])(propsToSlots))), {}, {
        // Props that can't be overridden
        lazy: false,
        busy: false,
        visible: false,
        noStacking: false,
        noEnforceFocus: false
      })
    }); // Convert certain props to scoped slots

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["a" /* keys */])(propsToSlots).forEach(function (prop) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["i" /* isUndefined */])(props[prop])) {
        // Can be a string, or array of VNodes.
        // Alternatively, user can use HTML version of prop to pass an HTML string.
        msgBox.$slots[propsToSlots[prop]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(props[prop]);
      }
    }); // Return a promise that resolves when hidden, or rejects on destroyed

    return new Promise(function (resolve, reject) {
      var resolved = false;
      msgBox.$once(__WEBPACK_IMPORTED_MODULE_1__constants_events__["f" /* HOOK_EVENT_NAME_DESTROYED */], function () {
        if (!resolved) {
          /* istanbul ignore next */
          reject(new Error('BootstrapVue MsgBox destroyed before resolve'));
        }
      });
      msgBox.$on(__WEBPACK_IMPORTED_MODULE_1__constants_events__["e" /* EVENT_NAME_HIDE */], function (bvModalEvent) {
        if (!bvModalEvent.defaultPrevented) {
          var result = resolver(bvModalEvent); // If resolver didn't cancel hide, we resolve

          if (!bvModalEvent.defaultPrevented) {
            resolved = true;
            resolve(result);
          }
        }
      }); // Create a mount point (a DIV) and mount the msgBo which will trigger it to show

      var div = document.createElement('div');
      document.body.appendChild(div);
      msgBox.$mount(div);
    });
  }; // Private utility method to open a user defined message box and returns a promise.
  // Not to be used directly by consumers, as this method may change calling syntax


  var makeMsgBox = function makeMsgBox(parent, content) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var resolver = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (!content || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["d" /* warnNoPromiseSupport */])(PROP_NAME) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["c" /* warnNotClient */])(PROP_NAME) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["a" /* isFunction */])(resolver)) {
      /* istanbul ignore next */
      return;
    }

    return asyncMsgBox(parent, _objectSpread(_objectSpread({}, filterOptions(options)), {}, {
      msgBoxContent: content
    }), resolver);
  }; // BvModal instance class


  var BvModal = /*#__PURE__*/function () {
    function BvModal(vm) {
      _classCallCheck(this, BvModal);

      // Assign the new properties to this instance
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["e" /* assign */])(this, {
        _vm: vm,
        _root: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__["a" /* getEventRoot */])(vm)
      }); // Set these properties as read-only and non-enumerable

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["f" /* defineProperties */])(this, {
        _vm: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["g" /* readonlyDescriptor */])(),
        _root: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["g" /* readonlyDescriptor */])()
      });
    } // --- Instance methods ---
    // Show modal with the specified ID args are for future use


    _createClass(BvModal, [{
      key: "show",
      value: function show(id) {
        if (id && this._root) {
          var _this$_root;

          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          (_this$_root = this._root).$emit.apply(_this$_root, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["b" /* NAME_MODAL */], 'show'), id].concat(args));
        }
      } // Hide modal with the specified ID args are for future use

    }, {
      key: "hide",
      value: function hide(id) {
        if (id && this._root) {
          var _this$_root2;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          (_this$_root2 = this._root).$emit.apply(_this$_root2, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["b" /* NAME_MODAL */], 'hide'), id].concat(args));
        }
      } // The following methods require Promise support!
      // IE 11 and others do not support Promise natively, so users
      // should have a Polyfill loaded (which they need anyways for IE 11 support)
      // Open a message box with OK button only and returns a promise

    }, {
      key: "msgBoxOk",
      value: function msgBoxOk(message) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // Pick the modal props we support from options
        var props = _objectSpread(_objectSpread({}, options), {}, {
          // Add in overrides and our content prop
          okOnly: true,
          okDisabled: false,
          hideFooter: false,
          msgBoxContent: message
        });

        return makeMsgBox(this._vm, message, props, function () {
          // Always resolve to true for OK
          return true;
        });
      } // Open a message box modal with OK and CANCEL buttons
      // and returns a promise

    }, {
      key: "msgBoxConfirm",
      value: function msgBoxConfirm(message) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        // Set the modal props we support from options
        var props = _objectSpread(_objectSpread({}, options), {}, {
          // Add in overrides and our content prop
          okOnly: false,
          okDisabled: false,
          cancelDisabled: false,
          hideFooter: false
        });

        return makeMsgBox(this._vm, message, props, function (bvModalEvent) {
          var trigger = bvModalEvent.trigger;
          return trigger === 'ok' ? true : trigger === 'cancel' ? false : null;
        });
      }
    }]);

    return BvModal;
  }(); // Add our instance mixin


  Vue.mixin({
    beforeCreate: function beforeCreate() {
      // Because we need access to `$root` for `$emits`, and VM for parenting,
      // we have to create a fresh instance of `BvModal` for each VM
      this[PROP_NAME_PRIV] = new BvModal(this);
    }
  }); // Define our read-only `$bvModal` instance property
  // Placed in an if just in case in HMR mode

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["c" /* hasOwnProperty */])(Vue.prototype, PROP_NAME)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["h" /* defineProperty */])(Vue.prototype, PROP_NAME, {
      get: function get() {
        /* istanbul ignore next */
        if (!this || !this[PROP_NAME_PRIV]) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["a" /* warn */])("\"".concat(PROP_NAME, "\" must be accessed from a Vue instance \"this\" context."), __WEBPACK_IMPORTED_MODULE_0__constants_components__["b" /* NAME_MODAL */]);
        }

        return this[PROP_NAME_PRIV];
      }
    });
  }
};

var BVModalPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_plugins__["b" /* pluginFactory */])({
  plugins: {
    plugin: plugin
  }
});

/***/ }),
/* 398 */
/* exports provided: ModalPlugin, BModal */
/* exports used: ModalPlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/modal/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(/*! ./modal */ 230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_modal_modal__ = __webpack_require__(/*! ../../directives/modal/modal */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_bv_modal__ = __webpack_require__(/*! ./helpers/bv-modal */ 397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BModal */




var ModalPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BModal: __WEBPACK_IMPORTED_MODULE_0__modal__["a" /* BModal */]
  },
  directives: {
    VBModal: __WEBPACK_IMPORTED_MODULE_1__directives_modal_modal__["a" /* VBModal */]
  },
  // $bvModal injection
  plugins: {
    BVModalPlugin: __WEBPACK_IMPORTED_MODULE_2__helpers_bv_modal__["a" /* BVModalPlugin */]
  }
});


/***/ }),
/* 399 */
/* exports provided: props, BNavForm */
/* exports used: BNavForm */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/nav/nav-form.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_form__ = __webpack_require__(/*! ../form/form */ 170);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var formProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_5__form_form__["b" /* props */], ['inline']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, formProps), {}, {
  formClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["W" /* NAME_NAV_FORM */]); // --- Main component ---
// @vue/component

var BNavForm = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["W" /* NAME_NAV_FORM */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children,
        listeners = _ref.listeners;
    var $form = h(__WEBPACK_IMPORTED_MODULE_5__form_form__["a" /* BForm */], {
      class: props.formClass,
      props: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["c" /* pluckProps */])(formProps, props)), {}, {
        inline: true
      }),
      attrs: data.attrs,
      on: listeners
    }, children);
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(data, ['attrs', 'on']), {
      staticClass: 'form-inline'
    }), [$form]);
  }
});

/***/ }),
/* 400 */
/* exports provided: props, BNavItemDropdown */
/* exports used: BNavItemDropdown */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/nav/nav-item-dropdown.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavItemDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_dropdown__ = __webpack_require__(/*! ../../mixins/dropdown */ 251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropdown_dropdown__ = __webpack_require__(/*! ../dropdown/dropdown */ 216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__mixins_id__["a" /* props */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["k" /* pick */])(__WEBPACK_IMPORTED_MODULE_9__dropdown_dropdown__["b" /* props */], [].concat(_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["a" /* keys */])(__WEBPACK_IMPORTED_MODULE_6__mixins_dropdown__["a" /* props */])), ['html', 'lazy', 'menuClass', 'noCaret', 'role', 'text', 'toggleClass'])))), __WEBPACK_IMPORTED_MODULE_1__constants_components__["T" /* NAME_NAV_ITEM_DROPDOWN */]); // --- Main component ---
// @vue/component

var BNavItemDropdown = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["T" /* NAME_NAV_ITEM_DROPDOWN */],
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_dropdown__["b" /* dropdownMixin */], __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  computed: {
    toggleId: function toggleId() {
      return this.safeId('_BV_toggle_');
    },
    menuId: function menuId() {
      return this.safeId('_BV_toggle_menu_');
    },
    dropdownClasses: function dropdownClasses() {
      return [this.directionClass, this.boundaryClass, {
        show: this.visible
      }];
    },
    menuClasses: function menuClasses() {
      return [this.menuClass, {
        'dropdown-menu-right': this.right,
        show: this.visible
      }];
    },
    toggleClasses: function toggleClasses() {
      return [this.toggleClass, {
        'dropdown-toggle-no-caret': this.noCaret
      }];
    }
  },
  render: function render(h) {
    var toggleId = this.toggleId,
        menuId = this.menuId,
        visible = this.visible,
        hide = this.hide;
    var $toggle = h(__WEBPACK_IMPORTED_MODULE_10__link_link__["a" /* BLink */], {
      staticClass: 'nav-link dropdown-toggle',
      class: this.toggleClasses,
      props: {
        href: "#".concat(this.id || ''),
        disabled: this.disabled
      },
      attrs: {
        id: toggleId,
        role: 'button',
        'aria-haspopup': 'true',
        'aria-expanded': visible ? 'true' : 'false',
        'aria-controls': menuId
      },
      on: {
        mousedown: this.onMousedown,
        click: this.toggle,
        keydown: this.toggle // Handle ENTER, SPACE and DOWN

      },
      ref: 'toggle'
    }, [// TODO: The `text` slot is deprecated in favor of the `button-content` slot
    this.normalizeSlot([__WEBPACK_IMPORTED_MODULE_2__constants_slots__["D" /* SLOT_NAME_BUTTON_CONTENT */], __WEBPACK_IMPORTED_MODULE_2__constants_slots__["E" /* SLOT_NAME_TEXT */]]) || h('span', {
      domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(this.html, this.text)
    })]);
    var $menu = h('ul', {
      staticClass: 'dropdown-menu',
      class: this.menuClasses,
      attrs: {
        tabindex: '-1',
        'aria-labelledby': toggleId,
        id: menuId
      },
      on: {
        keydown: this.onKeydown // Handle UP, DOWN and ESC

      },
      ref: 'menu'
    }, !this.lazy || visible ? this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_2__constants_slots__["a" /* SLOT_NAME_DEFAULT */], {
      hide: hide
    }) : [h()]);
    return h('li', {
      staticClass: 'nav-item b-nav-dropdown dropdown',
      class: this.dropdownClasses,
      attrs: {
        id: this.safeId()
      }
    }, [$toggle, $menu]);
  }
});

/***/ }),
/* 401 */
/* exports provided: props, BNavItem */
/* exports used: BNavItem */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/nav/nav-item.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_5__link_link__["b" /* props */], ['event', 'routerTag']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, linkProps), {}, {
  linkAttrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */], {}),
  linkClasses: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["V" /* NAME_NAV_ITEM */]); // --- Main component ---
// @vue/component

var BNavItem = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["V" /* NAME_NAV_ITEM */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        listeners = _ref.listeners,
        children = _ref.children;
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(data, ['on']), {
      staticClass: 'nav-item'
    }), [h(__WEBPACK_IMPORTED_MODULE_5__link_link__["a" /* BLink */], {
      staticClass: 'nav-link',
      class: props.linkClasses,
      attrs: props.linkAttrs,
      props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["c" /* pluckProps */])(linkProps, props),
      on: listeners
    }, children)]);
  }
});

/***/ }),
/* 402 */
/* exports provided: props, BNavText */
/* exports used: BNavText */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/nav/nav-text.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);

 // --- Props ---

var props = {}; // --- Main component ---
// @vue/component

var BNavText = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["S" /* NAME_NAV_TEXT */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;
    return h('li', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'navbar-text'
    }), children);
  }
});

/***/ }),
/* 403 */
/* exports provided: NavbarPlugin, BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle */
/* exports used: NavbarPlugin */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/navbar/index.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavbarPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar__ = __webpack_require__(/*! ./navbar */ 407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navbar_nav__ = __webpack_require__(/*! ./navbar-nav */ 405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_brand__ = __webpack_require__(/*! ./navbar-brand */ 404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__ = __webpack_require__(/*! ./navbar-toggle */ 406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav__ = __webpack_require__(/*! ../nav */ 231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collapse__ = __webpack_require__(/*! ../collapse */ 215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dropdown__ = __webpack_require__(/*! ../dropdown */ 166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BNavbar */
/* unused harmony reexport BNavbarNav */
/* unused harmony reexport BNavbarBrand */
/* unused harmony reexport BNavbarToggle */








var NavbarPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BNavbar: __WEBPACK_IMPORTED_MODULE_0__navbar__["a" /* BNavbar */],
    BNavbarNav: __WEBPACK_IMPORTED_MODULE_1__navbar_nav__["a" /* BNavbarNav */],
    BNavbarBrand: __WEBPACK_IMPORTED_MODULE_2__navbar_brand__["a" /* BNavbarBrand */],
    BNavbarToggle: __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__["a" /* BNavbarToggle */],
    BNavToggle: __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__["a" /* BNavbarToggle */]
  },
  plugins: {
    NavPlugin: __WEBPACK_IMPORTED_MODULE_4__nav__["a" /* NavPlugin */],
    CollapsePlugin: __WEBPACK_IMPORTED_MODULE_5__collapse__["a" /* CollapsePlugin */],
    DropdownPlugin: __WEBPACK_IMPORTED_MODULE_6__dropdown__["a" /* DropdownPlugin */]
  }
});


/***/ }),
/* 404 */
/* exports provided: props, BNavbarBrand */
/* exports used: BNavbarBrand */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/navbar/navbar-brand.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavbarBrand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_5__link_link__["b" /* props */], ['event', 'routerTag']);
linkProps.href.default = undefined;
linkProps.to.default = undefined;
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, linkProps), {}, {
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["Q" /* NAME_NAVBAR_BRAND */]); // --- Main component ---
// @vue/component

var BNavbarBrand = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["Q" /* NAME_NAVBAR_BRAND */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var isLink = props.to || props.href;
    var tag = isLink ? __WEBPACK_IMPORTED_MODULE_5__link_link__["a" /* BLink */] : props.tag;
    return h(tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'navbar-brand',
      props: isLink ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["c" /* pluckProps */])(linkProps, props) : {}
    }), children);
  }
});

/***/ }),
/* 405 */
/* exports provided: props, BNavbarNav */
/* exports used: BNavbarNav */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/navbar/navbar-nav.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavbarNav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav_nav__ = __webpack_require__(/*! ../nav/nav */ 174);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // --- Helper methods ---

var computeJustifyContent = function computeJustifyContent(value) {
  value = value === 'left' ? 'start' : value === 'right' ? 'end' : value;
  return "justify-content-".concat(value);
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["k" /* pick */])(__WEBPACK_IMPORTED_MODULE_4__nav_nav__["b" /* props */], ['tag', 'fill', 'justified', 'align', 'small']), __WEBPACK_IMPORTED_MODULE_1__constants_components__["P" /* NAME_NAVBAR_NAV */]); // --- Main component ---
// @vue/component

var BNavbarNav = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["P" /* NAME_NAVBAR_NAV */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    var align = props.align;
    return h(props.tag, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'navbar-nav',
      class: (_class = {
        'nav-fill': props.fill,
        'nav-justified': props.justified
      }, _defineProperty(_class, computeJustifyContent(align), align), _defineProperty(_class, "small", props.small), _class)
    }), children);
  }
});

/***/ }),
/* 406 */
/* exports provided: props, BNavbarToggle */
/* exports used: BNavbarToggle */
/*!****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/navbar/navbar-toggle.js ***!
  \****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavbarToggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_toggle_toggle__ = __webpack_require__(/*! ../../directives/toggle/toggle */ 247);









 // --- Constants ---

var CLASS_NAME = 'navbar-toggler';
var ROOT_EVENT_NAME_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'state');
var ROOT_EVENT_NAME_SYNC_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'sync-state'); // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Toggle navigation'),
  target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */], undefined, true) // Required

}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["O" /* NAME_NAVBAR_TOGGLE */]); // --- Main component ---
// @vue/component

var BNavbarToggle = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["O" /* NAME_NAVBAR_TOGGLE */],
  directives: {
    VBToggle: __WEBPACK_IMPORTED_MODULE_9__directives_toggle_toggle__["a" /* VBToggle */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    return {
      toggleState: false
    };
  },
  created: function created() {
    this.listenOnRoot(ROOT_EVENT_NAME_STATE, this.handleStateEvent);
    this.listenOnRoot(ROOT_EVENT_NAME_SYNC_STATE, this.handleStateEvent);
  },
  methods: {
    onClick: function onClick(event) {
      if (!this.disabled) {
        // Emit courtesy `click` event
        this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["x" /* EVENT_NAME_CLICK */], event);
      }
    },
    handleStateEvent: function handleStateEvent(id, state) {
      // We listen for state events so that we can pass the
      // boolean expanded state to the default scoped slot
      if (id === this.target) {
        this.toggleState = state;
      }
    }
  },
  render: function render(h) {
    var disabled = this.disabled;
    return h('button', {
      staticClass: CLASS_NAME,
      class: {
        disabled: disabled
      },
      directives: [{
        name: 'VBToggle',
        value: this.target
      }],
      attrs: {
        type: 'button',
        disabled: disabled,
        'aria-label': this.label
      },
      on: {
        click: this.onClick
      }
    }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["a" /* SLOT_NAME_DEFAULT */], {
      expanded: this.toggleState
    }) || h('span', {
      staticClass: "".concat(CLASS_NAME, "-icon")
    })]);
  }
});

/***/ }),
/* 407 */
/* exports provided: props, BNavbar */
/* exports used: BNavbar */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/navbar/navbar.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BNavbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_config__ = __webpack_require__(/*! ../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])({
  fixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  print: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  sticky: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'nav'),
  toggleable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'light'),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["R" /* NAME_NAVBAR */]); // --- Main component ---
// @vue/component

var BNavbar = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["R" /* NAME_NAVBAR */],
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvNavbar: function getBvNavbar() {
        return _this;
      }
    };
  },
  props: props,
  computed: {
    breakpointClass: function breakpointClass() {
      var toggleable = this.toggleable;
      var xs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_config__["b" /* getBreakpoints */])()[0];
      var breakpoint = null;

      if (toggleable && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["f" /* isString */])(toggleable) && toggleable !== xs) {
        breakpoint = "navbar-expand-".concat(toggleable);
      } else if (toggleable === false) {
        breakpoint = 'navbar-expand';
      }

      return breakpoint;
    }
  },
  render: function render(h) {
    var _ref;

    var tag = this.tag,
        type = this.type,
        variant = this.variant,
        fixed = this.fixed;
    return h(tag, {
      staticClass: 'navbar',
      class: [(_ref = {
        'd-print': this.print,
        'sticky-top': this.sticky
      }, _defineProperty(_ref, "navbar-".concat(type), type), _defineProperty(_ref, "bg-".concat(variant), variant), _defineProperty(_ref, "fixed-".concat(fixed), fixed), _ref), this.breakpointClass],
      attrs: {
        role: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["p" /* isTag */])(tag, 'nav') ? null : 'navigation'
      }
    }, [this.normalizeSlot()]);
  }
});

/***/ }),
/* 408 */
/* exports provided: OverlayPlugin, BOverlay */
/* exports used: OverlayPlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/overlay/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlay__ = __webpack_require__(/*! ./overlay */ 409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BOverlay */


var OverlayPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BOverlay: __WEBPACK_IMPORTED_MODULE_0__overlay__["a" /* BOverlay */]
  }
});


/***/ }),
/* 409 */
/* exports provided: props, BOverlay */
/* exports used: BOverlay */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/overlay/overlay.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__spinner_spinner__ = __webpack_require__(/*! ../spinner/spinner */ 233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transition_bv_transition__ = __webpack_require__(/*! ../transition/bv-transition */ 108);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Constants ---

var POSITION_COVER = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
}; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["b" /* makePropsConfigurable */])({
  // Alternative to variant, allowing a specific
  // CSS color to be applied to the overlay
  bgColor: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  blur: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], '2px'),
  fixed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noFade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // If `true, does not render the default slot
  // and switches to absolute positioning
  noWrap: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  opacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0.85, function (value) {
    var number = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_number__["a" /* toFloat */])(value, 0);
    return number >= 0 && number <= 1;
  }),
  overlayTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  rounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  show: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  spinnerSmall: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  spinnerType: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'border'),
  spinnerVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'light'),
  wrapTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  zIndex: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 10)
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["N" /* NAME_OVERLAY */]); // --- Main component ---
// @vue/component

var BOverlay = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["N" /* NAME_OVERLAY */],
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  computed: {
    computedRounded: function computedRounded() {
      var rounded = this.rounded;
      return rounded === true || rounded === '' ? 'rounded' : !rounded ? '' : "rounded-".concat(rounded);
    },
    computedVariant: function computedVariant() {
      var variant = this.variant;
      return variant && !this.bgColor ? "bg-".concat(variant) : '';
    },
    slotScope: function slotScope() {
      return {
        spinnerType: this.spinnerType || null,
        spinnerVariant: this.spinnerVariant || null,
        spinnerSmall: this.spinnerSmall
      };
    }
  },
  methods: {
    defaultOverlayFn: function defaultOverlayFn(_ref) {
      var spinnerType = _ref.spinnerType,
          spinnerVariant = _ref.spinnerVariant,
          spinnerSmall = _ref.spinnerSmall;
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_8__spinner_spinner__["a" /* BSpinner */], {
        props: {
          type: spinnerType,
          variant: spinnerVariant,
          small: spinnerSmall
        }
      });
    }
  },
  render: function render(h) {
    var _this = this;

    var show = this.show,
        fixed = this.fixed,
        noFade = this.noFade,
        noWrap = this.noWrap,
        slotScope = this.slotScope;
    var $overlay = h();

    if (show) {
      var $background = h('div', {
        staticClass: 'position-absolute',
        class: [this.computedVariant, this.computedRounded],
        style: _objectSpread(_objectSpread({}, POSITION_COVER), {}, {
          opacity: this.opacity,
          backgroundColor: this.bgColor || null,
          backdropFilter: this.blur ? "blur(".concat(this.blur, ")") : null
        })
      });
      var $content = h('div', {
        staticClass: 'position-absolute',
        style: this.noCenter ?
        /* istanbul ignore next */
        _objectSpread({}, POSITION_COVER) : {
          top: '50%',
          left: '50%',
          transform: 'translateX(-50%) translateY(-50%)'
        }
      }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["C" /* SLOT_NAME_OVERLAY */], slotScope) || this.defaultOverlayFn(slotScope)]);
      $overlay = h(this.overlayTag, {
        staticClass: 'b-overlay',
        class: {
          'position-absolute': !noWrap || noWrap && !fixed,
          'position-fixed': noWrap && fixed
        },
        style: _objectSpread(_objectSpread({}, POSITION_COVER), {}, {
          zIndex: this.zIndex || 10
        }),
        on: {
          click: function click(event) {
            return _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["x" /* EVENT_NAME_CLICK */], event);
          }
        },
        key: 'overlay'
      }, [$background, $content]);
    } // Wrap in a fade transition


    $overlay = h(__WEBPACK_IMPORTED_MODULE_9__transition_bv_transition__["a" /* BVTransition */], {
      props: {
        noFade: noFade,
        appear: true
      },
      on: {
        'after-enter': function afterEnter() {
          return _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["d" /* EVENT_NAME_SHOWN */]);
        },
        'after-leave': function afterLeave() {
          return _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["b" /* EVENT_NAME_HIDDEN */]);
        }
      }
    }, [$overlay]);

    if (noWrap) {
      return $overlay;
    }

    return h(this.wrapTag, {
      staticClass: 'b-overlay-wrap position-relative',
      attrs: {
        'aria-busy': show ? 'true' : null
      }
    }, noWrap ? [$overlay] : [this.normalizeSlot(), $overlay]);
  }
});

/***/ }),
/* 410 */
/* exports provided: PaginationNavPlugin, BPaginationNav */
/* exports used: PaginationNavPlugin */
/*!****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/pagination-nav/index.js ***!
  \****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationNavPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagination_nav__ = __webpack_require__(/*! ./pagination-nav */ 411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BPaginationNav */


var PaginationNavPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BPaginationNav: __WEBPACK_IMPORTED_MODULE_0__pagination_nav__["a" /* BPaginationNav */]
  }
});


/***/ }),
/* 411 */
/* exports provided: sanitizeNumberOfPages, BPaginationNav */
/* exports used: BPaginationNav */
/*!*************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/pagination-nav/pagination-nav.js ***!
  \*************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sanitizeNumberOfPages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BPaginationNav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__ = __webpack_require__(/*! ../../utils/bv-event.class */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_router__ = __webpack_require__(/*! ../../utils/router */ 110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_warn__ = __webpack_require__(/*! ../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_pagination__ = __webpack_require__(/*! ../../mixins/pagination */ 462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__link_link__ = __webpack_require__(/*! ../link/link */ 53);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















 // --- Helper methods ---
// Sanitize the provided number of pages (converting to a number)

var sanitizeNumberOfPages = function sanitizeNumberOfPages(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(value, 0), 1);
}; // --- Props ---

var _linkProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_17__link_link__["b" /* props */], ['event', 'routerTag']);

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__mixins_pagination__["a" /* props */]), _linkProps), {}, {
  baseUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], '/'),
  linkGen: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  // Disable auto page number detection if `true`
  noPageDetect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  numberOfPages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 1,
  /* istanbul ignore next */
  function (value) {
    var number = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(value, 0);

    if (number < 1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_warn__["a" /* warn */])('Prop "number-of-pages" must be a number greater than "0"', __WEBPACK_IMPORTED_MODULE_1__constants_components__["L" /* NAME_PAGINATION_NAV */]);
      return false;
    }

    return true;
  }),
  pageGen: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  // Optional array of page links
  pages: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["o" /* PROP_TYPE_ARRAY */]),
  useRouter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["L" /* NAME_PAGINATION_NAV */]); // --- Main component ---
// @vue/component

var BPaginationNav = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["L" /* NAME_PAGINATION_NAV */],
  // The render function is brought in via the pagination mixin
  mixins: [__WEBPACK_IMPORTED_MODULE_16__mixins_pagination__["b" /* paginationMixin */]],
  props: props,
  computed: {
    // Used by render function to trigger wrapping in '<nav>' element
    isNav: function isNav() {
      return true;
    },
    computedValue: function computedValue() {
      // Returns the value prop as a number or `null` if undefined or < 1
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(this.value, 0);
      return value < 1 ? null : value;
    }
  },
  watch: {
    numberOfPages: function numberOfPages() {
      var _this = this;

      this.$nextTick(function () {
        _this.setNumberOfPages();
      });
    },
    pages: function pages() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.setNumberOfPages();
      });
    }
  },
  created: function created() {
    this.setNumberOfPages();
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.$router) {
      // We only add the watcher if vue router is detected
      this.$watch('$route', function () {
        _this3.$nextTick(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* requestAF */])(function () {
            _this3.guessCurrentPage();
          });
        });
      });
    }
  },
  methods: {
    setNumberOfPages: function setNumberOfPages() {
      var _this4 = this;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["c" /* isArray */])(this.pages) && this.pages.length > 0) {
        this.localNumberOfPages = this.pages.length;
      } else {
        this.localNumberOfPages = sanitizeNumberOfPages(this.numberOfPages);
      }

      this.$nextTick(function () {
        _this4.guessCurrentPage();
      });
    },
    onClick: function onClick(event, pageNumber) {
      var _this5 = this;

      // Dont do anything if clicking the current active page
      if (pageNumber === this.currentPage) {
        return;
      }

      var target = event.currentTarget || event.target; // Emit a user-cancelable `page-click` event

      var clickEvent = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* BvEvent */](__WEBPACK_IMPORTED_MODULE_3__constants_events__["T" /* EVENT_NAME_PAGE_CLICK */], {
        cancelable: true,
        vueTarget: this,
        target: target
      });
      this.$emit(clickEvent.type, clickEvent, pageNumber);

      if (clickEvent.defaultPrevented) {
        return;
      } // Update the `v-model`
      // Done in in requestAF() to allow browser to complete the
      // native browser click handling of a link


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* requestAF */])(function () {
        _this5.currentPage = pageNumber;

        _this5.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["w" /* EVENT_NAME_CHANGE */], pageNumber);
      }); // Emulate native link click page reloading behaviour by blurring the
      // paginator and returning focus to the document
      // Done in a `nextTick()` to ensure rendering complete

      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["A" /* attemptBlur */])(target);
      });
    },
    getPageInfo: function getPageInfo(pageNumber) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["c" /* isArray */])(this.pages) || this.pages.length === 0 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["i" /* isUndefined */])(this.pages[pageNumber - 1])) {
        var link = "".concat(this.baseUrl).concat(pageNumber);
        return {
          link: this.useRouter ? {
            path: link
          } : link,
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_string__["a" /* toString */])(pageNumber)
        };
      }

      var info = this.pages[pageNumber - 1];

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["d" /* isObject */])(info)) {
        var _link = info.link;
        return {
          // Normalize link for router use
          link: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["d" /* isObject */])(_link) ? _link : this.useRouter ? {
            path: _link
          } : _link,
          // Make sure text has a value
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_string__["a" /* toString */])(info.text || pageNumber)
        };
      } else {
        return {
          link: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_string__["a" /* toString */])(info),
          text: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_string__["a" /* toString */])(pageNumber)
        };
      }
    },
    makePage: function makePage(pageNumber) {
      var pageGen = this.pageGen;
      var info = this.getPageInfo(pageNumber);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["d" /* hasPropFunction */])(pageGen)) {
        return pageGen(pageNumber, info);
      }

      return info.text;
    },
    makeLink: function makeLink(pageNumber) {
      var linkGen = this.linkGen;
      var info = this.getPageInfo(pageNumber);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["d" /* hasPropFunction */])(linkGen)) {
        return linkGen(pageNumber, info);
      }

      return info.link;
    },
    linkProps: function linkProps(pageNumber) {
      var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_props__["c" /* pluckProps */])(_linkProps, this);
      var link = this.makeLink(pageNumber);

      if (this.useRouter || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["d" /* isObject */])(link)) {
        props.to = link;
      } else {
        props.href = link;
      }

      return props;
    },
    resolveLink: function resolveLink() {
      var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // Given a to (or href string), convert to normalized route-like structure
      // Works only client side!
      var link;

      try {
        // Convert the `to` to a HREF via a temporary `a` tag
        link = document.createElement('a');
        link.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_router__["e" /* computeHref */])({
          to: to
        }, 'a', '/', '/'); // We need to add the anchor to the document to make sure the
        // `pathname` is correctly detected in any browser (i.e. IE)

        document.body.appendChild(link); // Once href is assigned, the link will be normalized to the full URL bits

        var _link2 = link,
            pathname = _link2.pathname,
            hash = _link2.hash,
            search = _link2.search; // Remove link from document

        document.body.removeChild(link); // Return the location in a route-like object

        return {
          path: pathname,
          hash: hash,
          query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_router__["f" /* parseQuery */])(search)
        };
      } catch (e) {
        /* istanbul ignore next */
        try {
          link && link.parentNode && link.parentNode.removeChild(link);
        } catch (_unused) {}
        /* istanbul ignore next */


        return {};
      }
    },
    resolveRoute: function resolveRoute() {
      var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      // Given a to (or href string), convert to normalized route location structure
      // Works only when router available!
      try {
        var route = this.$router.resolve(to, this.$route).route;
        return {
          path: route.path,
          hash: route.hash,
          query: route.query
        };
      } catch (e) {
        /* istanbul ignore next */
        return {};
      }
    },
    guessCurrentPage: function guessCurrentPage() {
      var $router = this.$router,
          $route = this.$route;
      var guess = this.computedValue; // This section only occurs if we are client side, or server-side with `$router`

      if (!this.noPageDetect && !guess && (__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] || !__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] && $router)) {
        // Current route (if router available)
        var currentRoute = $router && $route ? {
          path: $route.path,
          hash: $route.hash,
          query: $route.query
        } : {}; // Current page full HREF (if client side)
        // Can't be done as a computed prop!

        var loc = __WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] ? window.location || document.location : null;
        var currentLink = loc ? {
          path: loc.pathname,
          hash: loc.hash,
          query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_router__["f" /* parseQuery */])(loc.search)
        } :
        /* istanbul ignore next */
        {}; // Loop through the possible pages looking for a match until found

        for (var pageNumber = 1; !guess && pageNumber <= this.localNumberOfPages; pageNumber++) {
          var to = this.makeLink(pageNumber);

          if ($router && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["d" /* isObject */])(to) || this.useRouter)) {
            // Resolve the page via the `$router`
            guess = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_loose_equal__["a" /* looseEqual */])(this.resolveRoute(to), currentRoute) ? pageNumber : null;
          } else if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */]) {
            // If no `$router` available (or `!this.useRouter` when `to` is a string)
            // we compare using parsed URIs
            guess = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_loose_equal__["a" /* looseEqual */])(this.resolveLink(to), currentLink) ? pageNumber : null;
          } else {
            // Probably SSR, but no `$router` so we can't guess,
            // so lets break out of the loop early

            /* istanbul ignore next */
            guess = -1;
          }
        }
      } // We set `currentPage` to `0` to trigger an `$emit('input', null)`
      // As the default for `currentPage` is `-1` when no value is specified
      // Valid page numbers are greater than `0`


      this.currentPage = guess > 0 ? guess : 0;
    }
  }
});

/***/ }),
/* 412 */
/* exports provided: PaginationPlugin, BPagination */
/* exports used: PaginationPlugin */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/pagination/index.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagination__ = __webpack_require__(/*! ./pagination */ 413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BPagination */


var PaginationPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BPagination: __WEBPACK_IMPORTED_MODULE_0__pagination__["a" /* BPagination */]
  }
});


/***/ }),
/* 413 */
/* exports provided: props, BPagination */
/* exports used: BPagination */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/pagination/pagination.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BPagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bv_event_class__ = __webpack_require__(/*! ../../utils/bv-event.class */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_pagination__ = __webpack_require__(/*! ../../mixins/pagination */ 462);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












 // --- Constants ---

var DEFAULT_PER_PAGE = 20;
var DEFAULT_TOTAL_ROWS = 0; // --- Helper methods ---
// Sanitize the provided per page number (converting to a number)

var sanitizePerPage = function sanitizePerPage(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(value) || DEFAULT_PER_PAGE, 1);
}; // Sanitize the provided total rows number (converting to a number)


var sanitizeTotalRows = function sanitizeTotalRows(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(value) || DEFAULT_TOTAL_ROWS, 0);
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_11__mixins_pagination__["a" /* props */]), {}, {
  ariaControls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  perPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_PER_PAGE),
  totalRows: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_TOTAL_ROWS)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["M" /* NAME_PAGINATION */]); // --- Main component ---
// @vue/component

var BPagination = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["M" /* NAME_PAGINATION */],
  // The render function is brought in via the `paginationMixin`
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_pagination__["b" /* paginationMixin */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math__["f" /* mathCeil */])(sanitizeTotalRows(this.totalRows) / sanitizePerPage(this.perPage));
      return result < 1 ? 1 : result;
    },
    // Used for watching changes to `perPage` and `numberOfPages`
    pageSizeNumberOfPages: function pageSizeNumberOfPages() {
      return {
        perPage: sanitizePerPage(this.perPage),
        totalRows: sanitizeTotalRows(this.totalRows),
        numberOfPages: this.numberOfPages
      };
    }
  },
  watch: {
    pageSizeNumberOfPages: function pageSizeNumberOfPages(newValue, oldValue) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["g" /* isUndefinedOrNull */])(oldValue)) {
        if (newValue.perPage !== oldValue.perPage && newValue.totalRows === oldValue.totalRows) {
          // If the page size changes, reset to page 1
          this.currentPage = 1;
        } else if (newValue.numberOfPages !== oldValue.numberOfPages && this.currentPage > newValue.numberOfPages) {
          // If `numberOfPages` changes and is less than
          // the `currentPage` number, reset to page 1
          this.currentPage = 1;
        }
      }

      this.localNumberOfPages = newValue.numberOfPages;
    }
  },
  created: function created() {
    var _this = this;

    // Set the initial page count
    this.localNumberOfPages = this.numberOfPages; // Set the initial page value

    var currentPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(this[__WEBPACK_IMPORTED_MODULE_11__mixins_pagination__["c" /* MODEL_PROP_NAME */]], 0);

    if (currentPage > 0) {
      this.currentPage = currentPage;
    } else {
      this.$nextTick(function () {
        // If this value parses to `NaN` or a value less than `1`
        // trigger an initial emit of `null` if no page specified
        _this.currentPage = 0;
      });
    }
  },
  methods: {
    // These methods are used by the render function
    onClick: function onClick(event, pageNumber) {
      var _this2 = this;

      // Dont do anything if clicking the current active page
      if (pageNumber === this.currentPage) {
        return;
      }

      var target = event.target; // Emit a user-cancelable `page-click` event

      var clickEvent = new __WEBPACK_IMPORTED_MODULE_4__utils_bv_event_class__["a" /* BvEvent */](__WEBPACK_IMPORTED_MODULE_2__constants_events__["T" /* EVENT_NAME_PAGE_CLICK */], {
        cancelable: true,
        vueTarget: this,
        target: target
      });
      this.$emit(clickEvent.type, clickEvent, pageNumber);

      if (clickEvent.defaultPrevented) {
        return;
      } // Update the `v-model`


      this.currentPage = pageNumber; // Emit event triggered by user interaction

      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */], this.currentPage); // Keep the current button focused if possible

      this.$nextTick(function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["c" /* isVisible */])(target) && _this2.$el.contains(target)) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(target);
        } else {
          _this2.focusCurrent();
        }
      });
    },
    makePage: function makePage(pageNum) {
      return pageNum;
    },

    /* istanbul ignore next */
    linkProps: function linkProps() {
      // No props, since we render a plain button
      return {};
    }
  }
});

/***/ }),
/* 414 */
/* exports provided: BVPopover */
/* exports used: BVPopover */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/popover/helpers/bv-popover.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_helpers_bv_tooltip__ = __webpack_require__(/*! ../../tooltip/helpers/bv-tooltip */ 242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bv_popover_template__ = __webpack_require__(/*! ./bv-popover-template */ 928);
// Popover "Class" (Built as a renderless Vue instance)
// Inherits from BVTooltip
//
// Handles trigger events, etc.
// Instantiates template on demand



 // @vue/component

var BVPopover = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["i" /* NAME_POPOVER_HELPER */],
  extends: __WEBPACK_IMPORTED_MODULE_2__tooltip_helpers_bv_tooltip__["a" /* BVTooltip */],
  computed: {
    // Overwrites BVTooltip
    templateType: function templateType() {
      return 'popover';
    }
  },
  methods: {
    getTemplate: function getTemplate() {
      // Overwrites BVTooltip
      return __WEBPACK_IMPORTED_MODULE_3__bv_popover_template__["a" /* BVPopoverTemplate */];
    }
  }
});

/***/ }),
/* 415 */
/* exports provided: PopoverPlugin, BPopover */
/* exports used: PopoverPlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/popover/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popover__ = __webpack_require__(/*! ./popover */ 416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_popover__ = __webpack_require__(/*! ../../directives/popover */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BPopover */



var PopoverPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BPopover: __WEBPACK_IMPORTED_MODULE_0__popover__["a" /* BPopover */]
  },
  plugins: {
    VBPopoverPlugin: __WEBPACK_IMPORTED_MODULE_1__directives_popover__["a" /* VBPopoverPlugin */]
  }
});


/***/ }),
/* 416 */
/* exports provided: props, BPopover */
/* exports used: BPopover */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/popover/popover.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip_tooltip__ = __webpack_require__(/*! ../tooltip/tooltip */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_bv_popover__ = __webpack_require__(/*! ./helpers/bv-popover */ 414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__tooltip_tooltip__["b" /* props */]), {}, {
  content: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  placement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'right'),
  triggers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */], __WEBPACK_IMPORTED_MODULE_2__constants_events__["x" /* EVENT_NAME_CLICK */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["h" /* NAME_POPOVER */]); // --- Main component ---
// @vue/component

var BPopover = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["h" /* NAME_POPOVER */],
  extends: __WEBPACK_IMPORTED_MODULE_6__tooltip_tooltip__["a" /* BTooltip */],
  inheritAttrs: false,
  props: props,
  methods: {
    getComponent: function getComponent() {
      // Overridden by BPopover
      return __WEBPACK_IMPORTED_MODULE_7__helpers_bv_popover__["a" /* BVPopover */];
    },
    updateContent: function updateContent() {
      // Tooltip: Default slot is `title`
      // Popover: Default slot is `content`, `title` slot is title
      // We pass a scoped slot function references by default (Vue v2.6x)
      // And pass the title prop as a fallback
      this.setContent(this.normalizeSlot() || this.content);
      this.setTitle(this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["e" /* SLOT_NAME_TITLE */]) || this.title);
    }
  } // Render function provided by BTooltip

});

/***/ }),
/* 417 */
/* exports provided: ProgressPlugin, BProgress, BProgressBar */
/* exports used: ProgressPlugin */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/progress/index.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(/*! ./progress */ 418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_bar__ = __webpack_require__(/*! ./progress-bar */ 232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BProgress */
/* unused harmony reexport BProgressBar */



var ProgressPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BProgress: __WEBPACK_IMPORTED_MODULE_0__progress__["a" /* BProgress */],
    BProgressBar: __WEBPACK_IMPORTED_MODULE_1__progress_bar__["a" /* BProgressBar */]
  }
});


/***/ }),
/* 418 */
/* exports provided: props, BProgress */
/* exports used: BProgress */
/*!*************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/progress/progress.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BProgress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__progress_bar__ = __webpack_require__(/*! ./progress-bar */ 232);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var progressBarProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_6__progress_bar__["b" /* props */], ['label', 'labelHtml']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, progressBarProps), {}, {
  animated: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  max: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 100),
  precision: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  showProgress: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  showValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  striped: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["K" /* NAME_PROGRESS */]); // --- Main component ---
// @vue/component

var BProgress = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["K" /* NAME_PROGRESS */],
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvProgress: function getBvProgress() {
        return _this;
      }
    };
  },
  props: props,
  computed: {
    progressHeight: function progressHeight() {
      return {
        height: this.height || null
      };
    }
  },
  render: function render(h) {
    var $childNodes = this.normalizeSlot();

    if (!$childNodes) {
      $childNodes = h(__WEBPACK_IMPORTED_MODULE_6__progress_bar__["a" /* BProgressBar */], {
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["c" /* pluckProps */])(progressBarProps, this.$props)
      });
    }

    return h('div', {
      staticClass: 'progress',
      style: this.progressHeight
    }, [$childNodes]);
  }
});

/***/ }),
/* 419 */
/* exports provided: SidebarPlugin, BSidebar */
/* exports used: SidebarPlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/sidebar/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SidebarPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar__ = __webpack_require__(/*! ./sidebar */ 420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_toggle__ = __webpack_require__(/*! ../../directives/toggle */ 179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BSidebar */



var SidebarPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BSidebar: __WEBPACK_IMPORTED_MODULE_0__sidebar__["a" /* BSidebar */]
  },
  plugins: {
    VBTogglePlugin: __WEBPACK_IMPORTED_MODULE_1__directives_toggle__["a" /* VBTogglePlugin */]
  }
});


/***/ }),
/* 420 */
/* exports provided: props, BSidebar */
/* exports used: BSidebar */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/sidebar/sidebar.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSidebar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_listen_on_root__ = __webpack_require__(/*! ../../mixins/listen-on-root */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__icons_icons__ = __webpack_require__(/*! ../../icons/icons */ 61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__button_button_close__ = __webpack_require__(/*! ../button/button-close */ 107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__transition_bv_transition__ = __webpack_require__(/*! ../transition/bv-transition */ 108);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















 // --- Constants ---

var CLASS_NAME = 'b-sidebar';
var ROOT_ACTION_EVENT_NAME_REQUEST_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'request-state');
var ROOT_ACTION_EVENT_NAME_TOGGLE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'toggle');
var ROOT_EVENT_NAME_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'state');
var ROOT_EVENT_NAME_SYNC_STATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["g" /* NAME_COLLAPSE */], 'sync-state');

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_model__["a" /* makeModelMixin */])('visible', {
  type: __WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */],
  defaultValue: false,
  event: __WEBPACK_IMPORTED_MODULE_3__constants_events__["w" /* EVENT_NAME_CHANGE */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_13__mixins_id__["a" /* props */]), modelProps), {}, {
  ariaLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  ariaLabelledby: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  // If `true`, shows a basic backdrop
  backdrop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  backdropVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'dark'),
  bgVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'light'),
  bodyClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  // `aria-label` for close button
  closeLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  footerClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  footerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'footer'),
  headerClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  headerTag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'header'),
  lazy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noCloseOnBackdrop: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noCloseOnEsc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noCloseOnRouteChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noEnforceFocus: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noHeader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noHeaderClose: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noSlide: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  right: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  shadow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  sidebarClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'div'),
  textVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'dark'),
  title: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
  zIndex: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */])
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["I" /* NAME_SIDEBAR */]); // --- Render methods ---

var renderHeaderTitle = function renderHeaderTitle(h, ctx) {
  // Render a empty `<span>` when to title was provided
  var title = ctx.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["e" /* SLOT_NAME_TITLE */], ctx.slotScope) || ctx.title;

  if (!title) {
    return h('span');
  }

  return h('strong', {
    attrs: {
      id: ctx.safeId('__title__')
    }
  }, [title]);
};

var renderHeaderClose = function renderHeaderClose(h, ctx) {
  if (ctx.noHeaderClose) {
    return h();
  }

  var closeLabel = ctx.closeLabel,
      textVariant = ctx.textVariant,
      hide = ctx.hide;
  return h(__WEBPACK_IMPORTED_MODULE_17__button_button_close__["a" /* BButtonClose */], {
    props: {
      ariaLabel: closeLabel,
      textVariant: textVariant
    },
    on: {
      click: hide
    },
    ref: 'close-button'
  }, [ctx.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["t" /* SLOT_NAME_HEADER_CLOSE */]) || h(__WEBPACK_IMPORTED_MODULE_16__icons_icons__["_1306" /* BIconX */])]);
};

var renderHeader = function renderHeader(h, ctx) {
  if (ctx.noHeader) {
    return h();
  }

  var $content = ctx.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["u" /* SLOT_NAME_HEADER */], ctx.slotScope);

  if (!$content) {
    var $title = renderHeaderTitle(h, ctx);
    var $close = renderHeaderClose(h, ctx);
    $content = ctx.right ? [$close, $title] : [$title, $close];
  }

  return h(ctx.headerTag, {
    staticClass: "".concat(CLASS_NAME, "-header"),
    class: ctx.headerClass,
    key: 'header'
  }, $content);
};

var renderBody = function renderBody(h, ctx) {
  return h('div', {
    staticClass: "".concat(CLASS_NAME, "-body"),
    class: ctx.bodyClass,
    key: 'body'
  }, [ctx.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["a" /* SLOT_NAME_DEFAULT */], ctx.slotScope)]);
};

var renderFooter = function renderFooter(h, ctx) {
  var $footer = ctx.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["v" /* SLOT_NAME_FOOTER */], ctx.slotScope);

  if (!$footer) {
    return h();
  }

  return h(ctx.footerTag, {
    staticClass: "".concat(CLASS_NAME, "-footer"),
    class: ctx.footerClass,
    key: 'footer'
  }, [$footer]);
};

var renderContent = function renderContent(h, ctx) {
  // We render the header even if `lazy` is enabled as it
  // acts as the accessible label for the sidebar
  var $header = renderHeader(h, ctx);

  if (ctx.lazy && !ctx.isOpen) {
    return $header;
  }

  return [$header, renderBody(h, ctx), renderFooter(h, ctx)];
};

var renderBackdrop = function renderBackdrop(h, ctx) {
  if (!ctx.backdrop) {
    return h();
  }

  var backdropVariant = ctx.backdropVariant;
  return h('div', {
    directives: [{
      name: 'show',
      value: ctx.localShow
    }],
    staticClass: 'b-sidebar-backdrop',
    class: _defineProperty({}, "bg-".concat(backdropVariant), backdropVariant),
    on: {
      click: ctx.onBackdropClick
    }
  });
}; // --- Main component ---
// @vue/component


var BSidebar = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["I" /* NAME_SIDEBAR */],
  mixins: [__WEBPACK_IMPORTED_MODULE_12__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_13__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_14__mixins_listen_on_root__["a" /* listenOnRootMixin */], __WEBPACK_IMPORTED_MODULE_15__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    var visible = !!this[MODEL_PROP_NAME];
    return {
      // Internal `v-model` state
      localShow: visible,
      // For lazy render triggering
      isOpen: visible
    };
  },
  computed: {
    transitionProps: function transitionProps() {
      return this.noSlide ?
      /* istanbul ignore next */
      {
        css: true
      } : {
        css: true,
        enterClass: '',
        enterActiveClass: 'slide',
        enterToClass: 'show',
        leaveClass: 'show',
        leaveActiveClass: 'slide',
        leaveToClass: ''
      };
    },
    slotScope: function slotScope() {
      var hide = this.hide,
          right = this.right,
          visible = this.localShow;
      return {
        hide: hide,
        right: right,
        visible: visible
      };
    },
    hasTitle: function hasTitle() {
      var $scopedSlots = this.$scopedSlots,
          $slots = this.$slots;
      return !this.noHeader && !this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["u" /* SLOT_NAME_HEADER */]) && !!(this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["e" /* SLOT_NAME_TITLE */], this.slotScope, $scopedSlots, $slots) || this.title);
    },
    titleId: function titleId() {
      return this.hasTitle ? this.safeId('__title__') : null;
    },
    computedAttrs: function computedAttrs() {
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        id: this.safeId(),
        tabindex: '-1',
        role: 'dialog',
        'aria-modal': this.backdrop ? 'true' : 'false',
        'aria-hidden': this.localShow ? null : 'true',
        'aria-label': this.ariaLabel || null,
        'aria-labelledby': this.ariaLabelledby || this.titleId || null
      });
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      this.localShow = newValue;
    }
  }), _defineProperty(_watch, "localShow", function localShow(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.emitState(newValue);
      this.$emit(MODEL_EVENT_NAME, newValue);
    }
  }), _defineProperty(_watch, "$route", function $route() {
    var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var oldValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!this.noCloseOnRouteChange && newValue.fullPath !== oldValue.fullPath) {
      this.hide();
    }
  }), _watch),
  created: function created() {
    // Define non-reactive properties
    this.$_returnFocusEl = null;
  },
  mounted: function mounted() {
    var _this = this;

    // Add `$root` listeners
    this.listenOnRoot(ROOT_ACTION_EVENT_NAME_TOGGLE, this.handleToggle);
    this.listenOnRoot(ROOT_ACTION_EVENT_NAME_REQUEST_STATE, this.handleSync); // Send out a gratuitous state event to ensure toggle button is synced

    this.$nextTick(function () {
      _this.emitState(_this.localShow);
    });
  },

  /* istanbul ignore next */
  activated: function activated() {
    this.emitSync();
  },
  beforeDestroy: function beforeDestroy() {
    this.localShow = false;
    this.$_returnFocusEl = null;
  },
  methods: {
    hide: function hide() {
      this.localShow = false;
    },
    emitState: function emitState() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.localShow;
      this.emitOnRoot(ROOT_EVENT_NAME_STATE, this.safeId(), state);
    },
    emitSync: function emitSync() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.localShow;
      this.emitOnRoot(ROOT_EVENT_NAME_SYNC_STATE, this.safeId(), state);
    },
    handleToggle: function handleToggle(id) {
      // Note `safeId()` can be null until after mount
      if (id && id === this.safeId()) {
        this.localShow = !this.localShow;
      }
    },
    handleSync: function handleSync(id) {
      var _this2 = this;

      // Note `safeId()` can be null until after mount
      if (id && id === this.safeId()) {
        this.$nextTick(function () {
          _this2.emitSync(_this2.localShow);
        });
      }
    },
    onKeydown: function onKeydown(event) {
      var keyCode = event.keyCode;

      if (!this.noCloseOnEsc && keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["k" /* CODE_ESC */] && this.localShow) {
        this.hide();
      }
    },
    onBackdropClick: function onBackdropClick() {
      if (this.localShow && !this.noCloseOnBackdrop) {
        this.hide();
      }
    },

    /* istanbul ignore next */
    onTopTrapFocus: function onTopTrapFocus() {
      var tabables = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["E" /* getTabables */])(this.$refs.content);
      this.enforceFocus(tabables.reverse()[0]);
    },

    /* istanbul ignore next */
    onBottomTrapFocus: function onBottomTrapFocus() {
      var tabables = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["E" /* getTabables */])(this.$refs.content);
      this.enforceFocus(tabables[0]);
    },
    onBeforeEnter: function onBeforeEnter() {
      // Returning focus to `document.body` may cause unwanted scrolls,
      // so we exclude setting focus on body
      this.$_returnFocusEl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["B" /* getActiveElement */])(__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] ? [document.body] : []); // Trigger lazy render

      this.isOpen = true;
    },
    onAfterEnter: function onAfterEnter(el) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["b" /* contains */])(el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["B" /* getActiveElement */])())) {
        this.enforceFocus(el);
      }

      this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["d" /* EVENT_NAME_SHOWN */]);
    },
    onAfterLeave: function onAfterLeave() {
      this.enforceFocus(this.$_returnFocusEl);
      this.$_returnFocusEl = null; // Trigger lazy render

      this.isOpen = false;
      this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["b" /* EVENT_NAME_HIDDEN */]);
    },
    enforceFocus: function enforceFocus(el) {
      if (!this.noEnforceFocus) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["n" /* attemptFocus */])(el);
      }
    }
  },
  render: function render(h) {
    var _ref;

    var bgVariant = this.bgVariant,
        width = this.width,
        textVariant = this.textVariant,
        localShow = this.localShow;
    var shadow = this.shadow === '' ? true : this.shadow;
    var $sidebar = h(this.tag, {
      staticClass: CLASS_NAME,
      class: [(_ref = {
        shadow: shadow === true
      }, _defineProperty(_ref, "shadow-".concat(shadow), shadow && shadow !== true), _defineProperty(_ref, "".concat(CLASS_NAME, "-right"), this.right), _defineProperty(_ref, "bg-".concat(bgVariant), bgVariant), _defineProperty(_ref, "text-".concat(textVariant), textVariant), _ref), this.sidebarClass],
      style: {
        width: width
      },
      attrs: this.computedAttrs,
      directives: [{
        name: 'show',
        value: localShow
      }],
      ref: 'content'
    }, [renderContent(h, this)]);
    $sidebar = h('transition', {
      props: this.transitionProps,
      on: {
        beforeEnter: this.onBeforeEnter,
        afterEnter: this.onAfterEnter,
        afterLeave: this.onAfterLeave
      }
    }, [$sidebar]);
    var $backdrop = h(__WEBPACK_IMPORTED_MODULE_18__transition_bv_transition__["a" /* BVTransition */], {
      props: {
        noFade: this.noSlide
      }
    }, [renderBackdrop(h, this)]);
    var $tabTrapTop = h();
    var $tabTrapBottom = h();

    if (this.backdrop && localShow) {
      $tabTrapTop = h('div', {
        attrs: {
          tabindex: '0'
        },
        on: {
          focus: this.onTopTrapFocus
        }
      });
      $tabTrapBottom = h('div', {
        attrs: {
          tabindex: '0'
        },
        on: {
          focus: this.onBottomTrapFocus
        }
      });
    }

    return h('div', {
      staticClass: 'b-sidebar-outer',
      style: {
        zIndex: this.zIndex
      },
      attrs: {
        tabindex: '-1'
      },
      on: {
        keydown: this.onKeydown
      }
    }, [$tabTrapTop, $sidebar, $tabTrapBottom, $backdrop]);
  }
});

/***/ }),
/* 421 */
/* exports provided: SkeletonPlugin, BSkeleton, BSkeletonIcon, BSkeletonImg, BSkeletonTable, BSkeletonWrapper */
/* exports used: SkeletonPlugin */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/skeleton/index.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SkeletonPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__skeleton__ = __webpack_require__(/*! ./skeleton */ 175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__skeleton_icon__ = __webpack_require__(/*! ./skeleton-icon */ 422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__skeleton_img__ = __webpack_require__(/*! ./skeleton-img */ 423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__skeleton_table__ = __webpack_require__(/*! ./skeleton-table */ 424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__skeleton_wrapper__ = __webpack_require__(/*! ./skeleton-wrapper */ 425);
/* unused harmony reexport BSkeleton */
/* unused harmony reexport BSkeletonIcon */
/* unused harmony reexport BSkeletonImg */
/* unused harmony reexport BSkeletonTable */
/* unused harmony reexport BSkeletonWrapper */






var SkeletonPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BSkeleton: __WEBPACK_IMPORTED_MODULE_1__skeleton__["a" /* BSkeleton */],
    BSkeletonIcon: __WEBPACK_IMPORTED_MODULE_2__skeleton_icon__["a" /* BSkeletonIcon */],
    BSkeletonImg: __WEBPACK_IMPORTED_MODULE_3__skeleton_img__["a" /* BSkeletonImg */],
    BSkeletonTable: __WEBPACK_IMPORTED_MODULE_4__skeleton_table__["a" /* BSkeletonTable */],
    BSkeletonWrapper: __WEBPACK_IMPORTED_MODULE_5__skeleton_wrapper__["a" /* BSkeletonWrapper */]
  }
});


/***/ }),
/* 422 */
/* exports provided: props, BSkeletonIcon */
/* exports used: BSkeletonIcon */
/*!******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/skeleton/skeleton-icon.js ***!
  \******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSkeletonIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons__ = __webpack_require__(/*! ../../icons */ 949);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  animation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'wave'),
  icon: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  iconProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */], {})
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["G" /* NAME_SKELETON_ICON */]); // --- Main component ---
// @vue/component

var BSkeletonIcon = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["G" /* NAME_SKELETON_ICON */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props;
    var icon = props.icon,
        animation = props.animation;
    var $icon = h(__WEBPACK_IMPORTED_MODULE_4__icons__["a" /* BIcon */], {
      staticClass: 'b-skeleton-icon',
      props: _objectSpread(_objectSpread({}, props.iconProps), {}, {
        icon: icon
      })
    });
    return h('div', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      staticClass: 'b-skeleton-icon-wrapper position-relative d-inline-block overflow-hidden',
      class: _defineProperty({}, "b-skeleton-animate-".concat(animation), animation)
    }), [$icon]);
  }
});

/***/ }),
/* 423 */
/* exports provided: props, BSkeletonImg */
/* exports used: BSkeletonImg */
/*!*****************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/skeleton/skeleton-img.js ***!
  \*****************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSkeletonImg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aspect__ = __webpack_require__(/*! ../aspect */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__skeleton__ = __webpack_require__(/*! ./skeleton */ 175);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])({
  animation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  aspect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], '16:9'),
  cardImg: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  noAspect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["F" /* NAME_SKELETON_IMG */]); // --- Main component ---
// @vue/component

var BSkeletonImg = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["F" /* NAME_SKELETON_IMG */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props;
    var aspect = props.aspect,
        width = props.width,
        height = props.height,
        animation = props.animation,
        variant = props.variant,
        cardImg = props.cardImg;
    var $img = h(__WEBPACK_IMPORTED_MODULE_5__skeleton__["a" /* BSkeleton */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      props: {
        type: 'img',
        width: width,
        height: height,
        animation: animation,
        variant: variant
      },
      class: _defineProperty({}, "card-img-".concat(cardImg), cardImg)
    }));
    return props.noAspect ? $img : h(__WEBPACK_IMPORTED_MODULE_4__aspect__["b" /* BAspect */], {
      props: {
        aspect: aspect
      }
    }, [$img]);
  }
});

/***/ }),
/* 424 */
/* exports provided: props, BSkeletonTable */
/* exports used: BSkeletonTable */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/skeleton/skeleton-table.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSkeletonTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__skeleton__ = __webpack_require__(/*! ./skeleton */ 175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table__ = __webpack_require__(/*! ../table */ 236);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Helper methods ---

var isPositiveNumber = function isPositiveNumber(value) {
  return value > 0;
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["b" /* makePropsConfigurable */])({
  animation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  columns: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["l" /* PROP_TYPE_NUMBER */], 5, isPositiveNumber),
  hideHeader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  rows: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["l" /* PROP_TYPE_NUMBER */], 3, isPositiveNumber),
  showFooter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tableProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */], {})
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["E" /* NAME_SKELETON_TABLE */]); // --- Main component ---
// @vue/component

var BSkeletonTable = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["E" /* NAME_SKELETON_TABLE */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props;
    var animation = props.animation,
        columns = props.columns;
    var $th = h('th', [h(__WEBPACK_IMPORTED_MODULE_5__skeleton__["a" /* BSkeleton */], {
      props: {
        animation: animation
      }
    })]);
    var $thTr = h('tr', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* createArray */])(columns, $th));
    var $td = h('td', [h(__WEBPACK_IMPORTED_MODULE_5__skeleton__["a" /* BSkeleton */], {
      props: {
        width: '75%',
        animation: animation
      }
    })]);
    var $tdTr = h('tr', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* createArray */])(columns, $td));
    var $tbody = h('tbody', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* createArray */])(props.rows, $tdTr));
    var $thead = !props.hideHeader ? h('thead', [$thTr]) : h();
    var $tfoot = props.showFooter ? h('tfoot', [$thTr]) : h();
    return h(__WEBPACK_IMPORTED_MODULE_6__table__["d" /* BTableSimple */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      props: _objectSpread({}, props.tableProps)
    }), [$thead, $tbody, $tfoot]);
  }
});

/***/ }),
/* 425 */
/* exports provided: props, BSkeletonWrapper */
/* exports used: BSkeletonWrapper */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/skeleton/skeleton-wrapper.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BSkeletonWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__ = __webpack_require__(/*! ../../utils/normalize-slot */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);





 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])({
  loading: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, __WEBPACK_IMPORTED_MODULE_1__constants_components__["D" /* NAME_SKELETON_WRAPPER */]); // --- Main component ---
// @vue/component

var BSkeletonWrapper = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["D" /* NAME_SKELETON_WRAPPER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        slots = _ref.slots,
        scopedSlots = _ref.scopedSlots;
    var $slots = slots();
    var $scopedSlots = scopedSlots || {};
    var slotScope = {};

    if (props.loading) {
      return h('div', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
        attrs: {
          role: 'alert',
          'aria-live': 'polite',
          'aria-busy': true
        },
        staticClass: 'b-skeleton-wrapper',
        key: 'loading'
      }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["s" /* SLOT_NAME_LOADING */], slotScope, $scopedSlots, $slots));
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_normalize_slot__["b" /* normalizeSlot */])(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["a" /* SLOT_NAME_DEFAULT */], slotScope, $scopedSlots, $slots);
  }
});

/***/ }),
/* 426 */
/* exports provided: SpinnerPlugin, BSpinner */
/* exports used: SpinnerPlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/spinner/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__spinner__ = __webpack_require__(/*! ./spinner */ 233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BSpinner */


var SpinnerPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BSpinner: __WEBPACK_IMPORTED_MODULE_0__spinner__["a" /* BSpinner */]
  }
});


/***/ }),
/* 427 */
/* exports provided: filterEvent */
/* exports used: filterEvent */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/filter-event.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(/*! ./constants */ 176);


var TABLE_TAG_NAMES = ['TD', 'TH', 'TR']; // Returns `true` if we should ignore the click/double-click/keypress event
// Avoids having the user need to use `@click.stop` on the form control

var filterEvent = function filterEvent(event) {
  // Exit early when we don't have a target element
  if (!event || !event.target) {
    /* istanbul ignore next */
    return false;
  }

  var el = event.target; // Exit early when element is disabled or a table element

  if (el.disabled || TABLE_TAG_NAMES.indexOf(el.tagName) !== -1) {
    return false;
  } // Ignore the click when it was inside a dropdown menu


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["f" /* closest */])('.dropdown-menu', el)) {
    return true;
  }

  var label = el.tagName === 'LABEL' ? el : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["f" /* closest */])('label', el); // If the label's form control is not disabled then we don't propagate event
  // Modern browsers have `label.control` that references the associated input, but IE 11
  // does not have this property on the label element, so we resort to DOM lookups

  if (label) {
    var labelFor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["i" /* getAttr */])(label, 'for');
    var input = labelFor ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["d" /* getById */])(labelFor) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["h" /* select */])('input, select, textarea', label);

    if (input && !input.disabled) {
      return true;
    }
  } // Otherwise check if the event target matches one of the selectors in the
  // event filter (i.e. anchors, non disabled inputs, etc.)
  // Return `true` if we should ignore the event


  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["y" /* matches */])(el, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EVENT_FILTER */]);
};

/***/ }),
/* 428 */
/* exports provided: props, captionMixin */
/* exports used: props, captionMixin */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-caption.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return captionMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);




 // --- Props ---

var props = {
  caption: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  captionHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]) // `caption-top` is part of table-render mixin (styling)
  // captionTop: makeProp(PROP_TYPE_BOOLEAN, false)

}; // --- Mixin ---
// @vue/component

var captionMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  computed: {
    captionId: function captionId() {
      return this.isStacked ? this.safeId('_caption_') : null;
    }
  },
  methods: {
    renderCaption: function renderCaption() {
      var caption = this.caption,
          captionHtml = this.captionHtml;
      var h = this.$createElement;
      var $caption = h();
      var hasCaptionSlot = this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_2__constants_slots__["j" /* SLOT_NAME_TABLE_CAPTION */]);

      if (hasCaptionSlot || caption || captionHtml) {
        $caption = h('caption', {
          attrs: {
            id: this.captionId
          },
          domProps: hasCaptionSlot ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(captionHtml, caption),
          key: 'caption',
          ref: 'caption'
        }, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_2__constants_slots__["j" /* SLOT_NAME_TABLE_CAPTION */]));
      }

      return $caption;
    }
  }
});

/***/ }),
/* 429 */
/* exports provided: props, colgroupMixin */
/* exports used: props, colgroupMixin */
/*!************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-colgroup.js ***!
  \************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return colgroupMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);

 // --- Props ---

var props = {}; // --- Mixin ---
// @vue/component

var colgroupMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  methods: {
    renderColgroup: function renderColgroup() {
      var fields = this.computedFields;
      var h = this.$createElement;
      var $colgroup = h();

      if (this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_1__constants_slots__["i" /* SLOT_NAME_TABLE_COLGROUP */])) {
        $colgroup = h('colgroup', {
          key: 'colgroup'
        }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_1__constants_slots__["i" /* SLOT_NAME_TABLE_COLGROUP */], {
          columns: fields.length,
          fields: fields
        })]);
      }

      return $colgroup;
    }
  }
});

/***/ }),
/* 430 */
/* exports provided: MODEL_PROP_NAME, MODEL_EVENT_NAME, props, itemsMixin */
/* exports used: props, itemsMixin */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-items.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MODEL_PROP_NAME */
/* unused harmony export MODEL_EVENT_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemsMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_use_parent__ = __webpack_require__(/*! ../../../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__ = __webpack_require__(/*! ../../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_math__ = __webpack_require__(/*! ../../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_model__ = __webpack_require__(/*! ../../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__normalize_fields__ = __webpack_require__(/*! ./normalize-fields */ 940);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_2__constants_props__["o" /* PROP_TYPE_ARRAY */],
  defaultValue: []
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, modelProps), {}, _defineProperty({
  fields: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["o" /* PROP_TYPE_ARRAY */], null),
  // Provider mixin adds in `Function` type
  items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["o" /* PROP_TYPE_ARRAY */], []),
  // Primary key for record
  // If provided the value in each row must be unique!
  primaryKey: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])
}, MODEL_PROP_NAME, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["o" /* PROP_TYPE_ARRAY */], [])))); // --- Mixin ---
// @vue/component

var itemsMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [modelMixin, __WEBPACK_IMPORTED_MODULE_3__mixins_use_parent__["a" /* useParentMixin */]],
  props: props,
  data: function data() {
    var items = this.items;
    return {
      // Our local copy of the items
      // Must be an array
      localItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["c" /* isArray */])(items) ? items.slice() : []
    };
  },
  computed: {
    computedFields: function computedFields() {
      // We normalize fields into an array of objects
      // `[ { key:..., label:..., ...}, {...}, ..., {..}]`
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__normalize_fields__["a" /* normalizeFields */])(this.fields, this.localItems);
    },
    computedFieldsObj: function computedFieldsObj() {
      // Fields as a simple lookup hash object
      // Mainly for formatter lookup and use in `scopedSlots` for convenience
      // If the field has a formatter, it normalizes formatter to a
      // function ref or `undefined` if no formatter
      var bvParent = this.bvParent;
      return this.computedFields.reduce(function (obj, f) {
        // We use object spread here so we don't mutate the original field object
        obj[f.key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_object__["b" /* clone */])(f);

        if (f.formatter) {
          // Normalize formatter to a function ref or `undefined`
          var formatter = f.formatter;

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["f" /* isString */])(formatter) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(bvParent[formatter])) {
            formatter = bvParent[formatter];
          } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(formatter)) {
            /* istanbul ignore next */
            formatter = undefined;
          } // Return formatter function or `undefined` if none


          obj[f.key].formatter = formatter;
        }

        return obj;
      }, {});
    },
    computedItems: function computedItems() {
      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          paginatedItems = _safeVueInstance.paginatedItems,
          sortedItems = _safeVueInstance.sortedItems,
          filteredItems = _safeVueInstance.filteredItems,
          localItems = _safeVueInstance.localItems; // Fallback if various mixins not provided


      return (paginatedItems || sortedItems || filteredItems || localItems ||
      /* istanbul ignore next */
      []).slice();
    },
    context: function context() {
      var _safeVueInstance2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          perPage = _safeVueInstance2.perPage,
          currentPage = _safeVueInstance2.currentPage; // Current state of sorting, filtering and pagination props/values


      return {
        filter: this.localFilter,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc,
        perPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(perPage, 0), 0),
        currentPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["b" /* toInteger */])(currentPage, 0), 1),
        apiUrl: this.apiUrl
      };
    }
  },
  watch: {
    items: function items(newValue) {
      // Set `localItems`/`filteredItems` to a copy of the provided array
      this.localItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["c" /* isArray */])(newValue) ? newValue.slice() : [];
    },
    // Watch for changes on `computedItems` and update the `v-model`
    computedItems: function computedItems(newValue, oldValue) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
        this.$emit(MODEL_EVENT_NAME, newValue);
      }
    },
    // Watch for context changes
    context: function context(newValue, oldValue) {
      // Emit context information for external paging/filtering/sorting handling
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["N" /* EVENT_NAME_CONTEXT_CHANGED */], newValue);
      }
    }
  },
  mounted: function mounted() {
    // Initially update the `v-model` of displayed items
    this.$emit(MODEL_EVENT_NAME, this.computedItems);
  },
  methods: {
    // Method to get the formatter method for a given field key
    getFieldFormatter: function getFieldFormatter(key) {
      var field = this.computedFieldsObj[key]; // `this.computedFieldsObj` has pre-normalized the formatter to a
      // function ref if present, otherwise `undefined`

      return field ? field.formatter : undefined;
    }
  }
});

/***/ }),
/* 431 */
/* exports provided: props, tbodyMixin */
/* exports used: props, tbodyMixin */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-tbody.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tbodyMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__ = __webpack_require__(/*! ../../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tbody__ = __webpack_require__(/*! ../tbody */ 237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filter_event__ = __webpack_require__(/*! ./filter-event */ 427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__text_selection_active__ = __webpack_require__(/*! ./text-selection-active */ 435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixin_tbody_row__ = __webpack_require__(/*! ./mixin-tbody-row */ 938);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














 // --- Helper methods ---

var getCellSlotName = function getCellSlotName(value) {
  return "cell(".concat(value || '', ")");
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_10__tbody__["b" /* props */]), __WEBPACK_IMPORTED_MODULE_13__mixin_tbody_row__["a" /* props */]), {}, {
  tbodyClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])
})); // --- Mixin ---
// @vue/component

var tbodyMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixin_tbody_row__["b" /* tbodyRowMixin */]],
  props: props,
  beforeDestroy: function beforeDestroy() {
    this.$_bodyFieldSlotNameCache = null;
  },
  methods: {
    // Returns all the item TR elements (excludes detail and spacer rows)
    // `this.$refs['item-rows']` is an array of item TR components/elements
    // Rows should all be `<b-tr>` components, but we map to TR elements
    // Also note that `this.$refs['item-rows']` may not always be in document order
    getTbodyTrs: function getTbodyTrs() {
      var $refs = this.$refs;
      var tbody = $refs.tbody ? $refs.tbody.$el || $refs.tbody : null;
      var trs = ($refs['item-rows'] || []).map(function (tr) {
        return tr.$el || tr;
      });
      return tbody && tbody.children && tbody.children.length > 0 && trs && trs.length > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["a" /* from */])(tbody.children).filter(function (tr) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])(trs, tr);
      }) :
      /* istanbul ignore next */
      [];
    },
    // Returns index of a particular TBODY item TR
    // We set `true` on closest to include self in result
    getTbodyTrIndex: function getTbodyTrIndex(el) {
      /* istanbul ignore next: should not normally happen */
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["e" /* isElement */])(el)) {
        return -1;
      }

      var tr = el.tagName === 'TR' ? el : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["f" /* closest */])('tr', el, true);
      return tr ? this.getTbodyTrs().indexOf(tr) : -1;
    },
    // Emits a row event, with the item object, row index and original event
    emitTbodyRowEvent: function emitTbodyRowEvent(type, event) {
      if (type && this.hasListener(type) && event && event.target) {
        var rowIndex = this.getTbodyTrIndex(event.target);

        if (rowIndex > -1) {
          // The array of TRs correlate to the `computedItems` array
          var item = this.computedItems[rowIndex];
          this.$emit(type, item, rowIndex, event);
        }
      }
    },
    tbodyRowEventStopped: function tbodyRowEventStopped(event) {
      return this.stopIfBusy && this.stopIfBusy(event);
    },
    // Delegated row event handlers
    onTbodyRowKeydown: function onTbodyRowKeydown(event) {
      // Keyboard navigation and row click emulation
      var target = event.target,
          keyCode = event.keyCode;

      if (this.tbodyRowEventStopped(event) || target.tagName !== 'TR' || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["C" /* isActiveElement */])(target) || target.tabIndex !== 0) {
        // Early exit if not an item row TR
        return;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])([__WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["a" /* CODE_ENTER */], __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["b" /* CODE_SPACE */]], keyCode)) {
        // Emulated click for keyboard users, transfer to click handler
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event);
        this.onTBodyRowClicked(event);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* arrayIncludes */])([__WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["e" /* CODE_UP */], __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["f" /* CODE_DOWN */], __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["g" /* CODE_HOME */], __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["h" /* CODE_END */]], keyCode)) {
        // Keyboard navigation
        var rowIndex = this.getTbodyTrIndex(target);

        if (rowIndex > -1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event);
          var trs = this.getTbodyTrs();
          var shift = event.shiftKey;

          if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["g" /* CODE_HOME */] || shift && keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["e" /* CODE_UP */]) {
            // Focus first row
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(trs[0]);
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["h" /* CODE_END */] || shift && keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["f" /* CODE_DOWN */]) {
            // Focus last row
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(trs[trs.length - 1]);
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["e" /* CODE_UP */] && rowIndex > 0) {
            // Focus previous row
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(trs[rowIndex - 1]);
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["f" /* CODE_DOWN */] && rowIndex < trs.length - 1) {
            // Focus next row
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["n" /* attemptFocus */])(trs[rowIndex + 1]);
          }
        }
      }
    },
    onTBodyRowClicked: function onTBodyRowClicked(event) {
      var $refs = this.$refs;
      var tbody = $refs.tbody ? $refs.tbody.$el || $refs.tbody : null; // Don't emit event when the table is busy, the user clicked
      // on a non-disabled control or is selecting text

      if (this.tbodyRowEventStopped(event) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__filter_event__["a" /* filterEvent */])(event) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__text_selection_active__["a" /* textSelectionActive */])(tbody || this.$el)) {
        return;
      }

      this.emitTbodyRowEvent(__WEBPACK_IMPORTED_MODULE_1__constants_events__["G" /* EVENT_NAME_ROW_CLICKED */], event);
    },
    onTbodyRowMiddleMouseRowClicked: function onTbodyRowMiddleMouseRowClicked(event) {
      if (!this.tbodyRowEventStopped(event) && event.which === 2) {
        this.emitTbodyRowEvent(__WEBPACK_IMPORTED_MODULE_1__constants_events__["H" /* EVENT_NAME_ROW_MIDDLE_CLICKED */], event);
      }
    },
    onTbodyRowContextmenu: function onTbodyRowContextmenu(event) {
      if (!this.tbodyRowEventStopped(event)) {
        this.emitTbodyRowEvent(__WEBPACK_IMPORTED_MODULE_1__constants_events__["I" /* EVENT_NAME_ROW_CONTEXTMENU */], event);
      }
    },
    onTbodyRowDblClicked: function onTbodyRowDblClicked(event) {
      if (!this.tbodyRowEventStopped(event) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__filter_event__["a" /* filterEvent */])(event)) {
        this.emitTbodyRowEvent(__WEBPACK_IMPORTED_MODULE_1__constants_events__["J" /* EVENT_NAME_ROW_DBLCLICKED */], event);
      }
    },
    // Render the tbody element and children
    // Note:
    //   Row hover handlers are handled by the tbody-row mixin
    //   As mouseenter/mouseleave events do not bubble
    renderTbody: function renderTbody() {
      var _this = this;

      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          items = _safeVueInstance.computedItems,
          renderBusy = _safeVueInstance.renderBusy,
          renderTopRow = _safeVueInstance.renderTopRow,
          renderEmpty = _safeVueInstance.renderEmpty,
          renderBottomRow = _safeVueInstance.renderBottomRow,
          hasSelectableRowClick = _safeVueInstance.hasSelectableRowClick;

      var h = this.$createElement;
      var hasRowClickHandler = this.hasListener(__WEBPACK_IMPORTED_MODULE_1__constants_events__["G" /* EVENT_NAME_ROW_CLICKED */]) || hasSelectableRowClick; // Prepare the tbody rows

      var $rows = []; // Add the item data rows or the busy slot

      var $busy = renderBusy ? renderBusy() : null;

      if ($busy) {
        // If table is busy and a busy slot, then return only the busy "row" indicator
        $rows.push($busy);
      } else {
        // Table isn't busy, or we don't have a busy slot
        // Create a slot cache for improved performance when looking up cell slot names
        // Values will be keyed by the field's `key` and will store the slot's name
        // Slots could be dynamic (i.e. `v-if`), so we must compute on each render
        // Used by tbody-row mixin render helper
        var cache = {};
        var defaultSlotName = getCellSlotName();
        defaultSlotName = this.hasNormalizedSlot(defaultSlotName) ? defaultSlotName : null;
        this.computedFields.forEach(function (field) {
          var key = field.key;
          var slotName = getCellSlotName(key);
          var lowercaseSlotName = getCellSlotName(key.toLowerCase());
          cache[key] = _this.hasNormalizedSlot(slotName) ? slotName : _this.hasNormalizedSlot(lowercaseSlotName) ?
          /* istanbul ignore next */
          lowercaseSlotName : defaultSlotName;
        }); // Created as a non-reactive property so to not trigger component updates
        // Must be a fresh object each render

        this.$_bodyFieldSlotNameCache = cache; // Add static top row slot (hidden in visibly stacked mode
        // as we can't control `data-label` attr)

        $rows.push(renderTopRow ? renderTopRow() : h()); // Render the rows

        items.forEach(function (item, rowIndex) {
          // Render the individual item row (rows if details slot)
          $rows.push(_this.renderTbodyRow(item, rowIndex));
        }); // Empty items / empty filtered row slot (only shows if `items.length < 1`)

        $rows.push(renderEmpty ? renderEmpty() : h()); // Static bottom row slot (hidden in visibly stacked mode
        // as we can't control `data-label` attr)

        $rows.push(renderBottomRow ? renderBottomRow() : h());
      } // Note: these events will only emit if a listener is registered


      var handlers = {
        auxclick: this.onTbodyRowMiddleMouseRowClicked,
        // TODO:
        //   Perhaps we do want to automatically prevent the
        //   default context menu from showing if there is a
        //   `row-contextmenu` listener registered
        contextmenu: this.onTbodyRowContextmenu,
        // The following event(s) is not considered A11Y friendly
        dblclick: this.onTbodyRowDblClicked // Hover events (`mouseenter`/`mouseleave`) are handled by `tbody-row` mixin

      }; // Add in click/keydown listeners if needed

      if (hasRowClickHandler) {
        handlers.click = this.onTBodyRowClicked;
        handlers.keydown = this.onTbodyRowKeydown;
      } // Assemble rows into the tbody


      var $tbody = h(__WEBPACK_IMPORTED_MODULE_10__tbody__["a" /* BTbody */], {
        class: this.tbodyClass || null,
        props: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["c" /* pluckProps */])(__WEBPACK_IMPORTED_MODULE_10__tbody__["b" /* props */], this.$props),
        // BTbody transfers all native event listeners to the root element
        // TODO: Only set the handlers if the table is not busy
        on: handlers,
        ref: 'tbody'
      }, $rows); // Return the assembled tbody

      return $tbody;
    }
  }
});

/***/ }),
/* 432 */
/* exports provided: props, tfootMixin */
/* exports used: props, tfootMixin */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-tfoot.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tfootMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tfoot__ = __webpack_require__(/*! ../tfoot */ 177);




 // --- Props ---

var props = {
  footClone: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Any Bootstrap theme variant (or custom)
  // Falls back to `headRowVariant`
  footRowVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  // 'dark', 'light', or `null` (or custom)
  footVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  tfootClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  tfootTrClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])
}; // --- Mixin ---
// @vue/component

var tfootMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  methods: {
    renderTFootCustom: function renderTFootCustom() {
      var h = this.$createElement;

      if (this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_2__constants_slots__["l" /* SLOT_NAME_CUSTOM_FOOT */])) {
        return h(__WEBPACK_IMPORTED_MODULE_4__tfoot__["a" /* BTfoot */], {
          class: this.tfootClass || null,
          props: {
            footVariant: this.footVariant || this.headVariant || null
          },
          key: 'bv-tfoot-custom'
        }, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_2__constants_slots__["l" /* SLOT_NAME_CUSTOM_FOOT */], {
          items: this.computedItems.slice(),
          fields: this.computedFields.slice(),
          columns: this.computedFields.length
        }));
      }

      return h();
    },
    renderTfoot: function renderTfoot() {
      // Passing true to renderThead will make it render a tfoot
      return this.footClone ? this.renderThead(true) : this.renderTFootCustom();
    }
  }
});

/***/ }),
/* 433 */
/* exports provided: props, theadMixin */
/* exports used: props, theadMixin */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-thead.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return theadMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__ = __webpack_require__(/*! ../../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_html__ = __webpack_require__(/*! ../../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_identity__ = __webpack_require__(/*! ../../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_noop__ = __webpack_require__(/*! ../../../utils/noop */ 256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_string__ = __webpack_require__(/*! ../../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__thead__ = __webpack_require__(/*! ../thead */ 238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tfoot__ = __webpack_require__(/*! ../tfoot */ 177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tr__ = __webpack_require__(/*! ../tr */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__th__ = __webpack_require__(/*! ../th */ 178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filter_event__ = __webpack_require__(/*! ./filter-event */ 427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__text_selection_active__ = __webpack_require__(/*! ./text-selection-active */ 435);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















 // --- Helper methods ---

var getHeadSlotName = function getHeadSlotName(value) {
  return "head(".concat(value || '', ")");
};

var getFootSlotName = function getFootSlotName(value) {
  return "foot(".concat(value || '', ")");
}; // --- Props ---


var props = {
  // Any Bootstrap theme variant (or custom)
  headRowVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  // 'light', 'dark' or `null` (or custom)
  headVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  theadClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  theadTrClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])
}; // --- Mixin ---
// @vue/component

var theadMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  methods: {
    fieldClasses: function fieldClasses(field) {
      // Header field (<th>) classes
      return [field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    headClicked: function headClicked(event, field, isFoot) {
      if (this.stopIfBusy && this.stopIfBusy(event)) {
        // If table is busy (via provider) then don't propagate
        return;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__filter_event__["a" /* filterEvent */])(event)) {
        // Clicked on a non-disabled control so ignore
        return;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__text_selection_active__["a" /* textSelectionActive */])(this.$el)) {
        // User is selecting text, so ignore

        /* istanbul ignore next: JSDOM doesn't support getSelection() */
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_events__["f" /* stopEvent */])(event);
      this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["M" /* EVENT_NAME_HEAD_CLICKED */], field.key, field, event, isFoot);
    },
    renderThead: function renderThead() {
      var _this = this;

      var isFoot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          fields = _safeVueInstance.computedFields,
          isSortable = _safeVueInstance.isSortable,
          isSelectable = _safeVueInstance.isSelectable,
          headVariant = _safeVueInstance.headVariant,
          footVariant = _safeVueInstance.footVariant,
          headRowVariant = _safeVueInstance.headRowVariant,
          footRowVariant = _safeVueInstance.footRowVariant;

      var h = this.$createElement; // In always stacked mode, we don't bother rendering the head/foot
      // Or if no field headings (empty table)

      if (this.isStackedAlways || fields.length === 0) {
        return h();
      }

      var hasHeadClickListener = isSortable || this.hasListener(__WEBPACK_IMPORTED_MODULE_1__constants_events__["M" /* EVENT_NAME_HEAD_CLICKED */]); // Reference to `selectAllRows` and `clearSelected()`, if table is selectable

      var selectAllRows = isSelectable ? this.selectAllRows : __WEBPACK_IMPORTED_MODULE_9__utils_noop__["a" /* noop */];
      var clearSelected = isSelectable ? this.clearSelected : __WEBPACK_IMPORTED_MODULE_9__utils_noop__["a" /* noop */]; // Helper function to generate a field <th> cell

      var makeCell = function makeCell(field, colIndex) {
        var label = field.label,
            labelHtml = field.labelHtml,
            variant = field.variant,
            stickyColumn = field.stickyColumn,
            key = field.key;
        var ariaLabel = null;

        if (!field.label.trim() && !field.headerTitle) {
          // In case field's label and title are empty/blank
          // We need to add a hint about what the column is about for non-sighted users

          /* istanbul ignore next */
          ariaLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_string__["e" /* startCase */])(field.key);
        }

        var on = {};

        if (hasHeadClickListener) {
          on.click = function (event) {
            _this.headClicked(event, field, isFoot);
          };

          on.keydown = function (event) {
            var keyCode = event.keyCode;

            if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["a" /* CODE_ENTER */] || keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["b" /* CODE_SPACE */]) {
              _this.headClicked(event, field, isFoot);
            }
          };
        }

        var sortAttrs = isSortable ? _this.sortTheadThAttrs(key, field, isFoot) : {};
        var sortClass = isSortable ? _this.sortTheadThClasses(key, field, isFoot) : null;
        var sortLabel = isSortable ? _this.sortTheadThLabel(key, field, isFoot) : null;
        var data = {
          class: [{
            // We need to make the header cell relative when we have
            // a `.sr-only` sort label to work around overflow issues
            'position-relative': sortLabel
          }, _this.fieldClasses(field), sortClass],
          props: {
            variant: variant,
            stickyColumn: stickyColumn
          },
          style: field.thStyle || {},
          attrs: _objectSpread(_objectSpread({
            // We only add a `tabindex` of `0` if there is a head-clicked listener
            // and the current field is sortable
            tabindex: hasHeadClickListener && field.sortable ? '0' : null,
            abbr: field.headerAbbr || null,
            title: field.headerTitle || null,
            'aria-colindex': colIndex + 1,
            'aria-label': ariaLabel
          }, _this.getThValues(null, key, field.thAttr, isFoot ? 'foot' : 'head', {})), sortAttrs),
          on: on,
          key: key
        }; // Handle edge case where in-document templates are used with new
        // `v-slot:name` syntax where the browser lower-cases the v-slot's
        // name (attributes become lower cased when parsed by the browser)
        // We have replaced the square bracket syntax with round brackets
        // to prevent confusion with dynamic slot names

        var slotNames = [getHeadSlotName(key), getHeadSlotName(key.toLowerCase()), getHeadSlotName()]; // Footer will fallback to header slot names

        if (isFoot) {
          slotNames = [getFootSlotName(key), getFootSlotName(key.toLowerCase()), getFootSlotName()].concat(_toConsumableArray(slotNames));
        }

        var scope = {
          label: label,
          column: key,
          field: field,
          isFoot: isFoot,
          // Add in row select methods
          selectAllRows: selectAllRows,
          clearSelected: clearSelected
        };
        var $content = _this.normalizeSlot(slotNames, scope) || h('div', {
          domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_html__["a" /* htmlOrText */])(labelHtml, label)
        });
        var $srLabel = sortLabel ? h('span', {
          staticClass: 'sr-only'
        }, " (".concat(sortLabel, ")")) : null; // Return the header cell

        return h(__WEBPACK_IMPORTED_MODULE_16__th__["a" /* BTh */], data, [$content, $srLabel].filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]));
      }; // Generate the array of <th> cells


      var $cells = fields.map(makeCell).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]); // Generate the row(s)

      var $trs = [];

      if (isFoot) {
        $trs.push(h(__WEBPACK_IMPORTED_MODULE_15__tr__["a" /* BTr */], {
          class: this.tfootTrClass,
          props: {
            variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["g" /* isUndefinedOrNull */])(footRowVariant) ? headRowVariant :
            /* istanbul ignore next */
            footRowVariant
          }
        }, $cells));
      } else {
        var scope = {
          columns: fields.length,
          fields: fields,
          // Add in row select methods
          selectAllRows: selectAllRows,
          clearSelected: clearSelected
        };
        $trs.push(this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["m" /* SLOT_NAME_THEAD_TOP */], scope) || h());
        $trs.push(h(__WEBPACK_IMPORTED_MODULE_15__tr__["a" /* BTr */], {
          class: this.theadTrClass,
          props: {
            variant: headRowVariant
          }
        }, $cells));
      }

      return h(isFoot ? __WEBPACK_IMPORTED_MODULE_14__tfoot__["a" /* BTfoot */] : __WEBPACK_IMPORTED_MODULE_13__thead__["a" /* BThead */], {
        class: (isFoot ? this.tfootClass : this.theadClass) || null,
        props: isFoot ? {
          footVariant: footVariant || headVariant || null
        } : {
          headVariant: headVariant || null
        },
        key: isFoot ? 'bv-tfoot' : 'bv-thead'
      }, $trs);
    }
  }
});

/***/ }),
/* 434 */
/* exports provided: sanitizeRow */
/* exports used: sanitizeRow */
/*!**********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/sanitize-row.js ***!
  \**********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sanitizeRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ./constants */ 176);



 // Return a copy of a row after all reserved fields have been filtered out

var sanitizeRow = function sanitizeRow(row, ignoreFields, includeFields) {
  var fieldsObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // We first need to format the row based on the field configurations
  // This ensures that we add formatted values for keys that may not
  // exist in the row itself
  var formattedRow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(fieldsObj).reduce(function (result, key) {
    var field = fieldsObj[key];
    var filterByFormatted = field.filterByFormatted;
    var formatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["a" /* isFunction */])(filterByFormatted) ?
    /* istanbul ignore next */
    filterByFormatted : filterByFormatted ?
    /* istanbul ignore next */
    field.formatter : null;

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["a" /* isFunction */])(formatter)) {
      result[key] = formatter(row[key], key, row);
    }

    return result;
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b" /* clone */])(row)); // Determine the allowed keys:
  //   - Ignore special fields that start with `_`
  //   - Ignore fields in the `ignoreFields` array
  //   - Include only fields in the `includeFields` array

  var allowedKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(formattedRow).filter(function (key) {
    return !__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* IGNORED_FIELD_KEYS */][key] && !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["c" /* isArray */])(ignoreFields) && ignoreFields.length > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["c" /* arrayIncludes */])(ignoreFields, key)) && !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["c" /* isArray */])(includeFields) && includeFields.length > 0 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["c" /* arrayIncludes */])(includeFields, key));
  });
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["k" /* pick */])(formattedRow, allowedKeys);
};

/***/ }),
/* 435 */
/* exports provided: textSelectionActive */
/* exports used: textSelectionActive */
/*!*******************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/text-selection-active.js ***!
  \*******************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return textSelectionActive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
 // Helper to determine if a there is an active text selection on the document page
// Used to filter out click events caused by the mouse up at end of selection
//
// Accepts an element as only argument to test to see if selection overlaps or is
// contained within the element

var textSelectionActive = function textSelectionActive() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var sel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["D" /* getSel */])();
  return sel && sel.toString().trim() !== '' && sel.containsNode && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["e" /* isElement */])(el) ?
  /* istanbul ignore next */
  sel.containsNode(el, true) : false;
};

/***/ }),
/* 436 */
/* exports provided: props, BTableLite */
/* exports used: BTableLite */
/*!************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/table-lite.js ***!
  \************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTableLite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_has_listener__ = __webpack_require__(/*! ../../mixins/has-listener */ 252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_caption__ = __webpack_require__(/*! ./helpers/mixin-caption */ 428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_colgroup__ = __webpack_require__(/*! ./helpers/mixin-colgroup */ 429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_mixin_items__ = __webpack_require__(/*! ./helpers/mixin-items */ 430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_mixin_stacked__ = __webpack_require__(/*! ./helpers/mixin-stacked */ 234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_mixin_table_renderer__ = __webpack_require__(/*! ./helpers/mixin-table-renderer */ 235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_mixin_tbody__ = __webpack_require__(/*! ./helpers/mixin-tbody */ 431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_mixin_tfoot__ = __webpack_require__(/*! ./helpers/mixin-tfoot */ 432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_mixin_thead__ = __webpack_require__(/*! ./helpers/mixin-thead */ 433);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_caption__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_colgroup__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_10__helpers_mixin_items__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__helpers_mixin_stacked__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__helpers_mixin_table_renderer__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_13__helpers_mixin_tbody__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_14__helpers_mixin_tfoot__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_15__helpers_mixin_thead__["a" /* props */])), __WEBPACK_IMPORTED_MODULE_1__constants_components__["A" /* NAME_TABLE_LITE */]); // --- Main component ---
// @vue/component

var BTableLite = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["A" /* NAME_TABLE_LITE */],
  // Order of mixins is important!
  // They are merged from first to last, followed by this component
  mixins: [// General mixins
  __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_has_listener__["a" /* hasListenerMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__["a" /* normalizeSlotMixin */], // Required table mixins
  __WEBPACK_IMPORTED_MODULE_10__helpers_mixin_items__["b" /* itemsMixin */], __WEBPACK_IMPORTED_MODULE_12__helpers_mixin_table_renderer__["b" /* tableRendererMixin */], __WEBPACK_IMPORTED_MODULE_11__helpers_mixin_stacked__["b" /* stackedMixin */], __WEBPACK_IMPORTED_MODULE_15__helpers_mixin_thead__["b" /* theadMixin */], __WEBPACK_IMPORTED_MODULE_14__helpers_mixin_tfoot__["b" /* tfootMixin */], __WEBPACK_IMPORTED_MODULE_13__helpers_mixin_tbody__["b" /* tbodyMixin */], // Table features mixins
  // These are pretty lightweight, and are useful for lightweight tables
  __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_caption__["b" /* captionMixin */], __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_colgroup__["b" /* colgroupMixin */]],
  props: props // Render function is provided by `tableRendererMixin`

});

/***/ }),
/* 437 */
/* exports provided: props, BTableSimple */
/* exports used: BTableSimple */
/*!**************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/table-simple.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTableSimple; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_has_listener__ = __webpack_require__(/*! ../../mixins/has-listener */ 252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_stacked__ = __webpack_require__(/*! ./helpers/mixin-stacked */ 234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_table_renderer__ = __webpack_require__(/*! ./helpers/mixin-table-renderer */ 235);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_stacked__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_table_renderer__["a" /* props */])), __WEBPACK_IMPORTED_MODULE_1__constants_components__["z" /* NAME_TABLE_SIMPLE */]); // --- Main component ---
// @vue/component

var BTableSimple = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["z" /* NAME_TABLE_SIMPLE */],
  // Order of mixins is important!
  // They are merged from first to last, followed by this component
  mixins: [// General mixins
  __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_has_listener__["a" /* hasListenerMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__["a" /* normalizeSlotMixin */], // Required table mixins
  __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_table_renderer__["b" /* tableRendererMixin */], // Table features mixins
  // Stacked requires extra handling by users via
  // the table cell `stacked-heading` prop
  __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_stacked__["b" /* stackedMixin */]],
  props: props,
  computed: {
    isTableSimple: function isTableSimple() {
      return true;
    }
  } // Render function is provided by `tableRendererMixin`

});

/***/ }),
/* 438 */
/* exports provided: props, BTable */
/* exports used: BTable */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/table.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__ = __webpack_require__(/*! ../../mixins/attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_has_listener__ = __webpack_require__(/*! ../../mixins/has-listener */ 252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_bottom_row__ = __webpack_require__(/*! ./helpers/mixin-bottom-row */ 930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_busy__ = __webpack_require__(/*! ./helpers/mixin-busy */ 931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_mixin_caption__ = __webpack_require__(/*! ./helpers/mixin-caption */ 428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_mixin_colgroup__ = __webpack_require__(/*! ./helpers/mixin-colgroup */ 429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_mixin_empty__ = __webpack_require__(/*! ./helpers/mixin-empty */ 932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_mixin_filtering__ = __webpack_require__(/*! ./helpers/mixin-filtering */ 933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_mixin_items__ = __webpack_require__(/*! ./helpers/mixin-items */ 430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_mixin_pagination__ = __webpack_require__(/*! ./helpers/mixin-pagination */ 934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_mixin_provider__ = __webpack_require__(/*! ./helpers/mixin-provider */ 935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_mixin_selectable__ = __webpack_require__(/*! ./helpers/mixin-selectable */ 936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_mixin_sorting__ = __webpack_require__(/*! ./helpers/mixin-sorting */ 937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_mixin_stacked__ = __webpack_require__(/*! ./helpers/mixin-stacked */ 234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_mixin_table_renderer__ = __webpack_require__(/*! ./helpers/mixin-table-renderer */ 235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_mixin_tbody__ = __webpack_require__(/*! ./helpers/mixin-tbody */ 431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_mixin_tfoot__ = __webpack_require__(/*! ./helpers/mixin-tfoot */ 432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_mixin_thead__ = __webpack_require__(/*! ./helpers/mixin-thead */ 433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_mixin_top_row__ = __webpack_require__(/*! ./helpers/mixin-top-row */ 939);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__mixins_id__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_bottom_row__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_busy__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_10__helpers_mixin_caption__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__helpers_mixin_colgroup__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__helpers_mixin_empty__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_13__helpers_mixin_filtering__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_14__helpers_mixin_items__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_15__helpers_mixin_pagination__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_16__helpers_mixin_provider__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_17__helpers_mixin_selectable__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_18__helpers_mixin_sorting__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_19__helpers_mixin_stacked__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_20__helpers_mixin_table_renderer__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_21__helpers_mixin_tbody__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_22__helpers_mixin_tfoot__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_23__helpers_mixin_thead__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_24__helpers_mixin_top_row__["a" /* props */])), __WEBPACK_IMPORTED_MODULE_1__constants_components__["B" /* NAME_TABLE */]); // --- Main component ---
// @vue/component

var BTable = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["B" /* NAME_TABLE */],
  // Order of mixins is important!
  // They are merged from first to last, followed by this component
  mixins: [// General mixins
  __WEBPACK_IMPORTED_MODULE_4__mixins_attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins_has_listener__["a" /* hasListenerMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_7__mixins_normalize_slot__["a" /* normalizeSlotMixin */], // Required table mixins
  __WEBPACK_IMPORTED_MODULE_14__helpers_mixin_items__["b" /* itemsMixin */], __WEBPACK_IMPORTED_MODULE_20__helpers_mixin_table_renderer__["b" /* tableRendererMixin */], __WEBPACK_IMPORTED_MODULE_19__helpers_mixin_stacked__["b" /* stackedMixin */], __WEBPACK_IMPORTED_MODULE_23__helpers_mixin_thead__["b" /* theadMixin */], __WEBPACK_IMPORTED_MODULE_22__helpers_mixin_tfoot__["b" /* tfootMixin */], __WEBPACK_IMPORTED_MODULE_21__helpers_mixin_tbody__["b" /* tbodyMixin */], // Table features mixins
  __WEBPACK_IMPORTED_MODULE_19__helpers_mixin_stacked__["b" /* stackedMixin */], __WEBPACK_IMPORTED_MODULE_13__helpers_mixin_filtering__["b" /* filteringMixin */], __WEBPACK_IMPORTED_MODULE_18__helpers_mixin_sorting__["b" /* sortingMixin */], __WEBPACK_IMPORTED_MODULE_15__helpers_mixin_pagination__["b" /* paginationMixin */], __WEBPACK_IMPORTED_MODULE_10__helpers_mixin_caption__["b" /* captionMixin */], __WEBPACK_IMPORTED_MODULE_11__helpers_mixin_colgroup__["b" /* colgroupMixin */], __WEBPACK_IMPORTED_MODULE_17__helpers_mixin_selectable__["b" /* selectableMixin */], __WEBPACK_IMPORTED_MODULE_12__helpers_mixin_empty__["b" /* emptyMixin */], __WEBPACK_IMPORTED_MODULE_24__helpers_mixin_top_row__["b" /* topRowMixin */], __WEBPACK_IMPORTED_MODULE_8__helpers_mixin_bottom_row__["b" /* bottomRowMixin */], __WEBPACK_IMPORTED_MODULE_9__helpers_mixin_busy__["b" /* busyMixin */], __WEBPACK_IMPORTED_MODULE_16__helpers_mixin_provider__["b" /* providerMixin */]],
  props: props // Render function is provided by `tableRendererMixin`

});

/***/ }),
/* 439 */
/* exports provided: TabsPlugin, BTabs, BTab */
/* exports used: TabsPlugin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tabs/index.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabsPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__(/*! ./tabs */ 441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tab__ = __webpack_require__(/*! ./tab */ 440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BTabs */
/* unused harmony reexport BTab */



var TabsPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BTabs: __WEBPACK_IMPORTED_MODULE_0__tabs__["a" /* BTabs */],
    BTab: __WEBPACK_IMPORTED_MODULE_1__tab__["a" /* BTab */]
  }
});


/***/ }),
/* 440 */
/* exports provided: props, BTab */
/* exports used: BTab */
/*!****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tabs/tab.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__transition_bv_transition__ = __webpack_require__(/*! ../transition/bv-transition */ 108);
var _objectSpread2, _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Constants ---

var MODEL_PROP_NAME_ACTIVE = 'active';
var MODEL_EVENT_NAME_ACTIVE = __WEBPACK_IMPORTED_MODULE_2__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_ACTIVE; // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__mixins_id__["a" /* props */]), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, MODEL_PROP_NAME_ACTIVE, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_objectSpread2, "buttonId", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])), _defineProperty(_objectSpread2, "disabled", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_objectSpread2, "lazy", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_objectSpread2, "noBody", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_objectSpread2, "tag", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'div')), _defineProperty(_objectSpread2, "title", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])), _defineProperty(_objectSpread2, "titleItemClass", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])), _defineProperty(_objectSpread2, "titleLinkAttributes", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["e" /* PROP_TYPE_OBJECT */])), _defineProperty(_objectSpread2, "titleLinkClass", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */])), _objectSpread2))), __WEBPACK_IMPORTED_MODULE_1__constants_components__["p" /* NAME_TAB */]); // --- Main component ---
// @vue/component

var BTab = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["p" /* NAME_TAB */],
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_id__["b" /* idMixin */], __WEBPACK_IMPORTED_MODULE_8__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  inject: {
    getBvTabs: {
      default: function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  props: props,
  data: function data() {
    return {
      localActive: this[MODEL_PROP_NAME_ACTIVE] && !this.disabled
    };
  },
  computed: {
    bvTabs: function bvTabs() {
      return this.getBvTabs();
    },
    // For parent sniffing of child
    _isTab: function _isTab() {
      return true;
    },
    tabClasses: function tabClasses() {
      var active = this.localActive,
          disabled = this.disabled;
      return [{
        active: active,
        disabled: disabled,
        'card-body': this.bvTabs.card && !this.noBody
      }, // Apply <b-tabs> `activeTabClass` styles when this tab is active
      active ? this.bvTabs.activeTabClass : null];
    },
    controlledBy: function controlledBy() {
      return this.buttonId || this.safeId('__BV_tab_button__');
    },
    computedNoFade: function computedNoFade() {
      return !(this.bvTabs.fade || false);
    },
    computedLazy: function computedLazy() {
      return this.bvTabs.lazy || this.lazy;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME_ACTIVE, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      if (newValue) {
        // If activated post mount
        this.activate();
      } else {
        /* istanbul ignore next */
        if (!this.deactivate()) {
          // Tab couldn't be deactivated, so we reset the synced active prop
          // Deactivation will fail if no other tabs to activate
          this.$emit(MODEL_EVENT_NAME_ACTIVE, this.localActive);
        }
      }
    }
  }), _defineProperty(_watch, "disabled", function disabled(newValue, oldValue) {
    if (newValue !== oldValue) {
      var firstTab = this.bvTabs.firstTab;

      if (newValue && this.localActive && firstTab) {
        this.localActive = false;
        firstTab();
      }
    }
  }), _defineProperty(_watch, "localActive", function localActive(newValue) {
    // Make `active` prop work with `.sync` modifier
    this.$emit(MODEL_EVENT_NAME_ACTIVE, newValue);
  }), _watch),
  mounted: function mounted() {
    // Inform `<b-tabs>` of our presence
    this.registerTab();
  },
  updated: function updated() {
    // Force the tab button content to update (since slots are not reactive)
    // Only done if we have a title slot, as the title prop is reactive
    var updateButton = this.bvTabs.updateButton;

    if (updateButton && this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["e" /* SLOT_NAME_TITLE */])) {
      updateButton(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Inform `<b-tabs>` of our departure
    this.unregisterTab();
  },
  methods: {
    // Private methods
    registerTab: function registerTab() {
      // Inform `<b-tabs>` of our presence
      var registerTab = this.bvTabs.registerTab;

      if (registerTab) {
        registerTab(this);
      }
    },
    unregisterTab: function unregisterTab() {
      // Inform `<b-tabs>` of our departure
      var unregisterTab = this.bvTabs.unregisterTab;

      if (unregisterTab) {
        unregisterTab(this);
      }
    },
    // Public methods
    activate: function activate() {
      // Not inside a `<b-tabs>` component or tab is disabled
      var activateTab = this.bvTabs.activateTab;
      return activateTab && !this.disabled ? activateTab(this) : false;
    },
    deactivate: function deactivate() {
      // Not inside a `<b-tabs>` component or not active to begin with
      var deactivateTab = this.bvTabs.deactivateTab;
      return deactivateTab && this.localActive ? deactivateTab(this) : false;
    }
  },
  render: function render(h) {
    var localActive = this.localActive;
    var $content = h(this.tag, {
      staticClass: 'tab-pane',
      class: this.tabClasses,
      directives: [{
        name: 'show',
        value: localActive
      }],
      attrs: {
        role: 'tabpanel',
        id: this.safeId(),
        'aria-hidden': localActive ? 'false' : 'true',
        'aria-labelledby': this.controlledBy || null
      },
      ref: 'panel'
    }, // Render content lazily if requested
    [localActive || !this.computedLazy ? this.normalizeSlot() : h()]);
    return h(__WEBPACK_IMPORTED_MODULE_9__transition_bv_transition__["a" /* BVTransition */], {
      props: {
        mode: 'out-in',
        noFade: this.computedNoFade
      }
    }, [$content]);
  }
});

/***/ }),
/* 441 */
/* exports provided: props, BTabs */
/* exports used: BTabs */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tabs/tabs.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__ = __webpack_require__(/*! ../../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_slots__ = __webpack_require__(/*! ../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bv_event_class__ = __webpack_require__(/*! ../../utils/bv-event.class */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_events__ = __webpack_require__(/*! ../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_model__ = __webpack_require__(/*! ../../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_observe_dom__ = __webpack_require__(/*! ../../utils/observe-dom */ 185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_stable_sort__ = __webpack_require__(/*! ../../utils/stable-sort */ 466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__mixins_id__ = __webpack_require__(/*! ../../mixins/id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__link_link__ = __webpack_require__(/*! ../link/link */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__nav_nav__ = __webpack_require__(/*! ../nav/nav */ 174);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_5__constants_props__["l" /* PROP_TYPE_NUMBER */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event; // --- Helper methods ---
// Filter function to filter out disabled tabs


var notDisabled = function notDisabled(tab) {
  return !tab.disabled;
}; // --- Helper components ---
// @vue/component


var BVTabButton = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["q" /* NAME_TAB_BUTTON_HELPER */],
  inject: {
    getBvTabs: {
      default:
      /* istanbul ignore next */
      function _default() {
        return function () {
          return {};
        };
      }
    }
  },
  props: {
    controls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
    id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */]),
    noKeyNav: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
    posInSet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["l" /* PROP_TYPE_NUMBER */]),
    setSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["l" /* PROP_TYPE_NUMBER */]),
    // Reference to the child <b-tab> instance
    tab: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(),
    tabIndex: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["l" /* PROP_TYPE_NUMBER */])
  },
  computed: {
    bvTabs: function bvTabs() {
      return this.getBvTabs();
    }
  },
  methods: {
    focus: function focus() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(this.$refs.link);
    },
    handleEvent: function handleEvent(event) {
      /* istanbul ignore next */
      if (this.tab.disabled) {
        return;
      }

      var type = event.type,
          keyCode = event.keyCode,
          shiftKey = event.shiftKey;

      if (type === 'click') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event);
        this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["x" /* EVENT_NAME_CLICK */], event);
      } else if (type === 'keydown' && keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["b" /* CODE_SPACE */]) {
        // For ARIA tabs the SPACE key will also trigger a click/select
        // Even with keyboard navigation disabled, SPACE should "click" the button
        // See: https://github.com/bootstrap-vue/bootstrap-vue/issues/4323
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event);
        this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["x" /* EVENT_NAME_CLICK */], event);
      } else if (type === 'keydown' && !this.noKeyNav) {
        // For keyboard navigation
        if ([__WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["e" /* CODE_UP */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["c" /* CODE_LEFT */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["g" /* CODE_HOME */]].indexOf(keyCode) !== -1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event);

          if (shiftKey || keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["g" /* CODE_HOME */]) {
            this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["A" /* EVENT_NAME_FIRST */], event);
          } else {
            this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["B" /* EVENT_NAME_PREV */], event);
          }
        } else if ([__WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["f" /* CODE_DOWN */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["d" /* CODE_RIGHT */], __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["h" /* CODE_END */]].indexOf(keyCode) !== -1) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_events__["f" /* stopEvent */])(event);

          if (shiftKey || keyCode === __WEBPACK_IMPORTED_MODULE_4__constants_key_codes__["h" /* CODE_END */]) {
            this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["C" /* EVENT_NAME_LAST */], event);
          } else {
            this.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["D" /* EVENT_NAME_NEXT */], event);
          }
        }
      }
    }
  },
  render: function render(h) {
    var id = this.id,
        tabIndex = this.tabIndex,
        setSize = this.setSize,
        posInSet = this.posInSet,
        controls = this.controls,
        handleEvent = this.handleEvent;
    var _this$tab = this.tab,
        title = _this$tab.title,
        localActive = _this$tab.localActive,
        disabled = _this$tab.disabled,
        titleItemClass = _this$tab.titleItemClass,
        titleLinkClass = _this$tab.titleLinkClass,
        titleLinkAttributes = _this$tab.titleLinkAttributes;
    var $link = h(__WEBPACK_IMPORTED_MODULE_23__link_link__["a" /* BLink */], {
      staticClass: 'nav-link',
      class: [{
        active: localActive && !disabled,
        disabled: disabled
      }, titleLinkClass, // Apply <b-tabs> `activeNavItemClass` styles when the tab is active
      localActive ? this.bvTabs.activeNavItemClass : null],
      props: {
        disabled: disabled
      },
      attrs: _objectSpread(_objectSpread({}, titleLinkAttributes), {}, {
        id: id,
        role: 'tab',
        // Roving tab index when keynav enabled
        tabindex: tabIndex,
        'aria-selected': localActive && !disabled ? 'true' : 'false',
        'aria-setsize': setSize,
        'aria-posinset': posInSet,
        'aria-controls': controls
      }),
      on: {
        click: handleEvent,
        keydown: handleEvent
      },
      ref: 'link'
    }, [this.tab.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["e" /* SLOT_NAME_TITLE */]) || title]);
    return h('li', {
      staticClass: 'nav-item',
      class: [titleItemClass],
      attrs: {
        role: 'presentation'
      }
    }, [$link]);
  }
}); // --- Props ---

var navProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_24__nav_nav__["b" /* props */], ['tabs', 'isNavBar', 'cardHeader']);
var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_21__mixins_id__["a" /* props */]), modelProps), navProps), {}, {
  // Only applied to the currently active `<b-nav-item>`
  activeNavItemClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  // Only applied to the currently active `<b-tab>`
  // This prop is sniffed by the `<b-tab>` child
  activeTabClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  card: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  contentClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  // Synonym for 'bottom'
  end: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // This prop is sniffed by the `<b-tab>` child
  lazy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  navClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  navWrapperClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  noFade: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noKeyNav: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noNavStyle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_5__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
})), __WEBPACK_IMPORTED_MODULE_1__constants_components__["r" /* NAME_TABS */]); // --- Main component ---
// @vue/component

var BTabs = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["r" /* NAME_TABS */],
  mixins: [__WEBPACK_IMPORTED_MODULE_21__mixins_id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_22__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  provide: function provide() {
    var _this = this;

    return {
      getBvTabs: function getBvTabs() {
        return _this;
      }
    };
  },
  props: props,
  data: function data() {
    return {
      // Index of current tab
      currentTab: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_number__["b" /* toInteger */])(this[MODEL_PROP_NAME], -1),
      // Array of direct child `<b-tab>` instances, in DOM order
      tabs: [],
      // Array of child instances registered (for triggering reactive updates)
      registeredTabs: []
    };
  },
  computed: {
    fade: function fade() {
      // This computed prop is sniffed by the tab child
      return !this.noFade;
    },
    localNavClass: function localNavClass() {
      var classes = [];

      if (this.card && this.vertical) {
        classes.push('card-header', 'h-100', 'border-bottom-0', 'rounded-0');
      }

      return [].concat(classes, [this.navClass]);
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_number__["b" /* toInteger */])(newValue, -1);
      oldValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_number__["b" /* toInteger */])(oldValue, 0);
      var $tab = this.tabs[newValue];

      if ($tab && !$tab.disabled) {
        this.activateTab($tab);
      } else {
        // Try next or prev tabs
        if (newValue < oldValue) {
          this.previousTab();
        } else {
          this.nextTab();
        }
      }
    }
  }), _defineProperty(_watch, "currentTab", function currentTab(newValue) {
    var index = -1; // Ensure only one tab is active at most

    this.tabs.forEach(function ($tab, i) {
      if (i === newValue && !$tab.disabled) {
        $tab.localActive = true;
        index = i;
      } else {
        $tab.localActive = false;
      }
    }); // Update the v-model

    this.$emit(MODEL_EVENT_NAME, index);
  }), _defineProperty(_watch, "tabs", function tabs(newValue, oldValue) {
    var _this2 = this;

    // We use `_uid` instead of `safeId()`, as the later is changed in a `$nextTick()`
    // if no explicit ID is provided, causing duplicate emits
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_loose_equal__["a" /* looseEqual */])(newValue.map(function ($tab) {
      return $tab[__WEBPACK_IMPORTED_MODULE_0__vue__["e" /* COMPONENT_UID_KEY */]];
    }), oldValue.map(function ($tab) {
      return $tab[__WEBPACK_IMPORTED_MODULE_0__vue__["e" /* COMPONENT_UID_KEY */]];
    }))) {
      // In a `$nextTick()` to ensure `currentTab` has been set first
      this.$nextTick(function () {
        // We emit shallow copies of the new and old arrays of tabs,
        // to prevent users from potentially mutating the internal arrays
        _this2.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["E" /* EVENT_NAME_CHANGED */], newValue.slice(), oldValue.slice());
      });
    }
  }), _defineProperty(_watch, "registeredTabs", function registeredTabs() {
    this.updateTabs();
  }), _watch),
  created: function created() {
    // Create private non-reactive props
    this.$_observer = null;
  },
  mounted: function mounted() {
    this.setObserver(true);
  },
  beforeDestroy: function beforeDestroy() {
    this.setObserver(false); // Ensure no references to child instances exist

    this.tabs = [];
  },
  methods: {
    registerTab: function registerTab($tab) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_array__["c" /* arrayIncludes */])(this.registeredTabs, $tab)) {
        this.registeredTabs.push($tab);
      }
    },
    unregisterTab: function unregisterTab($tab) {
      this.registeredTabs = this.registeredTabs.slice().filter(function ($t) {
        return $t !== $tab;
      });
    },
    // DOM observer is needed to detect changes in order of tabs
    setObserver: function setObserver() {
      var _this3 = this;

      var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.$_observer && this.$_observer.disconnect();
      this.$_observer = null;

      if (on) {
        /* istanbul ignore next: difficult to test mutation observer in JSDOM */
        var handler = function handler() {
          _this3.$nextTick(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["a" /* requestAF */])(function () {
              _this3.updateTabs();
            });
          });
        }; // Watch for changes to `<b-tab>` sub components


        this.$_observer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_observe_dom__["a" /* observeDom */])(this.$refs.content, handler, {
          childList: true,
          subtree: false,
          attributes: true,
          attributeFilter: ['id']
        });
      }
    },
    getTabs: function getTabs() {
      var $tabs = this.registeredTabs; // Dropped intentionally
      // .filter(
      //   $tab => $tab.$children.filter($t => $t && $t._isTab).length === 0
      // )
      // DOM Order of Tabs

      var order = [];
      /* istanbul ignore next: too difficult to test */

      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] && $tabs.length > 0) {
        // We rely on the DOM when mounted to get the "true" order of the `<b-tab>` children
        // `querySelectorAll()` always returns elements in document order, regardless of
        // order specified in the selector
        var selector = $tabs.map(function ($tab) {
          return "#".concat($tab.safeId());
        }).join(', ');
        order = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["w" /* selectAll */])(selector, this.$el).map(function ($el) {
          return $el.id;
        }).filter(__WEBPACK_IMPORTED_MODULE_11__utils_identity__["a" /* identity */]);
      } // Stable sort keeps the original order if not found in the `order` array,
      // which will be an empty array before mount


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_stable_sort__["a" /* stableSort */])($tabs, function (a, b) {
        return order.indexOf(a.safeId()) - order.indexOf(b.safeId());
      });
    },
    updateTabs: function updateTabs() {
      var $tabs = this.getTabs(); // Find last active non-disabled tab in current tabs
      // We trust tab state over `currentTab`, in case tabs were added/removed/re-ordered

      var tabIndex = $tabs.indexOf($tabs.slice().reverse().find(function ($tab) {
        return $tab.localActive && !$tab.disabled;
      })); // Else try setting to `currentTab`

      if (tabIndex < 0) {
        var currentTab = this.currentTab;

        if (currentTab >= $tabs.length) {
          // Handle last tab being removed, so find the last non-disabled tab
          tabIndex = $tabs.indexOf($tabs.slice().reverse().find(notDisabled));
        } else if ($tabs[currentTab] && !$tabs[currentTab].disabled) {
          // Current tab is not disabled
          tabIndex = currentTab;
        }
      } // Else find first non-disabled tab in current tabs


      if (tabIndex < 0) {
        tabIndex = $tabs.indexOf($tabs.find(notDisabled));
      } // Ensure only one tab is active at a time


      $tabs.forEach(function ($tab, index) {
        $tab.localActive = index === tabIndex;
      });
      this.tabs = $tabs;
      this.currentTab = tabIndex;
    },
    // Find a button that controls a tab, given the tab reference
    // Returns the button vm instance
    getButtonForTab: function getButtonForTab($tab) {
      return (this.$refs.buttons || []).find(function ($btn) {
        return $btn.tab === $tab;
      });
    },
    // Force a button to re-render its content, given a `<b-tab>` instance
    // Called by `<b-tab>` on `update()`
    updateButton: function updateButton($tab) {
      var $button = this.getButtonForTab($tab);

      if ($button && $button.$forceUpdate) {
        $button.$forceUpdate();
      }
    },
    // Activate a tab given a `<b-tab>` instance
    // Also accessed by `<b-tab>`
    activateTab: function activateTab($tab) {
      var currentTab = this.currentTab,
          $tabs = this.tabs;
      var result = false;

      if ($tab) {
        var index = $tabs.indexOf($tab);

        if (index !== currentTab && index > -1 && !$tab.disabled) {
          var tabEvent = new __WEBPACK_IMPORTED_MODULE_8__utils_bv_event_class__["a" /* BvEvent */](__WEBPACK_IMPORTED_MODULE_3__constants_events__["F" /* EVENT_NAME_ACTIVATE_TAB */], {
            cancelable: true,
            vueTarget: this,
            componentId: this.safeId()
          });
          this.$emit(tabEvent.type, index, currentTab, tabEvent);

          if (!tabEvent.defaultPrevented) {
            this.currentTab = index;
            result = true;
          }
        }
      } // Couldn't set tab, so ensure v-model is up to date

      /* istanbul ignore next: should rarely happen */


      if (!result && this[MODEL_PROP_NAME] !== currentTab) {
        this.$emit(MODEL_EVENT_NAME, currentTab);
      }

      return result;
    },
    // Deactivate a tab given a `<b-tab>` instance
    // Accessed by `<b-tab>`
    deactivateTab: function deactivateTab($tab) {
      if ($tab) {
        // Find first non-disabled tab that isn't the one being deactivated
        // If no tabs are available, then don't deactivate current tab
        return this.activateTab(this.tabs.filter(function ($t) {
          return $t !== $tab;
        }).find(notDisabled));
      }
      /* istanbul ignore next: should never/rarely happen */


      return false;
    },
    // Focus a tab button given its `<b-tab>` instance
    focusButton: function focusButton($tab) {
      var _this4 = this;

      // Wrap in `$nextTick()` to ensure DOM has completed rendering
      this.$nextTick(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dom__["n" /* attemptFocus */])(_this4.getButtonForTab($tab));
      });
    },
    // Emit a click event on a specified `<b-tab>` component instance
    emitTabClick: function emitTabClick(tab, event) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_inspect__["l" /* isEvent */])(event) && tab && tab.$emit && !tab.disabled) {
        tab.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["x" /* EVENT_NAME_CLICK */], event);
      }
    },
    // Click handler
    clickTab: function clickTab($tab, event) {
      this.activateTab($tab);
      this.emitTabClick($tab, event);
    },
    // Move to first non-disabled tab
    firstTab: function firstTab(focus) {
      var $tab = this.tabs.find(notDisabled);

      if (this.activateTab($tab) && focus) {
        this.focusButton($tab);
        this.emitTabClick($tab, focus);
      }
    },
    // Move to previous non-disabled tab
    previousTab: function previousTab(focus) {
      var currentIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_math__["a" /* mathMax */])(this.currentTab, 0);
      var $tab = this.tabs.slice(0, currentIndex).reverse().find(notDisabled);

      if (this.activateTab($tab) && focus) {
        this.focusButton($tab);
        this.emitTabClick($tab, focus);
      }
    },
    // Move to next non-disabled tab
    nextTab: function nextTab(focus) {
      var currentIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_math__["a" /* mathMax */])(this.currentTab, -1);
      var $tab = this.tabs.slice(currentIndex + 1).find(notDisabled);

      if (this.activateTab($tab) && focus) {
        this.focusButton($tab);
        this.emitTabClick($tab, focus);
      }
    },
    // Move to last non-disabled tab
    lastTab: function lastTab(focus) {
      var $tab = this.tabs.slice().reverse().find(notDisabled);

      if (this.activateTab($tab) && focus) {
        this.focusButton($tab);
        this.emitTabClick($tab, focus);
      }
    }
  },
  render: function render(h) {
    var _this5 = this;

    var align = this.align,
        card = this.card,
        end = this.end,
        fill = this.fill,
        firstTab = this.firstTab,
        justified = this.justified,
        lastTab = this.lastTab,
        nextTab = this.nextTab,
        noKeyNav = this.noKeyNav,
        noNavStyle = this.noNavStyle,
        pills = this.pills,
        previousTab = this.previousTab,
        small = this.small,
        $tabs = this.tabs,
        vertical = this.vertical; // Currently active tab

    var $activeTab = $tabs.find(function ($tab) {
      return $tab.localActive && !$tab.disabled;
    }); // Tab button to allow focusing when no active tab found (keynav only)

    var $fallbackTab = $tabs.find(function ($tab) {
      return !$tab.disabled;
    }); // For each `<b-tab>` found create the tab buttons

    var $buttons = $tabs.map(function ($tab, index) {
      var _on;

      var safeId = $tab.safeId; // Ensure at least one tab button is focusable when keynav enabled (if possible)

      var tabIndex = null;

      if (!noKeyNav) {
        // Buttons are not in tab index unless active, or a fallback tab
        tabIndex = -1;

        if ($tab === $activeTab || !$activeTab && $tab === $fallbackTab) {
          // Place tab button in tab sequence
          tabIndex = null;
        }
      }

      return h(BVTabButton, _defineProperty({
        props: {
          controls: safeId ? safeId() : null,
          id: $tab.controlledBy || (safeId ? safeId("_BV_tab_button_") : null),
          noKeyNav: noKeyNav,
          posInSet: index + 1,
          setSize: $tabs.length,
          tab: $tab,
          tabIndex: tabIndex
        },
        on: (_on = {}, _defineProperty(_on, __WEBPACK_IMPORTED_MODULE_3__constants_events__["x" /* EVENT_NAME_CLICK */], function (event) {
          _this5.clickTab($tab, event);
        }), _defineProperty(_on, __WEBPACK_IMPORTED_MODULE_3__constants_events__["A" /* EVENT_NAME_FIRST */], firstTab), _defineProperty(_on, __WEBPACK_IMPORTED_MODULE_3__constants_events__["B" /* EVENT_NAME_PREV */], previousTab), _defineProperty(_on, __WEBPACK_IMPORTED_MODULE_3__constants_events__["D" /* EVENT_NAME_NEXT */], nextTab), _defineProperty(_on, __WEBPACK_IMPORTED_MODULE_3__constants_events__["C" /* EVENT_NAME_LAST */], lastTab), _on),
        key: $tab[__WEBPACK_IMPORTED_MODULE_0__vue__["e" /* COMPONENT_UID_KEY */]] || index,
        ref: 'buttons'
      }, __WEBPACK_IMPORTED_MODULE_0__vue__["g" /* REF_FOR_KEY */], true));
    });
    var $nav = h(__WEBPACK_IMPORTED_MODULE_24__nav_nav__["a" /* BNav */], {
      class: this.localNavClass,
      attrs: {
        role: 'tablist',
        id: this.safeId('_BV_tab_controls_')
      },
      props: {
        fill: fill,
        justified: justified,
        align: align,
        tabs: !noNavStyle && !pills,
        pills: !noNavStyle && pills,
        vertical: vertical,
        small: small,
        cardHeader: card && !vertical
      },
      ref: 'nav'
    }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["f" /* SLOT_NAME_TABS_START */]) || h(), $buttons, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["g" /* SLOT_NAME_TABS_END */]) || h()]);
    $nav = h('div', {
      class: [{
        'card-header': card && !vertical && !end,
        'card-footer': card && !vertical && end,
        'col-auto': vertical
      }, this.navWrapperClass],
      key: 'bv-tabs-nav'
    }, [$nav]);
    var $children = this.normalizeSlot() || [];
    var $empty = h();

    if ($children.length === 0) {
      $empty = h('div', {
        class: ['tab-pane', 'active', {
          'card-body': card
        }],
        key: 'bv-empty-tab'
      }, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_6__constants_slots__["h" /* SLOT_NAME_EMPTY */]));
    }

    var $content = h('div', {
      staticClass: 'tab-content',
      class: [{
        col: vertical
      }, this.contentClass],
      attrs: {
        id: this.safeId('_BV_tab_container_')
      },
      key: 'bv-content',
      ref: 'content'
    }, [$children, $empty]); // Render final output

    return h(this.tag, {
      staticClass: 'tabs',
      class: {
        row: vertical,
        'no-gutters': vertical && card
      },
      attrs: {
        id: this.safeId()
      }
    }, [end ? $content : h(), $nav, end ? h() : $content]);
  }
});

/***/ }),
/* 442 */
/* exports provided: TimePlugin, BTime */
/* exports used: TimePlugin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/time/index.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(/*! ./time */ 239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BTime */


var TimePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BTime: __WEBPACK_IMPORTED_MODULE_0__time__["a" /* BTime */]
  }
});


/***/ }),
/* 443 */
/* exports provided: BVToastPlugin */
/* exports used: BVToastPlugin */
/*!******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/toast/helpers/bv-toast.js ***!
  \******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVToastPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_use_parent__ = __webpack_require__(/*! ../../../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_config__ = __webpack_require__(/*! ../../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_plugins__ = __webpack_require__(/*! ../../../utils/plugins */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_warn__ = __webpack_require__(/*! ../../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_create_new_child_component__ = __webpack_require__(/*! ../../../utils/create-new-child-component */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__ = __webpack_require__(/*! ../../../utils/get-event-root */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__toast__ = __webpack_require__(/*! ../toast */ 240);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Plugin for adding `$bvToast` property to all Vue instances
 */













 // --- Constants ---

var PROP_NAME = '$bvToast';
var PROP_NAME_PRIV = '_bv__toast'; // Base toast props that are allowed
// Some may be ignored or overridden on some message boxes
// Prop ID is allowed, but really only should be used for testing
// We need to add it in explicitly as it comes from the `idMixin`

var BASE_PROPS = ['id'].concat(_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["a" /* keys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_13__toast__["b" /* props */], ['static', 'visible'])))); // Map prop names to toast slot names

var propsToSlots = {
  toastContent: 'default',
  title: 'toast-title'
}; // --- Helper methods ---
// Method to filter only recognized props that are not undefined

var filterOptions = function filterOptions(options) {
  return BASE_PROPS.reduce(function (memo, key) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["i" /* isUndefined */])(options[key])) {
      memo[key] = options[key];
    }

    return memo;
  }, {});
}; // Method to install `$bvToast` VM injection


var plugin = function plugin(Vue) {
  // Create a private sub-component constructor that
  // extends BToast and self-destructs after hidden
  // @vue/component
  var BVToastPop = Vue.extend({
    name: __WEBPACK_IMPORTED_MODULE_0__constants_components__["_76" /* NAME_TOAST_POP */],
    extends: __WEBPACK_IMPORTED_MODULE_13__toast__["a" /* BToast */],
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_use_parent__["a" /* useParentMixin */]],
    destroyed: function destroyed() {
      // Make sure we not in document any more
      var $el = this.$el;

      if ($el && $el.parentNode) {
        $el.parentNode.removeChild($el);
      }
    },
    mounted: function mounted() {
      var _this = this;

      // Self destruct handler
      var handleDestroy = function handleDestroy() {
        // Ensure the toast has been force hidden
        _this.localShow = false;
        _this.doRender = false;

        _this.$nextTick(function () {
          _this.$nextTick(function () {
            // In a `requestAF()` to release control back to application
            // and to allow the portal-target time to remove the content
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_dom__["a" /* requestAF */])(function () {
              _this.$destroy();
            });
          });
        });
      }; // Self destruct if parent destroyed


      this.bvParent.$once(__WEBPACK_IMPORTED_MODULE_1__constants_events__["f" /* HOOK_EVENT_NAME_DESTROYED */], handleDestroy); // Self destruct after hidden

      this.$once(__WEBPACK_IMPORTED_MODULE_1__constants_events__["b" /* EVENT_NAME_HIDDEN */], handleDestroy); // Self destruct when toaster is destroyed

      this.listenOnRoot(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["k" /* NAME_TOASTER */], __WEBPACK_IMPORTED_MODULE_1__constants_events__["v" /* EVENT_NAME_DESTROYED */]), function (toaster) {
        /* istanbul ignore next: hard to test */
        if (toaster === _this.toaster) {
          handleDestroy();
        }
      });
    }
  }); // Private method to generate the on-demand toast

  var makeToast = function makeToast(props, parent) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["c" /* warnNotClient */])(PROP_NAME)) {
      /* istanbul ignore next */
      return;
    } // Create an instance of `BVToastPop` component


    var toast = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_create_new_child_component__["a" /* createNewChildComponent */])(parent, BVToastPop, {
      // We set parent as the local VM so these toasts can emit events on the
      // app `$root`, and it ensures `BToast` is destroyed when parent is destroyed
      propsData: _objectSpread(_objectSpread(_objectSpread({}, filterOptions(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["l" /* NAME_TOAST */]))), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["m" /* omit */])(props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["a" /* keys */])(propsToSlots))), {}, {
        // Props that can't be overridden
        static: false,
        visible: true
      })
    }); // Convert certain props to slots

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["a" /* keys */])(propsToSlots).forEach(function (prop) {
      var value = props[prop];

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["i" /* isUndefined */])(value)) {
        // Can be a string, or array of VNodes
        if (prop === 'title' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_inspect__["f" /* isString */])(value)) {
          // Special case for title if it is a string, we wrap in a <strong>
          value = [parent.$createElement('strong', {
            class: 'mr-2'
          }, value)];
        }

        toast.$slots[propsToSlots[prop]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(value);
      }
    }); // Create a mount point (a DIV) and mount it (which triggers the show)

    var div = document.createElement('div');
    document.body.appendChild(div);
    toast.$mount(div);
  }; // Declare BvToast instance property class


  var BvToast = /*#__PURE__*/function () {
    function BvToast(vm) {
      _classCallCheck(this, BvToast);

      // Assign the new properties to this instance
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["e" /* assign */])(this, {
        _vm: vm,
        _root: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_get_event_root__["a" /* getEventRoot */])(vm)
      }); // Set these properties as read-only and non-enumerable

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["f" /* defineProperties */])(this, {
        _vm: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["g" /* readonlyDescriptor */])(),
        _root: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["g" /* readonlyDescriptor */])()
      });
    } // --- Public Instance methods ---
    // Opens a user defined toast and returns immediately


    _createClass(BvToast, [{
      key: "toast",
      value: function toast(content) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!content || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["c" /* warnNotClient */])(PROP_NAME)) {
          /* istanbul ignore next */
          return;
        }

        makeToast(_objectSpread(_objectSpread({}, filterOptions(options)), {}, {
          toastContent: content
        }), this._vm);
      } // shows a `<b-toast>` component with the specified ID

    }, {
      key: "show",
      value: function show(id) {
        if (id) {
          this._root.$emit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["l" /* NAME_TOAST */], __WEBPACK_IMPORTED_MODULE_1__constants_events__["a" /* EVENT_NAME_SHOW */]), id);
        }
      } // Hide a toast with specified ID, or if not ID all toasts

    }, {
      key: "hide",
      value: function hide() {
        var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        this._root.$emit(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["l" /* NAME_TOAST */], __WEBPACK_IMPORTED_MODULE_1__constants_events__["e" /* EVENT_NAME_HIDE */]), id);
      }
    }]);

    return BvToast;
  }(); // Add our instance mixin


  Vue.mixin({
    beforeCreate: function beforeCreate() {
      // Because we need access to `$root` for `$emits`, and VM for parenting,
      // we have to create a fresh instance of `BvToast` for each VM
      this[PROP_NAME_PRIV] = new BvToast(this);
    }
  }); // Define our read-only `$bvToast` instance property
  // Placed in an if just in case in HMR mode

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["c" /* hasOwnProperty */])(Vue.prototype, PROP_NAME)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["h" /* defineProperty */])(Vue.prototype, PROP_NAME, {
      get: function get() {
        /* istanbul ignore next */
        if (!this || !this[PROP_NAME_PRIV]) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["a" /* warn */])("\"".concat(PROP_NAME, "\" must be accessed from a Vue instance \"this\" context."), __WEBPACK_IMPORTED_MODULE_0__constants_components__["l" /* NAME_TOAST */]);
        }

        return this[PROP_NAME_PRIV];
      }
    });
  }
};

var BVToastPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_plugins__["b" /* pluginFactory */])({
  plugins: {
    plugin: plugin
  }
});

/***/ }),
/* 444 */
/* exports provided: ToastPlugin, BToast, BToaster */
/* exports used: ToastPlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/toast/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_bv_toast__ = __webpack_require__(/*! ./helpers/bv-toast */ 443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast__ = __webpack_require__(/*! ./toast */ 240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toaster__ = __webpack_require__(/*! ./toaster */ 241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BToast */
/* unused harmony reexport BToaster */




var ToastPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BToast: __WEBPACK_IMPORTED_MODULE_1__toast__["a" /* BToast */],
    BToaster: __WEBPACK_IMPORTED_MODULE_2__toaster__["a" /* BToaster */]
  },
  // $bvToast injection
  plugins: {
    BVToastPlugin: __WEBPACK_IMPORTED_MODULE_0__helpers_bv_toast__["a" /* BVToastPlugin */]
  }
});


/***/ }),
/* 445 */
/* exports provided: props, BVTooltipTemplate */
/* exports used: BVTooltipTemplate */
/*!*******************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tooltip/helpers/bv-tooltip-template.js ***!
  \*******************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVTooltipTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_scoped_style__ = __webpack_require__(/*! ../../../mixins/scoped-style */ 253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bv_popper__ = __webpack_require__(/*! ./bv-popper */ 942);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








 // --- Props ---

var props = {
  // Used only by the directive versions
  html: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Other non-reactive (while open) props are pulled in from BVPopper
  id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])
}; // --- Main component ---
// @vue/component

var BVTooltipTemplate = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["d" /* NAME_TOOLTIP_TEMPLATE */],
  extends: __WEBPACK_IMPORTED_MODULE_7__bv_popper__["a" /* BVPopper */],
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_scoped_style__["a" /* scopedStyleMixin */]],
  props: props,
  data: function data() {
    // We use data, rather than props to ensure reactivity
    // Parent component will directly set this data
    return {
      title: '',
      content: '',
      variant: null,
      customClass: null,
      interactive: true
    };
  },
  computed: {
    templateType: function templateType() {
      return 'tooltip';
    },
    templateClasses: function templateClasses() {
      var _ref;

      var variant = this.variant,
          attachment = this.attachment,
          templateType = this.templateType;
      return [(_ref = {
        // Disables pointer events to hide the tooltip when the user
        // hovers over its content
        noninteractive: !this.interactive
      }, _defineProperty(_ref, "b-".concat(templateType, "-").concat(variant), variant), _defineProperty(_ref, "bs-".concat(templateType, "-").concat(attachment), attachment), _ref), this.customClass];
    },
    templateAttributes: function templateAttributes() {
      var id = this.id;
      return _objectSpread(_objectSpread({}, this.bvParent.bvParent.$attrs), {}, {
        id: id,
        role: 'tooltip',
        tabindex: '-1'
      }, this.scopedStyleAttrs);
    },
    templateListeners: function templateListeners() {
      var _this = this;

      // Used for hover/focus trigger listeners
      return {
        mouseenter:
        /* istanbul ignore next */
        function mouseenter(event) {
          _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["i" /* EVENT_NAME_MOUSEENTER */], event);
        },
        mouseleave:
        /* istanbul ignore next */
        function mouseleave(event) {
          _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["j" /* EVENT_NAME_MOUSELEAVE */], event);
        },
        focusin:
        /* istanbul ignore next */
        function focusin(event) {
          _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["g" /* EVENT_NAME_FOCUSIN */], event);
        },
        focusout:
        /* istanbul ignore next */
        function focusout(event) {
          _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["h" /* EVENT_NAME_FOCUSOUT */], event);
        }
      };
    }
  },
  methods: {
    renderTemplate: function renderTemplate(h) {
      var title = this.title; // Title can be a scoped slot function

      var $title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(title) ? title({}) : title; // Directive versions only

      var domProps = this.html && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(title) ? {
        innerHTML: title
      } : {};
      return h('div', {
        staticClass: 'tooltip b-tooltip',
        class: this.templateClasses,
        attrs: this.templateAttributes,
        on: this.templateListeners
      }, [h('div', {
        staticClass: 'arrow',
        ref: 'arrow'
      }), h('div', {
        staticClass: 'tooltip-inner',
        domProps: domProps
      }, [$title])]);
    }
  }
});

/***/ }),
/* 446 */
/* exports provided: TooltipPlugin, BTooltip */
/* exports used: TooltipPlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tooltip/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(/*! ./tooltip */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_tooltip__ = __webpack_require__(/*! ../../directives/tooltip */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport BTooltip */



var TooltipPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["b" /* pluginFactory */])({
  components: {
    BTooltip: __WEBPACK_IMPORTED_MODULE_0__tooltip__["a" /* BTooltip */]
  },
  plugins: {
    VBTooltipPlugin: __WEBPACK_IMPORTED_MODULE_1__directives_tooltip__["a" /* VBTooltipPlugin */]
  }
});


/***/ }),
/* 447 */
/* exports provided: NAME, PROP_NAME, DEFAULT_BREAKPOINT */
/* exports used: NAME, PROP_NAME, DEFAULT_BREAKPOINT */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/config.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_BREAKPOINT; });
var NAME = 'BvConfig';
var PROP_NAME = '$bvConfig';
var DEFAULT_BREAKPOINT = ['xs', 'sm', 'md', 'lg', 'xl'];

/***/ }),
/* 448 */
/* exports provided: CALENDAR_GREGORY, CALENDAR_LONG, CALENDAR_NARROW, CALENDAR_SHORT, DATE_FORMAT_2_DIGIT, DATE_FORMAT_NUMERIC */
/* exports used: CALENDAR_GREGORY, DATE_FORMAT_NUMERIC, CALENDAR_LONG, CALENDAR_SHORT, CALENDAR_NARROW, DATE_FORMAT_2_DIGIT */
/*!***********************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/date.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_GREGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALENDAR_LONG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CALENDAR_NARROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CALENDAR_SHORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATE_FORMAT_2_DIGIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATE_FORMAT_NUMERIC; });
var CALENDAR_GREGORY = 'gregory';
var CALENDAR_LONG = 'long';
var CALENDAR_NARROW = 'narrow';
var CALENDAR_SHORT = 'short';
var DATE_FORMAT_2_DIGIT = '2-digit';
var DATE_FORMAT_NUMERIC = 'numeric';

/***/ }),
/* 449 */
/* exports provided: VBHoverPlugin, VBHover */
/* exports used: VBHoverPlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/hover/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBHoverPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hover__ = __webpack_require__(/*! ./hover */ 244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport VBHover */


var VBHoverPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  directives: {
    VBHover: __WEBPACK_IMPORTED_MODULE_0__hover__["a" /* VBHover */]
  }
});


/***/ }),
/* 450 */
/* exports provided: VBModalPlugin, VBModal */
/* exports used: VBModalPlugin */
/*!*******************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/modal/index.js ***!
  \*******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBModalPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(/*! ./modal */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport VBModal */


var VBModalPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  directives: {
    VBModal: __WEBPACK_IMPORTED_MODULE_0__modal__["a" /* VBModal */]
  }
});


/***/ }),
/* 451 */
/* exports provided: VBPopover */
/* exports used: VBPopover */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/popover/popover.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBPopover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_config__ = __webpack_require__(/*! ../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_get_scope_id__ = __webpack_require__(/*! ../../utils/get-scope-id */ 140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_get_instance_from_directive__ = __webpack_require__(/*! ../../utils/get-instance-from-directive */ 139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_create_new_child_component__ = __webpack_require__(/*! ../../utils/create-new-child-component */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_popover_helpers_bv_popover__ = __webpack_require__(/*! ../../components/popover/helpers/bv-popover */ 414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__vue__ = __webpack_require__(/*! ../../vue */ 0);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















 // Key which we use to store tooltip object on element

var BV_POPOVER = '__BV_Popover__'; // Default trigger

var DefaultTrigger = 'click'; // Valid event triggers

var validTriggers = {
  focus: true,
  hover: true,
  click: true,
  blur: true,
  manual: true
}; // Directive modifier test regular expressions. Pre-compile for performance

var htmlRE = /^html$/i;
var noFadeRE = /^nofade$/i;
var placementRE = /^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/i;
var boundaryRE = /^(window|viewport|scrollParent)$/i;
var delayRE = /^d\d+$/i;
var delayShowRE = /^ds\d+$/i;
var delayHideRE = /^dh\d+$/i;
var offsetRE = /^o-?\d+$/i;
var variantRE = /^v-.+$/i;
var spacesRE = /\s+/; // Build a Popover config based on bindings (if any)
// Arguments and modifiers take precedence over passed value config object

var parseBindings = function parseBindings(bindings, vnode)
/* istanbul ignore next: not easy to test */
{
  // We start out with a basic config
  var config = {
    title: undefined,
    content: undefined,
    trigger: '',
    // Default set below if needed
    placement: 'right',
    fallbackPlacement: 'flip',
    container: false,
    // Default of body
    animation: true,
    offset: 0,
    disabled: false,
    id: null,
    html: false,
    delay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["h" /* NAME_POPOVER */], 'delay', 50),
    boundary: String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["h" /* NAME_POPOVER */], 'boundary', 'scrollParent')),
    boundaryPadding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["h" /* NAME_POPOVER */], 'boundaryPadding', 5), 0),
    variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["h" /* NAME_POPOVER */], 'variant'),
    customClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["h" /* NAME_POPOVER */], 'customClass')
  }; // Process `bindings.value`

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["f" /* isString */])(bindings.value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["j" /* isNumber */])(bindings.value)) {
    // Value is popover content (html optionally supported)
    config.content = bindings.value;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["a" /* isFunction */])(bindings.value)) {
    // Content generator function
    config.content = bindings.value;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["h" /* isPlainObject */])(bindings.value)) {
    // Value is config object, so merge
    config = _objectSpread(_objectSpread({}, config), bindings.value);
  } // If argument, assume element ID of container element


  if (bindings.arg) {
    // Element ID specified as arg
    // We must prepend '#' to become a CSS selector
    config.container = "#".concat(bindings.arg);
  } // If title is not provided, try title attribute


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["i" /* isUndefined */])(config.title)) {
    // Try attribute
    var data = vnode.data || {};
    config.title = data.attrs && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["g" /* isUndefinedOrNull */])(data.attrs.title) ? data.attrs.title : undefined;
  } // Normalize delay


  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["h" /* isPlainObject */])(config.delay)) {
    config.delay = {
      show: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(config.delay, 0),
      hide: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(config.delay, 0)
    };
  } // Process modifiers


  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["a" /* keys */])(bindings.modifiers).forEach(function (mod) {
    if (htmlRE.test(mod)) {
      // Title/content allows HTML
      config.html = true;
    } else if (noFadeRE.test(mod)) {
      // No animation
      config.animation = false;
    } else if (placementRE.test(mod)) {
      // Placement of popover
      config.placement = mod;
    } else if (boundaryRE.test(mod)) {
      // Boundary of popover
      mod = mod === 'scrollparent' ? 'scrollParent' : mod;
      config.boundary = mod;
    } else if (delayRE.test(mod)) {
      // Delay value
      var delay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(mod.slice(1), 0);
      config.delay.show = delay;
      config.delay.hide = delay;
    } else if (delayShowRE.test(mod)) {
      // Delay show value
      config.delay.show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(mod.slice(2), 0);
    } else if (delayHideRE.test(mod)) {
      // Delay hide value
      config.delay.hide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(mod.slice(2), 0);
    } else if (offsetRE.test(mod)) {
      // Offset value, negative allowed
      config.offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(mod.slice(1), 0);
    } else if (variantRE.test(mod)) {
      // Variant
      config.variant = mod.slice(2) || null;
    }
  }); // Special handling of event trigger modifiers trigger is
  // a space separated list

  var selectedTriggers = {}; // Parse current config object trigger

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(config.trigger || '').filter(__WEBPACK_IMPORTED_MODULE_6__utils_identity__["a" /* identity */]).join(' ').trim().toLowerCase().split(spacesRE).forEach(function (trigger) {
    if (validTriggers[trigger]) {
      selectedTriggers[trigger] = true;
    }
  }); // Parse modifiers for triggers

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["a" /* keys */])(bindings.modifiers).forEach(function (mod) {
    mod = mod.toLowerCase();

    if (validTriggers[mod]) {
      // If modifier is a valid trigger
      selectedTriggers[mod] = true;
    }
  }); // Sanitize triggers

  config.trigger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["a" /* keys */])(selectedTriggers).join(' ');

  if (config.trigger === 'blur') {
    // Blur by itself is useless, so convert it to 'focus'
    config.trigger = 'focus';
  }

  if (!config.trigger) {
    // Use default trigger
    config.trigger = DefaultTrigger;
  }

  return config;
}; // Add or update Popover on our element


var applyPopover = function applyPopover(el, bindings, vnode) {
  if (!__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */]) {
    /* istanbul ignore next */
    return;
  }

  var config = parseBindings(bindings, vnode);

  if (!el[BV_POPOVER]) {
    var parent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, bindings);
    el[BV_POPOVER] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_create_new_child_component__["a" /* createNewChildComponent */])(parent, __WEBPACK_IMPORTED_MODULE_13__components_popover_helpers_bv_popover__["a" /* BVPopover */], {
      // Add the parent's scoped style attribute data
      _scopeId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get_scope_id__["a" /* getScopeId */])(parent, undefined)
    });
    el[BV_POPOVER].__bv_prev_data__ = {};
    el[BV_POPOVER].$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["a" /* EVENT_NAME_SHOW */], function ()
    /* istanbul ignore next: for now */
    {
      // Before showing the popover, we update the title
      // and content if they are functions
      var data = {};

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["a" /* isFunction */])(config.title)) {
        data.title = config.title(el);
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["a" /* isFunction */])(config.content)) {
        data.content = config.content(el);
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["a" /* keys */])(data).length > 0) {
        el[BV_POPOVER].updateData(data);
      }
    });
  }

  var data = {
    title: config.title,
    content: config.content,
    triggers: config.trigger,
    placement: config.placement,
    fallbackPlacement: config.fallbackPlacement,
    variant: config.variant,
    customClass: config.customClass,
    container: config.container,
    boundary: config.boundary,
    delay: config.delay,
    offset: config.offset,
    noFade: !config.animation,
    id: config.id,
    disabled: config.disabled,
    html: config.html
  };
  var oldData = el[BV_POPOVER].__bv_prev_data__;
  el[BV_POPOVER].__bv_prev_data__ = data;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_loose_equal__["a" /* looseEqual */])(data, oldData)) {
    // We only update the instance if data has changed
    var newData = {
      target: el
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_object__["a" /* keys */])(data).forEach(function (prop) {
      // We only pass data properties that have changed
      if (data[prop] !== oldData[prop]) {
        // If title/content is a function, we execute it here
        newData[prop] = (prop === 'title' || prop === 'content') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["a" /* isFunction */])(data[prop]) ?
        /* istanbul ignore next */
        data[prop](el) : data[prop];
      }
    });
    el[BV_POPOVER].updateData(newData);
  }
}; // Remove Popover from our element


var removePopover = function removePopover(el) {
  if (el[BV_POPOVER]) {
    el[BV_POPOVER].$destroy();
    el[BV_POPOVER] = null;
  }

  delete el[BV_POPOVER];
}; // Export our directive


var VBPopover = {
  bind: function bind(el, bindings, vnode) {
    applyPopover(el, bindings, vnode);
  },
  // We use `componentUpdated` here instead of `update`, as the former
  // waits until the containing component and children have finished updating
  componentUpdated: function componentUpdated(el, bindings, vnode) {
    // Performed in a `$nextTick()` to prevent endless render/update loops
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__vue__["a" /* nextTick */])(function () {
      applyPopover(el, bindings, vnode);
    });
  },
  unbind: function unbind(el) {
    removePopover(el);
  }
};

/***/ }),
/* 452 */
/* exports provided: VBScrollspyPlugin, VBScrollspy */
/* exports used: VBScrollspyPlugin */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/scrollspy/index.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBScrollspyPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scrollspy__ = __webpack_require__(/*! ./scrollspy */ 453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport VBScrollspy */


var VBScrollspyPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  directives: {
    VBScrollspy: __WEBPACK_IMPORTED_MODULE_0__scrollspy__["a" /* VBScrollspy */]
  }
});


/***/ }),
/* 453 */
/* exports provided: VBScrollspy */
/* exports used: VBScrollspy */
/*!***************************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/scrollspy/scrollspy.js ***!
  \***************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBScrollspy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_math__ = __webpack_require__(/*! ../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_get_event_root__ = __webpack_require__(/*! ../../utils/get-event-root */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__ = __webpack_require__(/*! ../../utils/get-instance-from-directive */ 139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_bv_scrollspy_class__ = __webpack_require__(/*! ./helpers/bv-scrollspy.class */ 947);







 // Key we use to store our instance

var BV_SCROLLSPY = '__BV_Scrollspy__'; // Pre-compiled regular expressions

var onlyDigitsRE = /^\d+$/;
var offsetRE = /^(auto|position|offset)$/; // Build a Scrollspy config based on bindings (if any)
// Arguments and modifiers take precedence over passed value config object

/* istanbul ignore next: not easy to test */

var parseBindings = function parseBindings(bindings)
/* istanbul ignore next: not easy to test */
{
  var config = {}; // If argument, assume element ID

  if (bindings.arg) {
    // Element ID specified as arg
    // We must prepend '#' to become a CSS selector
    config.element = "#".concat(bindings.arg);
  } // Process modifiers


  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["a" /* keys */])(bindings.modifiers).forEach(function (mod) {
    if (onlyDigitsRE.test(mod)) {
      // Offset value
      config.offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_number__["b" /* toInteger */])(mod, 0);
    } else if (offsetRE.test(mod)) {
      // Offset method
      config.method = mod;
    }
  }); // Process value

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["f" /* isString */])(bindings.value)) {
    // Value is a CSS ID or selector
    config.element = bindings.value;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["j" /* isNumber */])(bindings.value)) {
    // Value is offset
    config.offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_math__["b" /* mathRound */])(bindings.value);
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["d" /* isObject */])(bindings.value)) {
    // Value is config object
    // Filter the object based on our supported config options
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["a" /* keys */])(bindings.value).filter(function (k) {
      return !!__WEBPACK_IMPORTED_MODULE_7__helpers_bv_scrollspy_class__["a" /* BVScrollspy */].DefaultType[k];
    }).forEach(function (k) {
      config[k] = bindings.value[k];
    });
  }

  return config;
}; // Add or update Scrollspy on our element


var applyScrollspy = function applyScrollspy(el, bindings, vnode)
/* istanbul ignore next: not easy to test */
{
  if (!__WEBPACK_IMPORTED_MODULE_0__constants_env__["e" /* IS_BROWSER */]) {
    /* istanbul ignore next */
    return;
  }

  var config = parseBindings(bindings);

  if (el[BV_SCROLLSPY]) {
    el[BV_SCROLLSPY].updateConfig(config, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get_event_root__["a" /* getEventRoot */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, bindings)));
  } else {
    el[BV_SCROLLSPY] = new __WEBPACK_IMPORTED_MODULE_7__helpers_bv_scrollspy_class__["a" /* BVScrollspy */](el, config, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get_event_root__["a" /* getEventRoot */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, bindings)));
  }
}; // Remove Scrollspy on our element

/* istanbul ignore next: not easy to test */


var removeScrollspy = function removeScrollspy(el)
/* istanbul ignore next: not easy to test */
{
  if (el[BV_SCROLLSPY]) {
    el[BV_SCROLLSPY].dispose();
    el[BV_SCROLLSPY] = null;
    delete el[BV_SCROLLSPY];
  }
};
/*
 * Export our directive
 */


var VBScrollspy = {
  /* istanbul ignore next: not easy to test */
  bind: function bind(el, bindings, vnode) {
    applyScrollspy(el, bindings, vnode);
  },

  /* istanbul ignore next: not easy to test */
  inserted: function inserted(el, bindings, vnode) {
    applyScrollspy(el, bindings, vnode);
  },

  /* istanbul ignore next: not easy to test */
  update: function update(el, bindings, vnode) {
    if (bindings.value !== bindings.oldValue) {
      applyScrollspy(el, bindings, vnode);
    }
  },

  /* istanbul ignore next: not easy to test */
  componentUpdated: function componentUpdated(el, bindings, vnode) {
    if (bindings.value !== bindings.oldValue) {
      applyScrollspy(el, bindings, vnode);
    }
  },

  /* istanbul ignore next: not easy to test */
  unbind: function unbind(el) {
    removeScrollspy(el);
  }
};

/***/ }),
/* 454 */
/* exports provided: VBTooltip */
/* exports used: VBTooltip */
/*!***********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/tooltip/tooltip.js ***!
  \***********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_config__ = __webpack_require__(/*! ../../utils/config */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_get_scope_id__ = __webpack_require__(/*! ../../utils/get-scope-id */ 140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_get_instance_from_directive__ = __webpack_require__(/*! ../../utils/get-instance-from-directive */ 139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_loose_equal__ = __webpack_require__(/*! ../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_number__ = __webpack_require__(/*! ../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_create_new_child_component__ = __webpack_require__(/*! ../../utils/create-new-child-component */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_tooltip_helpers_bv_tooltip__ = __webpack_require__(/*! ../../components/tooltip/helpers/bv-tooltip */ 242);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }















 // Key which we use to store tooltip object on element

var BV_TOOLTIP = '__BV_Tooltip__'; // Default trigger

var DefaultTrigger = 'hover focus'; // Valid event triggers

var validTriggers = {
  focus: true,
  hover: true,
  click: true,
  blur: true,
  manual: true
}; // Directive modifier test regular expressions. Pre-compile for performance

var htmlRE = /^html$/i;
var noninteractiveRE = /^noninteractive$/i;
var noFadeRE = /^nofade$/i;
var placementRE = /^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/i;
var boundaryRE = /^(window|viewport|scrollParent)$/i;
var delayRE = /^d\d+$/i;
var delayShowRE = /^ds\d+$/i;
var delayHideRE = /^dh\d+$/i;
var offsetRE = /^o-?\d+$/i;
var variantRE = /^v-.+$/i;
var spacesRE = /\s+/; // Build a Tooltip config based on bindings (if any)
// Arguments and modifiers take precedence over passed value config object

var parseBindings = function parseBindings(bindings, vnode)
/* istanbul ignore next: not easy to test */
{
  // We start out with a basic config
  var config = {
    title: undefined,
    trigger: '',
    // Default set below if needed
    placement: 'top',
    fallbackPlacement: 'flip',
    container: false,
    // Default of body
    animation: true,
    offset: 0,
    id: null,
    html: false,
    interactive: true,
    disabled: false,
    delay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["a" /* NAME_TOOLTIP */], 'delay', 50),
    boundary: String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["a" /* NAME_TOOLTIP */], 'boundary', 'scrollParent')),
    boundaryPadding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["a" /* NAME_TOOLTIP */], 'boundaryPadding', 5), 0),
    variant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["a" /* NAME_TOOLTIP */], 'variant'),
    customClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_config__["a" /* getComponentConfig */])(__WEBPACK_IMPORTED_MODULE_0__constants_components__["a" /* NAME_TOOLTIP */], 'customClass')
  }; // Process `bindings.value`

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["f" /* isString */])(bindings.value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["j" /* isNumber */])(bindings.value)) {
    // Value is tooltip content (HTML optionally supported)
    config.title = bindings.value;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["a" /* isFunction */])(bindings.value)) {
    // Title generator function
    config.title = bindings.value;
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["h" /* isPlainObject */])(bindings.value)) {
    // Value is config object, so merge
    config = _objectSpread(_objectSpread({}, config), bindings.value);
  } // If title is not provided, try title attribute


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["i" /* isUndefined */])(config.title)) {
    // Try attribute
    var attrs = __WEBPACK_IMPORTED_MODULE_4__vue__["c" /* isVue3 */] ? vnode.props : (vnode.data || {}).attrs;
    config.title = attrs && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["g" /* isUndefinedOrNull */])(attrs.title) ? attrs.title : undefined;
  } // Normalize delay


  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["h" /* isPlainObject */])(config.delay)) {
    config.delay = {
      show: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(config.delay, 0),
      hide: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(config.delay, 0)
    };
  } // If argument, assume element ID of container element


  if (bindings.arg) {
    // Element ID specified as arg
    // We must prepend '#' to become a CSS selector
    config.container = "#".concat(bindings.arg);
  } // Process modifiers


  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["a" /* keys */])(bindings.modifiers).forEach(function (mod) {
    if (htmlRE.test(mod)) {
      // Title allows HTML
      config.html = true;
    } else if (noninteractiveRE.test(mod)) {
      // Noninteractive
      config.interactive = false;
    } else if (noFadeRE.test(mod)) {
      // No animation
      config.animation = false;
    } else if (placementRE.test(mod)) {
      // Placement of tooltip
      config.placement = mod;
    } else if (boundaryRE.test(mod)) {
      // Boundary of tooltip
      mod = mod === 'scrollparent' ? 'scrollParent' : mod;
      config.boundary = mod;
    } else if (delayRE.test(mod)) {
      // Delay value
      var delay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(mod.slice(1), 0);
      config.delay.show = delay;
      config.delay.hide = delay;
    } else if (delayShowRE.test(mod)) {
      // Delay show value
      config.delay.show = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(mod.slice(2), 0);
    } else if (delayHideRE.test(mod)) {
      // Delay hide value
      config.delay.hide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(mod.slice(2), 0);
    } else if (offsetRE.test(mod)) {
      // Offset value, negative allowed
      config.offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(mod.slice(1), 0);
    } else if (variantRE.test(mod)) {
      // Variant
      config.variant = mod.slice(2) || null;
    }
  }); // Special handling of event trigger modifiers trigger is
  // a space separated list

  var selectedTriggers = {}; // Parse current config object trigger

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["b" /* concat */])(config.trigger || '').filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]).join(' ').trim().toLowerCase().split(spacesRE).forEach(function (trigger) {
    if (validTriggers[trigger]) {
      selectedTriggers[trigger] = true;
    }
  }); // Parse modifiers for triggers

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["a" /* keys */])(bindings.modifiers).forEach(function (mod) {
    mod = mod.toLowerCase();

    if (validTriggers[mod]) {
      // If modifier is a valid trigger
      selectedTriggers[mod] = true;
    }
  }); // Sanitize triggers

  config.trigger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["a" /* keys */])(selectedTriggers).join(' ');

  if (config.trigger === 'blur') {
    // Blur by itself is useless, so convert it to 'focus'
    config.trigger = 'focus';
  }

  if (!config.trigger) {
    // Use default trigger
    config.trigger = DefaultTrigger;
  } // Return the config


  return config;
}; // Add/update Tooltip on our element


var applyTooltip = function applyTooltip(el, bindings, vnode) {
  if (!__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */]) {
    /* istanbul ignore next */
    return;
  }

  var config = parseBindings(bindings, vnode);

  if (!el[BV_TOOLTIP]) {
    var parent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_get_instance_from_directive__["a" /* getInstanceFromDirective */])(vnode, bindings);
    el[BV_TOOLTIP] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_create_new_child_component__["a" /* createNewChildComponent */])(parent, __WEBPACK_IMPORTED_MODULE_14__components_tooltip_helpers_bv_tooltip__["a" /* BVTooltip */], {
      // Add the parent's scoped style attribute data
      _scopeId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_get_scope_id__["a" /* getScopeId */])(parent, undefined)
    });
    el[BV_TOOLTIP].__bv_prev_data__ = {};
    el[BV_TOOLTIP].$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["a" /* EVENT_NAME_SHOW */], function ()
    /* istanbul ignore next: for now */
    {
      // Before showing the tooltip, we update the title if it is a function
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["a" /* isFunction */])(config.title)) {
        el[BV_TOOLTIP].updateData({
          title: config.title(el)
        });
      }
    });
  }

  var data = {
    title: config.title,
    triggers: config.trigger,
    placement: config.placement,
    fallbackPlacement: config.fallbackPlacement,
    variant: config.variant,
    customClass: config.customClass,
    container: config.container,
    boundary: config.boundary,
    delay: config.delay,
    offset: config.offset,
    noFade: !config.animation,
    id: config.id,
    interactive: config.interactive,
    disabled: config.disabled,
    html: config.html
  };
  var oldData = el[BV_TOOLTIP].__bv_prev_data__;
  el[BV_TOOLTIP].__bv_prev_data__ = data;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_loose_equal__["a" /* looseEqual */])(data, oldData)) {
    // We only update the instance if data has changed
    var newData = {
      target: el
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["a" /* keys */])(data).forEach(function (prop) {
      // We only pass data properties that have changed
      if (data[prop] !== oldData[prop]) {
        // if title is a function, we execute it here
        newData[prop] = prop === 'title' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_inspect__["a" /* isFunction */])(data[prop]) ? data[prop](el) : data[prop];
      }
    });
    el[BV_TOOLTIP].updateData(newData);
  }
}; // Remove Tooltip on our element


var removeTooltip = function removeTooltip(el) {
  if (el[BV_TOOLTIP]) {
    el[BV_TOOLTIP].$destroy();
    el[BV_TOOLTIP] = null;
  }

  delete el[BV_TOOLTIP];
}; // Export our directive


var VBTooltip = {
  bind: function bind(el, bindings, vnode) {
    applyTooltip(el, bindings, vnode);
  },
  // We use `componentUpdated` here instead of `update`, as the former
  // waits until the containing component and children have finished updating
  componentUpdated: function componentUpdated(el, bindings, vnode) {
    // Performed in a `$nextTick()` to prevent render update loops
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vue__["a" /* nextTick */])(function () {
      applyTooltip(el, bindings, vnode);
    });
  },
  unbind: function unbind(el) {
    removeTooltip(el);
  }
};

/***/ }),
/* 455 */
/* exports provided: VBVisiblePlugin, VBVisible */
/* exports used: VBVisiblePlugin */
/*!*********************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/visible/index.js ***!
  \*********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VBVisiblePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visible__ = __webpack_require__(/*! ./visible */ 180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(/*! ../../utils/plugins */ 10);
/* unused harmony reexport VBVisible */


var VBVisiblePlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* pluginFactory */])({
  directives: {
    VBVisible: __WEBPACK_IMPORTED_MODULE_0__visible__["a" /* VBVisible */]
  }
});


/***/ }),
/* 456 */
/* exports provided: iconNames, IconsPlugin, BootstrapVueIcons */
/* exports used: IconsPlugin, BootstrapVueIcons */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/icons/plugin.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iconNames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BootstrapVueIcons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(/*! ../utils/plugins */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon__ = __webpack_require__(/*! ./icon */ 138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iconstack__ = __webpack_require__(/*! ./iconstack */ 250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons__ = __webpack_require__(/*! ./icons */ 61);
// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.5.0
// @Generated: 2022-10-26T01:10:52.933Z
//
// This file is generated on each build. Do not edit this file!
 // Icon helper component

 // Icon stacking component


 // Icon component names for used in the docs

var iconNames = [// BootstrapVue custom icon component names
'BIconBlank', // Bootstrap icon component names
'BIconAlarm', 'BIconAlarmFill', 'BIconAlignBottom', 'BIconAlignCenter', 'BIconAlignEnd', 'BIconAlignMiddle', 'BIconAlignStart', 'BIconAlignTop', 'BIconAlt', 'BIconApp', 'BIconAppIndicator', 'BIconArchive', 'BIconArchiveFill', 'BIconArrow90degDown', 'BIconArrow90degLeft', 'BIconArrow90degRight', 'BIconArrow90degUp', 'BIconArrowBarDown', 'BIconArrowBarLeft', 'BIconArrowBarRight', 'BIconArrowBarUp', 'BIconArrowClockwise', 'BIconArrowCounterclockwise', 'BIconArrowDown', 'BIconArrowDownCircle', 'BIconArrowDownCircleFill', 'BIconArrowDownLeft', 'BIconArrowDownLeftCircle', 'BIconArrowDownLeftCircleFill', 'BIconArrowDownLeftSquare', 'BIconArrowDownLeftSquareFill', 'BIconArrowDownRight', 'BIconArrowDownRightCircle', 'BIconArrowDownRightCircleFill', 'BIconArrowDownRightSquare', 'BIconArrowDownRightSquareFill', 'BIconArrowDownShort', 'BIconArrowDownSquare', 'BIconArrowDownSquareFill', 'BIconArrowDownUp', 'BIconArrowLeft', 'BIconArrowLeftCircle', 'BIconArrowLeftCircleFill', 'BIconArrowLeftRight', 'BIconArrowLeftShort', 'BIconArrowLeftSquare', 'BIconArrowLeftSquareFill', 'BIconArrowRepeat', 'BIconArrowReturnLeft', 'BIconArrowReturnRight', 'BIconArrowRight', 'BIconArrowRightCircle', 'BIconArrowRightCircleFill', 'BIconArrowRightShort', 'BIconArrowRightSquare', 'BIconArrowRightSquareFill', 'BIconArrowUp', 'BIconArrowUpCircle', 'BIconArrowUpCircleFill', 'BIconArrowUpLeft', 'BIconArrowUpLeftCircle', 'BIconArrowUpLeftCircleFill', 'BIconArrowUpLeftSquare', 'BIconArrowUpLeftSquareFill', 'BIconArrowUpRight', 'BIconArrowUpRightCircle', 'BIconArrowUpRightCircleFill', 'BIconArrowUpRightSquare', 'BIconArrowUpRightSquareFill', 'BIconArrowUpShort', 'BIconArrowUpSquare', 'BIconArrowUpSquareFill', 'BIconArrowsAngleContract', 'BIconArrowsAngleExpand', 'BIconArrowsCollapse', 'BIconArrowsExpand', 'BIconArrowsFullscreen', 'BIconArrowsMove', 'BIconAspectRatio', 'BIconAspectRatioFill', 'BIconAsterisk', 'BIconAt', 'BIconAward', 'BIconAwardFill', 'BIconBack', 'BIconBackspace', 'BIconBackspaceFill', 'BIconBackspaceReverse', 'BIconBackspaceReverseFill', 'BIconBadge3d', 'BIconBadge3dFill', 'BIconBadge4k', 'BIconBadge4kFill', 'BIconBadge8k', 'BIconBadge8kFill', 'BIconBadgeAd', 'BIconBadgeAdFill', 'BIconBadgeAr', 'BIconBadgeArFill', 'BIconBadgeCc', 'BIconBadgeCcFill', 'BIconBadgeHd', 'BIconBadgeHdFill', 'BIconBadgeTm', 'BIconBadgeTmFill', 'BIconBadgeVo', 'BIconBadgeVoFill', 'BIconBadgeVr', 'BIconBadgeVrFill', 'BIconBadgeWc', 'BIconBadgeWcFill', 'BIconBag', 'BIconBagCheck', 'BIconBagCheckFill', 'BIconBagDash', 'BIconBagDashFill', 'BIconBagFill', 'BIconBagPlus', 'BIconBagPlusFill', 'BIconBagX', 'BIconBagXFill', 'BIconBank', 'BIconBank2', 'BIconBarChart', 'BIconBarChartFill', 'BIconBarChartLine', 'BIconBarChartLineFill', 'BIconBarChartSteps', 'BIconBasket', 'BIconBasket2', 'BIconBasket2Fill', 'BIconBasket3', 'BIconBasket3Fill', 'BIconBasketFill', 'BIconBattery', 'BIconBatteryCharging', 'BIconBatteryFull', 'BIconBatteryHalf', 'BIconBell', 'BIconBellFill', 'BIconBellSlash', 'BIconBellSlashFill', 'BIconBezier', 'BIconBezier2', 'BIconBicycle', 'BIconBinoculars', 'BIconBinocularsFill', 'BIconBlockquoteLeft', 'BIconBlockquoteRight', 'BIconBook', 'BIconBookFill', 'BIconBookHalf', 'BIconBookmark', 'BIconBookmarkCheck', 'BIconBookmarkCheckFill', 'BIconBookmarkDash', 'BIconBookmarkDashFill', 'BIconBookmarkFill', 'BIconBookmarkHeart', 'BIconBookmarkHeartFill', 'BIconBookmarkPlus', 'BIconBookmarkPlusFill', 'BIconBookmarkStar', 'BIconBookmarkStarFill', 'BIconBookmarkX', 'BIconBookmarkXFill', 'BIconBookmarks', 'BIconBookmarksFill', 'BIconBookshelf', 'BIconBootstrap', 'BIconBootstrapFill', 'BIconBootstrapReboot', 'BIconBorder', 'BIconBorderAll', 'BIconBorderBottom', 'BIconBorderCenter', 'BIconBorderInner', 'BIconBorderLeft', 'BIconBorderMiddle', 'BIconBorderOuter', 'BIconBorderRight', 'BIconBorderStyle', 'BIconBorderTop', 'BIconBorderWidth', 'BIconBoundingBox', 'BIconBoundingBoxCircles', 'BIconBox', 'BIconBoxArrowDown', 'BIconBoxArrowDownLeft', 'BIconBoxArrowDownRight', 'BIconBoxArrowInDown', 'BIconBoxArrowInDownLeft', 'BIconBoxArrowInDownRight', 'BIconBoxArrowInLeft', 'BIconBoxArrowInRight', 'BIconBoxArrowInUp', 'BIconBoxArrowInUpLeft', 'BIconBoxArrowInUpRight', 'BIconBoxArrowLeft', 'BIconBoxArrowRight', 'BIconBoxArrowUp', 'BIconBoxArrowUpLeft', 'BIconBoxArrowUpRight', 'BIconBoxSeam', 'BIconBraces', 'BIconBricks', 'BIconBriefcase', 'BIconBriefcaseFill', 'BIconBrightnessAltHigh', 'BIconBrightnessAltHighFill', 'BIconBrightnessAltLow', 'BIconBrightnessAltLowFill', 'BIconBrightnessHigh', 'BIconBrightnessHighFill', 'BIconBrightnessLow', 'BIconBrightnessLowFill', 'BIconBroadcast', 'BIconBroadcastPin', 'BIconBrush', 'BIconBrushFill', 'BIconBucket', 'BIconBucketFill', 'BIconBug', 'BIconBugFill', 'BIconBuilding', 'BIconBullseye', 'BIconCalculator', 'BIconCalculatorFill', 'BIconCalendar', 'BIconCalendar2', 'BIconCalendar2Check', 'BIconCalendar2CheckFill', 'BIconCalendar2Date', 'BIconCalendar2DateFill', 'BIconCalendar2Day', 'BIconCalendar2DayFill', 'BIconCalendar2Event', 'BIconCalendar2EventFill', 'BIconCalendar2Fill', 'BIconCalendar2Minus', 'BIconCalendar2MinusFill', 'BIconCalendar2Month', 'BIconCalendar2MonthFill', 'BIconCalendar2Plus', 'BIconCalendar2PlusFill', 'BIconCalendar2Range', 'BIconCalendar2RangeFill', 'BIconCalendar2Week', 'BIconCalendar2WeekFill', 'BIconCalendar2X', 'BIconCalendar2XFill', 'BIconCalendar3', 'BIconCalendar3Event', 'BIconCalendar3EventFill', 'BIconCalendar3Fill', 'BIconCalendar3Range', 'BIconCalendar3RangeFill', 'BIconCalendar3Week', 'BIconCalendar3WeekFill', 'BIconCalendar4', 'BIconCalendar4Event', 'BIconCalendar4Range', 'BIconCalendar4Week', 'BIconCalendarCheck', 'BIconCalendarCheckFill', 'BIconCalendarDate', 'BIconCalendarDateFill', 'BIconCalendarDay', 'BIconCalendarDayFill', 'BIconCalendarEvent', 'BIconCalendarEventFill', 'BIconCalendarFill', 'BIconCalendarMinus', 'BIconCalendarMinusFill', 'BIconCalendarMonth', 'BIconCalendarMonthFill', 'BIconCalendarPlus', 'BIconCalendarPlusFill', 'BIconCalendarRange', 'BIconCalendarRangeFill', 'BIconCalendarWeek', 'BIconCalendarWeekFill', 'BIconCalendarX', 'BIconCalendarXFill', 'BIconCamera', 'BIconCamera2', 'BIconCameraFill', 'BIconCameraReels', 'BIconCameraReelsFill', 'BIconCameraVideo', 'BIconCameraVideoFill', 'BIconCameraVideoOff', 'BIconCameraVideoOffFill', 'BIconCapslock', 'BIconCapslockFill', 'BIconCardChecklist', 'BIconCardHeading', 'BIconCardImage', 'BIconCardList', 'BIconCardText', 'BIconCaretDown', 'BIconCaretDownFill', 'BIconCaretDownSquare', 'BIconCaretDownSquareFill', 'BIconCaretLeft', 'BIconCaretLeftFill', 'BIconCaretLeftSquare', 'BIconCaretLeftSquareFill', 'BIconCaretRight', 'BIconCaretRightFill', 'BIconCaretRightSquare', 'BIconCaretRightSquareFill', 'BIconCaretUp', 'BIconCaretUpFill', 'BIconCaretUpSquare', 'BIconCaretUpSquareFill', 'BIconCart', 'BIconCart2', 'BIconCart3', 'BIconCart4', 'BIconCartCheck', 'BIconCartCheckFill', 'BIconCartDash', 'BIconCartDashFill', 'BIconCartFill', 'BIconCartPlus', 'BIconCartPlusFill', 'BIconCartX', 'BIconCartXFill', 'BIconCash', 'BIconCashCoin', 'BIconCashStack', 'BIconCast', 'BIconChat', 'BIconChatDots', 'BIconChatDotsFill', 'BIconChatFill', 'BIconChatLeft', 'BIconChatLeftDots', 'BIconChatLeftDotsFill', 'BIconChatLeftFill', 'BIconChatLeftQuote', 'BIconChatLeftQuoteFill', 'BIconChatLeftText', 'BIconChatLeftTextFill', 'BIconChatQuote', 'BIconChatQuoteFill', 'BIconChatRight', 'BIconChatRightDots', 'BIconChatRightDotsFill', 'BIconChatRightFill', 'BIconChatRightQuote', 'BIconChatRightQuoteFill', 'BIconChatRightText', 'BIconChatRightTextFill', 'BIconChatSquare', 'BIconChatSquareDots', 'BIconChatSquareDotsFill', 'BIconChatSquareFill', 'BIconChatSquareQuote', 'BIconChatSquareQuoteFill', 'BIconChatSquareText', 'BIconChatSquareTextFill', 'BIconChatText', 'BIconChatTextFill', 'BIconCheck', 'BIconCheck2', 'BIconCheck2All', 'BIconCheck2Circle', 'BIconCheck2Square', 'BIconCheckAll', 'BIconCheckCircle', 'BIconCheckCircleFill', 'BIconCheckLg', 'BIconCheckSquare', 'BIconCheckSquareFill', 'BIconChevronBarContract', 'BIconChevronBarDown', 'BIconChevronBarExpand', 'BIconChevronBarLeft', 'BIconChevronBarRight', 'BIconChevronBarUp', 'BIconChevronCompactDown', 'BIconChevronCompactLeft', 'BIconChevronCompactRight', 'BIconChevronCompactUp', 'BIconChevronContract', 'BIconChevronDoubleDown', 'BIconChevronDoubleLeft', 'BIconChevronDoubleRight', 'BIconChevronDoubleUp', 'BIconChevronDown', 'BIconChevronExpand', 'BIconChevronLeft', 'BIconChevronRight', 'BIconChevronUp', 'BIconCircle', 'BIconCircleFill', 'BIconCircleHalf', 'BIconCircleSquare', 'BIconClipboard', 'BIconClipboardCheck', 'BIconClipboardData', 'BIconClipboardMinus', 'BIconClipboardPlus', 'BIconClipboardX', 'BIconClock', 'BIconClockFill', 'BIconClockHistory', 'BIconCloud', 'BIconCloudArrowDown', 'BIconCloudArrowDownFill', 'BIconCloudArrowUp', 'BIconCloudArrowUpFill', 'BIconCloudCheck', 'BIconCloudCheckFill', 'BIconCloudDownload', 'BIconCloudDownloadFill', 'BIconCloudDrizzle', 'BIconCloudDrizzleFill', 'BIconCloudFill', 'BIconCloudFog', 'BIconCloudFog2', 'BIconCloudFog2Fill', 'BIconCloudFogFill', 'BIconCloudHail', 'BIconCloudHailFill', 'BIconCloudHaze', 'BIconCloudHaze1', 'BIconCloudHaze2Fill', 'BIconCloudHazeFill', 'BIconCloudLightning', 'BIconCloudLightningFill', 'BIconCloudLightningRain', 'BIconCloudLightningRainFill', 'BIconCloudMinus', 'BIconCloudMinusFill', 'BIconCloudMoon', 'BIconCloudMoonFill', 'BIconCloudPlus', 'BIconCloudPlusFill', 'BIconCloudRain', 'BIconCloudRainFill', 'BIconCloudRainHeavy', 'BIconCloudRainHeavyFill', 'BIconCloudSlash', 'BIconCloudSlashFill', 'BIconCloudSleet', 'BIconCloudSleetFill', 'BIconCloudSnow', 'BIconCloudSnowFill', 'BIconCloudSun', 'BIconCloudSunFill', 'BIconCloudUpload', 'BIconCloudUploadFill', 'BIconClouds', 'BIconCloudsFill', 'BIconCloudy', 'BIconCloudyFill', 'BIconCode', 'BIconCodeSlash', 'BIconCodeSquare', 'BIconCoin', 'BIconCollection', 'BIconCollectionFill', 'BIconCollectionPlay', 'BIconCollectionPlayFill', 'BIconColumns', 'BIconColumnsGap', 'BIconCommand', 'BIconCompass', 'BIconCompassFill', 'BIconCone', 'BIconConeStriped', 'BIconController', 'BIconCpu', 'BIconCpuFill', 'BIconCreditCard', 'BIconCreditCard2Back', 'BIconCreditCard2BackFill', 'BIconCreditCard2Front', 'BIconCreditCard2FrontFill', 'BIconCreditCardFill', 'BIconCrop', 'BIconCup', 'BIconCupFill', 'BIconCupStraw', 'BIconCurrencyBitcoin', 'BIconCurrencyDollar', 'BIconCurrencyEuro', 'BIconCurrencyExchange', 'BIconCurrencyPound', 'BIconCurrencyYen', 'BIconCursor', 'BIconCursorFill', 'BIconCursorText', 'BIconDash', 'BIconDashCircle', 'BIconDashCircleDotted', 'BIconDashCircleFill', 'BIconDashLg', 'BIconDashSquare', 'BIconDashSquareDotted', 'BIconDashSquareFill', 'BIconDiagram2', 'BIconDiagram2Fill', 'BIconDiagram3', 'BIconDiagram3Fill', 'BIconDiamond', 'BIconDiamondFill', 'BIconDiamondHalf', 'BIconDice1', 'BIconDice1Fill', 'BIconDice2', 'BIconDice2Fill', 'BIconDice3', 'BIconDice3Fill', 'BIconDice4', 'BIconDice4Fill', 'BIconDice5', 'BIconDice5Fill', 'BIconDice6', 'BIconDice6Fill', 'BIconDisc', 'BIconDiscFill', 'BIconDiscord', 'BIconDisplay', 'BIconDisplayFill', 'BIconDistributeHorizontal', 'BIconDistributeVertical', 'BIconDoorClosed', 'BIconDoorClosedFill', 'BIconDoorOpen', 'BIconDoorOpenFill', 'BIconDot', 'BIconDownload', 'BIconDroplet', 'BIconDropletFill', 'BIconDropletHalf', 'BIconEarbuds', 'BIconEasel', 'BIconEaselFill', 'BIconEgg', 'BIconEggFill', 'BIconEggFried', 'BIconEject', 'BIconEjectFill', 'BIconEmojiAngry', 'BIconEmojiAngryFill', 'BIconEmojiDizzy', 'BIconEmojiDizzyFill', 'BIconEmojiExpressionless', 'BIconEmojiExpressionlessFill', 'BIconEmojiFrown', 'BIconEmojiFrownFill', 'BIconEmojiHeartEyes', 'BIconEmojiHeartEyesFill', 'BIconEmojiLaughing', 'BIconEmojiLaughingFill', 'BIconEmojiNeutral', 'BIconEmojiNeutralFill', 'BIconEmojiSmile', 'BIconEmojiSmileFill', 'BIconEmojiSmileUpsideDown', 'BIconEmojiSmileUpsideDownFill', 'BIconEmojiSunglasses', 'BIconEmojiSunglassesFill', 'BIconEmojiWink', 'BIconEmojiWinkFill', 'BIconEnvelope', 'BIconEnvelopeFill', 'BIconEnvelopeOpen', 'BIconEnvelopeOpenFill', 'BIconEraser', 'BIconEraserFill', 'BIconExclamation', 'BIconExclamationCircle', 'BIconExclamationCircleFill', 'BIconExclamationDiamond', 'BIconExclamationDiamondFill', 'BIconExclamationLg', 'BIconExclamationOctagon', 'BIconExclamationOctagonFill', 'BIconExclamationSquare', 'BIconExclamationSquareFill', 'BIconExclamationTriangle', 'BIconExclamationTriangleFill', 'BIconExclude', 'BIconEye', 'BIconEyeFill', 'BIconEyeSlash', 'BIconEyeSlashFill', 'BIconEyedropper', 'BIconEyeglasses', 'BIconFacebook', 'BIconFile', 'BIconFileArrowDown', 'BIconFileArrowDownFill', 'BIconFileArrowUp', 'BIconFileArrowUpFill', 'BIconFileBarGraph', 'BIconFileBarGraphFill', 'BIconFileBinary', 'BIconFileBinaryFill', 'BIconFileBreak', 'BIconFileBreakFill', 'BIconFileCheck', 'BIconFileCheckFill', 'BIconFileCode', 'BIconFileCodeFill', 'BIconFileDiff', 'BIconFileDiffFill', 'BIconFileEarmark', 'BIconFileEarmarkArrowDown', 'BIconFileEarmarkArrowDownFill', 'BIconFileEarmarkArrowUp', 'BIconFileEarmarkArrowUpFill', 'BIconFileEarmarkBarGraph', 'BIconFileEarmarkBarGraphFill', 'BIconFileEarmarkBinary', 'BIconFileEarmarkBinaryFill', 'BIconFileEarmarkBreak', 'BIconFileEarmarkBreakFill', 'BIconFileEarmarkCheck', 'BIconFileEarmarkCheckFill', 'BIconFileEarmarkCode', 'BIconFileEarmarkCodeFill', 'BIconFileEarmarkDiff', 'BIconFileEarmarkDiffFill', 'BIconFileEarmarkEasel', 'BIconFileEarmarkEaselFill', 'BIconFileEarmarkExcel', 'BIconFileEarmarkExcelFill', 'BIconFileEarmarkFill', 'BIconFileEarmarkFont', 'BIconFileEarmarkFontFill', 'BIconFileEarmarkImage', 'BIconFileEarmarkImageFill', 'BIconFileEarmarkLock', 'BIconFileEarmarkLock2', 'BIconFileEarmarkLock2Fill', 'BIconFileEarmarkLockFill', 'BIconFileEarmarkMedical', 'BIconFileEarmarkMedicalFill', 'BIconFileEarmarkMinus', 'BIconFileEarmarkMinusFill', 'BIconFileEarmarkMusic', 'BIconFileEarmarkMusicFill', 'BIconFileEarmarkPdf', 'BIconFileEarmarkPdfFill', 'BIconFileEarmarkPerson', 'BIconFileEarmarkPersonFill', 'BIconFileEarmarkPlay', 'BIconFileEarmarkPlayFill', 'BIconFileEarmarkPlus', 'BIconFileEarmarkPlusFill', 'BIconFileEarmarkPost', 'BIconFileEarmarkPostFill', 'BIconFileEarmarkPpt', 'BIconFileEarmarkPptFill', 'BIconFileEarmarkRichtext', 'BIconFileEarmarkRichtextFill', 'BIconFileEarmarkRuled', 'BIconFileEarmarkRuledFill', 'BIconFileEarmarkSlides', 'BIconFileEarmarkSlidesFill', 'BIconFileEarmarkSpreadsheet', 'BIconFileEarmarkSpreadsheetFill', 'BIconFileEarmarkText', 'BIconFileEarmarkTextFill', 'BIconFileEarmarkWord', 'BIconFileEarmarkWordFill', 'BIconFileEarmarkX', 'BIconFileEarmarkXFill', 'BIconFileEarmarkZip', 'BIconFileEarmarkZipFill', 'BIconFileEasel', 'BIconFileEaselFill', 'BIconFileExcel', 'BIconFileExcelFill', 'BIconFileFill', 'BIconFileFont', 'BIconFileFontFill', 'BIconFileImage', 'BIconFileImageFill', 'BIconFileLock', 'BIconFileLock2', 'BIconFileLock2Fill', 'BIconFileLockFill', 'BIconFileMedical', 'BIconFileMedicalFill', 'BIconFileMinus', 'BIconFileMinusFill', 'BIconFileMusic', 'BIconFileMusicFill', 'BIconFilePdf', 'BIconFilePdfFill', 'BIconFilePerson', 'BIconFilePersonFill', 'BIconFilePlay', 'BIconFilePlayFill', 'BIconFilePlus', 'BIconFilePlusFill', 'BIconFilePost', 'BIconFilePostFill', 'BIconFilePpt', 'BIconFilePptFill', 'BIconFileRichtext', 'BIconFileRichtextFill', 'BIconFileRuled', 'BIconFileRuledFill', 'BIconFileSlides', 'BIconFileSlidesFill', 'BIconFileSpreadsheet', 'BIconFileSpreadsheetFill', 'BIconFileText', 'BIconFileTextFill', 'BIconFileWord', 'BIconFileWordFill', 'BIconFileX', 'BIconFileXFill', 'BIconFileZip', 'BIconFileZipFill', 'BIconFiles', 'BIconFilesAlt', 'BIconFilm', 'BIconFilter', 'BIconFilterCircle', 'BIconFilterCircleFill', 'BIconFilterLeft', 'BIconFilterRight', 'BIconFilterSquare', 'BIconFilterSquareFill', 'BIconFlag', 'BIconFlagFill', 'BIconFlower1', 'BIconFlower2', 'BIconFlower3', 'BIconFolder', 'BIconFolder2', 'BIconFolder2Open', 'BIconFolderCheck', 'BIconFolderFill', 'BIconFolderMinus', 'BIconFolderPlus', 'BIconFolderSymlink', 'BIconFolderSymlinkFill', 'BIconFolderX', 'BIconFonts', 'BIconForward', 'BIconForwardFill', 'BIconFront', 'BIconFullscreen', 'BIconFullscreenExit', 'BIconFunnel', 'BIconFunnelFill', 'BIconGear', 'BIconGearFill', 'BIconGearWide', 'BIconGearWideConnected', 'BIconGem', 'BIconGenderAmbiguous', 'BIconGenderFemale', 'BIconGenderMale', 'BIconGenderTrans', 'BIconGeo', 'BIconGeoAlt', 'BIconGeoAltFill', 'BIconGeoFill', 'BIconGift', 'BIconGiftFill', 'BIconGithub', 'BIconGlobe', 'BIconGlobe2', 'BIconGoogle', 'BIconGraphDown', 'BIconGraphUp', 'BIconGrid', 'BIconGrid1x2', 'BIconGrid1x2Fill', 'BIconGrid3x2', 'BIconGrid3x2Gap', 'BIconGrid3x2GapFill', 'BIconGrid3x3', 'BIconGrid3x3Gap', 'BIconGrid3x3GapFill', 'BIconGridFill', 'BIconGripHorizontal', 'BIconGripVertical', 'BIconHammer', 'BIconHandIndex', 'BIconHandIndexFill', 'BIconHandIndexThumb', 'BIconHandIndexThumbFill', 'BIconHandThumbsDown', 'BIconHandThumbsDownFill', 'BIconHandThumbsUp', 'BIconHandThumbsUpFill', 'BIconHandbag', 'BIconHandbagFill', 'BIconHash', 'BIconHdd', 'BIconHddFill', 'BIconHddNetwork', 'BIconHddNetworkFill', 'BIconHddRack', 'BIconHddRackFill', 'BIconHddStack', 'BIconHddStackFill', 'BIconHeadphones', 'BIconHeadset', 'BIconHeadsetVr', 'BIconHeart', 'BIconHeartFill', 'BIconHeartHalf', 'BIconHeptagon', 'BIconHeptagonFill', 'BIconHeptagonHalf', 'BIconHexagon', 'BIconHexagonFill', 'BIconHexagonHalf', 'BIconHourglass', 'BIconHourglassBottom', 'BIconHourglassSplit', 'BIconHourglassTop', 'BIconHouse', 'BIconHouseDoor', 'BIconHouseDoorFill', 'BIconHouseFill', 'BIconHr', 'BIconHurricane', 'BIconImage', 'BIconImageAlt', 'BIconImageFill', 'BIconImages', 'BIconInbox', 'BIconInboxFill', 'BIconInboxes', 'BIconInboxesFill', 'BIconInfo', 'BIconInfoCircle', 'BIconInfoCircleFill', 'BIconInfoLg', 'BIconInfoSquare', 'BIconInfoSquareFill', 'BIconInputCursor', 'BIconInputCursorText', 'BIconInstagram', 'BIconIntersect', 'BIconJournal', 'BIconJournalAlbum', 'BIconJournalArrowDown', 'BIconJournalArrowUp', 'BIconJournalBookmark', 'BIconJournalBookmarkFill', 'BIconJournalCheck', 'BIconJournalCode', 'BIconJournalMedical', 'BIconJournalMinus', 'BIconJournalPlus', 'BIconJournalRichtext', 'BIconJournalText', 'BIconJournalX', 'BIconJournals', 'BIconJoystick', 'BIconJustify', 'BIconJustifyLeft', 'BIconJustifyRight', 'BIconKanban', 'BIconKanbanFill', 'BIconKey', 'BIconKeyFill', 'BIconKeyboard', 'BIconKeyboardFill', 'BIconLadder', 'BIconLamp', 'BIconLampFill', 'BIconLaptop', 'BIconLaptopFill', 'BIconLayerBackward', 'BIconLayerForward', 'BIconLayers', 'BIconLayersFill', 'BIconLayersHalf', 'BIconLayoutSidebar', 'BIconLayoutSidebarInset', 'BIconLayoutSidebarInsetReverse', 'BIconLayoutSidebarReverse', 'BIconLayoutSplit', 'BIconLayoutTextSidebar', 'BIconLayoutTextSidebarReverse', 'BIconLayoutTextWindow', 'BIconLayoutTextWindowReverse', 'BIconLayoutThreeColumns', 'BIconLayoutWtf', 'BIconLifePreserver', 'BIconLightbulb', 'BIconLightbulbFill', 'BIconLightbulbOff', 'BIconLightbulbOffFill', 'BIconLightning', 'BIconLightningCharge', 'BIconLightningChargeFill', 'BIconLightningFill', 'BIconLink', 'BIconLink45deg', 'BIconLinkedin', 'BIconList', 'BIconListCheck', 'BIconListNested', 'BIconListOl', 'BIconListStars', 'BIconListTask', 'BIconListUl', 'BIconLock', 'BIconLockFill', 'BIconMailbox', 'BIconMailbox2', 'BIconMap', 'BIconMapFill', 'BIconMarkdown', 'BIconMarkdownFill', 'BIconMask', 'BIconMastodon', 'BIconMegaphone', 'BIconMegaphoneFill', 'BIconMenuApp', 'BIconMenuAppFill', 'BIconMenuButton', 'BIconMenuButtonFill', 'BIconMenuButtonWide', 'BIconMenuButtonWideFill', 'BIconMenuDown', 'BIconMenuUp', 'BIconMessenger', 'BIconMic', 'BIconMicFill', 'BIconMicMute', 'BIconMicMuteFill', 'BIconMinecart', 'BIconMinecartLoaded', 'BIconMoisture', 'BIconMoon', 'BIconMoonFill', 'BIconMoonStars', 'BIconMoonStarsFill', 'BIconMouse', 'BIconMouse2', 'BIconMouse2Fill', 'BIconMouse3', 'BIconMouse3Fill', 'BIconMouseFill', 'BIconMusicNote', 'BIconMusicNoteBeamed', 'BIconMusicNoteList', 'BIconMusicPlayer', 'BIconMusicPlayerFill', 'BIconNewspaper', 'BIconNodeMinus', 'BIconNodeMinusFill', 'BIconNodePlus', 'BIconNodePlusFill', 'BIconNut', 'BIconNutFill', 'BIconOctagon', 'BIconOctagonFill', 'BIconOctagonHalf', 'BIconOption', 'BIconOutlet', 'BIconPaintBucket', 'BIconPalette', 'BIconPalette2', 'BIconPaletteFill', 'BIconPaperclip', 'BIconParagraph', 'BIconPatchCheck', 'BIconPatchCheckFill', 'BIconPatchExclamation', 'BIconPatchExclamationFill', 'BIconPatchMinus', 'BIconPatchMinusFill', 'BIconPatchPlus', 'BIconPatchPlusFill', 'BIconPatchQuestion', 'BIconPatchQuestionFill', 'BIconPause', 'BIconPauseBtn', 'BIconPauseBtnFill', 'BIconPauseCircle', 'BIconPauseCircleFill', 'BIconPauseFill', 'BIconPeace', 'BIconPeaceFill', 'BIconPen', 'BIconPenFill', 'BIconPencil', 'BIconPencilFill', 'BIconPencilSquare', 'BIconPentagon', 'BIconPentagonFill', 'BIconPentagonHalf', 'BIconPeople', 'BIconPeopleFill', 'BIconPercent', 'BIconPerson', 'BIconPersonBadge', 'BIconPersonBadgeFill', 'BIconPersonBoundingBox', 'BIconPersonCheck', 'BIconPersonCheckFill', 'BIconPersonCircle', 'BIconPersonDash', 'BIconPersonDashFill', 'BIconPersonFill', 'BIconPersonLinesFill', 'BIconPersonPlus', 'BIconPersonPlusFill', 'BIconPersonSquare', 'BIconPersonX', 'BIconPersonXFill', 'BIconPhone', 'BIconPhoneFill', 'BIconPhoneLandscape', 'BIconPhoneLandscapeFill', 'BIconPhoneVibrate', 'BIconPhoneVibrateFill', 'BIconPieChart', 'BIconPieChartFill', 'BIconPiggyBank', 'BIconPiggyBankFill', 'BIconPin', 'BIconPinAngle', 'BIconPinAngleFill', 'BIconPinFill', 'BIconPinMap', 'BIconPinMapFill', 'BIconPip', 'BIconPipFill', 'BIconPlay', 'BIconPlayBtn', 'BIconPlayBtnFill', 'BIconPlayCircle', 'BIconPlayCircleFill', 'BIconPlayFill', 'BIconPlug', 'BIconPlugFill', 'BIconPlus', 'BIconPlusCircle', 'BIconPlusCircleDotted', 'BIconPlusCircleFill', 'BIconPlusLg', 'BIconPlusSquare', 'BIconPlusSquareDotted', 'BIconPlusSquareFill', 'BIconPower', 'BIconPrinter', 'BIconPrinterFill', 'BIconPuzzle', 'BIconPuzzleFill', 'BIconQuestion', 'BIconQuestionCircle', 'BIconQuestionCircleFill', 'BIconQuestionDiamond', 'BIconQuestionDiamondFill', 'BIconQuestionLg', 'BIconQuestionOctagon', 'BIconQuestionOctagonFill', 'BIconQuestionSquare', 'BIconQuestionSquareFill', 'BIconRainbow', 'BIconReceipt', 'BIconReceiptCutoff', 'BIconReception0', 'BIconReception1', 'BIconReception2', 'BIconReception3', 'BIconReception4', 'BIconRecord', 'BIconRecord2', 'BIconRecord2Fill', 'BIconRecordBtn', 'BIconRecordBtnFill', 'BIconRecordCircle', 'BIconRecordCircleFill', 'BIconRecordFill', 'BIconRecycle', 'BIconReddit', 'BIconReply', 'BIconReplyAll', 'BIconReplyAllFill', 'BIconReplyFill', 'BIconRss', 'BIconRssFill', 'BIconRulers', 'BIconSafe', 'BIconSafe2', 'BIconSafe2Fill', 'BIconSafeFill', 'BIconSave', 'BIconSave2', 'BIconSave2Fill', 'BIconSaveFill', 'BIconScissors', 'BIconScrewdriver', 'BIconSdCard', 'BIconSdCardFill', 'BIconSearch', 'BIconSegmentedNav', 'BIconServer', 'BIconShare', 'BIconShareFill', 'BIconShield', 'BIconShieldCheck', 'BIconShieldExclamation', 'BIconShieldFill', 'BIconShieldFillCheck', 'BIconShieldFillExclamation', 'BIconShieldFillMinus', 'BIconShieldFillPlus', 'BIconShieldFillX', 'BIconShieldLock', 'BIconShieldLockFill', 'BIconShieldMinus', 'BIconShieldPlus', 'BIconShieldShaded', 'BIconShieldSlash', 'BIconShieldSlashFill', 'BIconShieldX', 'BIconShift', 'BIconShiftFill', 'BIconShop', 'BIconShopWindow', 'BIconShuffle', 'BIconSignpost', 'BIconSignpost2', 'BIconSignpost2Fill', 'BIconSignpostFill', 'BIconSignpostSplit', 'BIconSignpostSplitFill', 'BIconSim', 'BIconSimFill', 'BIconSkipBackward', 'BIconSkipBackwardBtn', 'BIconSkipBackwardBtnFill', 'BIconSkipBackwardCircle', 'BIconSkipBackwardCircleFill', 'BIconSkipBackwardFill', 'BIconSkipEnd', 'BIconSkipEndBtn', 'BIconSkipEndBtnFill', 'BIconSkipEndCircle', 'BIconSkipEndCircleFill', 'BIconSkipEndFill', 'BIconSkipForward', 'BIconSkipForwardBtn', 'BIconSkipForwardBtnFill', 'BIconSkipForwardCircle', 'BIconSkipForwardCircleFill', 'BIconSkipForwardFill', 'BIconSkipStart', 'BIconSkipStartBtn', 'BIconSkipStartBtnFill', 'BIconSkipStartCircle', 'BIconSkipStartCircleFill', 'BIconSkipStartFill', 'BIconSkype', 'BIconSlack', 'BIconSlash', 'BIconSlashCircle', 'BIconSlashCircleFill', 'BIconSlashLg', 'BIconSlashSquare', 'BIconSlashSquareFill', 'BIconSliders', 'BIconSmartwatch', 'BIconSnow', 'BIconSnow2', 'BIconSnow3', 'BIconSortAlphaDown', 'BIconSortAlphaDownAlt', 'BIconSortAlphaUp', 'BIconSortAlphaUpAlt', 'BIconSortDown', 'BIconSortDownAlt', 'BIconSortNumericDown', 'BIconSortNumericDownAlt', 'BIconSortNumericUp', 'BIconSortNumericUpAlt', 'BIconSortUp', 'BIconSortUpAlt', 'BIconSoundwave', 'BIconSpeaker', 'BIconSpeakerFill', 'BIconSpeedometer', 'BIconSpeedometer2', 'BIconSpellcheck', 'BIconSquare', 'BIconSquareFill', 'BIconSquareHalf', 'BIconStack', 'BIconStar', 'BIconStarFill', 'BIconStarHalf', 'BIconStars', 'BIconStickies', 'BIconStickiesFill', 'BIconSticky', 'BIconStickyFill', 'BIconStop', 'BIconStopBtn', 'BIconStopBtnFill', 'BIconStopCircle', 'BIconStopCircleFill', 'BIconStopFill', 'BIconStoplights', 'BIconStoplightsFill', 'BIconStopwatch', 'BIconStopwatchFill', 'BIconSubtract', 'BIconSuitClub', 'BIconSuitClubFill', 'BIconSuitDiamond', 'BIconSuitDiamondFill', 'BIconSuitHeart', 'BIconSuitHeartFill', 'BIconSuitSpade', 'BIconSuitSpadeFill', 'BIconSun', 'BIconSunFill', 'BIconSunglasses', 'BIconSunrise', 'BIconSunriseFill', 'BIconSunset', 'BIconSunsetFill', 'BIconSymmetryHorizontal', 'BIconSymmetryVertical', 'BIconTable', 'BIconTablet', 'BIconTabletFill', 'BIconTabletLandscape', 'BIconTabletLandscapeFill', 'BIconTag', 'BIconTagFill', 'BIconTags', 'BIconTagsFill', 'BIconTelegram', 'BIconTelephone', 'BIconTelephoneFill', 'BIconTelephoneForward', 'BIconTelephoneForwardFill', 'BIconTelephoneInbound', 'BIconTelephoneInboundFill', 'BIconTelephoneMinus', 'BIconTelephoneMinusFill', 'BIconTelephoneOutbound', 'BIconTelephoneOutboundFill', 'BIconTelephonePlus', 'BIconTelephonePlusFill', 'BIconTelephoneX', 'BIconTelephoneXFill', 'BIconTerminal', 'BIconTerminalFill', 'BIconTextCenter', 'BIconTextIndentLeft', 'BIconTextIndentRight', 'BIconTextLeft', 'BIconTextParagraph', 'BIconTextRight', 'BIconTextarea', 'BIconTextareaResize', 'BIconTextareaT', 'BIconThermometer', 'BIconThermometerHalf', 'BIconThermometerHigh', 'BIconThermometerLow', 'BIconThermometerSnow', 'BIconThermometerSun', 'BIconThreeDots', 'BIconThreeDotsVertical', 'BIconToggle2Off', 'BIconToggle2On', 'BIconToggleOff', 'BIconToggleOn', 'BIconToggles', 'BIconToggles2', 'BIconTools', 'BIconTornado', 'BIconTranslate', 'BIconTrash', 'BIconTrash2', 'BIconTrash2Fill', 'BIconTrashFill', 'BIconTree', 'BIconTreeFill', 'BIconTriangle', 'BIconTriangleFill', 'BIconTriangleHalf', 'BIconTrophy', 'BIconTrophyFill', 'BIconTropicalStorm', 'BIconTruck', 'BIconTruckFlatbed', 'BIconTsunami', 'BIconTv', 'BIconTvFill', 'BIconTwitch', 'BIconTwitter', 'BIconType', 'BIconTypeBold', 'BIconTypeH1', 'BIconTypeH2', 'BIconTypeH3', 'BIconTypeItalic', 'BIconTypeStrikethrough', 'BIconTypeUnderline', 'BIconUiChecks', 'BIconUiChecksGrid', 'BIconUiRadios', 'BIconUiRadiosGrid', 'BIconUmbrella', 'BIconUmbrellaFill', 'BIconUnion', 'BIconUnlock', 'BIconUnlockFill', 'BIconUpc', 'BIconUpcScan', 'BIconUpload', 'BIconVectorPen', 'BIconViewList', 'BIconViewStacked', 'BIconVinyl', 'BIconVinylFill', 'BIconVoicemail', 'BIconVolumeDown', 'BIconVolumeDownFill', 'BIconVolumeMute', 'BIconVolumeMuteFill', 'BIconVolumeOff', 'BIconVolumeOffFill', 'BIconVolumeUp', 'BIconVolumeUpFill', 'BIconVr', 'BIconWallet', 'BIconWallet2', 'BIconWalletFill', 'BIconWatch', 'BIconWater', 'BIconWhatsapp', 'BIconWifi', 'BIconWifi1', 'BIconWifi2', 'BIconWifiOff', 'BIconWind', 'BIconWindow', 'BIconWindowDock', 'BIconWindowSidebar', 'BIconWrench', 'BIconX', 'BIconXCircle', 'BIconXCircleFill', 'BIconXDiamond', 'BIconXDiamondFill', 'BIconXLg', 'BIconXOctagon', 'BIconXOctagonFill', 'BIconXSquare', 'BIconXSquareFill', 'BIconYoutube', 'BIconZoomIn', 'BIconZoomOut']; // Export the icons plugin

var IconsPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["c" /* pluginFactoryNoConfig */])({
  components: {
    // Icon helper component
    BIcon: __WEBPACK_IMPORTED_MODULE_1__icon__["a" /* BIcon */],
    // Icon stacking component
    BIconstack: __WEBPACK_IMPORTED_MODULE_2__iconstack__["a" /* BIconstack */],
    // BootstrapVue custom icon components
    BIconBlank: __WEBPACK_IMPORTED_MODULE_3__icons__["a" /* BIconBlank */],
    // Bootstrap icon components
    BIconAlarm: __WEBPACK_IMPORTED_MODULE_3__icons__["b" /* BIconAlarm */],
    BIconAlarmFill: __WEBPACK_IMPORTED_MODULE_3__icons__["c" /* BIconAlarmFill */],
    BIconAlignBottom: __WEBPACK_IMPORTED_MODULE_3__icons__["d" /* BIconAlignBottom */],
    BIconAlignCenter: __WEBPACK_IMPORTED_MODULE_3__icons__["e" /* BIconAlignCenter */],
    BIconAlignEnd: __WEBPACK_IMPORTED_MODULE_3__icons__["f" /* BIconAlignEnd */],
    BIconAlignMiddle: __WEBPACK_IMPORTED_MODULE_3__icons__["g" /* BIconAlignMiddle */],
    BIconAlignStart: __WEBPACK_IMPORTED_MODULE_3__icons__["h" /* BIconAlignStart */],
    BIconAlignTop: __WEBPACK_IMPORTED_MODULE_3__icons__["i" /* BIconAlignTop */],
    BIconAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["j" /* BIconAlt */],
    BIconApp: __WEBPACK_IMPORTED_MODULE_3__icons__["k" /* BIconApp */],
    BIconAppIndicator: __WEBPACK_IMPORTED_MODULE_3__icons__["l" /* BIconAppIndicator */],
    BIconArchive: __WEBPACK_IMPORTED_MODULE_3__icons__["m" /* BIconArchive */],
    BIconArchiveFill: __WEBPACK_IMPORTED_MODULE_3__icons__["n" /* BIconArchiveFill */],
    BIconArrow90degDown: __WEBPACK_IMPORTED_MODULE_3__icons__["o" /* BIconArrow90degDown */],
    BIconArrow90degLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["p" /* BIconArrow90degLeft */],
    BIconArrow90degRight: __WEBPACK_IMPORTED_MODULE_3__icons__["q" /* BIconArrow90degRight */],
    BIconArrow90degUp: __WEBPACK_IMPORTED_MODULE_3__icons__["r" /* BIconArrow90degUp */],
    BIconArrowBarDown: __WEBPACK_IMPORTED_MODULE_3__icons__["s" /* BIconArrowBarDown */],
    BIconArrowBarLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["t" /* BIconArrowBarLeft */],
    BIconArrowBarRight: __WEBPACK_IMPORTED_MODULE_3__icons__["u" /* BIconArrowBarRight */],
    BIconArrowBarUp: __WEBPACK_IMPORTED_MODULE_3__icons__["v" /* BIconArrowBarUp */],
    BIconArrowClockwise: __WEBPACK_IMPORTED_MODULE_3__icons__["w" /* BIconArrowClockwise */],
    BIconArrowCounterclockwise: __WEBPACK_IMPORTED_MODULE_3__icons__["x" /* BIconArrowCounterclockwise */],
    BIconArrowDown: __WEBPACK_IMPORTED_MODULE_3__icons__["y" /* BIconArrowDown */],
    BIconArrowDownCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["z" /* BIconArrowDownCircle */],
    BIconArrowDownCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["A" /* BIconArrowDownCircleFill */],
    BIconArrowDownLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["B" /* BIconArrowDownLeft */],
    BIconArrowDownLeftCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["C" /* BIconArrowDownLeftCircle */],
    BIconArrowDownLeftCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["D" /* BIconArrowDownLeftCircleFill */],
    BIconArrowDownLeftSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["E" /* BIconArrowDownLeftSquare */],
    BIconArrowDownLeftSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["F" /* BIconArrowDownLeftSquareFill */],
    BIconArrowDownRight: __WEBPACK_IMPORTED_MODULE_3__icons__["G" /* BIconArrowDownRight */],
    BIconArrowDownRightCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["H" /* BIconArrowDownRightCircle */],
    BIconArrowDownRightCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["I" /* BIconArrowDownRightCircleFill */],
    BIconArrowDownRightSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["J" /* BIconArrowDownRightSquare */],
    BIconArrowDownRightSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["K" /* BIconArrowDownRightSquareFill */],
    BIconArrowDownShort: __WEBPACK_IMPORTED_MODULE_3__icons__["L" /* BIconArrowDownShort */],
    BIconArrowDownSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["M" /* BIconArrowDownSquare */],
    BIconArrowDownSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["N" /* BIconArrowDownSquareFill */],
    BIconArrowDownUp: __WEBPACK_IMPORTED_MODULE_3__icons__["O" /* BIconArrowDownUp */],
    BIconArrowLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["P" /* BIconArrowLeft */],
    BIconArrowLeftCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["Q" /* BIconArrowLeftCircle */],
    BIconArrowLeftCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["R" /* BIconArrowLeftCircleFill */],
    BIconArrowLeftRight: __WEBPACK_IMPORTED_MODULE_3__icons__["S" /* BIconArrowLeftRight */],
    BIconArrowLeftShort: __WEBPACK_IMPORTED_MODULE_3__icons__["T" /* BIconArrowLeftShort */],
    BIconArrowLeftSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["U" /* BIconArrowLeftSquare */],
    BIconArrowLeftSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["V" /* BIconArrowLeftSquareFill */],
    BIconArrowRepeat: __WEBPACK_IMPORTED_MODULE_3__icons__["W" /* BIconArrowRepeat */],
    BIconArrowReturnLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["X" /* BIconArrowReturnLeft */],
    BIconArrowReturnRight: __WEBPACK_IMPORTED_MODULE_3__icons__["Y" /* BIconArrowReturnRight */],
    BIconArrowRight: __WEBPACK_IMPORTED_MODULE_3__icons__["Z" /* BIconArrowRight */],
    BIconArrowRightCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_0" /* BIconArrowRightCircle */],
    BIconArrowRightCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1" /* BIconArrowRightCircleFill */],
    BIconArrowRightShort: __WEBPACK_IMPORTED_MODULE_3__icons__["_2" /* BIconArrowRightShort */],
    BIconArrowRightSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_3" /* BIconArrowRightSquare */],
    BIconArrowRightSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_4" /* BIconArrowRightSquareFill */],
    BIconArrowUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_5" /* BIconArrowUp */],
    BIconArrowUpCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_6" /* BIconArrowUpCircle */],
    BIconArrowUpCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_7" /* BIconArrowUpCircleFill */],
    BIconArrowUpLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_8" /* BIconArrowUpLeft */],
    BIconArrowUpLeftCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_9" /* BIconArrowUpLeftCircle */],
    BIconArrowUpLeftCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_10" /* BIconArrowUpLeftCircleFill */],
    BIconArrowUpLeftSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_11" /* BIconArrowUpLeftSquare */],
    BIconArrowUpLeftSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_12" /* BIconArrowUpLeftSquareFill */],
    BIconArrowUpRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_13" /* BIconArrowUpRight */],
    BIconArrowUpRightCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_14" /* BIconArrowUpRightCircle */],
    BIconArrowUpRightCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_15" /* BIconArrowUpRightCircleFill */],
    BIconArrowUpRightSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_16" /* BIconArrowUpRightSquare */],
    BIconArrowUpRightSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_17" /* BIconArrowUpRightSquareFill */],
    BIconArrowUpShort: __WEBPACK_IMPORTED_MODULE_3__icons__["_18" /* BIconArrowUpShort */],
    BIconArrowUpSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_19" /* BIconArrowUpSquare */],
    BIconArrowUpSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_20" /* BIconArrowUpSquareFill */],
    BIconArrowsAngleContract: __WEBPACK_IMPORTED_MODULE_3__icons__["_21" /* BIconArrowsAngleContract */],
    BIconArrowsAngleExpand: __WEBPACK_IMPORTED_MODULE_3__icons__["_22" /* BIconArrowsAngleExpand */],
    BIconArrowsCollapse: __WEBPACK_IMPORTED_MODULE_3__icons__["_23" /* BIconArrowsCollapse */],
    BIconArrowsExpand: __WEBPACK_IMPORTED_MODULE_3__icons__["_24" /* BIconArrowsExpand */],
    BIconArrowsFullscreen: __WEBPACK_IMPORTED_MODULE_3__icons__["_25" /* BIconArrowsFullscreen */],
    BIconArrowsMove: __WEBPACK_IMPORTED_MODULE_3__icons__["_26" /* BIconArrowsMove */],
    BIconAspectRatio: __WEBPACK_IMPORTED_MODULE_3__icons__["_27" /* BIconAspectRatio */],
    BIconAspectRatioFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_28" /* BIconAspectRatioFill */],
    BIconAsterisk: __WEBPACK_IMPORTED_MODULE_3__icons__["_29" /* BIconAsterisk */],
    BIconAt: __WEBPACK_IMPORTED_MODULE_3__icons__["_30" /* BIconAt */],
    BIconAward: __WEBPACK_IMPORTED_MODULE_3__icons__["_31" /* BIconAward */],
    BIconAwardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_32" /* BIconAwardFill */],
    BIconBack: __WEBPACK_IMPORTED_MODULE_3__icons__["_33" /* BIconBack */],
    BIconBackspace: __WEBPACK_IMPORTED_MODULE_3__icons__["_34" /* BIconBackspace */],
    BIconBackspaceFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_35" /* BIconBackspaceFill */],
    BIconBackspaceReverse: __WEBPACK_IMPORTED_MODULE_3__icons__["_36" /* BIconBackspaceReverse */],
    BIconBackspaceReverseFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_37" /* BIconBackspaceReverseFill */],
    BIconBadge3d: __WEBPACK_IMPORTED_MODULE_3__icons__["_38" /* BIconBadge3d */],
    BIconBadge3dFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_39" /* BIconBadge3dFill */],
    BIconBadge4k: __WEBPACK_IMPORTED_MODULE_3__icons__["_40" /* BIconBadge4k */],
    BIconBadge4kFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_41" /* BIconBadge4kFill */],
    BIconBadge8k: __WEBPACK_IMPORTED_MODULE_3__icons__["_42" /* BIconBadge8k */],
    BIconBadge8kFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_43" /* BIconBadge8kFill */],
    BIconBadgeAd: __WEBPACK_IMPORTED_MODULE_3__icons__["_44" /* BIconBadgeAd */],
    BIconBadgeAdFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_45" /* BIconBadgeAdFill */],
    BIconBadgeAr: __WEBPACK_IMPORTED_MODULE_3__icons__["_46" /* BIconBadgeAr */],
    BIconBadgeArFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_47" /* BIconBadgeArFill */],
    BIconBadgeCc: __WEBPACK_IMPORTED_MODULE_3__icons__["_48" /* BIconBadgeCc */],
    BIconBadgeCcFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_49" /* BIconBadgeCcFill */],
    BIconBadgeHd: __WEBPACK_IMPORTED_MODULE_3__icons__["_50" /* BIconBadgeHd */],
    BIconBadgeHdFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_51" /* BIconBadgeHdFill */],
    BIconBadgeTm: __WEBPACK_IMPORTED_MODULE_3__icons__["_52" /* BIconBadgeTm */],
    BIconBadgeTmFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_53" /* BIconBadgeTmFill */],
    BIconBadgeVo: __WEBPACK_IMPORTED_MODULE_3__icons__["_54" /* BIconBadgeVo */],
    BIconBadgeVoFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_55" /* BIconBadgeVoFill */],
    BIconBadgeVr: __WEBPACK_IMPORTED_MODULE_3__icons__["_56" /* BIconBadgeVr */],
    BIconBadgeVrFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_57" /* BIconBadgeVrFill */],
    BIconBadgeWc: __WEBPACK_IMPORTED_MODULE_3__icons__["_58" /* BIconBadgeWc */],
    BIconBadgeWcFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_59" /* BIconBadgeWcFill */],
    BIconBag: __WEBPACK_IMPORTED_MODULE_3__icons__["_60" /* BIconBag */],
    BIconBagCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_61" /* BIconBagCheck */],
    BIconBagCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_62" /* BIconBagCheckFill */],
    BIconBagDash: __WEBPACK_IMPORTED_MODULE_3__icons__["_63" /* BIconBagDash */],
    BIconBagDashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_64" /* BIconBagDashFill */],
    BIconBagFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_65" /* BIconBagFill */],
    BIconBagPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_66" /* BIconBagPlus */],
    BIconBagPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_67" /* BIconBagPlusFill */],
    BIconBagX: __WEBPACK_IMPORTED_MODULE_3__icons__["_68" /* BIconBagX */],
    BIconBagXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_69" /* BIconBagXFill */],
    BIconBank: __WEBPACK_IMPORTED_MODULE_3__icons__["_70" /* BIconBank */],
    BIconBank2: __WEBPACK_IMPORTED_MODULE_3__icons__["_71" /* BIconBank2 */],
    BIconBarChart: __WEBPACK_IMPORTED_MODULE_3__icons__["_72" /* BIconBarChart */],
    BIconBarChartFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_73" /* BIconBarChartFill */],
    BIconBarChartLine: __WEBPACK_IMPORTED_MODULE_3__icons__["_74" /* BIconBarChartLine */],
    BIconBarChartLineFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_75" /* BIconBarChartLineFill */],
    BIconBarChartSteps: __WEBPACK_IMPORTED_MODULE_3__icons__["_76" /* BIconBarChartSteps */],
    BIconBasket: __WEBPACK_IMPORTED_MODULE_3__icons__["_77" /* BIconBasket */],
    BIconBasket2: __WEBPACK_IMPORTED_MODULE_3__icons__["_78" /* BIconBasket2 */],
    BIconBasket2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_79" /* BIconBasket2Fill */],
    BIconBasket3: __WEBPACK_IMPORTED_MODULE_3__icons__["_80" /* BIconBasket3 */],
    BIconBasket3Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_81" /* BIconBasket3Fill */],
    BIconBasketFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_82" /* BIconBasketFill */],
    BIconBattery: __WEBPACK_IMPORTED_MODULE_3__icons__["_83" /* BIconBattery */],
    BIconBatteryCharging: __WEBPACK_IMPORTED_MODULE_3__icons__["_84" /* BIconBatteryCharging */],
    BIconBatteryFull: __WEBPACK_IMPORTED_MODULE_3__icons__["_85" /* BIconBatteryFull */],
    BIconBatteryHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_86" /* BIconBatteryHalf */],
    BIconBell: __WEBPACK_IMPORTED_MODULE_3__icons__["_87" /* BIconBell */],
    BIconBellFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_88" /* BIconBellFill */],
    BIconBellSlash: __WEBPACK_IMPORTED_MODULE_3__icons__["_89" /* BIconBellSlash */],
    BIconBellSlashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_90" /* BIconBellSlashFill */],
    BIconBezier: __WEBPACK_IMPORTED_MODULE_3__icons__["_91" /* BIconBezier */],
    BIconBezier2: __WEBPACK_IMPORTED_MODULE_3__icons__["_92" /* BIconBezier2 */],
    BIconBicycle: __WEBPACK_IMPORTED_MODULE_3__icons__["_93" /* BIconBicycle */],
    BIconBinoculars: __WEBPACK_IMPORTED_MODULE_3__icons__["_94" /* BIconBinoculars */],
    BIconBinocularsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_95" /* BIconBinocularsFill */],
    BIconBlockquoteLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_96" /* BIconBlockquoteLeft */],
    BIconBlockquoteRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_97" /* BIconBlockquoteRight */],
    BIconBook: __WEBPACK_IMPORTED_MODULE_3__icons__["_98" /* BIconBook */],
    BIconBookFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_99" /* BIconBookFill */],
    BIconBookHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_100" /* BIconBookHalf */],
    BIconBookmark: __WEBPACK_IMPORTED_MODULE_3__icons__["_101" /* BIconBookmark */],
    BIconBookmarkCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_102" /* BIconBookmarkCheck */],
    BIconBookmarkCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_103" /* BIconBookmarkCheckFill */],
    BIconBookmarkDash: __WEBPACK_IMPORTED_MODULE_3__icons__["_104" /* BIconBookmarkDash */],
    BIconBookmarkDashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_105" /* BIconBookmarkDashFill */],
    BIconBookmarkFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_106" /* BIconBookmarkFill */],
    BIconBookmarkHeart: __WEBPACK_IMPORTED_MODULE_3__icons__["_107" /* BIconBookmarkHeart */],
    BIconBookmarkHeartFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_108" /* BIconBookmarkHeartFill */],
    BIconBookmarkPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_109" /* BIconBookmarkPlus */],
    BIconBookmarkPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_110" /* BIconBookmarkPlusFill */],
    BIconBookmarkStar: __WEBPACK_IMPORTED_MODULE_3__icons__["_111" /* BIconBookmarkStar */],
    BIconBookmarkStarFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_112" /* BIconBookmarkStarFill */],
    BIconBookmarkX: __WEBPACK_IMPORTED_MODULE_3__icons__["_113" /* BIconBookmarkX */],
    BIconBookmarkXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_114" /* BIconBookmarkXFill */],
    BIconBookmarks: __WEBPACK_IMPORTED_MODULE_3__icons__["_115" /* BIconBookmarks */],
    BIconBookmarksFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_116" /* BIconBookmarksFill */],
    BIconBookshelf: __WEBPACK_IMPORTED_MODULE_3__icons__["_117" /* BIconBookshelf */],
    BIconBootstrap: __WEBPACK_IMPORTED_MODULE_3__icons__["_118" /* BIconBootstrap */],
    BIconBootstrapFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_119" /* BIconBootstrapFill */],
    BIconBootstrapReboot: __WEBPACK_IMPORTED_MODULE_3__icons__["_120" /* BIconBootstrapReboot */],
    BIconBorder: __WEBPACK_IMPORTED_MODULE_3__icons__["_121" /* BIconBorder */],
    BIconBorderAll: __WEBPACK_IMPORTED_MODULE_3__icons__["_122" /* BIconBorderAll */],
    BIconBorderBottom: __WEBPACK_IMPORTED_MODULE_3__icons__["_123" /* BIconBorderBottom */],
    BIconBorderCenter: __WEBPACK_IMPORTED_MODULE_3__icons__["_124" /* BIconBorderCenter */],
    BIconBorderInner: __WEBPACK_IMPORTED_MODULE_3__icons__["_125" /* BIconBorderInner */],
    BIconBorderLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_126" /* BIconBorderLeft */],
    BIconBorderMiddle: __WEBPACK_IMPORTED_MODULE_3__icons__["_127" /* BIconBorderMiddle */],
    BIconBorderOuter: __WEBPACK_IMPORTED_MODULE_3__icons__["_128" /* BIconBorderOuter */],
    BIconBorderRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_129" /* BIconBorderRight */],
    BIconBorderStyle: __WEBPACK_IMPORTED_MODULE_3__icons__["_130" /* BIconBorderStyle */],
    BIconBorderTop: __WEBPACK_IMPORTED_MODULE_3__icons__["_131" /* BIconBorderTop */],
    BIconBorderWidth: __WEBPACK_IMPORTED_MODULE_3__icons__["_132" /* BIconBorderWidth */],
    BIconBoundingBox: __WEBPACK_IMPORTED_MODULE_3__icons__["_133" /* BIconBoundingBox */],
    BIconBoundingBoxCircles: __WEBPACK_IMPORTED_MODULE_3__icons__["_134" /* BIconBoundingBoxCircles */],
    BIconBox: __WEBPACK_IMPORTED_MODULE_3__icons__["_135" /* BIconBox */],
    BIconBoxArrowDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_136" /* BIconBoxArrowDown */],
    BIconBoxArrowDownLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_137" /* BIconBoxArrowDownLeft */],
    BIconBoxArrowDownRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_138" /* BIconBoxArrowDownRight */],
    BIconBoxArrowInDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_139" /* BIconBoxArrowInDown */],
    BIconBoxArrowInDownLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_140" /* BIconBoxArrowInDownLeft */],
    BIconBoxArrowInDownRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_141" /* BIconBoxArrowInDownRight */],
    BIconBoxArrowInLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_142" /* BIconBoxArrowInLeft */],
    BIconBoxArrowInRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_143" /* BIconBoxArrowInRight */],
    BIconBoxArrowInUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_144" /* BIconBoxArrowInUp */],
    BIconBoxArrowInUpLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_145" /* BIconBoxArrowInUpLeft */],
    BIconBoxArrowInUpRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_146" /* BIconBoxArrowInUpRight */],
    BIconBoxArrowLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_147" /* BIconBoxArrowLeft */],
    BIconBoxArrowRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_148" /* BIconBoxArrowRight */],
    BIconBoxArrowUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_149" /* BIconBoxArrowUp */],
    BIconBoxArrowUpLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_150" /* BIconBoxArrowUpLeft */],
    BIconBoxArrowUpRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_151" /* BIconBoxArrowUpRight */],
    BIconBoxSeam: __WEBPACK_IMPORTED_MODULE_3__icons__["_152" /* BIconBoxSeam */],
    BIconBraces: __WEBPACK_IMPORTED_MODULE_3__icons__["_153" /* BIconBraces */],
    BIconBricks: __WEBPACK_IMPORTED_MODULE_3__icons__["_154" /* BIconBricks */],
    BIconBriefcase: __WEBPACK_IMPORTED_MODULE_3__icons__["_155" /* BIconBriefcase */],
    BIconBriefcaseFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_156" /* BIconBriefcaseFill */],
    BIconBrightnessAltHigh: __WEBPACK_IMPORTED_MODULE_3__icons__["_157" /* BIconBrightnessAltHigh */],
    BIconBrightnessAltHighFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_158" /* BIconBrightnessAltHighFill */],
    BIconBrightnessAltLow: __WEBPACK_IMPORTED_MODULE_3__icons__["_159" /* BIconBrightnessAltLow */],
    BIconBrightnessAltLowFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_160" /* BIconBrightnessAltLowFill */],
    BIconBrightnessHigh: __WEBPACK_IMPORTED_MODULE_3__icons__["_161" /* BIconBrightnessHigh */],
    BIconBrightnessHighFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_162" /* BIconBrightnessHighFill */],
    BIconBrightnessLow: __WEBPACK_IMPORTED_MODULE_3__icons__["_163" /* BIconBrightnessLow */],
    BIconBrightnessLowFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_164" /* BIconBrightnessLowFill */],
    BIconBroadcast: __WEBPACK_IMPORTED_MODULE_3__icons__["_165" /* BIconBroadcast */],
    BIconBroadcastPin: __WEBPACK_IMPORTED_MODULE_3__icons__["_166" /* BIconBroadcastPin */],
    BIconBrush: __WEBPACK_IMPORTED_MODULE_3__icons__["_167" /* BIconBrush */],
    BIconBrushFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_168" /* BIconBrushFill */],
    BIconBucket: __WEBPACK_IMPORTED_MODULE_3__icons__["_169" /* BIconBucket */],
    BIconBucketFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_170" /* BIconBucketFill */],
    BIconBug: __WEBPACK_IMPORTED_MODULE_3__icons__["_171" /* BIconBug */],
    BIconBugFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_172" /* BIconBugFill */],
    BIconBuilding: __WEBPACK_IMPORTED_MODULE_3__icons__["_173" /* BIconBuilding */],
    BIconBullseye: __WEBPACK_IMPORTED_MODULE_3__icons__["_174" /* BIconBullseye */],
    BIconCalculator: __WEBPACK_IMPORTED_MODULE_3__icons__["_175" /* BIconCalculator */],
    BIconCalculatorFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_176" /* BIconCalculatorFill */],
    BIconCalendar: __WEBPACK_IMPORTED_MODULE_3__icons__["_177" /* BIconCalendar */],
    BIconCalendar2: __WEBPACK_IMPORTED_MODULE_3__icons__["_178" /* BIconCalendar2 */],
    BIconCalendar2Check: __WEBPACK_IMPORTED_MODULE_3__icons__["_179" /* BIconCalendar2Check */],
    BIconCalendar2CheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_180" /* BIconCalendar2CheckFill */],
    BIconCalendar2Date: __WEBPACK_IMPORTED_MODULE_3__icons__["_181" /* BIconCalendar2Date */],
    BIconCalendar2DateFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_182" /* BIconCalendar2DateFill */],
    BIconCalendar2Day: __WEBPACK_IMPORTED_MODULE_3__icons__["_183" /* BIconCalendar2Day */],
    BIconCalendar2DayFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_184" /* BIconCalendar2DayFill */],
    BIconCalendar2Event: __WEBPACK_IMPORTED_MODULE_3__icons__["_185" /* BIconCalendar2Event */],
    BIconCalendar2EventFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_186" /* BIconCalendar2EventFill */],
    BIconCalendar2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_187" /* BIconCalendar2Fill */],
    BIconCalendar2Minus: __WEBPACK_IMPORTED_MODULE_3__icons__["_188" /* BIconCalendar2Minus */],
    BIconCalendar2MinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_189" /* BIconCalendar2MinusFill */],
    BIconCalendar2Month: __WEBPACK_IMPORTED_MODULE_3__icons__["_190" /* BIconCalendar2Month */],
    BIconCalendar2MonthFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_191" /* BIconCalendar2MonthFill */],
    BIconCalendar2Plus: __WEBPACK_IMPORTED_MODULE_3__icons__["_192" /* BIconCalendar2Plus */],
    BIconCalendar2PlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_193" /* BIconCalendar2PlusFill */],
    BIconCalendar2Range: __WEBPACK_IMPORTED_MODULE_3__icons__["_194" /* BIconCalendar2Range */],
    BIconCalendar2RangeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_195" /* BIconCalendar2RangeFill */],
    BIconCalendar2Week: __WEBPACK_IMPORTED_MODULE_3__icons__["_196" /* BIconCalendar2Week */],
    BIconCalendar2WeekFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_197" /* BIconCalendar2WeekFill */],
    BIconCalendar2X: __WEBPACK_IMPORTED_MODULE_3__icons__["_198" /* BIconCalendar2X */],
    BIconCalendar2XFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_199" /* BIconCalendar2XFill */],
    BIconCalendar3: __WEBPACK_IMPORTED_MODULE_3__icons__["_200" /* BIconCalendar3 */],
    BIconCalendar3Event: __WEBPACK_IMPORTED_MODULE_3__icons__["_201" /* BIconCalendar3Event */],
    BIconCalendar3EventFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_202" /* BIconCalendar3EventFill */],
    BIconCalendar3Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_203" /* BIconCalendar3Fill */],
    BIconCalendar3Range: __WEBPACK_IMPORTED_MODULE_3__icons__["_204" /* BIconCalendar3Range */],
    BIconCalendar3RangeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_205" /* BIconCalendar3RangeFill */],
    BIconCalendar3Week: __WEBPACK_IMPORTED_MODULE_3__icons__["_206" /* BIconCalendar3Week */],
    BIconCalendar3WeekFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_207" /* BIconCalendar3WeekFill */],
    BIconCalendar4: __WEBPACK_IMPORTED_MODULE_3__icons__["_208" /* BIconCalendar4 */],
    BIconCalendar4Event: __WEBPACK_IMPORTED_MODULE_3__icons__["_209" /* BIconCalendar4Event */],
    BIconCalendar4Range: __WEBPACK_IMPORTED_MODULE_3__icons__["_210" /* BIconCalendar4Range */],
    BIconCalendar4Week: __WEBPACK_IMPORTED_MODULE_3__icons__["_211" /* BIconCalendar4Week */],
    BIconCalendarCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_212" /* BIconCalendarCheck */],
    BIconCalendarCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_213" /* BIconCalendarCheckFill */],
    BIconCalendarDate: __WEBPACK_IMPORTED_MODULE_3__icons__["_214" /* BIconCalendarDate */],
    BIconCalendarDateFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_215" /* BIconCalendarDateFill */],
    BIconCalendarDay: __WEBPACK_IMPORTED_MODULE_3__icons__["_216" /* BIconCalendarDay */],
    BIconCalendarDayFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_217" /* BIconCalendarDayFill */],
    BIconCalendarEvent: __WEBPACK_IMPORTED_MODULE_3__icons__["_218" /* BIconCalendarEvent */],
    BIconCalendarEventFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_219" /* BIconCalendarEventFill */],
    BIconCalendarFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_220" /* BIconCalendarFill */],
    BIconCalendarMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_221" /* BIconCalendarMinus */],
    BIconCalendarMinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_222" /* BIconCalendarMinusFill */],
    BIconCalendarMonth: __WEBPACK_IMPORTED_MODULE_3__icons__["_223" /* BIconCalendarMonth */],
    BIconCalendarMonthFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_224" /* BIconCalendarMonthFill */],
    BIconCalendarPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_225" /* BIconCalendarPlus */],
    BIconCalendarPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_226" /* BIconCalendarPlusFill */],
    BIconCalendarRange: __WEBPACK_IMPORTED_MODULE_3__icons__["_227" /* BIconCalendarRange */],
    BIconCalendarRangeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_228" /* BIconCalendarRangeFill */],
    BIconCalendarWeek: __WEBPACK_IMPORTED_MODULE_3__icons__["_229" /* BIconCalendarWeek */],
    BIconCalendarWeekFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_230" /* BIconCalendarWeekFill */],
    BIconCalendarX: __WEBPACK_IMPORTED_MODULE_3__icons__["_231" /* BIconCalendarX */],
    BIconCalendarXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_232" /* BIconCalendarXFill */],
    BIconCamera: __WEBPACK_IMPORTED_MODULE_3__icons__["_233" /* BIconCamera */],
    BIconCamera2: __WEBPACK_IMPORTED_MODULE_3__icons__["_234" /* BIconCamera2 */],
    BIconCameraFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_235" /* BIconCameraFill */],
    BIconCameraReels: __WEBPACK_IMPORTED_MODULE_3__icons__["_236" /* BIconCameraReels */],
    BIconCameraReelsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_237" /* BIconCameraReelsFill */],
    BIconCameraVideo: __WEBPACK_IMPORTED_MODULE_3__icons__["_238" /* BIconCameraVideo */],
    BIconCameraVideoFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_239" /* BIconCameraVideoFill */],
    BIconCameraVideoOff: __WEBPACK_IMPORTED_MODULE_3__icons__["_240" /* BIconCameraVideoOff */],
    BIconCameraVideoOffFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_241" /* BIconCameraVideoOffFill */],
    BIconCapslock: __WEBPACK_IMPORTED_MODULE_3__icons__["_242" /* BIconCapslock */],
    BIconCapslockFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_243" /* BIconCapslockFill */],
    BIconCardChecklist: __WEBPACK_IMPORTED_MODULE_3__icons__["_244" /* BIconCardChecklist */],
    BIconCardHeading: __WEBPACK_IMPORTED_MODULE_3__icons__["_245" /* BIconCardHeading */],
    BIconCardImage: __WEBPACK_IMPORTED_MODULE_3__icons__["_246" /* BIconCardImage */],
    BIconCardList: __WEBPACK_IMPORTED_MODULE_3__icons__["_247" /* BIconCardList */],
    BIconCardText: __WEBPACK_IMPORTED_MODULE_3__icons__["_248" /* BIconCardText */],
    BIconCaretDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_249" /* BIconCaretDown */],
    BIconCaretDownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_250" /* BIconCaretDownFill */],
    BIconCaretDownSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_251" /* BIconCaretDownSquare */],
    BIconCaretDownSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_252" /* BIconCaretDownSquareFill */],
    BIconCaretLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_253" /* BIconCaretLeft */],
    BIconCaretLeftFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_254" /* BIconCaretLeftFill */],
    BIconCaretLeftSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_255" /* BIconCaretLeftSquare */],
    BIconCaretLeftSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_256" /* BIconCaretLeftSquareFill */],
    BIconCaretRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_257" /* BIconCaretRight */],
    BIconCaretRightFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_258" /* BIconCaretRightFill */],
    BIconCaretRightSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_259" /* BIconCaretRightSquare */],
    BIconCaretRightSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_260" /* BIconCaretRightSquareFill */],
    BIconCaretUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_261" /* BIconCaretUp */],
    BIconCaretUpFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_262" /* BIconCaretUpFill */],
    BIconCaretUpSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_263" /* BIconCaretUpSquare */],
    BIconCaretUpSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_264" /* BIconCaretUpSquareFill */],
    BIconCart: __WEBPACK_IMPORTED_MODULE_3__icons__["_265" /* BIconCart */],
    BIconCart2: __WEBPACK_IMPORTED_MODULE_3__icons__["_266" /* BIconCart2 */],
    BIconCart3: __WEBPACK_IMPORTED_MODULE_3__icons__["_267" /* BIconCart3 */],
    BIconCart4: __WEBPACK_IMPORTED_MODULE_3__icons__["_268" /* BIconCart4 */],
    BIconCartCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_269" /* BIconCartCheck */],
    BIconCartCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_270" /* BIconCartCheckFill */],
    BIconCartDash: __WEBPACK_IMPORTED_MODULE_3__icons__["_271" /* BIconCartDash */],
    BIconCartDashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_272" /* BIconCartDashFill */],
    BIconCartFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_273" /* BIconCartFill */],
    BIconCartPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_274" /* BIconCartPlus */],
    BIconCartPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_275" /* BIconCartPlusFill */],
    BIconCartX: __WEBPACK_IMPORTED_MODULE_3__icons__["_276" /* BIconCartX */],
    BIconCartXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_277" /* BIconCartXFill */],
    BIconCash: __WEBPACK_IMPORTED_MODULE_3__icons__["_278" /* BIconCash */],
    BIconCashCoin: __WEBPACK_IMPORTED_MODULE_3__icons__["_279" /* BIconCashCoin */],
    BIconCashStack: __WEBPACK_IMPORTED_MODULE_3__icons__["_280" /* BIconCashStack */],
    BIconCast: __WEBPACK_IMPORTED_MODULE_3__icons__["_281" /* BIconCast */],
    BIconChat: __WEBPACK_IMPORTED_MODULE_3__icons__["_282" /* BIconChat */],
    BIconChatDots: __WEBPACK_IMPORTED_MODULE_3__icons__["_283" /* BIconChatDots */],
    BIconChatDotsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_284" /* BIconChatDotsFill */],
    BIconChatFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_285" /* BIconChatFill */],
    BIconChatLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_286" /* BIconChatLeft */],
    BIconChatLeftDots: __WEBPACK_IMPORTED_MODULE_3__icons__["_287" /* BIconChatLeftDots */],
    BIconChatLeftDotsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_288" /* BIconChatLeftDotsFill */],
    BIconChatLeftFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_289" /* BIconChatLeftFill */],
    BIconChatLeftQuote: __WEBPACK_IMPORTED_MODULE_3__icons__["_290" /* BIconChatLeftQuote */],
    BIconChatLeftQuoteFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_291" /* BIconChatLeftQuoteFill */],
    BIconChatLeftText: __WEBPACK_IMPORTED_MODULE_3__icons__["_292" /* BIconChatLeftText */],
    BIconChatLeftTextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_293" /* BIconChatLeftTextFill */],
    BIconChatQuote: __WEBPACK_IMPORTED_MODULE_3__icons__["_294" /* BIconChatQuote */],
    BIconChatQuoteFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_295" /* BIconChatQuoteFill */],
    BIconChatRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_296" /* BIconChatRight */],
    BIconChatRightDots: __WEBPACK_IMPORTED_MODULE_3__icons__["_297" /* BIconChatRightDots */],
    BIconChatRightDotsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_298" /* BIconChatRightDotsFill */],
    BIconChatRightFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_299" /* BIconChatRightFill */],
    BIconChatRightQuote: __WEBPACK_IMPORTED_MODULE_3__icons__["_300" /* BIconChatRightQuote */],
    BIconChatRightQuoteFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_301" /* BIconChatRightQuoteFill */],
    BIconChatRightText: __WEBPACK_IMPORTED_MODULE_3__icons__["_302" /* BIconChatRightText */],
    BIconChatRightTextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_303" /* BIconChatRightTextFill */],
    BIconChatSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_304" /* BIconChatSquare */],
    BIconChatSquareDots: __WEBPACK_IMPORTED_MODULE_3__icons__["_305" /* BIconChatSquareDots */],
    BIconChatSquareDotsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_306" /* BIconChatSquareDotsFill */],
    BIconChatSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_307" /* BIconChatSquareFill */],
    BIconChatSquareQuote: __WEBPACK_IMPORTED_MODULE_3__icons__["_308" /* BIconChatSquareQuote */],
    BIconChatSquareQuoteFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_309" /* BIconChatSquareQuoteFill */],
    BIconChatSquareText: __WEBPACK_IMPORTED_MODULE_3__icons__["_310" /* BIconChatSquareText */],
    BIconChatSquareTextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_311" /* BIconChatSquareTextFill */],
    BIconChatText: __WEBPACK_IMPORTED_MODULE_3__icons__["_312" /* BIconChatText */],
    BIconChatTextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_313" /* BIconChatTextFill */],
    BIconCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_314" /* BIconCheck */],
    BIconCheck2: __WEBPACK_IMPORTED_MODULE_3__icons__["_315" /* BIconCheck2 */],
    BIconCheck2All: __WEBPACK_IMPORTED_MODULE_3__icons__["_316" /* BIconCheck2All */],
    BIconCheck2Circle: __WEBPACK_IMPORTED_MODULE_3__icons__["_317" /* BIconCheck2Circle */],
    BIconCheck2Square: __WEBPACK_IMPORTED_MODULE_3__icons__["_318" /* BIconCheck2Square */],
    BIconCheckAll: __WEBPACK_IMPORTED_MODULE_3__icons__["_319" /* BIconCheckAll */],
    BIconCheckCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_320" /* BIconCheckCircle */],
    BIconCheckCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_321" /* BIconCheckCircleFill */],
    BIconCheckLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_322" /* BIconCheckLg */],
    BIconCheckSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_323" /* BIconCheckSquare */],
    BIconCheckSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_324" /* BIconCheckSquareFill */],
    BIconChevronBarContract: __WEBPACK_IMPORTED_MODULE_3__icons__["_325" /* BIconChevronBarContract */],
    BIconChevronBarDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_326" /* BIconChevronBarDown */],
    BIconChevronBarExpand: __WEBPACK_IMPORTED_MODULE_3__icons__["_327" /* BIconChevronBarExpand */],
    BIconChevronBarLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_328" /* BIconChevronBarLeft */],
    BIconChevronBarRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_329" /* BIconChevronBarRight */],
    BIconChevronBarUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_330" /* BIconChevronBarUp */],
    BIconChevronCompactDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_331" /* BIconChevronCompactDown */],
    BIconChevronCompactLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_332" /* BIconChevronCompactLeft */],
    BIconChevronCompactRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_333" /* BIconChevronCompactRight */],
    BIconChevronCompactUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_334" /* BIconChevronCompactUp */],
    BIconChevronContract: __WEBPACK_IMPORTED_MODULE_3__icons__["_335" /* BIconChevronContract */],
    BIconChevronDoubleDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_336" /* BIconChevronDoubleDown */],
    BIconChevronDoubleLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_337" /* BIconChevronDoubleLeft */],
    BIconChevronDoubleRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_338" /* BIconChevronDoubleRight */],
    BIconChevronDoubleUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_339" /* BIconChevronDoubleUp */],
    BIconChevronDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_340" /* BIconChevronDown */],
    BIconChevronExpand: __WEBPACK_IMPORTED_MODULE_3__icons__["_341" /* BIconChevronExpand */],
    BIconChevronLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_342" /* BIconChevronLeft */],
    BIconChevronRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_343" /* BIconChevronRight */],
    BIconChevronUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_344" /* BIconChevronUp */],
    BIconCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_345" /* BIconCircle */],
    BIconCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_346" /* BIconCircleFill */],
    BIconCircleHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_347" /* BIconCircleHalf */],
    BIconCircleSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_348" /* BIconCircleSquare */],
    BIconClipboard: __WEBPACK_IMPORTED_MODULE_3__icons__["_349" /* BIconClipboard */],
    BIconClipboardCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_350" /* BIconClipboardCheck */],
    BIconClipboardData: __WEBPACK_IMPORTED_MODULE_3__icons__["_351" /* BIconClipboardData */],
    BIconClipboardMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_352" /* BIconClipboardMinus */],
    BIconClipboardPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_353" /* BIconClipboardPlus */],
    BIconClipboardX: __WEBPACK_IMPORTED_MODULE_3__icons__["_354" /* BIconClipboardX */],
    BIconClock: __WEBPACK_IMPORTED_MODULE_3__icons__["_355" /* BIconClock */],
    BIconClockFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_356" /* BIconClockFill */],
    BIconClockHistory: __WEBPACK_IMPORTED_MODULE_3__icons__["_357" /* BIconClockHistory */],
    BIconCloud: __WEBPACK_IMPORTED_MODULE_3__icons__["_358" /* BIconCloud */],
    BIconCloudArrowDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_359" /* BIconCloudArrowDown */],
    BIconCloudArrowDownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_360" /* BIconCloudArrowDownFill */],
    BIconCloudArrowUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_361" /* BIconCloudArrowUp */],
    BIconCloudArrowUpFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_362" /* BIconCloudArrowUpFill */],
    BIconCloudCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_363" /* BIconCloudCheck */],
    BIconCloudCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_364" /* BIconCloudCheckFill */],
    BIconCloudDownload: __WEBPACK_IMPORTED_MODULE_3__icons__["_365" /* BIconCloudDownload */],
    BIconCloudDownloadFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_366" /* BIconCloudDownloadFill */],
    BIconCloudDrizzle: __WEBPACK_IMPORTED_MODULE_3__icons__["_367" /* BIconCloudDrizzle */],
    BIconCloudDrizzleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_368" /* BIconCloudDrizzleFill */],
    BIconCloudFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_369" /* BIconCloudFill */],
    BIconCloudFog: __WEBPACK_IMPORTED_MODULE_3__icons__["_370" /* BIconCloudFog */],
    BIconCloudFog2: __WEBPACK_IMPORTED_MODULE_3__icons__["_371" /* BIconCloudFog2 */],
    BIconCloudFog2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_372" /* BIconCloudFog2Fill */],
    BIconCloudFogFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_373" /* BIconCloudFogFill */],
    BIconCloudHail: __WEBPACK_IMPORTED_MODULE_3__icons__["_374" /* BIconCloudHail */],
    BIconCloudHailFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_375" /* BIconCloudHailFill */],
    BIconCloudHaze: __WEBPACK_IMPORTED_MODULE_3__icons__["_376" /* BIconCloudHaze */],
    BIconCloudHaze1: __WEBPACK_IMPORTED_MODULE_3__icons__["_377" /* BIconCloudHaze1 */],
    BIconCloudHaze2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_378" /* BIconCloudHaze2Fill */],
    BIconCloudHazeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_379" /* BIconCloudHazeFill */],
    BIconCloudLightning: __WEBPACK_IMPORTED_MODULE_3__icons__["_380" /* BIconCloudLightning */],
    BIconCloudLightningFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_381" /* BIconCloudLightningFill */],
    BIconCloudLightningRain: __WEBPACK_IMPORTED_MODULE_3__icons__["_382" /* BIconCloudLightningRain */],
    BIconCloudLightningRainFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_383" /* BIconCloudLightningRainFill */],
    BIconCloudMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_384" /* BIconCloudMinus */],
    BIconCloudMinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_385" /* BIconCloudMinusFill */],
    BIconCloudMoon: __WEBPACK_IMPORTED_MODULE_3__icons__["_386" /* BIconCloudMoon */],
    BIconCloudMoonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_387" /* BIconCloudMoonFill */],
    BIconCloudPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_388" /* BIconCloudPlus */],
    BIconCloudPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_389" /* BIconCloudPlusFill */],
    BIconCloudRain: __WEBPACK_IMPORTED_MODULE_3__icons__["_390" /* BIconCloudRain */],
    BIconCloudRainFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_391" /* BIconCloudRainFill */],
    BIconCloudRainHeavy: __WEBPACK_IMPORTED_MODULE_3__icons__["_392" /* BIconCloudRainHeavy */],
    BIconCloudRainHeavyFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_393" /* BIconCloudRainHeavyFill */],
    BIconCloudSlash: __WEBPACK_IMPORTED_MODULE_3__icons__["_394" /* BIconCloudSlash */],
    BIconCloudSlashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_395" /* BIconCloudSlashFill */],
    BIconCloudSleet: __WEBPACK_IMPORTED_MODULE_3__icons__["_396" /* BIconCloudSleet */],
    BIconCloudSleetFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_397" /* BIconCloudSleetFill */],
    BIconCloudSnow: __WEBPACK_IMPORTED_MODULE_3__icons__["_398" /* BIconCloudSnow */],
    BIconCloudSnowFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_399" /* BIconCloudSnowFill */],
    BIconCloudSun: __WEBPACK_IMPORTED_MODULE_3__icons__["_400" /* BIconCloudSun */],
    BIconCloudSunFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_401" /* BIconCloudSunFill */],
    BIconCloudUpload: __WEBPACK_IMPORTED_MODULE_3__icons__["_402" /* BIconCloudUpload */],
    BIconCloudUploadFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_403" /* BIconCloudUploadFill */],
    BIconClouds: __WEBPACK_IMPORTED_MODULE_3__icons__["_404" /* BIconClouds */],
    BIconCloudsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_405" /* BIconCloudsFill */],
    BIconCloudy: __WEBPACK_IMPORTED_MODULE_3__icons__["_406" /* BIconCloudy */],
    BIconCloudyFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_407" /* BIconCloudyFill */],
    BIconCode: __WEBPACK_IMPORTED_MODULE_3__icons__["_408" /* BIconCode */],
    BIconCodeSlash: __WEBPACK_IMPORTED_MODULE_3__icons__["_409" /* BIconCodeSlash */],
    BIconCodeSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_410" /* BIconCodeSquare */],
    BIconCoin: __WEBPACK_IMPORTED_MODULE_3__icons__["_411" /* BIconCoin */],
    BIconCollection: __WEBPACK_IMPORTED_MODULE_3__icons__["_412" /* BIconCollection */],
    BIconCollectionFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_413" /* BIconCollectionFill */],
    BIconCollectionPlay: __WEBPACK_IMPORTED_MODULE_3__icons__["_414" /* BIconCollectionPlay */],
    BIconCollectionPlayFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_415" /* BIconCollectionPlayFill */],
    BIconColumns: __WEBPACK_IMPORTED_MODULE_3__icons__["_416" /* BIconColumns */],
    BIconColumnsGap: __WEBPACK_IMPORTED_MODULE_3__icons__["_417" /* BIconColumnsGap */],
    BIconCommand: __WEBPACK_IMPORTED_MODULE_3__icons__["_418" /* BIconCommand */],
    BIconCompass: __WEBPACK_IMPORTED_MODULE_3__icons__["_419" /* BIconCompass */],
    BIconCompassFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_420" /* BIconCompassFill */],
    BIconCone: __WEBPACK_IMPORTED_MODULE_3__icons__["_421" /* BIconCone */],
    BIconConeStriped: __WEBPACK_IMPORTED_MODULE_3__icons__["_422" /* BIconConeStriped */],
    BIconController: __WEBPACK_IMPORTED_MODULE_3__icons__["_423" /* BIconController */],
    BIconCpu: __WEBPACK_IMPORTED_MODULE_3__icons__["_424" /* BIconCpu */],
    BIconCpuFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_425" /* BIconCpuFill */],
    BIconCreditCard: __WEBPACK_IMPORTED_MODULE_3__icons__["_426" /* BIconCreditCard */],
    BIconCreditCard2Back: __WEBPACK_IMPORTED_MODULE_3__icons__["_427" /* BIconCreditCard2Back */],
    BIconCreditCard2BackFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_428" /* BIconCreditCard2BackFill */],
    BIconCreditCard2Front: __WEBPACK_IMPORTED_MODULE_3__icons__["_429" /* BIconCreditCard2Front */],
    BIconCreditCard2FrontFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_430" /* BIconCreditCard2FrontFill */],
    BIconCreditCardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_431" /* BIconCreditCardFill */],
    BIconCrop: __WEBPACK_IMPORTED_MODULE_3__icons__["_432" /* BIconCrop */],
    BIconCup: __WEBPACK_IMPORTED_MODULE_3__icons__["_433" /* BIconCup */],
    BIconCupFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_434" /* BIconCupFill */],
    BIconCupStraw: __WEBPACK_IMPORTED_MODULE_3__icons__["_435" /* BIconCupStraw */],
    BIconCurrencyBitcoin: __WEBPACK_IMPORTED_MODULE_3__icons__["_436" /* BIconCurrencyBitcoin */],
    BIconCurrencyDollar: __WEBPACK_IMPORTED_MODULE_3__icons__["_437" /* BIconCurrencyDollar */],
    BIconCurrencyEuro: __WEBPACK_IMPORTED_MODULE_3__icons__["_438" /* BIconCurrencyEuro */],
    BIconCurrencyExchange: __WEBPACK_IMPORTED_MODULE_3__icons__["_439" /* BIconCurrencyExchange */],
    BIconCurrencyPound: __WEBPACK_IMPORTED_MODULE_3__icons__["_440" /* BIconCurrencyPound */],
    BIconCurrencyYen: __WEBPACK_IMPORTED_MODULE_3__icons__["_441" /* BIconCurrencyYen */],
    BIconCursor: __WEBPACK_IMPORTED_MODULE_3__icons__["_442" /* BIconCursor */],
    BIconCursorFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_443" /* BIconCursorFill */],
    BIconCursorText: __WEBPACK_IMPORTED_MODULE_3__icons__["_444" /* BIconCursorText */],
    BIconDash: __WEBPACK_IMPORTED_MODULE_3__icons__["_445" /* BIconDash */],
    BIconDashCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_446" /* BIconDashCircle */],
    BIconDashCircleDotted: __WEBPACK_IMPORTED_MODULE_3__icons__["_447" /* BIconDashCircleDotted */],
    BIconDashCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_448" /* BIconDashCircleFill */],
    BIconDashLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_449" /* BIconDashLg */],
    BIconDashSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_450" /* BIconDashSquare */],
    BIconDashSquareDotted: __WEBPACK_IMPORTED_MODULE_3__icons__["_451" /* BIconDashSquareDotted */],
    BIconDashSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_452" /* BIconDashSquareFill */],
    BIconDiagram2: __WEBPACK_IMPORTED_MODULE_3__icons__["_453" /* BIconDiagram2 */],
    BIconDiagram2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_454" /* BIconDiagram2Fill */],
    BIconDiagram3: __WEBPACK_IMPORTED_MODULE_3__icons__["_455" /* BIconDiagram3 */],
    BIconDiagram3Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_456" /* BIconDiagram3Fill */],
    BIconDiamond: __WEBPACK_IMPORTED_MODULE_3__icons__["_457" /* BIconDiamond */],
    BIconDiamondFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_458" /* BIconDiamondFill */],
    BIconDiamondHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_459" /* BIconDiamondHalf */],
    BIconDice1: __WEBPACK_IMPORTED_MODULE_3__icons__["_460" /* BIconDice1 */],
    BIconDice1Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_461" /* BIconDice1Fill */],
    BIconDice2: __WEBPACK_IMPORTED_MODULE_3__icons__["_462" /* BIconDice2 */],
    BIconDice2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_463" /* BIconDice2Fill */],
    BIconDice3: __WEBPACK_IMPORTED_MODULE_3__icons__["_464" /* BIconDice3 */],
    BIconDice3Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_465" /* BIconDice3Fill */],
    BIconDice4: __WEBPACK_IMPORTED_MODULE_3__icons__["_466" /* BIconDice4 */],
    BIconDice4Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_467" /* BIconDice4Fill */],
    BIconDice5: __WEBPACK_IMPORTED_MODULE_3__icons__["_468" /* BIconDice5 */],
    BIconDice5Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_469" /* BIconDice5Fill */],
    BIconDice6: __WEBPACK_IMPORTED_MODULE_3__icons__["_470" /* BIconDice6 */],
    BIconDice6Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_471" /* BIconDice6Fill */],
    BIconDisc: __WEBPACK_IMPORTED_MODULE_3__icons__["_472" /* BIconDisc */],
    BIconDiscFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_473" /* BIconDiscFill */],
    BIconDiscord: __WEBPACK_IMPORTED_MODULE_3__icons__["_474" /* BIconDiscord */],
    BIconDisplay: __WEBPACK_IMPORTED_MODULE_3__icons__["_475" /* BIconDisplay */],
    BIconDisplayFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_476" /* BIconDisplayFill */],
    BIconDistributeHorizontal: __WEBPACK_IMPORTED_MODULE_3__icons__["_477" /* BIconDistributeHorizontal */],
    BIconDistributeVertical: __WEBPACK_IMPORTED_MODULE_3__icons__["_478" /* BIconDistributeVertical */],
    BIconDoorClosed: __WEBPACK_IMPORTED_MODULE_3__icons__["_479" /* BIconDoorClosed */],
    BIconDoorClosedFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_480" /* BIconDoorClosedFill */],
    BIconDoorOpen: __WEBPACK_IMPORTED_MODULE_3__icons__["_481" /* BIconDoorOpen */],
    BIconDoorOpenFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_482" /* BIconDoorOpenFill */],
    BIconDot: __WEBPACK_IMPORTED_MODULE_3__icons__["_483" /* BIconDot */],
    BIconDownload: __WEBPACK_IMPORTED_MODULE_3__icons__["_484" /* BIconDownload */],
    BIconDroplet: __WEBPACK_IMPORTED_MODULE_3__icons__["_485" /* BIconDroplet */],
    BIconDropletFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_486" /* BIconDropletFill */],
    BIconDropletHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_487" /* BIconDropletHalf */],
    BIconEarbuds: __WEBPACK_IMPORTED_MODULE_3__icons__["_488" /* BIconEarbuds */],
    BIconEasel: __WEBPACK_IMPORTED_MODULE_3__icons__["_489" /* BIconEasel */],
    BIconEaselFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_490" /* BIconEaselFill */],
    BIconEgg: __WEBPACK_IMPORTED_MODULE_3__icons__["_491" /* BIconEgg */],
    BIconEggFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_492" /* BIconEggFill */],
    BIconEggFried: __WEBPACK_IMPORTED_MODULE_3__icons__["_493" /* BIconEggFried */],
    BIconEject: __WEBPACK_IMPORTED_MODULE_3__icons__["_494" /* BIconEject */],
    BIconEjectFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_495" /* BIconEjectFill */],
    BIconEmojiAngry: __WEBPACK_IMPORTED_MODULE_3__icons__["_496" /* BIconEmojiAngry */],
    BIconEmojiAngryFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_497" /* BIconEmojiAngryFill */],
    BIconEmojiDizzy: __WEBPACK_IMPORTED_MODULE_3__icons__["_498" /* BIconEmojiDizzy */],
    BIconEmojiDizzyFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_499" /* BIconEmojiDizzyFill */],
    BIconEmojiExpressionless: __WEBPACK_IMPORTED_MODULE_3__icons__["_500" /* BIconEmojiExpressionless */],
    BIconEmojiExpressionlessFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_501" /* BIconEmojiExpressionlessFill */],
    BIconEmojiFrown: __WEBPACK_IMPORTED_MODULE_3__icons__["_502" /* BIconEmojiFrown */],
    BIconEmojiFrownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_503" /* BIconEmojiFrownFill */],
    BIconEmojiHeartEyes: __WEBPACK_IMPORTED_MODULE_3__icons__["_504" /* BIconEmojiHeartEyes */],
    BIconEmojiHeartEyesFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_505" /* BIconEmojiHeartEyesFill */],
    BIconEmojiLaughing: __WEBPACK_IMPORTED_MODULE_3__icons__["_506" /* BIconEmojiLaughing */],
    BIconEmojiLaughingFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_507" /* BIconEmojiLaughingFill */],
    BIconEmojiNeutral: __WEBPACK_IMPORTED_MODULE_3__icons__["_508" /* BIconEmojiNeutral */],
    BIconEmojiNeutralFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_509" /* BIconEmojiNeutralFill */],
    BIconEmojiSmile: __WEBPACK_IMPORTED_MODULE_3__icons__["_510" /* BIconEmojiSmile */],
    BIconEmojiSmileFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_511" /* BIconEmojiSmileFill */],
    BIconEmojiSmileUpsideDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_512" /* BIconEmojiSmileUpsideDown */],
    BIconEmojiSmileUpsideDownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_513" /* BIconEmojiSmileUpsideDownFill */],
    BIconEmojiSunglasses: __WEBPACK_IMPORTED_MODULE_3__icons__["_514" /* BIconEmojiSunglasses */],
    BIconEmojiSunglassesFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_515" /* BIconEmojiSunglassesFill */],
    BIconEmojiWink: __WEBPACK_IMPORTED_MODULE_3__icons__["_516" /* BIconEmojiWink */],
    BIconEmojiWinkFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_517" /* BIconEmojiWinkFill */],
    BIconEnvelope: __WEBPACK_IMPORTED_MODULE_3__icons__["_518" /* BIconEnvelope */],
    BIconEnvelopeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_519" /* BIconEnvelopeFill */],
    BIconEnvelopeOpen: __WEBPACK_IMPORTED_MODULE_3__icons__["_520" /* BIconEnvelopeOpen */],
    BIconEnvelopeOpenFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_521" /* BIconEnvelopeOpenFill */],
    BIconEraser: __WEBPACK_IMPORTED_MODULE_3__icons__["_522" /* BIconEraser */],
    BIconEraserFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_523" /* BIconEraserFill */],
    BIconExclamation: __WEBPACK_IMPORTED_MODULE_3__icons__["_524" /* BIconExclamation */],
    BIconExclamationCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_525" /* BIconExclamationCircle */],
    BIconExclamationCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_526" /* BIconExclamationCircleFill */],
    BIconExclamationDiamond: __WEBPACK_IMPORTED_MODULE_3__icons__["_527" /* BIconExclamationDiamond */],
    BIconExclamationDiamondFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_528" /* BIconExclamationDiamondFill */],
    BIconExclamationLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_529" /* BIconExclamationLg */],
    BIconExclamationOctagon: __WEBPACK_IMPORTED_MODULE_3__icons__["_530" /* BIconExclamationOctagon */],
    BIconExclamationOctagonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_531" /* BIconExclamationOctagonFill */],
    BIconExclamationSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_532" /* BIconExclamationSquare */],
    BIconExclamationSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_533" /* BIconExclamationSquareFill */],
    BIconExclamationTriangle: __WEBPACK_IMPORTED_MODULE_3__icons__["_534" /* BIconExclamationTriangle */],
    BIconExclamationTriangleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_535" /* BIconExclamationTriangleFill */],
    BIconExclude: __WEBPACK_IMPORTED_MODULE_3__icons__["_536" /* BIconExclude */],
    BIconEye: __WEBPACK_IMPORTED_MODULE_3__icons__["_537" /* BIconEye */],
    BIconEyeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_538" /* BIconEyeFill */],
    BIconEyeSlash: __WEBPACK_IMPORTED_MODULE_3__icons__["_539" /* BIconEyeSlash */],
    BIconEyeSlashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_540" /* BIconEyeSlashFill */],
    BIconEyedropper: __WEBPACK_IMPORTED_MODULE_3__icons__["_541" /* BIconEyedropper */],
    BIconEyeglasses: __WEBPACK_IMPORTED_MODULE_3__icons__["_542" /* BIconEyeglasses */],
    BIconFacebook: __WEBPACK_IMPORTED_MODULE_3__icons__["_543" /* BIconFacebook */],
    BIconFile: __WEBPACK_IMPORTED_MODULE_3__icons__["_544" /* BIconFile */],
    BIconFileArrowDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_545" /* BIconFileArrowDown */],
    BIconFileArrowDownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_546" /* BIconFileArrowDownFill */],
    BIconFileArrowUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_547" /* BIconFileArrowUp */],
    BIconFileArrowUpFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_548" /* BIconFileArrowUpFill */],
    BIconFileBarGraph: __WEBPACK_IMPORTED_MODULE_3__icons__["_549" /* BIconFileBarGraph */],
    BIconFileBarGraphFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_550" /* BIconFileBarGraphFill */],
    BIconFileBinary: __WEBPACK_IMPORTED_MODULE_3__icons__["_551" /* BIconFileBinary */],
    BIconFileBinaryFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_552" /* BIconFileBinaryFill */],
    BIconFileBreak: __WEBPACK_IMPORTED_MODULE_3__icons__["_553" /* BIconFileBreak */],
    BIconFileBreakFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_554" /* BIconFileBreakFill */],
    BIconFileCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_555" /* BIconFileCheck */],
    BIconFileCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_556" /* BIconFileCheckFill */],
    BIconFileCode: __WEBPACK_IMPORTED_MODULE_3__icons__["_557" /* BIconFileCode */],
    BIconFileCodeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_558" /* BIconFileCodeFill */],
    BIconFileDiff: __WEBPACK_IMPORTED_MODULE_3__icons__["_559" /* BIconFileDiff */],
    BIconFileDiffFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_560" /* BIconFileDiffFill */],
    BIconFileEarmark: __WEBPACK_IMPORTED_MODULE_3__icons__["_561" /* BIconFileEarmark */],
    BIconFileEarmarkArrowDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_562" /* BIconFileEarmarkArrowDown */],
    BIconFileEarmarkArrowDownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_563" /* BIconFileEarmarkArrowDownFill */],
    BIconFileEarmarkArrowUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_564" /* BIconFileEarmarkArrowUp */],
    BIconFileEarmarkArrowUpFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_565" /* BIconFileEarmarkArrowUpFill */],
    BIconFileEarmarkBarGraph: __WEBPACK_IMPORTED_MODULE_3__icons__["_566" /* BIconFileEarmarkBarGraph */],
    BIconFileEarmarkBarGraphFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_567" /* BIconFileEarmarkBarGraphFill */],
    BIconFileEarmarkBinary: __WEBPACK_IMPORTED_MODULE_3__icons__["_568" /* BIconFileEarmarkBinary */],
    BIconFileEarmarkBinaryFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_569" /* BIconFileEarmarkBinaryFill */],
    BIconFileEarmarkBreak: __WEBPACK_IMPORTED_MODULE_3__icons__["_570" /* BIconFileEarmarkBreak */],
    BIconFileEarmarkBreakFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_571" /* BIconFileEarmarkBreakFill */],
    BIconFileEarmarkCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_572" /* BIconFileEarmarkCheck */],
    BIconFileEarmarkCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_573" /* BIconFileEarmarkCheckFill */],
    BIconFileEarmarkCode: __WEBPACK_IMPORTED_MODULE_3__icons__["_574" /* BIconFileEarmarkCode */],
    BIconFileEarmarkCodeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_575" /* BIconFileEarmarkCodeFill */],
    BIconFileEarmarkDiff: __WEBPACK_IMPORTED_MODULE_3__icons__["_576" /* BIconFileEarmarkDiff */],
    BIconFileEarmarkDiffFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_577" /* BIconFileEarmarkDiffFill */],
    BIconFileEarmarkEasel: __WEBPACK_IMPORTED_MODULE_3__icons__["_578" /* BIconFileEarmarkEasel */],
    BIconFileEarmarkEaselFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_579" /* BIconFileEarmarkEaselFill */],
    BIconFileEarmarkExcel: __WEBPACK_IMPORTED_MODULE_3__icons__["_580" /* BIconFileEarmarkExcel */],
    BIconFileEarmarkExcelFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_581" /* BIconFileEarmarkExcelFill */],
    BIconFileEarmarkFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_582" /* BIconFileEarmarkFill */],
    BIconFileEarmarkFont: __WEBPACK_IMPORTED_MODULE_3__icons__["_583" /* BIconFileEarmarkFont */],
    BIconFileEarmarkFontFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_584" /* BIconFileEarmarkFontFill */],
    BIconFileEarmarkImage: __WEBPACK_IMPORTED_MODULE_3__icons__["_585" /* BIconFileEarmarkImage */],
    BIconFileEarmarkImageFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_586" /* BIconFileEarmarkImageFill */],
    BIconFileEarmarkLock: __WEBPACK_IMPORTED_MODULE_3__icons__["_587" /* BIconFileEarmarkLock */],
    BIconFileEarmarkLock2: __WEBPACK_IMPORTED_MODULE_3__icons__["_588" /* BIconFileEarmarkLock2 */],
    BIconFileEarmarkLock2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_589" /* BIconFileEarmarkLock2Fill */],
    BIconFileEarmarkLockFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_590" /* BIconFileEarmarkLockFill */],
    BIconFileEarmarkMedical: __WEBPACK_IMPORTED_MODULE_3__icons__["_591" /* BIconFileEarmarkMedical */],
    BIconFileEarmarkMedicalFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_592" /* BIconFileEarmarkMedicalFill */],
    BIconFileEarmarkMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_593" /* BIconFileEarmarkMinus */],
    BIconFileEarmarkMinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_594" /* BIconFileEarmarkMinusFill */],
    BIconFileEarmarkMusic: __WEBPACK_IMPORTED_MODULE_3__icons__["_595" /* BIconFileEarmarkMusic */],
    BIconFileEarmarkMusicFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_596" /* BIconFileEarmarkMusicFill */],
    BIconFileEarmarkPdf: __WEBPACK_IMPORTED_MODULE_3__icons__["_597" /* BIconFileEarmarkPdf */],
    BIconFileEarmarkPdfFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_598" /* BIconFileEarmarkPdfFill */],
    BIconFileEarmarkPerson: __WEBPACK_IMPORTED_MODULE_3__icons__["_599" /* BIconFileEarmarkPerson */],
    BIconFileEarmarkPersonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_600" /* BIconFileEarmarkPersonFill */],
    BIconFileEarmarkPlay: __WEBPACK_IMPORTED_MODULE_3__icons__["_601" /* BIconFileEarmarkPlay */],
    BIconFileEarmarkPlayFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_602" /* BIconFileEarmarkPlayFill */],
    BIconFileEarmarkPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_603" /* BIconFileEarmarkPlus */],
    BIconFileEarmarkPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_604" /* BIconFileEarmarkPlusFill */],
    BIconFileEarmarkPost: __WEBPACK_IMPORTED_MODULE_3__icons__["_605" /* BIconFileEarmarkPost */],
    BIconFileEarmarkPostFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_606" /* BIconFileEarmarkPostFill */],
    BIconFileEarmarkPpt: __WEBPACK_IMPORTED_MODULE_3__icons__["_607" /* BIconFileEarmarkPpt */],
    BIconFileEarmarkPptFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_608" /* BIconFileEarmarkPptFill */],
    BIconFileEarmarkRichtext: __WEBPACK_IMPORTED_MODULE_3__icons__["_609" /* BIconFileEarmarkRichtext */],
    BIconFileEarmarkRichtextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_610" /* BIconFileEarmarkRichtextFill */],
    BIconFileEarmarkRuled: __WEBPACK_IMPORTED_MODULE_3__icons__["_611" /* BIconFileEarmarkRuled */],
    BIconFileEarmarkRuledFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_612" /* BIconFileEarmarkRuledFill */],
    BIconFileEarmarkSlides: __WEBPACK_IMPORTED_MODULE_3__icons__["_613" /* BIconFileEarmarkSlides */],
    BIconFileEarmarkSlidesFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_614" /* BIconFileEarmarkSlidesFill */],
    BIconFileEarmarkSpreadsheet: __WEBPACK_IMPORTED_MODULE_3__icons__["_615" /* BIconFileEarmarkSpreadsheet */],
    BIconFileEarmarkSpreadsheetFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_616" /* BIconFileEarmarkSpreadsheetFill */],
    BIconFileEarmarkText: __WEBPACK_IMPORTED_MODULE_3__icons__["_617" /* BIconFileEarmarkText */],
    BIconFileEarmarkTextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_618" /* BIconFileEarmarkTextFill */],
    BIconFileEarmarkWord: __WEBPACK_IMPORTED_MODULE_3__icons__["_619" /* BIconFileEarmarkWord */],
    BIconFileEarmarkWordFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_620" /* BIconFileEarmarkWordFill */],
    BIconFileEarmarkX: __WEBPACK_IMPORTED_MODULE_3__icons__["_621" /* BIconFileEarmarkX */],
    BIconFileEarmarkXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_622" /* BIconFileEarmarkXFill */],
    BIconFileEarmarkZip: __WEBPACK_IMPORTED_MODULE_3__icons__["_623" /* BIconFileEarmarkZip */],
    BIconFileEarmarkZipFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_624" /* BIconFileEarmarkZipFill */],
    BIconFileEasel: __WEBPACK_IMPORTED_MODULE_3__icons__["_625" /* BIconFileEasel */],
    BIconFileEaselFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_626" /* BIconFileEaselFill */],
    BIconFileExcel: __WEBPACK_IMPORTED_MODULE_3__icons__["_627" /* BIconFileExcel */],
    BIconFileExcelFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_628" /* BIconFileExcelFill */],
    BIconFileFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_629" /* BIconFileFill */],
    BIconFileFont: __WEBPACK_IMPORTED_MODULE_3__icons__["_630" /* BIconFileFont */],
    BIconFileFontFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_631" /* BIconFileFontFill */],
    BIconFileImage: __WEBPACK_IMPORTED_MODULE_3__icons__["_632" /* BIconFileImage */],
    BIconFileImageFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_633" /* BIconFileImageFill */],
    BIconFileLock: __WEBPACK_IMPORTED_MODULE_3__icons__["_634" /* BIconFileLock */],
    BIconFileLock2: __WEBPACK_IMPORTED_MODULE_3__icons__["_635" /* BIconFileLock2 */],
    BIconFileLock2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_636" /* BIconFileLock2Fill */],
    BIconFileLockFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_637" /* BIconFileLockFill */],
    BIconFileMedical: __WEBPACK_IMPORTED_MODULE_3__icons__["_638" /* BIconFileMedical */],
    BIconFileMedicalFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_639" /* BIconFileMedicalFill */],
    BIconFileMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_640" /* BIconFileMinus */],
    BIconFileMinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_641" /* BIconFileMinusFill */],
    BIconFileMusic: __WEBPACK_IMPORTED_MODULE_3__icons__["_642" /* BIconFileMusic */],
    BIconFileMusicFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_643" /* BIconFileMusicFill */],
    BIconFilePdf: __WEBPACK_IMPORTED_MODULE_3__icons__["_644" /* BIconFilePdf */],
    BIconFilePdfFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_645" /* BIconFilePdfFill */],
    BIconFilePerson: __WEBPACK_IMPORTED_MODULE_3__icons__["_646" /* BIconFilePerson */],
    BIconFilePersonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_647" /* BIconFilePersonFill */],
    BIconFilePlay: __WEBPACK_IMPORTED_MODULE_3__icons__["_648" /* BIconFilePlay */],
    BIconFilePlayFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_649" /* BIconFilePlayFill */],
    BIconFilePlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_650" /* BIconFilePlus */],
    BIconFilePlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_651" /* BIconFilePlusFill */],
    BIconFilePost: __WEBPACK_IMPORTED_MODULE_3__icons__["_652" /* BIconFilePost */],
    BIconFilePostFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_653" /* BIconFilePostFill */],
    BIconFilePpt: __WEBPACK_IMPORTED_MODULE_3__icons__["_654" /* BIconFilePpt */],
    BIconFilePptFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_655" /* BIconFilePptFill */],
    BIconFileRichtext: __WEBPACK_IMPORTED_MODULE_3__icons__["_656" /* BIconFileRichtext */],
    BIconFileRichtextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_657" /* BIconFileRichtextFill */],
    BIconFileRuled: __WEBPACK_IMPORTED_MODULE_3__icons__["_658" /* BIconFileRuled */],
    BIconFileRuledFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_659" /* BIconFileRuledFill */],
    BIconFileSlides: __WEBPACK_IMPORTED_MODULE_3__icons__["_660" /* BIconFileSlides */],
    BIconFileSlidesFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_661" /* BIconFileSlidesFill */],
    BIconFileSpreadsheet: __WEBPACK_IMPORTED_MODULE_3__icons__["_662" /* BIconFileSpreadsheet */],
    BIconFileSpreadsheetFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_663" /* BIconFileSpreadsheetFill */],
    BIconFileText: __WEBPACK_IMPORTED_MODULE_3__icons__["_664" /* BIconFileText */],
    BIconFileTextFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_665" /* BIconFileTextFill */],
    BIconFileWord: __WEBPACK_IMPORTED_MODULE_3__icons__["_666" /* BIconFileWord */],
    BIconFileWordFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_667" /* BIconFileWordFill */],
    BIconFileX: __WEBPACK_IMPORTED_MODULE_3__icons__["_668" /* BIconFileX */],
    BIconFileXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_669" /* BIconFileXFill */],
    BIconFileZip: __WEBPACK_IMPORTED_MODULE_3__icons__["_670" /* BIconFileZip */],
    BIconFileZipFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_671" /* BIconFileZipFill */],
    BIconFiles: __WEBPACK_IMPORTED_MODULE_3__icons__["_672" /* BIconFiles */],
    BIconFilesAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_673" /* BIconFilesAlt */],
    BIconFilm: __WEBPACK_IMPORTED_MODULE_3__icons__["_674" /* BIconFilm */],
    BIconFilter: __WEBPACK_IMPORTED_MODULE_3__icons__["_675" /* BIconFilter */],
    BIconFilterCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_676" /* BIconFilterCircle */],
    BIconFilterCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_677" /* BIconFilterCircleFill */],
    BIconFilterLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_678" /* BIconFilterLeft */],
    BIconFilterRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_679" /* BIconFilterRight */],
    BIconFilterSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_680" /* BIconFilterSquare */],
    BIconFilterSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_681" /* BIconFilterSquareFill */],
    BIconFlag: __WEBPACK_IMPORTED_MODULE_3__icons__["_682" /* BIconFlag */],
    BIconFlagFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_683" /* BIconFlagFill */],
    BIconFlower1: __WEBPACK_IMPORTED_MODULE_3__icons__["_684" /* BIconFlower1 */],
    BIconFlower2: __WEBPACK_IMPORTED_MODULE_3__icons__["_685" /* BIconFlower2 */],
    BIconFlower3: __WEBPACK_IMPORTED_MODULE_3__icons__["_686" /* BIconFlower3 */],
    BIconFolder: __WEBPACK_IMPORTED_MODULE_3__icons__["_687" /* BIconFolder */],
    BIconFolder2: __WEBPACK_IMPORTED_MODULE_3__icons__["_688" /* BIconFolder2 */],
    BIconFolder2Open: __WEBPACK_IMPORTED_MODULE_3__icons__["_689" /* BIconFolder2Open */],
    BIconFolderCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_690" /* BIconFolderCheck */],
    BIconFolderFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_691" /* BIconFolderFill */],
    BIconFolderMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_692" /* BIconFolderMinus */],
    BIconFolderPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_693" /* BIconFolderPlus */],
    BIconFolderSymlink: __WEBPACK_IMPORTED_MODULE_3__icons__["_694" /* BIconFolderSymlink */],
    BIconFolderSymlinkFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_695" /* BIconFolderSymlinkFill */],
    BIconFolderX: __WEBPACK_IMPORTED_MODULE_3__icons__["_696" /* BIconFolderX */],
    BIconFonts: __WEBPACK_IMPORTED_MODULE_3__icons__["_697" /* BIconFonts */],
    BIconForward: __WEBPACK_IMPORTED_MODULE_3__icons__["_698" /* BIconForward */],
    BIconForwardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_699" /* BIconForwardFill */],
    BIconFront: __WEBPACK_IMPORTED_MODULE_3__icons__["_700" /* BIconFront */],
    BIconFullscreen: __WEBPACK_IMPORTED_MODULE_3__icons__["_701" /* BIconFullscreen */],
    BIconFullscreenExit: __WEBPACK_IMPORTED_MODULE_3__icons__["_702" /* BIconFullscreenExit */],
    BIconFunnel: __WEBPACK_IMPORTED_MODULE_3__icons__["_703" /* BIconFunnel */],
    BIconFunnelFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_704" /* BIconFunnelFill */],
    BIconGear: __WEBPACK_IMPORTED_MODULE_3__icons__["_705" /* BIconGear */],
    BIconGearFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_706" /* BIconGearFill */],
    BIconGearWide: __WEBPACK_IMPORTED_MODULE_3__icons__["_707" /* BIconGearWide */],
    BIconGearWideConnected: __WEBPACK_IMPORTED_MODULE_3__icons__["_708" /* BIconGearWideConnected */],
    BIconGem: __WEBPACK_IMPORTED_MODULE_3__icons__["_709" /* BIconGem */],
    BIconGenderAmbiguous: __WEBPACK_IMPORTED_MODULE_3__icons__["_710" /* BIconGenderAmbiguous */],
    BIconGenderFemale: __WEBPACK_IMPORTED_MODULE_3__icons__["_711" /* BIconGenderFemale */],
    BIconGenderMale: __WEBPACK_IMPORTED_MODULE_3__icons__["_712" /* BIconGenderMale */],
    BIconGenderTrans: __WEBPACK_IMPORTED_MODULE_3__icons__["_713" /* BIconGenderTrans */],
    BIconGeo: __WEBPACK_IMPORTED_MODULE_3__icons__["_714" /* BIconGeo */],
    BIconGeoAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_715" /* BIconGeoAlt */],
    BIconGeoAltFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_716" /* BIconGeoAltFill */],
    BIconGeoFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_717" /* BIconGeoFill */],
    BIconGift: __WEBPACK_IMPORTED_MODULE_3__icons__["_718" /* BIconGift */],
    BIconGiftFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_719" /* BIconGiftFill */],
    BIconGithub: __WEBPACK_IMPORTED_MODULE_3__icons__["_720" /* BIconGithub */],
    BIconGlobe: __WEBPACK_IMPORTED_MODULE_3__icons__["_721" /* BIconGlobe */],
    BIconGlobe2: __WEBPACK_IMPORTED_MODULE_3__icons__["_722" /* BIconGlobe2 */],
    BIconGoogle: __WEBPACK_IMPORTED_MODULE_3__icons__["_723" /* BIconGoogle */],
    BIconGraphDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_724" /* BIconGraphDown */],
    BIconGraphUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_725" /* BIconGraphUp */],
    BIconGrid: __WEBPACK_IMPORTED_MODULE_3__icons__["_726" /* BIconGrid */],
    BIconGrid1x2: __WEBPACK_IMPORTED_MODULE_3__icons__["_727" /* BIconGrid1x2 */],
    BIconGrid1x2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_728" /* BIconGrid1x2Fill */],
    BIconGrid3x2: __WEBPACK_IMPORTED_MODULE_3__icons__["_729" /* BIconGrid3x2 */],
    BIconGrid3x2Gap: __WEBPACK_IMPORTED_MODULE_3__icons__["_730" /* BIconGrid3x2Gap */],
    BIconGrid3x2GapFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_731" /* BIconGrid3x2GapFill */],
    BIconGrid3x3: __WEBPACK_IMPORTED_MODULE_3__icons__["_732" /* BIconGrid3x3 */],
    BIconGrid3x3Gap: __WEBPACK_IMPORTED_MODULE_3__icons__["_733" /* BIconGrid3x3Gap */],
    BIconGrid3x3GapFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_734" /* BIconGrid3x3GapFill */],
    BIconGridFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_735" /* BIconGridFill */],
    BIconGripHorizontal: __WEBPACK_IMPORTED_MODULE_3__icons__["_736" /* BIconGripHorizontal */],
    BIconGripVertical: __WEBPACK_IMPORTED_MODULE_3__icons__["_737" /* BIconGripVertical */],
    BIconHammer: __WEBPACK_IMPORTED_MODULE_3__icons__["_738" /* BIconHammer */],
    BIconHandIndex: __WEBPACK_IMPORTED_MODULE_3__icons__["_739" /* BIconHandIndex */],
    BIconHandIndexFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_740" /* BIconHandIndexFill */],
    BIconHandIndexThumb: __WEBPACK_IMPORTED_MODULE_3__icons__["_741" /* BIconHandIndexThumb */],
    BIconHandIndexThumbFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_742" /* BIconHandIndexThumbFill */],
    BIconHandThumbsDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_743" /* BIconHandThumbsDown */],
    BIconHandThumbsDownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_744" /* BIconHandThumbsDownFill */],
    BIconHandThumbsUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_745" /* BIconHandThumbsUp */],
    BIconHandThumbsUpFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_746" /* BIconHandThumbsUpFill */],
    BIconHandbag: __WEBPACK_IMPORTED_MODULE_3__icons__["_747" /* BIconHandbag */],
    BIconHandbagFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_748" /* BIconHandbagFill */],
    BIconHash: __WEBPACK_IMPORTED_MODULE_3__icons__["_749" /* BIconHash */],
    BIconHdd: __WEBPACK_IMPORTED_MODULE_3__icons__["_750" /* BIconHdd */],
    BIconHddFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_751" /* BIconHddFill */],
    BIconHddNetwork: __WEBPACK_IMPORTED_MODULE_3__icons__["_752" /* BIconHddNetwork */],
    BIconHddNetworkFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_753" /* BIconHddNetworkFill */],
    BIconHddRack: __WEBPACK_IMPORTED_MODULE_3__icons__["_754" /* BIconHddRack */],
    BIconHddRackFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_755" /* BIconHddRackFill */],
    BIconHddStack: __WEBPACK_IMPORTED_MODULE_3__icons__["_756" /* BIconHddStack */],
    BIconHddStackFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_757" /* BIconHddStackFill */],
    BIconHeadphones: __WEBPACK_IMPORTED_MODULE_3__icons__["_758" /* BIconHeadphones */],
    BIconHeadset: __WEBPACK_IMPORTED_MODULE_3__icons__["_759" /* BIconHeadset */],
    BIconHeadsetVr: __WEBPACK_IMPORTED_MODULE_3__icons__["_760" /* BIconHeadsetVr */],
    BIconHeart: __WEBPACK_IMPORTED_MODULE_3__icons__["_761" /* BIconHeart */],
    BIconHeartFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_762" /* BIconHeartFill */],
    BIconHeartHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_763" /* BIconHeartHalf */],
    BIconHeptagon: __WEBPACK_IMPORTED_MODULE_3__icons__["_764" /* BIconHeptagon */],
    BIconHeptagonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_765" /* BIconHeptagonFill */],
    BIconHeptagonHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_766" /* BIconHeptagonHalf */],
    BIconHexagon: __WEBPACK_IMPORTED_MODULE_3__icons__["_767" /* BIconHexagon */],
    BIconHexagonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_768" /* BIconHexagonFill */],
    BIconHexagonHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_769" /* BIconHexagonHalf */],
    BIconHourglass: __WEBPACK_IMPORTED_MODULE_3__icons__["_770" /* BIconHourglass */],
    BIconHourglassBottom: __WEBPACK_IMPORTED_MODULE_3__icons__["_771" /* BIconHourglassBottom */],
    BIconHourglassSplit: __WEBPACK_IMPORTED_MODULE_3__icons__["_772" /* BIconHourglassSplit */],
    BIconHourglassTop: __WEBPACK_IMPORTED_MODULE_3__icons__["_773" /* BIconHourglassTop */],
    BIconHouse: __WEBPACK_IMPORTED_MODULE_3__icons__["_774" /* BIconHouse */],
    BIconHouseDoor: __WEBPACK_IMPORTED_MODULE_3__icons__["_775" /* BIconHouseDoor */],
    BIconHouseDoorFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_776" /* BIconHouseDoorFill */],
    BIconHouseFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_777" /* BIconHouseFill */],
    BIconHr: __WEBPACK_IMPORTED_MODULE_3__icons__["_778" /* BIconHr */],
    BIconHurricane: __WEBPACK_IMPORTED_MODULE_3__icons__["_779" /* BIconHurricane */],
    BIconImage: __WEBPACK_IMPORTED_MODULE_3__icons__["_780" /* BIconImage */],
    BIconImageAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_781" /* BIconImageAlt */],
    BIconImageFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_782" /* BIconImageFill */],
    BIconImages: __WEBPACK_IMPORTED_MODULE_3__icons__["_783" /* BIconImages */],
    BIconInbox: __WEBPACK_IMPORTED_MODULE_3__icons__["_784" /* BIconInbox */],
    BIconInboxFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_785" /* BIconInboxFill */],
    BIconInboxes: __WEBPACK_IMPORTED_MODULE_3__icons__["_786" /* BIconInboxes */],
    BIconInboxesFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_787" /* BIconInboxesFill */],
    BIconInfo: __WEBPACK_IMPORTED_MODULE_3__icons__["_788" /* BIconInfo */],
    BIconInfoCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_789" /* BIconInfoCircle */],
    BIconInfoCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_790" /* BIconInfoCircleFill */],
    BIconInfoLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_791" /* BIconInfoLg */],
    BIconInfoSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_792" /* BIconInfoSquare */],
    BIconInfoSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_793" /* BIconInfoSquareFill */],
    BIconInputCursor: __WEBPACK_IMPORTED_MODULE_3__icons__["_794" /* BIconInputCursor */],
    BIconInputCursorText: __WEBPACK_IMPORTED_MODULE_3__icons__["_795" /* BIconInputCursorText */],
    BIconInstagram: __WEBPACK_IMPORTED_MODULE_3__icons__["_796" /* BIconInstagram */],
    BIconIntersect: __WEBPACK_IMPORTED_MODULE_3__icons__["_797" /* BIconIntersect */],
    BIconJournal: __WEBPACK_IMPORTED_MODULE_3__icons__["_798" /* BIconJournal */],
    BIconJournalAlbum: __WEBPACK_IMPORTED_MODULE_3__icons__["_799" /* BIconJournalAlbum */],
    BIconJournalArrowDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_800" /* BIconJournalArrowDown */],
    BIconJournalArrowUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_801" /* BIconJournalArrowUp */],
    BIconJournalBookmark: __WEBPACK_IMPORTED_MODULE_3__icons__["_802" /* BIconJournalBookmark */],
    BIconJournalBookmarkFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_803" /* BIconJournalBookmarkFill */],
    BIconJournalCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_804" /* BIconJournalCheck */],
    BIconJournalCode: __WEBPACK_IMPORTED_MODULE_3__icons__["_805" /* BIconJournalCode */],
    BIconJournalMedical: __WEBPACK_IMPORTED_MODULE_3__icons__["_806" /* BIconJournalMedical */],
    BIconJournalMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_807" /* BIconJournalMinus */],
    BIconJournalPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_808" /* BIconJournalPlus */],
    BIconJournalRichtext: __WEBPACK_IMPORTED_MODULE_3__icons__["_809" /* BIconJournalRichtext */],
    BIconJournalText: __WEBPACK_IMPORTED_MODULE_3__icons__["_810" /* BIconJournalText */],
    BIconJournalX: __WEBPACK_IMPORTED_MODULE_3__icons__["_811" /* BIconJournalX */],
    BIconJournals: __WEBPACK_IMPORTED_MODULE_3__icons__["_812" /* BIconJournals */],
    BIconJoystick: __WEBPACK_IMPORTED_MODULE_3__icons__["_813" /* BIconJoystick */],
    BIconJustify: __WEBPACK_IMPORTED_MODULE_3__icons__["_814" /* BIconJustify */],
    BIconJustifyLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_815" /* BIconJustifyLeft */],
    BIconJustifyRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_816" /* BIconJustifyRight */],
    BIconKanban: __WEBPACK_IMPORTED_MODULE_3__icons__["_817" /* BIconKanban */],
    BIconKanbanFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_818" /* BIconKanbanFill */],
    BIconKey: __WEBPACK_IMPORTED_MODULE_3__icons__["_819" /* BIconKey */],
    BIconKeyFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_820" /* BIconKeyFill */],
    BIconKeyboard: __WEBPACK_IMPORTED_MODULE_3__icons__["_821" /* BIconKeyboard */],
    BIconKeyboardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_822" /* BIconKeyboardFill */],
    BIconLadder: __WEBPACK_IMPORTED_MODULE_3__icons__["_823" /* BIconLadder */],
    BIconLamp: __WEBPACK_IMPORTED_MODULE_3__icons__["_824" /* BIconLamp */],
    BIconLampFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_825" /* BIconLampFill */],
    BIconLaptop: __WEBPACK_IMPORTED_MODULE_3__icons__["_826" /* BIconLaptop */],
    BIconLaptopFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_827" /* BIconLaptopFill */],
    BIconLayerBackward: __WEBPACK_IMPORTED_MODULE_3__icons__["_828" /* BIconLayerBackward */],
    BIconLayerForward: __WEBPACK_IMPORTED_MODULE_3__icons__["_829" /* BIconLayerForward */],
    BIconLayers: __WEBPACK_IMPORTED_MODULE_3__icons__["_830" /* BIconLayers */],
    BIconLayersFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_831" /* BIconLayersFill */],
    BIconLayersHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_832" /* BIconLayersHalf */],
    BIconLayoutSidebar: __WEBPACK_IMPORTED_MODULE_3__icons__["_833" /* BIconLayoutSidebar */],
    BIconLayoutSidebarInset: __WEBPACK_IMPORTED_MODULE_3__icons__["_834" /* BIconLayoutSidebarInset */],
    BIconLayoutSidebarInsetReverse: __WEBPACK_IMPORTED_MODULE_3__icons__["_835" /* BIconLayoutSidebarInsetReverse */],
    BIconLayoutSidebarReverse: __WEBPACK_IMPORTED_MODULE_3__icons__["_836" /* BIconLayoutSidebarReverse */],
    BIconLayoutSplit: __WEBPACK_IMPORTED_MODULE_3__icons__["_837" /* BIconLayoutSplit */],
    BIconLayoutTextSidebar: __WEBPACK_IMPORTED_MODULE_3__icons__["_838" /* BIconLayoutTextSidebar */],
    BIconLayoutTextSidebarReverse: __WEBPACK_IMPORTED_MODULE_3__icons__["_839" /* BIconLayoutTextSidebarReverse */],
    BIconLayoutTextWindow: __WEBPACK_IMPORTED_MODULE_3__icons__["_840" /* BIconLayoutTextWindow */],
    BIconLayoutTextWindowReverse: __WEBPACK_IMPORTED_MODULE_3__icons__["_841" /* BIconLayoutTextWindowReverse */],
    BIconLayoutThreeColumns: __WEBPACK_IMPORTED_MODULE_3__icons__["_842" /* BIconLayoutThreeColumns */],
    BIconLayoutWtf: __WEBPACK_IMPORTED_MODULE_3__icons__["_843" /* BIconLayoutWtf */],
    BIconLifePreserver: __WEBPACK_IMPORTED_MODULE_3__icons__["_844" /* BIconLifePreserver */],
    BIconLightbulb: __WEBPACK_IMPORTED_MODULE_3__icons__["_845" /* BIconLightbulb */],
    BIconLightbulbFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_846" /* BIconLightbulbFill */],
    BIconLightbulbOff: __WEBPACK_IMPORTED_MODULE_3__icons__["_847" /* BIconLightbulbOff */],
    BIconLightbulbOffFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_848" /* BIconLightbulbOffFill */],
    BIconLightning: __WEBPACK_IMPORTED_MODULE_3__icons__["_849" /* BIconLightning */],
    BIconLightningCharge: __WEBPACK_IMPORTED_MODULE_3__icons__["_850" /* BIconLightningCharge */],
    BIconLightningChargeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_851" /* BIconLightningChargeFill */],
    BIconLightningFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_852" /* BIconLightningFill */],
    BIconLink: __WEBPACK_IMPORTED_MODULE_3__icons__["_853" /* BIconLink */],
    BIconLink45deg: __WEBPACK_IMPORTED_MODULE_3__icons__["_854" /* BIconLink45deg */],
    BIconLinkedin: __WEBPACK_IMPORTED_MODULE_3__icons__["_855" /* BIconLinkedin */],
    BIconList: __WEBPACK_IMPORTED_MODULE_3__icons__["_856" /* BIconList */],
    BIconListCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_857" /* BIconListCheck */],
    BIconListNested: __WEBPACK_IMPORTED_MODULE_3__icons__["_858" /* BIconListNested */],
    BIconListOl: __WEBPACK_IMPORTED_MODULE_3__icons__["_859" /* BIconListOl */],
    BIconListStars: __WEBPACK_IMPORTED_MODULE_3__icons__["_860" /* BIconListStars */],
    BIconListTask: __WEBPACK_IMPORTED_MODULE_3__icons__["_861" /* BIconListTask */],
    BIconListUl: __WEBPACK_IMPORTED_MODULE_3__icons__["_862" /* BIconListUl */],
    BIconLock: __WEBPACK_IMPORTED_MODULE_3__icons__["_863" /* BIconLock */],
    BIconLockFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_864" /* BIconLockFill */],
    BIconMailbox: __WEBPACK_IMPORTED_MODULE_3__icons__["_865" /* BIconMailbox */],
    BIconMailbox2: __WEBPACK_IMPORTED_MODULE_3__icons__["_866" /* BIconMailbox2 */],
    BIconMap: __WEBPACK_IMPORTED_MODULE_3__icons__["_867" /* BIconMap */],
    BIconMapFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_868" /* BIconMapFill */],
    BIconMarkdown: __WEBPACK_IMPORTED_MODULE_3__icons__["_869" /* BIconMarkdown */],
    BIconMarkdownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_870" /* BIconMarkdownFill */],
    BIconMask: __WEBPACK_IMPORTED_MODULE_3__icons__["_871" /* BIconMask */],
    BIconMastodon: __WEBPACK_IMPORTED_MODULE_3__icons__["_872" /* BIconMastodon */],
    BIconMegaphone: __WEBPACK_IMPORTED_MODULE_3__icons__["_873" /* BIconMegaphone */],
    BIconMegaphoneFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_874" /* BIconMegaphoneFill */],
    BIconMenuApp: __WEBPACK_IMPORTED_MODULE_3__icons__["_875" /* BIconMenuApp */],
    BIconMenuAppFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_876" /* BIconMenuAppFill */],
    BIconMenuButton: __WEBPACK_IMPORTED_MODULE_3__icons__["_877" /* BIconMenuButton */],
    BIconMenuButtonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_878" /* BIconMenuButtonFill */],
    BIconMenuButtonWide: __WEBPACK_IMPORTED_MODULE_3__icons__["_879" /* BIconMenuButtonWide */],
    BIconMenuButtonWideFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_880" /* BIconMenuButtonWideFill */],
    BIconMenuDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_881" /* BIconMenuDown */],
    BIconMenuUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_882" /* BIconMenuUp */],
    BIconMessenger: __WEBPACK_IMPORTED_MODULE_3__icons__["_883" /* BIconMessenger */],
    BIconMic: __WEBPACK_IMPORTED_MODULE_3__icons__["_884" /* BIconMic */],
    BIconMicFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_885" /* BIconMicFill */],
    BIconMicMute: __WEBPACK_IMPORTED_MODULE_3__icons__["_886" /* BIconMicMute */],
    BIconMicMuteFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_887" /* BIconMicMuteFill */],
    BIconMinecart: __WEBPACK_IMPORTED_MODULE_3__icons__["_888" /* BIconMinecart */],
    BIconMinecartLoaded: __WEBPACK_IMPORTED_MODULE_3__icons__["_889" /* BIconMinecartLoaded */],
    BIconMoisture: __WEBPACK_IMPORTED_MODULE_3__icons__["_890" /* BIconMoisture */],
    BIconMoon: __WEBPACK_IMPORTED_MODULE_3__icons__["_891" /* BIconMoon */],
    BIconMoonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_892" /* BIconMoonFill */],
    BIconMoonStars: __WEBPACK_IMPORTED_MODULE_3__icons__["_893" /* BIconMoonStars */],
    BIconMoonStarsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_894" /* BIconMoonStarsFill */],
    BIconMouse: __WEBPACK_IMPORTED_MODULE_3__icons__["_895" /* BIconMouse */],
    BIconMouse2: __WEBPACK_IMPORTED_MODULE_3__icons__["_896" /* BIconMouse2 */],
    BIconMouse2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_897" /* BIconMouse2Fill */],
    BIconMouse3: __WEBPACK_IMPORTED_MODULE_3__icons__["_898" /* BIconMouse3 */],
    BIconMouse3Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_899" /* BIconMouse3Fill */],
    BIconMouseFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_900" /* BIconMouseFill */],
    BIconMusicNote: __WEBPACK_IMPORTED_MODULE_3__icons__["_901" /* BIconMusicNote */],
    BIconMusicNoteBeamed: __WEBPACK_IMPORTED_MODULE_3__icons__["_902" /* BIconMusicNoteBeamed */],
    BIconMusicNoteList: __WEBPACK_IMPORTED_MODULE_3__icons__["_903" /* BIconMusicNoteList */],
    BIconMusicPlayer: __WEBPACK_IMPORTED_MODULE_3__icons__["_904" /* BIconMusicPlayer */],
    BIconMusicPlayerFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_905" /* BIconMusicPlayerFill */],
    BIconNewspaper: __WEBPACK_IMPORTED_MODULE_3__icons__["_906" /* BIconNewspaper */],
    BIconNodeMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_907" /* BIconNodeMinus */],
    BIconNodeMinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_908" /* BIconNodeMinusFill */],
    BIconNodePlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_909" /* BIconNodePlus */],
    BIconNodePlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_910" /* BIconNodePlusFill */],
    BIconNut: __WEBPACK_IMPORTED_MODULE_3__icons__["_911" /* BIconNut */],
    BIconNutFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_912" /* BIconNutFill */],
    BIconOctagon: __WEBPACK_IMPORTED_MODULE_3__icons__["_913" /* BIconOctagon */],
    BIconOctagonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_914" /* BIconOctagonFill */],
    BIconOctagonHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_915" /* BIconOctagonHalf */],
    BIconOption: __WEBPACK_IMPORTED_MODULE_3__icons__["_916" /* BIconOption */],
    BIconOutlet: __WEBPACK_IMPORTED_MODULE_3__icons__["_917" /* BIconOutlet */],
    BIconPaintBucket: __WEBPACK_IMPORTED_MODULE_3__icons__["_918" /* BIconPaintBucket */],
    BIconPalette: __WEBPACK_IMPORTED_MODULE_3__icons__["_919" /* BIconPalette */],
    BIconPalette2: __WEBPACK_IMPORTED_MODULE_3__icons__["_920" /* BIconPalette2 */],
    BIconPaletteFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_921" /* BIconPaletteFill */],
    BIconPaperclip: __WEBPACK_IMPORTED_MODULE_3__icons__["_922" /* BIconPaperclip */],
    BIconParagraph: __WEBPACK_IMPORTED_MODULE_3__icons__["_923" /* BIconParagraph */],
    BIconPatchCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_924" /* BIconPatchCheck */],
    BIconPatchCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_925" /* BIconPatchCheckFill */],
    BIconPatchExclamation: __WEBPACK_IMPORTED_MODULE_3__icons__["_926" /* BIconPatchExclamation */],
    BIconPatchExclamationFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_927" /* BIconPatchExclamationFill */],
    BIconPatchMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_928" /* BIconPatchMinus */],
    BIconPatchMinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_929" /* BIconPatchMinusFill */],
    BIconPatchPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_930" /* BIconPatchPlus */],
    BIconPatchPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_931" /* BIconPatchPlusFill */],
    BIconPatchQuestion: __WEBPACK_IMPORTED_MODULE_3__icons__["_932" /* BIconPatchQuestion */],
    BIconPatchQuestionFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_933" /* BIconPatchQuestionFill */],
    BIconPause: __WEBPACK_IMPORTED_MODULE_3__icons__["_934" /* BIconPause */],
    BIconPauseBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_935" /* BIconPauseBtn */],
    BIconPauseBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_936" /* BIconPauseBtnFill */],
    BIconPauseCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_937" /* BIconPauseCircle */],
    BIconPauseCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_938" /* BIconPauseCircleFill */],
    BIconPauseFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_939" /* BIconPauseFill */],
    BIconPeace: __WEBPACK_IMPORTED_MODULE_3__icons__["_940" /* BIconPeace */],
    BIconPeaceFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_941" /* BIconPeaceFill */],
    BIconPen: __WEBPACK_IMPORTED_MODULE_3__icons__["_942" /* BIconPen */],
    BIconPenFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_943" /* BIconPenFill */],
    BIconPencil: __WEBPACK_IMPORTED_MODULE_3__icons__["_944" /* BIconPencil */],
    BIconPencilFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_945" /* BIconPencilFill */],
    BIconPencilSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_946" /* BIconPencilSquare */],
    BIconPentagon: __WEBPACK_IMPORTED_MODULE_3__icons__["_947" /* BIconPentagon */],
    BIconPentagonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_948" /* BIconPentagonFill */],
    BIconPentagonHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_949" /* BIconPentagonHalf */],
    BIconPeople: __WEBPACK_IMPORTED_MODULE_3__icons__["_950" /* BIconPeople */],
    BIconPeopleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_951" /* BIconPeopleFill */],
    BIconPercent: __WEBPACK_IMPORTED_MODULE_3__icons__["_952" /* BIconPercent */],
    BIconPerson: __WEBPACK_IMPORTED_MODULE_3__icons__["_953" /* BIconPerson */],
    BIconPersonBadge: __WEBPACK_IMPORTED_MODULE_3__icons__["_954" /* BIconPersonBadge */],
    BIconPersonBadgeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_955" /* BIconPersonBadgeFill */],
    BIconPersonBoundingBox: __WEBPACK_IMPORTED_MODULE_3__icons__["_956" /* BIconPersonBoundingBox */],
    BIconPersonCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_957" /* BIconPersonCheck */],
    BIconPersonCheckFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_958" /* BIconPersonCheckFill */],
    BIconPersonCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_959" /* BIconPersonCircle */],
    BIconPersonDash: __WEBPACK_IMPORTED_MODULE_3__icons__["_960" /* BIconPersonDash */],
    BIconPersonDashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_961" /* BIconPersonDashFill */],
    BIconPersonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_962" /* BIconPersonFill */],
    BIconPersonLinesFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_963" /* BIconPersonLinesFill */],
    BIconPersonPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_964" /* BIconPersonPlus */],
    BIconPersonPlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_965" /* BIconPersonPlusFill */],
    BIconPersonSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_966" /* BIconPersonSquare */],
    BIconPersonX: __WEBPACK_IMPORTED_MODULE_3__icons__["_967" /* BIconPersonX */],
    BIconPersonXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_968" /* BIconPersonXFill */],
    BIconPhone: __WEBPACK_IMPORTED_MODULE_3__icons__["_969" /* BIconPhone */],
    BIconPhoneFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_970" /* BIconPhoneFill */],
    BIconPhoneLandscape: __WEBPACK_IMPORTED_MODULE_3__icons__["_971" /* BIconPhoneLandscape */],
    BIconPhoneLandscapeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_972" /* BIconPhoneLandscapeFill */],
    BIconPhoneVibrate: __WEBPACK_IMPORTED_MODULE_3__icons__["_973" /* BIconPhoneVibrate */],
    BIconPhoneVibrateFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_974" /* BIconPhoneVibrateFill */],
    BIconPieChart: __WEBPACK_IMPORTED_MODULE_3__icons__["_975" /* BIconPieChart */],
    BIconPieChartFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_976" /* BIconPieChartFill */],
    BIconPiggyBank: __WEBPACK_IMPORTED_MODULE_3__icons__["_977" /* BIconPiggyBank */],
    BIconPiggyBankFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_978" /* BIconPiggyBankFill */],
    BIconPin: __WEBPACK_IMPORTED_MODULE_3__icons__["_979" /* BIconPin */],
    BIconPinAngle: __WEBPACK_IMPORTED_MODULE_3__icons__["_980" /* BIconPinAngle */],
    BIconPinAngleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_981" /* BIconPinAngleFill */],
    BIconPinFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_982" /* BIconPinFill */],
    BIconPinMap: __WEBPACK_IMPORTED_MODULE_3__icons__["_983" /* BIconPinMap */],
    BIconPinMapFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_984" /* BIconPinMapFill */],
    BIconPip: __WEBPACK_IMPORTED_MODULE_3__icons__["_985" /* BIconPip */],
    BIconPipFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_986" /* BIconPipFill */],
    BIconPlay: __WEBPACK_IMPORTED_MODULE_3__icons__["_987" /* BIconPlay */],
    BIconPlayBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_988" /* BIconPlayBtn */],
    BIconPlayBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_989" /* BIconPlayBtnFill */],
    BIconPlayCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_990" /* BIconPlayCircle */],
    BIconPlayCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_991" /* BIconPlayCircleFill */],
    BIconPlayFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_992" /* BIconPlayFill */],
    BIconPlug: __WEBPACK_IMPORTED_MODULE_3__icons__["_993" /* BIconPlug */],
    BIconPlugFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_994" /* BIconPlugFill */],
    BIconPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_995" /* BIconPlus */],
    BIconPlusCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_996" /* BIconPlusCircle */],
    BIconPlusCircleDotted: __WEBPACK_IMPORTED_MODULE_3__icons__["_997" /* BIconPlusCircleDotted */],
    BIconPlusCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_998" /* BIconPlusCircleFill */],
    BIconPlusLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_999" /* BIconPlusLg */],
    BIconPlusSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_1000" /* BIconPlusSquare */],
    BIconPlusSquareDotted: __WEBPACK_IMPORTED_MODULE_3__icons__["_1001" /* BIconPlusSquareDotted */],
    BIconPlusSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1002" /* BIconPlusSquareFill */],
    BIconPower: __WEBPACK_IMPORTED_MODULE_3__icons__["_1003" /* BIconPower */],
    BIconPrinter: __WEBPACK_IMPORTED_MODULE_3__icons__["_1004" /* BIconPrinter */],
    BIconPrinterFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1005" /* BIconPrinterFill */],
    BIconPuzzle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1006" /* BIconPuzzle */],
    BIconPuzzleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1007" /* BIconPuzzleFill */],
    BIconQuestion: __WEBPACK_IMPORTED_MODULE_3__icons__["_1008" /* BIconQuestion */],
    BIconQuestionCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1009" /* BIconQuestionCircle */],
    BIconQuestionCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1010" /* BIconQuestionCircleFill */],
    BIconQuestionDiamond: __WEBPACK_IMPORTED_MODULE_3__icons__["_1011" /* BIconQuestionDiamond */],
    BIconQuestionDiamondFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1012" /* BIconQuestionDiamondFill */],
    BIconQuestionLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_1013" /* BIconQuestionLg */],
    BIconQuestionOctagon: __WEBPACK_IMPORTED_MODULE_3__icons__["_1014" /* BIconQuestionOctagon */],
    BIconQuestionOctagonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1015" /* BIconQuestionOctagonFill */],
    BIconQuestionSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_1016" /* BIconQuestionSquare */],
    BIconQuestionSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1017" /* BIconQuestionSquareFill */],
    BIconRainbow: __WEBPACK_IMPORTED_MODULE_3__icons__["_1018" /* BIconRainbow */],
    BIconReceipt: __WEBPACK_IMPORTED_MODULE_3__icons__["_1019" /* BIconReceipt */],
    BIconReceiptCutoff: __WEBPACK_IMPORTED_MODULE_3__icons__["_1020" /* BIconReceiptCutoff */],
    BIconReception0: __WEBPACK_IMPORTED_MODULE_3__icons__["_1021" /* BIconReception0 */],
    BIconReception1: __WEBPACK_IMPORTED_MODULE_3__icons__["_1022" /* BIconReception1 */],
    BIconReception2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1023" /* BIconReception2 */],
    BIconReception3: __WEBPACK_IMPORTED_MODULE_3__icons__["_1024" /* BIconReception3 */],
    BIconReception4: __WEBPACK_IMPORTED_MODULE_3__icons__["_1025" /* BIconReception4 */],
    BIconRecord: __WEBPACK_IMPORTED_MODULE_3__icons__["_1026" /* BIconRecord */],
    BIconRecord2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1027" /* BIconRecord2 */],
    BIconRecord2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1028" /* BIconRecord2Fill */],
    BIconRecordBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1029" /* BIconRecordBtn */],
    BIconRecordBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1030" /* BIconRecordBtnFill */],
    BIconRecordCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1031" /* BIconRecordCircle */],
    BIconRecordCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1032" /* BIconRecordCircleFill */],
    BIconRecordFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1033" /* BIconRecordFill */],
    BIconRecycle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1034" /* BIconRecycle */],
    BIconReddit: __WEBPACK_IMPORTED_MODULE_3__icons__["_1035" /* BIconReddit */],
    BIconReply: __WEBPACK_IMPORTED_MODULE_3__icons__["_1036" /* BIconReply */],
    BIconReplyAll: __WEBPACK_IMPORTED_MODULE_3__icons__["_1037" /* BIconReplyAll */],
    BIconReplyAllFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1038" /* BIconReplyAllFill */],
    BIconReplyFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1039" /* BIconReplyFill */],
    BIconRss: __WEBPACK_IMPORTED_MODULE_3__icons__["_1040" /* BIconRss */],
    BIconRssFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1041" /* BIconRssFill */],
    BIconRulers: __WEBPACK_IMPORTED_MODULE_3__icons__["_1042" /* BIconRulers */],
    BIconSafe: __WEBPACK_IMPORTED_MODULE_3__icons__["_1043" /* BIconSafe */],
    BIconSafe2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1044" /* BIconSafe2 */],
    BIconSafe2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1045" /* BIconSafe2Fill */],
    BIconSafeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1046" /* BIconSafeFill */],
    BIconSave: __WEBPACK_IMPORTED_MODULE_3__icons__["_1047" /* BIconSave */],
    BIconSave2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1048" /* BIconSave2 */],
    BIconSave2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1049" /* BIconSave2Fill */],
    BIconSaveFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1050" /* BIconSaveFill */],
    BIconScissors: __WEBPACK_IMPORTED_MODULE_3__icons__["_1051" /* BIconScissors */],
    BIconScrewdriver: __WEBPACK_IMPORTED_MODULE_3__icons__["_1052" /* BIconScrewdriver */],
    BIconSdCard: __WEBPACK_IMPORTED_MODULE_3__icons__["_1053" /* BIconSdCard */],
    BIconSdCardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1054" /* BIconSdCardFill */],
    BIconSearch: __WEBPACK_IMPORTED_MODULE_3__icons__["_1055" /* BIconSearch */],
    BIconSegmentedNav: __WEBPACK_IMPORTED_MODULE_3__icons__["_1056" /* BIconSegmentedNav */],
    BIconServer: __WEBPACK_IMPORTED_MODULE_3__icons__["_1057" /* BIconServer */],
    BIconShare: __WEBPACK_IMPORTED_MODULE_3__icons__["_1058" /* BIconShare */],
    BIconShareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1059" /* BIconShareFill */],
    BIconShield: __WEBPACK_IMPORTED_MODULE_3__icons__["_1060" /* BIconShield */],
    BIconShieldCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_1061" /* BIconShieldCheck */],
    BIconShieldExclamation: __WEBPACK_IMPORTED_MODULE_3__icons__["_1062" /* BIconShieldExclamation */],
    BIconShieldFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1063" /* BIconShieldFill */],
    BIconShieldFillCheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_1064" /* BIconShieldFillCheck */],
    BIconShieldFillExclamation: __WEBPACK_IMPORTED_MODULE_3__icons__["_1065" /* BIconShieldFillExclamation */],
    BIconShieldFillMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_1066" /* BIconShieldFillMinus */],
    BIconShieldFillPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_1067" /* BIconShieldFillPlus */],
    BIconShieldFillX: __WEBPACK_IMPORTED_MODULE_3__icons__["_1068" /* BIconShieldFillX */],
    BIconShieldLock: __WEBPACK_IMPORTED_MODULE_3__icons__["_1069" /* BIconShieldLock */],
    BIconShieldLockFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1070" /* BIconShieldLockFill */],
    BIconShieldMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_1071" /* BIconShieldMinus */],
    BIconShieldPlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_1072" /* BIconShieldPlus */],
    BIconShieldShaded: __WEBPACK_IMPORTED_MODULE_3__icons__["_1073" /* BIconShieldShaded */],
    BIconShieldSlash: __WEBPACK_IMPORTED_MODULE_3__icons__["_1074" /* BIconShieldSlash */],
    BIconShieldSlashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1075" /* BIconShieldSlashFill */],
    BIconShieldX: __WEBPACK_IMPORTED_MODULE_3__icons__["_1076" /* BIconShieldX */],
    BIconShift: __WEBPACK_IMPORTED_MODULE_3__icons__["_1077" /* BIconShift */],
    BIconShiftFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1078" /* BIconShiftFill */],
    BIconShop: __WEBPACK_IMPORTED_MODULE_3__icons__["_1079" /* BIconShop */],
    BIconShopWindow: __WEBPACK_IMPORTED_MODULE_3__icons__["_1080" /* BIconShopWindow */],
    BIconShuffle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1081" /* BIconShuffle */],
    BIconSignpost: __WEBPACK_IMPORTED_MODULE_3__icons__["_1082" /* BIconSignpost */],
    BIconSignpost2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1083" /* BIconSignpost2 */],
    BIconSignpost2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1084" /* BIconSignpost2Fill */],
    BIconSignpostFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1085" /* BIconSignpostFill */],
    BIconSignpostSplit: __WEBPACK_IMPORTED_MODULE_3__icons__["_1086" /* BIconSignpostSplit */],
    BIconSignpostSplitFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1087" /* BIconSignpostSplitFill */],
    BIconSim: __WEBPACK_IMPORTED_MODULE_3__icons__["_1088" /* BIconSim */],
    BIconSimFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1089" /* BIconSimFill */],
    BIconSkipBackward: __WEBPACK_IMPORTED_MODULE_3__icons__["_1090" /* BIconSkipBackward */],
    BIconSkipBackwardBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1091" /* BIconSkipBackwardBtn */],
    BIconSkipBackwardBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1092" /* BIconSkipBackwardBtnFill */],
    BIconSkipBackwardCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1093" /* BIconSkipBackwardCircle */],
    BIconSkipBackwardCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1094" /* BIconSkipBackwardCircleFill */],
    BIconSkipBackwardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1095" /* BIconSkipBackwardFill */],
    BIconSkipEnd: __WEBPACK_IMPORTED_MODULE_3__icons__["_1096" /* BIconSkipEnd */],
    BIconSkipEndBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1097" /* BIconSkipEndBtn */],
    BIconSkipEndBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1098" /* BIconSkipEndBtnFill */],
    BIconSkipEndCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1099" /* BIconSkipEndCircle */],
    BIconSkipEndCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1100" /* BIconSkipEndCircleFill */],
    BIconSkipEndFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1101" /* BIconSkipEndFill */],
    BIconSkipForward: __WEBPACK_IMPORTED_MODULE_3__icons__["_1102" /* BIconSkipForward */],
    BIconSkipForwardBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1103" /* BIconSkipForwardBtn */],
    BIconSkipForwardBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1104" /* BIconSkipForwardBtnFill */],
    BIconSkipForwardCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1105" /* BIconSkipForwardCircle */],
    BIconSkipForwardCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1106" /* BIconSkipForwardCircleFill */],
    BIconSkipForwardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1107" /* BIconSkipForwardFill */],
    BIconSkipStart: __WEBPACK_IMPORTED_MODULE_3__icons__["_1108" /* BIconSkipStart */],
    BIconSkipStartBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1109" /* BIconSkipStartBtn */],
    BIconSkipStartBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1110" /* BIconSkipStartBtnFill */],
    BIconSkipStartCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1111" /* BIconSkipStartCircle */],
    BIconSkipStartCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1112" /* BIconSkipStartCircleFill */],
    BIconSkipStartFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1113" /* BIconSkipStartFill */],
    BIconSkype: __WEBPACK_IMPORTED_MODULE_3__icons__["_1114" /* BIconSkype */],
    BIconSlack: __WEBPACK_IMPORTED_MODULE_3__icons__["_1115" /* BIconSlack */],
    BIconSlash: __WEBPACK_IMPORTED_MODULE_3__icons__["_1116" /* BIconSlash */],
    BIconSlashCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1117" /* BIconSlashCircle */],
    BIconSlashCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1118" /* BIconSlashCircleFill */],
    BIconSlashLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_1119" /* BIconSlashLg */],
    BIconSlashSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_1120" /* BIconSlashSquare */],
    BIconSlashSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1121" /* BIconSlashSquareFill */],
    BIconSliders: __WEBPACK_IMPORTED_MODULE_3__icons__["_1122" /* BIconSliders */],
    BIconSmartwatch: __WEBPACK_IMPORTED_MODULE_3__icons__["_1123" /* BIconSmartwatch */],
    BIconSnow: __WEBPACK_IMPORTED_MODULE_3__icons__["_1124" /* BIconSnow */],
    BIconSnow2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1125" /* BIconSnow2 */],
    BIconSnow3: __WEBPACK_IMPORTED_MODULE_3__icons__["_1126" /* BIconSnow3 */],
    BIconSortAlphaDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_1127" /* BIconSortAlphaDown */],
    BIconSortAlphaDownAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_1128" /* BIconSortAlphaDownAlt */],
    BIconSortAlphaUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_1129" /* BIconSortAlphaUp */],
    BIconSortAlphaUpAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_1130" /* BIconSortAlphaUpAlt */],
    BIconSortDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_1131" /* BIconSortDown */],
    BIconSortDownAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_1132" /* BIconSortDownAlt */],
    BIconSortNumericDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_1133" /* BIconSortNumericDown */],
    BIconSortNumericDownAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_1134" /* BIconSortNumericDownAlt */],
    BIconSortNumericUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_1135" /* BIconSortNumericUp */],
    BIconSortNumericUpAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_1136" /* BIconSortNumericUpAlt */],
    BIconSortUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_1137" /* BIconSortUp */],
    BIconSortUpAlt: __WEBPACK_IMPORTED_MODULE_3__icons__["_1138" /* BIconSortUpAlt */],
    BIconSoundwave: __WEBPACK_IMPORTED_MODULE_3__icons__["_1139" /* BIconSoundwave */],
    BIconSpeaker: __WEBPACK_IMPORTED_MODULE_3__icons__["_1140" /* BIconSpeaker */],
    BIconSpeakerFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1141" /* BIconSpeakerFill */],
    BIconSpeedometer: __WEBPACK_IMPORTED_MODULE_3__icons__["_1142" /* BIconSpeedometer */],
    BIconSpeedometer2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1143" /* BIconSpeedometer2 */],
    BIconSpellcheck: __WEBPACK_IMPORTED_MODULE_3__icons__["_1144" /* BIconSpellcheck */],
    BIconSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_1145" /* BIconSquare */],
    BIconSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1146" /* BIconSquareFill */],
    BIconSquareHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_1147" /* BIconSquareHalf */],
    BIconStack: __WEBPACK_IMPORTED_MODULE_3__icons__["_1148" /* BIconStack */],
    BIconStar: __WEBPACK_IMPORTED_MODULE_3__icons__["_1149" /* BIconStar */],
    BIconStarFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1150" /* BIconStarFill */],
    BIconStarHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_1151" /* BIconStarHalf */],
    BIconStars: __WEBPACK_IMPORTED_MODULE_3__icons__["_1152" /* BIconStars */],
    BIconStickies: __WEBPACK_IMPORTED_MODULE_3__icons__["_1153" /* BIconStickies */],
    BIconStickiesFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1154" /* BIconStickiesFill */],
    BIconSticky: __WEBPACK_IMPORTED_MODULE_3__icons__["_1155" /* BIconSticky */],
    BIconStickyFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1156" /* BIconStickyFill */],
    BIconStop: __WEBPACK_IMPORTED_MODULE_3__icons__["_1157" /* BIconStop */],
    BIconStopBtn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1158" /* BIconStopBtn */],
    BIconStopBtnFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1159" /* BIconStopBtnFill */],
    BIconStopCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1160" /* BIconStopCircle */],
    BIconStopCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1161" /* BIconStopCircleFill */],
    BIconStopFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1162" /* BIconStopFill */],
    BIconStoplights: __WEBPACK_IMPORTED_MODULE_3__icons__["_1163" /* BIconStoplights */],
    BIconStoplightsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1164" /* BIconStoplightsFill */],
    BIconStopwatch: __WEBPACK_IMPORTED_MODULE_3__icons__["_1165" /* BIconStopwatch */],
    BIconStopwatchFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1166" /* BIconStopwatchFill */],
    BIconSubtract: __WEBPACK_IMPORTED_MODULE_3__icons__["_1167" /* BIconSubtract */],
    BIconSuitClub: __WEBPACK_IMPORTED_MODULE_3__icons__["_1168" /* BIconSuitClub */],
    BIconSuitClubFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1169" /* BIconSuitClubFill */],
    BIconSuitDiamond: __WEBPACK_IMPORTED_MODULE_3__icons__["_1170" /* BIconSuitDiamond */],
    BIconSuitDiamondFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1171" /* BIconSuitDiamondFill */],
    BIconSuitHeart: __WEBPACK_IMPORTED_MODULE_3__icons__["_1172" /* BIconSuitHeart */],
    BIconSuitHeartFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1173" /* BIconSuitHeartFill */],
    BIconSuitSpade: __WEBPACK_IMPORTED_MODULE_3__icons__["_1174" /* BIconSuitSpade */],
    BIconSuitSpadeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1175" /* BIconSuitSpadeFill */],
    BIconSun: __WEBPACK_IMPORTED_MODULE_3__icons__["_1176" /* BIconSun */],
    BIconSunFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1177" /* BIconSunFill */],
    BIconSunglasses: __WEBPACK_IMPORTED_MODULE_3__icons__["_1178" /* BIconSunglasses */],
    BIconSunrise: __WEBPACK_IMPORTED_MODULE_3__icons__["_1179" /* BIconSunrise */],
    BIconSunriseFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1180" /* BIconSunriseFill */],
    BIconSunset: __WEBPACK_IMPORTED_MODULE_3__icons__["_1181" /* BIconSunset */],
    BIconSunsetFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1182" /* BIconSunsetFill */],
    BIconSymmetryHorizontal: __WEBPACK_IMPORTED_MODULE_3__icons__["_1183" /* BIconSymmetryHorizontal */],
    BIconSymmetryVertical: __WEBPACK_IMPORTED_MODULE_3__icons__["_1184" /* BIconSymmetryVertical */],
    BIconTable: __WEBPACK_IMPORTED_MODULE_3__icons__["_1185" /* BIconTable */],
    BIconTablet: __WEBPACK_IMPORTED_MODULE_3__icons__["_1186" /* BIconTablet */],
    BIconTabletFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1187" /* BIconTabletFill */],
    BIconTabletLandscape: __WEBPACK_IMPORTED_MODULE_3__icons__["_1188" /* BIconTabletLandscape */],
    BIconTabletLandscapeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1189" /* BIconTabletLandscapeFill */],
    BIconTag: __WEBPACK_IMPORTED_MODULE_3__icons__["_1190" /* BIconTag */],
    BIconTagFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1191" /* BIconTagFill */],
    BIconTags: __WEBPACK_IMPORTED_MODULE_3__icons__["_1192" /* BIconTags */],
    BIconTagsFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1193" /* BIconTagsFill */],
    BIconTelegram: __WEBPACK_IMPORTED_MODULE_3__icons__["_1194" /* BIconTelegram */],
    BIconTelephone: __WEBPACK_IMPORTED_MODULE_3__icons__["_1195" /* BIconTelephone */],
    BIconTelephoneFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1196" /* BIconTelephoneFill */],
    BIconTelephoneForward: __WEBPACK_IMPORTED_MODULE_3__icons__["_1197" /* BIconTelephoneForward */],
    BIconTelephoneForwardFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1198" /* BIconTelephoneForwardFill */],
    BIconTelephoneInbound: __WEBPACK_IMPORTED_MODULE_3__icons__["_1199" /* BIconTelephoneInbound */],
    BIconTelephoneInboundFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1200" /* BIconTelephoneInboundFill */],
    BIconTelephoneMinus: __WEBPACK_IMPORTED_MODULE_3__icons__["_1201" /* BIconTelephoneMinus */],
    BIconTelephoneMinusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1202" /* BIconTelephoneMinusFill */],
    BIconTelephoneOutbound: __WEBPACK_IMPORTED_MODULE_3__icons__["_1203" /* BIconTelephoneOutbound */],
    BIconTelephoneOutboundFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1204" /* BIconTelephoneOutboundFill */],
    BIconTelephonePlus: __WEBPACK_IMPORTED_MODULE_3__icons__["_1205" /* BIconTelephonePlus */],
    BIconTelephonePlusFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1206" /* BIconTelephonePlusFill */],
    BIconTelephoneX: __WEBPACK_IMPORTED_MODULE_3__icons__["_1207" /* BIconTelephoneX */],
    BIconTelephoneXFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1208" /* BIconTelephoneXFill */],
    BIconTerminal: __WEBPACK_IMPORTED_MODULE_3__icons__["_1209" /* BIconTerminal */],
    BIconTerminalFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1210" /* BIconTerminalFill */],
    BIconTextCenter: __WEBPACK_IMPORTED_MODULE_3__icons__["_1211" /* BIconTextCenter */],
    BIconTextIndentLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_1212" /* BIconTextIndentLeft */],
    BIconTextIndentRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_1213" /* BIconTextIndentRight */],
    BIconTextLeft: __WEBPACK_IMPORTED_MODULE_3__icons__["_1214" /* BIconTextLeft */],
    BIconTextParagraph: __WEBPACK_IMPORTED_MODULE_3__icons__["_1215" /* BIconTextParagraph */],
    BIconTextRight: __WEBPACK_IMPORTED_MODULE_3__icons__["_1216" /* BIconTextRight */],
    BIconTextarea: __WEBPACK_IMPORTED_MODULE_3__icons__["_1217" /* BIconTextarea */],
    BIconTextareaResize: __WEBPACK_IMPORTED_MODULE_3__icons__["_1218" /* BIconTextareaResize */],
    BIconTextareaT: __WEBPACK_IMPORTED_MODULE_3__icons__["_1219" /* BIconTextareaT */],
    BIconThermometer: __WEBPACK_IMPORTED_MODULE_3__icons__["_1220" /* BIconThermometer */],
    BIconThermometerHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_1221" /* BIconThermometerHalf */],
    BIconThermometerHigh: __WEBPACK_IMPORTED_MODULE_3__icons__["_1222" /* BIconThermometerHigh */],
    BIconThermometerLow: __WEBPACK_IMPORTED_MODULE_3__icons__["_1223" /* BIconThermometerLow */],
    BIconThermometerSnow: __WEBPACK_IMPORTED_MODULE_3__icons__["_1224" /* BIconThermometerSnow */],
    BIconThermometerSun: __WEBPACK_IMPORTED_MODULE_3__icons__["_1225" /* BIconThermometerSun */],
    BIconThreeDots: __WEBPACK_IMPORTED_MODULE_3__icons__["_1226" /* BIconThreeDots */],
    BIconThreeDotsVertical: __WEBPACK_IMPORTED_MODULE_3__icons__["_1227" /* BIconThreeDotsVertical */],
    BIconToggle2Off: __WEBPACK_IMPORTED_MODULE_3__icons__["_1228" /* BIconToggle2Off */],
    BIconToggle2On: __WEBPACK_IMPORTED_MODULE_3__icons__["_1229" /* BIconToggle2On */],
    BIconToggleOff: __WEBPACK_IMPORTED_MODULE_3__icons__["_1230" /* BIconToggleOff */],
    BIconToggleOn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1231" /* BIconToggleOn */],
    BIconToggles: __WEBPACK_IMPORTED_MODULE_3__icons__["_1232" /* BIconToggles */],
    BIconToggles2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1233" /* BIconToggles2 */],
    BIconTools: __WEBPACK_IMPORTED_MODULE_3__icons__["_1234" /* BIconTools */],
    BIconTornado: __WEBPACK_IMPORTED_MODULE_3__icons__["_1235" /* BIconTornado */],
    BIconTranslate: __WEBPACK_IMPORTED_MODULE_3__icons__["_1236" /* BIconTranslate */],
    BIconTrash: __WEBPACK_IMPORTED_MODULE_3__icons__["_1237" /* BIconTrash */],
    BIconTrash2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1238" /* BIconTrash2 */],
    BIconTrash2Fill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1239" /* BIconTrash2Fill */],
    BIconTrashFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1240" /* BIconTrashFill */],
    BIconTree: __WEBPACK_IMPORTED_MODULE_3__icons__["_1241" /* BIconTree */],
    BIconTreeFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1242" /* BIconTreeFill */],
    BIconTriangle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1243" /* BIconTriangle */],
    BIconTriangleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1244" /* BIconTriangleFill */],
    BIconTriangleHalf: __WEBPACK_IMPORTED_MODULE_3__icons__["_1245" /* BIconTriangleHalf */],
    BIconTrophy: __WEBPACK_IMPORTED_MODULE_3__icons__["_1246" /* BIconTrophy */],
    BIconTrophyFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1247" /* BIconTrophyFill */],
    BIconTropicalStorm: __WEBPACK_IMPORTED_MODULE_3__icons__["_1248" /* BIconTropicalStorm */],
    BIconTruck: __WEBPACK_IMPORTED_MODULE_3__icons__["_1249" /* BIconTruck */],
    BIconTruckFlatbed: __WEBPACK_IMPORTED_MODULE_3__icons__["_1250" /* BIconTruckFlatbed */],
    BIconTsunami: __WEBPACK_IMPORTED_MODULE_3__icons__["_1251" /* BIconTsunami */],
    BIconTv: __WEBPACK_IMPORTED_MODULE_3__icons__["_1252" /* BIconTv */],
    BIconTvFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1253" /* BIconTvFill */],
    BIconTwitch: __WEBPACK_IMPORTED_MODULE_3__icons__["_1254" /* BIconTwitch */],
    BIconTwitter: __WEBPACK_IMPORTED_MODULE_3__icons__["_1255" /* BIconTwitter */],
    BIconType: __WEBPACK_IMPORTED_MODULE_3__icons__["_1256" /* BIconType */],
    BIconTypeBold: __WEBPACK_IMPORTED_MODULE_3__icons__["_1257" /* BIconTypeBold */],
    BIconTypeH1: __WEBPACK_IMPORTED_MODULE_3__icons__["_1258" /* BIconTypeH1 */],
    BIconTypeH2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1259" /* BIconTypeH2 */],
    BIconTypeH3: __WEBPACK_IMPORTED_MODULE_3__icons__["_1260" /* BIconTypeH3 */],
    BIconTypeItalic: __WEBPACK_IMPORTED_MODULE_3__icons__["_1261" /* BIconTypeItalic */],
    BIconTypeStrikethrough: __WEBPACK_IMPORTED_MODULE_3__icons__["_1262" /* BIconTypeStrikethrough */],
    BIconTypeUnderline: __WEBPACK_IMPORTED_MODULE_3__icons__["_1263" /* BIconTypeUnderline */],
    BIconUiChecks: __WEBPACK_IMPORTED_MODULE_3__icons__["_1264" /* BIconUiChecks */],
    BIconUiChecksGrid: __WEBPACK_IMPORTED_MODULE_3__icons__["_1265" /* BIconUiChecksGrid */],
    BIconUiRadios: __WEBPACK_IMPORTED_MODULE_3__icons__["_1266" /* BIconUiRadios */],
    BIconUiRadiosGrid: __WEBPACK_IMPORTED_MODULE_3__icons__["_1267" /* BIconUiRadiosGrid */],
    BIconUmbrella: __WEBPACK_IMPORTED_MODULE_3__icons__["_1268" /* BIconUmbrella */],
    BIconUmbrellaFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1269" /* BIconUmbrellaFill */],
    BIconUnion: __WEBPACK_IMPORTED_MODULE_3__icons__["_1270" /* BIconUnion */],
    BIconUnlock: __WEBPACK_IMPORTED_MODULE_3__icons__["_1271" /* BIconUnlock */],
    BIconUnlockFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1272" /* BIconUnlockFill */],
    BIconUpc: __WEBPACK_IMPORTED_MODULE_3__icons__["_1273" /* BIconUpc */],
    BIconUpcScan: __WEBPACK_IMPORTED_MODULE_3__icons__["_1274" /* BIconUpcScan */],
    BIconUpload: __WEBPACK_IMPORTED_MODULE_3__icons__["_1275" /* BIconUpload */],
    BIconVectorPen: __WEBPACK_IMPORTED_MODULE_3__icons__["_1276" /* BIconVectorPen */],
    BIconViewList: __WEBPACK_IMPORTED_MODULE_3__icons__["_1277" /* BIconViewList */],
    BIconViewStacked: __WEBPACK_IMPORTED_MODULE_3__icons__["_1278" /* BIconViewStacked */],
    BIconVinyl: __WEBPACK_IMPORTED_MODULE_3__icons__["_1279" /* BIconVinyl */],
    BIconVinylFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1280" /* BIconVinylFill */],
    BIconVoicemail: __WEBPACK_IMPORTED_MODULE_3__icons__["_1281" /* BIconVoicemail */],
    BIconVolumeDown: __WEBPACK_IMPORTED_MODULE_3__icons__["_1282" /* BIconVolumeDown */],
    BIconVolumeDownFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1283" /* BIconVolumeDownFill */],
    BIconVolumeMute: __WEBPACK_IMPORTED_MODULE_3__icons__["_1284" /* BIconVolumeMute */],
    BIconVolumeMuteFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1285" /* BIconVolumeMuteFill */],
    BIconVolumeOff: __WEBPACK_IMPORTED_MODULE_3__icons__["_1286" /* BIconVolumeOff */],
    BIconVolumeOffFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1287" /* BIconVolumeOffFill */],
    BIconVolumeUp: __WEBPACK_IMPORTED_MODULE_3__icons__["_1288" /* BIconVolumeUp */],
    BIconVolumeUpFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1289" /* BIconVolumeUpFill */],
    BIconVr: __WEBPACK_IMPORTED_MODULE_3__icons__["_1290" /* BIconVr */],
    BIconWallet: __WEBPACK_IMPORTED_MODULE_3__icons__["_1291" /* BIconWallet */],
    BIconWallet2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1292" /* BIconWallet2 */],
    BIconWalletFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1293" /* BIconWalletFill */],
    BIconWatch: __WEBPACK_IMPORTED_MODULE_3__icons__["_1294" /* BIconWatch */],
    BIconWater: __WEBPACK_IMPORTED_MODULE_3__icons__["_1295" /* BIconWater */],
    BIconWhatsapp: __WEBPACK_IMPORTED_MODULE_3__icons__["_1296" /* BIconWhatsapp */],
    BIconWifi: __WEBPACK_IMPORTED_MODULE_3__icons__["_1297" /* BIconWifi */],
    BIconWifi1: __WEBPACK_IMPORTED_MODULE_3__icons__["_1298" /* BIconWifi1 */],
    BIconWifi2: __WEBPACK_IMPORTED_MODULE_3__icons__["_1299" /* BIconWifi2 */],
    BIconWifiOff: __WEBPACK_IMPORTED_MODULE_3__icons__["_1300" /* BIconWifiOff */],
    BIconWind: __WEBPACK_IMPORTED_MODULE_3__icons__["_1301" /* BIconWind */],
    BIconWindow: __WEBPACK_IMPORTED_MODULE_3__icons__["_1302" /* BIconWindow */],
    BIconWindowDock: __WEBPACK_IMPORTED_MODULE_3__icons__["_1303" /* BIconWindowDock */],
    BIconWindowSidebar: __WEBPACK_IMPORTED_MODULE_3__icons__["_1304" /* BIconWindowSidebar */],
    BIconWrench: __WEBPACK_IMPORTED_MODULE_3__icons__["_1305" /* BIconWrench */],
    BIconX: __WEBPACK_IMPORTED_MODULE_3__icons__["_1306" /* BIconX */],
    BIconXCircle: __WEBPACK_IMPORTED_MODULE_3__icons__["_1307" /* BIconXCircle */],
    BIconXCircleFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1308" /* BIconXCircleFill */],
    BIconXDiamond: __WEBPACK_IMPORTED_MODULE_3__icons__["_1309" /* BIconXDiamond */],
    BIconXDiamondFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1310" /* BIconXDiamondFill */],
    BIconXLg: __WEBPACK_IMPORTED_MODULE_3__icons__["_1311" /* BIconXLg */],
    BIconXOctagon: __WEBPACK_IMPORTED_MODULE_3__icons__["_1312" /* BIconXOctagon */],
    BIconXOctagonFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1313" /* BIconXOctagonFill */],
    BIconXSquare: __WEBPACK_IMPORTED_MODULE_3__icons__["_1314" /* BIconXSquare */],
    BIconXSquareFill: __WEBPACK_IMPORTED_MODULE_3__icons__["_1315" /* BIconXSquareFill */],
    BIconYoutube: __WEBPACK_IMPORTED_MODULE_3__icons__["_1316" /* BIconYoutube */],
    BIconZoomIn: __WEBPACK_IMPORTED_MODULE_3__icons__["_1317" /* BIconZoomIn */],
    BIconZoomOut: __WEBPACK_IMPORTED_MODULE_3__icons__["_1318" /* BIconZoomOut */]
  }
}); // Export the BootstrapVueIcons plugin installer
// Mainly for the stand-alone bootstrap-vue-icons.xxx.js builds

var BootstrapVueIcons = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["c" /* pluginFactoryNoConfig */])({
  plugins: {
    IconsPlugin: IconsPlugin
  }
}, {
  NAME: 'BootstrapVueIcons'
}); // --- END AUTO-GENERATED FILE ---

/***/ }),
/* 457 */
/* exports provided: MODEL_PROP_NAME, MODEL_EVENT_NAME, props, formRadioCheckGroupMixin */
/* exports used: props, formRadioCheckGroupMixin, MODEL_PROP_NAME */
/*!**************************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-radio-check-group.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODEL_PROP_NAME; });
/* unused harmony export MODEL_EVENT_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formRadioCheckGroupMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_slots__ = __webpack_require__(/*! ../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__ = __webpack_require__(/*! ../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_model__ = __webpack_require__(/*! ../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_form_checkbox_form_checkbox__ = __webpack_require__(/*! ../components/form-checkbox/form-checkbox */ 217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_form_radio_form_radio__ = __webpack_require__(/*! ../components/form-radio/form-radio */ 218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_control__ = __webpack_require__(/*! ./form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_custom__ = __webpack_require__(/*! ./form-custom */ 182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__form_options__ = __webpack_require__(/*! ./form-options */ 183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_size__ = __webpack_require__(/*! ./form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__form_state__ = __webpack_require__(/*! ./form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__id__ = __webpack_require__(/*! ./id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__normalize_slot__ = __webpack_require__(/*! ./normalize-slot */ 15);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















 // --- Constants ---
// Attributes to pass down to checks/radios instead of applying them to the group

var PASS_DOWN_ATTRS = ['aria-describedby', 'aria-labelledby'];

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_model__["a" /* makeModelMixin */])('checked'),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_15__id__["a" /* props */]), modelProps), __WEBPACK_IMPORTED_MODULE_10__form_control__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__form_options__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_13__form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_14__form_state__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__form_custom__["a" /* props */]), {}, {
  ariaInvalid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  // Only applicable when rendered with button style
  buttonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Render as button style
  buttons: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  stacked: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  validated: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), 'formRadioCheckGroups'); // --- Mixin ---
// @vue/component

var formRadioCheckGroupMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_15__id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_16__normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_10__form_control__["b" /* formControlMixin */], __WEBPACK_IMPORTED_MODULE_12__form_options__["b" /* formOptionsMixin */], __WEBPACK_IMPORTED_MODULE_13__form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_14__form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_11__form_custom__["b" /* formCustomMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      localChecked: this[MODEL_PROP_NAME]
    };
  },
  computed: {
    inline: function inline() {
      return !this.stacked;
    },
    groupName: function groupName() {
      // Checks/Radios tied to the same model must have the same name,
      // especially for ARIA accessibility
      return this.name || this.safeId();
    },
    groupClasses: function groupClasses() {
      var inline = this.inline,
          size = this.size,
          validated = this.validated;
      var classes = {
        'was-validated': validated
      };

      if (this.buttons) {
        classes = [classes, 'btn-group-toggle', _defineProperty({
          'btn-group': inline,
          'btn-group-vertical': !inline
        }, "btn-group-".concat(size), size)];
      }

      return classes;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__["a" /* looseEqual */])(newValue, this.localChecked)) {
      this.localChecked = newValue;
    }
  }), _defineProperty(_watch, "localChecked", function localChecked(newValue, oldValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      this.$emit(MODEL_EVENT_NAME, newValue);
    }
  }), _watch),
  render: function render(h) {
    var _this = this;

    var isRadioGroup = this.isRadioGroup;
    var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["k" /* pick */])(this.$attrs, PASS_DOWN_ATTRS);
    var optionComponent = isRadioGroup ? __WEBPACK_IMPORTED_MODULE_9__components_form_radio_form_radio__["a" /* BFormRadio */] : __WEBPACK_IMPORTED_MODULE_8__components_form_checkbox_form_checkbox__["a" /* BFormCheckbox */];
    var $inputs = this.formOptions.map(function (option, index) {
      var key = "BV_option_".concat(index);
      return h(optionComponent, {
        props: {
          // Individual radios or checks can be disabled in a group
          disabled: option.disabled || false,
          id: _this.safeId(key),
          value: option.value // We don't need to include these, since the input's will know they are inside here
          // form: this.form || null,
          // name: this.groupName,
          // required: Boolean(this.name && this.required),
          // state: this.state

        },
        attrs: attrs,
        key: key
      }, [h('span', {
        domProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(option.html, option.text)
      })]);
    });
    return h('div', {
      class: [this.groupClasses, 'bv-no-focus-ring'],
      attrs: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["m" /* omit */])(this.$attrs, PASS_DOWN_ATTRS)), {}, {
        'aria-invalid': this.computedAriaInvalid,
        'aria-required': this.required ? 'true' : null,
        id: this.safeId(),
        role: isRadioGroup ? 'radiogroup' : 'group',
        // Add `tabindex="-1"` to allow group to be focused if needed by screen readers
        tabindex: '-1'
      })
    }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_2__constants_slots__["Q" /* SLOT_NAME_FIRST */]), $inputs, this.normalizeSlot()]);
  }
});

/***/ }),
/* 458 */
/* exports provided: MODEL_PROP_NAME, MODEL_EVENT_NAME, props, formRadioCheckMixin */
/* exports used: props, formRadioCheckMixin, MODEL_EVENT_NAME */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-radio-check.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MODEL_PROP_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODEL_EVENT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formRadioCheckMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(/*! ../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__ = __webpack_require__(/*! ../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_model__ = __webpack_require__(/*! ../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__attrs__ = __webpack_require__(/*! ./attrs */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_control__ = __webpack_require__(/*! ./form-control */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__form_custom__ = __webpack_require__(/*! ./form-custom */ 182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__form_size__ = __webpack_require__(/*! ./form-size */ 80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form_state__ = __webpack_require__(/*! ./form-state */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__id__ = __webpack_require__(/*! ./id */ 27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__normalize_slot__ = __webpack_require__(/*! ./normalize-slot */ 15);
var _watch, _methods;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_model__["a" /* makeModelMixin */])('checked', {
  defaultValue: null
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_14__id__["a" /* props */]), modelProps), __WEBPACK_IMPORTED_MODULE_10__form_control__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_12__form_size__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_13__form_state__["a" /* props */]), __WEBPACK_IMPORTED_MODULE_11__form_custom__["a" /* props */]), {}, {
  ariaLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  ariaLabelledby: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Only applicable in standalone mode (non group)
  button: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Only applicable when rendered with button style
  buttonVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  inline: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["f" /* PROP_TYPE_ANY */])
})), 'formRadioCheckControls'); // --- Mixin ---
// @vue/component

var formRadioCheckMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__attrs__["a" /* attrsMixin */], __WEBPACK_IMPORTED_MODULE_14__id__["b" /* idMixin */], modelMixin, __WEBPACK_IMPORTED_MODULE_15__normalize_slot__["a" /* normalizeSlotMixin */], __WEBPACK_IMPORTED_MODULE_10__form_control__["b" /* formControlMixin */], __WEBPACK_IMPORTED_MODULE_12__form_size__["b" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_13__form_state__["b" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_11__form_custom__["b" /* formCustomMixin */]],
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      localChecked: this.isGroup ? this.bvGroup[MODEL_PROP_NAME] : this[MODEL_PROP_NAME],
      hasFocus: false
    };
  },
  computed: {
    computedLocalChecked: {
      get: function get() {
        return this.isGroup ? this.bvGroup.localChecked : this.localChecked;
      },
      set: function set(value) {
        if (this.isGroup) {
          this.bvGroup.localChecked = value;
        } else {
          this.localChecked = value;
        }
      }
    },
    isChecked: function isChecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(this.value, this.computedLocalChecked);
    },
    isRadio: function isRadio() {
      return true;
    },
    isGroup: function isGroup() {
      // Is this check/radio a child of check-group or radio-group?
      return !!this.bvGroup;
    },
    isBtnMode: function isBtnMode() {
      // Support button style in single input mode
      return this.isGroup ? this.bvGroup.buttons : this.button;
    },
    isPlain: function isPlain() {
      return this.isBtnMode ? false : this.isGroup ? this.bvGroup.plain : this.plain;
    },
    isCustom: function isCustom() {
      return this.isBtnMode ? false : !this.isPlain;
    },
    isSwitch: function isSwitch() {
      // Custom switch styling (checkboxes only)
      return this.isBtnMode || this.isRadio || this.isPlain ? false : this.isGroup ? this.bvGroup.switches : this.switch;
    },
    isInline: function isInline() {
      return this.isGroup ? this.bvGroup.inline : this.inline;
    },
    isDisabled: function isDisabled() {
      // Child can be disabled while parent isn't, but is always disabled if group is
      return this.isGroup ? this.bvGroup.disabled || this.disabled : this.disabled;
    },
    isRequired: function isRequired() {
      // Required only works when a name is provided for the input(s)
      // Child can only be required when parent is
      // Groups will always have a name (either user supplied or auto generated)
      return this.computedName && (this.isGroup ? this.bvGroup.required : this.required);
    },
    computedName: function computedName() {
      // Group name preferred over local name
      return (this.isGroup ? this.bvGroup.groupName : this.name) || null;
    },
    computedForm: function computedForm() {
      return (this.isGroup ? this.bvGroup.form : this.form) || null;
    },
    computedSize: function computedSize() {
      return (this.isGroup ? this.bvGroup.size : this.size) || '';
    },
    computedState: function computedState() {
      return this.isGroup ? this.bvGroup.computedState : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["k" /* isBoolean */])(this.state) ? this.state : null;
    },
    computedButtonVariant: function computedButtonVariant() {
      // Local variant preferred over group variant
      var buttonVariant = this.buttonVariant;

      if (buttonVariant) {
        return buttonVariant;
      }

      if (this.isGroup && this.bvGroup.buttonVariant) {
        return this.bvGroup.buttonVariant;
      }

      return 'secondary';
    },
    buttonClasses: function buttonClasses() {
      var _ref;

      var computedSize = this.computedSize;
      return ['btn', "btn-".concat(this.computedButtonVariant), (_ref = {}, _defineProperty(_ref, "btn-".concat(computedSize), computedSize), _defineProperty(_ref, "disabled", this.isDisabled), _defineProperty(_ref, "active", this.isChecked), _defineProperty(_ref, "focus", this.hasFocus), _ref)];
    },
    computedAttrs: function computedAttrs() {
      var disabled = this.isDisabled,
          required = this.isRequired;
      return _objectSpread(_objectSpread({}, this.bvAttrs), {}, {
        id: this.safeId(),
        type: this.isRadio ? 'radio' : 'checkbox',
        name: this.computedName,
        form: this.computedForm,
        disabled: disabled,
        required: required,
        'aria-required': required || null,
        'aria-label': this.ariaLabel || null,
        'aria-labelledby': this.ariaLabelledby || null
      });
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function () {
    this["".concat(MODEL_PROP_NAME, "Watcher")].apply(this, arguments);
  }), _defineProperty(_watch, "computedLocalChecked", function computedLocalChecked() {
    this.computedLocalCheckedWatcher.apply(this, arguments);
  }), _watch),
  methods: (_methods = {}, _defineProperty(_methods, "".concat(MODEL_PROP_NAME, "Watcher"), function Watcher(newValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(newValue, this.computedLocalChecked)) {
      this.computedLocalChecked = newValue;
    }
  }), _defineProperty(_methods, "computedLocalCheckedWatcher", function computedLocalCheckedWatcher(newValue, oldValue) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
      this.$emit(MODEL_EVENT_NAME, newValue);
    }
  }), _defineProperty(_methods, "handleChange", function handleChange(_ref2) {
    var _this = this;

    var checked = _ref2.target.checked;
    var value = this.value;
    var localChecked = checked ? value : null;
    this.computedLocalChecked = value; // Fire events in a `$nextTick()` to ensure the `v-model` is updated

    this.$nextTick(function () {
      // Change is only emitted on user interaction
      _this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */], localChecked); // If this is a child of a group, we emit a change event on it as well


      if (_this.isGroup) {
        _this.bvGroup.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["w" /* EVENT_NAME_CHANGE */], localChecked);
      }
    });
  }), _defineProperty(_methods, "handleFocus", function handleFocus(event) {
    // When in buttons mode, we need to add 'focus' class to label when input focused
    // As it is the hidden input which has actual focus
    if (event.target) {
      if (event.type === 'focus') {
        this.hasFocus = true;
      } else if (event.type === 'blur') {
        this.hasFocus = false;
      }
    }
  }), _defineProperty(_methods, "focus", function focus() {
    if (!this.isDisabled) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["n" /* attemptFocus */])(this.$refs.input);
    }
  }), _defineProperty(_methods, "blur", function blur() {
    if (!this.isDisabled) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["A" /* attemptBlur */])(this.$refs.input);
    }
  }), _methods),
  render: function render(h) {
    var isRadio = this.isRadio,
        isBtnMode = this.isBtnMode,
        isPlain = this.isPlain,
        isCustom = this.isCustom,
        isInline = this.isInline,
        isSwitch = this.isSwitch,
        computedSize = this.computedSize,
        bvAttrs = this.bvAttrs;
    var $content = this.normalizeSlot();
    var $input = h('input', {
      class: [{
        'form-check-input': isPlain,
        'custom-control-input': isCustom,
        // https://github.com/bootstrap-vue/bootstrap-vue/issues/2911
        'position-static': isPlain && !$content
      }, isBtnMode ? '' : this.stateClass],
      directives: [{
        name: 'model',
        value: this.computedLocalChecked
      }],
      attrs: this.computedAttrs,
      domProps: {
        value: this.value,
        checked: this.isChecked
      },
      on: _objectSpread({
        change: this.handleChange
      }, isBtnMode ? {
        focus: this.handleFocus,
        blur: this.handleFocus
      } : {}),
      key: 'input',
      ref: 'input'
    });

    if (isBtnMode) {
      var $button = h('label', {
        class: this.buttonClasses
      }, [$input, $content]);

      if (!this.isGroup) {
        // Standalone button mode, so wrap in 'btn-group-toggle'
        // and flag it as inline-block to mimic regular buttons
        $button = h('div', {
          class: ['btn-group-toggle', 'd-inline-block']
        }, [$button]);
      }

      return $button;
    } // If no label content in plain mode we dont render the label
    // See: https://github.com/bootstrap-vue/bootstrap-vue/issues/2911


    var $label = h();

    if (!(isPlain && !$content)) {
      $label = h('label', {
        class: {
          'form-check-label': isPlain,
          'custom-control-label': isCustom
        },
        attrs: {
          for: this.safeId()
        }
      }, $content);
    }

    return h('div', {
      class: [_defineProperty({
        'form-check': isPlain,
        'form-check-inline': isPlain && isInline,
        'custom-control': isCustom,
        'custom-control-inline': isCustom && isInline,
        'custom-checkbox': isCustom && !isRadio && !isSwitch,
        'custom-switch': isSwitch,
        'custom-radio': isCustom && isRadio
      }, "b-custom-control-".concat(computedSize), computedSize && !isBtnMode), bvAttrs.class],
      style: bvAttrs.style
    }, [$input, $label]);
  }
});

/***/ }),
/* 459 */
/* exports provided: formSelectionMixin */
/* exports used: formSelectionMixin */
/*!******************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-selection.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formSelectionMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
 // @vue/component

var formSelectionMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  computed: {
    selectionStart: {
      // Expose selectionStart for formatters, etc
      cache: false,

      /* istanbul ignore next */
      get: function get() {
        return this.$refs.input.selectionStart;
      },

      /* istanbul ignore next */
      set: function set(val) {
        this.$refs.input.selectionStart = val;
      }
    },
    selectionEnd: {
      // Expose selectionEnd for formatters, etc
      cache: false,

      /* istanbul ignore next */
      get: function get() {
        return this.$refs.input.selectionEnd;
      },

      /* istanbul ignore next */
      set: function set(val) {
        this.$refs.input.selectionEnd = val;
      }
    },
    selectionDirection: {
      // Expose selectionDirection for formatters, etc
      cache: false,

      /* istanbul ignore next */
      get: function get() {
        return this.$refs.input.selectionDirection;
      },

      /* istanbul ignore next */
      set: function set(val) {
        this.$refs.input.selectionDirection = val;
      }
    }
  },
  methods: {
    /* istanbul ignore next */
    select: function select() {
      var _this$$refs$input;

      // For external handler that may want a select() method
      (_this$$refs$input = this.$refs.input).select.apply(_this$$refs$input, arguments);
    },

    /* istanbul ignore next */
    setSelectionRange: function setSelectionRange() {
      var _this$$refs$input2;

      // For external handler that may want a setSelectionRange(a,b,c) method
      (_this$$refs$input2 = this.$refs.input).setSelectionRange.apply(_this$$refs$input2, arguments);
    },

    /* istanbul ignore next */
    setRangeText: function setRangeText() {
      var _this$$refs$input3;

      // For external handler that may want a setRangeText(a,b,c) method
      (_this$$refs$input3 = this.$refs.input).setRangeText.apply(_this$$refs$input3, arguments);
    }
  }
});

/***/ }),
/* 460 */
/* exports provided: MODEL_PROP_NAME, MODEL_EVENT_NAME, props, formTextMixin */
/* exports used: props, formTextMixin */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-text.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MODEL_PROP_NAME */
/* unused harmony export MODEL_EVENT_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formTextMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(/*! ../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__(/*! ../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_math__ = __webpack_require__(/*! ../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_model__ = __webpack_require__(/*! ../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_number__ = __webpack_require__(/*! ../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_string__ = __webpack_require__(/*! ../utils/string */ 23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











 // --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */],
  defaultValue: '',
  event: __WEBPACK_IMPORTED_MODULE_1__constants_events__["X" /* EVENT_NAME_UPDATE */]
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, modelProps), {}, {
  ariaInvalid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["m" /* PROP_TYPE_BOOLEAN_STRING */], false),
  autocomplete: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Debounce timeout (in ms). Not applicable with `lazy` prop
  debounce: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  formatter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  // Only update the `v-model` on blur/change events
  lazy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  lazyFormatter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  number: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  placeholder: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */]),
  plaintext: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  readonly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  trim: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
})), 'formTextControls'); // --- Mixin ---
// @vue/component

var formTextMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [modelMixin],
  props: props,
  data: function data() {
    var value = this[MODEL_PROP_NAME];
    return {
      localValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* toString */])(value),
      vModelValue: this.modifyValue(value)
    };
  },
  computed: {
    computedClass: function computedClass() {
      var plaintext = this.plaintext,
          type = this.type;
      var isRange = type === 'range';
      var isColor = type === 'color';
      return [{
        // Range input needs class `custom-range`
        'custom-range': isRange,
        // `plaintext` not supported by `type="range"` or `type="color"`
        'form-control-plaintext': plaintext && !isRange && !isColor,
        // `form-control` not used by `type="range"` or `plaintext`
        // Always used by `type="color"`
        'form-control': isColor || !plaintext && !isRange
      }, this.sizeFormClass, this.stateClass];
    },
    computedDebounce: function computedDebounce() {
      // Ensure we have a positive number equal to or greater than 0
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_number__["b" /* toInteger */])(this.debounce, 0), 0);
    },
    hasFormatter: function hasFormatter() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["d" /* hasPropFunction */])(this.formatter);
    }
  },
  watch: _defineProperty({}, MODEL_PROP_NAME, function (newValue) {
    var stringifyValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* toString */])(newValue);
    var modifiedValue = this.modifyValue(newValue);

    if (stringifyValue !== this.localValue || modifiedValue !== this.vModelValue) {
      // Clear any pending debounce timeout, as we are overwriting the user input
      this.clearDebounce(); // Update the local values

      this.localValue = stringifyValue;
      this.vModelValue = modifiedValue;
    }
  }),
  created: function created() {
    // Create private non-reactive props
    this.$_inputDebounceTimer = null;
  },
  beforeDestroy: function beforeDestroy() {
    this.clearDebounce();
  },
  methods: {
    clearDebounce: function clearDebounce() {
      clearTimeout(this.$_inputDebounceTimer);
      this.$_inputDebounceTimer = null;
    },
    formatValue: function formatValue(value, event) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* toString */])(value);

      if (this.hasFormatter && (!this.lazyFormatter || force)) {
        value = this.formatter(value, event);
      }

      return value;
    },
    modifyValue: function modifyValue(value) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* toString */])(value); // Emulate `.trim` modifier behaviour

      if (this.trim) {
        value = value.trim();
      } // Emulate `.number` modifier behaviour


      if (this.number) {
        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_number__["a" /* toFloat */])(value, value);
      }

      return value;
    },
    updateValue: function updateValue(value) {
      var _this = this;

      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var lazy = this.lazy;

      if (lazy && !force) {
        return;
      } // Make sure to always clear the debounce when `updateValue()`
      // is called, even when the v-model hasn't changed


      this.clearDebounce(); // Define the shared update logic in a method to be able to use
      // it for immediate and debounced value changes

      var doUpdate = function doUpdate() {
        value = _this.modifyValue(value);

        if (value !== _this.vModelValue) {
          _this.vModelValue = value;

          _this.$emit(MODEL_EVENT_NAME, value);
        } else if (_this.hasFormatter) {
          // When the `vModelValue` hasn't changed but the actual input value
          // is out of sync, make sure to change it to the given one
          // Usually caused by browser autocomplete and how it triggers the
          // change or input event, or depending on the formatter function
          // https://github.com/bootstrap-vue/bootstrap-vue/issues/2657
          // https://github.com/bootstrap-vue/bootstrap-vue/issues/3498

          /* istanbul ignore next: hard to test */
          var $input = _this.$refs.input;
          /* istanbul ignore if: hard to test out of sync value */

          if ($input && value !== $input.value) {
            $input.value = value;
          }
        }
      }; // Only debounce the value update when a value greater than `0`
      // is set and we are not in lazy mode or this is a forced update


      var debounce = this.computedDebounce;

      if (debounce > 0 && !lazy && !force) {
        this.$_inputDebounceTimer = setTimeout(doUpdate, debounce);
      } else {
        // Immediately update the v-model
        doUpdate();
      }
    },
    onInput: function onInput(event) {
      // `event.target.composing` is set by Vue
      // https://github.com/vuejs/vue/blob/dev/src/platforms/web/runtime/directives/model.js
      // TODO: Is this needed now with the latest Vue?

      /* istanbul ignore if: hard to test composition events */
      if (event.target.composing) {
        return;
      }

      var value = event.target.value;
      var formattedValue = this.formatValue(value, event); // Exit when the `formatter` function strictly returned `false`
      // or prevented the input event

      /* istanbul ignore next */

      if (formattedValue === false || event.defaultPrevented) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        return;
      }

      this.localValue = formattedValue;
      this.updateValue(formattedValue);
      this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["y" /* EVENT_NAME_INPUT */], formattedValue);
    },
    onChange: function onChange(event) {
      var value = event.target.value;
      var formattedValue = this.formatValue(value, event); // Exit when the `formatter` function strictly returned `false`
      // or prevented the input event

      /* istanbul ignore next */

      if (formattedValue === false || event.defaultPrevented) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        return;
      }

      this.localValue = formattedValue;
      this.updateValue(formattedValue, true);
      this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["w" /* EVENT_NAME_CHANGE */], formattedValue);
    },
    onBlur: function onBlur(event) {
      // Apply the `localValue` on blur to prevent cursor jumps
      // on mobile browsers (e.g. caused by autocomplete)
      var value = event.target.value;
      var formattedValue = this.formatValue(value, event, true);

      if (formattedValue !== false) {
        // We need to use the modified value here to apply the
        // `.trim` and `.number` modifiers properly
        this.localValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_string__["a" /* toString */])(this.modifyValue(formattedValue)); // We pass the formatted value here since the `updateValue` method
        // handles the modifiers itself

        this.updateValue(formattedValue, true);
      } // Emit native blur event


      this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["Y" /* EVENT_NAME_BLUR */], event);
    },
    focus: function focus() {
      // For external handler that may want a focus method
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["n" /* attemptFocus */])(this.$el);
      }
    },
    blur: function blur() {
      // For external handler that may want a blur method
      if (!this.disabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["A" /* attemptBlur */])(this.$el);
      }
    }
  }
});

/***/ }),
/* 461 */
/* exports provided: formValidityMixin */
/* exports used: formValidityMixin */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/form-validity.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formValidityMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
 // @vue/component

var formValidityMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  computed: {
    validity: {
      // Expose validity property
      cache: false,

      /* istanbul ignore next */
      get: function get() {
        return this.$refs.input.validity;
      }
    },
    validationMessage: {
      // Expose validationMessage property
      cache: false,

      /* istanbul ignore next */
      get: function get() {
        return this.$refs.input.validationMessage;
      }
    },
    willValidate: {
      // Expose willValidate property
      cache: false,

      /* istanbul ignore next */
      get: function get() {
        return this.$refs.input.willValidate;
      }
    }
  },
  methods: {
    /* istanbul ignore next */
    setCustomValidity: function setCustomValidity() {
      var _this$$refs$input;

      // For external handler that may want a setCustomValidity(...) method
      return (_this$$refs$input = this.$refs.input).setCustomValidity.apply(_this$$refs$input, arguments);
    },

    /* istanbul ignore next */
    checkValidity: function checkValidity() {
      var _this$$refs$input2;

      // For external handler that may want a checkValidity(...) method
      return (_this$$refs$input2 = this.$refs.input).checkValidity.apply(_this$$refs$input2, arguments);
    },

    /* istanbul ignore next */
    reportValidity: function reportValidity() {
      var _this$$refs$input3;

      // For external handler that may want a reportValidity(...) method
      return (_this$$refs$input3 = this.$refs.input).reportValidity.apply(_this$$refs$input3, arguments);
    }
  }
});

/***/ }),
/* 462 */
/* exports provided: MODEL_PROP_NAME, MODEL_EVENT_NAME, props, paginationMixin */
/* exports used: props, paginationMixin, MODEL_PROP_NAME */
/*!**************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/pagination.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODEL_PROP_NAME; });
/* unused harmony export MODEL_EVENT_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return paginationMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__ = __webpack_require__(/*! ../constants/key-codes */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_slots__ = __webpack_require__(/*! ../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array__ = __webpack_require__(/*! ../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_events__ = __webpack_require__(/*! ../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_inspect__ = __webpack_require__(/*! ../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_math__ = __webpack_require__(/*! ../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_model__ = __webpack_require__(/*! ../utils/model */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_number__ = __webpack_require__(/*! ../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_props__ = __webpack_require__(/*! ../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_safe_vue_instance__ = __webpack_require__(/*! ../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_string__ = __webpack_require__(/*! ../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_warn__ = __webpack_require__(/*! ../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_normalize_slot__ = __webpack_require__(/*! ../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_link_link__ = __webpack_require__(/*! ../components/link/link */ 53);
var _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















 // Common props, computed, data, render function, and methods
// for `<b-pagination>` and `<b-pagination-nav>`
// --- Constants ---

var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_model__["a" /* makeModelMixin */])('value', {
  type: __WEBPACK_IMPORTED_MODULE_3__constants_props__["r" /* PROP_TYPE_BOOLEAN_NUMBER_STRING */],
  defaultValue: null,

  /* istanbul ignore next */
  validator: function validator(value) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["e" /* isNull */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(value, 0) < 1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_warn__["a" /* warn */])('"v-model" value must be a number greater than "0"', __WEBPACK_IMPORTED_MODULE_1__constants_components__["M" /* NAME_PAGINATION */]);
      return false;
    }

    return true;
  }
}),
    modelMixin = _makeModelMixin.mixin,
    modelProps = _makeModelMixin.props,
    MODEL_PROP_NAME = _makeModelMixin.prop,
    MODEL_EVENT_NAME = _makeModelMixin.event;

 // Threshold of limit size when we start/stop showing ellipsis

var ELLIPSIS_THRESHOLD = 3; // Default # of buttons limit

var DEFAULT_LIMIT = 5; // --- Helper methods ---
// Make an array of N to N+X

var makePageArray = function makePageArray(startNumber, numberOfPages) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["d" /* createArray */])(numberOfPages, function (_, i) {
    return {
      number: startNumber + i,
      classes: null
    };
  });
}; // Sanitize the provided limit value (converting to a number)


var sanitizeLimit = function sanitizeLimit(value) {
  var limit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(value) || 1;
  return limit < 1 ? DEFAULT_LIMIT : limit;
}; // Sanitize the provided current page number (converting to a number)


var sanitizeCurrentPage = function sanitizeCurrentPage(val, numberOfPages) {
  var page = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(val) || 1;
  return page > numberOfPages ? numberOfPages : page < 1 ? 1 : page;
}; // Links don't normally respond to SPACE, so we add that
// functionality via this handler


var onSpaceKey = function onSpaceKey(event) {
  if (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["b" /* CODE_SPACE */]) {
    // Stop page from scrolling
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event, {
      immediatePropagation: true
    }); // Trigger the click event on the link

    event.currentTarget.click();
    return false;
  }
}; // --- Props ---


var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, modelProps), {}, {
  align: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'left'),
  ariaLabel: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Pagination'),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  ellipsisClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  ellipsisText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], "\u2026"),
  // '…'
  firstClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  firstNumber: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  firstText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], "\xAB"),
  // '«'
  hideEllipsis: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  hideGotoEndButtons: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  labelFirstPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Go to first page'),
  labelLastPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Go to last page'),
  labelNextPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Go to next page'),
  labelPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["s" /* PROP_TYPE_FUNCTION_STRING */], 'Go to page'),
  labelPrevPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'Go to previous page'),
  lastClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  lastNumber: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  lastText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], "\xBB"),
  // '»'
  limit: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], DEFAULT_LIMIT,
  /* istanbul ignore next */
  function (value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(value, 0) < 1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__utils_warn__["a" /* warn */])('Prop "limit" must be a number greater than "0"', __WEBPACK_IMPORTED_MODULE_1__constants_components__["M" /* NAME_PAGINATION */]);
      return false;
    }

    return true;
  }),
  nextClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  nextText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], "\u203A"),
  // '›'
  pageClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  pills: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  prevClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  prevText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], "\u2039"),
  // '‹'
  size: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */])
})), 'pagination'); // --- Mixin ---
// @vue/component

var paginationMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [modelMixin, __WEBPACK_IMPORTED_MODULE_17__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  data: function data() {
    // `-1` signifies no page initially selected
    var currentPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(this[MODEL_PROP_NAME], 0);
    currentPage = currentPage > 0 ? currentPage : -1;
    return {
      currentPage: currentPage,
      localNumberOfPages: 1,
      localLimit: DEFAULT_LIMIT
    };
  },
  computed: {
    btnSize: function btnSize() {
      var size = this.size;
      return size ? "pagination-".concat(size) : '';
    },
    alignment: function alignment() {
      var align = this.align;

      if (align === 'center') {
        return 'justify-content-center';
      } else if (align === 'end' || align === 'right') {
        return 'justify-content-end';
      } else if (align === 'fill') {
        // The page-items will also have 'flex-fill' added
        // We add text centering to make the button appearance better in fill mode
        return 'text-center';
      }

      return '';
    },
    styleClass: function styleClass() {
      return this.pills ? 'b-pagination-pills' : '';
    },
    computedCurrentPage: function computedCurrentPage() {
      return sanitizeCurrentPage(this.currentPage, this.localNumberOfPages);
    },
    paginationParams: function paginationParams() {
      // Determine if we should show the the ellipsis
      var limit = this.localLimit,
          numberOfPages = this.localNumberOfPages,
          currentPage = this.computedCurrentPage,
          hideEllipsis = this.hideEllipsis,
          firstNumber = this.firstNumber,
          lastNumber = this.lastNumber;
      var showFirstDots = false;
      var showLastDots = false;
      var numberOfLinks = limit;
      var startNumber = 1;

      if (numberOfPages <= limit) {
        // Special case: Less pages available than the limit of displayed pages
        numberOfLinks = numberOfPages;
      } else if (currentPage < limit - 1 && limit > ELLIPSIS_THRESHOLD) {
        if (!hideEllipsis || lastNumber) {
          showLastDots = true;
          numberOfLinks = limit - (firstNumber ? 0 : 1);
        }

        numberOfLinks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["e" /* mathMin */])(numberOfLinks, limit);
      } else if (numberOfPages - currentPage + 2 < limit && limit > ELLIPSIS_THRESHOLD) {
        if (!hideEllipsis || firstNumber) {
          showFirstDots = true;
          numberOfLinks = limit - (lastNumber ? 0 : 1);
        }

        startNumber = numberOfPages - numberOfLinks + 1;
      } else {
        // We are somewhere in the middle of the page list
        if (limit > ELLIPSIS_THRESHOLD) {
          numberOfLinks = limit - (hideEllipsis ? 0 : 2);
          showFirstDots = !!(!hideEllipsis || firstNumber);
          showLastDots = !!(!hideEllipsis || lastNumber);
        }

        startNumber = currentPage - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["c" /* mathFloor */])(numberOfLinks / 2);
      } // Sanity checks

      /* istanbul ignore if */


      if (startNumber < 1) {
        startNumber = 1;
        showFirstDots = false;
      } else if (startNumber > numberOfPages - numberOfLinks) {
        startNumber = numberOfPages - numberOfLinks + 1;
        showLastDots = false;
      }

      if (showFirstDots && firstNumber && startNumber < 4) {
        numberOfLinks = numberOfLinks + 2;
        startNumber = 1;
        showFirstDots = false;
      }

      var lastPageNumber = startNumber + numberOfLinks - 1;

      if (showLastDots && lastNumber && lastPageNumber > numberOfPages - 3) {
        numberOfLinks = numberOfLinks + (lastPageNumber === numberOfPages - 2 ? 2 : 3);
        showLastDots = false;
      } // Special handling for lower limits (where ellipsis are never shown)


      if (limit <= ELLIPSIS_THRESHOLD) {
        if (firstNumber && startNumber === 1) {
          numberOfLinks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["e" /* mathMin */])(numberOfLinks + 1, numberOfPages, limit + 1);
        } else if (lastNumber && numberOfPages === startNumber + numberOfLinks - 1) {
          startNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["a" /* mathMax */])(startNumber - 1, 1);
          numberOfLinks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["e" /* mathMin */])(numberOfPages - startNumber + 1, numberOfPages, limit + 1);
        }
      }

      numberOfLinks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_math__["e" /* mathMin */])(numberOfLinks, numberOfPages - startNumber + 1);
      return {
        showFirstDots: showFirstDots,
        showLastDots: showLastDots,
        numberOfLinks: numberOfLinks,
        startNumber: startNumber
      };
    },
    pageList: function pageList() {
      // Generates the pageList array
      var _this$paginationParam = this.paginationParams,
          numberOfLinks = _this$paginationParam.numberOfLinks,
          startNumber = _this$paginationParam.startNumber;
      var currentPage = this.computedCurrentPage; // Generate list of page numbers

      var pages = makePageArray(startNumber, numberOfLinks); // We limit to a total of 3 page buttons on XS screens
      // So add classes to page links to hide them for XS breakpoint
      // Note: Ellipsis will also be hidden on XS screens
      // TODO: Make this visual limit configurable based on breakpoint(s)

      if (pages.length > 3) {
        var idx = currentPage - startNumber; // THe following is a bootstrap-vue custom utility class

        var classes = 'bv-d-xs-down-none';

        if (idx === 0) {
          // Keep leftmost 3 buttons visible when current page is first page
          for (var i = 3; i < pages.length; i++) {
            pages[i].classes = classes;
          }
        } else if (idx === pages.length - 1) {
          // Keep rightmost 3 buttons visible when current page is last page
          for (var _i = 0; _i < pages.length - 3; _i++) {
            pages[_i].classes = classes;
          }
        } else {
          // Hide all except current page, current page - 1 and current page + 1
          for (var _i2 = 0; _i2 < idx - 1; _i2++) {
            // hide some left button(s)
            pages[_i2].classes = classes;
          }

          for (var _i3 = pages.length - 1; _i3 > idx + 1; _i3--) {
            // hide some right button(s)
            pages[_i3].classes = classes;
          }
        }
      }

      return pages;
    }
  },
  watch: (_watch = {}, _defineProperty(_watch, MODEL_PROP_NAME, function (newValue, oldValue) {
    if (newValue !== oldValue) {
      this.currentPage = sanitizeCurrentPage(newValue, this.localNumberOfPages);
    }
  }), _defineProperty(_watch, "currentPage", function currentPage(newValue, oldValue) {
    if (newValue !== oldValue) {
      // Emit `null` if no page selected
      this.$emit(MODEL_EVENT_NAME, newValue > 0 ? newValue : null);
    }
  }), _defineProperty(_watch, "limit", function limit(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.localLimit = sanitizeLimit(newValue);
    }
  }), _watch),
  created: function created() {
    var _this = this;

    // Set our default values in data
    this.localLimit = sanitizeLimit(this.limit);
    this.$nextTick(function () {
      // Sanity check
      _this.currentPage = _this.currentPage > _this.localNumberOfPages ? _this.localNumberOfPages : _this.currentPage;
    });
  },
  methods: {
    handleKeyNav: function handleKeyNav(event) {
      var keyCode = event.keyCode,
          shiftKey = event.shiftKey;
      /* istanbul ignore if */

      if (this.isNav) {
        // We disable left/right keyboard navigation in `<b-pagination-nav>`
        return;
      }

      if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["c" /* CODE_LEFT */] || keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["e" /* CODE_UP */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        shiftKey ? this.focusFirst() : this.focusPrev();
      } else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["d" /* CODE_RIGHT */] || keyCode === __WEBPACK_IMPORTED_MODULE_2__constants_key_codes__["f" /* CODE_DOWN */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_events__["f" /* stopEvent */])(event, {
          propagation: false
        });
        shiftKey ? this.focusLast() : this.focusNext();
      }
    },
    getButtons: function getButtons() {
      // Return only buttons that are visible
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["w" /* selectAll */])('button.page-link, a.page-link', this.$el).filter(function (btn) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["c" /* isVisible */])(btn);
      });
    },
    focusCurrent: function focusCurrent() {
      var _this2 = this;

      // We do this in `$nextTick()` to ensure buttons have finished rendering
      this.$nextTick(function () {
        var btn = _this2.getButtons().find(function (el) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_number__["b" /* toInteger */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* getAttr */])(el, 'aria-posinset'), 0) === _this2.computedCurrentPage;
        });

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(btn)) {
          // Fallback if current page is not in button list
          _this2.focusFirst();
        }
      });
    },
    focusFirst: function focusFirst() {
      var _this3 = this;

      // We do this in `$nextTick()` to ensure buttons have finished rendering
      this.$nextTick(function () {
        var btn = _this3.getButtons().find(function (el) {
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isDisabled */])(el);
        });

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(btn);
      });
    },
    focusLast: function focusLast() {
      var _this4 = this;

      // We do this in `$nextTick()` to ensure buttons have finished rendering
      this.$nextTick(function () {
        var btn = _this4.getButtons().reverse().find(function (el) {
          return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isDisabled */])(el);
        });

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(btn);
      });
    },
    focusPrev: function focusPrev() {
      var _this5 = this;

      // We do this in `$nextTick()` to ensure buttons have finished rendering
      this.$nextTick(function () {
        var buttons = _this5.getButtons();

        var index = buttons.indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["B" /* getActiveElement */])());

        if (index > 0 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isDisabled */])(buttons[index - 1])) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(buttons[index - 1]);
        }
      });
    },
    focusNext: function focusNext() {
      var _this6 = this;

      // We do this in `$nextTick()` to ensure buttons have finished rendering
      this.$nextTick(function () {
        var buttons = _this6.getButtons();

        var index = buttons.indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["B" /* getActiveElement */])());

        if (index < buttons.length - 1 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isDisabled */])(buttons[index + 1])) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["n" /* attemptFocus */])(buttons[index + 1]);
        }
      });
    }
  },
  render: function render(h) {
    var _this7 = this;

    var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
        disabled = _safeVueInstance.disabled,
        labelPage = _safeVueInstance.labelPage,
        ariaLabel = _safeVueInstance.ariaLabel,
        isNav = _safeVueInstance.isNav,
        numberOfPages = _safeVueInstance.localNumberOfPages,
        currentPage = _safeVueInstance.computedCurrentPage;

    var pageNumbers = this.pageList.map(function (p) {
      return p.number;
    });
    var _this$paginationParam2 = this.paginationParams,
        showFirstDots = _this$paginationParam2.showFirstDots,
        showLastDots = _this$paginationParam2.showLastDots;
    var fill = this.align === 'fill';
    var $buttons = []; // Helper function and flag

    var isActivePage = function isActivePage(pageNumber) {
      return pageNumber === currentPage;
    };

    var noCurrentPage = this.currentPage < 1; // Factory function for prev/next/first/last buttons

    var makeEndBtn = function makeEndBtn(linkTo, ariaLabel, btnSlot, btnText, btnClass, pageTest, key) {
      var isDisabled = disabled || isActivePage(pageTest) || noCurrentPage || linkTo < 1 || linkTo > numberOfPages;
      var pageNumber = linkTo < 1 ? 1 : linkTo > numberOfPages ? numberOfPages : linkTo;
      var scope = {
        disabled: isDisabled,
        page: pageNumber,
        index: pageNumber - 1
      };
      var $btnContent = _this7.normalizeSlot(btnSlot, scope) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_string__["a" /* toString */])(btnText) || h();
      var $inner = h(isDisabled ? 'span' : isNav ? __WEBPACK_IMPORTED_MODULE_18__components_link_link__["a" /* BLink */] : 'button', {
        staticClass: 'page-link',
        class: {
          'flex-grow-1': !isNav && !isDisabled && fill
        },
        props: isDisabled || !isNav ? {} : _this7.linkProps(linkTo),
        attrs: {
          role: isNav ? null : 'menuitem',
          type: isNav || isDisabled ? null : 'button',
          tabindex: isDisabled || isNav ? null : '-1',
          'aria-label': ariaLabel,
          'aria-controls': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_safe_vue_instance__["a" /* safeVueInstance */])(_this7).ariaControls || null,
          'aria-disabled': isDisabled ? 'true' : null
        },
        on: isDisabled ? {} : {
          '!click': function click(event) {
            _this7.onClick(event, linkTo);
          },
          keydown: onSpaceKey
        }
      }, [$btnContent]);
      return h('li', {
        key: key,
        staticClass: 'page-item',
        class: [{
          disabled: isDisabled,
          'flex-fill': fill,
          'd-flex': fill && !isNav && !isDisabled
        }, btnClass],
        attrs: {
          role: isNav ? null : 'presentation',
          'aria-hidden': isDisabled ? 'true' : null
        }
      }, [$inner]);
    }; // Ellipsis factory


    var makeEllipsis = function makeEllipsis(isLast) {
      return h('li', {
        staticClass: 'page-item',
        class: ['disabled', 'bv-d-xs-down-none', fill ? 'flex-fill' : '', _this7.ellipsisClass],
        attrs: {
          role: 'separator'
        },
        key: "ellipsis-".concat(isLast ? 'last' : 'first')
      }, [h('span', {
        staticClass: 'page-link'
      }, [_this7.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["w" /* SLOT_NAME_ELLIPSIS_TEXT */]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_string__["a" /* toString */])(_this7.ellipsisText) || h()])]);
    }; // Page button factory


    var makePageButton = function makePageButton(page, idx) {
      var pageNumber = page.number;
      var active = isActivePage(pageNumber) && !noCurrentPage; // Active page will have tabindex of 0, or if no current page and first page button

      var tabIndex = disabled ? null : active || noCurrentPage && idx === 0 ? '0' : '-1';
      var attrs = {
        role: isNav ? null : 'menuitemradio',
        type: isNav || disabled ? null : 'button',
        'aria-disabled': disabled ? 'true' : null,
        'aria-controls': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_safe_vue_instance__["a" /* safeVueInstance */])(_this7).ariaControls || null,
        'aria-label': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_props__["d" /* hasPropFunction */])(labelPage) ?
        /* istanbul ignore next */
        labelPage(pageNumber) : "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["a" /* isFunction */])(labelPage) ? labelPage() : labelPage, " ").concat(pageNumber),
        'aria-checked': isNav ? null : active ? 'true' : 'false',
        'aria-current': isNav && active ? 'page' : null,
        'aria-posinset': isNav ? null : pageNumber,
        'aria-setsize': isNav ? null : numberOfPages,
        // ARIA "roving tabindex" method (except in `isNav` mode)
        tabindex: isNav ? null : tabIndex
      };
      var btnContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_string__["a" /* toString */])(_this7.makePage(pageNumber));
      var scope = {
        page: pageNumber,
        index: pageNumber - 1,
        content: btnContent,
        active: active,
        disabled: disabled
      };
      var $inner = h(disabled ? 'span' : isNav ? __WEBPACK_IMPORTED_MODULE_18__components_link_link__["a" /* BLink */] : 'button', {
        props: disabled || !isNav ? {} : _this7.linkProps(pageNumber),
        staticClass: 'page-link',
        class: {
          'flex-grow-1': !isNav && !disabled && fill
        },
        attrs: attrs,
        on: disabled ? {} : {
          '!click': function click(event) {
            _this7.onClick(event, pageNumber);
          },
          keydown: onSpaceKey
        }
      }, [_this7.normalizeSlot(__WEBPACK_IMPORTED_MODULE_4__constants_slots__["x" /* SLOT_NAME_PAGE */], scope) || btnContent]);
      return h('li', {
        staticClass: 'page-item',
        class: [{
          disabled: disabled,
          active: active,
          'flex-fill': fill,
          'd-flex': fill && !isNav && !disabled
        }, page.classes, _this7.pageClass],
        attrs: {
          role: isNav ? null : 'presentation'
        },
        key: "page-".concat(pageNumber)
      }, [$inner]);
    }; // Goto first page button
    // Don't render button when `hideGotoEndButtons` or `firstNumber` is set


    var $firstPageBtn = h();

    if (!this.firstNumber && !this.hideGotoEndButtons) {
      $firstPageBtn = makeEndBtn(1, this.labelFirstPage, __WEBPACK_IMPORTED_MODULE_4__constants_slots__["y" /* SLOT_NAME_FIRST_TEXT */], this.firstText, this.firstClass, 1, 'pagination-goto-first');
    }

    $buttons.push($firstPageBtn); // Goto previous page button

    $buttons.push(makeEndBtn(currentPage - 1, this.labelPrevPage, __WEBPACK_IMPORTED_MODULE_4__constants_slots__["z" /* SLOT_NAME_PREV_TEXT */], this.prevText, this.prevClass, 1, 'pagination-goto-prev')); // Show first (1) button?

    $buttons.push(this.firstNumber && pageNumbers[0] !== 1 ? makePageButton({
      number: 1
    }, 0) : h()); // First ellipsis

    $buttons.push(showFirstDots ? makeEllipsis(false) : h()); // Individual page links

    this.pageList.forEach(function (page, idx) {
      var offset = showFirstDots && _this7.firstNumber && pageNumbers[0] !== 1 ? 1 : 0;
      $buttons.push(makePageButton(page, idx + offset));
    }); // Last ellipsis

    $buttons.push(showLastDots ? makeEllipsis(true) : h()); // Show last page button?

    $buttons.push(this.lastNumber && pageNumbers[pageNumbers.length - 1] !== numberOfPages ? makePageButton({
      number: numberOfPages
    }, -1) : h()); // Goto next page button

    $buttons.push(makeEndBtn(currentPage + 1, this.labelNextPage, __WEBPACK_IMPORTED_MODULE_4__constants_slots__["A" /* SLOT_NAME_NEXT_TEXT */], this.nextText, this.nextClass, numberOfPages, 'pagination-goto-next')); // Goto last page button
    // Don't render button when `hideGotoEndButtons` or `lastNumber` is set

    var $lastPageBtn = h();

    if (!this.lastNumber && !this.hideGotoEndButtons) {
      $lastPageBtn = makeEndBtn(numberOfPages, this.labelLastPage, __WEBPACK_IMPORTED_MODULE_4__constants_slots__["B" /* SLOT_NAME_LAST_TEXT */], this.lastText, this.lastClass, numberOfPages, 'pagination-goto-last');
    }

    $buttons.push($lastPageBtn); // Assemble the pagination buttons

    var $pagination = h('ul', {
      staticClass: 'pagination',
      class: ['b-pagination', this.btnSize, this.alignment, this.styleClass],
      attrs: {
        role: isNav ? null : 'menubar',
        'aria-disabled': disabled ? 'true' : 'false',
        'aria-label': isNav ? null : ariaLabel || null
      },
      // We disable keyboard left/right nav when `<b-pagination-nav>`
      on: isNav ? {} : {
        keydown: this.handleKeyNav
      },
      ref: 'ul'
    }, $buttons); // If we are `<b-pagination-nav>`, wrap in `<nav>` wrapper

    if (isNav) {
      return h('nav', {
        attrs: {
          'aria-disabled': disabled ? 'true' : null,
          'aria-hidden': disabled ? 'true' : 'false',
          'aria-label': isNav ? ariaLabel || null : null
        }
      }, [$pagination]);
    }

    return $pagination;
  }
});

/***/ }),
/* 463 */
/* exports provided: makePropWatcher, makePropCacheMixin */
/* exports used: makePropCacheMixin */
/*!********************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/cache.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makePropWatcher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makePropCacheMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clone_deep__ = __webpack_require__(/*! ./clone-deep */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loose_equal__ = __webpack_require__(/*! ./loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__object__ = __webpack_require__(/*! ./object */ 6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var isEmpty = function isEmpty(value) {
  return !value || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__object__["a" /* keys */])(value).length === 0;
};

var makePropWatcher = function makePropWatcher(propName) {
  return {
    handler: function handler(newValue, oldValue) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
        return;
      }

      if (isEmpty(newValue) || isEmpty(oldValue)) {
        this[propName] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clone_deep__["a" /* cloneDeep */])(newValue);
        return;
      }

      for (var key in oldValue) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__object__["c" /* hasOwnProperty */])(newValue, key)) {
          this.$delete(this.$data[propName], key);
        }
      }

      for (var _key in newValue) {
        this.$set(this.$data[propName], _key, newValue[_key]);
      }
    }
  };
};
var makePropCacheMixin = function makePropCacheMixin(propName, proxyPropName) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
    data: function data() {
      return _defineProperty({}, proxyPropName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__clone_deep__["a" /* cloneDeep */])(this[propName]));
    },
    watch: _defineProperty({}, propName, makePropWatcher(proxyPropName))
  });
};

/***/ }),
/* 464 */
/* exports provided: cssEscape */
/* exports used: cssEscape */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/css-escape.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cssEscape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(/*! ./string */ 23);


var escapeChar = function escapeChar(value) {
  return '\\' + value;
}; // The `cssEscape()` util is based on this `CSS.escape()` polyfill:
// https://github.com/mathiasbynens/CSS.escape


var cssEscape = function cssEscape(value) {
  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__string__["a" /* toString */])(value);
  var length = value.length;
  var firstCharCode = value.charCodeAt(0);
  return value.split('').reduce(function (result, char, index) {
    var charCode = value.charCodeAt(index); // If the character is NULL (U+0000), use (U+FFFD) as replacement

    if (charCode === 0x0000) {
      return result + "\uFFFD";
    } // If the character ...


    if ( // ... is U+007F OR
    charCode === 0x007f || // ... is in the range [\1-\1F] (U+0001 to U+001F) OR ...
    charCode >= 0x0001 && charCode <= 0x001f || // ... is the first character and is in the range [0-9] (U+0030 to U+0039) OR ...
    index === 0 && charCode >= 0x0030 && charCode <= 0x0039 || // ... is the second character and is in the range [0-9] (U+0030 to U+0039)
    // and the first character is a `-` (U+002D) ...
    index === 1 && charCode >= 0x0030 && charCode <= 0x0039 && firstCharCode === 0x002d) {
      // ... https://drafts.csswg.org/cssom/#escape-a-character-as-code-point
      return result + escapeChar("".concat(charCode.toString(16), " "));
    } // If the character ...


    if ( // ... is the first character AND ...
    index === 0 && // ... is a `-` (U+002D) AND ...
    charCode === 0x002d && // ... there is no second character ...
    length === 1) {
      // ... use the escaped character
      return result + escapeChar(char);
    } // If the character ...


    if ( // ... is greater than or equal to U+0080 OR ...
    charCode >= 0x0080 || // ... is `-` (U+002D) OR ...
    charCode === 0x002d || // ... is `_` (U+005F) OR ...
    charCode === 0x005f || // ... is in the range [0-9] (U+0030 to U+0039) OR ...
    charCode >= 0x0030 && charCode <= 0x0039 || // ... is in the range [A-Z] (U+0041 to U+005A) OR ...
    charCode >= 0x0041 && charCode <= 0x005a || // ... is in the range [a-z] (U+0061 to U+007A) ...
    charCode >= 0x0061 && charCode <= 0x007a) {
      // ... use the character itself
      return result + char;
    } // Otherwise use the escaped character
    // See: https://drafts.csswg.org/cssom/#escape-a-character


    return result + escapeChar(char);
  }, '');
};

/***/ }),
/* 465 */
/* exports provided: registerElementToInstance, removeElementToInstance, getInstanceFromElement */
/* exports used: getInstanceFromElement, registerElementToInstance, removeElementToInstance */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/element-to-vue-instance-registry.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return registerElementToInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeElementToInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInstanceFromElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);

var registry = null;

if (__WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */]) {
  registry = new WeakMap();
}

var registerElementToInstance = function registerElementToInstance(element, instance) {
  if (!__WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */]) {
    return;
  }

  registry.set(element, instance);
};
var removeElementToInstance = function removeElementToInstance(element) {
  if (!__WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */]) {
    return;
  }

  registry.delete(element);
};
var getInstanceFromElement = function getInstanceFromElement(element) {
  if (!__WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */]) {
    return element.__vue__;
  }

  var currentElement = element;

  while (currentElement) {
    if (registry.has(currentElement)) {
      /* istanbul ignore next */
      return registry.get(currentElement);
    }

    currentElement = currentElement.parentNode;
  }

  return null;
};

/***/ }),
/* 466 */
/* exports provided: stableSort */
/* exports used: stableSort */
/*!**************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/stable-sort.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stableSort; });
/*
 * Consistent and stable sort function across JavaScript platforms
 *
 * Inconsistent sorts can cause SSR problems between client and server
 * such as in <b-table> if sortBy is applied to the data on server side render.
 * Chrome and V8 native sorts are inconsistent/unstable
 *
 * This function uses native sort with fallback to index compare when the a and b
 * compare returns 0
 *
 * Algorithm based on:
 * https://stackoverflow.com/questions/1427608/fast-stable-sorting-algorithm-implementation-in-javascript/45422645#45422645
 *
 * @param {array} array to sort
 * @param {function} sort compare function
 * @return {array}
 */
var stableSort = function stableSort(array, compareFn) {
  // Using `.bind(compareFn)` on the wrapped anonymous function improves
  // performance by avoiding the function call setup. We don't use an arrow
  // function here as it binds `this` to the `stableSort` context rather than
  // the `compareFn` context, which wouldn't give us the performance increase.
  return array.map(function (a, index) {
    return [index, a];
  }).sort(function (a, b) {
    return this(a[1], b[1]) || a[0] - b[0];
  }.bind(compareFn)).map(function (e) {
    return e[1];
  });
};

/***/ }),
/* 467 */
/* exports provided: stringifyObjectValues */
/* exports used: stringifyObjectValues */
/*!**************************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/stringify-object-values.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stringifyObjectValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(/*! ./object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__string__ = __webpack_require__(/*! ./string */ 23);


 // Recursively stringifies the values of an object, space separated, in an
// SSR safe deterministic way (keys are sorted before stringification)
//
//   ex:
//     { b: 3, c: { z: 'zzz', d: null, e: 2 }, d: [10, 12, 11], a: 'one' }
//   becomes
//     'one 3 2 zzz 10 12 11'
//
// Strings are returned as-is
// Numbers get converted to string
// `null` and `undefined` values are filtered out
// Dates are converted to their native string format

var stringifyObjectValues = function stringifyObjectValues(value) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["g" /* isUndefinedOrNull */])(value)) {
    return '';
  } // Arrays are also object, and keys just returns the array indexes
  // Date objects we convert to strings


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["d" /* isObject */])(value) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__inspect__["b" /* isDate */])(value)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__object__["a" /* keys */])(value).sort() // Sort to prevent SSR issues on pre-rendered sorted tables
    .map(function (k) {
      return stringifyObjectValues(value[k]);
    }).filter(function (v) {
      return !!v;
    }) // Ignore empty strings
    .join(' ');
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__string__["a" /* toString */])(value);
};

/***/ }),
/* 468 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/core-js/library/modules/_html.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(/*! ./_global */ 55).document;
module.exports = document && document.documentElement;


/***/ }),
/* 469 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/core-js/library/modules/_ie8-dom-define.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(/*! ./_descriptors */ 66) && !__webpack_require__(/*! ./_fails */ 111)(function () {
  return Object.defineProperty(__webpack_require__(/*! ./_dom-create */ 259)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 470 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/core-js/library/modules/_is-array-iter.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(/*! ./_iterators */ 123);
var ITERATOR = __webpack_require__(/*! ./_wks */ 56)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 471 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/core-js/library/modules/_is-array.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(/*! ./_cof */ 143);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 472 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_iter-call.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(/*! ./_an-object */ 89);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 473 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_iter-detect.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(/*! ./_wks */ 56)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 474 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_iter-step.js ***!
  \*************************************************/
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 475 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_object-gopn.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(/*! ./_object-keys-internal */ 476);
var hiddenKeys = __webpack_require__(/*! ./_enum-bug-keys */ 260).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 476 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/core-js/library/modules/_object-keys-internal.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(/*! ./_has */ 112);
var toIObject = __webpack_require__(/*! ./_to-iobject */ 113);
var arrayIndexOf = __webpack_require__(/*! ./_array-includes */ 976)(false);
var IE_PROTO = __webpack_require__(/*! ./_shared-key */ 268)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 477 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/modules/_perform.js ***!
  \***********************************************/
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 478 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/core-js/library/modules/_promise-resolve.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ./_an-object */ 89);
var isObject = __webpack_require__(/*! ./_is-object */ 82);
var newPromiseCapability = __webpack_require__(/*! ./_new-promise-capability */ 264);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 479 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/core-js/library/modules/_redefine.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./_hide */ 97);


/***/ }),
/* 480 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_set-species.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(/*! ./_global */ 55);
var core = __webpack_require__(/*! ./_core */ 39);
var dP = __webpack_require__(/*! ./_object-dp */ 75);
var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ 66);
var SPECIES = __webpack_require__(/*! ./_wks */ 56)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 481 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/core-js/library/modules/_species-constructor.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(/*! ./_an-object */ 89);
var aFunction = __webpack_require__(/*! ./_a-function */ 142);
var SPECIES = __webpack_require__(/*! ./_wks */ 56)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 482 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/core-js/library/modules/_task.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(/*! ./_ctx */ 96);
var invoke = __webpack_require__(/*! ./_invoke */ 985);
var html = __webpack_require__(/*! ./_html */ 468);
var cel = __webpack_require__(/*! ./_dom-create */ 259);
var global = __webpack_require__(/*! ./_global */ 55);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(/*! ./_cof */ 143)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 483 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/core-js/library/modules/_validate-collection.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./_is-object */ 82);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 484 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-nav-tabs/themes/vue-tabs.css ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, ".vue-tabs.stacked {\n  display: flex; }\n\n.vue-tabs a {\n  text-decoration: none;\n  color: gray; }\n\n.vue-tabs .nav {\n  margin-bottom: 0;\n  margin-top: 0;\n  padding-left: 0;\n  list-style: none; }\n  .vue-tabs .nav:before, .vue-tabs .nav:after {\n    content: \" \";\n    display: table; }\n  .vue-tabs .nav:after {\n    clear: both; }\n  .vue-tabs .nav > li {\n    position: relative;\n    display: block; }\n    .vue-tabs .nav > li > a {\n      position: relative;\n      display: block;\n      padding: 10px 15px; }\n      .vue-tabs .nav > li > a:hover, .vue-tabs .nav > li > a:focus {\n        text-decoration: none;\n        background-color: #eeeeee; }\n    .vue-tabs .nav > li span.title {\n      display: flex;\n      justify-content: center; }\n    .vue-tabs .nav > li.disabled > a {\n      color: #777777; }\n      .vue-tabs .nav > li.disabled > a:hover, .vue-tabs .nav > li.disabled > a:focus {\n        color: #777777;\n        text-decoration: none;\n        cursor: not-allowed;\n        background-color: transparent;\n        border-color: transparent; }\n  .vue-tabs .nav .nav-divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #e5e5e5; }\n  .vue-tabs .nav > li > a > img {\n    max-width: none; }\n\n.vue-tabs .nav-tabs {\n  border-bottom: 1px solid #ddd; }\n  .vue-tabs .nav-tabs > li {\n    float: left;\n    margin-bottom: -1px; }\n    .vue-tabs .nav-tabs > li > a {\n      margin-right: 2px;\n      line-height: 1.42857;\n      border: 1px solid transparent;\n      border-radius: 4px 4px 0 0; }\n      .vue-tabs .nav-tabs > li > a:hover {\n        border-color: #eeeeee #eeeeee #ddd; }\n    .vue-tabs .nav-tabs > li.active > a, .vue-tabs .nav-tabs > li.active > a:hover, .vue-tabs .nav-tabs > li.active > a:focus {\n      color: #555555;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      border-bottom-color: transparent;\n      cursor: default; }\n\n.vue-tabs .nav-pills > li {\n  float: left; }\n  .vue-tabs .nav-pills > li > a {\n    border-radius: 4px; }\n  .vue-tabs .nav-pills > li + li {\n    margin-left: 2px; }\n  .vue-tabs .nav-pills > li.active > a, .vue-tabs .nav-pills > li.active > a:hover, .vue-tabs .nav-pills > li.active > a:focus {\n    color: #fff;\n    background-color: #337ab7; }\n\n.vue-tabs .nav-stacked > li {\n  float: none; }\n  .vue-tabs .nav-stacked > li + li {\n    margin-top: 2px;\n    margin-left: 0; }\n\n.vue-tabs .nav-justified, .vue-tabs .nav-tabs.nav-justified {\n  width: 100%; }\n  .vue-tabs .nav-justified > li, .vue-tabs .nav-tabs.nav-justified > li {\n    float: none; }\n    .vue-tabs .nav-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n      text-align: center;\n      margin-bottom: 5px; }\n  .vue-tabs .nav-justified > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto; }\n  @media (min-width: 768px) {\n    .vue-tabs .nav-justified > li, .vue-tabs .nav-tabs.nav-justified > li {\n      display: table-cell;\n      width: 1%; }\n      .vue-tabs .nav-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n        margin-bottom: 0; } }\n\n.vue-tabs .nav-tabs-justified, .vue-tabs .nav-tabs.nav-justified {\n  border-bottom: 0; }\n  .vue-tabs .nav-tabs-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n    margin-right: 0;\n    border-radius: 4px; }\n  .vue-tabs .nav-tabs-justified > .active > a, .vue-tabs .nav-tabs.nav-justified > .active > a,\n  .vue-tabs .nav-tabs-justified > .active > a:hover, .vue-tabs .nav-tabs.nav-justified > .active > a:hover,\n  .vue-tabs .nav-tabs-justified > .active > a:focus, .vue-tabs .nav-tabs.nav-justified > .active > a:focus {\n    border: 1px solid #ddd; }\n  @media (min-width: 768px) {\n    .vue-tabs .nav-tabs-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n      border-bottom: 1px solid #ddd;\n      border-radius: 4px 4px 0 0; }\n    .vue-tabs .nav-tabs-justified > .active > a, .vue-tabs .nav-tabs.nav-justified > .active > a,\n    .vue-tabs .nav-tabs-justified > .active > a:hover, .vue-tabs .nav-tabs.nav-justified > .active > a:hover,\n    .vue-tabs .nav-tabs-justified > .active > a:focus, .vue-tabs .nav-tabs.nav-justified > .active > a:focus {\n      border-bottom-color: #fff; } }\n\n.vue-tabs .tab-content > .tab-pane {\n  display: none; }\n\n.vue-tabs .tab-content > .active {\n  display: block; }\n\n.vue-tabs section[aria-hidden=\"true\"] {\n  display: none; }\n", "", {"version":3,"sources":["/./node_modules/vue-nav-tabs/themes/vue-tabs.css"],"names":[],"mappings":"AAAA;EACE,cAAc,EAAE;;AAElB;EACE,sBAAsB;EACtB,YAAY,EAAE;;AAEhB;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB,EAAE;EACnB;IACE,aAAa;IACb,eAAe,EAAE;EACnB;IACE,YAAY,EAAE;EAChB;IACE,mBAAmB;IACnB,eAAe,EAAE;IACjB;MACE,mBAAmB;MACnB,eAAe;MACf,mBAAmB,EAAE;MACrB;QACE,sBAAsB;QACtB,0BAA0B,EAAE;IAChC;MACE,cAAc;MACd,wBAAwB,EAAE;IAC5B;MACE,eAAe,EAAE;MACjB;QACE,eAAe;QACf,sBAAsB;QACtB,oBAAoB;QACpB,8BAA8B;QAC9B,0BAA0B,EAAE;EAClC;IACE,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,0BAA0B,EAAE;EAC9B;IACE,gBAAgB,EAAE;;AAEtB;EACE,8BAA8B,EAAE;EAChC;IACE,YAAY;IACZ,oBAAoB,EAAE;IACtB;MACE,kBAAkB;MAClB,qBAAqB;MACrB,8BAA8B;MAC9B,2BAA2B,EAAE;MAC7B;QACE,mCAAmC,EAAE;IACzC;MACE,eAAe;MACf,uBAAuB;MACvB,uBAAuB;MACvB,iCAAiC;MACjC,gBAAgB,EAAE;;AAExB;EACE,YAAY,EAAE;EACd;IACE,mBAAmB,EAAE;EACvB;IACE,iBAAiB,EAAE;EACrB;IACE,YAAY;IACZ,0BAA0B,EAAE;;AAEhC;EACE,YAAY,EAAE;EACd;IACE,gBAAgB;IAChB,eAAe,EAAE;;AAErB;EACE,YAAY,EAAE;EACd;IACE,YAAY,EAAE;IACd;MACE,mBAAmB;MACnB,mBAAmB,EAAE;EACzB;IACE,UAAU;IACV,WAAW,EAAE;EACf;IACE;MACE,oBAAoB;MACpB,UAAU,EAAE;MACZ;QACE,iBAAiB,EAAE,EAAE;;AAE7B;EACE,iBAAiB,EAAE;EACnB;IACE,gBAAgB;IAChB,mBAAmB,EAAE;EACvB;;;IAGE,uBAAuB,EAAE;EAC3B;IACE;MACE,8BAA8B;MAC9B,2BAA2B,EAAE;IAC/B;;;MAGE,0BAA0B,EAAE,EAAE;;AAEpC;EACE,cAAc,EAAE;;AAElB;EACE,eAAe,EAAE;;AAEnB;EACE,cAAc,EAAE","file":"vue-tabs.css","sourcesContent":[".vue-tabs.stacked {\n  display: flex; }\n\n.vue-tabs a {\n  text-decoration: none;\n  color: gray; }\n\n.vue-tabs .nav {\n  margin-bottom: 0;\n  margin-top: 0;\n  padding-left: 0;\n  list-style: none; }\n  .vue-tabs .nav:before, .vue-tabs .nav:after {\n    content: \" \";\n    display: table; }\n  .vue-tabs .nav:after {\n    clear: both; }\n  .vue-tabs .nav > li {\n    position: relative;\n    display: block; }\n    .vue-tabs .nav > li > a {\n      position: relative;\n      display: block;\n      padding: 10px 15px; }\n      .vue-tabs .nav > li > a:hover, .vue-tabs .nav > li > a:focus {\n        text-decoration: none;\n        background-color: #eeeeee; }\n    .vue-tabs .nav > li span.title {\n      display: flex;\n      justify-content: center; }\n    .vue-tabs .nav > li.disabled > a {\n      color: #777777; }\n      .vue-tabs .nav > li.disabled > a:hover, .vue-tabs .nav > li.disabled > a:focus {\n        color: #777777;\n        text-decoration: none;\n        cursor: not-allowed;\n        background-color: transparent;\n        border-color: transparent; }\n  .vue-tabs .nav .nav-divider {\n    height: 1px;\n    margin: 9px 0;\n    overflow: hidden;\n    background-color: #e5e5e5; }\n  .vue-tabs .nav > li > a > img {\n    max-width: none; }\n\n.vue-tabs .nav-tabs {\n  border-bottom: 1px solid #ddd; }\n  .vue-tabs .nav-tabs > li {\n    float: left;\n    margin-bottom: -1px; }\n    .vue-tabs .nav-tabs > li > a {\n      margin-right: 2px;\n      line-height: 1.42857;\n      border: 1px solid transparent;\n      border-radius: 4px 4px 0 0; }\n      .vue-tabs .nav-tabs > li > a:hover {\n        border-color: #eeeeee #eeeeee #ddd; }\n    .vue-tabs .nav-tabs > li.active > a, .vue-tabs .nav-tabs > li.active > a:hover, .vue-tabs .nav-tabs > li.active > a:focus {\n      color: #555555;\n      background-color: #fff;\n      border: 1px solid #ddd;\n      border-bottom-color: transparent;\n      cursor: default; }\n\n.vue-tabs .nav-pills > li {\n  float: left; }\n  .vue-tabs .nav-pills > li > a {\n    border-radius: 4px; }\n  .vue-tabs .nav-pills > li + li {\n    margin-left: 2px; }\n  .vue-tabs .nav-pills > li.active > a, .vue-tabs .nav-pills > li.active > a:hover, .vue-tabs .nav-pills > li.active > a:focus {\n    color: #fff;\n    background-color: #337ab7; }\n\n.vue-tabs .nav-stacked > li {\n  float: none; }\n  .vue-tabs .nav-stacked > li + li {\n    margin-top: 2px;\n    margin-left: 0; }\n\n.vue-tabs .nav-justified, .vue-tabs .nav-tabs.nav-justified {\n  width: 100%; }\n  .vue-tabs .nav-justified > li, .vue-tabs .nav-tabs.nav-justified > li {\n    float: none; }\n    .vue-tabs .nav-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n      text-align: center;\n      margin-bottom: 5px; }\n  .vue-tabs .nav-justified > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto; }\n  @media (min-width: 768px) {\n    .vue-tabs .nav-justified > li, .vue-tabs .nav-tabs.nav-justified > li {\n      display: table-cell;\n      width: 1%; }\n      .vue-tabs .nav-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n        margin-bottom: 0; } }\n\n.vue-tabs .nav-tabs-justified, .vue-tabs .nav-tabs.nav-justified {\n  border-bottom: 0; }\n  .vue-tabs .nav-tabs-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n    margin-right: 0;\n    border-radius: 4px; }\n  .vue-tabs .nav-tabs-justified > .active > a, .vue-tabs .nav-tabs.nav-justified > .active > a,\n  .vue-tabs .nav-tabs-justified > .active > a:hover, .vue-tabs .nav-tabs.nav-justified > .active > a:hover,\n  .vue-tabs .nav-tabs-justified > .active > a:focus, .vue-tabs .nav-tabs.nav-justified > .active > a:focus {\n    border: 1px solid #ddd; }\n  @media (min-width: 768px) {\n    .vue-tabs .nav-tabs-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n      border-bottom: 1px solid #ddd;\n      border-radius: 4px 4px 0 0; }\n    .vue-tabs .nav-tabs-justified > .active > a, .vue-tabs .nav-tabs.nav-justified > .active > a,\n    .vue-tabs .nav-tabs-justified > .active > a:hover, .vue-tabs .nav-tabs.nav-justified > .active > a:hover,\n    .vue-tabs .nav-tabs-justified > .active > a:focus, .vue-tabs .nav-tabs.nav-justified > .active > a:focus {\n      border-bottom-color: #fff; } }\n\n.vue-tabs .tab-content > .tab-pane {\n  display: none; }\n\n.vue-tabs .tab-content > .active {\n  display: block; }\n\n.vue-tabs section[aria-hidden=\"true\"] {\n  display: none; }\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 485 */
/* exports provided: CalendarDay */
/* exports used: CalendarDay */
/*!**************************************!*\
  !*** ./~/dayspan/lib/CalendarDay.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Operation__ = __webpack_require__(/*! ./Operation */ 151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Day__ = __webpack_require__(/*! ./Day */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Iterator__ = __webpack_require__(/*! ./Iterator */ 150);

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * A day in a [[Calendar]] with extra information relative to any selection on
 * the calendar, the current date, or events on the day.
 *
 * @typeparam T The type of data stored in the [[Event]] class.
 * @typeparam M The type of metadata stored in the schedule.
 */
var CalendarDay = (function (_super) {
    __extends(CalendarDay, _super);
    function CalendarDay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Whether this day is the current day (ex: today).
         */
        _this.currentDay = false;
        /**
         * Whether this day is on the same week as the current day (ex: today).
         */
        _this.currentWeek = false;
        /**
         * Whether this day is on the same month as the current day (ex: today).
         */
        _this.currentMonth = false;
        /**
         * Whether this day is on the same year as the current day (ex: today).
         */
        _this.currentYear = false;
        /**
         * How many days away this day is from the current day (ex: today). If this
         * day is the current day the offset is 0. If this day is before the current
         * day it will be the negative number of days away. Otherwise this will be
         * positive meaning this day is after the current day by the given days.
         */
        _this.currentOffset = 0;
        /**
         * Whether this day is part of a selection on the calendar.
         */
        _this.selectedDay = false;
        /**
         * Whether this day is on the same week that the calendar selection is.
         */
        _this.selectedWeek = false;
        /**
         * Whether this day is on the same month that the calendar selection is.
         */
        _this.selectedMonth = false;
        /**
         * Whether this day is on the same year that the calendar selection is.
         */
        _this.selectedYear = false;
        /**
         * Whether this day is in the current calendar or not. Some days are outside
         * the calendar span and used to fill in weeks. Month calendars will fill in
         * days so the list of days in the calendar start on Sunday and end on Saturday.
         */
        _this.inCalendar = false;
        /**
         * The list of events on this day based on the settings and schedules in the
         * calendar.
         */
        _this.events = [];
        return _this;
    }
    /**
     * Creates an iterator for the events on this day.
     *
     * @returns The new iterator for the events on this day.
     */
    CalendarDay.prototype.iterateEvents = function () {
        return __WEBPACK_IMPORTED_MODULE_2__Iterator__["b" /* Iterator */].forArray(this.events);
    };
    /**
     * Updates the current flags on this day given the current day (ex: today).
     *
     * @param current The current day of the calendar.
     */
    CalendarDay.prototype.updateCurrent = function (current) {
        this.currentDay = this.sameDay(current);
        this.currentWeek = this.sameWeek(current);
        this.currentMonth = this.sameMonth(current);
        this.currentYear = this.sameYear(current);
        this.currentOffset = this.daysBetween(current, __WEBPACK_IMPORTED_MODULE_0__Operation__["a" /* Op */].DOWN, false);
        return this;
    };
    /**
     * Updates the selection flags on this day given the selection range on the
     * calendar.
     *
     * @param selected The span of days selected on the calendar.
     */
    CalendarDay.prototype.updateSelected = function (selected) {
        this.selectedDay = selected.matchesDay(this);
        this.selectedWeek = selected.matchesWeek(this);
        this.selectedMonth = selected.matchesMonth(this);
        this.selectedYear = selected.matchesYear(this);
        return this;
    };
    /**
     * Clears the selection flags on this day. This is done when the selection on
     * the calendar is cleared.
     */
    CalendarDay.prototype.clearSelected = function () {
        this.selectedDay = this.selectedWeek = this.selectedMonth = this.selectedYear = false;
        return this;
    };
    return CalendarDay;
}(__WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */]));

//# sourceMappingURL=CalendarDay.js.map

/***/ }),
/* 486 */
/* exports provided: CalendarEvent */
/* exports used: CalendarEvent */
/*!****************************************!*\
  !*** ./~/dayspan/lib/CalendarEvent.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(/*! ./Constants */ 98);


/**
 * An instance of an [[Event]] on a given day of a [[Calendar]] generated by
 * the event's [[Schedule]].
 *
 * @typeparam T The type of data stored in the [[Event]] class.
 * @typeparam M The type of metadata stored in the schedule and in this class.
 */
var CalendarEvent = (function () {
    /**
     * Creates a new event instance given the id, the event paired with the
     * schedule, the schedule, the time span of the event, and the day on the
     * calendar the event belongs to.
     *
     * @param id The relatively unique identifier of this event.
     * @param event The event which created this instance.
     * @param time The time span of this event.
     * @param actualDay The day on the calendar this event is for.
     */
    function CalendarEvent(id, event, time, actualDay) {
        /**
         * The row this event is on in a visual calendar. An event can span multiple
         * days and it is desirable to have the occurrence on each day to line up.
         * This is only set when [[Calendar.updateRows]] is true or manually set.
         * This value makes sense for visual calendars for all day events or when the
         * visual calendar is not positioning events based on their time span.
         */
        this.row = 0;
        /**
         * The column this event is on in a visual calendar. An event can have its
         * time overlap with another event displaying one of the events in another
         * column. This is only set when [[Calendar.updateColumns]] is true or
         * manually set. This value makes sense for visual calendars that are
         * displaying event occurrences at specific times positioned accordingly.
         */
        this.col = 0;
        this.id = id;
        this.event = event;
        this.time = time;
        this.day = actualDay;
        this.fullDay = event.schedule.isFullDay();
        this.meta = event.schedule.getMeta(time.start);
        this.cancelled = event.schedule.isCancelled(time.start);
        this.starting = time.isPoint || time.start.sameDay(actualDay);
        this.ending = time.isPoint || time.end.relative(-1).sameDay(actualDay);
    }
    Object.defineProperty(CalendarEvent.prototype, "scheduleId", {
        /**
         * The id of the schedule uniqe within the calendar which generated this event.
         */
        get: function () {
            return Math.floor(this.id / __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].MAX_EVENTS_PER_DAY);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "start", {
        /**
         * The start timestamp of the event.
         */
        get: function () {
            return this.time.start;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "end", {
        /**
         * The end timestamp of the event.
         */
        get: function () {
            return this.time.end;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "schedule", {
        /**
         * The schedule which generated this event.
         */
        get: function () {
            return this.event.schedule;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "data", {
        /**
         * The related event data.
         */
        get: function () {
            return this.event.data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "identifier", {
        /**
         * An [[IdentifierInput]] for the start of this event.
         */
        get: function () {
            return this.identifierType.get(this.start);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "identifierType", {
        /**
         * The [[Identifier]] for this event. Either [[Identifier.Day]] or
         * [[Identifier.Time]].
         */
        get: function () {
            return this.schedule.identifierType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "startDelta", {
        /**
         * Returns a delta value between 0 and 1 which represents where the
         * [[CalendarEvent.start]] is relative to [[CalendarEvent.day]]. The delta
         * value would be less than 0 if the start of the event is before
         * [[CalendarEvent.day]].
         */
        get: function () {
            return this.time.startDelta(this.day);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEvent.prototype, "endDelta", {
        /**
         * Returns a delta value between 0 and 1 which represents where the
         * [[CalendarEvent.end]] is relative to [[CalendarEvent.day]]. The delta value
         * would be greater than 1 if the end of the event is after
         * [[CalendarEvent.day]].
         */
        get: function () {
            return this.time.endDelta(this.day);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the bounds for this event if it were placed in a rectangle which
     * represents a day (24 hour period). By default the returned values are
     * between 0 and 1 and can be scaled by the proper rectangle dimensions or the
     * rectangle dimensions can be passed to this function.
     *
     * @param dayHeight The height of the rectangle of the day.
     * @param dayWidth The width of the rectangle of the day.
     * @param columnOffset The offset in the rectangle of the day to adjust this
     *    event by if it intersects or is contained in a previous event. This also
     *    reduces the width of the returned bounds to keep the bounds in the
     *    rectangle of the day.
     * @param clip `true` if the bounds should stay in the day rectangle, `false`
     *    and the bounds may go outside the rectangle of the day for multi-day
     *    events.
     * @param offsetX How much to translate the left & right properties by.
     * @param offsetY How much to translate the top & bottom properties by.
     * @returns The calculated bounds for this event.
     */
    CalendarEvent.prototype.getTimeBounds = function (dayHeight, dayWidth, columnOffset, clip, offsetX, offsetY) {
        if (dayHeight === void 0) { dayHeight = 1; }
        if (dayWidth === void 0) { dayWidth = 1; }
        if (columnOffset === void 0) { columnOffset = 0.1; }
        if (clip === void 0) { clip = true; }
        if (offsetX === void 0) { offsetX = 0; }
        if (offsetY === void 0) { offsetY = 0; }
        return this.time.getBounds(this.day, dayHeight, dayWidth, this.col * columnOffset, clip, offsetX, offsetY);
    };
    /**
     * Changes the cancellation status of this event. By default this cancels
     * this event - but `false` may be passed to undo a cancellation.
     *
     * @param cancelled Whether the event should be cancelled.
     */
    CalendarEvent.prototype.cancel = function (cancelled) {
        if (cancelled === void 0) { cancelled = true; }
        this.schedule.setCancelled(this.start, cancelled);
        this.cancelled = cancelled;
        return this;
    };
    /**
     * Changes the exclusion status of this event. By default this excludes this
     * event - but `false`  may be passed to undo an exclusion.
     *
     * @param excluded Whether the event should be excluded.
     */
    CalendarEvent.prototype.exclude = function (excluded) {
        if (excluded === void 0) { excluded = true; }
        this.schedule.setExcluded(this.start, excluded);
        return this;
    };
    /**
     * Moves this event to potentially another day and time. A move is
     * accomplished by excluding the current event and adding an inclusion of the
     * new day & time. Any [[CalendarEvent.meta]] on this event will be moved to
     * the new event. If the schedule represents a single event
     * ([[Schedule.isSingleEvent]]) then the schedule frequencies are updated
     * to match the timestamp provided.
     *
     * @param toTime The timestamp to move this event to.
     * @returns Whether the event was moved to the given time.
     */
    CalendarEvent.prototype.move = function (toTime) {
        return this.schedule.move(toTime, this.start);
    };
    return CalendarEvent;
}());

//# sourceMappingURL=CalendarEvent.js.map

/***/ }),
/* 487 */
/* exports provided: Event */
/* exports used: Event */
/*!********************************!*\
  !*** ./~/dayspan/lib/Event.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Event; });

/**
 * A pairing of a user specified event object and the schedule which defines
 * when it occurs on a calendar.
 *
 * @typeparam T The type of data stored in the [[Event]] class.
 * @typeparam M The type of metadata stored in the schedule.
 */
var Event = (function () {
    /**
     * Creates a new event.
     *
     * @param schedule The schedule which defines when the event occurs.
     * @param data User specified object which describes this event.
     * @param id User specified ID which identifies this event.
     */
    function Event(schedule, data, id, visible) {
        if (visible === void 0) { visible = true; }
        this.schedule = schedule;
        this.data = data;
        this.id = id;
        this.visible = visible;
    }
    return Event;
}());

//# sourceMappingURL=Event.js.map

/***/ }),
/* 488 */
/* exports provided: Weekday */
/* exports used: Weekday */
/*!**********************************!*\
  !*** ./~/dayspan/lib/Weekday.js ***!
  \**********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Weekday; });

/**
 * The days in a week.
 */
var Weekday = (function () {
    function Weekday() {
    }
    Weekday.SUNDAY = 0;
    Weekday.MONDAY = 1;
    Weekday.TUESDAY = 2;
    Weekday.WEDNESDAY = 3;
    Weekday.THURSDAY = 4;
    Weekday.FRIDAY = 5;
    Weekday.SATURDAY = 6;
    /**
     * The full list of days in a week.
     */
    Weekday.LIST = [
        Weekday.SUNDAY,
        Weekday.MONDAY,
        Weekday.TUESDAY,
        Weekday.WEDNESDAY,
        Weekday.THURSDAY,
        Weekday.FRIDAY,
        Weekday.SATURDAY
    ];
    /**
     * The list of days starting with Monday and ending on Friday.
     */
    Weekday.WEEK = [
        Weekday.MONDAY,
        Weekday.TUESDAY,
        Weekday.WEDNESDAY,
        Weekday.THURSDAY,
        Weekday.FRIDAY
    ];
    /**
     * The days on the weekend, starting with Saturday and ending with Sunday.
     */
    Weekday.ENDS = [
        Weekday.SATURDAY,
        Weekday.SUNDAY
    ];
    return Weekday;
}());

//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 489 */
/* exports provided: Calendar, CalendarDay, CalendarEvent, Event, Constants, Day, DaySpan, Functions, Identifier, IteratorAction, Iterator, Month, Op, operate, Parse, Pattern, Patterns, PatternMap, Schedule, ScheduleModifier, Sorts, Suffix, Time, Units, Weekday */
/* all exports used */
/*!********************************!*\
  !*** ./~/dayspan/lib/index.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(/*! ./Calendar */ 1121);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Calendar", function() { return __WEBPACK_IMPORTED_MODULE_0__Calendar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarDay__ = __webpack_require__(/*! ./CalendarDay */ 485);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CalendarDay", function() { return __WEBPACK_IMPORTED_MODULE_1__CalendarDay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarEvent__ = __webpack_require__(/*! ./CalendarEvent */ 486);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CalendarEvent", function() { return __WEBPACK_IMPORTED_MODULE_2__CalendarEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Event__ = __webpack_require__(/*! ./Event */ 487);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Event", function() { return __WEBPACK_IMPORTED_MODULE_3__Event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(/*! ./Constants */ 98);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return __WEBPACK_IMPORTED_MODULE_4__Constants__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Day__ = __webpack_require__(/*! ./Day */ 114);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Day", function() { return __WEBPACK_IMPORTED_MODULE_5__Day__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DaySpan__ = __webpack_require__(/*! ./DaySpan */ 189);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DaySpan", function() { return __WEBPACK_IMPORTED_MODULE_6__DaySpan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Functions", function() { return __WEBPACK_IMPORTED_MODULE_7__Functions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Identifier__ = __webpack_require__(/*! ./Identifier */ 190);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Identifier", function() { return __WEBPACK_IMPORTED_MODULE_8__Identifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Iterator__ = __webpack_require__(/*! ./Iterator */ 150);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IteratorAction", function() { return __WEBPACK_IMPORTED_MODULE_9__Iterator__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Iterator", function() { return __WEBPACK_IMPORTED_MODULE_9__Iterator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Month__ = __webpack_require__(/*! ./Month */ 1122);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Month", function() { return __WEBPACK_IMPORTED_MODULE_10__Month__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Operation__ = __webpack_require__(/*! ./Operation */ 151);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Op", function() { return __WEBPACK_IMPORTED_MODULE_11__Operation__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "operate", function() { return __WEBPACK_IMPORTED_MODULE_11__Operation__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Parse__ = __webpack_require__(/*! ./Parse */ 152);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Parse", function() { return __WEBPACK_IMPORTED_MODULE_12__Parse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pattern__ = __webpack_require__(/*! ./Pattern */ 1123);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Pattern", function() { return __WEBPACK_IMPORTED_MODULE_13__Pattern__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Patterns", function() { return __WEBPACK_IMPORTED_MODULE_13__Pattern__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PatternMap", function() { return __WEBPACK_IMPORTED_MODULE_13__Pattern__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Schedule__ = __webpack_require__(/*! ./Schedule */ 276);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Schedule", function() { return __WEBPACK_IMPORTED_MODULE_14__Schedule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ScheduleModifier__ = __webpack_require__(/*! ./ScheduleModifier */ 277);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ScheduleModifier", function() { return __WEBPACK_IMPORTED_MODULE_15__ScheduleModifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Sort__ = __webpack_require__(/*! ./Sort */ 1124);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Sorts", function() { return __WEBPACK_IMPORTED_MODULE_16__Sort__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Suffix__ = __webpack_require__(/*! ./Suffix */ 278);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Suffix", function() { return __WEBPACK_IMPORTED_MODULE_17__Suffix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Time__ = __webpack_require__(/*! ./Time */ 279);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Time", function() { return __WEBPACK_IMPORTED_MODULE_18__Time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Units__ = __webpack_require__(/*! ./Units */ 191);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Units", function() { return __WEBPACK_IMPORTED_MODULE_19__Units__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Weekday__ = __webpack_require__(/*! ./Weekday */ 488);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Weekday", function() { return __WEBPACK_IMPORTED_MODULE_20__Weekday__["a"]; });






















//# sourceMappingURL=index.js.map

/***/ }),
/* 490 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./client/assets/icones_app/banco_branco.svg ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "banco_branco.svg?5ff00b01f0ef4643e090ff2860a5b92a";

/***/ }),
/* 491 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/assets/icones_app/cartao_azul.svg ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cartao_azul.svg?06cd8dd6edcf824ba1dcf19876becbbe";

/***/ }),
/* 492 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/lodash.clonedeep/index.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/global.js */ 102), __webpack_require__(/*! ./../webpack/buildin/module.js */ 302)(module)))

/***/ }),
/* 493 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/af.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 494 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ar-dz.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 495 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ar-kw.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 496 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ar-ly.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 497 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ar-ma.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 498 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ar-ps.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arPs = moment.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
            '_'
        ),
        monthsShort:
            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .split('') // reversed since negative lookbehind not supported everywhere
                .reverse()
                .join('')
                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                    return numberMap[match];
                })
                .split('')
                .reverse()
                .join('')
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arPs;

})));


/***/ }),
/* 499 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ar-sa.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 500 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ar-tn.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 501 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ar.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 502 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/az.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 503 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/be.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 504 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/bg.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 505 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/bm.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 506 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/bn-bd.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 507 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/bn.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 508 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/bo.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 509 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/br.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 510 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/bs.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix
                    ? 'jedna minuta'
                    : isFuture
                      ? 'jednu minutu'
                      : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 511 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ca.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 512 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/cs.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            standalone:
                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                    '_'
                ),
            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                '_'
            ),
            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 513 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/cv.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                      ? 'тан'
                      : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 514 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/cy.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 515 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/da.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 516 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/de-at.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 517 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/de-ch.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 518 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/de.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 519 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/dv.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 520 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/el.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 521 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-au.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 522 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-ca.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 523 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-gb.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 524 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-ie.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 525 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-il.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 526 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-in.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 527 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-nz.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 528 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/en-sg.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 529 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/eo.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 530 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/es-do.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 531 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/es-mx.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 532 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/es-us.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 533 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/es.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 534 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/et.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 535 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/eu.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 536 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/fa.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 537 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/fi.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 538 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./~/moment/locale/fil.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 539 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/fo.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 540 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/fr-ca.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 541 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/fr-ch.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 542 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/fr.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 543 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/fy.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 544 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ga.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 545 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/gd.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 546 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/gl.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 547 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/moment/locale/gom-deva.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 548 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/moment/locale/gom-latn.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 549 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/gu.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 550 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/he.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 551 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/hi.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 552 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/hr.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 553 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/hu.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 554 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/hy-am.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 555 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/id.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 556 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/is.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 557 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/it-ch.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 558 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/it.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 559 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ja.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 560 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/jv.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 561 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ka.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 562 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/kk.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 563 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/km.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 564 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/kn.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 565 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ko.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 566 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./~/moment/locale/ku-kmr.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (
            !(ll == 12 || ll == 13) &&
            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
        )
            return 'yê';
        return 'ê';
    }

    var kuKmr = moment.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
            '_'
        ),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function (num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return kuKmr;

})));


/***/ }),
/* 567 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ku.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 568 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ky.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 569 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/lb.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 570 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/lo.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 571 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/lt.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
              ? forms(key)[1]
              : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 572 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/lv.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 573 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/me.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                  ? wordKey[1]
                  : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 574 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/mi.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 575 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/mk.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 576 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ml.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 577 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/mn.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 578 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/mr.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 579 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ms-my.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 580 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ms.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 581 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/mt.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 582 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/my.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 583 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/nb.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 584 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ne.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 585 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/nl-be.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 586 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/nl.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 587 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/nn.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 588 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./~/moment/locale/oc-lnc.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 589 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/pa-in.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 590 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/pl.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 591 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/pt-br.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 592 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/pt.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 593 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ro.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 594 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ru.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 595 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/sd.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 596 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/se.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 597 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/si.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 598 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/sk.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 599 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/sl.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 600 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/sq.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 601 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./~/moment/locale/sr-cyrl.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 602 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/sr.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 603 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ss.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 604 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/sv.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                          ? ':a'
                          : b === 2
                            ? ':a'
                            : b === 3
                              ? ':e'
                              : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 605 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/sw.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 606 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ta.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 607 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/te.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 608 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./~/moment/locale/tet.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 609 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/tg.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 610 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/th.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 611 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/tk.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 612 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/tl-ph.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 613 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./~/moment/locale/tlh.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'waQ'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'nem'
                    : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'wen'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'ben'
                    : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 614 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/tr.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 615 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./~/moment/locale/tzl.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
              ? format[key][0]
              : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 616 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/moment/locale/tzm-latn.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 617 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./~/moment/locale/tzm.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 618 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/ug-cn.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 619 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/uk.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
              ? 'genitive'
              : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 620 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/ur.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 621 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./~/moment/locale/uz-latn.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 622 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/uz.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 623 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/vi.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 624 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/moment/locale/x-pseudo.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 625 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/moment/locale/yo.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 626 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/zh-cn.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 627 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/zh-hk.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 628 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/zh-mo.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 629 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale/zh-tw.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(/*! ../moment */ 1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 630 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/popper.js/dist/esm/popper.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ 102)))

/***/ }),
/* 631 */
/* no static exports found */
/* exports used: Wormhole, PortalTarget, Portal */
/*!************************************************!*\
  !*** ./~/portal-vue/dist/portal-vue.common.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

 /*! 
  * portal-vue © Thorsten Lünborg, 2019 
  * 
  * Version: 2.1.7
  * 
  * LICENCE: MIT 
  * 
  * https://github.com/linusborg/portal-vue
  * 
 */



Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__(/*! vue */ 31));

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var inBrowser = typeof window !== 'undefined';
function freeze(item) {
  if (Array.isArray(item) || _typeof(item) === 'object') {
    return Object.freeze(item);
  }

  return item;
}
function combinePassengers(transports) {
  var slotProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return transports.reduce(function (passengers, transport) {
    var temp = transport.passengers[0];
    var newPassengers = typeof temp === 'function' ? temp(slotProps) : transport.passengers;
    return passengers.concat(newPassengers);
  }, []);
}
function stableSort(array, compareFn) {
  return array.map(function (v, idx) {
    return [idx, v];
  }).sort(function (a, b) {
    return compareFn(a[1], b[1]) || a[0] - b[0];
  }).map(function (c) {
    return c[1];
  });
}
function pick(obj, keys) {
  return keys.reduce(function (acc, key) {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

var transports = {};
var targets = {};
var sources = {};
var Wormhole = Vue.extend({
  data: function data() {
    return {
      transports: transports,
      targets: targets,
      sources: sources,
      trackInstances: inBrowser
    };
  },
  methods: {
    open: function open(transport) {
      if (!inBrowser) return;
      var to = transport.to,
          from = transport.from,
          passengers = transport.passengers,
          _transport$order = transport.order,
          order = _transport$order === void 0 ? Infinity : _transport$order;
      if (!to || !from || !passengers) return;
      var newTransport = {
        to: to,
        from: from,
        passengers: freeze(passengers),
        order: order
      };
      var keys = Object.keys(this.transports);

      if (keys.indexOf(to) === -1) {
        Vue.set(this.transports, to, []);
      }

      var currentIndex = this.$_getTransportIndex(newTransport); // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays

      var newTransports = this.transports[to].slice(0);

      if (currentIndex === -1) {
        newTransports.push(newTransport);
      } else {
        newTransports[currentIndex] = newTransport;
      }

      this.transports[to] = stableSort(newTransports, function (a, b) {
        return a.order - b.order;
      });
    },
    close: function close(transport) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var to = transport.to,
          from = transport.from;
      if (!to || !from && force === false) return;

      if (!this.transports[to]) {
        return;
      }

      if (force) {
        this.transports[to] = [];
      } else {
        var index = this.$_getTransportIndex(transport);

        if (index >= 0) {
          // Copying the array here so that the PortalTarget change event will actually contain two distinct arrays
          var newTransports = this.transports[to].slice(0);
          newTransports.splice(index, 1);
          this.transports[to] = newTransports;
        }
      }
    },
    registerTarget: function registerTarget(target, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.targets[target]) {
        console.warn("[portal-vue]: Target ".concat(target, " already exists"));
      }

      this.$set(this.targets, target, Object.freeze([vm]));
    },
    unregisterTarget: function unregisterTarget(target) {
      this.$delete(this.targets, target);
    },
    registerSource: function registerSource(source, vm, force) {
      if (!inBrowser) return;

      if (this.trackInstances && !force && this.sources[source]) {
        console.warn("[portal-vue]: source ".concat(source, " already exists"));
      }

      this.$set(this.sources, source, Object.freeze([vm]));
    },
    unregisterSource: function unregisterSource(source) {
      this.$delete(this.sources, source);
    },
    hasTarget: function hasTarget(to) {
      return !!(this.targets[to] && this.targets[to][0]);
    },
    hasSource: function hasSource(to) {
      return !!(this.sources[to] && this.sources[to][0]);
    },
    hasContentFor: function hasContentFor(to) {
      return !!this.transports[to] && !!this.transports[to].length;
    },
    // Internal
    $_getTransportIndex: function $_getTransportIndex(_ref) {
      var to = _ref.to,
          from = _ref.from;

      for (var i in this.transports[to]) {
        if (this.transports[to][i].from === from) {
          return +i;
        }
      }

      return -1;
    }
  }
});
var wormhole = new Wormhole(transports);

var _id = 1;
var Portal = Vue.extend({
  name: 'portal',
  props: {
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      default: function _default() {
        return String(_id++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerSource(_this.name, _this);
    });
  },
  mounted: function mounted() {
    if (!this.disabled) {
      this.sendUpdate();
    }
  },
  updated: function updated() {
    if (this.disabled) {
      this.clear();
    } else {
      this.sendUpdate();
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterSource(this.name);
    this.clear();
  },
  watch: {
    to: function to(newValue, oldValue) {
      oldValue && oldValue !== newValue && this.clear(oldValue);
      this.sendUpdate();
    }
  },
  methods: {
    clear: function clear(target) {
      var closer = {
        from: this.name,
        to: target || this.to
      };
      wormhole.close(closer);
    },
    normalizeSlots: function normalizeSlots() {
      return this.$scopedSlots.default ? [this.$scopedSlots.default] : this.$slots.default;
    },
    normalizeOwnChildren: function normalizeOwnChildren(children) {
      return typeof children === 'function' ? children(this.slotProps) : children;
    },
    sendUpdate: function sendUpdate() {
      var slotContent = this.normalizeSlots();

      if (slotContent) {
        var transport = {
          from: this.name,
          to: this.to,
          passengers: _toConsumableArray(slotContent),
          order: this.order
        };
        wormhole.open(transport);
      } else {
        this.clear();
      }
    }
  },
  render: function render(h) {
    var children = this.$slots.default || this.$scopedSlots.default || [];
    var Tag = this.tag;

    if (children && this.disabled) {
      return children.length <= 1 && this.slim ? this.normalizeOwnChildren(children)[0] : h(Tag, [this.normalizeOwnChildren(children)]);
    } else {
      return this.slim ? h() : h(Tag, {
        class: {
          'v-portal': true
        },
        style: {
          display: 'none'
        },
        key: 'v-portal-placeholder'
      });
    }
  }
});

var PortalTarget = Vue.extend({
  name: 'portalTarget',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    slim: {
      type: Boolean,
      default: false
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  data: function data() {
    return {
      transports: wormhole.transports,
      firstRender: true
    };
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      wormhole.registerTarget(_this.name, _this);
    });
  },
  watch: {
    ownTransports: function ownTransports() {
      this.$emit('change', this.children().length > 0);
    },
    name: function name(newVal, oldVal) {
      /**
       * TODO
       * This should warn as well ...
       */
      wormhole.unregisterTarget(oldVal);
      wormhole.registerTarget(newVal, this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.transition) {
      this.$nextTick(function () {
        // only when we have a transition, because it causes a re-render
        _this2.firstRender = false;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    wormhole.unregisterTarget(this.name);
  },
  computed: {
    ownTransports: function ownTransports() {
      var transports = this.transports[this.name] || [];

      if (this.multiple) {
        return transports;
      }

      return transports.length === 0 ? [] : [transports[transports.length - 1]];
    },
    passengers: function passengers() {
      return combinePassengers(this.ownTransports, this.slotProps);
    }
  },
  methods: {
    // can't be a computed prop because it has to "react" to $slot changes.
    children: function children() {
      return this.passengers.length !== 0 ? this.passengers : this.$scopedSlots.default ? this.$scopedSlots.default(this.slotProps) : this.$slots.default || [];
    },
    // can't be a computed prop because it has to "react" to this.children().
    noWrapper: function noWrapper() {
      var noWrapper = this.slim && !this.transition;

      if (noWrapper && this.children().length > 1) {
        console.warn('[portal-vue]: PortalTarget with `slim` option received more than one child element.');
      }

      return noWrapper;
    }
  },
  render: function render(h) {
    var noWrapper = this.noWrapper();
    var children = this.children();
    var Tag = this.transition || this.tag;
    return noWrapper ? children[0] : this.slim && !Tag ? h() : h(Tag, {
      props: {
        // if we have a transition component, pass the tag if it exists
        tag: this.transition && this.tag ? this.tag : undefined
      },
      class: {
        'vue-portal-target': true
      }
    }, children);
  }
});

var _id$1 = 0;
var portalProps = ['disabled', 'name', 'order', 'slim', 'slotProps', 'tag', 'to'];
var targetProps = ['multiple', 'transition'];
var MountingPortal = Vue.extend({
  name: 'MountingPortal',
  inheritAttrs: false,
  props: {
    append: {
      type: [Boolean, String]
    },
    bail: {
      type: Boolean
    },
    mountTo: {
      type: String,
      required: true
    },
    // Portal
    disabled: {
      type: Boolean
    },
    // name for the portal
    name: {
      type: String,
      default: function _default() {
        return 'mounted_' + String(_id$1++);
      }
    },
    order: {
      type: Number,
      default: 0
    },
    slim: {
      type: Boolean
    },
    slotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag: {
      type: String,
      default: 'DIV'
    },
    // name for the target
    to: {
      type: String,
      default: function _default() {
        return String(Math.round(Math.random() * 10000000));
      }
    },
    // Target
    multiple: {
      type: Boolean,
      default: false
    },
    targetSlim: {
      type: Boolean
    },
    targetSlotProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    targetTag: {
      type: String,
      default: 'div'
    },
    transition: {
      type: [String, Object, Function]
    }
  },
  created: function created() {
    if (typeof document === 'undefined') return;
    var el = document.querySelector(this.mountTo);

    if (!el) {
      console.error("[portal-vue]: Mount Point '".concat(this.mountTo, "' not found in document"));
      return;
    }

    var props = this.$props; // Target already exists

    if (wormhole.targets[props.name]) {
      if (props.bail) {
        console.warn("[portal-vue]: Target ".concat(props.name, " is already mounted.\n        Aborting because 'bail: true' is set"));
      } else {
        this.portalTarget = wormhole.targets[props.name];
      }

      return;
    }

    var append = props.append;

    if (append) {
      var type = typeof append === 'string' ? append : 'DIV';
      var mountEl = document.createElement(type);
      el.appendChild(mountEl);
      el = mountEl;
    } // get props for target from $props
    // we have to rename a few of them


    var _props = pick(this.$props, targetProps);

    _props.slim = this.targetSlim;
    _props.tag = this.targetTag;
    _props.slotProps = this.targetSlotProps;
    _props.name = this.to;
    this.portalTarget = new PortalTarget({
      el: el,
      parent: this.$parent || this,
      propsData: _props
    });
  },
  beforeDestroy: function beforeDestroy() {
    var target = this.portalTarget;

    if (this.append) {
      var el = target.$el;
      el.parentNode.removeChild(el);
    }

    target.$destroy();
  },
  render: function render(h) {
    if (!this.portalTarget) {
      console.warn("[portal-vue] Target wasn't mounted");
      return h();
    } // if there's no "manual" scoped slot, so we create a <Portal> ourselves


    if (!this.$scopedSlots.manual) {
      var props = pick(this.$props, portalProps);
      return h(Portal, {
        props: props,
        attrs: this.$attrs,
        on: this.$listeners,
        scopedSlots: this.$scopedSlots
      }, this.$slots.default);
    } // else, we render the scoped slot


    var content = this.$scopedSlots.manual({
      to: this.to
    }); // if user used <template> for the scoped slot
    // content will be an array

    if (Array.isArray(content)) {
      content = content[0];
    }

    if (!content) return h();
    return content;
  }
});

function install(Vue$$1) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue$$1.component(options.portalName || 'Portal', Portal);
  Vue$$1.component(options.portalTargetName || 'PortalTarget', PortalTarget);
  Vue$$1.component(options.MountingPortalName || 'MountingPortal', MountingPortal);
}

var index = {
  install: install
};

exports.default = index;
exports.Portal = Portal;
exports.PortalTarget = PortalTarget;
exports.MountingPortal = MountingPortal;
exports.Wormhole = wormhole;
//# sourceMappingURL=portal-vue.common.js.map


/***/ }),
/* 632 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./~/underscore/modules/_baseCreate.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseCreate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(/*! ./isObject.js */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);



// Create a naked function reference for surrogate-prototype-swapping.
function ctor() {
  return function(){};
}

// An internal function for creating a new object that inherits from another.
function baseCreate(prototype) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(prototype)) return {};
  if (__WEBPACK_IMPORTED_MODULE_1__setup_js__["g" /* nativeCreate */]) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__setup_js__["g" /* nativeCreate */])(prototype);
  var Ctor = ctor();
  Ctor.prototype = prototype;
  var result = new Ctor;
  Ctor.prototype = null;
  return result;
}


/***/ }),
/* 633 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/_baseIteratee.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = baseIteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(/*! ./identity.js */ 288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(/*! ./isObject.js */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(/*! ./isArray.js */ 116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matcher_js__ = __webpack_require__(/*! ./matcher.js */ 193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__property_js__ = __webpack_require__(/*! ./property.js */ 296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__ = __webpack_require__(/*! ./_optimizeCb.js */ 153);








// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `_.identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value, context, argCount) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */];
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(value)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__optimizeCb_js__["a" /* default */])(value, context, argCount);
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matcher_js__["a" /* default */])(value);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__property_js__["a" /* default */])(value);
}


/***/ }),
/* 634 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./~/underscore/modules/_chainResult.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);


// Helper function to continue chaining intermediate results.
function chainResult(instance, obj) {
  return instance._chain ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj).chain() : obj;
}


/***/ }),
/* 635 */
/* exports provided: default */
/* exports used: default */
/*!******************************************************!*\
  !*** ./~/underscore/modules/_collectNonEnumProps.js ***!
  \******************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = collectNonEnumProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_js__ = __webpack_require__(/*! ./_has.js */ 99);




// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function emulatedSet(keys) {
  var hash = {};
  for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
  return {
    contains: function(key) { return hash[key] === true; },
    push: function(key) {
      hash[key] = true;
      return keys.push(key);
    }
  };
}

// Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
// be iterated by `for key in ...` and thus missed. Extends `keys` in place if
// needed.
function collectNonEnumProps(obj, keys) {
  keys = emulatedSet(keys);
  var nonEnumIdx = __WEBPACK_IMPORTED_MODULE_0__setup_js__["i" /* nonEnumerableProps */].length;
  var constructor = obj.constructor;
  var proto = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(constructor) && constructor.prototype) || __WEBPACK_IMPORTED_MODULE_0__setup_js__["j" /* ObjProto */];

  // Constructor is a special case.
  var prop = 'constructor';
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__has_js__["a" /* default */])(obj, prop) && !keys.contains(prop)) keys.push(prop);

  while (nonEnumIdx--) {
    prop = __WEBPACK_IMPORTED_MODULE_0__setup_js__["i" /* nonEnumerableProps */][nonEnumIdx];
    if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
      keys.push(prop);
    }
  }
}


/***/ }),
/* 636 */
/* exports provided: default */
/* exports used: default */
/*!************************************************!*\
  !*** ./~/underscore/modules/_createEscaper.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createEscaper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);


// Internal helper to generate functions for escaping and unescaping strings
// to/from HTML interpolation.
function createEscaper(map) {
  var escaper = function(match) {
    return map[match];
  };
  // Regexes for identifying a key that needs to be escaped.
  var source = '(?:' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(map).join('|') + ')';
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, 'g');
  return function(string) {
    string = string == null ? '' : '' + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}


/***/ }),
/* 637 */
/* exports provided: default */
/* exports used: default */
/*!****************************************************!*\
  !*** ./~/underscore/modules/_createIndexFinder.js ***!
  \****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isNaN_js__ = __webpack_require__(/*! ./isNaN.js */ 662);




// Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
function createIndexFinder(dir, predicateFind, sortedIndex) {
  return function(array, item, idx) {
    var i = 0, length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array);
    if (typeof idx == 'number') {
      if (dir > 0) {
        i = idx >= 0 ? idx : Math.max(idx + length, i);
      } else {
        length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
      }
    } else if (sortedIndex && idx && length) {
      idx = sortedIndex(array, item);
      return array[idx] === item ? idx : -1;
    }
    if (item !== item) {
      idx = predicateFind(__WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* slice */].call(array, i, length), __WEBPACK_IMPORTED_MODULE_2__isNaN_js__["a" /* default */]);
      return idx >= 0 ? idx + i : -1;
    }
    for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
      if (array[idx] === item) return idx;
    }
    return -1;
  };
}


/***/ }),
/* 638 */
/* exports provided: default */
/* exports used: default */
/*!*************************************************************!*\
  !*** ./~/underscore/modules/_createPredicateIndexFinder.js ***!
  \*************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPredicateIndexFinder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);



// Internal function to generate `_.findIndex` and `_.findLastIndex`.
function createPredicateIndexFinder(dir) {
  return function(array, predicate, context) {
    predicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
    var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
    var index = dir > 0 ? 0 : length - 1;
    for (; index >= 0 && index < length; index += dir) {
      if (predicate(array[index], index, array)) return index;
    }
    return -1;
  };
}


/***/ }),
/* 639 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/_createReduce.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(/*! ./_optimizeCb.js */ 153);




// Internal helper to create a reducing function, iterating left or right.
function createReduce(dir) {
  // Wrap code that reassigns argument variables in a separate function than
  // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
  var reducer = function(obj, iteratee, memo, initial) {
    var _keys = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
        length = (_keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
    if (!initial) {
      memo = obj[_keys ? _keys[index] : index];
      index += dir;
    }
    for (; index >= 0 && index < length; index += dir) {
      var currentKey = _keys ? _keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  return function(obj, iteratee, memo, context) {
    var initial = arguments.length >= 3;
    return reducer(obj, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, context, 4), memo, initial);
  };
}


/***/ }),
/* 640 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./~/underscore/modules/_createSizePropertyCheck.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSizePropertyCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// Common internal logic for `isArrayLike` and `isBufferLike`.
function createSizePropertyCheck(getSizeProperty) {
  return function(collection) {
    var sizeProperty = getSizeProperty(collection);
    return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= __WEBPACK_IMPORTED_MODULE_0__setup_js__["e" /* MAX_ARRAY_INDEX */];
  }
}


/***/ }),
/* 641 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/_escapeMap.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Internal list of HTML entities for escaping.
/* harmony default export */ __webpack_exports__["a"] = ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
});


/***/ }),
/* 642 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/_executeBound.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = executeBound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(/*! ./_baseCreate.js */ 632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(/*! ./isObject.js */ 117);



// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(result)) return result;
  return self;
}


/***/ }),
/* 643 */
/* exports provided: default */
/* exports used: default */
/*!**************************************************!*\
  !*** ./~/underscore/modules/_shallowProperty.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowProperty;
// Internal helper to generate a function to obtain property `key` from `obj`.
function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}


/***/ }),
/* 644 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/before.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = before;
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function before(times, func) {
  var memo;
  return function() {
    if (--times > 0) {
      memo = func.apply(this, arguments);
    }
    if (times <= 1) func = null;
    return memo;
  };
}


/***/ }),
/* 645 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/bind.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__executeBound_js__ = __webpack_require__(/*! ./_executeBound.js */ 642);




// Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, context, args) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(func)) throw new TypeError('Bind must be called on a function');
  var bound = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(callArgs) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__executeBound_js__["a" /* default */])(func, bound, context, this, args.concat(callArgs));
  });
  return bound;
}));


/***/ }),
/* 646 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/constant.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constant;
// Predicate-generating function. Often useful outside of Underscore.
function constant(value) {
  return function() {
    return value;
  };
}


/***/ }),
/* 647 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/defaults.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(/*! ./_createAssigner.js */ 282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(/*! ./allKeys.js */ 156);



// Fill in a given object with default properties.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */], true));


/***/ }),
/* 648 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/delay.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);


// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
}));


/***/ }),
/* 649 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/difference.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(/*! ./_flatten.js */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_js__ = __webpack_require__(/*! ./filter.js */ 158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(/*! ./contains.js */ 157);





// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, rest) {
  rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(rest, true, true);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__filter_js__["a" /* default */])(array, function(value){
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(rest, value);
  });
}));


/***/ }),
/* 650 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/extend.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAssigner_js__ = __webpack_require__(/*! ./_createAssigner.js */ 282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allKeys_js__ = __webpack_require__(/*! ./allKeys.js */ 156);



// Extend a given object with all the properties in passed-in object(s).
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createAssigner_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__allKeys_js__["a" /* default */]));


/***/ }),
/* 651 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/find.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = find;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(/*! ./findIndex.js */ 287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findKey_js__ = __webpack_require__(/*! ./findKey.js */ 652);




// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__findKey_js__["a" /* default */];
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}


/***/ }),
/* 652 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/findKey.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);



// Returns the first key on an object that passes a truth test.
function findKey(obj, predicate, context) {
  predicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj), key;
  for (var i = 0, length = _keys.length; i < length; i++) {
    key = _keys[i];
    if (predicate(obj[key], key, obj)) return key;
  }
}


/***/ }),
/* 653 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/findLastIndex.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__ = __webpack_require__(/*! ./_createPredicateIndexFinder.js */ 638);


// Returns the last index on an array-like that passes a truth test.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createPredicateIndexFinder_js__["a" /* default */])(-1));


/***/ }),
/* 654 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/functions.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = functions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);


// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];
  for (var key in obj) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(obj[key])) names.push(key);
  }
  return names.sort();
}


/***/ }),
/* 655 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/get.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPath_js__ = __webpack_require__(/*! ./_toPath.js */ 155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepGet_js__ = __webpack_require__(/*! ./_deepGet.js */ 283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isUndefined_js__ = __webpack_require__(/*! ./isUndefined.js */ 666);




// Get the value of the (deep) property on `path` from `object`.
// If any property in `path` does not exist or if the value is
// `undefined`, return `defaultValue` instead.
// The `path` is normalized through `_.toPath`.
function get(object, path, defaultValue) {
  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__deepGet_js__["a" /* default */])(object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toPath_js__["a" /* default */])(path));
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isUndefined_js__["a" /* default */])(value) ? defaultValue : value;
}


/***/ }),
/* 656 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/indexOf.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__ = __webpack_require__(/*! ./sortedIndex.js */ 674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(/*! ./findIndex.js */ 287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__ = __webpack_require__(/*! ./_createIndexFinder.js */ 637);




// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createIndexFinder_js__["a" /* default */])(1, __WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__sortedIndex_js__["a" /* default */]));


/***/ }),
/* 657 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/initial.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
function initial(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["d" /* slice */].call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}


/***/ }),
/* 658 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/invert.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);


// Invert the keys and values of an object. The values must be serializable.
function invert(obj) {
  var result = {};
  var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  for (var i = 0, length = _keys.length; i < length; i++) {
    result[obj[_keys[i]]] = _keys[i];
  }
  return result;
}


/***/ }),
/* 659 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/isArrayBuffer.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('ArrayBuffer'));


/***/ }),
/* 660 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/isBoolean.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isBoolean;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// Is a given value a boolean?
function isBoolean(obj) {
  return obj === true || obj === false || __WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* toString */].call(obj) === '[object Boolean]';
}


/***/ }),
/* 661 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/isMatch.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);


// Returns whether an object has a given set of `key:value` pairs.
function isMatch(object, attrs) {
  var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(attrs), length = _keys.length;
  if (object == null) return !length;
  var obj = Object(object);
  for (var i = 0; i < length; i++) {
    var key = _keys[i];
    if (attrs[key] !== obj[key] || !(key in obj)) return false;
  }
  return true;
}


/***/ }),
/* 662 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/isNaN.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNaN;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNumber_js__ = __webpack_require__(/*! ./isNumber.js */ 663);



// Is the given value `NaN`?
function isNaN(obj) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isNumber_js__["a" /* default */])(obj) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setup_js__["q" /* _isNaN */])(obj);
}


/***/ }),
/* 663 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/isNumber.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Number'));


/***/ }),
/* 664 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/isSymbol.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Symbol'));


/***/ }),
/* 665 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./~/underscore/modules/isTypedArray.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isDataView_js__ = __webpack_require__(/*! ./isDataView.js */ 291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(/*! ./constant.js */ 646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__ = __webpack_require__(/*! ./_isBufferLike.js */ 1158);





// Is a given value a typed array?
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(obj) {
  // `ArrayBuffer.isView` is the most future-proof, so use it when available.
  // Otherwise, fall back on the above regular expression.
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["o" /* nativeIsView */] ? (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setup_js__["o" /* nativeIsView */])(obj) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isDataView_js__["a" /* default */])(obj)) :
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isBufferLike_js__["a" /* default */])(obj) && typedArrayPattern.test(__WEBPACK_IMPORTED_MODULE_0__setup_js__["l" /* toString */].call(obj));
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__setup_js__["p" /* supportsArrayBuffer */] ? isTypedArray : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(false));


/***/ }),
/* 666 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./~/underscore/modules/isUndefined.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isUndefined;
// Is a given variable undefined?
function isUndefined(obj) {
  return obj === void 0;
}


/***/ }),
/* 667 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/iteratee.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iteratee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(/*! ./_baseIteratee.js */ 633);



// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
function iteratee(value, context) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(value, context, Infinity);
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].iteratee = iteratee;


/***/ }),
/* 668 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/max.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(/*! ./values.js */ 129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(/*! ./each.js */ 115);





// Return the maximum element (or element-based computation).
function max(obj, iteratee, context) {
  var result = -Infinity, lastComputed = -Infinity,
      value, computed;
  if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
    obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value > result) {
        result = value;
      }
    }
  } else {
    iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 669 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/noop.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
// Predicate-generating function. Often useful outside of Underscore.
function noop(){}


/***/ }),
/* 670 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/pick.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__ = __webpack_require__(/*! ./_optimizeCb.js */ 153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__allKeys_js__ = __webpack_require__(/*! ./allKeys.js */ 156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__ = __webpack_require__(/*! ./_keyInObj.js */ 1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flatten_js__ = __webpack_require__(/*! ./_flatten.js */ 127);







// Return a copy of the object only containing the allowed properties.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var result = {}, iteratee = keys[0];
  if (obj == null) return result;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    if (keys.length > 1) iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__optimizeCb_js__["a" /* default */])(iteratee, keys[1]);
    keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__allKeys_js__["a" /* default */])(obj);
  } else {
    iteratee = __WEBPACK_IMPORTED_MODULE_4__keyInObj_js__["a" /* default */];
    keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__flatten_js__["a" /* default */])(keys, false, false);
    obj = Object(obj);
  }
  for (var i = 0, length = keys.length; i < length; i++) {
    var key = keys[i];
    var value = obj[key];
    if (iteratee(value, key, obj)) result[key] = value;
  }
  return result;
}));


/***/ }),
/* 671 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/random.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = random;
// Return a random integer between `min` and `max` (inclusive).
function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}


/***/ }),
/* 672 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/rest.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// Returns everything but the first entry of the `array`. Especially useful on
// the `arguments` object. Passing an **n** will return the rest N values in the
// `array`.
function rest(array, n, guard) {
  return __WEBPACK_IMPORTED_MODULE_0__setup_js__["d" /* slice */].call(array, n == null || guard ? 1 : n);
}


/***/ }),
/* 673 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/sample.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(/*! ./values.js */ 129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__random_js__ = __webpack_require__(/*! ./random.js */ 671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toArray_js__ = __webpack_require__(/*! ./toArray.js */ 676);






// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `_.map`.
function sample(obj, n, guard) {
  if (n == null || guard) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj)) obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    return obj[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__random_js__["a" /* default */])(obj.length - 1)];
  }
  var sample = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toArray_js__["a" /* default */])(obj);
  var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getLength_js__["a" /* default */])(sample);
  n = Math.max(Math.min(n, length), 0);
  var last = length - 1;
  for (var index = 0; index < n; index++) {
    var rand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__random_js__["a" /* default */])(index, last);
    var temp = sample[index];
    sample[index] = sample[rand];
    sample[rand] = temp;
  }
  return sample.slice(0, n);
}


/***/ }),
/* 674 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./~/underscore/modules/sortedIndex.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortedIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);



// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex(array, obj, iteratee, context) {
  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context, 1);
  var value = iteratee(obj);
  var low = 0, high = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */])(array);
  while (low < high) {
    var mid = Math.floor((low + high) / 2);
    if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
  }
  return low;
}


/***/ }),
/* 675 */
/* exports provided: default */
/* exports used: default */
/*!**************************************************!*\
  !*** ./~/underscore/modules/templateSettings.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);


// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
});


/***/ }),
/* 676 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/toArray.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(/*! ./isArray.js */ 116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(/*! ./isString.js */ 292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map_js__ = __webpack_require__(/*! ./map.js */ 128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__identity_js__ = __webpack_require__(/*! ./identity.js */ 288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__values_js__ = __webpack_require__(/*! ./values.js */ 129);








// Safely create a real, live array from anything iterable.
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray(obj) {
  if (!obj) return [];
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(obj)) return __WEBPACK_IMPORTED_MODULE_1__setup_js__["d" /* slice */].call(obj);
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj)) {
    // Keep surrogate pair characters together.
    return obj.match(reStrSymbol);
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__["a" /* default */])(obj)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__map_js__["a" /* default */])(obj, __WEBPACK_IMPORTED_MODULE_5__identity_js__["a" /* default */]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__values_js__["a" /* default */])(obj);
}


/***/ }),
/* 677 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/toPath.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(/*! ./isArray.js */ 116);



// Normalize a (deep) property `path` to array.
// Like `_.iteratee`, this function can be customized.
function toPath(path) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(path) ? path : [path];
}
__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].toPath = toPath;


/***/ }),
/* 678 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/uniq.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isBoolean_js__ = __webpack_require__(/*! ./isBoolean.js */ 660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contains_js__ = __webpack_require__(/*! ./contains.js */ 157);





// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array, isSorted, iteratee, context) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isBoolean_js__["a" /* default */])(isSorted)) {
    context = iteratee;
    iteratee = isSorted;
    isSorted = false;
  }
  if (iteratee != null) iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cb_js__["a" /* default */])(iteratee, context);
  var result = [];
  var seen = [];
  for (var i = 0, length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getLength_js__["a" /* default */])(array); i < length; i++) {
    var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted && !iteratee) {
      if (!i || seen !== computed) result.push(value);
      seen = computed;
    } else if (iteratee) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(seen, computed)) {
        seen.push(computed);
        result.push(value);
      }
    } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__contains_js__["a" /* default */])(result, value)) {
      result.push(value);
    }
  }
  return result;
}


/***/ }),
/* 679 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/unzip.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unzip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__max_js__ = __webpack_require__(/*! ./max.js */ 668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pluck_js__ = __webpack_require__(/*! ./pluck.js */ 295);




// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array) {
  var length = (array && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__max_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__getLength_js__["a" /* default */]).length) || 0;
  var result = Array(length);

  for (var index = 0; index < length; index++) {
    result[index] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__pluck_js__["a" /* default */])(array, index);
  }
  return result;
}


/***/ }),
/* 680 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./client/assets/icones_app/today-signal.png ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b18fda9aefe060d1f9e2f4401a6635f3.png";

/***/ }),
/* 681 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./client/assets/login/img/password.png ***!
  \**********************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAaCAYAAAC6nQw6AAAAAXNSR0IArs4c6QAAAVNJREFUOBG9lLtKA0EUhndiVoggBhFsTKGNgogWWisoxBQhTfBhBDsrX0FbK59BUGx8AMEHCF4KQQgWQSHrd2QWzo67OSEuDnzMufzn35llWRcVrCRJ5mjtwZqXPLLfOOf6Prc3TA7hFWR9eSR+hgPbAQXCdfiEHrShBjPQgScYwKpphugO+tAIxdSW4QOuw14mRzAPsk4zDZXQO4MhzKpyVNEJ8ZbP74O6TqXnYFMXQ6MF33zToiBOe6n2px0aBTPjp6UZZR7JC4yhDlOZhkroVb0mVuXIUdylcKKLE8TNKkOLsD/BsB6plPaO/tXogTu86HvkxdaJjvltbDC4Ard5BmnNMroQIWYDtst0KG+3jHbU0LaKf4d8R0dQtN5pyL+oVSTw9dg6UZ1HT4N8ayOXZTRyWDfly7bWOYIlSzSOUdcykX5pVyvNSK7Wgys53h/W8BsnjdoiQwg6ZAAAAABJRU5ErkJggg=="

/***/ }),
/* 682 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./client/assets/login/img/user.png ***!
  \******************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAaCAYAAACzdqxAAAAAAXNSR0IArs4c6QAAAXVJREFUSA2tlLFLw1AQh5NaQYoiRUUUxcFO4iAqiLoJ3Rx0EgdHV2dB/GMcFWcHwUFx1b3SRbRYUByLUGz8bgik6V3yEnPwI/d+d/e9Rx99vucQQRDM0TaPhtEnavq+3+WbLwBOoxsUj3eMnVxUBgXajhMj6x75YWY4Q5cRiJV+UZhyhtNcs0iKf6aBS5qJt2r4mr2mmRa4pjUb3qLmW+CG1mx4L5pvgZ+0ZsPL0ut5XNKFclFx6wOjamyo2wxMoNc4KbLuku/p0ykug1V0FYGFaZNkI2ncTyqGNSBL5JtoBMnF3v/rrQCQOxJPzEmlvo7kxLOog1rokRO3+WYLgBV0jt6QFr+YD6juTKZ5G1lASgNxjTOauAEN++hnYDTdeKZlUoVTWEGddIbZcUdlqA+OUUYNc8S9cBoHH7vPJnZ+Ux0XePgInfTtlH8h78aRjJfYYYHvsiwKil3hyInlr1pkbAlMwDNFUmGN8StUyiS36KBgeO8Pj0inIq9J60cAAAAASUVORK5CYII="

/***/ }),
/* 683 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/assets/login/img/voltar.png ***!
  \********************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAAXNSR0IArs4c6QAAA5NJREFUWAnFl91LFFEYxncriD7sQ+1LLUooutkIukkviiAS0aIPCMLqLkQirLzrprrqIugqC6K8KLqOggr6MjIriv6BNAXJzFDIjLS0tt+znrM7uzszOzMWPfDs+57zPu+Z98zMnnMmHguBZDK5AHktrIZlhguxn+FH2Acfwo54PD6J/Xvg4jXwPvwBg2AYURtcG6SKuJ+IQTYSPw+3O3QT+J2wB2r2I3ApLIcJQ0wKuhtX4FnujO5WOFBAE5yAFp04DXCR30jEK2EL/AAtBnA2++VlxRDPhBdtNrYL7skSBWiQMweegqNQGIcHA6TGYgidBdylrZcxMshPwF4o/Ib+E0JwREqDS9gZka/uSGScJfCtGfcbdoMjnHEJqGL79t/DD1UA+lLo+aITK4d6N4T3cHbm6sajU7de6Ib67wcGer2Ik/C6XxLxKqPDJFuytHRsVa/BvqxggQY5J2witq2AXO/cNaPXWpKZLI07JvCq0CDOODnNJk+mA85zxt18NBVwDArHUxqcudB2NrgluvWRcwxaPMeZ76Zz60N70yS2p+I0dpsOLUyL3ZJy+9AdNTkyL2BRrsavjX6/EoGuWaxndEEt8NQv0cbQaSW1eIkTeh0hpwjqRRbq9DfUmi+8mzLevyQ0Em01itfYGvaEr94Z7hFyRol8MtFyFbHCNAaMdTUUcIDAZai14A3cEaUA8iy0+QllKqIk5cZiQ8Z6mcME7GLURAHaPaeDYZNcoiJso7TAiOeIjxnNLe5MZQF9oXB68irC3hb7WFyTmfkzArvgOFwJ2ylkDTYqdDITBpxFrJvq8/6lkEdEbSGr8FXIau8M9wg5+ksvN9F+/UWjrBM67ul8IPRCFRQY6PPWCa2Y36EQZsWsRW8L6cHXIwoEtHbFfJJOoDPq3lFHrt3+tT1XpAf1cKSBdptoTsvo3AItwu6i9STaQm6nB/Vw0NpddAg/s4tKT8d0zhM7ye+HZzyuneom7jxPnMzTIkhAO6PQJ6u8AXM6GNt5suqmnX+yUg6B/3vGtIVTyL8+be+11/K0FDELtkKLLhz/Y7rLaOS4fXcccpF6dzGIDi46dFh04jTAKF9gg+RVeV3N7oqucRI3EdC36DaHYALf+S36hfYyqL1A3xMJaPEL5yo8zZI/aDsjWYrRovQYOu8MTU+MELkB1we5oO+dyB2AQYvpq4fVUDMX9Xg0S+3GffABbGfmP7GB8Ad+rEiKzd9zOAAAAABJRU5ErkJggg=="

/***/ }),
/* 684 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./client/assets/logos_equals/logo_banking.png ***!
  \*****************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 685 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./client/assets/logos_equals/logo_equals_quadrado.png ***!
  \*************************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 686 */
/* exports provided: default, ErrorBag, Rules, ValidationObserver, ValidationProvider, Validator, directive, install, mapFields, mixin, version, withValidation */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/vee-validate/dist/vee-validate.esm.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorBag", function() { return ErrorBag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rules", function() { return Rules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationObserver", function() { return ValidationObserver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationProvider", function() { return ValidationProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Validator", function() { return Validator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "directive", function() { return directive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapFields", function() { return mapFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixin", function() { return mixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withValidation", function() { return withValidation; });
/**
  * vee-validate v2.2.15
  * (c) 2019 Abdelrahman Awad
  * @license MIT
  */
// 

var isTextInput = function (el) {
  return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'textarea', 'number'], el.type);
};

var isCheckboxOrRadioInput = function (el) {
  return includes(['radio', 'checkbox'], el.type);
};

var isDateInput = function (el) {
  return includes(['date', 'week', 'month', 'datetime-local', 'time'], el.type);
};

/**
 * Gets the data attribute. the name must be kebab-case.
 */
var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };

var isNaN$1 = function (value) {
  if ('isNaN' in Number) {
    return Number.isNaN(value);
  }

  // eslint-disable-next-line
  return typeof(value) === 'number' && value !== value;
};

/**
 * Checks if the values are either null or undefined.
 */
var isNullOrUndefined = function () {
  var values = [], len = arguments.length;
  while ( len-- ) values[ len ] = arguments[ len ];

  return values.every(function (value) {
    return value === null || value === undefined;
  });
};

/**
 * Creates the default flags object.
 */
var createFlags = function () { return ({
  untouched: true,
  touched: false,
  dirty: false,
  pristine: true,
  valid: null,
  invalid: null,
  validated: false,
  pending: false,
  required: false,
  changed: false
}); };

/**
 * Shallow object comparison.
 */
var isEqual = function (lhs, rhs) {
  if (lhs instanceof RegExp && rhs instanceof RegExp) {
    return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
  }

  if (Array.isArray(lhs) && Array.isArray(rhs)) {
    if (lhs.length !== rhs.length) { return false; }

    for (var i = 0; i < lhs.length; i++) {
      if (!isEqual(lhs[i], rhs[i])) {
        return false;
      }
    }

    return true;
  }

  // if both are objects, compare each key recursively.
  if (isObject(lhs) && isObject(rhs)) {
    return Object.keys(lhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    }) && Object.keys(rhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    });
  }

  if (isNaN$1(lhs) && isNaN$1(rhs)) {
    return true;
  }

  return lhs === rhs;
};

/**
 * Determines the input field scope.
 */
var getScope = function (el) {
  var scope = getDataAttribute(el, 'scope');
  if (isNullOrUndefined(scope)) {
    var form = getForm(el);

    if (form) {
      scope = getDataAttribute(form, 'scope');
    }
  }

  return !isNullOrUndefined(scope) ? scope : null;
};

/**
 * Get the closest form element.
 */
var getForm = function (el) {
  if (isNullOrUndefined(el)) { return null; }

  if (el.tagName === 'FORM') { return el; }

  if (!isNullOrUndefined(el.form)) { return el.form; }

  return !isNullOrUndefined(el.parentNode) ? getForm(el.parentNode) : null;
};

/**
 * Gets the value in an object safely.
 */
var getPath = function (path, target, def) {
  if ( def === void 0 ) def = undefined;

  if (!path || !target) { return def; }

  var value = target;
  path.split('.').every(function (prop) {
    if (prop in value) {
      value = value[prop];

      return true;
    }

    value = def;

    return false;
  });

  return value;
};

/**
 * Checks if path exists within an object.
 */
var hasPath = function (path, target) {
  var obj = target;
  var previousPath = null;
  var isNullOrNonObject = false;
  var isValidPath = path.split('.').reduce(function (reducer, prop) {
    if (obj == null || typeof obj !== 'object') {
      isNullOrNonObject = true;
      return reducer && false;
    }

    if (prop in obj) {
      obj = obj[prop];
      previousPath = previousPath === null ? prop : previousPath + '.' + prop;

      return reducer && true;
    }

    return reducer && false;
  }, true);

  if (true) {
    if (isNullOrNonObject) {
      throw new Error(previousPath + ' is not an object');
    }
  }

  return isValidPath;
};

/**
 * Parses a rule string expression.
 */
var parseRule = function (rule) {
  var params = [];
  var name = rule.split(':')[0];

  if (includes(rule, ':')) {
    params = rule.split(':').slice(1).join(':').split(',');
  }

  return { name: name, params: params };
};

/**
 * Debounces a function.
 */
var debounce = function (fn, wait, token) {
  if ( wait === void 0 ) wait = 0;
  if ( token === void 0 ) token = { cancelled: false };

  if (wait === 0) {
    return fn;
  }

  var timeout;

  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var later = function () {
      timeout = null;

      // check if the fn call was cancelled.
      if (!token.cancelled) { fn.apply(void 0, args); }
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (!timeout) { fn.apply(void 0, args); }
  };
};

/**
 * Appends a rule definition to a list of rules.
 */
var appendRule = function (rule, rules) {
  if (!rules) {
    return normalizeRules(rule);
  }

  if (!rule) {
    return normalizeRules(rules);
  }

  if (typeof rules === 'string') {
    rules = normalizeRules(rules);
  }

  return assign({}, rules, normalizeRules(rule));
};

/**
 * Normalizes the given rules expression.
 */
var normalizeRules = function (rules) {
  // if falsy value return an empty object.
  if (!rules) {
    return {};
  }

  if (isObject(rules)) {
    // $FlowFixMe
    return Object.keys(rules).reduce(function (prev, curr) {
      var params = [];
      // $FlowFixMe
      if (rules[curr] === true) {
        params = [];
      } else if (Array.isArray(rules[curr])) {
        params = rules[curr];
      } else if (isObject(rules[curr])) {
        params = rules[curr];
      } else {
        params = [rules[curr]];
      }

      // $FlowFixMe
      if (rules[curr] !== false) {
        prev[curr] = params;
      }

      return prev;
    }, {});
  }

  if (typeof rules !== 'string') {
    warn('rules must be either a string or an object.');
    return {};
  }

  return rules.split('|').reduce(function (prev, rule) {
    var parsedRule = parseRule(rule);
    if (!parsedRule.name) {
      return prev;
    }

    prev[parsedRule.name] = parsedRule.params;
    return prev;
  }, {});
};

/**
 * Emits a warning to the console.
 */
var warn = function (message) {
  console.warn(("[vee-validate] " + message)); // eslint-disable-line
};

/**
 * Creates a branded error object.
 */
var createError = function (message) { return new Error(("[vee-validate] " + message)); };

/**
 * Checks if the value is an object.
 */
var isObject = function (obj) { return obj !== null && obj && typeof obj === 'object' && ! Array.isArray(obj); };

/**
 * Checks if a function is callable.
 */
var isCallable = function (func) { return typeof func === 'function'; };

/**
 * Check if element has the css class on it.
 */
var hasClass = function (el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  }

  return !!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)")));
};

/**
 * Adds the provided css className to the element.
 */
var addClass = function (el, className) {
  if (el.classList) {
    el.classList.add(className);
    return;
  }

  if (!hasClass(el, className)) {
    el.className += " " + className;
  }
};

/**
 * Remove the provided css className from the element.
 */
var removeClass = function (el, className) {
  if (el.classList) {
    el.classList.remove(className);
    return;
  }

  if (hasClass(el, className)) {
    var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
    el.className = el.className.replace(reg, ' ');
  }
};

/**
 * Adds or removes a class name on the input depending on the status flag.
 */
var toggleClass = function (el, className, status) {
  if (!el || !className) { return; }

  if (Array.isArray(className)) {
    className.forEach(function (item) { return toggleClass(el, item, status); });
    return;
  }

  if (status) {
    return addClass(el, className);
  }

  removeClass(el, className);
};

/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
var toArray = function (arrayLike) {
  if (isCallable(Array.from)) {
    return Array.from(arrayLike);
  }

  var array = [];
  var length = arrayLike.length;
  /* istanbul ignore next */
  for (var i = 0; i < length; i++) {
    array.push(arrayLike[i]);
  }

  /* istanbul ignore next */
  return array;
};

/**
 * Converts an array-like object to array and place other elements in an array
 */
var ensureArray = function (arrayLike) {
  if (Array.isArray(arrayLike)) {
    return [].concat( arrayLike );
  }
  var array = toArray(arrayLike);
  return isEmptyArray(array) ? [arrayLike] : array;
};

/**
 * Assign polyfill from the mdn.
 */
var assign = function (target) {
  var others = [], len = arguments.length - 1;
  while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];

  /* istanbul ignore else */
  if (isCallable(Object.assign)) {
    return Object.assign.apply(Object, [ target ].concat( others ));
  }

  /* istanbul ignore next */
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  /* istanbul ignore next */
  var to = Object(target);
  /* istanbul ignore next */
  others.forEach(function (arg) {
    // Skip over if undefined or null
    if (arg != null) {
      Object.keys(arg).forEach(function (key) {
        to[key] = arg[key];
      });
    }
  });
  /* istanbul ignore next */
  return to;
};

var id = 0;
var idTemplate = '{id}';

/**
 * Generates a unique id.
 */
var uniqId = function () {
  // handle too many uses of uniqId, although unlikely.
  if (id >= 9999) {
    id = 0;
    // shift the template.
    idTemplate = idTemplate.replace('{id}', '_{id}');
  }

  id++;
  var newId = idTemplate.replace('{id}', String(id));

  return newId;
};

var findIndex = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      return i;
    }
  }

  return -1;
};

/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
var find = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  var idx = findIndex(array, predicate);

  return idx === -1 ? undefined : array[idx];
};

var isBuiltInComponent = function (vnode) {
  if (!vnode) {
    return false;
  }

  var tag = vnode.componentOptions.tag;

  return /^(keep-alive|transition|transition-group)$/.test(tag);
};

var makeDelayObject = function (events, delay, delayConfig) {
  if (typeof delay === 'number') {
    return events.reduce(function (prev, e) {
      prev[e] = delay;
      return prev;
    }, {});
  }

  return events.reduce(function (prev, e) {
    if (typeof delay === 'object' && e in delay) {
      prev[e] = delay[e];
      return prev;
    }

    if (typeof delayConfig === 'number') {
      prev[e] = delayConfig;
      return prev;
    }

    prev[e] = (delayConfig && delayConfig[e]) || 0;

    return prev;
  }, {});
};

var deepParseInt = function (input) {
  if (typeof input === 'number') { return input; }

  if (typeof input === 'string') { return parseInt(input); }

  var map = {};
  for (var element in input) {
    map[element] = parseInt(input[element]);
  }

  return map;
};

var merge = function (target, source) {
  if (! (isObject(target) && isObject(source))) {
    return target;
  }

  Object.keys(source).forEach(function (key) {
    var obj, obj$1;

    if (isObject(source[key])) {
      if (! target[key]) {
        assign(target, ( obj = {}, obj[key] = {}, obj ));
      }

      merge(target[key], source[key]);
      return;
    }

    assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
  });

  return target;
};

var fillRulesFromElement = function (el, rules) {
  if (el.required) {
    rules = appendRule('required', rules);
  }

  if (isTextInput(el)) {
    if (el.type === 'email') {
      rules = appendRule(("email" + (el.multiple ? ':multiple' : '')), rules);
    }

    if (el.pattern) {
      rules = appendRule({ regex: el.pattern }, rules);
    }

    // 524288 is the max on some browsers and test environments.
    if (el.maxLength >= 0 && el.maxLength < 524288) {
      rules = appendRule(("max:" + (el.maxLength)), rules);
    }

    if (el.minLength > 0) {
      rules = appendRule(("min:" + (el.minLength)), rules);
    }

    if (el.type === 'number') {
      rules = appendRule('decimal', rules);
      if (el.min !== '') {
        rules = appendRule(("min_value:" + (el.min)), rules);
      }

      if (el.max !== '') {
        rules = appendRule(("max_value:" + (el.max)), rules);
      }
    }

    return rules;
  }

  if (isDateInput(el)) {
    var timeFormat = el.step && Number(el.step) < 60 ? 'HH:mm:ss' : 'HH:mm';

    if (el.type === 'date') {
      return appendRule('date_format:yyyy-MM-dd', rules);
    }

    if (el.type === 'datetime-local') {
      return appendRule(("date_format:yyyy-MM-ddT" + timeFormat), rules);
    }

    if (el.type === 'month') {
      return appendRule('date_format:yyyy-MM', rules);
    }

    if (el.type === 'week') {
      return appendRule('date_format:yyyy-[W]WW', rules);
    }

    if (el.type === 'time') {
      return appendRule(("date_format:" + timeFormat), rules);
    }
  }

  return rules;
};

var values = function (obj) {
  if (isCallable(Object.values)) {
    return Object.values(obj);
  }

  // fallback to keys()
  /* istanbul ignore next */
  return Object.keys(obj).map(function (k) { return obj[k]; });
};

var parseSelector = function (selector) {
  var rule = null;
  if (includes(selector, ':')) {
    rule = selector.split(':').pop();
    selector = selector.replace((":" + rule), '');
  }

  if (selector[0] === '#') {
    return {
      id: selector.slice(1),
      rule: rule,
      name: null,
      scope: null
    };
  }

  var scope = null;
  var name = selector;
  if (includes(selector, '.')) {
    var parts = selector.split('.');
    scope = parts[0];
    name = parts.slice(1).join('.');
  }

  return {
    id: null,
    scope: scope,
    name: name,
    rule: rule
  };
};

var includes = function (collection, item) {
  return collection.indexOf(item) !== -1;
};

var isEmptyArray = function (arr) {
  return Array.isArray(arr) && arr.length === 0;
};

var defineNonReactive = function (obj, prop, value) {
  Object.defineProperty(obj, prop, {
    configurable: false,
    writable: true,
    value: value
  });
};

// 

var LOCALE = 'en';

var Dictionary = function Dictionary (dictionary) {
  if ( dictionary === void 0 ) dictionary = {};

  this.container = {};
  this.merge(dictionary);
};

var prototypeAccessors = { locale: { configurable: true } };

prototypeAccessors.locale.get = function () {
  return LOCALE;
};

prototypeAccessors.locale.set = function (value) {
  LOCALE = value || 'en';
};

Dictionary.prototype.hasLocale = function hasLocale (locale) {
  return !!this.container[locale];
};

Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
  if (!this.container[locale]) {
    this.container[locale] = {};
  }

  this.container[locale].dateFormat = format;
};

Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
  if (!this.container[locale] || !this.container[locale].dateFormat) {
    return null;
  }

  return this.container[locale].dateFormat;
};

Dictionary.prototype.getMessage = function getMessage (locale, key, data) {
  var message = null;
  if (!this.hasMessage(locale, key)) {
    message = this._getDefaultMessage(locale);
  } else {
    message = this.container[locale].messages[key];
  }

  return isCallable(message) ? message.apply(void 0, data) : message;
};

/**
 * Gets a specific message for field. falls back to the rule message.
 */
Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
  if (!this.hasLocale(locale)) {
    return this.getMessage(locale, key, data);
  }

  var dict = this.container[locale].custom && this.container[locale].custom[field];
  if (!dict || !dict[key]) {
    return this.getMessage(locale, key, data);
  }

  var message = dict[key];
  return isCallable(message) ? message.apply(void 0, data) : message;
};

Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
  if (this.hasMessage(locale, '_default')) {
    return this.container[locale].messages._default;
  }

  return this.container.en.messages._default;
};

Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  if (!this.hasAttribute(locale, key)) {
    return fallback;
  }

  return this.container[locale].attributes[key];
};

Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].messages &&
          this.container[locale].messages[key]
  );
};

Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].attributes &&
          this.container[locale].attributes[key]
  );
};

Dictionary.prototype.merge = function merge$1 (dictionary) {
  merge(this.container, dictionary);
};

Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }
    
  if (!this.container[locale].messages) {
    this.container[locale].messages = {};
  }

  this.container[locale].messages[key] = message;
};

Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].attributes[key] = attribute;
};

Object.defineProperties( Dictionary.prototype, prototypeAccessors );

var drivers = {
  default: new Dictionary({
    en: {
      messages: {},
      attributes: {},
      custom: {}
    }
  })
};

var currentDriver = 'default';

var DictionaryResolver = function DictionaryResolver () {};

DictionaryResolver._checkDriverName = function _checkDriverName (driver) {
  if (!driver) {
    throw createError('you must provide a name to the dictionary driver');
  }
};

DictionaryResolver.setDriver = function setDriver (driver, implementation) {
    if ( implementation === void 0 ) implementation = null;

  this._checkDriverName(driver);
  if (implementation) {
    drivers[driver] = implementation;
  }

  currentDriver = driver;
};

DictionaryResolver.getDriver = function getDriver () {
  return drivers[currentDriver];
};

// 

var ErrorBag = function ErrorBag (errorBag, id) {
  if ( errorBag === void 0 ) errorBag = null;
  if ( id === void 0 ) id = null;

  this.vmId = id || null;
  // make this bag a mirror of the provided one, sharing the same items reference.
  if (errorBag && errorBag instanceof ErrorBag) {
    this.items = errorBag.items;
  } else {
    this.items = [];
  }
};

ErrorBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Adds an error to the internal array.
 */
ErrorBag.prototype.add = function add (error) {
    var ref;

  (ref = this.items).push.apply(
    ref, this._normalizeError(error)
  );
};

/**
 * Normalizes passed errors to an error array.
 */
ErrorBag.prototype._normalizeError = function _normalizeError (error) {
    var this$1 = this;

  if (Array.isArray(error)) {
    return error.map(function (e) {
      e.scope = !isNullOrUndefined(e.scope) ? e.scope : null;
      e.vmId = !isNullOrUndefined(e.vmId) ? e.vmId : (this$1.vmId || null);

      return e;
    });
  }

  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
  error.vmId = !isNullOrUndefined(error.vmId) ? error.vmId : (this.vmId || null);

  return [error];
};

/**
 * Regenrates error messages if they have a generator function.
 */
ErrorBag.prototype.regenerate = function regenerate () {
  this.items.forEach(function (i) {
    i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
  });
};

/**
 * Updates a field error with the new field scope.
 */
ErrorBag.prototype.update = function update (id, error) {
  var item = find(this.items, function (i) { return i.id === id; });
  if (!item) {
    return;
  }

  var idx = this.items.indexOf(item);
  this.items.splice(idx, 1);
  item.scope = error.scope;
  this.items.push(item);
};

/**
 * Gets all error messages from the internal array.
 */
ErrorBag.prototype.all = function all (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return this.items.filter(filterFn).map(function (e) { return e.msg; });
};

/**
 * Checks if there are any errors in the internal array.
 */
ErrorBag.prototype.any = function any (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return !!this.items.filter(filterFn).length;
};

/**
 * Removes all items from the internal array.
 */
ErrorBag.prototype.clear = function clear (scope) {
    var this$1 = this;

  var matchesVM = isNullOrUndefined(this.vmId) ? function () { return true; } : function (i) { return i.vmId === this$1.vmId; };
  var matchesScope = function (i) { return i.scope === scope; };
  if (arguments.length === 0) {
    matchesScope = function () { return true; };
  } else if (isNullOrUndefined(scope)) {
    scope = null;
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (matchesVM(this.items[i]) && matchesScope(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Collects errors into groups or for a specific field.
 */
ErrorBag.prototype.collect = function collect (field, scope, map) {
    var this$1 = this;
    if ( map === void 0 ) map = true;

  var isSingleField = !isNullOrUndefined(field) && !field.includes('*');
  var groupErrors = function (items) {
    var errors = items.reduce(function (collection, error) {
      if (!isNullOrUndefined(this$1.vmId) && error.vmId !== this$1.vmId) {
        return collection;
      }

      if (!collection[error.field]) {
        collection[error.field] = [];
      }

      collection[error.field].push(map ? error.msg : error);

      return collection;
    }, {});

    // reduce the collection to be a single array.
    if (isSingleField) {
      return values(errors)[0] || [];
    }

    return errors;
  };

  if (isNullOrUndefined(field)) {
    return groupErrors(this.items);
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  var collected = this.items.reduce(function (prev, curr) {
    if (isPrimary(curr)) {
      prev.primary.push(curr);
    }

    if (isAlt(curr)) {
      prev.alt.push(curr);
    }

    return prev;
  }, { primary: [], alt: [] });

  collected = collected.primary.length ? collected.primary : collected.alt;

  return groupErrors(collected);
};

/**
 * Gets the internal array length.
 */
ErrorBag.prototype.count = function count () {
    var this$1 = this;

  if (this.vmId) {
    return this.items.filter(function (e) { return e.vmId === this$1.vmId; }).length;
  }

  return this.items.length;
};

/**
 * Finds and fetches the first error message for the specified field id.
 */
ErrorBag.prototype.firstById = function firstById (id) {
  var error = find(this.items, function (i) { return i.id === id; });

  return error ? error.msg : undefined;
};

/**
 * Gets the first error message for a specific field.
 */
ErrorBag.prototype.first = function first (field, scope) {
    if ( scope === void 0 ) scope = null;

  var selector = isNullOrUndefined(scope) ? field : (scope + "." + field);
  var match = this._match(selector);

  return match && match.msg;
};

/**
 * Returns the first error rule for the specified field
 */
ErrorBag.prototype.firstRule = function firstRule (field, scope) {
  var errors = this.collect(field, scope, false);

  return (errors.length && errors[0].rule) || undefined;
};

/**
 * Checks if the internal array has at least one error for the specified field.
 */
ErrorBag.prototype.has = function has (field, scope) {
    if ( scope === void 0 ) scope = null;

  return !!this.first(field, scope);
};

/**
 * Gets the first error message for a specific field and a rule.
 */
ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Gets the first error message for a specific field that not match the rule.
 */
ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
    if ( rule === void 0 ) rule = 'required';
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Removes errors by matching against the id or ids.
 */
ErrorBag.prototype.removeById = function removeById (id) {
  var condition = function (item) { return item.id === id; };
  if (Array.isArray(id)) {
    condition = function (item) { return id.indexOf(item.id) !== -1; };
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (condition(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Removes all error messages associated with a specific field.
 */
ErrorBag.prototype.remove = function remove (field, scope, vmId) {
  if (isNullOrUndefined(field)) {
    return;
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;
  var matches = function (item) { return isPrimary(item) || isAlt(item); };
  var shouldRemove = function (item) {
    if (isNullOrUndefined(vmId)) { return matches(item); }

    return matches(item) && item.vmId === vmId;
  };

  for (var i = 0; i < this.items.length; ++i) {
    if (shouldRemove(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

ErrorBag.prototype._makeCandidateFilters = function _makeCandidateFilters (selector) {
    var this$1 = this;

  var matchesRule = function () { return true; };
  var matchesScope = function () { return true; };
  var matchesName = function () { return true; };
  var matchesVM = function () { return true; };

  var ref = parseSelector(selector);
    var id = ref.id;
    var rule = ref.rule;
    var scope = ref.scope;
    var name = ref.name;

  if (rule) {
    matchesRule = function (item) { return item.rule === rule; };
  }

  // match by id, can be combined with rule selection.
  if (id) {
    return {
      isPrimary: function (item) { return matchesRule(item) && (function (item) { return id === item.id; }); },
      isAlt: function () { return false; }
    };
  }

  if (isNullOrUndefined(scope)) {
    // if no scope specified, make sure the found error has no scope.
    matchesScope = function (item) { return isNullOrUndefined(item.scope); };
  } else {
    matchesScope = function (item) { return item.scope === scope; };
  }

  if (!isNullOrUndefined(name) && name !== '*') {
    matchesName = function (item) { return item.field === name; };
  }

  if (!isNullOrUndefined(this.vmId)) {
    matchesVM = function (item) { return item.vmId === this$1.vmId; };
  }

  // matches the first candidate.
  var isPrimary = function (item) {
    return matchesVM(item) && matchesName(item) && matchesRule(item) && matchesScope(item);
  };

  // matches a second candidate, which is a field with a name containing the '.' character.
  var isAlt = function (item) {
    return matchesVM(item) && matchesRule(item) && item.field === (scope + "." + name);
  };

  return {
    isPrimary: isPrimary,
    isAlt: isAlt
  };
};

ErrorBag.prototype._match = function _match (selector) {
  if (isNullOrUndefined(selector)) {
    return undefined;
  }

  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  return this.items.reduce(function (prev, item, idx, arr) {
    var isLast = idx === arr.length - 1;
    if (prev.primary) {
      return isLast ? prev.primary : prev;
    }

    if (isPrimary(item)) {
      prev.primary = item;
    }

    if (isAlt(item)) {
      prev.alt = item;
    }

    // keep going.
    if (!isLast) {
      return prev;
    }

    return prev.primary || prev.alt;
  }, {});
};

var DEFAULT_CONFIG = {
  locale: 'en',
  delay: 0,
  errorBagName: 'errors',
  dictionary: null,
  fieldsBagName: 'fields',
  classes: false,
  classNames: null,
  events: 'input',
  inject: true,
  fastExit: true,
  aria: true,
  validity: false,
  mode: 'aggressive',
  useConstraintAttrs: true,
  i18n: null,
  i18nRootKey: 'validation'
};

var currentConfig = assign({}, DEFAULT_CONFIG);

var resolveConfig = function (ctx) {
  var selfConfig = getPath('$options.$_veeValidate', ctx, {});

  return assign({}, currentConfig, selfConfig);
};

var getConfig = function () { return currentConfig; };

var setConfig = function (newConf) {
  currentConfig = assign({}, currentConfig, newConf);
};

// VNode Utils

// Gets the model object on the vnode.
function findModel (vnode) {
  if (!vnode.data) {
    return null;
  }

  // Component Model
  if (vnode.data.model) {
    return vnode.data.model;
  }

  return !!(vnode.data.directives) && find(vnode.data.directives, function (d) { return d.name === 'model'; });
}

function extractChildren (vnode) {
  if (Array.isArray(vnode)) {
    return vnode;
  }

  if (Array.isArray(vnode.children)) {
    return vnode.children;
  }

  if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
    return vnode.componentOptions.children;
  }

  return [];
}

function extractVNodes (vnode) {
  if (findModel(vnode)) {
    return [vnode];
  }

  var children = extractChildren(vnode);

  return children.reduce(function (nodes, node) {
    var candidates = extractVNodes(node);
    if (candidates.length) {
      nodes.push.apply(nodes, candidates);
    }

    return nodes;
  }, []);
}

// Resolves v-model config if exists.
function findModelConfig (vnode) {
  if (!vnode.componentOptions) { return null; }

  return vnode.componentOptions.Ctor.options.model;
}
// Adds a listener to vnode listener object.
function mergeVNodeListeners (obj, eventName, handler) {
  // Has a single listener, convert to array.
  if (isCallable(obj[eventName])) {
    var prevHandler = obj[eventName];
    obj[eventName] = [prevHandler];
  }

  // no listeners, create the array.
  if (isNullOrUndefined(obj[eventName])) {
    obj[eventName] = [];
  }

  obj[eventName].push(handler);
}

// Adds a listener to a native HTML vnode.
function addNativeNodeListener (node, eventName, handler) {
  if (isNullOrUndefined(node.data.on)) {
    node.data.on = {};
  }

  mergeVNodeListeners(node.data.on, eventName, handler);
}

// Adds a listener to a Vue component vnode.
function addComponentNodeListener (node, eventName, handler) {
  /* istanbul ignore next */
  if (!node.componentOptions.listeners) {
    node.componentOptions.listeners = {};
  }

  mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
}
function addVNodeListener (vnode, eventName, handler) {
  if (vnode.componentOptions) {
    addComponentNodeListener(vnode, eventName, handler);
    return;
  }

  addNativeNodeListener(vnode, eventName, handler);
}
// Determines if `change` should be used over `input` for listeners.
function getInputEventName (vnode, model) {
  // Is a component.
  if (vnode.componentOptions) {
    var ref = findModelConfig(vnode) || { event: 'input' };
    var event = ref.event;

    return event;
  }

  // Lazy Models and select tag typically use change event
  if ((model && model.modifiers && model.modifiers.lazy) || vnode.tag === 'select') {
    return 'change';
  }

  // is a textual-type input.
  if (vnode.data.attrs && isTextInput({ type: vnode.data.attrs.type || 'text' })) {
    return 'input';
  }

  return 'change';
}

function normalizeSlots (slots, ctx) {
  return Object.keys(slots).reduce(function (arr, key) {
    slots[key].forEach(function (vnode) {
      if (!vnode.context) {
        slots[key].context = ctx;
        if (!vnode.data) {
          vnode.data = {};
        }
        vnode.data.slot = key;
      }
    });

    return arr.concat(slots[key]);
  }, []);
}
function createRenderless (h, children) {
  // Only render the first item of the node.
  if (Array.isArray(children) && children[0]) {
    return children[0];
  }

  // a single node.
  if (children) {
    return children;
  }

  // No slots, render nothing.
  return h();
}

/**
 * Generates the options required to construct a field.
 */
var Resolver = function Resolver () {};

Resolver.generate = function generate (el, binding, vnode) {
  var model = Resolver.resolveModel(binding, vnode);
  var options = resolveConfig(vnode.context);

  return {
    name: Resolver.resolveName(el, vnode),
    el: el,
    listen: !binding.modifiers.disable,
    bails: binding.modifiers.bails ? true : (binding.modifiers.continues === true ? false : undefined),
    scope: Resolver.resolveScope(el, binding, vnode),
    vm: vnode.context,
    expression: binding.value,
    component: vnode.componentInstance,
    classes: options.classes,
    classNames: options.classNames,
    getter: Resolver.resolveGetter(el, vnode, model),
    events: Resolver.resolveEvents(el, vnode) || options.events,
    model: model,
    delay: Resolver.resolveDelay(el, vnode, options),
    rules: Resolver.resolveRules(el, binding, vnode),
    immediate: !!binding.modifiers.initial || !!binding.modifiers.immediate,
    persist: !!binding.modifiers.persist,
    validity: options.validity && !vnode.componentInstance,
    aria: options.aria && !vnode.componentInstance,
    initialValue: Resolver.resolveInitialValue(vnode)
  };
};

Resolver.getCtorConfig = function getCtorConfig (vnode) {
  if (!vnode.componentInstance) { return null; }

  var config = getPath('componentInstance.$options.$_veeValidate', vnode);

  return config;
};

/**
 * Resolves the rules defined on an element.
 */
Resolver.resolveRules = function resolveRules (el, binding, vnode) {
  var rules = '';
  if (!binding.value && (!binding || !binding.expression)) {
    rules = getDataAttribute(el, 'rules');
  }

  if (binding.value && includes(['string', 'object'], typeof binding.value.rules)) {
    rules = binding.value.rules;
  } else if (binding.value) {
    rules = binding.value;
  }

  if (vnode.componentInstance) {
    return rules;
  }

  // If validity is disabled, ignore field rules.
  var normalized = normalizeRules(rules);
  if (!getConfig().useConstraintAttrs) {
    return normalized;
  }

  return assign({}, fillRulesFromElement(el, {}), normalized);
};

/**
 * @param {*} vnode
 */
Resolver.resolveInitialValue = function resolveInitialValue (vnode) {
  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });

  return model && model.value;
};

/**
 * Resolves the delay value.
 * @param {*} el
 * @param {*} vnode
 * @param {Object} options
 */
Resolver.resolveDelay = function resolveDelay (el, vnode, options) {
  var delay = getDataAttribute(el, 'delay');
  var globalDelay = (options && 'delay' in options) ? options.delay : 0;

  if (!delay && vnode.componentInstance && vnode.componentInstance.$attrs) {
    delay = vnode.componentInstance.$attrs['data-vv-delay'];
  }

  if (!isObject(globalDelay)) {
    return deepParseInt(delay || globalDelay);
  }

  if (!isNullOrUndefined(delay)) {
    globalDelay.input = delay;
  }

  return deepParseInt(globalDelay);
};

/**
 * Resolves the events to validate in response to.
 * @param {*} el
 * @param {*} vnode
 */
Resolver.resolveEvents = function resolveEvents (el, vnode) {
  // resolve it from the root element.
  var events = getDataAttribute(el, 'validate-on');

  // resolve from data-vv-validate-on if its a vue component.
  if (!events && vnode.componentInstance && vnode.componentInstance.$attrs) {
    events = vnode.componentInstance.$attrs['data-vv-validate-on'];
  }

  // resolve it from $_veeValidate options.
  if (!events && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    events = config && config.events;
  }

  if (!events && getConfig().events) {
    events = getConfig().events;
  }

  // resolve the model event if its configured for custom components.
  if (events && vnode.componentInstance && includes(events, 'input')) {
    var ref = vnode.componentInstance.$options.model || { event: 'input' };
      var event = ref.event;
    // if the prop was configured but not the model.
    if (!event) {
      return events;
    }

    events = events.replace('input', event);
  }

  return events;
};

/**
 * Resolves the scope for the field.
 * @param {*} el
 * @param {*} binding
 */
Resolver.resolveScope = function resolveScope (el, binding, vnode) {
    if ( vnode === void 0 ) vnode = {};

  var scope = null;
  if (vnode.componentInstance && isNullOrUndefined(scope)) {
    scope = vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-scope'];
  }

  return !isNullOrUndefined(scope) ? scope : getScope(el);
};

/**
 * Checks if the node directives contains a v-model or a specified arg.
 * Args take priority over models.
 *
 * @return {Object}
 */
Resolver.resolveModel = function resolveModel (binding, vnode) {
  if (binding.arg) {
    return { expression: binding.arg };
  }

  var model = findModel(vnode);
  if (!model) {
    return null;
  }

  // https://github.com/vuejs/vue/blob/dev/src/core/util/lang.js#L26
  var watchable = !/[^\w.$]/.test(model.expression) && hasPath(model.expression, vnode.context);
  var lazy = !!(model.modifiers && model.modifiers.lazy);

  if (!watchable) {
    return { expression: null, lazy: lazy };
  }

  return { expression: model.expression, lazy: lazy };
};

/**
 * Resolves the field name to trigger validations.
 * @return {String} The field name.
 */
Resolver.resolveName = function resolveName (el, vnode) {
  var name = getDataAttribute(el, 'name');

  if (!name && !vnode.componentInstance) {
    return el.name;
  }

  if (!name && vnode.componentInstance && vnode.componentInstance.$attrs) {
    name = vnode.componentInstance.$attrs['data-vv-name'] || vnode.componentInstance.$attrs['name'];
  }

  if (!name && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.name)) {
      var boundGetter = config.name.bind(vnode.componentInstance);

      return boundGetter();
    }

    return vnode.componentInstance.name;
  }

  return name;
};

/**
 * Returns a value getter input type.
 */
Resolver.resolveGetter = function resolveGetter (el, vnode, model) {
  if (model && model.expression) {
    return function () {
      return getPath(model.expression, vnode.context);
    };
  }

  if (vnode.componentInstance) {
    var path = getDataAttribute(el, 'value-path') || (vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-value-path']);
    if (path) {
      return function () {
        return getPath(path, vnode.componentInstance);
      };
    }

    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.value)) {
      var boundGetter = config.value.bind(vnode.componentInstance);

      return function () {
        return boundGetter();
      };
    }

    var ref = vnode.componentInstance.$options.model || { prop: 'value' };
      var prop = ref.prop;

    return function () {
      return vnode.componentInstance[prop];
    };
  }

  switch (el.type) {
  case 'checkbox': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));

    els = toArray(els).filter(function (el) { return el.checked; });
    if (!els.length) { return undefined; }

    return els.map(function (checkbox) { return checkbox.value; });
  };
  case 'radio': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
    var elm = find(els, function (el) { return el.checked; });

    return elm && elm.value;
  };
  case 'file': return function (context) {
    return toArray(el.files);
  };
  case 'select-multiple': return function () {
    return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; });
  };
  default: return function () {
    return el && el.value;
  };
  }
};

var RULES = {};

var RuleContainer = function RuleContainer () {};

var staticAccessors = { rules: { configurable: true } };

RuleContainer.add = function add (name, ref) {
    var validate = ref.validate;
    var options = ref.options;
    var paramNames = ref.paramNames;

  RULES[name] = {
    validate: validate,
    options: options,
    paramNames: paramNames
  };
};

staticAccessors.rules.get = function () {
  return RULES;
};

RuleContainer.has = function has (name) {
  return !!RULES[name];
};

RuleContainer.isImmediate = function isImmediate (name) {
  return !!(RULES[name] && RULES[name].options.immediate);
};

RuleContainer.isRequireRule = function isRequireRule (name) {
  return !!(RULES[name] && RULES[name].options.computesRequired);
};

RuleContainer.isTargetRule = function isTargetRule (name) {
  return !!(RULES[name] && RULES[name].options.hasTarget);
};

RuleContainer.remove = function remove (ruleName) {
  delete RULES[ruleName];
};

RuleContainer.getParamNames = function getParamNames (ruleName) {
  return RULES[ruleName] && RULES[ruleName].paramNames;
};

RuleContainer.getOptions = function getOptions (ruleName) {
  return RULES[ruleName] && RULES[ruleName].options;
};

RuleContainer.getValidatorMethod = function getValidatorMethod (ruleName) {
  return RULES[ruleName] ? RULES[ruleName].validate : null;
};

Object.defineProperties( RuleContainer, staticAccessors );

// 

var isEvent = function (evt) {
  return (typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event) || (evt && evt.srcElement);
};

var normalizeEvents = function (evts) {
  if (!evts) { return []; }

  return (typeof evts === 'string' ? evts.split('|') : evts);
};

var supportsPassive = true;

var detectPassiveSupport = function () {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get () {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    supportsPassive = false;
  }
  return supportsPassive;
};

var addEventListener = function (el, eventName, cb) {
  el.addEventListener(eventName, cb, supportsPassive ? { passive: true } : false);
};

// 

var DEFAULT_OPTIONS = {
  targetOf: null,
  immediate: false,
  persist: false,
  scope: null,
  listen: true,
  name: null,
  rules: {},
  vm: null,
  classes: false,
  validity: true,
  aria: true,
  events: 'input|blur',
  delay: 0,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
};

var Field = function Field (options) {
  if ( options === void 0 ) options = {};

  this.id = uniqId();
  this.el = options.el;
  this.updated = false;
  this.vmId = options.vmId;
  defineNonReactive(this, 'dependencies', []);
  defineNonReactive(this, 'watchers', []);
  defineNonReactive(this, 'events', []);
  this.delay = 0;
  this.rules = {};
  this.forceRequired = false;
  this._cacheId(options);
  this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
  options = assign({}, DEFAULT_OPTIONS, options);
  this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0; // cache initial delay
  this.validity = options.validity;
  this.aria = options.aria;
  this.flags = options.flags || createFlags();
  defineNonReactive(this, 'vm', options.vm);
  defineNonReactive(this, 'componentInstance', options.component);
  this.ctorConfig = this.componentInstance ? getPath('$options.$_veeValidate', this.componentInstance) : undefined;
  this.update(options);
  // set initial value.
  this.initialValue = this.value;
  this.updated = false;
};

var prototypeAccessors$1 = { validator: { configurable: true },isRequired: { configurable: true },isDisabled: { configurable: true },alias: { configurable: true },value: { configurable: true },bails: { configurable: true },rejectsFalse: { configurable: true } };

prototypeAccessors$1.validator.get = function () {
  if (!this.vm || !this.vm.$validator) {
    return { validate: function () { return Promise.resolve(true); } };
  }

  return this.vm.$validator;
};

prototypeAccessors$1.isRequired.get = function () {
  return !!this.rules.required || this.forceRequired;
};

prototypeAccessors$1.isDisabled.get = function () {
  return !!(this.el && this.el.disabled);
};

/**
 * Gets the display name (user-friendly name).
 */
prototypeAccessors$1.alias.get = function () {
  if (this._alias) {
    return this._alias;
  }

  var alias = null;
  if (this.ctorConfig && this.ctorConfig.alias) {
    alias = isCallable(this.ctorConfig.alias) ? this.ctorConfig.alias.call(this.componentInstance) : this.ctorConfig.alias;
  }

  if (!alias && this.el) {
    alias = getDataAttribute(this.el, 'as');
  }

  if (!alias && this.componentInstance) {
    return this.componentInstance.$attrs && this.componentInstance.$attrs['data-vv-as'];
  }

  return alias;
};

/**
 * Gets the input value.
 */

prototypeAccessors$1.value.get = function () {
  if (!isCallable(this.getter)) {
    return undefined;
  }

  return this.getter();
};

prototypeAccessors$1.bails.get = function () {
  return this._bails;
};

/**
 * If the field rejects false as a valid value for the required rule.
 */

prototypeAccessors$1.rejectsFalse.get = function () {
  if (this.componentInstance && this.ctorConfig) {
    return !!this.ctorConfig.rejectsFalse;
  }

  if (!this.el) {
    return false;
  }

  return this.el.type === 'checkbox';
};

/**
 * Determines if the instance matches the options provided.
 */
Field.prototype.matches = function matches (options) {
    var this$1 = this;

  if (!options) {
    return true;
  }

  if (options.id) {
    return this.id === options.id;
  }

  var matchesComponentId = isNullOrUndefined(options.vmId) ? function () { return true; } : function (id) { return id === this$1.vmId; };
  if (!matchesComponentId(options.vmId)) {
    return false;
  }

  if (options.name === undefined && options.scope === undefined) {
    return true;
  }

  if (options.scope === undefined) {
    return this.name === options.name;
  }

  if (options.name === undefined) {
    return this.scope === options.scope;
  }

  return options.name === this.name && options.scope === this.scope;
};

/**
 * Caches the field id.
 */
Field.prototype._cacheId = function _cacheId (options) {
  if (this.el && !options.targetOf) {
    this.el._veeValidateId = this.id;
  }
};

/**
 * Keeps a reference of the most current validation run.
 */
Field.prototype.waitFor = function waitFor (pendingPromise) {
  this._waitingFor = pendingPromise;
};

Field.prototype.isWaitingFor = function isWaitingFor (promise) {
  return this._waitingFor === promise;
};

/**
 * Updates the field with changed data.
 */
Field.prototype.update = function update (options) {
    var this$1 = this;

  this.targetOf = options.targetOf || null;
  this.immediate = options.immediate || this.immediate || false;
  this.persist = options.persist || this.persist || false;

  // update errors scope if the field scope was changed.
  if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
    this.validator.update(this.id, { scope: options.scope });
  }
  this.scope = !isNullOrUndefined(options.scope) ? options.scope
    : !isNullOrUndefined(this.scope) ? this.scope : null;
  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
  this._bails = options.bails !== undefined ? options.bails : this._bails;
  this.model = options.model || this.model;
  this.listen = options.listen !== undefined ? options.listen : this.listen;
  this.classes = (options.classes || this.classes || false) && !this.componentInstance;
  this.classNames = isObject(options.classNames) ? merge(this.classNames, options.classNames) : this.classNames;
  this.getter = isCallable(options.getter) ? options.getter : this.getter;
  this._alias = options.alias || this._alias;
  this.events = (options.events) ? normalizeEvents(options.events) : this.events;
  this.delay = makeDelayObject(this.events, options.delay || this.delay, this._delay);
  this.updateDependencies();
  this.addActionListeners();

  if ("production-oci" !== 'production' && !this.name && !this.targetOf) {
    warn('A field is missing a "name" or "data-vv-name" attribute');
  }

  // update required flag flags
  if (options.rules !== undefined) {
    this.flags.required = this.isRequired;
  }

  if (Object.keys(options.rules || {}).length === 0 && this.updated) {
    var resetFlag = this.flags.validated;
    this.validator.validate(("#" + (this.id))).then(function () {
      this$1.flags.validated = resetFlag;
    });
  }

  // validate if it was validated before and field was updated and there was a rules mutation.
  if (this.flags.validated && options.rules !== undefined && this.updated) {
    this.validator.validate(("#" + (this.id)));
  }

  this.updated = true;
  this.addValueListeners();

  // no need to continue.
  if (!this.el) {
    return;
  }
  this.updateClasses();
  this.updateAriaAttrs();
};

/**
 * Resets field flags and errors.
 */
Field.prototype.reset = function reset () {
    var this$1 = this;

  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
    delete this._cancellationToken;
  }

  var defaults = createFlags();
  Object.keys(this.flags).filter(function (flag) { return flag !== 'required'; }).forEach(function (flag) {
    this$1.flags[flag] = defaults[flag];
  });

  // update initial value
  this.initialValue = this.value;
  this.flags.changed = false;

  this.addValueListeners();
  this.addActionListeners();
  this.updateClasses(true);
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
 */
Field.prototype.setFlags = function setFlags (flags) {
    var this$1 = this;

  var negated = {
    pristine: 'dirty',
    dirty: 'pristine',
    valid: 'invalid',
    invalid: 'valid',
    touched: 'untouched',
    untouched: 'touched'
  };

  Object.keys(flags).forEach(function (flag) {
    this$1.flags[flag] = flags[flag];
    // if it has a negation and was not specified, set it as well.
    if (negated[flag] && flags[negated[flag]] === undefined) {
      this$1.flags[negated[flag]] = !flags[flag];
    }
  });

  if (
    flags.untouched !== undefined ||
    flags.touched !== undefined ||
    flags.dirty !== undefined ||
    flags.pristine !== undefined
  ) {
    this.addActionListeners();
  }
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Determines if the field requires references to target fields.
*/
Field.prototype.updateDependencies = function updateDependencies () {
    var this$1 = this;

  // reset dependencies.
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];

  // we get the selectors for each field.
  var fields = Object.keys(this.rules).reduce(function (prev, r) {
    if (RuleContainer.isTargetRule(r)) {
      prev.push({ selector: this$1.rules[r][0], name: r });
    }

    return prev;
  }, []);

  if (!fields.length || !this.vm || !this.vm.$el) { return; }

  // must be contained within the same component, so we use the vm root element constrain our dom search.
  fields.forEach(function (ref$1) {
      var selector = ref$1.selector;
      var name = ref$1.name;

    var ref = this$1.vm.$refs[selector];
    var el = Array.isArray(ref) ? ref[0] : ref;
    if (!el) {
      return;
    }

    var options = {
      vm: this$1.vm,
      classes: this$1.classes,
      classNames: this$1.classNames,
      delay: this$1.delay,
      scope: this$1.scope,
      events: this$1.events.join('|'),
      immediate: this$1.immediate,
      targetOf: this$1.id
    };

    // probably a component.
    if (isCallable(el.$watch)) {
      options.component = el;
      options.el = el.$el;
      options.getter = Resolver.resolveGetter(el.$el, el.$vnode);
    } else {
      options.el = el;
      options.getter = Resolver.resolveGetter(el, {});
    }

    this$1.dependencies.push({ name: name, field: new Field(options) });
  });
};

/**
 * Removes listeners.
 */
Field.prototype.unwatch = function unwatch (tag) {
    if ( tag === void 0 ) tag = null;

  if (!tag) {
    this.watchers.forEach(function (w) { return w.unwatch(); });
    this.watchers = [];
    return;
  }

  this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
  this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
};

/**
 * Updates the element classes depending on each field flag status.
 */
Field.prototype.updateClasses = function updateClasses (isReset) {
    var this$1 = this;
    if ( isReset === void 0 ) isReset = false;

  if (!this.classes || this.isDisabled) { return; }
  var applyClasses = function (el) {
    toggleClass(el, this$1.classNames.dirty, this$1.flags.dirty);
    toggleClass(el, this$1.classNames.pristine, this$1.flags.pristine);
    toggleClass(el, this$1.classNames.touched, this$1.flags.touched);
    toggleClass(el, this$1.classNames.untouched, this$1.flags.untouched);

    // remove valid/invalid classes on reset.
    if (isReset) {
      toggleClass(el, this$1.classNames.valid, false);
      toggleClass(el, this$1.classNames.invalid, false);
    }

    // make sure we don't set any classes if the state is undetermined.
    if (!isNullOrUndefined(this$1.flags.valid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.valid, this$1.flags.valid);
    }

    if (!isNullOrUndefined(this$1.flags.invalid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.invalid, this$1.flags.invalid);
    }
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyClasses(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyClasses);
};

/**
 * Adds the listeners required for automatic classes and some flags.
 */
Field.prototype.addActionListeners = function addActionListeners () {
    var this$1 = this;

  // remove previous listeners.
  this.unwatch(/class/);

  if (!this.el) { return; }

  var onBlur = function () {
    this$1.flags.touched = true;
    this$1.flags.untouched = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.touched, true);
      toggleClass(this$1.el, this$1.classNames.untouched, false);
    }

    // only needed once.
    this$1.unwatch(/^class_blur$/);
  };

  var inputEvent = isTextInput(this.el) ? 'input' : 'change';
  var onInput = function () {
    this$1.flags.dirty = true;
    this$1.flags.pristine = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.pristine, false);
      toggleClass(this$1.el, this$1.classNames.dirty, true);
    }

    // only needed once.
    this$1.unwatch(/^class_input$/);
  };

  if (this.componentInstance && isCallable(this.componentInstance.$once)) {
    this.componentInstance.$once('input', onInput);
    this.componentInstance.$once('blur', onBlur);
    this.watchers.push({
      tag: 'class_input',
      unwatch: function () {
        this$1.componentInstance.$off('input', onInput);
      }
    });
    this.watchers.push({
      tag: 'class_blur',
      unwatch: function () {
        this$1.componentInstance.$off('blur', onBlur);
      }
    });
    return;
  }

  if (!this.el) { return; }

  addEventListener(this.el, inputEvent, onInput);
  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
  var blurEvent = isCheckboxOrRadioInput(this.el) ? 'change' : 'blur';
  addEventListener(this.el, blurEvent, onBlur);
  this.watchers.push({
    tag: 'class_input',
    unwatch: function () {
      this$1.el.removeEventListener(inputEvent, onInput);
    }
  });

  this.watchers.push({
    tag: 'class_blur',
    unwatch: function () {
      this$1.el.removeEventListener(blurEvent, onBlur);
    }
  });
};

Field.prototype.checkValueChanged = function checkValueChanged () {
  // handle some people initialize the value to null, since text inputs have empty string value.
  if (this.initialValue === null && this.value === '' && isTextInput(this.el)) {
    return false;
  }

  return this.value !== this.initialValue;
};

/**
 * Determines the suitable primary event to listen for.
 */
Field.prototype._determineInputEvent = function _determineInputEvent () {
  // if its a custom component, use the customized model event or the input event.
  if (this.componentInstance) {
    return (this.componentInstance.$options.model && this.componentInstance.$options.model.event) || 'input';
  }

  if (this.model && this.model.lazy) {
    return 'change';
  }

  if (isTextInput(this.el)) {
    return 'input';
  }

  return 'change';
};

/**
 * Determines the list of events to listen to.
 */
Field.prototype._determineEventList = function _determineEventList (defaultInputEvent) {
    var this$1 = this;

  // if no event is configured, or it is a component or a text input then respect the user choice.
  if (!this.events.length || this.componentInstance || isTextInput(this.el)) {
    return [].concat( this.events ).map(function (evt) {
      if (evt === 'input' && this$1.model && this$1.model.lazy) {
        return 'change';
      }

      return evt;
    });
  }

  // force suitable event for non-text type fields.
  return this.events.map(function (e) {
    if (e === 'input') {
      return defaultInputEvent;
    }

    return e;
  });
};

/**
 * Adds the listeners required for validation.
 */
Field.prototype.addValueListeners = function addValueListeners () {
    var this$1 = this;

  this.unwatch(/^input_.+/);
  if (!this.listen || !this.el) { return; }

  var token = { cancelled: false };
  var fn = this.targetOf ? function () {
    var target = this$1.validator._resolveField(("#" + (this$1.targetOf)));
    if (target && target.flags.validated) {
      this$1.validator.validate(("#" + (this$1.targetOf)));
    }
  } : function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
    if (args.length === 0 || isEvent(args[0])) {
      args[0] = this$1.value;
    }

    this$1.flags.pending = true;
    this$1._cancellationToken = token;
    this$1.validator.validate(("#" + (this$1.id)), args[0]);
  };

  var inputEvent = this._determineInputEvent();
  var events = this._determineEventList(inputEvent);

  // if on input validation is requested.
  if (includes(events, inputEvent)) {
    var ctx = null;
    var expression = null;
    var watchCtxVm = false;
    // if its watchable from the context vm.
    if (this.model && this.model.expression) {
      ctx = this.vm;
      expression = this.model.expression;
      watchCtxVm = true;
    }

    // watch it from the custom component vm instead.
    if (!expression && this.componentInstance && this.componentInstance.$options.model) {
      ctx = this.componentInstance;
      expression = this.componentInstance.$options.model.prop || 'value';
    }

    if (ctx && expression) {
      var debouncedFn = debounce(fn, this.delay[inputEvent], token);
      var unwatch = ctx.$watch(expression, debouncedFn);
      this.watchers.push({
        tag: 'input_model',
        unwatch: function () {
          this$1.vm.$nextTick(function () {
            unwatch();
          });
        }
      });

      // filter out input event when we are watching from the context vm.
      if (watchCtxVm) {
        events = events.filter(function (e) { return e !== inputEvent; });
      }
    }
  }

  // Add events.
  events.forEach(function (e) {
    var debouncedFn = debounce(fn, this$1.delay[e], token);

    this$1._addComponentEventListener(e, debouncedFn);
    this$1._addHTMLEventListener(e, debouncedFn);
  });
};

Field.prototype._addComponentEventListener = function _addComponentEventListener (evt, validate) {
    var this$1 = this;

  if (!this.componentInstance) { return; }

  this.componentInstance.$on(evt, validate);
  this.watchers.push({
    tag: 'input_vue',
    unwatch: function () {
      this$1.componentInstance.$off(evt, validate);
    }
  });
};

Field.prototype._addHTMLEventListener = function _addHTMLEventListener (evt, validate) {
    var this$1 = this;

  if (!this.el || this.componentInstance) { return; }

  // listen for the current element.
  var addListener = function (el) {
    addEventListener(el, evt, validate);
    this$1.watchers.push({
      tag: 'input_native',
      unwatch: function () {
        el.removeEventListener(evt, validate);
      }
    });
  };

  addListener(this.el);
  if (!isCheckboxOrRadioInput(this.el)) {
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(function (el) {
    // skip if it is added by v-validate and is not the current element.
    if (el._veeValidateId && el !== this$1.el) {
      return;
    }

    addListener(el);
  });
};

/**
 * Updates aria attributes on the element.
 */
Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
    var this$1 = this;

  if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) { return; }

  var applyAriaAttrs = function (el) {
    el.setAttribute('aria-required', this$1.isRequired ? 'true' : 'false');
    el.setAttribute('aria-invalid', this$1.flags.invalid ? 'true' : 'false');
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyAriaAttrs(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyAriaAttrs);
};

/**
 * Updates the custom validity for the field.
 */
Field.prototype.updateCustomValidity = function updateCustomValidity () {
  if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity) || !this.validator.errors) { return; }

  this.el.setCustomValidity(this.flags.valid ? '' : (this.validator.errors.firstById(this.id) || ''));
};

/**
 * Removes all listeners.
 */
Field.prototype.destroy = function destroy () {
  // ignore the result of any ongoing validation.
  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
  }

  this.unwatch();
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];
};

Object.defineProperties( Field.prototype, prototypeAccessors$1 );

// 

var FieldBag = function FieldBag (items) {
  if ( items === void 0 ) items = [];

  this.items = items || [];
  this.itemsById = this.items.reduce(function (itemsById, item) {
    itemsById[item.id] = item;
    return itemsById;
  }, {});
};

var prototypeAccessors$2 = { length: { configurable: true } };

FieldBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Gets the current items length.
 */

prototypeAccessors$2.length.get = function () {
  return this.items.length;
};

/**
 * Finds the first field that matches the provided matcher object.
 */
FieldBag.prototype.find = function find$1 (matcher) {
  return find(this.items, function (item) { return item.matches(matcher); });
};

/**
 * Finds the field with the given id, using a plain object as a map to link
 * ids to items faster than by looping over the array and matching.
 */
FieldBag.prototype.findById = function findById (id) {
  return this.itemsById[id] || null;
};

/**
 * Filters the items down to the matched fields.
 */
FieldBag.prototype.filter = function filter (matcher) {
  // multiple matchers to be tried.
  if (Array.isArray(matcher)) {
    return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
  }

  return this.items.filter(function (item) { return item.matches(matcher); });
};

/**
 * Maps the field items using the mapping function.
 */
FieldBag.prototype.map = function map (mapper) {
  return this.items.map(mapper);
};

/**
 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
 */
FieldBag.prototype.remove = function remove (matcher) {
  var item = null;
  if (matcher instanceof Field) {
    item = matcher;
  } else {
    item = this.find(matcher);
  }

  if (!item) { return null; }

  var index = this.items.indexOf(item);
  this.items.splice(index, 1);
  delete this.itemsById[item.id];

  return item;
};

/**
 * Adds a field item to the list.
 */
FieldBag.prototype.push = function push (item) {
  if (! (item instanceof Field)) {
    throw createError('FieldBag only accepts instances of Field that has an id defined.');
  }

  if (!item.id) {
    throw createError('Field id must be defined.');
  }

  if (this.findById(item.id)) {
    throw createError(("Field with id " + (item.id) + " is already added."));
  }

  this.items.push(item);
  this.itemsById[item.id] = item;
};

Object.defineProperties( FieldBag.prototype, prototypeAccessors$2 );

var ScopedValidator = function ScopedValidator (base, vm) {
  this.id = vm._uid;
  this._base = base;
  this._paused = false;

  // create a mirror bag with limited component scope.
  this.errors = new ErrorBag(base.errors, this.id);
};

var prototypeAccessors$3 = { flags: { configurable: true },rules: { configurable: true },fields: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

prototypeAccessors$3.flags.get = function () {
    var this$1 = this;

  return this._base.fields.items.filter(function (f) { return f.vmId === this$1.id; }).reduce(function (acc, field) {
    if (field.scope) {
      if (!acc[("$" + (field.scope))]) {
        acc[("$" + (field.scope))] = {};
      }

      acc[("$" + (field.scope))][field.name] = field.flags;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

prototypeAccessors$3.rules.get = function () {
  return this._base.rules;
};

prototypeAccessors$3.fields.get = function () {
  return new FieldBag(this._base.fields.filter({ vmId: this.id }));
};

prototypeAccessors$3.dictionary.get = function () {
  return this._base.dictionary;
};

prototypeAccessors$3.locale.get = function () {
  return this._base.locale;
};

prototypeAccessors$3.locale.set = function (val) {
  this._base.locale = val;
};

ScopedValidator.prototype.localize = function localize () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).localize.apply(ref, args);
};

ScopedValidator.prototype.update = function update () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).update.apply(ref, args);
};

ScopedValidator.prototype.attach = function attach (opts) {
  var attachOpts = assign({}, opts, { vmId: this.id });

  return this._base.attach(attachOpts);
};

ScopedValidator.prototype.pause = function pause () {
  this._paused = true;
};

ScopedValidator.prototype.resume = function resume () {
  this._paused = false;
};

ScopedValidator.prototype.remove = function remove (ruleName) {
  return this._base.remove(ruleName);
};

ScopedValidator.prototype.detach = function detach (name, scope) {
  return this._base.detach(name, scope, this.id);
};

ScopedValidator.prototype.extend = function extend () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).extend.apply(ref, args);
};

ScopedValidator.prototype.validate = function validate (descriptor, value, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validate(descriptor, value, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.verify = function verify () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).verify.apply(ref, args);
};

ScopedValidator.prototype.validateAll = function validateAll (values, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateAll(values, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.validateScopes = function validateScopes (opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateScopes(assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.destroy = function destroy () {
  delete this.id;
  delete this._base;
};

ScopedValidator.prototype.reset = function reset (matcher) {
  return this._base.reset(Object.assign({}, matcher || {}, { vmId: this.id }));
};

ScopedValidator.prototype.flag = function flag () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).flag.apply(ref, args.concat( [this.id] ));
};

ScopedValidator.prototype._resolveField = function _resolveField () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base)._resolveField.apply(ref, args);
};

Object.defineProperties( ScopedValidator.prototype, prototypeAccessors$3 );

var VALIDATOR = null;

var getValidator = function () {
  return VALIDATOR;
};

var setValidator = function (value) {
  VALIDATOR = value;

  return value;
};

// 

/**
 * Checks if a parent validator instance was requested.
 */
var requestsValidator = function (injections) {
  if (isObject(injections) && injections.$validator) {
    return true;
  }

  return false;
};

var mixin = {
  provide: function provide () {
    if (this.$validator && !isBuiltInComponent(this.$vnode)) {
      return {
        $validator: this.$validator
      };
    }

    return {};
  },
  beforeCreate: function beforeCreate () {
    // if built in do nothing.
    if (isBuiltInComponent(this.$vnode) || this.$options.$__veeInject === false) {
      return;
    }

    // if its a root instance set the config if it exists.
    if (!this.$parent) {
      setConfig(this.$options.$_veeValidate || {});
    }

    var options = resolveConfig(this);

    // if its a root instance, inject anyways, or if it requested a new instance.
    if (!this.$parent || (this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator))) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    var requested = requestsValidator(this.$options.inject);

    // if automatic injection is enabled and no instance was requested.
    if (! this.$validator && options.inject && !requested) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    // don't inject errors or fieldBag as no validator was resolved.
    if (!requested && !this.$validator) {
      return;
    }

    // There is a validator but it isn't injected, mark as reactive.
    if (!requested && this.$validator) {
      var Vue = this.$options._base; // the vue constructor.
      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
    }

    if (!this.$options.computed) {
      this.$options.computed = {};
    }

    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter () {
      return this.$validator.errors;
    };
    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter () {
      return this.$validator.fields.items.reduce(function (acc, field) {
        if (field.scope) {
          if (!acc[("$" + (field.scope))]) {
            acc[("$" + (field.scope))] = {};
          }

          acc[("$" + (field.scope))][field.name] = field.flags;

          return acc;
        }

        acc[field.name] = field.flags;

        return acc;
      }, {});
    };
  },
  beforeDestroy: function beforeDestroy () {
    if (this.$validator && this._uid === this.$validator.id) {
      this.$validator.errors.clear(); // remove errors generated by this component.
    }
  }
};

// 

/**
 * Finds the requested field by id from the context object.
 */
function findField (el, context) {
  if (!context || !context.$validator) {
    return null;
  }

  return context.$validator.fields.findById(el._veeValidateId);
}
var directive = {
  bind: function bind (el, binding, vnode) {
    var validator = vnode.context.$validator;
    if (!validator) {
      if (true) {
        warn("No validator instance is present on vm, did you forget to inject '$validator'?");
      }

      return;
    }

    var fieldOptions = Resolver.generate(el, binding, vnode);
    validator.attach(fieldOptions);
  },
  inserted: function inserted (el, binding, vnode) {
    var field = findField(el, vnode.context);
    var scope = Resolver.resolveScope(el, binding, vnode);

    // skip if scope hasn't changed.
    if (!field || scope === field.scope) { return; }

    // only update scope.
    field.update({ scope: scope });

    // allows the field to re-evaluated once more in the update hook.
    field.updated = false;
  },
  update: function update (el, binding, vnode) {
    var field = findField(el, vnode.context);

    // make sure we don't do unneccasary work if no important change was done.
    if (!field || (field.updated && isEqual(binding.value, binding.oldValue))) { return; }
    var scope = Resolver.resolveScope(el, binding, vnode);
    var rules = Resolver.resolveRules(el, binding, vnode);

    field.update({
      scope: scope,
      rules: rules
    });
  },
  unbind: function unbind (el, binding, ref) {
    var context = ref.context;

    var field = findField(el, context);
    if (!field) { return; }

    context.$validator.detach(field);
  }
};

// 

var Validator = function Validator (validations, options, pluginContainer) {
  if ( options === void 0 ) options = { fastExit: true };
  if ( pluginContainer === void 0 ) pluginContainer = null;

  this.errors = new ErrorBag();
  this.fields = new FieldBag();
  this._createFields(validations);
  this.paused = false;
  this.fastExit = !isNullOrUndefined(options && options.fastExit) ? options.fastExit : true;
  this.$vee = pluginContainer || {
    _vm: {
      $nextTick: function (cb) { return isCallable(cb) ? cb() : Promise.resolve(); },
      $emit: function () {},
      $off: function () {}
    }
  };
};

var prototypeAccessors$4 = { rules: { configurable: true },dictionary: { configurable: true },flags: { configurable: true },locale: { configurable: true } };
var staticAccessors$1 = { rules: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

/**
 * @deprecated
 */
staticAccessors$1.rules.get = function () {
  if (true) {
    warn('this accessor will be deprecated, use `import { rules } from "vee-validate"` instead.');
  }

  return RuleContainer.rules;
};

/**
 * @deprecated
 */
prototypeAccessors$4.rules.get = function () {
  if (true) {
    warn('this accessor will be deprecated, use `import { rules } from "vee-validate"` instead.');
  }

  return RuleContainer.rules;
};

prototypeAccessors$4.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$1.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$4.flags.get = function () {
  return this.fields.items.reduce(function (acc, field) {
      var obj;

    if (field.scope) {
      acc[("$" + (field.scope))] = ( obj = {}, obj[field.name] = field.flags, obj );

      return acc;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

/**
 * Getter for the current locale.
 */
prototypeAccessors$4.locale.get = function () {
  return Validator.locale;
};

/**
 * Setter for the validator locale.
 */
prototypeAccessors$4.locale.set = function (value) {
  Validator.locale = value;
};

staticAccessors$1.locale.get = function () {
  return DictionaryResolver.getDriver().locale;
};

/**
 * Setter for the validator locale.
 */
staticAccessors$1.locale.set = function (value) {
  var hasChanged = value !== DictionaryResolver.getDriver().locale;
  DictionaryResolver.getDriver().locale = value;
  if (hasChanged && Validator.$vee && Validator.$vee._vm) {
    Validator.$vee._vm.$emit('localeChanged');
  }
};

/**
 * Static constructor.
 * @deprecated
 */
Validator.create = function create (validations, options) {
  if (true) {
    warn('Please use `new` to create new validator instances.');
  }

  return new Validator(validations, options);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator._guardExtend(name, validator);
  // rules imported from the minimal bundle
  // will have the options embedded in them
  var mergedOpts = validator.options || {};
  Validator._merge(name, {
    validator: validator,
    paramNames: (options && options.paramNames) || validator.paramNames,
    options: assign({ hasTarget: false, immediate: true }, mergedOpts, options || {})
  });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.remove = function remove (name) {
  if (true) {
    warn('this method will be deprecated, you can still override your rules with `extend`');
  }

  RuleContainer.remove(name);
};

/**
 * Adds and sets the current locale for the validator.
*/
Validator.prototype.localize = function localize (lang, dictionary) {
  Validator.localize(lang, dictionary);
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.localize = function localize (lang, dictionary) {
    var obj;

  if (isObject(lang)) {
    DictionaryResolver.getDriver().merge(lang);
    return;
  }

  // merge the dictionary.
  if (dictionary) {
    var locale = lang || dictionary.name;
    dictionary = assign({}, dictionary);
    DictionaryResolver.getDriver().merge(( obj = {}, obj[locale] = dictionary, obj ));
  }

  if (lang) {
    // set the locale.
    Validator.locale = lang;
  }
};

/**
 * Registers a field to be validated.
 */
Validator.prototype.attach = function attach (fieldOpts) {
    var this$1 = this;

  // We search for a field with the same name & scope, having persist enabled
  var oldFieldMatcher = { name: fieldOpts.name, scope: fieldOpts.scope, persist: true };
  var oldField = fieldOpts.persist ? this.fields.find(oldFieldMatcher) : null;

  if (oldField) {
    // We keep the flags of the old field, then we remove its instance
    fieldOpts.flags = oldField.flags;
    oldField.destroy();
    this.fields.remove(oldField);
  }

  // fixes initial value detection with v-model and select elements.
  var value = fieldOpts.initialValue;
  var field = new Field(fieldOpts);
  this.fields.push(field);

  // validate the field initially
  if (field.immediate) {
    this.$vee._vm.$nextTick(function () { return this$1.validate(("#" + (field.id)), value || field.value, { vmId: fieldOpts.vmId }); });
  } else {
    this._validate(field, value || field.value, { initial: true }).then(function (result) {
      field.flags.valid = result.valid;
      field.flags.invalid = !result.valid;
    });
  }

  return field;
};

/**
 * Sets the flags on a field.
 */
Validator.prototype.flag = function flag (name, flags, uid) {
    if ( uid === void 0 ) uid = null;

  var field = this._resolveField(name, undefined, uid);
  if (!field || !flags) {
    return;
  }

  field.setFlags(flags);
};

/**
 * Removes a field from the validator.
 */
Validator.prototype.detach = function detach (name, scope, uid) {
  var field = isCallable(name.destroy) ? name : this._resolveField(name, scope, uid);
  if (!field) { return; }

  // We destroy/remove the field & error instances if it's not a `persist` one
  if (!field.persist) {
    field.destroy();
    this.errors.remove(field.name, field.scope, field.vmId);
    this.fields.remove(field);
  }
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.prototype.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator.extend(name, validator, options);
};

Validator.prototype.reset = function reset (matcher) {
    var this$1 = this;

  // two ticks
  return this.$vee._vm.$nextTick().then(function () {
    return this$1.$vee._vm.$nextTick();
  }).then(function () {
    this$1.fields.filter(matcher).forEach(function (field) {
      field.waitFor(null);
      field.reset(); // reset field flags.
      this$1.errors.remove(field.name, field.scope, matcher && matcher.vmId);
    });
  });
};

/**
 * Updates a field, updating both errors and flags.
 */
Validator.prototype.update = function update (id, ref) {
    var scope = ref.scope;

  var field = this._resolveField(("#" + id));
  if (!field) { return; }

  // remove old scope.
  this.errors.update(id, { scope: scope });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.prototype.remove = function remove (name) {
  Validator.remove(name);
};

/**
 * Validates a value against a registered field validations.
 */
Validator.prototype.validate = function validate (fieldDescriptor, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  // overload to validate all.
  if (isNullOrUndefined(fieldDescriptor)) {
    return this.validateScopes({ silent: silent, vmId: vmId });
  }

  // overload to validate scope-less fields.
  if (fieldDescriptor === '*') {
    return this.validateAll(undefined, { silent: silent, vmId: vmId });
  }

  // if scope validation was requested.
  if (/^(.+)\.\*$/.test(fieldDescriptor)) {
    var matched = fieldDescriptor.match(/^(.+)\.\*$/)[1];
    return this.validateAll(matched);
  }

  var field = this._resolveField(fieldDescriptor);
  if (!field) {
    return this._handleFieldNotFound(fieldDescriptor);
  }

  if (!silent) { field.flags.pending = true; }
  if (value === undefined) {
    value = field.value;
  }

  var validationPromise = this._validate(field, value);
  field.waitFor(validationPromise);

  return validationPromise.then(function (result) {
    if (!silent && field.isWaitingFor(validationPromise)) {
      // allow next validation to mutate the state.
      field.waitFor(null);
      this$1._handleValidationResults([result], vmId);
    }

    return result.valid;
  });
};

/**
 * Pauses the validator.
 */
Validator.prototype.pause = function pause () {
  this.paused = true;

  return this;
};

/**
 * Resumes the validator.
 */
Validator.prototype.resume = function resume () {
  this.paused = false;

  return this;
};

/**
 * Validates each value against the corresponding field validations.
 */
Validator.prototype.validateAll = function validateAll (values, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  var matcher = null;
  var providedValues = false;

  if (typeof values === 'string') {
    matcher = { scope: values, vmId: vmId };
  } else if (isObject(values)) {
    matcher = Object.keys(values).map(function (key) {
      return { name: key, vmId: vmId, scope: null };
    });
    providedValues = true;
  } else if (Array.isArray(values)) {
    matcher = values.map(function (key) {
      return typeof key === 'object' ? Object.assign({ vmId: vmId }, key) : { name: key, vmId: vmId };
    });
  } else {
    matcher = { scope: null, vmId: vmId };
  }

  return Promise.all(
    this.fields.filter(matcher).map(function (field) { return this$1._validate(field, providedValues ? values[field.name] : field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates all scopes.
 */
Validator.prototype.validateScopes = function validateScopes (ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  return Promise.all(
    this.fields.filter({ vmId: vmId }).map(function (field) { return this$1._validate(field, field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates a value against the rules.
 */
Validator.prototype.verify = function verify (value, rules, options) {
    if ( options === void 0 ) options = {};

  var field = {
    name: (options && options.name) || '{field}',
    rules: normalizeRules(rules),
    bails: getPath('bails', options, true),
    forceRequired: false,
    get isRequired () {
      return !!this.rules.required || this.forceRequired;
    }
  };

  var targetRules = Object.keys(field.rules).filter(RuleContainer.isTargetRule);
  if (targetRules.length && options && isObject(options.values)) {
    field.dependencies = targetRules.map(function (rule) {
      var ref = field.rules[rule];
        var targetKey = ref[0];

      return {
        name: rule,
        field: { value: options.values[targetKey] }
      };
    });
  }

  return this._validate(field, value).then(function (result) {
    var errors = [];
    var ruleMap = {};
    result.errors.forEach(function (e) {
      errors.push(e.msg);
      ruleMap[e.rule] = e.msg;
    });

    return {
      valid: result.valid,
      errors: errors,
      failedRules: ruleMap
    };
  });
};

/**
 * Perform cleanup.
 */
Validator.prototype.destroy = function destroy () {
  this.$vee._vm.$off('localeChanged');
};

/**
 * Creates the fields to be validated.
 */
Validator.prototype._createFields = function _createFields (validations) {
    var this$1 = this;

  if (!validations) { return; }

  Object.keys(validations).forEach(function (field) {
    var options = assign({}, { name: field, rules: validations[field] });
    this$1.attach(options);
  });
};

/**
 * Date rules need the existence of a format, so date_format must be supplied.
 */
Validator.prototype._getDateFormat = function _getDateFormat (validations) {
  var format = null;
  if (validations.date_format && Array.isArray(validations.date_format)) {
    format = validations.date_format[0];
  }

  return format || DictionaryResolver.getDriver().getDateFormat(this.locale);
};

/**
 * Formats an error message for field and a rule.
 */
Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
    if ( data === void 0 ) data = {};
    if ( targetName === void 0 ) targetName = null;

  var name = this._getFieldDisplayName(field);
  var params = this._getLocalizedParams(rule, targetName);

  return DictionaryResolver.getDriver().getFieldMessage(this.locale, field.name, rule.name, [name, params, data]);
};

/**
 * We need to convert any object param to an array format since the locales do not handle params as objects yet.
 */
Validator.prototype._convertParamObjectToArray = function _convertParamObjectToArray (obj, ruleName) {
  if (Array.isArray(obj)) {
    return obj;
  }

  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames || !isObject(obj)) {
    return obj;
  }

  return paramNames.reduce(function (prev, paramName) {
    if (paramName in obj) {
      prev.push(obj[paramName]);
    }

    return prev;
  }, []);
};

/**
 * Translates the parameters passed to the rule (mainly for target fields).
 */
Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
    if ( targetName === void 0 ) targetName = null;

  var params = this._convertParamObjectToArray(rule.params, rule.name);
  if (rule.options.hasTarget && params && params[0]) {
    var localizedName = targetName || DictionaryResolver.getDriver().getAttribute(this.locale, params[0], params[0]);
    return [localizedName].concat(params.slice(1));
  }

  return params;
};

/**
 * Resolves an appropriate display name, first checking 'data-as' or the registered 'prettyName'
 */
Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
  return field.alias || DictionaryResolver.getDriver().getAttribute(this.locale, field.name, field.name);
};

/**
 * Converts an array of params to an object with named properties.
 * Only works if the rule is configured with a paramNames array.
 * Returns the same params if it cannot convert it.
 */
Validator.prototype._convertParamArrayToObj = function _convertParamArrayToObj (params, ruleName) {
  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames) {
    return params;
  }

  if (isObject(params)) {
    // check if the object is either a config object or a single parameter that is an object.
    var hasKeys = paramNames.some(function (name) { return Object.keys(params).indexOf(name) !== -1; });
    // if it has some of the keys, return it as is.
    if (hasKeys) {
      return params;
    }
    // otherwise wrap the object in an array.
    params = [params];
  }

  // Reduce the paramsNames to a param object.
  return params.reduce(function (prev, value, idx) {
    prev[paramNames[idx]] = value;

    return prev;
  }, {});
};

/**
 * Tests a single input value against a rule.
 */
Validator.prototype._test = function _test (field, value, rule) {
    var this$1 = this;

  var validator = RuleContainer.getValidatorMethod(rule.name);
  var params = Array.isArray(rule.params) ? toArray(rule.params) : rule.params;
  if (!params) {
    params = [];
  }

  var targetName = null;
  if (!validator || typeof validator !== 'function') {
    return Promise.reject(createError(("No such validator '" + (rule.name) + "' exists.")));
  }

  // has field dependencies.
  if (rule.options.hasTarget && field.dependencies) {
    var target = find(field.dependencies, function (d) { return d.name === rule.name; });
    if (target) {
      targetName = target.field.alias;
      params = [target.field.value].concat(params.slice(1));
    }
  } else if (rule.name === 'required' && field.rejectsFalse) {
    // invalidate false if no args were specified and the field rejects false by default.
    params = params.length ? params : [true];
  }

  if (rule.options.isDate) {
    var dateFormat = this._getDateFormat(field.rules);
    if (rule.name !== 'date_format') {
      params.push(dateFormat);
    }
  }

  var result = validator(value, this._convertParamArrayToObj(params, rule.name));

  // If it is a promise.
  if (isCallable(result.then)) {
    return result.then(function (values) {
      var allValid = true;
      var data = {};
      if (Array.isArray(values)) {
        allValid = values.every(function (t) { return (isObject(t) ? t.valid : t); });
      } else { // Is a single object/boolean.
        allValid = isObject(values) ? values.valid : values;
        data = values.data;
      }

      return {
        valid: allValid,
        data: result.data,
        errors: allValid ? [] : [this$1._createFieldError(field, rule, data, targetName)]
      };
    });
  }

  if (!isObject(result)) {
    result = { valid: result, data: {} };
  }

  return {
    valid: result.valid,
    data: result.data,
    errors: result.valid ? [] : [this._createFieldError(field, rule, result.data, targetName)]
  };
};

/**
 * Merges a validator object into the RULES and Messages.
 */
Validator._merge = function _merge (name, ref) {
    var validator = ref.validator;
    var options = ref.options;
    var paramNames = ref.paramNames;

  var validate = isCallable(validator) ? validator : validator.validate;
  if (validator.getMessage) {
    DictionaryResolver.getDriver().setMessage(Validator.locale, name, validator.getMessage);
  }

  RuleContainer.add(name, {
    validate: validate,
    options: options,
    paramNames: paramNames
  });
};

/**
 * Guards from extension violations.
 */
Validator._guardExtend = function _guardExtend (name, validator) {
  if (isCallable(validator)) {
    return;
  }

  if (!isCallable(validator.validate)) {
    throw createError(
      ("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.")
    );
  }
};

/**
 * Creates a Field Error Object.
 */
Validator.prototype._createFieldError = function _createFieldError (field, rule, data, targetName) {
    var this$1 = this;

  return {
    id: field.id,
    vmId: field.vmId,
    field: field.name,
    msg: this._formatErrorMessage(field, rule, data, targetName),
    rule: rule.name,
    scope: field.scope,
    regenerate: function () {
      return this$1._formatErrorMessage(field, rule, data, targetName);
    }
  };
};

/**
 * Tries different strategies to find a field.
 */
Validator.prototype._resolveField = function _resolveField (name, scope, uid) {
  if (name[0] === '#') {
    return this.fields.findById(name.slice(1));
  }

  if (!isNullOrUndefined(scope)) {
    return this.fields.find({ name: name, scope: scope, vmId: uid });
  }

  if (includes(name, '.')) {
    var ref = name.split('.');
      var fieldScope = ref[0];
      var fieldName = ref.slice(1);
    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope, vmId: uid });
    if (field) {
      return field;
    }
  }

  return this.fields.find({ name: name, scope: null, vmId: uid });
};

/**
 * Handles when a field is not found.
 */
Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
  var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);

  return Promise.reject(createError(
    ("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first.")
  ));
};

/**
 * Handles validation results.
 */
Validator.prototype._handleValidationResults = function _handleValidationResults (results, vmId) {
    var this$1 = this;

  var matchers = results.map(function (result) { return ({ id: result.id }); });
  this.errors.removeById(matchers.map(function (m) { return m.id; }));
  // remove by name and scope to remove any custom errors added.
  results.forEach(function (result) {
    this$1.errors.remove(result.field, result.scope, vmId);
  });
  var allErrors = results.reduce(function (prev, curr) {
    prev.push.apply(prev, curr.errors);

    return prev;
  }, []);

  this.errors.add(allErrors);

  // handle flags.
  this.fields.filter(matchers).forEach(function (field) {
    var result = find(results, function (r) { return r.id === field.id; });
    field.setFlags({
      pending: false,
      valid: result.valid,
      validated: true
    });
  });
};

Validator.prototype._shouldSkip = function _shouldSkip (field, value) {
  // field is configured to run through the pipeline regardless
  if (field.bails === false) {
    return false;
  }

  // disabled fields are skipped if useConstraintAttrs is enabled in config
  if (field.isDisabled && getConfig().useConstraintAttrs) {
    return true;
  }

  // skip if the field is not required and has an empty value.
  return !field.isRequired && (isNullOrUndefined(value) || value === '' || isEmptyArray(value));
};

Validator.prototype._shouldBail = function _shouldBail (field) {
  // if the field was configured explicitly.
  if (field.bails !== undefined) {
    return field.bails;
  }

  return this.fastExit;
};

/**
 * Starts the validation process.
 */
Validator.prototype._validate = function _validate (field, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var initial = ref.initial;

  var requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);

  field.forceRequired = false;
  requireRules.forEach(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });

    if (isCallable(result.then)) { throw createError('Require rules cannot be async'); }
    if (!isObject(result)) { throw createError('Require rules has to return an object (see docs)'); }

    if (result.data.required === true) {
      field.forceRequired = true;
    }
  });

  if (this._shouldSkip(field, value)) {
    return Promise.resolve({ valid: true, id: field.id, field: field.name, scope: field.scope, errors: [] });
  }

  var promises = [];
  var errors = [];
  var isExitEarly = false;
  if (isCallable(field.checkValueChanged)) {
    field.flags.changed = field.checkValueChanged();
  }

  // use of '.some()' is to break iteration in middle by returning true
  Object.keys(field.rules).filter(function (rule) {
    if (!initial || !RuleContainer.has(rule)) { return true; }

    return RuleContainer.isImmediate(rule);
  }).some(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });
    if (isCallable(result.then)) {
      promises.push(result);
    } else if (!result.valid && this$1._shouldBail(field)) {
      errors.push.apply(errors, result.errors);
      isExitEarly = true;
    } else {
      // promisify the result.
      promises.push(new Promise(function (resolve) { return resolve(result); }));
    }

    return isExitEarly;
  });

  if (isExitEarly) {
    return Promise.resolve({ valid: false, errors: errors, id: field.id, field: field.name, scope: field.scope });
  }

  return Promise.all(promises).then(function (results) {
    return results.reduce(function (prev, v) {
        var ref;

      if (!v.valid) {
        (ref = prev.errors).push.apply(ref, v.errors);
      }

      prev.valid = prev.valid && v.valid;

      return prev;
    }, { valid: true, errors: errors, id: field.id, field: field.name, scope: field.scope });
  });
};

Object.defineProperties( Validator.prototype, prototypeAccessors$4 );
Object.defineProperties( Validator, staticAccessors$1 );

// 

var normalizeValue = function (value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (prev, key) {
      prev[key] = normalizeValue(value[key]);

      return prev;
    }, {});
  }

  if (isCallable(value)) {
    return value('{0}', ['{1}', '{2}', '{3}']);
  }

  return value;
};

var normalizeFormat = function (locale) {
  // normalize messages
  var dictionary = {};
  if (locale.messages) {
    dictionary.messages = normalizeValue(locale.messages);
  }

  if (locale.custom) {
    dictionary.custom = normalizeValue(locale.custom);
  }

  if (locale.attributes) {
    dictionary.attributes = locale.attributes;
  }

  if (!isNullOrUndefined(locale.dateFormat)) {
    dictionary.dateFormat = locale.dateFormat;
  }

  return dictionary;
};

var I18nDictionary = function I18nDictionary (i18n, rootKey) {
  this.i18n = i18n;
  this.rootKey = rootKey;
};

var prototypeAccessors$5 = { locale: { configurable: true } };

prototypeAccessors$5.locale.get = function () {
  return this.i18n.locale;
};

prototypeAccessors$5.locale.set = function (value) {
  warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
};

I18nDictionary.prototype.getDateFormat = function getDateFormat (locale) {
  return this.i18n.getDateTimeFormat(locale || this.locale);
};

I18nDictionary.prototype.setDateFormat = function setDateFormat (locale, value) {
  this.i18n.setDateTimeFormat(locale || this.locale, value);
};

I18nDictionary.prototype.getMessage = function getMessage (_, key, data) {
  var path = (this.rootKey) + ".messages." + key;
  var dataOptions = data;

  if (Array.isArray(data)) {
    dataOptions = [].concat.apply([], data);
  }

  if (this.i18n.te(path)) {
    return this.i18n.t(path, dataOptions);
  }

  // fallback to the fallback message
  if (this.i18n.te(path, this.i18n.fallbackLocale)) {
    return this.i18n.t(path, this.i18n.fallbackLocale, dataOptions);
  }

  // fallback to the root message
  return this.i18n.t(((this.rootKey) + ".messages._default"), dataOptions);
};

I18nDictionary.prototype.getAttribute = function getAttribute (_, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  var path = (this.rootKey) + ".attributes." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path);
  }

  return fallback;
};

I18nDictionary.prototype.getFieldMessage = function getFieldMessage (_, field, key, data) {
  var path = (this.rootKey) + ".custom." + field + "." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path, data);
  }

  return this.getMessage(_, key, data);
};

I18nDictionary.prototype.merge = function merge$1 (dictionary) {
    var this$1 = this;

  Object.keys(dictionary).forEach(function (localeKey) {
      var obj;

    // i18n doesn't deep merge
    // first clone the existing locale (avoid mutations to locale)
    var clone = merge({}, getPath((localeKey + "." + (this$1.rootKey)), this$1.i18n.messages, {}));
    // Merge cloned locale with new one
    var locale = merge(clone, normalizeFormat(dictionary[localeKey]));
    this$1.i18n.mergeLocaleMessage(localeKey, ( obj = {}, obj[this$1.rootKey] = locale, obj ));
    if (locale.dateFormat) {
      this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
    }
  });
};

I18nDictionary.prototype.setMessage = function setMessage (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      messages: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

I18nDictionary.prototype.setAttribute = function setAttribute (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      attributes: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

Object.defineProperties( I18nDictionary.prototype, prototypeAccessors$5 );

var aggressive = function () { return ({
  on: ['input']
}); };

var lazy = function () { return ({
  on: ['change']
}); };

var eager = function (ref) {
  var errors = ref.errors;

  if (errors.length) {
    return {
      on: ['input']
    };
  }

  return {
    on: ['change', 'blur']
  };
};

var passive = function () { return ({
  on: []
}); };

var modes = {
  aggressive: aggressive,
  eager: eager,
  passive: passive,
  lazy: lazy
};

// 

var Vue;
var pendingPlugins;
var pluginInstance;

var VeeValidate$1 = function VeeValidate (config, _Vue) {
  this.configure(config);
  pluginInstance = this;
  if (_Vue) {
    Vue = _Vue;
  }
  this._validator = setValidator(
    new Validator(null, { fastExit: config && config.fastExit }, this)
  );
  this._initVM(this.config);
  this._initI18n(this.config);
};

var prototypeAccessors$6 = { i18nDriver: { configurable: true },config: { configurable: true } };
var staticAccessors$2 = { i18nDriver: { configurable: true },config: { configurable: true } };

VeeValidate$1.setI18nDriver = function setI18nDriver (driver, instance) {
  DictionaryResolver.setDriver(driver, instance);
};

VeeValidate$1.configure = function configure (cfg) {
  setConfig(cfg);
};

VeeValidate$1.setMode = function setMode (mode, implementation) {
  setConfig({ mode: mode });
  if (!implementation) {
    return;
  }

  if (!isCallable(implementation)) {
    throw new Error('A mode implementation must be a function');
  }

  modes[mode] = implementation;
};

VeeValidate$1.use = function use (plugin, options) {
    if ( options === void 0 ) options = {};

  if (!isCallable(plugin)) {
    return warn('The plugin must be a callable function');
  }

  // Don't install plugins until vee-validate is installed.
  if (!pluginInstance) {
    if (!pendingPlugins) {
      pendingPlugins = [];
    }
    pendingPlugins.push({ plugin: plugin, options: options });
    return;
  }

  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
};
VeeValidate$1.install = function install (_Vue, opts) {
  if (Vue && _Vue === Vue) {
    if (true) {
      warn('already installed, Vue.use(VeeValidate) should only be called once.');
    }
    return;
  }

  Vue = _Vue;
  pluginInstance = new VeeValidate$1(opts);
  // inject the plugin container statically into the validator class
  Validator.$vee = pluginInstance;

  detectPassiveSupport();

  Vue.mixin(mixin);
  Vue.directive('validate', directive);
  if (pendingPlugins) {
    pendingPlugins.forEach(function (ref) {
        var plugin = ref.plugin;
        var options = ref.options;

      VeeValidate$1.use(plugin, options);
    });
    pendingPlugins = null;
  }
};

prototypeAccessors$6.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$2.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$6.config.get = function () {
  return getConfig();
};

staticAccessors$2.config.get = function () {
  return getConfig();
};

VeeValidate$1.prototype._initVM = function _initVM (config) {
    var this$1 = this;

  this._vm = new Vue({
    data: function () { return ({
      errors: this$1._validator.errors,
      fields: this$1._validator.fields
    }); }
  });
};

VeeValidate$1.prototype._initI18n = function _initI18n (config) {
    var this$1 = this;

  var dictionary = config.dictionary;
    var i18n = config.i18n;
    var i18nRootKey = config.i18nRootKey;
    var locale = config.locale;
  var onLocaleChanged = function () {
    if (dictionary) {
      this$1.i18nDriver.merge(dictionary);
    }

    this$1._validator.errors.regenerate();
  };

  // i18 is being used for localization.
  if (i18n) {
    VeeValidate$1.setI18nDriver('i18n', new I18nDictionary(i18n, i18nRootKey));
    i18n._vm.$watch('locale', onLocaleChanged);
  } else if (typeof window !== 'undefined') {
    this._vm.$on('localeChanged', onLocaleChanged);
  }

  if (dictionary) {
    this.i18nDriver.merge(dictionary);
  }

  if (locale && !i18n) {
    this._validator.localize(locale);
  }
};

VeeValidate$1.prototype.configure = function configure (cfg) {
  setConfig(cfg);
};

Object.defineProperties( VeeValidate$1.prototype, prototypeAccessors$6 );
Object.defineProperties( VeeValidate$1, staticAccessors$2 );

VeeValidate$1.mixin = mixin;
VeeValidate$1.directive = directive;
VeeValidate$1.Validator = Validator;
VeeValidate$1.ErrorBag = ErrorBag;

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
var formatFileSize = function (size) {
  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var threshold = 1024;
  size = Number(size) * threshold;
  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
};

/**
 * Checks if vee-validate is defined globally.
 */
var isDefinedGlobally = function () {
  return typeof VeeValidate !== 'undefined';
};

var obj;

var messages = {
  _default: function (field) { return ("The " + field + " value is not valid"); },
  after: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target);
},
  alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters"); },
  alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores"); },
  alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters"); },
  alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces"); },
  before: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target);
},
  between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " field must be between " + min + " and " + max);
},
  confirmed: function (field) { return ("The " + field + " confirmation does not match"); },
  credit_card: function (field) { return ("The " + field + " field is invalid"); },
  date_between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " must be between " + min + " and " + max);
},
  date_format: function (field, ref) {
    var format = ref[0];

    return ("The " + field + " must be in the format " + format);
},
  decimal: function (field, ref) {
    if ( ref === void 0 ) ref = [];
    var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';

    return ("The " + field + " field must be numeric and may contain" + (!decimals || decimals === '*' ? '' : ' ' + decimals) + " decimal points");
},
  digits: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be numeric and contains exactly " + length + " digits");
},
  dimensions: function (field, ref) {
    var width = ref[0];
    var height = ref[1];

    return ("The " + field + " field must be " + width + " pixels by " + height + " pixels");
},
  email: function (field) { return ("The " + field + " field must be a valid email"); },
  excluded: function (field) { return ("The " + field + " field must be a valid value"); },
  ext: function (field) { return ("The " + field + " field must be a valid file"); },
  image: function (field) { return ("The " + field + " field must be an image"); },
  included: function (field) { return ("The " + field + " field must be a valid value"); },
  integer: function (field) { return ("The " + field + " field must be an integer"); },
  ip: function (field) { return ("The " + field + " field must be a valid ip address"); },
  ip_or_fqdn: function (field) { return ("The " + field + " field must be a valid ip address or FQDN"); },
  length: function (field, ref) {
    var length = ref[0];
    var max = ref[1];

    if (max) {
      return ("The " + field + " length must be between " + length + " and " + max);
    }

    return ("The " + field + " length must be " + length);
  },
  max: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field may not be greater than " + length + " characters");
},
  max_value: function (field, ref) {
    var max = ref[0];

    return ("The " + field + " field must be " + max + " or less");
},
  mimes: function (field) { return ("The " + field + " field must have a valid file type"); },
  min: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be at least " + length + " characters");
},
  min_value: function (field, ref) {
    var min = ref[0];

    return ("The " + field + " field must be " + min + " or more");
},
  numeric: function (field) { return ("The " + field + " field may only contain numeric characters"); },
  regex: function (field) { return ("The " + field + " field format is invalid"); },
  required: function (field) { return ("The " + field + " field is required"); },
  required_if: function (field, ref) {
    var target = ref[0];

    return ("The " + field + " field is required when the " + target + " field has this value");
},
  size: function (field, ref) {
    var size = ref[0];

    return ("The " + field + " size must be less than " + (formatFileSize(size)));
},
  url: function (field) { return ("The " + field + " field is not a valid URL"); }
};

var locale = {
  name: 'en',
  messages: messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize(( obj = {}, obj[locale.name] = locale, obj ));
}

function toInteger (dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number)
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/ // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate (argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {};

  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (argument instanceof Date ||
    (typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]')
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument)
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN)
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN)
      }
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);
      if (isNaN(offset)) {
        return new Date(NaN)
      }
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(NaN)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimeter);
  var timeString;

  if (patterns.plainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimeter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimeter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1 +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = patterns.timezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  var hours;

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);

    if (!validateTimezone()) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOWeekYear (isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex (year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

function validateDate (year, month, date) {
  if (month < 0 || month > 11) {
    return false
  }

  if (date != null) {
    if (date < 1) {
      return false
    }

    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false
    }
  }

  return true
}

function validateDayOfYearDate (year, dayOfYear) {
  if (dayOfYear < 1) {
    return false
  }

  var isLeapYear = isLeapYearIndex(year);
  if (isLeapYear && dayOfYear > 366) {
    return false
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false
  }

  return true
}

function validateWeekDate (year, week, day) {
  if (week < 0 || week > 52) {
    return false
  }

  if (day != null && (day < 0 || day > 6)) {
    return false
  }

  return true
}

function validateTime (hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false
  }

  return true
}

function validateTimezone (hours, minutes) {
  if (minutes != null && (minutes < 0 || minutes > 59)) {
    return false
  }

  return true
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount)
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid('2014-02-31')
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  return !isNaN(date)
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },

  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },

  halfAMinute: 'half a minute',

  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },

  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },

  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },

  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },

  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },

  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance (token, count, options) {
  options = options || {};

  var result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}

function buildFormatLongFn (args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format
  }
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};

var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};

var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};

var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function formatRelative (token, date, baseDate, options) {
  return formatRelativeLocale[token]
}

function buildLocalizeFn (args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var context = options.context ? String(options.context) : 'standalone';

    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      valuesArray = args.formattingValues[width] || args.formattingValues[args.defaultFormattingWidth];
    } else {
      valuesArray = args.values[width] || args.values[args.defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index]
  }
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};

var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};

var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaulFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn (args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};

    var matchResult = string.match(args.matchPattern);
    if (!matchResult) {
      return null
    }
    var matchedString = matchResult[0];

    var parseResult = string.match(args.parsePattern);
    if (!parseResult) {
      return null
    }
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    }
  }
}

function buildMatchFn (args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;

    var matchPattern = (width && args.matchPatterns[width]) || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null
    }
    var matchedString = matchResult[0];

    var parsePatterns = (width && args.parsePatterns[width]) || args.parsePatterns[args.defaultParseWidth];

    var value;
    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(function (pattern) {
        return pattern.test(string)
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string)
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    }
  }
}

function findKey (object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;

var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};

var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};

var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};

var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};

var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};

var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10)
    }
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1
    }
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

var MILLISECONDS_IN_DAY = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var weekStartsOn = 1;

  var date = toDate(dirtyDate, dirtyOptions);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, options);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale &&
    locale.options &&
    locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);

  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale &&
    locale.options &&
    locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK$1 = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCWeek(date, dirtyOptions).getTime() - startOfUTCWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {width: 'abbreviated'})
      // A, B
      case 'GGGGG':
        return localize.era(era, {width: 'narrow'})
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {width: 'wide'})
    }
  },

  // Year
  y: function (date, token, localize, options) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();

    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;

    // Two digit year
    if (token === 'yy') {
      var twoDigitYear = year % 100;
      return addLeadingZeros(twoDigitYear, 2)
    }

    // Ordinal number
    if (token === 'yo') {
      return localize.ordinalNumber(year, {unit: 'year'})
    }

    // Padding
    return addLeadingZeros(year, token.length)
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2)
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {unit: 'year'})
    }

    // Padding
    return addLeadingZeros(weekYear, token.length)
  },

  // ISO week-numbering year
  R: function (date, token, localize, options) {
    var isoWeekYear = getUTCISOWeekYear(date, options);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length)
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token, localize, options) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length)
  },

  // Quarter
  Q: function (date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter)
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2)
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {unit: 'quarter'})
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {width: 'abbreviated', context: 'formatting'})
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {width: 'narrow', context: 'formatting'})
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter)
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2)
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {unit: 'quarter'})
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {width: 'abbreviated', context: 'standalone'})
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {width: 'narrow', context: 'standalone'})
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {width: 'wide', context: 'standalone'})
    }
  },

  // Month
  M: function (date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'M':
        return String(month + 1)
      // 01, 02, ..., 12
      case 'MM':
        return addLeadingZeros(month + 1, 2)
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {unit: 'month'})
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {width: 'abbreviated', context: 'formatting'})
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {width: 'narrow', context: 'formatting'})
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone month
  L: function (date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1)
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2)
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {unit: 'month'})
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {width: 'abbreviated', context: 'standalone'})
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {width: 'narrow', context: 'standalone'})
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {width: 'wide', context: 'standalone'})
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {unit: 'week'})
    }

    return addLeadingZeros(week, token.length)
  },

  // ISO week of year
  I: function (date, token, localize, options) {
    var isoWeek = getUTCISOWeek(date, options);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {unit: 'week'})
    }

    return addLeadingZeros(isoWeek, token.length)
  },

  // Day of the month
  d: function (date, token, localize, options) {
    var dayOfMonth = date.getUTCDate();

    if (token === 'do') {
      return localize.ordinalNumber(dayOfMonth, {unit: 'date'})
    }

    return addLeadingZeros(dayOfMonth, token.length)
  },

  // Day of year
  D: function (date, token, localize, options) {
    var dayOfYear = getUTCDayOfYear(date, options);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {unit: 'dayOfYear'})
    }

    return addLeadingZeros(dayOfYear, token.length)
  },

  // Day of week
  E: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = ((dayOfWeek - options.weekStartsOn + 8) % 7) || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek)
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2)
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {unit: 'day'})
      case 'eee':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = ((dayOfWeek - options.weekStartsOn + 8) % 7) || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek)
      // Padded numberical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length)
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {unit: 'day'})
      case 'ccc':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'standalone'})
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'standalone'})
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {width: 'short', context: 'standalone'})
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'standalone'})
    }
  },

  // ISO day of week
  i: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek)
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length)
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {unit: 'day'})
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = (hours / 12) >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = (hours / 12) >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // Hour [1-12]
  h: function (date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (hours === 0) {
      hours = 12;
    }

    if (token === 'ho') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [0-23]
  H: function (date, token, localize, options) {
    var hours = date.getUTCHours();

    if (token === 'Ho') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [0-11]
  K: function (date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [1-24]
  k: function (date, token, localize, options) {
    var hours = date.getUTCHours();

    if (hours === 0) {
      hours = 24;
    }

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Minute
  m: function (date, token, localize, options) {
    var minutes = date.getUTCMinutes();

    if (token === 'mo') {
      return localize.ordinalNumber(minutes, {unit: 'minute'})
    }

    return addLeadingZeros(minutes, token.length)
  },

  // Second
  s: function (date, token, localize, options) {
    var seconds = date.getUTCSeconds();

    if (token === 'so') {
      return localize.ordinalNumber(seconds, {unit: 'second'})
    }

    return addLeadingZeros(seconds, token.length)
  },

  // Fraction of second
  S: function (date, token, localize, options) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, numberOfDigits)
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z'
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Seconds timestamp
  t: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length)
  },

  // Milliseconds timestamp
  T: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length)
  }
};

function addLeadingZeros (number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output
}

function formatTimezone (offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimeter + minutes
}

function formatTimezoneWithOptionalMinutes (offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2)
  }
  return formatTimezone(offset, dirtyDelimeter)
}

function formatTimezoneShort (offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours)
  }
  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2)
}

function dateLongFormatter (pattern, formatLong, options) {
  switch (pattern) {
    case 'P':
      return formatLong.date({width: 'short'})
    case 'PP':
      return formatLong.date({width: 'medium'})
    case 'PPP':
      return formatLong.date({width: 'long'})
    case 'PPPP':
    default:
      return formatLong.date({width: 'full'})
  }
}

function timeLongFormatter (pattern, formatLong, options) {
  switch (pattern) {
    case 'p':
      return formatLong.time({width: 'short'})
    case 'pp':
      return formatLong.time({width: 'medium'})
    case 'ppp':
      return formatLong.time({width: 'long'})
    case 'pppp':
    default:
      return formatLong.time({width: 'full'})
  }
}

function dateTimeLongFormatter (pattern, formatLong, options) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong)
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({width: 'short'});
      break
    case 'PP':
      dateTimeFormat = formatLong.dateTime({width: 'medium'});
      break
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({width: 'long'});
      break
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({width: 'full'});
      break
  }

  return dateTimeFormat
    .replace('{{date}}', dateLongFormatter(datePattern, formatLong))
    .replace('{{time}}', timeLongFormatter(timePattern, formatLong))
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount, dirtyOptions)
}

var protectedTokens = ['D', 'DD', 'YY', 'YYYY'];

function isProtectedToken(token) {
  return protectedTokens.indexOf(token) !== -1
}

function throwProtectedError(token) {
  throw new RangeError(
    '`options.awareOfUnicodeTokens` must be set to `true` to use `' +
      token +
      '` token; see: https://git.io/fxCyr'
  )
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp = /^'(.*?)'?$/;
var doubleQuoteRegExp = /''/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/dd/yyyy'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(
 *   new Date(2014, 6, 2),
 *   "do 'de' MMMM yyyy",
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(
 *   new Date(2014, 6, 2, 15),
 *   "h 'o''clock'"
 * )
 * //=> "3 o'clock"
 */
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError(
      '2 arguments required, but only ' + arguments.length + ' present'
    )
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  var localeFirstWeekContainsDate =
    locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError(
      'firstWeekContainsDate must be between 1 and 7 inclusively'
    )
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn =
    localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn =
    options.weekStartsOn == null
      ? defaultWeekStartsOn
      : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var originalDate = toDate(dirtyDate, options);

  if (!isValid(originalDate, options)) {
    return 'Invalid Date'
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset, options);

  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };

  var result = formatStr
    .match(longFormattingTokensRegExp)
    .map(function(substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong, formatterOptions)
      }
      return substring
    })
    .join('')
    .match(formattingTokensRegExp)
    .map(function(substring) {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'"
      }

      var firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return cleanEscapedString(substring)
      }

      var formatter = formatters[firstCharacter];
      if (formatter) {
        if (!options.awareOfUnicodeTokens && isProtectedToken(substring)) {
          throwProtectedError(substring);
        }
        return formatter(utcDate, substring, locale.localize, formatterOptions)
      }

      return substring
    })
    .join('');

  return result
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'")
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() > dateToCompare.getTime()
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() < dateToCompare.getTime()
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1 (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
  var dateRight = toDate(dirtyRightDate, dirtyOptions);
  return dateLeft.getTime() === dateRight.getTime()
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var day = toInteger(dirtyDay);

  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCWeek (dirtyDate, dirtyWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, dirtyOptions) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate, dirtyOptions);
  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_SECOND = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern (pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null
  }

  var value = parseInt(matchResult[0], 10);

  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  }
}

function parseTimezonePattern (pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    }
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value: sign * (
      hours * MILLISECONDS_IN_HOUR$1 +
        minutes * MILLISECONDS_IN_MINUTE$2 +
        seconds * MILLISECONDS_IN_SECOND
    ),
    rest: string.slice(matchResult[0].length)
  }
}

function parseAnyDigitsSigned (string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback)
}

function parseNDigits (n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback)
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback)
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback)
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback)
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback)
  }
}

function parseNDigitsSigned (n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback)
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback)
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback)
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback)
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback)
  }
}

function dayPeriodEnumToHours (enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4
    case 'evening':
      return 17
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0
  }
}

function normalizeTwoDigitYear (twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result
}

var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// User for validation
function isLeapYearIndex$1 (year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {width: 'abbreviated'}) ||
            match.era(string, {width: 'narrow'})
        // A, B
        case 'GGGGG':
          return match.era(string, {width: 'narrow'})
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(string, {width: 'wide'}) ||
            match.era(string, {width: 'abbreviated'}) ||
            match.era(string, {width: 'narrow'})
      }
    },
    set: function (date, value, options) {
      // Sets year 10 BC if BC, or 10 AC if AC
      date.setUTCFullYear(value === 1 ? 10 : -9, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    priority: 130,
    parse: function (string, token, match, options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        }
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback)
        case 'yo':
          return match.ordinalNumber(string, {unit: 'year', valueCallback: valueCallback})
        default:
          return parseNDigits(token.length, string, valueCallback)
      }
    },
    validate: function (date, value, options) {
      return value.isTwoDigitYear || value.year > 0
    },
    set: function (date, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        }
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback)
        case 'Yo':
          return match.ordinalNumber(string, {unit: 'year', valueCallback: valueCallback})
        default:
          return parseNDigits(token.length, string, valueCallback)
      }
    },
    validate: function (date, value, options) {
      return value.isTwoDigitYear || value.year > 0
    },
    set: function (date, value, options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options)
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options)
    }
  },

  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, match, options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string)
      }

      return parseNDigitsSigned(token.length, string)
    },
    set: function (date, value, options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear)
    }
  },

  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, match, options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string)
      }

      return parseNDigitsSigned(token.length, string)
    },
    set: function (date, value, options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ': // 01, 02, 03, 04
          return parseNDigits(token.length, string)
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(string, {unit: 'quarter'})
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.quarter(string, {width: 'narrow', context: 'formatting'})
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(string, {width: 'narrow', context: 'formatting'})
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(string, {width: 'wide', context: 'formatting'}) ||
            match.quarter(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.quarter(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 4
    },
    set: function (date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq': // 01, 02, 03, 04
          return parseNDigits(token.length, string)
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(string, {unit: 'quarter'})
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.quarter(string, {width: 'narrow', context: 'standalone'})
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(string, {width: 'narrow', context: 'standalone'})
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(string, {width: 'wide', context: 'standalone'}) ||
            match.quarter(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.quarter(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 4
    },
    set: function (date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return value - 1
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback)
        // 01, 02, ..., 12
        case 'MM':
          return parseNDigits(2, string, valueCallback)
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return match.ordinalNumber(string, {unit: 'month', valueCallback: valueCallback})
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.month(string, {width: 'narrow', context: 'formatting'})
        // J, F, ..., D
        case 'MMMMM':
          return match.month(string, {width: 'narrow', context: 'formatting'})
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(string, {width: 'wide', context: 'formatting'}) ||
            match.month(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.month(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return value - 1
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback)
        // 01, 02, ..., 12
        case 'LL':
          return parseNDigits(2, string, valueCallback)
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return match.ordinalNumber(string, {unit: 'month', valueCallback: valueCallback})
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.month(string, {width: 'narrow', context: 'standalone'})
        // J, F, ..., D
        case 'LLLLL':
          return match.month(string, {width: 'narrow', context: 'standalone'})
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(string, {width: 'wide', context: 'standalone'}) ||
            match.month(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.month(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string)
        case 'wo':
          return match.ordinalNumber(string, {unit: 'week'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 53
    },
    set: function (date, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options)
    }
  },

  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string)
        case 'Io':
          return match.ordinalNumber(string, {unit: 'week'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 53
    },
    set: function (date, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options)
    }
  },

  // Day of the month
  d: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string)
        case 'do':
          return match.ordinalNumber(string, {unit: 'date'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR$1[month]
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH$1[month]
      }
    },
    set: function (date, value, options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Day of year
  D: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string)
        case 'Do':
          return match.ordinalNumber(string, {unit: 'date'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366
      } else {
        return value >= 1 && value <= 365
      }
    },
    set: function (date, value, options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
        // T
        case 'EEEEE':
          return match.day(string, {width: 'narrow', context: 'formatting'})
        // Tu
        case 'EEEEEE':
          return match.day(string, {width: 'short', context: 'formatting'}) ||
          match.day(string, {width: 'narrow', context: 'formatting'})
        // Tuesday
        case 'EEEE':
        default:
          return match.day(string, {width: 'wide', context: 'formatting'}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee': // 03
          return parseNDigits(token.length, string, valueCallback)
        // 3rd
        case 'eo':
          return match.ordinalNumber(string, {unit: 'day', valueCallback: valueCallback})
        // Tue
        case 'eee':
          return match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
        // T
        case 'eeeee':
          return match.day(string, {width: 'narrow', context: 'formatting'})
        // Tu
        case 'eeeeee':
          return match.day(string, {width: 'short', context: 'formatting'}) ||
          match.day(string, {width: 'narrow', context: 'formatting'})
        // Tuesday
        case 'eeee':
        default:
          return match.day(string, {width: 'wide', context: 'formatting'}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc': // 03
          return parseNDigits(token.length, string, valueCallback)
        // 3rd
        case 'co':
          return match.ordinalNumber(string, {unit: 'day', valueCallback: valueCallback})
        // Tue
        case 'ccc':
          return match.day(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.day(string, {width: 'short', context: 'standalone'}) ||
            match.day(string, {width: 'narrow', context: 'standalone'})
        // T
        case 'ccccc':
          return match.day(string, {width: 'narrow', context: 'standalone'})
        // Tu
        case 'cccccc':
          return match.day(string, {width: 'short', context: 'standalone'}) ||
          match.day(string, {width: 'narrow', context: 'standalone'})
        // Tuesday
        case 'cccc':
        default:
          return match.day(string, {width: 'wide', context: 'standalone'}) ||
            match.day(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.day(string, {width: 'short', context: 'standalone'}) ||
            match.day(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7
        }
        return value
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii': // 02
          return parseNDigits(token.length, string)
        // 2nd
        case 'io':
          return match.ordinalNumber(string, {unit: 'day'})
        // Tue
        case 'iii':
          return match.day(string, {width: 'abbreviated', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // T
        case 'iiiii':
          return match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // Tu
        case 'iiiiii':
          return match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
          match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // Tuesday
        case 'iiii':
        default:
          return match.day(string, {width: 'wide', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 7
    },
    set: function (date, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'aaaaa':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'aaaa':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'bbbbb':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'bbbb':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'BBBBB':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'BBBB':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string)
        case 'ho':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 12
    },
    set: function (date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date
    }
  },

  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string)
        case 'Ho':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 23
    },
    set: function (date, value, options) {
      date.setUTCHours(value, 0, 0, 0);
      return date
    }
  },

  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string)
        case 'Ko':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date
    }
  },

  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string)
        case 'ko':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 24
    },
    set: function (date, value, options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date
    }
  },

  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string)
        case 'mo':
          return match.ordinalNumber(string, {unit: 'minute'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 59
    },
    set: function (date, value, options) {
      date.setUTCMinutes(value, 0, 0);
      return date
    }
  },

  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string)
        case 'so':
          return match.ordinalNumber(string, {unit: 'second'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 59
    },
    set: function (date, value, options) {
      date.setUTCSeconds(value, 0);
      return date
    }
  },

  // Fraction of second
  S: {
    priority: 40,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3))
      };
      return parseNDigits(token.length, string, valueCallback)
    },
    set: function (date, value, options) {
      date.setUTCMilliseconds(value);
      return date
    }
  },

  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 20,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string)
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string)
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string)
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string)
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string)
      }
    },
    set: function (date, value, options) {
      return new Date(date.getTime() - value)
    }
  },

  // Timezone (ISO-8601)
  x: {
    priority: 20,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string)
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string)
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string)
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string)
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string)
      }
    },
    set: function (date, value, options) {
      return new Date(date.getTime() - value)
    }
  },

  // Seconds timestamp
  t: {
    priority: 10,
    parse: function (string, token, match, options) {
      return parseAnyDigitsSigned(string)
    },
    set: function (date, value, options) {
      return new Date(value * 1000)
    }
  },

  // Milliseconds timestamp
  T: {
    priority: 10,
    parse: function (string, token, match, options) {
      return parseAnyDigitsSigned(string)
    },
    set: function (date, value, options) {
      return new Date(value)
    }
  }
};

var TIMEZONE_UNIT_PRIORITY = 20;

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp$1 = /^'(.*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;

var notWhitespaceRegExp = /\S/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 6     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 6     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              |  40 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  20 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  20 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Seconds timestamp               |  10 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Milliseconds timestamp          |  10 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `baseDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *
 * 6. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
 *
 * `baseDate` must be passed for correct work of the function.
 * If you're not sure which `baseDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|String|Number} baseDate - defines values missing from the parsed dateString
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse(
 *   '02/11/2014',
 *   'MM/dd/yyyy',
 *   new Date()
 * )
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse(
 *   '28-a de februaro',
 *   "do 'de' MMMM",
 *   new Date(2010, 0, 1),
 *   {locale: eo}
 * )
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(
  dirtyDateString,
  dirtyFormatString,
  dirtyBaseDate,
  dirtyOptions
) {
  if (arguments.length < 3) {
    throw new TypeError(
      '3 arguments required, but only ' + arguments.length + ' present'
    )
  }

  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  if (!locale.match) {
    throw new RangeError('locale must contain match property')
  }

  var localeFirstWeekContainsDate =
    locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError(
      'firstWeekContainsDate must be between 1 and 7 inclusively'
    )
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn =
    localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn =
    options.weekStartsOn == null
      ? defaultWeekStartsOn
      : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyBaseDate, options)
    } else {
      return new Date(NaN)
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [
    {
      priority: TIMEZONE_UNIT_PRIORITY,
      set: dateToSystemTimezone,
      index: 0
    }
  ];

  var i;

  var tokens = formatString.match(formattingTokensRegExp$1);

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.awareOfUnicodeTokens && isProtectedToken(token)) {
      throwProtectedError(token);
    }

    var firstCharacter = token[0];
    var parser = parsers[firstCharacter];
    if (parser) {
      var parseResult = parser.parse(
        dateString,
        token,
        locale.match,
        subFnOptions
      );

      if (!parseResult) {
        return new Date(NaN)
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });

      dateString = parseResult.rest;
    } else {
      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString$1(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN)
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN)
  }

  var uniquePrioritySetters = setters
    .map(function(setter) {
      return setter.priority
    })
    .sort(function(a, b) {
      return b - a
    })
    .filter(function(priority, index, array) {
      return array.indexOf(priority) === index
    })
    .map(function(priority) {
      return setters
        .filter(function(setter) {
          return setter.priority === priority
        })
        .reverse()
    })
    .map(function(setterArray) {
      return setterArray[0]
    });

  var date = toDate(dirtyBaseDate, options);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (
      setter.validate &&
      !setter.validate(utcDate, setter.value, subFnOptions)
    ) {
      return new Date(NaN)
    }

    utcDate = setter.set(utcDate, setter.value, subFnOptions);
  }

  return utcDate
}

function dateToSystemTimezone(date) {
  var convertedDate = new Date(0);
  convertedDate.setFullYear(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate()
  );
  convertedDate.setHours(
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
  return convertedDate
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'")
}

// 

/**
 * Custom parse behavior on top of date-fns parse function.
 */
function parseDate$1 (date, format$1) {
  if (typeof date !== 'string') {
    return isValid(date) ? date : null;
  }

  var parsed = parse(date, format$1, new Date());

  // if date is not valid or the formatted output after parsing does not match
  // the string value passed in (avoids overflows)
  if (!isValid(parsed) || format(parsed, format$1) !== date) {
    return null;
  }

  return parsed;
}

var afterValidator = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion; if ( inclusion === void 0 ) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isAfter(value, targetValue) || (inclusion && isEqual$1(value, targetValue));
};

var options = {
  hasTarget: true,
  isDate: true
};

// required to convert from a list of array values to an object.
var paramNames = ['targetValue', 'inclusion', 'format'];

var after = {
  validate: afterValidator,
  options: options,
  paramNames: paramNames
};

/**
 * Some Alpha Regex helpers.
 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
 */

var alpha = {
  en: /^[A-Z]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[A-ZÆØÅ]*$/i,
  de: /^[A-ZÄÖÜß]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[A-Z\xC0-\xFF]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[А-ЯЁ]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[A-ZČĆŽŠĐ]*$/i,
  sv: /^[A-ZÅÄÖ]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaSpaces = {
  en: /^[A-Z\s]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
  da: /^[A-ZÆØÅ\s]*$/i,
  de: /^[A-ZÄÖÜß\s]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی\s]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
  it: /^[A-Z\xC0-\xFF\s]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
  ru: /^[А-ЯЁ\s]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
  sv: /^[A-ZÅÄÖ\s]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i
};

var alphanumeric = {
  en: /^[0-9A-Z]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[0-9A-ZÆØÅ]$/i,
  de: /^[0-9A-ZÄÖÜß]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[0-9A-Z\xC0-\xFF]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[0-9А-ЯЁ]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
  sv: /^[0-9A-ZÅÄÖ]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaDash = {
  en: /^[0-9A-Z_-]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
  da: /^[0-9A-ZÆØÅ_-]*$/i,
  de: /^[0-9A-ZÄÖÜß_-]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی_-]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
  it: /^[0-9A-Z\xC0-\xFF_-]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
  ru: /^[0-9А-ЯЁ_-]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
  sv: /^[0-9A-ZÅÄÖ_-]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i
};

var validate = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
  }

  return (alpha[locale] || alpha.en).test(value);
};

var paramNames$1 = ['locale'];

var alpha$1 = {
  validate: validate,
  paramNames: paramNames$1
};

var validate$1 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$1(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
  }

  return (alphaDash[locale] || alphaDash.en).test(value);
};

var paramNames$2 = ['locale'];

var alpha_dash = {
  validate: validate$1,
  paramNames: paramNames$2
};

var validate$2 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$2(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
  }

  return (alphanumeric[locale] || alphanumeric.en).test(value);
};

var paramNames$3 = ['locale'];

var alpha_num = {
  validate: validate$2,
  paramNames: paramNames$3
};

var validate$3 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$3(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
  }

  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};

var paramNames$4 = ['locale'];

var alpha_spaces = {
  validate: validate$3,
  paramNames: paramNames$4
};

var validate$4 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion; if ( inclusion === void 0 ) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isBefore(value, targetValue) || (inclusion && isEqual$1(value, targetValue));
};

var options$1 = {
  hasTarget: true,
  isDate: true
};

var paramNames$5 = ['targetValue', 'inclusion', 'format'];

var before = {
  validate: validate$4,
  options: options$1,
  paramNames: paramNames$5
};

var validate$5 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var min = ref.min;
  var max = ref.max;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$5(val, { min: min, max: max }); });
  }

  return Number(min) <= value && Number(max) >= value;
};

var paramNames$6 = ['min', 'max'];

var between = {
  validate: validate$5,
  paramNames: paramNames$6
};

var validate$6 = function (value, ref) {
  var targetValue = ref.targetValue;

  return String(value) === String(targetValue);
};
var options$2 = {
  hasTarget: true
};

var paramNames$7 = ['targetValue'];

var confirmed = {
  validate: validate$6,
  options: options$2,
  paramNames: paramNames$7
};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType;

    if (input === null) {
      invalidType = 'null';
    } else {
      invalidType = _typeof(input);

      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
        invalidType = input.constructor.name;
      } else {
        invalidType = "a ".concat(invalidType);
      }
    }

    throw new TypeError("Expected string but received ".concat(invalidType, "."));
  }
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(assertString_1);

var isCreditCard_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble;

  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isCreditCard = unwrapExports(isCreditCard_1);

var validate$7 = function (value) { return isCreditCard(String(value)); };

var credit_card = {
  validate: validate$7
};

var validate$8 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var min = ref.min;
  var max = ref.max;
  var inclusivity = ref.inclusivity; if ( inclusivity === void 0 ) inclusivity = '()';
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusivity;
    inclusivity = '()';
  }

  var minDate = parseDate$1(String(min), format);
  var maxDate = parseDate$1(String(max), format);
  var dateVal = parseDate$1(String(value), format);

  if (!minDate || !maxDate || !dateVal) {
    return false;
  }

  if (inclusivity === '()') {
    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
  }

  if (inclusivity === '(]') {
    return isAfter(dateVal, minDate) && (isEqual$1(dateVal, maxDate) || isBefore(dateVal, maxDate));
  }

  if (inclusivity === '[)') {
    return isBefore(dateVal, maxDate) && (isEqual$1(dateVal, minDate) || isAfter(dateVal, minDate));
  }

  return isEqual$1(dateVal, maxDate) || isEqual$1(dateVal, minDate) ||
    (isBefore(dateVal, maxDate) && isAfter(dateVal, minDate));
};

var options$3 = {
  isDate: true
};

var paramNames$8 = ['min', 'max', 'inclusivity', 'format'];

var date_between = {
  validate: validate$8,
  options: options$3,
  paramNames: paramNames$8
};

var validate$9 = function (value, ref) {
  var format = ref.format;

  return !!parseDate$1(value, format);
};

var options$4 = {
  isDate: true
};

var paramNames$9 = ['format'];

var date_format = {
  validate: validate$9,
  options: options$4,
  paramNames: paramNames$9
};

var validate$a = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var decimals = ref.decimals; if ( decimals === void 0 ) decimals = '*';
  var separator = ref.separator; if ( separator === void 0 ) separator = '.';

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$a(val, { decimals: decimals, separator: separator }); });
  }

  // if is 0.
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }

  var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
  var regex = new RegExp(("^[-+]?\\d*(\\" + separator + "\\d" + regexPart + ")?([eE]{1}[-]?\\d+)?$"));

  if (! regex.test(value)) {
    return false;
  }

  var parsedValue = parseFloat(value);

  // eslint-disable-next-line
  return parsedValue === parsedValue;
};

var paramNames$a = ['decimals', 'separator'];

var decimal = {
  validate: validate$a,
  paramNames: paramNames$a
};

var validate$b = function (value, ref) {
  var length = ref[0];

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$b(val, [length]); });
  }
  var strVal = String(value);

  return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
};

var digits = {
  validate: validate$b
};

var imageRegex = /\.(jpg|svg|jpeg|png|bmp|gif)$/i;

var validateImage = function (file, width, height) {
  var URL = window.URL || window.webkitURL;
  return new Promise(function (resolve) {
    var image = new Image();
    image.onerror = function () { return resolve({ valid: false }); };
    image.onload = function () { return resolve({
      valid: image.width === Number(width) && image.height === Number(height)
    }); };

    image.src = URL.createObjectURL(file);
  });
};

var validate$c = function (files, ref) {
  var width = ref[0];
  var height = ref[1];

  var images = ensureArray(files).filter(function (file) { return imageRegex.test(file.name); });
  if (images.length === 0) {
    return false;
  }
  return Promise.all(images.map(function (image) { return validateImage(image, width, height); }));
};

var dimensions = {
  validate: validate$c
};

var merge_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(merge_1);

var isByteLength_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isByteLength;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(isByteLength_1);

var isFQDN_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = _interopRequireDefault(assertString_1);

var _merge = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }

  var parts = str.split('.');

  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }

  if (options.require_tld) {
    var tld = parts.pop();

    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }

  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];

    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }

    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }

    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isFQDN = unwrapExports(isFQDN_1);

var isIP_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::
    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.

    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    } // initial or final ::


    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }

        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) ; else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }

    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }

    return blocks.length === expectedNumberOfBlocks;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isIP = unwrapExports(isIP_1);

var isEmail_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = _interopRequireDefault(assertString_1);

var _merge = _interopRequireDefault(merge_1);

var _isByteLength = _interopRequireDefault(isByteLength_1);

var _isFQDN = _interopRequireDefault(isFQDN_1);

var _isIP = _interopRequireDefault(isIP_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);

    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');
  var lower_domain = domain.toLowerCase();

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace('.', ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  })) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isEmail = unwrapExports(isEmail_1);

function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var validate$d = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var multiple = ref.multiple; if ( multiple === void 0 ) multiple = false;
  var rest = objectWithoutProperties( ref, ["multiple"] );
  var options = rest;

  if (multiple && !Array.isArray(value)) {
    value = String(value).split(',').map(function (emailStr) { return emailStr.trim(); });
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) { return isEmail(String(val), validatorOptions); });
  }

  return isEmail(String(value), validatorOptions);
};

var email = {
  validate: validate$d
};

var validate$e = function (value, options) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$e(val, options); });
  }

  return toArray(options).some(function (item) {
    // eslint-disable-next-line
    return item == value;
  });
};

var included = {
  validate: validate$e
};

var validate$f = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return !validate$e.apply(void 0, args);
};

var excluded = {
  validate: validate$f
};

var validate$g = function (files, extensions) {
  var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');
  return ensureArray(files).every(function (file) { return regex.test(file.name); });
};

var ext = {
  validate: validate$g
};

var validate$h = function (files) { return (Array.isArray(files) ? files : [files]).every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }); };

var image = {
  validate: validate$h
};

var validate$i = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
  }

  return /^-?[0-9]+$/.test(String(value));
};

var integer = {
  validate: validate$i
};

var validate$j = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var version = ref.version; if ( version === void 0 ) version = 4;

  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isIP(val, version); });
  }

  return isIP(value, version);
};

var paramNames$b = ['version'];

var ip = {
  validate: validate$j,
  paramNames: paramNames$b
};

var validate$k = function (value) {
  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return (isIP(val, '') || isFQDN(val)); });
  }

  return isIP(value, '') || isFQDN(value);
};

var ip_or_fqdn = {
  validate: validate$k
};

var validate$l = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value === other;
};

var is = {
  validate: validate$l
};

var validate$m = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value !== other;
};

var is_not = {
  validate: validate$m
};

/**
 * @param {Array|String} value
 * @param {Number} length
 * @param {Number} max
 */
var compare = function (value, length, max) {
  if (max === undefined) {
    return value.length === length;
  }

  // cast to number.
  max = Number(max);

  return value.length >= length && value.length <= max;
};

var validate$n = function (value, ref) {
  var length = ref[0];
  var max = ref[1]; if ( max === void 0 ) max = undefined;

  if (isNullOrUndefined(value)) {
    return false;
  }

  length = Number(length);
  if (typeof value === 'number') {
    value = String(value);
  }

  if (!value.length) {
    value = toArray(value);
  }

  return compare(value, length, max);
};

var length = {
  validate: validate$n
};

var validate$o = function (value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return length >= 0;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$o(val, [length]); });
  }

  return String(value).length <= length;
};

var max = {
  validate: validate$o
};

var validate$p = function (value, ref) {
  var max = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) { return validate$p(val, [max]); });
  }

  return Number(value) <= max;
};

var max_value = {
  validate: validate$p
};

var validate$q = function (files, mimes) {
  var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');
  return ensureArray(files).every(function (file) { return regex.test(file.type); });
};

var mimes = {
  validate: validate$q
};

var validate$r = function (value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$r(val, [length]); });
  }

  return String(value).length >= length;
};

var min = {
  validate: validate$r
};

var validate$s = function (value, ref) {
  var min = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) { return validate$s(val, [min]); });
  }

  return Number(value) >= min;
};

var min_value = {
  validate: validate$s
};

var ar = /^[٠١٢٣٤٥٦٧٨٩]+$/;
var en = /^[0-9]+$/;

var validate$t = function (value) {
  var testValue = function (val) {
    var strValue = String(val);

    return en.test(strValue) || ar.test(strValue);
  };

  if (Array.isArray(value)) {
    return value.every(testValue);
  }

  return testValue(value);
};

var numeric = {
  validate: validate$t
};

var validate$u = function (value, ref) {
  var expression = ref.expression;

  if (typeof expression === 'string') {
    expression = new RegExp(expression);
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$u(val, { expression: expression }); });
  }

  return expression.test(String(value));
};

var paramNames$c = ['expression'];

var regex = {
  validate: validate$u,
  paramNames: paramNames$c
};

var validate$v = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var invalidateFalse = ref[0]; if ( invalidateFalse === void 0 ) invalidateFalse = false;

  if (isNullOrUndefined(value) || isEmptyArray(value)) {
    return false;
  }

  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && invalidateFalse) {
    return false;
  }

  return !!String(value).trim().length;
};

var required = {
  validate: validate$v
};

var validate$w = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var otherFieldVal = ref[0];
  var possibleVals = ref.slice(1);

  var required = possibleVals.includes(String(otherFieldVal).trim());

  if (!required) {
    return {
      valid: true,
      data: {
        required: required
      }
    };
  }

  var invalid = (isEmptyArray(value) || [false, null, undefined].includes(value));

  invalid = invalid || !String(value).trim().length;

  return {
    valid: !invalid,
    data: {
      required: required
    }
  };
};

var options$5 = {
  hasTarget: true,
  computesRequired: true
};

var required_if = {
  validate: validate$w,
  options: options$5
};

var validate$x = function (files, ref) {
  var size = ref[0];

  if (isNaN(size)) {
    return false;
  }
  var nSize = Number(size) * 1024;
  return ensureArray(files).every(function (file) { return file.size <= nSize; });
};

var size = {
  validate: validate$x
};

var isURL_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = _interopRequireDefault(assertString_1);

var _isFQDN = _interopRequireDefault(isFQDN_1);

var _isIP = _interopRequireDefault(isIP_1);

var _merge = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);
  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isURL = unwrapExports(isURL_1);

var validate$y = function (value, options) {
  if ( options === void 0 ) options = {};

  if (isNullOrUndefined(value)) {
    value = '';
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) { return isURL(val, validatorOptions); });
  }

  return isURL(value, validatorOptions);
};

var url = {
  validate: validate$y
};

/* eslint-disable camelcase */

var Rules = /*#__PURE__*/Object.freeze({
  after: after,
  alpha_dash: alpha_dash,
  alpha_num: alpha_num,
  alpha_spaces: alpha_spaces,
  alpha: alpha$1,
  before: before,
  between: between,
  confirmed: confirmed,
  credit_card: credit_card,
  date_between: date_between,
  date_format: date_format,
  decimal: decimal,
  digits: digits,
  dimensions: dimensions,
  email: email,
  ext: ext,
  image: image,
  included: included,
  integer: integer,
  length: length,
  ip: ip,
  ip_or_fqdn: ip_or_fqdn,
  is_not: is_not,
  is: is,
  max: max,
  max_value: max_value,
  mimes: mimes,
  min: min,
  min_value: min_value,
  excluded: excluded,
  numeric: numeric,
  regex: regex,
  required: required,
  required_if: required_if,
  size: size,
  url: url
});

// 

var normalize = function (fields) {
  if (Array.isArray(fields)) {
    return fields.reduce(function (prev, curr) {
      if (includes(curr, '.')) {
        prev[curr.split('.')[1]] = curr;
      } else {
        prev[curr] = curr;
      }

      return prev;
    }, {});
  }

  return fields;
};

// Combines two flags using either AND or OR depending on the flag type.
var combine = function (lhs, rhs) {
  var mapper = {
    pristine: function (lhs, rhs) { return lhs && rhs; },
    dirty: function (lhs, rhs) { return lhs || rhs; },
    touched: function (lhs, rhs) { return lhs || rhs; },
    untouched: function (lhs, rhs) { return lhs && rhs; },
    valid: function (lhs, rhs) { return lhs && rhs; },
    invalid: function (lhs, rhs) { return lhs || rhs; },
    pending: function (lhs, rhs) { return lhs || rhs; },
    required: function (lhs, rhs) { return lhs || rhs; },
    validated: function (lhs, rhs) { return lhs && rhs; }
  };

  return Object.keys(mapper).reduce(function (flags, flag) {
    flags[flag] = mapper[flag](lhs[flag], rhs[flag]);

    return flags;
  }, {});
};

var mapScope = function (scope, deep) {
  if ( deep === void 0 ) deep = true;

  return Object.keys(scope).reduce(function (flags, field) {
    if (!flags) {
      flags = assign({}, scope[field]);
      return flags;
    }

    // scope.
    var isScope = field.indexOf('$') === 0;
    if (deep && isScope) {
      return combine(mapScope(scope[field]), flags);
    } else if (!deep && isScope) {
      return flags;
    }

    flags = combine(flags, scope[field]);

    return flags;
  }, null);
};

/**
 * Maps fields to computed functions.
 */
var mapFields = function (fields) {
  if (!fields) {
    return function () {
      return mapScope(this.$validator.flags);
    };
  }

  var normalized = normalize(fields);
  return Object.keys(normalized).reduce(function (prev, curr) {
    var field = normalized[curr];
    prev[curr] = function mappedField () {
      // if field exists
      if (this.$validator.flags[field]) {
        return this.$validator.flags[field];
      }

      // scopeless fields were selected.
      if (normalized[curr] === '*') {
        return mapScope(this.$validator.flags, false);
      }

      // if it has a scope defined
      var index = field.indexOf('.');
      if (index <= 0) {
        return {};
      }

      var ref = field.split('.');
      var scope = ref[0];
      var name = ref.slice(1);

      scope = this.$validator.flags[("$" + scope)];
      name = name.join('.');

      // an entire scope was selected: scope.*
      if (name === '*' && scope) {
        return mapScope(scope);
      }

      if (scope && scope[name]) {
        return scope[name];
      }

      return {};
    };

    return prev;
  }, {});
};

var $validator = null;

var PROVIDER_COUNTER = 0;

var ValidationProvider = {
  $__veeInject: false,
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1 () {
        if (!this.$vnode.context.$_veeObserver) {
          this.$vnode.context.$_veeObserver = createObserver();
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    vid: {
      type: [String, Number],
      default: function () {
        PROVIDER_COUNTER++;

        return ("_vee_" + PROVIDER_COUNTER);
      }
    },
    name: {
      type: String,
      default: null
    },
    mode: {
      type: [String, Function],
      default: function () {
        return getConfig().mode;
      }
    },
    events: {
      type: Array,
      validate: function () {
        /* istanbul ignore next */
        if (true) {
          warn('events prop and config will be deprecated in future version please use the interaction modes instead');
        }

        return true;
      },
      default: function () {
        var events = getConfig().events;
        if (typeof events === 'string') {
          return events.split('|');
        }

        return events;
      }
    },
    rules: {
      type: [Object, String],
      default: null
    },
    immediate: {
      type: Boolean,
      default: false
    },
    persist: {
      type: Boolean,
      default: false
    },
    bails: {
      type: Boolean,
      default: function () { return getConfig().fastExit; }
    },
    debounce: {
      type: Number,
      default: function () { return getConfig().delay || 0; }
    },
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rules: {
      deep: true,
      handler: function handler (val, oldVal) {
        this._needsValidation = !isEqual(val, oldVal);
      }
    }
  },
  data: function () { return ({
    messages: [],
    value: undefined,
    initialized: false,
    initialValue: undefined,
    flags: createFlags(),
    failedRules: {},
    forceRequired: false,
    isDeactivated: false,
    id: null
  }); },
  computed: {
    isValid: function isValid () {
      return this.flags.valid;
    },
    fieldDeps: function fieldDeps () {
      var this$1 = this;

      var rules = normalizeRules(this.rules);

      return Object.keys(rules).filter(RuleContainer.isTargetRule).map(function (rule) {
        var depName = rules[rule][0];
        watchCrossFieldDep(this$1, depName);

        return depName;
      });
    },
    normalizedEvents: function normalizedEvents () {
      var this$1 = this;

      var ref = computeModeSetting(this);
      var on = ref.on;

      return normalizeEvents(on || this.events || []).map(function (e) {
        if (e === 'input') {
          return this$1._inputEventName;
        }

        return e;
      });
    },
    isRequired: function isRequired () {
      var rules = normalizeRules(this.rules);
      var forceRequired = this.forceRequired;

      var isRequired = rules.required || forceRequired;
      this.flags.required = isRequired;

      return isRequired;
    },
    classes: function classes () {
      var this$1 = this;

      var names = getConfig().classNames;
      return Object.keys(this.flags).reduce(function (classes, flag) {
        var className = (names && names[flag]) || flag;
        if (isNullOrUndefined(this$1.flags[flag])) {
          return classes;
        }

        if (className) {
          classes[className] = this$1.flags[flag];
        }

        return classes;
      }, {});
    }
  },
  render: function render (h) {
    var this$1 = this;

    this.registerField();
    var ctx = createValidationCtx(this);

    // Gracefully handle non-existent scoped slots.
    var slot = this.$scopedSlots.default;
    /* istanbul ignore next */
    if (!isCallable(slot)) {
      if (true) {
        warn('ValidationProvider expects a scoped slot. Did you forget to add "v-slot" to your slot?');
      }

      return h(this.tag, this.$slots.default);
    }

    var nodes = slot(ctx);
    // Handle single-root slot.
    extractVNodes(nodes).forEach(function (input) {
      addListeners.call(this$1, input);
    });

    return this.slim ? createRenderless(h, nodes) : h(this.tag, nodes);
  },
  beforeDestroy: function beforeDestroy () {
    // cleanup reference.
    this.$_veeObserver.unsubscribe(this);
  },
  activated: function activated () {
    this.$_veeObserver.subscribe(this);
    this.isDeactivated = false;
  },
  deactivated: function deactivated () {
    this.$_veeObserver.unsubscribe(this);
    this.isDeactivated = true;
  },
  methods: {
    setFlags: function setFlags (flags) {
      var this$1 = this;

      Object.keys(flags).forEach(function (flag) {
        this$1.flags[flag] = flags[flag];
      });
    },
    syncValue: function syncValue (e) {
      var value = normalizeValue$1(e);
      this.value = value;
      this.flags.changed = this.initialValue !== value;
    },
    reset: function reset () {
      this.messages = [];
      this._pendingValidation = null;
      this.initialValue = this.value;
      var flags = createFlags();
      this.setFlags(flags);
    },
    validate: function validate () {
      var this$1 = this;
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      if (args.length > 0) {
        this.syncValue(args[0]);
      }

      return this.validateSilent().then(function (result) {
        this$1.applyResult(result);

        return result;
      });
    },
    validateSilent: function validateSilent () {
      var this$1 = this;

      this.setFlags({ pending: true });

      return $validator.verify(this.value, this.rules, {
        name: this.name,
        values: createValuesLookup(this),
        bails: this.bails
      }).then(function (result) {
        this$1.setFlags({ pending: false });
        if (!this$1.isRequired) {
          this$1.setFlags({ valid: result.valid, invalid: !result.valid });
        }

        return result;
      });
    },
    applyResult: function applyResult (ref) {
      var errors = ref.errors;
      var failedRules = ref.failedRules;

      this.messages = errors;
      this.failedRules = assign({}, failedRules);
      this.setFlags({
        valid: !errors.length,
        changed: this.value !== this.initialValue,
        invalid: !!errors.length,
        validated: true
      });
    },
    registerField: function registerField () {
      if (!$validator) {
        $validator = getValidator() || new Validator(null, { fastExit: getConfig().fastExit });
      }

      updateRenderingContextRefs(this);
    }
  }
};

function createValidationCtx (ctx) {
  return {
    errors: ctx.messages,
    flags: ctx.flags,
    classes: ctx.classes,
    valid: ctx.isValid,
    failedRules: ctx.failedRules,
    reset: function () { return ctx.reset(); },
    validate: function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      return ctx.validate.apply(ctx, args);
  },
    aria: {
      'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
      'aria-required': ctx.isRequired ? 'true' : 'false'
    }
  };
}

function normalizeValue$1 (value) {
  if (isEvent(value)) {
    return value.target.type === 'file' ? toArray(value.target.files) : value.target.value;
  }

  return value;
}

/**
 * Determines if a provider needs to run validation.
 */
function shouldValidate (ctx, model) {
  // when an immediate/initial validation is needed and wasn't done before.
  if (!ctx._ignoreImmediate && ctx.immediate) {
    return true;
  }

  // when the value changes for whatever reason.
  if (ctx.value !== model.value) {
    return true;
  }

  // when it needs validation due to props/cross-fields changes.
  if (ctx._needsValidation) {
    return true;
  }

  // when the initial value is undefined and the field wasn't rendered yet.
  if (!ctx.initialized && model.value === undefined) {
    return true;
  }

  return false;
}

function computeModeSetting (ctx) {
  var compute = isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode];

  return compute({
    errors: ctx.messages,
    value: ctx.value,
    flags: ctx.flags
  });
}

function onRenderUpdate (model) {
  if (!this.initialized) {
    this.initialValue = model.value;
  }

  var validateNow = shouldValidate(this, model);
  this._needsValidation = false;
  this.value = model.value;
  this._ignoreImmediate = true;

  if (!validateNow) {
    return;
  }

  this.validateSilent().then(this.immediate || this.flags.validated ? this.applyResult : function (x) { return x; });
}

// Creates the common handlers for a validatable context.
function createCommonHandlers (ctx) {
  var onInput = function (e) {
    ctx.syncValue(e); // track and keep the value updated.
    ctx.setFlags({ dirty: true, pristine: false });
  };

  // Blur event listener.
  var onBlur = function () {
    ctx.setFlags({ touched: true, untouched: false });
  };

  var onValidate = ctx.$veeHandler;
  var mode = computeModeSetting(ctx);

  // Handle debounce changes.
  if (!onValidate || ctx.$veeDebounce !== ctx.debounce) {
    onValidate = debounce(
      function () {
        ctx.$nextTick(function () {
          var pendingPromise = ctx.validateSilent();
          // avoids race conditions between successive validations.
          ctx._pendingValidation = pendingPromise;
          pendingPromise.then(function (result) {
            if (pendingPromise === ctx._pendingValidation) {
              ctx.applyResult(result);
              ctx._pendingValidation = null;
            }
          });
        });
      },
      mode.debounce || ctx.debounce
    );

    // Cache the handler so we don't create it each time.
    ctx.$veeHandler = onValidate;
    // cache the debounce value so we detect if it was changed.
    ctx.$veeDebounce = ctx.debounce;
  }

  return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
}

// Adds all plugin listeners to the vnode.
function addListeners (node) {
  var model = findModel(node);
  // cache the input eventName.
  this._inputEventName = this._inputEventName || getInputEventName(node, model);

  onRenderUpdate.call(this, model);

  var ref = createCommonHandlers(this);
  var onInput = ref.onInput;
  var onBlur = ref.onBlur;
  var onValidate = ref.onValidate;
  addVNodeListener(node, this._inputEventName, onInput);
  addVNodeListener(node, 'blur', onBlur);

  // add the validation listeners.
  this.normalizedEvents.forEach(function (evt) {
    addVNodeListener(node, evt, onValidate);
  });

  this.initialized = true;
}

function createValuesLookup (ctx) {
  var providers = ctx.$_veeObserver.refs;

  return ctx.fieldDeps.reduce(function (acc, depName) {
    if (!providers[depName]) {
      return acc;
    }

    acc[depName] = providers[depName].value;

    return acc;
  }, {});
}

function updateRenderingContextRefs (ctx) {
  // IDs should not be nullable.
  if (isNullOrUndefined(ctx.id) && ctx.id === ctx.vid) {
    ctx.id = PROVIDER_COUNTER;
    PROVIDER_COUNTER++;
  }

  var id = ctx.id;
  var vid = ctx.vid;
  // Nothing has changed.
  if (ctx.isDeactivated || (id === vid && ctx.$_veeObserver.refs[id])) {
    return;
  }

  // vid was changed.
  if (id !== vid && ctx.$_veeObserver.refs[id] === ctx) {
    ctx.$_veeObserver.unsubscribe({ vid: id });
  }

  ctx.$_veeObserver.subscribe(ctx);
  ctx.id = vid;
}

function createObserver () {
  return {
    refs: {},
    subscribe: function subscribe (ctx) {
      this.refs[ctx.vid] = ctx;
    },
    unsubscribe: function unsubscribe (ctx) {
      delete this.refs[ctx.vid];
    }
  };
}

function watchCrossFieldDep (ctx, depName, withHooks) {
  if ( withHooks === void 0 ) withHooks = true;

  var providers = ctx.$_veeObserver.refs;
  if (!ctx._veeWatchers) {
    ctx._veeWatchers = {};
  }

  if (!providers[depName] && withHooks) {
    return ctx.$once('hook:mounted', function () {
      watchCrossFieldDep(ctx, depName, false);
    });
  }

  if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
    ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
      if (ctx.flags.validated) {
        ctx._needsValidation = true;
        ctx.validate();
      }
    });
  }
}

var flagMergingStrategy = {
  pristine: 'every',
  dirty: 'some',
  touched: 'some',
  untouched: 'every',
  valid: 'every',
  invalid: 'some',
  pending: 'some',
  validated: 'every'
};

function mergeFlags (lhs, rhs, strategy) {
  var stratName = flagMergingStrategy[strategy];

  return [lhs, rhs][stratName](function (f) { return f; });
}

var OBSERVER_COUNTER = 0;

var ValidationObserver = {
  name: 'ValidationObserver',
  provide: function provide () {
    return {
      $_veeObserver: this
    };
  },
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1 () {
        if (!this.$vnode.context.$_veeObserver) {
          return null;
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  data: function () { return ({
    vid: ("obs_" + (OBSERVER_COUNTER++)),
    refs: {},
    observers: [],
    persistedStore: {}
  }); },
  computed: {
    ctx: function ctx () {
      var this$1 = this;

      var ctx = {
        errors: {},
        validate: function (arg) {
          var promise = this$1.validate(arg);

          return {
            then: function then (thenable) {
              return promise.then(function (success) {
                if (success && isCallable(thenable)) {
                  return Promise.resolve(thenable());
                }

                return Promise.resolve(success);
              });
            }
          };
        },
        reset: function () { return this$1.reset(); }
      };

      return values(this.refs).concat( Object.keys(this.persistedStore).map(function (key) {
          return {
            vid: key,
            flags: this$1.persistedStore[key].flags,
            messages: this$1.persistedStore[key].errors
          };
        }),
        this.observers ).reduce(function (acc, provider) {
        Object.keys(flagMergingStrategy).forEach(function (flag) {
          var flags = provider.flags || provider.ctx;
          if (!(flag in acc)) {
            acc[flag] = flags[flag];
            return;
          }

          acc[flag] = mergeFlags(acc[flag], flags[flag], flag);
        });

        acc.errors[provider.vid] = provider.messages || values(provider.ctx.errors).reduce(function (errs, obsErrors) {
          return errs.concat(obsErrors);
        }, []);

        return acc;
      }, ctx);
    }
  },
  created: function created () {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  activated: function activated () {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  deactivated: function deactivated () {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  beforeDestroy: function beforeDestroy () {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  render: function render (h) {
    var slots = this.$slots.default || this.$scopedSlots.default || [];
    if (isCallable(slots)) {
      slots = slots(this.ctx);
    }

    return this.slim ? createRenderless(h, slots) : h(this.tag, { on: this.$listeners, attrs: this.$attrs }, slots);
  },
  methods: {
    subscribe: function subscribe (subscriber, kind) {
      var obj;

      if ( kind === void 0 ) kind = 'provider';
      if (kind === 'observer') {
        this.observers.push(subscriber);
        return;
      }

      this.refs = Object.assign({}, this.refs, ( obj = {}, obj[subscriber.vid] = subscriber, obj ));
      if (subscriber.persist && this.persistedStore[subscriber.vid]) {
        this.restoreProviderState(subscriber);
      }
    },
    unsubscribe: function unsubscribe (ref, kind) {
      var vid = ref.vid;
      if ( kind === void 0 ) kind = 'provider';

      if (kind === 'provider') {
        this.removeProvider(vid);
      }

      var idx = findIndex(this.observers, function (o) { return o.vid === vid; });
      if (idx !== -1) {
        this.observers.splice(idx, 1);
      }
    },
    validate: function validate (ref) {
      if ( ref === void 0 ) ref = { silent: false };
      var silent = ref.silent;

      return Promise.all(values(this.refs).map(function (ref) { return ref[silent ? 'validateSilent' : 'validate']().then(function (r) { return r.valid; }); }).concat( this.observers.map(function (obs) { return obs.validate({ silent: silent }); })
      )).then(function (results) { return results.every(function (r) { return r; }); });
    },
    reset: function reset () {
      var this$1 = this;

      Object.keys(this.persistedStore).forEach(function (key) {
        this$1.$delete(this$1.persistedStore, key);
      });
      return values(this.refs).concat( this.observers).forEach(function (ref) { return ref.reset(); });
    },
    restoreProviderState: function restoreProviderState (provider) {
      var state = this.persistedStore[provider.vid];
      provider.setFlags(state.flags);
      provider.applyResult(state);
      this.$delete(this.persistedStore, provider.vid);
    },
    removeProvider: function removeProvider (vid) {
      var obj;

      var provider = this.refs[vid];
      // save it for the next time.
      if (provider && provider.persist) {
        /* istanbul ignore else */
        if (true) {
          if (vid.indexOf('_vee_') === 0) {
            warn('Please provide a `vid` prop when using `persist`, there might be unexpected issues otherwise.');
          }
        }

        this.persistedStore = assign({}, this.persistedStore, ( obj = {}, obj[vid] = {
            flags: provider.flags,
            errors: provider.messages,
            failedRules: provider.failedRules
          }, obj ));
      }

      this.$delete(this.refs, vid);
    },
  }
};

function withValidation (component, ctxToProps) {
  if ( ctxToProps === void 0 ) ctxToProps = null;

  var options = isCallable(component) ? component.options : component;
  options.$__veeInject = false;
  var hoc = {
    name: ((options.name || 'AnonymousHoc') + "WithValidation"),
    props: assign({}, ValidationProvider.props),
    data: ValidationProvider.data,
    computed: assign({}, ValidationProvider.computed),
    methods: assign({}, ValidationProvider.methods),
    $__veeInject: false,
    beforeDestroy: ValidationProvider.beforeDestroy,
    inject: ValidationProvider.inject
  };

  // Default ctx converts ctx props to component props.
  if (!ctxToProps) {
    ctxToProps = function (ctx) { return ctx; };
  }

  var eventName = (options.model && options.model.event) || 'input';

  hoc.render = function (h) {
    var obj;

    this.registerField();
    var vctx = createValidationCtx(this);
    var listeners = assign({}, this.$listeners);

    var model = findModel(this.$vnode);
    this._inputEventName = this._inputEventName || getInputEventName(this.$vnode, model);
    onRenderUpdate.call(this, model);

    var ref = createCommonHandlers(this);
    var onInput = ref.onInput;
    var onBlur = ref.onBlur;
    var onValidate = ref.onValidate;

    mergeVNodeListeners(listeners, eventName, onInput);
    mergeVNodeListeners(listeners, 'blur', onBlur);
    this.normalizedEvents.forEach(function (evt, idx) {
      mergeVNodeListeners(listeners, evt, onValidate);
    });

    // Props are any attrs not associated with ValidationProvider Plus the model prop.
    // WARNING: Accidental prop overwrite will probably happen.
    var ref$1 = findModelConfig(this.$vnode) || { prop: 'value' };
    var prop = ref$1.prop;
    var props = assign({}, this.$attrs, ( obj = {}, obj[prop] = model.value, obj ), ctxToProps(vctx));

    return h(options, {
      attrs: this.$attrs,
      props: props,
      on: listeners
    }, normalizeSlots(this.$slots, this.$vnode.context));
  };

  return hoc;
}

var version = '2.2.15';

Object.keys(Rules).forEach(function (rule) {
  Validator.extend(rule, Rules[rule].validate, assign({}, Rules[rule].options, { paramNames: Rules[rule].paramNames }));
});

// Merge the english messages.
Validator.localize({ en: locale });

var install = VeeValidate$1.install;

VeeValidate$1.version = version;
VeeValidate$1.mapFields = mapFields;
VeeValidate$1.ValidationProvider = ValidationProvider;
VeeValidate$1.ValidationObserver = ValidationObserver;
VeeValidate$1.withValidation = withValidation;

/* harmony default export */ __webpack_exports__["default"] = (VeeValidate$1);



/***/ }),
/* 687 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./~/vue-highcharts/src/constructors.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  Highcharts: 'chart',
  Highstock: 'stockChart',
  Highmaps: 'mapChart',
  HighchartsGantt: 'ganttChart',
});


/***/ }),
/* 688 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/vue-input-tag/dist/vueInputTag.common.js ***!
  \****************************************************/
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");
var getIteratorMethod = __webpack_require__("35a1");
var callWithSafeIterationClosing = __webpack_require__("9bdd");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2726":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("512f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("d4c64dc4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");
var bind = __webpack_require__("0366");
var html = __webpack_require__("1be4");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts && !fails(post)) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNames = __webpack_require__("241c").f;
var isRegExp = __webpack_require__("44e7");
var getFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var setInternalState = __webpack_require__("69f3").set;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var FORCED = DESCRIPTORS && isForced('RegExp', (!CORRECT_NEW || UNSUPPORTED_Y || fails(function () {
  re2[MATCH] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (!thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = getFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y && sticky) setInternalState(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys.length > index) proxy(keys[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "512f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vue-input-tag-wrapper{background-color:#fff;border:1px solid #ccc;overflow:hidden;padding-left:4px;padding-top:4px;cursor:text;text-align:left;-webkit-appearance:textfield;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.vue-input-tag-wrapper .input-tag{background-color:#cde69c;border-radius:2px;border:1px solid #a5d24a;color:#638421;display:inline-block;font-size:13px;font-weight:400;margin-bottom:4px;margin-right:4px;padding:3px}.vue-input-tag-wrapper .input-tag .remove{cursor:pointer;font-weight:700;color:#638421}.vue-input-tag-wrapper .input-tag .remove:hover{text-decoration:none}.vue-input-tag-wrapper .input-tag .remove:empty:before{content:\" x\"}.vue-input-tag-wrapper .new-tag{background:transparent;border:0;color:#777;font-size:13px;font-weight:400;margin-bottom:6px;margin-top:1px;outline:none;padding:4px;padding-left:0;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.vue-input-tag-wrapper.read-only{cursor:default}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8e26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputTag_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2726");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputTag_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputTag_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputTag_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "96cf":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toAbsoluteIndex = __webpack_require__("23cb");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var classof = __webpack_require__("c6b6");
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var IS_NODE = classof(process) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var isObject = __webpack_require__("861d");
var aFunction = __webpack_require__("1c0b");
var anInstance = __webpack_require__("19aa");
var classof = __webpack_require__("c6b6");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof(process) == 'process';
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"5b6c6fa5-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/InputTag.vue?vue&type=template&id=dc37c95a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-input-tag-wrapper",class:{
    'read-only': _vm.readOnly,
    'vue-input-tag-wrapper--active': _vm.isInputActive
  },on:{"click":function($event){return _vm.focusNewTag()}}},[_vm._l((_vm.innerTags),function(tag,index){return _c('span',{key:index,staticClass:"input-tag"},[_c('span',[_vm._v(_vm._s(tag))]),(!_vm.readOnly)?_c('a',{staticClass:"remove",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.remove(index)}}},[_vm._t("remove-icon")],2):_vm._e()])}),(!_vm.readOnly && !_vm.isLimit)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newTag),expression:"newTag"}],ref:"inputtag",staticClass:"new-tag",attrs:{"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":(_vm.newTag)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }$event.stopPropagation();return _vm.removeLastTag($event)},_vm.addNew],"blur":_vm.handleInputBlur,"focus":_vm.handleInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.newTag=$event.target.value}}}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/InputTag.vue?vue&type=template&id=dc37c95a&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/InputTag.vue?vue&type=script&lang=js&












/* eslint-disable */
var validators = {
  email: new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  url: new RegExp(/^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i),
  text: new RegExp(/^[a-zA-Z]+$/),
  digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  isodate: new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/)
};
/* eslint-enable */

/* harmony default export */ var InputTagvue_type_script_lang_js_ = ({
  name: "InputTag",
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    validate: {
      type: String | Function | Object,
      default: ""
    },
    addTagOnKeys: {
      type: Array,
      default: function _default() {
        return [13, // Return
        188, // Comma ','
        9 // Tab
        ];
      }
    },
    addTagOnBlur: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: -1
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    beforeAdding: {
      type: Function
    }
  },
  data: function data() {
    return {
      newTag: "",
      innerTags: _toConsumableArray(this.value),
      isInputActive: false
    };
  },
  computed: {
    isLimit: function isLimit() {
      return this.limit > 0 && Number(this.limit) === this.innerTags.length;
    }
  },
  watch: {
    value: function value() {
      this.innerTags = _toConsumableArray(this.value);
    }
  },
  methods: {
    focusNewTag: function focusNewTag() {
      if (this.readOnly || !this.$el.querySelector(".new-tag")) {
        return;
      }

      this.$el.querySelector(".new-tag").focus();
    },
    handleInputFocus: function handleInputFocus() {
      this.isInputActive = true;
    },
    handleInputBlur: function handleInputBlur(e) {
      this.isInputActive = false;
      this.addNew(e);
    },
    addNew: function addNew(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var keyShouldAddTag, typeIsNotBlur, tag, isValid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keyShouldAddTag = e ? _this.addTagOnKeys.indexOf(e.keyCode) !== -1 : true;
                typeIsNotBlur = e && e.type !== "blur";

                if (!(!keyShouldAddTag && (typeIsNotBlur || !_this.addTagOnBlur) || _this.isLimit)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                if (!_this.beforeAdding) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return _this.beforeAdding(_this.newTag);

              case 7:
                _context.t0 = _context.sent;
                _context.next = 11;
                break;

              case 10:
                _context.t0 = _this.newTag;

              case 11:
                tag = _context.t0;
                _context.next = 14;
                return _this.validateIfNeeded(tag);

              case 14:
                isValid = _context.sent;

                if (tag && isValid && (_this.allowDuplicates || _this.innerTags.indexOf(tag) === -1)) {
                  _this.innerTags.push(tag);

                  _this.newTag = "";

                  _this.tagChange();

                  e && e.preventDefault();
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    validateIfNeeded: function validateIfNeeded(tagValue) {
      if (this.validate === "" || this.validate === undefined) {
        return true;
      }

      if (typeof this.validate === "function") {
        return this.validate(tagValue);
      }

      if (typeof this.validate === "string" && Object.keys(validators).indexOf(this.validate) > -1) {
        return validators[this.validate].test(tagValue);
      }

      if (_typeof(this.validate) === "object" && this.validate.test !== undefined) {
        return this.validate.test(tagValue);
      }

      return true;
    },
    remove: function remove(index) {
      this.innerTags.splice(index, 1);
      this.tagChange();
    },
    removeLastTag: function removeLastTag() {
      if (this.newTag) {
        return;
      }

      this.innerTags.pop();
      this.tagChange();
    },
    tagChange: function tagChange() {
      this.$emit("update:tags", this.innerTags);
      this.$emit("input", this.innerTags);
    }
  }
});
// CONCATENATED MODULE: ./src/components/InputTag.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_InputTagvue_type_script_lang_js_ = (InputTagvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/InputTag.vue?vue&type=style&index=0&lang=css&
var InputTagvue_type_style_index_0_lang_css_ = __webpack_require__("8e26");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/InputTag.vue






/* normalize component */

var component = normalizeComponent(
  components_InputTagvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InputTag = (component.exports);
// CONCATENATED MODULE: ./src/components/index.js

/* harmony default export */ var components = (InputTag);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (components);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ })

/******/ });
//# sourceMappingURL=vueInputTag.common.js.map

/***/ }),
/* 689 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/vue-js-toggle-button/dist/index.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-js-toggle-button"] = factory();
	else
		root["vue-js-toggle-button"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(7),
  /* scopeId */
  "data-v-25adc6c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(3);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var DEFAULT_COLOR_CHECKED = '#75c791';
var DEFAULT_COLOR_UNCHECKED = '#bfcbd9';
var DEFAULT_LABEL_CHECKED = 'on';
var DEFAULT_LABEL_UNCHECKED = 'off';
var DEFAULT_SWITCH_COLOR = '#fff';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String
    },
    sync: {
      type: Boolean,
      default: false
    },
    speed: {
      type: Number,
      default: 300
    },
    color: {
      type: [String, Object],
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isString */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'checked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'unchecked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'disabled');
      }
    },
    switchColor: {
      type: [String, Object],
      validator: function validator(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isString */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'checked') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* has */])(value, 'unchecked');
      }
    },
    cssColors: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
      }
    },
    height: {
      type: Number,
      default: 22
    },
    width: {
      type: Number,
      default: 50
    },
    margin: {
      type: Number,
      default: 3
    },
    fontSize: {
      type: Number
    }
  },
  computed: {
    className: function className() {
      var toggled = this.toggled,
          disabled = this.disabled;


      return ['vue-js-switch', {
        toggled: toggled,
        disabled: disabled
      }];
    },
    coreStyle: function coreStyle() {
      return {
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.width),
        height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.height),
        backgroundColor: this.cssColors ? null : this.disabled ? this.colorDisabled : this.colorCurrent,
        borderRadius: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(Math.round(this.height / 2))
      };
    },
    buttonRadius: function buttonRadius() {
      return this.height - this.margin * 2;
    },
    distance: function distance() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.width - this.height + this.margin);
    },
    buttonStyle: function buttonStyle() {
      var transition = 'transform ' + this.speed + 'ms';
      var margin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.margin);

      var transform = this.toggled ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* translate3d */])(this.distance, margin) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* translate3d */])(margin, margin);

      var background = this.switchColor ? this.switchColorCurrent : null;

      return {
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.buttonRadius),
        height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.buttonRadius),
        transition: transition,
        transform: transform,
        background: background
      };
    },
    labelStyle: function labelStyle() {
      return {
        lineHeight: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.height),
        fontSize: this.fontSize ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* px */])(this.fontSize) : null
      };
    },
    colorChecked: function colorChecked() {
      var color = this.color;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* isObject */])(color)) {
        return color || DEFAULT_COLOR_CHECKED;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(color, 'checked', DEFAULT_COLOR_CHECKED);
    },
    colorUnchecked: function colorUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.color, 'unchecked', DEFAULT_COLOR_UNCHECKED);
    },
    colorDisabled: function colorDisabled() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.color, 'disabled', this.colorCurrent);
    },
    colorCurrent: function colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },
    labelChecked: function labelChecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.labels, 'checked', DEFAULT_LABEL_CHECKED);
    },
    labelUnchecked: function labelUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.labels, 'unchecked', DEFAULT_LABEL_UNCHECKED);
    },
    switchColorChecked: function switchColorChecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.switchColor, 'checked', DEFAULT_SWITCH_COLOR);
    },
    switchColorUnchecked: function switchColorUnchecked() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* get */])(this.switchColor, 'unchecked', DEFAULT_SWITCH_COLOR);
    },
    switchColorCurrent: function switchColorCurrent() {
      var switchColor = this.switchColor;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* isObject */])(this.switchColor)) {
        return this.switchColor || DEFAULT_SWITCH_COLOR;
      }

      return this.toggled ? this.switchColorChecked : this.switchColorUnchecked;
    }
  },
  watch: {
    value: function value(_value) {
      if (this.sync) {
        this.toggled = !!_value;
      }
    }
  },
  data: function data() {
    return {
      toggled: !!this.value
    };
  },

  methods: {
    toggle: function toggle(event) {
      var toggled = !this.toggled;

      if (!this.sync) {
        this.toggled = toggled;
      }

      this.$emit('input', toggled);
      this.$emit('change', {
        value: toggled,
        tag: this.tag,
        srcEvent: event
      });
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Button_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a; });


var installed = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    if (installed) {
      return;
    }

    Vue.component('ToggleButton', __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a);
    installed = true;
  }
});



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isString; });
/* unused harmony export isBoolean */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return translate3d; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isString = function isString(value) {
  return typeof value === 'string';
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var isObject = function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
};

var has = function has(object, key) {
  return isObject(object) && object.hasOwnProperty(key);
};

var get = function get(object, key, defaultValue) {
  return has(object, key) ? object[key] : defaultValue;
};

var px = function px(value) {
  return value + 'px';
};

var translate3d = function translate3d(x, y) {
  var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0px';

  return 'translate3d(' + x + ', ' + y + ', ' + z + ')';
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".vue-js-switch[data-v-25adc6c0]{display:inline-block;position:relative;vertical-align:middle;user-select:none;font-size:10px;cursor:pointer}.vue-js-switch .v-switch-input[data-v-25adc6c0]{opacity:0;position:absolute;width:1px;height:1px}.vue-js-switch .v-switch-label[data-v-25adc6c0]{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.vue-js-switch .v-switch-label.v-left[data-v-25adc6c0]{left:10px}.vue-js-switch .v-switch-label.v-right[data-v-25adc6c0]{right:10px}.vue-js-switch .v-switch-core[data-v-25adc6c0]{display:block;position:relative;box-sizing:border-box;outline:0;margin:0;transition:border-color .3s,background-color .3s;user-select:none}.vue-js-switch .v-switch-core .v-switch-button[data-v-25adc6c0]{display:block;position:absolute;overflow:hidden;top:0;left:0;border-radius:100%;background-color:#fff;z-index:2}.vue-js-switch.disabled[data-v-25adc6c0]{pointer-events:none;opacity:.6}", ""]);

// exports


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.className
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  }, [_c('div', {
    staticClass: "v-switch-button",
    style: (_vm.buttonStyle)
  })]), _vm._v(" "), (_vm.labels) ? [(_vm.toggled) ? _c('span', {
    staticClass: "v-switch-label v-left",
    style: (_vm.labelStyle)
  }, [_vm._t("checked", [
    [_vm._v(_vm._s(_vm.labelChecked))]
  ])], 2) : _c('span', {
    staticClass: "v-switch-label v-right",
    style: (_vm.labelStyle)
  }, [_vm._t("unchecked", [
    [_vm._v(_vm._s(_vm.labelUnchecked))]
  ])], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2283861f", content, true);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(10)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 690 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************!*\
  !*** ./client/components/modals/gridDetailsModal/tabAllotment/TabAllotment.vue ***!
  \*********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4140c414","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabAllotment.vue */ 1506)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./TabAllotment.vue */ 836),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4140c414"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabAllotment.pug */ 1404),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/gridDetailsModal/tabAllotment/TabAllotment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabAllotment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4140c414", Component.options)
  } else {
    hotAPI.reload("data-v-4140c414", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 691 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/components/registration/attributesSet/TreeViewAtt.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2df64858","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TreeViewAtt.vue */ 1498)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TreeViewAtt.vue */ 850),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/attributesSet/TreeViewAtt.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2df64858", Component.options)
  } else {
    hotAPI.reload("data-v-2df64858", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 692 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./client/components/registration/categories/TreeviewCategories.vue ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4dcb5a70","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TreeviewCategories.vue */ 1514)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TreeviewCategories.vue */ 852),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/categories/TreeviewCategories.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4dcb5a70", Component.options)
  } else {
    hotAPI.reload("data-v-4dcb5a70", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 693 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./client/components/registration/conciliationPlan/TreeViewPlans.vue ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-c76a377a","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TreeViewPlans.vue */ 1552)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TreeViewPlans.vue */ 853),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/conciliationPlan/TreeViewPlans.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c76a377a", Component.options)
  } else {
    hotAPI.reload("data-v-c76a377a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 694 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./client/components/treeViewHistoric/TreeviewHistoric.vue ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-292a2a0b","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./TreeviewHistoric.vue */ 1493)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./TreeviewHistoric.vue */ 875),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/treeViewHistoric/TreeviewHistoric.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-292a2a0b", Component.options)
  } else {
    hotAPI.reload("data-v-292a2a0b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 695 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtColumnsDropdown.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLColumnsDropdown = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLColumnsDropdown */ 1604));

var _dropdownWrapper = _interopRequireDefault(__webpack_require__(/*! ./dropdown-wrapper */ 1601));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtColumnsDropdown',
  components: {
    RLColumnsDropdown: _RLColumnsDropdown["default"]
  },
  render: function render(h) {
    return h("r-l-columns-dropdown", {
      scopedSlots: {
        "default": function _default(props) {
          if (props.override) {
            return h(props.override, {
              attrs: {
                props: props
              }
            });
          }

          var content;
          var cols = props.origColumns.map(function (column) {
            content = h("a", {
              "class": props.theme.dropdown.item,
              attrs: {
                href: "#"
              },
              on: {
                "click": function click() {
                  return props.toggleColumn(column);
                }
              }
            }, [h("input", {
              attrs: {
                type: "checkbox",
                disabled: props.onlyColumn(column)
              },
              domProps: {
                "value": column,
                "checked": props.columns.includes(column)
              }
            }), props.getHeading(column)]);
            return props.theme.framework === 'bulma' ? content : h("li", [content]);
          });
          return h("div", {
            "class": "VueTables__columns-dropdown"
          }, [h("button", {
            attrs: {
              type: "button"
            },
            "class": "".concat(props.theme.button, " ").concat(props.theme.dropdown.trigger),
            on: {
              "click": props.toggleColumnsDropdown
            }
          }, [props.display('columns'), h("span", {
            "class": "".concat(props.theme.icon, " ").concat(props.theme.small)
          }, [h("i", {
            "class": props.theme.dropdown.caret
          })])]), (0, _dropdownWrapper["default"])(h, props.theme.dropdown, cols, props.displayColumnsDropdown)]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 696 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtDropdownPagination.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLDropdownPagination = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLDropdownPagination */ 1606));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VTDropdownPagination',
  components: {
    RLDropdownPagination: _RLDropdownPagination["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-dropdown-pagination", {
      scopedSlots: {
        "default": function _default(props) {
          var id = "VueTables__dropdown-pagination_" + props.name;
          var pages = [];

          for (var pag = 1; pag <= props.totalPages; pag++) {
            pages.push(h("option", {
              domProps: {
                "value": pag
              }
            }, [pag]));
          }

          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("select", {
            "class": "".concat(props.theme.select, " dropdown-pagination"),
            attrs: {
              name: "page",
              id: id
            },
            ref: "page",
            domProps: {
              "value": props.page
            },
            on: {
              "change": function change(e) {
                return props.setPage(e.target.value);
              }
            }
          }, [pages]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 697 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtGenericFilter.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLGenericFilter = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLGenericFilter */ 1608));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtGenericFilter',
  components: {
    RLGenericFilter: _RLGenericFilter["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-generic-filter", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__search-field"
          }, [h("label", {
            attrs: {
              "for": "VueTables__search_".concat(props.id)
            },
            "class": props.theme.label
          }, [props.display("filter")]), h("input", {
            "class": "VueTables__search__input ".concat(props.theme.input, " ").concat(props.theme.small),
            ref: "filter",
            attrs: {
              type: "text",
              placeholder: props.display('filterPlaceholder'),
              id: "VueTables__search_".concat(props.id),
              autocomplete: "off"
            },
            on: {
              "keyup": props.search(props.opts.debounce)
            }
          })]);
        }
      }
    });
  },
  methods: {
    focus: function focus() {
      this.$refs.filter.focus();
    },
    blur: function blur() {
      this.$refs.filter.blur();
    }
  }
};
exports["default"] = _default2;

/***/ }),
/* 698 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtPagination.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLPagination = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLPagination */ 1613));

var _vuePagination = _interopRequireDefault(__webpack_require__(/*! vue-pagination-2 */ 1569));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtPagination',
  components: {
    RLPagination: _RLPagination["default"],
    Pagination: _vuePagination["default"]
  },
  render: function render(h) {
    return h("r-l-pagination", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("pagination", {
            attrs: {
              options: props.optionsObj,
              records: props.records,
              "per-page": props.perPage,
              value: props.page
            },
            on: {
              "input": function input(page) {
                return props.setPage(page);
              }
            }
          });
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 699 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtPerPageSelector.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLPerPageSelector = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLPerPageSelector */ 1614));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtPerPageSelector',
  components: {
    RLPerPageSelector: _RLPerPageSelector["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-per-page-selector", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__limit-field"
          }, [h("label", {
            "class": props.labelClass,
            attrs: {
              "for": "VueTables__limit_".concat(props.id)
            }
          }, [props.display('limit')]), h("select", {
            attrs: {
              id: props.selectAttrs.id
            },
            "class": props.selectAttrs["class"],
            on: {
              "change": props.selectEvents.change
            }
          }, [props.perPageValues.map(function (val) {
            return h("option", {
              domProps: {
                "value": val,
                "selected": val === props.selectAttrs.value
              }
            }, [val]);
          })])]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 700 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtTable.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTable = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLTable */ 1616));

var _VtTableHead = _interopRequireDefault(__webpack_require__(/*! ./VtTableHead */ 1597));

var _VtTableBody = _interopRequireDefault(__webpack_require__(/*! ./VtTableBody */ 1595));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTable',
  components: {
    RLTable: _RLTable["default"],
    VtTableHead: _VtTableHead["default"],
    VtTableBody: _VtTableBody["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table", {
      scopedSlots: {
        "default": function _default(props) {
          var caption = props.caption ? h("caption", [props.caption]) : '';
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("table", {
            "class": props.tableAttrs["class"],
            attrs: {
              summary: props.tableAttrs.summary
            }
          }, [caption, h("vt-table-head"), props.slots.beforeBody, h("vt-table-body", {
            ref: "vt_table_body"
          }), props.slots.afterBody]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 701 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLDataTable.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.$scopedSlots["default"]({
    source: this.source,
    theme: this.theme,
    opts: this.opts,
    perPageValues: this.perPageValues,
    totalPages: this.totalPages,
    slots: this.$parent.$slots,
    override: this.componentsOverride.dataTable
  });
};

/***/ }),
/* 702 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/total-pages.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return Math.ceil(this.count / this.limit);
};

/***/ }),
/* 703 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./~/vue-tables-2/compiled/helpers/is-valid-moment-object.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (val) {
  return val && typeof val.isValid == 'function' && val.isValid();
};

/***/ }),
/* 704 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/vue-tables-2/compiled/helpers/resizeable-columns.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (table, hasChildRow, isChildRowTogglerFirst, resizeableColumns) {
  var row = table.getElementsByTagName("tr")[0],
      cols = row ? Array.from(row.children) : undefined;
  if (!cols) return;

  if (_typeof(resizeableColumns) === 'object') {
    cols = cols.filter(function (col) {
      return resizeableColumns.includes(col.id.split('--')[1]);
    });
  }

  table.style.overflow = "hidden";
  var tableHeight = table.offsetHeight;
  var i = hasChildRow && isChildRowTogglerFirst ? 1 : 0;
  var till = hasChildRow && !isChildRowTogglerFirst ? cols.length - 2 : cols.length;

  for (; i < till; i++) {
    var div = createDiv(tableHeight);
    div.className = "resize-handle";
    cols[i].appendChild(div);
    cols[i].style.position = "relative";
    setListeners(div);
  }

  function setListeners(div) {
    var pageX, curCol, nxtCol, curColWidth, nxtColWidth;
    div.addEventListener("mousedown", function (e) {
      e.preventDefault();
      e.stopPropagation();
      curCol = e.target.parentElement;
      nxtCol = curCol.nextElementSibling;
      pageX = e.pageX;
      var padding = paddingDiff(curCol);
      curColWidth = curCol.offsetWidth - padding;
      if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding;
    }); // div.addEventListener("mouseover", function(e) {
    //   e.target.style.borderRight = "2px solid #0000ff";
    // });

    div.addEventListener("mouseout", function (e) {
      e.target.style.borderRight = "";
    });
    document.addEventListener("mousemove", function (e) {
      if (curCol) {
        var diffX = e.pageX - pageX;
        if (nxtCol) nxtCol.style.width = nxtColWidth - diffX + "px";
        curCol.style.width = curColWidth + diffX + "px";
      }
    });
    document.addEventListener("mouseup", function (e) {
      if (e.target.nodeName === 'INPUT') return; // Commented out due to #968. Monitor.
      // e.stopPropagation();

      curCol = undefined;
      nxtCol = undefined;
      pageX = undefined;
      nxtColWidth = undefined;
      curColWidth = undefined;
    });
  }

  function createDiv(height) {
    var div = document.createElement("div");
    div.style.top = 0;
    div.style.right = 0;
    div.style.width = "5px";
    div.style.position = "absolute";
    div.style.cursor = "col-resize";
    div.style.userSelect = "none";
    div.style.height = height + "px";
    return div;
  }

  function paddingDiff(col) {
    if (getStyleVal(col, "box-sizing") == "border-box") {
      return 0;
    }

    var padLeft = getStyleVal(col, "padding-left");
    var padRight = getStyleVal(col, "padding-right");
    return parseInt(padLeft) + parseInt(padRight);
  }

  function getStyleVal(elm, css) {
    return window.getComputedStyle(elm, null).getPropertyValue(css);
  }
};

/***/ }),
/* 705 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/server-search.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (e, dateEvent) {
  // we need to handle the store this.query to make sure we're not mutating outside of it
  var query = this.vuex ? JSON.parse(JSON.stringify(this.query)) : this.query; // in case we pass an object manually (mostly used for init-date-filters should refactor

  if (Object.prototype.toString.call(e).slice(8, -1) == 'Object') {
    query = this.vuex ? JSON.parse(JSON.stringify(e)) : e;
    if (!this.vuex) this.query = query;
    var name = dateEvent.target.name;
    var value = dateEvent.target.value;

    if (name) {
      this.dispatch('filter', {
        name: name,
        value: value
      });
      this.dispatch("filter::".concat(name), value);
    } else {
      this.dispatch('filter', value);
    }

    this.updateState('query', query);
  } else if (e) {
    var _name = this.getName(e.target.name);

    var _value = e.target.value;

    if (_name) {
      query[_name] = _value;
    } else {
      query = _value;
    }

    if (!this.vuex) this.query = query;

    if (_name) {
      this.dispatch('filter', {
        name: _name,
        value: _value
      });
      this.dispatch("filter::".concat(_name), _value);
    } else {
      this.dispatch('filter', _value);
    }

    this.updateState('query', query);
  }

  return search(this, query);
};

function search(that, query) {
  if (that.vuex) {
    that.commit('SET_FILTER', query);
  } else {
    that.page = 1;
    that.updateState('page', 1);
    that.getData();
  }
}

/***/ }),
/* 706 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-tables-2/compiled/mixins/created.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var is_empty = __webpack_require__(/*! ../helpers/is-empty */ 1644);

var registerVuexModule = __webpack_require__(/*! ../state/register-module */ 1722);

module.exports = function (self) {
  if (self.vuex) {
    registerVuexModule(self);
  } else {
    self.limit = self.opts.perPage;
  }

  if (is_empty(self.opts.columnsDisplay) || typeof window === 'undefined') return;
  self.columnsDisplay = getColumnsDisplay(self.opts.columnsDisplay);
  window.addEventListener('resize', function () {
    self.windowWidth = window.innerWidth;
  }.bind(self));
};

function getColumnsDisplay(columnsDisplay) {
  var res = {};
  var range;
  var device;
  var operator;

  for (var column in columnsDisplay) {
    operator = getOperator(columnsDisplay[column]);

    try {
      device = getDevice(columnsDisplay[column]);
      range = getRange(device, operator);
      res[column] = range.concat([operator]);
    } catch (err) {
      console.warn('Unknown device ' + device);
    }
  }

  return res;
}

function getRange(device, operator) {
  var devices = {
    desktopHuge: [1920, null],
    desktopLarge: [1280, 1920],
    desktop: [1024, 1280],
    tablet: [480, 1024],
    mobile: [0, 480],
    tabletL: [768, 1024],
    tabletP: [480, 768],
    mobileL: [320, 480],
    mobileP: [0, 320]
  };

  switch (operator) {
    case 'min':
      return [devices[device][0], null];

    case 'max':
      return [0, devices[device][1]];

    default:
      return devices[device];
  }
}

function getOperator(val) {
  var pieces = val.split('_');
  if (['not', 'min', 'max'].indexOf(pieces[0]) > -1) return pieces[0];
  return false;
}

function getDevice(val) {
  var pieces = val.split('_');
  return pieces.length > 1 ? pieces[1] : pieces[0];
}

/***/ }),
/* 707 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/vue-tables-2/compiled/mixins/data.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    id: makeId(),
    allFilteredData: [],
    openChildRows: [],
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
    userMultiSorting: {},
    editing: []
  };
};

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

/***/ }),
/* 708 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-tables-2/compiled/mixins/provide.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  return {
    count: function count() {
      return _this.count;
    },
    rowWasClicked: this.rowWasClicked,
    render: this.render,
    opts: function opts() {
      return _this.opts;
    },
    limit: function limit() {
      return _this.limit;
    },
    setLimit: this.setLimit,
    perPageValues: function perPageValues() {
      return _this.perPageValues;
    },
    page: function page() {
      return _this.page;
    },
    id: this.id,
    theme: this.theme,
    display: this.display,
    origColumns: this.columns,
    allColumns: function allColumns() {
      return _this.allColumns;
    },
    sortableClass: this.sortableClass,
    getHeadingTooltip: this.getHeadingTooltip,
    getHeading: this.getHeading,
    sortable: this.sortable,
    sortableChevronClass: this.sortableChevronClass,
    orderByColumn: this.orderByColumn,
    filteredData: function filteredData() {
      return _this.filteredData;
    },
    tableData: function tableData() {
      return _this.tableData;
    },
    source: this.source,
    colspan: function colspan() {
      return _this.colspan;
    },
    setEditingCell: this._setEditingCell,
    revertValue: this._revertValue,
    updateValue: this._updateValue,
    editing: function editing() {
      return _this.editing;
    },
    hasChildRow: function hasChildRow() {
      return _this.hasChildRow;
    },
    getChildRowTemplate: this._getChildRowTemplate,
    openChildRows: function openChildRows() {
      return _this.openChildRows;
    },
    vuex: this.vuex,
    name: this.name,
    setPage: this.setPage,
    totalPages: function totalPages() {
      return _this.totalPages;
    },
    query: function query() {
      return _this.query;
    },
    filterable: this.filterable,
    filterType: this._filterType,
    columnClass: this.columnClass,
    search: this._search,
    getColumnName: this._getColumnName,
    onlyColumn: this._onlyColumn,
    toggleColumn: this.toggleColumn,
    toggleColumnsDropdown: this._toggleColumnsDropdown,
    displayColumnsDropdown: function displayColumnsDropdown() {
      return _this.displayColumnsDropdown;
    },
    childRowTogglerClass: this.childRowTogglerClass,
    toggleChildRow: this.toggleChildRow,
    componentsOverride: this.componentsOverride,
    getValue: this._getValue,
    cellClasses: this._cellClasses,
    toggleGroup: this.toggleGroup,
    groupToggleIcon: this.groupToggleIcon,
    getGroupSlot: this.getGroupSlot,
    toggleGroupDirection: this._toggleGroupDirection,
    collapsedGroups: function collapsedGroups() {
      return _this.collapsedGroups;
    },
    userMultiSorting: function userMultiSorting() {
      return _this.userMultiSorting;
    },
    hasMultiSort: this.hasMultiSort,
    orderBy: function orderBy() {
      return _this.orderBy;
    },
    isListFilter: this.isListFilter,
    optionText: this.optionText,
    dateFormat: this.dateFormat,
    formatDate: this.formatDate,
    tabIndex: function tabIndex() {
      return _this.tabIndex;
    },
    loading: function loading() {
      return _this.loading;
    },
    initialRequestSent: function initialRequestSent() {
      return _this.initialRequestSent;
    }
  };
};

/***/ }),
/* 709 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/vue-tables-2/compiled/state/data.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(useVuex, source) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var data = {
    vuex: true,
    activeState: false,
    userColumnsDisplay: [],
    userControlsColumns: false,
    displayColumnsDropdown: false,
    collapsedGroups: []
  };
  if (useVuex) return data;
  data = (0, _merge["default"])(data, {
    vuex: false,
    count: 0,
    customQueries: {},
    query: null,
    page: page,
    limit: 10,
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
    orderBy: {
      column: false,
      ascending: true
    }
  });
  if (source == 'server') data.data = [];
  return data;
}

/***/ }),
/* 710 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/vue-tables-2/compiled/state/normal.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    computed: {
      Columns: function Columns() {
        return this.columns;
      }
    }
  };
}

/***/ }),
/* 711 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/vue-tables-2/compiled/state/vuex.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _default(source) {
  var extra = source == 'server' ? serverExtra() : clientExtra();
  return _merge["default"].recursive(true, {
    props: {
      name: {
        type: String,
        required: true
      }
    },
    computed: {
      state: function state() {
        return this.$store.state[this.name] ? this.$store.state[this.name] : {};
      },
      Page: function Page() {
        return this.state.page;
      },
      count: function count() {
        return this.state.count;
      },
      Columns: function Columns() {
        return this.state.columns ? this.state.columns : [];
      },
      tableData: function tableData() {
        return this.state.data ? this.state.data : [];
      },
      page: function page() {
        return this.state.page;
      },
      limit: function limit() {
        return this.state.limit;
      },
      customQueries: function customQueries() {
        return this.state.customQueries;
      },
      query: function query() {
        return this.state.query;
      },
      orderBy: function orderBy() {
        return {
          column: this.state.sortBy,
          ascending: this.state.ascending
        };
      }
    },
    methods: {
      commit: function commit(action, payload) {
        return this.$store.commit("".concat(this.name, "/").concat(action), payload);
      },
      orderByColumn: function orderByColumn(column, ev) {
        if (!this.sortable(column)) return;

        if (ev.shiftKey && this.orderBy.column && this.hasMultiSort) {
          this.setUserMultiSort(column);
        } else {
          var ascending = this.orderBy.column === column ? !this.orderBy.ascending : this._initialOrderAscending(column);
          var orderBy = {
            column: column,
            ascending: ascending
          };
          this.updateState('orderBy', orderBy);
          this.commit('SORT', orderBy);
          this.dispatch('sorted', orderBy);
        }
      },
      setLimit: function setLimit(e) {
        var limit = _typeof(e) === 'object' ? parseInt(e.target.value) : e;
        this.updateState('perPage', limit);
        this.commit("SET_LIMIT", limit);
        this.dispatch("limit", limit);
      },
      setOrder: function setOrder(column, ascending) {
        this.updateState('orderBy', {
          column: column,
          ascending: ascending
        });
        this.commit('SORT', {
          column: column,
          ascending: ascending
        });
      },
      setPage: function setPage(page) {
        this.dispatch('pagination', page);
        this.commit("PAGINATE", page);
      }
    }
  }, extra);
}

function serverExtra() {
  return {
    methods: {
      setData: function setData(data) {
        this.commit('SET_DATA', data);
        setTimeout(function () {
          this.dispatch('loaded', data);
        }.bind(this), 0);
      },
      setRequestParams: function setRequestParams() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var data = this.convertParams(params);

        if (typeof data.query !== 'undefined') {
          this._setFiltersDOM(data.query);
        }

        this.commit('SET_STATE', data);

        if (sendRequest) {
          this.getData();
        }
      },
      convertParams: function convertParams(params) {
        if (params.order) {
          params.orderBy = params.order;
          delete params.order;
        }

        if (typeof params.filters !== 'undefined') {
          params.query = params.filters;
          delete params.filters;
        }

        return params;
      }
    }
  };
}

function clientExtra() {
  return {};
}

/***/ }),
/* 712 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./~/vue-tables-2/compiled/table.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var methods = __webpack_require__(/*! ./mixins/methods */ 1720);

var computed = __webpack_require__(/*! ./mixins/computed */ 1719);

var beforeDestroy = __webpack_require__(/*! ./mixins/before-destroy */ 1718);

function _default() {
  return {
    methods: methods,
    computed: computed,
    beforeDestroy: beforeDestroy
  };
}

/***/ }),
/* 713 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/vue-tables-2/compiled/themes/bootstrap3.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    framework: 'bootstrap3',
    table: 'table table-striped table-bordered table-hover',
    td: '',
    row: 'row',
    column: 'col-md-12',
    label: '',
    input: 'form-control',
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: 'pull-right',
    left: 'pull-left',
    center: 'text-center',
    contentCenter: '',
    small: '',
    nomargin: '',
    groupTr: 'info',
    button: 'btn btn-secondary',
    icon: '',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: '',
      caret: 'caret'
    },
    pagination: {
      nav: 'text-center',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item',
      link: 'page-link',
      next: '',
      prev: '',
      active: 'active',
      disabled: 'disabled'
    }
  };
};

/***/ }),
/* 714 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/vue-tables-2/compiled/themes/bootstrap4.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    framework: 'bootstrap4',
    td: '',
    table: 'table table-striped table-bordered table-hover',
    row: 'row',
    column: 'col-md-12',
    label: '',
    input: 'form-control',
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: 'float-right',
    left: 'float-left',
    center: 'text-center',
    contentCenter: 'justify-content-center',
    nomargin: 'm-0',
    groupTr: 'table-info',
    small: '',
    button: 'btn btn-secondary',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: 'dropdown-item',
      caret: 'caret'
    },
    pagination: {
      nav: 'text-center',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item',
      link: 'page-link',
      next: '',
      prev: '',
      active: 'active',
      disabled: 'disabled',
      icon: ''
    }
  };
};

/***/ }),
/* 715 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/vue-tables-2/compiled/themes/bulma.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    framework: 'bulma',
    table: 'table is-bordered is-striped is-hoverable is-fullwidth',
    row: 'columns',
    td: '',
    column: 'column is-12',
    label: 'label',
    input: 'input',
    select: 'select',
    field: 'field',
    inline: 'is-horizontal',
    right: 'is-pulled-right',
    left: 'is-pulled-left',
    center: 'has-text-centered',
    contentCenter: 'is-centered',
    icon: 'icon',
    small: 'is-small',
    nomargin: 'marginless',
    button: 'button',
    groupTr: 'is-selected',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-trigger',
      menu: 'dropdown-menu',
      content: 'dropdown-content',
      item: 'dropdown-item',
      caret: 'fa fa-angle-down'
    },
    pagination: {
      nav: 'has-text-centered',
      count: '',
      wrapper: 'pagination',
      list: 'pagination-list',
      item: '',
      link: 'pagination-link',
      next: '',
      prev: '',
      active: 'is-current',
      disabled: ''
    }
  };
};

/***/ }),
/* 716 */
/* no static exports found */
/* all exports used */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(/*! ./app */ 743);

__webpack_require__(/*! smoothscroll-polyfill */ 1149).polyfill();
window.$ = window.jQuery = __webpack_require__(/*! jquery */ 16);

if (false) {
  require('./pwa');
}

_app.app.$mount('#app');

/***/ }),
/* 717 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./client/template/pages/js/pages.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 137);

var _typeof3 = _interopRequireDefault(_typeof2);

var _store = __webpack_require__(/*! ../../../store */ 105);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function ($) {
    'use strict';

    var Pages = function Pages() {
        this.VERSION = "2.2.0";
        this.AUTHOR = "Revox";
        this.SUPPORT = "support@revox.io";

        this.pageScrollElement = 'html, body';
        this.$body = $('body');

        this.setUserOS();
        this.setUserAgent();
    };

    Pages.prototype.setUserOS = function () {
        var OSName = "";
        if (navigator.appVersion.indexOf("Win") != -1) OSName = "windows";
        if (navigator.appVersion.indexOf("Mac") != -1) OSName = "mac";
        if (navigator.appVersion.indexOf("X11") != -1) OSName = "unix";
        if (navigator.appVersion.indexOf("Linux") != -1) OSName = "linux";

        this.$body.addClass(OSName);
    };

    Pages.prototype.setUserAgent = function () {
        if (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) {
            this.$body.addClass('mobile');
        } else {
            this.$body.addClass('desktop');
            if (navigator.userAgent.match(/MSIE 9.0/)) {
                this.$body.addClass('ie9');
            }
        }
    };

    Pages.prototype.isVisibleXs = function () {
        !$('#pg-visible-xs').length && this.$body.append('<div id="pg-visible-xs" class="visible-xs" />');
        return $('#pg-visible-xs').is(':visible');
    };

    Pages.prototype.isVisibleSm = function () {
        !$('#pg-visible-sm').length && this.$body.append('<div id="pg-visible-sm" class="visible-sm" />');
        return $('#pg-visible-sm').is(':visible');
    };

    Pages.prototype.isVisibleMd = function () {
        !$('#pg-visible-md').length && this.$body.append('<div id="pg-visible-md" class="visible-md" />');
        return $('#pg-visible-md').is(':visible');
    };

    Pages.prototype.isVisibleLg = function () {
        !$('#pg-visible-lg').length && this.$body.append('<div id="pg-visible-lg" class="visible-lg" />');
        return $('#pg-visible-lg').is(':visible');
    };

    Pages.prototype.getUserAgent = function () {
        return $('body').hasClass('mobile') ? "mobile" : "desktop";
    };

    Pages.prototype.setFullScreen = function (element) {
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;

        if (requestMethod) {
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") {
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    };

    Pages.prototype.getColor = function (color, opacity) {
        opacity = parseFloat(opacity) || 1;

        var elem = $('.pg-colors').length ? $('.pg-colors') : $('<div class="pg-colors"></div>').appendTo('body');

        var colorElem = elem.find('[data-color="' + color + '"]').length ? elem.find('[data-color="' + color + '"]') : $('<div class="bg-' + color + '" data-color="' + color + '"></div>').appendTo(elem);

        var color = colorElem.css('background-color');

        var rgb = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        var rgba = "rgba(" + rgb[1] + ", " + rgb[2] + ", " + rgb[3] + ', ' + opacity + ')';

        return rgba;
    };

    Pages.prototype.initSidebar = function (context) {
        $('[data-pages="sidebar"]', context).each(function () {
            var $sidebar = $(this);
            $sidebar.sidebar($sidebar.data());
        });
    };

    Pages.prototype.initDropDown = function (context) {
        $('.dropdown-default', context).each(function () {
            var btn = $(this).find('.dropdown-menu').siblings('.dropdown-toggle');
            var offset = 0;

            var menuWidth = $(this).find('.dropdown-menu').actual('outerWidth');

            if (btn.actual('outerWidth') < menuWidth) {
                btn.width(menuWidth - offset);
                $(this).find('.dropdown-menu').width(btn.actual('outerWidth'));
            } else {
                $(this).find('.dropdown-menu').width(btn.actual('outerWidth'));
            }
        });
    };

    Pages.prototype.initFormGroupDefault = function (context) {
        $('.form-group.form-group-default', context).click(function () {
            $(this).find('input').focus();
        });

        if (!this.initFormGroupDefaultRun) {
            $('body').on('focus', '.form-group.form-group-default :input', function () {
                $('.form-group.form-group-default').removeClass('focused');
                $(this).parents('.form-group').addClass('focused');
            });

            $('body').on('blur', '.form-group.form-group-default :input', function () {
                $(this).parents('.form-group').removeClass('focused');
                if ($(this).val()) {
                    $(this).closest('.form-group').find('label').addClass('fade');
                } else {
                    $(this).closest('.form-group').find('label').removeClass('fade');
                }
            });

            this.initFormGroupDefaultRun = true;
        }

        $('.form-group.form-group-default .checkbox, .form-group.form-group-default .radio', context).hover(function () {
            $(this).parents('.form-group').addClass('focused');
        }, function () {
            $(this).parents('.form-group').removeClass('focused');
        });
    };

    Pages.prototype.initSlidingTabs = function (context) {
        $('a[data-toggle="tab"]', context).on('show.bs.tab', function (e) {
            e = $(e.target).parent().find('a[data-toggle=tab]');

            var hrefPrev = e.attr('href');

            var hrefCurrent = e.attr('href');

            if (!$(hrefCurrent).is('.slide-left, .slide-right')) return;
            $(hrefCurrent).addClass('sliding');

            setTimeout(function () {
                $(hrefCurrent).removeClass('sliding');
            }, 100);
        });
    };

    Pages.prototype.reponsiveTabs = function () {
        $('[data-init-reponsive-tabs="dropdownfx"]').each(function () {
            var drop = $(this);
            drop.addClass("hidden-sm hidden-xs");
            var content = '<select class="cs-select cs-skin-slide full-width" data-init-plugin="cs-select">';
            for (var i = 1; i <= drop.children("li").length; i++) {
                var li = drop.children("li:nth-child(" + i + ")");
                var selected = "";
                if (li.hasClass("active")) {
                    selected = "selected";
                }
                content += '<option value="' + li.children('a').attr('href') + '" ' + selected + '>';
                content += li.children('a').text();
                content += '</option>';
            }
            content += '</select>';
            drop.after(content);
            var select = drop.next()[0];
            $(select).on('change', function (e) {
                var optionSelected = $("option:selected", this);
                var valueSelected = this.value;
                drop.find('a[href="' + valueSelected + '"]').tab('show');
            });
            $(select).wrap('<div class="nav-tab-dropdown cs-wrapper full-width p-t-10 visible-xs visible-sm"></div>');
            new SelectFx(select);
        });

        $.fn.tabCollapse && $('[data-init-reponsive-tabs="collapse"]').tabCollapse();
    };

    Pages.prototype.initNotificationCenter = function () {
        $('body').on('click', '.notification-list .dropdown-menu', function (event) {
            event.stopPropagation();
        });
        $('body').on('click', '.toggle-more-details', function (event) {
            var p = $(this).closest('.heading');
            p.closest('.heading').children('.more-details').stop().slideToggle('fast', function () {
                p.toggleClass('open');
            });
        });
    };

    Pages.prototype.initProgressBars = function () {
        $(window).on('load', function () {
            $('.progress-bar-indeterminate, .progress-circle-indeterminate, .mapplic-pin').hide().show(0);
        });
    };

    Pages.prototype.initInputFile = function () {
        $(document).on('change', '.btn-file :file', function () {
            var input = $(this),
                numFiles = input.get(0).files ? input.get(0).files.length : 1,
                label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
            input.trigger('fileselect', [numFiles, label]);
        });

        $('.btn-file :file').on('fileselect', function (event, numFiles, label) {
            var input = $(this).parents('.input-group').find(':text'),
                log = numFiles > 1 ? numFiles + ' files selected' : label;
            if (input.length) {
                input.val(log);
            } else {
                $(this).parent().html(log);
            }
        });
    };

    Pages.prototype.initHorizontalMenu = function () {
        $(document).on('click', '.horizontal-menu .bar-inner > ul > li', function () {
            $(this).toggleClass('open').siblings().removeClass('open');
        });

        $('.content').on('click', function () {
            $('.horizontal-menu .bar-inner > ul > li').removeClass('open');
        });

        $('[data-pages="horizontal-menu-toggle"]').on('click touchstart', function (e) {
            e.preventDefault();
            $('body').toggleClass('menu-opened');
        });
    };

    Pages.prototype.initTooltipPlugin = function (context) {
        $.fn.tooltip && $('[data-toggle="tooltip"]', context).tooltip();
    };

    Pages.prototype.initSelect2Plugin = function (context) {
        $.fn.select2 && $('[data-init-plugin="select2"]', context).each(function () {
            $(this).select2({
                minimumResultsForSearch: $(this).attr('data-disable-search') == 'true' ? -1 : 1
            }).on('select2:open', function () {
                $.fn.scrollbar && $('.select2-results__options').scrollbar({
                    ignoreMobile: false
                });
            });
        });
    };

    Pages.prototype.initScrollBarPlugin = function (context) {
        $.fn.scrollbar && $('.scrollable', context).scrollbar({
            ignoreOverlay: false
        });
    };

    Pages.prototype.initListView = function (context) {
        $.fn.ioslist && $('[data-init-list-view="ioslist"]', context).ioslist();
        $.fn.scrollbar && $('.list-view-wrapper', context).scrollbar({
            ignoreOverlay: false
        });
    };

    Pages.prototype.initSwitcheryPlugin = function (context) {
        window.Switchery && $('[data-init-plugin="switchery"]', context).each(function () {
            var el = $(this);
            new Switchery(el.get(0), {
                color: el.data("color") != null ? $.Pages.getColor(el.data("color")) : $.Pages.getColor('success'),
                size: el.data("size") != null ? el.data("size") : "default"
            });
        });
    };

    Pages.prototype.initSelectFxPlugin = function (context) {
        window.SelectFx && $('select[data-init-plugin="cs-select"]', context).each(function () {
            var el = $(this).get(0);
            $(el).wrap('<div class="cs-wrapper"></div>');
            new SelectFx(el);
        });
    };

    Pages.prototype.initUnveilPlugin = function (context) {
        $.fn.unveil && $("img", context).unveil();
    };

    Pages.prototype.initValidatorPlugin = function () {
        $.validator && $.validator.setDefaults({
            ignore: "",
            showErrors: function showErrors(errorMap, errorList) {
                var $this = this;
                $.each(this.successList, function (index, value) {
                    var parent = $(this).closest('.form-group-attached');
                    if (parent.length) return $(value).popover("hide");
                });
                return $.each(errorList, function (index, value) {

                    var parent = $(value.element).closest('.form-group-attached');
                    if (!parent.length) {
                        return $this.defaultShowErrors();
                    }
                    var _popover;
                    _popover = $(value.element).popover({
                        trigger: "manual",
                        placement: "top",
                        html: true,
                        container: parent.closest('form'),
                        content: value.message
                    });
                    _popover.data("bs.popover").options.content = value.message;
                    var parent = $(value.element).closest('.form-group');
                    parent.addClass('has-error');
                    $(value.element).popover("show");
                });
            },
            onfocusout: function onfocusout(element) {
                var parent = $(element).closest('.form-group');
                if ($(element).valid()) {
                    parent.removeClass('has-error');
                    parent.next('.error').remove();
                }
            },
            onkeyup: function onkeyup(element) {
                var parent = $(element).closest('.form-group');
                if ($(element).valid()) {
                    $(element).removeClass('error');
                    parent.removeClass('has-error');
                    parent.next('label.error').remove();
                    parent.find('label.error').remove();
                } else {
                    parent.addClass('has-error');
                }
            },
            errorPlacement: function errorPlacement(error, element) {
                var parent = $(element).closest('.form-group');
                if (parent.hasClass('form-group-default')) {
                    parent.addClass('has-error');
                    error.insertAfter(parent);
                } else {
                    error.insertAfter(element);
                }
            }
        });
    };

    Pages.prototype.init = function () {
        this.initSidebar();
        this.initDropDown();
        this.initFormGroupDefault();
        this.initSlidingTabs();
        this.initNotificationCenter();
        this.initProgressBars();
        this.initHorizontalMenu();

        this.initTooltipPlugin();
        this.initSelect2Plugin();
        this.initScrollBarPlugin();
        this.initSwitcheryPlugin();
        this.initSelectFxPlugin();
        this.initUnveilPlugin();
        this.initValidatorPlugin();
        this.initListView();
        this.initInputFile();
        this.reponsiveTabs();
    };

    $.Pages = new Pages();
    $.Pages.Constructor = Pages;
})(window.jQuery);

;
(function (window) {

    'use strict';

    function hasParent(e, p) {
        if (!e) return false;
        var el = e.target || e.srcElement || e || false;
        while (el && el != p) {
            el = el.parentNode || false;
        }
        return el !== false;
    };

    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    }

    function SelectFx(el, options) {
        this.el = el;
        this.options = extend({}, this.options);
        extend(this.options, options);
        this._init();
    }

    function closest(elem, selector) {
        var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
        while (elem) {
            if (matchesSelector.bind(elem)(selector)) {
                return elem;
            } else {
                elem = elem.parentElement;
            }
        }
        return false;
    }

    function offset(el) {
        return {
            left: el.getBoundingClientRect().left + window.pageXOffset - el.ownerDocument.documentElement.clientLeft,
            top: el.getBoundingClientRect().top + window.pageYOffset - el.ownerDocument.documentElement.clientTop
        };
    }

    function insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    SelectFx.prototype.options = {
        newTab: true,

        stickyPlaceholder: true,

        container: 'body',

        onChange: function onChange(el) {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            el.dispatchEvent(event);
        }
    };

    SelectFx.prototype._init = function () {
        var selectedOpt = document.querySelector('option[selected]');
        this.hasDefaultPlaceholder = selectedOpt && selectedOpt.disabled;

        this.selectedOpt = selectedOpt || this.el.querySelector('option');

        this._createSelectEl();

        this.selOpts = [].slice.call(this.selEl.querySelectorAll('li[data-option]'));

        this.selOptsCount = this.selOpts.length;

        this.current = this.selOpts.indexOf(this.selEl.querySelector('li.cs-selected')) || -1;

        this.selPlaceholder = this.selEl.querySelector('span.cs-placeholder');

        this._initEvents();

        this.el.onchange = function () {
            var index = this.selectedIndex;
            var inputText = this.children[index].innerHTML.trim();
        };
    };

    SelectFx.prototype._createSelectEl = function () {
        var self = this,
            options = '',
            createOptionHTML = function createOptionHTML(el) {
            var optclass = '',
                classes = '',
                link = '';

            if (el.selectedOpt && !this.foundSelected && !this.hasDefaultPlaceholder) {
                classes += 'cs-selected ';
                this.foundSelected = true;
            }

            if (el.getAttribute('data-class')) {
                classes += el.getAttribute('data-class');
            }

            if (el.getAttribute('data-link')) {
                link = 'data-link=' + el.getAttribute('data-link');
            }

            if (classes !== '') {
                optclass = 'class="' + classes + '" ';
            }

            return '<li ' + optclass + link + ' data-option data-value="' + el.value + '"><span>' + el.textContent + '</span></li>';
        };

        [].slice.call(this.el.children).forEach(function (el) {
            if (el.disabled) {
                return;
            }

            var tag = el.tagName.toLowerCase();

            if (tag === 'option') {
                options += createOptionHTML(el);
            } else if (tag === 'optgroup') {
                options += '<li class="cs-optgroup"><span>' + el.label + '</span><ul>';
                [].slice.call(el.children).forEach(function (opt) {
                    options += createOptionHTML(opt);
                });
                options += '</ul></li>';
            }
        });

        var opts_el = '<div class="cs-options"><ul>' + options + '</ul></div>';
        this.selEl = document.createElement('div');
        this.selEl.className = this.el.className;
        this.selEl.tabIndex = this.el.tabIndex;
        this.selEl.innerHTML = '<span class="cs-placeholder">' + this.selectedOpt.textContent + '</span>' + opts_el;
        this.el.parentNode.appendChild(this.selEl);
        this.selEl.appendChild(this.el);

        var backdrop = document.createElement('div');
        backdrop.className = 'cs-backdrop';
        this.selEl.appendChild(backdrop);
    };

    SelectFx.prototype._initEvents = function () {
        var self = this;

        this.selPlaceholder.addEventListener('click', function () {
            self._toggleSelect();
        });

        this.selOpts.forEach(function (opt, idx) {
            opt.addEventListener('click', function () {
                self.current = idx;
                self._changeOption();

                self._toggleSelect();
            });
        });

        document.addEventListener('click', function (ev) {
            var target = ev.target;
            if (self._isOpen() && target !== self.selEl && !hasParent(target, self.selEl)) {
                self._toggleSelect();
            }
        });

        this.selEl.addEventListener('keydown', function (ev) {
            var keyCode = ev.keyCode || ev.which;

            switch (keyCode) {
                case 38:
                    ev.preventDefault();
                    self._navigateOpts('prev');
                    break;

                case 40:
                    ev.preventDefault();
                    self._navigateOpts('next');
                    break;

                case 32:
                    ev.preventDefault();
                    if (self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1) {
                        self._changeOption();
                    }
                    self._toggleSelect();
                    break;

                case 13:
                    ev.preventDefault();
                    if (self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1) {
                        self._changeOption();
                        self._toggleSelect();
                    }
                    break;

                case 27:
                    ev.preventDefault();
                    if (self._isOpen()) {
                        self._toggleSelect();
                    }
                    break;
            }
        });
    };

    SelectFx.prototype._navigateOpts = function (dir) {
        if (!this._isOpen()) {
            this._toggleSelect();
        }

        var tmpcurrent = typeof this.preSelCurrent != 'undefined' && this.preSelCurrent !== -1 ? this.preSelCurrent : this.current;

        if (dir === 'prev' && tmpcurrent > 0 || dir === 'next' && tmpcurrent < this.selOptsCount - 1) {
            this.preSelCurrent = dir === 'next' ? tmpcurrent + 1 : tmpcurrent - 1;

            this._removeFocus();

            classie.add(this.selOpts[this.preSelCurrent], 'cs-focus');
        }
    };

    SelectFx.prototype._toggleSelect = function () {
        var backdrop = this.selEl.querySelector('.cs-backdrop');
        var container = document.querySelector(this.options.container);
        var mask = container.querySelector('.dropdown-mask');
        var csOptions = this.selEl.querySelector('.cs-options');
        var csPlaceholder = this.selEl.querySelector('.cs-placeholder');

        var csPlaceholderWidth = csPlaceholder.offsetWidth;
        var csPlaceholderHeight = csPlaceholder.offsetHeight;
        var csOptionsWidth = csOptions.scrollWidth;

        if (this._isOpen()) {
            if (this.current !== -1) {
                this.selPlaceholder.textContent = this.selOpts[this.current].textContent;
            }

            var dummy = this.selEl.data;

            var parent = dummy.parentNode;

            insertAfter(this.selEl, dummy);
            this.selEl.removeAttribute('style');

            parent.removeChild(dummy);

            var x = this.selEl.clientHeight;

            backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = 'scale3d(1,1,1)';
            classie.remove(this.selEl, 'cs-active');

            mask.style.display = 'none';
            csOptions.style.overflowY = 'hidden';
            csOptions.style.width = 'auto';

            var parentFormGroup = closest(this.selEl, '.form-group');
            parentFormGroup && classie.removeClass(parentFormGroup, 'focused');
        } else {
            if (this.hasDefaultPlaceholder && this.options.stickyPlaceholder) {
                this.selPlaceholder.textContent = this.selectedOpt.textContent;
            }

            var dummy;
            if (this.selEl.parentNode.querySelector('.dropdown-placeholder')) {
                dummy = this.selEl.parentNode.querySelector('.dropdown-placeholder');
            } else {
                dummy = document.createElement('div');
                classie.add(dummy, 'dropdown-placeholder');

                insertAfter(dummy, this.selEl);
            }

            dummy.style.height = csPlaceholderHeight + 'px';
            dummy.style.width = this.selEl.offsetWidth + 'px';

            this.selEl.data = dummy;

            this.selEl.style.position = 'absolute';
            var offsetselEl = offset(this.selEl);

            this.selEl.style.left = offsetselEl.left + 'px';
            this.selEl.style.top = offsetselEl.top + 'px';

            container.appendChild(this.selEl);

            var contentHeight = csOptions.offsetHeight;
            var originalHeight = csPlaceholder.offsetHeight;

            var contentWidth = csOptions.offsetWidth;
            var originalWidth = csPlaceholder.offsetWidth;

            var scaleV = contentHeight / originalHeight;
            var scaleH = contentWidth > originalWidth ? contentWidth / originalWidth : 1.05;

            backdrop.style.transform = backdrop.style.webkitTransform = backdrop.style.MozTransform = backdrop.style.msTransform = backdrop.style.OTransform = 'scale3d(' + 1 + ', ' + scaleV + ', 1)';

            if (!mask) {
                mask = document.createElement('div');
                classie.add(mask, 'dropdown-mask');
                container.appendChild(mask);
            }

            mask.style.display = 'block';

            classie.add(this.selEl, 'cs-active');

            var resizedWidth = csPlaceholderWidth < csOptionsWidth ? csOptionsWidth : csPlaceholderWidth;

            this.selEl.style.width = resizedWidth + 'px';
            this.selEl.style.height = originalHeight + 'px';
            csOptions.style.width = '100%';

            setTimeout(function () {
                csOptions.style.overflowY = 'auto';
            }, 300);
        }
    };

    SelectFx.prototype._changeOption = function () {
        if (typeof this.preSelCurrent != 'undefined' && this.preSelCurrent !== -1) {
            this.current = this.preSelCurrent;
            this.preSelCurrent = -1;
        }

        var opt = this.selOpts[this.current];

        this.selPlaceholder.textContent = opt.textContent;

        this.el.value = opt.getAttribute('data-value');

        var oldOpt = this.selEl.querySelector('li.cs-selected');
        if (oldOpt) {
            classie.remove(oldOpt, 'cs-selected');
        }
        classie.add(opt, 'cs-selected');

        if (opt.getAttribute('data-link')) {
            if (this.options.newTab) {
                window.open(opt.getAttribute('data-link'), '_blank');
            } else {
                window.location = opt.getAttribute('data-link');
            }
        }

        this.options.onChange(this.el);
    };

    SelectFx.prototype._isOpen = function (opt) {
        return classie.has(this.selEl, 'cs-active');
    };

    SelectFx.prototype._removeFocus = function (opt) {
        var focusEl = this.selEl.querySelector('li.cs-focus');
        if (focusEl) {
            classie.remove(focusEl, 'cs-focus');
        }
    };

    window.SelectFx = SelectFx;
})(window);


(function ($) {
    'use strict';

    $('[data-chat-input]').on('keypress', function (e) {
        if (e.which == 13) {
            var el = $(this).attr('data-chat-conversation');
            $(el).append('<div class="message clearfix">' + '<div class="chat-bubble from-me">' + $(this).val() + '</div></div>');
            $(this).val('');
        }
    });
})(window.jQuery);


(function ($) {
    'use strict';

    var Progress = function Progress(element, options) {
        this.$element = $(element);
        this.options = $.extend(true, {}, $.fn.circularProgress.defaults, options);

        this.$container = $('<div class="progress-circle"></div>');

        this.$element.attr('data-color') && this.$container.addClass('progress-circle-' + this.$element.attr('data-color'));
        this.$element.attr('data-thick') && this.$container.addClass('progress-circle-thick');

        this.$pie = $('<div class="pie"></div>');

        this.$pie.$left = $('<div class="left-side half-circle"></div>');
        this.$pie.$right = $('<div class="right-side half-circle"></div>');

        this.$pie.append(this.$pie.$left).append(this.$pie.$right);

        this.$container.append(this.$pie).append('<div class="shadow"></div>');

        this.$element.after(this.$container);


        this.val = this.$element.val();
        var deg = perc2deg(this.val);

        if (this.val <= 50) {
            this.$pie.$right.css('transform', 'rotate(' + deg + 'deg)');
        } else {
            this.$pie.css('clip', 'rect(auto, auto, auto, auto)');
            this.$pie.$right.css('transform', 'rotate(180deg)');
            this.$pie.$left.css('transform', 'rotate(' + deg + 'deg)');
        }
    };
    Progress.VERSION = "1.0.0";

    Progress.prototype.value = function (val) {
        if (typeof val == 'undefined') return;

        var deg = perc2deg(val);

        this.$pie.removeAttr('style');

        this.$pie.$right.removeAttr('style');
        this.$pie.$left.removeAttr('style');

        if (val <= 50) {
            this.$pie.$right.css('transform', 'rotate(' + deg + 'deg)');
        } else {
            this.$pie.css('clip', 'rect(auto, auto, auto, auto)');
            this.$pie.$right.css('transform', 'rotate(180deg)');
            this.$pie.$left.css('transform', 'rotate(' + deg + 'deg)');
        }
    };

    function Plugin(option) {
        return this.filter(':input').each(function () {
            var $this = $(this);
            var data = $this.data('pg.circularProgress');
            var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;

            if (!data) $this.data('pg.circularProgress', data = new Progress(this, options));
            if (typeof option == 'string') data[option]();else if (options.hasOwnProperty('value')) data.value(options.value);
        });
    }

    var old = $.fn.circularProgress;

    $.fn.circularProgress = Plugin;
    $.fn.circularProgress.Constructor = Progress;

    $.fn.circularProgress.defaults = {
        value: 0
    };

    $.fn.circularProgress.noConflict = function () {
        $.fn.circularProgress = old;
        return this;
    };

    $(window).on('load', function () {
        $('[data-pages-progress="circle"]').each(function () {
            var $progress = $(this);
            $progress.circularProgress($progress.data());
        });
    });

    function perc2deg(p) {
        return parseInt(p / 100 * 360);
    }
})(window.jQuery);

(function ($) {

    'use strict';

    var Notification = function Notification(container, options) {

        var self = this;

        self.container = $(container);
        self.notification = $('<div class="pgn push-on-sidebar-open"></div>');
        self.options = $.extend(true, {}, $.fn.pgNotification.defaults, options);

        if (!self.container.find('.pgn-wrapper[data-position=' + this.options.position + ']').length) {
            self.wrapper = $('<div class="pgn-wrapper" data-position="' + this.options.position + '"></div>');
            self.container.append(self.wrapper);
        } else {
            self.wrapper = $('.pgn-wrapper[data-position=' + this.options.position + ']');
        }

        self.alert = $('<div class="alert"></div>');
        self.alert.addClass('alert-' + self.options.type);

        if (self.options.style == 'bar') {
            new BarNotification();
        } else if (self.options.style == 'flip') {
            new FlipNotification();
        } else if (self.options.style == 'circle') {
            new CircleNotification();
        } else if (self.options.style == 'simple') {
            new SimpleNotification();
        } else {
            new SimpleNotification();
        }

        function SimpleNotification() {

            self.notification.addClass('pgn-simple');

            self.alert.append(self.options.message);
            if (self.options.showClose) {
                var close = $('<button type="button" class="close" data-dismiss="alert"></button>').append('<span aria-hidden="true">&times;</span>').append('<span class="sr-only">Close</span>');

                self.alert.prepend(close);
            }
        }

        function BarNotification() {

            self.notification.addClass('pgn-bar');

            self.alert.append('<span>' + self.options.message + '</span>');
            self.alert.addClass('alert-' + self.options.type);

            if (self.options.showClose) {
                var close = $('<button type="button" class="close" data-dismiss="alert"></button>').append('<span aria-hidden="true">&times;</span>').append('<span class="sr-only">Close</span>');

                self.alert.prepend(close);
            }
        }

        function CircleNotification() {

            self.notification.addClass('pgn-circle');

            var table = '<div>';
            if (self.options.thumbnail) {
                table += '<div class="pgn-thumbnail"><div>' + self.options.thumbnail + '</div></div>';
            }

            table += '<div class="pgn-message"><div>';

            if (self.options.title) {
                table += '<p class="bold">' + self.options.title + '</p>';
            }
            table += '<p>' + self.options.message + '</p></div></div>';
            table += '</div>';

            if (self.options.showClose) {
                table += '<button type="button" class="close" data-dismiss="alert">';
                table += '<span aria-hidden="true">&times;</span><span class="sr-only">Close</span>';
                table += '</button>';
            }

            self.alert.append(table);
            self.alert.after('<div class="clearfix"></div>');
        }

        function FlipNotification() {

            self.notification.addClass('pgn-flip');
            self.alert.append("<span>" + self.options.message + "</span>");
            if (self.options.showClose) {
                var close = $('<button type="button" class="close" data-dismiss="alert"></button>').append('<span aria-hidden="true">&times;</span>').append('<span class="sr-only">Close</span>');

                self.alert.prepend(close);
            }
        }

        self.notification.append(self.alert);

        self.alert.on('closed.bs.alert', function () {
            self.notification.remove();
            self.options.onClosed();
        });

        return this;
    };

    Notification.VERSION = "1.0.0";

    Notification.prototype.show = function () {
        this.wrapper.prepend(this.notification);

        this.options.onShown();

        if (this.options.timeout != 0) {
            var _this = this;

            setTimeout(function () {
                this.notification.fadeOut("slow", function () {
                    $(this).remove();
                    _this.options.onClosed();
                });
            }.bind(this), this.options.timeout);
        }
    };

    $.fn.pgNotification = function (options) {
        return new Notification(this, options);
    };

    $.fn.pgNotification.defaults = {
        style: 'simple',
        message: null,
        position: 'top-right',
        type: 'info',
        showClose: true,
        timeout: 4000,
        onShown: function onShown() {},
        onClosed: function onClosed() {}
    };
})(window.jQuery);


(function ($) {
    'use strict';

    var Portlet = function Portlet(element, options) {
        this.$element = $(element);
        this.options = $.extend(true, {}, $.fn.portlet.defaults, options);
        this.$loader = null;
        this.$body = this.$element.find('.panel-body');
    };
    Portlet.VERSION = "1.0.0";

    Portlet.prototype.collapse = function () {
        var icon = this.$element.find(this.options.collapseButton + ' > i');
        var heading = this.$element.find('.panel-heading');

        this.$body.stop().slideToggle("fast");

        if (this.$element.hasClass('panel-collapsed')) {
            this.$element.removeClass('panel-collapsed');
            icon.removeClass().addClass('pg-arrow_maximize');
            $.isFunction(this.options.onExpand) && this.options.onExpand(this);
            return;
        }
        this.$element.addClass('panel-collapsed');
        icon.removeClass().addClass('pg-arrow_minimize');
        $.isFunction(this.options.onCollapse) && this.options.onCollapse(this);
    };

    Portlet.prototype.close = function () {
        this.$element.remove();
        $.isFunction(this.options.onClose) && this.options.onClose(this);
    };

    Portlet.prototype.maximize = function () {
        var icon = this.$element.find(this.options.maximizeButton + ' > i');

        if (this.$element.hasClass('panel-maximized')) {
            this.$element.removeClass('panel-maximized');
            icon.removeClass('pg-fullscreen_restore').addClass('pg-fullscreen');
            $.isFunction(this.options.onRestore) && this.options.onRestore(this);
        } else {
            this.$element.addClass('panel-maximized');
            icon.removeClass('pg-fullscreen').addClass('pg-fullscreen_restore');
            $.isFunction(this.options.onMaximize) && this.options.onMaximize(this);
        }
    };

    Portlet.prototype.refresh = function (refresh) {
        var toggle = this.$element.find(this.options.refreshButton);

        if (refresh) {
            if (this.$loader && this.$loader.is(':visible')) return;
            if (!$.isFunction(this.options.onRefresh)) return;
            this.$loader = $('<div class="portlet-progress"></div>');
            this.$loader.css({
                'background-color': 'rgba(' + this.options.overlayColor + ',' + this.options.overlayOpacity + ')'

            });

            var elem = '';
            if (this.options.progress == 'circle') {
                elem += '<div class="progress-circle-indeterminate progress-circle-' + this.options.progressColor + '"></div>';
            } else if (this.options.progress == 'bar') {

                elem += '<div class="progress progress-small">';
                elem += '    <div class="progress-bar-indeterminate progress-bar-' + this.options.progressColor + '"></div>';
                elem += '</div>';
            } else if (this.options.progress == 'circle-lg') {
                toggle.addClass('refreshing');
                var iconOld = toggle.find('> i').first();
                var iconNew;
                if (!toggle.find('[class$="-animated"]').length) {
                    iconNew = $('<i/>');
                    iconNew.css({
                        'position': 'absolute',
                        'top': iconOld.position().top,
                        'left': iconOld.position().left
                    });
                    iconNew.addClass('portlet-icon-refresh-lg-' + this.options.progressColor + '-animated');
                    toggle.append(iconNew);
                } else {
                    iconNew = toggle.find('[class$="-animated"]');
                }

                iconOld.addClass('fade');
                iconNew.addClass('active');
            } else {
                elem += '<div class="progress progress-small">';
                elem += '    <div class="progress-bar-indeterminate progress-bar-' + this.options.progressColor + '"></div>';
                elem += '</div>';
            }

            this.$loader.append(elem);
            this.$element.append(this.$loader);

            var _loader = this.$loader;
            setTimeout(function () {
                this.$loader.remove();
                this.$element.append(_loader);
            }.bind(this), 300);

            this.$loader.fadeIn();

            $.isFunction(this.options.onRefresh) && this.options.onRefresh(this);
        } else {
            var _this = this;
            this.$loader.fadeOut(function () {
                $(this).remove();
                if (_this.options.progress == 'circle-lg') {
                    var iconNew = toggle.find('.active');
                    var iconOld = toggle.find('.fade');
                    iconNew.removeClass('active');
                    iconOld.removeClass('fade');
                    toggle.removeClass('refreshing');
                }
                _this.options.refresh = false;
            });
        }
    };

    Portlet.prototype.error = function (error) {
        if (error) {
            var _this = this;
            this.$element.pgNotification({
                style: 'bar',
                message: error,
                position: 'top',
                timeout: 0,
                type: 'danger',
                onShown: function onShown() {
                    _this.$loader.find('> div').fadeOut();
                },
                onClosed: function onClosed() {
                    _this.refresh(false);
                }
            }).show();
        }
    };

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('pg.portlet');
            var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;

            if (!data) $this.data('pg.portlet', data = new Portlet(this, options));
            if (typeof option == 'string') data[option]();else if (options.hasOwnProperty('refresh')) data.refresh(options.refresh);else if (options.hasOwnProperty('error')) data.error(options.error);
        });
    }

    var old = $.fn.portlet;

    $.fn.portlet = Plugin;
    $.fn.portlet.Constructor = Portlet;

    $.fn.portlet.defaults = {
        progress: 'circle',
        progressColor: 'master',
        refresh: false,
        error: null,
        overlayColor: '255,255,255',
        overlayOpacity: 0.8,
        refreshButton: '[data-toggle="refresh"]',
        maximizeButton: '[data-toggle="maximize"]',
        collapseButton: '[data-toggle="collapse"]',
        closeButton: '[data-toggle="close"]'

    };

    $.fn.portlet.noConflict = function () {
        $.fn.portlet = old;
        return this;
    };

    $(document).on('click.pg.portlet.data-api', '[data-toggle="collapse"]', function (e) {
        var $this = $(this);
        var $target = $this.closest('.panel');
        if ($this.is('a')) e.preventDefault();
        $target.data('pg.portlet') && $target.portlet('collapse');
    });

    $(document).on('click.pg.portlet.data-api', '[data-toggle="close"]', function (e) {
        var $this = $(this);
        var $target = $this.closest('.panel');
        if ($this.is('a')) e.preventDefault();
        $target.data('pg.portlet') && $target.portlet('close');
    });

    $(document).on('click.pg.portlet.data-api', '[data-toggle="refresh"]', function (e) {
        var $this = $(this);
        var $target = $this.closest('.panel');
        if ($this.is('a')) e.preventDefault();
        $target.data('pg.portlet') && $target.portlet({
            refresh: true
        });
    });

    $(document).on('click.pg.portlet.data-api', '[data-toggle="maximize"]', function (e) {
        var $this = $(this);
        var $target = $this.closest('.panel');
        if ($this.is('a')) e.preventDefault();
        $target.data('pg.portlet') && $target.portlet('maximize');
    });

    $(window).on('load', function () {
        $('[data-pages="portlet"]').each(function () {
            var $portlet = $(this);
            $portlet.portlet($portlet.data());
        });
    });
})(window.jQuery);

(function ($) {
    'use strict';

    var MobileView = function MobileView(element, options) {
        var self = this;
        self.options = $.extend(true, {}, $.fn.pgMobileViews.defaults, options);
        self.element = $(element);
        self.element.on('click', function (e) {
            e.preventDefault();
            var data = self.element.data();
            var el = $(data.viewPort);
            var toView = data.toggleView;
            if (data.toggleView != null) {
                el.children().last().children('.view').hide();
                $(data.toggleView).show();
            } else {
                toView = el.last();
            }
            el.toggleClass(data.viewAnimation);
            self.options.onNavigate(toView, data.viewAnimation);
            return false;
        });
        return this;
    };
    $.fn.pgMobileViews = function (options) {
        return new MobileView(this, options);
    };

    $.fn.pgMobileViews.defaults = {
        onNavigate: function onNavigate(view, animation) {}
    };


    $(window).on('load', function () {
        $('[data-navigate="view"]').each(function () {
            var $mobileView = $(this);
            $mobileView.pgMobileViews();
        });
    });
})(window.jQuery);


(function ($) {
    'use strict';

    var Quickview = function Quickview(element, options) {
        this.$element = $(element);
        this.options = $.extend(true, {}, $.fn.quickview.defaults, options);
        this.bezierEasing = [.05, .74, .27, .99];
        var _this = this;

        $(this.options.notes).on('click', '.list > ul > li', function (e) {
            var note = $(this).find('.note-preview');
            var note = $(this).find('.note-preview');
            $(_this.options.noteEditor).html(note.html());
            $(_this.options.notes).toggleClass('push');
        });
        $(this.options.notes).on('click', '.list > ul > li .checkbox', function (e) {
            e.stopPropagation();
        });
        $(this.options.notes).on('click', _this.options.backButton, function (e) {
            $(_this.options.notes).find('.toolbar > li > a').removeClass('active');
            $(_this.options.notes).toggleClass('push');
        });
        $(this.options.deleteNoteButton).click(function (e) {
            e.preventDefault();
            $(this).toggleClass('selected');
            $(_this.options.notes).find('.list > ul > li .checkbox').fadeToggle("fast");
            $(_this.options.deleteNoteConfirmButton).fadeToggle("fast").removeClass('hide');
        });
        $(this.options.newNoteButton).click(function (e) {
            e.preventDefault();
            $(_this.options.noteEditor).html('');
        });

        $(this.options.deleteNoteConfirmButton).click(function () {
            var checked = $(_this.options.notes).find('input[type=checkbox]:checked');
            checked.each(function () {
                $(this).parents('li').remove();
            });
        });
        $(this.options.notes).on('click', '.toolbar > li > a', function (e) {
            var command = $(this).attr('data-action');
            document.execCommand(command, false, null);
            $(this).toggleClass('active');
        });
    };
    Quickview.VERSION = "1.0.0";

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('pg.quickview');
            var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;

            if (!data) $this.data('pg.quickview', data = new Quickview(this, options));
            if (typeof option == 'string') data[option]();
        });
    }

    var old = $.fn.quickview;

    $.fn.quickview = Plugin;
    $.fn.quickview.Constructor = Quickview;

    $.fn.quickview.defaults = {
        notes: '#note-views',
        alerts: '#alerts',
        chat: '#chat',
        notesList: '.list',
        noteEditor: '.quick-note-editor',
        deleteNoteButton: '.delete-note-link',
        deleteNoteConfirmButton: '.btn-remove-notes',
        newNoteButton: '.new-note-link',
        backButton: '.close-note-link'
    };

    $.fn.quickview.noConflict = function () {
        $.fn.quickview = old;
        return this;
    };

    $(window).on('load', function () {

        $('[data-pages="quickview"]').each(function () {
            var $quickview = $(this);
            $quickview.quickview($quickview.data());
        });
    });

    $(document).on('click.pg.quickview.data-api touchstart', '[data-toggle="quickview"]', function (e) {
        var elem = $(this).attr('data-toggle-element');
        if (Modernizr.csstransitions) {
            $(elem).toggleClass('open');
        } else {
            var width = $(elem).width();
            if (!$(elem).hasClass('open-ie')) {
                $(elem).stop().animate({
                    right: -1 * width
                }, 400, $.bez([.05, .74, .27, .99]), function () {
                    $(elem).addClass('open-ie');
                });
            } else {
                $(elem).stop().animate({
                    right: 0
                }, 400, $.bez([.05, .74, .27, .99]), function () {
                    $(elem).removeClass('open-ie');
                });
            }
        }
        e.preventDefault();
    });
})(window.jQuery);


(function ($) {
    'use strict';

    var Parallax = function Parallax(element, options) {
        this.$element = $(element);
        this.options = $.extend(true, {}, $.fn.parallax.defaults, options);
        this.$coverPhoto = this.$element.find('.cover-photo');

        this.$content = this.$element.find('.inner');

        if (this.$coverPhoto.find('> img').length) {
            var img = this.$coverPhoto.find('> img');
            this.$coverPhoto.css('background-image', 'url(' + img.attr('src') + ')');
            img.remove();
        }
    };
    Parallax.VERSION = "1.0.0";

    Parallax.prototype.animate = function () {

        var scrollPos;
        var pagecoverWidth = this.$element.height();

        var opacityKeyFrame = pagecoverWidth * 50 / 100;
        var direction = 'translateX';

        scrollPos = $(window).scrollTop();
        direction = 'translateY';

        this.$coverPhoto.css({
            'transform': direction + '(' + scrollPos * this.options.speed.coverPhoto + 'px)'
        });

        this.$content.css({
            'transform': direction + '(' + scrollPos * this.options.speed.content + 'px)'
        });

        if (scrollPos > opacityKeyFrame) {
            this.$content.css({
                'opacity': 1 - scrollPos / 1200
            });
        } else {
            this.$content.css({
                'opacity': 1
            });
        }
    };

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('pg.parallax');
            var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;

            if (!data) $this.data('pg.parallax', data = new Parallax(this, options));
            if (typeof option == 'string') data[option]();
        });
    }

    var old = $.fn.parallax;

    $.fn.parallax = Plugin;
    $.fn.parallax.Constructor = Parallax;

    $.fn.parallax.defaults = {
        speed: {
            coverPhoto: 0.3,
            content: 0.17
        }
    };

    $.fn.parallax.noConflict = function () {
        $.fn.parallax = old;
        return this;
    };

    $(window).on('load', function () {

        $('[data-pages="parallax"]').each(function () {
            var $parallax = $(this);
            $parallax.parallax($parallax.data());
        });
    });

    $(window).on('scroll', function () {
        if (Modernizr.touch) {
            return;
        }
        $('[data-pages="parallax"]').parallax('animate');
    });
})(window.jQuery);


(function ($) {
    'use strict';

    var Sidebar = function Sidebar(element, options) {
        this.$element = $(element);
        this.$body = $('body');
        this.options = $.extend(true, {}, $.fn.sidebar.defaults, options);

        this.bezierEasing = [.05, .74, .27, .99];
        this.cssAnimation = true;
        this.css3d = true;

        this.sideBarWidth = 250;
        this.sideBarWidthCondensed = 250 - 60;

        if (_store2.default.getters.isOpen) {
            this.$body.addClass('sidebar-visible');
        } else {
            this.$body.addClass('sidebar-invisible');
        }

        this.$sidebarMenu = this.$element.find('.sidebar-menu > ul');
        this.$pageContainer = $(this.options.pageContainer);

        if (!this.$sidebarMenu.length) return;

        if (!Modernizr.csstransitions) this.cssAnimation = false;
        if (!Modernizr.csstransforms3d) this.css3d = false;

        $('.sidebar-slide-toggle').on('click touchend', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            var el = $(this).attr('data-pages-toggle');
            if (el != null) {
                $(el).toggleClass('show');
            }
        });
    };

    Sidebar.prototype.toggleSidebar = function () {
        if (this.$body.hasClass('sidebar-visible')) {
            this.$body.removeClass('sidebar-visible');
            this.$body.addClass('sidebar-invisible');
            _store2.default.dispatch('updateSidebarState', false);
        } else {
            this.$body.removeClass('sidebar-invisible');
            this.$body.addClass('sidebar-visible');
            _store2.default.dispatch('updateSidebarState', true);
        }
    };

    Sidebar.prototype.togglePinSidebar = function (toggle) {
        if (toggle == 'hide') {
            this.$body.removeClass('menu-pin');
        } else if (toggle == 'show') {
            this.$body.addClass('menu-pin');
        } else {
            this.$body.toggleClass('menu-pin');
        }
    };

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('pg.sidebar');
            var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;

            if (!data) $this.data('pg.sidebar', data = new Sidebar(this, options));
            if (typeof option == 'string') data[option]();
        });
    }

    var old = $.fn.sidebar;

    $.fn.sidebar = Plugin;
    $.fn.sidebar.Constructor = Sidebar;

    $.fn.sidebar.defaults = {
        pageContainer: '.abrir-menu'
    };

    $.fn.sidebar.noConflict = function () {
        $.fn.sidebar = old;
        return this;
    };

    $(document).on('click.pg.sidebar.data-api', '[data-toggle-pin="sidebar"]', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $target = $('[data-pages="sidebar"]');
        $target.data('pg.sidebar').togglePinSidebar();
        return false;
    });
    $(document).on('click.pg.sidebar.data-api touchstart', '[data-toggle="sidebar"]', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $target = $('[data-pages="sidebar"]');
        $target.data('pg.sidebar').toggleSidebar();
        return false;
    });
})(window.jQuery);


(function ($) {

    'use strict';

    var Search = function Search(element, options) {
        this.$element = $(element);
        this.options = $.extend(true, {}, $.fn.search.defaults, options);
        this.init();
    };
    Search.VERSION = "1.0.0";

    Search.prototype.init = function () {
        var _this = this;
        this.pressedKeys = [];
        this.ignoredKeys = [];

        this.$searchField = this.$element.find(this.options.searchField);
        this.$closeButton = this.$element.find(this.options.closeButton);
        this.$suggestions = this.$element.find(this.options.suggestions);
        this.$brand = this.$element.find(this.options.brand);

        this.$searchField.on('keyup', function (e) {
            _this.$suggestions && _this.$suggestions.html($(this).val());
        });

        this.$searchField.on('keyup', function (e) {
            _this.options.onKeyEnter && _this.options.onKeyEnter(_this.$searchField.val());
            if (e.keyCode == 13) {
                e.preventDefault();
                _this.options.onSearchSubmit && _this.options.onSearchSubmit(_this.$searchField.val());
            }
            if ($('body').hasClass('overlay-disabled')) {
                return 0;
            }
        });

        this.$closeButton.on('click', function () {
            _this.toggleOverlay('hide');
        });

        this.$element.on('click', function (e) {
            if ($(e.target).data('pages') == 'search') {
                _this.toggleOverlay('hide');
            }
        });

        $(document).on('keypress.pg.search', function (e) {
            _this.keypress(e);
        });

        $(document).on('keyup', function (e) {
            if (_this.$element.is(':visible') && e.keyCode == 27) {
                _this.toggleOverlay('hide');
            }
        });
    };

    Search.prototype.keypress = function (e) {

        e = e || event;
        var nodeName = e.target.nodeName;
        if ($('body').hasClass('overlay-disabled') || $(e.target).hasClass('js-input') || nodeName == 'INPUT' || nodeName == 'TEXTAREA') {
            return;
        }

        if (e.which !== 0 && e.charCode !== 0 && !e.ctrlKey && !e.metaKey && !e.altKey && e.keyCode != 27) {
            this.toggleOverlay('show', String.fromCharCode(e.keyCode | e.charCode));
        }
    };

    Search.prototype.toggleOverlay = function (action, key) {
        var _this = this;
        if (action == 'show') {
            this.$element.removeClass("hide");
            this.$element.fadeIn("fast");
            if (!this.$searchField.is(':focus')) {
                this.$searchField.val(key);
                setTimeout(function () {
                    this.$searchField.focus();
                    var tmpStr = this.$searchField.val();
                    this.$searchField.val('');
                    this.$searchField.val(tmpStr);
                }.bind(this), 10);
            }

            this.$element.removeClass("closed");
            this.$brand.toggleClass('invisible');
            $(document).off('keypress.pg.search');
        } else {
            this.$element.fadeOut("fast").addClass("closed");
            this.$searchField.val('').blur();
            setTimeout(function () {
                if (this.$element.is(':visible')) {
                    this.$brand.toggleClass('invisible');
                }
                $(document).on('keypress.pg.search', function (e) {
                    _this.keypress(e);
                });
            }.bind(this), 10);
        }
    };

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('pg.search');
            var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;

            if (!data) {
                $this.data('pg.search', data = new Search(this, options));
            }
            if (typeof option == 'string') data[option]();
        });
    }

    var old = $.fn.search;

    $.fn.search = Plugin;
    $.fn.search.Constructor = Search;

    $.fn.search.defaults = {
        searchField: '[data-search="searchField"]',
        closeButton: '[data-search="closeButton"]',
        suggestions: '[data-search="suggestions"]',
        brand: '[data-search="brand"]'
    };

    $.fn.search.noConflict = function () {
        $.fn.search = old;
        return this;
    };

    $(document).on('click.pg.search.data-api', '[data-toggle="search"]', function (e) {
        var $this = $(this);
        var $target = $('[data-pages="search"]');
        if ($this.is('a')) e.preventDefault();
        $target.data('pg.search').toggleOverlay('show');
    });
})(window.jQuery);
(function ($) {
    'use strict';

    typeof angular === 'undefined' && $.Pages.init();
})(window.jQuery);

/***/ }),
/* 718 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./build/language/files/locale-es.json ***!
  \*********************************************/
/***/ (function(module, exports) {

module.exports = {"login":{"sucesso":{"recuperarSenha":"¡Su contraseña ha sido recuperada con éxito, ver su e-mail","cadastrarSenha":"¡Contraseña registrada con éxito!","alterarSenha":"Contraseña alterada con éxito!","login":"Éxito al logar"},"erro":{"usuario":{"inativo":"Usuario inactivo","senhaBloqueada":"Contraseña bloqueada","invalido":"Usuario inválido","diferente":"El e-mail del usuario no confiere","senhaInvaida":"La contraseña no debe contener caractéres especiales y necesita tener de 3 y 20 caracteres."},"keyInvalida":"La clave no es válida","recuperarSenha":"Error al recuperar la contraseña!","loginTitle":"Error al iniciar sesión","senha":"¡Contraseña incorrecta!","verificarEmailSenha":"Revise su correo electrónico y contraseña.","emailValido":"Introduzca un correo electrónico válido!","alterarSenha":"Error al cambiar la contraseña!","cadastrarSenha":"¡Error al registrar contraseña!","senhaVazia":"No se ha rellenado la contraseña","senhaInvalida":"Contraseña no válida","senhaDiferente":"Verifique su contraseña actual.","login":"No se puede autenticar usuario. Compruebe los datos informados e inténtelo de nuevo."},"validacao":{"recaptcha":"Confirmación de seguridad.","emailVazio":"Rellene con su e-mail","emailInvalido":"E-mail no válido","senhaVazia":"Rellene con su contraseña","confirmacaoDeSenha":"Rellena con la confirmación de contraseña","senhasDiferentes":"Las contraseñas deben ser idénticas","sessaoInvalida":"Token expirado!","emulacao":{"naoPermitida":"No se pudo iniciar sesión con los datos informados, vuelva a intentarlo."}},"labels":{"idioma":"Idioma:","entrar":"Entrar","recuperarSenha":"Recuperar contraseña","cadastrarSenha":"Contraseña:","voltar":"Volver","bemVindo":"Sea bienvenido!","esqueceuSenha":"¿Olvidó su clave?"},"placeholders":{"usuario":"Introduzca su dirección de correo electrónico","senha":"Introduzca su contraseña","confirmarSenha":"Confirme su contraseña"},"titulos":{"pt":"Portugués","eng":"Inglés","esp":"Español","recuperarSenha":"Recuperar contraseña","entrar":"¡Entrar en Banking!","cadastrarSenha":"¡Registrarse contraseña!","abrirSelecaoDeIdioma":"Abrir selección de idioma","fecharSelecaoDeIdioma":"Cerrar selección de idioma","fechar":"Cerrar","voltar":"Volver al inicio"}},"modalCliente":{"labels":{"clientes":"Clientes","selecionar":"Seleccionar","selecionado":"Seleccionado","nome":"Nombre"},"titulos":{"selecioneCliente":"Seleccione el cliente"}},"modalMinhaConta":{"labels":{"minhaConta":"Mi cuenta","subtitulo":"Visualice o cambie sus datos","nome":"Nombre","email":"E-mail","perfil":"Perfil de acceso","senha":"Contraseña","senhaAtual":"Contraseña actual","novaSenha":"Nueva contraseña","confirmarSenha":"Confirmar seña","voltar":"Volver","salvar":"Guardar","fechar":"Cerrar"},"validacao":{"camposObrigatorios":"Verifica los campos requeridos.","senhasDiferentes":"Las contraseñas deben ser idénticas"},"sucesso":{"salvar":"Datos modificados con éxito!"},"erro":{"salvar":"Error al cambiar datos."},"titulo":{"mostrarSenha":"Mostrar / ocultar contraseña","mudarSenha":"Cambiar contraseña"}},"menu":{"suspenso":{"minhaConta":"Mi cuenta","clientes":"Clientes","apps":"Aplicaciones","logout":"Logout"},"grupos":{"administracao":"Administración","registro":"Catastros","integracao":"Integraciones","conciliacao":"Conciliación","movimento":"Movimientos"},"funcionalidades":{"perfis":"Perfiles de acceso","operadores":"Operadores","logs":"Registros de auditoría","contasBancarias":"Cuentas bancarias","gruposEstabelecimentos":"Grupos de establecimientos","estabelecimentos":"Establecimientos","categorias":"Categorías","planosConciliacao":"Planes de conciliación","motivosOcorrencia":"Motivos de ocurrencia","atributos":"Conjunto de atributos","extratoBancario":"Extracto bancario","movimentosFinanceiros":"Movimientos financieros","arquivosProcessados":"Archivos procesados","relatorioConciliacao":"Informe de conciliación","conciliacaoManual":"Conciliación manual","relatorioOcorrencias":"Ocurrencias","envioArquivos":"Envío de archivos","resumoConciliacao":"Resumen de conciliación","tarefas":"Consulta de tareas","saldoBancario":"Saldo bancario","saldoCarteiraDigital":"Saldo cartera digital","analiseDuplicidade":"Análisis de duplicados","remessaIntegracao":"Remesas para la integración"}},"administracao":{"perfilAcesso":{"sucesso":{"criado":"Perfil de acceso creado con éxito!","editado":"Perfil de acceso editado con éxito!"},"erro":{"criar":"Error al crear perfil de acceso!","editar":"Error al editar perfil de acceso!","duplicado":"Ya existe un perfil de acceso con la descripción informada."},"labels":{"acoes":"Acciones","novoPerfil":"Nuevo perfil","perfil":"Perfil","perfilInfo":"Descripción del perfil","visibilidade":"Visibilidad en establecimientos y cuentas bancarias","visibilidadeAcessaTodos":"Acceso a todos/todas","visibilidadeAcessaAlguns":"Acceso a algunos/algunas","salvar":"Salvar","proximo":"Próximo","cancelar":"Cancelar","voltar":"Volver","funcionalidades":"Funciones","selecionarTodos":"Seleccionar todos","grupoFuncionalidade":"Grupo funcionalidad","hintEmularAcesso":"El Equipo Equals podrá acceder a este perfil ejecutando acciones sobre las funcionalidades disponibles. Las acciones realizadas durante la emulación se registrarán en el registro de auditoría."},"titulos":{"perfisAcesso":"Perfiles de acceso","novoPerfil":"Nuevo perfil de acceso","editarPerfil":"Editar perfil de acceso","cadastroSubtitulo":"Crear un nuevo perfil de acceso, seleccionando visibilidad sobre todos o algunos establecimientos y cuentas bancarias","edicaoSubtitulo":"Edita el perfil de acceso, su descripción, funcionalidades, la visibilidad de establecimientos y cuentas bancarias","listagemSubtitlo":"Administrar perfiles de acceso al sistema"},"validacao":{"naoPodeEditar":"No se puede cambiar este perfil","camposObrigatorios":"Compruebe los campos obligatorios.","tamanhoNome":"Nombre de perfil no puede ser mayor que 40 caracteres"},"etapas":{"informacoesPerfil":"Información del perfil","estabelecimentos":"Establecimientos","contasBancarias":"Cuenta bancarias","confirmacao":"Confirmación"}},"operadores":{"sucesso":{"criado":"Operador creado con éxito!","editado":"Operador editado con éxito!"},"erro":{"criar":"Error al crear operador!","editar":"Error al editar operador!","usuarioClienteAplicacaoExistente":"Este operador ya está registrado en el sistema.","emailExistente":"Este email ya está registrado en el sistema."},"labels":{"situacao":"Situación","email":"Email","novoOperador":"Nuevo operador","editarOperador":"Editar operador","nome":"Nombre","perfilAcesso":"Perfil acceso","sexo":"Sexo","ativo":"Activo","inativo":"Inactivo","masculino":"Masculino","feminino":"Femenino","selecionarPerfil":"Seleccione un perfil"},"titulos":{"operadores":"Operadores","cadastroSubTitulo":"Gestione los operadores","listagemSubtitlo":"Administrar los operadores del sistema"},"validacao":{"camposObrigatorios":"Compruebe los campos obligatorios."}}},"estabelecimentos":{"sucesso":{"criado":"Establecimiento creado con éxito!","editado":"Establecimiento editado con éxito!","estabelecimentosAtualizados":"Establecimientos actualizados!","gruposDeEstabelecimentos":"Grupos de establecimientos cargados con éxito!","movido":"Establecimiento movido con éxito"},"erro":{"criar":"Error al crear establecimiento!","editar":"Error al editar el establecimiento!","carregar":"Error al cargar establecimiento!","atualizar":"Error al actualizar establecimiento!","gruposDeEstabelecimentos":"Error al cargar grupos de establecimientos!","nome":"El nombre es obligatorio y debe tener un máximo de 50 caracteres.","nomeFantasia":"El nombre de fantasía debe tener un máximo de 50 caracteres.","cnpj":"El CNPJ debe contener 14 dígitos.","erroAoAtualizar":"Error al actualizar los establecimientos!","ufs":"Error al actualizar UFs!","carregarCidades":"Error al cargar ciudades!","atualizarCidades":"Error al actualizar ciudades!","cnpjCadastrado":"CNPJ ya registrado.","grupoEstabelecimentosInput":"Grupo de establecimientos debe contener un máximo de 20 caracteres.","cnpjInvalido":"CNPJ no válido.","cpfInvalido":"CPF no válido.","carregarAtributos":"Error al cargar atributos para establecimientos.","semAtributos":"Su empresa todavía no tiene ningún atributo registrado.","atributoValidacaoFail":"El valor informado no cumple los requisitos de validación definidos.","mesmoNome":"Ya existe un establecimiento con el mismo nombre.","salvar":"Error al guardar establecimiento!","origemDestinoIguais":"Los establecimientos de origen y destino no puede ser el mismo","moverEstabelecimento":"Error al mover o establecimiento","excluirEstabelecimentoVinculado":"No es posible excluir el establecimiento de origen, ya que está vinculado al plan/criterio de conciliación.","naoHouveLancamentosExcluiuEstabelecimento":"No hubo lanzamientos que mover. Se ha eliminado el establecimiento de origen.","naoHouveLancamento":"No hubo lanzamientos que mover."},"labels":{"estabelecimento":"Establecimiento","estabelecimentos":"Establecimientos","grupoEstabelecimento":"Grupo establecimientos","visualizacao":"Administrar sus establecimientos","cadastre":"Gestione los establecimientos","nome":"Nombre","cnpj":"CNPJ","cidade":"Ciudad","grupoDeEstabelecimentos":"Grupo","situacao":"Situación","ativo":"Activo","inativo":"Inactivo","pesquisar":"Búsqueda","salvar":"Guardar","cancelar":"Cancelar","mover":"Mover","sim":"Sí","nao":"No","novoEstabelecimento":"Nuevo establecimiento","editarEstabelecimento":"Editar establecimiento","moverEstabelecimento":"Mover establecimiento","nomeFantasia":"Nombre de fantasía","cidadeEstado":"Ciudad/Estado","uf":"UF","acoes":"Acciones","nenhumResultado":"No hay resultados encontrados!","estabbelecimentoAtributos":"Atributos","btnProximo":"Siguiente","selecaoColunas":"Seleccione los atributos que desea ver en la consulta","selecionarTodosPagina":"Seleccionar todo de la página","tooltipInfo":"Todos los establecimientos se considerarán si el campo está vacío.","estabelecimentoOrigem":"Establecimiento de origen","estabelecimentoDestino":"establecimiento de destino","excluirEstabelecimentoOrigem":"Quieres eliminar el establecimiento de origen?","confirmacaoMoverEstabelecimento":"Realmente desea trasladar el establecimiento de origen al establecimiento de destino?","apenasMoverLancamento":"Solo quieres mover lanzamientos?","filtroTitulo":"Filtros para consulta de establecimientos","filtro":{"buscar":"Introduzca el nombre...","listaVazia":"No hay resultados.","semResultado":"No se ha encontrado ningún establecimiento.","selecionar":"Seleccionar un establecimiento"},"alertaGrid":"* Prefijos de columnas: E = Establecimiento."},"placeholders":{"selecaoColunas":"Seleccione un atributo que se va a mostrar"},"titulos":{}},"dataTable":{"labels":{"contagem":"Mostrando {from} a {to} de {count} registros","semResultados":"Sin registros","filtrar":"Filtrar","filtroPlaceholder":"Filtrar por","acaoAplicar":"Aplicar","acaoFechar":"Cerrar","visualizacaoPorGrupos":"Visualización por grupos","mostrarContasInativas":"Mostrar cuentas inactivas","registrosPorPagina":"Registros por página"}},"logDeAuditoria":{"sucesso:":{},"erro":{},"validacao":{},"labels":{"logDeAuditoria":"Registros de auditoría","periodo":"Período","operadores":"Operadores","funcionalidades":"Funciones","entidades":"Entidades","identificacaoUnica":"Identificación única de la entidad del sistema","selecionarOperador":"Seleccionar operadores","selecionarFuncionalidades":"Seleccionar funciones","selecionarEntidades":"Seleccionar entidades","selecionarIdDaEntidade":"Seleccionar Id de la entidad","buscar":"Búsqueda","entidade":"Entidad","descricao":"Descripción"},"placeholders":{},"titulos":{"listagemSubtitlo":"Compruebe todos los accesos al sistema","filtroTitulo":"Filtros de consulta de registros de auditoría"}},"botoesExportacoes":{"titulos":{"tooltipCsv":"Exportar .CSV!","tooltipXls":"Exportar .XLS!","tooltipImprimir":"Imprimir tabla!","tooltipExport":"Exportar"}},"GENERAL":"Por favor, póngase en contacto con el administrador","TIMEOUT":"El tiempo de la solicitud ha caducado.","error":{"gruposFuncionalidades":{"invalid":"Grupo de funcionalidad no válida","listar":"Error al enumerar grupo de características","listarGrupoEFuncionalidades":"Error al enumerar grupo de características y sus característicasv"},"perfilDuplicado":"Nombre del perfil ya utilizado","perfilAcesso":{"invalid":"Perfil no válido","listar":"Error al enumerar perfil de acceso","salvar":"Error al guardar perfil de acceso","buscar":"Error al buscar perfil de acceso"},"salvarOperador":{"mesmoEmail":"Email ya registrado para otro operador"},"update":{"perfil":{"invalid":"Perfil no válido"}}},"validacao":{"campoObrigatorio":"Campo obligatorio","emailInvalido":"Email no válido ","somenteNumeros":"Sólo numeros","select":{"placeholder":"Seleccione una opción","nenhum":" - Vazio - "}},"inputTag":{"labels":{"todos":"Todos","todas":"Todos","novo":"nuevo"}},"datePicker":{"labels":{"ate":"hasta"}},"dateRange":{"labels":{"ate":"hasta"},"validacao":{"periodoMaximo":"Período máximo de %dias% días","dataInicialMaiorFinal":"La fecha final debe ser mayor o igual que la fecha inicial","dataInicialInvalida":"La fecha de inicio informada es una fecha no válida.","dataFinalInvalida":"La fecha final informada es una fecha no válida.","dataVazia":"Las fechas de período no pueden ser vacías.","dataInvalida":"La fecha rellenada no es válida!"}},"planoConciliacao":{"labels":{"gerenciar":"Administrar el plan de conciliación","criar":"Adicionar plan","acoes":"Acciones","novoPlano":"Nuevo plan","plano":"Nombre del plan","visibilidade":"Visibilidad","planoInfo":"Descripción del  plan","salvar":"Salvar","voltar":"Cancelar","nomePlano":"Nombre","escolhaPlano":"Seleccione un plan de conciliación","historico":"Regex História","categoria":"Categoria","ordem":"Orden","criteriosClassificacao":"Criterios de Clasificación","criteriosConciliacao":"Criterios de Conciliación","relevancia":"Relevancia","relevante":"Pertinente","irrelevante":"Irrelevante","status":"Status","ativo":"Activo","inativo":"Inactivo","resultadoVazio":"No se encontraron planes de conciliación.","descricao":"Descripción","tipo":"Tipo","criterios":"Criterios","addCriterio":"Agregar criterio","criterioReordenar":"Haga clic en los criterios deseados y arrastre para definir el orden de prioridad durante la conciliación","criterioEmUso":"Criterio en uso","tipoLancamento":{"C":"Crédito","D":"Débito","A":"Crédito/Débito","W":"Cartera Digital","texto":"Tipo de lanzamientos"},"descricaoCriterio":"Descripción del criterio","detalheCriterio":"Detalles del criterio","associacaoCategoria":"Asociar lanzamientos a la categoría","aplicarCriterio":"Cuando aplicar el criterio","mascaraHistorico":"Máscara de historial de lanzamiento","mascaraComplemento":"Máscara de complemento de lanzamiento","codigoHistorico":"Código del historial de versiones","febraban":"Categoría FEBRABAN","banco":"Banco","conta":"Cuenta bancaria","chaveRelacionamento":"Campos de clasificación","conjuntoAtributo":"Conjunto de atributos","atributo":"Nombre del Atributo","conciliacaoCampo":"Campo de conciliación","adicionar":"Añadir","remover":"Quitar","nenhumItem":"Ningún","editar":"Editar","minDiasDif":"Qtd dias mín.","maxDiasDif":"Qtd dias máx.","vlDifMax":"Diferencia máx.","vlDiverMax":"Divergencia máx.","diasMinimo":"Número mínimo de días","diasMaximo":"Número máximo de días","valorDiferenca":"Valor máx. de diferencia","valorDivergencia":"Valor máx. de divergencia","motivoOcorrencia":"Razón de ocurrencia","movFinan":"Movimiento financiero","movBan":"Movimiento bancario","removerBloqueado":"No puede eliminar planes de conciliación que el sistema haya utilizado en la clasificación / conciliación de entradas.","confirmarDelete":"La eliminación de un plan de conciliación eliminará todos los criterios asociados con él. ¿Quieres continuar con la eliminación?","cadastroPlano":"Crear nuevo plan de conciliación","cadastroPlanoBloquado":"Solo puede haber un plan de conciliación para cada cliente."},"titulos":{"planosConciliacao":"Planes de conciliación","novoPlanoConciliacao":"Nuevo plan de conciliación","visualizacao":"Administrar sus planes de conciliación","editarPlanoConciliacao":"Editar el plan de conciliación","cadastroSubtitulo":"Gestione los planes de conciliación","criteriosClassificacao":{"novoCriterio":"Nuevos criterios de clasificación","novoCriterioInfo":"Registre un criterio personalizado para este plan de conciliación","novoCriterioPortlet":"Registro de criterios de clasificación"},"criteriosConciliacao":{"novoCriterio":"Nuevos criterios de conciliación","novoCriterioInfo":"Registre un criterio personalizado para este plan de conciliación","novoCriterioPortlet":"Registro de criterios de conciliación","abrangencia":"Alcance del criterio","campoAplicacao":"Campos para aplicar el criterio","linkCamposConcil":"Estabeleça la relación entre los campos de movimientos Financieros y Bancarios deseados en conciliación:","modalConfirmaDivergenciaMaxNula":"Dejar el campo Valor máx. de divergencia vacío hará que cualquier diferencia de valor se concilie como <span class='titulo'>Divergente</span>.<br/><br/>¿Quieres continuar de todos modos?","modalOpcaoConfirmar":"Confirmar","modalOpcaoCancelar":"Cancelar"}},"validacao":{"naoPodeEditar":"No se puede cambiar este plan","tamanhoNome":"El nombre de plan no puede contener más de 40 caracteres","nomeObrigatorio":"El nombre del plan de conciliación es obligatorio","nomesIguais":"Ya existe un plan de conciliación registrado bajo este nombre","objetoInvalido":"Artículo mal estructurado. Revise los campos obligatorios.","criterioNomeRepetido":"Ya existe un criterios de clasificación registrado bajo este nombre","criterioEmUso":"No puede editar los criterios una vez que se han aplicado a la clasificación de publicación, solo desactívalos.","criterioEmUsoExcluir":"No puede quitar los criterios una vez que se han aplicado a la clasificación de publicación, solo desactívalos.","criterioEmUsoEditar":"No puede editar los criterios una vez que se han aplicado a la clasificación de publicación, solo desactívalos.","criterioPersistido":"Una vez guardados, los criterios no se pueden eliminar, solo desactívalos.","criterioConcilNomeRepetido":"Ya existe un criterios de conciliación registrado bajo este nombre","criterioConcilEmUsoEditar":"No puede editar los criterios una vez que se han aplicado a la clonciliación de publicación, solo desactívalos.","criterioConcilEmUsoExcluir":"No puede quitar los criterios una vez que se han aplicado a la clonciliación de publicación, solo desactívalos."},"sucesso":{"salvar":"¡Plan de conciliación creado con éxito!","atualizar":"¡Plan de conciliación actualizado con éxito!","criterioAdicionado":"Criterio agregado al plan.","criterioAlterado":"Criterio actualizado.","remover":"¡Plan de conciliación eliminado con éxito!"},"erro":{"salvar":"¡Error al crear el plan de conciliación!!","atualizar":"¡Error al editar el plan de conciliación!","remover":"¡Error al quitar el plan de conciliación!"}},"analiseDuplicidade":{"mensagem":{"anulacaoSucesso":"¡Transacción(es) anulada(s) con éxito!","reverterAnulacaoSucesso":"¡Reversión de anulación de la(s) transacción(es) seleccionada(s) realizada con éxito!","confirmarAnularLancamento":"¿Confirmar la anulación de la(s) transacción(es) seleccionada(s)?","confirmarReverterAnulacao":"¿Confirmar la reversión de la anulación de la(s) transacción(es) seleccionada(s)?","solicitacaoExclusaoSucesso":"La solicitud de exclusión de la remesa se realizó con éxito."},"titulos":{"titulo":"Análisis de duplicados","subtitulo":"Verifique las transacciones duplicadas y anuladas. Anule las duplicadas y revierta las anuladas, si es necesario."},"labels":{"listaDuplicado":"Filtro de Transacciones Duplicadas","listaAnulado":"Filtro de Transacciones Anuladas","buscar":"Buscar","anularLancamento":"Anular Transacción","reverterAnulacao":"Revertir Anulación","camposAvaliados":{"titulo":"Campos Evaluados","historico":"Historia","complemento":"Complemento","fitid":"FITID","documento":"Documento"},"sim":"Sí","nao":"No","contasBancarias":"Cuentas Bancarias","selecionarContasBancarias":"Seleccionar Cuentas Bancarias","alertaGridAnularLancamneto":"* No es posible anular transacciones conciliadas, por lo tanto, no puede seleccionarlas. Estas transacciones se muestran solo con fines de comparación.","alertaGridReverterAnulacao":"* Revertir transacciones que fueron anuladas por error."}},"modalLogAuditoria":{"nomeUsuario":"Nombre de usuario name","login":"Login","funcionalidade":"Functionalidad","transacaoRealizada":"Transacción realizada","dataTransacao":"Fecha de la transacción","ipAcesso":"IP de acesso","estacaoTrabalho":"Estación de trabajo","entidade":"Entidad","idEntidade":"Identificación única de la entidad","perfilAcesso":"Perfil acceso","imprimir":"Imprimir","titulo":"Log de auditoria","subtitulo":"Información detallada"},"filterPortlet":{"defaultTitle":"Filtros"},"contaBancaria":{"labels":{"contaBancaria":"Cuenta bancaria","contasBancarias":"Cuenta bancarias","agencia":"Agencia","digitoAgencia":"Dígito agencia","numeroConta":"Número cuenta","digitoConta":"Dígito cuenta","banco":"Banco","selecionarBanco":"Seleccione un banco","novaConta":"Nueva cuenta","nome":"Nombre","visualizacao":"Administrar la información de sus cuentas bancarias","dataSaldo":"Fecha del saldo","saldoInicial":"Saldo inicial","semGrupo":"Sin Grupo","status":"Status","ativa":"Activo","inativa":"Inactivo","contaEmUso":"* Los campos bloqueados no se pueden cambiar porque la cuenta se está utilizando en el sistema","confirmarDelete":"¿Está seguro de que desea eliminar esta  cuentas bancaria?","deleteBloqueado":"Las cuentas en uso por la aplicación no se pueden eliminar.","delete":"Eliminar cuenta bancaria","editar":"Editar cuenta bancaria","emUso":"En uso *","headerEmUso":"* Se considera que una cuenta bancaria está en uso si tiene: procesamiento (con o sin contabilizaciones) y / o criterios de clasificación / conciliación asociados."},"titulos":{"contaBancaria":"Cuenta bancaria","contasBancarias":"Cuentas bancarias","novaContaBancaria":"Nueva cuenta bacaria","editarContaBancaria":"Editar cuenta bancaria","cadastroSubtitulo":"Gestione las cuentas bancarias"},"sucesso":{"criado":"Cuenta bancaria creada con éxito!","editado":"¡Cuenta bancaria actualizada con éxito!","remover":"¡Cuenta bancaria eliminada con éxito!"},"error":{"salvar":"Error al crear cuenta bancaria!","atualizar":"Error al editar la cuenta bancaria!","remover":"Error al eliminar la cuenta bancaria!","banco":{"naoEncontrado":"Banco no encontrado"},"agencia":{"naoEncontrado":"Agencia no encontrada para el banco informado"},"recalcularSaldo":"Error al volver a calcular el saldo inicial"},"validacao":{"nomesIguais":"Ya existe una cuenta bancaria con el mismo nombre","contasIguais":"Esta cuenta ya está registrada en el sistema","dataSaldoVazio":"La fecha del saldo debe cumplimentarse para registrar el saldo","saldoVazio":"El valor del saldo debe rellenarse para registrar el saldo"}},"motivoOcorrencia":{"titulos":{"cadastroTitulo":"Motivo de ocurrencia","listagemTitulo":"Motivos de ocurrencia","cadastroSubtitulo":"Gestione los motivos de ocurrencia","listagemSubtitulo":"Administrar sus motivos de ocurrencia"},"labels":{"novo":"Nuevo motivo","novoPortlet":"Nuevo motivo de ocurrencia","editar":"Editar motivo de ocurrencia","remover":"Remover motivo de ocurrencia","sigla":"Código","descricao":"Descripción","categoria":"Categoría","acoes":"Acciones","confirmarDelete":"¿Está seguro de que desea eliminar este motivo de ocurrencia?","removeBloqueio":"No puede eliminar el motivo de ocurrencia, ya que está siendo utilizado por el sistema."},"validacao":{"siglaObrigatorio":"El campo 'Código' es obligatorio.","descricaoObrigatorio":"El campo 'Descripción' es obligatorio."},"sucesso":{"criar":"Motivo de ocurrencia creada con éxito!","editar":"Motivo de ocurrencia actualizada con éxito!","remover":"Motivo de ocurrencia eliminado con éxito!"},"erro":{"criar":"Error al crear motivo de ocurrencia!","editar":"Error al editar motivo de ocurrencia!","motivoCadastrado":"Ya existe un motivo de ocurrencia registrado con el mismo código informado."}},"extratoBancario":{"labels":{"contasBancarias":"Cuentas bancarias","selecionarContasBancarias":"Seleccionar cuentas bancarias","buscar":"Buscar","periodo":"Período","alertaGrid":"* Dependiendo de los criterios de ordenación, agrupación y filtro, los valores de la columna 'Saldo' deben ser desconsiderados.<br/>** Prefijos de columnas: CL = Cuenta de lanzamiento, E = Establecimiento","saldoVazio":"Sin registro de saldo hasta la fecha ({DIA_ANTERIOR})","consultaApenasNaoClassif":"Lanzamientos sin clasificar","consultaApenasClassif":"Lanzamientos clasificados","naoClassificado":"Sin clasificar"},"titulos":{"extratoBancario":"Extracto bancario","visualize":"Ver los lanzamientos de su banco","filtroTitulo":"Filtros para consulta de extractos bancarios"}},"geral":{"usuario":{"erro":{"buscar":{"usuarioNaoExiste":"El usuario no existe"}}},"labels":{"opcional":" - opcional","semResultadosSingular":"No se encontraron resultados para el parámetro elegido.","semResultadosPlural":"No se encontraron resultados para los parámetros elegidos.","listaVazia":"La lista está vacía.","carregando":"Cargando..."},"loading":{"andamento":"En proceso","preparandoGrid":"Preparando grid","preparandoArquivo":"Preparar archivo","digiteParaPesquisar":"Escriba para comenzar la búsqueda"},"perguntas":{"sairPagina":"¿Quieres irte?\nLas modificaciones no guardadas se perderán."}},"movimentosFinanceiros":{"titulos":{"titulo":"Movimientos financieros","subtitulo":"Ver los lanzamientos de su sistema interno","filtroTitulo":"Filtros para consulta de movimientos financieros","modalPlanoTitulo":"Planes de conciliación","modalPlanoSubtitulo":"Seleccionar planes de conciliación","modalEstabelecimentoTitulo":"Establecimientos","modalEstabelecimentoSubtitulo":"Seleccionar establecimientos"},"labels":{"periodo":"Período","planosConciliacao":"Planes de conciliación","selecionarPlanos":"Seleccionar planes de conciliación","estabelecimentos":"Establecimientos","selecionarEstabelecimentos":"Seleccionar establecimientos","conciliacao":"Situación","alertaGrid":"* Prefijos de columnas: MF = Movimiento Financiero, E = Establecimiento."}},"statusConciliacao":{"aberto":"En abierto","conciliado":"Conciliado","divergente":"Divergente","naoAplicavel":"No aplicable","conciliadoManualmente":"Conciliado manualmente"},"naoEncontrado":{"labels":{"mensagem":"Lo sentimos pero no podemos encontrar la página.","voltarHome":"Volver a la página de inicio"}},"naoAutorizado":{"labels":{"mensagem401":"Su sesión ha caducado. Por favor, introduzca un nuevo login.","mensagem":"Usted no tiene autorización para abrir esta página.","mensagemRedirect":"Usted será redirigido en breve...","voltarHome":"Volver a la página de inicio","operadorSemCliente":"Este usuario no está conectado a ningún cliente. Busque al administrador del sistema!","usuarioNaoEncntrado":"No se ha encontrado ningún usuario para los datos informados."}},"session":{"labels":{"erro":"Hubo un error con su sesión. Por favor, introduzca un nuevo login."}},"arquivoProcessado":{"erro":{"listar":"No se pudo consultar la información de este archivo."}},"arquivosProcessados":{"titulos":{"titulo":"Archivos procesados","subtitulo":"Acompañe el procesamiento de sus archivos","filtro":"Filtros para consulta de archivos procesados"},"labels":{"buscar":"Búsqueda"},"erro":{"periodoLimitado":"El período máximo para la consulta es de {dias} días"}},"remessaIntegracao":{"mensagem":{"sucesso":"Solicitud exitosa. En un momento el archivo estará disponible para descargar","confirmar":"¿Confirma el registro para generación de un nuevo archivo de movimiento financiero?","periodoExistente":"Ya existe un envío de integración con información del período solicitado. Al generar este nuevo envío la información que ya ha sido integrada no será duplicada.","confirmarExclusao":"Confirma la exclusión de las remesas de integración elegidas? Este proceso puede llevar algunos minutos para ser concluído.","solicitacaoExclusaoSucesso":"La solicitud para eliminar la remesa fue exitosa"},"titulos":{"titulo":"Remesas para la Integración","subtitulo":"Descargar la remesa de integración","filtro":"Filtro para consulta de remesas para la integración","excluirRemessas":"Borrar remessas","excluirRemessa":"Borrar la remessa"},"labels":{"novoArquivo":"Nuevo archivo","consultaPor":"Consultar por","dataGeracao":"Fecha de generación del archivo","periodoMovimentacao":"Período de movimentación del archivo","tipoRemessa":"Tipo de remesa","idsRemessa":"Remesa ID","digiteIdRemessa":"Ingrese la identificación de la remesa","numeroSequencia":"Número de secuencia","digiteNumeroSequencia":"Ingrese el número de secuencia","comentariosAdicionais":"Comentarios adicionales","gerar":"Generar","sim":"Sí","nao":"No","fechar":"Cerrar","modal":{"tabs":{"resumo":"Resumen"}}},"remessa":{"detalhar":{"modal":{"titulo":"Detalle de la remesa para la integración","subtitulo":"Información de remesa a enviar para integración"},"resultado":{"P":"En proceso","C":"Concluida"},"tab":{"nomeArquivo":"Nombre del archivo","idRemessa":"Remesa ID","resultado":"Resultado","conteudo":"Contenido","sequencia":"Secuencia","periodoContabil":"Período contable","dataMovimentacaoInicial":"Fecha de movimiento inicial","dataMovimentacaoFinal":"Fecha de movimiento final","dataGeracaoArquivo":"Fecha de generación del archivo","dataBase":"Fecha base","usuario":"Usuario","observacao":"Nota"}}},"tipoRemessa":{"listar":{"vazio":"No hay tipo de remesa."}}},"relatorioConciliacao":{"titulos":{"titulo":"Informe de conciliación","subtitulo":"Acompañe la conciliación de los lanzamientos","tituloFiltro":"Filtros para consulta de informe de conciliación"},"labels":{"contasBancarias":"Cuentas bancarias","selecaoContaBancaria":"Seleccionar cuentas bancarias","statusConciliacao":"Situación","exportarArquivo":"Exportar a archivo","pesquisaAvancada":"Búsqueda avanzada","alertaGrid":"* Prefijos de columnas: MB = Movimiento Bancario, MF = Movimiento Financiero, CL = Cuenta Lanzamiento, E = Establecimiento."}},"parametro":{"naoEncontrado":"Parámetro no encontrado"},"conciliacaoManual":{"titulos":{"titulo":"Conciliación manual","subtitulo":"Conciliar manualmente las contabilizaciones pendientes","abaLancamentos":"Lanzamientos","abaLotes":"Lotes","filtro":"Filtros para consulta de transacciones","gridMovimentosFinanceiros":"Movimientos financieros","gridExtratoBancario":"Extracto bancario","portletSelecionados":"Lanzamientos seleccionados","gridLotes":"Lotes disponibles","portletSelecionadosInterno":"Movimientos","portletSelecionadosBancario":"Extracto","confirmacao":"Confirmación","justificativa":"Justificación","justificativas":"Justificaciones","selecionarMotivo":"Determinar los valores y motivos de la divergencia","modalAllotmentDetailsTitle":"Detalles del lote","modalAllotmentDetailsSubtitle":"Visualización de los lanzamientos de este lote"},"labels":{"divergencia":"Divergencia","reabrir":"Reabrir lote","aplicar":"Aplicar","justificar":"Justificar","totalLancamentos":"Lanzamientos","periodo":"Período","valorTotalInterno":"Valor total","valorTotalBancario":"Valor total","data":"Datos","valor":"Valoraciones","situacao":"Situación","conciliacaoDeLote":"Confirma la conciliación del lote?","conciliacaoDeLoteDivergente":"Confirma la creación del lote divergiente?","reabrirLote":"Desea reabrir todo el lote?","acaoFechar":"No","acaoConfirmar":"Sim","limpar":"Limpiar","loteSelecionado":"Lote seleccionado","comentario":"Comentario","emProcessamento":"En proceso...","aguarde":"Espere","valorJustificar":"Valor a justificar","naoJustificado":"No justificado","parcial":"Parcial","total":"Total","motivoOcorrencia":"Motivo de ocurrencia","tooltipJustificativa":"Diferencia entre el valor a justificar y la divergencia","alertJustificativa":"La justificación agregada se perder si sale de la página. ¿Desea continuar?","alertJustificativas":"Las justificaciones añadidas se perder si sale de la página. ¿Desea continuar?","adicionarTodos":"Añadir","reaplicarConciliacao":"Volver a aplicar la conciliación automática","salvandoInformacoes":"Guardar información...","conciliacaoAutomatica":"Ejecución de la conciliación automática..."},"validacao":{"selecionarItensMovFin":"Usted debe seleccionar al menos una Impulsión Financiera","selecionarItensBankStat":"Usted debe seleccionar al menos un movimiento del Extracto Bancario"},"sucesso":{"loteConciliadoOk":"Lote %id% creado y conciliado con éxito!","loteDivergenteOk":"Lote divergente %id% creado con éxito!","loteReaberto":"Lote reabierto con éxito!","justificar":{"naoAplicavel":"Situación de los lanzamientos modificado para no aplicable.","lote":{"conciliado":"Lote conciliado %id% creado con éxito","divergente":"Lote divergente %id% creado com sucesso"}},"lote":{"reabrir":"Lote reabierto con éxito!"},"reaplicarConciliacao":"Conciliación aplicada con éxito!"},"erro":{"buscar":{"loteNaoExiste":"El lote no existe","loteOuClienteNaoExiste":"El lote o el cliente no existen","naoExistemMovimentacoesBancarias":"Movimientos bancarios no encontrados","naoExistemMovimentacoesFinanceiras":"Movimientos financieros no encontrados","clienteNaoEncontrado":"Cliente no encontrado"},"nenhumLancamentoInterno":"Ningún lanzamiento interno","nenhumLancamentoBancario":"Ninguna contabilización bancaria","motivoOcorrenciaInvalido":"Motivo de ocurrencia no válida","listar":"Error al enumerar los movimientos","reaplicarConciliacao":"Error al volver a solicitar la conciliación","verificarProcessamentoConciliacao":"Error al verificar volver a aplicar la conciliación","jaExisteReaplicacaoEmAndamento":"Ya hay una conciliación en progreso"}},"atributos":{"sucesso":{"listar":"Atributos enumerados correctamente"},"erro":{"listar":"Error al enumerar los atributos"}},"atributoValor":{"validacao":{"configuracaoNaoEncontrada":"Configuración no encontrada","vinculoNaoEncontrado":"Vinculo no encontrado","nomeAtributoNaoEncontrado":"Nombre de atributo no encontrado","clienteNaoEncontrado":"Cliente no encontrado"}},"relatorioOcorrencia":{"titulos":{"titulo":"Ocurrencias","subtitulo":"Ver todas las ocurrencias creadas","filtro":"Filtros para consulta de las ocurrencias"},"labels":{"motivoOcorrencia":"Motivos de ocurrencia","selecaoMotivoOcorrencia":"Seleccionar motivos de ocurrencia"},"erro":{"erroConsulta":"Error durante la consulta de instancias."}},"categoria":{"titulos":{"titulo":"Categorías","subtitulo":"Administrar las categorías del sistema"},"labels":{"novaCategoria":"Nueva categoría","editar":"Editar","criar":"Crear subcategoría","remover":"Remover","expandir":"Ampliar","recolher":"Retraer","credito":"Crédito","debito":"Débito","creditoDebito":"Crédito/Débito","carteiraDigital":"Cartera digital","dataSaldo":"Fecha del saldo","saldoInicial":"Saldo inicial","descricao":"Descripción","acoes":"Acciones","resultadoVazio":"No se encontró ninguna categoría registrada","selecionarCategoria":"Seleccionar categorías","removerBloqueado":"No puede eliminar la categoría ya que está siendo utilizada por el sistema.","confirmarDelete":"¿Está seguro de que desea eliminar esta categoría?"},"modal":{"titulo":{"novaCategoria":"Nueva categoría","edicaoCategoria":"Editar categoría","novaSubCategoria":"Nueva Subcategoría","edicaoSubCategoria":"Editar subcategoría"},"subtitulo":{"novaCategoria":"Crear una nueva categoría","edicaoCategoria":"Edite la información de la categoría","novaSubCategoria":"Crear una nueva subcategoría","edicaoSubCategoria":"Edite la información de la subcategoría"},"labels":{"numero":"Número","descricao":"Descripción","idContabil":"Id Contable","tipo":"Tipo","salvar":"Guardar","categoriaPai":"Categoría principal","C":"Crédito","D":"Débito","A":"Crédito/Débito","W":"Cartera Digital","saldoInicial":"Saldo Inicial (R$)","dataSaldoInicial":"Fecha del saldo"}},"sucesso":{"salvar":"Categoría guardada con éxito","buscar":"Categoría enumerada con éxito","listar":"Categorías enumeradas con éxito","remover":"Categoría eliminada con éxito"},"erro":{"salvar":"Error al guardar categoría","buscar":"Error al buscar categoría","listar":"Error al enumerar categorías","remover":"Error al eliminar la categoría"},"subCategoria":{"sucesso":{"salvar":"Subcategoría guardada con éxito","buscar":"Subcategoría enumerada con éxito","listar":"Subcategorías enumeradas con éxito"},"erro":{"salvar":"Error al guardar subcategoría","buscar":"Error al buscar subcategoría","listar":"Error al enumerar subcategorías"},"validacao":{"numeroObrigatorio":"El número de la subcategoría es obligatorio","nomeObrigatorio":"El nombre de la subcategoría es obligatorio","tipoObrigatorio":"El tipo de la subcategoría es obligatorio","mesmoNome":"Ya existe una subcategoría registrada con el nombre informado"}},"validacao":{"numeroObrigatorio":"El número de la categoría es obligatorio","nomeObrigatorio":"El nombre de la categoría es obligatorio","tipoObrigatorio":"El tipo de la categoría es obligatorio","mesmoNome":"Ya existe una categoría registrada con el nombre informado","saldoVazio":"El valor del saldo debe rellenarse para registrar el saldo","dataSaldoVazio":"La fecha del saldo debe cumplimentarse para registrar el saldo"}},"uploadArquivo":{"titulos":{"titulo":"Envío de archivos","subtitulo":"Envíe los archivos a la cola de procesamiento","tituloFilter":"Carga del archivo","mensagemFilter":"Después del envío, Equals puede tardar unos minutos para validar el contenido y procesar el archivo. <br/> El resultado del procesamiento podrá ser consultado a través del informe <a href='/banking/arquivosProcessados' class='upload-link'> Archivos procesados </a>","mensagemFilterDisabled":"El resultado del procesamiento podrá ser consultado a través del informe <a href='/banking/arquivosProcessados' class='upload-link'> Archivos procesados </a>"},"uploader":{"dictDefaultMessage":"<br/>Para enviar un archivo, arrastre o haga clic aquí!","dictFallbackMessage":"Su navegador no admite el envío de archivos por 'arrastrar / soltar'.","dictFallbackText":"Por favor, utilice el área de clic para seleccionar los archivos de su ordenador.","dictFileTooBig":"Archivo muy grande ({{filesize}}MiB). Tamaño máximo: {{maxFilesize}}MiB.","dictInvalidFileType":"Usted no puede subir archivos de este tipo.","dictResponseError":"El envío falló.","dictMaxFilesExceeded":"No puede enviar más archivos.","dictRemoveFile":"Quitar","envioFalhou":"Error de envío!","envioOk":"Enviado","dzInnerMessage":"Usted puede agregar más archivos arrastrándolos o haciendo clic en el área discontinua","envioDesabilitado":"<br/>Su envío de archivos está deshabilitado<br/>Para liberarlo, póngase en contacto con el administrador del sistema"},"erro":{"geral":"Error al cargar","regex":{"nome":"Nombre de archivo no válido","extensao":"Extensión del archivo no válido","naoEncontrada":"No hay máscara de validación registrada","invalida":"Máscara de validación registrada con error, póngase en contacto con el administrador del sistema."},"caminhoArquivo":"Ruta o disposición del archivo no válido","fileLayout":"Diseño del archivo no encontrado","permissaoUpload":"No hay permiso para cargar el archivo","enviroment":"Ningún servidor seleccionado","criacaoPasta":"Error al crear carpeta. Por favor inténtelo de nuevo","caixaPostal":"No se encontró una carpeta para cargar. Por favor, póngase en contacto con el administrador","naoFoiPossivelBuscarLayouts":"No se pueden consultar layouts registrados"},"sucesso":{"envioArquivo":"Archivo enviado con éxito","logAuditoria":"Registro con éxito"}},"resumoConciliacao":{"titulos":{"titulo":"Resumen de la conciliación","subtitulo":"Resumen de la situación de conciliación de los lanzamientos","tituloFiltro":"Filtros para consulta de resumen de conciliación"},"labels":{"movimentosFinanceiros":"Movimientos financieros","extratoBancario":"Extracto bancario","dataBase":"Base de datos","relatorio":"Informe","calendario":"Calendario"},"sucesso":{"listar":"Búsqueda de resumen de conciliación realizada con éxito"},"erro":{"listar":"Error al buscar un resumen de conciliación"}},"modalDetalhesLanc":{"titulos":{"titulo":"Detalles del lanzamiento","subtitulo":"Visualiza y realiza acciones con los lanzamientos","tituloTarefas":"Detalles de la tarea","subtituloTarefas":"Visualización de las tareas del lanzamiento","tabDetalhes":"Detalles","tabIntegracoes":"Integraciones","tabHistorico":"Historia","tabLote":"Lote","tabTarefas":"Tareas","tabClassif":"Clasificación"},"labels":{"valores":"Values","lancamentoExcluido":"<b>¡Atención!</ b> Este lanzamiento ha sido eliminado del sistema."},"details":{"titulos":{"idlanc":"ID lanzamiento","dtLanc":"Fecha lanzamiento","dtCont":"Fecha contables","banco":"Banco","nmConta":"Nombre de cuenta","agencia":"Numero agencia","nrConta":"Numero cuenta","cdHist":"Cód. histórico","dsHist":"Historia","dsDoc":"Nr. documento","dsTipo":"Tipo","vlDeb":"Lanzamiento débito","vlCred":"Lanzamiento crédito","vlSaldo":"Saldo","complemento":"Complemento","cdCat":"Cód. categoría","dsCat":"Categoría","bancoOrig":"Banco de origen","nrAgOrig":"Nr. agencia origen","agenciaOrig":"Agência origem","ocorrencia":"Motivo de ocurrencia","movFinanceiro":"Movimiento financiero","extBancario":"Extracto bancario","divergencia":"Divergencia","lote":"Lote","statusConciliacao":"Estado de conciliación","idMovimento":"ID movimiento","planoConciliacao":"Plano de conciliación","valorLanc":"Valor de lanzamiento","valorOrigem":"Valor original","lancCaixa":"Lanzamiento de caja","nrTicket":"Número ticket","valorVendaBruto":"Valor de venta en bruto","valorVendaLiq":"Valor de venta neto","processamento":"Procesamiento","nomeTarefa":"Nombre tarea","situacaoTarefa":"situación tarea","idEmpresa":"ID empresa","identificado":"Identificado","adquirente":"Adquiridor","bandeira":"Bandera","tipoProduto":"Tipo producto","origem":"Origen","valorBruto":"Valor bruto","valorComissao":"Valor comisión","comentario":"Comentário","estabelecimento":"Estabelecimiento","localizador":"Locador"}},"tabItegrations":{"labels":{"idProc":"Id","arquivo":"Nombre de archivo","sequencia":"Secuencia","dtgen":"Generación","layout":"Diseño","origem":"Origen","dtproc":"Procesamiento","origemInterno":"Interno","origemExterno":"Externo"}},"tabHistorico":{"labels":{"responsavel":"Responsable","status":"Estado","idLote":"Lote","acao":"Acción","resultadoVazio":"No se ha encontrado ningún historial para este lanzamiento"},"acao":{"CM":"Conciliación manual","RL":"Reabrir el lote","JC":"Justificado","CA":"Conciliación automática","EP":"Exclusión de procesamiento","CL":"Clasificación de lanzamiento","IF":"Importación de movimentaciones financieras"},"erro":{"listarHistorico":{"contaLancamento":"No se pudo cargar el historial de contabilizaciones","movimentoFinanceiro":"No se pudo cargar el historial del movimiento financiero","movimentacaoBancaria":"No se pudo cargar el historial del extracto bancario"}},"sucesso":{"listarHistorico":{"contaLancamento":"Historia de los lanzamientos cargados con éxito","movimentoFinanceiro":"Historia del movimiento financiero cargado con éxito","movimentacaoBancaria":"Historia del extracto bancario cargado con éxito"}}},"tabLotes":{"labels":{"lancamentoSemVinculo":"Este lanzamiento no está vinculado a un lote","concilarManualmente":"Conciliar manualmente","idLote":"Identificación del lote","qtdLanc":"Cantidad de lanzamientos","situacaoLote":"Situación","vlMovFin":"Movimiento financiero","vlMovExt":"Extracto bancario","vlDivergencia":"Divergencia","id":"Id","dtLanc":"Fecha lanzamiento","vlMovFinanc":"Vl. movimiento financiero","vlMovExtrato":"Vl. ext. bancario","codOcorrencia":"Cód. ocurrencia","dsOcorrencia":"Ocurrencia","nmConta":"Nombre del cuenta","banco":"Banco","nrConta":"Num. cuenta","agencia":"Agencia","qtdMovFin":"Cant. mov. financeiro","qtdMovBan":"Cant. ext. bancario","periodo":"Período","critConcil":"Criterio de conciliación utilizado:"},"erro":{"erroDetalhes":"Error al recuperar detalles de lote"}},"error":{"parseError":"Error en la transcripción de los datos para el detalle"},"tabTarefas":{"titulos":{"lancamentoSemTarefaAtiva":"No hay ninguna tarea pendiente en este lanzamiento en el momento.","lancamentoComTarefaAtiva":"Tarea actual","historicoTarefas":"Historial de tareas","historicoAcoes":"Historial de acciones","atualizarStatus":"Actualizar estado"},"labels":{"msgNenhumaTarefa":"No hay ninguna tarea vinculada a este lanzamiento.","iniciarTarefa":"Iniciar nueva tarea","novaTarefa":"Nueva tarea","editarTarefa":"Editar","detalheTarefa":"Detalles","verDetalhe":"Ver detalles de la tarea","tipoVinculoMF":"Movimiento financiero","tipoVinculoCL":"Cuenta lanzamiento","reabrir":"Reabrir","assumirTarefa":"Asumir tarea","salvarOcorrencia":"Cambiar el estado de esta tarea"},"datatableHistTarefa":{"colNome":"Nombre","colDesc":"Descripción","colTipo":"Tipo de Vínculo","colRes":"Responsable","colData":"Fecha vencto.","colConclAuto":"Conclusión automática"}},"tabClassif":{"btnSalvar":"Clasificar","btnEdit":"Reclasificar","btnRemover":"Desclasificar","tooltipEstab":"Debes ingresar el nombre del establecimiento deseado para recogerlo en la base. Los resultados de la consulta se mostrarán en la lista.","tooltipClassificacao":"Solo las transacciones bancarias con un estado 'En abierto' pueden cambiar y / o eliminar sus calificaciones.","infos":{"semPlanoConciliacao":"Es necesario tener un plan de conciliación registrado"},"critClassif":"Criterio de clasificación utilizado:","classifManual":"Clasificado manualmente","semClassif":"Sin clasificación"}},"conjuntoAtributo":{"tipoAtributo":{"texto":"Campo de texto","data":"Datepicker","combo":"Lista de selección (ComboBox)","numerico":"Valor numérico"},"titulos":{"conjuntoAtributos":"Conjunto de Atributos","titulo":"Conjunto de atributos","subtitulo":"Administrar el conjunto de atributos del sistema","tituloNovo":"Conjunto de atributos","subtituloNovo":"Administrar conjuntos de atributos","descricao":"Registrar conjuntos de atributos y atributos personalizados","novoAtributo":"Nuevo Atributo","adicionarAtributo":"Nuevo atributo","cadastroDeConjunto":"Registro de conjunto y atributos","cadastre":"Registrar un atributo personalizado para este conjunto","atributos":"Atributos","nomeDoConjunto":"Nombre del conjunto"},"infos":{"combo":"Monte una lista predefinida con los valores deseados.","datepicker":"Campo de fecha.","texto":"Campo de texto simple, añada una máscara deseada.","numerico":"Campo numérico simple, añada una máscara deseada.","dicaCombo":"Introduzca el valor deseado y presione <b> Enter </ b> para agregar una opción.","validacao":"Escriba la <b>Expresión regular</b> para validar el valor de este atributo.."},"labels":{"gerenciar":"Administrar el conjunto de atributos","novoConjunto":"Nuevo conjunto","configuracao":"Configuración del atributo","tipo":"Tipo","valoresPossiveis":"Valores posibles","nome":"Nombre","identificador":"Identificador","tipoVinculo":"Tipo de vínculo","quantidadeAtributos":"Cantidad de atributos","E":"Establecimiento","MF":"Movimiento financiero","CL":"Cuenta de lanzamiento","criar":"Crear atributo","containerConjunto":"Registro de conjunto","containerAtributos":"Atributos","descricao":"Descripción","limpar":"Limpiar","adicionar":"Añadir","resultadoVazio":"No se encontró ningún conjunto de atributos registrados","nenhumResultado":"No se encontró ningún conjunto de atributos!","mascara":"Máscara","validacao":"Validación (RegExp)","salvar":"Guardar","cancelar":"Cancelar","ordem":"Orden","tipoDeVinculo":"Tipo de vínculo","arrasteParaReordenar":"Haga clic en la línea del atributo y arrastre para definir el orden de aparición en el momento del registro","removerBloqueado":"No puede eliminar un conjunto de atributos que el sistema ha utilizado en la composición de contabilización o que está asociado con un plan de conciliación.","confirmarDelete":"La eliminación de un conjunto de atributos eliminará todos los atributos asociados con él. ¿Quieres continuar con la eliminación?","cadastroBloquado":"¡Solo puede haber un conjunto de atributos para cada tipo disponible!","cadastro":"Crear nuevo conjunto de atributos"},"tooltips":{"comboBox":"Monte una lista predefinida con los valores deseados"},"placeholders":{"infos":"Información de las tiendas","listaDeSelecao":"Lista de selección (Combo Box)"},"sucesso":{"atualizar":"Éxito al actualizar el conjunto de atributos!","salvar":"Éxito al guardar el conjunto de atributos!","listar":"Listado de atributos realizados con éxito","adicionadoOk":"Atributo agregado al conjunto!","editadoOk":"Atributo de conjunto cambiado!","remover":"Conjunto de atributos eliminado con éxito"},"erro":{"camposObrigatorios":"Compruebe los campos obligatorios!","criarConjunto":"Error al crear conjunto de atributos!","nomesDuplicados":"Los nombres de los atributos no pueden estar duplicados!","nomeConjuntoObrigatorio":"El nombre del conjunto de atributos es obligatorio!","tipoVinculoConjuntoObrigatorio":"El tipo de vínculo del conjunto es obligatorio!","listar":"Error al enumerar atributos","salvar":"Error al salvar conjunto de atributo","atualizar":"Error al actualizar conjunto de atributo","atributo":{"ordemAtributoObrigatorio":"El orden de aparición del atributo es obligatorio!","nomeAtributoObrigatorio":"El nombre de los atributos es obligatorio!","descricaoAtributoObrigatorio":"La descripción de los atributos es obligatoria!","tipoAtributoObrigatorio":"El tipo de atributo es obligatorio","atributoUtilizado":"No se puede editar este atributo, ya que el mismo ya está siendo utilizado por el sistema","atributoTipoValor":{"valorObrigatorio":"Debe definir al menos un valor para su ComboBox!"},"excluir":"No se pudo eliminar el atributo, ya que el mismo está utilizando en el sistema"},"remover":"No se pudo eliminar el conjunto de atributos."},"validacao":{"atributoEmUsoEditar":"No se permite editar atributos que utiliza el sistema.","atributoEmUsoExcluir":"No está permitido excluir atributos que son usados ​​por el sistema."},"types":{"STRING":"Campo de texto","COMBO":"Casilla de verificación (Combo Box)","NUMBER":"Valor numérico","DATE":"Datepicker"}},"tarefa":{"validacao":{"modificadaOutraSessao":"Tarea modificada en otra sesión","usuarioNaoEncotrado":"Usuario no encontrado","situacaoNaoPermitida":"Situación no permitida","vinculoExistente":"Ya existe tarea En curso o Pendiente para el vínculo","tipoVinculoNaoEncotrado":"Tipo de vínculo no encontrado","contaLancamentoNaoEncotrada":"Cuenta de lanzamiento no encontrada","movimentoFinanceiroNaoEncotrado":"Movimiento financiero no encontrado","usuarioResponsavelNaoEncotrado":"Usuario responsable no encontrado","clienteNaoEncotrado":"Cliente no encontrado","dtVencimentoInvalida":"La fecha de vencimiento no puede ser retroactiva!"},"erro":{"cadastrar":"Error al guardar tarea","atualizar":"Error al actualizar tarea","reabrir":"Error al volver a abrir tarea","gravarOcorrencia":"Error al grabar la ocurrencia","assumir":"Error al asumir tarea","buscar":"Error al buscar tarea","email":"Error al enviar correo electrónico a responsable","gravarEmMassa":"Error a guardar tareas en masa"},"sucesso":{"cadastrar":"Tarea guardada con éxito","atualizar":"Tarea actualizada con éxito","reabrir":"Tarea reabierta con éxito","gravarOcorrencia":"Ocurrencia salva con éxito","assumir":"Responsable cambiado con éxito","buscar":"Tarea obtenida con éxito","gravarEmMassa":"Tareas guardadas con éxito"}},"auditoria":{"erro":{"salvar":"Error al registrar registro de auditoría"}},"consultaTarefa":{"titulos":{"titulo":"Consulta de tareas","subtitulo":"Busque todas las tareas creadas en el sistema","filtroTitulo":"Filtros para consulta de tareas"},"labels":{"baseConsulta":"Base de consulta","todas":"Todas las tareas","dataCriacao":"Fecha de creación","dataVencimento":"Fecha de vencimiento","dataConclusao":"Fecha de finalización/fecha de cancelación","nenhumResultado":"¡Ningún resultado encontrado!","origem":"Origen","MF":"Movimiento financiero","CL":"Cuenta de lanzamiento","situacaoLabel":"Situación","atribuidas":"Mostrar sólo tareas asignadas a mí","situacao":{"pendente":"Pendientes","emAndamento":"En proceso","aguardando":"Esperando el comienzo","concluido":"Concluidas","cancelado":"Cancelaciones"},"tarefaOutroCliente":"Esta tarea está asociada a un lanzamiento de otro cliente.","tarefaNãoEncontrada":"Esta tarea ya no aparece en el sistema.","tarefaLancamentoRemovido":"¡Atención! La versión original a la que estaba asociada esta tarea se eliminó de la plataforma."},"sucesso":{"listar":"Búsqueda de tareas realizadas con éxito"},"erro":{"listar":"Error al buscar tareas"}},"tarefaEmMassa":{"titulos":{"titulo":"Iniciar tarea masiva","subtitulo":"Cree una misma tarea para múltiples lanzamientos","portletForm":"Nueva tarea","portletTable":"Lanzamientos","enviarEmail":"Enviar correo electrónico automáticamente al responsable"},"labels":{"nome":"Nombre","tipoVinculo":"Tipo de vínculo","descricao":"Descripción","situacao":"Situación","dtVencimento":"Fecha de vencimiento","responsavel":"Responsable","autoConc":"Completar automáticamente esta tarea cuando","tipoCl":"Cuenta de lanzamiento","tipoMf":"Movimiento financiero","itemVinculado":"Este lanzamiento ya tiene una tarea ","itemVinculadoStatus":{"emAndamento":"en progreso.","pendente":"pendiente.","aguardando":"esperando el comienzo."},"removerLanc":"Quitar lanzamiento","tarefasMistas":"La opción de autocompletar solo afecta a las contabilizaciones de movimientos financieros."},"erro":{"semLancamentos":"Usted necesita seleccionar al menos 1 lanzamiento en la cuadrícula."},"tarefaStatuses":{"pendente":"Pendiente","emAndamento":"En proceso","aguardando":"Esperando el comienzo","concluido":"Concluida","cancelada":"Cancelada"},"extrato":{"TipoMovBank":"Extracto bancario","IdLancamento":"Id lanz.","DtLanc":"Fecha lanz.","Banco":"Banco","NomeConta":"Nombre cuenta","Agencia":"Agencia","NrConta":"Num. cuenta","Tipo":"Tipo","Valor":"Valor","DsCategoria":"Categoría","tipoCred":"Crédito","tipoDeb":"Débito"},"movimento":{"TipoMovFin":"Movimiento financiero","IdMov":"Id movimiento","Estabelecimento":"Estabelecimiento","PlanoConcil":"Plan de conciliación","Situacao":"Situación"},"ocorrencia":{"IdLote":"Lote","Ocorrencia":"Ocurrencia"}},"desclassificacaoEmMassa":{"titulos":{"titulo":"Desclasificar en masa","subtitulo":"Desclasifica registros que estén clasificados y que no estén conciliados","portletForm":"Cantidad de registros seleccionados que no pueden ser desclasificados","portletTable":"Cantidad de registros seleccionados que pueden ser desclasificados","botao":"Desclasificar en masa"},"colunas":{"TipoMovBank":"Extracto bancario","IdLancamento":"Id lanz.","DtLanc":"Fecha lanz.","Banco":"Banco","NomeConta":"Nombre cuenta","Agencia":"Agencia","NrConta":"Num. cuenta","Tipo":"Tipo","Valor":"Valor","CritClassif":"Crit. Clasif.","DsHistorico":"Histórico","tipoCred":"Crédito","tipoDeb":"Débito"},"labels":{"fechar":"Cerrar","desclassificar":"Desclasificar","removerLancamento":"Eliminar registro de la desclasificación","desclassificarInvalido":"Para continuar debes seleccionar entre 1 y 100 registros que pueden ser desclasificados","sim":"Sí","nao":"No","confirmacao":"¿Está seguro de que desea continuar con la desclasificación? Recuerde que después de la conclusión, debe recargar el informe para traer los datos actualizados.","classificadoManualmente":"Clasificado manualmente"}},"logTransacao":{"NOVA_TAREFA":"Nueva tarea","ALTERAR_TAREFA":"Editar tarea","NOVA_OCORRENCIA_TAREFA":"Nueva aparición","ASSUMIR_TAREFA":"Asumir tarea","REABRIR_TAREFA":"Reabrir tarea","CONSULTA_TAREFA":"Consulte la tarea"},"situacaoTarefa":{"PENDENTE":"Pendiente","EM_ANDAMENTO":"En proceso","AGUARDANDO":"Esperando el comienzo","CONCLUIDO":"Concluida","CANCELADO":"Cancelada"},"dashboard":{"titulos":{"portlet":"Periodo mostrado: ","filtros":{"data":"Por fecha","lancamento":"Por tipo de lanzamiento","plano":"Por plan de conciliación"}},"filtro":{"data":{"estaSemana":"Esta semana","ultimosSeteDias":"Últimos 7 dias","esteMes":"Este mes","ultimosTrintaDias":"Últimos 30 dias","mesAnterior":"Mes pasado","personalizado":"Personalizado"},"tipo":{"E":"Extractos bancarios","MF":"Movimientos financieros","T":"Todos"},"semOpcoes":"No hay otra opción disponible para este filtro","semAgrupamento":"Sin agrupar"},"labels":{"resultadoVazio":"<i class='fa fa-pie-chart' aria-hidden='true'></i> <br> <span>No hay datos que se muestran<span>","contextButtonTitle":"Opciones","downloadJPEG":"Descargar imagen JPG","downloadCSV":"Descargar CSV","downloadPDF":"Descargar PDF","downloadPNG":"Descargar imagen PNG","downloadSVG":"Descargar SVG","downloadXLS":"Descargar XLS","printChart":"Imprimir gráfico","viewData":"Ver datos","valorTotal":"Valor total"}},"estatistica":{"sucesso":{"atualizar":"Éxito al actualizar estadísticas"},"erro":{"periodoInvalido":"Período no válido","atualizar":"Error al actualizar estadísticas"},"resumoConciliacao":{"titulo":"Distribución de conciliación","sucesso":{"pesquisar":"Éxito al obtener distribución de conciliación"},"erro":{"pesquisar":"Error al buscar distribución de conciliación"}},"resumoFinanceiro":{"titulo":"Ventas por plan de conciliación","sucesso":{"pesquisar":"Éxito al obtener ventas por plan de conciliación"},"erro":{"pesquisar":"Error al buscar ventas por plan de conciliación"}},"conciliacaoLote":{"titulo":"Lanzamientos conciliados"},"saldoBancario":{"titulo":"Saldo en cuenta","sucesso":{"pesquisar":"Éxito al obtener saldo en cuenta"},"erro":{"pesquisar":"Error al buscar saldo en cuenta"}},"tarefa":{"titulo":"Tareas","labels":{"naoConcluida":"No completada","concluida":"Terminado","movFinanceira":"Mov. financiero","movBancaria":"Mov. banco","total":"Total","alertaVencidasSingular":"Tarea ha ganado y necesita su atención.","alertaVencidasPlural":"Tareas han vencido y necesitan su atención.","alertaSemTarefasVencidas":"No hay tareas vencidas.","dataProximoVencimento":"El próximo vencimiento se producirá en","semDataProximoVencimento":"No hay tareas a vencer.","visualizeTarefasConcluidas":"Visualización de las tareas completadas","semTarefasConcluidas":"No hay tareas completadas.","verQuaisSao":"Vea cuáles son haciendo clic aquí."},"tooltip":{"vencidas":"Ver las tareas vencidas","concluidas":"Ver tareas completadas."},"sucesso":{"pesquisar":"Éxito al obtener tareas"},"erro":{"pesquisar":"Error al buscar tareas"}},"saldoCarteiraDigital":{"titulo":"Saldo portafolio","sucesso":{"pesquisar":"Éxito al obtener saldo portafolio"},"erro":{"pesquisar":"Error al buscar saldo portafolio"}}},"gadgets":{"sucesso":{"listar":"Éxito al mostrar gráficos","salvar":"Éxito al guardar gráficos","atualizar":"Éxito al actualizar gráficos"},"erro":{"listar":"Error al mostrar gráficos","salvar":"Error al guardar gráficos","atualizar":"Error al actualizar gráficos"}},"trocaApp":{"titulos":{"titulo":"Intercambio de aplicación","subtitulo":"Haga clic abajo para elegir cuál desea utilizar"},"labels":{"voceAqui":"Tu estás aquí"},"aplicacoes":{"banking":"Banking","cartoes":"Gestão de vendas com cartões","extrato":"Conciliação de Extratos Bancários","bandeiras":"Conciliação de Bandeiras","cobranca":"Gestão de Cobrança Bancária"},"erro":{"aplicacaiIndisponivel":"Aplicación no disponible"}},"saldoBancario":{"labels":{"contasBancarias":"Cuentas bancarias","selecionarContasBancarias":"Seleccionar cuentas bancarias","buscar":"Buscar","periodo":"Período","alertaGrid":"* Dependiendo de los criterios de ordenación, agrupación y filtrado, los valores en la columna 'Saldo diario' no deben tenerse en cuenta. <br/> ** En la columna 'Saldo anterior', los bloques resaltados en amarillo representan los saldos registrados manualmente por aplicación."},"titulos":{"saldoBancario":"Saldo bancario","visualize":"Ver los lanzamientos de su banco","filtroTitulo":"Filtros para consulta de saldos bancarios"}},"saldoCarteiraDigital":{"labels":{"carteirasDigitais":"Carteras digitais","selecionarCarteirasDigitais":"Selecionar carteras digitais","buscar":"Buscar","periodo":"Período","nome":"Nombre","alertaGrid":"* Al agrupar información no se deben considerar las columnas 'Saldo del día' y 'Saldo anterior'. Por lo tanto, en estos casos se mostrará '0.00' para la agrupación, pero los valores serán visibles a nivel individual."},"titulos":{"saldoCarteiraDigital":"Saldo cartera digital","visualize":"Ver los lanzamientos de su cartera digital.","filtroTitulo":"Filtros para consulta de saldos de carteras digitais"}},"downloads":{"labels":{"extratoBancario":"extractoBancario","movimentacaoFinanceira":"movimientosFinancieros","relatorioConciliacao":"informeConciliacion","resumoConciliacao":"resumenConciliacion"}},"movbancaria":{"sucesso":{"salvar":"Clasificación creada con éxito y conciliación aplicada nuevamente.","atualizar":"Clasificación cambió con éxito y conciliación aplicada nuevamente.","remover":"Clasificación eliminada correctamente y conciliación aplicada nuevamente."}},"ofda":{"titulo":"Open Finance","compartilhar":"Compartir datos (opcional)","tipoConta":"Tipo da Cuenta","tipoContaPf":"Perssona Física","tipoContaPj":"Perssona Jurídica","requisitante":"Nombre del solicitante","cpfRequisitante":"CPF del solicitante","empresa":"Nombre social del titular de la cuenta","cnpjRequisitante":"CNPJ del titular de la cuenta","jaAutorizado":"¡Esta cuenta ya está autorizada en Open Finance y está compartiendo datos con nuestra aplicación!","statusAceite":{"revogado":"Derogado","autorizado":"Autorizado","aguardando":"Espera","autorizar":"Autorizar"},"nenhumaInstituicaoHomologada":"No existen instituciones financieras aprobadas en Open Finance Brasil asociadas a los datos proporcionados."},"calendarioConciliacao":{"detalhe":{"vlMovBanc":"Vlr. Extrato","vlMovFinan":"Vlr. Mov. Finan.","diferenca":"Valor diferencia","situacao":"Situación","conciliadoManualmente":"Conc. Manual","movFinan":"Mov. Financeira","semLancamentos":"¡No hay lanzamientos registrados en esa fecha!","total":"Total","percent":"%","resumo":"Resumen","detalhe":"Detalles"},"labels":{"seg":"Lun.","ter":"Mar.","qua":"Mie.","qui":"Jue.","sex":"Vie.","sab":"Sab.","dom":"Dom.","periodo":"Período","situacao":"Situación","categoria":"Categoria"},"alerta":{"tooltipPercent":"Porcentaje de valores Mov. Estado Financiero + Extracto de cuenta, por situación de conciliación, en relación al total agregado del día/período."}}}

/***/ }),
/* 719 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./build/language/files/locale-in.json ***!
  \*********************************************/
/***/ (function(module, exports) {

module.exports = {"login":{"sucesso":{"recuperarSenha":"Your password has been successfully recovered, check your email","cadastrarSenha":"Password successfully registered!","alterarSenha":"Password changed successfully!","login":"Success to log in!"},"erro":{"usuario":{"inativo":"Inactive user","senhaBloqueada":"Password locked","invalido":"Invalid user","diferente":"The user's email does not match","senhaInvaida":"The password must not contain special characters and must be 3 and 20 characters long."},"keyInvalida":"The key is invalid","recuperarSenha":"Error retrieving password!","loginTitle":"Error logging in!","senha":"Password incorrect!","verificarEmailSenha":"Check your email and password.","emailValido":"Please enter a valid email address!","alterarSenha":"Error changing password!","cadastrarSenha":"Error registering password!","senhaVazia":"Password not filled in","senhaInvalida":"Invalid password","senhaDiferente":"Verify your current password.","login":"Unable to authenticate user. Verify the given informations and try again."},"validacao":{"recaptcha":"Check security confirmation.","emailVazio":"Fill in your email","emailInvalido":"Invalid email","senhaVazia":"Fill in your password","confirmacaoDeSenha":"Fill in the password confirmation","senhasDiferentes":"Passwords must be identical","sessaoInvalida":"Expired token!","emulacao":{"naoPermitida":"Unable to log in with reported data, please try again."}},"labels":{"idioma":"Language:","entrar":"Get in","recuperarSenha":"Recover password","cadastrarSenha":"Register password","voltar":"Back","bemVindo":"Welcome!","esqueceuSenha":"Forgot your password?"},"placeholders":{"usuario":"Type your e-mail","senha":"Type your password","confirmarSenha":"Confirm your password"},"titulos":{"pt":"Portuguese","eng":"English","esp":"Spanish","recuperarSenha":"Recover password","entrar":"Enter on Banking!","cadastrarSenha":"Register password!","abrirSelecaoDeIdioma":"Open language selection","fecharSelecaoDeIdioma":"Close language selection","fechar":"Close","voltar":"Back to login"}},"modalCliente":{"labels":{"clientes":"Clients","selecionar":"Select","selecionado":"Selected","nome":"Name"},"titulos":{"selecioneCliente":"Select customer"}},"modalMinhaConta":{"labels":{"minhaConta":"My account","subtitulo":"View or change your data","nome":"Name","email":"E-mail","perfil":"Access profile","senha":"Password","senhaAtual":"Current password","novaSenha":"New password","confirmarSenha":"Confirm password","voltar":"Close","salvar":"Save","fechar":"Close"},"validacao":{"camposObrigatorios":"Check the required fields.","senhasDiferentes":"Passwords must be identical"},"sucesso":{"salvar":"Successfully changed data!"},"erro":{"salvar":"Error changing data."},"titulo":{"mostrarSenha":"Show / hide password","mudarSenha":"Change Password"}},"menu":{"suspenso":{"minhaConta":"My account","clientes":"Clients","apps":"Applications","logout":"Logout"},"grupos":{"administracao":"Management","registro":"Registration","integracao":"Integrations","conciliacao":"Reconciliation","movimento":"Movements"},"funcionalidades":{"perfis":"Access profiles","operadores":"Operators","logs":"Audit logs","contasBancarias":"Bank accounts","gruposEstabelecimentos":"Groups of establishments","estabelecimentos":"Establishments","categorias":"Categories","planosConciliacao":"Reconciliation Plans","motivosOcorrencia":"Occurrence Reasons","atributos":"Attribute set","extratoBancario":"Bank statement","movimentosFinanceiros":"Financial movements","arquivosProcessados":"Processed files","relatorioConciliacao":"Reconciliation report","conciliacaoManual":"Manual reconciliation","relatorioOcorrencias":"Occurrences","envioArquivos":"Upload files","resumoConciliacao":"Reconciliation summary","tarefas":"Task query","saldoBancario":"Bank balance","saldoCarteiraDigital":"Digital wallet balance","analiseDuplicidade":"Duplicate analysis","remessaIntegracao":"Remittances for integration"}},"administracao":{"perfilAcesso":{"sucesso":{"criado":"Successfully created access profile!","editado":"Successfully edited access profile!"},"erro":{"criar":"Error creating access profile!","editar":"Error editing access profile!","duplicado":"There is already an access profile with the provided description."},"labels":{"acoes":"Actions","novoPerfil":"New profile","perfil":"Profile","perfilInfo":"Profile info","visibilidade":"Visibility on establishments and bank accounts","visibilidadeAcessaTodos":"Access to all","visibilidadeAcessaAlguns":"Access to some","salvar":"Save","proximo":"Next","cancelar":"Cancel","voltar":"Back","funcionalidades":"Functionalities","selecionarTodos":"Select all","grupoFuncionalidade":"Functionality group","hintEmularAcesso":"The Equals Team can access this profile and perform actions on the available features. The actions performed during the emulation will be logged in the audit lo"},"titulos":{"perfisAcesso":"Access profiles","novoPerfil":"New access profile","editarPerfil":"Edit access profile","cadastroSubtitulo":"Create a new access profile, selecting visibility over all or some establishments and bank accounts","edicaoSubtitulo":"Edit the access profile, its description, functionalities, the visibility of establishments and bank accounts","listagemSubtitlo":"Manage system access profiles"},"validacao":{"naoPodeEditar":"This profile can not be changed","camposObrigatorios":"Check the required fields.","tamanhoNome":"Profile name can not be longer than 40 characters"},"etapas":{"informacoesPerfil":"Profile information","estabelecimentos":"Establishments","contasBancarias":"Bank accounts","confirmacao":"Confirmation"}},"operadores":{"sucesso":{"criado":"Operator successfully created!","editado":"Operator edited successfully!"},"erro":{"criar":"Error creating operator!","editar":"Error editing operator!","usuarioClienteAplicacaoExistente":"This operator is already registered in the system.","emailExistente":"This email is already registered in the system."},"labels":{"situacao":"Situation","email":"Email","novoOperador":"New operator","editarOperador":"Edit operator","nome":"Name","perfilAcesso":"Access profile","sexo":"Sex","ativo":"Active","inativo":"Inactive","masculino":"Male","feminino":"Female","selecionarPerfil":"Select a profile"},"titulos":{"operadores":"Operators","cadastroSubTitulo":"Manage operators","listagemSubtitlo":"Manage system operators"},"validacao":{"camposObrigatorios":"Check the required fields."}}},"estabelecimentos":{"sucesso":{"criado":"Establishment successfully created!","editado":"Establishment successfully edited!","estabelecimentosAtualizados":"Updated establishments!","gruposDeEstabelecimentos":"Successfully loaded groups of establishments!","movido":"Successfully moved establishment"},"erro":{"criar":"Error creating establishment!","editar":"Error editing establishment!","carregar":"Error loading establishment!","atualizar":"Error updating establishment!","gruposDeEstabelecimentos":"Error loading groups of stores!","nome":"The name is required and be at most 50 characters.","nomeFantasia":"Trading name must be at most 50 characters.","cnpj":"The CNPJ must contain 14 digits.","erroAoAtualizar":"Error updating merchants!","ufs":"Error updating UFs!","carregarCidades":"Error loading cities!","atualizarCidades":"Error updating cities!","cnpjCadastrado":"CNPJ already registered.","grupoEstabelecimentosInput":"Establishments group must contain a maximum of 20 characters.","cnpjInvalido":"Invalid CNPJ.","cpfInvalido":"Invalid CPF.","carregarAtributos":"Error loading attributes for stores.","semAtributos":"Your company does not have any registered attributes yet.","atributoValidacaoFail":"The reported value does not meet the validation requirements defined.","mesmoNome":"An establishment with the same name already exists.","salvar":"Error saving establishment!","origemDestinoIguais":"The establishments of origin and destination cannot be the same","moverEstabelecimento":"Error moving establishment","excluirEstabelecimentoVinculado":"It is not possible to exclude the establishment of origin, as it is linked to a conciliation plan/criterion.","naoHouveLancamentosExcluiuEstabelecimento":"There were no entries to be moved. The home establishment has been deleted.","naoHouveLancamento":"There were no entries to be moved."},"labels":{"estabelecimento":"Establishment","estabelecimentos":"Establishments","grupoEstabelecimento":"Establishment group","visualizacao":"Manage your establishments","cadastre":"Manage establishments","nome":"Name","cnpj":"CNPJ","cidade":"City","grupoDeEstabelecimentos":"Group","situacao":"Situation","ativo":"Active","inativo":"Inactive","pesquisar":"Search","salvar":"Save","cancelar":"Cancel","mover":"Move","sim":"Yes","nao":"No","novoEstabelecimento":"New establishment","editarEstabelecimento":"Edit establishment","moverEstabelecimento":"Move establishment","nomeFantasia":"Fantasy name","cidadeEstado":"City/State","uf":"UF","acoes":"Actions","nenhumResultado":"No results found!","estabbelecimentoAtributos":"Attributes","btnProximo":"Next","selecaoColunas":"Select the attributes you want to display in the query","selecionarTodosPagina":"Select all from page","tooltipInfo":"All establishments will be considered if the field is empty.","estabelecimentoOrigem":"Origin establishment","estabelecimentoDestino":"Destination establishment","excluirEstabelecimentoOrigem":"Do you want to delete the establishment of origin?","confirmacaoMoverEstabelecimento":"Do you really want to move the originating establishment to the destination establishment?","apenasMoverLancamento":"You just want to move the entries?","filtroTitulo":"Establishments' searching filters","filtro":{"buscar":"Enter the name...","listaVazia":"No results.","semResultado":"No properties found.","selecionar":"Select establishment"},"alertaGrid":"* Column prefix: E = Establishment."},"placeholders":{"selecaoColunas":"Select an attribute to display"},"titulos":{}},"dataTable":{"labels":{"contagem":"Showing {from} to {to} of {count} records","semResultados":"No matching records","filtrar":"Filter","filtorPlaceholder":"Filter by","acaoAplicar":"Apply","acaoFechar":"Close","visualizacaoPorGrupos":"Visualization by groups","mostrarContasInativas":"Show inactive accounts","registrosPorPagina":"Records per page"}},"logDeAuditoria":{"sucesso:":{},"erro":{},"validacao":{},"labels":{"logDeAuditoria":"Audit logs","periodo":"Period","operadores":"Operators","funcionalidades":"Functionalities","entidades":"Entities","identificacaoUnica":"Unique identification of the system entity","selecionarOperador":"Select operators","selecionarFuncionalidades":"Select functionalities","selecionarEntidades":"Select entities","selecionarIdDaEntidade":"Select entity Id","buscar":"Find","entidade":"Entity","descricao":"Description"},"placeholders":{},"titulos":{"listagemSubtitlo":"Check all accesses to the system","filtroTitulo":"Audit logs' searching filters"}},"botoesExportacoes":{"titulos":{"tooltipCsv":"Export .CSV!","tooltipXls":"Export .XLS!","tooltipImprimir":"Print table!","tooltipExport":"Export"}},"GENERAL":"Please contact the Administrator!","TIMEOUT":"The request time has expired.","error":{"gruposFuncionalidades":{"invalid":"Invalid feature group","listar":"Error while listing feature group","listarGrupoEFuncionalidades":"Error listing feature group and its features"},"perfilDuplicado":"Profile name already used","perfilAcesso":{"invalid":"Invalid profile","listar":"Error listing access profile","salvar":"Error saving access profile","buscar":"Error fetching access profile"},"salvarOperador":{"mesmoEmail":"Email already registred for another operator"},"update":{"perfil":{"invalid":"Invalid profile"}}},"validacao":{"campoObrigatorio":"Mandatory field","emailInvalido":"Invalid email","somenteNumeros":"Only numbers","select":{"placeholder":"Select an option","nenhum":" - Empty - "}},"inputTag":{"labels":{"todos":"All","todas":"All","novo":"new"}},"dateRange":{"labels":{"ate":"to"},"validacao":{"periodoMaximo":"Maximum period of %dias% days","dataInicialMaiorFinal":"The end date must be greater than or equal to the starting date","dataInicialInvalida":"The starting date is invalid.","dataFinalInvalida":"The end date is invalid.","dataVazia":"The period dates can not be empty.","dataInvalida":"La fecha rellenada no es válida!"}},"planoConciliacao":{"labels":{"gerenciar":"Manage conciliation plan","criar":"Add plan","acoes":"Action","novoPlano":"New plan","plano":"Plan name","visibilidade":"Visibility","planoInfo":"Plan info","salvar":"Save","voltar":"Cancel","nomePlano":"Name","escolhaPlano":"Select a reconciliation plan","historico":"History's Regex","categoria":"Category","ordem":"Order","criteriosClassificacao":"Classification Criterias","criteriosConciliacao":"Conciliation Criterias","relevancia":"Relevance","relevante":"Relevant","irrelevante":"Irrelevant","status":"Status","ativo":"Active","inativo":"Inactive","resultadoVazio":"No conciliation plans were found.","descricao":"Description","tipo":"Type","criterios":"Criterias","addCriterio":"Add criteria","criterioReordenar":"Click on the desired criteria and drag to define the order of priority during reconciliation","criterioEmUso":"Criteria in use","tipoLancamento":{"C":"Credit","D":"Debit","A":"Credit/Debit","W":"Digital Wallet","texto":"Entry type"},"descricaoCriterio":"Criteria description","detalheCriterio":"Criteria details","associacaoCategoria":"Associate entries to Category","aplicarCriterio":"When to apply the criteria","mascaraHistorico":"Entry history mask","mascaraComplemento":"Entry complement mask","codigoHistorico":"Entry history code","febraban":"FEBRABAN Category","banco":"Bank","conta":"Bank account","chaveRelacionamento":"Classification fields","conjuntoAtributo":"Attribute Set","atributo":"Attribute name","conciliacaoCampo":"Conciliation field","adicionar":"Add","remover":"Remove","nenhumItem":"None","editar":"Edit","minDiasDif":"Minimum days","maxDiasDif":"Maximum days","vlDifMax":"Max Diff","vlDiverMax":"Max Divergence","diasMinimo":"Min amount of days","diasMaximo":"Max amount of days","valorDiferenca":"Max Diff Value","valorDivergencia":"Max Divergence Value","motivoOcorrencia":"Occurrence Reason","movFinan":"Financial Movment","movBan":"Bank Movment","removerBloqueado":"You cannot remove reconciliation plans that have been used in the classification/reconciliation of entries by the system.","confirmarDelete":"Removing a reconciliation plan will delete all criteria associated with it. Do you want to proceed with the deletion?","cadastroPlano":"Create a new reconciliation plan","cadastroPlanoBloquado":"There can only be one reconciliation plan for each customer."},"titulos":{"planosConciliacao":"Reconciliation plans","visualizacao":"Manage your reconciliation plans","novoPlanoConciliacao":"New reconciliation plan","editarPlanoConciliacao":"Editing reconciliation plan","cadastroSubtitulo":"Manage reconciliation plans","criteriosClassificacao":{"novoCriterio":"New classification criteria","novoCriterioInfo":"Register a custom criterion for this reconciliation plan","novoCriterioPortlet":"Classification criteria record"},"criteriosConciliacao":{"novoCriterio":"New reconciliation criteria","novoCriterioInfo":"Register a custom criterion for this reconciliation plan","novoCriterioPortlet":"Reconciliation criteria record","abrangencia":"Scope of the criteria","campoAplicacao":"Fields for applying the criteria","linkCamposConcil":"Establish the relationship between Financial and Banking's movements fields desired in conciliation:","modalConfirmaDivergenciaMaxNula":"Leaving the Max Divergence Value field empty will cause any difference in value to be reconciled as <span class='titulo'>Divergent</span>.<br/><br/>Do you want to continue anyway?","modalOpcaoConfirmar":"Confirm","modalOpcaoCancelar":"Cancel"}},"validacao":{"naoPodeEditar":"This plan can not be changed","tamanhoNome":"Plan name can not be longer than 40 characters","nomeObrigatorio":"The reconciliation plan name is mandatory","nomesIguais":"There is already a reconciliation plan registered under this name","objetoInvalido":"Poorly structured item. Review the required fields.","criterioNomeRepetido":"There is already a classification criteria registered under this name","criterioEmUso":"You cannot edit criterias once they have been applied to the posting classification, just inactivate them.","criterioEmUsoExcluir":"You cannot delete criterias once they have been applied to the posting classification, just inactivate them.","criterioEmUsoEditar":"You cannot edit criterias once they have been applied to the posting classification, just inactivate them.","criterioPersistido":"Once saved, criteria cannot be removed, just inactivate them.","criterioConcilNomeRepetido":"There is already a reconciliation criteria registered under this name","criterioConcilEmUsoEditar":"You cannot edit criterias once they have been applied to the posting conciliation, just inactivate them.","criterioConcilEmUsoExcluir":"You cannot delete criterias once they have been applied to the posting conciliation, just inactivate them."},"sucesso":{"salvar":"Reconciliation plan successfully created!","atualizar":"Reconciliation plan successfully updated!","criterioAdicionado":"Criteria added to the plan.","criterioAlterado":"Criteria updated.","remover":"Conciliation plan successfully removed"},"erro":{"salvar":"Error creating reconciliation plan!","atualizar":"Error editing reconciliation plan!","remover":"Error removing reconciliation plan!"}},"analiseDuplicidade":{"mensagem":{"anulacaoSucesso":"Transaction(s) successfully annulled!","reverterAnulacaoSucesso":"Reversal of annulment for the selected transaction(s) done successfully!","confirmarAnularLancamento":"Confirm annulment of the selected transaction(s)?","confirmarReverterAnulacao":"Confirm reversal of annulment for the selected transaction(s)?","solicitacaoExclusaoSucesso":"The exclusion request for the remittance was successfully made."},"titulos":{"titulo":"Duplicate analysis","subtitulo":"Check duplicated and annulled transactions. Annul duplicates and reverse annulled ones, if necessary."},"labels":{"listaDuplicado":"Duplicate Transactions Filter","listaAnulado":"Annulled Transactions Filter","buscar":"Search","anularLancamento":"Annul Transaction","reverterAnulacao":"Reverse Annulment","camposAvaliados":{"titulo":"Evaluated Fields","historico":"History","complemento":"Complement","fitid":"FITID","documento":"Document"},"sim":"Yes","nao":"No","contasBancarias":"Bank Accounts","selecionarContasBancarias":"Select Bank Accounts","alertaGridAnularLancamneto":"* It is not possible to annul reconciled transactions, so you cannot select them. These transactions are displayed only for comparison purposes.","alertaGridReverterAnulacao":"* Reverse transactions that were annulled mistakenly."}},"modalLogAuditoria":{"nomeUsuario":"User name","login":"Login","funcionalidade":"Functionality","transacaoRealizada":"Transaction performed","dataTransacao":"Transaction date","ipAcesso":"Access IP","estacaoTrabalho":"Workstation","entidade":"Entity","idEntidade":"Entity unique identification","perfilAcesso":"Acces profile","imprimir":"Print","titulo":"Audit log","subtitulo":"Detailed informations"},"filterPortlet":{"defaultTitle":"Filters"},"contaBancaria":{"labels":{"contaBancaria":"Bank account","contasBancarias":"Bank accounts","agencia":"Agency","digitoAgencia":"Agency digit","numeroConta":"Account number","digitoConta":"Account digit","banco":"Bank","selecionarBanco":"Select a bank","novaConta":"New account","nome":"Name","visualizacao":"Manage your bank accounts information","dataSaldo":"Balance date","saldoInicial":"Start balance","semGrupo":"Without Group","status":"Status","ativa":"Active","inativa":"Inactive","contaEmUso":"* Blocked fields cannot be changed as the account is being used in the system","confirmarDelete":"Are you sure you want to delete this bank account?","deleteBloqueado":"Accounts in use by the application cannot be deleted.","delete":"Delete bank account","editar":"Edit bank account","emUso":"In use *","headerEmUso":"* A bank account is considered to be in use if it has: processing (with or without postings) and/or sorting/reconciliation criteria associated with it."},"titulos":{"contaBancaria":"Bank account","contasBancarias":"Bank accounts","novaContaBancaria":"New bank account","editarContaBancaria":"Editing bank account","cadastroSubtitulo":"Manage bank accounts"},"sucesso":{"salvar":"Bank account successfully created!","atualizar":"Bank account successfully updated!","remover":"Bank account successfully deleted!"},"erro":{"salvar":"Error creating bank account!","atualizar":"Error editing bank account!","remover":"Error deleting bank account!","banco":{"naoEncontrado":"Bank not found"},"agencia":{"naoEncontrado":"Agency not found for the informed bank"},"recalcularSaldo":"Error recalculating initial balance"},"validacao":{"nomesIguais":"A bank account with the same name already exists","contasIguais":"This account is already registered in the system","dataSaldoVazio":"The balance date must be filled in to register the balance","saldoVazio":"The amount of the balance must be filled in to register the balance"}},"motivoOcorrencia":{"titulos":{"cadastroTitulo":"Occurrence reason","listagemTitulo":"Occurrence reasons","cadastroSubtitulo":"Manage occurrence reasons","listagemSubtitulo":"Manage your occurrence reasons"},"labels":{"novo":"New reason","novoPortlet":"New occurrence reason","editar":"Edit occurrence reason","remover":"Delete occurrence reason","sigla":"Code","descricao":"Description","categoria":"Category","acoes":"Actions","confirmarDelete":"Are you sure you want to delete this occurrence reason?","removeBloqueio":"You cannot remove the occurrence reason, as it is being used by the system."},"validacao":{"siglaObrigatorio":"Field 'Code' is required.","descricaoObrigatorio":"Field 'Description' is required."},"sucesso":{"criar":"Occurrence reason successfully created!","editar":"Occurrence reason successfully updated!","remover":"Occurrence reason successfully removed!"},"erro":{"criar":"Error creating occurrence reason!","editar":"Error creating occurrence reason!","motivoCadastrado":"An occurrence reason registered with the same code already exists."}},"extratoBancario":{"labels":{"contasBancarias":"Bank accounts","selecionarContasBancarias":"Select bank accounts","buscar":"Find","periodo":"Period","alertaGrid":"* Depending on the sorting, grouping and filtering criteria the values in the 'Balance' column should be disregarded.<br/>** Column prefixes: CL = Account Entry, E = Establishment.","saldoVazio":"No balance record to date ({DIA_ANTERIOR})","consultaApenasNaoClassif":"Unclassified statements","consultaApenasClassif":"Classified statements","naoClassificado":"Unclassified"},"titulos":{"extratoBancario":"Bank statement","visualize":"Check your bank's launches","filtroTitulo":"Bank statements' searching filters"}},"geral":{"usuario":{"erro":{"buscar":{"usuarioNaoExiste":"User does not exist"}}},"labels":{"opcional":" - optional","semResultadosSingular":"No results were found for the chosen parameter.","semResultadosPlural":"No results were found for the chosen parameters.","listaVazia":"The list is empty.","carregando":"Loading...","digiteParaPesquisar":"Type to start searching"},"loading":{"andamento":"In progress","preparandoGrid":"Preparing grid","preparandoArquivo":"Preparing file"},"perguntas":{"sairPagina":"Do you wish to leave?\nUnsaved modifications will be lost."}},"movimentosFinanceiros":{"titulos":{"titulo":"Financial movements","subtitulo":"Check the launches of your internal system","filtroTitulo":"Financial movements' searching filters","modalPlanoTitulo":"Reconciliation plans","modalPlanoSubtitulo":"Select reconciliation plans","modalEstabelecimentoTitulo":"Establishments","modalEstabelecimentoSubtitulo":"Select establishments"},"labels":{"periodo":"Period","planosConciliacao":"Reconciliation plans","selecionarPlanos":"Select reconciliation plans","estabelecimentos":"Establishments","selecionarEstabelecimentos":"Select establishments","conciliacao":"Situation","alertaGrid":"* Column prefixes: MF = Financial Movement, E = Establishment."}},"statusConciliacao":{"aberto":"Opened","conciliado":"Conciliated","divergente":"Divergent","naoAplicavel":"Not applicable","conciliadoManualmente":"Manually conciliated"},"naoEncontrado":{"labels":{"mensagem":"Sorry, we could not find the page.","voltarHome":"Back to home"}},"naoAutorizado":{"labels":{"mensagem401":"Your session has expired. Please login again.","mensagem":"You do not have permission to open this page.","mensagemRedirect":"You will be redirected soon...","voltarHome":"Back to home","operadorSemCliente":"This user is not connected to any client. Check with your system administrator!","usuarioNaoEncntrado":"No user was found for the reported data."}},"session":{"labels":{"erro":"There was an error with your session. Please login again."}},"arquivoProcessado":{"erro":{"listar":"The information about this file could not be found."}},"arquivosProcessados":{"titulos":{"titulo":"Processed files","subtitulo":"Track the processing of your files","filtro":"Processed files' searching filters"},"labels":{"buscar":"Search"},"erros":{"periodoLimitado":"The maximum search period is {dias} days"}},"remessaIntegracao":{"mensagem":{"sucesso":"Request successful. In a moment the file will be available for download","confirmar":"Do you confirm request for a new financial statement file processing?","periodoExistente":"Already exists an integration shipment with information from the requested period. When generating this new shipment the information that has already been integrated won't be duplicated.","confirmarExclusao":"Are you sure you want to delete the selected remittance for integration? This process may take several minutes to complete.","solicitacaoExclusaoSucesso":"The request to delete the remittance was successfull"},"titulos":{"titulo":"Remittances for integration","subtitulo":"Download remittances for integration","filtro":"Search criteria to view remittances for integration","excluirRemessas":"Delete remittances","excluirRemessa":"Delete remittance"},"labels":{"novoArquivo":"New file","consultaPor":"Search By","dataGeracao":"Generation date of file","periodoMovimentacao":"Occurrence period of file","tipoRemessa":"Remittance Type","idsRemessa":"Remittance ID","digiteIdRemessa":"Enter the remittance ID","numeroSequencia":"Sequence number","digiteNumeroSequencia":"Enter the sequence number","comentariosAdicionais":"Additional comments","gerar":"Create","sim":"Yes","nao":"No","fechar":"Close","modal":{"tabs":{"resumo":"Summary"}}},"remessa":{"detalhar":{"modal":{"titulo":"Detail of the remittance for integration","subtitulo":"Information about the remittance to be sent for integration"},"resultado":{"P":"Processing","C":"Completed"},"tab":{"nomeArquivo":"File name","idRemessa":"Remittance ID","resultado":"Result","conteudo":"Content","sequencia":"Sequence","periodoContabil":"Accounting period","dataMovimentacaoInicial":"Report start date","dataMovimentacaoFinal":"Report end date","dataGeracaoArquivo":"File generation date","dataBase":"Source date","usuario":"User","observacao":"Note"}}},"tipoRemessa":{"listar":{"vazio":"There is no remittance type."}}},"relatorioConciliacao":{"titulos":{"titulo":"Reconciliation report","subtitulo":"Track the reconciliation of launches","tituloFiltro":"Reconciliation reports' searching filters"},"labels":{"contasBancarias":"Bank accounts","selecaoContaBancaria":"Select bank accounts","statusConciliacao":"Situation","exportarArquivo":"Export to file","pesquisaAvancada":"Advanced search","alertaGrid":"* Column prefixes: MB = Banking Movement, MF = Financial Movement, CL = Account Entry, E = Establishment."}},"parametro":{"naoEncontrado":"Parameter not found","incorreto":"Incorret parameter"},"conciliacaoManual":{"titulos":{"titulo":"Manual Reconciliation","subtitulo":"Manually reconcile pending postings","abaLancamentos":"Releases","abaLotes":"Lots","filtro":"Manual reconciliations' searching filters","gridMovimentosFinanceiros":"Financial movements","gridExtratoBancario":"Bank statements","gridLotes":"Available allotments","portletSelecionados":"Selected Statements","portletSelecionadosInterno":"Movements","portletSelecionadosBancario":"Statements","confirmacao":"Confirmation","justificativa":"Justification","justificativas":"Justifications","selecionarMotivo":"Determine the values and motives of the divergence","modalAllotmentDetailsTitle":"Allotment details","modalAllotmentDetailsSubtitle":"Check all entries from this allotment"},"labels":{"divergencia":"Divergence","reabrir":"Reopen batch","aplicar":"To apply","justificar":"Justify","totalLancamentos":"Qty. Releases","periodo":"Period","valorTotalInterno":"Total value","valorTotalBancario":"Total value","data":"Date","valor":"Value","situacao":"Status","conciliacaoDeLote":"Confirm batch reconciliation?","conciliacaoDeLoteDivergente":"Confirm divergent batch creation?","reabrirLote":"Do you want to reopen the entire batch?","acaoFechar":"No","acaoConfirmar":"Yes","limpar":"Clear","loteSelecionado":"Selected allotment","comentario":"Commentary","emProcessamento":"Processing...","aguarde":"Wait","valorJustificar":"Value to justify","naoJustificado":"Not justified","parcial":"Partial","total":"Total","motivoOcorrencia":"Reason for occurrence","tooltipJustificativa":"Difference between the value to be justified and the divergence","alertJustificativa":"The added justification will be lost if you leave the page. Do you wish to continue?","alertJustificativas":"The added justifications will be lost if you leave the page. Do you wish to continue?","adicionarTodos":"Add","reaplicarConciliacao":"Reapply automatic conciliation","salvandoInformacoes":"Saving information...","conciliacaoAutomatica":"Performing automatic conciliation..."},"validacao":{"selecionarItensMovFin":"You must select at least one Financial Transaction","selecionarItensBankStat":"You must select at least one movement from the Bank Statement"},"sucesso":{"loteConciliadoOk":"Batch %id% created and successfully reconciled!","loteDivergenteOk":"Divergent batch %id% created successfully!","loteReaberto":"Lot reopened successfully!","justificar":{"naoAplicavel":"Movments status changed to not applicable.","lote":{"conciliado":"Conciliated batch %id% successfully created.","divergente":"Divergent batch %id% successfully created."}},"lote":{"reabrir":"Lot reopened successfully!"},"reaplicarConciliacao":"Conciliation successfully applied!"},"erro":{"buscar":{"loteNaoExiste":"Lot does not exist","loteOuClienteNaoExiste":"Batch or customer does not exist","naoExistemMovimentacoesBancarias":"Bank transactions not found","naoExistemMovimentacoesFinanceiras":"Financial transactions not found","clienteNaoEncontrado":"Client not found"},"planoConciliacao":{"naoEncontrado":"Conciliation plan not found"},"nenhumLancamentoInterno":"No internal release","nenhumLancamentoBancario":"No bank posting","motivoOcorrenciaInvalido":"Invalid reason for occurrence","listar":"Error while listing drives","reaplicarConciliacao":"Error on reapplying conciliation","verificarProcessamentoConciliacao":"Error on verifying conciliation","jaExisteReaplicacaoEmAndamento":"There is already a conciliation in progress"}},"atributos":{"sucesso":{"listar":"Attributes successfully listed"},"erro":{"listar":"Error while listing atritbutes"}},"atributoValor":{"validacao":{"configuracaoNaoEncontrada":"Config not founda","vinculoNaoEncontrado":"Link not found","nomeAtributoNaoEncontrado":"Attribute name not found","clienteNaoEncontrado":"Client not found"}},"relatorioOcorrencia":{"titulos":{"titulo":"Occurrences","subtitulo":"Check all occurrences created","filtro":"Occurences' searching filters"},"labels":{"motivoOcorrencia":"Occurrence reasons","selecaoMotivoOcorrencia":"Select occurrence reasons"},"erro":{"erroConsulta":"Error while querying occurrences."}},"categoria":{"titulos":{"titulo":"Categories","subtitulo":"Manage system categories"},"labels":{"novaCategoria":"New category","editar":"To edit","criar":"Create Subcategory","remover":"Delete","expandir":"Expand","recolher":"Retract","credito":"Credit","debito":"Debit","creditoDebito":"Credit/Debit","carteiraDigital":"Digital Wallet","dataSaldo":"Balance Date","saldoInicial":"Start balance","descricao":"Description","acoes":"Actions","resultadoVazio":"No registered category found","selecionarCategoria":"Select categories","removerBloqueado":"You cannot remove the category as it is being used by the system.","confirmarDelete":"Are you sure you want to delete this category?"},"modal":{"titulo":{"novaCategoria":"New Category","edicaoCategoria":"Edit Category","novaSubCategoria":"New Subcategory","edicaoSubCategoria":"Edit Subcategory"},"subtitulo":{"novaCategoria":"Create a new category","edicaoCategoria":"Edit category information","novaSubCategoria":"Create a new subcategory","edicaoSubCategoria":"Edit subcategory information"},"labels":{"numero":"Number","descricao":"Description","idContabil":"Accounting Id","tipo":"Type","salvar":"Save","categoriaPai":"Parent Category","C":"Credit","D":"Debit","A":"Credit/Debit","W":"Digital Wallet","saldoInicial":"Start balance ($)","dataSaldoInicial":"Balance date"}},"sucesso":{"salvar":"Category successfully saved","buscar":"Category successfully listed","listar":"Categories successfully listed","remover":"Category removed successfully"},"erro":{"salvar":"Error saving category","buscar":"Error fetching category","listar":"Erro listing categories","remover":"Error removing category"},"subCategoria":{"sucesso":{"salvar":"Subcategory successfully saved","buscar":"Subcategory successfully listed","listar":"Subcategories successfully listed"},"erro":{"salvar":"Error saving subcategory","buscar":"Error fetching subcategory","listar":"Erro listing subcategories"},"validacao":{"numeroObrigatorio":"Subcategory number is required","nomeObrigatorio":"Subategory name is required","tipoObrigatorio":"Subcategory type is required","mesmoNome":"There is already a registered subcategory with the name entered"}},"validacao":{"numeroObrigatorio":"Category number is required","nomeObrigatorio":"Category name is required","tipoObrigatorio":"Category type is required","mesmoNome":"There is already a registered category with the name entered","saldoVazio":"The amount of the balance must be filled in to register the balance","dataSaldoVazio":"The balance date must be filled in to register the balance"}},"uploadArquivo":{"titulos":{"titulo":"Upload files","subtitulo":"Send the files to the processing queue","tituloFilter":"File upload","mensagemFilter":"After submission, it may take a few minutes for Equals to validate the content and process the file. <br/> The result of the processing can be consulted through the report <a href='/banking/arquivosProcessados' class='upload-link'> Processed files </a>","mensagemFilterDisabled":"The result of the processing can be consulted through the report <a href='/banking/arquivosProcessados' class='upload-link'> Processed files </a>"},"uploader":{"dictDefaultMessage":"<br/>To submit a file, drag or click here!","dictFallbackMessage":"Your browser does not support inline streaming.","dictFallbackText":"Please use the clickable area to select the files on your computer.","dictFileTooBig":"File too large ({{filesize}}MiB). Max size: {{maxFilesize}}MiB.","dictInvalidFileType":"You can not upload files of this type.","dictResponseError":"Upload failed.","dictMaxFilesExceeded":"You can not upload more files.","dictRemoveFile":"Remove","envioFalhou":"Upload failed!","envioOk":"Sent","dzInnerMessage":"You can add more files by dragging them or by clicking in the dashed area","envioDesabilitado":"<br/>Your file upload is disabled<br/>To release it, contact your system administrator."},"erro":{"geral":"Error uploading","regex":{"nome":"Invalid filename","extensao":"Invalid file extension","naoEncontrada":"There is no validation mask registered","invalida":"Validation mask registered with error, contact your system administrator."},"caminhoArquivo":"Invalid file path or layout","fileLayout":"File layout not found","permissaoUpload":"There is no permission to upload the file","enviroment":"No server selected","criacaoPasta":"Error creating folder. Please try again","caixaPostal":"Could not find a folder to upload. Please contact your administrator","naoFoiPossivelBuscarLayouts":"Unable to search registered layouts"},"sucesso":{"envioArquivo":"File uploaded successfully","logAuditoria":"Log saved successfully"}},"resumoConciliacao":{"titulos":{"titulo":"Conciliation summary","subtitulo":"Entries conciliation summary","tituloFiltro":"Conciliation summaries' searching filters"},"labels":{"movimentosFinanceiros":"Finanancial movement","extratoBancario":"Bank statement","dataBase":"Data base","relatorio":"Report","calendario":"Calendar"},"sucesso":{"listar":"Search conciliation summary successfully"},"erro":{"listar":"Error fetching conciliation summary"}},"modalDetalhesLanc":{"titulos":{"titulo":"Entry Details","subtitulo":"Visualize and perform actions with the releases","tituloTarefas":"Task details","subtituloTarefas":"View launch tasks","tabDetalhes":"Details","tabIntegracoes":"Integrations","tabHistorico":"History","tabLote":"Allotment","tabTarefas":"Tasks","tabClassif":"Classification"},"labels":{"valores":"Valores","lancamentoExcluido":"<b>Warning!</ b> This release has been deleted from the system."},"details":{"titulos":{"idlanc":"Entry Id","dtLanc":"Entry date","dtCont":"Accounting date","banco":"Bank","nmConta":"Account Name","agencia":"Agency number","nrConta":"Account number","cdHist":"Historical code","dsHist":"History","dsDoc":"Document number","dsTipo":"Type","vlDeb":"Debit entry","vlCred":"Credit entry","vlSaldo":"Balance","complemento":"Complement","cdCat":"Category code","dsCat":"Category","bancoOrig":"Origin bank","nrAgOrig":"Nr. agência origem","agenciaOrig":"Origin agency number","ocorrencia":"Occurrence reason","movFinanceiro":"Financial movement","extBancario":"Bank statement","divergencia":"Divergence","lote":"Allotment","statusConciliacao":"Conciliation status","idMovimento":"Movement Id","planoConciliacao":"Conciliation plan","valorLanc":"Entry value","valorOrigem":"Original value","lancCaixa":"Teller entry","nrTicket":"Ticket number","valorVendaBruto":"Gross sales value","valorVendaLiq":"Liquid sales value","processamento":"Processing","nomeTarefa":"Task name","situacaoTarefa":"Task situation","idEmpresa":"ID company","identificado":"Identified","adquirente":"Acquirer","bandeira":"Flag","tipoProduto":"Product type","origem":"Origin","valorBruto":"Gross value","valorComissao":"Commission value","comentario":"Commentary","estabelecimento":"Establishment","localizador":"Locator"}},"tabItegrations":{"labels":{"idProc":"Id","arquivo":"File name","sequencia":"Sequence","dtgen":"Generation","layout":"Layout","origem":"Source","dtproc":"Processing","origemInterno":"Internal","origemExterno":"External"}},"tabHistorico":{"labels":{"responsavel":"Responsible","status":"Status","idLote":"Allotment","acao":"Action","resultadoVazio":"No history found for this release"},"acao":{"CM":"Manual reconciliation","RL":"Reopen lot","JC":"Justified","CA":"Automatic reconciliation","EP":"Deletion of processing","CL":"Entry classification","IF":"Importation of financial movement"},"erro":{"listarHistorico":{"contaLancamento":"Unable to load posting history","movimentoFinanceiro":"Could not load history of financial movement","movimentacaoBancaria":"Could not load bank statement history"}},"sucesso":{"listarHistorico":{"contaLancamento":"Upload history uploaded successfully","movimentoFinanceiro":"History of the Financial Movement Loaded Successfully","movimentacaoBancaria":"Bank Statement History Loaded Successfully"}}},"tabLotes":{"labels":{"lancamentoSemVinculo":"This entry is not bound to an allotment","concilarManualmente":"Manually concile","idLote":"Allotment id","qtdLanc":"Number of entries","situacaoLote":"Situation","vlMovFin":"Financial movement","vlMovExt":"Bank statment","vlDivergencia":"Divergence","id":"Id","dtLanc":"Entry date","vlMovFinanc":"Financial mov. value","vlMovExtrato":"Bank stat. value","codOcorrencia":"Occurrence code","dsOcorrencia":"Occurrence","nmConta":"Account name","banco":"Bank","nrConta":"Account number","agencia":"Agency","qtdMovFin":"Numb. of financial mov.","qtdMovBan":"Numb. of bank stat.","periodo":"Period","critConcil":"Conciliation criteria used:"},"erro":{"erroDetalhes":"Failed to retrieve allotment details"}},"error":{"parseError":"Error in transcription of the data for detailing"},"tabTarefas":{"titulos":{"lancamentoSemTarefaAtiva":"There is no pending task in this statment right now.","lancamentoComTarefaAtiva":"Current task","historicoTarefas":"Task history","historicoAcoes":"Task actions history","atualizarStatus":"Update status"},"labels":{"msgNenhumaTarefa":"There is no task linked to this statment.","iniciarTarefa":"Start new task","novaTarefa":"New task","editarTarefa":"Edit","detalheTarefa":"Details","verDetalhe":"View task details","tipoVinculoMF":"Financial Movement","tipoVinculoCL":"Bank statment","reabrir":"Reopen","assumirTarefa":"Assign task to myself","salvarOcorrencia":"Change task status"},"datatableHistTarefa":{"colNome":"Name","colDesc":"Description","colTipo":"Bond type","colRes":"Responsible","colData":"Due date","colConclAuto":"Automatic completion"}},"tabClassif":{"btnSalvar":"Classify","btnEdit":"Reclassify","btnRemover":"Declassify","tooltipEstab":"You must enter the name of the desired establishment to pick it up at the base. The query results will be displayed in the listing.","tooltipClassificacao":"Only bank transactions with an 'Opened' status can have their classifications changed and/or removed.","infos":{"semPlanoConciliacao":"It is necessary to have a registered conciliation plan"},"critClassif":"Classification criteria used:","classifManual":"Manually classified","semClassif":"Not classified"}},"conjuntoAtributo":{"tipoAtributo":{"texto":"Text field","data":"Datepicker","combo":"Selection list (ComboBox)","numerico":"Numerical value"},"titulos":{"conjuntoAtributos":"Set of Attributes","titulo":"Attribute set","subtitulo":"Manage the set of system attributes","tituloNovo":"Set of Attributes","subtituloNovo":"Manage attribute sets","descricao":"Register sets of attributes and custom attributes","novoAtributo":"New attribute","adicionarAtributo":"New attribute","cadastroDeConjunto":"Set register and attributes","cadastre":"Register a custom attribute for this set","atributos":"Attributes","nomeDoConjunto":"Set name"},"infos":{"combo":"Mount a predefined list with the desired values.","datepicker":"Date field.","texto":"Field simple text, add a desired mask.","numerico":"Simple numeric field, add a desired mask.","dicaCombo":"Enter the desired value and press <b> Enter </ b> to add an option.","validacao":"Type the <b> Regular expression </ b> to validate the value of this attribute."},"labels":{"gerenciar":"Manage attribute set","novoConjunto":"New Set","configuracao":"Attribute Configuration","tipo":"Type","valoresPossiveis":"Possible values","nome":"Name","identificador":"Identifier","tipoVinculo":"Link type","quantidadeAtributos":"Number of attributes","E":"Establishment","MF":"Financial movement","CL":"Release account","criar":"Create attribute","containerConjunto":"Set register","containerAtributos":"Attributes","descricao":"Description","limpar":"Clear","adicionar":"Add","resultadoVazio":"No registered attribute set was found","nenhumResultado":"No set of attributes found!","mascara":"Mask","validacao":"Validation (RegExp)","salvar":"Save","cancelar":"Cancel","ordem":"Order","tipoDeVinculo":"Link type","arrasteParaReordenar":"Click on the attribute row and drag to set the order of appearance at the time of registration","removerBloqueado":"You cannot remove an attribute set that has been used in the posting composition by the system or that is associated with a reconciliation plan.","confirmarDelete":"Remove the attribute set will remove all attributes associated with it. Do you want to proceed?","cadastroBloquado":"There can only be one set of attributes for each available type!","cadastro":"Create new attribute set"},"tooltips":{"comboBox":"Mount a predefined list with the desired values"},"placeholders":{"infos":"Shopping Information","listaDeSelecao":"Selection list (Combo Box)"},"sucesso":{"atualizar":"Success when updating attribute set!","salvar":"Success saving attribute set!","listar":"Successful listing of attributes","adicionadoOk":"Attribute added to the set!","editadoOk":"Set attribute changed!","remover":"Attribute set removed successfully!"},"erro":{"camposObrigatorios":"Check the required fields!","criarConjunto":"Error creating attribute set!","nomesDuplicados":"Attribute names can not be duplicate!","nomeConjuntoObrigatorio":"Attribute set name is required!","tipoVinculoConjuntoObrigatorio":"Set link type is required!","listar":"Error while listing attributes","salvar":"Error while saving attribute set","atualizar":"Error while updating attribute set","atributo":{"ordemAtributoObrigatorio":"Order of appearance of attribute is required!","nomeAtributoObrigatorio":"Attribute names are required!","descricaoAtributoObrigatorio":"Attribute description required!","tipoAtributoObrigatorio":"Attribute type is required","atributoUtilizado":"It is not possible to edit this attribute, since it is already being used by the system","atributoTipoValor":{"valorObrigatorio":"You must set at least one value for your ComboBox!"},"excluir":"The attribute could not be deleted because it is already being used in the system"},"remover":"It wasn't possible to remove the attribute set."},"validacao":{"atributoEmUsoEditar":"Editing attributes that are in use by the system is not allowed.","atributoEmUsoExcluir":"It is not allowed to delete attributes that are in use by the system."},"types":{"STRING":"Text field","COMBO":"Selection box (Combo Box)","NUMBER":"Numerical value","DATE":"Datepicker"}},"tarefa":{"validacao":{"modificadaOutraSessao":"Task modified in another session","usuarioNaoEncotrado":"User not found","situacaoNaoPermitida":"Situation not allowed","vinculoExistente":"There is already an open or pending task for the bond","tipoVinculoNaoEncotrado":"Bond type not found","contaLancamentoNaoEncotrada":"Account entry not found","movimentoFinanceiroNaoEncotrado":"Financial movement not found","usuarioResponsavelNaoEncotrado":"Responsible user not found","clienteNaoEncotrado":"Client not found","dtVencimentoInvalida":"The due date can not be retroactive!"},"erro":{"cadastrar":"Error saving task","atualizar":"Error while updating task","reabrir":"Error reopening task","gravarOcorrencia":"Error saving occurrence","assumir":"Erro taking over task","buscar":"Error fetching task","email":"Error sending email to responsible","gravarEmMassa":"Error saving mass tasks"},"sucesso":{"cadastrar":"Task saved successfully","atualizar":"Task updated successfully","reabrir":"Task reopened successfully","gravarOcorrencia":"Occurence for task saved successfully","assumir":"Responsible user changed successfully","buscar":"Successfully obtained task","gravarEmMassa":"Tasks saved successfully"}},"auditoria":{"erro":{"salvar":"Error while saving audit log"}},"consultaTarefa":{"titulos":{"titulo":"Task query","subtitulo":"Search for all tasks created","filtroTitulo":"Tasks' searching filters"},"labels":{"baseConsulta":"Query base","todas":"All tasks","dataCriacao":"Creation date","dataVencimento":"Due date","dataConclusao":"Completion date/cancellation date","nenhumResultado":"No results found!","origem":"Source","MF":"Financial movement","CL":"Release account","situacaoLabel":"Situation","atribuidas":"Show only tasks assigned to me","situacao":{"pendente":"Pending","emAndamento":"In progress","aguardando":"Waiting for start","concluido":"Completed","cancelado":"Canceled"},"tarefaOutroCliente":"This task is associated with a statment from another client.","tarefaNãoEncontrada":"This task is no longer in the system.","tarefaLancamentoRemovido":"Warning! The original statment which this task was associated with has been deleted from the platform."},"sucesso":{"listar":"Job search made successful"},"erro":{"listar":"Error fetching jobs"}},"tarefaEmMassa":{"titulos":{"titulo":"Start tasks in bulk","subtitulo":"Create the same task for multiple statements","portletForm":"New task","portletTable":"Statements","enviarEmail":"Automatically send email to the person in charge"},"labels":{"nome":"Name","tipoVinculo":"Bond type","descricao":"Description","situacao":"Situation","dtVencimento":"Due date","responsavel":"Responsible","autoConc":"Automatically complete this task when","tipoCl":"Bank statment","tipoMf":"Financial movement","itemVinculado":"This statment already has a ","itemVinculadoStatus":{"emAndamento":"task in progress.","pendente":"pending task.","aguardando":"task waiting for start."},"removerLanc":"Remove statment","tarefasMistas":"The auto-complete option only affects financial movement postings."},"erro":{"semLancamentos":"You must select at least 1 launch on the grid."},"tarefaStatuses":{"pendente":"Pending","emAndamento":"In progress","aguardando":"Waiting for start","concluido":"Completed","cancelada":"Canceled"},"extrato":{"TipoMovBank":"Bank statment","IdLancamento":"Entry id","DtLanc":"Entry date","Banco":"Bank","NomeConta":"Account name","Agencia":"Agency","NrConta":"Account numb.","Tipo":"Type","Valor":"Value","DsCategoria":"Category","tipoCred":"Credit","tipoDeb":"Debit"},"movimento":{"TipoMovFin":"Financial movement","IdMov":"Movement id","Estabelecimento":"Establishment","PlanoConcil":"Conciliation plan","Situacao":"Situation"},"ocorrencia":{"IdLote":"Allotment","Ocorrencia":"Occurrence"}},"desclassificacaoEmMassa":{"titulos":{"titulo":"Mass Declassification","subtitulo":"Declassify entries that are classified and not reconciled","portletForm":"Number of selected entries that cannot be declassified","portletTable":"Number of selected entries that can be declassified","botao":"Mass Declassification"},"colunas":{"TipoMovBank":"Bank statement","IdLancamento":"Entry id","DtLanc":"Entry date","Banco":"Bank","NomeConta":"Account name","Agencia":"Agency","NrConta":"Account number","Tipo":"Type","Valor":"Value","CritClassif":"Classif. Criteria","DsHistorico":"History","tipoCred":"Credit","tipoDeb":"Debit"},"labels":{"fechar":"Close","desclassificar":"Declassify","removerLancamento":"Remove entry from declassification","desclassificarInvalido":"To proceed, you must select between 1 and 100 entries that can be declassified","sim":"Yes","nao":"No","confirmacao":"Are you sure you want to continue with the declassification? Remember that after completion, you should reload the report to bring in the updated data.","classificadoManualmente":"Manually classified"}},"logTransacao":{"NOVA_TAREFA":"New task","ALTERAR_TAREFA":"Edit task","NOVA_OCORRENCIA_TAREFA":"New occurrence","ASSUMIR_TAREFA":"Assume task","REABRIR_TAREFA":"Reopen task","CONSULTA_TAREFA":"Browse task"},"situacaoTarefa":{"PENDENTE":"Pending","EM_ANDAMENTO":"In progress","AGUARDANDO":"Waiting for start","CONCLUIDO":"Completed","CANCELADO":"Canceled"},"dashboard":{"titulos":{"portlet":"Displayed period: ","filtros":{"data":"By Date","lancamento":"By statment type","plano":"By conciliation plan"}},"filtro":{"data":{"estaSemana":"This week","ultimosSeteDias":"Last 7 days","esteMes":"This month","ultimosTrintaDias":"Last 30 days","mesAnterior":"Last month","personalizado":"Custom"},"tipo":{"E":"Bank statements","MF":"Financial transactions","T":"All"},"semOpcoes":"There is no other option available for this filter","semAgrupamento":"Without grouping"},"labels":{"resultadoVazio":"<i class='fa fa-pie-chart' aria-hidden='true'></i> <br> <span>No data to display<span>","contextButtonTitle":"Options","downloadJPEG":"Download JPG image","downloadCSV":"Download CSV","downloadPDF":"Download PDF","downloadPNG":"Download PNG image","downloadSVG":"Download SVG","downloadXLS":"Download XLS","printChart":"Print chart","viewData":"View data","valorTotal":"Amount"}},"estatistica":{"sucesso":{"atualizar":"Success when updating statistics"},"erro":{"periodoInvalido":"Invalid period","atualizar":"Error updating statistics"},"resumoConciliacao":{"titulo":"Distribution of conciliation","sucesso":{"pesquisar":"Success in getting reconciliation distribution"},"erro":{"pesquisar":"Error fetching reconciliation distribution"}},"resumoFinanceiro":{"titulo":"Sales by conciliation plan","sucesso":{"pesquisar":"Success in getting sales by conciliation plan"},"erro":{"pesquisar":"Error fetching sales by conciliation plan"}},"conciliacaoLote":{"titulo":"Reconciled launches"},"saldoBancario":{"titulo":"Balance in account","sucesso":{"pesquisar":"Success in getting balance in account"},"erro":{"pesquisar":"Error fetching balance in account"}},"tarefa":{"titulo":"Tasks","labels":{"naoConcluida":"Not completed","concluida":"Completed","movFinanceira":"Mov. financial","movBancaria":"Mov. bank","total":"Total","alertaVencidasSingular":"Task has won and needs your attention.","alertaVencidasPlural":"Tasks have won and need your attention.","alertaSemTarefasVencidas":"There are no overdue tasks.","dataProximoVencimento":"The next maturity will occur in","semDataProximoVencimento":"There are no tasks to overcome","visualizeTarefasConcluidas":"View completed tasks.","semTarefasConcluidas":"No tasks completed.","verQuaisSao":"See which ones clicking here."},"tooltip":{"vencidas":"View past due tasks","concluidas":"View completed tasks."},"sucesso":{"pesquisar":"Success in getting tasks"},"erro":{"pesquisar":"Error fetching tasks"}},"saldoCarteiraDigital":{"titulo":"Digital wallet balance","sucesso":{"pesquisar":"Success in getting digital wallet balance"},"erro":{"pesquisar":"Error fetching digital wallet balance"}}},"gadgets":{"sucesso":{"listar":"Success while displaying graphics","salvar":"Success saving graphics","atualizar":"Success updating graphics"},"erro":{"listar":"Error while displaying graphics","salvar":"Error saving graphics","atualizar":"Error updating graphics"}},"trocaApp":{"titulos":{"titulo":"Application Swapping","subtitulo":"Click below to choose which one to use"},"labels":{"voceAqui":"You are here"},"aplicacoes":{"banking":"Banking","cartoes":"Gestão de vendas com cartões","extrato":"Conciliação de Extratos Bancários","bandeiras":"Conciliação de Bandeiras","cobranca":"Gestão de Cobrança Bancária"},"erro":{"aplicacaiIndisponivel":"Application unavailable"}},"saldoBancario":{"labels":{"contasBancarias":"Bank accounts","selecionarContasBancarias":"Select bank accounts","buscar":"Search","periodo":"Period","alertaGrid":"* Depending on the ordering, grouping and filtering criteria, the values ​​in the 'Day Balance' column should be disregarded. <br/> ** In the column \"Previous Balance\", blocks highlighted in yellow represent balances registered manually via application."},"titulos":{"saldoBancario":"Bank balance","visualize":"Check the details of your bank balance.","filtroTitulo":"Bank balances' searching filters"}},"saldoCarteiraDigital":{"labels":{"carteirasDigitais":"Digital Wallet","selecionarCarteirasDigitais":"Select digital wallets","buscar":"Search","periodo":"Period","nome":"Name","alertaGrid":"* When information is grouped, the 'Day's balance' and 'Previous balance' columns should not be considered. Therefore, in these cases '0.00' will be displayed for the group, but the values will be displayed at the individual level."},"titulos":{"saldoCarteiraDigital":"Digital Wallet Balance","visualize":"Check the details of your digital wallet balance.","filtroTitulo":"Digital Wallet balances' searching filters"}},"downloads":{"labels":{"extratoBancario":"bankStatement","movimentacaoFinanceira":"financialMovement","relatorioConciliacao":"reconciliationReport","resumoConciliacao":"conciliationSummary"}},"movbancaria":{"sucesso":{"salvar":"Classification created successfully and conciliation applied again.","atualizar":"Classification changed successfully and conciliation applied again.","remover":"Classification removed successfully and conciliation applied again."}},"ofda":{"titulo":"Open Finance","compartilhar":"Share data (Optional)","tipoConta":"Account type","tipoContaPf":"Private person","tipoContaPj":"Legal entity","requisitante":"Requestor's name","cpfRequisitante":"Requestor's CPF","empresa":"Social name of the account holder","cnpjRequisitante":"CNPJ of the account holder","jaAutorizado":"This account is already authorized in Open Finance and is sharing data with our application!","statusAceite":{"revogado":"Repealed","autorizado":"Authorized","aguardando":"Waiting","autorizar":"Authorize"},"nenhumaInstituicaoHomologada":"There are no financial institutions approved in Open Finance Brasil associated with the data provided."},"calendarioConciliacao":{"detalhe":{"vlMovBanc":"Vl. Bank stat.","vlMovFinan":"Vl.Finanancial mov.","diferenca":"Diff Value","situacao":"Status","conciliadoManualmente":"Manual Conc.","movFinan":"Financial mov.","semLancamentos":"There are no informations registered on that date!","total":"Total","percent":"%","resumo":"Summary","detalhe":"Details"},"labels":{"seg":"Mon.","ter":"Tue.","qua":"Wen.","qui":"Thu.","sex":"Fri.","sab":"Sat.","dom":"Sun.","periodo":"Period","situacao":"Status","categoria":"Category"},"alerta":{"tooltipPercent":"Percentage of values for Financial Mov. + Bank Statements, by conciliation status, in relation to the aggregate total for the day/period."}}}

/***/ }),
/* 720 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./build/language/files/locale-pt.json ***!
  \*********************************************/
/***/ (function(module, exports) {

module.exports = {"login":{"sucesso":{"recuperarSenha":"Sua senha foi recuperada com sucesso, verifique seu e-mail","cadastrarSenha":"Senha cadastrada com sucesso!","alterarSenha":"Senha alterada com sucesso!","login":"Sucesso ao logar"},"erro":{"usuario":{"inativo":"Usuário inativo","senhaBloqueada":"Senha bloqueada","invalido":"Usuário inválido","diferente":"O e-mail do usuário não confere","senhaInvaida":"A senha não deve conter caractéres especiais e precisa ter de 3 e 20 caractéres."},"keyInvalida":"A chave é inválida","recuperarSenha":"Erro ao recuperar senha!","loginTitle":"Erro ao logar!","senha":"Senha incorreta!","verificarEmailSenha":"Verifique seu e-mail e senha.","emailValido":"Preencha um e-mail válido.","alterarSenha":"Erro ao alterar senha!","cadastrarSenha":"Erro ao cadastrar senha!","senhaVazia":"A senha não foi preenchida","senhaInvalida":"Senha inválida","senhaDiferente":"Verifique sua senha atual.","login":"Impossível autenticar usuário. Verifique os dados informados e tente novamente."},"validacao":{"recaptcha":"Verifique a confirmação de segurança.","emailVazio":"Preencha um e-mail.","emailInvalido":"E-mail inválido","senhaVazia":"Preencha sua senha.","confirmacaoDeSenha":"Preencha com a confirmação de senha","senhasDiferentes":"As senhas devem ser idênticas","sessaoInvalida":"Token expirado!","emulacao":{"naoPermitida":"Não foi possível realizar o login com os dados informados, tente novamente"}},"labels":{"idioma":"Idioma:","entrar":"Entrar","recuperarSenha":"Recuperar senha","cadastrarSenha":"Cadastrar senha","voltar":"Voltar","bemVindo":"Seja bem vindo!","esqueceuSenha":"Esqueceu sua senha?"},"placeholders":{"usuario":"Digite seu e-mail","senha":"Digite sua senha","confirmarSenha":"Confirme sua senha"},"titulos":{"pt":"Português","eng":"Inglês","esp":"Espanhol","recuperarSenha":"Recuperar senha","entrar":"Entrar no Banking!","cadastrarSenha":"Cadastrar senha!","abrirSelecaoDeIdioma":"Abrir seleção de idioma","fecharSelecaoDeIdioma":"Fechar seleção de idioma","fechar":"Fechar","voltar":"Voltar para o login"}},"modalCliente":{"labels":{"clientes":"Clientes","selecionar":"Selecionar","selecionado":"Selecionado","nome":"Nome"},"titulos":{"selecioneCliente":"Selecione o cliente"}},"modalMinhaConta":{"labels":{"minhaConta":"Minha conta","subtitulo":"Visualize ou altere seus dados","nome":"Nome","email":"E-mail","perfil":"Perfil de acesso","senha":"Senha","senhaAtual":"Senha atual","novaSenha":"Nova senha","confirmarSenha":"Confirmar senha","fechar":"Fechar","salvar":"Salvar"},"validacao":{"camposObrigatorios":"Verifique os campos obrigatórios.","senhasDiferentes":"As senhas devem ser idênticas"},"sucesso":{"salvar":"Dados alterados com sucesso!"},"erro":{"salvar":"Erro ao alterar dados."},"titulo":{"mostrarSenha":"Mostrar/esconder senha","mudarSenha":"Mudar senha"}},"menu":{"suspenso":{"minhaConta":"Minha conta","clientes":"Clientes","apps":"Aplicações","logout":"Logout"},"grupos":{"administracao":"Administração","registro":"Cadastros","integracao":"Integrações","conciliacao":"Conciliação","movimento":"Movimentos"},"funcionalidades":{"perfis":"Perfis de acesso","operadores":"Operadores","logs":"Logs de auditoria","contasBancarias":"Contas bancárias","gruposEstabelecimentos":"Grupos de estabelecimentos","estabelecimentos":"Estabelecimentos","categorias":"Categorias","planosConciliacao":"Planos de conciliação","motivosOcorrencia":"Motivos de ocorrência","atributos":"Conjunto de atributos","extratoBancario":"Extrato bancário","movimentosFinanceiros":"Movimentos financeiros","arquivosProcessados":"Arquivos processados","relatorioConciliacao":"Relatório de conciliação","conciliacaoManual":"Conciliação manual","relatorioOcorrencias":"Ocorrências","envioArquivos":"Envio de arquivos","resumoConciliacao":"Resumo de conciliação","tarefas":"Consulta de tarefas","saldoBancario":"Saldo bancário","saldoCarteiraDigital":"Saldo carteira digital","analiseDuplicidade":"Análise de duplicidade","remessaIntegracao":"Remessas para integração"}},"administracao":{"perfilAcesso":{"sucesso":{"criado":"Perfil de acesso criado com sucesso!","editado":"Perfil de acesso editado com sucesso!"},"erro":{"criar":"Erro ao criar perfil de acesso!","editar":"Erro ao editar perfil de acesso!","duplicado":"Já existe um perfil de acesso com a descrição informada."},"labels":{"acoes":"Ações","novoPerfil":"Novo perfil","perfil":"Perfil","perfilInfo":"Descrição do perfil","visibilidade":"Visibilidade sobre estabelecimentos e contas bancárias","visibilidadeAcessaTodos":"Acesso à todos/todas","visibilidadeAcessaAlguns":"Acesso à alguns/algumas","salvar":"Salvar","proximo":"Próximo","cancelar":"Cancelar","voltar":"Voltar","funcionalidades":"Funcionalidades","selecionarTodos":"Selecionar todos","grupoFuncionalidade":"Grupo funcionalidade","hintEmularAcesso":"A Equipe Equals poderá acessar este perfil executando ações sobre as funcionalidades disponíveis. As ações executadas durante a emulação serão registradas no log de auditoria."},"titulos":{"perfisAcesso":"Perfis de acesso","novoPerfil":"Novo perfil de acesso","editarPerfil":"Editar perfil de acesso","cadastroSubtitulo":"Crie um novo perfil de acesso, selecionando a visibilidade sobre todos ou alguns estabelecimentos e contas bancárias","edicaoSubtitulo":"Edite o perfil de acesso, sua descrição, funcionalidades, a visibilidade de estabelecimentos e contas bancárias","listagemSubtitlo":"Gerencie os perfis de acesso ao sistema"},"validacao":{"naoPodeEditar":"Não é possível alterar este perfil","camposObrigatorios":"Verifique os campos obrigatórios.","tamanhoNome":"Nome do perfil não pode conter mais do que 40 caracteres"},"etapas":{"informacoesPerfil":"Informações do Perfil","estabelecimentos":"Estabelecimentos","contasBancarias":"Contas bancárias","confirmacao":"Confirmação"}},"operadores":{"sucesso":{"criado":"Operador criado com sucesso!","editado":"Operador editado com sucesso!"},"erro":{"criar":"Erro ao criar operador!","editar":"Erro ao editar operador!","usuarioClienteAplicacaoExistente":"Este operador já está cadastrado no sistema.","emailExistente":"Este email já está cadastrado no sistema."},"labels":{"situacao":"Situação","email":"Email","novoOperador":"Novo operador","editarOperador":"Editar operador","nome":"Nome","perfilAcesso":"Perfil de acesso","sexo":"Sexo","ativo":"Ativo","inativo":"Inativo","masculino":"Masculino","feminino":"Feminino","selecionarPerfil":"Selecione um perfil"},"titulos":{"operadores":"Operadores","cadastroSubTitulo":"Gerencie operadores","listagemSubtitlo":"Gerencie os operadores do sistema"},"validacao":{"camposObrigatorios":"Verifique os campos obrigatórios."}}},"estabelecimentos":{"sucesso":{"criado":"Estabelecimento criado com sucesso!","editado":"Estabelecimento editado com sucesso!","estabelecimentosAtualizados":"Estabelecimentos atualizados!","gruposDeEstabelecimentos":"Grupos de estabelecimentos carregados com sucesso!","movido":"Estabelecimento movido com sucesso"},"erro":{"criar":"Erro ao criar estabelecimento!","editar":"Erro ao editar estabelecimento!","carregar":"Erro ao carregar estabelecimento!","atualizar":"Erro ao atualizar estabelecimento!","gruposDeEstabelecimentos":"Erro ao carregar grupos de estabelecimentos!","nome":"O nome é de preenchimento obrigatório e deve conter no máximo 50 caracteres.","nomeFantasia":"O nome fantasia deve conter no máximo 50 caracteres.","cnpj":"O CNPJ deve conter 14 dígitos.","erroAoAtualizar":"Erro ao atualizar estabelecimentos!","ufs":"Erro ao atualizar UFs!","carregarCidades":"Erro ao carregar cidades!","atualizarCidades":"Erro ao atualizar cidades!","cnpjCadastrado":"CNPJ já cadastrado.","grupoEstabelecimentosInput":"Grupo de estabelecimento deve conter no máximo 20 caracteres.","cnpjInvalido":"CNPJ inválido.","cpfInvalido":"CPF inválido.","carregarAtributos":"Erro ao carregar atributos para estabelecimentos.","semAtributos":"Sua empresa ainda não tem nenhum atributo cadastrado.","atributoValidacaoFail":"O valor informado não atende aos requisitos de validação definidos.","mesmoNome":"Já existe um estabelecimento com o mesmo nome.","salvar":"Erro ao salvar estabelecimento!","origemDestinoIguais":"Os estabelecimentos de origem e destino não podem ser iguais","moverEstabelecimento":"Erro ao mover o estabelecimento","excluirEstabelecimentoVinculado":"Não é possível o excluir estabelecimento de origem, pois o mesmo possui vínculo com plano/critério de conciliação.","naoHouveLancamentosExcluiuEstabelecimento":"Não haviam lançamentos a serem movidos. O estabelecimento de origem foi excluído.","naoHouveLancamento":"Não haviam lançamentos a serem movidos."},"labels":{"estabelecimento":"Estabelecimento","estabelecimentos":"Estabelecimentos","grupoEstabelecimento":"Grupo estabelecimento","visualizacao":"Gerencie seus estabelecimentos","cadastre":"Gerencie estabelecimentos","nome":"Nome","cnpj":"CNPJ","cidade":"Cidade","grupoDeEstabelecimentos":"Grupo","situacao":"Situação","ativo":"Ativo","inativo":"Inativo","pesquisar":"Pesquisar","salvar":"Salvar","cancelar":"Cancelar","mover":"Mover","sim":"Sim","nao":"Não","novoEstabelecimento":"Novo estabelecimento","editarEstabelecimento":"Editar estabelecimento","moverEstabelecimento":"Mover estabelecimento","nomeFantasia":"Nome fantasia","cidadeEstado":"Cidade/Estado","uf":"UF","acoes":"Ações","nenhumResultado":"Nenhum resultado encontrado!","estabbelecimentoAtributos":"Atributos","btnProximo":"Próximo","selecaoColunas":"Selecione os atributos que deseja exibir na consulta","selecionarTodosPagina":"Selecionar todos da página","tooltipInfo":"Todos os estabelecimentos serão considerados caso o campo fique vazio.","estabelecimentoOrigem":"Estabelecimento de origem","estabelecimentoDestino":"Estabelecimento de destino","excluirEstabelecimentoOrigem":"Deseja excluir o estabelecimento de origem?","confirmacaoMoverEstabelecimento":"Deseja realmente mover o estabelecimento de origem para o estabelecimento de destino?","apenasMoverLancamento":"Deseja apenas mover os lançamentos?","filtroTitulo":"Filtros para consulta de estabelecimentos","filtro":{"buscar":"Digite o nome...","listaVazia":"Não há resultados.","semResultado":"Não foi encontrado nenhum estabelecimento.","selecionar":"Selecionar estabelecimento"},"alertaGrid":"* Prefixo das colunas: E = Estabelecimento."},"placeholders":{"selecaoColunas":"Selecione um atributo a ser exibido"},"titulos":{}},"dataTable":{"labels":{"contagem":"Exibindo {from} a {to} de {count} registros","semResultados":"Nenhum resultado","filtrar":"Filtrar","filtroPlaceholder":"Filtrar por","acaoAplicar":"Aplicar","acaoFechar":"Fechar","visualizacaoPorGrupos":"Visualização por grupos","mostrarContasInativas":"Mostrar contas inativas","registrosPorPagina":"Registros por página"}},"logDeAuditoria":{"sucesso:":{},"erro":{},"validacao":{},"labels":{"logDeAuditoria":"Log de auditoria","periodo":"Período","operadores":"Operadores","funcionalidades":"Funcionalidades","entidades":"Entidades","identificacaoUnica":"Identificação única da entidade do sistema","selecionarOperador":"Selecionar operadores","selecionarFuncionalidades":"Selecionar funcionalidades","selecionarEntidades":"Selecionar entidades","selecionarIdDaEntidade":"Selecionar Id da entidade","buscar":"Buscar","entidade":"Entidade","descricao":"Descrição"},"placeholders":{},"titulos":{"listagemSubtitlo":"Confira todos os acessos ao sistema","filtroTitulo":"Filtros para consulta de logs de auditoria"}},"botoesExportacoes":{"titulos":{"tooltipCsv":"Exportar .CSV!","tooltipXls":"Exportar .XLS!","tooltipImprimir":"Imprimir tabela!","tooltipExport":"Exportar"}},"GENERAL":"Favor entrar em contato com o Administrador","TIMEOUT":"O tempo da requisição expirou.","error":{"gruposFuncionalidades":{"invalid":"Grupo de funcionalidades inválido","listar":"Erro ao listar grupo de funcionalidades","listarGrupoEFuncionalidades":"Erro ao listar grupo de funcionalidades e suas funcionalidades"},"perfilDuplicado":"Nome do perfil já utilizado","perfilAcesso":{"invalid":"Perfil inválido","listar":"Erro ao listar perfil de acesso","salvar":"Erro ao salvar perfil de acesso","buscar":"Erro ao buscar perfil de acesso"},"salvarOperador":{"mesmoEmail":"Email já cadastrado para outro operador"},"update":{"perfil":{"invalid":"Perfil inválido"}}},"validacao":{"campoObrigatorio":"Campo obrigatório","emailInvalido":"Email inválido","somenteNumeros":"Somente números","select":{"placeholder":"Selecione uma opção","nenhum":" - Vazio - "}},"inputTag":{"labels":{"todos":"Todos","todas":"Todas","novo":"novo"}},"dateRange":{"labels":{"ate":"até"},"validacao":{"periodoMaximo":"Período máximo de %dias% dias","dataInicialMaiorFinal":"A data final deve ser maior ou igual a data inicial","dataInicialInvalida":"A data inicial informada é uma data inválida.","dataFinalInvalida":"A data final informada é uma data inválida.","dataVazia":"As datas de período não podem ser vazias.","dataInvalida":"A data preenchida é inválida!"}},"planoConciliacao":{"labels":{"gerenciar":"Gerenciar plano de conciliação","criar":"Criar plano","acoes":"Ações","novoPlano":"Novo plano","plano":"Nome do plano","visibilidade":"Visibilidade","planoInfo":"Informações do plano","salvar":"Salvar","voltar":"Cancelar","nomePlano":"Nome","escolhaPlano":"Selecione um plano de conciliação","historico":"Regex Histórico","categoria":"Categoria","ordem":"Ordem","criteriosClassificacao":"Critérios de Classificação","criteriosConciliacao":"Critérios de Conciliação","relevancia":"Relevância","relevante":"Relevante","irrelevante":"Irrelevante","status":"Status","ativo":"Ativo","inativo":"Inativo","resultadoVazio":"Não foram encontrados planos de conciliação.","descricao":"Descrição","tipo":"Tipo","criterios":"Critérios","addCriterio":"Adicionar critério","criterioReordenar":"Clique no critério desejado e arraste para definir a ordem de prioridade durante a conciliação","criterioEmUso":"Critério em uso","tipoLancamento":{"C":"Crédito","D":"Débito","A":"Crédito/Débito","W":"Carteira Digital","texto":"Tipo do lançamento"},"descricaoCriterio":"Descrição do critério","detalheCriterio":"Detalhes do critério","associacaoCategoria":"Associar lançamentos à Categoria","aplicarCriterio":"Quando aplicar o critério","mascaraHistorico":"Máscara do histórico do lançamento","mascaraComplemento":"Máscara do complemento do lançamento","codigoHistorico":"Código do histórico do lançamento","febraban":"Categoria FEBRABAN","banco":"Banco","conta":"Conta Bancária","chaveRelacionamento":"Campos da classificação","conjuntoAtributo":"Conjunto de atributos","atributo":"Nome do atributo","conciliacaoCampo":"Campo da conciliação","adicionar":"Adicionar","remover":"Remover","nenhumItem":"Nenhum","editar":"Editar","minDiasDif":"Qtd dias mín.","maxDiasDif":"Qtd dias máx.","vlDifMax":"Diferença máx.","vlDiverMax":"Divergência máx.","diasMinimo":"Número mínimo de dias","diasMaximo":"Número máximo de dias","valorDiferenca":"Valor máx. de diferença","valorDivergencia":"Valor máx. de divergência","motivoOcorrencia":"Motivo de ocorrência","movFinan":"Movimento Financeiro","movBan":"Movimento Bancário","removerBloqueado":"Você não pode remover planos de conciliação que tenham sido utilizados na classificação/conciliação de lançamentos pelo sistema.","confirmarDelete":"Remover o plano de conciliação irá excluir todos os critérios associados à ele. Deseja prosseguir?","cadastroPlano":"Criar novo plano de conciliação","cadastroPlanoBloquado":"Só pode haver um único plano de conciliação para cada cliente."},"titulos":{"planosConciliacao":"Planos de conciliação","visualizacao":"Gerencie seus planos de conciliação","novoPlanoConciliacao":"Novo plano de conciliação","editarPlanoConciliacao":"Editar plano conciliação","cadastroSubtitulo":"Gerencie planos de conciliação","criteriosClassificacao":{"novoCriterio":"Novo critério de classificação","novoCriterioInfo":"Cadastre um critério personalizado para este plano de conciliação","novoCriterioPortlet":"Cadastro de critério de classificação"},"criteriosConciliacao":{"novoCriterio":"Novo critério de conciliação","novoCriterioInfo":"Cadastre um critério personalizado para este plano de conciliação","novoCriterioPortlet":"Cadastro de critério de conciliação","abrangencia":"Abrangência do critério","campoAplicacao":"Campos para aplicação do critério","linkCamposConcil":"Estabeleça a relação entre campo do Mov. Financeiro e do Mov. Bancário desejado na conciliação:","modalConfirmaDivergenciaMaxNula":"Deixando o campo Valor máx. de divergência vazio fará com que qualquer diferença de valor seja conciliado como <span class='titulo'>Divergente</span>.<br/><br/>Deseja seguir mesmo assim?","modalOpcaoConfirmar":"Confirmar","modalOpcaoCancelar":"Cancelar"}},"validacao":{"naoPodeEditar":"Não é possível alterar este plano","tamanhoNome":"Nome do plano não pode conter mais do que 40 caracteres","nomeObrigatorio":"Nome do plano é obrigatorio","nomesIguais":"Já existe um plano de conciliação com o mesmo nome","objetoInvalido":"Item mal estruturado. Revise os campos obrigatórios.","criterioNomeRepetido":"Já existe um critério de classificação com o mesmo nome","criterioEmUsoEditar":"Você não pode editar critérios uma vez que eles tenham sido aplicados na classificação de lançamentos, apenas inativá-los.","criterioEmUsoExcluir":"Você não pode excluir critérios uma vez que eles tenham sido aplicados na classificação de lançamentos, apenas inativá-los.","criterioPersistido":"Uma vez salvos, critérios não podem ser removidos, apenas inativados.","criterioConcilNomeRepetido":"Já existe um critério de conciliação com o mesmo nome","criterioConcilEmUsoEditar":"Você não pode editar critérios uma vez que eles tenham sido aplicados na conciliação de lançamentos, apenas inativá-los.","criterioConcilEmUsoExcluir":"Você não pode excluir critérios uma vez que eles tenham sido aplicados na conciliação de lançamentos, apenas inativá-los."},"sucesso":{"salvar":"Plano de coniliação criado com sucesso","atualizar":"Plano de conciliação editado com sucesso","criterioAdicionado":"Critério adicionado ao plano.","criterioAlterado":"Critério alterado.","remover":"Plano de coniliação removido com sucesso"},"erro":{"salvar":"Erro ao criar plano de conciliação","atualizar":"Erro ao atualizar plano de conciliação","remover":"Erro ao remover Plano de conciliação"}},"analiseDuplicidade":{"mensagem":{"anulacaoSucesso":"Lançamento(s) anulado(s) com sucesso!","reverterAnulacaoSucesso":"Reversão da anulação do(s) lançamento(s) feita com sucesso!","confirmarAnularLancamento":"Confirma a anulação do(s) lançamento(s) selecionado(s)?","confirmarReverterAnulacao":"Confirma a reversão de anulação do(s) lançamento(s) selecionado(s)?","solicitacaoExclusaoSucesso":" A solicitação da exclusão da remessa foi realizada com sucesso"},"titulos":{"titulo":"Análise de duplicidade","subtitulo":"Verifique os lançamentos em duplicidade e os anulados. Anule os duplicados e reverta os anulados, caso seja necessário"},"labels":{"listaDuplicado":"Filtro de Lançamentos Duplicados","listaAnulado":"Filtro de Lançamentos Anulados","buscar":"Buscar","anularLancamento":"Anular lançamento","reverterAnulacao":"Reverter anulação","camposAvaliados":{"titulo":"Campos avaliados","historico":"Histórico","complemento":"Complemento","fitid":"FITID","documento":"Documento"},"sim":"Sim","nao":"Não","contasBancarias":"Contas bancárias","selecionarContasBancarias":"Selecionar contas bancárias","alertaGridAnularLancamneto":"* Não é possível anular lançamentos conciliados, portanto, não é possível selecioná-los. Esses lançamentos são exibidos apenas para fins de comparação.","alertaGridReverterAnulacao":"* Realize a reversão dos lançamentos que foram anulados equivocadamente."}},"modalLogAuditoria":{"nomeUsuario":"Nome do usuário","login":"Login","funcionalidade":"Funcionalidade","transacaoRealizada":"Transação realizada","dataTransacao":"Data da transação","ipAcesso":"IP de acesso","estacaoTrabalho":"Estação de trabalho","entidade":"Entidade","idEntidade":"Identificação única da entidade","perfilAcesso":"Perfil de acesso","imprimir":"Imprimir","titulo":"Log de auditoria","subtitulo":"Informações detalhadas"},"filterPortlet":{"defaultTitle":"Filtros"},"contaBancaria":{"labels":{"contaBancaria":"Conta bancária","contasBancarias":"Contas bancárias","agencia":"Agência","digitoAgencia":"Dígito agência","numeroConta":"Número conta","digitoConta":"Dígito conta","banco":"Banco","selecionarBanco":"Selecione o banco","novaConta":"Nova conta","nome":"Nome","visualizacao":"Gerencie as informações das suas contas bancárias","dataSaldo":"Data do saldo","saldoInicial":"Saldo inicial","semGrupo":"Sem Grupo","status":"Status","ativa":"Ativa","inativa":"Inativa","contaEmUso":"* Os campos bloqueados não podem ser alterados, pois a conta está sendo utilizada no sistema","confirmarDelete":"Tem certeza que deseja excluir esta conta bancária?","deleteBloqueado":"Contas em uso pela aplicação não podem ser excluídas.","delete":"Excluir conta bancária","editar":"Editar conta bancária","emUso":"Em uso *","headerEmUso":"* Um conta bancária é considerada em uso caso ela tenha: processamentos (com ou sem lançamentos) e/ou critérios de classificação/conciliação associados à ela."},"titulos":{"contaBancaria":"Conta bancária","contasBancarias":"Contas bancárias","novaContaBancaria":"Nova conta bancária","editarContaBancaria":"Editar conta bancária","cadastroSubtitulo":"Gerencie contas bancárias","listagemSubtitlo":"Gerencie as informações das suas contas bancárias"},"sucesso":{"salvar":"Conta bancária criada com sucesso!","atualizar":"Conta bancária editada com sucesso!","remover":"Conta bancária removida com sucesso!"},"erro":{"salvar":"Erro ao criar conta bancária!","atualizar":"Erro ao editar conta bancária!","remover":"Erro ao remover conta bancária!","banco":{"naoEncontrado":"Banco não encontrado"},"agencia":{"naoEncontrado":"Agência não encontrada para o banco informado"},"recalcularSaldo":"Erro ao recalcular o saldo inicial"},"validacao":{"nomesIguais":"Já existe uma conta bancária com o mesmo nome","contasIguais":"Esta conta já está cadastrada no sistema","dataSaldoVazio":"A data do saldo deve ser preenchida para cadastrar o saldo","saldoVazio":"O valor do saldo deve ser preenchido para cadastrar o saldo"}},"motivoOcorrencia":{"titulos":{"cadastroTitulo":"Motivo de ocorrência","listagemTitulo":"Motivos de ocorrência","cadastroSubtitulo":"Gerencie motivos de ocorrência","listagemSubtitulo":"Gerencie seus motivos de ocorrência"},"labels":{"novo":"Novo motivo","novoPortlet":"Novo motivo de ocorrência","editar":"Editar motivo de ocorrência","remover":"Remover motivo de ocorrência","sigla":"Código","descricao":"Descrição","categoria":"Categoria","acoes":"Ações","confirmarDelete":"Tem certeza que deseja excluir este motivo de ocorrência?","removeBloqueio":"Você não pode remover o motivo de ocorrência, pois ele está sendo utilizado pelo sistema."},"validacao":{"siglaObrigatorio":"Campo 'Código' é de preenchimento obrigatório.","descricaoObrigatorio":"Campo 'Descrição' é de preenchimento obrigatório."},"sucesso":{"criar":"Motivo de ocorrência criado com sucesso.","editar":"Motivo de ocorrência editado com sucesso.","remover":"Motivo de ocorrência removido com sucesso."},"erro":{"criar":"Erro ao criar motivo de ocorrência","editar":"Erro ao editar motivo de ocorrência","motivoCadastrado":"Já existe um motivo de ocorrência cadastrado com o mesmo código informado."}},"extratoBancario":{"labels":{"contasBancarias":"Contas bancárias","selecionarContasBancarias":"Selecionar contas bancárias","buscar":"Buscar","periodo":"Período","alertaGrid":"* Dependendo dos critérios de ordenação, agrupamento e filtro os valores da coluna 'Saldo' devem ser desconsiderados.<br/>** Prefixos das colunas: CL = Conta Lançamento, E = Estabelecimento.","saldoVazio":"Sem registro de saldo até a data ({DIA_ANTERIOR})","consultaApenasNaoClassif":"Lançamentos não classificados","consultaApenasClassif":"Lançamentos classificados","naoClassificado":"Não Classificado"},"titulos":{"extratoBancario":"Extrato bancário","visualize":"Confira os lançamentos do seu banco","filtroTitulo":"Filtros para consulta de extratos bancários"}},"geral":{"usuario":{"erro":{"buscar":{"usuarioNaoExiste":"Usuário não existe"}}},"labels":{"opcional":" - opcional","semResultadosSingular":"Não existem resultados para o parâmetro informado.","semResultadosPlural":"Não existem resultados para os parâmetros informados.","listaVazia":"A lista está vazia.","carregando":"Carregando...","digiteParaPesquisar":"Digite para começar a pesquisar"},"loading":{"andamento":"Em andamento","preparandoGrid":"Preparando grid","preparandoArquivo":"Preparando arquivo"},"perguntas":{"sairPagina":"Você deseja deixar esta página?\nAlterações que não foram salvas serão perdidas."}},"movimentosFinanceiros":{"titulos":{"titulo":"Movimentos financeiros","subtitulo":"Confira os lançamentos do seu sistema interno","filtroTitulo":"Filtros para consulta de movimentos financeiros","modalPlanoTitulo":"Planos de conciliação","modalPlanoSubtitulo":"Selecionar planos de conciliação","modalEstabelecimentoTitulo":"Estabelecimentos","modalEstabelecimentoSubtitulo":"Selecionar estabelecimentos"},"labels":{"periodo":"Período","planosConciliacao":"Planos de conciliação","selecionarPlanos":"Selecionar planos de conciliação","estabelecimentos":"Estabelecimentos","selecionarEstabelecimentos":"Selecionar estabelecimentos","conciliacao":"Situação","alertaGrid":"* Prefixos das colunas: MF = Movimento Financeiro, E = Estabelecimento."}},"statusConciliacao":{"aberto":"Em aberto","conciliado":"Conciliado","divergente":"Divergente","naoAplicavel":"Não aplicável","conciliadoManualmente":"Conciliado manualmente"},"naoEncontrado":{"labels":{"mensagem":"Desculpe mas não conseguimos encontrar a página.","voltarHome":"Voltar para página inicial"}},"naoAutorizado":{"labels":{"mensagem401":"Sua sessão expirou. Por favor, realize novo login.","mensagem":"Você não tem autorização para abrir essa página","mensagemRedirect":"Você será redirecionado em breve...","voltarHome":"Voltar para página inicial","operadorSemCliente":"Este usuário não está ligado a nenhum cliente. Procure o administrador do sistema!","usuarioNaoEncntrado":"Nenhum usuário foi encontrado para os dados informados."}},"session":{"labels":{"erro":"Ocorreu um erro com a sua sessão. Por favor, realize novo login."}},"arquivoProcessado":{"erro":{"listar":"Não foi possível consultar as informações sobre este arquivos."}},"arquivosProcessados":{"titulos":{"titulo":"Arquivos processados","subtitulo":"Acompanhe o processamento de seus arquivos","filtro":"Filtros para consulta de arquivos processados"},"labels":{"buscar":"Buscar"},"erros":{"periodoLimitado":"O período máximo para consulta é de {dias} dias"}},"remessaIntegracao":{"mensagem":{"sucesso":"Solicitação realizada com sucesso. Em instantes o arquivo será disponibilizado para download","confirmar":"Confirma a geração do arquivo de movimento financeiro?","periodoExistente":"Já existe uma remessa de integração com informações do período solicitado. Ao gerar esta nova remessa as informações que já foram integradas não serão duplicadas.","confirmarExclusao":"Confirma a exclusão da remessa para integração selecionada? Este processo pode levar alguns minutos para ser concluído.","solicitacaoExclusaoSucesso":" A solicitação da exclusão da remessa foi realizada com sucesso"},"titulos":{"titulo":"Remessa para integração","subtitulo":"Faça o download da remessa de integração","filtro":"Filtros para consulta de remessa para integração","filtroCriacao":"Detalhes do arquivo a ser gerado","excluirRemessas":"Excluir remessas","excluirRemessa":"Excluir remessa"},"labels":{"novoArquivo":"Novo arquivo","consultaPor":"Consultar por","dataGeracao":"Data de geração da remessa","periodoMovimentacao":"Período de movimentação da remessa","tipoRemessa":"Tipo de remessa","idsRemessa":"IDs remessa","digiteIdRemessa":"Digite o ID da remessa","numeroSequencia":"Número de sequencia","digiteNumeroSequencia":"Digite o número de sequencia","periodo":"Período","comentariosAdicionais":"Comentários Adicionais","gerar":"Gerar","sim":"Sim","nao":"Não","fechar":"Fechar","modal":{"tabs":{"resumo":"Resumo"}}},"remessa":{"gerar":{"modal":{"titulo":"Geração de arquivo de movimento financeiro","subtitulo":"Registro de geração de arquivo de movimento financeiro para integração com outros sistemas"}},"detalhar":{"modal":{"titulo":"Detalhe da Remessa para Integração","subtitulo":"Informações sobre a remessa a ser enviada para integração"},"resultado":{"P":"Processando","C":"Concluído"},"tab":{"nomeArquivo":"Nome do arquivo","idRemessa":"ID da remessa","resultado":"Resultado","conteudo":"Conteúdo","sequencia":"Sequência","periodoContabil":"Período contábil","dataMovimentacaoInicial":"Data de movimentação inicial","dataMovimentacaoFinal":"Data de movimentação final","dataGeracaoArquivo":"Data de geração do arquivo","dataBase":"Data base","usuario":"Usuário","observacao":"Observação"}}},"tipoRemessa":{"listar":{"vazio":"Não existe tipo de remessa."}}},"relatorioConciliacao":{"titulos":{"titulo":"Relatório de conciliação","subtitulo":"Acompanhe a conciliação dos lançamentos","tituloFiltro":"Filtros para consulta do relatório de conciliação"},"labels":{"contasBancarias":"Contas bancárias","selecaoContaBancaria":"Selecionar contas bancárias","statusConciliacao":"Situação","exportarArquivo":"Exportar para arquivo","pesquisaAvancada":"Pesquisa avançada","alertaGrid":"* Prefixos das colunas: MB = Movimento Bancário, MF = Movimento Financeiro, CL = Conta Lançamento, E = Estabelecimento."}},"parametro":{"naoEncontrado":"Parâmetro não encontrado","incorreto":"Parâmetro(s) incorreto(s)"},"conciliacaoManual":{"titulos":{"titulo":"Conciliação Manual","subtitulo":"Concilie manualmente os lançamentos pendentes","abaLancamentos":"Lançamentos","abaLotes":"Lotes","filtro":"Filtros para consulta das transações","gridMovimentosFinanceiros":"Movimentos financeiros","gridExtratoBancario":"Extrato bancário","gridLotes":"Lotes disponíveis","portletSelecionados":"Lançamentos Selecionados","portletSelecionadosInterno":"Movimentos","portletSelecionadosBancario":"Extrato","confirmacao":"Confirmação","justificativa":"Justificativa","justificativas":"Justificativas","selecionarMotivo":"Determine os valores e motivos da divergência","modalAllotmentDetailsTitle":"Detalhes do lote","modalAllotmentDetailsSubtitle":"Visualize os lançamentos deste lote"},"labels":{"divergencia":"Divergência","reabrir":"Reabrir lote","aplicar":"Aplicar","justificar":"Justificar","totalLancamentos":"Qtd. Lançamentos","periodo":"Período","valorTotalInterno":"Valor total","valorTotalBancario":"Valor total","data":"Data","valor":"Valor","situacao":"Situação","conciliacaoDeLote":"Confirma a conciliação do lote?","conciliacaoDeLoteDivergente":"Confirma a criação do lote divergente?","reabrirLote":"Deseja reabrir todo o lote?","acaoFechar":"Não","acaoConfirmar":"Sim","limpar":"Limpar","loteSelecionado":"Lote selecionado","comentario":"Comentário","emProcessamento":"Em processamento...","aguarde":"Aguarde","valorJustificar":"Valor a justificar","naoJustificado":"Não justificado","parcial":"Parcial","total":"Total","motivoOcorrencia":"Motivo de ocorrência","tooltipJustificativa":"Diferença entre o valor a justificar e a divergência","alertJustificativa":"A justificativa adicionada será perdida se você sair da página. Deseja continuar?","alertJustificativas":"As justificativas adicionadas serão perdidas se você sair da página. Deseja continuar?","adicionarTodos":"Adicionar","reaplicarConciliacao":"Reaplicar conciliação automática","salvandoInformacoes":"Salvando informações...","conciliacaoAutomatica":"Executando conciliação automática..."},"validacao":{"selecionarItensMovFin":"Você deve selecionar ao menos uma Movimentação Financeira","selecionarItensBankStat":"Você deve selecionar ao menos um movimento do Extrato Bancário"},"sucesso":{"loteConciliadoOk":"Lote %id% criado e conciliado com sucesso!","loteDivergenteOk":"Lote divergente %id% criado com sucesso!","loteReaberto":"Lote reaberto com sucesso!","justificar":{"naoAplicavel":"Situação dos lançamentos alterado para não aplicável.","lote":{"conciliado":"Lote conciliado %id% criado com sucesso","divergente":"Lote divergente %id% criado com sucesso"}},"lote":{"reabrir":"Lote reaberto com sucesso!"},"reaplicarConciliacao":"Conciliação reaplicada com sucessso!"},"erro":{"buscar":{"loteNaoExiste":"Lote não existe","loteOuClienteNaoExiste":"Lote ou cliente não existem","naoExistemMovimentacoesBancarias":"Movimentações bancárias não encontradas","naoExistemMovimentacoesFinanceiras":"Movimentações financeiras não encontradas","clienteNaoEncontrado":"Cliente não encontrado"},"planoConciliacao":{"naoEncontrado":"Plano de concilição não encontrado"},"nenhumLancamentoInterno":"Nenhum lançamento interno","nenhumLancamentoBancario":"Nenhum lançamento bancário","loteConciliadoNOk":"Erro ao conciliar lote!","loteReabertoNOK":"Lote reaberto com sucesso!","motivoOcorrenciaInvalido":"Motivo de ocorrência inválido","listar":"Erro ao listar movimentações","reaplicarConciliacao":"Erro ao reaplicar a conciliação","verificarProcessamentoConciliacao":"Erro ao verificar a reaplicação de conciliação","jaExisteReaplicacaoEmAndamento":"Já existe uma conciliação em andamento"}},"atributos":{"sucesso":{"listar":"Atributos listados com sucesso"},"erro":{"listar":"Erro ao listar atributos"}},"atributoValor":{"validacao":{"configuracaoNaoEncontrada":"Configuração não encontrada","vinculoNaoEncontrado":"Vinculo não encontrado","nomeAtributoNaoEncontrado":"Nome do atributo não encontrado","clienteNaoEncontrado":"Cliente não encontrado"}},"relatorioOcorrencia":{"titulos":{"titulo":"Ocorrências","subtitulo":"Confira todas as ocorrências criadas","filtro":"Filtros para consulta das ocorrências"},"labels":{"motivoOcorrencia":"Motivos de ocorrência","selecaoMotivoOcorrencia":"Selecionar motivos de ocorrência"},"erro":{"erroConsulta":"Erro durante a consulta de ocorrências."}},"categoria":{"titulos":{"titulo":"Categorias","subtitulo":"Gerencie as categorias do sistema"},"labels":{"novaCategoria":"Nova categoria","editar":"Editar","criar":"Criar subcategoria","remover":"Remover","expandir":"Expandir","recolher":"Retrair","credito":"Crédito","debito":"Débito","creditoDebito":"Crédito/Débito","carteiraDigital":"Carteira Digital","dataSaldo":"Data do saldo","saldoInicial":"Saldo Inicial","descricao":"Descrição","acoes":"Ações","resultadoVazio":"Não foi encontrada nenhuma categoria cadastrada","selecionarCategoria":"Selecionar categorias","removerBloqueado":"Você não pode remover a categoria, pois ela está sendo utilizada pelo sistema.","confirmarDelete":"Tem certeza que deseja excluir esta categoria?"},"modal":{"titulo":{"novaCategoria":"Nova Categoria","edicaoCategoria":"Editar Categoria","novaSubCategoria":"Nova Subcategoria","edicaoSubCategoria":"Editar Subcategoria"},"subtitulo":{"novaCategoria":"Crie uma nova categoria","edicaoCategoria":"Edite as informações da categoria","novaSubCategoria":"Crie uma nova subcategoria","edicaoSubCategoria":"Edite as informações da subcategoria"},"labels":{"numero":"Número","descricao":"Descrição","idContabil":"Id Contábil","tipo":"Tipo","salvar":"Salvar","categoriaPai":"Categoria pai","C":"Crédito","D":"Débito","A":"Crédito/Débito","W":"Carteira Digital","saldoInicial":"Saldo Inicial (R$)","dataSaldoInicial":"Data Saldo Inicial"}},"sucesso":{"salvar":"Categoria salva com sucesso","buscar":"Categoria listada com sucesso","listar":"Categorias listadas com sucesso","remover":"Categoria removida com sucesso"},"erro":{"salvar":"Erro ao salvar categoria","buscar":"Erro ao buscar categoria","listar":"Erro ao listar categoria","remover":"Erro ao remover categoria"},"subCategoria":{"sucesso":{"salvar":"Subcategoria salva com sucesso","buscar":"Subcategoria listada com sucesso","listar":"Subcategorias listadas com sucesso"},"erro":{"salvar":"Erro ao salvar subcategoria","buscar":"Erro ao buscar subcategoria","listar":"Erro ao listar subcategoria"},"validacao":{"numeroObrigatorio":"O número da subcategoria é obrigatório","nomeObrigatorio":"O nome da subcategoria é obrigatório","tipoObrigatorio":"o tipo da subcategoria é obrigatório","mesmoNome":"Já existe uma subcategoria cadastrada com o nome informado"}},"validacao":{"numeroObrigatorio":"O número da categoria é obrigatório","nomeObrigatorio":"O nome da categoria é obrigatório","tipoObrigatorio":"o tipo da categoria é obrigatório","mesmoNome":"Já existe uma categoria cadastrada com o nome informado","saldoVazio":"O valor do saldo deve ser preenchido para cadastrar o saldo","dataSaldoVazio":"A data do saldo deve ser preenchida para cadastrar o saldo"}},"uploadArquivo":{"titulos":{"titulo":"Envio de arquivos","subtitulo":"Envie os arquivos para a fila de processamento","tituloFilter":"Upload do arquivo","mensagemFilter":"Após o envio, o Equals poderá demorar alguns minutos para validar o conteúdo e processar o arquivo. <br/> O resultado do processamento poderá ser consultado através do relatório <a href='/banking/arquivosProcessados' class='upload-link'> Arquivos processados </a>","mensagemFilterDisabled":"O resultado do processamento poderá ser consultado através do relatório <a href='/banking/arquivosProcessados' class='upload-link'> Arquivos processados </a>"},"uploader":{"dictDefaultMessage":"<br/>Para enviar um arquivo, arraste ou clique aqui!","dictFallbackMessage":"Seu browser não suporta envio de arquivos por 'arrastar/soltar'.","dictFallbackText":"Por favor, utilize a área clicável para selecionar os arquivos do seu computador.","dictFileTooBig":"Arquivo muito grande ({{filesize}}MB). Tamanho máximo: {{maxFilesize}}MB.","dictInvalidFileType":"Você não pode fazer o upload de arquivos deste tipo.","dictResponseError":"Envio falhou.","dictMaxFilesExceeded":"Você não pode enviar mais arquivos.","dictRemoveFile":"Remover","envioFalhou":"Falha no envio!","envioOk":"Enviado","dzInnerMessage":"Você pode adicionar mais arquivos arrastando-os ou clicando na área tracejada","envioDesabilitado":"<br/>Seu envio de arquivos está desabilitado<br/>Para liberá-lo, contate o administrador do sistema"},"erro":{"geral":"Erro ao fazer upload","regex":{"nome":"Nome do arquivo inválido","extensao":"Extensão do arquivo inválida","naoEncontrada":"Não há máscara de validação cadastrada","invalida":"Máscara de validação cadastrada com erro, contate o administrador do sistema."},"caminhoArquivo":"Caminho ou layout do arquivo inválido","fileLayout":"Layout do arquivo não encontrado","permissaoUpload":"Não há permissão para fazer o upload do arquivo","enviroment":"Nenhum servidor selecionado","criacaoPasta":"Erro ao criar pasta. Favor tente novamente","caixaPostal":"Não foi encontrada a pasta para fazer o upload. Favor, entre em contato com o administrador","naoFoiPossivelBuscarLayouts":"Não foi possível consultar os layouts cadastrados"},"sucesso":{"envioArquivo":"Arquivo enviado com sucesso","logAuditoria":"Log salvo com sucesso"}},"resumoConciliacao":{"titulos":{"titulo":"Resumo de conciliação","subtitulo":"Resumo da situação de conciliação dos lançamentos","tituloFiltro":"Filtros para consulta do resumo de conciliação"},"labels":{"movimentosFinanceiros":"Movimentos financeiros","extratoBancario":"Extrato bancário","dataBase":"Data base","relatorio":"Relatório","calendario":"Calendário"},"sucesso":{"listar":"Busca de resumo de conciliação realizada com sucesso"},"erro":{"listar":"Erro ao buscar resumo de conciliação"}},"modalDetalhesLanc":{"titulos":{"titulo":"Detalhes do lançamento","subtitulo":"Visualize e realize ações com os lançamentos","tituloTarefas":"Detalhes da tarefa","subtituloTarefas":"Visualize as tarefas do lançamento","tabDetalhes":"Detalhes","tabIntegracoes":"Integrações","tabHistorico":"Histórico","tabLote":"Lote","tabTarefas":"Tarefas","tabClassif":"Classificação"},"labels":{"valores":"Valores","lancamentoExcluido":"<b>Atenção!</b> Este lançamento foi excluído do sistema."},"details":{"titulos":{"idlanc":"ID lançamento","dtLanc":"Data lançamento","dtCont":"Data contábil","banco":"Banco","nmConta":"Nome conta","agencia":"Nr. agência","nrConta":"Nr. conta","cdHist":"Cód. histórico","dsHist":"Histórico","dsDoc":"Nr. documento","dsTipo":"Tipo","vlDeb":"Lançamento débito","vlCred":"Lançamento crédito","vlSaldo":"Saldo","complemento":"Complemento","cdCat":"Cód. categoria","dsCat":"Categoria","bancoOrig":"Banco origem","nrAgOrig":"Nr. agência origem","agenciaOrig":"Agência origem","ocorrencia":"Motivo de ocorrência","movFinanceiro":"Movimento financeiro","extBancario":"Extrato bancário","divergencia":"Divergência","lote":"Lote","statusConciliacao":"Status conciliação","idMovimento":"ID movimento","planoConciliacao":"Plano de conciliação","valorLanc":"Valor lançamento","valorOrigem":"Valor original","lancCaixa":"Lançamento caixa","nrTicket":"Número ticket","valorVendaBruto":"Valor venda bruto","valorVendaLiq":"Valor venda líquido","processamento":"Processamento","nomeTarefa":"Nome tarefa","situacaoTarefa":"Situação tarefa","idEmpresa":"ID empresa","identificado":"Identificado","adquirente":"Adquirente","bandeira":"Bandeira","tipoProduto":"Tipo produto","origem":"Origem","valorBruto":"Valor bruto","valorComissao":"Valor comissão","comentario":"Comentário","estabelecimento":"Estabelecimento","localizador":"Localizador"}},"tabItegrations":{"labels":{"idProc":"Id","arquivo":"Nome do arquivo","sequencia":"Sequência","dtgen":"Geração","layout":"Layout","origem":"Origem","dtproc":"Processamento","origemInterno":"Interno","origemExterno":"Externo"}},"tabHistorico":{"labels":{"responsavel":"Operador","status":"Status","idLote":"Lote","acao":"Ação","resultadoVazio":"Não foi encontrado histórico para este lançamento"},"acao":{"CM":"Conciliação manual","RL":"Reabrir lote","JC":"Justificado","CA":"Conciliação automática","EP":"Exclusão de processamento","CL":"Classificação de lançamento","IF":"Importação de movimentação financeira"},"erro":{"listarHistorico":{"contaLancamento":"Não foi possível carregar o histórico dos lançamentos","movimentoFinanceiro":"Não foi possível carregar o histórico do movimento financeiro","movimentacaoBancaria":"Não foi possível carregar o histórico do extrato bancário"}},"sucesso":{"listarHistorico":{"contaLancamento":"Histórico dos lançamentos carregado com sucesso","movimentoFinanceiro":"Histórico do movimento financeiro carregado com sucesso","movimentacaoBancaria":"Histórico do extrato bancário carregado com sucesso"}}},"tabLotes":{"labels":{"lancamentoSemVinculo":"Este lançamento não está vinculado a um lote","concilarManualmente":"Conciliar manualmente","idLote":"Id do lote","qtdLanc":"Qtde de lançamentos","situacaoLote":"Situação","vlMovFin":"Movimentação financeira","vlMovExt":"Extrato bancário","vlDivergencia":"Divergência","id":"Id","dtLanc":"Dt. lançamento","vlMovFinanc":"Vl. movimento financeiro","vlMovExtrato":"Vl. ext. bancário","codOcorrencia":"Cód. ocorrência","dsOcorrencia":"Ocorrência","nmConta":"Nome da conta","banco":"Banco","nrConta":"Num. conta","agencia":"Agência","qtdMovFin":"Qtd. mov. financeiro","qtdMovBan":"Qtd. ext. bancário","periodo":"Período","critConcil":"Crit. de conciliação utilizado:"},"erro":{"erroDetalhes":"Falha ao recuperar detalhes do lote."}},"error":{"parseError":"Erro na transcrição dos dados para detalhamento."},"tabTarefas":{"titulos":{"lancamentoSemTarefaAtiva":"Não há nenhuma tarefa pendente neste lançamento no momento.","lancamentoComTarefaAtiva":"Tarefa atual","historicoTarefas":"Histórico de tarefas","historicoAcoes":"Histórico de ações","atualizarStatus":"Atualizar status"},"labels":{"msgNenhumaTarefa":"Não há nenhuma tarefa vinculada a este lançamento","iniciarTarefa":"Iniciar nova tarefa","novaTarefa":"Nova tarefa","editarTarefa":"Editar","detalheTarefa":"Detalhes","verDetalhe":"Ver detalhes da tarefa","tipoVinculoMF":"Movimento financeiro","tipoVinculoCL":"Conta lançamento","reabrir":"Reabrir","assumirTarefa":"Assumir tarefa","salvarOcorrencia":"Alterar estado desta tarefa"},"datatableHistTarefa":{"colNome":"Nome","colDesc":"Descrição","colTipo":"Tipo de Vínculo","colRes":"Responsável","colData":"Data vencimento","colConclAuto":"Conclusão automática"}},"tabClassif":{"btnSalvar":"Classificar","btnEdit":"Reclassificar","btnRemover":"Desclassificar","tooltipEstab":"Você deve digitar o nome do estabelecimento desejado para buscá-lo na base. Os resultados da consulta serão exibidos na listagem.","tooltipClassificacao":"Apenas movimentações bancárias com status 'Em Aberto' podem ter suas classificações alteradas e/ou removidas.","infos":{"semPlanoConciliacao":"É necessário possuir um plano de conciliação cadastrado"},"critClassif":"Crit. de classificação utilizado:","classifManual":"Classificado manualmente","semClassif":"Não classificado"}},"conjuntoAtributo":{"tipoAtributo":{"texto":"Campo de texto","data":"Datepicker","combo":"Lista de seleção (ComboBox)","numerico":"Valor numérico"},"titulos":{"conjuntoAtributos":"Conjunto de Atributos","titulo":"Conjunto de atributos","subtitulo":"Gerencie o conjunto de atributos do sistema","tituloNovo":"Conjunto de Atributos","subtituloNovo":"Gerencie os conjuntos de atributos","descricao":"Cadastre conjuntos de atributos e atributos personalizados","novoAtributo":"Novo atributo","adicionarAtributo":"Novo atributo","cadastroDeConjunto":"Cadastro de conjunto e atributos","cadastre":"Cadastre um atributo personalizado para este conjunto","atributos":"Atributos","nomeDoConjunto":"Nome do conjunto"},"infos":{"combo":"Monte uma lista pré-definida com os valores desejados.","datepicker":"Campo de data.","texto":"Campo texto simples, adicione uma máscara desejada.","numerico":"Campo numérico simples, adicione uma máscara desejada.","dicaCombo":"Digite o valor desejado e pressione <b>Enter</b> para adicionar uma opção.","validacao":"Digite a <b>Expressão regular</b> para validar o valor deste atributo."},"labels":{"gerenciar":"Gerenciar conjunto de atributos","novoConjunto":"Novo conjunto","configuracao":"Configuração do atributo","tipo":"Tipo","valoresPossiveis":"Valores possíveis","nome":"Nome","identificador":"Identificador","tipoVinculo":"Tipo de vínculo","quantidadeAtributos":"Quantidade de atributos","E":"Estabelecimento","MF":"Movimento financeiro","CL":"Conta lançamento","criar":"Criar atributo","containerConjunto":"Cadastro de conjunto","containerAtributos":"Atributos","descricao":"Descrição","limpar":"Limpar","adicionar":"Adicionar","resultadoVazio":"Não foi encontrado nenhum conjunto de atributos cadastrado","nenhumResultado":"Não foi encontrado nenhum conjunto de atributos!","mascara":"Máscara","validacao":"Validação (RegExp)","salvar":"Salvar","cancelar":"Cancelar","ordem":"Ordem","tipoDeVinculo":"Tipo de vínculo","arrasteParaReordenar":"Clique na linha do atributo e arraste para definir a ordem de aparição no momento do cadastro","removerBloqueado":"Você não pode remover um conjunto de atributo que tenha sido utilizado na composição de lançamentos pelo sistema ou que esteja associado a um plano de conciliação.","confirmarDelete":"Remover o conjunto irá excluir todos os atributos associados à ele. Deseja prosseguir?","cadastroBloquado":"Só pode haver um conjunto de atributos para cada tipo disponível!","cadastro":"Criar novo conjunto de atributos"},"tooltips":{"comboBox":"Monte uma lista pré-definida com os valores desejados"},"placeholders":{"infos":"Informações lojas","listaDeSelecao":"Lista de seleção (Combo Box)"},"sucesso":{"atualizar":"Sucesso ao atualizar o conjunto de atributos!","salvar":"Sucesso ao salvar o conjunto de atributos!","listar":"Listagem de atributos realizada com sucesso","adicionadoOk":"Atributo adicionado ao conjunto!","editadoOk":"Atributo de conjunto alterado!","remover":"Conjunto de atributos removido com sucesso!"},"erro":{"camposObrigatorios":"Verifique os campos obrigatórios!","criarConjunto":"Erro ao criar conjunto de atributos!","nomesDuplicados":"Os nomes dos atributos não podem estar duplicados!","nomeConjuntoObrigatorio":"O nome do conjunto de atributos é obrigatório!","tipoVinculoConjuntoObrigatorio":"O tipo de vínculo do conjunto é obrigatório!","listar":"Erro ao listar atributos","salvar":"Erro ao salvar conjunto de atributo","atualizar":"Erro ao atualizar conjunto de atributo","atributo":{"ordemAtributoObrigatorio":"A ordem de aparição do atributo é obrigatória!","nomeAtributoObrigatorio":"O nome dos atributos é obrigatório!","descricaoAtributoObrigatorio":"A descrição dos atributos é obrigatória!","tipoAtributoObrigatorio":"O tipo do atributo é obrigatório","atributoUtilizado":"Não é possível editar este atributo, pois o mesmo já está sendo utilizado pelo sistema","atributoTipoValor":{"valorObrigatorio":"É necessário definir pelo menos um valor para o seu ComboBox!"},"excluir":"Não foi possível excluir o atributo, pois o mesmo já está sendo usado no sistema"},"remover":"Não foi possível excluir o conjunto de atributos."},"validacao":{"atributoEmUsoEditar":"Não é permitido editar atributos que estão em uso pelo sistema.","atributoEmUsoExcluir":"Não é permitido excluir atributos que estão em uso pelo sistema."},"types":{"STRING":"Campo de texto","COMBO":"Caixa de seleção (Combo Box)","NUMBER":"Valor numérico","DATE":"Datepicker"}},"tarefa":{"validacao":{"modificadaOutraSessao":"Tarefa modificada em outra sessão","usuarioNaoEncotrado":"Usuário não encontrado","situacaoNaoPermitida":"Situação não permitida","vinculoExistente":"Já existe tarefa Em andamento ou Pendente para o vínculo","tipoVinculoNaoEncotrado":"Tipo de vínculo não encontrado","contaLancamentoNaoEncotrada":"Conta lancamento não encontrada","movimentoFinanceiroNaoEncotrado":"Movimentação financeira não encontrada","usuarioResponsavelNaoEncotrado":"Usuário responsável não encontrado","clienteNaoEncotrado":"Cliente não encontrado","dtVencimentoInvalida":"A data de vencimento não pode ser retroativa!"},"erro":{"cadastrar":"Erro ao salvar tarefa","atualizar":"Erro ao atualiza tarefa","reabrir":"Erro ao reabrir tarefa","gravarOcorrencia":"Erro ao gravar ocorrência","assumir":"Erro ao assumir tarefa","buscar":"Erro ao buscar tarea","email":"Erro ao enviar email para responsável","gravarEmMassa":"Erro a salvar tarefas em massa"},"sucesso":{"cadastrar":"Tarefa criada com sucesso.","atualizar":"Tarefa editada com sucesso.","reabrir":"Tarefa reaberta com sucesso.","gravarOcorrencia":"Ocorrência salva com sucesso.","assumir":"Tarefa assumida com sucesso.","buscar":"Tarefa obtida com sucesso.","gravarEmMassa":"Tarefas salvas com sucesso."}},"auditoria":{"erro":{"salvar":"Erro ao gravar log de auditoria"}},"consultaTarefa":{"titulos":{"titulo":"Consulta de tarefas","subtitulo":"Busque por todas as tarefas criadas no sistema","filtroTitulo":"Filtros para consulta de tarefas"},"labels":{"baseConsulta":"Base de consulta","todas":"Todas as tarefas","dataCriacao":"Data de criação","dataVencimento":"Data de vencimento","dataConclusao":"Data de conclusão/data de cancelamento","nenhumResultado":"Nenhum resultado encontrado!","origem":"Origem","MF":"Movimento financeiro","CL":"Conta lançamento","situacaoLabel":"Situação","atribuidas":"Mostrar somente tarefas atribuídas a mim","situacao":{"pendente":"Pendentes","emAndamento":"Em andamento","aguardando":"Aguardando início","concluido":"Concluídas","cancelado":"Canceladas"},"tarefaOutroCliente":"Esta tarefa está associada a um lançamento de outro cliente.","tarefaNãoEncontrada":"Esta tarefa não consta mais no sistema.","tarefaLancamentoRemovido":"Atenção! O lançamento original ao qual esta tarefa estava associada foi excluído da plataforma."},"sucesso":{"listar":"Busca de tarefas efetuada com sucesso"},"erro":{"listar":"Erro ao buscar tarefas"}},"tarefaEmMassa":{"titulos":{"titulo":"Iniciar tarefa em massa","subtitulo":"Crie uma mesma tarefa para múltiplos lançamentos","portletForm":"Nova tarefa","portletTable":"Lançamentos","enviarEmail":"Enviar e-mail automaticamente para o responsável"},"labels":{"nome":"Nome","tipoVinculo":"Tipo de vínculo","descricao":"Descrição","situacao":"Situação","dtVencimento":"Data de vencimento","responsavel":"Responsável","autoConc":"Concluir automaticamente esta tarefa quando","tipoCl":"Conta lançamento","tipoMf":"Movimento financeiro","itemVinculado":"Este lançamento já possui uma tarefa ","itemVinculadoStatus":{"emAndamento":"em andamento.","pendente":"pendente.","aguardando":"aguardando início."},"removerLanc":"Remover lançamento","tarefasMistas":"A opção de conclusão automática afeta apenas lançamentos de movimentações financeiras."},"erro":{"semLancamentos":"Você precisa selecionar ao menos 1 lançamento na grid."},"tarefaStatuses":{"pendente":"Pendente","emAndamento":"Em andamento","aguardando":"Aguardando início","concluido":"Concluída","cancelada":"Cancelada"},"extrato":{"TipoMovBank":"Extrato bancário","IdLancamento":"Id lanç.","DtLanc":"Data lanç.","Banco":"Banco","NomeConta":"Nome conta","Agencia":"Agência","NrConta":"Num. conta","Tipo":"Tipo","Valor":"Valor","DsCategoria":"Categoria","tipoCred":"Crédito","tipoDeb":"Débito"},"movimento":{"TipoMovFin":"Movimento financeiro","IdMov":"Id movimento","Estabelecimento":"Estabelecimento","PlanoConcil":"Plano de conciliação","Situacao":"Situação"},"ocorrencia":{"IdLote":"Lote","Ocorrencia":"Ocorrência"}},"desclassificacaoEmMassa":{"titulos":{"titulo":"Desclassificar em massa","subtitulo":"Desclassifique lançamentos que estejam classificados e que não estejam conciliados","portletForm":"Quantidade de lançamentos selecionados e que não podem ser desclassificados","portletTable":"Quantidade de lançamentos selecionados e que podem ser desclassificados","botao":"Desclassificar em massa"},"colunas":{"TipoMovBank":"Extrato bancário","IdLancamento":"Id lanç.","DtLanc":"Data lanç.","Banco":"Banco","NomeConta":"Nome conta","Agencia":"Agência","NrConta":"Num. conta","Tipo":"Tipo","Valor":"Valor","CritClassif":"Crit. Classif.","DsHistorico":"Histórico","tipoCred":"Crédito","tipoDeb":"Débito"},"labels":{"fechar":"Fechar","desclassificar":"Desclassificar","removerLancamento":"Remover lançamento da desclassificação","desclassificarInvalido":"Para continuar você deve selecionar entre 1 e 100 lançamentos que podem ser desclassificados","sim":"Sim","nao":"Não","confirmacao":"Tem certeza que deseja continuar com a desclassificação? Lembrando que após a conclusão, você deve recarregar o relatório para trazer os dados atualizados.","classificadoManualmente":"Classificado Manualmente"}},"logTransacao":{"NOVA_TAREFA":"Nova tarefa","ALTERAR_TAREFA":"Editar tarefa","NOVA_OCORRENCIA_TAREFA":"Nova ocorrência","ASSUMIR_TAREFA":"Assumir tarefa","REABRIR_TAREFA":"Reabrir tarefa","CONSULTA_TAREFA":"Consultar tarefa"},"situacaoTarefa":{"PENDENTE":"Pendente","EM_ANDAMENTO":"Em andamento","AGUARDANDO":"Aguardando início","CONCLUIDO":"Concluída","CANCELADO":"Cancelada"},"dashboard":{"titulos":{"portlet":"Período consultado: ","filtros":{"data":"Por data","lancamento":"Por tipo de lançamentos","plano":"Por plano de conciliacao"}},"filtro":{"data":{"estaSemana":"Esta semana","ultimosSeteDias":"Últimos 7 dias","esteMes":"Este mês","ultimosTrintaDias":"Últimos 30 dias","mesAnterior":"Mês anterior","personalizado":"Personalizado"},"tipo":{"E":"Extratos bancários","MF":"Movimentações financeiras","T":"Todas"},"semOpcoes":"Não há outra opção disponível para este filtro","semAgrupamento":"Sem agrupamento"},"labels":{"resultadoVazio":"<i class='fa fa-pie-chart' aria-hidden='true'></i> <br> <span>Não existem dados a serem exibidos<span>","contextButtonTitle":"Opções","downloadJPEG":"Baixar imagem JPG","downloadCSV":"Baixar CSV","downloadPDF":"Baixar PDF","downloadPNG":"Baixar imagem PNG","downloadSVG":"Baixar SVG","downloadXLS":"Baixar XLS","printChart":"Imprimir gráfico","viewData":"Visualizar dados","valorTotal":"Valor total"}},"estatistica":{"sucesso":{"atualizar":"Sucesso ao atualizar estatística"},"erro":{"periodoInvalido":"Período inválido","atualizar":"Erro ao atualizar estatística"},"resumoConciliacao":{"titulo":"Distribuição de conciliação","sucesso":{"pesquisar":"Distribuição de conciliação obtida com sucesso"},"erro":{"pesquisar":"Erro ao pesquisar distribuição de concilição"}},"resumoFinanceiro":{"titulo":"Vendas por plano de conciliação","sucesso":{"pesquisar":"Vendas por plano de conciliação obtida com sucesso"},"erro":{"pesquisar":"Erro ao pesquisar vendas por plano de conciliação"}},"conciliacaoLote":{"titulo":"Lançamentos conciliados"},"saldoBancario":{"titulo":"Saldo em conta","sucesso":{"pesquisar":"Saldo em conta obtido com sucesso"},"erro":{"pesquisar":"Erro ao pesquisar saldo em conta"}},"tarefa":{"titulo":"Tarefas","labels":{"naoConcluida":"Não concluída","concluida":"Concluída","movFinanceira":"Mov. financeira","movBancaria":"Mov. bancária","total":"Total","alertaVencidasSingular":"Tarefa venceu e precisa de sua atenção.","alertaVencidasPlural":"Tarefas venceram e precisam de sua atenção.","alertaSemTarefasVencidas":"Não há tarefas vencidas.","dataProximoVencimento":"O próximo vencimento ocorrerá em","semDataProximoVencimento":"Não há tarefas a vencer.","visualizeTarefasConcluidas":"Visualize as tarefas concluídas","semTarefasConcluidas":"Não há tarefas concluídas.","verQuaisSao":"Veja quais são clicando aqui."},"tooltip":{"vencidas":"Visualizar tarefas vencidas","concluidas":"Visualizar tarefas concluídas."},"sucesso":{"pesquisar":"Tarefas obtidas com sucesso"},"erro":{"pesquisar":"Erro ao pesquisar tarefas"}},"saldoCarteiraDigital":{"titulo":"Saldo Carteira Digital","sucesso":{"pesquisar":"Saldo da carteira digital obtido com sucesso"},"erro":{"pesquisar":"Erro ao pesquisar saldo da carteira digital"}}},"gadgets":{"sucesso":{"listar":"Sucesso ao exibir gráficos","salvar":"Sucesso ao salvar os gráficos","atualizar":"Sucesso ao atualizar os gráficos"},"erro":{"listar":"Erro ao exibir gráficos","salvar":"Erro ao salvar os gráficos","atualizar":"Erro ao atualizar os gráficos"}},"trocaApp":{"titulos":{"titulo":"Troca de aplicação","subtitulo":"Clique abaixo para escolher qual quer utilizar"},"labels":{"voceAqui":"Você está aqui"},"aplicacoes":{"banking":"Banking","cartoes":"Gestão de vendas com cartões","extrato":"Conciliação de Extratos Bancários","bandeiras":"Conciliação de Bandeiras","cobranca":"Gestão de Cobrança Bancária"},"erro":{"aplicacaiIndisponivel":"Aplicação indisponível"}},"saldoBancario":{"labels":{"contasBancarias":"Contas bancárias","selecionarContasBancarias":"Selecionar contas bancárias","buscar":"Buscar","periodo":"Período","alertaGrid":"* Dependendo dos critérios de ordenação, agrupamento e filtro os valores da coluna 'Saldo do Dia' devem ser desconsiderados. <br/>** Na coluna 'Saldo Anterior', blocos destacados em amarelo representam saldos cadastrados manualmente via aplicação."},"titulos":{"saldoBancario":"Saldo bancário","visualize":"Confira os detalhes do saldo do seu banco.","filtroTitulo":"Filtros para consulta de saldos bancários"}},"saldoCarteiraDigital":{"labels":{"carteirasDigitais":"Carteiras digitais","selecionarCarteirasDigitais":"Selecionar carteiras digitais","buscar":"Buscar","periodo":"Período","nome":"Nome","alertaGrid":"* Quando ocorrer o agrupamento das informações, as colunas 'Saldo do dia' e 'Saldo anterior' não devem ser consideradas. Portanto, nesses casos será demonstrado '0,00' para o agrupamento, mas os valores estarão visíveis no nível individual."},"titulos":{"saldoCarteiraDigital":"Saldo carteira digital","visualize":"Confira os detalhes do saldo da sua carteira digital.","filtroTitulo":"Filtros para consulta de saldos de carteiras digitais"}},"downloads":{"labels":{"extratoBancario":"extratoBancario","movimentacaoFinanceira":"movimentacaoFinanceira","relatorioConciliacao":"relatorioConciliacao","resumoConciliacao":"resumoConciliacao"}},"movbancaria":{"sucesso":{"salvar":"Classificação criada com sucesso e conciliação reaplicada.","atualizar":"Classificação alterada com sucesso e conciliação reaplicada.","remover":"Classificação removida com sucesso e conciliação reaplicada."}},"ofda":{"titulo":"Open Finance","compartilhar":"Compartilhar dados (Opcional)","tipoConta":"Tipo da Conta","tipoContaPf":"Pessoa Física","tipoContaPj":"Pessoa Jurídica","requisitante":"Nome do Requisitante","cpfRequisitante":"CPF do Requisitante","empresa":"Razão Social do titular da conta","cnpjRequisitante":"CNPJ do titular da conta","jaAutorizado":"Esta conta já se encontrada autorizada no Open Finance e está compartilhando dados com a nossa aplicação!","statusAceite":{"revogado":"Revogado","autorizado":"Autorizado","aguardando":"Aguardando","autorizar":"Autorizar"},"nenhumaInstituicaoHomologada":"Não existem instituições financeiras homologadas no Open Finance Brasil associadas aos dados informados."},"calendarioConciliacao":{"detalhe":{"vlMovBanc":"Vlr. Extrato","vlMovFinan":"Vlr. Mov. Finan.","diferenca":"Valor diferença","situacao":"Situação","conciliadoManualmente":"Conc. Manual","movFinan":"Mov. Financeira","semLancamentos":"Não existem lançamentos registrados nessa data!","total":"Total","percent":"%","resumo":"Resumo","detalhe":"Detalhes"},"labels":{"seg":"Seg.","ter":"Ter.","qua":"Qua.","qui":"Qui.","sex":"Sex.","sab":"Sáb.","dom":"Dom.","periodo":"Período","situacao":"Situação","categoria":"Categoria"},"alerta":{"tooltipPercent":"Porcentagem dos valores de Mov. Financeiras + Extrato, por situação da conciliação, em relação ao total agregado do dia/período."}}}

/***/ }),
/* 721 */
/* exports provided: FullStory, init, isInitialized */
/* all exports used */
/*!************************************************!*\
  !*** ./~/@fullstory/browser/dist/index.esm.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FullStory", function() { return FullStory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInitialized", function() { return isInitialized; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fullstory_snippet__ = __webpack_require__(/*! @fullstory/snippet */ 722);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var getFullStory = function () {
    if (window._fs_namespace) {
        return window[window._fs_namespace];
    }
    return undefined;
};
var ensureSnippetLoaded = function () {
    var fs = getFullStory();
    if (!fs) {
        throw Error('FullStory is not loaded, please ensure the init function is invoked before calling FullStory API functions');
    }
    return fs;
};
var _init = function (inputOptions, readyCallback) {
    // Make a copy so we can modify `options` if desired.
    var options = __assign({}, inputOptions);
    if (getFullStory()) {
        console.warn('The FullStory snippet has already been defined elsewhere (likely in the <head> element)');
        return;
    }
    // see README for details on the recordCrossDomainIFrames option
    if (options.recordCrossDomainIFrames) {
        window._fs_run_in_iframe = true;
    }
    if (options.appHost) {
        window._fs_app_host = options.appHost;
    }
    if (options.assetMapId) {
        window._fs_asset_map_id = options.assetMapId;
    }
    if (options.startCaptureManually) {
        window._fs_capture_on_startup = false;
    }
    // record the contents of this iFrame when embedded in a parent site
    if (options.recordOnlyThisIFrame) {
        window._fs_is_outer_script = true;
    }
    // Set cookie domain if it was specified.
    if (options.cookieDomain) {
        window._fs_cookie_domain = options.cookieDomain;
    }
    if (options.debug === true) {
        if (!options.script) {
            options.script = 'edge.fullstory.com/s/fs-debug.js';
        }
        else {
            console.warn('Ignoring `debug = true` because `script` is set');
        }
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fullstory_snippet__["a" /* initFS */])(options);
    var fs = getFullStory();
    if (!fs) {
        console.warn('Failed to initialize FS snippet');
        return;
    }
    if (readyCallback) {
        fs('observe', { type: 'start', callback: readyCallback });
    }
    if (options.devMode === true) {
        var message = 'FullStory was initialized in devMode and will stop recording';
        fs('trackEvent', {
            name: 'FullStory Dev Mode',
            properties: {
                message: message,
            }
        });
        fs('shutdown');
        window._fs_dev_mode = true;
        console.warn(message);
    }
};
var initOnce = function (message) { return function (inputOptions, readyCallback) {
    if (window._fs_initialized) {
        if (message)
            console.warn(message);
        return;
    }
    _init(inputOptions, readyCallback);
    window._fs_initialized = true;
}; };
var init = initOnce('FullStory init has already been called once, additional invocations are ignored');
// normalize undefined into boolean
var isInitialized = function () { return !!window._fs_initialized; };
var hasFullStoryWithFunction = function () {
    var testNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        testNames[_i] = arguments[_i];
    }
    var fs = ensureSnippetLoaded();
    return testNames.every(function (current) { return fs[current]; });
};
var guard = function (name) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (window._fs_dev_mode) {
        var message = "FullStory is in dev mode and is not capturing: ".concat(name, " method not executed");
        console.warn(message);
        return message;
    }
    var fs = getFullStory();
    if (hasFullStoryWithFunction(name) && fs) {
        return fs[name].apply(fs, args);
    }
    console.warn("FS.".concat(name, " not ready"));
    return null;
}; };
var buildFullStoryShim = function () {
    var FS = function (operation, options, source) {
        var fs = ensureSnippetLoaded();
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(operation, " not executed");
            console.warn(message);
            return undefined;
        }
        return fs(operation, options, source);
    };
    FS.anonymize = guard('anonymize');
    FS.consent = guard('consent');
    FS.disableConsole = guard('disableConsole');
    FS.enableConsole = guard('enableConsole');
    FS.event = guard('event');
    FS.getCurrentSessionURL = guard('getCurrentSessionURL');
    FS.identify = guard('identify');
    FS.log = guard('log');
    FS.restart = guard('restart');
    FS.setUserVars = guard('setUserVars');
    FS.setVars = guard('setVars');
    FS.shutdown = guard('shutdown');
    return FS;
};
var FullStory = buildFullStoryShim();




/***/ }),
/* 722 */
/* exports provided: SnippetSrc, SnippetSrcDelayed, SnippetSrcV1, generateSnippetText, generateSnippetTextV1, initFS, initFSV1, mockSnippetSrc, mockSnippetSrcV1 */
/* exports used: initFS */
/*!************************************************!*\
  !*** ./~/@fullstory/snippet/dist/index.esm.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SnippetSrc */
/* unused harmony export SnippetSrcDelayed */
/* unused harmony export SnippetSrcV1 */
/* unused harmony export generateSnippetText */
/* unused harmony export generateSnippetTextV1 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initFS; });
/* unused harmony export initFSV1 */
/* unused harmony export mockSnippetSrc */
/* unused harmony export mockSnippetSrcV1 */
// @ts-nocheck
var SnippetSrcV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{\nthen:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){\nh(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}\n;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n\"function\"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){\n(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",o.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)}\n;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,j){h(\"setProperties\",{type:b,properties:d},j)}function j(b,h){d(\"user\",b,h)}function r(b,h,d){j({\nuid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h(\"trackEvent\",{\nname:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var SnippetSrcV2Delayed = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(d){\nreturn!(d in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var d,h=[];function k(){d&&(h.forEach((function(b){var h;try{h=b[d[0]]&&b[d[0]](d[1])}catch(d){return void(b[3]&&b[3](d))}\nh&&h.then?h.then(b[2],b[3]):b[2]&&b[2](h)})),h.length=0)}function r(b){return function(h){d||(d=[b,h],k())}}return b(r(0),r(1)),{\nthen:function(b,d){return p((function(r,i){h.push([b,d,r,i]),k()}))}}}function j(){(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",\no.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)};var b=n.getElementsByTagName(t)[0]\n;b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}a&&(g=m[e]=function(){var b=function(b,h,k,r){function i(i,c){\nd(b,h,k,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):d(b,h,k,c,c,r)}\n;function d(d,h,k,r,i,c){return b._api?b._api(d,h,k,r,i,c):(b.q&&b.q.push([d,h,k,r,i,c]),null)}return b.q=[],b}(),y=function(b){function d(d){\n\"function\"==typeof d[4]&&d[4](new Error(b))}var h=g.q;if(h){for(var k=0;k<h.length;k++)d(h[k]);h.length=0,h.push=d}},function(){try{\nvar b=!1,d=\"paint\";if(void 0!==window.PerformanceObserver&&PerformanceObserver.supportedEntryTypes.indexOf(d)>-1){\nvar h=new PerformanceObserver((function(d){for(var k=d.getEntriesByName(\"first-contentful-paint\"),r=0;r<k.length;r++)k[r]&&(h.disconnect(),\nb||(b=!0,j()))}));h.observe({buffered:!0,type:d}),setTimeout((function(){b||(b=!0,j())}),1e3)}else j()}catch(b){}}(),function(){function b(){}\nfunction d(b,d,h){g(b,d,h,1)}function h(b,h,k){d(\"setProperties\",{type:b,properties:h},k)}function k(b,d){h(\"user\",b,d)}function r(b,d,h){k({\nuid:b},h),d&&k(d,h)}g.identify=r,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=h,g.event=function(b,h,k){d(\"trackEvent\",{\nname:b,properties:h},k)},g.anonymize=function(){r(!1)},g.shutdown=function(){d(\"shutdown\")},g.restart=function(){d(\"restart\")},\ng.log=function(b,h){d(\"log\",{level:b,msg:h})},g.consent=function(b){d(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0.delayed\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var mockSnippetV1 = "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"1.3.0\";\n})(window,document,window['_fs_namespace'],'script','user');";
var mockSnippetV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function j(b){var h,d=[];function k(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function i(b){return function(d){h||(h=[b,d],k())}}return b(i(0),i(1)),{\nthen:function(b,h){return j((function(i,c){d.push([b,h,i,c]),k()}))}}}a&&(g=m[e]=function(){var b=function(b,d,k,i){function c(c,r){\nh(b,d,k,c,r,i)}i=i||2;var r,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(c):j(c)):h(b,d,k,r,r,i)}\n;function h(h,d,k,i,c,r){return b._api?b._api(h,d,k,i,c,r):(b.q&&b.q.push([h,d,k,i,c,r]),null)}return b.q=[],b}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,k){h(\"setProperties\",{type:b,properties:d},k)}function k(b,h){d(\"user\",b,h)}function i(b,h,d){k({\nuid:b},d),h&&k(h,d)}g.identify=i,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,k){h(\"trackEvent\",{\nname:b,properties:d},k)},g.anonymize=function(){i(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,0,window._fs_script);";
var executeSnippet = function executeSnippet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$wnd = _ref.wnd,
    wnd = _ref$wnd === void 0 ? window : _ref$wnd;
  (function (win, doc, fsNamespace, tagName, fsScript, script, api, rejector) {
    var valid = function checkNamespace(fsNamespace) {
      if (!(fsNamespace in win)) {
        return true;
      }
      if (win.console && win.console.log) {
        win.console.log("FullStory namespace conflict. Please set window[\"_fs_namespace\"].");
      }
      return false;
    }(fsNamespace);
    if (!valid) return;
    function makeThenable(callback) {
      var waiters = [];
      var resolution;
      function flush() {
        if (!resolution) {
          return;
        }
        waiters.forEach(function (waiter) {
          var result;
          try {
            result = waiter[resolution[0]] && waiter[resolution[0]](resolution[1]);
          } catch (error) {
            waiter[3] && waiter[3](error);
            return;
          }
          if (result && result.then) {
            result.then(waiter[2], waiter[3]);
          } else {
            waiter[2] && waiter[2](result);
          }
        });
        waiters.length = 0;
      }
      function makeHandler(which) {
        return function (value) {
          if (resolution) {
            return;
          }
          resolution = [which, value];
          flush();
        };
      }
      callback(makeHandler(0), makeHandler(1));
      function _then(onFulfilled, onRejected) {
        return makeThenable(function (nextResolve, nextReject) {
          waiters.push([onFulfilled, onRejected, nextResolve, nextReject]);
          flush();
        });
      }
      return {
        then: _then
      };
    }
    api = win[fsNamespace] = function createV2API() {
      var FS = function FS(action, options, source, apiVersion) {
        apiVersion = apiVersion || 2;
        function setResolve(resolve, reject) {
          api(action, options, source, resolve, reject, apiVersion);
        }
        var re = /Async$/;
        if (re.test(action)) {
          action = action.replace(re, '');
          // @ts-ignore
          if (typeof Promise === 'function') {
            // @ts-ignore
            return new Promise(setResolve);
          }
          return makeThenable(setResolve);
        }
        var _undefined;
        return api(action, options, source, _undefined, _undefined, apiVersion);
      };
      function api(op, args, source, resolve, reject, apiVersion) {
        // Once fs.js is bootstrapped, we have access to ._api which
        //   handles pushing deferred methods into the queue internally.
        if (FS._api) {
          return FS._api(op, args, source, resolve, reject, apiVersion);
        }
        if (FS.q) {
          FS.q.push([op, args, source, resolve, reject, apiVersion]);
        }
        return null;
      }
      FS.q = [];
      return FS;
    }();
    rejector = function createRejector() {
      // Returns a function called on the error handler of the fs.js script tag.
      // Its purpose is to reject all pending and future asynchronous api calls.
      // The 4th argument to any api operation is always the reject function if it
      // has been called with the "Async" modifier.
      return function (reason) {
        function doReject(operation) {
          if (typeof operation[4] === 'function') {
            operation[4](new Error(reason));
          }
        }
        var q = api.q;
        if (q) {
          for (var i = 0; i < q.length; i++) {
            doReject(q[i]);
          }
          q.length = 0;
          q.push = doReject;
        }
      };
    }();
    (function insertScript() {
      script = doc.createElement(tagName);
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://' + fsScript;
      script.onerror = function () {
        rejector('Error loading ' + fsScript);
      };
      var firstScript = doc.getElementsByTagName(tagName)[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        doc.head.appendChild(script);
      }
    })();
    (function translateV1API() {
      function noop() {}
      function callAPI(action, option, source) {
        api(action, option, source, 1);
      }
      function setProperties(scope, props, source) {
        callAPI('setProperties', {
          type: scope,
          properties: props
        }, source);
      }
      function setUserProperties(props, source) {
        setProperties('user', props, source);
      }
      function identify(uid, customVars, source) {
        setUserProperties({
          uid: uid
        }, source);
        if (customVars) {
          setUserProperties(customVars, source);
        }
      }
      api.identify = identify;
      api.setUserVars = setUserProperties;
      api.identifyAccount = noop;
      api.clearUserCookie = noop;
      api.setVars = setProperties;
      api.event = function (eventName, eventProps, source) {
        callAPI('trackEvent', {
          name: eventName,
          properties: eventProps
        }, source);
      };
      api.anonymize = function () {
        identify(false);
      };
      api.shutdown = function () {
        callAPI('shutdown');
      };
      api.restart = function () {
        callAPI('restart');
      };
      api.log = function (level, msg) {
        callAPI('log', {
          level: level,
          msg: msg
        });
      };
      api.consent = function (userConsents) {
        callAPI('setIdentity', {
          consent: !arguments.length || userConsents
        });
      };
    })();
    (function snapshotGlobals() {
      var f = 'fetch';
      var xhr = 'XMLHttpRequest';
      api._w = {};
      api._w[xhr] = win[xhr];
      api._w[f] = win[f];
      if (win[f]) {
        win[f] = function () {
          return api._w[f].apply(this, arguments);
        };
      }
    })();
    api._v = "2.0.0";
  })(wnd, wnd.document, wnd['_fs_namespace'], 'script', wnd['_fs_script']);
};
var executeSnippetV1 = function executeSnippetV1() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$wnd = _ref2.wnd,
    wnd = _ref2$wnd === void 0 ? window : _ref2$wnd;
  (function (m, n, e, t, l, o, g, y) {
    if (e in m) {
      if (m.console && m.console.log) {
        m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
      }
      return;
    }
    g = m[e] = function (a, b, s) {
      g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
    };
    g.q = [];
    o = n.createElement(t);
    o.async = 1;
    o.crossOrigin = 'anonymous';
    o.src = 'https://' + _fs_script;
    y = n.getElementsByTagName(t)[0];
    y.parentNode.insertBefore(o, y);
    g.identify = function (i, v, s) {
      g(l, {
        uid: i
      }, s);
      if (v) g(l, v, s);
    };
    g.setUserVars = function (v, s) {
      g(l, v, s);
    };
    g.event = function (i, v, s) {
      g('event', {
        n: i,
        p: v
      }, s);
    };
    g.anonymize = function () {
      g.identify(!!0);
    };
    g.shutdown = function () {
      g("rec", !1);
    };
    g.restart = function () {
      g("rec", !0);
    };
    g.log = function (a, b) {
      g("log", [a, b]);
    };
    g.consent = function (a) {
      g("consent", !arguments.length || a);
    };
    g.identifyAccount = function (i, v) {
      o = 'account';
      v = v || {};
      v.acctId = i;
      g(o, v);
    };
    g.clearUserCookie = function () {};
    g.setVars = function (n, p) {
      g('setVars', [n, p]);
    };
    g._w = {};
    y = 'XMLHttpRequest';
    g._w[y] = m[y];
    y = 'fetch';
    g._w[y] = m[y];
    if (m[y]) m[y] = function () {
      return g._w[y].apply(this, arguments);
    };
    g._v = "1.3.0";
  })(wnd, wnd.document, wnd['_fs_namespace'], 'script', 'user');
};
var getDocumentVar = function getDocumentVar(globalVar) {
  return globalVar === 'window' ? 'document' : "".concat(globalVar, ".document");
};
var toV1String = function toV1String() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$shouldInsertScr = _ref3.shouldInsertScript,
    shouldInsertScript = _ref3$shouldInsertScr === void 0 ? true : _ref3$shouldInsertScr,
    _ref3$globalVar = _ref3.globalVar,
    globalVar = _ref3$globalVar === void 0 ? 'window' : _ref3$globalVar,
    _ref3$apiVersion = _ref3.apiVersion,
    apiVersion = _ref3$apiVersion === void 0 ? '1.3.0' : _ref3$apiVersion;
  return "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];".concat(shouldInsertScript ? "\n    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);" : '', "\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"").concat(apiVersion, "\";\n})(").concat(globalVar, ",").concat(getDocumentVar(globalVar), ",").concat(globalVar, "['_fs_namespace'],'script','user');");
};
var initFS = function initFS(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  window['_fs_host'] = host;
  window['_fs_script'] = script;
  window['_fs_org'] = orgId;
  window['_fs_namespace'] = namespace;
  executeSnippet();
};
var initFSV1 = function initFSV1(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  window['_fs_host'] = host;
  window['_fs_script'] = script;
  window['_fs_org'] = orgId;
  window['_fs_namespace'] = namespace;
  executeSnippetV1();
};
var SnippetSrc = SnippetSrcV2;
var SnippetSrcDelayed = SnippetSrcV2Delayed;
var SnippetSrcV1 = toV1String();
var generateSnippetText = function generateSnippetText(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat(SnippetSrc, "\n");
};
var generateSnippetTextV1 = function generateSnippetTextV1(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat(SnippetSrcV1, "\n");
};
var mockSnippetSrc = mockSnippetV2;
var mockSnippetSrcV1 = mockSnippetV1;


/***/ }),
/* 723 */
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** ./~/axios/index.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/axios */ 724);

/***/ }),
/* 724 */
/* no static exports found */
/* all exports used */
/*!******************************!*\
  !*** ./~/axios/lib/axios.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./utils */ 60);
var bind = __webpack_require__(/*! ./helpers/bind */ 311);
var Axios = __webpack_require__(/*! ./core/Axios */ 726);
var mergeConfig = __webpack_require__(/*! ./core/mergeConfig */ 310);
var defaults = __webpack_require__(/*! ./defaults */ 198);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ 306);
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ 725);
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ 307);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ 739);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(/*! ./helpers/isAxiosError */ 735);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 725 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/axios/lib/cancel/CancelToken.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ 306);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 726 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./~/axios/lib/core/Axios.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);
var buildURL = __webpack_require__(/*! ../helpers/buildURL */ 312);
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ 727);
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ 729);
var mergeConfig = __webpack_require__(/*! ./mergeConfig */ 310);
var validator = __webpack_require__(/*! ../helpers/validator */ 740);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 727 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/axios/lib/core/InterceptorManager.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 728 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/axios/lib/core/buildFullPath.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(/*! ../helpers/isAbsoluteURL */ 734);
var combineURLs = __webpack_require__(/*! ../helpers/combineURLs */ 732);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 729 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/axios/lib/core/dispatchRequest.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);
var transformData = __webpack_require__(/*! ./transformData */ 731);
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ 307);
var defaults = __webpack_require__(/*! ../defaults */ 198);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 730 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./~/axios/lib/core/settle.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(/*! ./createError */ 308);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 731 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/axios/lib/core/transformData.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);
var defaults = __webpack_require__(/*! ./../defaults */ 198);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 732 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/axios/lib/helpers/combineURLs.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 733 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./~/axios/lib/helpers/cookies.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 734 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/axios/lib/helpers/isAbsoluteURL.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 735 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/axios/lib/helpers/isAxiosError.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 736 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/axios/lib/helpers/isURLSameOrigin.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 737 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/axios/lib/helpers/normalizeHeaderName.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ 60);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 738 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/axios/lib/helpers/parseHeaders.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ 60);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 739 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./~/axios/lib/helpers/spread.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 740 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./~/axios/lib/helpers/validator.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(/*! ./../../package.json */ 741);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 741 */
/* no static exports found */
/* all exports used */
/*!******************************!*\
  !*** ./~/axios/package.json ***!
  \******************************/
/***/ (function(module, exports) {

module.exports = {"_args":[["axios@0.21.4","/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend"]],"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_spec":"0.21.4","_where":"/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 742 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/babel-helper-vue-jsx-merge-props/index.js ***!
  \*****************************************************/
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/

module.exports = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp
    for (key in b) {
      aa = a[key]
      bb = b[key]
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa
            a[key] = aa = {}
            aa[temp] = true
          }
          if (typeof bb === 'string') {
            temp = bb
            b[key] = bb = {}
            bb[temp] = true
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb)
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb)
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey]
          }
        }
      } else {
        a[key] = b[key]
      }
    }
    return a
  }, {})
}

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments)
    b && b.apply(this, arguments)
  }
}


/***/ }),
/* 743 */
/* no static exports found */
/* all exports used */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.router = exports.app = undefined;

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _vuexRouterSync = __webpack_require__(/*! vuex-router-sync */ 1730);

var _App = __webpack_require__(/*! ./components/views/App */ 1315);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(/*! ./router */ 752);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(/*! ./store */ 105);

var _store2 = _interopRequireDefault(_store);

var _vueTables = __webpack_require__(/*! vue-tables-2 */ 132);

var _index = __webpack_require__(/*! ../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _vuexI18n = __webpack_require__(/*! vuex-i18n */ 1728);

var _vuexI18n2 = _interopRequireDefault(_vuexI18n);

var _localeIn = __webpack_require__(/*! ../build/language/files/locale-in.json */ 719);

var _localeIn2 = _interopRequireDefault(_localeIn);

var _localeEs = __webpack_require__(/*! ../build/language/files/locale-es.json */ 718);

var _localeEs2 = _interopRequireDefault(_localeEs);

var _localePt = __webpack_require__(/*! ../build/language/files/locale-pt.json */ 720);

var _localePt2 = _interopRequireDefault(_localePt);

var _veeValidate = __webpack_require__(/*! vee-validate */ 686);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueInputTag = __webpack_require__(/*! vue-input-tag */ 688);

var _vueInputTag2 = _interopRequireDefault(_vueInputTag);

var _vueAnalytics = __webpack_require__(/*! vue-analytics */ 1247);

var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);

var _bootstrapVue = __webpack_require__(/*! bootstrap-vue */ 950);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _vueCookie = __webpack_require__(/*! vue-cookie */ 1249);

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _vueJsPopover = __webpack_require__(/*! vue-js-popover */ 1254);

var _vueJsPopover2 = _interopRequireDefault(_vueJsPopover);

var _vueHighcharts = __webpack_require__(/*! vue-highcharts */ 1253);

var _vueHighcharts2 = _interopRequireDefault(_vueHighcharts);

var _highcharts = __webpack_require__(/*! highcharts */ 280);

var _highcharts2 = _interopRequireDefault(_highcharts);

var _exporting = __webpack_require__(/*! highcharts/modules/exporting */ 1143);

var _exporting2 = _interopRequireDefault(_exporting);

var _highchartsGroupedCategories = __webpack_require__(/*! highcharts-grouped-categories */ 1141);

var _highchartsGroupedCategories2 = _interopRequireDefault(_highchartsGroupedCategories);

var _highchartsNoDataToDisplay = __webpack_require__(/*! highcharts-no-data-to-display */ 1142);

var _highchartsNoDataToDisplay2 = _interopRequireDefault(_highchartsNoDataToDisplay);

var _vueJsToggleButton = __webpack_require__(/*! vue-js-toggle-button */ 689);

var _vueJsToggleButton2 = _interopRequireDefault(_vueJsToggleButton);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _browser = __webpack_require__(/*! @fullstory/browser */ 721);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

_store2.default.dispatch('setHasUnsavedChanges', false);
_store2.default.dispatch('cleanGadgetsFilters');

_vue2.default.config.productionTip = false;

(0, _exporting2.default)(_highcharts2.default);
(0, _highchartsGroupedCategories2.default)(_highcharts2.default);
(0, _highchartsNoDataToDisplay2.default)(_highcharts2.default);

_vue2.default.use(_bootstrapVue2.default);
_vue2.default.use(_veeValidate2.default, { events: 'input' });
_vue2.default.use(_vueCookie2.default);
_vue2.default.use(_vuexI18n2.default.plugin, _store2.default, {
  identifiers: ['%', '%']
});
_vue2.default.use(_vueTables.ClientTable);
_vue2.default.use(_vueTables.ServerTable);
_vue2.default.use(_vueInputTag2.default);
_vue2.default.use(_vueJsPopover2.default);
_vue2.default.use(_vueHighcharts2.default, { Highcharts: _highcharts2.default });
_vue2.default.use(_vueJsToggleButton2.default);

_vue2.default.use(_vueAnalytics2.default, {
  id: 'UA-108229859-1',
  router: _router2.default,
  autoTracking: { pageviewOnLoad: true },
  checkDuplicatedScript: true,
  beforeFirstHit: function beforeFirstHit() {},
  ready: function ready() {}
});

(0, _browser.init)({ orgId: 'o-1PEET3-na1' });

_vue2.default.prototype.$FullStory = _browser.FullStory;

_vue2.default.i18n.add('in', _localeIn2.default);
_vue2.default.i18n.add('es', _localeEs2.default);
_vue2.default.i18n.add('pt', _localePt2.default);

_vue2.default.filter('formatDate', function (value) {
  if (value) {
    return (0, _moment2.default)().format('DD/MM/YYYY HH:mm:ss');
  }
});

var language = _index2.default.getCookieByName('language');
if (!language || language !== 'in' && language !== 'es') {
  language = 'pt';
}
_index2.default.changeLanguage(language);

var app = new _vue2.default((0, _assign2.default)({
  router: _router2.default,
  store: _store2.default
}, _App2.default));

exports.app = app;
exports.router = _router2.default;
exports.store = _store2.default;

/***/ }),
/* 744 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./client/components/views/index/config.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCharts = undefined;

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _maxSafeInteger = __webpack_require__(/*! babel-runtime/core-js/number/max-safe-integer */ 203);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(/*! ../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _numberMasker = __webpack_require__(/*! ../../../utils/numberMasker.js */ 71);

var _graficoId = __webpack_require__(/*! ../../../enum/graficoId */ 103);

var _graficoId2 = _interopRequireDefault(_graficoId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var marginTopChart = 50;
var lang = _index2.default.getCookieByName('language');

var numberFormatterWithDecimal = _index2.default.getIntlCurrencyFormatter();
var numberFormatterWithoutDecimal = _index2.default.getIntlCurrencyFormatter(0, 2);

function getCharts() {
  var $t = _vue2.default.i18n.translate;
  return [{
    idChart: _graficoId2.default.GADGET_TAREFAS,
    chartTitle: $t('estatistica.tarefa.titulo'),
    idChartTemplate: 'GadgetTasks',
    showTaskGadget: true,
    data: {},
    isLoadingData: true
  }, {
    isLoadingData: true,
    idChart: _graficoId2.default.RESUMO_SITUACAO_CONCILIACAO,
    idChartTemplate: 'ChartConciliationSituationSummary',
    chart: {
      type: 'column',
      marginTop: marginTopChart
    },
    chartTitle: $t('estatistica.resumoConciliacao.titulo'),
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },

    xAxis: {
      categories: []
    },

    yAxis: {
      allowDecimals: false,
      min: 0,
      title: {
        text: $t('dashboard.labels.valorTotal')
      }
    },

    tooltip: {
      formatter: function formatter() {
        return '<b>' + this.x + '</b><br/>\n            ' + this.series.name + ': ' + (0, _numberMasker.maskThousand)(this.y) + ' <br/>\n            Total: ' + (0, _numberMasker.maskThousand)(this.point.stackTotal);
      }
    },

    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },

    series: [],

    lang: {
      noData: $t('dashboard.labels.resultadoVazio'),
      contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
      downloadJPEG: $t('dashboard.labels.downloadJPEG'),
      downloadCSV: $t('dashboard.labels.downloadCSV'),
      downloadPDF: $t('dashboard.labels.downloadPDF'),
      downloadPNG: $t('dashboard.labels.downloadPNG'),
      downloadSVG: $t('dashboard.labels.downloadSVG'),
      downloadXLS: $t('dashboard.labels.downloadXLS'),
      printChart: $t('dashboard.labels.printChart'),
      viewData: $t('dashboard.labels.viewData')
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      },
      useHTML: true
    },

    exporting: {
      sourceWidth: 1500,
      sourceHeight: 400,
      scale: 1
    }
  }, {
    isLoadingData: true,
    idChart: _graficoId2.default.RESUMO_FINANCEIRO_PLANO_CONCILIACAO,
    idChartTemplate: 'ChartFinancialSummary',
    chart: {
      type: 'column',
      marginTop: marginTopChart
    },
    chartTitle: $t('estatistica.resumoFinanceiro.titulo'),
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },

    xAxis: {
      categories: []
    },

    yAxis: {
      allowDecimals: false,
      min: 0,
      title: {
        text: $t('dashboard.labels.valorTotal')
      }
    },

    tooltip: {
      formatter: function formatter() {
        return '<b>' + this.x + '</b><br/>\n            ' + this.series.name + ': ' + (0, _numberMasker.maskThousand)(this.y) + ' <br/>\n            Total: ' + (0, _numberMasker.maskThousand)(this.point.stackTotal);
      }
    },

    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },

    series: [],

    lang: {
      noData: $t('dashboard.labels.resultadoVazio'),
      contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
      downloadJPEG: $t('dashboard.labels.downloadJPEG'),
      downloadCSV: $t('dashboard.labels.downloadCSV'),
      downloadPDF: $t('dashboard.labels.downloadPDF'),
      downloadPNG: $t('dashboard.labels.downloadPNG'),
      downloadSVG: $t('dashboard.labels.downloadSVG'),
      downloadXLS: $t('dashboard.labels.downloadXLS'),
      printChart: $t('dashboard.labels.printChart'),
      viewData: $t('dashboard.labels.viewData')
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      },
      useHTML: true
    },

    exporting: {
      sourceWidth: 1500,
      sourceHeight: 400,
      scale: 1
    }
  }, {
    isLoadingData: true,
    idChart: _graficoId2.default.DISTRIBUICAO_CONCILIACAO_LOTE,
    idChartTemplate: 'ChartAllotmentDistributionConciliation',
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      marginTop: marginTopChart
    },
    chartTitle: $t('estatistica.conciliacaoLote.titulo'),
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function formatter() {
        return '\n            <b>' + this.point.percentage.toFixed(1) + '% ' + this.point.name + '</b><br/>\n            ' + this.series.name + ': ' + (0, _numberMasker.maskThousand)(this.y);
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        showInLegend: true
      }
    },
    series: [],
    lang: {
      noData: $t('dashboard.labels.resultadoVazio'),
      contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
      downloadJPEG: $t('dashboard.labels.downloadJPEG'),
      downloadCSV: $t('dashboard.labels.downloadCSV'),
      downloadPDF: $t('dashboard.labels.downloadPDF'),
      downloadPNG: $t('dashboard.labels.downloadPNG'),
      downloadSVG: $t('dashboard.labels.downloadSVG'),
      downloadXLS: $t('dashboard.labels.downloadXLS'),
      printChart: $t('dashboard.labels.printChart'),
      viewData: $t('dashboard.labels.viewData')
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      },
      useHTML: true
    },

    exporting: {
      sourceWidth: 1500,
      sourceHeight: 400,
      scale: 1
    }
  }, {
    isLoadingData: true,
    idChart: _graficoId2.default.SALDO_BANCARIO,
    idChartTemplate: 'DailyBankStatment',
    chart: {
      type: 'line',
      marginTop: marginTopChart
    },
    chartTitle: $t('estatistica.saldoBancario.titulo'),
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },

    xAxis: {
      className: 'bold',
      categories: []
    },

    yAxis: {
      allowDecimals: false,
      title: {
        text: $t('dashboard.labels.valorTotal')
      },
      labels: {
        formatter: function formatter() {
          if (this.value <= -1e5 || this.value >= 1e5) {
            if (this.axis.max - this.axis.min === 0) {
              return numberFormatterWithDecimal(this.value);
            }

            var value = Math.floor(this.value).toString();
            var ticks = this.axis.tickPositions;

            if (this.axis.tickInterval < ticks.length * 1e2) {
              return numberFormatterWithoutDecimal(this.value);
            }

            var maxDigits = value.length % 3 || 3;
            var slicedValue = value.substring(0, maxDigits);

            var abbreviation = _index2.default.getMonetaryAbbreviation(this.value, lang);

            var earliestIndexDifferentDigit = _maxSafeInteger2.default;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = (0, _getIterator3.default)(ticks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var tick = _step.value;

                if (tick === value) {
                  continue;
                }

                var tickValue = tick.toString();

                if (value.length !== tickValue.length) {
                  continue;
                }

                var tickAbbreviation = _index2.default.getMonetaryAbbreviation(tick, lang);

                var slicedTick = tickValue.substring(0, maxDigits);

                if (slicedTick + tickAbbreviation === slicedValue + abbreviation) {
                  for (var digitIndex = 0; digitIndex < value.length; ++digitIndex) {
                    if (value[digitIndex] !== tickValue[digitIndex] && digitIndex < earliestIndexDifferentDigit) {
                      earliestIndexDifferentDigit = digitIndex + 1;
                      break;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var numberFormatter = numberFormatterWithoutDecimal;
            if (earliestIndexDifferentDigit !== _maxSafeInteger2.default) {
              earliestIndexDifferentDigit++;
              slicedValue += '.' + value.substring(slicedValue.length, earliestIndexDifferentDigit);
              if (earliestIndexDifferentDigit !== 2) {
                numberFormatter = _index2.default.getIntlCurrencyFormatter(0, earliestIndexDifferentDigit);
              }
            }

            return numberFormatter(slicedValue) + abbreviation;
          }
          return numberFormatterWithoutDecimal(this.value);
        }
      }
    },

    tooltip: {
      formatter: function formatter() {
        return '<b>' + this.x + '</b><br/>\n            ' + this.series.name + ': ' + (0, _numberMasker.maskThousand)(this.y);
      }
    },

    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,

          formatter: function formatter() {
            var _this = this;

            var index = this.point.index;
            var isEveryItemEqual = false;

            if (index === 0) {
              isEveryItemEqual = this.series.yData.every(function (y) {
                return y === _this.y;
              });
            }

            if (isEveryItemEqual || index > 0 && this.y === this.series.yData[index - 1]) {
              return null;
            }

            return numberFormatterWithDecimal(this.y);
          },
          y: -10
        },
        enableMouseTracking: true
      }
    },

    series: [],
    lang: {
      noData: $t('dashboard.labels.resultadoVazio'),
      contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
      downloadJPEG: $t('dashboard.labels.downloadJPEG'),
      downloadCSV: $t('dashboard.labels.downloadCSV'),
      downloadPDF: $t('dashboard.labels.downloadPDF'),
      downloadPNG: $t('dashboard.labels.downloadPNG'),
      downloadSVG: $t('dashboard.labels.downloadSVG'),
      downloadXLS: $t('dashboard.labels.downloadXLS'),
      printChart: $t('dashboard.labels.printChart'),
      viewData: $t('dashboard.labels.viewData')
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      },
      useHTML: true
    },

    exporting: {
      sourceWidth: 1720,
      sourceHeight: 400,
      scale: 1
    }
  }, {
    isLoadingData: true,
    idChart: _graficoId2.default.SALDO_CARTEIRA_DIGITAL,
    idChartTemplate: 'DigitalWalletBalance',
    chart: {
      type: 'line',
      marginTop: marginTopChart
    },
    chartTitle: $t('estatistica.saldoCarteiraDigital.titulo'),
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },

    xAxis: {
      className: 'bold',
      categories: []
    },

    yAxis: {
      allowDecimals: false,
      title: {
        text: $t('dashboard.labels.valorTotal')
      },
      labels: {
        formatter: function formatter() {
          if (this.value <= -1e5 || this.value >= 1e5) {
            if (this.axis.max - this.axis.min === 0) {
              return numberFormatterWithDecimal(this.value);
            }

            var value = Math.floor(this.value).toString();
            var ticks = this.axis.tickPositions;

            if (this.axis.tickInterval < ticks.length * 1e2) {
              return numberFormatterWithoutDecimal(this.value);
            }

            var maxDigits = value.length % 3 || 3;
            var slicedValue = value.substring(0, maxDigits);

            var abbreviation = _index2.default.getMonetaryAbbreviation(this.value, lang);

            var earliestIndexDifferentDigit = _maxSafeInteger2.default;

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(ticks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var tick = _step2.value;

                if (tick === value) {
                  continue;
                }

                var tickValue = tick.toString();

                if (value.length !== tickValue.length) {
                  continue;
                }

                var tickAbbreviation = _index2.default.getMonetaryAbbreviation(tick, lang);

                var slicedTick = tickValue.substring(0, maxDigits);

                if (slicedTick + tickAbbreviation === slicedValue + abbreviation) {
                  for (var digitIndex = 0; digitIndex < value.length; ++digitIndex) {
                    if (value[digitIndex] !== tickValue[digitIndex] && digitIndex < earliestIndexDifferentDigit) {
                      earliestIndexDifferentDigit = digitIndex + 1;
                      break;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            var numberFormatter = numberFormatterWithoutDecimal;
            if (earliestIndexDifferentDigit !== _maxSafeInteger2.default) {
              earliestIndexDifferentDigit++;
              slicedValue += '.' + value.substring(slicedValue.length, earliestIndexDifferentDigit);
              if (earliestIndexDifferentDigit !== 2) {
                numberFormatter = _index2.default.getIntlCurrencyFormatter(0, earliestIndexDifferentDigit);
              }
            }

            return numberFormatter(slicedValue) + abbreviation;
          }
          return numberFormatterWithoutDecimal(this.value);
        }
      }
    },

    tooltip: {
      formatter: function formatter() {
        return '<b>' + this.x + '</b><br/>\n            ' + this.series.name + ': ' + (0, _numberMasker.maskThousand)(this.y);
      }
    },

    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
          formatter: function formatter() {
            var _this2 = this;

            var index = this.point.index;
            var isEveryItemEqual = false;

            if (index === 0) {
              isEveryItemEqual = this.series.yData.every(function (y) {
                return y === _this2.y;
              });
            }

            if (isEveryItemEqual || index > 0 && this.y === this.series.yData[index - 1]) {
              return null;
            }

            return numberFormatterWithDecimal(this.y);
          },
          y: -10
        },
        enableMouseTracking: true
      }
    },

    series: [],
    lang: {
      noData: $t('dashboard.labels.resultadoVazio'),
      contextButtonTitle: $t('dashboard.labels.contextButtonTitle'),
      downloadJPEG: $t('dashboard.labels.downloadJPEG'),
      downloadCSV: $t('dashboard.labels.downloadCSV'),
      downloadPDF: $t('dashboard.labels.downloadPDF'),
      downloadPNG: $t('dashboard.labels.downloadPNG'),
      downloadSVG: $t('dashboard.labels.downloadSVG'),
      downloadXLS: $t('dashboard.labels.downloadXLS'),
      printChart: $t('dashboard.labels.printChart'),
      viewData: $t('dashboard.labels.viewData')
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      },
      useHTML: true
    },

    exporting: {
      sourceWidth: 1720,
      sourceHeight: 400,
      scale: 1
    }
  }];
}

exports.getCharts = getCharts;

/***/ }),
/* 745 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./client/enum/aplicacaoEnum.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var aplicacaoEnum = {
  APLICATIVO: 2,
  BANDEIRAS: 7
};

exports.default = aplicacaoEnum;

/***/ }),
/* 746 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./client/enum/codigoBancoBelvo.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var codigoBancoBelvo = [{
  codigo: 1,
  tipos: [{
    tipo: 'PF',
    bancos: ['bancodobrasil_br_retail', 'ofbancodobrasil_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['bancodobrasil_br_business', 'ofbancodobrasil_br_business']
  }]
}, {
  codigo: 237,
  tipos: [{
    tipo: 'PF',
    bancos: ['bradesco_br_retail', 'ofbradescard_br_retail', 'ofbradesco_br_retail', 'ofnext_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['bradesco_br_business', 'ofbradesco_br_business']
  }]
}, {
  codigo: 104,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofcaixa_br_retail', 'caixa_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['caixa_br_business', 'ofcaixa_br_business']
  }]
}, {
  codigo: 341,
  tipos: [{
    tipo: 'PF',
    bancos: ['itau_br_retail', 'ofitau_br_retail', 'ofitaucard_br_retail', 'itaucard_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['itau_br_business', 'ofitau_br_business']
  }]
}, {
  codigo: 623,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofbancopan_br_retail']
  }]
}, {
  codigo: 41,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofbanrisul_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofbanrisul_br_business']
  }]
}, {
  codigo: 208,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofbtg_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofbtgempresas_br_business']
  }]
}, {
  codigo: 655,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofbvapp_br_retail', 'ofbvweb_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofbv_br_business']
  }]
}, {
  codigo: 745,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofciti_br_business']
  }, {
    tipo: 'PJ',
    bancos: ['ofcitibank_br_business']
  }]
}, {
  codigo: 335,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofdigio_br_retail', 'ofuberdigio_br_retail']
  }]
}, {
  codigo: 323,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofmercadopago_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofmercadopago_br_business']
  }]
}, {
  codigo: 4,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofnordeste_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofnordeste_br_business']
  }]
}, {
  codigo: 260,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofnubank_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofnubank_br_business']
  }]
}, {
  codigo: 380,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofpicpay_br_retail']
  }]
}, {
  codigo: 422,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofsafra_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofsafra_br_business', 'ofsafrapay_br_business']
  }]
}, {
  codigo: 33,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofsantander_br_retail', 'santander_br_retail', 'ofsantandercard_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofsantander_br_business', 'santander_br_business', 'getnet_br_business']
  }]
}, {
  codigo: 756,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofsicoob_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofsicoob_br_business', 'sicoob_br_business']
  }]
}, {
  codigo: 748,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofsicredi_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofsicredi_br_business', 'sicredi_br_business']
  }]
}, {
  codigo: 136,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofunicred_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofunicred_br_business']
  }]
}, {
  codigo: 348,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofxp_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['ofxp_br_business']
  }]
}, {
  codigo: 999,
  tipos: [{
    tipo: 'PF',
    bancos: ['ofxp_br_retail', 'ofbmg_br_retail']
  }, {
    tipo: 'PJ',
    bancos: ['pagseguro_br_business', 'ofbmg_br_business', 'inss_br_employment']
  }]
}];

function getBelvoInstitutionsByCdBankPersonType(codigo, tipo) {
  var item = codigoBancoBelvo.find(function (dado) {
    return dado.codigo === codigo;
  });
  if (!item) {
    return [];
  }

  var tipoItem = item.tipos.find(function (t) {
    return t.tipo === tipo;
  });
  return tipoItem ? tipoItem.bancos : [];
}

exports.getBelvoInstitutionsByCdBankPersonType = getBelvoInstitutionsByCdBankPersonType;

/***/ }),
/* 747 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./client/enum/keyCode.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var KeyCodeEnum = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SPACE_BAR: 32,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  A: 65
};

exports.default = KeyCodeEnum;

/***/ }),
/* 748 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./client/enum/logTransacao.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LogTransacaoEnum = {
  286: 'NOVA_TAREFA',
  287: 'ALTERAR_TAREFA',
  288: 'NOVA_OCORRENCIA_TAREFA',
  289: 'ASSUMIR_TAREFA',
  290: 'REABRIR_TAREFA',
  291: 'CONSULTA_TAREFA'
};

exports.default = LogTransacaoEnum;

/***/ }),
/* 749 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/enum/pluggyConnectorsMap.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPluggyConnectorCodeByCdBankPersonType = undefined;

var _set = __webpack_require__(/*! babel-runtime/core-js/set */ 204);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluggyConnectorsMap = [{
  bankCode: 1,
  types: [{
    type: 'PF',
    connectorIds: [620, 611, 673]
  }, {
    type: 'PJ',
    connectorIds: [781, 662]
  }]
}, {
  bankCode: 107,
  types: [{
    type: 'PF',
    connectorIds: [652]
  }, {
    type: 'PJ',
    connectorIds: [666]
  }]
}, {
  bankCode: 335,
  types: [{
    type: 'PF',
    connectorIds: [653, 674]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 4,
  types: [{
    type: 'PF',
    connectorIds: [671]
  }, {
    type: 'PJ',
    connectorIds: [672]
  }]
}, {
  bankCode: 623,
  types: [{
    type: 'PF',
    connectorIds: [657]
  }]
}, {
  bankCode: 611,
  types: [{
    type: 'PF',
    connectorIds: [705]
  }, {
    type: 'PJ',
    connectorIds: [706]
  }]
}, {
  bankCode: 637,
  types: [{
    type: 'PF',
    connectorIds: [714]
  }, {
    type: 'PJ',
    connectorIds: [715]
  }]
}, {
  bankCode: 41,
  types: [{
    type: 'PF',
    connectorIds: [659]
  }, {
    type: 'PJ',
    connectorIds: [660]
  }]
}, {
  bankCode: 237,
  types: [{
    type: 'PF',
    connectorIds: [603, 656]
  }, {
    type: 'PJ',
    connectorIds: [609, 801]
  }]
}, {
  bankCode: 208,
  types: [{
    type: 'PF',
    connectorIds: [675, 614]
  }, {
    type: 'PJ',
    connectorIds: [655, 779]
  }]
}, {
  bankCode: 413,
  types: [{
    type: 'PF',
    connectorIds: [716, 717, 719]
  }, {
    type: 'PJ',
    connectorIds: [718]
  }]
}, {
  bankCode: 104,
  types: [{
    type: 'PF',
    connectorIds: [619, 783]
  }, {
    type: 'PJ',
    connectorIds: [616]
  }]
}, {
  bankCode: 745,
  types: [{
    type: 'PF',
    connectorIds: []
  }, {
    type: 'PJ',
    connectorIds: [710]
  }]
}, {
  bankCode: 321,
  types: [{
    type: 'PF',
    connectorIds: [802]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 9999,
  types: [{
    type: 'PF',
    connectorIds: [777]
  }, {
    type: 'PJ',
    connectorIds: [778]
  }]
}, {
  bankCode: 9998,
  types: [{
    type: 'PF',
    connectorIds: [677]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 341,
  types: [{
    type: 'PF',
    connectorIds: [601, 647, 638]
  }, {
    type: 'PJ',
    connectorIds: [668, 618, 786]
  }]
}, {
  bankCode: 184,
  types: [{
    type: 'PF',
    connectorIds: []
  }, {
    type: 'PJ',
    connectorIds: [794]
  }]
}, {
  bankCode: 9997,
  types: [{
    type: 'PF',
    connectorIds: [720]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 323,
  types: [{
    type: 'PF',
    connectorIds: [606]
  }, {
    type: 'PJ',
    connectorIds: [665]
  }]
}, {
  bankCode: 9996,
  types: [{
    type: 'PF',
    connectorIds: [795]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 354,
  types: [{
    type: 'PF',
    connectorIds: [793]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 536,
  types: [{
    type: 'PF',
    connectorIds: [689]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 260,
  types: [{
    type: 'PF',
    connectorIds: [612]
  }, {
    type: 'PJ',
    connectorIds: [664]
  }]
}, {
  bankCode: 9995,
  types: [{
    type: 'PF',
    connectorIds: [814]
  }, {
    type: 'PJ',
    connectorIds: [815]
  }]
}, {
  bankCode: 380,
  types: [{
    type: 'PF',
    connectorIds: [651]
  }, {
    type: 'PJ',
    connectorIds: [713]
  }]
}, {
  bankCode: 9994,
  types: [{
    type: 'PF',
    connectorIds: [765]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 9993,
  types: [{
    type: 'PF',
    connectorIds: [800]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 9992,
  types: [{
    type: 'PF',
    connectorIds: [767]
  }, {
    type: 'PJ',
    connectorIds: [768]
  }]
}, {
  bankCode: 509,
  types: [{
    type: 'PF',
    connectorIds: [696]
  }, {
    type: 'PJ',
    connectorIds: [811]
  }]
}, {
  bankCode: 102,
  types: [{
    type: 'PF',
    connectorIds: [623, 605]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 422,
  types: [{
    type: 'PF',
    connectorIds: [629, 711, 708]
  }, {
    type: 'PJ',
    connectorIds: [697, 712, 709]
  }]
}, {
  bankCode: 33,
  types: [{
    type: 'PF',
    connectorIds: [608, 798, 812]
  }, {
    type: 'PJ',
    connectorIds: [799, 813, 621]
  }]
}, {
  bankCode: 756,
  types: [{
    type: 'PF',
    connectorIds: [658]
  }, {
    type: 'PJ',
    connectorIds: [628]
  }]
}, {
  bankCode: 748,
  types: [{
    type: 'PF',
    connectorIds: [661, 676]
  }, {
    type: 'PJ',
    connectorIds: [627]
  }]
}, {
  bankCode: 197,
  types: [{
    type: 'PF',
    connectorIds: [787]
  }, {
    type: 'PJ',
    connectorIds: [788]
  }]
}, {
  bankCode: 352,
  types: [{
    type: 'PF',
    connectorIds: [796]
  }, {
    type: 'PJ',
    connectorIds: [797]
  }]
}, {
  bankCode: 136,
  types: [{
    type: 'PF',
    connectorIds: [663]
  }, {
    type: 'PJ',
    connectorIds: [670]
  }]
}, {
  bankCode: 348,
  types: [{
    type: 'PF',
    connectorIds: [602]
  }, {
    type: 'PJ',
    connectorIds: [702]
  }]
}, {
  bankCode: 290,
  types: [{
    type: 'PF',
    connectorIds: [692]
  }, {
    type: 'PJ',
    connectorIds: [816]
  }]
}, {
  bankCode: 70,
  types: [{
    type: 'PF',
    connectorIds: [817]
  }, {
    type: 'PJ',
    connectorIds: [818]
  }]
}, {
  bankCode: 389,
  types: [{
    type: 'PF',
    connectorIds: [742]
  }, {
    type: 'PJ',
    connectorIds: [819]
  }]
}, {
  bankCode: 336,
  types: [{
    type: 'PF',
    connectorIds: [626]
  }, {
    type: 'PJ',
    connectorIds: [726]
  }]
}, {
  bankCode: 69,
  types: [{
    type: 'PF',
    connectorIds: [750]
  }, {
    type: 'PJ',
    connectorIds: [860]
  }]
}, {
  bankCode: 77,
  types: [{
    type: 'PF',
    connectorIds: [823]
  }, {
    type: 'PJ',
    connectorIds: [824]
  }]
}, {
  bankCode: 301,
  types: [{
    type: 'PF',
    connectorIds: [804]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 82,
  types: [{
    type: 'PF',
    connectorIds: [680]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 63,
  types: [{
    type: 'PF',
    connectorIds: [775]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 368,
  types: [{
    type: 'PF',
    connectorIds: [821, 822]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 204,
  types: [{
    type: 'PF',
    connectorIds: [820]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}, {
  bankCode: 358,
  types: [{
    type: 'PF',
    connectorIds: [688]
  }, {
    type: 'PJ',
    connectorIds: []
  }]
}];

function getPluggyConnectorCodeByCdBankPersonType(bankCode, type) {
  var item = pluggyConnectorsMap.find(function (dado) {
    return dado.bankCode === bankCode;
  });
  if (!item) {
    return [];
  }

  if (type) {
    var typeItem = item.types.find(function (t) {
      return t.type === type;
    });

    return typeItem ? flatItemsConnectorIds({ types: [(0, _assign2.default)({}, typeItem)] }) : [];
  } else {
    return flatItemsConnectorIds(item);
  }
}

function flatItemsConnectorIds(item) {
  var allConnectors = item.types.flatMap(function (t) {
    return t.connectorIds;
  });
  return [].concat((0, _toConsumableArray3.default)(new _set2.default(allConnectors)));
}

exports.getPluggyConnectorCodeByCdBankPersonType = getPluggyConnectorCodeByCdBankPersonType;

/***/ }),
/* 750 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./client/enum/situacaoRemessa.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SituacaoRemessaEnum = {
  'EM_PROCESSAMENTO': 'P',
  'CONCLUIDO': 'C',
  'ERRO': 'E',
  'N_A': 'D',
  'AGUARDANDO_EXCLUSAO': 'X',
  'AGUARDANDO_PROCESSAMENTO': 'A',
  'REPROCESSANDO': 'R'
};

exports.default = SituacaoRemessaEnum;

/***/ }),
/* 751 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./client/enum/situacaoTarefa.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SituacaoTarefaEnum = {
  0: 'PENDENTE',
  10: 'EM_ANDAMENTO',
  20: 'AGUARDANDO',
  90: 'CONCLUIDO',
  99: 'CANCELADO'
};

exports.default = SituacaoTarefaEnum;

/***/ }),
/* 752 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(/*! vue-router */ 1575);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(/*! ../store */ 105);

var _store2 = _interopRequireDefault(_store);

var _routesMap = __webpack_require__(/*! ../router/routesMap */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

var _popExitingConfirmation = __webpack_require__(/*! ../utils/popExitingConfirmation */ 161);

var _popExitingConfirmation2 = _interopRequireDefault(_popExitingConfirmation);

var _Login = __webpack_require__(/*! ../components/views/login/Login */ 1328);

var _Login2 = _interopRequireDefault(_Login);

var _CadastrarSenha = __webpack_require__(/*! ../components/views/login/CadastrarSenha */ 1327);

var _CadastrarSenha2 = _interopRequireDefault(_CadastrarSenha);

var _LoginEmulado = __webpack_require__(/*! ../components/views/login/LoginEmulado */ 1329);

var _LoginEmulado2 = _interopRequireDefault(_LoginEmulado);

var _TrocaAplicacao = __webpack_require__(/*! ../components/views/login/TrocaAplicacao */ 1330);

var _TrocaAplicacao2 = _interopRequireDefault(_TrocaAplicacao);

var _Home = __webpack_require__(/*! ../components/views/home/Home */ 1322);

var _Home2 = _interopRequireDefault(_Home);

var _Index = __webpack_require__(/*! ../components/views/index/Index */ 1323);

var _Index2 = _interopRequireDefault(_Index);

var _BankStatement = __webpack_require__(/*! ../components/views/reports/bankStatement/BankStatement */ 1347);

var _BankStatement2 = _interopRequireDefault(_BankStatement);

var _BankBalance = __webpack_require__(/*! ../components/views/reports/bankBalance/BankBalance */ 1346);

var _BankBalance2 = _interopRequireDefault(_BankBalance);

var _DigitalWalletBalance = __webpack_require__(/*! ../components/views/reports/digitalWalletBalance/DigitalWalletBalance */ 1350);

var _DigitalWalletBalance2 = _interopRequireDefault(_DigitalWalletBalance);

var _DuplicateMovementsAnalysis = __webpack_require__(/*! ../components/views/reports/duplicateMovementsAnalysis/DuplicateMovementsAnalysis */ 1351);

var _DuplicateMovementsAnalysis2 = _interopRequireDefault(_DuplicateMovementsAnalysis);

var _FinancialMovement = __webpack_require__(/*! ../components/views/reports/financialMovement/FinancialMovement */ 1352);

var _FinancialMovement2 = _interopRequireDefault(_FinancialMovement);

var _ConciliationReport = __webpack_require__(/*! ../components/views/reports/conciliationReport/ConciliationReport */ 1348);

var _ConciliationReport2 = _interopRequireDefault(_ConciliationReport);

var _ConciliationSummary = __webpack_require__(/*! ../components/views/reports/conciliationSummary/ConciliationSummary */ 1349);

var _ConciliationSummary2 = _interopRequireDefault(_ConciliationSummary);

var _ManualConciliation = __webpack_require__(/*! ../components/views/reports/manualConciliation/ManualConciliation */ 1353);

var _ManualConciliation2 = _interopRequireDefault(_ManualConciliation);

var _OccurrenceReport = __webpack_require__(/*! ../components/views/reports/occurrenceReport/OccurrenceReport */ 1354);

var _OccurrenceReport2 = _interopRequireDefault(_OccurrenceReport);

var _ProcessedFiles = __webpack_require__(/*! ../components/views/integration/processedFiles/ProcessedFiles */ 1325);

var _ProcessedFiles2 = _interopRequireDefault(_ProcessedFiles);

var _FileUpload = __webpack_require__(/*! ../components/views/integration/fileUpload/FileUpload */ 1324);

var _FileUpload2 = _interopRequireDefault(_FileUpload);

var _RemittanceIntegration = __webpack_require__(/*! ../components/views/integration/remittanceIntegration/RemittanceIntegration */ 1326);

var _RemittanceIntegration2 = _interopRequireDefault(_RemittanceIntegration);

var _List = __webpack_require__(/*! ../components/views/registration/bankAccounts/List */ 1335);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(/*! ../components/views/registration/bankAccounts/New */ 1336);

var _New2 = _interopRequireDefault(_New);

var _List3 = __webpack_require__(/*! ../components/views/registration/establishments/List.vue */ 1341);

var _List4 = _interopRequireDefault(_List3);

var _New3 = __webpack_require__(/*! ../components/views/registration/establishments/New.vue */ 1343);

var _New4 = _interopRequireDefault(_New3);

var _Move = __webpack_require__(/*! ../components/views/registration/establishments/Move.vue */ 1342);

var _Move2 = _interopRequireDefault(_Move);

var _List5 = __webpack_require__(/*! ../components/views/registration/categories/List */ 1338);

var _List6 = _interopRequireDefault(_List5);

var _List7 = __webpack_require__(/*! ../components/views/registration/conciliationPlan/List */ 1339);

var _List8 = _interopRequireDefault(_List7);

var _New5 = __webpack_require__(/*! ../components/views/registration/conciliationPlan/New */ 1340);

var _New6 = _interopRequireDefault(_New5);

var _List9 = __webpack_require__(/*! ../components/views/registration/occurrenceReason/List */ 1344);

var _List10 = _interopRequireDefault(_List9);

var _New7 = __webpack_require__(/*! ../components/views/registration/occurrenceReason/New */ 1345);

var _New8 = _interopRequireDefault(_New7);

var _List11 = __webpack_require__(/*! ../components/views/registration/attributesSet/List */ 1332);

var _List12 = _interopRequireDefault(_List11);

var _New9 = __webpack_require__(/*! ../components/views/registration/attributesSet/New */ 1333);

var _New10 = _interopRequireDefault(_New9);

var _List13 = __webpack_require__(/*! ../components/views/administration/accessProfile/List */ 1316);

var _List14 = _interopRequireDefault(_List13);

var _New11 = __webpack_require__(/*! ../components/views/administration/accessProfile/New */ 1317);

var _New12 = _interopRequireDefault(_New11);

var _List15 = __webpack_require__(/*! ../components/views/administration/operator/List */ 1320);

var _List16 = _interopRequireDefault(_List15);

var _New13 = __webpack_require__(/*! ../components/views/administration/operator/New */ 1321);

var _New14 = _interopRequireDefault(_New13);

var _List17 = __webpack_require__(/*! ../components/views/administration/assignment/List */ 1318);

var _List18 = _interopRequireDefault(_List17);

var _AuditLog = __webpack_require__(/*! ../components/views/administration/auditLog/AuditLog */ 1319);

var _AuditLog2 = _interopRequireDefault(_AuditLog);

var _Unauthorized = __webpack_require__(/*! ../components/views/unauthorized/Unauthorized */ 1355);

var _Unauthorized2 = _interopRequireDefault(_Unauthorized);

var _NotFound = __webpack_require__(/*! ../components/views/notFound/NotFound */ 1331);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _OfdaDeepLink = __webpack_require__(/*! ../components/views/registration/bankAccounts/OfdaDeepLink */ 1337);

var _OfdaDeepLink2 = _interopRequireDefault(_OfdaDeepLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: _routesMap2.default.BANKING,
    component: _Login2.default
  }, {
    path: _routesMap2.default.PASSWORD_RECOVERY,
    component: _CadastrarSenha2.default
  }, {
    path: _routesMap2.default.NEW_PASSWORD,
    component: _CadastrarSenha2.default
  }, {
    path: _routesMap2.default.LOGIN_EMULADO,
    component: _LoginEmulado2.default
  }, {
    path: _routesMap2.default.OFDA_REG_DEEPLINK,
    component: _OfdaDeepLink2.default
  }, {
    path: _routesMap2.default.TROCA_APLICACAO,
    component: _TrocaAplicacao2.default
  }, {
    path: _routesMap2.default.HOME,
    component: _Home2.default,
    children: [{
      path: _routesMap2.default.HOME,
      component: _Index2.default
    }, {
      path: _routesMap2.default.BANK_STATEMENT,
      component: _BankStatement2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.BANK_BALANCE,
      component: _BankBalance2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.DIGITAL_WALLET_BALANCE,
      component: _DigitalWalletBalance2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.DUPLICATE_MOVEMENTS_ANALYSIS,
      component: _DuplicateMovementsAnalysis2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.FINANCIAL_MOVEMENT,
      component: _FinancialMovement2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.CONCILIATION_REPORT,
      component: _ConciliationReport2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.CONCILIATION_SUMMARY,
      component: _ConciliationSummary2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.CONCILIATION_SUMMARY_CALENDAR,
      component: _ConciliationSummary2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.MANUAL_CONCILIATION,
      component: _ManualConciliation2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.OCCURRENCE_REPORT,
      component: _OccurrenceReport2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.PROCESSED_FILES,
      component: _ProcessedFiles2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.FILE_UPLOAD,
      component: _FileUpload2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.REMITTANCE_INTEGRATION,
      component: _RemittanceIntegration2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_BANK_ACCOUNTS,
      component: _List2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.NEW_BANK_ACCOUNT,
      component: _New2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_ESTABLISHMENTS,
      component: _List4.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.NEW_ESTABLISHMENT,
      component: _New4.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.MOVE_ESTABLISHMENT,
      component: _Move2.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.CATEGORIES,
      component: _List6.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_CONCILIATION_PLANS,
      component: _List8.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.NEW_CONCILIATION_PLAN,
      component: _New6.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_OCCURRENCE_REASONS,
      component: _List10.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.NEW_OCCURRENCE_REASON,
      component: _New8.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_ATTRIBUTES_SET,
      component: _List12.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.NEW_ATTRIBUTES_SET,
      component: _New10.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_ACCESS_PROFILE,
      component: _List14.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.NEW_ACCESS_PROFILE,
      component: _New12.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_OPERATORS,
      component: _List16.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.NEW_OPERATOR,
      component: _New14.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.LIST_ASSIGNMENT,
      component: _List18.default,
      meta: {
        requiresAuth: true
      }
    }, {
      path: _routesMap2.default.AUDIT_LOG,
      component: _AuditLog2.default,
      meta: {
        requiresAuth: true
      }
    }]
  }, {
    path: _routesMap2.default.UNAUTHORIZED,
    component: _Unauthorized2.default
  }, {
    path: '*',
    component: _NotFound2.default
  }]
});

router.beforeResolve(function (to, from, next) {
  var response = false;
  if (!_store2.default.getters.hasUnsavedChanges || (0, _popExitingConfirmation2.default)()) {
    response = true;
    next();
  }
  _store2.default.dispatch('setConfirmResponse', response);
});

router.beforeEach(function (to, from, next) {
  if (localStorage.getItem('CONNECTION_ERROR')) {
    localStorage.removeItem('CONNECTION_ERROR');
    _store2.default.dispatch('cleanSession');
    router.push(_routesMap2.default.LOGIN);
  } else if (_store2.default.getters.isLoggedIn && (to.path === _routesMap2.default.BANKING || to.path === _routesMap2.default.BANKING + '/')) {
    _store2.default.dispatch('clearSelectedMenuItem');
    router.push(_routesMap2.default.HOME);
  } else if (!_store2.default.getters.isLoggedIn && (to.path === _routesMap2.default.HOME || to.path === _routesMap2.default.HOME + '/')) {
    router.push(_routesMap2.default.BANKING);
  } else {
    checkLoadPage(to, from, next);
  }
});

router.afterEach(function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(to, from) {
    var response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _store2.default.dispatch('currentRoute', to.path);
            if (from.fullPath === '/' && _store2.default.getters.lastUrl !== to.fullPath) {
              _store2.default.dispatch('cleanEditState');
            }
            if (to.path !== _routesMap2.default.HOME) {
              _store2.default.dispatch('cancelDashboardRequests');
            }

            if (!(!_store2.default.getters.isLoggedIn && to.meta.requiresAuth)) {
              _context.next = 10;
              break;
            }

            if (to.path === '/banking/tarefas') {
              _store2.default.dispatch('setLastUrl', to.fullPath);
              _store2.default.dispatch('setUpdateLocation', true);
            }
            _context.next = 7;
            return _store2.default.dispatch('logout');

          case 7:
            if (to.path !== _routesMap2.default.LOGIN) {
              router.push(_routesMap2.default.LOGIN);
            }
            _context.next = 27;
            break;

          case 10:
            if (!(to && to.path !== _routesMap2.default.UNAUTHORIZED && to.meta && to.meta.requiresAuth)) {
              _context.next = 27;
              break;
            }

            _context.next = 13;
            return _store2.default.dispatch('getFuncionalities');

          case 13:
            response = _context.sent;
            _context.next = 16;
            return _store2.default.dispatch('saveAllowedFuncionalities', response.data.allowedFunc);

          case 16:
            _context.prev = 16;
            _context.next = 19;
            return _store2.default.dispatch('verifyTokenAndAuthorization', to.path);

          case 19:
            if (to.path === _routesMap2.default.LOGIN) {
              _store2.default.dispatch('setLastUrl', _routesMap2.default.HOME.path);
              router.push(_routesMap2.default.HOME);
            } else {
              _store2.default.dispatch('setLastUrl', to.fullPath);
            }
            _context.next = 27;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context['catch'](16);
            _context.next = 26;
            return _store2.default.dispatch('logout');

          case 26:
            if (to.path !== _routesMap2.default.LOGIN) {
              router.push(_routesMap2.default.LOGIN);
            }

          case 27:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[16, 22]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());

var checkLoadPage = function checkLoadPage(to, from, next) {
  if (from.path === _routesMap2.default.MANUAL_CONCILIATION) {
    _store2.default.dispatch('alertUser').then(function () {
      next();
    }).catch();
  } else {
    next();
  }
};

exports.default = router;

/***/ }),
/* 753 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/store/modules/accessProfile.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    profileToEditId: null
  },

  mutations: {
    PROFILE_TO_EDIT_SELECTED: function PROFILE_TO_EDIT_SELECTED(state, profileId) {
      state.profileToEditId = profileId;
    },
    CLEAN_PROFILE_TO_EDIT: function CLEAN_PROFILE_TO_EDIT(state) {
      state.profileToEditId = null;
    }
  },

  actions: {
    getProfiles: function getProfiles(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/accessProfile/').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getOperatorProfiles: function getOperatorProfiles(_ref2, url) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(url).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getFunctionalitiesGroups: function getFunctionalitiesGroups(_ref3, url) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(url).then(function (response) {
          var group = response.data.find(function (el) {
            return el.id === 35;
          });
          group.funcionalidades = group.funcionalidades.filter(function (func) {
            return func.id !== 206;
          });

          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    newProfile: function newProfile(_ref4, data) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/accessProfile', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getProfile: function getProfile(_ref5, idProfile) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/accessProfile/find', { params: { idProfile: idProfile } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setProfileToEdit: function setProfileToEdit(_ref6, profileId) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('PROFILE_TO_EDIT_SELECTED', profileId);
        resolve();
      });
    },

    cleanProfileToEdit: function cleanProfileToEdit(_ref7) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_PROFILE_TO_EDIT');
        resolve();
      });
    }
  },

  getters: {
    profileToEditId: function profileToEditId(state) {
      return state.profileToEditId;
    }
  }
};

/***/ }),
/* 754 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/store/modules/assignment.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    situationFilter: {
      arraySituations: [],
      type: null,
      dateFirstDue: null,
      fromDashboard: false
    }
  },

  mutations: {
    SET_FILTER_TASK_LIST: function SET_FILTER_TASK_LIST(state, filter) {
      state.situationFilter = {
        arraySituations: filter.arraySituations,
        type: filter.type,
        dateFirstDue: filter.dateFirstDue,
        fromDashboard: filter.fromDashboard
      };
    },
    CLEAR_FILTER_TASK_LIST: function CLEAR_FILTER_TASK_LIST(state, filter) {
      state.situationFilter = {
        arraySituations: [],
        type: null,
        dateFirstDue: null
      };
    }
  },

  actions: {
    searchAssignment: function searchAssignment(_ref, filter) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/assignment/', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchTaskBoundType: function searchTaskBoundType(_ref2, tarefaId) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/assignment/searchTaskBoundType', { tarefaId: tarefaId }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setFilterTasksList: function setFilterTasksList(_ref3, filter) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_FILTER_TASK_LIST', filter);
        resolve();
      });
    },

    clearFilterTaskList: function clearFilterTaskList(_ref4) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAR_FILTER_TASK_LIST');
        resolve();
      });
    }
  },

  getters: {
    situationFilter: function situationFilter(state) {
      return state.situationFilter;
    }
  }
};

/***/ }),
/* 755 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/store/modules/attributesSet.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    attributeToEditOrder: null,
    attributesList: [],
    attributesSetList: [],
    attributeSetToEdit: {},
    attributesListIsDrawed: true
  },

  mutations: {
    UPDATE_ATT_LIST: function UPDATE_ATT_LIST(state, attList) {
      state.attributesList = attList;
    },
    UPDATE_ATT_SET_LIST: function UPDATE_ATT_SET_LIST(state, attSetList) {
      state.attributesSetList = attSetList;
    },
    SET_ATT_TO_EDIT: function SET_ATT_TO_EDIT(state, attId) {
      state.attributeToEditOrder = attId;
    },
    SET_ATTSET_TO_EDIT: function SET_ATTSET_TO_EDIT(state, attSet) {
      state.attributeSetToEdit = attSet;
    },
    EDIT_ATTRIBUTE_ON_LIST: function EDIT_ATTRIBUTE_ON_LIST(state, att) {
      state.attributesList[att.order - 1] = att;
    },
    ADD_ATTRIBUTE_TO_LIST: function ADD_ATTRIBUTE_TO_LIST(state, att) {
      att.order = state.attributesList.length + 1;
      state.attributesList.push(att);
    },
    REMOVE_ATTRIBUTE_FROM_LIST: function REMOVE_ATTRIBUTE_FROM_LIST(state, attOrder) {
      state.attributesList.splice(attOrder - 1, 1);
    },
    CLEAR_ATTRIBUTE_SET_TO_EDIT: function CLEAR_ATTRIBUTE_SET_TO_EDIT(state) {
      state.attributeSetToEdit = null;
      state.attributesSetList = [];
    },
    CLEAR_EDIT_ATTRIBUTE_ID_TO_EDIT: function CLEAR_EDIT_ATTRIBUTE_ID_TO_EDIT(state) {
      state.attributeToEditOrder = null;
    },
    CLEAR_ATTRIBUTE_LIST: function CLEAR_ATTRIBUTE_LIST(state) {
      state.attributesList = [];
    },
    REDRAW_LIST_OF_ATTRIBUTES: function REDRAW_LIST_OF_ATTRIBUTES(state) {
      state.attributesListIsDrawed = false;
      state.attributesListIsDrawed = true;
    },
    CLEAR_EDIT_ATTRIBUTE: function CLEAR_EDIT_ATTRIBUTE(state) {
      state.attributesList = {};
    }
  },

  actions: {
    updateAttList: function updateAttList(_ref, attList) {
      var commit = _ref.commit;

      commit('UPDATE_ATT_LIST', attList);
      commit('REDRAW_LIST_OF_ATTRIBUTES');
    },

    getAttributesSet: function getAttributesSet(_ref2) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/attributesSet/').then(function (response) {
          return resolve(response.data);
        }).catch(function (error) {
          return reject(error.data);
        });
      });
    },

    setAttributesSetList: function setAttributesSetList(_ref3, attSetList) {
      var commit = _ref3.commit;

      commit('UPDATE_ATT_SET_LIST', attSetList);
    },

    setAttributeToEdit: function setAttributeToEdit(_ref4, attId) {
      var commit = _ref4.commit;

      commit('SET_ATT_TO_EDIT', attId);
    },

    setAttributesSetToEdit: function setAttributesSetToEdit(_ref5, attSet) {
      var commit = _ref5.commit;

      commit('SET_ATTSET_TO_EDIT', attSet);
      commit('UPDATE_ATT_LIST', attSet.attributes);
      commit('REDRAW_LIST_OF_ATTRIBUTES');
    },

    clearEditAttributeSet: function clearEditAttributeSet(_ref6) {
      var commit = _ref6.commit;

      commit('CLEAR_ATTRIBUTE_SET_TO_EDIT');
    },

    editAttribute: function editAttribute(_ref7, att) {
      var commit = _ref7.commit;

      commit('EDIT_ATTRIBUTE_ON_LIST', att);
      commit('CLEAR_EDIT_ATTRIBUTE_ID_TO_EDIT');
      commit('REDRAW_LIST_OF_ATTRIBUTES');
    },

    clearEditAttribute: function clearEditAttribute(_ref8) {
      var commit = _ref8.commit;

      commit('CLEAR_EDIT_ATTRIBUTE_ID_TO_EDIT');
    },

    clearAttributeList: function clearAttributeList(_ref9) {
      var commit = _ref9.commit;

      commit('CLEAR_ATTRIBUTE_LIST');
    },

    saveAttributeSet: function saveAttributeSet(_ref10, attributeSet) {
      var commit = _ref10.commit;

      attributeSet.attributes.forEach(function (element, index) {
        element.order = index + 1;
      });

      return _axiosCommon2.default.post('/attributesSet/typeConfig', { attributeSet: attributeSet }).then(function (response) {
        return _promise2.default.resolve(response.data);
      }).catch(function (error) {
        return _promise2.default.reject(error);
      });
    },

    getAttributeSetById: function getAttributeSetById(_ref11, attSetId) {
      var commit = _ref11.commit;

      return _axiosCommon2.default.get('/attributesSet/typeConfig?attSetId=' + attSetId).then(function (response) {
        if (response.data === 'GENERAL') {
          _promise2.default.reject(response.data);
        }
        return response.data;
      }).catch(function (error) {
        return error.message;
      });
    },

    addAttribute: function addAttribute(_ref12, att) {
      var commit = _ref12.commit;

      commit('ADD_ATTRIBUTE_TO_LIST', att);
      commit('REDRAW_LIST_OF_ATTRIBUTES');
    },

    removeAttribute: function removeAttribute(_ref13, attOrder) {
      var commit = _ref13.commit;

      commit('REMOVE_ATTRIBUTE_FROM_LIST', attOrder);
      commit('REDRAW_LIST_OF_ATTRIBUTES');
    },

    loadAttributeTypes: function loadAttributeTypes(_ref14) {
      var commit = _ref14.commit;

      return _axiosCommon2.default.get('/attributesSet/types').then(function (response) {
        return _promise2.default.resolve(response.data);
      }).catch(function (error) {
        return _promise2.default.reject(error.data);
      });
    },

    removeAttributeSet: function removeAttributeSet(_ref15, idAtributoCfg) {
      var commit = _ref15.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.delete('/attributesSet/removeAttributeSet', { params: { idAtributoCfg: idAtributoCfg } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {
    attributeToEditOrder: function attributeToEditOrder(state) {
      return state.attributeToEditOrder;
    },
    attributesList: function attributesList(state) {
      return state.attributesList;
    },
    editingAttribute: function editingAttribute(state) {
      return state.attributeToEditOrder ? state.attributesList[state.attributeToEditOrder] : state.attributesList;
    },
    attributeSetToEdit: function attributeSetToEdit(state) {
      return state.attributeSetToEdit;
    },
    attributesListIsDrawed: function attributesListIsDrawed(state) {
      return state.attributesListIsDrawed;
    },
    attributesSetList: function attributesSetList(state) {
      return state.attributesSetList;
    }
  }
};

/***/ }),
/* 756 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./client/store/modules/auditLog.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    getEntities: function getEntities(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/auditLog/entities').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getAudit: function getAudit(_ref2, auditId) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/auditLog/audits', { params: { auditId: auditId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 757 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./client/store/modules/bankAccounts.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    bankAccounttoEditId: null
  },

  mutations: {
    CLEAN_BANK_ACCOUNT_TO_EDIT: function CLEAN_BANK_ACCOUNT_TO_EDIT(state) {
      state.bankAccounttoEditId = null;
    },
    BANK_ACCOUNT_TO_EDIT_SELECTED: function BANK_ACCOUNT_TO_EDIT_SELECTED(state, bankAccounttoEditId) {
      state.bankAccounttoEditId = bankAccounttoEditId;
    }
  },

  actions: {
    getBankAccounts: function getBankAccounts(_ref, url) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(url).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    newBankAccount: function newBankAccount(_ref2, data) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/bankAccounts', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setBankAccountToEdit: function setBankAccountToEdit(_ref3, bankAccountId) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('BANK_ACCOUNT_TO_EDIT_SELECTED', bankAccountId);
        resolve();
      });
    },

    cleanBankAccountToEdit: function cleanBankAccountToEdit(_ref4) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_BANK_ACCOUNT_TO_EDIT');
        resolve();
      });
    },

    getBankAccount: function getBankAccount(_ref5, bankAccountId) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/bankAccounts/find', { params: { bankAccountId: bankAccountId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getBanks: function getBanks(_ref6) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/bankAccounts/banks').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getAccountsByGroup: function getAccountsByGroup(_ref7, groupId) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/bankAccounts/find/group', { params: { groupId: groupId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    removeBankAccount: function removeBankAccount(_ref8, bankAccountIdToRemove) {
      var commit = _ref8.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.delete('/bankAccounts', { params: { bankAccountId: bankAccountIdToRemove } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },
  getters: {
    bankAccounttoEditId: function bankAccounttoEditId(state) {
      return state.bankAccounttoEditId;
    }
  }
};

/***/ }),
/* 758 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/store/modules/bankStatement.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _generateDateTime = __webpack_require__(/*! ../../utils/generateDateTime */ 202);

var _generateDateTime2 = _interopRequireDefault(_generateDateTime);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    getAccountEntryByIdTask: function getAccountEntryByIdTask(_ref, obj) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(obj.url, { params: { idTarefa: obj.idTask } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getHistoricBankStat: function getHistoricBankStat(_ref2, data) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(data.url, { params: { idBankStat: data.idBankStat } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getAllotmentByBankMovementId: function getAllotmentByBankMovementId(_ref3, data) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(data.url, { params: { idMovimento: data.idBankStat } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    searchBankStatementToFile: function searchBankStatementToFile(_ref4, filter) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/bankStatement/searchBankStatementToFile', filter, { responseType: 'blob' }).then(function (response) {
          var datetime = (0, _generateDateTime2.default)();
          var blob = new Blob([response.data]);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', _vue2.default.i18n.translate('downloads.labels.extratoBancario') + datetime + '.csv');
          document.body.appendChild(link);
          link.click();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    declassifyBankMovementList: function declassifyBankMovementList(_ref5, data) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        (0, _axiosCommon2.default)({
          url: '/bankStatement/deleteBankMovimentList',
          method: 'DELETE',
          data: data,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 759 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/store/modules/categories.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    categorieFather: {},
    lastCategorieNumber: null,
    categorieToEdit: {},
    numberOfCategories: null,
    lastCategorieOrder: null
  },

  mutations: {
    SET_FATHER_CATEGORIE: function SET_FATHER_CATEGORIE(state, categorie) {
      state.categorieFather = {
        id: categorie.id,
        description: categorie.description,
        number: categorie.number,
        lastChildren: categorie.lastChildren,
        isMainFather: categorie.isMainFather,
        order: categorie.order,
        initialBalance: categorie.initialBalance,
        balanceInitialDate: categorie.balanceInitialDate
      };
    },
    SET_LAST_CATEGORIE_ORDER: function SET_LAST_CATEGORIE_ORDER(state, order) {
      state.lastCategorieOrder = order;
    },
    CLEAN_LAST_CATEGORIE_ORDER: function CLEAN_LAST_CATEGORIE_ORDER(state) {
      state.lastCategorieOrder = null;
    },
    CLEAN_FATHER_CATEGORIE: function CLEAN_FATHER_CATEGORIE(state) {
      state.categorieFather = {};
    },
    SET_CATEGORIE_TO_EDIT: function SET_CATEGORIE_TO_EDIT(state, categorie) {
      state.categorieToEdit = {
        id: categorie.id,
        fatherCategory: {
          id: categorie.fatherCategory ? categorie.fatherCategory.id : null,
          name: categorie.fatherCategory ? categorie.fatherCategory.nome : null,
          number: categorie.fatherCategory ? categorie.fatherCategory.numero : null
        },
        name: categorie.description,
        number: categorie.number,
        type: categorie.type,
        accountingId: categorie.accountingId,
        order: categorie.order,
        initialBalance: categorie.initialBalance,
        balanceInitialDate: categorie.balanceInitialDate
      };
    },
    CLEAN_CATEGORIE_TO_EDIT: function CLEAN_CATEGORIE_TO_EDIT(state) {
      state.categorieToEdit = {};
    },
    RELOAD_CATEGORIE_LIST: function RELOAD_CATEGORIE_LIST(state, flag) {
      state.reloadCategorieList = flag;
    },
    SET_LAST_CATEGORIE_NUMBER: function SET_LAST_CATEGORIE_NUMBER(state, number) {
      state.lastCategorieNumber = number;
    },
    CLEAN_LAST_CATEGORIE_NUMBER: function CLEAN_LAST_CATEGORIE_NUMBER(state) {
      state.lastCategorieNumber = null;
    },
    SET_CATEGORIES_QTY: function SET_CATEGORIES_QTY(state, qty) {
      state.numberOfCategories = qty;
    }
  },

  actions: {
    getCategorie: function getCategorie(_ref, categorieId) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/categories/find', { params: { categorieId: categorieId } }).then(function (response) {
          commit('SET_CATEGORIE_TO_EDIT', response.data);
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getCategories: function getCategories(_ref2, data) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(data.url, {
          params: {
            flTipoCategoria: data.flTipoCategoria,
            validarUso: data.validarUso
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getMainCategories: function getMainCategories(_ref3, url) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(url).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    saveCategorie: function saveCategorie(_ref4, categorie) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/categories', categorie).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    removeCategorie: function removeCategorie(_ref5, categorieId) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.delete('/categories', { params: { categorieId: categorieId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setCategorieFather: function setCategorieFather(_ref6, categorie) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_FATHER_CATEGORIE', categorie);
        resolve();
      });
    },

    cleanCategorieToEdit: function cleanCategorieToEdit(_ref7) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_CATEGORIE_TO_EDIT');
        resolve();
      });
    },

    setReloadCategories: function setReloadCategories(_ref8, flag) {
      var commit = _ref8.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('RELOAD_CATEGORIE_LIST', flag);
        resolve();
      });
    },

    cleanCategorieFather: function cleanCategorieFather(_ref9) {
      var commit = _ref9.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_FATHER_CATEGORIE');
        resolve();
      });
    },

    setLastCategorieNumber: function setLastCategorieNumber(_ref10, number) {
      var commit = _ref10.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_LAST_CATEGORIE_NUMBER', number);
        resolve();
      });
    },

    cleanLastCategorieNumber: function cleanLastCategorieNumber(_ref11) {
      var commit = _ref11.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_LAST_CATEGORIE_NUMBER');
        resolve();
      });
    },

    setLastCategorieOrder: function setLastCategorieOrder(_ref12, order) {
      var commit = _ref12.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_LAST_CATEGORIE_ORDER', order);
        resolve();
      });
    },

    cleanLastCategorieOrder: function cleanLastCategorieOrder(_ref13) {
      var commit = _ref13.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_LAST_CATEGORIE_ORDER');
        resolve();
      });
    }
  },

  getters: {
    categorieFather: function categorieFather(state) {
      return state.categorieFather;
    },
    categorieToEdit: function categorieToEdit(state) {
      return state.categorieToEdit;
    },
    cleanCategorieToEdit: function cleanCategorieToEdit(state) {
      return state.cleanCategorieToEdit;
    },
    reloadCategorieList: function reloadCategorieList(state) {
      return state.reloadCategorieList;
    },
    cleanCategorieFather: function cleanCategorieFather(state) {
      return state.cleanCategorieFather;
    },
    lastCategorieNumber: function lastCategorieNumber(state) {
      return state.lastCategorieNumber;
    },
    numberOfCategories: function numberOfCategories(state) {
      return state.numberOfCategories;
    },
    lastCategorieOrder: function lastCategorieOrder(state) {
      return state.lastCategorieOrder;
    }
  }
};

/***/ }),
/* 760 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./client/store/modules/cities.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    getCities: function getCities(_ref, uf) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/cities/' + uf).then(function (response) {
          resolve(response.data.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 761 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./client/store/modules/client.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    client: null,
    clients: [],
    clientApps: [],
    clientName: null,
    singleClient: null,
    openClientModal: false,
    openMyAccountModal: false,
    openAppChangeModal: false,
    accessProfileName: ''
  },

  mutations: {
    CLIENT_SELECTED: function CLIENT_SELECTED(state, data) {
      state.client = data.client;
      state.clientName = data.clientName;
      state.singleClient = data.singleClient;
      state.selectedMenuItem = null;
    },
    OPEN_CHANGE_APP_MODAL: function OPEN_CHANGE_APP_MODAL(state) {
      state.openAppChangeModal = !state.openAppChangeModal;
    },
    OPEN_CLIENT_MODAL: function OPEN_CLIENT_MODAL(state) {
      state.openClientModal = !state.openClientModal;
    },
    OPEN_MYACCOUNT_MODAL: function OPEN_MYACCOUNT_MODAL(state) {
      state.openMyAccountModal = !state.openMyAccountModal;
    },
    SET_CLIENTS: function SET_CLIENTS(state, clients) {
      state.clients = clients;
    },
    ACCESS_PROFILE_SELECTED: function ACCESS_PROFILE_SELECTED(state, accessProfileName) {
      state.accessProfileName = accessProfileName;
    },
    ACCESS_PROFILE_ID_SELECTED: function ACCESS_PROFILE_ID_SELECTED(state, accessProfileId) {
      state.accessProfileId = accessProfileId;
    },
    IS_LOGIN_EMULADO: function IS_LOGIN_EMULADO(state, isEmulated) {
      state.isEmulated = isEmulated;
    },
    SET_CLIENT_APPS: function SET_CLIENT_APPS(state, apps) {
      state.clientApps = [];
      apps.filter(function (element) {
        state.clientApps.push(element['id']);
      });
    }
  },

  actions: {
    getClients: function getClients(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/client/').then(function (response) {
          commit('SET_CLIENTS', response.data);
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setClient: function setClient(_ref2, data) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/client/', { clientId: data.client }).then(function (response) {
          commit('CLIENT_SELECTED', data);

          if (response.data.perfilAcesso && response.data.perfilAcesso.nome) {
            commit('ACCESS_PROFILE_ID_SELECTED', response.data.perfilAcesso.id);
            commit('ACCESS_PROFILE_SELECTED', response.data.perfilAcesso.nome);
          }

          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    openClientModal: function openClientModal(_ref3) {
      var commit = _ref3.commit;

      return commit('OPEN_CLIENT_MODAL');
    },

    openMyAccountModal: function openMyAccountModal(_ref4) {
      var commit = _ref4.commit;

      return commit('OPEN_MYACCOUNT_MODAL');
    },

    openAppChangeModal: function openAppChangeModal(_ref5) {
      var commit = _ref5.commit;

      return commit('OPEN_CHANGE_APP_MODAL');
    },

    setClientEmulatedLogin: function setClientEmulatedLogin(_ref6, data) {
      var commit = _ref6.commit;

      commit('CLIENT_SELECTED', data);
      commit('IS_LOGIN_EMULADO', true);
    },

    setAplicacoes: function setAplicacoes(_ref7, data) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_CLIENT_APPS', data);
        resolve();
      });
    },

    getAplicacoes: function getAplicacoes(_ref8) {
      var commit = _ref8.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/client/aplicacoes').then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    trocaAplicacao: function trocaAplicacao(_ref9, app) {
      var commit = _ref9.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/login/trocaAplicacao', app).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setPerfilAcesso: function setPerfilAcesso(_ref10, perfilAcesso) {
      var commit = _ref10.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('ACCESS_PROFILE_ID_SELECTED', perfilAcesso.id);
        commit('ACCESS_PROFILE_SELECTED', perfilAcesso.nome);
        resolve();
      });
    }
  },

  getters: {
    client: function client(state) {
      return state.client;
    },
    clients: function clients(state) {
      return state.clients;
    },
    clientName: function clientName(state) {
      return state.clientName;
    },
    singleClient: function singleClient(state) {
      return state.singleClient;
    },
    openClientModal: function openClientModal(state) {
      return state.openClientModal;
    },
    openMyAccountModal: function openMyAccountModal(state) {
      return state.openMyAccountModal;
    },
    accessProfileName: function accessProfileName(state) {
      return state.accessProfileName;
    },
    accessProfileId: function accessProfileId(state) {
      return state.accessProfileId;
    },
    openAppChangeModal: function openAppChangeModal(state) {
      return state.openAppChangeModal;
    },
    clientApps: function clientApps(state) {
      return state.clientApps;
    },
    isClientEmulatedLogin: function isClientEmulatedLogin(state) {
      return state.isEmulated;
    }
  }
};

/***/ }),
/* 762 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/store/modules/conciliationPlan.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    planToEditId: null
  },

  mutations: {
    CLEAN_PLAN_TO_EDIT: function CLEAN_PLAN_TO_EDIT(state) {
      state.planToEditId = null;
    },
    PLAN_TO_EDIT_SELECTED: function PLAN_TO_EDIT_SELECTED(state, planToEditId) {
      state.planToEditId = planToEditId;
    }
  },

  actions: {
    savePlan: function savePlan(_ref, data) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/conciliationPlan/savePlan', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getPlans: function getPlans(_ref2, url) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(url).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getPlan: function getPlan(_ref3, idPlan) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/conciliationPlan/find', { params: { idPlan: idPlan } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setPlanToEdit: function setPlanToEdit(_ref4, planId) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('PLAN_TO_EDIT_SELECTED', planId);
        resolve();
      });
    },

    cleanPlanToEdit: function cleanPlanToEdit(_ref5) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_PLAN_TO_EDIT');
        resolve();
      });
    },

    getFebraban: function getFebraban() {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/conciliationPlan/febraban').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getConciliationFields: function getConciliationFields(_ref6) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/conciliationPlan/conciliationFields').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    removeConciliationPlan: function removeConciliationPlan(_ref7, idPlan) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.delete('/conciliationPlan/removeConciliationPlan', { params: { idPlan: idPlan } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {
    planToEditId: function planToEditId(state) {
      return state.planToEditId;
    }
  }
};

/***/ }),
/* 763 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./client/store/modules/conciliationReport.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    searchConciliationReport: function searchConciliationReport(_ref, filter) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/conciliationReport/searchConciliationReport', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchConciliationReportToFile: function searchConciliationReportToFile(_ref2, filter) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/conciliationReport/searchConciliationReportToFile', filter, { responseType: 'blob' }).then(function (response) {
          var currentdate = new Date();
          var datetime = currentdate.getDate().toString() + (currentdate.getMonth() + 1).toString() + currentdate.getFullYear().toString() + '_' + currentdate.getHours() + currentdate.getMinutes() + currentdate.getSeconds();
          var blob = new Blob([response.data]);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = _vue2.default.i18n.translate('downloads.labels.relatorioConciliacao') + datetime + '.csv';
          link.click();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getBankStatementById: function getBankStatementById(_ref3, data) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/bankStatement/getBankStatementById', { params: { idMovimentacaoBancaria: data } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getHistoricConciliationReport: function getHistoricConciliationReport(_ref4, data) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(data.url, { params: { conciliationReportId: data.conciliationReportId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 764 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./client/store/modules/conciliationSummary.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _generateDateTime = __webpack_require__(/*! ../../utils/generateDateTime */ 202);

var _generateDateTime2 = _interopRequireDefault(_generateDateTime);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    searchConciliationSummary: function searchConciliationSummary(_ref, filter) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/conciliationSummary/search', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchConciliationSummaryToFile: function searchConciliationSummaryToFile(_ref2, filter) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/conciliationSummary/searchConciliationSummaryToFile', filter, { responseType: 'blob' }).then(function (response) {
          var datetime = (0, _generateDateTime2.default)();
          var blob = new Blob([response.data]);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', _vue2.default.i18n.translate('downloads.labels.resumoConciliacao') + datetime + '.csv');
          document.body.appendChild(link);
          link.click();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 765 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./client/store/modules/dashboard.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _store = __webpack_require__(/*! ../../store */ 105);

var _store2 = _interopRequireDefault(_store);

var _filtroPeriodo = __webpack_require__(/*! ../../enum/filtroPeriodo */ 199);

var _filtroPeriodo2 = _interopRequireDefault(_filtroPeriodo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    availableGadgets: [],
    currentRequests: {},
    periodDashboard: {
      id: _filtroPeriodo2.default.ULTIMOS_TRINTA_DIAS
    },
    plansDashboard: [],
    mainCategoriesDashboard: [],

    periodFilterConcSitSummary: {},
    planSelectedFilterConcSitSummary: {},
    typeFilterConcSituationSummary: {},
    mainCategorySelectedFilterConcSitSummary: {},

    periodFilterAllotmentDistribution: {},
    planSelectedFilterBatch: {},
    typeSelectedFilterBatch: {},
    mainCategorySelectedFilterBatch: {},

    periodFilterFinancialSummary: {},
    mainCategorySelectedFilterFinancialSummary: {},

    periodFilterBankBalance: {},
    accountSelectedBankBalance: {},

    periodFilterDigitalWalletBalance: {},
    categorySelectedDigitalWalletBalance: {}
  },

  mutations: {
    SET_AVAILABLE_GADGETS: function SET_AVAILABLE_GADGETS(state, gadgets) {
      state.availableGadgets = [];
      state.availableGadgets = gadgets;
    },
    CLEAN_GADGETS_FILTERS: function CLEAN_GADGETS_FILTERS(state) {
      state.periodDashboard = {
        id: _filtroPeriodo2.default.ULTIMOS_TRINTA_DIAS
      };

      state.periodFilterConcSitSummary = {};
      state.planSelectedFilterConcSitSummary = {};
      state.typeFilterConcSituationSummary = {};
      state.mainCategorySelectedFilterConcSitSummary = {};

      state.periodFilterAllotmentDistribution = {};
      state.planSelectedFilterBatch = {};
      state.typeSelectedFilterBatch = {};
      state.mainCategorySelectedFilterBatch = {};

      state.periodFilterFinancialSummary = {};
      state.mainCategorySelectedFilterFinancialSummary = {};

      state.periodFilterBankBalance = {};
      state.accountSelectedBankBalance = {};

      state.periodFilterDigitalWalletBalance = {};
      state.categorySelectedDigitalWalletBalance = {};
    },
    SET_PERIOD_DASHBOARD: function SET_PERIOD_DASHBOARD(state, period) {
      state.periodDashboard = (0, _assign2.default)({}, period);
    },
    SET_PLANS_FILTER_DASHBOARD: function SET_PLANS_FILTER_DASHBOARD(state, plans) {
      state.plansDashboard = plans;
    },
    SET_MAIN_CATEGORIES_FILTER_DASHBOARD: function SET_MAIN_CATEGORIES_FILTER_DASHBOARD(state, mainCategories) {
      state.mainCategoriesDashboard = mainCategories;
    },
    SET_PERIOD_FILTER_CONCILIATION_SITUATION_SUMMARY: function SET_PERIOD_FILTER_CONCILIATION_SITUATION_SUMMARY(state, period) {
      state.periodFilterConcSitSummary = (0, _assign2.default)({}, period);
    },
    SET_PLAN_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY: function SET_PLAN_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY(state, planSelected) {
      state.planSelectedFilterConcSitSummary = planSelected;
    },
    SET_TYPE_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY: function SET_TYPE_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY(state, typeSelected) {
      state.typeFilterConcSituationSummary = typeSelected;
    },
    SET_MAIN_CATEGORY_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY: function SET_MAIN_CATEGORY_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY(state, mainCategorySelected) {
      state.mainCategorySelectedFilterConcSitSummary = mainCategorySelected;
    },
    SET_PERIOD_FILTER_BATCH_DISTRIBUTION: function SET_PERIOD_FILTER_BATCH_DISTRIBUTION(state, period) {
      state.periodFilterAllotmentDistribution = (0, _assign2.default)({}, period);
    },
    SET_PLAN_SELECTED_FILTER_BATCH: function SET_PLAN_SELECTED_FILTER_BATCH(state, planSelected) {
      state.planSelectedFilterBatch = planSelected;
    },
    SET_TYPE_SELECTED_FILTER_BATCH: function SET_TYPE_SELECTED_FILTER_BATCH(state, typeSelected) {
      state.typeSelectedFilterBatch = typeSelected;
    },
    SET_MAIN_CATEGORY_SELECTED_FILTER_BATCH: function SET_MAIN_CATEGORY_SELECTED_FILTER_BATCH(state, mainCategorySelected) {
      state.mainCategorySelectedFilterBatch = mainCategorySelected;
    },
    SET_PERIOD_FILTER_FINANCIAL_SUMMARY: function SET_PERIOD_FILTER_FINANCIAL_SUMMARY(state, period) {
      state.periodFilterFinancialSummary = (0, _assign2.default)({}, period);
    },
    SET_MAIN_CATEGORY_SELECTED_FILTER_FINANCIAL_SUMMARY: function SET_MAIN_CATEGORY_SELECTED_FILTER_FINANCIAL_SUMMARY(state, mainCategorySelected) {
      state.mainCategorySelectedFilterFinancialSummary = mainCategorySelected;
    },
    SET_PERIOD_SELECTED_FILTER_BANK_BALANCE: function SET_PERIOD_SELECTED_FILTER_BANK_BALANCE(state, periodo) {
      state.periodFilterBankBalance = (0, _assign2.default)({}, periodo);
    },
    SET_ACCOUNT_SELECTED_FILTER_BANK_BALANCE: function SET_ACCOUNT_SELECTED_FILTER_BANK_BALANCE(state, accSelected) {
      state.accountSelectedBankBalance = accSelected;
    },
    SET_PERIOD_SELECTED_FILTER_DIGITAL_WALLET_BALANCE: function SET_PERIOD_SELECTED_FILTER_DIGITAL_WALLET_BALANCE(state, periodo) {
      state.periodFilterDigitalWalletBalance = (0, _assign2.default)({}, periodo);
    },
    SET_CATEGORY_SELECTED_FILTER_DIGITAL_WALLET_BALANCE: function SET_CATEGORY_SELECTED_FILTER_DIGITAL_WALLET_BALANCE(state, categorySelected) {
      state.categorySelectedDigitalWalletBalance = categorySelected;
    }
  },

  actions: {
    getGadgets: function getGadgets(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashBoard/gadgets').then(function (response) {
          var avaliableGadgets = response.data.data;
          var avaliableFunctionlitiesGadgets = [];
          if (avaliableGadgets && avaliableGadgets.length > 0) {
            avaliableGadgets.forEach(function (avaliableGadget) {
              if (_store2.default.getters.allowedFuncionalities.indexOf(avaliableGadget.funcionalidade.idFuncionalidade) >= 0) {
                avaliableFunctionlitiesGadgets.push(avaliableGadget);
              }
            });
          }
          commit('SET_AVAILABLE_GADGETS', avaliableFunctionlitiesGadgets);
          resolve(response);
        }).catch(function (error) {
          commit('SET_AVAILABLE_GADGETS', []);
          reject(error);
        });
      });
    },

    setGadgetConfig: function setGadgetConfig(_ref2, data) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/salvaConfiguracao', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    updateGadgetList: function updateGadgetList(_ref3, gadgets) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/atualizaListaGadgets', gadgets).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    cleanGadgetsFilters: function cleanGadgetsFilters(_ref4) {
      var commit = _ref4.commit;

      commit('CLEAN_GADGETS_FILTERS');
    },

    setDashboardDateFilter: function setDashboardDateFilter(_ref5, period) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_PERIOD_DASHBOARD', period);
        commit('SET_PERIOD_SELECTED_FILTER_BANK_BALANCE', period);
        commit('SET_PERIOD_FILTER_BATCH_DISTRIBUTION', period);
        commit('SET_PERIOD_FILTER_FINANCIAL_SUMMARY', period);
        commit('SET_PERIOD_FILTER_CONCILIATION_SITUATION_SUMMARY', period);
        commit('SET_PERIOD_SELECTED_FILTER_DIGITAL_WALLET_BALANCE', period);
        resolve();
      });
    },

    setPlansDashboard: function setPlansDashboard(_ref6, plans) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_PLANS_FILTER_DASHBOARD', plans);
        resolve();
      });
    },

    setMainCategoriesDashboard: function setMainCategoriesDashboard(_ref7, mainCategories) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_MAIN_CATEGORIES_FILTER_DASHBOARD', mainCategories);
        resolve();
      });
    },

    getDataConciliationSituationSummary: function getDataConciliationSituationSummary(_ref8, filter) {
      var commit = _ref8.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/resumoSituacaoConciliacao', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getDataAllotmentDistributionSummary: function getDataAllotmentDistributionSummary(_ref9, filter) {
      var commit = _ref9.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/distribuicaoDeConciliacao', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getDataFinancialSummary: function getDataFinancialSummary(_ref10, filter) {
      var commit = _ref10.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/resumoFinanceiro', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getDataDailyBankStatment: function getDataDailyBankStatment(_ref11, filter) {
      var state = _ref11.state,
          commit = _ref11.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/saldoBancario', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getDataTasks: function getDataTasks(_ref12) {
      var commit = _ref12.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/tarefas').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getDataDigitalWalletBalance: function getDataDigitalWalletBalance(_ref13, filter) {
      var state = _ref13.state,
          commit = _ref13.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/dashboard/saldoCarteiraDigital', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setPlanSelectedFilterConcSitSummary: function setPlanSelectedFilterConcSitSummary(_ref14, planSelected) {
      var commit = _ref14.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_PLAN_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY', planSelected);
        resolve();
      });
    },

    setTypeFilterConcSitSummary: function setTypeFilterConcSitSummary(_ref15, type) {
      var commit = _ref15.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_TYPE_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY', type);
        resolve();
      });
    },

    setMainCategorySelectedFilterConcSitSummary: function setMainCategorySelectedFilterConcSitSummary(_ref16, mainCategorySelected) {
      var commit = _ref16.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_MAIN_CATEGORY_SELECTED_FILTER_CONCILIATION_SITUATION_SUMMARY', mainCategorySelected);
        resolve();
      });
    },

    setPlanSelectedAllotmentDistributionSummary: function setPlanSelectedAllotmentDistributionSummary(_ref17, planSelected) {
      var commit = _ref17.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_PLAN_SELECTED_FILTER_BATCH', planSelected);
        resolve();
      });
    },

    setTypeFilterBatchDistribution: function setTypeFilterBatchDistribution(_ref18, type) {
      var commit = _ref18.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_TYPE_SELECTED_FILTER_BATCH', type);
        resolve();
      });
    },

    setMainCategorySelectedAllotmentDistributionSummary: function setMainCategorySelectedAllotmentDistributionSummary(_ref19, mainCategorySelected) {
      var commit = _ref19.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_MAIN_CATEGORY_SELECTED_FILTER_BATCH', mainCategorySelected);
        resolve();
      });
    },

    setMainCategorySelectedFinancialSummary: function setMainCategorySelectedFinancialSummary(_ref20, mainCategorySelected) {
      var commit = _ref20.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_MAIN_CATEGORY_SELECTED_FILTER_FINANCIAL_SUMMARY', mainCategorySelected);
        resolve();
      });
    },

    setAccountSelectedBankBalance: function setAccountSelectedBankBalance(_ref21, accSelected) {
      var commit = _ref21.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_ACCOUNT_SELECTED_FILTER_BANK_BALANCE', accSelected);
        resolve();
      });
    },

    setCategorySelectedDigitalWalletBalance: function setCategorySelectedDigitalWalletBalance(_ref22, categorySelected) {
      var commit = _ref22.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_CATEGORY_SELECTED_FILTER_DIGITAL_WALLET_BALANCE', categorySelected);
        resolve();
      });
    },

    cancelDashboardRequests: function cancelDashboardRequests(_ref23) {
      var state = _ref23.state;

      for (var key in state.currentRequests) {
        if (state.currentRequests[key]) {
          if (typeof state.currentRequests[key].cancel === 'function') {
            state.currentRequests[key].cancel();
          }
          delete state.currentRequests[key];
        }
      }
    }
  },

  getters: {
    availableGadgets: function availableGadgets(state) {
      return state.availableGadgets;
    },
    periodDashboard: function periodDashboard(state) {
      return state.periodDashboard;
    },
    plansDashboard: function plansDashboard(state) {
      return state.plansDashboard;
    },
    mainCategoriesDashboard: function mainCategoriesDashboard(state) {
      return state.mainCategoriesDashboard;
    },

    periodFilterConcSitSummary: function periodFilterConcSitSummary(state) {
      return state.periodFilterConcSitSummary;
    },
    planSelectedFilterConcSitSummary: function planSelectedFilterConcSitSummary(state) {
      return state.planSelectedFilterConcSitSummary;
    },
    typeFilterConcSituationSummary: function typeFilterConcSituationSummary(state) {
      return state.typeFilterConcSituationSummary;
    },
    mainCategorySelectedFilterConcSitSummary: function mainCategorySelectedFilterConcSitSummary(state) {
      return state.mainCategorySelectedFilterConcSitSummary;
    },

    periodFilterAllotmentDistribution: function periodFilterAllotmentDistribution(state) {
      return state.periodFilterAllotmentDistribution;
    },
    planSelectedFilterBatch: function planSelectedFilterBatch(state) {
      return state.planSelectedFilterBatch;
    },
    typeSelectedFilterBatch: function typeSelectedFilterBatch(state) {
      return state.typeSelectedFilterBatch;
    },
    mainCategorySelectedFilterBatch: function mainCategorySelectedFilterBatch(state) {
      return state.mainCategorySelectedFilterBatch;
    },

    periodFilterFinancialSummary: function periodFilterFinancialSummary(state) {
      return state.periodFilterFinancialSummary;
    },
    mainCategorySelectedFilterFinancialSummary: function mainCategorySelectedFilterFinancialSummary(state) {
      return state.mainCategorySelectedFilterFinancialSummary;
    },

    periodFilterBankBalance: function periodFilterBankBalance(state) {
      return state.periodFilterBankBalance;
    },
    accountSelectedBankBalance: function accountSelectedBankBalance(state) {
      return state.accountSelectedBankBalance;
    },

    periodFilterDigitalWalletBalance: function periodFilterDigitalWalletBalance(state) {
      return state.periodFilterDigitalWalletBalance;
    },
    categorySelectedDigitalWalletBalance: function categorySelectedDigitalWalletBalance(state) {
      return state.categorySelectedDigitalWalletBalance;
    }
  }
};

/***/ }),
/* 766 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./client/store/modules/duplicateMovementsAnalysis.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    searchDuplicateMovements: function searchDuplicateMovements(_ref, filter) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/duplicateMovementsAnalysis/list/duplicated', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchAnnulledMovements: function searchAnnulledMovements(_ref2, filter) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/duplicateMovementsAnalysis/list/annulled', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    annulledMovements: function annulledMovements(_ref3, movements) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/duplicateMovementsAnalysis/update/annulled', movements).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 767 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/store/modules/establishment.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    establishmentToEditId: null,
    currentRequests: {},
    selectedEstablishmentsMoveEstablishment: {}
  },

  mutations: {
    CLEAN_ESTABLISHMENT_TO_EDIT: function CLEAN_ESTABLISHMENT_TO_EDIT(state) {
      state.establishmentToEditId = null;
    },
    ESTABLISHMENT_TO_EDIT_SELECTED: function ESTABLISHMENT_TO_EDIT_SELECTED(state, establishmentId) {
      state.establishmentToEditId = establishmentId;
    },
    SET_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT: function SET_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT(state, selectedEstablishmentsMoveEstablishment) {
      state.selectedEstablishmentsMoveEstablishment = {
        establishmentOrigin: selectedEstablishmentsMoveEstablishment.establishmentOrigin,
        establishmentDestiny: selectedEstablishmentsMoveEstablishment.establishmentDestiny,
        deleteEstablishmentOrigin: selectedEstablishmentsMoveEstablishment.deleteEstablishmentOrigin
      };
    },
    CLEAN_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT: function CLEAN_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT(state) {
      state.selectedEstablishmentsMoveEstablishment = {};
    }
  },

  actions: {
    newEstablishment: function newEstablishment(_ref, _newEstablishment) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/establishment/saveEstablishment', _newEstablishment).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getEstablishments: function getEstablishments(_ref2, filter) {
      var state = _ref2.state,
          commit = _ref2.commit;

      state.currentRequests.getEstablishment = _axiosCommon2.default.CancelToken.source();
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/' + filter.url, filter, {
          cancelToken: state.currentRequests.getEstablishment.token
        }).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getEstablishment: function getEstablishment(_ref3, establishmentId) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/establishment/find/' + establishmentId).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setEstablishmentToEdit: function setEstablishmentToEdit(_ref4, establishmentId) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('ESTABLISHMENT_TO_EDIT_SELECTED', establishmentId);
        resolve();
      });
    },

    cleanEstablishmentToEdit: function cleanEstablishmentToEdit(_ref5) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_ESTABLISHMENT_TO_EDIT');
        resolve();
      });
    },

    setSelectedEstablishmentsMoveEstablishment: function setSelectedEstablishmentsMoveEstablishment(_ref6, selectedEstablishmentsMoveEstablishment) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT', selectedEstablishmentsMoveEstablishment);
        resolve();
      });
    },

    cleanSelectedEstablishmentsMoveEstablishment: function cleanSelectedEstablishmentsMoveEstablishment(_ref7) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_SELECTED_ESTABLISHMENT_MOVE_ESTABLISHMENT');
        resolve();
      });
    },

    getEstablishmentGroups: function getEstablishmentGroups(_ref8) {
      var commit = _ref8.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/establishmentGroups/list').then(function (response) {
          resolve(response.data.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getEstablishmentsToTreeGrid: function getEstablishmentsToTreeGrid(_ref9, data) {
      var commit = _ref9.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/establishment/listDetails', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    loadEstablishmentAtt: function loadEstablishmentAtt(_ref10, url) {
      var commit = _ref10.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post(url).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    moveEstablishment: function moveEstablishment(_ref11, data) {
      var commit = _ref11.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/establishment/moveEstablishment', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    cancelEstablishmentsSearchRequests: function cancelEstablishmentsSearchRequests(_ref12) {
      var state = _ref12.state;

      for (var key in state.currentRequests) {
        if (state.currentRequests[key]) {
          if (typeof state.currentRequests[key].cancel === 'function') {
            state.currentRequests[key].cancel();
          }
          delete state.currentRequests[key];
        }
      }
    }
  },

  getters: {
    establishmentToEditId: function establishmentToEditId(state) {
      return state.establishmentToEditId;
    },
    selectedEstablishmentsMoveEstablishment: function selectedEstablishmentsMoveEstablishment(state) {
      return state.selectedEstablishmentsMoveEstablishment;
    }
  }
};

/***/ }),
/* 768 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./client/store/modules/exitingWithUnsavedChanges.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  state: {
    hasUnsavedChanges: false,
    popupConfirmResponse: true
  },

  mutations: {
    CHANGE_UNSAVED_CHANGES: function CHANGE_UNSAVED_CHANGES(state, flag) {
      state.hasUnsavedChanges = flag;
    },
    SET_CONFIRM_RESPONSE: function SET_CONFIRM_RESPONSE(state, popupConfirmResponse) {
      state.popupConfirmResponse = popupConfirmResponse;
    }
  },

  actions: {
    setHasUnsavedChanges: function setHasUnsavedChanges(_ref, flag) {
      var commit = _ref.commit;

      commit('CHANGE_UNSAVED_CHANGES', flag);
    },
    setConfirmResponse: function setConfirmResponse(_ref2, popupConfirmResponse) {
      var commit = _ref2.commit;

      commit('SET_CONFIRM_RESPONSE', popupConfirmResponse);
    }
  },

  getters: {
    hasUnsavedChanges: function hasUnsavedChanges(state) {
      return state.hasUnsavedChanges;
    },
    popupConfirmResponse: function popupConfirmResponse(state) {
      return state.popupConfirmResponse;
    }
  }
};

/***/ }),
/* 769 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./client/store/modules/fileUploader.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    getSentFiles: function getSentFiles(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/banking/accessProfile/').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    uploadFile: function uploadFile(_ref2, data) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/uploadFile', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getFileLayout: function getFileLayout(_ref3, data) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/uploadFile/layout', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 770 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./client/store/modules/filter.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    idsFilterEstablishments: []
  },

  mutations: {
    CLEAR_IDS_FILTER_ESTABLISHMENT: function CLEAR_IDS_FILTER_ESTABLISHMENT(state) {
      state.idsFilterEstablishments = [];
    },
    SET_IDS_FILTER_ESTABLISHMENT: function SET_IDS_FILTER_ESTABLISHMENT(state, establishmentsIds) {
      state.idsFilterEstablishments = establishmentsIds;
    },
    PUSH_ID_FILTER_ESTABLISHMENT: function PUSH_ID_FILTER_ESTABLISHMENT(state, establishmentsId) {
      state.idsFilterEstablishments.push(establishmentsId);
    }
  },

  actions: {
    setEstablishmentFilter: function setEstablishmentFilter(_ref, establishmentsIds) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_IDS_FILTER_ESTABLISHMENT', establishmentsIds);
        resolve();
      });
    },

    addEstablishmentFilter: function addEstablishmentFilter(_ref2, establishmentsId) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('PUSH_ID_FILTER_ESTABLISHMENT', establishmentsId);
        resolve();
      });
    },

    clearEstablishmentFilter: function clearEstablishmentFilter(_ref3) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAR_IDS_FILTER_ESTABLISHMENT');
        resolve();
      });
    }
  },

  getters: {
    idsFilterEstablishments: function idsFilterEstablishments(state) {
      return state.idsFilterEstablishments;
    }
  }
};

/***/ }),
/* 771 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./client/store/modules/financialMovements.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _generateDateTime = __webpack_require__(/*! ../../utils/generateDateTime */ 202);

var _generateDateTime2 = _interopRequireDefault(_generateDateTime);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    searchFinancialMovements: function searchFinancialMovements(_ref, data) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/financialMovements/search', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getFinancialMovByIdTask: function getFinancialMovByIdTask(_ref2, obj) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(obj.url, { params: { idTarefa: obj.idTask } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getFinancialMovementById: function getFinancialMovementById(_ref3, obj) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(obj.url, { params: { idMovimentacaoFinanceira: obj.id } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getHistoricFinancialMovement: function getHistoricFinancialMovement(_ref4, data) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(data.url, { params: { idMovimentacaoFinanceira: data.idFinancialMovement } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getAllotmentByMovementId: function getAllotmentByMovementId(_ref5, data) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(data.url, { params: { idMovimento: data.idFinancialMovement } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchFinancialMovementsToFile: function searchFinancialMovementsToFile(_ref6, filter) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/financialMovements/searchFinancialMovementsToFile', filter, { responseType: 'blob' }).then(function (response) {
          var datetime = (0, _generateDateTime2.default)();
          var blob = new Blob([response.data]);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', _vue2.default.i18n.translate('downloads.labels.movimentacaoFinanceira') + datetime + '.csv');
          document.body.appendChild(link);
          link.click();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 772 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./client/store/modules/loading.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  state: {
    isLoadingData: false,
    isLoadingStatic: false
  },

  mutations: {
    LOADING: function LOADING(state) {
      state.isLoadingData = true;
    },
    LOADINGSTATIC: function LOADINGSTATIC(state) {
      state.isLoadingData = true;
      state.isLoadingStatic = true;
    },
    LOADED: function LOADED(state) {
      state.isLoadingData = false;
      state.isLoadingStatic = false;
    }
  },

  actions: {
    loadingData: function loadingData(_ref) {
      var commit = _ref.commit;

      commit('LOADING');
    },

    loadingDataStatic: function loadingDataStatic(_ref2) {
      var commit = _ref2.commit;

      commit('LOADINGSTATIC');
    },

    dataLoaded: function dataLoaded(_ref3) {
      var commit = _ref3.commit;

      commit('LOADED');
    }
  },

  getters: {
    isLoadingData: function isLoadingData(state) {
      return state.isLoadingData;
    },
    isLoadingStatic: function isLoadingStatic(state) {
      return state.isLoadingStatic;
    }
  }
};

/***/ }),
/* 773 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./client/store/modules/loadingFullPage.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  state: {
    isLoadingFullPage: false,
    loadingFullPageMessages: [],
    intervalBetweenMessages: 2500
  },

  mutations: {
    LOADING_FULL_PAGE: function LOADING_FULL_PAGE(state, _ref) {
      var messages = _ref.messages,
          interval = _ref.interval;

      state.isLoadingFullPage = true;
      state.loadingFullPageMessages = messages;
      state.intervalBetweenMessages = interval;
    },
    FULL_PAGE_LOADED: function FULL_PAGE_LOADED(state) {
      state.isLoadingFullPage = false;
      state.loadingFullPageMessages = [];
      state.intervalBetweenMessages = 2500;
    }
  },

  actions: {
    loadingFullPage: function loadingFullPage(_ref2, _ref3) {
      var commit = _ref2.commit;
      var messages = _ref3.messages,
          _ref3$interval = _ref3.interval,
          interval = _ref3$interval === undefined ? 2500 : _ref3$interval;

      commit('LOADING_FULL_PAGE', { messages: messages, interval: interval });
    },

    fullPageLoaded: function fullPageLoaded(_ref4) {
      var commit = _ref4.commit;

      commit('FULL_PAGE_LOADED');
    }
  },

  getters: {
    isLoadingFullPage: function isLoadingFullPage(state) {
      return state.isLoadingFullPage;
    },
    loadingFullPageMessages: function loadingFullPageMessages(state) {
      return state.loadingFullPageMessages;
    },
    intervalBetweenMessages: function intervalBetweenMessages(state) {
      return state.intervalBetweenMessages;
    }
  }
};

/***/ }),
/* 774 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./client/store/modules/login.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(/*! babel-runtime/core-js/object/keys */ 321);

var _keys2 = _interopRequireDefault(_keys);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _vuexModules = __webpack_require__(/*! ../vuex-modules */ 317);

var _vuexModules2 = _interopRequireDefault(_vuexModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    user: null,
    userEmail: null,
    userId: null
  },

  mutations: {
    LOGIN: function LOGIN(state) {
      state.pending = true;
      state.selectedMenuItem = null;
    },
    LOGIN_SUCCESS: function LOGIN_SUCCESS(state, user) {
      state.isLoggedIn = true;
      state.pending = false;
      state.user = user.name;
      state.userEmail = user.email;
      state.userId = user.idUsuario;
    },
    LOGOUT: function LOGOUT(state) {
      state.isLoggedIn = false;
      state.client = null;
      state.clientApps = [];
      state.profileToEditId = null;
      state.clientName = null;
      state.selectedMenuItem = null;
    },
    UPDATE_USER_NAME: function UPDATE_USER_NAME(state, username) {
      state.user = username;
    },
    CLEAN_MODULES: function CLEAN_MODULES() {
      var self = this;
      (0, _keys2.default)(_vuexModules2.default).forEach(function (value, index) {
        if (self.state[value]) {
          self.state[value] = _vuexModules2.default[value];
        }
      });
    }
  },

  actions: {
    cleanVuexModules: function cleanVuexModules(_ref) {
      var commit = _ref.commit;

      commit('CLEAN_MODULES');
    },

    login: function login(_ref2, credentials) {
      var commit = _ref2.commit;

      commit('CLEAN_MODULES');
      commit('LOGIN');
      localStorage.setItem('event-login-start', Math.random());
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/login', { username: credentials.username, password: credentials.password, recaptcha: credentials.recaptcha }).then(function (response) {
          var token = response.headers['x-access-token'];
          var user = {
            name: response && response.data && response.data.data && response.data.data.nome ? response.data.data.nome : '',
            email: response && response.data && response.data.data && response.data.data.email ? response.data.data.email : '',
            idUsuario: response && response.data && response.data.data && response.data.data.idUsuario ? response.data.data.idUsuario : ''
          };
          localStorage.setItem('token', token);
          commit('LOGIN_SUCCESS', user);
          resolve();
        }).catch(function (error) {
          commit('LOGOUT');
          reject(error);
        });
      });
    },

    logout: function logout(_ref3) {
      var commit = _ref3.commit;

      localStorage.removeItem('token');
      commit('LOGOUT');
      commit('CLEAN_MODULES');
      var response = _axiosCommon2.default.get('/user/logout');
      localStorage.setItem('event-logout', Math.random());
      return response;
    },

    recoverPassword: function recoverPassword(_ref4, recoverPasswordData) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/recoveryPassword', { data: recoverPasswordData }).then(function () {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    registerPassword: function registerPassword(_ref5, credentials) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/newPassword', {
          username: credentials.username,
          password: credentials.password,
          confirmPassword: credentials.confirmPassword,
          key: credentials.key
        }).then(function () {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    registerRecoverPassword: function registerRecoverPassword(_ref6, credentials) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/changePassword', {
          username: credentials.username,
          password: credentials.password,
          confirmPassword: credentials.confirmPassword,
          key: credentials.key
        }).then(function () {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    loginEmulado: function loginEmulado(_ref7, data) {
      var commit = _ref7.commit;

      commit('CLEAN_MODULES');
      commit('LOGIN');
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/loginEmulado', { token: data.token, lang: data.idioma }).then(function (response) {
          var token = response.headers['x-access-token'];
          var user = {
            name: response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.nome : '',
            email: response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.email : ''
          };
          localStorage.setItem('token', token);
          commit('LOGIN_SUCCESS', user);
          resolve(response.data.data);
        }).catch(function (error) {
          commit('LOGOUT');
          reject(error);
        });
      });
    },

    loginTrocaAplicacao: function loginTrocaAplicacao(_ref8, data) {
      var commit = _ref8.commit;

      commit('CLEAN_MODULES');
      commit('LOGIN');
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/changeApplication', { token: data.token, lang: data.idioma }).then(function (response) {
          var token = response.headers['x-access-token'];
          var user = {
            name: response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.nome : '',
            email: response && response.data && response.data.data && response.data.data.usuario ? response.data.data.usuario.email : ''
          };
          localStorage.setItem('token', token);
          commit('LOGIN_SUCCESS', user);
          resolve(response.data.data);
        }).catch(function (error) {
          commit('LOGOUT');
          reject(error);
        });
      });
    },

    tentativas: function tentativas() {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/user/login/tentativas').then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    cleanSession: function cleanSession(_ref9) {
      var commit = _ref9.commit;

      commit('LOGOUT');
    }
  },

  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return state.isLoggedIn;
    },
    user: function user(state) {
      return state.user;
    },
    userEmail: function userEmail(state) {
      return state.userEmail;
    },
    userId: function userId(state) {
      return state.userId;
    }
  }
};

/***/ }),
/* 775 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./client/store/modules/manualConciliation.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _index = __webpack_require__(/*! ../index */ 105);

var _index2 = _interopRequireDefault(_index);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeAllotment = function removeAllotment(_ref, allotmentIdsToHandle) {
  var commit = _ref.commit;

  return new _promise2.default(function (resolve, reject) {
    commit('REMOVE_ALLOTMENT', allotmentIdsToHandle);
    resolve();
  });
};

var setBankStat = function setBankStat(_ref2, row) {
  var commit = _ref2.commit;

  return new _promise2.default(function (resolve, reject) {
    commit('SET_BANK_STAT', row);
    resolve();
  });
};

var setFinMov = function setFinMov(_ref3, row) {
  var commit = _ref3.commit;

  return new _promise2.default(function (resolve, reject) {
    commit('SET_FIN_MOV', row);
    resolve();
  });
};

var setBankStatArray = function setBankStatArray(_ref4, array) {
  var commit = _ref4.commit;

  return new _promise2.default(function (resolve, reject) {
    commit('SET_BANK_STAT_ARRAY', array);
    resolve();
  });
};

var setFinMovArray = function setFinMovArray(_ref5, array) {
  var commit = _ref5.commit;

  return new _promise2.default(function (resolve, reject) {
    commit('SET_FIN_MOV_ARRAY', array);
    resolve();
  });
};

var alertConfirmation = function alertConfirmation() {
  var $t = _vue2.default.i18n.translate;
  var size = _index2.default.getters.arrayJustify ? _index2.default.getters.arrayJustify.length : 0;
  if (size > 0) {
    var confirmation = null;
    if (size > 1) {
      confirmation = window.confirm($t('conciliacaoManual.labels.alertJustificativas'));
    } else {
      confirmation = window.confirm($t('conciliacaoManual.labels.alertJustificativa'));
    }
    return confirmation;
  } else {
    return true;
  }
};

exports.default = {
  state: {
    finMovAdded: [],
    idRowMovFinRemoved: {},
    bankStatAdded: [],
    idRowBankStatRemoved: {},
    totalAmountForInternalEntries: 0.00,
    totalAmountForBankEntries: 0.00,
    idRowAllotmentMovementRemoved: null,
    idRowAllotmentMovementAdded: null,
    idAllotment: null,
    hasPendingFinMov: false,
    hasPendingBankStat: false,
    hasToUpdateMAnualConcilSearch: false,
    arrayConciliationPlan: [],
    needSearchManualConciliationTransactions: false,
    allotmentMovementRemoved: null,
    arrayJustify: [],
    reaplyConciliation: false,
    loadingMessage: 'conciliacaoManual.labels.salvandoInformacoes'
  },

  mutations: {
    SET_ARRAY_CONCILIATION_PLAN: function SET_ARRAY_CONCILIATION_PLAN(state, data) {
      state.arrayConciliationPlan = [];
      state.arrayConciliationPlan.push(data);
    },
    SET_NEED_SEARCH_MANUAL_CONCILIATION: function SET_NEED_SEARCH_MANUAL_CONCILIATION(state, flag) {
      state.hasToUpdateMAnualConcilSearch = flag;
    },
    HAS_PENDING_FIN_MOV: function HAS_PENDING_FIN_MOV(state, flag) {
      state.hasPendingFinMov = flag;
    },
    HAS_PENDING_BANK_STAT: function HAS_PENDING_BANK_STAT(state, flag) {
      state.hasPendingBankStat = flag;
    },
    HAS_TO_UPDATE_MANUAL_CONCIL_SEARCH: function HAS_TO_UPDATE_MANUAL_CONCIL_SEARCH(state, flag) {
      state.hasToUpdateMAnualConcilSearch = flag;
    },
    SET_FIN_MOV: function SET_FIN_MOV(state, row) {
      var data = {};
      if (row.isTreeGrid) {
        data = {
          'id': row.id,
          'idMovimentacao': row.IdMovimentacao,
          'dtLanc': row.DtLanc,
          'valor': row.VlLancamento,
          'situacao': row.SituacaoConciliacao
        };
      } else {
        data = row;
      }
      state.finMovAdded.push(data);
    },
    SET_FIN_MOV_ARRAY: function SET_FIN_MOV_ARRAY(state, finMovArray) {
      state.finMovAdded = state.finMovAdded.concat(finMovArray);
    },
    REMOVE_FIN_MOV: function REMOVE_FIN_MOV(state, row) {
      state.finMovAdded = _underscore2.default.without(state.finMovAdded, _underscore2.default.findWhere(state.finMovAdded, { id: row.id }));
      if (row && row.id) {
        state.idRowMovFinRemoved = {
          id: row.id,
          idMovimentacao: row.idMovimentacao
        };
      }
      state.allotmentMovementRemoved = row && row.idLote ? row.idLote : state.allotmentMovementRemoved;
    },
    SET_BANK_STAT: function SET_BANK_STAT(state, row) {
      var data = {};
      if (row.isTreeGrid) {
        data = {
          'id': row.id,
          'idLancamento': row.IdLancamento,
          'idMovBank': row.IdMovimentoBancario,
          'dtLanc': row.DtLanc,
          'valor': row.VlLancamento,
          'situacao': row.SituacaoConciliacao,
          'isTreeGrid': true
        };
      } else {
        data = row;
      }
      state.bankStatAdded.push(data);
    },
    SET_BANK_STAT_ARRAY: function SET_BANK_STAT_ARRAY(state, bankStatArray) {
      state.bankStatAdded = state.bankStatAdded.concat(bankStatArray);
    },
    REMOVE_BANK_STAT: function REMOVE_BANK_STAT(state, row) {
      state.bankStatAdded = _underscore2.default.without(state.bankStatAdded, _underscore2.default.findWhere(state.bankStatAdded, { id: row.id }));
      if (row && row.id) {
        state.idRowBankStatRemoved = {
          id: row.id,
          idLancamento: row.idLancamento
        };
      }
      state.allotmentMovementRemoved = row && row.idLote ? row.idLote : state.allotmentMovementRemoved;
    },
    REMOVE_ALL_BANK: function REMOVE_ALL_BANK(state, list) {
      list.forEach(function (row) {
        state.bankStatAdded = _underscore2.default.without(state.bankStatAdded, _underscore2.default.findWhere(state.bankStatAdded, { id: row.id }));
        if (window.Grids.ConcManualExtBan) {
          var item = window.Grids.ConcManualExtBan.GetRowById(row.id);
          if (!item) {
            item = _underscore2.default.findWhere(window.Grids.ConcManualExtBan.Rows, { IdLancamento: row.idLancamento });
          }
          if (item) {
            window.Grids.ConcManualExtBan.ShowRow(item);
          }
          window.Grids.ConcManualExtBan.Reload();
        }
      });
    },
    REMOVE_ALL_MOV: function REMOVE_ALL_MOV(state, list) {
      list.forEach(function (row) {
        state.finMovAdded = _underscore2.default.without(state.finMovAdded, _underscore2.default.findWhere(state.finMovAdded, { id: row.id }));
        if (window.Grids.ConcManualMovFin) {
          var item = window.Grids.ConcManualMovFin.GetRowById(row.id);
          if (!item) {
            item = _underscore2.default.findWhere(window.Grids.ConcManualMovFin.Rows, { IdMovimentacao: row.idMovimentacao });
          }
          if (item) {
            window.Grids.ConcManualMovFin.ShowRow(item);
          }
          window.Grids.ConcManualMovFin.Reload();
        }
      });
    },
    UPDATE_TOTAL_AMOUNT_INTERNAL: function UPDATE_TOTAL_AMOUNT_INTERNAL(state, value) {
      state.totalAmountForInternalEntries = value;
    },
    UPDATE_TOTAL_AMOUNT_BANK: function UPDATE_TOTAL_AMOUNT_BANK(state, value) {
      state.totalAmountForBankEntries = value;
    },
    REMOVE_ALLOTMENT: function REMOVE_ALLOTMENT(state, allotmentIdsToHandle) {
      var idLote = {};
      if (state.bankStatAdded && state.bankStatAdded.length > 0) {
        state.bankStatAdded.forEach(function (obj) {
          if (obj.idLote) {
            if (!idLote) {
              idLote = obj.idLote;
            }
            state.bankStatAdded = _underscore2.default.without(state.bankStatAdded, _underscore2.default.findWhere(state.bankStatAdded, { idLote: obj.idLote }));
          }
        });
      }

      if (state.finMovAdded && state.finMovAdded.length > 0) {
        state.finMovAdded.forEach(function (obj) {
          if (obj.idLote) {
            if (!idLote) {
              idLote = obj.idLote;
            }
            state.finMovAdded = _underscore2.default.without(state.finMovAdded, _underscore2.default.findWhere(state.finMovAdded, { idLote: obj.idLote }));
          }
        });
      }
      state.idRowAllotmentMovementRemoved = allotmentIdsToHandle.idAllotmentRemoved;
      state.idRowAllotmentMovementAdded = allotmentIdsToHandle.idAllotmentToRemove;
      state.allotmentMovementRemoved = null;
    },
    SET_ID_ALLOTMENT: function SET_ID_ALLOTMENT(state, id) {
      state.idAllotment = id;
      state.allotmentMovementRemoved = null;
    },
    SET_JUSTIFY: function SET_JUSTIFY(state, justify) {
      state.arrayJustify.push(justify);
    },
    REMOVE_JUSTIFY: function REMOVE_JUSTIFY(state, row) {
      state.arrayJustify = _underscore2.default.without(state.arrayJustify, _underscore2.default.findWhere(state.arrayJustify, { id: row.id }));
    },
    CLEAN_ARRAY_JUSTIFY: function CLEAN_ARRAY_JUSTIFY(state) {
      state.arrayJustify = [];
    },
    SET_REAPLY_CONCILIATION: function SET_REAPLY_CONCILIATION(state, value) {
      state.reaplyConciliation = value;
    },
    SET_LOADING_MESSAGE: function SET_LOADING_MESSAGE(state, value) {
      state.loadingMessage = value;
    },
    CLEAN_EDIT_STATE: function CLEAN_EDIT_STATE(state) {
      state.planToEditId = null;
      state.profileToEditId = null;
      state.bankAccounttoEditId = null;
      state.establishmentToEditId = null;
      state.lastUrl = null;
      state.occurrenceReasonToEditId = null;
      state.finMovAdded = [];
      state.idRowMovFinRemoved = {};
      state.bankStatAdded = [];
      state.idRowBankStatRemoved = {};
      state.idRowAllotmentMovementRemoved = null;
      state.idRowAllotmentMovementAdded = null;
      state.totalAmountForInternalEntries = 0.00;
      state.totalAmountForBankEntries = 0.00;
      state.idAllotment = null;
      state.hasPendingFinMov = false;
      state.hasPendingBankStat = false;
      state.hasToUpdateMAnualConcilSearch = false;
      state.arrayConciliationPlan = [];
      state.allotmentMovementRemoved = null;
      state.arrayJustify = [];
      state.loadingMessage = 'conciliacaoManual.labels.salvandoInformacoes';
    }
  },

  actions: {
    applyConciliation: function applyConciliation(_ref6, filter) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/manualConciliation/applyConciliation', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    reopenConciliation: function reopenConciliation(_ref7, filter) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/manualConciliation/reopenConciliation', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    justifyConciliation: function justifyConciliation(_ref8, filter) {
      var commit = _ref8.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/manualConciliation/justifyConciliation', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchTransactionsForManualConciliation: function searchTransactionsForManualConciliation(_ref9, filter) {
      var commit = _ref9.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/manualConciliation/searchTransactionsForManualConciliation', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchAllotments: function searchAllotments(_ref10, filter) {
      var commit = _ref10.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/manualConciliation/searchAllotments', filter).then(function (allotments) {
          resolve(allotments.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    reaplyConciliation: function reaplyConciliation(_ref11, filter) {
      var commit = _ref11.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/manualConciliation/reaplyConciliation', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    verifyReaplyConciliation: function verifyReaplyConciliation(_ref12, filter) {
      var commit = _ref12.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/manualConciliation/verifyReaplyConciliation').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    removeFinMov: function removeFinMov(_ref13, row) {
      var commit = _ref13.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('REMOVE_FIN_MOV', row);
        resolve();
      });
    },

    removeBankStat: function removeBankStat(_ref14, row) {
      var commit = _ref14.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('REMOVE_BANK_STAT', row);
        resolve();
      });
    },

    removeAllBankStat: function removeAllBankStat(_ref15, list) {
      var commit = _ref15.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('REMOVE_ALL_BANK', list);
        resolve();
      });
    },

    removeAllMovFin: function removeAllMovFin(_ref16, list) {
      var commit = _ref16.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('REMOVE_ALL_MOV', list);
        resolve();
      });
    },

    recoverAllotmentMov: function recoverAllotmentMov(_ref17, idLote) {
      var commit = _ref17.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/manualConciliation/listAllotmentMov', { params: { allotmentId: idLote } }).then(function (allotments) {
          resolve(allotments.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getAllotmentMov: function getAllotmentMov(_ref18, data) {
      var commit = _ref18.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/manualConciliation/listAllotmentMov', { params: { allotmentId: data.row.IdLote } }).then(function (response) {
          var allotmentData = {
            'idAllotmentToRemove': data.row.id,
            'idAllotmentRemoved': data.idAllotmentRemoved
          };
          removeAllotment({ commit: commit }, allotmentData);
          if (response.data.bankMovements && response.data.bankMovements.length > 0) {
            setBankStatArray({ commit: commit }, response.data.bankMovements);
          }
          if (response.data.financialMovements && response.data.financialMovements.length > 0) {
            setFinMovArray({ commit: commit }, response.data.financialMovements);
          }
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setIdAllotment: function setIdAllotment(_ref19, id) {
      var commit = _ref19.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_ID_ALLOTMENT', id);
        resolve();
      });
    },

    updateTotalAmountForInternalEntries: function updateTotalAmountForInternalEntries(_ref20, value) {
      var commit = _ref20.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('UPDATE_TOTAL_AMOUNT_INTERNAL', value);
        resolve();
      });
    },

    updateTotalAmountForBankEntries: function updateTotalAmountForBankEntries(_ref21, value) {
      var commit = _ref21.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('UPDATE_TOTAL_AMOUNT_BANK', value);
        resolve();
      });
    },

    hasPendingFinMov: function hasPendingFinMov(_ref22, flag) {
      var commit = _ref22.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('HAS_PENDING_FIN_MOV', flag);
        resolve();
      });
    },

    hasPendingBankStat: function hasPendingBankStat(_ref23, flag) {
      var commit = _ref23.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('HAS_PENDING_BANK_STAT', flag);
        resolve();
      });
    },

    hasToUpdateMAnualConcilSearch: function hasToUpdateMAnualConcilSearch(_ref24, flag) {
      var commit = _ref24.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('HAS_TO_UPDATE_MANUAL_CONCIL_SEARCH', flag);
        resolve();
      });
    },

    setArrayConciliationPlan: function setArrayConciliationPlan(_ref25, data) {
      var commit = _ref25.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_ARRAY_CONCILIATION_PLAN', data);
        resolve();
      });
    },

    setNeedSearchManualConciliationTransactions: function setNeedSearchManualConciliationTransactions(_ref26, flag) {
      var commit = _ref26.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_NEED_SEARCH_MANUAL_CONCILIATION', flag);
        resolve();
      });
    },

    cleanEditState: function cleanEditState(_ref27) {
      var commit = _ref27.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_EDIT_STATE');
        resolve();
      });
    },

    setJustify: function setJustify(_ref28, justify) {
      var commit = _ref28.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_JUSTIFY', justify);
        resolve();
      });
    },

    removeJustify: function removeJustify(_ref29, row) {
      var commit = _ref29.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('REMOVE_JUSTIFY', row);
        resolve();
      });
    },

    cleanArrayJustify: function cleanArrayJustify(_ref30) {
      var commit = _ref30.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_ARRAY_JUSTIFY');
        resolve();
      });
    },

    alertUser: function alertUser(_ref31) {
      var commit = _ref31.commit;

      return new _promise2.default(function (resolve, reject) {
        var confirmation = alertConfirmation();
        if (confirmation) {
          resolve();
        } else {
          reject();
        }
      });
    },

    setReaplyConciliation: function setReaplyConciliation(_ref32, flag) {
      var commit = _ref32.commit;

      return new _promise2.default(function (resolve) {
        commit('SET_REAPLY_CONCILIATION', flag);
        resolve();
      });
    },

    setLoadingMessage: function setLoadingMessage(_ref33, msg) {
      var commit = _ref33.commit;

      return new _promise2.default(function (resolve) {
        commit('SET_LOADING_MESSAGE', msg);
        resolve();
      });
    },

    setFinMov: setFinMov,
    setBankStat: setBankStat,
    setFinMovArray: setFinMovArray,
    setBankStatArray: setBankStatArray,
    removeAllotment: removeAllotment,
    alertConfirmation: alertConfirmation
  },

  getters: {
    hasToUpdateMAnualConcilSearch: function hasToUpdateMAnualConcilSearch(state) {
      return state.hasToUpdateMAnualConcilSearch;
    },
    finMovAdded: function finMovAdded(state) {
      return state.finMovAdded;
    },
    idRowMovFinRemoved: function idRowMovFinRemoved(state) {
      return state.idRowMovFinRemoved;
    },
    bankStatAdded: function bankStatAdded(state) {
      return state.bankStatAdded;
    },
    idRowBankStatRemoved: function idRowBankStatRemoved(state) {
      return state.idRowBankStatRemoved;
    },
    totalAmountForInternalEntries: function totalAmountForInternalEntries(state) {
      return state.totalAmountForInternalEntries;
    },
    totalAmountForBankEntries: function totalAmountForBankEntries(state) {
      return state.totalAmountForBankEntries;
    },
    idRowAllotmentMovementRemoved: function idRowAllotmentMovementRemoved(state) {
      return state.idRowAllotmentMovementRemoved;
    },
    idRowAllotmentMovementAdded: function idRowAllotmentMovementAdded(state) {
      return state.idRowAllotmentMovementAdded;
    },
    idAllotment: function idAllotment(state) {
      return state.idAllotment;
    },
    hasPendingFinMov: function hasPendingFinMov(state) {
      return state.hasPendingFinMov;
    },
    hasPendingBankStat: function hasPendingBankStat(state) {
      return state.hasPendingBankStat;
    },
    arrayConciliationPlan: function arrayConciliationPlan(state) {
      return state.arrayConciliationPlan;
    },
    needSearchManualConciliationTransactions: function needSearchManualConciliationTransactions(state) {
      return state.needSearchManualConciliationTransactions;
    },
    allotmentMovementRemoved: function allotmentMovementRemoved(state) {
      return state.allotmentMovementRemoved;
    },
    arrayJustify: function arrayJustify(state) {
      return state.arrayJustify;
    },
    isReaplyConciliation: function isReaplyConciliation(state) {
      return state.reaplyConciliation;
    },
    loadingMessage: function loadingMessage(state) {
      return state.loadingMessage;
    }
  }
};

/***/ }),
/* 776 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./client/store/modules/menu.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  state: {
    expandedMenu: null
  },

  mutations: {
    MENU_STATE: function MENU_STATE(state, flag) {
      state.expandedMenu = flag;
    }
  },

  actions: {
    setMenuState: function setMenuState(_ref, flag) {
      var commit = _ref.commit;

      commit('MENU_STATE', flag);
    }
  },

  getters: {
    expandedMenu: function expandedMenu(state) {
      return state.expandedMenu;
    }
  }
};

/***/ }),
/* 777 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./client/store/modules/myAccount.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    updateAccount: function updateAccount(_ref, userData) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/updateAccount', userData).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    updateUserName: function updateUserName(_ref2, username) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('UPDATE_USER_NAME', username);
        resolve();
      });
    }
  },

  getters: {}
};

/***/ }),
/* 778 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/store/modules/occurrenceReason.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    occurrenceReasonToEditId: null
  },

  mutations: {
    CLEAN_OCCURRENCE_REASON_TO_EDIT: function CLEAN_OCCURRENCE_REASON_TO_EDIT(state) {
      state.occurrenceReasonToEditId = null;
    },
    OCCURRENCE_REASON_TO_EDIT_SELECTED: function OCCURRENCE_REASON_TO_EDIT_SELECTED(state, occurrenceReasonToEditId) {
      state.occurrenceReasonToEditId = occurrenceReasonToEditId;
    }
  },

  actions: {
    saveOccurrenceReason: function saveOccurrenceReason(_ref, data) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/occurrenceReason/saveOccurrenceReason', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getOccurrenceReasons: function getOccurrenceReasons(_ref2, url) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(url).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getOccurrenceReason: function getOccurrenceReason(_ref3, occurrenceReasonId) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/occurrenceReason/find', { params: { occurrenceReasonId: occurrenceReasonId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setOccurrenceReasonToEdit: function setOccurrenceReasonToEdit(_ref4, occurrenceReasonId) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('OCCURRENCE_REASON_TO_EDIT_SELECTED', occurrenceReasonId);
        resolve();
      });
    },

    cleanOccurrenceReasonToEdit: function cleanOccurrenceReasonToEdit(_ref5) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_OCCURRENCE_REASON_TO_EDIT');
        resolve();
      });
    },

    removeOccurrenceReason: function removeOccurrenceReason(_ref6, occurrenceReasonId) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.delete('/occurrenceReason/removeOccurrenceReason', { params: { occurrenceReasonId: occurrenceReasonId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {
    occurrenceReasonToEditId: function occurrenceReasonToEditId(state) {
      return state.occurrenceReasonToEditId;
    }
  }
};

/***/ }),
/* 779 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/store/modules/occurrenceReport.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    searchOccurrenceReport: function searchOccurrenceReport(_ref, filter) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/occurrenceReport/searchOccurrenceReport', filter).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 780 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./client/store/modules/operator.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    operatorToEditId: null
  },

  mutations: {
    OPERATOR_TO_EDIT_SELECTED: function OPERATOR_TO_EDIT_SELECTED(state, operatorId) {
      state.operatorToEditId = operatorId;
    },
    CLEAN_OPERATOR_TO_EDIT: function CLEAN_OPERATOR_TO_EDIT(state) {
      state.operatorToEditId = null;
      state.clientName = null;
    }
  },

  actions: {
    getOperators: function getOperators(_ref, url) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(url).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getOperatorsWithTaskPermission: function getOperatorsWithTaskPermission(_ref2) {
      var commit = _ref2.commit;

      return _axiosCommon2.default.get('/operator/byFunctionality', { params: { functionalityId: 209 } }).then(function (response) {
        return _promise2.default.resolve(response.data);
      }).catch(function (error) {
        return _promise2.default.reject(error);
      });
    },

    newOperator: function newOperator(_ref3, data) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/operator/', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setOperatorToEdit: function setOperatorToEdit(_ref4, operatorId) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('OPERATOR_TO_EDIT_SELECTED', operatorId);
        resolve();
      });
    },

    cleanOperatorToEdit: function cleanOperatorToEdit(_ref5) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_OPERATOR_TO_EDIT');
        resolve();
      });
    },

    getOperator: function getOperator(_ref6, operatorId) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/operator/find', { params: { operatorId: operatorId } }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {
    operatorToEditId: function operatorToEditId(state) {
      return state.operatorToEditId;
    }
  }
};

/***/ }),
/* 781 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./client/store/modules/processedFiles.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    searchFiles: function searchFiles(_ref, data) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/processedFiles/search', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getProcessedFiles: function getProcessedFiles(_ref2, data) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get(data.url, { params: { procId: data.idProcessamento } }).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 782 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/store/modules/remittanceIntegration.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  actions: {
    searchRemittanceIntegration: function searchRemittanceIntegration(_, data) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/remittanceIntegration/search', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getRemittanceTypes: function getRemittanceTypes() {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/remittanceIntegration/getRemittanceTypes').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getRemittanceDetail: function getRemittanceDetail(_, idRemittance) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/remittanceIntegration/getRemittanceDetail', {
          params: {
            idRemittance: idRemittance
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    createRemittance: function createRemittance(_, data) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/remittanceIntegration/create', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    remittanceDetail: function remittanceDetail(_, idRemittance) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/remittanceIntegration/remittanceDetail', {
          params: {
            idRemittance: idRemittance
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    validateRemittancePeriod: function validateRemittancePeriod(_, data) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/remittanceIntegration/validateRemittancePeriod', data).then(function (response) {
          resolve(response.data.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    searchRemittanceSummary: function searchRemittanceSummary(_, data) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/remittanceIntegration/searchRemittanceSummary', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    remittanceDownload: function remittanceDownload(_, idMovFinan) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/remittanceIntegration/download', {
          params: {
            idMovFinan: idMovFinan
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    removeRemittance: function removeRemittance(_, data) {
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/remittanceIntegration/removeRemittance', data).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};

/***/ }),
/* 783 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./client/store/modules/sidebarMenu.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    selectedMenuItem: null,
    funcionalities: null,
    allowedFuncionalities: null,
    isOpen: false,
    currentPath: null
  },

  mutations: {
    MENU_ITEM_SELECTED: function MENU_ITEM_SELECTED(state, menu) {
      state.selectedMenuItem = menu;
    },
    CLEAR_MENU_ITEM_SELECTED: function CLEAR_MENU_ITEM_SELECTED(state) {
      state.selectedMenuItem = null;
    },
    SAVE_ALLOWED_FUNCIONALITIES: function SAVE_ALLOWED_FUNCIONALITIES(state, funcionalities) {
      state.allowedFuncionalities = funcionalities;
    },
    CLEAN_FUNCTIONALITE_MODULE: function CLEAN_FUNCTIONALITE_MODULE(state) {
      state.allowedFuncionalities = null;
    },
    UPDATE_SIDEBAR_STATE: function UPDATE_SIDEBAR_STATE(state, value) {
      state.isOpen = value;
    },
    UPDATE_CURRENT_ROUTE: function UPDATE_CURRENT_ROUTE(state, path) {
      state.currentPath = path;
    }
  },

  actions: {
    getFuncionalities: function getFuncionalities(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/home/functionalities').then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    selectMenuItem: function selectMenuItem(_ref2, menu) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('MENU_ITEM_SELECTED', menu);
        resolve();
      });
    },

    clearSelectedMenuItem: function clearSelectedMenuItem(_ref3) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAR_MENU_ITEM_SELECTED');
        resolve();
      });
    },

    saveAllowedFuncionalities: function saveAllowedFuncionalities(_ref4, funcionalities) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SAVE_ALLOWED_FUNCIONALITIES', funcionalities);
        resolve();
      });
    },

    cleanFunctionatieModule: function cleanFunctionatieModule(_ref5) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('CLEAN_FUNCTIONALITE_MODULE');
        resolve();
      });
    },

    updateSidebarState: function updateSidebarState(_ref6, value) {
      var commit = _ref6.commit;

      commit('UPDATE_SIDEBAR_STATE', value);
    },

    currentRoute: function currentRoute(_ref7, path) {
      var commit = _ref7.commit;

      commit('UPDATE_CURRENT_ROUTE', path);
    }
  },

  getters: {
    selectedMenuItem: function selectedMenuItem(state) {
      return state.selectedMenuItem;
    },
    funcionalities: function funcionalities(state) {
      return state.funcionalities;
    },
    allowedFuncionalities: function allowedFuncionalities(state) {
      return state.allowedFuncionalities;
    },
    isOpen: function isOpen(state) {
      return state.isOpen;
    },
    currentPath: function currentPath(state) {
      return state.currentPath;
    }
  }
};

/***/ }),
/* 784 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./client/store/modules/states.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {},

  mutations: {},

  actions: {
    getStates: function getStates(_ref) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/states').then(function (response) {
          resolve(response.data.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  },

  getters: {}
};

/***/ }),
/* 785 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./client/store/modules/task.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emptyTask = {
  id: null,
  nome: '',
  tipoVinculo: '',
  descricao: '',
  situacao: null,
  dataVencimento: null,
  dataAlteracao: null,
  responsavel: null,
  conclusaoAutomatica: [],
  enviarEmail: false,
  historico: null
};

exports.default = {
  state: {
    task: (0, _assign2.default)({}, emptyTask),
    hadTasksBonded: false,
    isLoadingTaskData: false,
    isManagingTask: false,
    hasActiveTask: false
  },

  mutations: {
    SET_EMPTY_TASK: function SET_EMPTY_TASK(state) {
      state.task = (0, _assign2.default)({}, emptyTask);
    },
    SET_TASK: function SET_TASK(state, task) {
      (0, _assign2.default)(state.task, task);
    },
    SET_HAD_TASKS_BONDED: function SET_HAD_TASKS_BONDED(state, hadTasksBonded) {
      state.hadTasksBonded = hadTasksBonded;
    },
    SET_IS_LOADING_TASK_DATA: function SET_IS_LOADING_TASK_DATA(state, isLoadingTaskData) {
      state.isLoadingTaskData = isLoadingTaskData;
    },
    SET_IS_MANAGING_TASK: function SET_IS_MANAGING_TASK(state, isManagingTask) {
      state.isManagingTask = isManagingTask;
    },
    SET_HAS_ACTIVE_TASK: function SET_HAS_ACTIVE_TASK(state, hasActiveTask) {
      state.hasActiveTask = hasActiveTask;
    },
    CLEAR_FLAGS_TASKS: function CLEAR_FLAGS_TASKS(state) {
      state.hadTasksBonded = false;
      state.isLoadingTaskData = false;
      state.isManagingTask = false;
      state.hasActiveTask = false;
    }
  },

  actions: {
    createMassTask: function createMassTask(_ref, massTaskData) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/tasks/createMassTask', massTaskData).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    createNewTask: function createNewTask(_ref2, newTaskData) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/tasks/createNewTask', newTaskData).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    loadTasksFromStatement: function loadTasksFromStatement(_ref3, statmentData) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/tasks/loadTasksFromStatement', statmentData).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    loadOpenTasksFromStatementIds: function loadOpenTasksFromStatementIds(_ref4, statementIds) {
      var commit = _ref4.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/tasks/loadOpenTasksFromStatementIds', statementIds).then(function (response) {
          resolve(response.data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    saveTaskOcurrence: function saveTaskOcurrence(_ref5, taskOcur) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/tasks/saveTaskOcurrence', taskOcur).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    getTaskDetails: function getTaskDetails(_ref6, taskId) {
      var commit = _ref6.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/tasks/getTaskDetails/' + taskId).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    reopenTask: function reopenTask(_ref7, taskOcur) {
      var commit = _ref7.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/tasks/reopenTask', taskOcur).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    assignTaskToLoggedUser: function assignTaskToLoggedUser(_ref8, task) {
      var commit = _ref8.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/tasks/assignTaskToLoggedUser', task).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setEmptyTask: function setEmptyTask(_ref9) {
      var commit = _ref9.commit;

      commit('SET_EMPTY_TASK');
    },

    setTask: function setTask(_ref10, newTask) {
      var commit = _ref10.commit;

      commit('SET_TASK', newTask);
    },

    setTaskConfiguration: function setTaskConfiguration(_ref11, _ref12) {
      var commit = _ref11.commit;
      var isLoadingTask = _ref12.isLoadingTask,
          hasBondedTask = _ref12.hasBondedTask,
          managingTask = _ref12.managingTask;

      commit('SET_IS_LOADING_TASK_DATA', isLoadingTask);
      commit('SET_HAD_TASKS_BONDED', hasBondedTask);
      commit('SET_IS_MANAGING_TASK', managingTask);
    },

    setIsManagingTask: function setIsManagingTask(_ref13, isManagingTask) {
      var commit = _ref13.commit;

      commit('SET_IS_MANAGING_TASK', isManagingTask);
    },

    setHasActiveTask: function setHasActiveTask(_ref14, hasActiveTask) {
      var commit = _ref14.commit;

      commit('SET_HAS_ACTIVE_TASK', hasActiveTask);
    },

    clearFlagsTasks: function clearFlagsTasks(_ref15) {
      var commit = _ref15.commit;

      commit('CLEAR_FLAGS_TASKS');
    }
  },

  getters: {
    task: function task(state) {
      return state.task;
    },
    hadTasksBonded: function hadTasksBonded(state) {
      return state.hadTasksBonded;
    },
    isLoadingTaskData: function isLoadingTaskData(state) {
      return state.isLoadingTaskData;
    },
    isManagingTask: function isManagingTask(state) {
      return state.isManagingTask;
    },
    hasActiveTask: function hasActiveTask(state) {
      return state.hasActiveTask;
    }
  }
};

/***/ }),
/* 786 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./client/store/modules/token.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../build/http-requests/axios-common */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  state: {
    lastUrl: null,
    updateLocation: false,
    lastRequestDate: new Date()
  },

  mutations: {
    SET_LAST_URL: function SET_LAST_URL(state, url) {
      state.lastUrl = url;
    },
    SET_UPDATE_LOCATION: function SET_UPDATE_LOCATION(state, flag) {
      state.updateLocation = flag;
    },
    SET_LAST_REQUEST_DATE: function SET_LAST_REQUEST_DATE(state) {
      state.lastRequestDate = new Date();
    }
  },

  actions: {
    verifyTokenAndAuthorization: function verifyTokenAndAuthorization(_ref, data) {
      var commit = _ref.commit;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/user/verifyTokenAndAuthorization', { url: data }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },

    setLastUrl: function setLastUrl(_ref2, url) {
      var commit = _ref2.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_LAST_URL', url);
        resolve();
      });
    },

    setUpdateLocation: function setUpdateLocation(_ref3, flag) {
      var commit = _ref3.commit;

      return new _promise2.default(function (resolve, reject) {
        commit('SET_UPDATE_LOCATION', flag);
        resolve();
      });
    },

    renewToken: function renewToken(_ref4) {
      var commit = _ref4.commit;

      return _axiosCommon2.default.get('/user/renewToken');
    },

    setLastRequestDate: function setLastRequestDate(_ref5) {
      var commit = _ref5.commit;

      commit('SET_LAST_REQUEST_DATE');
    }

  },

  getters: {
    lastUrl: function lastUrl(state) {
      return state.lastUrl;
    },
    updateLocation: function updateLocation(state) {
      return state.updateLocation;
    },
    lastRequestDate: function lastRequestDate(state) {
      return state.lastRequestDate;
    }
  }
};

/***/ }),
/* 787 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./client/store/state.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  count: 0
};

exports.default = state;

/***/ }),
/* 788 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************!*\
  !*** ./client/template/assets/plugins/jquery-scrollbar/jquery.scrollbar.min.js ***!
  \*********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!function (l, e) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! jquery */ 16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : e(l.jQuery);
}(undefined, function (l) {
  "use strict";
  function e(e) {
    if (t.webkit && !e) return { height: 0, width: 0 };if (!t.data.outer) {
      var o = { border: "none", "box-sizing": "content-box", height: "200px", margin: "0", padding: "0", width: "200px" };t.data.inner = l("<div>").css(l.extend({}, o)), t.data.outer = l("<div>").css(l.extend({ left: "-1000px", overflow: "scroll", position: "absolute", top: "-1000px" }, o)).append(t.data.inner).appendTo("body");
    }return t.data.outer.scrollLeft(1e3).scrollTop(1e3), { height: Math.ceil(t.data.outer.offset().top - t.data.inner.offset().top || 0), width: Math.ceil(t.data.outer.offset().left - t.data.inner.offset().left || 0) };
  }function o() {
    var l = e(!0);return !(l.height || l.width);
  }function s(l) {
    var e = l.originalEvent;return e.axis && e.axis === e.HORIZONTAL_AXIS ? !1 : e.wheelDeltaX ? !1 : !0;
  }var r = !1,
      t = { data: { index: 0, name: "scrollbar" }, macosx: /mac/i.test(navigator.platform), mobile: /android|webos|iphone|ipad|ipod|blackberry/i.test(navigator.userAgent), overlay: null, scroll: null, scrolls: [], webkit: /webkit/i.test(navigator.userAgent) && !/edge\/\d+/i.test(navigator.userAgent) };t.scrolls.add = function (l) {
    this.remove(l).push(l);
  }, t.scrolls.remove = function (e) {
    for (; l.inArray(e, this) >= 0;) {
      this.splice(l.inArray(e, this), 1);
    }return this;
  };var i = { autoScrollSize: !0, autoUpdate: !0, debug: !1, disableBodyScroll: !1, duration: 200, ignoreMobile: !1, ignoreOverlay: !1, scrollStep: 30, showArrows: !1, stepScrolling: !0, scrollx: null, scrolly: null, onDestroy: null, onInit: null, onScroll: null, onUpdate: null },
      n = function n(s) {
    t.scroll || (t.overlay = o(), t.scroll = e(), a(), l(window).resize(function () {
      var l = !1;if (t.scroll && (t.scroll.height || t.scroll.width)) {
        var o = e();(o.height !== t.scroll.height || o.width !== t.scroll.width) && (t.scroll = o, l = !0);
      }a(l);
    })), this.container = s, this.namespace = ".scrollbar_" + t.data.index++, this.options = l.extend({}, i, window.jQueryScrollbarOptions || {}), this.scrollTo = null, this.scrollx = {}, this.scrolly = {}, s.data(t.data.name, this), t.scrolls.add(this);
  };n.prototype = { destroy: function destroy() {
      if (this.wrapper) {
        this.container.removeData(t.data.name), t.scrolls.remove(this);var e = this.container.scrollLeft(),
            o = this.container.scrollTop();this.container.insertBefore(this.wrapper).css({ height: "", margin: "", "max-height": "" }).removeClass("scroll-content scroll-scrollx_visible scroll-scrolly_visible").off(this.namespace).scrollLeft(e).scrollTop(o), this.scrollx.scroll.removeClass("scroll-scrollx_visible").find("div").andSelf().off(this.namespace), this.scrolly.scroll.removeClass("scroll-scrolly_visible").find("div").andSelf().off(this.namespace), this.wrapper.remove(), l(document).add("body").off(this.namespace), l.isFunction(this.options.onDestroy) && this.options.onDestroy.apply(this, [this.container]);
      }
    }, init: function init(e) {
      var o = this,
          r = this.container,
          i = this.containerWrapper || r,
          n = this.namespace,
          c = l.extend(this.options, e || {}),
          a = { x: this.scrollx, y: this.scrolly },
          d = this.wrapper,
          h = { scrollLeft: r.scrollLeft(), scrollTop: r.scrollTop() };if (t.mobile && c.ignoreMobile || t.overlay && c.ignoreOverlay || t.macosx && !t.webkit) return !1;if (d) i.css({ height: "auto", "margin-bottom": -1 * t.scroll.height + "px", "margin-right": -1 * t.scroll.width + "px", "max-height": "" });else {
        if (this.wrapper = d = l("<div>").addClass("scroll-wrapper").addClass(r.attr("class")).css("position", "absolute" == r.css("position") ? "absolute" : "relative").insertBefore(r).append(r), r.is("textarea") && (this.containerWrapper = i = l("<div>").insertBefore(r).append(r), d.addClass("scroll-textarea")), i.addClass("scroll-content").css({ height: "auto", "margin-bottom": -1 * t.scroll.height + "px", "margin-right": -1 * t.scroll.width + "px", "max-height": "" }), r.on("scroll" + n, function () {
          l.isFunction(c.onScroll) && c.onScroll.call(o, { maxScroll: a.y.maxScrollOffset, scroll: r.scrollTop(), size: a.y.size, visible: a.y.visible }, { maxScroll: a.x.maxScrollOffset, scroll: r.scrollLeft(), size: a.x.size, visible: a.x.visible }), a.x.isVisible && a.x.scroll.bar.css("left", r.scrollLeft() * a.x.kx + "px"), a.y.isVisible && a.y.scroll.bar.css("top", r.scrollTop() * a.y.kx + "px");
        }), d.on("scroll" + n, function () {
          d.scrollTop(0).scrollLeft(0);
        }), c.disableBodyScroll) {
          var p = function p(l) {
            s(l) ? a.y.isVisible && a.y.mousewheel(l) : a.x.isVisible && a.x.mousewheel(l);
          };d.on("MozMousePixelScroll" + n, p), d.on("mousewheel" + n, p), t.mobile && d.on("touchstart" + n, function (e) {
            var o = e.originalEvent.touches && e.originalEvent.touches[0] || e,
                s = { pageX: o.pageX, pageY: o.pageY },
                t = { left: r.scrollLeft(), top: r.scrollTop() };l(document).on("touchmove" + n, function (l) {
              var e = l.originalEvent.targetTouches && l.originalEvent.targetTouches[0] || l;r.scrollLeft(t.left + s.pageX - e.pageX), r.scrollTop(t.top + s.pageY - e.pageY), l.preventDefault();
            }), l(document).on("touchend" + n, function () {
              l(document).off(n);
            });
          });
        }l.isFunction(c.onInit) && c.onInit.apply(this, [r]);
      }l.each(a, function (e, t) {
        var i = null,
            d = 1,
            h = "x" === e ? "scrollLeft" : "scrollTop",
            p = c.scrollStep,
            u = function u() {
          var l = r[h]();r[h](l + p), 1 == d && l + p >= f && (l = r[h]()), -1 == d && f >= l + p && (l = r[h]()), r[h]() == l && i && i();
        },
            f = 0;t.scroll || (t.scroll = o._getScroll(c["scroll" + e]).addClass("scroll-" + e), c.showArrows && t.scroll.addClass("scroll-element_arrows_visible"), t.mousewheel = function (l) {
          if (!t.isVisible || "x" === e && s(l)) return !0;if ("y" === e && !s(l)) return a.x.mousewheel(l), !0;var i = -1 * l.originalEvent.wheelDelta || l.originalEvent.detail,
              n = t.size - t.visible - t.offset;return (i > 0 && n > f || 0 > i && f > 0) && (f += i, 0 > f && (f = 0), f > n && (f = n), o.scrollTo = o.scrollTo || {}, o.scrollTo[h] = f, setTimeout(function () {
            o.scrollTo && (r.stop().animate(o.scrollTo, 240, "linear", function () {
              f = r[h]();
            }), o.scrollTo = null);
          }, 1)), l.preventDefault(), !1;
        }, t.scroll.on("MozMousePixelScroll" + n, t.mousewheel).on("mousewheel" + n, t.mousewheel).on("mouseenter" + n, function () {
          f = r[h]();
        }), t.scroll.find(".scroll-arrow, .scroll-element_track").on("mousedown" + n, function (s) {
          if (1 != s.which) return !0;d = 1;var n = { eventOffset: s["x" === e ? "pageX" : "pageY"], maxScrollValue: t.size - t.visible - t.offset, scrollbarOffset: t.scroll.bar.offset()["x" === e ? "left" : "top"], scrollbarSize: t.scroll.bar["x" === e ? "outerWidth" : "outerHeight"]() },
              a = 0,
              v = 0;return l(this).hasClass("scroll-arrow") ? (d = l(this).hasClass("scroll-arrow_more") ? 1 : -1, p = c.scrollStep * d, f = d > 0 ? n.maxScrollValue : 0) : (d = n.eventOffset > n.scrollbarOffset + n.scrollbarSize ? 1 : n.eventOffset < n.scrollbarOffset ? -1 : 0, p = Math.round(.75 * t.visible) * d, f = n.eventOffset - n.scrollbarOffset - (c.stepScrolling ? 1 == d ? n.scrollbarSize : 0 : Math.round(n.scrollbarSize / 2)), f = r[h]() + f / t.kx), o.scrollTo = o.scrollTo || {}, o.scrollTo[h] = c.stepScrolling ? r[h]() + p : f, c.stepScrolling && (i = function i() {
            f = r[h](), clearInterval(v), clearTimeout(a), a = 0, v = 0;
          }, a = setTimeout(function () {
            v = setInterval(u, 40);
          }, c.duration + 100)), setTimeout(function () {
            o.scrollTo && (r.animate(o.scrollTo, c.duration), o.scrollTo = null);
          }, 1), o._handleMouseDown(i, s);
        }), t.scroll.bar.on("mousedown" + n, function (s) {
          if (1 != s.which) return !0;var i = s["x" === e ? "pageX" : "pageY"],
              c = r[h]();return t.scroll.addClass("scroll-draggable"), l(document).on("mousemove" + n, function (l) {
            var o = parseInt((l["x" === e ? "pageX" : "pageY"] - i) / t.kx, 10);r[h](c + o);
          }), o._handleMouseDown(function () {
            t.scroll.removeClass("scroll-draggable"), f = r[h]();
          }, s);
        }));
      }), l.each(a, function (l, e) {
        var o = "scroll-scroll" + l + "_visible",
            s = "x" == l ? a.y : a.x;e.scroll.removeClass(o), s.scroll.removeClass(o), i.removeClass(o);
      }), l.each(a, function (e, o) {
        l.extend(o, "x" == e ? { offset: parseInt(r.css("left"), 10) || 0, size: r.prop("scrollWidth"), visible: d.width() } : { offset: parseInt(r.css("top"), 10) || 0, size: r.prop("scrollHeight"), visible: d.height() });
      }), this._updateScroll("x", this.scrollx), this._updateScroll("y", this.scrolly), l.isFunction(c.onUpdate) && c.onUpdate.apply(this, [r]), l.each(a, function (l, e) {
        var o = "x" === l ? "left" : "top",
            s = "x" === l ? "outerWidth" : "outerHeight",
            t = "x" === l ? "width" : "height",
            i = parseInt(r.css(o), 10) || 0,
            n = e.size,
            a = e.visible + i,
            d = e.scroll.size[s]() + (parseInt(e.scroll.size.css(o), 10) || 0);c.autoScrollSize && (e.scrollbarSize = parseInt(d * a / n, 10), e.scroll.bar.css(t, e.scrollbarSize + "px")), e.scrollbarSize = e.scroll.bar[s](), e.kx = (d - e.scrollbarSize) / (n - a) || 1, e.maxScrollOffset = n - a;
      }), r.scrollLeft(h.scrollLeft).scrollTop(h.scrollTop).trigger("scroll");
    }, _getScroll: function _getScroll(e) {
      var o = { advanced: ['<div class="scroll-element">', '<div class="scroll-element_corner"></div>', '<div class="scroll-arrow scroll-arrow_less"></div>', '<div class="scroll-arrow scroll-arrow_more"></div>', '<div class="scroll-element_outer">', '<div class="scroll-element_size"></div>', '<div class="scroll-element_inner-wrapper">', '<div class="scroll-element_inner scroll-element_track">', '<div class="scroll-element_inner-bottom"></div>', "</div>", "</div>", '<div class="scroll-bar">', '<div class="scroll-bar_body">', '<div class="scroll-bar_body-inner"></div>', "</div>", '<div class="scroll-bar_bottom"></div>', '<div class="scroll-bar_center"></div>', "</div>", "</div>", "</div>"].join(""), simple: ['<div class="scroll-element">', '<div class="scroll-element_outer">', '<div class="scroll-element_size"></div>', '<div class="scroll-element_track"></div>', '<div class="scroll-bar"></div>', "</div>", "</div>"].join("") };return o[e] && (e = o[e]), e || (e = o.simple), e = "string" == typeof e ? l(e).appendTo(this.wrapper) : l(e), l.extend(e, { bar: e.find(".scroll-bar"), size: e.find(".scroll-element_size"), track: e.find(".scroll-element_track") }), e;
    }, _handleMouseDown: function _handleMouseDown(e, o) {
      var s = this.namespace;return l(document).on("blur" + s, function () {
        l(document).add("body").off(s), e && e();
      }), l(document).on("dragstart" + s, function (l) {
        return l.preventDefault(), !1;
      }), l(document).on("mouseup" + s, function () {
        l(document).add("body").off(s), e && e();
      }), l("body").on("selectstart" + s, function (l) {
        return l.preventDefault(), !1;
      }), o && o.preventDefault(), !1;
    }, _updateScroll: function _updateScroll(e, o) {
      var s = this.container,
          r = this.containerWrapper || s,
          i = "scroll-scroll" + e + "_visible",
          n = "x" === e ? this.scrolly : this.scrollx,
          c = parseInt(this.container.css("x" === e ? "left" : "top"), 10) || 0,
          a = this.wrapper,
          d = o.size,
          h = o.visible + c;o.isVisible = d - h > 1, o.isVisible ? (o.scroll.addClass(i), n.scroll.addClass(i), r.addClass(i)) : (o.scroll.removeClass(i), n.scroll.removeClass(i), r.removeClass(i)), "y" === e && r.css(s.is("textarea") || h > d ? { height: h + t.scroll.height + "px", "max-height": "none" } : { "max-height": h + t.scroll.height + "px" }), (o.size != s.prop("scrollWidth") || n.size != s.prop("scrollHeight") || o.visible != a.width() || n.visible != a.height() || o.offset != (parseInt(s.css("left"), 10) || 0) || n.offset != (parseInt(s.css("top"), 10) || 0)) && (l.extend(this.scrollx, { offset: parseInt(s.css("left"), 10) || 0, size: s.prop("scrollWidth"), visible: a.width() }), l.extend(this.scrolly, { offset: parseInt(s.css("top"), 10) || 0, size: this.container.prop("scrollHeight"), visible: a.height() }), this._updateScroll("x" === e ? "y" : "x", n));
    } };var c = n;l.fn.scrollbar = function (e, o) {
    return "string" != typeof e && (o = e, e = "init"), "undefined" == typeof o && (o = []), l.isArray(o) || (o = [o]), this.not("body, .scroll-wrapper").each(function () {
      var s = l(this),
          r = s.data(t.data.name);(r || "init" === e) && (r || (r = new c(s)), r[e] && r[e].apply(r, o));
    }), this;
  }, l.fn.scrollbar.options = i;var a = function () {
    var l = 0,
        e = 0;return function (o) {
      var s, i, n, c, d, h, p;for (s = 0; s < t.scrolls.length; s++) {
        c = t.scrolls[s], i = c.container, n = c.options, d = c.wrapper, h = c.scrollx, p = c.scrolly, (o || n.autoUpdate && d && d.is(":visible") && (i.prop("scrollWidth") != h.size || i.prop("scrollHeight") != p.size || d.width() != h.visible || d.height() != p.visible)) && (c.init(), n.debug && (window.console && console.log({ scrollHeight: i.prop("scrollHeight") + ":" + c.scrolly.size, scrollWidth: i.prop("scrollWidth") + ":" + c.scrollx.size, visibleHeight: d.height() + ":" + c.scrolly.visible, visibleWidth: d.width() + ":" + c.scrollx.visible }, !0), e++));
      }r && e > 10 ? (window.console && console.log("Scroll updates exceed 10"), a = function a() {}) : (clearTimeout(l), l = setTimeout(a, 300));
    };
  }();window.angular && !function (l) {
    l.module("jQueryScrollbar", []).provider("jQueryScrollbar", function () {
      var e = i;return { setOptions: function setOptions(o) {
          l.extend(e, o);
        }, $get: function $get() {
          return { options: l.copy(e) };
        } };
    }).directive("jqueryScrollbar", function (l, e) {
      return { restrict: "AC", link: function link(o, s, r) {
          var t = e(r.jqueryScrollbar),
              i = t(o);s.scrollbar(i || l.options).on("$destroy", function () {
            s.scrollbar("destroy");
          });
        } };
    });
  }(window.angular);
});

/***/ }),
/* 789 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./client/utils/arrayUtils.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getArrayOfValues = function getArrayOfValues(list, field) {
  var fieldArray = [];
  list.map(function (item) {
    fieldArray.push(item[field]);
  });
  return fieldArray;
};

exports.getArrayOfValues = getArrayOfValues;

/***/ }),
/* 790 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./client/utils/dateUtils.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var convertToUTC = function convertToUTC(date) {
  if (!date) {
    return date;
  }

  var dateUTC = void 0;

  if (date instanceof Date) {
    dateUTC = date;
  } else if (typeof date === 'number') {
    dateUTC = new Date(date);
  }

  return new Date(dateUTC.toUTCString().slice(0, -4));
};

exports.convertToUTC = convertToUTC;

/***/ }),
/* 791 */
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./client/utils/directives.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoFocus = {
  inserted: function inserted(el) {
    el.focus();
  }
};

_vue2.default.directive('focus', AutoFocus);

_vue2.default.directive('on-click-outside', {
  bind: function bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

exports.default = {
  AutoFocus: AutoFocus
};

/***/ }),
/* 792 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./client/utils/toggleActiveListItem.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(/*! ../store */ 105);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toggleActiveListItem = function toggleActiveListItem() {
  var allActiveListItems = Array.prototype.slice.call(document.getElementsByClassName('active-li-retraido'));
  allActiveListItems.map(function (activeListItem) {
    return activeListItem.classList.remove('active-li-retraido');
  });
  if (_store2.default.getters.selectedMenuItem) {
    document.getElementById(_store2.default.getters.selectedMenuItem).classList.add('active-li-retraido');
  }
};

exports.default = toggleActiveListItem;

/***/ }),
/* 793 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./client/utils/truncateString.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var truncateString = function truncateString(value, lengthInitial, lengthFinal) {
  return value.substring(0, lengthInitial) + '...' + value.substring(value.length - lengthFinal, value.length);
};

exports.truncateString = truncateString;

/***/ }),
/* 794 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./client/utils/verifyReaplyConcByTimeAsync.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var verifyReaplyConcByTimeAsync = function verifyReaplyConcByTimeAsync(func, successCallback, errorCallback, wait) {
  func().then(function (response) {
    if (response.data.data === true) {
      successCallback(response);
      return;
    } else if (response.data.data === null) {
      errorCallback();
    }
    setTimeout(function () {
      return verifyReaplyConcByTimeAsync(func, successCallback, errorCallback, wait);
    }, wait);
  }).catch(function (err) {
    errorCallback(err);
  });
};

var verifyReaplyConcTimeout = 10000;

exports.verifyReaplyConcByTimeAsync = verifyReaplyConcByTimeAsync;
exports.verifyReaplyConcTimeout = verifyReaplyConcTimeout;

/***/ }),
/* 795 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./client/template/assets/plugins/modernizr.custom.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 137);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  !function (e, t, n) {
    function r(e, t) {
      return (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) === t;
    }function o() {
      var e, t, n, o, i, a, s;for (var l in S) {
        if (S.hasOwnProperty(l)) {
          if (e = [], t = S[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) {
            e.push(t.options.aliases[n].toLowerCase());
          }for (o = r(t.fn, "function") ? t.fn() : t.fn, i = 0; i < e.length; i++) {
            a = e[i], s = a.split("."), 1 === s.length ? Modernizr[s[0]] = o : (!Modernizr[s[0]] || Modernizr[s[0]] instanceof Boolean || (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])), Modernizr[s[0]][s[1]] = o), C.push((o ? "" : "no-") + s.join("-"));
          }
        }
      }
    }function i(e) {
      var t = b.className,
          n = Modernizr._config.classPrefix || "";if (w && (t = t.baseVal), Modernizr._config.enableJSClass) {
        var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");t = t.replace(r, "$1" + n + "js$2");
      }Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), w ? b.className.baseVal = t : b.className = t);
    }function a(e) {
      return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {
        return t + n.toUpperCase();
      }).replace(/^-/, "");
    }function s() {
      return "function" != typeof t.createElement ? t.createElement(arguments[0]) : w ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
    }function l() {
      var e = t.body;return e || (e = s(w ? "svg" : "body"), e.fake = !0), e;
    }function u(e, n, r, o) {
      var i,
          a,
          u,
          f,
          c = "modernizr",
          d = s("div"),
          p = l();if (parseInt(r, 10)) for (; r--;) {
        u = s("div"), u.id = o ? o[r] : c + (r + 1), d.appendChild(u);
      }return i = s("style"), i.type = "text/css", i.id = "s" + c, (p.fake ? p : d).appendChild(i), p.appendChild(d), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(t.createTextNode(e)), d.id = c, p.fake && (p.style.background = "", p.style.overflow = "hidden", f = b.style.overflow, b.style.overflow = "hidden", b.appendChild(p)), a = n(d, e), p.fake ? (p.parentNode.removeChild(p), b.style.overflow = f, b.offsetHeight) : d.parentNode.removeChild(d), !!a;
    }function f(e, t) {
      return !!~("" + e).indexOf(t);
    }function c(e, t) {
      return function () {
        return e.apply(t, arguments);
      };
    }function d(e, t, n) {
      var o;for (var i in e) {
        if (e[i] in t) return n === !1 ? e[i] : (o = t[e[i]], r(o, "function") ? c(o, n || t) : o);
      }return !1;
    }function p(e) {
      return e.replace(/([A-Z])/g, function (e, t) {
        return "-" + t.toLowerCase();
      }).replace(/^ms-/, "-ms-");
    }function m(t, n, r) {
      var o;if ("getComputedStyle" in e) {
        o = getComputedStyle.call(e, t, n);var i = e.console;if (null !== o) r && (o = o.getPropertyValue(r));else if (i) {
          var a = i.error ? "error" : "log";i[a].call(i, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
        }
      } else o = !n && t.currentStyle && t.currentStyle[r];return o;
    }function h(t, r) {
      var o = t.length;if ("CSS" in e && "supports" in e.CSS) {
        for (; o--;) {
          if (e.CSS.supports(p(t[o]), r)) return !0;
        }return !1;
      }if ("CSSSupportsRule" in e) {
        for (var i = []; o--;) {
          i.push("(" + p(t[o]) + ":" + r + ")");
        }return i = i.join(" or "), u("@supports (" + i + ") { #modernizr { position: absolute; } }", function (e) {
          return "absolute" == m(e, null, "position");
        });
      }return n;
    }function g(e, t, o, i) {
      function l() {
        c && (delete L.style, delete L.modElem);
      }if (i = r(i, "undefined") ? !1 : i, !r(o, "undefined")) {
        var u = h(e, o);if (!r(u, "undefined")) return u;
      }for (var c, d, p, m, g, v = ["modernizr", "tspan", "samp"]; !L.style && v.length;) {
        c = !0, L.modElem = s(v.shift()), L.style = L.modElem.style;
      }for (p = e.length, d = 0; p > d; d++) {
        if (m = e[d], g = L.style[m], f(m, "-") && (m = a(m)), L.style[m] !== n) {
          if (i || r(o, "undefined")) return l(), "pfx" == t ? m : !0;try {
            L.style[m] = o;
          } catch (y) {}if (L.style[m] != g) return l(), "pfx" == t ? m : !0;
        }
      }return l(), !1;
    }function v(e, t, n, o, i) {
      var a = e.charAt(0).toUpperCase() + e.slice(1),
          s = (e + " " + k.join(a + " ") + a).split(" ");return r(t, "string") || r(t, "undefined") ? g(s, t, o, i) : (s = (e + " " + N.join(a + " ") + a).split(" "), d(s, t, n));
    }function y(e, t, r) {
      return v(e, n, n, t, r);
    }var C = [],
        S = [],
        x = { _version: "3.5.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {
        var n = this;setTimeout(function () {
          t(n[e]);
        }, 0);
      }, addTest: function addTest(e, t, n) {
        S.push({ name: e, fn: t, options: n });
      }, addAsyncTest: function addAsyncTest(e) {
        S.push({ name: null, fn: e });
      } },
        Modernizr = function Modernizr() {};Modernizr.prototype = x, Modernizr = new Modernizr();var E = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];x._prefixes = E;var b = t.documentElement,
        w = "svg" === b.nodeName.toLowerCase();w || !function (e, t) {
      function n(e, t) {
        var n = e.createElement("p"),
            r = e.getElementsByTagName("head")[0] || e.documentElement;return n.innerHTML = "x<style>" + t + "</style>", r.insertBefore(n.lastChild, r.firstChild);
      }function r() {
        var e = C.elements;return "string" == typeof e ? e.split(" ") : e;
      }function o(e, t) {
        var n = C.elements;"string" != typeof n && (n = n.join(" ")), "string" != typeof e && (e = e.join(" ")), C.elements = n + " " + e, u(t);
      }function i(e) {
        var t = y[e[g]];return t || (t = {}, v++, e[g] = v, y[v] = t), t;
      }function a(e, n, r) {
        if (n || (n = t), c) return n.createElement(e);r || (r = i(n));var o;return o = r.cache[e] ? r.cache[e].cloneNode() : h.test(e) ? (r.cache[e] = r.createElem(e)).cloneNode() : r.createElem(e), !o.canHaveChildren || m.test(e) || o.tagUrn ? o : r.frag.appendChild(o);
      }function s(e, n) {
        if (e || (e = t), c) return e.createDocumentFragment();n = n || i(e);for (var o = n.frag.cloneNode(), a = 0, s = r(), l = s.length; l > a; a++) {
          o.createElement(s[a]);
        }return o;
      }function l(e, t) {
        t.cache || (t.cache = {}, t.createElem = e.createElement, t.createFrag = e.createDocumentFragment, t.frag = t.createFrag()), e.createElement = function (n) {
          return C.shivMethods ? a(n, e, t) : t.createElem(n);
        }, e.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + r().join().replace(/[\w\-:]+/g, function (e) {
          return t.createElem(e), t.frag.createElement(e), 'c("' + e + '")';
        }) + ");return n}")(C, t.frag);
      }function u(e) {
        e || (e = t);var r = i(e);return !C.shivCSS || f || r.hasCSS || (r.hasCSS = !!n(e, "article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")), c || l(e, r), e;
      }var f,
          c,
          d = "3.7.3",
          p = e.html5 || {},
          m = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,
          h = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,
          g = "_html5shiv",
          v = 0,
          y = {};!function () {
        try {
          var e = t.createElement("a");e.innerHTML = "<xyz></xyz>", f = "hidden" in e, c = 1 == e.childNodes.length || function () {
            t.createElement("a");var e = t.createDocumentFragment();return "undefined" == typeof e.cloneNode || "undefined" == typeof e.createDocumentFragment || "undefined" == typeof e.createElement;
          }();
        } catch (n) {
          f = !0, c = !0;
        }
      }();var C = { elements: p.elements || "abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video", version: d, shivCSS: p.shivCSS !== !1, supportsUnknownElements: c, shivMethods: p.shivMethods !== !1, type: "default", shivDocument: u, createElement: a, createDocumentFragment: s, addElements: o };e.html5 = C, u(t), "object" == ( false ? "undefined" : (0, _typeof3.default)(module)) && module.exports && (module.exports = C);
    }("undefined" != typeof e ? e : this, t);var _ = "Moz O ms Webkit",
        N = x._config.usePrefixes ? _.toLowerCase().split(" ") : [];x._domPrefixes = N;var z = "CSS" in e && "supports" in e.CSS,
        P = "supportsCSS" in e;Modernizr.addTest("supports", z || P);var k = x._config.usePrefixes ? _.split(" ") : [];x._cssomPrefixes = k;var T = function T(t) {
      var r,
          o = E.length,
          i = e.CSSRule;if ("undefined" == typeof i) return n;if (!t) return !1;if (t = t.replace(/^@/, ""), r = t.replace(/-/g, "_").toUpperCase() + "_RULE", r in i) return "@" + t;for (var a = 0; o > a; a++) {
        var s = E[a],
            l = s.toUpperCase() + "_" + r;if (l in i) return "@-" + s.toLowerCase() + "-" + t;
      }return !1;
    };x.atRule = T;var j = x.testStyles = u,
        F = { elem: s("modernizr") };Modernizr._q.push(function () {
      delete F.elem;
    });var L = { style: F.elem.style };Modernizr._q.unshift(function () {
      delete L.style;
    });x.testProp = function (e, t, r) {
      return g([e], n, t, r);
    };x.testAllProps = v, x.testAllProps = y, Modernizr.addTest("csstransitions", y("transition", "all", !0)), Modernizr.addTest("csstransforms3d", function () {
      var e = !!y("perspective", "1px", !0),
          t = Modernizr._config.usePrefixes;if (e && (!t || "webkitPerspective" in b.style)) {
        var n,
            r = "#modernizr{width:0;height:0}";Modernizr.supports ? n = "@supports (perspective: 1px)" : (n = "@media (transform-3d)", t && (n += ",(-webkit-transform-3d)")), n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", j(r + n, function (t) {
          e = 7 === t.offsetWidth && 18 === t.offsetHeight;
        });
      }return e;
    });x.prefixed = function (e, t, n) {
      return 0 === e.indexOf("@") ? T(e) : (-1 != e.indexOf("-") && (e = a(e)), t ? v(e, t, n) : v(e, "pfx"));
    };o(), i(C), delete x.addTest, delete x.addAsyncTest;for (var M = 0; M < Modernizr._q.length; M++) {
      Modernizr._q[M]();
    }e.Modernizr = Modernizr;
  }(window, document);

  module.exports = window.Modernizr;
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../../../~/webpack/buildin/module.js */ 302)(module)))

/***/ }),
/* 796 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/administration/auditLog/AuditModal.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _Modal = __webpack_require__(/*! ../../modals/modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _ButtonPrint = __webpack_require__(/*! ../../buttons/buttonPrint/ButtonPrint */ 1257);

var _ButtonPrint2 = _interopRequireDefault(_ButtonPrint);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

exports.default = {
  name: 'AuditModal',

  components: {
    Modal: _Modal2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    ButtonPrint: _ButtonPrint2.default
  },

  props: {
    audit: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      modalTitle: this.$t('logDeAuditoria.labels.logDeAuditoria'),
      modalSubtitle: this.$t('logDeAuditoria.labels.logDeAuditoria'),
      userName: '',
      login: '',
      accessProfile: '',
      functionality: '',
      transaction: '',
      transactionDate: '',
      ip: '',
      workStation: '',
      entity: '',
      entityId: ''
    };
  },


  watch: {
    audit: function audit() {
      this.modalTitle = this.audit.tituloModal;
      this.userName = this.audit.nomeUsuario;
      this.login = this.audit.login;
      this.accessProfile = this.audit.nomePerfil;
      this.functionality = this.audit.funcionalidade ? this.audit.funcionalidade.nome : '';
      this.transaction = this.audit.transacao ? this.audit.transacao.nome : '';
      this.transactionDate = (0, _moment2.default)(this.audit.dataTransacao).format('DD/MM/YYYY HH:mm:ss');
      this.ip = this.audit.numeroIP;
      this.workStation = this.audit.numeroIP;
      this.entity = this.audit.entidade ? this.audit.entidade.numero : '';
      this.entityId = this.audit.idEntidade;
      this.loadData();
    }
  },

  methods: {
    loadData: function loadData() {
      $('#treeView > li').empty();
      var xmlText = null;
      var xmlObjetct = null;

      xmlText = this.audit.xmlEntidade;
      xmlObjetct = jQuery.parseXML(xmlText);
      this.toXml(xmlObjetct);
    },
    toXml: function toXml(tree) {
      this.traverse($('#treeView li'), tree.firstChild);

      $('<b>-</b>').prependTo('#treeView li:has(li)').click(function () {
        var sign = $(this).text();
        if (sign === '-') {
          var next = $(this).text('+').next()[0];
          next.innerText = $(this).next().text() + ' ...';
          $(this).text('+').next().next().hide();
        } else {
          var _next = $(this).text('+').next()[0];
          _next.innerText = $(this).next().text().replace(' ...', '');
          $(this).text('-').next().next().show();
        }
      });
    },
    traverse: function traverse(node, tree) {
      var children = $(tree).children();
      var self = this;

      if (tree.children && tree.children.length) {
        children = tree.children;

        node.append('<label>' + tree.nodeName + '</label>');
        var ul = $('<ul>').appendTo(node);

        var li = null;

        for (var i = 0; i < children.length; i++) {
          li = $('<li>').appendTo(ul);
          self.traverse(li, children[i]);
        }
      } else {
        if (tree.nodeName === 'lang') {
          node.append('<label>linguagemDoSistema: </label>');
        } else {
          node.append('<label>' + tree.nodeName + ': </label>');
        }

        if ($(tree).text() === 'true') {
          $('<span> Sim</span>').appendTo(node);
        } else if ($(tree).text() === 'false') {
          $('<span> Não</span>').appendTo(node);
        } else {
          if ($(tree).text().length === 10 && $(tree).text().split('-').length - 1 === 2) {
            $('<span> ' + this.handleText($(tree).text()) + '</span>').appendTo(node);
          } else {
            $('<span> ' + $(tree).text() + '</span>').appendTo(node);
          }
        }
      }
    },
    handleText: function handleText(text) {
      return (0, _moment2.default)(text).format('DD/MM/YYYY');
    },
    closeModal: function closeModal() {
      $('#auditModal').modal('hide');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16), __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 797 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/buttons/buttonApplication/ButtonApplication.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ButtonApplication',

  props: {
    btnDesc: {
      type: String,
      required: true
    },
    btnImg: {
      type: String,
      required: true
    },
    btnActive: {
      type: Boolean,
      required: true
    },
    btnClickFunction: {
      type: Function,
      required: true
    },
    btnWidth: {
      type: String,
      required: true
    },
    btnAppId: {
      type: Number,
      required: true
    }
  },

  data: function data() {
    return {
      equalsCartoesImg: __webpack_require__(/*! ../../../assets/icones_app/cartao_azul.svg */ 491),
      equalsBankingImg: __webpack_require__(/*! ../../../assets/icones_app/banco_branco.svg */ 490)
    };
  },


  methods: {
    roundedClass: function roundedClass() {
      return this.btnActive ? 'rounded-div-active' : 'rounded-div';
    },
    activeMarkClass: function activeMarkClass() {
      return this.btnActive ? 'mark' : 'transp-mark';
    },
    activeDescClass: function activeDescClass() {
      return this.btnActive ? 'app-font bold' : 'app-font';
    }
  }
};

/***/ }),
/* 798 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/buttons/buttonPrimary/ButtonPrimary.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

exports.default = {
  name: 'ButtonPrimary',

  props: {
    faIcon: {
      type: String
    },
    label: {
      type: String
    },
    clickFunction: {
      type: Function,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'button'
    },
    customClass: {
      type: String
    },
    width: {
      type: String
    },
    title: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    trackEvent: function trackEvent() {
      (0, _analytics.trackAnalyticsEvent)(this, 'button-click', 'primary-button-component', this.id);
      if (typeof this.clickFunction !== 'undefined') {
        this.clickFunction();
      }
    }
  }
};

/***/ }),
/* 799 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/buttons/buttonPrint/ButtonPrint.vue ***!
  \***************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(/*! babel-runtime/core-js/array/from */ 164);

var _from2 = _interopRequireDefault(_from);

var _printHtmlElement = __webpack_require__(/*! print-html-element */ 1145);

var _printHtmlElement2 = _interopRequireDefault(_printHtmlElement);

var _ButtonPrimary = __webpack_require__(/*! ../buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ButtonPrint',

  components: {
    ButtonPrimary: _ButtonPrimary2.default
  },

  methods: {
    print: function print() {
      var clonedElement = document.createElement('toPrint');

      var printableArray = (0, _from2.default)(document.getElementsByClassName('printable'));

      printableArray.forEach(function (element) {
        clonedElement.appendChild(element.cloneNode(true));
      }, this);

      this.removeObjectByClass(clonedElement, 'dataTables_info');

      this.removeObjectByClass(clonedElement, 'dataTables_paginate');

      this.removeObjectByTag(clonedElement, 'input');

      this.showAllTableObjects(clonedElement);

      var textAreaArray = (0, _from2.default)(clonedElement.getElementsByTagName('textarea'));
      this.getValueElement(textAreaArray);

      this.getValueComponentMultiselect(clonedElement);

      this.getElementsTd(clonedElement);
      _printHtmlElement2.default.printElement(clonedElement, {
        styles: []
      });

      return true;
    },
    removeObjectByClass: function removeObjectByClass(clonedElement, className) {
      var elementArray = (0, _from2.default)(clonedElement.getElementsByClassName(className));
      elementArray.forEach(function (element) {
        element.style.display = 'none';
      }, this);
    },
    removeObjectByTag: function removeObjectByTag(clonedElement, tagName) {
      var elementArray = (0, _from2.default)(clonedElement.getElementsByTagName(tagName));
      elementArray.forEach(function (element) {
        element.style.display = 'none';
      }, this);
    },
    showAllTableObjects: function showAllTableObjects(clonedElement) {
      var tableArray = (0, _from2.default)(clonedElement.getElementsByTagName('table'));

      tableArray.forEach(function (element) {
        var idTable = $(element).attr('id');
        var htmlTd = '';
        var htmlTrInicio = '<tr role="row" class="odd">';
        var htmlTrFim = '</tr>';

        $('#' + idTable).DataTable().rows().iterator('row', function (context, index) {
          var node = $(this.row(index).node());
          htmlTd = htmlTd + (htmlTrInicio + node.context.innerHTML + htmlTrFim);
        });

        element.getElementsByTagName('tbody')[0].innerHTML = htmlTd;
      }, this);
    },
    getValueComponentMultiselect: function getValueComponentMultiselect(clonedElement) {
      var multiselectArray = (0, _from2.default)(clonedElement.getElementsByClassName('multiselect'));

      multiselectArray.forEach(function (element) {
        var elementArray = (0, _from2.default)(element.getElementsByTagName('input'));

        elementArray.forEach(function (elementAux) {
          if (elementAux.value) {
            element.innerHTML = elementAux.value;
          }
        }, this);
      }, this);
    },
    getElementsTd: function getElementsTd(clonedElement) {
      var tdArray = (0, _from2.default)(clonedElement.getElementsByTagName('td'));
      tdArray.forEach(function (element) {
        if (element.title) {
          element.innerHTML = element.title;
        }
      }, this);
    },
    getValueElement: function getValueElement(elementArray) {
      elementArray.forEach(function (element) {
        if (element.value) {
          element.innerHTML = element.value;
        }
      }, this);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 800 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/buttons/buttonSearch/ButtonSearch.vue ***!
  \*****************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonPrimary = __webpack_require__(/*! ../buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ButtonSearch',

  components: {
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    isDisabled: {
      type: Boolean,
      required: true
    }
  }
};

/***/ }),
/* 801 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/buttons/toogle/Toogle.vue ***!
  \*****************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

exports.default = {
  name: 'Toogle',

  props: {
    labelLeft: {
      type: String
    },
    labelRight: {
      type: String
    },
    idLeft: {
      type: String,
      required: true
    },
    idRight: {
      type: String,
      required: true
    },
    handleSelection: {
      type: Function,
      required: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    trackEvent: function trackEvent(idSelected) {
      (0, _analytics.trackAnalyticsEvent)(this, 'toogle-click', 'toogle-component', this[idSelected]);
      if (typeof this.handleSelection !== 'undefined') {
        this.handleSelection(idSelected === 'idLeft');
      }
    }
  }
};

/***/ }),
/* 802 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/calendarView/CalendarView.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(/*! ../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CalendarView',

  components: {
    Datepicker: _vuejsDatepicker2.default,
    vSelect: _vueSelect2.default
  },

  computed: {
    monthPickerLanguage: function monthPickerLanguage() {
      return this.language.getDatePickerLanguageObject();
    },
    alertMessage: function alertMessage() {
      return this.$t('calendarioConciliacao.alerta.disclaimer');
    },
    orderedStatusList: function orderedStatusList() {
      return this.situationList.sort(function (a, b) {
        return a.prioridade - b.prioridade;
      });
    }
  },

  props: {
    monthToShow: {
      type: Date,
      required: true
    },
    setStartDate: {
      type: Function,
      required: true,
      default: function _default() {
        return null;
      }
    },
    setEndDate: {
      type: Function,
      required: true,
      default: function _default() {
        return null;
      }
    },
    setMonth: {
      type: Function,
      required: true,
      default: function _default() {
        return null;
      }
    },
    conciliacaoData: {
      type: Array,
      required: true,
      default: []
    },
    categories: {
      type: Array,
      required: true,
      default: []
    },
    isLoadingData: {
      type: Boolean,
      required: true
    },
    setCategory: {
      type: Function,
      required: true,
      default: function _default() {
        return null;
      }
    },
    selectedCategory: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      language: _index2.default,
      monthPick: null,
      calendarData: {
        weeks: []
      },
      situationList: [{
        id: 'A',
        nome: this.$t('statusConciliacao.aberto'),
        color: '#FFD54F',
        prioridade: 1
      }, {
        id: 'C',
        nome: this.$t('statusConciliacao.conciliado'),
        color: '#81C784',
        prioridade: 3
      }, {
        id: 'M',
        nome: this.$t('calendarioConciliacao.detalhe.conciliadoManualmente'),
        color: '#4DB6AC',
        prioridade: 4
      }, {
        id: 'D',
        nome: this.$t('statusConciliacao.divergente'),
        color: '#E57373',
        prioridade: 2
      }],
      fromDate: null,
      toDate: null,
      hasFirstClick: false,
      filteredStatus: {
        id: 'A',
        nome: this.$t('statusConciliacao.aberto'),
        color: '#FFD54F',
        prioridade: 1
      },
      filteredCategory: {},
      isUpdatingInfo: false
    };
  },


  watch: {
    monthPick: {
      handler: function handler(newVal, oldVal) {
        if (newVal && !_moment2.default.utc(newVal).startOf('day').isSame(_moment2.default.utc(this.monthToShow).startOf('day'))) {
          this.setMonth(newVal);
        } else {
          this.monthPick = this.monthToShow;
        }
      },

      deep: true
    },
    conciliacaoData: {
      handler: function handler() {
        this.generateCalendar();
      },

      deep: true
    },
    categories: {
      handler: function handler() {
        if (this.categories && this.categories.length > 0) {
          this.filteredCategory = this.categories[0];
        }
      },

      deep: true
    },
    selectedCategory: {
      handler: function handler() {
        this.filteredCategory = this.selectedCategory;
      },

      deep: true
    },
    filteredCategory: {
      handler: function handler() {
        this.isUpdatingInfo = true;
        this.mountCalendarInfo();
        this.isUpdatingInfo = false;
        this.setCategory(this.filteredCategory);
      },

      deep: true
    }
  },

  methods: {
    getReferenceFromDay: function getReferenceFromDay(day) {
      return _moment2.default.utc(day).valueOf();
    },
    generateCalendar: function generateCalendar() {
      var _this = this;

      var weeksToShow = this.calculateWeeks();
      weeksToShow.map(function (wk) {
        if (wk.length < 7) {
          var miss = 7 - wk.length;

          for (var i = 0; i < miss; i++) {
            wk.splice(i, 0, {});
          }

          wk.map(function (day, dayIndex) {
            var weekIndex = day.date ? _moment2.default.utc(day.date).day() : -1;
            if (weekIndex >= 0) {
              wk.splice(dayIndex, 1);
              wk.splice(weekIndex, 0, day);
            }
          });
        }
        wk.map(function (day) {
          day.selected = _this.isToday(day.date);
        });
      });
      this.calendarData.weeks = weeksToShow;
      this.mountCalendarInfo();
    },
    calculateWeeks: function calculateWeeks() {
      var startDate = _moment2.default.utc(this.monthToShow).startOf('month');
      var endDate = _moment2.default.utc(startDate).endOf('month');
      var month = _moment2.default.utc(this.monthToShow).get('month');
      var weeks = [];
      var perWeek = [];
      var difference = endDate.diff(startDate, 'days');
      perWeek.push({ date: startDate.toDate() });
      var index = 0;
      var lastWeek = false;
      while (startDate.add(1, 'days').diff(endDate) < 0) {
        if (startDate.day() !== 0) {
          perWeek.push({ date: startDate.toDate() });
        } else {
          if (startDate.clone().add(7, 'days').month() === month) {
            weeks.push(perWeek);
            perWeek = [];
            perWeek.push({ date: startDate.toDate() });
          } else if (Math.abs(index - difference) > 0) {
            if (!lastWeek) {
              weeks.push(perWeek);
              perWeek = [];
            }
            lastWeek = true;
            perWeek.push({ date: startDate.toDate() });
          }
        }
        index += 1;
        if (lastWeek === true && Math.abs(index - difference) === 0 || Math.abs(index - difference) === 0 && perWeek.length === 1) {
          weeks.push(perWeek);
        }
      }
      return weeks;
    },
    formatDateGetDay: function formatDateGetDay(day) {
      return day ? _moment2.default.utc(day).format('DD') : '';
    },
    isToday: function isToday(date) {
      return date ? _moment2.default.utc(date).endOf('day').isSame(_moment2.default.utc().endOf('day')) : false;
    },
    handleClickDay: function handleClickDay(selectedDate) {
      if (selectedDate) {
        if (this.hasFirstClick) {
          var firstDate = _moment2.default.utc(this.fromDate).startOf('day').isBefore(_moment2.default.utc(selectedDate).startOf('day')) ? this.fromDate : selectedDate;
          var lastDate = _moment2.default.utc(this.fromDate).startOf('day').isAfter(_moment2.default.utc(selectedDate).startOf('day')) ? this.fromDate : selectedDate;
          this.setStartDate(firstDate);
          this.setEndDate(lastDate);
          this.hasFirstClick = false;
        } else {
          this.calendarData.weeks.map(function (week) {
            week.map(function (day) {
              day.selected = day.date ? _moment2.default.utc(day.date).endOf('day').isSame(_moment2.default.utc(selectedDate).endOf('day')) : false;
            });
          });
          this.hasFirstClick = true;
          this.fromDate = selectedDate;
        }
      }
    },
    unselectAll: function unselectAll() {
      this.calendarData.weeks.map(function (week) {
        week.map(function (day) {
          day.selected = false;
        });
      });
    },
    getConciliationLabel: function getConciliationLabel(status) {
      var label = ' - ';
      this.situationList.map(function (item) {
        if (item.id === status) {
          label = item.nome;
        }
      });
      return label;
    },
    getColorByStatus: function getColorByStatus(status) {
      var label = '#64b5f6';
      this.situationList.map(function (item) {
        if (item.id === status) {
          label = item.color;
        }
      });
      return label;
    },
    formatPercent: function formatPercent(value) {
      if (!isNaN(value)) {
        var result = Number(value);
        return (result % 1 !== 0 ? result.toFixed(2) : result) + '%';
      }
      return value;
    },
    mountCalendarInfo: function mountCalendarInfo() {
      var _this2 = this;

      if (this.conciliacaoData && this.conciliacaoData.length > 0) {
        this.calendarData.weeks.map(function (week) {
          week.map(function (day) {
            var baseDataByDay = _this2.conciliacaoData.filter(function (item) {
              return item.situacao !== 'N' && (_this2.filteredCategory && _this2.filteredCategory.id !== '-1' ? _this2.filteredCategory.nome === item.categoria : true) && _moment2.default.utc(item.dataMin).startOf('day').isSame(_moment2.default.utc(day.date).startOf('day'));
            });
            var summaryByStatus = [];
            var totalByDay = 0;
            baseDataByDay.map(function (item) {
              totalByDay += item.totalExtrato + item.totalMovFinan;
            });
            baseDataByDay.map(function (item) {
              var summaryIndex = summaryByStatus.findIndex(function (el) {
                return el.status === item.situacao;
              });
              if (summaryIndex >= 0) {
                var summary = summaryByStatus.at(summaryIndex);
                summary.totalByStatus += item.totalExtrato + item.totalMovFinan;
                summaryByStatus.splice(summaryIndex, 1, summary);
              } else {
                var _summary = {
                  status: item.situacao,
                  totalByStatus: item.totalExtrato + item.totalMovFinan
                };
                summaryByStatus.push(_summary);
              }
            });
            summaryByStatus.map(function (sum) {
              sum.percent = totalByDay !== 0 ? 100 * sum.totalByStatus / totalByDay : 'N/A';
            });
            day.summary = summaryByStatus;
          });
        });
        this.$forceUpdate();
      }
    },
    handleMouseOver: function handleMouseOver(date, isOverElement) {
      if (date && this.hasFirstClick) {
        if (isOverElement) {
          var firstDate = _moment2.default.utc(this.fromDate).startOf('day').isBefore(_moment2.default.utc(date).startOf('day')) ? this.fromDate : date;
          var lastDate = _moment2.default.utc(this.fromDate).startOf('day').isAfter(_moment2.default.utc(date).startOf('day')) ? this.fromDate : date;
          this.calendarData.weeks.map(function (week) {
            week.map(function (day) {
              day.selected = day.date ? _moment2.default.utc(day.date).isBetween(_moment2.default.utc(firstDate).startOf('day'), _moment2.default.utc(lastDate).endOf('day'), undefined, '[]') : false;
            });
          });
        }
      }
    },
    setFilteredStatus: function setFilteredStatus(status) {
      this.filteredStatus = status;
    }
  },
  mounted: function mounted() {
    this.monthPick = this.monthToShow;
  }
};

/***/ }),
/* 803 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/Dashboard.vue ***!
  \***************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = __webpack_require__(/*! babel-runtime/helpers/slicedToArray */ 323);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vuedraggable = __webpack_require__(/*! vuedraggable */ 197);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _HeaderBar = __webpack_require__(/*! ../layout/headerBar/HeaderBar */ 1276);

var _HeaderBar2 = _interopRequireDefault(_HeaderBar);

var _DateRange = __webpack_require__(/*! ../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _Chart = __webpack_require__(/*! ./chart/Chart */ 1262);

var _Chart2 = _interopRequireDefault(_Chart);

var _helpers = __webpack_require__(/*! ../../utils/helpers */ 318);

var _filtroPeriodo = __webpack_require__(/*! ../../enum/filtroPeriodo */ 199);

var _filtroPeriodo2 = _interopRequireDefault(_filtroPeriodo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Dashboard',

  components: {
    vSelect: _vueSelect2.default,
    Draggable: _vuedraggable2.default,
    HeaderBar: _HeaderBar2.default,
    DateRange: _DateRange2.default,
    Chart: _Chart2.default
  },

  props: {
    charts: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      debounce: _helpers.debounce.apply(this),
      finalDateDisable: (0, _moment2.default)(new Date()).add(1, 'days').toDate(),
      dateRange: {},
      firstDate: (0, _moment2.default)(new Date()).add(-31, 'days').toDate(),
      finalDate: (0, _moment2.default)(new Date()).toDate(),
      filter: {
        periodType: {}
      },
      periodList: [{
        id: _filtroPeriodo2.default.ESTA_SEMANA,
        label: this.$t('dashboard.filtro.data.estaSemana')
      }, {
        id: _filtroPeriodo2.default.ULTIMOS_SETE_DIAS,
        label: this.$t('dashboard.filtro.data.ultimosSeteDias')
      }, {
        id: _filtroPeriodo2.default.ESTE_MES,
        label: this.$t('dashboard.filtro.data.esteMes')
      }, {
        id: _filtroPeriodo2.default.ULTIMOS_TRINTA_DIAS,
        label: this.$t('dashboard.filtro.data.ultimosTrintaDias')
      }, {
        id: _filtroPeriodo2.default.MES_ANTERIOR,
        label: this.$t('dashboard.filtro.data.mesAnterior')
      }, {
        id: _filtroPeriodo2.default.PERSONALIZADO,
        label: this.$t('dashboard.filtro.data.personalizado')
      }]
    };
  },


  computed: {
    availableGadgets: function availableGadgets() {
      return this.$store.getters.availableGadgets;
    }
  },

  methods: {
    setCustomRangeFilter: function setCustomRangeFilter() {
      if (!this.dateRange.invalid) {
        this.filter.fromDate = this.dateRange.fromDate;
        this.filter.toDate = this.dateRange.toDate;
        this.$store.dispatch('setDashboardDateFilter', { id: this.filter.periodType.id, label: this.filter.periodType.label, fromDate: this.dateRange.fromDate, toDate: this.dateRange.toDate });
      }
    },
    onPeriodChanged: function onPeriodChanged(period) {
      if (_filtroPeriodo2.default.PERSONALIZADO !== period.id) {
        this.$store.dispatch('setDashboardDateFilter', { id: period.id, label: period.label });
      }
      this.filter.periodType = period;
    },
    resize: function resize(index, chart) {
      if (chart.container === 'chartFull') {
        chart.container = 'chartMiddle';
      } else {
        chart.container = 'chartFull';
      }
      this.charts.splice(index, 1, chart);
      this.saveDashboard();
    },
    saveDashboard: function saveDashboard() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.charts.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

          var index = _ref2[0];
          var chart = _ref2[1];

          if (!chart) {
            continue;
          }
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(this.availableGadgets), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var gadget = _step2.value;

              if (gadget && gadget.gadgetParam && gadget.gadgetParam.length > 0) {
                var paramOrderAux = gadget.gadgetParam.find(function (param) {
                  return param.nome === 'ordemExibicao';
                });
                var paramContainerAux = gadget.gadgetParam.find(function (param) {
                  return param.nome === 'container';
                });
                if (chart.idChart === gadget.funcionalidade.idFuncionalidade) {
                  paramOrderAux.valor = index + 1;
                  paramContainerAux.valor = chart.container === 'chartFull' ? 1 : 2;
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.debounce(this.setGadgetConfig, 2500);
    },
    configChartShow: function configChartShow(chart) {
      return chart && chart.idChart ? this.$store.getters.allowedFuncionalities.includes(chart.idChart) : null;
    },
    setGadgetConfig: function setGadgetConfig() {
      this.$store.dispatch('updateGadgetList', this.availableGadgets);
    },
    showDateRange: function showDateRange() {
      return _filtroPeriodo2.default.PERSONALIZADO === this.filter.periodType.id;
    }
  },

  created: function created() {
    var _this = this;

    this.filter.periodType = this.periodList.find(function (item) {
      return item.id === _this.$store.getters.periodDashboard.id;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.setGadgetConfig();
  }
};

/***/ }),
/* 804 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/chart/Chart.vue ***!
  \*****************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(/*! babel-runtime/core-js/array/from */ 164);

var _from2 = _interopRequireDefault(_from);

var _ConciliationSituationSummary = __webpack_require__(/*! ../chartFilter/ConciliationSituationSummary */ 1264);

var _ConciliationSituationSummary2 = _interopRequireDefault(_ConciliationSituationSummary);

var _FinancialSummary = __webpack_require__(/*! ../chartFilter/FinancialSummary */ 1267);

var _FinancialSummary2 = _interopRequireDefault(_FinancialSummary);

var _AllotmentDistributionConciliation = __webpack_require__(/*! ../chartFilter/AllotmentDistributionConciliation */ 1263);

var _AllotmentDistributionConciliation2 = _interopRequireDefault(_AllotmentDistributionConciliation);

var _DailyBankStatment = __webpack_require__(/*! ../chartFilter/DailyBankStatment */ 1265);

var _DailyBankStatment2 = _interopRequireDefault(_DailyBankStatment);

var _DigitalWalletBalance = __webpack_require__(/*! ../chartFilter/DigitalWalletBalance */ 1266);

var _DigitalWalletBalance2 = _interopRequireDefault(_DigitalWalletBalance);

var _TaskGadget = __webpack_require__(/*! ../gadget/TaskGadget */ 1269);

var _TaskGadget2 = _interopRequireDefault(_TaskGadget);

var _openMenu = __webpack_require__(/*! ../../../events/openMenu */ 315);

var _openMenu2 = _interopRequireDefault(_openMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Chart',

  components: {
    ConciliationSituationSummaryFilter: _ConciliationSituationSummary2.default,
    FinancialSummaryFilter: _FinancialSummary2.default,
    AllotmentDistributionFilter: _AllotmentDistributionConciliation2.default,
    DailyBankStatmentFilter: _DailyBankStatment2.default,
    DigitalWalletBalanceFilter: _DigitalWalletBalance2.default,
    TaskGadget: _TaskGadget2.default
  },

  props: {
    id: {
      type: Number
    },
    chart: {
      type: Object
    },
    filters: {
      type: Array
    },
    classTitChart: {
      type: String
    },
    classFilterChart: {
      type: String
    },
    showTaskGadget: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      showChart: !this.chart.isCollapsed
    };
  },


  methods: {
    resize: function resize() {
      this.$emit('onResize', this.chart);
    },
    getClassChartTitle: function getClassChartTitle(chart) {
      return this._getClass('classTitChart', chart);
    },
    getClassChartFilter: function getClassChartFilter(chart) {
      return this._getClass('classFilterChart', chart);
    },
    _getClass: function _getClass(baseClass, chart) {
      if (!chart.container) {
        return baseClass;
      }

      var el = (0, _from2.default)(document.querySelectorAll('div')).find(function (el) {
        return el.getAttribute('id') === chart.idChart.toString();
      });
      if (!el) {
        return baseClass;
      }

      if (el.children[0].classList.contains('dragFull')) {
        return baseClass + ' chartFull';
      }

      return baseClass + ' chartMiddle';
    },
    collapseContent: function collapseContent() {
      this.showChart = !this.showChart;
      this.chart.isCollapsed = !this.chart.isCollapsed;
    },
    updateCredits: function updateCredits() {
      var _this = this;

      this.showChart = false;
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
        _this.showChart = true;
      }, 150);
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    _openMenu2.default.$on('menuOpened', function () {
      _this2.updateCredits();
    });
  }
};

/***/ }),
/* 805 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/chartFilter/AllotmentDistributionConciliation.vue ***!
  \***************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _FiltersCommon = __webpack_require__(/*! ../filter/FiltersCommon */ 159);

var _FiltersCommon2 = _interopRequireDefault(_FiltersCommon);

var _graficoId = __webpack_require__(/*! ../../../enum/graficoId */ 103);

var _graficoId2 = _interopRequireDefault(_graficoId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AllotmentDistributionConciliation',

  components: {
    FiltersCommon: _FiltersCommon2.default
  },

  data: function data() {
    return {
      gadget: this.$store.getters.availableGadgets.find(function (g) {
        return g.funcionalidade.idFuncionalidade === _graficoId2.default.DISTRIBUICAO_CONCILIACAO_LOTE;
      }),
      filters: [{
        name: 'agrupamentoPlano',
        options: this.$store.getters.plansDashboard.map(function (plan) {
          return {
            id: plan.id,
            label: plan.nome
          };
        }),
        onChange: this.setSelected('setPlanSelectedAllotmentDistributionSummary', 'agrupamentoPlano'),
        order: 1
      }, {
        name: 'agrupamentoTipoMovimento',
        options: [{
          id: 'TD',
          label: this.$t('dashboard.filtro.tipo.T')
        }, {
          id: 'MF',
          label: this.$t('dashboard.filtro.tipo.MF')
        }, {
          id: 'MB',
          label: this.$t('dashboard.filtro.tipo.E')
        }],
        onChange: this.setSelected('setTypeFilterBatchDistribution', 'agrupamentoTipoMovimento'),
        order: 2
      }, {
        name: 'agrupamentoCategoriaPrincipal',
        options: [{
          id: 'TD',
          label: this.$t('dashboard.filtro.tipo.T')
        }].concat((0, _toConsumableArray3.default)(this.$store.getters.mainCategoriesDashboard.map(function (mainCategory) {
          return {
            id: mainCategory.id,
            label: mainCategory.number + ' - ' + mainCategory.description
          };
        }))),
        onChange: this.setSelected('setMainCategorySelectedAllotmentDistributionSummary', 'agrupamentoCategoriaPrincipal'),
        order: 3
      }]
    };
  },


  computed: {
    periodoDashboard: function periodoDashboard() {
      return this.$store.getters.periodFilterAllotmentDistribution;
    }
  },

  watch: {
    periodoDashboard: {
      handler: function handler() {
        this.setFilter('periodoResultado', this.periodoDashboard);
      },

      deep: true
    }
  },

  methods: {
    getParam: function getParam(filterName) {
      return this.gadget.gadgetParam.find(function (param) {
        return param.nome === filterName;
      });
    },
    setFilter: function setFilter(filterName, value) {
      var _this = this;

      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return;
      }

      var param = this.getParam(filterName);
      if (!param) {
        return;
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id;
        this.$store.dispatch('loadingData');
        this.$store.dispatch('setGadgetConfig', this.gadget).finally(function () {
          _this.$store.dispatch('dataLoaded');
        });
      }
    },
    setSelected: function setSelected(eventName, filterName) {
      var _this2 = this;

      return function (result) {
        if (result && result.id) {
          _this2.$store.dispatch(eventName, result);
          _this2.setFilter(filterName, result.id);
        }
      };
    }
  },

  created: function created() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(this.filters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var filter = _step.value;

        var param = this.getParam(filter.name);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(filter.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var option = _step2.value;

            option.__selected = param && param.valor === option.id;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
};

/***/ }),
/* 806 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/chartFilter/ConciliationSituationSummary.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _FiltersCommon = __webpack_require__(/*! ../filter/FiltersCommon */ 159);

var _FiltersCommon2 = _interopRequireDefault(_FiltersCommon);

var _graficoId = __webpack_require__(/*! ../../../enum/graficoId */ 103);

var _graficoId2 = _interopRequireDefault(_graficoId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConciliationSituationSummary',

  components: {
    FiltersCommon: _FiltersCommon2.default
  },

  data: function data() {
    return {
      gadget: this.$store.getters.availableGadgets.find(function (g) {
        return g.funcionalidade.idFuncionalidade === _graficoId2.default.RESUMO_SITUACAO_CONCILIACAO;
      }),
      filters: [{
        name: 'agrupamentoPlano',
        options: this.$store.getters.plansDashboard.map(function (plan) {
          return {
            id: plan.id,
            label: plan.nome
          };
        }),
        onChange: this.setSelected('setPlanSelectedFilterConcSitSummary', 'agrupamentoPlano'),
        order: 1
      }, {
        name: 'agrupamentoTipoMovimento',
        options: [{
          id: 'TD',
          label: this.$t('dashboard.filtro.tipo.T')
        }, {
          id: 'MF',
          label: this.$t('dashboard.filtro.tipo.MF')
        }, {
          id: 'MB',
          label: this.$t('dashboard.filtro.tipo.E')
        }],
        onChange: this.setSelected('setTypeFilterConcSitSummary', 'agrupamentoTipoMovimento'),
        order: 2
      }, {
        name: 'agrupamentoCategoriaPrincipal',
        options: [{
          id: 'TD',
          label: this.$t('dashboard.filtro.tipo.T')
        }].concat((0, _toConsumableArray3.default)(this.$store.getters.mainCategoriesDashboard.map(function (mainCategory) {
          return {
            id: mainCategory.id,
            label: mainCategory.number + ' - ' + mainCategory.description
          };
        }))),
        onChange: this.setSelected('setMainCategorySelectedFilterConcSitSummary', 'agrupamentoCategoriaPrincipal'),
        order: 3
      }]
    };
  },


  computed: {
    periodoDashboard: function periodoDashboard() {
      return this.$store.getters.periodFilterConcSitSummary;
    }
  },

  watch: {
    periodoDashboard: {
      handler: function handler() {
        this.setFilter('periodoResultado', this.periodoDashboard);
      },

      deep: true
    }
  },

  methods: {
    getParam: function getParam(filterName) {
      return this.gadget.gadgetParam.find(function (param) {
        return param.nome === filterName;
      });
    },
    setFilter: function setFilter(filterName, value) {
      var _this = this;

      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return;
      }

      var param = this.getParam(filterName);
      if (!param) {
        return;
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id;
        this.$store.dispatch('loadingData');
        this.$store.dispatch('setGadgetConfig', this.gadget).finally(function () {
          _this.$store.dispatch('dataLoaded');
        });
      }
    },
    setSelected: function setSelected(eventName, filterName) {
      var _this2 = this;

      return function (result) {
        if (result && result.id) {
          _this2.$store.dispatch(eventName, result);
          _this2.setFilter(filterName, result.id);
        }
      };
    }
  },

  created: function created() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(this.filters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var filter = _step.value;

        var param = this.getParam(filter.name);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(filter.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var option = _step2.value;

            option.__selected = param && param.valor === option.id;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
};

/***/ }),
/* 807 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/chartFilter/DailyBankStatment.vue ***!
  \***********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _FiltersCommon = __webpack_require__(/*! ../filter/FiltersCommon */ 159);

var _FiltersCommon2 = _interopRequireDefault(_FiltersCommon);

var _graficoId = __webpack_require__(/*! ../../../enum/graficoId */ 103);

var _graficoId2 = _interopRequireDefault(_graficoId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DailyBankStatment',

  components: {
    FiltersCommon: _FiltersCommon2.default
  },

  data: function data() {
    return {
      loaded: false,
      gadget: this.$store.getters.availableGadgets.find(function (g) {
        return g.funcionalidade.idFuncionalidade === _graficoId2.default.SALDO_BANCARIO;
      }),
      filters: [{
        name: 'agrupamentoConta',
        options: [],
        onChange: this.setSelected('setAccountSelectedBankBalance', 'agrupamentoConta'),
        hasGroups: true,
        order: 1,
        convertIdTo: function convertIdTo(id) {
          return Number(id);
        }
      }]
    };
  },


  computed: {
    periodoDashboard: function periodoDashboard() {
      return this.$store.getters.periodFilterBankBalance;
    }
  },

  watch: {
    periodoDashboard: {
      handler: function handler() {
        this.setFilter('periodoResultado', this.periodoDashboard);
      },

      deep: true
    }
  },

  methods: {
    setSelectFlags: function setSelectFlags() {
      var _this = this;

      var _loop = function _loop(filter) {
        var param = _this.getParam(filter.name);
        if (filter.hasGroups) {
          (function () {
            filter.convertIdTo = filter.convertIdTo || function (id) {
              return id;
            };
            var paramValue = param ? filter.convertIdTo(param.valor) : null;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(filter.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var group = _step2.value;

                if (paramValue === null) {
                  group.__selected = false;
                } else {
                  var index = group.options.findIndex(function (groupOption) {
                    return filter.convertIdTo(groupOption.id) === paramValue;
                  });
                  if (index === -1) {
                    group.__selected = false;
                  } else {
                    group.__selected = true;
                    group.options[index].__selected = true;
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          })();
        } else {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(filter.options), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var option = _step3.value;

              option.__selected = param && param.valor === option.id;
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.filters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var filter = _step.value;

          _loop(filter);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.loaded = true;
    },
    getParam: function getParam(filterName) {
      return this.gadget.gadgetParam.find(function (param) {
        return param.nome === filterName;
      });
    },
    setFilter: function setFilter(filterName, value) {
      var _this2 = this;

      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return;
      }

      var param = this.getParam(filterName);
      if (!param) {
        return;
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id;
        this.$store.dispatch('loadingData');
        this.$store.dispatch('cancelDashboardRequests');
        this.$store.dispatch('setGadgetConfig', this.gadget).finally(function () {
          _this2.$store.dispatch('dataLoaded');
        });
      }
    },
    setSelected: function setSelected(eventName, filterName) {
      var _this3 = this;

      return function (result) {
        if (result && result.id) {
          _this3.$store.dispatch(eventName, result);
          _this3.setFilter(filterName, result.id);
        }
      };
    },
    getAccounts: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response, accounts, groups;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch('getBankAccounts', '/dashboard/listBankAccounts');

              case 2:
                response = _context.sent;
                accounts = response.data.data.filter(function (bankAccount) {
                  return bankAccount.ativo;
                });
                _context.next = 6;
                return this.$store.dispatch('getEstablishmentGroups');

              case 6:
                groups = _context.sent;
                return _context.abrupt('return', [{
                  groupName: 'Grupos',
                  options: [{
                    id: '-1',
                    label: this.$t('dashboard.filtro.semAgrupamento'),
                    tipo: 'GRUPO'
                  }].concat((0, _toConsumableArray3.default)(groups.map(function (group) {
                    return {
                      id: group.id,
                      label: group.nome,
                      tipo: 'GRUPO'
                    };
                  })))
                }, {
                  groupName: 'Contas',
                  default: true,
                  options: [{
                    id: '0',
                    label: this.$t('dashboard.filtro.tipo.T'),
                    tipo: 'CONTA_BANCARIA'
                  }].concat((0, _toConsumableArray3.default)(accounts.map(function (account) {
                    return {
                      id: account.id,
                      label: account.banco.codigo + ' - ' + account.nome,
                      codigoBanco: account.banco.codigo,
                      nomeConta: account.nome,
                      tipo: 'CONTA_BANCARIA'
                    };
                  }).sort(function (a, b) {
                    if (a.codigoBanco > b.codigoBanco) {
                      return 1;
                    }
                    if (a.codigoBanco < b.codigoBanco) {
                      return -1;
                    }

                    return a.nomeConta.localeCompare(b.nomeConta);
                  })))
                }]);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAccounts() {
        return _ref.apply(this, arguments);
      }

      return getAccounts;
    }()
  },

  created: function created() {
    var self = this;
    this.getAccounts().then(function (accounts) {
      var accountFilter = self.filters.find(function (filter) {
        return filter.name === 'agrupamentoConta';
      });
      accountFilter.options = accounts;
      self.setSelectFlags();
    });
  }
};

/***/ }),
/* 808 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/chartFilter/DigitalWalletBalance.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _FiltersCommon = __webpack_require__(/*! ../filter/FiltersCommon */ 159);

var _FiltersCommon2 = _interopRequireDefault(_FiltersCommon);

var _graficoId = __webpack_require__(/*! ../../../enum/graficoId */ 103);

var _graficoId2 = _interopRequireDefault(_graficoId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DigitalWalletBalance',

  components: {
    FiltersCommon: _FiltersCommon2.default
  },

  data: function data() {
    return {
      loaded: false,
      gadget: this.$store.getters.availableGadgets.find(function (g) {
        return g.funcionalidade.idFuncionalidade === _graficoId2.default.SALDO_CARTEIRA_DIGITAL;
      }),
      filters: [{
        name: 'agrupamentoCategoria',
        options: [],
        onChange: this.setSelected('setCategorySelectedDigitalWalletBalance', 'agrupamentoCategoria'),
        order: 1,
        convertIdTo: function convertIdTo(id) {
          return Number(id);
        }
      }]
    };
  },


  computed: {
    periodoDashboard: function periodoDashboard() {
      return this.$store.getters.periodFilterDigitalWalletBalance;
    }
  },

  watch: {
    periodoDashboard: {
      handler: function handler() {
        this.setFilter('periodoResultado', this.periodoDashboard);
      },

      deep: true
    }
  },

  methods: {
    setSelectFlags: function setSelectFlags() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.filters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var filter = _step.value;

          var param = this.getParam(filter.name);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(filter.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var option = _step2.value;

              option.__selected = param && param.valor === option.id;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.loaded = true;
    },
    getParam: function getParam(filterName) {
      return this.gadget.gadgetParam.find(function (param) {
        return param.nome === filterName;
      });
    },
    setFilter: function setFilter(filterName, value) {
      var _this = this;

      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return;
      }

      var param = this.getParam(filterName);
      if (!param) {
        return;
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id;
        this.$store.dispatch('loadingData');
        this.$store.dispatch('cancelDashboardRequests');
        this.$store.dispatch('setGadgetConfig', this.gadget).finally(function () {
          _this.$store.dispatch('dataLoaded');
        });
      }
    },
    setSelected: function setSelected(eventName, filterName) {
      var _this2 = this;

      return function (result) {
        if (result && result.id) {
          _this2.$store.dispatch(eventName, result);
          _this2.setFilter(filterName, result.id);
        }
      };
    },
    getCategories: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var response, categories;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch('getCategories', {
                  url: '/dashboard/loadCategories',
                  flTipoCategoria: 'W',
                  validarUso: false
                });

              case 2:
                response = _context.sent;
                categories = response.data;
                return _context.abrupt('return', [{
                  id: 'TD',
                  label: this.$t('dashboard.filtro.tipo.T')
                }].concat((0, _toConsumableArray3.default)(categories.map(function (category) {
                  return {
                    id: category.id,
                    label: category.numero + ' - ' + category.nome,
                    numero: category.numero,
                    nome: category.nome
                  };
                }).sort(function (a, b) {
                  if (a.numero > b.numero) {
                    return 1;
                  }
                  if (a.numero < b.numero) {
                    return -1;
                  }

                  return a.nome.localeCompare(b.nome);
                }))));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCategories() {
        return _ref.apply(this, arguments);
      }

      return getCategories;
    }()
  },

  created: function created() {
    var self = this;
    this.getCategories().then(function (categories) {
      var categoryFilter = self.filters.find(function (filter) {
        return filter.name === 'agrupamentoCategoria';
      });
      categoryFilter.options = categories;
      self.setSelectFlags();
    });
  }
};

/***/ }),
/* 809 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/chartFilter/FinancialSummary.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _FiltersCommon = __webpack_require__(/*! ../filter/FiltersCommon */ 159);

var _FiltersCommon2 = _interopRequireDefault(_FiltersCommon);

var _graficoId = __webpack_require__(/*! ../../../enum/graficoId */ 103);

var _graficoId2 = _interopRequireDefault(_graficoId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'FinancialSummary',

  components: {
    FiltersCommon: _FiltersCommon2.default
  },

  data: function data() {
    return {
      gadget: this.$store.getters.availableGadgets.find(function (g) {
        return g.funcionalidade.idFuncionalidade === _graficoId2.default.RESUMO_FINANCEIRO_PLANO_CONCILIACAO;
      }),
      filters: [{
        name: 'agrupamentoCategoriaPrincipal',
        options: [{
          id: 'TD',
          label: this.$t('dashboard.filtro.tipo.T')
        }].concat((0, _toConsumableArray3.default)(this.$store.getters.mainCategoriesDashboard.map(function (mainCategory) {
          return {
            id: mainCategory.id,
            label: mainCategory.number + ' - ' + mainCategory.description
          };
        }))),
        onChange: this.setSelected('setMainCategorySelectedFinancialSummary', 'agrupamentoCategoriaPrincipal'),
        order: 1
      }]
    };
  },


  computed: {
    periodoDashboard: function periodoDashboard() {
      return this.$store.getters.periodFilterFinancialSummary;
    }
  },

  watch: {
    periodoDashboard: {
      handler: function handler() {
        this.setFilter('periodoResultado', this.periodoDashboard);
      },

      deep: true
    }
  },

  methods: {
    getParam: function getParam(filterName) {
      return this.gadget.gadgetParam.find(function (param) {
        return param.nome === filterName;
      });
    },
    setFilter: function setFilter(filterName, value) {
      var _this = this;

      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return;
      }

      var param = this.getParam(filterName);
      if (!param) {
        return;
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id;
        this.$store.dispatch('loadingData');
        this.$store.dispatch('setGadgetConfig', this.gadget).finally(function () {
          _this.$store.dispatch('dataLoaded');
        });
      }
    },
    setSelected: function setSelected(eventName, filterName) {
      var _this2 = this;

      return function (result) {
        if (result && result.id) {
          _this2.$store.dispatch(eventName, result);
          _this2.setFilter(filterName, result.id);
        }
      };
    }
  },

  created: function created() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(this.filters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var filter = _step.value;

        var param = this.getParam(filter.name);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(filter.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var option = _step2.value;

            option.__selected = param && param.valor === option.id;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
};

/***/ }),
/* 810 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/filter/FilterCommon.vue ***!
  \*************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'FiltersCommon',

  props: {
    options: {
      type: Array,
      required: true
    },
    onChange: {
      type: Function,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    hasGroups: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      hasData: false,
      shown: false,
      selected: {},
      disabled: false,
      disabledText: this.$t('dashboard.filtro.semOpcoes'),
      element: null,
      selectedTextElement: null
    };
  },


  methods: {
    select: function select(selected) {
      selected.__selected = true;
      this.selected.__selected = false;
      this.selected = selected;
      this.onChange(selected);
      this.close();
    },
    getDisplayOptions: function getDisplayOptions(group) {
      if (group) {
        return group.options.filter(function (option) {
          return !option.__selected;
        }).sort();
      }
      return this.options.filter(function (option) {
        return !option.__selected;
      }).sort();
    },
    getSelected: function getSelected() {
      var selected = void 0;

      if (this.hasGroups) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var group = _step.value;

            if (group.__selected) {
              selected = group.options.find(function (option) {
                return option.__selected;
              });
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (!selected) {
          selected = this.options.find(function (group) {
            return group.default;
          }).options[0];
        }
      } else {
        selected = this.options.find(function (option) {
          return option.__selected;
        }) || this.options[0];
      }

      selected.__selected = true;
      this.onChange(selected);
      return selected;
    },
    getTitle: function getTitle(label) {
      var title = this.disabled ? this.disabledText : label;

      if (!this.element) {
        return title;
      }

      if (!this.selectedTextElement) {
        var span = this.element.getElementsByClassName('filter-common-selected-text');
        if (!span) {
          return title;
        }
        this.selectedTextElement = span[0];
      }

      if (this.selectedTextElement.offsetWidth < this.selectedTextElement.scrollWidth) {
        if (this.disabled) {
          return label + '\n\n' + title;
        }
        return title;
      }

      return this.disabled ? this.disabledText : '';
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.shown = !this.shown;
      }
    },
    close: function close() {
      this.shown = false;
    }
  },

  mounted: function mounted() {
    this.element = this.$el;

    this.element.style.maxWidth = 'calc(' + Math.floor(100 / this.quantity) + '% - 15px)';
  },
  created: function created() {
    if (this.options.length > 0) {
      this.selected = this.getSelected();
      this.hasData = true;
    }
    this.disabled = this.options.length === 1;
  }
};

/***/ }),
/* 811 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/filter/FiltersCommon.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FilterCommon = __webpack_require__(/*! ./FilterCommon */ 1268);

var _FilterCommon2 = _interopRequireDefault(_FilterCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'FiltersCommon',

  components: {
    FilterCommon: _FilterCommon2.default
  },

  props: {
    data: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      quantity: this.data.filter(function (d) {
        return d.options.length > 0;
      }).length,
      sortedData: this.data.sort(function (a, b) {
        return a.order - b.order;
      })
    };
  }
};

/***/ }),
/* 812 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/gadget/TaskGadget.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _TaskGadgetTabContent = __webpack_require__(/*! ./TaskGadgetTabContent */ 1270);

var _TaskGadgetTabContent2 = _interopRequireDefault(_TaskGadgetTabContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TaskGadget',

  components: {
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    TaskGadgetTabContent: _TaskGadgetTabContent2.default
  },

  props: {
    data: {
      type: Object
    },
    isLoadingDataTaskGadget: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      hasData: {
        tarefasPendentes: typeof this.data.quantidadePendenteMovFin === 'number' && typeof this.data.quantidadePendenteMovBan === 'number' && typeof this.data.totalQuantidadePendente === 'number',
        tarefasConciliadas: typeof this.data.quantidadeConcluidaMovFin === 'number' && typeof this.data.quantidadeConcluidaMovBan === 'number' && typeof this.data.totalQuantidadeConcluida === 'number'
      }
    };
  }
};

/***/ }),
/* 813 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/dashboard/gadget/TaskGadgetTabContent.vue ***!
  \*********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _idSituacaoTarefa = __webpack_require__(/*! ../../../enum/idSituacaoTarefa */ 200);

var _idSituacaoTarefa2 = _interopRequireDefault(_idSituacaoTarefa);

var _tipoFiltroSituacaoTarefas = __webpack_require__(/*! ../../../enum/tipoFiltroSituacaoTarefas */ 314);

var _tipoFiltroSituacaoTarefas2 = _interopRequireDefault(_tipoFiltroSituacaoTarefas);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TaskGadgetTabContent',

  props: {
    data: {
      type: Object
    },
    quantidadeMovFin: {
      type: Number,
      required: true
    },
    quantidadeMovBan: {
      type: Number,
      required: true
    },
    totalQuantidade: {
      type: Number,
      required: true
    },
    isPendentTab: {
      type: Boolean
    }
  },

  data: function data() {
    return {
      naoConcluido: [_idSituacaoTarefa2.default.PENDENTE, _idSituacaoTarefa2.default.EM_ANDAMENTO, _idSituacaoTarefa2.default.AGUARDANDO],
      concluido: [_idSituacaoTarefa2.default.CONCLUIDO],
      tipoNaoConcluido: _tipoFiltroSituacaoTarefas2.default.NC,
      tipoConcluido: _tipoFiltroSituacaoTarefas2.default.C
    };
  },


  methods: {
    getTextNextExpiration: function getTextNextExpiration() {
      if (!this.data || !this.data.dataProximoVencimento) {
        return this.$t('estatistica.tarefa.labels.semDataProximoVencimento');
      }

      return this.$t('estatistica.tarefa.labels.dataProximoVencimento') + ' <b>' + this.data.dataProximoVencimento + '</b>.';
    },
    redirectToTasks: function redirectToTasks(situations, type) {
      var _this = this;

      var arraySituations = situations.split(',').map(function (situation) {
        return Number(situation);
      });
      var typeFilter = {
        arraySituations: arraySituations,
        type: type,
        dateFirstDue: this.data && this.data.dataPrimeiroVencimento ? this.data.dataPrimeiroVencimento : null,
        fromDashboard: true
      };
      if (arraySituations && arraySituations.length > 0) {
        this.$store.dispatch('setFilterTasksList', typeFilter).then(function () {
          _this.$router.push(_routesMap2.default.LIST_ASSIGNMENT);
        });
      } else {
        self.$root.$refs.notification.error('GENERAL');
      }
    }
  }
};

/***/ }),
/* 814 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/form/formSearch/FormSearch.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonSearch = __webpack_require__(/*! ../../buttons/buttonSearch/ButtonSearch */ 1258);

var _ButtonSearch2 = _interopRequireDefault(_ButtonSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'FormSearch',

  components: {
    ButtonSearch: _ButtonSearch2.default
  },

  props: {
    fn: {
      type: Function,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
    getMessages: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    interval: {
      type: Number,
      default: 2500
    },
    hasExportFile: {
      type: Boolean,
      required: true
    },
    exportFileFlag: {
      type: Boolean
    },
    showLoadingFullPage: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isExporting: this.exportFileFlag,
      color: { checked: '#40b9bb', unchecked: '#E5E5E5' }
    };
  },


  methods: {
    send: function send() {
      var _this = this;

      if (!this.showLoadingFullPage) {
        this.fn();
        return;
      }

      var params = {
        messages: this.getMessages(),
        interval: this.interval
      };
      this.$store.dispatch('loadingFullPage', params);
      this.fn().finally(function () {
        _this.$store.dispatch('fullPageLoaded');
      });
    }
  }
};

/***/ }),
/* 815 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/input/betterInputTag/BetterInputTag.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ 322);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(/*! ../../../utils/helpers */ 318);

var _keyCode = __webpack_require__(/*! ../../../enum/keyCode */ 747);

var _keyCode2 = _interopRequireDefault(_keyCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BetterInputTag',

  props: {
    defaultTagsIfEmpty: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    typeable: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    props: {
      type: Object,
      default: function _default() {
        return {
          id: 'id',
          name: 'name'
        };
      }
    },
    typeOnly: {
      type: Boolean,
      default: false
    },
    typeOnlyOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fnGetDataFromServer: {
      type: Function,
      default: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt('return', _promise2.default.resolve([]));

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined);
        }));

        function _default() {
          return _ref.apply(this, arguments);
        }

        return _default;
      }()
    },
    possibleTagsSearchTexts: {
      type: Object,
      default: function _default() {
        return {
          noResult: 'geral.labels.semResultadosSingular',
          empty: 'geral.labels.listaVazia'
        };
      }
    },
    placeHolders: {
      type: Object,
      default: function _default() {
        return {
          input: 'estabelecimentos.labels.filtro.buscar'
        };
      }
    },
    disableInput: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      eventTypes: {
        SEARCH: 0,
        TYPE_TO_START_SEARCHING: 1,
        NOOP: 2,
        SHOW_EMPTY_LIST: 3
      },
      currentMaxWidth: 80,
      tag: '',
      input: null,
      inputExists: this.typeable && !this.readOnly,
      paddingClass: this.readOnly || !this.disableInput ? 'full-padding' : 'left-padding',
      showingPossibilities: false,
      highlightedIndex: 0,
      possibilities: [],
      selectedEveryThing: false,
      debounce: _helpers.debounce.apply(this)
    };
  },


  computed: {
    expandedMenu: function expandedMenu() {
      return this.$store.getters.expandedMenu;
    }
  },

  watch: {
    tags: {
      handler: function handler() {
        this.resetInputWidth();
      },

      deep: true
    },
    expandedMenu: function expandedMenu() {
      this.resetInputWidth(200);
    }
  },

  methods: {
    boxClicked: function boxClicked(_ref2) {
      var target = _ref2.target;

      if (!this.inputExists) {
        return;
      }

      var inputs = target.getElementsByTagName('input');
      var input = null;

      if (inputs !== null) {
        input = inputs[0];
      }

      if (this.input === null && input !== null) {
        this.input = input;
      }

      this.input.focus();
    },
    handleKey: function handleKey(evt) {
      if (!this.inputExists) {
        return;
      }

      if (this.typeOnly) {
        this.handleTypeOnly(evt);
        return;
      }

      var nextEvent = this.handleInteraction(evt);

      if (nextEvent === this.eventTypes.SEARCH) {
        this.handleDataFromServer();
      } else if (nextEvent === this.eventTypes.TYPE_TO_START_SEARCHING) {
        this.possibilities = this.getStartToType();
      } else if (nextEvent === this.eventTypes.SHOW_EMPTY_LIST) {
        this.possibilities = this.getEmptyList();
      }
    },
    handleTypeOnly: function handleTypeOnly(evt) {
      var _tag;

      var tag = (_tag = {}, (0, _defineProperty3.default)(_tag, this.props.name, this.tag), (0, _defineProperty3.default)(_tag, this.props.id, this.tag), _tag);

      if (this.tag) {
        var toAdd = false;
        if ([_keyCode2.default.TAB, _keyCode2.default.ENTER, _keyCode2.default.BACKSPACE].includes(evt.keyCode)) {
          toAdd = true;
        } else if (this.typeOnlyOptions.isNumericOnly && evt.keyCode === _keyCode2.default.SPACE_BAR) {
          toAdd = true;
        }

        if (toAdd) {
          evt.preventDefault();
          this.addTag(tag);
          this.input.focus();
        }
      } else if (!this.tag && evt.keyCode === _keyCode2.default.BACKSPACE) {
        this.removeTag(this.tags.length - 1);
      }
    },
    getStartToType: function getStartToType() {
      var _ref3;

      return [(_ref3 = {}, (0, _defineProperty3.default)(_ref3, this.props.name, this.$t('geral.labels.digiteParaPesquisar')), (0, _defineProperty3.default)(_ref3, '__blocked', true), _ref3)];
    },
    handleDataFromServer: function handleDataFromServer() {
      var _ref4;

      if (!this.tag) {
        this.possibilities = this.getStartToType();
        return;
      }

      this.possibilities = [(_ref4 = {}, (0, _defineProperty3.default)(_ref4, this.props.name, this.$t('geral.labels.carregando')), (0, _defineProperty3.default)(_ref4, '__blocked', true), _ref4)];

      this.showPossibilities();

      this.debounce(this.getDataFromServer, 250);
    },
    getDataFromServer: function getDataFromServer() {
      var _this = this;

      if (this.typeOnly) {
        return;
      }
      this.fnGetDataFromServer(this.tag, this.tags).then(function (response) {
        if (response.length === 0) {
          _this.possibilities = _this.getEmptyList();
        } else {
          _this.highlightedIndex = 0;
          _this.possibilities = response;
        }
        _this.updateListOfPossibilitiesMargin();
      }).catch(function (e) {
        if (e.message !== 'user.cancelled') {
          _this.$root.$refs.notification.error(e.message);
        }
      });
    },
    handleInteraction: function handleInteraction(evt) {
      if (evt.keyCode === _keyCode2.default.BACKSPACE) {
        if (!this.tag) {
          this.removeTag(this.tags.length - 1);
          return this.eventTypes.TYPE_TO_START_SEARCHING;
        }

        if (this.selectedEveryThing) {
          this.selectedEveryThing = false;
          return this.eventTypes.TYPE_TO_START_SEARCHING;
        }

        evt.preventDefault();

        if (evt.ctrlKey) {
          this.tag = '';
          return this.eventTypes.TYPE_TO_START_SEARCHING;
        }

        this.tag = this.tag.substring(0, this.tag.length - 1);
        return this.eventTypes.SEARCH;
      }

      if (evt.ctrlKey) {
        if (evt.keyCode === _keyCode2.default.A) {
          this.selectedEveryThing = true;
        }
        return this.eventTypes.NOOP;
      }

      evt.preventDefault();

      if (evt.key.length === 1) {
        if (this.selectedEveryThing) {
          this.tag = evt.key;
        } else {
          this.tag += evt.key;
        }
        this.selectedEveryThing = false;
        return this.eventTypes.SEARCH;
      }

      this.selectedEveryThing = false;

      if (evt.keyCode === _keyCode2.default.ENTER) {
        this.addTag(this.possibilities[this.highlightedIndex]);
        return this.eventTypes.TYPE_TO_START_SEARCHING;
      }

      if ([_keyCode2.default.ARROW_UP, _keyCode2.default.ARROW_DOWN].includes(evt.keyCode)) {
        this.highlightedIndex += evt.keyCode === _keyCode2.default.ARROW_UP ? -1 : 1;

        if (this.highlightedIndex < 0) {
          this.highlightedIndex = 0;
        } else if (this.possibilities.length === 1 && this.possibilities[0].__blocked) {
          this.highlightedIndex = -1;
        } else if (this.highlightedIndex >= this.possibilities.length) {
          this.highlightedIndex = this.possibilities.length - 1;
        }
        return this.eventTypes.NOOP;
      }
      return this.eventTypes.SEARCH;
    },
    handleMouse: function handleMouse(tag, index) {
      if (!tag.__blocked) {
        this.highlightedIndex = index;
      }
    },
    addTag: function addTag(tag) {
      var _this2 = this;

      if (!tag) {
        return;
      }

      if (tag.__blocked) {
        this.possibilities = this.getStartToType();
        return;
      }

      this.showingPossibilities = false;

      this.input.blur();

      var index = -1;
      if (this.typeOnly) {
        index = this.tags.findIndex(function (added) {
          return added[_this2.props.id] === tag[_this2.props.id];
        });
      } else {
        index = this.tags.lastIndexOf(tag);
      }

      if (index === -1) {
        if (!this.validateTypeOnly(tag[this.props.name])) {
          return;
        }
        this.possibilities = [];
        this.tags.push(tag);
        this.highlightedIndex = -1;
      }
      this.$emit('update:tags', this.tags);
    },
    removeTag: function removeTag(index) {
      this.tags.splice(index, 1);
      this.$emit('update:tags', this.tags);
      this.tag = '';
      this.possibilities = [];
    },
    validateTypeOnly: function validateTypeOnly(value) {
      if (this.typeOnlyOptions.isNumericOnly) {
        return (/^\d+$/.test(value)
        );
      }
      return true;
    },
    resetInputWidth: function resetInputWidth() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!this.inputExists) {
        return;
      }
      this.input.style.width = '55px';
      this.$nextTick(function () {
        setTimeout(function () {
          var width = _this3.input.parentElement.clientWidth - _this3.input.offsetLeft - 10 + 'px';
          _this3.input.style.width = width;
          _this3.updateListOfPossibilitiesMargin();
        }, delay);
      });
    },
    getEmptyList: function getEmptyList() {
      var possibility = {
        __blocked: true
      };

      var name = void 0;
      if (this.tag) {
        name = this.$t(this.possibleTagsSearchTexts.noResult);
      } else {
        name = this.$t(this.possibleTagsSearchTexts.empty);
      }

      possibility[this.props.name] = name;
      return [possibility];
    },
    showPossibilities: function showPossibilities() {
      var _this4 = this;

      if (this.typeOnly) {
        return;
      }
      this.showingPossibilities = true;
      this.$nextTick(function () {
        if (_this4.possibilities.length === 0 && _this4.tag === '') {
          _this4.possibilities = _this4.getStartToType();
        }
        _this4.updateListOfPossibilitiesMargin();
      });
    },
    updateListOfPossibilitiesMargin: function updateListOfPossibilitiesMargin() {
      var divListOfPossibilities = this.getDivListOfPossibilities();

      if (divListOfPossibilities) {
        var height = divListOfPossibilities.parentElement.clientHeight;
        divListOfPossibilities.style.marginTop = height + 'px';
      }
    },
    getDivListOfPossibilities: function getDivListOfPossibilities() {
      var listDivsListOfPossibilities = this.$el.getElementsByClassName('possibilities-list');
      var divListOfPossibilities = void 0;
      if (listDivsListOfPossibilities) {
        divListOfPossibilities = listDivsListOfPossibilities[0];
      }
      return divListOfPossibilities;
    },
    close: function close() {
      if (this.typeOnly) {
        if (this.tag) {
          var _addTag;

          this.addTag((_addTag = {}, (0, _defineProperty3.default)(_addTag, this.props.name, this.tag), (0, _defineProperty3.default)(_addTag, this.props.id, this.tag), _addTag));
        }
      } else {
        this.showingPossibilities = false;
        this.possibilities = this.getStartToType();
      }
      this.tag = '';
    }
  },

  mounted: function mounted() {
    var _this5 = this;

    if (!this.inputExists) {
      return;
    }

    this.input = new XPathEvaluator().createExpression('div/input').evaluate(this.$el, XPathResult.FIRST_ORDERED_NODE_TYPE).singleNodeValue;

    window.addEventListener('resize', function () {
      _this5.resetInputWidth(200);
    });
  }
};

/***/ }),
/* 816 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/input/dateRange/DateRange.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _customValidator = __webpack_require__(/*! ../../../utils/customValidator.js */ 106);

var _customValidator2 = _interopRequireDefault(_customValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DateRange',

  components: {
    Datepicker: _vuejsDatepicker2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    value: {
      type: Object
    },
    initialFromDate: {
      type: Date
    },
    initialToDate: {
      type: Date
    },
    maxRange: {
      type: Number
    },
    customPeriodMessage: {
      type: String,
      default: null
    },
    customDatesMessage: {
      type: String,
      default: null
    },
    finalDateDisableFrom: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    disableDateRange: {
      type: Boolean,
      default: false
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    displayAction: {
      type: Boolean,
      default: false
    },
    action: {
      type: Function,
      default: null
    }
  },

  data: function data() {
    return {
      clients: [],
      idioma: _index2.default,
      fromDate: this.initialFromDate,
      toDate: this.initialToDate,
      message: null,
      invalid: false,
      inputFrom: null,
      inputTo: null
    };
  },


  computed: {
    datePickerLanguage: function datePickerLanguage() {
      return this.idioma.getDatePickerLanguageObject();
    },
    errorMessage: function errorMessage() {
      return this.message;
    },
    isInvalid: function isInvalid() {
      return this.invalid;
    },
    endDateDisableFrom: function endDateDisableFrom() {
      return this.finalDateDisableFrom ? this.finalDateDisableFrom : new Date();
    }
  },

  methods: {
    input: function input() {
      this.invalid = !this.validate();

      this.$emit('input', {
        fromDate: this.resetHours(this.fromDate, false),
        toDate: this.resetHours(this.toDate, true),
        invalid: this.invalid
      });
    },
    validate: function validate() {
      if (!this.isDateValid(this.inputFrom)) {
        this.fromDate = this.initialFromDate;
      }

      if (!this.isDateValid(this.inputTo)) {
        this.toDate = this.initialToDate;
      }

      this.fromDate = new Date(this.resetHours(this.fromDate, false));
      this.toDate = new Date(this.resetHours(this.toDate, true));

      var isDateRangeValid = true;
      var timeDiff = Math.abs(this.fromDate.getTime() - this.toDate.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      if (diffDays > this.maxRange) {
        this.message = this.$t('dateRange.validacao.periodoMaximo', { dias: this.maxRange });
        isDateRangeValid = false;
      }

      if (this.fromDate > this.toDate) {
        this.message = this.$t('dateRange.validacao.dataInicialMaiorFinal');
        isDateRangeValid = false;
      }
      return isDateRangeValid;
    },
    isDateValid: function isDateValid(input) {
      return input.value.length === 10 && _customValidator2.default.isValidDate(input.value);
    },
    resetHours: function resetHours(date, endOfTheDay) {
      if (typeof date === 'number') {
        date = new Date(date);
      }

      if (endOfTheDay) {
        return date.setHours(23, 59, 59, 999);
      }
      return date.setHours(0, 0, 0, 0);
    }
  },

  created: function created() {
    this.fromDate = this.initialFromDate;
    this.toDate = this.initialToDate;

    this.$emit('input', {
      fromDate: this.resetHours(this.fromDate, false),
      toDate: this.resetHours(this.toDate, true),
      invalid: this.invalid
    });
  },
  mounted: function mounted() {
    this.inputFrom = document.getElementById('datePickerFromDate');
    this.inputFrom.setAttribute('autocomplete', 'off');

    this.inputTo = document.getElementById('datePickerToDate');
    this.inputTo.setAttribute('autocomplete', 'off');
  }
};

/***/ }),
/* 817 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/input/dynamicInput/DynamicInput.vue ***!
  \***************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vueTheMask = __webpack_require__(/*! vue-the-mask */ 133);

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DynamicInput',

  components: {
    vSelect: _vueSelect2.default,
    TheMask: _vueTheMask.TheMask,
    Datepicker: _vuejsDatepicker2.default
  },

  props: {
    inputName: {
      type: String,
      required: true
    },

    inputTag: {
      type: String,
      required: true
    },

    inputType: {
      type: String,
      required: true
    },

    inputValue: {
      required: true
    },

    inputMask: {
      type: String
    },

    inputValidator: {
      type: String
    },

    inputTipoValores: {
      type: Array
    }
  },

  data: function data() {
    return {
      invalid: false,

      inputMaskModel: null,
      inputValueSelect: null,

      instantValue: null,

      inputDate: null,

      message: null,
      toDate: new Date('December 31, 1999 23:59:59'),
      fromDate: new Date('December 31, 2999 23:59:59')
    };
  },


  computed: {
    datePickerLanguage: function datePickerLanguage() {
      return _index2.default.getDatePickerLanguageObject();
    },
    defineInput: function defineInput() {
      if (this.inputType === 'STRING' && !this.inputMask) {
        return 1;
      } else if (this.inputType === 'NUMBER' && !this.inputMask) {
        return 2;
      } else if (this.inputType === 'DATE') {
        return 3;
      } else if (this.inputType === 'COMBO') {
        return 4;
      } else {
        return 0;
      }
    },
    defineId: function defineId() {
      if (this.inputType === 'STRING' && !this.inputMask) {
        return 'dynamicInputItem' + this.inputTag;
      } else if (this.inputType === 'NUMBER' && !this.inputMask) {
        return 'dynamicInputNumberItem' + this.inputTag;
      } else if (this.inputType === 'DATE') {
        return 'dynamicPickerDate' + this.inputTag;
      } else if (this.inputType === 'COMBO') {
        return 'dynamicSelectItem' + this.inputTag;
      } else {
        return 'dynamicMaskedItem' + this.inputTag;
      }
    }
  },

  methods: {
    trackEvent: function trackEvent(e) {
      (0, _analytics.trackAnalyticsEvent)(this, 'dynamic-input', 'on-input-event', e.currentTarget.id);
    },
    validateDate: function validateDate() {
      return this.inputDate !== null;
    },
    isInputInvalid: function isInputInvalid() {
      if (this.inputValidator && this.inputValue) {
        var regexp = new RegExp(this.inputValidator);
        if (!regexp.test(this.inputValue)) {
          this.message = this.$t('estabelecimentos.erro.atributoValidacaoFail');
          return true;
        }
      }
      this.message = null;
      return false;
    }
  },

  mounted: function mounted() {
    var _this = this;

    var currentInput = document.getElementById(this.defineId);
    if (currentInput) {
      if (this.inputType === 'STRING' || this.inputType === 'NUMBER') {
        currentInput.addEventListener('blur', function () {
          _this.invalid = _this.isInputInvalid();
          _this.$emit('input-invalid', _this.invalid);
        });
      } else if (this.inputType === 'COMBO') {
        this.inputValueSelect = this.inputValue ? this.inputValue : this.$t('validacao.select.placeholder');
      }
      if (this.defineInput === 0) {
        this.inputMaskModel = this.inputValue;
      }

      if (this.inputType === 'DATE') {
        this.inputDate = this.inputValue || null;
        currentInput.classList.remove('date-picker');
        currentInput.style.border = 'none';
        currentInput.style.height = '28px';
        currentInput.style.width = '90%';
        currentInput.setAttribute('autocomplete', 'off');
        currentInput.addEventListener('blur', function () {
          _this.validateDate();
        });
      }
    }

    if (this.inputTipoValores && this.inputTipoValores.length > 0) {
      this.inputTipoValores.unshift({ valor: this.$t('validacao.select.placeholder') });
    }
  }
};

/***/ }),
/* 818 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/input/inputEstablishment/InputEstablishment.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _MultiSelectModal = __webpack_require__(/*! ../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _BetterInputTag = __webpack_require__(/*! ../betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _LoadingPlaceholder = __webpack_require__(/*! ../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _stringUtils = __webpack_require__(/*! ../../../utils/stringUtils.js */ 319);

var _looseDeepEqual = __webpack_require__(/*! ../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'InputEstablishment',

  components: {
    vSelect: _vueSelect2.default,
    MultiSelectModal: _MultiSelectModal2.default,
    BetterInputTag: _BetterInputTag2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    LoadingPlaceholder: _LoadingPlaceholder2.default
  },

  props: {
    id: {
      type: String,
      required: true
    },
    urls: {
      type: Object,
      required: true
    },
    selectedItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      noop: null,
      DEFAULT_COLUMNS: ['nome', 'cnpj', 'grupo'],
      selectedAttributesHolder: [],
      templateHolder: {},
      currentInputState: false,
      shown: false,
      icon: 'fa fa-spinner fa-spin',
      canShowModal: false,
      attributesList: [],
      dynamicColumns: [],
      establishments: {
        titles: {
          main: this.$t('movimentosFinanceiros.titulos.modalEstabelecimentoTitulo'),
          sub: this.$t('movimentosFinanceiros.titulos.modalEstabelecimentoSubtitulo')
        },
        unselectedItems: [],
        selectedItems: this.selectedItems,
        columns: ['nome', 'cnpj', 'grupo'],
        values: [],
        options: {
          columnsClasses: { nome: 'col-md-6', cnpj: 'col-md-3', grupo: 'col-md-3' },
          perPage: 5,
          headings: {
            nome: this.$t('administracao.operadores.labels.nome'),
            cnpj: this.$t('estabelecimentos.labels.cnpj'),
            grupo: this.$t('estabelecimentos.labels.grupoDeEstabelecimentos')
          },
          filterable: ['nome', 'cnpj', 'grupo'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['nome', 'cnpj', 'grupo'],
          sortIcon: {
            is: ''
          },
          responseAdapter: function (data) {
            for (var key in this.templateHolder) {
              this.establishments.options.templates[key] = this.templateHolder[key];
            }

            this.establishments.values = data.elements;

            this.updateColumns(this.selectedAttributesHolder);

            return {
              data: data.elements,
              count: data.totalElements
            };
          }.bind(this),
          requestFunction: function (pagination) {
            for (var key in this.establishments.options.templates) {
              if (this.establishments.options.templates[key].name === _LoadingPlaceholder2.default.name) {
                continue;
              }
              this.templateHolder[key] = this.establishments.options.templates[key];
              this.establishments.options.templates[key] = _LoadingPlaceholder2.default;
            }

            return this.$store.dispatch('getEstablishments', this.mountFilters(pagination));
          }.bind(this),
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'nome'
          },
          customSorting: {
            nome: function nome(asc) {
              return function (a, b) {
                if (asc) {
                  return (0, _stringUtils.compareStrings)(a.nome, b.nome);
                }
                return (0, _stringUtils.compareStrings)(b.nome, a.nome);
              };
            },
            cnpj: function cnpj(asc) {
              return function (a, b) {
                if (asc) {
                  return (0, _stringUtils.compareStrings)(a.cnpj, b.cnpj);
                }
                return (0, _stringUtils.compareStrings)(b.cnpj, a.cnpj);
              };
            },
            grupo: function grupo(asc) {
              return function (a, b) {
                if (asc) {
                  return (0, _stringUtils.compareStrings)(a.grupo.nome, b.grupo.nome);
                }
                return (0, _stringUtils.compareStrings)(b.grupo.nome, a.grupo.nome);
              };
            }
          },
          templates: {
            nome: function nome(h, row) {
              return row.nome;
            },
            cnpj: function cnpj(h, row) {
              return row.cnpj ? row.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5') : '-';
            },
            grupo: function grupo(h, row) {
              return row.grupo.nome;
            }
          }
        }
      },
      defaultTags: [{
        id: '-1',
        nome: this.$t('inputTag.labels.todos')
      }],
      inputTagsProps: {
        id: 'id',
        name: 'nome'
      },
      possibleTagsSearchTexts: {
        noResult: 'estabelecimentos.labels.filtro.semResultado',
        empty: 'estabelecimentos.labels.filtro.listaVazia'
      }
    };
  },


  watch: {
    'establishments.selectedItems': {
      handler: function handler() {
        this.$emit('update:establishments', this.establishments.selectedItems);
      },

      deep: true
    },
    selectedItems: {
      handler: function handler(newVal, oldVal) {
        if (!(0, _looseDeepEqual2.default)(oldVal, newVal)) {
          this.establishments.selectedItems = [].concat((0, _toConsumableArray3.default)(newVal));
        }
      },

      deep: true
    }
  },

  methods: {
    closeModal: function closeModal() {
      if (!this.currentInputState) {
        this.focusOnModal();
        this.shown = false;
      }
    },
    open: function open() {
      this.shown = this.canShowModal;
    },
    mountFilters: function mountFilters(pagination) {
      var filters = {};
      var atributosValores = [];
      for (var key in pagination.query) {
        if (!this.DEFAULT_COLUMNS.includes(key)) {
          atributosValores.push({
            idAtributoCfg: key.replace(/-.+?$/, ''),
            valor: pagination.query[key]
          });
        } else {
          filters[key] = pagination.query[key];
        }
      }
      return (0, _assign2.default)({
        atributosValores: atributosValores,
        filters: filters
      }, pagination, {
        url: this.urls.establishments
      });
    },
    updateColumns: function updateColumns(selectedAttributes) {
      this.selectedAttributesHolder = selectedAttributes;
      this.dynamicColumns = this.attributesList.filter(function (att) {
        return selectedAttributes.some(function (item) {
          return item.id === att.id;
        });
      }).map(function (att) {
        return {
          column: att.id,
          heading: att.descricaoAtributo || att.nomeAtributo,
          template: function (id) {
            return function (h, row) {
              return row[id] || '-';
            };
          }(att.id)
        };
      });
      this.establishments.values.map(function (value) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(selectedAttributes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var attId = _step.value;

            value[attId] = '-';
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(value.atributosValores), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var att = _step2.value;

            var id = att.idAtributoCfg + '-' + att.nomeAtributo;
            if (att.atributo.tipo === 'DATE') {
              value[id] = att.valor ? (0, _moment2.default)(att.valor).format('L') : '-';
            } else {
              value[id] = att.valor || '-';
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return value;
      });
    },
    changeClickedInputState: function changeClickedInputState(state) {
      this.currentInputState = state;
      if (!state) {
        this.focusOnModal();
      }
    },
    focusOnModal: function focusOnModal() {
      this.$el.getElementsByClassName('modal-mask')[0].focus();
    },
    getEstablishmentsFromServerDefault: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(queryValue, toIgnore) {
        var filters, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$store.dispatch('cancelEstablishmentsSearchRequests');
                filters = this.mountFilters({
                  ascending: 1,
                  orderBy: 'nome',
                  page: 1,
                  limit: 5,
                  query: {
                    nome: queryValue
                  }
                });

                filters.toIgnore = toIgnore;
                _context.next = 5;
                return this.$store.dispatch('getEstablishments', filters);

              case 5:
                response = _context.sent;
                return _context.abrupt('return', response.elements);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEstablishmentsFromServerDefault(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getEstablishmentsFromServerDefault;
    }()
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('loadingData');
    this.$store.dispatch('loadEstablishmentAtt', this.urls.attributes).then(function (response) {
      var _establishments$optio;

      _this.attributesList = response.map(function (att) {
        att.id = att.atributoCfg.id + '-' + att.nomeAtributo;
        att.nomeDefinido = att.descricaoAtributo || att.nomeAtributo;
        return att;
      });
      _this.icon = 'fa fa-search';
      _this.$store.dispatch('dataLoaded');

      var dynamicAttsIds = _this.attributesList.map(function (att) {
        return att.id;
      });
      (_establishments$optio = _this.establishments.options.filterable).push.apply(_establishments$optio, (0, _toConsumableArray3.default)(dynamicAttsIds));
      _this.canShowModal = true;
    });
  }
};

/***/ }),
/* 819 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/integration/remittanceIntegration/RemittanceIntegrationCreationModal.vue ***!
  \****************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _ConfirmModal = __webpack_require__(/*! ../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _BetterModal = __webpack_require__(/*! ../../modals/betterModal/BetterModal */ 131);

var _BetterModal2 = _interopRequireDefault(_BetterModal);

var _DateRange = __webpack_require__(/*! ../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'RemittanceIntegrationCreationModal',

  components: {
    vSelect: _vueSelect2.default,
    ConfirmModal: _ConfirmModal2.default,
    BetterModal: _BetterModal2.default,
    DateRange: _DateRange2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    remittanceTypes: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      firstDate: new Date(),
      finalDate: new Date(),
      hasRemittance: false,
      isLoadingData: false,
      remittance: {
        type: '',
        period: {},
        comments: ''
      },
      modal: {
        text: {
          title: this.$t('remessaIntegracao.remessa.gerar.modal.titulo'),
          subtitle: this.$t('remessaIntegracao.remessa.gerar.modal.subtitulo')
        }
      }
    };
  },


  methods: {
    clearRemittance: function clearRemittance() {
      this.remittance = {
        type: '',
        period: {},
        comments: ''
      };
    },
    validate: function validate() {
      var _this = this;

      return new _promise2.default(function (resolve) {
        _this.$validator.validateAll().then(function (result) {
          if (result) {
            _this.$store.dispatch('validateRemittancePeriod', _this.remittance).then(function (hasRemittance) {
              _this.hasRemittance = hasRemittance;
              $('#confirmRemittanceCreation').modal('show');
            });
            resolve();
          }
        });
      });
    },
    create: function create() {
      var _this2 = this;

      this.closeModalConfirm();
      this.isLoadingData = true;
      return new _promise2.default(function (resolve, reject) {
        _this2.$store.dispatch('createRemittance', _this2.remittance).then(function (response) {
          _this2.clearRemittance();
          _this2.isLoadingData = false;
          _this2.$root.$refs.notification.success('remessaIntegracao.mensagem.sucesso');
          _this2.$emit('close-modal');
          resolve();
        }).catch(function (error) {
          _this2.$root.$refs.notification.error(error);
          _this2.isLoadingData = false;
          reject();
        });
      });
    },
    closeModalConfirm: function closeModalConfirm() {
      $('#confirmRemittanceCreation').modal('hide');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 820 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/integration/remittanceIntegration/RemittanceIntegrationModal.vue ***!
  \********************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _BetterModal = __webpack_require__(/*! ../../modals/betterModal/BetterModal */ 131);

var _BetterModal2 = _interopRequireDefault(_BetterModal);

var _TabRemittanceDetail = __webpack_require__(/*! ./TabRemittanceDetail */ 1274);

var _TabRemittanceDetail2 = _interopRequireDefault(_TabRemittanceDetail);

var _TabRemittanceReport = __webpack_require__(/*! ./TabRemittanceReport */ 1275);

var _TabRemittanceReport2 = _interopRequireDefault(_TabRemittanceReport);

var _situacaoRemessa = __webpack_require__(/*! ../../../enum/situacaoRemessa */ 750);

var _situacaoRemessa2 = _interopRequireDefault(_situacaoRemessa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'RemittanceIntegrationModal',

  components: {
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    BetterModal: _BetterModal2.default,
    TabRemittanceDetail: _TabRemittanceDetail2.default,
    TabRemittanceReport: _TabRemittanceReport2.default
  },

  props: {
    remittance: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    showRemovalButton: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      tabName: null,
      tabs: [],
      modal: {
        text: {
          title: this.$t('remessaIntegracao.remessa.detalhar.modal.titulo'),
          subtitle: this.$t('remessaIntegracao.remessa.detalhar.modal.subtitulo')
        }
      }
    };
  },


  computed: {
    situacaoRemocaoValida: function situacaoRemocaoValida() {
      if (this.remittance.Situacao === _situacaoRemessa2.default.CONCLUIDO || this.remittance.Situacao === _situacaoRemessa2.default.ERRO) {
        return false;
      }
      return true;
    }
  },

  watch: {
    remittance: function remittance() {
      if (this.remittance.id) {
        this.tabs = [];
        this.loadDetail();
      }
    }
  },

  methods: {
    verifyTabAuthorization: function verifyTabAuthorization(tab) {
      return true;
    },
    loadDetail: function loadDetail() {
      this.tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-TabRemittanceDetail',
        idTabContent: 'tab-detail-id',
        idLanc: this.idRemittance,
        tabRef: 'tabDetailGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabRemittanceDetail',
        props: {
          remittance: this.remittance,
          showRemovalButton: this.showRemovalButton && this.situacaoRemocaoValida
        }
      });
      this.tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-TabRemittanceReport',
        idTabContent: 'tab-report-id',
        idLanc: this.idRemittance,
        tabRef: 'tabReportGridModal',
        title: this.$t('remessaIntegracao.labels.modal.tabs.resumo'),
        icon: 'icon="tab-icon-font fa fa-bars',
        type: 'TabRemittanceReport',
        props: {
          remittance: this.remittance,
          showRemovalButton: this.showRemovalButton && this.situacaoRemocaoValida
        }
      });
    },
    closeModal: function closeModal() {
      this.tabName = null;
      this.$emit('close-modal');
    }
  }
};

/***/ }),
/* 821 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/integration/remittanceIntegration/TabRemittanceDetail.vue ***!
  \*************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TabRemittanceDetail',

  components: {
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    idModal: {
      type: String
    },
    remittance: {
      type: Object,
      required: true
    },
    showRemovalButton: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    openModalConfirm: function openModalConfirm() {
      $('#confirmRemittanceRemoval').modal('show');
    },
    closeModalConfirm: function closeModalConfirm() {
      $('#confirmRemittanceRemoval').modal('hide');
    },
    handleDateFull: function handleDateFull(text) {
      return text ? (0, _moment2.default)(text).format('DD/MM/YYYY HH:mm:ss') : '-';
    },
    handleDate: function handleDate(text) {
      return text ? (0, _moment2.default)(text).format('DD/MM/YYYY') : '-';
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 822 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/integration/remittanceIntegration/TabRemittanceReport.vue ***!
  \*************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TreeGrid = __webpack_require__(/*! ../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _exportRoutes = __webpack_require__(/*! ../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _gridLoadTransition = __webpack_require__(/*! ../../../utils/grid-load-transition.js */ 34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TabRemittanceReport',

  components: {
    TreeGrid: _TreeGrid2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    idModal: {
      type: String
    },
    remittance: {
      type: Object,
      required: true
    },
    showRemovalButton: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      gridId: '#remittanceReportGrid',
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      treeGridCfg: {},
      result: {},
      showGrid: false
    };
  },


  methods: {
    loadTreegridReport: function loadTreegridReport() {
      var _this = this;

      var filter = {
        idRemessa: this.remittance.id
      };
      this.$store.dispatch('searchRemittanceSummary', filter).then(function (response) {
        _this.result = response.data;
        _this.treeGridCfg = response.data.Cfg.Layout;
        (0, _gridLoadTransition.stopTreeGridLoading)(_this.gridId);
      }).catch(function (error) {
        (0, _gridLoadTransition.stopTreeGridLoading)(_this.gridId);
        _this.$root.$refs.notification.error(error);
      });
    },
    openModalConfirm: function openModalConfirm() {
      $('#confirmRemittanceRemoval').modal('show');
    },
    closeModalConfirm: function closeModalConfirm() {
      $('#confirmRemittanceRemoval').modal('hide');
    }
  },

  mounted: function mounted() {
    this.showGrid = true;
    (0, _gridLoadTransition.startTreeGridLoading)(this.gridId);
    this.loadTreegridReport();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 823 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/layout/filterPortlet/FilterPortlet.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'FilterPortlet',

  props: {
    portletTitle: {
      default: function _default() {
        return this.$t('filterPortlet.defaultTitle');
      }
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  }
};

/***/ }),
/* 824 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/layout/headerBar/HeaderBar.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'HeaderBar',

  props: ['title', 'subTitle']
};

/***/ }),
/* 825 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/layout/menu/SidebarMenu.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(/*! babel-runtime/core-js/set */ 204);

var _set2 = _interopRequireDefault(_set);

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _openMenu = __webpack_require__(/*! ../../../events/openMenu */ 315);

var _openMenu2 = _interopRequireDefault(_openMenu);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SidebarMenu',

  data: function data() {
    return {
      isLoadingData: true,
      functionalitiesGroup: [],
      home: _routesMap2.default.HOME,
      loadingGif: __webpack_require__(/*! ../../../assets/loading-gif/loading.svg */ 67)
    };
  },


  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    client: function client() {
      return this.$store.getters.client;
    },
    popupConfirmResponse: function popupConfirmResponse() {
      return this.$store.getters.popupConfirmResponse;
    },
    isOpen: function isOpen() {
      return this.$store.getters.isOpen;
    },
    currentPath: function currentPath() {
      return this.$store.getters.currentPath;
    },
    isEmulatedLogin: function isEmulatedLogin() {
      return this.$store.getters.isClientEmulatedLogin;
    }
  },

  watch: {
    client: function client() {
      if (this.client) {
        this.loadFuncionalities();
        this.loadAplications();
      }
    },
    isOpen: function isOpen() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.functionalitiesGroup), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;

          group.selected = false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    currentPath: function currentPath() {
      this.setSelectedItemGroup();
    }
  },

  methods: {
    setSelectedItemGroup: function setSelectedItemGroup() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.functionalitiesGroup), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var grupo = _step2.value;

          grupo.active = false;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(grupo.funcionalidades), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var funcionalidade = _step3.value;

              funcionalidade.active = false;
              if (funcionalidade.path === this.currentPath) {
                funcionalidade.active = true;
                grupo.active = true;
                break;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    clearSelectedMenuItem: function clearSelectedMenuItem() {
      (0, _analytics.trackAnalyticsEvent)(this, 'redirect-para-dashboard', 'logo-click', 'redirect-para-dashboard');
    },
    groupClicked: function groupClicked(grupo) {
      var _this = this;

      if (!this.isOpen) {
        return;
      }

      var alreadyActivatedSomeGroup = false;
      grupo.selected = !grupo.selected;

      this.functionalitiesGroup = this.functionalitiesGroup.map(function (g) {
        if (!alreadyActivatedSomeGroup) {
          g.active = g.funcionalidades.some(function (f) {
            return f.path === _this.currentPath;
          });
          alreadyActivatedSomeGroup = g.active;
        }

        if (g !== grupo) {
          g.selected = false;
        }
        return g;
      });

      (0, _analytics.trackAnalyticsEvent)(this, 'menu-lateral', 'grupo-funcionalidade-click', grupo.key);
    },
    functClicked: function functClicked(funcionalidade, grupo) {
      grupo.funcionalidades.map(function (f) {
        f.active = false;
      });
      funcionalidade.active = true;
      (0, _analytics.trackAnalyticsEvent)(this, 'menu-lateral', 'funcionalidade-click', funcionalidade.key);
      if (!this.popupConfirmResponse) {
        return;
      }
      this.$store.dispatch('selectMenuItem', { funcionalidade: funcionalidade, grupo: grupo });
    },
    loadFuncionalities: function loadFuncionalities() {
      var _this2 = this;

      var self = this;
      this.$store.dispatch('getFuncionalities').then(function (response) {
        _this2.functionalitiesGroup = response.data.funcList.map(function (grupo) {
          grupo.active = false;
          grupo.text = _this2.$t('menu.grupos.' + grupo.key);

          if (!self.$store.getters.isClientEmulatedLogin) {
            if (grupo.key === 'registro') {
              grupo.funcionalidades = grupo.funcionalidades.filter(function (funcionalidade) {
                return funcionalidade.key !== 'categorias' && funcionalidade.key !== 'planosConciliacao' && funcionalidade.key !== 'atributos';
              });
            }
          }

          grupo.funcionalidades = grupo.funcionalidades.map(function (funcionalidade) {
            funcionalidade.active = false;
            if (funcionalidade.key === 'resumoConciliacao' || funcionalidade.key === 'calendarioResumoConciliacao') {
              funcionalidade.text = _this2.$t('menu.funcionalidades.resumoConciliacao');
              funcionalidade.ordemListagem = 2;
            } else {
              funcionalidade.text = _this2.$t('menu.funcionalidades.' + funcionalidade.key);
            }
            return funcionalidade;
          });

          var seen = new _set2.default();
          grupo.funcionalidades = grupo.funcionalidades.filter(function (obj) {
            if (seen.has(obj.text)) {
              return false;
            }
            seen.add(obj.text);
            return true;
          });
          grupo.funcionalidades.sort(function (a, b) {
            return a.ordemListagem - b.ordemListagem;
          });
          return grupo;
        });

        _this2.setSelectedItemGroup();
        _this2.isLoadingData = false;
        _this2.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc);
      });
    },
    loadAplications: function loadAplications() {
      var _this3 = this;

      var self = this;
      this.$store.dispatch('getAplicacoes').then(function (data) {
        _this3.$store.dispatch('setAplicacoes', data);
      }).catch(function (error) {
        self.$root.$refs.notification.error(error.message);
      });
    },
    openCloseSidebarMenu: function openCloseSidebarMenu() {
      this.$store.dispatch('setMenuState', this.isOpen);

      if (this.isOpen) {
        (0, _analytics.trackAnalyticsEvent)(this, 'menu-lateral', 'menu-toggle', 'expandido');
      } else {
        (0, _analytics.trackAnalyticsEvent)(this, 'menu-lateral', 'menu-toggle', 'retraído');
      }

      _openMenu2.default.$emit('menuOpened');
    },
    setFullStory: function setFullStory() {
      this.$FullStory.identify(String(this.$store.getters.userId));
      this.$FullStory.setUserVars({
        conc_idCliente: this.$store.getters.client,
        conc_idUsuario: this.$store.getters.userId,
        conc_idPerfilAcesso: this.$store.getters.accessProfileId,
        conc_nomePerfilAcesso: this.$store.getters.accessProfileName,
        conc_aplicacao: 'Banking'
      });
    }
  },

  created: function created() {
    this.$store.dispatch('setMenuState', false);
    if (this.isLoggedIn && this.client) {
      this.loadFuncionalities();
      this.loadAplications();
      this.setFullStory();
    }
  }
};

/***/ }),
/* 826 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/layout/menu/SuspendedMenu.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SuspendedMenu',

  data: function data() {
    return {
      blockClientSelectButton: false
    };
  },


  computed: {
    applicationList: function applicationList() {
      return this.$store.getters.clientApps;
    },
    singleClient: function singleClient() {
      return this.$store.getters.singleClient;
    }
  },

  watch: {
    singleClient: function singleClient() {
      this.blockClientSelectButton = this.singleClient;
    }
  },

  methods: {
    logout: function logout() {
      this.$store.dispatch('logout').then(this.$router.push(_routesMap2.default.LOGIN));
    },
    openClientModal: function openClientModal() {
      this.$store.dispatch('openClientModal');
    },
    openMyAccountModal: function openMyAccountModal() {
      (0, _analytics.trackAnalyticsEvent)(this, 'menu-minha-conta', 'menu-minha-conta-click', 'abrir-modal-minha-conta');
      this.$store.dispatch('openMyAccountModal');
    },
    openAppChangeModal: function openAppChangeModal() {
      (0, _analytics.trackAnalyticsEvent)(this, 'menu-troca-app', 'menu-troca-app-click', 'abrir-modal-troca-app');
      this.$store.dispatch('openAppChangeModal');
    }
  },

  mounted: function mounted() {
    this.blockClientSelectButton = this.singleClient;
  }
};

/***/ }),
/* 827 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/layout/menu/TopBar.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SuspendedMenu = __webpack_require__(/*! ./SuspendedMenu */ 1278);

var _SuspendedMenu2 = _interopRequireDefault(_SuspendedMenu);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _toggleActiveListItem = __webpack_require__(/*! ../../../utils/toggleActiveListItem.js */ 792);

var _toggleActiveListItem2 = _interopRequireDefault(_toggleActiveListItem);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TopBar',

  components: {
    SuspendedMenu: _SuspendedMenu2.default
  },

  data: function data() {
    return {
      home: _routesMap2.default.HOME,
      username: null,
      clientActive: null
    };
  },


  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    clientName: function clientName() {
      return this.$store.getters.clientName;
    },
    isOpen: function isOpen() {
      return this.$store.getters.isOpen;
    }
  },

  watch: {
    user: function user() {
      this.username = this.user;
    },
    clientName: function clientName() {
      if (this.clientName) {
        this.clientActive = this.clientName;
      }
    }
  },

  methods: {
    clearSelectedMenuItem: function clearSelectedMenuItem() {
      (0, _analytics.trackAnalyticsEvent)(this, 'redirect-para-dashboard', 'banking-click', 'redirect-para-dashboard');
      this.$store.dispatch('clearSelectedMenuItem').then(function () {
        (0, _toggleActiveListItem2.default)();
      });
    }
  },

  mounted: function mounted() {
    if (this.user) {
      this.username = this.user;
    }
    if (this.clientName) {
      this.clientActive = this.clientName;
    }
  }
};

/***/ }),
/* 828 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/layout/pageTitle/PageTitle.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'PageTitle',

  props: ['title', 'subTitle']
};

/***/ }),
/* 829 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/loading/LoadingFullPage.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'LoadingFullPage',

  data: function data() {
    return {
      message: '',
      interval: null
    };
  },


  computed: {
    loadingFullPageMessages: function loadingFullPageMessages() {
      return this.$store.getters.loadingFullPageMessages;
    },
    intervalBetweenMessages: function intervalBetweenMessages() {
      return this.$store.getters.intervalBetweenMessages;
    }
  },

  created: function created() {
    var _this = this;

    var counter = 1;
    var intervalBetweenMessages = this.intervalBetweenMessages;
    var messages = this.loadingFullPageMessages;
    var length = messages.length;
    if (length === 0) {
      return;
    }

    var translatedMessages = messages.map(this.$t);
    this.message = translatedMessages[0];
    this.interval = setInterval(function () {
      _this.message = translatedMessages[counter % length];
      ++counter;
    }, intervalBetweenMessages);
  },
  beforeDestroy: function beforeDestroy() {
    this.message = '';
    clearInterval(this.interval);
  }
};

/***/ }),
/* 830 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/loading/LoadingPlaceholder.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueContentPlaceholder = __webpack_require__(/*! vue-content-placeholder */ 1248);

var _vueContentPlaceholder2 = _interopRequireDefault(_vueContentPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'LoadingPlaceholder',

  components: {
    ContentPlaceholder: _vueContentPlaceholder2.default
  },

  data: function data() {
    return {
      placeholderRows: [{
        height: '1.5rem',
        boxes: [[0, this.generateRandomWidthBetween(40, 100)]]
      }]
    };
  },


  methods: {
    generateRandomWidthBetween: function generateRandomWidthBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min + '%';
    }
  }
};

/***/ }),
/* 831 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/betterModal/BetterModal.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _directives = __webpack_require__(/*! ../../../utils/directives.js */ 791);

var _popExitingConfirmation = __webpack_require__(/*! ../../../utils/popExitingConfirmation.js */ 161);

var _popExitingConfirmation2 = _interopRequireDefault(_popExitingConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BetterModal',

  components: {
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    closable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    checkForUnsavedChanges: {
      type: Boolean,
      default: false
    },
    defaultCloseButton: {
      type: Boolean,
      default: false
    },
    tabbedModal: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    bringBack: {
      type: Boolean,
      default: false
    }
  },

  directives: {
    AutoFocus: _directives.AutoFocus
  },

  computed: {
    hasUnsavedChanges: function hasUnsavedChanges() {
      return this.$store.getters.hasUnsavedChanges;
    }
  },

  methods: {
    close: function close() {
      if (this.checkForUnsavedChanges && this.hasUnsavedChanges && !(0, _popExitingConfirmation2.default)()) {
        return;
      }
      (0, _analytics.trackAnalyticsEvent)(this, 'close-modal', 'titlebar-close-modal-click', this.id);
      if (this.closable) {
        this.$emit('close-modal');
      }
    }
  }
};

/***/ }),
/* 832 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/changeApplicationModal/ChangeApplicationModal.vue ***!
  \************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(/*! ../modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _ButtonApplication = __webpack_require__(/*! ../../buttons/buttonApplication/ButtonApplication */ 1256);

var _ButtonApplication2 = _interopRequireDefault(_ButtonApplication);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _aplicacaoEnum = __webpack_require__(/*! ../../../enum/aplicacaoEnum */ 745);

var _aplicacaoEnum2 = _interopRequireDefault(_aplicacaoEnum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ChangeApplicationModal',

  components: {
    Modal: _Modal2.default,
    ButtonApplication: _ButtonApplication2.default
  },

  data: function data() {
    return {
      equalsCartoesImg: __webpack_require__(/*! ../../../assets/icones_app/cartao_azul.svg */ 491),
      equalsBankingImg: __webpack_require__(/*! ../../../assets/icones_app/banco_branco.svg */ 490),
      equalsExtratoImg: __webpack_require__(/*! ../../../assets/icones_app/extrato_azul.svg */ 1138),
      equalsCobrancaImg: __webpack_require__(/*! ../../../assets/icones_app/cobranca_zaul.svg */ 1137),
      equalsBandeirasImg: __webpack_require__(/*! ../../../assets/icones_app/bandeira_azul.svg */ 1136),
      aplicacoes: []
    };
  },


  computed: {
    applicationList: function applicationList() {
      return this.$store.getters.clientApps;
    },
    openAppChangeModal: function openAppChangeModal() {
      return this.$store.getters.openAppChangeModal;
    },
    modalWidthByAppList: function modalWidthByAppList(index) {
      var style = '';
      switch (this.aplicacoes.length) {
        case 2:
          style = 'col-xs-6';
          break;
        case 3:
          style = 'col-xs-4';
          break;
        case 4:
          style = 'col-xs-3';
          break;
        case 5:
          style = 'col-xs-2';
          break;
        default:
          style = 'col-xs-6';
          break;
      }
      return style;
    }
  },

  watch: {
    openAppChangeModal: function openAppChangeModal() {
      if (this.$store.getters.isLoggedIn) {
        this.loadAplications();
      }
    }
  },

  methods: {
    loadAplications: function loadAplications() {
      var _this = this;

      this.aplicacoes = [];
      this.applicationList.forEach(function (appId) {
        if (appId !== _aplicacaoEnum2.default.BANDEIRAS && appId !== _aplicacaoEnum2.default.APLICATIVO) {
          _this.aplicacoes.push(_this.mountAppObject(appId));
        }
      });
      this.aplicacoes.sort(function (x, y) {
        return x.active === y.active ? 0 : x.active ? -1 : 1;
      });
      this.showModal();
    },
    showModal: function showModal() {
      var _this2 = this;

      $('#modal-troca-app').modal({
        backdrop: 'static',
        keyboard: false
      });

      setTimeout(function () {
        _this2.aplicacoes.forEach(function (app) {
          _this2.normilizeMArgin(app.id);
        });
      }, 100);
    },
    closeModal: function closeModal() {
      $('#modal-troca-app').modal('hide');
    },
    abrirEqualsCartoes: function abrirEqualsCartoes() {
      $('#modal-troca-app').modal('hide');
    },
    calcWidth: function calcWidth(app) {
      var base = '';
      switch (this.aplicacoes.length) {
        case 2:
          base = 'col-xs-6';
          break;
        case 3:
          base = 'col-xs-4';
          break;
        case 4:
          base = 'col-xs-3';
          break;
        case 5:
          base = 'col-xs-2';
          app.id === 8 ? base += ' col-xs-offset-1' : '';
          break;
      }
      return base;
    },
    normilizeMArgin: function normilizeMArgin(id) {
      var image = document.getElementsByName('rounded-div-image-' + id);
      if (image && image.length > 0) {
        image[0].style.margin = '0 auto';
      }
    },
    mountAppObject: function mountAppObject(id) {
      var self = this;
      var app = {
        id: id,
        click: function click() {
          return self.trocaAplicacao(id);
        }
      };
      switch (id) {
        case 1:
          app.descricao = this.$t('trocaApp.aplicacoes.cartoes');
          app.imagem = this.equalsCartoesImg;
          app.active = false;
          break;
        case 5:
          app.descricao = this.$t('trocaApp.aplicacoes.extrato');
          app.imagem = this.equalsExtratoImg;
          app.active = false;
          break;
        case 6:
          app.descricao = this.$t('trocaApp.aplicacoes.cobranca');
          app.imagem = this.equalsCobrancaImg;
          app.active = false;
          break;
        case 8:
          app.descricao = this.$t('trocaApp.aplicacoes.banking');
          app.imagem = this.equalsBankingImg;
          app.active = true;
          app.click = this.closeModal;
          break;
      }
      return app;
    },
    trocaAplicacao: function trocaAplicacao(idAplicacao) {
      var _this3 = this;

      var app = {
        idAplicacao: idAplicacao,
        lang: _index2.default.getCookieByName('language')
      };
      this.$store.dispatch('trocaAplicacao', app).then(function (response) {
        window.open(response, '_self');
        _this3.closeModal();
      }).catch(function (error) {
        _this3.$root.$refs.notification.error(error.message);
        _this3.closeModal();
      });
    },
    aplicacaoIndisponivel: function aplicacaoIndisponivel() {
      this.$root.$refs.notification.warning(this.$t('GENERAL'), this.$t('trocaApp.erro.aplicacaiIndisponivel'));
      this.closeModal();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 833 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/clientModal/ClientModal.vue ***!
  \**************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(/*! ../modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _customSorter = __webpack_require__(/*! ../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ClientModal',

  components: {
    Modal: _Modal2.default
  },

  props: {
    autoOpen: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      clients: this.$store.getters.clients,
      singleClient: false,
      columns: ['nomeFantasia'],
      options: {
        columnsClasses: { 'nomeFantasia': 'col-md-11' },
        headings: {
          nomeFantasia: this.$t('modalCliente.labels.nome')
        },
        filterable: false,
        perPageValues: [],
        texts: {
          count: '',
          noResults: this.$t('dataTable.labels.semResultados')
        },
        sortIcon: {
          is: ''
        },
        sortable: ['nomeFantasia'],
        pagination: { chunk: 5 },
        customSorting: {
          nomeFantasia: function nomeFantasia(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'nomeFantasia');
            };
          }
        }
      }
    };
  },


  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    client: function client() {
      return this.$store.getters.client;
    },
    openClientModal: function openClientModal() {
      return this.$store.getters.openClientModal;
    },
    updateLocation: function updateLocation() {
      return this.$store.getters.updateLocation;
    },
    lastUrl: function lastUrl() {
      return this.$store.getters.lastUrl;
    }
  },

  watch: {
    openClientModal: function openClientModal() {
      if (this.isLoggedIn) {
        this.loadClients();
      }
    }
  },

  methods: {
    loadClients: function loadClients() {
      if (this.clients.length > 1) {
        this.singleClient = false;
        this.showModal();
      } else if (this.clients.length === 1) {
        this.singleClient = true;
        this.selectClient(this.clients[0].id, this.clients[0].nomeFantasia);
      }
    },
    selectClient: function selectClient(id, name) {
      var _this = this;

      this.$store.dispatch('cleanFunctionatieModule').then(function () {
        _this.$store.dispatch('setClient', { client: id, clientName: name, singleClient: _this.singleClient }).then(function (response) {
          $('#client-modal').modal('hide');
          _this.$store.dispatch('getFuncionalities').then(function (response) {
            _this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc).then(function (response) {
              $('#client-modal').modal('hide');
              _this.$store.dispatch('cleanGadgetsFilters');
              localStorage.setItem('event-client-selected', Math.random());
              if (_this.updateLocation) {
                _this.$router.push(_this.lastUrl);
                _this.$store.dispatch('setUpdateLocation', false);
                _this.$store.dispatch('setLastUrl', null);
              } else {
                _this.$router.push(_routesMap2.default.HOME);
              }
            });
          });
        });
      });
    },
    closeModal: function closeModal() {
      if (this.client) $('#client-modal').modal('hide');
    },
    showModal: function showModal() {
      if (!this.client) {
        $('#client-modal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        $('#client-modal').modal();
      }
    },
    rowClick: function rowClick(props) {
      this.selectClient(props.row.id, props.row.nomeFantasia);
    }
  },

  mounted: function mounted() {
    if (this.isLoggedIn && !this.client && this.autoOpen) {
      this.loadClients();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 834 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/confirmModal/ConfirmModal.vue ***!
  \****************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ConfirmDialog',

  props: ['id'],

  methods: {
    closeModal: function closeModal() {
      $('#' + this.id).modal('hide');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 835 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/gridDetailsModal/GridDetailsModal.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vuex = __webpack_require__(/*! vuex */ 301);

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _BetterModal = __webpack_require__(/*! ../betterModal/BetterModal */ 131);

var _BetterModal2 = _interopRequireDefault(_BetterModal);

var _TabDetails = __webpack_require__(/*! ./tabDetails/TabDetails */ 1284);

var _TabDetails2 = _interopRequireDefault(_TabDetails);

var _TabIntegrations = __webpack_require__(/*! ./tabIntegrations/TabIntegrations */ 1286);

var _TabIntegrations2 = _interopRequireDefault(_TabIntegrations);

var _TabHistoric = __webpack_require__(/*! ./tabHistoric/TabHistoric */ 1285);

var _TabHistoric2 = _interopRequireDefault(_TabHistoric);

var _TabAllotment = __webpack_require__(/*! ./tabAllotment/TabAllotment */ 690);

var _TabAllotment2 = _interopRequireDefault(_TabAllotment);

var _TabTasks = __webpack_require__(/*! ./tabTasks/TabTasks */ 1287);

var _TabTasks2 = _interopRequireDefault(_TabTasks);

var _TabClassification = __webpack_require__(/*! ./tabClassification/TabClassification */ 1283);

var _TabClassification2 = _interopRequireDefault(_TabClassification);

var _closeModal = __webpack_require__(/*! ../../../events/closeModal.js */ 104);

var _closeModal2 = _interopRequireDefault(_closeModal);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _popExitingConfirmation = __webpack_require__(/*! ../../../utils/popExitingConfirmation */ 161);

var _popExitingConfirmation2 = _interopRequireDefault(_popExitingConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'GridDetailsModal',

  components: {
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    BetterModal: _BetterModal2.default,
    TabDetails: _TabDetails2.default,
    TabIntegrations: _TabIntegrations2.default,
    TabHistoric: _TabHistoric2.default,
    TabAllotment: _TabAllotment2.default,
    TabTasks: _TabTasks2.default,
    TabClassification: _TabClassification2.default
  },

  props: {
    id: {
      type: String,
      required: true
    },
    size: {
      type: String
    },
    closable: {
      type: Boolean,
      default: false
    },
    closeFunction: {},
    tabs: {
      type: Array,
      required: true
    },
    defaultTab: {
      type: String,
      required: false,
      default: 'gridDetailsModal-tabDetails'
    },
    labelModalTitle: {
      type: String,
      default: 'modalDetalhesLanc.titulos.titulo'
    },
    labelModalSubTitle: {
      type: String,
      default: 'modalDetalhesLanc.titulos.subtitulo'
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      tabName: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
      mustReloadParent: false
    };
  },


  computed: (0, _assign2.default)({
    modalTitle: function modalTitle() {
      return this.$t(this.labelModalTitle);
    },
    modalSubtitle: function modalSubtitle() {
      return this.$t(this.labelModalSubTitle);
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      return this.$store.getters.hasUnsavedChanges;
    }
  }, (0, _vuex.mapGetters)(['isManagingTask'])),

  watch: {
    tabs: function tabs() {
      var _this = this;

      var self = this;
      if (self.defaultTab === 'gridDetailsModal-tabDetails') {
        setTimeout(function () {
          self.$refs.tabRouter.navigateToTab(0);
        }, 100);
        self.tabName = self.$t('modalDetalhesLanc.titulos.tabDetalhes');
      } else if (self.defaultTab === 'gridDetailsModal-tabTasks') {
        setTimeout(function () {
          self.$refs.tabRouter.navigateToTab(_this.tabs.length - 1);
        }, 100);
      }
    }
  },

  methods: {
    trackEvent: function trackEvent() {
      if (this.hasUnsavedChanges && !(0, _popExitingConfirmation2.default)()) {
        return;
      }
      this.$store.dispatch('setHasUnsavedChanges', false);
      (0, _analytics.trackAnalyticsEvent)(this, 'close-grid-modal', 'titlebar-close-click', this.id);
      _closeModal2.default.$emit('modalDetailsClose', this.mustReloadParent);
      this.$emit('closeDetailsModal');
      window.Grids[0].Enable();
      if (this.$refs.tabTasksGridModal) {
        this.$refs.tabTasksGridModal[0].$children[0].clearManagementTask();
      }
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      (0, _analytics.trackAnalyticsEvent)(this, 'tab-click', newTab.id + '-click', this.getTabIdLanc(newTab.id));
      this.$store.dispatch('setHasUnsavedChanges', false);
      switch (newTab.id) {
        case 'gridDetailsModal-tabDetails':
          break;
        case 'gridDetailsModal-tabIntegrations':
          this.$refs.tadIntegrationGridModal[0].$children[0].loadProcFile();
          break;
        case 'gridDetailsModal-tabHistoric':
          this.$refs.tabHisotiricGridModal[0].$children[0].clickAction();
          break;
        case 'gridDetailsModal-tabAllotment':
          this.$refs.tadAllotmentGridModal[0].$children[0].loadAllotment();
          break;
        case 'gridDetailsModal-tabTasks':
          this.$refs.tabTasksGridModal[0].$children[0].loadTaskData(this.isManagingtask);
          break;
        case 'gridDetailsModal-tabTask':
          this.$refs.tabTasksGridModal[0].$children[0].loadTaskDetail();
          break;
        case 'gridDetailsModal-tabClassification':
          this.$refs.tabClassificationGridModal[0].$children[0].prepareTab();
          break;
        default:
          break;
      }
    },
    getTabIdLanc: function getTabIdLanc(tabId) {
      var lanc = null;
      this.tabs.forEach(function (tab) {
        if (tab.idTabRoot === tabId) {
          lanc = tab.idLanc;
        }
      });
      return lanc;
    },
    verifyTabAuthorization: function verifyTabAuthorization(id) {
      if (!id) {
        return true;
      } else {
        if (this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.length > 0 && this.$store.getters.allowedFuncionalities.indexOf(id) >= 0) {
          return true;
        }
      }
      return false;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    _closeModal2.default.$on('taskChange', function (flag) {
      _this2.mustReloadParent = flag;
    });
  }
};

/***/ }),
/* 836 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/gridDetailsModal/tabAllotment/TabAllotment.vue ***!
  \*********************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _numberMasker = __webpack_require__(/*! ../../../../utils/numberMasker.js */ 71);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

exports.default = {
  name: 'TabAllotment',

  components: {
    ButtonPrimary: _ButtonPrimary2.default,
    LoadingPlaceholder: _LoadingPlaceholder2.default
  },

  props: {
    idMovimento: {
      type: String,
      default: null
    },

    tipoMovimento: {
      type: String,
      default: null
    },

    dadosLote: {
      type: Object,
      default: null
    },

    getAllotment: {
      type: Function
    }
  },

  data: function data() {
    var _this = this;

    return {
      loadingGif: __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67),
      columns: ['id', 'estabelecimento', 'dtLanc', 'vlMovFin', 'vlMovExt', 'cdOcu', 'dsOcu', 'nmConta', 'banco', 'nrConta', 'agencia'],
      options: {
        columnsClasses: {
          'id': 'col-1 limit-char',
          'estabelecimento': 'col-2 limit-char',
          'dtLanc': 'col-1 limit-char',
          'vlMovFin': 'col-2 limit-char',
          'vlMovExt': 'col-2 limit-char',
          'cdOcu': 'col-1 limit-char',
          'dsOcu': 'col-1 limit-char',
          'nmConta': 'col-1 limit-char',
          'banco': 'col-1 limit-char',
          'nrConta': 'col-1 limit-char',
          'agencia': 'col-1 limit-char'
        },
        headings: {
          id: this.$t('modalDetalhesLanc.tabLotes.labels.id'),
          estabelecimento: this.$t('estabelecimentos.labels.estabelecimento'),
          dtLanc: this.$t('modalDetalhesLanc.tabLotes.labels.dtLanc'),
          vlMovFin: this.$t('modalDetalhesLanc.tabLotes.labels.vlMovFinanc'),
          vlMovExt: this.$t('modalDetalhesLanc.tabLotes.labels.vlMovExtrato'),
          cdOcu: this.$t('modalDetalhesLanc.tabLotes.labels.codOcorrencia'),
          dsOcu: this.$t('modalDetalhesLanc.tabLotes.labels.dsOcorrencia'),
          nmConta: this.$t('modalDetalhesLanc.tabLotes.labels.nmConta'),
          banco: this.$t('modalDetalhesLanc.tabLotes.labels.banco'),
          nrConta: this.$t('modalDetalhesLanc.tabLotes.labels.nrConta'),
          agencia: this.$t('modalDetalhesLanc.tabLotes.labels.agencia')
        },
        templates: {
          id: function id(h, row) {
            return row.id ? row.id : ' - ';
          },
          dtLanc: function dtLanc(h, row) {
            return (0, _moment2.default)(row.dataLancamento).utc().format('L');
          },
          vlMovFin: function vlMovFin(h, row) {
            return (0, _numberMasker.maskThousand)(row.valorMovFin);
          },
          vlMovExt: function vlMovExt(h, row) {
            return (0, _numberMasker.maskThousand)(row.valorMovBan);
          },
          cdOcu: function cdOcu(h, row) {
            return row.motivoOcorrencia && row.motivoOcorrencia.codigo ? row.motivoOcorrencia.codigo : ' - ';
          },
          dsOcu: function dsOcu(h, row) {
            return row.motivoOcorrencia && row.motivoOcorrencia.descricao ? row.motivoOcorrencia.descricao : ' - ';
          },
          nmConta: function nmConta(h, row) {
            return row.nomeConta ? row.nomeConta : ' - ';
          },
          nrConta: function nrConta(h, row) {
            return row.numConta ? row.numConta : ' - ';
          }
        },
        rowClassCallback: function rowClassCallback(row) {
          var customClass = '';
          if (row.id && row.id === _this.idMovimento) {
            customClass = 'selected-row';
          }
          return customClass;
        },
        filterable: false,
        perPage: 10,
        perPageValues: [10, 20, 50, 100],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: null,
          limit: this.$t('dataTable.labels.registrosPorPagina')
        },
        pagination: { chunk: 5 },
        sortable: ['id', 'estabelecimento', 'dtLanc', 'vlMovFin', 'vlMovExt', 'cdOcu', 'dsOcu', 'nmConta', 'banco', 'nrConta', 'agencia'],
        sortIcon: {
          is: ''
        }
      },
      hasAllotment: false,
      isLoadingData: true,
      allotment: {
        lancamentos: []
      },
      idLastLanc: null
    };
  },


  computed: {
    allotmentEntries: function allotmentEntries() {
      return this.allotment && this.allotment.lancamentos ? this.allotment.lancamentos : [];
    },
    allotmentId: function allotmentId() {
      return this.allotment && this.allotment.idLote ? this.allotment.idLote : ' - ';
    },
    allotmentQtdLanc: function allotmentQtdLanc() {
      return this.allotment.lancamentos ? this.allotment.lancamentos.length : ' - ';
    },
    allotmentStatus: function allotmentStatus() {
      return {
        valor: this.getStatusValueLabel(this.allotment.situacao),
        classe: this.getStatusValueClass(this.allotment.situacao)
      };
    },
    totalMovFin: function totalMovFin() {
      return this.allotment && this.allotment.totalMovFin ? this.allotment.totalMovFin : 0.00;
    },
    totalMovExt: function totalMovExt() {
      return this.allotment && this.allotment.totalMovBan ? this.allotment.totalMovBan : 0.00;
    },
    totalDivergencia: function totalDivergencia() {
      return parseFloat(this.totalMovExt).toFixed(2) - parseFloat(this.totalMovFin).toFixed(2);
    },
    totalMovFinTransformed: function totalMovFinTransformed() {
      return (0, _numberMasker.maskThousand)(this.totalMovFin);
    },
    totalMovExtTransformed: function totalMovExtTransformed() {
      return (0, _numberMasker.maskThousand)(this.totalMovExt);
    },
    totalDivergenciaTransformed: function totalDivergenciaTransformed() {
      return (0, _numberMasker.maskThousand)(this.totalDivergencia);
    },
    dateRangeAllotment: function dateRangeAllotment() {
      return (0, _moment2.default)(this.allotment.dtInicio).utc().format('L') + ' - ' + (0, _moment2.default)(this.allotment.dtFim).utc().format('L');
    },
    canGoToManualConcil: function canGoToManualConcil() {
      return this.totalDivergencia !== 0 && this.dadosLote === null;
    },
    canConciliate: function canConciliate() {
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(199) >= 0;
    },
    criteria: function criteria() {
      return this.allotment && this.allotment.critConciliacao ? this.allotment.critConciliacao : '-';
    }
  },

  methods: {
    closeModal: function closeModal(idModal) {
      $('#' + idModal).modal('hide');
    },
    getStatusValueClass: function getStatusValueClass(item) {
      var title = '';
      switch (item) {
        case 'C':
          title = 'font-C';
          break;
        case 'M':
          title = 'font-C';
          break;
        case 'D':
          title = 'font-D';
          break;
        case 'N':
          title = 'font-N';
          break;
        case 'A':
          title = 'font-A';
          break;
        default:
          title = '';
          break;
      }
      return title;
    },
    getStatusValueLabel: function getStatusValueLabel(item) {
      var title = '';
      switch (item) {
        case 'C':
          title = this.$t('statusConciliacao.conciliado');
          break;
        case 'M':
          title = this.$t('statusConciliacao.conciliadoManualmente');
          break;
        case 'D':
          title = this.$t('statusConciliacao.divergente');
          break;
        case 'N':
          title = this.$t('statusConciliacao.naoAplicavel');
          break;
        case 'A':
          title = this.$t('statusConciliacao.aberto');
          break;
        default:
          title = ' - ';
          break;
      }
      return title;
    },
    loadAllotment: function loadAllotment() {
      var _this2 = this;

      if (!this.idLastLanc || this.idLastLanc !== this.idMovimento) {
        this.isLoadingData = true;
        this.getAllotment(this.idMovimento).then(function (response) {
          _this2.idLastLanc = _this2.idMovimento;
          _this2.isLoadingData = false;
          _this2.hasAllotment = response.data.idLote != null;
          _this2.allotment = response.data;
          _this2.setAllotmentRangeDate();
          _this2.setAllotmentMovCounts();
        }).catch(function (error) {
          if (error.message) {
            _this2.$root.$refs.notification.error(error.message);
          } else {
            _this2.$root.$refs.notification.error('modalDetalhesLanc.error.parseError');
          }
          _this2.isLoadingData = false;
          _this2.hasAllotment = false;
          _this2.allotment.lancamentos = [];
          _this2.closeModal();
        });
      }
    },
    createAllotmentDetailsFromManualConcilaition: function createAllotmentDetailsFromManualConcilaition() {
      var _this3 = this;

      if (!this.idLastLanc || this.idLastLanc !== (this.dadosLote && this.dadosLote.idLote ? this.dadosLote.idLote : -1)) {
        this.isLoadingData = true;
        this.$store.dispatch('recoverAllotmentMov', this.dadosLote.idLote).then(function (response) {
          _this3.idLastLanc = _this3.dadosLote.idLote;
          _this3.isLoadingData = false;
          _this3.hasAllotment = _this3.dadosLote.idLote != null;
          _this3.allotment = _this3.dadosLote;
          _this3.allotment.countMovFin = response.financialMovements ? response.financialMovements.length : 0;
          _this3.allotment.countMovBan = response.bankMovements ? response.bankMovements.length : 0;
          _this3.allotment.lancamentos = [];
          response.financialMovements.forEach(function (movFin) {
            var item = {
              id: movFin.id,
              dataLancamento: movFin.data,
              valorMovFin: movFin.valor,
              valorMovBan: 0,
              estabelecimento: movFin.estabelecimento,
              motivoOcorrencia: {
                codigo: movFin.cdOcorrencia,
                descricao: movFin.dsOcorrencia
              },
              nomeConta: movFin.nomeConta,
              banco: movFin.banco,
              numConta: movFin.numConta,
              agencia: movFin.agencia
            };
            _this3.allotment.lancamentos.push(item);
          });
          response.bankMovements.forEach(function (movBan) {
            var item = {
              id: movBan.id,
              dataLancamento: movBan.data,
              valorMovFin: 0,
              valorMovBan: movBan.valor,
              estabelecimento: movBan.estabelecimento,
              motivoOcorrencia: {
                codigo: movBan.cdOcorrencia,
                descricao: movBan.dsOcorrencia
              },
              nomeConta: movBan.nomeConta,
              banco: movBan.banco,
              numConta: movBan.numConta,
              agencia: movBan.agencia
            };
            _this3.allotment.lancamentos.push(item);
          });
        }).catch(function (error) {
          if (error.message) {
            _this3.$root.$refs.notification.error(error.message);
          } else {
            _this3.$root.$refs.notification.error('modalDetalhesLanc.error.parseError');
          }
          _this3.closeModal('detalhesLoteConcManual');
          _this3.hasAllotment = false;
          _this3.allotment.lancamentos = [];
        });
      }
    },
    goManualConcil: function goManualConcil() {
      window.open(_routesMap2.default.MANUAL_CONCILIATION, '_blank');
    },
    setAllotmentRangeDate: function setAllotmentRangeDate() {
      var startDate = new Date('01/01/9999');
      var endDate = new Date('01/01/1900');
      this.allotment.lancamentos.forEach(function (entry) {
        var date = entry.dataLancamento ? entry.dataLancamento : entry.data;
        if ((0, _moment2.default)(date).isBefore(startDate)) {
          startDate = date;
        }
        if ((0, _moment2.default)(date).isAfter(endDate)) {
          endDate = date;
        }
      });

      this.allotment.dtInicio = startDate;
      this.allotment.dtFim = endDate;
    },
    setAllotmentMovCounts: function setAllotmentMovCounts() {
      var finCount = 0;
      var banCount = 0;
      this.allotment.lancamentos.forEach(function (mov) {
        mov.banco !== ' - ' ? banCount++ : finCount++;
      });
      this.allotment.countMovFin = finCount;
      this.allotment.countMovBan = banCount;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 837 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/gridDetailsModal/tabClassification/TabClassification.vue ***!
  \*******************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TabClassification',

  components: {
    vSelect: _vueSelect2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    idModal: {
      type: String
    },
    mainValuesList: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      bankMov: {
        id: null,
        situacaoConciliacao: 'A',
        planoConciliacao: null,
        categoria: null,
        estabelecimento: null,
        contaLancamento: {
          id: null
        }
      },
      categories: [],
      establishments: [],
      conciliationPlans: [],
      isLoadingData: true,
      valuesList: []
    };
  },


  computed: {
    titleFormClassif: function titleFormClassif() {
      return this.$t('modalDetalhesLanc.titulos.tabClassif');
    },
    conciliationPlansLenght: function conciliationPlansLenght() {
      return this.conciliationPlans.length <= 1;
    },
    existsConciliationPlans: function existsConciliationPlans() {
      return this.conciliationPlans.length !== 0;
    },
    enableRemove: function enableRemove() {
      return this.bankMov.id && this.bankMov.situacaoConciliacao === 'A';
    },
    defineClassificationLabel: function defineClassificationLabel() {
      var label = '';
      if (this.bankMov.critClassif && this.bankMov.critClassif.toLowerCase() !== this.$t('modalDetalhesLanc.tabClassif.semClassif').toLowerCase()) {
        label = this.bankMov.critClassif;
      } else {
        label = this.bankMov.categoria ? this.$t('modalDetalhesLanc.tabClassif.classifManual') : this.$t('modalDetalhesLanc.tabClassif.semClassif');
      }
      return label;
    }
  },

  methods: {
    closeModal: function closeModal() {
      $('#' + this.idModal).modal('hide');
    },
    prepareTab: function prepareTab() {
      var _this = this;

      this.isLoadingData = true;
      this.bankMov.contaLancamento.id = this.mainValuesList[0].value;
      var critClassif = this.mainValuesList.filter(function (item) {
        return item.title === _this.$t('modalDetalhesLanc.tabClassif.critClassif');
      });
      var labelClassif = critClassif && critClassif.length > 0 ? critClassif[0].value : null;
      this.valuesList = this.mainValuesList.filter(function (item) {
        return item.title !== _this.$t('modalDetalhesLanc.tabClassif.critClassif');
      });

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.get('/bankStatement/getBankMovmentByIdBankStatment', { params: { idContaLancamento: _this.mainValuesList[0].value } }).then(function (responseMov) {
          _this.bankMov = responseMov.data.data;
          if (!_this.bankMov) {
            _this.bankMov = {
              id: null,
              situacaoConciliacao: 'A',
              planoConciliacao: null,
              categoria: null,
              estabelecimento: null,
              contaLancamento: {
                id: _this.mainValuesList[0].value
              }
            };
          }
          _this.bankMov.critClassif = labelClassif;

          if (_this.bankMov.planoConciliacao) {
            _this.bankMov.planoConciliacao.label = _this.bankMov.planoConciliacao.nome;
          }

          if (_this.bankMov.categoria) {
            _this.bankMov.categoria.label = _this.bankMov.categoria.numero + ' - ' + _this.bankMov.categoria.nome;
          }

          if (_this.bankMov.estabelecimento) {
            _this.bankMov.estabelecimento.label = _this.bankMov.estabelecimento.nome + ' - ' + _this.bankMov.estabelecimento.cnpj;
            _this.establishments.push(_this.bankMov.estabelecimento);
          }

          _this.$store.dispatch('getPlans', '/conciliationPlan/listCategorized').then(function (responsePlan) {
            _this.conciliationPlans = responsePlan.data;
            _this.conciliationPlans = _this.conciliationPlans.map(function (plan) {
              plan.label = plan.planName;
              return plan;
            });
            _this.bankMov.planoConciliacao = _this.conciliationPlans[0];

            _this.$store.dispatch('getCategories', {
              url: '/bankStatement/loadCategories',
              flTipoCategoria: null,
              validarUso: false
            }).then(function (responseCat) {
              var catArray = [];
              responseCat.data.forEach(function (cat) {
                cat.label = cat.numero + ' - ' + cat.nome;
                catArray.push(cat);
              });

              _this.categories = _customSorter2.default.arrayDottedSorter(catArray, 'numero', 'asc');
              _this.isLoadingData = false;
            }).catch(function (errorCat) {
              _this.$root.$refs.notification.error(errorCat.data.message);
              _this.isLoadingData = false;
            });
          }).catch(function (errorPlan) {
            _this.$root.$refs.notification.error(errorPlan.data.message);
            _this.isLoadingData = false;
          });
          resolve();
        }).catch(function (errorMov) {
          _this.$root.$refs.notification.error(errorMov);
          _this.isLoadingData = false;
          reject();
        });
      });
    },
    loadEstablishments: function loadEstablishments() {
      var _this2 = this;

      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (search.length) {
        var filters = this.mountFilters({
          ascending: 1,
          orderBy: 'nome',
          page: 1,
          limit: 5,
          query: {
            nome: search
          }
        });

        this.$store.dispatch('getEstablishments', filters).then(function (response) {
          if (response.elements.length === 0) {
            _this2.establishments = [];
          } else {
            _this2.establishments = response.elements;
          }
        }).catch(function (error) {
          _this2.establishments = [];
          _this2.$root.$refs.notification.error(error.message);
        });
      }
    },
    mountFilters: function mountFilters(pagination) {
      var filters = {};
      var atributosValores = [];
      for (var key in pagination.query) {
        filters[key] = pagination.query[key];
      }
      return (0, _assign2.default)({
        atributosValores: atributosValores,
        filters: filters
      }, pagination, {
        url: 'establishment/list'
      });
    },
    handleClearList: function handleClearList() {
      this.establishments = [];
    },
    bindConciliationPlan: function bindConciliationPlan(plan) {
      if (plan) {
        this.bankMov.planoConciliacao = plan;
        this.errors.remove('bankMov.planoConciliacao');
      }
    },
    validate: function validate() {
      var _this3 = this;

      this.isLoadingData = true;
      var self = this;
      var promise = null;
      return new _promise2.default(function (resolve) {
        self.$validator.validateAll().then(function (result) {
          if (result) {
            promise = self.createClassification();
            promise.finally(function () {
              resolve();
            });
          } else {
            _this3.isLoadingData = false;
          }
        });
      });
    },
    createClassification: function createClassification() {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/bankStatement/saveBankMovment', _this4.bankMov).then(function (response) {
          _this4.$root.$refs.notification.success(_this4.enableRemove ? 'movbancaria.sucesso.atualizar' : 'movbancaria.sucesso.salvar');
          _this4.bankMov = response.data.data;
          if (_this4.bankMov.planoConciliacao) {
            _this4.bankMov.planoConciliacao.label = _this4.bankMov.planoConciliacao.nome;
          }
          if (_this4.bankMov.categoria) {
            _this4.bankMov.categoria.label = _this4.bankMov.categoria.numero + ' - ' + _this4.bankMov.categoria.nome;
          }
          if (_this4.bankMov.estabelecimento) {
            _this4.bankMov.estabelecimento.label = _this4.bankMov.estabelecimento.nome + ' - ' + _this4.bankMov.estabelecimento.cnpj;
            _this4.establishments = [];
            _this4.establishments.push(_this4.bankMov.estabelecimento);
          }
          _this4.isLoadingData = false;
          resolve();
        }).catch(function (errorMov) {
          _this4.$root.$refs.notification.error(errorMov);
          _this4.isLoadingData = false;
          reject();
        });
      });
    },
    remove: function remove() {
      var _this5 = this;

      this.isLoadingData = true;
      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.delete('/bankStatement/deleteBankMovment', { params: { idMovBancario: _this5.bankMov.id } }).then(function (response) {
          _this5.$root.$refs.notification.success('movbancaria.sucesso.remover');
          _this5.bankMov = {
            id: null,
            situacaoConciliacao: 'A',
            planoConciliacao: _this5.conciliationPlans[0],
            categoria: null,
            estabelecimento: null,
            contaLancamento: {
              id: _this5.mainValuesList[0].value
            }
          };

          _this5.isLoadingData = false;
          resolve();
        }).catch(function (error) {
          _this5.$root.$refs.notification.error(error);
          _this5.isLoadingData = false;
          reject();
        });
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 838 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/gridDetailsModal/tabDetails/TabDetails.vue ***!
  \*****************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'TabDetails',

  props: {
    idModal: {
      type: String
    },
    establishtmentValue: {
      type: Object
    },
    mainValuesList: {
      type: Array,
      required: true
    },
    statusValuesList: {
      type: Array
    },
    monetaryValuesList: {
      type: Array,
      required: true
    },
    commentary: {
      type: Object
    }
  },

  methods: {
    closeModal: function closeModal() {
      $('#' + this.idModal).modal('hide');
    },
    getStatusValueClass: function getStatusValueClass(item) {
      var title = '';
      switch (item.value) {
        case 'C':
          title = 'detail-status font-C';
          break;
        case 'M':
          title = 'detail-status font-C';
          break;
        case 'D':
          title = 'detail-status font-D';
          break;
        case 'N':
          title = 'detail-status font-N';
          break;
        case 'A':
          title = 'detail-status font-A';
          break;
        default:
          title = 'detail-value';
          break;
      }
      return title;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 839 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/gridDetailsModal/tabHistoric/TabHistoric.vue ***!
  \*******************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TabHistoric',

  props: {
    loadHistoric: Function,
    idLancamento: String
  },

  data: function data() {
    return {
      historics: [],
      historicEmpty: false,
      isLoading: false,
      idLastLanc: null
    };
  },


  methods: {
    clickAction: function clickAction() {
      var _this = this;

      if (!this.idLastLanc || this.idLastLanc !== this.idLancamento) {
        this.isLoading = true;
        this.loadHistoric(this.idLancamento).then(function (response) {
          _this.idLastLanc = _this.idLancamento;
          _this.historics = [];
          if (response && response.data && response.data.length > 0) {
            response.data.forEach(function (data) {
              var history = {
                data: data.data ? (0, _moment2.default)(data.data).format('LL') : ' - ',
                hora: data.data ? (0, _moment2.default)(data.data).format('LT') : ' - ',
                id: data.id ? data.id : ' - ',
                status: data.situacaoConciliacao ? data.situacaoConciliacao : ' - ',
                usuario: data.usuarioNome ? data.usuarioNome : ' - ',
                acao: data.acao,
                idLote: data.idConciliacaoLote ? data.idConciliacaoLote : '-'
              };
              _this.historics.push(history);
            });
            _this.historicEmpty = false;
          } else {
            _this.historicEmpty = true;
          }
          _this.isLoading = false;
        }).catch(function (error) {
          _this.$root.$refs.notification.error(error.message);
          _this.isLoading = false;
        });
      }
    },
    isFirst: function isFirst(index) {
      return !index;
    },
    getClassContent: function getClassContent(index) {
      if (index === 0) {
        return 'historic-line-data-first';
      } else if (index === this.historics.length - 1) {
        return 'historic-line-data-last';
      }
      return 'historic-line-data';
    },
    getLabelStatus: function getLabelStatus(key) {
      return key === 'A' ? 'statusConciliacao.aberto' : key === 'C' ? 'statusConciliacao.conciliado' : key === 'M' ? 'statusConciliacao.conciliadoManualmente' : key === 'D' ? 'statusConciliacao.divergente' : key === 'N' ? 'statusConciliacao.naoAplicavel' : ' - ';
    },
    getStyleByStatus: function getStyleByStatus(item) {
      var title = '';
      switch (item) {
        case 'C':
          title = 'font-C';
          break;
        case 'M':
          title = 'font-C';
          break;
        case 'D':
          title = 'font-D';
          break;
        case 'N':
          title = 'font-N';
          break;
        case 'A':
          title = 'font-A';
          break;
        default:
          title = '';
          break;
      }
      return title;
    },
    getKeyAction: function getKeyAction(keyAction) {
      return 'modalDetalhesLanc.tabHistorico.acao.' + keyAction;
    }
  }
};

/***/ }),
/* 840 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/gridDetailsModal/tabIntegrations/TabIntegrations.vue ***!
  \***************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _statusesTranslator = __webpack_require__(/*! ../../../../utils/statusesTranslator.js */ 162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

exports.default = {
  name: 'TabIntegrations',

  components: {
    LoadingPlaceholder: _LoadingPlaceholder2.default
  },

  props: {
    idModal: {
      type: String
    },
    idProcessamento: {
      type: Number,
      required: true,
      default: -1
    },
    establishtmentValue: {
      type: Object
    },
    integrationValuesList: {
      type: Array,
      required: true
    },
    loadIntegration: {
      type: Function
    }
  },

  data: function data() {
    return {
      columns: ['id', 'arquivo', 'sequencia', 'dtgen', 'layout', 'origem', 'dtproc'],
      options: {
        columnsClasses: {
          'id': 'table-col-1',
          'arquivo': 'table-col-2',
          'sequencia': 'table-col-1',
          'dtgen': 'table-col-1',
          'layout': 'table-col-2',
          'origem': 'table-col-1',
          'dtproc': 'table-col-1'
        },
        headings: {
          id: this.$t('modalDetalhesLanc.tabItegrations.labels.idProc'),
          arquivo: this.$t('modalDetalhesLanc.tabItegrations.labels.arquivo'),
          sequencia: this.$t('modalDetalhesLanc.tabItegrations.labels.sequencia'),
          dtgen: this.$t('modalDetalhesLanc.tabItegrations.labels.dtgen'),
          layout: this.$t('modalDetalhesLanc.tabItegrations.labels.layout'),
          origem: this.$t('modalDetalhesLanc.tabItegrations.labels.origem'),
          dtproc: this.$t('modalDetalhesLanc.tabItegrations.labels.dtproc')
        },
        templates: {
          id: _LoadingPlaceholder2.default,
          arquivo: _LoadingPlaceholder2.default,
          sequencia: _LoadingPlaceholder2.default,
          dtgen: _LoadingPlaceholder2.default,
          layout: _LoadingPlaceholder2.default,
          origem: _LoadingPlaceholder2.default,
          dtproc: _LoadingPlaceholder2.default
        },
        filterable: false,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filter: null,
          filterPlaceholder: null
        },
        pagination: {},
        sortable: ['id'],
        sortIcon: {
          is: ''
        }
      },
      processedFiles: (0, _gridLoadTransition.generateLoadingRows)(3)
    };
  },


  methods: {
    closeModal: function closeModal() {
      $('#' + this.idModal).modal('hide');
    },
    getStatusValueClass: function getStatusValueClass(item) {
      var title = '';
      switch (item.value) {
        case 'C':
          title = 'detail-status-C';
          break;
        case 'M':
          title = 'detail-status-C';
          break;
        case 'D':
          title = 'detail-status-D';
          break;
        case 'N':
          title = 'detail-status-N';
          break;
        case 'A':
          title = 'detail-status-A';
          break;
        default:
          title = 'detail-value';
          break;
      }
      return title;
    },
    getStatusValueLabel: function getStatusValueLabel(item) {
      var title = '';
      switch (item.value) {
        case 'C':
          title = this.$t('statusConciliacao.conciliado');
          break;
        case 'M':
          title = this.$t('statusConciliacao.conciliadoManualmente');
          break;
        case 'D':
          title = this.$t('statusConciliacao.divergente');
          break;
        case 'N':
          title = this.$t('statusConciliacao.naoAplicavel');
          break;
        case 'A':
          title = this.$t('statusConciliacao.aberto');
          break;
        default:
          title = item.value;
          break;
      }
      return title;
    },
    loadProcFile: function loadProcFile() {
      var _this = this;

      if (this.idProcessamento && this.idProcessamento >= 0) {
        this.loadIntegration(this.idProcessamento).then(function (response) {
          _this.processedFiles = [];
          _this.processedFiles.push({
            id: response.id,
            arquivo: response.nomeArquivo ? response.nomeArquivo : ' - ',
            sequencia: response.numSequencia ? response.numSequencia : ' - ',
            dtgen: response.dataGeracao ? (0, _moment2.default)(response.dataGeracao).format('DD/MM/YYYY') : ' - ',
            layout: response.layout ? response.layout : ' - ',
            origem: response.origem ? (0, _statusesTranslator.originTranslate)(response.origem, _this) : ' - ',
            dtproc: response.dataFinal ? (0, _moment2.default)(response.dataFinal).format('DD/MM/YYYY') : ' - '
          });
          _this.options.templates = {};
        }).catch(function (error) {
          _this.processedFiles = [];
          _this.$root.$refs.notification.error(error.message);
        });
      } else {
        this.processedFiles = [];
        this.options.templates = {};
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 841 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/gridDetailsModal/tabTasks/TabTasks.vue ***!
  \*************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ 322);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _vuex = __webpack_require__(/*! vuex */ 301);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _TreeviewHistoric = __webpack_require__(/*! ../../../treeViewHistoric/TreeviewHistoric */ 694);

var _TreeviewHistoric2 = _interopRequireDefault(_TreeviewHistoric);

var _index = __webpack_require__(/*! ../../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _closeModal = __webpack_require__(/*! ../../../../events/closeModal.js */ 104);

var _closeModal2 = _interopRequireDefault(_closeModal);

var _statusesTranslator = __webpack_require__(/*! ../../../../utils/statusesTranslator.js */ 162);

var _customValidator = __webpack_require__(/*! ../../../../utils/customValidator.js */ 106);

var _customValidator2 = _interopRequireDefault(_customValidator);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _popExitingConfirmation = __webpack_require__(/*! ../../../../utils/popExitingConfirmation */ 161);

var _popExitingConfirmation2 = _interopRequireDefault(_popExitingConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());
_moment2.default.updateLocale(_index2.default.getDatePickerLanguage(), { invalidDate: ' - ' });

exports.default = {
  name: 'TabTasks',

  components: {
    LoadingPlaceholder: _LoadingPlaceholder2.default,
    TreeViewHistoric: _TreeviewHistoric2.default,
    vSelect: _vueSelect2.default,
    Datepicker: _vuejsDatepicker2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      currentTask: {},
      alreadySaved: false,

      concilStatusesBase: [],

      concilStatuses: [],

      loadingGif: __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67),

      columns: [],

      options: {
        filterable: false,
        perPage: 5,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: null
        },
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 }
      },
      invalid: false,

      toDate: new Date(),

      fromDate: new Date('December 31, 2999 23:59:59'),

      inputDate: null,

      taskHistory: [],

      activeTask: null,

      taskOcurrence: {
        situacao: {},
        observacaoHistorico: ''
      },

      operators: [],

      treeViewButtonTitle: {
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher')
      },

      isVisualisingTask: false,

      autoConcludeSelectedSize: 0,
      disabledBtnChangeStatusTask: true,
      erroDataDeVencimento: false,
      canEditTask: true,
      showActionButtons: true,
      defaultObject: null,
      tarefaStatuses: [],

      disabledBtnSaveTask: false
    };
  },


  props: {
    idMovimento: {
      type: String,
      default: null
    },

    tipoMovimento: {
      type: String,
      default: null
    },

    statusMovimento: {
      type: String,
      default: null
    },

    idTarefa: {
      type: String,
      default: null
    }
  },

  watch: {
    task: {
      handler: function handler() {
        if (this.defaultObject !== null && !this.alreadySaved) {
          this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, this.task));
        }
      },

      deep: true
    }
  },

  computed: (0, _assign2.default)({
    hintNoMovment: function hintNoMovment() {
      return this.$t('consultaTarefa.labels.tarefaLancamentoRemovido');
    },
    statusesBase: function statusesBase() {
      return [{
        id: 'A',
        nome: this.$t('statusConciliacao.aberto')
      }, {
        id: 'C',
        nome: this.$t('statusConciliacao.conciliado')
      }, {
        id: 'M',
        nome: this.$t('statusConciliacao.conciliadoManualmente')
      }, {
        id: 'D',
        nome: this.$t('statusConciliacao.divergente')
      }, {
        id: 'N',
        nome: this.$t('statusConciliacao.naoAplicavel')
      }];
    },
    tarefaTipoVinculo: function tarefaTipoVinculo() {
      return [{
        id: 'MF',
        nome: this.$t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoMF')
      }, {
        id: 'CL',
        nome: this.$t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoCL')
      }];
    },
    loggedUser: function loggedUser() {
      return this.$store.getters.user;
    },
    loggedUserId: function loggedUserId() {
      return this.$store.getters.userId;
    },
    datePickerLanguage: function datePickerLanguage() {
      return _index2.default.getDatePickerLanguageObject();
    },
    messageEmail: function messageEmail() {
      return this.$t('tarefaEmMassa.titulos.enviarEmail');
    },
    createEditTask: function createEditTask() {
      return !this.isLoadingTaskData && this.isManagingTask;
    },
    noTasksBonded: function noTasksBonded() {
      return !this.isLoadingTaskData && !this.hadTasksBonded && !this.isManagingTask;
    },
    withTaskBonded: function withTaskBonded() {
      return !this.isLoadingTaskData && this.hadTasksBonded && !this.isManagingTask;
    },
    taskDetailsHeaderTitle: function taskDetailsHeaderTitle() {
      return this.hasActiveTask ? this.$t('modalDetalhesLanc.tabTarefas.titulos.lancamentoComTarefaAtiva') : this.$t('modalDetalhesLanc.tabTarefas.titulos.lancamentoSemTarefaAtiva');
    },
    taskDetailsHeaderButton: function taskDetailsHeaderButton() {
      return this.hasActiveTask ? this.$t('modalDetalhesLanc.tabTarefas.labels.detalheTarefa') : this.$t('modalDetalhesLanc.tabTarefas.labels.novaTarefa');
    },
    tipAcaoDetalhes: function tipAcaoDetalhes() {
      return this.$t('modalDetalhesLanc.tabTarefas.labels.verDetalhe');
    },
    canReopenTask: function canReopenTask() {
      return this.isVisualisingTask && !this.hasActiveTask;
    },
    canAssignToTask: function canAssignToTask() {
      return this.loggedUserId !== this.activeTask.responsavel.id;
    },
    canPerformTaskAction: function canPerformTaskAction() {
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(209) >= 0;
    },
    dueDateFormatted: function dueDateFormatted() {
      if (this.activeTask.dataVencimento && typeof this.activeTask.dataVencimento === 'number') {
        return (0, _moment2.default)(this.activeTask.dataVencimento).format('l');
      } else {
        return this.activeTask.dataVencimento;
      }
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      return this.$store.getters.hasUnsavedChanges;
    },


    task: {
      get: function get() {
        return this.$store.getters.task;
      },
      set: function set(task) {
        return this.$store.dispatch('setTask', task);
      }
    }
  }, (0, _vuex.mapGetters)(['hadTasksBonded', 'isLoadingTaskData', 'isManagingTask', 'hasActiveTask'])),

  mounted: function mounted() {
    var _this = this;

    this.resetTaskStatuses();
    this.erroDataDeVencimento = false;
    this.disabledBtnChangeStatusTask = true;
    this.$store.dispatch('clearFlagsTasks');
    this.$nextTick(function () {
      _this.$validator.reset();
    });
  },


  methods: {
    resetTaskStatuses: function resetTaskStatuses(isCreatingTask) {
      this.tarefaStatuses = [{
        id: 0,
        nome: this.$t('tarefaEmMassa.tarefaStatuses.pendente')
      }, {
        id: 10,
        nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
      }, {
        id: 20,
        nome: this.$t('tarefaEmMassa.tarefaStatuses.aguardando')
      }];

      if (!isCreatingTask) {
        this.tarefaStatuses.push({
          id: 90,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.concluido')
        }, {
          id: 99,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.cancelada')
        });
      }
    },
    setResponsible: function setResponsible(responsible) {
      return {
        id: responsible.id,
        nome: responsible.nome,
        senhaBloqueada: responsible.senhaBloqueada,
        numeroTentativa: responsible.numeroTentativa,
        idEntidade: responsible.idEntidade,
        nomeEntidade: responsible.nomeEntidade,
        name: responsible.name
      };
    },
    setHistoric: function setHistoric(historic) {
      return historic.map(function (history) {
        return {
          id: history.id,
          descricao: history.descricao,
          data: history.data,
          usuario: {
            nome: history.usuario ? history.usuario.nome : ' - '
          },
          situacao: history.situacao,
          idTransacao: history.idTransacao
        };
      });
    },
    onDescriptionChanged: function onDescriptionChanged(ev) {
      ev.currentTarget.value !== '' || this.activeTask.situacao.id !== this.taskOcurrence.situacao.id ? this.disabledBtnChangeStatusTask = false : this.disabledBtnChangeStatusTask = true;

      if (!this.taskOcurrence.situacao) this.disabledBtnChangeStatusTask = true;
    },
    onSituationChanged: function onSituationChanged(situation) {
      this.taskOcurrence.situacao = situation;

      if (situation) {
        this.activeTask.situacao.id !== situation.id || this.taskOcurrence.observacaoHistorico !== '' ? this.disabledBtnChangeStatusTask = false : this.disabledBtnChangeStatusTask = true;
      } else {
        this.disabledBtnChangeStatusTask = true;
      }
    },
    closeModal: function closeModal(idModal) {
      var _this2 = this;

      this.disabledBtnChangeStatusTask = true;
      this.disabledBtnSaveTask = false;
      this.$nextTick(function () {
        _this2.$validator.reset();
      });
      $('#' + idModal).modal('hide');
    },
    startLoading: function startLoading() {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: true,
        hasBondedTask: false,
        managingTask: this.isManagingTask
      });
    },
    noTaskExisting: function noTaskExisting() {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: false,
        hasBondedTask: false,
        managingTask: this.isManagingTask
      });
    },
    hasTaskHistory: function hasTaskHistory() {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: false,
        hasBondedTask: true,
        managingTask: this.isManagingTask
      });
    },
    managingTask: function managingTask() {
      this.$store.dispatch('setTaskConfiguration', {
        isLoadingTask: false,
        hasBondedTask: this.hadTasksBonded,
        managingTask: true
      });

      this.preparteForm();
    },
    concatStatusesAutoConcluede: function concatStatusesAutoConcluede(conclusoesAutomaticas) {
      if (!conclusoesAutomaticas || conclusoesAutomaticas.length === 0) {
        return ' - ';
      } else {
        var statuses = '';
        conclusoesAutomaticas.forEach(function (sigla) {
          statuses += (0, _statusesTranslator.conciliationStatusTranslate)(sigla.situacaoConciliacao) + '|';
        });
        return statuses.substring(0, statuses.length - 1);
      }
    },
    loadTaskDetail: function loadTaskDetail() {
      var _this3 = this;

      this.isVisualisingTask = false;
      this.startLoading();
      this.resetTaskData();
      this.resetActiveTaskData();
      this.initializeBaseConcilList();

      var self = this;
      this.$store.dispatch('getTaskDetails', this.idTarefa).then(function (response) {
        var details = response.data;
        _this3.setDetailTaskVisual(details, self);
      }).catch(function (error) {
        self.$root.$refs.notification.error(error.message);
      });
    },
    loadTaskData: function loadTaskData(clearTaskData) {
      var _this4 = this;

      this.startLoading();
      var param = {
        tipoVinculo: this.tipoMovimento === 'MovFin' ? 'MF' : 'CL',
        idVinculo: this.idMovimento
      };

      if (clearTaskData) {
        this.resetTaskData();
        this.resetActiveTaskData();
      }

      this.initializeBaseConcilList();
      var self = this;
      this.$store.dispatch('loadTasksFromStatement', param).then(function (response) {
        _this4.resetTaskStatuses();
        _this4.alreadySaved = false;
        _this4.options.perPage = 10;
        var responseHistory = [];
        var taskResult = response.data.data;
        if (!taskResult || taskResult.length === 0) {
          self.noTaskExisting();
        } else {
          taskResult.forEach(function (task) {
            if (task.tarefa.situacao === 90 || task.tarefa.situacao === 99) {
              responseHistory.push(task.tarefa);
            } else {
              self.activeTask = {
                id: task.tarefa.id,
                nome: task.tarefa.nome,
                tipoVinculo: {
                  id: task.tarefa.tipoVinculo,
                  nome: (0, _statusesTranslator.taskBondTypeTranslate)(task.tarefa.tipoVinculo)
                },
                responsavel: {
                  id: task.tarefa.usuarioResponsavel.idUsuario,
                  nome: task.tarefa.usuarioResponsavel.nome
                },
                situacao: {
                  id: task.tarefa.situacao
                },
                dataAlteracao: task.tarefa.dataAlteracao,
                dataVencimento: task.tarefa.dataVencimento ? task.tarefa.dataVencimento : ' - ',
                descricao: task.tarefa.descricao,
                historico: _this4.setHistoric(task.tarefa.historico),
                situacoesConclusaoAutomatica: task.tarefa.conclusoesAutomaticas,
                conclusoesAutomaticas: task.tarefa.conclusoesAutomaticas ? _this4.concatStatusesAutoConcluede(task.tarefa.conclusoesAutomaticas) : ' - '
              };
              self.taskOcurrence.situacao.id = task.tarefa.situacao;
              self.taskOcurrence.situacao.nome = (0, _statusesTranslator.taskStatusesTranslate)(task.tarefa.situacao);
              _this4.options.perPage = 5;
              _this4.$store.dispatch('setHasActiveTask', true);
            }
          });
          self.hasTaskHistory();
          self.prepareTaskHistoryList(responseHistory);
        }
        _this4.disabledBtnChangeStatusTask = true;
      }).catch(function (error) {
        _this4.$root.$refs.notification.error(error);
        _this4.closeModal();
      });
    },
    setDetailTaskVisual: function setDetailTaskVisual(details, self) {
      this.showActionButtons = false;
      self.task = {};
      self.task.id = details.id;
      self.task.nome = details.nome;
      self.task.descricao = details.descricao;
      self.task.dataAlteracao = details.dataAlteracao;
      self.task.dataVencimento = details.dataVencimento ? (0, _moment2.default)(details.dataVencimento) : null;
      self.task.tipoVinculo = {
        id: details.tipoVinculo,
        nome: (0, _statusesTranslator.taskBondTypeTranslate)(details.tipoVinculo)
      };
      self.task.situacao = {
        id: details.situacao,
        nome: (0, _statusesTranslator.taskStatusesTranslate)(details.situacao)
      };
      if (details.usuarioResponsavel) {
        self.task.responsavel = {
          id: details.usuarioResponsavel.idUsuario,
          nome: details.usuarioResponsavel.nome
        };
      }
      self.task.conclusaoAutomatica = [];
      if (details.conclusoesAutomaticas && details.conclusoesAutomaticas.length > 0) {
        details.conclusoesAutomaticas.forEach(function (status) {
          self.task.conclusaoAutomatica.push({
            id: status.situacaoConciliacao,
            nome: (0, _statusesTranslator.conciliationStatusTranslate)(status.situacaoConciliacao)
          });
        });
        self.task.conclusoesAutomaticas = self.concatStatusesAutoConcluede(details.conclusoesAutomaticas);
      } else {
        self.task.conclusoesAutomaticas = ' - ';
      }
      self.task.historico = details.historico;
      self.isVisualisingTask = true;
      self.managingTask();
    },
    resetTaskData: function resetTaskData() {
      this.erroDataDeVencimento = false;

      this.$store.dispatch('setEmptyTask');
      this.$store.dispatch('setTask', {
        situacao: {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        }
      });

      var tipoVinculo = {};

      if (this.tipoMovimento === 'MovBan') {
        tipoVinculo = {
          id: 'CL',
          nome: this.$t('tarefaEmMassa.labels.tipoCl')
        };
      } else {
        tipoVinculo = {
          id: 'MF',
          nome: this.$t('tarefaEmMassa.labels.tipoMf')
        };
      }

      this.$store.dispatch('setTask', { tipoVinculo: tipoVinculo });
      this.currentTask = this.task;

      this.autoConcludeSelectedSize = 0;
      this.concilStatuses = this.concilStatusesBase.slice();
    },
    resetActiveTaskData: function resetActiveTaskData() {
      this.$store.dispatch('setHasActiveTask', false);
      this.activeTask = null;
      this.defaultObject = null;
    },
    preparteForm: function preparteForm() {
      var _this5 = this;

      setTimeout(function () {
        _this5.inputDate = document.getElementById('dataVencimento');
        if (_this5.inputDate) {
          _this5.inputDate.setAttribute('autocomplete', 'off');
          _this5.inputDate.addEventListener('blur', function () {
            _promise2.default.resolve(_this5.validateDate());
          });
        }
      }, 100);
    },
    loadOperators: function loadOperators() {
      var _this6 = this;

      this.$store.dispatch('getOperatorsWithTaskPermission').then(function (activeOperators) {
        _this6.operators = activeOperators;

        var idUsuario = _this6.task.responsavel ? _this6.task.responsavel.id : _this6.loggedUserId;
        _this6.operators.forEach(function (op) {
          if (op.id === idUsuario) {
            _this6.task.responsavel = _this6.setResponsible(op);
          }
        });
        if (!_this6.task.responsavel) {
          _this6.task.responsavel = _this6.operators[0];
        }
        _this6.defaultObject = (0, _assign2.default)({}, _this6.task);
        _this6.defaultObject.responsavel = _this6.setResponsible(_this6.task.responsavel);
        _this6.managingTask();
      });
    },
    validateDate: function validateDate() {
      var _this7 = this;

      return new _promise2.default(function (resolve) {
        var isValid = _this7.inputDate.value.length === 10 && _customValidator2.default.isValidDate(_this7.inputDate.value);
        if (!isValid) {
          _this7.task.dataVencimento = null;
          _this7.$refs.dataVencimento.$children.find(function (item) {
            return !!item.id;
          }).typedDate = '';
        }
        resolve();
      });
    },
    dataDeVencimentoValida: function dataDeVencimentoValida() {
      if (this.task.dataVencimento) {
        var today = new Date();
        var yesterday = today.setDate(today.getDate() - 1);
        var validDate = false;

        validDate = this.task.dataVencimento.getTime() > yesterday;

        this.erroDataDeVencimento = !validDate;

        return validDate;
      }

      return true;
    },
    validate: function validate() {
      var _this8 = this;

      var previousDate = void 0;
      var newDate = new Date(this.task.dataVencimento).getTime();

      this.activeTask ? previousDate = new Date(this.activeTask.dataVencimento).getTime() : previousDate = false;

      var self = this;

      this.$validator.validateAll().then(function (result) {
        if (result && _this8.activeTask !== null && previousDate === newDate || result && _this8.dataDeVencimentoValida() || result && _this8.task.dataVencimento === null) {
          self.salvarTarefa();
          _this8.alreadySaved = true;
          self.$nextTick(function () {
            self.$validator.reset();
          });
        } else if (previousDate !== newDate && !self.dataDeVencimentoValida()) {
          self.task.dataVencimento === null ? self.erroDataDeVencimento = false : self.erroDataDeVencimento = true;
        }
      });
    },
    salvarTarefa: function salvarTarefa() {
      var _this9 = this;

      this.disabledBtnSaveTask = true;

      var newTask = {
        id: this.task.id,
        dataCriacao: new Date(),
        dataVencimento: this.task.dataVencimento,
        nome: this.task.nome,
        descricao: this.task.descricao,
        tipoVinculo: this.task.tipoVinculo.id,
        situacao: this.task.situacao.id,
        idVinculo: this.idMovimento,
        dataAlteracao: this.task.dataAlteracao,
        usuarioResponsavel: {
          idUsuario: this.task.responsavel.id
        },
        enviarEmail: this.task.enviarEmail,
        situacoesConclusaoAutomatica: []
      };

      this.task.conclusaoAutomatica.forEach(function (status) {
        newTask.situacoesConclusaoAutomatica.push(status.id);
      });

      this.$store.dispatch('createNewTask', newTask).then(function (response) {
        _this9.$root.$refs.notification.success(response.data.message);
        _this9.resetTaskData();
        _this9.task && _this9.task.id ? _this9.viewOldTask(_this9.task, true) : _this9.loadTaskData();
        _this9.$store.dispatch('setIsManagingTask', false);
        _closeModal2.default.$emit('taskChange', true);
        _this9.$store.dispatch('setHasUnsavedChanges', false);
        _this9.$nextTick(function () {
          _this9.$validator.reset();
        });
        _this9.disabledBtnSaveTask = false;
      }).catch(function (error) {
        _this9.disabledBtnSaveTask = false;
        _this9.$root.$refs.notification.error(error.message);
      });
    },
    mountTaskHistoryDataTable: function mountTaskHistoryDataTable() {
      this.columns = ['acoes', 'nome', 'descricao', 'tipoVinculo', 'responsavel', 'data'];

      this.options.headings = {
        acoes: '',
        nome: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colNome'),
        descricao: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'),
        tipoVinculo: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colTipo'),
        responsavel: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colRes'),
        data: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colData')
      };

      this.options.columnsClasses = {
        acoes: 'col-1',
        nome: 'col-1 limit-char',
        descricao: 'col-1 limit-char',
        tipoVinculo: 'col-1 limit-char',
        responsavel: 'col-1 limit-char',
        data: 'col-1 limit-char'
      };
      this.sortable = ['nome', 'descricao', 'tipoVinculo', 'responsavel', 'data'];
      this.options.orderBy = 'nome';
    },
    prepareTaskHistoryList: function prepareTaskHistoryList(responseHistory) {
      var _this10 = this;

      this.taskHistory = [];
      if (responseHistory && responseHistory.length > 0) {
        responseHistory.forEach(function (item) {
          _this10.taskHistory.push({
            id: item.id,
            nome: item.nome,
            descricao: item.descricao,
            tipoVinculo: item.tipoVinculo === 'MF' ? _this10.tarefaTipoVinculo[0].nome : _this10.tarefaTipoVinculo[1].nome,
            responsavel: item.usuarioResponsavel ? item.usuarioResponsavel.nome : ' - ',
            data: item.dataVencimento ? (0, _moment2.default)(item.dataVencimento).format('l') : ' - '
          });
        });
      }
      this.mountTaskHistoryDataTable();
    },
    updateTaskStatus: function updateTaskStatus() {
      var _this11 = this;

      this.disabledBtnChangeStatusTask = true;

      var taskOcur = {
        id: this.activeTask.id,
        tipoVinculo: this.activeTask.tipoVinculo.id,
        situacao: this.taskOcurrence.situacao.id,
        observacaoHistorico: this.taskOcurrence.observacaoHistorico,
        idVinculo: this.idMovimento,
        dataAlteracao: this.activeTask.dataAlteracao
      };

      this.$store.dispatch('saveTaskOcurrence', taskOcur).then(function (response) {
        _this11.resetActiveTaskData();
        _this11.loadTaskData();
        _this11.taskOcurrence = {
          situacao: {},
          observacaoHistorico: ''
        };
        _this11.$root.$refs.notification.success(response.data.message);
        _closeModal2.default.$emit('taskChange', true);
        _this11.$nextTick(function () {
          _this11.$validator.reset();
        });
      }).catch(function (error) {
        _this11.disabledBtnChangeStatusTask = false;
        _this11.$root.$refs.notification.error(error.message);
      });
    },
    manageTask: function manageTask() {
      this.erroDataDeVencimento = false;

      this.resetTaskData();
      this.isVisualisingTask = false;
      if (this.hasActiveTask) {
        var task = {
          id: this.activeTask.id,
          nome: this.activeTask.nome,
          tipoVinculo: this.activeTask.tipoVinculo,
          descricao: this.activeTask.descricao,
          situacao: {
            id: this.activeTask.situacao.id,
            nome: this.activeTask.situacao.nome ? this.activeTask.situacao.nome : (0, _statusesTranslator.taskStatusesTranslate)(this.activeTask.situacao.id)
          },
          dataAlteracao: this.activeTask.dataAlteracao,
          dataVencimento: this.activeTask.dataVencimento && this.activeTask.dataVencimento !== ' - ' ? new Date(this.activeTask.dataVencimento) : null,
          responsavel: this.activeTask.responsavel,
          conclusaoAutomatica: [],
          enviarEmail: false
        };
        this.autoConcludeSelectedSize = this.activeTask.situacoesConclusaoAutomatica ? this.activeTask.situacoesConclusaoAutomatica.length : this.activeTask.conclusaoAutomatica ? this.activeTask.conclusaoAutomatica.length : 0;
        if (this.activeTask.situacoesConclusaoAutomatica && this.activeTask.situacoesConclusaoAutomatica.length > 0) {
          this.activeTask.situacoesConclusaoAutomatica.forEach(function (status) {
            task.conclusaoAutomatica.push({
              id: status.situacaoConciliacao,
              nome: (0, _statusesTranslator.conciliationStatusTranslate)(status.situacaoConciliacao)
            });
          });
        } else if (this.activeTask.conclusaoAutomatica && this.activeTask.conclusaoAutomatica.length > 0) {
          this.activeTask.conclusaoAutomatica.forEach(function (status) {
            task.conclusaoAutomatica.push({
              id: status.id,
              nome: (0, _statusesTranslator.conciliationStatusTranslate)(status.nome)
            });
          });
        }
        this.changeAutoConcludeList(this.task.conclusaoAutomatica);
        if (this.activeTask.historico && this.activeTask.historico.length > 0) {
          task.historico = this.activeTask.historico.slice();
        }
        this.$store.dispatch('setTask', task);
      }

      this.startLoading();

      this.loadOperators();
    },
    cancelManagement: function cancelManagement() {
      this.loadTaskData(true);
      this.$store.dispatch('setIsManagingTask', false);
    },
    goBack: function goBack() {
      if (this.hasUnsavedChanges && !(0, _popExitingConfirmation2.default)()) {
        return;
      }
      this.$store.dispatch('setHasUnsavedChanges', false);
      this.viewOldTask();
    },
    viewOldTask: function viewOldTask(oldTask, isEdit) {
      var _this12 = this;

      if (isEdit) {
        this.canEditTask = true;
      } else {
        if (oldTask) {
          this.canEditTask = false;
        } else {
          this.canEditTask = true;
        }
      }
      var self = this;
      if (oldTask || self.activeTask) {
        this.$store.dispatch('getTaskDetails', oldTask ? oldTask.id : self.activeTask.id).then(function (response) {
          var details = response.data;
          var task = {};
          task.id = details.id;
          task.nome = details.nome;
          task.tipoVinculo = {
            id: details.tipoVinculo,
            nome: (0, _statusesTranslator.taskBondTypeTranslate)(details.tipoVinculo)
          };
          task.descricao = details.descricao;
          task.situacao = {
            id: details.situacao,
            nome: (0, _statusesTranslator.taskStatusesTranslate)(details.situacao)
          };
          task.dataAlteracao = details.dataAlteracao;
          task.dataVencimento = details.dataVencimento ? (0, _moment2.default)(details.dataVencimento) : null;
          if (details.usuarioResponsavel) {
            task.responsavel = _this12.setResponsible(details.usuarioResponsavel);
          }
          task.conclusaoAutomatica = [];
          if (details.conclusoesAutomaticas && details.conclusoesAutomaticas.length > 0) {
            details.conclusoesAutomaticas.forEach(function (status) {
              task.conclusaoAutomatica.push({
                id: status.situacaoConciliacao,
                nome: (0, _statusesTranslator.conciliationStatusTranslate)(status.situacaoConciliacao)
              });
            });
            task.conclusoesAutomaticas = self.concatStatusesAutoConcluede(details.conclusoesAutomaticas);
          } else {
            task.conclusoesAutomaticas = ' - ';
          }
          task.historico = _this12.setHistoric(details.historico);
          self.isVisualisingTask = true;
          if (isEdit) {
            self.activeTask = task;
          }
          self.$store.dispatch('setTask', task);
          self.currentTask = task;
          self.managingTask();
        }).catch(function (error) {
          self.$root.$refs.notification.error(error.message);
        });
      } else {
        self.isVisualisingTask = false;
        this.resetTaskData();
        self.managingTask();
        self.resetTaskStatuses(true);
        self.loadOperators();
      }
    },
    reopenTask: function reopenTask() {
      var _this13 = this;

      var task = {
        id: this.task.id,
        tipoVinculo: this.task.tipoVinculo.id,
        idVinculo: this.idMovimento,
        dataAlteracao: this.task.dataAlteracao
      };

      this.$store.dispatch('reopenTask', task).then(function (response) {
        _this13.isVisualisingTask = false;
        _this13.loadTaskData();
        _this13.viewOldTask(_this13.task, true);
        _this13.$root.$refs.notification.success(response.data.message);
        _closeModal2.default.$emit('taskChange', true);
        _this13.$nextTick(function () {
          _this13.$validator.reset();
        });
      }).catch(function (error) {
        _this13.$root.$refs.notification.error(error.message);
      });
    },
    formatDate: function formatDate(date) {
      return (0, _moment2.default)(date).format('l');
    },
    assignTaskToLoggedUser: function assignTaskToLoggedUser() {
      var _this14 = this;

      var task = {
        id: this.activeTask.id,
        idVinculo: this.idMovimento,
        dataAlteracao: this.activeTask.dataAlteracao,
        usuarioResponsavel: {
          idUsuario: this.loggedUserId
        },
        situacoesConclusaoAutomatica: []
      };
      if (this.activeTask.situacoesConclusaoAutomatica && this.activeTask.situacoesConclusaoAutomatica.length > 0) {
        this.activeTask.situacoesConclusaoAutomatica.forEach(function (status) {
          task.situacoesConclusaoAutomatica.push(status.situacaoConciliacao);
        });
      }
      this.$store.dispatch('assignTaskToLoggedUser', task).then(function (response) {
        _this14.loadTaskData();
        _this14.$root.$refs.notification.success(response.data.message);
        _closeModal2.default.$emit('taskChange', true);
        _this14.$nextTick(function () {
          _this14.$validator.reset();
        });
      }).catch(function (error) {
        _this14.$root.$refs.notification.error(error.message);
      });
    },
    startTask: function startTask() {
      this.resetActiveTaskData();
      this.resetTaskStatuses(true);
      this.manageTask();
    },
    changeAutoConcludeList: function changeAutoConcludeList(selectDataTableDinamicColumn) {
      var _this15 = this;

      if (this.autoConcludeSelectedSize > 0 && selectDataTableDinamicColumn && this.autoConcludeSelectedSize <= selectDataTableDinamicColumn.length) {
        var selected = selectDataTableDinamicColumn[selectDataTableDinamicColumn.length - 1];

        this.concilStatuses = _underscore2.default.without(this.concilStatuses, selected);

        this.autoConcludeSelectedSize++;
      } else {
        this.concilStatuses = this.concilStatusesBase.slice();
        selectDataTableDinamicColumn.forEach(function (item) {
          var index = _this15.concilStatuses.findIndex(function (dinamicColumn) {
            return dinamicColumn.id === item.id;
          });
          _this15.concilStatuses.splice(index, 1);
        });

        this.autoConcludeSelectedSize--;
      }
      this.setTask('conclusaoAutomatica', selectDataTableDinamicColumn);
    },
    initializeBaseConcilList: function initializeBaseConcilList() {
      var _this16 = this;

      if (this.statusMovimento) {
        var index = this.statusesBase.findIndex(function (dinamicColumn) {
          return dinamicColumn.id === _this16.statusMovimento;
        });
        var status = this.statusesBase[index];
        this.concilStatusesBase = _underscore2.default.without(this.statusesBase, status);
      }
    },
    setTask: function setTask(prop, value) {
      this.currentTask[prop] = value;
      this.$store.dispatch('setTask', (0, _defineProperty3.default)({}, prop, value));
    },
    selectSituacao: function selectSituacao(newSituacao) {
      this.setTask('situacao', newSituacao);
    },
    clearManagementTask: function clearManagementTask() {
      this.$store.dispatch('clearFlagsTasks');
      this.resetTaskData();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 842 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/massDeclassifyModal/MassDeclassifyModal.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _ConfirmModal = __webpack_require__(/*! ../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _Modal = __webpack_require__(/*! ../../modals/modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _numberMasker = __webpack_require__(/*! ../../../utils/numberMasker.js */ 71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MassDeclassifyModal',

  components: {
    vSelect: _vueSelect2.default,
    ConfirmModal: _ConfirmModal2.default,
    Modal: _Modal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    id: {
      type: String,
      required: true
    },
    gridId: {
      type: String,
      required: true
    },
    listIdExt: {
      type: Array,
      required: true
    },
    listRowsD: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      columns: [],
      options: {
        columnsClasses: {},
        headings: {},
        filterable: false,
        perPageValues: [],
        perPage: 5,
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filter: null,
          filterPlaceholder: null
        },
        pagination: {},
        sortable: [],
        sortIcon: {
          is: ''
        }
      },
      items: [],
      idsContalancamento: [],
      idsContalancamentoDesclassificaveis: [],
      message: null,
      invalid: false,
      isLoadingData: false
    };
  },


  computed: {
    loggedUser: function loggedUser() {
      return this.$store.getters.user;
    },
    modalTitle: function modalTitle() {
      return this.$t('desclassificacaoEmMassa.titulos.titulo');
    },
    modalSubtitle: function modalSubtitle() {
      return this.$t('desclassificacaoEmMassa.titulos.subtitulo');
    },
    portletTable: function portletTable() {
      return this.$t('desclassificacaoEmMassa.titulos.portletTable') + ': ' + this.items.length;
    },
    portletForm: function portletForm() {
      return this.$t('desclassificacaoEmMassa.titulos.portletForm') + ': ' + (this.listIdExt.length - this.items.length);
    },
    enableSave: function enableSave() {
      return this.items.length > 0 && this.items.length < 101;
    }
  },

  watch: {
    listRowsD: function listRowsD() {
      var _this = this;

      this.$nextTick(function () {
        _this.$validator.reset();
      });
      this.showDataTableD();
      this.isLoadingData = false;
    }
  },

  methods: {
    openModalConfirm: function openModalConfirm() {
      $('#confirmDeclassifyMass').modal('show');
    },
    closeModalConfirm: function closeModalConfirm() {
      $('#confirmDeclassifyMass').modal('hide');
    },
    validateD: function validateD() {
      var _this2 = this;

      this.closeModalConfirm();
      this.isLoadingData = true;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.desclassificarEmMassa();
          _this2.$nextTick(function () {
            _this2.$validator.reset();
          });
        } else {
          _this2.isLoadingData = false;
        }
      });
    },
    desclassificarEmMassa: function desclassificarEmMassa() {
      var _this3 = this;

      this.items.forEach(function (item) {
        _this3.idsContalancamentoDesclassificaveis.push(item.IdLancamento);
      });
      var data = {
        idsContaLancamento: this.idsContalancamentoDesclassificaveis
      };
      this.idsContalancamentoDesclassificaveis = [];
      this.$store.dispatch('declassifyBankMovementList', data).then(function (response) {
        _this3.$root.$refs.notification.success(response.message);
        _this3.isLoadingData = false;
        $('#' + _this3.id).modal('hide');
      }).catch(function (error) {
        _this3.isLoadingData = false;
        _this3.$root.$refs.notification.error(error.message);
      });
    },
    trackCloseEvent: function trackCloseEvent() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$validator.reset();
      });
      (0, _analytics.trackAnalyticsEvent)(this, 'mass-declassify-modal', 'titlebar-close-click', this.id);
      $('#' + this.id).modal('hide');
    },
    showDataTableD: function showDataTableD() {
      var _this5 = this;

      this.idsContalancamento = this.listIdExt;
      switch (this.gridId) {
        case 'ExtratoConta':
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt).then(function () {
            _this5.mountDataTableBankStat();
          });
          break;
      }
    },
    prepareList: function prepareList() {
      var _this6 = this;

      this.items = [];
      this.listRowsD.forEach(function (item) {
        if (item['SituacaoConcil'] === 'A') {
          _this6.items.push({
            ID: item.IdLancamento,
            IdLancamento: item.IdLancamento,
            DsHistorico: item.DsHistorico,
            DtLanc: item.DtLanc ? _moment2.default.utc(item.DtLanc).format('l') : ' - ',
            Banco: item.Banco ? item.Banco : ' - ',
            NomeConta: item.NomeConta ? item.NomeConta : ' - ',
            Agencia: item.Agencia ? item.Agencia : ' - ',
            NrConta: item.NrConta ? item.NrConta : ' - ',
            Valor: (0, _numberMasker.maskThousand)(item.Tipo === 'C' ? item.VlLancCred : item.VlLancDeb),
            CritClassif: item.CritClassif && item.CritClassif !== _this6.$t('extratoBancario.labels.naoClassificado') ? item.CritClassif : _this6.$t('desclassificacaoEmMassa.labels.classificadoManualmente')
          });
        }
      });
    },
    removeEntry: function removeEntry(entry) {
      var _this7 = this;

      var index = -1;
      this.items.forEach(function (item) {
        if (item.ID === entry.ID) {
          index = _this7.items.indexOf(item);
        }
      });
      if (index >= 0) {
        this.items.splice(index, 1);
      }
      switch (this.gridId) {
        case 'ExtratoConta':
          var indexCL = this.idsContalancamento.findIndex(function (item) {
            return item === entry.ID;
          });
          if (indexCL >= 0) {
            this.idsContalancamento.splice(indexCL, 1);
          }
          break;
      }
    },
    mountDataTableBankStat: function mountDataTableBankStat() {
      this.prepareList();
      this.columns = ['IdLancamento', 'DtLanc', 'Valor', 'DsHistorico', 'CritClassif', 'Banco', 'NomeConta', 'Agencia', 'NrConta', 'acoes'];
      this.options.headings = {
        IdLancamento: this.$t('desclassificacaoEmMassa.colunas.IdLancamento'),
        DtLanc: this.$t('desclassificacaoEmMassa.colunas.DtLanc'),
        Banco: this.$t('desclassificacaoEmMassa.colunas.Banco'),
        NomeConta: this.$t('desclassificacaoEmMassa.colunas.NomeConta'),
        Agencia: this.$t('desclassificacaoEmMassa.colunas.Agencia'),
        NrConta: this.$t('desclassificacaoEmMassa.colunas.NrConta'),
        Valor: this.$t('desclassificacaoEmMassa.colunas.Valor'),
        CritClassif: this.$t('desclassificacaoEmMassa.colunas.CritClassif'),
        DsHistorico: this.$t('desclassificacaoEmMassa.colunas.DsHistorico'),
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      };
      this.options.columnsClasses = {
        'IdLancamento': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Banco': 'col-1 limit-char',
        'NomeConta': 'col-1 limit-char',
        'Agencia': 'col-1 limit-char',
        'NrConta': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'CritClassif': 'col-1 limit-char',
        'acoes': 'col-1',
        'DsHistorico': 'col-1 limit-char'
      };
      this.options.orderBy = 'IdLancamento';
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 843 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/massTaskModal/MassTaskModal.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _ConfirmModal = __webpack_require__(/*! ../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _Modal = __webpack_require__(/*! ../../modals/modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _index = __webpack_require__(/*! ../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _numberMasker = __webpack_require__(/*! ../../../utils/numberMasker.js */ 71);

var _statusesTranslator = __webpack_require__(/*! ../../../utils/statusesTranslator.js */ 162);

var _customValidator = __webpack_require__(/*! ../../../utils/customValidator.js */ 106);

var _customValidator2 = _interopRequireDefault(_customValidator);

var _idSituacaoTarefa = __webpack_require__(/*! ../../../enum/idSituacaoTarefa */ 200);

var _idSituacaoTarefa2 = _interopRequireDefault(_idSituacaoTarefa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

exports.default = {
  name: 'MassTaskModal',

  components: {
    vSelect: _vueSelect2.default,
    Datepicker: _vuejsDatepicker2.default,
    ConfirmModal: _ConfirmModal2.default,
    Modal: _Modal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    id: {
      type: String,
      required: true
    },
    gridId: {
      type: String,
      required: true
    },
    listIdExt: {
      type: Array,
      required: true
    },
    listIdMov: {
      type: Array,
      required: true
    },
    listRows: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      tarefaStatuses: [{
        id: 0,
        nome: this.$t('tarefaEmMassa.tarefaStatuses.pendente')
      }, {
        id: 10,
        nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
      }, {
        id: 20,
        nome: this.$t('tarefaEmMassa.tarefaStatuses.aguardando')
      }],
      concilStatuses: [{
        id: 'A',
        nome: this.$t('statusConciliacao.aberto')
      }, {
        id: 'C',
        nome: this.$t('statusConciliacao.conciliado')
      }, {
        id: 'M',
        nome: this.$t('statusConciliacao.conciliadoManualmente')
      }, {
        id: 'D',
        nome: this.$t('statusConciliacao.divergente')
      }, {
        id: 'N',
        nome: this.$t('statusConciliacao.naoAplicavel')
      }],
      concilStatusesTransformed: [],
      columns: [],
      options: {
        columnsClasses: {},
        headings: {},
        filterable: false,
        perPageValues: [],
        perPage: 5,
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filter: null,
          filterPlaceholder: null
        },
        pagination: {},
        sortable: [],
        sortIcon: {
          is: ''
        }
      },
      items: [],
      task: {
        nome: '',
        tipoVinculo: '',
        descricao: '',
        situacao: {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        },
        dtVencimento: new Date(),
        responsavel: null,
        conclusaoAutomatica: [],
        enviarEmail: false,
        idsMovimentosFinanceiros: [],
        idsContalancamento: []
      },
      message: null,
      invalid: false,
      toDate: new Date(),
      fromDate: new Date('December 31, 2999 23:59:59'),
      inputDate: null,
      isLoadingData: false,
      operators: [],
      hasAtLeastOneElegibleStatment: false,
      erroDataDeVencimento: false
    };
  },


  computed: {
    loggedUser: function loggedUser() {
      return this.$store.getters.user;
    },
    loggedUserEmail: function loggedUserEmail() {
      return this.$store.getters.userEmail;
    },
    datePickerLanguage: function datePickerLanguage() {
      return _index2.default.getDatePickerLanguageObject();
    },
    modalTitle: function modalTitle() {
      return this.$t('tarefaEmMassa.titulos.titulo');
    },
    modalSubtitle: function modalSubtitle() {
      return this.$t('tarefaEmMassa.titulos.subtitulo');
    },
    portletTable: function portletTable() {
      return this.$t('tarefaEmMassa.titulos.portletTable');
    },
    portletForm: function portletForm() {
      return this.$t('tarefaEmMassa.titulos.portletForm');
    },
    messageEmail: function messageEmail() {
      return this.$t('tarefaEmMassa.titulos.enviarEmail');
    },
    isSingleStatus: function isSingleStatus() {
      return this.items.length > 0 && !!this.items.reduce(function (previous, atual) {
        return previous.Situacao === atual.Situacao ? previous : NaN;
      });
    },
    enableSave: function enableSave() {
      return this.hasAtLeastOneElegibleStatment && this.items.length > 0;
    }
  },

  watch: {
    listRows: function listRows() {
      var _this = this;

      this.erroDataDeVencimento = false;
      this.$nextTick(function () {
        _this.$validator.reset();
      });
      this.task = {
        nome: '',
        tipoVinculo: '',
        descricao: '',
        situacao: {
          id: 10,
          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')
        },
        dtVencimento: new Date(),
        responsavel: null,
        conclusaoAutomatica: [],
        enviarEmail: false,
        idsMovimentosFinanceiros: [],
        idsContalancamento: []
      };
      this.loadOperators();
    },
    items: function items() {
      var noTaskStats = [];
      this.items.forEach(function (item) {
        if (item.SituacaoTarefa === null) {
          noTaskStats.push(item);
        }
      });
      this.hasAtLeastOneElegibleStatment = noTaskStats.length > 0;
    }
  },

  methods: {
    openModalConfirm: function openModalConfirm() {
      $('#confirmMassTask').modal('show');
    },
    closeModalConfirm: function closeModalConfirm() {
      $('#confirmMassTask').modal('hide');
    },
    verifySave: function verifySave() {
      if (this.task.idsContalancamento && this.task.idsContalancamento.length > 0 && this.task.idsMovimentosFinanceiros && this.task.idsMovimentosFinanceiros.length > 0) {
        this.openModalConfirm();
      } else {
        this.validate();
      }
    },
    validate: function validate() {
      var _this2 = this;

      this.closeModalConfirm();
      this.isLoadingData = true;
      this.$validator.validateAll().then(function (result) {
        if (result && _this2.dataDeVencimentoValida()) {
          _this2.criatTarefaEmMAssa();
          _this2.$nextTick(function () {
            _this2.$validator.reset();
          });
        } else {
          _this2.isLoadingData = false;
        }
      });
    },
    criatTarefaEmMAssa: function criatTarefaEmMAssa() {
      var _this3 = this;

      var massTask = {
        dataCriacao: new Date(),
        dataVencimento: this.task.dtVencimento,
        nome: this.task.nome,
        descricao: this.task.descricao,
        situacao: this.task.situacao.id,
        usuarioResponsavel: {
          idUsuario: this.task.responsavel.id
        },
        enviarEmail: this.task.enviarEmail,
        situacoesConclusaoAutomatica: [],
        idsMovimentosFinanceiros: this.task.idsMovimentosFinanceiros,
        idsContalancamento: this.task.idsContalancamento
      };

      this.task.conclusaoAutomatica.forEach(function (status) {
        massTask.situacoesConclusaoAutomatica.push(status.id);
      });

      this.$store.dispatch('createMassTask', massTask).then(function (response) {
        _this3.$root.$refs.notification.success(response.data.message);
        _this3.isLoadingData = false;
        $('#' + _this3.id).modal('hide');
      }).catch(function (error) {
        _this3.isLoadingData = false;
        _this3.$root.$refs.notification.error(error.message);
      });
    },
    input: function input() {
      this.dataDeVencimentoValida();
      this.validateDate();
    },
    validateDate: function validateDate() {
      var isValid = this.inputDate.value.length === 10 && _customValidator2.default.isValidDate(this.inputDate.value);
      if (!isValid) {
        this.task.dtVencimento = null;
        this.$refs.dtVencimento.$children.find(function (item) {
          return !!item.id;
        }).typedDate = '';
      }
      return this.invalid;
    },
    dataDeVencimentoValida: function dataDeVencimentoValida() {
      if (this.task.dtVencimento) {
        var today = new Date();
        var yesterday = today.setDate(today.getDate() - 1);
        var validDate = false;

        validDate = this.task.dtVencimento.getTime() > yesterday;

        this.erroDataDeVencimento = !validDate;

        return validDate;
      }
      return true;
    },
    trackCloseEvent: function trackCloseEvent() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$validator.reset();
      });
      (0, _analytics.trackAnalyticsEvent)(this, 'modal-mass-task', 'titlebar-close-click', this.id);
      $('#' + this.id).modal('hide');
    },
    showDataTable: function showDataTable() {
      var _this5 = this;

      this.task.idsContalancamento = this.listIdExt;
      this.task.idsMovimentosFinanceiros = this.listIdMov;
      switch (this.gridId) {
        case 'ExtratoConta':
          this.task.tipoVinculo = {
            id: 'CL',
            descricao: this.$t('tarefaEmMassa.labels.tipoCl')
          };
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt).then(function (response) {
            _this5.mountDataTableBankStat(response);
          });
          break;
        case 'RelatorioConciliacao':
          this.task.tipoVinculo = {
            id: 'RC',
            descricao: this.listIdExt.length > 0 ? this.$t('tarefaEmMassa.labels.tipoCl') + (this.listIdMov.length > 0 ? '/' + this.$t('tarefaEmMassa.labels.tipoMf') : '') : ''
          };
          this.task.tipoVinculo.id = 'RC';
          this.task.tipoVinculo.descricao = this.listIdExt.length > 0 && this.listIdMov.length > 0 ? this.$t('tarefaEmMassa.labels.tipoCl') + '/' + this.$t('tarefaEmMassa.labels.tipoMf') : this.listIdExt.length > 0 && this.listIdMov.length === 0 ? this.$t('tarefaEmMassa.labels.tipoCl') : this.listIdExt.length === 0 && this.listIdMov.length > 0 ? this.$t('tarefaEmMassa.labels.tipoMf') : ' - ';
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt.concat(this.listIdMov)).then(function (response) {
            _this5.mountDataTableConcilReport(response);
          });
          break;
        case 'MovimentoFinanceiro':
          this.task.tipoVinculo = {
            id: 'MF',
            descricao: this.$t('tarefaEmMassa.labels.tipoMf')
          };
          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdMov).then(function (response) {
            _this5.mountDataTableMovFin(response);
          });
          break;
      }

      if (this.isSingleStatus) {
        this.concilStatusesTransformed = this.concilStatuses.filter(function (status) {
          return status.nome !== _this5.items[0].Situacao;
        });
      } else {
        this.concilStatusesTransformed = this.concilStatuses;
      }
    },
    prepareList: function prepareList(movimentTasks) {
      var _this6 = this;

      this.items = [];
      this.listRows.forEach(function (item) {
        var movimentWithTask = movimentTasks ? movimentTasks.find(function (moviment) {
          return moviment.idVinculo === item.IdLancamento;
        }) : null;
        _this6.items.push({
          ID: item.IdLancamento,
          IdLancamento: item.IdLancamento,
          DtLanc: item.DtLanc ? _moment2.default.utc(item.DtLanc).format('l') : ' - ',
          Banco: item.Banco ? item.Banco : ' - ',
          NomeConta: item.NomeConta ? item.NomeConta : ' - ',
          Agencia: item.Agencia ? item.Agencia : ' - ',
          NrConta: item.NrConta ? item.NrConta : ' - ',
          Tipo: item.Tipo ? (0, _statusesTranslator.typeTranslate)(item.Tipo, _this6) : ' - ',
          Valor: (0, _numberMasker.maskThousand)(item.Tipo === 'C' ? item.VlLancCred : item.VlLancDeb),
          DsCategoria: item.DsCategoria ? item.DsCategoria : ' - ',
          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null
        });
      });
    },
    removeEntry: function removeEntry(entry) {
      var _this7 = this;

      var index = -1;
      this.items.forEach(function (item) {
        if (item.ID === entry.ID) {
          index = _this7.items.indexOf(item);
        }
      });
      if (index >= 0) {
        this.items.splice(index, 1);
      }
      switch (this.gridId) {
        case 'ExtratoConta':
          var indexCL = this.task.idsContalancamento.findIndex(function (item) {
            return item === entry.ID;
          });
          if (indexCL >= 0) {
            this.task.idsContalancamento.splice(indexCL, 1);
          }
          break;
        case 'RelatorioConciliacao':
          if (entry.Tipo === this.$t('tarefaEmMassa.extrato.TipoMovBank')) {
            var _indexCL = this.task.idsContalancamento.findIndex(function (item) {
              return item === entry.ID;
            });
            if (_indexCL >= 0) {
              this.task.idsContalancamento.splice(_indexCL, 1);
            }
          } else if (entry.Tipo === this.$t('tarefaEmMassa.movimento.TipoMovFin')) {
            var _indexMF = this.task.idsMovimentosFinanceiros.findIndex(function (item) {
              return item === entry.ID;
            });
            if (_indexMF >= 0) {
              this.task.idsMovimentosFinanceiros.splice(_indexMF, 1);
            }
          }
          break;
        case 'MovimentoFinanceiro':
          var indexMF = this.task.idsMovimentosFinanceiros.findIndex(function (item) {
            return item === entry.ID;
          });
          if (indexMF >= 0) {
            this.task.idsMovimentosFinanceiros.splice(indexMF, 1);
          }
          break;
      }
    },
    displayTaskAlert: function displayTaskAlert(item) {
      return item.SituacaoTarefa !== null;
    },
    mountDataTableBankStat: function mountDataTableBankStat(response) {
      this.prepareList(response.data);
      this.columns = ['flag', 'IdLancamento', 'DtLanc', 'Valor', 'DsCategoria', 'Banco', 'NomeConta', 'Agencia', 'NrConta', 'acoes'];
      this.options.headings = {
        IdLancamento: this.$t('tarefaEmMassa.extrato.IdLancamento'),
        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),
        Banco: this.$t('tarefaEmMassa.extrato.Banco'),
        NomeConta: this.$t('tarefaEmMassa.extrato.NomeConta'),
        Agencia: this.$t('tarefaEmMassa.extrato.Agencia'),
        NrConta: this.$t('tarefaEmMassa.extrato.NrConta'),
        Valor: this.$t('tarefaEmMassa.extrato.Valor'),
        DsCategoria: this.$t('tarefaEmMassa.extrato.DsCategoria'),
        flag: '',
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      };
      this.options.columnsClasses = {
        'IdLancamento': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Banco': 'col-1 limit-char',
        'NomeConta': 'col-1 limit-char',
        'Agencia': 'col-1 limit-char',
        'NrConta': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'DsCategoria': 'col-1 limit-char',
        'acoes': 'col-1',
        'flag': 'col-1'
      };
      this.options.orderBy = 'IdLancamento';
    },
    prepareListMovFin: function prepareListMovFin(movimentTasks) {
      var _this8 = this;

      this.items = [];
      this.listRows.forEach(function (item) {
        var movimentWithTask = movimentTasks ? movimentTasks.find(function (moviment) {
          return moviment.idVinculo === item.IdMovimentacao;
        }) : null;
        _this8.items.push({
          ID: item.IdMovimentacao,
          IdMov: item.IdMovimentacao,
          DtLanc: (0, _moment2.default)(item.DtLanc).format('l'),
          Tipo: item.Tipo ? (0, _statusesTranslator.typeTranslate)(item.Tipo, _this8) : ' - ',
          Valor: (0, _numberMasker.maskThousand)(item.VlLancamento),
          Estabelecimento: item.NomeEstabelecimento ? item.NomeEstabelecimento + (item.NomeEstabelecimentoGrupo ? ' - ' + item.NomeEstabelecimentoGrupo : '') : ' - ',
          PlanoConciliacao: item.NomePlanoConciliacao ? item.NomePlanoConciliacao : ' - ',
          Situacao: item.SituacaoConciliacao ? (0, _statusesTranslator.conciliationStatusTranslate)(item.SituacaoConciliacao, _this8) : ' - ',
          DsCategoria: item.DsCategoria ? item.DsCategoria : ' - ',
          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null
        });
      });
    },
    mountDataTableMovFin: function mountDataTableMovFin(response) {
      this.prepareListMovFin(response.data);
      this.columns = ['flag', 'IdMov', 'DtLanc', 'Valor', 'Estabelecimento', 'PlanoConciliacao', 'Situacao', 'DsCategoria', 'acoes'];
      this.options.headings = {
        IdMov: this.$t('tarefaEmMassa.movimento.IdMov'),
        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),
        Tipo: this.$t('tarefaEmMassa.extrato.Tipo'),
        Valor: this.$t('tarefaEmMassa.extrato.Valor'),
        Estabelecimento: this.$t('tarefaEmMassa.movimento.Estabelecimento'),
        PlanoConciliacao: this.$t('tarefaEmMassa.movimento.PlanoConcil'),
        Situacao: this.$t('tarefaEmMassa.movimento.Situacao'),
        DsCategoria: this.$t('tarefaEmMassa.extrato.DsCategoria'),
        flag: '',
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      };
      this.options.columnsClasses = {
        'IdMov': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Tipo': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'Estabelecimento': 'col-1 limit-char',
        'PlanoConciliacao': 'col-1 limit-char',
        'Situacao': 'col-1 limit-char',
        'DsCategoria': 'col-1 limit-char',
        'acoes': 'col-1',
        'flag': 'col-1'
      };
      this.options.orderBy = 'IdMov';
    },
    prepareConcilReport: function prepareConcilReport(movimentTasks) {
      var _this9 = this;

      this.items = [];
      this.listRows.forEach(function (item) {
        var movimentWithTask = movimentTasks ? movimentTasks.find(function (moviment) {
          return moviment.idVinculo === item.IdMovFinanceiro || moviment.idVinculo === item.IdContaLancamento;
        }) : null;
        _this9.items.push({
          ID: item.IdExtBancario ? item.IdExtBancario : item.IdMovFinanceiro,
          IdLote: item.IdConciliacaoLote ? item.IdConciliacaoLote : ' - ',
          Tipo: item.IdExtBancario ? _this9.$t('tarefaEmMassa.extrato.TipoMovBank') : _this9.$t('tarefaEmMassa.movimento.TipoMovFin'),
          DtLanc: (0, _moment2.default)(item.DataLancamento).format('l'),
          Valor: item.IdExtBancario ? (0, _numberMasker.maskThousand)(item.ValorExtratoBancario) : (0, _numberMasker.maskThousand)(item.ValorMovimentoFinanceiro),
          Estabelecimento: item.Estabelecimento ? item.Estabelecimento : ' - ',
          Situacao: item.FlagSituacaoConciliacao ? (0, _statusesTranslator.conciliationStatusTranslate)(item.FlagSituacaoConciliacao, _this9) : ' - ',
          Ocorrencia: item.DescricaoMotivoOcorrenica,
          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null
        });
      });
    },
    mountDataTableConcilReport: function mountDataTableConcilReport(response) {
      this.prepareConcilReport(response.data);
      this.columns = ['flag', 'IdLote', 'Tipo', 'DtLanc', 'Valor', 'Estabelecimento', 'Situacao', 'Ocorrencia', 'acoes'];
      this.options.headings = {
        IdLote: this.$t('tarefaEmMassa.ocorrencia.IdLote'),
        Tipo: this.$t('tarefaEmMassa.extrato.Tipo'),
        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),
        Valor: this.$t('tarefaEmMassa.extrato.Valor'),
        Estabelecimento: this.$t('tarefaEmMassa.movimento.Estabelecimento'),
        Situacao: this.$t('tarefaEmMassa.movimento.Situacao'),
        Ocorrencia: this.$t('tarefaEmMassa.ocorrencia.Ocorrencia'),
        flag: '',
        acoes: this.$t('administracao.perfilAcesso.labels.acoes')
      };
      this.options.columnsClasses = {
        'IdLote': 'col-1 limit-char',
        'Tipo': 'col-1 limit-char',
        'DtLanc': 'col-1 limit-char',
        'Valor': 'col-1 limit-char',
        'Estabelecimento': 'col-1 limit-char',
        'Situacao': 'col-1 limit-char',
        'Ocorrencia': 'col-1 limit-char',
        'acoes': 'col-1',
        'flag': 'col-1'
      };
      this.options.orderBy = 'IdLote';
    },
    loadOperators: function loadOperators() {
      var _this10 = this;

      this.isLoadingData = true;
      var url = 'operator';
      this.$store.dispatch('getOperators', url).then(function (response) {
        _this10.operators = response.data;
        _this10.operators.forEach(function (op) {
          if (op.email === _this10.loggedUserEmail) {
            _this10.task.responsavel = op;
          }
        });
        if (!_this10.task.responsavel) {
          _this10.task.responsavel = _this10.operators[0];
        }
        _this10.showDataTable();
        _this10.isLoadingData = false;
      });
    },
    alertTooltipMessage: function alertTooltipMessage(item) {
      var message = '';

      switch (item.SituacaoTarefa) {
        case _idSituacaoTarefa2.default.PENDENTE:
          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.pendente');
          break;
        case _idSituacaoTarefa2.default.EM_ANDAMENTO:
          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.emAndamento');
          break;
        case _idSituacaoTarefa2.default.AGUARDANDO:
          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.aguardando');
          break;
      }

      return this.$t('tarefaEmMassa.labels.itemVinculado') + message;
    }
  },

  mounted: function mounted() {
    var _this11 = this;

    this.erroDataDeVencimento = false;
    this.inputDate = document.getElementById('dtVencimento');
    if (this.inputDate) {
      this.inputDate.setAttribute('autocomplete', 'off');
      this.inputDate.addEventListener('blur', function () {
        _this11.validateDate();
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 844 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/modal/Modal.vue ***!
  \**************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

exports.default = {
  name: 'Modal',

  props: {
    bodyClass: {
      Type: String,
      default: 'modal-body'
    },
    id: {},
    size: {},
    closable: {},
    closeFunction: {}
  },

  methods: {
    trackEvent: function trackEvent() {
      (0, _analytics.trackAnalyticsEvent)(this, 'close-modal', 'titlebar-close-modal-click', this.id);
      if (this.closeFunction) {
        this.closeFunction();
      }
    }
  }
};

/***/ }),
/* 845 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/multiSelectModal/MultiSelectModal.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _BetterModal = __webpack_require__(/*! ../betterModal/BetterModal */ 131);

var _BetterModal2 = _interopRequireDefault(_BetterModal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MultiSelectModal',

  components: {
    BetterModal: _BetterModal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    dynamicColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    objProperties: {
      type: Object,
      default: function _default() {
        return {
          id: 'id',
          name: 'nome'
        };
      }
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    groupingOptions: {
      type: Object
    }
  },

  data: function data() {
    return {
      isEveryItemSelected: this.data.selectedItems.length === 0,
      initialSelection: [].concat((0, _toConsumableArray3.default)(this.data.selectedItems)),
      selectedItems: [].concat((0, _toConsumableArray3.default)(this.data.selectedItems)),
      hasComputedComponentFunctions: false,
      dataView: this.data.values,
      currentSavedDynamicColumns: [].concat((0, _toConsumableArray3.default)(this.dynamicColumns.map(function (dynamic) {
        return dynamic.column;
      }))),
      grouped: false,
      isServerRequest: false,
      showInactiveAccounts: this.data.considerInactiveAccounts
    };
  },


  watch: {
    dynamicColumns: {
      handler: function handler() {
        this.removeDynamicColumns();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(this.dynamicColumns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var dynamic = _step.value;

            this.data.columns.push(dynamic.column);
            this.data.options.sortable.push(dynamic.column);
            this.data.options.headings[dynamic.column] = dynamic.heading;
            this.data.options.templates[dynamic.column] = dynamic.template;
            this.currentSavedDynamicColumns.push(dynamic.column);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      },

      deep: true
    },
    'data.values': {
      handler: function handler() {
        if (!this.data.options.requestFunction) {
          return;
        }
        this.updateDataItemsState();
      },

      deep: true
    },
    selectedItems: {
      handler: function handler() {
        if (this.groups.length > 1 && this.groupingOptions && this.selectedItems.length === this.data.values.length) {
          this.selectedItems = [];
        }
      },

      deep: true
    }
  },

  methods: {
    groupTheData: function groupTheData() {
      if (this.groups.length <= 1) {
        return;
      }
      var groupingHash = {};

      var groupByProp = this.groupingOptions.prop.split('.');
      var groupIdProp = this.groupingOptions.groupIdProp;
      var groupIdValueFallback = this.groupingOptions.defaultIdGroup;

      this.groups.forEach(function (group) {
        group.dataView = [];
        if (!groupingHash[group[groupIdProp]]) {
          groupingHash[group[groupIdProp]] = group;
        }
      });
      this.data.values.forEach(function (data) {
        var groupingIdentifier = data;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(groupByProp), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var prop = _step2.value;

            groupingIdentifier = groupingIdentifier[prop];
            if (!groupingIdentifier) {
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        groupingHash[groupingIdentifier || groupIdValueFallback].dataView.push(data);
      });
    },
    removeDynamicColumns: function removeDynamicColumns() {
      var _this = this;

      var _loop = function _loop(current) {
        var index = _this.data.columns.findIndex(function (column) {
          return column === current;
        });
        if (index === -1) {
          return 'continue';
        }
        _this.data.columns.splice(index, 1);
        _this.data.options.sortable.splice(index, 1);
        delete _this.data.options.headings[current];
        delete _this.data.options.templates[current];
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(this.currentSavedDynamicColumns), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var current = _step3.value;

          var _ret = _loop(current);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    defineCheckConditions: function defineCheckConditions() {
      if (this.data.columns[0] !== 'check') {
        this.data.columns.unshift('check');
      }

      this.updateDataItemsState();
    },
    updateDataItemsState: function updateDataItemsState() {
      var _this2 = this;

      var defaultState = !this.data.options.requestFunction;
      this.dataView = this.data.values.map(function (value) {
        var selected = _this2.selectedItems.find(function (selected) {
          return selected[_this2.objProperties.id] === value[_this2.objProperties.id];
        });
        value.checked = _this2.selectedItems.length === 0 && defaultState || !!selected;
        return value;
      });

      this.isEveryItemSelected = this.data.values.every(function (value) {
        return value.checked;
      });
    },
    toggleAllItens: function toggleAllItens() {
      var _this3 = this;

      this.isEveryItemSelected = !this.isEveryItemSelected;
      this.dataView = this.dataView.map(function (value) {
        value.checked = _this3.isEveryItemSelected;
        var index = _this3.selectedItems.findIndex(function (selected) {
          return selected[_this3.objProperties.id] === value[_this3.objProperties.id];
        });
        if (index > -1 && !_this3.isEveryItemSelected) {
          _this3.selectedItems.splice(index, 1);
        } else if (index === -1 && _this3.isEveryItemSelected && _this3.isServerRequest) {
          _this3.selectedItems.push(value);
        }
        return value;
      });
      if (this.isEveryItemSelected && !this.isServerRequest) {
        this.selectedItems = [];
      }
    },
    toggleAllGroupItens: function toggleAllGroupItens(groupIndex) {
      var _this4 = this;

      var group = this.groups[groupIndex];
      group.isEveryItemSelected = !group.isEveryItemSelected;

      var ignoreSearchingInSelected = false;
      if (!group.isEveryItemSelected && this.selectedItems.length === 0) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = (0, _getIterator3.default)(this.groups), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var g = _step4.value;

            if (g.id !== group.id) {
              var _selectedItems;

              (_selectedItems = this.selectedItems).push.apply(_selectedItems, (0, _toConsumableArray3.default)(g.dataView));
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        ignoreSearchingInSelected = true;
      }

      group.dataView = group.dataView.map(function (value) {
        value.checked = group.isEveryItemSelected;

        if (ignoreSearchingInSelected) {
          return value;
        }

        var index = _this4.selectedItems.findIndex(function (selected) {
          return selected[_this4.objProperties.id] === value[_this4.objProperties.id];
        });
        if (index > -1 && !group.isEveryItemSelected) {
          _this4.selectedItems.splice(index, 1);
        } else if (index === -1 && group.isEveryItemSelected) {
          _this4.selectedItems.push(value);
        }
        return value;
      });
      this.$set(this.groups, groupIndex, group);
    },
    toggleGrouped: function toggleGrouped() {
      var _this5 = this;

      this.grouped = !this.grouped;

      if (this.grouped) {
        this.groups.forEach(function (group) {
          group.isEveryItemSelected = _this5.selectedItems === 0 || group.dataView.every(function (item) {
            return item.checked;
          });
        });
      } else {
        this.isEveryItemSelected = this.selectedItems === 0 || this.dataView.every(function (item) {
          return item.checked;
        });
      }
    },
    selectItem: function selectItem(item) {
      var _this6 = this;

      var stateSelected = !item.checked;
      this.dataView = this.dataView.map(function (value) {
        if (value[_this6.objProperties.id] === item[_this6.objProperties.id]) {
          value.checked = stateSelected;
        }
        return value;
      });

      if (stateSelected) {
        this.selectedItems.push(item);
      } else {
        var index = this.selectedItems.findIndex(function (selected) {
          return selected[_this6.objProperties.id] === item[_this6.objProperties.id];
        });
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }

      if (this.data.options.requestFunction) {
        this.isEveryItemSelected = false;
      } else {
        if (this.selectedItems.length === 0 || this.selectedItems.length !== this.data.values.length) {
          this.selectedItems = this.dataView.filter(function (value) {
            return value.checked;
          });
          this.isEveryItemSelected = false;
        } else if (this.selectedItems.length === this.data.values.length) {
          this.selectedItems = [];
          this.isEveryItemSelected = true;
        }
      }
    },
    selectGroupItem: function selectGroupItem(groupIndex, item) {
      var _this7 = this;

      var group = this.groups[groupIndex];
      var stateSelected = !item.checked;
      group.dataView = group.dataView.map(function (value) {
        if (value[_this7.objProperties.id] === item[_this7.objProperties.id]) {
          value.checked = stateSelected;
        }
        return value;
      });

      if (stateSelected) {
        this.selectedItems.push(item);
      } else {
        if (this.selectedItems.length === 0) {
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = (0, _getIterator3.default)(this.groups), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var g = _step5.value;
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = (0, _getIterator3.default)(g.dataView), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var i = _step6.value;

                  if (i[this.objProperties.id] !== item[this.objProperties.id]) {
                    this.selectedItems.push(i);
                  }
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        } else {
          var index = this.selectedItems.findIndex(function (selected) {
            return selected[_this7.objProperties.id] === item[_this7.objProperties.id];
          });
          if (index > -1) {
            this.selectedItems.splice(index, 1);
          }
        }
      }
      group.isEveryItemSelected = group.dataView.every(function (i) {
        return i.checked;
      });
      this.$set(this.groups, groupIndex, group);
    },
    toggleInactiveAccounts: function toggleInactiveAccounts() {
      this.showInactiveAccounts = !this.showInactiveAccounts;
      this.showAccountsInactive();
    },
    showAccountsInactive: function showAccountsInactive() {
      var _this8 = this;

      if (this.showInactiveAccounts) {
        this.dataView = this.data.allBankAccounts;
        this.data.values = this.dataView;
        if (this.grouped && this.groups.length > 1) {
          this.groups.forEach(function (group, index) {
            group.isEveryItemSelected = true;
            _this8.toggleAllGroupItens(index);
          });
        } else {
          this.isEveryItemSelected = true;
          this.toggleAllItens();
        }
      } else {
        this.isEveryItemSelected = true;
        this.toggleAllItens();
        this.dataView = this.data.allBankAccounts.filter(function (bankAccount) {
          return bankAccount.ativo;
        });
        this.data.values = this.dataView;
      }
      this.groupTheData();
    },
    apply: function apply() {
      if (this.data.allBankAccounts) {
        if (this.selectedItems.length === 0 && this.showInactiveAccounts || this.data.allBankAccounts.length === this.data.values.length) {
          this.data.considerInactiveAccounts = true;
        } else {
          this.data.considerInactiveAccounts = false;
        }
      }
      this.data.selectedItems = this.selectedItems;
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.$emit('close-modal');
    },
    searchGroupItens: function searchGroupItens(groupIndex) {
      var _this9 = this;

      var group = this.groups[groupIndex];

      if (group.selected) {
        group.selected = false;
        this.$set(this.groups, groupIndex, group);
        return;
      }

      this.groups.forEach(function (g) {
        _this9.$set(g, 'selected', false);
      });

      group.selected = true;
      group.isEveryItemSelected = group.dataView.every(function (i) {
        return i.checked;
      });

      this.$set(this.groups, groupIndex, group);
    }
  },

  created: function created() {
    this.defineCheckConditions();
    this.groupTheData();
    this.hasComputedComponentFunctions = true;
    this.isServerRequest = !!this.data.options.requestFunction;
  }
};

/***/ }),
/* 846 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/modals/myAccountModal/MyAccountModal.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(/*! ../modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MyAccountModal',

  components: {
    Modal: _Modal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      name: this.$store.getters.user,
      email: this.$store.getters.userEmail,
      accessProfileName: this.$store.getters.accessProfileName,
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      changingPassword: false,
      hidePasswordIcon: 'fa-eye',
      saveBtnDisabled: false,
      differentNewPassword: false
    };
  },


  computed: {
    openMyAccountModal: function openMyAccountModal() {
      return this.$store.getters.openMyAccountModal;
    }
  },

  watch: {
    openMyAccountModal: function openMyAccountModal() {
      if (this.$store.getters.isLoggedIn) {
        this.showModal();
      }
    }
  },

  methods: {
    showModal: function showModal() {
      var _this = this;

      this.name = this.$store.getters.user;
      this.accessProfileName = this.$store.getters.accessProfileName;
      this.$nextTick(function () {
        _this.$validator.reset();
      });
      $('#my-account-modal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    validate: function validate() {
      var _this2 = this;

      this.saveBtnDisabled = true;
      this.differentNewPassword = false;
      this.$validator.validateAll().then(function (result) {
        if (result && _this2.changingPassword) {
          if (_this2.newPassword !== '' && _this2.currentPassword !== '') {
            if (_this2.newPassword !== _this2.confirmNewPassword) {
              _this2.differentNewPassword = true;
              _this2.saveBtnDisabled = false;
            } else {
              _this2.updateAccount();
            }
          } else {
            _this2.saveBtnDisabled = false;
          }
        } else if (result) {
          _this2.updateAccount();
        } else {
          _this2.saveBtnDisabled = false;
        }
      });
    },
    closeModal: function closeModal() {
      this.changingPassword = false;
      this.currentPassword = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
      $('#my-account-modal').modal('hide');
    },
    updateAccount: function updateAccount() {
      var _this3 = this;

      this.$store.dispatch('updateAccount', {
        name: this.name,
        email: this.email,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }).then(function (user) {
        _this3.$store.dispatch('updateUserName', user.nome);
        _this3.closeModal();
      }).then(function () {
        _this3.$root.$refs.notification.success('modalMinhaConta.sucesso.salvar');
        _this3.saveBtnDisabled = false;
      }).catch(function (error) {
        _this3.$root.$refs.notification.error(error.message);
        _this3.saveBtnDisabled = false;
      });
    },
    showPassword: function showPassword(idInput, idButton) {
      this.togglePasswordInputType(idInput, idButton);
    },
    togglePasswordInputType: function togglePasswordInputType(idInput, idButton) {
      if (document.getElementById(idInput).type === 'text') {
        document.getElementById(idInput).type = 'password';
        document.querySelector(idButton).style.color = '#999';
      } else {
        document.getElementById(idInput).type = 'text';
        document.querySelector(idButton).style.color = '#333';
      }
    },
    changePassword: function changePassword() {
      (0, _analytics.trackAnalyticsEvent)(this, 'button-click', 'button-default-component', 'edit-password-btn');
      this.changingPassword = true;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 847 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/notification/Notification.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toastr = __webpack_require__(/*! toastr */ 1153);

var _toastr2 = _interopRequireDefault(_toastr);

var _analytics = __webpack_require__(/*! ../../utils/analytics.js */ 25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Notification',

  data: function data() {
    return {
      toastr: _toastr2.default,
      options: {
        'closeButton': true,
        'debug': false,
        'newestOnTop': true,
        'progressBar': true,
        'positionClass': 'toast-top-right',
        'preventDuplicates': true,
        'onclick': null,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '2000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
      }
    };
  },


  methods: {
    remove: function remove() {
      this.toastr.remove();
    },
    clear: function clear() {
      this.toastr.clear();
    },
    success: function success(message, title) {
      (0, _analytics.trackAnalyticsEvent)(this, 'notification', 'success', this.translate(message));
      this.toastr.success(this.translate(message), this.translate(title));
    },
    info: function info(message, title) {
      (0, _analytics.trackAnalyticsEvent)(this, 'notification', 'info', this.translate(message));
      this.toastr.info(this.translate(message), this.translate(title));
    },
    warning: function warning(message, title) {
      (0, _analytics.trackAnalyticsEvent)(this, 'notification', 'warning', this.translate(message));
      this.toastr.warning(this.translate(message), this.translate(title));
    },
    error: function error(message, title) {
      (0, _analytics.trackAnalyticsEvent)(this, 'notification', 'error', this.translate(message));
      this.toastr.error(this.translate(message), this.translate(title));
    },
    global: function global(type, message, title) {
      switch (type) {
        case 'S':
          this.toastr.success(message, title);
          break;
        case 'I':
          this.toastr.info(message, title);
          break;
        case 'W':
          this.toastr.warning(message, title);
          break;
        case 'E':
          this.toastr.error(message, title);
          break;
      }
    },
    translate: function translate(key) {
      return this.$t(key);
    }
  },

  created: function created() {
    this.toastr.options = this.options;
  }
};

/***/ }),
/* 848 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/attributesSet/Attribute.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Attribute',

  props: {
    order: {
      type: Number
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    type: {
      type: Object,
      required: true,
      default: {}
    },
    possibleValues: {
      type: Array,
      required: true
    },
    validation: {
      type: String
    },
    inUse: {
      type: Boolean
    },
    mask: {
      type: String
    },
    handleEdit: {
      type: Function,
      required: true
    },
    handleRemove: {
      type: Function,
      required: true
    }
  },

  computed: {
    transformedPossibleValues: function transformedPossibleValues() {
      if (this.possibleValues.length > 0) {
        var transformedValues = [];
        this.possibleValues.forEach(function (element) {
          transformedValues.push(element.valor || element.value || element);
        });
        return transformedValues.toString();
      }
      return '-';
    },
    btnRemoveTitle: function btnRemoveTitle() {
      return this.inUse ? this.$t('conjuntoAtributo.validacao.atributoEmUsoExcluir') : '';
    }
  }
};

/***/ }),
/* 849 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/attributesSet/NewAtributeModal.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vueInputTag = __webpack_require__(/*! vue-input-tag */ 688);

var _vueInputTag2 = _interopRequireDefault(_vueInputTag);

var _BetterModal = __webpack_require__(/*! ../../modals/betterModal/BetterModal */ 131);

var _BetterModal2 = _interopRequireDefault(_BetterModal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _stringUtils = __webpack_require__(/*! ../../../utils/stringUtils.js */ 319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'NewAtributeModal',

  components: {
    vSelect: _vueSelect2.default,
    InputTag: _vueInputTag2.default,
    BetterModal: _BetterModal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    editingAttribute: {
      type: Object
    },
    attributesList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      isEditing: false,
      attributeTypeHint: '',
      types: [],
      possibleValues: [],
      availableFields: {
        value: false,
        mask: false,
        validation: false
      },
      attribute: {
        name: '',
        description: null,
        type: {
          key: '',
          description: ''
        },
        possibleValues: [],
        inUse: false
      },
      tagsPossibleValue: [],
      typesValues: {
        COMBO: {
          hintText: this.$t('conjuntoAtributo.infos.combo'),
          availableFields: {
            value: true,
            mask: false,
            validation: false
          }
        },
        NUMBER: {
          hintText: this.$t('conjuntoAtributo.infos.numerico'),
          availableFields: {
            value: false,
            mask: true,
            validation: true
          }
        },
        STRING: {
          hintText: this.$t('conjuntoAtributo.infos.texto'),
          availableFields: {
            value: false,
            mask: true,
            validation: true
          }
        },
        DATE: {
          hintText: this.$t('conjuntoAtributo.infos.datepicker'),
          availableFields: {
            value: false,
            mask: false,
            validation: false
          }
        }
      }
    };
  },


  watch: {
    attribute: {
      handler: function handler() {
        this.possibleValuesChanged(null);
      },

      deep: true
    }
  },

  methods: {
    handleIdentifier: function handleIdentifier(evnt) {
      this.attribute.name = (0, _stringUtils.removeNonAlphanumeric)((0, _stringUtils.normalize)(this.attribute.name)).toUpperCase();
    },
    validate: function validate() {
      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          self.save();
        } else {
          self.$root.$refs.notification.error('conjuntoAtributo.erro.camposObrigatorios');
        }
      });
    },
    save: function save() {
      var _this = this;

      if (this.attribute.type.key === 'COMBO') {
        this.attribute.possibleValues = [].concat((0, _toConsumableArray3.default)(this.possibleValues));
      } else {
        this.attribute.possibleValues = [];
      }

      var newList = [].concat((0, _toConsumableArray3.default)(this.attributesList));

      if (this.isEditing) {
        var index = this.attributesList.findIndex(function (att) {
          return att === _this.editingAttribute;
        });
        if (index === -1) {
          throw new Error('Not found');
        }
        newList.splice(index, 1, this.attribute);
      } else {
        newList.push(this.attribute);
      }
      this.$emit('update-list-attributes', newList);
      this.close();
    },
    toggleAditionalFields: function toggleAditionalFields(selectedType) {
      if (!selectedType || !selectedType.key || !selectedType.description) {
        return;
      }

      if (!this.attribute.type) {
        this.attribute.type = {};
      }

      this.attribute.type.key = selectedType.key;
      this.attribute.type.description = selectedType.description;

      var typeValues = this.typesValues[selectedType.key];
      if (!typeValues) {
        return;
      }

      this.availableFields = (0, _assign2.default)({}, typeValues.availableFields);
    },
    possibleValuesChanged: function possibleValuesChanged(list) {
      if (!list) {
        list = [].concat((0, _toConsumableArray3.default)(this.attribute.possibleValues));
      }
      this.tagsPossibleValue = [].concat((0, _toConsumableArray3.default)(list));
      this.possibleValues = list.map(function (value) {
        return {
          id: null,
          value: value
        };
      });
    },
    close: function close() {
      this.$emit('close-modal');
    }
  },

  created: function created() {
    var _this2 = this;

    this.$store.dispatch('loadAttributeTypes').then(function (types) {
      _this2.types = types.map(function (type) {
        type.key = type.tipo;
        type.description = _this2.$t(type.descricao);
        return type;
      });
    }).catch(function (error) {
      return _this2.$root.$refs.notification.error(error.message);
    });
    if (this.editingAttribute) {
      this.isEditing = true;
      this.attribute = (0, _assign2.default)({}, this.editingAttribute);
      this.attribute.type.description = this.$t(this.attribute.type.description);
      this.attribute.possibleValues = this.editingAttribute.possibleValues.map(function (tag) {
        return tag.value;
      });
      this.tagsPossibleValue = [].concat((0, _toConsumableArray3.default)(this.attribute.possibleValues));
      this.possibleValues = this.editingAttribute.possibleValues;
      this.toggleAditionalFields(this.editingAttribute.type);
    }
    this.defaultObject = (0, _assign2.default)({}, this.attribute);
  }
};

/***/ }),
/* 850 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/attributesSet/TreeViewAtt.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ 136);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var id = 1000;
var fromData = '';
var toData = '';
var fromParentModelChildren = '';
var nodeClicked = null;

exports.default = {
  name: 'TreeViewAtt',

  props: {
    model: Object,
    buttonsTitle: Object,
    clickFunction: Function,
    id: String,
    father: Object,
    defaultText: String,
    currentHighlight: Boolean,
    hoverColor: String,
    highlightColor: String,
    spaceLeft: String,
    styleObj: Object,
    clickRemoveFunction: {
      type: Function,
      default: null
    },
    showRemove: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      open: false,
      isClicked: false
    };
  },

  computed: {
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length;
    }
  },

  template: '<div class="treeview">\n              <div :id=\'model.id\' draggable=\'false\' @dragstart=\'dragStart\' @dragover=\'dragOver\' @dragenter=\'dragEnter\' @dragleave=\'dragLeave\' @drop=\'drop\' @dragend=\'dragEnd\' class=\'col-xs-12 col-sm-12 col-md-12 treeRow pl-0\' :class="[model.mainFather ? \'treeRowBg\' : \'\']" @mouseover=\'mouseOver\' @mouseout=\'mouseOut\' :style=\'styleObj\'>\n                <div v-if=\'model.mainFather\' class="pull-left pl-0 text-left" style="padding-top:3px!important">\n                  <div v-if="model.children && model.children.length === 0" style="min-width:33px;"></div>\n                  <button style="width:23px; float:left;" v-if="!isClicked && model.children && model.children.length > 0" :title="[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : \'\']" @click="toggle" class="fa fa-chevron-down px-0 action btn-white"></button>\n                  <button style="width:23px; float:left;" v-if="isClicked && model.children && model.children.length > 0" :title="[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : \'\']" @click="toggle" class="fa fa-chevron-up px-0 action btn-white"></button>\n                </div>\n                <div :style=\'spaceLeft\' class="col-xs-3 col-sm-3 col-md-3 col-lg-4" :class="[model.mainFather ? \'pl-0\' : \'padding-left-children\']">\n                  {{model.number}} {{model.attibuteSetName}}\n                </div>\n                <div class="col-xs-2 col-sm-2 col-md-3 col-lg-3" v-html="$t(model.linkType ? \'conjuntoAtributo.labels.\' + model.linkType : null)"></div>\n                <div class="col-xs-2 col-sm-2 col-md-3 col-lg-2">{{model.amount}}</div>\n                <div v-if=\'model.mainFather\' class="pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-2" style="padding-top:3px!important">\n                  <button v-if=\'showRemove\' :disabled=\'model.emUso\' style="width:23px; float:right;" @click="clickRemoveFunction(model.id)" :title="[model.emUso ? (buttonsTitle && buttonsTitle.removeBloq ? buttonsTitle.removeBloq : \'\') : (buttonsTitle && buttonsTitle.remove ? buttonsTitle.remove : \'\')]" class="fa fa-times action btn-white pr-0"></button>\n                  <button style="width:23px; float:right;" id="buttonEdit" @click="clickAction(\'buttonEdit\')" :title="[buttonsTitle && buttonsTitle.config ? buttonsTitle.config : \'\']" class="fa fa-cog action btn-white pr-0"></button>\n                </div>\n              </div>\n              <div class="clear"></div>\n              <div v-show="open" v-if="isFolder">\n                <item v-for="model in model.children" :spaceLeft=\'model.marginLeft\' :clickFunction=\'clickFunction\' :id=\'model.id\' :father="model" :model="model" :key=\'model.id\' :currentHighlight=\'currentHighlight\' :defaultText=\'defaultText\' :hoverColor=\'hoverColor\' :highlightColor=\'highlightColor\'>\n                </item>\n              </div>\n            </div>',

  methods: {
    clickAction: function clickAction(idButton) {
      var isEdit = idButton === 'buttonEdit';
      this.clickFunction(this.id, this.father, isEdit);
    },
    toggle: function toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
      var rootTree = this.findRoot();

      this.isClicked = !this.isClicked;

      if (this.currentHighlight) {
        if (nodeClicked !== this.model.id) {
          var treeParent = rootTree.$parent;
          var nodeStack = [treeParent.$children[0]];
          while (nodeStack.length !== 0) {
            var item = nodeStack.shift();
            item.styleObj.background = 'white';
            if (item.$children && item.$children.length > 0) {
              nodeStack = nodeStack.concat(item.$children);
            }
          }
          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF';
          nodeClicked = this.model.id;
        }
      }
    },
    exchangeData: function exchangeData(rootCom, from, to) {
      if (!to || !from || typeof to === 'string' || from.id === to.id) {
        return;
      }

      from = JSON.parse((0, _stringify2.default)(from));
      to = JSON.parse((0, _stringify2.default)(to));

      var treeData = JSON.parse((0, _stringify2.default)(this.model));
      var nodeStack = [treeData];
      var status = 0;

      try {
        while (!(status === 2)) {
          var item = nodeStack.shift();
          if (item.id === from.id) {
            item.id = to.id;
            item.name = to.name;
            if (to.children && to.children.length > 0) {
              item['children'] = to.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.id === to.id) {
            item.id = from.id;
            item.name = from.name;
            if (from.children && from.children.length > 0) {
              item['children'] = from.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.children && item.children.length > 0) {
            nodeStack = nodeStack.concat(item.children);
          }
        }
      } catch (e) {
        return;
      }
      rootCom.assignData(treeData);
    },
    changeType: function changeType() {
      if (this.currentHighlight) {
        nodeClicked = this.model.id;
      }
      if (!this.isFolder) {
        this.$set(this.model, 'children', []);
        this.addChild();
        this.open = true;
        this.isClicked = true;
      }
    },
    mouseOver: function mouseOver(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2';
        }
      }
    },
    mouseOut: function mouseOut(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = 'white';
        }
      }
    },
    findRoot: function findRoot() {
      var ok = false;
      var that = this;
      while (!ok) {
        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {
          ok = true;
          break;
        }
        that = that.$parent;
      }
      return that;
    },
    addChild: function addChild() {
      this.model.children.push({
        name: this.defaultText ? this.defaultText : 'New Node',
        id: id++
      });
    },
    removeChild: function removeChild(id) {
      var parentModelChildren = this.$parent.model.children;
      for (var index in parentModelChildren) {
        if (parentModelChildren[index].id === id) {
          parentModelChildren = parentModelChildren.splice(index, 1);
          break;
        }
      }
    },
    dragStart: function dragStart(e) {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('nottext', e.target.innerHTML);
      return true;
    },
    dragEnd: function dragEnd(e) {
      fromData = undefined;
      toData = undefined;
      fromParentModelChildren = undefined;
    },
    dragOver: function dragOver(e) {
      e.preventDefault();
      return true;
    },
    dragOverPlus: function dragOverPlus(e) {
      e.preventDefault();
    },
    dragEnterPlus: function dragEnterPlus(e) {},
    dragEnter: function dragEnter(e) {
      toData = this.model;
      var rootTree = this.findRoot();
      rootTree.exchangeData(rootTree.$parent, fromData, toData);
    },
    dragLeave: function dragLeave(e) {
      fromData = this.model;
      fromParentModelChildren = this.$parent.model.children;
    },
    drop: function drop(e) {},
    dropPlus: function dropPlus(e) {
      if (this.model.hasOwnProperty('children')) {
        this.model.children.push(fromData);
      } else {
        this.model.children = [fromData];
      }
      for (var i in fromParentModelChildren) {
        if (fromParentModelChildren[i].id === fromData.id) {
          fromParentModelChildren.splice(i, 1);
        }
      }
    }
  },

  beforeCreate: function beforeCreate() {
    this.$options.components.item = __webpack_require__(/*! ./TreeViewAtt */ 691);
  }
};

/***/ }),
/* 851 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/categories/CategorieModal.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vMoney = __webpack_require__(/*! v-money */ 195);

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _BetterModal = __webpack_require__(/*! ../../modals/betterModal/BetterModal */ 131);

var _BetterModal2 = _interopRequireDefault(_BetterModal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _looseDeepEqual = __webpack_require__(/*! ../../../utils/looseDeepEqual.js */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _customValidator = __webpack_require__(/*! ../../../utils/customValidator */ 106);

var _customValidator2 = _interopRequireDefault(_customValidator);

var _dateUtils = __webpack_require__(/*! ../../../utils/dateUtils */ 790);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CategorieModal',

  components: {
    BetterModal: _BetterModal2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    Money: _vMoney.Money,
    Datepicker: _vuejsDatepicker2.default
  },

  props: {
    idEditingCategory: {
      type: String,
      default: null
    },
    subCategoryParent: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    lastCategoryOrder: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      requestSent: false,
      category: {
        description: null,
        accountingId: null,
        type: '',
        emUso: false,
        initialBalance: '',
        initialBalanceDate: null
      },
      parentCategory: null,
      creatingNumber: 0,
      titles: {
        main: '',
        sub: ''
      },
      idioma: _index2.default,
      moneyMask: {},
      inputDate: null,
      disabledDates: {
        to: new Date('January 01, 2010')
      }
    };
  },


  computed: {
    datePickerLanguage: function datePickerLanguage() {
      return this.idioma.getDatePickerLanguageObject();
    },
    moneyMaskLength: function moneyMaskLength() {
      return this.idioma.getDatePickerLanguage() === 'pt-br' ? 21 : 20;
    }
  },

  watch: {
    category: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, this.category));
        if (this.category.type !== '' && this.category.type !== 'W') {
          this.category.initialBalance = '';
          this.category.initialBalanceDate = null;
        }
      },

      deep: true
    }
  },

  methods: {
    createOrder: function createOrder() {
      if (!this.parentCategory) {
        if (this.categories.length > 0) {
          var lastCategory = this.categories[this.categories.length - 1];
          if ('number' in lastCategory) {
            return parseInt(lastCategory.number) + 1;
          }
        }
        return 1;
      }
      if (this.parentCategory.children && this.parentCategory.children.length > 0) {
        var lastChildCategory = this.parentCategory.children[this.parentCategory.children.length - 1];
        if ('number' in lastChildCategory) {
          return this.parentCategory.number + '.' + (parseInt(lastChildCategory.number.split('.').pop()) + 1);
        }
      }
      return this.parentCategory.number + '.' + 1;
    },
    defineTitles: function defineTitles() {
      if (this.idEditingCategory) {
        if (this.parentCategory) {
          this.titles.main = this.$t('categoria.modal.titulo.edicaoSubCategoria');
          this.titles.sub = this.$t('categoria.modal.subtitulo.edicaoSubCategoria');
        } else {
          this.titles.main = this.$t('categoria.modal.titulo.edicaoCategoria');
          this.titles.sub = this.$t('categoria.modal.subtitulo.edicaoCategoria');
        }
      } else {
        if (this.parentCategory) {
          this.titles.main = this.$t('categoria.modal.titulo.novaSubCategoria');
          this.titles.sub = this.$t('categoria.modal.subtitulo.novaSubCategoria');
        } else {
          this.titles.main = this.$t('categoria.modal.titulo.novaCategoria');
          this.titles.sub = this.$t('categoria.modal.subtitulo.novaCategoria');
        }
      }
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result && _this.isWalletFieldsValid()) {
          _this.save();
        } else {
          _this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', _this.getTitleError());
        }
      });
    },
    isWalletFieldsValid: function isWalletFieldsValid() {
      var isValid = this.category.type !== 'W' || this.category.type === 'W' && this.$refs.money.$el.value !== '' && this.category.initialBalanceDate !== null;

      if (!isValid) {
        if (this.$refs.money.$el.value === '') {
          this.errors.add('initialBalance', 'balance');
          this.errors.remove('initialBalanceDate');
        } else {
          this.errors.add('initialBalanceDate', 'balance');
          this.errors.remove('initialBalance');
        }
      } else {
        this.errors.remove('initialBalance');
        this.errors.remove('initialBalanceDate');
      }
      return isValid;
    },
    getTitleError: function getTitleError() {
      if (this.parentCategory) {
        return 'categoria.subCategoria.erro.salvar';
      }
      return 'categoria.erro.salvar';
    },
    save: function save() {
      var _this2 = this;

      this.requestSent = true;
      this.$store.dispatch('saveCategorie', this.createSavingObject()).then(function (response) {
        _this2.$root.$refs.notification.success(response.data.message);
        _this2.$emit('close-modal');
      }).catch(function (error) {
        _this2.$root.$refs.notification.error(error.message);
      }).finally(function () {
        _this2.requestSent = false;
      });
    },
    createSavingObject: function createSavingObject() {
      return {
        id: this.category.id,
        categoriaPai: {
          id: this.parentCategory ? this.parentCategory.id : null
        },
        nome: this.category.description,
        numero: this.creatingNumber,
        tipo: this.category.type !== 'null' ? this.category.type : null,
        idContabil: this.category.accountingId,
        ordem: this.lastCategoryOrder + 1,
        saldoInicial: typeof this.category.initialBalance === 'string' && this.category.initialBalance === '' ? null : this.removeBankAccountMask(),
        dataSaldoInicial: (0, _dateUtils.convertToUTC)(this.category.initialBalanceDate)
      };
    },
    removeBankAccountMask: function removeBankAccountMask() {
      var splittedInitialBalance = this.category.initialBalance.toString().split(' ');

      if (this.category.initialBalance && splittedInitialBalance.length > 1) {
        return splittedInitialBalance[1].replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1');
      }
      return this.category.initialBalance.replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1');
    },
    validateDate: function validateDate() {
      var isValid = this.inputDate.value.length === 10 && _customValidator2.default.isValidDate(this.inputDate.value);
      if (!isValid) {
        this.category.initialBalanceDate = null;
      } else {
        this.errors.remove('initialBalanceDate');
      }
    }
  },

  created: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.subCategoryParent) {
                this.parentCategory = (0, _assign2.default)({}, this.subCategoryParent);
              }

              if (this.idEditingCategory) {
                _context.next = 6;
                break;
              }

              this.defineTitles();
              this.creatingNumber = this.createOrder();
              this.defaultObject = (0, _assign2.default)({}, this.category);
              return _context.abrupt('return');

            case 6:
              _context.prev = 6;
              _context.next = 9;
              return this.$store.dispatch('getCategorie', this.idEditingCategory);

            case 9:
              response = _context.sent;

              this.category = response.data;
              if (this.category && this.category.fatherCategory) {
                this.parentCategory = (0, _assign2.default)({}, this.category.fatherCategory);
              } else {
                this.parentCategory = null;
              }
              this.creatingNumber = this.category.number;
              this.category.initialBalance = this.category.type === 'W' ? this.category.initialBalance.toFixed(2) : '';
              this.category.initialBalanceDate = this.category.type === 'W' ? this.category.initialBalanceDate : null;
              this.defaultObject = (0, _assign2.default)({}, this.category);
              this.defineTitles();
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](6);

              this.$root.$refs.notification.error(_context.t0.data);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 19]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function mounted() {
    var _this3 = this;

    this.moneyMask = this.idioma.getMoneyMaskByLanguage();
    setTimeout(function () {
      _this3.inputDate = document.getElementById('initialBalanceDate');
      if (_this3.inputDate) {
        _this3.inputDate.setAttribute('autocomplete', 'off');
        _this3.inputDate.addEventListener('blur', function () {
          _this3.validateDate();
        });
      }
    }, 100);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
  }
};

/***/ }),
/* 852 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/categories/TreeviewCategories.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ 136);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var id = 1000;
var fromData = '';
var toData = '';
var fromParentModelChildren = '';
var nodeClicked = null;

exports.default = {
  name: 'TreeViewCategories',

  props: {
    model: Object,
    buttonsTitle: Object,
    clickFunction: Function,
    id: String,
    father: Object,
    defaultText: String,
    currentHighlight: Boolean,
    hoverColor: String,
    highlightColor: String,
    spaceLeft: String,
    styleObj: Object,
    clickRemoveFunction: {
      type: Function,
      default: null
    },
    showRemove: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      open: false,
      isClicked: false
    };
  },

  computed: {
    orderedNumbers: function orderedNumbers() {
      return this.model.children.sort(function (a, b) {
        return Number(a.number.replace(/\./g, '')) - Number(b.number.replace(/\./g, ''));
      });
    },
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length;
    }
  },

  template: '<div class="treeview">\n\n              <div :id=\'model.id\' draggable=\'false\' @dragstart=\'dragStart\' @dragover=\'dragOver\' @dragenter=\'dragEnter\' @dragleave=\'dragLeave\' @drop=\'drop\' @dragend=\'dragEnd\' class=\'col-xs-12 col-sm-12 col-md-12 treeRow pl-0\' :class="[model.mainFather ? \'treeRowBg\' : \'\']" @mouseover=\'mouseOver\' @mouseout=\'mouseOut\' :style=\'styleObj\'>\n                <div class="pull-left pl-0 text-left" style="padding-top:3px!important">\n                  <div v-if="!model.children" style="min-width:33px;"></div>\n                  <button style="width: 23px; float: left;" v-if="!isClicked && model.children" :title="[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : \'\']" @click="toggle" class="fa fa-chevron-down px-0 action btn-white"></button>\n                  <button style="width: 23px; float: left;" v-if="isClicked && model.children" :title="[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : \'\']" @click="toggle" class="fa fa-chevron-up px-0 action btn-white"></button>\n                </div>\n\n                <div :style=\'spaceLeft\' class="col-xs-5 col-sm-7 col-md-6 col-lg-4" :class="[model.mainFather ? \'pl-0\' : \'\']">\n                  <b>{{model.number}}</b> &nbsp;&nbsp; {{model.description}}\n                </div>\n\n                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2" v-html="$t(\'categoria.modal.labels.\' + model.type)"></div>\n\n                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right">{{formatInitialBalance(model.initialBalance)}}</div>\n\n                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right">{{formatInitialBalanceDate(model.initialBalanceDate)}}</div>\n\n                <div class="pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-1-5" style="padding-top:3px!important">\n                  <button v-if=\'showRemove && !model.children\' style="width:23px; float:right;" @click="clickRemoveFunction(model.id)" :title="[model.emUso ? (buttonsTitle && buttonsTitle.removeBloq ? buttonsTitle.removeBloq : \'\') : (buttonsTitle && buttonsTitle.remove ? buttonsTitle.remove : \'\')]" class="fa fa-times action btn-white pr-0" :disabled=\'model.emUso\'></button>\n                  <button style="width:23px; float:right;" id="buttonEdit" @click="clickAction(\'buttonEdit\')" :title="[buttonsTitle && buttonsTitle.edit ? buttonsTitle.edit : \'\']" class="fa fa-pencil action pr-0"></button>\n                  <button style="width:23px; float:right;" id="buttonCreate" @click="clickAction(\'buttonCreate\')" :title="[buttonsTitle && buttonsTitle.create ? buttonsTitle.create : \'\']" class="fa fa-plus action pr-0 mr-0"></button>\n                </div>\n              </div>\n\n              <div class="clear"></div>\n\n              <div v-show="open" v-if="isFolder">\n                <item v-for="model in orderedNumbers" :spaceLeft=\'model.marginLeft\' :clickFunction=\'clickFunction\' :clickRemoveFunction=\'clickRemoveFunction\' :showRemove=\'showRemove\' :id=\'model.id\' :father="model" :buttonsTitle="buttonsTitle" :model="model" :key=\'model.id\' :currentHighlight=\'currentHighlight\' :defaultText=\'defaultText\' :hoverColor=\'hoverColor\' :highlightColor=\'highlightColor\'>\n                </item>\n              </div>\n            </div>',

  methods: {
    clickAction: function clickAction(idButton) {
      var isEdit = idButton === 'buttonEdit';
      this.clickFunction(this.id, this.father, isEdit);
    },
    toggle: function toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
      var rootTree = this.findRoot();

      this.isClicked = !this.isClicked;

      if (this.currentHighlight) {
        if (nodeClicked !== this.model.id) {
          var treeParent = rootTree.$parent;
          var nodeStack = [treeParent.$children[0]];
          while (nodeStack.length !== 0) {
            var item = nodeStack.shift();
            item.styleObj.background = 'white';
            if (item.$children && item.$children.length > 0) {
              nodeStack = nodeStack.concat(item.$children);
            }
          }
          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF';
          nodeClicked = this.model.id;
        }
      }
    },
    exchangeData: function exchangeData(rootCom, from, to) {
      if (!to || !from || typeof to === 'string' || from.id === to.id) {
        return;
      }

      from = JSON.parse((0, _stringify2.default)(from));
      to = JSON.parse((0, _stringify2.default)(to));

      var treeData = JSON.parse((0, _stringify2.default)(this.model));
      var nodeStack = [treeData];
      var status = 0;

      try {
        while (!(status === 2)) {
          var item = nodeStack.shift();
          if (item.id === from.id) {
            item.id = to.id;
            item.name = to.name;
            if (to.children && to.children.length > 0) {
              item['children'] = to.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.id === to.id) {
            item.id = from.id;
            item.name = from.name;
            if (from.children && from.children.length > 0) {
              item['children'] = from.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.children && item.children.length > 0) {
            nodeStack = nodeStack.concat(item.children);
          }
        }
      } catch (e) {
        return;
      }
      rootCom.assignData(treeData);
    },
    changeType: function changeType() {
      if (this.currentHighlight) {
        nodeClicked = this.model.id;
      }
      if (!this.isFolder) {
        this.$set(this.model, 'children', []);
        this.addChild();
        this.open = true;
        this.isClicked = true;
      }
    },
    mouseOver: function mouseOver(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2';
        }
      }
    },
    mouseOut: function mouseOut(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = 'white';
        }
      }
    },
    findRoot: function findRoot() {
      var ok = false;
      var that = this;
      while (!ok) {
        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {
          ok = true;
          break;
        }
        that = that.$parent;
      }
      return that;
    },
    addChild: function addChild() {
      this.model.children.push({
        name: this.defaultText ? this.defaultText : 'New Node',
        id: id++
      });
    },
    removeChild: function removeChild(id) {
      var parentModelChildren = this.$parent.model.children;
      for (var index in parentModelChildren) {
        if (parentModelChildren[index].id === id) {
          parentModelChildren = parentModelChildren.splice(index, 1);
          break;
        }
      }
    },
    dragStart: function dragStart(e) {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('nottext', e.target.innerHTML);
      return true;
    },
    dragEnd: function dragEnd(e) {
      fromData = undefined;
      toData = undefined;
      fromParentModelChildren = undefined;
    },
    dragOver: function dragOver(e) {
      e.preventDefault();
      return true;
    },
    dragOverPlus: function dragOverPlus(e) {
      e.preventDefault();
    },
    dragEnterPlus: function dragEnterPlus(e) {},
    dragEnter: function dragEnter(e) {
      toData = this.model;
      var rootTree = this.findRoot();
      rootTree.exchangeData(rootTree.$parent, fromData, toData);
    },
    dragLeave: function dragLeave(e) {
      fromData = this.model;
      fromParentModelChildren = this.$parent.model.children;
    },
    drop: function drop(e) {},
    dropPlus: function dropPlus(e) {
      if (this.model.hasOwnProperty('children')) {
        this.model.children.push(fromData);
      } else {
        this.model.children = [fromData];
      }
      for (var i in fromParentModelChildren) {
        if (fromParentModelChildren[i].id === fromData.id) {
          fromParentModelChildren.splice(i, 1);
        }
      }
    },
    formatInitialBalanceDate: function formatInitialBalanceDate(timestamp) {
      if (timestamp === null) {
        return timestamp;
      }
      var date = new Date(timestamp);
      var day = String(date.getDate()).padStart(2, '0');
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var year = date.getFullYear();
      return day + '/' + month + '/' + year;
    },
    formatInitialBalance: function formatInitialBalance(value) {
      if (value === null) {
        return value;
      }
      return value % 1 !== 0 ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : value.toLocaleString('pt-BR') + ',00';
    }
  },

  beforeCreate: function beforeCreate() {
    this.$options.components.item = __webpack_require__(/*! ./TreeviewCategories */ 692);
  }
};

/***/ }),
/* 853 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/conciliationPlan/TreeViewPlans.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ 136);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var id = 1000;
var fromData = '';
var toData = '';
var fromParentModelChildren = '';
var nodeClicked = null;

exports.default = {
  name: 'TreeViewPlans',

  data: function data() {
    return {
      open: false,
      isClicked: false
    };
  },

  props: {
    model: Object,
    buttonsTitle: Object,
    clickFunction: Function,
    clickRemoveFunction: {
      type: Function,
      default: null
    },
    showRemove: {
      type: Boolean,
      default: false
    },
    id: String,
    father: Object,
    defaultText: String,
    currentHighlight: Boolean,
    hoverColor: String,
    highlightColor: String,
    spaceLeft: String,
    styleObj: Object
  },

  template: '<div class="treeview">\n              <div :id=\'model.id\' draggable=\'false\' @dragstart=\'dragStart\' @dragover=\'dragOver\' @dragenter=\'dragEnter\' @dragleave=\'dragLeave\' @drop=\'drop\' @dragend=\'dragEnd\' class=\'col-xs-12 col-sm-12 col-md-12 treeRow pl-0\' :class="[model.parent ? \'treeRowBg\' : \'\']" @mouseover=\'mouseOver\' @mouseout=\'mouseOut\' :style=\'styleObj\'>\n                <div class="pull-left pl-0 text-left" style="padding-top:3px!important">\n                  <div v-if="model.children" style="min-width:33px;"></div>\n                  <button style="width:23px; float:left;" v-if="!isClicked && model.children && model.children.length > 0" :title="[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : \'\']" @click="toggle" class="fa fa-chevron-down px-0 action btn-white"></button>\n                  <button style="width:23px; float:left;" v-if="isClicked && model.children && model.children.length > 0" :title="[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : \'\']" @click="toggle" class="fa fa-chevron-up px-0 action btn-white"></button>\n                </div>\n\n                <div :style=\'spaceLeft\' class="col-xs-3 col-sm-3 col-md-3 col-lg-4" :class="[model.parent || model.isMidSection ? \'pl-0\' : \'padding-left-children\']">\n                  {{model.isMidSection ? this.$t(model.planName) : model.planName}}\n                </div>\n                <div class="col-xs-2 col-sm-2 col-md-3 col-lg-2" :class="[model.parent ? \'pl-0\' : \'padding-left-children-item\']">{{model.order}}</div>\n                <div class="col-xs-2 col-sm-2 col-md-3 col-lg-2" :class="[model.parent ? \'pl-0\' : \'padding-left-children-item\']" v-html="$t(model.isRelevant != null ? (model.isRelevant ? \'planoConciliacao.labels.relevante\' : \'planoConciliacao.labels.irrelevante\') : null)"></div>\n                <div class="col-xs-2 col-sm-2 col-md-3 col-lg-2" :class="[model.parent ? \'pl-0\' : \'padding-left-children-item\']" v-html="$t(model.isActive != null ? (model.isActive ? \'planoConciliacao.labels.ativo\' : \'planoConciliacao.labels.inativo\') : null)"></div>\n\n                <div v-if=\'model.parent\' class="pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-2" style="padding-top:3px!important">\n                  <button v-if=\'showRemove\' :disabled=\'model.emUso\' style="width:23px; float:right;" @click="clickRemoveFunction(model.id)" :title="[model.emUso ? (buttonsTitle && buttonsTitle.removeBloq ? buttonsTitle.removeBloq : \'\') : (buttonsTitle && buttonsTitle.remove ? buttonsTitle.remove : \'\')]" class="fa fa-times action btn-white pr-0"></button>\n                  <button style="width:23px; float:right;" id="buttonEdit" @click="clickAction(\'buttonEdit\')" :title="[buttonsTitle && buttonsTitle.config ? buttonsTitle.config : \'\']" class="fa fa-cog action btn-white pr-0"></button>\n                </div>\n\n              </div>\n\n              <div class="clear"></div>\n\n              <div v-show="open" v-if="isFolder">\n                <item v-for="model in orderedNumbers" :spaceLeft=\'model.marginLeft\' :clickFunction=\'clickFunction\' :id=\'model.id\' :father="model" :model="model" :key=\'model.id\' :currentHighlight=\'currentHighlight\' :defaultText=\'defaultText\' :hoverColor=\'hoverColor\' :highlightColor=\'highlightColor\'>\n                </item>\n              </div>\n            </div>',

  computed: {
    orderedNumbers: function orderedNumbers() {
      return this.model.children.sort(function (a, b) {
        return Number(a.order) - Number(b.order);
      });
    },
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length > 0;
    }
  },

  methods: {
    clickAction: function clickAction(idButton) {
      var isEdit = idButton === 'buttonEdit';
      this.clickFunction(this.id, this.father, isEdit);
    },
    toggle: function toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
      var rootTree = this.findRoot();

      this.isClicked = !this.isClicked;

      if (this.currentHighlight) {
        if (nodeClicked !== this.model.id) {
          var treeParent = rootTree.$parent;
          var nodeStack = [treeParent.$children[0]];
          while (nodeStack.length !== 0) {
            var item = nodeStack.shift();
            item.styleObj.background = 'white';
            if (item.$children && item.$children.length > 0) {
              nodeStack = nodeStack.concat(item.$children);
            }
          }
          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF';
          nodeClicked = this.model.id;
        }
      }
    },
    exchangeData: function exchangeData(rootCom, from, to) {
      if (!to || !from || typeof to === 'string' || from.id === to.id) {
        return;
      }

      from = JSON.parse((0, _stringify2.default)(from));
      to = JSON.parse((0, _stringify2.default)(to));

      var treeData = JSON.parse((0, _stringify2.default)(this.model));
      var nodeStack = [treeData];
      var status = 0;

      try {
        while (!(status === 2)) {
          var item = nodeStack.shift();
          if (item.id === from.id) {
            item.id = to.id;
            item.name = to.name;
            if (to.children && to.children.length > 0) {
              item['children'] = to.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.id === to.id) {
            item.id = from.id;
            item.name = from.name;
            if (from.children && from.children.length > 0) {
              item['children'] = from.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.children && item.children.length > 0) {
            nodeStack = nodeStack.concat(item.children);
          }
        }
      } catch (e) {
        return;
      }
      rootCom.assignData(treeData);
    },
    changeType: function changeType() {
      if (this.currentHighlight) {
        nodeClicked = this.model.id;
      }
      if (!this.isFolder) {
        this.$set(this.model, 'children', []);
        this.addChild();
        this.open = true;
        this.isClicked = true;
      }
    },
    mouseOver: function mouseOver(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2';
        }
      }
    },
    mouseOut: function mouseOut(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = 'white';
        }
      }
    },
    findRoot: function findRoot() {
      var ok = false;
      var that = this;
      while (!ok) {
        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {
          ok = true;
          break;
        }
        that = that.$parent;
      }
      return that;
    },
    addChild: function addChild() {
      this.model.children.push({
        name: this.defaultText ? this.defaultText : 'New Node',
        id: id++
      });
    },
    removeChild: function removeChild(id) {
      var parentModelChildren = this.$parent.model.children;
      for (var index in parentModelChildren) {
        if (parentModelChildren[index].id === id) {
          parentModelChildren = parentModelChildren.splice(index, 1);
          break;
        }
      }
    },
    dragStart: function dragStart(e) {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('nottext', e.target.innerHTML);
      return true;
    },
    dragEnd: function dragEnd(e) {
      fromData = undefined;
      toData = undefined;
      fromParentModelChildren = undefined;
    },
    dragOver: function dragOver(e) {
      e.preventDefault();
      return true;
    },
    dragOverPlus: function dragOverPlus(e) {
      e.preventDefault();
    },
    dragEnterPlus: function dragEnterPlus(e) {},
    dragEnter: function dragEnter(e) {
      toData = this.model;
      var rootTree = this.findRoot();
      rootTree.exchangeData(rootTree.$parent, fromData, toData);
    },
    dragLeave: function dragLeave(e) {
      fromData = this.model;
      fromParentModelChildren = this.$parent.model.children;
    },
    drop: function drop(e) {},
    dropPlus: function dropPlus(e) {
      if (this.model.hasOwnProperty('children')) {
        this.model.children.push(fromData);
      } else {
        this.model.children = [fromData];
      }
      for (var i in fromParentModelChildren) {
        if (fromParentModelChildren[i].id === fromData.id) {
          fromParentModelChildren.splice(i, 1);
        }
      }
    }
  },

  beforeCreate: function beforeCreate() {
    this.$options.components.item = __webpack_require__(/*! ./TreeViewPlans */ 693);
  }
};

/***/ }),
/* 854 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/conciliationPlan/classificationCriteria/ClassificationCriteria.vue ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ClassificationCriteria',

  props: {
    criteria: {
      type: Object,
      required: true
    },
    order: {
      type: Number,
      required: true
    },
    handleEdit: {
      type: Function,
      required: true
    },
    handleRemove: {
      type: Function,
      required: true
    }
  },

  computed: {
    btnEditTitle: function btnEditTitle() {
      return this.criteria.criterioEmUso ? this.$t('planoConciliacao.validacao.criterioEmUsoEditar') : this.$t('planoConciliacao.labels.editar');
    },
    btnRemoveTitle: function btnRemoveTitle() {
      return this.criteria.criterioEmUso ? this.$t('planoConciliacao.validacao.criterioEmUsoExcluir') : this.$t('planoConciliacao.labels.remover');
    }
  }
};

/***/ }),
/* 855 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/conciliationPlan/classificationCriteria/ConciliationField.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConciliationField',

  components: {
    vSelect: _vueSelect2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    conciliationField: {
      type: Object,
      default: {}
    },
    attributesCfg: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    attributes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    conciliationFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      field: null
    };
  },


  watch: {
    conciliationField: {
      handler: function handler(newVal, oldVal) {
        this.field = newVal;
      },

      deep: true
    }
  },

  methods: {
    changeAttCfg: function changeAttCfg(cfg) {
      if (cfg === null || cfg instanceof Object) {
        this.$emit('change-conc-field-cfg', { cfg: cfg, concField: this.conciliationField });
      }
    },
    changeAttName: function changeAttName(att) {
      if (att instanceof Object) {
        this.$emit('change-conc-field-att-name', { att: att, concField: this.conciliationField });
      }
    },
    changeConcField: function changeConcField(field) {
      if (field instanceof Object) {
        this.$emit('change-conc-field', { field: field, concField: this.conciliationField });
      }
    },
    removeField: function removeField() {
      this.$emit('remove-field-from-criteria', this.conciliationField);
    }
  }
};

/***/ }),
/* 856 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/conciliationPlan/classificationCriteria/NewClassificationCriteria.vue ***!
  \**************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = __webpack_require__(/*! babel-runtime/core-js/object/entries */ 320);

var _entries2 = _interopRequireDefault(_entries);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ConciliationField = __webpack_require__(/*! ./ConciliationField */ 1296);

var _ConciliationField2 = _interopRequireDefault(_ConciliationField);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'NewClassificationCriteria',

  components: {
    vSelect: _vueSelect2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ConciliationField: _ConciliationField2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    criteriaToEdit: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: null,
      required: true
    },
    febraban: {
      type: Array,
      default: null,
      required: true
    },
    banks: {
      type: Array,
      default: null,
      required: true
    },
    accounts: {
      type: Array,
      default: null,
      required: true
    },
    attributesCfg: {
      type: Array,
      default: null,
      required: true
    },
    conciliationFields: {
      type: Array,
      default: null,
      required: true
    }
  },

  data: function data() {
    return {
      requestSent: false,
      criteria: {},
      filteredAccounts: [],
      attributes: []
    };
  },


  watch: {
    criteriaToEdit: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          this.criteria = (0, _assign2.default)({}, newVal, { classificacaoCampos: [].concat((0, _toConsumableArray3.default)(newVal.classificacaoCampos)) });
          if (this.criteria.categoria) {
            this.criteria.categoria.label = this.criteria.categoria.numero + ' - ' + this.criteria.categoria.nome;
          }
          if (this.criteria.conta) {
            this.criteria.conta.label = this.criteria.conta.id !== 0 ? this.criteria.conta.nome + ' (' + this.criteria.conta.numAgencia + (this.criteria.conta.digAgencia ? '-' + this.criteria.conta.digAgencia : '') + '/' + this.criteria.conta.conta + (this.criteria.conta.digConta ? '-' + this.criteria.conta.digConta : '') + ')' + (this.criteria.conta.ativo === undefined || this.criteria.conta.ativo === null || this.criteria.conta.ativo ? '' : ' [' + this.$t('contaBancaria.labels.inativa') + ']') : this.criteria.conta.nome;
          }

          if (this.criteria.banco) {
            this.criteria.banco.label = (this.criteria.banco.codigo ? this.criteria.banco.codigo + '-' : '') + this.criteria.banco.nomeFantasia;
          }

          if (this.criteria.categoriaFebraban) {
            this.criteria.categoriaFebraban.label = this.criteria.categoriaFebraban.codigo + ' - ' + this.criteria.categoriaFebraban.descricao;
          }
        } else {
          this.criteria = {
            ativo: true,
            relevante: true,
            banco: {},
            conta: {},
            categoria: {},
            categoriaFebraban: {},
            classificacaoCampos: [],
            criterioEmUso: false
          };
        }
      }
    },
    accounts: {
      handler: function handler(newVal, oldVal) {
        this.filteredAccounts = [].concat((0, _toConsumableArray3.default)(newVal));
      }
    }
  },

  methods: {
    filterAccounts: function filterAccounts(val) {
      this.criteria.conta = null;
      if (val && val.codigo) {
        this.criteria.banco = val;
        this.filteredAccounts = this.accounts.filter(function (account) {
          return account.banco.codigo === val.codigo || account.id === 0;
        });
      } else {
        this.criteria.banco = null;
        this.filteredAccounts = [].concat((0, _toConsumableArray3.default)(this.accounts));
      }
    },
    back: function back() {
      this.$emit('change-managing-plan');
      this.errors.clear();
      this.requestSent = false;
    },
    validate: function validate(event) {
      var _this = this;

      this.requestSent = true;
      var self = this;
      event.preventDefault();
      this.$validator.validateAll().then(function (result) {
        if (result) {
          var isAllFieldsValid = true;
          (0, _entries2.default)(self.$refs).map(function (refArray) {
            if (refArray[1] && refArray[1].length > 0) {
              refArray[1][0].$validator.validateAll().then(function (fieldValidation) {
                if (isAllFieldsValid) {
                  isAllFieldsValid = fieldValidation;
                }
              });
            }
          });
          setTimeout(function () {
            if (isAllFieldsValid) {
              self.addCriteria();
            } else {
              _this.requestSent = false;
            }
          }, 500);
        } else {
          _this.requestSent = false;
        }
      });
    },
    addCriteria: function addCriteria() {
      this.$emit('add-criteria-to-plan', this.criteria);
      this.back();
    },
    setValuesFieldsCategory: function setValuesFieldsCategory(category) {
      if (category) {
        this.criteria.tipoLancamento = category.tipo;
        if (!this.criteria.hasOwnProperty('descricao') || this.criteria.descricao === '') {
          this.$set(this.criteria, 'descricao', category.nome);
          var field = this.$validator.fields.find({ name: 'criteria.descricao' });
          field.reset();
          this.$validator.errors.remove(field.name);
        }
      } else {
        this.criteria.categoria = null;
        this.criteria.tipoLancamento = null;
      }
    },
    addClassificationField: function addClassificationField() {
      if (!this.criteria.classificacaoCampos) {
        this.criteria.classificacaoCampos = [];
      }

      this.criteria.classificacaoCampos.push({
        idCriterioClassificacao: this.criteria.idCriterioClassificacao,
        idAtributoCfg: this.attributesCfg[0],
        nomeAtributo: this.attributesCfg[0].children[0],
        conciliacaoCampo: this.conciliationFields[0],
        key: this.criteria.classificacaoCampos.length + 1
      });
    },
    removeClassificationField: function removeClassificationField(field) {
      var index = this.criteria.classificacaoCampos.findIndex(function (item) {
        return item.key === field.key;
      });
      this.criteria.classificacaoCampos.splice(index, 1);
      if (field.id) {
        if (!this.criteria.idsCamposRemovidos) {
          this.criteria.idsCamposRemovidos = [];
        }
        this.criteria.idsCamposRemovidos.push(field.id);
      }
    },
    changeFieldAttCfg: function changeFieldAttCfg(item) {
      var _this2 = this;

      this.criteria.classificacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          mappedItem.idAtributoCfg = item.cfg;
          if (item.cfg) {
            _this2.attributes = item.cfg.children;
            var att = item.cfg.children.find(function (itemAtt) {
              return itemAtt.id === (mappedItem.nomeAtributo instanceof Object ? mappedItem.nomeAtributo.id : mappedItem.nomeAtributo);
            });
            mappedItem.nomeAtributo = att !== null && att !== undefined ? att : item.cfg.children[0];
          } else {
            mappedItem.nomeAtributo = null;
            _this2.attributes = [];
          }
        }
      });
    },
    changeFieldAttName: function changeFieldAttName(item) {
      this.criteria.classificacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          mappedItem.nomeAtributo = item.att;
        }
      });
    },
    changeFieldAttConciliationField: function changeFieldAttConciliationField(item) {
      this.criteria.classificacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          mappedItem.conciliacaoCampo = item.field;
        }
      });
    }
  }
};

/***/ }),
/* 857 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCritFields.vue ***!
  \*********************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConciliationCritFields',

  components: {
    vSelect: _vueSelect2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    conciliationField: {
      type: Object,
      default: {},
      required: true
    },
    attributesCfgMfList: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    attributesMfList: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    mfFieldList: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    mbFieldList: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    conciliationFieldList: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    }
  },

  data: function data() {
    return {
      field: {
        atributo: {
          nomeAtributo: null,
          atributoCfg: null
        }
      }
    };
  },


  computed: {
    mfCfgList: function mfCfgList() {
      var mfCfgList = [];
      var self = this;
      this.attributesCfgMfList.map(function (cfg) {
        if (cfg.linkType === (self.conciliationField && self.conciliationField.conciliacaoCampoMovFinan ? self.conciliationField.conciliacaoCampoMovFinan.tipoVinculo : '')) {
          mfCfgList.push(cfg);
        }
      });
      return mfCfgList;
    },
    mfAttList: function mfAttList() {
      var attributesCfgMf = [];
      var self = this;
      this.attributesMfList.map(function (att) {
        var alreadyUsed = false;

        if (self.conciliationFieldList && self.conciliationFieldList.length > 0) {
          alreadyUsed = self.conciliationFieldList.findIndex(function (concField) {
            return concField.key !== self.conciliationField.key && (concField.atributo && concField.atributo.nomeAtributo ? concField.atributo.nomeAtributo.id : null) === att.id && (concField.conciliacaoCampoMovFinan ? concField.conciliacaoCampoMovFinan.id : null) === (self.conciliationField && self.conciliationField.conciliacaoCampoMovFinan ? self.conciliationField.conciliacaoCampoMovFinan.id : null);
          }) !== -1;
        }
        if (!alreadyUsed) {
          attributesCfgMf.push(att);
        }
      });
      return attributesCfgMf;
    }
  },

  watch: {
    conciliationField: {
      handler: function handler(newVal, oldVal) {
        this.field = (0, _assign2.default)({}, newVal, {
          atributo: newVal.atributo ? {
            atributoCfg: newVal.atributo.atributoCfg ? (0, _assign2.default)({}, newVal.atributo.atributoCfg) : null,
            nomeAtributo: newVal.atributo.nomeAtributo ? (0, _assign2.default)({}, newVal.atributo.nomeAtributo) : null
          } : null
        });
      },

      deep: true
    }
  },

  methods: {
    changeMfField: function changeMfField(field) {
      if (field === null || field instanceof Object) {
        this.$emit('change-conc-field-mf', { field: field, concField: this.conciliationField });
      }
    },
    changeMbField: function changeMbField(field) {
      if (field === null || field instanceof Object) {
        this.$emit('change-conc-field-mb', { field: field, concField: this.conciliationField });
      }
    },
    changeMfAttCfg: function changeMfAttCfg(cfg) {
      if (cfg === null || cfg instanceof Object) {
        this.$emit('change-conc-field-cfg-mf', { cfg: cfg, concField: this.conciliationField });
      }
    },
    updateMfAttList: function updateMfAttList(cfg) {
      if (cfg === null || cfg instanceof Object) {
        this.$emit('update-attributes-list', { cfg: cfg, concField: this.conciliationField });
      }
    },
    changeMfAtt: function changeMfAtt(att) {
      if (att === null || att instanceof Object) {
        this.$emit('change-conc-field-att-name-mf', { att: att, concField: this.conciliationField });
      }
    },
    removeField: function removeField() {
      this.$emit('remove-field-from-criteria-concil', this.conciliationField);
    }
  },

  mounted: function mounted() {
    this.field = (0, _assign2.default)({}, this.conciliationField, {
      atributo: this.conciliationField.atributo ? {
        atributoCfg: this.conciliationField.atributo.atributoCfg ? (0, _assign2.default)({}, this.conciliationField.atributo.atributoCfg) : null,
        nomeAtributo: this.conciliationField.atributo.nomeAtributo ? (0, _assign2.default)({}, this.conciliationField.atributo.nomeAtributo) : null
      } : null
    });
    this.updateMfAttList(this.conciliationField.atributo && this.conciliationField.atributo.atributoCfg ? this.conciliationField.atributo.atributoCfg : null);
  }
};

/***/ }),
/* 858 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCriteria.vue ***!
  \*******************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ConciliationCriteria',

  props: {
    criteria: {
      type: Object,
      required: true
    },
    order: {
      type: Number,
      required: true
    },
    handleEdit: {
      type: Function,
      required: true
    },
    handleRemove: {
      type: Function,
      required: true
    }
  },

  computed: {
    btnEditTitle: function btnEditTitle() {
      return this.criteria.criterioEmUso ? this.$t('planoConciliacao.validacao.criterioConcilEmUsoEditar') : this.$t('planoConciliacao.labels.editar');
    },
    btnRemoveTitle: function btnRemoveTitle() {
      return this.criteria.criterioEmUso ? this.$t('planoConciliacao.validacao.criterioConcilEmUsoExcluir') : this.$t('planoConciliacao.labels.remover');
    }
  }
};

/***/ }),
/* 859 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria.vue ***!
  \**********************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = __webpack_require__(/*! babel-runtime/core-js/object/entries */ 320);

var _entries2 = _interopRequireDefault(_entries);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vMoney = __webpack_require__(/*! v-money */ 195);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _InputEstablishment = __webpack_require__(/*! ../../../input/inputEstablishment/InputEstablishment */ 130);

var _InputEstablishment2 = _interopRequireDefault(_InputEstablishment);

var _ConciliationCritFields = __webpack_require__(/*! ./ConciliationCritFields */ 1298);

var _ConciliationCritFields2 = _interopRequireDefault(_ConciliationCritFields);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _ConfirmModal = __webpack_require__(/*! ../../../../components/modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'NewConciliationCriteria',

  components: {
    Money: _vMoney.Money,
    vSelect: _vueSelect2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    InputEstablishment: _InputEstablishment2.default,
    ConciliationCritField: _ConciliationCritFields2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    ConfirmModal: _ConfirmModal2.default
  },

  props: {
    concilCriteriaToEdit: {
      type: Object,
      default: null
    },
    banks: {
      type: Array,
      default: null,
      required: true
    },
    accounts: {
      type: Array,
      default: null,
      required: true
    },
    attributesCfg: {
      type: Array,
      default: null,
      required: true
    },
    conciliationFields: {
      type: Array,
      default: null,
      required: true
    },
    occurrenceReasons: {
      type: Array,
      default: null,
      required: true
    }
  },

  data: function data() {
    return {
      requestSent: false,
      criteriaConcil: {
        valorDiferencaMax: 0,
        valorDivergenciaMax: 0
      },
      filteredAccounts: [],
      attributes: [],
      establishimentsUrls: {
        establishments: 'conciliationPlan/establishment/list',
        attributes: '/conciliationPlan/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      moneyMask: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      },
      idioma: _index2.default,
      attributesMfList: [],
      attributesMbList: []
    };
  },


  computed: {
    mfFieldList: function mfFieldList() {
      var mfFieldList = [];
      var self = this;
      this.conciliationFields.map(function (field) {
        var alreadyUsed = false;

        if (self.criteriaConcil.conciliacaoCampos && self.criteriaConcil.conciliacaoCampos.length > 0) {
          alreadyUsed = self.criteriaConcil.conciliacaoCampos.findIndex(function (concField) {
            return (concField.conciliacaoCampoMovFinan ? concField.conciliacaoCampoMovFinan.id : null) === field.id && field.tipo !== 'A';
          }) !== -1;
        }

        if (!(field.tipo === 'B') && !alreadyUsed) {
          mfFieldList.push(field);
        }
      });
      return mfFieldList;
    },
    mbFieldList: function mbFieldList() {
      var mbFieldList = [];
      var self = this;
      this.conciliationFields.map(function (field) {
        var alreadyUsed = false;

        if (self.criteriaConcil.conciliacaoCampos && self.criteriaConcil.conciliacaoCampos.length > 0) {
          alreadyUsed = self.criteriaConcil.conciliacaoCampos.findIndex(function (concField) {
            return (concField.conciliacaoCampoMovBancario ? concField.conciliacaoCampoMovBancario.id : null) === field.id && field.tipo !== 'A';
          }) !== -1;
        }

        if (field.tipo === 'B' && !alreadyUsed) {
          mbFieldList.push(field);
        }
      });
      return mbFieldList;
    },
    attributesCfgMfList: function attributesCfgMfList() {
      var attributesCfgMf = [];
      this.attributesCfg.map(function (cfg) {
        attributesCfgMf.push(cfg);
      });
      return attributesCfgMf;
    }
  },

  watch: {
    concilCriteriaToEdit: {
      handler: function handler(newVal, oldVal) {
        if (newVal) {
          this.criteriaConcil = (0, _assign2.default)({}, newVal, { conciliacaoCampos: [].concat((0, _toConsumableArray3.default)(newVal.conciliacaoCampos)) });
          if (this.criteriaConcil.valorDiferencaMax === 0 || !this.criteriaConcil.valorDiferencaMax) {
            this.criteriaConcil.valorDiferencaMax = '0';
          }
          if (this.criteriaConcil.valorDivergenciaMax === 0) {
            this.criteriaConcil.valorDivergenciaMax = '0';
          }
          if (this.criteriaConcil.conciliacaoEstabelecimentos && this.criteriaConcil.conciliacaoEstabelecimentos.length > 0) {
            this.selectedEstablishments = [].concat((0, _toConsumableArray3.default)(this.criteriaConcil.conciliacaoEstabelecimentos));
          } else {
            this.selectedEstablishments = [];
          }
        } else {
          this.criteriaConcil = {
            ativo: true,
            criterioEmUso: false,
            conciliacaoCampos: [],
            conta: null,
            banco: null,
            descricao: '',
            estabelecimentos: [],
            diasDiferencaMin: 0,
            diasDiferencaMax: 0,
            valorDiferencaMax: 0,
            valorDivergenciaMax: 0,
            motivoOcorrencia: null
          };
        }
      }
    },
    accounts: {
      handler: function handler(newVal, oldVal) {
        this.filteredAccounts = [].concat((0, _toConsumableArray3.default)(newVal));
      }
    }
  },

  methods: {
    back: function back() {
      this.$emit('change-managing-plan-concil');
      this.errors.clear();
      this.requestSent = false;
    },
    validate: function validate(event) {
      var _this = this;

      this.requestSent = true;
      if (event) {
        event.preventDefault();
      }
      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (!_this.criteriaConcil.valorDivergenciaMax) {
            _this.openConfirmationModal();
            _this.requestSent = false;
            return;
          }
          _this.submitCriteria();
        } else {
          _this.requestSent = false;
        }
      });
    },
    submitCriteria: function submitCriteria() {
      var _this2 = this;

      var self = this;
      setTimeout(function () {
        if (_this2.verifyFields) {
          self.addCriteria();
        } else {
          _this2.requestSent = false;
        }
      }, 500);
    },
    verifyFields: function verifyFields() {
      var self = this;
      var isAllFieldsValid = true;
      (0, _entries2.default)(self.$refs).map(function (refArray) {
        if (refArray[1] && refArray[1].length > 0) {
          refArray[1][0].$validator.validateAll().then(function (fieldValidation) {
            if (isAllFieldsValid) {
              isAllFieldsValid = fieldValidation;
            }
          });
        }
      });
      return isAllFieldsValid;
    },
    addCriteria: function addCriteria() {
      if (this.selectedEstablishments && this.selectedEstablishments.length > 0) {
        this.criteriaConcil.conciliacaoEstabelecimentos = [].concat((0, _toConsumableArray3.default)(this.selectedEstablishments));
        this.criteriaConcil.flEstabelecimento = true;
      } else {
        this.criteriaConcil.conciliacaoEstabelecimentos = null;
        this.criteriaConcil.flEstabelecimento = false;
      }
      this.$emit('add-concil-criteria-to-plan', this.criteriaConcil);
      this.back();
    },
    addConciliationField: function addConciliationField() {
      if (!this.criteriaConcil.conciliacaoCampos) {
        this.criteriaConcil.conciliacaoCampos = [];
      }

      this.criteriaConcil.conciliacaoCampos.push({
        idCriterioClassificacao: this.criteriaConcil.idCriterioClassificacao,
        atributo: {
          atributoCfg: null,
          nomeAtributo: null
        },
        conciliacaoCampoMovBancario: null,
        conciliacaoCampoMovFinan: null,
        key: this.criteriaConcil.conciliacaoCampos.length + 1
      });
    },
    removeConciliationField: function removeConciliationField(field) {
      var index = this.criteriaConcil.conciliacaoCampos.findIndex(function (item) {
        return item.key === field.key;
      });
      this.criteriaConcil.conciliacaoCampos.splice(index, 1);
      if (field.id) {
        if (!this.criteriaConcil.idsCamposRemovidos) {
          this.criteriaConcil.idsCamposRemovidos = [];
        }
        this.criteriaConcil.idsCamposRemovidos.push(field.id);
      }
    },
    changeFieldAttCfgMf: function changeFieldAttCfgMf(item) {
      var _this3 = this;

      this.criteriaConcil.conciliacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          if (!mappedItem.atributo) {
            mappedItem.atributo = {};
          }
          mappedItem.atributo.atributoCfg = item.cfg;
          mappedItem.atributo.nomeAtributo = null;
          if (item.cfg) {
            _this3.attributesMfList = item.cfg.children;
          } else {
            _this3.attributesMfList = [];
          }
        }
      });
    },
    changeFieldAttNameMf: function changeFieldAttNameMf(item) {
      this.criteriaConcil.conciliacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          mappedItem.atributo.nomeAtributo = item.att;
        }
      });
    },
    changeFieldAttConciliationFieldMf: function changeFieldAttConciliationFieldMf(item) {
      this.criteriaConcil.conciliacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          mappedItem.conciliacaoCampoMovFinan = item.field;
          if (item.field && item.field.tipo === 'A') {
            mappedItem.atributo = {
              atributoCfg: null,
              nomeAtributo: null
            };
          } else {
            mappedItem.atributo = null;
          }
        }
      });
    },
    changeFieldAttConciliationFieldMb: function changeFieldAttConciliationFieldMb(item) {
      this.criteriaConcil.conciliacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          mappedItem.conciliacaoCampoMovBancario = item.field;
        }
      });
    },
    changeCritBank: function changeCritBank(val) {
      this.criteriaConcil.conta = null;
      if (val && val.codigo) {
        this.criteriaConcil.banco = val;
        this.filteredAccounts = this.accounts.filter(function (account) {
          return account.banco.codigo === val.codigo || account.id === 0;
        });
      } else {
        this.criteriaConcil.banco = null;
        this.filteredAccounts = [].concat((0, _toConsumableArray3.default)(this.accounts));
      }
    },
    updateAttibutesList: function updateAttibutesList(item) {
      var _this4 = this;

      this.criteriaConcil.conciliacaoCampos.map(function (mappedItem) {
        if (mappedItem.key === item.concField.key) {
          if (item.cfg) {
            _this4.attributesMfList = item.cfg.children;
          } else {
            _this4.attributesMfList = [];
          }
        }
      });
    },
    openConfirmationModal: function openConfirmationModal() {
      this.verifyFields();
      this.showConfirmationModal();
    },
    confirmAdd: function confirmAdd() {
      this.closeModal();
      this.submitCriteria();
    },
    closeModal: function closeModal() {
      $('#confirmDivergMax').modal('hide');
    },
    showConfirmationModal: function showConfirmationModal() {
      $('#confirmDivergMax').modal({ backdrop: 'static', keyboard: false });
    }
  },

  mounted: function mounted() {
    this.moneyMask = this.idioma.getMoneyMaskByLanguage();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 860 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/registration/establishments/MoveEstablishmentModal.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConfirmModal = __webpack_require__(/*! ../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MoveEstablishmentModal',

  components: {
    ConfirmModal: _ConfirmModal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      disableButton: false,
      textModal: 'estabelecimentos.labels.confirmacaoMoverEstabelecimento'
    };
  },


  computed: {
    selectedEstablishmentsMoveEstablishment: function selectedEstablishmentsMoveEstablishment() {
      return this.$store.getters.selectedEstablishmentsMoveEstablishment;
    }
  },

  methods: {
    confirmMoveEstablishment: function confirmMoveEstablishment() {
      var _this = this;

      var data = {
        establishmentOrigin: this.selectedEstablishmentsMoveEstablishment.establishmentOrigin,
        establishmentDestiny: this.selectedEstablishmentsMoveEstablishment.establishmentDestiny,
        deleteEstablishmentOrigin: this.selectedEstablishmentsMoveEstablishment.deleteEstablishmentOrigin
      };

      this.$store.dispatch('loadingData').then(function () {
        _this.disableButton = true;
        _this.$store.dispatch('moveEstablishment', data).then(function (response) {
          _this.confirmReopenSuccess(response);
        }).catch(function (error) {
          _this.confirmReopenError(error);
        });
      });
    },
    confirmReopenSuccess: function confirmReopenSuccess(response) {
      this.disableButton = false;
      this.$store.dispatch('cleanSelectedEstablishmentsMoveEstablishment');
      this.closeModal();
      this.$root.$refs.notification.global('S', this.$t(response.data.message));
      this.$store.dispatch('dataLoaded');
      this.$router.push(_routesMap2.default.LIST_ESTABLISHMENTS);
    },
    confirmReopenError: function confirmReopenError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.disableButton = false;
      if (error && error.message === 'estabelecimentos.erro.excluirEstabelecimentoVinculado') {
        this.textModal = 'estabelecimentos.labels.apenasMoverLancamento';
        this.$store.dispatch('setSelectedEstablishmentsMoveEstablishment', {
          establishmentOrigin: this.selectedEstablishmentsMoveEstablishment.establishmentOrigin,
          establishmentDestiny: this.selectedEstablishmentsMoveEstablishment.establishmentDestiny,
          deleteEstablishmentOrigin: false
        });
      } else {
        this.closeModal();
      }
      this.$root.$refs.notification.global('E', error && error.data && error.data.message ? this.$t(error.data.message) : error && error.message ? this.$t(error.message) : this.$t('GENERAL'));
      this.$store.dispatch('dataLoaded');
    },
    closeModal: function closeModal() {
      $('#moveEstablishmentModal').modal('hide');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 861 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/conciliationSummary/CalendarDetailBox.vue ***!
  \*****************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _numberMasker = __webpack_require__(/*! ../../../utils/numberMasker.js */ 71);

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _LoadingPlaceholder = __webpack_require__(/*! ../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _Toogle = __webpack_require__(/*! ../../buttons/toogle/Toogle */ 1259);

var _Toogle2 = _interopRequireDefault(_Toogle);

var _BetterInputTag = __webpack_require__(/*! ../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

exports.default = {
  name: 'CalendarDetailBox',

  components: {
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    ButtonPrimary: _ButtonPrimary2.default,
    Toogle: _Toogle2.default,
    BetterInputTag: _BetterInputTag2.default
  },

  props: {
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    },
    conciliacaoData: {
      type: Array,
      required: true
    },
    filteredCategory: {
      type: Object
    },
    setCategory: {
      type: Function,
      required: true,
      default: function _default() {
        return null;
      }
    }
  },

  watch: {
    conciliacaoData: {
      handler: function handler() {
        this.handleChangeSelection ? this.handleChangeSelection() : null;
      },

      deep: true
    },
    startDate: {
      handler: function handler() {
        this.handleChangeSelection ? this.handleChangeSelection() : null;
      },

      deep: true
    },
    filteredCategory: {
      handler: function handler() {
        this.handleChangeSelection ? this.handleChangeSelection() : null;
      },

      deep: true
    }
  },

  data: function data() {
    var _this = this;

    return {
      conciliationSummary: [],
      accountsTable: {
        columns: ['conta', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],
        options: {
          columnsClasses: {
            'situacao': 'col-2 limit-char table-cell-center',
            'conta': 'col-2 limit-char table-cell-center',
            'valorMovFinan': 'col-2 limit-char table-cell-rigth',
            'valorMovBanc': 'col-2 limit-char table-cell-rigth',
            'diferenca': 'col-2 limit-char table-cell-rigth'
          },
          headings: {
            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),
            conta: this.$t('contaBancaria.labels.numeroConta'),
            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),
            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),
            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')
          },
          templates: {
            situacao: _LoadingPlaceholder2.default,
            conta: _LoadingPlaceholder2.default,
            valorMovFinan: _LoadingPlaceholder2.default,
            valorMovBanc: _LoadingPlaceholder2.default,
            diferenca: _LoadingPlaceholder2.default
          },
          filterable: [],
          filterByColumn: false,
          sortable: [],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          perPageValues: [],
          perPage: 10,
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados')
          }
        },
        data: []
      },
      establishmentsTable: {
        columns: ['estabelecimento', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],
        options: {
          columnsClasses: {
            'situacao': 'col-2 limit-char table-cell-center',
            'estabelecimento': 'col-2 limit-char table-cell-center',
            'valorMovFinan': 'col-2 limit-char table-cell-rigth',
            'valorMovBanc': 'col-2 limit-char table-cell-rigth',
            'diferenca': 'col-2 limit-char table-cell-rigth'
          },
          headings: {
            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),
            estabelecimento: this.$t('estabelecimentos.labels.estabelecimento'),
            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),
            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),
            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')
          },
          templates: {
            situacao: _LoadingPlaceholder2.default,
            estabelecimento: _LoadingPlaceholder2.default,
            valorMovFinan: _LoadingPlaceholder2.default,
            valorMovBanc: _LoadingPlaceholder2.default,
            diferenca: _LoadingPlaceholder2.default
          },
          filterable: [],
          filterByColumn: false,
          sortable: [],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          perPageValues: [],
          perPage: 10,
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados')
          }
        },
        data: []
      },
      categoriesTable: {
        columns: ['categoria', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],
        options: {
          columnsClasses: {
            'situacao': 'col-2 limit-char table-cell-center',
            'categoria': 'col-2 limit-char table-cell-center',
            'valorMovFinan': 'col-2 limit-char table-cell-rigth',
            'valorMovBanc': 'col-2 limit-char table-cell-rigth',
            'diferenca': 'col-2 limit-char table-cell-rigth'
          },
          headings: {
            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),
            categoria: this.$t('planoConciliacao.labels.categoria'),
            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),
            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),
            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')
          },
          templates: {
            situacao: _LoadingPlaceholder2.default,
            categoria: _LoadingPlaceholder2.default,
            valorMovFinan: _LoadingPlaceholder2.default,
            valorMovBanc: _LoadingPlaceholder2.default,
            diferenca: _LoadingPlaceholder2.default
          },
          filterable: [],
          filterByColumn: false,
          sortable: [],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          perPageValues: [],
          perPage: 10,
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados')
          }
        },
        data: []
      },
      situationList: [{
        id: 'A',
        nome: this.$t('statusConciliacao.aberto'),
        color: '#FFD54F',
        prioridade: 1
      }, {
        id: 'C',
        nome: this.$t('statusConciliacao.conciliado'),
        color: '#81C784',
        prioridade: 3
      }, {
        id: 'M',
        nome: this.$t('calendarioConciliacao.detalhe.conciliadoManualmente'),
        color: '#4DB6AC',
        prioridade: 4
      }, {
        id: 'D',
        nome: this.$t('statusConciliacao.divergente'),
        color: '#E57373',
        prioridade: 2
      }, {
        id: 'N',
        nome: this.$t('statusConciliacao.naoAplicavel'),
        color: '#7EC1F7',
        prioridade: 5
      }, {
        id: 'T',
        nome: this.$t('calendarioConciliacao.detalhe.total'),
        color: '#7EC1F7',
        prioridade: 6
      }],
      templatesWhenIsLoaded: {
        conta: function conta(h, row) {
          return row.conta;
        },
        estabelecimento: function estabelecimento(h, row) {
          return row.estabelecimento;
        },
        categoria: function categoria(h, row) {
          return row.categoria;
        },
        situacao: function situacao(h, row) {
          return _this.getConciliationLabel(row.situacao);
        },
        valorMovFinan: function valorMovFinan(h, row) {
          return _this.getVlTotal(row.valorMovFinan);
        },
        valorMovBanc: function valorMovBanc(h, row) {
          return _this.getVlTotal(row.valorMovBanc);
        },
        diferenca: function diferenca(h, row) {
          return _this.getVlTotal(Number(row.valorMovBanc - row.valorMovFinan).toFixed(2));
        }
      },
      isPreparingData: true,
      showSummary: true
    };
  },


  computed: {
    getFormatedCurrentDate: function getFormatedCurrentDate() {
      var label = void 0;
      if (_moment2.default.utc(this.startDate).startOf('day').isSame(_moment2.default.utc(this.endDate).startOf('day'))) {
        label = _moment2.default.utc(this.startDate).format('LL');
      } else {
        label = _moment2.default.utc(this.startDate).format('LL') + ' ' + this.$t('dateRange.labels.ate') + ' ' + _moment2.default.utc(this.endDate).format('LL');
      }
      return label;
    },
    isComponentReady: function isComponentReady() {
      return !this.isPreparingData;
    },
    handleChangeSelection: function handleChangeSelection() {
      this.isPreparingData = true;
      this.generatePeriodSummary();
      this.generateGroupByAccount();
      this.generateGroupByEstablishment();
      this.generateGroupByCategory();
      this.isPreparingData = false;
    }
  },

  methods: {
    generatePeriodSummary: function generatePeriodSummary() {
      var _this2 = this;

      this.conciliationSummary = [];
      var baseData = this.conciliacaoData.filter(function (item) {
        return (_this2.filteredCategory && _this2.filteredCategory.id !== '-1' ? _this2.filteredCategory.nome === item.categoria : true) && _moment2.default.utc(item.dataMin).isBetween(_moment2.default.utc(_this2.startDate).startOf('day'), _moment2.default.utc(_this2.endDate).endOf('day'), undefined, '[]');
      });
      var total = {
        situacao: 'T',
        movFinanAmount: 0,
        movBancAmount: 0,
        percent: 100
      };
      baseData.map(function (item) {
        var summaryIndex = _this2.conciliationSummary.findIndex(function (el) {
          return el.situacao === item.situacao;
        });

        total.movFinanAmount += item.totalMovFinan;
        total.movBancAmount += item.totalExtrato;

        if (summaryIndex >= 0) {
          var summary = _this2.conciliationSummary.at(summaryIndex);
          summary.movFinanAmount += item.totalMovFinan;
          summary.movBancAmount += item.totalExtrato;
          _this2.conciliationSummary.splice(summaryIndex, 1, summary);
        } else {
          var _summary = {
            situacao: item.situacao,
            movFinanAmount: item.totalMovFinan,
            movBancAmount: item.totalExtrato
          };
          _this2.conciliationSummary.push(_summary);
        }
      });
      if (this.conciliationSummary && this.conciliationSummary.length > 0) {
        this.conciliationSummary.map(function (item) {
          item.percent = total.movFinanAmount + total.movBancAmount !== 0 ? 100 * (item.movFinanAmount + item.movBancAmount) / (total.movFinanAmount + total.movBancAmount) : 'N/A';
        });
        this.conciliationSummary.push(total);
        this.conciliationSummary.sort(function (a, b) {
          return _this2.getPrioridadeByStatus(a.situacao) - _this2.getPrioridadeByStatus(b.situacao);
        });
      }
    },
    generateGroupBy: function generateGroupBy(field) {
      var _this3 = this;

      var groupedBy = [];
      var baseData = this.conciliacaoData.filter(function (item) {
        return (_this3.filteredCategory && _this3.filteredCategory.id !== '-1' ? _this3.filteredCategory.nome === item.categoria : true) && _moment2.default.utc(item.dataMin).isBetween(_moment2.default.utc(_this3.startDate).startOf('day'), _moment2.default.utc(_this3.endDate).endOf('day'), undefined, '[]');
      });
      baseData.map(function (item) {
        var summaryIndex = groupedBy.findIndex(function (el) {
          return el.situacao === item.situacao && (field ? el[field] === item[field] : true);
        });
        if (summaryIndex >= 0) {
          var summary = groupedBy.at(summaryIndex);
          summary.valorMovFinan += item.totalMovFinan;
          summary.valorMovBanc += item.totalExtrato;
          groupedBy.splice(summaryIndex, 1, summary);
        } else {
          var _summary2 = {
            situacao: item.situacao,
            conta: item.conta,
            estabelecimento: item.estabelecimento,
            categoria: item.categoria,
            valorMovFinan: item.totalMovFinan,
            valorMovBanc: item.totalExtrato
          };
          groupedBy.push(_summary2);
        }
      });
      return groupedBy;
    },
    generateGroupByAccount: function generateGroupByAccount() {
      this.accountsTable.data = this.generateGroupBy('conta');
      this.accountsTable.options.templates = this.templatesWhenIsLoaded;
    },
    generateGroupByEstablishment: function generateGroupByEstablishment() {
      this.establishmentsTable.data = this.generateGroupBy('estabelecimento');
      this.establishmentsTable.options.templates = this.templatesWhenIsLoaded;
    },
    generateGroupByCategory: function generateGroupByCategory() {
      this.categoriesTable.data = this.generateGroupBy('categoria');
      this.categoriesTable.options.templates = this.templatesWhenIsLoaded;
    },
    getVlTotal: function getVlTotal(value) {
      return 'R$ ' + (0, _numberMasker.maskThousand)(value);
    },
    getConciliationLabel: function getConciliationLabel(status) {
      var label = ' - ';
      this.situationList.map(function (item) {
        if (item.id === status) {
          label = item.nome;
        }
      });
      return label;
    },
    getColorByStatus: function getColorByStatus(status) {
      var label = ' - ';
      this.situationList.map(function (item) {
        if (item.id === status) {
          label = item.color;
        }
      });
      return label;
    },
    getPrioridadeByStatus: function getPrioridadeByStatus(status) {
      var label = -1;
      this.situationList.map(function (item) {
        if (item.id === status) {
          label = item.prioridade;
        }
      });
      return label;
    },
    formatPercent: function formatPercent(value) {
      if (!isNaN(value)) {
        var result = Number(value);
        return (0, _numberMasker.maskThousandNoFixed)(result % 1 !== 0 ? result.toFixed(2) : result) + '%';
      }
      return value;
    },
    handleToogle: function handleToogle(selected) {
      this.showSummary = selected;
    }
  }
};

/***/ }),
/* 862 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/conciliationSummary/CalendarSummary.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(/*! vue */ 31);

var _vue2 = _interopRequireDefault(_vue);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _dayspanVuetify = __webpack_require__(/*! dayspan-vuetify */ 1120);

var _dayspanVuetify2 = _interopRequireDefault(_dayspanVuetify);

var _CalendarDetailBox = __webpack_require__(/*! ./CalendarDetailBox */ 1302);

var _CalendarDetailBox2 = _interopRequireDefault(_CalendarDetailBox);

var _CalendarView = __webpack_require__(/*! ../../calendarView/CalendarView */ 1260);

var _CalendarView2 = _interopRequireDefault(_CalendarView);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _customSorter = __webpack_require__(/*! ../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_dayspanVuetify2.default);

exports.default = {
  name: 'CalendarSummary',

  components: {
    ButtonPrimary: _ButtonPrimary2.default,
    CalendarDetailBox: _CalendarDetailBox2.default,
    Datepicker: _vuejsDatepicker2.default,
    CalendarView: _CalendarView2.default
  },

  props: {},

  computed: {
    monthPickerLanguage: function monthPickerLanguage() {
      return this.language.getDatePickerLanguageObject();
    },
    isLoadingData: function isLoadingData() {
      return this.isLoadingDataConcil || this.isLoadingCategories;
    }
  },

  data: function data() {
    return {
      isLoadingDataConcil: false,
      isLoadingCategories: false,
      language: _index2.default,
      selectedStartDate: new Date(),
      selectedEndDate: new Date(),
      selectedMonth: new Date(),
      conciliacaoData: [],
      categories: [],
      selectedCategory: {
        id: '-1',
        numero: '-1',
        nome: this.$t('inputTag.labels.todas')
      },
      categoryAll: {
        id: '-1',
        numero: '-1',
        nome: this.$t('inputTag.labels.todas')
      }
    };
  },


  methods: {
    validateClick: function validateClick(event) {
      if (event) {
        event.handled = true;
        event.stopPropagation = true;
      }
      return null;
    },
    searchConciliationSummary: function searchConciliationSummary() {
      if (this.selectedMonth) {
        var filter = {
          inicio: _moment2.default.utc(this.selectedMonth).startOf('month').startOf('day').valueOf(),
          fim: _moment2.default.utc(this.selectedMonth).endOf('month').endOf('day').valueOf(),
          idsContas: [],
          considerarContasInativas: false,
          idsEstabelecimentos: [],
          tipoMovimetacao: 'M',
          idsCategorias: [],
          idsPlanosConciliacao: [],
          situacoesConciliacao: ['A', 'C', 'M', 'D', 'N'],
          lang: 'pt'
        };
        this.isLoadingDataConcil = true;
        var self = this;
        return new _promise2.default(function (resolve, reject) {
          self.$store.dispatch('searchConciliationSummary', filter).then(function (response) {
            setTimeout(function () {
              self.handleResult(response.data.Body[0]);
              self.isLoadingDataConcil = false;
            }, 1000);
            resolve();
          }).catch(function (error) {
            self.isLoadingDataConcil = false;
            self.error = true;
            self.msgError = error.body;
            self.$root.$refs.notification.error('GENERAL');
            reject();
          });
        });
      }
    },
    handleResult: function handleResult(result) {
      var _this = this;

      var resumeList = [];
      result.map(function (item) {
        resumeList.push({
          situacao: item.FlagSituacaoConciliacao,
          categoria: item.NomeCategoria,
          estabelecimento: item.Estabelecimento ? item.Estabelecimento : 'N/A',
          conta: item.Banco ? '(' + item.Banco + ') ' + item.Agencia + '/' + item.NrConta : _this.$t('calendarioConciliacao.detalhe.movFinan'),
          totalExtrato: item.ValorExtratoBancario,
          totalMovFinan: item.ValorMovimentoFinanceiro,
          dataMin: _moment2.default.utc(item.DataMinimaLancamento).startOf('day').toDate(),
          dataMax: _moment2.default.utc(item.DataMaximaLancamento).endOf('day').toDate()
        });
      });
      this.conciliacaoData = resumeList;
    },
    handleMonthChange: function handleMonthChange(newDate) {
      this.selectedMonth = newDate;
      this.searchConciliationSummary();
    },
    setStartDate: function setStartDate(newStartDate) {
      this.selectedStartDate = _moment2.default.utc(newStartDate).toDate();
      this.selectedEndDate = _moment2.default.utc(newStartDate).toDate();
    },
    setEndDate: function setEndDate(newEndDate) {
      this.selectedEndDate = _moment2.default.utc(newEndDate).toDate();
    },
    loadCategories: function loadCategories() {
      var _this2 = this;

      this.isLoadingCategories = true;
      this.$store.dispatch('getCategories', {
        url: '/categories/',
        flTipoCategoria: null,
        validarUso: false
      }).then(function (response) {
        var catArray = [];
        response.data.forEach(function (cat) {
          cat.label = cat.numero + ' - ' + cat.nome;
          catArray.push(cat);
        });
        catArray.push(_this2.categoryAll);

        _this2.categories = _customSorter2.default.arrayDottedSorter(catArray, 'numero', 'asc');
        _this2.isLoadingCategories = false;
      }).catch(function (error) {
        _this2.$root.$refs.notification.error(error.data.message);
        _this2.isLoadingCategories = false;
      });
    },
    setCategory: function setCategory(category) {
      this.selectedCategory = category && category.id ? category : this.categoryAll;
    }
  },

  mounted: function mounted() {
    this.loadCategories();
  }
};

/***/ }),
/* 863 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/duplicateMovementsAnalysis/AnnulledMovements.vue ***!
  \************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _MultiSelectModal = __webpack_require__(/*! ../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _DateRange = __webpack_require__(/*! ../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DuplicateMovements',

  components: {
    MultiSelectModal: _MultiSelectModal2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    disableSearchButton: {
      type: Boolean,
      required: true
    }
  },

  data: function data() {
    var _this = this;

    return {
      language: _index2.default,
      dateRange: {},
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: (0, _moment2.default)(new Date()).add(10, 'years').toDate(),
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        }
      },
      shown: {
        bankAccounts: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('analiseDuplicidade.labels.contasBancarias'),
            sub: this.$t('analiseDuplicidade.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              banco: function banco(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1;
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1;
                };
              },
              agencia: function agencia(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia;
                  }
                  return a.numAgencia >= b.numAgencia;
                };
              },
              conta: function conta(asc) {
                return function (a, b) {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1;
                  }
                  return +a.conta <= +b.conta ? 1 : -1;
                };
              }
            },
            templates: {
              nome: function nome(h, row) {
                var txt = row.nome;
                if (!row.ativo) {
                  txt += ' (' + _this.$t('contaBancaria.labels.inativa') + ')';
                }
                return txt;
              },
              banco: function banco(h, row) {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome;
                }
                return '-';
              },
              agencia: function agencia(h, row) {
                var txt = '-';
                if (row.agencia) {
                  txt = row.numAgencia;
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia;
                  }
                }
                return txt;
              },
              conta: function conta(h, row) {
                var txt = row.conta;
                if (row.digConta) {
                  txt += '-' + row.digConta;
                }
                return txt;
              }
            }
          }
        }
      }
    };
  },


  methods: {
    openSelectBankAccountsModal: function openSelectBankAccountsModal() {
      var _this2 = this;

      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true;
        return;
      }
      this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list').then(function (response) {
        _this2.data.bankAccounts.allBankAccounts = response.data.data;
        _this2.data.bankAccounts.showToggleInactiveAccounts = _this2.data.bankAccounts.allBankAccounts.find(function (bankAccount) {
          return !bankAccount.ativo;
        });
        _this2.data.bankAccounts.values = _this2.data.bankAccounts.allBankAccounts.filter(function (bankAccount) {
          return bankAccount.ativo;
        });
        _this2.shown.bankAccounts = true;
      });
    },
    closeModal: function closeModal() {
      this.shown.bankAccounts = false;
    },
    validate: function validate() {
      var _this3 = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result && self.$refs.dateRange.validate()) {
          var searchData = {
            gridId: 'LancamentoAnulado',
            actionName: 'searchAnnulledMovements',
            filter: {
              inicio: self.dateRange.fromDate,
              fim: self.dateRange.toDate,
              idsConta: self.data.bankAccounts.selectedItems.map(function (selected) {
                return selected.id;
              }).filter(function (account) {
                return account !== '-1';
              }),
              lang: _index2.default.getCookieByName('language')
            }
          };

          _this3.$emit('search-movements', searchData);
        }
      });
    }
  }
};

/***/ }),
/* 864 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/duplicateMovementsAnalysis/DuplicateMovements.vue ***!
  \*************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _DateRange = __webpack_require__(/*! ../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DuplicateMovements',

  components: {
    DateRange: _DateRange2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  props: {
    disableSearchButton: {
      type: Boolean,
      required: true
    }
  },

  data: function data() {
    return {
      language: _index2.default,
      dateRange: {},
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: (0, _moment2.default)(new Date()).add(10, 'years').toDate(),
      comparableFieldsList: [{
        id: 'H',
        nome: this.$t('analiseDuplicidade.labels.camposAvaliados.historico'),
        checked: true
      }, {
        id: 'C',
        nome: this.$t('analiseDuplicidade.labels.camposAvaliados.complemento'),
        checked: true
      }, {
        id: 'T',
        nome: this.$t('analiseDuplicidade.labels.camposAvaliados.fitid'),
        checked: true
      }, {
        id: 'D',
        nome: this.$t('analiseDuplicidade.labels.camposAvaliados.documento'),
        checked: true
      }],
      selectedFields: ['H', 'C', 'T', 'D']
    };
  },


  watch: {
    comparableFieldsList: {
      handler: function handler(val) {
        var _this = this;

        this.selectedFields = [];
        val.forEach(function (st) {
          if (st.checked) {
            _this.selectedFields.push(st.id);
          }
        });
      },

      deep: true
    }
  },

  methods: {
    validate: function validate() {
      var _this2 = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result && self.$refs.dateRange.validate()) {
          var searchData = {
            gridId: 'LancamentoDuplicado',
            actionName: 'searchDuplicateMovements',
            filter: {
              inicio: self.dateRange.fromDate,
              fim: self.dateRange.toDate,
              avaliarHistorico: self.selectedFields.includes('H'),
              avaliarDsComplemento: self.selectedFields.includes('C'),
              avaliarNRFITID: self.selectedFields.includes('T'),
              avaliarNrDocumento: self.selectedFields.includes('D'),
              lang: _index2.default.getCookieByName('language')
            }
          };

          _this2.$emit('search-movements', searchData);
        }
      });
    }
  }
};

/***/ }),
/* 865 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/Allotment.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TreeGrid = __webpack_require__(/*! ../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Allotment',

  components: {
    TreeGrid: _TreeGrid2.default
  },

  props: {
    showTreegridLot: {
      type: Boolean,
      required: false
    },
    resultLot: {
      type: Object,
      required: true
    },
    treeGridCfgLot: {
      type: Object,
      required: false
    }
  },

  data: function data() {
    return {
      exportUrl: _exportRoutes.EXPORT_TREEGRID
    };
  },
  beforeUpdate: function beforeUpdate() {
    var _this = this;

    if (document.querySelector("[aria-controls='#tab-lotes']")) {
      document.querySelector("[aria-controls='#tab-lotes']").addEventListener('click', function () {
        (0, _analytics.trackAnalyticsEvent)(_this, 'conciliacao-manual', 'click-mudar-de-aba', 'tab-lotes');
      });
    }
  }
};

/***/ }),
/* 866 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/EntryManager.vue ***!
  \***********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _customSorter = __webpack_require__(/*! ../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _numberMasker = __webpack_require__(/*! ../../../utils/numberMasker.js */ 71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

exports.default = {
  name: 'EntryManager',

  props: {
    entriesList: {
      type: Array,
      required: true
    },
    isInternal: { type: Boolean,
      required: true
    }
  },

  data: function data() {
    var _this = this;

    return {
      sumAmount: 0.00,
      columns: ['dtLanc', 'valor', 'situacao', 'acoes'],
      options: {
        columnsClasses: { 'acoes': 'col-md-1', 'dtLanc': 'col-md-2', 'valor': 'col-md-2 align-right', 'situacao': 'col-md-2' },
        headings: {
          dtLanc: this.$t('conciliacaoManual.labels.data'),
          valor: this.$t('conciliacaoManual.labels.valor'),
          situacao: this.$t('conciliacaoManual.labels.situacao'),
          acoes: ''
        },
        sortIcon: {
          is: ''
        },
        templates: {
          dtLanc: function dtLanc(h, row) {
            var date = row.dtLanc ? row.dtLanc : row.data;
            return (0, _moment2.default)(date).format('DD/MM/YYYY');
          },

          valor: function valor(h, row) {
            return (0, _numberMasker.maskThousand)(row.valor);
          },

          situacao: function situacao(h, row) {
            return row.situacao === 'A' ? _this.$t('statusConciliacao.aberto') : row.situacao === 'C' ? _this.$t('statusConciliacao.conciliado') : row.situacao === 'M' ? _this.$t('statusConciliacao.conciliadoManualmente') : row.situacao === 'D' ? _this.$t('statusConciliacao.divergente') : row.situacao === 'N' ? _this.$t('statusConciliacao.naoAplicavel') : ' - ';
          }
        },
        filterable: false,
        perPage: 9999,
        perPageValues: [],
        texts: {
          count: '',
          noResults: this.isInternal ? this.$t('conciliacaoManual.erro.nenhumLancamentoInterno') : this.$t('conciliacaoManual.erro.nenhumLancamentoBancario')
        },
        sortable: ['dtLanc', 'valor', 'situacao'],
        pagination: {},
        customSorting: {
          dtLanc: function dtLanc(ascending) {
            return function (a, b) {
              a.nDate = a.dtLanc ? a.dtLanc : a.data;
              b.nDate = b.dtLanc ? b.dtLanc : b.data;
              return _customSorter2.default.dateSorter(ascending, a, b, 'nDate');
            };
          }
        }
      }
    };
  },


  computed: {
    totalAmountOfEntries: function totalAmountOfEntries() {
      return this.entriesList.length;
    },
    sum: function sum() {
      var valueF = 0.00;
      this.entriesList.forEach(function (entry) {
        valueF += entry.valor;
      });
      this.sumAmount = valueF;

      return (0, _numberMasker.maskThousand)(valueF);
    },
    rangeDate: function rangeDate() {
      var startDate = new Date('01/01/9999');
      var endDate = new Date('01/01/1900');
      this.entriesList.forEach(function (entry) {
        var date = entry.dtLanc ? entry.dtLanc : entry.data;
        if ((0, _moment2.default)(date).isBefore(startDate)) {
          startDate = date;
        }

        if ((0, _moment2.default)(date).isAfter(endDate)) {
          endDate = date;
        }
      });

      return this.totalAmountOfEntries > 0 ? startDate === endDate ? (0, _moment2.default)(startDate).format('DD/MM/YYYY') : (0, _moment2.default)(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + (0, _moment2.default)(endDate).format('DD/MM/YYYY') : ' - ';
    }
  },

  watch: {
    sum: function sum() {
      var _this2 = this;

      var action = this.isInternal ? 'updateTotalAmountForInternalEntries' : 'updateTotalAmountForBankEntries';
      this.$store.dispatch(action, this.sumAmount).then(function () {}).catch(function (error) {
        _this2.$root.$refs.notification.error(error);
      });
    }
  },

  methods: {
    removeEntry: function removeEntry(entry) {
      var _this3 = this;

      var action = this.isInternal ? 'removeFinMov' : 'removeBankStat';
      var flag = this.isInternal ? 'hasPendingFinMov' : 'hasPendingBankStat';

      this.$store.dispatch(action, entry).then(function () {
        action === 'removeFinMov' ? window.Grids[0].Reload() : window.Grids[1].Reload();

        _this3.$store.dispatch(flag, true);
      }).catch(function (error) {
        _this3.$root.$refs.notification.error(error);
      });
    }
  }
};

/***/ }),
/* 867 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/Justifications.vue ***!
  \*************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _numberMasker = __webpack_require__(/*! ../../../utils/numberMasker.js */ 71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale(_index2.default.getDatePickerLanguage());

exports.default = {
  name: 'Justifications',

  data: function data() {
    return {
      sumAmount: 0.00,
      columns: ['motivoOcorrencia', 'comentario', 'valor', 'acoes'],
      options: {
        columnsClasses: { 'motivoOcorrencia': 'col-md-4', 'comentario': 'col-md-5', 'valor': 'col-md-2 align-right', 'acoes': 'col-md-1' },
        headings: {
          motivoOcorrencia: this.$t('conciliacaoManual.labels.motivoOcorrencia'),
          comentario: this.$t('conciliacaoManual.labels.comentario'),
          valor: this.$t('conciliacaoManual.labels.valor'),
          acoes: ''
        },
        sortIcon: {
          is: ''
        },
        templates: {
          motivoOcorrencia: function motivoOcorrencia(h, row) {
            return row && row.motivoOcorrencia ? row.motivoOcorrencia : '-';
          },
          comentario: function comentario(h, row) {
            return row && row.comentario ? row.comentario : '-';
          },
          valor: function valor(h, row) {
            return (0, _numberMasker.maskThousand)(row.valor);
          }
        },
        filterable: false,
        perPage: 9999,
        perPageValues: [],
        texts: {
          count: '',
          noResults: this.$t('conciliacaoManual.erro.nenhumLancamentoInterno')
        },
        sortable: ['motivoOcorrencia', 'comentario', 'valor'],
        pagination: {},
        customSorting: {}
      },
      justifications: []
    };
  },


  computed: {
    arrayJustify: function arrayJustify() {
      return this.$store.getters.arrayJustify;
    }
  },

  watch: {
    arrayJustify: function arrayJustify() {
      this.justifications = this.$store.getters.arrayJustify;
    }
  },

  methods: {
    removeJustify: function removeJustify(justify) {
      var _this = this;

      this.$store.dispatch('removeJustify', justify).then(function () {}).catch(function (error) {
        _this.$root.$refs.notification.error(error);
      });
    }
  }
};

/***/ }),
/* 868 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/PendingConciliations.vue ***!
  \*******************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TreeGrid = __webpack_require__(/*! ../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _gridLoadTransition = __webpack_require__(/*! ../../../utils/grid-load-transition.js */ 34);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PendingConciliations',

  components: {
    TreeGrid: _TreeGrid2.default
  },

  props: {
    resultMov: {
      type: Object,
      required: true
    },
    resultExt: {
      type: Object,
      required: true
    },
    treeGridCfgMov: {
      type: Object,
      required: false
    },
    treeGridCfgExt: {
      type: Object,
      required: false
    },
    showTreegridMov: {
      type: Boolean,
      required: false
    },
    showTreegridExt: {
      type: Boolean,
      required: false
    }
  },

  data: function data() {
    return {
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      showHideButtonAddAllMovFin: false,
      showHideButtonAddAllBankStat: false
    };
  },


  methods: {
    startTreeGridLoading: function startTreeGridLoading(idGrid, messages) {
      (0, _gridLoadTransition.startTreeGridLoading)(idGrid, messages);
    },
    stopTreeGridLoading: function stopTreeGridLoading(idGrid) {
      (0, _gridLoadTransition.stopTreeGridLoading)(idGrid);
    },
    addAllRowsFinMov: function addAllRowsFinMov() {
      var _this = this;

      setTimeout(function () {
        if (window.Grids.ConcManualMovFin && window.Grids.ConcManualMovFin.GetSelRows().length > 0) {
          window.Grids.ConcManualMovFin.GetSelRows().forEach(function (row) {
            if (row.Visible) {
              row.isTreeGrid = true;
              _this.$store.dispatch('setFinMov', row).then(function () {
                window.Grids.ConcManualMovFin.HideRow(row);
                _this.showHideButtonAddAllMovFin = false;
              }).catch(function (error) {
                _this.$root.$refs.notification.error(_this.$t(error.message));
              });
            } else {
              window.Grids.ConcManualMovFin.SelectRow(row);
            }
          });
        } else {
          _this.$root.$refs.notification.warning(_this.$t('conciliacaoManual.validacao.selecionarItensMovFin'));
        }
        _this.$store.dispatch('dataLoaded');
      }, 100);
      setTimeout(function () {
        window.Grids.ConcManualMovFin.RenderBody();
      }, 150);
    },
    addAllRowsBankStat: function addAllRowsBankStat() {
      var _this2 = this;

      setTimeout(function () {
        if (window.Grids.ConcManualExtBan && window.Grids.ConcManualExtBan.GetSelRows().length > 0) {
          window.Grids.ConcManualExtBan.GetSelRows().forEach(function (row) {
            if (row.Visible) {
              row.isTreeGrid = true;
              _this2.$store.dispatch('setBankStat', row).then(function () {
                window.Grids.ConcManualExtBan.HideRow(row);
                _this2.showHideButtonAddAllBankStat = false;
              }).catch(function (error) {
                _this2.$root.$refs.notification.error(_this2.$t(error.message));
              });
            } else {
              window.Grids.ConcManualMovFin.SelectRow(row);
            }
          });
        } else {
          _this2.$root.$refs.notification.warning(_this2.$t('conciliacaoManual.validacao.selecionarItensBankStat'));
        }
        _this2.$store.dispatch('dataLoaded');
      }, 100);
      setTimeout(function () {
        window.Grids.ConcManualExtBan.RenderBody();
      }, 150);
    },
    startLoading: function startLoading() {
      this.$store.dispatch('loadingDataStatic');
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    $(document).on('showHideButtonAddAllMovFin', function (data, flag) {
      _this3.showHideButtonAddAllMovFin = flag;
    });

    $(document).on('showHideButtonAddAllBankStat', function (data, flag) {
      _this3.showHideButtonAddAllBankStat = flag;
    });
  },
  beforeUpdate: function beforeUpdate() {
    var _this4 = this;

    if (document.querySelector("[aria-controls='#tab-conciliacoes-pendentes']")) {
      document.querySelector("[aria-controls='#tab-conciliacoes-pendentes']").addEventListener('click', function () {
        (0, _analytics.trackAnalyticsEvent)(_this4, 'conciliacao-manual', 'click-mudar-de-aba', 'tab-conciliacoes-pendentes');
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 869 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/SelectedEntries.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _ReopenAllotmentModal = __webpack_require__(/*! ./modals/ReopenAllotmentModal */ 1313);

var _ReopenAllotmentModal2 = _interopRequireDefault(_ReopenAllotmentModal);

var _ApplyModal = __webpack_require__(/*! ./modals/ApplyModal */ 1311);

var _ApplyModal2 = _interopRequireDefault(_ApplyModal);

var _JustifyModal = __webpack_require__(/*! ./modals/JustifyModal */ 1312);

var _JustifyModal2 = _interopRequireDefault(_JustifyModal);

var _EntryManager = __webpack_require__(/*! ./EntryManager */ 1307);

var _EntryManager2 = _interopRequireDefault(_EntryManager);

var _Justifications = __webpack_require__(/*! ./Justifications */ 1308);

var _Justifications2 = _interopRequireDefault(_Justifications);

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _numberMasker = __webpack_require__(/*! ../../../utils/numberMasker.js */ 71);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _funcionalidadeId = __webpack_require__(/*! ../../../enum/funcionalidadeId.js */ 134);

var _funcionalidadeId2 = _interopRequireDefault(_funcionalidadeId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SelectedEntries',

  components: {
    ReopenAllotmentModal: _ReopenAllotmentModal2.default,
    ApplyModal: _ApplyModal2.default,
    JustifyModal: _JustifyModal2.default,
    EntryManager: _EntryManager2.default,
    Justifications: _Justifications2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      internalEntries: [],
      bankEntries: [],
      justifications: []
    };
  },


  computed: {
    allotmentMovementRemoved: function allotmentMovementRemoved() {
      return this.$store.getters.allotmentMovementRemoved;
    },
    allotmentId: function allotmentId() {
      return this.$store.getters.idAllotment;
    },
    hasPendingFinMov: function hasPendingFinMov() {
      return this.$store.getters.hasPendingFinMov;
    },
    hasPendingBankStat: function hasPendingBankStat() {
      return this.$store.getters.hasPendingBankStat;
    },
    totalAmountForInternalEntries: function totalAmountForInternalEntries() {
      return this.$store.getters.totalAmountForInternalEntries;
    },
    totalAmountForBankEntries: function totalAmountForBankEntries() {
      return this.$store.getters.totalAmountForBankEntries;
    },
    totalAmountToJustify: function totalAmountToJustify() {
      return this.calculateTotalToJustify();
    },
    totalDivergence: function totalDivergence() {
      var value = Number(Number(this.totalAmountForBankEntries) - Number(this.totalAmountForInternalEntries) - Number(this.totalAmountToJustify)).toFixed(2);
      return Number(value).toFixed(2);
    },
    totalTransformed: function totalTransformed() {
      return (0, _numberMasker.maskThousand)(this.totalDivergence);
    },
    divergentInstance: function divergentInstance() {
      return Number(this.totalDivergence).toFixed(2) !== '0.00' || this.totalAmoutOfEntriesMov > 0 || this.totalAmountOfEntriesBank > 0;
    },
    canReopen: function canReopen() {
      return this.allotmentId && !this.hasPendingBankStat && !this.hasPendingFinMov;
    },
    canConciliate: function canConciliate() {
      return this.internalEntries.length > 0 && this.bankEntries.length > 0 && (this.hasPendingBankStat || this.hasPendingFinMov) || this.arrayJustify.length > 0;
    },
    canResumeConciliation: function canResumeConciliation() {
      return this.canConciliate;
    },
    finMovAdded: function finMovAdded() {
      return this.$store.getters.finMovAdded;
    },
    bankStatAdded: function bankStatAdded() {
      return this.$store.getters.bankStatAdded;
    },
    totalAmountOfEntriesBank: function totalAmountOfEntriesBank() {
      return this.bankEntries.length;
    },
    totalAmoutOfEntriesMov: function totalAmoutOfEntriesMov() {
      return this.internalEntries.length;
    },
    sumMov: function sumMov() {
      var _this = this;

      var value = 0.00;
      this.internalEntries.forEach(function (entry) {
        value = _this.round(value, 2) + _this.round(entry.valor, 2);
      });
      this.sumAmount = value;
      return (0, _numberMasker.maskThousand)(value);
    },
    rangeDateMov: function rangeDateMov() {
      var startDate = new Date('01/01/9999');
      var endDate = new Date('01/01/1900');
      this.internalEntries.forEach(function (entry) {
        var date = entry.dtLanc ? entry.dtLanc : entry.data;
        if ((0, _moment2.default)(date).isBefore(startDate)) {
          startDate = date;
        }

        if ((0, _moment2.default)(date).isAfter(endDate)) {
          endDate = date;
        }
      });

      return this.totalAmoutOfEntriesMov > 0 ? startDate === endDate ? (0, _moment2.default)(startDate).format('DD/MM/YYYY') : (0, _moment2.default)(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + (0, _moment2.default)(endDate).format('DD/MM/YYYY') : ' - ';
    },
    sumBank: function sumBank() {
      var _this2 = this;

      var value = 0.00;
      this.bankEntries.forEach(function (entry) {
        value = _this2.round(value, 2) + _this2.round(entry.valor, 2);
      });
      this.sumAmount = value;
      return (0, _numberMasker.maskThousand)(value);
    },
    rangeDateBank: function rangeDateBank() {
      var startDate = new Date('01/01/9999');
      var endDate = new Date('01/01/1900');
      this.bankEntries.forEach(function (entry) {
        var date = entry.dtLanc ? entry.dtLanc : entry.data;
        if ((0, _moment2.default)(date).isBefore(startDate)) {
          startDate = date;
        }

        if ((0, _moment2.default)(date).isAfter(endDate)) {
          endDate = date;
        }
      });

      return this.totalAmountOfEntriesBank > 0 ? startDate === endDate ? (0, _moment2.default)(startDate).format('DD/MM/YYYY') : (0, _moment2.default)(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + (0, _moment2.default)(endDate).format('DD/MM/YYYY') : ' - ';
    },
    arrayJustify: function arrayJustify() {
      return this.$store.getters.arrayJustify;
    },
    resumeAutomaticProcessing: function resumeAutomaticProcessing() {
      return this.$store.getters.isConciliationResumed;
    },
    verifyAuthorizationResumeProcess: function verifyAuthorizationResumeProcess() {
      if (this.$store.getters.allowedFuncionalities) {
        return !!this.$store.getters.allowedFuncionalities.find(function (element) {
          return element === _funcionalidadeId2.default.RETOMAR_CONCILIACAO;
        });
      }
      return false;
    }
  },

  watch: {
    finMovAdded: function finMovAdded() {
      this.internalEntries = this.$store.getters.finMovAdded;
      this.verifyAndCleanJustify();
    },
    bankStatAdded: function bankStatAdded() {
      this.bankEntries = this.$store.getters.bankStatAdded;
      this.verifyAndCleanJustify();
    },
    arrayJustify: function arrayJustify() {
      this.justifications = this.$store.getters.arrayJustify;
    }
  },

  methods: {
    verifyAndCleanJustify: function verifyAndCleanJustify() {
      if (this.internalEntries.length === 0 || this.bankEntries.length === 0) {
        this.cleanJustify();
      }
    },
    cleanJustify: function cleanJustify() {
      var _this3 = this;

      this.$store.dispatch('cleanArrayJustify').then(function () {}).catch(function (error) {
        _this3.$root.$refs.notification.error(error);
      });
    },
    reaopenAllotment: function reaopenAllotment() {
      $('#reopenAllotmentModal').modal({ backdrop: 'static', keyboard: false });
    },
    applyConciliation: function applyConciliation() {
      $('#applyModal').modal({ backdrop: 'static', keyboard: false });
    },
    justifyAllotment: function justifyAllotment() {
      $('#justifyModal').modal({ backdrop: 'static', keyboard: false });
    },
    calculateTotalToJustify: function calculateTotalToJustify() {
      var value = 0.00;
      this.arrayJustify.forEach(function (justify) {
        value += justify.valor;
      });
      return value;
    },
    getDivergenceAmoutClass: function getDivergenceAmoutClass() {
      return this.divergentInstance ? 'divergence-value' : 'conciliated-value';
    },
    clearMovTable: function clearMovTable() {
      var _this4 = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'conciliacao-manual', 'click-limpar-movimentacoes');

      var movList = this.internalEntries.slice();
      this.$store.dispatch('removeAllMovFin', movList).then(function () {}).catch(function (error) {
        _this4.$root.$refs.notification.error(error);
      });
    },
    clearBankTable: function clearBankTable() {
      var _this5 = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'conciliacao-manual', 'click-limpar-extratos');

      var bankList = this.bankEntries.slice();
      this.$store.dispatch('removeAllBankStat', bankList).then(function () {}).catch(function (error) {
        _this5.$root.$refs.notification.error(error);
      });
    },
    removeAllotment: function removeAllotment() {
      var data = {
        idAllotmentRemoved: this.$store.getters.idRowAllotmentMovementAdded,
        idAllotmentToRemove: this.$store.getters.idRowAllotmentMovementAdded
      };
      this.$store.dispatch('removeAllotment', data);
    },
    round: function round(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    },
    changeReaplyConciliation: function changeReaplyConciliation(event) {
      this.$store.dispatch('setReaplyConciliation', event.target.checked);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 870 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/modals/ApplyModal.vue ***!
  \****************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _verifyReaplyConcByTimeAsync = __webpack_require__(/*! ../../../../utils/verifyReaplyConcByTimeAsync */ 794);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ApplyModal',

  components: {
    ConfirmModal: _ConfirmModal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      disableButton: false,
      isJustification: false
    };
  },


  computed: {
    allotmentId: function allotmentId() {
      return this.$store.getters.idAllotment;
    },
    totalAmountForInternalEntries: function totalAmountForInternalEntries() {
      return this.$store.getters.totalAmountForInternalEntries;
    },
    totalAmountForBankEntries: function totalAmountForBankEntries() {
      return this.$store.getters.totalAmountForBankEntries;
    },
    totalAmountToJustify: function totalAmountToJustify() {
      return this.calculateTotalToJustify();
    },
    totalDivergence: function totalDivergence() {
      var value = Number(Number(this.totalAmountForBankEntries) - Number(this.totalAmountForInternalEntries) - Number(this.totalAmountToJustify)).toFixed(2);
      return Number(value).toFixed(2);
    },
    finMovAdded: function finMovAdded() {
      return this.$store.getters.finMovAdded;
    },
    bankStatAdded: function bankStatAdded() {
      return this.$store.getters.bankStatAdded;
    },
    arrayJustify: function arrayJustify() {
      return this.$store.getters.arrayJustify;
    }
  },

  watch: {
    arrayJustify: function arrayJustify() {
      this.isJustification = this.$store.getters.arrayJustify.length > 0;
    }
  },

  methods: {
    confirmApplyAllotment: function confirmApplyAllotment() {
      var _this = this;

      this.$store.dispatch('loadingData').then(function () {
        _this.disableButton = true;
        var reaplicarConciliacao = _this.$store.getters.isReaplyConciliation;
        var data = {
          idLote: _this.allotmentId,
          idsMovFinanceira: _this.generateArrayWithIds(_this.finMovAdded),
          idsMovBancaria: _this.generateArrayWithIds(_this.bankStatAdded),
          valorDivergencia: _this.totalDivergence,
          dataBase: new Date(),
          reaplicarConciliacao: reaplicarConciliacao
        };
        _this.$store.dispatch('applyConciliation', data).then(function (response) {
          if (reaplicarConciliacao) {
            _this.$store.dispatch('setLoadingMessage', 'conciliacaoManual.labels.conciliacaoAutomatica');
            _this.$store.dispatch('reaplyConciliation', data).catch(function (error) {
              _this.confirmApplyAllotmentError(error);
            });

            (0, _verifyReaplyConcByTimeAsync.verifyReaplyConcByTimeAsync)(function () {
              return _this.$store.dispatch('verifyReaplyConciliation', data);
            }, _this.confirmApplyAllotmentSuccess, _this.confirmApplyAllotmentError, _verifyReaplyConcByTimeAsync.verifyReaplyConcTimeout);
          } else {
            _this.confirmApplyAllotmentSuccess(response);
          }
        }).catch(function (error) {
          _this.confirmApplyAllotmentError(error);
        });
      });
    },
    confirmApplyAllotmentSuccess: function confirmApplyAllotmentSuccess(response) {
      this.disableButton = false;

      if (response.data.data === true) {
        this.$root.$refs.notification.global('S', this.$t(response.data.message));
      } else {
        this.$root.$refs.notification.global('S', response.data.data ? this.totalDivergence === 0.00 || this.totalDivergence === '0.00' ? this.$t('conciliacaoManual.sucesso.loteConciliadoOk', { id: response.data.data }) : this.$t('conciliacaoManual.sucesso.loteDivergenteOk', { id: response.data.data }) : this.$t(response.data.message));
      }
      this.$store.dispatch('cleanEditState');
      this.closeModal();
      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true);
      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true);
      this.$store.dispatch('dataLoaded');
    },
    confirmApplyAllotmentError: function confirmApplyAllotmentError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.disableButton = false;
      this.closeModal();
      this.$store.dispatch('dataLoaded');
      this.$root.$refs.notification.global('E', error && error.data && error.data.message ? this.$t(error.data.message) : error && error.message ? this.$t(error.message) : this.$t('GENERAL'));
    },
    confirmJustify: function confirmJustify() {
      var _this2 = this;

      var reaplicarConciliacao = this.$store.getters.isReaplyConciliation;
      var data = {
        idsMovFinanceira: this.generateArrayWithIds(this.finMovAdded),
        idsMovBancaria: this.generateArrayWithIds(this.bankStatAdded),
        idsPlanosConciliacao: this.$store.getters.arrayConciliationPlan,
        valorDivergencia: this.totalDivergence,
        idsMotivosOcorrencia: this.generateArrayIdsOcurrence(this.arrayJustify),
        justificativas: this.arrayJustify,
        dataBase: new Date(),
        reaplicarConciliacao: reaplicarConciliacao
      };
      this.$store.dispatch('loadingData').then(function () {
        _this2.disableButton = true;
        _this2.$store.dispatch('justifyConciliation', data).then(function (response) {
          if (reaplicarConciliacao) {
            _this2.$store.dispatch('setLoadingMessage', 'conciliacaoManual.labels.conciliacaoAutomatica');
            _this2.$store.dispatch('reaplyConciliation', data).catch(function (error) {
              _this2.confirmJustifyError(error);
            });

            (0, _verifyReaplyConcByTimeAsync.verifyReaplyConcByTimeAsync)(function () {
              return _this2.$store.dispatch('verifyReaplyConciliation', data);
            }, _this2.confirmJustifySuccess, _this2.confirmJustifyError, _verifyReaplyConcByTimeAsync.verifyReaplyConcTimeout);
          } else {
            _this2.confirmJustifySuccess(response);
          }
        }).catch(function (error) {
          _this2.confirmJustifyError(error);
        });
      });
    },
    confirmJustifySuccess: function confirmJustifySuccess(response) {
      this.disableButton = false;
      this.$store.dispatch('cleanEditState');
      this.closeModal();

      this.$root.$refs.notification.global('S', response.data.data ? this.$t(response.data.message, { id: response.data.data }) : this.$t(response.data.message));
      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true);
      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true);
      this.$store.dispatch('', false);
      this.$store.dispatch('dataLoaded');
    },
    confirmJustifyError: function confirmJustifyError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.disableButton = false;
      this.closeModal();
      this.$root.$refs.notification.global('E', error && error.data && error.data.message ? this.$t(error.data.message) : error && error.message ? this.$t(error.message) : this.$t('GENERAL'));
      this.$store.dispatch('dataLoaded');
    },
    generateArrayIdsOcurrence: function generateArrayIdsOcurrence(list) {
      var result = [];
      list.forEach(function (item) {
        result.push(item.idMotivoOcorrencia);
      });
      return result;
    },
    closeModal: function closeModal() {
      $('#applyModal').modal('hide');
    },
    calculateTotalToJustify: function calculateTotalToJustify() {
      var value = 0.00;
      this.arrayJustify.forEach(function (justify) {
        value += justify.valor;
      });
      return value;
    },
    generateArrayWithIds: function generateArrayWithIds(list) {
      var result = [];
      list.forEach(function (item) {
        result.push(item.idMovimentacao ? item.idMovimentacao : item.idMovBank ? item.idMovBank : item.id);
      });
      return result;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 871 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/modals/JustifyModal.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vMoney = __webpack_require__(/*! v-money */ 195);

var _Modal = __webpack_require__(/*! ../../../modals/modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _numberMasker = __webpack_require__(/*! ../../../../utils/numberMasker.js */ 71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'JustifyModal',

  components: {
    vSelect: _vueSelect2.default,
    Money: _vMoney.Money,
    Modal: _Modal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      disableButton: false,
      isLoadingData: true,
      selectedOccurrenceReason: false,
      occurrenceReasons: [],
      commentary: null,
      valueJustify: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      divergenceValue: '',
      notJustifiedValue: '',
      isTotal: false
    };
  },


  computed: {
    arrayJustify: function arrayJustify() {
      return this.$store.getters.arrayJustify;
    },
    itsAbleToJustify: function itsAbleToJustify() {
      return this.selectedOccurrenceReason && !this.disableButton;
    },
    allotmentId: function allotmentId() {
      return this.$store.getters.idAllotment;
    },
    totalAmountForInternalEntries: function totalAmountForInternalEntries() {
      return this.$store.getters.totalAmountForInternalEntries;
    },
    totalAmountForBankEntries: function totalAmountForBankEntries() {
      return this.$store.getters.totalAmountForBankEntries;
    },
    totalDivergence: function totalDivergence() {
      return this.totalAmountForBankEntries - this.totalAmountForInternalEntries - this.totalAmountToJustify;
    },
    totalAmountToJustify: function totalAmountToJustify() {
      return this.calculateTotalToJustify();
    },
    finMovAdded: function finMovAdded() {
      return this.$store.getters.finMovAdded;
    },
    bankStatAdded: function bankStatAdded() {
      return this.$store.getters.bankStatAdded;
    },
    arrayConciliationPlan: function arrayConciliationPlan() {
      return this.$store.getters.arrayConciliationPlan;
    },
    totalDivergenceTransformed: function totalDivergenceTransformed() {
      return (0, _numberMasker.maskThousand)(Number(this.totalDivergence).toFixed(2));
    },
    totalNotJustified: function totalNotJustified() {
      var value = this.valueJustify - this.totalDivergence;
      return (0, _numberMasker.maskThousand)(value);
    },
    divergentInstance: function divergentInstance() {
      return Number(this.totalDivergence).toFixed(2) !== '0.00';
    },
    hasPendingFinMov: function hasPendingFinMov() {
      return this.$store.getters.hasPendingFinMov;
    },
    hasPendingBankStat: function hasPendingBankStat() {
      return this.$store.getters.hasPendingBankStat;
    }
  },

  watch: {
    totalNotJustified: function totalNotJustified() {
      this.setStyleValue();
    },
    isTotal: function isTotal() {
      if (this.isTotal) {
        this.valueJustify = this.totalDivergence;
      }
    },
    arrayJustify: function arrayJustify() {
      this.valueJustify = 0.00;
    },
    totalDivergence: function totalDivergence() {
      if (this.finMovAdded.length === 0 || this.bankStatAdded.length === 0) {
        this.valueJustify = this.totalDivergence;
      } else {
        this.isTotal = false;
        this.valueJustify = 0.00;
      }
    }
  },

  methods: {
    calculateTotalToJustify: function calculateTotalToJustify() {
      var value = 0.00;
      this.arrayJustify.forEach(function (justify) {
        value += justify.valor;
      });
      return value;
    },
    setStyleValue: function setStyleValue() {
      if (this.totalNotJustified === '0,00' || this.totalNotJustified === 0.00) {
        document.getElementById('labelTotalNotJustified').style.color = 'green';
      } else {
        document.getElementById('labelTotalNotJustified').style.color = 'red';
      }
    },
    getValueClass: function getValueClass(value) {
      return value !== 0 ? 'divergence-value-modal' : 'conciliated-value-modal';
    },
    confirmJustifyAllotment: function confirmJustifyAllotment() {
      var _this = this;

      var data = {
        id: this.arrayJustify.length + 1,
        valor: this.valueJustify,
        idMotivoOcorrencia: this.selectedOccurrenceReason ? this.selectedOccurrenceReason.id : null,
        motivoOcorrencia: this.selectedOccurrenceReason && this.selectedOccurrenceReason.label ? this.selectedOccurrenceReason.label : null,
        comentario: this.commentary
      };
      this.$store.dispatch('setJustify', data).then(function () {
        _this.closeModal();
      }).catch(function () {
        _this.closeModal();
        _this.$root.$refs.notification.global('E', 'ERRO');
      });
    },
    closeModal: function closeModal() {
      var _this2 = this;

      $('#justifyModal').modal('hide');
      this.selectedOccurrenceReason = null;
      this.commentary = null;
      this.$nextTick(function () {
        _this2.$validator.reset();
      });
    },
    loadOccurrenceReasons: function loadOccurrenceReasons() {
      var _this3 = this;

      var url = '/manualConciliation/occurrenceReasons/list';
      this.$store.dispatch('getOccurrenceReasons', url).then(function (response) {
        _this3.occurrenceReasons = response.data.data;
        _this3.isLoadingData = false;
        _this3.occurrenceReasons.forEach(function (occurrenceReason) {
          occurrenceReason.label = occurrenceReason.codigo + ' - ' + occurrenceReason.descricao;
        });
        _this3.occurrenceReasons.sort(function (a, b) {
          return a.codigo - b.codigo;
        });
      });
    },
    generateArrayWithIds: function generateArrayWithIds(list) {
      var result = [];
      list.forEach(function (item) {
        result.push(item.idMovimentacao ? item.idMovimentacao : item.idMovBank ? item.idMovBank : item.id);
      });
      return result;
    }
  },

  created: function created() {
    this.loadOccurrenceReasons();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 872 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/reports/manualConciliation/modals/ReopenAllotmentModal.vue ***!
  \**************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ReopenAllotmentModal',

  components: {
    ConfirmModal: _ConfirmModal2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      disableButton: false
    };
  },


  computed: {
    allotmentId: function allotmentId() {
      return this.$store.getters.idAllotment;
    }
  },

  methods: {
    confirmReopenAllotment: function confirmReopenAllotment() {
      var _this = this;

      var data = {
        idLote: this.allotmentId
      };
      this.$store.dispatch('loadingData').then(function () {
        _this.disableButton = true;
        _this.$store.dispatch('reopenConciliation', data).then(function (response) {
          _this.confirmReopenSuccess(response);
        }).catch(function (error) {
          _this.confirmReopenError(error);
        });
      });
    },
    confirmReopenSuccess: function confirmReopenSuccess(response) {
      this.disableButton = false;
      this.$store.dispatch('cleanEditState');
      this.closeModal();
      this.$root.$refs.notification.global('S', this.$t(response.data.message));
      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true);
      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true);
      this.$store.dispatch('dataLoaded');
    },
    confirmReopenError: function confirmReopenError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.disableButton = false;
      this.closeModal();
      this.$root.$refs.notification.global('E', error && error.data && error.data.message ? this.$t(error.data.message) : error && error.message ? this.$t(error.message) : this.$t('GENERAL'));
      this.$store.dispatch('dataLoaded');
    },
    closeModal: function closeModal() {
      $('#reopenAllotmentModal').modal('hide');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 873 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/step/StepProgress.vue ***!
  \*************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'StepProgress',

  props: {
    steps: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(val) {
        return val && val.length > 0;
      }
    },
    currentStep: {
      type: Number,
      default: 0
    },
    iconClass: {
      type: String,
      default: 'fa fa-check'
    },
    activeColor: {
      type: String,
      default: '#40b9bb'
    },
    passiveColor: {
      type: String,
      default: '#b5b5b5'
    },
    activeThickness: {
      type: Number,
      default: 10
    },
    passiveThickness: {
      type: Number,
      default: 3
    },
    lineThickness: {
      type: Number,
      default: 4
    }
  },

  computed: {
    scaleX: function scaleX() {
      var step = this.currentStep;
      if (step < 0) {
        step = 0;
      } else if (step >= this.steps.length) {
        step = this.steps.length - 1;
      }
      return step / (this.steps.length - 1);
    }
  }
};

/***/ }),
/* 874 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/treeGrid/TreeGrid.vue ***!
  \*************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _MassTaskModal = __webpack_require__(/*! ../modals/massTaskModal/MassTaskModal */ 1289);

var _MassTaskModal2 = _interopRequireDefault(_MassTaskModal);

var _MassDeclassifyModal = __webpack_require__(/*! ../modals/massDeclassifyModal/MassDeclassifyModal */ 1288);

var _MassDeclassifyModal2 = _interopRequireDefault(_MassDeclassifyModal);

var _ButtonPrimary = __webpack_require__(/*! ../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _language = __webpack_require__(/*! ../../../build/language */ 19);

var _language2 = _interopRequireDefault(_language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatter = new Intl.NumberFormat(_language2.default.getDatePickerLanguage()).format;

exports.default = {
  name: 'TreeGrid',

  components: {
    MassTaskModal: _MassTaskModal2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    MassDeclassifyModal: _MassDeclassifyModal2.default
  },

  props: {
    gridId: {
      type: String
    },
    result: {
      type: Object,
      required: true
    },
    exportUrl: {
      type: String,
      required: true
    },
    treeGridFileName: {
      type: String,
      required: true
    },
    treeGridLayoutPath: {
      type: String
    },
    cfgObj: {
      type: Object,
      required: false
    },
    showExportButton: {
      type: Boolean,
      default: true
    },
    showMassTaskAction: {
      type: Boolean,
      default: false
    },
    showAnnulledMovementButton: {
      type: Boolean,
      default: false
    },
    showExcluirRemessaButton: {
      type: Boolean,
      default: false
    },
    showHrTopGrid: {
      type: Boolean,
      default: true
    },
    showAlert: {
      type: Boolean,
      default: false
    },
    showMassDeclassifyAction: {
      type: Boolean,
      default: false
    },
    alertMessage: {
      type: String,
      required: false
    },
    treeGridModal: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      lancamentosSelecionados: {
        arrayIdExtBancSelecionado: [],
        arrayIdMovFinSelecionado: [],
        arrayLinhaSelecionada: []
      }
    };
  },


  computed: {
    allowMassTask: function allowMassTask() {
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(209) >= 0;
    },
    showMassTaskButton: function showMassTaskButton() {
      return this.showMassTaskAction && this.allowMassTask;
    },
    showMassDeclassifyButton: function showMassDeclassifyButton() {
      return this.showMassDeclassifyAction;
    },
    treeGridResult: function treeGridResult() {
      return this.result;
    },
    btnId: function btnId() {
      return 'btnExportarXls-' + this.gridId;
    },
    btnTarefaEmMassaId: function btnTarefaEmMassaId() {
      return 'btnIniciarTarefaEmMAssa-' + this.gridId;
    },
    modalTarefaEmMassaId: function modalTarefaEmMassaId() {
      return 'modalIniciarTarefaEmMAssa-' + this.gridId;
    },
    btnDesclassificarEmMassaId: function btnDesclassificarEmMassaId() {
      return 'btnIniciarDesclassificarEmMassa-' + this.gridId;
    },
    modalDesclassificarEmMassaId: function modalDesclassificarEmMassaId() {
      return 'modalIniciarDesclassificarEmMassa-' + this.gridId;
    },
    btnAnulacaoContaLancamentoId: function btnAnulacaoContaLancamentoId() {
      return 'btnIniciarAnulacaoContaLancamento-' + this.gridId;
    },
    btnExcluir: function btnExcluir() {
      return 'btnExcluirRemessas-' + this.gridId;
    },
    gridItemId: function gridItemId() {
      switch (this.gridId) {
        case 'ExtratoConta':
          return 'IdLancamento';
        case 'RelatorioConciliacao':
          return 'IdConciliacaoLote';
        case 'MovimentoFinanceiro':
          return 'IdMovimentacao';
        case 'RemessasIntegracao':
          return 'IdMov';
      }
    },
    labelBtnAnulacaoContaLancamento: function labelBtnAnulacaoContaLancamento() {
      return this.gridId === 'LancamentoDuplicado' ? this.$t('analiseDuplicidade.labels.anularLancamento') : this.$t('analiseDuplicidade.labels.reverterAnulacao');
    }
  },

  watch: {
    treeGridResult: function treeGridResult() {
      this.createTreeGrid();
    }
  },

  methods: {
    exportarXls: function exportarXls() {
      window.Grids[0].Source.Export.Type = '';
      window.Grids[0].ActionExport();
    },
    createTreeGrid: function createTreeGrid() {
      var treegridCfg = {
        Text: {
          Url: '../assets/grid/Text-' + _language2.default.getCookieByName('language') + '.xml'
        },
        Layout: {
          Url: '../assets/treegridLayouts/' + this.treeGridLayoutPath + '/config-' + _language2.default.getCookieByName('language') + '.js'
        },
        Data: {
          Data: this.result
        },
        Export: {
          Url: this.exportUrl + '?treeGridFileName=' + this.treeGridFileName
        }
      };
      if (this.cfgObj) {
        treegridCfg.Layout = {};
        treegridCfg.Layout.Data = this.cfgObj;
      }
      window.TreeGrid(treegridCfg, this.gridId);
      window.Grids.OnClickButtonExport = function (G) {
        window.Grids[0].Source.Export.Type = '';
        window.Grids[0].ActionExport();
        return true;
      };

      window.Grids.OnGetExportValue = function (G, row, col, str) {
        if (G.ExportFormat === 'csv') {
          if (G.GetType(row, col) === 'Date') {
            if (window.Get(row, col)) {
              return (0, _moment2.default)(window.Get(row, col)).utc().format('L');
            }
          } else {
            return window.Get(row, col, str);
          }
        } else if (G.ExportFormat === 'xlsx') {
          if (typeof str === 'number' && /^id/i.test(col)) {
            return str.toString().length >= 15 ? 'ㅤ' + formatter(str) : formatter(str);
          }
        } else if (G.ExportFormat === 'xls') {
          if (typeof str === 'number' && /^id/i.test(col)) {
            return str.toString().length >= 15 ? 'ㅤ' + formatter(str) : formatter(str);
          }
        }
      };
    },
    openModalMassTask: function openModalMassTask() {
      this.lancamentosSelecionados = {
        arrayIdExtBancSelecionado: [],
        arrayIdMovBancSelecionado: [],
        arrayIdMovFinSelecionado: [],
        arrayLinhaSelecionada: []
      };

      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            linha._isVue = true;
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados);

            linha._isVue = false;
          }
        }
      }
      $('#' + this.modalTarefaEmMassaId).modal({ backdrop: 'static', keyboard: false });
    },
    openModalMassDeclassify: function openModalMassDeclassify() {
      this.lancamentosSelecionados = {
        arrayIdExtBancSelecionado: [],
        arrayIdMovBancSelecionado: [],
        arrayIdMovFinSelecionado: [],
        arrayLinhaSelecionada: []
      };

      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            linha._isVue = true;
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados);

            linha._isVue = false;
          }
        }
      }
      $('#' + this.modalDesclassificarEmMassaId).modal({ backdrop: 'static', keyboard: false });
    },
    annulMovements: function annulMovements() {
      this.lancamentosSelecionados = {
        arrayIdExtBancSelecionado: [],
        arrayLinhaSelecionada: []
      };

      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            linha._isVue = true;
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados);

            linha._isVue = false;
          }
        }
      }
      this.$emit('annulMovements', {
        idsContaLancamento: this.lancamentosSelecionados.arrayIdExtBancSelecionado,
        flAnulado: this.gridId === 'LancamentoDuplicado' ? 1 : 0,
        flRevertido: this.gridId === 'LancamentoDuplicado' ? 0 : 1
      });
    },
    excluirRemessas: function excluirRemessas() {
      this.lancamentosSelecionados = {
        arrayIdRemessaIntegracao: [],
        arrayLinhaSelecionada: []
      };

      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {
        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {
          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {
            linha._isVue = true;
            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados);

            linha._isVue = false;
          }
        }
      }
      this.$emit('remittanceRemoval', this.lancamentosSelecionados);
    },
    salvaVendasSolicitadas: function salvaVendasSolicitadas(linha, lancamentosSelecionados) {
      if (linha.firstChild) {
        for (var linhaFilha = linha.firstChild; linhaFilha; linhaFilha = linhaFilha.nextSibling) {
          lancamentosSelecionados = this.salvaVendasSolicitadas(linhaFilha, lancamentosSelecionados);
        }
      } else if (linha.Kind === 'Data' && linha['Check'] && linha['Check'] === 1) {
        if (this.gridId === 'ExtratoConta') {
          lancamentosSelecionados.arrayIdExtBancSelecionado.push(linha[this.gridItemId]);
          if (linha['SituacaoConcil'] === 'A') {
            lancamentosSelecionados.arrayIdMovBancSelecionado.push(linha[this.gridItemId]);
          }
        } else if (this.gridId === 'MovimentoFinanceiro') {
          lancamentosSelecionados.arrayIdMovFinSelecionado.push(linha[this.gridItemId]);
        } else if (this.gridId === 'RemessasIntegracao') {
          lancamentosSelecionados.arrayIdRemessaIntegracao.push(linha[this.gridItemId]);
        } else {
          linha['IdContaLancamento'] ? lancamentosSelecionados.arrayIdExtBancSelecionado.push(linha['IdContaLancamento']) : lancamentosSelecionados.arrayIdMovFinSelecionado.push(linha['IdMovFinanceiro']);
        }
        lancamentosSelecionados.arrayLinhaSelecionada.push(linha);
      }
      return lancamentosSelecionados;
    }
  },

  destroyed: function destroyed() {
    if (!this.treeGridModal) {
      window.DisposeGrids();
    } else if (this.cfgObj && this.cfgObj.Cfg && this.cfgObj.Cfg.id) {
      window.Grids[this.cfgObj.Cfg.id].Dispose();
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 875 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/treeViewHistoric/TreeviewHistoric.vue ***!
  \*****************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ 136);

var _stringify2 = _interopRequireDefault(_stringify);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _logTransacao = __webpack_require__(/*! ../../enum/logTransacao */ 748);

var _logTransacao2 = _interopRequireDefault(_logTransacao);

var _situacaoTarefa = __webpack_require__(/*! ../../enum/situacaoTarefa */ 751);

var _situacaoTarefa2 = _interopRequireDefault(_situacaoTarefa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var id = 1000;
var fromData = '';
var toData = '';
var fromParentModelChildren = '';
var nodeClicked = null;

exports.default = {
  name: 'TreeviewHistoric',

  props: {
    model: Object,
    buttonsTitle: Object,
    clickFunction: Function,
    id: String,
    father: Object,
    defaultText: String,
    currentHighlight: Boolean,
    hoverColor: String,
    highlightColor: String,
    spaceLeft: String,
    styleObj: Object
  },

  data: function data() {
    return {
      open: true,
      isClicked: true,
      title: '',
      situation: '',
      dateFomated: null
    };
  },

  computed: {
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length;
    }
  },

  template: '<div class="treeviewHistoric">\n              <div :id=\'model.id\' draggable=\'false\' @dragstart=\'dragStart\' @dragover=\'dragOver\' @dragenter=\'dragEnter\' @dragleave=\'dragLeave\' @drop=\'drop\' @dragend=\'dragEnd\' class=\'col-xs-12 acaoMain pl-0\' @mouseover=\'mouseOver\' @mouseout=\'mouseOut\' :style=\'styleObj\'>\n                <button v-if="!isClicked" :title="[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : \'\']" @click="toggle" class="fa fa-plus-square px-0 action btn-fa-expand"></button>\n                <button v-if="isClicked" :title="[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : \'\']" @click="toggle" class="fa fa-minus-square px-0 action btn-fa-expand"></button>\n                <div :style=\'spaceLeft\' class="col-xs-10 pl-0">\n                  {{title}} | {{dateFomated}}\n                </div>\n              </div>\n              <div class="clear"></div>\n              <div v-if="!open" style="min-height:20px;"></div>\n              <div v-if="open" class="childrenObject">\n                <div style="margin-bottom:5px;">{{model.usuario && model.usuario.nome ? model.usuario.nome : \'-\'}}</div>\n                <div><b>{{situation != null ? situation : \'-\'}}</b></div>\n                <div>{{model.descricao ? model.descricao : \'-\'}}</div>\n              </div>\n            </div>',

  methods: {
    getTitLabel: function getTitLabel() {
      this.title = this.$t('logTransacao.' + _logTransacao2.default[this.model.idTransacao]);
    },
    getSituationTaskLabel: function getSituationTaskLabel() {
      this.situation = this.model.situacao != null ? this.$t('situacaoTarefa.' + _situacaoTarefa2.default[this.model.situacao]) : null;
    },
    getDateFormated: function getDateFormated() {
      this.dateFomated = (0, _moment2.default)(this.model.data).format('lll');
    },
    toggle: function toggle() {
      this.open = !this.open;
      var rootTree = this.findRoot();

      this.isClicked = !this.isClicked;

      if (this.currentHighlight) {
        if (nodeClicked !== this.model.id) {
          var treeParent = rootTree.$parent;
          var nodeStack = [treeParent.$children[0]];
          while (nodeStack.length !== 0) {
            var item = nodeStack.shift();
            item.styleObj.background = 'white';
            if (item.$children && item.$children.length > 0) {
              nodeStack = nodeStack.concat(item.$children);
            }
          }
          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF';
          nodeClicked = this.model.id;
        }
      }
    },
    exchangeData: function exchangeData(rootCom, from, to) {
      if (!to || !from || typeof to === 'string' || from.id === to.id) {
        return;
      }

      from = JSON.parse((0, _stringify2.default)(from));
      to = JSON.parse((0, _stringify2.default)(to));

      var treeData = JSON.parse((0, _stringify2.default)(this.model));
      var nodeStack = [treeData];
      var status = 0;

      try {
        while (!(status === 2)) {
          var item = nodeStack.shift();
          if (item.id === from.id) {
            item.id = to.id;
            item.name = to.name;
            if (to.children && to.children.length > 0) {
              item['children'] = to.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.id === to.id) {
            item.id = from.id;
            item.name = from.name;
            if (from.children && from.children.length > 0) {
              item['children'] = from.children;
            } else {
              item.children = [];
            }
            status++;
            continue;
          }
          if (item.children && item.children.length > 0) {
            nodeStack = nodeStack.concat(item.children);
          }
        }
      } catch (e) {
        return;
      }
      rootCom.assignData(treeData);
    },
    changeType: function changeType() {
      if (this.currentHighlight) {
        nodeClicked = this.model.id;
      }
      if (!this.isFolder) {
        this.$set(this.model, 'children', []);
        this.addChild();
        this.open = true;
        this.isClicked = true;
      }
    },
    mouseOver: function mouseOver(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2';
        }
      }
    },
    mouseOut: function mouseOut(e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = 'white';
        }
      }
    },
    findRoot: function findRoot() {
      var ok = false;
      var that = this;
      while (!ok) {
        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {
          ok = true;
          break;
        }
        that = that.$parent;
      }
      return that;
    },
    addChild: function addChild() {
      this.model.children.push({
        name: this.defaultText ? this.defaultText : 'New Node',
        id: id++
      });
    },
    removeChild: function removeChild(id) {
      var parentModelChildren = this.$parent.model.children;
      for (var index in parentModelChildren) {
        if (parentModelChildren[index].id === id) {
          parentModelChildren = parentModelChildren.splice(index, 1);
          break;
        }
      }
    },
    dragStart: function dragStart(e) {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('nottext', e.target.innerHTML);
      return true;
    },
    dragEnd: function dragEnd(e) {
      fromData = undefined;
      toData = undefined;
      fromParentModelChildren = undefined;
    },
    dragOver: function dragOver(e) {
      e.preventDefault();
      return true;
    },
    dragOverPlus: function dragOverPlus(e) {
      e.preventDefault();
    },
    dragEnterPlus: function dragEnterPlus(e) {},
    dragEnter: function dragEnter(e) {
      toData = this.model;
      var rootTree = this.findRoot();
      rootTree.exchangeData(rootTree.$parent, fromData, toData);
    },
    dragLeave: function dragLeave(e) {
      fromData = this.model;
      fromParentModelChildren = this.$parent.model.children;
    },
    drop: function drop(e) {},
    dropPlus: function dropPlus(e) {
      if (this.model.hasOwnProperty('children')) {
        this.model.children.push(fromData);
      } else {
        this.model.children = [fromData];
      }
      for (var i in fromParentModelChildren) {
        if (fromParentModelChildren[i].id === fromData.id) {
          fromParentModelChildren.splice(i, 1);
        }
      }
    }
  },

  beforeCreate: function beforeCreate() {
    this.$options.components.item = __webpack_require__(/*! ./TreeviewHistoric */ 694);
  },
  mounted: function mounted() {
    this.getTitLabel();
    this.getSituationTaskLabel();
    this.getDateFormated();
  }
};

/***/ }),
/* 876 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/App.vue ***!
  \*****************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoadingFullPage = __webpack_require__(/*! ../loading/LoadingFullPage */ 1280);

var _LoadingFullPage2 = _interopRequireDefault(_LoadingFullPage);

var _Notification = __webpack_require__(/*! ../notification/Notification */ 1291);

var _Notification2 = _interopRequireDefault(_Notification);

__webpack_require__(/*! reset-css/reset.css */ 1132);

__webpack_require__(/*! font-awesome/css/font-awesome.css */ 1131);

__webpack_require__(/*! ../../template/assets/plugins/jquery-scrollbar/jquery.scrollbar.css */ 1127);

__webpack_require__(/*! ../../template/pages/css/pages.css */ 1128);

__webpack_require__(/*! bootstrap/dist/css/bootstrap.min.css */ 1130);

__webpack_require__(/*! ../../assets/fonts/fonts.css */ 1126);

__webpack_require__(/*! toastr/build/toastr.min.css */ 1133);

__webpack_require__(/*! ../../template/assets/plugins/jquery-scrollbar/jquery.scrollbar.min.js */ 788);

__webpack_require__(/*! ../../template/assets/plugins/modernizr.custom.js */ 795);

__webpack_require__(/*! bootstrap/dist/js/bootstrap.min.js */ 959);

__webpack_require__(/*! bootstrap-vue/dist/bootstrap-vue.css */ 1129);

__webpack_require__(/*! vue-select/dist/vue-select.css */ 1134);

var _routesMap = __webpack_require__(/*! ../../router/routesMap */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'App',

  components: {
    LoadingFullPage: _LoadingFullPage2.default,
    Notification: _Notification2.default
  },

  data: function data() {
    return {
      intervalRenewToken: null
    };
  },


  computed: {
    isLoadingFullPage: function isLoadingFullPage() {
      return this.$store.getters.isLoadingFullPage;
    }
  },

  mounted: function mounted() {
    document.body.classList.remove('fade-out');
    this.$store.dispatch('fullPageLoaded');

    window.addEventListener('storage', function (event) {
      if (event.newValue === null) {
        return;
      }

      switch (event.key) {
        case 'event-login-start':
          localStorage.removeItem('event-login-start');
          break;
        case 'event-login-done':
        case 'event-client-selected':
          localStorage.removeItem(event.key);
          location.href = _routesMap2.default.HOME;
          break;
        case 'event-logout':
          localStorage.removeItem(event.key);
          location.href = _routesMap2.default.BANKING;
          break;
        default:
          break;
      }
    });
  }
};

/***/ }),
/* 877 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/administration/accessProfile/List.vue ***!
  \***********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueTables = __webpack_require__(/*! vue-tables-2 */ 132);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _customFilters = __webpack_require__(/*! ../../../../utils/customFilters.js */ 135);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _perfilAcessoEnum = __webpack_require__(/*! ../../../../enum/perfilAcessoEnum */ 201);

var _perfilAcessoEnum2 = _interopRequireDefault(_perfilAcessoEnum);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AccessProfileList',

  components: {
    PageTitle: _PageTitle2.default,
    LoadingPlaceholder: _LoadingPlaceholder2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      isLoadingData: true,
      profiles: (0, _gridLoadTransition.generateLoadingRows)(10),
      columns: ['nome', 'visibilidade', 'acoes'],
      options: {
        templates: {
          nome: _LoadingPlaceholder2.default,
          visibilidade: _LoadingPlaceholder2.default,
          acoes: _LoadingPlaceholder2.default
        },
        columnsClasses: {
          'nome': 'col-md-6',
          'visibilidade': 'col-md-5',
          'acoes': 'col-md-1'
        },
        headings: {
          nome: this.$t('administracao.perfilAcesso.labels.perfil'),
          visibilidade: this.$t('administracao.perfilAcesso.labels.visibilidade'),
          acoes: this.$t('administracao.perfilAcesso.labels.acoes')
        },
        filterable: [],
        customFilters: [{
          name: 'nome',
          callback: _customFilters.filterByAccessProfileName
        }],
        filterByColumn: true,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortable: ['nome'],
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 },
        orderBy: {
          ascending: true,
          column: 'nome'
        },

        customSorting: {
          nome: function nome(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'nome');
            };
          }
        }
      }
    };
  },


  methods: {
    handleFilter: function handleFilter(event, column) {
      _vueTables.Event.$emit('vue-tables.filter::' + column, event.currentTarget.value);
    },
    isMasterProfile: function isMasterProfile(accessProfileId) {
      return Number(accessProfileId) === _perfilAcessoEnum2.default.MASTER;
    },
    edit: function edit(acessProfileId) {
      var _this = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'edit-click', 'edit-perfil-de-acesso', 'edit-perfil-de-acesso');
      this.$store.dispatch('setProfileToEdit', acessProfileId).then(function (response) {
        _this.$router.push(_routesMap2.default.NEW_ACCESS_PROFILE);
      });
    },
    newProfile: function newProfile() {
      this.$router.push(_routesMap2.default.NEW_ACCESS_PROFILE);
    },
    loadProfiles: function loadProfiles() {
      var _this2 = this;

      this.$store.dispatch('getProfiles').then(function (response) {
        _this2.profiles = response.data;
        _this2.isLoadingData = false;
        _this2.options.templates = {
          visibilidade: function visibilidade(h, row) {
            return row.perfilAcessoBanking ? row.perfilAcessoBanking.visibilidadeEstabelecimento === '0' ? _this2.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos') : _this2.$t('administracao.perfilAcesso.labels.visibilidadeAcessaAlguns') : _this2.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos');
          }
        };
      });
    },
    removeSpecialChars: function removeSpecialChars(newStringComAcento) {
      var string = newStringComAcento;
      var mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB&(?!amp;)]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g,
        '-': /\s/g
      };

      mapaAcentosHex.forEach(function (letra) {
        var expressaoRegular = mapaAcentosHex[letra];
        string = string.replace(expressaoRegular, letra);
      });

      return string;
    }
  },

  created: function created() {
    this.loadProfiles();
  }
};

/***/ }),
/* 878 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/administration/accessProfile/New.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _maxSafeInteger = __webpack_require__(/*! babel-runtime/core-js/number/max-safe-integer */ 203);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _vueTables = __webpack_require__(/*! vue-tables-2 */ 132);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _StepProgress = __webpack_require__(/*! ../../../step/StepProgress */ 1314);

var _StepProgress2 = _interopRequireDefault(_StepProgress);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _customFilters = __webpack_require__(/*! ../../../../utils/customFilters.js */ 135);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _perfilAcessoEnum = __webpack_require__(/*! ../../../../enum/perfilAcessoEnum */ 201);

var _perfilAcessoEnum2 = _interopRequireDefault(_perfilAcessoEnum);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AccessProfileNew',

  components: {
    StepProgress: _StepProgress2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    var _this = this;

    return {
      steps: [this.$t('administracao.perfilAcesso.etapas.informacoesPerfil'), this.$t('administracao.perfilAcesso.etapas.estabelecimentos'), this.$t('administracao.perfilAcesso.etapas.contasBancarias'), this.$t('administracao.perfilAcesso.etapas.confirmacao')],
      currentStep: 0,
      profile: {
        name: '',
        visibility: '',
        functionalitiesSelected: [],
        establishmentsSelected: [],
        bankAccountsSelected: []
      },
      functionalitiesGroups: [],
      totalFunctionalities: null,
      allFunctionalitiesSelected: false,
      establishments: {
        establishments: [],
        allEstablishmentsSelected: false,
        columns: ['check', 'nome', 'nomeFantasia', 'cnpj'],
        options: {
          headings: {
            nome: this.$t('estabelecimentos.labels.nome'),
            nomeFantasia: this.$t('estabelecimentos.labels.nomeFantasia'),
            cnpj: this.$t('estabelecimentos.labels.cnpj')
          },
          columnsClasses: {
            nome: 'col-md-4',
            nomeFantasia: 'col-md-4',
            cnpj: 'col-md-4'
          },
          filterable: ['nome', 'nomeFantasia', 'cnpj'],
          filterByColumn: true,
          perPageValues: [],
          sortable: ['nome', 'nomeFantasia', 'cnpj'],
          sortIcon: { is: '' },
          pagination: { chunk: 5 },
          perPage: _maxSafeInteger2.default,
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          }
        }
      },
      bankAccounts: {
        accounts: [],
        allBankAccountsSelected: false,
        columns: ['check', 'nome', 'banco', 'agencia', 'conta'],
        options: {
          headings: {
            nome: this.$t('contaBancaria.labels.nome'),
            banco: this.$t('contaBancaria.labels.banco'),
            agencia: this.$t('contaBancaria.labels.agencia'),
            conta: this.$t('contaBancaria.labels.numeroConta')
          },
          columnsClasses: {
            nome: 'col-md-3',
            banco: 'col-md-4',
            agencia: 'col-md-2',
            conta: 'col-md-3'
          },
          filterable: ['nome'],
          customFilters: [{
            name: 'banco',
            callback: _customFilters.filterByBank
          }, {
            name: 'agencia',
            callback: _customFilters.filterByAgency
          }, {
            name: 'conta',
            callback: _customFilters.filterByAccount
          }],
          filterByColumn: true,
          perPageValues: [],
          sortable: ['nome', 'banco', 'agencia', 'conta'],
          sortIcon: { is: '' },
          customSorting: {
            nome: function nome(ascending) {
              return function (a, b) {
                return _customSorter2.default.stringSorter(ascending, a, b, 'nome');
              };
            },
            banco: function banco(ascending) {
              return function (a, b) {
                var lastA = a.banco.codigo;
                var lastB = b.banco.codigo;
                if (ascending) {
                  return lastA <= lastB ? 1 : -1;
                }
                return lastA >= lastB ? 1 : -1;
              };
            },
            agencia: function agencia(ascending) {
              return function (a, b) {
                var lastA = a.agencia;
                lastA.agencia = a.numAgencia + (a.digAgencia ? '-' + a.digAgencia : '');

                var lastB = b.agencia;
                lastB.agencia = b.numAgencia + (b.digAgencia ? '-' + b.digAgencia : '');

                return _customSorter2.default.stringSorter(ascending, lastA, lastB, 'agencia');
              };
            },
            conta: function conta(ascending) {
              return function (a, b) {
                return _customSorter2.default.stringSorter(ascending, a, b, 'conta');
              };
            }
          },
          pagination: { chunk: 5 },
          perPage: _maxSafeInteger2.default,
          templates: {
            nome: function nome(h, row) {
              return row.nome + (row.ativo ? '' : ' (' + _this.$t('contaBancaria.labels.inativa') + ')');
            },
            banco: function banco(h, row) {
              return row.banco.codigo + '-' + row.banco.nomeFantasia;
            },
            agencia: function agencia(h, row) {
              return row.numAgencia + (row.digAgencia ? '-' + row.digAgencia : '');
            },
            conta: function conta(h, row) {
              return row.conta + (row.digConta ? '-' + row.digConta : '');
            }
          },
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          }
        }
      },
      requestSaveProfileSent: false
    };
  },


  computed: {
    profileToEditId: function profileToEditId() {
      return this.$store.getters.profileToEditId;
    },
    pageTitleSubTitle: function pageTitleSubTitle() {
      return this.profileToEditId ? this.$t('administracao.perfilAcesso.titulos.edicaoSubtitulo') : this.$t('administracao.perfilAcesso.titulos.cadastroSubtitulo');
    },
    filterPortletTitle: function filterPortletTitle() {
      return this.profileToEditId ? this.$t('administracao.perfilAcesso.titulos.editarPerfil') : this.$t('administracao.perfilAcesso.titulos.novoPerfil');
    }
  },

  watch: {
    'profile.name': {
      handler: function handler() {
        var objectToCompare = {
          name: this.profile.name,
          visibility: this.profile.visibility,
          functionalities: this.profile.functionalitiesSelected.map(function (fun) {
            return fun.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          establishments: this.profile.establishmentsSelected.map(function (estab) {
            return estab.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          bankAccounts: this.profile.bankAccountsSelected.map(function (account) {
            return account.id;
          }).sort(function (a, b) {
            return a - b;
          })
        };
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, objectToCompare));
      },

      deep: true
    },
    'profile.visibility': {
      handler: function handler() {
        var objectToCompare = {
          name: this.profile.name,
          visibility: this.profile.visibility,
          functionalities: this.profile.functionalitiesSelected.map(function (fun) {
            return fun.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          establishments: this.profile.establishmentsSelected.map(function (estab) {
            return estab.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          bankAccounts: this.profile.bankAccountsSelected.map(function (account) {
            return account.id;
          }).sort(function (a, b) {
            return a - b;
          })
        };
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, objectToCompare));
      },

      deep: true
    },
    'profile.functionalitiesSelected': {
      handler: function handler() {
        var objectToCompare = {
          name: this.profile.name,
          visibility: this.profile.visibility,
          functionalities: this.profile.functionalitiesSelected.map(function (fun) {
            return fun.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          establishments: this.profile.establishmentsSelected.map(function (estab) {
            return estab.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          bankAccounts: this.profile.bankAccountsSelected.map(function (account) {
            return account.id;
          }).sort(function (a, b) {
            return a - b;
          })
        };
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, objectToCompare));
      },

      deep: true
    },
    'profile.establishmentsSelected': {
      handler: function handler() {
        var objectToCompare = {
          name: this.profile.name,
          visibility: this.profile.visibility,
          functionalities: this.profile.functionalitiesSelected.map(function (fun) {
            return fun.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          establishments: this.profile.establishmentsSelected.map(function (estab) {
            return estab.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          bankAccounts: this.profile.bankAccountsSelected.map(function (account) {
            return account.id;
          }).sort(function (a, b) {
            return a - b;
          })
        };
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, objectToCompare));
      },

      deep: true
    },
    'profile.bankAccountsSelected': {
      handler: function handler() {
        var objectToCompare = {
          name: this.profile.name,
          visibility: this.profile.visibility,
          functionalities: this.profile.functionalitiesSelected.map(function (fun) {
            return fun.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          establishments: this.profile.establishmentsSelected.map(function (estab) {
            return estab.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          bankAccounts: this.profile.bankAccountsSelected.map(function (account) {
            return account.id;
          }).sort(function (a, b) {
            return a - b;
          })
        };
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, objectToCompare));
      },

      deep: true
    }
  },

  methods: {
    loadData: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.loadEstablishments();

              case 3:
                _context.next = 5;
                return this.loadBankAccounts();

              case 5:
                _context.next = 7;
                return this.loadFunctionalitiesGroups();

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);

                this.$root.$refs.notification.error(_context.t0.message);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function loadData() {
        return _ref.apply(this, arguments);
      }

      return loadData;
    }(),
    loadProfile: function loadProfile() {
      var _this2 = this;

      this.$store.dispatch('getProfile', this.profileToEditId).then(function (response) {
        var profileToEdit = response.data;

        _this2.profile.name = profileToEdit.nome;
        profileToEdit.grupoFuncionalidades.forEach(function (functionalityGroupSelected) {
          functionalityGroupSelected.funcionalidades.forEach(function (functionalitySelected) {
            _this2.functionalitiesGroups.forEach(function (functionalityGroup) {
              functionalityGroup.funcionalidades.forEach(function (functionality) {
                if (functionality.id === functionalitySelected.id) {
                  functionality.checked = true;
                  _this2.selectFunctionality(functionality);
                  return;
                }
              });
            });
          });
        });
        if (profileToEdit.perfilAcessoBanking) {
          _this2.profile.visibility = profileToEdit.perfilAcessoBanking.visibilidadeEstabelecimento;

          profileToEdit.perfilAcessoBanking.perfilAcessoEstabelecimentos.forEach(function (establishmentSelected) {
            _this2.establishments.establishments.forEach(function (establishment) {
              if (establishmentSelected.estabelecimento.id === establishment.id) {
                _this2.selectEstablishment(establishment);
                return;
              }
            });
          });

          profileToEdit.perfilAcessoBanking.perfilAcessoContas.forEach(function (bankAccountSelected) {
            _this2.bankAccounts.accounts.forEach(function (bankAccount) {
              if (bankAccountSelected.conta.id === bankAccount.id) {
                _this2.selectBankAccount(bankAccount);
                return;
              }
            });
          });
        } else {
          _this2.profile.visibility = '0';
        }

        _this2.defaultObject = {
          name: _this2.profile.name,
          visibility: _this2.profile.visibility,
          functionalities: _this2.profile.functionalitiesSelected.map(function (fun) {
            return fun.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          establishments: _this2.profile.establishmentsSelected.map(function (estab) {
            return estab.id;
          }).sort(function (a, b) {
            return a - b;
          }),
          bankAccounts: _this2.profile.bankAccountsSelected.map(function (account) {
            return account.id;
          }).sort(function (a, b) {
            return a - b;
          })
        };
      });
    },
    isMasterProfile: function isMasterProfile(accessProfileId) {
      return Number(accessProfileId) === _perfilAcessoEnum2.default.MASTER;
    },
    loadFunctionalitiesGroups: function loadFunctionalitiesGroups() {
      var _this3 = this;

      var self = this;
      return new _promise2.default(function (resolve, reject) {
        _this3.$store.dispatch('getFunctionalitiesGroups', '/accessProfile/functionalitiesGroups').then(function (response) {
          _this3.totalFunctionalities = 0;
          _this3.functionalitiesGroups = response.data;
          var remove = [];
          _this3.functionalitiesGroups.forEach(function (functionalityGroup, index, list) {
            if (functionalityGroup.funcionalidades && functionalityGroup.funcionalidades.length > 0) {
              _this3.$set(functionalityGroup, 'checked', false);
              _this3.$set(functionalityGroup, 'selectedFuncs', []);
              if (!self.$store.getters.isClientEmulatedLogin) {
                if (functionalityGroup.nome === self.$t('menu.grupos.registro')) {
                  functionalityGroup.funcionalidades = functionalityGroup.funcionalidades.filter(function (funcionalidade) {
                    return funcionalidade.nome !== self.$t('menu.funcionalidades.categorias') && funcionalidade.nome !== self.$t('menu.funcionalidades.planosConciliacao') && funcionalidade.nome !== self.$t('conjuntoAtributo.titulos.atributos');
                  });
                }
              }
              functionalityGroup.funcionalidades.forEach(function (functionality) {
                _this3.$set(functionality, 'checked', false);
                _this3.totalFunctionalities++;
              });
            } else {
              remove.push(functionalityGroup);
            }
          });

          remove.forEach(function (group) {
            var idx = _this3.functionalitiesGroups.indexOf(group);
            if (idx >= 0) {
              _this3.functionalitiesGroups.splice(idx, 1);
            }
          });

          if (_this3.profileToEditId) {
            _this3.loadProfile();
          } else {
            _this3.defaultObject = {
              name: _this3.profile.name,
              visibility: _this3.profile.visibility,
              functionalities: _this3.profile.functionalitiesSelected.map(function (fun) {
                return fun.id;
              }).sort(function (a, b) {
                return a - b;
              }),
              establishments: _this3.profile.establishmentsSelected.map(function (estab) {
                return estab.id;
              }).sort(function (a, b) {
                return a - b;
              }),
              bankAccounts: _this3.profile.bankAccountsSelected.map(function (account) {
                return account.id;
              }).sort(function (a, b) {
                return a - b;
              })
            };
          }
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    trackEventOnFunctionality: function trackEventOnFunctionality(functionalityName) {
      (0, _analytics.trackAnalyticsEvent)(this, 'checkbox-click', 'select-funcionalidade', functionalityName);
    },
    trackEventOnFunctionalityGroup: function trackEventOnFunctionalityGroup(functionalityGroupName) {
      (0, _analytics.trackAnalyticsEvent)(this, 'checkbox-click', 'select-grupo-de-funcionalidade', functionalityGroupName);
    },
    selectAllFunctionalities: function selectAllFunctionalities() {
      var _this4 = this;

      this.allFunctionalitiesSelected = !this.allFunctionalitiesSelected;
      this.profile.functionalitiesSelected = [];

      this.functionalitiesGroups.forEach(function (gf) {
        gf.checked = _this4.allFunctionalitiesSelected;
        gf.selectedFuncs = _this4.allFunctionalitiesSelected ? gf.funcionalidades.slice() : [];
        gf.funcionalidades.forEach(function (f) {
          f.checked = _this4.allFunctionalitiesSelected;
          _this4.allFunctionalitiesSelected ? _this4.pushItemToArray(f, _this4.profile.functionalitiesSelected) : _this4.spliceItemToArray(f, _this4.profile.functionalitiesSelected);
        });
      });
    },
    selectFunctionalityGroup: function selectFunctionalityGroup(functionalityGroup) {
      var _this5 = this;

      var groupIndex = this.functionalitiesGroups.indexOf(functionalityGroup);
      this.functionalitiesGroups[groupIndex].funcionalidades.forEach(function (f) {
        f.checked = _this5.functionalitiesGroups[groupIndex].checked;
        if (_this5.functionalitiesGroups[groupIndex].checked) {
          _this5.pushItemToArray(f, _this5.profile.functionalitiesSelected);
          _this5.pushItemToArray(f, _this5.functionalitiesGroups[groupIndex].selectedFuncs);
        } else {
          _this5.spliceItemToArray(f, _this5.profile.functionalitiesSelected);
          _this5.spliceItemToArray(f, _this5.functionalitiesGroups[groupIndex].selectedFuncs);
        }
      });

      this.allFunctionalitiesSelected = this.profile.functionalitiesSelected.length === this.totalFunctionalities;
      this.functionalitiesGroups[groupIndex].checked = this.functionalitiesGroups[groupIndex].selectedFuncs.length >= this.functionalitiesGroups[groupIndex].funcionalidades.length;
    },
    selectFunctionality: function selectFunctionality(functionality) {
      var gindex = this.getGroupIndexById(functionality.grupoFuncionalidade.id);

      if (functionality.checked) {
        this.pushItemToArray(functionality, this.profile.functionalitiesSelected);
        if (this.profile.functionalitiesSelected.length === this.totalFunctionalities) {
          this.allFunctionalitiesSelected = true;
        } else {
          this.allFunctionalitiesSelected = false;
        }
        this.pushItemToArray(functionality, this.functionalitiesGroups[gindex].selectedFuncs);
        if (this.functionalitiesGroups[gindex].selectedFuncs.length === this.functionalitiesGroups[gindex].funcionalidades.length) {
          this.functionalitiesGroups[gindex].checked = true;
        } else {
          this.functionalitiesGroups[gindex].checked = false;
        }
      } else {
        if (this.spliceItemToArray(functionality, this.profile.functionalitiesSelected)) {
          this.allFunctionalitiesSelected = false;
        }

        if (this.spliceItemToArray(functionality, this.functionalitiesGroups[gindex].selectedFuncs)) {
          this.functionalitiesGroups[gindex].checked = false;
        }
      }
    },
    getGroupIndexById: function getGroupIndexById(groupId) {
      var gIndex = -1;
      this.functionalitiesGroups.forEach(function (group, index) {
        if (group.id === groupId) {
          gIndex = index;
          return gIndex;
        }
      });
      return gIndex;
    },
    pushItemToArray: function pushItemToArray(item, array) {
      var idx = array.indexOf(item);
      if (idx === -1) {
        array.push(item);
      }
    },
    spliceItemToArray: function spliceItemToArray(item, array) {
      var idx = array.indexOf(item);
      if (idx > -1) {
        array.splice(idx, 1);
        return true;
      }
      return false;
    },
    getGroupIcon: function getGroupIcon(group) {
      var icon = '';
      if (group === 31) {
        icon = 'fa fa-wrench';
      } else if (group === 32) {
        icon = 'fa fa-pencil-square-o';
      } else if (group === 33) {
        icon = 'fa fa-handshake-o';
      } else if (group === 34) {
        icon = 'fa fa-share-alt';
      } else if (group === 35) {
        icon = 'fa fa-window-restore';
      } else if (group === 36) {
        icon = 'fa fa-bar-chart';
      } else if (group === 37) {
        icon = 'fa fa-usd';
      }
      return icon;
    },
    getCheckFuncContainerClass: function getCheckFuncContainerClass(index) {
      if (index % 2 === 0) {
        return 'col-xs-6 pull-left';
      } else {
        return 'col-xs-6 pull-right';
      }
    },
    loadEstablishments: function loadEstablishments() {
      var _this6 = this;

      return new _promise2.default(function (resolve, reject) {
        _this6.$store.dispatch('getEstablishmentsToTreeGrid', {
          url: 'establishment/listDetails'
        }).then(function (response) {
          var establishments = response.data.Body[0];
          _this6.establishments.establishments = establishments.map(function (establishment) {
            return {
              id: establishment.id,
              nome: establishment.Nome,
              nomeFantasia: establishment.NomeFantasia,
              cnpj: establishment.CNPJ ? establishment.CNPJ.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5') : '-'
            };
          });
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    selectAllEstablishments: function selectAllEstablishments() {
      var _this7 = this;

      this.establishments.allEstablishmentsSelected = !this.establishments.allEstablishmentsSelected;
      this.establishments.establishments = this.establishments.establishments.map(function (establishment) {
        establishment.checked = _this7.establishments.allEstablishmentsSelected;
        var index = _this7.profile.establishmentsSelected.findIndex(function (establishmentSelected) {
          return establishmentSelected['id'] === establishment['id'];
        });
        if (index > -1 && !_this7.establishments.allEstablishmentsSelected) {
          _this7.profile.establishmentsSelected.splice(index, 1);
        } else if (index === -1 && _this7.establishments.allEstablishmentsSelected) {
          _this7.profile.establishmentsSelected.push(establishment);
        }
        return establishment;
      });
    },
    selectEstablishment: function selectEstablishment(establishmentClicked) {
      var establishmentSelected = !establishmentClicked.checked;

      this.establishments.establishments = this.establishments.establishments.map(function (establishment) {
        if (establishment['id'] === establishmentClicked['id']) {
          establishment.checked = establishmentSelected;
        }
        return establishment;
      });

      if (establishmentSelected) {
        this.profile.establishmentsSelected.push(establishmentClicked);
      } else {
        var index = this.profile.establishmentsSelected.findIndex(function (establishment) {
          return establishment['id'] === establishmentClicked['id'];
        });
        if (index > -1) {
          this.profile.establishmentsSelected.splice(index, 1);
        }
      }

      if (this.profile.establishmentsSelected.length === 0 || this.profile.establishmentsSelected.length !== this.establishments.establishments.length) {
        this.establishments.allEstablishmentsSelected = false;
      } else if (this.profile.establishmentsSelected.length === this.establishments.establishments.length) {
        this.establishments.allEstablishmentsSelected = true;
      }
    },
    loadBankAccounts: function loadBankAccounts() {
      var _this8 = this;

      return new _promise2.default(function (resolve, reject) {
        _this8.$store.dispatch('getBankAccounts', '/bankAccounts').then(function (response) {
          _this8.bankAccounts.accounts = response.data.data;
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleFilter: function handleFilter(event, column) {
      _vueTables.Event.$emit('vue-tables.filter::' + column, event.currentTarget.value);
    },
    selectAllBankAccounts: function selectAllBankAccounts() {
      var _this9 = this;

      this.bankAccounts.allBankAccountsSelected = !this.bankAccounts.allBankAccountsSelected;
      this.bankAccounts.accounts = this.bankAccounts.accounts.map(function (account) {
        account.checked = _this9.bankAccounts.allBankAccountsSelected;
        var index = _this9.profile.bankAccountsSelected.findIndex(function (accountSelected) {
          return accountSelected['id'] === account['id'];
        });
        if (index > -1 && !_this9.bankAccounts.allBankAccountsSelected) {
          _this9.profile.bankAccountsSelected.splice(index, 1);
        } else if (index === -1 && _this9.bankAccounts.allBankAccountsSelected) {
          _this9.profile.bankAccountsSelected.push(account);
        }
        return account;
      });
    },
    selectBankAccount: function selectBankAccount(accountClicked) {
      var accountSelected = !accountClicked.checked;

      this.bankAccounts.accounts = this.bankAccounts.accounts.map(function (account) {
        if (account['id'] === accountClicked['id']) {
          account.checked = accountSelected;
        }
        return account;
      });

      if (accountSelected) {
        this.profile.bankAccountsSelected.push(accountClicked);
      } else {
        var index = this.profile.bankAccountsSelected.findIndex(function (account) {
          return account['id'] === accountClicked['id'];
        });
        if (index > -1) {
          this.profile.bankAccountsSelected.splice(index, 1);
        }
      }

      if (this.profile.bankAccountsSelected.length === 0 || this.profile.bankAccountsSelected.length !== this.bankAccounts.accounts.length) {
        this.bankAccounts.allBankAccountsSelected = false;
      } else if (this.profile.bankAccountsSelected.length === this.bankAccounts.accounts.length) {
        this.bankAccounts.allBankAccountsSelected = true;
      }
    },
    newProfile: function newProfile() {
      var _this10 = this;

      var profile = {
        id: this.profileToEditId,
        nome: this.profile.name.trim(),
        visibilidade: this.profile.visibility,
        funcionalidades: this.profile.functionalitiesSelected,
        estabelecimentos: this.profile.establishmentsSelected,
        contas: this.profile.bankAccountsSelected
      };

      this.requestSaveProfileSent = true;
      this.$store.dispatch('newProfile', profile).then(function (response) {
        if (_this10.profileToEditId) {
          _this10.$root.$refs.notification.success('administracao.perfilAcesso.sucesso.editado');
        } else {
          _this10.$root.$refs.notification.success('administracao.perfilAcesso.sucesso.criado');
        }
        _this10.profiles = response.data;
        _this10.$store.dispatch('setHasUnsavedChanges', false);
        _this10.$router.push(_routesMap2.default.LIST_ACCESS_PROFILE);
      }).catch(function (error) {
        _this10.$root.$refs.notification.error(error.message);
      }).finally(function () {
        _this10.requestSaveProfileSent = false;
      });
    },
    nextStep: function nextStep() {
      var _this11 = this;

      if (this.currentStep < 3) {
        this.$validator.validateAll().then(function (result) {
          if (result) {
            if (_this11.profile.visibility === '1') {
              _this11.currentStep = _this11.currentStep + 1;
            } else {
              _this11.currentStep = 3;
            }
          } else {
            _this11.$root.$refs.notification.error('administracao.perfilAcesso.validacao.camposObrigatorios', 'administracao.perfilAcesso.erro.criar');
          }
        });
      }
    },
    backStep: function backStep() {
      if (this.currentStep > 0) {
        if (this.profile.visibility === '1') {
          this.currentStep = this.currentStep - 1;
        } else {
          this.currentStep = 0;
        }
      }
    },
    back: function back() {
      this.$router.push(_routesMap2.default.LIST_ACCESS_PROFILE);
    }
  },

  created: function created() {
    this.loadData();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
    this.$store.dispatch('cleanProfileToEdit');
  }
};

/***/ }),
/* 879 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/administration/assignment/List.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _GridDetailsModal = __webpack_require__(/*! ../../../modals/gridDetailsModal/GridDetailsModal */ 196);

var _GridDetailsModal2 = _interopRequireDefault(_GridDetailsModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _transformationData = __webpack_require__(/*! ../../../../utils/transformationData.js */ 163);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _closeModal = __webpack_require__(/*! ../../../../events/closeModal */ 104);

var _closeModal2 = _interopRequireDefault(_closeModal);

var _idSituacaoTarefa = __webpack_require__(/*! ../../../../enum/idSituacaoTarefa */ 200);

var _idSituacaoTarefa2 = _interopRequireDefault(_idSituacaoTarefa);

var _tipoFiltroSituacaoTarefas = __webpack_require__(/*! ../../../../enum/tipoFiltroSituacaoTarefas */ 314);

var _tipoFiltroSituacaoTarefas2 = _interopRequireDefault(_tipoFiltroSituacaoTarefas);

var _funcionalidadeId = __webpack_require__(/*! ../../../../enum/funcionalidadeId */ 134);

var _funcionalidadeId2 = _interopRequireDefault(_funcionalidadeId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AssignmentList',

  components: {
    vSelect: _vueSelect2.default,
    GridDetailsModal: _GridDetailsModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    DateRange: _DateRange2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      defaultTab: 'gridDetailsModal-tabDetails',

      gridId: '#assignmentGrid',
      result: {},
      treeGridCfg: {},
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      showTreegrid: false,

      isOpenDetailsModal: false,
      queryBaseOptions: [{
        'id': 0,
        'label': this.$t('consultaTarefa.labels.todas'),
        'showDatePicker': false
      }, {
        'id': 1,
        'label': this.$t('consultaTarefa.labels.dataCriacao'),
        'showDatePicker': true
      }, {
        'id': 2,
        'label': this.$t('consultaTarefa.labels.dataVencimento'),
        'showDatePicker': true
      }, {
        'id': 3,
        'label': this.$t('consultaTarefa.labels.dataConclusao'),
        'showDatePicker': true
      }],
      showDate: false,

      filteredOriginOptions: [],
      originalOriginOptions: [{
        'label': this.$t('consultaTarefa.labels.MF'),
        'key': 'MF'
      }, {
        'label': this.$t('consultaTarefa.labels.CL'),
        'key': 'CL'
      }],

      situationList: [{
        id: _idSituacaoTarefa2.default.PENDENTE,
        nome: this.$t('consultaTarefa.labels.situacao.pendente'),
        checked: true
      }, {
        id: _idSituacaoTarefa2.default.EM_ANDAMENTO,
        nome: this.$t('consultaTarefa.labels.situacao.emAndamento'),
        checked: true
      }, {
        id: _idSituacaoTarefa2.default.AGUARDANDO,
        nome: this.$t('consultaTarefa.labels.situacao.aguardando'),
        checked: true
      }, {
        id: _idSituacaoTarefa2.default.CONCLUIDO,
        nome: this.$t('consultaTarefa.labels.situacao.concluido'),
        checked: true
      }, {
        id: _idSituacaoTarefa2.default.CANCELADO,
        nome: this.$t('consultaTarefa.labels.situacao.cancelado'),
        checked: true
      }],
      disableSearchButton: false,
      queryBaseSelected: {
        'id': 0,
        'label': this.$t('consultaTarefa.labels.todas'),
        'showDatePicker': false
      },
      typeLinkSelected: [],
      assignCheck: false,
      firstDate: new Date(),
      finalDate: new Date(),
      detailsObj: {
        establishtmentValue: {},
        mainValuesList: [],
        monetaryValuesList: [],
        statusValuesList: [],
        integrationValuesList: [],
        concSituation: null,
        idProcessamento: -1
      },
      modalId: '',
      modalDetailsTabs: [],
      finalDateDisable: new Date(),
      dateRange: {},
      modalTitle: null,
      modalSubTitle: null
    };
  },


  computed: {
    client: function client() {
      return this.$store.getters.client;
    },
    situationFilter: function situationFilter() {
      return this.$store.getters.situationFilter;
    }
  },

  methods: {
    showDatePicker: function showDatePicker(val) {
      (0, _analytics.trackAnalyticsEvent)(this, 'tarefas-select', 'base-consulta', val.label);

      if (val.id === 2) {
        this.finalDateDisable = null;
      } else {
        this.finalDateDisable = new Date();
        this.firstDate = new Date();
        this.finalDate = new Date();
      }
      this.showDate = val.showDatePicker;
      this.queryBaseSelected = val;
    },
    trackCheckBox: function trackCheckBox(event) {
      (0, _analytics.trackAnalyticsEvent)(this, 'tarefas-check-box', 'tarefas-atribuidas-a-mim', event.target.checked ? 'marcada' : 'desmarcada');
    },
    trackCheckBoxSituacao: function trackCheckBoxSituacao(nomeSituacao) {
      (0, _analytics.trackAnalyticsEvent)(this, 'tarefas-check-box', 'situacao-clicada', nomeSituacao);
    },
    trackOrigem: function trackOrigem(selectedOrigins) {
      this.filteredOriginOptions = _underscore2.default.difference(this.originalOriginOptions, selectedOrigins);
      if (selectedOrigins.length > 0) {
        var originsString = [];
        selectedOrigins.forEach(function (element) {
          originsString.push(element.label);
        });
        (0, _analytics.trackAnalyticsEvent)(this, 'tarefas-multi-select', 'origem-da-tarefa', originsString.toString());
      }
    },
    validate: function validate(event) {
      event.preventDefault();
      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (self.$refs.dateRange && !self.$refs.dateRange.validate()) {
            self.$root.$refs.notification.error('dateRange.validacao.dataInvalida');
            return;
          }
          self.showTreegrid = true;
          (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
          self.search();
        }
      });
    },
    search: function search() {
      var _this = this;

      var typeLinkAux = this.createArrayTypeLinkFilter();

      var situationListAux = this.createArraySituationListFilter();

      this.disableSearchButton = true;
      this.showTreegrid = true;
      (0, _gridLoadTransition.startTreeGridLoading)(this.gridId);

      var filter = {
        usuarioLogadoResponsavel: this.assignCheck,
        idUsuarioResponsavel: 0,
        inicio: this.showDate ? this.dateRange.fromDate : new Date('2000', '01', '01'),
        fim: this.showDate ? this.dateRange.toDate : new Date(),
        baseConsulta: this.queryBaseSelected.id,
        tiposVinculo: typeLinkAux,
        situacoes: situationListAux,
        lang: _index2.default.getCookieByName('language')
      };

      (0, _analytics.trackAnalyticsEvent)(this, 'tarefas-date-input', 'data-inicio', filter.inicio);
      (0, _analytics.trackAnalyticsEvent)(this, 'tarefas-date-input', 'data-fim', filter.fim);

      this.$store.dispatch('searchAssignment', filter).then(function (response) {
        window.DisposeGrids();
        _this.treeGridCfg = response.data.treegrid.Cfg.Layout;
        _this.result = response.data.treegrid;
        window.Grids.openAssignmentModal = function (row) {
          _this.prepareGridReactions(row);
        };
        (0, _gridLoadTransition.stopTreeGridLoading)(_this.gridId);
        _this.disableSearchButton = false;
      }).catch(function (error) {
        _this.$root.$refs.notification.error(error);
        (0, _gridLoadTransition.stopTreeGridLoading)(_this.gridId);
        _this.disableSearchButton = false;
      });

      if (this.situationFilter.fromDashboard) {
        this.dateRange.fromDate = new Date();
        this.dateRange.toDate = new Date();
        this.queryBaseSelected = this.queryBaseOptions.find(function (o) {
          return o.id === 0;
        });
      }
    },
    prepareGridReactions: function prepareGridReactions(row) {
      var _this2 = this;

      this.modalId = 'finMovGridModalIdMov-' + row.IdVinculo;
      this.defaultTab = 'gridDetailsModal-tabDetails';

      var obj = {};
      var funcTrasform = null;
      var funcTabs = null;

      if (row && row.TipoVinculo === 'MF') {
        obj.store = 'getFinancialMovByIdTask';
        obj.url = '/assignment/getFinancialMovByIdTask';
        obj.id = row.IdVinculo;
        obj.idTask = row.IdTarefa;
        funcTrasform = _transformationData.generateFinMovFromNode;
        funcTabs = this.generateModalTabsFinMov;
      } else if (row && row.TipoVinculo === 'CL') {
        obj.store = 'getAccountEntryByIdTask';
        obj.url = '/assignment/getAccountEntryByIdTask';
        obj.id = row.IdVinculo;
        obj.idTask = row.IdTarefa;
        funcTrasform = _transformationData.generateAccountEntryFromNode;
        funcTabs = this.generateModalTabsBankStat;
      }

      if (obj && obj.id) {
        this.$store.dispatch(obj.store, obj).then(function (response) {
          var data = null;
          data = response.data;
          if (data) {
            _this2.detailsObj = funcTrasform(data);
            funcTabs();
            setTimeout(function () {
              _this2.showDetailsModal();
              window.Grids[0].Disable();
            }, 100);
          } else {
            _this2.detailsObj = { idProcessamento: '-1' };
            _this2.generateModalTabTask(obj.idTask.toString());
            setTimeout(function () {
              _this2.showDetailsModal();
              window.Grids[0].Disable();
            }, 100);
          }
        });
      }
    },
    createArrayTypeLinkFilter: function createArrayTypeLinkFilter() {
      var typeLinkArray = [];
      if (this.typeLinkSelected && this.typeLinkSelected.length > 0) {
        this.typeLinkSelected.forEach(function (typeLink) {
          typeLinkArray.push(typeLink.key);
        });
      }
      return typeLinkArray;
    },
    createArraySituationListFilter: function createArraySituationListFilter() {
      var situationArray = [];
      if (this.situationList && this.situationList.length > 0) {
        this.situationList.forEach(function (situation) {
          if (situation.checked) {
            situationArray.push(situation.id);
          }
        });
      }
      return situationArray;
    },
    showDetailsModal: function showDetailsModal() {
      (0, _analytics.trackAnalyticsEvent)(this, 'tarefas-open-click', 'open-modal-detalhes-tarefas', 'open-modal-detalhes-tarefas');
      this.isOpenDetailsModal = true;
    },
    closeDetailsModal: function closeDetailsModal() {
      this.isOpenDetailsModal = false;
    },
    generateModalTabsFinMov: function generateModalTabsFinMov() {
      var tabs = [];
      this.modalDetailsTabs = [];

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          establishtmentValue: this.detailsObj.establishtmentValue,
          mainValuesList: this.detailsObj.mainValuesList,
          statusValuesList: this.detailsObj.statusValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList,
          commentary: this.detailsObj.commentary
        }
      });

      if (this.detailsObj.idProcessamento) {
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            establishtmentValue: this.detailsObj.establishtmentValue,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        });
      }

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.findFinancialMovementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value
        }
      });

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabAllotment',
        idTabContent: 'tab-allotment-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadAllotmentGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabLote'),
        icon: 'tab-icon-font fa fa-cubes',
        type: 'TabAllotment',
        props: {
          getAllotment: this.findFinancialMovementAllotment,
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: 'MovFin'
        }
      });

      tabs.push({
        idFunctionalitie: _funcionalidadeId2.default.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: 'MovFin',
          statusMovimento: this.detailsObj.concSituation,
          idTarefa: null
        }
      });
      this.modalTitle = 'modalDetalhesLanc.titulos.titulo';
      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtitulo';
      this.modalDetailsTabs = tabs;
    },
    generateModalTabsBankStat: function generateModalTabsBankStat() {
      var tabs = [];
      this.modalDetailsTabs = [];

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          mainValuesList: this.detailsObj.mainValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList
        }
      });

      if (this.detailsObj.idProcessamento) {
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        });
      }

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.findBankStatementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value
        }
      });

      tabs.push({
        idFunctionalitie: _funcionalidadeId2.default.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: 'MovBan',
          idTarefa: null
        }
      });
      this.modalTitle = 'modalDetalhesLanc.titulos.titulo';
      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtitulo';
      this.modalDetailsTabs = tabs;
    },
    generateModalTabTask: function generateModalTabTask(idTask) {
      var tabs = [];
      this.modalDetailsTabs = [];

      tabs.push({
        idFunctionalitie: _funcionalidadeId2.default.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTask',
        idTabContent: 'tab-tasks-id',

        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idTarefa: idTask,
          idMovimento: this.detailsObj.idProcessamento.toString()
        }
      });
      this.modalTitle = 'modalDetalhesLanc.titulos.tituloTarefas';
      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtituloTarefas';
      this.modalDetailsTabs = tabs;
    },
    findFinancialMovementHistory: function findFinancialMovementHistory(id) {
      var data = {
        idFinancialMovement: id,
        url: '/financialMovements/history'
      };
      return this.$store.dispatch('getHistoricFinancialMovement', data);
    },
    findBankStatementHistory: function findBankStatementHistory(id) {
      var data = {
        idBankStat: id,
        url: '/bankStatement/history'
      };
      return this.$store.dispatch('getHistoricBankStat', data);
    },
    findFinancialMovementAllotment: function findFinancialMovementAllotment(id) {
      var data = {
        idFinancialMovement: id,
        url: '/assignment/financialMovements/getAllotmentByMovFinId'
      };
      return this.$store.dispatch('getAllotmentByMovementId', data);
    },
    findIntegration: function findIntegration(id) {
      var data = {
        idProcessamento: id,
        url: '/assignment/getProcessedFilesById'
      };
      return this.$store.dispatch('getProcessedFiles', data);
    },
    loadModalFromEmailLink: function loadModalFromEmailLink(tarefaId) {
      var _this3 = this;

      this.$store.dispatch('searchTaskBoundType', tarefaId).then(function (response) {
        if (response.status !== 401) {
          if (!response.data || response.data === '') {
            _this3.$root.$refs.notification.warning('consultaTarefa.labels.tarefaNãoEncontrada');
          } else if (response.data.cliente !== _this3.client) {
            _this3.$root.$refs.notification.warning('consultaTarefa.labels.tarefaOutroCliente');
          } else {
            _this3.prepareGridReactions(response.data);
            _this3.defaultTab = 'gridDetailsModal-tabTasks';
            _this3.search();
          }
          _this3.disableSearchButton = false;
        }
      }).catch(function (error) {
        _this3.$root.$refs.notification.error(error);
        _this3.disableSearchButton = false;
      });
    },
    searchCompletedTasks: function searchCompletedTasks() {
      this.assignCheck = true;

      this.showTreegrid = true;
      (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
      this.search();

      this.$store.dispatch('clearFilterTaskList');
    },
    searchOverdueAndPendingTasks: function searchOverdueAndPendingTasks(dateFirstDue) {
      this.assignCheck = true;
      this.queryBaseSelected = this.queryBaseOptions.find(function (o) {
        return o.id === 2;
      });
      this.dateRange.fromDate = new Date(dateFirstDue);
      this.firstDate = this.dateRange.fromDate;
      this.dateRange.toDate = new Date();

      this.showTreegrid = true;
      (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
      this.search();

      this.$store.dispatch('clearFilterTaskList');
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    this.filteredOriginOptions = [].concat((0, _toConsumableArray3.default)(this.originalOriginOptions));
    var tarefaId = this.$route.query.tarefa;
    if (tarefaId) {
      this.loadModalFromEmailLink(tarefaId);
    }

    _closeModal2.default.$on('modalDetailsClose', function (flag) {
      if (flag) {
        _this4.showTreegrid = true;
        (0, _gridLoadTransition.startTreeGridLoading)(_this4.gridId);
        _this4.search();

        _closeModal2.default.$emit('taskChange', false);
      }
    });

    if (this.situationFilter && this.situationFilter.type && this.situationFilter.arraySituations && this.situationFilter.arraySituations.length > 0) {
      this.situationList.forEach(function (sit) {
        sit.checked = false;
      });

      this.situationFilter.arraySituations.forEach(function (sitFilter) {
        var situation = _underscore2.default.findWhere(_this4.situationList, { id: sitFilter });
        situation.checked = true;
      });

      if (this.situationFilter.type === _tipoFiltroSituacaoTarefas2.default.NC) {
        this.searchOverdueAndPendingTasks(this.situationFilter.dateFirstDue);
      } else if (this.situationFilter.type === _tipoFiltroSituacaoTarefas2.default.C) {
        this.searchCompletedTasks();
      }
    }
  }
};

/***/ }),
/* 880 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/administration/auditLog/AuditLog.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _AuditModal = __webpack_require__(/*! ../../../administration/auditLog/AuditModal */ 1255);

var _AuditModal2 = _interopRequireDefault(_AuditModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AuditLog',

  components: {
    MultiSelectModal: _MultiSelectModal2.default,
    AuditModal: _AuditModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      gridId: '#auditLogGrid',
      isAdvancedSearch: true,
      OPERATORS_MODAL: 'operatorsModal',
      ENTITIES_MODAL: 'entitiesModal',
      FUNCTIONALITIES_MODAL: 'functionalitiesModal',
      audit: {},
      dateRange: {},
      list: [],
      selectedList: [],
      selectModal: null,
      allItensSelected: null,
      operatorsSelected: [],
      operatorsTags: [this.$t('inputTag.labels.todos')],
      functionalitiesSelected: [],
      functionalitiesTags: [this.$t('inputTag.labels.todos')],
      entitiesSelected: [],
      entitiesTags: [this.$t('inputTag.labels.todos')],
      customId: 'id',
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'LogDeAuditoria',
      dataTableColumns: [],
      disableSearchButton: false,
      firstTimeOp: true,
      firstTimeFunc: true,
      firstTimeEnt: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      selectDataTableCustomSetOrder: null,
      customTagMap: null,
      rowId: null,
      filterable: ['nome', 'email', 'nomeFuncionalidade', 'numeroEntidade', 'descricao'],
      data: this.setDataValues(),
      inputTagsProps: {
        operators: {
          id: 'id',
          name: 'nome'
        },
        functionalities: {
          id: 'idFuncionalidade',
          name: 'nomeFuncionalidade'
        },
        entities: {
          id: 'numeroEntidade',
          name: 'numeroEntidade'
        }
      },
      shown: {
        operators: false,
        functionalities: false,
        entities: false
      },
      defaultTags: {
        operators: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        functionalities: [{
          idFuncionalidade: '-1',
          nomeFuncionalidade: this.$t('inputTag.labels.todos')
        }],
        entities: [{
          numeroEntidade: this.$t('inputTag.labels.todos'),
          descricao: this.$t('inputTag.labels.todos')
        }]
      }
    };
  },


  methods: {
    setDataValues: function setDataValues() {
      var data = {
        operators: this.setOperatorsData(),
        functionalities: this.setFunctionalitiesData(),
        entities: this.setEntitiesData()
      };
      return data;
    },
    setEntitiesData: function setEntitiesData() {
      return {
        titles: {
          main: this.$t('logDeAuditoria.labels.entidades'),
          sub: this.$t('logDeAuditoria.labels.selecionarEntidades')
        },
        selectedItems: [],
        columns: ['numeroEntidade', 'descricao'],
        values: [],
        options: {
          columnsClasses: { numeroEntidade: 'col-md-4', descricao: 'col-md-8' },
          perPage: 5,
          headings: {
            numeroEntidade: this.$t('logDeAuditoria.labels.entidade'),
            descricao: this.$t('logDeAuditoria.labels.descricao')
          },
          filterable: ['numeroEntidade', 'descricao'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['numeroEntidade', 'descricao'],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'numeroEntidade'
          },
          customSorting: {
            numeroEntidade: function numeroEntidade(asc) {
              return function (a, b) {
                if (asc) {
                  return a.numeroEntidade.toLowerCase().localeCompare(b.numeroEntidade.toLowerCase());
                }
                return b.numeroEntidade.toLowerCase().localeCompare(a.numeroEntidade.toLowerCase());
              };
            },
            descricao: function descricao(asc) {
              return function (a, b) {
                if (asc) {
                  return a.descricao.toLowerCase().localeCompare(b.descricao.toLowerCase());
                }
                return b.descricao.toLowerCase().localeCompare(a.descricao.toLowerCase());
              };
            }
          }
        }
      };
    },
    setOperatorsData: function setOperatorsData() {
      return {
        titles: {
          main: this.$t('logDeAuditoria.labels.operadores'),
          sub: this.$t('logDeAuditoria.labels.selecionarOperador')
        },
        selectedItems: [],
        columns: ['nome', 'email'],
        values: [],
        options: {
          columnsClasses: { nome: 'col-md-7', email: 'col-md-5' },
          perPage: 5,
          headings: {
            nome: this.$t('administracao.operadores.labels.nome'),
            email: this.$t('administracao.operadores.labels.email')
          },
          filterable: ['nome', 'email'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['nome', 'email'],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'nome'
          },
          customSorting: {
            nome: function nome(asc) {
              return function (a, b) {
                if (asc) {
                  return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                }
                return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
              };
            },
            email: function email(asc) {
              return function (a, b) {
                if (asc) {
                  return a.email.toLowerCase().localeCompare(b.email.toLowerCase());
                }
                return b.email.toLowerCase().localeCompare(a.email.toLowerCase());
              };
            }
          }
        }
      };
    },
    setFunctionalitiesData: function setFunctionalitiesData() {
      return {
        titles: {
          main: this.$t('logDeAuditoria.labels.funcionalidades'),
          sub: this.$t('logDeAuditoria.labels.selecionarFuncionalidades')
        },
        selectedItems: [],
        columns: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],
        values: [],
        options: {
          columnsClasses: { nomeFuncionalidade: 'col-md-7', grupoFuncionalidade: 'col-md-5' },
          perPage: 5,
          headings: {
            nomeFuncionalidade: this.$t('administracao.operadores.labels.nome'),
            nomeGrupoFuncionalidade: this.$t('administracao.perfilAcesso.labels.grupoFuncionalidade')
          },
          filterable: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'nomeGrupoFuncionalidade'
          },
          customSorting: {
            nomeFuncionalidade: function nomeFuncionalidade(asc) {
              return function (a, b) {
                if (asc) {
                  return a.nomeFuncionalidade.toLowerCase().localeCompare(b.nomeFuncionalidade.toLowerCase());
                }
                return b.nomeFuncionalidade.toLowerCase().localeCompare(a.nomeFuncionalidade.toLowerCase());
              };
            }
          }
        }
      };
    },
    validate: function validate() {
      var _this = this;

      var self = this;
      return new _promise2.default(function (resolve) {
        _this.$validator.validateAll().then(function (result) {
          if (result && _this.$refs.dateRange.validate()) {
            _this.showTreegrid = true;
            (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
            _this.search().finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    resetFilter: function resetFilter() {
      this.filter.entityId = null;
      this.data.operators.selectedItems = [];
      this.data.functionalities.selectedItems = [];
      this.data.entities.selectedItems = [];
    },
    search: function search() {
      var _this2 = this;

      this.disableSearchButton = true;
      var inicio = this.dateRange.fromDate;
      var fim = this.dateRange.toDate;

      var filter = {
        inicio: inicio,
        fim: fim,
        idEntidadeDoSistema: this.filter.entityId,
        idsOperadores: this.data.operators.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (operator) {
          return operator !== '-1';
        }),
        idsFuncionalidades: this.data.functionalities.selectedItems.map(function (selected) {
          return selected.idFuncionalidade;
        }).filter(function (functionality) {
          return functionality !== '-1';
        }),
        idsEntidades: this.data.entities.selectedItems.map(function (selected) {
          return selected.numeroEntidade;
        }).filter(function (entity) {
          return entity !== _this2.$t('inputTag.labels.todos');
        })
      };

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/auditLog/audits', { filter: filter }).then(function (response) {
          window.DisposeGrids();
          _this2.result = response.data;
          window.Grids.abrirModalAuditoria = function (row) {
            _this2.$store.dispatch('getAudit', row.Id).then(function (response) {
              _this2.audit = response.data;
              $('#auditModal').modal();
            });
          };
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this2.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          reject();
        });
      });
    },
    openSelectOperatorsModal: function openSelectOperatorsModal() {
      var _this3 = this;

      if (this.data.operators.values.length > 0) {
        this.shown.operators = true;
        return;
      }
      this.$store.dispatch('getOperators', '/auditLog/operator').then(function (response) {
        _this3.data.operators.values = response.data;
        _this3.shown.operators = true;
      });
    },
    openSelectFunctionalitiesModal: function openSelectFunctionalitiesModal() {
      var _this4 = this;

      if (this.data.functionalities.values.length > 0) {
        this.shown.functionalities = true;
        return;
      }
      this.$store.dispatch('getFunctionalitiesGroups', '/auditLog/functionalitiesGroups').then(function (response) {
        _this4.data.functionalities.values = response.data.map(function (gf) {
          gf.funcionalidades.forEach(function (f) {
            f.idFuncionalidade = f.id;
            f.nomeFuncionalidade = f.nome;
            f.nomeGrupoFuncionalidade = gf.nome;
          });
          return gf.funcionalidades;
        }).flat();
        _this4.shown.functionalities = true;
      });
    },
    openSelectEntitiesModal: function openSelectEntitiesModal() {
      var _this5 = this;

      if (this.data.entities.values.length > 0) {
        this.shown.entities = true;
        return;
      }
      this.$store.dispatch('getEntities').then(function (response) {
        _this5.data.entities.values = response.data.data.map(function (entity) {
          if (entity.numeroEntidade === 'AtributoConfig') {
            entity.numeroEntidade = 'Atributo';
          }
          return entity;
        });
        _this5.shown.entities = true;
      });
    },
    openModal: function openModal() {
      $('#selectModal').modal({ backdrop: 'static', keyboard: false });
    },
    closeModal: function closeModal() {
      this.shown.operators = false;
      this.shown.functionalities = false;
      this.shown.entities = false;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 881 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/administration/operator/List.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vueTables = __webpack_require__(/*! vue-tables-2 */ 132);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _customFilters = __webpack_require__(/*! ../../../../utils/customFilters.js */ 135);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templatesWhenIsLoaded = {
  nomePerfilAcesso: function nomePerfilAcesso(h, row) {
    return row.perfilAcesso ? row.perfilAcesso.nomePerfilAcesso : '-';
  },
  situacao: function situacao(h, row) {
    return row.ativo ? 'Ativo' : 'Inativo';
  }
};

exports.default = {
  name: 'OperatorList',

  components: {
    PageTitle: _PageTitle2.default,
    LoadingPlaceholder: _LoadingPlaceholder2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      isLoadingData: true,
      loggedUserProfileId: this.$store.getters.accessProfileId,
      operators: (0, _gridLoadTransition.generateLoadingRows)(10),
      columns: ['nome', 'email', 'nomePerfilAcesso', 'situacao', 'acoes'],
      options: {
        columnsClasses: { nome: 'col-md-4', email: 'col-md-3', situacao: 'col-md-2', acoes: 'col-md-1', nomePerfilAcesso: 'col-md-2' },
        headings: {
          nome: this.$t('administracao.operadores.labels.nome'),
          nomePerfilAcesso: this.$t('administracao.perfilAcesso.labels.perfil'),
          email: this.$t('administracao.operadores.labels.email'),
          acoes: this.$t('administracao.perfilAcesso.labels.acoes'),
          situacao: this.$t('administracao.operadores.labels.situacao')
        },
        filterable: ['nome'],
        customFilters: [{
          name: 'situacao',
          callback: _customFilters.filterBySituation
        }, {
          name: 'nomePerfilAcesso',
          callback: _customFilters.filterByAccessProfileName
        }, {
          name: 'email',
          callback: _customFilters.filterByEmail
        }],
        filterByColumn: true,
        perPageValues: [],
        templates: {
          nome: _LoadingPlaceholder2.default,
          email: _LoadingPlaceholder2.default,
          situacao: _LoadingPlaceholder2.default,
          acoes: _LoadingPlaceholder2.default,
          nomePerfilAcesso: _LoadingPlaceholder2.default
        },
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortable: ['nome', 'email', 'nomePerfilAcesso', 'situacao'],
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 },
        orderBy: {
          ascending: true,
          column: 'nome'
        },
        customSorting: {
          nome: function nome(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'nome');
            };
          },
          nomePerfilAcesso: function nomePerfilAcesso(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'nomePerfilAcesso');
            };
          },
          situacao: function situacao(ascending) {
            return function (a, b) {
              return _customSorter2.default.booleanSorter(ascending, a, b, 'ativo');
            };
          }
        }
      }
    };
  },


  methods: {
    handleFilter: function handleFilter(event, column) {
      _vueTables.Event.$emit('vue-tables.filter::' + column, event.currentTarget.value);
    },
    canEditOperator: function canEditOperator() {
      var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { id: null };

      return this.loggedUserProfileId && this.loggedUserProfileId.toString() === '2' || profile.id && profile.id.toString() !== '2';
    },
    edit: function edit(userId) {
      var _this = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'edit-click', 'edit-operador', 'edit-operador');

      this.$store.dispatch('setOperatorToEdit', userId).then(function (response) {
        _this.$router.push(_routesMap2.default.NEW_OPERATOR);
      });
    },
    newProfile: function newProfile() {
      this.$router.push(_routesMap2.default.NEW_OPERATOR);
    },
    loadOperators: function loadOperators() {
      var _this2 = this;

      var url = 'operator';
      this.$store.dispatch('getOperators', url).then(function (response) {
        _this2.operators = response.data.map(function (operator) {
          operator.perfilAcesso = (0, _assign2.default)({}, operator.perfilAcesso, { nomePerfilAcesso: operator.perfilAcesso.nome });
          return operator;
        }).flat();
        _this2.isLoadingData = false;
        _this2.options.templates = templatesWhenIsLoaded;
      });
    }
  },

  created: function created() {
    this.loadOperators();
  }
};

/***/ }),
/* 882 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/administration/operator/New.vue ***!
  \*****************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _perfilAcessoEnum = __webpack_require__(/*! ../../../../enum/perfilAcessoEnum */ 201);

var _perfilAcessoEnum2 = _interopRequireDefault(_perfilAcessoEnum);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OperatorNew',

  components: {
    vSelect: _vueSelect2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      requestSent: false,
      operator: {
        name: '',
        email: '',
        status: null,
        accessProfile: {
          id: '',
          nome: ''
        }
      },
      profiles: [],
      loggedUserProfileId: this.$store.getters.accessProfileId
    };
  },


  computed: {
    operatorToEdit: function operatorToEdit() {
      return this.$store.getters.operatorToEditId;
    },
    profileList: function profileList() {
      return _underscore2.default.sortBy(this.profiles, function (item) {
        return _customSorter2.default.cleanLowerString(item.nome);
      }, 'asc');
    },
    filterPortletTitle: function filterPortletTitle() {
      return this.operatorToEdit ? this.$t('administracao.operadores.labels.editarOperador') : this.$t('administracao.operadores.labels.novoOperador');
    }
  },

  watch: {
    operator: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, this.operator));
      },

      deep: true
    }
  },

  methods: {
    isMasterProfile: function isMasterProfile() {
      return Number(this.loggedUserProfileId) === _perfilAcessoEnum2.default.MASTER;
    },
    setOperatorProfile: function setOperatorProfile(val) {
      if (val) {
        if (!this.operator.accessProfile) this.operator.accessProfile = {};
        this.operator.accessProfile.id = val.id;
        this.operator.accessProfile.nome = val.nome;
      } else {
        this.operator.accessProfile = null;
      }
    },
    loadProfiles: function loadProfiles() {
      var _this = this;

      var url = 'operator/operatorsProfiles';
      this.$store.dispatch('getOperatorProfiles', url).then(function (response) {
        _this.profiles = _this.isMasterProfile() ? response.data : response.data.filter(function (item) {
          return item.id.toString() !== '2';
        });
        if (_this.operatorToEdit) {
          _this.loadOperator();
        } else {
          _this.defaultObject = (0, _assign2.default)({}, _this.operator, { accessProfile: (0, _assign2.default)({}, _this.operator.accessProfile) });
        }
      });
    },
    newOperator: function newOperator() {
      var _this2 = this;

      this.operator.operatorId = this.operatorToEdit;
      var oper = {
        accessProfileId: this.operator.accessProfile.id,
        email: this.operator.email,
        name: this.operator.name,
        operatorId: this.operator.operatorId,
        sex: '',
        status: this.operator.status,
        url: 'http://' + window.location.host + '/banking/'
      };

      this.requestSent = true;
      this.$store.dispatch('newOperator', oper).then(function (response) {
        _this2.$root.$refs.notification.success(response.data);
        (0, _analytics.trackAnalyticsEvent)(_this2, 'perfil-de-acesso', 'perfil-de-acesso-escolhido', oper.accessProfileId);
        _this2.$store.dispatch('setHasUnsavedChanges', false);
        _this2.$router.push(_routesMap2.default.LIST_OPERATORS);
      }).catch(function (error) {
        _this2.$root.$refs.notification.error(error.message);
      }).finally(function () {
        _this2.requestSent = false;
      });
    },
    loadOperator: function loadOperator() {
      var _this3 = this;

      this.$store.dispatch('getOperator', this.operatorToEdit).then(function (response) {
        _this3.operator = {
          name: response.data.name,
          email: response.data.email,
          status: response.data.ativo,
          accessProfile: {
            id: response.data.perfilAcesso.id,
            nome: response.data.perfilAcesso.nome
          }
        };
        _this3.defaultObject = (0, _assign2.default)({}, _this3.operator, { accessProfile: (0, _assign2.default)({}, _this3.operator.accessProfile) });
      });
    },
    validate: function validate(event) {
      var _this4 = this;

      event.preventDefault();
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this4.newOperator();
        } else {
          _this4.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'administracao.operadores.erro.criar');
        }
      });
    },
    back: function back() {
      this.$router.push(_routesMap2.default.LIST_OPERATORS);
    }
  },

  created: function created() {
    this.loadProfiles();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
    this.$store.dispatch('cleanOperatorToEdit');
  }
};

/***/ }),
/* 883 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/home/Home.vue ***!
  \***********************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopBar = __webpack_require__(/*! ../../layout/menu/TopBar */ 1279);

var _TopBar2 = _interopRequireDefault(_TopBar);

var _SidebarMenu = __webpack_require__(/*! ../../layout/menu/SidebarMenu */ 1277);

var _SidebarMenu2 = _interopRequireDefault(_SidebarMenu);

var _ClientModal = __webpack_require__(/*! ../../modals/clientModal/ClientModal */ 1282);

var _ClientModal2 = _interopRequireDefault(_ClientModal);

var _MyAccountModal = __webpack_require__(/*! ../../modals/myAccountModal/MyAccountModal */ 1290);

var _MyAccountModal2 = _interopRequireDefault(_MyAccountModal);

var _ChangeApplicationModal = __webpack_require__(/*! ../../modals/changeApplicationModal/ChangeApplicationModal */ 1281);

var _ChangeApplicationModal2 = _interopRequireDefault(_ChangeApplicationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Home',

  components: {
    TopBar: _TopBar2.default,
    SidebarMenu: _SidebarMenu2.default,
    ClientModal: _ClientModal2.default,
    MyAccountModal: _MyAccountModal2.default,
    ChangeApplicationModal: _ChangeApplicationModal2.default
  }
};

/***/ }),
/* 884 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/index/Index.vue ***!
  \*************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vuedraggable = __webpack_require__(/*! vuedraggable */ 197);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _Dashboard = __webpack_require__(/*! ../../dashboard/Dashboard */ 1261);

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _config = __webpack_require__(/*! ./config */ 744);

var _index = __webpack_require__(/*! ../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _graficoId = __webpack_require__(/*! ../../../enum/graficoId */ 103);

var _graficoId2 = _interopRequireDefault(_graficoId);

var _filtroPeriodo = __webpack_require__(/*! ../../../enum/filtroPeriodo */ 199);

var _filtroPeriodo2 = _interopRequireDefault(_filtroPeriodo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Index',

  components: {
    vSelect: _vueSelect2.default,
    Draggable: _vuedraggable2.default,
    Dashboard: _Dashboard2.default
  },

  data: function data() {
    return {
      doneLoading: false,
      clientId: null,
      windowWidth: null,
      minWindowWidth: 1024,
      itermedWindowWidth: 1320,
      intervalLoadGadgets: null,
      isLoadingGadgets: false,
      view: false,
      gadgets: [],
      charts: (0, _config.getCharts)(),
      dashboardCharts: [],
      hasPendingRequest: false,
      canLoad: {
        ChartConciliationSituationSummary: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataConciliationSituationSummary,
          currentRequest: null
        },
        DailyBankStatment: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataDailyBankStatment,
          currentRequest: null
        },
        ChartAllotmentDistributionConciliation: {
          state: false,
          alreadyLoaded: false,
          load: this.loadBatchReconciliationDistribution,
          currentRequest: null
        },
        GadgetTasks: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataTasks,
          currentRequest: null
        },
        ChartFinancialSummary: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataFinancialSummary,
          currentRequest: null
        },
        DigitalWalletBalance: {
          state: false,
          alreadyLoaded: false,
          load: this.loadDataDigitalWalletBalance,
          currentRequest: null
        }
      }
    };
  },


  computed: {
    client: function client() {
      return this.$store.getters.client;
    },
    allowedFuncionalities: function allowedFuncionalities() {
      return this.$store.getters.allowedFuncionalities;
    },
    isLoadingDataGeneral: function isLoadingDataGeneral() {
      return this.$store.getters.isLoadingData;
    },
    availableGadgets: function availableGadgets() {
      return this.$store.getters.availableGadgets;
    },
    periodFilterConcSitSummary: function periodFilterConcSitSummary() {
      return this.$store.getters.periodFilterConcSitSummary;
    },
    planSelectedFilterConcSitSummary: function planSelectedFilterConcSitSummary() {
      return this.$store.getters.planSelectedFilterConcSitSummary;
    },
    typeFilterConcSituationSummary: function typeFilterConcSituationSummary() {
      return this.$store.getters.typeFilterConcSituationSummary;
    },
    mainCategorySelectedFilterConcSitSummary: function mainCategorySelectedFilterConcSitSummary() {
      return this.$store.getters.mainCategorySelectedFilterConcSitSummary;
    },
    periodFilterAllotmentDistribution: function periodFilterAllotmentDistribution() {
      return this.$store.getters.periodFilterAllotmentDistribution;
    },
    planSelectedFilterBatch: function planSelectedFilterBatch() {
      return this.$store.getters.planSelectedFilterBatch;
    },
    typeSelectedFilterBatch: function typeSelectedFilterBatch() {
      return this.$store.getters.typeSelectedFilterBatch;
    },
    mainCategorySelectedFilterBatch: function mainCategorySelectedFilterBatch() {
      return this.$store.getters.mainCategorySelectedFilterBatch;
    },
    periodFilterFinancialSummary: function periodFilterFinancialSummary() {
      return this.$store.getters.periodFilterFinancialSummary;
    },
    mainCategorySelectedFilterFinancialSummary: function mainCategorySelectedFilterFinancialSummary() {
      return this.$store.getters.mainCategorySelectedFilterFinancialSummary;
    },
    periodFilterBankBalance: function periodFilterBankBalance() {
      return this.$store.getters.periodFilterBankBalance;
    },
    accountSelectedBankBalance: function accountSelectedBankBalance() {
      return this.$store.getters.accountSelectedBankBalance;
    },
    periodFilterDigitalWalletBalance: function periodFilterDigitalWalletBalance() {
      return this.$store.getters.periodFilterDigitalWalletBalance;
    },
    categorySelectedDigitalWalletBalance: function categorySelectedDigitalWalletBalance() {
      return this.$store.getters.categorySelectedDigitalWalletBalance;
    }
  },

  watch: {
    client: function client() {
      this.loadHome();
    },


    canLoad: {
      handler: function handler() {
        for (var key in this.canLoad) {
          if (this.canLoad[key].alreadyLoaded) {
            continue;
          }
          if (this.canLoad[key].state) {
            this.canLoad[key].load();
          } else {
            this.stopLoadingGadget(key);
          }
        }
      },

      deep: true
    },

    periodFilterConcSitSummary: {
      handler: function handler(newVal, oldVal) {
        var isNewisNewLoading = newVal.id !== oldVal.id || newVal.id === _filtroPeriodo2.default.PERSONALIZADO && (newVal.fromDate !== oldVal.fromDate || newVal.toDate !== oldVal.toDate);
        this.handleConciliationSituationSummary(!isNewisNewLoading);
      },

      deep: true
    },

    planSelectedFilterConcSitSummary: {
      handler: function handler(newVal, oldVal) {
        this.handleConciliationSituationSummary(newVal.id === oldVal.id);
      },

      deep: true
    },

    typeFilterConcSituationSummary: {
      handler: function handler(newVal, oldVal) {
        this.handleConciliationSituationSummary(newVal.id === oldVal.id);
      },

      deep: true
    },

    mainCategorySelectedFilterConcSitSummary: {
      handler: function handler(newVal, oldVal) {
        this.handleConciliationSituationSummary(newVal.id === oldVal.id);
      },

      deep: true
    },

    periodFilterAllotmentDistribution: {
      handler: function handler(newVal, oldVal) {
        var isNewisNewLoading = newVal.id !== oldVal.id || newVal.id === _filtroPeriodo2.default.PERSONALIZADO && (newVal.fromDate !== oldVal.fromDate || newVal.toDate !== oldVal.toDate);
        this.handleReconciliationDistribution(!isNewisNewLoading);
      },

      deep: true
    },

    planSelectedFilterBatch: {
      handler: function handler(newVal, oldVal) {
        this.handleReconciliationDistribution(newVal.id === oldVal.id);
      },

      deep: true
    },

    typeSelectedFilterBatch: {
      handler: function handler(newVal, oldVal) {
        this.handleReconciliationDistribution(newVal.id === oldVal.id);
      },

      deep: true
    },

    mainCategorySelectedFilterBatch: {
      handler: function handler(newVal, oldVal) {
        this.handleReconciliationDistribution(newVal.id === oldVal.id);
      },

      deep: true
    },

    periodFilterFinancialSummary: {
      handler: function handler(newVal, oldVal) {
        var currentRequest = this.canLoad.ChartFinancialSummary.currentRequest;
        var isNewLoading = true;
        if (currentRequest) {
          if (currentRequest.periodo === newVal.id && newVal.id === _filtroPeriodo2.default.PERSONALIZADO) {
            if (newVal.fromDate !== currentRequest.dataInicio || newVal.toDate !== currentRequest.dataFim) {
              this.canLoad.ChartFinancialSummary.currentRequest = null;
            } else {
              isNewLoading = false;
            }
          } else if (currentRequest.periodo === newVal.id) {
            return;
          } else {
            this.canLoad.ChartFinancialSummary.currentRequest = null;
          }
        }
        this.canLoad.ChartFinancialSummary.alreadyLoaded = !isNewLoading;
        this.canLoad.ChartFinancialSummary.state = this.periodFilterFinancialSummary && this.periodFilterFinancialSummary.id;
      },

      deep: true
    },

    mainCategorySelectedFilterFinancialSummary: {
      handler: function handler(newVal, oldVal) {
        this.handleFinancialSummary(newVal.id === oldVal.id);
      },

      deep: true
    },

    periodFilterBankBalance: {
      handler: function handler(newVal, oldVal) {
        var isNewisNewLoading = newVal.id !== oldVal.id || newVal.id === _filtroPeriodo2.default.PERSONALIZADO && (newVal.fromDate !== oldVal.fromDate || newVal.toDate !== oldVal.toDate);
        this.handleBankBalance(!isNewisNewLoading);
      },

      deep: true
    },

    accountSelectedBankBalance: {
      handler: function handler(newVal, oldVal) {
        this.handleBankBalance(newVal.id === oldVal.id);
      },

      deep: true
    },

    periodFilterDigitalWalletBalance: {
      handler: function handler(newVal, oldVal) {
        var isNewisNewLoading = newVal.id !== oldVal.id || newVal.id === _filtroPeriodo2.default.PERSONALIZADO && (newVal.fromDate !== oldVal.fromDate || newVal.toDate !== oldVal.toDate);
        this.handleDigitalWalletBalance(!isNewisNewLoading);
      },

      deep: true
    },

    categorySelectedDigitalWalletBalance: {
      handler: function handler(newVal, oldVal) {
        this.handleDigitalWalletBalance(newVal.id === oldVal.id);
      },

      deep: true
    }
  },

  methods: {
    loadHome: function loadHome() {
      var _this = this;

      this.resetGadgets();
      this.hasPendingRequest = true;
      this.$store.dispatch('loadingData').then(function () {
        _this.loadGadgets().then(function () {
          _this.canLoad.GadgetTasks.state = true;
          _this.hasPendingRequest = false;
          _this.$store.dispatch('dataLoaded');
        });
      });
    },
    loadGadgets: function loadGadgets() {
      var _this2 = this;

      var self = this;
      return new _promise2.default(function (resolve, reject) {
        _promise2.default.all([_this2.loadPlans(), _this2.loadMainCategories()]).then(function () {
          self.$store.dispatch('getGadgets').then(function (response) {
            self.handleGadgetsChange();
            resolve();
          }).catch(function () {
            self.gadgets = [];
            self.view = false;
            reject();
          });
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleGadgetsChange: function handleGadgetsChange() {
      var _this3 = this;

      this.view = false;
      this.windowWidth = window.innerWidth;

      this.dashboardCharts = [];

      if (!this.intervalLoadGadgets) {
        this.intervalLoadGadgets = setInterval(function () {
          if (!this.hasPendingRequest && this.allowedFuncionalities && this.allowedFuncionalities.length > 0) {
            this.loadHome();
          }
        }.bind(this), 600000);
      }

      var _loop = function _loop(gadget) {
        var idGadget = gadget.funcionalidade.idFuncionalidade;
        var container = null;
        var order = null;

        if (gadget && gadget.gadgetParam && gadget.gadgetParam.length > 0) {
          container = Number(gadget.gadgetParam.find(function (param) {
            return param.nome === 'container';
          }).valor);

          order = gadget.gadgetParam.find(function (param) {
            return param.nome === 'ordemExibicao';
          }).valor;
        }

        var index = _this3.charts.findIndex(function (chart) {
          return chart.idChart === idGadget;
        });
        if (index === -1) {
          return 'continue';
        }
        var chartFound = _this3.charts[index];
        chartFound.container = container === 1 ? 'chartFull' : 'chartMiddle';
        chartFound.order = Number(order);

        _this3.dashboardCharts.push(chartFound);
        _this3.canLoad[chartFound.idChartTemplate].state = true;
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.availableGadgets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var gadget = _step.value;

          var _ret = _loop(gadget);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.dashboardCharts.sort(function (a, b) {
        return a.order - b.order;
      });
      this.doneLoading = true;
      this.view = this.availableGadgets.length > 0;
      this.$store.dispatch('setDashboardDateFilter', {
        id: _filtroPeriodo2.default.ULTIMOS_TRINTA_DIAS,
        label: this.$t('dashboard.filtro.data.ultimosTrintaDias')
      });
    },
    stopLoadingGadget: function stopLoadingGadget(idChart) {
      var chartConfig = this.charts.find(function (chart) {
        return chart.idChartTemplate === idChart;
      });
      if (chartConfig.series) {
        chartConfig.series = [];
      }
      if (chartConfig.xAxis) {
        chartConfig.xAxis.categories = [];
      }
      chartConfig.isLoadingData = false;
    },
    resetGadgets: function resetGadgets() {
      this.$store.dispatch('cancelDashboardRequests');
      this.gadgets = [];
      this.view = false;
      clearInterval(this.intervalLoadGadgets);
      this.intervalLoadGadgets = null;
      for (var key in this.canLoad) {
        this.canLoad[key].alreadyLoaded = false;
        this.canLoad[key].state = false;
      }
    },
    loadPlans: function loadPlans() {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        _this4.$store.dispatch('getPlans', '/dashboard/listPlans').then(function (response) {
          _this4.$store.dispatch('setPlansDashboard', response.data.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    loadMainCategories: function loadMainCategories() {
      var _this5 = this;

      return new _promise2.default(function (resolve, reject) {
        _this5.$store.dispatch('getMainCategories', '/dashboard/listMainCategories').then(function (response) {
          _this5.$store.dispatch('setMainCategoriesDashboard', response.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleConciliationSituationSummary: function handleConciliationSituationSummary(alreadyLoaded) {
      var currentRequest = this.canLoad.ChartConciliationSituationSummary.currentRequest;
      if (currentRequest) {
        if (currentRequest.idPlanoConciliacao === this.planSelectedFilterConcSitSummary.id && (currentRequest.tipo || 'TD') === this.typeFilterConcSituationSummary.id && (currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterConcSitSummary.id && alreadyLoaded) {
          return;
        }
        this.canLoad.ChartConciliationSituationSummary.currentRequest = null;
      }
      this.canLoad.ChartConciliationSituationSummary.alreadyLoaded = alreadyLoaded;
      this.canLoad.ChartConciliationSituationSummary.state = this.periodFilterConcSitSummary && this.periodFilterConcSitSummary.id && this.planSelectedFilterConcSitSummary && this.planSelectedFilterConcSitSummary.id && this.typeFilterConcSituationSummary && this.typeFilterConcSituationSummary.id && this.mainCategorySelectedFilterConcSitSummary && this.mainCategorySelectedFilterConcSitSummary.id;
    },
    loadDataConciliationSituationSummary: function loadDataConciliationSituationSummary() {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        var gadget = self.availableGadgets.find(function (g) {
          return g.funcionalidade.idFuncionalidade === _graficoId2.default.RESUMO_SITUACAO_CONCILIACAO;
        });
        var chartConfig = self.charts.find(function (chart) {
          return chart.idChartTemplate === 'ChartConciliationSituationSummary';
        });

        if (!gadget || !self.planSelectedFilterConcSitSummary.id || !self.periodFilterConcSitSummary.id) {
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          chartConfig.isLoadingData = false;
          return resolve();
        }

        self.canLoad.ChartConciliationSituationSummary.alreadyLoaded = true;

        chartConfig.isLoadingData = true;
        var filterConciliationSituationSummary = {
          idPlanoConciliacao: self.planSelectedFilterConcSitSummary.id,
          tipo: self.typeFilterConcSituationSummary.id !== 'TD' ? self.typeFilterConcSituationSummary.id : null,
          idCategoriaPai: self.mainCategorySelectedFilterConcSitSummary.id !== 'TD' ? self.mainCategorySelectedFilterConcSitSummary.id : null,
          periodo: self.periodFilterConcSitSummary.id,
          dataInicio: self.periodFilterConcSitSummary.fromDate,
          dataFim: self.periodFilterConcSitSummary.toDate,
          lang: _index2.default.getCookieByName('language')
        };

        self.canLoad.ChartConciliationSituationSummary.currentRequest = filterConciliationSituationSummary;

        self.$store.dispatch('getDataConciliationSituationSummary', filterConciliationSituationSummary).then(function (response) {
          chartConfig.series = response.data.series;
          chartConfig.xAxis.categories = response.data.xAxis;
          resolve();
        }).catch(function () {
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          reject();
        }).finally(function () {
          chartConfig.isLoadingData = false;
        });
      });
    },
    handleReconciliationDistribution: function handleReconciliationDistribution(alreadyLoaded) {
      var currentRequest = this.canLoad.ChartAllotmentDistributionConciliation.currentRequest;
      if (currentRequest) {
        if (currentRequest.idPlanoConciliacao === this.planSelectedFilterBatch.id && (currentRequest.tipo || 'TD') === this.typeSelectedFilterBatch.id && (currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterBatch.id && alreadyLoaded) {
          return;
        }
        this.canLoad.ChartAllotmentDistributionConciliation.currentRequest = null;
      }
      this.canLoad.ChartAllotmentDistributionConciliation.alreadyLoaded = alreadyLoaded;
      this.canLoad.ChartAllotmentDistributionConciliation.state = this.periodFilterAllotmentDistribution && this.periodFilterAllotmentDistribution.id && this.planSelectedFilterBatch && this.planSelectedFilterBatch.id && this.typeSelectedFilterBatch && this.typeSelectedFilterBatch.id && this.mainCategorySelectedFilterBatch && this.mainCategorySelectedFilterBatch.id;
    },
    loadBatchReconciliationDistribution: function loadBatchReconciliationDistribution() {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        var gadget = self.availableGadgets.find(function (g) {
          return g.funcionalidade.idFuncionalidade === _graficoId2.default.DISTRIBUICAO_CONCILIACAO_LOTE;
        });
        var chartConfig = self.charts.find(function (chart) {
          return chart.idChartTemplate === 'ChartAllotmentDistributionConciliation';
        });

        if (!gadget || !self.periodFilterAllotmentDistribution.id || !self.planSelectedFilterBatch.id) {
          chartConfig.series = [];
          chartConfig.isLoadingData = false;
          self.isLoadingDataBatchReconciliationDistribution = false;
          return resolve();
        }

        self.canLoad.ChartAllotmentDistributionConciliation.alreadyLoaded = true;

        chartConfig.isLoadingData = true;
        var filterAllotmentDistribution = {
          idPlanoConciliacao: self.planSelectedFilterBatch.id,
          tipo: self.typeSelectedFilterBatch.id !== 'TD' ? self.typeSelectedFilterBatch.id : null,
          idCategoriaPai: self.mainCategorySelectedFilterBatch.id !== 'TD' ? self.mainCategorySelectedFilterBatch.id : null,
          periodo: self.periodFilterAllotmentDistribution.id,
          dataInicio: self.periodFilterAllotmentDistribution.fromDate,
          dataFim: self.periodFilterAllotmentDistribution.toDate,
          lang: _index2.default.getCookieByName('language')
        };

        self.canLoad.ChartAllotmentDistributionConciliation.currentRequest = filterAllotmentDistribution;

        self.$store.dispatch('getDataAllotmentDistributionSummary', filterAllotmentDistribution).then(function (response) {
          chartConfig.series = response.data.series;
          resolve();
        }).catch(function () {
          chartConfig.series = [];
          reject();
        }).finally(function () {
          chartConfig.isLoadingData = false;
        });
      });
    },
    handleFinancialSummary: function handleFinancialSummary(alreadyLoaded) {
      var currentRequest = this.canLoad.ChartFinancialSummary.currentRequest;
      if (currentRequest) {
        if ((currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterFinancialSummary.id && alreadyLoaded) {
          return;
        }
        this.canLoad.ChartFinancialSummary.currentRequest = null;
      }
      this.canLoad.ChartFinancialSummary.alreadyLoaded = alreadyLoaded;
      this.canLoad.ChartFinancialSummary.state = this.periodFilterFinancialSummary && this.periodFilterFinancialSummary.id && this.mainCategorySelectedFilterFinancialSummary && this.mainCategorySelectedFilterFinancialSummary.id;
    },
    loadDataFinancialSummary: function loadDataFinancialSummary() {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        var gadget = self.availableGadgets.find(function (g) {
          return g.funcionalidade.idFuncionalidade === _graficoId2.default.RESUMO_FINANCEIRO_PLANO_CONCILIACAO;
        });
        var chartConfig = self.charts.find(function (chart) {
          return chart.idChartTemplate === 'ChartFinancialSummary';
        });

        if (!gadget || !self.periodFilterFinancialSummary.id) {
          chartConfig.isLoadingData = false;
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          return resolve();
        }

        self.canLoad.ChartFinancialSummary.alreadyLoaded = true;

        chartConfig.isLoadingData = true;
        var filterFinancialSummary = {
          tipo: 'MF',
          idCategoriaPai: self.mainCategorySelectedFilterFinancialSummary.id !== 'TD' ? self.mainCategorySelectedFilterFinancialSummary.id : null,
          periodo: self.periodFilterFinancialSummary.id,
          dataInicio: self.periodFilterFinancialSummary.fromDate,
          dataFim: self.periodFilterFinancialSummary.toDate,
          lang: _index2.default.getCookieByName('language')
        };

        self.canLoad.ChartFinancialSummary.currentRequest = filterFinancialSummary;

        self.$store.dispatch('getDataFinancialSummary', filterFinancialSummary).then(function (response) {
          chartConfig.series = response.data.series;
          chartConfig.xAxis.categories = response.data.xAxis;
          resolve();
        }).catch(function () {
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          reject();
        }).finally(function () {
          chartConfig.isLoadingData = false;
        });
      });
    },
    handleBankBalance: function handleBankBalance(alreadyLoaded) {
      var currentRequest = this.canLoad.DailyBankStatment.currentRequest;
      if (currentRequest) {
        if (currentRequest.idConta === this.accountSelectedBankBalance.id && alreadyLoaded) {
          return;
        }
        this.canLoad.DailyBankStatment.currentRequest = null;
      }
      this.canLoad.DailyBankStatment.alreadyLoaded = alreadyLoaded;
      this.canLoad.DailyBankStatment.state = this.periodFilterBankBalance && this.periodFilterBankBalance.id && this.accountSelectedBankBalance && typeof this.accountSelectedBankBalance.id !== 'undefined';
    },
    loadDataDailyBankStatment: function loadDataDailyBankStatment() {
      var _this6 = this;

      var self = this;
      return new _promise2.default(function (resolve, reject) {
        var gadget = self.availableGadgets.find(function (g) {
          return g.funcionalidade.idFuncionalidade === _graficoId2.default.SALDO_BANCARIO;
        });
        var chartConfig = self.charts.find(function (chart) {
          return chart.idChartTemplate === 'DailyBankStatment';
        });

        if (!gadget || !self.periodFilterBankBalance.id || typeof self.accountSelectedBankBalance.id === 'undefined') {
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          chartConfig.isLoadingData = false;
          return resolve();
        }

        self.canLoad.DailyBankStatment.alreadyLoaded = true;

        var idGrupo = void 0;

        if (self.accountSelectedBankBalance.tipo === 'GRUPO') {
          idGrupo = self.accountSelectedBankBalance.id > 0 ? self.accountSelectedBankBalance.id : 0;
        }

        chartConfig.isLoadingData = true;
        var filterDailyBank = {
          idConta: self.accountSelectedBankBalance.tipo === 'CONTA_BANCARIA' ? self.accountSelectedBankBalance.id : null,
          idGrupo: self.accountSelectedBankBalance.tipo === 'GRUPO' ? idGrupo : null,
          periodo: self.periodFilterBankBalance.id,
          dataInicio: self.periodFilterBankBalance.fromDate,
          dataFim: self.periodFilterBankBalance.toDate,
          lang: _index2.default.getCookieByName('language')
        };

        self.canLoad.DailyBankStatment.currentRequest = filterDailyBank;

        _this6.$store.dispatch('getDataDailyBankStatment', filterDailyBank).then(function (response) {
          chartConfig.series = response.data.series;
          chartConfig.xAxis.categories = response.data.xAxis;
          resolve();
        }).catch(function (error) {
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          if (error && error.message === 'user.cancelled') {
            resolve();
          } else {
            reject();
          }
        }).finally(function () {
          chartConfig.isLoadingData = false;
        });
      });
    },
    loadDataTasks: function loadDataTasks() {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        var gadget = self.availableGadgets.find(function (g) {
          return g.funcionalidade.idFuncionalidade === _graficoId2.default.GADGET_TAREFAS;
        });
        var chartConfig = self.charts.find(function (chart) {
          return chart.idChartTemplate === 'GadgetTasks';
        });

        if (!gadget) {
          return resolve();
        }

        self.canLoad.GadgetTasks.alreadyLoaded = true;

        chartConfig.isLoadingData = true;
        self.$store.dispatch('getDataTasks').then(function (response) {
          var tasks = response.data;
          tasks.dataProximoVencimento = tasks.dataProximoVencimento ? (0, _moment2.default)(tasks.dataProximoVencimento).format('L') : null;
          chartConfig.data = tasks;
          resolve();
        }).catch(function () {
          reject();
        }).finally(function () {
          chartConfig.isLoadingData = false;
        });
      });
    },
    handleDigitalWalletBalance: function handleDigitalWalletBalance(alreadyLoaded) {
      var currentRequest = this.canLoad.DigitalWalletBalance.currentRequest;
      if (currentRequest) {
        if (currentRequest.idCategoria === this.categorySelectedDigitalWalletBalance.id && alreadyLoaded) {
          return;
        }
        this.canLoad.DigitalWalletBalance.currentRequest = null;
      }
      this.canLoad.DigitalWalletBalance.alreadyLoaded = alreadyLoaded;
      this.canLoad.DigitalWalletBalance.state = this.periodFilterDigitalWalletBalance && this.periodFilterDigitalWalletBalance.id && this.categorySelectedDigitalWalletBalance && typeof this.categorySelectedDigitalWalletBalance.id !== 'undefined';
    },
    loadDataDigitalWalletBalance: function loadDataDigitalWalletBalance() {
      var _this7 = this;

      var self = this;
      return new _promise2.default(function (resolve, reject) {
        var gadget = self.availableGadgets.find(function (g) {
          return g.funcionalidade.idFuncionalidade === _graficoId2.default.SALDO_CARTEIRA_DIGITAL;
        });
        var chartConfig = self.charts.find(function (chart) {
          return chart.idChartTemplate === 'DigitalWalletBalance';
        });

        if (!gadget || !self.periodFilterDigitalWalletBalance.id || typeof self.categorySelectedDigitalWalletBalance.id === 'undefined') {
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          chartConfig.isLoadingData = false;
          return resolve();
        }

        self.canLoad.DigitalWalletBalance.alreadyLoaded = true;

        chartConfig.isLoadingData = true;
        var filterDigitalWalletBalance = {
          idCategoria: self.categorySelectedDigitalWalletBalance.id !== 'TD' ? self.categorySelectedDigitalWalletBalance.id : null,
          periodo: self.periodFilterDigitalWalletBalance.id,
          dataInicio: self.periodFilterDigitalWalletBalance.fromDate,
          dataFim: self.periodFilterDigitalWalletBalance.toDate,
          lang: _index2.default.getCookieByName('language')
        };

        self.canLoad.DigitalWalletBalance.currentRequest = filterDigitalWalletBalance;

        _this7.$store.dispatch('getDataDigitalWalletBalance', filterDigitalWalletBalance).then(function (response) {
          chartConfig.series = response.data.series;
          chartConfig.xAxis.categories = response.data.xAxis;
          resolve();
        }).catch(function (error) {
          chartConfig.series = [];
          chartConfig.xAxis.categories = [];
          if (error && error.message === 'user.cancelled') {
            resolve();
          } else {
            reject();
          }
        }).finally(function () {
          chartConfig.isLoadingData = false;
        });
      });
    }
  },

  mounted: function mounted() {
    if (this.client && this.allowedFuncionalities && this.allowedFuncionalities.length > 0) {
      this.loadHome();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('cleanGadgetsFilters');
  }
};

/***/ }),
/* 885 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/integration/fileUpload/FileUpload.vue ***!
  \***********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(/*! babel-runtime/core-js/array/from */ 164);

var _from2 = _interopRequireDefault(_from);

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(/*! babel-runtime/core-js/json/stringify */ 136);

var _stringify2 = _interopRequireDefault(_stringify);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _vue2Dropzone = __webpack_require__(/*! vue2-dropzone */ 1726);

var _vue2Dropzone2 = _interopRequireDefault(_vue2Dropzone);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _getNodeMiddlewareUrl = __webpack_require__(/*! ../../../../../build/http-requests/getNodeMiddlewareUrl */ 313);

var _getNodeMiddlewareUrl2 = _interopRequireDefault(_getNodeMiddlewareUrl);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _truncateString = __webpack_require__(/*! ../../../../utils/truncateString.js */ 793);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'FileUpload',

  components: {
    Dropzone: _vue2Dropzone2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      layouts: null,
      availableLayouts: [],
      isLoadingData: true,
      msgError: 'uploadArquivo.erro.geral',
      showInnerMessage: false,
      useCustomDropzoneOptions: true,
      dropzoneOptions: {
        showRemoveLink: false,
        maxFileSizeInMB: 1024,
        maxNumberOfFiles: 100000000,
        parallelUploads: 5,
        timeout: 50000,
        autoProcessQueue: false,
        autoQueue: false,
        error: function error(file, message) {
          file.previewElement.classList.add('dz-error');
          var refs = file.previewElement.querySelectorAll('[data-dz-errormessage]');
          var results = [];
          refs.forEach(function (ref) {
            results.push(ref.textContent = message);
          });
          file.previewElement.getElementsByClassName('dz-progress')[0].style.display = 'none';
          return results;
        },
        language: {
          dictDefaultMessage: this.$t('uploadArquivo.uploader.dictDefaultMessage'),
          dictFallbackMessage: this.$t('uploadArquivo.uploader.dictFallbackMessage'),
          dictFallbackText: this.$t('uploadArquivo.uploader.dictFallbackText'),
          dictFileTooBig: this.$t('uploadArquivo.uploader.dictFileTooBig'),
          dictInvalidFileType: this.$t('uploadArquivo.uploader.dictInvalidFileType'),
          dictResponseError: this.$t(this.errorMessage),
          dictMaxFilesExceeded: this.$t('uploadArquivo.uploader.dictMaxFilesExceeded'),
          dictRemoveFile: this.$t('uploadArquivo.uploader.dictRemoveFile')
        },
        headers: {
          'x-access-token': localStorage.getItem('token'),
          client: this.$store.getters.client
        }
      },
      spanError: 'uploadArquivo.uploader.envioFalhou',
      idLayoutFile: null,
      permissionUploadFile: false,
      uploadUrl: this.getUrlSendFile()
    };
  },


  computed: {
    client: function client() {
      return this.$store.getters.client;
    },
    expandedMenu: function expandedMenu() {
      return this.$store.getters.expandedMenu;
    }
  },

  watch: {
    expandedMenu: function expandedMenu() {
      this.configPreviewWidth();
    }
  },

  methods: {
    loadLayout: function loadLayout() {
      var _this = this;

      this.$store.dispatch('getFileLayout').then(function (response) {
        if (response && response.data && response.data.length > 0) {
          var canUploadFile = _underscore2.default.findWhere(response.data, { flUpload: true });
          if (canUploadFile) {
            _this.layouts = (0, _stringify2.default)(response.data);
            _this.availableLayouts = response.data;
            _this.permissionUploadFile = true;
          } else {
            _this.permissionUploadFile = false;
          }
        } else {
          _this.permissionUploadFile = false;
        }
      }).catch(function () {
        _this.permissionUploadFile = false;
        _this.$root.$refs.notification.error('uploadArquivo.erro.naoFoiPossivelBuscarLayouts');
      }).finally(function () {
        _this.isLoadingData = false;
      });
    },
    fileListTemplate: function fileListTemplate() {
      return '\n        <div class="col-lg-6 col-md-12 dz-preview">\n          <div class="upload-box">\n            <i class="col-lg-1 col-md-1 upload-box-padding fa fa-file-code-o upload-box-fa-file" aria-hidden="true"></i>\n            <div class="col-lg-10 col-md-10 upload-box-padding upload-box-info" style="background-color:transparent; height:40px;">\n              <div class="details">\n                <div class="filename pull-left">\n                  <div style="cursor:pointer" class="fileUploadName">\n                    <span data-dz-name/>\n                  </div>\n                </div>\n                <div class="dz-error-mark dz-error-mark-message pull-left span-status" style="width: auto!important; top: 15%!important; position: sticky!important">\n                  &nbsp-&nbsp' + this.$t(this.spanError) + '&nbsp\n                  <div class="messageError">\n                    <span data-dz-errormessage/>\n                  </div>\n                </div>\n                <div class="size pull-right">\n                  <span data-dz-size/>\n                </div>\n              </div>\n              <div class="clear"></div>\n              <div id=\'upload-progress-bar\' class="border-radius-progress-bar dz-progress col-md-12 upload-box-padding">\n                <span class="border-radius-progress-bar dz-upload" style="background-color: #17375F !important; height: 10px!important;" data-dz-uploadprogress></span>\n              </div>\n              <div class="border-radius-progress-bar dz-success-mark dz-success col-md-12 upload-box-padding" style="width:100%!important; background-color:#83E1BA; opacity:1!important ">\n              </div>\n              <div class="border-radius-progress-bar dz-error-mark dz-error col-md-12 upload-box-padding" style="width:100%!important; background-color:#F55753; ">\n              </div>\n            </div>\n            <div class="col-lg-1 col-md-1 upload-box-padding text-center remover-arquivo">\n              <a data-dz-remove title=\'Remover arquivo\'>\n                <i style="cursor:pointer" class="fa fa-times" aria-hidden="true"></i>\n              </a>\n            </div>\n          </div>\n        </div>\n      ';
    },
    updateQueuedFiles: function updateQueuedFiles(file) {
      var _this2 = this;

      var self = this;
      this.validateNameAndRegex(file.name).then(function (layout) {
        self.$refs.fileUploadDZ.processQueue();
        (0, _analytics.trackAnalyticsEvent)(_this2, 'file-upload', 'send-file', file.type);
        self.showInnerMessage = true;
        if (file && file.name) {
          var fileName = (0, _truncateString.truncateString)(file.name, 12, 3);
          $(file.previewElement).find('.fileUploadName').text(fileName);
          $(file.previewElement).find('.fileUploadName').attr('title', file.name);
        }
        self.configPreviewWidth();
      }).catch(function (error) {
        self.showErrorMessage(file, error);
        var fileAux = self.$refs.fileUploadDZ.getAcceptedFiles().find(function (fileUpload) {
          return fileUpload.name === file.name;
        });
        fileAux.status = 'error';
        self.dropzoneOptions.error(file, error);
      });
    },
    validateNameAndRegex: function validateNameAndRegex(filename) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.availableLayouts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var layout = _step.value;

          if (layout.mascara) {
            var regexp = new RegExp(layout.mascara);
            if (regexp.test(filename) && layout.flUpload) {
              return _promise2.default.resolve(layout);
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return _promise2.default.reject('uploadArquivo.erro.regex.naoEncontrada');
    },
    verifyDropzoneEmpty: function verifyDropzoneEmpty() {
      this.showInnerMessage = document.getElementsByClassName('dz-preview').length !== 0;
    },
    getIdLayout: function getIdLayout(file) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.availableLayouts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var layout = _step2.value;

          var regexp = new RegExp(layout.mascara);
          if (regexp.test(file.name)) {
            return _promise2.default.resolve(layout);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return _promise2.default.reject();
    },
    showErrorMessage: function showErrorMessage(file, errorMessage) {
      errorMessage = this.$t(errorMessage);
      if (errorMessage && errorMessage.length > 20) {
        var errorTitle = errorMessage;
        errorMessage = (0, _truncateString.truncateString)(errorMessage, 12, 8);
        $(file.previewElement).find('.messageError').attr('title', errorTitle);
        $(file.previewElement).find('.messageError').css({ 'cursor': 'pointer' });
      }
      (0, _analytics.trackAnalyticsEvent)(this, 'file-upload', 'upload-error', errorMessage);
      $(file.previewElement).find('.messageError').text(errorMessage);
      if (file && file.name) {
        var fileName = (0, _truncateString.truncateString)(file.name, 5, 3);
        $(file.previewElement).find('.fileUploadName').text(fileName);
        $(file.previewElement).find('.fileUploadName').attr('title', file.name);
      }
    },
    saveAuditLog: function saveAuditLog(file, response) {
      (0, _analytics.trackAnalyticsEvent)(this, 'file-upload', 'upload-success', file.size);
      this.getIdLayout(file).then(function (layout) {
        _axiosCommon2.default.post('/uploadFile/logAuditoria', { idLayout: layout.id });
      });
    },
    getUrlSendFile: function getUrlSendFile() {
      return (0, _getNodeMiddlewareUrl2.default)() + '/uploadFile';
    },
    configPreviewWidth: function configPreviewWidth() {
      if (document.getElementsByClassName('dz-preview').length > 0) {
        var previewDivs = (0, _from2.default)(document.getElementsByClassName('dz-preview'));
        var windowWidth = window.innerWidth;
        if (windowWidth < 1299) {
          this.setClassToDiv(previewDivs, 'col-lg-6', 'col-lg-12');
        } else {
          if (this.expandedMenu && windowWidth >= 1300 && windowWidth < 1501) {
            this.setClassToDiv(previewDivs, 'col-lg-6', 'col-lg-12');
          } else {
            this.setClassToDiv(previewDivs, 'col-lg-12', 'col-lg-6');
          }
        }
      }
    },
    setClassToDiv: function setClassToDiv(listDiv, classToRemove, classToAdd) {
      listDiv.forEach(function (item) {
        item.classList.remove(classToRemove);
        item.classList.add(classToAdd);
      });
    }
  },

  mounted: function mounted() {
    this.configPreviewWidth();
    this.showInnerMessage = false;
  },
  created: function created() {
    this.loadLayout();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 886 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/integration/processedFiles/ProcessedFiles.vue ***!
  \*******************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ProcessedFiles',

  components: {
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      gridId: '#processedFilesGrid',
      treeGridCfg: {},
      audit: {},
      dateRange: {},
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'ExtratoBancario',
      disableSearchButton: false
    };
  },


  methods: {
    validate: function validate() {
      var _this = this;

      var self = this;
      return new _promise2.default(function (resolve) {
        _this.$validator.validateAll().then(function (result) {
          if (result && _this.$refs.dateRange.validate()) {
            _this.showTreegrid = true;
            (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
            _this.search().finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    search: function search() {
      var _this2 = this;

      this.disableSearchButton = true;
      var inicio = this.dateRange.fromDate;
      var fim = this.dateRange.toDate;
      var filter = {
        inicio: inicio,
        fim: fim,
        lang: _index2.default.getCookieByName('language')
      };
      return new _promise2.default(function (resolve, reject) {
        _this2.$store.dispatch('searchFiles', filter).then(function (response) {
          window.DisposeGrids();
          _this2.result = response.data;
          _this2.treeGridCfg = response.data.Cfg.Layout;
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this2.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          reject();
        });
      });
    }
  }
};

/***/ }),
/* 887 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/integration/remittanceIntegration/RemittanceIntegration.vue ***!
  \*********************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _RemittanceIntegrationModal = __webpack_require__(/*! ../../../integration/remittanceIntegration/RemittanceIntegrationModal */ 1273);

var _RemittanceIntegrationModal2 = _interopRequireDefault(_RemittanceIntegrationModal);

var _RemittanceIntegrationCreationModal = __webpack_require__(/*! ../../../integration/remittanceIntegration/RemittanceIntegrationCreationModal */ 1272);

var _RemittanceIntegrationCreationModal2 = _interopRequireDefault(_RemittanceIntegrationCreationModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _arrayUtils = __webpack_require__(/*! ../../../../utils/arrayUtils.js */ 789);

var _closeModal = __webpack_require__(/*! ../../../../events/closeModal */ 104);

var _closeModal2 = _interopRequireDefault(_closeModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'RemittanceIntegration',

  components: {
    vSelect: _vueSelect2.default,
    ConfirmModal: _ConfirmModal2.default,
    RemittanceIntegrationModal: _RemittanceIntegrationModal2.default,
    RemittanceIntegrationCreationModal: _RemittanceIntegrationCreationModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      remittance: {},
      shown: {
        detail: false,
        new: false
      },
      showGrid: false,
      disableSelect: false,
      gridId: '#RemessasIntegracao',
      firstDate: new Date(),
      finalDate: new Date(),
      result: {},
      treeGridCfg: {},
      filters: {
        origin: 'G',
        remittenceIds: [],
        sequenceNumber: []
      },
      remittenceTypes: [],
      cleanRemittanceTypes: [],
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      isExportFile: false,
      disableSearchButton: false,
      arrayRemessas: []
    };
  },


  computed: {
    canRemoveRemittance: function canRemoveRemittance() {
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(4002) >= 0;
    },
    disableDateRange: function disableDateRange() {
      return this.filters.remittenceIds.length > 0 || this.filters.sequenceNumber.length > 0;
    }
  },

  methods: {
    getLoadingMessages: function getLoadingMessages() {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid'];
    },
    loadRemittanceTypes: function loadRemittanceTypes() {
      var _this = this;

      this.$store.dispatch('getRemittanceTypes').then(function (response) {
        _this.remittenceTypes = response.data.data;
        _this.cleanRemittanceTypes = [].concat((0, _toConsumableArray3.default)(response.data.data));
        _this.remittenceTypes.splice(0, 0, { id: 0, nome: _this.$t('inputTag.labels.todos') });
        _this.filters.type = _this.remittenceTypes[0];
        if (_this.remittenceTypes.length === 1) {
          _this.disableSelect = true;
        }
      }).catch(function () {
        _this.remittenceTypes = [];
        _this.remittenceTypes.push({ id: 0, nome: _this.$t('inputTag.labels.todos') });
        _this.filters.type = _this.remittenceTypes[0];
        _this.disableSelect = true;
      });
    },
    newRemittance: function newRemittance() {
      this.shown.new = true;
    },
    validate: function validate() {
      var _this2 = this;

      var self = this;
      var promise = null;
      return new _promise2.default(function (resolve) {
        self.$validator.validateAll().then(function (result) {
          if (result && _this2.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download();
            } else {
              self.showGrid = true;
              (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
              promise = self.search();
            }
            promise.finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    search: function search() {
      var _this3 = this;

      if (!this.filters.type) {
        this.filters.type = this.remittenceTypes[0];
      }
      this.disableSearchButton = true;
      var filter = {
        inicio: this.filters.period.fromDate,
        fim: this.filters.period.toDate,
        opcaoData: this.filters.origin,
        idCrcMovFinanCfg: this.filters.type.id,
        idsRemessas: (0, _arrayUtils.getArrayOfValues)(this.filters.remittenceIds, 'id'),
        sequencias: (0, _arrayUtils.getArrayOfValues)(this.filters.sequenceNumber, 'id'),
        lang: _index2.default.getCookieByName('language'),
        podeExcluirRemessa: this.canRemoveRemittance
      };
      return new _promise2.default(function (resolve, reject) {
        _this3.$store.dispatch('searchRemittanceIntegration', filter).then(function (response) {
          if (window.Grids[0]) {
            window.DisposeGrids();
          }

          _this3.treeGridCfg = response.data.Cfg.Layout;
          _this3.result = response.data;

          window.Grids.downloadFile = function (encodedId, fileName) {
            (0, _axiosCommon2.default)({
              url: '/remittanceIntegration/download?idMovFin=' + encodedId,
              method: 'GET',
              responseType: 'blob'
            }).then(function (response) {
              var a = document.createElement('a');
              a.href = window.URL.createObjectURL(new Blob([response.data]));
              a.setAttribute('download', fileName);
              a.click();
              document.body.removeChild(a);
            }).catch(function (error) {
              _this3.$root.$refs.notification.error(error);
              reject();
            });
          };

          window.Grids.abrirModalDetalhes = function (idRemittance) {
            return new _promise2.default(function (resolve, reject) {
              _this3.$store.dispatch('remittanceDetail', idRemittance).then(function (response) {
                return _this3.loadDetailModal(response.data);
              }).catch(function (error) {
                _this3.$root.$refs.notification.error(error);
                reject();
              });
            });
          };

          window.Grids.openAssignmentModal = function (row) {
            _this3.loadDetailModal(row);
          };

          _this3.showGrid = true;
          _this3.disableSearchButton = false;
          (0, _gridLoadTransition.stopTreeGridLoading)(_this3.gridId);
          resolve();
        }).catch(function (error) {
          _this3.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this3.gridId);
          _this3.disableSearchButton = false;
          reject();
        });
      });
    },
    loadDetailModal: function loadDetailModal(remittance) {
      this.remittance = remittance;
      this.shown.detail = true;
    },
    closeDetailModal: function closeDetailModal() {
      this.shown.detail = false;
      this.remittance = {};
    },
    loadNewRemittanceModal: function loadNewRemittanceModal() {
      this.shown.new = true;
    },
    closeNewRemittanceModal: function closeNewRemittanceModal() {
      this.shown.new = false;
    },
    openModalConfirm: function openModalConfirm() {
      $('#confirmRemittanceRemoval').modal('show');
    },
    closeModalConfirm: function closeModalConfirm() {
      $('#confirmRemittanceRemoval').modal('hide');
    },
    removeRemittance: function removeRemittance() {
      var _this4 = this;

      if (this.remittance && this.remittance.id && this.shown.detail) {
        this.arrayRemessas.arrayIdRemessaIntegracao = [];
        this.arrayRemessas.arrayLinhaSelecionada = [];
        this.arrayRemessas.arrayIdRemessaIntegracao.push(this.remittance.id);
        this.arrayRemessas.arrayLinhaSelecionada.push(this.remittance);
      }
      $('#confirmRemittanceRemoval').modal('hide');
      return new _promise2.default(function (resolve, reject) {
        _this4.$store.dispatch('removeRemittance', _this4.arrayRemessas.arrayIdRemessaIntegracao).then(function (response) {
          _this4.arrayRemessas = [];
          _this4.$root.$refs.notification.success('remessaIntegracao.mensagem.solicitacaoExclusaoSucesso');
          _this4.closeModalConfirm();
          if (_this4.shown.detail) {
            _this4.closeDetailModal();
          }
          resolve();
        }).catch(function (error) {
          _this4.$root.$refs.notification.error(error);
          reject();
        });
      });
    },
    remittanceRemoval: function remittanceRemoval(remessas) {
      if (this.shown.detail) {
        this.closeDetailModal();
      }
      this.arrayRemessas = remessas;
      this.openModalConfirm();
    }
  },

  mounted: function mounted() {
    var self = this;
    _closeModal2.default.$on('modalDetaisClose', function (flag) {
      if (flag) {
        self.showGrid = true;
        (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
        self.search();

        _closeModal2.default.$emit('taskChange', false);
      }
    });
  },
  created: function created() {
    this.loadRemittanceTypes();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 888 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/login/CadastrarSenha.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(/*! ../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CadastrarSenha',

  data: function data() {
    return {
      username: null,
      pass: null,
      confirmPass: null,
      chave: null,
      success: false,
      abrirIdiomas: false,
      senhaDiferente: false,
      campoUsernamaVazio: false,
      campoUsernameInvalido: false,
      campoPassVazio: false,
      campoConfirmPassVazio: false,
      disableCreateButton: false,
      idiomaPng: __webpack_require__(/*! ../../../assets/login/img/idioma.png */ 299),
      logoEqualsLoginPng: __webpack_require__(/*! ../../../assets/logos_equals/logo_banking.png */ 684),
      fecharPng: __webpack_require__(/*! ../../../assets/login/img/fechar.png */ 297),
      idiomaAtivoPng: __webpack_require__(/*! ../../../assets/login/img/idioma-ativo.png */ 298),
      logadoOkPng: __webpack_require__(/*! ../../../assets/login/img/logado-ok.png */ 300)
    };
  },


  watch: {
    username: function username() {
      if (this.username && this.username.length > 0) {
        this.campoUsernamaVazio = false;
        this.campoUsernameInvalido = false;
        document.getElementById('nome').style.borderBottom = '2px solid #ffffff';
      }
    },
    pass: function pass() {
      if (this.pass && this.pass.length > 0) {
        this.campoPassVazio = false;
        document.querySelector('#senha').style.borderBottom = '2px solid #ffffff';
      }
    },
    confirmPass: function confirmPass() {
      if (this.confirmPass && this.confirmPass.length > 0) {
        this.campoConfirmPassVazio = false;
        this.senhaDiferente = false;
        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #ffffff';
      }
    }
  },

  methods: {
    escolherIdioma: function escolherIdioma() {
      this.abrirIdiomas = true;
    },
    fecharEscolherIdioma: function fecharEscolherIdioma() {
      this.abrirIdiomas = false;
    },
    trocarIdioma: function trocarIdioma(language) {
      _index2.default.changeLanguage(language);

      $('div.btn-group').find('.btn-ativo').removeClass('btn-ativo');

      switch (language) {
        case 'pt':
          $('.btn-pt').addClass('btn-ativo');
          break;
        case 'in':
          $('.btn-in').addClass('btn-ativo');
          break;
        case 'es':
          $('.btn-es').addClass('btn-ativo');
          break;
        default:
          break;
      }
    },
    cadastrar: function cadastrar(event) {
      var _this = this;

      event.preventDefault();
      if (this.validateForm()) {
        this.disableCreateButton = true;
        this.chave = this.$route.query.hash;
        if (location.pathname === _routesMap2.default.NEW_PASSWORD) {
          this.$store.dispatch('registerPassword', {
            username: this.username,
            password: this.pass,
            confirmPassword: this.confirmPass,
            key: this.chave
          }).then(function (response) {
            _this.$root.$refs.notification.success('login.sucesso.cadastrarSenha');
            _this.disableCreateButton = false;
            _this.$router.push(_routesMap2.default.LOGIN);
          }).catch(function (error) {
            _this.disableCreateButton = false;
            _this.$root.$refs.notification.error(error.message);
          });
        } else {
          this.$store.dispatch('registerRecoverPassword', {
            username: this.username,
            password: this.pass,
            confirmPassword: this.confirmPass,
            key: this.chave
          }).then(function (response) {
            _this.disableCreateButton = false;
            _this.$root.$refs.notification.success('login.sucesso.alterarSenha');
            _this.$router.push(_routesMap2.default.LOGIN);
          }).catch(function (error) {
            _this.disableCreateButton = false;
            _this.$root.$refs.notification.error(error.message);
          });
        }
      }
    },
    validateForm: function validateForm() {
      var isValidForm = this.verificarCamposVazios();
      var isSamePass = this.verificarSenhasIguais();
      return isValidForm && isSamePass;
    },
    validateEmail: function validateEmail() {
      return (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.username)
      );
    },
    verificarCamposVazios: function verificarCamposVazios() {
      var isValid = true;
      this.campoUsernamaVazio = false;
      this.campoPassVazio = false;
      this.campoConfirmPassVazio = false;
      this.campoUsernameInvalido = false;

      if (this.username == null || this.username === undefined || this.username === '') {
        this.campoUsernamaVazio = true;
        document.querySelector('#nome').style.borderBottom = '2px solid #c65b55';
        isValid = false;
      } else if (!this.validateEmail()) {
        this.campoUsernameInvalido = true;
        document.querySelector('#nome').style.borderBottom = '2px solid #c65b55';
        isValid = false;
      }

      if (this.pass == null || this.pass === undefined || this.pass === '') {
        this.campoPassVazio = true;
        document.querySelector('#senha').style.borderBottom = '2px solid #c65b55';
        isValid = false;
      }

      if (this.confirmPass == null || this.confirmPass === undefined || this.confirmPass === '') {
        this.campoConfirmPassVazio = true;
        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #c65b55';
        isValid = false;
      }

      return isValid;
    },
    verificarSenhasIguais: function verificarSenhasIguais() {
      if (this.pass === this.confirmPass) {
        return true;
      } else {
        this.senhaDiferente = true;
        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #c65b55';
        return false;
      }
    },
    carregarImagem: function carregarImagem(nomeImagem) {
      var idiomaImagem = _index2.default.getCookieByName('language');
      return __webpack_require__(/*! ../../../assets/login/img */ 303)("./" + nomeImagem + idiomaImagem + '.png');
    }
  },

  mounted: function mounted() {
    this.$store.dispatch('logout');
    _index2.default.changeLanguage(_index2.default.getCookieByName('language'));

    switch (_index2.default.getCookieByName('language')) {
      case 'pt':
        $('.btn-pt').addClass('btn-ativo');
        break;
      case 'in':
        $('.btn-in').addClass('btn-ativo');
        break;
      case 'es':
        $('.btn-es').addClass('btn-ativo');
        break;
      default:
        break;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 889 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/login/Login.vue ***!
  \*************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vueRecaptcha = __webpack_require__(/*! vue-recaptcha */ 1574);

var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);

var _index = __webpack_require__(/*! ../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _analytics = __webpack_require__(/*! ../../../utils/analytics.js */ 25);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Login',

  components: { VueRecaptcha: _vueRecaptcha2.default },

  data: function data() {
    return {
      PUBLIC_KEY: '6Lcr0awUAAAAAFQhGvyrtVnXKHS4c2d2r_qnBzaK',
      isProbableABot: false,
      isLogin: true,
      username: '',
      pass: '',
      responsePasswordRecoveryCaptcha: null,
      responseLoginCaptcha: null,
      abrirIdiomas: false,
      captchaOK: false,
      msgErroCriacaoCaptcha: false,
      msgCaptchaErro: false,
      logadoSuccess: false,
      logadoError: false,
      campoUsernameVazio: false,
      campoPassVazio: false,
      campoUsernameInvalido: false,
      destFileCaptcha: '',
      numeroCaptcha: '',
      disableLoginButton: false,
      disableRecoveryButton: false,
      idiomaPng: __webpack_require__(/*! ../../../assets/login/img/idioma.png */ 299),
      idiomaAtivoPng: __webpack_require__(/*! ../../../assets/login/img/idioma-ativo.png */ 298),
      logoEqualsLoginPng: __webpack_require__(/*! ../../../assets/logos_equals/logo_banking.png */ 684),
      userPng: __webpack_require__(/*! ../../../assets/login/img/user.png */ 682),
      passwordPng: __webpack_require__(/*! ../../../assets/login/img/password.png */ 681),
      fecharPng: __webpack_require__(/*! ../../../assets/login/img/fechar.png */ 297),
      logadoOkPng: __webpack_require__(/*! ../../../assets/login/img/logado-ok.png */ 300),
      voltarPng: __webpack_require__(/*! ../../../assets/login/img/voltar.png */ 683)
    };
  },


  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    messageErrorLogin: function messageErrorLogin() {
      return this.$store.getters.messageErrorLogin;
    }
  },

  watch: {
    messageErrorLogin: function messageErrorLogin() {
      if (this.messageErrorLogin) {
        this.$root.$refs.notification.warning('erro');
        this.$store.dispatch('cleanMessageErrorSession');
      }
    },
    username: function username() {
      if (this.username && this.username.length > 0) {
        this.campoUsernameVazio = false;
        this.campoUsernameInvalido = false;
        var inputId = this.isLogin ? 'loginInputLog' : 'loginInputRec';
        document.getElementById(inputId).style.borderBottom = '2px solid #ffffff';
      }
    },
    pass: function pass() {
      if (this.pass && this.pass.length > 0) {
        this.campoPassVazio = false;
        document.querySelector('#loginSenha').style.borderBottom = '2px solid #ffffff';
      }
    }
  },

  methods: {
    escolherIdioma: function escolherIdioma() {
      this.abrirIdiomas = true;
    },
    fecharEscolherIdioma: function fecharEscolherIdioma() {
      this.abrirIdiomas = false;
    },
    trocarIdioma: function trocarIdioma(language) {
      _index2.default.changeLanguage(language);

      $('div.btn-group').find('.btn-ativo').removeClass('btn-ativo');

      switch (language) {
        case 'pt':
          $('.btn-pt').addClass('btn-ativo');
          break;
        case 'in':
          $('.btn-in').addClass('btn-ativo');
          break;
        case 'es':
          $('.btn-es').addClass('btn-ativo');
          break;
        default:
          break;
      }
    },
    login: function login(event) {
      var _this = this;

      localStorage.removeItem('token');
      event.preventDefault();
      if (this.responseLoginCaptcha === null && this.isProbableABot) {
        this.$root.$refs.notification.error('login.validacao.recaptcha');
        return;
      }
      if (this.validateForm()) {
        this.disableLoginButton = true;
        this.$store.dispatch('login', {
          username: this.username,
          password: this.pass,
          recaptcha: this.responseLoginCaptcha
        }).then(function (response) {
          _this.$store.dispatch('setClient', { client: null, clientName: null, singleClient: null }).then((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _analytics.trackAnalyticsEvent)(_this, 'tentativa-de-login', 'login-click', _index2.default.getCookieByName('language'));

                  case 2:
                    _this.$store.dispatch('getClients').then(function (clients) {
                      _this.$root.$refs.notification.success('login.sucesso.login');
                      location.href = _routesMap2.default.HOME;
                      _this.disableLoginButton = false;
                    }).catch(function (error) {
                      _this.$store.dispatch('logout').then(function () {
                        _this.$store.dispatch('cleanVuexModules').then(function () {
                          _this.$root.$refs.notification.error(error.message);
                          _this.disableLoginButton = false;
                        });
                      });
                    }).finally(function () {
                      localStorage.setItem('event-login-done', Math.random());
                    });

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          })));
        }).catch(function (error) {
          _this.isProbableABot = error.triesAmount >= 5;
          var errorMessageSplitted = error.message.split('  ');
          if (errorMessageSplitted[0] === 'login.erro.usuario.senhaBloqueada') {
            (0, _analytics.trackAnalyticsEvent)(_this, 'tentativa-de-login', 'login-click', 'senha-bloqueada');
          }
          _this.disableLoginButton = false;
          if (errorMessageSplitted[0] === 'No message available') {
            _this.$root.$refs.notification.error('GENERAL', 'login.erro.verificarEmailSenha');
          } else if (errorMessageSplitted[0] === "Cannot read property 'status' of undefined") {
            _this.$root.$refs.notification.error('GENERAL', 'login.erro.loginTitle');
          } else {
            _this.$root.$refs.notification.error(errorMessageSplitted[0], 'login.erro.loginTitle');
          }
        });
      }
    },
    logout: function logout() {
      var _this2 = this;

      this.$store.dispatch('logout').then(function () {
        localStorage.removeItem('token');
        _this2.$router.push('/');
      });
    },
    validateEmail: function validateEmail(email) {
      return (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.username)
      );
    },
    validateForm: function validateForm() {
      var isValidUsername = this.verifyUsernameEmpty();
      var isValidPass = this.verifyPasswordEmpty();
      return isValidUsername && isValidPass;
    },
    verifyUsernameEmpty: function verifyUsernameEmpty() {
      var inputId = this.isLogin ? 'loginInputLog' : 'loginInputRec';
      var isValid = true;
      this.campoUsernameVazio = false;
      this.campoUsernameInvalido = false;
      if (this.username == null || this.username === undefined || this.username === '') {
        this.campoUsernameVazio = true;
        document.getElementById(inputId).style.borderBottom = '2px solid #c65b55';
        isValid = false;
      } else if (!this.validateEmail()) {
        this.campoUsernameInvalido = true;
        document.getElementById(inputId).style.borderBottom = '2px solid #c65b55';
        isValid = false;
      }
      return isValid;
    },
    verifyPasswordEmpty: function verifyPasswordEmpty() {
      var isValid = true;
      this.campoPassVazio = false;
      if (this.pass == null || this.pass === undefined || this.pass === '') {
        this.campoPassVazio = true;
        document.querySelector('#loginSenha').style.borderBottom = '2px solid #c65b55';
        isValid = false;
      }

      return isValid;
    },
    limparErro: function limparErro() {
      this.logadoError = false;
      $('.form-control').css('border-bottom', '2px solid rgba(255, 255, 255, 1)');
    },


    animacaoTela: function animacaoTela(step) {
      step.addClass('animate-out');

      setTimeout(function () {
        step.removeClass('animate-out is-showing').next().addClass('animate-in');
      }, 400);

      setTimeout(function () {
        step.next().removeClass('animate-in').addClass('is-showing');
      }, 1200);
    },

    trocaTelaRecuperarSenha: function trocaTelaRecuperarSenha() {
      var self = this;
      self.isLogin = false;
      var step = $('.inicial-body2');
      if (this.campoUsernameVazio || this.campoUsernameInvalido) {
        document.getElementById('loginInputRec').style.borderBottom = '2px solid #c65b55';
      }
      self.animacaoTela(step);
    },

    trocaTelaVoltar: function trocaTelaVoltar() {
      this.isLogin = true;
      this.campoPassVazio = false;
      this.campoUsernameVazio = false;
      this.campoUsernameInvalido = false;
      this.username = '';
      this.pass = '';
      document.querySelector('#loginSenha').style.borderBottom = '2px solid white';
      document.querySelector('#loginInputLog').style.borderBottom = '2px solid white';
      document.querySelector('#loginInputRec').style.borderBottom = '2px solid white';
      var step = $('.inicial-body3');

      step.addClass('animate-out');

      setTimeout(function () {
        step.removeClass('animate-out is-showing').prev().addClass('animate-in');
      }, 400);

      setTimeout(function () {
        step.prev().removeClass('animate-in').addClass('is-showing');
      }, 1200);
    },

    removeSpaces: function removeSpaces(string) {
      return string.split(' ').join('');
    },

    onVerify: function onVerify(response) {
      this.responsePasswordRecoveryCaptcha = response;
    },
    onVerifyLogin: function onVerifyLogin(response) {
      this.responseLoginCaptcha = response;
    },
    recoverPassword: function recoverPassword(event) {
      var _this3 = this;

      event.preventDefault();
      if (!this.responsePasswordRecoveryCaptcha) {
        this.$root.$refs.notification.error('login.validacao.recaptcha');
        return;
      }

      if (this.verifyUsernameEmpty()) {
        this.disableRecoveryButton = true;
        var recoverPasswordData = {
          username: this.username,
          url: 'http://' + window.location.host + '/banking/',
          recaptcha: this.responsePasswordRecoveryCaptcha
        };
        this.$store.dispatch('recoverPassword', recoverPasswordData).then(function (response) {
          _this3.$root.$refs.notification.success('login.sucesso.recuperarSenha');
          (0, _analytics.trackAnalyticsEvent)(_this3, 'tentativa-de-recuperar-senha', 'recuperar-senha', 'sucesso');
          _this3.disableRecoveryButton = false;
          _this3.trocaTelaVoltar();
        }).catch(function (error) {
          (0, _analytics.trackAnalyticsEvent)(_this3, 'tentativa-de-recuperar-senha', 'recuperar-senha', 'erro');
          _this3.disableRecoveryButton = false;
          _this3.$root.$refs.notification.error(error.message);
        });
      }
    },
    carregarImagem: function carregarImagem(nomeImagem) {
      var idiomaImagem = _index2.default.getCookieByName('language');
      return __webpack_require__(/*! ../../../assets/login/img */ 303)("./" + nomeImagem + idiomaImagem + '.png');
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    this.$store.dispatch('tentativas').then(function (response) {
      _this4.isProbableABot = response.triesAmount >= 5;
    });
    if (localStorage.getItem('SESSION_ERR')) {
      this.$root.$refs.notification.warning(localStorage.getItem('SESSION_ERR'));
      localStorage.removeItem('SESSION_ERR');
    }

    if (localStorage.getItem('UNAUTHORIZED') === 'UNAUTHORIZED') {
      this.$root.$refs.notification.warning('naoAutorizado.labels.mensagem401');
    } else if (localStorage.getItem('SESSION_ERR')) {
      this.$root.$refs.notification.warning(localStorage.getItem('SESSION_ERR'));
      localStorage.removeItem('SESSION_ERR');
    }

    localStorage.setItem('UNAUTHORIZED', null);

    _index2.default.changeLanguage(_index2.default.getCookieByName('language'));

    switch (_index2.default.getCookieByName('language')) {
      case 'pt':
        $('.btn-pt').addClass('btn-ativo');
        break;
      case 'in':
        $('.btn-in').addClass('btn-ativo');
        break;
      case 'es':
        $('.btn-es').addClass('btn-ativo');
        break;
      default:
        break;
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 890 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/login/LoginEmulado.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(/*! ../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'LoginEmulado',

  data: function data() {
    return {
      isLogin: false
    };
  },


  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      var lang = this.$route.query.idioma;
      localStorage.removeItem('token');
      _index2.default.setLanguageEmulatedLogin(lang);
      this.$store.dispatch('loginEmulado', { token: this.$route.query.token }).then(function (response) {
        _this.$store.dispatch('setPerfilAcesso', { id: response.perfilAcesso.id, nome: response.perfilAcesso.nome });
        _this.$store.dispatch('setClientEmulatedLogin', { client: response.cliente.id, clientName: response.cliente.nomeFantasia, singleClient: true }).then(function (response) {
          _this.$store.dispatch('getFuncionalities').then(function (response) {
            _this.isLoadingData = false;
            _this.funcionalitiesGroup = response.data.funcList;
            _this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc).then(function (response) {
              location.href = _routesMap2.default.HOME;
            });
          });
        });
      }).catch(function (error) {
        _this.$store.dispatch('logout').then(function () {
          _this.$root.$refs.notification.error(error.message);
          _this.$router.push(_routesMap2.default.LOGIN);
        });
      });
    }
  },

  created: function created() {
    this.login();
  }
};

/***/ }),
/* 891 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/login/TrocaAplicacao.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(/*! ../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TrocaAplicacao',

  data: function data() {
    return {
      isLogin: false
    };
  },


  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      var lang = this.$route.query.idioma;
      _index2.default.changeLanguage(lang);
      this.$store.dispatch('loginTrocaAplicacao', { token: this.$route.query.token }).then(function (response) {
        _this.$store.dispatch('getClients').then(function (clients) {
          _this.$store.dispatch('getFuncionalities').then(function (response) {
            _this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc);
          });
          _this.$store.dispatch('setClient', { client: response.cliente.id, clientName: response.cliente.nomeFantasia, singleClient: clients && clients.length === 1 }).then(function (response) {
            location.href = _routesMap2.default.HOME;
          });
        }).catch(function (error) {
          _this.$store.dispatch('logout').then(function () {
            _this.$root.$refs.notification.error(error.message);
            _this.$router.push(_routesMap2.default.LOGIN);
          });
        });
      }).catch(function (error) {
        _this.$store.dispatch('logout').then(function () {
          _this.$root.$refs.notification.error(error.message);
          _this.$router.push(_routesMap2.default.LOGIN);
        });
      });
    }
  },

  created: function created() {
    this.login();
  }
};

/***/ }),
/* 892 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/notFound/NotFound.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'NotFound',

  components: {
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      imageNotFound: __webpack_require__(/*! ../../../assets/notFound/notFound.png */ 1244)
    };
  },


  computed: {
    client: function client() {
      return this.$store.getters.client;
    }
  },

  methods: {
    goHome: function goHome() {
      location.href = this.client ? _routesMap2.default.HOME : _routesMap2.default.LOGIN;
    }
  }
};

/***/ }),
/* 893 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/attributesSet/List.vue ***!
  \*********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeViewAtt = __webpack_require__(/*! ../../../registration/attributesSet/TreeViewAtt */ 691);

var _TreeViewAtt2 = _interopRequireDefault(_TreeViewAtt);

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AttributesSetList',

  components: {
    PageTitle: _PageTitle2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    VueDragTree: _TreeViewAtt2.default,
    ConfirmModal: _ConfirmModal2.default
  },

  data: function data() {
    return {
      attributesSet: [],
      treeViewButtonTitle: {
        config: this.$t('conjuntoAtributo.labels.gerenciar'),
        edit: this.$t('categoria.labels.editar'),
        create: this.$t('conjuntoAtributo.labels.criar'),
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher'),
        remove: this.$t('planoConciliacao.labels.remover'),
        removeBloq: this.$t('conjuntoAtributo.labels.removerBloqueado')
      },
      linkTypes: [{
        type: 'E',
        description: this.$t('conjuntoAtributo.labels.E')
      }, {
        type: 'MF',
        description: this.$t('conjuntoAtributo.labels.MF')
      }, {
        type: 'CL',
        description: this.$t('conjuntoAtributo.labels.CL')
      }],
      attSetIdToRemove: null
    };
  },


  computed: {
    canCreate: function canCreate() {
      return this.verifySetTypes();
    }
  },

  methods: {
    loadAttributesSet: function loadAttributesSet() {
      var _this = this;

      this.$store.dispatch('getAttributesSet').then(function (attributesSetList) {
        _this.attributesSet = attributesSetList;
      }).catch(function (error) {
        _this.$root.$refs.notification.error(error.message);
      });
    },
    createEditAttribute: function createEditAttribute(attributeId, set, isEdit) {
      if (isEdit) {
        (0, _analytics.trackAnalyticsEvent)(this, 'attribute-click', 'edit-attribute', attributeId);
        this.editAttribute(attributeId, set);
      }
    },
    newAttribute: function newAttribute(set) {
      this.$store.dispatch('clearEditAttributeSet');
      this.$store.dispatch('setAttributesSetList', this.attributesSet);
      this.$router.push(_routesMap2.default.NEW_ATTRIBUTES_SET);
    },
    editAttribute: function editAttribute(attributeId, set) {
      var _this2 = this;

      this.$store.dispatch('getAttributeSetById', attributeId).then(function (attributeSet) {
        _this2.$store.dispatch('setAttributesSetToEdit', attributeSet);
        _this2.$store.dispatch('setAttributesSetList', _this2.attributesSet);
        _this2.$router.push(_routesMap2.default.NEW_ATTRIBUTES_SET);
      }).catch(function (error) {
        return _this2.$root.$refs.notification.error(error.message);
      });
    },
    handleRemove: function handleRemove(attSetIdToRemove) {
      this.attSetIdToRemove = attSetIdToRemove;
      $('#confirmRemoveAttSet').modal('show');
    },
    removeAttSet: function removeAttSet() {
      var _this3 = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'remove-click', 'remove-att-cfg', 'remove-att-cfg');
      if (this.attSetIdToRemove) {
        this.$store.dispatch('removeAttributeSet', this.attSetIdToRemove).then(function (response) {
          _this3.$root.$refs.notification.success('conjuntoAtributo.sucesso.remover');
          _this3.attSetIdToRemove = null;
          $('#confirmRemoveAttSet').modal('hide');
          _this3.loadAttributesSet();
          _this3.$store.dispatch('clearAttributeList');
          _this3.$store.dispatch('clearEditAttributeSet');
        }).catch(function (error) {
          _this3.$root.$refs.notification.error(error.message);
        });
      }
    },
    closeModalConfirm: function closeModalConfirm() {
      this.attSetIdToRemove = null;
      $('#confirmRemoveAttSet').modal('hide');
    },
    verifySetTypes: function verifySetTypes() {
      var _this4 = this;

      var aviables = this.linkTypes.filter(function (type) {
        var link = _this4.attributesSet.find(function (item) {
          return item.linkType === type.type;
        });
        return link === undefined || link === null;
      });
      return aviables && aviables.length > 0;
    }
  },

  created: function created() {
    this.loadAttributesSet();
    this.$store.dispatch('clearAttributeList');
    this.$store.dispatch('clearEditAttributeSet');
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 894 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/attributesSet/New.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = __webpack_require__(/*! babel-runtime/core-js/set */ 204);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vuedraggable = __webpack_require__(/*! vuedraggable */ 197);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _Attribute = __webpack_require__(/*! ../../../registration/attributesSet/Attribute */ 1292);

var _Attribute2 = _interopRequireDefault(_Attribute);

var _NewAtributeModal = __webpack_require__(/*! ../../../registration/attributesSet/NewAtributeModal */ 1293);

var _NewAtributeModal2 = _interopRequireDefault(_NewAtributeModal);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AttributesSetNew',

  components: {
    vSelect: _vueSelect2.default,
    Draggable: _vuedraggable2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    Attribute: _Attribute2.default,
    NewAttributeModal: _NewAtributeModal2.default
  },

  data: function data() {
    return {
      requestSent: false,
      editingAttribute: {},
      isLoadingData: false,
      attributeSet: {
        id: null,
        name: '',
        linkType: {
          type: null,
          description: null
        },
        inUse: false
      },
      linkTypes: [{
        type: 'E',
        description: this.$t('conjuntoAtributo.labels.E')
      }, {
        type: 'MF',
        description: this.$t('conjuntoAtributo.labels.MF')
      }, {
        type: 'CL',
        description: this.$t('conjuntoAtributo.labels.CL')
      }],
      attributes: [],
      shown: false
    };
  },


  computed: {
    attributeSetToEdit: function attributeSetToEdit() {
      return this.$store.getters.attributeSetToEdit;
    },
    attTypesAviable: function attTypesAviable() {
      var _this = this;

      var aviables = [];
      if (!!this.$store.getters.attributesSetList && this.$store.getters.attributesSetList.length > 0) {
        aviables = this.linkTypes.filter(function (type) {
          var link = _this.$store.getters.attributesSetList.find(function (item) {
            return item.linkType === type.type;
          });
          return link === undefined || link === null;
        });
      } else {
        aviables = this.linkTypes;
      }
      return aviables;
    }
  },

  watch: {
    attributeSet: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, (0, _assign2.default)({}, this.attributeSet, { attributes: [].concat((0, _toConsumableArray3.default)(this.attributes)) })));
      },

      deep: true
    },
    attributes: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, (0, _assign2.default)({}, this.attributeSet, { attributes: [].concat((0, _toConsumableArray3.default)(this.attributes)) })));
      },

      deep: true
    }
  },

  methods: {
    updateAttributesList: function updateAttributesList(newList) {
      this.attributes = newList;
      this.$root.$refs.notification.info('conjuntoAtributo.sucesso.adicionadoOk');
    },
    createOrEditAttribute: function createOrEditAttribute(attOrder) {
      if (!attOrder) {
        this.editingAttribute = null;
      } else {
        this.editingAttribute = this.attributes[attOrder - 1];
        (0, _analytics.trackAnalyticsEvent)(this, 'action-click', 'edit-atributo', attOrder);
      }
      this.shown = true;
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (!_this2.checkAttributesWithSameName()) {
          _this2.$root.$refs.notification.error('conjuntoAtributo.erro.nomesDuplicados', 'conjuntoAtributo.erro.criarConjunto');
        } else if (result) {
          _this2.saveAttributeSet({
            id: _this2.attributeSet.id,
            name: _this2.attributeSet.name,
            linkType: _this2.attributeSet.linkType,
            attributes: _this2.attributes
          });
        } else {
          _this2.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'conjuntoAtributo.erro.criarConjunto');
        }
      });
    },
    checkAttributesWithSameName: function checkAttributesWithSameName() {
      var attributeNames = this.attributes.map(function (att) {
        return att.name;
      });
      return attributeNames.length === new _set2.default(attributeNames).size;
    },
    backToList: function backToList() {
      this.$router.push(_routesMap2.default.LIST_ATTRIBUTES_SET);
    },
    saveAttributeSet: function saveAttributeSet(attributeSet) {
      var _this3 = this;

      this.requestSent = true;
      this.$store.dispatch('saveAttributeSet', attributeSet).then(function (response) {
        _this3.$root.$refs.notification.success(response.message);
        _this3.$store.dispatch('setHasUnsavedChanges', false);
        _this3.$router.push(_routesMap2.default.LIST_ATTRIBUTES_SET);
      }).catch(function (err) {
        _this3.$root.$refs.notification.error(err.message);
        if (_this3.attributeSetToEdit && _this3.attributeSetToEdit.id) {
          _this3.$store.dispatch('getAttributeSetById', _this3.attributeSetToEdit.id).then(function (attributeSet) {
            _this3.$store.dispatch('setAttributesSetToEdit', attributeSet);
          }).catch(function (error) {
            return _this3.$root.$refs.notification.error(error.message);
          });
        }
      }).finally(function () {
        _this3.requestSent = false;
      });
    },
    removeAttributeHandler: function removeAttributeHandler(attOrder) {
      (0, _analytics.trackAnalyticsEvent)(this, 'action-click', 'remove-atributo', attOrder);
      this.attributes.splice(attOrder - 1, 1);
    }
  },

  created: function created() {
    if (this.attributeSetToEdit) {
      this.attributeSet = (0, _assign2.default)({}, this.attributeSetToEdit);
      this.attributeSet.linkType.description = this.$t(this.attributeSet.linkType.description);
      this.attributes = [].concat((0, _toConsumableArray3.default)(this.attributeSet.attributes));
    }
    this.defaultObject = (0, _assign2.default)({}, this.attributeSet, { attributes: [].concat((0, _toConsumableArray3.default)(this.attributes)) });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
  }
};

/***/ }),
/* 895 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/bankAccounts/BelvoWidget.vue ***!
  \***************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _customValidator = __webpack_require__(/*! ../../../../utils/customValidator.js */ 106);

var _customValidator2 = _interopRequireDefault(_customValidator);

var _codigoBancoBelvo = __webpack_require__(/*! ../../../../enum/codigoBancoBelvo.js */ 746);

var _vueTheMask = __webpack_require__(/*! vue-the-mask */ 133);

var _vueJsToggleButton = __webpack_require__(/*! vue-js-toggle-button */ 689);

var _veeValidate = __webpack_require__(/*! vee-validate */ 686);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BelvoWidget',

  props: {
    showOpenFinance: {
      type: Boolean,
      default: false
    },
    bankAccount: {
      type: Object,
      required: true
    },
    linkOFDA: {
      type: String
    }
  },

  components: {
    ButtonPrimary: _ButtonPrimary2.default,
    TheMask: _vueTheMask.TheMask,
    ToggleButton: _vueJsToggleButton.ToggleButton
  },

  watch: {
    bankAccount: {
      handler: function handler() {
        this.enableOfdaForm = !!(this.bankAccount && this.bankAccount.optIn && this.bankAccount.optIn.id);
      },

      deep: true
    }
  },

  data: function data() {
    return {
      belvoToken: {},
      cpf: null,
      cnpj: null,
      requisitante: '',
      empresa: '',
      tipoConta: 'PF',
      link: null,
      enableOfdaForm: false
    };
  },


  methods: {
    activeWidgetBelvo: function activeWidgetBelvo() {
      var _this = this;

      var institutionsList = (0, _codigoBancoBelvo.getBelvoInstitutionsByCdBankPersonType)(this.bankAccount.bank.codigo, this.tipoConta);
      if (institutionsList.length <= 0) {
        this.$root.$refs.notification.warning(this.$t('ofda.nenhumaInstituicaoHomologada'));
        this.$store.dispatch('setHasUnsavedChanges', false);
        this.$store.dispatch('cleanBankAccountToEdit');
        location.href = _routesMap2.default.LIST_BANK_ACCOUNTS;
      } else {
        return new _promise2.default(function (resolve, reject) {
          var body = {
            user: {
              name: _this.requisitante,
              registration: _this.cpf
            },
            bankAccountData: _this.bankAccount.bank.codigo + '|' + _this.bankAccount.agency + '|' + _this.bankAccount.accountNumber
          };

          if (_this.tipoConta === 'PJ') {
            body.company = {
              name: _this.empresa,
              registration: _this.cnpj
            };
          }

          _axiosCommon2.default.post('/ofda/generateOFDAAccess', body).then(function (response) {
            _this.belvoToken = response.data;
            _this.createWidget();
            resolve();
          }).catch(function (err) {
            _this.$root.$refs.notification.error(err.message);
            reject();
          });
        });
      }
    },
    createWidget: function createWidget() {
      var successCallbackFunction = function successCallbackFunction(link, institution) {};
      var onExitCallbackFunction = function onExitCallbackFunction(data) {};
      var onEventCallbackFunction = function onEventCallbackFunction(data) {};

      var config = {
        integration_type: 'openfinance',
        callback: function callback(link, institution) {
          return successCallbackFunction(link, institution);
        },
        onExit: function onExit(data) {
          return onExitCallbackFunction(data);
        },
        onEvent: function onEvent(data) {
          return onEventCallbackFunction(data);
        },
        country_codes: ['BR'],
        locale: 'pt',
        institutions: (0, _codigoBancoBelvo.getBelvoInstitutionsByCdBankPersonType)(this.bankAccount.bank.codigo, this.tipoConta),
        show_close_dialog: true,
        show_abandon_survey: true,
        institution_types: ['retail', 'business']
      };
      window.belvoSDK.createWidget(this.belvoToken.access, config).build();
    },
    loadScript: function loadScript(src) {
      var node = document.createElement('script');
      node.src = src;
      node.type = 'text/javascript';
      node.async = true;

      node.onload = this.createWidget;

      document.body.appendChild(node);
    }
  },

  created: function created() {
    var _this2 = this;

    this.requisitante = this.$store.getters.user;
    this.empresa = this.$store.getters.clientName;

    _veeValidate.Validator.extend('cnpjValido', {
      getMessage: function getMessage(field) {
        return _this2.$t('estabelecimentos.erro.cnpjInvalido');
      },
      validate: function validate(value) {
        return _customValidator2.default.validateCnpj(value);
      }
    });

    _veeValidate.Validator.extend('cpfValido', {
      getMessage: function getMessage(field) {
        return _this2.$t('estabelecimentos.erro.cpfInvalido');
      },
      validate: function validate(value) {
        return _customValidator2.default.validateCpf(value);
      }
    });
  },
  mounted: function mounted() {
    this.loadScript('https://cdn.belvo.io/belvo-widget-1-stable.js');
  }
};

/***/ }),
/* 896 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/bankAccounts/List.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _maxSafeInteger = __webpack_require__(/*! babel-runtime/core-js/number/max-safe-integer */ 203);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _vueTables = __webpack_require__(/*! vue-tables-2 */ 132);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _customFilters = __webpack_require__(/*! ../../../../utils/customFilters.js */ 135);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templatesWhenIsLoaded = {
  nome: function nome(h, row) {
    return row.nome;
  },
  banco: function banco(h, row) {
    return row.banco.codigo + '-' + row.banco.nomeFantasia;
  },
  agencia: function agencia(h, row) {
    return row.numAgencia + (row.digAgencia ? '-' + row.digAgencia : '');
  },
  conta: function conta(h, row) {
    return row.conta + (row.digConta ? '-' + row.digConta : '');
  },
  ofdaStatus: function ofdaStatus(h, row) {
    return row.ofdaStatusText;
  },
  status: function status(h, row) {
    return row.statusText;
  }
};

exports.default = {
  name: 'BankAccountsList',

  components: {
    PageTitle: _PageTitle2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    LoadingPlaceholder: _LoadingPlaceholder2.default,
    ConfirmModal: _ConfirmModal2.default
  },

  data: function data() {
    return {
      bankAccountIdToRemove: null,
      requestSentRemove: false,
      isLoadingData: true,
      showToggleInactiveAccounts: false,
      showInactiveAccounts: false,
      allBankAccounts: null,
      bankAccounts: (0, _gridLoadTransition.generateLoadingRows)(10),
      columns: ['nome', 'banco', 'agencia', 'conta', 'ofdaStatus', 'status', 'acoes'],
      options: {
        columnsClasses: { 'acoes': 'col-md-1', 'nome': 'col-md-2', 'banco': 'col-md-2', 'agencia': 'col-md-2', 'numeroConta': 'col-md-2', 'status': 'col-md-1', 'ofdaStatus': 'col-md-2' },
        headings: {
          conta: this.$t('contaBancaria.labels.numeroConta'),
          agencia: this.$t('contaBancaria.labels.agencia'),
          banco: this.$t('contaBancaria.labels.banco'),
          nome: this.$t('contaBancaria.labels.nome'),
          ofdaStatus: this.$t('ofda.titulo'),
          status: this.$t('contaBancaria.labels.status'),
          acoes: this.$t('administracao.perfilAcesso.labels.acoes')
        },
        templates: {
          banco: _LoadingPlaceholder2.default,
          agencia: _LoadingPlaceholder2.default,
          conta: _LoadingPlaceholder2.default,
          acoes: _LoadingPlaceholder2.default,
          status: _LoadingPlaceholder2.default,
          ofdaStatus: _LoadingPlaceholder2.default,
          nome: _LoadingPlaceholder2.default
        },
        filterable: ['nome'],
        customFilters: [{
          name: 'banco',
          callback: _customFilters.filterByBank
        }, {
          name: 'agencia',
          callback: _customFilters.filterByAgency
        }, {
          name: 'conta',
          callback: _customFilters.filterByAccount
        }, {
          name: 'status',
          callback: _customFilters.filterByStatus
        }],
        filterByColumn: true,
        perPageValues: [],
        texts: {
          count: '',
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortable: ['nome', 'banco', 'agencia', 'conta', 'status', 'ofdaStatus'],
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 },
        perPage: _maxSafeInteger2.default,
        customSorting: {
          banco: function banco(ascending) {
            return function (a, b) {
              var lastA = a.banco.codigo;
              var lastB = b.banco.codigo;
              if (ascending) {
                return lastA <= lastB ? 1 : -1;
              }
              return lastA >= lastB ? 1 : -1;
            };
          },
          agencia: function agencia(ascending) {
            return function (a, b) {
              var lastA = a.agencia;
              lastA.agencia = a.numAgencia + (a.digAgencia ? '-' + a.digAgencia : '');

              var lastB = b.agencia;
              lastB.agencia = b.numAgencia + (b.digAgencia ? '-' + b.digAgencia : '');

              return _customSorter2.default.stringSorter(ascending, lastA, lastB, 'agencia');
            };
          },
          conta: function conta(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'conta');
            };
          },
          nome: function nome(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'nome');
            };
          },
          status: function status(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'statusText');
            };
          }
        },
        cellClasses: {
          ofdaStatus: [{
            class: 'status-aceite-3',
            condition: function condition(row) {
              return !row.optIn;
            }
          }, {
            class: 'status-aceite-0',
            condition: function condition(row) {
              return row.optIn && row.optIn.statusAceite === '0';
            }
          }, {
            class: 'status-aceite-1',
            condition: function condition(row) {
              return row.optIn && (!!row.optIn.belvoLinkId && row.optIn.statusAceite === '2' || row.optIn.statusAceite === '1');
            }
          }, {
            class: 'status-aceite-3',
            condition: function condition(row) {
              return row.optIn && !row.optIn.belvoLinkId && row.optIn.statusAceite === '2';
            }
          }]
        }
      }
    };
  },


  methods: {
    handleFilter: function handleFilter(event, column) {
      _vueTables.Event.$emit('vue-tables.filter::' + column, event.currentTarget.value);
    },
    edit: function edit(bankAccountId) {
      var _this = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'edit-click', 'edit-conta-bancaria', 'edit-conta-bancaria');

      this.$store.dispatch('setBankAccountToEdit', bankAccountId).then(function (response) {
        _this.$router.push(_routesMap2.default.NEW_BANK_ACCOUNT);
      });
    },
    newBankAccount: function newBankAccount() {
      this.$router.push(_routesMap2.default.NEW_BANK_ACCOUNT);
    },
    loadBankAccounts: function loadBankAccounts() {
      var _this2 = this;

      var url = '/bankAccounts/';
      this.isLoadingData = true;
      this.$store.dispatch('getBankAccounts', url).then(function (response) {
        _this2.allBankAccounts = response.data.data;
        _this2.allBankAccounts.map(function (acc) {
          acc.statusText = acc.ativo ? _this2.$t('contaBancaria.labels.ativa') : _this2.$t('contaBancaria.labels.inativa');
          if (acc.optIn) {
            if (acc.optIn.statusAceite === '0') {
              acc.ofdaStatusText = _this2.$t('ofda.statusAceite.revogado');
            } else if (acc.optIn.statusAceite === '2') {
              acc.ofdaStatusText = _this2.$t('ofda.statusAceite.autorizar');
            } else if (acc.optIn.statusAceite === '1') {
              acc.ofdaStatusText = _this2.$t('ofda.statusAceite.autorizado');
            }
          } else {
            acc.ofdaStatusText = _this2.$t('ofda.statusAceite.autorizar');
          }
        });
        _this2.showAccounts();
        _this2.isLoadingData = false;
        _this2.options.templates = templatesWhenIsLoaded;
      }).catch(function (error) {
        _this2.$root.$refs.notification.error(error.message);
      });
    },
    showAccounts: function showAccounts() {
      this.bankAccounts = this.allBankAccounts;
    },
    handleRemove: function handleRemove(bankAccountIdToRemove) {
      this.bankAccountIdToRemove = bankAccountIdToRemove;
      $('#confirmRemoveBankAccount').modal('show');
    },
    remove: function remove() {
      var _this3 = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'remove-click', 'remove-conta-bancaria', 'remove-conta-bancaria');
      if (this.bankAccountIdToRemove) {
        this.requestSentRemove = true;
        this.$store.dispatch('removeBankAccount', this.bankAccountIdToRemove).then(function (response) {
          _this3.$root.$refs.notification.success('contaBancaria.sucesso.remover');
          _this3.bankAccountIdToRemove = null;
          $('#confirmRemoveBankAccount').modal('hide');
          _this3.loadBankAccounts();
        }).catch(function (error) {
          _this3.$root.$refs.notification.error(error.message);
        }).finally(function () {
          _this3.requestSentRemove = false;
        });
      }
    },
    closeModalConfirm: function closeModalConfirm() {
      this.bankAccountIdToRemove = null;
      $('#confirmRemoveBankAccount').modal('hide');
    }
  },

  created: function created() {
    this.loadBankAccounts();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 897 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/bankAccounts/New.vue ***!
  \*******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 137);

var _typeof3 = _interopRequireDefault(_typeof2);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vueTheMask = __webpack_require__(/*! vue-the-mask */ 133);

var _vMoney = __webpack_require__(/*! v-money */ 195);

var _vuejsDatepicker = __webpack_require__(/*! vuejs-datepicker */ 101);

var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _customValidator = __webpack_require__(/*! ../../../../utils/customValidator.js */ 106);

var _customValidator2 = _interopRequireDefault(_customValidator);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

var _BelvoWidget = __webpack_require__(/*! ./BelvoWidget.vue */ 1334);

var _BelvoWidget2 = _interopRequireDefault(_BelvoWidget);

var _pluggyConnectorsMap = __webpack_require__(/*! ../../../../enum/pluggyConnectorsMap.js */ 749);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BankAccountsNew',

  components: {
    vSelect: _vueSelect2.default,
    TheMask: _vueTheMask.TheMask,
    Money: _vMoney.Money,
    Datepicker: _vuejsDatepicker2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    BelvoWidget: _BelvoWidget2.default
  },

  data: function data() {
    return {
      requestSent: false,
      banks: [],
      establishmentsGroup: [],
      bankSelected: null,
      bankAccount: {
        bank: null,
        name: null,
        accountNumber: null,
        agency: null,
        startBalance: '',
        startBalanceDate: null,
        agencyDigit: null,
        accountDigit: null,
        ativo: true,
        group: null,
        inUse: false,
        ofdaAtivo: false
      },
      operator: {
        accessProfileId: null
      },
      profiles: [],
      inputAgencyDigit: null,
      inputAccountDigit: null,
      maskTokens: {
        D: {
          pattern: /[0-9]/
        },
        X: {
          pattern: /\w/
        }
      },
      idioma: _index2.default,
      invalid: null,
      moneyMask: {},
      inputDate: null,
      belvoToken: {},
      enableOfdaForm: false,
      ofdaAccountType: 'PF',
      hasLinkIdUpdated: false
    };
  },


  computed: {
    bankAccountToEdit: function bankAccountToEdit() {
      return this.$store.getters.bankAccounttoEditId;
    },
    portletTitle: function portletTitle() {
      return this.bankAccountToEdit ? this.$t('contaBancaria.titulos.editarContaBancaria') : this.$t('contaBancaria.titulos.novaContaBancaria');
    },
    banksList: function banksList() {
      return _underscore2.default.sortBy(this.banks, function (item) {
        return _customSorter2.default.cleanLowerString(item.nome);
      }, 'asc');
    },
    datePickerLanguage: function datePickerLanguage() {
      return this.idioma.getDatePickerLanguageObject();
    },
    moneyMaskLength: function moneyMaskLength() {
      return this.idioma.getDatePickerLanguage() === 'pt-br' ? 24 : 23;
    },
    establishmentsGroupList: function establishmentsGroupList() {
      return _underscore2.default.sortBy(this.establishmentsGroup, function (item) {
        return _customSorter2.default.cleanLowerString(item.nome);
      }, 'asc');
    },
    stylizeGroupLabel: function stylizeGroupLabel() {
      var _this = this;

      return function (option) {
        var result = null;
        if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
          if (_this.label && option[_this.label]) {
            result = option[_this.label];
          } else {
            result = option['nome'];
          }
        } else {
          result = option + ' (' + _this.$t('inputTag.labels.novo') + ')';
        }
        return result;
      };
    },
    groupInput: function groupInput() {
      return this.bankAccount.group;
    },
    showOpenFinance: function showOpenFinance() {
      return this.$store.getters.allowedFuncionalities.includes(4007);
    }
  },

  watch: {
    bankAccount: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, this.bankAccount));
      },

      deep: true
    },
    groupInput: function groupInput() {
      if (this.bankAccount.group && !this.bankAccount.group.nome) {
        this.bankAccount.group = { nome: this.bankAccount.group };
      }
      if (this.bankAccount.group && this.bankAccount.group.nome && this.bankAccount.group.nome.length > 20) {
        this.bankAccount.group.nome = this.bankAccount.group.nome.slice(0, 20);
      } else {
        this.bankAccount.group = this.bankAccount.group;
      }
    }
  },

  methods: {
    handleGroupChange: function handleGroupChange(group) {
      this.bankAccount.group = group;
    },
    loadBanks: function loadBanks() {
      var _this2 = this;

      this.$store.dispatch('getBanks').then(function (response) {
        _this2.banks = response.data.data;
        _this2.banks.forEach(function (bank) {
          bank.label = bank.codigo + '-' + bank.nomeFantasia;
        });
        if (_this2.bankAccountToEdit) {
          _this2.loadBankAccount();
        } else {
          _this2.defaultObject = (0, _assign2.default)({}, _this2.bankAccount);
        }
      });
    },
    newBankAccount: function newBankAccount() {
      var _this3 = this;

      var accountCopy = (0, _assign2.default)({}, this.bankAccount);
      accountCopy.id = this.bankAccountToEdit;
      if (typeof accountCopy.startBalance === 'string' && accountCopy.startBalance === '') {
        accountCopy.startBalance = 0;
      } else {
        accountCopy.startBalance = this.removeBankAccountMask();
      }
      accountCopy.ofdaAtivo = this.enableOfdaForm;
      this.requestSent = true;
      this.$store.dispatch('newBankAccount', accountCopy).then(function (response) {
        _this3.$root.$refs.notification.success(response.data.message);
        _this3.$store.dispatch('setHasUnsavedChanges', false);
        if (_this3.enableOfdaForm) {
          _this3.openPluggyWidget();
        } else {
          _this3.$router.push(_routesMap2.default.LIST_BANK_ACCOUNTS);
        }
      }).catch(function (error) {
        if (typeof _this3.bankAccount.startBalance === 'number' && _this3.bankAccount.startBalance === 0) {
          _this3.bankAccount.startBalance = '';
        }
        _this3.$root.$refs.notification.error(error.message);
      }).finally(function () {
        _this3.requestSent = false;
      });
    },
    removeBankAccountMask: function removeBankAccountMask() {
      var splittedStartBalance = this.bankAccount.startBalance.toString().split(' ');

      if (this.bankAccount.startBalance && splittedStartBalance.length > 1) {
        return splittedStartBalance[1].replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1');
      }
      return this.bankAccount.startBalance.replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1');
    },
    loadBankAccount: function loadBankAccount() {
      var self = this;
      this.$store.dispatch('getBankAccount', this.bankAccountToEdit).then(function (response) {
        self.bankAccount.bank = {};
        var bankAccountLoaded = response.data.data;
        self.bankAccount.name = bankAccountLoaded.nome;
        self.bankAccount.agency = bankAccountLoaded.numAgencia;
        self.bankAccount.agencyDigit = bankAccountLoaded.digAgencia;
        self.bankAccount.accountDigit = bankAccountLoaded.digConta;
        self.bankAccount.accountNumber = bankAccountLoaded.conta;
        self.bankAccount.bank.codigo = bankAccountLoaded.banco ? bankAccountLoaded.banco.codigo : null;
        self.bankAccount.bank.nome = bankAccountLoaded.banco ? bankAccountLoaded.banco.nome : null;
        self.bankAccount.bank.label = bankAccountLoaded.banco.codigo + '-' + bankAccountLoaded.banco.nomeFantasia;
        self.bankAccount.startBalance = bankAccountLoaded.saldoInicial !== null ? bankAccountLoaded.saldoInicial.toFixed(2) : '';
        self.bankAccount.startBalanceDate = bankAccountLoaded.dataSaldoInicial;
        self.bankAccount.ativo = bankAccountLoaded.ativo;
        self.bankAccount.group = bankAccountLoaded.grupo;
        self.bankAccount.inUse = bankAccountLoaded.contaEmUso;
        self.bankAccount.linkId = bankAccountLoaded.linkId;
        self.bankAccount.institutionOFDA = bankAccountLoaded.institutionOFDA;
        self.bankAccount.optIn = (0, _assign2.default)({}, bankAccountLoaded.optIn);
        self.defaultObject = (0, _assign2.default)({}, self.bankAccount);
      });
    },
    validate: function validate(event) {
      var _this4 = this;

      event.preventDefault();
      this.$validator.validateAll('formNew').then(function (result) {
        if (result && _this4.isBalanceFieldsValid()) {
          _this4.newBankAccount();
        } else {
          _this4.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'contaBancaria.erro.salvar');
        }
      });
    },
    back: function back() {
      this.$router.push(_routesMap2.default.LIST_BANK_ACCOUNTS);
    },
    uniCharCode: function uniCharCode(event) {
      if (event) {
        var char = event.which || event.keyCode;

        if (!(char >= 96 && char <= 105 || char === 16 || char === 88 || char >= 48 && char <= 57) || event.shiftKey && event.key !== 'X') {
          if (event.currentTarget.id === 'agencyDigit') {
            this.inputAgencyDigit.value = null;
            this.bankAccount.agencyDigit = null;
          } else {
            this.inputAccountDigit.value = null;
            this.bankAccount.accountDigit = null;
          }
        }
      }
    },
    isBalanceFieldsValid: function isBalanceFieldsValid() {
      var isValid = this.$refs.money.$el.value !== '' && this.bankAccount.startBalanceDate !== null || this.$refs.money.$el.value === '' && this.bankAccount.startBalanceDate == null;

      if (!isValid) {
        if (this.$refs.money.$el.value === '') {
          this.errors.add('startBalance', 'balance');
          this.errors.remove('startBalanceDate');
        } else {
          this.errors.add('startBalanceDate', 'balance');
          this.errors.remove('startBalance');
        }
      } else {
        this.errors.remove('startBalance');
        this.errors.remove('startBalanceDate');
      }
      return isValid;
    },
    input: function input() {
      this.validateDate();
    },
    validateDate: function validateDate() {
      var isValid = this.inputDate.value.length === 10 && _customValidator2.default.isValidDate(this.inputDate.value);
      if (!isValid) {
        this.$refs.startBalanceDate.$children.find(function (item) {
          return !!item.id;
        }).typedDate = '';
      }
    },
    loadEstablishmentGroups: function loadEstablishmentGroups() {
      var _this5 = this;

      this.$store.dispatch('getEstablishmentGroups').then(function (response) {
        _this5.establishmentsGroup = response;
      }).catch(function (error) {
        _this5.$root.$refs.notification.error(error.message);
      });
    },
    getlinkIdLoaded: function getlinkIdLoaded() {
      return this.bankAccount !== null ? this.bankAccount.linkId : null;
    },
    loadScript: function loadScript(src) {
      return new _promise2.default(function (resolve, reject) {
        if (window.PluggyConnect) {
          return resolve();
        }

        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    openPluggyWidget: function openPluggyWidget() {
      var _this6 = this;

      var self = this;
      this.loadScript('https://cdn.pluggy.ai/pluggy-connect/v2.8.2/pluggy-connect.js');
      _axiosCommon2.default.post('/ofda/generatePluggyAccessToken', {}).then(function (response) {
        var userToken = response.data;
        var widgetConfig = {
          connectToken: userToken.accessToken,
          includeSandbox: false,
          onSuccess: function onSuccess(connection) {
            _this6.startLinkUpdate(connection);
          },
          onEvent: function onEvent(event) {
            switch (event.event) {
              case 'ITEM_RESPONSE':
                if (!self.hasLinkIdUpdated) {
                  self.hasLinkIdUpdated = true;
                  if (self.bankAccount) {
                    self.registerLink(event.item);
                  }
                }
                break;
              default:
                break;
            }
          },
          onClose: function onClose() {
            _this6.$router.push(_routesMap2.default.LIST_BANK_ACCOUNTS);
          }
        };

        var connectorIds = (0, _pluggyConnectorsMap.getPluggyConnectorCodeByCdBankPersonType)(_this6.bankAccount.bank.codigo, _this6.ofdaAccountType);
        if (connectorIds.length === 1) {
          widgetConfig.selectedConnectorId = connectorIds[0];
        } else {
          widgetConfig.connectorIds = connectorIds;
        }

        self.pluggyInstance = new window.PluggyConnect(widgetConfig);
        self.pluggyInstance.init();
      }).catch(function (err) {
        self.$root.$refs.notification.error(err.message);
      });
    },
    registerLink: function registerLink(item) {
      var _this7 = this;

      var account = {
        id: this.bankAccountToEdit,
        bank: this.bankAccount.bank,
        name: this.bankAccount.name,
        accountNumber: this.bankAccount.accountNumber,
        agency: this.bankAccount.agency,
        linkId: item.id,
        linkIdOld: this.bankAccount && this.bankAccount.optIn ? this.bankAccount.optIn.linkId : null,
        institutionOFDA: item.connector.id
      };

      _axiosCommon2.default.post('/bankAccounts/linkAccoutToOFDA', account).then(function (responseSaveAcc) {
        _this7.$root.$refs.notification.info('ItemId associado ao optIn da conta com sucesso.');
      }).catch(function () {
        _this7.$root.$refs.notification.error('Erro ao associar ItemId a conta bancaria.');
      });
    },
    startLinkUpdate: function startLinkUpdate() {
      var _this8 = this;

      var account = (0, _assign2.default)({}, this.bankAccount);
      account.id = this.bankAccountToEdit;
      account.startBalance = null;

      _axiosCommon2.default.post('/bankAccounts/activateOptIn', account).then(function (responseSaveAcc) {
        _this8.$root.$refs.notification.info('Ativação do opt-in realizada com sucesso.');
      }).catch(function () {
        _this8.$root.$refs.notification.error('Erro ao iniciar ativação do opt-in.');
      });
    }
  },

  mounted: function mounted() {
    var _this9 = this;

    this.inputAgencyDigit = document.getElementById('agencyDigit');
    this.inputAgencyDigit.addEventListener('keyup', this.uniCharCode, event);
    this.inputAccountDigit = document.getElementById('accountDigit');
    this.inputAccountDigit.addEventListener('keyup', this.uniCharCode, event);
    this.moneyMask = this.idioma.getMoneyMaskByLanguage();
    setTimeout(function () {
      _this9.inputDate = document.getElementById('startBalanceDate');
      if (_this9.inputDate) {
        _this9.inputDate.setAttribute('autocomplete', 'off');
        _this9.inputDate.addEventListener('blur', function () {
          _this9.validateDate();
        });
      }
    }, 100);
  },
  created: function created() {
    this.loadBanks();
    this.loadEstablishmentGroups();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
    this.$store.dispatch('cleanBankAccountToEdit');
  }
};

/***/ }),
/* 898 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/bankAccounts/OfdaDeepLink.vue ***!
  \****************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OfdaDeepLink',

  data: function data() {
    return {
      isLoadingData: false
    };
  },


  methods: {
    registerLink: function registerLink() {
      var _this = this;

      var link = this.$route.query.link;
      var institution = this.$route.query.institution;
      var accData = this.$route.query.bankAccountId.split('|');

      this.isLoadingData = true;

      var account = {
        bank: {},
        name: null,
        accountNumber: null,
        agency: null
      };
      account.bank.codigo = accData && accData.length > 0 ? accData[0] : null;
      account.agency = accData && accData.length > 1 ? accData[1] : null;
      account.accountNumber = accData && accData.length > 2 ? accData[2] : null;
      account.linkOFDA = link;
      account.institutionOFDA = institution;

      _axiosCommon2.default.post('/bankAccounts/linkAccoutToOFDA', account).then(function (responseSaveAcc) {
        _this.isLoadingData = false;
        _this.$store.dispatch('setHasUnsavedChanges', false);
        _this.$store.dispatch('cleanBankAccountToEdit');
        location.href = _routesMap2.default.LIST_BANK_ACCOUNTS;
      }).catch(function () {
        _this.isLoadingData = false;
        _this.$store.dispatch('setHasUnsavedChanges', false);
        _this.$store.dispatch('cleanBankAccountToEdit');
        location.href = _routesMap2.default.LIST_BANK_ACCOUNTS;
        _this.$root.$refs.notification.error('Erro ao associar conta bancária à autorização OFDA.');
      });
    },
    redirectAccountList: function redirectAccountList() {
      this.$store.dispatch('setHasUnsavedChanges', false);
      this.$store.dispatch('cleanBankAccountToEdit');
      location.href = _routesMap2.default.LIST_BANK_ACCOUNTS;
    }
  },

  created: function created() {
    this.registerLink();
  }
};

/***/ }),
/* 899 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/categories/List.vue ***!
  \******************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _TreeviewCategories = __webpack_require__(/*! ../../../registration/categories/TreeviewCategories */ 692);

var _TreeviewCategories2 = _interopRequireDefault(_TreeviewCategories);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _CategorieModal = __webpack_require__(/*! ../../../registration/categories/CategorieModal */ 1294);

var _CategorieModal2 = _interopRequireDefault(_CategorieModal);

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CategoriesList',

  components: {
    PageTitle: _PageTitle2.default,
    VueDragTree: _TreeviewCategories2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    CategorieModal: _CategorieModal2.default,
    ConfirmModal: _ConfirmModal2.default
  },

  data: function data() {
    return {
      categories: [],
      treeViewButtonTitle: {
        edit: this.$t('categoria.labels.editar'),
        create: this.$t('categoria.labels.criar'),
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher'),
        remove: this.$t('categoria.labels.remover'),
        removeBloq: this.$t('categoria.labels.removerBloqueado')
      },
      lastOrder: null,
      shown: false,
      idEditingCategory: null,
      lastCategoryOrder: 0,
      parentCategory: null,
      categoryIdToRemove: null,
      requestSentRemove: false
    };
  },


  computed: {
    isLoadingDataGeneral: function isLoadingDataGeneral() {
      return this.$store.getters.isLoadingData;
    }
  },

  watch: {
    shown: function shown() {
      if (!this.shown) {
        this.loadCategories();
      }
    }
  },

  methods: {
    createEditCategory: function createEditCategory(categoryId, parentCategory, isEdit) {
      if (isEdit) {
        this.idEditingCategory = categoryId;
      } else {
        this.parentCategory = parentCategory;
        this.idEditingCategory = null;
      }
      this.newCategory(categoryId, parentCategory);
      this.shown = true;
    },
    getLastCategoryOrder: function getLastCategoryOrder(category) {
      if (!category) {
        return 0;
      }
      if (category && category.children && category.children.length > 0) {
        return this.getLastCategoryOrder(category.children[category.children.length - 1]);
      }

      return category.order;
    },
    newCategory: function newCategory(categoryId, parentCategory) {
      var lastCategory = _underscore2.default.last(this.categories);

      if (categoryId && parentCategory) {
        lastCategory = _underscore2.default.last(parentCategory.children);
      }

      this.lastCategoryOrder = this.getLastCategoryOrder(lastCategory);
    },
    loadCategories: function loadCategories() {
      var _this = this;

      this.$store.dispatch('loadingData').then(function () {
        _this.$store.dispatch('getCategories', {
          url: '/categories/',
          flTipoCategoria: null,
          validarUso: true
        }).then(function (response) {
          _this.categories = response.data;
          _this.categories.forEach(function (cat) {
            if (cat.children && cat.children.length > 0) {
              cat.children = _customSorter2.default.arrayDottedSorter(cat.children, 'number', 'asc');
            }
          });
          _this.$store.commit('SET_CATEGORIES_QTY', _this.categories.length);
          _this.$store.dispatch('dataLoaded');
        }).catch(function (error) {
          _this.$root.$refs.notification.error(error.data.message);
          _this.$store.dispatch('dataLoaded');
        });
      });
    },
    handleRemove: function handleRemove(categoryIdToRemove) {
      this.categoryIdToRemove = categoryIdToRemove;
      $('#confirmRemoveCategory').modal('show');
    },
    removeCategory: function removeCategory() {
      var _this2 = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'remove-click', 'remove-categoria', 'remove-categoria');
      if (this.categoryIdToRemove) {
        this.requestSentRemove = true;
        this.$store.dispatch('removeCategorie', this.categoryIdToRemove).then(function (response) {
          _this2.$root.$refs.notification.success('categoria.sucesso.remover');
          _this2.categoryIdToRemove = null;
          $('#confirmRemoveCategory').modal('hide');
          _this2.loadCategories();
        }).catch(function (error) {
          _this2.$root.$refs.notification.error(error.message);
        }).finally(function () {
          _this2.requestSentRemove = false;
        });
      }
    },
    closeModalConfirm: function closeModalConfirm() {
      this.categoryIdToRemove = null;
      $('#confirmRemoveCategory').modal('hide');
    }
  },

  created: function created() {
    this.loadCategories();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 900 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/conciliationPlan/List.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _TreeViewPlans = __webpack_require__(/*! ../../../registration/conciliationPlan/TreeViewPlans */ 693);

var _TreeViewPlans2 = _interopRequireDefault(_TreeViewPlans);

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConciliationPlanList',

  components: {
    PageTitle: _PageTitle2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    LoadingPlaceholder: _LoadingPlaceholder2.default,
    VueDragTree: _TreeViewPlans2.default,
    ConfirmModal: _ConfirmModal2.default
  },

  data: function data() {
    return {
      isLoadingData: true,
      treeViewButtonTitle: {
        config: this.$t('planoConciliacao.labels.gerenciar'),
        edit: this.$t('categoria.labels.editar'),
        create: this.$t('planoConciliacao.labels.criar'),
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher'),
        remove: this.$t('planoConciliacao.labels.remover'),
        removeBloq: this.$t('planoConciliacao.labels.removerBloqueado')
      },
      plans: (0, _gridLoadTransition.generateLoadingRows)(10),
      columns: ['planName', 'acoes'],
      options: {
        columnsClasses: { 'acoes': 'col-md-1', 'planName': 'col-md-11' },
        headings: {
          nomePlanoConciliacao: this.$t('planoConciliacao.labels.plano'),
          acoes: this.$t('planoConciliacao.labels.acoes')
        },
        templates: {
          nome: _LoadingPlaceholder2.default,
          acoes: _LoadingPlaceholder2.default
        },
        filterable: ['planName'],
        filterByColumn: true,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortable: ['planName'],
        sortIcon: {
          is: ''
        },
        pagination: { chunk: 5 },
        customSorting: {
          nome: function nome(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'planName');
            };
          }
        }
      },
      planIdToRemove: null
    };
  },


  methods: {
    edit: function edit(conciliationPlanId) {
      var _this = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'edit-click', 'edit-plano-de-conciliacao', 'edit-plano-de-conciliacao');

      this.$store.dispatch('setPlanToEdit', conciliationPlanId).then(function (response) {
        _this.$router.push(_routesMap2.default.NEW_CONCILIATION_PLAN);
      });
    },
    newPlan: function newPlan() {
      this.$router.push(_routesMap2.default.NEW_CONCILIATION_PLAN);
    },
    loadPlans: function loadPlans() {
      var _this2 = this;

      var url = '/conciliationPlan/listCategorized';
      this.$store.dispatch('getPlans', url).then(function (response) {
        _this2.plans = response.data;
        _this2.isLoadingData = false;
        _this2.options.templates = {};
      });
    },
    removeSpecialChars: function removeSpecialChars(newStringComAcento) {
      var string = newStringComAcento;
      var mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB&(?!amp;)]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g,
        '-': /\s/g
      };

      mapaAcentosHex.forEach(function (letra) {
        var expressaoRegular = mapaAcentosHex[letra];
        string = string.replace(expressaoRegular, letra);
      });

      return string;
    },
    createEditPlan: function createEditPlan(conciliationPlanId, set, isEdit) {
      var _this3 = this;

      if (isEdit) {
        (0, _analytics.trackAnalyticsEvent)(this, 'edit-click', 'edit-plano-de-conciliacao', 'edit-plano-de-conciliacao');

        this.$store.dispatch('setPlanToEdit', conciliationPlanId).then(function (response) {
          _this3.$router.push(_routesMap2.default.NEW_CONCILIATION_PLAN);
        });
      }
    },
    handleRemove: function handleRemove(planIdToRemove) {
      this.planIdToRemove = planIdToRemove;
      $('#confirmRemovePlan').modal('show');
    },
    removePlan: function removePlan() {
      var _this4 = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'remove-click', 'remove-plano-conciliacao', 'remove-plano-conciliacao');
      if (this.planIdToRemove) {
        this.$store.dispatch('removeConciliationPlan', this.planIdToRemove).then(function (response) {
          _this4.$root.$refs.notification.success('planoConciliacao.sucesso.remover');
          _this4.planIdToRemove = null;
          $('#confirmRemovePlan').modal('hide');
          _this4.loadPlans();
        }).catch(function (error) {
          _this4.$root.$refs.notification.error(error.message);
        });
      }
    },
    closeModalConfirm: function closeModalConfirm() {
      this.occurrenceReasonIdToRemove = null;
      $('#confirmRemovePlan').modal('hide');
    }
  },

  created: function created() {
    this.loadPlans();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 901 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/conciliationPlan/New.vue ***!
  \***********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(/*! babel-runtime/core-js/object/keys */ 321);

var _keys2 = _interopRequireDefault(_keys);

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _vuedraggable = __webpack_require__(/*! vuedraggable */ 197);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _ClassificationCriteria = __webpack_require__(/*! ../../../registration/conciliationPlan/classificationCriteria/ClassificationCriteria */ 1295);

var _ClassificationCriteria2 = _interopRequireDefault(_ClassificationCriteria);

var _NewClassificationCriteria = __webpack_require__(/*! ../../../registration/conciliationPlan/classificationCriteria/NewClassificationCriteria */ 1297);

var _NewClassificationCriteria2 = _interopRequireDefault(_NewClassificationCriteria);

var _ConciliationCriteria = __webpack_require__(/*! ../../../registration/conciliationPlan/conciliationCriteria/ConciliationCriteria */ 1299);

var _ConciliationCriteria2 = _interopRequireDefault(_ConciliationCriteria);

var _NewConciliationCriteria = __webpack_require__(/*! ../../../registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria */ 1300);

var _NewConciliationCriteria2 = _interopRequireDefault(_NewConciliationCriteria);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _numberMasker = __webpack_require__(/*! ../../../../utils/numberMasker */ 71);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConciliationPlanNew',

  components: {
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    Draggable: _vuedraggable2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    ClassificationCriteria: _ClassificationCriteria2.default,
    NewClassificationCriteria: _NewClassificationCriteria2.default,
    ConciliationCriteria: _ConciliationCriteria2.default,
    NewConciliationCriteria: _NewConciliationCriteria2.default
  },

  data: function data() {
    return {
      isManagingClassCriteria: false,
      requestSent: false,
      planName: null,
      planToEdit: null,
      classificationCriterias: [],
      conciliationCriterias: [],
      tabMain: '',
      criteriaToEdit: null,
      defaultCriteria: {
        ativo: true,
        relevante: true,
        criterioEmUso: false,
        classificacaoCampos: [],
        conta: null
      },
      concilCriteriaToEdit: null,
      defaultConcilCriteria: {
        ativo: true,
        criterioEmUso: false,
        conciliacaoCampos: [],
        conta: null,
        banco: null,
        descricao: '',
        estabelecimentos: [],
        diasDiferencaMin: 0,
        diasDiferencaMax: 0,
        valorDiferencaMax: 0.00,
        valorDivergenciaMax: 0.00,
        motivoOcorrencia: null
      },
      idsCriteriasRemoved: [],
      categories: [],
      febraban: [],
      banks: [],
      accounts: [],
      attributesCfgClassif: [],
      attributesCfg: [],
      conciliationFields: [],
      conciliationFieldsBanking: [],
      occurrenceReasons: [],
      isManagingConcilCriteria: false,
      idioma: _index2.default,
      idsConciliationCriteriasRemoved: [],
      errorCaptured: false
    };
  },


  computed: {
    planToEditId: function planToEditId() {
      return this.$store.getters.planToEditId;
    },
    portletTitle: function portletTitle() {
      if (this.planToEditId) {
        return this.$t('planoConciliacao.titulos.editarPlanoConciliacao');
      } else {
        return this.$t('planoConciliacao.titulos.novoPlanoConciliacao');
      }
    },
    tabClass: function tabClass() {
      return this.$t('planoConciliacao.labels.criteriosClassificacao');
    },
    tabConcil: function tabConcil() {
      return this.$t('planoConciliacao.labels.criteriosConciliacao');
    }
  },

  watch: {
    planName: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, {
          id: this.planToEditId,
          nome: this.planName,
          criteriosClassificacao: this.classificationCriterias,
          criteriosConciliacao: this.conciliationCriterias
        }));
      },

      deep: true
    }
  },

  methods: {
    savePlan: function savePlan() {
      var _this = this;

      this.classificationCriterias.map(function (criteria) {
        if (criteria.classificacaoCampos.length > 0) {
          criteria.classificacaoCampos.map(function (classif) {
            classif.idAtributoCfg = classif.idAtributoCfg && classif.idAtributoCfg.id ? classif.idAtributoCfg.id : classif.idAtributoCfg;
            classif.nomeAtributo = classif.nomeAtributo && classif.nomeAtributo.id ? classif.nomeAtributo.id : classif.nomeAtributo;
          });
        }
      });
      this.conciliationCriterias.map(function (criteria) {
        if (criteria.valorDiferencaMax && typeof criteria.valorDiferencaMax === 'string') {
          criteria.valorDiferencaMax = parseFloat(_this.removeMonetaryMask(criteria.valorDiferencaMax));
        }

        if (criteria.valorDivergenciaMax && typeof criteria.valorDivergenciaMax === 'string') {
          criteria.valorDivergenciaMax = parseFloat(_this.removeMonetaryMask(criteria.valorDivergenciaMax));
        }
        if (criteria.conciliacaoCampos.length > 0) {
          criteria.conciliacaoCampos.map(function (field) {
            if (field.atributo && (0, _keys2.default)(field.atributo).length > 0 && field.atributo.constructor === Object) {
              field.atributo.atributoCfg = { id: field.atributo.atributoCfg && field.atributo.atributoCfg.id ? field.atributo.atributoCfg.id : field.atributo.atributoCfg };
              field.atributo.nomeAtributo = field.atributo.nomeAtributo && field.atributo.nomeAtributo.id ? field.atributo.nomeAtributo.id : field.atributo.nomeAtributo;
            }

            if (field.banco && (0, _keys2.default)(field.banco).length > 0 && field.banco.constructor === Object) {
              criteria.banco = field.banco;
            }

            if (field.conta && (0, _keys2.default)(field.conta).length > 0 && field.conta.constructor === Object) {
              criteria.conta = field.conta;
            }
          });
        }
      });

      var plan = {
        nome: this.planName,
        criteriosClassificacao: this.classificationCriterias,
        criteriosConciliacao: this.conciliationCriterias,
        idsCriteriosClassificacaoRemovidos: this.idsCriteriasRemoved,
        idsCriteriosConciliacaoRemovidos: this.idsConciliationCriteriasRemoved
      };

      if (this.planToEditId != null) {
        plan.id = this.planToEditId;
      }
      this.requestSent = true;
      this.$store.dispatch('savePlan', plan).then(function (response) {
        _this.$root.$refs.notification.success(response.data.message);
        _this.$store.dispatch('setHasUnsavedChanges', false);
        _this.$router.push(_routesMap2.default.LIST_CONCILIATION_PLANS);
      }).catch(function (error) {
        _this.$root.$refs.notification.error(error.message);
      }).finally(function () {
        _this.requestSent = false;
      });
    },
    loadPlan: function loadPlan() {
      var _this2 = this;

      var self = this;
      this.$store.dispatch('getPlan', this.planToEditId).then(function (response) {
        self.planToEdit = response.data.data[0];
        self.planName = self.planToEdit.nome;
        self.classificationCriterias = self.planToEdit.criteriosClassificacao.sort(function (a, b) {
          return Number(a.ordem) - Number(b.ordem);
        });
        self.classificationCriterias.map(function (crit) {
          crit.classificacaoCampos.map(function (field) {
            field.key = field.id;
          });
        });

        self.conciliationCriterias = self.planToEdit.criteriosConciliacao.sort(function (a, b) {
          return Number(a.ordem) - Number(b.ordem);
        });
        self.conciliationCriterias.map(function (crit) {
          crit.conciliacaoCampos.map(function (field) {
            field.key = field.id;
          });

          if (crit.valorDivergenciaMax !== null && crit.valorDivergenciaMax !== undefined) {
            crit.valorDivergenciaMax = self.idioma.getMoneyMaskByLanguage().prefix + '' + (0, _numberMasker.maskThousand)(crit.valorDivergenciaMax);
          } else {
            crit.valorDivergenciaMax = '';
          }

          if (crit.valorDiferencaMax !== null && crit.valorDiferencaMax !== undefined) {
            crit.valorDiferencaMax = self.idioma.getMoneyMaskByLanguage().prefix + '' + (0, _numberMasker.maskThousand)(crit.valorDiferencaMax);
          } else {
            crit.valorDiferencaMax = '';
          }
          if (crit.banco) {
            crit.banco.label = (crit.banco.codigo ? crit.banco.codigo + '-' : '') + crit.banco.nomeFantasia;
          }

          if (crit.conta) {
            crit.conta.label = crit.conta.id !== 0 ? crit.conta.nome + ' (' + crit.conta.numAgencia + (crit.conta.digAgencia ? '-' + crit.conta.digAgencia : '') + '/' + crit.conta.conta + (crit.conta.digConta ? '-' + crit.conta.digConta : '') + ')' + (crit.conta.ativo === undefined || crit.conta.ativo === null || crit.conta.ativo ? '' : ' [' + _this2.$t('contaBancaria.labels.inativa') + ']') : crit.$t('planoConciliacao.labels.nenhumItem');
          }
        });

        self.defaultObject = {
          id: self.planToEditId,
          nome: self.planName,
          criteriosClassificacao: self.classificationCriterias,
          criteriosConciliacao: self.conciliationCriterias
        };
        if (self.classificationCriterias && self.classificationCriterias.length > 0) {
          self.updateCriteriasAttCfg();
          self.updateCriteriasConcFields();
        }
        if (self.conciliationCriterias && self.conciliationCriterias.length > 0) {
          self.updateConcilCriteriasAttCfg();
        }
      }).catch(function (error) {
        self.$root.$refs.notification.error(error.message);
      });
    },
    validate: function validate(event) {
      var _this3 = this;

      event.preventDefault();
      this.changeClassifOrder();
      this.changeConcilOrder();
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this3.savePlan();
        } else {
          _this3.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'planoConciliacao.erro.salvar');
        }
      });
    },
    back: function back() {
      this.$router.push(_routesMap2.default.LIST_CONCILIATION_PLANS);
    },
    createOrEditCriteria: function createOrEditCriteria() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!criteria || !criteria.ordem) {
        criteria = (0, _assign2.default)({}, this.defaultCriteria, { classificacaoCampos: [].concat((0, _toConsumableArray3.default)(this.defaultCriteria.classificacaoCampos)) });
      }

      this.criteriaToEdit = (0, _assign2.default)({}, criteria, { classificacaoCampos: [].concat((0, _toConsumableArray3.default)(criteria.classificacaoCampos)) });
      this.isManagingClassCriteria = !this.isManagingClassCriteria;
    },
    updateCriteriasList: function updateCriteriasList() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.classificationCriterias == null) {
        this.classificationCriterias = [];
      }

      this.checkDescriptionExistsCriteria(criteria);

      if (criteria.idCriterioClassificacao || criteria.ordem) {
        var index = this.classificationCriterias.findIndex(function (crit) {
          return crit.idCriterioClassificacao ? crit.idCriterioClassificacao === criteria.idCriterioClassificacao : crit.ordem === criteria.ordem;
        });

        if (index === -1) {
          throw new Error('Not found');
        }
        this.classificationCriterias.splice(index, 1, criteria);
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAlterado');
      } else {
        criteria.planoConciliacao = this.planToEditId;
        criteria.ordem = this.classificationCriterias.length + 1;
        this.classificationCriterias.push(criteria);
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAdicionado');
      }

      this.criteriaToEdit = (0, _assign2.default)({}, this.defaultCriteria, { classificacaoCampos: [].concat((0, _toConsumableArray3.default)(this.defaultCriteria.classificacaoCampos)) });
    },
    checkDescriptionExistsCriteria: function checkDescriptionExistsCriteria() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var existsDescriptionCriteria = this.classificationCriterias.find(function (crit) {
        return crit.descricao === criteria.descricao && crit.ordem !== criteria.ordem;
      });

      if (existsDescriptionCriteria) {
        this.errorCaptured = true;
        this.$root.$refs.notification.warning('planoConciliacao.validacao.criterioNomeRepetido');
        throw new Error('There is already a criterion with this description');
      }
    },
    removeCriteriaHandler: function removeCriteriaHandler() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var index = this.classificationCriterias.findIndex(function (crit) {
        return crit === criteria;
      });
      this.classificationCriterias.splice(index, 1);
      if (criteria.idCriterioClassificacao) {
        this.idsCriteriasRemoved.push(criteria.idCriterioClassificacao);
      }
    },
    updateCriteriasAttCfg: function updateCriteriasAttCfg() {
      var _this4 = this;

      this.classificationCriterias.map(function (crit) {
        crit.classificacaoCampos.map(function (field) {
          field.idAtributoCfg = _this4.attributesCfgClassif.find(function (cfg) {
            return cfg.id === field.idAtributoCfg.toString();
          });
          setTimeout(function () {
            if (field.idAtributoCfg && field.idAtributoCfg.children && field.idAtributoCfg.children.length > 0) {
              field.nomeAtributo = field.idAtributoCfg.children.find(function (att) {
                return att.id === field.nomeAtributo;
              });
            }
          }, 250);
        });
      });
    },
    updateConcilCriteriasAttCfg: function updateConcilCriteriasAttCfg() {
      var self = this;
      this.conciliationCriterias.map(function (crit) {
        crit.conciliacaoCampos.map(function (field) {
          if (field.atributo && field.atributo instanceof Object && field.atributo.atributoCfg && field.atributo.atributoCfg instanceof Object) {
            field.atributo.atributoCfg = self.attributesCfg.find(function (cfg) {
              return cfg.id.toString() === (field.atributo.atributoCfg ? field.atributo.atributoCfg.id : field.atributo.atributoCfg).toString();
            });
            setTimeout(function () {
              if (field.atributo.atributoCfg && field.atributo.atributoCfg.children && field.atributo.atributoCfg.children.length > 0) {
                field.atributo.nomeAtributo = field.atributo.atributoCfg.children.find(function (att) {
                  return att.id === field.atributo.nomeAtributo;
                });
              }
            }, 250);
          } else if (field.atributo && field.atributo instanceof String) {
            self.attributesCfg.map(function (cfg) {
              if (cfg.linkType === (field.conciliacaoCampoMovFinan ? field.conciliacaoCampoMovFinan.tipoVinculo : null)) {
                cfg.children.map(function (att) {
                  if (field.atributo === att.id) {
                    field.atributo.atributoCfg = cfg;
                    field.atributo.nomeAtributo = att;
                  }
                });
              }
            });
          }
        });
      });
    },
    updateCriteriasConcFields: function updateCriteriasConcFields() {
      var self = this;
      self.classificationCriterias.map(function (crit) {
        crit.classificacaoCampos.map(function (field) {
          field.conciliacaoCampo = self.conciliationFieldsBanking.find(function (concField) {
            if (field.conciliacaoCampo) {
              return concField.id.toString() === field.conciliacaoCampo.id.toString();
            }
            return false;
          });
        });
      });
    },
    changeManagingClassCriteria: function changeManagingClassCriteria() {
      if (!this.errorCaptured) {
        this.accounts = [].concat((0, _toConsumableArray3.default)(this.accounts));
        this.criteriaToEdit = null;
        this.isManagingClassCriteria = !this.isManagingClassCriteria;
      }
      this.errorCaptured = false;
    },
    changeClassifOrder: function changeClassifOrder() {
      var _this5 = this;

      this.classificationCriterias.map(function (crit) {
        crit.ordem = _this5.classificationCriterias.findIndex(function (item) {
          return (0, _looseDeepEqual2.default)(item, crit);
        }) + 1;
      });
    },
    changeConcilOrder: function changeConcilOrder() {
      var _this6 = this;

      this.conciliationCriterias.map(function (crit) {
        crit.ordem = _this6.conciliationCriterias.findIndex(function (item) {
          return (0, _looseDeepEqual2.default)(item, crit);
        }) + 1;
      });
    },
    loadCategories: function loadCategories() {
      var _this7 = this;

      this.$store.dispatch('getCategories', {
        url: '/conciliationPlan/loadCategories',
        flTipoCategoria: null,
        validarUso: false
      }).then(function (response) {
        var catArray = [];
        response.data.forEach(function (cat) {
          cat.label = cat.numero + ' - ' + cat.nome;
          catArray.push(cat);
        });

        _this7.categories = _customSorter2.default.arrayDottedSorter(catArray, 'numero', 'asc');
      }).catch(function (error) {
        _this7.$root.$refs.notification.error(error.data.message);
      });
    },
    loadFebraban: function loadFebraban() {
      var _this8 = this;

      this.$store.dispatch('getFebraban').then(function (response) {
        _this8.febraban = response.data.data;
        _this8.febraban.forEach(function (cat) {
          cat.label = cat.codigo + ' - ' + cat.descricao;
        });
        _this8.febraban.sort(function (a, b) {
          return Number(a.codigo) - Number(b.codigo);
        });
      });
    },
    loadBanks: function loadBanks() {
      var _this9 = this;

      this.$store.dispatch('getBanks').then(function (response) {
        _this9.banks = response.data.data;
        _this9.banks.forEach(function (bank) {
          bank.label = (bank.codigo ? bank.codigo + '-' : '') + bank.nomeFantasia;
        });
        _this9.banks.sort(function (a, b) {
          return Number(a.codigo) - Number(b.codigo);
        });
      });
    },
    loadBankAccounts: function loadBankAccounts() {
      var _this10 = this;

      var url = '/bankAccounts/';
      this.$store.dispatch('getBankAccounts', url).then(function (response) {
        _this10.accounts = response.data.data;
        _this10.accounts.forEach(function (account) {
          account.label = account.id !== 0 ? account.nome + ' (' + account.numAgencia + (account.digAgencia ? '-' + account.digAgencia : '') + '/' + account.conta + (account.digConta ? '-' + account.digConta : '') + ')' + (account.ativo === undefined || account.ativo === null || account.ativo === true ? '' : ' [' + _this10.$t('contaBancaria.labels.inativa') + ']') : _this10.$t('planoConciliacao.labels.nenhumItem');
        });
        _this10.accounts.sort(function (a, b) {
          return Number(a.id) - Number(b.id);
        });
      }).catch(function (error) {
        _this10.$root.$refs.notification.error(error.message);
      });
    },
    loadConciliationFieldsData: function loadConciliationFieldsData() {
      var _this11 = this;

      this.$store.dispatch('getAttributesSet').then(function (attributesSetList) {
        _this11.attributesCfg = attributesSetList;
        _this11.attributesCfgClassif = attributesSetList.filter(function (set) {
          return set.children && set.children.length > 0 && set.linkType === 'E';
        });
      }).then(function () {
        _this11.$store.dispatch('getConciliationFields').then(function (response) {
          _this11.conciliationFields = response.data.data;
          _this11.conciliationFieldsBanking = response.data.data.filter(function (field) {
            return field.tipo && field.tipo === 'B';
          });
          _this11.conciliationFieldsBanking.forEach(function (cfg) {
            cfg.label = cfg.nome + ' | ' + cfg.expressao;
          });
        });
      }).then(function () {
        if (_this11.planToEditId) {
          _this11.loadPlan();
        } else {
          _this11.defaultObject = {
            id: _this11.planToEditId,
            nome: _this11.planName,
            criteriosClassificacao: _this11.classificationCriterias,
            criteriosConciliacao: _this11.conciliationCriterias
          };
        }
      }).catch(function (error) {
        _this11.$root.$refs.notification.error(error.message);
      });
    },
    createOrEditConcilCriteria: function createOrEditConcilCriteria() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!criteria || !criteria.ordem) {
        criteria = (0, _assign2.default)({}, this.defaultConcilCriteria, { conciliacaoCampos: [].concat((0, _toConsumableArray3.default)(this.defaultConcilCriteria.conciliacaoCampos)) });
      }

      this.concilCriteriaToEdit = (0, _assign2.default)({}, criteria, { conciliacaoCampos: [].concat((0, _toConsumableArray3.default)(criteria.conciliacaoCampos)) });
      this.isManagingConcilCriteria = !this.isManagingConcilCriteria;
    },
    removeConcilCriteriaHandler: function removeConcilCriteriaHandler() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var index = this.conciliationCriterias.findIndex(function (crit) {
        return crit === criteria;
      });
      this.conciliationCriterias.splice(index, 1);
      if (criteria.id) {
        this.idsConciliationCriteriasRemoved.push(criteria.id);
      }
    },
    loadOccurrences: function loadOccurrences() {
      var _this12 = this;

      var url = 'conciliationPlan/occurrenceReason/list';
      this.$store.dispatch('getOccurrenceReasons', url).then(function (response) {
        _this12.occurrenceReasons = response.data.data;
      }).catch(function (error) {
        _this12.$root.$refs.notification.error(error.message);
      });
    },
    updateConcilCriteriasList: function updateConcilCriteriasList() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.conciliationCriterias == null) {
        this.conciliationCriterias = [];
      }

      this.checkDescriptionExistsConcilCriteria(criteria);

      if (criteria.id || criteria.ordem) {
        var index = this.conciliationCriterias.findIndex(function (crit) {
          return crit.id ? crit.id === criteria.id : crit.ordem === criteria.ordem;
        });

        if (index === -1) {
          throw new Error('Not found');
        }
        this.conciliationCriterias.splice(index, 1, criteria);
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAlterado');
      } else {
        criteria.planoConciliacao = this.planToEditId;
        criteria.ordem = this.conciliationCriterias.length + 1;
        this.conciliationCriterias.push(criteria);
        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAdicionado');
      }

      this.concilCriteriaToEdit = (0, _assign2.default)({}, this.defaultConcilCriteria, { conciliacaoCampos: [].concat((0, _toConsumableArray3.default)(this.defaultConcilCriteria.conciliacaoCampos)) });
    },
    checkDescriptionExistsConcilCriteria: function checkDescriptionExistsConcilCriteria() {
      var criteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var existsDescriptionCriteria = this.conciliationCriterias.find(function (crit) {
        return crit.descricao === criteria.descricao && crit.ordem !== criteria.ordem;
      });

      if (existsDescriptionCriteria) {
        this.errorCaptured = true;
        this.$root.$refs.notification.warning('planoConciliacao.validacao.criterioConcilNomeRepetido');
        throw new Error('There is already a criterion with this description');
      }
    },
    changeManagingConcilCriteria: function changeManagingConcilCriteria() {
      if (!this.errorCaptured) {
        this.concilCriteriaToEdit = null;
        this.isManagingConcilCriteria = !this.isManagingConcilCriteria;
      }
      this.errorCaptured = false;
    },
    removeMonetaryMask: function removeMonetaryMask(value) {
      var splittedStartBalance = value.toString().split(' ');

      if (splittedStartBalance.length > 1) {
        return splittedStartBalance[1].replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1');
      }
      return value.replace(/[.,]/g, '').replace(/(\d{2})$/, '.$1');
    }
  },

  created: function created() {
    this.loadOccurrences();
    this.loadCategories();
    this.loadBanks();
    this.loadBankAccounts();
    this.loadFebraban();
    this.loadConciliationFieldsData();
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
    this.$store.dispatch('cleanPlanToEdit');
  }
};

/***/ }),
/* 902 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/establishments/List.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vueTheMask = __webpack_require__(/*! vue-the-mask */ 133);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index.js */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'EstablishmentsList',

  components: {
    vSelect: _vueSelect2.default,
    TheMask: _vueTheMask.TheMask,
    PageTitle: _PageTitle2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    FilterPortlet: _FilterPortlet2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      gridId: '#establishmentsGrid',
      treeGridCfg: {},
      isLoadingData: true,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      showTreegrid: false,
      filter: {
        nome: null,
        cnpj: null,
        uf: null,
        cidade: null,
        grupo: null,
        situacoes: null
      },
      situationList: [{
        id: 'A',
        value: 1,
        nome: this.$t('estabelecimentos.labels.ativo'),
        checked: true
      }, {
        id: 'I',
        value: 0,
        nome: this.$t('estabelecimentos.labels.inativo'),
        checked: true
      }],
      disableSearchButton: false,
      selectedStatuses: [0, 1],
      uf: [],
      cities: [],
      establishmentsGroup: [],
      result: {}
    };
  },


  watch: {
    situationList: {
      handler: function handler(val) {
        var _this = this;

        this.selectedStatuses = [];
        val.forEach(function (st) {
          if (st.checked) {
            _this.selectedStatuses.push(st.value);
          }
        });
      },

      deep: true
    }
  },

  methods: {
    validate: function validate() {
      var _this2 = this;

      var isScrollable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.showTreegrid = true;
          (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, undefined, isScrollable);
          _this2.search(isScrollable);
        }
      });
    },
    search: function search() {
      var isScrollable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.disableSearchButton = true;
      this.filter.nome = this.filter.nome ? this.filter.nome : null;
      this.filter.cnpj = this.filter.cnpj ? this.filter.cnpj : null;
      this.filter.lang = _index2.default.getCookieByName('language');
      this.loadEstablishments(isScrollable);
    },
    edit: function edit(establishmentId) {
      var _this3 = this;

      this.$store.dispatch('setEstablishmentToEdit', establishmentId).then(function (response) {
        _this3.$router.push(_routesMap2.default.NEW_ESTABLISHMENT);
      });
    },
    newEstablishment: function newEstablishment() {
      this.$router.push(_routesMap2.default.NEW_ESTABLISHMENT);
    },
    moveEstablishment: function moveEstablishment() {
      this.$router.push(_routesMap2.default.MOVE_ESTABLISHMENT);
    },
    loadEstablishments: function loadEstablishments() {
      var _this4 = this;

      var isScrollable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.filter.url = 'establishment/listDetails';
      this.filter.situacao = false;
      this.filter.idioma = _index2.default.getCookieByName('language');
      this.$store.dispatch('getEstablishmentsToTreeGrid', this.filter).then(function (response) {
        if (window.DisposeGrids) {
          window.DisposeGrids();
        }
        _this4.treeGridCfg = response.data.Cfg.Layout;
        _this4.result = response.data;
        window.Grids.editEstablishment = function (row) {
          _this4.edit(row.id);
        };
        (0, _gridLoadTransition.stopTreeGridLoading)(_this4.gridId, isScrollable);
        _this4.disableSearchButton = false;
      }).catch(function (error) {
        _this4.$root.$refs.notification.error(error.message);
        (0, _gridLoadTransition.stopTreeGridLoading)(_this4.gridId, isScrollable);
        _this4.disableSearchButton = false;
      });
    },
    loadEstablishmentGroups: function loadEstablishmentGroups() {
      var _this5 = this;

      this.$store.dispatch('getEstablishmentGroups').then(function (response) {
        _this5.establishmentsGroup = response;
      }).catch(function (error) {
        _this5.$root.$refs.notification.error(error.message);
      });
    }
  },

  created: function created() {
    this.loadEstablishmentGroups();
    this.validate(false);
  }
};

/***/ }),
/* 903 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/establishments/Move.vue ***!
  \**********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _MoveEstablishmentModal = __webpack_require__(/*! ../../../registration/establishments/MoveEstablishmentModal */ 1301);

var _MoveEstablishmentModal2 = _interopRequireDefault(_MoveEstablishmentModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'EstablishmentsMove',

  components: {
    vSelect: _vueSelect2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    MoveEstablishmentModal: _MoveEstablishmentModal2.default
  },

  data: function data() {
    return {
      establishmentList: [],
      establishmentOrigin: null,
      establishmentDestiny: null,
      deleteEstablishmentOrigin: true,
      establishimentsUrl: 'establishment/list'
    };
  },


  methods: {
    loadEstablishments: function loadEstablishments(search) {
      var _this = this;

      if (search.length) {
        var filters = this.mountFilters({
          ascending: 1,
          orderBy: 'nome',
          page: 1,
          limit: 5,
          query: {
            nome: search
          }
        });

        this.$store.dispatch('getEstablishments', filters).then(function (response) {
          if (response.elements.length === 0) {
            _this.establishmentList = [];
          } else {
            _this.establishmentList = response.elements;
          }
        }).catch(function (error) {
          _this.$root.$refs.notification.error(error.message);
        });
      }
    },
    mountFilters: function mountFilters(pagination) {
      var filters = {};
      var atributosValores = [];
      for (var key in pagination.query) {
        filters[key] = pagination.query[key];
      }
      return (0, _assign2.default)({
        atributosValores: atributosValores,
        filters: filters
      }, pagination, {
        url: this.establishimentsUrl
      });
    },
    handleClearList: function handleClearList() {
      this.establishmentList = [];
    },
    validate: function validate() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (_this2.establishmentOrigin.id !== _this2.establishmentDestiny.id) {
            _this2.$store.dispatch('setSelectedEstablishmentsMoveEstablishment', {
              establishmentOrigin: _this2.establishmentOrigin,
              establishmentDestiny: _this2.establishmentDestiny,
              deleteEstablishmentOrigin: _this2.deleteEstablishmentOrigin
            });
            _this2.moveEstablishmentModal();
          }
        }
      });
    },
    moveEstablishmentModal: function moveEstablishmentModal() {
      $('#moveEstablishmentModal').modal({ backdrop: 'static', keyboard: false });
    },
    back: function back() {
      this.$router.push(_routesMap2.default.LIST_ESTABLISHMENTS);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 904 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/establishments/New.vue ***!
  \*********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(/*! babel-runtime/core-js/get-iterator */ 47);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 48);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 137);

var _typeof3 = _interopRequireDefault(_typeof2);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _vueTheMask = __webpack_require__(/*! vue-the-mask */ 133);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _DynamicInput = __webpack_require__(/*! ../../../input/dynamicInput/DynamicInput */ 1271);

var _DynamicInput2 = _interopRequireDefault(_DynamicInput);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _customValidator = __webpack_require__(/*! ../../../../utils/customValidator.js */ 106);

var _customValidator2 = _interopRequireDefault(_customValidator);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'EstablishmentsNew',

  components: {
    vSelect: _vueSelect2.default,
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    TheMask: _vueTheMask.TheMask,
    PageTitle: _PageTitle2.default,
    DynamicInput: _DynamicInput2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      requestSent: false,
      editFirstCity: true,
      establishment: {
        id: null,
        nome: null,
        nomeFantasia: null,
        cnpj: null,
        uf: null,
        cidade: {
          nome: '',
          sigla: ''
        },
        grupo: null,
        situacao: null
      },
      uf: [],
      cities: [],
      establishmentsGroup: [],
      inputEstabelecimentoValidator: false,
      tabMain: '',
      dynamicValidator: true,
      attributesList: [],
      attributesLoaded: false
    };
  },


  computed: {
    establishmentsGroupList: function establishmentsGroupList() {
      return _underscore2.default.sortBy(this.establishmentsGroup, function (item) {
        return _customSorter2.default.cleanLowerString(item.nome);
      }, 'asc');
    },
    establishmentGroupInput: function establishmentGroupInput() {
      return this.establishment.grupo;
    },
    tabEstab: function tabEstab() {
      return this.$store.getters.establishmentToEditId ? this.$t('estabelecimentos.labels.editarEstabelecimento') : this.$t('estabelecimentos.labels.novoEstabelecimento');
    },
    tabAtt: function tabAtt() {
      return this.$t('estabelecimentos.labels.estabbelecimentoAtributos');
    },
    stylizeGroupLabel: function stylizeGroupLabel() {
      var _this = this;

      return function (option) {
        var result = null;
        if ((typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object') {
          if (_this.label && option[_this.label]) {
            result = option[_this.label];
          } else {
            result = option['nome'];
          }
        } else {
          result = option + ' (' + _this.$t('inputTag.labels.novo') + ')';
        }
        return result;
      };
    }
  },

  watch: {
    establishmentGroupInput: function establishmentGroupInput() {
      if (this.establishment.grupo && !this.establishment.grupo.nome) {
        this.establishment.grupo = { nome: this.establishment.grupo };
      }
      if (this.establishment.grupo && this.establishment.grupo.nome && this.establishment.grupo.nome.length > 20) {
        this.establishment.grupo.nome = this.establishment.grupo.nome.slice(0, 20);
        this.inputEstabelecimentoValidator = true;
      } else {
        this.establishment.grupo.nome = this.establishment.grupo.nome;
        this.inputEstabelecimentoValidator = false;
      }
    },

    establishment: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, (0, _assign2.default)({}, this.establishment, { attributes: this.attributesList }), ['invalid']));
      },

      deep: true
    },
    attributesList: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, (0, _assign2.default)({}, this.establishment, { attributes: this.attributesList }), ['invalid']));
      },

      deep: true
    }
  },

  methods: {
    setIsInvalid: function setIsInvalid(att, isInvalid) {
      att.invalid = isInvalid;
    },
    loadEstablishmentAtt: function loadEstablishmentAtt() {
      var self = this;
      var url = '/establishment/loadEstablishmentAtt';
      self.$store.dispatch('loadEstablishmentAtt', url).then(function (response) {
        self.attributesList = response;
        if (self.$store.getters.establishmentToEditId) {
          self.loadEstablishment();
        } else {
          self.attributesLoaded = true;
          self.defaultObject = (0, _assign2.default)({}, self.establishment, { attributes: [].concat((0, _toConsumableArray3.default)(self.attributesList.map(function (att) {
              return (0, _assign2.default)({}, att);
            }))) });
        }
      }).catch(function (error) {
        var notifTitle = self.establishment.id ? 'estabelecimentos.erro.editar' : 'estabelecimentos.erro.criar';
        self.$root.$refs.notification.error(error.message, notifTitle);
      });
    },
    newEstablishment: function newEstablishment() {
      var _this2 = this;

      this.establishment.atributosValores = this.attributesList.map(function (att) {
        att.idAtributoCfg = att.atributoCfg ? att.atributoCfg.id : null;
        att.idVinculo = _this2.establishment.id ? _this2.establishment.id : null;
        if (!att.valorOriginal || att.tipo !== 'DATE') {
          att.valor = att.valorOriginal;
          if (att.tipo === 'COMBO') {
            att.valor = att.valorOriginal ? att.valorOriginal.valor : null;
          }
          return att;
        }

        if (!(att.valorOriginal instanceof Date)) {
          att.valorOriginal = new Date(att.valorOriginal);
        }
        var _ref = [att.valorOriginal.getDate().toString().padStart(2, '0'), (att.valorOriginal.getMonth() + 1).toString().padStart(2, '0'), att.valorOriginal.getFullYear().toString()],
            day = _ref[0],
            month = _ref[1],
            year = _ref[2];

        att.valor = year + '/' + month + '/' + day;
        return att;
      });

      this.requestSent = true;
      this.$store.dispatch('newEstablishment', this.establishment).then(function (response) {
        if (_this2.establishment.id) {
          _this2.$root.$refs.notification.success('estabelecimentos.sucesso.editado');
        } else {
          _this2.$root.$refs.notification.success('estabelecimentos.sucesso.criado');
        }
        _this2.$store.dispatch('setHasUnsavedChanges', false);
        _this2.$router.push(_routesMap2.default.LIST_ESTABLISHMENTS);
      }).catch(function (error) {
        var notifTitle = _this2.establishment.id ? 'estabelecimentos.erro.editar' : 'estabelecimentos.erro.criar';
        _this2.$root.$refs.notification.error(error.message || '', notifTitle);
      }).finally(function () {
        _this2.requestSent = false;
      });
    },
    loadEstablishment: function loadEstablishment() {
      var self = this;
      self.$store.dispatch('getEstablishment', self.$store.getters.establishmentToEditId).then(function (response) {
        self.establishment = response;
        self.attributesList = self.attributesList.map(function (existingAttribute) {
          existingAttribute.invalid = false;
          var insertedAttribute = self.establishment.atributosValores.find(function (att) {
            return att.nomeAtributo === existingAttribute.nomeAtributo;
          });
          if (!insertedAttribute) {
            return existingAttribute;
          }
          existingAttribute.valorOriginal = insertedAttribute.valor;
          if (existingAttribute.tipo === 'DATE') {
            existingAttribute.valorOriginal = new Date(insertedAttribute.valor);
          }
          if (existingAttribute.tipo === 'COMBO') {
            existingAttribute.valorOriginal = {
              valor: insertedAttribute.valor
            };
          }
          return existingAttribute;
        });
        self.attributesLoaded = true;
        self.defaultObject = (0, _assign2.default)({}, self.establishment, { attributes: [].concat((0, _toConsumableArray3.default)(self.attributesList.map(function (att) {
            return (0, _assign2.default)({}, att);
          }))) });
      }).catch(function (error) {
        self.$root.$refs.notification.error(error.message);
      });
    },
    loadEstablishmentGroups: function loadEstablishmentGroups() {
      var _this3 = this;

      this.$store.dispatch('getEstablishmentGroups').then(function (response) {
        _this3.establishmentsGroup = response;
      }).catch(function (error) {
        _this3.$root.$refs.notification.error(error.message);
      });
    },
    loadUfs: function loadUfs() {
      var _this4 = this;

      this.$store.dispatch('getStates').then(function (response) {
        _this4.uf = response;
        _this4.loadCities();
      }).catch(function (error) {
        _this4.$root.$refs.notification.error(error);
      });
    },
    loadCities: function loadCities() {
      var _this5 = this;

      this.$store.dispatch('getCities', this.establishment.uf).then(function (response) {
        _this5.cities = response;
      }).catch(function (error) {
        _this5.$root.$refs.notification.error(error);
      });
    },
    updateCities: function updateCities(vSelectValue) {
      var _this6 = this;

      if (this.editFirstCity) {
        this.establishment.cidade = null;
      }
      this.establishment.uf = vSelectValue;
      this.$store.dispatch('getCities', vSelectValue).then(function (response) {
        _this6.cities = response;
        if (_this6.editFirstCity) {
          _this6.establishment.cidade = _this6.cities ? _this6.cities[0] : null;
        }
        _this6.editFirstCity = true;
      }).catch(function (error) {
        _this6.$root.$refs.notification.error(error);
      });
    },
    changeCities: function changeCities(vSelectValue) {
      this.establishment.cidade = vSelectValue;
    },
    validate: function validate() {
      var self = this;
      self.$validator.validateAll().then(function (result) {
        if (result && self.validateCnpj()) {
          if (self.validateAtt()) {
            self.newEstablishment();
          }
        } else {
          if (self.tabMain === self.tabAtt) {
            self.backToEstab();
          }
        }
      });
    },
    validateAtt: function validateAtt() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.attributesList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var att = _step.value;

          if (att.invalid) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    validateCnpj: function validateCnpj() {
      if (this.establishment && this.establishment.cnpj && this.establishment.cnpj.length > 0) {
        if (!_customValidator2.default.validateCnpj(this.establishment.cnpj)) {
          return false;
        }
      }
      return true;
    },
    backToEstab: function backToEstab() {
      this.tabMain = this.tabEstab;
    },
    nextToAtt: function nextToAtt() {
      this.tabMain = this.tabAtt;
    },
    back: function back() {
      this.$router.go(-1);
    },
    verifyCnpj: function verifyCnpj() {
      if (this.establishment && this.establishment.cnpj && this.establishment.cnpj.length === 14) {
        if (!_customValidator2.default.validateCnpj(this.establishment.cnpj)) {
          this.errors.add({
            field: 'establishmentCnpjInvalid',
            msg: this.$t('estabelecimentos.erro.cnpjInvalido')
          });
        } else {
          this.errors.remove('establishmentCnpjInvalid');
        }
      } else {
        this.errors.remove('establishmentCnpjInvalid');
      }
    }
  },

  created: function created() {
    this.loadEstablishmentAtt();
    if (!this.$store.getters.establishmentToEditId) {
      this.editFirstCity = true;
      this.establishment.cidade = undefined;
    } else {
      this.editFirstCity = false;
    }
    this.loadEstablishmentGroups();
    this.loadUfs();
  },
  mounted: function mounted() {
    var self = this;
    self.$refs.ufSelect.$refs.search.addEventListener('blur', function () {
      setTimeout(function () {
        if (!self.establishment.uf) {
          self.$refs.ufSelect.search = '';
        }
      }, 100);
    });

    self.$refs.citySelect.$refs.search.addEventListener('blur', function () {
      setTimeout(function () {
        if (!self.establishment.cidade) {
          self.establishment.uf = null;
          self.$refs.citySelect.search = '';
        }
      }, 100);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
    this.$store.dispatch('cleanEstablishmentToEdit');
  }
};

/***/ }),
/* 905 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/occurrenceReason/List.vue ***!
  \************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueTables = __webpack_require__(/*! vue-tables-2 */ 132);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _LoadingPlaceholder = __webpack_require__(/*! ../../../loading/LoadingPlaceholder */ 77);

var _LoadingPlaceholder2 = _interopRequireDefault(_LoadingPlaceholder);

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _customFilters = __webpack_require__(/*! ../../../../utils/customFilters.js */ 135);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OccurrenceReasonList',

  components: {
    PageTitle: _PageTitle2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    LoadingPlaceholder: _LoadingPlaceholder2.default,
    ConfirmModal: _ConfirmModal2.default
  },

  data: function data() {
    return {
      isLoadingData: true,
      reasons: (0, _gridLoadTransition.generateLoadingRows)(10),
      columns: ['codigo', 'descricao', 'categoria', 'acoes'],
      options: {
        columnsClasses: { 'acoes': 'col-md-1', 'codigo': 'col-md-1', 'descricao': 'col-md-5', 'categoria': 'col-md-3' },
        headings: {
          codigo: this.$t('motivoOcorrencia.labels.sigla'),
          descricao: this.$t('motivoOcorrencia.labels.descricao'),
          categoria: this.$t('motivoOcorrencia.labels.categoria'),
          acoes: this.$t('motivoOcorrencia.labels.acoes')
        },
        templates: {
          acoes: _LoadingPlaceholder2.default,
          descricao: _LoadingPlaceholder2.default,
          categoria: _LoadingPlaceholder2.default,
          codigo: _LoadingPlaceholder2.default
        },
        filterable: ['codigo', 'descricao'],
        filterByColumn: true,
        perPageValues: [],
        texts: {
          count: this.$t('dataTable.labels.contagem'),
          noResults: this.$t('dataTable.labels.semResultados'),
          filterBy: '',
          filterPlaceholder: this.$t('dataTable.labels.filtrar')
        },
        sortIcon: {
          is: ''
        },
        sortable: ['codigo', 'descricao', 'categoria'],
        pagination: { chunk: 5 },
        customSorting: {
          codigo: function codigo(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'codigo');
            };
          },
          descricao: function descricao(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a, b, 'descricao');
            };
          },
          categoria: function categoria(ascending) {
            return function (a, b) {
              return _customSorter2.default.stringSorter(ascending, a.categoria, b.categoria, 'nome');
            };
          }
        },
        customFilters: [{
          name: 'categoria',
          callback: _customFilters.filterByCategory
        }]
      },
      occurrenceReasonIdToRemove: null
    };
  },


  methods: {
    handleFilter: function handleFilter(event, column) {
      _vueTables.Event.$emit('vue-tables.filter::' + column, event.currentTarget.value);
    },
    edit: function edit(occurrenceReasonId) {
      var _this = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'edit-click', 'edit-motivo-de-ocorrencia', 'edit-motivo-de-ocorrencia');

      this.$store.dispatch('setOccurrenceReasonToEdit', occurrenceReasonId).then(function (response) {
        _this.$router.push(_routesMap2.default.NEW_OCCURRENCE_REASON);
      });
    },
    newOccurrence: function newOccurrence() {
      this.$router.push(_routesMap2.default.NEW_OCCURRENCE_REASON);
    },
    loadOccurrenceReasons: function loadOccurrenceReasons() {
      var _this2 = this;

      var url = '/occurrenceReason/list';
      this.$store.dispatch('getOccurrenceReasons', url).then(function (response) {
        _this2.reasons = response.data.data;
        _this2.isLoadingData = false;
        _this2.options.templates = {
          categoria: function categoria(h, row) {
            return row.categoria ? row.categoria.numero + ' - ' + row.categoria.nome : '-';
          }
        };
      }).catch(function (error) {
        _this2.$root.$refs.notification.error(error.message);
      });
    },
    handleRemove: function handleRemove(occurrenceReasonId) {
      this.occurrenceReasonIdToRemove = occurrenceReasonId;
      $('#confirmRemoveOccurrence').modal('show');
    },
    removeOccurrence: function removeOccurrence() {
      var _this3 = this;

      (0, _analytics.trackAnalyticsEvent)(this, 'remove-click', 'remove-motivo-de-ocorrencia', 'remove-motivo-de-ocorrencia');
      if (this.occurrenceReasonIdToRemove) {
        this.$store.dispatch('removeOccurrenceReason', this.occurrenceReasonIdToRemove).then(function (response) {
          _this3.$root.$refs.notification.success('motivoOcorrencia.sucesso.remover');
          _this3.occurrenceReasonIdToRemove = null;
          $('#confirmRemoveOccurrence').modal('hide');
          _this3.loadOccurrenceReasons();
        }).catch(function (error) {
          _this3.$root.$refs.notification.error(error.message);
        });
      }
    },
    closeModalConfirm: function closeModalConfirm() {
      this.occurrenceReasonIdToRemove = null;
      $('#confirmRemoveOccurrence').modal('hide');
    }
  },

  created: function created() {
    this.loadOccurrenceReasons();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 906 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/registration/occurrenceReason/New.vue ***!
  \***********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _customSorter = __webpack_require__(/*! ../../../../utils/customSorter.js */ 46);

var _customSorter2 = _interopRequireDefault(_customSorter);

var _looseDeepEqual = __webpack_require__(/*! ../../../../utils/looseDeepEqual */ 78);

var _looseDeepEqual2 = _interopRequireDefault(_looseDeepEqual);

var _routesMap = __webpack_require__(/*! ../../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OccurrenceReasonNew',

  components: {
    vSelect: _vueSelect2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      requestSent: false,
      occurrenceReason: {
        id: null,
        initials: null,
        description: null,
        category: null
      },
      categories: []
    };
  },


  computed: {
    occurrenceReasonToEditId: function occurrenceReasonToEditId() {
      return this.$store.getters.occurrenceReasonToEditId;
    },
    filterPortletTitle: function filterPortletTitle() {
      return this.occurrenceReasonToEditId ? this.$t('motivoOcorrencia.labels.editar') : this.$t('motivoOcorrencia.labels.novoPortlet');
    }
  },

  watch: {
    occurrenceReason: {
      handler: function handler() {
        this.$store.dispatch('setHasUnsavedChanges', !(0, _looseDeepEqual2.default)(this.defaultObject, this.occurrenceReason));
      },

      deep: true
    }
  },

  methods: {
    setOcurrencyCategory: function setOcurrencyCategory(val) {
      var _this = this;

      setTimeout(function () {
        if (val) {
          if (!_this.occurrenceReason.category) _this.occurrenceReason.category = {};
          _this.occurrenceReason.category.id = val.id;
          _this.occurrenceReason.category.nome = val.nome;
          _this.occurrenceReason.category.numero = val.numero;
          _this.occurrenceReason.category.label = val.numero + ' - ' + val.nome;
        } else {
          _this.occurrenceReason.category = null;
        }
      }, 100);
    },
    loadCategories: function loadCategories() {
      var _this2 = this;

      this.$store.dispatch('getCategories', {
        url: '/occurrenceReason/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      }).then(function (response) {
        var catArray = [];
        response.data.forEach(function (cat) {
          cat.label = cat.numero + ' - ' + cat.nome;
          catArray.push(cat);
        });

        _this2.categories = _customSorter2.default.arrayDottedSorter(catArray, 'numero', 'asc');
      }).catch(function (error) {
        _this2.$root.$refs.notification.error(error.data.message);
      });
    },
    newOcurrencyReason: function newOcurrencyReason() {
      var _this3 = this;

      var occur = {
        id: this.occurrenceReasonToEditId,
        codigo: this.occurrenceReason.initials,
        descricao: this.occurrenceReason.description,
        categoria: this.occurrenceReason.category
      };

      this.requestSent = true;
      this.$store.dispatch('saveOccurrenceReason', occur).then(function (response) {
        if (_this3.occurrenceReasonToEditId) {
          _this3.$root.$refs.notification.success('motivoOcorrencia.sucesso.editar');
        } else {
          _this3.$root.$refs.notification.success('motivoOcorrencia.sucesso.criar');
        }
        _this3.$store.dispatch('setHasUnsavedChanges', false);
        _this3.$router.push(_routesMap2.default.LIST_OCCURRENCE_REASONS);
      }).catch(function (error) {
        _this3.$root.$refs.notification.error(error.message);
      }).finally(function () {
        _this3.requestSent = false;
      });
    },
    loadOccurrenceReason: function loadOccurrenceReason() {
      var _this4 = this;

      this.$store.dispatch('getOccurrenceReason', this.occurrenceReasonToEditId).then(function (response) {
        _this4.occurrenceReason.initials = response.data.data.codigo;
        _this4.occurrenceReason.description = response.data.data.descricao;
        _this4.occurrenceReason.category = response.data.data.categoria;
        _this4.occurrenceReason.category.label = _this4.occurrenceReason.category.numero + ' - ' + _this4.occurrenceReason.category.nome;
        _this4.defaultObject = (0, _assign2.default)({}, _this4.occurrenceReason, { category: (0, _assign2.default)({}, _this4.occurrenceReason.category) });
      });
    },
    validate: function validate(event) {
      var _this5 = this;

      event.preventDefault();
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this5.newOcurrencyReason();
        } else {
          _this5.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'motivoOcorrencia.erro.criar');
        }
      });
    },
    back: function back() {
      this.$router.push(_routesMap2.default.LIST_OCCURRENCE_REASONS);
    }
  },

  created: function created() {
    this.loadCategories();
    if (this.occurrenceReasonToEditId) {
      this.loadOccurrenceReason();
    } else {
      this.defaultObject = (0, _assign2.default)({}, this.occurrenceReason);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setHasUnsavedChanges', false);
    this.$store.dispatch('cleanOccurrenceReasonToEdit');
  }
};

/***/ }),
/* 907 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/bankBalance/BankBalance.vue ***!
  \*********************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _selectTag = __webpack_require__(/*! ../../../../events/selectTag */ 316);

var _selectTag2 = _interopRequireDefault(_selectTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BankBalance',

  components: {
    MultiSelectModal: _MultiSelectModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    var _this = this;

    return {
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        }
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('saldoBancario.labels.contasBancarias'),
            sub: this.$t('saldoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              banco: function banco(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1;
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1;
                };
              },
              agencia: function agencia(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia;
                  }
                  return a.numAgencia >= b.numAgencia;
                };
              },
              conta: function conta(asc) {
                return function (a, b) {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1;
                  }
                  return +a.conta <= +b.conta ? 1 : -1;
                };
              }
            },
            templates: {
              nome: function nome(h, row) {
                var txt = row.nome;
                if (!row.ativo) {
                  txt += ' (' + _this.$t('contaBancaria.labels.inativa') + ')';
                }
                return txt;
              },
              banco: function banco(h, row) {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome;
                }
                return '-';
              },
              agencia: function agencia(h, row) {
                var txt = '-';
                if (row.agencia) {
                  txt = row.numAgencia;
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia;
                  }
                }
                return txt;
              },
              conta: function conta(h, row) {
                var txt = row.conta;
                if (row.digConta) {
                  txt += '-' + row.digConta;
                }
                return txt;
              }
            }
          }
        }
      },
      shown: {
        bankAccounts: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      groupingOptions: {
        prop: 'grupo.id',
        groupIdProp: 'id',
        headerNameProp: 'nome',
        defaultIdGroup: '0'
      },
      groups: [],
      gridId: '#SaldoConta',
      treeGridCfg: {},
      BANK_ACCOUNT_MODAL: 'bankAccountsModal',
      audit: {},
      dateRange: {},
      bankAccountsSelected: [],
      bankAccountsTags: [this.$t('inputTag.labels.todos')],
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: (0, _moment2.default)(new Date()).add(10, 'years').toDate(),
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'SaldoBancario',
      error: false,
      msgError: '',
      disableSearchButton: false,
      idsItensSelected: []
    };
  },


  methods: {
    validate: function validate() {
      var self = this;
      return new _promise2.default(function (resolve) {
        self.$validator.validateAll().then(function (result) {
          if (result && self.$refs.dateRange.validate()) {
            self.showTreegrid = true;
            (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
            self.search().finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    search: function search() {
      var _this2 = this;

      this.disableSearchButton = true;
      var filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (account) {
          return account !== '-1';
        }),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        lang: _index2.default.getCookieByName('language')
      };

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/bankBalance/', { filter: filter }).then(function (response) {
          if (window.Grids[0]) {
            window.DisposeGrids();
          }
          _this2.result = response.data;
          response.data.Body[0].forEach(function (item) {
            if (item.NomeEstabelecimentoGrupo === '') {
              item.NomeEstabelecimentoGrupo = _this2.$t('contaBancaria.labels.semGrupo');
            }
          });
          _this2.treeGridCfg = response.data.Cfg.Layout;
          _this2.showTreegrid = true;
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this2.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          reject();
        });
      });
    },
    openSelectBankAccountsModal: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var bankAccounts, groups;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.data.bankAccounts.values.length > 0)) {
                  _context.next = 3;
                  break;
                }

                this.shown.bankAccounts = true;
                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list');

              case 5:
                bankAccounts = _context.sent;

                this.data.bankAccounts.allBankAccounts = bankAccounts.data.data;
                this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find(function (bankAccount) {
                  return !bankAccount.ativo;
                });
                this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter(function (bankAccount) {
                  return bankAccount.ativo;
                });
                _context.next = 11;
                return this.$store.dispatch('getEstablishmentGroups');

              case 11:
                groups = _context.sent;

                this.groups = groups;
                this.groups.push({
                  id: 0,
                  nome: this.$t('contaBancaria.labels.semGrupo')
                });
                this.shown.bankAccounts = true;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function openSelectBankAccountsModal() {
        return _ref.apply(this, arguments);
      }

      return openSelectBankAccountsModal;
    }(),
    closeModal: function closeModal() {
      this.shown.bankAccounts = false;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    _selectTag2.default.$on('tagsSelected', function (tags, idsItensSelected) {
      _this3.bankAccountsTags = tags;
      _this3.idsItensSelected = idsItensSelected;
    });
  }
};

/***/ }),
/* 908 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/bankStatement/BankStatement.vue ***!
  \*************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _GridDetailsModal = __webpack_require__(/*! ../../../modals/gridDetailsModal/GridDetailsModal */ 196);

var _GridDetailsModal2 = _interopRequireDefault(_GridDetailsModal);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _transformationData = __webpack_require__(/*! ../../../../utils/transformationData.js */ 163);

var _closeModal = __webpack_require__(/*! ../../../../events/closeModal */ 104);

var _closeModal2 = _interopRequireDefault(_closeModal);

var _funcionalidadeId = __webpack_require__(/*! ../../../../enum/funcionalidadeId */ 134);

var _funcionalidadeId2 = _interopRequireDefault(_funcionalidadeId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'BankStatement',

  components: {
    GridDetailsModal: _GridDetailsModal2.default,
    MultiSelectModal: _MultiSelectModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    var _this = this;

    return {
      groupingOptions: {
        prop: 'grupo.id',
        groupIdProp: 'id',
        headerNameProp: 'nome',
        defaultIdGroup: '0'
      },
      groups: [],
      titleModal: this.$t('extratoBancario.labels.contasBancarias'),
      subTitleModal: this.$t('extratoBancario.labels.selecionarContasBancarias'),
      gridId: '#ExtratoConta',
      BANK_ACCOUNT_MODAL: 'bankAccountsModal',
      audit: {},
      dateRange: {},
      itensSelected: [],
      list: [],
      selectedList: [],
      selectModal: null,
      allItensSelected: null,
      bankAccountsSelected: [],
      bankAccountsTags: [this.$t('inputTag.labels.todos')],
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: (0, _moment2.default)(new Date()).add(10, 'years').toDate(),
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'ExtratoBancario',
      error: false,
      msgError: '',
      dataTableColumns: [],
      disableSearchButton: false,
      detailsObj: {
        mainValuesList: [],
        monetaryValuesList: [],
        integrationValuesList: [],
        classificationValuesList: [],
        idProcessamento: -1
      },
      bankStatGridModalId: '',
      isOpenDetailsModal: false,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTime: true,
      modalDetailsTabs: [],
      filterable: ['nome'],
      showCustomColumns: false,
      treeGridCfg: {},
      isExportFile: false,
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        }
      },
      shown: {
        bankAccounts: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              banco: function banco(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1;
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1;
                };
              },
              agencia: function agencia(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia;
                  }
                  return a.numAgencia >= b.numAgencia;
                };
              },
              conta: function conta(asc) {
                return function (a, b) {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1;
                  }
                  return +a.conta <= +b.conta ? 1 : -1;
                };
              }
            },
            templates: {
              nome: function nome(h, row) {
                var txt = row.nome;
                if (!row.ativo) {
                  txt += ' (' + _this.$t('contaBancaria.labels.inativa') + ')';
                }
                return txt;
              },
              banco: function banco(h, row) {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome;
                }
                return '-';
              },
              agencia: function agencia(h, row) {
                var txt = '-';
                if (row.agencia) {
                  txt = row.numAgencia;
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia;
                  }
                }
                return txt;
              },
              conta: function conta(h, row) {
                var txt = row.conta;
                if (row.digConta) {
                  txt += '-' + row.digConta;
                }
                return txt;
              }
            }
          }
        }
      },
      queryNotClassif: true,
      queryOnlyClassif: true
    };
  },


  methods: {
    getLoadingMessages: function getLoadingMessages() {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid'];
    },
    validate: function validate() {
      var _this2 = this;

      var self = this;
      var promise = null;
      return new _promise2.default(function (resolve) {
        self.$validator.validateAll().then(function (result) {
          if (result && _this2.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download();
            } else {
              self.showTreegrid = true;
              (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
              promise = self.search();
            }
            promise.finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    mountFilters: function mountFilters() {
      this.disableSearchButton = true;
      var filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (account) {
          return account !== '-1';
        }),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        lang: _index2.default.getCookieByName('language'),
        considerarClassificacao: this.queryNotClassif && !this.queryOnlyClassif ? 0 : !this.queryNotClassif && this.queryOnlyClassif ? 1 : 2
      };
      return filter;
    },
    download: function download() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        _this3.$store.dispatch('searchBankStatementToFile', { filter: _this3.mountFilters() }).then(function () {
          _this3.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this3.error = true;
          _this3.msgError = error.body;
          _this3.$root.$refs.notification.error('GENERAL');
          _this3.disableSearchButton = false;
          reject();
        });
      });
    },
    search: function search() {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/bankStatement/', { filter: _this4.mountFilters() }).then(function (response) {
          response.data.Body.forEach(function (e) {
            e._isVue = true;
          });
          if (window.Grids[0]) {
            window.DisposeGrids();
          }
          _this4.result = response.data;
          response.data.Body.forEach(function (bodyList) {
            bodyList.forEach(function (item) {
              if (item.NomeEstabelecimentoGrupo === '') {
                item.NomeEstabelecimentoGrupo = _this4.$t('contaBancaria.labels.semGrupo');
              }
              if (item.CritClassif === '') {
                item.CritClassif = _this4.$t('extratoBancario.labels.naoClassificado');
              }
            });
          });
          _this4.treeGridCfg = _this4.result && _this4.result.Cfg ? _this4.result.Cfg.Layout : {};

          if (_this4.result && _this4.result.Solid[0]) {
            var valorAnterior = _this4.result.Solid[0].VlSaldoAnterior;
            if (valorAnterior == null) {
              _this4.treeGridCfg.Solid[2].DsHistorico = _this4.$t('extratoBancario.labels.saldoVazio').replace('{DIA_ANTERIOR}', (0, _moment2.default)(_this4.result.Solid[0].DtLanc).format('DD/MM/YYYY'));
              _this4.treeGridCfg.Solid[2].Cells = 'DsHistorico';
            } else {
              _this4.treeGridCfg.Solid[2].DsHistorico = _this4.treeGridCfg.Solid[2].DsHistorico.replace('{DIA_ANTERIOR}', (0, _moment2.default)(_this4.result.Solid[0].DtLanc).format('DD/MM/YYYY'));
            }
          }
          _this4.showTreegrid = true;
          window.Grids.abrirModalDetalhes = function (row) {
            _this4.bankStatGridModalId = 'bankStatGridModalIdMov-' + row.IdLancamento;
            (0, _analytics.trackAnalyticsEvent)(_this4, 'row-click', 'extrato-bancario-grid-details', row.IdLancamento);
            _this4.detailsObj = (0, _transformationData.generateBankStatFromRow)(row);
            _this4.generateModalTabs();
            setTimeout(function () {
              _this4.showDetailsModal();
              window.Grids[0].Disable();
            }, 100);
          };
          _this4.showTreegrid = true;
          (0, _gridLoadTransition.stopTreeGridLoading)(_this4.gridId);

          if (!_this4.queryNotClassif && _this4.queryOnlyClassif) {
            setTimeout(function () {
              window.Grids[0].DoGrouping('CritClassif,NomeCategoria,DtLanc,Banco,NrConta,DsHistorico');
            }, 300);
          }
          _this4.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this4.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this4.gridId);
          _this4.disableSearchButton = false;
          reject();
        });
      });
    },
    openSelectBankAccountsModal: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var bankAccounts, groups;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.data.bankAccounts.values.length > 0)) {
                  _context.next = 3;
                  break;
                }

                this.shown.bankAccounts = true;
                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list');

              case 5:
                bankAccounts = _context.sent;

                this.data.bankAccounts.allBankAccounts = bankAccounts.data.data;
                this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find(function (bankAccount) {
                  return !bankAccount.ativo;
                });
                this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter(function (bankAccount) {
                  return bankAccount.ativo;
                });
                _context.next = 11;
                return this.$store.dispatch('getEstablishmentGroups');

              case 11:
                groups = _context.sent;

                this.groups = groups;
                this.groups.push({
                  id: 0,
                  nome: this.$t('contaBancaria.labels.semGrupo')
                });
                this.shown.bankAccounts = true;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function openSelectBankAccountsModal() {
        return _ref.apply(this, arguments);
      }

      return openSelectBankAccountsModal;
    }(),
    showDetailsModal: function showDetailsModal() {
      this.isOpenDetailsModal = true;
    },
    closeDetailsModal: function closeDetailsModal() {
      this.isOpenDetailsModal = false;
    },
    closeModal: function closeModal() {
      this.shown.bankAccounts = false;
    },
    generateModalTabs: function generateModalTabs() {
      var tabs = [];

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          mainValuesList: this.detailsObj.mainValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList
        }
      });

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabClassification',
        idTabContent: 'tab-classification-id',
        idMovimento: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabClassificationGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabClassif'),
        icon: 'tab-icon-font fa fa-handshake-o',
        type: 'TabClassification',
        props: {
          mainValuesList: this.detailsObj.classificationValuesList
        }
      });

      if (this.detailsObj.idProcessamento) {
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        });
      }

      tabs.push({
        idFunctionalitie: _funcionalidadeId2.default.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tipoMovimento: 'MovBan'
        }
      });

      this.modalDetailsTabs = tabs;
    },
    findBankStatementHistory: function findBankStatementHistory(id) {
      var data = {
        idBankStat: id,
        url: '/bankStatement/history'
      };
      return this.$store.dispatch('getHistoricBankStat', data);
    },
    findIntegration: function findIntegration(id) {
      var data = {
        idProcessamento: id,
        url: '/processedFiles/getProcessedFilesById'
      };
      return this.$store.dispatch('getProcessedFiles', data);
    }
  },

  mounted: function mounted() {
    var self = this;
    _closeModal2.default.$on('modalDetaisClose', function (flag) {
      if (flag) {
        self.showTreegrid = true;
        (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
        self.search();

        _closeModal2.default.$emit('taskChange', false);
      }
    });
  }
};

/***/ }),
/* 909 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/conciliationReport/ConciliationReport.vue ***!
  \***********************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _GridDetailsModal = __webpack_require__(/*! ../../../modals/gridDetailsModal/GridDetailsModal */ 196);

var _GridDetailsModal2 = _interopRequireDefault(_GridDetailsModal);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _InputEstablishment = __webpack_require__(/*! ../../../input/inputEstablishment/InputEstablishment */ 130);

var _InputEstablishment2 = _interopRequireDefault(_InputEstablishment);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _transformationData = __webpack_require__(/*! ../../../../utils/transformationData.js */ 163);

var _closeModal = __webpack_require__(/*! ../../../../events/closeModal */ 104);

var _closeModal2 = _interopRequireDefault(_closeModal);

var _funcionalidadeId = __webpack_require__(/*! ../../../../enum/funcionalidadeId */ 134);

var _funcionalidadeId2 = _interopRequireDefault(_funcionalidadeId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConciliationReport',

  components: {
    GridDetailsModal: _GridDetailsModal2.default,
    MultiSelectModal: _MultiSelectModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    InputEstablishment: _InputEstablishment2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    var _this = this;

    return {
      establishimentsUrls: {
        establishments: 'conciliationReport/establishment/list',
        attributes: '/conciliationReport/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isExportFile: false,
      isAdvancedSearch: true,
      gridId: '#RelatorioConciliacao',
      treeGridCfg: {},
      audit: {},
      dateRange: {},
      situationList: [{
        id: 'A',
        nome: this.$t('statusConciliacao.aberto'),
        checked: true
      }, {
        id: 'C',
        nome: this.$t('statusConciliacao.conciliado'),
        checked: true
      }, {
        id: 'M',
        nome: this.$t('statusConciliacao.conciliadoManualmente'),
        checked: true
      }, {
        id: 'D',
        nome: this.$t('statusConciliacao.divergente'),
        checked: true
      }, {
        id: 'N',
        nome: this.$t('statusConciliacao.naoAplicavel'),
        checked: true
      }],
      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'RelatorioConciliacao',
      dataTableColumns: [],
      disableSearchButton: false,
      firstTimeBank: true,
      detailsObj: {
        establishtmentValue: {},
        mainValuesList: [],
        monetaryValuesList: [],
        statusValuesList: [],
        integrationValuesList: [],
        classificationValuesList: [],
        idProcessamento: -1
      },
      concReportGridModalId: '',
      isOpenDetailsModal: false,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTimeAccount: true,
      modalDetailsTabs: [],
      filterable: [],
      attList: [],
      columnsFilterable: [],
      customFilters: [],
      showCustomColumns: false,
      firstTimeCategorie: true,
      customSetOrder: null,
      shown: {
        bankAccounts: false,
        categories: false
      },
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        },
        categories: {
          id: 'id',
          name: 'nome'
        }
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        categories: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todas')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              banco: function banco(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1;
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1;
                };
              },
              agencia: function agencia(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia;
                  }
                  return a.numAgencia >= b.numAgencia;
                };
              },
              conta: function conta(asc) {
                return function (a, b) {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1;
                  }
                  return +a.conta <= +b.conta ? 1 : -1;
                };
              }
            },
            templates: {
              nome: function nome(h, row) {
                var txt = row.nome;
                if (!row.ativo) {
                  txt += ' (' + _this.$t('contaBancaria.labels.inativa') + ')';
                }
                return txt;
              },
              banco: function banco(h, row) {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome;
                }
                return '-';
              },
              agencia: function agencia(h, row) {
                var txt = '-';
                if (row.agencia) {
                  txt = row.numAgencia;
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia;
                  }
                }
                return txt;
              },
              conta: function conta(h, row) {
                var txt = row.conta;
                if (row.digConta) {
                  txt += '-' + row.digConta;
                }
                return txt;
              }
            }
          }
        },
        categories: {
          titles: {
            main: this.$t('categoria.titulos.titulo'),
            sub: this.$t('categoria.labels.selecionarCategoria')
          },
          selectedItems: [],
          columns: ['numero', 'nome', 'idContabil', 'tipo'],
          values: [],
          options: {
            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },
            perPage: 5,
            headings: {
              numero: this.$t('categoria.modal.labels.numero'),
              nome: this.$t('categoria.modal.labels.descricao'),
              idContabil: this.$t('categoria.modal.labels.idContabil'),
              tipo: this.$t('categoria.modal.labels.tipo')
            },
            filterable: ['numero', 'nome', 'idContabil', 'tipo'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['numero', 'nome', 'idContabil', 'tipo'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'numero'
            },
            customSorting: {
              numero: function numero(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.ordem >= b.ordem ? 1 : -1;
                  }
                  return a.ordem <= b.ordem ? 1 : -1;
                };
              },
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              idContabil: function idContabil(asc) {
                return function (a, b) {
                  var idA = a.idContabil;
                  var idB = b.idContabil;
                  if (idA === null || idB === null) {
                    if (asc) {
                      return idA === null ? -1 : 1;
                    }
                    return idA === null ? 1 : -1;
                  }
                  if (asc) {
                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase());
                  }
                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase());
                };
              },
              tipo: function tipo(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase());
                  }
                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase());
                };
              }
            },
            templates: {
              idContabil: function idContabil(h, row) {
                return row.idContabil || '-';
              },
              tipo: function tipo(h, row) {
                return _this.$t('categoria.modal.labels.' + row.tipo);
              }
            }
          }
        }
      }
    };
  },


  watch: {
    situationList: {
      handler: function handler(val) {
        var _this2 = this;

        this.selectedStatuses = [];
        val.forEach(function (st) {
          if (st.checked) {
            _this2.selectedStatuses.push(st.id);
          }
        });
      },

      deep: true
    }
  },

  methods: {
    setFilter: function setFilter() {
      return {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (account) {
          return account !== '-1';
        }),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        idsEstabelecimentos: this.selectedEstablishments.map(function (selected) {
          return selected.id;
        }),
        idsCategorias: this.data.categories.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (categories) {
          return categories !== '-1';
        }),
        situacoesConciliacao: this.selectedStatuses,
        lang: _index2.default.getCookieByName('language')
      };
    },
    resetFilter: function resetFilter() {
      this.selectedEstablishments = [];
      this.data.bankAccounts.selectedItems = [];
      this.data.bankAccounts.considerInactiveAccounts = false;
      this.data.categories.selectedItems = [];
      this.situationList.forEach(function (situation) {
        situation.checked = true;
      });
      this.selectedStatuses = ['A', 'C', 'M', 'D', 'N'];
    },
    getLoadingMessages: function getLoadingMessages() {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid'];
    },
    validate: function validate() {
      var _this3 = this;

      var self = this;
      var promise = null;
      return new _promise2.default(function (resolve) {
        _this3.$validator.validateAll().then(function (result) {
          if (result && self.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download();
            } else {
              self.showTreegrid = true;
              (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
              promise = self.search();
            }
            promise.finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    download: function download() {
      var _this4 = this;

      this.disableSearchButton = true;
      var filter = this.setFilter();
      return new _promise2.default(function (resolve, reject) {
        _this4.$store.dispatch('searchConciliationReportToFile', filter).then(function () {
          _this4.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this4.$root.$refs.notification.error(error);
          _this4.disableSearchButton = false;
          reject();
        });
      });
    },
    search: function search() {
      var _this5 = this;

      this.disableSearchButton = true;
      var filter = this.setFilter();

      return new _promise2.default(function (resolve, reject) {
        _this5.$store.dispatch('searchConciliationReport', filter).then(function (response) {
          if (window.Grids[0]) {
            window.DisposeGrids();
          }
          _this5.result = response.data;
          _this5.treeGridCfg = response.data.Cfg.Layout;
          window.Grids.abrirModalDetalhes = function (row) {
            (0, _analytics.trackAnalyticsEvent)(_this5, 'row-click', 'relatorio-conciliacao-grid-details', row.IdConciliacaoLote);
            if (row.IdExtBancario) {
              _this5.concReportGridModalId = 'concReportGridModalIdMov-' + row.IdExtBancario;
              _this5.$store.dispatch('getBankStatementById', row.IdExtBancario).then(function (response) {
                _this5.detailsObj = (0, _transformationData.generateBankStatFromNode)(response.data);
                _this5.detailsObj.statusLancamento = response.data.situacaoConciliacao;
                _this5.generateModalTabs('MovBan', row.IdContaLancamento);
                setTimeout(function () {
                  _this5.showDetailsModal();
                  window.Grids[0].Disable();
                }, 100);
              }).catch(function (error) {
                if (error.message) {
                  _this5.$root.$refs.notification.error(error.message);
                } else {
                  _this5.$root.$refs.notification.error('modalDetalhesLanc.error.parseError');
                }
              });
            } else {
              _this5.concReportGridModalId = 'concReportGridModalIdMov-' + row.IdMovFinanceiro;
              var obj = {
                url: '/conciliationReport/getFinancialMovById',
                id: row.IdMovFinanceiro
              };

              _this5.$store.dispatch('getFinancialMovementById', obj).then(function (response) {
                _this5.detailsObj = (0, _transformationData.generateFinMovFromNode)(response.data);
                _this5.detailsObj.statusLancamento = response.data.situacaoConciliacao;
                _this5.generateModalTabs('MovFin');
                setTimeout(function () {
                  _this5.showDetailsModal();
                  window.Grids[0].Disable();
                }, 100);
              }).catch(function (error) {
                if (error.message) {
                  _this5.$root.$refs.notification.error(error.message);
                } else {
                  _this5.$root.$refs.notification.error('modalDetalhesLanc.error.parseError');
                }
              });
            }
          };
          (0, _gridLoadTransition.stopTreeGridLoading)(_this5.gridId);
          _this5.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this5.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this5.gridId);
          _this5.disableSearchButton = false;
          reject();
        });
      });
    },
    openSelectBankAccountsModal: function openSelectBankAccountsModal() {
      var _this6 = this;

      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true;
        return;
      }
      this.$store.dispatch('getBankAccounts', '/conciliationReport/bankAccounts/list').then(function (response) {
        _this6.data.bankAccounts.allBankAccounts = response.data.data;
        _this6.data.bankAccounts.showToggleInactiveAccounts = _this6.data.bankAccounts.allBankAccounts.find(function (bankAccount) {
          return !bankAccount.ativo;
        });
        _this6.data.bankAccounts.values = _this6.data.bankAccounts.allBankAccounts.filter(function (bankAccount) {
          return bankAccount.ativo;
        });
        _this6.shown.bankAccounts = true;
      });
    },
    openSelectCategoriesModal: function openSelectCategoriesModal() {
      var _this7 = this;

      if (this.data.categories.values.length > 0) {
        this.shown.categories = true;
        return;
      }
      this.$store.dispatch('getCategories', {
        url: '/conciliationReport/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      }).then(function (response) {
        _this7.data.categories.values = response.data;
        _this7.shown.categories = true;
      });
    },
    showDetailsModal: function showDetailsModal() {
      this.isOpenDetailsModal = true;
    },
    closeDetailsModal: function closeDetailsModal() {
      this.isOpenDetailsModal = false;
    },
    closeModal: function closeModal() {
      this.shown.bankAccounts = false;
      this.shown.categories = false;
    },
    generateModalTabs: function generateModalTabs(tipoMovimento, idContaLanc) {
      var tabs = [];

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          establishtmentValue: this.detailsObj.establishtmentValue,
          mainValuesList: this.detailsObj.mainValuesList,
          statusValuesList: this.detailsObj.statusValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList,
          commentary: this.detailsObj.commentary
        }
      });

      if (tipoMovimento !== 'MovFin') {
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabClassification',
          idTabContent: 'tab-classification-id',
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tabClassificationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabClassif'),
          icon: 'tab-icon-font fa fa-handshake-o',
          type: 'TabClassification',
          props: {
            mainValuesList: this.detailsObj.classificationValuesList
          }
        });
      }

      if (this.detailsObj.idProcessamento) {
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value.toString(),
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            establishtmentValue: this.detailsObj.establishtmentValue,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        });
      }

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.detailsObj.idMovimentoBancario ? this.findBankStatementHistory : this.findFinancialMovementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value.toString()
        }
      });

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabAllotment',
        idTabContent: 'tab-allotment-id',
        idLanc: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tadAllotmentGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabLote'),
        icon: 'tab-icon-font fa fa-cubes',
        type: 'TabAllotment',
        props: {
          getAllotment: tipoMovimento === 'MovFin' ? this.findFinancialMovementAllotment : this.findBankStatAllotment,
          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: tipoMovimento
        }
      });

      tabs.push({
        idFunctionalitie: _funcionalidadeId2.default.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: tipoMovimento === 'MovBan' ? idContaLanc.toString() : this.detailsObj.mainValuesList[0].value.toString(),
          tipoMovimento: tipoMovimento,
          statusMovimento: this.detailsObj.statusLancamento
        }
      });
      this.modalDetailsTabs = tabs;
    },
    findFinancialMovementHistory: function findFinancialMovementHistory(id) {
      var data = {
        conciliationReportId: id,
        url: '/conciliationReport/financialMovementHistoryHistory'
      };
      return this.$store.dispatch('getHistoricConciliationReport', data);
    },
    findBankStatementHistory: function findBankStatementHistory(id) {
      var data = {
        conciliationReportId: id,
        url: '/conciliationReport/bankStatementHistory'
      };
      return this.$store.dispatch('getHistoricConciliationReport', data);
    },
    findIntegration: function findIntegration(id) {
      var data = {
        idProcessamento: id,
        url: '/conciliationReport/getProcessedFilesById'
      };
      return this.$store.dispatch('getProcessedFiles', data);
    },
    findFinancialMovementAllotment: function findFinancialMovementAllotment(id) {
      var data = {
        idFinancialMovement: id,
        url: '/conciliationReport/getAllotmentByMovFinId'
      };
      return this.$store.dispatch('getAllotmentByMovementId', data);
    },
    findBankStatAllotment: function findBankStatAllotment(id) {
      var data = {
        idFinancialMovement: id,
        url: '/conciliationReport/getAllotmentByMovBanId'
      };
      return this.$store.dispatch('getAllotmentByMovementId', data);
    }
  },

  mounted: function mounted() {
    var self = this;
    _closeModal2.default.$on('modalDetaisClose', function (flag) {
      if (flag) {
        self.showTreegrid = true;
        (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
        self.search();

        _closeModal2.default.$emit('taskChange', false);
      }
    });
  }
};

/***/ }),
/* 910 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/conciliationSummary/ConciliationSummary.vue ***!
  \*************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _InputEstablishment = __webpack_require__(/*! ../../../input/inputEstablishment/InputEstablishment */ 130);

var _InputEstablishment2 = _interopRequireDefault(_InputEstablishment);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _CalendarSummary = __webpack_require__(/*! ../../../reports/conciliationSummary/CalendarSummary */ 1303);

var _CalendarSummary2 = _interopRequireDefault(_CalendarSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConciliationSummary',

  components: {
    MultiSelectModal: _MultiSelectModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    InputEstablishment: _InputEstablishment2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default,
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    CalendarSummary: _CalendarSummary2.default
  },

  data: function data() {
    var _this = this;

    return {
      establishimentsUrls: {
        establishments: 'conciliationSummary/establishment/list',
        attributes: '/conciliationSummary/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      gridId: '#conciliationSummaryGrid',
      CATEGORIES_MODAL: 'categoriesModal',
      dateRange: {},
      treeGridCfg: {},
      firstDate: new Date(),
      finalDate: new Date(),
      itensSelected: [],
      tipoMovimetacao: 'M',
      list: [],
      selectedList: [],
      disableSearchButton: false,
      filter: {},
      allSelectedItems: null,
      dataTableColumns: [],
      showTreegrid: false,
      result: {},
      treeGridFileName: 'ResumoConciliacao',
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      idsItensSelected: [],
      firstTime: true,
      filterable: [],
      attList: [],
      columnsFilterable: [],
      showCustomColumns: false,
      establishment: [],
      firstTimeCategorie: true,
      customSetOrder: null,
      situationList: [{
        id: 'A',
        nome: this.$t('statusConciliacao.aberto'),
        checked: true
      }, {
        id: 'C',
        nome: this.$t('statusConciliacao.conciliado'),
        checked: true
      }, {
        id: 'M',
        nome: this.$t('statusConciliacao.conciliadoManualmente'),
        checked: true
      }, {
        id: 'D',
        nome: this.$t('statusConciliacao.divergente'),
        checked: true
      }, {
        id: 'N',
        nome: this.$t('statusConciliacao.naoAplicavel'),
        checked: true
      }],
      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],
      plansSelected: [],
      idsPlansSelected: [],
      firstTimePlan: true,
      isExportFile: false,
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        },
        categories: {
          id: 'id',
          name: 'nome'
        }
      },
      shown: {
        bankAccounts: false,
        categories: false
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        categories: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todas')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              banco: function banco(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1;
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1;
                };
              },
              agencia: function agencia(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia;
                  }
                  return a.numAgencia >= b.numAgencia;
                };
              },
              conta: function conta(asc) {
                return function (a, b) {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1;
                  }
                  return +a.conta <= +b.conta ? 1 : -1;
                };
              }
            },
            templates: {
              nome: function nome(h, row) {
                var txt = row.nome;
                if (!row.ativo) {
                  txt += ' (' + _this.$t('contaBancaria.labels.inativa') + ')';
                }
                return txt;
              },
              banco: function banco(h, row) {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome;
                }
                return '-';
              },
              agencia: function agencia(h, row) {
                var txt = '-';
                if (row.agencia) {
                  txt = row.numAgencia;
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia;
                  }
                }
                return txt;
              },
              conta: function conta(h, row) {
                var txt = row.conta;
                if (row.digConta) {
                  txt += '-' + row.digConta;
                }
                return txt;
              }
            }
          }
        },
        categories: {
          titles: {
            main: this.$t('categoria.titulos.titulo'),
            sub: this.$t('categoria.labels.selecionarCategoria')
          },
          selectedItems: [],
          columns: ['numero', 'nome', 'idContabil', 'tipo'],
          values: [],
          options: {
            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },
            perPage: 5,
            headings: {
              numero: this.$t('categoria.modal.labels.numero'),
              nome: this.$t('categoria.modal.labels.descricao'),
              idContabil: this.$t('categoria.modal.labels.idContabil'),
              tipo: this.$t('categoria.modal.labels.tipo')
            },
            filterable: ['numero', 'nome', 'idContabil', 'tipo'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['numero', 'nome', 'idContabil', 'tipo'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'numero'
            },
            customSorting: {
              numero: function numero(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.ordem >= b.ordem ? 1 : -1;
                  }
                  return a.ordem <= b.ordem ? 1 : -1;
                };
              },
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              idContabil: function idContabil(asc) {
                return function (a, b) {
                  var idA = a.idContabil;
                  var idB = b.idContabil;
                  if (idA === null || idB === null) {
                    if (asc) {
                      return idA === null ? -1 : 1;
                    }
                    return idA === null ? 1 : -1;
                  }
                  if (asc) {
                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase());
                  }
                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase());
                };
              },
              tipo: function tipo(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase());
                  }
                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase());
                };
              }
            },
            templates: {
              idContabil: function idContabil(h, row) {
                return row.idContabil || '-';
              },
              tipo: function tipo(h, row) {
                return _this.$t('categoria.modal.labels.' + row.tipo);
              }
            }
          }
        }
      }
    };
  },


  computed: {
    idsFilterEstablishments: function idsFilterEstablishments() {
      return this.$store.getters.idsFilterEstablishments;
    },
    showCalendarTab: function showCalendarTab() {
      return this.$store.getters.allowedFuncionalities.includes(4008);
    },
    showReportTab: function showReportTab() {
      return this.$store.getters.allowedFuncionalities.includes(205);
    }
  },

  watch: {
    situationList: {
      handler: function handler(val) {
        var _this2 = this;

        this.selectedStatuses = [];
        val.forEach(function (st) {
          if (st.checked) {
            _this2.selectedStatuses.push(st.id);
          }
        });
      },

      deep: true
    }
  },

  methods: {
    getLoadingMessages: function getLoadingMessages() {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid'];
    },
    validate: function validate() {
      var _this3 = this;

      var self = this;
      var promise = null;
      return new _promise2.default(function (resolve) {
        _this3.$validator.validateAll().then(function (result) {
          if (result && self.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download();
            } else {
              self.showTreegrid = true;
              (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
              promise = self.search();
            }
            promise.finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    resetFilter: function resetFilter() {
      this.selectedEstablishments = [];
      this.data.bankAccounts.selectedItems = [];
      this.data.bankAccounts.considerInactiveAccounts = false;
      this.data.categories.selectedItems = [];
      this.situationList.forEach(function (situation) {
        situation.checked = true;
      });
      this.selectedStatuses = ['A', 'C', 'M', 'D', 'N'];
    },
    generateFilter: function generateFilter() {
      return {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsContas: this.data.bankAccounts.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (account) {
          return account !== '-1';
        }),
        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,
        idsEstabelecimentos: this.selectedEstablishments.map(function (selected) {
          return selected.id;
        }),
        tipoMovimetacao: this.tipoMovimetacao,
        idsCategorias: this.data.categories.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (category) {
          return category !== '-1';
        }),
        idsPlanosConciliacao: [],
        situacoesConciliacao: this.selectedStatuses,
        lang: _index2.default.getCookieByName('language')
      };
    },
    download: function download() {
      var _this4 = this;

      this.disableSearchButton = true;
      return new _promise2.default(function (resolve, reject) {
        _this4.$store.dispatch('searchConciliationSummaryToFile', _this4.generateFilter()).then(function () {
          _this4.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this4.error = true;
          _this4.msgError = error.body;
          _this4.$root.$refs.notification.error('GENERAL');
          _this4.disableSearchButton = false;
          reject();
        });
      });
    },
    search: function search() {
      var _this5 = this;

      this.disableSearchButton = true;
      return new _promise2.default(function (resolve, reject) {
        _this5.$store.dispatch('searchConciliationSummary', _this5.generateFilter()).then(function (response) {
          window.DisposeGrids();
          _this5.result = response.data;
          _this5.treeGridCfg = response.data.Cfg.Layout;
          (0, _gridLoadTransition.stopTreeGridLoading)(_this5.gridId);
          _this5.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this5.error = true;
          _this5.msgError = error.body;
          _this5.$root.$refs.notification.error('GENERAL');
          (0, _gridLoadTransition.stopTreeGridLoading)(_this5.gridId);
          _this5.disableSearchButton = false;
          reject();
        });
      });
    },
    openSelectBankAccountsModal: function openSelectBankAccountsModal() {
      var _this6 = this;

      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true;
        return;
      }
      this.$store.dispatch('getBankAccounts', '/conciliationSummary/bankAccounts/list').then(function (response) {
        _this6.data.bankAccounts.allBankAccounts = response.data.data;
        _this6.data.bankAccounts.showToggleInactiveAccounts = _this6.data.bankAccounts.allBankAccounts.find(function (bankAccount) {
          return !bankAccount.ativo;
        });
        _this6.data.bankAccounts.values = _this6.data.bankAccounts.allBankAccounts.filter(function (bankAccount) {
          return bankAccount.ativo;
        });
        _this6.shown.bankAccounts = true;
      });
    },
    openSelectCategoriesModal: function openSelectCategoriesModal() {
      var _this7 = this;

      if (this.data.categories.values.length > 0) {
        this.shown.categories = true;
        return;
      }
      this.$store.dispatch('getCategories', {
        url: '/conciliationSummary/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      }).then(function (response) {
        _this7.data.categories.values = response.data;
        _this7.shown.categories = true;
      });
    },
    closeModal: function closeModal() {
      this.shown.bankAccounts = false;
      this.shown.categories = false;
    },
    handleTabChange: function handleTabChange(tabIndex, newTab, oldTab) {
      switch (newTab.id) {
        case 'reportSummary':
          break;
        case 'calendarSummary':
          this.$refs.calendarSummary.$children[0].searchConciliationSummary();
          break;
        default:
          break;
      }
    }
  },

  mounted: function mounted() {
    this.$refs.calendarSummary.$children[0].searchConciliationSummary();
  }
};

/***/ }),
/* 911 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/digitalWalletBalance/DigitalWalletBalance.vue ***!
  \***************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _moment = __webpack_require__(/*! moment */ 1);

var _moment2 = _interopRequireDefault(_moment);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _axiosCommon = __webpack_require__(/*! ../../../../../build/http-requests/axios-common.js */ 20);

var _axiosCommon2 = _interopRequireDefault(_axiosCommon);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _selectTag = __webpack_require__(/*! ../../../../events/selectTag */ 316);

var _selectTag2 = _interopRequireDefault(_selectTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DigitalWalletBalance',

  components: {
    MultiSelectModal: _MultiSelectModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      inputTagsProps: {
        digitalWallets: {
          id: 'id',
          name: 'nome'
        }
      },
      data: {
        digitalWallets: {
          titles: {
            main: this.$t('saldoCarteiraDigital.labels.carteirasDigitais'),
            sub: this.$t('saldoCarteiraDigital.labels.selecionarCarteirasDigitais')
          },
          selectedItems: [],
          columns: ['nome'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-12' },
            perPage: 5,
            headings: {
              nome: this.$t('saldoCarteiraDigital.labels.nome')
            },
            filterable: ['nome'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              }
            },
            templates: {
              nome: function nome(h, row) {
                return row.nome;
              }
            }
          }
        }
      },
      shown: {
        digitalWallets: false
      },
      defaultTags: {
        digitalWallets: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      gridId: '#SaldoCarteiraDigital',
      treeGridCfg: {},
      DIGITAL_WALLET_MODAL: 'digitalWalletsModal',
      audit: {},
      dateRange: {},
      digitalWalletsSelected: [],
      digitalWalletsTags: [this.$t('inputTag.labels.todos')],
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: (0, _moment2.default)(new Date()).add(10, 'years').toDate(),
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'SaldoCarteiraDigital',
      error: false,
      msgError: '',
      disableSearchButton: false,
      idsItensSelected: []
    };
  },


  methods: {
    validate: function validate() {
      var self = this;
      return new _promise2.default(function (resolve) {
        self.$validator.validateAll().then(function (result) {
          if (result && self.$refs.dateRange.validate()) {
            self.showTreegrid = true;
            (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
            self.search().finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    search: function search() {
      var _this = this;

      this.disableSearchButton = true;
      var filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsCategorias: this.data.digitalWallets.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (categories) {
          return categories !== '-1';
        }),
        lang: _index2.default.getCookieByName('language')
      };

      return new _promise2.default(function (resolve, reject) {
        _axiosCommon2.default.post('/digitalWalletBalance/', { filter: filter }).then(function (response) {
          if (window.Grids[0]) {
            window.DisposeGrids();
          }
          _this.result = response.data;
          _this.treeGridCfg = response.data.Cfg.Layout;
          _this.showTreegrid = true;
          (0, _gridLoadTransition.stopTreeGridLoading)(_this.gridId);
          _this.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this.gridId);
          _this.disableSearchButton = false;
          reject();
        });
      });
    },
    openSelectDigitalWalletsModal: function openSelectDigitalWalletsModal() {
      var _this2 = this;

      if (this.data.digitalWallets.values.length > 0) {
        this.shown.digitalWallets = true;
        return;
      }
      this.$store.dispatch('getCategories', {
        url: '/digitalWalletBalance/loadCategories',
        flTipoCategoria: 'W',
        validarUso: false
      }).then(function (response) {
        _this2.data.digitalWallets.values = response.data;
        _this2.shown.digitalWallets = true;
      });
    },
    closeModal: function closeModal() {
      this.shown.digitalWallets = false;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    _selectTag2.default.$on('tagsSelected', function (tags, idsItensSelected) {
      _this3.digitalWalletsTags = tags;
      _this3.idsItensSelected = idsItensSelected;
    });
  }
};

/***/ }),
/* 912 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/duplicateMovementsAnalysis/DuplicateMovementsAnalysis.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(/*! babel-runtime/core-js/object/assign */ 35);

var _assign2 = _interopRequireDefault(_assign);

var _ConfirmModal = __webpack_require__(/*! ../../../modals/confirmModal/ConfirmModal */ 59);

var _ConfirmModal2 = _interopRequireDefault(_ConfirmModal);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _DuplicateMovements = __webpack_require__(/*! ../../../reports/duplicateMovementsAnalysis/DuplicateMovements */ 1305);

var _DuplicateMovements2 = _interopRequireDefault(_DuplicateMovements);

var _AnnulledMovements = __webpack_require__(/*! ../../../reports/duplicateMovementsAnalysis/AnnulledMovements */ 1304);

var _AnnulledMovements2 = _interopRequireDefault(_AnnulledMovements);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DuplicateMovementsAnalysis',

  components: {
    ConfirmModal: _ConfirmModal2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    PageTitle: _PageTitle2.default,
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    DuplicateMovements: _DuplicateMovements2.default,
    AnnulledMovements: _AnnulledMovements2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      currentTab: 'tabDuplicated',
      disableSearchButton: false,
      disableConfirmButton: false,
      showTreegrid: false,
      searchData: {
        gridId: '',
        actionName: '',
        filter: {}
      },
      treeGridCfg: {},
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      result: {},
      movements: {}
    };
  },


  computed: {
    labelConfirmacaoAnulacao: function labelConfirmacaoAnulacao() {
      return this.searchData.gridId === 'LancamentoDuplicado' ? this.$t('analiseDuplicidade.mensagem.confirmarAnularLancamento') : this.$t('analiseDuplicidade.mensagem.confirmarReverterAnulacao');
    },
    labelAlertaAnulacao: function labelAlertaAnulacao() {
      return this.searchData.gridId === 'LancamentoDuplicado' ? this.$t('analiseDuplicidade.labels.alertaGridAnularLancamneto') : this.$t('analiseDuplicidade.labels.alertaGridReverterAnulacao');
    }
  },

  methods: {
    handleTabChange: function handleTabChange(tabIndex) {
      this.showTreegrid = false;
      this.currentTab = tabIndex === 0 ? 'tabDuplicated' : 'tabAnnulled';
    },
    searchMovements: function searchMovements(searchData) {
      var _this = this;

      this.showTreegrid = true;
      this.searchData = searchData;

      (0, _gridLoadTransition.startTreeGridLoading)('#' + this.searchData.gridId);

      this.disableSearchButton = true;
      this.$store.dispatch(this.searchData.actionName, { filter: this.searchData.filter }).then(function (response) {
        window.DisposeGrids();
        var data = response.data;

        data.Body = response.data.Body.map(function (elements) {
          return elements.map(function (element) {
            var checkCanEdit = element.SitConciliacao === '' || element.SitConciliacao === 'A' ? '1' : '0';
            return (0, _assign2.default)({}, element, { CheckCanEdit: checkCanEdit });
          });
        });

        _this.result = data;
        _this.treeGridCfg = data.Cfg.Layout;
        (0, _gridLoadTransition.stopTreeGridLoading)('#' + _this.searchData.gridId);
        _this.disableSearchButton = false;
      }).catch(function (error) {
        _this.error = true;
        _this.msgError = error.body;
        _this.$root.$refs.notification.error('GENERAL');
        (0, _gridLoadTransition.stopTreeGridLoading)('#' + _this.searchData.gridId);
        _this.disableSearchButton = false;
      });
    },
    annulMovementsOpenModalConfirm: function annulMovementsOpenModalConfirm(movements) {
      this.movements = movements;
      $('#confirmUpdateAnnulledField').modal('show');
    },
    annulMovementsCloseModalConfirm: function annulMovementsCloseModalConfirm() {
      $('#confirmUpdateAnnulledField').modal('hide');
    },
    annulMovements: function annulMovements() {
      var _this2 = this;

      this.disableConfirmButton = true;
      this.$store.dispatch('annulledMovements', this.movements).then(function (response) {
        _this2.movements = {};
        _this2.$root.$refs.notification.success(_this2.searchData.gridId === 'LancamentoDuplicado' ? 'analiseDuplicidade.mensagem.anulacaoSucesso' : 'analiseDuplicidade.mensagem.reverterAnulacaoSucesso');
        _this2.annulMovementsCloseModalConfirm();
        _this2.disableConfirmButton = false;
        _this2.searchMovements(_this2.searchData);
      }).catch(function (error) {
        _this2.$root.$refs.notification.error(error);
        _this2.disableConfirmButton = false;
        _this2.annulMovementsCloseModalConfirm();
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 913 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/financialMovement/FinancialMovement.vue ***!
  \*********************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _GridDetailsModal = __webpack_require__(/*! ../../../modals/gridDetailsModal/GridDetailsModal */ 196);

var _GridDetailsModal2 = _interopRequireDefault(_GridDetailsModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _InputEstablishment = __webpack_require__(/*! ../../../input/inputEstablishment/InputEstablishment */ 130);

var _InputEstablishment2 = _interopRequireDefault(_InputEstablishment);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

var _transformationData = __webpack_require__(/*! ../../../../utils/transformationData.js */ 163);

var _closeModal = __webpack_require__(/*! ../../../../events/closeModal */ 104);

var _closeModal2 = _interopRequireDefault(_closeModal);

var _funcionalidadeId = __webpack_require__(/*! ../../../../enum/funcionalidadeId */ 134);

var _funcionalidadeId2 = _interopRequireDefault(_funcionalidadeId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'FinancialMovement',

  components: {
    GridDetailsModal: _GridDetailsModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    InputEstablishment: _InputEstablishment2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      establishimentsUrls: {
        establishments: 'financialMovements/establishment/list',
        attributes: '/financialMovements/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      gridId: '#MovimentoFinanceiro',
      treeGridCfg: {},
      audit: {},
      dateRange: {},
      situationList: [{
        id: 'A',
        nome: this.$t('statusConciliacao.aberto'),
        checked: true
      }, {
        id: 'C',
        nome: this.$t('statusConciliacao.conciliado'),
        checked: true
      }, {
        id: 'M',
        nome: this.$t('statusConciliacao.conciliadoManualmente'),
        checked: true
      }, {
        id: 'D',
        nome: this.$t('statusConciliacao.divergente'),
        checked: true
      }, {
        id: 'N',
        nome: this.$t('statusConciliacao.naoAplicavel'),
        checked: true
      }],
      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],
      firstDate: new Date(),
      finalDate: new Date(),
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'MovimentosFinanceiros',
      dataTableColumns: [],
      disableSearchButton: false,
      detailsObj: {
        establishtmentValue: {},
        mainValuesList: [],
        monetaryValuesList: [],
        statusValuesList: [],
        integrationValuesList: [],
        idProcessamento: -1
      },
      finMovGridModalId: '',
      isOpenDetailsModal: false,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTimePlan: true,
      firstTimeEstableshment: true,
      modalDetailsTabs: [],
      attList: [],
      filterable: [],
      columnsFilterable: [],
      showCustomColumns: false,
      isExportFile: false
    };
  },


  computed: {
    idsFilterEstablishments: function idsFilterEstablishments() {
      return this.$store.getters.idsFilterEstablishments;
    }
  },

  watch: {
    situationList: {
      handler: function handler(val) {
        var _this = this;

        this.selectedStatuses = [];
        val.forEach(function (st) {
          if (st.checked) {
            _this.selectedStatuses.push(st.id);
          }
        });
      },

      deep: true
    }
  },

  methods: {
    resetFilter: function resetFilter() {
      this.selectedEstablishments = [];
      this.situationList.forEach(function (situation) {
        situation.checked = true;
      });
    },
    getLoadingMessages: function getLoadingMessages() {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid'];
    },
    validate: function validate() {
      var self = this;
      var promise = null;
      return new _promise2.default(function (resolve) {
        self.$validator.validateAll().then(function (result) {
          if (result && self.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download();
            } else {
              self.showTreegrid = true;
              (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
              promise = self.search();
            }
            promise.finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    mountFilters: function mountFilters() {
      this.disableSearchButton = true;
      var filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsPlanosConciliacao: [],
        idsEstabelecimentos: this.selectedEstablishments.map(function (selected) {
          return selected.id;
        }),
        situacoesConciliacao: this.selectedStatuses,
        lang: _index2.default.getCookieByName('language')
      };

      return filter;
    },
    download: function download() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        _this2.$store.dispatch('searchFinancialMovementsToFile', { filter: _this2.mountFilters() }).then(function () {
          _this2.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this2.error = true;
          _this2.msgError = error.body;
          _this2.$root.$refs.notification.error('GENERAL');
          _this2.disableSearchButton = false;
          reject();
        });
      });
    },
    search: function search() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        _this3.$store.dispatch('searchFinancialMovements', { filter: _this3.mountFilters() }).then(function (response) {
          if (window.Grids[0]) {
            window.DisposeGrids();
          }
          _this3.result = response.data;
          _this3.treeGridCfg = response.data.Cfg.Layout;
          window.Grids.abrirModalDetalhes = function (row) {
            _this3.finMovGridModalId = 'finMovGridModalIdMov-' + row.IdMovimentacao;
            (0, _analytics.trackAnalyticsEvent)(_this3, 'row-click', 'movimento-financeiro-grid-details', row.IdMovimentacao);
            _this3.detailsObj = (0, _transformationData.generateFinMovFromRow)(row);
            _this3.detailsObj.statusLancamento = row.SituacaoConciliacao;
            _this3.generateModalTabs();
            setTimeout(function () {
              _this3.showDetailsModal();
              window.Grids[0].Disable();
            }, 100);
          };
          (0, _gridLoadTransition.stopTreeGridLoading)(_this3.gridId);
          _this3.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this3.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this3.gridId);
          _this3.disableSearchButton = false;
          reject();
        });
      });
    },
    showDetailsModal: function showDetailsModal() {
      this.isOpenDetailsModal = true;
    },
    closeDetailsModal: function closeDetailsModal() {
      this.isOpenDetailsModal = false;
    },
    generateModalTabs: function generateModalTabs() {
      var tabs = [];

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabDetails',
        idTabContent: 'tab-details-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadDetailsGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),
        icon: 'icon="tab-icon-font fa fa-info-circle',
        type: 'TabDetails',
        props: {
          establishtmentValue: this.detailsObj.establishtmentValue,
          mainValuesList: this.detailsObj.mainValuesList,
          statusValuesList: this.detailsObj.statusValuesList,
          monetaryValuesList: this.detailsObj.monetaryValuesList,
          commentary: this.detailsObj.commentary
        }
      });

      if (this.detailsObj.idProcessamento) {
        tabs.push({
          idFunctionalitie: null,
          idTabRoot: 'gridDetailsModal-tabIntegrations',
          idTabContent: 'tab-integrations-id',
          idLanc: this.detailsObj.mainValuesList[0].value,
          tabRef: 'tadIntegrationGridModal',
          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),
          icon: 'tab-icon-font fa fa-share-alt',
          type: 'TabIntegrations',
          props: {
            loadIntegration: this.findIntegration,
            establishtmentValue: this.detailsObj.establishtmentValue,
            idProcessamento: this.detailsObj.idProcessamento,
            integrationValuesList: this.detailsObj.integrationValuesList
          }
        });
      }

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabHistoric',
        idTabContent: 'tab-historic-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabHisotiricGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),
        icon: 'tab-icon-font fa fa-hourglass',
        type: 'TabHistoric',
        props: {
          loadHistoric: this.findFinancialMovementHistory,
          idLancamento: this.detailsObj.mainValuesList[0].value
        }
      });

      tabs.push({
        idFunctionalitie: null,
        idTabRoot: 'gridDetailsModal-tabAllotment',
        idTabContent: 'tab-allotment-id',
        idLanc: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tadAllotmentGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabLote'),
        icon: 'tab-icon-font fa fa-cubes',
        type: 'TabAllotment',
        props: {
          getAllotment: this.findFinancialMovementAllotment,
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tipoMovimento: 'MovFin'
        }
      });

      tabs.push({
        idFunctionalitie: _funcionalidadeId2.default.TAREFAS,
        idTabRoot: 'gridDetailsModal-tabTasks',
        idTabContent: 'tab-tasks-id',
        idMovimento: this.detailsObj.mainValuesList[0].value,
        tabRef: 'tabTasksGridModal',
        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),
        icon: 'tab-icon-font fa fa-tasks',
        type: 'TabTasks',
        props: {
          idMovimento: this.detailsObj.mainValuesList[0].value,
          tipoMovimento: 'MovFin',
          statusMovimento: this.detailsObj.statusLancamento
        }
      });
      this.modalDetailsTabs = tabs;
    },
    findFinancialMovementHistory: function findFinancialMovementHistory(id) {
      var data = {
        idFinancialMovement: id,
        url: '/financialMovements/history'
      };
      return this.$store.dispatch('getHistoricFinancialMovement', data);
    },
    findFinancialMovementAllotment: function findFinancialMovementAllotment(id) {
      var data = {
        idFinancialMovement: id,
        url: '/financialMovements/getAllotmentByMovFinId'
      };
      return this.$store.dispatch('getAllotmentByMovementId', data);
    },
    findIntegration: function findIntegration(id) {
      var data = {
        idProcessamento: id,
        url: '/processedFiles/getProcessedFilesById'
      };
      return this.$store.dispatch('getProcessedFiles', data);
    }
  },

  mounted: function mounted() {
    var self = this;
    _closeModal2.default.$on('modalDetaisClose', function (flag) {
      if (flag) {
        self.showTreegrid = true;
        (0, _gridLoadTransition.startTreeGridLoading)(self.gridId, self.getLoadingMessages());
        self.search();

        _closeModal2.default.$emit('taskChange', false);
      }
    });
  }
};

/***/ }),
/* 914 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/manualConciliation/ManualConciliation.vue ***!
  \***********************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 72);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _underscore = __webpack_require__(/*! underscore */ 83);

var _underscore2 = _interopRequireDefault(_underscore);

var _vueSelect = __webpack_require__(/*! vue-select */ 29);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

var _vueNavTabs = __webpack_require__(/*! vue-nav-tabs */ 91);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _Modal = __webpack_require__(/*! ../../../modals/modal/Modal */ 100);

var _Modal2 = _interopRequireDefault(_Modal);

var _TabAllotment = __webpack_require__(/*! ../../../modals/gridDetailsModal/tabAllotment/TabAllotment */ 690);

var _TabAllotment2 = _interopRequireDefault(_TabAllotment);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _InputEstablishment = __webpack_require__(/*! ../../../input/inputEstablishment/InputEstablishment */ 130);

var _InputEstablishment2 = _interopRequireDefault(_InputEstablishment);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _PendingConciliations = __webpack_require__(/*! ../../../reports/manualConciliation/PendingConciliations */ 1309);

var _PendingConciliations2 = _interopRequireDefault(_PendingConciliations);

var _Allotment = __webpack_require__(/*! ../../../reports/manualConciliation/Allotment.vue */ 1306);

var _Allotment2 = _interopRequireDefault(_Allotment);

var _SelectedEntries = __webpack_require__(/*! ../../../reports/manualConciliation/SelectedEntries */ 1310);

var _SelectedEntries2 = _interopRequireDefault(_SelectedEntries);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _analytics = __webpack_require__(/*! ../../../../utils/analytics.js */ 25);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ManualConciliation',

  components: {
    vSelect: _vueSelect2.default,
    VueTabs: _vueNavTabs.VueTabs,
    VTab: _vueNavTabs.VTab,
    MultiSelectModal: _MultiSelectModal2.default,
    Modal: _Modal2.default,
    TabAllotment: _TabAllotment2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    InputEstablishment: _InputEstablishment2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    PendingConciliations: _PendingConciliations2.default,
    Allotment: _Allotment2.default,
    SelectedEntries: _SelectedEntries2.default
  },

  data: function data() {
    var _this = this;

    return {
      establishimentsUrls: {
        establishments: 'manualConciliation/establishment/list',
        attributes: '/manualConciliation/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      messageExit: '',
      confirmExit: function confirmExit(e) {
        var message = this.messageExit;
        e = e || window.event;

        if (e) {
          e.returnValue = message;
        }

        return message;
      },
      CONCILIATION_PLAN_MODAL: 'conciliationPlanModal',
      BANK_ACCOUNT_MODAL: 'bankAccountsModal',
      CATEGORIES_MODAL: 'categoriesModal',
      dateRange: {},
      itensSelected: [],
      list: [],
      selectedList: [],
      selectedStatuses: [],
      idPlanSelected: null,
      plansSelected: [],
      plansTags: [],
      firstDate: new Date(),
      finalDate: new Date(),
      dataTableColumns: [],
      dataTableOptions: {
        perPage: 5,
        perPageValues: [],
        texts: { count: this.$t('dataTable.labels.contagem'), noResults: this.$t('dataTable.labels.semResultados'), filter: '', filterPlaceholder: this.$t('dataTable.labels.filtrar') },
        filterable: true,
        pagination: {
          chunk: 5,
          dropdown: false
        },
        sortIcon: {
          is: ''
        },
        sortable: [],
        headings: {},
        templates: {},
        customSorting: {},
        orderBy: {},
        columnsClasses: {}
      },

      resultMov: {},
      resultExt: {},
      treeGridCfgMov: {},
      treeGridCfgExt: {},
      showTreegridMov: false,
      showTreegridExt: false,

      resultLot: {},
      treeGridCfgLot: {},
      showTreegridLot: false,

      internalEntries: [],
      bankEntries: [],
      allotmentEntry: {},
      filterChanged: false,
      tabName: null,
      disableSearchButton: false,
      noPlanSelected: false,
      firstTimeBank: true,
      firstTimeEstab: true,
      planSelected: null,
      plans: [],
      disableSelectPlan: false,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      idsAccountsSelected: [],
      firstTimeAccount: true,
      firstTimeEstableshment: true,
      allotmentDetailsModalObj: null,
      filterable: [],
      attList: [],
      columnsFilterable: [],
      showCustomColumns: false,
      customSetOrder: null,
      filter: {
        entityId: null
      },
      isLoadingStatic: false,
      shown: {
        bankAccounts: false,
        categories: false
      },
      inputTagsProps: {
        bankAccounts: {
          id: 'id',
          name: 'nome'
        },
        categories: {
          id: 'id',
          name: 'nome'
        }
      },
      defaultTags: {
        bankAccounts: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }],
        categories: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todas')
        }]
      },
      data: {
        bankAccounts: {
          titles: {
            main: this.$t('extratoBancario.labels.contasBancarias'),
            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')
          },
          allBankAccounts: [],
          showToggleInactiveAccounts: false,
          selectedItems: [],
          considerInactiveAccounts: false,
          columns: ['nome', 'banco', 'numAgencia', 'conta'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },
            perPage: 5,
            headings: {
              nome: this.$t('contaBancaria.labels.nome'),
              banco: this.$t('contaBancaria.labels.banco'),
              numAgencia: this.$t('contaBancaria.labels.agencia'),
              conta: this.$t('contaBancaria.labels.numeroConta')
            },
            filterable: ['nome', 'banco', 'numAgencia', 'conta'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome', 'banco', 'numAgencia', 'conta'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              banco: function banco(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.banco.codigo <= b.banco.codigo ? 1 : -1;
                  }
                  return a.banco.codigo >= b.banco.codigo ? 1 : -1;
                };
              },
              agencia: function agencia(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.numAgencia <= b.numAgencia;
                  }
                  return a.numAgencia >= b.numAgencia;
                };
              },
              conta: function conta(asc) {
                return function (a, b) {
                  if (asc) {
                    return +a.conta >= +b.conta ? 1 : -1;
                  }
                  return +a.conta <= +b.conta ? 1 : -1;
                };
              }
            },
            templates: {
              nome: function nome(h, row) {
                var txt = row.nome;
                if (!row.ativo) {
                  txt += ' (' + _this.$t('contaBancaria.labels.inativa') + ')';
                }
                return txt;
              },
              banco: function banco(h, row) {
                if (row.banco) {
                  return row.banco.codigo + '-' + row.banco.nome;
                }
                return '-';
              },
              agencia: function agencia(h, row) {
                var txt = '-';
                if (row.agencia) {
                  txt = row.numAgencia;
                  if (row.digAgencia) {
                    txt += '-' + row.digAgencia;
                  }
                }
                return txt;
              },
              conta: function conta(h, row) {
                var txt = row.conta;
                if (row.digConta) {
                  txt += '-' + row.digConta;
                }
                return txt;
              }
            }
          }
        },
        categories: {
          titles: {
            main: this.$t('categoria.titulos.titulo'),
            sub: this.$t('categoria.labels.selecionarCategoria')
          },
          selectedItems: [],
          columns: ['numero', 'nome', 'idContabil', 'tipo'],
          values: [],
          options: {
            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },
            perPage: 5,
            headings: {
              numero: this.$t('categoria.modal.labels.numero'),
              nome: this.$t('categoria.modal.labels.descricao'),
              idContabil: this.$t('categoria.modal.labels.idContabil'),
              tipo: this.$t('categoria.modal.labels.tipo')
            },
            filterable: ['numero', 'nome', 'idContabil', 'tipo'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['numero', 'nome', 'idContabil', 'tipo'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'numero'
            },
            customSorting: {
              numero: function numero(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.ordem >= b.ordem ? 1 : -1;
                  }
                  return a.ordem <= b.ordem ? 1 : -1;
                };
              },
              nome: function nome(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase());
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase());
                };
              },
              idContabil: function idContabil(asc) {
                return function (a, b) {
                  var idA = a.idContabil;
                  var idB = b.idContabil;
                  if (idA === null || idB === null) {
                    if (asc) {
                      return idA === null ? -1 : 1;
                    }
                    return idA === null ? 1 : -1;
                  }
                  if (asc) {
                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase());
                  }
                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase());
                };
              },
              tipo: function tipo(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase());
                  }
                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase());
                };
              }
            },
            templates: {
              idContabil: function idContabil(h, row) {
                return row.idContabil || '-';
              },
              tipo: function tipo(h, row) {
                return _this.$t('categoria.modal.labels.' + row.tipo);
              }
            }
          }
        }
      }
    };
  },


  computed: {
    showTabs: function showTabs() {
      return this.showTreegridExt && this.showTreegridMov;
    },
    hasToUpdateMAnualConcilSearch: function hasToUpdateMAnualConcilSearch() {
      return this.$store.getters.hasToUpdateMAnualConcilSearch;
    },
    idRowMovFinRemoved: function idRowMovFinRemoved() {
      return this.$store.getters.idRowMovFinRemoved;
    },
    idRowBankStatRemoved: function idRowBankStatRemoved() {
      return this.$store.getters.idRowBankStatRemoved;
    },
    idRowAllotmentMovementRemoved: function idRowAllotmentMovementRemoved() {
      return this.$store.getters.idRowAllotmentMovementRemoved;
    },
    idRowAllotmentMovementAdded: function idRowAllotmentMovementAdded() {
      return this.$store.getters.idRowAllotmentMovementAdded;
    },
    finMovAdded: function finMovAdded() {
      return this.$store.getters.finMovAdded;
    },
    bankStatAdded: function bankStatAdded() {
      return this.$store.getters.bankStatAdded;
    },
    arrayConciliationPlan: function arrayConciliationPlan() {
      return this.$store.getters.arrayConciliationPlan;
    },
    needSearchManualConciliationTransactions: function needSearchManualConciliationTransactions() {
      return this.$store.getters.needSearchManualConciliationTransactions;
    },
    modalAllotmentDetails: function modalAllotmentDetails() {
      return {
        title: this.$t('conciliacaoManual.titulos.modalAllotmentDetailsTitle'),
        subtitle: this.$t('conciliacaoManual.titulos.modalAllotmentDetailsSubtitle')
      };
    },
    isLoadingDataActionsManualConciliation: function isLoadingDataActionsManualConciliation() {
      return this.$store.getters.isLoadingData;
    },
    isLoadingDataActionsManualConciliationStatic: function isLoadingDataActionsManualConciliationStatic() {
      return this.$store.getters.isLoadingStatic;
    },
    arrayJustify: function arrayJustify() {
      return this.$store.getters.arrayJustify;
    },
    idsFilterEstablishments: function idsFilterEstablishments() {
      return this.$store.getters.idsFilterEstablishments;
    },
    loadingMessage: function loadingMessage() {
      return this.getKeyTranslated(this.$store.getters.loadingMessage);
    }
  },

  watch: {
    idRowMovFinRemoved: function idRowMovFinRemoved() {
      if (window && window.Grids && window.Grids.ConcManualMovFin) {
        var row = window.Grids.ConcManualMovFin.GetRowById(this.$store.getters.idRowMovFinRemoved.id);
        if (!row) {
          row = _underscore2.default.findWhere(window.Grids.ConcManualMovFin.Rows, { IdMovimentacao: this.$store.getters.idRowMovFinRemoved.idMovimentacao });
        }
        if (row && row.IdMovimentacao === this.$store.getters.idRowMovFinRemoved.idMovimentacao) {
          window.Grids.ConcManualMovFin.ShowRow(row);
        }
      }
    },
    idRowBankStatRemoved: function idRowBankStatRemoved() {
      if (window && window.Grids && window.Grids.ConcManualExtBan) {
        var row = window.Grids.ConcManualExtBan.GetRowById(this.$store.getters.idRowBankStatRemoved.id);
        if (!row) {
          row = _underscore2.default.findWhere(window.Grids.ConcManualExtBan.Rows, { IdLancamento: this.$store.getters.idRowBankStatRemoved.idLancamento });
        }
        if (row && row.IdLancamento === this.$store.getters.idRowBankStatRemoved.idLancamento) {
          window.Grids.ConcManualExtBan.ShowRow(row);
        }
      }
    },
    idRowAllotmentMovementAdded: function idRowAllotmentMovementAdded() {
      if (window && window.Grids && window.Grids.ConcManualLotes) {
        var row = window.Grids.ConcManualLotes.GetRowById(this.$store.getters.idRowAllotmentMovementRemoved);
        if (row) {
          window.Grids.ConcManualLotes.ShowRow(row);
        }
      }
    },
    finMovAdded: function finMovAdded() {
      this.hasPendingLanc(this.$store.getters.finMovAdded, 'idMovimentacao', 'hasPendingFinMov');
      this.verifyAndShowAllotment();
    },
    bankStatAdded: function bankStatAdded() {
      this.hasPendingLanc(this.$store.getters.bankStatAdded, 'idLancamento', 'hasPendingBankStat');
      this.verifyAndShowAllotment();
    },
    hasToUpdateMAnualConcilSearch: function hasToUpdateMAnualConcilSearch() {
      if (this.hasToUpdateMAnualConcilSearch) {
        this.configGridsAndSearch();
      }
    },
    needSearchManualConciliationTransactions: function needSearchManualConciliationTransactions() {
      if (this.$store.getters.bankStatAdded.needSearchManualConciliationTransactions) {
        this.search();
      }
    },
    arrayJustify: function arrayJustify() {
      if (this.arrayJustify.length > 0) {
        window.addEventListener('beforeunload', this.confirmExit);
      } else {
        window.removeEventListener('beforeunload', this.confirmExit);
      }
    }
  },

  methods: {
    resetFilter: function resetFilter() {
      this.selectedEstablishments = [];
      this.data.bankAccounts.selectedItems = [];
      this.data.bankAccounts.considerInactiveAccounts = false;
      this.data.categories.selectedItems = [];
    },
    hasPendingLanc: function hasPendingLanc(arrayLancAdded, objectToFind, action) {
      var _this2 = this;

      var lancSelecMov = false;
      arrayLancAdded.forEach(function (mov) {
        if (objectToFind in mov) {
          lancSelecMov = true;
        }
      });

      this.$store.dispatch(action, lancSelecMov).catch(function (error) {
        _this2.$root.$refs.notification.error(error);
      });
    },
    verifyAndShowAllotment: function verifyAndShowAllotment() {
      var lancSelecFinMovAllotment = true;
      var lancSelecBankStatAllotment = true;

      this.$store.getters.finMovAdded.forEach(function (mov) {
        if ('idLote' in mov) {
          lancSelecFinMovAllotment = false;
        }
      });

      this.$store.getters.bankStatAdded.forEach(function (mov) {
        if ('idLote' in mov) {
          lancSelecBankStatAllotment = false;
        }
      });

      if (lancSelecFinMovAllotment && lancSelecBankStatAllotment) {
        var idAllotment = this.$store.getters.idAllotment;
        this.$store.dispatch('setIdAllotment', null).then(function () {
          if (window && window.Grids && window.Grids.ConcManualLotes) {
            if (idAllotment) {
              var row = _underscore2.default.findWhere(window.Grids.ConcManualLotes.Rows, { IdLote: idAllotment });
              if (row) {
                window.Grids.ConcManualLotes.ShowRow(row);
                window.Grids.ConcManualLotes.Reload();
              }
            }
          }
        });
      }
    },
    badgerify: function badgerify(containerId, counter) {
      var badgeValue = document.createTextNode(counter);
      var badge = document.getElementById(containerId + '-badge');
      if (badge) {
        badge.textContent = counter;
      } else {
        var tabSpan = document.querySelector('[aria-controls="' + containerId + '"]').childNodes[0];
        badge = document.createElement('b-badge');
        badge.className = 'badge badge-custom';
        badge.id = containerId + '-badge';
        badge.appendChild(badgeValue);
        tabSpan.appendChild(badge);
      }
    },
    removeBadge: function removeBadge(containerId) {
      var badge = document.getElementById(containerId + '-badge');
      if (badge) {
        badge.remove();
      }
    },
    validate: function validate() {
      var _this3 = this;

      return new _promise2.default(function (resolve) {
        _this3.$validator.validateAll().then(function (result) {
          if (result && _this3.$refs.dateRange.validate()) {
            _this3.configGridsAndSearch().finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    configGridsAndSearch: function configGridsAndSearch() {
      this.noPlanSelected = false;
      this.showTreegridMov = true;
      this.showTreegridExt = true;
      this.showTreegridLot = true;
      return this.search();
    },
    search: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$store.dispatch('setNeedSearchManualConciliationTransactions', false);
                this.disableSearchButton = true;
                this.tabName = this.$t('conciliacaoManual.titulos.abaLancamentos');
                _context.next = 5;
                return this.verifyAndCleanAndSetConciliationPlan();

              case 5:
                _context.next = 7;
                return this.hideRowsGrids();

              case 7:
                _context.next = 9;
                return this.buildFilter();

              case 9:
                _context.next = 11;
                return this.startLoading();

              case 11:
                _context.prev = 11;
                _context.next = 14;
                return this.searchTransactionsFormManualConciliation();

              case 14:
                return _context.abrupt('return', _promise2.default.resolve());

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](11);
                return _context.abrupt('return', _promise2.default.reject());

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 17]]);
      }));

      function search() {
        return _ref.apply(this, arguments);
      }

      return search;
    }(),
    verifyAndCleanAndSetConciliationPlan: function verifyAndCleanAndSetConciliationPlan() {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        var self = _this4;

        if (self.$store.getters.arrayConciliationPlan && self.$store.getters.arrayConciliationPlan.length > 0) {
          var teste = _underscore2.default.indexOf(self.$store.getters.arrayConciliationPlan, _this4.idPlanSelected);
          if (teste === -1) {
            _this4.$store.dispatch('cleanEditState');
          }
        }

        _this4.$store.dispatch('setArrayConciliationPlan', _this4.idPlanSelected).then(function () {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    hideRowsGrids: function hideRowsGrids() {
      var _this5 = this;

      return new _promise2.default(function (resolve, reject) {
        var self = _this5;
        window.Grids.OnRenderFinish = function (G) {
          G.ReloadBody();

          if (self.$store.getters.finMovAdded && self.$store.getters.finMovAdded.length > 0) {
            self.$store.getters.finMovAdded.forEach(function (mov) {
              var row = _underscore2.default.findWhere(G.Rows, { IdMovimentacao: mov.idMovimentacao });
              if (row) {
                G.HideRow(row);
              }
            });
          }

          if (self.$store.getters.bankStatAdded && self.$store.getters.bankStatAdded.length > 0) {
            self.$store.getters.bankStatAdded.forEach(function (mov) {
              var row = _underscore2.default.findWhere(G.Rows, { IdLancamento: mov.idLancamento });
              if (row) {
                G.HideRow(row);
              }
            });
          }
          G.RenderBody();
        };
        resolve();
      });
    },
    buildFilter: function buildFilter() {
      var _this6 = this;

      return new _promise2.default(function (resolve, reject) {
        var inicio = _this6.dateRange.fromDate;
        var fim = _this6.dateRange.toDate;
        _this6.filter = {
          inicio: inicio,
          fim: fim,
          idsPlanosConciliacao: _this6.plansSelected.map(function (plan) {
            return plan['id'];
          }),
          idsEstabelecimentos: _this6.selectedEstablishments.map(function (selected) {
            return selected.id;
          }),
          idsContas: _this6.data.bankAccounts.selectedItems.map(function (selected) {
            return selected.id;
          }).filter(function (account) {
            return account !== '-1';
          }),
          considerarContasInativas: _this6.data.bankAccounts.considerInactiveAccounts,
          idsCategorias: _this6.data.categories.selectedItems.map(function (selected) {
            return selected.id;
          }).filter(function (categories) {
            return categories !== '-1';
          }),
          lang: _index2.default.getCookieByName('language')
        };
        _this6.filterChanged = true;
        resolve();
      });
    },
    startLoading: function startLoading() {
      var _this7 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _gridLoadTransition.startTreeGridLoading)('#concManualMovFin');
        (0, _gridLoadTransition.startTreeGridLoading)('#concManualExtBanc');
        _this7.$store.dispatch('hasToUpdateMAnualConcilSearch', false).then(function () {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    searchTransactionsFormManualConciliation: function searchTransactionsFormManualConciliation() {
      var _this8 = this;

      return new _promise2.default(function (resolve, reject) {
        _this8.$store.dispatch('searchTransactionsForManualConciliation', _this8.filter).then(function (response) {
          window.DisposeGrids();
          _this8.treeGridCfgMov = response.data.treegrid.Cfg.Layout;
          _this8.resultMov = response.data.treegrid;
          _this8.treeGridCfgExt = response.data.treegridBankStat.Cfg.Layout;
          _this8.resultExt = response.data.treegridBankStat;
          _this8.buttonGridAddRowFinMov();
          _this8.buttonGridAddRowBankStat();
          _this8.stopLoadingAndConfigureBadge(response);
          resolve();
        }).catch(function (error) {
          _this8.$root.$refs.notification.error(_this8.$t(error.message));
          (0, _gridLoadTransition.stopTreeGridLoading)('#concManualMovFin');
          (0, _gridLoadTransition.stopTreeGridLoading)('#concManualExtBanc');

          _this8.disableSearchButton = false;
          reject();
        });
      });
    },
    buttonGridAddRowFinMov: function buttonGridAddRowFinMov() {
      var _this9 = this;

      window.Grids.addRowFinMov = function (row) {
        (0, _analytics.trackAnalyticsEvent)(_this9, 'conciliacao-manual', 'click-add-mov-financeira', row.SituacaoConciliacao);

        row.isTreeGrid = true;
        _this9.$store.dispatch('setFinMov', row).then(function () {
          window.Grids.ConcManualMovFin.HideRow(row);
        }).catch(function (error) {
          _this9.$root.$refs.notification.error(_this9.$t(error.message));
        });
      };
    },
    buttonGridAddRowBankStat: function buttonGridAddRowBankStat() {
      var _this10 = this;

      window.Grids.addRowBankStat = function (row) {
        (0, _analytics.trackAnalyticsEvent)(_this10, 'conciliacao-manual', 'click-add-extrato-bancario', row.SituacaoConciliacao);

        row.isTreeGrid = true;
        _this10.$store.dispatch('setBankStat', row).then(function () {
          window.Grids.ConcManualExtBan.HideRow(row);
        }).catch(function (error) {
          _this10.$root.$refs.notification.error(_this10.$t(error.message));
        });
      };
    },
    stopLoadingAndConfigureBadge: function stopLoadingAndConfigureBadge(response) {
      (0, _gridLoadTransition.stopTreeGridLoading)('#concManualMovFin');
      (0, _gridLoadTransition.stopTreeGridLoading)('#concManualExtBanc');

      response.data.pendingEntries && response.data.pendingEntries > 0 ? this.badgerify('#tab-conciliacoes-pendentes', response.data.pendingEntries) : this.removeBadge('#tab-conciliacoes-pendentes');

      response.data.pendingAllotments && response.data.pendingAllotments > 0 ? this.badgerify('#tab-lotes', response.data.pendingAllotments) : this.removeBadge('#tab-lotes');

      this.disableSearchButton = false;
    },
    loadAllotments: function loadAllotments(tabIndex) {
      if (tabIndex === 1 && this.filterChanged) {
        this.disableSearchButton = true;
        this.filterChanged = false;
        this.showTreegridLot = true;
        (0, _gridLoadTransition.startTreeGridLoading)('#concManualLotes');
        var self = this;
        window.Grids.OnRenderFinish = function (G) {
          if (self.$store.getters.idAllotment) {
            var row = _underscore2.default.findWhere(G.Rows, { IdLote: self.$store.getters.idAllotment });
            if (row) {
              G.HideRow(row);
            }
          }
        };

        this.getAllotments();
      }
    },
    getAllotments: function getAllotments() {
      var _this11 = this;

      this.$store.dispatch('searchAllotments', this.filter).then(function (allotmentsResponse) {
        if (window.Grids.ConcManualLotes) {
          window.Grids.ConcManualLotes.DisposeGrids();
        }
        _this11.resultLot = allotmentsResponse.treegridAllotment.Cfg.Layout;
        _this11.treeGridCfgLot = allotmentsResponse.treegridAllotment;

        _this11.loadAllotmentsMovements();
      }).catch(function (error) {
        _this11.$root.$refs.notification.error(error);
        (0, _gridLoadTransition.stopTreeGridLoading)('#concManualLotes');
        document.querySelector('#pendingProtlet').scrollIntoView({ behavior: 'smooth' });
        _this11.disableSearchButton = false;
      });
    },
    loadAllotmentsMovements: function loadAllotmentsMovements() {
      var _this12 = this;

      var self = this;

      window.Grids.getAllotmentMovements = function (row) {
        (0, _analytics.trackAnalyticsEvent)(_this12, 'conciliacao-manual', 'click-add-lote', row.SituacaoConciliacao);

        _this12.$store.dispatch('setIdAllotment', row.IdLote).then(function (response) {
          var idAllotmentRemoved = self.$store.getters.idRowAllotmentMovementAdded;
          var data = {
            'idAllotmentRemoved': idAllotmentRemoved,
            'row': row
          };
          _this12.$store.dispatch('getAllotmentMov', data).then(function (response) {
            window.Grids.ConcManualLotes.HideRow(row);
          }).catch(function (error) {
            _this12.$root.$refs.notification.error(_this12.$t(error.message));
          });
        }).catch(function (error) {
          _this12.$root.$refs.notification.error(_this12.$t(error.message));
        });
      };

      window.Grids.openAllotmentDetailsModal = function (row) {
        self.allotmentDetailsModalObj = {
          idLote: row.IdLote,
          dtInicio: row.DtLancInicial,
          dtFim: row.DtLancFinal,
          totalMovBan: row.VlExtratoBancario,
          totalMovFin: row.VlMovimentoFinanceiro,
          situacao: row.SituacaoConciliacao
        };
        setTimeout(function () {
          self.$refs.tabAllotmentManualConcilModal.createAllotmentDetailsFromManualConcilaition();
          $('#detalhesLoteConcManual').modal({ backdrop: 'static', keyboard: false });
        }, 100);
      };
      (0, _gridLoadTransition.stopTreeGridLoading)('#concManualLotes');
      document.querySelector('#tab-navigation').scrollIntoView({ behavior: 'smooth' });
      this.disableSearchButton = false;
    },
    saveAndClose: function saveAndClose() {
      switch (this.selectModal) {
        case this.CONCILIATION_PLAN_MODAL:
          this.plansTags = this.plansSelected.map(function (plan) {
            return plan['nome'];
          });
          if (this.noPlanSelected) {
            this.noPlanSelected = false;
            document.getElementsByClassName('vue-input-tag-wrapper')[0].style.border = '1px solid #CCC';
          }
          break;
      }
      this.closeModal();
    },
    selectItem: function selectItem(item) {
      item.checked = !item.checked;
      switch (this.selectModal) {
        case this.CONCILIATION_PLAN_MODALCONCILIATION_PLAN_MODAL:
          this.selectPlan(item);
          break;
      }
    },
    selectPlan: function selectPlan(plan) {
      if (plan === null) {
        return;
      }
      this.idPlanSelected = plan.id;
      this.plansSelected = [];
      this.planSelected = plan;
      this.plansSelected.push(plan);
    },
    loadPlans: function loadPlans() {
      var _this13 = this;

      this.selectModal = this.CONCILIATION_PLAN_MODAL;

      var url = '/manualConciliation/plans/list';
      this.$store.dispatch('getPlans', url).then(function (response) {
        _this13.plans = response.data.data;
        if (response.data.data.length === 1) {
          _this13.planSelected = response.data.data[0];
          _this13.selectPlan(_this13.planSelected);
          _this13.disableSelectPlan = true;
        }
      });
    },
    openSelectBankAccountsModal: function openSelectBankAccountsModal() {
      var _this14 = this;

      if (this.data.bankAccounts.values.length > 0) {
        this.shown.bankAccounts = true;
        return;
      }
      this.$store.dispatch('getBankAccounts', '/manualConciliation/bankAccounts/list').then(function (response) {
        _this14.data.bankAccounts.allBankAccounts = response.data.data;
        _this14.data.bankAccounts.showToggleInactiveAccounts = _this14.data.bankAccounts.allBankAccounts.find(function (bankAccount) {
          return !bankAccount.ativo;
        });
        _this14.data.bankAccounts.values = _this14.data.bankAccounts.allBankAccounts.filter(function (bankAccount) {
          return bankAccount.ativo;
        });
        _this14.shown.bankAccounts = true;
      });
    },
    openSelectCategoriesModal: function openSelectCategoriesModal() {
      var _this15 = this;

      if (this.data.categories.values.length > 0) {
        this.shown.categories = true;
        return;
      }
      this.$store.dispatch('getCategories', {
        url: '/manualConciliation/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      }).then(function (response) {
        _this15.data.categories.values = response.data;
        _this15.shown.categories = true;
      });
    },
    closeModal: function closeModal() {
      this.shown.bankAccounts = false;
      this.shown.categories = false;
    },
    closeAllotmentDetailsModal: function closeAllotmentDetailsModal() {
      $('#detalhesLoteConcManual').modal('hide');
    },
    getKeyTranslated: function getKeyTranslated(key) {
      return this.$t(key);
    }
  },

  created: function created() {
    this.messageExit = this.$t('conciliacaoManual.labels.alertJustificativa');
    this.$store.dispatch('cleanEditState');
    this.loadPlans();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('beforeunload', this.confirmExit);
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 915 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/reports/occurrenceReport/OccurrenceReport.vue ***!
  \*******************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(/*! babel-runtime/core-js/promise */ 14);

var _promise2 = _interopRequireDefault(_promise);

var _MultiSelectModal = __webpack_require__(/*! ../../../modals/multiSelectModal/MultiSelectModal */ 84);

var _MultiSelectModal2 = _interopRequireDefault(_MultiSelectModal);

var _PageTitle = __webpack_require__(/*! ../../../layout/pageTitle/PageTitle */ 26);

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _FilterPortlet = __webpack_require__(/*! ../../../layout/filterPortlet/FilterPortlet */ 33);

var _FilterPortlet2 = _interopRequireDefault(_FilterPortlet);

var _FormSearch = __webpack_require__(/*! ../../../form/formSearch/FormSearch */ 76);

var _FormSearch2 = _interopRequireDefault(_FormSearch);

var _DateRange = __webpack_require__(/*! ../../../input/dateRange/DateRange */ 51);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _BetterInputTag = __webpack_require__(/*! ../../../input/betterInputTag/BetterInputTag */ 70);

var _BetterInputTag2 = _interopRequireDefault(_BetterInputTag);

var _InputEstablishment = __webpack_require__(/*! ../../../input/inputEstablishment/InputEstablishment */ 130);

var _InputEstablishment2 = _interopRequireDefault(_InputEstablishment);

var _ButtonPrimary = __webpack_require__(/*! ../../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _TreeGrid = __webpack_require__(/*! ../../../treeGrid/TreeGrid */ 52);

var _TreeGrid2 = _interopRequireDefault(_TreeGrid);

var _exportRoutes = __webpack_require__(/*! ../../../../../build/jsonToExcel/exportRoutes.js */ 45);

var _index = __webpack_require__(/*! ../../../../../build/language/index */ 19);

var _index2 = _interopRequireDefault(_index);

var _gridLoadTransition = __webpack_require__(/*! ../../../../utils/grid-load-transition.js */ 34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OccurrenceReport',

  components: {
    MultiSelectModal: _MultiSelectModal2.default,
    PageTitle: _PageTitle2.default,
    FilterPortlet: _FilterPortlet2.default,
    FormSearch: _FormSearch2.default,
    DateRange: _DateRange2.default,
    BetterInputTag: _BetterInputTag2.default,
    InputEstablishment: _InputEstablishment2.default,
    ButtonPrimary: _ButtonPrimary2.default,
    TreeGrid: _TreeGrid2.default
  },

  data: function data() {
    return {
      establishimentsUrls: {
        establishments: 'occurrenceReport/establishment/list',
        attributes: '/occurrenceReport/loadEstablishmentAtt'
      },
      selectedEstablishments: [],
      isAdvancedSearch: true,
      gridId: '#occurrenceReportGrid',
      result: {},
      treeGridCfg: {},
      OCCURRENCES_MODAL: 'occurrencesModal',
      dateRange: {},
      itensSelected: [],
      list: [],
      selectedList: [],
      selectedStatuses: [],
      firstDate: new Date(),
      finalDate: new Date(),
      dataTableColumns: [],
      disableSearchButton: false,
      showTreegrid: false,
      exportUrl: _exportRoutes.EXPORT_TREEGRID,
      firstTime: true,
      titleModal: null,
      subTitleModal: null,
      columnsClasses: {},
      orderBy: {},
      headings: {},
      templates: {},
      customSorting: {},
      sortable: [],
      firstTimeOccurrence: true,
      selectDataTableCustomSetOrder: null,
      customTagMap: null,
      filterable: [],
      attList: [],
      columnsFilterable: [],
      showCustomColumns: false,
      inputTagsProps: {
        occurrenceReason: {
          id: 'id',
          name: 'descricao'
        }
      },
      shown: {
        occurrenceReason: false
      },
      defaultTags: {
        occurrenceReason: [{
          id: '-1',
          descricao: this.$t('inputTag.labels.todos')
        }]
      },
      data: {
        occurrenceReason: {
          titles: {
            main: this.$t('relatorioOcorrencia.labels.motivoOcorrencia'),
            sub: this.$t('relatorioOcorrencia.labels.selecaoMotivoOcorrencia')
          },
          selectedItems: [],
          columns: ['codigo', 'descricao'],
          values: [],
          options: {
            columnsClasses: { codigo: 'col-md-4', descricao: 'col-md-8' },
            perPage: 5,
            headings: {
              codigo: this.$t('motivoOcorrencia.labels.sigla'),
              descricao: this.$t('motivoOcorrencia.labels.descricao')
            },
            filterable: ['codigo', 'descricao'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['codigo', 'descricao'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'codigo'
            },
            customSorting: {
              codigo: function codigo(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.codigo.toLowerCase().localeCompare(b.codigo.toLowerCase());
                  }
                  return b.codigo.toLowerCase().localeCompare(a.codigo.toLowerCase());
                };
              },
              descricao: function descricao(asc) {
                return function (a, b) {
                  if (asc) {
                    return a.descricao.toLowerCase().localeCompare(b.descricao.toLowerCase());
                  }
                  return b.descricao.toLowerCase().localeCompare(a.descricao.toLowerCase());
                };
              }
            }
          }
        }
      }
    };
  },


  computed: {
    idsFilterEstablishments: function idsFilterEstablishments() {
      return this.$store.getters.idsFilterEstablishments;
    }
  },

  methods: {
    resetFilter: function resetFilter() {
      this.selectedEstablishments = [];
      this.data.occurrenceReason.selectedItems = [];
    },
    validate: function validate() {
      var _this = this;

      var self = this;
      return new _promise2.default(function (resolve) {
        _this.$validator.validateAll().then(function (result) {
          if (result && _this.$refs.dateRange.validate()) {
            _this.showTreegrid = true;
            (0, _gridLoadTransition.startTreeGridLoading)(self.gridId);
            _this.search().finally(function () {
              resolve();
            });
          } else {
            resolve();
          }
        });
      });
    },
    search: function search() {
      var _this2 = this;

      this.disableSearchButton = true;
      var inicio = this.dateRange.fromDate;
      var fim = this.dateRange.toDate;
      var filter = {
        inicio: inicio,
        fim: fim,
        idsMotivosOcorrencias: this.data.occurrenceReason.selectedItems.map(function (selected) {
          return selected.id;
        }).filter(function (occurrence) {
          return occurrence !== '-1';
        }),
        idsEstabelecimentos: this.selectedEstablishments.map(function (selected) {
          return selected.id;
        }),
        idsPlanosConciliacao: [],
        lang: _index2.default.getCookieByName('language')
      };
      return new _promise2.default(function (resolve, reject) {
        _this2.$store.dispatch('searchOccurrenceReport', filter).then(function (response) {
          window.DisposeGrids();
          _this2.treeGridCfg = response.data.Cfg.Layout;
          _this2.result = response.data;
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          resolve();
        }).catch(function (error) {
          _this2.$root.$refs.notification.error(error);
          (0, _gridLoadTransition.stopTreeGridLoading)(_this2.gridId);
          _this2.disableSearchButton = false;
          reject();
        });
      });
    },
    openSelectOccurrencesModal: function openSelectOccurrencesModal() {
      var _this3 = this;

      if (this.data.occurrenceReason.values.length > 0) {
        this.shown.occurrenceReason = true;
        return;
      }
      this.$store.dispatch('getOccurrenceReasons', '/occurrenceReport/occurrenceReason/list').then(function (response) {
        _this3.data.occurrenceReason.values = response.data.data;
        _this3.shown.occurrenceReason = true;
      });
    },
    closeModal: function closeModal() {
      this.shown.occurrenceReason = false;
    }
  },

  created: function created() {
    this.$store.dispatch('cleanEditState');
  }
};

/***/ }),
/* 916 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/views/unauthorized/Unauthorized.vue ***!
  \***************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonPrimary = __webpack_require__(/*! ../../buttons/buttonPrimary/ButtonPrimary */ 11);

var _ButtonPrimary2 = _interopRequireDefault(_ButtonPrimary);

var _routesMap = __webpack_require__(/*! ../../../router/routesMap.js */ 24);

var _routesMap2 = _interopRequireDefault(_routesMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Unauthorized',

  components: {
    ButtonPrimary: _ButtonPrimary2.default
  },

  data: function data() {
    return {
      imageNotFound: __webpack_require__(/*! ../../../assets/notFound/forbidden.png */ 1243)
    };
  },


  computed: {
    client: function client() {
      return this.$store.getters.client;
    }
  },

  methods: {
    goHome: function goHome() {
      location.href = this.client ? _routesMap2.default.HOME : _routesMap2.default.LOGIN;
    }
  }
};

/***/ }),
/* 917 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/babel-runtime/core-js/is-iterable.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/is-iterable */ 962), __esModule: true };

/***/ }),
/* 918 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/babel-runtime/core-js/number/is-nan.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/number/is-nan */ 964), __esModule: true };

/***/ }),
/* 919 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/babel-runtime/core-js/object/define-property.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/object/define-property */ 967), __esModule: true };

/***/ }),
/* 920 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/babel-runtime/core-js/symbol.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/symbol */ 972), __esModule: true };

/***/ }),
/* 921 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/babel-runtime/core-js/symbol/iterator.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(/*! core-js/library/fn/symbol/iterator */ 973), __esModule: true };

/***/ }),
/* 922 */
/* exports provided: BVConfigPlugin */
/* exports used: BVConfigPlugin */
/*!******************************************!*\
  !*** ./~/bootstrap-vue/esm/bv-config.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVConfigPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(/*! ./utils/plugins */ 10);
//
// Utility Plugin for setting the configuration
//

var BVConfigPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["b" /* pluginFactory */])();

/***/ }),
/* 923 */
/* exports provided: props, BVCollapse */
/* exports used: BVCollapse */
/*!************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/collapse/helpers/bv-collapse.js ***!
  \************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVCollapse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
// Generic collapse transion helper component
//
// Note:
//   Applies the classes `collapse`, `show` and `collapsing`
//   during the enter/leave transition phases only
//   Although it appears that Vue may be leaving the classes
//   in-place after the transition completes




 // --- Helper methods ---
// Transition event handler helpers

var onEnter = function onEnter(el) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'height', 0); // In a `requestAF()` for `appear` to work

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a" /* requestAF */])(function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["H" /* reflow */])(el);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'height', "".concat(el.scrollHeight, "px"));
  });
};

var onAfterEnter = function onAfterEnter(el) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["t" /* removeStyle */])(el, 'height');
};

var onLeave = function onLeave(el) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'height', 'auto');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'display', 'block');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'height', "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["x" /* getBCR */])(el).height, "px"));
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["H" /* reflow */])(el);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* setStyle */])(el, 'height', 0);
};

var onAfterLeave = function onAfterLeave(el) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["t" /* removeStyle */])(el, 'height');
}; // --- Constants ---
// Default transition props
// `appear` will use the enter classes


var TRANSITION_PROPS = {
  css: true,
  enterClass: '',
  enterActiveClass: 'collapsing',
  enterToClass: 'collapse show',
  leaveClass: 'collapse show',
  leaveActiveClass: 'collapsing',
  leaveToClass: 'collapse'
}; // Default transition handlers
// `appear` will use the enter handlers

var TRANSITION_HANDLERS = {
  enter: onEnter,
  afterEnter: onAfterEnter,
  leave: onLeave,
  afterLeave: onAfterLeave
}; // --- Main component ---

var props = {
  // // If `true` (and `visible` is `true` on mount), animate initially visible
  appear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}; // --- Main component ---
// @vue/component

var BVCollapse = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["_48" /* NAME_COLLAPSE_HELPER */],
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;
    return h('transition', // We merge in the `appear` prop last
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])(data, {
      props: TRANSITION_PROPS,
      on: TRANSITION_HANDLERS
    }, {
      props: props
    }), // Note: `<transition>` supports a single root element only
    children);
  }
});

/***/ }),
/* 924 */
/* exports provided: props, optionsMixin */
/* exports used: optionsMixin */
/*!*****************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/form-select/helpers/mixin-options.js ***!
  \*****************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return optionsMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_get__ = __webpack_require__(/*! ../../../utils/get */ 141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_form_options__ = __webpack_require__(/*! ../../../mixins/form-options */ 183);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // --- Props ---

var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["b" /* makePropsConfigurable */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_object__["l" /* sortKeys */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__mixins_form_options__["a" /* props */]), {}, {
  labelField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'label'),
  optionsField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'options')
})), 'formOptions'); // --- Mixin ---
// @vue/component

var optionsMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_form_options__["b" /* formOptionsMixin */]],
  props: props,
  methods: {
    normalizeOption: function normalizeOption(option) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // When the option is an object, normalize it
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["h" /* isPlainObject */])(option)) {
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.valueField);
        var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.textField);
        var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.optionsField, null); // When it has options, create an `<optgroup>` object

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["e" /* isNull */])(options)) {
          return {
            label: String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.labelField) || text),
            options: this.normalizeOptions(options)
          };
        } // Otherwise create an `<option>` object


        return {
          value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["i" /* isUndefined */])(value) ? key || text : value,
          text: String(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["i" /* isUndefined */])(text) ? key : text),
          html: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.htmlField),
          disabled: Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get__["b" /* get */])(option, this.disabledField))
        };
      } // Otherwise create an `<option>` object from the given value


      return {
        value: key || option,
        text: String(option),
        disabled: false
      };
    }
  }
});

/***/ }),
/* 925 */
/* exports provided: componentsPlugin */
/* exports used: componentsPlugin */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/index.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentsPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(/*! ../utils/plugins */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert__ = __webpack_require__(/*! ./alert */ 326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aspect__ = __webpack_require__(/*! ./aspect */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__avatar__ = __webpack_require__(/*! ./avatar */ 329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__badge__ = __webpack_require__(/*! ./badge */ 330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__breadcrumb__ = __webpack_require__(/*! ./breadcrumb */ 333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__button__ = __webpack_require__(/*! ./button */ 338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__button_group__ = __webpack_require__(/*! ./button-group */ 335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__button_toolbar__ = __webpack_require__(/*! ./button-toolbar */ 337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__calendar__ = __webpack_require__(/*! ./calendar */ 339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__card__ = __webpack_require__(/*! ./card */ 344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__carousel__ = __webpack_require__(/*! ./carousel */ 347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__collapse__ = __webpack_require__(/*! ./collapse */ 215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dropdown__ = __webpack_require__(/*! ./dropdown */ 166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__embed__ = __webpack_require__(/*! ./embed */ 357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form__ = __webpack_require__(/*! ./form */ 383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__form_checkbox__ = __webpack_require__(/*! ./form-checkbox */ 360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__form_datepicker__ = __webpack_require__(/*! ./form-datepicker */ 362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__form_file__ = __webpack_require__(/*! ./form-file */ 364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_group__ = __webpack_require__(/*! ./form-group */ 366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__form_input__ = __webpack_require__(/*! ./form-input */ 368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__form_radio__ = __webpack_require__(/*! ./form-radio */ 370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__form_rating__ = __webpack_require__(/*! ./form-rating */ 372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__form_select__ = __webpack_require__(/*! ./form-select */ 374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__form_spinbutton__ = __webpack_require__(/*! ./form-spinbutton */ 375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__form_tags__ = __webpack_require__(/*! ./form-tags */ 377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__form_textarea__ = __webpack_require__(/*! ./form-textarea */ 379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__form_timepicker__ = __webpack_require__(/*! ./form-timepicker */ 381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__image__ = __webpack_require__(/*! ./image */ 384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__input_group__ = __webpack_require__(/*! ./input-group */ 385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__jumbotron__ = __webpack_require__(/*! ./jumbotron */ 387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__layout__ = __webpack_require__(/*! ./layout */ 389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__link__ = __webpack_require__(/*! ./link */ 391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__list_group__ = __webpack_require__(/*! ./list-group */ 392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__media__ = __webpack_require__(/*! ./media */ 395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modal__ = __webpack_require__(/*! ./modal */ 398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__nav__ = __webpack_require__(/*! ./nav */ 231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__navbar__ = __webpack_require__(/*! ./navbar */ 403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__overlay__ = __webpack_require__(/*! ./overlay */ 408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pagination__ = __webpack_require__(/*! ./pagination */ 412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pagination_nav__ = __webpack_require__(/*! ./pagination-nav */ 410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__popover__ = __webpack_require__(/*! ./popover */ 415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__progress__ = __webpack_require__(/*! ./progress */ 417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__sidebar__ = __webpack_require__(/*! ./sidebar */ 419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__skeleton__ = __webpack_require__(/*! ./skeleton */ 421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__spinner__ = __webpack_require__(/*! ./spinner */ 426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__table__ = __webpack_require__(/*! ./table */ 236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__tabs__ = __webpack_require__(/*! ./tabs */ 439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__time__ = __webpack_require__(/*! ./time */ 442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__toast__ = __webpack_require__(/*! ./toast */ 444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__tooltip__ = __webpack_require__(/*! ./tooltip */ 446);
 // Component group plugins













































 // Table plugin includes TableLitePlugin and TableSimplePlugin





 // Main plugin to install all component group plugins

var componentsPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["b" /* pluginFactory */])({
  plugins: {
    AlertPlugin: __WEBPACK_IMPORTED_MODULE_1__alert__["a" /* AlertPlugin */],
    AspectPlugin: __WEBPACK_IMPORTED_MODULE_2__aspect__["a" /* AspectPlugin */],
    AvatarPlugin: __WEBPACK_IMPORTED_MODULE_3__avatar__["a" /* AvatarPlugin */],
    BadgePlugin: __WEBPACK_IMPORTED_MODULE_4__badge__["a" /* BadgePlugin */],
    BreadcrumbPlugin: __WEBPACK_IMPORTED_MODULE_5__breadcrumb__["a" /* BreadcrumbPlugin */],
    ButtonPlugin: __WEBPACK_IMPORTED_MODULE_6__button__["a" /* ButtonPlugin */],
    ButtonGroupPlugin: __WEBPACK_IMPORTED_MODULE_7__button_group__["a" /* ButtonGroupPlugin */],
    ButtonToolbarPlugin: __WEBPACK_IMPORTED_MODULE_8__button_toolbar__["a" /* ButtonToolbarPlugin */],
    CalendarPlugin: __WEBPACK_IMPORTED_MODULE_9__calendar__["a" /* CalendarPlugin */],
    CardPlugin: __WEBPACK_IMPORTED_MODULE_10__card__["a" /* CardPlugin */],
    CarouselPlugin: __WEBPACK_IMPORTED_MODULE_11__carousel__["a" /* CarouselPlugin */],
    CollapsePlugin: __WEBPACK_IMPORTED_MODULE_12__collapse__["a" /* CollapsePlugin */],
    DropdownPlugin: __WEBPACK_IMPORTED_MODULE_13__dropdown__["a" /* DropdownPlugin */],
    EmbedPlugin: __WEBPACK_IMPORTED_MODULE_14__embed__["a" /* EmbedPlugin */],
    FormPlugin: __WEBPACK_IMPORTED_MODULE_15__form__["a" /* FormPlugin */],
    FormCheckboxPlugin: __WEBPACK_IMPORTED_MODULE_16__form_checkbox__["a" /* FormCheckboxPlugin */],
    FormDatepickerPlugin: __WEBPACK_IMPORTED_MODULE_17__form_datepicker__["a" /* FormDatepickerPlugin */],
    FormFilePlugin: __WEBPACK_IMPORTED_MODULE_18__form_file__["a" /* FormFilePlugin */],
    FormGroupPlugin: __WEBPACK_IMPORTED_MODULE_19__form_group__["a" /* FormGroupPlugin */],
    FormInputPlugin: __WEBPACK_IMPORTED_MODULE_20__form_input__["a" /* FormInputPlugin */],
    FormRadioPlugin: __WEBPACK_IMPORTED_MODULE_21__form_radio__["a" /* FormRadioPlugin */],
    FormRatingPlugin: __WEBPACK_IMPORTED_MODULE_22__form_rating__["a" /* FormRatingPlugin */],
    FormSelectPlugin: __WEBPACK_IMPORTED_MODULE_23__form_select__["a" /* FormSelectPlugin */],
    FormSpinbuttonPlugin: __WEBPACK_IMPORTED_MODULE_24__form_spinbutton__["a" /* FormSpinbuttonPlugin */],
    FormTagsPlugin: __WEBPACK_IMPORTED_MODULE_25__form_tags__["a" /* FormTagsPlugin */],
    FormTextareaPlugin: __WEBPACK_IMPORTED_MODULE_26__form_textarea__["a" /* FormTextareaPlugin */],
    FormTimepickerPlugin: __WEBPACK_IMPORTED_MODULE_27__form_timepicker__["a" /* FormTimepickerPlugin */],
    ImagePlugin: __WEBPACK_IMPORTED_MODULE_28__image__["a" /* ImagePlugin */],
    InputGroupPlugin: __WEBPACK_IMPORTED_MODULE_29__input_group__["a" /* InputGroupPlugin */],
    JumbotronPlugin: __WEBPACK_IMPORTED_MODULE_30__jumbotron__["a" /* JumbotronPlugin */],
    LayoutPlugin: __WEBPACK_IMPORTED_MODULE_31__layout__["a" /* LayoutPlugin */],
    LinkPlugin: __WEBPACK_IMPORTED_MODULE_32__link__["a" /* LinkPlugin */],
    ListGroupPlugin: __WEBPACK_IMPORTED_MODULE_33__list_group__["a" /* ListGroupPlugin */],
    MediaPlugin: __WEBPACK_IMPORTED_MODULE_34__media__["a" /* MediaPlugin */],
    ModalPlugin: __WEBPACK_IMPORTED_MODULE_35__modal__["a" /* ModalPlugin */],
    NavPlugin: __WEBPACK_IMPORTED_MODULE_36__nav__["a" /* NavPlugin */],
    NavbarPlugin: __WEBPACK_IMPORTED_MODULE_37__navbar__["a" /* NavbarPlugin */],
    OverlayPlugin: __WEBPACK_IMPORTED_MODULE_38__overlay__["a" /* OverlayPlugin */],
    PaginationPlugin: __WEBPACK_IMPORTED_MODULE_39__pagination__["a" /* PaginationPlugin */],
    PaginationNavPlugin: __WEBPACK_IMPORTED_MODULE_40__pagination_nav__["a" /* PaginationNavPlugin */],
    PopoverPlugin: __WEBPACK_IMPORTED_MODULE_41__popover__["a" /* PopoverPlugin */],
    ProgressPlugin: __WEBPACK_IMPORTED_MODULE_42__progress__["a" /* ProgressPlugin */],
    SidebarPlugin: __WEBPACK_IMPORTED_MODULE_43__sidebar__["a" /* SidebarPlugin */],
    SkeletonPlugin: __WEBPACK_IMPORTED_MODULE_44__skeleton__["a" /* SkeletonPlugin */],
    SpinnerPlugin: __WEBPACK_IMPORTED_MODULE_45__spinner__["a" /* SpinnerPlugin */],
    TablePlugin: __WEBPACK_IMPORTED_MODULE_46__table__["a" /* TablePlugin */],
    TabsPlugin: __WEBPACK_IMPORTED_MODULE_47__tabs__["a" /* TabsPlugin */],
    TimePlugin: __WEBPACK_IMPORTED_MODULE_48__time__["a" /* TimePlugin */],
    ToastPlugin: __WEBPACK_IMPORTED_MODULE_49__toast__["a" /* ToastPlugin */],
    TooltipPlugin: __WEBPACK_IMPORTED_MODULE_50__tooltip__["a" /* TooltipPlugin */]
  }
});

/***/ }),
/* 926 */
/* exports provided: BvModalEvent */
/* exports used: BvModalEvent */
/*!******************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/modal/helpers/bv-modal-event.class.js ***!
  \******************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BvModalEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_bv_event_class__ = __webpack_require__(/*! ../../../utils/bv-event.class */ 109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




var BvModalEvent = /*#__PURE__*/function (_BvEvent) {
  _inherits(BvModalEvent, _BvEvent);

  var _super = _createSuper(BvModalEvent);

  function BvModalEvent(type) {
    var _this;

    var eventInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, BvModalEvent);

    _this = _super.call(this, type, eventInit); // Freeze our new props as readonly, but leave them enumerable

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["f" /* defineProperties */])(_assertThisInitialized(_this), {
      trigger: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["g" /* readonlyDescriptor */])()
    });
    return _this;
  }

  _createClass(BvModalEvent, null, [{
    key: "Defaults",
    get: function get() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(BvModalEvent), "Defaults", this)), {}, {
        trigger: null
      });
    }
  }]);

  return BvModalEvent;
}(__WEBPACK_IMPORTED_MODULE_0__utils_bv_event_class__["a" /* BvEvent */]); // Named exports




/***/ }),
/* 927 */
/* exports provided: modalManager */
/* exports used: modalManager */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/modal/helpers/modal-manager.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modalManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/**
 * Private ModalManager helper
 * Handles controlling modal stacking zIndexes and body adjustments/classes
 */




 // --- Constants ---
// Default modal backdrop z-index

var DEFAULT_ZINDEX = 1040; // Selectors for padding/margin adjustments

var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var SELECTOR_STICKY_CONTENT = '.sticky-top';
var SELECTOR_NAVBAR_TOGGLER = '.navbar-toggler'; // --- Main component ---
// @vue/component

var ModalManager = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  data: function data() {
    return {
      modals: [],
      baseZIndex: null,
      scrollbarWidth: null,
      isBodyOverflowing: false
    };
  },
  computed: {
    modalCount: function modalCount() {
      return this.modals.length;
    },
    modalsAreOpen: function modalsAreOpen() {
      return this.modalCount > 0;
    }
  },
  watch: {
    modalCount: function modalCount(newCount, oldCount) {
      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */]) {
        this.getScrollbarWidth();

        if (newCount > 0 && oldCount === 0) {
          // Transitioning to modal(s) open
          this.checkScrollbar();
          this.setScrollbar();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* addClass */])(document.body, 'modal-open');
        } else if (newCount === 0 && oldCount > 0) {
          // Transitioning to modal(s) closed
          this.resetScrollbar();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["q" /* removeClass */])(document.body, 'modal-open');
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["j" /* setAttr */])(document.body, 'data-modal-open-count', String(newCount));
      }
    },
    modals: function modals(newValue) {
      var _this = this;

      this.checkScrollbar();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* requestAF */])(function () {
        _this.updateModals(newValue || []);
      });
    }
  },
  methods: {
    // Public methods
    registerModal: function registerModal(modal) {
      // Register the modal if not already registered
      if (modal && this.modals.indexOf(modal) === -1) {
        this.modals.push(modal);
      }
    },
    unregisterModal: function unregisterModal(modal) {
      var index = this.modals.indexOf(modal);

      if (index > -1) {
        // Remove modal from modals array
        this.modals.splice(index, 1); // Reset the modal's data

        if (!modal._isBeingDestroyed && !modal._isDestroyed) {
          this.resetModal(modal);
        }
      }
    },
    getBaseZIndex: function getBaseZIndex() {
      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["e" /* isNull */])(this.baseZIndex)) {
        // Create a temporary `div.modal-backdrop` to get computed z-index
        var div = document.createElement('div');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* addClass */])(div, 'modal-backdrop');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* addClass */])(div, 'd-none');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(div, 'display', 'none');
        document.body.appendChild(div);
        this.baseZIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_number__["b" /* toInteger */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* getCS */])(div).zIndex, DEFAULT_ZINDEX);
        document.body.removeChild(div);
      }

      return this.baseZIndex || DEFAULT_ZINDEX;
    },
    getScrollbarWidth: function getScrollbarWidth() {
      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_inspect__["e" /* isNull */])(this.scrollbarWidth)) {
        // Create a temporary `div.measure-scrollbar` to get computed z-index
        var div = document.createElement('div');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* addClass */])(div, 'modal-scrollbar-measure');
        document.body.appendChild(div);
        this.scrollbarWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["x" /* getBCR */])(div).width - div.clientWidth;
        document.body.removeChild(div);
      }

      return this.scrollbarWidth || 0;
    },
    // Private methods
    updateModals: function updateModals(modals) {
      var _this2 = this;

      var baseZIndex = this.getBaseZIndex();
      var scrollbarWidth = this.getScrollbarWidth();
      modals.forEach(function (modal, index) {
        // We update data values on each modal
        modal.zIndex = baseZIndex + index;
        modal.scrollbarWidth = scrollbarWidth;
        modal.isTop = index === _this2.modals.length - 1;
        modal.isBodyOverflowing = _this2.isBodyOverflowing;
      });
    },
    resetModal: function resetModal(modal) {
      if (modal) {
        modal.zIndex = this.getBaseZIndex();
        modal.isTop = true;
        modal.isBodyOverflowing = false;
      }
    },
    checkScrollbar: function checkScrollbar() {
      // Determine if the body element is overflowing
      var _getBCR = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["x" /* getBCR */])(document.body),
          left = _getBCR.left,
          right = _getBCR.right;

      this.isBodyOverflowing = left + right < window.innerWidth;
    },
    setScrollbar: function setScrollbar() {
      var body = document.body; // Storage place to cache changes to margins and padding
      // Note: This assumes the following element types are not added to the
      // document after the modal has opened.

      body._paddingChangedForModal = body._paddingChangedForModal || [];
      body._marginChangedForModal = body._marginChangedForModal || [];

      if (this.isBodyOverflowing) {
        var scrollbarWidth = this.scrollbarWidth; // Adjust fixed content padding

        /* istanbul ignore next: difficult to test in JSDOM */

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["w" /* selectAll */])(SELECTOR_FIXED_CONTENT).forEach(function (el) {
          var actualPadding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["G" /* getStyle */])(el, 'paddingRight') || '';
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["j" /* setAttr */])(el, 'data-padding-right', actualPadding);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(el, 'paddingRight', "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_number__["a" /* toFloat */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* getCS */])(el).paddingRight, 0) + scrollbarWidth, "px"));

          body._paddingChangedForModal.push(el);
        }); // Adjust sticky content margin

        /* istanbul ignore next: difficult to test in JSDOM */

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["w" /* selectAll */])(SELECTOR_STICKY_CONTENT).forEach(function (el)
        /* istanbul ignore next */
        {
          var actualMargin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["G" /* getStyle */])(el, 'marginRight') || '';
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["j" /* setAttr */])(el, 'data-margin-right', actualMargin);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(el, 'marginRight', "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_number__["a" /* toFloat */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* getCS */])(el).marginRight, 0) - scrollbarWidth, "px"));

          body._marginChangedForModal.push(el);
        }); // Adjust <b-navbar-toggler> margin

        /* istanbul ignore next: difficult to test in JSDOM */

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["w" /* selectAll */])(SELECTOR_NAVBAR_TOGGLER).forEach(function (el)
        /* istanbul ignore next */
        {
          var actualMargin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["G" /* getStyle */])(el, 'marginRight') || '';
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["j" /* setAttr */])(el, 'data-margin-right', actualMargin);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(el, 'marginRight', "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_number__["a" /* toFloat */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* getCS */])(el).marginRight, 0) + scrollbarWidth, "px"));

          body._marginChangedForModal.push(el);
        }); // Adjust body padding

        var actualPadding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["G" /* getStyle */])(body, 'paddingRight') || '';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["j" /* setAttr */])(body, 'data-padding-right', actualPadding);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(body, 'paddingRight', "".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_number__["a" /* toFloat */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["o" /* getCS */])(body).paddingRight, 0) + scrollbarWidth, "px"));
      }
    },
    resetScrollbar: function resetScrollbar() {
      var body = document.body;

      if (body._paddingChangedForModal) {
        // Restore fixed content padding
        body._paddingChangedForModal.forEach(function (el) {
          /* istanbul ignore next: difficult to test in JSDOM */
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l" /* hasAttr */])(el, 'data-padding-right')) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(el, 'paddingRight', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["i" /* getAttr */])(el, 'data-padding-right') || '');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["k" /* removeAttr */])(el, 'data-padding-right');
          }
        });
      }

      if (body._marginChangedForModal) {
        // Restore sticky content and navbar-toggler margin
        body._marginChangedForModal.forEach(function (el) {
          /* istanbul ignore next: difficult to test in JSDOM */
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l" /* hasAttr */])(el, 'data-margin-right')) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(el, 'marginRight', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["i" /* getAttr */])(el, 'data-margin-right') || '');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["k" /* removeAttr */])(el, 'data-margin-right');
          }
        });
      }

      body._paddingChangedForModal = null;
      body._marginChangedForModal = null; // Restore body padding

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l" /* hasAttr */])(body, 'data-padding-right')) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* setStyle */])(body, 'paddingRight', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["i" /* getAttr */])(body, 'data-padding-right') || '');
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["k" /* removeAttr */])(body, 'data-padding-right');
      }
    }
  }
}); // Create and export our modal manager instance

var modalManager = new ModalManager();

/***/ }),
/* 928 */
/* exports provided: BVPopoverTemplate */
/* exports used: BVPopoverTemplate */
/*!*******************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/popover/helpers/bv-popover-template.js ***!
  \*******************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVPopoverTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip_helpers_bv_tooltip_template__ = __webpack_require__(/*! ../../tooltip/helpers/bv-tooltip-template */ 445);



 // @vue/component

var BVPopoverTemplate = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["j" /* NAME_POPOVER_TEMPLATE */],
  extends: __WEBPACK_IMPORTED_MODULE_3__tooltip_helpers_bv_tooltip_template__["a" /* BVTooltipTemplate */],
  computed: {
    templateType: function templateType() {
      return 'popover';
    }
  },
  methods: {
    renderTemplate: function renderTemplate(h) {
      var title = this.title,
          content = this.content; // Title and content could be a scoped slot function

      var $title = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(title) ? title({}) : title;
      var $content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(content) ? content({}) : content; // Directive usage only

      var titleDomProps = this.html && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(title) ? {
        innerHTML: title
      } : {};
      var contentDomProps = this.html && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(content) ? {
        innerHTML: content
      } : {};
      return h('div', {
        staticClass: 'popover b-popover',
        class: this.templateClasses,
        attrs: this.templateAttributes,
        on: this.templateListeners
      }, [h('div', {
        staticClass: 'arrow',
        ref: 'arrow'
      }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["g" /* isUndefinedOrNull */])($title) || $title === '' ?
      /* istanbul ignore next */
      h() : h('h3', {
        staticClass: 'popover-header',
        domProps: titleDomProps
      }, [$title]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["g" /* isUndefinedOrNull */])($content) || $content === '' ?
      /* istanbul ignore next */
      h() : h('div', {
        staticClass: 'popover-body',
        domProps: contentDomProps
      }, [$content])]);
    }
  }
});

/***/ }),
/* 929 */
/* exports provided: defaultSortCompare */
/* exports used: defaultSortCompare */
/*!******************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/default-sort-compare.js ***!
  \******************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultSortCompare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_get__ = __webpack_require__(/*! ../../../utils/get */ 141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_stringify_object_values__ = __webpack_require__(/*! ../../../utils/stringify-object-values */ 467);





var normalizeValue = function normalizeValue(value) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["g" /* isUndefinedOrNull */])(value)) {
    return '';
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["n" /* isNumeric */])(value)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_number__["a" /* toFloat */])(value, value);
  }

  return value;
}; // Default sort compare routine
//
// TODO:
//   Add option to sort by multiple columns (tri-state per column,
//   plus order of columns in sort) where `sortBy` could be an array
//   of objects `[ {key: 'foo', sortDir: 'asc'}, {key:'bar', sortDir: 'desc'} ...]`
//   or an array of arrays `[ ['foo','asc'], ['bar','desc'] ]`
//   Multisort will most likely be handled in `mixin-sort.js` by
//   calling this method for each sortBy


var defaultSortCompare = function defaultSortCompare(a, b) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$sortBy = _ref.sortBy,
      sortBy = _ref$sortBy === void 0 ? null : _ref$sortBy,
      _ref$formatter = _ref.formatter,
      formatter = _ref$formatter === void 0 ? null : _ref$formatter,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? undefined : _ref$locale,
      _ref$localeOptions = _ref.localeOptions,
      localeOptions = _ref$localeOptions === void 0 ? {} : _ref$localeOptions,
      _ref$nullLast = _ref.nullLast,
      nullLast = _ref$nullLast === void 0 ? false : _ref$nullLast;

  // Get the value by `sortBy`
  var aa = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_get__["b" /* get */])(a, sortBy, null);
  var bb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_get__["b" /* get */])(b, sortBy, null); // Apply user-provided formatter

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["a" /* isFunction */])(formatter)) {
    aa = formatter(aa, sortBy, a);
    bb = formatter(bb, sortBy, b);
  } // Internally normalize value
  // `null` / `undefined` => ''
  // `'0'` => `0`


  aa = normalizeValue(aa);
  bb = normalizeValue(bb);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["b" /* isDate */])(aa) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["b" /* isDate */])(bb) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["j" /* isNumber */])(aa) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["j" /* isNumber */])(bb)) {
    // Special case for comparing dates and numbers
    // Internally dates are compared via their epoch number values
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  } else if (nullLast && aa === '' && bb !== '') {
    // Special case when sorting `null` / `undefined` / '' last
    return 1;
  } else if (nullLast && aa !== '' && bb === '') {
    // Special case when sorting `null` / `undefined` / '' last
    return -1;
  } // Do localized string comparison


  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_stringify_object_values__["a" /* stringifyObjectValues */])(aa).localeCompare(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_stringify_object_values__["a" /* stringifyObjectValues */])(bb), locale, localeOptions);
};

/***/ }),
/* 930 */
/* exports provided: props, bottomRowMixin */
/* exports used: props, bottomRowMixin */
/*!**************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-bottom-row.js ***!
  \**************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bottomRowMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tr__ = __webpack_require__(/*! ../tr */ 92);



 // --- Props ---

var props = {}; // --- Mixin ---
// @vue/component

var bottomRowMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  methods: {
    renderBottomRow: function renderBottomRow() {
      var fields = this.computedFields,
          stacked = this.stacked,
          tbodyTrClass = this.tbodyTrClass,
          tbodyTrAttr = this.tbodyTrAttr;
      var h = this.$createElement; // Static bottom row slot (hidden in visibly stacked mode as we can't control the data-label)
      // If in *always* stacked mode, we don't bother rendering the row

      if (!this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_1__constants_slots__["o" /* SLOT_NAME_BOTTOM_ROW */]) || stacked === true || stacked === '') {
        return h();
      }

      return h(__WEBPACK_IMPORTED_MODULE_3__tr__["a" /* BTr */], {
        staticClass: 'b-table-bottom-row',
        class: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(tbodyTrClass) ?
        /* istanbul ignore next */
        tbodyTrClass(null, 'row-bottom') : tbodyTrClass],
        attrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(tbodyTrAttr) ?
        /* istanbul ignore next */
        tbodyTrAttr(null, 'row-bottom') : tbodyTrAttr,
        key: 'b-bottom-row'
      }, this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_1__constants_slots__["o" /* SLOT_NAME_BOTTOM_ROW */], {
        columns: fields.length,
        fields: fields
      }));
    }
  }
});

/***/ }),
/* 931 */
/* exports provided: props, busyMixin */
/* exports used: props, busyMixin */
/*!********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-busy.js ***!
  \********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return busyMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tr__ = __webpack_require__(/*! ../tr */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__td__ = __webpack_require__(/*! ../td */ 120);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









 // --- Constants ---

var MODEL_PROP_NAME_BUSY = 'busy';
var MODEL_EVENT_NAME_BUSY = __WEBPACK_IMPORTED_MODULE_1__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_BUSY; // --- Props ---

var props = _defineProperty({}, MODEL_PROP_NAME_BUSY, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)); // --- Mixin ---
// @vue/component

var busyMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  data: function data() {
    return {
      localBusy: false
    };
  },
  computed: {
    computedBusy: function computedBusy() {
      return this[MODEL_PROP_NAME_BUSY] || this.localBusy;
    }
  },
  watch: {
    localBusy: function localBusy(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit(MODEL_EVENT_NAME_BUSY, newValue);
      }
    }
  },
  methods: {
    // Event handler helper
    stopIfBusy: function stopIfBusy(event) {
      // If table is busy (via provider) then don't propagate
      if (this.computedBusy) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["f" /* stopEvent */])(event);
        return true;
      }

      return false;
    },
    // Render the busy indicator or return `null` if not busy
    renderBusy: function renderBusy() {
      var tbodyTrClass = this.tbodyTrClass,
          tbodyTrAttr = this.tbodyTrAttr;
      var h = this.$createElement; // Return a busy indicator row, or `null` if not busy

      if (this.computedBusy && this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["n" /* SLOT_NAME_TABLE_BUSY */])) {
        return h(__WEBPACK_IMPORTED_MODULE_7__tr__["a" /* BTr */], {
          staticClass: 'b-table-busy-slot',
          class: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["a" /* isFunction */])(tbodyTrClass) ?
          /* istanbul ignore next */
          tbodyTrClass(null, __WEBPACK_IMPORTED_MODULE_3__constants_slots__["n" /* SLOT_NAME_TABLE_BUSY */]) : tbodyTrClass],
          attrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["a" /* isFunction */])(tbodyTrAttr) ?
          /* istanbul ignore next */
          tbodyTrAttr(null, __WEBPACK_IMPORTED_MODULE_3__constants_slots__["n" /* SLOT_NAME_TABLE_BUSY */]) : tbodyTrAttr,
          key: 'table-busy-slot'
        }, [h(__WEBPACK_IMPORTED_MODULE_8__td__["a" /* BTd */], {
          props: {
            colspan: this.computedFields.length || null
          }
        }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["n" /* SLOT_NAME_TABLE_BUSY */])])]);
      } // We return `null` here so that we can determine if we need to
      // render the table items rows or not


      return null;
    }
  }
});

/***/ }),
/* 932 */
/* exports provided: props, emptyMixin */
/* exports used: props, emptyMixin */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-empty.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emptyMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_html__ = __webpack_require__(/*! ../../../utils/html */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tr__ = __webpack_require__(/*! ../tr */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__td__ = __webpack_require__(/*! ../td */ 120);








 // --- Props ---

var props = {
  emptyFilteredHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  emptyFilteredText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'There are no records matching your request'),
  emptyHtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */]),
  emptyText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["b" /* PROP_TYPE_STRING */], 'There are no records to show'),
  showEmpty: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}; // --- Mixin ---
// @vue/component

var emptyMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  methods: {
    renderEmpty: function renderEmpty() {
      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          items = _safeVueInstance.computedItems,
          computedBusy = _safeVueInstance.computedBusy;

      var h = this.$createElement;
      var $empty = h();

      if (this.showEmpty && (!items || items.length === 0) && !(computedBusy && this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_2__constants_slots__["n" /* SLOT_NAME_TABLE_BUSY */]))) {
        var fields = this.computedFields,
            isFiltered = this.isFiltered,
            emptyText = this.emptyText,
            emptyHtml = this.emptyHtml,
            emptyFilteredText = this.emptyFilteredText,
            emptyFilteredHtml = this.emptyFilteredHtml,
            tbodyTrClass = this.tbodyTrClass,
            tbodyTrAttr = this.tbodyTrAttr;
        $empty = this.normalizeSlot(isFiltered ? __WEBPACK_IMPORTED_MODULE_2__constants_slots__["q" /* SLOT_NAME_EMPTYFILTERED */] : __WEBPACK_IMPORTED_MODULE_2__constants_slots__["h" /* SLOT_NAME_EMPTY */], {
          emptyFilteredHtml: emptyFilteredHtml,
          emptyFilteredText: emptyFilteredText,
          emptyHtml: emptyHtml,
          emptyText: emptyText,
          fields: fields,
          // Not sure why this is included, as it will always be an empty array
          items: items
        });

        if (!$empty) {
          $empty = h('div', {
            class: ['text-center', 'my-2'],
            domProps: isFiltered ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(emptyFilteredHtml, emptyFilteredText) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_html__["a" /* htmlOrText */])(emptyHtml, emptyText)
          });
        }

        $empty = h(__WEBPACK_IMPORTED_MODULE_8__td__["a" /* BTd */], {
          props: {
            colspan: fields.length || null
          }
        }, [h('div', {
          attrs: {
            role: 'alert',
            'aria-live': 'polite'
          }
        }, [$empty])]);
        $empty = h(__WEBPACK_IMPORTED_MODULE_7__tr__["a" /* BTr */], {
          staticClass: 'b-table-empty-row',
          class: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(tbodyTrClass) ?
          /* istanbul ignore next */
          tbodyTrClass(null, 'row-empty') : tbodyTrClass],
          attrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(tbodyTrAttr) ?
          /* istanbul ignore next */
          tbodyTrAttr(null, 'row-empty') : tbodyTrAttr,
          key: isFiltered ? 'b-empty-filtered-row' : 'b-empty-row'
        }, [$empty]);
      }

      return $empty;
    }
  }
});

/***/ }),
/* 933 */
/* exports provided: props, filteringMixin */
/* exports used: props, filteringMixin */
/*!*************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-filtering.js ***!
  \*************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filteringMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_regex__ = __webpack_require__(/*! ../../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_clone_deep__ = __webpack_require__(/*! ../../../utils/clone-deep */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_identity__ = __webpack_require__(/*! ../../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_loose_equal__ = __webpack_require__(/*! ../../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_string__ = __webpack_require__(/*! ../../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_warn__ = __webpack_require__(/*! ../../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stringify_record_values__ = __webpack_require__(/*! ./stringify-record-values */ 941);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }















 // --- Constants ---

var DEBOUNCE_DEPRECATED_MSG = 'Prop "filter-debounce" is deprecated. Use the debounce feature of "<b-form-input>" instead.'; // --- Props ---

var props = {
  filter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]), [__WEBPACK_IMPORTED_MODULE_3__constants_props__["q" /* PROP_TYPE_REG_EXP */]])),
  filterDebounce: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0, function (value) {
    return __WEBPACK_IMPORTED_MODULE_4__constants_regex__["a" /* RX_DIGITS */].test(String(value));
  }),
  filterFunction: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["h" /* PROP_TYPE_FUNCTION */]),
  filterIgnoredFields: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["o" /* PROP_TYPE_ARRAY */], []),
  filterIncludedFields: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["o" /* PROP_TYPE_ARRAY */], [])
}; // --- Mixin ---
// @vue/component

var filteringMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  data: function data() {
    return {
      // Flag for displaying which empty slot to show and some event triggering
      isFiltered: false,
      // Where we store the copy of the filter criteria after debouncing
      // We pre-set it with the sanitized filter value
      localFilter: this.filterSanitize(this.filter)
    };
  },
  computed: {
    computedFilterIgnored: function computedFilterIgnored() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(this.filterIgnoredFields || []).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]);
    },
    computedFilterIncluded: function computedFilterIncluded() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(this.filterIncludedFields || []).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]);
    },
    computedFilterDebounce: function computedFilterDebounce() {
      var ms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_number__["b" /* toInteger */])(this.filterDebounce, 0);
      /* istanbul ignore next */

      if (ms > 0) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_warn__["a" /* warn */])(DEBOUNCE_DEPRECATED_MSG, __WEBPACK_IMPORTED_MODULE_1__constants_components__["B" /* NAME_TABLE */]);
      }

      return ms;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? !!this.noProviderFiltering : true;
    },
    // For watching changes to `filteredItems` vs `localItems`
    filteredCheck: function filteredCheck() {
      var filteredItems = this.filteredItems,
          localItems = this.localItems,
          localFilter = this.localFilter;
      return {
        filteredItems: filteredItems,
        localItems: localItems,
        localFilter: localFilter
      };
    },
    // Sanitized/normalize filter-function prop
    localFilterFn: function localFilterFn() {
      // Return `null` to signal to use internal filter function
      var filterFunction = this.filterFunction;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_props__["d" /* hasPropFunction */])(filterFunction) ? filterFunction : null;
    },
    // Returns the records in `localItems` that match the filter criteria
    // Returns the original `localItems` array if not sorting
    filteredItems: function filteredItems() {
      // Note the criteria is debounced and sanitized
      var items = this.localItems,
          criteria = this.localFilter; // Resolve the filtering function, when requested
      // We prefer the provided filtering function and fallback to the internal one
      // When no filtering criteria is specified the filtering factories will return `null`

      var filterFn = this.localFiltering ? this.filterFnFactory(this.localFilterFn, criteria) || this.defaultFilterFnFactory(criteria) : null; // We only do local filtering when requested and there are records to filter

      return filterFn && items.length > 0 ? items.filter(filterFn) : items;
    }
  },
  watch: {
    // Watch for debounce being set to 0
    computedFilterDebounce: function computedFilterDebounce(newValue) {
      if (!newValue && this.$_filterTimer) {
        this.clearFilterTimer();
        this.localFilter = this.filterSanitize(this.filter);
      }
    },
    // Watch for changes to the filter criteria, and debounce if necessary
    filter: {
      // We need a deep watcher in case the user passes
      // an object when using `filter-function`
      deep: true,
      handler: function handler(newCriteria) {
        var _this = this;

        var timeout = this.computedFilterDebounce;
        this.clearFilterTimer();

        if (timeout && timeout > 0) {
          // If we have a debounce time, delay the update of `localFilter`
          this.$_filterTimer = setTimeout(function () {
            _this.localFilter = _this.filterSanitize(newCriteria);
          }, timeout);
        } else {
          // Otherwise, immediately update `localFilter` with `newFilter` value
          this.localFilter = this.filterSanitize(newCriteria);
        }
      }
    },
    // Watch for changes to the filter criteria and filtered items vs `localItems`
    // Set visual state and emit events as required
    filteredCheck: function filteredCheck(_ref) {
      var filteredItems = _ref.filteredItems,
          localFilter = _ref.localFilter;
      // Determine if the dataset is filtered or not
      var isFiltered = false;

      if (!localFilter) {
        // If filter criteria is falsey
        isFiltered = false;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_loose_equal__["a" /* looseEqual */])(localFilter, []) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_loose_equal__["a" /* looseEqual */])(localFilter, {})) {
        // If filter criteria is an empty array or object
        isFiltered = false;
      } else if (localFilter) {
        // If filter criteria is truthy
        isFiltered = true;
      }

      if (isFiltered) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["R" /* EVENT_NAME_FILTERED */], filteredItems, filteredItems.length);
      }

      this.isFiltered = isFiltered;
    },
    isFiltered: function isFiltered(newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        // We need to emit a filtered event if `isFiltered` transitions from `true` to
        // `false` so that users can update their pagination controls
        var localItems = this.localItems;
        this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["R" /* EVENT_NAME_FILTERED */], localItems, localItems.length);
      }
    }
  },
  created: function created() {
    var _this2 = this;

    // Create private non-reactive props
    this.$_filterTimer = null; // If filter is "pre-set", set the criteria
    // This will trigger any watchers/dependents
    // this.localFilter = this.filterSanitize(this.filter)
    // Set the initial filtered state in a `$nextTick()` so that
    // we trigger a filtered event if needed

    this.$nextTick(function () {
      _this2.isFiltered = Boolean(_this2.localFilter);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearFilterTimer();
  },
  methods: {
    clearFilterTimer: function clearFilterTimer() {
      clearTimeout(this.$_filterTimer);
      this.$_filterTimer = null;
    },
    filterSanitize: function filterSanitize(criteria) {
      // Sanitizes filter criteria based on internal or external filtering
      if (this.localFiltering && !this.localFilterFn && !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["f" /* isString */])(criteria) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["o" /* isRegExp */])(criteria))) {
        // If using internal filter function, which only accepts string or RegExp,
        // return '' to signify no filter
        return '';
      } // Could be a string, object or array, as needed by external filter function
      // We use `cloneDeep` to ensure we have a new copy of an object or array
      // without Vue's reactive observers


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_clone_deep__["a" /* cloneDeep */])(criteria);
    },
    // Filter Function factories
    filterFnFactory: function filterFnFactory(filterFn, criteria) {
      // Wrapper factory for external filter functions
      // Wrap the provided filter-function and return a new function
      // Returns `null` if no filter-function defined or if criteria is falsey
      // Rather than directly grabbing `this.computedLocalFilterFn` or `this.filterFunction`
      // we have it passed, so that the caller computed prop will be reactive to changes
      // in the original filter-function (as this routine is a method)
      if (!filterFn || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["a" /* isFunction */])(filterFn) || !criteria || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_loose_equal__["a" /* looseEqual */])(criteria, []) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_loose_equal__["a" /* looseEqual */])(criteria, {})) {
        return null;
      } // Build the wrapped filter test function, passing the criteria to the provided function


      var fn = function fn(item) {
        // Generated function returns true if the criteria matches part
        // of the serialized data, otherwise false
        return filterFn(item, criteria);
      }; // Return the wrapped function


      return fn;
    },
    defaultFilterFnFactory: function defaultFilterFnFactory(criteria) {
      var _this3 = this;

      // Generates the default filter function, using the given filter criteria
      // Returns `null` if no criteria or criteria format not supported
      if (!criteria || !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["f" /* isString */])(criteria) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["o" /* isRegExp */])(criteria))) {
        // Built in filter can only support strings or RegExp criteria (at the moment)
        return null;
      } // Build the RegExp needed for filtering


      var regExp = criteria;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["f" /* isString */])(regExp)) {
        // Escape special RegExp characters in the string and convert contiguous
        // whitespace to \s+ matches
        var pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_string__["g" /* escapeRegExp */])(criteria).replace(__WEBPACK_IMPORTED_MODULE_4__constants_regex__["z" /* RX_SPACES */], '\\s+'); // Build the RegExp (no need for global flag, as we only need
        // to find the value once in the string)

        regExp = new RegExp(".*".concat(pattern, ".*"), 'i');
      } // Generate the wrapped filter test function to use


      var fn = function fn(item) {
        // This searches all row values (and sub property values) in the entire (excluding
        // special `_` prefixed keys), because we convert the record to a space-separated
        // string containing all the value properties (recursively), even ones that are
        // not visible (not specified in this.fields)
        // Users can ignore filtering on specific fields, or on only certain fields,
        // and can optionall specify searching results of fields with formatter
        //
        // TODO: Enable searching on scoped slots (optional, as it will be SLOW)
        //
        // Generated function returns true if the criteria matches part of
        // the serialized data, otherwise false
        //
        // We set `lastIndex = 0` on the `RegExp` in case someone specifies the `/g` global flag
        regExp.lastIndex = 0;
        return regExp.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__stringify_record_values__["a" /* stringifyRecordValues */])(item, _this3.computedFilterIgnored, _this3.computedFilterIncluded, _this3.computedFieldsObj));
      }; // Return the generated function


      return fn;
    }
  }
});

/***/ }),
/* 934 */
/* exports provided: props, paginationMixin */
/* exports used: props, paginationMixin */
/*!**************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-pagination.js ***!
  \**************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return paginationMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_math__ = __webpack_require__(/*! ../../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);





 // --- Props ---

var props = {
  currentPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 1),
  perPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_1__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0)
}; // --- Mixin ---
// @vue/component

var paginationMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  computed: {
    localPaging: function localPaging() {
      return this.hasProvider ? !!this.noProviderPaging : true;
    },
    paginatedItems: function paginatedItems() {
      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          sortedItems = _safeVueInstance.sortedItems,
          filteredItems = _safeVueInstance.filteredItems,
          localItems = _safeVueInstance.localItems;

      var items = sortedItems || filteredItems || localItems || [];
      var currentPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_number__["b" /* toInteger */])(this.currentPage, 1), 1);
      var perPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_math__["a" /* mathMax */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_number__["b" /* toInteger */])(this.perPage, 0), 0); // Apply local pagination

      if (this.localPaging && perPage) {
        // Grab the current page of data (which may be past filtered items limit)
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      } // Return the items to display in the table


      return items;
    }
  }
});

/***/ }),
/* 935 */
/* exports provided: props, providerMixin */
/* exports used: props, providerMixin */
/*!************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-provider.js ***!
  \************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return providerMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_loose_equal__ = __webpack_require__(/*! ../../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_warn__ = __webpack_require__(/*! ../../../utils/warn */ 54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_listen_on_root__ = __webpack_require__(/*! ../../../mixins/listen-on-root */ 74);











 // --- Constants ---

var ROOT_EVENT_NAME_REFRESHED = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["a" /* getRootEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["B" /* NAME_TABLE */], __WEBPACK_IMPORTED_MODULE_2__constants_events__["O" /* EVENT_NAME_REFRESHED */]);
var ROOT_ACTION_EVENT_NAME_REFRESH = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["d" /* getRootActionEventName */])(__WEBPACK_IMPORTED_MODULE_1__constants_components__["B" /* NAME_TABLE */], __WEBPACK_IMPORTED_MODULE_2__constants_events__["P" /* EVENT_NAME_REFRESH */]); // --- Props ---

var props = {
  // Passed to the context object
  // Not used by `<b-table>` directly
  apiUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]),
  // Adds in 'Function' support
  items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["p" /* PROP_TYPE_ARRAY_FUNCTION */], []),
  noProviderFiltering: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noProviderPaging: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noProviderSorting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}; // --- Mixin ---
// @vue/component

var providerMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_11__mixins_listen_on_root__["a" /* listenOnRootMixin */]],
  props: props,
  computed: {
    hasProvider: function hasProvider() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["a" /* isFunction */])(this.items);
    },
    providerTriggerContext: function providerTriggerContext() {
      // Used to trigger the provider function via a watcher. Only the fields that
      // are needed for triggering a provider update are included. Note that the
      // regular this.context is sent to the provider during fetches though, as they
      // may need all the prop info.
      var ctx = {
        apiUrl: this.apiUrl,
        filter: null,
        sortBy: null,
        sortDesc: null,
        perPage: null,
        currentPage: null
      };

      if (!this.noProviderFiltering) {
        // Either a string, or could be an object or array.
        ctx.filter = this.localFilter;
      }

      if (!this.noProviderSorting) {
        ctx.sortBy = this.localSortBy;
        ctx.sortDesc = this.localSortDesc;
      }

      if (!this.noProviderPaging) {
        ctx.perPage = this.perPage;
        ctx.currentPage = this.currentPage;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_object__["b" /* clone */])(ctx);
    }
  },
  watch: {
    // Provider update triggering
    items: function items(newValue) {
      // If a new provider has been specified, trigger an update
      if (this.hasProvider || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["a" /* isFunction */])(newValue)) {
        this.$nextTick(this._providerUpdate);
      }
    },
    providerTriggerContext: function providerTriggerContext(newValue, oldValue) {
      // Trigger the provider to update as the relevant context values have changed.
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_loose_equal__["a" /* looseEqual */])(newValue, oldValue)) {
        this.$nextTick(this._providerUpdate);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Call the items provider if necessary
    if (this.hasProvider && (!this.localItems || this.localItems.length === 0)) {
      // Fetch on mount if localItems is empty
      this._providerUpdate();
    } // Listen for global messages to tell us to force refresh the table


    this.listenOnRoot(ROOT_ACTION_EVENT_NAME_REFRESH, function (id) {
      if (id === _this.id || id === _this) {
        _this.refresh();
      }
    });
  },
  methods: {
    refresh: function refresh() {
      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          items = _safeVueInstance.items,
          refresh = _safeVueInstance.refresh,
          computedBusy = _safeVueInstance.computedBusy; // Public Method: Force a refresh of the provider function


      this.$off(__WEBPACK_IMPORTED_MODULE_2__constants_events__["O" /* EVENT_NAME_REFRESHED */], refresh);

      if (computedBusy) {
        // Can't force an update when forced busy by user (busy prop === true)
        if (this.localBusy && this.hasProvider) {
          // But if provider running (localBusy), re-schedule refresh once `refreshed` emitted
          this.$on(__WEBPACK_IMPORTED_MODULE_2__constants_events__["O" /* EVENT_NAME_REFRESHED */], refresh);
        }
      } else {
        this.clearSelected();

        if (this.hasProvider) {
          this.$nextTick(this._providerUpdate);
        } else {
          /* istanbul ignore next */
          this.localItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["c" /* isArray */])(items) ? items.slice() : [];
        }
      }
    },
    // Provider related methods
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["c" /* isArray */])(items) ? items.slice() : [];
      this.localBusy = false;
      this.$emit(__WEBPACK_IMPORTED_MODULE_2__constants_events__["O" /* EVENT_NAME_REFRESHED */]); // New root emit

      if (this.id) {
        this.emitOnRoot(ROOT_EVENT_NAME_REFRESHED, this.id);
      }
    },
    _providerUpdate: function _providerUpdate() {
      var _this2 = this;

      // Refresh the provider function items.
      if (!this.hasProvider) {
        // Do nothing if no provider
        return;
      } // If table is busy, wait until refreshed before calling again


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_safe_vue_instance__["a" /* safeVueInstance */])(this).computedBusy) {
        // Schedule a new refresh once `refreshed` is emitted
        this.$nextTick(this.refresh);
        return;
      } // Set internal busy state


      this.localBusy = true; // Call provider function with context and optional callback after DOM is fully updated

      this.$nextTick(function () {
        try {
          // Call provider function passing it the context and optional callback
          var data = _this2.items(_this2.context, _this2._providerSetLocal);

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["m" /* isPromise */])(data)) {
            // Provider returned Promise
            data.then(function (items) {
              // Provider resolved with items
              _this2._providerSetLocal(items);
            });
          } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["c" /* isArray */])(data)) {
            // Provider returned Array data
            _this2._providerSetLocal(data);
          } else {
            /* istanbul ignore if */
            if (_this2.items.length !== 2) {
              // Check number of arguments provider function requested
              // Provider not using callback (didn't request second argument), so we clear
              // busy state as most likely there was an error in the provider function

              /* istanbul ignore next */
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["a" /* warn */])("Provider function didn't request callback and did not return a promise or data.", __WEBPACK_IMPORTED_MODULE_1__constants_components__["B" /* NAME_TABLE */]);
              _this2.localBusy = false;
            }
          }
        } catch (e)
        /* istanbul ignore next */
        {
          // Provider function borked on us, so we spew out a warning
          // and clear the busy state
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["a" /* warn */])("Provider function error [".concat(e.name, "] ").concat(e.message, "."), __WEBPACK_IMPORTED_MODULE_1__constants_components__["B" /* NAME_TABLE */]);
          _this2.localBusy = false;

          _this2.$off(__WEBPACK_IMPORTED_MODULE_2__constants_events__["O" /* EVENT_NAME_REFRESHED */], _this2.refresh);
        }
      });
    }
  }
});

/***/ }),
/* 936 */
/* exports provided: props, selectableMixin */
/* exports used: props, selectableMixin */
/*!**************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-selectable.js ***!
  \**************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectableMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_identity__ = __webpack_require__(/*! ../../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_loose_equal__ = __webpack_require__(/*! ../../../utils/loose-equal */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math__ = __webpack_require__(/*! ../../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_string__ = __webpack_require__(/*! ../../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sanitize_row__ = __webpack_require__(/*! ./sanitize-row */ 434);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











 // --- Constants ---

var SELECT_MODES = ['range', 'multi', 'single'];
var ROLE_GRID = 'grid'; // --- Props ---

var props = {
  // Disable use of click handlers for row selection
  noSelectOnClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  selectMode: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'multi', function (value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(SELECT_MODES, value);
  }),
  selectable: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  selectedVariant: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'active')
}; // --- Mixin ---
// @vue/component

var selectableMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  data: function data() {
    return {
      selectedRows: [],
      selectedLastRow: -1
    };
  },
  computed: {
    isSelectable: function isSelectable() {
      return this.selectable && this.selectMode;
    },
    hasSelectableRowClick: function hasSelectableRowClick() {
      return this.isSelectable && !this.noSelectOnClick;
    },
    supportsSelectableRows: function supportsSelectableRows() {
      return true;
    },
    selectableHasSelection: function selectableHasSelection() {
      var selectedRows = this.selectedRows;
      return this.isSelectable && selectedRows && selectedRows.length > 0 && selectedRows.some(__WEBPACK_IMPORTED_MODULE_4__utils_identity__["a" /* identity */]);
    },
    selectableIsMultiSelect: function selectableIsMultiSelect() {
      return this.isSelectable && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(['range', 'multi'], this.selectMode);
    },
    selectableTableClasses: function selectableTableClasses() {
      var _ref;

      var isSelectable = this.isSelectable;
      return _ref = {
        'b-table-selectable': isSelectable
      }, _defineProperty(_ref, "b-table-select-".concat(this.selectMode), isSelectable), _defineProperty(_ref, 'b-table-selecting', this.selectableHasSelection), _defineProperty(_ref, 'b-table-selectable-no-click', isSelectable && !this.hasSelectableRowClick), _ref;
    },
    selectableTableAttrs: function selectableTableAttrs() {
      if (!this.isSelectable) {
        return {};
      }

      var role = this.bvAttrs.role || ROLE_GRID;
      return {
        role: role,
        // TODO:
        //   Should this attribute not be included when `no-select-on-click` is set
        //   since this attribute implies keyboard navigation?
        'aria-multiselectable': role === ROLE_GRID ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["a" /* toString */])(this.selectableIsMultiSelect) : null
      };
    }
  },
  watch: {
    computedItems: function computedItems(newValue, oldValue) {
      // Reset for selectable
      var equal = false;

      if (this.isSelectable && this.selectedRows.length > 0) {
        // Quick check against array length
        equal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["c" /* isArray */])(newValue) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["c" /* isArray */])(oldValue) && newValue.length === oldValue.length;

        for (var i = 0; equal && i < newValue.length; i++) {
          // Look for the first non-loosely equal row, after ignoring reserved fields
          equal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_loose_equal__["a" /* looseEqual */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sanitize_row__["a" /* sanitizeRow */])(newValue[i]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sanitize_row__["a" /* sanitizeRow */])(oldValue[i]));
        }
      }

      if (!equal) {
        this.clearSelected();
      }
    },
    selectable: function selectable(newValue) {
      this.clearSelected();
      this.setSelectionHandlers(newValue);
    },
    selectMode: function selectMode() {
      this.clearSelected();
    },
    hasSelectableRowClick: function hasSelectableRowClick(newValue) {
      this.clearSelected();
      this.setSelectionHandlers(!newValue);
    },
    selectedRows: function selectedRows(_selectedRows, oldValue) {
      var _this = this;

      if (this.isSelectable && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_loose_equal__["a" /* looseEqual */])(_selectedRows, oldValue)) {
        var items = []; // `.forEach()` skips over non-existent indices (on sparse arrays)

        _selectedRows.forEach(function (v, idx) {
          if (v) {
            items.push(_this.computedItems[idx]);
          }
        });

        this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["Q" /* EVENT_NAME_ROW_SELECTED */], items);
      }
    }
  },
  beforeMount: function beforeMount() {
    // Set up handlers if needed
    if (this.isSelectable) {
      this.setSelectionHandlers(true);
    }
  },
  methods: {
    // Public methods
    selectRow: function selectRow(index) {
      // Select a particular row (indexed based on computedItems)
      if (this.isSelectable && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["j" /* isNumber */])(index) && index >= 0 && index < this.computedItems.length && !this.isRowSelected(index)) {
        var selectedRows = this.selectableIsMultiSelect ? this.selectedRows.slice() : [];
        selectedRows[index] = true;
        this.selectedLastClicked = -1;
        this.selectedRows = selectedRows;
      }
    },
    unselectRow: function unselectRow(index) {
      // Un-select a particular row (indexed based on `computedItems`)
      if (this.isSelectable && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["j" /* isNumber */])(index) && this.isRowSelected(index)) {
        var selectedRows = this.selectedRows.slice();
        selectedRows[index] = false;
        this.selectedLastClicked = -1;
        this.selectedRows = selectedRows;
      }
    },
    selectAllRows: function selectAllRows() {
      var length = this.computedItems.length;

      if (this.isSelectable && length > 0) {
        this.selectedLastClicked = -1;
        this.selectedRows = this.selectableIsMultiSelect ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* createArray */])(length, true) : [true];
      }
    },
    isRowSelected: function isRowSelected(index) {
      // Determine if a row is selected (indexed based on `computedItems`)
      return !!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["j" /* isNumber */])(index) && this.selectedRows[index]);
    },
    clearSelected: function clearSelected() {
      // Clear any active selected row(s)
      this.selectedLastClicked = -1;
      this.selectedRows = [];
    },
    // Internal private methods
    selectableRowClasses: function selectableRowClasses(index) {
      if (this.isSelectable && this.isRowSelected(index)) {
        var variant = this.selectedVariant;
        return _defineProperty({
          'b-table-row-selected': true
        }, "".concat(this.dark ? 'bg' : 'table', "-").concat(variant), variant);
      }

      return {};
    },
    selectableRowAttrs: function selectableRowAttrs(index) {
      return {
        'aria-selected': !this.isSelectable ? null : this.isRowSelected(index) ? 'true' : 'false'
      };
    },
    setSelectionHandlers: function setSelectionHandlers(on) {
      var method = on && !this.noSelectOnClick ? '$on' : '$off'; // Handle row-clicked event

      this[method](__WEBPACK_IMPORTED_MODULE_1__constants_events__["G" /* EVENT_NAME_ROW_CLICKED */], this.selectionHandler); // Clear selection on filter, pagination, and sort changes

      this[method](__WEBPACK_IMPORTED_MODULE_1__constants_events__["R" /* EVENT_NAME_FILTERED */], this.clearSelected);
      this[method](__WEBPACK_IMPORTED_MODULE_1__constants_events__["N" /* EVENT_NAME_CONTEXT_CHANGED */], this.clearSelected);
    },
    selectionHandler: function selectionHandler(item, index, event) {
      /* istanbul ignore if: should never happen */
      if (!this.isSelectable || this.noSelectOnClick) {
        // Don't do anything if table is not in selectable mode
        this.clearSelected();
        return;
      }

      var selectMode = this.selectMode,
          selectedLastRow = this.selectedLastRow;
      var selectedRows = this.selectedRows.slice();
      var selected = !selectedRows[index]; // Note 'multi' mode needs no special event handling

      if (selectMode === 'single') {
        selectedRows = [];
      } else if (selectMode === 'range') {
        if (selectedLastRow > -1 && event.shiftKey) {
          // range
          for (var idx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math__["e" /* mathMin */])(selectedLastRow, index); idx <= __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math__["a" /* mathMax */])(selectedLastRow, index); idx++) {
            selectedRows[idx] = true;
          }

          selected = true;
        } else {
          if (!(event.ctrlKey || event.metaKey)) {
            // Clear range selection if any
            selectedRows = [];
            selected = true;
          }

          if (selected) this.selectedLastRow = index;
        }
      }

      selectedRows[index] = selected;
      this.selectedRows = selectedRows;
    }
  }
});

/***/ }),
/* 937 */
/* exports provided: props, sortingMixin */
/* exports used: props, sortingMixin */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-sorting.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sortingMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_stable_sort__ = __webpack_require__(/*! ../../../utils/stable-sort */ 466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_string__ = __webpack_require__(/*! ../../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__default_sort_compare__ = __webpack_require__(/*! ./default-sort-compare */ 929);
var _props, _watch;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










 // --- Constants ---

var MODEL_PROP_NAME_SORT_BY = 'sortBy';
var MODEL_EVENT_NAME_SORT_BY = __WEBPACK_IMPORTED_MODULE_1__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_SORT_BY;
var MODEL_PROP_NAME_SORT_DESC = 'sortDesc';
var MODEL_EVENT_NAME_SORT_DESC = __WEBPACK_IMPORTED_MODULE_1__constants_events__["s" /* MODEL_EVENT_NAME_PREFIX */] + MODEL_PROP_NAME_SORT_DESC;
var SORT_DIRECTION_ASC = 'asc';
var SORT_DIRECTION_DESC = 'desc';
var SORT_DIRECTION_LAST = 'last';
var SORT_DIRECTIONS = [SORT_DIRECTION_ASC, SORT_DIRECTION_DESC, SORT_DIRECTION_LAST]; // --- Props ---

var props = (_props = {
  labelSortAsc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'Click to sort ascending'),
  labelSortClear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'Click to clear sorting'),
  labelSortDesc: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], 'Click to sort descending'),
  noFooterSorting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  noLocalSorting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // Another prop that should have had a better name
  // It should be `noSortClear` (on non-sortable headers)
  // We will need to make sure the documentation is clear on what
  // this prop does (as well as in the code for future reference)
  noSortReset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)
}, _defineProperty(_props, MODEL_PROP_NAME_SORT_BY, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */])), _defineProperty(_props, "sortCompare", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["h" /* PROP_TYPE_FUNCTION */])), _defineProperty(_props, "sortCompareLocale", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */])), _defineProperty(_props, "sortCompareOptions", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["e" /* PROP_TYPE_OBJECT */], {
  numeric: true
})), _defineProperty(_props, MODEL_PROP_NAME_SORT_DESC, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_props, "sortDirection", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["b" /* PROP_TYPE_STRING */], SORT_DIRECTION_ASC, function (value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(SORT_DIRECTIONS, value);
})), _defineProperty(_props, "sortIconLeft", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _defineProperty(_props, "sortNullLast", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false)), _props); // --- Mixin ---
// @vue/component

var sortingMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  props: props,
  data: function data() {
    return {
      localSortBy: this[MODEL_PROP_NAME_SORT_BY] || '',
      localSortDesc: this[MODEL_PROP_NAME_SORT_DESC] || false
    };
  },
  computed: {
    localSorting: function localSorting() {
      return this.hasProvider ? !!this.noProviderSorting : !this.noLocalSorting;
    },
    isSortable: function isSortable() {
      return this.computedFields.some(function (f) {
        return f.sortable;
      });
    },
    // Sorts the filtered items and returns a new array of the sorted items
    // When not sorted, the original items array will be returned
    sortedItems: function sortedItems() {
      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          sortBy = _safeVueInstance.localSortBy,
          sortDesc = _safeVueInstance.localSortDesc,
          locale = _safeVueInstance.sortCompareLocale,
          nullLast = _safeVueInstance.sortNullLast,
          sortCompare = _safeVueInstance.sortCompare,
          localSorting = _safeVueInstance.localSorting,
          filteredItems = _safeVueInstance.filteredItems,
          localItems = _safeVueInstance.localItems;

      var items = (filteredItems || localItems || []).slice();

      var localeOptions = _objectSpread(_objectSpread({}, this.sortCompareOptions), {}, {
        usage: 'sort'
      });

      if (sortBy && localSorting) {
        var field = this.computedFieldsObj[sortBy] || {};
        var sortByFormatted = field.sortByFormatted;
        var formatter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(sortByFormatted) ?
        /* istanbul ignore next */
        sortByFormatted : sortByFormatted ? this.getFieldFormatter(sortBy) : undefined; // `stableSort` returns a new array, and leaves the original array intact

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_stable_sort__["a" /* stableSort */])(items, function (a, b) {
          var result = null; // Call user provided `sortCompare` routine first

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["a" /* isFunction */])(sortCompare)) {
            // TODO:
            //   Change the `sortCompare` signature to the one of `defaultSortCompare`
            //   with the next major version bump
            result = sortCompare(a, b, sortBy, sortDesc, formatter, localeOptions, locale);
          } // Fallback to built-in `defaultSortCompare` if `sortCompare`
          // is not defined or returns `null`/`false`


          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_inspect__["g" /* isUndefinedOrNull */])(result) || result === false) {
            result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__default_sort_compare__["a" /* defaultSortCompare */])(a, b, {
              sortBy: sortBy,
              formatter: formatter,
              locale: locale,
              localeOptions: localeOptions,
              nullLast: nullLast
            });
          } // Negate result if sorting in descending order


          return (result || 0) * (sortDesc ? -1 : 1);
        });
      }

      return items;
    }
  },
  watch: (_watch = {
    /* istanbul ignore next: pain in the butt to test */
    isSortable: function isSortable(newValue) {
      if (newValue) {
        if (this.isSortable) {
          this.$on(__WEBPACK_IMPORTED_MODULE_1__constants_events__["M" /* EVENT_NAME_HEAD_CLICKED */], this.handleSort);
        }
      } else {
        this.$off(__WEBPACK_IMPORTED_MODULE_1__constants_events__["M" /* EVENT_NAME_HEAD_CLICKED */], this.handleSort);
      }
    }
  }, _defineProperty(_watch, MODEL_PROP_NAME_SORT_DESC, function (newValue) {
    /* istanbul ignore next */
    if (newValue === this.localSortDesc) {
      return;
    }

    this.localSortDesc = newValue || false;
  }), _defineProperty(_watch, MODEL_PROP_NAME_SORT_BY, function (newValue) {
    /* istanbul ignore next */
    if (newValue === this.localSortBy) {
      return;
    }

    this.localSortBy = newValue || '';
  }), _defineProperty(_watch, "localSortDesc", function localSortDesc(newValue, oldValue) {
    // Emit update to sort-desc.sync
    if (newValue !== oldValue) {
      this.$emit(MODEL_EVENT_NAME_SORT_DESC, newValue);
    }
  }), _defineProperty(_watch, "localSortBy", function localSortBy(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.$emit(MODEL_EVENT_NAME_SORT_BY, newValue);
    }
  }), _watch),
  created: function created() {
    if (this.isSortable) {
      this.$on(__WEBPACK_IMPORTED_MODULE_1__constants_events__["M" /* EVENT_NAME_HEAD_CLICKED */], this.handleSort);
    }
  },
  methods: {
    // Handlers
    // Need to move from thead-mixin
    handleSort: function handleSort(key, field, event, isFoot) {
      var _this = this;

      if (!this.isSortable) {
        /* istanbul ignore next */
        return;
      }

      if (isFoot && this.noFooterSorting) {
        return;
      } // TODO: make this tri-state sorting
      // cycle desc => asc => none => desc => ...


      var sortChanged = false;

      var toggleLocalSortDesc = function toggleLocalSortDesc() {
        var sortDirection = field.sortDirection || _this.sortDirection;

        if (sortDirection === SORT_DIRECTION_ASC) {
          _this.localSortDesc = false;
        } else if (sortDirection === SORT_DIRECTION_DESC) {
          _this.localSortDesc = true;
        } else {// sortDirection === 'last'
          // Leave at last sort direction from previous column
        }
      };

      if (field.sortable) {
        var sortKey = !this.localSorting && field.sortKey ? field.sortKey : key;

        if (this.localSortBy === sortKey) {
          // Change sorting direction on current column
          this.localSortDesc = !this.localSortDesc;
        } else {
          // Start sorting this column ascending
          this.localSortBy = sortKey; // this.localSortDesc = false

          toggleLocalSortDesc();
        }

        sortChanged = true;
      } else if (this.localSortBy && !this.noSortReset) {
        this.localSortBy = '';
        toggleLocalSortDesc();
        sortChanged = true;
      }

      if (sortChanged) {
        // Sorting parameters changed
        this.$emit(__WEBPACK_IMPORTED_MODULE_1__constants_events__["S" /* EVENT_NAME_SORT_CHANGED */], this.context);
      }
    },
    // methods to compute classes and attrs for thead>th cells
    sortTheadThClasses: function sortTheadThClasses(key, field, isFoot) {
      return {
        // If sortable and sortIconLeft are true, then place sort icon on the left
        'b-table-sort-icon-left': field.sortable && this.sortIconLeft && !(isFoot && this.noFooterSorting)
      };
    },
    sortTheadThAttrs: function sortTheadThAttrs(key, field, isFoot) {
      var _field$sortKey;

      var isSortable = this.isSortable,
          noFooterSorting = this.noFooterSorting,
          localSortDesc = this.localSortDesc,
          localSortBy = this.localSortBy,
          localSorting = this.localSorting;

      if (!isSortable || isFoot && noFooterSorting) {
        // No attributes if not a sortable table
        return {};
      }

      var sortable = field.sortable;
      var sortKey = !localSorting ? (_field$sortKey = field.sortKey) !== null && _field$sortKey !== void 0 ? _field$sortKey : key : key; // Assemble the aria-sort attribute value

      var ariaSort = sortable && localSortBy === sortKey ? localSortDesc ? 'descending' : 'ascending' : sortable ? 'none' : null; // Return the attribute

      return {
        'aria-sort': ariaSort
      };
    },
    // A label to be placed in an `.sr-only` element in the header cell
    sortTheadThLabel: function sortTheadThLabel(key, field, isFoot) {
      // No label if not a sortable table
      if (!this.isSortable || isFoot && this.noFooterSorting) {
        return null;
      }

      var localSortBy = this.localSortBy,
          localSortDesc = this.localSortDesc,
          labelSortAsc = this.labelSortAsc,
          labelSortDesc = this.labelSortDesc;
      var sortable = field.sortable; // The correctness of these labels is very important for screen reader users

      var labelSorting = '';

      if (sortable) {
        if (localSortBy === key) {
          // Currently sorted sortable column
          labelSorting = localSortDesc ? labelSortAsc : labelSortDesc;
        } else {
          // Not currently sorted sortable column
          // Not using nested ternary's here for clarity/readability
          // Default for `aria-label`
          labelSorting = localSortDesc ? labelSortDesc : labelSortAsc; // Handle `sortDirection` setting

          var sortDirection = this.sortDirection || field.sortDirection;

          if (sortDirection === SORT_DIRECTION_ASC) {
            labelSorting = labelSortAsc;
          } else if (sortDirection === SORT_DIRECTION_DESC) {
            labelSorting = labelSortDesc;
          }
        }
      } else if (!this.noSortReset) {
        // Non sortable column
        labelSorting = localSortBy ? this.labelSortClear : '';
      } // Return the `.sr-only` sort label or `null` if no label


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_string__["f" /* trim */])(labelSorting) || null;
    }
  }
});

/***/ }),
/* 938 */
/* exports provided: props, tbodyRowMixin */
/* exports used: props, tbodyRowMixin */
/*!*************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-tbody-row.js ***!
  \*************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tbodyRowMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_use_parent__ = __webpack_require__(/*! ../../../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_get__ = __webpack_require__(/*! ../../../utils/get */ 141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_safe_vue_instance__ = __webpack_require__(/*! ../../../utils/safe-vue-instance */ 65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_string__ = __webpack_require__(/*! ../../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tr__ = __webpack_require__(/*! ../tr */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__td__ = __webpack_require__(/*! ../td */ 120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__th__ = __webpack_require__(/*! ../th */ 178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(/*! ./constants */ 176);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














 // --- Props ---

var props = {
  detailsTdClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]),
  tbodyTrAttr: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_2__constants_props__["n" /* PROP_TYPE_OBJECT_FUNCTION */]),
  tbodyTrClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_props__["a" /* makeProp */])([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__constants_props__["i" /* PROP_TYPE_ARRAY_OBJECT_STRING */]), [__WEBPACK_IMPORTED_MODULE_2__constants_props__["h" /* PROP_TYPE_FUNCTION */]]))
}; // --- Mixin ---
// @vue/component

var tbodyRowMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_use_parent__["a" /* useParentMixin */]],
  props: props,
  methods: {
    // Methods for computing classes, attributes and styles for table cells
    getTdValues: function getTdValues(item, key, tdValue, defaultValue) {
      var bvParent = this.bvParent;

      if (tdValue) {
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get__["b" /* get */])(item, key, '');

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(tdValue)) {
          return tdValue(value, key, item);
        } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["f" /* isString */])(tdValue) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(bvParent[tdValue])) {
          return bvParent[tdValue](value, key, item);
        }

        return tdValue;
      }

      return defaultValue;
    },
    getThValues: function getThValues(item, key, thValue, type, defaultValue) {
      var bvParent = this.bvParent;

      if (thValue) {
        var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get__["b" /* get */])(item, key, '');

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(thValue)) {
          return thValue(value, key, item, type);
        } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["f" /* isString */])(thValue) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(bvParent[thValue])) {
          return bvParent[thValue](value, key, item, type);
        }

        return thValue;
      }

      return defaultValue;
    },
    // Method to get the value for a field
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = this.getFieldFormatter(key);
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get__["b" /* get */])(item, key, null);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(formatter)) {
        value = formatter(value, key, item);
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["g" /* isUndefinedOrNull */])(value) ? '' : value;
    },
    // Factory function methods
    toggleDetailsFactory: function toggleDetailsFactory(hasDetailsSlot, item) {
      var _this = this;

      // Returns a function to toggle a row's details slot
      return function () {
        if (hasDetailsSlot) {
          _this.$set(item, __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* FIELD_KEY_SHOW_DETAILS */], !item[__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* FIELD_KEY_SHOW_DETAILS */]]);
        }
      };
    },
    // Row event handlers
    rowHovered: function rowHovered(event) {
      // `mouseenter` handler (non-bubbling)
      // `this.tbodyRowEventStopped` from tbody mixin
      if (!this.tbodyRowEventStopped(event)) {
        // `this.emitTbodyRowEvent` from tbody mixin
        this.emitTbodyRowEvent(__WEBPACK_IMPORTED_MODULE_1__constants_events__["K" /* EVENT_NAME_ROW_HOVERED */], event);
      }
    },
    rowUnhovered: function rowUnhovered(event) {
      // `mouseleave` handler (non-bubbling)
      // `this.tbodyRowEventStopped` from tbody mixin
      if (!this.tbodyRowEventStopped(event)) {
        // `this.emitTbodyRowEvent` from tbody mixin
        this.emitTbodyRowEvent(__WEBPACK_IMPORTED_MODULE_1__constants_events__["L" /* EVENT_NAME_ROW_UNHOVERED */], event);
      }
    },
    // Renders a TD or TH for a row's field
    renderTbodyRowCell: function renderTbodyRowCell(field, colIndex, item, rowIndex) {
      var _this2 = this;

      var isStacked = this.isStacked;
      var key = field.key,
          label = field.label,
          isRowHeader = field.isRowHeader;
      var h = this.$createElement;
      var hasDetailsSlot = this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["k" /* SLOT_NAME_ROW_DETAILS */]);
      var formatted = this.getFormattedValue(item, field);
      var stickyColumn = !isStacked && (this.isResponsive || this.stickyHeader) && field.stickyColumn; // We only uses the helper components for sticky columns to
      // improve performance of BTable/BTableLite by reducing the
      // total number of vue instances created during render

      var cellTag = stickyColumn ? isRowHeader ? __WEBPACK_IMPORTED_MODULE_12__th__["a" /* BTh */] : __WEBPACK_IMPORTED_MODULE_11__td__["a" /* BTd */] : isRowHeader ? 'th' : 'td';
      var cellVariant = item[__WEBPACK_IMPORTED_MODULE_13__constants__["c" /* FIELD_KEY_CELL_VARIANT */]] && item[__WEBPACK_IMPORTED_MODULE_13__constants__["c" /* FIELD_KEY_CELL_VARIANT */]][key] ? item[__WEBPACK_IMPORTED_MODULE_13__constants__["c" /* FIELD_KEY_CELL_VARIANT */]][key] : field.variant || null;
      var data = {
        // For the Vue key, we concatenate the column index and
        // field key (as field keys could be duplicated)
        // TODO: Although we do prevent duplicate field keys...
        //   So we could change this to: `row-${rowIndex}-cell-${key}`
        class: [field.class ? field.class : '', this.getTdValues(item, key, field.tdClass, '')],
        props: {},
        attrs: _objectSpread({
          'aria-colindex': String(colIndex + 1)
        }, isRowHeader ? this.getThValues(item, key, field.thAttr, 'row', {}) : this.getTdValues(item, key, field.tdAttr, {})),
        key: "row-".concat(rowIndex, "-cell-").concat(colIndex, "-").concat(key)
      };

      if (stickyColumn) {
        // We are using the helper BTd or BTh
        data.props = {
          stackedHeading: isStacked ? label : null,
          stickyColumn: true,
          variant: cellVariant
        };
      } else {
        // Using native TD or TH element, so we need to
        // add in the attributes and variant class
        data.attrs['data-label'] = isStacked && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["g" /* isUndefinedOrNull */])(label) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["a" /* toString */])(label) : null;
        data.attrs.role = isRowHeader ? 'rowheader' : 'cell';
        data.attrs.scope = isRowHeader ? 'row' : null; // Add in the variant class

        if (cellVariant) {
          data.class.push("".concat(this.dark ? 'bg' : 'table', "-").concat(cellVariant));
        }
      }

      var slotScope = {
        item: item,
        index: rowIndex,
        field: field,
        unformatted: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get__["b" /* get */])(item, key, ''),
        value: formatted,
        toggleDetails: this.toggleDetailsFactory(hasDetailsSlot, item),
        detailsShowing: Boolean(item[__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* FIELD_KEY_SHOW_DETAILS */]])
      }; // If table supports selectable mode, then add in the following scope
      // this.supportsSelectableRows will be undefined if mixin isn't loaded

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_safe_vue_instance__["a" /* safeVueInstance */])(this).supportsSelectableRows) {
        slotScope.rowSelected = this.isRowSelected(rowIndex);

        slotScope.selectRow = function () {
          return _this2.selectRow(rowIndex);
        };

        slotScope.unselectRow = function () {
          return _this2.unselectRow(rowIndex);
        };
      } // The new `v-slot` syntax doesn't like a slot name starting with
      // a square bracket and if using in-document HTML templates, the
      // v-slot attributes are lower-cased by the browser.
      // Switched to round bracket syntax to prevent confusion with
      // dynamic slot name syntax.
      // We look for slots in this order: `cell(${key})`, `cell(${key.toLowerCase()})`, 'cell()'
      // Slot names are now cached by mixin tbody in `this.$_bodyFieldSlotNameCache`
      // Will be `null` if no slot (or fallback slot) exists


      var slotName = this.$_bodyFieldSlotNameCache[key];
      var $childNodes = slotName ? this.normalizeSlot(slotName, slotScope) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["a" /* toString */])(formatted);

      if (this.isStacked) {
        // We wrap in a DIV to ensure rendered as a single cell when visually stacked!
        $childNodes = [h('div', [$childNodes])];
      } // Render either a td or th cell


      return h(cellTag, data, [$childNodes]);
    },
    // Renders an item's row (or rows if details supported)
    renderTbodyRow: function renderTbodyRow(item, rowIndex) {
      var _this3 = this;

      var _safeVueInstance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_safe_vue_instance__["a" /* safeVueInstance */])(this),
          fields = _safeVueInstance.computedFields,
          striped = _safeVueInstance.striped,
          primaryKey = _safeVueInstance.primaryKey,
          currentPage = _safeVueInstance.currentPage,
          perPage = _safeVueInstance.perPage,
          tbodyTrClass = _safeVueInstance.tbodyTrClass,
          tbodyTrAttr = _safeVueInstance.tbodyTrAttr,
          hasSelectableRowClick = _safeVueInstance.hasSelectableRowClick;

      var h = this.$createElement;
      var hasDetailsSlot = this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["k" /* SLOT_NAME_ROW_DETAILS */]);
      var rowShowDetails = item[__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* FIELD_KEY_SHOW_DETAILS */]] && hasDetailsSlot;
      var hasRowClickHandler = this.$listeners[__WEBPACK_IMPORTED_MODULE_1__constants_events__["G" /* EVENT_NAME_ROW_CLICKED */]] || hasSelectableRowClick; // We can return more than one TR if rowDetails enabled

      var $rows = []; // Details ID needed for `aria-details` when details showing
      // We set it to `null` when not showing so that attribute
      // does not appear on the element

      var detailsId = rowShowDetails ? this.safeId("_details_".concat(rowIndex, "_")) : null; // For each item data field in row

      var $tds = fields.map(function (field, colIndex) {
        return _this3.renderTbodyRowCell(field, colIndex, item, rowIndex);
      }); // Calculate the row number in the dataset (indexed from 1)

      var ariaRowIndex = null;

      if (currentPage && perPage && perPage > 0) {
        ariaRowIndex = String((currentPage - 1) * perPage + rowIndex + 1);
      } // Create a unique :key to help ensure that sub components are re-rendered rather than
      // re-used, which can cause issues. If a primary key is not provided we use the rendered
      // rows index within the tbody.
      // See: https://github.com/bootstrap-vue/bootstrap-vue/issues/2410


      var primaryKeyValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["a" /* toString */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_get__["b" /* get */])(item, primaryKey)) || null;
      var rowKey = primaryKeyValue || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_string__["a" /* toString */])(rowIndex); // If primary key is provided, use it to generate a unique ID on each tbody > tr
      // In the format of '{tableId}__row_{primaryKeyValue}'

      var rowId = primaryKeyValue ? this.safeId("_row_".concat(primaryKeyValue)) : null; // Selectable classes and attributes

      var selectableClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_safe_vue_instance__["a" /* safeVueInstance */])(this).selectableRowClasses ? this.selectableRowClasses(rowIndex) : {};
      var selectableAttrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_safe_vue_instance__["a" /* safeVueInstance */])(this).selectableRowAttrs ? this.selectableRowAttrs(rowIndex) : {}; // Additional classes and attributes

      var userTrClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(tbodyTrClass) ? tbodyTrClass(item, 'row') : tbodyTrClass;
      var userTrAttrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(tbodyTrAttr) ?
      /* istanbul ignore next */
      tbodyTrAttr(item, 'row') : tbodyTrAttr; // Add the item row

      $rows.push(h(__WEBPACK_IMPORTED_MODULE_10__tr__["a" /* BTr */], _defineProperty({
        class: [userTrClasses, selectableClasses, rowShowDetails ? 'b-table-has-details' : ''],
        props: {
          variant: item[__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* FIELD_KEY_ROW_VARIANT */]] || null
        },
        attrs: _objectSpread(_objectSpread({
          id: rowId
        }, userTrAttrs), {}, {
          // Users cannot override the following attributes
          tabindex: hasRowClickHandler ? '0' : null,
          'data-pk': primaryKeyValue || null,
          'aria-details': detailsId,
          'aria-owns': detailsId,
          'aria-rowindex': ariaRowIndex
        }, selectableAttrs),
        on: {
          // Note: These events are not A11Y friendly!
          mouseenter: this.rowHovered,
          mouseleave: this.rowUnhovered
        },
        key: "__b-table-row-".concat(rowKey, "__"),
        ref: 'item-rows'
      }, __WEBPACK_IMPORTED_MODULE_0__vue__["g" /* REF_FOR_KEY */], true), $tds)); // Row Details slot

      if (rowShowDetails) {
        var detailsScope = {
          item: item,
          index: rowIndex,
          fields: fields,
          toggleDetails: this.toggleDetailsFactory(hasDetailsSlot, item)
        }; // If table supports selectable mode, then add in the following scope
        // this.supportsSelectableRows will be undefined if mixin isn't loaded

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_safe_vue_instance__["a" /* safeVueInstance */])(this).supportsSelectableRows) {
          detailsScope.rowSelected = this.isRowSelected(rowIndex);

          detailsScope.selectRow = function () {
            return _this3.selectRow(rowIndex);
          };

          detailsScope.unselectRow = function () {
            return _this3.unselectRow(rowIndex);
          };
        } // Render the details slot in a TD


        var $details = h(__WEBPACK_IMPORTED_MODULE_11__td__["a" /* BTd */], {
          props: {
            colspan: fields.length
          },
          class: this.detailsTdClass
        }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_3__constants_slots__["k" /* SLOT_NAME_ROW_DETAILS */], detailsScope)]); // Add a hidden row to keep table row striping consistent when details showing
        // Only added if the table is striped

        if (striped) {
          $rows.push( // We don't use `BTr` here as we don't need the extra functionality
          h('tr', {
            staticClass: 'd-none',
            attrs: {
              'aria-hidden': 'true',
              role: 'presentation'
            },
            key: "__b-table-details-stripe__".concat(rowKey)
          }));
        } // Add the actual details row


        var userDetailsTrClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(this.tbodyTrClass) ?
        /* istanbul ignore next */
        this.tbodyTrClass(item, __WEBPACK_IMPORTED_MODULE_3__constants_slots__["k" /* SLOT_NAME_ROW_DETAILS */]) : this.tbodyTrClass;
        var userDetailsTrAttrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_inspect__["a" /* isFunction */])(this.tbodyTrAttr) ?
        /* istanbul ignore next */
        this.tbodyTrAttr(item, __WEBPACK_IMPORTED_MODULE_3__constants_slots__["k" /* SLOT_NAME_ROW_DETAILS */]) : this.tbodyTrAttr;
        $rows.push(h(__WEBPACK_IMPORTED_MODULE_10__tr__["a" /* BTr */], {
          staticClass: 'b-table-details',
          class: [userDetailsTrClasses],
          props: {
            variant: item[__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* FIELD_KEY_ROW_VARIANT */]] || null
          },
          attrs: _objectSpread(_objectSpread({}, userDetailsTrAttrs), {}, {
            // Users cannot override the following attributes
            id: detailsId,
            tabindex: '-1'
          }),
          key: "__b-table-details__".concat(rowKey)
        }, [$details]));
      } else if (hasDetailsSlot) {
        // Only add the placeholder if a the table has a row-details slot defined (but not shown)
        $rows.push(h());

        if (striped) {
          // Add extra placeholder if table is striped
          $rows.push(h());
        }
      } // Return the row(s)


      return $rows;
    }
  }
});

/***/ }),
/* 939 */
/* exports provided: props, topRowMixin */
/* exports used: props, topRowMixin */
/*!***********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/mixin-top-row.js ***!
  \***********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return topRowMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_slots__ = __webpack_require__(/*! ../../../constants/slots */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tr__ = __webpack_require__(/*! ../tr */ 92);



 // --- Props ---

var props = {}; // --- Mixin ---
// @vue/component

var topRowMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  methods: {
    renderTopRow: function renderTopRow() {
      var fields = this.computedFields,
          stacked = this.stacked,
          tbodyTrClass = this.tbodyTrClass,
          tbodyTrAttr = this.tbodyTrAttr;
      var h = this.$createElement; // Add static Top Row slot (hidden in visibly stacked mode as we can't control the data-label)
      // If in *always* stacked mode, we don't bother rendering the row

      if (!this.hasNormalizedSlot(__WEBPACK_IMPORTED_MODULE_1__constants_slots__["p" /* SLOT_NAME_TOP_ROW */]) || stacked === true || stacked === '') {
        return h();
      }

      return h(__WEBPACK_IMPORTED_MODULE_3__tr__["a" /* BTr */], {
        staticClass: 'b-table-top-row',
        class: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(tbodyTrClass) ? tbodyTrClass(null, 'row-top') : tbodyTrClass],
        attrs: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_inspect__["a" /* isFunction */])(tbodyTrAttr) ? tbodyTrAttr(null, 'row-top') : tbodyTrAttr,
        key: 'b-top-row'
      }, [this.normalizeSlot(__WEBPACK_IMPORTED_MODULE_1__constants_slots__["p" /* SLOT_NAME_TOP_ROW */], {
        columns: fields.length,
        fields: fields
      })]);
    }
  }
});

/***/ }),
/* 940 */
/* exports provided: normalizeFields */
/* exports used: normalizeFields */
/*!**************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/normalize-fields.js ***!
  \**************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeFields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_identity__ = __webpack_require__(/*! ../../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_string__ = __webpack_require__(/*! ../../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(/*! ./constants */ 176);




 // Private function to massage field entry into common object format

var processField = function processField(key, value) {
  var field = null;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["f" /* isString */])(value)) {
    // Label shortcut
    field = {
      key: key,
      label: value
    };
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["a" /* isFunction */])(value)) {
    // Formatter shortcut
    field = {
      key: key,
      formatter: value
    };
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["d" /* isObject */])(value)) {
    field = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b" /* clone */])(value);
    field.key = field.key || key;
  } else if (value !== false) {
    // Fallback to just key

    /* istanbul ignore next */
    field = {
      key: key
    };
  }

  return field;
}; // We normalize fields into an array of objects
// [ { key:..., label:..., ...}, {...}, ..., {..}]


var normalizeFields = function normalizeFields(origFields, items) {
  var fields = [];

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["c" /* isArray */])(origFields)) {
    // Normalize array Form
    origFields.filter(__WEBPACK_IMPORTED_MODULE_0__utils_identity__["a" /* identity */]).forEach(function (f) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["f" /* isString */])(f)) {
        fields.push({
          key: f,
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["e" /* startCase */])(f)
        });
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["d" /* isObject */])(f) && f.key && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["f" /* isString */])(f.key)) {
        // Full object definition. We use assign so that we don't mutate the original
        fields.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["b" /* clone */])(f));
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["d" /* isObject */])(f) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(f).length === 1) {
        // Shortcut object (i.e. { 'foo_bar': 'This is Foo Bar' }
        var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(f)[0];
        var field = processField(key, f[key]);

        if (field) {
          fields.push(field);
        }
      }
    });
  } // If no field provided, take a sample from first record (if exits)


  if (fields.length === 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["c" /* isArray */])(items) && items.length > 0) {
    var sample = items[0];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* keys */])(sample).forEach(function (k) {
      if (!__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* IGNORED_FIELD_KEYS */][k]) {
        fields.push({
          key: k,
          label: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["e" /* startCase */])(k)
        });
      }
    });
  } // Ensure we have a unique array of fields and that they have String labels


  var memo = {};
  return fields.filter(function (f) {
    if (!memo[f.key]) {
      memo[f.key] = true;
      f.label = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_inspect__["f" /* isString */])(f.label) ? f.label : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_string__["e" /* startCase */])(f.key);
      return true;
    }

    return false;
  });
};

/***/ }),
/* 941 */
/* exports provided: stringifyRecordValues */
/* exports used: stringifyRecordValues */
/*!*********************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/table/helpers/stringify-record-values.js ***!
  \*********************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stringifyRecordValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_stringify_object_values__ = __webpack_require__(/*! ../../../utils/stringify-object-values */ 467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sanitize_row__ = __webpack_require__(/*! ./sanitize-row */ 434);


 // Stringifies the values of a record, ignoring any special top level field keys
// TODO: Add option to stringify `scopedSlot` items

var stringifyRecordValues = function stringifyRecordValues(row, ignoreFields, includeFields, fieldsObj) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_inspect__["d" /* isObject */])(row) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_stringify_object_values__["a" /* stringifyObjectValues */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sanitize_row__["a" /* sanitizeRow */])(row, ignoreFields, includeFields, fieldsObj)) :
  /* istanbul ignore next */
  '';
};

/***/ }),
/* 942 */
/* exports provided: props, BVPopper */
/* exports used: BVPopper */
/*!*********************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/tooltip/helpers/bv-popper.js ***!
  \*********************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVPopper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(/*! popper.js */ 630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue__ = __webpack_require__(/*! ../../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_components__ = __webpack_require__(/*! ../../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_props__ = __webpack_require__(/*! ../../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_safe_types__ = __webpack_require__(/*! ../../../constants/safe-types */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_use_parent__ = __webpack_require__(/*! ../../../mixins/use-parent */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_props__ = __webpack_require__(/*! ../../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transition_bv_transition__ = __webpack_require__(/*! ../../transition/bv-transition */ 108);
// Base on-demand component for tooltip / popover templates
//
// Currently:
//   Responsible for positioning and transitioning the template
//   Templates are only instantiated when shown, and destroyed when hidden
//










 // --- Constants ---

var AttachmentMap = {
  AUTO: 'auto',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  TOPLEFT: 'top',
  TOPRIGHT: 'top',
  RIGHTTOP: 'right',
  RIGHTBOTTOM: 'right',
  BOTTOMLEFT: 'bottom',
  BOTTOMRIGHT: 'bottom',
  LEFTTOP: 'left',
  LEFTBOTTOM: 'left'
};
var OffsetMap = {
  AUTO: 0,
  TOPLEFT: -1,
  TOP: 0,
  TOPRIGHT: +1,
  RIGHTTOP: -1,
  RIGHT: 0,
  RIGHTBOTTOM: +1,
  BOTTOMLEFT: -1,
  BOTTOM: 0,
  BOTTOMRIGHT: +1,
  LEFTTOP: -1,
  LEFT: 0,
  LEFTBOTTOM: +1
}; // --- Props ---

var props = {
  // The minimum distance (in `px`) from the edge of the
  // tooltip/popover that the arrow can be positioned
  arrowPadding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 6),
  // 'scrollParent', 'viewport', 'window', or `Element`
  boundary: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_5__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */]], 'scrollParent'),
  // Tooltip/popover will try and stay away from
  // boundary edge by this many pixels
  boundaryPadding: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 5),
  fallbackPlacement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["d" /* PROP_TYPE_ARRAY_STRING */], 'flip'),
  offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["c" /* PROP_TYPE_NUMBER_STRING */], 0),
  placement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_4__constants_props__["b" /* PROP_TYPE_STRING */], 'top'),
  // Element that the tooltip/popover is positioned relative to
  target: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_5__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_5__constants_safe_types__["d" /* SVGElement */]])
}; // --- Main component ---
// @vue/component

var BVPopper = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_2__constants_components__["e" /* NAME_POPPER */],
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_use_parent__["a" /* useParentMixin */]],
  props: props,
  data: function data() {
    return {
      // reactive props set by parent
      noFade: false,
      // State related data
      localShow: true,
      attachment: this.getAttachment(this.placement)
    };
  },
  computed: {
    /* istanbul ignore next */
    templateType: function templateType() {
      // Overridden by template component
      return 'unknown';
    },
    popperConfig: function popperConfig() {
      var _this = this;

      var placement = this.placement;
      return {
        placement: this.getAttachment(placement),
        modifiers: {
          offset: {
            offset: this.getOffset(placement)
          },
          flip: {
            behavior: this.fallbackPlacement
          },
          // `arrow.element` can also be a reference to an HTML Element
          // maybe we should make this a `$ref` in the templates?
          arrow: {
            element: '.arrow'
          },
          preventOverflow: {
            padding: this.boundaryPadding,
            boundariesElement: this.boundary
          }
        },
        onCreate: function onCreate(data) {
          // Handle flipping arrow classes
          if (data.originalPlacement !== data.placement) {
            /* istanbul ignore next: can't test in JSDOM */
            _this.popperPlacementChange(data);
          }
        },
        onUpdate: function onUpdate(data) {
          // Handle flipping arrow classes
          _this.popperPlacementChange(data);
        }
      };
    }
  },
  created: function created() {
    var _this2 = this;

    // Note: We are created on-demand, and should be guaranteed that
    // DOM is rendered/ready by the time the created hook runs
    this.$_popper = null; // Ensure we show as we mount

    this.localShow = true; // Create popper instance before shown

    this.$on(__WEBPACK_IMPORTED_MODULE_3__constants_events__["a" /* EVENT_NAME_SHOW */], function (el) {
      _this2.popperCreate(el);
    }); // Self destruct handler

    var handleDestroy = function handleDestroy() {
      _this2.$nextTick(function () {
        // In a `requestAF()` to release control back to application
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["a" /* requestAF */])(function () {
          _this2.$destroy();
        });
      });
    }; // Self destruct if parent destroyed


    this.bvParent.$once(__WEBPACK_IMPORTED_MODULE_3__constants_events__["f" /* HOOK_EVENT_NAME_DESTROYED */], handleDestroy); // Self destruct after hidden

    this.$once(__WEBPACK_IMPORTED_MODULE_3__constants_events__["b" /* EVENT_NAME_HIDDEN */], handleDestroy);
  },
  beforeMount: function beforeMount() {
    // Ensure that the attachment position is correct before mounting
    // as our propsData is added after `new Template({...})`
    this.attachment = this.getAttachment(this.placement);
  },
  updated: function updated() {
    // Update popper if needed
    // TODO: Should this be a watcher on `this.popperConfig` instead?
    this.updatePopper();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyPopper();
  },
  destroyed: function destroyed() {
    // Make sure template is removed from DOM
    var el = this.$el;
    el && el.parentNode && el.parentNode.removeChild(el);
  },
  methods: {
    // "Public" method to trigger hide template
    hide: function hide() {
      this.localShow = false;
    },
    // Private
    getAttachment: function getAttachment(placement) {
      return AttachmentMap[String(placement).toUpperCase()] || 'auto';
    },
    getOffset: function getOffset(placement) {
      if (!this.offset) {
        // Could set a ref for the arrow element
        var arrow = this.$refs.arrow || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["h" /* select */])('.arrow', this.$el);
        var arrowOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["a" /* toFloat */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_dom__["o" /* getCS */])(arrow).width, 0) + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_number__["a" /* toFloat */])(this.arrowPadding, 0);

        switch (OffsetMap[String(placement).toUpperCase()] || 0) {
          /* istanbul ignore next: can't test in JSDOM */
          case +1:
            /* istanbul ignore next: can't test in JSDOM */
            return "+50%p - ".concat(arrowOffset, "px");

          /* istanbul ignore next: can't test in JSDOM */

          case -1:
            /* istanbul ignore next: can't test in JSDOM */
            return "-50%p + ".concat(arrowOffset, "px");

          default:
            return 0;
        }
      }
      /* istanbul ignore next */


      return this.offset;
    },
    popperCreate: function popperCreate(el) {
      this.destroyPopper(); // We use `el` rather than `this.$el` just in case the original
      // mountpoint root element type was changed by the template

      this.$_popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](this.target, el, this.popperConfig);
    },
    destroyPopper: function destroyPopper() {
      this.$_popper && this.$_popper.destroy();
      this.$_popper = null;
    },
    updatePopper: function updatePopper() {
      this.$_popper && this.$_popper.scheduleUpdate();
    },
    popperPlacementChange: function popperPlacementChange(data) {
      // Callback used by popper to adjust the arrow placement
      this.attachment = this.getAttachment(data.placement);
    },

    /* istanbul ignore next */
    renderTemplate: function renderTemplate(h) {
      // Will be overridden by templates
      return h('div');
    }
  },
  render: function render(h) {
    var _this3 = this;

    var noFade = this.noFade; // Note: 'show' and 'fade' classes are only appled during transition

    return h(__WEBPACK_IMPORTED_MODULE_10__transition_bv_transition__["a" /* BVTransition */], {
      // Transitions as soon as mounted
      props: {
        appear: true,
        noFade: noFade
      },
      on: {
        // Events used by parent component/instance
        beforeEnter: function beforeEnter(el) {
          return _this3.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["a" /* EVENT_NAME_SHOW */], el);
        },
        afterEnter: function afterEnter(el) {
          return _this3.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["d" /* EVENT_NAME_SHOWN */], el);
        },
        beforeLeave: function beforeLeave(el) {
          return _this3.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["e" /* EVENT_NAME_HIDE */], el);
        },
        afterLeave: function afterLeave(el) {
          return _this3.$emit(__WEBPACK_IMPORTED_MODULE_3__constants_events__["b" /* EVENT_NAME_HIDDEN */], el);
        }
      }
    }, [this.localShow ? this.renderTemplate(h) : h()]);
  }
});

/***/ }),
/* 943 */
/* exports provided: props, BVTransporter */
/* exports used: BVTransporter */
/*!*******************************************************************!*\
  !*** ./~/bootstrap-vue/esm/components/transporter/transporter.js ***!
  \*******************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVTransporter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_components__ = __webpack_require__(/*! ../../constants/components */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_env__ = __webpack_require__(/*! ../../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_props__ = __webpack_require__(/*! ../../constants/props */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_safe_types__ = __webpack_require__(/*! ../../constants/safe-types */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_array__ = __webpack_require__(/*! ../../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(/*! ../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_identity__ = __webpack_require__(/*! ../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_inspect__ = __webpack_require__(/*! ../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_normalize_slot__ = __webpack_require__(/*! ../../mixins/normalize-slot */ 15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_props__ = __webpack_require__(/*! ../../utils/props */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_create_new_child_component__ = __webpack_require__(/*! ../../utils/create-new-child-component */ 95);











 // --- Helper components ---
// BVTransporter/BVTransporterTarget:
//
// Single root node portaling of content, which retains parent/child hierarchy
// Unlike Portal-Vue where portaled content is no longer a descendent of its
// intended parent components
//
// Private components for use by Tooltips, Popovers and Modals
//
// Based on vue-simple-portal
// https://github.com/LinusBorg/vue-simple-portal
// Transporter target used by BVTransporter
// Supports only a single root element
// @vue/component

var BVTransporterTarget = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  // As an abstract component, it doesn't appear in the $parent chain of
  // components, which means the next parent of any component rendered inside
  // of this one will be the parent from which is was portal'd
  abstract: true,
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["Y" /* NAME_TRANSPORTER_TARGET */],
  props: {
    // Even though we only support a single root element,
    // VNodes are always passed as an array
    nodes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["p" /* PROP_TYPE_ARRAY_FUNCTION */])
  },
  data: function data(vm) {
    return {
      updatedNodes: vm.nodes
    };
  },
  destroyed: function destroyed() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["F" /* removeNode */])(this.$el);
  },
  render: function render(h) {
    var updatedNodes = this.updatedNodes;
    var $nodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["a" /* isFunction */])(updatedNodes) ? updatedNodes({}) : updatedNodes;
    $nodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])($nodes).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]);

    if ($nodes && $nodes.length > 0 && !$nodes[0].text) {
      return $nodes[0];
    }
    /* istanbul ignore next */


    return h();
  }
}); // --- Props ---

var props = {
  // String: CSS selector,
  // HTMLElement: Element reference
  // Mainly needed for tooltips/popovers inside modals
  container: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])([__WEBPACK_IMPORTED_MODULE_4__constants_safe_types__["c" /* HTMLElement */], __WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */]], 'body'),
  disabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["a" /* PROP_TYPE_BOOLEAN */], false),
  // This should be set to match the root element type
  tag: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_props__["a" /* makeProp */])(__WEBPACK_IMPORTED_MODULE_3__constants_props__["b" /* PROP_TYPE_STRING */], 'div')
}; // --- Main component ---
// @vue/component

var BVTransporterVue2 = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["Z" /* NAME_TRANSPORTER */],
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  watch: {
    disabled: {
      immediate: true,
      handler: function handler(disabled) {
        disabled ? this.unmountTarget() : this.$nextTick(this.mountTarget);
      }
    }
  },
  created: function created() {
    // Create private non-reactive props
    this.$_defaultFn = null;
    this.$_target = null;
  },
  beforeMount: function beforeMount() {
    this.mountTarget();
  },
  updated: function updated() {
    // We need to make sure that all children have completed updating
    // before rendering in the target
    // `vue-simple-portal` has the this in a `$nextTick()`,
    // while `portal-vue` doesn't
    // Just trying to see if the `$nextTick()` delay is required or not
    // Since all slots in Vue 2.6.x are always functions
    this.updateTarget();
  },
  beforeDestroy: function beforeDestroy() {
    this.unmountTarget();
    this.$_defaultFn = null;
  },
  methods: {
    // Get the element which the target should be appended to
    getContainer: function getContainer() {
      /* istanbul ignore else */
      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */]) {
        var container = this.container;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_inspect__["f" /* isString */])(container) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["h" /* select */])(container) : container;
      } else {
        return null;
      }
    },
    // Mount the target
    mountTarget: function mountTarget() {
      if (!this.$_target) {
        var $container = this.getContainer();

        if ($container) {
          var $el = document.createElement('div');
          $container.appendChild($el);
          this.$_target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_create_new_child_component__["a" /* createNewChildComponent */])(this, BVTransporterTarget, {
            el: $el,
            propsData: {
              // Initial nodes to be rendered
              nodes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(this.normalizeSlot())
            }
          });
        }
      }
    },
    // Update the content of the target
    updateTarget: function updateTarget() {
      if (__WEBPACK_IMPORTED_MODULE_2__constants_env__["e" /* IS_BROWSER */] && this.$_target) {
        var defaultFn = this.$scopedSlots.default;

        if (!this.disabled) {
          /* istanbul ignore else: only applicable in Vue 2.5.x */
          if (defaultFn && this.$_defaultFn !== defaultFn) {
            // We only update the target component if the scoped slot
            // function is a fresh one. The new slot syntax (since Vue 2.6)
            // can cache unchanged slot functions and we want to respect that here
            this.$_target.updatedNodes = defaultFn;
          } else if (!defaultFn) {
            // We also need to be back compatible with non-scoped default slot (i.e. 2.5.x)
            this.$_target.updatedNodes = this.$slots.default;
          }
        } // Update the scoped slot function cache


        this.$_defaultFn = defaultFn;
      }
    },
    // Unmount the target
    unmountTarget: function unmountTarget() {
      this.$_target && this.$_target.$destroy();
      this.$_target = null;
    }
  },
  render: function render(h) {
    // This component has no root element, so only a single VNode is allowed
    if (this.disabled) {
      var $nodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(this.normalizeSlot()).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]);

      if ($nodes.length > 0 && !$nodes[0].text) {
        return $nodes[0];
      }
    }

    return h();
  }
});
var BVTransporterVue3 = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  name: __WEBPACK_IMPORTED_MODULE_1__constants_components__["Z" /* NAME_TRANSPORTER */],
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_normalize_slot__["a" /* normalizeSlotMixin */]],
  props: props,
  render: function render(h) {
    if (this.disabled) {
      var $nodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_array__["b" /* concat */])(this.normalizeSlot()).filter(__WEBPACK_IMPORTED_MODULE_7__utils_identity__["a" /* identity */]);

      if ($nodes.length > 0) {
        return $nodes[0];
      }
    }

    return h(__WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].Teleport, {
      to: this.container
    }, this.normalizeSlot());
  }
});
var BVTransporter = __WEBPACK_IMPORTED_MODULE_0__vue__["c" /* isVue3 */] ? BVTransporterVue3 : BVTransporterVue2;

/***/ }),
/* 944 */
/* exports provided: CLASS_NAME_SHOW, CLASS_NAME_FADE */
/* exports used: CLASS_NAME_SHOW */
/*!**************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/classes.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLASS_NAME_SHOW; });
/* unused harmony export CLASS_NAME_FADE */
var CLASS_NAME_SHOW = 'show';
var CLASS_NAME_FADE = 'fade';

/***/ }),
/* 945 */
/* exports provided: PLACEMENT_TOP_START, PLACEMENT_TOP_END, PLACEMENT_BOTTOM_START, PLACEMENT_BOTTOM_END, PLACEMENT_RIGHT_START, PLACEMENT_RIGHT_END, PLACEMENT_LEFT_START, PLACEMENT_LEFT_END */
/* exports used: PLACEMENT_BOTTOM_START, PLACEMENT_TOP_END, PLACEMENT_TOP_START, PLACEMENT_RIGHT_START, PLACEMENT_LEFT_START, PLACEMENT_BOTTOM_END */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/constants/popper.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLACEMENT_TOP_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLACEMENT_TOP_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PLACEMENT_BOTTOM_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PLACEMENT_BOTTOM_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PLACEMENT_RIGHT_START; });
/* unused harmony export PLACEMENT_RIGHT_END */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PLACEMENT_LEFT_START; });
/* unused harmony export PLACEMENT_LEFT_END */
var PLACEMENT_TOP_START = 'top-start';
var PLACEMENT_TOP_END = 'top-end';
var PLACEMENT_BOTTOM_START = 'bottom-start';
var PLACEMENT_BOTTOM_END = 'bottom-end';
var PLACEMENT_RIGHT_START = 'right-start';
var PLACEMENT_RIGHT_END = 'right-end';
var PLACEMENT_LEFT_START = 'left-start';
var PLACEMENT_LEFT_END = 'left-end';

/***/ }),
/* 946 */
/* exports provided: directivesPlugin */
/* exports used: directivesPlugin */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/index.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return directivesPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(/*! ../utils/plugins */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hover__ = __webpack_require__(/*! ./hover */ 449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal__ = __webpack_require__(/*! ./modal */ 450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popover__ = __webpack_require__(/*! ./popover */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scrollspy__ = __webpack_require__(/*! ./scrollspy */ 452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toggle__ = __webpack_require__(/*! ./toggle */ 179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip__ = __webpack_require__(/*! ./tooltip */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__visible__ = __webpack_require__(/*! ./visible */ 455);







 // Main plugin for installing all directive plugins

var directivesPlugin = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["b" /* pluginFactory */])({
  plugins: {
    VBHoverPlugin: __WEBPACK_IMPORTED_MODULE_1__hover__["a" /* VBHoverPlugin */],
    VBModalPlugin: __WEBPACK_IMPORTED_MODULE_2__modal__["a" /* VBModalPlugin */],
    VBPopoverPlugin: __WEBPACK_IMPORTED_MODULE_3__popover__["a" /* VBPopoverPlugin */],
    VBScrollspyPlugin: __WEBPACK_IMPORTED_MODULE_4__scrollspy__["a" /* VBScrollspyPlugin */],
    VBTogglePlugin: __WEBPACK_IMPORTED_MODULE_5__toggle__["a" /* VBTogglePlugin */],
    VBTooltipPlugin: __WEBPACK_IMPORTED_MODULE_6__tooltip__["a" /* VBTooltipPlugin */],
    VBVisiblePlugin: __WEBPACK_IMPORTED_MODULE_7__visible__["a" /* VBVisiblePlugin */]
  }
});

/***/ }),
/* 947 */
/* exports provided: BVScrollspy */
/* exports used: BVScrollspy */
/*!********************************************************************************!*\
  !*** ./~/bootstrap-vue/esm/directives/scrollspy/helpers/bv-scrollspy.class.js ***!
  \********************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BVScrollspy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_events__ = __webpack_require__(/*! ../../../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_regex__ = __webpack_require__(/*! ../../../constants/regex */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(/*! ../../../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__(/*! ../../../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_identity__ = __webpack_require__(/*! ../../../utils/identity */ 28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_inspect__ = __webpack_require__(/*! ../../../utils/inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_math__ = __webpack_require__(/*! ../../../utils/math */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_number__ = __webpack_require__(/*! ../../../utils/number */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(/*! ../../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_observe_dom__ = __webpack_require__(/*! ../../../utils/observe-dom */ 185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_warn__ = __webpack_require__(/*! ../../../utils/warn */ 54);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/*
 * Scrollspy class definition
 */











/*
 * Constants / Defaults
 */

var NAME = 'v-b-scrollspy';
var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var CLASS_NAME_ACTIVE = 'active';
var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var SELECTOR_NAV_LINKS = '.nav-link';
var SELECTOR_NAV_ITEMS = '.nav-item';
var SELECTOR_LIST_ITEMS = '.list-group-item';
var SELECTOR_DROPDOWN = '.dropdown, .dropup';
var SELECTOR_DROPDOWN_ITEMS = '.dropdown-item';
var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var ROOT_EVENT_NAME_ACTIVATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["a" /* getRootEventName */])('BVScrollspy', 'activate');
var METHOD_OFFSET = 'offset';
var METHOD_POSITION = 'position';
var Default = {
  element: 'body',
  offset: 10,
  method: 'auto',
  throttle: 75
};
var DefaultType = {
  element: '(string|element|component)',
  offset: 'number',
  method: 'string',
  throttle: 'number'
}; // Transition Events

var TransitionEndEvents = ['webkitTransitionEnd', 'transitionend', 'otransitionend', 'oTransitionEnd'];
/*
 * Utility Methods
 */
// Better var type detection

var toType = function toType(obj)
/* istanbul ignore next: not easy to test */
{
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["j" /* toString */])(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}; // Check config properties for expected types

/* istanbul ignore next */


var typeCheckConfig = function typeCheckConfig(componentName, config, configTypes)
/* istanbul ignore next: not easy to test */
{
  for (var property in configTypes) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["c" /* hasOwnProperty */])(configTypes, property)) {
      var expectedTypes = configTypes[property];
      var value = config[property];
      var valueType = value && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e" /* isElement */])(value) ? 'element' : toType(value); // handle Vue instances

      valueType = value && value._isVue ? 'component' : valueType;

      if (!new RegExp(expectedTypes).test(valueType)) {
        /* istanbul ignore next */
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_warn__["a" /* warn */])("".concat(componentName, ": Option \"").concat(property, "\" provided type \"").concat(valueType, "\" but expected type \"").concat(expectedTypes, "\""));
      }
    }
  }
};
/*
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

/* istanbul ignore next: not easy to test */


var BVScrollspy
/* istanbul ignore next: not easy to test */
= /*#__PURE__*/function () {
  function BVScrollspy(element, config, $root) {
    _classCallCheck(this, BVScrollspy);

    // The element we activate links in
    this.$el = element;
    this.$scroller = null;
    this.$selector = [SELECTOR_NAV_LINKS, SELECTOR_LIST_ITEMS, SELECTOR_DROPDOWN_ITEMS].join(',');
    this.$offsets = [];
    this.$targets = [];
    this.$activeTarget = null;
    this.$scrollHeight = 0;
    this.$resizeTimeout = null;
    this.$scrollerObserver = null;
    this.$targetsObserver = null;
    this.$root = $root || null;
    this.$config = null;
    this.updateConfig(config);
  }

  _createClass(BVScrollspy, [{
    key: "updateConfig",
    value: function updateConfig(config, $root) {
      if (this.$scroller) {
        // Just in case out scroll element has changed
        this.unlisten();
        this.$scroller = null;
      }

      var cfg = _objectSpread(_objectSpread({}, this.constructor.Default), config);

      if ($root) {
        this.$root = $root;
      }

      typeCheckConfig(this.constructor.Name, cfg, this.constructor.DefaultType);
      this.$config = cfg;

      if (this.$root) {
        var self = this;
        this.$root.$nextTick(function () {
          self.listen();
        });
      } else {
        this.listen();
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.unlisten();
      clearTimeout(this.$resizeTimeout);
      this.$resizeTimeout = null;
      this.$el = null;
      this.$config = null;
      this.$scroller = null;
      this.$selector = null;
      this.$offsets = null;
      this.$targets = null;
      this.$activeTarget = null;
      this.$scrollHeight = null;
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;

      var scroller = this.getScroller();

      if (scroller && scroller.tagName !== 'BODY') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* eventOn */])(scroller, 'scroll', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* eventOn */])(window, 'scroll', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* eventOn */])(window, 'resize', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* eventOn */])(window, 'orientationchange', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      TransitionEndEvents.forEach(function (eventName) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* eventOn */])(window, eventName, _this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      });
      this.setObservers(true); // Schedule a refresh

      this.handleEvent('refresh');
    }
  }, {
    key: "unlisten",
    value: function unlisten() {
      var _this2 = this;

      var scroller = this.getScroller();
      this.setObservers(false);

      if (scroller && scroller.tagName !== 'BODY') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["c" /* eventOff */])(scroller, 'scroll', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["c" /* eventOff */])(window, 'scroll', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["c" /* eventOff */])(window, 'resize', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["c" /* eventOff */])(window, 'orientationchange', this, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      TransitionEndEvents.forEach(function (eventName) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["c" /* eventOff */])(window, eventName, _this2, __WEBPACK_IMPORTED_MODULE_0__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      });
    }
  }, {
    key: "setObservers",
    value: function setObservers(on) {
      var _this3 = this;

      // We observe both the scroller for content changes, and the target links
      this.$scrollerObserver && this.$scrollerObserver.disconnect();
      this.$targetsObserver && this.$targetsObserver.disconnect();
      this.$scrollerObserver = null;
      this.$targetsObserver = null;

      if (on) {
        this.$targetsObserver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_observe_dom__["a" /* observeDom */])(this.$el, function () {
          _this3.handleEvent('mutation');
        }, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['href']
        });
        this.$scrollerObserver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_observe_dom__["a" /* observeDom */])(this.getScroller(), function () {
          _this3.handleEvent('mutation');
        }, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['id', 'style', 'class']
        });
      }
    } // General event handler

  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["f" /* isString */])(event) ? event : event.type;
      var self = this;

      var resizeThrottle = function resizeThrottle() {
        if (!self.$resizeTimeout) {
          self.$resizeTimeout = setTimeout(function () {
            self.refresh();
            self.process();
            self.$resizeTimeout = null;
          }, self.$config.throttle);
        }
      };

      if (type === 'scroll') {
        if (!this.$scrollerObserver) {
          // Just in case we are added to the DOM before the scroll target is
          // We re-instantiate our listeners, just in case
          this.listen();
        }

        this.process();
      } else if (/(resize|orientationchange|mutation|refresh)/.test(type)) {
        // Postpone these events by throttle time
        resizeThrottle();
      }
    } // Refresh the list of target links on the element we are applied to

  }, {
    key: "refresh",
    value: function refresh() {
      var _this4 = this;

      var scroller = this.getScroller();

      if (!scroller) {
        return;
      }

      var autoMethod = scroller !== scroller.window ? METHOD_POSITION : METHOD_OFFSET;
      var method = this.$config.method === 'auto' ? autoMethod : this.$config.method;
      var methodFn = method === METHOD_POSITION ? __WEBPACK_IMPORTED_MODULE_2__utils_dom__["u" /* position */] : __WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* offset */];
      var offsetBase = method === METHOD_POSITION ? this.getScrollTop() : 0;
      this.$offsets = [];
      this.$targets = [];
      this.$scrollHeight = this.getScrollHeight(); // Find all the unique link HREFs that we will control

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["w" /* selectAll */])(this.$selector, this.$el) // Get HREF value
      .map(function (link) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["i" /* getAttr */])(link, 'href');
      }) // Filter out HREFs that do not match our RegExp
      .filter(function (href) {
        return href && __WEBPACK_IMPORTED_MODULE_1__constants_regex__["p" /* RX_HREF */].test(href || '');
      }) // Find all elements with ID that match HREF hash
      .map(function (href) {
        // Convert HREF into an ID (including # at beginning)
        var id = href.replace(__WEBPACK_IMPORTED_MODULE_1__constants_regex__["p" /* RX_HREF */], '$1').trim();

        if (!id) {
          return null;
        } // Find the element with the ID specified by id


        var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["h" /* select */])(id, scroller);

        if (el && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c" /* isVisible */])(el)) {
          return {
            offset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_number__["b" /* toInteger */])(methodFn(el).top, 0) + offsetBase,
            target: id
          };
        }

        return null;
      }).filter(__WEBPACK_IMPORTED_MODULE_4__utils_identity__["a" /* identity */]) // Sort them by their offsets (smallest first)
      .sort(function (a, b) {
        return a.offset - b.offset;
      }) // record only unique targets/offsets
      .reduce(function (memo, item) {
        if (!memo[item.target]) {
          _this4.$offsets.push(item.offset);

          _this4.$targets.push(item.target);

          memo[item.target] = true;
        }

        return memo;
      }, {}); // Return this for easy chaining

      return this;
    } // Handle activating/clearing

  }, {
    key: "process",
    value: function process() {
      var scrollTop = this.getScrollTop() + this.$config.offset;
      var scrollHeight = this.getScrollHeight();
      var maxScroll = this.$config.offset + scrollHeight - this.getOffsetHeight();

      if (this.$scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this.$targets[this.$targets.length - 1];

        if (this.$activeTarget !== target) {
          this.activate(target);
        }

        return;
      }

      if (this.$activeTarget && scrollTop < this.$offsets[0] && this.$offsets[0] > 0) {
        this.$activeTarget = null;
        this.clear();
        return;
      }

      for (var i = this.$offsets.length; i--;) {
        var isActiveTarget = this.$activeTarget !== this.$targets[i] && scrollTop >= this.$offsets[i] && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["i" /* isUndefined */])(this.$offsets[i + 1]) || scrollTop < this.$offsets[i + 1]);

        if (isActiveTarget) {
          this.activate(this.$targets[i]);
        }
      }
    }
  }, {
    key: "getScroller",
    value: function getScroller() {
      if (this.$scroller) {
        return this.$scroller;
      }

      var scroller = this.$config.element;

      if (!scroller) {
        return null;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e" /* isElement */])(scroller.$el)) {
        scroller = scroller.$el;
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_inspect__["f" /* isString */])(scroller)) {
        scroller = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["h" /* select */])(scroller);
      }

      if (!scroller) {
        return null;
      }

      this.$scroller = scroller.tagName === 'BODY' ? window : scroller;
      return this.$scroller;
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      var scroller = this.getScroller();
      return scroller === window ? scroller.pageYOffset : scroller.scrollTop;
    }
  }, {
    key: "getScrollHeight",
    value: function getScrollHeight() {
      return this.getScroller().scrollHeight || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_math__["a" /* mathMax */])(document.body.scrollHeight, document.documentElement.scrollHeight);
    }
  }, {
    key: "getOffsetHeight",
    value: function getOffsetHeight() {
      var scroller = this.getScroller();
      return scroller === window ? window.innerHeight : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["x" /* getBCR */])(scroller).height;
    }
  }, {
    key: "activate",
    value: function activate(target) {
      var _this5 = this;

      this.$activeTarget = target;
      this.clear(); // Grab the list of target links (<a href="{$target}">)

      var links = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["w" /* selectAll */])(this.$selector // Split out the base selectors
      .split(',') // Map to a selector that matches links with HREF ending in the ID (including '#')
      .map(function (selector) {
        return "".concat(selector, "[href$=\"").concat(target, "\"]");
      }) // Join back into a single selector string
      .join(','), this.$el);
      links.forEach(function (link) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["g" /* hasClass */])(link, CLASS_NAME_DROPDOWN_ITEM)) {
          // This is a dropdown item, so find the .dropdown-toggle and set its state
          var dropdown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["f" /* closest */])(SELECTOR_DROPDOWN, link);

          if (dropdown) {
            _this5.setActiveState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["h" /* select */])(SELECTOR_DROPDOWN_TOGGLE, dropdown), true);
          } // Also set this link's state


          _this5.setActiveState(link, true);
        } else {
          // Set triggered link as active
          _this5.setActiveState(link, true);

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["y" /* matches */])(link.parentElement, SELECTOR_NAV_ITEMS)) {
            // Handle nav-link inside nav-item, and set nav-item active
            _this5.setActiveState(link.parentElement, true);
          } // Set triggered links parents as active
          // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor


          var el = link;

          while (el) {
            el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["f" /* closest */])(SELECTOR_NAV_LIST_GROUP, el);
            var sibling = el ? el.previousElementSibling : null;

            if (sibling && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["y" /* matches */])(sibling, "".concat(SELECTOR_NAV_LINKS, ", ").concat(SELECTOR_LIST_ITEMS))) {
              _this5.setActiveState(sibling, true);
            } // Handle special case where nav-link is inside a nav-item


            if (sibling && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["y" /* matches */])(sibling, SELECTOR_NAV_ITEMS)) {
              _this5.setActiveState(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["h" /* select */])(SELECTOR_NAV_LINKS, sibling), true); // Add active state to nav-item as well


              _this5.setActiveState(sibling, true);
            }
          }
        }
      }); // Signal event to via $root, passing ID of activated target and reference to array of links

      if (links && links.length > 0 && this.$root) {
        this.$root.$emit(ROOT_EVENT_NAME_ACTIVATE, target, links);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this6 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["w" /* selectAll */])("".concat(this.$selector, ", ").concat(SELECTOR_NAV_ITEMS), this.$el).filter(function (el) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["g" /* hasClass */])(el, CLASS_NAME_ACTIVE);
      }).forEach(function (el) {
        return _this6.setActiveState(el, false);
      });
    }
  }, {
    key: "setActiveState",
    value: function setActiveState(el, active) {
      if (!el) {
        return;
      }

      if (active) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["r" /* addClass */])(el, CLASS_NAME_ACTIVE);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["q" /* removeClass */])(el, CLASS_NAME_ACTIVE);
      }
    }
  }], [{
    key: "Name",
    get: function get() {
      return NAME;
    }
  }, {
    key: "Default",
    get: function get() {
      return Default;
    }
  }, {
    key: "DefaultType",
    get: function get() {
      return DefaultType;
    }
  }]);

  return BVScrollspy;
}();

/***/ }),
/* 948 */
/* exports provided: makeIcon */
/* exports used: makeIcon */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/icons/helpers/make-icon.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(/*! ../../utils/object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_string__ = __webpack_require__(/*! ../../utils/string */ 23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_base__ = __webpack_require__(/*! ./icon-base */ 249);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var iconProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["m" /* omit */])(__WEBPACK_IMPORTED_MODULE_3__icon_base__["a" /* props */], ['content']);
/**
 * Icon component generator function
 *
 * @param {string} icon name (minus the leading `BIcon`)
 * @param {string} raw `innerHTML` for SVG
 * @return {VueComponent}
 */

var makeIcon = function makeIcon(name, content) {
  // For performance reason we pre-compute some values, so that
  // they are not computed on each render of the icon component
  var kebabName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_string__["b" /* kebabCase */])(name);
  var iconName = "BIcon".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_string__["j" /* pascalCase */])(name));
  var iconNameClass = "bi-".concat(kebabName);
  var iconTitle = kebabName.replace(/-/g, ' ');
  var svgContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_string__["f" /* trim */])(content || '');
  return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
    name: iconName,
    functional: true,
    props: iconProps,
    render: function render(h, _ref) {
      var data = _ref.data,
          props = _ref.props;
      return h(__WEBPACK_IMPORTED_MODULE_3__icon_base__["b" /* BVIconBase */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["f" /* mergeData */])( // Defaults
      {
        props: {
          title: iconTitle
        },
        attrs: {
          'aria-label': iconTitle
        }
      }, // User data
      data, // Required data
      {
        staticClass: iconNameClass,
        props: _objectSpread(_objectSpread({}, props), {}, {
          content: svgContent
        })
      }));
    }
  });
};

/***/ }),
/* 949 */
/* exports provided: BIconBlank, BIconAlarm, BIconAlarmFill, BIconAlignBottom, BIconAlignCenter, BIconAlignEnd, BIconAlignMiddle, BIconAlignStart, BIconAlignTop, BIconAlt, BIconApp, BIconAppIndicator, BIconArchive, BIconArchiveFill, BIconArrow90degDown, BIconArrow90degLeft, BIconArrow90degRight, BIconArrow90degUp, BIconArrowBarDown, BIconArrowBarLeft, BIconArrowBarRight, BIconArrowBarUp, BIconArrowClockwise, BIconArrowCounterclockwise, BIconArrowDown, BIconArrowDownCircle, BIconArrowDownCircleFill, BIconArrowDownLeft, BIconArrowDownLeftCircle, BIconArrowDownLeftCircleFill, BIconArrowDownLeftSquare, BIconArrowDownLeftSquareFill, BIconArrowDownRight, BIconArrowDownRightCircle, BIconArrowDownRightCircleFill, BIconArrowDownRightSquare, BIconArrowDownRightSquareFill, BIconArrowDownShort, BIconArrowDownSquare, BIconArrowDownSquareFill, BIconArrowDownUp, BIconArrowLeft, BIconArrowLeftCircle, BIconArrowLeftCircleFill, BIconArrowLeftRight, BIconArrowLeftShort, BIconArrowLeftSquare, BIconArrowLeftSquareFill, BIconArrowRepeat, BIconArrowReturnLeft, BIconArrowReturnRight, BIconArrowRight, BIconArrowRightCircle, BIconArrowRightCircleFill, BIconArrowRightShort, BIconArrowRightSquare, BIconArrowRightSquareFill, BIconArrowUp, BIconArrowUpCircle, BIconArrowUpCircleFill, BIconArrowUpLeft, BIconArrowUpLeftCircle, BIconArrowUpLeftCircleFill, BIconArrowUpLeftSquare, BIconArrowUpLeftSquareFill, BIconArrowUpRight, BIconArrowUpRightCircle, BIconArrowUpRightCircleFill, BIconArrowUpRightSquare, BIconArrowUpRightSquareFill, BIconArrowUpShort, BIconArrowUpSquare, BIconArrowUpSquareFill, BIconArrowsAngleContract, BIconArrowsAngleExpand, BIconArrowsCollapse, BIconArrowsExpand, BIconArrowsFullscreen, BIconArrowsMove, BIconAspectRatio, BIconAspectRatioFill, BIconAsterisk, BIconAt, BIconAward, BIconAwardFill, BIconBack, BIconBackspace, BIconBackspaceFill, BIconBackspaceReverse, BIconBackspaceReverseFill, BIconBadge3d, BIconBadge3dFill, BIconBadge4k, BIconBadge4kFill, BIconBadge8k, BIconBadge8kFill, BIconBadgeAd, BIconBadgeAdFill, BIconBadgeAr, BIconBadgeArFill, BIconBadgeCc, BIconBadgeCcFill, BIconBadgeHd, BIconBadgeHdFill, BIconBadgeTm, BIconBadgeTmFill, BIconBadgeVo, BIconBadgeVoFill, BIconBadgeVr, BIconBadgeVrFill, BIconBadgeWc, BIconBadgeWcFill, BIconBag, BIconBagCheck, BIconBagCheckFill, BIconBagDash, BIconBagDashFill, BIconBagFill, BIconBagPlus, BIconBagPlusFill, BIconBagX, BIconBagXFill, BIconBank, BIconBank2, BIconBarChart, BIconBarChartFill, BIconBarChartLine, BIconBarChartLineFill, BIconBarChartSteps, BIconBasket, BIconBasket2, BIconBasket2Fill, BIconBasket3, BIconBasket3Fill, BIconBasketFill, BIconBattery, BIconBatteryCharging, BIconBatteryFull, BIconBatteryHalf, BIconBell, BIconBellFill, BIconBellSlash, BIconBellSlashFill, BIconBezier, BIconBezier2, BIconBicycle, BIconBinoculars, BIconBinocularsFill, BIconBlockquoteLeft, BIconBlockquoteRight, BIconBook, BIconBookFill, BIconBookHalf, BIconBookmark, BIconBookmarkCheck, BIconBookmarkCheckFill, BIconBookmarkDash, BIconBookmarkDashFill, BIconBookmarkFill, BIconBookmarkHeart, BIconBookmarkHeartFill, BIconBookmarkPlus, BIconBookmarkPlusFill, BIconBookmarkStar, BIconBookmarkStarFill, BIconBookmarkX, BIconBookmarkXFill, BIconBookmarks, BIconBookmarksFill, BIconBookshelf, BIconBootstrap, BIconBootstrapFill, BIconBootstrapReboot, BIconBorder, BIconBorderAll, BIconBorderBottom, BIconBorderCenter, BIconBorderInner, BIconBorderLeft, BIconBorderMiddle, BIconBorderOuter, BIconBorderRight, BIconBorderStyle, BIconBorderTop, BIconBorderWidth, BIconBoundingBox, BIconBoundingBoxCircles, BIconBox, BIconBoxArrowDown, BIconBoxArrowDownLeft, BIconBoxArrowDownRight, BIconBoxArrowInDown, BIconBoxArrowInDownLeft, BIconBoxArrowInDownRight, BIconBoxArrowInLeft, BIconBoxArrowInRight, BIconBoxArrowInUp, BIconBoxArrowInUpLeft, BIconBoxArrowInUpRight, BIconBoxArrowLeft, BIconBoxArrowRight, BIconBoxArrowUp, BIconBoxArrowUpLeft, BIconBoxArrowUpRight, BIconBoxSeam, BIconBraces, BIconBricks, BIconBriefcase, BIconBriefcaseFill, BIconBrightnessAltHigh, BIconBrightnessAltHighFill, BIconBrightnessAltLow, BIconBrightnessAltLowFill, BIconBrightnessHigh, BIconBrightnessHighFill, BIconBrightnessLow, BIconBrightnessLowFill, BIconBroadcast, BIconBroadcastPin, BIconBrush, BIconBrushFill, BIconBucket, BIconBucketFill, BIconBug, BIconBugFill, BIconBuilding, BIconBullseye, BIconCalculator, BIconCalculatorFill, BIconCalendar, BIconCalendar2, BIconCalendar2Check, BIconCalendar2CheckFill, BIconCalendar2Date, BIconCalendar2DateFill, BIconCalendar2Day, BIconCalendar2DayFill, BIconCalendar2Event, BIconCalendar2EventFill, BIconCalendar2Fill, BIconCalendar2Minus, BIconCalendar2MinusFill, BIconCalendar2Month, BIconCalendar2MonthFill, BIconCalendar2Plus, BIconCalendar2PlusFill, BIconCalendar2Range, BIconCalendar2RangeFill, BIconCalendar2Week, BIconCalendar2WeekFill, BIconCalendar2X, BIconCalendar2XFill, BIconCalendar3, BIconCalendar3Event, BIconCalendar3EventFill, BIconCalendar3Fill, BIconCalendar3Range, BIconCalendar3RangeFill, BIconCalendar3Week, BIconCalendar3WeekFill, BIconCalendar4, BIconCalendar4Event, BIconCalendar4Range, BIconCalendar4Week, BIconCalendarCheck, BIconCalendarCheckFill, BIconCalendarDate, BIconCalendarDateFill, BIconCalendarDay, BIconCalendarDayFill, BIconCalendarEvent, BIconCalendarEventFill, BIconCalendarFill, BIconCalendarMinus, BIconCalendarMinusFill, BIconCalendarMonth, BIconCalendarMonthFill, BIconCalendarPlus, BIconCalendarPlusFill, BIconCalendarRange, BIconCalendarRangeFill, BIconCalendarWeek, BIconCalendarWeekFill, BIconCalendarX, BIconCalendarXFill, BIconCamera, BIconCamera2, BIconCameraFill, BIconCameraReels, BIconCameraReelsFill, BIconCameraVideo, BIconCameraVideoFill, BIconCameraVideoOff, BIconCameraVideoOffFill, BIconCapslock, BIconCapslockFill, BIconCardChecklist, BIconCardHeading, BIconCardImage, BIconCardList, BIconCardText, BIconCaretDown, BIconCaretDownFill, BIconCaretDownSquare, BIconCaretDownSquareFill, BIconCaretLeft, BIconCaretLeftFill, BIconCaretLeftSquare, BIconCaretLeftSquareFill, BIconCaretRight, BIconCaretRightFill, BIconCaretRightSquare, BIconCaretRightSquareFill, BIconCaretUp, BIconCaretUpFill, BIconCaretUpSquare, BIconCaretUpSquareFill, BIconCart, BIconCart2, BIconCart3, BIconCart4, BIconCartCheck, BIconCartCheckFill, BIconCartDash, BIconCartDashFill, BIconCartFill, BIconCartPlus, BIconCartPlusFill, BIconCartX, BIconCartXFill, BIconCash, BIconCashCoin, BIconCashStack, BIconCast, BIconChat, BIconChatDots, BIconChatDotsFill, BIconChatFill, BIconChatLeft, BIconChatLeftDots, BIconChatLeftDotsFill, BIconChatLeftFill, BIconChatLeftQuote, BIconChatLeftQuoteFill, BIconChatLeftText, BIconChatLeftTextFill, BIconChatQuote, BIconChatQuoteFill, BIconChatRight, BIconChatRightDots, BIconChatRightDotsFill, BIconChatRightFill, BIconChatRightQuote, BIconChatRightQuoteFill, BIconChatRightText, BIconChatRightTextFill, BIconChatSquare, BIconChatSquareDots, BIconChatSquareDotsFill, BIconChatSquareFill, BIconChatSquareQuote, BIconChatSquareQuoteFill, BIconChatSquareText, BIconChatSquareTextFill, BIconChatText, BIconChatTextFill, BIconCheck, BIconCheck2, BIconCheck2All, BIconCheck2Circle, BIconCheck2Square, BIconCheckAll, BIconCheckCircle, BIconCheckCircleFill, BIconCheckLg, BIconCheckSquare, BIconCheckSquareFill, BIconChevronBarContract, BIconChevronBarDown, BIconChevronBarExpand, BIconChevronBarLeft, BIconChevronBarRight, BIconChevronBarUp, BIconChevronCompactDown, BIconChevronCompactLeft, BIconChevronCompactRight, BIconChevronCompactUp, BIconChevronContract, BIconChevronDoubleDown, BIconChevronDoubleLeft, BIconChevronDoubleRight, BIconChevronDoubleUp, BIconChevronDown, BIconChevronExpand, BIconChevronLeft, BIconChevronRight, BIconChevronUp, BIconCircle, BIconCircleFill, BIconCircleHalf, BIconCircleSquare, BIconClipboard, BIconClipboardCheck, BIconClipboardData, BIconClipboardMinus, BIconClipboardPlus, BIconClipboardX, BIconClock, BIconClockFill, BIconClockHistory, BIconCloud, BIconCloudArrowDown, BIconCloudArrowDownFill, BIconCloudArrowUp, BIconCloudArrowUpFill, BIconCloudCheck, BIconCloudCheckFill, BIconCloudDownload, BIconCloudDownloadFill, BIconCloudDrizzle, BIconCloudDrizzleFill, BIconCloudFill, BIconCloudFog, BIconCloudFog2, BIconCloudFog2Fill, BIconCloudFogFill, BIconCloudHail, BIconCloudHailFill, BIconCloudHaze, BIconCloudHaze1, BIconCloudHaze2Fill, BIconCloudHazeFill, BIconCloudLightning, BIconCloudLightningFill, BIconCloudLightningRain, BIconCloudLightningRainFill, BIconCloudMinus, BIconCloudMinusFill, BIconCloudMoon, BIconCloudMoonFill, BIconCloudPlus, BIconCloudPlusFill, BIconCloudRain, BIconCloudRainFill, BIconCloudRainHeavy, BIconCloudRainHeavyFill, BIconCloudSlash, BIconCloudSlashFill, BIconCloudSleet, BIconCloudSleetFill, BIconCloudSnow, BIconCloudSnowFill, BIconCloudSun, BIconCloudSunFill, BIconCloudUpload, BIconCloudUploadFill, BIconClouds, BIconCloudsFill, BIconCloudy, BIconCloudyFill, BIconCode, BIconCodeSlash, BIconCodeSquare, BIconCoin, BIconCollection, BIconCollectionFill, BIconCollectionPlay, BIconCollectionPlayFill, BIconColumns, BIconColumnsGap, BIconCommand, BIconCompass, BIconCompassFill, BIconCone, BIconConeStriped, BIconController, BIconCpu, BIconCpuFill, BIconCreditCard, BIconCreditCard2Back, BIconCreditCard2BackFill, BIconCreditCard2Front, BIconCreditCard2FrontFill, BIconCreditCardFill, BIconCrop, BIconCup, BIconCupFill, BIconCupStraw, BIconCurrencyBitcoin, BIconCurrencyDollar, BIconCurrencyEuro, BIconCurrencyExchange, BIconCurrencyPound, BIconCurrencyYen, BIconCursor, BIconCursorFill, BIconCursorText, BIconDash, BIconDashCircle, BIconDashCircleDotted, BIconDashCircleFill, BIconDashLg, BIconDashSquare, BIconDashSquareDotted, BIconDashSquareFill, BIconDiagram2, BIconDiagram2Fill, BIconDiagram3, BIconDiagram3Fill, BIconDiamond, BIconDiamondFill, BIconDiamondHalf, BIconDice1, BIconDice1Fill, BIconDice2, BIconDice2Fill, BIconDice3, BIconDice3Fill, BIconDice4, BIconDice4Fill, BIconDice5, BIconDice5Fill, BIconDice6, BIconDice6Fill, BIconDisc, BIconDiscFill, BIconDiscord, BIconDisplay, BIconDisplayFill, BIconDistributeHorizontal, BIconDistributeVertical, BIconDoorClosed, BIconDoorClosedFill, BIconDoorOpen, BIconDoorOpenFill, BIconDot, BIconDownload, BIconDroplet, BIconDropletFill, BIconDropletHalf, BIconEarbuds, BIconEasel, BIconEaselFill, BIconEgg, BIconEggFill, BIconEggFried, BIconEject, BIconEjectFill, BIconEmojiAngry, BIconEmojiAngryFill, BIconEmojiDizzy, BIconEmojiDizzyFill, BIconEmojiExpressionless, BIconEmojiExpressionlessFill, BIconEmojiFrown, BIconEmojiFrownFill, BIconEmojiHeartEyes, BIconEmojiHeartEyesFill, BIconEmojiLaughing, BIconEmojiLaughingFill, BIconEmojiNeutral, BIconEmojiNeutralFill, BIconEmojiSmile, BIconEmojiSmileFill, BIconEmojiSmileUpsideDown, BIconEmojiSmileUpsideDownFill, BIconEmojiSunglasses, BIconEmojiSunglassesFill, BIconEmojiWink, BIconEmojiWinkFill, BIconEnvelope, BIconEnvelopeFill, BIconEnvelopeOpen, BIconEnvelopeOpenFill, BIconEraser, BIconEraserFill, BIconExclamation, BIconExclamationCircle, BIconExclamationCircleFill, BIconExclamationDiamond, BIconExclamationDiamondFill, BIconExclamationLg, BIconExclamationOctagon, BIconExclamationOctagonFill, BIconExclamationSquare, BIconExclamationSquareFill, BIconExclamationTriangle, BIconExclamationTriangleFill, BIconExclude, BIconEye, BIconEyeFill, BIconEyeSlash, BIconEyeSlashFill, BIconEyedropper, BIconEyeglasses, BIconFacebook, BIconFile, BIconFileArrowDown, BIconFileArrowDownFill, BIconFileArrowUp, BIconFileArrowUpFill, BIconFileBarGraph, BIconFileBarGraphFill, BIconFileBinary, BIconFileBinaryFill, BIconFileBreak, BIconFileBreakFill, BIconFileCheck, BIconFileCheckFill, BIconFileCode, BIconFileCodeFill, BIconFileDiff, BIconFileDiffFill, BIconFileEarmark, BIconFileEarmarkArrowDown, BIconFileEarmarkArrowDownFill, BIconFileEarmarkArrowUp, BIconFileEarmarkArrowUpFill, BIconFileEarmarkBarGraph, BIconFileEarmarkBarGraphFill, BIconFileEarmarkBinary, BIconFileEarmarkBinaryFill, BIconFileEarmarkBreak, BIconFileEarmarkBreakFill, BIconFileEarmarkCheck, BIconFileEarmarkCheckFill, BIconFileEarmarkCode, BIconFileEarmarkCodeFill, BIconFileEarmarkDiff, BIconFileEarmarkDiffFill, BIconFileEarmarkEasel, BIconFileEarmarkEaselFill, BIconFileEarmarkExcel, BIconFileEarmarkExcelFill, BIconFileEarmarkFill, BIconFileEarmarkFont, BIconFileEarmarkFontFill, BIconFileEarmarkImage, BIconFileEarmarkImageFill, BIconFileEarmarkLock, BIconFileEarmarkLock2, BIconFileEarmarkLock2Fill, BIconFileEarmarkLockFill, BIconFileEarmarkMedical, BIconFileEarmarkMedicalFill, BIconFileEarmarkMinus, BIconFileEarmarkMinusFill, BIconFileEarmarkMusic, BIconFileEarmarkMusicFill, BIconFileEarmarkPdf, BIconFileEarmarkPdfFill, BIconFileEarmarkPerson, BIconFileEarmarkPersonFill, BIconFileEarmarkPlay, BIconFileEarmarkPlayFill, BIconFileEarmarkPlus, BIconFileEarmarkPlusFill, BIconFileEarmarkPost, BIconFileEarmarkPostFill, BIconFileEarmarkPpt, BIconFileEarmarkPptFill, BIconFileEarmarkRichtext, BIconFileEarmarkRichtextFill, BIconFileEarmarkRuled, BIconFileEarmarkRuledFill, BIconFileEarmarkSlides, BIconFileEarmarkSlidesFill, BIconFileEarmarkSpreadsheet, BIconFileEarmarkSpreadsheetFill, BIconFileEarmarkText, BIconFileEarmarkTextFill, BIconFileEarmarkWord, BIconFileEarmarkWordFill, BIconFileEarmarkX, BIconFileEarmarkXFill, BIconFileEarmarkZip, BIconFileEarmarkZipFill, BIconFileEasel, BIconFileEaselFill, BIconFileExcel, BIconFileExcelFill, BIconFileFill, BIconFileFont, BIconFileFontFill, BIconFileImage, BIconFileImageFill, BIconFileLock, BIconFileLock2, BIconFileLock2Fill, BIconFileLockFill, BIconFileMedical, BIconFileMedicalFill, BIconFileMinus, BIconFileMinusFill, BIconFileMusic, BIconFileMusicFill, BIconFilePdf, BIconFilePdfFill, BIconFilePerson, BIconFilePersonFill, BIconFilePlay, BIconFilePlayFill, BIconFilePlus, BIconFilePlusFill, BIconFilePost, BIconFilePostFill, BIconFilePpt, BIconFilePptFill, BIconFileRichtext, BIconFileRichtextFill, BIconFileRuled, BIconFileRuledFill, BIconFileSlides, BIconFileSlidesFill, BIconFileSpreadsheet, BIconFileSpreadsheetFill, BIconFileText, BIconFileTextFill, BIconFileWord, BIconFileWordFill, BIconFileX, BIconFileXFill, BIconFileZip, BIconFileZipFill, BIconFiles, BIconFilesAlt, BIconFilm, BIconFilter, BIconFilterCircle, BIconFilterCircleFill, BIconFilterLeft, BIconFilterRight, BIconFilterSquare, BIconFilterSquareFill, BIconFlag, BIconFlagFill, BIconFlower1, BIconFlower2, BIconFlower3, BIconFolder, BIconFolder2, BIconFolder2Open, BIconFolderCheck, BIconFolderFill, BIconFolderMinus, BIconFolderPlus, BIconFolderSymlink, BIconFolderSymlinkFill, BIconFolderX, BIconFonts, BIconForward, BIconForwardFill, BIconFront, BIconFullscreen, BIconFullscreenExit, BIconFunnel, BIconFunnelFill, BIconGear, BIconGearFill, BIconGearWide, BIconGearWideConnected, BIconGem, BIconGenderAmbiguous, BIconGenderFemale, BIconGenderMale, BIconGenderTrans, BIconGeo, BIconGeoAlt, BIconGeoAltFill, BIconGeoFill, BIconGift, BIconGiftFill, BIconGithub, BIconGlobe, BIconGlobe2, BIconGoogle, BIconGraphDown, BIconGraphUp, BIconGrid, BIconGrid1x2, BIconGrid1x2Fill, BIconGrid3x2, BIconGrid3x2Gap, BIconGrid3x2GapFill, BIconGrid3x3, BIconGrid3x3Gap, BIconGrid3x3GapFill, BIconGridFill, BIconGripHorizontal, BIconGripVertical, BIconHammer, BIconHandIndex, BIconHandIndexFill, BIconHandIndexThumb, BIconHandIndexThumbFill, BIconHandThumbsDown, BIconHandThumbsDownFill, BIconHandThumbsUp, BIconHandThumbsUpFill, BIconHandbag, BIconHandbagFill, BIconHash, BIconHdd, BIconHddFill, BIconHddNetwork, BIconHddNetworkFill, BIconHddRack, BIconHddRackFill, BIconHddStack, BIconHddStackFill, BIconHeadphones, BIconHeadset, BIconHeadsetVr, BIconHeart, BIconHeartFill, BIconHeartHalf, BIconHeptagon, BIconHeptagonFill, BIconHeptagonHalf, BIconHexagon, BIconHexagonFill, BIconHexagonHalf, BIconHourglass, BIconHourglassBottom, BIconHourglassSplit, BIconHourglassTop, BIconHouse, BIconHouseDoor, BIconHouseDoorFill, BIconHouseFill, BIconHr, BIconHurricane, BIconImage, BIconImageAlt, BIconImageFill, BIconImages, BIconInbox, BIconInboxFill, BIconInboxes, BIconInboxesFill, BIconInfo, BIconInfoCircle, BIconInfoCircleFill, BIconInfoLg, BIconInfoSquare, BIconInfoSquareFill, BIconInputCursor, BIconInputCursorText, BIconInstagram, BIconIntersect, BIconJournal, BIconJournalAlbum, BIconJournalArrowDown, BIconJournalArrowUp, BIconJournalBookmark, BIconJournalBookmarkFill, BIconJournalCheck, BIconJournalCode, BIconJournalMedical, BIconJournalMinus, BIconJournalPlus, BIconJournalRichtext, BIconJournalText, BIconJournalX, BIconJournals, BIconJoystick, BIconJustify, BIconJustifyLeft, BIconJustifyRight, BIconKanban, BIconKanbanFill, BIconKey, BIconKeyFill, BIconKeyboard, BIconKeyboardFill, BIconLadder, BIconLamp, BIconLampFill, BIconLaptop, BIconLaptopFill, BIconLayerBackward, BIconLayerForward, BIconLayers, BIconLayersFill, BIconLayersHalf, BIconLayoutSidebar, BIconLayoutSidebarInset, BIconLayoutSidebarInsetReverse, BIconLayoutSidebarReverse, BIconLayoutSplit, BIconLayoutTextSidebar, BIconLayoutTextSidebarReverse, BIconLayoutTextWindow, BIconLayoutTextWindowReverse, BIconLayoutThreeColumns, BIconLayoutWtf, BIconLifePreserver, BIconLightbulb, BIconLightbulbFill, BIconLightbulbOff, BIconLightbulbOffFill, BIconLightning, BIconLightningCharge, BIconLightningChargeFill, BIconLightningFill, BIconLink, BIconLink45deg, BIconLinkedin, BIconList, BIconListCheck, BIconListNested, BIconListOl, BIconListStars, BIconListTask, BIconListUl, BIconLock, BIconLockFill, BIconMailbox, BIconMailbox2, BIconMap, BIconMapFill, BIconMarkdown, BIconMarkdownFill, BIconMask, BIconMastodon, BIconMegaphone, BIconMegaphoneFill, BIconMenuApp, BIconMenuAppFill, BIconMenuButton, BIconMenuButtonFill, BIconMenuButtonWide, BIconMenuButtonWideFill, BIconMenuDown, BIconMenuUp, BIconMessenger, BIconMic, BIconMicFill, BIconMicMute, BIconMicMuteFill, BIconMinecart, BIconMinecartLoaded, BIconMoisture, BIconMoon, BIconMoonFill, BIconMoonStars, BIconMoonStarsFill, BIconMouse, BIconMouse2, BIconMouse2Fill, BIconMouse3, BIconMouse3Fill, BIconMouseFill, BIconMusicNote, BIconMusicNoteBeamed, BIconMusicNoteList, BIconMusicPlayer, BIconMusicPlayerFill, BIconNewspaper, BIconNodeMinus, BIconNodeMinusFill, BIconNodePlus, BIconNodePlusFill, BIconNut, BIconNutFill, BIconOctagon, BIconOctagonFill, BIconOctagonHalf, BIconOption, BIconOutlet, BIconPaintBucket, BIconPalette, BIconPalette2, BIconPaletteFill, BIconPaperclip, BIconParagraph, BIconPatchCheck, BIconPatchCheckFill, BIconPatchExclamation, BIconPatchExclamationFill, BIconPatchMinus, BIconPatchMinusFill, BIconPatchPlus, BIconPatchPlusFill, BIconPatchQuestion, BIconPatchQuestionFill, BIconPause, BIconPauseBtn, BIconPauseBtnFill, BIconPauseCircle, BIconPauseCircleFill, BIconPauseFill, BIconPeace, BIconPeaceFill, BIconPen, BIconPenFill, BIconPencil, BIconPencilFill, BIconPencilSquare, BIconPentagon, BIconPentagonFill, BIconPentagonHalf, BIconPeople, BIconPeopleFill, BIconPercent, BIconPerson, BIconPersonBadge, BIconPersonBadgeFill, BIconPersonBoundingBox, BIconPersonCheck, BIconPersonCheckFill, BIconPersonCircle, BIconPersonDash, BIconPersonDashFill, BIconPersonFill, BIconPersonLinesFill, BIconPersonPlus, BIconPersonPlusFill, BIconPersonSquare, BIconPersonX, BIconPersonXFill, BIconPhone, BIconPhoneFill, BIconPhoneLandscape, BIconPhoneLandscapeFill, BIconPhoneVibrate, BIconPhoneVibrateFill, BIconPieChart, BIconPieChartFill, BIconPiggyBank, BIconPiggyBankFill, BIconPin, BIconPinAngle, BIconPinAngleFill, BIconPinFill, BIconPinMap, BIconPinMapFill, BIconPip, BIconPipFill, BIconPlay, BIconPlayBtn, BIconPlayBtnFill, BIconPlayCircle, BIconPlayCircleFill, BIconPlayFill, BIconPlug, BIconPlugFill, BIconPlus, BIconPlusCircle, BIconPlusCircleDotted, BIconPlusCircleFill, BIconPlusLg, BIconPlusSquare, BIconPlusSquareDotted, BIconPlusSquareFill, BIconPower, BIconPrinter, BIconPrinterFill, BIconPuzzle, BIconPuzzleFill, BIconQuestion, BIconQuestionCircle, BIconQuestionCircleFill, BIconQuestionDiamond, BIconQuestionDiamondFill, BIconQuestionLg, BIconQuestionOctagon, BIconQuestionOctagonFill, BIconQuestionSquare, BIconQuestionSquareFill, BIconRainbow, BIconReceipt, BIconReceiptCutoff, BIconReception0, BIconReception1, BIconReception2, BIconReception3, BIconReception4, BIconRecord, BIconRecord2, BIconRecord2Fill, BIconRecordBtn, BIconRecordBtnFill, BIconRecordCircle, BIconRecordCircleFill, BIconRecordFill, BIconRecycle, BIconReddit, BIconReply, BIconReplyAll, BIconReplyAllFill, BIconReplyFill, BIconRss, BIconRssFill, BIconRulers, BIconSafe, BIconSafe2, BIconSafe2Fill, BIconSafeFill, BIconSave, BIconSave2, BIconSave2Fill, BIconSaveFill, BIconScissors, BIconScrewdriver, BIconSdCard, BIconSdCardFill, BIconSearch, BIconSegmentedNav, BIconServer, BIconShare, BIconShareFill, BIconShield, BIconShieldCheck, BIconShieldExclamation, BIconShieldFill, BIconShieldFillCheck, BIconShieldFillExclamation, BIconShieldFillMinus, BIconShieldFillPlus, BIconShieldFillX, BIconShieldLock, BIconShieldLockFill, BIconShieldMinus, BIconShieldPlus, BIconShieldShaded, BIconShieldSlash, BIconShieldSlashFill, BIconShieldX, BIconShift, BIconShiftFill, BIconShop, BIconShopWindow, BIconShuffle, BIconSignpost, BIconSignpost2, BIconSignpost2Fill, BIconSignpostFill, BIconSignpostSplit, BIconSignpostSplitFill, BIconSim, BIconSimFill, BIconSkipBackward, BIconSkipBackwardBtn, BIconSkipBackwardBtnFill, BIconSkipBackwardCircle, BIconSkipBackwardCircleFill, BIconSkipBackwardFill, BIconSkipEnd, BIconSkipEndBtn, BIconSkipEndBtnFill, BIconSkipEndCircle, BIconSkipEndCircleFill, BIconSkipEndFill, BIconSkipForward, BIconSkipForwardBtn, BIconSkipForwardBtnFill, BIconSkipForwardCircle, BIconSkipForwardCircleFill, BIconSkipForwardFill, BIconSkipStart, BIconSkipStartBtn, BIconSkipStartBtnFill, BIconSkipStartCircle, BIconSkipStartCircleFill, BIconSkipStartFill, BIconSkype, BIconSlack, BIconSlash, BIconSlashCircle, BIconSlashCircleFill, BIconSlashLg, BIconSlashSquare, BIconSlashSquareFill, BIconSliders, BIconSmartwatch, BIconSnow, BIconSnow2, BIconSnow3, BIconSortAlphaDown, BIconSortAlphaDownAlt, BIconSortAlphaUp, BIconSortAlphaUpAlt, BIconSortDown, BIconSortDownAlt, BIconSortNumericDown, BIconSortNumericDownAlt, BIconSortNumericUp, BIconSortNumericUpAlt, BIconSortUp, BIconSortUpAlt, BIconSoundwave, BIconSpeaker, BIconSpeakerFill, BIconSpeedometer, BIconSpeedometer2, BIconSpellcheck, BIconSquare, BIconSquareFill, BIconSquareHalf, BIconStack, BIconStar, BIconStarFill, BIconStarHalf, BIconStars, BIconStickies, BIconStickiesFill, BIconSticky, BIconStickyFill, BIconStop, BIconStopBtn, BIconStopBtnFill, BIconStopCircle, BIconStopCircleFill, BIconStopFill, BIconStoplights, BIconStoplightsFill, BIconStopwatch, BIconStopwatchFill, BIconSubtract, BIconSuitClub, BIconSuitClubFill, BIconSuitDiamond, BIconSuitDiamondFill, BIconSuitHeart, BIconSuitHeartFill, BIconSuitSpade, BIconSuitSpadeFill, BIconSun, BIconSunFill, BIconSunglasses, BIconSunrise, BIconSunriseFill, BIconSunset, BIconSunsetFill, BIconSymmetryHorizontal, BIconSymmetryVertical, BIconTable, BIconTablet, BIconTabletFill, BIconTabletLandscape, BIconTabletLandscapeFill, BIconTag, BIconTagFill, BIconTags, BIconTagsFill, BIconTelegram, BIconTelephone, BIconTelephoneFill, BIconTelephoneForward, BIconTelephoneForwardFill, BIconTelephoneInbound, BIconTelephoneInboundFill, BIconTelephoneMinus, BIconTelephoneMinusFill, BIconTelephoneOutbound, BIconTelephoneOutboundFill, BIconTelephonePlus, BIconTelephonePlusFill, BIconTelephoneX, BIconTelephoneXFill, BIconTerminal, BIconTerminalFill, BIconTextCenter, BIconTextIndentLeft, BIconTextIndentRight, BIconTextLeft, BIconTextParagraph, BIconTextRight, BIconTextarea, BIconTextareaResize, BIconTextareaT, BIconThermometer, BIconThermometerHalf, BIconThermometerHigh, BIconThermometerLow, BIconThermometerSnow, BIconThermometerSun, BIconThreeDots, BIconThreeDotsVertical, BIconToggle2Off, BIconToggle2On, BIconToggleOff, BIconToggleOn, BIconToggles, BIconToggles2, BIconTools, BIconTornado, BIconTranslate, BIconTrash, BIconTrash2, BIconTrash2Fill, BIconTrashFill, BIconTree, BIconTreeFill, BIconTriangle, BIconTriangleFill, BIconTriangleHalf, BIconTrophy, BIconTrophyFill, BIconTropicalStorm, BIconTruck, BIconTruckFlatbed, BIconTsunami, BIconTv, BIconTvFill, BIconTwitch, BIconTwitter, BIconType, BIconTypeBold, BIconTypeH1, BIconTypeH2, BIconTypeH3, BIconTypeItalic, BIconTypeStrikethrough, BIconTypeUnderline, BIconUiChecks, BIconUiChecksGrid, BIconUiRadios, BIconUiRadiosGrid, BIconUmbrella, BIconUmbrellaFill, BIconUnion, BIconUnlock, BIconUnlockFill, BIconUpc, BIconUpcScan, BIconUpload, BIconVectorPen, BIconViewList, BIconViewStacked, BIconVinyl, BIconVinylFill, BIconVoicemail, BIconVolumeDown, BIconVolumeDownFill, BIconVolumeMute, BIconVolumeMuteFill, BIconVolumeOff, BIconVolumeOffFill, BIconVolumeUp, BIconVolumeUpFill, BIconVr, BIconWallet, BIconWallet2, BIconWalletFill, BIconWatch, BIconWater, BIconWhatsapp, BIconWifi, BIconWifi1, BIconWifi2, BIconWifiOff, BIconWind, BIconWindow, BIconWindowDock, BIconWindowSidebar, BIconWrench, BIconX, BIconXCircle, BIconXCircleFill, BIconXDiamond, BIconXDiamondFill, BIconXLg, BIconXOctagon, BIconXOctagonFill, BIconXSquare, BIconXSquareFill, BIconYoutube, BIconZoomIn, BIconZoomOut, BIcon, BIconstack, IconsPlugin, BootstrapVueIcons, iconNames */
/* exports used: BIcon */
/*!********************************************!*\
  !*** ./~/bootstrap-vue/esm/icons/index.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons__ = __webpack_require__(/*! ./icons */ 61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon__ = __webpack_require__(/*! ./icon */ 138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iconstack__ = __webpack_require__(/*! ./iconstack */ 250);
/* unused harmony reexport BIconstack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin__ = __webpack_require__(/*! ./plugin */ 456);
/* unused harmony reexport IconsPlugin */
/* unused harmony reexport BootstrapVueIcons */
/* unused harmony reexport iconNames */
// Icons Plugin
// These re-exports are not currently used, as Webpack 4 has
// issues with tree shaking re-exports of re-exports
// `/src/index.js` does a single level re-export `* from './icons/icons/icons'`
// Export all icons
 // Export helper component

 // Export stacking component

 // Plugin (an iconNames for docs)



/***/ }),
/* 950 */
/* exports provided: install, NAME, BVConfigPlugin, BVConfig, BootstrapVue, BVModalPlugin, BVToastPlugin, IconsPlugin, BootstrapVueIcons, BIcon, BIconstack, AlertPlugin, BAlert, AspectPlugin, BAspect, AvatarPlugin, BAvatar, BAvatarGroup, BadgePlugin, BBadge, BreadcrumbPlugin, BBreadcrumb, BBreadcrumbItem, ButtonPlugin, BButton, BButtonClose, ButtonGroupPlugin, BButtonGroup, ButtonToolbarPlugin, BButtonToolbar, CalendarPlugin, BCalendar, CardPlugin, BCard, BCardBody, BCardFooter, BCardGroup, BCardHeader, BCardImg, BCardImgLazy, BCardSubTitle, BCardText, BCardTitle, CarouselPlugin, BCarousel, BCarouselSlide, CollapsePlugin, BCollapse, DropdownPlugin, BDropdown, BDropdownItem, BDropdownItemButton, BDropdownDivider, BDropdownForm, BDropdownGroup, BDropdownHeader, BDropdownText, EmbedPlugin, BEmbed, FormPlugin, BForm, BFormDatalist, BFormText, BFormInvalidFeedback, BFormValidFeedback, FormCheckboxPlugin, BFormCheckbox, BFormCheckboxGroup, FormDatepickerPlugin, BFormDatepicker, FormFilePlugin, BFormFile, FormGroupPlugin, BFormGroup, FormInputPlugin, BFormInput, FormRadioPlugin, BFormRadio, BFormRadioGroup, FormRatingPlugin, BFormRating, FormTagsPlugin, BFormTags, BFormTag, FormSelectPlugin, BFormSelect, BFormSelectOption, BFormSelectOptionGroup, FormSpinbuttonPlugin, BFormSpinbutton, FormTextareaPlugin, BFormTextarea, FormTimepickerPlugin, BFormTimepicker, ImagePlugin, BImg, BImgLazy, InputGroupPlugin, BInputGroup, BInputGroupAddon, BInputGroupAppend, BInputGroupPrepend, BInputGroupText, JumbotronPlugin, BJumbotron, LayoutPlugin, BContainer, BRow, BCol, BFormRow, LinkPlugin, BLink, ListGroupPlugin, BListGroup, BListGroupItem, MediaPlugin, BMedia, BMediaAside, BMediaBody, ModalPlugin, BModal, NavPlugin, BNav, BNavForm, BNavItem, BNavItemDropdown, BNavText, NavbarPlugin, BNavbar, BNavbarBrand, BNavbarNav, BNavbarToggle, OverlayPlugin, BOverlay, PaginationPlugin, BPagination, PaginationNavPlugin, BPaginationNav, PopoverPlugin, BPopover, ProgressPlugin, BProgress, BProgressBar, SidebarPlugin, BSidebar, SkeletonPlugin, BSkeleton, BSkeletonIcon, BSkeletonImg, BSkeletonTable, BSkeletonWrapper, SpinnerPlugin, BSpinner, TablePlugin, TableLitePlugin, TableSimplePlugin, BTable, BTableLite, BTableSimple, BTbody, BThead, BTfoot, BTr, BTh, BTd, TabsPlugin, BTabs, BTab, TimePlugin, BTime, ToastPlugin, BToast, BToaster, TooltipPlugin, BTooltip, VBHoverPlugin, VBHover, VBModalPlugin, VBModal, VBPopoverPlugin, VBPopover, VBScrollspyPlugin, VBScrollspy, VBTogglePlugin, VBToggle, VBTooltipPlugin, VBTooltip, VBVisiblePlugin, VBVisible, default, BIconBlank, BIconAlarm, BIconAlarmFill, BIconAlignBottom, BIconAlignCenter, BIconAlignEnd, BIconAlignMiddle, BIconAlignStart, BIconAlignTop, BIconAlt, BIconApp, BIconAppIndicator, BIconArchive, BIconArchiveFill, BIconArrow90degDown, BIconArrow90degLeft, BIconArrow90degRight, BIconArrow90degUp, BIconArrowBarDown, BIconArrowBarLeft, BIconArrowBarRight, BIconArrowBarUp, BIconArrowClockwise, BIconArrowCounterclockwise, BIconArrowDown, BIconArrowDownCircle, BIconArrowDownCircleFill, BIconArrowDownLeft, BIconArrowDownLeftCircle, BIconArrowDownLeftCircleFill, BIconArrowDownLeftSquare, BIconArrowDownLeftSquareFill, BIconArrowDownRight, BIconArrowDownRightCircle, BIconArrowDownRightCircleFill, BIconArrowDownRightSquare, BIconArrowDownRightSquareFill, BIconArrowDownShort, BIconArrowDownSquare, BIconArrowDownSquareFill, BIconArrowDownUp, BIconArrowLeft, BIconArrowLeftCircle, BIconArrowLeftCircleFill, BIconArrowLeftRight, BIconArrowLeftShort, BIconArrowLeftSquare, BIconArrowLeftSquareFill, BIconArrowRepeat, BIconArrowReturnLeft, BIconArrowReturnRight, BIconArrowRight, BIconArrowRightCircle, BIconArrowRightCircleFill, BIconArrowRightShort, BIconArrowRightSquare, BIconArrowRightSquareFill, BIconArrowUp, BIconArrowUpCircle, BIconArrowUpCircleFill, BIconArrowUpLeft, BIconArrowUpLeftCircle, BIconArrowUpLeftCircleFill, BIconArrowUpLeftSquare, BIconArrowUpLeftSquareFill, BIconArrowUpRight, BIconArrowUpRightCircle, BIconArrowUpRightCircleFill, BIconArrowUpRightSquare, BIconArrowUpRightSquareFill, BIconArrowUpShort, BIconArrowUpSquare, BIconArrowUpSquareFill, BIconArrowsAngleContract, BIconArrowsAngleExpand, BIconArrowsCollapse, BIconArrowsExpand, BIconArrowsFullscreen, BIconArrowsMove, BIconAspectRatio, BIconAspectRatioFill, BIconAsterisk, BIconAt, BIconAward, BIconAwardFill, BIconBack, BIconBackspace, BIconBackspaceFill, BIconBackspaceReverse, BIconBackspaceReverseFill, BIconBadge3d, BIconBadge3dFill, BIconBadge4k, BIconBadge4kFill, BIconBadge8k, BIconBadge8kFill, BIconBadgeAd, BIconBadgeAdFill, BIconBadgeAr, BIconBadgeArFill, BIconBadgeCc, BIconBadgeCcFill, BIconBadgeHd, BIconBadgeHdFill, BIconBadgeTm, BIconBadgeTmFill, BIconBadgeVo, BIconBadgeVoFill, BIconBadgeVr, BIconBadgeVrFill, BIconBadgeWc, BIconBadgeWcFill, BIconBag, BIconBagCheck, BIconBagCheckFill, BIconBagDash, BIconBagDashFill, BIconBagFill, BIconBagPlus, BIconBagPlusFill, BIconBagX, BIconBagXFill, BIconBank, BIconBank2, BIconBarChart, BIconBarChartFill, BIconBarChartLine, BIconBarChartLineFill, BIconBarChartSteps, BIconBasket, BIconBasket2, BIconBasket2Fill, BIconBasket3, BIconBasket3Fill, BIconBasketFill, BIconBattery, BIconBatteryCharging, BIconBatteryFull, BIconBatteryHalf, BIconBell, BIconBellFill, BIconBellSlash, BIconBellSlashFill, BIconBezier, BIconBezier2, BIconBicycle, BIconBinoculars, BIconBinocularsFill, BIconBlockquoteLeft, BIconBlockquoteRight, BIconBook, BIconBookFill, BIconBookHalf, BIconBookmark, BIconBookmarkCheck, BIconBookmarkCheckFill, BIconBookmarkDash, BIconBookmarkDashFill, BIconBookmarkFill, BIconBookmarkHeart, BIconBookmarkHeartFill, BIconBookmarkPlus, BIconBookmarkPlusFill, BIconBookmarkStar, BIconBookmarkStarFill, BIconBookmarkX, BIconBookmarkXFill, BIconBookmarks, BIconBookmarksFill, BIconBookshelf, BIconBootstrap, BIconBootstrapFill, BIconBootstrapReboot, BIconBorder, BIconBorderAll, BIconBorderBottom, BIconBorderCenter, BIconBorderInner, BIconBorderLeft, BIconBorderMiddle, BIconBorderOuter, BIconBorderRight, BIconBorderStyle, BIconBorderTop, BIconBorderWidth, BIconBoundingBox, BIconBoundingBoxCircles, BIconBox, BIconBoxArrowDown, BIconBoxArrowDownLeft, BIconBoxArrowDownRight, BIconBoxArrowInDown, BIconBoxArrowInDownLeft, BIconBoxArrowInDownRight, BIconBoxArrowInLeft, BIconBoxArrowInRight, BIconBoxArrowInUp, BIconBoxArrowInUpLeft, BIconBoxArrowInUpRight, BIconBoxArrowLeft, BIconBoxArrowRight, BIconBoxArrowUp, BIconBoxArrowUpLeft, BIconBoxArrowUpRight, BIconBoxSeam, BIconBraces, BIconBricks, BIconBriefcase, BIconBriefcaseFill, BIconBrightnessAltHigh, BIconBrightnessAltHighFill, BIconBrightnessAltLow, BIconBrightnessAltLowFill, BIconBrightnessHigh, BIconBrightnessHighFill, BIconBrightnessLow, BIconBrightnessLowFill, BIconBroadcast, BIconBroadcastPin, BIconBrush, BIconBrushFill, BIconBucket, BIconBucketFill, BIconBug, BIconBugFill, BIconBuilding, BIconBullseye, BIconCalculator, BIconCalculatorFill, BIconCalendar, BIconCalendar2, BIconCalendar2Check, BIconCalendar2CheckFill, BIconCalendar2Date, BIconCalendar2DateFill, BIconCalendar2Day, BIconCalendar2DayFill, BIconCalendar2Event, BIconCalendar2EventFill, BIconCalendar2Fill, BIconCalendar2Minus, BIconCalendar2MinusFill, BIconCalendar2Month, BIconCalendar2MonthFill, BIconCalendar2Plus, BIconCalendar2PlusFill, BIconCalendar2Range, BIconCalendar2RangeFill, BIconCalendar2Week, BIconCalendar2WeekFill, BIconCalendar2X, BIconCalendar2XFill, BIconCalendar3, BIconCalendar3Event, BIconCalendar3EventFill, BIconCalendar3Fill, BIconCalendar3Range, BIconCalendar3RangeFill, BIconCalendar3Week, BIconCalendar3WeekFill, BIconCalendar4, BIconCalendar4Event, BIconCalendar4Range, BIconCalendar4Week, BIconCalendarCheck, BIconCalendarCheckFill, BIconCalendarDate, BIconCalendarDateFill, BIconCalendarDay, BIconCalendarDayFill, BIconCalendarEvent, BIconCalendarEventFill, BIconCalendarFill, BIconCalendarMinus, BIconCalendarMinusFill, BIconCalendarMonth, BIconCalendarMonthFill, BIconCalendarPlus, BIconCalendarPlusFill, BIconCalendarRange, BIconCalendarRangeFill, BIconCalendarWeek, BIconCalendarWeekFill, BIconCalendarX, BIconCalendarXFill, BIconCamera, BIconCamera2, BIconCameraFill, BIconCameraReels, BIconCameraReelsFill, BIconCameraVideo, BIconCameraVideoFill, BIconCameraVideoOff, BIconCameraVideoOffFill, BIconCapslock, BIconCapslockFill, BIconCardChecklist, BIconCardHeading, BIconCardImage, BIconCardList, BIconCardText, BIconCaretDown, BIconCaretDownFill, BIconCaretDownSquare, BIconCaretDownSquareFill, BIconCaretLeft, BIconCaretLeftFill, BIconCaretLeftSquare, BIconCaretLeftSquareFill, BIconCaretRight, BIconCaretRightFill, BIconCaretRightSquare, BIconCaretRightSquareFill, BIconCaretUp, BIconCaretUpFill, BIconCaretUpSquare, BIconCaretUpSquareFill, BIconCart, BIconCart2, BIconCart3, BIconCart4, BIconCartCheck, BIconCartCheckFill, BIconCartDash, BIconCartDashFill, BIconCartFill, BIconCartPlus, BIconCartPlusFill, BIconCartX, BIconCartXFill, BIconCash, BIconCashCoin, BIconCashStack, BIconCast, BIconChat, BIconChatDots, BIconChatDotsFill, BIconChatFill, BIconChatLeft, BIconChatLeftDots, BIconChatLeftDotsFill, BIconChatLeftFill, BIconChatLeftQuote, BIconChatLeftQuoteFill, BIconChatLeftText, BIconChatLeftTextFill, BIconChatQuote, BIconChatQuoteFill, BIconChatRight, BIconChatRightDots, BIconChatRightDotsFill, BIconChatRightFill, BIconChatRightQuote, BIconChatRightQuoteFill, BIconChatRightText, BIconChatRightTextFill, BIconChatSquare, BIconChatSquareDots, BIconChatSquareDotsFill, BIconChatSquareFill, BIconChatSquareQuote, BIconChatSquareQuoteFill, BIconChatSquareText, BIconChatSquareTextFill, BIconChatText, BIconChatTextFill, BIconCheck, BIconCheck2, BIconCheck2All, BIconCheck2Circle, BIconCheck2Square, BIconCheckAll, BIconCheckCircle, BIconCheckCircleFill, BIconCheckLg, BIconCheckSquare, BIconCheckSquareFill, BIconChevronBarContract, BIconChevronBarDown, BIconChevronBarExpand, BIconChevronBarLeft, BIconChevronBarRight, BIconChevronBarUp, BIconChevronCompactDown, BIconChevronCompactLeft, BIconChevronCompactRight, BIconChevronCompactUp, BIconChevronContract, BIconChevronDoubleDown, BIconChevronDoubleLeft, BIconChevronDoubleRight, BIconChevronDoubleUp, BIconChevronDown, BIconChevronExpand, BIconChevronLeft, BIconChevronRight, BIconChevronUp, BIconCircle, BIconCircleFill, BIconCircleHalf, BIconCircleSquare, BIconClipboard, BIconClipboardCheck, BIconClipboardData, BIconClipboardMinus, BIconClipboardPlus, BIconClipboardX, BIconClock, BIconClockFill, BIconClockHistory, BIconCloud, BIconCloudArrowDown, BIconCloudArrowDownFill, BIconCloudArrowUp, BIconCloudArrowUpFill, BIconCloudCheck, BIconCloudCheckFill, BIconCloudDownload, BIconCloudDownloadFill, BIconCloudDrizzle, BIconCloudDrizzleFill, BIconCloudFill, BIconCloudFog, BIconCloudFog2, BIconCloudFog2Fill, BIconCloudFogFill, BIconCloudHail, BIconCloudHailFill, BIconCloudHaze, BIconCloudHaze1, BIconCloudHaze2Fill, BIconCloudHazeFill, BIconCloudLightning, BIconCloudLightningFill, BIconCloudLightningRain, BIconCloudLightningRainFill, BIconCloudMinus, BIconCloudMinusFill, BIconCloudMoon, BIconCloudMoonFill, BIconCloudPlus, BIconCloudPlusFill, BIconCloudRain, BIconCloudRainFill, BIconCloudRainHeavy, BIconCloudRainHeavyFill, BIconCloudSlash, BIconCloudSlashFill, BIconCloudSleet, BIconCloudSleetFill, BIconCloudSnow, BIconCloudSnowFill, BIconCloudSun, BIconCloudSunFill, BIconCloudUpload, BIconCloudUploadFill, BIconClouds, BIconCloudsFill, BIconCloudy, BIconCloudyFill, BIconCode, BIconCodeSlash, BIconCodeSquare, BIconCoin, BIconCollection, BIconCollectionFill, BIconCollectionPlay, BIconCollectionPlayFill, BIconColumns, BIconColumnsGap, BIconCommand, BIconCompass, BIconCompassFill, BIconCone, BIconConeStriped, BIconController, BIconCpu, BIconCpuFill, BIconCreditCard, BIconCreditCard2Back, BIconCreditCard2BackFill, BIconCreditCard2Front, BIconCreditCard2FrontFill, BIconCreditCardFill, BIconCrop, BIconCup, BIconCupFill, BIconCupStraw, BIconCurrencyBitcoin, BIconCurrencyDollar, BIconCurrencyEuro, BIconCurrencyExchange, BIconCurrencyPound, BIconCurrencyYen, BIconCursor, BIconCursorFill, BIconCursorText, BIconDash, BIconDashCircle, BIconDashCircleDotted, BIconDashCircleFill, BIconDashLg, BIconDashSquare, BIconDashSquareDotted, BIconDashSquareFill, BIconDiagram2, BIconDiagram2Fill, BIconDiagram3, BIconDiagram3Fill, BIconDiamond, BIconDiamondFill, BIconDiamondHalf, BIconDice1, BIconDice1Fill, BIconDice2, BIconDice2Fill, BIconDice3, BIconDice3Fill, BIconDice4, BIconDice4Fill, BIconDice5, BIconDice5Fill, BIconDice6, BIconDice6Fill, BIconDisc, BIconDiscFill, BIconDiscord, BIconDisplay, BIconDisplayFill, BIconDistributeHorizontal, BIconDistributeVertical, BIconDoorClosed, BIconDoorClosedFill, BIconDoorOpen, BIconDoorOpenFill, BIconDot, BIconDownload, BIconDroplet, BIconDropletFill, BIconDropletHalf, BIconEarbuds, BIconEasel, BIconEaselFill, BIconEgg, BIconEggFill, BIconEggFried, BIconEject, BIconEjectFill, BIconEmojiAngry, BIconEmojiAngryFill, BIconEmojiDizzy, BIconEmojiDizzyFill, BIconEmojiExpressionless, BIconEmojiExpressionlessFill, BIconEmojiFrown, BIconEmojiFrownFill, BIconEmojiHeartEyes, BIconEmojiHeartEyesFill, BIconEmojiLaughing, BIconEmojiLaughingFill, BIconEmojiNeutral, BIconEmojiNeutralFill, BIconEmojiSmile, BIconEmojiSmileFill, BIconEmojiSmileUpsideDown, BIconEmojiSmileUpsideDownFill, BIconEmojiSunglasses, BIconEmojiSunglassesFill, BIconEmojiWink, BIconEmojiWinkFill, BIconEnvelope, BIconEnvelopeFill, BIconEnvelopeOpen, BIconEnvelopeOpenFill, BIconEraser, BIconEraserFill, BIconExclamation, BIconExclamationCircle, BIconExclamationCircleFill, BIconExclamationDiamond, BIconExclamationDiamondFill, BIconExclamationLg, BIconExclamationOctagon, BIconExclamationOctagonFill, BIconExclamationSquare, BIconExclamationSquareFill, BIconExclamationTriangle, BIconExclamationTriangleFill, BIconExclude, BIconEye, BIconEyeFill, BIconEyeSlash, BIconEyeSlashFill, BIconEyedropper, BIconEyeglasses, BIconFacebook, BIconFile, BIconFileArrowDown, BIconFileArrowDownFill, BIconFileArrowUp, BIconFileArrowUpFill, BIconFileBarGraph, BIconFileBarGraphFill, BIconFileBinary, BIconFileBinaryFill, BIconFileBreak, BIconFileBreakFill, BIconFileCheck, BIconFileCheckFill, BIconFileCode, BIconFileCodeFill, BIconFileDiff, BIconFileDiffFill, BIconFileEarmark, BIconFileEarmarkArrowDown, BIconFileEarmarkArrowDownFill, BIconFileEarmarkArrowUp, BIconFileEarmarkArrowUpFill, BIconFileEarmarkBarGraph, BIconFileEarmarkBarGraphFill, BIconFileEarmarkBinary, BIconFileEarmarkBinaryFill, BIconFileEarmarkBreak, BIconFileEarmarkBreakFill, BIconFileEarmarkCheck, BIconFileEarmarkCheckFill, BIconFileEarmarkCode, BIconFileEarmarkCodeFill, BIconFileEarmarkDiff, BIconFileEarmarkDiffFill, BIconFileEarmarkEasel, BIconFileEarmarkEaselFill, BIconFileEarmarkExcel, BIconFileEarmarkExcelFill, BIconFileEarmarkFill, BIconFileEarmarkFont, BIconFileEarmarkFontFill, BIconFileEarmarkImage, BIconFileEarmarkImageFill, BIconFileEarmarkLock, BIconFileEarmarkLock2, BIconFileEarmarkLock2Fill, BIconFileEarmarkLockFill, BIconFileEarmarkMedical, BIconFileEarmarkMedicalFill, BIconFileEarmarkMinus, BIconFileEarmarkMinusFill, BIconFileEarmarkMusic, BIconFileEarmarkMusicFill, BIconFileEarmarkPdf, BIconFileEarmarkPdfFill, BIconFileEarmarkPerson, BIconFileEarmarkPersonFill, BIconFileEarmarkPlay, BIconFileEarmarkPlayFill, BIconFileEarmarkPlus, BIconFileEarmarkPlusFill, BIconFileEarmarkPost, BIconFileEarmarkPostFill, BIconFileEarmarkPpt, BIconFileEarmarkPptFill, BIconFileEarmarkRichtext, BIconFileEarmarkRichtextFill, BIconFileEarmarkRuled, BIconFileEarmarkRuledFill, BIconFileEarmarkSlides, BIconFileEarmarkSlidesFill, BIconFileEarmarkSpreadsheet, BIconFileEarmarkSpreadsheetFill, BIconFileEarmarkText, BIconFileEarmarkTextFill, BIconFileEarmarkWord, BIconFileEarmarkWordFill, BIconFileEarmarkX, BIconFileEarmarkXFill, BIconFileEarmarkZip, BIconFileEarmarkZipFill, BIconFileEasel, BIconFileEaselFill, BIconFileExcel, BIconFileExcelFill, BIconFileFill, BIconFileFont, BIconFileFontFill, BIconFileImage, BIconFileImageFill, BIconFileLock, BIconFileLock2, BIconFileLock2Fill, BIconFileLockFill, BIconFileMedical, BIconFileMedicalFill, BIconFileMinus, BIconFileMinusFill, BIconFileMusic, BIconFileMusicFill, BIconFilePdf, BIconFilePdfFill, BIconFilePerson, BIconFilePersonFill, BIconFilePlay, BIconFilePlayFill, BIconFilePlus, BIconFilePlusFill, BIconFilePost, BIconFilePostFill, BIconFilePpt, BIconFilePptFill, BIconFileRichtext, BIconFileRichtextFill, BIconFileRuled, BIconFileRuledFill, BIconFileSlides, BIconFileSlidesFill, BIconFileSpreadsheet, BIconFileSpreadsheetFill, BIconFileText, BIconFileTextFill, BIconFileWord, BIconFileWordFill, BIconFileX, BIconFileXFill, BIconFileZip, BIconFileZipFill, BIconFiles, BIconFilesAlt, BIconFilm, BIconFilter, BIconFilterCircle, BIconFilterCircleFill, BIconFilterLeft, BIconFilterRight, BIconFilterSquare, BIconFilterSquareFill, BIconFlag, BIconFlagFill, BIconFlower1, BIconFlower2, BIconFlower3, BIconFolder, BIconFolder2, BIconFolder2Open, BIconFolderCheck, BIconFolderFill, BIconFolderMinus, BIconFolderPlus, BIconFolderSymlink, BIconFolderSymlinkFill, BIconFolderX, BIconFonts, BIconForward, BIconForwardFill, BIconFront, BIconFullscreen, BIconFullscreenExit, BIconFunnel, BIconFunnelFill, BIconGear, BIconGearFill, BIconGearWide, BIconGearWideConnected, BIconGem, BIconGenderAmbiguous, BIconGenderFemale, BIconGenderMale, BIconGenderTrans, BIconGeo, BIconGeoAlt, BIconGeoAltFill, BIconGeoFill, BIconGift, BIconGiftFill, BIconGithub, BIconGlobe, BIconGlobe2, BIconGoogle, BIconGraphDown, BIconGraphUp, BIconGrid, BIconGrid1x2, BIconGrid1x2Fill, BIconGrid3x2, BIconGrid3x2Gap, BIconGrid3x2GapFill, BIconGrid3x3, BIconGrid3x3Gap, BIconGrid3x3GapFill, BIconGridFill, BIconGripHorizontal, BIconGripVertical, BIconHammer, BIconHandIndex, BIconHandIndexFill, BIconHandIndexThumb, BIconHandIndexThumbFill, BIconHandThumbsDown, BIconHandThumbsDownFill, BIconHandThumbsUp, BIconHandThumbsUpFill, BIconHandbag, BIconHandbagFill, BIconHash, BIconHdd, BIconHddFill, BIconHddNetwork, BIconHddNetworkFill, BIconHddRack, BIconHddRackFill, BIconHddStack, BIconHddStackFill, BIconHeadphones, BIconHeadset, BIconHeadsetVr, BIconHeart, BIconHeartFill, BIconHeartHalf, BIconHeptagon, BIconHeptagonFill, BIconHeptagonHalf, BIconHexagon, BIconHexagonFill, BIconHexagonHalf, BIconHourglass, BIconHourglassBottom, BIconHourglassSplit, BIconHourglassTop, BIconHouse, BIconHouseDoor, BIconHouseDoorFill, BIconHouseFill, BIconHr, BIconHurricane, BIconImage, BIconImageAlt, BIconImageFill, BIconImages, BIconInbox, BIconInboxFill, BIconInboxes, BIconInboxesFill, BIconInfo, BIconInfoCircle, BIconInfoCircleFill, BIconInfoLg, BIconInfoSquare, BIconInfoSquareFill, BIconInputCursor, BIconInputCursorText, BIconInstagram, BIconIntersect, BIconJournal, BIconJournalAlbum, BIconJournalArrowDown, BIconJournalArrowUp, BIconJournalBookmark, BIconJournalBookmarkFill, BIconJournalCheck, BIconJournalCode, BIconJournalMedical, BIconJournalMinus, BIconJournalPlus, BIconJournalRichtext, BIconJournalText, BIconJournalX, BIconJournals, BIconJoystick, BIconJustify, BIconJustifyLeft, BIconJustifyRight, BIconKanban, BIconKanbanFill, BIconKey, BIconKeyFill, BIconKeyboard, BIconKeyboardFill, BIconLadder, BIconLamp, BIconLampFill, BIconLaptop, BIconLaptopFill, BIconLayerBackward, BIconLayerForward, BIconLayers, BIconLayersFill, BIconLayersHalf, BIconLayoutSidebar, BIconLayoutSidebarInset, BIconLayoutSidebarInsetReverse, BIconLayoutSidebarReverse, BIconLayoutSplit, BIconLayoutTextSidebar, BIconLayoutTextSidebarReverse, BIconLayoutTextWindow, BIconLayoutTextWindowReverse, BIconLayoutThreeColumns, BIconLayoutWtf, BIconLifePreserver, BIconLightbulb, BIconLightbulbFill, BIconLightbulbOff, BIconLightbulbOffFill, BIconLightning, BIconLightningCharge, BIconLightningChargeFill, BIconLightningFill, BIconLink, BIconLink45deg, BIconLinkedin, BIconList, BIconListCheck, BIconListNested, BIconListOl, BIconListStars, BIconListTask, BIconListUl, BIconLock, BIconLockFill, BIconMailbox, BIconMailbox2, BIconMap, BIconMapFill, BIconMarkdown, BIconMarkdownFill, BIconMask, BIconMastodon, BIconMegaphone, BIconMegaphoneFill, BIconMenuApp, BIconMenuAppFill, BIconMenuButton, BIconMenuButtonFill, BIconMenuButtonWide, BIconMenuButtonWideFill, BIconMenuDown, BIconMenuUp, BIconMessenger, BIconMic, BIconMicFill, BIconMicMute, BIconMicMuteFill, BIconMinecart, BIconMinecartLoaded, BIconMoisture, BIconMoon, BIconMoonFill, BIconMoonStars, BIconMoonStarsFill, BIconMouse, BIconMouse2, BIconMouse2Fill, BIconMouse3, BIconMouse3Fill, BIconMouseFill, BIconMusicNote, BIconMusicNoteBeamed, BIconMusicNoteList, BIconMusicPlayer, BIconMusicPlayerFill, BIconNewspaper, BIconNodeMinus, BIconNodeMinusFill, BIconNodePlus, BIconNodePlusFill, BIconNut, BIconNutFill, BIconOctagon, BIconOctagonFill, BIconOctagonHalf, BIconOption, BIconOutlet, BIconPaintBucket, BIconPalette, BIconPalette2, BIconPaletteFill, BIconPaperclip, BIconParagraph, BIconPatchCheck, BIconPatchCheckFill, BIconPatchExclamation, BIconPatchExclamationFill, BIconPatchMinus, BIconPatchMinusFill, BIconPatchPlus, BIconPatchPlusFill, BIconPatchQuestion, BIconPatchQuestionFill, BIconPause, BIconPauseBtn, BIconPauseBtnFill, BIconPauseCircle, BIconPauseCircleFill, BIconPauseFill, BIconPeace, BIconPeaceFill, BIconPen, BIconPenFill, BIconPencil, BIconPencilFill, BIconPencilSquare, BIconPentagon, BIconPentagonFill, BIconPentagonHalf, BIconPeople, BIconPeopleFill, BIconPercent, BIconPerson, BIconPersonBadge, BIconPersonBadgeFill, BIconPersonBoundingBox, BIconPersonCheck, BIconPersonCheckFill, BIconPersonCircle, BIconPersonDash, BIconPersonDashFill, BIconPersonFill, BIconPersonLinesFill, BIconPersonPlus, BIconPersonPlusFill, BIconPersonSquare, BIconPersonX, BIconPersonXFill, BIconPhone, BIconPhoneFill, BIconPhoneLandscape, BIconPhoneLandscapeFill, BIconPhoneVibrate, BIconPhoneVibrateFill, BIconPieChart, BIconPieChartFill, BIconPiggyBank, BIconPiggyBankFill, BIconPin, BIconPinAngle, BIconPinAngleFill, BIconPinFill, BIconPinMap, BIconPinMapFill, BIconPip, BIconPipFill, BIconPlay, BIconPlayBtn, BIconPlayBtnFill, BIconPlayCircle, BIconPlayCircleFill, BIconPlayFill, BIconPlug, BIconPlugFill, BIconPlus, BIconPlusCircle, BIconPlusCircleDotted, BIconPlusCircleFill, BIconPlusLg, BIconPlusSquare, BIconPlusSquareDotted, BIconPlusSquareFill, BIconPower, BIconPrinter, BIconPrinterFill, BIconPuzzle, BIconPuzzleFill, BIconQuestion, BIconQuestionCircle, BIconQuestionCircleFill, BIconQuestionDiamond, BIconQuestionDiamondFill, BIconQuestionLg, BIconQuestionOctagon, BIconQuestionOctagonFill, BIconQuestionSquare, BIconQuestionSquareFill, BIconRainbow, BIconReceipt, BIconReceiptCutoff, BIconReception0, BIconReception1, BIconReception2, BIconReception3, BIconReception4, BIconRecord, BIconRecord2, BIconRecord2Fill, BIconRecordBtn, BIconRecordBtnFill, BIconRecordCircle, BIconRecordCircleFill, BIconRecordFill, BIconRecycle, BIconReddit, BIconReply, BIconReplyAll, BIconReplyAllFill, BIconReplyFill, BIconRss, BIconRssFill, BIconRulers, BIconSafe, BIconSafe2, BIconSafe2Fill, BIconSafeFill, BIconSave, BIconSave2, BIconSave2Fill, BIconSaveFill, BIconScissors, BIconScrewdriver, BIconSdCard, BIconSdCardFill, BIconSearch, BIconSegmentedNav, BIconServer, BIconShare, BIconShareFill, BIconShield, BIconShieldCheck, BIconShieldExclamation, BIconShieldFill, BIconShieldFillCheck, BIconShieldFillExclamation, BIconShieldFillMinus, BIconShieldFillPlus, BIconShieldFillX, BIconShieldLock, BIconShieldLockFill, BIconShieldMinus, BIconShieldPlus, BIconShieldShaded, BIconShieldSlash, BIconShieldSlashFill, BIconShieldX, BIconShift, BIconShiftFill, BIconShop, BIconShopWindow, BIconShuffle, BIconSignpost, BIconSignpost2, BIconSignpost2Fill, BIconSignpostFill, BIconSignpostSplit, BIconSignpostSplitFill, BIconSim, BIconSimFill, BIconSkipBackward, BIconSkipBackwardBtn, BIconSkipBackwardBtnFill, BIconSkipBackwardCircle, BIconSkipBackwardCircleFill, BIconSkipBackwardFill, BIconSkipEnd, BIconSkipEndBtn, BIconSkipEndBtnFill, BIconSkipEndCircle, BIconSkipEndCircleFill, BIconSkipEndFill, BIconSkipForward, BIconSkipForwardBtn, BIconSkipForwardBtnFill, BIconSkipForwardCircle, BIconSkipForwardCircleFill, BIconSkipForwardFill, BIconSkipStart, BIconSkipStartBtn, BIconSkipStartBtnFill, BIconSkipStartCircle, BIconSkipStartCircleFill, BIconSkipStartFill, BIconSkype, BIconSlack, BIconSlash, BIconSlashCircle, BIconSlashCircleFill, BIconSlashLg, BIconSlashSquare, BIconSlashSquareFill, BIconSliders, BIconSmartwatch, BIconSnow, BIconSnow2, BIconSnow3, BIconSortAlphaDown, BIconSortAlphaDownAlt, BIconSortAlphaUp, BIconSortAlphaUpAlt, BIconSortDown, BIconSortDownAlt, BIconSortNumericDown, BIconSortNumericDownAlt, BIconSortNumericUp, BIconSortNumericUpAlt, BIconSortUp, BIconSortUpAlt, BIconSoundwave, BIconSpeaker, BIconSpeakerFill, BIconSpeedometer, BIconSpeedometer2, BIconSpellcheck, BIconSquare, BIconSquareFill, BIconSquareHalf, BIconStack, BIconStar, BIconStarFill, BIconStarHalf, BIconStars, BIconStickies, BIconStickiesFill, BIconSticky, BIconStickyFill, BIconStop, BIconStopBtn, BIconStopBtnFill, BIconStopCircle, BIconStopCircleFill, BIconStopFill, BIconStoplights, BIconStoplightsFill, BIconStopwatch, BIconStopwatchFill, BIconSubtract, BIconSuitClub, BIconSuitClubFill, BIconSuitDiamond, BIconSuitDiamondFill, BIconSuitHeart, BIconSuitHeartFill, BIconSuitSpade, BIconSuitSpadeFill, BIconSun, BIconSunFill, BIconSunglasses, BIconSunrise, BIconSunriseFill, BIconSunset, BIconSunsetFill, BIconSymmetryHorizontal, BIconSymmetryVertical, BIconTable, BIconTablet, BIconTabletFill, BIconTabletLandscape, BIconTabletLandscapeFill, BIconTag, BIconTagFill, BIconTags, BIconTagsFill, BIconTelegram, BIconTelephone, BIconTelephoneFill, BIconTelephoneForward, BIconTelephoneForwardFill, BIconTelephoneInbound, BIconTelephoneInboundFill, BIconTelephoneMinus, BIconTelephoneMinusFill, BIconTelephoneOutbound, BIconTelephoneOutboundFill, BIconTelephonePlus, BIconTelephonePlusFill, BIconTelephoneX, BIconTelephoneXFill, BIconTerminal, BIconTerminalFill, BIconTextCenter, BIconTextIndentLeft, BIconTextIndentRight, BIconTextLeft, BIconTextParagraph, BIconTextRight, BIconTextarea, BIconTextareaResize, BIconTextareaT, BIconThermometer, BIconThermometerHalf, BIconThermometerHigh, BIconThermometerLow, BIconThermometerSnow, BIconThermometerSun, BIconThreeDots, BIconThreeDotsVertical, BIconToggle2Off, BIconToggle2On, BIconToggleOff, BIconToggleOn, BIconToggles, BIconToggles2, BIconTools, BIconTornado, BIconTranslate, BIconTrash, BIconTrash2, BIconTrash2Fill, BIconTrashFill, BIconTree, BIconTreeFill, BIconTriangle, BIconTriangleFill, BIconTriangleHalf, BIconTrophy, BIconTrophyFill, BIconTropicalStorm, BIconTruck, BIconTruckFlatbed, BIconTsunami, BIconTv, BIconTvFill, BIconTwitch, BIconTwitter, BIconType, BIconTypeBold, BIconTypeH1, BIconTypeH2, BIconTypeH3, BIconTypeItalic, BIconTypeStrikethrough, BIconTypeUnderline, BIconUiChecks, BIconUiChecksGrid, BIconUiRadios, BIconUiRadiosGrid, BIconUmbrella, BIconUmbrellaFill, BIconUnion, BIconUnlock, BIconUnlockFill, BIconUpc, BIconUpcScan, BIconUpload, BIconVectorPen, BIconViewList, BIconViewStacked, BIconVinyl, BIconVinylFill, BIconVoicemail, BIconVolumeDown, BIconVolumeDownFill, BIconVolumeMute, BIconVolumeMuteFill, BIconVolumeOff, BIconVolumeOffFill, BIconVolumeUp, BIconVolumeUpFill, BIconVr, BIconWallet, BIconWallet2, BIconWalletFill, BIconWatch, BIconWater, BIconWhatsapp, BIconWifi, BIconWifi1, BIconWifi2, BIconWifiOff, BIconWind, BIconWindow, BIconWindowDock, BIconWindowSidebar, BIconWrench, BIconX, BIconXCircle, BIconXCircleFill, BIconXDiamond, BIconXDiamondFill, BIconXLg, BIconXOctagon, BIconXOctagonFill, BIconXSquare, BIconXSquareFill, BIconYoutube, BIconZoomIn, BIconZoomOut */
/* all exports used */
/*!**************************************!*\
  !*** ./~/bootstrap-vue/esm/index.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAME", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BootstrapVue", function() { return BootstrapVue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(/*! ./utils/plugins */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(/*! ./components */ 925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(/*! ./directives */ 946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bv_config__ = __webpack_require__(/*! ./bv-config */ 922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BVConfigPlugin", function() { return __WEBPACK_IMPORTED_MODULE_3__bv_config__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BVConfig", function() { return __WEBPACK_IMPORTED_MODULE_3__bv_config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modal_helpers_bv_modal__ = __webpack_require__(/*! ./components/modal/helpers/bv-modal */ 397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BVModalPlugin", function() { return __WEBPACK_IMPORTED_MODULE_4__components_modal_helpers_bv_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toast_helpers_bv_toast__ = __webpack_require__(/*! ./components/toast/helpers/bv-toast */ 443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BVToastPlugin", function() { return __WEBPACK_IMPORTED_MODULE_5__components_toast_helpers_bv_toast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_plugin__ = __webpack_require__(/*! ./icons/plugin */ 456);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IconsPlugin", function() { return __WEBPACK_IMPORTED_MODULE_6__icons_plugin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BootstrapVueIcons", function() { return __WEBPACK_IMPORTED_MODULE_6__icons_plugin__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons_icon__ = __webpack_require__(/*! ./icons/icon */ 138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BIcon", function() { return __WEBPACK_IMPORTED_MODULE_7__icons_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_iconstack__ = __webpack_require__(/*! ./icons/iconstack */ 250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BIconstack", function() { return __WEBPACK_IMPORTED_MODULE_8__icons_iconstack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icons_icons__ = __webpack_require__(/*! ./icons/icons */ 61);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBlank", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlarm", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlarmFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlignBottom", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlignCenter", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlignEnd", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlignMiddle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlignStart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlignTop", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconApp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAppIndicator", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArchive", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArchiveFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrow90degDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrow90degLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrow90degRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrow90degUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowBarDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowBarLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowBarRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowBarUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowClockwise", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowCounterclockwise", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownLeftCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownLeftCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownLeftSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownLeftSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownRightCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownRightCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownRightSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownRightSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownShort", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["M"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["N"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowDownUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["O"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["P"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowLeftCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["Q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowLeftCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["R"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowLeftRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["S"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowLeftShort", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["T"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowLeftSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["U"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowLeftSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["V"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowRepeat", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["W"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowReturnLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["X"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowReturnRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["Y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["Z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowRightCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_0"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowRightCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowRightShort", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_2"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowRightSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_3"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowRightSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_4"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_5"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_6"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_7"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_8"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpLeftCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_9"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpLeftCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_10"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpLeftSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_11"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpLeftSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_12"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_13"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpRightCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_14"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpRightCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_15"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpRightSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_16"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpRightSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_17"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpShort", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_18"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_19"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowUpSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_20"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowsAngleContract", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_21"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowsAngleExpand", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_22"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowsCollapse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_23"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowsExpand", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_24"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowsFullscreen", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_25"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconArrowsMove", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_26"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAspectRatio", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_27"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAspectRatioFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_28"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAsterisk", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_29"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_30"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAward", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_31"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconAwardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_32"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBack", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_33"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBackspace", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_34"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBackspaceFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_35"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBackspaceReverse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_36"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBackspaceReverseFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_37"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadge3d", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_38"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadge3dFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_39"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadge4k", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_40"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadge4kFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_41"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadge8k", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_42"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadge8kFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_43"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeAd", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_44"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeAdFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_45"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeAr", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_46"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeArFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_47"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeCc", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_48"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeCcFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_49"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeHd", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_50"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeHdFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_51"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeTm", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_52"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeTmFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_53"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeVo", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_54"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeVoFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_55"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeVr", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_56"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeVrFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_57"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeWc", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_58"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBadgeWcFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_59"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBag", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_60"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_61"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_62"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagDash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_63"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagDashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_64"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_65"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_66"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_67"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_68"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBagXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_69"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBank", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_70"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBank2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_71"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBarChart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_72"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBarChartFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_73"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBarChartLine", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_74"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBarChartLineFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_75"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBarChartSteps", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_76"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBasket", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_77"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBasket2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_78"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBasket2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_79"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBasket3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_80"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBasket3Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_81"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBasketFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_82"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBattery", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_83"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBatteryCharging", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_84"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBatteryFull", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_85"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBatteryHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_86"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBell", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_87"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBellFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_88"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBellSlash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_89"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBellSlashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_90"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBezier", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_91"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBezier2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_92"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBicycle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_93"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBinoculars", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_94"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBinocularsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_95"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBlockquoteLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_96"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBlockquoteRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_97"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBook", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_98"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_99"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_100"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmark", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_101"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_102"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_103"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkDash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_104"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkDashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_105"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_106"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkHeart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_107"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkHeartFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_108"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_109"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_110"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkStar", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_111"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkStarFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_112"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_113"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarkXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_114"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarks", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_115"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookmarksFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_116"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBookshelf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_117"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBootstrap", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_118"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBootstrapFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_119"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBootstrapReboot", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_120"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorder", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_121"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderAll", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_122"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderBottom", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_123"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderCenter", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_124"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderInner", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_125"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_126"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderMiddle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_127"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderOuter", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_128"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_129"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderStyle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_130"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderTop", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_131"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBorderWidth", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_132"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoundingBox", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_133"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoundingBoxCircles", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_134"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBox", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_135"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_136"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowDownLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_137"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowDownRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_138"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_139"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInDownLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_140"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInDownRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_141"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_142"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_143"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_144"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInUpLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_145"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowInUpRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_146"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_147"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_148"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_149"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowUpLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_150"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxArrowUpRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_151"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBoxSeam", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_152"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBraces", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_153"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBricks", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_154"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBriefcase", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_155"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBriefcaseFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_156"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessAltHigh", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_157"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessAltHighFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_158"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessAltLow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_159"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessAltLowFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_160"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessHigh", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_161"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessHighFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_162"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessLow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_163"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrightnessLowFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_164"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBroadcast", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_165"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBroadcastPin", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_166"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrush", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_167"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBrushFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_168"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBucket", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_169"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBucketFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_170"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBug", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_171"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBugFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_172"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBuilding", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_173"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconBullseye", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_174"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalculator", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_175"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalculatorFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_176"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_177"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_178"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Check", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_179"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2CheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_180"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Date", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_181"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2DateFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_182"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Day", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_183"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2DayFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_184"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Event", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_185"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2EventFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_186"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_187"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Minus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_188"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2MinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_189"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Month", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_190"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2MonthFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_191"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Plus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_192"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2PlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_193"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Range", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_194"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2RangeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_195"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2Week", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_196"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2WeekFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_197"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2X", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_198"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar2XFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_199"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_200"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3Event", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_201"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3EventFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_202"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_203"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3Range", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_204"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3RangeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_205"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3Week", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_206"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar3WeekFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_207"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar4", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_208"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar4Event", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_209"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar4Range", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_210"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendar4Week", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_211"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_212"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_213"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarDate", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_214"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarDateFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_215"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarDay", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_216"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarDayFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_217"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarEvent", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_218"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarEventFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_219"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_220"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_221"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarMinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_222"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarMonth", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_223"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarMonthFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_224"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_225"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_226"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarRange", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_227"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarRangeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_228"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarWeek", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_229"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarWeekFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_230"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_231"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCalendarXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_232"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCamera", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_233"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCamera2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_234"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCameraFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_235"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCameraReels", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_236"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCameraReelsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_237"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCameraVideo", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_238"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCameraVideoFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_239"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCameraVideoOff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_240"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCameraVideoOffFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_241"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCapslock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_242"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCapslockFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_243"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCardChecklist", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_244"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCardHeading", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_245"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCardImage", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_246"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCardList", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_247"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCardText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_248"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_249"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretDownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_250"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretDownSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_251"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretDownSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_252"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_253"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretLeftFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_254"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretLeftSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_255"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretLeftSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_256"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_257"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretRightFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_258"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretRightSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_259"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretRightSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_260"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_261"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretUpFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_262"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretUpSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_263"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCaretUpSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_264"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_265"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCart2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_266"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCart3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_267"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCart4", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_268"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_269"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_270"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartDash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_271"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartDashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_272"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_273"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_274"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_275"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_276"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCartXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_277"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_278"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCashCoin", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_279"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCashStack", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_280"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCast", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_281"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChat", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_282"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatDots", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_283"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatDotsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_284"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_285"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_286"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeftDots", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_287"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeftDotsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_288"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeftFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_289"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeftQuote", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_290"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeftQuoteFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_291"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeftText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_292"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatLeftTextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_293"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatQuote", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_294"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatQuoteFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_295"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_296"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRightDots", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_297"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRightDotsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_298"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRightFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_299"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRightQuote", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_300"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRightQuoteFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_301"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRightText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_302"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatRightTextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_303"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_304"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquareDots", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_305"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquareDotsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_306"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_307"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquareQuote", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_308"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquareQuoteFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_309"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquareText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_310"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatSquareTextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_311"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_312"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChatTextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_313"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_314"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheck2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_315"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheck2All", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_316"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheck2Circle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_317"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheck2Square", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_318"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheckAll", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_319"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheckCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_320"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheckCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_321"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheckLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_322"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheckSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_323"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCheckSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_324"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronBarContract", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_325"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronBarDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_326"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronBarExpand", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_327"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronBarLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_328"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronBarRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_329"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronBarUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_330"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronCompactDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_331"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronCompactLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_332"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronCompactRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_333"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronCompactUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_334"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronContract", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_335"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronDoubleDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_336"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronDoubleLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_337"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronDoubleRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_338"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronDoubleUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_339"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_340"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronExpand", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_341"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_342"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_343"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconChevronUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_344"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_345"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_346"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCircleHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_347"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCircleSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_348"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClipboard", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_349"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClipboardCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_350"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClipboardData", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_351"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClipboardMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_352"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClipboardPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_353"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClipboardX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_354"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_355"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClockFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_356"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClockHistory", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_357"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloud", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_358"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudArrowDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_359"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudArrowDownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_360"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudArrowUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_361"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudArrowUpFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_362"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_363"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_364"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudDownload", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_365"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudDownloadFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_366"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudDrizzle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_367"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudDrizzleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_368"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_369"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudFog", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_370"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudFog2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_371"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudFog2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_372"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudFogFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_373"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudHail", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_374"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudHailFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_375"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudHaze", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_376"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudHaze1", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_377"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudHaze2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_378"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudHazeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_379"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudLightning", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_380"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudLightningFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_381"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudLightningRain", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_382"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudLightningRainFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_383"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_384"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudMinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_385"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudMoon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_386"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudMoonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_387"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_388"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_389"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudRain", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_390"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudRainFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_391"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudRainHeavy", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_392"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudRainHeavyFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_393"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSlash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_394"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSlashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_395"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSleet", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_396"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSleetFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_397"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSnow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_398"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSnowFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_399"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSun", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_400"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudSunFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_401"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudUpload", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_402"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudUploadFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_403"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconClouds", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_404"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_405"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudy", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_406"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCloudyFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_407"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCode", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_408"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCodeSlash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_409"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCodeSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_410"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCoin", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_411"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCollection", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_412"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCollectionFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_413"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCollectionPlay", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_414"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCollectionPlayFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_415"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconColumns", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_416"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconColumnsGap", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_417"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCommand", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_418"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCompass", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_419"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCompassFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_420"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCone", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_421"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconConeStriped", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_422"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconController", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_423"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCpu", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_424"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCpuFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_425"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCreditCard", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_426"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCreditCard2Back", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_427"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCreditCard2BackFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_428"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCreditCard2Front", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_429"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCreditCard2FrontFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_430"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCreditCardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_431"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCrop", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_432"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCup", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_433"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCupFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_434"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCupStraw", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_435"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCurrencyBitcoin", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_436"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCurrencyDollar", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_437"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCurrencyEuro", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_438"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCurrencyExchange", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_439"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCurrencyPound", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_440"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCurrencyYen", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_441"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCursor", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_442"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCursorFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_443"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconCursorText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_444"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_445"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDashCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_446"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDashCircleDotted", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_447"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDashCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_448"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDashLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_449"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDashSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_450"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDashSquareDotted", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_451"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDashSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_452"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiagram2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_453"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiagram2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_454"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiagram3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_455"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiagram3Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_456"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiamond", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_457"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiamondFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_458"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiamondHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_459"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice1", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_460"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice1Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_461"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_462"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_463"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_464"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice3Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_465"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice4", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_466"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice4Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_467"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice5", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_468"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice5Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_469"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice6", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_470"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDice6Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_471"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDisc", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_472"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiscFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_473"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDiscord", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_474"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDisplay", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_475"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDisplayFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_476"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDistributeHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_477"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDistributeVertical", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_478"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDoorClosed", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_479"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDoorClosedFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_480"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDoorOpen", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_481"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDoorOpenFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_482"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDot", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_483"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDownload", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_484"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDroplet", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_485"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDropletFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_486"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconDropletHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_487"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEarbuds", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_488"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEasel", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_489"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEaselFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_490"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEgg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_491"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEggFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_492"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEggFried", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_493"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEject", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_494"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEjectFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_495"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiAngry", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_496"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiAngryFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_497"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiDizzy", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_498"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiDizzyFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_499"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiExpressionless", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_500"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiExpressionlessFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_501"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiFrown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_502"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiFrownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_503"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiHeartEyes", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_504"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiHeartEyesFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_505"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiLaughing", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_506"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiLaughingFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_507"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiNeutral", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_508"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiNeutralFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_509"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiSmile", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_510"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiSmileFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_511"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiSmileUpsideDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_512"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiSmileUpsideDownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_513"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiSunglasses", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_514"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiSunglassesFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_515"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiWink", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_516"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEmojiWinkFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_517"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEnvelope", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_518"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEnvelopeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_519"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEnvelopeOpen", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_520"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEnvelopeOpenFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_521"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEraser", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_522"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEraserFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_523"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamation", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_524"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_525"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_526"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationDiamond", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_527"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationDiamondFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_528"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_529"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationOctagon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_530"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationOctagonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_531"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_532"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_533"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationTriangle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_534"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclamationTriangleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_535"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconExclude", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_536"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEye", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_537"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEyeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_538"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEyeSlash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_539"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEyeSlashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_540"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEyedropper", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_541"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconEyeglasses", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_542"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFacebook", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_543"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFile", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_544"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileArrowDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_545"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileArrowDownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_546"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileArrowUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_547"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileArrowUpFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_548"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileBarGraph", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_549"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileBarGraphFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_550"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileBinary", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_551"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileBinaryFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_552"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileBreak", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_553"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileBreakFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_554"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_555"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_556"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileCode", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_557"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileCodeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_558"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileDiff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_559"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileDiffFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_560"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmark", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_561"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkArrowDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_562"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkArrowDownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_563"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkArrowUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_564"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkArrowUpFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_565"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkBarGraph", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_566"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkBarGraphFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_567"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkBinary", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_568"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkBinaryFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_569"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkBreak", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_570"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkBreakFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_571"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_572"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_573"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkCode", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_574"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkCodeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_575"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkDiff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_576"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkDiffFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_577"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkEasel", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_578"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkEaselFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_579"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkExcel", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_580"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkExcelFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_581"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_582"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkFont", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_583"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkFontFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_584"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkImage", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_585"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkImageFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_586"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkLock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_587"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkLock2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_588"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkLock2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_589"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkLockFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_590"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkMedical", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_591"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkMedicalFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_592"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_593"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkMinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_594"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkMusic", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_595"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkMusicFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_596"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPdf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_597"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPdfFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_598"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPerson", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_599"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPersonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_600"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPlay", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_601"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPlayFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_602"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_603"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_604"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPost", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_605"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPostFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_606"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPpt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_607"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkPptFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_608"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkRichtext", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_609"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkRichtextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_610"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkRuled", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_611"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkRuledFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_612"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkSlides", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_613"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkSlidesFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_614"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkSpreadsheet", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_615"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkSpreadsheetFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_616"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_617"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkTextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_618"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkWord", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_619"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkWordFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_620"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_621"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_622"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkZip", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_623"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEarmarkZipFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_624"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEasel", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_625"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileEaselFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_626"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileExcel", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_627"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileExcelFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_628"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_629"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileFont", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_630"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileFontFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_631"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileImage", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_632"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileImageFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_633"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileLock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_634"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileLock2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_635"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileLock2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_636"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileLockFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_637"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileMedical", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_638"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileMedicalFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_639"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_640"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileMinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_641"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileMusic", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_642"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileMusicFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_643"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePdf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_644"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePdfFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_645"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePerson", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_646"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePersonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_647"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePlay", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_648"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePlayFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_649"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_650"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_651"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePost", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_652"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePostFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_653"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePpt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_654"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilePptFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_655"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileRichtext", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_656"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileRichtextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_657"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileRuled", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_658"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileRuledFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_659"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileSlides", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_660"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileSlidesFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_661"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileSpreadsheet", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_662"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileSpreadsheetFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_663"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_664"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileTextFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_665"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileWord", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_666"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileWordFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_667"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_668"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_669"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileZip", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_670"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFileZipFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_671"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFiles", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_672"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilesAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_673"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilm", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_674"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilter", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_675"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilterCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_676"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilterCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_677"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilterLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_678"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilterRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_679"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilterSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_680"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFilterSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_681"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFlag", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_682"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFlagFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_683"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFlower1", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_684"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFlower2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_685"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFlower3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_686"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolder", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_687"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolder2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_688"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolder2Open", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_689"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolderCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_690"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolderFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_691"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolderMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_692"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolderPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_693"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolderSymlink", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_694"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolderSymlinkFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_695"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFolderX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_696"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFonts", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_697"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconForward", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_698"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconForwardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_699"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFront", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_700"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFullscreen", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_701"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFullscreenExit", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_702"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFunnel", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_703"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconFunnelFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_704"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGear", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_705"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGearFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_706"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGearWide", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_707"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGearWideConnected", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_708"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGem", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_709"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGenderAmbiguous", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_710"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGenderFemale", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_711"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGenderMale", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_712"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGenderTrans", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_713"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGeo", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_714"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGeoAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_715"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGeoAltFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_716"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGeoFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_717"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGift", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_718"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGiftFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_719"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGithub", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_720"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGlobe", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_721"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGlobe2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_722"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGoogle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_723"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGraphDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_724"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGraphUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_725"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_726"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid1x2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_727"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid1x2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_728"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid3x2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_729"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid3x2Gap", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_730"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid3x2GapFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_731"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid3x3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_732"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid3x3Gap", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_733"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGrid3x3GapFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_734"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGridFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_735"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGripHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_736"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconGripVertical", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_737"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHammer", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_738"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandIndex", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_739"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandIndexFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_740"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandIndexThumb", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_741"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandIndexThumbFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_742"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandThumbsDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_743"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandThumbsDownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_744"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandThumbsUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_745"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandThumbsUpFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_746"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandbag", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_747"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHandbagFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_748"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_749"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHdd", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_750"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHddFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_751"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHddNetwork", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_752"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHddNetworkFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_753"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHddRack", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_754"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHddRackFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_755"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHddStack", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_756"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHddStackFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_757"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeadphones", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_758"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeadset", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_759"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeadsetVr", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_760"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_761"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeartFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_762"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeartHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_763"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeptagon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_764"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeptagonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_765"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHeptagonHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_766"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHexagon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_767"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHexagonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_768"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHexagonHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_769"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHourglass", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_770"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHourglassBottom", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_771"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHourglassSplit", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_772"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHourglassTop", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_773"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHouse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_774"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHouseDoor", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_775"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHouseDoorFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_776"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHouseFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_777"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHr", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_778"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconHurricane", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_779"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconImage", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_780"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconImageAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_781"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconImageFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_782"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconImages", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_783"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInbox", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_784"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInboxFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_785"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInboxes", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_786"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInboxesFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_787"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInfo", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_788"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInfoCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_789"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInfoCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_790"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInfoLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_791"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInfoSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_792"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInfoSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_793"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInputCursor", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_794"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInputCursorText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_795"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconInstagram", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_796"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconIntersect", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_797"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournal", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_798"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalAlbum", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_799"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalArrowDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_800"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalArrowUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_801"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalBookmark", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_802"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalBookmarkFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_803"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_804"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalCode", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_805"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalMedical", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_806"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_807"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_808"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalRichtext", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_809"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalText", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_810"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournalX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_811"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJournals", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_812"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJoystick", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_813"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJustify", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_814"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJustifyLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_815"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconJustifyRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_816"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconKanban", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_817"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconKanbanFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_818"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconKey", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_819"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconKeyFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_820"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconKeyboard", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_821"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconKeyboardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_822"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLadder", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_823"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLamp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_824"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLampFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_825"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLaptop", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_826"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLaptopFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_827"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayerBackward", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_828"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayerForward", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_829"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayers", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_830"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayersFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_831"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayersHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_832"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutSidebar", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_833"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutSidebarInset", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_834"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutSidebarInsetReverse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_835"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutSidebarReverse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_836"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutSplit", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_837"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutTextSidebar", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_838"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutTextSidebarReverse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_839"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutTextWindow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_840"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutTextWindowReverse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_841"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutThreeColumns", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_842"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLayoutWtf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_843"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLifePreserver", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_844"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightbulb", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_845"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightbulbFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_846"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightbulbOff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_847"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightbulbOffFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_848"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightning", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_849"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightningCharge", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_850"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightningChargeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_851"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLightningFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_852"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLink", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_853"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLink45deg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_854"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLinkedin", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_855"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconList", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_856"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconListCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_857"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconListNested", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_858"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconListOl", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_859"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconListStars", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_860"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconListTask", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_861"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconListUl", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_862"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_863"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconLockFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_864"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMailbox", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_865"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMailbox2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_866"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMap", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_867"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMapFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_868"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMarkdown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_869"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMarkdownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_870"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMask", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_871"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMastodon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_872"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMegaphone", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_873"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMegaphoneFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_874"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuApp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_875"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuAppFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_876"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuButton", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_877"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuButtonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_878"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuButtonWide", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_879"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuButtonWideFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_880"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_881"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMenuUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_882"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMessenger", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_883"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMic", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_884"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMicFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_885"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMicMute", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_886"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMicMuteFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_887"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMinecart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_888"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMinecartLoaded", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_889"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMoisture", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_890"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMoon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_891"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMoonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_892"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMoonStars", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_893"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMoonStarsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_894"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMouse", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_895"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMouse2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_896"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMouse2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_897"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMouse3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_898"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMouse3Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_899"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMouseFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_900"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMusicNote", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_901"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMusicNoteBeamed", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_902"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMusicNoteList", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_903"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMusicPlayer", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_904"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconMusicPlayerFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_905"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconNewspaper", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_906"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconNodeMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_907"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconNodeMinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_908"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconNodePlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_909"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconNodePlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_910"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconNut", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_911"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconNutFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_912"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconOctagon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_913"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconOctagonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_914"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconOctagonHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_915"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconOption", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_916"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconOutlet", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_917"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPaintBucket", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_918"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPalette", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_919"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPalette2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_920"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPaletteFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_921"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPaperclip", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_922"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconParagraph", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_923"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_924"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_925"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchExclamation", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_926"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchExclamationFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_927"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_928"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchMinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_929"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_930"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_931"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchQuestion", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_932"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPatchQuestionFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_933"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPause", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_934"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPauseBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_935"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPauseBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_936"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPauseCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_937"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPauseCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_938"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPauseFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_939"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPeace", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_940"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPeaceFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_941"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPen", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_942"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPenFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_943"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPencil", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_944"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPencilFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_945"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPencilSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_946"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPentagon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_947"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPentagonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_948"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPentagonHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_949"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPeople", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_950"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPeopleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_951"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPercent", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_952"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPerson", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_953"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonBadge", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_954"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonBadgeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_955"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonBoundingBox", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_956"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_957"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonCheckFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_958"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_959"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonDash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_960"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonDashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_961"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_962"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonLinesFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_963"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_964"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonPlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_965"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_966"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_967"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPersonXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_968"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPhone", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_969"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPhoneFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_970"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPhoneLandscape", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_971"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPhoneLandscapeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_972"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPhoneVibrate", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_973"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPhoneVibrateFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_974"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPieChart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_975"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPieChartFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_976"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPiggyBank", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_977"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPiggyBankFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_978"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPin", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_979"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPinAngle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_980"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPinAngleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_981"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPinFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_982"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPinMap", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_983"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPinMapFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_984"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPip", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_985"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPipFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_986"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlay", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_987"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlayBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_988"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlayBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_989"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlayCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_990"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlayCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_991"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlayFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_992"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlug", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_993"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlugFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_994"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_995"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlusCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_996"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlusCircleDotted", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_997"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlusCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_998"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlusLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_999"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlusSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1000"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlusSquareDotted", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1001"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPlusSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1002"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPower", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1003"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPrinter", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1004"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPrinterFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1005"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPuzzle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1006"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconPuzzleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1007"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestion", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1008"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1009"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1010"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionDiamond", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1011"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionDiamondFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1012"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1013"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionOctagon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1014"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionOctagonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1015"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1016"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconQuestionSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1017"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRainbow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1018"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReceipt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1019"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReceiptCutoff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1020"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReception0", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1021"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReception1", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1022"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReception2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1023"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReception3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1024"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReception4", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1025"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecord", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1026"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecord2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1027"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecord2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1028"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecordBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1029"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecordBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1030"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecordCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1031"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecordCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1032"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecordFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1033"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRecycle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1034"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReddit", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1035"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReply", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1036"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReplyAll", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1037"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReplyAllFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1038"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconReplyFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1039"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRss", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1040"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRssFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1041"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconRulers", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1042"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSafe", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1043"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSafe2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1044"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSafe2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1045"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSafeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1046"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSave", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1047"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSave2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1048"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSave2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1049"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSaveFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1050"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconScissors", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1051"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconScrewdriver", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1052"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSdCard", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1053"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSdCardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1054"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSearch", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1055"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSegmentedNav", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1056"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconServer", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1057"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1058"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1059"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShield", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1060"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1061"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldExclamation", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1062"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1063"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldFillCheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1064"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldFillExclamation", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1065"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldFillMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1066"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldFillPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1067"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldFillX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1068"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldLock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1069"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldLockFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1070"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1071"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldPlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1072"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldShaded", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1073"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldSlash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1074"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldSlashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1075"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShieldX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1076"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShift", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1077"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShiftFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1078"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShop", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1079"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShopWindow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1080"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconShuffle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1081"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSignpost", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1082"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSignpost2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1083"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSignpost2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1084"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSignpostFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1085"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSignpostSplit", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1086"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSignpostSplitFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1087"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSim", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1088"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSimFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1089"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipBackward", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1090"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipBackwardBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1091"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipBackwardBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1092"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipBackwardCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1093"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipBackwardCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1094"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipBackwardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1095"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipEnd", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1096"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipEndBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1097"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipEndBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1098"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipEndCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1099"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipEndCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1100"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipEndFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1101"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipForward", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1102"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipForwardBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1103"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipForwardBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1104"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipForwardCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1105"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipForwardCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1106"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipForwardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1107"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipStart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1108"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipStartBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1109"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipStartBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1110"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipStartCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1111"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipStartCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1112"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkipStartFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1113"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSkype", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1114"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSlack", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1115"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSlash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1116"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSlashCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1117"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSlashCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1118"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSlashLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1119"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSlashSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1120"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSlashSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1121"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSliders", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1122"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSmartwatch", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1123"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSnow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1124"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSnow2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1125"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSnow3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1126"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortAlphaDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1127"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortAlphaDownAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1128"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortAlphaUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1129"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortAlphaUpAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1130"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1131"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortDownAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1132"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortNumericDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1133"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortNumericDownAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1134"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortNumericUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1135"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortNumericUpAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1136"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1137"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSortUpAlt", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1138"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSoundwave", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1139"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSpeaker", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1140"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSpeakerFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1141"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSpeedometer", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1142"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSpeedometer2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1143"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSpellcheck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1144"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1145"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1146"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSquareHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1147"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStack", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1148"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStar", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1149"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStarFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1150"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStarHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1151"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStars", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1152"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStickies", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1153"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStickiesFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1154"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSticky", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1155"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStickyFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1156"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStop", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1157"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStopBtn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1158"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStopBtnFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1159"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStopCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1160"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStopCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1161"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStopFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1162"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStoplights", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1163"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStoplightsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1164"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStopwatch", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1165"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconStopwatchFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1166"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSubtract", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1167"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitClub", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1168"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitClubFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1169"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitDiamond", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1170"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitDiamondFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1171"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitHeart", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1172"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitHeartFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1173"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitSpade", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1174"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSuitSpadeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1175"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSun", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1176"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSunFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1177"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSunglasses", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1178"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSunrise", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1179"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSunriseFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1180"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSunset", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1181"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSunsetFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1182"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSymmetryHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1183"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconSymmetryVertical", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1184"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTable", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1185"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTablet", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1186"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTabletFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1187"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTabletLandscape", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1188"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTabletLandscapeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1189"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTag", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1190"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTagFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1191"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTags", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1192"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTagsFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1193"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelegram", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1194"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephone", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1195"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1196"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneForward", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1197"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneForwardFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1198"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneInbound", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1199"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneInboundFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1200"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneMinus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1201"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneMinusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1202"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneOutbound", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1203"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneOutboundFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1204"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephonePlus", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1205"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephonePlusFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1206"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1207"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTelephoneXFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1208"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTerminal", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1209"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTerminalFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1210"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextCenter", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1211"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextIndentLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1212"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextIndentRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1213"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextLeft", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1214"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextParagraph", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1215"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextRight", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1216"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextarea", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1217"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextareaResize", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1218"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTextareaT", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1219"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThermometer", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1220"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThermometerHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1221"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThermometerHigh", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1222"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThermometerLow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1223"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThermometerSnow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1224"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThermometerSun", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1225"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThreeDots", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1226"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconThreeDotsVertical", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1227"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconToggle2Off", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1228"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconToggle2On", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1229"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconToggleOff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1230"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconToggleOn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1231"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconToggles", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1232"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconToggles2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1233"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTools", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1234"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTornado", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1235"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTranslate", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1236"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTrash", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1237"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTrash2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1238"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTrash2Fill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1239"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTrashFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1240"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTree", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1241"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTreeFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1242"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTriangle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1243"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTriangleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1244"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTriangleHalf", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1245"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTrophy", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1246"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTrophyFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1247"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTropicalStorm", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1248"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTruck", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1249"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTruckFlatbed", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1250"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTsunami", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1251"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTv", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1252"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTvFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1253"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTwitch", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1254"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTwitter", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1255"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconType", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1256"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTypeBold", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1257"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTypeH1", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1258"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTypeH2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1259"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTypeH3", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1260"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTypeItalic", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1261"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTypeStrikethrough", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1262"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconTypeUnderline", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1263"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUiChecks", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1264"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUiChecksGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1265"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUiRadios", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1266"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUiRadiosGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1267"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUmbrella", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1268"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUmbrellaFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1269"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUnion", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1270"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUnlock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1271"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUnlockFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1272"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUpc", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1273"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUpcScan", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1274"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconUpload", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1275"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVectorPen", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1276"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconViewList", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1277"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconViewStacked", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1278"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVinyl", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1279"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVinylFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1280"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVoicemail", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1281"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeDown", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1282"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeDownFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1283"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeMute", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1284"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeMuteFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1285"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeOff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1286"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeOffFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1287"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeUp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1288"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVolumeUpFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1289"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconVr", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1290"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWallet", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1291"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWallet2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1292"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWalletFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1293"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWatch", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1294"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWater", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1295"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWhatsapp", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1296"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWifi", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1297"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWifi1", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1298"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWifi2", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1299"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWifiOff", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1300"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWind", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1301"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWindow", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1302"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWindowDock", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1303"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWindowSidebar", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1304"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconWrench", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1305"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconX", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1306"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1307"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXCircleFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1308"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXDiamond", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1309"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXDiamondFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1310"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXLg", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1311"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXOctagon", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1312"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXOctagonFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1313"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXSquare", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1314"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconXSquareFill", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1315"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconYoutube", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1316"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconZoomIn", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1317"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BIconZoomOut", function() { return __WEBPACK_IMPORTED_MODULE_9__icons_icons__["_1318"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_alert__ = __webpack_require__(/*! ./components/alert */ 326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlertPlugin", function() { return __WEBPACK_IMPORTED_MODULE_10__components_alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_alert_alert__ = __webpack_require__(/*! ./components/alert/alert */ 325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BAlert", function() { return __WEBPACK_IMPORTED_MODULE_11__components_alert_alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_aspect__ = __webpack_require__(/*! ./components/aspect */ 205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AspectPlugin", function() { return __WEBPACK_IMPORTED_MODULE_12__components_aspect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_aspect_aspect__ = __webpack_require__(/*! ./components/aspect/aspect */ 327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BAspect", function() { return __WEBPACK_IMPORTED_MODULE_13__components_aspect_aspect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_avatar__ = __webpack_require__(/*! ./components/avatar */ 329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AvatarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_14__components_avatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_avatar_avatar__ = __webpack_require__(/*! ./components/avatar/avatar */ 206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BAvatar", function() { return __WEBPACK_IMPORTED_MODULE_15__components_avatar_avatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_avatar_avatar_group__ = __webpack_require__(/*! ./components/avatar/avatar-group */ 328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BAvatarGroup", function() { return __WEBPACK_IMPORTED_MODULE_16__components_avatar_avatar_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_badge__ = __webpack_require__(/*! ./components/badge */ 330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BadgePlugin", function() { return __WEBPACK_IMPORTED_MODULE_17__components_badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_badge_badge__ = __webpack_require__(/*! ./components/badge/badge */ 207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BBadge", function() { return __WEBPACK_IMPORTED_MODULE_18__components_badge_badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_breadcrumb__ = __webpack_require__(/*! ./components/breadcrumb */ 333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbPlugin", function() { return __WEBPACK_IMPORTED_MODULE_19__components_breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_breadcrumb_breadcrumb__ = __webpack_require__(/*! ./components/breadcrumb/breadcrumb */ 332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BBreadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_20__components_breadcrumb_breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_breadcrumb_breadcrumb_item__ = __webpack_require__(/*! ./components/breadcrumb/breadcrumb-item */ 208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BBreadcrumbItem", function() { return __WEBPACK_IMPORTED_MODULE_21__components_breadcrumb_breadcrumb_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_button__ = __webpack_require__(/*! ./components/button */ 338);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonPlugin", function() { return __WEBPACK_IMPORTED_MODULE_22__components_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_button_button__ = __webpack_require__(/*! ./components/button/button */ 85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BButton", function() { return __WEBPACK_IMPORTED_MODULE_23__components_button_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_button_button_close__ = __webpack_require__(/*! ./components/button/button-close */ 107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BButtonClose", function() { return __WEBPACK_IMPORTED_MODULE_24__components_button_button_close__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_button_group__ = __webpack_require__(/*! ./components/button-group */ 335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupPlugin", function() { return __WEBPACK_IMPORTED_MODULE_25__components_button_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_button_group_button_group__ = __webpack_require__(/*! ./components/button-group/button-group */ 334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_26__components_button_group_button_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_button_toolbar__ = __webpack_require__(/*! ./components/button-toolbar */ 337);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_27__components_button_toolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_button_toolbar_button_toolbar__ = __webpack_require__(/*! ./components/button-toolbar/button-toolbar */ 336);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BButtonToolbar", function() { return __WEBPACK_IMPORTED_MODULE_28__components_button_toolbar_button_toolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_calendar__ = __webpack_require__(/*! ./components/calendar */ 339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CalendarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_29__components_calendar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_calendar_calendar__ = __webpack_require__(/*! ./components/calendar/calendar */ 209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCalendar", function() { return __WEBPACK_IMPORTED_MODULE_30__components_calendar_calendar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_card__ = __webpack_require__(/*! ./components/card */ 344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardPlugin", function() { return __WEBPACK_IMPORTED_MODULE_31__components_card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_card_card__ = __webpack_require__(/*! ./components/card/card */ 343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCard", function() { return __WEBPACK_IMPORTED_MODULE_32__components_card_card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_card_card_body__ = __webpack_require__(/*! ./components/card/card-body */ 210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardBody", function() { return __WEBPACK_IMPORTED_MODULE_33__components_card_card_body__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_card_card_footer__ = __webpack_require__(/*! ./components/card/card-footer */ 211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardFooter", function() { return __WEBPACK_IMPORTED_MODULE_34__components_card_card_footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_card_card_group__ = __webpack_require__(/*! ./components/card/card-group */ 340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardGroup", function() { return __WEBPACK_IMPORTED_MODULE_35__components_card_card_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_card_card_header__ = __webpack_require__(/*! ./components/card/card-header */ 212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardHeader", function() { return __WEBPACK_IMPORTED_MODULE_36__components_card_card_header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_card_card_img__ = __webpack_require__(/*! ./components/card/card-img */ 165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardImg", function() { return __WEBPACK_IMPORTED_MODULE_37__components_card_card_img__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_card_card_img_lazy__ = __webpack_require__(/*! ./components/card/card-img-lazy */ 341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardImgLazy", function() { return __WEBPACK_IMPORTED_MODULE_38__components_card_card_img_lazy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_card_card_sub_title__ = __webpack_require__(/*! ./components/card/card-sub-title */ 213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardSubTitle", function() { return __WEBPACK_IMPORTED_MODULE_39__components_card_card_sub_title__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_card_card_text__ = __webpack_require__(/*! ./components/card/card-text */ 342);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardText", function() { return __WEBPACK_IMPORTED_MODULE_40__components_card_card_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_card_card_title__ = __webpack_require__(/*! ./components/card/card-title */ 214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCardTitle", function() { return __WEBPACK_IMPORTED_MODULE_41__components_card_card_title__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_carousel__ = __webpack_require__(/*! ./components/carousel */ 347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselPlugin", function() { return __WEBPACK_IMPORTED_MODULE_42__components_carousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_carousel_carousel__ = __webpack_require__(/*! ./components/carousel/carousel */ 346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCarousel", function() { return __WEBPACK_IMPORTED_MODULE_43__components_carousel_carousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_carousel_carousel_slide__ = __webpack_require__(/*! ./components/carousel/carousel-slide */ 345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCarouselSlide", function() { return __WEBPACK_IMPORTED_MODULE_44__components_carousel_carousel_slide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_collapse__ = __webpack_require__(/*! ./components/collapse */ 215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CollapsePlugin", function() { return __WEBPACK_IMPORTED_MODULE_45__components_collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_collapse_collapse__ = __webpack_require__(/*! ./components/collapse/collapse */ 348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCollapse", function() { return __WEBPACK_IMPORTED_MODULE_46__components_collapse_collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_dropdown__ = __webpack_require__(/*! ./components/dropdown */ 166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownPlugin", function() { return __WEBPACK_IMPORTED_MODULE_47__components_dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_dropdown_dropdown__ = __webpack_require__(/*! ./components/dropdown/dropdown */ 216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdown", function() { return __WEBPACK_IMPORTED_MODULE_48__components_dropdown_dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_dropdown_dropdown_item__ = __webpack_require__(/*! ./components/dropdown/dropdown-item */ 354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdownItem", function() { return __WEBPACK_IMPORTED_MODULE_49__components_dropdown_dropdown_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_dropdown_dropdown_item_button__ = __webpack_require__(/*! ./components/dropdown/dropdown-item-button */ 353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdownItemButton", function() { return __WEBPACK_IMPORTED_MODULE_50__components_dropdown_dropdown_item_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_dropdown_dropdown_divider__ = __webpack_require__(/*! ./components/dropdown/dropdown-divider */ 349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdownDivider", function() { return __WEBPACK_IMPORTED_MODULE_51__components_dropdown_dropdown_divider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_dropdown_dropdown_form__ = __webpack_require__(/*! ./components/dropdown/dropdown-form */ 350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdownForm", function() { return __WEBPACK_IMPORTED_MODULE_52__components_dropdown_dropdown_form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_dropdown_dropdown_group__ = __webpack_require__(/*! ./components/dropdown/dropdown-group */ 351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdownGroup", function() { return __WEBPACK_IMPORTED_MODULE_53__components_dropdown_dropdown_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_dropdown_dropdown_header__ = __webpack_require__(/*! ./components/dropdown/dropdown-header */ 352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdownHeader", function() { return __WEBPACK_IMPORTED_MODULE_54__components_dropdown_dropdown_header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_dropdown_dropdown_text__ = __webpack_require__(/*! ./components/dropdown/dropdown-text */ 355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BDropdownText", function() { return __WEBPACK_IMPORTED_MODULE_55__components_dropdown_dropdown_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_embed__ = __webpack_require__(/*! ./components/embed */ 357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EmbedPlugin", function() { return __WEBPACK_IMPORTED_MODULE_56__components_embed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_embed_embed__ = __webpack_require__(/*! ./components/embed/embed */ 356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BEmbed", function() { return __WEBPACK_IMPORTED_MODULE_57__components_embed_embed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_form__ = __webpack_require__(/*! ./components/form */ 383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormPlugin", function() { return __WEBPACK_IMPORTED_MODULE_58__components_form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_form_form__ = __webpack_require__(/*! ./components/form/form */ 170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BForm", function() { return __WEBPACK_IMPORTED_MODULE_59__components_form_form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_form_form_datalist__ = __webpack_require__(/*! ./components/form/form-datalist */ 382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormDatalist", function() { return __WEBPACK_IMPORTED_MODULE_60__components_form_form_datalist__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_form_form_text__ = __webpack_require__(/*! ./components/form/form-text */ 169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormText", function() { return __WEBPACK_IMPORTED_MODULE_61__components_form_form_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_form_form_invalid_feedback__ = __webpack_require__(/*! ./components/form/form-invalid-feedback */ 168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormInvalidFeedback", function() { return __WEBPACK_IMPORTED_MODULE_62__components_form_form_invalid_feedback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_form_form_valid_feedback__ = __webpack_require__(/*! ./components/form/form-valid-feedback */ 222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormValidFeedback", function() { return __WEBPACK_IMPORTED_MODULE_63__components_form_form_valid_feedback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_form_checkbox__ = __webpack_require__(/*! ./components/form-checkbox */ 360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormCheckboxPlugin", function() { return __WEBPACK_IMPORTED_MODULE_64__components_form_checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_form_checkbox_form_checkbox__ = __webpack_require__(/*! ./components/form-checkbox/form-checkbox */ 217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_65__components_form_checkbox_form_checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_form_checkbox_form_checkbox_group__ = __webpack_require__(/*! ./components/form-checkbox/form-checkbox-group */ 359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormCheckboxGroup", function() { return __WEBPACK_IMPORTED_MODULE_66__components_form_checkbox_form_checkbox_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_form_datepicker__ = __webpack_require__(/*! ./components/form-datepicker */ 362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormDatepickerPlugin", function() { return __WEBPACK_IMPORTED_MODULE_67__components_form_datepicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_form_datepicker_form_datepicker__ = __webpack_require__(/*! ./components/form-datepicker/form-datepicker */ 361);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormDatepicker", function() { return __WEBPACK_IMPORTED_MODULE_68__components_form_datepicker_form_datepicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_form_file__ = __webpack_require__(/*! ./components/form-file */ 364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormFilePlugin", function() { return __WEBPACK_IMPORTED_MODULE_69__components_form_file__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_form_file_form_file__ = __webpack_require__(/*! ./components/form-file/form-file */ 363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormFile", function() { return __WEBPACK_IMPORTED_MODULE_70__components_form_file_form_file__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_form_group__ = __webpack_require__(/*! ./components/form-group */ 366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupPlugin", function() { return __WEBPACK_IMPORTED_MODULE_71__components_form_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_form_group_form_group__ = __webpack_require__(/*! ./components/form-group/form-group */ 365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormGroup", function() { return __WEBPACK_IMPORTED_MODULE_72__components_form_group_form_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_form_input__ = __webpack_require__(/*! ./components/form-input */ 368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormInputPlugin", function() { return __WEBPACK_IMPORTED_MODULE_73__components_form_input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_form_input_form_input__ = __webpack_require__(/*! ./components/form-input/form-input */ 367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormInput", function() { return __WEBPACK_IMPORTED_MODULE_74__components_form_input_form_input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_form_radio__ = __webpack_require__(/*! ./components/form-radio */ 370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRadioPlugin", function() { return __WEBPACK_IMPORTED_MODULE_75__components_form_radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_form_radio_form_radio__ = __webpack_require__(/*! ./components/form-radio/form-radio */ 218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormRadio", function() { return __WEBPACK_IMPORTED_MODULE_76__components_form_radio_form_radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_form_radio_form_radio_group__ = __webpack_require__(/*! ./components/form-radio/form-radio-group */ 369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormRadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_77__components_form_radio_form_radio_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_form_rating__ = __webpack_require__(/*! ./components/form-rating */ 372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRatingPlugin", function() { return __WEBPACK_IMPORTED_MODULE_78__components_form_rating__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_form_rating_form_rating__ = __webpack_require__(/*! ./components/form-rating/form-rating */ 371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormRating", function() { return __WEBPACK_IMPORTED_MODULE_79__components_form_rating_form_rating__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_form_tags__ = __webpack_require__(/*! ./components/form-tags */ 377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormTagsPlugin", function() { return __WEBPACK_IMPORTED_MODULE_80__components_form_tags__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_form_tags_form_tags__ = __webpack_require__(/*! ./components/form-tags/form-tags */ 376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormTags", function() { return __WEBPACK_IMPORTED_MODULE_81__components_form_tags_form_tags__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_form_tags_form_tag__ = __webpack_require__(/*! ./components/form-tags/form-tag */ 221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormTag", function() { return __WEBPACK_IMPORTED_MODULE_82__components_form_tags_form_tag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_form_select__ = __webpack_require__(/*! ./components/form-select */ 374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormSelectPlugin", function() { return __WEBPACK_IMPORTED_MODULE_83__components_form_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_form_select_form_select__ = __webpack_require__(/*! ./components/form-select/form-select */ 373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormSelect", function() { return __WEBPACK_IMPORTED_MODULE_84__components_form_select_form_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_form_select_form_select_option__ = __webpack_require__(/*! ./components/form-select/form-select-option */ 167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormSelectOption", function() { return __WEBPACK_IMPORTED_MODULE_85__components_form_select_form_select_option__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_form_select_form_select_option_group__ = __webpack_require__(/*! ./components/form-select/form-select-option-group */ 219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormSelectOptionGroup", function() { return __WEBPACK_IMPORTED_MODULE_86__components_form_select_form_select_option_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_form_spinbutton__ = __webpack_require__(/*! ./components/form-spinbutton */ 375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormSpinbuttonPlugin", function() { return __WEBPACK_IMPORTED_MODULE_87__components_form_spinbutton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_form_spinbutton_form_spinbutton__ = __webpack_require__(/*! ./components/form-spinbutton/form-spinbutton */ 220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormSpinbutton", function() { return __WEBPACK_IMPORTED_MODULE_88__components_form_spinbutton_form_spinbutton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_form_textarea__ = __webpack_require__(/*! ./components/form-textarea */ 379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormTextareaPlugin", function() { return __WEBPACK_IMPORTED_MODULE_89__components_form_textarea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_form_textarea_form_textarea__ = __webpack_require__(/*! ./components/form-textarea/form-textarea */ 378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormTextarea", function() { return __WEBPACK_IMPORTED_MODULE_90__components_form_textarea_form_textarea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_form_timepicker__ = __webpack_require__(/*! ./components/form-timepicker */ 381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormTimepickerPlugin", function() { return __WEBPACK_IMPORTED_MODULE_91__components_form_timepicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_form_timepicker_form_timepicker__ = __webpack_require__(/*! ./components/form-timepicker/form-timepicker */ 380);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormTimepicker", function() { return __WEBPACK_IMPORTED_MODULE_92__components_form_timepicker_form_timepicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_image__ = __webpack_require__(/*! ./components/image */ 384);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImagePlugin", function() { return __WEBPACK_IMPORTED_MODULE_93__components_image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_image_img__ = __webpack_require__(/*! ./components/image/img */ 119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BImg", function() { return __WEBPACK_IMPORTED_MODULE_94__components_image_img__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_image_img_lazy__ = __webpack_require__(/*! ./components/image/img-lazy */ 223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BImgLazy", function() { return __WEBPACK_IMPORTED_MODULE_95__components_image_img_lazy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_input_group__ = __webpack_require__(/*! ./components/input-group */ 385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroupPlugin", function() { return __WEBPACK_IMPORTED_MODULE_96__components_input_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_input_group_input_group__ = __webpack_require__(/*! ./components/input-group/input-group */ 386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BInputGroup", function() { return __WEBPACK_IMPORTED_MODULE_97__components_input_group_input_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_input_group_input_group_addon__ = __webpack_require__(/*! ./components/input-group/input-group-addon */ 171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BInputGroupAddon", function() { return __WEBPACK_IMPORTED_MODULE_98__components_input_group_input_group_addon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_input_group_input_group_append__ = __webpack_require__(/*! ./components/input-group/input-group-append */ 224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BInputGroupAppend", function() { return __WEBPACK_IMPORTED_MODULE_99__components_input_group_input_group_append__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_input_group_input_group_prepend__ = __webpack_require__(/*! ./components/input-group/input-group-prepend */ 225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BInputGroupPrepend", function() { return __WEBPACK_IMPORTED_MODULE_100__components_input_group_input_group_prepend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_input_group_input_group_text__ = __webpack_require__(/*! ./components/input-group/input-group-text */ 172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BInputGroupText", function() { return __WEBPACK_IMPORTED_MODULE_101__components_input_group_input_group_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_jumbotron__ = __webpack_require__(/*! ./components/jumbotron */ 387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "JumbotronPlugin", function() { return __WEBPACK_IMPORTED_MODULE_102__components_jumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_jumbotron_jumbotron__ = __webpack_require__(/*! ./components/jumbotron/jumbotron */ 388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BJumbotron", function() { return __WEBPACK_IMPORTED_MODULE_103__components_jumbotron_jumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_layout__ = __webpack_require__(/*! ./components/layout */ 389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutPlugin", function() { return __WEBPACK_IMPORTED_MODULE_104__components_layout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_layout_container__ = __webpack_require__(/*! ./components/layout/container */ 227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BContainer", function() { return __WEBPACK_IMPORTED_MODULE_105__components_layout_container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_layout_row__ = __webpack_require__(/*! ./components/layout/row */ 390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BRow", function() { return __WEBPACK_IMPORTED_MODULE_106__components_layout_row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_layout_col__ = __webpack_require__(/*! ./components/layout/col */ 226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BCol", function() { return __WEBPACK_IMPORTED_MODULE_107__components_layout_col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_layout_form_row__ = __webpack_require__(/*! ./components/layout/form-row */ 173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BFormRow", function() { return __WEBPACK_IMPORTED_MODULE_108__components_layout_form_row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_link__ = __webpack_require__(/*! ./components/link */ 391);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkPlugin", function() { return __WEBPACK_IMPORTED_MODULE_109__components_link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_link_link__ = __webpack_require__(/*! ./components/link/link */ 53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BLink", function() { return __WEBPACK_IMPORTED_MODULE_110__components_link_link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_list_group__ = __webpack_require__(/*! ./components/list-group */ 392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupPlugin", function() { return __WEBPACK_IMPORTED_MODULE_111__components_list_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_list_group_list_group__ = __webpack_require__(/*! ./components/list-group/list-group */ 394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BListGroup", function() { return __WEBPACK_IMPORTED_MODULE_112__components_list_group_list_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_list_group_list_group_item__ = __webpack_require__(/*! ./components/list-group/list-group-item */ 393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BListGroupItem", function() { return __WEBPACK_IMPORTED_MODULE_113__components_list_group_list_group_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_media__ = __webpack_require__(/*! ./components/media */ 395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MediaPlugin", function() { return __WEBPACK_IMPORTED_MODULE_114__components_media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_media_media__ = __webpack_require__(/*! ./components/media/media */ 396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BMedia", function() { return __WEBPACK_IMPORTED_MODULE_115__components_media_media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_media_media_aside__ = __webpack_require__(/*! ./components/media/media-aside */ 228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BMediaAside", function() { return __WEBPACK_IMPORTED_MODULE_116__components_media_media_aside__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_media_media_body__ = __webpack_require__(/*! ./components/media/media-body */ 229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BMediaBody", function() { return __WEBPACK_IMPORTED_MODULE_117__components_media_media_body__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_modal__ = __webpack_require__(/*! ./components/modal */ 398);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalPlugin", function() { return __WEBPACK_IMPORTED_MODULE_118__components_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_modal_modal__ = __webpack_require__(/*! ./components/modal/modal */ 230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BModal", function() { return __WEBPACK_IMPORTED_MODULE_119__components_modal_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_nav__ = __webpack_require__(/*! ./components/nav */ 231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavPlugin", function() { return __WEBPACK_IMPORTED_MODULE_120__components_nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_nav_nav__ = __webpack_require__(/*! ./components/nav/nav */ 174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNav", function() { return __WEBPACK_IMPORTED_MODULE_121__components_nav_nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_nav_nav_form__ = __webpack_require__(/*! ./components/nav/nav-form */ 399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavForm", function() { return __WEBPACK_IMPORTED_MODULE_122__components_nav_nav_form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_nav_nav_item__ = __webpack_require__(/*! ./components/nav/nav-item */ 401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavItem", function() { return __WEBPACK_IMPORTED_MODULE_123__components_nav_nav_item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_nav_nav_item_dropdown__ = __webpack_require__(/*! ./components/nav/nav-item-dropdown */ 400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavItemDropdown", function() { return __WEBPACK_IMPORTED_MODULE_124__components_nav_nav_item_dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_nav_nav_text__ = __webpack_require__(/*! ./components/nav/nav-text */ 402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavText", function() { return __WEBPACK_IMPORTED_MODULE_125__components_nav_nav_text__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_navbar__ = __webpack_require__(/*! ./components/navbar */ 403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_126__components_navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_navbar_navbar__ = __webpack_require__(/*! ./components/navbar/navbar */ 407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavbar", function() { return __WEBPACK_IMPORTED_MODULE_127__components_navbar_navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_navbar_navbar_brand__ = __webpack_require__(/*! ./components/navbar/navbar-brand */ 404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavbarBrand", function() { return __WEBPACK_IMPORTED_MODULE_128__components_navbar_navbar_brand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_navbar_navbar_nav__ = __webpack_require__(/*! ./components/navbar/navbar-nav */ 405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavbarNav", function() { return __WEBPACK_IMPORTED_MODULE_129__components_navbar_navbar_nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_navbar_navbar_toggle__ = __webpack_require__(/*! ./components/navbar/navbar-toggle */ 406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BNavbarToggle", function() { return __WEBPACK_IMPORTED_MODULE_130__components_navbar_navbar_toggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_overlay__ = __webpack_require__(/*! ./components/overlay */ 408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayPlugin", function() { return __WEBPACK_IMPORTED_MODULE_131__components_overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_overlay_overlay__ = __webpack_require__(/*! ./components/overlay/overlay */ 409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BOverlay", function() { return __WEBPACK_IMPORTED_MODULE_132__components_overlay_overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_pagination__ = __webpack_require__(/*! ./components/pagination */ 412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationPlugin", function() { return __WEBPACK_IMPORTED_MODULE_133__components_pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_pagination_pagination__ = __webpack_require__(/*! ./components/pagination/pagination */ 413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BPagination", function() { return __WEBPACK_IMPORTED_MODULE_134__components_pagination_pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_pagination_nav__ = __webpack_require__(/*! ./components/pagination-nav */ 410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationNavPlugin", function() { return __WEBPACK_IMPORTED_MODULE_135__components_pagination_nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_pagination_nav_pagination_nav__ = __webpack_require__(/*! ./components/pagination-nav/pagination-nav */ 411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BPaginationNav", function() { return __WEBPACK_IMPORTED_MODULE_136__components_pagination_nav_pagination_nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_popover__ = __webpack_require__(/*! ./components/popover */ 415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverPlugin", function() { return __WEBPACK_IMPORTED_MODULE_137__components_popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_popover_popover__ = __webpack_require__(/*! ./components/popover/popover */ 416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BPopover", function() { return __WEBPACK_IMPORTED_MODULE_138__components_popover_popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_progress__ = __webpack_require__(/*! ./components/progress */ 417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressPlugin", function() { return __WEBPACK_IMPORTED_MODULE_139__components_progress__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_progress_progress__ = __webpack_require__(/*! ./components/progress/progress */ 418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BProgress", function() { return __WEBPACK_IMPORTED_MODULE_140__components_progress_progress__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_progress_progress_bar__ = __webpack_require__(/*! ./components/progress/progress-bar */ 232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BProgressBar", function() { return __WEBPACK_IMPORTED_MODULE_141__components_progress_progress_bar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_sidebar__ = __webpack_require__(/*! ./components/sidebar */ 419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SidebarPlugin", function() { return __WEBPACK_IMPORTED_MODULE_142__components_sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_sidebar_sidebar__ = __webpack_require__(/*! ./components/sidebar/sidebar */ 420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BSidebar", function() { return __WEBPACK_IMPORTED_MODULE_143__components_sidebar_sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_skeleton__ = __webpack_require__(/*! ./components/skeleton */ 421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SkeletonPlugin", function() { return __WEBPACK_IMPORTED_MODULE_144__components_skeleton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_skeleton_skeleton__ = __webpack_require__(/*! ./components/skeleton/skeleton */ 175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BSkeleton", function() { return __WEBPACK_IMPORTED_MODULE_145__components_skeleton_skeleton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_skeleton_skeleton_icon__ = __webpack_require__(/*! ./components/skeleton/skeleton-icon */ 422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BSkeletonIcon", function() { return __WEBPACK_IMPORTED_MODULE_146__components_skeleton_skeleton_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_skeleton_skeleton_img__ = __webpack_require__(/*! ./components/skeleton/skeleton-img */ 423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BSkeletonImg", function() { return __WEBPACK_IMPORTED_MODULE_147__components_skeleton_skeleton_img__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_skeleton_skeleton_table__ = __webpack_require__(/*! ./components/skeleton/skeleton-table */ 424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BSkeletonTable", function() { return __WEBPACK_IMPORTED_MODULE_148__components_skeleton_skeleton_table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_skeleton_skeleton_wrapper__ = __webpack_require__(/*! ./components/skeleton/skeleton-wrapper */ 425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BSkeletonWrapper", function() { return __WEBPACK_IMPORTED_MODULE_149__components_skeleton_skeleton_wrapper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_spinner__ = __webpack_require__(/*! ./components/spinner */ 426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SpinnerPlugin", function() { return __WEBPACK_IMPORTED_MODULE_150__components_spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_spinner_spinner__ = __webpack_require__(/*! ./components/spinner/spinner */ 233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BSpinner", function() { return __WEBPACK_IMPORTED_MODULE_151__components_spinner_spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_table__ = __webpack_require__(/*! ./components/table */ 236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TablePlugin", function() { return __WEBPACK_IMPORTED_MODULE_152__components_table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableLitePlugin", function() { return __WEBPACK_IMPORTED_MODULE_152__components_table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableSimplePlugin", function() { return __WEBPACK_IMPORTED_MODULE_152__components_table__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_table_table__ = __webpack_require__(/*! ./components/table/table */ 438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTable", function() { return __WEBPACK_IMPORTED_MODULE_153__components_table_table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_table_table_lite__ = __webpack_require__(/*! ./components/table/table-lite */ 436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTableLite", function() { return __WEBPACK_IMPORTED_MODULE_154__components_table_table_lite__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_table_table_simple__ = __webpack_require__(/*! ./components/table/table-simple */ 437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTableSimple", function() { return __WEBPACK_IMPORTED_MODULE_155__components_table_table_simple__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_table_tbody__ = __webpack_require__(/*! ./components/table/tbody */ 237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTbody", function() { return __WEBPACK_IMPORTED_MODULE_156__components_table_tbody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_table_thead__ = __webpack_require__(/*! ./components/table/thead */ 238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BThead", function() { return __WEBPACK_IMPORTED_MODULE_157__components_table_thead__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_table_tfoot__ = __webpack_require__(/*! ./components/table/tfoot */ 177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTfoot", function() { return __WEBPACK_IMPORTED_MODULE_158__components_table_tfoot__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_table_tr__ = __webpack_require__(/*! ./components/table/tr */ 92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTr", function() { return __WEBPACK_IMPORTED_MODULE_159__components_table_tr__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_table_th__ = __webpack_require__(/*! ./components/table/th */ 178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTh", function() { return __WEBPACK_IMPORTED_MODULE_160__components_table_th__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_table_td__ = __webpack_require__(/*! ./components/table/td */ 120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTd", function() { return __WEBPACK_IMPORTED_MODULE_161__components_table_td__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__components_tabs__ = __webpack_require__(/*! ./components/tabs */ 439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabsPlugin", function() { return __WEBPACK_IMPORTED_MODULE_162__components_tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__components_tabs_tabs__ = __webpack_require__(/*! ./components/tabs/tabs */ 441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTabs", function() { return __WEBPACK_IMPORTED_MODULE_163__components_tabs_tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__components_tabs_tab__ = __webpack_require__(/*! ./components/tabs/tab */ 440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTab", function() { return __WEBPACK_IMPORTED_MODULE_164__components_tabs_tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__components_time__ = __webpack_require__(/*! ./components/time */ 442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TimePlugin", function() { return __WEBPACK_IMPORTED_MODULE_165__components_time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__components_time_time__ = __webpack_require__(/*! ./components/time/time */ 239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTime", function() { return __WEBPACK_IMPORTED_MODULE_166__components_time_time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__components_toast__ = __webpack_require__(/*! ./components/toast */ 444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToastPlugin", function() { return __WEBPACK_IMPORTED_MODULE_167__components_toast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__components_toast_toast__ = __webpack_require__(/*! ./components/toast/toast */ 240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BToast", function() { return __WEBPACK_IMPORTED_MODULE_168__components_toast_toast__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__components_toast_toaster__ = __webpack_require__(/*! ./components/toast/toaster */ 241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BToaster", function() { return __WEBPACK_IMPORTED_MODULE_169__components_toast_toaster__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__components_tooltip__ = __webpack_require__(/*! ./components/tooltip */ 446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TooltipPlugin", function() { return __WEBPACK_IMPORTED_MODULE_170__components_tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__components_tooltip_tooltip__ = __webpack_require__(/*! ./components/tooltip/tooltip */ 243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BTooltip", function() { return __WEBPACK_IMPORTED_MODULE_171__components_tooltip_tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__directives_hover__ = __webpack_require__(/*! ./directives/hover */ 449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBHoverPlugin", function() { return __WEBPACK_IMPORTED_MODULE_172__directives_hover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__directives_hover_hover__ = __webpack_require__(/*! ./directives/hover/hover */ 244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBHover", function() { return __WEBPACK_IMPORTED_MODULE_173__directives_hover_hover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__directives_modal__ = __webpack_require__(/*! ./directives/modal */ 450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBModalPlugin", function() { return __WEBPACK_IMPORTED_MODULE_174__directives_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__directives_modal_modal__ = __webpack_require__(/*! ./directives/modal/modal */ 245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBModal", function() { return __WEBPACK_IMPORTED_MODULE_175__directives_modal_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__directives_popover__ = __webpack_require__(/*! ./directives/popover */ 246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBPopoverPlugin", function() { return __WEBPACK_IMPORTED_MODULE_176__directives_popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__directives_popover_popover__ = __webpack_require__(/*! ./directives/popover/popover */ 451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBPopover", function() { return __WEBPACK_IMPORTED_MODULE_177__directives_popover_popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__directives_scrollspy__ = __webpack_require__(/*! ./directives/scrollspy */ 452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBScrollspyPlugin", function() { return __WEBPACK_IMPORTED_MODULE_178__directives_scrollspy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__directives_scrollspy_scrollspy__ = __webpack_require__(/*! ./directives/scrollspy/scrollspy */ 453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBScrollspy", function() { return __WEBPACK_IMPORTED_MODULE_179__directives_scrollspy_scrollspy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__directives_toggle__ = __webpack_require__(/*! ./directives/toggle */ 179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBTogglePlugin", function() { return __WEBPACK_IMPORTED_MODULE_180__directives_toggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__directives_toggle_toggle__ = __webpack_require__(/*! ./directives/toggle/toggle */ 247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBToggle", function() { return __WEBPACK_IMPORTED_MODULE_181__directives_toggle_toggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__directives_tooltip__ = __webpack_require__(/*! ./directives/tooltip */ 248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBTooltipPlugin", function() { return __WEBPACK_IMPORTED_MODULE_182__directives_tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__directives_tooltip_tooltip__ = __webpack_require__(/*! ./directives/tooltip/tooltip */ 454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBTooltip", function() { return __WEBPACK_IMPORTED_MODULE_183__directives_tooltip_tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__directives_visible__ = __webpack_require__(/*! ./directives/visible */ 455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBVisiblePlugin", function() { return __WEBPACK_IMPORTED_MODULE_184__directives_visible__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__directives_visible_visible__ = __webpack_require__(/*! ./directives/visible/visible */ 180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBVisible", function() { return __WEBPACK_IMPORTED_MODULE_185__directives_visible_visible__["a"]; });
/*!
 * BootstrapVue 2.23.1
 *
 * @link https://bootstrap-vue.org
 * @source https://github.com/bootstrap-vue/bootstrap-vue
 * @copyright (c) 2016-2022 BootstrapVue
 * @license MIT
 * https://github.com/bootstrap-vue/bootstrap-vue/blob/master/LICENSE
 */




var NAME = 'BootstrapVue'; // --- BootstrapVue installer ---

var install = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["a" /* installFactory */])({
  plugins: {
    componentsPlugin: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* componentsPlugin */],
    directivesPlugin: __WEBPACK_IMPORTED_MODULE_2__directives__["a" /* directivesPlugin */]
  }
}); // --- BootstrapVue plugin ---

var BootstrapVue = /*#__PURE__*/{
  install: install,
  NAME: NAME
}; // --- Named exports for BvConfigPlugin ---

 // --- Export named injection plugins ---
// TODO:
//   We should probably move injections into their own
//   parent directory (i.e. `/src/injections`)


 // Webpack 4 has optimization difficulties with re-export of re-exports,
// so we import the components individually here for better tree shaking
//
// Webpack v5 fixes the optimizations with re-export of re-exports so this
// can be reverted back to `export * from './table'` when Webpack v5 is released
// See: https://github.com/webpack/webpack/pull/9203 (available in Webpack v5.0.0-alpha.15)
// -- Export Icon components and IconPlugin/BootstrapVueIcons ---
// export * from './icons'



 // This re-export is only a single level deep, which
// Webpack 4 (usually) handles correctly when tree shaking

 // --- Export all individual components and component group plugins as named exports ---
// export * from './components/alert'


 // export * from './components/aspect'


 // export * from './components/avatar'



 // export * from './components/badge'


 // export * from './components/breadcrumb'



 // export * from './components/button'



 // export * from './components/button-group'


 // export * from './components/button-toolbar'


 // export * from './components/calendar'


 // export * from './components/card'











 // export * from './components/carousel'



 // export * from './components/collapse'


 // export * from './components/dropdown'









 // export * from './components/embed'


 // export * from './components/form'






 // export * from './components/form-checkbox'



 // export * from './components/form-datepicker'


 // export * from './components/form-file'


 // export * from './components/form-group'


 // export * from './components/form-input'


 // export * from './components/form-radio'



 // export * from './components/form-rating'


 // export * from './components/form-tags'



 // export * from './components/form-select'




 // export * from './components/form-spinbutton'


 // export * from './components/form-textarea'


 // export * from './components/form-timepicker'


 // export * from './components/image'



 // export * from './components/input-group'






 // export * from './components/jumbotron'


 // export * from './components/layout'





 // export * from './components/link'


 // export * from './components/list-group'



 // export * from './components/media'




 // export * from './components/modal'


 // export * from './components/nav'






 // export * from './components/navbar'





 // export * from './components/overlay'


 // export * from './components/pagination'


 // export * from './components/pagination-nav'


 // export * from './components/popover'


 // export * from './components/progress'



 // export * from './components/sidebar'


 // export * from './components/skeleton'






 // export * from './components/spinner'


 // export * from './components/table'










 // export * from './components/tabs'



 // export * from './components/time'


 // export * from './components/toast'



 // export * from './components/tooltip'


 // --- Named exports of all directives (VB<Name>) and plugins (VB<Name>Plugin) ---
// Webpack 4 has optimization difficulties with re-export of re-exports,
// so we import the directives individually here for better tree shaking
//
// Webpack v5 fixes the optimizations with re-export of re-exports so this
// can be reverted back to `export * from './scrollspy'` when Webpack v5 is released
// https://github.com/webpack/webpack/pull/9203 (available in Webpack v5.0.0-alpha.15)
// export * from './directives/hover'


 // export * from './directives/modal'


 // export * from './directives/popover'


 // export * from './directives/scrollspy'


 // export * from './directives/toggle'


 // export * from './directives/tooltip'


 // export * from './directives/tooltip'


 // Default export is the BootstrapVue plugin

/* harmony default export */ __webpack_exports__["default"] = (BootstrapVue);

/***/ }),
/* 951 */
/* exports provided: clickOutMixin */
/* exports used: clickOutMixin */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/click-out.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickOutMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(/*! ../utils/dom */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__(/*! ../utils/events */ 21);



 // @vue/component

var clickOutMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  data: function data() {
    return {
      listenForClickOut: false
    };
  },
  watch: {
    listenForClickOut: function listenForClickOut(newValue, oldValue) {
      if (newValue !== oldValue) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["c" /* eventOff */])(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);

        if (newValue) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* eventOn */])(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        }
      }
    }
  },
  beforeCreate: function beforeCreate() {
    // Declare non-reactive properties
    this.clickOutElement = null;
    this.clickOutEventName = null;
  },
  mounted: function mounted() {
    if (!this.clickOutElement) {
      this.clickOutElement = document;
    }

    if (!this.clickOutEventName) {
      this.clickOutEventName = 'click';
    }

    if (this.listenForClickOut) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* eventOn */])(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
    }
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_events__["c" /* eventOff */])(this.clickOutElement, this.clickOutEventName, this._clickOutHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
  },
  methods: {
    isClickOut: function isClickOut(event) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["b" /* contains */])(this.$el, event.target);
    },
    _clickOutHandler: function _clickOutHandler(event) {
      if (this.clickOutHandler && this.isClickOut(event)) {
        this.clickOutHandler(event);
      }
    }
  }
});

/***/ }),
/* 952 */
/* exports provided: focusInMixin */
/* exports used: focusInMixin */
/*!************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/focus-in.js ***!
  \************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusInMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_events__ = __webpack_require__(/*! ../utils/events */ 21);


 // @vue/component

var focusInMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  data: function data() {
    return {
      listenForFocusIn: false
    };
  },
  watch: {
    listenForFocusIn: function listenForFocusIn(newValue, oldValue) {
      if (newValue !== oldValue) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_events__["c" /* eventOff */])(this.focusInElement, 'focusin', this._focusInHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);

        if (newValue) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_events__["b" /* eventOn */])(this.focusInElement, 'focusin', this._focusInHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        }
      }
    }
  },
  beforeCreate: function beforeCreate() {
    // Declare non-reactive properties
    this.focusInElement = null;
  },
  mounted: function mounted() {
    if (!this.focusInElement) {
      this.focusInElement = document;
    }

    if (this.listenForFocusIn) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_events__["b" /* eventOn */])(this.focusInElement, 'focusin', this._focusInHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
    }
  },
  beforeDestroy: function beforeDestroy() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_events__["c" /* eventOff */])(this.focusInElement, 'focusin', this._focusInHandler, __WEBPACK_IMPORTED_MODULE_1__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
  },
  methods: {
    _focusInHandler: function _focusInHandler(event) {
      if (this.focusInHandler) {
        this.focusInHandler(event);
      }
    }
  }
});

/***/ }),
/* 953 */
/* exports provided: listenOnDocumentMixin */
/* exports used: listenOnDocumentMixin */
/*!**********************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/listen-on-document.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listenOnDocumentMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__(/*! ../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);





 // --- Constants ---

var PROP = '$_documentListeners'; // --- Mixin ---
// @vue/component

var listenOnDocumentMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  created: function created() {
    // Define non-reactive property
    // Object of arrays, keyed by event name,
    // where value is an array of callbacks
    this[PROP] = {};
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    // Unregister all registered listeners
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["a" /* keys */])(this[PROP] || {}).forEach(function (event) {
      _this[PROP][event].forEach(function (callback) {
        _this.listenOffDocument(event, callback);
      });
    });
    this[PROP] = null;
  },
  methods: {
    registerDocumentListener: function registerDocumentListener(event, callback) {
      if (this[PROP]) {
        this[PROP][event] = this[PROP][event] || [];

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(this[PROP][event], callback)) {
          this[PROP][event].push(callback);
        }
      }
    },
    unregisterDocumentListener: function unregisterDocumentListener(event, callback) {
      if (this[PROP] && this[PROP][event]) {
        this[PROP][event] = this[PROP][event].filter(function (cb) {
          return cb !== callback;
        });
      }
    },
    listenDocument: function listenDocument(on, event, callback) {
      on ? this.listenOnDocument(event, callback) : this.listenOffDocument(event, callback);
    },
    listenOnDocument: function listenOnDocument(event, callback) {
      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["b" /* eventOn */])(document, event, callback, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        this.registerDocumentListener(event, callback);
      }
    },
    listenOffDocument: function listenOffDocument(event, callback) {
      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["c" /* eventOff */])(document, event, callback, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      }

      this.unregisterDocumentListener(event, callback);
    }
  }
});

/***/ }),
/* 954 */
/* exports provided: listenOnWindowMixin */
/* exports used: listenOnWindowMixin */
/*!********************************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/listen-on-window.js ***!
  \********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listenOnWindowMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_env__ = __webpack_require__(/*! ../constants/env */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_events__ = __webpack_require__(/*! ../constants/events */ 12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(/*! ../utils/array */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__(/*! ../utils/events */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(/*! ../utils/object */ 6);





 // --- Constants ---

var PROP = '$_windowListeners'; // --- Mixin ---
// @vue/component

var listenOnWindowMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__vue__["d" /* extend */])({
  created: function created() {
    // Define non-reactive property
    // Object of arrays, keyed by event name,
    // where value is an array of callbacks
    this[PROP] = {};
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    // Unregister all registered listeners
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["a" /* keys */])(this[PROP] || {}).forEach(function (event) {
      _this[PROP][event].forEach(function (callback) {
        _this.listenOffWindow(event, callback);
      });
    });
    this[PROP] = null;
  },
  methods: {
    registerWindowListener: function registerWindowListener(event, callback) {
      if (this[PROP]) {
        this[PROP][event] = this[PROP][event] || [];

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* arrayIncludes */])(this[PROP][event], callback)) {
          this[PROP][event].push(callback);
        }
      }
    },
    unregisterWindowListener: function unregisterWindowListener(event, callback) {
      if (this[PROP] && this[PROP][event]) {
        this[PROP][event] = this[PROP][event].filter(function (cb) {
          return cb !== callback;
        });
      }
    },
    listenWindow: function listenWindow(on, event, callback) {
      on ? this.listenOnWindow(event, callback) : this.listenOffWindow(event, callback);
    },
    listenOnWindow: function listenOnWindow(event, callback) {
      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["b" /* eventOn */])(window, event, callback, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
        this.registerWindowListener(event, callback);
      }
    },
    listenOffWindow: function listenOffWindow(event, callback) {
      if (__WEBPACK_IMPORTED_MODULE_1__constants_env__["e" /* IS_BROWSER */]) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_events__["c" /* eventOff */])(window, event, callback, __WEBPACK_IMPORTED_MODULE_2__constants_events__["m" /* EVENT_OPTIONS_NO_CAPTURE */]);
      }

      this.unregisterWindowListener(event, callback);
    }
  }
});

/***/ }),
/* 955 */
/* exports provided: modelMixin, props, MODEL_PROP_NAME, MODEL_EVENT_NAME */
/* exports used: props, modelMixin, MODEL_PROP_NAME, MODEL_EVENT_NAME */
/*!*********************************************!*\
  !*** ./~/bootstrap-vue/esm/mixins/model.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return prop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_model__ = __webpack_require__(/*! ../utils/model */ 37);


var _makeModelMixin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_model__["a" /* makeModelMixin */])('value'),
    mixin = _makeModelMixin.mixin,
    props = _makeModelMixin.props,
    prop = _makeModelMixin.prop,
    event = _makeModelMixin.event;



/***/ }),
/* 956 */
/* exports provided: setConfig, resetConfig */
/* exports used: setConfig */
/*!*************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/config-set.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setConfig; });
/* unused harmony export resetConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue__ = __webpack_require__(/*! ../vue */ 0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_config__ = __webpack_require__(/*! ../constants/config */ 447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clone_deep__ = __webpack_require__(/*! ./clone-deep */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get__ = __webpack_require__(/*! ./get */ 141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inspect__ = __webpack_require__(/*! ./inspect */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(/*! ./object */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__warn__ = __webpack_require__(/*! ./warn */ 54);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }







 // Config manager class

var BvConfig = /*#__PURE__*/function () {
  function BvConfig() {
    _classCallCheck(this, BvConfig);

    this.$_config = {};
  } // Method to merge in user config parameters


  _createClass(BvConfig, [{
    key: "setConfig",
    value: function setConfig() {
      var _this = this;

      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /* istanbul ignore next */
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["h" /* isPlainObject */])(config)) {
        return;
      }

      var configKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__object__["d" /* getOwnPropertyNames */])(config);
      configKeys.forEach(function (key) {
        /* istanbul ignore next */
        var subConfig = config[key];

        if (key === 'breakpoints') {
          /* istanbul ignore if */
          if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["c" /* isArray */])(subConfig) || subConfig.length < 2 || subConfig.some(function (b) {
            return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["f" /* isString */])(b) || b.length === 0;
          })) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__warn__["a" /* warn */])('"breakpoints" must be an array of at least 2 breakpoint names', __WEBPACK_IMPORTED_MODULE_1__constants_config__["a" /* NAME */]);
          } else {
            _this.$_config[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clone_deep__["a" /* cloneDeep */])(subConfig);
          }
        } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["h" /* isPlainObject */])(subConfig)) {
          // Component prop defaults
          _this.$_config[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__object__["d" /* getOwnPropertyNames */])(subConfig).reduce(function (config, prop) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__inspect__["i" /* isUndefined */])(subConfig[prop])) {
              config[prop] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clone_deep__["a" /* cloneDeep */])(subConfig[prop]);
            }

            return config;
          }, _this.$_config[key] || {});
        }
      });
    } // Clear the config

  }, {
    key: "resetConfig",
    value: function resetConfig() {
      this.$_config = {};
    } // Returns a deep copy of the user config

  }, {
    key: "getConfig",
    value: function getConfig() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clone_deep__["a" /* cloneDeep */])(this.$_config);
    } // Returns a deep copy of the config value

  }, {
    key: "getConfigValue",
    value: function getConfigValue(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__clone_deep__["a" /* cloneDeep */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__get__["a" /* getRaw */])(this.$_config, key, defaultValue));
    }
  }]);

  return BvConfig;
}(); // Method for applying a global config


var setConfig = function setConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Vue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */];
  // Ensure we have a `$bvConfig` Object on the Vue prototype
  // We set on Vue and OurVue just in case consumer has not set an alias of `vue`
  Vue.prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]] = __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]] = Vue.prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]] || __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]] || new BvConfig(); // Apply the config values

  Vue.prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]].setConfig(config);
}; // Method for resetting the user config
// Exported for testing purposes only

var resetConfig = function resetConfig() {
  if (__WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]] && __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]].resetConfig) {
    __WEBPACK_IMPORTED_MODULE_0__vue__["b" /* Vue */].prototype[__WEBPACK_IMPORTED_MODULE_1__constants_config__["b" /* PROP_NAME */]].resetConfig();
  }
};

/***/ }),
/* 957 */
/* exports provided: getEnv, getNoWarn */
/* exports used: getNoWarn */
/*!******************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/env.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getEnv */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNoWarn; });
/**
 * Utilities to get information about the current environment
 */
var getEnv = function getEnv(key) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var env = typeof process !== 'undefined' && process ? process.env || {} : {};

  if (!key) {
    /* istanbul ignore next */
    return env;
  }

  return env[key] || fallback;
};
var getNoWarn = function getNoWarn() {
  return getEnv('BOOTSTRAP_VUE_NO_WARN') || getEnv('NODE_ENV') === 'production';
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(/*! ./../../../process/browser.js */ 281)))

/***/ }),
/* 958 */
/* exports provided: looseIndexOf */
/* exports used: looseIndexOf */
/*!*****************************************************!*\
  !*** ./~/bootstrap-vue/esm/utils/loose-index-of.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return looseIndexOf; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loose_equal__ = __webpack_require__(/*! ./loose-equal */ 38);
 // Assumes that the first argument is an array

var looseIndexOf = function looseIndexOf(array, value) {
  for (var i = 0; i < array.length; i++) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__loose_equal__["a" /* looseEqual */])(array[i], value)) {
      return i;
    }
  }

  return -1;
};

/***/ }),
/* 959 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/bootstrap/dist/js/bootstrap.min.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");!function(t){"use strict";var e=jQuery.fn.jquery.split(" ")[0].split(".");if(e[0]<2&&e[1]<9||1==e[0]&&9==e[1]&&e[2]<1||3<e[0])throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(),function(n){"use strict";n.fn.emulateTransitionEnd=function(t){var e=!1,i=this;n(this).one("bsTransitionEnd",function(){e=!0});return setTimeout(function(){e||n(i).trigger(n.support.transition.end)},t),this},n(function(){n.support.transition=function o(){var t=document.createElement("bootstrap"),e={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var i in e)if(t.style[i]!==undefined)return{end:e[i]};return!1}(),n.support.transition&&(n.event.special.bsTransitionEnd={bindType:n.support.transition.end,delegateType:n.support.transition.end,handle:function(t){if(n(t.target).is(this))return t.handleObj.handler.apply(this,arguments)}})})}(jQuery),function(s){"use strict";var e='[data-dismiss="alert"]',a=function(t){s(t).on("click",e,this.close)};a.VERSION="3.4.1",a.TRANSITION_DURATION=150,a.prototype.close=function(t){var e=s(this),i=e.attr("data-target");i||(i=(i=e.attr("href"))&&i.replace(/.*(?=#[^\s]*$)/,"")),i="#"===i?[]:i;var o=s(document).find(i);function n(){o.detach().trigger("closed.bs.alert").remove()}t&&t.preventDefault(),o.length||(o=e.closest(".alert")),o.trigger(t=s.Event("close.bs.alert")),t.isDefaultPrevented()||(o.removeClass("in"),s.support.transition&&o.hasClass("fade")?o.one("bsTransitionEnd",n).emulateTransitionEnd(a.TRANSITION_DURATION):n())};var t=s.fn.alert;s.fn.alert=function o(i){return this.each(function(){var t=s(this),e=t.data("bs.alert");e||t.data("bs.alert",e=new a(this)),"string"==typeof i&&e[i].call(t)})},s.fn.alert.Constructor=a,s.fn.alert.noConflict=function(){return s.fn.alert=t,this},s(document).on("click.bs.alert.data-api",e,a.prototype.close)}(jQuery),function(s){"use strict";var n=function(t,e){this.$element=s(t),this.options=s.extend({},n.DEFAULTS,e),this.isLoading=!1};function i(o){return this.each(function(){var t=s(this),e=t.data("bs.button"),i="object"==typeof o&&o;e||t.data("bs.button",e=new n(this,i)),"toggle"==o?e.toggle():o&&e.setState(o)})}n.VERSION="3.4.1",n.DEFAULTS={loadingText:"loading..."},n.prototype.setState=function(t){var e="disabled",i=this.$element,o=i.is("input")?"val":"html",n=i.data();t+="Text",null==n.resetText&&i.data("resetText",i[o]()),setTimeout(s.proxy(function(){i[o](null==n[t]?this.options[t]:n[t]),"loadingText"==t?(this.isLoading=!0,i.addClass(e).attr(e,e).prop(e,!0)):this.isLoading&&(this.isLoading=!1,i.removeClass(e).removeAttr(e).prop(e,!1))},this),0)},n.prototype.toggle=function(){var t=!0,e=this.$element.closest('[data-toggle="buttons"]');if(e.length){var i=this.$element.find("input");"radio"==i.prop("type")?(i.prop("checked")&&(t=!1),e.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==i.prop("type")&&(i.prop("checked")!==this.$element.hasClass("active")&&(t=!1),this.$element.toggleClass("active")),i.prop("checked",this.$element.hasClass("active")),t&&i.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var t=s.fn.button;s.fn.button=i,s.fn.button.Constructor=n,s.fn.button.noConflict=function(){return s.fn.button=t,this},s(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(t){var e=s(t.target).closest(".btn");i.call(e,"toggle"),s(t.target).is('input[type="radio"], input[type="checkbox"]')||(t.preventDefault(),e.is("input,button")?e.trigger("focus"):e.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(t){s(t.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(t.type))})}(jQuery),function(p){"use strict";var c=function(t,e){this.$element=p(t),this.$indicators=this.$element.find(".carousel-indicators"),this.options=e,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",p.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",p.proxy(this.pause,this)).on("mouseleave.bs.carousel",p.proxy(this.cycle,this))};function r(n){return this.each(function(){var t=p(this),e=t.data("bs.carousel"),i=p.extend({},c.DEFAULTS,t.data(),"object"==typeof n&&n),o="string"==typeof n?n:i.slide;e||t.data("bs.carousel",e=new c(this,i)),"number"==typeof n?e.to(n):o?e[o]():i.interval&&e.pause().cycle()})}c.VERSION="3.4.1",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(t){if(!/input|textarea/i.test(t.target.tagName)){switch(t.which){case 37:this.prev();break;case 39:this.next();break;default:return}t.preventDefault()}},c.prototype.cycle=function(t){return t||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(p.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(t){return this.$items=t.parent().children(".item"),this.$items.index(t||this.$active)},c.prototype.getItemForDirection=function(t,e){var i=this.getItemIndex(e);if(("prev"==t&&0===i||"next"==t&&i==this.$items.length-1)&&!this.options.wrap)return e;var o=(i+("prev"==t?-1:1))%this.$items.length;return this.$items.eq(o)},c.prototype.to=function(t){var e=this,i=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(t>this.$items.length-1||t<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){e.to(t)}):i==t?this.pause().cycle():this.slide(i<t?"next":"prev",this.$items.eq(t))},c.prototype.pause=function(t){return t||(this.paused=!0),this.$element.find(".next, .prev").length&&p.support.transition&&(this.$element.trigger(p.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(t,e){var i=this.$element.find(".item.active"),o=e||this.getItemForDirection(t,i),n=this.interval,s="next"==t?"left":"right",a=this;if(o.hasClass("active"))return this.sliding=!1;var r=o[0],l=p.Event("slide.bs.carousel",{relatedTarget:r,direction:s});if(this.$element.trigger(l),!l.isDefaultPrevented()){if(this.sliding=!0,n&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var h=p(this.$indicators.children()[this.getItemIndex(o)]);h&&h.addClass("active")}var d=p.Event("slid.bs.carousel",{relatedTarget:r,direction:s});return p.support.transition&&this.$element.hasClass("slide")?(o.addClass(t),"object"==typeof o&&o.length&&o[0].offsetWidth,i.addClass(s),o.addClass(s),i.one("bsTransitionEnd",function(){o.removeClass([t,s].join(" ")).addClass("active"),i.removeClass(["active",s].join(" ")),a.sliding=!1,setTimeout(function(){a.$element.trigger(d)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(i.removeClass("active"),o.addClass("active"),this.sliding=!1,this.$element.trigger(d)),n&&this.cycle(),this}};var t=p.fn.carousel;p.fn.carousel=r,p.fn.carousel.Constructor=c,p.fn.carousel.noConflict=function(){return p.fn.carousel=t,this};var e=function(t){var e=p(this),i=e.attr("href");i&&(i=i.replace(/.*(?=#[^\s]+$)/,""));var o=e.attr("data-target")||i,n=p(document).find(o);if(n.hasClass("carousel")){var s=p.extend({},n.data(),e.data()),a=e.attr("data-slide-to");a&&(s.interval=!1),r.call(n,s),a&&n.data("bs.carousel").to(a),t.preventDefault()}};p(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),p(window).on("load",function(){p('[data-ride="carousel"]').each(function(){var t=p(this);r.call(t,t.data())})})}(jQuery),function(a){"use strict";var r=function(t,e){this.$element=a(t),this.options=a.extend({},r.DEFAULTS,e),this.$trigger=a('[data-toggle="collapse"][href="#'+t.id+'"],[data-toggle="collapse"][data-target="#'+t.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};function n(t){var e,i=t.attr("data-target")||(e=t.attr("href"))&&e.replace(/.*(?=#[^\s]+$)/,"");return a(document).find(i)}function l(o){return this.each(function(){var t=a(this),e=t.data("bs.collapse"),i=a.extend({},r.DEFAULTS,t.data(),"object"==typeof o&&o);!e&&i.toggle&&/show|hide/.test(o)&&(i.toggle=!1),e||t.data("bs.collapse",e=new r(this,i)),"string"==typeof o&&e[o]()})}r.VERSION="3.4.1",r.TRANSITION_DURATION=350,r.DEFAULTS={toggle:!0},r.prototype.dimension=function(){return this.$element.hasClass("width")?"width":"height"},r.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var t,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(t=e.data("bs.collapse"))&&t.transitioning)){var i=a.Event("show.bs.collapse");if(this.$element.trigger(i),!i.isDefaultPrevented()){e&&e.length&&(l.call(e,"hide"),t||e.data("bs.collapse",null));var o=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[o](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var n=function(){this.$element.removeClass("collapsing").addClass("collapse in")[o](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return n.call(this);var s=a.camelCase(["scroll",o].join("-"));this.$element.one("bsTransitionEnd",a.proxy(n,this)).emulateTransitionEnd(r.TRANSITION_DURATION)[o](this.$element[0][s])}}}},r.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var t=a.Event("hide.bs.collapse");if(this.$element.trigger(t),!t.isDefaultPrevented()){var e=this.dimension();this.$element[e](this.$element[e]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var i=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};if(!a.support.transition)return i.call(this);this.$element[e](0).one("bsTransitionEnd",a.proxy(i,this)).emulateTransitionEnd(r.TRANSITION_DURATION)}}},r.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},r.prototype.getParent=function(){return a(document).find(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(t,e){var i=a(e);this.addAriaAndCollapsedClass(n(i),i)},this)).end()},r.prototype.addAriaAndCollapsedClass=function(t,e){var i=t.hasClass("in");t.attr("aria-expanded",i),e.toggleClass("collapsed",!i).attr("aria-expanded",i)};var t=a.fn.collapse;a.fn.collapse=l,a.fn.collapse.Constructor=r,a.fn.collapse.noConflict=function(){return a.fn.collapse=t,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(t){var e=a(this);e.attr("data-target")||t.preventDefault();var i=n(e),o=i.data("bs.collapse")?"toggle":e.data();l.call(i,o)})}(jQuery),function(a){"use strict";var r='[data-toggle="dropdown"]',o=function(t){a(t).on("click.bs.dropdown",this.toggle)};function l(t){var e=t.attr("data-target");e||(e=(e=t.attr("href"))&&/#[A-Za-z]/.test(e)&&e.replace(/.*(?=#[^\s]*$)/,""));var i="#"!==e?a(document).find(e):null;return i&&i.length?i:t.parent()}function s(o){o&&3===o.which||(a(".dropdown-backdrop").remove(),a(r).each(function(){var t=a(this),e=l(t),i={relatedTarget:this};e.hasClass("open")&&(o&&"click"==o.type&&/input|textarea/i.test(o.target.tagName)&&a.contains(e[0],o.target)||(e.trigger(o=a.Event("hide.bs.dropdown",i)),o.isDefaultPrevented()||(t.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",i)))))}))}o.VERSION="3.4.1",o.prototype.toggle=function(t){var e=a(this);if(!e.is(".disabled, :disabled")){var i=l(e),o=i.hasClass("open");if(s(),!o){"ontouchstart"in document.documentElement&&!i.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",s);var n={relatedTarget:this};if(i.trigger(t=a.Event("show.bs.dropdown",n)),t.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),i.toggleClass("open").trigger(a.Event("shown.bs.dropdown",n))}return!1}},o.prototype.keydown=function(t){if(/(38|40|27|32)/.test(t.which)&&!/input|textarea/i.test(t.target.tagName)){var e=a(this);if(t.preventDefault(),t.stopPropagation(),!e.is(".disabled, :disabled")){var i=l(e),o=i.hasClass("open");if(!o&&27!=t.which||o&&27==t.which)return 27==t.which&&i.find(r).trigger("focus"),e.trigger("click");var n=i.find(".dropdown-menu li:not(.disabled):visible a");if(n.length){var s=n.index(t.target);38==t.which&&0<s&&s--,40==t.which&&s<n.length-1&&s++,~s||(s=0),n.eq(s).trigger("focus")}}}};var t=a.fn.dropdown;a.fn.dropdown=function e(i){return this.each(function(){var t=a(this),e=t.data("bs.dropdown");e||t.data("bs.dropdown",e=new o(this)),"string"==typeof i&&e[i].call(t)})},a.fn.dropdown.Constructor=o,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=t,this},a(document).on("click.bs.dropdown.data-api",s).on("click.bs.dropdown.data-api",".dropdown form",function(t){t.stopPropagation()}).on("click.bs.dropdown.data-api",r,o.prototype.toggle).on("keydown.bs.dropdown.data-api",r,o.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",o.prototype.keydown)}(jQuery),function(a){"use strict";var s=function(t,e){this.options=e,this.$body=a(document.body),this.$element=a(t),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.fixedContent=".navbar-fixed-top, .navbar-fixed-bottom",this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};function r(o,n){return this.each(function(){var t=a(this),e=t.data("bs.modal"),i=a.extend({},s.DEFAULTS,t.data(),"object"==typeof o&&o);e||t.data("bs.modal",e=new s(this,i)),"string"==typeof o?e[o](n):i.show&&e.show(n)})}s.VERSION="3.4.1",s.TRANSITION_DURATION=300,s.BACKDROP_TRANSITION_DURATION=150,s.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},s.prototype.toggle=function(t){return this.isShown?this.hide():this.show(t)},s.prototype.show=function(i){var o=this,t=a.Event("show.bs.modal",{relatedTarget:i});this.$element.trigger(t),this.isShown||t.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){o.$element.one("mouseup.dismiss.bs.modal",function(t){a(t.target).is(o.$element)&&(o.ignoreBackdropClick=!0)})}),this.backdrop(function(){var t=a.support.transition&&o.$element.hasClass("fade");o.$element.parent().length||o.$element.appendTo(o.$body),o.$element.show().scrollTop(0),o.adjustDialog(),t&&o.$element[0].offsetWidth,o.$element.addClass("in"),o.enforceFocus();var e=a.Event("shown.bs.modal",{relatedTarget:i});t?o.$dialog.one("bsTransitionEnd",function(){o.$element.trigger("focus").trigger(e)}).emulateTransitionEnd(s.TRANSITION_DURATION):o.$element.trigger("focus").trigger(e)}))},s.prototype.hide=function(t){t&&t.preventDefault(),t=a.Event("hide.bs.modal"),this.$element.trigger(t),this.isShown&&!t.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(s.TRANSITION_DURATION):this.hideModal())},s.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(t){document===t.target||this.$element[0]===t.target||this.$element.has(t.target).length||this.$element.trigger("focus")},this))},s.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(t){27==t.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},s.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},s.prototype.hideModal=function(){var t=this;this.$element.hide(),this.backdrop(function(){t.$body.removeClass("modal-open"),t.resetAdjustments(),t.resetScrollbar(),t.$element.trigger("hidden.bs.modal")})},s.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},s.prototype.backdrop=function(t){var e=this,i=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var o=a.support.transition&&i;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+i).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(t){this.ignoreBackdropClick?this.ignoreBackdropClick=!1:t.target===t.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide())},this)),o&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!t)return;o?this.$backdrop.one("bsTransitionEnd",t).emulateTransitionEnd(s.BACKDROP_TRANSITION_DURATION):t()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var n=function(){e.removeBackdrop(),t&&t()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",n).emulateTransitionEnd(s.BACKDROP_TRANSITION_DURATION):n()}else t&&t()},s.prototype.handleUpdate=function(){this.adjustDialog()},s.prototype.adjustDialog=function(){var t=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&t?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!t?this.scrollbarWidth:""})},s.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},s.prototype.checkScrollbar=function(){var t=window.innerWidth;if(!t){var e=document.documentElement.getBoundingClientRect();t=e.right-Math.abs(e.left)}this.bodyIsOverflowing=document.body.clientWidth<t,this.scrollbarWidth=this.measureScrollbar()},s.prototype.setScrollbar=function(){var t=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"";var n=this.scrollbarWidth;this.bodyIsOverflowing&&(this.$body.css("padding-right",t+n),a(this.fixedContent).each(function(t,e){var i=e.style.paddingRight,o=a(e).css("padding-right");a(e).data("padding-right",i).css("padding-right",parseFloat(o)+n+"px")}))},s.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad),a(this.fixedContent).each(function(t,e){var i=a(e).data("padding-right");a(e).removeData("padding-right"),e.style.paddingRight=i||""})},s.prototype.measureScrollbar=function(){var t=document.createElement("div");t.className="modal-scrollbar-measure",this.$body.append(t);var e=t.offsetWidth-t.clientWidth;return this.$body[0].removeChild(t),e};var t=a.fn.modal;a.fn.modal=r,a.fn.modal.Constructor=s,a.fn.modal.noConflict=function(){return a.fn.modal=t,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(t){var e=a(this),i=e.attr("href"),o=e.attr("data-target")||i&&i.replace(/.*(?=#[^\s]+$)/,""),n=a(document).find(o),s=n.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(i)&&i},n.data(),e.data());e.is("a")&&t.preventDefault(),n.one("show.bs.modal",function(t){t.isDefaultPrevented()||n.one("hidden.bs.modal",function(){e.is(":visible")&&e.trigger("focus")})}),r.call(n,s,this)})}(jQuery),function(g){"use strict";var o=["sanitize","whiteList","sanitizeFn"],a=["background","cite","href","itemtype","longdesc","poster","src","xlink:href"],t={"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},r=/^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi,l=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;function u(t,e){var i=t.nodeName.toLowerCase();if(-1!==g.inArray(i,e))return-1===g.inArray(i,a)||Boolean(t.nodeValue.match(r)||t.nodeValue.match(l));for(var o=g(e).filter(function(t,e){return e instanceof RegExp}),n=0,s=o.length;n<s;n++)if(i.match(o[n]))return!0;return!1}function n(t,e,i){if(0===t.length)return t;if(i&&"function"==typeof i)return i(t);if(!document.implementation||!document.implementation.createHTMLDocument)return t;var o=document.implementation.createHTMLDocument("sanitization");o.body.innerHTML=t;for(var n=g.map(e,function(t,e){return e}),s=g(o.body).find("*"),a=0,r=s.length;a<r;a++){var l=s[a],h=l.nodeName.toLowerCase();if(-1!==g.inArray(h,n))for(var d=g.map(l.attributes,function(t){return t}),p=[].concat(e["*"]||[],e[h]||[]),c=0,f=d.length;c<f;c++)u(d[c],p)||l.removeAttribute(d[c].nodeName);else l.parentNode.removeChild(l)}return o.body.innerHTML}var m=function(t,e){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",t,e)};m.VERSION="3.4.1",m.TRANSITION_DURATION=150,m.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0},sanitize:!0,sanitizeFn:null,whiteList:t},m.prototype.init=function(t,e,i){if(this.enabled=!0,this.type=t,this.$element=g(e),this.options=this.getOptions(i),this.$viewport=this.options.viewport&&g(document).find(g.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var o=this.options.trigger.split(" "),n=o.length;n--;){var s=o[n];if("click"==s)this.$element.on("click."+this.type,this.options.selector,g.proxy(this.toggle,this));else if("manual"!=s){var a="hover"==s?"mouseenter":"focusin",r="hover"==s?"mouseleave":"focusout";this.$element.on(a+"."+this.type,this.options.selector,g.proxy(this.enter,this)),this.$element.on(r+"."+this.type,this.options.selector,g.proxy(this.leave,this))}}this.options.selector?this._options=g.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},m.prototype.getDefaults=function(){return m.DEFAULTS},m.prototype.getOptions=function(t){var e=this.$element.data();for(var i in e)e.hasOwnProperty(i)&&-1!==g.inArray(i,o)&&delete e[i];return(t=g.extend({},this.getDefaults(),e,t)).delay&&"number"==typeof t.delay&&(t.delay={show:t.delay,hide:t.delay}),t.sanitize&&(t.template=n(t.template,t.whiteList,t.sanitizeFn)),t},m.prototype.getDelegateOptions=function(){var i={},o=this.getDefaults();return this._options&&g.each(this._options,function(t,e){o[t]!=e&&(i[t]=e)}),i},m.prototype.enter=function(t){var e=t instanceof this.constructor?t:g(t.currentTarget).data("bs."+this.type);if(e||(e=new this.constructor(t.currentTarget,this.getDelegateOptions()),g(t.currentTarget).data("bs."+this.type,e)),t instanceof g.Event&&(e.inState["focusin"==t.type?"focus":"hover"]=!0),e.tip().hasClass("in")||"in"==e.hoverState)e.hoverState="in";else{if(clearTimeout(e.timeout),e.hoverState="in",!e.options.delay||!e.options.delay.show)return e.show();e.timeout=setTimeout(function(){"in"==e.hoverState&&e.show()},e.options.delay.show)}},m.prototype.isInStateTrue=function(){for(var t in this.inState)if(this.inState[t])return!0;return!1},m.prototype.leave=function(t){var e=t instanceof this.constructor?t:g(t.currentTarget).data("bs."+this.type);if(e||(e=new this.constructor(t.currentTarget,this.getDelegateOptions()),g(t.currentTarget).data("bs."+this.type,e)),t instanceof g.Event&&(e.inState["focusout"==t.type?"focus":"hover"]=!1),!e.isInStateTrue()){if(clearTimeout(e.timeout),e.hoverState="out",!e.options.delay||!e.options.delay.hide)return e.hide();e.timeout=setTimeout(function(){"out"==e.hoverState&&e.hide()},e.options.delay.hide)}},m.prototype.show=function(){var t=g.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(t);var e=g.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(t.isDefaultPrevented()||!e)return;var i=this,o=this.tip(),n=this.getUID(this.type);this.setContent(),o.attr("id",n),this.$element.attr("aria-describedby",n),this.options.animation&&o.addClass("fade");var s="function"==typeof this.options.placement?this.options.placement.call(this,o[0],this.$element[0]):this.options.placement,a=/\s?auto?\s?/i,r=a.test(s);r&&(s=s.replace(a,"")||"top"),o.detach().css({top:0,left:0,display:"block"}).addClass(s).data("bs."+this.type,this),this.options.container?o.appendTo(g(document).find(this.options.container)):o.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var l=this.getPosition(),h=o[0].offsetWidth,d=o[0].offsetHeight;if(r){var p=s,c=this.getPosition(this.$viewport);s="bottom"==s&&l.bottom+d>c.bottom?"top":"top"==s&&l.top-d<c.top?"bottom":"right"==s&&l.right+h>c.width?"left":"left"==s&&l.left-h<c.left?"right":s,o.removeClass(p).addClass(s)}var f=this.getCalculatedOffset(s,l,h,d);this.applyPlacement(f,s);var u=function(){var t=i.hoverState;i.$element.trigger("shown.bs."+i.type),i.hoverState=null,"out"==t&&i.leave(i)};g.support.transition&&this.$tip.hasClass("fade")?o.one("bsTransitionEnd",u).emulateTransitionEnd(m.TRANSITION_DURATION):u()}},m.prototype.applyPlacement=function(t,e){var i=this.tip(),o=i[0].offsetWidth,n=i[0].offsetHeight,s=parseInt(i.css("margin-top"),10),a=parseInt(i.css("margin-left"),10);isNaN(s)&&(s=0),isNaN(a)&&(a=0),t.top+=s,t.left+=a,g.offset.setOffset(i[0],g.extend({using:function(t){i.css({top:Math.round(t.top),left:Math.round(t.left)})}},t),0),i.addClass("in");var r=i[0].offsetWidth,l=i[0].offsetHeight;"top"==e&&l!=n&&(t.top=t.top+n-l);var h=this.getViewportAdjustedDelta(e,t,r,l);h.left?t.left+=h.left:t.top+=h.top;var d=/top|bottom/.test(e),p=d?2*h.left-o+r:2*h.top-n+l,c=d?"offsetWidth":"offsetHeight";i.offset(t),this.replaceArrow(p,i[0][c],d)},m.prototype.replaceArrow=function(t,e,i){this.arrow().css(i?"left":"top",50*(1-t/e)+"%").css(i?"top":"left","")},m.prototype.setContent=function(){var t=this.tip(),e=this.getTitle();this.options.html?(this.options.sanitize&&(e=n(e,this.options.whiteList,this.options.sanitizeFn)),t.find(".tooltip-inner").html(e)):t.find(".tooltip-inner").text(e),t.removeClass("fade in top bottom left right")},m.prototype.hide=function(t){var e=this,i=g(this.$tip),o=g.Event("hide.bs."+this.type);function n(){"in"!=e.hoverState&&i.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),t&&t()}if(this.$element.trigger(o),!o.isDefaultPrevented())return i.removeClass("in"),g.support.transition&&i.hasClass("fade")?i.one("bsTransitionEnd",n).emulateTransitionEnd(m.TRANSITION_DURATION):n(),this.hoverState=null,this},m.prototype.fixTitle=function(){var t=this.$element;(t.attr("title")||"string"!=typeof t.attr("data-original-title"))&&t.attr("data-original-title",t.attr("title")||"").attr("title","")},m.prototype.hasContent=function(){return this.getTitle()},m.prototype.getPosition=function(t){var e=(t=t||this.$element)[0],i="BODY"==e.tagName,o=e.getBoundingClientRect();null==o.width&&(o=g.extend({},o,{width:o.right-o.left,height:o.bottom-o.top}));var n=window.SVGElement&&e instanceof window.SVGElement,s=i?{top:0,left:0}:n?null:t.offset(),a={scroll:i?document.documentElement.scrollTop||document.body.scrollTop:t.scrollTop()},r=i?{width:g(window).width(),height:g(window).height()}:null;return g.extend({},o,a,r,s)},m.prototype.getCalculatedOffset=function(t,e,i,o){return"bottom"==t?{top:e.top+e.height,left:e.left+e.width/2-i/2}:"top"==t?{top:e.top-o,left:e.left+e.width/2-i/2}:"left"==t?{top:e.top+e.height/2-o/2,left:e.left-i}:{top:e.top+e.height/2-o/2,left:e.left+e.width}},m.prototype.getViewportAdjustedDelta=function(t,e,i,o){var n={top:0,left:0};if(!this.$viewport)return n;var s=this.options.viewport&&this.options.viewport.padding||0,a=this.getPosition(this.$viewport);if(/right|left/.test(t)){var r=e.top-s-a.scroll,l=e.top+s-a.scroll+o;r<a.top?n.top=a.top-r:l>a.top+a.height&&(n.top=a.top+a.height-l)}else{var h=e.left-s,d=e.left+s+i;h<a.left?n.left=a.left-h:d>a.right&&(n.left=a.left+a.width-d)}return n},m.prototype.getTitle=function(){var t=this.$element,e=this.options;return t.attr("data-original-title")||("function"==typeof e.title?e.title.call(t[0]):e.title)},m.prototype.getUID=function(t){for(;t+=~~(1e6*Math.random()),document.getElementById(t););return t},m.prototype.tip=function(){if(!this.$tip&&(this.$tip=g(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},m.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},m.prototype.enable=function(){this.enabled=!0},m.prototype.disable=function(){this.enabled=!1},m.prototype.toggleEnabled=function(){this.enabled=!this.enabled},m.prototype.toggle=function(t){var e=this;t&&((e=g(t.currentTarget).data("bs."+this.type))||(e=new this.constructor(t.currentTarget,this.getDelegateOptions()),g(t.currentTarget).data("bs."+this.type,e))),t?(e.inState.click=!e.inState.click,e.isInStateTrue()?e.enter(e):e.leave(e)):e.tip().hasClass("in")?e.leave(e):e.enter(e)},m.prototype.destroy=function(){var t=this;clearTimeout(this.timeout),this.hide(function(){t.$element.off("."+t.type).removeData("bs."+t.type),t.$tip&&t.$tip.detach(),t.$tip=null,t.$arrow=null,t.$viewport=null,t.$element=null})},m.prototype.sanitizeHtml=function(t){return n(t,this.options.whiteList,this.options.sanitizeFn)};var e=g.fn.tooltip;g.fn.tooltip=function i(o){return this.each(function(){var t=g(this),e=t.data("bs.tooltip"),i="object"==typeof o&&o;!e&&/destroy|hide/.test(o)||(e||t.data("bs.tooltip",e=new m(this,i)),"string"==typeof o&&e[o]())})},g.fn.tooltip.Constructor=m,g.fn.tooltip.noConflict=function(){return g.fn.tooltip=e,this}}(jQuery),function(n){"use strict";var s=function(t,e){this.init("popover",t,e)};if(!n.fn.tooltip)throw new Error("Popover requires tooltip.js");s.VERSION="3.4.1",s.DEFAULTS=n.extend({},n.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),((s.prototype=n.extend({},n.fn.tooltip.Constructor.prototype)).constructor=s).prototype.getDefaults=function(){return s.DEFAULTS},s.prototype.setContent=function(){var t=this.tip(),e=this.getTitle(),i=this.getContent();if(this.options.html){var o=typeof i;this.options.sanitize&&(e=this.sanitizeHtml(e),"string"===o&&(i=this.sanitizeHtml(i))),t.find(".popover-title").html(e),t.find(".popover-content").children().detach().end()["string"===o?"html":"append"](i)}else t.find(".popover-title").text(e),t.find(".popover-content").children().detach().end().text(i);t.removeClass("fade top bottom left right in"),t.find(".popover-title").html()||t.find(".popover-title").hide()},s.prototype.hasContent=function(){return this.getTitle()||this.getContent()},s.prototype.getContent=function(){var t=this.$element,e=this.options;return t.attr("data-content")||("function"==typeof e.content?e.content.call(t[0]):e.content)},s.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var t=n.fn.popover;n.fn.popover=function e(o){return this.each(function(){var t=n(this),e=t.data("bs.popover"),i="object"==typeof o&&o;!e&&/destroy|hide/.test(o)||(e||t.data("bs.popover",e=new s(this,i)),"string"==typeof o&&e[o]())})},n.fn.popover.Constructor=s,n.fn.popover.noConflict=function(){return n.fn.popover=t,this}}(jQuery),function(s){"use strict";function n(t,e){this.$body=s(document.body),this.$scrollElement=s(t).is(document.body)?s(window):s(t),this.options=s.extend({},n.DEFAULTS,e),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",s.proxy(this.process,this)),this.refresh(),this.process()}function e(o){return this.each(function(){var t=s(this),e=t.data("bs.scrollspy"),i="object"==typeof o&&o;e||t.data("bs.scrollspy",e=new n(this,i)),"string"==typeof o&&e[o]()})}n.VERSION="3.4.1",n.DEFAULTS={offset:10},n.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},n.prototype.refresh=function(){var t=this,o="offset",n=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),s.isWindow(this.$scrollElement[0])||(o="position",n=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var t=s(this),e=t.data("target")||t.attr("href"),i=/^#./.test(e)&&s(e);return i&&i.length&&i.is(":visible")&&[[i[o]().top+n,e]]||null}).sort(function(t,e){return t[0]-e[0]}).each(function(){t.offsets.push(this[0]),t.targets.push(this[1])})},n.prototype.process=function(){var t,e=this.$scrollElement.scrollTop()+this.options.offset,i=this.getScrollHeight(),o=this.options.offset+i-this.$scrollElement.height(),n=this.offsets,s=this.targets,a=this.activeTarget;if(this.scrollHeight!=i&&this.refresh(),o<=e)return a!=(t=s[s.length-1])&&this.activate(t);if(a&&e<n[0])return this.activeTarget=null,this.clear();for(t=n.length;t--;)a!=s[t]&&e>=n[t]&&(n[t+1]===undefined||e<n[t+1])&&this.activate(s[t])},n.prototype.activate=function(t){this.activeTarget=t,this.clear();var e=this.selector+'[data-target="'+t+'"],'+this.selector+'[href="'+t+'"]',i=s(e).parents("li").addClass("active");i.parent(".dropdown-menu").length&&(i=i.closest("li.dropdown").addClass("active")),i.trigger("activate.bs.scrollspy")},n.prototype.clear=function(){s(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var t=s.fn.scrollspy;s.fn.scrollspy=e,s.fn.scrollspy.Constructor=n,s.fn.scrollspy.noConflict=function(){return s.fn.scrollspy=t,this},s(window).on("load.bs.scrollspy.data-api",function(){s('[data-spy="scroll"]').each(function(){var t=s(this);e.call(t,t.data())})})}(jQuery),function(r){"use strict";var a=function(t){this.element=r(t)};function e(i){return this.each(function(){var t=r(this),e=t.data("bs.tab");e||t.data("bs.tab",e=new a(this)),"string"==typeof i&&e[i]()})}a.VERSION="3.4.1",a.TRANSITION_DURATION=150,a.prototype.show=function(){var t=this.element,e=t.closest("ul:not(.dropdown-menu)"),i=t.data("target");if(i||(i=(i=t.attr("href"))&&i.replace(/.*(?=#[^\s]*$)/,"")),!t.parent("li").hasClass("active")){var o=e.find(".active:last a"),n=r.Event("hide.bs.tab",{relatedTarget:t[0]}),s=r.Event("show.bs.tab",{relatedTarget:o[0]});if(o.trigger(n),t.trigger(s),!s.isDefaultPrevented()&&!n.isDefaultPrevented()){var a=r(document).find(i);this.activate(t.closest("li"),e),this.activate(a,a.parent(),function(){o.trigger({type:"hidden.bs.tab",relatedTarget:t[0]}),t.trigger({type:"shown.bs.tab",relatedTarget:o[0]})})}}},a.prototype.activate=function(t,e,i){var o=e.find("> .active"),n=i&&r.support.transition&&(o.length&&o.hasClass("fade")||!!e.find("> .fade").length);function s(){o.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),t.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),n?(t[0].offsetWidth,t.addClass("in")):t.removeClass("fade"),t.parent(".dropdown-menu").length&&t.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),i&&i()}o.length&&n?o.one("bsTransitionEnd",s).emulateTransitionEnd(a.TRANSITION_DURATION):s(),o.removeClass("in")};var t=r.fn.tab;r.fn.tab=e,r.fn.tab.Constructor=a,r.fn.tab.noConflict=function(){return r.fn.tab=t,this};var i=function(t){t.preventDefault(),e.call(r(this),"show")};r(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',i).on("click.bs.tab.data-api",'[data-toggle="pill"]',i)}(jQuery),function(l){"use strict";var h=function(t,e){this.options=l.extend({},h.DEFAULTS,e);var i=this.options.target===h.DEFAULTS.target?l(this.options.target):l(document).find(this.options.target);this.$target=i.on("scroll.bs.affix.data-api",l.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",l.proxy(this.checkPositionWithEventLoop,this)),this.$element=l(t),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};function i(o){return this.each(function(){var t=l(this),e=t.data("bs.affix"),i="object"==typeof o&&o;e||t.data("bs.affix",e=new h(this,i)),"string"==typeof o&&e[o]()})}h.VERSION="3.4.1",h.RESET="affix affix-top affix-bottom",h.DEFAULTS={offset:0,target:window},h.prototype.getState=function(t,e,i,o){var n=this.$target.scrollTop(),s=this.$element.offset(),a=this.$target.height();if(null!=i&&"top"==this.affixed)return n<i&&"top";if("bottom"==this.affixed)return null!=i?!(n+this.unpin<=s.top)&&"bottom":!(n+a<=t-o)&&"bottom";var r=null==this.affixed,l=r?n:s.top;return null!=i&&n<=i?"top":null!=o&&t-o<=l+(r?a:e)&&"bottom"},h.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(h.RESET).addClass("affix");var t=this.$target.scrollTop(),e=this.$element.offset();return this.pinnedOffset=e.top-t},h.prototype.checkPositionWithEventLoop=function(){setTimeout(l.proxy(this.checkPosition,this),1)},h.prototype.checkPosition=function(){if(this.$element.is(":visible")){var t=this.$element.height(),e=this.options.offset,i=e.top,o=e.bottom,n=Math.max(l(document).height(),l(document.body).height());"object"!=typeof e&&(o=i=e),"function"==typeof i&&(i=e.top(this.$element)),"function"==typeof o&&(o=e.bottom(this.$element));var s=this.getState(n,t,i,o);if(this.affixed!=s){null!=this.unpin&&this.$element.css("top","");var a="affix"+(s?"-"+s:""),r=l.Event(a+".bs.affix");if(this.$element.trigger(r),r.isDefaultPrevented())return;this.affixed=s,this.unpin="bottom"==s?this.getPinnedOffset():null,this.$element.removeClass(h.RESET).addClass(a).trigger(a.replace("affix","affixed")+".bs.affix")}"bottom"==s&&this.$element.offset({top:n-t-o})}};var t=l.fn.affix;l.fn.affix=i,l.fn.affix.Constructor=h,l.fn.affix.noConflict=function(){return l.fn.affix=t,this},l(window).on("load",function(){l('[data-spy="affix"]').each(function(){var t=l(this),e=t.data();e.offset=e.offset||{},null!=e.offsetBottom&&(e.offset.bottom=e.offsetBottom),null!=e.offsetTop&&(e.offset.top=e.offsetTop),i.call(t,e)})})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 960 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./~/core-js/library/fn/array/from.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.string.iterator */ 126);
__webpack_require__(/*! ../../modules/es6.array.from */ 1002);
module.exports = __webpack_require__(/*! ../../modules/_core */ 39).Array.from;


/***/ }),
/* 961 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/fn/get-iterator.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../modules/web.dom.iterable */ 149);
__webpack_require__(/*! ../modules/es6.string.iterator */ 126);
module.exports = __webpack_require__(/*! ../modules/core.get-iterator */ 1000);


/***/ }),
/* 962 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/core-js/library/fn/is-iterable.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../modules/web.dom.iterable */ 149);
__webpack_require__(/*! ../modules/es6.string.iterator */ 126);
module.exports = __webpack_require__(/*! ../modules/core.is-iterable */ 1001);


/***/ }),
/* 963 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/core-js/library/fn/json/stringify.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(/*! ../../modules/_core */ 39);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 964 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/fn/number/is-nan.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.number.is-nan */ 1004);
module.exports = __webpack_require__(/*! ../../modules/_core */ 39).Number.isNaN;


/***/ }),
/* 965 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/core-js/library/fn/number/max-safe-integer.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.number.max-safe-integer */ 1005);
module.exports = 0x1fffffffffffff;


/***/ }),
/* 966 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/core-js/library/fn/object/assign.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.object.assign */ 1006);
module.exports = __webpack_require__(/*! ../../modules/_core */ 39).Object.assign;


/***/ }),
/* 967 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/core-js/library/fn/object/define-property.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.object.define-property */ 1007);
var $Object = __webpack_require__(/*! ../../modules/_core */ 39).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 968 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/core-js/library/fn/object/entries.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es7.object.entries */ 1012);
module.exports = __webpack_require__(/*! ../../modules/_core */ 39).Object.entries;


/***/ }),
/* 969 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/core-js/library/fn/object/keys.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.object.keys */ 1008);
module.exports = __webpack_require__(/*! ../../modules/_core */ 39).Object.keys;


/***/ }),
/* 970 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./~/core-js/library/fn/promise.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../modules/es6.object.to-string */ 275);
__webpack_require__(/*! ../modules/es6.string.iterator */ 126);
__webpack_require__(/*! ../modules/web.dom.iterable */ 149);
__webpack_require__(/*! ../modules/es6.promise */ 1009);
__webpack_require__(/*! ../modules/es7.promise.finally */ 1013);
__webpack_require__(/*! ../modules/es7.promise.try */ 1014);
module.exports = __webpack_require__(/*! ../modules/_core */ 39).Promise;


/***/ }),
/* 971 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/core-js/library/fn/set.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../modules/es6.object.to-string */ 275);
__webpack_require__(/*! ../modules/es6.string.iterator */ 126);
__webpack_require__(/*! ../modules/web.dom.iterable */ 149);
__webpack_require__(/*! ../modules/es6.set */ 1010);
__webpack_require__(/*! ../modules/es7.set.to-json */ 1017);
__webpack_require__(/*! ../modules/es7.set.of */ 1016);
__webpack_require__(/*! ../modules/es7.set.from */ 1015);
module.exports = __webpack_require__(/*! ../modules/_core */ 39).Set;


/***/ }),
/* 972 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/fn/symbol/index.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.symbol */ 1011);
__webpack_require__(/*! ../../modules/es6.object.to-string */ 275);
__webpack_require__(/*! ../../modules/es7.symbol.async-iterator */ 1018);
__webpack_require__(/*! ../../modules/es7.symbol.observable */ 1019);
module.exports = __webpack_require__(/*! ../../modules/_core */ 39).Symbol;


/***/ }),
/* 973 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/fn/symbol/iterator.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ../../modules/es6.string.iterator */ 126);
__webpack_require__(/*! ../../modules/web.dom.iterable */ 149);
module.exports = __webpack_require__(/*! ../../modules/_wks-ext */ 273).f('iterator');


/***/ }),
/* 974 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/core-js/library/modules/_add-to-unscopables.js ***!
  \**********************************************************/
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 975 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/core-js/library/modules/_array-from-iterable.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(/*! ./_for-of */ 144);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 976 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/core-js/library/modules/_array-includes.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(/*! ./_to-iobject */ 113);
var toLength = __webpack_require__(/*! ./_to-length */ 187);
var toAbsoluteIndex = __webpack_require__(/*! ./_to-absolute-index */ 998);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 977 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/core-js/library/modules/_array-methods.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(/*! ./_ctx */ 96);
var IObject = __webpack_require__(/*! ./_iobject */ 261);
var toObject = __webpack_require__(/*! ./_to-object */ 125);
var toLength = __webpack_require__(/*! ./_to-length */ 187);
var asc = __webpack_require__(/*! ./_array-species-create */ 979);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 978 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./~/core-js/library/modules/_array-species-constructor.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./_is-object */ 82);
var isArray = __webpack_require__(/*! ./_is-array */ 471);
var SPECIES = __webpack_require__(/*! ./_wks */ 56)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 979 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/core-js/library/modules/_array-species-create.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(/*! ./_array-species-constructor */ 978);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 980 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/core-js/library/modules/_collection-strong.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(/*! ./_object-dp */ 75).f;
var create = __webpack_require__(/*! ./_object-create */ 265);
var redefineAll = __webpack_require__(/*! ./_redefine-all */ 267);
var ctx = __webpack_require__(/*! ./_ctx */ 96);
var anInstance = __webpack_require__(/*! ./_an-instance */ 257);
var forOf = __webpack_require__(/*! ./_for-of */ 144);
var $iterDefine = __webpack_require__(/*! ./_iter-define */ 262);
var step = __webpack_require__(/*! ./_iter-step */ 474);
var setSpecies = __webpack_require__(/*! ./_set-species */ 480);
var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ 66);
var fastKey = __webpack_require__(/*! ./_meta */ 263).fastKey;
var validate = __webpack_require__(/*! ./_validate-collection */ 483);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 981 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/core-js/library/modules/_collection-to-json.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(/*! ./_classof */ 186);
var from = __webpack_require__(/*! ./_array-from-iterable */ 975);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 982 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_collection.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(/*! ./_global */ 55);
var $export = __webpack_require__(/*! ./_export */ 49);
var meta = __webpack_require__(/*! ./_meta */ 263);
var fails = __webpack_require__(/*! ./_fails */ 111);
var hide = __webpack_require__(/*! ./_hide */ 97);
var redefineAll = __webpack_require__(/*! ./_redefine-all */ 267);
var forOf = __webpack_require__(/*! ./_for-of */ 144);
var anInstance = __webpack_require__(/*! ./_an-instance */ 257);
var isObject = __webpack_require__(/*! ./_is-object */ 82);
var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ 148);
var dP = __webpack_require__(/*! ./_object-dp */ 75).f;
var each = __webpack_require__(/*! ./_array-methods */ 977)(0);
var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ 66);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 983 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/core-js/library/modules/_create-property.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(/*! ./_object-dp */ 75);
var createDesc = __webpack_require__(/*! ./_property-desc */ 147);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 984 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_enum-keys.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(/*! ./_object-keys */ 124);
var gOPS = __webpack_require__(/*! ./_object-gops */ 266);
var pIE = __webpack_require__(/*! ./_object-pie */ 146);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 985 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/modules/_invoke.js ***!
  \**********************************************/
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 986 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_iter-create.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(/*! ./_object-create */ 265);
var descriptor = __webpack_require__(/*! ./_property-desc */ 147);
var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ 148);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(/*! ./_hide */ 97)(IteratorPrototype, __webpack_require__(/*! ./_wks */ 56)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 987 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_microtask.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ./_global */ 55);
var macrotask = __webpack_require__(/*! ./_task */ 482).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(/*! ./_cof */ 143)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 988 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/core-js/library/modules/_object-assign.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ 66);
var getKeys = __webpack_require__(/*! ./_object-keys */ 124);
var gOPS = __webpack_require__(/*! ./_object-gops */ 266);
var pIE = __webpack_require__(/*! ./_object-pie */ 146);
var toObject = __webpack_require__(/*! ./_to-object */ 125);
var IObject = __webpack_require__(/*! ./_iobject */ 261);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(/*! ./_fails */ 111)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 989 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_object-dps.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(/*! ./_object-dp */ 75);
var anObject = __webpack_require__(/*! ./_an-object */ 89);
var getKeys = __webpack_require__(/*! ./_object-keys */ 124);

module.exports = __webpack_require__(/*! ./_descriptors */ 66) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 990 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/_object-gopd.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(/*! ./_object-pie */ 146);
var createDesc = __webpack_require__(/*! ./_property-desc */ 147);
var toIObject = __webpack_require__(/*! ./_to-iobject */ 113);
var toPrimitive = __webpack_require__(/*! ./_to-primitive */ 271);
var has = __webpack_require__(/*! ./_has */ 112);
var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */ 469);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(/*! ./_descriptors */ 66) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 991 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/core-js/library/modules/_object-gopn-ext.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(/*! ./_to-iobject */ 113);
var gOPN = __webpack_require__(/*! ./_object-gopn */ 475).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 992 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_object-gpo.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(/*! ./_has */ 112);
var toObject = __webpack_require__(/*! ./_to-object */ 125);
var IE_PROTO = __webpack_require__(/*! ./_shared-key */ 268)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 993 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_object-sap.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(/*! ./_export */ 49);
var core = __webpack_require__(/*! ./_core */ 39);
var fails = __webpack_require__(/*! ./_fails */ 111);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 994 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/core-js/library/modules/_object-to-array.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ 66);
var getKeys = __webpack_require__(/*! ./_object-keys */ 124);
var toIObject = __webpack_require__(/*! ./_to-iobject */ 113);
var isEnum = __webpack_require__(/*! ./_object-pie */ 146).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 995 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/core-js/library/modules/_set-collection-from.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(/*! ./_export */ 49);
var aFunction = __webpack_require__(/*! ./_a-function */ 142);
var ctx = __webpack_require__(/*! ./_ctx */ 96);
var forOf = __webpack_require__(/*! ./_for-of */ 144);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 996 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/core-js/library/modules/_set-collection-of.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(/*! ./_export */ 49);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 997 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/_string-at.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ./_to-integer */ 270);
var defined = __webpack_require__(/*! ./_defined */ 258);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 998 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/core-js/library/modules/_to-absolute-index.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(/*! ./_to-integer */ 270);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 999 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/_user-agent.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(/*! ./_global */ 55);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1000 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/core-js/library/modules/core.get-iterator.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(/*! ./_an-object */ 89);
var get = __webpack_require__(/*! ./core.get-iterator-method */ 274);
module.exports = __webpack_require__(/*! ./_core */ 39).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1001 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/core-js/library/modules/core.is-iterable.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(/*! ./_classof */ 186);
var ITERATOR = __webpack_require__(/*! ./_wks */ 56)('iterator');
var Iterators = __webpack_require__(/*! ./_iterators */ 123);
module.exports = __webpack_require__(/*! ./_core */ 39).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1002 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/core-js/library/modules/es6.array.from.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(/*! ./_ctx */ 96);
var $export = __webpack_require__(/*! ./_export */ 49);
var toObject = __webpack_require__(/*! ./_to-object */ 125);
var call = __webpack_require__(/*! ./_iter-call */ 472);
var isArrayIter = __webpack_require__(/*! ./_is-array-iter */ 470);
var toLength = __webpack_require__(/*! ./_to-length */ 187);
var createProperty = __webpack_require__(/*! ./_create-property */ 983);
var getIterFn = __webpack_require__(/*! ./core.get-iterator-method */ 274);

$export($export.S + $export.F * !__webpack_require__(/*! ./_iter-detect */ 473)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1003 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/core-js/library/modules/es6.array.iterator.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(/*! ./_add-to-unscopables */ 974);
var step = __webpack_require__(/*! ./_iter-step */ 474);
var Iterators = __webpack_require__(/*! ./_iterators */ 123);
var toIObject = __webpack_require__(/*! ./_to-iobject */ 113);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(/*! ./_iter-define */ 262)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1004 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/core-js/library/modules/es6.number.is-nan.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(/*! ./_export */ 49);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1005 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./~/core-js/library/modules/es6.number.max-safe-integer.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(/*! ./_export */ 49);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1006 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/core-js/library/modules/es6.object.assign.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(/*! ./_export */ 49);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(/*! ./_object-assign */ 988) });


/***/ }),
/* 1007 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./~/core-js/library/modules/es6.object.define-property.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(/*! ./_export */ 49);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(/*! ./_descriptors */ 66), 'Object', { defineProperty: __webpack_require__(/*! ./_object-dp */ 75).f });


/***/ }),
/* 1008 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/core-js/library/modules/es6.object.keys.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(/*! ./_to-object */ 125);
var $keys = __webpack_require__(/*! ./_object-keys */ 124);

__webpack_require__(/*! ./_object-sap */ 993)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1009 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/core-js/library/modules/es6.promise.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(/*! ./_library */ 145);
var global = __webpack_require__(/*! ./_global */ 55);
var ctx = __webpack_require__(/*! ./_ctx */ 96);
var classof = __webpack_require__(/*! ./_classof */ 186);
var $export = __webpack_require__(/*! ./_export */ 49);
var isObject = __webpack_require__(/*! ./_is-object */ 82);
var aFunction = __webpack_require__(/*! ./_a-function */ 142);
var anInstance = __webpack_require__(/*! ./_an-instance */ 257);
var forOf = __webpack_require__(/*! ./_for-of */ 144);
var speciesConstructor = __webpack_require__(/*! ./_species-constructor */ 481);
var task = __webpack_require__(/*! ./_task */ 482).set;
var microtask = __webpack_require__(/*! ./_microtask */ 987)();
var newPromiseCapabilityModule = __webpack_require__(/*! ./_new-promise-capability */ 264);
var perform = __webpack_require__(/*! ./_perform */ 477);
var userAgent = __webpack_require__(/*! ./_user-agent */ 999);
var promiseResolve = __webpack_require__(/*! ./_promise-resolve */ 478);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(/*! ./_wks */ 56)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(/*! ./_redefine-all */ 267)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(/*! ./_set-to-string-tag */ 148)($Promise, PROMISE);
__webpack_require__(/*! ./_set-species */ 480)(PROMISE);
Wrapper = __webpack_require__(/*! ./_core */ 39)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(/*! ./_iter-detect */ 473)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1010 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/core-js/library/modules/es6.set.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(/*! ./_collection-strong */ 980);
var validate = __webpack_require__(/*! ./_validate-collection */ 483);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(/*! ./_collection */ 982)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1011 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/es6.symbol.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(/*! ./_global */ 55);
var has = __webpack_require__(/*! ./_has */ 112);
var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */ 66);
var $export = __webpack_require__(/*! ./_export */ 49);
var redefine = __webpack_require__(/*! ./_redefine */ 479);
var META = __webpack_require__(/*! ./_meta */ 263).KEY;
var $fails = __webpack_require__(/*! ./_fails */ 111);
var shared = __webpack_require__(/*! ./_shared */ 269);
var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */ 148);
var uid = __webpack_require__(/*! ./_uid */ 188);
var wks = __webpack_require__(/*! ./_wks */ 56);
var wksExt = __webpack_require__(/*! ./_wks-ext */ 273);
var wksDefine = __webpack_require__(/*! ./_wks-define */ 272);
var enumKeys = __webpack_require__(/*! ./_enum-keys */ 984);
var isArray = __webpack_require__(/*! ./_is-array */ 471);
var anObject = __webpack_require__(/*! ./_an-object */ 89);
var isObject = __webpack_require__(/*! ./_is-object */ 82);
var toObject = __webpack_require__(/*! ./_to-object */ 125);
var toIObject = __webpack_require__(/*! ./_to-iobject */ 113);
var toPrimitive = __webpack_require__(/*! ./_to-primitive */ 271);
var createDesc = __webpack_require__(/*! ./_property-desc */ 147);
var _create = __webpack_require__(/*! ./_object-create */ 265);
var gOPNExt = __webpack_require__(/*! ./_object-gopn-ext */ 991);
var $GOPD = __webpack_require__(/*! ./_object-gopd */ 990);
var $GOPS = __webpack_require__(/*! ./_object-gops */ 266);
var $DP = __webpack_require__(/*! ./_object-dp */ 75);
var $keys = __webpack_require__(/*! ./_object-keys */ 124);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(/*! ./_object-gopn */ 475).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(/*! ./_object-pie */ 146).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(/*! ./_library */ 145)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(/*! ./_hide */ 97)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1012 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/core-js/library/modules/es7.object.entries.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(/*! ./_export */ 49);
var $entries = __webpack_require__(/*! ./_object-to-array */ 994)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1013 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/core-js/library/modules/es7.promise.finally.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(/*! ./_export */ 49);
var core = __webpack_require__(/*! ./_core */ 39);
var global = __webpack_require__(/*! ./_global */ 55);
var speciesConstructor = __webpack_require__(/*! ./_species-constructor */ 481);
var promiseResolve = __webpack_require__(/*! ./_promise-resolve */ 478);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1014 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/core-js/library/modules/es7.promise.try.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(/*! ./_export */ 49);
var newPromiseCapability = __webpack_require__(/*! ./_new-promise-capability */ 264);
var perform = __webpack_require__(/*! ./_perform */ 477);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1015 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/core-js/library/modules/es7.set.from.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(/*! ./_set-collection-from */ 995)('Set');


/***/ }),
/* 1016 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/core-js/library/modules/es7.set.of.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(/*! ./_set-collection-of */ 996)('Set');


/***/ }),
/* 1017 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/core-js/library/modules/es7.set.to-json.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(/*! ./_export */ 49);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(/*! ./_collection-to-json */ 981)('Set') });


/***/ }),
/* 1018 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/core-js/library/modules/es7.symbol.async-iterator.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./_wks-define */ 272)('asyncIterator');


/***/ }),
/* 1019 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/core-js/library/modules/es7.symbol.observable.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./_wks-define */ 272)('observable');


/***/ }),
/* 1020 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-01f4a2a2","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/integration/fileUpload/FileUpload.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.upload-box-padding {\n  padding: 0px !important;\n}\n.upload-label {\n  text-transform: initial !important;\n  color: #515151;\n  font-weight: normal !important;\n  font-size: 18px !important;\n  margin: 20px 30px;\n}\n.upload-link {\n  font-weight: bold !important;\n}\n.dz-message {\n  font-size: 23px;\n  color: #a9a9a9;\n  font-family: 'Inter', sans-serif;\n}\ni.fa.fa-cloud-upload {\n  font-size: 70px;\n}\n.upload-button {\n  color: #fff;\n  background: #17375f;\n  border: 0px;\n  font-size: 14px;\n  padding: 10px;\n  border-radius: 5px;\n  font-family: 'Inter', sans-serif;\n}\n@media screen and (min-width: 1400px) {\n.upload-box-fa-file {\n    font-size: 40px;\n    font-weight: normal;\n    padding-top: 3px !important;\n}\n.upload-box {\n    /*width: 49%;*/\n    border: 2px solid #bbbaba;\n    margin-bottom: 10px;\n    padding: 10px 0px 8px 20px;\n    min-height: 70px;\n}\n.upload-box-info {\n    margin: 0px;\n}\n}\n@media screen and (min-width: 1200px) and (max-width: 1399px) {\n.upload-box-fa-file {\n    font-size: 30px;\n    font-weight: normal;\n    padding-top: 7px !important;\n}\n.upload-box {\n    /*width: 49%;*/\n    border: 2px solid #bbbaba;\n    margin-bottom: 10px;\n    padding: 10px 0px 8px 10px;\n    min-height: 70px;\n}\n.upload-box-info {\n    margin: 0px 1% 0px 1%;\n    width: 80%;\n}\n}\n@media screen and (max-width: 1199px) {\n.upload-box-fa-file {\n    font-size: 40px;\n    font-weight: normal;\n    padding-top: 3px !important;\n}\n.upload-box {\n    /*width: 49%;*/\n    border: 2px solid #bbbaba;\n    margin-bottom: 10px;\n    padding: 10px 0px 8px 20px;\n    min-height: 70px;\n}\n.upload-box-info {\n    margin: 0px;\n}\n}\n.details {\n  overflow: hidden;\n  color: #696969;\n  background-color: transparent;\n  margin-top: 5px;\n}\n.error-label {\n  color: red;\n  font-size: 2vh;\n  font-family: 'Inter', sans-serif;\n}\n.error-icon {\n  color: red !important;\n  font-size: 3vh;\n}\n.success-label {\n  color: green;\n  font-size: 2vh;\n  font-family: 'Inter', sans-serif;\n}\n.success-icon {\n  color: green !important;\n  font-size: 3vh;\n}\n.error-mark {\n  float: left;\n  width: 100%;\n  pointer-events: none;\n  z-index: 100 !important;\n  margin-left: auto;\n  margin-top: auto;\n  opacity: 1;\n  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.dropzone .dz-preview .dz-progress {\n  z-index: 102 !important;\n}\n.dropzone .dz-preview .dz-success-mark {\n  z-index: 100 !important;\n}\n.dropzone .dz-preview .dz-error-mark {\n  z-index: 101 !important;\n}\n.dropzone .dz-preview:hover {\n  z-index: 100 !important;\n}\n.size {\n  font-size: 12px;\n  font-weight: bold;\n}\n.filename {\n  font-size: 13px !important;\n}\n.dz-inner {\n  text-align: center;\n  color: #a9a9a9;\n}\n.error-message {\n  pointer-events: none;\n  z-index: 1000;\n  display: none;\n  opacity: 0;\n  transition: opacity .3s ease;\n  border-radius: 8px;\n  font-size: 13px;\n  width: 140px;\n  background: linear-gradient(180deg, #be2626, #a92222);\n  padding: .5em 1.2em;\n  color: #fff;\n  top: 90%;\n  left: 70%;\n}\n#FileUploadWrapper > .dz-error-mark i {\n  display: none !important;\n}\n.vue-dropzone {\n  border: 2px dashed #d6d6d6 !important;\n  font-family: 'Arial', sans-serif;\n  letter-spacing: 0.2px;\n  color: #777;\n  transition: background-color .2s linear;\n  margin: 15px 0px 10px 0px;\n}\n.vue-dropzone .dz-preview .dz-details {\n    overflow: hidden !important;\n    color: #696969 !important;\n    background-color: #fff !important;\n    border: 2px solid #bbbaba !important;\n}\n.vue-dropzone .dz-preview .dz-remove {\n    text-transform: initial !important;\n    font-size: 2vh !important;\n    color: #696969 !important;\n    border: 2px solid #bbbaba !important;\n    padding: .8vh !important;\n}\n.vue-dropzone .dz-preview .dz-error-message {\n    top: 90% !important;\n    left: 70% !important;\n}\n.dropzone .dz-preview {\n  float: left !important;\n  min-height: 70px !important;\n  margin: 15px 0px 0px 0px !important;\n}\n.dropzone .dz-preview .dz-progress {\n  opacity: 1;\n  position: absolute;\n  height: 10px !important;\n  top: auto !important;\n  bottom: 0px !important;\n  left: 0px !important;\n  margin-top: 0px !important;\n  width: 100% !important;\n  margin-left: 0px !important;\n  background: rgba(255, 255, 255, 0.9) !important;\n  -webkit-transform: scale(1);\n  border-radius: 2px !important;\n  overflow: hidden;\n}\n.dz-success {\n  opacity: 1;\n  position: absolute;\n  height: 10px !important;\n  top: auto !important;\n  bottom: 0px !important;\n  left: 0px !important;\n  margin-top: 0px !important;\n  transition: width .5s ease-in-out;\n  border-radius: 2px !important;\n  overflow: hidden;\n}\n.dz-error {\n  opacity: 1;\n  position: absolute;\n  height: 10px !important;\n  top: auto !important;\n  bottom: 0px !important;\n  left: 0px !important;\n  margin-top: 0px !important;\n  transition: width .5s ease-in-out;\n  border-radius: 2px !important;\n  overflow: hidden;\n}\n.dropzone .dz-preview .dz-progress .dz-upload {\n  height: 10px !important;\n  transition: width .3s ease-in-out;\n}\n.dz-error-mark-message {\n  background: transparent !important;\n}\nspan.dz-error-mark,\n.dz-error-mark-label {\n  opacity: 1;\n  position: absolute !important;\n  height: auto !important;\n  top: auto !important;\n  bottom: 0px !important;\n  left: 0px !important;\n  margin-top: -20px !important;\n  width: 100% !important;\n  margin-left: 0px !important;\n  /*background: hsla(0,0%,100%,.9)!important;*/\n  overflow: hidden;\n}\n.dz-success-mark {\n  opacity: 1 !important;\n  animation: none !important;\n  left: 0 !important;\n}\n.dropzone .dz-preview.dz-error .dz-error-mark {\n  opacity: 1 !important;\n  animation: none !important;\n}\n.dropzone .dz-preview .dz-success-mark svg,\n.dropzone .dz-preview .dz-error-mark svg {\n  display: block !important;\n  width: 54px !important;\n  height: 54px !important;\n}\n.remover-arquivo {\n  font-size: 20px;\n  height: 40px;\n  color: #FFF;\n  padding-top: 8px !important;\n}\n.span-status {\n  font-style: italic;\n  font-size: 12px;\n  margin-top: 2px;\n  color: #bdbdbd;\n}\n.messageError {\n  float: right;\n  font-style: normal;\n  font-size: 12px;\n  color: #34B8BA;\n}\n.border-radius-progress-bar {\n  border-radius: 5px !important;\n}\n.upload-disabled {\n  padding: 15px 0px;\n  cursor: not-allowed;\n}\ni.icon-upload-disabled {\n  font-size: 70px;\n  color: #FF2B3F;\n}\np.txt-upload-disabled {\n  font-size: 24px;\n}\n.dropzone .dz-preview .dz-error-mark, .dropzone .dz-preview .dz-success-mark {\n  pointer-events: auto !important;\n}\n.loadingData {\n  background: url(" + __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67) + ") 50% 50% no-repeat;\n  cursor: wait;\n  height: 390px;\n  background-size: 100px;\n}\n.titulo {\n  font-weight: bolder;\n}\n", ""]);

// exports


/***/ }),
/* 1021 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-1b8ade6c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/menu/SidebarMenu.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#menu-lateral {\n  position: relative;\n}\nbody.sidebar-visible .page-content-wrapper {\n  padding: 80px 0 0 105px;\n}\nbody .page-content-wrapper {\n  transition: all 150ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n  backface-visibility: hidden;\n  -ms-perspective: 1000;\n  perspective: 1000;\n}\nbody .page-content-wrapper > .container-fluid.container-fixed-lg {\n    width: auto !important;\n}\n@media (max-width: 991px) {\nbody .page-content-wrapper {\n    margin-right: 0 !important;\n}\nbody .page-sidebar {\n    transition: width 150ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n    margin-left: 0;\n    display: block;\n    z-index: 253 !important;\n}\nbody .page-sidebar .sidebar-menu > p.group-text {\n      display: none;\n}\nbody .page-sidebar .sidebar-bottom {\n      display: none;\n}\nbody.sidebar-visible .page-content-wrapper {\n    padding: 80px 0 0 70px !important;\n}\nbody.sidebar-visible .header {\n    margin-left: 70px !important;\n    width: calc(100% - 70px) !important;\n}\nbody.sidebar-visible .page-sidebar {\n    width: 70px !important;\n}\nbody.sidebar-visible .page-sidebar .sidebar-header a {\n      background: url(" + __webpack_require__(/*! ../../../assets/logos_equals/logo_equals_quadrado.png */ 685) + ") no-repeat 50% 50%;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li > a.group > p.group-text {\n      display: none;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li > a.group:hover + ul.group-options {\n      display: block !important;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options {\n      width: 267px;\n      position: absolute;\n      left: 70px;\n      margin-top: -53px;\n      display: none;\n      border: 1px solid #21252d;\n      border-radius: 5px;\n      z-index: 253 !important;\n      height: auto !important;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options:hover {\n        display: block !important;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options span {\n        border-top: 1px solid #10253E;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n        background-color: #10253E;\n        font-size: 13px;\n        padding: 20px 18px;\n        font-family: 'Inter', sans-serif !important;\n        color: #37F3F5;\n        font-weight: 600;\n        letter-spacing: 0.1117em;\n        width: 100%;\n        display: block;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options > li {\n        background-color: #123258;\n        padding-left: 0 !important;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options > li:last-child {\n          border-bottom: 1px solid #123258;\n          border-bottom-left-radius: 3px;\n          border-bottom-right-radius: 3px;\n}\nbody.sidebar-invisible .page-content-wrapper {\n    padding: 80px 0 0 0px !important;\n}\nbody.sidebar-invisible .header {\n    margin-left: 0 !important;\n    width: 100% !important;\n}\nbody.sidebar-invisible .page-sidebar {\n    width: 0 !important;\n}\nbody.sidebar-invisible .page-sidebar > * {\n      display: none;\n}\n}\n@media (min-width: 992px) {\nbody .page-sidebar {\n    margin-left: 210px;\n}\n  /**\n    * Sidebar aberto acima de 991px.\n    */\nbody.sidebar-visible .page-content-wrapper {\n    margin-right: 50px !important;\n    padding: 80px 0 0 300px;\n}\nbody.sidebar-visible .header {\n    margin-left: 260px;\n    width: calc(100% - 260px);\n}\nbody.sidebar-visible .page-sidebar {\n    width: 260px;\n}\nbody.sidebar-visible .page-sidebar .sidebar-header a {\n      background: url(" + __webpack_require__(/*! ../../../assets/logos_equals/logo_equals_branco.png */ 1242) + ") no-repeat 50% 50%;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li.selected {\n      background-color: #132E4D;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li.selected > a.group > * {\n        color: #37F3F5 !important;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li.selected > a.group > p::after {\n        content: \"\\F077\";\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options {\n      background-color: #10253E;\n      width: inherit;\n      overflow-y: hidden;\n      transition-property: max-height;\n      transition-duration: 150ms;\n      transition-delay: 0ms;\n      backface-visibility: hidden;\n      -ms-perspective: 1000;\n      perspective: 1000;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options > span {\n        display: none;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options.is-expanded {\n        transition-timing-function: ease-in;\n        max-height: 999px;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options.is-collapsed {\n        transition-timing-function: ease-out;\n        max-height: 0;\n}\nbody.sidebar-visible .page-sidebar .sidebar-menu ul > li ul.group-options > li {\n        background-color: #10253E !important;\n}\n  /**\n    * Sidebar fechado acima de 991px.\n    */\nbody.sidebar-invisible .page-content-wrapper {\n    margin-right: 50px !important;\n    padding: 80px 0 0 105px;\n}\nbody.sidebar-invisible .header {\n    margin-left: 70px;\n    width: calc(100% - 70px);\n}\nbody.sidebar-invisible .page-sidebar {\n    width: 70px !important;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-header a {\n      background: url(" + __webpack_require__(/*! ../../../assets/logos_equals/logo_equals_quadrado.png */ 685) + ") no-repeat 50% 50%;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-menu ul > li > a.group > p.group-text {\n      display: none;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-menu ul > li > a.group:hover + ul.group-options {\n      display: block !important;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-menu ul > li ul.group-options {\n      width: 267px;\n      position: absolute;\n      left: 70px;\n      margin-top: -53px;\n      display: none;\n      border: 1px solid #21252d;\n      border-radius: 5px;\n      z-index: 253 !important;\n      height: auto !important;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-menu ul > li ul.group-options:hover {\n        display: block !important;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-menu ul > li ul.group-options span {\n        border-top: 1px solid #10253E;\n        border-top-left-radius: 3px;\n        border-top-right-radius: 3px;\n        background-color: #10253E;\n        font-size: 13px;\n        padding: 20px 18px;\n        font-family: 'Inter', sans-serif !important;\n        color: #37F3F5;\n        font-weight: 600;\n        letter-spacing: 0.1117em;\n        width: 100%;\n        display: block;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-menu ul > li ul.group-options > li {\n        background-color: #123258;\n        padding-left: 0 !important;\n}\nbody.sidebar-invisible .page-sidebar .sidebar-menu ul > li ul.group-options > li:last-child {\n          border-bottom: 1px solid #123258;\n          border-bottom-left-radius: 3px;\n          border-bottom-right-radius: 3px;\n}\n}\n\n/**\n  * Estilo comum do sidebar, nesse caso, o sidebar aberto e fechado.\n  */\n.page-sidebar {\n  transition: all 150ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n  z-index: 253 !important;\n  backface-visibility: hidden;\n  -ms-perspective: 1000;\n  perspective: 1000;\n}\n.page-sidebar .sidebar-header {\n    background: #142C4F;\n    border: none;\n    padding: 0px;\n    height: 60px;\n    width: 100%;\n}\n.page-sidebar .sidebar-header a {\n      transition: unset !important;\n      display: block;\n      width: 100%;\n      height: 100%;\n}\n.page-sidebar .sidebar-menu {\n    background-color: #1B3C65;\n}\n.page-sidebar .sidebar-menu ul {\n      position: relative;\n      height: 100%;\n      margin-bottom: 0px;\n      margin-right: 0px;\n      max-height: 999px;\n      list-style: none;\n      display: block;\n      width: 100%;\n}\n.page-sidebar .sidebar-menu ul > li.loading-functionalities {\n        height: 85%;\n        padding: 0 !important;\n        line-height: 0 !important;\n        text-align: center;\n}\n.page-sidebar .sidebar-menu ul > li.loading-functionalities::before {\n          content: \"\";\n          display: inline-block;\n          height: 100%;\n          vertical-align: middle;\n          font-size: 0;\n}\n.page-sidebar .sidebar-menu ul > li.loading-functionalities > * {\n          vertical-align: middle;\n          width: 100%;\n          max-width: 70px;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) {\n        padding: 0px !important;\n        width: 100%;\n        line-height: 0px;\n        min-height: 53px;\n        position: relative;\n        display: block;\n        clear: right;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities):hover:not(.active) {\n          text-decoration: none;\n          background-color: #132E4D;\n          transition: color,background-color 100ms linear;\n          backface-visibility: hidden;\n          -ms-perspective: 1000;\n          perspective: 1000;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities):hover:not(.active) > a.group > * {\n            color: #FFF;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities).active {\n          background-color: #132E4D;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities).active > a.group {\n            border-color: #37F3F5;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities).active > a.group > * {\n              color: #37F3F5 !important;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) > a.group {\n          border-left: 5px solid transparent;\n          line-height: 53px;\n          display: -ms-inline-flexbox;\n          display: inline-flex;\n          padding-left: 15px;\n          text-decoration: none;\n          width: 100%;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) > a.group > .group-icon {\n            width: 30px;\n            text-align: center;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) > a.group > .group-icon > i {\n              font-size: 18px;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) > a.group .group-icon, .page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) > a.group p {\n            color: #8AA4AF;\n            font-weight: 600;\n            letter-spacing: 0.1em;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) > a.group p.group-text {\n            position: absolute;\n            font-size: 13px;\n            margin-left: 40px;\n            line-height: 53px;\n            transition: unset !important;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) > a.group p.group-text::after {\n              content: \"\\F078\";\n              font-family: FontAwesome;\n              font-style: normal;\n              right: 15px;\n              position: fixed;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) ul.group-options > li {\n          min-height: 36px;\n          line-height: 22px;\n          padding-left: 25px !important;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) ul.group-options > li.active {\n            font-weight: 600;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) ul.group-options > li.active > a {\n              color: white !important;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) ul.group-options > li > a {\n            letter-spacing: 0;\n            text-decoration: none;\n            width: 100%;\n            font-family: 'Inter', serif !important;\n            color: #8AA4AF;\n            padding: 6px 18px 6px 35px;\n            width: 100%;\n            display: block;\n}\n.page-sidebar .sidebar-menu ul > li:not(.loading-functionalities) ul.group-options > li > a:hover {\n              color: white;\n              font-weight: 600;\n}\n.page-sidebar .sidebar-bottom {\n    background-color: #132C4A;\n    vertical-align: middle;\n    height: 40px;\n    width: 100%;\n    z-index: 253 !important;\n    position: absolute;\n    bottom: 0;\n    color: #FFF;\n    cursor: pointer;\n    padding-top: 12px;\n    text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 1022 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-40c8036e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/chart/Chart.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n@charset \"UTF-8\";\n.dashboard-top {\n  background-color: #EEE;\n  height: 400px;\n}\n.button-content {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  height: 36px;\n  pointer-events: all;\n  width: 36px;\n}\n.button-content > i {\n    transition: 150ms;\n}\n.button-content > i.open, .button-content > i.chartMiddle {\n      margin-top: 5px;\n      -ms-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n/*Estilo para a div dos gráficos*/\n.dashboard-chart {\n  margin-bottom: 20px;\n}\n.dashboard-top {\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #1a3b5f;\n  font-family: 'Inter', sans-serif;\n  font-weight: 700;\n  font-size: 13px;\n  color: #FFF;\n  height: 36px;\n  cursor: move;\n  padding-left: 0px;\n}\n.dashboard-top-chart-name {\n  background-color: #40b9bb;\n  font-size: 15px;\n  padding: 7px 8px;\n  float: left;\n  height: 36px;\n  width: 30%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dashboard-action-bar {\n  color: #ffffff;\n  width: 100%;\n  padding: 0px 15px;\n  float: left;\n  height: 36px;\n  background-color: #1a3b5f;\n}\n.chart-content {\n  width: 100%;\n}\n.chart-content > .button-content {\n    position: absolute;\n    right: 15px;\n}\n.chart-content > .button-content.top {\n      top: 0;\n}\n.chart-content > .button-content.bottom {\n      bottom: 0;\n}\n", ""]);

// exports


/***/ }),
/* 1023 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-54cd97fd","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/menu/TopBar.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\nhtml body {\n  font-style: normal;\n  background-color: #f4f4f4;\n  -moz-appearance: none !important;\n}\n.header {\n  border: none !important;\n  height: 60px !important;\n  z-index: 199 !important;\n  background: #142C4F;\n  background: linear-gradient(to right, #142C4F, #3BB5B4);\n  transition: all 150ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n}\n.header a > i {\n    color: white;\n}\n.header .brand {\n    width: 22px !important;\n    margin-left: 20px;\n}\n.header .aplicacao-nome-topo {\n    padding: 12px 0px 0px 13px;\n}\n@media (max-width: 991px) {\n.header .aplicacao-nome-topo {\n        text-align: center;\n}\n}\n@media (min-width: 992px) {\n.header .aplicacao-nome-topo {\n        float: left;\n}\n}\n.header .aplicacao-nome-topo span {\n      font-family: 'Inter', sans-serif;\n      font-weight: 700;\n      color: #E5E5E5;\n      font-size: 25px;\n      text-transform: capitalize;\n}\n.header .user-info {\n    margin-right: 10px;\n    font-size: 13px;\n    color: #FFF;\n    font-family: 'Inter', sans-serif;\n}\n.header .user-info hr {\n      border: none;\n      clear: both;\n      border-top: 1px solid #65BBC2;\n      margin: -1px 0px 3px 0px;\n}\n.header .user-info span {\n      float: right;\n}\n.header .user-info span.user-info-client {\n        font-weight: bold;\n}\n.header .top-user-icons {\n    margin-right: 10px;\n    width: 38px;\n    height: 38px;\n    border-radius: 19px;\n    padding: 0px;\n    display: block;\n    background-color: #1E7F81;\n    color: #EEE;\n    font-size: 21px;\n    text-align: center;\n}\n.header .top-user-icons .fa {\n      padding-top: 7px;\n}\n.header .top-user-icons a {\n      display: block;\n      color: #FFF;\n}\n.header .top-user-icons a:hover {\n        opacity: 0.8;\n}\n", ""]);

// exports


/***/ }),
/* 1024 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-632aab56","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/Dashboard.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.sortable-chosen, .sortable-ghost {\n  background: none !important;\n  background-color: transparent !important;\n  max-width: 100% !important;\n  min-width: 50% !important;\n  content: '';\n  opacity: 0.5 !important;\n  transition: all .2s !important;\n}\n.list-complete-enter, .list-complete-leave-active {\n  background: red;\n}\n.chart-item {\n  margin-bottom: 50px;\n}\n.style-chooser {\n  width: 13vw;\n  float: left;\n  margin-right: 15px;\n}\n.style-chooser .vs__dropdown-toggle {\n  appearance: none;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0 0 4px;\n  background: none;\n  border: 1px solid rgba(60, 60, 60, 0.26);\n  border-radius: 4px;\n  white-space: normal;\n  background: white;\n}\n.col-per-83 {\n  width: 83%;\n}\n.col-per-17 {\n  width: 17%;\n}\n.col-per-100 {\n  width: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 1025 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-7b55184e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/gadget/TaskGadgetTabContent.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.boxBorderRight {\n  border-right: 2px solid #d9d9d9;\n}\n.boxQtde {\n  padding-top: 15px;\n  height: 125px;\n  margin: 0px 0px 20px 0px;\n}\nspan.valorQtde {\n  font-size: 40px;\n  color: #4a4a4a;\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n}\nlabel.valorQtdeTxt {\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #b0b0b0;\n  margin-top: 8px;\n}\n.boxTarefas {\n  padding-top: 45px;\n}\n.alerta {\n  margin-top: 10px;\n  margin-bottom: 30px;\n}\n.alerta > div div {\n    display: inline-block;\n    max-width: 90%;\n}\n.alerta > div div.alerta-text {\n      margin-left: 10px;\n}\n.alerta span {\n    font-family: 'Inter', sans-serif;\n    font-size: 15px;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #4a4a4a;\n    margin-bottom: 15px;\n}\n.alerta span.link {\n      font-family: 'Inter', sans-serif;\n      font-weight: 700;\n      color: #00ABEA;\n      font-size: 15px;\n      cursor: pointer;\n}\n.badge-custom-tasks {\n  padding: 5px 2px;\n  background-color: #f55753 !important;\n  border-radius: 50%;\n  min-width: 30px;\n  right: 5px;\n  font-family: 'Inter', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  color: #ffffff;\n  vertical-align: top !important;\n}\n", ""]);

// exports


/***/ }),
/* 1026 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-c5e6e690","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/step/StepProgress.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.step-progress__wrapper[data-v-c5e6e690] {\n  width: 60%;\n  margin: 0 auto;\n  position: relative;\n}\n.step-progress__wrapper-before[data-v-c5e6e690] {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  height: 12px;\n  width: 100%;\n  background-color: #b5b5b5;\n  transform: translateY(-50%) perspective(1000px);\n}\n.step-progress__wrapper-after[data-v-c5e6e690] {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  height: 12px;\n  width: 100%;\n  background-color: #40b9bb;\n  transform: scaleX(0) translateY(-50%) perspective(1000px);\n  -ms-transform-origin: left center;\n      transform-origin: left center;\n  transition: transform .5s ease;\n}\n.step-progress__bar[data-v-c5e6e690] {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100px;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 25px;\n}\n.step-progress__step[data-v-c5e6e690] {\n  z-index: 2;\n  position: relative;\n  --activeColor: #40b9bb;\n  --passiveColor: #b5b5b5;\n  --activeBorder: 5px;\n  --passiveBorder: 5px;\n}\n.step-progress__step--active span[data-v-c5e6e690] {\n    color: var(--activeColor);\n}\n.step-progress__step--active .step-progress__step-label[data-v-c5e6e690] {\n    color: var(--activeColor);\n}\n.step-progress__step--active .step-progress__step-icon[data-v-c5e6e690] {\n    opacity: 1;\n}\n.step-progress__step--valid .step-progress__step-icon[data-v-c5e6e690] {\n    opacity: 1;\n    transform: translate3d(-50%, -50%, 0) scale(1) perspective(1000px);\n}\n.step-progress__step--valid .step-progress__step-label[data-v-c5e6e690] {\n    color: var(--activeColor);\n}\n.step-progress__step[data-v-c5e6e690]:after {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%) perspective(1000px);\n    width: 30px;\n    height: 30px;\n    background-color: #fff;\n    border-radius: 50%;\n    border: var(--passiveBorder) solid var(--passiveColor);\n    transition: .3s ease;\n}\n@media (max-width: 767px) {\n.step-progress__step[data-v-c5e6e690]:after {\n        width: 40px;\n        height: 40px;\n}\n}\n.step-progress__step--active[data-v-c5e6e690]:after {\n    border: var(--activeBorder) solid var(--activeColor);\n}\n.step-progress__step--valid[data-v-c5e6e690]:after {\n    background-color: var(--activeColor);\n    border: var(--activeBorder) solid var(--activeColor);\n}\n.step-progress__step-label[data-v-c5e6e690] {\n  position: absolute;\n  top: calc(100% + 25px);\n  left: 50%;\n  transform: translateX(-50%) perspective(1000px);\n  white-space: nowrap;\n  font-weight: 600;\n  color: #b5b5b5;\n  transition: .3s ease;\n}\n.step-progress__step-icon[data-v-c5e6e690] {\n  color: #fff;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transition: transform .3s ease;\n  opacity: 0;\n  transform: translate3d(-50%, -50%, 0) scale(0) perspective(1000px);\n}\n@media (max-width: 767px) {\n.step-progress__step-icon[data-v-c5e6e690] {\n      font-size: 22px;\n}\n}\n", ""]);

// exports


/***/ }),
/* 1027 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/dayspan-vuetify/dist/lib/dayspan-vuetify.min.css ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, ".ds-button-tall{height:48px;margin-top:0;margin-bottom:0}.ds-textfield.v-input-group--multi-line label{margin-top:6px}.ds-textfield>label{margin:6px 8px}.ds-textfield .v-input-group__input input{height:40px}.ds-textfield .v-input-group__input input,.ds-textfield .v-input-group__input textarea{background-color:#f5f5f5;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);padding:10px}.ds-textfield .v-input-group__details:before{background-color:#f5f5f5!important}.ds-textfield.inline{width:auto;display:inline-block!important;margin-left:6px;margin-right:6px;top:14px;padding-top:0;margin-top:-14px}.ds-textfield.inline.small{width:60px}.ds-dropdown .v-input-group__input{background-color:#f5f5f5;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);height:40px;padding:10px}.ds-button,.ds-dropdown .v-input-group__details:before{background-color:#f5f5f5!important}.ds-button{height:40px}.ds-button.push-down{margin-top:18px}.ds-light-forecolor{color:#757575!important}.ds-fullscreen{position:fixed!important;top:0!important;left:0!important;width:100%!important;height:100%!important;max-height:auto!important;max-width:100%!important;min-width:100%!important}.ds-fullscreen>*{height:100%}.ds-gesture-container[data-v-33b6bfdc]{width:100%;height:100%}.ds-day[data-v-4c181404]{-ms-flex:1;flex:1;width:0;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;padding:4px;overflow:hidden}.ds-day .ds-dom[data-v-4c181404],.ds-day[data-v-4c181404]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-day .ds-dom[data-v-4c181404]{text-decoration:none;color:#212121;width:24px;height:24px;line-height:24px;text-align:center}.ds-day .ds-dom[data-v-4c181404]:hover{text-decoration:underline}.ds-day .ds-dom.ds-today-dom[data-v-4c181404]{border-radius:12px;background-color:#4285f4;color:#fff;display:inline-block;position:relative;z-index:1}.ds-out-calendar[data-v-4c181404]{color:#757575}.ds-week[data-v-eb16c334]{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1}.ds-week-view-container[data-v-30ccf664]{-ms-flex-direction:column;flex-direction:column;height:100%}.ds-week-view-container .ds-week-view-bottom[data-v-30ccf664],.ds-week-view-container[data-v-30ccf664]{display:-ms-flexbox;display:flex;overflow:hidden}.ds-week-view-container .ds-week-view-bottom[data-v-30ccf664]{-ms-flex:1 1 60%;flex:1 1 60%;position:relative;-ms-flex-direction:column;flex-direction:column}.ds-week-view-container .ds-week-view-scrollable[data-v-30ccf664]{overflow-y:scroll;-ms-flex:1 1 auto;flex:1 1 auto;display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.ds-week-view-container .ds-week-view-pane[data-v-30ccf664]{width:100%;overflow-y:hidden;-ms-flex:none;flex:none;display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.ds-week-view-container .ds-week-view-pane .ds-day[data-v-30ccf664]{position:relative}.ds-week-view-container .ds-week[data-v-30ccf664]{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;width:100%;height:100%}.ds-week-view-container .ds-hour-list[data-v-30ccf664]{-ms-flex:none;flex:none;width:44px;border-right:1px solid #e0e0e0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-week-view-container .ds-hour-list .ds-hour[data-v-30ccf664]{text-align:center;border-bottom:none;height:40px}.ds-week-view-container .ds-hour-list .ds-hour .ds-hour-text[data-v-30ccf664]{display:block;position:relative;top:-6px;font-size:10px;color:#212121}.v-menu__activator[data-v-74cb2e5c]{-ms-flex-align:end;align-items:end}.ds-day[data-v-74cb2e5c]{-ms-flex:1;flex:1;width:0;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0}.ds-day.ds-day-today[data-v-74cb2e5c]{background-color:rgba(0,0,0,.04)}.ds-hour[data-v-74cb2e5c]{height:40px;border-bottom:1px solid #e0e0e0}.ds-day-picker .ds-week-header[data-v-36e040b2]{display:-ms-flexbox;display:flex}.ds-day-picker .ds-week-header>div[data-v-36e040b2]{-ms-flex:1;flex:1}.ds-day-picker .ds-week-header .tooltip[data-v-36e040b2]{-ms-flex:1;flex:1;text-align:center}.ds-day-picker .ds-week-header .subtitle[data-v-36e040b2]{-ms-flex:5;flex:5}.ds-day-picker .ds-week-subheader[data-v-36e040b2],.ds-day-picker .ds-week[data-v-36e040b2]{display:-ms-flexbox;display:flex;text-align:center}.ds-day-picker .ds-week[data-v-36e040b2]{-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.ds-day-picker .ds-weekday[data-v-36e040b2]{-ms-flex:1;flex:1}.ds-day-picker .ds-day-pick[data-v-36e040b2]{-ms-flex:1 0 14%;flex:1 0 14%}.ds-agenda-table[data-v-8262ea58]{width:100%;border-spacing:0;table-layout:fixed}.column-day[data-v-8262ea58]{width:100px}.column-when[data-v-8262ea58]{min-width:200px;width:30%}.column-event[data-v-8262ea58]{width:70%}.ds-agenda-day tr:first-child td[data-v-64bbe350]{padding-top:6px}.ds-agenda-day tr:last-child td[data-v-64bbe350]{padding-bottom:6px}.ds-day-today .ds-agenda-lines[data-v-64bbe350]{color:#4285f4;font-weight:700}.ds-day-past .ds-agenda-details[data-v-64bbe350],.ds-day-past .ds-agenda-lines[data-v-64bbe350],.ds-day-past .ds-agenda-when[data-v-64bbe350]{color:#9e9e9e}.ds-calendar-event-menu[data-v-52125556]{width:100%}.ds-agenda-activator[data-v-52125556]{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ds-first-event td[data-v-52125556]{border-top:1px solid #e0e0e0}.ds-agenda-lines[data-v-52125556]{vertical-align:top;padding:4px 4px 4px 1em}.ds-agenda-lines .ds-agenda-line-first[data-v-52125556]{font-size:12px}.ds-agenda-lines .ds-agenda-line-second[data-v-52125556]{font-size:14px;cursor:pointer;margin-top:-4px}.ds-agenda-lines .ds-agenda-line-second[data-v-52125556]:hover{text-decoration:underline}.ds-agenda-event .ds-agenda-details strong[data-v-52125556]{cursor:pointer}.ds-agenda-event .ds-agenda-details strong[data-v-52125556]:hover{text-decoration:underline}.ds-agenda-details[data-v-52125556]{padding:4px;cursor:pointer}.ds-calendar[data-v-5325b506]{width:100%;height:100%;position:relative;padding:0!important}.ds-month-view[data-v-5325b506]{width:100%;height:100%}.ds-month-view .ds-today[data-v-5325b506]{background-color:rgba(0,0,0,.04)}.ds-week-view[data-v-5325b506]{position:absolute;top:0;right:0;bottom:0;left:0;overflow-y:auto;outline:none;background-color:#fff}.ds-year-view .ds-first-day[data-v-5325b506]{font-weight:700}.ds-year-view .ds-first-day-day[data-v-5325b506]{background-color:rgba(0,0,0,.08)}.ds-app-calendar-toolbar .v-toolbar__content{border-bottom:1px solid #e0e0e0}.ds-skinny-button{margin-left:2px!important;margin-right:2px!important}.ds-expand{width:100%;height:100%}.ds-calendar-container{padding:0!important;position:relative}.v-btn--floating.ds-add-event-today .v-icon{width:24px;height:24px}.ds-calendar-event-menu[data-v-46108b38]{width:100%;height:18px;pointer-events:none}.ds-calendar-event[data-v-46108b38]{margin:1px;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:.5em;font-size:12px;cursor:pointer;position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;margin:0;border-radius:2px;pointer-events:all}.ds-calendar-event-menu[data-v-7a377cd1]{width:100%}.ds-calendar-event[data-v-7a377cd1]{margin:1px;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:.5em;font-size:12px;cursor:pointer;position:absolute;right:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:2px;pointer-events:none}.ds-calendar-event .v-menu__activator[data-v-7a377cd1]{-ms-flex-align:end;align-items:end}.ds-calendar-event .ds-calendar-event-span[data-v-7a377cd1]{width:100%;height:100%;pointer-events:all}.ds-calendar-event-popover-card .v-btn--floating.v-btn--left[data-v-7461b951]{margin-left:0!important}.ds-calendar-event-popover-card .v-btn--floating.v-btn--left .v-icon[data-v-7461b951]{height:auto}.ds-calendar-event-popover-card .v-card__text[data-v-7461b951]{padding:16px 0}.ds-calendar-event-popover-card .v-card__text .v-list .v-list__tile[data-v-7461b951]{padding:0!important;height:auto}.ds-calendar-event-popover-card .v-toolbar__extension[data-v-7461b951]{padding:0 16px!important}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title[data-v-7461b951]{margin-left:56px}.ds-calendar-event-menu[data-v-26705f1f]{width:100%;height:18px}.ds-calendar-event-menu .ds-calendar-event[data-v-26705f1f]{height:100%}.v-btn--floating.v-btn--left[data-v-0b314bb5]{margin-left:0!important}.v-btn--floating.v-btn--left .v-icon[data-v-0b314bb5]{height:auto}.ds-calendar-event-popover-card .v-toolbar__extension[data-v-0b314bb5]{padding:0 16px!important;height:60px!important;-ms-flex-align:start;align-items:start}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title[data-v-0b314bb5]{width:100%;margin-left:56px;margin-right:0}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title .v-input__slot[data-v-0b314bb5]{background-color:hsla(0,0%,100%,.2)!important}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title .v-input__slot input[data-v-0b314bb5]{caret-color:rgba(0,0,0,.87)!important}.v-text-field--full-width[data-v-0b314bb5]{width:100%}.v-card__text[data-v-0b314bb5]{padding:16px 0}.v-card__text .v-list[data-v-0b314bb5]{padding-bottom:0}.v-card__text .v-list>div[data-v-0b314bb5]:first-child{margin-bottom:1em}.v-card__text .v-list .v-list__tile[data-v-0b314bb5]{height:auto!important}.ds-create-popover-save[data-v-0b314bb5]{background-color:transparent!important}.ds-color-option[data-v-0b314bb5]{width:100%;color:#fff;padding:4px}.v-input[data-v-0b314bb5]{margin-bottom:8px!important}.ds-calendar-event-placeholder[data-v-01c6c692]{position:absolute;right:0;left:0;top:0;padding:0;margin:0}.ds-calendar-event-title[data-v-0b1da002]{font-size:18px;padding-right:8px;padding-top:4px}.ds-color-option[data-v-0b1da002]{width:100%;color:#fff;padding:4px}.ds-button-tall[data-v-0b1da002]{height:48px}.ds-event.ds-has-cancel .ds-event-area[data-v-0b1da002]{margin-left:60px}.ds-event.ds-event-small.ds-has-cancel .ds-event-area[data-v-0b1da002]{margin-left:0}.ds-event.ds-event-small.ds-has-cancel .ds-event-header[data-v-0b1da002]{margin-left:60px;margin-bottom:58px}.ds-event.ds-event-small .ds-event-title[data-v-0b1da002]{position:absolute;right:8px;left:-60px;top:60px}.ds-event.ds-event-small .ds-event-body[data-v-0b1da002]{clear:both}.ds-event .ds-event-area[data-v-0b1da002]{position:relative}.ds-event .ds-event-actions[data-v-0b1da002]{float:right}.ds-event .ds-event-actions>[data-v-0b1da002]{display:inline-block}.ds-event .ds-event-header[data-v-0b1da002]{min-height:60px}.ds-event .ds-event-cancel[data-v-0b1da002]{position:absolute;left:-60px}.ds-event .v-input[data-v-0b1da002]{margin-bottom:8px}.ds-schedule .ds-schedule-type{max-width:436px;padding-right:8px}.ds-schedule.ds-schedule-small .ds-schedule-type{width:100%}.ds-span-menu[data-v-b104ba6e]{width:260px;padding:10px;background-color:#fff}.v-input__icon--append-outer[data-v-0490c2b9]{color:#000}.ds-time-row[data-v-9de2f668]{display:-ms-flexbox;display:flex}.ds-time-row .ds-time-cell[data-v-9de2f668]{padding-right:8px;-ms-flex:1 0 0px;flex:1 0 0px;margin-bottom:8px}.ds-time-row .ds-time-cell[data-v-9de2f668]:last-child{margin-right:-8px}.ds-schedule-times[data-v-746db5d7]{max-width:436px}.ds-schedule-times .ds-time-row[data-v-746db5d7]{display:-ms-flexbox;display:flex}.ds-schedule-times .ds-time-row .ds-time-cell[data-v-746db5d7]{padding-right:8px;-ms-flex:1 0 0px;flex:1 0 0px}.ds-schedule-times .ds-time-row .ds-time-cell.double[data-v-746db5d7]{padding-right:16px;-ms-flex:2 0 0px;flex:2 0 0px}.ds-month[data-v-45f856ac]{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;background-color:#fff}.ds-month .ds-week-header[data-v-45f856ac]{display:-ms-flexbox;display:flex;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-month .ds-week-header-day[data-v-45f856ac]{-ms-flex:1 0 20px;flex:1 0 20px;border-right:1px solid #e0e0e0;color:#757575;padding:4px;padding-bottom:0}.ds-month .ds-week-header-day.ds-week-header-today[data-v-45f856ac]{color:#4285f4;font-weight:500}.ds-week-header[data-v-dc94a82e]{-ms-flex:none;flex:none;display:-ms-flexbox;display:flex}.ds-week-header .ds-hour-list[data-v-dc94a82e]{-ms-flex:none;flex:none;width:44px;border-right:1px solid #e0e0e0}.ds-day[data-v-238290c6]{-ms-flex:1 1 auto;flex:1 1 auto;width:0;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;padding:4px}.ds-day .ds-week-date[data-v-238290c6]{font-size:40px;line-height:36px;color:#000;padding-left:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-day .ds-week-date[data-v-238290c6]:hover{text-decoration:underline}.ds-day .ds-all-events[data-v-238290c6]{margin-top:8px}.ds-day .ds-week-weekday[data-v-238290c6]{color:#000;padding-left:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-day.ds-day-today[data-v-238290c6]{background-color:rgba(0,0,0,.04)}.ds-day.ds-day-today .ds-week-date[data-v-238290c6],.ds-day.ds-day-today .ds-week-weekday[data-v-238290c6]{color:#4285f4}.ds-day.ds-day-past .ds-week-date[data-v-238290c6],.ds-day.ds-day-past .ds-week-weekday[data-v-238290c6]{color:#9e9e9e}", "", {"version":3,"sources":["/./node_modules/dayspan-vuetify/dist/lib/dayspan-vuetify.min.css"],"names":[],"mappings":"AAAA,gBAAgB,YAAY,aAAa,eAAe,CAAC,8CAA8C,cAAc,CAAC,oBAAoB,cAAc,CAAC,0CAA0C,WAAW,CAAC,uFAAuF,yBAAyB,iGAAiG,YAAY,CAAC,6CAA6C,kCAAkC,CAAC,qBAAqB,WAAW,+BAA+B,gBAAgB,iBAAiB,SAAS,cAAc,gBAAgB,CAAC,2BAA2B,UAAU,CAAC,mCAAmC,yBAAyB,iGAAiG,YAAY,YAAY,CAAC,uDAAuD,kCAAkC,CAAC,WAAW,WAAW,CAAC,qBAAqB,eAAe,CAAC,oBAAoB,uBAAuB,CAAC,eAAe,yBAAyB,gBAAgB,iBAAiB,qBAAqB,sBAAsB,0BAA0B,yBAAyB,wBAAwB,CAAC,iBAAiB,WAAW,CAAC,uCAAuC,WAAW,WAAW,CAAC,yBAAyB,WAAW,OAAO,QAAQ,+BAA+B,gCAAgC,YAAY,eAAe,CAAC,0DAA0D,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,iCAAiC,qBAAqB,cAAc,WAAW,YAAY,iBAAiB,iBAAiB,CAAC,uCAAuC,yBAAyB,CAAC,8CAA8C,mBAAmB,yBAAyB,WAAW,qBAAqB,kBAAkB,SAAS,CAAC,kCAAkC,aAAa,CAAC,0BAA0B,oBAAoB,aAAa,WAAW,MAAM,CAAC,yCAAyC,0BAA0B,sBAAsB,WAAW,CAAC,uGAAuG,oBAAoB,aAAa,eAAe,CAAC,8DAA8D,iBAAiB,aAAa,kBAAkB,0BAA0B,qBAAqB,CAAC,kEAAkE,kBAAkB,kBAAkB,cAAc,oBAAoB,aAAa,qBAAqB,sBAAsB,CAAC,4DAA4D,WAAW,kBAAkB,cAAc,UAAU,oBAAoB,aAAa,qBAAqB,sBAAsB,CAAC,oEAAoE,iBAAiB,CAAC,kDAAkD,oBAAoB,aAAa,WAAW,OAAO,WAAW,WAAW,CAAC,uDAAuD,cAAc,UAAU,WAAW,+BAA+B,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,gEAAgE,kBAAkB,mBAAmB,WAAW,CAAC,8EAA8E,cAAc,kBAAkB,SAAS,eAAe,aAAa,CAAC,oCAAoC,mBAAmB,eAAe,CAAC,yBAAyB,WAAW,OAAO,QAAQ,+BAA+B,+BAA+B,CAAC,sCAAsC,gCAAgC,CAAC,0BAA0B,YAAY,+BAA+B,CAAC,gDAAgD,oBAAoB,YAAY,CAAC,oDAAoD,WAAW,MAAM,CAAC,yDAAyD,WAAW,OAAO,iBAAiB,CAAC,0DAA0D,WAAW,MAAM,CAAC,4FAA4F,oBAAoB,aAAa,iBAAiB,CAAC,yCAAyC,uBAAuB,mBAAmB,mBAAmB,cAAc,CAAC,4CAA4C,WAAW,MAAM,CAAC,6CAA6C,iBAAiB,YAAY,CAAC,kCAAkC,WAAW,iBAAiB,kBAAkB,CAAC,6BAA6B,WAAW,CAAC,8BAA8B,gBAAgB,SAAS,CAAC,+BAA+B,SAAS,CAAC,kDAAkD,eAAe,CAAC,iDAAiD,kBAAkB,CAAC,gDAAgD,cAAc,eAAe,CAAC,8IAA8I,aAAa,CAAC,yCAAyC,UAAU,CAAC,sCAAsC,WAAW,mBAAmB,gBAAgB,sBAAsB,CAAC,oCAAoC,4BAA4B,CAAC,kCAAkC,mBAAmB,uBAAuB,CAAC,wDAAwD,cAAc,CAAC,yDAAyD,eAAe,eAAe,eAAe,CAAC,+DAA+D,yBAAyB,CAAC,4DAA4D,cAAc,CAAC,kEAAkE,yBAAyB,CAAC,oCAAoC,YAAY,cAAc,CAAC,8BAA8B,WAAW,YAAY,kBAAkB,mBAAmB,CAAC,gCAAgC,WAAW,WAAW,CAAC,0CAA0C,gCAAgC,CAAC,+BAA+B,kBAAkB,MAAM,QAAQ,SAAS,OAAO,gBAAgB,aAAa,qBAAqB,CAAC,6CAA6C,eAAe,CAAC,iDAAiD,gCAAgC,CAAC,6CAA6C,+BAA+B,CAAC,kBAAkB,0BAA0B,0BAA0B,CAAC,WAAW,WAAW,WAAW,CAAC,uBAAuB,oBAAoB,iBAAiB,CAAC,4CAA4C,WAAW,WAAW,CAAC,yCAAyC,WAAW,YAAY,mBAAmB,CAAC,oCAAoC,WAAW,WAAW,gBAAgB,uBAAuB,mBAAmB,kBAAkB,eAAe,eAAe,kBAAkB,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,SAAS,kBAAkB,kBAAkB,CAAC,yCAAyC,UAAU,CAAC,oCAAoC,WAAW,WAAW,gBAAgB,uBAAuB,mBAAmB,kBAAkB,eAAe,eAAe,kBAAkB,QAAQ,yBAAyB,sBAAsB,qBAAqB,iBAAiB,kBAAkB,mBAAmB,CAAC,uDAAuD,mBAAmB,eAAe,CAAC,4DAA4D,WAAW,YAAY,kBAAkB,CAAC,8EAA8E,uBAAuB,CAAC,sFAAsF,WAAW,CAAC,+DAA+D,cAAc,CAAC,qFAAqF,oBAAoB,WAAW,CAAC,uEAAuE,wBAAwB,CAAC,yFAAyF,gBAAgB,CAAC,yCAAyC,WAAW,WAAW,CAAC,4DAA4D,WAAW,CAAC,8CAA8C,uBAAuB,CAAC,sDAAsD,WAAW,CAAC,uEAAuE,yBAAyB,sBAAsB,qBAAqB,iBAAiB,CAAC,yFAAyF,WAAW,iBAAiB,cAAc,CAAC,wGAAwG,6CAA6C,CAAC,8GAA8G,qCAAqC,CAAC,2CAA2C,UAAU,CAAC,+BAA+B,cAAc,CAAC,uCAAuC,gBAAgB,CAAC,uDAAuD,iBAAiB,CAAC,qDAAqD,qBAAqB,CAAC,yCAAyC,sCAAsC,CAAC,kCAAkC,WAAW,WAAW,WAAW,CAAC,0BAA0B,2BAA2B,CAAC,gDAAgD,kBAAkB,QAAQ,OAAO,MAAM,UAAU,QAAQ,CAAC,0CAA0C,eAAe,kBAAkB,eAAe,CAAC,kCAAkC,WAAW,WAAW,WAAW,CAAC,iCAAiC,WAAW,CAAC,wDAAwD,gBAAgB,CAAC,uEAAuE,aAAa,CAAC,yEAAyE,iBAAiB,kBAAkB,CAAC,0DAA0D,kBAAkB,UAAU,WAAW,QAAQ,CAAC,yDAAyD,UAAU,CAAC,0CAA0C,iBAAiB,CAAC,6CAA6C,WAAW,CAAC,8CAA8C,oBAAoB,CAAC,4CAA4C,eAAe,CAAC,4CAA4C,kBAAkB,UAAU,CAAC,oCAAoC,iBAAiB,CAAC,+BAA+B,gBAAgB,iBAAiB,CAAC,iDAAiD,UAAU,CAAC,+BAA+B,YAAY,aAAa,qBAAqB,CAAC,8CAA8C,UAAU,CAAC,8BAA8B,oBAAoB,YAAY,CAAC,4CAA4C,kBAAkB,iBAAiB,aAAa,iBAAiB,CAAC,uDAAuD,iBAAiB,CAAC,oCAAoC,eAAe,CAAC,iDAAiD,oBAAoB,YAAY,CAAC,+DAA+D,kBAAkB,iBAAiB,YAAY,CAAC,sEAAsE,mBAAmB,iBAAiB,YAAY,CAAC,2BAA2B,WAAW,YAAY,oBAAoB,aAAa,0BAA0B,sBAAsB,qBAAqB,CAAC,2CAA2C,oBAAoB,aAAa,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,+CAA+C,kBAAkB,cAAc,+BAA+B,cAAc,YAAY,gBAAgB,CAAC,oEAAoE,cAAc,eAAe,CAAC,iCAAiC,cAAc,UAAU,oBAAoB,YAAY,CAAC,+CAA+C,cAAc,UAAU,WAAW,8BAA8B,CAAC,yBAAyB,kBAAkB,cAAc,QAAQ,+BAA+B,gCAAgC,WAAW,CAAC,uCAAuC,eAAe,iBAAiB,WAAW,iBAAiB,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,6CAA6C,yBAAyB,CAAC,wCAAwC,cAAc,CAAC,0CAA0C,WAAW,iBAAiB,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,sCAAsC,gCAAgC,CAAC,2GAA2G,aAAa,CAAC,yGAAyG,aAAa,CAAC","file":"dayspan-vuetify.min.css","sourcesContent":[".ds-button-tall{height:48px;margin-top:0;margin-bottom:0}.ds-textfield.v-input-group--multi-line label{margin-top:6px}.ds-textfield>label{margin:6px 8px}.ds-textfield .v-input-group__input input{height:40px}.ds-textfield .v-input-group__input input,.ds-textfield .v-input-group__input textarea{background-color:#f5f5f5;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);padding:10px}.ds-textfield .v-input-group__details:before{background-color:#f5f5f5!important}.ds-textfield.inline{width:auto;display:inline-block!important;margin-left:6px;margin-right:6px;top:14px;padding-top:0;margin-top:-14px}.ds-textfield.inline.small{width:60px}.ds-dropdown .v-input-group__input{background-color:#f5f5f5;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);height:40px;padding:10px}.ds-button,.ds-dropdown .v-input-group__details:before{background-color:#f5f5f5!important}.ds-button{height:40px}.ds-button.push-down{margin-top:18px}.ds-light-forecolor{color:#757575!important}.ds-fullscreen{position:fixed!important;top:0!important;left:0!important;width:100%!important;height:100%!important;max-height:auto!important;max-width:100%!important;min-width:100%!important}.ds-fullscreen>*{height:100%}.ds-gesture-container[data-v-33b6bfdc]{width:100%;height:100%}.ds-day[data-v-4c181404]{-ms-flex:1;flex:1;width:0;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;padding:4px;overflow:hidden}.ds-day .ds-dom[data-v-4c181404],.ds-day[data-v-4c181404]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-day .ds-dom[data-v-4c181404]{text-decoration:none;color:#212121;width:24px;height:24px;line-height:24px;text-align:center}.ds-day .ds-dom[data-v-4c181404]:hover{text-decoration:underline}.ds-day .ds-dom.ds-today-dom[data-v-4c181404]{border-radius:12px;background-color:#4285f4;color:#fff;display:inline-block;position:relative;z-index:1}.ds-out-calendar[data-v-4c181404]{color:#757575}.ds-week[data-v-eb16c334]{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1}.ds-week-view-container[data-v-30ccf664]{-ms-flex-direction:column;flex-direction:column;height:100%}.ds-week-view-container .ds-week-view-bottom[data-v-30ccf664],.ds-week-view-container[data-v-30ccf664]{display:-ms-flexbox;display:flex;overflow:hidden}.ds-week-view-container .ds-week-view-bottom[data-v-30ccf664]{-ms-flex:1 1 60%;flex:1 1 60%;position:relative;-ms-flex-direction:column;flex-direction:column}.ds-week-view-container .ds-week-view-scrollable[data-v-30ccf664]{overflow-y:scroll;-ms-flex:1 1 auto;flex:1 1 auto;display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.ds-week-view-container .ds-week-view-pane[data-v-30ccf664]{width:100%;overflow-y:hidden;-ms-flex:none;flex:none;display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.ds-week-view-container .ds-week-view-pane .ds-day[data-v-30ccf664]{position:relative}.ds-week-view-container .ds-week[data-v-30ccf664]{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;width:100%;height:100%}.ds-week-view-container .ds-hour-list[data-v-30ccf664]{-ms-flex:none;flex:none;width:44px;border-right:1px solid #e0e0e0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-week-view-container .ds-hour-list .ds-hour[data-v-30ccf664]{text-align:center;border-bottom:none;height:40px}.ds-week-view-container .ds-hour-list .ds-hour .ds-hour-text[data-v-30ccf664]{display:block;position:relative;top:-6px;font-size:10px;color:#212121}.v-menu__activator[data-v-74cb2e5c]{-ms-flex-align:end;align-items:end}.ds-day[data-v-74cb2e5c]{-ms-flex:1;flex:1;width:0;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0}.ds-day.ds-day-today[data-v-74cb2e5c]{background-color:rgba(0,0,0,.04)}.ds-hour[data-v-74cb2e5c]{height:40px;border-bottom:1px solid #e0e0e0}.ds-day-picker .ds-week-header[data-v-36e040b2]{display:-ms-flexbox;display:flex}.ds-day-picker .ds-week-header>div[data-v-36e040b2]{-ms-flex:1;flex:1}.ds-day-picker .ds-week-header .tooltip[data-v-36e040b2]{-ms-flex:1;flex:1;text-align:center}.ds-day-picker .ds-week-header .subtitle[data-v-36e040b2]{-ms-flex:5;flex:5}.ds-day-picker .ds-week-subheader[data-v-36e040b2],.ds-day-picker .ds-week[data-v-36e040b2]{display:-ms-flexbox;display:flex;text-align:center}.ds-day-picker .ds-week[data-v-36e040b2]{-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.ds-day-picker .ds-weekday[data-v-36e040b2]{-ms-flex:1;flex:1}.ds-day-picker .ds-day-pick[data-v-36e040b2]{-ms-flex:1 0 14%;flex:1 0 14%}.ds-agenda-table[data-v-8262ea58]{width:100%;border-spacing:0;table-layout:fixed}.column-day[data-v-8262ea58]{width:100px}.column-when[data-v-8262ea58]{min-width:200px;width:30%}.column-event[data-v-8262ea58]{width:70%}.ds-agenda-day tr:first-child td[data-v-64bbe350]{padding-top:6px}.ds-agenda-day tr:last-child td[data-v-64bbe350]{padding-bottom:6px}.ds-day-today .ds-agenda-lines[data-v-64bbe350]{color:#4285f4;font-weight:700}.ds-day-past .ds-agenda-details[data-v-64bbe350],.ds-day-past .ds-agenda-lines[data-v-64bbe350],.ds-day-past .ds-agenda-when[data-v-64bbe350]{color:#9e9e9e}.ds-calendar-event-menu[data-v-52125556]{width:100%}.ds-agenda-activator[data-v-52125556]{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ds-first-event td[data-v-52125556]{border-top:1px solid #e0e0e0}.ds-agenda-lines[data-v-52125556]{vertical-align:top;padding:4px 4px 4px 1em}.ds-agenda-lines .ds-agenda-line-first[data-v-52125556]{font-size:12px}.ds-agenda-lines .ds-agenda-line-second[data-v-52125556]{font-size:14px;cursor:pointer;margin-top:-4px}.ds-agenda-lines .ds-agenda-line-second[data-v-52125556]:hover{text-decoration:underline}.ds-agenda-event .ds-agenda-details strong[data-v-52125556]{cursor:pointer}.ds-agenda-event .ds-agenda-details strong[data-v-52125556]:hover{text-decoration:underline}.ds-agenda-details[data-v-52125556]{padding:4px;cursor:pointer}.ds-calendar[data-v-5325b506]{width:100%;height:100%;position:relative;padding:0!important}.ds-month-view[data-v-5325b506]{width:100%;height:100%}.ds-month-view .ds-today[data-v-5325b506]{background-color:rgba(0,0,0,.04)}.ds-week-view[data-v-5325b506]{position:absolute;top:0;right:0;bottom:0;left:0;overflow-y:auto;outline:none;background-color:#fff}.ds-year-view .ds-first-day[data-v-5325b506]{font-weight:700}.ds-year-view .ds-first-day-day[data-v-5325b506]{background-color:rgba(0,0,0,.08)}.ds-app-calendar-toolbar .v-toolbar__content{border-bottom:1px solid #e0e0e0}.ds-skinny-button{margin-left:2px!important;margin-right:2px!important}.ds-expand{width:100%;height:100%}.ds-calendar-container{padding:0!important;position:relative}.v-btn--floating.ds-add-event-today .v-icon{width:24px;height:24px}.ds-calendar-event-menu[data-v-46108b38]{width:100%;height:18px;pointer-events:none}.ds-calendar-event[data-v-46108b38]{margin:1px;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:.5em;font-size:12px;cursor:pointer;position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;margin:0;border-radius:2px;pointer-events:all}.ds-calendar-event-menu[data-v-7a377cd1]{width:100%}.ds-calendar-event[data-v-7a377cd1]{margin:1px;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:.5em;font-size:12px;cursor:pointer;position:absolute;right:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:2px;pointer-events:none}.ds-calendar-event .v-menu__activator[data-v-7a377cd1]{-ms-flex-align:end;align-items:end}.ds-calendar-event .ds-calendar-event-span[data-v-7a377cd1]{width:100%;height:100%;pointer-events:all}.ds-calendar-event-popover-card .v-btn--floating.v-btn--left[data-v-7461b951]{margin-left:0!important}.ds-calendar-event-popover-card .v-btn--floating.v-btn--left .v-icon[data-v-7461b951]{height:auto}.ds-calendar-event-popover-card .v-card__text[data-v-7461b951]{padding:16px 0}.ds-calendar-event-popover-card .v-card__text .v-list .v-list__tile[data-v-7461b951]{padding:0!important;height:auto}.ds-calendar-event-popover-card .v-toolbar__extension[data-v-7461b951]{padding:0 16px!important}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title[data-v-7461b951]{margin-left:56px}.ds-calendar-event-menu[data-v-26705f1f]{width:100%;height:18px}.ds-calendar-event-menu .ds-calendar-event[data-v-26705f1f]{height:100%}.v-btn--floating.v-btn--left[data-v-0b314bb5]{margin-left:0!important}.v-btn--floating.v-btn--left .v-icon[data-v-0b314bb5]{height:auto}.ds-calendar-event-popover-card .v-toolbar__extension[data-v-0b314bb5]{padding:0 16px!important;height:60px!important;-ms-flex-align:start;align-items:start}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title[data-v-0b314bb5]{width:100%;margin-left:56px;margin-right:0}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title .v-input__slot[data-v-0b314bb5]{background-color:hsla(0,0%,100%,.2)!important}.ds-calendar-event-popover-card .v-toolbar__extension .v-toolbar__title .v-input__slot input[data-v-0b314bb5]{caret-color:rgba(0,0,0,.87)!important}.v-text-field--full-width[data-v-0b314bb5]{width:100%}.v-card__text[data-v-0b314bb5]{padding:16px 0}.v-card__text .v-list[data-v-0b314bb5]{padding-bottom:0}.v-card__text .v-list>div[data-v-0b314bb5]:first-child{margin-bottom:1em}.v-card__text .v-list .v-list__tile[data-v-0b314bb5]{height:auto!important}.ds-create-popover-save[data-v-0b314bb5]{background-color:transparent!important}.ds-color-option[data-v-0b314bb5]{width:100%;color:#fff;padding:4px}.v-input[data-v-0b314bb5]{margin-bottom:8px!important}.ds-calendar-event-placeholder[data-v-01c6c692]{position:absolute;right:0;left:0;top:0;padding:0;margin:0}.ds-calendar-event-title[data-v-0b1da002]{font-size:18px;padding-right:8px;padding-top:4px}.ds-color-option[data-v-0b1da002]{width:100%;color:#fff;padding:4px}.ds-button-tall[data-v-0b1da002]{height:48px}.ds-event.ds-has-cancel .ds-event-area[data-v-0b1da002]{margin-left:60px}.ds-event.ds-event-small.ds-has-cancel .ds-event-area[data-v-0b1da002]{margin-left:0}.ds-event.ds-event-small.ds-has-cancel .ds-event-header[data-v-0b1da002]{margin-left:60px;margin-bottom:58px}.ds-event.ds-event-small .ds-event-title[data-v-0b1da002]{position:absolute;right:8px;left:-60px;top:60px}.ds-event.ds-event-small .ds-event-body[data-v-0b1da002]{clear:both}.ds-event .ds-event-area[data-v-0b1da002]{position:relative}.ds-event .ds-event-actions[data-v-0b1da002]{float:right}.ds-event .ds-event-actions>[data-v-0b1da002]{display:inline-block}.ds-event .ds-event-header[data-v-0b1da002]{min-height:60px}.ds-event .ds-event-cancel[data-v-0b1da002]{position:absolute;left:-60px}.ds-event .v-input[data-v-0b1da002]{margin-bottom:8px}.ds-schedule .ds-schedule-type{max-width:436px;padding-right:8px}.ds-schedule.ds-schedule-small .ds-schedule-type{width:100%}.ds-span-menu[data-v-b104ba6e]{width:260px;padding:10px;background-color:#fff}.v-input__icon--append-outer[data-v-0490c2b9]{color:#000}.ds-time-row[data-v-9de2f668]{display:-ms-flexbox;display:flex}.ds-time-row .ds-time-cell[data-v-9de2f668]{padding-right:8px;-ms-flex:1 0 0px;flex:1 0 0px;margin-bottom:8px}.ds-time-row .ds-time-cell[data-v-9de2f668]:last-child{margin-right:-8px}.ds-schedule-times[data-v-746db5d7]{max-width:436px}.ds-schedule-times .ds-time-row[data-v-746db5d7]{display:-ms-flexbox;display:flex}.ds-schedule-times .ds-time-row .ds-time-cell[data-v-746db5d7]{padding-right:8px;-ms-flex:1 0 0px;flex:1 0 0px}.ds-schedule-times .ds-time-row .ds-time-cell.double[data-v-746db5d7]{padding-right:16px;-ms-flex:2 0 0px;flex:2 0 0px}.ds-month[data-v-45f856ac]{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;background-color:#fff}.ds-month .ds-week-header[data-v-45f856ac]{display:-ms-flexbox;display:flex;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-month .ds-week-header-day[data-v-45f856ac]{-ms-flex:1 0 20px;flex:1 0 20px;border-right:1px solid #e0e0e0;color:#757575;padding:4px;padding-bottom:0}.ds-month .ds-week-header-day.ds-week-header-today[data-v-45f856ac]{color:#4285f4;font-weight:500}.ds-week-header[data-v-dc94a82e]{-ms-flex:none;flex:none;display:-ms-flexbox;display:flex}.ds-week-header .ds-hour-list[data-v-dc94a82e]{-ms-flex:none;flex:none;width:44px;border-right:1px solid #e0e0e0}.ds-day[data-v-238290c6]{-ms-flex:1 1 auto;flex:1 1 auto;width:0;border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;padding:4px}.ds-day .ds-week-date[data-v-238290c6]{font-size:40px;line-height:36px;color:#000;padding-left:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-day .ds-week-date[data-v-238290c6]:hover{text-decoration:underline}.ds-day .ds-all-events[data-v-238290c6]{margin-top:8px}.ds-day .ds-week-weekday[data-v-238290c6]{color:#000;padding-left:8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ds-day.ds-day-today[data-v-238290c6]{background-color:rgba(0,0,0,.04)}.ds-day.ds-day-today .ds-week-date[data-v-238290c6],.ds-day.ds-day-today .ds-week-weekday[data-v-238290c6]{color:#4285f4}.ds-day.ds-day-past .ds-week-date[data-v-238290c6],.ds-day.ds-day-past .ds-week-weekday[data-v-238290c6]{color:#9e9e9e}"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1028 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0049b780","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/clientModal/ClientModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.page-title {\n  color: #1d436a;\n  padding-left: 5px;\n}\n.page-title h1 {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 2em;\n  margin-bottom: 0px;\n}\n.page-title h4 {\n  margin-top: 5px;\n  margin-left: 2px;\n}\n.subtitle {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n}\n.modal-body {\n  padding: 15px 15px 0px 15px !important;\n}\n.bg-selected {\n  background: #1d436a;\n  opacity: 0.3;\n}\n.bg-unselected {\n  background: #fff;\n}\n.selector-selected {\n  color: #1d436a;\n  font-weight: bold;\n  margin: 3px!important;\n  cursor: pointer;\n}\n.selector-unselected {\n  color: #9e9b9b;\n  margin: 3px!important;\n  cursor: pointer;\n}\n.selector-icon {\n  margin-right: 0.5vw;\n}\n.modal-dialog {\n  margin: auto auto;\n}\n.modal-center {\n  display:table;\n  height: 100%;\n  width: 100%;\n}\n.modal.in .modal-dialog {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-content {\n  width:inherit;\n  height:inherit;\n  margin: 0 auto;\n}\n.select-client-table tbody > tr label {\n  line-height: 100%;\n}\n", "", {"version":3,"sources":["/./client/components/modals/clientModal/ClientModal.vue?0bf05d62"],"names":[],"mappings":";AA6IA;EACA,eAAA;EACA,kBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,mBAAA;CACA;AAEA;EACA,gBAAA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;CACA;AAEA;EACA,uCAAA;CACA;AAEA;EACA,oBAAA;EACA,aAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;CACA;AAEA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,cAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,oBAAA;EACA,uBAAA;CACA;AAEA;EACA,cAAA;EACA,eAAA;EACA,eAAA;CACA;AAEA;EACA,kBAAA;CACA","file":"ClientModal.vue","sourcesContent":["<template src='./clientModal.pug' lang='pug'></template>\n\n<script>\nimport Modal from '../modal/Modal'\nimport customSorter from '../../../utils/customSorter.js'\nimport PATHS from '../../../router/routesMap.js'\n\nexport default {\n  name: 'ClientModal',\n\n  components: {\n    Modal\n  },\n\n  props: {\n    autoOpen: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      clients: this.$store.getters.clients,\n      singleClient: false,\n      columns: ['nomeFantasia'],\n      options: {\n        columnsClasses: { 'nomeFantasia': 'col-md-11' },\n        headings: {\n          nomeFantasia: this.$t('modalCliente.labels.nome')\n        },\n        filterable: false,\n        perPageValues: [],\n        texts: {\n          count: '',\n          noResults: this.$t('dataTable.labels.semResultados')\n        },\n        sortIcon: {\n          is: ''\n        },\n        sortable: ['nomeFantasia'],\n        pagination: { chunk: 5 },\n        customSorting: {\n          nomeFantasia: function (ascending) {\n            return function (a, b) {\n              return customSorter.stringSorter(ascending, a, b, 'nomeFantasia')\n            }\n          }\n        }\n      }\n    }\n  },\n\n  computed: {\n    isLoggedIn () {\n      return this.$store.getters.isLoggedIn\n    },\n    client () {\n      return this.$store.getters.client\n    },\n    openClientModal () {\n      return this.$store.getters.openClientModal\n    },\n    updateLocation () {\n      return this.$store.getters.updateLocation\n    },\n    lastUrl () {\n      return this.$store.getters.lastUrl\n    }\n  },\n\n  watch: {\n    openClientModal () {\n      if (this.isLoggedIn) {\n        this.loadClients()\n      }\n    }\n  },\n\n  methods: {\n    loadClients () {\n      if (this.clients.length > 1) {\n        this.singleClient = false\n        this.showModal()\n      } else if (this.clients.length === 1) {\n        this.singleClient = true\n        this.selectClient(this.clients[0].id, this.clients[0].nomeFantasia)\n      }\n    },\n\n    selectClient (id, name) {\n      this.$store.dispatch('cleanFunctionatieModule').then(() => {\n        this.$store.dispatch('setClient', { client: id, clientName: name, singleClient: this.singleClient }).then((response) => {\n          $('#client-modal').modal('hide')\n          this.$store.dispatch('getFuncionalities').then((response) => {\n            this.$store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc).then((response) => {\n              $('#client-modal').modal('hide')\n              this.$store.dispatch('cleanGadgetsFilters')\n              localStorage.setItem('event-client-selected', Math.random())\n              if (this.updateLocation) {\n                this.$router.push(this.lastUrl)\n                this.$store.dispatch('setUpdateLocation', false)\n                this.$store.dispatch('setLastUrl', null)\n              } else {\n                this.$router.push(PATHS.HOME)\n              }\n            })\n          })\n        })\n      })\n    },\n\n    closeModal () {\n      if (this.client) $('#client-modal').modal('hide')\n    },\n\n    showModal () {\n      if (!this.client) {\n        $('#client-modal').modal({\n          backdrop: 'static',\n          keyboard: false\n        })\n      } else {\n        $('#client-modal').modal()\n      }\n    },\n\n    rowClick (props) {\n      this.selectClient(props.row.id, props.row.nomeFantasia)\n    }\n  },\n\n  mounted () {\n    if (this.isLoggedIn && !this.client && this.autoOpen) {\n      this.loadClients()\n    }\n  }\n}\n</script>\n\n<style lang='css'>\n.page-title {\n  color: #1d436a;\n  padding-left: 5px;\n}\n\n.page-title h1 {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 2em;\n  margin-bottom: 0px;\n}\n\n.page-title h4 {\n  margin-top: 5px;\n  margin-left: 2px;\n}\n\n.subtitle {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n}\n\n.modal-body {\n  padding: 15px 15px 0px 15px !important;\n}\n\n.bg-selected {\n  background: #1d436a;\n  opacity: 0.3;\n}\n\n.bg-unselected {\n  background: #fff;\n}\n\n.selector-selected {\n  color: #1d436a;\n  font-weight: bold;\n  margin: 3px!important;\n  cursor: pointer;\n}\n\n.selector-unselected {\n  color: #9e9b9b;\n  margin: 3px!important;\n  cursor: pointer;\n}\n\n.selector-icon {\n  margin-right: 0.5vw;\n}\n\n.modal-dialog {\n  margin: auto auto;\n}\n\n.modal-center {\n  display:table;\n  height: 100%;\n  width: 100%;\n}\n\n.modal.in .modal-dialog {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.modal-content {\n  width:inherit;\n  height:inherit;\n  margin: 0 auto;\n}\n\n.select-client-table tbody > tr label {\n  line-height: 100%;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1029 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0643cdba","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/accessProfile/New.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.fa[data-v-0643cdba] {\n  font-size: 20px;\n}\n.check-group[data-v-0643cdba] {\n  margin-left: 0.7vw !important;\n}\n.checkbox[data-v-0643cdba] {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-left: 10px;\n}\n.group-checkbox[data-v-0643cdba] {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-left: 15px;\n}\n.boxed-container[data-v-0643cdba] {\n\tborder: 1px solid #ddd;\n\tbackground: #fff;\n\tcolor:#444;\n  padding: 10px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.func-group-title[data-v-0643cdba] {\n  color:#17375f;\n  font-size: 14px !important;\n  text-transform: none !important;\n}\n.func-group-title-label[data-v-0643cdba] {\n  margin-left: 0.5vw;\n}\n.func-group-labels[data-v-0643cdba] {\n  color:#515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n.bottom-bordered[data-v-0643cdba] {\n  border-bottom: 1px solid #17375f;\n  margin-top: 0.4vh;\n  margin-bottom: 0.7vh;\n}\n.func-padded[data-v-0643cdba] {\n  padding-left: 0.7vw;\n}\n.info-icon[data-v-0643cdba] {\n  margin-left: 15px;\n  font-size: 15px;\n  color: gray;\n}\n.custom-data-table[data-v-0643cdba] {\n  display: block;\n  height: calc(50vh - 20px);\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.checkbox-table-input[data-v-0643cdba] {\n  width: 20px !important;\n}\n.checkbox-table-input-header[data-v-0643cdba] {\n  margin: 0px 3px -5px 5px !important;\n}\n.checkbox-table-input-row[data-v-0643cdba] {\n  margin-left: 5px !important;\n  margin-right: 3px !important;\n}\n#confirmation .bg-gray[data-v-0643cdba] {\n  background-color: #dbdbdb;\n}\n", "", {"version":3,"sources":["/./client/components/views/administration/accessProfile/New.vue?a000c6a8"],"names":[],"mappings":";AAsrBA;EACA,gBAAA;CACA;AAEA;EACA,8BAAA;CACA;AAEA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;CACA;AAEA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;CACA;AAEA;CACA,uBAAA;CACA,iBAAA;CACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;CACA;AAEA;EACA,cAAA;EACA,2BAAA;EACA,gCAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,cAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;CACA;AAEA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;CACA;AAEA;EACA,uBAAA;CACA;AAEA;EACA,oCAAA;CACA;AAEA;EACA,4BAAA;EACA,6BAAA;CACA;AAEA;EACA,0BAAA;CACA","file":"New.vue","sourcesContent":["<template src='./new.pug' lang='pug'></template>\n\n<script>\nimport { Event } from 'vue-tables-2'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport StepProgress from '../../../step/StepProgress'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport customSorter from '../../../../utils/customSorter.js'\nimport { filterByBank, filterByAgency, filterByAccount } from '../../../../utils/customFilters.js'\nimport looseDeepEqual from '../../../../utils/looseDeepEqual'\nimport PerfilAcessoEnum from '../../../../enum/perfilAcessoEnum'\nimport PATHS from '../../../../router/routesMap.js'\n\nexport default {\n  name: 'AccessProfileNew',\n\n  components: {\n    StepProgress,\n    PageTitle,\n    FilterPortlet,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      steps: [\n        this.$t('administracao.perfilAcesso.etapas.informacoesPerfil'),\n        this.$t('administracao.perfilAcesso.etapas.estabelecimentos'),\n        this.$t('administracao.perfilAcesso.etapas.contasBancarias'),\n        this.$t('administracao.perfilAcesso.etapas.confirmacao')\n      ],\n      currentStep: 0,\n      profile: {\n        name: '',\n        visibility: '',\n        functionalitiesSelected: [],\n        establishmentsSelected: [],\n        bankAccountsSelected: []\n      },\n      functionalitiesGroups: [],\n      totalFunctionalities: null,\n      allFunctionalitiesSelected: false,\n      establishments: {\n        establishments: [],\n        allEstablishmentsSelected: false,\n        columns: ['check', 'nome', 'nomeFantasia', 'cnpj'],\n        options: {\n          headings: {\n            nome: this.$t('estabelecimentos.labels.nome'),\n            nomeFantasia: this.$t('estabelecimentos.labels.nomeFantasia'),\n            cnpj: this.$t('estabelecimentos.labels.cnpj')\n          },\n          columnsClasses: {\n            nome: 'col-md-4',\n            nomeFantasia: 'col-md-4',\n            cnpj: 'col-md-4'\n          },\n          filterable: ['nome', 'nomeFantasia', 'cnpj'],\n          filterByColumn: true,\n          perPageValues: [],\n          sortable: ['nome', 'nomeFantasia', 'cnpj'],\n          sortIcon: { is: '' },\n          pagination: { chunk: 5 },\n          perPage: Number.MAX_SAFE_INTEGER,\n          texts: {\n            count: '',\n            noResults: this.$t('dataTable.labels.semResultados'),\n            filterBy: '',\n            filterPlaceholder: this.$t('dataTable.labels.filtrar')\n          }\n        }\n      },\n      bankAccounts: {\n        accounts: [],\n        allBankAccountsSelected: false,\n        columns: ['check', 'nome', 'banco', 'agencia', 'conta'],\n        options: {\n          headings: {\n            nome: this.$t('contaBancaria.labels.nome'),\n            banco: this.$t('contaBancaria.labels.banco'),\n            agencia: this.$t('contaBancaria.labels.agencia'),\n            conta: this.$t('contaBancaria.labels.numeroConta')\n          },\n          columnsClasses: {\n            nome: 'col-md-3',\n            banco: 'col-md-4',\n            agencia: 'col-md-2',\n            conta: 'col-md-3'\n          },\n          filterable: ['nome'],\n          customFilters: [{\n            name: 'banco',\n            callback: filterByBank\n          }, {\n            name: 'agencia',\n            callback: filterByAgency\n          }, {\n            name: 'conta',\n            callback: filterByAccount\n          }],\n          filterByColumn: true,\n          perPageValues: [],\n          sortable: ['nome', 'banco', 'agencia', 'conta'],\n          sortIcon: { is: '' },\n          customSorting: {\n            nome: function (ascending) {\n              return function (a, b) {\n                return customSorter.stringSorter(ascending, a, b, 'nome')\n              }\n            },\n            banco: (ascending) => {\n              return (a, b) => {\n                let lastA = a.banco.codigo\n                let lastB = b.banco.codigo\n                if (ascending) {\n                  return lastA <= lastB ? 1 : -1\n                }\n                return lastA >= lastB ? 1 : -1\n              }\n            },\n            agencia: (ascending) => {\n              return (a, b) => {\n                let lastA = a.agencia\n                lastA.agencia = a.numAgencia + (a.digAgencia ? '-' + a.digAgencia : '')\n\n                let lastB = b.agencia\n                lastB.agencia = b.numAgencia + (b.digAgencia ? '-' + b.digAgencia : '')\n\n                return customSorter.stringSorter(ascending, lastA, lastB, 'agencia')\n              }\n            },\n            conta: function (ascending) {\n              return function (a, b) {\n                return customSorter.stringSorter(ascending, a, b, 'conta')\n              }\n            }\n          },\n          pagination: { chunk: 5 },\n          perPage: Number.MAX_SAFE_INTEGER,\n          templates: {\n            nome: (h, row) => row.nome + (row.ativo ? '' : ' (' + this.$t('contaBancaria.labels.inativa') + ')'),\n            banco: (h, row) => row.banco.codigo + '-' + row.banco.nomeFantasia,\n            agencia: (h, row) => row.numAgencia + (row.digAgencia ? '-' + row.digAgencia : ''),\n            conta: (h, row) => row.conta + (row.digConta ? '-' + row.digConta : '')\n          },\n          texts: {\n            count: '',\n            noResults: this.$t('dataTable.labels.semResultados'),\n            filterBy: '',\n            filterPlaceholder: this.$t('dataTable.labels.filtrar')\n          }\n        }\n      },\n      requestSaveProfileSent: false\n    }\n  },\n\n  computed: {\n    profileToEditId () {\n      return this.$store.getters.profileToEditId\n    },\n\n    pageTitleSubTitle () {\n      return this.profileToEditId ? this.$t('administracao.perfilAcesso.titulos.edicaoSubtitulo')\n        : this.$t('administracao.perfilAcesso.titulos.cadastroSubtitulo')\n    },\n\n    filterPortletTitle () {\n      return this.profileToEditId ? this.$t('administracao.perfilAcesso.titulos.editarPerfil')\n        : this.$t('administracao.perfilAcesso.titulos.novoPerfil')\n    }\n  },\n\n  watch: {\n    'profile.name': {\n      handler () {\n        const objectToCompare = {\n          name: this.profile.name,\n          visibility: this.profile.visibility,\n          functionalities: this.profile.functionalitiesSelected.map(fun => fun.id).sort((a, b) => a - b),\n          establishments: this.profile.establishmentsSelected.map(estab => estab.id).sort((a, b) => a - b),\n          bankAccounts: this.profile.bankAccountsSelected.map(account => account.id).sort((a, b) => a - b)\n        }\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, objectToCompare))\n      },\n      deep: true\n    },\n    'profile.visibility': {\n      handler () {\n        const objectToCompare = {\n          name: this.profile.name,\n          visibility: this.profile.visibility,\n          functionalities: this.profile.functionalitiesSelected.map(fun => fun.id).sort((a, b) => a - b),\n          establishments: this.profile.establishmentsSelected.map(estab => estab.id).sort((a, b) => a - b),\n          bankAccounts: this.profile.bankAccountsSelected.map(account => account.id).sort((a, b) => a - b)\n        }\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, objectToCompare))\n      },\n      deep: true\n    },\n    'profile.functionalitiesSelected': {\n      handler () {\n        const objectToCompare = {\n          name: this.profile.name,\n          visibility: this.profile.visibility,\n          functionalities: this.profile.functionalitiesSelected.map(fun => fun.id).sort((a, b) => a - b),\n          establishments: this.profile.establishmentsSelected.map(estab => estab.id).sort((a, b) => a - b),\n          bankAccounts: this.profile.bankAccountsSelected.map(account => account.id).sort((a, b) => a - b)\n        }\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, objectToCompare))\n      },\n      deep: true\n    },\n    'profile.establishmentsSelected': {\n      handler () {\n        const objectToCompare = {\n          name: this.profile.name,\n          visibility: this.profile.visibility,\n          functionalities: this.profile.functionalitiesSelected.map(fun => fun.id).sort((a, b) => a - b),\n          establishments: this.profile.establishmentsSelected.map(estab => estab.id).sort((a, b) => a - b),\n          bankAccounts: this.profile.bankAccountsSelected.map(account => account.id).sort((a, b) => a - b)\n        }\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, objectToCompare))\n      },\n      deep: true\n    },\n    'profile.bankAccountsSelected': {\n      handler () {\n        const objectToCompare = {\n          name: this.profile.name,\n          visibility: this.profile.visibility,\n          functionalities: this.profile.functionalitiesSelected.map(fun => fun.id).sort((a, b) => a - b),\n          establishments: this.profile.establishmentsSelected.map(estab => estab.id).sort((a, b) => a - b),\n          bankAccounts: this.profile.bankAccountsSelected.map(account => account.id).sort((a, b) => a - b)\n        }\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, objectToCompare))\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    /** CARREGAR DADOS INICIAIS */\n    async loadData () {\n      try {\n        await this.loadEstablishments()\n        await this.loadBankAccounts()\n        await this.loadFunctionalitiesGroups()\n      } catch (error) {\n        this.$root.$refs.notification.error(error.message)\n      }\n    },\n\n    /** PERFIL DE ACESSO **/\n    loadProfile () {\n      this.$store.dispatch('getProfile', this.profileToEditId)\n        .then((response) => {\n          const profileToEdit = response.data\n\n          this.profile.name = profileToEdit.nome\n          profileToEdit.grupoFuncionalidades.forEach(functionalityGroupSelected => {\n            functionalityGroupSelected.funcionalidades.forEach(functionalitySelected => {\n              this.functionalitiesGroups.forEach(functionalityGroup => {\n                functionalityGroup.funcionalidades.forEach(functionality => {\n                  if (functionality.id === functionalitySelected.id) {\n                    functionality.checked = true\n                    this.selectFunctionality(functionality)\n                    return\n                  }\n                })\n              })\n            })\n          })\n          if (profileToEdit.perfilAcessoBanking) {\n            /*\n              No BD a visibilidade para estabelecimento e conta bancarias é salva em campos separados,\n              porem na view é utilizado apenas um campo para representar os dois campos\n            */\n            this.profile.visibility = profileToEdit.perfilAcessoBanking.visibilidadeEstabelecimento\n\n            profileToEdit.perfilAcessoBanking.perfilAcessoEstabelecimentos.forEach(establishmentSelected => {\n              this.establishments.establishments.forEach(establishment => {\n                if (establishmentSelected.estabelecimento.id === establishment.id) {\n                  this.selectEstablishment(establishment)\n                  return\n                }\n              })\n            })\n\n            profileToEdit.perfilAcessoBanking.perfilAcessoContas.forEach(bankAccountSelected => {\n              this.bankAccounts.accounts.forEach(bankAccount => {\n                if (bankAccountSelected.conta.id === bankAccount.id) {\n                  this.selectBankAccount(bankAccount)\n                  return\n                }\n              })\n            })\n          } else {\n            this.profile.visibility = '0'\n          }\n\n          this.defaultObject = {\n            name: this.profile.name,\n            visibility: this.profile.visibility,\n            functionalities: this.profile.functionalitiesSelected.map(fun => fun.id).sort((a, b) => a - b),\n            establishments: this.profile.establishmentsSelected.map(estab => estab.id).sort((a, b) => a - b),\n            bankAccounts: this.profile.bankAccountsSelected.map(account => account.id).sort((a, b) => a - b)\n          }\n        })\n    },\n\n    isMasterProfile (accessProfileId) {\n      return Number(accessProfileId) === PerfilAcessoEnum.MASTER\n    },\n\n    /** FUNCIONALIDADES **/\n    loadFunctionalitiesGroups () {\n      let self = this\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('getFunctionalitiesGroups', '/accessProfile/functionalitiesGroups')\n        .then((response) => {\n          this.totalFunctionalities = 0\n          this.functionalitiesGroups = response.data\n          let remove = []\n          this.functionalitiesGroups.forEach((functionalityGroup, index, list) => {\n            if (functionalityGroup.funcionalidades && functionalityGroup.funcionalidades.length > 0) {\n              this.$set(functionalityGroup, 'checked', false)\n              this.$set(functionalityGroup, 'selectedFuncs', [])\n              if (!self.$store.getters.isClientEmulatedLogin) {\n                if (functionalityGroup.nome === self.$t('menu.grupos.registro')) {\n                  functionalityGroup.funcionalidades = functionalityGroup.funcionalidades.filter(funcionalidade => {\n                    return funcionalidade.nome !== self.$t('menu.funcionalidades.categorias') &&\n                    funcionalidade.nome !== self.$t('menu.funcionalidades.planosConciliacao') &&\n                    funcionalidade.nome !== self.$t('conjuntoAtributo.titulos.atributos')\n                  })\n                }\n              }\n              functionalityGroup.funcionalidades.forEach(functionality => {\n                this.$set(functionality, 'checked', false)\n                this.totalFunctionalities++\n              })\n            } else {\n              remove.push(functionalityGroup)\n            }\n          })\n\n          remove.forEach(group => {\n            let idx = this.functionalitiesGroups.indexOf(group)\n            if (idx >= 0) {\n              this.functionalitiesGroups.splice(idx, 1)\n            }\n          })\n\n          if (this.profileToEditId) {\n            this.loadProfile()\n          } else {\n            this.defaultObject = {\n              name: this.profile.name,\n              visibility: this.profile.visibility,\n              functionalities: this.profile.functionalitiesSelected.map(fun => fun.id).sort((a, b) => a - b),\n              establishments: this.profile.establishmentsSelected.map(estab => estab.id).sort((a, b) => a - b),\n              bankAccounts: this.profile.bankAccountsSelected.map(account => account.id).sort((a, b) => a - b)\n            }\n          }\n          resolve()\n        }).catch((error) => {\n          reject(error)\n        })\n      })\n    },\n\n    trackEventOnFunctionality (functionalityName) {\n      trackAnalyticsEvent(this, 'checkbox-click', 'select-funcionalidade', functionalityName)\n    },\n\n    trackEventOnFunctionalityGroup (functionalityGroupName) {\n      trackAnalyticsEvent(this, 'checkbox-click', 'select-grupo-de-funcionalidade', functionalityGroupName)\n    },\n\n    selectAllFunctionalities () {\n      this.allFunctionalitiesSelected = !this.allFunctionalitiesSelected\n      this.profile.functionalitiesSelected = []\n\n      this.functionalitiesGroups.forEach(gf => {\n        gf.checked = this.allFunctionalitiesSelected\n        gf.selectedFuncs = this.allFunctionalitiesSelected ? gf.funcionalidades.slice() : []\n        gf.funcionalidades.forEach(f => {\n          f.checked = this.allFunctionalitiesSelected\n          this.allFunctionalitiesSelected ? this.pushItemToArray(f, this.profile.functionalitiesSelected) : this.spliceItemToArray(f, this.profile.functionalitiesSelected)\n        })\n      })\n    },\n\n    selectFunctionalityGroup (functionalityGroup) {\n      let groupIndex = this.functionalitiesGroups.indexOf(functionalityGroup)\n      this.functionalitiesGroups[groupIndex].funcionalidades.forEach(f => {\n        f.checked = this.functionalitiesGroups[groupIndex].checked\n        if (this.functionalitiesGroups[groupIndex].checked) {\n          this.pushItemToArray(f, this.profile.functionalitiesSelected)\n          this.pushItemToArray(f, this.functionalitiesGroups[groupIndex].selectedFuncs)\n        } else {\n          this.spliceItemToArray(f, this.profile.functionalitiesSelected)\n          this.spliceItemToArray(f, this.functionalitiesGroups[groupIndex].selectedFuncs)\n        }\n      })\n\n      this.allFunctionalitiesSelected = (this.profile.functionalitiesSelected.length === this.totalFunctionalities)\n      this.functionalitiesGroups[groupIndex].checked = (this.functionalitiesGroups[groupIndex].selectedFuncs.length >= this.functionalitiesGroups[groupIndex].funcionalidades.length)\n    },\n\n    selectFunctionality (functionality) {\n      let gindex = this.getGroupIndexById(functionality.grupoFuncionalidade.id)\n\n      if (functionality.checked) {\n        this.pushItemToArray(functionality, this.profile.functionalitiesSelected)\n        if (this.profile.functionalitiesSelected.length === this.totalFunctionalities) {\n          this.allFunctionalitiesSelected = true\n        } else {\n          this.allFunctionalitiesSelected = false\n        }\n        this.pushItemToArray(functionality, this.functionalitiesGroups[gindex].selectedFuncs)\n        if (this.functionalitiesGroups[gindex].selectedFuncs.length === this.functionalitiesGroups[gindex].funcionalidades.length) {\n          this.functionalitiesGroups[gindex].checked = true\n        } else {\n          this.functionalitiesGroups[gindex].checked = false\n        }\n      } else {\n        if (this.spliceItemToArray(functionality, this.profile.functionalitiesSelected)) {\n          this.allFunctionalitiesSelected = false\n        }\n\n        if (this.spliceItemToArray(functionality, this.functionalitiesGroups[gindex].selectedFuncs)) {\n          this.functionalitiesGroups[gindex].checked = false\n        }\n      }\n    },\n\n    getGroupIndexById (groupId) {\n      let gIndex = -1\n      this.functionalitiesGroups.forEach((group, index) => {\n        if (group.id === groupId) {\n          gIndex = index\n          return gIndex\n        }\n      })\n      return gIndex\n    },\n\n    pushItemToArray (item, array) {\n      let idx = array.indexOf(item)\n      if (idx === -1) {\n        array.push(item)\n      }\n    },\n\n    spliceItemToArray (item, array) {\n      let idx = array.indexOf(item)\n      if (idx > -1) {\n        array.splice(idx, 1)\n        return true\n      }\n      return false\n    },\n\n    getGroupIcon (group) {\n      let icon = ''\n      if (group === 31) {\n        icon = 'fa fa-wrench'\n      } else if (group === 32) {\n        icon = 'fa fa-pencil-square-o'\n      } else if (group === 33) {\n        icon = 'fa fa-handshake-o'\n      } else if (group === 34) {\n        icon = 'fa fa-share-alt'\n      } else if (group === 35) {\n        icon = 'fa fa-window-restore'\n      } else if (group === 36) {\n        icon = 'fa fa-bar-chart'\n      } else if (group === 37) {\n        icon = 'fa fa-usd'\n      }\n      return icon\n    },\n\n    getCheckFuncContainerClass (index) {\n      if (index % 2 === 0) {\n        return 'col-xs-6 pull-left'\n      } else {\n        return 'col-xs-6 pull-right'\n      }\n    },\n\n    /** ESTABELECIMENTOS **/\n    loadEstablishments () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('getEstablishmentsToTreeGrid', {\n          url: 'establishment/listDetails'\n        })\n        .then((response) => {\n          const establishments = response.data.Body[0]\n          this.establishments.establishments = establishments.map(establishment => {\n            return {\n              id: establishment.id,\n              nome: establishment.Nome,\n              nomeFantasia: establishment.NomeFantasia,\n              cnpj: establishment.CNPJ ? establishment.CNPJ.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5') : '-'\n            }\n          })\n          resolve()\n        }).catch((error) => {\n          reject(error)\n        })\n      })\n    },\n\n    selectAllEstablishments () {\n      this.establishments.allEstablishmentsSelected = !this.establishments.allEstablishmentsSelected\n      this.establishments.establishments = this.establishments.establishments.map(establishment => {\n        establishment.checked = this.establishments.allEstablishmentsSelected\n        const index = this.profile.establishmentsSelected.findIndex(establishmentSelected => establishmentSelected['id'] === establishment['id'])\n        if (index > -1 && !this.establishments.allEstablishmentsSelected) {\n          this.profile.establishmentsSelected.splice(index, 1)\n        } else if (index === -1 && this.establishments.allEstablishmentsSelected) {\n          this.profile.establishmentsSelected.push(establishment)\n        }\n        return establishment\n      })\n    },\n\n    selectEstablishment (establishmentClicked) {\n      const establishmentSelected = !establishmentClicked.checked\n\n      this.establishments.establishments = this.establishments.establishments.map(establishment => {\n        if (establishment['id'] === establishmentClicked['id']) {\n          establishment.checked = establishmentSelected\n        }\n        return establishment\n      })\n\n      if (establishmentSelected) {\n        this.profile.establishmentsSelected.push(establishmentClicked)\n      } else {\n        const index = this.profile.establishmentsSelected.findIndex(\n          establishment => establishment['id'] === establishmentClicked['id']\n        )\n        if (index > -1) {\n          this.profile.establishmentsSelected.splice(index, 1)\n        }\n      }\n\n      if (this.profile.establishmentsSelected.length === 0 || this.profile.establishmentsSelected.length !== this.establishments.establishments.length) {\n        this.establishments.allEstablishmentsSelected = false\n      } else if (this.profile.establishmentsSelected.length === this.establishments.establishments.length) {\n        this.establishments.allEstablishmentsSelected = true\n      }\n    },\n\n    /** CONTAS BANCARIAS **/\n    loadBankAccounts () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('getBankAccounts', '/bankAccounts')\n        .then((response) => {\n          this.bankAccounts.accounts = response.data.data\n          resolve()\n        })\n        .catch((error) => {\n          reject(error)\n        })\n      })\n    },\n\n    handleFilter (event, column) {\n      Event.$emit(`vue-tables.filter::${column}`, event.currentTarget.value)\n    },\n\n    selectAllBankAccounts () {\n      this.bankAccounts.allBankAccountsSelected = !this.bankAccounts.allBankAccountsSelected\n      this.bankAccounts.accounts = this.bankAccounts.accounts.map(account => {\n        account.checked = this.bankAccounts.allBankAccountsSelected\n        const index = this.profile.bankAccountsSelected.findIndex(accountSelected => accountSelected['id'] === account['id'])\n        if (index > -1 && !this.bankAccounts.allBankAccountsSelected) {\n          this.profile.bankAccountsSelected.splice(index, 1)\n        } else if (index === -1 && this.bankAccounts.allBankAccountsSelected) {\n          this.profile.bankAccountsSelected.push(account)\n        }\n        return account\n      })\n    },\n\n    selectBankAccount (accountClicked) {\n      const accountSelected = !accountClicked.checked\n\n      this.bankAccounts.accounts = this.bankAccounts.accounts.map(account => {\n        if (account['id'] === accountClicked['id']) {\n          account.checked = accountSelected\n        }\n        return account\n      })\n\n      if (accountSelected) {\n        this.profile.bankAccountsSelected.push(accountClicked)\n      } else {\n        const index = this.profile.bankAccountsSelected.findIndex(\n          account => account['id'] === accountClicked['id']\n        )\n        if (index > -1) {\n          this.profile.bankAccountsSelected.splice(index, 1)\n        }\n      }\n\n      if (this.profile.bankAccountsSelected.length === 0 || this.profile.bankAccountsSelected.length !== this.bankAccounts.accounts.length) {\n        this.bankAccounts.allBankAccountsSelected = false\n      } else if (this.profile.bankAccountsSelected.length === this.bankAccounts.accounts.length) {\n        this.bankAccounts.allBankAccountsSelected = true\n      }\n    },\n\n    /** CADASTRO | ATUALIZACAO DO PERFIL DE ACESSO **/\n    newProfile () {\n      const profile = {\n        id: this.profileToEditId,\n        nome: this.profile.name.trim(),\n        visibilidade: this.profile.visibility,\n        funcionalidades: this.profile.functionalitiesSelected,\n        estabelecimentos: this.profile.establishmentsSelected,\n        contas: this.profile.bankAccountsSelected\n      }\n\n      this.requestSaveProfileSent = true\n      this.$store.dispatch('newProfile', profile)\n        .then((response) => {\n          if (this.profileToEditId) {\n            this.$root.$refs.notification.success('administracao.perfilAcesso.sucesso.editado')\n          } else {\n            this.$root.$refs.notification.success('administracao.perfilAcesso.sucesso.criado')\n          }\n          this.profiles = response.data\n          this.$store.dispatch('setHasUnsavedChanges', false)\n          this.$router.push(PATHS.LIST_ACCESS_PROFILE)\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n        .finally(() => {\n          this.requestSaveProfileSent = false\n        })\n    },\n\n    /** BOTOES **/\n    nextStep () {\n      if (this.currentStep < 3) {\n        this.$validator.validateAll()\n          .then((result) => {\n            if (result) {\n              if (this.profile.visibility === '1') {\n                this.currentStep = this.currentStep + 1\n              } else {\n                this.currentStep = 3\n              }\n            } else {\n              this.$root.$refs.notification.error('administracao.perfilAcesso.validacao.camposObrigatorios', 'administracao.perfilAcesso.erro.criar')\n            }\n          })\n      }\n    },\n\n    backStep () {\n      if (this.currentStep > 0) {\n        if (this.profile.visibility === '1') {\n          this.currentStep = this.currentStep - 1\n        } else {\n          this.currentStep = 0\n        }\n      }\n    },\n\n    back () {\n      this.$router.push(PATHS.LIST_ACCESS_PROFILE)\n    }\n  },\n\n  created () {\n    this.loadData()\n  },\n\n  beforeDestroy () {\n    this.$store.dispatch('setHasUnsavedChanges', false)\n    this.$store.dispatch('cleanProfileToEdit')\n  }\n}\n</script>\n\n<style scoped>\n.fa {\n  font-size: 20px;\n}\n\n.check-group {\n  margin-left: 0.7vw !important;\n}\n\n.checkbox {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-left: 10px;\n}\n\n.group-checkbox {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-left: 15px;\n}\n\n.boxed-container {\n\tborder: 1px solid #ddd;\n\tbackground: #fff;\n\tcolor:#444;\n  padding: 10px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.func-group-title {\n  color:#17375f;\n  font-size: 14px !important;\n  text-transform: none !important;\n}\n\n.func-group-title-label {\n  margin-left: 0.5vw;\n}\n\n.func-group-labels {\n  color:#515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n\n.bottom-bordered {\n  border-bottom: 1px solid #17375f;\n  margin-top: 0.4vh;\n  margin-bottom: 0.7vh;\n}\n\n.func-padded {\n  padding-left: 0.7vw;\n}\n\n.info-icon {\n  margin-left: 15px;\n  font-size: 15px;\n  color: gray;\n}\n\n.custom-data-table {\n  display: block;\n  height: calc(50vh - 20px);\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.checkbox-table-input {\n  width: 20px !important;\n}\n\n.checkbox-table-input-header {\n  margin: 0px 3px -5px 5px !important;\n}\n\n.checkbox-table-input-row {\n  margin-left: 5px !important;\n  margin-right: 3px !important;\n}\n\n#confirmation .bg-gray {\n  background-color: #dbdbdb;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1030 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-07ceb7ab","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/menu/SuspendedMenu.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Menu suspenso */\ndiv[data-popover=\"suspended-menu\"][data-v-07ceb7ab] {\n  background: #143965;\n  color: #86a0ac;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 16px;\n  padding: 0;\n  border-radius: 5px;\n  box-shadow: 0px 15px 25px 0 rgba(52,73,94,.4);\n  left: 0 !important;\n  top: 0 !important;\n  margin-top: 130% !important;\n  margin-left: -325.5% !important;\n  position: absolute !important;\n}\n\n/* Setinha do topo do menu */\ndiv[data-popover=\"suspended-menu\"].dropdown-position-bottom[data-v-07ceb7ab]:before {\n  border-bottom: 6px solid #143965;\n  left: calc(50% - -48px);\n}\n\n/* Conjunto de itens do menu */\ndiv[data-popover=\"suspended-menu\"] > ul[data-v-07ceb7ab] {\n  margin: 0;\n  text-align: left;\n}\n\n/* Cada item do menu */\ndiv[data-popover=\"suspended-menu\"] li[data-v-07ceb7ab] {\n  display: inline-block;\n  width: 100%;\n  padding: 20px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n/* Hover de cada item do menu */\ndiv[data-popover=\"suspended-menu\"] li[data-v-07ceb7ab]:hover {\n  transition: color 0.5s ease;\n  color: #fff;\n}\n\n/* Ícone de cada item do menu */\ndiv[data-popover=\"suspended-menu\"] li i[data-v-07ceb7ab] {\n  padding-right: 14px;\n  padding-top: 0;\n}\n\n/* Wrapper de ícone + span de cada item do menu */\ndiv[data-popover=\"suspended-menu\"] .clickable-item[data-v-07ceb7ab] {\n  height: 100%;\n  cursor: pointer;\n}\n\n/* Modificador do item Logout */\ndiv[data-popover=\"suspended-menu\"] li.logout[data-v-07ceb7ab] {\n  line-height: 14px;\n  background-color: #0B2848;\n}\n\n/* Modificador do item Logout */\ndiv[data-popover=\"suspended-menu\"] li.logout i[data-v-07ceb7ab] {\n  padding: 0;\n  float: right;\n}\n", "", {"version":3,"sources":["/./client/components/layout/menu/SuspendedMenu.vue?7f80bc2a"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA0DA,mBAAA;AACA;EACA,oBAAA;EACA,eAAA;EACA,iCAAA;AACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BAAA;CACA;;AAEA,6BAAA;AACA;EACA,iCAAA;EACA,wBAAA;CACA;;AAEA,+BAAA;AACA;EACA,UAAA;EACA,iBAAA;CACA;;AAEA,uBAAA;AACA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;CACA;;AAEA,gCAAA;AACA;EACA,4BAAA;EACA,YAAA;CACA;;AAEA,gCAAA;AACA;EACA,oBAAA;EACA,eAAA;CACA;;AAEA,kDAAA;AACA;EACA,aAAA;EACA,gBAAA;CACA;;AAEA,gCAAA;AACA;EACA,kBAAA;EACA,0BAAA;CACA;;AAEA,gCAAA;AACA;EACA,WAAA;EACA,aAAA;CACA","file":"SuspendedMenu.vue","sourcesContent":["<template lang=\"pug\" src=\"./suspendedMenu.pug\"></template>\n\n<script>\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\nimport PATHS from '../../../router/routesMap.js'\n\nexport default {\n  name: 'SuspendedMenu',\n\n  data () {\n    return {\n      blockClientSelectButton: false\n    }\n  },\n\n  computed: {\n    applicationList () {\n      return this.$store.getters.clientApps\n    },\n    singleClient () {\n      return this.$store.getters.singleClient\n    }\n  },\n\n  watch: {\n    singleClient () {\n      this.blockClientSelectButton = this.singleClient\n    }\n  },\n\n  methods: {\n    logout () {\n      this.$store.dispatch('logout')\n        .then(this.$router.push(PATHS.LOGIN))\n    },\n\n    openClientModal () {\n      this.$store.dispatch('openClientModal')\n    },\n\n    openMyAccountModal () {\n      trackAnalyticsEvent(this, 'menu-minha-conta', 'menu-minha-conta-click', 'abrir-modal-minha-conta')\n      this.$store.dispatch('openMyAccountModal')\n    },\n\n    openAppChangeModal () {\n      trackAnalyticsEvent(this, 'menu-troca-app', 'menu-troca-app-click', 'abrir-modal-troca-app')\n      this.$store.dispatch('openAppChangeModal')\n    }\n  },\n\n  mounted () {\n    this.blockClientSelectButton = this.singleClient\n  }\n}\n</script>\n\n<style scoped>\n/* Menu suspenso */\ndiv[data-popover=\"suspended-menu\"] {\n  background: #143965;\n  color: #86a0ac;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 16px;\n  padding: 0;\n  border-radius: 5px;\n  box-shadow: 0px 15px 25px 0 rgba(52,73,94,.4);\n  left: 0 !important;\n  top: 0 !important;\n  margin-top: 130% !important;\n  margin-left: -325.5% !important;\n  position: absolute !important;\n}\n\n/* Setinha do topo do menu */\ndiv[data-popover=\"suspended-menu\"].dropdown-position-bottom:before {\n  border-bottom: 6px solid #143965;\n  left: calc(50% - -48px);\n}\n\n/* Conjunto de itens do menu */\ndiv[data-popover=\"suspended-menu\"] > ul {\n  margin: 0;\n  text-align: left;\n}\n\n/* Cada item do menu */\ndiv[data-popover=\"suspended-menu\"] li {\n  display: inline-block;\n  width: 100%;\n  padding: 20px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n/* Hover de cada item do menu */\ndiv[data-popover=\"suspended-menu\"] li:hover {\n  transition: color 0.5s ease;\n  color: #fff;\n}\n\n/* Ícone de cada item do menu */\ndiv[data-popover=\"suspended-menu\"] li i {\n  padding-right: 14px;\n  padding-top: 0;\n}\n\n/* Wrapper de ícone + span de cada item do menu */\ndiv[data-popover=\"suspended-menu\"] .clickable-item {\n  height: 100%;\n  cursor: pointer;\n}\n\n/* Modificador do item Logout */\ndiv[data-popover=\"suspended-menu\"] li.logout {\n  line-height: 14px;\n  background-color: #0B2848;\n}\n\n/* Modificador do item Logout */\ndiv[data-popover=\"suspended-menu\"] li.logout i {\n  padding: 0;\n  float: right;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1031 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-081ec6ca","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonApplication/ButtonApplication.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.rounded-div-active {\n  width: 120px;\n  height: 120px;\n  border: 2px solid #012351;\n  border-radius: 50%;\n  text-align: center;\n  background: #012351;\n}\n.rounded-div {\n  width: 120px;\n  height: 120px;\n  border: 2px solid #012351;\n  border-radius: 50%;\n  text-align: center;\n  background: white;\n}\n.app-font {\n  font-family: 'Inter', sans-serif;\n  color: #012351;\n  font-size: 15px;\n  text-align: center;\n}\n#Botao-Aplicacao-Wrapper:hover .app-font {\n  font-weight: bold;\n}\n.mark {\n  color: white;\n  background: #40b9bb;\n  border-radius: 13px;\n  padding: 8px 15px 8px 15px;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 14px;\n}\n#Botao-Aplicacao-Wrapper:hover .mark {\n  box-shadow: 0px 0px 30px 0px #999;\n  transition: all linear 0.2s;\n}\n.transp-mark {\n  background: transparent;\n  color: transparent;\n}\n#Botao-Aplicacao-Wrapper {\n  cursor: pointer;\n  padding-top: 20px;\n}\n.img-troca-app {\n  padding-top: 25px;\n}\n#Botao-Aplicacao-Wrapper:hover .img-troca-app {\n  box-shadow: 0px 0px 30px 0px #999;\n  transition: all linear 0.2s;\n}\n", "", {"version":3,"sources":["/./client/components/buttons/buttonApplication/ButtonApplication.vue?6fdf33b8"],"names":[],"mappings":";AAyDA;EACA,aAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;CACA;AAEA;EACA,aAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,aAAA;EACA,oBAAA;EACA,oBAAA;EACA,2BAAA;EACA,iCAAA;AACA,iBAAA;EACA,gBAAA;CACA;AAEA;EAGA,kCAAA;EACA,4BAAA;CACA;AAEA;EACA,wBAAA;EACA,mBAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EAGA,kCAAA;EACA,4BAAA;CACA","file":"ButtonApplication.vue","sourcesContent":["<template src='./buttonApplication.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'ButtonApplication',\n\n  props: {\n    btnDesc: {\n      type: String,\n      required: true\n    },\n    btnImg: {\n      type: String,\n      required: true\n    },\n    btnActive: {\n      type: Boolean,\n      required: true\n    },\n    btnClickFunction: {\n      type: Function,\n      required: true\n    },\n    btnWidth: {\n      type: String,\n      required: true\n    },\n    btnAppId: {\n      type: Number,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      equalsCartoesImg: require('../../../assets/icones_app/cartao_azul.svg'),\n      equalsBankingImg: require('../../../assets/icones_app/banco_branco.svg')\n    }\n  },\n\n  methods: {\n    roundedClass () {\n      return this.btnActive ? 'rounded-div-active' : 'rounded-div'\n    },\n\n    activeMarkClass () {\n      return this.btnActive ? 'mark' : 'transp-mark'\n    },\n\n    activeDescClass () {\n      return this.btnActive ? 'app-font bold' : 'app-font'\n    }\n  }\n}\n</script>\n\n<style lang='css'>\n.rounded-div-active {\n  width: 120px;\n  height: 120px;\n  border: 2px solid #012351;\n  border-radius: 50%;\n  text-align: center;\n  background: #012351;\n}\n\n.rounded-div {\n  width: 120px;\n  height: 120px;\n  border: 2px solid #012351;\n  border-radius: 50%;\n  text-align: center;\n  background: white;\n}\n\n.app-font {\n  font-family: 'Inter', sans-serif;\n  color: #012351;\n  font-size: 15px;\n  text-align: center;\n}\n\n#Botao-Aplicacao-Wrapper:hover .app-font {\n  font-weight: bold;\n}\n\n.mark {\n  color: white;\n  background: #40b9bb;\n  border-radius: 13px;\n  padding: 8px 15px 8px 15px;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 14px;\n}\n\n#Botao-Aplicacao-Wrapper:hover .mark {\n  -webkit-box-shadow: 0px 0px 30px 0px #999;\n  -moz-box-shadow: 0px 0px 30px 0px #999;\n  box-shadow: 0px 0px 30px 0px #999;\n  transition: all linear 0.2s;\n}\n\n.transp-mark {\n  background: transparent;\n  color: transparent;\n}\n\n#Botao-Aplicacao-Wrapper {\n  cursor: pointer;\n  padding-top: 20px;\n}\n\n.img-troca-app {\n  padding-top: 25px;\n}\n\n#Botao-Aplicacao-Wrapper:hover .img-troca-app {\n  -webkit-box-shadow: 0px 0px 30px 0px #999;\n  -moz-box-shadow: 0px 0px 30px 0px #999;\n  box-shadow: 0px 0px 30px 0px #999;\n  transition: all linear 0.2s;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1032 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-09c1836a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/calendarView/CalendarView.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.week-header {\r\n  display: -ms-flexbox !important;\r\n  display: flex !important;\r\n  -webkit-user-select: none !important;\r\n  -ms-user-select: none !important;\r\n  user-select: none !important;\n}\n.week-column-day-header {\r\n  -ms-flex: 1 0 20px;\r\n      flex: 1 0 20px;\r\n  border-right: 1px solid #e0e0e0;\r\n  color: #757575;\r\n  padding: 4px;\r\n  padding-bottom: 0;\n}\n.week-day {\r\n  -ms-flex: 1 !important;\r\n      flex: 1 !important;\r\n  width: 0 !important;\r\n  border-right: 1px solid #e0e0e0 !important;\r\n  border-bottom: 1px solid #e0e0e0 !important;\r\n  padding: 4px !important;\r\n  overflow: hidden !important;\n}\n.label-today {\r\n  color: #0068AB;\r\n  font-weight: bolder;\r\n  font-size: large;\n}\n.selected-day {\r\n  background: #0068AB15;\r\n  border: 1px solid #0068AB !important;\n}\n.label-indicador-percent {\r\n  font-size: 15px;\r\n  font-weight: bold;\n}\n.label-indicador-status {\r\n  font-family: 'Inter', sans-serif;\r\n  text-transform: initial !important;\r\n  color: #515151;\r\n  font-weight: normal !important;\r\n  font-size: 12px !important;\n}\n.alert-calendar {\r\n  font-style: italic;\r\n  font-size: 12px;\r\n  color: #666;\r\n  padding-top: 10px;\n}\n.detail-line-position {\r\n  text-align: end;\r\n  padding-left: 1vh;\r\n  padding-right: 1vh;\n}\n.square-5 {\r\n  width: 1.5vh;\r\n  height: 1.5vh;\r\n  margin-right: 0.5vh;\n}\n.filter-active {\r\n  opacity: 100%;\n}\n.filter-inactive {\r\n  opacity: 55%;\n}\n.filter-item {\r\n  cursor: pointer;\r\n  height: 4vh;\r\n  -ms-flex-align: center;\r\n      align-items: center;\n}\n.filter-item:hover {\r\n  opacity: 100%;\r\n  border: 2px solid;\r\n  border-color: #3BB5B4;\r\n  border-radius: 10px;\n}\n.vdp-datepicker {\r\n  border-radius: 5px;\r\n  border: 1px solid #ccc;\r\n  padding: 7px 8px 7px 8px;\r\n  margin-right: 5px;\n}\n.margin-box-filter {\r\n  margin: 5px 5px 20px 0px;\n}\n.calendar-month-picker {\r\n  border: none;\r\n  height: 3.2vh;\r\n  width: 18vh;\n}\r\n", "", {"version":3,"sources":["/./client/components/calendarView/CalendarView.vue?63f939c4"],"names":[],"mappings":";AAuWA;EACA,gCAAA;EAAA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,6BAAA;CACA;AACA;EACA,mBAAA;MAAA,eAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;CACA;AACA;EACA,uBAAA;MAAA,mBAAA;EACA,oBAAA;EACA,2CAAA;EACA,4CAAA;EACA,wBAAA;EACA,4BAAA;CACA;AACA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;CACA;AACA;EACA,sBAAA;EACA,qCAAA;CACA;AACA;EACA,gBAAA;EACA,kBAAA;CACA;AACA;EACA,iCAAA;EACA,mCAAA;EACA,eAAA;EACA,+BAAA;EACA,2BAAA;CACA;AACA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;CACA;AACA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;CACA;AACA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;CACA;AACA;EACA,cAAA;CACA;AACA;EACA,aAAA;CACA;AACA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;MAAA,oBAAA;CACA;AACA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;CACA;AACA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;CACA;AACA;EACA,yBAAA;CACA;AACA;EACA,aAAA;EACA,cAAA;EACA,YAAA;CACA","file":"CalendarView.vue","sourcesContent":["<template src='./calendarView.pug' lang='pug'></template>\r\n\r\n<script>\r\nimport language from '../../../build/language/index'\r\nimport moment from 'moment'\r\nimport Datepicker from 'vuejs-datepicker'\r\nimport vSelect from 'vue-select'\r\n\r\nexport default {\r\n  name: 'CalendarView',\r\n\r\n  components: {\r\n    Datepicker,\r\n    vSelect\r\n  },\r\n\r\n  computed: {\r\n    monthPickerLanguage () {\r\n      return this.language.getDatePickerLanguageObject()\r\n    },\r\n    alertMessage () {\r\n      return this.$t('calendarioConciliacao.alerta.disclaimer')\r\n    },\r\n    orderedStatusList () {\r\n      return this.situationList.sort((a, b) => a.prioridade - b.prioridade)\r\n    }\r\n  },\r\n\r\n  props: {\r\n    monthToShow: {\r\n      type: Date,\r\n      required: true\r\n    },\r\n    setStartDate: {\r\n      type: Function,\r\n      required: true,\r\n      default: () => null\r\n    },\r\n    setEndDate: {\r\n      type: Function,\r\n      required: true,\r\n      default: () => null\r\n    },\r\n    setMonth: {\r\n      type: Function,\r\n      required: true,\r\n      default: () => null\r\n    },\r\n    conciliacaoData: {\r\n      type: Array,\r\n      required: true,\r\n      default: []\r\n    },\r\n    categories: {\r\n      type: Array,\r\n      required: true,\r\n      default: []\r\n    },\r\n    isLoadingData: {\r\n      type: Boolean,\r\n      required: true\r\n    },\r\n    setCategory: {\r\n      type: Function,\r\n      required: true,\r\n      default: () => null\r\n    },\r\n    selectedCategory: {\r\n      type: Object,\r\n      required: true\r\n    }\r\n  },\r\n\r\n  data () {\r\n    return {\r\n      language: language,\r\n      monthPick: null,\r\n      calendarData: {\r\n        weeks: []\r\n      },\r\n      situationList: [\r\n        {\r\n          id: 'A',\r\n          nome: this.$t('statusConciliacao.aberto'),\r\n          color: '#FFD54F',\r\n          prioridade: 1\r\n        },\r\n        {\r\n          id: 'C',\r\n          nome: this.$t('statusConciliacao.conciliado'),\r\n          color: '#81C784',\r\n          prioridade: 3\r\n        },\r\n        {\r\n          id: 'M',\r\n          nome: this.$t('calendarioConciliacao.detalhe.conciliadoManualmente'),\r\n          color: '#4DB6AC',\r\n          prioridade: 4\r\n        },\r\n        {\r\n          id: 'D',\r\n          nome: this.$t('statusConciliacao.divergente'),\r\n          color: '#E57373',\r\n          prioridade: 2\r\n        }\r\n      ],\r\n      fromDate: null,\r\n      toDate: null,\r\n      hasFirstClick: false,\r\n      filteredStatus: {\r\n        id: 'A',\r\n        nome: this.$t('statusConciliacao.aberto'),\r\n        color: '#FFD54F',\r\n        prioridade: 1\r\n      },\r\n      filteredCategory: {\r\n      },\r\n      isUpdatingInfo: false\r\n    }\r\n  },\r\n\r\n  watch: {\r\n    monthPick: {\r\n      handler (newVal, oldVal) {\r\n        if (newVal &&\r\n          !moment.utc(newVal).startOf('day').isSame(moment.utc(this.monthToShow).startOf('day'))\r\n        ) {\r\n          this.setMonth(newVal)\r\n        } else {\r\n          this.monthPick = this.monthToShow\r\n        }\r\n      },\r\n      deep: true\r\n    },\r\n    conciliacaoData: {\r\n      handler () {\r\n        this.generateCalendar()\r\n      },\r\n      deep: true\r\n    },\r\n    categories: {\r\n      handler () {\r\n        if (this.categories && this.categories.length > 0) {\r\n          this.filteredCategory = this.categories[0]\r\n        }\r\n      },\r\n      deep: true\r\n    },\r\n    selectedCategory: {\r\n      handler () {\r\n        this.filteredCategory = this.selectedCategory\r\n      },\r\n      deep: true\r\n    },\r\n    filteredCategory: {\r\n      handler () {\r\n        this.isUpdatingInfo = true\r\n        this.mountCalendarInfo()\r\n        this.isUpdatingInfo = false\r\n        this.setCategory(this.filteredCategory)\r\n      },\r\n      deep: true\r\n    }\r\n  },\r\n\r\n  methods: {\r\n    getReferenceFromDay (day) {\r\n      return moment.utc(day).valueOf()\r\n    },\r\n    /*\r\n      Normaliza matriz de dias do mês, organizando o arranjo posicionalmente\r\n    */\r\n    generateCalendar () {\r\n      let weeksToShow = this.calculateWeeks()\r\n      weeksToShow.map(wk => {\r\n        if (wk.length < 7) {\r\n          let miss = 7 - wk.length\r\n          // completa semana com 7 posicoes\r\n          for (let i = 0; i < miss; i++) {\r\n            wk.splice(i, 0, {})\r\n          }\r\n          // reorganiza as posicoes com cada dia no seu devido index (dom = 0, seg = 1...)\r\n          wk.map((day, dayIndex) => {\r\n            let weekIndex = day.date ? moment.utc(day.date).day() : -1\r\n            if (weekIndex >= 0) {\r\n              wk.splice(dayIndex, 1)\r\n              wk.splice(weekIndex, 0, day)\r\n            }\r\n          })\r\n        }\r\n        wk.map(day => {\r\n          // marca a data atual como pre selecionada\r\n          day.selected = this.isToday(day.date)\r\n        })\r\n      })\r\n      this.calendarData.weeks = weeksToShow\r\n      this.mountCalendarInfo()\r\n    },\r\n    /*\r\n      Gera matriz de dias separados por semana\r\n    */\r\n    calculateWeeks () {\r\n      let startDate = moment.utc(this.monthToShow).startOf('month')\r\n      let endDate = moment.utc(startDate).endOf('month')\r\n      let month = moment.utc(this.monthToShow).get('month')\r\n      let weeks = []\r\n      let perWeek = []\r\n      let difference = endDate.diff(startDate, 'days')\r\n      perWeek.push({date: startDate.toDate()})\r\n      let index = 0\r\n      let lastWeek = false\r\n      while (startDate.add(1, 'days').diff(endDate) < 0) {\r\n        if (startDate.day() !== 0) {\r\n          perWeek.push({date: startDate.toDate()})\r\n        } else {\r\n          if ((startDate.clone().add(7, 'days').month() === month)) {\r\n            weeks.push(perWeek)\r\n            perWeek = []\r\n            perWeek.push({date: startDate.toDate()})\r\n          } else if (Math.abs(index - difference) > 0) {\r\n            if (!lastWeek) {\r\n              weeks.push(perWeek)\r\n              perWeek = []\r\n            }\r\n            lastWeek = true\r\n            perWeek.push({date: startDate.toDate()})\r\n          }\r\n        }\r\n        index += 1\r\n        if (\r\n          (lastWeek === true && Math.abs(index - difference) === 0) ||\r\n          (Math.abs(index - difference) === 0 && perWeek.length === 1)\r\n        ) {\r\n          weeks.push(perWeek)\r\n        }\r\n      }\r\n      return weeks\r\n    },\r\n    formatDateGetDay (day) {\r\n      return day ? moment.utc(day).format('DD') : ''\r\n    },\r\n    isToday (date) {\r\n      return date ? moment.utc(date).endOf('day').isSame(moment.utc().endOf('day')) : false\r\n    },\r\n    handleClickDay (selectedDate) {\r\n      if (selectedDate) {\r\n        if (this.hasFirstClick) {\r\n          let firstDate = moment.utc(this.fromDate).startOf('day').isBefore(moment.utc(selectedDate).startOf('day')) ? this.fromDate : selectedDate\r\n          let lastDate = moment.utc(this.fromDate).startOf('day').isAfter(moment.utc(selectedDate).startOf('day')) ? this.fromDate : selectedDate\r\n          this.setStartDate(firstDate)\r\n          this.setEndDate(lastDate)\r\n          this.hasFirstClick = false\r\n        } else {\r\n          this.calendarData.weeks.map(week => {\r\n            week.map(day => {\r\n              day.selected = day.date ? moment.utc(day.date).endOf('day').isSame(moment.utc(selectedDate).endOf('day')) : false\r\n            })\r\n          })\r\n          this.hasFirstClick = true\r\n          this.fromDate = selectedDate\r\n        }\r\n      }\r\n    },\r\n    unselectAll () {\r\n      this.calendarData.weeks.map(week => {\r\n        week.map(day => {\r\n          day.selected = false\r\n        })\r\n      })\r\n    },\r\n    getConciliationLabel (status) {\r\n      let label = ' - '\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.nome\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    getColorByStatus (status) {\r\n      let label = '#64b5f6'\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.color\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    formatPercent (value) {\r\n      if (!isNaN(value)) {\r\n        let result = Number(value)\r\n        return (result % 1 !== 0 ? result.toFixed(2) : result) + '%'\r\n      }\r\n      return value\r\n    },\r\n    mountCalendarInfo () {\r\n      if (this.conciliacaoData && this.conciliacaoData.length > 0) {\r\n        this.calendarData.weeks.map(week => {\r\n          week.map(day => {\r\n            let baseDataByDay = this.conciliacaoData.filter((item) => {\r\n              return item.situacao !== 'N' &&\r\n                    (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&\r\n                    moment.utc(item.dataMin).startOf('day').isSame(moment.utc(day.date).startOf('day'))\r\n            })\r\n            let summaryByStatus = []\r\n            let totalByDay = 0\r\n            baseDataByDay.map(item => {\r\n              totalByDay += (item.totalExtrato + item.totalMovFinan)\r\n            })\r\n            baseDataByDay.map(item => {\r\n              let summaryIndex = summaryByStatus.findIndex(el => el.status === item.situacao)\r\n              if (summaryIndex >= 0) {\r\n                let summary = summaryByStatus.at(summaryIndex)\r\n                summary.totalByStatus += (item.totalExtrato + item.totalMovFinan)\r\n                summaryByStatus.splice(summaryIndex, 1, summary)\r\n              } else {\r\n                let summary = {\r\n                  status: item.situacao,\r\n                  totalByStatus: (item.totalExtrato + item.totalMovFinan)\r\n                }\r\n                summaryByStatus.push(summary)\r\n              }\r\n            })\r\n            summaryByStatus.map(sum => {\r\n              sum.percent = totalByDay !== 0\r\n                ? (100 * sum.totalByStatus) / totalByDay\r\n                : 'N/A'\r\n            })\r\n            day.summary = summaryByStatus\r\n          })\r\n        })\r\n        this.$forceUpdate()\r\n      }\r\n    },\r\n    handleMouseOver (date, isOverElement) {\r\n      if (date && this.hasFirstClick) {\r\n        if (isOverElement) {\r\n          let firstDate = moment.utc(this.fromDate).startOf('day').isBefore(moment.utc(date).startOf('day')) ? this.fromDate : date\r\n          let lastDate = moment.utc(this.fromDate).startOf('day').isAfter(moment.utc(date).startOf('day')) ? this.fromDate : date\r\n          this.calendarData.weeks.map(week => {\r\n            week.map(day => {\r\n              day.selected = day.date\r\n                            ? moment.utc(day.date).isBetween(moment.utc(firstDate).startOf('day'), moment.utc(lastDate).endOf('day'), undefined, '[]')\r\n                            : false\r\n            })\r\n          })\r\n        }\r\n      }\r\n    },\r\n    setFilteredStatus (status) {\r\n      this.filteredStatus = status\r\n    }\r\n  },\r\n  mounted () {\r\n    this.monthPick = this.monthToShow\r\n  }\r\n}\r\n</script>\r\n<style>\r\n.week-header {\r\n  display: flex !important;\r\n  -webkit-user-select: none !important;\r\n  -ms-user-select: none !important;\r\n  user-select: none !important;\r\n}\r\n.week-column-day-header {\r\n  flex: 1 0 20px;\r\n  border-right: 1px solid #e0e0e0;\r\n  color: #757575;\r\n  padding: 4px;\r\n  padding-bottom: 0;\r\n}\r\n.week-day {\r\n  flex: 1 !important;\r\n  width: 0 !important;\r\n  border-right: 1px solid #e0e0e0 !important;\r\n  border-bottom: 1px solid #e0e0e0 !important;\r\n  padding: 4px !important;\r\n  overflow: hidden !important;\r\n}\r\n.label-today {\r\n  color: #0068AB;\r\n  font-weight: bolder;\r\n  font-size: large;\r\n}\r\n.selected-day {\r\n  background: #0068AB15;\r\n  border: 1px solid #0068AB !important;\r\n}\r\n.label-indicador-percent {\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n}\r\n.label-indicador-status {\r\n  font-family: 'Inter', sans-serif;\r\n  text-transform: initial !important;\r\n  color: #515151;\r\n  font-weight: normal !important;\r\n  font-size: 12px !important;\r\n}\r\n.alert-calendar {\r\n  font-style: italic;\r\n  font-size: 12px;\r\n  color: #666;\r\n  padding-top: 10px;\r\n}\r\n.detail-line-position {\r\n  text-align: end;\r\n  padding-left: 1vh;\r\n  padding-right: 1vh;\r\n}\r\n.square-5 {\r\n  width: 1.5vh;\r\n  height: 1.5vh;\r\n  margin-right: 0.5vh;\r\n}\r\n.filter-active {\r\n  opacity: 100%;\r\n}\r\n.filter-inactive {\r\n  opacity: 55%;\r\n}\r\n.filter-item {\r\n  cursor: pointer;\r\n  height: 4vh;\r\n  align-items: center;\r\n}\r\n.filter-item:hover {\r\n  opacity: 100%;\r\n  border: 2px solid;\r\n  border-color: #3BB5B4;\r\n  border-radius: 10px;\r\n}\r\n.vdp-datepicker {\r\n  border-radius: 5px;\r\n  border: 1px solid #ccc;\r\n  padding: 7px 8px 7px 8px;\r\n  margin-right: 5px;\r\n}\r\n.margin-box-filter {\r\n  margin: 5px 5px 20px 0px;\r\n}\r\n.calendar-month-picker {\r\n  border: none;\r\n  height: 3.2vh;\r\n  width: 18vh;\r\n}\r\n</style>\r\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1033 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0a21cc36","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/attributesSet/Attribute.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.attribute > .att-field[data-v-0a21cc36] {\n  display: inline-block;\n}\n.list-complete-item[data-v-0a21cc36]:hover {\n  cursor: move;\n  background-color: #f5f5f5;\n}\n.list-complete-item[data-v-0a21cc36] {\n  padding-top: 18px;\n  padding-bottom: 18px;\n  height: auto;\n  word-wrap: break-word;\n  min-height: 58px;\n  border: 1px solid #ddd;\n  transition: all 1s;\n}\n.fa.action[data-v-0a21cc36] {\n  margin: 0;\n}\n.att-field.order[data-v-0a21cc36] {\n  margin-left: 30px;\n}\n.att-field.buttons[data-v-0a21cc36] {\n  padding-right: 7px;\n}\n", "", {"version":3,"sources":["/./client/components/registration/attributesSet/Attribute.vue?55c4fb6d"],"names":[],"mappings":";AAkEA;EACA,sBAAA;CACA;AAEA;EACA,aAAA;EACA,0BAAA;CACA;AAEA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA","file":"Attribute.vue","sourcesContent":["<template src='./attribute.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'Attribute',\n\n  props: {\n    order: {\n      type: Number\n    },\n    name: {\n      type: String,\n      required: true\n    },\n    description: {\n      type: String\n    },\n    type: {\n      type: Object,\n      required: true,\n      default: {}\n    },\n    possibleValues: {\n      type: Array,\n      required: true\n    },\n    validation: {\n      type: String\n    },\n    inUse: {\n      type: Boolean\n    },\n    mask: {\n      type: String\n    },\n    handleEdit: {\n      type: Function,\n      required: true\n    },\n    handleRemove: {\n      type: Function,\n      required: true\n    }\n  },\n\n  computed: {\n    transformedPossibleValues () {\n      if (this.possibleValues.length > 0) {\n        let transformedValues = []\n        this.possibleValues.forEach(element => {\n          transformedValues.push(element.valor || element.value || element)\n        })\n        return transformedValues.toString()\n      }\n      return '-'\n    },\n    btnRemoveTitle () {\n      return this.inUse\n        ? this.$t('conjuntoAtributo.validacao.atributoEmUsoExcluir')\n        : ''\n    }\n  }\n}\n</script>\n\n<style scoped>\n.attribute > .att-field {\n  display: inline-block;\n}\n\n.list-complete-item:hover {\n  cursor: move;\n  background-color: #f5f5f5;\n}\n\n.list-complete-item {\n  padding-top: 18px;\n  padding-bottom: 18px;\n  height: auto;\n  word-wrap: break-word;\n  min-height: 58px;\n  border: 1px solid #ddd;\n  transition: all 1s;\n}\n\n.fa.action {\n  margin: 0;\n}\n\n.att-field.order {\n  margin-left: 30px;\n}\n\n.att-field.buttons {\n  padding-right: 7px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1034 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0affa294","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabDetails/TabDetails.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n.tab-detail-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #17375f;\n  font-size: 15px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n.detail-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  margin-top: 1vh;\n  color: #17375f;\n}\n#main-detail-container.main-container {\n  max-height: 58vh;\n  overflow: auto;\n}\n.detail-status {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  font-size: 3vh;\n}\n.font-C {\n  color: #3bb57a;\n}\n.font-D {\n  color: #f55753;\n}\n.font-N {\n  color: #56a9c1;\n}\n.font-A {\n  color: #fdbd39;\n}\n#tab-details-id {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n", "", {"version":3,"sources":["/./client/components/modals/gridDetailsModal/tabDetails/TabDetails.vue?503bf24a"],"names":[],"mappings":";AA+DA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,2BAAA;MAAA,uBAAA;EACA,uBAAA;MAAA,+BAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;CACA","file":"TabDetails.vue","sourcesContent":["<template src='./tabDetails.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'TabDetails',\n\n  props: {\n    idModal: {\n      type: String\n    },\n    establishtmentValue: {\n      type: Object\n    },\n    mainValuesList: {\n      type: Array,\n      required: true\n    },\n    statusValuesList: {\n      type: Array\n    },\n    monetaryValuesList: {\n      type: Array,\n      required: true\n    },\n    commentary: {\n      type: Object\n    }\n  },\n\n  methods: {\n    closeModal () {\n      $('#' + this.idModal).modal('hide')\n    },\n\n    getStatusValueClass (item) {\n      let title = ''\n      switch (item.value) {\n        case 'C':\n          title = 'detail-status font-C'\n          break\n        case 'M':\n          title = 'detail-status font-C'\n          break\n        case 'D':\n          title = 'detail-status font-D'\n          break\n        case 'N':\n          title = 'detail-status font-N'\n          break\n        case 'A':\n          title = 'detail-status font-A'\n          break\n        default :\n          title = 'detail-value'\n          break\n      }\n      return title\n    }\n  }\n}\n</script>\n\n<style lang='css'>\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n\n.tab-detail-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #17375f;\n  font-size: 15px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n\n.detail-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  margin-top: 1vh;\n  color: #17375f;\n}\n\n#main-detail-container.main-container {\n  max-height: 58vh;\n  overflow: auto;\n}\n\n.detail-status {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  font-size: 3vh;\n}\n\n.font-C {\n  color: #3bb57a;\n}\n\n.font-D {\n  color: #f55753;\n}\n\n.font-N {\n  color: #56a9c1;\n}\n\n.font-A {\n  color: #fdbd39;\n}\n\n#tab-details-id {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1035 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0d6d05cc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/headerBar/HeaderBar.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.headerBar-title-wrapper[data-v-0d6d05cc] {\n  font-family: 'Inter', sans-serif;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #d0d0d0;\n}\nh1.primary-title[data-v-0d6d05cc] {\n  font-size: 2em;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: transparent;\n}\nh4.subtitle-headerBar[data-v-0d6d05cc] {\n  margin-top: 23px;\n  color: #1d436a;\n}\n.fields-wrapper[data-v-0d6d05cc] {\n  margin-bottom: 5px;\n}\n", "", {"version":3,"sources":["/./client/components/layout/headerBar/HeaderBar.vue?029f9374"],"names":[],"mappings":";AAcA;EACA,iCAAA;EACA,oBAAA;EACA,iCAAA;CACA;AAEA;EACA,eAAA;EACA,iCAAA;AACA,iBAAA;EACA,mBAAA;CACA;AAEA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,mBAAA;CACA","file":"HeaderBar.vue","sourcesContent":["<template src='./headerBar.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'HeaderBar',\n\n  props: [\n    'title',\n    'subTitle'\n  ]\n}\n</script>\n\n<style scoped>\n.headerBar-title-wrapper {\n  font-family: 'Inter', sans-serif;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #d0d0d0;\n}\n\nh1.primary-title {\n  font-size: 2em;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: transparent;\n}\n\nh4.subtitle-headerBar {\n  margin-top: 23px;\n  color: #1d436a;\n}\n\n.fields-wrapper {\n  margin-bottom: 5px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1036 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0e4ca9a2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/Allotment.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.bg-selected {\n  background: #1d436a;\n  opacity: 0.3;\n}\n.bg-unselected {\n  background: #fff;\n}\n.select-label {\n  text-transform: initial !important;\n}\n.selector-selected {\n  color: #1d436a;\n  font-weight: bold;\n  margin: 3px!important;\n}\n.selector-unselected {\n  color: #9e9b9b;\n  margin: 3px!important;\n}\n.selector-icon {\n  margin-right: 0.5vw;\n}\n.padded-table {\n  padding-left: 10px !important;\n}\n", "", {"version":3,"sources":["/./client/components/reports/manualConciliation/Allotment.vue?39c60a8a"],"names":[],"mappings":";AA+CA;EACA,oBAAA;EACA,aAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,mCAAA;CACA;AAEA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;CACA;AAEA;EACA,eAAA;EACA,sBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,8BAAA;CACA","file":"Allotment.vue","sourcesContent":["<template src=\"./allotment.pug\" lang=\"pug\"></template>\n\n<script>\nimport TreeGrid from '../../treeGrid/TreeGrid'\nimport { EXPORT_TREEGRID } from '../../../../build/jsonToExcel/exportRoutes.js'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\n\nexport default {\n  name: 'Allotment',\n\n  components: {\n    TreeGrid\n  },\n\n  props: {\n    showTreegridLot: {\n      type: Boolean,\n      required: false\n    },\n    resultLot: {\n      type: Object,\n      required: true\n    },\n    treeGridCfgLot: {\n      type: Object,\n      required: false\n    }\n  },\n\n  data () {\n    return {\n      exportUrl: EXPORT_TREEGRID\n    }\n  },\n\n  beforeUpdate () {\n    if (document.querySelector(\"[aria-controls='#tab-lotes']\")) {\n      document.querySelector(\"[aria-controls='#tab-lotes']\")\n        .addEventListener('click', () => {\n          trackAnalyticsEvent(this, 'conciliacao-manual', 'click-mudar-de-aba', 'tab-lotes')\n        })\n    }\n  }\n}\n</script>\n\n<style>\n.bg-selected {\n  background: #1d436a;\n  opacity: 0.3;\n}\n\n.bg-unselected {\n  background: #fff;\n}\n\n.select-label {\n  text-transform: initial !important;\n}\n\n.selector-selected {\n  color: #1d436a;\n  font-weight: bold;\n  margin: 3px!important;\n}\n\n.selector-unselected {\n  color: #9e9b9b;\n  margin: 3px!important;\n}\n\n.selector-icon {\n  margin-right: 0.5vw;\n}\n\n.padded-table {\n  padding-left: 10px !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1037 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-103c15fc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\nbody {\n  font-family: 'Inter', sans-serif;\n  opacity: 1;\n  transition: 1s opacity;\n  margin: 0;\n}\nbody.fade-out {\n  opacity: 0;\n  transition: none;\n}\np,\ninput {\n  font-family: 'Inter', sans-serif !important;\n}\n.pace-activity {\n  display: none !important;\n}\n.form-group label {\n  font-family: 'Inter', sans-serif !important;\n}\n.v-select input,\n.dropdown-toggle {\n  font-family: 'Inter', sans-serif;\n  background: #fff;\n}\n.v-select input,\n.dropdown-toggle > span {\n  font-size: 14px;\n  color: #555;\n}\n.v-select.is-danger {\n  border: 1px solid #ff3860;\n  border-radius: 4px;\n}\n.v-select input[type=\"search\"],\n.v-select input[type=\"search\"]:focus {\n  color: #555;\n}\n.v-select .selected-tag {\n  color: #555;\n}\n.page-content-wrapper {\n  padding-top: 35px;\n}\n.is-danger {\n  border-color: #ff3860;\n}\n.is-danger input {\n  border-color: #ff3860;\n}\n.is-danger .dropdown-toggle {\n  border-color: #ff3860 !important;\n}\n.form-control.is-danger {\n  border-color: #ff3860;\n}\n.vue-input-tag-wrapper.input.is-danger {\n  border-color: #ff3860;\n}\n.help.is-danger {\n  color: #ff3860 !important;\n}\n.help.is-warning {\n  color: #f7ae45;\n  font-weight: bold;\n}\n.help {\n  display: block;\n  font-size: 11px;\n  margin-top: 5px;\n}\n.row-filter-small {\n  margin-top: 10px;\n}\n.row-filter-medium {\n  margin-top: 20px;\n}\n.row-filter-big {\n  margin-top: 30px;\n}\n\n/*\nCSS Datatable. TODO: Separar em um arquivo\n*/\n.table-bordered>tbody>tr>td {\n  vertical-align: middle\n}\n.custom-data-table .table-responsive {\n  border-radius: 10px !important;\n}\n.custom-data-table {\n  font-family: 'Inter', sans-serif !important;\n}\n.custom-data-table .table-bordered {\n  border: 1px solid #dddddd;\n}\n.custom-data-table thead:first-child {\n  background-color: #1c3b60;\n  color: #ffffff !important;\n  font-weight: bold;\n}\n.VueTables__filters-row {\n  background-color: white;\n}\n.VueTables__filters-row > th {\n  padding: 0 !important;\n  border-bottom: none !important;\n}\n.VueTables__filters-row > th input{\n  transition: all linear 0.1s;\n  border: none;\n  background: url(" + __webpack_require__(/*! ../../assets/vue-tables-2/lupa.png */ 1246) + ") no-repeat;\n  background-position: calc(100% - 10px) center;\n  background-size: 15px;\n  padding: 7px 40px 5px 7px;\n  vertical-align: middle;\n  line-height: 100%;\n  min-height: 15px;\n  height: 100%;\n  box-shadow: unset;\n}\n.VueTables__filters-row > th input:focus {\n  transition: all linear 0.1s;\n  font-weight: bold;\n  border: none;\n  background: url(" + __webpack_require__(/*! ../../assets/vue-tables-2/lupa-active.png */ 1245) + ") no-repeat;\n  background-position: calc(100% - 10px) center;\n  background-size: 18px;\n  box-shadow: unset;\n}\n.custom-data-table tbody>tr {\n  background-color: #ffffff;\n}\n.custom-data-table tbody>tr:hover {\n  background-color: #f3f8fe;\n}\n.custom-data-table .pagination>.active>a {\n  background-color: #1c3b60;\n  border-color: #1c3b60;\n  color: #fff;\n}\n.custom-data-table .pagination>li>a {\n  color: #1c3b60;\n}\n.custom-data-table .pagination>li:first-child>a {\n  color: #1c3b60;\n}\n.custom-data-table .pagination>li:last-child>a {\n  color: #1c3b60;\n}\n.custom-data-table .pagination {\n  margin: 5px 0;\n}\n.VueTables__search {\n  margin-top: 15px;\n}\n.table > tbody > tr > td,\n.table > tbody > tr > th,\n.table > tfoot > tr > td,\n.table > tfoot > tr > th,\n.table > thead > tr > td {\n  padding: 7px 7px 5px 7px !important;\n  vertical-align: middle !important;\n  line-height: 100% !important;\n}\n.VueTables__table > tbody > .VueTables__filters-row > td {\n  padding: 0px !important;\n}\n.VueTables__table > thead > tr:first-child > th {\n  padding: 7px 7px 5px 7px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* Input tag */\n.input-tag {\n  background-color: #f3f8fe !important;\n  border: 1px solid #cccccc !important;\n  color: #1c3b60 !important;\n}\n.vue-input-tag-wrapper {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  max-height: 96px;\n  overflow-y: auto !important;\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  min-height: 36px;\n}\n.control-label {\n  font-family: 'Inter', sans-serif;\n  text-transform: initial !important;\n  color: #515151;\n  font-weight: normal !important;\n  font-size: 14px !important;\n  margin-top: 10px;\n}\n.label-export {\n  margin-top:1px;\n  margin-left:5px;\n}\n.export-file {\n  padding-top:17px;\n  margin-right:30px;\n}\n.optional-label {\n  color: #999999;\n  font-style: italic;\n  margin-left: 10px;\n}\n.required-label {\n  color: #e60000;\n  margin-left: 2px;\n}\n.checkbox label::after {\n  top: -1px!important;\n  left: 2.2px!important;\n  font-size:10px!important;\n}\n.checkbox label:before {\n  top: 2px!important;\n}\n.checkbox input[type=\"checkbox\"]:checked + label::before {\n  border-width: 7.6px!important;\n}\n.checkbox label:before {\n  width: 14px!important;\n  height: 14px!important;\n}\n.radio label:before {\n  width: 14px!important;\n  height: 14px!important;\n  bottom: 0px;\n  top: 2.3px;\n}\n.radio label, .checkbox label {\n  padding-left: 18px !important;\n  margin-right: 25px !important;\n}\nbutton.filter-input-tag {\n  width: 100%;\n  min-width:auto;\n  padding:0px;\n  margin: 0px !important;\n}\n.v-select input[type=search] {\n  height: 34px;\n  display: block!important;\n  border: none!important;\n}\n.vs__selected-options {\n  display: -ms-inline-flexbox!important;\n  display: inline-flex!important;\n  -ms-flex-wrap: nowrap!important;\n      flex-wrap: nowrap!important;\n}\n.dropdown.v-select.open input.form-control {\n  width: auto !important;\n}\n.form-control {\n  min-height: 34px!important;\n}\n.text-left {\n  text-align: left;\n}\n.v-select .dropdown-toggle .clear {\n  display: none;\n}\n.d-flex {\n  display: -ms-flexbox;\n  display: flex;\n}\n.flex-wrap {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.m-0 {\n  margin: 0 !important;\n}\n.mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.ml-0 {\n  margin-left: 0 !important;\n}\n.mr-0 {\n  margin-right: 0 !important;\n}\n.p-0 {\n  padding: 0 !important;\n}\n.px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pl-0 {\n  padding-left: 0 !important;\n}\n.pr-0 {\n  padding-right: 0 !important;\n}\n.m-5 {\n  margin: 5px !important;\n}\n.mx-5 {\n  margin-left: 5px !important;\n  margin-right: 5px !important;\n}\n.my-5 {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n}\n.mt-5 {\n  margin-top: 5px !important;\n}\n.mb-5 {\n  margin-bottom: 5px !important;\n}\n.ml-5 {\n  margin-left: 5px !important;\n}\n.mr-5 {\n  margin-right: 5px !important;\n}\n.p-5 {\n  padding: 5px !important;\n}\n.px-5 {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n.py-5 {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n.pt-5 {\n  padding-top: 5px !important;\n}\n.pb-5 {\n  padding-bottom: 5px !important;\n}\n.pl-5 {\n  padding-left: 5px !important;\n}\n.pr-5 {\n  padding-right: 5px !important;\n}\n", "", {"version":3,"sources":["/./client/components/views/App.vue?6488992a"],"names":[],"mappings":";AA8EA;EACA,iCAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;CACA;AAEA;EACA,WAAA;EACA,iBAAA;CACA;AAEA;;EAEA,4CAAA;CACA;AAEA;EACA,yBAAA;CACA;AAEA;EACA,4CAAA;CACA;AAEA;;EAEA,iCAAA;EACA,iBAAA;CACA;AAEA;;EAEA,gBAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,mBAAA;CACA;AAEA;;EAEA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,iCAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,eAAA;EACA,kBAAA;CACA;AAEA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,iBAAA;CACA;;AAEA;;EAEA;AACA;EACA,sBAAA;CACA;AAEA;EACA,+BAAA;CACA;AAEA;EACA,4CAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;EACA,kBAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,sBAAA;EACA,+BAAA;CACA;AAEA;EACA,4BAAA;EACA,aAAA;EACA,oDAAA;EACA,8CAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;CACA;AAEA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,oDAAA;EACA,8CAAA;EACA,sBAAA;EACA,kBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;EACA,sBAAA;EACA,YAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,cAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;;;;;EAKA,oCAAA;EACA,kCAAA;EACA,6BAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,yBAAA;EACA,oBAAA;EACA,wBAAA;CACA;;AAEA,eAAA;AACA;EACA,qCAAA;EACA,qCAAA;EACA,0BAAA;CACA;AAEA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gCAAA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,mCAAA;EACA,eAAA;EACA,+BAAA;EACA,2BAAA;EACA,iBAAA;CACA;AAEA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,iBAAA;EACA,kBAAA;CACA;AAEA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,eAAA;EACA,iBAAA;CACA;AAEA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,8BAAA;CACA;AAEA;EACA,sBAAA;EACA,uBAAA;CACA;AAEA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;CACA;AAEA;EACA,8BAAA;EACA,8BAAA;CACA;AAEA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;CACA;AAEA;EACA,sCAAA;EAAA,+BAAA;EACA,gCAAA;MAAA,4BAAA;CACA;AAEA;EACA,uBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,cAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;CACA;AAEA;EACA,oBAAA;MAAA,gBAAA;CACA;AAEA;EACA,qBAAA;CACA;AAEA;EACA,0BAAA;EACA,2BAAA;CACA;AAEA;EACA,yBAAA;EACA,4BAAA;CACA;AAEA;EACA,yBAAA;CACA;AAEA;EACA,4BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,2BAAA;EACA,4BAAA;CACA;AAEA;EACA,0BAAA;EACA,6BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,6BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,4BAAA;CACA;AAEA;EACA,uBAAA;CACA;AAEA;EACA,4BAAA;EACA,6BAAA;CACA;AAEA;EACA,2BAAA;EACA,8BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,8BAAA;CACA;AAEA;EACA,4BAAA;CACA;AAEA;EACA,6BAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,6BAAA;EACA,8BAAA;CACA;AAEA;EACA,4BAAA;EACA,+BAAA;CACA;AAEA;EACA,4BAAA;CACA;AAEA;EACA,+BAAA;CACA;AAEA;EACA,6BAAA;CACA;AAEA;EACA,8BAAA;CACA","file":"App.vue","sourcesContent":["<template lang=\"pug\">\n  #app\n    div(v-if='isLoadingFullPage')\n      loading-full-page\n    router-view\n    notification(ref='notification')\n</template>\n\n<script>\nimport LoadingFullPage from '../loading/LoadingFullPage'\nimport Notification from '../notification/Notification'\n\nimport 'reset-css/reset.css'\nimport 'font-awesome/css/font-awesome.css'\nimport '../../template/assets/plugins/jquery-scrollbar/jquery.scrollbar.css'\nimport '../../template/pages/css/pages.css'\nimport 'bootstrap/dist/css/bootstrap.min.css'\nimport '../../assets/fonts/fonts.css'\nimport 'toastr/build/toastr.min.css'\nimport '../../template/assets/plugins/jquery-scrollbar/jquery.scrollbar.min.js'\nimport '../../template/assets/plugins/modernizr.custom.js'\nimport 'bootstrap/dist/js/bootstrap.min.js'\nimport 'bootstrap-vue/dist/bootstrap-vue.css'\nimport 'vue-select/dist/vue-select.css'\nimport PATHS from '../../router/routesMap'\n\nexport default {\n  name: 'App',\n\n  components: {\n    LoadingFullPage,\n    Notification\n  },\n\n  data () {\n    return {\n      intervalRenewToken: null\n    }\n  },\n\n  computed: {\n    isLoadingFullPage () {\n      return this.$store.getters.isLoadingFullPage\n    }\n  },\n\n  mounted () {\n    // Adicionando animação simples para carregamento do body\n    document.body.classList.remove('fade-out')\n    this.$store.dispatch('fullPageLoaded')\n\n    window.addEventListener('storage', event => {\n      if (event.newValue === null) {\n        return\n      }\n\n      switch (event.key) {\n        case 'event-login-start':\n          localStorage.removeItem('event-login-start')\n          break\n        case 'event-login-done':\n        case 'event-client-selected':\n          localStorage.removeItem(event.key)\n          location.href = PATHS.HOME\n          break\n        case 'event-logout':\n          localStorage.removeItem(event.key)\n          location.href = PATHS.BANKING\n          break\n        default:\n          break\n      }\n    })\n  }\n}\n</script>\n\n<style>\nbody {\n  font-family: 'Inter', sans-serif;\n  opacity: 1;\n  transition: 1s opacity;\n  margin: 0;\n}\n\nbody.fade-out {\n  opacity: 0;\n  transition: none;\n}\n\np,\ninput {\n  font-family: 'Inter', sans-serif !important;\n}\n\n.pace-activity {\n  display: none !important;\n}\n\n.form-group label {\n  font-family: 'Inter', sans-serif !important;\n}\n\n.v-select input,\n.dropdown-toggle {\n  font-family: 'Inter', sans-serif;\n  background: #fff;\n}\n\n.v-select input,\n.dropdown-toggle > span {\n  font-size: 14px;\n  color: #555;\n}\n\n.v-select.is-danger {\n  border: 1px solid #ff3860;\n  border-radius: 4px;\n}\n\n.v-select input[type=\"search\"],\n.v-select input[type=\"search\"]:focus {\n  color: #555;\n}\n\n.v-select .selected-tag {\n  color: #555;\n}\n\n.page-content-wrapper {\n  padding-top: 35px;\n}\n\n.is-danger {\n  border-color: #ff3860;\n}\n\n.is-danger input {\n  border-color: #ff3860;\n}\n\n.is-danger .dropdown-toggle {\n  border-color: #ff3860 !important;\n}\n\n.form-control.is-danger {\n  border-color: #ff3860;\n}\n\n.vue-input-tag-wrapper.input.is-danger {\n  border-color: #ff3860;\n}\n\n.help.is-danger {\n  color: #ff3860 !important;\n}\n\n.help.is-warning {\n  color: #f7ae45;\n  font-weight: bold;\n}\n\n.help {\n  display: block;\n  font-size: 11px;\n  margin-top: 5px;\n}\n\n.row-filter-small {\n  margin-top: 10px;\n}\n\n.row-filter-medium {\n  margin-top: 20px;\n}\n\n.row-filter-big {\n  margin-top: 30px;\n}\n\n/*\nCSS Datatable. TODO: Separar em um arquivo\n*/\n.table-bordered>tbody>tr>td {\n  vertical-align: middle\n}\n\n.custom-data-table .table-responsive {\n  border-radius: 10px !important;\n}\n\n.custom-data-table {\n  font-family: 'Inter', sans-serif !important;\n}\n\n.custom-data-table .table-bordered {\n  border: 1px solid #dddddd;\n}\n\n.custom-data-table thead:first-child {\n  background-color: #1c3b60;\n  color: #ffffff !important;\n  font-weight: bold;\n}\n\n.VueTables__filters-row {\n  background-color: white;\n}\n\n.VueTables__filters-row > th {\n  padding: 0 !important;\n  border-bottom: none !important;\n}\n\n.VueTables__filters-row > th input{\n  transition: all linear 0.1s;\n  border: none;\n  background: url('../../assets/vue-tables-2/lupa.png') no-repeat;\n  background-position: calc(100% - 10px) center;\n  background-size: 15px;\n  padding: 7px 40px 5px 7px;\n  vertical-align: middle;\n  line-height: 100%;\n  min-height: 15px;\n  height: 100%;\n  box-shadow: unset;\n}\n\n.VueTables__filters-row > th input:focus {\n  transition: all linear 0.1s;\n  font-weight: bold;\n  border: none;\n  background: url('../../assets/vue-tables-2/lupa-active.png') no-repeat;\n  background-position: calc(100% - 10px) center;\n  background-size: 18px;\n  box-shadow: unset;\n}\n\n.custom-data-table tbody>tr {\n  background-color: #ffffff;\n}\n\n.custom-data-table tbody>tr:hover {\n  background-color: #f3f8fe;\n}\n\n.custom-data-table .pagination>.active>a {\n  background-color: #1c3b60;\n  border-color: #1c3b60;\n  color: #fff;\n}\n\n.custom-data-table .pagination>li>a {\n  color: #1c3b60;\n}\n\n.custom-data-table .pagination>li:first-child>a {\n  color: #1c3b60;\n}\n\n.custom-data-table .pagination>li:last-child>a {\n  color: #1c3b60;\n}\n\n.custom-data-table .pagination {\n  margin: 5px 0;\n}\n\n.VueTables__search {\n  margin-top: 15px;\n}\n\n.table > tbody > tr > td,\n.table > tbody > tr > th,\n.table > tfoot > tr > td,\n.table > tfoot > tr > th,\n.table > thead > tr > td {\n  padding: 7px 7px 5px 7px !important;\n  vertical-align: middle !important;\n  line-height: 100% !important;\n}\n\n.VueTables__table > tbody > .VueTables__filters-row > td {\n  padding: 0px !important;\n}\n\n.VueTables__table > thead > tr:first-child > th {\n  padding: 7px 7px 5px 7px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* Input tag */\n.input-tag {\n  background-color: #f3f8fe !important;\n  border: 1px solid #cccccc !important;\n  color: #1c3b60 !important;\n}\n\n.vue-input-tag-wrapper {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  max-height: 96px;\n  overflow-y: auto !important;\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  min-height: 36px;\n}\n\n.control-label {\n  font-family: 'Inter', sans-serif;\n  text-transform: initial !important;\n  color: #515151;\n  font-weight: normal !important;\n  font-size: 14px !important;\n  margin-top: 10px;\n}\n\n.label-export {\n  margin-top:1px;\n  margin-left:5px;\n}\n\n.export-file {\n  padding-top:17px;\n  margin-right:30px;\n}\n\n.optional-label {\n  color: #999999;\n  font-style: italic;\n  margin-left: 10px;\n}\n\n.required-label {\n  color: #e60000;\n  margin-left: 2px;\n}\n\n.checkbox label::after {\n  top: -1px!important;\n  left: 2.2px!important;\n  font-size:10px!important;\n}\n\n.checkbox label:before {\n  top: 2px!important;\n}\n\n.checkbox input[type=\"checkbox\"]:checked + label::before {\n  border-width: 7.6px!important;\n}\n\n.checkbox label:before {\n  width: 14px!important;\n  height: 14px!important;\n}\n\n.radio label:before {\n  width: 14px!important;\n  height: 14px!important;\n  bottom: 0px;\n  top: 2.3px;\n}\n\n.radio label, .checkbox label {\n  padding-left: 18px !important;\n  margin-right: 25px !important;\n}\n\nbutton.filter-input-tag {\n  width: 100%;\n  min-width:auto;\n  padding:0px;\n  margin: 0px !important;\n}\n\n.v-select input[type=search] {\n  height: 34px;\n  display: block!important;\n  border: none!important;\n}\n\n.vs__selected-options {\n  display: inline-flex!important;\n  flex-wrap: nowrap!important;\n}\n\n.dropdown.v-select.open input.form-control {\n  width: auto !important;\n}\n\n.form-control {\n  min-height: 34px!important;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.v-select .dropdown-toggle .clear {\n  display: none;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0 {\n  margin-left: 0 !important;\n}\n\n.mr-0 {\n  margin-right: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0 {\n  padding-left: 0 !important;\n}\n\n.pr-0 {\n  padding-right: 0 !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.mx-5 {\n  margin-left: 5px !important;\n  margin-right: 5px !important;\n}\n\n.my-5 {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n}\n\n.mt-5 {\n  margin-top: 5px !important;\n}\n\n.mb-5 {\n  margin-bottom: 5px !important;\n}\n\n.ml-5 {\n  margin-left: 5px !important;\n}\n\n.mr-5 {\n  margin-right: 5px !important;\n}\n\n.p-5 {\n  padding: 5px !important;\n}\n\n.px-5 {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.py-5 {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n}\n\n.pt-5 {\n  padding-top: 5px !important;\n}\n\n.pb-5 {\n  padding-bottom: 5px !important;\n}\n\n.pl-5 {\n  padding-left: 5px !important;\n}\n\n.pr-5 {\n  padding-right: 5px !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1038 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-13215916","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/modal/Modal.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.concil-modal-header {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  border-bottom: 2px solid #d0d0d0;\n  padding: 0 15px;\n}\n.concil-modal-header h1 {\n  font-size: 2em;\n  margin-top: 15px;\n  margin-bottom: 0px;\n}\n.concil-modal-header h4 {\n  margin-top: 5px;\n  margin-left: 2px;\n  margin-bottom: 10px;\n}\n.concil-modal-header button {\n  color: #b1b1b1;\n  margin: 5px 10px 0px 0px !important;\n  font-size: 40px;\n  opacity: 1 !important;\n}\n.concil-modal-header button:hover {\n  color: #1b3c65;\n}\n\n/*Template*/\n.modal-footer {\n  padding: 15px !important;\n}\n.modal-new-attribute {\n  width: 850px;\n}\n.modal-new-attribute.modal-dialog {\n  -ms-transform: none !important;\n      transform: none !important;\n}\n", "", {"version":3,"sources":["/./client/components/modals/modal/Modal.vue?de99bfb0"],"names":[],"mappings":";AA+BA;EACA,iCAAA;AACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;CACA;AAEA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;CACA;AAEA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;CACA;AAEA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,sBAAA;CACA;AAEA;EACA,eAAA;CACA;;AAEA,YAAA;AACA;EACA,yBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,+BAAA;MAAA,2BAAA;CACA","file":"Modal.vue","sourcesContent":["<template src='./modal.pug' lang='pug'></template>\n\n<script>\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\n\nexport default {\n  name: 'Modal',\n\n  props: {\n    bodyClass: {\n      Type: String,\n      default: 'modal-body'\n    },\n    id: {},\n    size: {},\n    closable: {},\n    closeFunction: {}\n  },\n\n  methods: {\n    trackEvent () {\n      trackAnalyticsEvent(this, 'close-modal', 'titlebar-close-modal-click', this.id)\n      if (this.closeFunction) {\n        this.closeFunction()\n      }\n    }\n  }\n}\n</script>\n\n<style>\n.concil-modal-header {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  border-bottom: 2px solid #d0d0d0;\n  padding: 0 15px;\n}\n\n.concil-modal-header h1 {\n  font-size: 2em;\n  margin-top: 15px;\n  margin-bottom: 0px;\n}\n\n.concil-modal-header h4 {\n  margin-top: 5px;\n  margin-left: 2px;\n  margin-bottom: 10px;\n}\n\n.concil-modal-header button {\n  color: #b1b1b1;\n  margin: 5px 10px 0px 0px !important;\n  font-size: 40px;\n  opacity: 1 !important;\n}\n\n.concil-modal-header button:hover {\n  color: #1b3c65;\n}\n\n/*Template*/\n.modal-footer {\n  padding: 15px !important;\n}\n\n.modal-new-attribute {\n  width: 850px;\n}\n\n.modal-new-attribute.modal-dialog {\n  transform: none !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1039 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-15fd6674","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/input/dynamicInput/DynamicInput.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.datepicker-input[data-v-15fd6674] {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 5px;\n  display: inline;\n  margin-left: 10px;\n}\n.datepicker-wrapper[data-v-15fd6674] {\n  display: inline !important;\n}\n.datepicker-wrapper div[data-v-15fd6674]:first-child {\n  display: inline !important;\n}\n.wrapperClass div[data-v-15fd6674]:first-child {\n  display: inline !important;\n}\n.wrapperClass[data-v-15fd6674] {\n  display: inline !important;\n}\n\n/* DatePicker*/\n.date-picker-dynamic[data-v-15fd6674] {\n  border: none;\n  height: 100%;\n  width: 30%;\n}\n.vdp-datepicker[data-v-15fd6674] {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 3px 8px;\n  margin-right: 10px;\n}\n.vdp-datepicker-margin-top[data-v-15fd6674] {\n  margin-top: 10px;\n}\n.second-date-picker[data-v-15fd6674] {\n  margin-left: 10px;\n}\n.second-date-picker .vdp-datepicker__calendar[data-v-15fd6674] {\n  margin-left: 180px;\n}\n.vdp-datepicker__calendar[data-v-15fd6674] {\n  padding: 5px;\n}\n.vdp-datepicker__calendar header span[data-v-15fd6674] {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n}\n.vdp-datepicker__calendar .cell[data-v-15fd6674] {\n  height: 35px !important;\n  line-height: 35px !important;\n}\n.vdp-datepicker__calendar .cell.day-header[data-v-15fd6674] {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #8c8c8c;\n  height: 35px;\n  line-height: 35px;\n}\n.vdp-datepicker__calendar .cell.selected[data-v-15fd6674],\n.vdp-datepicker__calendar .cell.selected.highlighted[data-v-15fd6674],\n.vdp-datepicker__calendar .cell.selected[data-v-15fd6674]:hover {\n  background: #40b9bb !important;\n  color: #fff !important;\n  border-radius: 5px;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day[data-v-15fd6674]:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month[data-v-15fd6674]:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year[data-v-15fd6674]:hover {\n  border: 1px solid #40b9bb !important;\n  border-radius: 5px;\n}\n.vdp-datepicker__calendar .disabled[data-v-15fd6674] {\n  color: #8c8c8c !important;\n}\n.vdp-datepicker__calendar .cell.today[data-v-15fd6674] {\n  background-image: url(" + __webpack_require__(/*! ../../../assets/icones_app/today-signal.png */ 680) + ") !important;\n  background-repeat: no-repeat !important;\n  background-position: 30px 20px !important;\n}\n.vdp-datepicker__calendar[data-v-15fd6674] {\n  z-index: 3!important;\n}\n.is-danger-dynamic[data-v-15fd6674] {\n  border-color: #ff3860 !important;\n}\n", "", {"version":3,"sources":["/./client/components/input/dynamicInput/DynamicInput.vue?63ef4584"],"names":[],"mappings":";AAsKA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,2BAAA;CACA;;AAEA,eAAA;AACA;EACA,aAAA;EACA,aAAA;EACA,WAAA;CACA;AAEA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;CACA;AAEA;EACA,wBAAA;EACA,6BAAA;CACA;AAEA;EACA,iCAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;CACA;AAEA;;;EAGA,+BAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;;;EAGA,qCAAA;EACA,mBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,2DAAA;EACA,wCAAA;EACA,0CAAA;CACA;AAEA;EACA,qBAAA;CACA;AACA;EACA,iCAAA;CACA","file":"DynamicInput.vue","sourcesContent":["<template src='./dynamicInput.pug' lang=\"pug\"></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport { TheMask } from 'vue-the-mask'\nimport Datepicker from 'vuejs-datepicker'\nimport idioma from '../../../../build/language/index'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\n\nexport default {\n  name: 'DynamicInput',\n\n  components: {\n    vSelect,\n    TheMask,\n    Datepicker\n  },\n\n  props: {\n    // representa o label do input\n    inputName: {\n      type: String,\n      required: true\n    },\n    // representa a TAG unica para o input, para fins de $refs\n    inputTag: {\n      type: String,\n      required: true\n    },\n    // representa o tipo do input\n    inputType: {\n      type: String,\n      required: true\n    },\n    // representa o valor incial do input gerado\n    inputValue: {\n      required: true\n    },\n    // representa a máscara para o input\n    inputMask: {\n      type: String\n    },\n    // representa a máscara para o input\n    inputValidator: {\n      type: String\n    },\n    // representa a máscara para o input\n    inputTipoValores: {\n      type: Array\n    }\n  },\n\n  data () {\n    return {\n      invalid: false,\n      // utilizado para instanciar o locale do datepicker\n      inputMaskModel: null,\n      inputValueSelect: null,\n      // utilizado como model do componente\n      instantValue: null,\n      // referencia o datepicker, quando presente\n      inputDate: null,\n      // campos de validação\n      message: null,\n      toDate: new Date('December 31, 1999 23:59:59'),\n      fromDate: new Date('December 31, 2999 23:59:59')\n    }\n  },\n\n  computed: {\n    // retorna o idioma para o datepicker\n    datePickerLanguage () {\n      return idioma.getDatePickerLanguageObject()\n    },\n    // flag para tipo do input à ser exibido\n    defineInput () {\n      if (this.inputType === 'STRING' && !this.inputMask) {\n        return 1\n      } else if (this.inputType === 'NUMBER' && !this.inputMask) {\n        return 2\n      } else if (this.inputType === 'DATE') {\n        return 3\n      } else if (this.inputType === 'COMBO') {\n        return 4\n      } else {\n        return 0\n      }\n    },\n\n    defineId () {\n      if (this.inputType === 'STRING' && !this.inputMask) {\n        return 'dynamicInputItem' + this.inputTag\n      } else if (this.inputType === 'NUMBER' && !this.inputMask) {\n        return 'dynamicInputNumberItem' + this.inputTag\n      } else if (this.inputType === 'DATE') {\n        return 'dynamicPickerDate' + this.inputTag\n      } else if (this.inputType === 'COMBO') {\n        return 'dynamicSelectItem' + this.inputTag\n      } else {\n        return 'dynamicMaskedItem' + this.inputTag\n      }\n    }\n  },\n\n  methods: {\n    // Evento disparado quando o usuário entra com algum valor em algum dos inputs\n    trackEvent (e) {\n      trackAnalyticsEvent(this, 'dynamic-input', 'on-input-event', e.currentTarget.id)\n    },\n    // validação global do datepicker\n    validateDate () {\n      return this.inputDate !== null\n    },\n\n    isInputInvalid () {\n      if (this.inputValidator && this.inputValue) {\n        let regexp = new RegExp(this.inputValidator)\n        if (!regexp.test(this.inputValue)) {\n          this.message = this.$t('estabelecimentos.erro.atributoValidacaoFail')\n          return true\n        }\n      }\n      this.message = null\n      return false\n    }\n  },\n\n  mounted () {\n    let currentInput = document.getElementById(this.defineId)\n    if (currentInput) {\n      if (this.inputType === 'STRING' || this.inputType === 'NUMBER') {\n        currentInput.addEventListener('blur', () => {\n          this.invalid = this.isInputInvalid()\n          this.$emit('input-invalid', this.invalid)\n        })\n      } else if (this.inputType === 'COMBO') {\n        this.inputValueSelect = this.inputValue ? this.inputValue : this.$t('validacao.select.placeholder')\n      }\n      if (this.defineInput === 0) {\n        this.inputMaskModel = this.inputValue\n      }\n\n      // atribuições dinâmicas para datepicker\n      if (this.inputType === 'DATE') {\n        this.inputDate = this.inputValue || null\n        currentInput.classList.remove('date-picker')\n        currentInput.style.border = 'none'\n        currentInput.style.height = '28px'\n        currentInput.style.width = '90%'\n        currentInput.setAttribute('autocomplete', 'off')\n        currentInput.addEventListener('blur', () => {\n          this.validateDate()\n        })\n      }\n    }\n\n    // Adiciona um valor default em cada select box, que deverá ser setado como null\n    // antes da criação do estabelecimento.\n    if (this.inputTipoValores && this.inputTipoValores.length > 0) {\n      this.inputTipoValores.unshift({ valor: this.$t('validacao.select.placeholder') })\n    }\n  }\n}\n</script>\n\n<style scoped>\n.datepicker-input {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 5px;\n  display: inline;\n  margin-left: 10px;\n}\n\n.datepicker-wrapper {\n  display: inline !important;\n}\n\n.datepicker-wrapper div:first-child {\n  display: inline !important;\n}\n\n.wrapperClass div:first-child {\n  display: inline !important;\n}\n\n.wrapperClass {\n  display: inline !important;\n}\n\n/* DatePicker*/\n.date-picker-dynamic {\n  border: none;\n  height: 100%;\n  width: 30%;\n}\n\n.vdp-datepicker {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 3px 8px;\n  margin-right: 10px;\n}\n\n.vdp-datepicker-margin-top {\n  margin-top: 10px;\n}\n\n.second-date-picker {\n  margin-left: 10px;\n}\n\n.second-date-picker .vdp-datepicker__calendar {\n  margin-left: 180px;\n}\n\n.vdp-datepicker__calendar {\n  padding: 5px;\n}\n\n.vdp-datepicker__calendar header span {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n}\n\n.vdp-datepicker__calendar .cell {\n  height: 35px !important;\n  line-height: 35px !important;\n}\n\n.vdp-datepicker__calendar .cell.day-header {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #8c8c8c;\n  height: 35px;\n  line-height: 35px;\n}\n\n.vdp-datepicker__calendar .cell.selected,\n.vdp-datepicker__calendar .cell.selected.highlighted,\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #40b9bb !important;\n  color: #fff !important;\n  border-radius: 5px;\n}\n\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #40b9bb !important;\n  border-radius: 5px;\n}\n\n.vdp-datepicker__calendar .disabled {\n  color: #8c8c8c !important;\n}\n\n.vdp-datepicker__calendar .cell.today {\n  background-image: url('../../../assets/icones_app/today-signal.png') !important;\n  background-repeat: no-repeat !important;\n  background-position: 30px 20px !important;\n}\n\n.vdp-datepicker__calendar {\n  z-index: 3!important;\n}\n.is-danger-dynamic {\n  border-color: #ff3860 !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1040 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-169f7ba6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/input/betterInputTag/BetterInputTag.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.better-input-tag[data-v-169f7ba6] {\n  background: white;\n  min-height: 36px;\n  border: 1px solid #ccc;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: left;\n      align-items: left;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n.better-input-tag.possibilities-list-closed[data-v-169f7ba6] {\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n.better-input-tag.possibilities-list-open[data-v-169f7ba6] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.full-radius[data-v-169f7ba6] {\n  border-radius: 5px;\n}\n.better-input-tag > input[data-v-169f7ba6] {\n  outline: 0;\n  border: 0;\n  background: transparent;\n  font-size: 13px;\n  margin: 5px;\n  min-width: 55px;\n}\n.better-input-tag > span[data-v-169f7ba6] {\n  border-radius: 2px;\n  color: #1c3b60;\n  border: 1px solid #ccc;\n  background-color: #f3f8fe;\n  text-align: center;\n  margin: 5px 0 5px 5px;\n  line-height: 20px;\n}\n.better-input-tag > span > a[data-v-169f7ba6] {\n  text-decoration: none;\n  color: #1c3b60;\n  font-size: 10px;\n  font-weight: bold;\n  padding: 7px;\n  height: 10px;\n  vertical-align: top;\n}\n.better-input-tag > .full-padding[data-v-169f7ba6] {\n  padding: 0 5px 0 5px;\n}\n.better-input-tag > .left-padding[data-v-169f7ba6] {\n  padding-left: 5px;\n}\n.possibilities-list[data-v-169f7ba6] {\n  margin-left: -1px;\n  cursor: pointer;\n  position: absolute;\n  background-color: #ffffff;\n  z-index: 900;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border: 1px solid #ccc;\n  max-height: 300px;\n  overflow: auto;\n}\n.possibilities-list > .possibilities-list-item[data-v-169f7ba6] {\n  padding: 10px 10px;\n  color: #444;\n}\n.possibilities-list > .possibilities-list-item.highlighted[data-v-169f7ba6]:not(.blocked) {\n  color: #000;\n  background-color: #eee;\n}\n.disable-input[data-v-169f7ba6] {\n  background-color: #f8f8f8;\n  cursor: default;\n}\n", "", {"version":3,"sources":["/./client/components/input/betterInputTag/BetterInputTag.vue?390d96dc"],"names":[],"mappings":";AAuaA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EAAA,cAAA;EACA,qBAAA;MAAA,kBAAA;EACA,oBAAA;MAAA,gBAAA;EACA,qBAAA;MAAA,4BAAA;CACA;AAEA;EACA,4BAAA;EACA,+BAAA;CACA;AAEA;EACA,0BAAA;EACA,6BAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;CACA;AAEA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;CACA;AAEA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;CACA;AAEA;EACA,qBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,+BAAA;EACA,gCAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;CACA;AAEA;EACA,mBAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;EACA,uBAAA;CACA;AAEA;EACA,0BAAA;EACA,gBAAA;CACA","file":"BetterInputTag.vue","sourcesContent":["<template src='./betterInputTag.pug' lang=\"pug\"></template>\n\n<script>\nimport { debounce as _debounce } from '../../../utils/helpers'\nimport KeyCodeEnum from '../../../enum/keyCode'\n\nexport default {\n  name: 'BetterInputTag',\n\n  props: {\n    defaultTagsIfEmpty: {\n      type: Array,\n      default: () => []\n    },\n    typeable: {\n      type: Boolean,\n      default: true\n    },\n    readOnly: {\n      type: Boolean,\n      default: false\n    },\n    tags: {\n      type: Array,\n      default: () => []\n    },\n    props: {\n      type: Object,\n      default: () => ({\n        id: 'id',\n        name: 'name'\n      })\n    },\n    typeOnly: {\n      type: Boolean,\n      default: false\n    },\n    typeOnlyOptions: {\n      type: Object,\n      default: () => ({})\n    },\n    fnGetDataFromServer: {\n      type: Function,\n      default: async () => Promise.resolve([])\n    },\n    possibleTagsSearchTexts: {\n      type: Object,\n      default: () => ({\n        noResult: 'geral.labels.semResultadosSingular',\n        empty: 'geral.labels.listaVazia'\n      })\n    },\n    placeHolders: {\n      type: Object,\n      default: () => ({\n        input: 'estabelecimentos.labels.filtro.buscar'\n      })\n    },\n    disableInput: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      eventTypes: {\n        SEARCH: 0,\n        TYPE_TO_START_SEARCHING: 1,\n        NOOP: 2,\n        SHOW_EMPTY_LIST: 3\n      },\n      currentMaxWidth: 80,\n      tag: '',\n      input: null,\n      inputExists: this.typeable && !this.readOnly,\n      paddingClass: this.readOnly || !this.disableInput ? 'full-padding' : 'left-padding',\n      showingPossibilities: false,\n      highlightedIndex: 0,\n      possibilities: [],\n      selectedEveryThing: false,\n      debounce: _debounce.apply(this)\n    }\n  },\n\n  computed: {\n    expandedMenu () {\n      return this.$store.getters.expandedMenu\n    }\n  },\n\n  watch: {\n    tags: {\n      handler () {\n        this.resetInputWidth()\n      },\n      deep: true\n    },\n    expandedMenu () {\n      this.resetInputWidth(200)\n    }\n  },\n\n  methods: {\n    boxClicked ({ target }) {\n      if (!this.inputExists) {\n        return\n      }\n\n      const inputs = target.getElementsByTagName('input')\n      let input = null\n\n      if (inputs !== null) {\n        input = inputs[0]\n      }\n\n      if (this.input === null && input !== null) {\n        this.input = input\n      }\n\n      this.input.focus()\n    },\n\n    handleKey (evt) {\n      if (!this.inputExists) {\n        return\n      }\n\n      if (this.typeOnly) {\n        this.handleTypeOnly(evt)\n        return\n      }\n\n      const nextEvent = this.handleInteraction(evt)\n\n      if (nextEvent === this.eventTypes.SEARCH) {\n        this.handleDataFromServer()\n      } else if (nextEvent === this.eventTypes.TYPE_TO_START_SEARCHING) {\n        this.possibilities = this.getStartToType()\n      } else if (nextEvent === this.eventTypes.SHOW_EMPTY_LIST) {\n        this.possibilities = this.getEmptyList()\n      }\n    },\n\n    handleTypeOnly (evt) {\n      const tag = {\n        [this.props.name]: this.tag,\n        [this.props.id]: this.tag\n      }\n\n      if (this.tag) {\n        let toAdd = false\n        if ([KeyCodeEnum.TAB, KeyCodeEnum.ENTER, KeyCodeEnum.BACKSPACE].includes(evt.keyCode)) {\n          toAdd = true\n        } else if (this.typeOnlyOptions.isNumericOnly && evt.keyCode === KeyCodeEnum.SPACE_BAR) {\n          toAdd = true\n        }\n\n        if (toAdd) {\n          evt.preventDefault()\n          this.addTag(tag)\n          this.input.focus()\n        }\n      } else if (!this.tag && evt.keyCode === KeyCodeEnum.BACKSPACE) {\n        this.removeTag(this.tags.length - 1)\n      }\n    },\n\n    getStartToType () {\n      return [{\n        [this.props.name]: this.$t('geral.labels.digiteParaPesquisar'),\n        __blocked: true\n      }]\n    },\n\n    handleDataFromServer () {\n      if (!this.tag) {\n        this.possibilities = this.getStartToType()\n        return\n      }\n\n      this.possibilities = [{\n        [this.props.name]: this.$t('geral.labels.carregando'),\n        __blocked: true\n      }]\n\n      this.showPossibilities()\n\n      this.debounce(this.getDataFromServer, 250)\n    },\n\n    getDataFromServer () {\n      if (this.typeOnly) {\n        return\n      }\n      this.fnGetDataFromServer(this.tag, this.tags)\n        .then(response => {\n          if (response.length === 0) {\n            this.possibilities = this.getEmptyList()\n          } else {\n            this.highlightedIndex = 0\n            this.possibilities = response\n          }\n          this.updateListOfPossibilitiesMargin()\n        })\n        .catch(e => {\n          if (e.message !== 'user.cancelled') {\n            this.$root.$refs.notification.error(e.message)\n          }\n        })\n    },\n\n    handleInteraction (evt) {\n      if (evt.keyCode === KeyCodeEnum.BACKSPACE) {\n        if (!this.tag) {\n          this.removeTag(this.tags.length - 1)\n          return this.eventTypes.TYPE_TO_START_SEARCHING\n        }\n\n        if (this.selectedEveryThing) {\n          this.selectedEveryThing = false\n          return this.eventTypes.TYPE_TO_START_SEARCHING\n        }\n\n        evt.preventDefault()\n\n        if (evt.ctrlKey) {\n          this.tag = ''\n          return this.eventTypes.TYPE_TO_START_SEARCHING\n        }\n\n        this.tag = this.tag.substring(0, this.tag.length - 1)\n        return this.eventTypes.SEARCH\n      }\n\n      if (evt.ctrlKey) {\n        if (evt.keyCode === KeyCodeEnum.A) {\n          this.selectedEveryThing = true\n        }\n        return this.eventTypes.NOOP\n      }\n\n      evt.preventDefault()\n\n      if (evt.key.length === 1) {\n        if (this.selectedEveryThing) {\n          this.tag = evt.key\n        } else {\n          this.tag += evt.key\n        }\n        this.selectedEveryThing = false\n        return this.eventTypes.SEARCH\n      }\n\n      this.selectedEveryThing = false\n\n      if (evt.keyCode === KeyCodeEnum.ENTER) {\n        this.addTag(this.possibilities[this.highlightedIndex])\n        return this.eventTypes.TYPE_TO_START_SEARCHING\n      }\n\n      if ([KeyCodeEnum.ARROW_UP, KeyCodeEnum.ARROW_DOWN].includes(evt.keyCode)) {\n        this.highlightedIndex += evt.keyCode === KeyCodeEnum.ARROW_UP ? -1 : 1\n\n        if (this.highlightedIndex < 0) {\n          this.highlightedIndex = 0\n        } else if (this.possibilities.length === 1 && this.possibilities[0].__blocked) {\n          this.highlightedIndex = -1\n        } else if (this.highlightedIndex >= this.possibilities.length) {\n          this.highlightedIndex = this.possibilities.length - 1\n        }\n        return this.eventTypes.NOOP\n      }\n      return this.eventTypes.SEARCH\n    },\n\n    handleMouse (tag, index) {\n      if (!tag.__blocked) {\n        this.highlightedIndex = index\n      }\n    },\n\n    addTag (tag) {\n      if (!tag) {\n        return\n      }\n\n      if (tag.__blocked) {\n        this.possibilities = this.getStartToType()\n        return\n      }\n\n      this.showingPossibilities = false\n\n      this.input.blur()\n\n      let index = -1\n      if (this.typeOnly) {\n        index = this.tags.findIndex(added => added[this.props.id] === tag[this.props.id])\n      } else {\n        index = this.tags.lastIndexOf(tag)\n      }\n\n      if (index === -1) {\n        if (!this.validateTypeOnly(tag[this.props.name])) {\n          return\n        }\n        this.possibilities = []\n        this.tags.push(tag)\n        this.highlightedIndex = -1\n      }\n      this.$emit('update:tags', this.tags)\n    },\n\n    removeTag (index) {\n      this.tags.splice(index, 1)\n      this.$emit('update:tags', this.tags)\n      this.tag = ''\n      this.possibilities = []\n    },\n\n    validateTypeOnly (value) {\n      if (this.typeOnlyOptions.isNumericOnly) {\n        return /^\\d+$/.test(value)\n      }\n      return true\n    },\n\n    resetInputWidth (delay = 0) {\n      if (!this.inputExists) {\n        return\n      }\n      this.input.style.width = '55px'\n      this.$nextTick(() => {\n        setTimeout(() => {\n          const width = (this.input.parentElement.clientWidth - this.input.offsetLeft - 10) + 'px'\n          this.input.style.width = width\n          this.updateListOfPossibilitiesMargin()\n        }, delay)\n      })\n    },\n\n    getEmptyList () {\n      const possibility = {\n        __blocked: true\n      }\n\n      let name\n      if (this.tag) {\n        name = this.$t(this.possibleTagsSearchTexts.noResult)\n      } else {\n        name = this.$t(this.possibleTagsSearchTexts.empty)\n      }\n\n      possibility[this.props.name] = name\n      return [possibility]\n    },\n\n    showPossibilities () {\n      if (this.typeOnly) {\n        return\n      }\n      this.showingPossibilities = true\n      this.$nextTick(() => {\n        if (this.possibilities.length === 0 && this.tag === '') {\n          this.possibilities = this.getStartToType()\n        }\n        this.updateListOfPossibilitiesMargin()\n      })\n    },\n\n    updateListOfPossibilitiesMargin () {\n      const divListOfPossibilities = this.getDivListOfPossibilities()\n\n      if (divListOfPossibilities) {\n        const height = divListOfPossibilities.parentElement.clientHeight\n        divListOfPossibilities.style.marginTop = height + 'px'\n      }\n    },\n\n    getDivListOfPossibilities () {\n      const listDivsListOfPossibilities = this.$el.getElementsByClassName('possibilities-list')\n      let divListOfPossibilities\n      if (listDivsListOfPossibilities) {\n        divListOfPossibilities = listDivsListOfPossibilities[0]\n      }\n      return divListOfPossibilities\n    },\n\n    close () {\n      if (this.typeOnly) {\n        if (this.tag) {\n          this.addTag({\n            [this.props.name]: this.tag,\n            [this.props.id]: this.tag\n          })\n        }\n      } else {\n        this.showingPossibilities = false\n        this.possibilities = this.getStartToType()\n      }\n      this.tag = ''\n    }\n  },\n\n  mounted () {\n    if (!this.inputExists) {\n      return\n    }\n\n    this.input = new XPathEvaluator()\n                    .createExpression('div/input')\n                    .evaluate(this.$el, XPathResult.FIRST_ORDERED_NODE_TYPE)\n                    .singleNodeValue\n\n    window.addEventListener('resize', () => {\n      this.resetInputWidth(200)\n    })\n  }\n}\n</script>\n\n<style scoped>\n.better-input-tag {\n  background: white;\n  min-height: 36px;\n  border: 1px solid #ccc;\n  display: flex;\n  align-items: left;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.better-input-tag.possibilities-list-closed {\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.better-input-tag.possibilities-list-open {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.full-radius {\n  border-radius: 5px;\n}\n\n.better-input-tag > input {\n  outline: 0;\n  border: 0;\n  background: transparent;\n  font-size: 13px;\n  margin: 5px;\n  min-width: 55px;\n}\n\n.better-input-tag > span {\n  border-radius: 2px;\n  color: #1c3b60;\n  border: 1px solid #ccc;\n  background-color: #f3f8fe;\n  text-align: center;\n  margin: 5px 0 5px 5px;\n  line-height: 20px;\n}\n\n.better-input-tag > span > a {\n  text-decoration: none;\n  color: #1c3b60;\n  font-size: 10px;\n  font-weight: bold;\n  padding: 7px;\n  height: 10px;\n  vertical-align: top;\n}\n\n.better-input-tag > .full-padding {\n  padding: 0 5px 0 5px;\n}\n\n.better-input-tag > .left-padding {\n  padding-left: 5px;\n}\n\n.possibilities-list {\n  margin-left: -1px;\n  cursor: pointer;\n  position: absolute;\n  background-color: #ffffff;\n  z-index: 900;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border: 1px solid #ccc;\n  max-height: 300px;\n  overflow: auto;\n}\n\n.possibilities-list > .possibilities-list-item {\n  padding: 10px 10px;\n  color: #444;\n}\n\n.possibilities-list > .possibilities-list-item.highlighted:not(.blocked) {\n  color: #000;\n  background-color: #eee;\n}\n\n.disable-input {\n  background-color: #f8f8f8;\n  cursor: default;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1041 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-17392d8c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/TabRemittanceDetail.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.break-all {\n  word-break: break-all;\n}\n.margin-container {\n  margin-top: 15px;\n}\n.detail-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #012351;\n  font-size: 14px;\n}\n.remittance-detail {\n  height: 62vh;\n  overflow-y: auto;\n}\n.tab-footer {\n  height: 9vh;\n  border-top: 2px solid #d0d0d0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-right: 15px;\n}\n", "", {"version":3,"sources":["/./client/components/integration/remittanceIntegration/TabRemittanceDetail.vue?4f6a4afc"],"names":[],"mappings":";AAgDA;EACA,sBAAA;CACA;AACA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,aAAA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EAAA,cAAA;EACA,mBAAA;MAAA,0BAAA;EACA,uBAAA;MAAA,oBAAA;EACA,oBAAA;CACA","file":"TabRemittanceDetail.vue","sourcesContent":["<template src='./tabRemittanceDetail.pug' lang='pug'></template>\n\n<script scoped>\nimport moment from 'moment'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'TabRemittanceDetail',\n\n  components: {\n    ButtonPrimary\n  },\n\n  props: {\n    idModal: {\n      type: String\n    },\n    remittance: {\n      type: Object,\n      required: true\n    },\n    showRemovalButton: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  methods: {\n    openModalConfirm () {\n      $('#confirmRemittanceRemoval').modal('show')\n    },\n\n    closeModalConfirm () {\n      $('#confirmRemittanceRemoval').modal('hide')\n    },\n\n    handleDateFull (text) {\n      return text ? moment(text).format('DD/MM/YYYY HH:mm:ss') : '-'\n    },\n\n    handleDate (text) {\n      return text ? moment(text).format('DD/MM/YYYY') : '-'\n    }\n  }\n}\n</script>\n\n<style>\n.break-all {\n  word-break: break-all;\n}\n.margin-container {\n  margin-top: 15px;\n}\n\n.detail-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #012351;\n  font-size: 14px;\n}\n\n.remittance-detail {\n  height: 62vh;\n  overflow-y: auto;\n}\n\n.tab-footer {\n  height: 9vh;\n  border-top: 2px solid #d0d0d0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 15px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1042 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-1a206fcb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCriteria.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.attribute > .att-field[data-v-1a206fcb] {\n  display: inline-block;\n}\n.list-complete-item[data-v-1a206fcb]:hover {\n  cursor: move;\n  background-color: #f5f5f5;\n}\n.list-complete-item[data-v-1a206fcb] {\n  padding-top: 18px;\n  padding-bottom: 18px;\n  height: auto;\n  word-wrap: break-word;\n  min-height: 58px;\n  border: 1px solid #ddd;\n  transition: all 1s;\n}\n.fa.action[data-v-1a206fcb] {\n  margin: 0;\n}\n.att-field.order[data-v-1a206fcb] {\n  margin-left: 30px;\n}\n.att-field.buttons[data-v-1a206fcb] {\n  padding-right: 7px;\n}\n.font-sized[data-v-1a206fcb] {\n  font-size: 1.1vh;\n}\n", "", {"version":3,"sources":["/./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCriteria.vue?3bcf3614"],"names":[],"mappings":";AAyCA;EACA,sBAAA;CACA;AAEA;EACA,aAAA;EACA,0BAAA;CACA;AAEA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,iBAAA;CACA","file":"ConciliationCriteria.vue","sourcesContent":["<template src='./conciliationCriteria.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'ConciliationCriteria',\n\n  props: {\n    criteria: {\n      type: Object,\n      required: true\n    },\n    order: {\n      type: Number,\n      required: true\n    },\n    handleEdit: {\n      type: Function,\n      required: true\n    },\n    handleRemove: {\n      type: Function,\n      required: true\n    }\n  },\n\n  computed: {\n    btnEditTitle () {\n      return this.criteria.criterioEmUso\n        ? this.$t('planoConciliacao.validacao.criterioConcilEmUsoEditar')\n        : this.$t('planoConciliacao.labels.editar')\n    },\n    btnRemoveTitle () {\n      return this.criteria.criterioEmUso\n        ? this.$t('planoConciliacao.validacao.criterioConcilEmUsoExcluir')\n        : this.$t('planoConciliacao.labels.remover')\n    }\n  }\n}\n</script>\n\n<style scoped>\n.attribute > .att-field {\n  display: inline-block;\n}\n\n.list-complete-item:hover {\n  cursor: move;\n  background-color: #f5f5f5;\n}\n\n.list-complete-item {\n  padding-top: 18px;\n  padding-bottom: 18px;\n  height: auto;\n  word-wrap: break-word;\n  min-height: 58px;\n  border: 1px solid #ddd;\n  transition: all 1s;\n}\n\n.fa.action {\n  margin: 0;\n}\n\n.att-field.order {\n  margin-left: 30px;\n}\n\n.att-field.buttons {\n  padding-right: 7px;\n}\n\n.font-sized {\n  font-size: 1.1vh;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1043 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-1d6ea436","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabTasks/TabTasks.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n@media screen and (min-width: 1199px) {\n.left-vertical-tabs {\n    width: 10%;\n}\n.right-text-tabs {\n    width: 90%;\n}\n}\n@media screen and (min-width: 992px) and (max-width: 1199px) {\n.left-vertical-tabs {\n    width: 15%;\n}\n.right-text-tabs {\n    width: 85%;\n}\n}\n@media screen and (max-width: 991px) and (min-width: 560px) {\n.left-vertical-tabs {\n    width: 20%;\n}\n.right-text-tabs {\n    width: 80%;\n}\n}\n@media screen and (max-width: 559px) {\n.left-vertical-tabs {\n    width: 25%;\n}\n.right-text-tabs {\n    width: 75%;\n}\n}\n.left-vertical-tabs {\n  border-bottom-left-radius: 3px;\n}\n.right-text-tabs {\n  border-bottom-right-radius: 3px;\n}\n#btnTabLoteConcManualDivergence {\n  margin-bottom: 10px;\n  margin-top: 0px;\n  min-width: auto;\n  width: 26px;\n  height: 26px;\n  padding: 0px 0px 0px 1px;\n}\n#tab-allotment-id {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n.loadingData {\n  background: url(" + __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67) + ") 50% 50% no-repeat;\n  cursor: wait;\n  height: 390px;\n  background-size: 100px;\n}\n.limit-char {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.no-allotment-img {\n  height: 30vh;\n}\n.big-txt-allotment {\n  font-family: 'Inter', sans-serif !important;\nfont-weight: 700;\n  color: #012351;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n.detail-value-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #012351;\n  font-size: 18px;\n}\n.detail-status-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 26px;\n}\n.detail-title-allotment {\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  margin-top: 1vh;\n  color: #012351;\n}\n#tab-allotment-id.modal-footer {\n  padding: 0px;\n}\n#main-tasks-container.main-container {\n  max-height: 50vh;\n  overflow: auto;\n}\n#create-edit-task-form {\n  max-height: 82vh;\n  height: 100%;\n  overflow: auto;\n  padding-top: 10px;\n}\n.position-initial, .vdp-datepicker {\n  position: initial;\n}\n.allotment-data-table {\n  max-width: 100%;\n  max-height: 40vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.font-C {\n  color: #3bb57a !important;\n}\n.font-D {\n  color: #f55753 !important;\n}\n.font-N {\n  color: #56a9c1 !important;\n}\n.font-A {\n  color: #fdbd39 !important;\n}\n.font-default {\n  color: #17375f !important;\n}\n.col-1 {\n  width: 3vw;\n  font-size: 12px;\n}\n.col-2 {\n  width: 7vw;\n  font-size: 12px;\n}\n.selected-row {\n  background-color: #617a95 !important;\n  color: #fff;\n}\n.margin-container {\n  margin-top: 15px;\n}\n.monetary-container {\n  background: #eff0f3;\n  border: 1px solid #DDD;\n  border-bottom-right-radius: 3px;\n  margin-top: 15px;\n  padding: 15px;\n  z-index: 3;\n}\n.loading-center {\n  text-align: center;\n  margin-bottom: 60px;\n}\n.detail-allotment-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #012351;\n  font-size: 14px;\n}\n.VueTables__sortable>span.VueTables__heading {\n  padding-right: 15px;\n}\n.VueTables__table .VueTables__sort-icon.glyphicon::before {\n  top: 1px;\n  position: absolute;\n  left: -10px;\n}\n.table-icon {\n  font-size: 14px;\n}\n.task-subtitle {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #626262;\n  padding: 10px 0px 0px 15px;\n  font-size: 18px;\n}\n\n/*Estilo da div do fundo do componente*/\n.historicoTarefaFundo {\n  max-height: 21vh;\n  height: auto;\n  overflow-x: auto;\n  padding: 20px 0px 0px 0px;\n  background-color: #EBF6F8;\n  border-radius: 10px;\n  margin: 0 10px;\n}\n.enviar-e-mail-automa {\n  font-size: 11px !important;\n  text-align: left;\n  color: #2a2a2a;\n  text-transform: initial !important;\n}\n.input-date-picker {\n  border: none;\n  width: 80%;\n}\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: not-allowed;\n  font-weight: bold;\n  color: #626262;\n}\n#btnSalvarOcorrenciaTarefa {\n  right: 4px;\n  height: 34px;\n}\n#btnSalvarOcorrenciaTarefa:disabled {\n  opacity: 1;\n}\n.warning-area {\n  background-color: #fff2cb;\n  border: 1px solid #ffe599;\n  border-radius: 4px;\n  margin-bottom: 0.8vh;\n}\n.warning-text {\n  color: #8e6f12 !important;\n  font-size: 11px;\n}\n", "", {"version":3,"sources":["/./client/components/modals/gridDetailsModal/tabTasks/TabTasks.vue?291becc8"],"names":[],"mappings":";AAiiCA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;EACA,+BAAA;CACA;AAEA;EACA,gCAAA;CACA;AAEA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;CACA;AAEA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;CACA;AAEA;EACA,4DAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;CACA;AAEA;EACA,oBAAA;EACA,wBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,4CAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,qCAAA;EACA,YAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,oBAAA;EACA,uBAAA;EACA,gCAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;CACA;AAEA;EACA,mBAAA;EACA,oBAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;CACA;;AAEA,wCAAA;AAEA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,0BAAA;EACA,0BAAA;EACA,oBAAA;EACA,eAAA;CACA;AAEA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,mCAAA;CACA;AAEA;EACA,aAAA;EACA,WAAA;CACA;AAEA;;EAEA,oBAAA;EACA,kBAAA;EACA,eAAA;CACA;AAEA;EACA,WAAA;EACA,aAAA;CACA;AAEA;EACA,WAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;CACA;AAEA;EACA,0BAAA;EACA,gBAAA;CACA","file":"TabTasks.vue","sourcesContent":["<template src='./tabTasks.pug' lang='pug'></template>\n\n<script>\nimport _ from 'underscore'\nimport { mapGetters } from 'vuex'\nimport moment from 'moment'\nimport vSelect from 'vue-select'\nimport Datepicker from 'vuejs-datepicker'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport LoadingPlaceholder from '../../../loading/LoadingPlaceholder'\nimport TreeViewHistoric from '../../../treeViewHistoric/TreeviewHistoric'\nimport language from '../../../../../build/language/index.js'\nimport closeModal from '../../../../events/closeModal.js'\nimport { conciliationStatusTranslate, taskBondTypeTranslate, taskStatusesTranslate } from '../../../../utils/statusesTranslator.js'\nimport customValidator from '../../../../utils/customValidator.js'\nimport looseDeepEqual from '../../../../utils/looseDeepEqual'\nimport popExitingConfirmation from '../../../../utils/popExitingConfirmation'\n\nmoment.locale(language.getDatePickerLanguage())\nmoment.updateLocale(language.getDatePickerLanguage(), { invalidDate: ' - ' })\n\nexport default {\n  name: 'TabTasks',\n\n  components: {\n    LoadingPlaceholder,\n    TreeViewHistoric,\n    vSelect,\n    Datepicker,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      currentTask: {},\n      alreadySaved: false,\n      // lista para statuses de conciliação, para conclusão automática de tarefa\n      concilStatusesBase: [],\n      // lista para statuses de conciliação, para conclusão automática de tarefa\n      concilStatuses: [],\n      // asset de loading\n      loadingGif: require('../../../../assets/loading-gif/loading.svg'),\n      // root para colunas de datatables (histórico de tarefas do lançamento)\n      columns: [],\n      // root para opções de datatables (histórico de tarefas do lançamento)\n      options: {\n        filterable: false,\n        perPage: 5,\n        perPageValues: [],\n        texts: {\n          count: this.$t('dataTable.labels.contagem'),\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filterBy: '',\n          filterPlaceholder: null\n        },\n        sortIcon: {\n          is: ''\n        },\n        pagination: { chunk: 5 }\n      },\n      invalid: false,\n      // atributo de disable do datepicker\n      toDate: new Date(),\n      // atributo de disable do datepicker\n      fromDate: new Date('December 31, 2999 23:59:59'),\n      // elemento interno do datepicker\n      inputDate: null,\n      // lista com itens do histórico de tarefas\n      taskHistory: [],\n      // model para exibição da tarefa ativa\n      activeTask: null,\n      // model para cadastro de ocorrência/atualização de status de uma tarefa\n      taskOcurrence: {\n        situacao: {},\n        observacaoHistorico: ''\n      },\n      // lista de operadores utilizada no cadastro/edição de tarefa\n      operators: [],\n      // Configuração do tooltip dos botões de expandir/recolher\n      treeViewButtonTitle: {\n        expand: this.$t('categoria.labels.expandir'),\n        collapse: this.$t('categoria.labels.recolher')\n      },\n      // flag para form desabilitado, indicando modo de visualização de tarefa\n      isVisualisingTask: false,\n      // constrola o seletor de statuses para conciliação automática\n      autoConcludeSelectedSize: 0,\n      disabledBtnChangeStatusTask: true,\n      erroDataDeVencimento: false,\n      canEditTask: true,\n      showActionButtons: true,\n      defaultObject: null,\n      tarefaStatuses: [],\n      // flag para habilitar/desabilitar o botão de salvar\n      disabledBtnSaveTask: false\n    }\n  },\n\n  props: {\n    // Prop enviada pelos relatórios de lançamentos.\n    // Indica que as informações vêm dos movimentos bancários/financeiros.\n    idMovimento: {\n      type: String,\n      default: null\n    },\n\n    // Prop enviada pelos relatórios de lançamentos.\n    // Indica que as informações vêm dos movimentos bancários/financeiros.\n    tipoMovimento: {\n      type: String,\n      default: null\n    },\n\n    // Prop enviada pelos relatórios de lançamentos.\n    // Indica que as informações vêm dos movimentos bancários/financeiros.\n    statusMovimento: {\n      type: String,\n      default: null\n    },\n\n    idTarefa: {\n      type: String,\n      default: null\n    }\n  },\n\n  watch: {\n    task: {\n      handler () {\n        if (this.defaultObject !== null && !this.alreadySaved) {\n          this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.task))\n        }\n      },\n      deep: true\n    }\n  },\n\n  computed: {\n    hintNoMovment () {\n      return this.$t('consultaTarefa.labels.tarefaLancamentoRemovido')\n    },\n\n    statusesBase () {\n      return [\n        {\n          id: 'A',\n          nome: this.$t('statusConciliacao.aberto')\n        },\n        {\n          id: 'C',\n          nome: this.$t('statusConciliacao.conciliado')\n        },\n        {\n          id: 'M',\n          nome: this.$t('statusConciliacao.conciliadoManualmente')\n        },\n        {\n          id: 'D',\n          nome: this.$t('statusConciliacao.divergente')\n        },\n        {\n          id: 'N',\n          nome: this.$t('statusConciliacao.naoAplicavel')\n        }\n      ]\n    },\n    // lista de tipos de vinculo para tarefa\n    tarefaTipoVinculo () {\n      return [\n        {\n          id: 'MF',\n          nome: this.$t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoMF')\n        },\n        {\n          id: 'CL',\n          nome: this.$t('modalDetalhesLanc.tabTarefas.labels.tipoVinculoCL')\n        }\n      ]\n    },\n    // retorna o nome do usuário logado\n    loggedUser () {\n      return this.$store.getters.user\n    },\n    // retorna o email do usuário logado\n    loggedUserId () {\n      return this.$store.getters.userId\n    },\n    // retorna o idioma para o datepicker\n    datePickerLanguage () {\n      return language.getDatePickerLanguageObject()\n    },\n    // retorna tradução da mensagem para envio automatico de email\n    messageEmail () {\n      return this.$t('tarefaEmMassa.titulos.enviarEmail')\n    },\n    // renderiza form para cadastro/edição de tarefa\n    createEditTask () {\n      return !this.isLoadingTaskData && this.isManagingTask\n    },\n    // renderiza tab quando não existir nenhuma tarefa para aquele lançamento\n    noTasksBonded () {\n      return !this.isLoadingTaskData && !this.hadTasksBonded && !this.isManagingTask\n    },\n    // renderiza tab quando houverem tarefas ativas ou não  para aquele lançamento\n    withTaskBonded () {\n      return !this.isLoadingTaskData && this.hadTasksBonded && !this.isManagingTask\n    },\n    // Define o \"titulo\" da área de detalhes da tarefa, variando caso haja tarefa ativa ou não.\n    taskDetailsHeaderTitle () {\n      return this.hasActiveTask\n        ? this.$t('modalDetalhesLanc.tabTarefas.titulos.lancamentoComTarefaAtiva')\n        : this.$t('modalDetalhesLanc.tabTarefas.titulos.lancamentoSemTarefaAtiva')\n    },\n    // Define o \"titulo\" do botão superior da área de detalhes da tarefa,\n    // variando caso haja tarefa ativa ou não.\n    taskDetailsHeaderButton () {\n      return this.hasActiveTask\n        ? this.$t('modalDetalhesLanc.tabTarefas.labels.detalheTarefa')\n        : this.$t('modalDetalhesLanc.tabTarefas.labels.novaTarefa')\n    },\n    // Dica do botão de detalhes apresentado na datatable de histórico de tarefas do lançamento\n    tipAcaoDetalhes () {\n      return this.$t('modalDetalhesLanc.tabTarefas.labels.verDetalhe')\n    },\n    // flag para form desabilitado, indicando modo de visualização de tarefa\n    canReopenTask () {\n      return this.isVisualisingTask && !this.hasActiveTask\n    },\n    // flag para ação de auto atribuição de tarefa\n    canAssignToTask () {\n      return this.loggedUserId !== this.activeTask.responsavel.id\n    },\n    // flag para permissão de funcionalidade\n    canPerformTaskAction () {\n      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(209) >= 0\n    },\n\n    dueDateFormatted () {\n      if (this.activeTask.dataVencimento && typeof this.activeTask.dataVencimento === 'number') {\n        return moment(this.activeTask.dataVencimento).format('l')\n      } else {\n        return this.activeTask.dataVencimento\n      }\n    },\n\n    hasUnsavedChanges () {\n      return this.$store.getters.hasUnsavedChanges\n    },\n\n    task: {\n      get () {\n        return this.$store.getters.task\n      },\n      set (task) {\n        return this.$store.dispatch('setTask', task)\n      }\n    },\n    ...mapGetters([\n      'hadTasksBonded',\n      'isLoadingTaskData',\n      'isManagingTask',\n      'hasActiveTask'\n    ])\n  },\n\n  mounted () {\n    this.resetTaskStatuses()\n    this.erroDataDeVencimento = false\n    this.disabledBtnChangeStatusTask = true\n    this.$store.dispatch('clearFlagsTasks')\n    this.$nextTick(() => {\n      this.$validator.reset()\n    })\n  },\n\n  methods: {\n    resetTaskStatuses (isCreatingTask) {\n      this.tarefaStatuses = [\n        {\n          id: 0,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.pendente')\n        },\n        {\n          id: 10,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')\n        },\n        {\n          id: 20,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.aguardando')\n        }\n      ]\n\n      if (!isCreatingTask) {\n        this.tarefaStatuses.push(\n          {\n            id: 90,\n            nome: this.$t('tarefaEmMassa.tarefaStatuses.concluido')\n          },\n          {\n            id: 99,\n            nome: this.$t('tarefaEmMassa.tarefaStatuses.cancelada')\n          }\n        )\n      }\n    },\n\n    // seta o objeto 'responsavel' que e usado na tarefa\n    setResponsible (responsible) {\n      return {\n        id: responsible.id,\n        nome: responsible.nome,\n        senhaBloqueada: responsible.senhaBloqueada,\n        numeroTentativa: responsible.numeroTentativa,\n        idEntidade: responsible.idEntidade,\n        nomeEntidade: responsible.nomeEntidade,\n        name: responsible.name\n      }\n    },\n\n    // seta o objeto 'historico' que e usado na tarefa\n    setHistoric (historic) {\n      return historic.map(history => {\n        return {\n          id: history.id,\n          descricao: history.descricao,\n          data: history.data,\n          usuario: {\n            nome: history.usuario ? history.usuario.nome : ' - '\n          },\n          situacao: history.situacao,\n          idTransacao: history.idTransacao\n        }\n      })\n    },\n\n    // Ativa o botão caso a descrição não seja vazia\n    onDescriptionChanged (ev) {\n      ev.currentTarget.value !== '' || this.activeTask.situacao.id !== this.taskOcurrence.situacao.id\n        ? this.disabledBtnChangeStatusTask = false\n        : this.disabledBtnChangeStatusTask = true\n\n      if (!this.taskOcurrence.situacao) this.disabledBtnChangeStatusTask = true\n    },\n\n    // Ativa o botão caso a situação seja diferente da atual situação da tarefa\n    onSituationChanged (situation) {\n      this.taskOcurrence.situacao = situation\n\n      if (situation) {\n        this.activeTask.situacao.id !== situation.id || this.taskOcurrence.observacaoHistorico !== ''\n          ? this.disabledBtnChangeStatusTask = false\n          : this.disabledBtnChangeStatusTask = true\n      } else {\n        this.disabledBtnChangeStatusTask = true\n      }\n    },\n\n    // Função para fechamento da modal\n    closeModal (idModal) {\n      this.disabledBtnChangeStatusTask = true\n      this.disabledBtnSaveTask = false\n      this.$nextTick(() => {\n        this.$validator.reset()\n      })\n      $('#' + idModal).modal('hide')\n    },\n\n    // Aciona flag de exibição do laoding\n    startLoading () {\n      this.$store.dispatch('setTaskConfiguration', {\n        isLoadingTask: true,\n        hasBondedTask: false,\n        managingTask: this.isManagingTask\n      })\n    },\n\n    // Aciona flag de exibição para nenhuma tarefa existente\n    noTaskExisting () {\n      this.$store.dispatch('setTaskConfiguration', {\n        isLoadingTask: false,\n        hasBondedTask: false,\n        managingTask: this.isManagingTask\n      })\n    },\n\n    // Aciona flag de exibição para lançamento com histórico de tarefas\n    hasTaskHistory () {\n      this.$store.dispatch('setTaskConfiguration', {\n        isLoadingTask: false,\n        hasBondedTask: true,\n        managingTask: this.isManagingTask\n      })\n    },\n\n    // Aciona flag de exibição para criação/edição de tarefa\n    managingTask () {\n      this.$store.dispatch('setTaskConfiguration', {\n        isLoadingTask: false,\n        hasBondedTask: this.hadTasksBonded,\n        managingTask: true\n      })\n\n      this.preparteForm()\n    },\n\n    // Função para criar label para statuses de conclusão automática baseado no identificador de status\n    concatStatusesAutoConcluede (conclusoesAutomaticas) {\n      if (!conclusoesAutomaticas || conclusoesAutomaticas.length === 0) {\n        return ' - '\n      } else {\n        let statuses = ''\n        conclusoesAutomaticas.forEach(sigla => {\n          statuses += conciliationStatusTranslate(sigla.situacaoConciliacao) + '|'\n        })\n        return statuses.substring(0, statuses.length - 1)\n      }\n    },\n\n    // Função para carregar os detalhes da tarefa de um lançamento excluído\n    loadTaskDetail () {\n      this.isVisualisingTask = false\n      this.startLoading()\n      this.resetTaskData()\n      this.resetActiveTaskData()\n      this.initializeBaseConcilList()\n\n      let self = this\n      this.$store.dispatch('getTaskDetails', this.idTarefa)\n        .then((response) => {\n          let details = response.data\n          this.setDetailTaskVisual(details, self)\n        })\n        .catch((error) => {\n          self.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    // Função para carregar os dados iniciais das tarefas do lançamento selecionado.\n    // Resultado dessa consulta define o estado de apresentação da aba.\n    loadTaskData (clearTaskData) {\n      this.startLoading()\n      let param = {\n        tipoVinculo: this.tipoMovimento === 'MovFin' ? 'MF' : 'CL',\n        idVinculo: this.idMovimento\n      }\n\n      if (clearTaskData) {\n        this.resetTaskData()\n        this.resetActiveTaskData()\n      }\n\n      this.initializeBaseConcilList()\n      let self = this\n      this.$store.dispatch('loadTasksFromStatement', param).then((response) => {\n        this.resetTaskStatuses()\n        this.alreadySaved = false\n        this.options.perPage = 10\n        let responseHistory = []\n        let taskResult = response.data.data\n        if (!taskResult || taskResult.length === 0) { // Nenhuma tarefa associada\n          self.noTaskExisting()\n        } else {\n          taskResult.forEach(task => {\n            if (task.tarefa.situacao === 90 || task.tarefa.situacao === 99) { // Tarefa concluída ou cancelada\n              responseHistory.push(task.tarefa)\n            } else { // Tarefa ativa\n              self.activeTask = {\n                id: task.tarefa.id,\n                nome: task.tarefa.nome,\n                tipoVinculo: {\n                  id: task.tarefa.tipoVinculo,\n                  nome: taskBondTypeTranslate(task.tarefa.tipoVinculo)\n                },\n                responsavel: {\n                  id: task.tarefa.usuarioResponsavel.idUsuario,\n                  nome: task.tarefa.usuarioResponsavel.nome\n                },\n                situacao: {\n                  id: task.tarefa.situacao\n                },\n                dataAlteracao: task.tarefa.dataAlteracao,\n                dataVencimento: task.tarefa.dataVencimento ? task.tarefa.dataVencimento : ' - ',\n                descricao: task.tarefa.descricao,\n                historico: this.setHistoric(task.tarefa.historico),\n                situacoesConclusaoAutomatica: task.tarefa.conclusoesAutomaticas,\n                conclusoesAutomaticas: task.tarefa.conclusoesAutomaticas\n                  ? this.concatStatusesAutoConcluede(task.tarefa.conclusoesAutomaticas)\n                  : ' - '\n              }\n              self.taskOcurrence.situacao.id = task.tarefa.situacao\n              self.taskOcurrence.situacao.nome = taskStatusesTranslate(task.tarefa.situacao)\n              this.options.perPage = 5\n              this.$store.dispatch('setHasActiveTask', true)\n            }\n          })\n          self.hasTaskHistory()\n          self.prepareTaskHistoryList(responseHistory)\n        }\n        this.disabledBtnChangeStatusTask = true\n      }).catch((error) => {\n        this.$root.$refs.notification.error(error)\n        this.closeModal()\n      })\n    },\n\n    setDetailTaskVisual (details, self) {\n      this.showActionButtons = false\n      self.task = {}\n      self.task.id = details.id\n      self.task.nome = details.nome\n      self.task.descricao = details.descricao\n      self.task.dataAlteracao = details.dataAlteracao\n      self.task.dataVencimento = details.dataVencimento ? moment(details.dataVencimento) : null\n      self.task.tipoVinculo = {\n        id: details.tipoVinculo,\n        nome: taskBondTypeTranslate(details.tipoVinculo)\n      }\n      self.task.situacao = {\n        id: details.situacao,\n        nome: taskStatusesTranslate(details.situacao)\n      }\n      if (details.usuarioResponsavel) {\n        self.task.responsavel = {\n          id: details.usuarioResponsavel.idUsuario,\n          nome: details.usuarioResponsavel.nome\n        }\n      }\n      self.task.conclusaoAutomatica = []\n      if (details.conclusoesAutomaticas && details.conclusoesAutomaticas.length > 0) {\n        details.conclusoesAutomaticas.forEach(status => {\n          self.task.conclusaoAutomatica.push({\n            id: status.situacaoConciliacao,\n            nome: conciliationStatusTranslate(status.situacaoConciliacao)\n          })\n        })\n        self.task.conclusoesAutomaticas = self.concatStatusesAutoConcluede(details.conclusoesAutomaticas)\n      } else {\n        self.task.conclusoesAutomaticas = ' - '\n      }\n      self.task.historico = details.historico\n      self.isVisualisingTask = true\n      self.managingTask()\n    },\n\n    // Restaura o estado orginal (vazio) do objeto de bind para nova tarefa\n    resetTaskData () {\n      this.erroDataDeVencimento = false\n\n      this.$store.dispatch('setEmptyTask')\n      this.$store.dispatch('setTask', {\n        situacao: {\n          id: 10,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')\n        }\n      })\n\n      let tipoVinculo = {}\n\n      if (this.tipoMovimento === 'MovBan') {\n        tipoVinculo = {\n          id: 'CL',\n          nome: this.$t('tarefaEmMassa.labels.tipoCl')\n        }\n      } else {\n        tipoVinculo = {\n          id: 'MF',\n          nome: this.$t('tarefaEmMassa.labels.tipoMf')\n        }\n      }\n\n      this.$store.dispatch('setTask', { tipoVinculo })\n      this.currentTask = this.task\n\n      this.autoConcludeSelectedSize = 0\n      this.concilStatuses = this.concilStatusesBase.slice()\n    },\n\n    // Restaura o estado orginal (vazio) do objeto de bind para tarefa ativa\n    resetActiveTaskData () {\n      this.$store.dispatch('setHasActiveTask', false)\n      this.activeTask = null\n      this.defaultObject = null\n    },\n\n    // Define listeners para datepicker da tela de cadastro/edição de tarefa\n    preparteForm () {\n      // delay de renderizacao da DOM alterada\n      setTimeout(() => {\n        this.inputDate = document.getElementById('dataVencimento')\n        if (this.inputDate) {\n          this.inputDate.setAttribute('autocomplete', 'off')\n          this.inputDate.addEventListener('blur', () => {\n            Promise.resolve(this.validateDate())\n          })\n        }\n      }, 100)\n    },\n\n    // Incializa lista de operadores da tela de cadastro/edição de tarefa e\n    // aciona renderização do form.\n    loadOperators () {\n      this.$store.dispatch('getOperatorsWithTaskPermission')\n        .then(activeOperators => {\n          this.operators = activeOperators\n\n          let idUsuario = this.task.responsavel ? this.task.responsavel.id : this.loggedUserId\n          this.operators.forEach(op => {\n            if (op.id === idUsuario) {\n              this.task.responsavel = this.setResponsible(op)\n            }\n          })\n          if (!this.task.responsavel) {\n            this.task.responsavel = this.operators[0]\n          }\n          this.defaultObject = { ...this.task }\n          this.defaultObject.responsavel = this.setResponsible(this.task.responsavel)\n          this.managingTask()\n        })\n    },\n\n    // validação global do datepicker\n    validateDate () {\n      return new Promise((resolve) => {\n        let isValid = this.inputDate.value.length === 10 &&\n          customValidator.isValidDate(this.inputDate.value)\n        if (!isValid) {\n          this.task.dataVencimento = null\n          this.$refs.dataVencimento.$children\n            .find(item => !!item.id).typedDate = ''\n        }\n        resolve()\n      })\n    },\n\n    dataDeVencimentoValida () {\n      if (this.task.dataVencimento) {\n        let today = new Date()\n        let yesterday = today.setDate(today.getDate() - 1)\n        let validDate = false\n\n        validDate = this.task.dataVencimento.getTime() > yesterday\n\n        this.erroDataDeVencimento = !validDate\n\n        return validDate\n      }\n\n      return true\n    },\n\n    // Valida o form de cadastro/edição de tarefa (obrigatoriedades).\n    // Aciona serviço de persistência caso form seja válido.\n    validate () {\n      let previousDate\n      let newDate = new Date(this.task.dataVencimento).getTime()\n\n      this.activeTask ? previousDate = new Date(this.activeTask.dataVencimento).getTime() : previousDate = false\n\n      let self = this\n\n      this.$validator.validateAll()\n        .then(result => {\n          if ((result && this.activeTask !== null && previousDate === newDate) ||\n            result && this.dataDeVencimentoValida() ||\n            result && this.task.dataVencimento === null) {\n            self.salvarTarefa()\n            this.alreadySaved = true\n            self.$nextTick(() => {\n              self.$validator.reset()\n            })\n          } else if (previousDate !== newDate && !self.dataDeVencimentoValida()) {\n            self.task.dataVencimento === null ? self.erroDataDeVencimento = false : self.erroDataDeVencimento = true\n          }\n        })\n    },\n\n    // Constróio objeto para nova tarefa e aciona requisição para persistência.\n    salvarTarefa () {\n      this.disabledBtnSaveTask = true\n\n      let newTask = {\n        id: this.task.id,\n        dataCriacao: new Date(),\n        dataVencimento: this.task.dataVencimento,\n        nome: this.task.nome,\n        descricao: this.task.descricao,\n        tipoVinculo: this.task.tipoVinculo.id,\n        situacao: this.task.situacao.id,\n        idVinculo: this.idMovimento,\n        dataAlteracao: this.task.dataAlteracao,\n        usuarioResponsavel: {\n          idUsuario: this.task.responsavel.id\n        },\n        enviarEmail: this.task.enviarEmail,\n        situacoesConclusaoAutomatica: []\n      }\n\n      this.task.conclusaoAutomatica.forEach(status => {\n        newTask.situacoesConclusaoAutomatica.push(status.id)\n      })\n\n      this.$store.dispatch('createNewTask', newTask)\n        .then((response) => {\n          this.$root.$refs.notification.success(response.data.message)\n          this.resetTaskData()\n          this.task && this.task.id ? this.viewOldTask(this.task, true) : this.loadTaskData()\n          this.$store.dispatch('setIsManagingTask', false)\n          closeModal.$emit('taskChange', true)\n          this.$store.dispatch('setHasUnsavedChanges', false)\n          this.$nextTick(() => {\n            this.$validator.reset()\n          })\n          this.disabledBtnSaveTask = false\n        })\n        .catch((error) => {\n          this.disabledBtnSaveTask = false\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    // Monta configuração para dataTable de histórico de tarefas do lançamento.\n    mountTaskHistoryDataTable () {\n      this.columns = [\n        'acoes',\n        'nome',\n        'descricao',\n        'tipoVinculo',\n        'responsavel',\n        'data'\n      ]\n\n      this.options.headings = {\n        acoes: '',\n        nome: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colNome'),\n        descricao: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'),\n        tipoVinculo: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colTipo'),\n        responsavel: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colRes'),\n        data: this.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colData')\n      }\n\n      this.options.columnsClasses = {\n        acoes: 'col-1',\n        nome: 'col-1 limit-char',\n        descricao: 'col-1 limit-char',\n        tipoVinculo: 'col-1 limit-char',\n        responsavel: 'col-1 limit-char',\n        data: 'col-1 limit-char'\n      }\n      this.sortable = ['nome', 'descricao', 'tipoVinculo', 'responsavel', 'data']\n      this.options.orderBy = 'nome'\n    },\n\n    // Monta lista de histórico de tarefas para exibição na dataTable\n    prepareTaskHistoryList (responseHistory) {\n      this.taskHistory = []\n      if (responseHistory && responseHistory.length > 0) {\n        responseHistory.forEach(item => {\n          this.taskHistory.push({\n            id: item.id,\n            nome: item.nome,\n            descricao: item.descricao,\n            tipoVinculo: item.tipoVinculo === 'MF' ? this.tarefaTipoVinculo[0].nome : this.tarefaTipoVinculo[1].nome,\n            responsavel: item.usuarioResponsavel ? item.usuarioResponsavel.nome : ' - ',\n            data: item.dataVencimento ? moment(item.dataVencimento).format('l') : ' - '\n          })\n        })\n      }\n      this.mountTaskHistoryDataTable()\n    },\n\n    // Salva nova ocorrência/status para a tarefa atual\n    updateTaskStatus () {\n      this.disabledBtnChangeStatusTask = true\n\n      let taskOcur = {\n        id: this.activeTask.id,\n        tipoVinculo: this.activeTask.tipoVinculo.id,\n        situacao: this.taskOcurrence.situacao.id,\n        observacaoHistorico: this.taskOcurrence.observacaoHistorico,\n        idVinculo: this.idMovimento,\n        dataAlteracao: this.activeTask.dataAlteracao\n      }\n\n      this.$store.dispatch('saveTaskOcurrence', taskOcur)\n        .then((response) => {\n          this.resetActiveTaskData()\n          this.loadTaskData()\n          this.taskOcurrence = {\n            situacao: {},\n            observacaoHistorico: ''\n          }\n          this.$root.$refs.notification.success(response.data.message)\n          closeModal.$emit('taskChange', true)\n          this.$nextTick(() => {\n            this.$validator.reset()\n          })\n        })\n        .catch((error) => {\n          this.disabledBtnChangeStatusTask = false\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    // Inicia fluxo de criação/edição de tarefa, baseado no estado da flag hasActiveTask:\n    // TRUE -> Edição da tarefa activeTask\n    // FALSE -> Criação de nova tarefa para o lançamento\n    manageTask () {\n      this.erroDataDeVencimento = false\n\n      // Prepara model de criação/edição\n      this.resetTaskData()\n      this.isVisualisingTask = false\n      if (this.hasActiveTask) {\n        const task = {\n          id: this.activeTask.id,\n          nome: this.activeTask.nome,\n          tipoVinculo: this.activeTask.tipoVinculo,\n          descricao: this.activeTask.descricao,\n          situacao: {\n            id: this.activeTask.situacao.id,\n            nome: this.activeTask.situacao.nome ? this.activeTask.situacao.nome : taskStatusesTranslate(this.activeTask.situacao.id)\n          },\n          dataAlteracao: this.activeTask.dataAlteracao,\n          dataVencimento: this.activeTask.dataVencimento && this.activeTask.dataVencimento !== ' - ' ? new Date(this.activeTask.dataVencimento) : null,\n          responsavel: this.activeTask.responsavel,\n          conclusaoAutomatica: [],\n          enviarEmail: false\n        }\n        this.autoConcludeSelectedSize = this.activeTask.situacoesConclusaoAutomatica ? this.activeTask.situacoesConclusaoAutomatica.length : (this.activeTask.conclusaoAutomatica ? this.activeTask.conclusaoAutomatica.length : 0)\n        if (this.activeTask.situacoesConclusaoAutomatica && this.activeTask.situacoesConclusaoAutomatica.length > 0) {\n          this.activeTask.situacoesConclusaoAutomatica.forEach(status => {\n            task.conclusaoAutomatica.push({\n              id: status.situacaoConciliacao,\n              nome: conciliationStatusTranslate(status.situacaoConciliacao)\n            })\n          })\n        } else if (this.activeTask.conclusaoAutomatica && this.activeTask.conclusaoAutomatica.length > 0) {\n          this.activeTask.conclusaoAutomatica.forEach(status => {\n            task.conclusaoAutomatica.push({\n              id: status.id,\n              nome: conciliationStatusTranslate(status.nome)\n            })\n          })\n        }\n        this.changeAutoConcludeList(this.task.conclusaoAutomatica)\n        if (this.activeTask.historico && this.activeTask.historico.length > 0) {\n          task.historico = this.activeTask.historico.slice()\n        }\n        this.$store.dispatch('setTask', task)\n      }\n      // Inicia loading de requisição\n      this.startLoading()\n      // Carrega lista de operadores (internamente inicializa o form)\n      this.loadOperators()\n    },\n\n    // Cancela o cadastro/edição de tarefa, retornando para a visualização adequada da modal\n    // através do reload da mesma (devido à volatilidade dos dados da tarefa, dada a possibilidade de\n    // alteração em multiplas sessões)/\n    cancelManagement () {\n      this.loadTaskData(true)\n      this.$store.dispatch('setIsManagingTask', false)\n    },\n\n    goBack () {\n      if (this.hasUnsavedChanges && !popExitingConfirmation()) {\n        return\n      }\n      this.$store.dispatch('setHasUnsavedChanges', false)\n      this.viewOldTask()\n    },\n\n    // Consulta detalhes de uma determinada tarefa e monta form de edição (desabilitado) para\n    // visualização dos dados.\n    viewOldTask (oldTask, isEdit) {\n      if (isEdit) {\n        this.canEditTask = true\n      } else {\n        if (oldTask) {\n          this.canEditTask = false\n        } else {\n          this.canEditTask = true\n        }\n      }\n      let self = this\n      if (oldTask || self.activeTask) {\n        this.$store.dispatch('getTaskDetails', oldTask ? oldTask.id : self.activeTask.id)\n          .then((response) => {\n            let details = response.data\n            const task = {}\n            task.id = details.id\n            task.nome = details.nome\n            task.tipoVinculo = {\n              id: details.tipoVinculo,\n              nome: taskBondTypeTranslate(details.tipoVinculo)\n            }\n            task.descricao = details.descricao\n            task.situacao = {\n              id: details.situacao,\n              nome: taskStatusesTranslate(details.situacao)\n            }\n            task.dataAlteracao = details.dataAlteracao\n            task.dataVencimento = details.dataVencimento ? moment(details.dataVencimento) : null\n            if (details.usuarioResponsavel) {\n              task.responsavel = this.setResponsible(details.usuarioResponsavel)\n            }\n            task.conclusaoAutomatica = []\n            if (details.conclusoesAutomaticas && details.conclusoesAutomaticas.length > 0) {\n              details.conclusoesAutomaticas.forEach(status => {\n                task.conclusaoAutomatica.push({\n                  id: status.situacaoConciliacao,\n                  nome: conciliationStatusTranslate(status.situacaoConciliacao)\n                })\n              })\n              task.conclusoesAutomaticas = self.concatStatusesAutoConcluede(details.conclusoesAutomaticas)\n            } else {\n              task.conclusoesAutomaticas = ' - '\n            }\n            task.historico = this.setHistoric(details.historico)\n            self.isVisualisingTask = true\n            if (isEdit) {\n              self.activeTask = task\n            }\n            self.$store.dispatch('setTask', task)\n            self.currentTask = task\n            self.managingTask()\n          })\n          .catch((error) => {\n            self.$root.$refs.notification.error(error.message)\n          })\n      } else {\n        self.isVisualisingTask = false\n        this.resetTaskData()\n        self.managingTask()\n        self.resetTaskStatuses(true)\n        self.loadOperators()\n      }\n    },\n\n    // Reabre uma tarefa do histórico.\n    reopenTask () {\n      let task = {\n        id: this.task.id,\n        tipoVinculo: this.task.tipoVinculo.id,\n        idVinculo: this.idMovimento,\n        dataAlteracao: this.task.dataAlteracao\n      }\n\n      this.$store.dispatch('reopenTask', task)\n        .then((response) => {\n          this.isVisualisingTask = false\n          this.loadTaskData()\n          this.viewOldTask(this.task, true)\n          this.$root.$refs.notification.success(response.data.message)\n          closeModal.$emit('taskChange', true)\n          this.$nextTick(() => {\n            this.$validator.reset()\n          })\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    // Retorna data formatada\n    formatDate (date) {\n      return moment(date).format('l')\n    },\n\n    // Colocar o usuário logado como responsável pela tarefa.\n    assignTaskToLoggedUser () {\n      let task = {\n        id: this.activeTask.id,\n        idVinculo: this.idMovimento,\n        dataAlteracao: this.activeTask.dataAlteracao,\n        usuarioResponsavel: {\n          idUsuario: this.loggedUserId\n        },\n        situacoesConclusaoAutomatica: []\n      }\n      if (this.activeTask.situacoesConclusaoAutomatica && this.activeTask.situacoesConclusaoAutomatica.length > 0) {\n        this.activeTask.situacoesConclusaoAutomatica.forEach(status => {\n          task.situacoesConclusaoAutomatica.push(status.situacaoConciliacao)\n        })\n      }\n      this.$store.dispatch('assignTaskToLoggedUser', task)\n        .then((response) => {\n          this.loadTaskData()\n          this.$root.$refs.notification.success(response.data.message)\n          closeModal.$emit('taskChange', true)\n          this.$nextTick(() => {\n            this.$validator.reset()\n          })\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    // Limpa dados de tarefa ativa e model de cadastro para exibição do form de cadastro \"em branco\".\n    startTask () {\n      this.resetActiveTaskData()\n      this.resetTaskStatuses(true)\n      this.manageTask()\n    },\n\n    // Atualiza listagem da combo de conclusão automática baseada nos valores já selecionados\n    changeAutoConcludeList (selectDataTableDinamicColumn) {\n      if (this.autoConcludeSelectedSize > 0 &&\n          selectDataTableDinamicColumn &&\n          (this.autoConcludeSelectedSize <= selectDataTableDinamicColumn.length)) {\n        // Adicionando\n        let selected = selectDataTableDinamicColumn[selectDataTableDinamicColumn.length - 1]\n        // remove item da combo\n        this.concilStatuses = _.without(this.concilStatuses, selected)\n        // Incrementa a variável de controle\n        this.autoConcludeSelectedSize++\n      } else {\n        // Removendo\n        this.concilStatuses = this.concilStatusesBase.slice()\n        selectDataTableDinamicColumn.forEach(item => {\n          let index = this.concilStatuses.findIndex(dinamicColumn => dinamicColumn.id === item.id)\n          this.concilStatuses.splice(index, 1)\n        })\n        // Decrementa a variável de controle\n        this.autoConcludeSelectedSize--\n      }\n      this.setTask('conclusaoAutomatica', selectDataTableDinamicColumn)\n    },\n\n    // Remove status do lançamento das possibilidades de seleção para conclusão automática.\n    initializeBaseConcilList () {\n      if (this.statusMovimento) {\n        let index = this.statusesBase.findIndex(dinamicColumn => dinamicColumn.id === this.statusMovimento)\n        let status = this.statusesBase[index]\n        this.concilStatusesBase = _.without(this.statusesBase, status)\n      }\n    },\n\n    setTask (prop, value) {\n      this.currentTask[prop] = value\n      this.$store.dispatch('setTask', { [prop]: value })\n    },\n\n    selectSituacao (newSituacao) {\n      this.setTask('situacao', newSituacao)\n    },\n\n    clearManagementTask () {\n      this.$store.dispatch('clearFlagsTasks')\n      this.resetTaskData()\n    }\n  }\n}\n</script>\n\n<style>\n@media screen and (min-width: 1199px) {\n  .left-vertical-tabs {\n    width: 10%;\n  }\n\n  .right-text-tabs {\n    width: 90%;\n  }\n}\n\n@media screen and (min-width: 992px) and (max-width: 1199px) {\n  .left-vertical-tabs {\n    width: 15%;\n  }\n\n  .right-text-tabs {\n    width: 85%;\n  }\n}\n\n@media screen and (max-width: 991px) and (min-width: 560px) {\n  .left-vertical-tabs {\n    width: 20%;\n  }\n\n  .right-text-tabs {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 559px) {\n  .left-vertical-tabs {\n    width: 25%;\n  }\n\n  .right-text-tabs {\n    width: 75%;\n  }\n}\n\n.left-vertical-tabs {\n  border-bottom-left-radius: 3px;\n}\n\n.right-text-tabs {\n  border-bottom-right-radius: 3px;\n}\n\n#btnTabLoteConcManualDivergence {\n  margin-bottom: 10px;\n  margin-top: 0px;\n  min-width: auto;\n  width: 26px;\n  height: 26px;\n  padding: 0px 0px 0px 1px;\n}\n\n#tab-allotment-id {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n\n.loadingData {\n  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;\n  cursor: wait;\n  height: 390px;\n  background-size: 100px;\n}\n\n.limit-char {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.no-allotment-img {\n  height: 30vh;\n}\n\n.big-txt-allotment {\n  font-family: 'Inter', sans-serif !important;\nfont-weight: 700;\n  color: #012351;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\n\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n\n.detail-value-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #012351;\n  font-size: 18px;\n}\n\n.detail-status-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 26px;\n}\n\n.detail-title-allotment {\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  margin-top: 1vh;\n  color: #012351;\n}\n\n#tab-allotment-id.modal-footer {\n  padding: 0px;\n}\n\n#main-tasks-container.main-container {\n  max-height: 50vh;\n  overflow: auto;\n}\n\n#create-edit-task-form {\n  max-height: 82vh;\n  height: 100%;\n  overflow: auto;\n  padding-top: 10px;\n}\n\n.position-initial, .vdp-datepicker {\n  position: initial;\n}\n\n.allotment-data-table {\n  max-width: 100%;\n  max-height: 40vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.font-C {\n  color: #3bb57a !important;\n}\n\n.font-D {\n  color: #f55753 !important;\n}\n\n.font-N {\n  color: #56a9c1 !important;\n}\n\n.font-A {\n  color: #fdbd39 !important;\n}\n\n.font-default {\n  color: #17375f !important;\n}\n\n.col-1 {\n  width: 3vw;\n  font-size: 12px;\n}\n\n.col-2 {\n  width: 7vw;\n  font-size: 12px;\n}\n\n.selected-row {\n  background-color: #617a95 !important;\n  color: #fff;\n}\n\n.margin-container {\n  margin-top: 15px;\n}\n\n.monetary-container {\n  background: #eff0f3;\n  border: 1px solid #DDD;\n  border-bottom-right-radius: 3px;\n  margin-top: 15px;\n  padding: 15px;\n  z-index: 3;\n}\n\n.loading-center {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.detail-allotment-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #012351;\n  font-size: 14px;\n}\n\n.VueTables__sortable>span.VueTables__heading {\n  padding-right: 15px;\n}\n\n.VueTables__table .VueTables__sort-icon.glyphicon::before {\n  top: 1px;\n  position: absolute;\n  left: -10px;\n}\n\n.table-icon {\n  font-size: 14px;\n}\n\n.task-subtitle {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #626262;\n  padding: 10px 0px 0px 15px;\n  font-size: 18px;\n}\n\n/*Estilo da div do fundo do componente*/\n\n.historicoTarefaFundo {\n  max-height: 21vh;\n  height: auto;\n  overflow-x: auto;\n  padding: 20px 0px 0px 0px;\n  background-color: #EBF6F8;\n  border-radius: 10px;\n  margin: 0 10px;\n}\n\n.enviar-e-mail-automa {\n  font-size: 11px !important;\n  text-align: left;\n  color: #2a2a2a;\n  text-transform: initial !important;\n}\n\n.input-date-picker {\n  border: none;\n  width: 80%;\n}\n\n.form-control[disabled],\nfieldset[disabled] .form-control {\n  cursor: not-allowed;\n  font-weight: bold;\n  color: #626262;\n}\n\n#btnSalvarOcorrenciaTarefa {\n  right: 4px;\n  height: 34px;\n}\n\n#btnSalvarOcorrenciaTarefa:disabled {\n  opacity: 1;\n}\n\n.warning-area {\n  background-color: #fff2cb;\n  border: 1px solid #ffe599;\n  border-radius: 4px;\n  margin-bottom: 0.8vh;\n}\n\n.warning-text {\n  color: #8e6f12 !important;\n  font-size: 11px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1044 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-1e61ffba","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/manualConciliation/ManualConciliation.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports
exports.i(__webpack_require__(/*! -!../../../../../~/css-loader?sourceMap!../../../../../~/vue-nav-tabs/themes/vue-tabs.css */ 484), "");

// module
exports.push([module.i, "\n.isLoadingManualConciliationActionsStatic[data-v-1e61ffba] {\n  background: url(" + __webpack_require__(/*! ../../../../assets/logos_equals/logo_equals_quadrado.svg */ 1140) + ") 50.5% 49% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.9;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  transition: all 5s ease-in-out;\n}\n.isLoadingManualConciliationActions[data-v-1e61ffba] {\n  background: url(" + __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67) + ") 50% 45% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.9;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  transition: all 5s ease-in-out;\n}\n.spanLoading[data-v-1e61ffba] {\n  color: #13556A;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 25px;\n  position: fixed;\n  top: 49%;\n  margin-top: 60px;\n  width: 100%;\n  text-align: center;\n}\n#spin[data-v-1e61ffba]:after {\n  content: '';\n  animation: spin 5s linear infinite;\n}\n@keyframes spin {\n0% {\n    content: attr(data-content);\n}\n100% {\n    content: attr(data-content2);\n}\n}\n#tab-navigation[data-v-1e61ffba] {\n  font-family: 'Inter', sans-serif;\n}\n.tab[data-v-1e61ffba] {\n  margin-top: 20px;\n}\n.nav-tabs>li>a[data-v-1e61ffba] {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  text-transform: none;\n}\n.vue-tabs .nav>li span.title[data-v-1e61ffba] {\n  color: #142C4F;\n}\n.vue-tabs .nav-tabs[data-v-1e61ffba] {\n  border-bottom: 2px solid #d6e2f5;\n}\n.vue-tabs .nav-tabs>li>a[data-v-1e61ffba] {\n  border: none;\n}\n.vue-tabs .nav>li.active span.title[data-v-1e61ffba] {\n  color: #fff;\n}\n.vue-tabs .nav-tabs>li.active>a[data-v-1e61ffba],\n.vue-tabs .nav-tabs>li.active>a[data-v-1e61ffba]:hover,\n.vue-tabs .nav-tabs>li.active>a[data-v-1e61ffba]:focus {\n  border: none;\n  border-top: 5px solid #3bb5b4;\n  color: #fff;\n  background: #142C4F;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 11px;\n}\n.vue-tabs .nav-tabs>li>a[data-v-1e61ffba],\n.vue-tabs .nav-tabs>li>a[data-v-1e61ffba]:hover,\n.vue-tabs .nav-tabs>li>a[data-v-1e61ffba]:focus {\n  border: none;\n  border-top: 5px solid #fff;\n  color: #142C4F;\n  background: #d6e2f5;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 13px;\n}\n.pending-title-manual-conciliation[data-v-1e61ffba] {\n  text-align: left;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  margin-top: 3vh;\n  color: #17375f;\n}\n.grey-right-border[data-v-1e61ffba] {\n  border-right: solid 2px #cccccc;\n}\n.pending-box[data-v-1e61ffba] {\n  padding-right: 25px!important;\n}\n.pending-conciliation-box[data-v-1e61ffba] {\n  display: -ms-grid;\n  display: grid;\n}\n.centered[data-v-1e61ffba] {\n  text-align: center;\n}\n.badge-custom[data-v-1e61ffba] {\n  padding: 7px 2px;\n  margin-left: 1vh;\n  background-color: #f55753 !important;\n  border-radius: 50%;\n  min-width: 30px;\n  margin-top: 21px;\n  right: 2px;\n  z-index: 9;\n  position: absolute;\n}\np.placeholderInputTag[data-v-1e61ffba] {\n  z-index: 3;\n  position: absolute;\n  padding: 7px 0px 0px 7px;\n  color: #999;\n}\nbutton.filter-input-tag[data-v-1e61ffba] {\n  width: 100%;\n  min-width: auto;\n  padding: 0px;\n}\n", "", {"version":3,"sources":["/./client/components/views/reports/manualConciliation/ManualConciliation.vue?302d855a"],"names":[],"mappings":";AA+7BA;EACA,8DAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAKA,+BAAA;CACA;AAEA;EACA,4DAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAKA,+BAAA;CACA;AAEA;EACA,eAAA;EACA,iCAAA;AACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;CACA;AAEA;EACA,YAAA;EACA,mCAAA;CACA;AAEA;AACA;IACA,4BAAA;CACA;AACA;IACA,6BAAA;CACA;CACA;AAEA;EACA,iCAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,iCAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;;;EAGA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;CACA;AAEA;;;EAGA,aAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;CACA;AAEA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;AACA,iBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,gCAAA;CACA;AAEA;EACA,8BAAA;CACA;AAEA;EACA,kBAAA;EAAA,cAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;CACA","file":"ManualConciliation.vue","sourcesContent":["<template src=\"./manualConciliation.pug\" lang=\"pug\"></template>\n\n<script>\nimport _ from 'underscore'\nimport vSelect from 'vue-select'\nimport { VueTabs, VTab } from 'vue-nav-tabs'\nimport MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'\nimport Modal from '../../../modals/modal/Modal'\nimport TabAllotment from '../../../modals/gridDetailsModal/tabAllotment/TabAllotment'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport BetterInputTag from '../../../input/betterInputTag/BetterInputTag'\nimport InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport PendingConciliations from '../../../reports/manualConciliation/PendingConciliations'\nimport Allotment from '../../../reports/manualConciliation/Allotment.vue'\nimport SelectedEntries from '../../../reports/manualConciliation/SelectedEntries'\nimport language from '../../../../../build/language/index'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\n\nexport default {\n  name: 'ManualConciliation',\n\n  components: {\n    vSelect,\n    VueTabs,\n    VTab,\n    MultiSelectModal,\n    Modal,\n    TabAllotment,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    BetterInputTag,\n    InputEstablishment,\n    ButtonPrimary,\n    PendingConciliations,\n    Allotment,\n    SelectedEntries\n  },\n\n  data () {\n    return {\n      establishimentsUrls: {\n        establishments: 'manualConciliation/establishment/list',\n        attributes: '/manualConciliation/loadEstablishmentAtt'\n      },\n      selectedEstablishments: [],\n      isAdvancedSearch: true,\n      messageExit: '',\n      confirmExit: function (e) {\n        let message = this.messageExit\n        e = e || window.event\n        // For IE and Firefox\n        if (e) {\n          e.returnValue = message\n        }\n        // For Safari\n        return message\n      },\n      CONCILIATION_PLAN_MODAL: 'conciliationPlanModal',\n      BANK_ACCOUNT_MODAL: 'bankAccountsModal',\n      CATEGORIES_MODAL: 'categoriesModal',\n      dateRange: {},\n      itensSelected: [],\n      list: [],\n      selectedList: [],\n      selectedStatuses: [],\n      idPlanSelected: null,\n      plansSelected: [],\n      plansTags: [],\n      firstDate: new Date(),\n      finalDate: new Date(),\n      dataTableColumns: [],\n      dataTableOptions: {\n        perPage: 5,\n        perPageValues: [],\n        texts: { count: this.$t('dataTable.labels.contagem'), noResults: this.$t('dataTable.labels.semResultados'), filter: '', filterPlaceholder: this.$t('dataTable.labels.filtrar') },\n        filterable: true,\n        pagination: {\n          chunk: 5,\n          dropdown: false\n        },\n        sortIcon: {\n          is: ''\n        },\n        sortable: [],\n        headings: {},\n        templates: {},\n        customSorting: {},\n        orderBy: {},\n        columnsClasses: {}\n      },\n      // pendingConciliaton data\n      resultMov: {},\n      resultExt: {},\n      treeGridCfgMov: {},\n      treeGridCfgExt: {},\n      showTreegridMov: false,\n      showTreegridExt: false,\n      // allotments data\n      resultLot: {},\n      treeGridCfgLot: {},\n      showTreegridLot: false,\n      // selectedEntries data\n      internalEntries: [],\n      bankEntries: [],\n      allotmentEntry: {},\n      filterChanged: false,\n      tabName: null,\n      disableSearchButton: false,\n      noPlanSelected: false,\n      firstTimeBank: true,\n      firstTimeEstab: true,\n      planSelected: null,\n      plans: [],\n      disableSelectPlan: false,\n      firstTime: true,\n      titleModal: null,\n      subTitleModal: null,\n      columnsClasses: {},\n      orderBy: {},\n      headings: {},\n      templates: {},\n      customSorting: {},\n      sortable: [],\n      idsAccountsSelected: [],\n      firstTimeAccount: true,\n      firstTimeEstableshment: true,\n      allotmentDetailsModalObj: null,\n      filterable: [],\n      attList: [],\n      columnsFilterable: [],\n      showCustomColumns: false,\n      customSetOrder: null,\n      filter: {\n        entityId: null\n      },\n      isLoadingStatic: false,\n      shown: {\n        bankAccounts: false,\n        categories: false\n      },\n      inputTagsProps: {\n        bankAccounts: {\n          id: 'id',\n          name: 'nome'\n        },\n        categories: {\n          id: 'id',\n          name: 'nome'\n        }\n      },\n      defaultTags: {\n        bankAccounts: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todos')\n        }],\n        categories: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todas')\n        }]\n      },\n      data: {\n        bankAccounts: {\n          titles: {\n            main: this.$t('extratoBancario.labels.contasBancarias'),\n            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')\n          },\n          allBankAccounts: [],\n          showToggleInactiveAccounts: false,\n          selectedItems: [],\n          considerInactiveAccounts: false,\n          columns: ['nome', 'banco', 'numAgencia', 'conta'],\n          values: [],\n          options: {\n            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },\n            perPage: 5,\n            headings: {\n              nome: this.$t('contaBancaria.labels.nome'),\n              banco: this.$t('contaBancaria.labels.banco'),\n              numAgencia: this.$t('contaBancaria.labels.agencia'),\n              conta: this.$t('contaBancaria.labels.numeroConta')\n            },\n            filterable: ['nome', 'banco', 'numAgencia', 'conta'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['nome', 'banco', 'numAgencia', 'conta'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'nome'\n            },\n            customSorting: {\n              nome: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                  }\n                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n                }\n              },\n              banco: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.banco.codigo <= b.banco.codigo ? 1 : -1\n                  }\n                  return a.banco.codigo >= b.banco.codigo ? 1 : -1\n                }\n              },\n              agencia: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.numAgencia <= b.numAgencia\n                  }\n                  return a.numAgencia >= b.numAgencia\n                }\n              },\n              conta: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return +a.conta >= +b.conta ? 1 : -1\n                  }\n                  return +a.conta <= +b.conta ? 1 : -1\n                }\n              }\n            },\n            templates: {\n              nome: (h, row) => {\n                let txt = row.nome\n                if (!row.ativo) {\n                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'\n                }\n                return txt\n              },\n              banco: (h, row) => {\n                if (row.banco) {\n                  return row.banco.codigo + '-' + row.banco.nome\n                }\n                return '-'\n              },\n              agencia: (h, row) => {\n                let txt = '-'\n                if (row.agencia) {\n                  txt = row.numAgencia\n                  if (row.digAgencia) {\n                    txt += '-' + row.digAgencia\n                  }\n                }\n                return txt\n              },\n              conta: (h, row) => {\n                let txt = row.conta\n                if (row.digConta) {\n                  txt += '-' + row.digConta\n                }\n                return txt\n              }\n            }\n          }\n        },\n        categories: {\n          titles: {\n            main: this.$t('categoria.titulos.titulo'),\n            sub: this.$t('categoria.labels.selecionarCategoria')\n          },\n          selectedItems: [],\n          columns: ['numero', 'nome', 'idContabil', 'tipo'],\n          values: [],\n          options: {\n            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },\n            perPage: 5,\n            headings: {\n              numero: this.$t('categoria.modal.labels.numero'),\n              nome: this.$t('categoria.modal.labels.descricao'),\n              idContabil: this.$t('categoria.modal.labels.idContabil'),\n              tipo: this.$t('categoria.modal.labels.tipo')\n            },\n            filterable: ['numero', 'nome', 'idContabil', 'tipo'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['numero', 'nome', 'idContabil', 'tipo'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'numero'\n            },\n            customSorting: {\n              numero: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.ordem >= b.ordem ? 1 : -1\n                  }\n                  return a.ordem <= b.ordem ? 1 : -1\n                }\n              },\n              nome: function (asc) {\n                return function (a, b) {\n                  if (asc) {\n                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                  }\n                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n                }\n              },\n              idContabil: function (asc) {\n                return function (a, b) {\n                  const idA = a.idContabil\n                  const idB = b.idContabil\n                  if (idA === null || idB === null) {\n                    if (asc) {\n                      return idA === null ? -1 : 1\n                    }\n                    return idA === null ? 1 : -1\n                  }\n                  if (asc) {\n                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase())\n                  }\n                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase())\n                }\n              },\n              tipo: function (asc) {\n                return function (a, b) {\n                  if (asc) {\n                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase())\n                  }\n                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase())\n                }\n              }\n            },\n            templates: {\n              idContabil: (h, row) => {\n                return row.idContabil || '-'\n              },\n              tipo: (h, row) => {\n                return this.$t(`categoria.modal.labels.${row.tipo}`)\n              }\n            }\n          }\n        }\n      }\n    }\n  },\n\n  computed: {\n    showTabs () {\n      return this.showTreegridExt && this.showTreegridMov\n    },\n    hasToUpdateMAnualConcilSearch () {\n      return this.$store.getters.hasToUpdateMAnualConcilSearch\n    },\n\n    idRowMovFinRemoved () {\n      return this.$store.getters.idRowMovFinRemoved\n    },\n\n    idRowBankStatRemoved () {\n      return this.$store.getters.idRowBankStatRemoved\n    },\n\n    idRowAllotmentMovementRemoved () {\n      return this.$store.getters.idRowAllotmentMovementRemoved\n    },\n\n    idRowAllotmentMovementAdded () {\n      return this.$store.getters.idRowAllotmentMovementAdded\n    },\n\n    finMovAdded () {\n      return this.$store.getters.finMovAdded\n    },\n\n    bankStatAdded () {\n      return this.$store.getters.bankStatAdded\n    },\n\n    arrayConciliationPlan () {\n      return this.$store.getters.arrayConciliationPlan\n    },\n\n    needSearchManualConciliationTransactions () {\n      return this.$store.getters.needSearchManualConciliationTransactions\n    },\n\n    modalAllotmentDetails () {\n      return {\n        title: this.$t('conciliacaoManual.titulos.modalAllotmentDetailsTitle'),\n        subtitle: this.$t('conciliacaoManual.titulos.modalAllotmentDetailsSubtitle')\n      }\n    },\n\n    isLoadingDataActionsManualConciliation () {\n      return this.$store.getters.isLoadingData\n    },\n\n    isLoadingDataActionsManualConciliationStatic () {\n      return this.$store.getters.isLoadingStatic\n    },\n\n    arrayJustify () {\n      return this.$store.getters.arrayJustify\n    },\n\n    idsFilterEstablishments () {\n      return this.$store.getters.idsFilterEstablishments\n    },\n\n    loadingMessage () {\n      return this.getKeyTranslated(this.$store.getters.loadingMessage)\n    }\n  },\n\n  watch: {\n    idRowMovFinRemoved () {\n      if (window && window.Grids && window.Grids.ConcManualMovFin) {\n        let row = window.Grids.ConcManualMovFin.GetRowById(this.$store.getters.idRowMovFinRemoved.id)\n        if (!row) {\n          row = _.findWhere(window.Grids.ConcManualMovFin.Rows, { IdMovimentacao: this.$store.getters.idRowMovFinRemoved.idMovimentacao })\n        }\n        if (row && (row.IdMovimentacao === this.$store.getters.idRowMovFinRemoved.idMovimentacao)) {\n          window.Grids.ConcManualMovFin.ShowRow(row)\n        }\n      }\n    },\n\n    idRowBankStatRemoved () {\n      if (window && window.Grids && window.Grids.ConcManualExtBan) {\n        let row = window.Grids.ConcManualExtBan.GetRowById(this.$store.getters.idRowBankStatRemoved.id)\n        if (!row) {\n          row = _.findWhere(window.Grids.ConcManualExtBan.Rows, { IdLancamento: this.$store.getters.idRowBankStatRemoved.idLancamento })\n        }\n        if (row && (row.IdLancamento === this.$store.getters.idRowBankStatRemoved.idLancamento)) {\n          window.Grids.ConcManualExtBan.ShowRow(row)\n        }\n      }\n    },\n\n    idRowAllotmentMovementAdded () {\n      if (window && window.Grids && window.Grids.ConcManualLotes) {\n        let row = window.Grids.ConcManualLotes.GetRowById(this.$store.getters.idRowAllotmentMovementRemoved)\n        if (row) {\n          window.Grids.ConcManualLotes.ShowRow(row)\n        }\n      }\n    },\n\n    // Percorre a lista de movimentos financeiros adicionados verificando se possui apenas lançamentos que não vieram no lote\n    finMovAdded () {\n      this.hasPendingLanc(this.$store.getters.finMovAdded, 'idMovimentacao', 'hasPendingFinMov')\n      this.verifyAndShowAllotment()\n    },\n\n    // Percorre a lista do extrato bancário adicionado verificando se possui apenas lançamentos que não vieram no lote\n    bankStatAdded () {\n      this.hasPendingLanc(this.$store.getters.bankStatAdded, 'idLancamento', 'hasPendingBankStat')\n      this.verifyAndShowAllotment()\n    },\n\n    hasToUpdateMAnualConcilSearch () {\n      if (this.hasToUpdateMAnualConcilSearch) {\n        this.configGridsAndSearch()\n      }\n    },\n\n    needSearchManualConciliationTransactions () {\n      if (this.$store.getters.bankStatAdded.needSearchManualConciliationTransactions) {\n        this.search()\n      }\n    },\n\n    arrayJustify () {\n      if (this.arrayJustify.length > 0) {\n        window.addEventListener('beforeunload', this.confirmExit)\n      } else {\n        window.removeEventListener('beforeunload', this.confirmExit)\n      }\n    }\n  },\n\n  methods: {\n    resetFilter () {\n      this.selectedEstablishments = []\n      this.data.bankAccounts.selectedItems = []\n      this.data.bankAccounts.considerInactiveAccounts = false\n      this.data.categories.selectedItems = []\n    },\n\n    hasPendingLanc (arrayLancAdded, objectToFind, action) {\n      let lancSelecMov = false\n      arrayLancAdded.forEach(mov => {\n        if (objectToFind in mov) {\n          lancSelecMov = true\n        }\n      })\n\n      this.$store.dispatch(action, lancSelecMov)\n        .catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    verifyAndShowAllotment () {\n      let lancSelecFinMovAllotment = true\n      let lancSelecBankStatAllotment = true\n\n      // Percorre o vetor de movimentos financeiros, caso tenha algum registro de algum lote, não vai voltar pra grid\n      this.$store.getters.finMovAdded.forEach(mov => {\n        if ('idLote' in mov) {\n          lancSelecFinMovAllotment = false\n        }\n      })\n\n      // Percorre o vetor de extrato bancário, caso tenha algum registro de algum lote, não vai voltar pra grid\n      this.$store.getters.bankStatAdded.forEach(mov => {\n        if ('idLote' in mov) {\n          lancSelecBankStatAllotment = false\n        }\n      })\n\n      // Se não tiver nenhum registro relacionado ao lote no último container, e ele estiver na grid, exibe novamente na grid\n      if (lancSelecFinMovAllotment && lancSelecBankStatAllotment) {\n        let idAllotment = this.$store.getters.idAllotment\n        this.$store.dispatch('setIdAllotment', null)\n          .then(() => {\n            if (window && window.Grids && window.Grids.ConcManualLotes) {\n              if (idAllotment) {\n                let row = _.findWhere(window.Grids.ConcManualLotes.Rows, { IdLote: idAllotment })\n                if (row) {\n                  window.Grids.ConcManualLotes.ShowRow(row)\n                  window.Grids.ConcManualLotes.Reload()\n                }\n              }\n            }\n          })\n      }\n    },\n\n    badgerify (containerId, counter) {\n      let badgeValue = document.createTextNode(counter)\n      let badge = document.getElementById(containerId + '-badge')\n      if (badge) {\n        badge.textContent = counter\n      } else {\n        let tabSpan = document.querySelector('[aria-controls=\"' + containerId + '\"]').childNodes[0]\n        badge = document.createElement('b-badge')\n        badge.className = 'badge badge-custom'\n        badge.id = containerId + '-badge'\n        badge.appendChild(badgeValue)\n        tabSpan.appendChild(badge)\n      }\n    },\n\n    removeBadge (containerId) {\n      let badge = document.getElementById(containerId + '-badge')\n      if (badge) {\n        badge.remove()\n      }\n    },\n\n    validate () {\n      return new Promise(resolve => {\n        this.$validator.validateAll().then((result) => {\n          if (result && this.$refs.dateRange.validate()) {\n            this.configGridsAndSearch().finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    configGridsAndSearch () {\n      this.noPlanSelected = false\n      this.showTreegridMov = true\n      this.showTreegridExt = true\n      this.showTreegridLot = true\n      return this.search()\n    },\n\n    async search () {\n      this.$store.dispatch('setNeedSearchManualConciliationTransactions', false)\n      this.disableSearchButton = true\n      this.tabName = this.$t('conciliacaoManual.titulos.abaLancamentos')\n      await this.verifyAndCleanAndSetConciliationPlan()\n      await this.hideRowsGrids()\n      await this.buildFilter()\n      await this.startLoading()\n      try {\n        await this.searchTransactionsFormManualConciliation()\n        return Promise.resolve()\n      } catch (e) {\n        return Promise.reject()\n      }\n    },\n\n    verifyAndCleanAndSetConciliationPlan () {\n      return new Promise((resolve, reject) => {\n        let self = this\n        // Verifica se foi modificado o plano de conciliação, caso tenha sido, limpa os valores previamente calculados\n        if (self.$store.getters.arrayConciliationPlan && self.$store.getters.arrayConciliationPlan.length > 0) {\n          let teste = _.indexOf(self.$store.getters.arrayConciliationPlan, this.idPlanSelected)\n          if (teste === -1) {\n            this.$store.dispatch('cleanEditState')\n          }\n        }\n        // Seta no vuex o plano selecionado\n        this.$store.dispatch('setArrayConciliationPlan', this.idPlanSelected).then(() => {\n          resolve()\n        }).catch((error) => {\n          reject(error)\n        })\n      })\n    },\n\n    hideRowsGrids () {\n      return new Promise((resolve, reject) => {\n        let self = this\n        window.Grids.OnRenderFinish = function (G) {\n          G.ReloadBody()\n          // Verifica se possui movimentações adicionadas no terceiro container\n          if (self.$store.getters.finMovAdded && self.$store.getters.finMovAdded.length > 0) {\n            self.$store.getters.finMovAdded.forEach(mov => {\n              let row = _.findWhere(G.Rows, { IdMovimentacao: mov.idMovimentacao })\n              if (row) {\n                G.HideRow(row)\n              }\n            })\n          }\n          // Verifica se possui lançamentos bancários adicionadas no terceiro container\n          if (self.$store.getters.bankStatAdded && self.$store.getters.bankStatAdded.length > 0) {\n            self.$store.getters.bankStatAdded.forEach(mov => {\n              let row = _.findWhere(G.Rows, { IdLancamento: mov.idLancamento })\n              if (row) {\n                G.HideRow(row)\n              }\n            })\n          }\n          G.RenderBody()\n        }\n        resolve()\n      })\n    },\n\n    buildFilter () {\n      return new Promise((resolve, reject) => {\n        let inicio = this.dateRange.fromDate\n        let fim = this.dateRange.toDate\n        this.filter = {\n          inicio: inicio,\n          fim: fim,\n          idsPlanosConciliacao: this.plansSelected.map(plan => plan['id']),\n          idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),\n          idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),\n          considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,\n          idsCategorias: this.data.categories.selectedItems.map(selected => selected.id).filter(categories => categories !== '-1'),\n          lang: language.getCookieByName('language')\n        }\n        this.filterChanged = true\n        resolve()\n      })\n    },\n\n    startLoading () {\n      return new Promise((resolve, reject) => {\n        startTreeGridLoading('#concManualMovFin')\n        startTreeGridLoading('#concManualExtBanc')\n        this.$store.dispatch('hasToUpdateMAnualConcilSearch', false).then(() => {\n          resolve()\n        }).catch((error) => {\n          reject(error)\n        })\n      })\n    },\n\n    searchTransactionsFormManualConciliation () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchTransactionsForManualConciliation', this.filter)\n          .then((response) => {\n            window.DisposeGrids()\n            this.treeGridCfgMov = response.data.treegrid.Cfg.Layout\n            this.resultMov = response.data.treegrid\n            this.treeGridCfgExt = response.data.treegridBankStat.Cfg.Layout\n            this.resultExt = response.data.treegridBankStat\n            this.buttonGridAddRowFinMov()\n            this.buttonGridAddRowBankStat()\n            this.stopLoadingAndConfigureBadge(response)\n            resolve()\n          }).catch((error) => {\n            this.$root.$refs.notification.error(this.$t(error.message))\n            stopTreeGridLoading('#concManualMovFin')\n            stopTreeGridLoading('#concManualExtBanc')\n            // document.querySelector('#pendingProtlet').scrollIntoView({ behavior: 'smooth' })\n            this.disableSearchButton = false\n            reject()\n          })\n      })\n    },\n\n    buttonGridAddRowFinMov () {\n      window.Grids.addRowFinMov = (row) => {\n        trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-mov-financeira', row.SituacaoConciliacao)\n\n        row.isTreeGrid = true\n        this.$store.dispatch('setFinMov', row)\n          .then(() => {\n            window.Grids.ConcManualMovFin.HideRow(row)\n          }).catch((error) => {\n            this.$root.$refs.notification.error(this.$t(error.message))\n          })\n      }\n    },\n\n    buttonGridAddRowBankStat () {\n      window.Grids.addRowBankStat = (row) => {\n        trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-extrato-bancario', row.SituacaoConciliacao)\n\n        row.isTreeGrid = true\n        this.$store.dispatch('setBankStat', row)\n          .then(() => {\n            window.Grids.ConcManualExtBan.HideRow(row)\n          }).catch((error) => {\n            this.$root.$refs.notification.error(this.$t(error.message))\n          })\n      }\n    },\n\n    stopLoadingAndConfigureBadge (response) {\n      stopTreeGridLoading('#concManualMovFin')\n      stopTreeGridLoading('#concManualExtBanc')\n\n      response.data.pendingEntries && response.data.pendingEntries > 0\n        ? this.badgerify('#tab-conciliacoes-pendentes', response.data.pendingEntries)\n        : this.removeBadge('#tab-conciliacoes-pendentes')\n\n      response.data.pendingAllotments && response.data.pendingAllotments > 0\n        ? this.badgerify('#tab-lotes', response.data.pendingAllotments)\n        : this.removeBadge('#tab-lotes')\n\n      this.disableSearchButton = false\n    },\n\n    loadAllotments (tabIndex) {\n      // Somente chama o serviço quando for a segunda aba (lotes) e quando o usuário clicar na busca novamente\n      if (tabIndex === 1 && this.filterChanged) {\n        this.disableSearchButton = true\n        this.filterChanged = false\n        this.showTreegridLot = true\n        startTreeGridLoading('#concManualLotes')\n        let self = this\n        window.Grids.OnRenderFinish = function (G) {\n          // Verifica se possui movimentações do lote adicionadas no terceiro container,\n          // caso possua remove da grid\n          if (self.$store.getters.idAllotment) {\n            let row = _.findWhere(G.Rows, { IdLote: self.$store.getters.idAllotment })\n            if (row) {\n              G.HideRow(row)\n            }\n          }\n        }\n        // Chama a consulta de lotes\n        this.getAllotments()\n      }\n    },\n\n    getAllotments () {\n      this.$store.dispatch('searchAllotments', this.filter)\n        .then((allotmentsResponse) => {\n          if (window.Grids.ConcManualLotes) {\n            window.Grids.ConcManualLotes.DisposeGrids()\n          }\n          this.resultLot = allotmentsResponse.treegridAllotment.Cfg.Layout\n          this.treeGridCfgLot = allotmentsResponse.treegridAllotment\n\n          // Ação do botão da grid de lotes, que carrega os movimentos e adiciona no resumo\n          this.loadAllotmentsMovements()\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n          stopTreeGridLoading('#concManualLotes')\n          document.querySelector('#pendingProtlet').scrollIntoView({ behavior: 'smooth' })\n          this.disableSearchButton = false\n        })\n    },\n\n    loadAllotmentsMovements () {\n      let self = this\n      // Função para adição de lote\n      window.Grids.getAllotmentMovements = (row) => {\n        trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-lote', row.SituacaoConciliacao)\n\n        this.$store.dispatch('setIdAllotment', row.IdLote)\n          .then((response) => {\n            let idAllotmentRemoved = self.$store.getters.idRowAllotmentMovementAdded\n            let data = {\n              'idAllotmentRemoved': idAllotmentRemoved,\n              'row': row\n            }\n            this.$store.dispatch('getAllotmentMov', data)\n              .then((response) => {\n                window.Grids.ConcManualLotes.HideRow(row)\n              }).catch((error) => {\n                this.$root.$refs.notification.error(this.$t(error.message))\n              })\n          }).catch((error) => {\n            this.$root.$refs.notification.error(this.$t(error.message))\n          })\n      }\n\n      // Função para abertura da modal de detalhes\n      window.Grids.openAllotmentDetailsModal = (row) => {\n        // trackAnalyticsEvent(this, 'conciliacao-manual', 'click-add-lote', row.SituacaoConciliacao)\n        self.allotmentDetailsModalObj = {\n          idLote: row.IdLote,\n          dtInicio: row.DtLancInicial,\n          dtFim: row.DtLancFinal,\n          totalMovBan: row.VlExtratoBancario,\n          totalMovFin: row.VlMovimentoFinanceiro,\n          situacao: row.SituacaoConciliacao\n        }\n        setTimeout(() => {\n          self.$refs.tabAllotmentManualConcilModal.createAllotmentDetailsFromManualConcilaition()\n          $('#detalhesLoteConcManual').modal({ backdrop: 'static', keyboard: false })\n        }, 100)\n      }\n      stopTreeGridLoading('#concManualLotes')\n      document.querySelector('#tab-navigation').scrollIntoView({ behavior: 'smooth' })\n      this.disableSearchButton = false\n    },\n\n    saveAndClose () {\n      switch (this.selectModal) {\n        case this.CONCILIATION_PLAN_MODAL:\n          this.plansTags = this.plansSelected.map(plan => plan['nome'])\n          if (this.noPlanSelected) {\n            this.noPlanSelected = false\n            document.getElementsByClassName('vue-input-tag-wrapper')[0].style.border = '1px solid #CCC'\n          }\n          break\n      }\n      this.closeModal()\n    },\n\n    selectItem (item) {\n      item.checked = !item.checked\n      switch (this.selectModal) {\n        case this.CONCILIATION_PLAN_MODALCONCILIATION_PLAN_MODAL:\n          this.selectPlan(item)\n          break\n      }\n    },\n\n    selectPlan (plan) {\n      if (plan === null) {\n        return\n      }\n      this.idPlanSelected = plan.id\n      this.plansSelected = []\n      this.planSelected = plan\n      this.plansSelected.push(plan)\n    },\n\n    loadPlans () {\n      this.selectModal = this.CONCILIATION_PLAN_MODAL\n\n      let url = '/manualConciliation/plans/list'\n      this.$store.dispatch('getPlans', url).then((response) => {\n        this.plans = response.data.data\n        if (response.data.data.length === 1) {\n          this.planSelected = response.data.data[0]\n          this.selectPlan(this.planSelected)\n          this.disableSelectPlan = true\n        }\n      })\n    },\n\n    openSelectBankAccountsModal () {\n      if (this.data.bankAccounts.values.length > 0) {\n        this.shown.bankAccounts = true\n        return\n      }\n      this.$store.dispatch('getBankAccounts', '/manualConciliation/bankAccounts/list')\n        .then(response => {\n          this.data.bankAccounts.allBankAccounts = response.data.data\n          this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {\n            return !bankAccount.ativo\n          })\n          this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {\n            return bankAccount.ativo\n          })\n          this.shown.bankAccounts = true\n        })\n    },\n\n    openSelectCategoriesModal () {\n      if (this.data.categories.values.length > 0) {\n        this.shown.categories = true\n        return\n      }\n      this.$store.dispatch('getCategories', {\n        url: '/manualConciliation/loadCategories',\n        flTipoCategoria: 'A,C,D',\n        validarUso: false\n      })\n        .then((response) => {\n          this.data.categories.values = response.data\n          this.shown.categories = true\n        })\n    },\n\n    closeModal () {\n      this.shown.bankAccounts = false\n      this.shown.categories = false\n    },\n\n    closeAllotmentDetailsModal () {\n      $('#detalhesLoteConcManual').modal('hide')\n    },\n\n    getKeyTranslated (key) {\n      return this.$t(key)\n    }\n  },\n\n  created () {\n    this.messageExit = this.$t('conciliacaoManual.labels.alertJustificativa')\n    this.$store.dispatch('cleanEditState')\n    this.loadPlans()\n  },\n\n  beforeDestroy () {\n    window.removeEventListener('beforeunload', this.confirmExit)\n  }\n}\n</script>\n\n<style scoped>\n@import '../../../../../node_modules/vue-nav-tabs/themes/vue-tabs.css';\n.isLoadingManualConciliationActionsStatic {\n  background: url(../../../../assets/logos_equals/logo_equals_quadrado.svg) 50.5% 49% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.9;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  -webkit-transition: all 5s ease-in-out;\n  -moz-transition: all 5s ease-in-out;\n  -ms-transition: all 5s ease-in-out;\n  -o-transition: all 5s ease-in-out;\n  transition: all 5s ease-in-out;\n}\n\n.isLoadingManualConciliationActions {\n  background: url(../../../../assets/loading-gif/loading.svg) 50% 45% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.9;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  -webkit-transition: all 5s ease-in-out;\n  -moz-transition: all 5s ease-in-out;\n  -ms-transition: all 5s ease-in-out;\n  -o-transition: all 5s ease-in-out;\n  transition: all 5s ease-in-out;\n}\n\n.spanLoading {\n  color: #13556A;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 25px;\n  position: fixed;\n  top: 49%;\n  margin-top: 60px;\n  width: 100%;\n  text-align: center;\n}\n\n#spin:after {\n  content: '';\n  animation: spin 5s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    content: attr(data-content);\n  }\n  100% {\n    content: attr(data-content2);\n  }\n}\n\n#tab-navigation {\n  font-family: 'Inter', sans-serif;\n}\n\n.tab {\n  margin-top: 20px;\n}\n\n.nav-tabs>li>a {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  text-transform: none;\n}\n\n.vue-tabs .nav>li span.title {\n  color: #142C4F;\n}\n\n.vue-tabs .nav-tabs {\n  border-bottom: 2px solid #d6e2f5;\n}\n\n.vue-tabs .nav-tabs>li>a {\n  border: none;\n}\n\n.vue-tabs .nav>li.active span.title {\n  color: #fff;\n}\n\n.vue-tabs .nav-tabs>li.active>a,\n.vue-tabs .nav-tabs>li.active>a:hover,\n.vue-tabs .nav-tabs>li.active>a:focus {\n  border: none;\n  border-top: 5px solid #3bb5b4;\n  color: #fff;\n  background: #142C4F;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 11px;\n}\n\n.vue-tabs .nav-tabs>li>a,\n.vue-tabs .nav-tabs>li>a:hover,\n.vue-tabs .nav-tabs>li>a:focus {\n  border: none;\n  border-top: 5px solid #fff;\n  color: #142C4F;\n  background: #d6e2f5;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 13px;\n}\n\n.pending-title-manual-conciliation {\n  text-align: left;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  margin-top: 3vh;\n  color: #17375f;\n}\n\n.grey-right-border {\n  border-right: solid 2px #cccccc;\n}\n\n.pending-box {\n  padding-right: 25px!important;\n}\n\n.pending-conciliation-box {\n  display: grid;\n}\n\n.centered {\n  text-align: center;\n}\n\n.badge-custom {\n  padding: 7px 2px;\n  margin-left: 1vh;\n  background-color: #f55753 !important;\n  border-radius: 50%;\n  min-width: 30px;\n  margin-top: 21px;\n  right: 2px;\n  z-index: 9;\n  position: absolute;\n}\n\np.placeholderInputTag {\n  z-index: 3;\n  position: absolute;\n  padding: 7px 0px 0px 7px;\n  color: #999;\n}\n\nbutton.filter-input-tag {\n  width: 100%;\n  min-width: auto;\n  padding: 0px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1045 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-248a974b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/notification/Notification.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#toast-container {\n  font-family: 'Inter', sans-serif;\n}\n#toast-container>.toast-success {\n  background-color: #72b372;\n}\n#toast-container>.toast-info {\n  background-color: #56a9c1;\n}\n#toast-container>.toast-warning {\n  background-color: #f7ae45;\n}\n#toast-container>.toast-error {\n  background-color: #c65b55;\n}\n#toast-container>div {\n  opacity: 0.95 !important;\n  padding: 20px 20px 20px 55px !important;\n}\n.toast-close-button {\n  top: -0.6em !important;\n}\n", "", {"version":3,"sources":["/./client/components/notification/Notification.vue?12e3848f"],"names":[],"mappings":";AAqFA;EACA,iCAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,yBAAA;EACA,wCAAA;CACA;AAEA;EACA,uBAAA;CACA","file":"Notification.vue","sourcesContent":["<template lang=\"pug\"></template>\n\n<script>\nimport toastr from 'toastr'\nimport { trackAnalyticsEvent } from '../../utils/analytics.js'\n\nexport default {\n  name: 'Notification',\n\n  data () {\n    return {\n      toastr: toastr,\n      options: {\n        'closeButton': true,\n        'debug': false,\n        'newestOnTop': true,\n        'progressBar': true,\n        'positionClass': 'toast-top-right',\n        'preventDuplicates': true,\n        'onclick': null,\n        'showDuration': '300',\n        'hideDuration': '1000',\n        'timeOut': '5000',\n        'extendedTimeOut': '2000',\n        'showEasing': 'swing',\n        'hideEasing': 'linear',\n        'showMethod': 'fadeIn',\n        'hideMethod': 'fadeOut'\n      }\n    }\n  },\n\n  methods: {\n    remove () {\n      this.toastr.remove()\n    },\n    clear () {\n      this.toastr.clear()\n    },\n    success (message, title) {\n      trackAnalyticsEvent(this, 'notification', 'success', this.translate(message))\n      this.toastr.success(this.translate(message), this.translate(title))\n    },\n    info (message, title) {\n      trackAnalyticsEvent(this, 'notification', 'info', this.translate(message))\n      this.toastr.info(this.translate(message), this.translate(title))\n    },\n    warning (message, title) {\n      trackAnalyticsEvent(this, 'notification', 'warning', this.translate(message))\n      this.toastr.warning(this.translate(message), this.translate(title))\n    },\n    error (message, title) {\n      trackAnalyticsEvent(this, 'notification', 'error', this.translate(message))\n      this.toastr.error(this.translate(message), this.translate(title))\n    },\n    // Permitira maior flexibilidade com as mensagens,\n    // não ficando preso ao translate interno do componente\n    global (type, message, title) {\n      switch (type) {\n        case 'S':\n          this.toastr.success(message, title)\n          break\n        case 'I':\n          this.toastr.info(message, title)\n          break\n        case 'W':\n          this.toastr.warning(message, title)\n          break\n        case 'E':\n          this.toastr.error(message, title)\n          break\n      }\n    },\n    translate (key) {\n      return this.$t(key)\n    }\n  },\n\n  created () {\n    this.toastr.options = this.options\n  }\n}\n</script>\n\n<style>\n#toast-container {\n  font-family: 'Inter', sans-serif;\n}\n\n#toast-container>.toast-success {\n  background-color: #72b372;\n}\n\n#toast-container>.toast-info {\n  background-color: #56a9c1;\n}\n\n#toast-container>.toast-warning {\n  background-color: #f7ae45;\n}\n\n#toast-container>.toast-error {\n  background-color: #c65b55;\n}\n\n#toast-container>div {\n  opacity: 0.95 !important;\n  padding: 20px 20px 20px 55px !important;\n}\n\n.toast-close-button {\n  top: -0.6em !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1046 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-265147fb","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/administration/auditLog/AuditModal.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#auditModal {\n  font-family: 'Inter', sans-serif;\n  z-index: 100000000;\n}\n.tree-view {\n  margin-top: 10px;\n  background-color: rgba(236, 244, 247, 1);\n  padding-top:10px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n/*Tree view*/\nul#treeView {\n  font-family: 'Inter', sans-serif;\n -webkit-padding-start: 15px!important;\n  margin-top: 10px\n}\n#treeView li{\n  list-style: none;\n  margin: 4px;\n  border: none;\n  padding-left: 10px;\n  background-clip: blue;\n  -webkit-padding-start: 0px !important;\n  margin-bottom: 8px;\n}\n#treeView ul {\n  padding-left: 1em;\n  border-left: solid 1px #1E1F20;\n  margin: 0;\n  padding: 5px 0 0 0;\n  margin-left: 12px;\n}\n#treeView b {\n  background: rgba(0, 94, 120, 1) !important;\n  border: solid 1px rgba(0, 94, 120, 1);\n  color: rgba(255, 255, 255, 1) !important;\n  text-align: center;\n  line-height: 9px;\n  cursor: pointer;\n  margin-left: -15px;\n  margin-right: 5px;\n  padding: 0px 5px;\n}\n#treeView span {\n  color: #333;\n  font-weight: bold;\n}\n#treeView label {\n  padding: 2px 3px;\n  font-weight: normal;\n}\n.modal-auditoria-tit {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: bold;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\np.modal-auditoria-left-txt {\n  font-size: 12px;\n  margin-bottom: 5px;\n  color: rgba(32, 32, 32, 1);\n}\n", "", {"version":3,"sources":["/./client/components/administration/auditLog/AuditModal.vue?5f0ef7fb"],"names":[],"mappings":";AA0IA;EACA,iCAAA;EACA,mBAAA;CACA;AAEA;EACA,iBAAA;EACA,yCAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;CACA;;AAEA,aAAA;AACA;EACA,iCAAA;CACA,sCAAA;EACA,gBAAA;CACA;AAEA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mBAAA;CACA;AAEA;EACA,kBAAA;EACA,+BAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,2CAAA;EACA,sCAAA;EACA,yCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;EACA,oBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;CACA;AAEA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;CACA","file":"AuditModal.vue","sourcesContent":["<template src='./auditModal.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport Modal from '../../modals/modal/Modal'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport ButtonPrint from '../../buttons/buttonPrint/ButtonPrint'\nimport language from '../../../../build/language/index'\n\nmoment.locale(language.getDatePickerLanguage())\n\nexport default {\n  name: 'AuditModal',\n\n  components: {\n    Modal,\n    ButtonPrimary,\n    ButtonPrint\n  },\n\n  props: {\n    audit: {\n      type: Object,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      modalTitle: this.$t('logDeAuditoria.labels.logDeAuditoria'),\n      modalSubtitle: this.$t('logDeAuditoria.labels.logDeAuditoria'),\n      userName: '',\n      login: '',\n      accessProfile: '',\n      functionality: '',\n      transaction: '',\n      transactionDate: '',\n      ip: '',\n      workStation: '',\n      entity: '',\n      entityId: ''\n    }\n  },\n\n  watch: {\n    audit () {\n      this.modalTitle = this.audit.tituloModal\n      this.userName = this.audit.nomeUsuario\n      this.login = this.audit.login\n      this.accessProfile = this.audit.nomePerfil\n      this.functionality = this.audit.funcionalidade ? this.audit.funcionalidade.nome : ''\n      this.transaction = this.audit.transacao ? this.audit.transacao.nome : ''\n      this.transactionDate = moment(this.audit.dataTransacao).format('DD/MM/YYYY HH:mm:ss')\n      this.ip = this.audit.numeroIP\n      this.workStation = this.audit.numeroIP\n      this.entity = this.audit.entidade ? this.audit.entidade.numero : ''\n      this.entityId = this.audit.idEntidade\n      this.loadData()\n    }\n  },\n\n  methods: {\n    loadData () {\n      $('#treeView > li').empty()\n      let xmlText = null\n      let xmlObjetct = null\n\n      xmlText = this.audit.xmlEntidade\n      xmlObjetct = jQuery.parseXML(xmlText)\n      this.toXml(xmlObjetct)\n    },\n\n    toXml (tree) {\n      this.traverse($('#treeView li'), tree.firstChild)\n      // this – is an &mdash\n      $('<b>-</b>').prependTo('#treeView li:has(li)').click(function () {\n        let sign = $(this).text()\n        if (sign === '-') {\n          let next = $(this).text('+').next()[0]\n          next.innerText = $(this).next().text() + ' ...'\n          $(this).text('+').next().next().hide()\n        } else {\n          let next = $(this).text('+').next()[0]\n          next.innerText = $(this).next().text().replace(' ...', '')\n          $(this).text('-').next().next().show()\n        }\n      })\n    },\n\n    traverse (node, tree) {\n      let children = $(tree).children()\n      let self = this\n\n      if (tree.children && tree.children.length) {\n        children = tree.children\n\n        node.append('<label>' + tree.nodeName + '</label>')\n        let ul = $('<ul>').appendTo(node)\n\n        var li = null\n\n        for (let i = 0; i < children.length; i++) {\n          li = $('<li>').appendTo(ul)\n          self.traverse(li, children[i])\n        }\n      } else {\n        if (tree.nodeName === 'lang') {\n          node.append('<label>linguagemDoSistema: </label>')\n        } else {\n          node.append('<label>' + tree.nodeName + ': </label>')\n        }\n\n        if ($(tree).text() === 'true') {\n          $('<span> Sim</span>').appendTo(node)\n        } else if ($(tree).text() === 'false') {\n          $('<span> Não</span>').appendTo(node)\n        } else {\n          if ($(tree).text().length === 10 && ($(tree).text().split('-').length - 1) === 2) {\n            $('<span> ' + this.handleText($(tree).text()) + '</span>').appendTo(node)\n          } else {\n            $('<span> ' + $(tree).text() + '</span>').appendTo(node)\n          }\n        }\n      }\n    },\n\n    handleText (text) {\n      return moment(text).format('DD/MM/YYYY')\n    },\n\n    closeModal () {\n      $('#auditModal').modal('hide')\n    }\n  }\n}\n</script>\n\n<style>\n#auditModal {\n  font-family: 'Inter', sans-serif;\n  z-index: 100000000;\n}\n\n.tree-view {\n  margin-top: 10px;\n  background-color: rgba(236, 244, 247, 1);\n  padding-top:10px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n/*Tree view*/\nul#treeView {\n  font-family: 'Inter', sans-serif;\n -webkit-padding-start: 15px!important;\n  margin-top: 10px\n}\n\n#treeView li{\n  list-style: none;\n  margin: 4px;\n  border: none;\n  padding-left: 10px;\n  background-clip: blue;\n  -webkit-padding-start: 0px !important;\n  margin-bottom: 8px;\n}\n\n#treeView ul {\n  padding-left: 1em;\n  border-left: solid 1px #1E1F20;\n  margin: 0;\n  padding: 5px 0 0 0;\n  margin-left: 12px;\n}\n\n#treeView b {\n  background: rgba(0, 94, 120, 1) !important;\n  border: solid 1px rgba(0, 94, 120, 1);\n  color: rgba(255, 255, 255, 1) !important;\n  text-align: center;\n  line-height: 9px;\n  cursor: pointer;\n  margin-left: -15px;\n  margin-right: 5px;\n  padding: 0px 5px;\n}\n\n#treeView span {\n  color: #333;\n  font-weight: bold;\n}\n\n#treeView label {\n  padding: 2px 3px;\n  font-weight: normal;\n}\n\n.modal-auditoria-tit {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: bold;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\np.modal-auditoria-left-txt {\n  font-size: 12px;\n  margin-bottom: 5px;\n  color: rgba(32, 32, 32, 1);\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1047 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-28cf8108","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/bankBalance/BankBalance.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.input-button>button[data-v-28cf8108] {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n#logDeAuditoriaWrapper[data-v-28cf8108] {\n  width: 100%;\n}\n#divTreeGridAuditoria[data-v-28cf8108] {\n  min-width: 100%;\n  min-height: 500px;\n}\n.check[data-v-28cf8108] {\n  text-align: center;\n}\n.filterButton[data-v-28cf8108] {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search[data-v-28cf8108] {\n  width: 53.5%;\n}\n.search-button[data-v-28cf8108] {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/views/reports/bankBalance/BankBalance.vue?73036000"],"names":[],"mappings":";AAsRA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA","file":"BankBalance.vue","sourcesContent":["<template src='./bankBalance.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport BetterInputTag from '../../../input/betterInputTag/BetterInputTag'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport axios from '../../../../../build/http-requests/axios-common.js'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\nimport selectTag from '../../../../events/selectTag'\n\nexport default {\n  name: 'BankBalance',\n\n  components: {\n    MultiSelectModal,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    BetterInputTag,\n    ButtonPrimary,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      inputTagsProps: {\n        bankAccounts: {\n          id: 'id',\n          name: 'nome'\n        }\n      },\n      data: {\n        bankAccounts: {\n          titles: {\n            main: this.$t('saldoBancario.labels.contasBancarias'),\n            sub: this.$t('saldoBancario.labels.selecionarContasBancarias')\n          },\n          allBankAccounts: [],\n          showToggleInactiveAccounts: false,\n          selectedItems: [],\n          considerInactiveAccounts: false,\n          columns: ['nome', 'banco', 'numAgencia', 'conta'],\n          values: [],\n          options: {\n            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },\n            perPage: 5,\n            headings: {\n              nome: this.$t('contaBancaria.labels.nome'),\n              banco: this.$t('contaBancaria.labels.banco'),\n              numAgencia: this.$t('contaBancaria.labels.agencia'),\n              conta: this.$t('contaBancaria.labels.numeroConta')\n            },\n            filterable: ['nome', 'banco', 'numAgencia', 'conta'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['nome', 'banco', 'numAgencia', 'conta'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'nome'\n            },\n            customSorting: {\n              nome: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                  }\n                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n                }\n              },\n              banco: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.banco.codigo <= b.banco.codigo ? 1 : -1\n                  }\n                  return a.banco.codigo >= b.banco.codigo ? 1 : -1\n                }\n              },\n              agencia: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.numAgencia <= b.numAgencia\n                  }\n                  return a.numAgencia >= b.numAgencia\n                }\n              },\n              conta: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return +a.conta >= +b.conta ? 1 : -1\n                  }\n                  return +a.conta <= +b.conta ? 1 : -1\n                }\n              }\n            },\n            templates: {\n              nome: (h, row) => {\n                let txt = row.nome\n                if (!row.ativo) {\n                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'\n                }\n                return txt\n              },\n              banco: (h, row) => {\n                if (row.banco) {\n                  return row.banco.codigo + '-' + row.banco.nome\n                }\n                return '-'\n              },\n              agencia: (h, row) => {\n                let txt = '-'\n                if (row.agencia) {\n                  txt = row.numAgencia\n                  if (row.digAgencia) {\n                    txt += '-' + row.digAgencia\n                  }\n                }\n                return txt\n              },\n              conta: (h, row) => {\n                let txt = row.conta\n                if (row.digConta) {\n                  txt += '-' + row.digConta\n                }\n                return txt\n              }\n            }\n          }\n        }\n      },\n      shown: {\n        bankAccounts: false\n      },\n      defaultTags: {\n        bankAccounts: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todos')\n        }]\n      },\n      groupingOptions: {\n        prop: 'grupo.id',\n        groupIdProp: 'id',\n        headerNameProp: 'nome',\n        defaultIdGroup: '0'\n      },\n      groups: [],\n      gridId: '#SaldoConta',\n      treeGridCfg: {},\n      BANK_ACCOUNT_MODAL: 'bankAccountsModal',\n      audit: {},\n      dateRange: {},\n      bankAccountsSelected: [],\n      bankAccountsTags: [this.$t('inputTag.labels.todos')],\n      firstDate: new Date(),\n      finalDate: new Date(),\n      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      filter: {\n        entityId: null\n      },\n      result: {},\n      treeGridFileName: 'SaldoBancario',\n      error: false,\n      msgError: '',\n      disableSearchButton: false,\n      idsItensSelected: []\n    }\n  },\n\n  methods: {\n    validate () {\n      const self = this\n      return new Promise(resolve => {\n        self.$validator.validateAll().then((result) => {\n          if (result && self.$refs.dateRange.validate()) {\n            self.showTreegrid = true\n            startTreeGridLoading(self.gridId)\n            self.search().finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    search () {\n      this.disableSearchButton = true\n      let filter = {\n        inicio: this.dateRange.fromDate,\n        fim: this.dateRange.toDate,\n        idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),\n        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,\n        lang: language.getCookieByName('language')\n      }\n\n      return new Promise((resolve, reject) => {\n        axios.post('/bankBalance/', { filter: filter }).then((response) => {\n          if (window.Grids[0]) {\n            window.DisposeGrids()\n          }\n          this.result = response.data\n          response.data.Body[0].forEach(item => {\n            if (item.NomeEstabelecimentoGrupo === '') {\n              item.NomeEstabelecimentoGrupo = this.$t('contaBancaria.labels.semGrupo')\n            }\n          })\n          this.treeGridCfg = response.data.Cfg.Layout\n          this.showTreegrid = true\n          stopTreeGridLoading(this.gridId)\n          this.disableSearchButton = false\n          resolve()\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n          stopTreeGridLoading(this.gridId)\n          this.disableSearchButton = false\n          reject()\n        })\n      })\n    },\n\n    async openSelectBankAccountsModal () {\n      if (this.data.bankAccounts.values.length > 0) {\n        this.shown.bankAccounts = true\n        return\n      }\n      const bankAccounts = await this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list')\n      this.data.bankAccounts.allBankAccounts = bankAccounts.data.data\n      this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {\n        return !bankAccount.ativo\n      })\n      this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {\n        return bankAccount.ativo\n      })\n      const groups = await this.$store.dispatch('getEstablishmentGroups')\n      this.groups = groups\n      this.groups.push({\n        id: 0,\n        nome: this.$t('contaBancaria.labels.semGrupo')\n      })\n      this.shown.bankAccounts = true\n    },\n\n    closeModal () {\n      this.shown.bankAccounts = false\n    }\n  },\n\n  mounted () {\n    selectTag.$on('tagsSelected', (tags, idsItensSelected) => {\n      this.bankAccountsTags = tags\n      this.idsItensSelected = idsItensSelected\n    })\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.check {\n  text-align: center;\n}\n\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search {\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1048 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-292a2a0b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/treeViewHistoric/TreeviewHistoric.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.treeviewHistoric {\n  font-family: 'Inter', sans-serif;\n  min-height: 20px;\n  padding: 0px 5px;\n  line-height: initial;\n}\n.childrenObject {\n  border-left: 1px solid #046582;\n  margin-left: 16px;\n  padding: 8px 0px 12px 17px;\n  font-family: 'Inter', sans-serif;\nfont-weight: 400;\n  color: #2A2A2A;\n  font-size: 14px;\n}\n.acaoMain {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #046582;\n  font-size: 14px;\n  margin-bottom: -2px;\n  height: 16px;\n  border: none;\n  padding-bottom: 0px;\n  margin-top: -2px;\n}\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: none;\n}\n.treeRowBg {\n  background: #617a95 !important;\n  border: solid 1px #3c5e82;\n  font-weight: bold;\n  color: #ffffff;\n}\nbutton.action.btn-fa-expand {\n  color: #046582;\n  border: none !important;\n  margin: 1px 5px 0 5px;\n  width:23px;\n  float:left;\n}\n.item {\n  cursor: pointer;\n}\n.bold {\n  font-weight: bold;\n}\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n.treeMargin {\n  margin-left: 0px;\n}\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n.nodeClicked {\n  -ms-transform: rotate(90deg);\n      transform: rotate(90deg);\n}\n", "", {"version":3,"sources":["/./client/components/treeViewHistoric/TreeviewHistoric.vue?769545b9"],"names":[],"mappings":";AA8QA;EACA,iCAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;CACA;AAEA;EACA,+BAAA;EACA,kBAAA;EACA,2BAAA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;EACA,YAAA;CACA;AAEA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;CACA;AAEA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;CACA;AAEA;EACA,eAAA;EACA,wBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,eAAA;CACA;AAEA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,sCAAA;CACA;AAEA;EACA,6BAAA;MAAA,yBAAA;CACA","file":"TreeviewHistoric.vue","sourcesContent":["<script>\nlet id = 1000\nlet fromData = ''\nlet toData = ''\nlet fromParentModelChildren = ''\nlet nodeClicked = null\n\nimport moment from 'moment'\nimport LogTransacaoEnum from '../../enum/logTransacao'\nimport SituacaoTarefaEnum from '../../enum/situacaoTarefa'\n\nexport default {\n  name: 'TreeviewHistoric',\n\n  props: {\n    model: Object,\n    buttonsTitle: Object,\n    clickFunction: Function,\n    id: String,\n    father: Object,\n    defaultText: String,\n    currentHighlight: Boolean,\n    hoverColor: String,\n    highlightColor: String,\n    spaceLeft: String,\n    styleObj: Object\n  },\n\n  data: function () {\n    return {\n      open: true,\n      isClicked: true,\n      title: '',\n      situation: '',\n      dateFomated: null\n    }\n  },\n\n  computed: {\n    isFolder () {\n      return this.model.children &&\n        this.model.children.length\n    }\n  },\n\n  template: `<div class=\"treeviewHistoric\">\n              <div :id='model.id' draggable='false' @dragstart='dragStart' @dragover='dragOver' @dragenter='dragEnter' @dragleave='dragLeave' @drop='drop' @dragend='dragEnd' class='col-xs-12 acaoMain pl-0' @mouseover='mouseOver' @mouseout='mouseOut' :style='styleObj'>\n                <button v-if=\"!isClicked\" :title=\"[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : '']\" @click=\"toggle\" class=\"fa fa-plus-square px-0 action btn-fa-expand\"></button>\n                <button v-if=\"isClicked\" :title=\"[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : '']\" @click=\"toggle\" class=\"fa fa-minus-square px-0 action btn-fa-expand\"></button>\n                <div :style='spaceLeft' class=\"col-xs-10 pl-0\">\n                  {{title}} | {{dateFomated}}\n                </div>\n              </div>\n              <div class=\"clear\"></div>\n              <div v-if=\"!open\" style=\"min-height:20px;\"></div>\n              <div v-if=\"open\" class=\"childrenObject\">\n                <div style=\"margin-bottom:5px;\">{{model.usuario && model.usuario.nome ? model.usuario.nome : '-'}}</div>\n                <div><b>{{situation != null ? situation : '-'}}</b></div>\n                <div>{{model.descricao ? model.descricao : '-'}}</div>\n              </div>\n            </div>`,\n\n  methods: {\n    getTitLabel () {\n      this.title = this.$t('logTransacao.' + LogTransacaoEnum[this.model.idTransacao])\n    },\n\n    getSituationTaskLabel () {\n      this.situation = this.model.situacao != null\n        ? this.$t('situacaoTarefa.' + SituacaoTarefaEnum[this.model.situacao])\n        : null\n    },\n\n    getDateFormated () {\n      this.dateFomated = moment(this.model.data).format('lll')\n    },\n\n    toggle () {\n      this.open = !this.open\n      let rootTree = this.findRoot()\n\n      this.isClicked = !this.isClicked\n\n      if (this.currentHighlight) {\n        if (nodeClicked !== this.model.id) {\n          let treeParent = rootTree.$parent\n          let nodeStack = [treeParent.$children[0]]\n          while (nodeStack.length !== 0) {\n            let item = nodeStack.shift()\n            item.styleObj.background = 'white'\n            if (item.$children && item.$children.length > 0) {\n              nodeStack = nodeStack.concat(item.$children)\n            }\n          }\n          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF'\n          nodeClicked = this.model.id\n        }\n      }\n    },\n\n    exchangeData (rootCom, from, to) {\n      if (!to || !from || typeof to === 'string' || from.id === to.id) {\n        return\n      }\n\n      from = JSON.parse(JSON.stringify(from))\n      to = JSON.parse(JSON.stringify(to))\n      // copy\n      let treeData = JSON.parse(JSON.stringify(this.model))\n      let nodeStack = [treeData]\n      let status = 0\n\n      try {\n        while (!(status === 2)) {\n          let item = nodeStack.shift()\n          if (item.id === from.id) {\n            item.id = to.id\n            item.name = to.name\n            if (to.children && to.children.length > 0) {\n              item['children'] = to.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.id === to.id) {\n            item.id = from.id\n            item.name = from.name\n            if (from.children && from.children.length > 0) {\n              item['children'] = from.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.children && item.children.length > 0) {\n            nodeStack = nodeStack.concat(item.children)\n          }\n        }\n      } catch (e) {\n        return\n      }\n      rootCom.assignData(treeData)\n    },\n\n    changeType () {\n      if (this.currentHighlight) {\n        nodeClicked = this.model.id\n      }\n      if (!this.isFolder) {\n        this.$set(this.model, 'children', [])\n        this.addChild()\n        this.open = true\n        this.isClicked = true\n      }\n    },\n\n    mouseOver (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2'\n        }\n      }\n    },\n\n    mouseOut (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = 'white'\n        }\n      }\n    },\n\n    findRoot () {\n      let ok = false\n      let that = this\n      while (!ok) {\n        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {\n          ok = true\n          break\n        }\n        that = that.$parent\n      }\n      return that\n    },\n\n    addChild () {\n      this.model.children.push({\n        name: this.defaultText ? this.defaultText : 'New Node',\n        id: id++\n      })\n    },\n\n    removeChild (id) {\n      let parentModelChildren = this.$parent.model.children\n      for (let index in parentModelChildren) {\n        if (parentModelChildren[index].id === id) {\n          parentModelChildren = parentModelChildren.splice(index, 1)\n          break\n        }\n      }\n    },\n\n    dragStart (e) {\n      e.dataTransfer.effectAllowed = 'move'\n      e.dataTransfer.setData('nottext', e.target.innerHTML)\n      return true\n    },\n\n    dragEnd (e) {\n      fromData = undefined\n      toData = undefined\n      fromParentModelChildren = undefined\n    },\n\n    dragOver (e) {\n      e.preventDefault()\n      return true\n    },\n\n    dragOverPlus (e) {\n      e.preventDefault()\n    },\n\n    dragEnterPlus (e) {\n    },\n\n    dragEnter (e) {\n      toData = this.model\n      let rootTree = this.findRoot()\n      rootTree.exchangeData(rootTree.$parent, fromData, toData)\n    },\n\n    dragLeave (e) {\n      fromData = this.model\n      fromParentModelChildren = this.$parent.model.children\n    },\n\n    drop (e) {\n    },\n\n    dropPlus (e) {\n      if (this.model.hasOwnProperty('children')) {\n        this.model.children.push(fromData)\n      } else {\n        this.model.children = [fromData]\n      }\n      for (let i in fromParentModelChildren) {\n        if (fromParentModelChildren[i].id === fromData.id) {\n          fromParentModelChildren.splice(i, 1)\n        }\n      }\n    }\n  },\n\n  beforeCreate () {\n    this.$options.components.item = require('./TreeviewHistoric')\n  },\n\n  mounted () {\n    this.getTitLabel()\n    this.getSituationTaskLabel()\n    this.getDateFormated()\n  }\n}\n</script>\n\n<style>\n.treeviewHistoric {\n  font-family: 'Inter', sans-serif;\n  min-height: 20px;\n  padding: 0px 5px;\n  line-height: initial;\n}\n\n.childrenObject {\n  border-left: 1px solid #046582;\n  margin-left: 16px;\n  padding: 8px 0px 12px 17px;\n  font-family: 'Inter', sans-serif;\nfont-weight: 400;\n  color: #2A2A2A;\n  font-size: 14px;\n}\n\n.acaoMain {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #046582;\n  font-size: 14px;\n  margin-bottom: -2px;\n  height: 16px;\n  border: none;\n  padding-bottom: 0px;\n  margin-top: -2px;\n}\n\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: none;\n}\n\n.treeRowBg {\n  background: #617a95 !important;\n  border: solid 1px #3c5e82;\n  font-weight: bold;\n  color: #ffffff;\n}\n\nbutton.action.btn-fa-expand {\n  color: #046582;\n  border: none !important;\n  margin: 1px 5px 0 5px;\n  width:23px;\n  float:left;\n}\n\n.item {\n  cursor: pointer;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n\n.treeMargin {\n  margin-left: 0px;\n}\n\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n\n.nodeClicked {\n  transform: rotate(90deg);\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1049 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2a9b0864","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/massDeclassifyModal/MassDeclassifyModal.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.declassify-title[data-v-2a9b0864] {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  padding: 0px 0px 5px 15px;\n  font-size: 15px;\n}\n.form-control[disabled][data-v-2a9b0864], fieldset[disabled] .form-control[data-v-2a9b0864] {\n  cursor: not-allowed;\n  font-weight: bold;\n  color: #626262;\n}\n", "", {"version":3,"sources":["/./client/components/modals/massDeclassifyModal/MassDeclassifyModal.vue?5fe40db2"],"names":[],"mappings":";AA6PA;EACA,iCAAA;AACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;CACA;AAEA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;CACA","file":"MassDeclassifyModal.vue","sourcesContent":["<template src='./massDeclassifyModal.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport vSelect from 'vue-select'\nimport ConfirmModal from '../../modals/confirmModal/ConfirmModal'\nimport Modal from '../../modals/modal/Modal'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\nimport { maskThousand } from '../../../utils/numberMasker.js'\n\nexport default {\n  name: 'MassDeclassifyModal',\n\n  components: {\n    vSelect,\n    ConfirmModal,\n    Modal,\n    ButtonPrimary\n  },\n\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    gridId: {\n      type: String,\n      required: true\n    },\n    listIdExt: {\n      type: Array,\n      required: true\n    },\n    listRowsD: {\n      type: Array,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      columns: [],\n      options: {\n        columnsClasses: {},\n        headings: {},\n        filterable: false,\n        perPageValues: [],\n        perPage: 5,\n        texts: {\n          count: this.$t('dataTable.labels.contagem'),\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filter: null,\n          filterPlaceholder: null\n        },\n        pagination: {},\n        sortable: [],\n        sortIcon: {\n          is: ''\n        }\n      },\n      items: [],\n      idsContalancamento: [],\n      idsContalancamentoDesclassificaveis: [],\n      message: null,\n      invalid: false,\n      isLoadingData: false\n    }\n  },\n\n  computed: {\n    loggedUser () {\n      return this.$store.getters.user\n    },\n\n    modalTitle () {\n      return this.$t('desclassificacaoEmMassa.titulos.titulo')\n    },\n\n    modalSubtitle () {\n      return this.$t('desclassificacaoEmMassa.titulos.subtitulo')\n    },\n\n    portletTable () {\n      return `${this.$t('desclassificacaoEmMassa.titulos.portletTable')}: ${this.items.length}`\n    },\n\n    portletForm () {\n      return `${this.$t('desclassificacaoEmMassa.titulos.portletForm')}: ${this.listIdExt.length - this.items.length}`\n    },\n\n    enableSave () {\n      return this.items.length > 0 && this.items.length < 101\n    }\n  },\n\n  watch: {\n    listRowsD () {\n      this.$nextTick(() => {\n        this.$validator.reset()\n      })\n      this.showDataTableD()\n      this.isLoadingData = false\n    }\n  },\n\n  methods: {\n    openModalConfirm () {\n      $('#confirmDeclassifyMass').modal('show')\n    },\n\n    closeModalConfirm () {\n      $('#confirmDeclassifyMass').modal('hide')\n    },\n\n    validateD () {\n      this.closeModalConfirm()\n      this.isLoadingData = true\n      this.$validator.validateAll().then((result) => {\n        if (result) {\n          this.desclassificarEmMassa()\n          this.$nextTick(() => {\n            this.$validator.reset()\n          })\n        } else {\n          this.isLoadingData = false\n        }\n      })\n    },\n\n    desclassificarEmMassa () {\n      this.items.forEach(item => { this.idsContalancamentoDesclassificaveis.push(item.IdLancamento) })\n      let data = {\n        idsContaLancamento: this.idsContalancamentoDesclassificaveis\n      }\n      this.idsContalancamentoDesclassificaveis = []\n      this.$store.dispatch('declassifyBankMovementList', data)\n        .then((response) => {\n          this.$root.$refs.notification.success(response.message)\n          this.isLoadingData = false\n          $('#' + this.id).modal('hide')\n        })\n        .catch((error) => {\n          this.isLoadingData = false\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    trackCloseEvent () {\n      this.$nextTick(() => {\n        this.$validator.reset()\n      })\n      trackAnalyticsEvent(this, 'mass-declassify-modal', 'titlebar-close-click', this.id)\n      $('#' + this.id).modal('hide')\n    },\n\n    showDataTableD () {\n      this.idsContalancamento = this.listIdExt\n      switch (this.gridId) {\n        case 'ExtratoConta':\n          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt)\n            .then(() => {\n              this.mountDataTableBankStat()\n            })\n          break\n      }\n    },\n\n    prepareList () {\n      this.items = []\n      this.listRowsD.forEach(item => {\n        if (item['SituacaoConcil'] === 'A') {\n          this.items.push({\n            ID: item.IdLancamento,\n            IdLancamento: item.IdLancamento,\n            DsHistorico: item.DsHistorico,\n            DtLanc: item.DtLanc ? moment.utc(item.DtLanc).format('l') : ' - ',\n            Banco: item.Banco ? item.Banco : ' - ',\n            NomeConta: item.NomeConta ? item.NomeConta : ' - ',\n            Agencia: item.Agencia ? item.Agencia : ' - ',\n            NrConta: item.NrConta ? item.NrConta : ' - ',\n            Valor: maskThousand(item.Tipo === 'C' ? item.VlLancCred : item.VlLancDeb),\n            CritClassif: item.CritClassif && item.CritClassif !== this.$t('extratoBancario.labels.naoClassificado') ? item.CritClassif : this.$t('desclassificacaoEmMassa.labels.classificadoManualmente')\n          })\n        }\n      })\n    },\n\n    removeEntry (entry) {\n      let index = -1\n      this.items.forEach(item => {\n        if (item.ID === entry.ID) {\n          index = this.items.indexOf(item)\n        }\n      })\n      if (index >= 0) {\n        this.items.splice(index, 1)\n      }\n      switch (this.gridId) {\n        case 'ExtratoConta':\n          let indexCL = this.idsContalancamento.findIndex(item => item === entry.ID)\n          if (indexCL >= 0) {\n            this.idsContalancamento.splice(indexCL, 1)\n          }\n          break\n      }\n    },\n\n    mountDataTableBankStat () {\n      this.prepareList()\n      this.columns = [\n        'IdLancamento',\n        'DtLanc',\n        'Valor',\n        'DsHistorico',\n        'CritClassif',\n        'Banco',\n        'NomeConta',\n        'Agencia',\n        'NrConta',\n        'acoes'\n      ]\n      this.options.headings = {\n        IdLancamento: this.$t('desclassificacaoEmMassa.colunas.IdLancamento'),\n        DtLanc: this.$t('desclassificacaoEmMassa.colunas.DtLanc'),\n        Banco: this.$t('desclassificacaoEmMassa.colunas.Banco'),\n        NomeConta: this.$t('desclassificacaoEmMassa.colunas.NomeConta'),\n        Agencia: this.$t('desclassificacaoEmMassa.colunas.Agencia'),\n        NrConta: this.$t('desclassificacaoEmMassa.colunas.NrConta'),\n        Valor: this.$t('desclassificacaoEmMassa.colunas.Valor'),\n        CritClassif: this.$t('desclassificacaoEmMassa.colunas.CritClassif'),\n        DsHistorico: this.$t('desclassificacaoEmMassa.colunas.DsHistorico'),\n        acoes: this.$t('administracao.perfilAcesso.labels.acoes')\n      }\n      this.options.columnsClasses = {\n        'IdLancamento': 'col-1 limit-char',\n        'DtLanc': 'col-1 limit-char',\n        'Banco': 'col-1 limit-char',\n        'NomeConta': 'col-1 limit-char',\n        'Agencia': 'col-1 limit-char',\n        'NrConta': 'col-1 limit-char',\n        'Valor': 'col-1 limit-char',\n        'CritClassif': 'col-1 limit-char',\n        'acoes': 'col-1',\n        'DsHistorico': 'col-1 limit-char'\n      }\n      this.options.orderBy = 'IdLancamento'\n    }\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.declassify-title {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  padding: 0px 0px 5px 15px;\n  font-size: 15px;\n}\n\n.form-control[disabled], fieldset[disabled] .form-control {\n  cursor: not-allowed;\n  font-weight: bold;\n  color: #626262;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1050 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b0b37d6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonPrint/ButtonPrint.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#btnImprimirTabela {\n  margin-top: 15px !important\n}\n", "", {"version":3,"sources":["/./client/components/buttons/buttonPrint/ButtonPrint.vue?5b91c438"],"names":[],"mappings":";AAsHA;EACA,2BAAA;CACA","file":"ButtonPrint.vue","sourcesContent":["<template src=\"./buttonPrint.pug\" lang=\"pug\"></template>\n\n<script>\nimport printHtmlElement from 'print-html-element'\nimport ButtonPrimary from '../buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'ButtonPrint',\n\n  components: {\n    ButtonPrimary\n  },\n\n  methods: {\n    print () {\n      let clonedElement = document.createElement('toPrint')\n\n      let printableArray = Array.from(document.getElementsByClassName('printable'))\n\n      printableArray.forEach(function (element) {\n        clonedElement.appendChild(element.cloneNode(true))\n      }, this)\n\n      // - Remove paginação da impressão (informação mostrando 1 a 10 de N registros)\n      this.removeObjectByClass(clonedElement, 'dataTables_info')\n\n      // - Remove paginação da impressão (páginas)\n      this.removeObjectByClass(clonedElement, 'dataTables_paginate')\n\n      // - Remove campo busca da impressão\n      this.removeObjectByTag(clonedElement, 'input')\n\n      // - Tabelas\n      // - Lógica para inserir todos os elementos da tabela sem a paginação.\n      this.showAllTableObjects(clonedElement)\n\n      // - Text area\n      let textAreaArray = Array.from(clonedElement.getElementsByTagName('textarea'))\n      this.getValueElement(textAreaArray)\n\n      // - Multiselect\n      this.getValueComponentMultiselect(clonedElement)\n\n      this.getElementsTd(clonedElement)\n      printHtmlElement.printElement(clonedElement, {\n        styles: []\n      })\n\n      return true\n    },\n\n    removeObjectByClass (clonedElement, className) {\n      let elementArray = Array.from(clonedElement.getElementsByClassName(className))\n      elementArray.forEach(function (element) {\n        element.style.display = 'none'\n      }, this)\n    },\n\n    removeObjectByTag (clonedElement, tagName) {\n      let elementArray = Array.from(clonedElement.getElementsByTagName(tagName))\n      elementArray.forEach(function (element) {\n        element.style.display = 'none'\n      }, this)\n    },\n\n    showAllTableObjects (clonedElement) {\n      let tableArray = Array.from(clonedElement.getElementsByTagName('table'))\n\n      tableArray.forEach(function (element) {\n        var idTable = $(element).attr('id')\n        var htmlTd = ''\n        var htmlTrInicio = '<tr role=\"row\" class=\"odd\">'\n        var htmlTrFim = '</tr>'\n\n        $('#' + idTable).DataTable().rows().iterator('row', function (context, index) {\n          var node = $(this.row(index).node())\n          htmlTd = htmlTd + (htmlTrInicio + node.context.innerHTML + htmlTrFim)\n        })\n\n        element.getElementsByTagName('tbody')[0].innerHTML = htmlTd\n      }, this)\n    },\n\n    getValueComponentMultiselect (clonedElement) {\n      let multiselectArray = Array.from(clonedElement.getElementsByClassName('multiselect'))\n\n      multiselectArray.forEach(function (element) {\n        let elementArray = Array.from(element.getElementsByTagName('input'))\n\n        elementArray.forEach(function (elementAux) {\n          if (elementAux.value) {\n            element.innerHTML = elementAux.value\n          }\n        }, this)\n      }, this)\n    },\n\n    getElementsTd (clonedElement) {\n      let tdArray = Array.from(clonedElement.getElementsByTagName('td'))\n      tdArray.forEach(function (element) {\n        if (element.title) {\n          element.innerHTML = element.title\n        }\n      }, this)\n    },\n\n    getValueElement (elementArray) {\n      elementArray.forEach(function (element) {\n        if (element.value) {\n          element.innerHTML = element.value\n        }\n      }, this)\n    }\n  }\n}\n</script>\n\n<style lang=\"css\">\n#btnImprimirTabela {\n  margin-top: 15px !important\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1051 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b0e21fa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.marged-button[data-v-2b0e21fa] {\n  margin-left: 10px;\n}\n.alert-icon[data-v-2b0e21fa] {\n  margin-right: 10px;\n  color: red;\n  font-size: 20px;\n}\n.alert-text[data-v-2b0e21fa] {\n  color: red;\n  font-size: 15px;\n}\n", "", {"version":3,"sources":["/./client/components/registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria.vue?3f8c5b74"],"names":[],"mappings":";AA6WA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,WAAA;EACA,gBAAA;CACA","file":"NewConciliationCriteria.vue","sourcesContent":["<template src='./newConciliationCriteria.pug' lang='pug'></template>\n\n<script>\nimport { Money } from 'v-money'\nimport vSelect from 'vue-select'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'\nimport ConciliationCritField from './ConciliationCritFields'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport idioma from '../../../../../build/language/index'\nimport ConfirmModal from '../../../../components/modals/confirmModal/ConfirmModal'\nexport default {\n  name: 'NewConciliationCriteria',\n\n  components: {\n    Money,\n    vSelect,\n    PageTitle,\n    FilterPortlet,\n    InputEstablishment,\n    ConciliationCritField,\n    ButtonPrimary,\n    ConfirmModal\n  },\n\n  props: {\n    concilCriteriaToEdit: {\n      type: Object,\n      default: null\n    },\n    banks: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    accounts: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    attributesCfg: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    conciliationFields: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    occurrenceReasons: {\n      type: Array,\n      default: null,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      requestSent: false,\n      criteriaConcil: {\n        valorDiferencaMax: 0,\n        valorDivergenciaMax: 0\n      },\n      filteredAccounts: [],\n      attributes: [],\n      establishimentsUrls: {\n        establishments: 'conciliationPlan/establishment/list',\n        attributes: '/conciliationPlan/loadEstablishmentAtt'\n      },\n      selectedEstablishments: [],\n      moneyMask: {\n        decimal: ',',\n        thousands: '.',\n        precision: 2,\n        masked: false\n      },\n      idioma: idioma,\n      attributesMfList: [],\n      attributesMbList: []\n    }\n  },\n\n  computed: {\n    mfFieldList () {\n      let mfFieldList = []\n      let self = this\n      this.conciliationFields.map(field => {\n        let alreadyUsed = false\n        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos\n        if (self.criteriaConcil.conciliacaoCampos && self.criteriaConcil.conciliacaoCampos.length > 0) {\n          alreadyUsed = self.criteriaConcil.conciliacaoCampos.findIndex(concField => (concField.conciliacaoCampoMovFinan ? concField.conciliacaoCampoMovFinan.id : null) === field.id && field.tipo !== 'A') !== -1\n        }\n\n        if (!(field.tipo === 'B') && !alreadyUsed) {\n          mfFieldList.push(field)\n        }\n      })\n      return mfFieldList\n    },\n\n    mbFieldList () {\n      let mbFieldList = []\n      let self = this\n      this.conciliationFields.map(field => {\n        let alreadyUsed = false\n        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos\n        if (self.criteriaConcil.conciliacaoCampos && self.criteriaConcil.conciliacaoCampos.length > 0) {\n          alreadyUsed = self.criteriaConcil.conciliacaoCampos.findIndex(concField => (concField.conciliacaoCampoMovBancario ? concField.conciliacaoCampoMovBancario.id : null) === field.id && field.tipo !== 'A') !== -1\n        }\n\n        if (field.tipo === 'B' && !alreadyUsed) {\n          mbFieldList.push(field)\n        }\n      })\n      return mbFieldList\n    },\n\n    attributesCfgMfList () {\n      let attributesCfgMf = []\n      this.attributesCfg.map(cfg => {\n        attributesCfgMf.push(cfg)\n      })\n      return attributesCfgMf\n    }\n  },\n\n  watch: {\n    concilCriteriaToEdit: {\n      handler (newVal, oldVal) {\n        if (newVal) {\n          this.criteriaConcil = {...newVal, conciliacaoCampos: [...newVal.conciliacaoCampos]}\n          if (this.criteriaConcil.valorDiferencaMax === 0 || !this.criteriaConcil.valorDiferencaMax) {\n            this.criteriaConcil.valorDiferencaMax = '0'\n          }\n          if (this.criteriaConcil.valorDivergenciaMax === 0) {\n            this.criteriaConcil.valorDivergenciaMax = '0'\n          }\n          if (this.criteriaConcil.conciliacaoEstabelecimentos && this.criteriaConcil.conciliacaoEstabelecimentos.length > 0) {\n            this.selectedEstablishments = [...this.criteriaConcil.conciliacaoEstabelecimentos]\n          } else {\n            this.selectedEstablishments = []\n          }\n        } else {\n          this.criteriaConcil = {\n            ativo: true,\n            criterioEmUso: false,\n            conciliacaoCampos: [],\n            conta: null,\n            banco: null,\n            descricao: '',\n            estabelecimentos: [],\n            diasDiferencaMin: 0,\n            diasDiferencaMax: 0,\n            valorDiferencaMax: 0,\n            valorDivergenciaMax: 0,\n            motivoOcorrencia: null\n          }\n        }\n      }\n    },\n    accounts: {\n      handler (newVal, oldVal) {\n        this.filteredAccounts = [...newVal]\n      }\n    }\n  },\n\n  methods: {\n    back () {\n      this.$emit('change-managing-plan-concil')\n      this.errors.clear()\n      this.requestSent = false\n    },\n\n    validate (event) {\n      this.requestSent = true\n      if (event) {\n        event.preventDefault()\n      }\n      this.$validator.validateAll().then((result) => {\n        if (result) {\n          if (!this.criteriaConcil.valorDivergenciaMax) {\n            this.openConfirmationModal()\n            this.requestSent = false\n            return\n          }\n          this.submitCriteria()\n        } else {\n          this.requestSent = false\n        }\n      })\n    },\n    submitCriteria () {\n      let self = this\n      setTimeout(() => {\n        if (this.verifyFields) {\n          self.addCriteria()\n        } else {\n          this.requestSent = false\n        }\n      }, 500)\n    },\n    verifyFields () {\n      let self = this\n      let isAllFieldsValid = true\n      Object.entries(self.$refs).map(refArray => {\n        if (refArray[1] && refArray[1].length > 0) {\n          refArray[1][0].$validator.validateAll().then((fieldValidation) => {\n            if (isAllFieldsValid) {\n              isAllFieldsValid = fieldValidation\n            }\n          })\n        }\n      })\n      return isAllFieldsValid\n    },\n    addCriteria () {\n      if (this.selectedEstablishments && this.selectedEstablishments.length > 0) {\n        this.criteriaConcil.conciliacaoEstabelecimentos = [...this.selectedEstablishments]\n        this.criteriaConcil.flEstabelecimento = true\n      } else {\n        this.criteriaConcil.conciliacaoEstabelecimentos = null\n        this.criteriaConcil.flEstabelecimento = false\n      }\n      this.$emit('add-concil-criteria-to-plan', this.criteriaConcil)\n      this.back()\n    },\n\n    addConciliationField () {\n      if (!this.criteriaConcil.conciliacaoCampos) {\n        this.criteriaConcil.conciliacaoCampos = []\n      }\n\n      this.criteriaConcil.conciliacaoCampos.push({\n        idCriterioClassificacao: this.criteriaConcil.idCriterioClassificacao,\n        atributo: {\n          atributoCfg: null,\n          nomeAtributo: null\n        },\n        conciliacaoCampoMovBancario: null,\n        conciliacaoCampoMovFinan: null,\n        key: this.criteriaConcil.conciliacaoCampos.length + 1\n      })\n    },\n\n    removeConciliationField (field) {\n      const index = this.criteriaConcil.conciliacaoCampos.findIndex(item => item.key === field.key)\n      this.criteriaConcil.conciliacaoCampos.splice(index, 1)\n      if (field.id) {\n        if (!this.criteriaConcil.idsCamposRemovidos) {\n          this.criteriaConcil.idsCamposRemovidos = []\n        }\n        this.criteriaConcil.idsCamposRemovidos.push(field.id)\n      }\n    },\n\n    changeFieldAttCfgMf (item) {\n      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {\n        // identifica a configuracao alterada\n        if (mappedItem.key === item.concField.key) {\n          // atualiza campo\n          if (!mappedItem.atributo) {\n            mappedItem.atributo = {}\n          }\n          mappedItem.atributo.atributoCfg = item.cfg\n          mappedItem.atributo.nomeAtributo = null\n          if (item.cfg) {\n            // atualiza lista de atributos com os filhos do conjunto\n            this.attributesMfList = item.cfg.children\n          } else {\n            this.attributesMfList = []\n          }\n        }\n      })\n    },\n\n    changeFieldAttNameMf (item) {\n      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {\n        // identifica a configuracao\n        if (mappedItem.key === item.concField.key) {\n          // atualiza campo\n          mappedItem.atributo.nomeAtributo = item.att\n        }\n      })\n    },\n\n    changeFieldAttConciliationFieldMf (item) {\n      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {\n        // identifica a configuracao\n        if (mappedItem.key === item.concField.key) {\n          // atualiza campo\n          mappedItem.conciliacaoCampoMovFinan = item.field\n          if (item.field && item.field.tipo === 'A') {\n            mappedItem.atributo = {\n              atributoCfg: null,\n              nomeAtributo: null\n            }\n          } else {\n            mappedItem.atributo = null\n          }\n        }\n      })\n    },\n\n    changeFieldAttConciliationFieldMb (item) {\n      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {\n        // identifica a configuracao\n        if (mappedItem.key === item.concField.key) {\n          // atualiza campo\n          mappedItem.conciliacaoCampoMovBancario = item.field\n        }\n      })\n    },\n\n    changeCritBank (val) {\n      this.criteriaConcil.conta = null\n      if (val && val.codigo) {\n        this.criteriaConcil.banco = val\n        this.filteredAccounts = this.accounts.filter(account => {\n          return account.banco.codigo === val.codigo || account.id === 0\n        })\n      } else {\n        this.criteriaConcil.banco = null\n        this.filteredAccounts = [...this.accounts]\n      }\n    },\n\n    updateAttibutesList (item) {\n      this.criteriaConcil.conciliacaoCampos.map(mappedItem => {\n        // identifica a configuracao alterada\n        if (mappedItem.key === item.concField.key) {\n          if (item.cfg) {\n            // atualiza lista de atributos com os filhos do conjunto\n            this.attributesMfList = item.cfg.children\n          } else {\n            this.attributesMfList = []\n          }\n        }\n      })\n    },\n    openConfirmationModal () {\n      this.verifyFields()\n      this.showConfirmationModal()\n    },\n    confirmAdd () {\n      this.closeModal()\n      this.submitCriteria()\n    },\n    closeModal () {\n      $('#confirmDivergMax').modal('hide')\n    },\n    showConfirmationModal () {\n      $('#confirmDivergMax').modal({ backdrop: 'static', keyboard: false })\n    }\n  },\n\n  mounted () {\n    this.moneyMask = this.idioma.getMoneyMaskByLanguage()\n  }\n}\n</script>\n\n<style scoped>\n.marged-button {\n  margin-left: 10px;\n}\n\n.alert-icon {\n  margin-right: 10px;\n  color: red;\n  font-size: 20px;\n}\n\n.alert-text {\n  color: red;\n  font-size: 15px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1052 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2dcfce74","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/Justifications.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.VueTables__table {\n  margin-bottom: 1px!important;\n}\n.entry-table {\n  max-height: 237px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-width: 98%;\n}\n.manage-value {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 3vh !important;\n  text-transform: initial !important;\n}\n.manage-date {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 2vh !important;\n  text-transform: initial !important;\n}\ntd.align-right {\n  text-align: right;\n}\n\n", "", {"version":3,"sources":["/./client/components/reports/manualConciliation/Justifications.vue?2fff8013"],"names":[],"mappings":";AAkFA;EACA,6BAAA;CACA;AAEA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,mBAAA;EACA,6BAAA;EACA,4CAAA;EACA,0BAAA;EACA,mCAAA;CACA;AAEA;EACA,mBAAA;EACA,6BAAA;EACA,4CAAA;EACA,0BAAA;EACA,mCAAA;CACA;AAEA;EACA,kBAAA;CACA","file":"Justifications.vue","sourcesContent":["<template lang=\"pug\" src=\"./justifications.pug\"></template>\n\n<script>\nimport moment from 'moment'\nimport language from '../../../../build/language/index'\nimport { maskThousand } from '../../../utils/numberMasker.js'\n\nmoment.locale(language.getDatePickerLanguage())\n\nexport default {\n  name: 'Justifications',\n\n  data () {\n    return {\n      sumAmount: 0.00,\n      columns: ['motivoOcorrencia', 'comentario', 'valor', 'acoes'],\n      options: {\n        columnsClasses: {'motivoOcorrencia': 'col-md-4', 'comentario': 'col-md-5', 'valor': 'col-md-2 align-right', 'acoes': 'col-md-1'},\n        headings: {\n          motivoOcorrencia: this.$t('conciliacaoManual.labels.motivoOcorrencia'),\n          comentario: this.$t('conciliacaoManual.labels.comentario'),\n          valor: this.$t('conciliacaoManual.labels.valor'),\n          acoes: ''\n        },\n        sortIcon: {\n          is: ''\n        },\n        templates: {\n          motivoOcorrencia: (h, row) => {\n            return row && row.motivoOcorrencia ? row.motivoOcorrencia : '-'\n          },\n          comentario: (h, row) => {\n            return row && row.comentario ? row.comentario : '-'\n          },\n          valor: (h, row) => {\n            return maskThousand(row.valor)\n          }\n        },\n        filterable: false,\n        perPage: 9999,\n        perPageValues: [],\n        texts: {\n          count: '',\n          noResults: this.$t('conciliacaoManual.erro.nenhumLancamentoInterno')\n        },\n        sortable: ['motivoOcorrencia', 'comentario', 'valor'],\n        pagination: {},\n        customSorting: {\n        }\n      },\n      justifications: []\n    }\n  },\n\n  computed: {\n    arrayJustify () {\n      return this.$store.getters.arrayJustify\n    }\n  },\n\n  watch: {\n    arrayJustify () {\n      this.justifications = this.$store.getters.arrayJustify\n    }\n  },\n\n  methods: {\n    removeJustify (justify) {\n      // Remover da lista e do vuex\n      this.$store.dispatch('removeJustify', justify)\n        .then(() => {\n          // Remonta a respectiva grid, para evitar problemas quando as entradas estão ordenadas\n          // window.Grids[0].Reload()\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    }\n  }\n}\n</script>\n\n<style>\n.VueTables__table {\n  margin-bottom: 1px!important;\n}\n\n.entry-table {\n  max-height: 237px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-width: 98%;\n}\n\n.manage-value {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 3vh !important;\n  text-transform: initial !important;;\n}\n\n.manage-date {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 2vh !important;\n  text-transform: initial !important;;\n}\n\ntd.align-right {\n  text-align: right;\n}\n\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1053 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2df64858","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/attributesSet/TreeViewAtt.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.treeview {\n  font-family: 'Inter', sans-serif;\n}\n.padding-left-children {\n  padding-left: 50px;\n}\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: none;\n}\n.treeRowBg {\n  background: #ffffff !important;\n  font-weight: bold;\n  color: #000000;\n}\n.treeRow .btn-white {\n  color: #000000;\n}\n.treeview.vue-drag-tree > div > .treeview > .treeRow {\n  background: #f6f6f6;\n  color: #414141;\n}\n.item {\n  cursor: pointer;\n}\n.bold {\n  font-weight: bold;\n}\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n.treeMargin {\n  margin-left: 0px;\n}\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n.nodeClicked {\n  -ms-transform: rotate(90deg);\n      transform: rotate(90deg);\n}\n", "", {"version":3,"sources":["/./client/components/registration/attributesSet/TreeViewAtt.vue?267aecb8"],"names":[],"mappings":";AA4QA;EACA,iCAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;EACA,YAAA;CACA;AAEA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;CACA;AAEA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,oBAAA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,eAAA;CACA;AAEA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,sCAAA;CACA;AAEA;EACA,6BAAA;MAAA,yBAAA;CACA","file":"TreeViewAtt.vue","sourcesContent":["<script>\nlet id = 1000\nlet fromData = ''\nlet toData = ''\nlet fromParentModelChildren = ''\nlet nodeClicked = null\n\nexport default {\n  name: 'TreeViewAtt',\n\n  props: {\n    model: Object,\n    buttonsTitle: Object,\n    clickFunction: Function,\n    id: String,\n    father: Object,\n    defaultText: String,\n    currentHighlight: Boolean,\n    hoverColor: String,\n    highlightColor: String,\n    spaceLeft: String,\n    styleObj: Object,\n    clickRemoveFunction: {\n      type: Function,\n      default: null\n    },\n    showRemove: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data: function () {\n    return {\n      open: false,\n      isClicked: false\n    }\n  },\n\n  computed: {\n    isFolder () {\n      return this.model.children &&\n        this.model.children.length\n    }\n  },\n\n  template: `<div class=\"treeview\">\n              <div :id='model.id' draggable='false' @dragstart='dragStart' @dragover='dragOver' @dragenter='dragEnter' @dragleave='dragLeave' @drop='drop' @dragend='dragEnd' class='col-xs-12 col-sm-12 col-md-12 treeRow pl-0' :class=\"[model.mainFather ? 'treeRowBg' : '']\" @mouseover='mouseOver' @mouseout='mouseOut' :style='styleObj'>\n                <div v-if='model.mainFather' class=\"pull-left pl-0 text-left\" style=\"padding-top:3px!important\">\n                  <div v-if=\"model.children && model.children.length === 0\" style=\"min-width:33px;\"></div>\n                  <button style=\"width:23px; float:left;\" v-if=\"!isClicked && model.children && model.children.length > 0\" :title=\"[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : '']\" @click=\"toggle\" class=\"fa fa-chevron-down px-0 action btn-white\"></button>\n                  <button style=\"width:23px; float:left;\" v-if=\"isClicked && model.children && model.children.length > 0\" :title=\"[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : '']\" @click=\"toggle\" class=\"fa fa-chevron-up px-0 action btn-white\"></button>\n                </div>\n                <div :style='spaceLeft' class=\"col-xs-3 col-sm-3 col-md-3 col-lg-4\" :class=\"[model.mainFather ? 'pl-0' : 'padding-left-children']\">\n                  {{model.number}} {{model.attibuteSetName}}\n                </div>\n                <div class=\"col-xs-2 col-sm-2 col-md-3 col-lg-3\" v-html=\"$t(model.linkType ? 'conjuntoAtributo.labels.' + model.linkType : null)\"></div>\n                <div class=\"col-xs-2 col-sm-2 col-md-3 col-lg-2\">{{model.amount}}</div>\n                <div v-if='model.mainFather' class=\"pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-2\" style=\"padding-top:3px!important\">\n                  <button v-if='showRemove' :disabled='model.emUso' style=\"width:23px; float:right;\" @click=\"clickRemoveFunction(model.id)\" :title=\"[model.emUso ? (buttonsTitle && buttonsTitle.removeBloq ? buttonsTitle.removeBloq : '') : (buttonsTitle && buttonsTitle.remove ? buttonsTitle.remove : '')]\" class=\"fa fa-times action btn-white pr-0\"></button>\n                  <button style=\"width:23px; float:right;\" id=\"buttonEdit\" @click=\"clickAction('buttonEdit')\" :title=\"[buttonsTitle && buttonsTitle.config ? buttonsTitle.config : '']\" class=\"fa fa-cog action btn-white pr-0\"></button>\n                </div>\n              </div>\n              <div class=\"clear\"></div>\n              <div v-show=\"open\" v-if=\"isFolder\">\n                <item v-for=\"model in model.children\" :spaceLeft='model.marginLeft' :clickFunction='clickFunction' :id='model.id' :father=\"model\" :model=\"model\" :key='model.id' :currentHighlight='currentHighlight' :defaultText='defaultText' :hoverColor='hoverColor' :highlightColor='highlightColor'>\n                </item>\n              </div>\n            </div>`,\n\n  methods: {\n    clickAction (idButton) {\n      let isEdit = (idButton === 'buttonEdit')\n      this.clickFunction(this.id, this.father, isEdit)\n    },\n\n    toggle () {\n      if (this.isFolder) {\n        this.open = !this.open\n      }\n      let rootTree = this.findRoot()\n\n      this.isClicked = !this.isClicked\n\n      if (this.currentHighlight) {\n        if (nodeClicked !== this.model.id) {\n          let treeParent = rootTree.$parent\n          let nodeStack = [treeParent.$children[0]]\n          while (nodeStack.length !== 0) {\n            let item = nodeStack.shift()\n            item.styleObj.background = 'white'\n            if (item.$children && item.$children.length > 0) {\n              nodeStack = nodeStack.concat(item.$children)\n            }\n          }\n          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF'\n          nodeClicked = this.model.id\n        }\n      }\n    },\n\n    exchangeData (rootCom, from, to) {\n      if (!to || !from || typeof to === 'string' || from.id === to.id) {\n        return\n      }\n\n      from = JSON.parse(JSON.stringify(from))\n      to = JSON.parse(JSON.stringify(to))\n      // copy\n      let treeData = JSON.parse(JSON.stringify(this.model))\n      let nodeStack = [treeData]\n      let status = 0\n\n      try {\n        while (!(status === 2)) {\n          let item = nodeStack.shift()\n          if (item.id === from.id) {\n            item.id = to.id\n            item.name = to.name\n            if (to.children && to.children.length > 0) {\n              item['children'] = to.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.id === to.id) {\n            item.id = from.id\n            item.name = from.name\n            if (from.children && from.children.length > 0) {\n              item['children'] = from.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.children && item.children.length > 0) {\n            nodeStack = nodeStack.concat(item.children)\n          }\n        }\n      } catch (e) {\n        return\n      }\n      rootCom.assignData(treeData)\n    },\n\n    changeType () {\n      if (this.currentHighlight) {\n        nodeClicked = this.model.id\n      }\n      if (!this.isFolder) {\n        this.$set(this.model, 'children', [])\n        this.addChild()\n        this.open = true\n        this.isClicked = true\n      }\n    },\n\n    mouseOver (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2'\n        }\n      }\n    },\n\n    mouseOut (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = 'white'\n        }\n      }\n    },\n\n    findRoot () {\n      let ok = false\n      let that = this\n      while (!ok) {\n        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {\n          ok = true\n          break\n        }\n        that = that.$parent\n      }\n      return that\n    },\n\n    addChild () {\n      this.model.children.push({\n        name: this.defaultText ? this.defaultText : 'New Node',\n        id: id++\n      })\n    },\n\n    removeChild (id) {\n      let parentModelChildren = this.$parent.model.children\n      for (let index in parentModelChildren) {\n        if (parentModelChildren[index].id === id) {\n          parentModelChildren = parentModelChildren.splice(index, 1)\n          break\n        }\n      }\n    },\n\n    dragStart (e) {\n      e.dataTransfer.effectAllowed = 'move'\n      e.dataTransfer.setData('nottext', e.target.innerHTML)\n      return true\n    },\n\n    dragEnd (e) {\n      fromData = undefined\n      toData = undefined\n      fromParentModelChildren = undefined\n    },\n\n    dragOver (e) {\n      e.preventDefault()\n      return true\n    },\n\n    dragOverPlus (e) {\n      e.preventDefault()\n    },\n\n    dragEnterPlus (e) {\n    },\n\n    dragEnter (e) {\n      toData = this.model\n      let rootTree = this.findRoot()\n      rootTree.exchangeData(rootTree.$parent, fromData, toData)\n    },\n\n    dragLeave (e) {\n      fromData = this.model\n      fromParentModelChildren = this.$parent.model.children\n      // e.target.style.background = '#7B1FA2'\n    },\n\n    drop (e) {\n      // toData = this.model\n      // e.target.style.background = '#7B1FA2'\n    },\n\n    dropPlus (e) {\n      if (this.model.hasOwnProperty('children')) {\n        this.model.children.push(fromData)\n      } else {\n        this.model.children = [fromData]\n      }\n      for (let i in fromParentModelChildren) {\n        if (fromParentModelChildren[i].id === fromData.id) {\n          fromParentModelChildren.splice(i, 1)\n        }\n      }\n    }\n  },\n\n  beforeCreate () {\n    this.$options.components.item = require('./TreeViewAtt')\n  }\n}\n</script>\n\n<style>\n.treeview {\n  font-family: 'Inter', sans-serif;\n}\n\n.padding-left-children {\n  padding-left: 50px;\n}\n\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: none;\n}\n\n.treeRowBg {\n  background: #ffffff !important;\n  font-weight: bold;\n  color: #000000;\n}\n\n.treeRow .btn-white {\n  color: #000000;\n}\n\n.treeview.vue-drag-tree > div > .treeview > .treeRow {\n  background: #f6f6f6;\n  color: #414141;\n}\n\n.item {\n  cursor: pointer;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n\n.treeMargin {\n  margin-left: 0px;\n}\n\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n\n.nodeClicked {\n  transform: rotate(90deg);\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1054 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2e8324c6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonSearch/ButtonSearch.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.search-button {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/buttons/buttonSearch/ButtonSearch.vue?626445fe"],"names":[],"mappings":";AAsBA;EACA,eAAA;CACA","file":"ButtonSearch.vue","sourcesContent":["<template src='./buttonSearch.pug' lang='pug'></template>\n\n<script>\nimport ButtonPrimary from '../buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'ButtonSearch',\n\n  components: {\n    ButtonPrimary\n  },\n\n  props: {\n    isDisabled: {\n      type: Boolean,\n      required: true\n    }\n  }\n}\n</script>\n\n<style>\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1055 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-30421256","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/gadget/TaskGadget.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.gadgetTasks {\n  font-family: 'Inter', sans-serif;\n  background-color: #FFF;\n  min-height: 400px;\n}\n.gadgetTasks>.tab {\n  margin-top: 20px;\n  border: none;\n}\n.gadgetTasks>.nav-tabs>li>a {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  text-transform: none;\n  border: none;\n}\n.gadgetTasks>.vue-tabs .nav>li span.title {\n  color: #012351;\n  border: none;\n}\n.gadgetTasks>.vue-tabs .nav-tabs {\n  border-bottom: none;\n}\n.gadgetTasks>.vue-tabs .nav-tabs>li>a {\n  border: none;\n}\n.vue-tabs .nav-tabs-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n  border-bottom: none!important;\n}\n.gadgetTasks>.vue-tabs .nav-tabs>li>a:hover {\n  border: none;\n}\n.gadgetTasks>.vue-tabs .nav>li.active span.title {\n  color: #39b8bb;\n}\n.gadgetTasks>.vue-tabs .nav-tabs>li.active>a,\n.gadgetTasks>.vue-tabs .nav-tabs>li.active>a:hover,\n.gadgetTasks>.vue-tabs .nav-tabs>li.active>a:focus {\n  border: none;\n  border-bottom: 5px solid #39b8bb!important;\n  color: #012351;\n  background: transparent;\n  font-weight: 600;\n  margin-bottom: -1px;\n  border-radius: none\n}\n@media screen and (max-width: 1199px) {\n.gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 10vw 0px 10vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n}\n}\n@media screen and (min-width: 1200px) and (max-width: 1399px) {\n.gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 1vw 0px 1vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n}\n}\n@media screen and (min-width: 1400px) and (max-width: 1599px) {\n.gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 4vw 0px 4vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n}\n}\n@media (min-width: 1600px) {\n.gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 7vw 0px 7vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n}\n}\n.gadgetTasks>.vue-tabs .nav-tabs>li>a,\n.gadgetTasks>.vue-tabs .nav-tabs>li>a:hover,\n.gadgetTasks>.vue-tabs .nav-tabs>li>a:focus {\n  border: none;\n}\n@media (min-width: 768px) {\n.gadgetTasks>.vue-tabs .nav-tabs>li.active>a,\n  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a:hover,\n  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a:focus {\n    border: none;\n    border-bottom: 5px solid #39b8bb;\n    color: #012351;\n    background: transparent;\n    font-weight: 600;\n    margin-bottom: -1px;\n    border-radius: none\n}\n}\n@media (min-width: 768px) {\n.gadgetTasks>.vue-tabs .gadgetTasks>.nav-justified>li,\n  .gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs.nav-justified>li {\n    display: table-cell;\n    width: 1%;\n}\n}\n.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a,\n.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a:hover,\n.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a:focus {\n  border: none;\n  color: #012351;\n  background: transparent;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 13px;\n}\n.gadgetTasks>.tab-content {\n  background: #fff;\n}\n.fa-task-gadget {\n  font-size: 20px;\n  margin-right: 5px;\n}\n", "", {"version":3,"sources":["/./client/components/dashboard/gadget/TaskGadget.vue?4b3d3850"],"names":[],"mappings":";AAqCA;EACA,iCAAA;EACA,uBAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;EACA,aAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;CACA;AAEA;EACA,eAAA;EACA,aAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;;;EAGA,aAAA;EACA,2CAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;CACA;AAEA;AACA;;IAEA,aAAA;IACA,UAAA;IACA,4BAAA;IACA,0BAAA;IACA,0BAAA;IACA,iBAAA;CACA;CACA;AAEA;AACA;;IAEA,aAAA;IACA,UAAA;IACA,0BAAA;IACA,0BAAA;IACA,0BAAA;IACA,iBAAA;CACA;CACA;AAEA;AACA;;IAEA,aAAA;IACA,UAAA;IACA,0BAAA;IACA,0BAAA;IACA,0BAAA;IACA,iBAAA;CACA;CACA;AAEA;AACA;;IAEA,aAAA;IACA,UAAA;IACA,0BAAA;IACA,0BAAA;IACA,0BAAA;IACA,iBAAA;CACA;CACA;AAEA;;;EAGA,aAAA;CACA;AAEA;AACA;;;IAGA,aAAA;IACA,iCAAA;IACA,eAAA;IACA,wBAAA;IACA,iBAAA;IACA,oBAAA;IACA,mBAAA;CACA;CACA;AAEA;AACA;;IAEA,oBAAA;IACA,UAAA;CACA;CACA;AAEA;;;EAGA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA","file":"TaskGadget.vue","sourcesContent":["<template lang=\"pug\" src='./taskGadget.pug'></template>\n\n<script>\nimport { VueTabs, VTab } from 'vue-nav-tabs'\nimport TaskGadgetTabContent from './TaskGadgetTabContent'\n\nexport default {\n  name: 'TaskGadget',\n\n  components: {\n    VueTabs,\n    VTab,\n    TaskGadgetTabContent\n  },\n\n  props: {\n    data: {\n      type: Object\n    },\n    isLoadingDataTaskGadget: {\n      type: Boolean,\n      default: true\n    }\n  },\n\n  data () {\n    return {\n      hasData: {\n        tarefasPendentes: typeof this.data.quantidadePendenteMovFin === 'number' && typeof this.data.quantidadePendenteMovBan === 'number' && typeof this.data.totalQuantidadePendente === 'number',\n        tarefasConciliadas: typeof this.data.quantidadeConcluidaMovFin === 'number' && typeof this.data.quantidadeConcluidaMovBan === 'number' && typeof this.data.totalQuantidadeConcluida === 'number'\n      }\n    }\n  }\n}\n</script>\n\n<style>\n.gadgetTasks {\n  font-family: 'Inter', sans-serif;\n  background-color: #FFF;\n  min-height: 400px;\n}\n\n.gadgetTasks>.tab {\n  margin-top: 20px;\n  border: none;\n}\n\n.gadgetTasks>.nav-tabs>li>a {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  text-transform: none;\n  border: none;\n}\n\n.gadgetTasks>.vue-tabs .nav>li span.title {\n  color: #012351;\n  border: none;\n}\n\n.gadgetTasks>.vue-tabs .nav-tabs {\n  border-bottom: none;\n}\n\n.gadgetTasks>.vue-tabs .nav-tabs>li>a {\n  border: none;\n}\n\n.vue-tabs .nav-tabs-justified > li > a, .vue-tabs .nav-tabs.nav-justified > li > a {\n  border-bottom: none!important;\n}\n\n.gadgetTasks>.vue-tabs .nav-tabs>li>a:hover {\n  border: none;\n}\n\n.gadgetTasks>.vue-tabs .nav>li.active span.title {\n  color: #39b8bb;\n}\n\n.gadgetTasks>.vue-tabs .nav-tabs>li.active>a,\n.gadgetTasks>.vue-tabs .nav-tabs>li.active>a:hover,\n.gadgetTasks>.vue-tabs .nav-tabs>li.active>a:focus {\n  border: none;\n  border-bottom: 5px solid #39b8bb!important;\n  color: #012351;\n  background: transparent;\n  font-weight: 600;\n  margin-bottom: -1px;\n  border-radius: none\n}\n\n@media screen and (max-width: 1199px) {\n  .gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 10vw 0px 10vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n  }\n}\n\n@media screen and (min-width: 1200px) and (max-width: 1399px) {\n  .gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 1vw 0px 1vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n  }\n}\n\n@media screen and (min-width: 1400px) and (max-width: 1599px) {\n  .gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 4vw 0px 4vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n  }\n}\n\n@media (min-width: 1600px) {\n  .gadgetTasks>.vue-tabs .nav-tabs-justified,\n  .gadgetTasks>.vue-tabs .nav-tabs.nav-justified {\n    border: none;\n    bottom: 0;\n    padding: 10px 7vw 0px 7vw;\n    background-color: #F5F6FA;\n    border: 1px solid #EAEEF4;\n    border-top: none;\n  }\n}\n\n.gadgetTasks>.vue-tabs .nav-tabs>li>a,\n.gadgetTasks>.vue-tabs .nav-tabs>li>a:hover,\n.gadgetTasks>.vue-tabs .nav-tabs>li>a:focus {\n  border: none;\n}\n\n@media (min-width: 768px) {\n  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a,\n  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a:hover,\n  .gadgetTasks>.vue-tabs .nav-tabs>li.active>a:focus {\n    border: none;\n    border-bottom: 5px solid #39b8bb;\n    color: #012351;\n    background: transparent;\n    font-weight: 600;\n    margin-bottom: -1px;\n    border-radius: none\n  }\n}\n\n@media (min-width: 768px) {\n  .gadgetTasks>.vue-tabs .gadgetTasks>.nav-justified>li,\n  .gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs.nav-justified>li {\n    display: table-cell;\n    width: 1%;\n  }\n}\n\n.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a,\n.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a:hover,\n.gadgetTasks>.vue-tabs .gadgetTasks>.nav-tabs>li>a:focus {\n  border: none;\n  color: #012351;\n  background: transparent;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 13px;\n}\n\n.gadgetTasks>.tab-content {\n  background: #fff;\n}\n\n.fa-task-gadget {\n  font-size: 20px;\n  margin-right: 5px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1056 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-33983fa4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/massTaskModal/MassTaskModal.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.task-title[data-v-33983fa4] {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  padding: 0px 0px 5px 15px;\n  font-size: 15px;\n}\n.enviar-e-mail-automa[data-v-33983fa4] {\n  font-size: 11px !important;\n  text-align: left;\n  color: #2a2a2a;\n  text-transform: initial !important;\n}\n.input-date-picker[data-v-33983fa4] {\n  border: none;\n  width: 80%;\n}\n.form-control[disabled][data-v-33983fa4], fieldset[disabled] .form-control[data-v-33983fa4] {\n  cursor: not-allowed;\n  font-weight: bold;\n  color: #626262;\n}\n", "", {"version":3,"sources":["/./client/components/modals/massTaskModal/MassTaskModal.vue?7ae27943"],"names":[],"mappings":";AAkpBA;EACA,iCAAA;AACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;CACA;AAEA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,mCAAA;CACA;AAEA;EACA,aAAA;EACA,WAAA;CACA;AAEA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;CACA","file":"MassTaskModal.vue","sourcesContent":["<template src='./massTaskModal.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport vSelect from 'vue-select'\nimport Datepicker from 'vuejs-datepicker'\nimport ConfirmModal from '../../modals/confirmModal/ConfirmModal'\nimport Modal from '../../modals/modal/Modal'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport language from '../../../../build/language/index.js'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\nimport { maskThousand } from '../../../utils/numberMasker.js'\nimport { conciliationStatusTranslate, typeTranslate } from '../../../utils/statusesTranslator.js'\nimport customValidator from '../../../utils/customValidator.js'\nimport IdSituacaoTarefaEnum from '../../../enum/idSituacaoTarefa'\n\nmoment.locale(language.getDatePickerLanguage())\n\nexport default {\n  name: 'MassTaskModal',\n\n  components: {\n    vSelect,\n    Datepicker,\n    ConfirmModal,\n    Modal,\n    ButtonPrimary\n  },\n\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    gridId: {\n      type: String,\n      required: true\n    },\n    listIdExt: {\n      type: Array,\n      required: true\n    },\n    listIdMov: {\n      type: Array,\n      required: true\n    },\n    listRows: {\n      type: Array,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      tarefaStatuses: [\n        {\n          id: 0,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.pendente')\n        },\n        {\n          id: 10,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')\n        },\n        {\n          id: 20,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.aguardando')\n        }\n      ],\n      concilStatuses: [\n        {\n          id: 'A',\n          nome: this.$t('statusConciliacao.aberto')\n        },\n        {\n          id: 'C',\n          nome: this.$t('statusConciliacao.conciliado')\n        },\n        {\n          id: 'M',\n          nome: this.$t('statusConciliacao.conciliadoManualmente')\n        },\n        {\n          id: 'D',\n          nome: this.$t('statusConciliacao.divergente')\n        },\n        {\n          id: 'N',\n          nome: this.$t('statusConciliacao.naoAplicavel')\n        }\n      ],\n      concilStatusesTransformed: [],\n      columns: [],\n      options: {\n        columnsClasses: {},\n        headings: {},\n        filterable: false,\n        perPageValues: [],\n        perPage: 5,\n        texts: {\n          count: this.$t('dataTable.labels.contagem'),\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filter: null,\n          filterPlaceholder: null\n        },\n        pagination: {},\n        sortable: [],\n        sortIcon: {\n          is: ''\n        }\n      },\n      items: [],\n      task: {\n        nome: '',\n        tipoVinculo: '',\n        descricao: '',\n        situacao: {\n          id: 10,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')\n        },\n        dtVencimento: new Date(),\n        responsavel: null,\n        conclusaoAutomatica: [],\n        enviarEmail: false,\n        idsMovimentosFinanceiros: [],\n        idsContalancamento: []\n      },\n      message: null,\n      invalid: false,\n      toDate: new Date(),\n      fromDate: new Date('December 31, 2999 23:59:59'),\n      inputDate: null,\n      isLoadingData: false,\n      operators: [],\n      hasAtLeastOneElegibleStatment: false,\n      erroDataDeVencimento: false\n    }\n  },\n\n  computed: {\n    loggedUser () {\n      return this.$store.getters.user\n    },\n\n    loggedUserEmail () {\n      return this.$store.getters.userEmail\n    },\n\n    // retorna o idioma para o datepicker\n    datePickerLanguage () {\n      return language.getDatePickerLanguageObject()\n    },\n\n    modalTitle () {\n      return this.$t('tarefaEmMassa.titulos.titulo')\n    },\n\n    modalSubtitle () {\n      return this.$t('tarefaEmMassa.titulos.subtitulo')\n    },\n\n    portletTable () {\n      return this.$t('tarefaEmMassa.titulos.portletTable')\n    },\n\n    portletForm () {\n      return this.$t('tarefaEmMassa.titulos.portletForm')\n    },\n\n    messageEmail () {\n      return this.$t('tarefaEmMassa.titulos.enviarEmail')\n    },\n\n    isSingleStatus () {\n      // Retorna true caso todas as Situacoes do array 'items' sejam iguais\n      return this.items.length > 0 && !!this.items.reduce((previous, atual) => (previous.Situacao === atual.Situacao) ? previous : NaN)\n    },\n\n    enableSave () {\n      return this.hasAtLeastOneElegibleStatment && this.items.length > 0\n    }\n  },\n\n  watch: {\n    listRows () {\n      this.erroDataDeVencimento = false\n      this.$nextTick(() => {\n        this.$validator.reset()\n      })\n      this.task = {\n        nome: '',\n        tipoVinculo: '',\n        descricao: '',\n        situacao: {\n          id: 10,\n          nome: this.$t('tarefaEmMassa.tarefaStatuses.emAndamento')\n        },\n        dtVencimento: new Date(),\n        responsavel: null,\n        conclusaoAutomatica: [],\n        enviarEmail: false,\n        idsMovimentosFinanceiros: [],\n        idsContalancamento: []\n      }\n      this.loadOperators()\n    },\n\n    items () {\n      let noTaskStats = []\n      this.items.forEach(item => {\n        if (item.SituacaoTarefa === null) {\n          noTaskStats.push(item)\n        }\n      })\n      this.hasAtLeastOneElegibleStatment = noTaskStats.length > 0\n    }\n  },\n\n  methods: {\n    openModalConfirm () {\n      $('#confirmMassTask').modal('show')\n    },\n\n    closeModalConfirm () {\n      $('#confirmMassTask').modal('hide')\n    },\n\n    verifySave () {\n      if (this.task.idsContalancamento &&\n        this.task.idsContalancamento.length > 0 &&\n        this.task.idsMovimentosFinanceiros &&\n        this.task.idsMovimentosFinanceiros.length > 0\n      ) {\n        this.openModalConfirm()\n      } else {\n        this.validate()\n      }\n    },\n\n    validate () {\n      this.closeModalConfirm()\n      this.isLoadingData = true\n      this.$validator.validateAll().then((result) => {\n        if (result && this.dataDeVencimentoValida()) {\n          this.criatTarefaEmMAssa()\n          this.$nextTick(() => {\n            this.$validator.reset()\n          })\n        } else {\n          this.isLoadingData = false\n        }\n      })\n    },\n\n    criatTarefaEmMAssa () {\n      let massTask = {\n        dataCriacao: new Date(),\n        dataVencimento: this.task.dtVencimento,\n        nome: this.task.nome,\n        descricao: this.task.descricao,\n        situacao: this.task.situacao.id,\n        usuarioResponsavel: {\n          idUsuario: this.task.responsavel.id\n        },\n        enviarEmail: this.task.enviarEmail,\n        situacoesConclusaoAutomatica: [],\n        idsMovimentosFinanceiros: this.task.idsMovimentosFinanceiros,\n        idsContalancamento: this.task.idsContalancamento\n      }\n\n      this.task.conclusaoAutomatica.forEach(status => {\n        massTask.situacoesConclusaoAutomatica.push(status.id)\n      })\n\n      this.$store.dispatch('createMassTask', massTask)\n        .then((response) => {\n          this.$root.$refs.notification.success(response.data.message)\n          this.isLoadingData = false\n          $('#' + this.id).modal('hide')\n        })\n        .catch((error) => {\n          this.isLoadingData = false\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    // evento para interação com o datepicker\n    input () {\n      this.dataDeVencimentoValida()\n      this.validateDate()\n    },\n\n    // validação global do datepicker\n    validateDate () {\n      let isValid = this.inputDate.value.length === 10 &&\n        customValidator.isValidDate(this.inputDate.value)\n      if (!isValid) {\n        this.task.dtVencimento = null\n        this.$refs.dtVencimento.$children\n          .find(item => !!item.id).typedDate = ''\n      }\n      return this.invalid\n    },\n\n    dataDeVencimentoValida () {\n      if (this.task.dtVencimento) {\n        let today = new Date()\n        let yesterday = today.setDate(today.getDate() - 1)\n        let validDate = false\n\n        validDate = this.task.dtVencimento.getTime() > yesterday\n\n        this.erroDataDeVencimento = !validDate\n\n        return validDate\n      }\n      return true\n    },\n\n    trackCloseEvent () {\n      this.$nextTick(() => {\n        this.$validator.reset()\n      })\n      trackAnalyticsEvent(this, 'modal-mass-task', 'titlebar-close-click', this.id)\n      $('#' + this.id).modal('hide')\n    },\n\n    showDataTable () {\n      this.task.idsContalancamento = this.listIdExt\n      this.task.idsMovimentosFinanceiros = this.listIdMov\n      switch (this.gridId) {\n        case 'ExtratoConta':\n          this.task.tipoVinculo = {\n            id: 'CL',\n            descricao: this.$t('tarefaEmMassa.labels.tipoCl')\n          }\n          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt)\n            .then((response) => {\n              this.mountDataTableBankStat(response)\n            })\n          break\n        case 'RelatorioConciliacao':\n          this.task.tipoVinculo = {\n            id: 'RC',\n            descricao: this.listIdExt.length > 0 ? this.$t('tarefaEmMassa.labels.tipoCl') +\n              (this.listIdMov.length > 0 ? '/' + this.$t('tarefaEmMassa.labels.tipoMf') : '')\n              : ''\n          }\n          this.task.tipoVinculo.id = 'RC'\n          this.task.tipoVinculo.descricao = this.listIdExt.length > 0 && this.listIdMov.length > 0\n          ? this.$t('tarefaEmMassa.labels.tipoCl') + '/' + this.$t('tarefaEmMassa.labels.tipoMf')\n          : this.listIdExt.length > 0 && this.listIdMov.length === 0\n          ? this.$t('tarefaEmMassa.labels.tipoCl')\n          : this.listIdExt.length === 0 && this.listIdMov.length > 0\n          ? this.$t('tarefaEmMassa.labels.tipoMf')\n          : ' - '\n          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdExt.concat(this.listIdMov))\n            .then((response) => {\n              this.mountDataTableConcilReport(response)\n            })\n          break\n        case 'MovimentoFinanceiro':\n          this.task.tipoVinculo = {\n            id: 'MF',\n            descricao: this.$t('tarefaEmMassa.labels.tipoMf')\n          }\n          this.$store.dispatch('loadOpenTasksFromStatementIds', this.listIdMov)\n            .then((response) => {\n              this.mountDataTableMovFin(response)\n            })\n          break\n      }\n\n      // Verifica se o array de tarefas selecionados é de um mesmo status,\n      // caso seja, remove essa opção selecionada das opçoes de conclusao automática\n      if (this.isSingleStatus) {\n        this.concilStatusesTransformed = this.concilStatuses.filter(status => status.nome !== this.items[0].Situacao)\n      } else {\n        this.concilStatusesTransformed = this.concilStatuses\n      }\n    },\n\n    prepareList (movimentTasks) {\n      this.items = []\n      this.listRows.forEach(item => {\n        const movimentWithTask = movimentTasks ? movimentTasks.find((moviment) => moviment.idVinculo === item.IdLancamento) : null\n        this.items.push({\n          ID: item.IdLancamento,\n          IdLancamento: item.IdLancamento,\n          DtLanc: item.DtLanc ? moment.utc(item.DtLanc).format('l') : ' - ',\n          Banco: item.Banco ? item.Banco : ' - ',\n          NomeConta: item.NomeConta ? item.NomeConta : ' - ',\n          Agencia: item.Agencia ? item.Agencia : ' - ',\n          NrConta: item.NrConta ? item.NrConta : ' - ',\n          Tipo: item.Tipo ? typeTranslate(item.Tipo, this) : ' - ',\n          Valor: maskThousand(item.Tipo === 'C' ? item.VlLancCred : item.VlLancDeb),\n          DsCategoria: item.DsCategoria ? item.DsCategoria : ' - ',\n          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null\n        })\n      })\n    },\n\n    removeEntry (entry) {\n      let index = -1\n      this.items.forEach(item => {\n        if (item.ID === entry.ID) {\n          index = this.items.indexOf(item)\n        }\n      })\n      if (index >= 0) {\n        this.items.splice(index, 1)\n      }\n      switch (this.gridId) {\n        case 'ExtratoConta':\n          let indexCL = this.task.idsContalancamento.findIndex(item => item === entry.ID)\n          if (indexCL >= 0) {\n            this.task.idsContalancamento.splice(indexCL, 1)\n          }\n          break\n        case 'RelatorioConciliacao':\n          if (entry.Tipo === this.$t('tarefaEmMassa.extrato.TipoMovBank')) {\n            let indexCL = this.task.idsContalancamento.findIndex(item => item === entry.ID)\n            if (indexCL >= 0) {\n              this.task.idsContalancamento.splice(indexCL, 1)\n            }\n          } else if (entry.Tipo === this.$t('tarefaEmMassa.movimento.TipoMovFin')) {\n            let indexMF = this.task.idsMovimentosFinanceiros.findIndex(item => item === entry.ID)\n            if (indexMF >= 0) {\n              this.task.idsMovimentosFinanceiros.splice(indexMF, 1)\n            }\n          }\n          break\n        case 'MovimentoFinanceiro':\n          let indexMF = this.task.idsMovimentosFinanceiros.findIndex(item => item === entry.ID)\n          if (indexMF >= 0) {\n            this.task.idsMovimentosFinanceiros.splice(indexMF, 1)\n          }\n          break\n      }\n    },\n\n    displayTaskAlert (item) {\n      return item.SituacaoTarefa !== null\n    },\n\n    mountDataTableBankStat (response) {\n      this.prepareList(response.data)\n      this.columns = [\n        'flag',\n        'IdLancamento',\n        'DtLanc',\n        'Valor',\n        'DsCategoria',\n        'Banco',\n        'NomeConta',\n        'Agencia',\n        'NrConta',\n        'acoes'\n      ]\n      this.options.headings = {\n        IdLancamento: this.$t('tarefaEmMassa.extrato.IdLancamento'),\n        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),\n        Banco: this.$t('tarefaEmMassa.extrato.Banco'),\n        NomeConta: this.$t('tarefaEmMassa.extrato.NomeConta'),\n        Agencia: this.$t('tarefaEmMassa.extrato.Agencia'),\n        NrConta: this.$t('tarefaEmMassa.extrato.NrConta'),\n        Valor: this.$t('tarefaEmMassa.extrato.Valor'),\n        DsCategoria: this.$t('tarefaEmMassa.extrato.DsCategoria'),\n        flag: '',\n        acoes: this.$t('administracao.perfilAcesso.labels.acoes')\n      }\n      this.options.columnsClasses = {\n        'IdLancamento': 'col-1 limit-char',\n        'DtLanc': 'col-1 limit-char',\n        'Banco': 'col-1 limit-char',\n        'NomeConta': 'col-1 limit-char',\n        'Agencia': 'col-1 limit-char',\n        'NrConta': 'col-1 limit-char',\n        'Valor': 'col-1 limit-char',\n        'DsCategoria': 'col-1 limit-char',\n        'acoes': 'col-1',\n        'flag': 'col-1'\n      }\n      this.options.orderBy = 'IdLancamento'\n    },\n\n    prepareListMovFin (movimentTasks) {\n      this.items = []\n      this.listRows.forEach(item => {\n        const movimentWithTask = movimentTasks ? movimentTasks.find((moviment) => moviment.idVinculo === item.IdMovimentacao) : null\n        this.items.push({\n          ID: item.IdMovimentacao,\n          IdMov: item.IdMovimentacao,\n          DtLanc: moment(item.DtLanc).format('l'),\n          Tipo: item.Tipo ? typeTranslate(item.Tipo, this) : ' - ',\n          Valor: maskThousand(item.VlLancamento),\n          Estabelecimento: item.NomeEstabelecimento\n            ? item.NomeEstabelecimento +\n            (item.NomeEstabelecimentoGrupo ? ' - ' + item.NomeEstabelecimentoGrupo : '')\n            : ' - ',\n          PlanoConciliacao: item.NomePlanoConciliacao ? item.NomePlanoConciliacao : ' - ',\n          Situacao: item.SituacaoConciliacao ? conciliationStatusTranslate(item.SituacaoConciliacao, this) : ' - ',\n          DsCategoria: item.DsCategoria ? item.DsCategoria : ' - ',\n          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null\n        })\n      })\n    },\n\n    mountDataTableMovFin (response) {\n      this.prepareListMovFin(response.data)\n      this.columns = [\n        'flag',\n        'IdMov',\n        'DtLanc',\n        'Valor',\n        'Estabelecimento',\n        'PlanoConciliacao',\n        'Situacao',\n        'DsCategoria',\n        'acoes'\n      ]\n      this.options.headings = {\n        IdMov: this.$t('tarefaEmMassa.movimento.IdMov'),\n        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),\n        Tipo: this.$t('tarefaEmMassa.extrato.Tipo'),\n        Valor: this.$t('tarefaEmMassa.extrato.Valor'),\n        Estabelecimento: this.$t('tarefaEmMassa.movimento.Estabelecimento'),\n        PlanoConciliacao: this.$t('tarefaEmMassa.movimento.PlanoConcil'),\n        Situacao: this.$t('tarefaEmMassa.movimento.Situacao'),\n        DsCategoria: this.$t('tarefaEmMassa.extrato.DsCategoria'),\n        flag: '',\n        acoes: this.$t('administracao.perfilAcesso.labels.acoes')\n      }\n      this.options.columnsClasses = {\n        'IdMov': 'col-1 limit-char',\n        'DtLanc': 'col-1 limit-char',\n        'Tipo': 'col-1 limit-char',\n        'Valor': 'col-1 limit-char',\n        'Estabelecimento': 'col-1 limit-char',\n        'PlanoConciliacao': 'col-1 limit-char',\n        'Situacao': 'col-1 limit-char',\n        'DsCategoria': 'col-1 limit-char',\n        'acoes': 'col-1',\n        'flag': 'col-1'\n      }\n      this.options.orderBy = 'IdMov'\n    },\n\n    prepareConcilReport (movimentTasks) {\n      this.items = []\n      this.listRows.forEach(item => {\n        const movimentWithTask = movimentTasks ? movimentTasks.find((moviment) => moviment.idVinculo === item.IdMovFinanceiro || moviment.idVinculo === item.IdContaLancamento) : null\n        this.items.push({\n          ID: item.IdExtBancario ? item.IdExtBancario : item.IdMovFinanceiro,\n          IdLote: item.IdConciliacaoLote ? item.IdConciliacaoLote : ' - ',\n          Tipo: item.IdExtBancario\n            ? this.$t('tarefaEmMassa.extrato.TipoMovBank')\n            : this.$t('tarefaEmMassa.movimento.TipoMovFin'),\n          DtLanc: moment(item.DataLancamento).format('l'),\n          Valor: item.IdExtBancario ? maskThousand(item.ValorExtratoBancario) : maskThousand(item.ValorMovimentoFinanceiro),\n          Estabelecimento: item.Estabelecimento\n            ? item.Estabelecimento\n            : ' - ',\n          Situacao: item.FlagSituacaoConciliacao ? conciliationStatusTranslate(item.FlagSituacaoConciliacao, this) : ' - ',\n          Ocorrencia: item.DescricaoMotivoOcorrenica,\n          SituacaoTarefa: movimentWithTask ? movimentWithTask.tarefa.situacao : null\n        })\n      })\n    },\n\n    mountDataTableConcilReport (response) {\n      this.prepareConcilReport(response.data)\n      this.columns = [\n        'flag',\n        'IdLote',\n        'Tipo',\n        'DtLanc',\n        'Valor',\n        'Estabelecimento',\n        'Situacao',\n        'Ocorrencia',\n        'acoes'\n      ]\n      this.options.headings = {\n        IdLote: this.$t('tarefaEmMassa.ocorrencia.IdLote'),\n        Tipo: this.$t('tarefaEmMassa.extrato.Tipo'),\n        DtLanc: this.$t('tarefaEmMassa.extrato.DtLanc'),\n        Valor: this.$t('tarefaEmMassa.extrato.Valor'),\n        Estabelecimento: this.$t('tarefaEmMassa.movimento.Estabelecimento'),\n        Situacao: this.$t('tarefaEmMassa.movimento.Situacao'),\n        Ocorrencia: this.$t('tarefaEmMassa.ocorrencia.Ocorrencia'),\n        flag: '',\n        acoes: this.$t('administracao.perfilAcesso.labels.acoes')\n      }\n      this.options.columnsClasses = {\n        'IdLote': 'col-1 limit-char',\n        'Tipo': 'col-1 limit-char',\n        'DtLanc': 'col-1 limit-char',\n        'Valor': 'col-1 limit-char',\n        'Estabelecimento': 'col-1 limit-char',\n        'Situacao': 'col-1 limit-char',\n        'Ocorrencia': 'col-1 limit-char',\n        'acoes': 'col-1',\n        'flag': 'col-1'\n      }\n      this.options.orderBy = 'IdLote'\n    },\n\n    loadOperators () {\n      this.isLoadingData = true\n      let url = 'operator'\n      this.$store.dispatch('getOperators', url).then((response) => {\n        this.operators = response.data\n        this.operators.forEach(op => {\n          if (op.email === this.loggedUserEmail) {\n            this.task.responsavel = op\n          }\n        })\n        if (!this.task.responsavel) {\n          this.task.responsavel = this.operators[0]\n        }\n        this.showDataTable()\n        this.isLoadingData = false\n      })\n    },\n\n    alertTooltipMessage (item) {\n      let message = ''\n\n      switch (item.SituacaoTarefa) {\n        case IdSituacaoTarefaEnum.PENDENTE:\n          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.pendente')\n          break\n        case IdSituacaoTarefaEnum.EM_ANDAMENTO:\n          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.emAndamento')\n          break\n        case IdSituacaoTarefaEnum.AGUARDANDO:\n          message = this.$t('tarefaEmMassa.labels.itemVinculadoStatus.aguardando')\n          break\n      }\n\n      return this.$t('tarefaEmMassa.labels.itemVinculado') + message\n    }\n  },\n\n  mounted () {\n    this.erroDataDeVencimento = false\n    this.inputDate = document.getElementById('dtVencimento')\n    if (this.inputDate) {\n      this.inputDate.setAttribute('autocomplete', 'off')\n      this.inputDate.addEventListener('blur', () => {\n        this.validateDate()\n      })\n    }\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.task-title {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  padding: 0px 0px 5px 15px;\n  font-size: 15px;\n}\n\n.enviar-e-mail-automa {\n  font-size: 11px !important;\n  text-align: left;\n  color: #2a2a2a;\n  text-transform: initial !important;\n}\n\n.input-date-picker {\n  border: none;\n  width: 80%;\n}\n\n.form-control[disabled], fieldset[disabled] .form-control {\n  cursor: not-allowed;\n  font-weight: bold;\n  color: #626262;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1057 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-33bc27be","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/establishments/New.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.dynamic-box {\n  min-height: 380px;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/establishments/New.vue?56af82fc"],"names":[],"mappings":";AAgYA;EACA,kBAAA;CACA","file":"New.vue","sourcesContent":["<template src='./new.pug' lang=\"pug\"></template>\n\n<script>\nimport _ from 'underscore'\nimport vSelect from 'vue-select'\nimport { VueTabs, VTab } from 'vue-nav-tabs'\nimport { TheMask } from 'vue-the-mask'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport DynamicInput from '../../../input/dynamicInput/DynamicInput'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport customSorter from '../../../../utils/customSorter.js'\nimport customValidator from '../../../../utils/customValidator.js'\nimport looseDeepEqual from '../../../../utils/looseDeepEqual'\nimport PATHS from '../../../../router/routesMap.js'\n\nexport default {\n  name: 'EstablishmentsNew',\n\n  components: {\n    vSelect,\n    VueTabs,\n    VTab,\n    TheMask,\n    PageTitle,\n    DynamicInput,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      requestSent: false,\n      editFirstCity: true,\n      establishment: {\n        id: null,\n        nome: null,\n        nomeFantasia: null,\n        cnpj: null,\n        uf: null,\n        cidade: {\n          nome: '',\n          sigla: ''\n        },\n        grupo: null,\n        situacao: null\n      },\n      uf: [],\n      cities: [],\n      establishmentsGroup: [],\n      inputEstabelecimentoValidator: false,\n      tabMain: '',\n      dynamicValidator: true,\n      attributesList: [],\n      attributesLoaded: false\n    }\n  },\n\n  computed: {\n    establishmentsGroupList () {\n      return _.sortBy(this.establishmentsGroup, function (item) {\n        return customSorter.cleanLowerString(item.nome)\n      }, 'asc')\n    },\n    establishmentGroupInput () {\n      return this.establishment.grupo\n    },\n\n    tabEstab () {\n      return this.$store.getters.establishmentToEditId ? this.$t('estabelecimentos.labels.editarEstabelecimento')\n        : this.$t('estabelecimentos.labels.novoEstabelecimento')\n    },\n\n    tabAtt () {\n      return this.$t('estabelecimentos.labels.estabbelecimentoAtributos')\n    },\n\n    stylizeGroupLabel () {\n      return (option) => {\n        let result = null\n        if (typeof option === 'object') {\n          if (this.label && option[this.label]) {\n            result = option[this.label]\n          } else {\n            result = option['nome']\n          }\n        } else {\n          result = option + ' (' + this.$t('inputTag.labels.novo') + ')'\n        }\n        return result\n      }\n    }\n  },\n\n  watch: {\n    establishmentGroupInput () {\n      if (this.establishment.grupo && !this.establishment.grupo.nome) {\n        this.establishment.grupo = {nome: this.establishment.grupo}\n      }\n      if (this.establishment.grupo && this.establishment.grupo.nome && this.establishment.grupo.nome.length > 20) {\n        this.establishment.grupo.nome = this.establishment.grupo.nome.slice(0, 20)\n        this.inputEstabelecimentoValidator = true\n      } else {\n        this.establishment.grupo.nome = this.establishment.grupo.nome\n        this.inputEstabelecimentoValidator = false\n      }\n    },\n    establishment: {\n      handler () {\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.establishment, attributes: this.attributesList }, ['invalid']))\n      },\n      deep: true\n    },\n    attributesList: {\n      handler () {\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.establishment, attributes: this.attributesList }, ['invalid']))\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    setIsInvalid (att, isInvalid) {\n      att.invalid = isInvalid\n    },\n\n    loadEstablishmentAtt () {\n      const self = this\n      let url = '/establishment/loadEstablishmentAtt'\n      self.$store.dispatch('loadEstablishmentAtt', url)\n        .then((response) => {\n          self.attributesList = response\n          if (self.$store.getters.establishmentToEditId) {\n            self.loadEstablishment()\n          } else {\n            self.attributesLoaded = true\n            self.defaultObject = { ...self.establishment, attributes: [...self.attributesList.map(att => ({ ...att }))] }\n          }\n        })\n        .catch((error) => {\n          let notifTitle = self.establishment.id ? 'estabelecimentos.erro.editar' : 'estabelecimentos.erro.criar'\n          self.$root.$refs.notification.error(error.message, notifTitle)\n        }\n      )\n    },\n\n    newEstablishment () {\n      this.establishment.atributosValores = this.attributesList\n        .map(att => {\n          att.idAtributoCfg = att.atributoCfg ? att.atributoCfg.id : null\n          att.idVinculo = this.establishment.id ? this.establishment.id : null\n          if (!att.valorOriginal || att.tipo !== 'DATE') {\n            att.valor = att.valorOriginal\n            if (att.tipo === 'COMBO') {\n              att.valor = att.valorOriginal ? att.valorOriginal.valor : null\n            }\n            return att\n          }\n\n          if (!(att.valorOriginal instanceof Date)) {\n            att.valorOriginal = new Date(att.valorOriginal)\n          }\n          const [\n            day,\n            month,\n            year\n          ] = [\n            att.valorOriginal.getDate().toString().padStart(2, '0'),\n            (att.valorOriginal.getMonth() + 1).toString().padStart(2, '0'),\n            att.valorOriginal.getFullYear().toString()\n          ]\n          att.valor = `${year}/${month}/${day}`\n          return att\n        })\n\n      this.requestSent = true\n      this.$store.dispatch('newEstablishment', this.establishment)\n        .then((response) => {\n          if (this.establishment.id) {\n            this.$root.$refs.notification.success('estabelecimentos.sucesso.editado')\n          } else {\n            this.$root.$refs.notification.success('estabelecimentos.sucesso.criado')\n          }\n          this.$store.dispatch('setHasUnsavedChanges', false)\n          this.$router.push(PATHS.LIST_ESTABLISHMENTS)\n        })\n        .catch((error) => {\n          let notifTitle = this.establishment.id ? 'estabelecimentos.erro.editar' : 'estabelecimentos.erro.criar'\n          this.$root.$refs.notification.error(error.message || '', notifTitle)\n        })\n        .finally(() => {\n          this.requestSent = false\n        })\n    },\n\n    loadEstablishment () {\n      const self = this\n      self.$store.dispatch('getEstablishment', self.$store.getters.establishmentToEditId)\n        .then((response) => {\n          self.establishment = response\n          self.attributesList = self.attributesList.map(existingAttribute => {\n            existingAttribute.invalid = false\n            const insertedAttribute = self.establishment.atributosValores.find(att => att.nomeAtributo === existingAttribute.nomeAtributo)\n            if (!insertedAttribute) {\n              return existingAttribute\n            }\n            existingAttribute.valorOriginal = insertedAttribute.valor\n            if (existingAttribute.tipo === 'DATE') {\n              existingAttribute.valorOriginal = new Date(insertedAttribute.valor)\n            }\n            if (existingAttribute.tipo === 'COMBO') {\n              existingAttribute.valorOriginal = {\n                valor: insertedAttribute.valor\n              }\n            }\n            return existingAttribute\n          })\n          self.attributesLoaded = true\n          self.defaultObject = { ...self.establishment, attributes: [...self.attributesList.map(att => ({ ...att }))] }\n        })\n        .catch((error) => {\n          self.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    loadEstablishmentGroups () {\n      this.$store.dispatch('getEstablishmentGroups')\n        .then((response) => {\n          this.establishmentsGroup = response\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    loadUfs () {\n      this.$store.dispatch('getStates')\n        .then(response => {\n          this.uf = response\n          this.loadCities()\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    loadCities () {\n      this.$store.dispatch('getCities', this.establishment.uf)\n        .then(response => {\n          this.cities = response\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    updateCities (vSelectValue) {\n      if (this.editFirstCity) {\n        this.establishment.cidade = null\n      }\n      this.establishment.uf = vSelectValue\n      this.$store.dispatch('getCities', vSelectValue)\n        .then(response => {\n          this.cities = response\n          if (this.editFirstCity) {\n            this.establishment.cidade = this.cities ? this.cities[0] : null\n          }\n          this.editFirstCity = true\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    changeCities (vSelectValue) {\n      this.establishment.cidade = vSelectValue\n    },\n\n    validate () {\n      let self = this\n      self.$validator.validateAll()\n        .then((result) => {\n          if (result && self.validateCnpj()) {\n            if (self.validateAtt()) {\n              self.newEstablishment()\n            }\n          } else {\n            if (self.tabMain === self.tabAtt) {\n              self.backToEstab()\n            }\n          }\n        })\n    },\n\n    validateAtt () {\n      for (const att of this.attributesList) {\n        if (att.invalid) {\n          return false\n        }\n      }\n      // Retorna true caso não hajam atributos invalidos\n      return true\n    },\n\n    validateCnpj () {\n      if (this.establishment && this.establishment.cnpj && this.establishment.cnpj.length > 0) {\n        if (!customValidator.validateCnpj(this.establishment.cnpj)) {\n          return false\n        }\n      }\n      return true\n    },\n\n    backToEstab () {\n      this.tabMain = this.tabEstab\n    },\n\n    nextToAtt () {\n      this.tabMain = this.tabAtt\n    },\n\n    back () {\n      this.$router.go(-1)\n    },\n\n    verifyCnpj () {\n      if (this.establishment && this.establishment.cnpj && this.establishment.cnpj.length === 14) {\n        if (!customValidator.validateCnpj(this.establishment.cnpj)) {\n          this.errors.add({\n            field: 'establishmentCnpjInvalid',\n            msg: this.$t('estabelecimentos.erro.cnpjInvalido')\n          })\n        } else {\n          this.errors.remove('establishmentCnpjInvalid')\n        }\n      } else {\n        this.errors.remove('establishmentCnpjInvalid')\n      }\n    }\n  },\n\n  created () {\n    this.loadEstablishmentAtt()\n    if (!this.$store.getters.establishmentToEditId) {\n      this.editFirstCity = true\n      this.establishment.cidade = undefined\n    } else {\n      this.editFirstCity = false\n    }\n    this.loadEstablishmentGroups()\n    this.loadUfs()\n  },\n\n  mounted () {\n    let self = this\n    self.$refs.ufSelect.$refs.search.addEventListener('blur', function () {\n      // Timeout para garantir o callback BLUR após a DOM\n      // acionar o CHANGE do valor, garantindo a verificação.\n      setTimeout(() => {\n        if (!self.establishment.uf) {\n          self.$refs.ufSelect.search = ''\n        }\n      }, 100)\n    })\n\n    self.$refs.citySelect.$refs.search.addEventListener('blur', function () {\n      // Timeout para garantir o callback BLUR após a DOM\n      // acionar o CHANGE do valor, garantindo a verificação.\n      setTimeout(() => {\n        if (!self.establishment.cidade) {\n          self.establishment.uf = null\n          self.$refs.citySelect.search = ''\n        }\n      }, 100)\n    })\n  },\n\n  beforeDestroy () {\n    this.$store.dispatch('setHasUnsavedChanges', false)\n    this.$store.dispatch('cleanEstablishmentToEdit')\n  }\n}\n\n</script>\n\n<style>\n.dynamic-box {\n  min-height: 380px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1058 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-35506d6d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/operator/List.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.actions[data-v-35506d6d] {\n  text-align: center;\n}\n.action[data-v-35506d6d] {\n  text-align: center;\n  background-color: transparent !important;\n  border: none !important;\n  margin: 0 5px 0 5px;\n  color: #1c3b60\n}\n.action[data-v-35506d6d]:hover {\n  border: none !important;\n}\n.action[data-v-35506d6d]:disabled {\n  cursor: not-allowed;\n}\n", "", {"version":3,"sources":["/./client/components/views/administration/operator/List.vue?a6d7701c"],"names":[],"mappings":";AAmJA;EACA,mBAAA;CACA;AAEA;EACA,mBAAA;EACA,yCAAA;EACA,wBAAA;EACA,oBAAA;EACA,cAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,oBAAA;CACA","file":"List.vue","sourcesContent":["<template src='./list.pug' lang='pug'></template>\n\n<script>\nimport { Event } from 'vue-tables-2'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport LoadingPlaceholder from '../../../loading/LoadingPlaceholder'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport { filterBySituation, filterByAccessProfileName, filterByEmail } from '../../../../utils/customFilters.js'\nimport customSorter from '../../../../utils/customSorter.js'\nimport { generateLoadingRows } from '../../../../utils/grid-load-transition.js'\nimport PATHS from '../../../../router/routesMap.js'\n\nconst templatesWhenIsLoaded = {\n  nomePerfilAcesso: (h, row) => {\n    return row.perfilAcesso ? row.perfilAcesso.nomePerfilAcesso : '-'\n  },\n  situacao: (h, row) => {\n    return row.ativo ? 'Ativo' : 'Inativo'\n  }\n}\n\nexport default {\n  name: 'OperatorList',\n\n  components: {\n    PageTitle,\n    LoadingPlaceholder,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      isLoadingData: true,\n      loggedUserProfileId: this.$store.getters.accessProfileId,\n      operators: generateLoadingRows(10),\n      columns: ['nome', 'email', 'nomePerfilAcesso', 'situacao', 'acoes'],\n      options: {\n        columnsClasses: { nome: 'col-md-4', email: 'col-md-3', situacao: 'col-md-2', acoes: 'col-md-1', nomePerfilAcesso: 'col-md-2' },\n        headings: {\n          nome: this.$t('administracao.operadores.labels.nome'),\n          nomePerfilAcesso: this.$t('administracao.perfilAcesso.labels.perfil'),\n          email: this.$t('administracao.operadores.labels.email'),\n          acoes: this.$t('administracao.perfilAcesso.labels.acoes'),\n          situacao: this.$t('administracao.operadores.labels.situacao')\n        },\n        filterable: ['nome'],\n        customFilters: [{\n          name: 'situacao',\n          callback: filterBySituation\n        }, {\n          name: 'nomePerfilAcesso',\n          callback: filterByAccessProfileName\n        }, {\n          name: 'email',\n          callback: filterByEmail\n        }],\n        filterByColumn: true,\n        perPageValues: [],\n        templates: {\n          nome: LoadingPlaceholder,\n          email: LoadingPlaceholder,\n          situacao: LoadingPlaceholder,\n          acoes: LoadingPlaceholder,\n          nomePerfilAcesso: LoadingPlaceholder\n        },\n        texts: {\n          count: this.$t('dataTable.labels.contagem'),\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filterBy: '',\n          filterPlaceholder: this.$t('dataTable.labels.filtrar')\n        },\n        sortable: ['nome', 'email', 'nomePerfilAcesso', 'situacao'],\n        sortIcon: {\n          is: ''\n        },\n        pagination: { chunk: 5 },\n        orderBy: {\n          ascending: true,\n          column: 'nome'\n        },\n        customSorting: {\n          nome: function (ascending) {\n            return function (a, b) {\n              return customSorter.stringSorter(ascending, a, b, 'nome')\n            }\n          },\n          nomePerfilAcesso: function (ascending) {\n            return function (a, b) {\n              return customSorter.stringSorter(ascending, a, b, 'nomePerfilAcesso')\n            }\n          },\n          situacao: function (ascending) {\n            return function (a, b) {\n              return customSorter.booleanSorter(ascending, a, b, 'ativo')\n            }\n          }\n        }\n      }\n    }\n  },\n\n  methods: {\n    handleFilter (event, column) {\n      Event.$emit(`vue-tables.filter::${column}`, event.currentTarget.value)\n    },\n\n    /**\n     * Usuario Master edita/cadastra tudo.\n     * Usuario nao Master edita/cadastra perfis nao master.\n     */\n    canEditOperator (profile = {id: null}) {\n      return (this.loggedUserProfileId && this.loggedUserProfileId.toString() === '2') || (profile.id && profile.id.toString() !== '2')\n    },\n\n    edit (userId) {\n      trackAnalyticsEvent(this, 'edit-click', 'edit-operador', 'edit-operador')\n\n      this.$store.dispatch('setOperatorToEdit', userId).then((response) => {\n        this.$router.push(PATHS.NEW_OPERATOR)\n      })\n    },\n\n    newProfile () {\n      this.$router.push(PATHS.NEW_OPERATOR)\n    },\n\n    loadOperators () {\n      let url = 'operator'\n      this.$store.dispatch('getOperators', url).then((response) => {\n        this.operators = response.data.map(operator => {\n          operator.perfilAcesso = {...operator.perfilAcesso, nomePerfilAcesso: operator.perfilAcesso.nome}\n          return operator\n        }).flat()\n        this.isLoadingData = false\n        this.options.templates = templatesWhenIsLoaded\n      })\n    }\n  },\n\n  created () {\n    this.loadOperators()\n  }\n}\n</script>\n\n<style scoped>\n.actions {\n  text-align: center;\n}\n\n.action {\n  text-align: center;\n  background-color: transparent !important;\n  border: none !important;\n  margin: 0 5px 0 5px;\n  color: #1c3b60\n}\n\n.action:hover {\n  border: none !important;\n}\n\n.action:disabled {\n  cursor: not-allowed;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1059 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-37139c00","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabIntegrations/TabIntegrations.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n.detail-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #17375f;\n  font-size: 15px;\n}\n.detail-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  margin-top: 1vh;\n  color: #17375f;\n}\n#tab-integrations-id.modal-footer {\n  padding: 0px;\n}\n#main-integrations-container.main-container {\n  max-height: 50vh;\n  overflow: auto;\n}\n.modal-data-table {\n  max-width: 47vw;\n}\n.font-C {\n  color: #3bb57a;\n}\n.font-D {\n  color: #f55753;\n}\n.font-N {\n  color: #56a9c1;\n}\n.font-A {\n  color: #fdbd39;\n}\n.table-col-1 {\n  min-width: 9vw;\n  font-size: 12px;\n  text-align: initial;\n}\n.table-col-2 {\n  min-width: 15vw;\n  font-size: 12px;\n  text-align: initial;\n}\n#tab-integrations-id {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n#monetary-container {\n  margin: 5px 10px;\n}\n", "", {"version":3,"sources":["/./client/components/modals/gridDetailsModal/tabIntegrations/TabIntegrations.vue?6de99587"],"names":[],"mappings":";AA0KA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;CACA;AAEA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;CACA;AAEA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;CACA;AAEA;EACA,iBAAA;CACA","file":"TabIntegrations.vue","sourcesContent":["<template src='./tabIntegrations.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport LoadingPlaceholder from '../../../loading/LoadingPlaceholder'\nimport language from '../../../../../build/language/index'\nimport { generateLoadingRows } from '../../../../utils/grid-load-transition.js'\nimport { originTranslate } from '../../../../utils/statusesTranslator.js'\n\nmoment.locale(language.getDatePickerLanguage())\n\nexport default {\n  name: 'TabIntegrations',\n\n  components: {\n    LoadingPlaceholder\n  },\n\n  props: {\n    idModal: {\n      type: String\n    },\n    idProcessamento: {\n      type: Number,\n      required: true,\n      default: -1\n    },\n    establishtmentValue: {\n      type: Object\n    },\n    integrationValuesList: {\n      type: Array,\n      required: true\n    },\n    loadIntegration: {\n      type: Function\n    }\n  },\n\n  data () {\n    return {\n      columns: ['id', 'arquivo', 'sequencia', 'dtgen', 'layout', 'origem', 'dtproc'],\n      options: {\n        columnsClasses: {\n          'id': 'table-col-1',\n          'arquivo': 'table-col-2',\n          'sequencia': 'table-col-1',\n          'dtgen': 'table-col-1',\n          'layout': 'table-col-2',\n          'origem': 'table-col-1',\n          'dtproc': 'table-col-1'\n        },\n        headings: {\n          id: this.$t('modalDetalhesLanc.tabItegrations.labels.idProc'),\n          arquivo: this.$t('modalDetalhesLanc.tabItegrations.labels.arquivo'),\n          sequencia: this.$t('modalDetalhesLanc.tabItegrations.labels.sequencia'),\n          dtgen: this.$t('modalDetalhesLanc.tabItegrations.labels.dtgen'),\n          layout: this.$t('modalDetalhesLanc.tabItegrations.labels.layout'),\n          origem: this.$t('modalDetalhesLanc.tabItegrations.labels.origem'),\n          dtproc: this.$t('modalDetalhesLanc.tabItegrations.labels.dtproc')\n        },\n        templates: {\n          id: LoadingPlaceholder,\n          arquivo: LoadingPlaceholder,\n          sequencia: LoadingPlaceholder,\n          dtgen: LoadingPlaceholder,\n          layout: LoadingPlaceholder,\n          origem: LoadingPlaceholder,\n          dtproc: LoadingPlaceholder\n        },\n        filterable: false,\n        perPageValues: [],\n        texts: {\n          count: this.$t('dataTable.labels.contagem'),\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filter: null,\n          filterPlaceholder: null\n        },\n        pagination: {},\n        sortable: ['id'],\n        sortIcon: {\n          is: ''\n        }\n      },\n      processedFiles: generateLoadingRows(3)\n    }\n  },\n\n  methods: {\n    closeModal () {\n      $('#' + this.idModal).modal('hide')\n    },\n    getStatusValueClass (item) {\n      let title = ''\n      switch (item.value) {\n        case 'C':\n          title = 'detail-status-C'\n          break\n        case 'M':\n          title = 'detail-status-C'\n          break\n        case 'D':\n          title = 'detail-status-D'\n          break\n        case 'N':\n          title = 'detail-status-N'\n          break\n        case 'A':\n          title = 'detail-status-A'\n          break\n        default :\n          title = 'detail-value'\n          break\n      }\n      return title\n    },\n\n    getStatusValueLabel (item) {\n      let title = ''\n      switch (item.value) {\n        case 'C':\n          title = this.$t('statusConciliacao.conciliado')\n          break\n        case 'M':\n          title = this.$t('statusConciliacao.conciliadoManualmente')\n          break\n        case 'D':\n          title = this.$t('statusConciliacao.divergente')\n          break\n        case 'N':\n          title = this.$t('statusConciliacao.naoAplicavel')\n          break\n        case 'A':\n          title = this.$t('statusConciliacao.aberto')\n          break\n        default :\n          title = item.value\n          break\n      }\n      return title\n    },\n\n    loadProcFile () {\n      if (this.idProcessamento && this.idProcessamento >= 0) {\n        this.loadIntegration(this.idProcessamento).then((response) => {\n          this.processedFiles = []\n          this.processedFiles.push({\n            id: response.id,\n            arquivo: response.nomeArquivo ? response.nomeArquivo : ' - ',\n            sequencia: response.numSequencia ? response.numSequencia : ' - ',\n            dtgen: response.dataGeracao ? moment(response.dataGeracao).format('DD/MM/YYYY') : ' - ',\n            layout: response.layout ? response.layout : ' - ',\n            origem: response.origem ? originTranslate(response.origem, this) : ' - ',\n            dtproc: response.dataFinal ? moment(response.dataFinal).format('DD/MM/YYYY') : ' - '\n          })\n          this.options.templates = {}\n        }).catch((error) => {\n          this.processedFiles = []\n          this.$root.$refs.notification.error(error.message)\n        })\n      } else {\n        this.processedFiles = []\n        this.options.templates = {}\n      }\n    }\n  }\n}\n</script>\n\n<style lang='css'>\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n\n.detail-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #17375f;\n  font-size: 15px;\n}\n\n.detail-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  margin-top: 1vh;\n  color: #17375f;\n}\n\n#tab-integrations-id.modal-footer {\n  padding: 0px;\n}\n\n#main-integrations-container.main-container {\n  max-height: 50vh;\n  overflow: auto;\n}\n\n.modal-data-table {\n  max-width: 47vw;\n}\n\n.font-C {\n  color: #3bb57a;\n}\n\n.font-D {\n  color: #f55753;\n}\n\n.font-N {\n  color: #56a9c1;\n}\n\n.font-A {\n  color: #fdbd39;\n}\n\n.table-col-1 {\n  min-width: 9vw;\n  font-size: 12px;\n  text-align: initial;\n}\n\n.table-col-2 {\n  min-width: 15vw;\n  font-size: 12px;\n  text-align: initial;\n}\n\n#tab-integrations-id {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n\n#monetary-container {\n  margin: 5px 10px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1060 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-3b9486da","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/auditLog/AuditLog.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.input-button>button[data-v-3b9486da] {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n#logDeAuditoriaWrapper[data-v-3b9486da] {\n  width: 100%;\n}\n#divTreeGridAuditoria[data-v-3b9486da] {\n  min-width: 100%;\n  min-height: 500px;\n}\n.check[data-v-3b9486da] {\n  text-align: center;\n}\n.filterButton[data-v-3b9486da] {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search[data-v-3b9486da] {\n  width: 53.5%;\n}\n.search-button[data-v-3b9486da] {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/views/administration/auditLog/AuditLog.vue?30f2d548"],"names":[],"mappings":";AAuZA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA","file":"AuditLog.vue","sourcesContent":["<template src='./auditLog.pug' lang='pug'></template>\n\n<script>\nimport MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'\nimport AuditModal from '../../../administration/auditLog/AuditModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport BetterInputTag from '../../../input/betterInputTag/BetterInputTag'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport axios from '../../../../../build/http-requests/axios-common.js'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\n\nexport default {\n  name: 'AuditLog',\n\n  components: {\n    MultiSelectModal,\n    AuditModal,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    BetterInputTag,\n    ButtonPrimary,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      gridId: '#auditLogGrid',\n      isAdvancedSearch: true,\n      OPERATORS_MODAL: 'operatorsModal',\n      ENTITIES_MODAL: 'entitiesModal',\n      FUNCTIONALITIES_MODAL: 'functionalitiesModal',\n      audit: {},\n      dateRange: {},\n      list: [],\n      selectedList: [],\n      selectModal: null,\n      allItensSelected: null,\n      operatorsSelected: [],\n      operatorsTags: [this.$t('inputTag.labels.todos')],\n      functionalitiesSelected: [],\n      functionalitiesTags: [this.$t('inputTag.labels.todos')],\n      entitiesSelected: [],\n      entitiesTags: [this.$t('inputTag.labels.todos')],\n      customId: 'id',\n      firstDate: new Date(),\n      finalDate: new Date(),\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      filter: {\n        entityId: null\n      },\n      result: {},\n      treeGridFileName: 'LogDeAuditoria',\n      dataTableColumns: [],\n      disableSearchButton: false,\n      firstTimeOp: true,\n      firstTimeFunc: true,\n      firstTimeEnt: true,\n      titleModal: null,\n      subTitleModal: null,\n      columnsClasses: {},\n      orderBy: {},\n      headings: {},\n      templates: {},\n      customSorting: {},\n      sortable: [],\n      selectDataTableCustomSetOrder: null,\n      customTagMap: null,\n      rowId: null,\n      filterable: ['nome', 'email', 'nomeFuncionalidade', 'numeroEntidade', 'descricao'],\n      data: this.setDataValues(),\n      inputTagsProps: {\n        operators: {\n          id: 'id',\n          name: 'nome'\n        },\n        functionalities: {\n          id: 'idFuncionalidade',\n          name: 'nomeFuncionalidade'\n        },\n        entities: {\n          id: 'numeroEntidade',\n          name: 'numeroEntidade'\n        }\n      },\n      shown: {\n        operators: false,\n        functionalities: false,\n        entities: false\n      },\n      defaultTags: {\n        operators: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todos')\n        }],\n        functionalities: [{\n          idFuncionalidade: '-1',\n          nomeFuncionalidade: this.$t('inputTag.labels.todos')\n        }],\n        entities: [{\n          numeroEntidade: this.$t('inputTag.labels.todos'),\n          descricao: this.$t('inputTag.labels.todos')\n        }]\n      }\n    }\n  },\n\n  methods: {\n    setDataValues () {\n      const data = {\n        operators: this.setOperatorsData(),\n        functionalities: this.setFunctionalitiesData(),\n        entities: this.setEntitiesData()\n      }\n      return data\n    },\n\n    setEntitiesData () {\n      return {\n        titles: {\n          main: this.$t('logDeAuditoria.labels.entidades'),\n          sub: this.$t('logDeAuditoria.labels.selecionarEntidades')\n        },\n        selectedItems: [],\n        columns: ['numeroEntidade', 'descricao'],\n        values: [],\n        options: {\n          columnsClasses: { numeroEntidade: 'col-md-4', descricao: 'col-md-8' },\n          perPage: 5,\n          headings: {\n            numeroEntidade: this.$t('logDeAuditoria.labels.entidade'),\n            descricao: this.$t('logDeAuditoria.labels.descricao')\n          },\n          filterable: ['numeroEntidade', 'descricao'],\n          filterByColumn: true,\n          perPageValues: [],\n          texts: {\n            count: this.$t('dataTable.labels.contagem'),\n            noResults: this.$t('dataTable.labels.semResultados'),\n            filterBy: '',\n            filterPlaceholder: this.$t('dataTable.labels.filtrar')\n          },\n          sortable: ['numeroEntidade', 'descricao'],\n          sortIcon: {\n            is: ''\n          },\n          pagination: { chunk: 5 },\n          orderBy: {\n            ascending: true,\n            column: 'numeroEntidade'\n          },\n          customSorting: {\n            numeroEntidade: (asc) => {\n              return (a, b) => {\n                if (asc) {\n                  return a.numeroEntidade.toLowerCase().localeCompare(b.numeroEntidade.toLowerCase())\n                }\n                return b.numeroEntidade.toLowerCase().localeCompare(a.numeroEntidade.toLowerCase())\n              }\n            },\n            descricao: function (asc) {\n              return function (a, b) {\n                if (asc) {\n                  return a.descricao.toLowerCase().localeCompare(b.descricao.toLowerCase())\n                }\n                return b.descricao.toLowerCase().localeCompare(a.descricao.toLowerCase())\n              }\n            }\n          }\n        }\n      }\n    },\n\n    setOperatorsData () {\n      return {\n        titles: {\n          main: this.$t('logDeAuditoria.labels.operadores'),\n          sub: this.$t('logDeAuditoria.labels.selecionarOperador')\n        },\n        selectedItems: [],\n        columns: ['nome', 'email'],\n        values: [],\n        options: {\n          columnsClasses: { nome: 'col-md-7', email: 'col-md-5' },\n          perPage: 5,\n          headings: {\n            nome: this.$t('administracao.operadores.labels.nome'),\n            email: this.$t('administracao.operadores.labels.email')\n          },\n          filterable: ['nome', 'email'],\n          filterByColumn: true,\n          perPageValues: [],\n          texts: {\n            count: this.$t('dataTable.labels.contagem'),\n            noResults: this.$t('dataTable.labels.semResultados'),\n            filterBy: '',\n            filterPlaceholder: this.$t('dataTable.labels.filtrar')\n          },\n          sortable: ['nome', 'email'],\n          sortIcon: {\n            is: ''\n          },\n          pagination: { chunk: 5 },\n          orderBy: {\n            ascending: true,\n            column: 'nome'\n          },\n          customSorting: {\n            nome: (asc) => {\n              return (a, b) => {\n                if (asc) {\n                  return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                }\n                return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n              }\n            },\n            email: function (asc) {\n              return function (a, b) {\n                if (asc) {\n                  return a.email.toLowerCase().localeCompare(b.email.toLowerCase())\n                }\n                return b.email.toLowerCase().localeCompare(a.email.toLowerCase())\n              }\n            }\n          }\n        }\n      }\n    },\n\n    setFunctionalitiesData () {\n      return {\n        titles: {\n          main: this.$t('logDeAuditoria.labels.funcionalidades'),\n          sub: this.$t('logDeAuditoria.labels.selecionarFuncionalidades')\n        },\n        selectedItems: [],\n        columns: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],\n        values: [],\n        options: {\n          columnsClasses: { nomeFuncionalidade: 'col-md-7', grupoFuncionalidade: 'col-md-5' },\n          perPage: 5,\n          headings: {\n            nomeFuncionalidade: this.$t('administracao.operadores.labels.nome'),\n            nomeGrupoFuncionalidade: this.$t('administracao.perfilAcesso.labels.grupoFuncionalidade')\n          },\n          filterable: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],\n          filterByColumn: true,\n          perPageValues: [],\n          texts: {\n            count: this.$t('dataTable.labels.contagem'),\n            noResults: this.$t('dataTable.labels.semResultados'),\n            filterBy: '',\n            filterPlaceholder: this.$t('dataTable.labels.filtrar')\n          },\n          sortable: ['nomeFuncionalidade', 'nomeGrupoFuncionalidade'],\n          sortIcon: {\n            is: ''\n          },\n          pagination: { chunk: 5 },\n          orderBy: {\n            ascending: true,\n            column: 'nomeGrupoFuncionalidade'\n          },\n          customSorting: {\n            nomeFuncionalidade: (asc) => {\n              return (a, b) => {\n                if (asc) {\n                  return a.nomeFuncionalidade.toLowerCase().localeCompare(b.nomeFuncionalidade.toLowerCase())\n                }\n                return b.nomeFuncionalidade.toLowerCase().localeCompare(a.nomeFuncionalidade.toLowerCase())\n              }\n            }\n          }\n        }\n      }\n    },\n\n    validate () {\n      const self = this\n      return new Promise(resolve => {\n        this.$validator.validateAll()\n          .then((result) => {\n            if (result && this.$refs.dateRange.validate()) {\n              this.showTreegrid = true\n              startTreeGridLoading(self.gridId)\n              this.search().finally(() => {\n                resolve()\n              })\n            } else {\n              resolve()\n            }\n          })\n      })\n    },\n\n    resetFilter () {\n      this.filter.entityId = null\n      this.data.operators.selectedItems = []\n      this.data.functionalities.selectedItems = []\n      this.data.entities.selectedItems = []\n    },\n\n    search () {\n      this.disableSearchButton = true\n      let inicio = this.dateRange.fromDate\n      let fim = this.dateRange.toDate\n\n      let filter = {\n        inicio: inicio,\n        fim: fim,\n        idEntidadeDoSistema: this.filter.entityId,\n        idsOperadores: this.data.operators.selectedItems.map(selected => selected.id).filter(operator => operator !== '-1'),\n        idsFuncionalidades: this.data.functionalities.selectedItems.map(selected => selected.idFuncionalidade).filter(functionality => functionality !== '-1'),\n        idsEntidades: this.data.entities.selectedItems.map(selected => selected.numeroEntidade).filter(entity => entity !== this.$t('inputTag.labels.todos'))\n      }\n\n      return new Promise((resolve, reject) => {\n        axios.post('/auditLog/audits', { filter: filter })\n          .then((response) => {\n            window.DisposeGrids()\n            this.result = response.data\n            window.Grids.abrirModalAuditoria = (row) => {\n              this.$store.dispatch('getAudit', row.Id)\n                .then((response) => {\n                  this.audit = response.data\n                  $('#auditModal').modal()\n                })\n            }\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            resolve()\n          })\n          .catch((error) => {\n            this.$root.$refs.notification.error(error)\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            reject()\n          })\n      })\n    },\n\n    openSelectOperatorsModal () {\n      if (this.data.operators.values.length > 0) {\n        this.shown.operators = true\n        return\n      }\n      this.$store.dispatch('getOperators', '/auditLog/operator').then((response) => {\n        this.data.operators.values = response.data\n        this.shown.operators = true\n      })\n    },\n\n    openSelectFunctionalitiesModal () {\n      if (this.data.functionalities.values.length > 0) {\n        this.shown.functionalities = true\n        return\n      }\n      this.$store.dispatch('getFunctionalitiesGroups', '/auditLog/functionalitiesGroups').then((response) => {\n        this.data.functionalities.values = response.data.map(gf => {\n          gf.funcionalidades.forEach(f => {\n            f.idFuncionalidade = f.id\n            f.nomeFuncionalidade = f.nome\n            f.nomeGrupoFuncionalidade = gf.nome\n          })\n          return gf.funcionalidades\n        }).flat()\n        this.shown.functionalities = true\n      })\n    },\n\n    openSelectEntitiesModal () {\n      if (this.data.entities.values.length > 0) {\n        this.shown.entities = true\n        return\n      }\n      this.$store.dispatch('getEntities').then((response) => {\n        this.data.entities.values = response.data.data.map(entity => {\n          if (entity.numeroEntidade === 'AtributoConfig') {\n            entity.numeroEntidade = 'Atributo'\n          }\n          return entity\n        })\n        this.shown.entities = true\n      })\n    },\n\n    openModal () {\n      $('#selectModal').modal({ backdrop: 'static', keyboard: false })\n    },\n\n    closeModal () {\n      this.shown.operators = false\n      this.shown.functionalities = false\n      this.shown.entities = false\n    }\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.check {\n  text-align: center;\n}\n\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search {\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1061 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4140c414","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabAllotment/TabAllotment.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n@media screen and (min-width: 1199px) {\n.left-vertical-tabs {\n    width: 10%;\n}\n.right-text-tabs {\n    width: 90%;\n}\n}\n@media screen and (min-width: 992px) and (max-width: 1199px) {\n.left-vertical-tabs {\n    width: 15%;\n}\n.right-text-tabs {\n    width: 85%;\n}\n}\n@media screen and (max-width: 991px) and (min-width: 560px) {\n.left-vertical-tabs {\n    width: 20%;\n}\n.right-text-tabs {\n    width: 80%;\n}\n}\n@media screen and (max-width: 559px) {\n.left-vertical-tabs {\n    width: 25%;\n}\n.right-text-tabs {\n    width: 75%;\n}\n}\n#btnTabLoteConcManualDivergence {\n  margin-bottom: 10px;\n  margin-top: 0px;\n  min-width: auto;\n  width: 26px;\n  height: 26px;\n  padding: 0px 0px 0px 1px;\n}\n#tab-allotment-id {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n.loadingData {\n  background: url(" + __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67) + ") 50% 50% no-repeat;\n  cursor: wait;\n  height: 390px;\n  background-size: 100px;\n}\n.limit-char {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.no-allotment-img {\n  height: 30vh;\n}\n.big-txt-allotment {\n  font-family: 'Inter', sans-serif !important;\nfont-weight: 700;\n  color: #012351;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n.detail-value-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #012351;\n  font-size: 18px;\n}\n.detail-status-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 26px;\n}\n.detail-title-allotment {\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  margin-top: 1vh;\n  color: #012351;\n}\n#tab-allotment-id.modal-footer {\n  padding: 0px;\n}\n#main-allotment-container.main-container {\n  max-height: 50vh;\n  overflow: auto;\n}\n#datatable-container .allotment-data-table {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  max-width: 100%;\n  max-height: 38vh !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.font-C {\n  color: #3bb57a !important;\n}\n.font-D {\n  color: #f55753 !important;\n}\n.font-N {\n  color: #56a9c1 !important;\n}\n.font-A {\n  color: #fdbd39 !important;\n}\n.font-default {\n  color: #17375f !important;\n}\n.col-1 {\n  width: 3vw;\n  font-size: 12px;\n}\n.col-2 {\n  width: 7vw;\n  font-size: 12px;\n}\n.selected-row {\n  background-color: #617a95 !important;\n  color: #fff;\n}\n.margin-container {\n  margin-top: 15px;\n}\n.monetary-container {\n  background: #eff0f3;\n  border: 1px solid #DDD;\n  margin-top: 15px;\n  padding: 15px;\n}\n.loading-center {\n  text-align: center;\n  margin-bottom: 60px;\n}\n.detail-allotment-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #012351;\n  font-size: 14px;\n}\n.VueTables__sortable > span.VueTables__heading {\n  padding-right: 15px;\n}\n.VueTables__table .VueTables__sort-icon.glyphicon::before {\n  top: 1px;\n  position: absolute;\n  left: -10px;\n}\n#datatable-container .VueTables .row {\n  -ms-flex-order: 3;\n      order: 3;\n  margin: 12px 0 0;\n  padding: 0;\n}\n#datatable-container .VueTables .row .VueTables__limit {\n  margin: 0;\n}\n#datatable-container .VueTables .row .VueTables__limit label{\n  text-transform: initial;\n  font-weight: normal;\n  font-size: 14px;\n  margin-right: 10px;\n}\n#datatable-container .VueTables .table-responsive {\n  -ms-flex-order: 1;\n      order: 1;\n}\n#datatable-container .VueTables .VuePagination {\n  -ms-flex: 1;\n      flex: 1;\n  -ms-flex-order: 2;\n      order: 2;\n  margin-top: 12px;\n}\n#datatable-container .VueTables .VuePagination nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n#datatable-container .VueTables .VuePagination nav ul {\n  -ms-flex-order: 2;\n      order: 2;\n  margin: 0 auto;\n}\n#datatable-container .VueTables .VuePagination nav p {\n  -ms-flex-order: 1;\n      order: 1;\n  width: auto;\n  padding: 0;\n  margin: 0;\n}\n.tab-allotment-detail-id {\n  min-height: 71vh !important;\n}\n", "", {"version":3,"sources":["/./client/components/modals/gridDetailsModal/tabAllotment/TabAllotment.vue?16b0f11a"],"names":[],"mappings":";AA+WA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;AAEA;IACA,WAAA;CACA;CACA;AAEA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;CACA;AAEA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;CACA;AAEA;EACA,4DAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;CACA;AAEA;EACA,oBAAA;EACA,wBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,4CAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,wBAAA;MAAA,oBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,qCAAA;EACA,YAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,oBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;CACA;AAEA;EACA,mBAAA;EACA,oBAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;CACA;AAEA;EACA,kBAAA;MAAA,SAAA;EACA,iBAAA;EACA,WAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,kBAAA;MAAA,SAAA;CACA;AAEA;EACA,YAAA;MAAA,QAAA;EACA,kBAAA;MAAA,SAAA;EACA,iBAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,uBAAA;MAAA,oBAAA;CACA;AAEA;EACA,kBAAA;MAAA,SAAA;EACA,eAAA;CACA;AAEA;EACA,kBAAA;MAAA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;CACA;AAEA;EACA,4BAAA;CACA","file":"TabAllotment.vue","sourcesContent":["<template src='./tabAllotment.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport LoadingPlaceholder from '../../../loading/LoadingPlaceholder'\nimport language from '../../../../../build/language/index'\nimport { maskThousand } from '../../../../utils/numberMasker.js'\nimport PATHS from '../../../../router/routesMap.js'\n\nmoment.locale(language.getDatePickerLanguage())\n\nexport default {\n  name: 'TabAllotment',\n\n  components: {\n    ButtonPrimary,\n    LoadingPlaceholder\n  },\n\n  props: {\n    // Prop enviada pelos relatórios de lançamentos.\n    // Indica que as informações vêm dos movimentos bancários/financeiros.\n    idMovimento: {\n      type: String,\n      default: null\n    },\n\n    // Prop enviada pelos relatórios de lançamentos.\n    // Indica que as informações vêm dos movimentos bancários/financeiros.\n    tipoMovimento: {\n      type: String,\n      default: null\n    },\n\n    // Prop enviada pela tela de conciliação manual.\n    // Indica que as informações vêm da grid de lotes.\n    dadosLote: {\n      type: Object,\n      default: null\n    },\n\n    getAllotment: {\n      type: Function\n    }\n  },\n\n  data () {\n    return {\n      loadingGif: require('../../../../assets/loading-gif/loading.svg'),\n      columns: ['id', 'estabelecimento', 'dtLanc', 'vlMovFin', 'vlMovExt', 'cdOcu', 'dsOcu', 'nmConta', 'banco', 'nrConta', 'agencia'],\n      options: {\n        columnsClasses: {\n          'id': 'col-1 limit-char',\n          'estabelecimento': 'col-2 limit-char',\n          'dtLanc': 'col-1 limit-char',\n          'vlMovFin': 'col-2 limit-char',\n          'vlMovExt': 'col-2 limit-char',\n          'cdOcu': 'col-1 limit-char',\n          'dsOcu': 'col-1 limit-char',\n          'nmConta': 'col-1 limit-char',\n          'banco': 'col-1 limit-char',\n          'nrConta': 'col-1 limit-char',\n          'agencia': 'col-1 limit-char'\n        },\n        headings: {\n          id: this.$t('modalDetalhesLanc.tabLotes.labels.id'),\n          estabelecimento: this.$t('estabelecimentos.labels.estabelecimento'),\n          dtLanc: this.$t('modalDetalhesLanc.tabLotes.labels.dtLanc'),\n          vlMovFin: this.$t('modalDetalhesLanc.tabLotes.labels.vlMovFinanc'),\n          vlMovExt: this.$t('modalDetalhesLanc.tabLotes.labels.vlMovExtrato'),\n          cdOcu: this.$t('modalDetalhesLanc.tabLotes.labels.codOcorrencia'),\n          dsOcu: this.$t('modalDetalhesLanc.tabLotes.labels.dsOcorrencia'),\n          nmConta: this.$t('modalDetalhesLanc.tabLotes.labels.nmConta'),\n          banco: this.$t('modalDetalhesLanc.tabLotes.labels.banco'),\n          nrConta: this.$t('modalDetalhesLanc.tabLotes.labels.nrConta'),\n          agencia: this.$t('modalDetalhesLanc.tabLotes.labels.agencia')\n        },\n        templates: {\n          id: (h, row) => {\n            return row.id ? row.id : ' - '\n          },\n          dtLanc: (h, row) => {\n            return moment(row.dataLancamento).utc().format('L')\n          },\n          vlMovFin: (h, row) => {\n            return maskThousand(row.valorMovFin)\n          },\n          vlMovExt: (h, row) => {\n            return maskThousand(row.valorMovBan)\n          },\n          cdOcu: (h, row) => {\n            return row.motivoOcorrencia && row.motivoOcorrencia.codigo ? row.motivoOcorrencia.codigo : ' - '\n          },\n          dsOcu: (h, row) => {\n            return row.motivoOcorrencia && row.motivoOcorrencia.descricao ? row.motivoOcorrencia.descricao : ' - '\n          },\n          nmConta: (h, row) => {\n            return row.nomeConta ? row.nomeConta : ' - '\n          },\n          nrConta: (h, row) => {\n            return row.numConta ? row.numConta : ' - '\n          }\n        },\n        rowClassCallback: (row) => {\n          let customClass = ''\n          if (row.id && row.id === this.idMovimento) {\n            customClass = 'selected-row'\n          }\n          return customClass\n        },\n        filterable: false,\n        perPage: 10,\n        perPageValues: [10, 20, 50, 100],\n        texts: {\n          count: this.$t('dataTable.labels.contagem'),\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filterBy: '',\n          filterPlaceholder: null,\n          limit: this.$t('dataTable.labels.registrosPorPagina')\n        },\n        pagination: { chunk: 5 },\n        sortable: ['id', 'estabelecimento', 'dtLanc', 'vlMovFin', 'vlMovExt', 'cdOcu', 'dsOcu', 'nmConta', 'banco', 'nrConta', 'agencia'],\n        sortIcon: {\n          is: ''\n        }\n      },\n      hasAllotment: false,\n      isLoadingData: true,\n      allotment: {\n        lancamentos: []\n      },\n      idLastLanc: null\n    }\n  },\n\n  computed: {\n    allotmentEntries () {\n      return this.allotment && this.allotment.lancamentos ? this.allotment.lancamentos : []\n    },\n    allotmentId () {\n      return this.allotment && this.allotment.idLote ? this.allotment.idLote : ' - '\n    },\n    allotmentQtdLanc () {\n      return this.allotment.lancamentos ? this.allotment.lancamentos.length : ' - '\n    },\n    allotmentStatus () {\n      return {\n        valor: this.getStatusValueLabel(this.allotment.situacao),\n        classe: this.getStatusValueClass(this.allotment.situacao)\n      }\n    },\n    totalMovFin () {\n      return this.allotment && this.allotment.totalMovFin ? this.allotment.totalMovFin : 0.00\n    },\n    totalMovExt () {\n      return this.allotment && this.allotment.totalMovBan ? this.allotment.totalMovBan : 0.00\n    },\n    totalDivergencia () {\n      return parseFloat(this.totalMovExt).toFixed(2) - parseFloat(this.totalMovFin).toFixed(2)\n    },\n    totalMovFinTransformed () {\n      return maskThousand(this.totalMovFin)\n    },\n    totalMovExtTransformed () {\n      return maskThousand(this.totalMovExt)\n    },\n    totalDivergenciaTransformed () {\n      return maskThousand(this.totalDivergencia)\n    },\n    dateRangeAllotment () {\n      return moment(this.allotment.dtInicio).utc().format('L') + ' - ' + moment(this.allotment.dtFim).utc().format('L')\n    },\n    canGoToManualConcil () {\n      return this.totalDivergencia !== 0 && this.dadosLote === null\n    },\n    canConciliate () {\n      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(199) >= 0\n    },\n    criteria () {\n      return this.allotment && this.allotment.critConciliacao ? this.allotment.critConciliacao : '-'\n    }\n  },\n\n  methods: {\n    closeModal (idModal) {\n      $('#' + idModal).modal('hide')\n    },\n\n    getStatusValueClass (item) {\n      let title = ''\n      switch (item) {\n        case 'C':\n          title = 'font-C'\n          break\n        case 'M':\n          title = 'font-C'\n          break\n        case 'D':\n          title = 'font-D'\n          break\n        case 'N':\n          title = 'font-N'\n          break\n        case 'A':\n          title = 'font-A'\n          break\n        default:\n          title = ''\n          break\n      }\n      return title\n    },\n\n    getStatusValueLabel (item) {\n      let title = ''\n      switch (item) {\n        case 'C':\n          title = this.$t('statusConciliacao.conciliado')\n          break\n        case 'M':\n          title = this.$t('statusConciliacao.conciliadoManualmente')\n          break\n        case 'D':\n          title = this.$t('statusConciliacao.divergente')\n          break\n        case 'N':\n          title = this.$t('statusConciliacao.naoAplicavel')\n          break\n        case 'A':\n          title = this.$t('statusConciliacao.aberto')\n          break\n        default:\n          title = ' - '\n          break\n      }\n      return title\n    },\n\n    loadAllotment () {\n      if (!this.idLastLanc || (this.idLastLanc !== this.idMovimento)) {\n        this.isLoadingData = true\n        this.getAllotment(this.idMovimento).then((response) => {\n          this.idLastLanc = this.idMovimento\n          this.isLoadingData = false\n          this.hasAllotment = response.data.idLote != null\n          this.allotment = response.data\n          this.setAllotmentRangeDate()\n          this.setAllotmentMovCounts()\n        }).catch((error) => {\n          if (error.message) {\n            this.$root.$refs.notification.error(error.message)\n          } else {\n            // Validação específica do parse dos dados\n            this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')\n          }\n          this.isLoadingData = false\n          this.hasAllotment = false\n          this.allotment.lancamentos = []\n          this.closeModal()\n        })\n      }\n    },\n\n    createAllotmentDetailsFromManualConcilaition () {\n      if (!this.idLastLanc || (this.idLastLanc !== (this.dadosLote && this.dadosLote.idLote ? this.dadosLote.idLote : -1))) {\n        this.isLoadingData = true\n        this.$store.dispatch('recoverAllotmentMov', this.dadosLote.idLote).then((response) => {\n          this.idLastLanc = this.dadosLote.idLote\n          this.isLoadingData = false\n          this.hasAllotment = this.dadosLote.idLote != null\n          this.allotment = this.dadosLote\n          this.allotment.countMovFin = response.financialMovements ? response.financialMovements.length : 0\n          this.allotment.countMovBan = response.bankMovements ? response.bankMovements.length : 0\n          this.allotment.lancamentos = []\n          response.financialMovements.forEach(movFin => {\n            let item = {\n              id: movFin.id,\n              dataLancamento: movFin.data,\n              valorMovFin: movFin.valor,\n              valorMovBan: 0,\n              estabelecimento: movFin.estabelecimento,\n              motivoOcorrencia: {\n                codigo: movFin.cdOcorrencia,\n                descricao: movFin.dsOcorrencia\n              },\n              nomeConta: movFin.nomeConta,\n              banco: movFin.banco,\n              numConta: movFin.numConta,\n              agencia: movFin.agencia\n            }\n            this.allotment.lancamentos.push(item)\n          })\n          response.bankMovements.forEach(movBan => {\n            let item = {\n              id: movBan.id,\n              dataLancamento: movBan.data,\n              valorMovFin: 0,\n              valorMovBan: movBan.valor,\n              estabelecimento: movBan.estabelecimento,\n              motivoOcorrencia: {\n                codigo: movBan.cdOcorrencia,\n                descricao: movBan.dsOcorrencia\n              },\n              nomeConta: movBan.nomeConta,\n              banco: movBan.banco,\n              numConta: movBan.numConta,\n              agencia: movBan.agencia\n            }\n            this.allotment.lancamentos.push(item)\n          })\n        }).catch((error) => {\n          if (error.message) {\n            this.$root.$refs.notification.error(error.message)\n          } else {\n            // Validação específica do parse dos dados\n            this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')\n          }\n          this.closeModal('detalhesLoteConcManual')\n          this.hasAllotment = false\n          this.allotment.lancamentos = []\n        })\n      }\n    },\n\n    goManualConcil () {\n      // Abre tela de conciliação manual em nova aba\n      window.open(PATHS.MANUAL_CONCILIATION, '_blank')\n    },\n\n    // Normaliza os dados de datas da aba da modal de lançamentos\n    // para estrutura reutilizável para lotes\n    setAllotmentRangeDate () {\n      let startDate = new Date('01/01/9999')\n      let endDate = new Date('01/01/1900')\n      this.allotment.lancamentos.forEach(entry => {\n        let date = entry.dataLancamento ? entry.dataLancamento : entry.data\n        if (moment(date).isBefore(startDate)) {\n          startDate = date\n        }\n        if (moment(date).isAfter(endDate)) {\n          endDate = date\n        }\n      })\n\n      this.allotment.dtInicio = startDate\n      this.allotment.dtFim = endDate\n    },\n\n    // Normaliza os dados de contadores de movimentos da aba da modal\n    // de lançamentos para estrutura reutilizável para lotes\n    setAllotmentMovCounts () {\n      let finCount = 0\n      let banCount = 0\n      this.allotment.lancamentos.forEach(mov => {\n        mov.banco !== ' - '\n        ? banCount++\n        : finCount++\n      })\n      this.allotment.countMovFin = finCount\n      this.allotment.countMovBan = banCount\n    }\n  }\n}\n</script>\n\n<style>\n@media screen and (min-width: 1199px) {\n  .left-vertical-tabs {\n    width: 10%;\n  }\n\n  .right-text-tabs {\n    width: 90%;\n  }\n}\n\n@media screen and (min-width: 992px) and (max-width: 1199px) {\n  .left-vertical-tabs {\n    width: 15%;\n  }\n\n  .right-text-tabs {\n    width: 85%;\n  }\n}\n\n@media screen and (max-width: 991px) and (min-width: 560px) {\n  .left-vertical-tabs {\n    width: 20%;\n  }\n\n  .right-text-tabs {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 559px) {\n  .left-vertical-tabs {\n    width: 25%;\n  }\n\n  .right-text-tabs {\n    width: 75%;\n  }\n}\n\n#btnTabLoteConcManualDivergence {\n  margin-bottom: 10px;\n  margin-top: 0px;\n  min-width: auto;\n  width: 26px;\n  height: 26px;\n  padding: 0px 0px 0px 1px;\n}\n\n#tab-allotment-id {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n\n.loadingData {\n  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;\n  cursor: wait;\n  height: 390px;\n  background-size: 100px;\n}\n\n.limit-char {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.no-allotment-img {\n  height: 30vh;\n}\n\n.big-txt-allotment {\n  font-family: 'Inter', sans-serif !important;\nfont-weight: 700;\n  color: #012351;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\n\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n\n.detail-value-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #012351;\n  font-size: 18px;\n}\n\n.detail-status-allotment {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 26px;\n}\n\n.detail-title-allotment {\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  margin-top: 1vh;\n  color: #012351;\n}\n\n#tab-allotment-id.modal-footer {\n  padding: 0px;\n}\n\n#main-allotment-container.main-container {\n  max-height: 50vh;\n  overflow: auto;\n}\n\n#datatable-container .allotment-data-table {\n  display: flex;\n  flex-flow: row wrap;\n  max-width: 100%;\n  max-height: 38vh !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.font-C {\n  color: #3bb57a !important;\n}\n\n.font-D {\n  color: #f55753 !important;\n}\n\n.font-N {\n  color: #56a9c1 !important;\n}\n\n.font-A {\n  color: #fdbd39 !important;\n}\n\n.font-default {\n  color: #17375f !important;\n}\n\n.col-1 {\n  width: 3vw;\n  font-size: 12px;\n}\n\n.col-2 {\n  width: 7vw;\n  font-size: 12px;\n}\n\n.selected-row {\n  background-color: #617a95 !important;\n  color: #fff;\n}\n\n.margin-container {\n  margin-top: 15px;\n}\n\n.monetary-container {\n  background: #eff0f3;\n  border: 1px solid #DDD;\n  margin-top: 15px;\n  padding: 15px;\n}\n\n.loading-center {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.detail-allotment-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #012351;\n  font-size: 14px;\n}\n\n.VueTables__sortable > span.VueTables__heading {\n  padding-right: 15px;\n}\n\n.VueTables__table .VueTables__sort-icon.glyphicon::before {\n  top: 1px;\n  position: absolute;\n  left: -10px;\n}\n\n#datatable-container .VueTables .row {\n  order: 3;\n  margin: 12px 0 0;\n  padding: 0;\n}\n\n#datatable-container .VueTables .row .VueTables__limit {\n  margin: 0;\n}\n\n#datatable-container .VueTables .row .VueTables__limit label{\n  text-transform: initial;\n  font-weight: normal;\n  font-size: 14px;\n  margin-right: 10px;\n}\n\n#datatable-container .VueTables .table-responsive {\n  order: 1;\n}\n\n#datatable-container .VueTables .VuePagination {\n  flex: 1;\n  order: 2;\n  margin-top: 12px;\n}\n\n#datatable-container .VueTables .VuePagination nav {\n  display: flex;\n  align-items: center;\n}\n\n#datatable-container .VueTables .VuePagination nav ul {\n  order: 2;\n  margin: 0 auto;\n}\n\n#datatable-container .VueTables .VuePagination nav p {\n  order: 1;\n  width: auto;\n  padding: 0;\n  margin: 0;\n}\n\n.tab-allotment-detail-id {\n  min-height: 71vh !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1062 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4485b970","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/establishments/List.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.margin-right[data-v-4485b970] {\n  margin-right: 15px;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/establishments/List.vue?8a697998"],"names":[],"mappings":";AA2JA;EACA,mBAAA;CACA","file":"List.vue","sourcesContent":["<template src=\"./list.pug\" lang=\"pug\"></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport { TheMask } from 'vue-the-mask'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\nimport PATHS from '../../../../router/routesMap.js'\n\nexport default {\n  name: 'EstablishmentsList',\n\n  components: {\n    vSelect,\n    TheMask,\n    PageTitle,\n    ButtonPrimary,\n    FilterPortlet,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      gridId: '#establishmentsGrid',\n      treeGridCfg: {},\n      isLoadingData: true,\n      exportUrl: EXPORT_TREEGRID,\n      showTreegrid: false,\n      filter: {\n        nome: null,\n        cnpj: null,\n        uf: null,\n        cidade: null,\n        grupo: null,\n        situacoes: null\n      },\n      situationList: [\n        {\n          id: 'A',\n          value: 1,\n          nome: this.$t('estabelecimentos.labels.ativo'),\n          checked: true\n        },\n        {\n          id: 'I',\n          value: 0,\n          nome: this.$t('estabelecimentos.labels.inativo'),\n          checked: true\n        }\n      ],\n      disableSearchButton: false,\n      selectedStatuses: [0, 1],\n      uf: [],\n      cities: [],\n      establishmentsGroup: [],\n      result: {}\n    }\n  },\n\n  watch: {\n    situationList: {\n      handler (val) {\n        this.selectedStatuses = []\n        val.forEach(st => {\n          if (st.checked) {\n            this.selectedStatuses.push(st.value)\n          }\n        })\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    validate (isScrollable = true) {\n      let self = this\n      this.$validator.validateAll()\n        .then((result) => {\n          if (result) {\n            this.showTreegrid = true\n            startTreeGridLoading(self.gridId, undefined, isScrollable)\n            this.search(isScrollable)\n          }\n        })\n    },\n\n    search (isScrollable = true) {\n      this.disableSearchButton = true\n      this.filter.nome = this.filter.nome ? this.filter.nome : null\n      this.filter.cnpj = this.filter.cnpj ? this.filter.cnpj : null\n      this.filter.lang = language.getCookieByName('language')\n      this.loadEstablishments(isScrollable)\n    },\n\n    edit (establishmentId) {\n      this.$store.dispatch('setEstablishmentToEdit', establishmentId).then((response) => {\n        this.$router.push(PATHS.NEW_ESTABLISHMENT)\n      })\n    },\n\n    newEstablishment () {\n      this.$router.push(PATHS.NEW_ESTABLISHMENT)\n    },\n\n    moveEstablishment () {\n      this.$router.push(PATHS.MOVE_ESTABLISHMENT)\n    },\n\n    loadEstablishments (isScrollable = true) {\n      this.filter.url = 'establishment/listDetails'\n      this.filter.situacao = false\n      this.filter.idioma = language.getCookieByName('language')\n      this.$store.dispatch('getEstablishmentsToTreeGrid', this.filter)\n      .then((response) => {\n        if (window.DisposeGrids) {\n          window.DisposeGrids()\n        }\n        this.treeGridCfg = response.data.Cfg.Layout\n        this.result = response.data\n        window.Grids.editEstablishment = (row) => {\n          this.edit(row.id)\n        }\n        stopTreeGridLoading(this.gridId, isScrollable)\n        this.disableSearchButton = false\n      }).catch((error) => {\n        this.$root.$refs.notification.error(error.message)\n        stopTreeGridLoading(this.gridId, isScrollable)\n        this.disableSearchButton = false\n      })\n    },\n\n    loadEstablishmentGroups () {\n      this.$store.dispatch('getEstablishmentGroups')\n        .then((response) => {\n          this.establishmentsGroup = response\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n    }\n  },\n\n  created () {\n    this.loadEstablishmentGroups()\n    this.validate(false)\n  }\n}\n</script>\n\n<style scoped>\n.margin-right {\n  margin-right: 15px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1063 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-44a5b89a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/GridDetailsModal.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#main-value-container.main-container {\n  padding-right: 15px;\n  padding-left: 15px;\n  padding-top: 15px;\n}\n#statuses-container {\n  margin-top: 10px;\n}\n#tab-historic-id {\n  margin: 0 !important;\n  padding-top: 10px;\n  height: 71vh !important;\n  width: 100% !important;\n}\n#tabbed-modal {\n  min-height: 71vh !important;\n}\n.tab.tab-container {\n  height: 100%;\n}\n#tab-details-id {\n  position: relative;\n  height: 100%;\n}\n#footer-monetary-container {\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n}\n#footer-monetary-detail-container {\n  position: inherit;\n  width: 100%;\n}\n#tab-allotment-id {\n  position: relative;\n  height: 100%;\n}\n#tab-tasks-id {\n  position: relative;\n  height: 100%;\n}\n.modal-lg {\n  width: 75vw;\n}\n.tab-icon-font {\n  font-size: 12px;\n}\n.tab {\n  margin-top: 0px !important;\n}\n.tabbed-modal-body {\n  padding: 0px !important;\n}\n#tabbed-modal.vue-tabs .nav-tabs {\n  border-bottom: none;\n}\n#tabbed-modal.vue-tabs .nav>li.active span.title {\n  color: #37F3F5;\n  font-size: 12px;\n}\n#tabbed-modal.vue-tabs .nav>li span.title {\n  color: #8AA4AF;\n  font-size: 12px;\n}\n\n/*Active*/\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus {\n  border-left: 5px solid!important;\n  border-color: #37F3F5!important;\n  transition: all 0.2s!important;\n  border-top: 0px !important;\n  border-right: 0px !important;\n  border-bottom: 0px !important;\n  background: #132E4D;\n  color: #37F3F5!important;\n}\n#tabbed-modal.vue-tabs .nav-tabs>li>a,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:focus {\n  border: none !important;\n  color: #8AA4AF;\n  background: transparent;\n  border-radius: 0px;\n  margin-right: 0px;\n}\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover {\n  background: #10253E;\n}\n.left-vertical-tabs {\n  background: #1B3C65;\n}\n.modal .modal-content {\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n.tab-historic {\n  max-height: 450px;\n  overflow-y: auto;\n}\n.tab-left {\n  text-align: center\n}\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus>.tab-left{\n  text-align: center;\n  margin-left: -5px;\n}\n", "", {"version":3,"sources":["/./client/components/modals/gridDetailsModal/GridDetailsModal.vue?05caa0e8"],"names":[],"mappings":";AA2LA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;CACA;AAEA;EACA,4BAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;CACA;AAEA;EACA,kBAAA;EACA,YAAA;CACA;AAEA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,eAAA;EACA,gBAAA;CACA;;AAEA,UAAA;AACA;;;EAGA,iCAAA;EACA,gCAAA;EAIA,+BAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,oBAAA;EACA,yBAAA;CACA;AAEA;;;EAGA,wBAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;CACA;AAEA;EACA,kBAAA;EACA,iBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;;;EAGA,mBAAA;EACA,kBAAA;CACA","file":"GridDetailsModal.vue","sourcesContent":["<template src='./gridDetailsModal.pug' lang='pug'></template>\n\n<script>\nimport { mapGetters } from 'vuex'\nimport { VueTabs, VTab } from 'vue-nav-tabs'\nimport BetterModal from '../betterModal/BetterModal'\nimport TabDetails from './tabDetails/TabDetails'\nimport TabIntegrations from './tabIntegrations/TabIntegrations'\nimport TabHistoric from './tabHistoric/TabHistoric'\nimport TabAllotment from './tabAllotment/TabAllotment'\nimport TabTasks from './tabTasks/TabTasks'\nimport TabClassification from './tabClassification/TabClassification'\nimport closeModal from '../../../events/closeModal.js'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\nimport popExitingConfirmation from '../../../utils/popExitingConfirmation'\n\nexport default {\n  name: 'GridDetailsModal',\n\n  components: {\n    VueTabs,\n    VTab,\n    BetterModal,\n    TabDetails,\n    TabIntegrations,\n    TabHistoric,\n    TabAllotment,\n    TabTasks,\n    TabClassification\n  },\n\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    size: {\n      type: String\n    },\n    closable: {\n      type: Boolean,\n      default: false\n    },\n    closeFunction: {\n    },\n    tabs: {\n      type: Array,\n      required: true\n    },\n    defaultTab: {\n      type: String,\n      required: false,\n      default: 'gridDetailsModal-tabDetails'\n    },\n    labelModalTitle: {\n      type: String,\n      default: 'modalDetalhesLanc.titulos.titulo'\n    },\n    labelModalSubTitle: {\n      type: String,\n      default: 'modalDetalhesLanc.titulos.subtitulo'\n    },\n    isOpen: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      tabName: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),\n      mustReloadParent: false\n    }\n  },\n\n  computed: {\n    modalTitle () {\n      return this.$t(this.labelModalTitle)\n    },\n\n    modalSubtitle () {\n      return this.$t(this.labelModalSubTitle)\n    },\n\n    hasUnsavedChanges () {\n      return this.$store.getters.hasUnsavedChanges\n    },\n\n    ...mapGetters([\n      'isManagingTask'\n    ])\n  },\n\n  watch: {\n    tabs () {\n      let self = this\n      if (self.defaultTab === 'gridDetailsModal-tabDetails') {\n        setTimeout(() => {\n          self.$refs.tabRouter.navigateToTab(0)\n        }, 100)\n        self.tabName = self.$t('modalDetalhesLanc.titulos.tabDetalhes')\n      } else if (self.defaultTab === 'gridDetailsModal-tabTasks') {\n        setTimeout(() => {\n          self.$refs.tabRouter.navigateToTab(this.tabs.length - 1)\n        }, 100)\n      }\n    }\n  },\n\n  methods: {\n    trackEvent () {\n      if (this.hasUnsavedChanges && !popExitingConfirmation()) {\n        return\n      }\n      this.$store.dispatch('setHasUnsavedChanges', false)\n      trackAnalyticsEvent(this, 'close-grid-modal', 'titlebar-close-click', this.id)\n      closeModal.$emit('modalDetailsClose', this.mustReloadParent)\n      this.$emit('closeDetailsModal')\n      window.Grids[0].Enable()\n      if (this.$refs.tabTasksGridModal) {\n        this.$refs.tabTasksGridModal[0].$children[0].clearManagementTask()\n      }\n    },\n\n    handleTabChange (tabIndex, newTab, oldTab) {\n      trackAnalyticsEvent(this, 'tab-click', newTab.id + '-click', this.getTabIdLanc(newTab.id))\n      this.$store.dispatch('setHasUnsavedChanges', false)\n      switch (newTab.id) {\n        case 'gridDetailsModal-tabDetails':\n          break\n        case 'gridDetailsModal-tabIntegrations':\n          this.$refs.tadIntegrationGridModal[0].$children[0].loadProcFile()\n          break\n        case 'gridDetailsModal-tabHistoric':\n          this.$refs.tabHisotiricGridModal[0].$children[0].clickAction()\n          break\n        case 'gridDetailsModal-tabAllotment':\n          this.$refs.tadAllotmentGridModal[0].$children[0].loadAllotment()\n          break\n        case 'gridDetailsModal-tabTasks':\n          this.$refs.tabTasksGridModal[0].$children[0].loadTaskData(this.isManagingtask)\n          break\n        case 'gridDetailsModal-tabTask':\n          this.$refs.tabTasksGridModal[0].$children[0].loadTaskDetail()\n          break\n        case 'gridDetailsModal-tabClassification':\n          this.$refs.tabClassificationGridModal[0].$children[0].prepareTab()\n          break\n        default:\n          break\n      }\n    },\n\n    getTabIdLanc (tabId) {\n      let lanc = null\n      this.tabs.forEach(tab => {\n        if (tab.idTabRoot === tabId) {\n          lanc = tab.idLanc\n        }\n      })\n      return lanc\n    },\n\n    // Verifica se possui permissão para exibir a aba. Atualmente, só há essa verificação para a aba de tarefas, pois o usuário só pode\n    // ter acesso a essa aba caso tenha permissão da funcionalidade 'TAREFAS'.\n    // Para as outras abas não há verificação específica, por isso a funcionalidade(id) das outras abas é passada como NULL\n    verifyTabAuthorization (id) {\n      if (!id) {\n        return true\n      } else {\n        if (this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.length > 0 && this.$store.getters.allowedFuncionalities.indexOf(id) >= 0) {\n          return true\n        }\n      }\n      return false\n    }\n  },\n\n  mounted () {\n    closeModal.$on('taskChange', (flag) => {\n      this.mustReloadParent = flag\n    })\n  }\n}\n</script>\n\n<style lang='css'>\n#main-value-container.main-container {\n  padding-right: 15px;\n  padding-left: 15px;\n  padding-top: 15px;\n}\n\n#statuses-container {\n  margin-top: 10px;\n}\n\n#tab-historic-id {\n  margin: 0 !important;\n  padding-top: 10px;\n  height: 71vh !important;\n  width: 100% !important;\n}\n\n#tabbed-modal {\n  min-height: 71vh !important;\n}\n\n.tab.tab-container {\n  height: 100%;\n}\n\n#tab-details-id {\n  position: relative;\n  height: 100%;\n}\n\n#footer-monetary-container {\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n}\n\n#footer-monetary-detail-container {\n  position: inherit;\n  width: 100%;\n}\n\n#tab-allotment-id {\n  position: relative;\n  height: 100%;\n}\n\n#tab-tasks-id {\n  position: relative;\n  height: 100%;\n}\n\n.modal-lg {\n  width: 75vw;\n}\n\n.tab-icon-font {\n  font-size: 12px;\n}\n\n.tab {\n  margin-top: 0px !important;\n}\n\n.tabbed-modal-body {\n  padding: 0px !important;\n}\n\n#tabbed-modal.vue-tabs .nav-tabs {\n  border-bottom: none;\n}\n\n#tabbed-modal.vue-tabs .nav>li.active span.title {\n  color: #37F3F5;\n  font-size: 12px;\n}\n\n#tabbed-modal.vue-tabs .nav>li span.title {\n  color: #8AA4AF;\n  font-size: 12px;\n}\n\n/*Active*/\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus {\n  border-left: 5px solid!important;\n  border-color: #37F3F5!important;\n  -webkit-transition: all 0.2ms!important;\n  -moz-transition: all 0.2ms!important;\n  -o-transition: all 0.2ms!important;\n  transition: all 0.2s!important;\n  border-top: 0px !important;\n  border-right: 0px !important;\n  border-bottom: 0px !important;\n  background: #132E4D;\n  color: #37F3F5!important;\n}\n\n#tabbed-modal.vue-tabs .nav-tabs>li>a,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:focus {\n  border: none !important;\n  color: #8AA4AF;\n  background: transparent;\n  border-radius: 0px;\n  margin-right: 0px;\n}\n\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover {\n  background: #10253E;\n}\n\n.left-vertical-tabs {\n  background: #1B3C65;\n}\n\n.modal .modal-content {\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n\n.tab-historic {\n  max-height: 450px;\n  overflow-y: auto;\n}\n\n.tab-left {\n  text-align: center\n}\n\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus>.tab-left{\n  text-align: center;\n  margin-left: -5px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1064 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-44b39af4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/input/dateRange/DateRange.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.datepicker-input {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 5px;\n  display: inline;\n  margin-left: 10px;\n}\n.datepicker-wrapper {\n  display: inline !important;\n}\n.datepicker-wrapper div:first-child {\n  display: inline !important;\n}\n.wrapperClass div:first-child {\n  display: inline !important;\n}\n.wrapperClass {\n  display: inline !important;\n}\n.fix-aligment {\n  padding-left: 0;\n  padding-top: 4px;\n}\n.disable-datepicker {\n  background-color: #f8f8f8;\n  cursor: default;\n}\n\n/* DatePicker*/\n.date-picker {\n  border: none;\n  height: 28px;\n  width: 100px;\n}\n.month-picker {\n  border: none;\n  height: 28px;\n  width: 130px;\n}\n.vdp-datepicker {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 11px 8px 10px 8px;\n  margin-right: 5px;\n}\n.vdp-datepicker-margin-top {\n  margin-top: 10px;\n}\n.second-date-picker {\n  margin-left: 10px;\n}\n.second-date-picker .vdp-datepicker__calendar {\n  margin-left: 180px;\n}\n.vdp-datepicker__calendar {\n  padding: 5px;\n}\n.vdp-datepicker__calendar header span {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n}\n.vdp-datepicker__calendar .cell {\n  height: 35px !important;\n  line-height: 35px !important;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #8c8c8c;\n  height: 35px;\n  line-height: 35px;\n}\n.vdp-datepicker__calendar .cell.selected,\n.vdp-datepicker__calendar .cell.selected.highlighted,\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #40b9bb !important;\n  color: #fff !important;\n  border-radius: 5px;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #40b9bb !important;\n  border-radius: 5px;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #8c8c8c !important;\n}\n.vdp-datepicker__calendar .cell.today {\n  background-image: url(" + __webpack_require__(/*! ../../../assets/icones_app/today-signal.png */ 680) + ") !important;\n  background-repeat: no-repeat !important;\n  background-position: 30px 20px !important;\n}\n.vdp-datepicker__calendar {\n  z-index: 3!important;\n}\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n", "", {"version":3,"sources":["/./client/components/input/dateRange/DateRange.vue?01e21dc3"],"names":[],"mappings":";AA0KA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,gBAAA;EACA,iBAAA;CACA;AAEA;EACA,0BAAA;EACA,gBAAA;CACA;;AAEA,eAAA;AACA;EACA,aAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,aAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;CACA;AAEA;EACA,wBAAA;EACA,6BAAA;CACA;AAEA;EACA,iCAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;CACA;AAEA;;;EAGA,+BAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;;;EAGA,qCAAA;EACA,mBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,2DAAA;EACA,wCAAA;EACA,0CAAA;CACA;AAEA;EACA,qBAAA;CACA;AAEA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA","file":"DateRange.vue","sourcesContent":["<template src='./dateRange.pug' lang='pug'></template>\n\n<script>\nimport Datepicker from 'vuejs-datepicker'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport idioma from '../../../../build/language/index'\nimport customValidator from '../../../utils/customValidator.js'\n\nexport default {\n  name: 'DateRange',\n\n  components: {\n    Datepicker,\n    ButtonPrimary\n  },\n\n  props: {\n    value: {\n      type: Object\n    },\n    initialFromDate: {\n      type: Date\n    },\n    initialToDate: {\n      type: Date\n    },\n    maxRange: {\n      type: Number\n    },\n    customPeriodMessage: {\n      type: String,\n      default: null\n    },\n    customDatesMessage: {\n      type: String,\n      default: null\n    },\n    finalDateDisableFrom: {\n      type: Date,\n      default () {\n        return new Date()\n      }\n    },\n    disableDateRange: {\n      type: Boolean,\n      default: false\n    },\n    displayLabel: {\n      type: Boolean,\n      default: true\n    },\n    displayAction: {\n      type: Boolean,\n      default: false\n    },\n    action: {\n      type: Function,\n      default: null\n    }\n  },\n\n  data () {\n    return {\n      clients: [],\n      idioma: idioma,\n      fromDate: this.initialFromDate,\n      toDate: this.initialToDate,\n      message: null,\n      invalid: false,\n      inputFrom: null,\n      inputTo: null\n    }\n  },\n\n  computed: {\n    datePickerLanguage () {\n      return this.idioma.getDatePickerLanguageObject()\n    },\n\n    errorMessage () {\n      return this.message\n    },\n\n    isInvalid () {\n      return this.invalid\n    },\n\n    endDateDisableFrom () {\n      return this.finalDateDisableFrom ? this.finalDateDisableFrom : new Date()\n    }\n  },\n\n  methods: {\n    input () {\n      this.invalid = !this.validate()\n      // Retorna um objeto toda vez que o período é alterado\n      // Setando a data inicial para as 00:00, e a data final para 24:00\n      this.$emit('input', {\n        fromDate: this.resetHours(this.fromDate, false),\n        toDate: this.resetHours(this.toDate, true),\n        invalid: this.invalid\n      })\n    },\n\n    validate () {\n      if (!this.isDateValid(this.inputFrom)) {\n        this.fromDate = this.initialFromDate\n      }\n\n      if (!this.isDateValid(this.inputTo)) {\n        this.toDate = this.initialToDate\n      }\n\n      this.fromDate = new Date(this.resetHours(this.fromDate, false))\n      this.toDate = new Date(this.resetHours(this.toDate, true))\n\n      let isDateRangeValid = true\n      let timeDiff = Math.abs(this.fromDate.getTime() - this.toDate.getTime())\n      let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))\n\n      if (diffDays > this.maxRange) {\n        this.message = this.$t('dateRange.validacao.periodoMaximo', {dias: this.maxRange})\n        isDateRangeValid = false\n      }\n\n      if (this.fromDate > this.toDate) {\n        this.message = this.$t('dateRange.validacao.dataInicialMaiorFinal')\n        isDateRangeValid = false\n      }\n      return isDateRangeValid\n    },\n\n    isDateValid (input) {\n      return input.value.length === 10 && customValidator.isValidDate(input.value)\n    },\n\n    resetHours (date, endOfTheDay) {\n      if (typeof date === 'number') {\n        date = new Date(date)\n      }\n\n      if (endOfTheDay) {\n        return date.setHours(23, 59, 59, 999)\n      }\n      return date.setHours(0, 0, 0, 0)\n    }\n  },\n\n  created () {\n    this.fromDate = this.initialFromDate\n    this.toDate = this.initialToDate\n\n    this.$emit('input', {\n      fromDate: this.resetHours(this.fromDate, false),\n      toDate: this.resetHours(this.toDate, true),\n      invalid: this.invalid\n    })\n  },\n\n  mounted () {\n    this.inputFrom = document.getElementById('datePickerFromDate')\n    this.inputFrom.setAttribute('autocomplete', 'off')\n\n    this.inputTo = document.getElementById('datePickerToDate')\n    this.inputTo.setAttribute('autocomplete', 'off')\n  }\n}\n</script>\n\n<style>\n.datepicker-input {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 5px;\n  display: inline;\n  margin-left: 10px;\n}\n\n.datepicker-wrapper {\n  display: inline !important;\n}\n\n.datepicker-wrapper div:first-child {\n  display: inline !important;\n}\n\n.wrapperClass div:first-child {\n  display: inline !important;\n}\n\n.wrapperClass {\n  display: inline !important;\n}\n\n.fix-aligment {\n  padding-left: 0;\n  padding-top: 4px;\n}\n\n.disable-datepicker {\n  background-color: #f8f8f8;\n  cursor: default;\n}\n\n/* DatePicker*/\n.date-picker {\n  border: none;\n  height: 28px;\n  width: 100px;\n}\n\n.month-picker {\n  border: none;\n  height: 28px;\n  width: 130px;\n}\n\n.vdp-datepicker {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 11px 8px 10px 8px;\n  margin-right: 5px;\n}\n\n.vdp-datepicker-margin-top {\n  margin-top: 10px;\n}\n\n.second-date-picker {\n  margin-left: 10px;\n}\n\n.second-date-picker .vdp-datepicker__calendar {\n  margin-left: 180px;\n}\n\n.vdp-datepicker__calendar {\n  padding: 5px;\n}\n\n.vdp-datepicker__calendar header span {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n}\n\n.vdp-datepicker__calendar .cell {\n  height: 35px !important;\n  line-height: 35px !important;\n}\n\n.vdp-datepicker__calendar .cell.day-header {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #8c8c8c;\n  height: 35px;\n  line-height: 35px;\n}\n\n.vdp-datepicker__calendar .cell.selected,\n.vdp-datepicker__calendar .cell.selected.highlighted,\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #40b9bb !important;\n  color: #fff !important;\n  border-radius: 5px;\n}\n\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #40b9bb !important;\n  border-radius: 5px;\n}\n\n.vdp-datepicker__calendar .disabled {\n  color: #8c8c8c !important;\n}\n\n.vdp-datepicker__calendar .cell.today {\n  background-image: url('../../../assets/icones_app/today-signal.png') !important;\n  background-repeat: no-repeat !important;\n  background-position: 30px 20px !important;\n}\n\n.vdp-datepicker__calendar {\n  z-index: 3!important;\n}\n\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1065 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4672dfff","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonPrimary/ButtonPrimary.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.common[data-v-4672dfff] {\n  font-family: 'Inter', sans-serif;\n  min-width: 40px;\n  text-align: center;\n}\n.common a[data-v-4672dfff] {\n  margin: 0 5px 0 5px;\n}\n.primary[data-v-4672dfff] {\n  background-color: #40b9bb;\n  margin: 10px 0px 10px 0px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  border-radius: 4px;\n}\n.secondary[data-v-4672dfff] {\n  margin: 10px 10px 10px 0;\n  color: #666;\n  background-color: #fff;\n  border-color: #999;\n}\n.secondary[data-v-4672dfff]:hover {\n  color: #666;\n  background-color: #EFEFEF;\n  border-color: #999;\n}\n.secondary[disabled][data-v-4672dfff] {\n  background-color: #EFEFEF;\n  border: 1px solid #ccc;\n  color: #666;\n}\n.secondary[disabled][data-v-4672dfff]:hover {\n  background-color: #EFEFEF;\n  border: 1px solid #ccc;\n}\n.big-primary[data-v-4672dfff] {\n  font-size: 17px !important;\n}\n.primary[disabled][data-v-4672dfff] {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n  color: #FFF;\n}\n.primary[disabled][data-v-4672dfff]:hover {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n}\n.grayed[data-v-4672dfff] {\n  margin: 38px 10px 10px 0;\n  color: #fff;\n  background-color: #b0b0b0;\n  border-color: #999;\n}\n.grayed[data-v-4672dfff]:hover {\n  color: #fff;\n  background-color: #566573;\n  border-color: #999;\n}\n.grayed[disabled][data-v-4672dfff] {\n  background-color:  #5d6d7e;\n  border: 1px solid #ccc;\n  color: #fff;\n}\n.grayed[disabled][data-v-4672dfff]:hover {\n  background-color: #85929e;\n  border: 1px solid #ccc;\n  color: #fff;\n}\n.danger[data-v-4672dfff] {\n  margin: 10px 10px 10px 0;\n  color: #fff;\n  background-color: rgb(234 106 106);\n  border-color: #fff;\n  border-radius: 4px;\n}\n.danger[disabled][data-v-4672dfff] {\n  background-color: #f08f8f;\n  border: 1px solid #ccc;\n  color: #fff;\n}\n", "", {"version":3,"sources":["/./client/components/buttons/buttonPrimary/ButtonPrimary.vue?1ee2957d"],"names":[],"mappings":";AAsDA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;CACA;AAEA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;CACA;AAEA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,uBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;CACA;AAEA;EACA,yBAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;CACA;AAEA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;CACA;AAEA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;EACA,yBAAA;EACA,YAAA;EACA,mCAAA;EACA,mBAAA;EACA,mBAAA;CACA;AAEA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;CACA","file":"ButtonPrimary.vue","sourcesContent":["<template src='./buttonPrimary.pug' lang='pug'></template>\n\n<script>\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\n\nexport default {\n  name: 'ButtonPrimary',\n\n  props: {\n    faIcon: {\n      type: String\n    },\n    label: {\n      type: String\n    },\n    clickFunction: {\n      type: Function,\n      required: false\n    },\n    id: {\n      type: String,\n      required: true\n    },\n    type: {\n      type: String,\n      default: 'button'\n    },\n    customClass: {\n      type: String\n    },\n    width: {\n      type: String\n    },\n    title: {\n      type: String\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  methods: {\n    trackEvent () {\n      trackAnalyticsEvent(this, 'button-click', 'primary-button-component', this.id)\n      if (typeof this.clickFunction !== 'undefined') {\n        this.clickFunction()\n      }\n    }\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.common {\n  font-family: 'Inter', sans-serif;\n  min-width: 40px;\n  text-align: center;\n}\n\n.common a {\n  margin: 0 5px 0 5px;\n}\n\n.primary {\n  background-color: #40b9bb;\n  margin: 10px 0px 10px 0px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  border-radius: 4px;\n}\n\n.secondary {\n  margin: 10px 10px 10px 0;\n  color: #666;\n  background-color: #fff;\n  border-color: #999;\n}\n\n.secondary:hover {\n  color: #666;\n  background-color: #EFEFEF;\n  border-color: #999;\n}\n\n.secondary[disabled] {\n  background-color: #EFEFEF;\n  border: 1px solid #ccc;\n  color: #666;\n}\n\n.secondary[disabled]:hover {\n  background-color: #EFEFEF;\n  border: 1px solid #ccc;\n}\n\n.big-primary {\n  font-size: 17px !important;\n}\n\n.primary[disabled] {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n  color: #FFF;\n}\n\n.primary[disabled]:hover {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n}\n\n.grayed {\n  margin: 38px 10px 10px 0;\n  color: #fff;\n  background-color: #b0b0b0;\n  border-color: #999;\n}\n\n.grayed:hover {\n  color: #fff;\n  background-color: #566573;\n  border-color: #999;\n}\n\n.grayed[disabled] {\n  background-color:  #5d6d7e;\n  border: 1px solid #ccc;\n  color: #fff;\n}\n\n.grayed[disabled]:hover {\n  background-color: #85929e;\n  border: 1px solid #ccc;\n  color: #fff;\n}\n\n.danger {\n  margin: 10px 10px 10px 0;\n  color: #fff;\n  background-color: rgb(234 106 106);\n  border-color: #fff;\n  border-radius: 4px;\n}\n\n.danger[disabled] {\n  background-color: #f08f8f;\n  border: 1px solid #ccc;\n  color: #fff;\n}\n</style>\n\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1066 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-475e994c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/occurrenceReport/OccurrenceReport.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports
exports.i(__webpack_require__(/*! -!../../../../../~/css-loader?sourceMap!../../../../../~/vue-nav-tabs/themes/vue-tabs.css */ 484), "");

// module
exports.push([module.i, "\n#tab-navigation {\n  font-family: 'Inter', sans-serif;\n}\n.tab {\n  margin-top: 20px;\n}\n.nav-tabs>li>a {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  text-transform: none;\n}\n.vue-tabs .nav>li span.title {\n  color: #142C4F;\n}\n.vue-tabs .nav-tabs {\n  border-bottom: 1px solid #e1e1e1;\n}\n.vue-tabs .nav-tabs>li>a {\n  border: none;\n}\n.vue-tabs .nav>li.active span.title {\n  color: #142C4F;\n}\n.vue-tabs .nav-tabs>li.active>a,\n.vue-tabs .nav-tabs>li.active>a:hover,\n.vue-tabs .nav-tabs>li.active>a:focus {\n  border: none;\n  border-top: 5px solid #142C4F;\n  color: #142C4F;\n  background: #fff;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 11px;\n}\n.vue-tabs .nav-tabs>li>a,\n.vue-tabs .nav-tabs>li>a:hover,\n.vue-tabs .nav-tabs>li>a:focus {\n  border: none;\n  border: 1px solid #e1e1e1;\n  color: #142C4F;\n  background: transparent;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 13px;\n}\n.tab-content {\n  background: #fff;\n}\n.pending-title {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  margin-top: 3vh;\n  color: #17375f;\n}\n.grey-right-border {\n  border-right: solid 2px #cccccc;\n}\n.pending-box {\n  padding-right: 25px!important;\n}\n.pending-conciliation-box {\n  display: -ms-grid;\n  display: grid;\n}\n.centered {\n  text-align: center;\n}\n.badge-custom {\n  padding: 7px 2px;\n  margin-left: 1vh;\n  background-color: #f55753 !important;\n  border-radius: 50%;\n  min-width: 30px;\n  margin-top: 21px;\n  right: 2px;\n  z-index: 9;\n  position: absolute;\n}\np.placeholderInputTag {\n  z-index:3;\n  position:absolute;\n  padding: 7px 0px 0px 7px;\n  color: #999;\n}\nbutton.filter-input-tag {\n  width: 100%;\n  min-width:auto;\n  padding:0px;\n}\n", "", {"version":3,"sources":["/./client/components/views/reports/occurrenceReport/OccurrenceReport.vue?a8bd09d6"],"names":[],"mappings":";AAmOA;EACA,iCAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,iCAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;;;EAGA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;CACA;AAEA;;;EAGA,aAAA;EACA,0BAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,gCAAA;CACA;AAEA;EACA,8BAAA;CACA;AAEA;EACA,kBAAA;EAAA,cAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,iBAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;CACA;AAEA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;EACA,eAAA;EACA,YAAA;CACA","file":"OccurrenceReport.vue","sourcesContent":["<template src=\"./occurrenceReport.pug\" lang=\"pug\"></template>\n\n<script>\n\nimport MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport BetterInputTag from '../../../input/betterInputTag/BetterInputTag'\nimport InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\n\nexport default {\n  name: 'OccurrenceReport',\n\n  components: {\n    MultiSelectModal,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    BetterInputTag,\n    InputEstablishment,\n    ButtonPrimary,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      establishimentsUrls: {\n        establishments: 'occurrenceReport/establishment/list',\n        attributes: '/occurrenceReport/loadEstablishmentAtt'\n      },\n      selectedEstablishments: [],\n      isAdvancedSearch: true,\n      gridId: '#occurrenceReportGrid',\n      result: {},\n      treeGridCfg: {},\n      OCCURRENCES_MODAL: 'occurrencesModal',\n      dateRange: {},\n      itensSelected: [],\n      list: [],\n      selectedList: [],\n      selectedStatuses: [],\n      firstDate: new Date(),\n      finalDate: new Date(),\n      dataTableColumns: [],\n      disableSearchButton: false,\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      firstTime: true,\n      titleModal: null,\n      subTitleModal: null,\n      columnsClasses: {},\n      orderBy: {},\n      headings: {},\n      templates: {},\n      customSorting: {},\n      sortable: [],\n      firstTimeOccurrence: true,\n      selectDataTableCustomSetOrder: null,\n      customTagMap: null,\n      filterable: [],\n      attList: [],\n      columnsFilterable: [],\n      showCustomColumns: false,\n      inputTagsProps: {\n        occurrenceReason: {\n          id: 'id',\n          name: 'descricao'\n        }\n      },\n      shown: {\n        occurrenceReason: false\n      },\n      defaultTags: {\n        occurrenceReason: [{\n          id: '-1',\n          descricao: this.$t('inputTag.labels.todos')\n        }]\n      },\n      data: {\n        occurrenceReason: {\n          titles: {\n            main: this.$t('relatorioOcorrencia.labels.motivoOcorrencia'),\n            sub: this.$t('relatorioOcorrencia.labels.selecaoMotivoOcorrencia')\n          },\n          selectedItems: [],\n          columns: ['codigo', 'descricao'],\n          values: [],\n          options: {\n            columnsClasses: { codigo: 'col-md-4', descricao: 'col-md-8' },\n            perPage: 5,\n            headings: {\n              codigo: this.$t('motivoOcorrencia.labels.sigla'),\n              descricao: this.$t('motivoOcorrencia.labels.descricao')\n            },\n            filterable: ['codigo', 'descricao'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['codigo', 'descricao'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'codigo'\n            },\n            customSorting: {\n              codigo: function (asc) {\n                return function (a, b) {\n                  if (asc) {\n                    return a.codigo.toLowerCase().localeCompare(b.codigo.toLowerCase())\n                  }\n                  return b.codigo.toLowerCase().localeCompare(a.codigo.toLowerCase())\n                }\n              },\n              descricao: function (asc) {\n                return function (a, b) {\n                  if (asc) {\n                    return a.descricao.toLowerCase().localeCompare(b.descricao.toLowerCase())\n                  }\n                  return b.descricao.toLowerCase().localeCompare(a.descricao.toLowerCase())\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  },\n\n  computed: {\n    idsFilterEstablishments () {\n      return this.$store.getters.idsFilterEstablishments\n    }\n  },\n\n  methods: {\n    resetFilter () {\n      this.selectedEstablishments = []\n      this.data.occurrenceReason.selectedItems = []\n    },\n\n    validate () {\n      let self = this\n      return new Promise(resolve => {\n        this.$validator.validateAll().then((result) => {\n          if (result && this.$refs.dateRange.validate()) {\n            this.showTreegrid = true\n            startTreeGridLoading(self.gridId)\n            this.search().finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    search () {\n      this.disableSearchButton = true\n      let inicio = this.dateRange.fromDate\n      let fim = this.dateRange.toDate\n      let filter = {\n        inicio: inicio,\n        fim: fim,\n        idsMotivosOcorrencias: this.data.occurrenceReason.selectedItems.map(selected => selected.id).filter(occurrence => occurrence !== '-1'),\n        idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),\n        idsPlanosConciliacao: [], // this.plansSelected.map(plan => plan['id']),\n        lang: language.getCookieByName('language')\n      }\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchOccurrenceReport', filter)\n          .then((response) => {\n            window.DisposeGrids()\n            this.treeGridCfg = response.data.Cfg.Layout\n            this.result = response.data\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            resolve()\n          }).catch((error) => {\n            this.$root.$refs.notification.error(error)\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            reject()\n          })\n      })\n    },\n\n    openSelectOccurrencesModal () {\n      if (this.data.occurrenceReason.values.length > 0) {\n        this.shown.occurrenceReason = true\n        return\n      }\n      this.$store.dispatch('getOccurrenceReasons', '/occurrenceReport/occurrenceReason/list').then((response) => {\n        this.data.occurrenceReason.values = response.data.data\n        this.shown.occurrenceReason = true\n      })\n    },\n\n    closeModal () {\n      this.shown.occurrenceReason = false\n    }\n  },\n\n  created () {\n    this.$store.dispatch('cleanEditState')\n  }\n}\n</script>\n\n<style>\n@import '../../../../../node_modules/vue-nav-tabs/themes/vue-tabs.css';\n#tab-navigation {\n  font-family: 'Inter', sans-serif;\n}\n\n.tab {\n  margin-top: 20px;\n}\n\n.nav-tabs>li>a {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  text-transform: none;\n}\n\n.vue-tabs .nav>li span.title {\n  color: #142C4F;\n}\n\n.vue-tabs .nav-tabs {\n  border-bottom: 1px solid #e1e1e1;\n}\n\n.vue-tabs .nav-tabs>li>a {\n  border: none;\n}\n\n.vue-tabs .nav>li.active span.title {\n  color: #142C4F;\n}\n\n.vue-tabs .nav-tabs>li.active>a,\n.vue-tabs .nav-tabs>li.active>a:hover,\n.vue-tabs .nav-tabs>li.active>a:focus {\n  border: none;\n  border-top: 5px solid #142C4F;\n  color: #142C4F;\n  background: #fff;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 11px;\n}\n\n.vue-tabs .nav-tabs>li>a,\n.vue-tabs .nav-tabs>li>a:hover,\n.vue-tabs .nav-tabs>li>a:focus {\n  border: none;\n  border: 1px solid #e1e1e1;\n  color: #142C4F;\n  background: transparent;\n  font-weight: 600;\n  margin-bottom: -1px;\n  padding-bottom: 13px;\n}\n\n.tab-content {\n  background: #fff;\n}\n\n.pending-title {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  margin-top: 3vh;\n  color: #17375f;\n}\n\n.grey-right-border {\n  border-right: solid 2px #cccccc;\n}\n\n.pending-box {\n  padding-right: 25px!important;\n}\n\n.pending-conciliation-box {\n  display: grid;\n}\n\n.centered {\n  text-align: center;\n}\n\n.badge-custom {\n  padding: 7px 2px;\n  margin-left: 1vh;\n  background-color: #f55753 !important;\n  border-radius: 50%;\n  min-width: 30px;\n  margin-top: 21px;\n  right: 2px;\n  z-index: 9;\n  position: absolute;\n}\n\np.placeholderInputTag {\n  z-index:3;\n  position:absolute;\n  padding: 7px 0px 0px 7px;\n  color: #999;\n}\n\nbutton.filter-input-tag {\n  width: 100%;\n  min-width:auto;\n  padding:0px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1067 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4ab25a9f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCritFields.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.info-text[data-v-4ab25a9f] {\n  color: #1d436a;\n  font-size: 15px;\n}\n.info-icon-text[data-v-4ab25a9f] {\n  margin-right: 10px;\n  color: #1d436a;\n  font-size: 15px;\n}\n", "", {"version":3,"sources":["/./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCritFields.vue?5233b109"],"names":[],"mappings":";AAqKA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;CACA","file":"ConciliationCritFields.vue","sourcesContent":["<template src='./conciliationCritFields.pug' lang='pug'></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'ConciliationCritFields',\n\n  components: {\n    vSelect,\n    ButtonPrimary\n  },\n\n  props: {\n    conciliationField: {\n      type: Object,\n      default: {},\n      required: true\n    },\n    attributesCfgMfList: {\n      type: Array,\n      default: () => [],\n      required: true\n    },\n    attributesMfList: {\n      type: Array,\n      default: () => [],\n      required: true\n    },\n    mfFieldList: {\n      type: Array,\n      default: () => [],\n      required: true\n    },\n    mbFieldList: {\n      type: Array,\n      default: () => [],\n      required: true\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    conciliationFieldList: {\n      type: Array,\n      default: () => [],\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      field: {\n        atributo: {\n          nomeAtributo: null,\n          atributoCfg: null\n        }\n      }\n    }\n  },\n\n  computed: {\n    mfCfgList () {\n      let mfCfgList = []\n      let self = this\n      this.attributesCfgMfList.map(cfg => {\n        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos\n        if (cfg.linkType === (self.conciliationField && self.conciliationField.conciliacaoCampoMovFinan ? self.conciliationField.conciliacaoCampoMovFinan.tipoVinculo : '')) {\n          mfCfgList.push(cfg)\n        }\n      })\n      return mfCfgList\n    },\n\n    mfAttList () {\n      let attributesCfgMf = []\n      let self = this\n      this.attributesMfList.map(att => {\n        let alreadyUsed = false\n        // Campos de conciliacao so podem ser utilizados uma vez a menos que sejam dinamicos\n        if (self.conciliationFieldList && self.conciliationFieldList.length > 0) {\n          alreadyUsed = self.conciliationFieldList.findIndex(concField => {\n            return (concField.key !== self.conciliationField.key) &&\n              (concField.atributo && concField.atributo.nomeAtributo ? concField.atributo.nomeAtributo.id : null) === att.id &&\n              (concField.conciliacaoCampoMovFinan ? concField.conciliacaoCampoMovFinan.id : null) === (self.conciliationField && self.conciliationField.conciliacaoCampoMovFinan ? self.conciliationField.conciliacaoCampoMovFinan.id : null)\n          }) !== -1\n        }\n        if (!alreadyUsed) {\n          attributesCfgMf.push(att)\n        }\n      })\n      return attributesCfgMf\n    }\n  },\n\n  watch: {\n    conciliationField: {\n      handler (newVal, oldVal) {\n        this.field = {\n          ...newVal,\n          atributo: newVal.atributo\n          ? {\n            atributoCfg: newVal.atributo.atributoCfg ? {...newVal.atributo.atributoCfg} : null,\n            nomeAtributo: newVal.atributo.nomeAtributo ? {...newVal.atributo.nomeAtributo} : null\n          }\n          : null\n        }\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    changeMfField (field) {\n      if (field === null || field instanceof Object) {\n        this.$emit('change-conc-field-mf', { field, concField: this.conciliationField })\n      }\n    },\n\n    changeMbField (field) {\n      if (field === null || field instanceof Object) {\n        this.$emit('change-conc-field-mb', { field, concField: this.conciliationField })\n      }\n    },\n\n    changeMfAttCfg (cfg) {\n      if (cfg === null || cfg instanceof Object) {\n        this.$emit('change-conc-field-cfg-mf', { cfg, concField: this.conciliationField })\n      }\n    },\n\n    updateMfAttList (cfg) {\n      if (cfg === null || cfg instanceof Object) {\n        this.$emit('update-attributes-list', { cfg, concField: this.conciliationField })\n      }\n    },\n\n    changeMfAtt (att) {\n      if (att === null || att instanceof Object) {\n        this.$emit('change-conc-field-att-name-mf', { att, concField: this.conciliationField })\n      }\n    },\n\n    removeField () {\n      this.$emit('remove-field-from-criteria-concil', this.conciliationField)\n    }\n  },\n\n  mounted () {\n    this.field = {\n      ...this.conciliationField,\n      atributo: this.conciliationField.atributo\n      ? {\n        atributoCfg: this.conciliationField.atributo.atributoCfg ? {...this.conciliationField.atributo.atributoCfg} : null,\n        nomeAtributo: this.conciliationField.atributo.nomeAtributo ? {...this.conciliationField.atributo.nomeAtributo} : null\n      }\n      : null\n    }\n    this.updateMfAttList(this.conciliationField.atributo && this.conciliationField.atributo.atributoCfg ? this.conciliationField.atributo.atributoCfg : null)\n  }\n}\n</script>\n\n<style scoped>\n.info-text {\n  color: #1d436a;\n  font-size: 15px;\n}\n\n.info-icon-text {\n  margin-right: 10px;\n  color: #1d436a;\n  font-size: 15px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1068 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4b893cfa","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/conciliationReport/ConciliationReport.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n.check {\n  text-align: center;\n}\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search {\n  width: 53.5%;\n}\n.search-button {\n  min-width: 7vw;\n}\n.checkbox {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.func-group-labels {\n  color: #515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n.status-filter {\n  margin-right: 20px;\n  width: auto;\n}\n", "", {"version":3,"sources":["/./client/components/views/reports/conciliationReport/ConciliationReport.vue?030cd4f4"],"names":[],"mappings":";AAmsBA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,eAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;EACA,YAAA;CACA","file":"ConciliationReport.vue","sourcesContent":["<template src='./conciliationReport.pug' lang='pug'></template>\n\n<script>\nimport GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'\nimport MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport BetterInputTag from '../../../input/betterInputTag/BetterInputTag'\nimport InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\nimport { generateFinMovFromNode, generateBankStatFromNode } from '../../../../utils/transformationData.js'\nimport closeModal from '../../../../events/closeModal'\nimport FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'\n\nexport default {\n  name: 'ConciliationReport',\n\n  components: {\n    GridDetailsModal,\n    MultiSelectModal,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    BetterInputTag,\n    InputEstablishment,\n    ButtonPrimary,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      establishimentsUrls: {\n        establishments: 'conciliationReport/establishment/list',\n        attributes: '/conciliationReport/loadEstablishmentAtt'\n      },\n      selectedEstablishments: [],\n      isExportFile: false,\n      isAdvancedSearch: true,\n      gridId: '#RelatorioConciliacao',\n      treeGridCfg: {},\n      audit: {},\n      dateRange: {},\n      situationList: [\n        {\n          id: 'A',\n          nome: this.$t('statusConciliacao.aberto'),\n          checked: true\n        },\n        {\n          id: 'C',\n          nome: this.$t('statusConciliacao.conciliado'),\n          checked: true\n        },\n        {\n          id: 'M',\n          nome: this.$t('statusConciliacao.conciliadoManualmente'),\n          checked: true\n        },\n        {\n          id: 'D',\n          nome: this.$t('statusConciliacao.divergente'),\n          checked: true\n        },\n        {\n          id: 'N',\n          nome: this.$t('statusConciliacao.naoAplicavel'),\n          checked: true\n        }\n      ],\n      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],\n      firstDate: new Date(),\n      finalDate: new Date(),\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      filter: {\n        entityId: null\n      },\n      result: {},\n      treeGridFileName: 'RelatorioConciliacao',\n      dataTableColumns: [],\n      disableSearchButton: false,\n      firstTimeBank: true,\n      detailsObj: {\n        establishtmentValue: {},\n        mainValuesList: [],\n        monetaryValuesList: [],\n        statusValuesList: [],\n        integrationValuesList: [],\n        classificationValuesList: [],\n        idProcessamento: -1\n      },\n      concReportGridModalId: '',\n      isOpenDetailsModal: false,\n      firstTime: true,\n      titleModal: null,\n      subTitleModal: null,\n      columnsClasses: {},\n      orderBy: {},\n      headings: {},\n      templates: {},\n      customSorting: {},\n      sortable: [],\n      firstTimeAccount: true,\n      modalDetailsTabs: [],\n      filterable: [],\n      attList: [],\n      columnsFilterable: [],\n      customFilters: [],\n      showCustomColumns: false,\n      firstTimeCategorie: true,\n      customSetOrder: null,\n      shown: {\n        bankAccounts: false,\n        categories: false\n      },\n      inputTagsProps: {\n        bankAccounts: {\n          id: 'id',\n          name: 'nome'\n        },\n        categories: {\n          id: 'id',\n          name: 'nome'\n        }\n      },\n      defaultTags: {\n        bankAccounts: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todos')\n        }],\n        categories: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todas')\n        }]\n      },\n      data: {\n        bankAccounts: {\n          titles: {\n            main: this.$t('extratoBancario.labels.contasBancarias'),\n            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')\n          },\n          allBankAccounts: [],\n          showToggleInactiveAccounts: false,\n          selectedItems: [],\n          considerInactiveAccounts: false,\n          columns: ['nome', 'banco', 'numAgencia', 'conta'],\n          values: [],\n          options: {\n            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },\n            perPage: 5,\n            headings: {\n              nome: this.$t('contaBancaria.labels.nome'),\n              banco: this.$t('contaBancaria.labels.banco'),\n              numAgencia: this.$t('contaBancaria.labels.agencia'),\n              conta: this.$t('contaBancaria.labels.numeroConta')\n            },\n            filterable: ['nome', 'banco', 'numAgencia', 'conta'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['nome', 'banco', 'numAgencia', 'conta'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'nome'\n            },\n            customSorting: {\n              nome: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                  }\n                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n                }\n              },\n              banco: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.banco.codigo <= b.banco.codigo ? 1 : -1\n                  }\n                  return a.banco.codigo >= b.banco.codigo ? 1 : -1\n                }\n              },\n              agencia: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.numAgencia <= b.numAgencia\n                  }\n                  return a.numAgencia >= b.numAgencia\n                }\n              },\n              conta: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return +a.conta >= +b.conta ? 1 : -1\n                  }\n                  return +a.conta <= +b.conta ? 1 : -1\n                }\n              }\n            },\n            templates: {\n              nome: (h, row) => {\n                let txt = row.nome\n                if (!row.ativo) {\n                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'\n                }\n                return txt\n              },\n              banco: (h, row) => {\n                if (row.banco) {\n                  return row.banco.codigo + '-' + row.banco.nome\n                }\n                return '-'\n              },\n              agencia: (h, row) => {\n                let txt = '-'\n                if (row.agencia) {\n                  txt = row.numAgencia\n                  if (row.digAgencia) {\n                    txt += '-' + row.digAgencia\n                  }\n                }\n                return txt\n              },\n              conta: (h, row) => {\n                let txt = row.conta\n                if (row.digConta) {\n                  txt += '-' + row.digConta\n                }\n                return txt\n              }\n            }\n          }\n        },\n        categories: {\n          titles: {\n            main: this.$t('categoria.titulos.titulo'),\n            sub: this.$t('categoria.labels.selecionarCategoria')\n          },\n          selectedItems: [],\n          columns: ['numero', 'nome', 'idContabil', 'tipo'],\n          values: [],\n          options: {\n            columnsClasses: { numero: 'col-md-3', nome: 'col-md-4', idContabil: 'col-md-2', tipo: 'col-md-3' },\n            perPage: 5,\n            headings: {\n              numero: this.$t('categoria.modal.labels.numero'),\n              nome: this.$t('categoria.modal.labels.descricao'),\n              idContabil: this.$t('categoria.modal.labels.idContabil'),\n              tipo: this.$t('categoria.modal.labels.tipo')\n            },\n            filterable: ['numero', 'nome', 'idContabil', 'tipo'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['numero', 'nome', 'idContabil', 'tipo'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'numero'\n            },\n            customSorting: {\n              numero: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.ordem >= b.ordem ? 1 : -1\n                  }\n                  return a.ordem <= b.ordem ? 1 : -1\n                }\n              },\n              nome: function (asc) {\n                return function (a, b) {\n                  if (asc) {\n                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                  }\n                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n                }\n              },\n              idContabil: function (asc) {\n                return function (a, b) {\n                  const idA = a.idContabil\n                  const idB = b.idContabil\n                  if (idA === null || idB === null) {\n                    if (asc) {\n                      return idA === null ? -1 : 1\n                    }\n                    return idA === null ? 1 : -1\n                  }\n                  if (asc) {\n                    return a.idContabil.toLowerCase().localeCompare(b.idContabil.toLowerCase())\n                  }\n                  return b.idContabil.toLowerCase().localeCompare(a.idContabil.toLowerCase())\n                }\n              },\n              tipo: function (asc) {\n                return function (a, b) {\n                  if (asc) {\n                    return a.tipo.toLowerCase().localeCompare(b.tipo.toLowerCase())\n                  }\n                  return b.tipo.toLowerCase().localeCompare(a.tipo.toLowerCase())\n                }\n              }\n            },\n            templates: {\n              idContabil: (h, row) => {\n                return row.idContabil || '-'\n              },\n              tipo: (h, row) => {\n                return this.$t(`categoria.modal.labels.${row.tipo}`)\n              }\n            }\n          }\n        }\n      }\n    }\n  },\n\n  watch: {\n    situationList: {\n      handler (val) {\n        this.selectedStatuses = []\n        val.forEach(st => {\n          if (st.checked) {\n            this.selectedStatuses.push(st.id)\n          }\n        })\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    setFilter () {\n      return {\n        inicio: this.dateRange.fromDate,\n        fim: this.dateRange.toDate,\n        idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),\n        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,\n        idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),\n        idsCategorias: this.data.categories.selectedItems.map(selected => selected.id).filter(categories => categories !== '-1'),\n        situacoesConciliacao: this.selectedStatuses,\n        lang: language.getCookieByName('language')\n      }\n    },\n\n    resetFilter () {\n      this.selectedEstablishments = []\n      this.data.bankAccounts.selectedItems = []\n      this.data.bankAccounts.considerInactiveAccounts = false\n      this.data.categories.selectedItems = []\n      this.situationList.forEach(situation => {\n        situation.checked = true\n      })\n      this.selectedStatuses = ['A', 'C', 'M', 'D', 'N']\n    },\n\n    getLoadingMessages () {\n      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']\n    },\n\n    validate () {\n      let self = this\n      let promise = null\n      return new Promise(resolve => {\n        this.$validator.validateAll().then((result) => {\n          if (result && self.$refs.dateRange.validate()) {\n            if (self.isExportFile) {\n              promise = self.download()\n            } else {\n              self.showTreegrid = true\n              startTreeGridLoading(self.gridId, self.getLoadingMessages())\n              promise = self.search()\n            }\n            promise.finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    download () {\n      this.disableSearchButton = true\n      let filter = this.setFilter()\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchConciliationReportToFile', filter).then(() => {\n          this.disableSearchButton = false\n          resolve()\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n          this.disableSearchButton = false\n          reject()\n        })\n      })\n    },\n\n    search () {\n      this.disableSearchButton = true\n      let filter = this.setFilter()\n\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchConciliationReport', filter)\n          .then((response) => {\n            if (window.Grids[0]) {\n              window.DisposeGrids()\n            }\n            this.result = response.data\n            this.treeGridCfg = response.data.Cfg.Layout\n            window.Grids.abrirModalDetalhes = (row) => {\n              trackAnalyticsEvent(this, 'row-click', 'relatorio-conciliacao-grid-details', row.IdConciliacaoLote)\n              if (row.IdExtBancario) {\n                this.concReportGridModalId = 'concReportGridModalIdMov-' + row.IdExtBancario\n                this.$store.dispatch('getBankStatementById', row.IdExtBancario).then((response) => {\n                  this.detailsObj = generateBankStatFromNode(response.data)\n                  this.detailsObj.statusLancamento = response.data.situacaoConciliacao\n                  this.generateModalTabs('MovBan', row.IdContaLancamento)\n                  setTimeout(() => {\n                    this.showDetailsModal()\n                    window.Grids[0].Disable()\n                  }, 100)\n                }).catch((error) => {\n                  if (error.message) {\n                    this.$root.$refs.notification.error(error.message)\n                  } else {\n                    // Validação específica do parse dosq dados\n                    this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')\n                  }\n                })\n              } else {\n                this.concReportGridModalId = 'concReportGridModalIdMov-' + row.IdMovFinanceiro\n                let obj = {\n                  url: '/conciliationReport/getFinancialMovById',\n                  id: row.IdMovFinanceiro\n                }\n\n                this.$store.dispatch('getFinancialMovementById', obj).then((response) => {\n                  this.detailsObj = generateFinMovFromNode(response.data)\n                  this.detailsObj.statusLancamento = response.data.situacaoConciliacao\n                  this.generateModalTabs('MovFin')\n                  setTimeout(() => {\n                    this.showDetailsModal()\n                    window.Grids[0].Disable()\n                  }, 100)\n                }).catch((error) => {\n                  if (error.message) {\n                    this.$root.$refs.notification.error(error.message)\n                  } else {\n                    // Validação específica do parse dos dados\n                    this.$root.$refs.notification.error('modalDetalhesLanc.error.parseError')\n                  }\n                })\n              }\n            }\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            resolve()\n          }).catch((error) => {\n            this.$root.$refs.notification.error(error)\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            reject()\n          })\n      })\n    },\n\n    openSelectBankAccountsModal () {\n      if (this.data.bankAccounts.values.length > 0) {\n        this.shown.bankAccounts = true\n        return\n      }\n      this.$store.dispatch('getBankAccounts', '/conciliationReport/bankAccounts/list')\n        .then(response => {\n          this.data.bankAccounts.allBankAccounts = response.data.data\n          this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {\n            return !bankAccount.ativo\n          })\n          this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {\n            return bankAccount.ativo\n          })\n          this.shown.bankAccounts = true\n        })\n    },\n\n    openSelectCategoriesModal () {\n      if (this.data.categories.values.length > 0) {\n        this.shown.categories = true\n        return\n      }\n      this.$store.dispatch('getCategories', {\n        url: '/conciliationReport/loadCategories',\n        flTipoCategoria: 'A,C,D',\n        validarUso: false\n      })\n        .then((response) => {\n          this.data.categories.values = response.data\n          this.shown.categories = true\n        })\n    },\n\n    showDetailsModal () {\n      this.isOpenDetailsModal = true\n    },\n\n    closeDetailsModal () {\n      this.isOpenDetailsModal = false\n    },\n\n    closeModal () {\n      this.shown.bankAccounts = false\n      this.shown.categories = false\n    },\n\n    generateModalTabs (tipoMovimento, idContaLanc) {\n      let tabs = []\n      // push tab details\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabDetails',\n        idTabContent: 'tab-details-id',\n        idLanc: this.detailsObj.mainValuesList[0].value.toString(),\n        tabRef: 'tadDetailsGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),\n        icon: 'icon=\"tab-icon-font fa fa-info-circle',\n        type: 'TabDetails',\n        props: {\n          establishtmentValue: this.detailsObj.establishtmentValue,\n          mainValuesList: this.detailsObj.mainValuesList,\n          statusValuesList: this.detailsObj.statusValuesList,\n          monetaryValuesList: this.detailsObj.monetaryValuesList,\n          commentary: this.detailsObj.commentary\n        }\n      })\n\n      if (tipoMovimento !== 'MovFin') {\n        // push tab classification\n        tabs.push({\n          idFunctionalitie: null,\n          idTabRoot: 'gridDetailsModal-tabClassification',\n          idTabContent: 'tab-classification-id',\n          idMovimento: this.detailsObj.mainValuesList[0].value,\n          tabRef: 'tabClassificationGridModal',\n          title: this.$t('modalDetalhesLanc.titulos.tabClassif'),\n          icon: 'tab-icon-font fa fa-handshake-o',\n          type: 'TabClassification',\n          props: {\n            mainValuesList: this.detailsObj.classificationValuesList\n          }\n        })\n      }\n\n      if (this.detailsObj.idProcessamento) {\n        // push tab integrations\n        tabs.push({\n          idFunctionalitie: null,\n          idTabRoot: 'gridDetailsModal-tabIntegrations',\n          idTabContent: 'tab-integrations-id',\n          idLanc: this.detailsObj.mainValuesList[0].value.toString(),\n          tabRef: 'tadIntegrationGridModal',\n          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),\n          icon: 'tab-icon-font fa fa-share-alt',\n          type: 'TabIntegrations',\n          props: {\n            loadIntegration: this.findIntegration,\n            establishtmentValue: this.detailsObj.establishtmentValue,\n            idProcessamento: this.detailsObj.idProcessamento,\n            integrationValuesList: this.detailsObj.integrationValuesList\n          }\n        })\n      }\n\n      // push tab historic\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabHistoric',\n        idTabContent: 'tab-historic-id',\n        idLanc: this.detailsObj.mainValuesList[0].value.toString(),\n        tabRef: 'tabHisotiricGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),\n        icon: 'tab-icon-font fa fa-hourglass',\n        type: 'TabHistoric',\n        props: {\n          loadHistoric: this.detailsObj.idMovimentoBancario ? this.findBankStatementHistory : this.findFinancialMovementHistory,\n          idLancamento: this.detailsObj.mainValuesList[0].value.toString()\n        }\n      })\n\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabAllotment',\n        idTabContent: 'tab-allotment-id',\n        idLanc: this.detailsObj.mainValuesList[0].value.toString(),\n        tabRef: 'tadAllotmentGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabLote'),\n        icon: 'tab-icon-font fa fa-cubes',\n        type: 'TabAllotment',\n        props: {\n          getAllotment: tipoMovimento === 'MovFin' ? this.findFinancialMovementAllotment : this.findBankStatAllotment,\n          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),\n          tipoMovimento: tipoMovimento\n        }\n      })\n\n      // push tab tasks\n      tabs.push({\n        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,\n        idTabRoot: 'gridDetailsModal-tabTasks',\n        idTabContent: 'tab-tasks-id',\n        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),\n        tabRef: 'tabTasksGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),\n        icon: 'tab-icon-font fa fa-tasks',\n        type: 'TabTasks',\n        props: {\n          idMovimento: tipoMovimento === 'MovBan' ? idContaLanc.toString() : this.detailsObj.mainValuesList[0].value.toString(),\n          tipoMovimento: tipoMovimento,\n          statusMovimento: this.detailsObj.statusLancamento\n        }\n      })\n      this.modalDetailsTabs = tabs\n    },\n\n    findFinancialMovementHistory (id) {\n      let data = {\n        conciliationReportId: id,\n        url: '/conciliationReport/financialMovementHistoryHistory'\n      }\n      return this.$store.dispatch('getHistoricConciliationReport', data)\n    },\n\n    findBankStatementHistory (id) {\n      let data = {\n        conciliationReportId: id,\n        url: '/conciliationReport/bankStatementHistory'\n      }\n      return this.$store.dispatch('getHistoricConciliationReport', data)\n    },\n\n    findIntegration (id) {\n      let data = {\n        idProcessamento: id,\n        url: '/conciliationReport/getProcessedFilesById'\n      }\n      return this.$store.dispatch('getProcessedFiles', data)\n    },\n\n    findFinancialMovementAllotment (id) {\n      let data = {\n        idFinancialMovement: id,\n        url: '/conciliationReport/getAllotmentByMovFinId'\n      }\n      return this.$store.dispatch('getAllotmentByMovementId', data)\n    },\n\n    findBankStatAllotment (id) {\n      let data = {\n        idFinancialMovement: id,\n        url: '/conciliationReport/getAllotmentByMovBanId'\n      }\n      return this.$store.dispatch('getAllotmentByMovementId', data)\n    }\n  },\n\n  mounted () {\n    // Listener para evento de atualização de dados dentro da modal de detalhes,\n    // o que requer uma nova consulta para o relatório\n    const self = this\n    closeModal.$on('modalDetaisClose', (flag) => {\n      if (flag) {\n        self.showTreegrid = true\n        startTreeGridLoading(self.gridId, self.getLoadingMessages())\n        self.search()\n        // Altera a flag que recarrega a treegrid após o recarregamento\n        // para impedir que ela seja recarregada sempre após a primeira vez\n        closeModal.$emit('taskChange', false)\n      }\n    })\n  }\n}\n</script>\n\n<style>\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.check {\n  text-align: center;\n}\n\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search {\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n\n.checkbox {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.func-group-labels {\n  color: #515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n\n.status-filter {\n  margin-right: 20px;\n  width: auto;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1069 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4dcb5a70","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/categories/TreeviewCategories.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.treeview {\n  font-family: 'Inter', sans-serif;\n}\n.treeview.vue-drag-tree {\n  border-left: solid 1px #cdcdcd;\n  border-right: solid 1px #cdcdcd;\n  border-bottom: solid 1px #cdcdcd;\n}\n.padding-left-children {\n  padding-left: 35px;\n}\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid #DFDFDF;\n}\n.treeRowBg {\n  background: #f3f8fe!important;\n  font-weight: bold;\n  border: none;\n}\n.treeRow .btn-white {\n  color: #1c3b60;\n}\n.treeview.vue-drag-tree > div > .treeview > .treeRow {\n  background: #f6f6f6;\n  color: #414141;\n}\n.item {\n  cursor: pointer;\n}\n.bold {\n  font-weight: bold;\n}\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n.treeMargin {\n  margin-left: 0px;\n}\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n.nodeClicked {\n  -ms-transform: rotate(90deg);\n      transform: rotate(90deg);\n}\n.col-lg-1-5 {\n  width: 12.5%;\n}\n", "", {"version":3,"sources":["/./client/components/registration/categories/TreeviewCategories.vue?edc01a42"],"names":[],"mappings":";AA4SA;EACA,iCAAA;CACA;AAEA;EACA,+BAAA;EACA,gCAAA;EACA,iCAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;EACA,YAAA;CACA;AAEA;EACA,iBAAA;EACA,oBAAA;EACA,iCAAA;CACA;AAEA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,oBAAA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,eAAA;CACA;AAEA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,sCAAA;CACA;AAEA;EACA,6BAAA;MAAA,yBAAA;CACA;AAEA;EACA,aAAA;CACA","file":"TreeviewCategories.vue","sourcesContent":["<script>\nlet id = 1000\nlet fromData = ''\nlet toData = ''\nlet fromParentModelChildren = ''\nlet nodeClicked = null\n\nexport default {\n  name: 'TreeViewCategories',\n\n  props: {\n    model: Object,\n    buttonsTitle: Object,\n    clickFunction: Function,\n    id: String,\n    father: Object,\n    defaultText: String,\n    currentHighlight: Boolean,\n    hoverColor: String,\n    highlightColor: String,\n    spaceLeft: String,\n    styleObj: Object,\n    clickRemoveFunction: {\n      type: Function,\n      default: null\n    },\n    showRemove: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data: function () {\n    return {\n      open: false,\n      isClicked: false\n    }\n  },\n\n  computed: {\n    orderedNumbers () {\n      return this.model.children.sort((a, b) => Number(a.number.replace(/\\./g, '')) - Number(b.number.replace(/\\./g, '')))\n    },\n\n    isFolder () {\n      return this.model.children &&\n        this.model.children.length\n    }\n  },\n\n  template: `<div class=\"treeview\">\n\n              <div :id='model.id' draggable='false' @dragstart='dragStart' @dragover='dragOver' @dragenter='dragEnter' @dragleave='dragLeave' @drop='drop' @dragend='dragEnd' class='col-xs-12 col-sm-12 col-md-12 treeRow pl-0' :class=\"[model.mainFather ? 'treeRowBg' : '']\" @mouseover='mouseOver' @mouseout='mouseOut' :style='styleObj'>\n                <div class=\"pull-left pl-0 text-left\" style=\"padding-top:3px!important\">\n                  <div v-if=\"!model.children\" style=\"min-width:33px;\"></div>\n                  <button style=\"width: 23px; float: left;\" v-if=\"!isClicked && model.children\" :title=\"[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : '']\" @click=\"toggle\" class=\"fa fa-chevron-down px-0 action btn-white\"></button>\n                  <button style=\"width: 23px; float: left;\" v-if=\"isClicked && model.children\" :title=\"[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : '']\" @click=\"toggle\" class=\"fa fa-chevron-up px-0 action btn-white\"></button>\n                </div>\n\n                <div :style='spaceLeft' class=\"col-xs-5 col-sm-7 col-md-6 col-lg-4\" :class=\"[model.mainFather ? 'pl-0' : '']\">\n                  <b>{{model.number}}</b> &nbsp;&nbsp; {{model.description}}\n                </div>\n\n                <div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\" v-html=\"$t('categoria.modal.labels.' + model.type)\"></div>\n\n                <div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right\">{{formatInitialBalance(model.initialBalance)}}</div>\n\n                <div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right\">{{formatInitialBalanceDate(model.initialBalanceDate)}}</div>\n\n                <div class=\"pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-1-5\" style=\"padding-top:3px!important\">\n                  <button v-if='showRemove && !model.children' style=\"width:23px; float:right;\" @click=\"clickRemoveFunction(model.id)\" :title=\"[model.emUso ? (buttonsTitle && buttonsTitle.removeBloq ? buttonsTitle.removeBloq : '') : (buttonsTitle && buttonsTitle.remove ? buttonsTitle.remove : '')]\" class=\"fa fa-times action btn-white pr-0\" :disabled='model.emUso'></button>\n                  <button style=\"width:23px; float:right;\" id=\"buttonEdit\" @click=\"clickAction('buttonEdit')\" :title=\"[buttonsTitle && buttonsTitle.edit ? buttonsTitle.edit : '']\" class=\"fa fa-pencil action pr-0\"></button>\n                  <button style=\"width:23px; float:right;\" id=\"buttonCreate\" @click=\"clickAction('buttonCreate')\" :title=\"[buttonsTitle && buttonsTitle.create ? buttonsTitle.create : '']\" class=\"fa fa-plus action pr-0 mr-0\"></button>\n                </div>\n              </div>\n\n              <div class=\"clear\"></div>\n\n              <div v-show=\"open\" v-if=\"isFolder\">\n                <item v-for=\"model in orderedNumbers\" :spaceLeft='model.marginLeft' :clickFunction='clickFunction' :clickRemoveFunction='clickRemoveFunction' :showRemove='showRemove' :id='model.id' :father=\"model\" :buttonsTitle=\"buttonsTitle\" :model=\"model\" :key='model.id' :currentHighlight='currentHighlight' :defaultText='defaultText' :hoverColor='hoverColor' :highlightColor='highlightColor'>\n                </item>\n              </div>\n            </div>`,\n\n  methods: {\n    clickAction (idButton) {\n      let isEdit = (idButton === 'buttonEdit')\n      this.clickFunction(this.id, this.father, isEdit)\n    },\n\n    toggle () {\n      if (this.isFolder) {\n        this.open = !this.open\n      }\n      let rootTree = this.findRoot()\n\n      this.isClicked = !this.isClicked\n\n      if (this.currentHighlight) {\n        if (nodeClicked !== this.model.id) {\n          let treeParent = rootTree.$parent\n          let nodeStack = [treeParent.$children[0]]\n          while (nodeStack.length !== 0) {\n            let item = nodeStack.shift()\n            item.styleObj.background = 'white'\n            if (item.$children && item.$children.length > 0) {\n              nodeStack = nodeStack.concat(item.$children)\n            }\n          }\n          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF'\n          nodeClicked = this.model.id\n        }\n      }\n    },\n\n    exchangeData (rootCom, from, to) {\n      if (!to || !from || typeof to === 'string' || from.id === to.id) {\n        return\n      }\n\n      from = JSON.parse(JSON.stringify(from))\n      to = JSON.parse(JSON.stringify(to))\n      // copy\n      let treeData = JSON.parse(JSON.stringify(this.model))\n      let nodeStack = [treeData]\n      let status = 0\n\n      try {\n        while (!(status === 2)) {\n          let item = nodeStack.shift()\n          if (item.id === from.id) {\n            item.id = to.id\n            item.name = to.name\n            if (to.children && to.children.length > 0) {\n              item['children'] = to.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.id === to.id) {\n            item.id = from.id\n            item.name = from.name\n            if (from.children && from.children.length > 0) {\n              item['children'] = from.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.children && item.children.length > 0) {\n            nodeStack = nodeStack.concat(item.children)\n          }\n        }\n      } catch (e) {\n        return\n      }\n      rootCom.assignData(treeData)\n    },\n\n    changeType () {\n      if (this.currentHighlight) {\n        nodeClicked = this.model.id\n      }\n      if (!this.isFolder) {\n        this.$set(this.model, 'children', [])\n        this.addChild()\n        this.open = true\n        this.isClicked = true\n      }\n    },\n\n    mouseOver (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2'\n        }\n      }\n    },\n\n    mouseOut (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = 'white'\n        }\n      }\n    },\n\n    findRoot () {\n      let ok = false\n      let that = this\n      while (!ok) {\n        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {\n          ok = true\n          break\n        }\n        that = that.$parent\n      }\n      return that\n    },\n\n    addChild () {\n      this.model.children.push({\n        name: this.defaultText ? this.defaultText : 'New Node',\n        id: id++\n      })\n    },\n\n    removeChild (id) {\n      let parentModelChildren = this.$parent.model.children\n      for (let index in parentModelChildren) {\n        if (parentModelChildren[index].id === id) {\n          parentModelChildren = parentModelChildren.splice(index, 1)\n          break\n        }\n      }\n    },\n\n    dragStart (e) {\n      e.dataTransfer.effectAllowed = 'move'\n      e.dataTransfer.setData('nottext', e.target.innerHTML)\n      return true\n    },\n\n    dragEnd (e) {\n      fromData = undefined\n      toData = undefined\n      fromParentModelChildren = undefined\n    },\n\n    dragOver (e) {\n      e.preventDefault()\n      return true\n    },\n\n    dragOverPlus (e) {\n      e.preventDefault()\n    },\n\n    dragEnterPlus (e) {\n    },\n\n    dragEnter (e) {\n      toData = this.model\n      let rootTree = this.findRoot()\n      rootTree.exchangeData(rootTree.$parent, fromData, toData)\n    },\n\n    dragLeave (e) {\n      fromData = this.model\n      fromParentModelChildren = this.$parent.model.children\n      // e.target.style.background = '#7B1FA2'\n    },\n\n    drop (e) {\n      // toData = this.model\n      // e.target.style.background = '#7B1FA2'\n    },\n\n    dropPlus (e) {\n      if (this.model.hasOwnProperty('children')) {\n        this.model.children.push(fromData)\n      } else {\n        this.model.children = [fromData]\n      }\n      for (let i in fromParentModelChildren) {\n        if (fromParentModelChildren[i].id === fromData.id) {\n          fromParentModelChildren.splice(i, 1)\n        }\n      }\n    },\n\n    formatInitialBalanceDate (timestamp) {\n      if (timestamp === null) {\n        return timestamp\n      }\n      const date = new Date(timestamp)\n      const day = String(date.getDate()).padStart(2, '0')\n      const month = String(date.getMonth() + 1).padStart(2, '0')\n      const year = date.getFullYear()\n      return `${day}/${month}/${year}`\n    },\n\n    formatInitialBalance (value) {\n      if (value === null) {\n        return value\n      }\n      return value % 1 !== 0 ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : `${value.toLocaleString('pt-BR')},00`\n    }\n  },\n\n  beforeCreate () {\n    this.$options.components.item = require('./TreeviewCategories')\n  }\n}\n</script>\n\n<style>\n.treeview {\n  font-family: 'Inter', sans-serif;\n}\n\n.treeview.vue-drag-tree {\n  border-left: solid 1px #cdcdcd;\n  border-right: solid 1px #cdcdcd;\n  border-bottom: solid 1px #cdcdcd;\n}\n\n.padding-left-children {\n  padding-left: 35px;\n}\n\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid #DFDFDF;\n}\n\n.treeRowBg {\n  background: #f3f8fe!important;\n  font-weight: bold;\n  border: none;\n}\n\n.treeRow .btn-white {\n  color: #1c3b60;\n}\n\n.treeview.vue-drag-tree > div > .treeview > .treeRow {\n  background: #f6f6f6;\n  color: #414141;\n}\n\n.item {\n  cursor: pointer;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n\n.treeMargin {\n  margin-left: 0px;\n}\n\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n\n.nodeClicked {\n  transform: rotate(90deg);\n}\n\n.col-lg-1-5 {\n  width: 12.5%;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1070 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-52cce311","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/modals/JustifyModal.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.centered-radio {\n  margin: 0;\n  height: 20px;\n}\n.centered-radio label {\n  margin: 0;\n  margin-right: -10px;\n  margin-top: 2px;\n}\n.divergence-value-modal {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  color: red;\n}\n.conciliated-value-modal {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  color: green;\n}\ni.icon-margin-left {\n  margin-left: 10px;\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/./client/components/reports/manualConciliation/modals/JustifyModal.vue?7217da79"],"names":[],"mappings":";AA+MA;EACA,UAAA;EACA,aAAA;CACA;AAEA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;CACA;AAEA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;CACA;AAEA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,aAAA;CACA;AAEA;EACA,kBAAA;EACA,gBAAA;CACA","file":"JustifyModal.vue","sourcesContent":["<template src=\"./justifyModal.pug\" lang=\"pug\"></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport { Money } from 'v-money'\nimport Modal from '../../../modals/modal/Modal'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport { maskThousand } from '../../../../utils/numberMasker.js'\n\nexport default {\n  name: 'JustifyModal',\n\n  components: {\n    vSelect,\n    Money,\n    Modal,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      disableButton: false,\n      isLoadingData: true,\n      selectedOccurrenceReason: false,\n      occurrenceReasons: [],\n      commentary: null,\n      valueJustify: '',\n      money: {\n        decimal: ',',\n        thousands: '.',\n        prefix: '',\n        suffix: '',\n        precision: 2,\n        masked: false\n      },\n      divergenceValue: '',\n      notJustifiedValue: '',\n      isTotal: false\n    }\n  },\n\n  computed: {\n    arrayJustify () {\n      return this.$store.getters.arrayJustify\n    },\n\n    itsAbleToJustify () {\n      return this.selectedOccurrenceReason && !this.disableButton\n    },\n\n    allotmentId () {\n      return this.$store.getters.idAllotment\n    },\n\n    totalAmountForInternalEntries () {\n      return this.$store.getters.totalAmountForInternalEntries\n    },\n\n    totalAmountForBankEntries () {\n      return this.$store.getters.totalAmountForBankEntries\n    },\n\n    totalDivergence () {\n      return (this.totalAmountForBankEntries - this.totalAmountForInternalEntries) - this.totalAmountToJustify\n    },\n\n    totalAmountToJustify () {\n      return this.calculateTotalToJustify()\n    },\n\n    finMovAdded () {\n      return this.$store.getters.finMovAdded\n    },\n\n    bankStatAdded () {\n      return this.$store.getters.bankStatAdded\n    },\n\n    arrayConciliationPlan () {\n      return this.$store.getters.arrayConciliationPlan\n    },\n\n    totalDivergenceTransformed () {\n      return maskThousand(Number(this.totalDivergence).toFixed(2))\n    },\n\n    totalNotJustified () {\n      let value = this.valueJustify - this.totalDivergence\n      return maskThousand(value)\n    },\n\n    divergentInstance () {\n      return Number(this.totalDivergence).toFixed(2) !== '0.00'\n    },\n\n    hasPendingFinMov () {\n      return this.$store.getters.hasPendingFinMov\n    },\n\n    hasPendingBankStat () {\n      return this.$store.getters.hasPendingBankStat\n    }\n  },\n\n  watch: {\n    totalNotJustified () {\n      this.setStyleValue()\n    },\n\n    isTotal () {\n      if (this.isTotal) {\n        this.valueJustify = this.totalDivergence\n      }\n    },\n\n    arrayJustify () {\n      this.valueJustify = 0.00\n    },\n\n    totalDivergence () {\n      if (this.finMovAdded.length === 0 || this.bankStatAdded.length === 0) {\n        this.valueJustify = this.totalDivergence\n      } else {\n        this.isTotal = false\n        this.valueJustify = 0.00\n      }\n    }\n  },\n\n  methods: {\n    calculateTotalToJustify () {\n      let value = 0.00\n      this.arrayJustify.forEach(justify => {\n        value += justify.valor\n      })\n      return value\n    },\n\n    setStyleValue () {\n      if (this.totalNotJustified === '0,00' || this.totalNotJustified === 0.00) {\n        document.getElementById('labelTotalNotJustified').style.color = 'green'\n      } else {\n        document.getElementById('labelTotalNotJustified').style.color = 'red'\n      }\n    },\n\n    getValueClass (value) {\n      return value !== 0 ? 'divergence-value-modal' : 'conciliated-value-modal'\n    },\n\n    confirmJustifyAllotment () {\n      let data = {\n        id: this.arrayJustify.length + 1,\n        valor: this.valueJustify,\n        idMotivoOcorrencia: this.selectedOccurrenceReason ? this.selectedOccurrenceReason.id : null,\n        motivoOcorrencia: this.selectedOccurrenceReason && this.selectedOccurrenceReason.label ? this.selectedOccurrenceReason.label : null,\n        comentario: this.commentary\n      }\n      this.$store.dispatch('setJustify', data)\n        .then(() => {\n          this.closeModal()\n        }).catch(() => {\n          this.closeModal()\n          this.$root.$refs.notification.global('E', 'ERRO')\n        })\n    },\n\n    closeModal () {\n      $('#justifyModal').modal('hide')\n      this.selectedOccurrenceReason = null\n      this.commentary = null\n      this.$nextTick(() => {\n        this.$validator.reset()\n      })\n    },\n\n    loadOccurrenceReasons () {\n      let url = '/manualConciliation/occurrenceReasons/list'\n      this.$store.dispatch('getOccurrenceReasons', url).then((response) => {\n        this.occurrenceReasons = response.data.data\n        this.isLoadingData = false\n        this.occurrenceReasons.forEach(occurrenceReason => {\n          occurrenceReason.label = occurrenceReason.codigo + ' - ' + occurrenceReason.descricao\n        })\n        this.occurrenceReasons.sort((a, b) => {\n          return a.codigo - b.codigo\n        })\n      })\n    },\n\n    generateArrayWithIds (list) {\n      let result = []\n      list.forEach(item => {\n        result.push(item.idMovimentacao ? item.idMovimentacao\n          : item.idMovBank ? item.idMovBank : item.id)\n      })\n      return result\n    }\n  },\n\n  created () {\n    this.loadOccurrenceReasons()\n  }\n}\n</script>\n\n<style>\n.centered-radio {\n  margin: 0;\n  height: 20px;\n}\n\n.centered-radio label {\n  margin: 0;\n  margin-right: -10px;\n  margin-top: 2px;\n}\n\n.divergence-value-modal {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  color: red;\n}\n\n.conciliated-value-modal {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  color: green;\n}\n\ni.icon-margin-left {\n  margin-left: 10px;\n  cursor: pointer;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1071 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-58825cfb","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/conciliationSummary/CalendarSummary.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports
exports.i(__webpack_require__(/*! -!../../../../~/css-loader?sourceMap!dayspan-vuetify/dist/lib/dayspan-vuetify.min.css */ 1027), "");

// module
exports.push([module.i, "\n.ds-month .ds-week-header {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  height: 4vh;\n}\n.ds-day {\r\n  -ms-flex: 1;\r\n      flex: 1;\r\n  width: 0;\r\n  border-right: 1px solid #e0e0e0;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  padding: 4px;\r\n  overflow: hidden;\r\n  height: 10vh;\n}\n.ds-gesture-container {\r\n    width: 100%;\r\n    height: 100%;\n}\n.ds-expand {\r\n    width: 100%;\r\n    height: 100%;\n}\n.ds-calendar {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    position: relative !important;\r\n    padding: 0!important;\n}\n.ds-month-view {\r\n    width: 100% !important;\r\n    height: 100% !important;\n}\n.ds-month .ds-week-header {\r\n    display: -ms-flexbox !important;\r\n    display: flex !important;\r\n    -webkit-user-select: none !important;\r\n    -ms-user-select: none !important;\r\n    user-select: none !important;\n}\n.ds-week {\r\n    display: -ms-flexbox !important;\r\n    display: flex !important;\r\n    -ms-flex: 1 !important;\r\n    flex: 1 !important;\n}\n.ds-out-calendar {\r\n    color: #757575 !important;\n}\n.ds-day {\r\n    -webkit-user-select: none !important;\r\n    -ms-user-select: none !important;\r\n    user-select: none !important;\n}\n.ds-day {\r\n    -ms-flex: 1 !important;\r\n    flex: 1 !important;\r\n    width: 0 !important;\r\n    border-right: 1px solid #e0e0e0 !important;\r\n    border-bottom: 1px solid #e0e0e0 !important;\r\n    padding: 4px !important;\r\n    overflow: hidden !important;\n}\n.margin-box-15 {\r\n  margin: 15px 15px 15px 0px;\n}\r\n", "", {"version":3,"sources":["/./client/components/reports/conciliationSummary/CalendarSummary.vue?5a0c2b14"],"names":[],"mappings":";AAoKA;EACA,qBAAA;EACA,cAAA;EACA,0BAAA;EAEA,sBAAA;EACA,kBAAA;EACA,YAAA;CACA;AACA;EACA,YAAA;MAAA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iCAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;CACA;AAEA;IACA,YAAA;IACA,aAAA;CACA;AAEA;IACA,YAAA;IACA,aAAA;CACA;AAEA;IACA,uBAAA;IACA,wBAAA;IACA,8BAAA;IACA,qBAAA;CACA;AAEA;IACA,uBAAA;IACA,wBAAA;CACA;AAEA;IACA,gCAAA;IACA,yBAAA;IACA,qCAAA;IAEA,iCAAA;IACA,6BAAA;CACA;AAEA;IACA,gCAAA;IACA,yBAAA;IACA,uBAAA;IACA,mBAAA;CACA;AAEA;IACA,0BAAA;CACA;AACA;IACA,qCAAA;IAEA,iCAAA;IACA,6BAAA;CACA;AAEA;IACA,uBAAA;IACA,mBAAA;IACA,oBAAA;IACA,2CAAA;IACA,4CAAA;IACA,wBAAA;IACA,4BAAA;CACA;AACA;EACA,2BAAA;CACA","file":"CalendarSummary.vue","sourcesContent":["<template src='./calendarSummary.pug' lang='pug'></template>\r\n\r\n<script>\r\nimport Vue from 'vue'\r\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\r\nimport language from '../../../../build/language/index'\r\nimport DaySpanVuetify from 'dayspan-vuetify'\r\nimport CalendarDetailBox from './CalendarDetailBox'\r\nimport CalendarView from '../../calendarView/CalendarView'\r\nimport moment from 'moment'\r\nimport Datepicker from 'vuejs-datepicker'\r\nimport customSorter from '../../../utils/customSorter.js'\r\n\r\nVue.use(DaySpanVuetify)\r\n\r\nexport default {\r\n  name: 'CalendarSummary',\r\n\r\n  components: {\r\n    ButtonPrimary,\r\n    CalendarDetailBox,\r\n    Datepicker,\r\n    CalendarView\r\n  },\r\n\r\n  props: {\r\n  },\r\n\r\n  computed: {\r\n    monthPickerLanguage () {\r\n      return this.language.getDatePickerLanguageObject()\r\n    },\r\n    isLoadingData () {\r\n      return this.isLoadingDataConcil || this.isLoadingCategories\r\n    }\r\n  },\r\n\r\n  data () {\r\n    return {\r\n      isLoadingDataConcil: false,\r\n      isLoadingCategories: false,\r\n      language: language,\r\n      selectedStartDate: new Date(),\r\n      selectedEndDate: new Date(),\r\n      selectedMonth: new Date(),\r\n      conciliacaoData: [],\r\n      categories: [],\r\n      selectedCategory: {\r\n        id: '-1',\r\n        numero: '-1',\r\n        nome: this.$t('inputTag.labels.todas')\r\n      },\r\n      categoryAll: {\r\n        id: '-1',\r\n        numero: '-1',\r\n        nome: this.$t('inputTag.labels.todas')\r\n      }\r\n    }\r\n  },\r\n\r\n  methods: {\r\n    validateClick (event) {\r\n      if (event) {\r\n        // event.day.date.toDate() get clicked day\r\n        event.handled = true\r\n        event.stopPropagation = true\r\n      }\r\n      return null\r\n    },\r\n    searchConciliationSummary () {\r\n      if (this.selectedMonth) {\r\n        let filter = {\r\n          inicio: moment.utc(this.selectedMonth).startOf('month').startOf('day').valueOf(),\r\n          fim: moment.utc(this.selectedMonth).endOf('month').endOf('day').valueOf(),\r\n          idsContas: [],\r\n          considerarContasInativas: false,\r\n          idsEstabelecimentos: [],\r\n          tipoMovimetacao: 'M',\r\n          idsCategorias: [],\r\n          idsPlanosConciliacao: [],\r\n          situacoesConciliacao: ['A', 'C', 'M', 'D', 'N'],\r\n          lang: 'pt'\r\n        }\r\n        this.isLoadingDataConcil = true\r\n        let self = this\r\n        return new Promise((resolve, reject) => {\r\n          self.$store.dispatch('searchConciliationSummary', filter)\r\n            .then((response) => {\r\n              setTimeout(() => {\r\n                self.handleResult(response.data.Body[0])\r\n                self.isLoadingDataConcil = false\r\n              }, 1000)\r\n              resolve()\r\n            }).catch((error) => {\r\n              self.isLoadingDataConcil = false\r\n              self.error = true\r\n              self.msgError = error.body\r\n              self.$root.$refs.notification.error('GENERAL')\r\n              reject()\r\n            })\r\n        })\r\n      }\r\n    },\r\n    handleResult (result) {\r\n      let resumeList = []\r\n      result.map(item => {\r\n        resumeList.push({\r\n          situacao: item.FlagSituacaoConciliacao,\r\n          categoria: item.NomeCategoria,\r\n          estabelecimento: item.Estabelecimento ? item.Estabelecimento : 'N/A',\r\n          conta: item.Banco ? '(' + item.Banco + ') ' + item.Agencia + '/' + item.NrConta : this.$t('calendarioConciliacao.detalhe.movFinan'),\r\n          totalExtrato: item.ValorExtratoBancario,\r\n          totalMovFinan: item.ValorMovimentoFinanceiro,\r\n          dataMin: moment.utc(item.DataMinimaLancamento).startOf('day').toDate(),\r\n          dataMax: moment.utc(item.DataMaximaLancamento).endOf('day').toDate()\r\n        })\r\n      })\r\n      this.conciliacaoData = resumeList\r\n    },\r\n    handleMonthChange (newDate) {\r\n      this.selectedMonth = newDate\r\n      this.searchConciliationSummary()\r\n    },\r\n    setStartDate (newStartDate) {\r\n      this.selectedStartDate = moment.utc(newStartDate).toDate()\r\n      this.selectedEndDate = moment.utc(newStartDate).toDate()\r\n    },\r\n    setEndDate (newEndDate) {\r\n      this.selectedEndDate = moment.utc(newEndDate).toDate()\r\n    },\r\n    loadCategories () {\r\n      this.isLoadingCategories = true\r\n      this.$store.dispatch('getCategories', {\r\n        url: '/categories/',\r\n        flTipoCategoria: null,\r\n        validarUso: false\r\n      }).then((response) => {\r\n        let catArray = []\r\n        response.data.forEach(cat => {\r\n          cat.label = cat.numero + ' - ' + cat.nome\r\n          catArray.push(cat)\r\n        })\r\n        catArray.push(this.categoryAll)\r\n        // arrayDottedSorter ordena o array baseado em valores do tipo '1.1.1'\r\n        this.categories = customSorter.arrayDottedSorter(catArray, 'numero', 'asc')\r\n        this.isLoadingCategories = false\r\n      }).catch((error) => {\r\n        this.$root.$refs.notification.error(error.data.message)\r\n        this.isLoadingCategories = false\r\n      })\r\n    },\r\n    setCategory (category) {\r\n      this.selectedCategory = category && category.id ? category : this.categoryAll\r\n    }\r\n  },\r\n\r\n  mounted () {\r\n    this.loadCategories()\r\n  }\r\n}\r\n</script>\r\n<style>\r\n@import '~dayspan-vuetify/dist/lib/dayspan-vuetify.min.css';\r\n\r\n.ds-month .ds-week-header {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  height: 4vh;\r\n}\r\n.ds-day {\r\n  flex: 1;\r\n  width: 0;\r\n  border-right: 1px solid #e0e0e0;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  padding: 4px;\r\n  overflow: hidden;\r\n  height: 10vh;\r\n}\r\n\r\n.ds-gesture-container {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.ds-expand {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.ds-calendar {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    position: relative !important;\r\n    padding: 0!important;\r\n}\r\n\r\n.ds-month-view {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.ds-month .ds-week-header {\r\n    display: -ms-flexbox !important;\r\n    display: flex !important;\r\n    -webkit-user-select: none !important;\r\n    -moz-user-select: none !important;\r\n    -ms-user-select: none !important;\r\n    user-select: none !important;\r\n}\r\n\r\n.ds-week {\r\n    display: -ms-flexbox !important;\r\n    display: flex !important;\r\n    -ms-flex: 1 !important;\r\n    flex: 1 !important;\r\n}\r\n\r\n.ds-out-calendar {\r\n    color: #757575 !important;\r\n}\r\n.ds-day {\r\n    -webkit-user-select: none !important;\r\n    -moz-user-select: none !important;\r\n    -ms-user-select: none !important;\r\n    user-select: none !important;\r\n}\r\n\r\n.ds-day {\r\n    -ms-flex: 1 !important;\r\n    flex: 1 !important;\r\n    width: 0 !important;\r\n    border-right: 1px solid #e0e0e0 !important;\r\n    border-bottom: 1px solid #e0e0e0 !important;\r\n    padding: 4px !important;\r\n    overflow: hidden !important;\r\n}\r\n.margin-box-15 {\r\n  margin: 15px 15px 15px 0px;\r\n}\r\n</style>"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1072 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-5cb3e11e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/login/Login.vue ***!
  \******************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*Tela de login*/\n.recaptcha-form[data-v-5cb3e11e] {\n  margin: 0 auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.bg-tela-login[data-v-5cb3e11e]:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n.bg-tela-login[data-v-5cb3e11e]:after {\n  bottom: 0;\n}\n.bg-tela-login[data-v-5cb3e11e] {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: linear-gradient(to right, #223768, #00C3BE);\n  height: auto !important;\n  min-height: 100vh;\n}\n.inicial-wrap[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  max-width: 650px;\n  margin: 20px auto;\n  transition: transform 300ms ease-in-out;\n}\n.inicial-bodies[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  text-align: center;\n  position: relative;\n  perspective: 1000px;\n}\nbutton.button[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(174, 223, 120, 1);\n  font-size: 20px;\n  cursor: pointer;\n  margin-top: 60px !important;\n  color: rgba(28, 59, 101, 1);\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\nbutton.button[data-v-5cb3e11e]:hover {\n  background-color: rgba(174, 223, 120, 1);\n  color: rgba(28, 59, 101, 1);\n  border: none;\n}\n.button i[data-v-5cb3e11e] {\n  font-weight: normal;\n  font-size: 24px;\n  margin-right: 5px;\n}\n\n/*Tela de boas vindas*/\n.boas-vindas-tit[data-v-5cb3e11e] {\n  text-align: center;\n  font-size: 50px;\n  color: rgba(122, 203, 231, 1);\n}\n.boas-vindas-txt[data-v-5cb3e11e] {\n  text-align: center;\n  padding: 50px 145px 50px 145px;\n  font-size: 25px;\n  color: rgba(255, 255, 255, 1);\n}\n.boas-vindas-txt-bottom[data-v-5cb3e11e] {\n  font-weight: bold;\n  font-size: 20px;\n  text-transform: uppercase;\n  color: rgba(122, 203, 231, 1);\n}\n@media screen and (min-width: 992px) {\n.inicial-body[data-v-5cb3e11e] {\n    background: #005E78;\n    padding: 40px 0px 0px 0px;\n    margin-bottom: 20px;\n    display: none;\n    box-sizing: border-box;\n    width: 100%;\n}\n.inicial-body2[data-v-5cb3e11e] {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 76px;\n    display: none;\n    width: 100%;\n}\n.inicial-body3[data-v-5cb3e11e] {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 20px;\n    display: none;\n    width: 100%;\n}\n.formulario-login[data-v-5cb3e11e] {\n    padding: 80px 125px 50px 125px;\n    box-sizing: border-box;\n    width: 100%;\n}\n}\n@media screen and (max-width: 991px) {\n.inicial-body[data-v-5cb3e11e] {\n    background: #005E78;\n    padding: 40px 0px 0px 0px;\n    margin-bottom: 20px;\n    display: none;\n    box-sizing: border-box;\n    width: 100%;\n}\n.inicial-body2[data-v-5cb3e11e] {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 74px;\n    display: none;\n    width: 100%;\n}\n.inicial-body3[data-v-5cb3e11e] {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 20px;\n    display: none;\n    width: 100%;\n}\n.formulario-login[data-v-5cb3e11e] {\n    padding: 80px 50px 50px 50px;\n    box-sizing: border-box;\n    width: 100%;\n}\n}\n.formulario-login-topo[data-v-5cb3e11e] {\n  height: 115px;\n  background-color: #FFF;\n}\n.formulario-login-topo-logo[data-v-5cb3e11e] {\n  z-index:1;\n  position: absolute;\n  width:100%;\n  max-width: 100%;\n  text-align: left;\n  padding: 22px 0px;\n}\nimg.logo-img[data-v-5cb3e11e] {\n  max-height:60px;\n  margin-top:8px;\n  padding-left:20px;\n}\np.logo-txt[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #1c3b65;\n  font-size: 30px;\n  text-transform: capitalize;\n}\nbutton.btn-idioma[data-v-5cb3e11e] {\n  background: #fff;\n  float: right;\n  height: 100%;\n  padding: 2%;\n  border: none;\n}\nbutton.btn-idioma[data-v-5cb3e11e]:hover {\n  background: transparent;\n  border: none;\n}\nbutton.btn-idioma[data-v-5cb3e11e]:active {\n  box-shadow: none;\n}\n.escolhaIdiomas[data-v-5cb3e11e] {\n  background: rgba(133, 186, 202, 1);\n  /* For browsers that do not support gradients */\n  /* For Safari 5.1 to 6.0 */\n  /* For Opera 11.1 to 12.0 */\n  /* For Firefox 3.6 to 15 */\n  background: linear-gradient(to right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* Standard syntax */\n  height: 50px;\n  z-index: 2;\n}\n.escolhaIdiomas p[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  color: rgba(28, 59, 101, 1);\n  padding: 15px;\n  font-weight: bold;\n  vertical-align: middle;\n}\nbutton.btn-escolher-idioma[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  border: none;\n  font-size: 15px;\n  background-color: transparent;\n  padding: 14px 10px 15px 10px;\n  color: rgba(255, 255, 255, 1);\n}\nbutton.btn-escolher-idioma.btn-ativo[data-v-5cb3e11e] {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\nbutton.btn-escolher-idioma[data-v-5cb3e11e]:hover {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\nbutton.btn-fechar-escolher-idioma[data-v-5cb3e11e] {\n  background-color: transparent;\n  padding: 0px;\n  margin: 0px 6px 0px 25px!important;\n  border: none;\n}\nbutton.btn-fechar-escolher-idioma[data-v-5cb3e11e]:hover {\n  background-color: transparent;\n  border: none;\n}\nbutton.btn-fechar-escolher-idioma[data-v-5cb3e11e]:active {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\nbutton.btn-esqueceu-senha[data-v-5cb3e11e] {\n  background-color: transparent;\n  border: none;\n  z-index: 2;\n  position: absolute;\n  height: 60px;\n  width: 60px;\n  right: 0;\n  text-align: center;\n  padding: 0px;\n}\nbutton.btn-esqueceu-senha[data-v-5cb3e11e]:hover {\n  background-color: transparent;\n  border: none;\n}\nbutton.btn-esqueceu-senha[data-v-5cb3e11e]:active {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\n.logo-equals[data-v-5cb3e11e] {\n  height: 100%;\n  padding: 2%;\n}\n.text-white[data-v-5cb3e11e] {\n  color: #fff;\n}\ninput[data-v-5cb3e11e]:-webkit-autofill,\ninput[data-v-5cb3e11e]:-webkit-autofill:hover,\ninput[data-v-5cb3e11e]:-webkit-autofill:focus,\ninput[data-v-5cb3e11e]:-webkit-autofill:active {\n  animation: autofill 0s forwards;\n  -webkit-text-fill-color: #fff !important;\n}\n@keyframes autofill {\n100% {\n    background: rgba(255, 255, 255, 0.15);\n    color: inherit;\n}\n}\n.formulario-login input[data-v-5cb3e11e] {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-radius: 0px!important;\n  border: none;\n  border-bottom: 2px solid rgba(255, 255, 255, 1);\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n  height: 60px;\n}\n.formulario-login input[data-v-5cb3e11e]:focus {\n  box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;\n}\n.formulario-login input[data-v-5cb3e11e]::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\n.formulario-login input[data-v-5cb3e11e]:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n.formulario-login input[data-v-5cb3e11e]::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n  opacity: 0.4;\n}\n.formulario-login input[data-v-5cb3e11e]:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\nbutton.button-login[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(28, 59, 101, 1);\n  bottom: 0;\n  font-size: 20px;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 1);\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\nbutton.button-login[data-v-5cb3e11e]:hover {\n  background-color: rgba(64, 185, 187, 1);\n  color: rgba(255, 255, 255, 1);\n  border: none;\n}\nbutton.button-login[data-v-5cb3e11e]:active {\n  background-color: rgba(28, 59, 101, 1);\n  color: rgba(255, 255, 255, 1);\n  border: none;\n}\nbutton.button-login[data-v-5cb3e11e]:disabled {\n  background-color: rgba(28, 59, 101, 1);\n  cursor: progress;\n  color: #FFF;\n  border: none;\n}\n\n/*Captcha*/\n.captcha[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  background-color: #FFF;\n  padding: 20px 10px;\n}\n.captcha p[data-v-5cb3e11e] {\n  width: 100%;\n  font-size: 15px;\n  margin-top: 10px;\n}\n#mainCaptcha[data-v-5cb3e11e] {\n  width: 90%;\n  background-color: transparent;\n  color: black;\n  text-align: center;\n  padding: 0px;\n}\n.text-center[data-v-5cb3e11e] {\n  text-align: center;\n}\nbutton.btn-refresh-catpcha[data-v-5cb3e11e] {\n  width: 10%;\n  background-color: transparent;\n  padding: 0px;\n  border: none;\n}\nbutton.btn-refresh-catpcha[data-v-5cb3e11e]:hover {\n  background-color: transparent;\n  border: none;\n}\nbutton.btn-refresh-catpcha[data-v-5cb3e11e]:active {\n  background-color: transparent;\n  border: none;\n}\ninput.captcha-recuperar-senha[data-v-5cb3e11e] {\n  padding: 8px;\n  width: 100%;\n  /* background-color: rgba(95, 169, 192, 1); */\n  border-radius: 0px!important;\n  border: none;\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n}\n.g-recaptcha[data-v-5cb3e11e] {\n  display: inline-block;\n}\ninput.captcha-recuperar-senha[data-v-5cb3e11e]::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\ninput.captcha-recuperar-senha[data-v-5cb3e11e]:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\ninput.captcha-recuperar-senha[data-v-5cb3e11e]::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n}\ninput.captcha-recuperar-senha[data-v-5cb3e11e]:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\nbutton.button2[data-v-5cb3e11e] {\n  margin-top: 20px!important;\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  padding: 0px;\n}\nbutton.button2[data-v-5cb3e11e]:hover {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n}\nbutton.button2[data-v-5cb3e11e]:active {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\nbutton.button2 span[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  margin-left: 8px;\n  font-weight: bold;\n}\n\n/*Tela logado*/\n.logado[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(147, 191, 98, 1);\n  color: rgba(255, 255, 255, 1);\n}\n.logado-ok[data-v-5cb3e11e] {\n  font-size: 50px;\n  margin: 30px 0px 10px 0px;\n}\n.bem-vindo[data-v-5cb3e11e] {\n  font-size: 20px;\n  text-transform: uppercase;\n}\n.img-bottom[data-v-5cb3e11e] {\n\n  height: 90px;\n  /*max-width: 650px;*/\n  vertical-align: middle;\n  margin-bottom: 30px;\n  /*position: absolute;*/\n}\n\n/*Login com erro*/\n.erro-login[data-v-5cb3e11e] {\n  color: rgba(106, 34, 35, 1);\n  margin-top: 5px;\n  font-size: 14px;\n  font-style: italic;\n}\n.inicial-body.is-showing[data-v-5cb3e11e] {\n  display: block;\n}\n.inicial-body2.is-showing[data-v-5cb3e11e] {\n  display: block;\n}\n.inicial-body3.is-showing[data-v-5cb3e11e] {\n  display: block;\n}\n.animate-out[data-v-5cb3e11e] {\n  animation: out 600ms ease-in-out;\n}\n.animate-in[data-v-5cb3e11e] {\n  animation: in 400ms ease-in-out;\n  display: block;\n}\n.animate-up[data-v-5cb3e11e] {\n  transform: rotateY(0deg);\n}\n.form-control[data-v-5cb3e11e] {\n  font-family: 'Inter', sans-serif;\n}\nhtml[data-v-5cb3e11e],\nbody[data-v-5cb3e11e] {\n  height: 100%;\n}\nbody[data-v-5cb3e11e] {\n  overflow: auto;\n}\n.vertical-center[data-v-5cb3e11e] {\n\n  /* Make it a flex container */\n  display: -ms-flexbox;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.jumbotron.vertical-center[data-v-5cb3e11e] {\n  margin-bottom: 0;\n}\n#loginInputLog[data-v-5cb3e11e], #loginInputRec[data-v-5cb3e11e] {\n  padding-left: 50px;\n}\n#loginSenha[data-v-5cb3e11e] {\n  padding-left: 50px;\n}\n.inicial-wrap.px-0.img-bottom div[data-v-5cb3e11e] {\n  padding-bottom: 15px;\n}\n.formulario-login .form-group>img[data-v-5cb3e11e] {\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  left: 0;\n  text-align: center;\n  padding: 15px;\n}\n.recuperarSenha[data-v-5cb3e11e] {\n  padding: 10px 0px;\n  color: #FFF;\n}\n.recuperarSenha a[data-v-5cb3e11e] {\n  color: #FFF;\n}\n.recuperarSenha a[data-v-5cb3e11e]:hover {\n  text-decoration: underline;\n}\n@keyframes out {\n0% {\n    opacity: 1;\n    transform: rotateY(0deg);\n}\n100% {\n    opacity: 0;\n    transform: rotateY(-90deg);\n}\n}\n@keyframes in {\n0% {\n    opacity: 0;\n    transform: rotateY(90deg);\n}\n100% {\n    opacity: 1;\n    transform: rotateY(0deg);\n}\n}\n", "", {"version":3,"sources":["/./client/components/views/login/Login.vue?6f85a392"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA6VA,iBAAA;AAEA;EACA,eAAA;EACA,qBAAA;EAAA,cAAA;EACA,sBAAA;MAAA,wBAAA;CACA;AAEA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oBAAA;EAIA,wDAAA;EACA,wBAAA;EACA,kBAAA;CACA;AAEA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EAGA,wCAAA;CAEA;AAEA;EACA,iCAAA;EACA,mBAAA;EACA,mBAAA;EAEA,oBAAA;CACA;AAEA;EACA,iCAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,4BAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,yCAAA;EACA,4BAAA;EACA,aAAA;CACA;AAEA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;CACA;;AAEA,uBAAA;AAEA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;CACA;AAEA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,8BAAA;CACA;AAEA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,8BAAA;CACA;AAEA;AAEA;IACA,oBAAA;IACA,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,uBAAA;IACA,YAAA;CACA;AAEA;IACA,yCAAA;IACA,oBAAA;IACA,cAAA;IACA,YAAA;CACA;AAEA;IACA,yCAAA;IACA,oBAAA;IACA,cAAA;IACA,YAAA;CACA;AAEA;IACA,+BAAA;IACA,uBAAA;IACA,YAAA;CACA;CAEA;AAEA;AAEA;IACA,oBAAA;IACA,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,uBAAA;IACA,YAAA;CACA;AAEA;IACA,yCAAA;IACA,oBAAA;IACA,cAAA;IACA,YAAA;CACA;AAEA;IACA,yCAAA;IACA,oBAAA;IACA,cAAA;IACA,YAAA;CACA;AAEA;IACA,6BAAA;IACA,uBAAA;IACA,YAAA;CACA;CAEA;AAEA;EACA,cAAA;EACA,uBAAA;CACA;AAEA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;CACA;AAEA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;CACA;AAEA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;CACA;AAEA;EACA,wBAAA;EACA,aAAA;CACA;AAEA;EAEA,iBAAA;CACA;AAEA;EACA,mCAAA;EACA,gDAAA;EAEA,2BAAA;EAEA,4BAAA;EAEA,2BAAA;EACA,sFAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;CACA;AAEA;EACA,iCAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;CACA;AAEA;EACA,aAAA;EACA,yCAAA;EACA,6BAAA;EACA,8CAAA;EACA,4BAAA;CACA;AAEA;EACA,aAAA;EACA,yCAAA;EACA,6BAAA;EACA,8CAAA;EACA,4BAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,mCAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EAEA,iBAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EAEA,iBAAA;CACA;AAEA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;;;;EAKA,gCAAA;EACA,yCAAA;CACA;AAEA;AACA;IACA,sCAAA;IACA,eAAA;CACA;CACA;AASA;EACA,4CAAA;EACA,6BAAA;EACA,aAAA;EACA,gDAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;CACA;AAEA;EAEA,sEAAA;CACA;AAEA;EACA,wCAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,yBAAA;EACA,wCAAA;EACA,aAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,iCAAA;EACA,uCAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,wCAAA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,uCAAA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,uCAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;CACA;;AAEA,WAAA;AAEA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;CACA;AAEA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,aAAA;EACA,YAAA;EACA,8CAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,wCAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,yBAAA;EACA,wCAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,2BAAA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;EACA,8BAAA;EACA,aAAA;EAEA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;CACA;;AAEA,eAAA;AAEA;EACA,iCAAA;EACA,wCAAA;EACA,8BAAA;CACA;AAEA;EACA,gBAAA;EACA,0BAAA;CACA;AAEA;EACA,gBAAA;EACA,0BAAA;CACA;AAEA;;EAEA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;CACA;;AAEA,kBAAA;AAEA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EAEA,iCAAA;CACA;AAEA;EAEA,gCAAA;EACA,eAAA;CACA;AAEA;EAEA,yBAAA;CACA;AAEA;EACA,iCAAA;CACA;AAEA;;EAEA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;;EAEA,8BAAA;EAGA,qBAAA;EAEA,cAAA;;EAEA,gDAAA;EAIA,uBAAA;EACA,oBAAA;;EAEA,YAAA;EAIA,sBAAA;EAEA,wBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,qBAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;CACA;AAEA;EACA,kBAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,2BAAA;CACA;AAeA;AACA;IACA,WAAA;IAEA,yBAAA;CACA;AACA;IACA,WAAA;IAEA,2BAAA;CACA;CACA;AAeA;AACA;IACA,WAAA;IAEA,0BAAA;CACA;AACA;IACA,WAAA;IAEA,yBAAA;CACA;CACA","file":"Login.vue","sourcesContent":["<template lang=\"pug\" src=\"./login.pug\"></template>\n\n<script>\nimport VueRecaptcha from 'vue-recaptcha'\nimport idioma from '../../../../build/language/index.js'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\nimport PATHS from '../../../router/routesMap.js'\n\nexport default {\n  name: 'Login',\n\n  components: { VueRecaptcha },\n\n  data () {\n    return {\n      PUBLIC_KEY: '6Lcr0awUAAAAAFQhGvyrtVnXKHS4c2d2r_qnBzaK',\n      isProbableABot: false,\n      isLogin: true,\n      username: '',\n      pass: '',\n      responsePasswordRecoveryCaptcha: null,\n      responseLoginCaptcha: null,\n      abrirIdiomas: false,\n      captchaOK: false,\n      msgErroCriacaoCaptcha: false,\n      msgCaptchaErro: false,\n      logadoSuccess: false,\n      logadoError: false,\n      campoUsernameVazio: false,\n      campoPassVazio: false,\n      campoUsernameInvalido: false,\n      destFileCaptcha: '',\n      numeroCaptcha: '',\n      disableLoginButton: false,\n      disableRecoveryButton: false,\n      idiomaPng: require('../../../assets/login/img/idioma.png'),\n      idiomaAtivoPng: require('../../../assets/login/img/idioma-ativo.png'),\n      logoEqualsLoginPng: require('../../../assets/logos_equals/logo_banking.png'),\n      userPng: require('../../../assets/login/img/user.png'),\n      passwordPng: require('../../../assets/login/img/password.png'),\n      fecharPng: require('../../../assets/login/img/fechar.png'),\n      logadoOkPng: require('../../../assets/login/img/logado-ok.png'),\n      voltarPng: require('../../../assets/login/img/voltar.png')\n    }\n  },\n\n  computed: {\n    isLoggedIn () {\n      return this.$store.getters.isLoggedIn\n    },\n\n    messageErrorLogin () {\n      return this.$store.getters.messageErrorLogin\n    }\n  },\n\n  watch: {\n    messageErrorLogin () {\n      if (this.messageErrorLogin) {\n        this.$root.$refs.notification.warning('erro')\n        this.$store.dispatch('cleanMessageErrorSession')\n      }\n    },\n\n    username () {\n      if (this.username && this.username.length > 0) {\n        this.campoUsernameVazio = false\n        this.campoUsernameInvalido = false\n        let inputId = this.isLogin ? 'loginInputLog' : 'loginInputRec'\n        document.getElementById(inputId).style.borderBottom = '2px solid #ffffff'\n      }\n    },\n\n    pass () {\n      if (this.pass && this.pass.length > 0) {\n        this.campoPassVazio = false\n        document.querySelector('#loginSenha').style.borderBottom = '2px solid #ffffff'\n      }\n    }\n  },\n\n  methods: {\n    escolherIdioma () {\n      this.abrirIdiomas = true\n    },\n\n    fecharEscolherIdioma () {\n      this.abrirIdiomas = false\n    },\n\n    trocarIdioma (language) {\n      idioma.changeLanguage(language)\n\n      $('div.btn-group').find('.btn-ativo').removeClass('btn-ativo')\n\n      switch (language) {\n        case 'pt':\n          $('.btn-pt').addClass('btn-ativo')\n          break\n        case 'in':\n          $('.btn-in').addClass('btn-ativo')\n          break\n        case 'es':\n          $('.btn-es').addClass('btn-ativo')\n          break\n        default:\n          break\n      }\n    },\n\n    login (event) {\n      localStorage.removeItem('token')\n      event.preventDefault()\n      if (this.responseLoginCaptcha === null && this.isProbableABot) {\n        this.$root.$refs.notification.error('login.validacao.recaptcha')\n        return\n      }\n      if (this.validateForm()) {\n        this.disableLoginButton = true\n        this.$store.dispatch('login', {\n          username: this.username,\n          password: this.pass,\n          recaptcha: this.responseLoginCaptcha\n        }).then((response) => {\n          this.$store.dispatch('setClient', {client: null, clientName: null, singleClient: null})\n            .then(async () => {\n              await trackAnalyticsEvent(this, 'tentativa-de-login', 'login-click', idioma.getCookieByName('language'))\n              this.$store.dispatch('getClients')\n                .then((clients) => {\n                  this.$root.$refs.notification.success('login.sucesso.login')\n                  location.href = PATHS.HOME\n                  this.disableLoginButton = false\n                })\n                .catch((error) => {\n                  this.$store.dispatch('logout')\n                    .then(() => {\n                      this.$store.dispatch('cleanVuexModules').then(() => {\n                        this.$root.$refs.notification.error(error.message)\n                        this.disableLoginButton = false\n                      })\n                    })\n                })\n                .finally(() => {\n                  localStorage.setItem('event-login-done', Math.random())\n                })\n            })\n        }).catch((error) => {\n          this.isProbableABot = error.triesAmount >= 5\n          let errorMessageSplitted = error.message.split('  ')\n          if (errorMessageSplitted[0] === 'login.erro.usuario.senhaBloqueada') {\n            trackAnalyticsEvent(this, 'tentativa-de-login', 'login-click', 'senha-bloqueada')\n          }\n          this.disableLoginButton = false\n          if (errorMessageSplitted[0] === 'No message available') {\n            this.$root.$refs.notification.error('GENERAL', 'login.erro.verificarEmailSenha')\n          // acontece quando nao recebe resposta do node\n          } else if (errorMessageSplitted[0] === \"Cannot read property 'status' of undefined\") {\n            this.$root.$refs.notification.error('GENERAL', 'login.erro.loginTitle')\n          } else {\n            this.$root.$refs.notification.error(errorMessageSplitted[0], 'login.erro.loginTitle')\n          }\n        })\n      }\n    },\n\n    logout () {\n      this.$store.dispatch('logout').then(() => {\n        localStorage.removeItem('token')\n        this.$router.push('/')\n      })\n    },\n\n    validateEmail (email) {\n      return (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$/).test(this.username)\n    },\n\n    validateForm () {\n      // Não pode fazer o retorno direto das funções de validação para\n      // garantir que ambos o campos do form sejam validados na ação.\n      let isValidUsername = this.verifyUsernameEmpty()\n      let isValidPass = this.verifyPasswordEmpty()\n      return isValidUsername && isValidPass\n    },\n\n    verifyUsernameEmpty () {\n      let inputId = this.isLogin ? 'loginInputLog' : 'loginInputRec'\n      let isValid = true\n      this.campoUsernameVazio = false\n      this.campoUsernameInvalido = false\n      if (this.username == null || this.username === undefined || this.username === '') {\n        this.campoUsernameVazio = true\n        document.getElementById(inputId).style.borderBottom = '2px solid #c65b55'\n        isValid = false\n      } else if (!this.validateEmail()) {\n        this.campoUsernameInvalido = true\n        document.getElementById(inputId).style.borderBottom = '2px solid #c65b55'\n        isValid = false\n      }\n      return isValid\n    },\n\n    verifyPasswordEmpty () {\n      let isValid = true\n      this.campoPassVazio = false\n      if (this.pass == null || this.pass === undefined || this.pass === '') {\n        this.campoPassVazio = true\n        document.querySelector('#loginSenha').style.borderBottom = '2px solid #c65b55'\n        isValid = false\n      }\n\n      return isValid\n    },\n\n    limparErro () {\n      this.logadoError = false\n      $('.form-control').css('border-bottom', '2px solid rgba(255, 255, 255, 1)')\n    },\n\n    animacaoTela: function (step) {\n      step.addClass('animate-out')\n\n      setTimeout(function () {\n        step.removeClass('animate-out is-showing').next().addClass('animate-in')\n      }, 400)\n\n      setTimeout(function () {\n        step.next().removeClass('animate-in').addClass('is-showing')\n      }, 1200)\n    },\n\n    // Troca de tela da tela de login para tela de recuperar senha\n    trocaTelaRecuperarSenha: function () {\n      var self = this\n      self.isLogin = false\n      var step = $('.inicial-body2')\n      if (this.campoUsernameVazio || this.campoUsernameInvalido) {\n        document.getElementById('loginInputRec').style.borderBottom = '2px solid #c65b55'\n      }\n      self.animacaoTela(step)\n    },\n\n    // Troca de tela da tela de recuperação de senha para tela de login\n    trocaTelaVoltar: function () {\n      this.isLogin = true\n      this.campoPassVazio = false\n      this.campoUsernameVazio = false\n      this.campoUsernameInvalido = false\n      this.username = ''\n      this.pass = ''\n      document.querySelector('#loginSenha').style.borderBottom = '2px solid white'\n      document.querySelector('#loginInputLog').style.borderBottom = '2px solid white'\n      document.querySelector('#loginInputRec').style.borderBottom = '2px solid white'\n      var step = $('.inicial-body3')\n\n      step.addClass('animate-out')\n\n      setTimeout(function () {\n        step.removeClass('animate-out is-showing').prev().addClass('animate-in')\n      }, 400)\n\n      setTimeout(function () {\n        step.prev().removeClass('animate-in').addClass('is-showing')\n      }, 1200)\n    },\n\n    removeSpaces: function (string) {\n      return string.split(' ').join('')\n    },\n\n    onVerify (response) {\n      this.responsePasswordRecoveryCaptcha = response\n    },\n\n    onVerifyLogin (response) {\n      this.responseLoginCaptcha = response\n    },\n\n    recoverPassword (event) {\n      event.preventDefault()\n      if (!this.responsePasswordRecoveryCaptcha) {\n        this.$root.$refs.notification.error('login.validacao.recaptcha')\n        return\n      }\n\n      if (this.verifyUsernameEmpty()) {\n        this.disableRecoveryButton = true\n        let recoverPasswordData = {\n          username: this.username,\n          url: 'http://' + window.location.host + '/banking/',\n          recaptcha: this.responsePasswordRecoveryCaptcha\n        }\n        this.$store.dispatch('recoverPassword', recoverPasswordData).then((response) => {\n          this.$root.$refs.notification.success('login.sucesso.recuperarSenha')\n          trackAnalyticsEvent(this, 'tentativa-de-recuperar-senha', 'recuperar-senha', 'sucesso')\n          this.disableRecoveryButton = false\n          this.trocaTelaVoltar()\n        }).catch((error) => {\n          trackAnalyticsEvent(this, 'tentativa-de-recuperar-senha', 'recuperar-senha', 'erro')\n          this.disableRecoveryButton = false\n          this.$root.$refs.notification.error(error.message)\n        })\n      }\n    },\n\n    carregarImagem (nomeImagem) {\n      var idiomaImagem = idioma.getCookieByName('language')\n      return require('../../../assets/login/img/' + nomeImagem + idiomaImagem + '.png')\n    }\n  },\n\n  mounted () {\n    this.$store.dispatch('tentativas').then(response => {\n      this.isProbableABot = response.triesAmount >= 5\n    })\n    if (localStorage.getItem('SESSION_ERR')) {\n      this.$root.$refs.notification.warning(localStorage.getItem('SESSION_ERR'))\n      localStorage.removeItem('SESSION_ERR')\n    }\n\n    if (localStorage.getItem('UNAUTHORIZED') === 'UNAUTHORIZED') {\n      this.$root.$refs.notification.warning('naoAutorizado.labels.mensagem401')\n    } else if (localStorage.getItem('SESSION_ERR')) {\n      this.$root.$refs.notification.warning(localStorage.getItem('SESSION_ERR'))\n      localStorage.removeItem('SESSION_ERR')\n    }\n\n    localStorage.setItem('UNAUTHORIZED', null)\n\n    idioma.changeLanguage(idioma.getCookieByName('language'))\n\n    // Deixa ativo o botão do idioma selecionado.\n    switch (idioma.getCookieByName('language')) {\n      case 'pt':\n        $('.btn-pt').addClass('btn-ativo')\n        break\n      case 'in':\n        $('.btn-in').addClass('btn-ativo')\n        break\n      case 'es':\n        $('.btn-es').addClass('btn-ativo')\n        break\n      default:\n        break\n    }\n  }\n}\n</script>\n\n<style scoped>\n/*Tela de login*/\n\n.recaptcha-form {\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n}\n\n.bg-tela-login:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n\n.bg-tela-login:after {\n  bottom: 0;\n}\n\n.bg-tela-login {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: -webkit-linear-gradient(left, #1C3B65, #40B9BB);\n  background: -o-linear-gradient(right, #223768, #00C3BE);\n  background: -moz-linear-gradient(right, #223768, #00C3BE);\n  background: linear-gradient(to right, #223768, #00C3BE);\n  height: auto !important;\n  min-height: 100vh;\n}\n\n.inicial-wrap {\n  font-family: 'Inter', sans-serif;\n  max-width: 650px;\n  margin: 20px auto;\n  -webkit-transition: -webkit-transform 300ms ease-in-out;\n  transition: -webkit-transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;\n}\n\n.inicial-bodies {\n  font-family: 'Inter', sans-serif;\n  text-align: center;\n  position: relative;\n  -webkit-perspective: 1000px;\n  perspective: 1000px;\n}\n\nbutton.button {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(174, 223, 120, 1);\n  font-size: 20px;\n  cursor: pointer;\n  margin-top: 60px !important;\n  color: rgba(28, 59, 101, 1);\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\n\nbutton.button:hover {\n  background-color: rgba(174, 223, 120, 1);\n  color: rgba(28, 59, 101, 1);\n  border: none;\n}\n\n.button i {\n  font-weight: normal;\n  font-size: 24px;\n  margin-right: 5px;\n}\n\n/*Tela de boas vindas*/\n\n.boas-vindas-tit {\n  text-align: center;\n  font-size: 50px;\n  color: rgba(122, 203, 231, 1);\n}\n\n.boas-vindas-txt {\n  text-align: center;\n  padding: 50px 145px 50px 145px;\n  font-size: 25px;\n  color: rgba(255, 255, 255, 1);\n}\n\n.boas-vindas-txt-bottom {\n  font-weight: bold;\n  font-size: 20px;\n  text-transform: uppercase;\n  color: rgba(122, 203, 231, 1);\n}\n\n@media screen and (min-width: 992px) {\n\n  .inicial-body {\n    background: #005E78;\n    padding: 40px 0px 0px 0px;\n    margin-bottom: 20px;\n    display: none;\n    box-sizing: border-box;\n    width: 100%;\n  }\n\n  .inicial-body2 {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 76px;\n    display: none;\n    width: 100%;\n  }\n\n  .inicial-body3 {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 20px;\n    display: none;\n    width: 100%;\n  }\n\n  .formulario-login {\n    padding: 80px 125px 50px 125px;\n    box-sizing: border-box;\n    width: 100%;\n  }\n\n}\n\n@media screen and (max-width: 991px) {\n\n  .inicial-body {\n    background: #005E78;\n    padding: 40px 0px 0px 0px;\n    margin-bottom: 20px;\n    display: none;\n    box-sizing: border-box;\n    width: 100%;\n  }\n\n  .inicial-body2 {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 74px;\n    display: none;\n    width: 100%;\n  }\n\n  .inicial-body3 {\n    border: 2px solid rgba(255, 255, 255, 1);\n    margin-bottom: 20px;\n    display: none;\n    width: 100%;\n  }\n\n  .formulario-login {\n    padding: 80px 50px 50px 50px;\n    box-sizing: border-box;\n    width: 100%;\n  }\n\n}\n\n.formulario-login-topo {\n  height: 115px;\n  background-color: #FFF;\n}\n\n.formulario-login-topo-logo {\n  z-index:1;\n  position: absolute;\n  width:100%;\n  max-width: 100%;\n  text-align: left;\n  padding: 22px 0px;\n}\n\nimg.logo-img {\n  max-height:60px;\n  margin-top:8px;\n  padding-left:20px;\n}\n\np.logo-txt {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #1c3b65;\n  font-size: 30px;\n  text-transform: capitalize;\n}\n\nbutton.btn-idioma {\n  background: #fff;\n  float: right;\n  height: 100%;\n  padding: 2%;\n  border: none;\n}\n\nbutton.btn-idioma:hover {\n  background: transparent;\n  border: none;\n}\n\nbutton.btn-idioma:active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.escolhaIdiomas {\n  background: rgba(133, 186, 202, 1);\n  /* For browsers that do not support gradients */\n  background: -webkit-linear-gradient(left, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* For Safari 5.1 to 6.0 */\n  background: -o-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* For Opera 11.1 to 12.0 */\n  background: -moz-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* For Firefox 3.6 to 15 */\n  background: linear-gradient(to right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* Standard syntax */\n  height: 50px;\n  z-index: 2;\n}\n\n.escolhaIdiomas p {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  color: rgba(28, 59, 101, 1);\n  padding: 15px;\n  font-weight: bold;\n  vertical-align: middle;\n}\n\nbutton.btn-escolher-idioma {\n  font-family: 'Inter', sans-serif;\n  border: none;\n  font-size: 15px;\n  background-color: transparent;\n  padding: 14px 10px 15px 10px;\n  color: rgba(255, 255, 255, 1);\n}\n\nbutton.btn-escolher-idioma.btn-ativo {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\n\nbutton.btn-escolher-idioma:hover {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\n\nbutton.btn-fechar-escolher-idioma {\n  background-color: transparent;\n  padding: 0px;\n  margin: 0px 6px 0px 25px!important;\n  border: none;\n}\n\nbutton.btn-fechar-escolher-idioma:hover {\n  background-color: transparent;\n  border: none;\n}\n\nbutton.btn-fechar-escolher-idioma:active {\n  background-color: transparent;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbutton.btn-esqueceu-senha {\n  background-color: transparent;\n  border: none;\n  z-index: 2;\n  position: absolute;\n  height: 60px;\n  width: 60px;\n  right: 0;\n  text-align: center;\n  padding: 0px;\n}\n\nbutton.btn-esqueceu-senha:hover {\n  background-color: transparent;\n  border: none;\n}\n\nbutton.btn-esqueceu-senha:active {\n  background-color: transparent;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.logo-equals {\n  height: 100%;\n  padding: 2%;\n}\n\n.text-white {\n  color: #fff;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-animation: autofill 0s forwards;\n  animation: autofill 0s forwards;\n  -webkit-text-fill-color: #fff !important;\n}\n\n@keyframes autofill {\n  100% {\n    background: rgba(255, 255, 255, 0.15);\n    color: inherit;\n  }\n}\n\n@-webkit-keyframes autofill {\n  100% {\n    background: rgba(255, 255, 255, 0.15);\n    color: inherit;\n  }\n}\n\n.formulario-login input {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-radius: 0px!important;\n  border: none;\n  border-bottom: 2px solid rgba(255, 255, 255, 1);\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n  height: 60px;\n}\n\n.formulario-login input:focus {\n  -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;\n  box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;\n}\n\n.formulario-login input::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\n\n.formulario-login input:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\n.formulario-login input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n  opacity: 0.4;\n}\n\n.formulario-login input:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\nbutton.button-login {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(28, 59, 101, 1);\n  bottom: 0;\n  font-size: 20px;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 1);\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\n\nbutton.button-login:hover {\n  background-color: rgba(64, 185, 187, 1);\n  color: rgba(255, 255, 255, 1);\n  border: none;\n}\n\nbutton.button-login:active {\n  background-color: rgba(28, 59, 101, 1);\n  color: rgba(255, 255, 255, 1);\n  border: none;\n}\n\nbutton.button-login:disabled {\n  background-color: rgba(28, 59, 101, 1);\n  cursor: progress;\n  color: #FFF;\n  border: none;\n}\n\n/*Captcha*/\n\n.captcha {\n  font-family: 'Inter', sans-serif;\n  background-color: #FFF;\n  padding: 20px 10px;\n}\n\n.captcha p {\n  width: 100%;\n  font-size: 15px;\n  margin-top: 10px;\n}\n\n#mainCaptcha {\n  width: 90%;\n  background-color: transparent;\n  color: black;\n  text-align: center;\n  padding: 0px;\n}\n\n.text-center {\n  text-align: center;\n}\n\nbutton.btn-refresh-catpcha {\n  width: 10%;\n  background-color: transparent;\n  padding: 0px;\n  border: none;\n}\n\nbutton.btn-refresh-catpcha:hover {\n  background-color: transparent;\n  border: none;\n}\n\nbutton.btn-refresh-catpcha:active {\n  background-color: transparent;\n  border: none;\n}\n\ninput.captcha-recuperar-senha {\n  padding: 8px;\n  width: 100%;\n  /* background-color: rgba(95, 169, 192, 1); */\n  border-radius: 0px!important;\n  border: none;\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n}\n\n.g-recaptcha {\n  display: inline-block;\n}\n\ninput.captcha-recuperar-senha::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\n\ninput.captcha-recuperar-senha:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\ninput.captcha-recuperar-senha::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\ninput.captcha-recuperar-senha:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\nbutton.button2 {\n  margin-top: 20px!important;\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  padding: 0px;\n}\n\nbutton.button2:hover {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n}\n\nbutton.button2:active {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  background-color: transparent;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbutton.button2 span {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  margin-left: 8px;\n  font-weight: bold;\n}\n\n/*Tela logado*/\n\n.logado {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(147, 191, 98, 1);\n  color: rgba(255, 255, 255, 1);\n}\n\n.logado-ok {\n  font-size: 50px;\n  margin: 30px 0px 10px 0px;\n}\n\n.bem-vindo {\n  font-size: 20px;\n  text-transform: uppercase;\n}\n\n.img-bottom {\n\n  height: 90px;\n  /*max-width: 650px;*/\n  vertical-align: middle;\n  margin-bottom: 30px;\n  /*position: absolute;*/\n}\n\n/*Login com erro*/\n\n.erro-login {\n  color: rgba(106, 34, 35, 1);\n  margin-top: 5px;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.inicial-body.is-showing {\n  display: block;\n}\n\n.inicial-body2.is-showing {\n  display: block;\n}\n\n.inicial-body3.is-showing {\n  display: block;\n}\n\n.animate-out {\n  -webkit-animation: out 600ms ease-in-out;\n  animation: out 600ms ease-in-out;\n}\n\n.animate-in {\n  -webkit-animation: in 400ms ease-in-out;\n  animation: in 400ms ease-in-out;\n  display: block;\n}\n\n.animate-up {\n  -webkit-transform: rotateY(0deg);\n  transform: rotateY(0deg);\n}\n\n.form-control {\n  font-family: 'Inter', sans-serif;\n}\n\nhtml,\nbody {\n  height: 100%;\n}\n\nbody {\n  overflow: auto;\n}\n\n.vertical-center {\n\n  /* Make it a flex container */\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -moz-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n\n  -webkit-box-pack: center;\n  -moz-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n}\n\n.jumbotron.vertical-center {\n  margin-bottom: 0;\n}\n\n#loginInputLog, #loginInputRec {\n  padding-left: 50px;\n}\n\n#loginSenha {\n  padding-left: 50px;\n}\n\n.inicial-wrap.px-0.img-bottom div {\n  padding-bottom: 15px;\n}\n\n.formulario-login .form-group>img {\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  left: 0;\n  text-align: center;\n  padding: 15px;\n}\n\n.recuperarSenha {\n  padding: 10px 0px;\n  color: #FFF;\n}\n\n.recuperarSenha a {\n  color: #FFF;\n}\n\n.recuperarSenha a:hover {\n  text-decoration: underline;\n}\n\n@-webkit-keyframes out {\n  0% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: rotateY(-90deg);\n    transform: rotateY(-90deg);\n  }\n}\n\n@keyframes out {\n  0% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: rotateY(-90deg);\n    transform: rotateY(-90deg);\n  }\n}\n\n@-webkit-keyframes in {\n  0% {\n    opacity: 0;\n    -webkit-transform: rotateY(90deg);\n    transform: rotateY(90deg);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n\n@keyframes in {\n  0% {\n    opacity: 0;\n    -webkit-transform: rotateY(90deg);\n    transform: rotateY(90deg);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1073 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-5e2ad742","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/RemittanceIntegrationModal.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#main-value-container.main-container {\n  padding-right: 15px;\n  padding-left: 15px;\n  padding-top: 15px;\n}\n#statuses-container {\n  margin-top: 10px;\n}\n#tab-historic-id {\n  margin: 0 !important;\n  padding-top: 10px;\n  height: 71vh !important;\n  width: 100% !important;\n}\n#tabbed-modal {\n  min-height: 71vh !important;\n}\n.tab.tab-container {\n  height: 100%;\n}\n#tab-details-id {\n  position: relative;\n  height: 100%;\n}\n#footer-monetary-container {\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n}\n#tab-allotment-id {\n  position: relative;\n  height: 100%;\n}\n#tab-tasks-id {\n  position: relative;\n  height: 100%;\n}\n.modal-lg {\n  width: 75vw;\n}\n.tab-icon-font {\n  font-size: 12px;\n}\n.tab {\n  margin-top: 0px !important;\n}\n.tabbed-modal-body {\n  padding: 0px !important;\n}\n#tabbed-modal.vue-tabs .nav-tabs {\n  border-bottom: none;\n}\n#tabbed-modal.vue-tabs .nav>li.active span.title {\n  color: #37F3F5;\n  font-size: 12px;\n}\n#tabbed-modal.vue-tabs .nav>li span.title {\n  color: #8AA4AF;\n  font-size: 12px;\n}\n\n/*Active*/\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus {\n  border-left: 5px solid!important;\n  border-color: #37F3F5!important;\n  transition: all 0.2s!important;\n  border-top: 0px !important;\n  border-right: 0px !important;\n  border-bottom: 0px !important;\n  background: #132E4D;\n  color: #37F3F5!important;\n}\n#tabbed-modal.vue-tabs .nav-tabs>li>a,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:focus {\n  border: none !important;\n  color: #8AA4AF;\n  background: transparent;\n  border-radius: 0px;\n  margin-right: 0px;\n}\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover {\n  background: #10253E;\n}\n.left-vertical-tabs {\n  background: #1B3C65;\n}\n.modal .modal-content {\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n.tab-historic {\n  max-height: 450px;\n  overflow-y: auto;\n}\n.tab-left {\n  text-align: center\n}\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus>.tab-left{\n  text-align: center;\n  margin-left: -5px;\n}\n", "", {"version":3,"sources":["/./client/components/integration/remittanceIntegration/RemittanceIntegrationModal.vue?260fecba"],"names":[],"mappings":";AA+GA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;CACA;AAEA;EACA,4BAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;CACA;AAEA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,eAAA;EACA,gBAAA;CACA;AAEA;EACA,eAAA;EACA,gBAAA;CACA;;AAEA,UAAA;AACA;;;EAGA,iCAAA;EACA,gCAAA;EAIA,+BAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,oBAAA;EACA,yBAAA;CACA;AAEA;;;EAGA,wBAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;CACA;AAEA;EACA,kBAAA;EACA,iBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;;;EAGA,mBAAA;EACA,kBAAA;CACA","file":"RemittanceIntegrationModal.vue","sourcesContent":["<template src='./remittanceIntegrationModal.pug' lang='pug'></template>\n\n<script>\nimport { VueTabs, VTab } from 'vue-nav-tabs'\nimport BetterModal from '../../modals/betterModal/BetterModal'\nimport TabRemittanceDetail from './TabRemittanceDetail'\nimport TabRemittanceReport from './TabRemittanceReport'\nimport SituacaoRemessaEnum from '../../../enum/situacaoRemessa'\n\nexport default {\n  name: 'RemittanceIntegrationModal',\n\n  components: {\n    VueTabs,\n    VTab,\n    BetterModal,\n    TabRemittanceDetail,\n    TabRemittanceReport\n  },\n\n  props: {\n    remittance: {\n      type: Object,\n      required: true\n    },\n    show: {\n      type: Boolean,\n      default: false\n    },\n    showRemovalButton: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      tabName: null,\n      tabs: [],\n      modal: {\n        text: {\n          title: this.$t('remessaIntegracao.remessa.detalhar.modal.titulo'),\n          subtitle: this.$t('remessaIntegracao.remessa.detalhar.modal.subtitulo')\n        }\n      }\n    }\n  },\n\n  computed: {\n    situacaoRemocaoValida () {\n      if (this.remittance.Situacao === SituacaoRemessaEnum.CONCLUIDO || this.remittance.Situacao === SituacaoRemessaEnum.ERRO) {\n        return false\n      }\n      return true\n    }\n  },\n\n  watch: {\n    remittance () {\n      if (this.remittance.id) {\n        this.tabs = []\n        this.loadDetail()\n      }\n    }\n  },\n\n  methods: {\n    verifyTabAuthorization (tab) {\n      return true\n    },\n\n    loadDetail () {\n      this.tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-TabRemittanceDetail',\n        idTabContent: 'tab-detail-id',\n        idLanc: this.idRemittance,\n        tabRef: 'tabDetailGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),\n        icon: 'icon=\"tab-icon-font fa fa-info-circle',\n        type: 'TabRemittanceDetail',\n        props: {\n          remittance: this.remittance,\n          showRemovalButton: this.showRemovalButton && this.situacaoRemocaoValida\n        }\n      })\n      this.tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-TabRemittanceReport',\n        idTabContent: 'tab-report-id',\n        idLanc: this.idRemittance,\n        tabRef: 'tabReportGridModal',\n        title: this.$t('remessaIntegracao.labels.modal.tabs.resumo'),\n        icon: 'icon=\"tab-icon-font fa fa-bars',\n        type: 'TabRemittanceReport',\n        props: {\n          remittance: this.remittance,\n          showRemovalButton: this.showRemovalButton && this.situacaoRemocaoValida\n        }\n      })\n    },\n\n    closeModal () {\n      this.tabName = null\n      this.$emit('close-modal')\n    }\n  }\n}\n</script>\n\n<style lang='css'>\n#main-value-container.main-container {\n  padding-right: 15px;\n  padding-left: 15px;\n  padding-top: 15px;\n}\n\n#statuses-container {\n  margin-top: 10px;\n}\n\n#tab-historic-id {\n  margin: 0 !important;\n  padding-top: 10px;\n  height: 71vh !important;\n  width: 100% !important;\n}\n\n#tabbed-modal {\n  min-height: 71vh !important;\n}\n\n.tab.tab-container {\n  height: 100%;\n}\n\n#tab-details-id {\n  position: relative;\n  height: 100%;\n}\n\n#footer-monetary-container {\n  bottom: 0;\n  position: absolute;\n  width: 100%;\n}\n\n#tab-allotment-id {\n  position: relative;\n  height: 100%;\n}\n\n#tab-tasks-id {\n  position: relative;\n  height: 100%;\n}\n\n.modal-lg {\n  width: 75vw;\n}\n\n.tab-icon-font {\n  font-size: 12px;\n}\n\n.tab {\n  margin-top: 0px !important;\n}\n\n.tabbed-modal-body {\n  padding: 0px !important;\n}\n\n#tabbed-modal.vue-tabs .nav-tabs {\n  border-bottom: none;\n}\n\n#tabbed-modal.vue-tabs .nav>li.active span.title {\n  color: #37F3F5;\n  font-size: 12px;\n}\n\n#tabbed-modal.vue-tabs .nav>li span.title {\n  color: #8AA4AF;\n  font-size: 12px;\n}\n\n/*Active*/\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus {\n  border-left: 5px solid!important;\n  border-color: #37F3F5!important;\n  -webkit-transition: all 0.2ms!important;\n  -moz-transition: all 0.2ms!important;\n  -o-transition: all 0.2ms!important;\n  transition: all 0.2s!important;\n  border-top: 0px !important;\n  border-right: 0px !important;\n  border-bottom: 0px !important;\n  background: #132E4D;\n  color: #37F3F5!important;\n}\n\n#tabbed-modal.vue-tabs .nav-tabs>li>a,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover,\n#tabbed-modal.vue-tabs .nav-tabs>li>a:focus {\n  border: none !important;\n  color: #8AA4AF;\n  background: transparent;\n  border-radius: 0px;\n  margin-right: 0px;\n}\n\n#tabbed-modal.vue-tabs .nav-tabs>li>a:hover {\n  background: #10253E;\n}\n\n.left-vertical-tabs {\n  background: #1B3C65;\n}\n\n.modal .modal-content {\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n\n.tab-historic {\n  max-height: 450px;\n  overflow-y: auto;\n}\n\n.tab-left {\n  text-align: center\n}\n\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:hover>.tab-left,\n#tabbed-modal.vue-tabs .nav-tabs>li.active>a:focus>.tab-left{\n  text-align: center;\n  margin-left: -5px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1074 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6021cb38","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/assignment/List.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.date-picker[data-v-6021cb38] {\n  border: none;\n  height: 36px!important;\n  width: 100px;\n}\n.vdp-datepicker[data-v-6021cb38] {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 11px 8px!important;\n  margin-right: 10px;\n}\n.check-atribuidas[data-v-6021cb38] {\n  font-weight: bold!important;\n}\n.spaced-bottom-top[data-v-6021cb38] {\n  margin-bottom: 10px;\n  margin-top: 5px;\n}\n", "", {"version":3,"sources":["/./client/components/views/administration/assignment/List.vue?9fa07b72"],"names":[],"mappings":";AAopBA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;CACA;AAEA;EACA,4BAAA;CACA;AAEA;EACA,oBAAA;EACA,gBAAA;CACA","file":"List.vue","sourcesContent":["<template src='./list.pug' lang='pug'></template>\n\n<script>\nimport _ from 'underscore'\nimport vSelect from 'vue-select'\nimport GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport language from '../../../../../build/language/index'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\nimport { generateFinMovFromNode, generateAccountEntryFromNode } from '../../../../utils/transformationData.js'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport closeModal from '../../../../events/closeModal'\nimport IdSituacaoTarefaEnum from '../../../../enum/idSituacaoTarefa'\nimport FiltroSituacaoTarefaEnum from '../../../../enum/tipoFiltroSituacaoTarefas'\nimport FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'\n\nexport default {\n  name: 'AssignmentList',\n\n  components: {\n    vSelect,\n    GridDetailsModal,\n    PageTitle,\n    FilterPortlet,\n    DateRange,\n    ButtonPrimary,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      defaultTab: 'gridDetailsModal-tabDetails',\n      // Variáveis utilizadas para montar a treegrid\n      gridId: '#assignmentGrid',\n      result: {},\n      treeGridCfg: {},\n      exportUrl: EXPORT_TREEGRID,\n      showTreegrid: false,\n      // Array de base de consulta\n      isOpenDetailsModal: false,\n      queryBaseOptions: [\n        {\n          'id': 0,\n          'label': this.$t('consultaTarefa.labels.todas'),\n          'showDatePicker': false\n        },\n        {\n          'id': 1,\n          'label': this.$t('consultaTarefa.labels.dataCriacao'),\n          'showDatePicker': true\n        },\n        {\n          'id': 2,\n          'label': this.$t('consultaTarefa.labels.dataVencimento'),\n          'showDatePicker': true\n        },\n        {\n          'id': 3,\n          'label': this.$t('consultaTarefa.labels.dataConclusao'),\n          'showDatePicker': true\n        }\n      ],\n      showDate: false,\n      // Array de tipos de ocorrência\n      filteredOriginOptions: [],\n      originalOriginOptions: [\n        {\n          'label': this.$t('consultaTarefa.labels.MF'),\n          'key': 'MF'\n        },\n        {\n          'label': this.$t('consultaTarefa.labels.CL'),\n          'key': 'CL'\n        }\n      ],\n      // Array de situações\n      situationList: [\n        {\n          // Pendente\n          id: IdSituacaoTarefaEnum.PENDENTE,\n          nome: this.$t('consultaTarefa.labels.situacao.pendente'),\n          checked: true\n        },\n        {\n          // Em andamento\n          id: IdSituacaoTarefaEnum.EM_ANDAMENTO,\n          nome: this.$t('consultaTarefa.labels.situacao.emAndamento'),\n          checked: true\n        },\n        {\n          // Aguardando\n          id: IdSituacaoTarefaEnum.AGUARDANDO,\n          nome: this.$t('consultaTarefa.labels.situacao.aguardando'),\n          checked: true\n        },\n        {\n          // Concluído\n          id: IdSituacaoTarefaEnum.CONCLUIDO,\n          nome: this.$t('consultaTarefa.labels.situacao.concluido'),\n          checked: true\n        },\n        {\n          // Cancelado\n          id: IdSituacaoTarefaEnum.CANCELADO,\n          nome: this.$t('consultaTarefa.labels.situacao.cancelado'),\n          checked: true\n        }\n      ],\n      disableSearchButton: false,\n      queryBaseSelected: {\n        'id': 0,\n        'label': this.$t('consultaTarefa.labels.todas'),\n        'showDatePicker': false\n      },\n      typeLinkSelected: [],\n      assignCheck: false,\n      firstDate: new Date(),\n      finalDate: new Date(),\n      detailsObj: {\n        establishtmentValue: {},\n        mainValuesList: [],\n        monetaryValuesList: [],\n        statusValuesList: [],\n        integrationValuesList: [],\n        concSituation: null,\n        idProcessamento: -1\n      },\n      modalId: '',\n      modalDetailsTabs: [],\n      finalDateDisable: new Date(),\n      dateRange: {},\n      modalTitle: null,\n      modalSubTitle: null\n    }\n  },\n\n  computed: {\n    client () {\n      return this.$store.getters.client\n    },\n    situationFilter () {\n      return this.$store.getters.situationFilter\n    }\n  },\n\n  methods: {\n    // Método chamando na troca do select de base de consulta, para exibir ou esconder o date picker\n    showDatePicker (val) {\n      trackAnalyticsEvent(this, 'tarefas-select', 'base-consulta', val.label)\n      // Se for data de vencimento (id=2) então não pode bloquear a data final\n      if (val.id === 2) {\n        this.finalDateDisable = null\n      } else {\n        this.finalDateDisable = new Date()\n        this.firstDate = new Date()\n        this.finalDate = new Date()\n      }\n      this.showDate = val.showDatePicker\n      this.queryBaseSelected = val\n    },\n\n    trackCheckBox (event) {\n      trackAnalyticsEvent(this, 'tarefas-check-box', 'tarefas-atribuidas-a-mim', event.target.checked ? 'marcada' : 'desmarcada')\n    },\n\n    trackCheckBoxSituacao (nomeSituacao) {\n      trackAnalyticsEvent(this, 'tarefas-check-box', 'situacao-clicada', nomeSituacao)\n    },\n\n    trackOrigem (selectedOrigins) {\n      this.filteredOriginOptions = _.difference(this.originalOriginOptions, selectedOrigins)\n      if (selectedOrigins.length > 0) {\n        let originsString = []\n        selectedOrigins.forEach(element => {\n          originsString.push(element.label)\n        })\n        trackAnalyticsEvent(this, 'tarefas-multi-select', 'origem-da-tarefa', originsString.toString())\n      }\n    },\n\n    validate (event) {\n      event.preventDefault()\n      let self = this\n      this.$validator.validateAll().then((result) => {\n        if (result) {\n          if (self.$refs.dateRange && !self.$refs.dateRange.validate()) {\n            self.$root.$refs.notification.error('dateRange.validacao.dataInvalida')\n            return\n          }\n          self.showTreegrid = true\n          startTreeGridLoading(self.gridId)\n          self.search()\n        }\n      })\n    },\n\n    // Faz a busca das tarefas\n    search () {\n      // Monta o array de tipo vinculo\n      let typeLinkAux = this.createArrayTypeLinkFilter()\n\n      // Monta o array de situações\n      let situationListAux = this.createArraySituationListFilter()\n\n      // Varíaveis de controle da tela\n      this.disableSearchButton = true\n      this.showTreegrid = true\n      startTreeGridLoading(this.gridId)\n\n      // Montando o filtro\n      let filter = {\n        usuarioLogadoResponsavel: this.assignCheck,\n        idUsuarioResponsavel: 0,\n        inicio: this.showDate ? this.dateRange.fromDate : new Date('2000', '01', '01'),\n        fim: this.showDate ? this.dateRange.toDate : new Date(),\n        baseConsulta: this.queryBaseSelected.id,\n        tiposVinculo: typeLinkAux,\n        situacoes: situationListAux,\n        lang: language.getCookieByName('language')\n      }\n\n      trackAnalyticsEvent(this, 'tarefas-date-input', 'data-inicio', filter.inicio)\n      trackAnalyticsEvent(this, 'tarefas-date-input', 'data-fim', filter.fim)\n\n      // Dispara a action que faz a requisição no MS\n      this.$store.dispatch('searchAssignment', filter)\n        .then((response) => {\n          window.DisposeGrids()\n          this.treeGridCfg = response.data.treegrid.Cfg.Layout\n          this.result = response.data.treegrid\n          window.Grids.openAssignmentModal = (row) => {\n            this.prepareGridReactions(row)\n          }\n          stopTreeGridLoading(this.gridId)\n          this.disableSearchButton = false\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n          stopTreeGridLoading(this.gridId)\n          this.disableSearchButton = false\n        })\n\n      if (this.situationFilter.fromDashboard) {\n        this.dateRange.fromDate = new Date()\n        this.dateRange.toDate = new Date()\n        this.queryBaseSelected = this.queryBaseOptions.find(o => o.id === 0)\n      }\n    },\n\n    prepareGridReactions (row) {\n      this.modalId = 'finMovGridModalIdMov-' + row.IdVinculo\n      this.defaultTab = 'gridDetailsModal-tabDetails'\n      // Variáveis utilizadas para controle de qual modal será exibida (MF - Movimento financeiro, CL - Conta lançamento)\n      let obj = {}\n      let funcTrasform = null\n      let funcTabs = null\n\n      // Configuração dos objetos conforme o tipo vinculo\n      if (row && row.TipoVinculo === 'MF') {\n        obj.store = 'getFinancialMovByIdTask'\n        obj.url = '/assignment/getFinancialMovByIdTask'\n        obj.id = row.IdVinculo\n        obj.idTask = row.IdTarefa\n        funcTrasform = generateFinMovFromNode\n        funcTabs = this.generateModalTabsFinMov\n      } else if (row && row.TipoVinculo === 'CL') {\n        obj.store = 'getAccountEntryByIdTask'\n        obj.url = '/assignment/getAccountEntryByIdTask'\n        obj.id = row.IdVinculo\n        obj.idTask = row.IdTarefa\n        funcTrasform = generateAccountEntryFromNode\n        funcTabs = this.generateModalTabsBankStat\n      }\n\n      // Chama a rota correta com os detalhes do lançamento\n      if (obj && obj.id) {\n        this.$store.dispatch(obj.store, obj).then((response) => {\n          let data = null\n          data = response.data\n          if (data) {\n            this.detailsObj = funcTrasform(data)\n            funcTabs()\n            setTimeout(() => {\n              this.showDetailsModal()\n              window.Grids[0].Disable()\n            }, 100)\n          } else {\n            this.detailsObj = {idProcessamento: '-1'}\n            this.generateModalTabTask(obj.idTask.toString())\n            setTimeout(() => {\n              this.showDetailsModal()\n              window.Grids[0].Disable()\n            }, 100)\n          }\n        })\n      }\n    },\n\n    // Método responsável por criar o array de tipo de vinculo a ser enviado para o MS\n    createArrayTypeLinkFilter () {\n      let typeLinkArray = []\n      if (this.typeLinkSelected && this.typeLinkSelected.length > 0) {\n        this.typeLinkSelected.forEach(typeLink => {\n          typeLinkArray.push(typeLink.key)\n        })\n      }\n      return typeLinkArray\n    },\n\n    // Método responsável por criar o array de situações a ser enviado para o MS\n    createArraySituationListFilter () {\n      let situationArray = []\n      if (this.situationList && this.situationList.length > 0) {\n        this.situationList.forEach(situation => {\n          if (situation.checked) {\n            situationArray.push(situation.id)\n          }\n        })\n      }\n      return situationArray\n    },\n\n    // Abre a modal de detalhes\n    showDetailsModal () {\n      trackAnalyticsEvent(this, 'tarefas-open-click', 'open-modal-detalhes-tarefas', 'open-modal-detalhes-tarefas')\n      this.isOpenDetailsModal = true\n    },\n\n    // Fecha a modal de detalhes\n    closeDetailsModal () {\n      this.isOpenDetailsModal = false\n    },\n\n    // Gera as tabs para a modal de movimento financeiro\n    generateModalTabsFinMov () {\n      let tabs = []\n      this.modalDetailsTabs = []\n      // push tab details\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabDetails',\n        idTabContent: 'tab-details-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tadDetailsGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),\n        icon: 'icon=\"tab-icon-font fa fa-info-circle',\n        type: 'TabDetails',\n        props: {\n          establishtmentValue: this.detailsObj.establishtmentValue,\n          mainValuesList: this.detailsObj.mainValuesList,\n          statusValuesList: this.detailsObj.statusValuesList,\n          monetaryValuesList: this.detailsObj.monetaryValuesList,\n          commentary: this.detailsObj.commentary\n        }\n      })\n\n      if (this.detailsObj.idProcessamento) {\n        // push tab details\n        tabs.push({\n          idFunctionalitie: null,\n          idTabRoot: 'gridDetailsModal-tabIntegrations',\n          idTabContent: 'tab-integrations-id',\n          idLanc: this.detailsObj.mainValuesList[0].value,\n          tabRef: 'tadIntegrationGridModal',\n          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),\n          icon: 'tab-icon-font fa fa-share-alt',\n          type: 'TabIntegrations',\n          props: {\n            loadIntegration: this.findIntegration,\n            establishtmentValue: this.detailsObj.establishtmentValue,\n            idProcessamento: this.detailsObj.idProcessamento,\n            integrationValuesList: this.detailsObj.integrationValuesList\n          }\n        })\n      }\n\n      // push tab historic\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabHistoric',\n        idTabContent: 'tab-historic-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tabHisotiricGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),\n        icon: 'tab-icon-font fa fa-hourglass',\n        type: 'TabHistoric',\n        props: {\n          loadHistoric: this.findFinancialMovementHistory,\n          idLancamento: this.detailsObj.mainValuesList[0].value\n        }\n      })\n\n      // push tab allotment\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabAllotment',\n        idTabContent: 'tab-allotment-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tadAllotmentGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabLote'),\n        icon: 'tab-icon-font fa fa-cubes',\n        type: 'TabAllotment',\n        props: {\n          getAllotment: this.findFinancialMovementAllotment,\n          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),\n          tipoMovimento: 'MovFin'\n        }\n      })\n      // push tab tasks\n      tabs.push({\n        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,\n        idTabRoot: 'gridDetailsModal-tabTasks',\n        idTabContent: 'tab-tasks-id',\n        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),\n        tabRef: 'tabTasksGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),\n        icon: 'tab-icon-font fa fa-tasks',\n        type: 'TabTasks',\n        props: {\n          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),\n          tipoMovimento: 'MovFin',\n          statusMovimento: this.detailsObj.concSituation,\n          idTarefa: null\n        }\n      })\n      this.modalTitle = 'modalDetalhesLanc.titulos.titulo'\n      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtitulo'\n      this.modalDetailsTabs = tabs\n    },\n\n    // Gera as tabs para a modal de conta lançamento\n    generateModalTabsBankStat () {\n      let tabs = []\n      this.modalDetailsTabs = []\n      // push tab details\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabDetails',\n        idTabContent: 'tab-details-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tadDetailsGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),\n        icon: 'icon=\"tab-icon-font fa fa-info-circle',\n        type: 'TabDetails',\n        props: {\n          mainValuesList: this.detailsObj.mainValuesList,\n          monetaryValuesList: this.detailsObj.monetaryValuesList\n        }\n      })\n\n      if (this.detailsObj.idProcessamento) {\n        // push tab details\n        tabs.push({\n          idFunctionalitie: null,\n          idTabRoot: 'gridDetailsModal-tabIntegrations',\n          idTabContent: 'tab-integrations-id',\n          idLanc: this.detailsObj.mainValuesList[0].value,\n          tabRef: 'tadIntegrationGridModal',\n          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),\n          icon: 'tab-icon-font fa fa-share-alt',\n          type: 'TabIntegrations',\n          props: {\n            loadIntegration: this.findIntegration,\n            idProcessamento: this.detailsObj.idProcessamento,\n            integrationValuesList: this.detailsObj.integrationValuesList\n          }\n        })\n      }\n\n      // push tab historic\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabHistoric',\n        idTabContent: 'tab-historic-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tabHisotiricGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),\n        icon: 'tab-icon-font fa fa-hourglass',\n        type: 'TabHistoric',\n        props: {\n          loadHistoric: this.findBankStatementHistory,\n          idLancamento: this.detailsObj.mainValuesList[0].value\n        }\n      })\n\n      // push tab tasks\n      tabs.push({\n        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,\n        idTabRoot: 'gridDetailsModal-tabTasks',\n        idTabContent: 'tab-tasks-id',\n        idMovimento: this.detailsObj.mainValuesList[0].value.toString(),\n        tabRef: 'tabTasksGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),\n        icon: 'tab-icon-font fa fa-tasks',\n        type: 'TabTasks',\n        props: {\n          idMovimento: this.detailsObj.mainValuesList[0].value.toString(),\n          tipoMovimento: 'MovBan',\n          idTarefa: null\n        }\n      })\n      this.modalTitle = 'modalDetalhesLanc.titulos.titulo'\n      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtitulo'\n      this.modalDetailsTabs = tabs\n    },\n\n    // Gera as tabs para a modal de conta lançamento\n    generateModalTabTask (idTask) {\n      let tabs = []\n      this.modalDetailsTabs = []\n      // push tab tasks\n      tabs.push({\n        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,\n        idTabRoot: 'gridDetailsModal-tabTask',\n        idTabContent: 'tab-tasks-id',\n        // idMovimento: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tabTasksGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),\n        icon: 'tab-icon-font fa fa-tasks',\n        type: 'TabTasks',\n        props: {\n          idTarefa: idTask,\n          idMovimento: this.detailsObj.idProcessamento.toString()\n        }\n      })\n      this.modalTitle = 'modalDetalhesLanc.titulos.tituloTarefas'\n      this.modalSubTitle = 'modalDetalhesLanc.titulos.subtituloTarefas'\n      this.modalDetailsTabs = tabs\n    },\n\n    findFinancialMovementHistory (id) {\n      let data = {\n        idFinancialMovement: id,\n        url: '/financialMovements/history'\n      }\n      return this.$store.dispatch('getHistoricFinancialMovement', data)\n    },\n\n    findBankStatementHistory (id) {\n      let data = {\n        idBankStat: id,\n        url: '/bankStatement/history'\n      }\n      return this.$store.dispatch('getHistoricBankStat', data)\n    },\n\n    findFinancialMovementAllotment (id) {\n      let data = {\n        idFinancialMovement: id,\n        url: '/assignment/financialMovements/getAllotmentByMovFinId'\n      }\n      return this.$store.dispatch('getAllotmentByMovementId', data)\n    },\n\n    findIntegration (id) {\n      let data = {\n        idProcessamento: id,\n        url: '/assignment/getProcessedFilesById'\n      }\n      return this.$store.dispatch('getProcessedFiles', data)\n    },\n\n    loadModalFromEmailLink (tarefaId) {\n      // Chama a rota correta com os detalhes do lançamento\n      this.$store.dispatch('searchTaskBoundType', tarefaId)\n        .then((response) => {\n          // Evita a exibição de notificação em caso de delay do $router em reagir ao 401\n          if (response.status !== 401) {\n            if (!response.data || response.data === '') {\n              this.$root.$refs.notification.warning('consultaTarefa.labels.tarefaNãoEncontrada')\n            } else if (response.data.cliente !== this.client) {\n              this.$root.$refs.notification.warning('consultaTarefa.labels.tarefaOutroCliente')\n            } else {\n              this.prepareGridReactions(response.data)\n              this.defaultTab = 'gridDetailsModal-tabTasks'\n              this.search()\n            }\n            this.disableSearchButton = false\n          }\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error)\n          this.disableSearchButton = false\n        })\n    },\n\n    // Busca pelas tarefas concluídas\n    searchCompletedTasks () {\n      this.assignCheck = true\n      // Faz a busca\n      this.showTreegrid = true\n      startTreeGridLoading(self.gridId)\n      this.search()\n      // Limpa o filtro do vuex\n      this.$store.dispatch('clearFilterTaskList')\n    },\n\n    // Busca pelas tarefas pendentes e vencidas\n    searchOverdueAndPendingTasks (dateFirstDue) {\n      this.assignCheck = true\n      this.queryBaseSelected = this.queryBaseOptions.find(o => o.id === 2)\n      this.dateRange.fromDate = new Date(dateFirstDue)\n      this.firstDate = this.dateRange.fromDate\n      this.dateRange.toDate = new Date()\n      // Faz a busca\n      this.showTreegrid = true\n      startTreeGridLoading(self.gridId)\n      this.search()\n      // Limpa o filtro do vuex\n      this.$store.dispatch('clearFilterTaskList')\n    }\n  },\n\n  mounted () {\n    this.filteredOriginOptions = [...this.originalOriginOptions]\n    let tarefaId = this.$route.query.tarefa\n    if (tarefaId) {\n      this.loadModalFromEmailLink(tarefaId)\n    }\n    // Listener para evento de atualização de dados dentro da modal de detalhes,\n    // o que requer uma nova consulta para o relatório\n    closeModal.$on('modalDetailsClose', (flag) => {\n      if (flag) {\n        this.showTreegrid = true\n        startTreeGridLoading(this.gridId)\n        this.search()\n        // Altera a flag que recarrega a treegrid após o recarregamento\n        // para impedir que ela seja recarregada sempre após a primeira vez\n        closeModal.$emit('taskChange', false)\n      }\n    })\n\n    if (this.situationFilter && this.situationFilter.type && this.situationFilter.arraySituations && this.situationFilter.arraySituations.length > 0) {\n      // Desmarca todas as situações\n      this.situationList.forEach((sit) => {\n        sit.checked = false\n      })\n\n      // Verifica as situações passadas para marcar como check\n      this.situationFilter.arraySituations.forEach((sitFilter) => {\n        let situation = _.findWhere(this.situationList, { id: sitFilter })\n        situation.checked = true\n      })\n\n      // Monta os filtros e busca conforme a situação passada\n      if (this.situationFilter.type === FiltroSituacaoTarefaEnum.NC) {\n        this.searchOverdueAndPendingTasks(this.situationFilter.dateFirstDue)\n      } else if (this.situationFilter.type === FiltroSituacaoTarefaEnum.C) {\n        this.searchCompletedTasks()\n      }\n    }\n  }\n}\n</script>\n\n<style scoped>\n.date-picker {\n  border: none;\n  height: 36px!important;\n  width: 100px;\n}\n\n.vdp-datepicker {\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding: 11px 8px!important;\n  margin-right: 10px;\n}\n\n.check-atribuidas {\n  font-weight: bold!important;\n}\n\n.spaced-bottom-top {\n  margin-bottom: 10px;\n  margin-top: 5px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1075 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-61521a9e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/PendingConciliations.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.button-addAll {\n  background-color: #40b9bb;\n  border: 1px solid #40b9bb;\n  color: #FFF;\n  font-family: 'Inter', sans-serif;\n  min-width: 40px;\n  text-align: center;\n}\n.button-addAll:hover {\n  background-color: #379d9e;\n  border: 1px solid #379d9e;\n  color: #FFF;\n}\n.icon-button-addAll-right {\n  margin: 2px 5px 0px 0px;\n}\n", "", {"version":3,"sources":["/./client/components/reports/manualConciliation/PendingConciliations.vue?20142633"],"names":[],"mappings":";AAgJA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;CACA;AAEA;EACA,wBAAA;CACA","file":"PendingConciliations.vue","sourcesContent":["<template src=\"./pendingConciliations.pug\" lang=\"pug\"></template>\n\n<script>\nimport TreeGrid from '../../treeGrid/TreeGrid'\nimport { EXPORT_TREEGRID } from '../../../../build/jsonToExcel/exportRoutes.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../utils/grid-load-transition.js'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\n\nexport default {\n  name: 'PendingConciliations',\n\n  components: {\n    TreeGrid\n  },\n\n  props: {\n    resultMov: {\n      type: Object,\n      required: true\n    },\n    resultExt: {\n      type: Object,\n      required: true\n    },\n    treeGridCfgMov: {\n      type: Object,\n      required: false\n    },\n    treeGridCfgExt: {\n      type: Object,\n      required: false\n    },\n    showTreegridMov: {\n      type: Boolean,\n      required: false\n    },\n    showTreegridExt: {\n      type: Boolean,\n      required: false\n    }\n  },\n\n  data () {\n    return {\n      exportUrl: EXPORT_TREEGRID,\n      showHideButtonAddAllMovFin: false,\n      showHideButtonAddAllBankStat: false\n    }\n  },\n\n  methods: {\n    startTreeGridLoading (idGrid, messages) {\n      startTreeGridLoading(idGrid, messages)\n    },\n\n    stopTreeGridLoading (idGrid) {\n      stopTreeGridLoading(idGrid)\n    },\n\n    // Adiciona todos os lançamentos de movimento financeiro selecionados na grid\n    addAllRowsFinMov () {\n      setTimeout(() => {\n        if (window.Grids.ConcManualMovFin && window.Grids.ConcManualMovFin.GetSelRows().length > 0) {\n          window.Grids.ConcManualMovFin.GetSelRows().forEach(row => {\n            if (row.Visible) {\n              row.isTreeGrid = true\n              this.$store.dispatch('setFinMov', row)\n                .then(() => {\n                  window.Grids.ConcManualMovFin.HideRow(row)\n                  this.showHideButtonAddAllMovFin = false\n                }).catch((error) => {\n                  this.$root.$refs.notification.error(this.$t(error.message))\n                })\n            } else {\n              window.Grids.ConcManualMovFin.SelectRow(row)\n            }\n          })\n        } else {\n          this.$root.$refs.notification.warning(this.$t('conciliacaoManual.validacao.selecionarItensMovFin'))\n        }\n        this.$store.dispatch('dataLoaded')\n      }, 100)\n      setTimeout(() => {\n        window.Grids.ConcManualMovFin.RenderBody()\n      }, 150)\n    },\n\n    // Adiciona todos os lançamentos de extrato bancário selecionados na grid\n    addAllRowsBankStat () {\n      setTimeout(() => {\n        if (window.Grids.ConcManualExtBan && window.Grids.ConcManualExtBan.GetSelRows().length > 0) {\n          window.Grids.ConcManualExtBan.GetSelRows().forEach(row => {\n            if (row.Visible) {\n              row.isTreeGrid = true\n              this.$store.dispatch('setBankStat', row)\n                .then(() => {\n                  window.Grids.ConcManualExtBan.HideRow(row)\n                  this.showHideButtonAddAllBankStat = false\n                }).catch((error) => {\n                  this.$root.$refs.notification.error(this.$t(error.message))\n                })\n            } else {\n              window.Grids.ConcManualMovFin.SelectRow(row)\n            }\n          })\n        } else {\n          this.$root.$refs.notification.warning(this.$t('conciliacaoManual.validacao.selecionarItensBankStat'))\n        }\n        this.$store.dispatch('dataLoaded')\n      }, 100)\n      setTimeout(() => {\n        window.Grids.ConcManualExtBan.RenderBody()\n      }, 150)\n    },\n\n    startLoading () {\n      this.$store.dispatch('loadingDataStatic')\n    }\n  },\n\n  mounted () {\n    // Escuta o evento emitido quando se seleciona uma ou todas as linhas da grid de Movimento Financeiro\n    $(document).on('showHideButtonAddAllMovFin', (data, flag) => {\n      this.showHideButtonAddAllMovFin = flag\n    })\n\n    // Escuta o evento emitido quando se seleciona uma ou todas as linhas da grid de Extrato Bancário\n    $(document).on('showHideButtonAddAllBankStat', (data, flag) => {\n      this.showHideButtonAddAllBankStat = flag\n    })\n  },\n\n  beforeUpdate () {\n    if (document.querySelector(\"[aria-controls='#tab-conciliacoes-pendentes']\")) {\n      document.querySelector(\"[aria-controls='#tab-conciliacoes-pendentes']\")\n        .addEventListener('click', () => {\n          trackAnalyticsEvent(this, 'conciliacao-manual', 'click-mudar-de-aba', 'tab-conciliacoes-pendentes')\n        })\n    }\n  }\n}\n</script>\n\n<style>\n.button-addAll {\n  background-color: #40b9bb;\n  border: 1px solid #40b9bb;\n  color: #FFF;\n  font-family: 'Inter', sans-serif;\n  min-width: 40px;\n  text-align: center;\n}\n\n.button-addAll:hover {\n  background-color: #379d9e;\n  border: 1px solid #379d9e;\n  color: #FFF;\n}\n\n.icon-button-addAll-right {\n  margin: 2px 5px 0px 0px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1076 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-632d0eea","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/home/Home.vue ***!
  \*****************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none !important;\n  margin: 0;\n}\ninput[type=number] {\n  -moz-appearance:textfield !important;\n}\na {\n  cursor: pointer\n}\n.table-thead-cursor-pointer{\n  cursor: pointer;\n}\n.table-thead-cursor-pointer tbody tr span {\n  cursor: pointer;\n}\n.modal .modal-header {\n  text-align: center;\n  border-bottom: 0;\n  padding: 10px 25px 10px 25px;\n}\n", "", {"version":3,"sources":["/./client/components/views/home/Home.vue?7ef0e930"],"names":[],"mappings":";AA+BA;;EAEA,yBAAA;EACA,UAAA;CACA;AAEA;;EAEA,oCAAA;EACA,UAAA;CACA;AAEA;EACA,qCAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;CACA","file":"Home.vue","sourcesContent":["<template lang=\"pug\">\n  #home-wrapper\n    top-bar\n    sidebar-menu\n    client-modal(:auto-open='true')\n    my-account-modal\n    change-application-modal\n    router-view\n</template>\n\n<script>\nimport TopBar from '../../layout/menu/TopBar'\nimport SidebarMenu from '../../layout/menu/SidebarMenu'\nimport ClientModal from '../../modals/clientModal/ClientModal'\nimport MyAccountModal from '../../modals/myAccountModal/MyAccountModal'\nimport ChangeApplicationModal from '../../modals/changeApplicationModal/ChangeApplicationModal'\n\nexport default {\n  name: 'Home',\n\n  components: {\n    TopBar,\n    SidebarMenu,\n    ClientModal,\n    MyAccountModal,\n    ChangeApplicationModal\n  }\n}\n</script>\n\n<style>\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none !important;\n  margin: 0;\n}\n\ninput[type=number] {\n  -moz-appearance:textfield !important;\n}\n\na {\n  cursor: pointer\n}\n\n.table-thead-cursor-pointer{\n  cursor: pointer;\n}\n\n.table-thead-cursor-pointer tbody tr span {\n  cursor: pointer;\n}\n\n.modal .modal-header {\n  text-align: center;\n  border-bottom: 0;\n  padding: 10px 25px 10px 25px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1077 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-63472d8e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabClassification/TabClassification.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.grid-modal-content[data-v-63472d8e] {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n.tab-detail-value[data-v-63472d8e] {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #17375f;\n  font-size: 15px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n.detail-title[data-v-63472d8e] {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  margin-top: 1vh;\n  color: #17375f;\n}\n#main-detail-container.main-container[data-v-63472d8e] {\n  max-height: 65vh;\n  overflow: auto;\n}\n.detail-status[data-v-63472d8e] {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  font-size: 3vh;\n}\n.font-C[data-v-63472d8e] {\n  color: #3bb57a;\n}\n.font-D[data-v-63472d8e] {\n  color: #f55753;\n}\n.font-N[data-v-63472d8e] {\n  color: #56a9c1;\n}\n.font-A[data-v-63472d8e] {\n  color: #fdbd39;\n}\n#tab-details-id[data-v-63472d8e] {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n.bordered[data-v-63472d8e] {\n  border: 1px solid  #d0d0d0;\n}\n", "", {"version":3,"sources":["/./client/components/modals/gridDetailsModal/tabClassification/TabClassification.vue?fe067658"],"names":[],"mappings":";AAwRA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iCAAA;CACA;AAEA;EACA,2BAAA;CACA","file":"TabClassification.vue","sourcesContent":["<template src='./tabClassification.pug' lang='pug'></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport axios from '../../../../../build/http-requests/axios-common.js'\nimport customSorter from '../../../../utils/customSorter.js'\n\nexport default {\n  name: 'TabClassification',\n\n  components: {\n    vSelect,\n    ButtonPrimary\n  },\n\n  props: {\n    idModal: {\n      type: String\n    },\n    mainValuesList: {\n      type: Array,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      bankMov: {\n        id: null,\n        situacaoConciliacao: 'A',\n        planoConciliacao: null,\n        categoria: null,\n        estabelecimento: null,\n        contaLancamento: {\n          id: null\n        }\n      },\n      categories: [],\n      establishments: [],\n      conciliationPlans: [],\n      isLoadingData: true,\n      valuesList: []\n    }\n  },\n\n  computed: {\n    titleFormClassif () {\n      return this.$t('modalDetalhesLanc.titulos.tabClassif')\n    },\n\n    conciliationPlansLenght () {\n      return this.conciliationPlans.length <= 1\n    },\n\n    existsConciliationPlans () {\n      return this.conciliationPlans.length !== 0\n    },\n\n    enableRemove () {\n      return this.bankMov.id && this.bankMov.situacaoConciliacao === 'A'\n    },\n\n    defineClassificationLabel () {\n      let label = ''\n      if (this.bankMov.critClassif && this.bankMov.critClassif.toLowerCase() !== this.$t('modalDetalhesLanc.tabClassif.semClassif').toLowerCase()) {\n        label = this.bankMov.critClassif\n      } else {\n        label = this.bankMov.categoria ? this.$t('modalDetalhesLanc.tabClassif.classifManual') : this.$t('modalDetalhesLanc.tabClassif.semClassif')\n      }\n      return label\n    }\n  },\n\n  methods: {\n    closeModal () {\n      $('#' + this.idModal).modal('hide')\n    },\n\n    prepareTab () {\n      this.isLoadingData = true\n      this.bankMov.contaLancamento.id = this.mainValuesList[0].value\n      let critClassif = this.mainValuesList.filter(item => item.title === this.$t('modalDetalhesLanc.tabClassif.critClassif'))\n      let labelClassif = critClassif && critClassif.length > 0 ? critClassif[0].value : null\n      this.valuesList = this.mainValuesList.filter(item => item.title !== this.$t('modalDetalhesLanc.tabClassif.critClassif'))\n\n      return new Promise((resolve, reject) => {\n        axios.get('/bankStatement/getBankMovmentByIdBankStatment', { params: { idContaLancamento: this.mainValuesList[0].value } }).then((responseMov) => {\n          this.bankMov = responseMov.data.data\n          if (!this.bankMov) {\n            this.bankMov = {\n              id: null,\n              situacaoConciliacao: 'A',\n              planoConciliacao: null,\n              categoria: null,\n              estabelecimento: null,\n              contaLancamento: {\n                id: this.mainValuesList[0].value\n              }\n            }\n          }\n          this.bankMov.critClassif = labelClassif\n\n          if (this.bankMov.planoConciliacao) {\n            this.bankMov.planoConciliacao.label = this.bankMov.planoConciliacao.nome\n          }\n\n          if (this.bankMov.categoria) {\n            this.bankMov.categoria.label = this.bankMov.categoria.numero + ' - ' + this.bankMov.categoria.nome\n          }\n\n          if (this.bankMov.estabelecimento) {\n            this.bankMov.estabelecimento.label = this.bankMov.estabelecimento.nome + ' - ' + this.bankMov.estabelecimento.cnpj\n            this.establishments.push(this.bankMov.estabelecimento)\n          }\n\n          this.$store.dispatch('getPlans', '/conciliationPlan/listCategorized').then((responsePlan) => {\n            this.conciliationPlans = responsePlan.data\n            this.conciliationPlans = this.conciliationPlans.map(plan => {\n              plan.label = plan.planName\n              return plan\n            })\n            this.bankMov.planoConciliacao = this.conciliationPlans[0]\n\n            this.$store.dispatch('getCategories', {\n              url: '/bankStatement/loadCategories',\n              flTipoCategoria: null,\n              validarUso: false\n            }).then((responseCat) => {\n              let catArray = []\n              responseCat.data.forEach(cat => {\n                cat.label = cat.numero + ' - ' + cat.nome\n                catArray.push(cat)\n              })\n              // arrayDottedSorter ordena o array baseado em valores do tipo '1.1.1'\n              this.categories = customSorter.arrayDottedSorter(catArray, 'numero', 'asc')\n              this.isLoadingData = false\n            }).catch((errorCat) => {\n              this.$root.$refs.notification.error(errorCat.data.message)\n              this.isLoadingData = false\n            })\n          }).catch((errorPlan) => {\n            this.$root.$refs.notification.error(errorPlan.data.message)\n            this.isLoadingData = false\n          })\n          resolve()\n        }).catch((errorMov) => {\n          this.$root.$refs.notification.error(errorMov)\n          this.isLoadingData = false\n          reject()\n        })\n      })\n    },\n\n    loadEstablishments (search = []) {\n      if (search.length) {\n        const filters = this.mountFilters({\n          ascending: 1,\n          orderBy: 'nome',\n          page: 1,\n          limit: 5,\n          query: {\n            nome: search\n          }\n        })\n\n        this.$store.dispatch('getEstablishments', filters)\n          .then((response) => {\n            if (response.elements.length === 0) {\n              this.establishments = []\n            } else {\n              this.establishments = response.elements\n            }\n          })\n          .catch((error) => {\n            this.establishments = []\n            this.$root.$refs.notification.error(error.message)\n          })\n      }\n    },\n\n    mountFilters (pagination) {\n      const filters = {}\n      const atributosValores = []\n      for (const key in pagination.query) {\n        filters[key] = pagination.query[key]\n      }\n      return {\n        atributosValores,\n        filters,\n        ...pagination,\n        url: 'establishment/list'\n      }\n    },\n\n    handleClearList () {\n      this.establishments = []\n    },\n\n    bindConciliationPlan (plan) {\n      if (plan) {\n        this.bankMov.planoConciliacao = plan\n        this.errors.remove('bankMov.planoConciliacao')\n      }\n    },\n\n    validate () {\n      this.isLoadingData = true\n      let self = this\n      let promise = null\n      return new Promise(resolve => {\n        self.$validator.validateAll().then((result) => {\n          if (result) {\n            promise = self.createClassification()\n            promise.finally(() => {\n              resolve()\n            })\n          } else {\n            this.isLoadingData = false\n          }\n        })\n      })\n    },\n\n    createClassification () {\n      return new Promise((resolve, reject) => {\n        axios.post('/bankStatement/saveBankMovment', this.bankMov).then((response) => {\n          this.$root.$refs.notification.success(this.enableRemove ? 'movbancaria.sucesso.atualizar' : 'movbancaria.sucesso.salvar')\n          this.bankMov = response.data.data\n          if (this.bankMov.planoConciliacao) {\n            this.bankMov.planoConciliacao.label = this.bankMov.planoConciliacao.nome\n          }\n          if (this.bankMov.categoria) {\n            this.bankMov.categoria.label = this.bankMov.categoria.numero + ' - ' + this.bankMov.categoria.nome\n          }\n          if (this.bankMov.estabelecimento) {\n            this.bankMov.estabelecimento.label = this.bankMov.estabelecimento.nome + ' - ' + this.bankMov.estabelecimento.cnpj\n            this.establishments = []\n            this.establishments.push(this.bankMov.estabelecimento)\n          }\n          this.isLoadingData = false\n          resolve()\n        }).catch((errorMov) => {\n          this.$root.$refs.notification.error(errorMov)\n          this.isLoadingData = false\n          reject()\n        })\n      })\n    },\n\n    remove () {\n      this.isLoadingData = true\n      return new Promise((resolve, reject) => {\n        axios.delete('/bankStatement/deleteBankMovment', { params: { idMovBancario: this.bankMov.id } }).then((response) => {\n          this.$root.$refs.notification.success('movbancaria.sucesso.remover')\n          this.bankMov = {\n            id: null,\n            situacaoConciliacao: 'A',\n            planoConciliacao: this.conciliationPlans[0],\n            categoria: null,\n            estabelecimento: null,\n            contaLancamento: {\n              id: this.mainValuesList[0].value\n            }\n          }\n\n          this.isLoadingData = false\n          resolve()\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n          this.isLoadingData = false\n          reject()\n        })\n      })\n    }\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.grid-modal-content {\n  padding: 5px 10px 0px 10px;\n  min-height: 47vh;\n  min-width: 47vw;\n}\n\n.tab-detail-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  color: #17375f;\n  font-size: 15px;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n\n.detail-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  margin-top: 1vh;\n  color: #17375f;\n}\n\n#main-detail-container.main-container {\n  max-height: 65vh;\n  overflow: auto;\n}\n\n.detail-status {\n  font-family: 'Inter', sans-serif;\n  font-weight: bold;\n  font-size: 3vh;\n}\n\n.font-C {\n  color: #3bb57a;\n}\n\n.font-D {\n  color: #f55753;\n}\n\n.font-N {\n  color: #56a9c1;\n}\n\n.font-A {\n  color: #fdbd39;\n}\n\n#tab-details-id {\n  margin: 0px;\n  overflow: hidden;\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n\n.bordered {\n  border: 1px solid  #d0d0d0;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1078 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-648087e0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/categories/List.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.clear {\n  clear: both;\n}\n#categories {\n  margin-top: 15px;\n}\n.categories-header {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #223763;\n  color: #FFF;\n  height: 30px;\n  padding: 5px 15px;\n  font-size: 14px;\n  border-radius: 12px 12px 0px 0px;\n}\n.categories-header-acoes-tit {\n  float:right;\n  width: 86px;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n.categories-header-column-left {\n  padding-left: 0px;\n  margin-left: 18px;\n  margin-right: 6px;\n}\n.categories-type {\n  margin-left: 3px;\n}\n.categories-initial-balance {\n  text-align: right;\n}\n.categories-initial-balance-date {\n  text-align: right;\n}\n.actions {\n  text-align: center;\n}\n.action {\n  text-align: center;\n  background-color: transparent !important;\n  border: none !important;\n  margin: 0 5px 0 5px;\n}\n.action:hover {\n  border: none !important;\n}\n.action:disabled {\n  cursor: not-allowed;\n}\n.isLoadingDataGeneral {\n  background: url(" + __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67) + ") 50% 50% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.8;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  transition: all 5s ease-in-out;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/categories/List.vue?08306c9e"],"names":[],"mappings":";AA4JA;EACA,YAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;CACA;AAEA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;CACA;AAEA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,mBAAA;EACA,yCAAA;EACA,wBAAA;EACA,oBAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,4DAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAKA,+BAAA;CACA","file":"List.vue","sourcesContent":["<template src='./list.pug' lang='pug'></template>\n\n<script>\nimport _ from 'underscore'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport VueDragTree from '../../../registration/categories/TreeviewCategories'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport CategorieModal from '../../../registration/categories/CategorieModal'\nimport ConfirmModal from '../../../modals/confirmModal/ConfirmModal'\nimport customSorter from '../../../../utils/customSorter.js'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\n\nexport default {\n  name: 'CategoriesList',\n\n  components: {\n    PageTitle,\n    VueDragTree,\n    ButtonPrimary,\n    CategorieModal,\n    ConfirmModal\n  },\n\n  data () {\n    return {\n      categories: [],\n      treeViewButtonTitle: {\n        edit: this.$t('categoria.labels.editar'),\n        create: this.$t('categoria.labels.criar'),\n        expand: this.$t('categoria.labels.expandir'),\n        collapse: this.$t('categoria.labels.recolher'),\n        remove: this.$t('categoria.labels.remover'),\n        removeBloq: this.$t('categoria.labels.removerBloqueado')\n      },\n      lastOrder: null,\n      shown: false,\n      idEditingCategory: null,\n      lastCategoryOrder: 0,\n      parentCategory: null,\n      categoryIdToRemove: null,\n      requestSentRemove: false\n    }\n  },\n\n  computed: {\n    isLoadingDataGeneral () {\n      return this.$store.getters.isLoadingData\n    }\n  },\n\n  watch: {\n    shown () {\n      if (!this.shown) {\n        this.loadCategories()\n      }\n    }\n  },\n\n  methods: {\n    // Método chamando nos botões do componente Treeview\n    createEditCategory (categoryId, parentCategory, isEdit) {\n      if (isEdit) {\n        this.idEditingCategory = categoryId\n      } else {\n        this.parentCategory = parentCategory\n        this.idEditingCategory = null\n      }\n      this.newCategory(categoryId, parentCategory)\n      this.shown = true\n    },\n\n    getLastCategoryOrder (category) {\n      if (!category) {\n        return 0\n      }\n      if (category && category.children && category.children.length > 0) {\n        return this.getLastCategoryOrder(category.children[category.children.length - 1])\n      }\n\n      return category.order\n    },\n\n    // Método que cria uma nova categoria\n    newCategory (categoryId, parentCategory) {\n      let lastCategory = _.last(this.categories)\n\n      if (categoryId && parentCategory) {\n        lastCategory = _.last(parentCategory.children)\n      }\n\n      this.lastCategoryOrder = this.getLastCategoryOrder(lastCategory)\n    },\n\n    // Carrega a listagem de categorias\n    loadCategories () {\n      this.$store.dispatch('loadingData').then(() => {\n        this.$store.dispatch('getCategories', {\n          url: '/categories/',\n          flTipoCategoria: null,\n          validarUso: true\n        })\n        .then((response) => {\n          this.categories = response.data\n          this.categories.forEach(cat => {\n            if (cat.children && cat.children.length > 0) {\n              cat.children = customSorter.arrayDottedSorter(cat.children, 'number', 'asc')\n            }\n          })\n          this.$store.commit('SET_CATEGORIES_QTY', this.categories.length)\n          this.$store.dispatch('dataLoaded')\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.data.message)\n          this.$store.dispatch('dataLoaded')\n        })\n      })\n    },\n\n    handleRemove (categoryIdToRemove) {\n      this.categoryIdToRemove = categoryIdToRemove\n      $('#confirmRemoveCategory').modal('show')\n    },\n\n    removeCategory () {\n      trackAnalyticsEvent(this, 'remove-click', 'remove-categoria', 'remove-categoria')\n      if (this.categoryIdToRemove) {\n        this.requestSentRemove = true\n        this.$store.dispatch('removeCategorie', this.categoryIdToRemove)\n          .then((response) => {\n            this.$root.$refs.notification.success('categoria.sucesso.remover')\n            this.categoryIdToRemove = null\n            $('#confirmRemoveCategory').modal('hide')\n            this.loadCategories()\n          })\n          .catch((error) => {\n            this.$root.$refs.notification.error(error.message)\n          })\n          .finally(() => {\n            this.requestSentRemove = false\n          })\n      }\n    },\n\n    closeModalConfirm () {\n      this.categoryIdToRemove = null\n      $('#confirmRemoveCategory').modal('hide')\n    }\n  },\n\n  created () {\n    this.loadCategories()\n  }\n}\n</script>\n\n<style>\n.clear {\n  clear: both;\n}\n\n#categories {\n  margin-top: 15px;\n}\n\n.categories-header {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #223763;\n  color: #FFF;\n  height: 30px;\n  padding: 5px 15px;\n  font-size: 14px;\n  border-radius: 12px 12px 0px 0px;\n}\n\n.categories-header-acoes-tit {\n  float:right;\n  width: 86px;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n\n.categories-header-column-left {\n  padding-left: 0px;\n  margin-left: 18px;\n  margin-right: 6px;\n}\n\n.categories-type {\n  margin-left: 3px;\n}\n\n.categories-initial-balance {\n  text-align: right;\n}\n\n.categories-initial-balance-date {\n  text-align: right;\n}\n\n.actions {\n  text-align: center;\n}\n\n.action {\n  text-align: center;\n  background-color: transparent !important;\n  border: none !important;\n  margin: 0 5px 0 5px;\n}\n\n.action:hover {\n  border: none !important;\n}\n\n.action:disabled {\n  cursor: not-allowed;\n}\n\n.isLoadingDataGeneral {\n  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.8;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  -webkit-transition: all 5s ease-in-out;\n  -moz-transition: all 5s ease-in-out;\n  -ms-transition: all 5s ease-in-out;\n  -o-transition: all 5s ease-in-out;\n  transition: all 5s ease-in-out;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1079 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-65d81ebc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/bankStatement/BankStatement.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.input-button>button[data-v-65d81ebc] {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n#logDeAuditoriaWrapper[data-v-65d81ebc] {\n  width: 100%;\n}\n#divTreeGridAuditoria[data-v-65d81ebc] {\n  min-width: 100%;\n  min-height: 500px;\n}\n.check[data-v-65d81ebc] {\n  text-align: center;\n}\n.filterButton[data-v-65d81ebc] {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search[data-v-65d81ebc] {\n  width: 53.5%;\n}\n.search-button[data-v-65d81ebc] {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/views/reports/bankStatement/BankStatement.vue?751fd19c"],"names":[],"mappings":";AAqeA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA","file":"BankStatement.vue","sourcesContent":["<template src='./bankStatement.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'\nimport MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport BetterInputTag from '../../../input/betterInputTag/BetterInputTag'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport axios from '../../../../../build/http-requests/axios-common.js'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\nimport { generateBankStatFromRow } from '../../../../utils/transformationData.js'\nimport closeModal from '../../../../events/closeModal'\nimport FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'\n\nexport default {\n  name: 'BankStatement',\n\n  components: {\n    GridDetailsModal,\n    MultiSelectModal,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    BetterInputTag,\n    ButtonPrimary,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      groupingOptions: {\n        prop: 'grupo.id',\n        groupIdProp: 'id',\n        headerNameProp: 'nome',\n        defaultIdGroup: '0'\n      },\n      groups: [],\n      titleModal: this.$t('extratoBancario.labels.contasBancarias'),\n      subTitleModal: this.$t('extratoBancario.labels.selecionarContasBancarias'),\n      gridId: '#ExtratoConta',\n      BANK_ACCOUNT_MODAL: 'bankAccountsModal',\n      audit: {},\n      dateRange: {},\n      itensSelected: [],\n      list: [],\n      selectedList: [],\n      selectModal: null,\n      allItensSelected: null,\n      bankAccountsSelected: [],\n      bankAccountsTags: [this.$t('inputTag.labels.todos')],\n      firstDate: new Date(),\n      finalDate: new Date(),\n      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      filter: {\n        entityId: null\n      },\n      result: {},\n      treeGridFileName: 'ExtratoBancario',\n      error: false,\n      msgError: '',\n      dataTableColumns: [],\n      disableSearchButton: false,\n      detailsObj: {\n        mainValuesList: [],\n        monetaryValuesList: [],\n        integrationValuesList: [],\n        classificationValuesList: [],\n        idProcessamento: -1\n      },\n      bankStatGridModalId: '',\n      isOpenDetailsModal: false,\n      columnsClasses: {},\n      orderBy: {},\n      headings: {},\n      templates: {},\n      customSorting: {},\n      sortable: [],\n      firstTime: true,\n      modalDetailsTabs: [],\n      filterable: ['nome'],\n      showCustomColumns: false,\n      treeGridCfg: {},\n      isExportFile: false,\n      inputTagsProps: {\n        bankAccounts: {\n          id: 'id',\n          name: 'nome'\n        }\n      },\n      shown: {\n        bankAccounts: false\n      },\n      defaultTags: {\n        bankAccounts: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todos')\n        }]\n      },\n      data: {\n        bankAccounts: {\n          titles: {\n            main: this.$t('extratoBancario.labels.contasBancarias'),\n            sub: this.$t('extratoBancario.labels.selecionarContasBancarias')\n          },\n          allBankAccounts: [],\n          showToggleInactiveAccounts: false,\n          selectedItems: [],\n          considerInactiveAccounts: false,\n          columns: ['nome', 'banco', 'numAgencia', 'conta'],\n          values: [],\n          options: {\n            columnsClasses: { nome: 'col-md-3', banco: 'col-md-4', numAgencia: 'col-md-2', conta: 'col-md-3' },\n            perPage: 5,\n            headings: {\n              nome: this.$t('contaBancaria.labels.nome'),\n              banco: this.$t('contaBancaria.labels.banco'),\n              numAgencia: this.$t('contaBancaria.labels.agencia'),\n              conta: this.$t('contaBancaria.labels.numeroConta')\n            },\n            filterable: ['nome', 'banco', 'numAgencia', 'conta'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['nome', 'banco', 'numAgencia', 'conta'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'nome'\n            },\n            customSorting: {\n              nome: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                  }\n                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n                }\n              },\n              banco: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.banco.codigo <= b.banco.codigo ? 1 : -1\n                  }\n                  return a.banco.codigo >= b.banco.codigo ? 1 : -1\n                }\n              },\n              agencia: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.numAgencia <= b.numAgencia\n                  }\n                  return a.numAgencia >= b.numAgencia\n                }\n              },\n              conta: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return +a.conta >= +b.conta ? 1 : -1\n                  }\n                  return +a.conta <= +b.conta ? 1 : -1\n                }\n              }\n            },\n            templates: {\n              nome: (h, row) => {\n                let txt = row.nome\n                if (!row.ativo) {\n                  txt += ' (' + this.$t('contaBancaria.labels.inativa') + ')'\n                }\n                return txt\n              },\n              banco: (h, row) => {\n                if (row.banco) {\n                  return row.banco.codigo + '-' + row.banco.nome\n                }\n                return '-'\n              },\n              agencia: (h, row) => {\n                let txt = '-'\n                if (row.agencia) {\n                  txt = row.numAgencia\n                  if (row.digAgencia) {\n                    txt += '-' + row.digAgencia\n                  }\n                }\n                return txt\n              },\n              conta: (h, row) => {\n                let txt = row.conta\n                if (row.digConta) {\n                  txt += '-' + row.digConta\n                }\n                return txt\n              }\n            }\n          }\n        }\n      },\n      queryNotClassif: true,\n      queryOnlyClassif: true\n    }\n  },\n\n  methods: {\n    getLoadingMessages () {\n      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']\n    },\n\n    validate () {\n      let self = this\n      let promise = null\n      return new Promise(resolve => {\n        self.$validator.validateAll().then((result) => {\n          if (result && this.$refs.dateRange.validate()) {\n            if (self.isExportFile) {\n              promise = self.download()\n            } else {\n              self.showTreegrid = true\n              startTreeGridLoading(self.gridId, self.getLoadingMessages())\n              promise = self.search()\n            }\n            promise.finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    mountFilters () {\n      this.disableSearchButton = true\n      let filter = {\n        inicio: this.dateRange.fromDate,\n        fim: this.dateRange.toDate,\n        idsContas: this.data.bankAccounts.selectedItems.map(selected => selected.id).filter(account => account !== '-1'),\n        considerarContasInativas: this.data.bankAccounts.considerInactiveAccounts,\n        lang: language.getCookieByName('language'),\n        considerarClassificacao: this.queryNotClassif && !this.queryOnlyClassif ? 0 // consulta apenas nao classificados\n          : (\n            !this.queryNotClassif && this.queryOnlyClassif ? 1 // consulta apenas classificados\n            : 2 // default consulta por todos\n          )\n      }\n      return filter\n    },\n\n    download () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchBankStatementToFile', { filter: this.mountFilters() })\n        .then(() => {\n          this.disableSearchButton = false\n          resolve()\n        }).catch((error) => {\n          this.error = true\n          this.msgError = error.body\n          this.$root.$refs.notification.error('GENERAL')\n          this.disableSearchButton = false\n          reject()\n        })\n      })\n    },\n\n    search () {\n      return new Promise((resolve, reject) => {\n        axios.post('/bankStatement/', { filter: this.mountFilters() }).then((response) => {\n          response.data.Body.forEach(e => {\n            e._isVue = true\n          })\n          if (window.Grids[0]) {\n            window.DisposeGrids()\n          }\n          this.result = response.data\n          response.data.Body.forEach(bodyList => {\n            bodyList.forEach(item => {\n              if (item.NomeEstabelecimentoGrupo === '') {\n                item.NomeEstabelecimentoGrupo = this.$t('contaBancaria.labels.semGrupo')\n              }\n              if (item.CritClassif === '') {\n                item.CritClassif = this.$t('extratoBancario.labels.naoClassificado')\n              }\n            })\n          })\n          this.treeGridCfg = this.result && this.result.Cfg ? this.result.Cfg.Layout : {}\n          // Quando a resposta nao possuir saldo anterior, altera a configuracao da treegrid para exibir a mensagem correta.\n          if (this.result && this.result.Solid[0]) {\n            const valorAnterior = this.result.Solid[0].VlSaldoAnterior\n            if (valorAnterior == null) {\n              this.treeGridCfg.Solid[2].DsHistorico = this.$t('extratoBancario.labels.saldoVazio').replace('{DIA_ANTERIOR}', moment(this.result.Solid[0].DtLanc).format('DD/MM/YYYY'))\n              this.treeGridCfg.Solid[2].Cells = 'DsHistorico'\n            } else {\n              this.treeGridCfg.Solid[2].DsHistorico = this.treeGridCfg.Solid[2].DsHistorico.replace('{DIA_ANTERIOR}', moment(this.result.Solid[0].DtLanc).format('DD/MM/YYYY'))\n            }\n          }\n          this.showTreegrid = true\n          window.Grids.abrirModalDetalhes = (row) => {\n            this.bankStatGridModalId = 'bankStatGridModalIdMov-' + row.IdLancamento\n            trackAnalyticsEvent(this, 'row-click', 'extrato-bancario-grid-details', row.IdLancamento)\n            this.detailsObj = generateBankStatFromRow(row)\n            this.generateModalTabs()\n            setTimeout(() => {\n              this.showDetailsModal()\n              window.Grids[0].Disable()\n            }, 100)\n          }\n          this.showTreegrid = true\n          stopTreeGridLoading(this.gridId)\n\n          if (!this.queryNotClassif && this.queryOnlyClassif) { // Caso consulta seja apenas por lancamentos classificados, aplica agrupamento especifico\n            setTimeout(() => {\n              window.Grids[0].DoGrouping('CritClassif,NomeCategoria,DtLanc,Banco,NrConta,DsHistorico')\n            }, 300)\n          }\n          this.disableSearchButton = false\n          resolve()\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n          stopTreeGridLoading(this.gridId)\n          this.disableSearchButton = false\n          reject()\n        })\n      })\n    },\n\n    async openSelectBankAccountsModal () {\n      if (this.data.bankAccounts.values.length > 0) {\n        this.shown.bankAccounts = true\n        return\n      }\n      const bankAccounts = await this.$store.dispatch('getBankAccounts', '/bankStatement/bankAccounts/list')\n      this.data.bankAccounts.allBankAccounts = bankAccounts.data.data\n      this.data.bankAccounts.showToggleInactiveAccounts = this.data.bankAccounts.allBankAccounts.find((bankAccount) => {\n        return !bankAccount.ativo\n      })\n      this.data.bankAccounts.values = this.data.bankAccounts.allBankAccounts.filter((bankAccount) => {\n        return bankAccount.ativo\n      })\n      const groups = await this.$store.dispatch('getEstablishmentGroups')\n      this.groups = groups\n      this.groups.push({\n        id: 0,\n        nome: this.$t('contaBancaria.labels.semGrupo')\n      })\n      this.shown.bankAccounts = true\n    },\n\n    showDetailsModal () {\n      this.isOpenDetailsModal = true\n    },\n\n    closeDetailsModal () {\n      this.isOpenDetailsModal = false\n    },\n\n    closeModal () {\n      this.shown.bankAccounts = false\n    },\n\n    generateModalTabs () {\n      let tabs = []\n      // push tab details\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabDetails',\n        idTabContent: 'tab-details-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tadDetailsGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),\n        icon: 'icon=\"tab-icon-font fa fa-info-circle',\n        type: 'TabDetails',\n        props: {\n          mainValuesList: this.detailsObj.mainValuesList,\n          monetaryValuesList: this.detailsObj.monetaryValuesList\n        }\n      })\n\n      // push tab classification\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabClassification',\n        idTabContent: 'tab-classification-id',\n        idMovimento: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tabClassificationGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabClassif'),\n        icon: 'tab-icon-font fa fa-handshake-o',\n        type: 'TabClassification',\n        props: {\n          mainValuesList: this.detailsObj.classificationValuesList\n        }\n      })\n\n      if (this.detailsObj.idProcessamento) {\n        // push tab Integrations\n        tabs.push({\n          idFunctionalitie: null,\n          idTabRoot: 'gridDetailsModal-tabIntegrations',\n          idTabContent: 'tab-integrations-id',\n          idLanc: this.detailsObj.mainValuesList[0].value,\n          tabRef: 'tadIntegrationGridModal',\n          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),\n          icon: 'tab-icon-font fa fa-share-alt',\n          type: 'TabIntegrations',\n          props: {\n            loadIntegration: this.findIntegration,\n            idProcessamento: this.detailsObj.idProcessamento,\n            integrationValuesList: this.detailsObj.integrationValuesList\n          }\n        })\n      }\n\n      // push tab tasks\n      tabs.push({\n        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,\n        idTabRoot: 'gridDetailsModal-tabTasks',\n        idTabContent: 'tab-tasks-id',\n        idMovimento: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tabTasksGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),\n        icon: 'tab-icon-font fa fa-tasks',\n        type: 'TabTasks',\n        props: {\n          idMovimento: this.detailsObj.mainValuesList[0].value,\n          tipoMovimento: 'MovBan'\n        }\n      })\n\n      this.modalDetailsTabs = tabs\n    },\n\n    findBankStatementHistory (id) {\n      let data = {\n        idBankStat: id,\n        url: '/bankStatement/history'\n      }\n      return this.$store.dispatch('getHistoricBankStat', data)\n    },\n\n    findIntegration (id) {\n      let data = {\n        idProcessamento: id,\n        url: '/processedFiles/getProcessedFilesById'\n      }\n      return this.$store.dispatch('getProcessedFiles', data)\n    }\n  },\n\n  mounted () {\n    // Listener para evento de atualização de dados dentro da modal de detalhes,\n    // o que requer uma nova consulta para o relatório\n    const self = this\n    closeModal.$on('modalDetaisClose', (flag) => {\n      if (flag) {\n        self.showTreegrid = true\n        startTreeGridLoading(self.gridId, self.getLoadingMessages())\n        self.search()\n        // Altera a flag que recarrega a treegrid após o recarregamento\n        // para impedir que ela seja recarregada sempre após a primeira vez\n        closeModal.$emit('taskChange', false)\n      }\n    })\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.check {\n  text-align: center;\n}\n\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search {\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1080 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-65f48b0a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/filter/FilterCommon.vue ***!
  \******************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.filter-common[data-v-65f48b0a] {\n  min-width: 50px;\n  margin-right: 10px;\n}\n.filter-common-selected[data-v-65f48b0a] {\n  margin: 4px 0px 0px 4px;\n  padding: 1px 0px;\n  line-height: 27px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row nowrap;\n      flex-flow: row nowrap;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n.filter-common-selected > .filter-common-selected-text[data-v-65f48b0a] {\n  transition: 0.1s;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.filter-common.closed > .filter-common-selected > .filter-common-selected-text[data-v-65f48b0a] {\n  opacity: 1;\n}\n.filter-common.open > .filter-common-selected > .filter-common-selected-text[data-v-65f48b0a] {\n  opacity: 0.5;\n}\n.filter-common-arrow[data-v-65f48b0a] {\n  background-image: url(" + __webpack_require__(/*! ../../../assets/icones_app/arrow.svg */ 1135) + ");\n  background-repeat: no-repeat;\n  height: 10px;\n  min-width: 17px;\n  margin-left: 7px;\n  margin-top: 8px;\n  transition: 0.15s;\n}\n.filter-common.open > .filter-common-selected > .filter-common-arrow[data-v-65f48b0a] {\n  -ms-transform: rotate(180deg);\n      transform: rotate(180deg);\n}\n.filter-common-list[data-v-65f48b0a] {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, .26);\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-top: none;\n  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, .15);\n  margin-top: 3px;\n  position: absolute;\n  z-index: 700!important;\n  max-height: 400px;\n  overflow: auto;\n  white-space: nowrap;\n}\n.filter-common-list-item[data-v-65f48b0a] {\n  color: #000000;\n  padding: 5px 15px 5px 15px;\n  transition: 0.1s;\n}\n.filter-common-list-item[data-v-65f48b0a]:hover, .filter-group-list-item[data-v-65f48b0a]:hover {\n  background-color: #5897fb;\n  color: #ffffff;\n}\n.disabled[data-v-65f48b0a] {\n  cursor: not-allowed;\n}\n.magin-small[data-v-65f48b0a]{\n  margin: 5px 10px 10px;\n}\n.group-title[data-v-65f48b0a] {\n  color: #1A3B5F;\n  font-weight: bold;\n  padding: 10px 15px 5px 15px;\n  transition: 0.1s;\n}\n.filter-group-list-item[data-v-65f48b0a] {\n  color: #000000;\n  padding: 5px 15px 5px 25px;\n  transition: 0.1s;\n}\n", "", {"version":3,"sources":["/./client/components/dashboard/filter/FilterCommon.vue?0ddf26ce"],"names":[],"mappings":";AAwIA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,sBAAA;EACA,mBAAA;MAAA,eAAA;CACA;AAEA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,wBAAA;CACA;AAEA;EACA,WAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,gDAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,8BAAA;MAAA,0BAAA;CACA;AAEA;EACA,0BAAA;EACA,qCAAA;EACA,+BAAA;EACA,gCAAA;EACA,iBAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;CACA;AAEA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;CACA;AAEA;EACA,0BAAA;EACA,eAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,iBAAA;CACA;AAEA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;CACA","file":"FilterCommon.vue","sourcesContent":["<template src=\"./filterCommon.pug\" lang=\"pug\"></template>\n\n<script>\nexport default {\n  name: 'FiltersCommon',\n\n  props: {\n    options: {\n      type: Array,\n      required: true\n    },\n    onChange: {\n      type: Function,\n      required: true\n    },\n    quantity: {\n      type: Number,\n      required: true\n    },\n    hasGroups: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      hasData: false,\n      shown: false,\n      selected: {},\n      disabled: false,\n      disabledText: this.$t('dashboard.filtro.semOpcoes'),\n      element: null,\n      selectedTextElement: null\n    }\n  },\n\n  methods: {\n    select (selected) {\n      selected.__selected = true\n      this.selected.__selected = false\n      this.selected = selected\n      this.onChange(selected)\n      this.close()\n    },\n\n    getDisplayOptions (group) {\n      if (group) {\n        return group.options.filter(option => !option.__selected).sort()\n      }\n      return this.options.filter(option => !option.__selected).sort()\n    },\n\n    getSelected () {\n      let selected\n\n      if (this.hasGroups) {\n        for (const group of this.options) {\n          if (group.__selected) {\n            selected = group.options.find(option => option.__selected)\n            break\n          }\n        }\n\n        if (!selected) {\n          selected = this.options.find(group => group.default).options[0]\n        }\n      } else {\n        selected = this.options.find(option => option.__selected) || this.options[0]\n      }\n\n      selected.__selected = true\n      this.onChange(selected)\n      return selected\n    },\n\n    getTitle (label) {\n      const title = this.disabled ? this.disabledText : label\n\n      if (!this.element) {\n        return title\n      }\n\n      if (!this.selectedTextElement) {\n        const span = this.element.getElementsByClassName('filter-common-selected-text')\n        if (!span) {\n          return title\n        }\n        this.selectedTextElement = span[0]\n      }\n\n      if (this.selectedTextElement.offsetWidth < this.selectedTextElement.scrollWidth) {\n        if (this.disabled) {\n          return label + '\\n\\n' + title\n        }\n        return title\n      }\n\n      return this.disabled ? this.disabledText : ''\n    },\n\n    toggle () {\n      if (!this.disabled) {\n        this.shown = !this.shown\n      }\n    },\n\n    close () {\n      this.shown = false\n    }\n  },\n\n  mounted () {\n    this.element = this.$el\n    /**\n     * É feito o seguinte cálculo para limitar o tamanho máximo de filtro do gadget:\n     * ⌊Tamanho da barra ÷ Quantidade de filtros⌋ - Offset\n     * Onde:\n     * - Tamanho da barra: 100% em referência ao elemento pai, que no caso é o .filters-common;\n     * - Quantidade de filtros: quantidade de filtros que esse gadget possui;\n     * - Offset: uma constante de 15px em relação a extrema direita do menu para poder ter um espaço para o botão de fechar o gadget.\n     **/\n    this.element.style.maxWidth = `calc(${Math.floor(100 / this.quantity)}% - 15px)`\n  },\n\n  created () {\n    if (this.options.length > 0) {\n      this.selected = this.getSelected()\n      this.hasData = true\n    }\n    this.disabled = this.options.length === 1\n  }\n}\n</script>\n\n<style scoped>\n.filter-common {\n  min-width: 50px;\n  margin-right: 10px;\n}\n\n.filter-common-selected {\n  margin: 4px 0px 0px 4px;\n  padding: 1px 0px;\n  line-height: 27px;\n  display: flex;\n  flex-flow: row nowrap;\n  flex: 1 1 auto;\n}\n\n.filter-common-selected > .filter-common-selected-text {\n  transition: 0.1s;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.filter-common.closed > .filter-common-selected > .filter-common-selected-text {\n  opacity: 1;\n}\n\n.filter-common.open > .filter-common-selected > .filter-common-selected-text {\n  opacity: 0.5;\n}\n\n.filter-common-arrow {\n  background-image: url('../../../assets/icones_app/arrow.svg');\n  background-repeat: no-repeat;\n  height: 10px;\n  min-width: 17px;\n  margin-left: 7px;\n  margin-top: 8px;\n  transition: 0.15s;\n}\n\n.filter-common.open > .filter-common-selected > .filter-common-arrow {\n  transform: rotate(180deg);\n}\n\n.filter-common-list {\n  background-color: #ffffff;\n  border: 1px solid rgba(0, 0, 0, .26);\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  border-top: none;\n  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, .15);\n  margin-top: 3px;\n  position: absolute;\n  z-index: 700!important;\n  max-height: 400px;\n  overflow: auto;\n  white-space: nowrap;\n}\n\n.filter-common-list-item {\n  color: #000000;\n  padding: 5px 15px 5px 15px;\n  transition: 0.1s;\n}\n\n.filter-common-list-item:hover, .filter-group-list-item:hover {\n  background-color: #5897fb;\n  color: #ffffff;\n}\n\n.disabled {\n  cursor: not-allowed;\n}\n\n.magin-small{\n  margin: 5px 10px 10px;\n}\n\n.group-title {\n  color: #1A3B5F;\n  font-weight: bold;\n  padding: 10px 15px 5px 15px;\n  transition: 0.1s;\n}\n\n.filter-group-list-item {\n  color: #000000;\n  padding: 5px 15px 5px 25px;\n  transition: 0.1s;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1081 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-66125f00","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabHistoric/TabHistoric.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#tab-historic-id[data-v-66125f00]{\n  margin: 0px 0px 10px 1%;\n  height: 392px;\n  overflow: hidden;\n  overflow-y: auto;\n  width: 99%;\n  font-family: 'Inter', sans-serif;\n}\np[data-v-66125f00] {\n  margin-bottom: 0px;\n}\nul > li[data-v-66125f00], ol > li[data-v-66125f00] {\n  padding: 0px;\n}\n\n/*Estilos customizados para o primeiro ítem do histórico (mais recente)*/\nul.historic-line-date-ul-first li[data-v-66125f00] {\n  font-size: 16px;\n  color: #111B54;\n  list-style: none;\n  margin-top: 15px;\n}\nul.historic-line-date-ul-first li[data-v-66125f00]:before {\n  list-style-type: disc;\n  color: #111B54;\n  content: \"\\2022\";\n  font-size: 57px;\n  padding-right: .25em;\n  position: relative;\n  top: 11px;\n}\n.historic-line-data-first[data-v-66125f00] {\n  font-size: 14px;\n  color: #FFF;\n  border-left: 1px solid #979797;\n  margin-left: 12px;\n  padding: 20px 0px 30px 20px;\n}\n.historic-line-data-first[data-v-66125f00]:after {\n  content: '';\n  display: block;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  background: #efefef;\n  border-right:1px solid #cecece;\n  border-bottom:1px solid #cecece;\n  -moz-transform:rotate(225deg);\n  -webkit-transform:rotate(225deg);\n  left: calc(75px);\n  top: 73px;\n}\n.historic-line-data-content-first[data-v-66125f00] {\n  background-color: #efefef;\n  padding: 12px 14px;\n  color: #252525;\n  border-radius: 5px;\n  border: 1px solid #cecece;\n}\n\n/*Estilos customizados para o restante dos ítens do histórico*/\nul.historic-line-date-ul li[data-v-66125f00] {\n  font-size: 16px;\n  color: #9b9b9b;\n  list-style: none;\n}\nul.historic-line-date-ul li[data-v-66125f00]:before {\n  list-style-type: disc;\n  color: #9b9b9b;\n  content: \"\\2022\";\n  font-size: 57px;\n  padding-right: .25em;\n  position: relative;\n  top: 11px;\n}\n.historic-line-data[data-v-66125f00] {\n  border-left: 1px solid #979797;\n  margin-left: 11px;\n  padding: 20px 0px 20px 20px;\n  font-size: 14px;\n  color: #7C7C7C;\n}\n.historic-line-data-last[data-v-66125f00] {\n  margin-left: 12px;\n  padding: 20px 0px 20px 20px;\n  font-size: 14px;\n  color: #7C7C7C;\n}\n.historic-line-data[data-v-66125f00]:after,\n.historic-line-data-last[data-v-66125f00]:after {\n  content: '';\n  display: block;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  background: #FFF;\n  border-right:1px solid #e3e3e3;\n  border-bottom:1px solid #e3e3e3;\n  -moz-transform:rotate(225deg);\n  -webkit-transform:rotate(225deg);\n  left: calc(75px);\n  top: 57px;\n}\n.historic-line-data-content[data-v-66125f00] {\n  background-color: #FFF;\n  padding: 12px 14px;\n  color: #252525;\n  border-radius: 5px;\n  border: 1px solid #e3e3e3;\n}\n.historic-line[data-v-66125f00] {\n  overflow-y: auto;\n}\n.empty-value[data-v-66125f00] {\n  text-align: center;\n  color: #666;\n  font-weight: bold;\n  margin-top: 20px;\n}\n.loadingData[data-v-66125f00] {\n  background: url(" + __webpack_require__(/*! ../../../../assets/loading-gif/loading.svg */ 67) + ") 50% 50% no-repeat;\n  cursor: wait;\n  height: 390px;\n  background-size: 100px;\n}\n.right-text-tabs[data-v-66125f00]{\n  width: 100%!important;\n}\n.font-C[data-v-66125f00] {\n  color: #3bb57a;\n}\n.font-D[data-v-66125f00] {\n  color: #f55753;\n}\n.font-N[data-v-66125f00] {\n  color: #56a9c1;\n}\n.font-A[data-v-66125f00] {\n  color: #fdbd39;\n}\n.font-default[data-v-66125f00] {\n  color: #17375f;\n}\n", "", {"version":3,"sources":["/./client/components/modals/gridDetailsModal/tabHistoric/TabHistoric.vue?74512a44"],"names":[],"mappings":";AAuHA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,iCAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,aAAA;CACA;;AAEA,yEAAA;AACA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;CACA;AAEA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;CACA;AAEA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,4BAAA;CACA;AAEA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,iBAAA;EACA,UAAA;CACA;AAEA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;CACA;;AAEA,+DAAA;AACA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;CACA;AAEA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;CACA;AAEA;EACA,+BAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;;EAEA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,iBAAA;EACA,UAAA;CACA;AAEA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;CACA;AAEA;EACA,4DAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA","file":"TabHistoric.vue","sourcesContent":["<template src='./tabHistoric.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\n\nexport default {\n  name: 'TabHistoric',\n\n  props: {\n    loadHistoric: Function,\n    idLancamento: String\n  },\n\n  data () {\n    return {\n      historics: [],\n      historicEmpty: false,\n      isLoading: false,\n      idLastLanc: null\n    }\n  },\n\n  methods: {\n    // Chama a função passada como parâmetro ao clicar na aba pela primeira vez\n    clickAction () {\n      if (!this.idLastLanc || (this.idLastLanc !== this.idLancamento)) {\n        this.isLoading = true\n        this.loadHistoric(this.idLancamento).then((response) => {\n          this.idLastLanc = this.idLancamento\n          this.historics = []\n          if (response && response.data && response.data.length > 0) {\n            response.data.forEach(data => {\n              let history = {\n                data: data.data ? moment(data.data).format('LL') : ' - ',\n                hora: data.data ? moment(data.data).format('LT') : ' - ',\n                id: data.id ? data.id : ' - ',\n                status: data.situacaoConciliacao ? data.situacaoConciliacao : ' - ',\n                usuario: data.usuarioNome ? data.usuarioNome : ' - ',\n                acao: data.acao,\n                idLote: data.idConciliacaoLote ? data.idConciliacaoLote : '-'\n              }\n              this.historics.push(history)\n            })\n            this.historicEmpty = false\n          } else {\n            this.historicEmpty = true\n          }\n          this.isLoading = false\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n          this.isLoading = false\n        })\n      }\n    },\n\n    // Verifica se é o primeiro ítem da lista exibido na tela, ou seja, o histórico mais recente, que possui classes css diferentes do restante\n    isFirst (index) {\n      return !index\n    },\n\n    // Retorna a classe responsável pelo css dos dados de acordo com a posição no vetor do histórico\n    getClassContent (index) {\n      if (index === 0) {\n        return 'historic-line-data-first'\n      } else if (index === (this.historics.length - 1)) {\n        return 'historic-line-data-last'\n      }\n      return 'historic-line-data'\n    },\n\n    // Retorna a label de tradução de acordo com o status retornado pelo MS\n    getLabelStatus (key) {\n      return key === 'A'\n        ? 'statusConciliacao.aberto'\n        : key === 'C'\n        ? 'statusConciliacao.conciliado'\n        : key === 'M'\n        ? 'statusConciliacao.conciliadoManualmente'\n        : key === 'D'\n        ? 'statusConciliacao.divergente'\n        : key === 'N'\n        ? 'statusConciliacao.naoAplicavel'\n        : ' - '\n    },\n\n    // Retorna a cor do texto de acordo com o status\n    getStyleByStatus (item) {\n      let title = ''\n      switch (item) {\n        case 'C':\n          title = 'font-C'\n          break\n        case 'M':\n          title = 'font-C'\n          break\n        case 'D':\n          title = 'font-D'\n          break\n        case 'N':\n          title = 'font-N'\n          break\n        case 'A':\n          title = 'font-A'\n          break\n        default :\n          title = ''\n          break\n      }\n      return title\n    },\n    // Retorna a key concatenada de acordo com a ação, utilizada para a tradução da ação\n    getKeyAction (keyAction) {\n      return 'modalDetalhesLanc.tabHistorico.acao.' + keyAction\n    }\n  }\n}\n</script>\n\n<style scoped>\n#tab-historic-id{\n  margin: 0px 0px 10px 1%;\n  height: 392px;\n  overflow: hidden;\n  overflow-y: auto;\n  width: 99%;\n  font-family: 'Inter', sans-serif;\n}\n\np {\n  margin-bottom: 0px;\n}\n\nul > li, ol > li {\n  padding: 0px;\n}\n\n/*Estilos customizados para o primeiro ítem do histórico (mais recente)*/\nul.historic-line-date-ul-first li {\n  font-size: 16px;\n  color: #111B54;\n  list-style: none;\n  margin-top: 15px;\n}\n\nul.historic-line-date-ul-first li:before {\n  list-style-type: disc;\n  color: #111B54;\n  content: \"\\2022\";\n  font-size: 57px;\n  padding-right: .25em;\n  position: relative;\n  top: 11px;\n}\n\n.historic-line-data-first {\n  font-size: 14px;\n  color: #FFF;\n  border-left: 1px solid #979797;\n  margin-left: 12px;\n  padding: 20px 0px 30px 20px;\n}\n\n.historic-line-data-first:after {\n  content: '';\n  display: block;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  background: #efefef;\n  border-right:1px solid #cecece;\n  border-bottom:1px solid #cecece;\n  -moz-transform:rotate(225deg);\n  -webkit-transform:rotate(225deg);\n  left: calc(75px);\n  top: 73px;\n}\n\n.historic-line-data-content-first {\n  background-color: #efefef;\n  padding: 12px 14px;\n  color: #252525;\n  border-radius: 5px;\n  border: 1px solid #cecece;\n}\n\n/*Estilos customizados para o restante dos ítens do histórico*/\nul.historic-line-date-ul li {\n  font-size: 16px;\n  color: #9b9b9b;\n  list-style: none;\n}\n\nul.historic-line-date-ul li:before {\n  list-style-type: disc;\n  color: #9b9b9b;\n  content: \"\\2022\";\n  font-size: 57px;\n  padding-right: .25em;\n  position: relative;\n  top: 11px;\n}\n\n.historic-line-data {\n  border-left: 1px solid #979797;\n  margin-left: 11px;\n  padding: 20px 0px 20px 20px;\n  font-size: 14px;\n  color: #7C7C7C;\n}\n\n.historic-line-data-last {\n  margin-left: 12px;\n  padding: 20px 0px 20px 20px;\n  font-size: 14px;\n  color: #7C7C7C;\n}\n\n.historic-line-data:after,\n.historic-line-data-last:after {\n  content: '';\n  display: block;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  background: #FFF;\n  border-right:1px solid #e3e3e3;\n  border-bottom:1px solid #e3e3e3;\n  -moz-transform:rotate(225deg);\n  -webkit-transform:rotate(225deg);\n  left: calc(75px);\n  top: 57px;\n}\n\n.historic-line-data-content {\n  background-color: #FFF;\n  padding: 12px 14px;\n  color: #252525;\n  border-radius: 5px;\n  border: 1px solid #e3e3e3;\n}\n\n.historic-line {\n  overflow-y: auto;\n}\n\n.empty-value {\n  text-align: center;\n  color: #666;\n  font-weight: bold;\n  margin-top: 20px;\n}\n\n.loadingData {\n  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;\n  cursor: wait;\n  height: 390px;\n  background-size: 100px;\n}\n\n.right-text-tabs{\n  width: 100%!important;\n}\n\n.font-C {\n  color: #3bb57a;\n}\n\n.font-D {\n  color: #f55753;\n}\n\n.font-N {\n  color: #56a9c1;\n}\n\n.font-A {\n  color: #fdbd39;\n}\n\n.font-default {\n  color: #17375f;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1082 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-66984113","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/conciliationPlan/List.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#plans {\n  margin-top: 15px;\n}\n.plans-header {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #223763;\n  color: #FFF;\n  height: 30px;\n  padding: 5px 15px;\n  font-size: 14px;\n  border-radius: 12px 12px 0px 0px;\n}\n.plans-header-acoes-tit {\n  float:right;\n  width: 86px;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n.plans-header-column-left {\n  padding-left: 0px;\n  margin-left: 0px;\n  margin-right: 6px;\n}\n.plans-type {\n  margin-left: 3px;\n}\n.actions {\n  text-align: center;\n}\n.action {\n  text-align: center;\n  background-color: transparent !important;\n  border: none !important;\n  margin: 0 5px 0 5px;\n}\n.action:hover {\n  border: none !important;\n}\n.action:disabled {\n  cursor: not-allowed;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/conciliationPlan/List.vue?503e2ed2"],"names":[],"mappings":";AAkKA;EACA,iBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;CACA;AAEA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;CACA;AAEA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,mBAAA;EACA,yCAAA;EACA,wBAAA;EACA,oBAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,oBAAA;CACA","file":"List.vue","sourcesContent":["<template src='./list.pug' lang='pug'></template>\n\n<script>\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport LoadingPlaceholder from '../../../loading/LoadingPlaceholder'\nimport VueDragTree from '../../../registration/conciliationPlan/TreeViewPlans'\nimport ConfirmModal from '../../../modals/confirmModal/ConfirmModal'\nimport customSorter from '../../../../utils/customSorter.js'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport { generateLoadingRows } from '../../../../utils/grid-load-transition.js'\nimport PATHS from '../../../../router/routesMap.js'\n\nexport default {\n  name: 'ConciliationPlanList',\n\n  components: {\n    PageTitle,\n    ButtonPrimary,\n    LoadingPlaceholder,\n    VueDragTree,\n    ConfirmModal\n  },\n\n  data () {\n    return {\n      isLoadingData: true,\n      treeViewButtonTitle: {\n        config: this.$t('planoConciliacao.labels.gerenciar'),\n        edit: this.$t('categoria.labels.editar'),\n        create: this.$t('planoConciliacao.labels.criar'),\n        expand: this.$t('categoria.labels.expandir'),\n        collapse: this.$t('categoria.labels.recolher'),\n        remove: this.$t('planoConciliacao.labels.remover'),\n        removeBloq: this.$t('planoConciliacao.labels.removerBloqueado')\n      },\n      plans: generateLoadingRows(10),\n      columns: ['planName', 'acoes'],\n      options: {\n        columnsClasses: { 'acoes': 'col-md-1', 'planName': 'col-md-11' },\n        headings: {\n          nomePlanoConciliacao: this.$t('planoConciliacao.labels.plano'),\n          acoes: this.$t('planoConciliacao.labels.acoes')\n        },\n        templates: {\n          nome: LoadingPlaceholder,\n          acoes: LoadingPlaceholder\n        },\n        filterable: ['planName'],\n        filterByColumn: true,\n        perPageValues: [],\n        texts: {\n          count: this.$t('dataTable.labels.contagem'),\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filterBy: '',\n          filterPlaceholder: this.$t('dataTable.labels.filtrar')\n        },\n        sortable: ['planName'],\n        sortIcon: {\n          is: ''\n        },\n        pagination: { chunk: 5 },\n        customSorting: {\n          nome: function (ascending) {\n            return function (a, b) {\n              return customSorter.stringSorter(ascending, a, b, 'planName')\n            }\n          }\n        }\n      },\n      planIdToRemove: null\n    }\n  },\n\n  methods: {\n    edit (conciliationPlanId) {\n      trackAnalyticsEvent(this, 'edit-click', 'edit-plano-de-conciliacao', 'edit-plano-de-conciliacao')\n\n      this.$store.dispatch('setPlanToEdit', conciliationPlanId).then((response) => {\n        this.$router.push(PATHS.NEW_CONCILIATION_PLAN)\n      })\n    },\n\n    newPlan () {\n      this.$router.push(PATHS.NEW_CONCILIATION_PLAN)\n    },\n\n    loadPlans () {\n      let url = '/conciliationPlan/listCategorized'\n      this.$store.dispatch('getPlans', url).then((response) => {\n        this.plans = response.data\n        this.isLoadingData = false\n        this.options.templates = {}\n      })\n    },\n\n    removeSpecialChars (newStringComAcento) {\n      let string = newStringComAcento\n      let mapaAcentosHex = {\n        a: /[\\xE0-\\xE6]/g,\n        e: /[\\xE8-\\xEB&(?!amp;)]/g,\n        i: /[\\xEC-\\xEF]/g,\n        o: /[\\xF2-\\xF6]/g,\n        u: /[\\xF9-\\xFC]/g,\n        c: /\\xE7/g,\n        n: /\\xF1/g,\n        '-': /\\s/g\n      }\n\n      mapaAcentosHex.forEach(letra => {\n        let expressaoRegular = mapaAcentosHex[letra]\n        string = string.replace(expressaoRegular, letra)\n      })\n\n      return string\n    },\n\n    // Metodo chamando nos botoes do componente TreeViewAtt\n    createEditPlan (conciliationPlanId, set, isEdit) {\n      if (isEdit) {\n        trackAnalyticsEvent(this, 'edit-click', 'edit-plano-de-conciliacao', 'edit-plano-de-conciliacao')\n\n        this.$store.dispatch('setPlanToEdit', conciliationPlanId).then((response) => {\n          this.$router.push(PATHS.NEW_CONCILIATION_PLAN)\n        })\n      }\n    },\n\n    handleRemove (planIdToRemove) {\n      this.planIdToRemove = planIdToRemove\n      $('#confirmRemovePlan').modal('show')\n    },\n\n    removePlan () {\n      trackAnalyticsEvent(this, 'remove-click', 'remove-plano-conciliacao', 'remove-plano-conciliacao')\n      if (this.planIdToRemove) {\n        this.$store.dispatch('removeConciliationPlan', this.planIdToRemove)\n          .then((response) => {\n            this.$root.$refs.notification.success('planoConciliacao.sucesso.remover')\n            this.planIdToRemove = null\n            $('#confirmRemovePlan').modal('hide')\n            this.loadPlans()\n          })\n          .catch((error) => {\n            this.$root.$refs.notification.error(error.message)\n          })\n      }\n    },\n\n    closeModalConfirm () {\n      this.occurrenceReasonIdToRemove = null\n      $('#confirmRemovePlan').modal('hide')\n    }\n  },\n\n  created () {\n    this.loadPlans()\n  }\n}\n</script>\n\n<style>\n#plans {\n  margin-top: 15px;\n}\n\n.plans-header {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #223763;\n  color: #FFF;\n  height: 30px;\n  padding: 5px 15px;\n  font-size: 14px;\n  border-radius: 12px 12px 0px 0px;\n}\n\n.plans-header-acoes-tit {\n  float:right;\n  width: 86px;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n\n.plans-header-column-left {\n  padding-left: 0px;\n  margin-left: 0px;\n  margin-right: 6px;\n}\n\n.plans-type {\n  margin-left: 3px;\n}\n\n.actions {\n  text-align: center;\n}\n\n.action {\n  text-align: center;\n  background-color: transparent !important;\n  border: none !important;\n  margin: 0 5px 0 5px;\n}\n\n.action:hover {\n  border: none !important;\n}\n\n.action:disabled {\n  cursor: not-allowed;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1083 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6bd12989","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/login/CadastrarSenha.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n@media (min-width: 420px) {\n.recaptcha-form[data-v-6bd12989] {\n    margin: auto;\n    width: 100%;\n}\n}\n@media (min-width: 768px) {\n.recaptcha-form[data-v-6bd12989] {\n    margin: auto;\n    width: 64%;\n}\n}\n.bg-tela-login[data-v-6bd12989]:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n.bg-tela-login[data-v-6bd12989]:after {\n  bottom: 0;\n}\n.bg-tela-login[data-v-6bd12989] {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: linear-gradient(to right, #223768, #00C3BE);\n}\n.inicial-wrap[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  max-width: 650px;\n  margin: 50px auto;\n  transition: transform 300ms ease-in-out;\n}\n.inicial-bodies[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  text-align: center;\n  position: relative;\n  perspective: 1000px;\n}\nbutton.button[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(174, 223, 120, 1);\n  font-size: 20px;\n  cursor: pointer;\n  margin-top: 60px !important;\n  color: rgba(28, 59, 101, 1);\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\nbutton.button[data-v-6bd12989]:hover {\n  background-color: rgba(174, 223, 120, 1);\n  color: rgba(28, 59, 101, 1);\n  border: none;\n}\n.button i[data-v-6bd12989] {\n  font-weight: normal;\n  font-size: 24px;\n  margin-right: 5px;\n}\n\n/*Tela de boas vindas*/\n.boas-vindas-tit[data-v-6bd12989] {\n  text-align: center;\n  font-size: 50px;\n  color: rgba(122, 203, 231, 1);\n}\n.boas-vindas-txt[data-v-6bd12989] {\n  text-align: center;\n  padding: 50px 145px 50px 145px;\n  font-size: 25px;\n  color: rgba(255, 255, 255, 1);\n}\n.boas-vindas-txt-bottom[data-v-6bd12989] {\n  font-weight: bold;\n  font-size: 20px;\n  text-transform: uppercase;\n  color: rgba(122, 203, 231, 1);\n}\n.inicial-body[data-v-6bd12989] {\n  background: #005E78;\n  padding: 40px 0px 0px 0px;\n  margin-bottom: 50px;\n  display: none;\n  box-sizing: border-box;\n  width: 100%;\n}\n.inicial-body2[data-v-6bd12989] {\n  border: 2px solid rgba(255, 255, 255, 1);\n  margin-bottom: 50px;\n  display: none;\n  width: 100%;\n}\n.inicial-body3[data-v-6bd12989] {\n  border: 2px solid rgba(255, 255, 255, 1);\n  margin-bottom: 50px;\n  display: none;\n  width: 100%;\n}\n.formulario-login-topo[data-v-6bd12989] {\n  height: 85px;\n  background-color: #FFF;\n}\nbutton.btn-idioma[data-v-6bd12989] {\n  background: #fff;\n  float: right;\n  height: 100%;\n  padding: 2%;\n  border: none;\n}\nbutton.btn-idioma[data-v-6bd12989]:hover {\n  background: transparent;\n  border: none;\n}\nbutton.btn-idioma[data-v-6bd12989]:active {\n  box-shadow: none;\n}\n.escolhaIdiomas[data-v-6bd12989] {\n  background: rgba(133, 186, 202, 1);\n  /* For browsers that do not support gradients */\n  /* For Safari 5.1 to 6.0 */\n  /* For Opera 11.1 to 12.0 */\n  /* For Firefox 3.6 to 15 */\n  background: linear-gradient(to right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* Standard syntax */\n  height: 50px;\n  z-index: 2;\n}\n.escolhaIdiomas p[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  color: rgba(28, 59, 101, 1);\n  padding: 15px;\n  font-weight: bold;\n  vertical-align: middle;\n}\nbutton.btn-escolher-idioma[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  border: none;\n  font-size: 15px;\n  background-color: transparent;\n  padding: 14px 10px 15px 10px;\n  color: rgba(255, 255, 255, 1);\n}\nbutton.btn-escolher-idioma.btn-ativo[data-v-6bd12989] {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\nbutton.btn-escolher-idioma[data-v-6bd12989]:hover {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\nbutton.btn-fechar-escolher-idioma[data-v-6bd12989] {\n  background-color: transparent;\n  padding: 0px;\n  margin: 0px 6px 0px 25px!important;\n  border: none;\n}\nbutton.btn-fechar-escolher-idioma[data-v-6bd12989]:hover {\n  background-color: transparent;\n  border: none;\n}\nbutton.btn-fechar-escolher-idioma[data-v-6bd12989]:active {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\nbutton.btn-esqueceu-senha[data-v-6bd12989] {\n  background-color: transparent;\n  border: none;\n  z-index: 2;\n  position: absolute;\n  height: 60px;\n  width: 60px;\n  right: 0;\n  text-align: center;\n  padding: 0px;\n}\nbutton.btn-esqueceu-senha[data-v-6bd12989]:hover {\n  background-color: transparent;\n  border: none;\n}\nbutton.btn-esqueceu-senha[data-v-6bd12989]:active {\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\n.logo-equals[data-v-6bd12989] {\n  height: 100%;\n  padding: 20px;\n}\n.formulario-login[data-v-6bd12989] {\n  padding: 80px 125px 70px 125px;\n  box-sizing: border-box;\n  width: 100%;\n}\ninput[data-v-6bd12989]:-webkit-autofill,\ninput[data-v-6bd12989]:-webkit-autofill:hover,\ninput[data-v-6bd12989]:-webkit-autofill:focus,\ninput[data-v-6bd12989]:-webkit-autofill:active {\n  transition: background-color 5000s ease-in-out 0s;\n  -webkit-text-fill-color: #fff !important;\n}\n.formulario-login input[data-v-6bd12989] {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-radius: 0px!important;\n  border: none;\n  border-bottom: 2px solid rgba(255, 255, 255, 1);\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n  height: 60px;\n}\n.formulario-login input[data-v-6bd12989]:focus {\n  box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;\n}\n.formulario-login input[data-v-6bd12989]::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\n.formulario-login input[data-v-6bd12989]:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n.formulario-login input[data-v-6bd12989]::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n}\n.formulario-login input[data-v-6bd12989]:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\nbutton.button-login[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(28, 59, 101, 1);\n  bottom: 0;\n  font-size: 20px;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 1)!important;\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\nbutton.button-login[data-v-6bd12989]:hover {\n  background-color: rgba(28, 59, 101, 1);\n  color: rgba(255, 255, 255, 1)!important;\n  border: none;\n}\nbutton.button-login[data-v-6bd12989]:active {\n  background-color: rgba(28, 59, 101, 1);\n  color: rgba(255, 255, 255, 1)!important;\n  border: none;\n}\nbutton.button-login[data-v-6bd12989]:disabled {\n  background-color: rgba(28, 59, 101, 1);\n  cursor: progress;\n  color: #FFF;\n  border: none;\n}\n\n/*Captcha*/\n.captcha[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  background-color: #FFF;\n  padding: 20px 10px;\n}\n.captcha p[data-v-6bd12989] {\n  width: 100%;\n  font-size: 15px;\n  margin-top: 10px;\n}\n#mainCaptcha[data-v-6bd12989] {\n  width: 90%;\n  background-color: transparent;\n  color: black;\n  text-align: center;\n  padding: 0px;\n}\n.text-center[data-v-6bd12989] {\n  text-align: center;\n}\nbutton.btn-refresh-catpcha[data-v-6bd12989] {\n  width: 10%;\n  background-color: transparent;\n  padding: 0px;\n  border: none;\n}\nbutton.btn-refresh-catpcha[data-v-6bd12989]:hover {\n  background-color: transparent;\n  border: none;\n}\nbutton.btn-refresh-catpcha[data-v-6bd12989]:active {\n  background-color: transparent;\n  border: none;\n}\ninput.captcha-recuperar-senha[data-v-6bd12989] {\n  padding: 8px;\n  width: 100%;\n  /* background-color: rgba(95, 169, 192, 1); */\n  border-radius: 0px!important;\n  border: none;\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n}\n.g-recaptcha[data-v-6bd12989] {\n  display: inline-block;\n}\ninput.captcha-recuperar-senha[data-v-6bd12989]::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\ninput.captcha-recuperar-senha[data-v-6bd12989]:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\ninput.captcha-recuperar-senha[data-v-6bd12989]::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n}\ninput.captcha-recuperar-senha[data-v-6bd12989]:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\nbutton.button2[data-v-6bd12989] {\n  margin-top: 30px!important;\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  padding: 0px;\n}\nbutton.button2[data-v-6bd12989]:hover {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n}\nbutton.button2[data-v-6bd12989]:active {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\nbutton.button2 span[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  margin-left: 8px;\n  font-weight: bold;\n}\n\n/*Tela logado*/\n.logado[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(147, 191, 98, 1);\n  color: rgba(255, 255, 255, 1);\n}\n.logado-ok[data-v-6bd12989] {\n  font-size: 50px;\n  margin: 30px 0px 10px 0px;\n}\n.bem-vindo[data-v-6bd12989] {\n  font-size: 20px;\n  text-transform: uppercase;\n}\n.img-bottom[data-v-6bd12989] {\n\n  height: 60px;\n  /*max-width: 650px;*/\n  vertical-align: middle;\n  margin-bottom: 30px;\n  /*position: absolute;*/\n}\n\n/*Login com erro*/\n.erro-login[data-v-6bd12989] {\n  color: rgba(106, 34, 35, 1);\n  margin-top: 5px;\n  font-size: 14px;\n  font-style: italic;\n}\n.inicial-body.is-showing[data-v-6bd12989] {\n  display: block;\n}\n.inicial-body2.is-showing[data-v-6bd12989] {\n  display: block;\n}\n.inicial-body3.is-showing[data-v-6bd12989] {\n  display: block;\n}\n.animate-out[data-v-6bd12989] {\n  animation: out 600ms ease-in-out;\n}\n.animate-in[data-v-6bd12989] {\n  animation: in 400ms ease-in-out;\n  display: block;\n}\n.animate-up[data-v-6bd12989] {\n  transform: rotateY(0deg);\n}\n.form-control[data-v-6bd12989] {\n  font-family: 'Inter', sans-serif;\n}\nhtml[data-v-6bd12989],\nbody[data-v-6bd12989] {\n  height: 100%;\n}\nbody[data-v-6bd12989] {\n  overflow: auto;\n}\n.vertical-center[data-v-6bd12989] {\n  min-height: 100%;\n  min-height: 99vh;\n\n  /* Make it a flex container */\n  display: -ms-flexbox;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.jumbotron.vertical-center[data-v-6bd12989] {\n  margin-bottom: 0;\n}\n#loginInput[data-v-6bd12989] {\n  padding-left: 50px;\n}\n#loginSenha[data-v-6bd12989] {\n  padding-left: 50px;\n}\n.inicial-wrap.px-0.img-bottom div[data-v-6bd12989] {\n  padding-bottom: 15px;\n}\n.formulario-login .form-group>img[data-v-6bd12989] {\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  left: 0;\n  text-align: center;\n  padding: 15px;\n}\n@keyframes out {\n0% {\n    opacity: 1;\n    transform: rotateY(0deg);\n}\n100% {\n    opacity: 0;\n    transform: rotateY(-90deg);\n}\n}\n@keyframes in {\n0% {\n    opacity: 0;\n    transform: rotateY(90deg);\n}\n100% {\n    opacity: 1;\n    transform: rotateY(0deg);\n}\n}\n", "", {"version":3,"sources":["/./client/components/views/login/CadastrarSenha.vue?abd82704"],"names":[],"mappings":";AA2MA;AACA;IACA,aAAA;IACA,YAAA;CACA;CACA;AAEA;AACA;IACA,aAAA;IACA,WAAA;CACA;CACA;AAEA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oBAAA;EAIA,wDAAA;CACA;AAEA;EACA,iCAAA;EACA,iBAAA;EACA,kBAAA;EAGA,wCAAA;CAEA;AAEA;EACA,iCAAA;EACA,mBAAA;EACA,mBAAA;EAEA,oBAAA;CACA;AAEA;EACA,iCAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,4BAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,yCAAA;EACA,4BAAA;EACA,aAAA;CACA;AAEA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;CACA;;AAEA,uBAAA;AAEA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;CACA;AAEA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,8BAAA;CACA;AAEA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,8BAAA;CACA;AAEA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;EACA,yCAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;CACA;AAEA;EACA,yCAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;CACA;AAEA;EACA,aAAA;EACA,uBAAA;CACA;AAEA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;CACA;AAEA;EACA,wBAAA;EACA,aAAA;CACA;AAEA;EAEA,iBAAA;CACA;AAEA;EACA,mCAAA;EACA,gDAAA;EAEA,2BAAA;EAEA,4BAAA;EAEA,2BAAA;EACA,sFAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;CACA;AAEA;EACA,iCAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;CACA;AAEA;EACA,aAAA;EACA,yCAAA;EACA,6BAAA;EACA,8CAAA;EACA,4BAAA;CACA;AAEA;EACA,aAAA;EACA,yCAAA;EACA,6BAAA;EACA,8CAAA;EACA,4BAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,mCAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EAEA,iBAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EAEA,iBAAA;CACA;AAEA;EACA,aAAA;EACA,cAAA;CACA;AAEA;EACA,+BAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;;;;EAIA,kDAAA;EACA,yCAAA;CACA;AAEA;EACA,4CAAA;EACA,6BAAA;EACA,aAAA;EACA,gDAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;CACA;AAEA;EAEA,sEAAA;CACA;AAEA;EACA,wCAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,yBAAA;EACA,wCAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,iCAAA;EACA,uCAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,uCAAA;EACA,wCAAA;EACA,aAAA;CACA;AAEA;EACA,uCAAA;EACA,wCAAA;EACA,aAAA;CACA;AAEA;EACA,uCAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;CACA;;AAEA,WAAA;AAEA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;CACA;AAEA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;CACA;AAEA;EACA,aAAA;EACA,YAAA;EACA,8CAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,wCAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,yBAAA;EACA,wCAAA;CACA;AAEA;EACA,6BAAA;EACA,wCAAA;CACA;AAEA;EACA,2BAAA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;EACA,aAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;EACA,8BAAA;EACA,aAAA;EAEA,iBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;CACA;;AAEA,eAAA;AAEA;EACA,iCAAA;EACA,wCAAA;EACA,8BAAA;CACA;AAEA;EACA,gBAAA;EACA,0BAAA;CACA;AAEA;EACA,gBAAA;EACA,0BAAA;CACA;AAEA;;EAEA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;CACA;;AAEA,kBAAA;AAEA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EAEA,iCAAA;CACA;AAEA;EAEA,gCAAA;EACA,eAAA;CACA;AAEA;EAEA,yBAAA;CACA;AAEA;EACA,iCAAA;CACA;AAEA;;EAEA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;EACA,iBAAA;;EAEA,8BAAA;EAGA,qBAAA;EAEA,cAAA;;EAEA,gDAAA;EAIA,uBAAA;EACA,oBAAA;;EAEA,YAAA;EAIA,sBAAA;EAEA,wBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,qBAAA;CACA;AAEA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;CACA;AAeA;AACA;IACA,WAAA;IAEA,yBAAA;CACA;AACA;IACA,WAAA;IAEA,2BAAA;CACA;CACA;AAeA;AACA;IACA,WAAA;IAEA,0BAAA;CACA;AACA;IACA,WAAA;IAEA,yBAAA;CACA;CACA","file":"CadastrarSenha.vue","sourcesContent":["<template lang=\"pug\" src=\"./cadastrarSenha.pug\"></template>\n\n<script>\nimport idioma from '../../../../build/language/index.js'\nimport PATHS from '../../../router/routesMap.js'\n\nexport default {\n  name: 'CadastrarSenha',\n\n  data () {\n    return {\n      username: null,\n      pass: null,\n      confirmPass: null,\n      chave: null,\n      success: false,\n      abrirIdiomas: false,\n      senhaDiferente: false,\n      campoUsernamaVazio: false,\n      campoUsernameInvalido: false,\n      campoPassVazio: false,\n      campoConfirmPassVazio: false,\n      disableCreateButton: false,\n      idiomaPng: require('../../../assets/login/img/idioma.png'),\n      logoEqualsLoginPng: require('../../../assets/logos_equals/logo_banking.png'),\n      fecharPng: require('../../../assets/login/img/fechar.png'),\n      idiomaAtivoPng: require('../../../assets/login/img/idioma-ativo.png'),\n      logadoOkPng: require('../../../assets/login/img/logado-ok.png')\n    }\n  },\n\n  watch: {\n    username () {\n      if (this.username && this.username.length > 0) {\n        this.campoUsernamaVazio = false\n        this.campoUsernameInvalido = false\n        document.getElementById('nome').style.borderBottom = '2px solid #ffffff'\n      }\n    },\n    pass () {\n      if (this.pass && this.pass.length > 0) {\n        this.campoPassVazio = false\n        document.querySelector('#senha').style.borderBottom = '2px solid #ffffff'\n      }\n    },\n    confirmPass () {\n      if (this.confirmPass && this.confirmPass.length > 0) {\n        this.campoConfirmPassVazio = false\n        this.senhaDiferente = false\n        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #ffffff'\n      }\n    }\n  },\n\n  methods: {\n    escolherIdioma () {\n      this.abrirIdiomas = true\n    },\n\n    fecharEscolherIdioma () {\n      this.abrirIdiomas = false\n    },\n\n    trocarIdioma (language) {\n      idioma.changeLanguage(language)\n\n      $('div.btn-group').find('.btn-ativo').removeClass('btn-ativo')\n\n      switch (language) {\n        case 'pt':\n          $('.btn-pt').addClass('btn-ativo')\n          break\n        case 'in':\n          $('.btn-in').addClass('btn-ativo')\n          break\n        case 'es':\n          $('.btn-es').addClass('btn-ativo')\n          break\n        default:\n          break\n      }\n    },\n\n    cadastrar (event) {\n      event.preventDefault()\n      if (this.validateForm()) {\n        this.disableCreateButton = true\n        this.chave = this.$route.query.hash\n        if (location.pathname === PATHS.NEW_PASSWORD) {\n          this.$store.dispatch('registerPassword', {\n            username: this.username,\n            password: this.pass,\n            confirmPassword: this.confirmPass,\n            key: this.chave\n          }).then((response) => {\n            this.$root.$refs.notification.success('login.sucesso.cadastrarSenha')\n            this.disableCreateButton = false\n            this.$router.push(PATHS.LOGIN)\n          }).catch((error) => {\n            this.disableCreateButton = false\n            this.$root.$refs.notification.error(error.message)\n          })\n        } else {\n          this.$store.dispatch('registerRecoverPassword', {\n            username: this.username,\n            password: this.pass,\n            confirmPassword: this.confirmPass,\n            key: this.chave\n          }).then((response) => {\n            this.disableCreateButton = false\n            this.$root.$refs.notification.success('login.sucesso.alterarSenha')\n            this.$router.push(PATHS.LOGIN)\n          }).catch((error) => {\n            this.disableCreateButton = false\n            this.$root.$refs.notification.error(error.message)\n          })\n        }\n      }\n    },\n\n    validateForm () {\n      // Não pode fazer o retorno direto das funções de validação para\n      // garantir que ambos o campos do form sejam validados na ação.\n      let isValidForm = this.verificarCamposVazios()\n      let isSamePass = this.verificarSenhasIguais()\n      return isValidForm && isSamePass\n    },\n\n    validateEmail () {\n      return (/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$/).test(this.username)\n    },\n\n    verificarCamposVazios () {\n      let isValid = true\n      this.campoUsernamaVazio = false\n      this.campoPassVazio = false\n      this.campoConfirmPassVazio = false\n      this.campoUsernameInvalido = false\n\n      if (this.username == null || this.username === undefined || this.username === '') {\n        this.campoUsernamaVazio = true\n        document.querySelector('#nome').style.borderBottom = '2px solid #c65b55'\n        isValid = false\n      } else if (!this.validateEmail()) {\n        this.campoUsernameInvalido = true\n        document.querySelector('#nome').style.borderBottom = '2px solid #c65b55'\n        isValid = false\n      }\n\n      if (this.pass == null || this.pass === undefined || this.pass === '') {\n        this.campoPassVazio = true\n        document.querySelector('#senha').style.borderBottom = '2px solid #c65b55'\n        isValid = false\n      }\n\n      if (this.confirmPass == null || this.confirmPass === undefined || this.confirmPass === '') {\n        this.campoConfirmPassVazio = true\n        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #c65b55'\n        isValid = false\n      }\n\n      return isValid\n    },\n\n    verificarSenhasIguais () {\n      if (this.pass === this.confirmPass) {\n        return true\n      } else {\n        this.senhaDiferente = true\n        document.querySelector('#confirmaSenha').style.borderBottom = '2px solid #c65b55'\n        return false\n      }\n    },\n\n    carregarImagem (nomeImagem) {\n      var idiomaImagem = idioma.getCookieByName('language')\n      return require('../../../assets/login/img/' + nomeImagem + idiomaImagem + '.png')\n    }\n  },\n\n  mounted () {\n    this.$store.dispatch('logout')\n    idioma.changeLanguage(idioma.getCookieByName('language'))\n\n    // Deixa ativo o botão do idioma selecionado.\n    switch (idioma.getCookieByName('language')) {\n      case 'pt':\n        $('.btn-pt').addClass('btn-ativo')\n        break\n      case 'in':\n        $('.btn-in').addClass('btn-ativo')\n        break\n      case 'es':\n        $('.btn-es').addClass('btn-ativo')\n        break\n      default:\n        break\n    }\n  }\n}\n</script>\n\n<style scoped>\n@media (min-width: 420px) {\n  .recaptcha-form {\n    margin: auto;\n    width: 100%;\n  }\n}\n\n@media (min-width: 768px) {\n  .recaptcha-form {\n    margin: auto;\n    width: 64%;\n  }\n}\n\n.bg-tela-login:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n\n.bg-tela-login:after {\n  bottom: 0;\n}\n\n.bg-tela-login {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: -webkit-linear-gradient(left, #1C3B65, #40B9BB);\n  background: -o-linear-gradient(right, #223768, #00C3BE);\n  background: -moz-linear-gradient(right, #223768, #00C3BE);\n  background: linear-gradient(to right, #223768, #00C3BE);\n}\n\n.inicial-wrap {\n  font-family: 'Inter', sans-serif;\n  max-width: 650px;\n  margin: 50px auto;\n  -webkit-transition: -webkit-transform 300ms ease-in-out;\n  transition: -webkit-transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out;\n  transition: transform 300ms ease-in-out, -webkit-transform 300ms ease-in-out;\n}\n\n.inicial-bodies {\n  font-family: 'Inter', sans-serif;\n  text-align: center;\n  position: relative;\n  -webkit-perspective: 1000px;\n  perspective: 1000px;\n}\n\nbutton.button {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(174, 223, 120, 1);\n  font-size: 20px;\n  cursor: pointer;\n  margin-top: 60px !important;\n  color: rgba(28, 59, 101, 1);\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\n\nbutton.button:hover {\n  background-color: rgba(174, 223, 120, 1);\n  color: rgba(28, 59, 101, 1);\n  border: none;\n}\n\n.button i {\n  font-weight: normal;\n  font-size: 24px;\n  margin-right: 5px;\n}\n\n/*Tela de boas vindas*/\n\n.boas-vindas-tit {\n  text-align: center;\n  font-size: 50px;\n  color: rgba(122, 203, 231, 1);\n}\n\n.boas-vindas-txt {\n  text-align: center;\n  padding: 50px 145px 50px 145px;\n  font-size: 25px;\n  color: rgba(255, 255, 255, 1);\n}\n\n.boas-vindas-txt-bottom {\n  font-weight: bold;\n  font-size: 20px;\n  text-transform: uppercase;\n  color: rgba(122, 203, 231, 1);\n}\n\n.inicial-body {\n  background: #005E78;\n  padding: 40px 0px 0px 0px;\n  margin-bottom: 50px;\n  display: none;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.inicial-body2 {\n  border: 2px solid rgba(255, 255, 255, 1);\n  margin-bottom: 50px;\n  display: none;\n  width: 100%;\n}\n\n.inicial-body3 {\n  border: 2px solid rgba(255, 255, 255, 1);\n  margin-bottom: 50px;\n  display: none;\n  width: 100%;\n}\n\n.formulario-login-topo {\n  height: 85px;\n  background-color: #FFF;\n}\n\nbutton.btn-idioma {\n  background: #fff;\n  float: right;\n  height: 100%;\n  padding: 2%;\n  border: none;\n}\n\nbutton.btn-idioma:hover {\n  background: transparent;\n  border: none;\n}\n\nbutton.btn-idioma:active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.escolhaIdiomas {\n  background: rgba(133, 186, 202, 1);\n  /* For browsers that do not support gradients */\n  background: -webkit-linear-gradient(left, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* For Safari 5.1 to 6.0 */\n  background: -o-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* For Opera 11.1 to 12.0 */\n  background: -moz-linear-gradient(right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* For Firefox 3.6 to 15 */\n  background: linear-gradient(to right, rgba(133, 186, 202, 1), rgba(157, 207, 224, 1));\n  /* Standard syntax */\n  height: 50px;\n  z-index: 2;\n}\n\n.escolhaIdiomas p {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  color: rgba(28, 59, 101, 1);\n  padding: 15px;\n  font-weight: bold;\n  vertical-align: middle;\n}\n\nbutton.btn-escolher-idioma {\n  font-family: 'Inter', sans-serif;\n  border: none;\n  font-size: 15px;\n  background-color: transparent;\n  padding: 14px 10px 15px 10px;\n  color: rgba(255, 255, 255, 1);\n}\n\nbutton.btn-escolher-idioma.btn-ativo {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\n\nbutton.btn-escolher-idioma:hover {\n  border: none;\n  background-color: rgba(224, 239, 244, 1);\n  padding: 14px 10px 10px 10px;\n  border-bottom: 5px solid rgba(28, 59, 101, 1);\n  color: rgba(28, 59, 101, 1);\n}\n\nbutton.btn-fechar-escolher-idioma {\n  background-color: transparent;\n  padding: 0px;\n  margin: 0px 6px 0px 25px!important;\n  border: none;\n}\n\nbutton.btn-fechar-escolher-idioma:hover {\n  background-color: transparent;\n  border: none;\n}\n\nbutton.btn-fechar-escolher-idioma:active {\n  background-color: transparent;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbutton.btn-esqueceu-senha {\n  background-color: transparent;\n  border: none;\n  z-index: 2;\n  position: absolute;\n  height: 60px;\n  width: 60px;\n  right: 0;\n  text-align: center;\n  padding: 0px;\n}\n\nbutton.btn-esqueceu-senha:hover {\n  background-color: transparent;\n  border: none;\n}\n\nbutton.btn-esqueceu-senha:active {\n  background-color: transparent;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.logo-equals {\n  height: 100%;\n  padding: 20px;\n}\n\n.formulario-login {\n  padding: 80px 125px 70px 125px;\n  box-sizing: border-box;\n  width: 100%;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  transition: background-color 5000s ease-in-out 0s;\n  -webkit-text-fill-color: #fff !important;\n}\n\n.formulario-login input {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-radius: 0px!important;\n  border: none;\n  border-bottom: 2px solid rgba(255, 255, 255, 1);\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n  height: 60px;\n}\n\n.formulario-login input:focus {\n  -webkit-box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;\n  box-shadow: 0 0 0px 1000px rgba(255, 255, 255, 0.15) inset !important;\n}\n\n.formulario-login input::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\n\n.formulario-login input:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\n.formulario-login input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\n.formulario-login input:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\nbutton.button-login {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(28, 59, 101, 1);\n  bottom: 0;\n  font-size: 20px;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 1)!important;\n  text-transform: uppercase;\n  width: 100%;\n  height: 60px;\n  border: none;\n}\n\nbutton.button-login:hover {\n  background-color: rgba(28, 59, 101, 1);\n  color: rgba(255, 255, 255, 1)!important;\n  border: none;\n}\n\nbutton.button-login:active {\n  background-color: rgba(28, 59, 101, 1);\n  color: rgba(255, 255, 255, 1)!important;\n  border: none;\n}\n\nbutton.button-login:disabled {\n  background-color: rgba(28, 59, 101, 1);\n  cursor: progress;\n  color: #FFF;\n  border: none;\n}\n\n/*Captcha*/\n\n.captcha {\n  font-family: 'Inter', sans-serif;\n  background-color: #FFF;\n  padding: 20px 10px;\n}\n\n.captcha p {\n  width: 100%;\n  font-size: 15px;\n  margin-top: 10px;\n}\n\n#mainCaptcha {\n  width: 90%;\n  background-color: transparent;\n  color: black;\n  text-align: center;\n  padding: 0px;\n}\n\n.text-center {\n  text-align: center;\n}\n\nbutton.btn-refresh-catpcha {\n  width: 10%;\n  background-color: transparent;\n  padding: 0px;\n  border: none;\n}\n\nbutton.btn-refresh-catpcha:hover {\n  background-color: transparent;\n  border: none;\n}\n\nbutton.btn-refresh-catpcha:active {\n  background-color: transparent;\n  border: none;\n}\n\ninput.captcha-recuperar-senha {\n  padding: 8px;\n  width: 100%;\n  /* background-color: rgba(95, 169, 192, 1); */\n  border-radius: 0px!important;\n  border: none;\n  color: rgba(255, 255, 255, 1);\n  font-size: 16px;\n}\n\n.g-recaptcha {\n  display: inline-block;\n}\n\ninput.captcha-recuperar-senha::-webkit-input-placeholder {\n  color: rgba(255, 255, 255, 1)!important;\n}\n\ninput.captcha-recuperar-senha:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\ninput.captcha-recuperar-senha::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\ninput.captcha-recuperar-senha:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: rgba(255, 255, 255, 1)!important;\n}\n\nbutton.button2 {\n  margin-top: 30px!important;\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  padding: 0px;\n}\n\nbutton.button2:hover {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n}\n\nbutton.button2:active {\n  background-color: transparent;\n  border: none;\n  color: rgba(28, 59, 101, 1);\n  background-color: transparent;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\nbutton.button2 span {\n  font-family: 'Inter', sans-serif;\n  font-size: 16px;\n  margin-left: 8px;\n  font-weight: bold;\n}\n\n/*Tela logado*/\n\n.logado {\n  font-family: 'Inter', sans-serif;\n  background-color: rgba(147, 191, 98, 1);\n  color: rgba(255, 255, 255, 1);\n}\n\n.logado-ok {\n  font-size: 50px;\n  margin: 30px 0px 10px 0px;\n}\n\n.bem-vindo {\n  font-size: 20px;\n  text-transform: uppercase;\n}\n\n.img-bottom {\n\n  height: 60px;\n  /*max-width: 650px;*/\n  vertical-align: middle;\n  margin-bottom: 30px;\n  /*position: absolute;*/\n}\n\n/*Login com erro*/\n\n.erro-login {\n  color: rgba(106, 34, 35, 1);\n  margin-top: 5px;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.inicial-body.is-showing {\n  display: block;\n}\n\n.inicial-body2.is-showing {\n  display: block;\n}\n\n.inicial-body3.is-showing {\n  display: block;\n}\n\n.animate-out {\n  -webkit-animation: out 600ms ease-in-out;\n  animation: out 600ms ease-in-out;\n}\n\n.animate-in {\n  -webkit-animation: in 400ms ease-in-out;\n  animation: in 400ms ease-in-out;\n  display: block;\n}\n\n.animate-up {\n  -webkit-transform: rotateY(0deg);\n  transform: rotateY(0deg);\n}\n\n.form-control {\n  font-family: 'Inter', sans-serif;\n}\n\nhtml,\nbody {\n  height: 100%;\n}\n\nbody {\n  overflow: auto;\n}\n\n.vertical-center {\n  min-height: 100%;\n  min-height: 99vh;\n\n  /* Make it a flex container */\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -moz-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n\n  -webkit-box-pack: center;\n  -moz-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n}\n\n.jumbotron.vertical-center {\n  margin-bottom: 0;\n}\n\n#loginInput {\n  padding-left: 50px;\n}\n\n#loginSenha {\n  padding-left: 50px;\n}\n\n.inicial-wrap.px-0.img-bottom div {\n  padding-bottom: 15px;\n}\n\n.formulario-login .form-group>img {\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  left: 0;\n  text-align: center;\n  padding: 15px;\n}\n\n@-webkit-keyframes out {\n  0% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: rotateY(-90deg);\n    transform: rotateY(-90deg);\n  }\n}\n\n@keyframes out {\n  0% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: rotateY(-90deg);\n    transform: rotateY(-90deg);\n  }\n}\n\n@-webkit-keyframes in {\n  0% {\n    opacity: 0;\n    -webkit-transform: rotateY(90deg);\n    transform: rotateY(90deg);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n\n@keyframes in {\n  0% {\n    opacity: 0;\n    -webkit-transform: rotateY(90deg);\n    transform: rotateY(90deg);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: rotateY(0deg);\n    transform: rotateY(0deg);\n  }\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1084 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6f5ddfa2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/integration/processedFiles/ProcessedFiles.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.input-button>button[data-v-6f5ddfa2] {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n#logDeAuditoriaWrapper[data-v-6f5ddfa2] {\n  width: 100%;\n}\n#divTreeGridAuditoria[data-v-6f5ddfa2] {\n  min-width: 100%;\n  min-height: 500px;\n}\n.check[data-v-6f5ddfa2] {\n  text-align: center;\n}\n.filterButton[data-v-6f5ddfa2] {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search[data-v-6f5ddfa2]{\n  width: 53.5%;\n}\n.search-button[data-v-6f5ddfa2] {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/views/integration/processedFiles/ProcessedFiles.vue?6c2726a0"],"names":[],"mappings":";AA2FA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA","file":"ProcessedFiles.vue","sourcesContent":["<template src='./processedFiles.pug' lang='pug'></template>\n\n<script>\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\n\nexport default {\n  name: 'ProcessedFiles',\n\n  components: {\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      gridId: '#processedFilesGrid',\n      treeGridCfg: {},\n      audit: {},\n      dateRange: {},\n      firstDate: new Date(),\n      finalDate: new Date(),\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      filter: {\n        entityId: null\n      },\n      result: {},\n      treeGridFileName: 'ExtratoBancario',\n      disableSearchButton: false\n    }\n  },\n\n  methods: {\n    validate () {\n      let self = this\n      return new Promise(resolve => {\n        this.$validator.validateAll().then((result) => {\n          if (result && this.$refs.dateRange.validate()) {\n            this.showTreegrid = true\n            startTreeGridLoading(self.gridId)\n            this.search().finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    search () {\n      this.disableSearchButton = true\n      let inicio = this.dateRange.fromDate\n      let fim = this.dateRange.toDate\n      let filter = {\n        inicio: inicio,\n        fim: fim,\n        lang: language.getCookieByName('language')\n      }\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchFiles', filter)\n          .then((response) => {\n            window.DisposeGrids()\n            this.result = response.data\n            this.treeGridCfg = response.data.Cfg.Layout\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            resolve()\n          }).catch((error) => {\n            this.$root.$refs.notification.error(error)\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            reject()\n          })\n      })\n    }\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.check {\n  text-align: center;\n}\n\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search{\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1085 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6fc77e22","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/TabRemittanceReport.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.margin-container[data-v-6fc77e22] {\n  margin-top: 15px;\n}\n.remittance-report[data-v-6fc77e22] {\n  height: 62vh;\n  overflow-y: auto;\n}\n.tab-footer[data-v-6fc77e22] {\n  height: 9vh;\n  border-top: 2px solid #d0d0d0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-right: 15px;\n}\n", "", {"version":3,"sources":["/./client/components/integration/remittanceIntegration/TabRemittanceReport.vue?76399b6a"],"names":[],"mappings":";AA2EA;EACA,iBAAA;CACA;AAEA;EACA,aAAA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,8BAAA;EACA,qBAAA;EAAA,cAAA;EACA,mBAAA;MAAA,0BAAA;EACA,uBAAA;MAAA,oBAAA;EACA,oBAAA;CACA","file":"TabRemittanceReport.vue","sourcesContent":["<template src='./tabRemittanceReport.pug' lang='pug'></template>\n\n<script>\nimport TreeGrid from '../../treeGrid/TreeGrid'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport { EXPORT_TREEGRID } from '../../../../build/jsonToExcel/exportRoutes.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../utils/grid-load-transition.js'\n\nexport default {\n  name: 'TabRemittanceReport',\n\n  components: {\n    TreeGrid,\n    ButtonPrimary\n  },\n\n  props: {\n    idModal: {\n      type: String\n    },\n    remittance: {\n      type: Object,\n      required: true\n    },\n    showRemovalButton: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      gridId: '#remittanceReportGrid',\n      exportUrl: EXPORT_TREEGRID,\n      treeGridCfg: {},\n      result: {},\n      showGrid: false\n    }\n  },\n\n  methods: {\n    loadTreegridReport () {\n      let filter = {\n        idRemessa: this.remittance.id\n      }\n      this.$store.dispatch('searchRemittanceSummary', filter)\n        .then(response => {\n          this.result = response.data\n          this.treeGridCfg = response.data.Cfg.Layout\n          stopTreeGridLoading(this.gridId)\n        })\n        .catch(error => {\n          stopTreeGridLoading(this.gridId)\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    openModalConfirm () {\n      $('#confirmRemittanceRemoval').modal('show')\n    },\n\n    closeModalConfirm () {\n      $('#confirmRemittanceRemoval').modal('hide')\n    }\n  },\n\n  mounted () {\n    this.showGrid = true\n    startTreeGridLoading(this.gridId)\n    this.loadTreegridReport()\n  }\n}\n</script>\n\n<style scoped>\n.margin-container {\n  margin-top: 15px;\n}\n\n.remittance-report {\n  height: 62vh;\n  overflow-y: auto;\n}\n\n.tab-footer {\n  height: 9vh;\n  border-top: 2px solid #d0d0d0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 15px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1086 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-72a54622","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/classificationCriteria/NewClassificationCriteria.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.marged-button[data-v-72a54622] {\n  margin-left: 10px;\n}\n.alert-icon[data-v-72a54622] {\n  margin-right: 10px;\n  color: red;\n  font-size: 20px;\n}\n.alert-text[data-v-72a54622] {\n  color: red;\n  font-size: 15px;\n}\n", "", {"version":3,"sources":["/./client/components/registration/conciliationPlan/classificationCriteria/NewClassificationCriteria.vue?4d338515"],"names":[],"mappings":";AAyPA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,WAAA;EACA,gBAAA;CACA","file":"NewClassificationCriteria.vue","sourcesContent":["<template src='./newClassificationCriteria.pug' lang='pug'></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport ConciliationField from './ConciliationField'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'NewClassificationCriteria',\n\n  components: {\n    vSelect,\n    PageTitle,\n    FilterPortlet,\n    ConciliationField,\n    ButtonPrimary\n  },\n\n  props: {\n    criteriaToEdit: {\n      type: Object,\n      default: null\n    },\n    categories: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    febraban: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    banks: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    accounts: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    attributesCfg: {\n      type: Array,\n      default: null,\n      required: true\n    },\n    conciliationFields: {\n      type: Array,\n      default: null,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      requestSent: false,\n      criteria: {},\n      filteredAccounts: [],\n      attributes: []\n    }\n  },\n\n  watch: {\n    criteriaToEdit: {\n      handler (newVal, oldVal) {\n        if (newVal) {\n          this.criteria = {...newVal, classificacaoCampos: [...newVal.classificacaoCampos]}\n          if (this.criteria.categoria) {\n            this.criteria.categoria.label = this.criteria.categoria.numero + ' - ' + this.criteria.categoria.nome\n          }\n          if (this.criteria.conta) {\n            this.criteria.conta.label = this.criteria.conta.id !== 0 ? (this.criteria.conta.nome + ' (' +\n              this.criteria.conta.numAgencia + (this.criteria.conta.digAgencia ? ('-' + this.criteria.conta.digAgencia) : '') +\n              '/' +\n              this.criteria.conta.conta + (this.criteria.conta.digConta ? ('-' + this.criteria.conta.digConta) : '') +\n              ')' +\n              (this.criteria.conta.ativo === undefined || this.criteria.conta.ativo === null || this.criteria.conta.ativo ? '' : (' [' + this.$t('contaBancaria.labels.inativa') + ']')))\n              : this.criteria.conta.nome\n          }\n\n          if (this.criteria.banco) {\n            this.criteria.banco.label = (this.criteria.banco.codigo ? this.criteria.banco.codigo + '-' : '') + this.criteria.banco.nomeFantasia\n          }\n\n          if (this.criteria.categoriaFebraban) {\n            this.criteria.categoriaFebraban.label = this.criteria.categoriaFebraban.codigo + ' - ' + this.criteria.categoriaFebraban.descricao\n          }\n        } else {\n          this.criteria = {\n            ativo: true,\n            relevante: true,\n            banco: {},\n            conta: {},\n            categoria: {},\n            categoriaFebraban: {},\n            classificacaoCampos: [],\n            criterioEmUso: false\n          }\n        }\n      }\n    },\n    accounts: {\n      handler (newVal, oldVal) {\n        this.filteredAccounts = [...newVal]\n      }\n    }\n  },\n\n  methods: {\n    filterAccounts (val) {\n      this.criteria.conta = null\n      if (val && val.codigo) {\n        this.criteria.banco = val\n        this.filteredAccounts = this.accounts.filter(account => {\n          return account.banco.codigo === val.codigo || account.id === 0\n        })\n      } else {\n        this.criteria.banco = null\n        this.filteredAccounts = [...this.accounts]\n      }\n    },\n\n    back () {\n      this.$emit('change-managing-plan')\n      this.errors.clear()\n      this.requestSent = false\n    },\n\n    validate (event) {\n      this.requestSent = true\n      let self = this\n      event.preventDefault()\n      this.$validator.validateAll().then((result) => {\n        if (result) {\n          let isAllFieldsValid = true\n          Object.entries(self.$refs).map(refArray => {\n            if (refArray[1] && refArray[1].length > 0) {\n              refArray[1][0].$validator.validateAll().then((fieldValidation) => {\n                if (isAllFieldsValid) {\n                  isAllFieldsValid = fieldValidation\n                }\n              })\n            }\n          })\n          setTimeout(() => {\n            if (isAllFieldsValid) {\n              self.addCriteria()\n            } else {\n              this.requestSent = false\n            }\n          }, 500)\n        } else {\n          this.requestSent = false\n        }\n      })\n    },\n\n    addCriteria () {\n      this.$emit('add-criteria-to-plan', this.criteria)\n      this.back()\n    },\n\n    setValuesFieldsCategory (category) {\n      if (category) {\n        this.criteria.tipoLancamento = category.tipo\n        if (!this.criteria.hasOwnProperty('descricao') || this.criteria.descricao === '') {\n          this.$set(this.criteria, 'descricao', category.nome)\n          const field = this.$validator.fields.find({name: 'criteria.descricao'})\n          field.reset()\n          this.$validator.errors.remove(field.name)\n        }\n      } else {\n        this.criteria.categoria = null\n        this.criteria.tipoLancamento = null\n      }\n    },\n\n    addClassificationField () {\n      if (!this.criteria.classificacaoCampos) {\n        this.criteria.classificacaoCampos = []\n      }\n\n      this.criteria.classificacaoCampos.push({\n        idCriterioClassificacao: this.criteria.idCriterioClassificacao,\n        idAtributoCfg: this.attributesCfg[0],\n        nomeAtributo: this.attributesCfg[0].children[0],\n        conciliacaoCampo: this.conciliationFields[0],\n        key: this.criteria.classificacaoCampos.length + 1\n      })\n    },\n\n    removeClassificationField (field) {\n      const index = this.criteria.classificacaoCampos.findIndex(item => item.key === field.key)\n      this.criteria.classificacaoCampos.splice(index, 1)\n      if (field.id) {\n        if (!this.criteria.idsCamposRemovidos) {\n          this.criteria.idsCamposRemovidos = []\n        }\n        this.criteria.idsCamposRemovidos.push(field.id)\n      }\n    },\n\n    changeFieldAttCfg (item) {\n      this.criteria.classificacaoCampos.map(mappedItem => {\n        // identifica a configuracao alterada\n        if (mappedItem.key === item.concField.key) {\n          // atualiza campo\n          mappedItem.idAtributoCfg = item.cfg\n          if (item.cfg) {\n            // atualiza lista de atributos com os filhos do conjunto\n            this.attributes = item.cfg.children\n            let att = item.cfg.children.find(itemAtt => itemAtt.id === (mappedItem.nomeAtributo instanceof Object ? mappedItem.nomeAtributo.id : mappedItem.nomeAtributo))\n            mappedItem.nomeAtributo = att !== null && att !== undefined ? att : item.cfg.children[0]\n          } else {\n            mappedItem.nomeAtributo = null\n            this.attributes = []\n          }\n        }\n      })\n    },\n\n    changeFieldAttName (item) {\n      this.criteria.classificacaoCampos.map(mappedItem => {\n        // identifica a configuracao\n        if (mappedItem.key === item.concField.key) {\n          // atualiza campo\n          mappedItem.nomeAtributo = item.att\n        }\n      })\n    },\n\n    changeFieldAttConciliationField (item) {\n      this.criteria.classificacaoCampos.map(mappedItem => {\n        // identifica a configuracao\n        if (mappedItem.key === item.concField.key) {\n          // atualiza campo\n          mappedItem.conciliacaoCampo = item.field\n        }\n      })\n    }\n  }\n}\n</script>\n\n<style scoped>\n.marged-button {\n  margin-left: 10px;\n}\n\n.alert-icon {\n  margin-right: 10px;\n  color: red;\n  font-size: 20px;\n}\n\n.alert-text {\n  color: red;\n  font-size: 15px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1087 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-72f81e1a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/changeApplicationModal/ChangeApplicationModal.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.pad-20 {\n  padding: 20px;\n}\n#modal-troca-app .modal-lg {\n  width: 62vw;\n}\n", "", {"version":3,"sources":["/./client/components/modals/changeApplicationModal/ChangeApplicationModal.vue?8a1fa9ca"],"names":[],"mappings":";AA6LA;EACA,cAAA;CACA;AAEA;EACA,YAAA;CACA","file":"ChangeApplicationModal.vue","sourcesContent":["<template src='./changeApplicationModal.pug' lang='pug'></template>\n\n<script>\nimport Modal from '../modal/Modal'\nimport ButtonApplication from '../../buttons/buttonApplication/ButtonApplication'\nimport idioma from '../../../../build/language/index'\nimport aplicacaoEnum from '../../../enum/aplicacaoEnum'\n\nexport default {\n  name: 'ChangeApplicationModal',\n\n  components: {\n    Modal,\n    ButtonApplication\n  },\n\n  data () {\n    return {\n      equalsCartoesImg: require('../../../assets/icones_app/cartao_azul.svg'),\n      equalsBankingImg: require('../../../assets/icones_app/banco_branco.svg'),\n      equalsExtratoImg: require('../../../assets/icones_app/extrato_azul.svg'),\n      equalsCobrancaImg: require('../../../assets/icones_app/cobranca_zaul.svg'),\n      equalsBandeirasImg: require('../../../assets/icones_app/bandeira_azul.svg'),\n      aplicacoes: []\n    }\n  },\n\n  computed: {\n    applicationList () {\n      return this.$store.getters.clientApps\n    },\n\n    openAppChangeModal () {\n      return this.$store.getters.openAppChangeModal\n    },\n\n    modalWidthByAppList (index) {\n      let style = ''\n      switch (this.aplicacoes.length) {\n        case 2:\n          style = 'col-xs-6'\n          break\n        case 3:\n          style = 'col-xs-4'\n          break\n        case 4:\n          style = 'col-xs-3'\n          break\n        case 5:\n          style = 'col-xs-2'\n          break\n        default:\n          style = 'col-xs-6'\n          break\n      }\n      return style\n    }\n  },\n\n  watch: {\n    openAppChangeModal () {\n      if (this.$store.getters.isLoggedIn) {\n        this.loadAplications()\n      }\n    }\n  },\n\n  methods: {\n    loadAplications () {\n      this.aplicacoes = []\n      this.applicationList.forEach(appId => {\n        if (appId !== aplicacaoEnum.BANDEIRAS && appId !== aplicacaoEnum.APLICATIVO) {\n          this.aplicacoes.push(this.mountAppObject(appId))\n        }\n      })\n      this.aplicacoes.sort(function (x, y) {\n        // true values first\n        return (x.active === y.active) ? 0 : x.active ? -1 : 1\n      })\n      this.showModal()\n    },\n\n    showModal () {\n      $('#modal-troca-app').modal({\n        backdrop: 'static',\n        keyboard: false\n      })\n\n      setTimeout(() => {\n        this.aplicacoes.forEach(app => {\n          this.normilizeMArgin(app.id)\n        })\n      }, 100)\n    },\n\n    closeModal () {\n      $('#modal-troca-app').modal('hide')\n    },\n\n    abrirEqualsCartoes () {\n      $('#modal-troca-app').modal('hide')\n    },\n\n    calcWidth (app) {\n      let base = ''\n      switch (this.aplicacoes.length) {\n        case 2:\n          base = 'col-xs-6'\n          break\n        case 3:\n          base = 'col-xs-4'\n          break\n        case 4:\n          base = 'col-xs-3'\n          break\n        case 5:\n          base = 'col-xs-2'\n          app.id === 8 ? base += ' col-xs-offset-1' : ''\n          break\n      }\n      return base\n    },\n\n    normilizeMArgin (id) {\n      let image = document.getElementsByName('rounded-div-image-' + id)\n      if (image && image.length > 0) {\n        image[0].style.margin = '0 auto'\n      }\n    },\n\n    mountAppObject (id) {\n      let self = this\n      let app = {\n        id: id,\n        click: function () {\n          return self.trocaAplicacao(id)\n        }\n      }\n      switch (id) {\n        case 1:\n          app.descricao = this.$t('trocaApp.aplicacoes.cartoes')\n          app.imagem = this.equalsCartoesImg\n          app.active = false\n          break\n        case 5:\n          app.descricao = this.$t('trocaApp.aplicacoes.extrato')\n          app.imagem = this.equalsExtratoImg\n          app.active = false\n          break\n        case 6:\n          app.descricao = this.$t('trocaApp.aplicacoes.cobranca')\n          app.imagem = this.equalsCobrancaImg\n          app.active = false\n          break\n        case 8:\n          app.descricao = this.$t('trocaApp.aplicacoes.banking')\n          app.imagem = this.equalsBankingImg\n          app.active = true\n          app.click = this.closeModal\n          break\n      }\n      return app\n    },\n\n    trocaAplicacao (idAplicacao) {\n      let app = {\n        idAplicacao: idAplicacao,\n        lang: idioma.getCookieByName('language')\n      }\n      this.$store.dispatch('trocaAplicacao', app)\n        .then((response) => {\n          window.open(response, '_self')\n          this.closeModal()\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n          this.closeModal()\n        })\n    },\n\n    aplicacaoIndisponivel () {\n      this.$root.$refs.notification.warning(this.$t('GENERAL'), this.$t('trocaApp.erro.aplicacaiIndisponivel'))\n      this.closeModal()\n    }\n  }\n}\n</script>\n\n<style lang='css'>\n.pad-20 {\n  padding: 20px;\n}\n\n#modal-troca-app .modal-lg {\n  width: 62vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1088 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-73ba95ea","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/notFound/NotFound.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.vertical-center {\n  /* Make it a flex container */\n  display: -ms-flexbox;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.bg-tela-login:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n.bg-tela-login:after {\n  bottom: 0;\n}\n.bg-tela-login {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: linear-gradient(to right, #223768, #00C3BE);\n  height: auto !important;\n  min-height: 100vh;\n}\n.middle-white-box {\n  height: 485px;\n  width: 774px;\n  background-color: #FFF;\n  display: table;\n  text-align: center;\n}\n.not-found-img {\n  width: 245px;\n  height: 287px;\n}\n.image-container {\n  display: table-cell;\n}\n.image-container img {\n  display: block;\n  margin: 1.5vh auto;\n}\np.big-txt {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #646464;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\n", "", {"version":3,"sources":["/./client/components/views/notFound/NotFound.vue?07f13576"],"names":[],"mappings":";AAkCA;EACA,8BAAA;EAGA,qBAAA;EAEA,cAAA;;EAEA,gDAAA;EAIA,uBAAA;EACA,oBAAA;;EAEA,YAAA;EAIA,sBAAA;EAEA,wBAAA;CACA;AAEA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oBAAA;EAIA,wDAAA;EACA,wBAAA;EACA,kBAAA;CACA;AAEA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;CACA;AAEA;EACA,aAAA;EACA,cAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,eAAA;EACA,mBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;CACA","file":"NotFound.vue","sourcesContent":["<template lang=\"pug\" src=\"./notFound.pug\"></template>\n\n<script>\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport PATHS from '../../../router/routesMap.js'\n\nexport default {\n  name: 'NotFound',\n\n  components: {\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      imageNotFound: require('../../../assets/notFound/notFound.png')\n    }\n  },\n\n  computed: {\n    client () {\n      return this.$store.getters.client\n    }\n  },\n\n  methods: {\n    goHome () {\n      location.href = this.client ? PATHS.HOME : PATHS.LOGIN\n    }\n  }\n}\n</script>\n\n<style>\n.vertical-center {\n  /* Make it a flex container */\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -moz-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n\n  -webkit-box-pack: center;\n  -moz-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n}\n\n.bg-tela-login:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n\n.bg-tela-login:after {\n  bottom: 0;\n}\n\n.bg-tela-login {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: -webkit-linear-gradient(left, #1C3B65, #40B9BB);\n  background: -o-linear-gradient(right, #223768, #00C3BE);\n  background: -moz-linear-gradient(right, #223768, #00C3BE);\n  background: linear-gradient(to right, #223768, #00C3BE);\n  height: auto !important;\n  min-height: 100vh;\n}\n\n.middle-white-box {\n  height: 485px;\n  width: 774px;\n  background-color: #FFF;\n  display: table;\n  text-align: center;\n}\n\n.not-found-img {\n  width: 245px;\n  height: 287px;\n}\n\n.image-container {\n  display: table-cell;\n}\n\n.image-container img {\n  display: block;\n  margin: 1.5vh auto;\n}\n\np.big-txt {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #646464;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1089 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-743a74ea","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/bankAccounts/List.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.margin-bottom {\n  margin-bottom: 10px;\n}\n.status-aceite-1{\n  color: green !important;\n  font-weight: bold !important;\n}\n.status-aceite-0{\n  color: red !important;\n  font-weight: bold !important;\n}\n.status-aceite-2{\n  color: orange !important;\n  font-weight: bold !important;\n}\n.status-aceite-3{\n  color: #147d96 !important;\n  font-weight: bold !important;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/bankAccounts/List.vue?21aa22cc"],"names":[],"mappings":";AAmPA;EACA,oBAAA;CACA;AACA;EACA,wBAAA;EACA,6BAAA;CACA;AACA;EACA,sBAAA;EACA,6BAAA;CACA;AACA;EACA,yBAAA;EACA,6BAAA;CACA;AACA;EACA,0BAAA;EACA,6BAAA;CACA","file":"List.vue","sourcesContent":["<template src='./list.pug' lang='pug'></template>\n\n<script>\nimport { Event } from 'vue-tables-2'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport ConfirmModal from '../../../modals/confirmModal/ConfirmModal'\nimport LoadingPlaceholder from '../../../loading/LoadingPlaceholder'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport customSorter from '../../../../utils/customSorter.js'\nimport { filterByBank, filterByAgency, filterByAccount, filterByStatus } from '../../../../utils/customFilters.js'\nimport { generateLoadingRows } from '../../../../utils/grid-load-transition.js'\nimport PATHS from '../../../../router/routesMap.js'\n\nconst templatesWhenIsLoaded = {\n  nome: (h, row) => row.nome,\n  banco: (h, row) => row.banco.codigo + '-' + row.banco.nomeFantasia,\n  agencia: (h, row) => row.numAgencia + (row.digAgencia ? '-' + row.digAgencia : ''),\n  conta: (h, row) => row.conta + (row.digConta ? '-' + row.digConta : ''),\n  ofdaStatus: (h, row) => row.ofdaStatusText,\n  status: (h, row) => row.statusText\n}\n\nexport default {\n  name: 'BankAccountsList',\n\n  components: {\n    PageTitle,\n    ButtonPrimary,\n    LoadingPlaceholder,\n    ConfirmModal\n  },\n\n  data () {\n    return {\n      bankAccountIdToRemove: null,\n      requestSentRemove: false,\n      isLoadingData: true,\n      showToggleInactiveAccounts: false,\n      showInactiveAccounts: false,\n      allBankAccounts: null,\n      bankAccounts: generateLoadingRows(10),\n      columns: ['nome', 'banco', 'agencia', 'conta', 'ofdaStatus', 'status', 'acoes'],\n      options: {\n        columnsClasses: { 'acoes': 'col-md-1', 'nome': 'col-md-2', 'banco': 'col-md-2', 'agencia': 'col-md-2', 'numeroConta': 'col-md-2', 'status': 'col-md-1', 'ofdaStatus': 'col-md-2' },\n        headings: {\n          conta: this.$t('contaBancaria.labels.numeroConta'),\n          agencia: this.$t('contaBancaria.labels.agencia'),\n          banco: this.$t('contaBancaria.labels.banco'),\n          nome: this.$t('contaBancaria.labels.nome'),\n          ofdaStatus: this.$t('ofda.titulo'),\n          status: this.$t('contaBancaria.labels.status'),\n          acoes: this.$t('administracao.perfilAcesso.labels.acoes')\n        },\n        templates: {\n          banco: LoadingPlaceholder,\n          agencia: LoadingPlaceholder,\n          conta: LoadingPlaceholder,\n          acoes: LoadingPlaceholder,\n          status: LoadingPlaceholder,\n          ofdaStatus: LoadingPlaceholder,\n          nome: LoadingPlaceholder\n        },\n        filterable: ['nome'],\n        customFilters: [{\n          name: 'banco',\n          callback: filterByBank\n        }, {\n          name: 'agencia',\n          callback: filterByAgency\n        }, {\n          name: 'conta',\n          callback: filterByAccount\n        }, {\n          name: 'status',\n          callback: filterByStatus\n        }],\n        filterByColumn: true,\n        perPageValues: [],\n        texts: {\n          count: '',\n          noResults: this.$t('dataTable.labels.semResultados'),\n          filterBy: '',\n          filterPlaceholder: this.$t('dataTable.labels.filtrar')\n        },\n        sortable: ['nome', 'banco', 'agencia', 'conta', 'status', 'ofdaStatus'],\n        sortIcon: {\n          is: ''\n        },\n        pagination: { chunk: 5 },\n        perPage: Number.MAX_SAFE_INTEGER,\n        customSorting: {\n          banco: (ascending) => {\n            return (a, b) => {\n              let lastA = a.banco.codigo\n              let lastB = b.banco.codigo\n              if (ascending) {\n                return lastA <= lastB ? 1 : -1\n              }\n              return lastA >= lastB ? 1 : -1\n            }\n          },\n          agencia: (ascending) => {\n            return (a, b) => {\n              // Cria instÂncia de valor apresentado no template da table para ordenação\n              let lastA = a.agencia\n              lastA.agencia = a.numAgencia + (a.digAgencia ? '-' + a.digAgencia : '')\n\n              let lastB = b.agencia\n              lastB.agencia = b.numAgencia + (b.digAgencia ? '-' + b.digAgencia : '')\n\n              return customSorter.stringSorter(ascending, lastA, lastB, 'agencia')\n            }\n          },\n          conta: function (ascending) {\n            return function (a, b) {\n              return customSorter.stringSorter(ascending, a, b, 'conta')\n            }\n          },\n          nome: function (ascending) {\n            return function (a, b) {\n              return customSorter.stringSorter(ascending, a, b, 'nome')\n            }\n          },\n          status: function (ascending) {\n            return function (a, b) {\n              return customSorter.stringSorter(ascending, a, b, 'statusText')\n            }\n          }\n        },\n        cellClasses: {\n          ofdaStatus: [\n            {\n              class: 'status-aceite-3',\n              condition: row => !row.optIn\n            },\n            {\n              class: 'status-aceite-0',\n              condition: row => row.optIn && row.optIn.statusAceite === '0'\n            },\n            {\n              class: 'status-aceite-1',\n              condition: row => row.optIn && ((!!row.optIn.belvoLinkId && row.optIn.statusAceite === '2') || row.optIn.statusAceite === '1')\n            },\n            {\n              class: 'status-aceite-3',\n              condition: row => row.optIn && !row.optIn.belvoLinkId && row.optIn.statusAceite === '2'\n            }\n          ]\n        }\n      }\n    }\n  },\n\n  methods: {\n    handleFilter (event, column) {\n      Event.$emit(`vue-tables.filter::${column}`, event.currentTarget.value)\n    },\n\n    edit (bankAccountId) {\n      trackAnalyticsEvent(this, 'edit-click', 'edit-conta-bancaria', 'edit-conta-bancaria')\n\n      this.$store.dispatch('setBankAccountToEdit', bankAccountId)\n        .then((response) => {\n          this.$router.push(PATHS.NEW_BANK_ACCOUNT)\n        })\n    },\n\n    newBankAccount () {\n      this.$router.push(PATHS.NEW_BANK_ACCOUNT)\n    },\n\n    loadBankAccounts () {\n      let url = '/bankAccounts/'\n      this.isLoadingData = true\n      this.$store.dispatch('getBankAccounts', url)\n        .then((response) => {\n          this.allBankAccounts = response.data.data\n          this.allBankAccounts.map(acc => {\n            acc.statusText = acc.ativo ? this.$t('contaBancaria.labels.ativa') : this.$t('contaBancaria.labels.inativa')\n            if (acc.optIn) {\n              if (acc.optIn.statusAceite === '0') {\n                acc.ofdaStatusText = this.$t('ofda.statusAceite.revogado')\n              } else if (acc.optIn.statusAceite === '2') {\n                acc.ofdaStatusText = this.$t('ofda.statusAceite.autorizar')\n              } else if (acc.optIn.statusAceite === '1') {\n                acc.ofdaStatusText = this.$t('ofda.statusAceite.autorizado')\n              }\n            } else {\n              acc.ofdaStatusText = this.$t('ofda.statusAceite.autorizar')\n            }\n          })\n          this.showAccounts()\n          this.isLoadingData = false\n          this.options.templates = templatesWhenIsLoaded\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    showAccounts () {\n      this.bankAccounts = this.allBankAccounts\n    },\n\n    handleRemove (bankAccountIdToRemove) {\n      this.bankAccountIdToRemove = bankAccountIdToRemove\n      $('#confirmRemoveBankAccount').modal('show')\n    },\n\n    remove () {\n      trackAnalyticsEvent(this, 'remove-click', 'remove-conta-bancaria', 'remove-conta-bancaria')\n      if (this.bankAccountIdToRemove) {\n        this.requestSentRemove = true\n        this.$store.dispatch('removeBankAccount', this.bankAccountIdToRemove)\n          .then((response) => {\n            this.$root.$refs.notification.success('contaBancaria.sucesso.remover')\n            this.bankAccountIdToRemove = null\n            $('#confirmRemoveBankAccount').modal('hide')\n            this.loadBankAccounts()\n          })\n          .catch((error) => {\n            this.$root.$refs.notification.error(error.message)\n          })\n          .finally(() => {\n            this.requestSentRemove = false\n          })\n      }\n    },\n\n    closeModalConfirm () {\n      this.bankAccountIdToRemove = null\n      $('#confirmRemoveBankAccount').modal('hide')\n    }\n  },\n\n  created () {\n    this.loadBankAccounts()\n  }\n}\n</script>\n\n<style>\n.margin-bottom {\n  margin-bottom: 10px;\n}\n.status-aceite-1{\n  color: green !important;\n  font-weight: bold !important;\n}\n.status-aceite-0{\n  color: red !important;\n  font-weight: bold !important;\n}\n.status-aceite-2{\n  color: orange !important;\n  font-weight: bold !important;\n}\n.status-aceite-3{\n  color: #147d96 !important;\n  font-weight: bold !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1090 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-74c6103a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/myAccountModal/MyAccountModal.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Fix da posição da label de controle em negrito */\n.col-xs-12.row-filter-medium > label.control-label[data-v-74c6103a] {\n  width: 100%;\n}\n#edit-password-btn[data-v-74c6103a] {\n  margin-left: 10px;\n  color: #fff;\n  padding: 0;\n  background-color: #34b8ba;\n  height: 20px;\n  width: 20px;\n  border: none;\n\n  border: 1px solid transparent;\n  border-color: #46b8da;\n  border-radius: 4px;\n}\nbutton.btn-change-password[data-v-74c6103a],\nbutton.btn-change-password[data-v-74c6103a]:hover,\nbutton.btn-change-password[data-v-74c6103a]:focus {\n  border-color: #ccc;\n  border-left: none;\n  background: #fff;\n  box-shadow: none;\n  color: #999;\n  font-size: 18px;\n  border-radius: 0px 4px 4px 0px!important;\n}\nbutton.btn-change-password.is-danger[data-v-74c6103a]{\n  border-color: #ff3860;\n  border-left: 1px solid #ccc;\n}\n.label-bold[data-v-74c6103a] {\n  font-family: 'Inter', sans-serif !important;\nfont-weight: 700;\n}\n.is-danger[data-v-74c6103a] {\n  border-color: #ff3860;\n}\n.is-danger input[data-v-74c6103a] {\n  border-color: #ff3860;\n}\n", "", {"version":3,"sources":["/./client/components/modals/myAccountModal/MyAccountModal.vue?cffa9cde"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;AAoIA,oDAAA;AACA;EACA,YAAA;CACA;AAEA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;;EAEA,8BAAA;EACA,sBAAA;EACA,mBAAA;CACA;AAEA;;;EAGA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,yCAAA;CACA;AAEA;EACA,sBAAA;EACA,4BAAA;CACA;AAEA;EACA,4CAAA;AACA,iBAAA;CACA;AAEA;EACA,sBAAA;CACA;AAEA;EACA,sBAAA;CACA","file":"MyAccountModal.vue","sourcesContent":["<template src='./myAccountModal.pug' lang='pug'></template>\n\n<script>\nimport Modal from '../modal/Modal'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\n\nexport default {\n  name: 'MyAccountModal',\n\n  components: {\n    Modal,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      name: this.$store.getters.user,\n      email: this.$store.getters.userEmail,\n      accessProfileName: this.$store.getters.accessProfileName,\n      currentPassword: '',\n      newPassword: '',\n      confirmNewPassword: '',\n      changingPassword: false,\n      hidePasswordIcon: 'fa-eye',\n      saveBtnDisabled: false,\n      differentNewPassword: false\n    }\n  },\n\n  computed: {\n    openMyAccountModal () {\n      return this.$store.getters.openMyAccountModal\n    }\n  },\n\n  watch: {\n    openMyAccountModal () {\n      if (this.$store.getters.isLoggedIn) {\n        this.showModal()\n      }\n    }\n  },\n\n  methods: {\n    showModal () {\n      this.name = this.$store.getters.user\n      this.accessProfileName = this.$store.getters.accessProfileName\n      this.$nextTick(() => {\n        this.$validator.reset()\n      })\n      $('#my-account-modal').modal({\n        backdrop: 'static',\n        keyboard: false\n      })\n    },\n\n    validate () {\n      this.saveBtnDisabled = true\n      this.differentNewPassword = false\n      this.$validator.validateAll()\n        .then((result) => {\n          if (result && this.changingPassword) {\n            // Se estiver mudando a senha\n            if (this.newPassword !== '' && this.currentPassword !== '') {\n              if (this.newPassword !== this.confirmNewPassword) {\n                this.differentNewPassword = true\n                this.saveBtnDisabled = false\n              } else {\n                this.updateAccount()\n              }\n            } else {\n              this.saveBtnDisabled = false\n            }\n          } else if (result) {\n            // Se estiver mundando só o nome\n            this.updateAccount()\n          } else {\n            this.saveBtnDisabled = false\n          }\n        })\n    },\n\n    closeModal () {\n      this.changingPassword = false\n      this.currentPassword = ''\n      this.newPassword = ''\n      this.confirmNewPassword = ''\n      $('#my-account-modal').modal('hide')\n    },\n\n    updateAccount () {\n      this.$store.dispatch('updateAccount', {\n        name: this.name,\n        email: this.email,\n        currentPassword: this.currentPassword,\n        newPassword: this.newPassword\n      }).then((user) => {\n        this.$store.dispatch('updateUserName', user.nome)\n        this.closeModal()\n      }).then(() => {\n        this.$root.$refs.notification.success('modalMinhaConta.sucesso.salvar')\n        this.saveBtnDisabled = false\n      }).catch((error) => {\n        this.$root.$refs.notification.error(error.message)\n        this.saveBtnDisabled = false\n      })\n    },\n\n    showPassword (idInput, idButton) {\n      this.togglePasswordInputType(idInput, idButton)\n    },\n\n    togglePasswordInputType (idInput, idButton) {\n      if (document.getElementById(idInput).type === 'text') {\n        document.getElementById(idInput).type = 'password'\n        document.querySelector(idButton).style.color = '#999'\n      } else {\n        document.getElementById(idInput).type = 'text'\n        document.querySelector(idButton).style.color = '#333'\n      }\n    },\n\n    changePassword () {\n      trackAnalyticsEvent(this, 'button-click', 'button-default-component', 'edit-password-btn')\n      this.changingPassword = true\n    }\n  }\n}\n</script>\n\n<style scoped>\n/* Fix da posição da label de controle em negrito */\n.col-xs-12.row-filter-medium > label.control-label {\n  width: 100%;\n}\n\n#edit-password-btn {\n  margin-left: 10px;\n  color: #fff;\n  padding: 0;\n  background-color: #34b8ba;\n  height: 20px;\n  width: 20px;\n  border: none;\n\n  border: 1px solid transparent;\n  border-color: #46b8da;\n  border-radius: 4px;\n}\n\nbutton.btn-change-password,\nbutton.btn-change-password:hover,\nbutton.btn-change-password:focus {\n  border-color: #ccc;\n  border-left: none;\n  background: #fff;\n  box-shadow: none;\n  color: #999;\n  font-size: 18px;\n  border-radius: 0px 4px 4px 0px!important;\n}\n\nbutton.btn-change-password.is-danger{\n  border-color: #ff3860;\n  border-left: 1px solid #ccc;\n}\n\n.label-bold {\n  font-family: 'Inter', sans-serif !important;\nfont-weight: 700;\n}\n\n.is-danger {\n  border-color: #ff3860;\n}\n\n.is-danger input {\n  border-color: #ff3860;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1091 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7511b8fb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/attributesSet/New.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.categories-header[data-v-7511b8fb] {\n  margin-bottom: 0;\n}\n.categories-header>div[data-v-7511b8fb] {\n  text-align: center;\n}\n.list-complete-enter[data-v-7511b8fb],\n.list-complete-leave-active[data-v-7511b8fb] {\n  opacity: 0;\n  transition: all .2s;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/attributesSet/New.vue?e70d5c48"],"names":[],"mappings":";AAwLA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;;EAEA,WAAA;EACA,oBAAA;CACA","file":"New.vue","sourcesContent":["<template src='./new.pug' lang='pug'></template>\n\n<script>\n\nimport vSelect from 'vue-select'\nimport Draggable from 'vuedraggable'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport Attribute from '../../../registration/attributesSet/Attribute'\nimport NewAttributeModal from '../../../registration/attributesSet/NewAtributeModal'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport looseDeepEqual from '../../../../utils/looseDeepEqual'\nimport PATHS from '../../../../router/routesMap.js'\n\nexport default {\n  name: 'AttributesSetNew',\n\n  components: {\n    vSelect,\n    Draggable,\n    PageTitle,\n    FilterPortlet,\n    ButtonPrimary,\n    Attribute,\n    NewAttributeModal\n  },\n\n  data () {\n    return {\n      requestSent: false,\n      editingAttribute: {},\n      isLoadingData: false,\n      attributeSet: {\n        id: null,\n        name: '',\n        linkType: {\n          type: null,\n          description: null\n        },\n        inUse: false\n      },\n      linkTypes: [\n        {\n          type: 'E',\n          description: this.$t('conjuntoAtributo.labels.E')\n        },\n        {\n          type: 'MF',\n          description: this.$t('conjuntoAtributo.labels.MF')\n        },\n        {\n          type: 'CL',\n          description: this.$t('conjuntoAtributo.labels.CL')\n        }\n      ],\n      attributes: [],\n      shown: false\n    }\n  },\n\n  computed: {\n    attributeSetToEdit () {\n      return this.$store.getters.attributeSetToEdit\n    },\n\n    attTypesAviable () {\n      let aviables = []\n      if (!!this.$store.getters.attributesSetList && this.$store.getters.attributesSetList.length > 0) {\n        aviables = this.linkTypes.filter(type => {\n          let link = this.$store.getters.attributesSetList.find(item => item.linkType === type.type)\n          return link === undefined || link === null\n        })\n      } else {\n        aviables = this.linkTypes\n      }\n      return aviables\n    }\n  },\n\n  watch: {\n    attributeSet: {\n      handler () {\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.attributeSet, attributes: [...this.attributes] }))\n      },\n      deep: true\n    },\n    attributes: {\n      handler () {\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.attributeSet, attributes: [...this.attributes] }))\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    updateAttributesList (newList) {\n      this.attributes = newList\n      this.$root.$refs.notification.info('conjuntoAtributo.sucesso.adicionadoOk')\n    },\n\n    createOrEditAttribute (attOrder) {\n      if (!attOrder) {\n        this.editingAttribute = null\n      } else {\n        this.editingAttribute = this.attributes[attOrder - 1]\n        trackAnalyticsEvent(this, 'action-click', 'edit-atributo', attOrder)\n      }\n      this.shown = true\n    },\n\n    validate () {\n      this.$validator.validateAll()\n        .then(result => {\n          if (!this.checkAttributesWithSameName()) {\n            this.$root.$refs.notification.error('conjuntoAtributo.erro.nomesDuplicados', 'conjuntoAtributo.erro.criarConjunto')\n          } else if (result) {\n            this.saveAttributeSet({\n              id: this.attributeSet.id,\n              name: this.attributeSet.name,\n              linkType: this.attributeSet.linkType,\n              attributes: this.attributes\n            })\n          } else {\n            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'conjuntoAtributo.erro.criarConjunto')\n          }\n        })\n    },\n\n    checkAttributesWithSameName () {\n      const attributeNames = this.attributes.map(att => att.name)\n      return attributeNames.length === new Set(attributeNames).size\n    },\n\n    backToList () {\n      this.$router.push(PATHS.LIST_ATTRIBUTES_SET)\n    },\n\n    saveAttributeSet (attributeSet) {\n      this.requestSent = true\n      this.$store.dispatch('saveAttributeSet', attributeSet)\n        .then(response => {\n          this.$root.$refs.notification.success(response.message)\n          this.$store.dispatch('setHasUnsavedChanges', false)\n          this.$router.push(PATHS.LIST_ATTRIBUTES_SET)\n        })\n        .catch(err => {\n          this.$root.$refs.notification.error(err.message)\n          if (this.attributeSetToEdit && this.attributeSetToEdit.id) {\n            this.$store.dispatch('getAttributeSetById', this.attributeSetToEdit.id)\n              .then(attributeSet => {\n                this.$store.dispatch('setAttributesSetToEdit', attributeSet)\n              })\n              .catch(error => this.$root.$refs.notification.error(error.message))\n          }\n        })\n        .finally(() => {\n          this.requestSent = false\n        })\n    },\n\n    removeAttributeHandler (attOrder) {\n      trackAnalyticsEvent(this, 'action-click', 'remove-atributo', attOrder)\n      this.attributes.splice(attOrder - 1, 1)\n    }\n  },\n\n  created () {\n    if (this.attributeSetToEdit) {\n      this.attributeSet = { ...this.attributeSetToEdit }\n      this.attributeSet.linkType.description = this.$t(this.attributeSet.linkType.description)\n      this.attributes = [...this.attributeSet.attributes]\n    }\n    this.defaultObject = { ...this.attributeSet, attributes: [...this.attributes] }\n  },\n\n  beforeDestroy () {\n    this.$store.dispatch('setHasUnsavedChanges', false)\n  }\n}\n\n</script>\n\n<style scoped>\n.categories-header {\n  margin-bottom: 0;\n}\n\n.categories-header>div {\n  text-align: center;\n}\n\n.list-complete-enter,\n.list-complete-leave-active {\n  opacity: 0;\n  transition: all .2s;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1092 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-777d8892","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/pageTitle/PageTitle.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.page-title-wrapper[data-v-777d8892] {\n  font-family: 'Inter', sans-serif;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #d0d0d0;\n}\nh1.primary-title[data-v-777d8892] {\n  font-size: 2em;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #1d436a;\n}\nh4.subtitle[data-v-777d8892] {\n  margin-top: 5px;\n  color: #1d436a;\n}\n.button-wrapper[data-v-777d8892] {\n  width: auto;\n  float: right;\n}\n", "", {"version":3,"sources":["/./client/components/layout/pageTitle/PageTitle.vue?9b0a4f76"],"names":[],"mappings":";AAcA;EACA,iCAAA;EACA,oBAAA;EACA,iCAAA;CACA;AAEA;EACA,eAAA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,YAAA;EACA,aAAA;CACA","file":"PageTitle.vue","sourcesContent":["<template src='./pageTitle.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'PageTitle',\n\n  props: [\n    'title',\n    'subTitle'\n  ]\n}\n</script>\n\n<style scoped>\n.page-title-wrapper {\n  font-family: 'Inter', sans-serif;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #d0d0d0;\n}\n\nh1.primary-title {\n  font-size: 2em;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #1d436a;\n}\n\nh4.subtitle {\n  margin-top: 5px;\n  color: #1d436a;\n}\n\n.button-wrapper {\n  width: auto;\n  float: right;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1093 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7947ef80","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/SelectedEntries.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.mid-button {\n  margin-left: 2vw !important;\n  margin-right: 2vw !important;\n  background-color: #40b9bb;\n  border: 1px solid #40b9bb;\n  color: #FFF;\n}\n.mid-button:hover {\n  background-color: #379d9e;\n  border: 1px solid #379d9e;\n  color: #FFF;\n}\n.mid-button[disabled] {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n  color: #FFF;\n}\n.mid-button[disabled]:hover {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n}\n.pending-divergence {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  margin-top: 3vh;\n  font-size: 2vh;\n}\n.divergence-value {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 4vh;\n  color: red;\n}\n.conciliated-value {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 4vh;\n  color: green;\n}\n.clear-link {\n  text-decoration: underline;\n  margin-right: 2%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.search-button {\n  min-width: 7vw !important;\n}\n.total-values {\n  padding-top: 30px;\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n}\n.row-flex {\n  display: -ms-flexbox;\n  display: flex;\n  /* equal height of the children */\n}\n.col-flex {\n  -ms-flex: 1;\n      flex: 1;\n  /* additionally, equal width */\n}\n.span-tag {\n  background-color: #f3f8fe;\n  border-radius: 5px;\n  border: 1px solid #cccccc;\n  color: #1a3b5f;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 3px 3px 3px 6px;\n}\n.close-tag-btn {\n  border: 0px;\n  background: transparent;\n  padding: 0px 0px 0px 5px;\n  margin: 0px;\n}\n.close-tag-span {\n  color: #1a3b5f !important;\n  font-size: 12px;\n  padding-right: 5px;\n  font-weight: bold;\n}\n.checkbox-centered {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin-left: 20px\n}\n", "", {"version":3,"sources":["/./client/components/reports/manualConciliation/SelectedEntries.vue?ac777bce"],"names":[],"mappings":";AA0RA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,0BAAA;CACA;AAEA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,WAAA;CACA;AAEA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;CACA;AAEA;EACA,2BAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,kCAAA;CACA;AAEA;EACA,YAAA;MAAA,QAAA;EACA,+BAAA;CACA;AAEA;EACA,0BAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;CACA;AAEA;EACA,YAAA;EACA,wBAAA;EACA,yBAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,sBAAA;MAAA,wBAAA;EACA,iBAAA;CACA","file":"SelectedEntries.vue","sourcesContent":["<template lang=\"pug\" src=\"./selectedEntries.pug\"></template>\n\n<script>\nimport moment from 'moment'\nimport ReopenAllotmentModal from './modals/ReopenAllotmentModal'\nimport ApplyModal from './modals/ApplyModal'\nimport JustifyModal from './modals/JustifyModal'\nimport EntryManager from './EntryManager'\nimport Justifications from './Justifications'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport { maskThousand } from '../../../utils/numberMasker.js'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\nimport FuncionalidadeIdEnum from '../../../enum/funcionalidadeId.js'\n\nexport default {\n  name: 'SelectedEntries',\n\n  components: {\n    ReopenAllotmentModal,\n    ApplyModal,\n    JustifyModal,\n    EntryManager,\n    Justifications,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      internalEntries: [],\n      bankEntries: [],\n      justifications: []\n    }\n  },\n\n  computed: {\n    allotmentMovementRemoved () {\n      return this.$store.getters.allotmentMovementRemoved\n    },\n\n    allotmentId () {\n      return this.$store.getters.idAllotment\n    },\n\n    hasPendingFinMov () {\n      return this.$store.getters.hasPendingFinMov\n    },\n\n    hasPendingBankStat () {\n      return this.$store.getters.hasPendingBankStat\n    },\n\n    totalAmountForInternalEntries () {\n      return this.$store.getters.totalAmountForInternalEntries\n    },\n\n    totalAmountForBankEntries () {\n      return this.$store.getters.totalAmountForBankEntries\n    },\n\n    totalAmountToJustify () {\n      return this.calculateTotalToJustify()\n    },\n\n    totalDivergence () {\n      let value = Number(Number(this.totalAmountForBankEntries) - Number(this.totalAmountForInternalEntries) - Number(this.totalAmountToJustify)).toFixed(2)\n      return Number(value).toFixed(2)\n    },\n\n    totalTransformed () {\n      return maskThousand(this.totalDivergence)\n    },\n\n    divergentInstance () {\n      return Number(this.totalDivergence).toFixed(2) !== '0.00' || this.totalAmoutOfEntriesMov > 0 || this.totalAmountOfEntriesBank > 0\n    },\n\n    canReopen () {\n      return this.allotmentId && !this.hasPendingBankStat && !this.hasPendingFinMov\n    },\n\n    canConciliate () {\n      return (this.internalEntries.length > 0 && this.bankEntries.length > 0 && (this.hasPendingBankStat || this.hasPendingFinMov) || this.arrayJustify.length > 0)\n    },\n\n    canResumeConciliation () {\n      return this.canConciliate\n    },\n\n    finMovAdded () {\n      return this.$store.getters.finMovAdded\n    },\n\n    bankStatAdded () {\n      return this.$store.getters.bankStatAdded\n    },\n\n    totalAmountOfEntriesBank () {\n      return this.bankEntries.length\n    },\n\n    totalAmoutOfEntriesMov () {\n      return this.internalEntries.length\n    },\n\n    sumMov () {\n      let value = 0.00\n      this.internalEntries.forEach(entry => {\n        value = this.round(value, 2) + this.round(entry.valor, 2)\n      })\n      this.sumAmount = value\n      return maskThousand(value)\n    },\n\n    rangeDateMov () {\n      let startDate = new Date('01/01/9999')\n      let endDate = new Date('01/01/1900')\n      this.internalEntries.forEach(entry => {\n        let date = entry.dtLanc ? entry.dtLanc : entry.data\n        if (moment(date).isBefore(startDate)) {\n          startDate = date\n        }\n\n        if (moment(date).isAfter(endDate)) {\n          endDate = date\n        }\n      })\n\n      return this.totalAmoutOfEntriesMov > 0\n        ? startDate === endDate\n          ? moment(startDate).format('DD/MM/YYYY')\n          : moment(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + moment(endDate).format('DD/MM/YYYY')\n        : ' - '\n    },\n\n    sumBank () {\n      let value = 0.00\n      this.bankEntries.forEach(entry => {\n        value = this.round(value, 2) + this.round(entry.valor, 2)\n      })\n      this.sumAmount = value\n      return maskThousand(value)\n    },\n\n    rangeDateBank () {\n      let startDate = new Date('01/01/9999')\n      let endDate = new Date('01/01/1900')\n      this.bankEntries.forEach(entry => {\n        let date = entry.dtLanc ? entry.dtLanc : entry.data\n        if (moment(date).isBefore(startDate)) {\n          startDate = date\n        }\n\n        if (moment(date).isAfter(endDate)) {\n          endDate = date\n        }\n      })\n\n      return this.totalAmountOfEntriesBank > 0\n        ? startDate === endDate\n          ? moment(startDate).format('DD/MM/YYYY')\n          : moment(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + moment(endDate).format('DD/MM/YYYY')\n        : ' - '\n    },\n\n    arrayJustify () {\n      return this.$store.getters.arrayJustify\n    },\n\n    resumeAutomaticProcessing () {\n      return this.$store.getters.isConciliationResumed\n    },\n\n    verifyAuthorizationResumeProcess () {\n      if (this.$store.getters.allowedFuncionalities) {\n        return !!this.$store.getters.allowedFuncionalities\n                .find(element => element === FuncionalidadeIdEnum.RETOMAR_CONCILIACAO)\n      }\n      return false\n    }\n  },\n\n  watch: {\n    finMovAdded () {\n      this.internalEntries = this.$store.getters.finMovAdded\n      this.verifyAndCleanJustify()\n    },\n\n    bankStatAdded () {\n      this.bankEntries = this.$store.getters.bankStatAdded\n      this.verifyAndCleanJustify()\n    },\n\n    arrayJustify () {\n      this.justifications = this.$store.getters.arrayJustify\n    }\n  },\n\n  methods: {\n    // Limpa as jutificativas adicionadas, caso o usuário tenha removido todos os lançamentos do lado do movimento financeirou ou do extrato bancário\n    verifyAndCleanJustify () {\n      if (this.internalEntries.length === 0 || this.bankEntries.length === 0) {\n        this.cleanJustify()\n      }\n    },\n\n    // Limpa as justificativas adicionadas\n    cleanJustify () {\n      this.$store.dispatch('cleanArrayJustify')\n        .then(() => {\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    reaopenAllotment () {\n      $('#reopenAllotmentModal').modal({ backdrop: 'static', keyboard: false })\n    },\n\n    applyConciliation () {\n      $('#applyModal').modal({ backdrop: 'static', keyboard: false })\n    },\n\n    justifyAllotment () {\n      $('#justifyModal').modal({ backdrop: 'static', keyboard: false })\n    },\n\n    // Calcula o valor total a ser justificado\n    calculateTotalToJustify () {\n      let value = 0.00\n      this.arrayJustify.forEach(justify => {\n        value += justify.valor\n      })\n      return value\n    },\n\n    // Retorna a classe que seta a cor do valor de divergência, caso seja = 0, a cor é verde, se não a cor é vermelha\n    getDivergenceAmoutClass () {\n      return this.divergentInstance ? 'divergence-value' : 'conciliated-value'\n    },\n\n    clearMovTable () {\n      trackAnalyticsEvent(this, 'conciliacao-manual', 'click-limpar-movimentacoes')\n\n      let movList = this.internalEntries.slice()\n      this.$store.dispatch('removeAllMovFin', movList)\n        .then(() => {\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    clearBankTable () {\n      trackAnalyticsEvent(this, 'conciliacao-manual', 'click-limpar-extratos')\n\n      let bankList = this.bankEntries.slice()\n      this.$store.dispatch('removeAllBankStat', bankList)\n        .then(() => {\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    },\n\n    removeAllotment () {\n      let data = {\n        idAllotmentRemoved: this.$store.getters.idRowAllotmentMovementAdded,\n        idAllotmentToRemove: this.$store.getters.idRowAllotmentMovementAdded\n      }\n      this.$store.dispatch('removeAllotment', data)\n    },\n\n    round (value, decimals) {\n      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)\n    },\n\n    changeReaplyConciliation (event) {\n      this.$store.dispatch('setReaplyConciliation', event.target.checked)\n    }\n  }\n}\n</script>\n\n<style>\n.mid-button {\n  margin-left: 2vw !important;\n  margin-right: 2vw !important;\n  background-color: #40b9bb;\n  border: 1px solid #40b9bb;\n  color: #FFF;\n}\n\n.mid-button:hover {\n  background-color: #379d9e;\n  border: 1px solid #379d9e;\n  color: #FFF;\n}\n\n.mid-button[disabled] {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n  color: #FFF;\n}\n\n.mid-button[disabled]:hover {\n  background-color: #c7c7c7;\n  border: 1px solid #c7c7c7;\n}\n\n.pending-divergence {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  margin-top: 3vh;\n  font-size: 2vh;\n}\n\n.divergence-value {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 4vh;\n  color: red;\n}\n\n.conciliated-value {\n  text-align: center;\n  font-weight: bold;\n  font-family: 'Inter', sans-serif;\n  font-size: 4vh;\n  color: green;\n}\n\n.clear-link {\n  text-decoration: underline;\n  margin-right: 2%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.search-button {\n  min-width: 7vw !important;\n}\n\n.total-values {\n  padding-top: 30px;\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n}\n\n.row-flex {\n  display: flex;\n  /* equal height of the children */\n}\n\n.col-flex {\n  flex: 1;\n  /* additionally, equal width */\n}\n\n.span-tag {\n  background-color: #f3f8fe;\n  border-radius: 5px;\n  border: 1px solid #cccccc;\n  color: #1a3b5f;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 3px 3px 3px 6px;\n}\n\n.close-tag-btn {\n  border: 0px;\n  background: transparent;\n  padding: 0px 0px 0px 5px;\n  margin: 0px;\n}\n\n.close-tag-span {\n  color: #1a3b5f !important;\n  font-size: 12px;\n  padding-right: 5px;\n  font-weight: bold;\n}\n\n.checkbox-centered {\n  display: flex;\n  justify-content: center;\n  margin-left: 20px\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1094 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7d8ec08a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/conciliationPlan/New.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.categories-header[data-v-7d8ec08a] {\n  margin-bottom: 0;\n}\n.categories-header>div[data-v-7d8ec08a] {\n  text-align: center;\n}\n.list-complete-enter[data-v-7d8ec08a],\n.list-complete-leave-active[data-v-7d8ec08a] {\n  opacity: 0;\n  transition: all .2s;\n}\n.check-group[data-v-7d8ec08a] {\n  margin-left: 10px\n}\n.concil-criterias-header-acoes-tit[data-v-7d8ec08a] {\n  width: 8.5vw;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n.criterias-header-acoes-tit[data-v-7d8ec08a] {\n  width: 5vw;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n.crit-font-sized[data-v-7d8ec08a] {\n  font-size: 1.06vh;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/conciliationPlan/New.vue?5483fdfc"],"names":[],"mappings":";AAukBA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;;EAEA,WAAA;EACA,oBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;CACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;CACA;AAEA;EACA,kBAAA;CACA","file":"New.vue","sourcesContent":["<template src='./new.pug' lang='pug'></template>\n\n<script>\nimport { VueTabs, VTab } from 'vue-nav-tabs'\nimport Draggable from 'vuedraggable'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport ClassificationCriteria from '../../../registration/conciliationPlan/classificationCriteria/ClassificationCriteria'\nimport NewClassificationCriteria from '../../../registration/conciliationPlan/classificationCriteria/NewClassificationCriteria'\nimport ConciliationCriteria from '../../../registration/conciliationPlan/conciliationCriteria/ConciliationCriteria'\nimport NewConciliationCriteria from '../../../registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria'\nimport idioma from '../../../../../build/language/index'\nimport customSorter from '../../../../utils/customSorter.js'\nimport looseDeepEqual from '../../../../utils/looseDeepEqual'\nimport { maskThousand } from '../../../../utils/numberMasker'\nimport PATHS from '../../../../router/routesMap.js'\n\nexport default {\n  name: 'ConciliationPlanNew',\n\n  components: {\n    VueTabs,\n    VTab,\n    Draggable,\n    PageTitle,\n    FilterPortlet,\n    ButtonPrimary,\n    ClassificationCriteria,\n    NewClassificationCriteria,\n    ConciliationCriteria,\n    NewConciliationCriteria\n  },\n\n  data () {\n    return {\n      isManagingClassCriteria: false,\n      requestSent: false,\n      planName: null,\n      planToEdit: null,\n      classificationCriterias: [],\n      conciliationCriterias: [],\n      tabMain: '',\n      criteriaToEdit: null,\n      defaultCriteria: {\n        ativo: true,\n        relevante: true,\n        criterioEmUso: false,\n        classificacaoCampos: [],\n        conta: null\n      },\n      concilCriteriaToEdit: null,\n      defaultConcilCriteria: {\n        ativo: true,\n        criterioEmUso: false,\n        conciliacaoCampos: [],\n        conta: null,\n        banco: null,\n        descricao: '',\n        estabelecimentos: [],\n        diasDiferencaMin: 0,\n        diasDiferencaMax: 0,\n        valorDiferencaMax: 0.00,\n        valorDivergenciaMax: 0.00,\n        motivoOcorrencia: null\n      },\n      idsCriteriasRemoved: [],\n      categories: [],\n      febraban: [],\n      banks: [],\n      accounts: [],\n      attributesCfgClassif: [],\n      attributesCfg: [],\n      conciliationFields: [],\n      conciliationFieldsBanking: [], // apenas tipo = 'B'\n      occurrenceReasons: [],\n      isManagingConcilCriteria: false,\n      idioma: idioma,\n      idsConciliationCriteriasRemoved: [],\n      errorCaptured: false\n    }\n  },\n\n  computed: {\n    planToEditId () {\n      return this.$store.getters.planToEditId\n    },\n    portletTitle () {\n      if (this.planToEditId) {\n        return this.$t('planoConciliacao.titulos.editarPlanoConciliacao')\n      } else {\n        return this.$t('planoConciliacao.titulos.novoPlanoConciliacao')\n      }\n    },\n    tabClass () {\n      return this.$t('planoConciliacao.labels.criteriosClassificacao')\n    },\n    tabConcil () {\n      return this.$t('planoConciliacao.labels.criteriosConciliacao')\n    }\n  },\n\n  watch: {\n    planName: {\n      handler () {\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject,\n          {\n            id: this.planToEditId,\n            nome: this.planName,\n            criteriosClassificacao: this.classificationCriterias,\n            criteriosConciliacao: this.conciliationCriterias\n          }\n        ))\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    savePlan () {\n      this.classificationCriterias.map(criteria => {\n        if (criteria.classificacaoCampos.length > 0) {\n          criteria.classificacaoCampos.map(classif => {\n            classif.idAtributoCfg = classif.idAtributoCfg && classif.idAtributoCfg.id ? classif.idAtributoCfg.id : classif.idAtributoCfg\n            classif.nomeAtributo = classif.nomeAtributo && classif.nomeAtributo.id ? classif.nomeAtributo.id : classif.nomeAtributo\n          })\n        }\n      })\n      this.conciliationCriterias.map(criteria => {\n        if (criteria.valorDiferencaMax && (typeof criteria.valorDiferencaMax === 'string')) {\n          criteria.valorDiferencaMax = parseFloat(this.removeMonetaryMask(criteria.valorDiferencaMax))\n        }\n\n        if (criteria.valorDivergenciaMax && (typeof criteria.valorDivergenciaMax === 'string')) {\n          criteria.valorDivergenciaMax = parseFloat(this.removeMonetaryMask(criteria.valorDivergenciaMax))\n        }\n        if (criteria.conciliacaoCampos.length > 0) {\n          criteria.conciliacaoCampos.map(field => {\n            // Caso o objeto 'atributo' exista e não seja vazio, normaliza campos\n            if (field.atributo && Object.keys(field.atributo).length > 0 && field.atributo.constructor === Object) {\n              field.atributo.atributoCfg = { id: field.atributo.atributoCfg && field.atributo.atributoCfg.id ? field.atributo.atributoCfg.id : field.atributo.atributoCfg }\n              field.atributo.nomeAtributo = field.atributo.nomeAtributo && field.atributo.nomeAtributo.id ? field.atributo.nomeAtributo.id : field.atributo.nomeAtributo\n            }\n            // Caso o objeto 'banco' exista e não seja vazio, normaliza campos\n            if (field.banco && Object.keys(field.banco).length > 0 && field.banco.constructor === Object) {\n              criteria.banco = field.banco\n            }\n            // Caso o objeto 'conta' exista e não seja vazio, normaliza campos\n            if (field.conta && Object.keys(field.conta).length > 0 && field.conta.constructor === Object) {\n              criteria.conta = field.conta\n            }\n          })\n        }\n      })\n\n      const plan = {\n        nome: this.planName,\n        criteriosClassificacao: this.classificationCriterias,\n        criteriosConciliacao: this.conciliationCriterias,\n        idsCriteriosClassificacaoRemovidos: this.idsCriteriasRemoved,\n        idsCriteriosConciliacaoRemovidos: this.idsConciliationCriteriasRemoved\n      }\n\n      if (this.planToEditId != null) {\n        plan.id = this.planToEditId\n      }\n      this.requestSent = true\n      this.$store.dispatch('savePlan', plan).then((response) => {\n        this.$root.$refs.notification.success(response.data.message)\n        this.$store.dispatch('setHasUnsavedChanges', false)\n        this.$router.push(PATHS.LIST_CONCILIATION_PLANS)\n      }).catch((error) => {\n        this.$root.$refs.notification.error(error.message)\n      })\n      .finally(() => {\n        this.requestSent = false\n      })\n    },\n\n    loadPlan () {\n      let self = this\n      this.$store.dispatch('getPlan', this.planToEditId).then((response) => {\n        self.planToEdit = response.data.data[0]\n        self.planName = self.planToEdit.nome\n        self.classificationCriterias = self.planToEdit.criteriosClassificacao.sort((a, b) => Number(a.ordem) - Number(b.ordem))\n        self.classificationCriterias.map(crit => {\n          crit.classificacaoCampos.map(field => {\n            field.key = field.id\n          })\n        })\n\n        self.conciliationCriterias = self.planToEdit.criteriosConciliacao.sort((a, b) => Number(a.ordem) - Number(b.ordem))\n        self.conciliationCriterias.map(crit => {\n          crit.conciliacaoCampos.map(field => {\n            field.key = field.id\n          })\n\n          if (crit.valorDivergenciaMax !== null && crit.valorDivergenciaMax !== undefined) {\n            crit.valorDivergenciaMax = self.idioma.getMoneyMaskByLanguage().prefix + '' + maskThousand(crit.valorDivergenciaMax)\n          } else {\n            crit.valorDivergenciaMax = ''\n          }\n\n          if (crit.valorDiferencaMax !== null && crit.valorDiferencaMax !== undefined) {\n            crit.valorDiferencaMax = self.idioma.getMoneyMaskByLanguage().prefix + '' + maskThousand(crit.valorDiferencaMax)\n          } else {\n            crit.valorDiferencaMax = ''\n          }\n          if (crit.banco) {\n            crit.banco.label = (crit.banco.codigo ? crit.banco.codigo + '-' : '') + crit.banco.nomeFantasia\n          }\n\n          if (crit.conta) {\n            crit.conta.label = crit.conta.id !== 0 ? (crit.conta.nome + ' (' +\n              crit.conta.numAgencia + (crit.conta.digAgencia ? ('-' + crit.conta.digAgencia) : '') +\n              '/' +\n              crit.conta.conta + (crit.conta.digConta ? ('-' + crit.conta.digConta) : '') +\n              ')' +\n              (crit.conta.ativo === undefined || crit.conta.ativo === null || crit.conta.ativo ? '' : (' [' + this.$t('contaBancaria.labels.inativa') + ']')))\n              : crit.$t('planoConciliacao.labels.nenhumItem')\n          }\n        })\n\n        self.defaultObject = {\n          id: self.planToEditId,\n          nome: self.planName,\n          criteriosClassificacao: self.classificationCriterias,\n          criteriosConciliacao: self.conciliationCriterias\n        }\n        if (self.classificationCriterias && self.classificationCriterias.length > 0) {\n          self.updateCriteriasAttCfg()\n          self.updateCriteriasConcFields()\n        }\n        if (self.conciliationCriterias && self.conciliationCriterias.length > 0) {\n          self.updateConcilCriteriasAttCfg()\n        }\n      }).catch((error) => {\n        self.$root.$refs.notification.error(error.message)\n      })\n    },\n\n    validate (event) {\n      event.preventDefault()\n      this.changeClassifOrder()\n      this.changeConcilOrder()\n      this.$validator.validateAll().then((result) => {\n        if (result) {\n          this.savePlan()\n        } else {\n          this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'planoConciliacao.erro.salvar')\n        }\n      })\n    },\n\n    back () {\n      this.$router.push(PATHS.LIST_CONCILIATION_PLANS)\n    },\n\n    createOrEditCriteria (criteria = {}) {\n      if (!criteria || !criteria.ordem) {\n        criteria = {...this.defaultCriteria, classificacaoCampos: [...this.defaultCriteria.classificacaoCampos]}\n      }\n\n      this.criteriaToEdit = {...criteria, classificacaoCampos: [...criteria.classificacaoCampos]}\n      this.isManagingClassCriteria = !this.isManagingClassCriteria\n    },\n\n    updateCriteriasList (criteria = {}) {\n      if (this.classificationCriterias == null) {\n        this.classificationCriterias = []\n      }\n\n      this.checkDescriptionExistsCriteria(criteria)\n\n      if (criteria.idCriterioClassificacao || criteria.ordem) {\n        const index = this.classificationCriterias.findIndex(crit => {\n          return crit.idCriterioClassificacao\n            ? (crit.idCriterioClassificacao === criteria.idCriterioClassificacao)\n            : (crit.ordem === criteria.ordem)\n        })\n\n        if (index === -1) {\n          throw new Error('Not found')\n        }\n        this.classificationCriterias.splice(index, 1, criteria)\n        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAlterado')\n      } else {\n        criteria.planoConciliacao = this.planToEditId\n        criteria.ordem = this.classificationCriterias.length + 1\n        this.classificationCriterias.push(criteria)\n        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAdicionado')\n      }\n\n      this.criteriaToEdit = {...this.defaultCriteria, classificacaoCampos: [...this.defaultCriteria.classificacaoCampos]}\n    },\n\n    checkDescriptionExistsCriteria (criteria = {}) {\n      const existsDescriptionCriteria = this.classificationCriterias.find(crit => crit.descricao === criteria.descricao && crit.ordem !== criteria.ordem)\n\n      if (existsDescriptionCriteria) {\n        this.errorCaptured = true\n        this.$root.$refs.notification.warning('planoConciliacao.validacao.criterioNomeRepetido')\n        throw new Error('There is already a criterion with this description')\n      }\n    },\n\n    removeCriteriaHandler (criteria = {}) {\n      const index = this.classificationCriterias.findIndex(crit => crit === criteria)\n      this.classificationCriterias.splice(index, 1)\n      if (criteria.idCriterioClassificacao) {\n        this.idsCriteriasRemoved.push(criteria.idCriterioClassificacao)\n      }\n    },\n\n    updateCriteriasAttCfg () {\n      this.classificationCriterias.map(crit => {\n        crit.classificacaoCampos.map(field => {\n          field.idAtributoCfg = this.attributesCfgClassif.find(cfg => cfg.id === field.idAtributoCfg.toString())\n          setTimeout(() => {\n            if (field.idAtributoCfg && field.idAtributoCfg.children && field.idAtributoCfg.children.length > 0) {\n              field.nomeAtributo = field.idAtributoCfg.children.find(att => att.id === field.nomeAtributo)\n            }\n          }, 250)\n        })\n      })\n    },\n\n    updateConcilCriteriasAttCfg () {\n      let self = this\n      this.conciliationCriterias.map(crit => {\n        crit.conciliacaoCampos.map(field => {\n          if (field.atributo && field.atributo instanceof Object && field.atributo.atributoCfg && field.atributo.atributoCfg instanceof Object) {\n            field.atributo.atributoCfg = self.attributesCfg.find(cfg => cfg.id.toString() === (field.atributo.atributoCfg ? field.atributo.atributoCfg.id : field.atributo.atributoCfg).toString())\n            setTimeout(() => {\n              if (field.atributo.atributoCfg && field.atributo.atributoCfg.children && field.atributo.atributoCfg.children.length > 0) {\n                field.atributo.nomeAtributo = field.atributo.atributoCfg.children.find(att => att.id === field.atributo.nomeAtributo)\n              }\n            }, 250)\n          } else if (field.atributo && field.atributo instanceof String) {\n            self.attributesCfg.map(cfg => {\n              if (cfg.linkType === (field.conciliacaoCampoMovFinan ? field.conciliacaoCampoMovFinan.tipoVinculo : null)) {\n                cfg.children.map(att => {\n                  if (field.atributo === att.id) {\n                    field.atributo.atributoCfg = cfg\n                    field.atributo.nomeAtributo = att\n                  }\n                })\n              }\n            })\n          }\n        })\n      })\n    },\n\n    updateCriteriasConcFields () {\n      let self = this\n      self.classificationCriterias.map(crit => {\n        crit.classificacaoCampos.map(field => {\n          field.conciliacaoCampo = self.conciliationFieldsBanking.find(concField => {\n            if (field.conciliacaoCampo) {\n              return concField.id.toString() === field.conciliacaoCampo.id.toString()\n            }\n            return false\n          })\n        })\n      })\n    },\n\n    changeManagingClassCriteria () {\n      if (!this.errorCaptured) {\n        this.accounts = [...this.accounts]\n        this.criteriaToEdit = null\n        this.isManagingClassCriteria = !this.isManagingClassCriteria\n      }\n      this.errorCaptured = false\n    },\n\n    changeClassifOrder () {\n      this.classificationCriterias.map(crit => {\n        crit.ordem = this.classificationCriterias.findIndex(item => looseDeepEqual(item, crit)) + 1\n      })\n    },\n\n    changeConcilOrder () {\n      this.conciliationCriterias.map(crit => {\n        crit.ordem = this.conciliationCriterias.findIndex(item => looseDeepEqual(item, crit)) + 1\n      })\n    },\n\n    loadCategories () {\n      this.$store.dispatch('getCategories', {\n        url: '/conciliationPlan/loadCategories',\n        flTipoCategoria: null,\n        validarUso: false\n      }).then((response) => {\n        let catArray = []\n        response.data.forEach(cat => {\n          cat.label = cat.numero + ' - ' + cat.nome\n          catArray.push(cat)\n        })\n        // arrayDottedSorter ordena o array baseado em valores do tipo '1.1.1'\n        this.categories = customSorter.arrayDottedSorter(catArray, 'numero', 'asc')\n      }).catch((error) => {\n        this.$root.$refs.notification.error(error.data.message)\n      })\n    },\n\n    loadFebraban () {\n      this.$store.dispatch('getFebraban')\n      .then((response) => {\n        this.febraban = response.data.data\n        this.febraban.forEach(cat => {\n          cat.label = cat.codigo + ' - ' + cat.descricao\n        })\n        this.febraban.sort((a, b) => Number(a.codigo) - Number(b.codigo))\n      })\n    },\n\n    loadBanks () {\n      this.$store.dispatch('getBanks')\n      .then((response) => {\n        this.banks = response.data.data\n        this.banks.forEach(bank => {\n          bank.label = (bank.codigo ? bank.codigo + '-' : '') + bank.nomeFantasia\n        })\n        this.banks.sort((a, b) => Number(a.codigo) - Number(b.codigo))\n      })\n    },\n\n    loadBankAccounts () {\n      let url = '/bankAccounts/'\n      this.$store.dispatch('getBankAccounts', url)\n        .then((response) => {\n          this.accounts = response.data.data\n          this.accounts.forEach(account => {\n            account.label = account.id !== 0 ? (account.nome + ' (' +\n              account.numAgencia + (account.digAgencia ? ('-' + account.digAgencia) : '') +\n              '/' +\n              account.conta + (account.digConta ? ('-' + account.digConta) : '') +\n              ')' +\n              (account.ativo === undefined || account.ativo === null || account.ativo === true ? '' : (' [' + this.$t('contaBancaria.labels.inativa') + ']')))\n              : this.$t('planoConciliacao.labels.nenhumItem')\n          })\n          this.accounts.sort((a, b) => Number(a.id) - Number(b.id))\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    loadConciliationFieldsData () {\n      this.$store.dispatch('getAttributesSet').then((attributesSetList) => {\n        // somente conjuntos com atributos cadastrados\n        this.attributesCfg = attributesSetList\n        this.attributesCfgClassif = attributesSetList.filter(set => (set.children && set.children.length > 0) && (set.linkType === 'E'))\n      }).then(() => {\n        this.$store.dispatch('getConciliationFields')\n        .then((response) => {\n          // apenas campos de movimentacao bancaria\n          this.conciliationFields = response.data.data\n          this.conciliationFieldsBanking = response.data.data.filter(field => field.tipo && field.tipo === 'B')\n          this.conciliationFieldsBanking.forEach(cfg => {\n            cfg.label = cfg.nome + ' | ' + cfg.expressao\n          })\n        })\n      }).then(() => {\n        if (this.planToEditId) {\n          this.loadPlan()\n        } else {\n          this.defaultObject = {\n            id: this.planToEditId,\n            nome: this.planName,\n            criteriosClassificacao: this.classificationCriterias,\n            criteriosConciliacao: this.conciliationCriterias\n          }\n        }\n      }).catch((error) => {\n        this.$root.$refs.notification.error(error.message)\n      })\n    },\n\n    createOrEditConcilCriteria (criteria = {}) {\n      if (!criteria || !criteria.ordem) {\n        criteria = {...this.defaultConcilCriteria, conciliacaoCampos: [...this.defaultConcilCriteria.conciliacaoCampos]}\n      }\n\n      this.concilCriteriaToEdit = {...criteria, conciliacaoCampos: [...criteria.conciliacaoCampos]}\n      this.isManagingConcilCriteria = !this.isManagingConcilCriteria\n    },\n\n    removeConcilCriteriaHandler (criteria = {}) {\n      const index = this.conciliationCriterias.findIndex(crit => crit === criteria)\n      this.conciliationCriterias.splice(index, 1)\n      if (criteria.id) {\n        this.idsConciliationCriteriasRemoved.push(criteria.id)\n      }\n    },\n\n    loadOccurrences () {\n      let url = 'conciliationPlan/occurrenceReason/list'\n      this.$store.dispatch('getOccurrenceReasons', url)\n      .then((response) => {\n        this.occurrenceReasons = response.data.data\n      })\n      .catch((error) => {\n        this.$root.$refs.notification.error(error.message)\n      })\n    },\n\n    updateConcilCriteriasList (criteria = {}) {\n      if (this.conciliationCriterias == null) {\n        this.conciliationCriterias = []\n      }\n\n      this.checkDescriptionExistsConcilCriteria(criteria)\n\n      if (criteria.id || criteria.ordem) {\n        const index = this.conciliationCriterias.findIndex(crit => {\n          return crit.id\n            ? (crit.id === criteria.id)\n            : (crit.ordem === criteria.ordem)\n        })\n\n        if (index === -1) {\n          throw new Error('Not found')\n        }\n        this.conciliationCriterias.splice(index, 1, criteria)\n        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAlterado')\n      } else {\n        criteria.planoConciliacao = this.planToEditId\n        criteria.ordem = this.conciliationCriterias.length + 1\n        this.conciliationCriterias.push(criteria)\n        this.$root.$refs.notification.info('planoConciliacao.sucesso.criterioAdicionado')\n      }\n\n      this.concilCriteriaToEdit = {...this.defaultConcilCriteria, conciliacaoCampos: [...this.defaultConcilCriteria.conciliacaoCampos]}\n    },\n\n    checkDescriptionExistsConcilCriteria (criteria = {}) {\n      const existsDescriptionCriteria = this.conciliationCriterias.find(crit => crit.descricao === criteria.descricao && crit.ordem !== criteria.ordem)\n\n      if (existsDescriptionCriteria) {\n        this.errorCaptured = true\n        this.$root.$refs.notification.warning('planoConciliacao.validacao.criterioConcilNomeRepetido')\n        throw new Error('There is already a criterion with this description')\n      }\n    },\n\n    changeManagingConcilCriteria () {\n      if (!this.errorCaptured) {\n        this.concilCriteriaToEdit = null\n        this.isManagingConcilCriteria = !this.isManagingConcilCriteria\n      }\n      this.errorCaptured = false\n    },\n\n    removeMonetaryMask (value) {\n      let splittedStartBalance = value.toString().split(' ')\n\n      if (splittedStartBalance.length > 1) {\n        return splittedStartBalance[1].replace(/[.,]/g, '').replace(/(\\d{2})$/, '.$1')\n      }\n      return value.replace(/[.,]/g, '').replace(/(\\d{2})$/, '.$1')\n    }\n  },\n\n  created () {\n    this.loadOccurrences()\n    this.loadCategories()\n    this.loadBanks()\n    this.loadBankAccounts()\n    this.loadFebraban()\n    this.loadConciliationFieldsData()\n  },\n\n  beforeDestroy () {\n    this.$store.dispatch('setHasUnsavedChanges', false)\n    this.$store.dispatch('cleanPlanToEdit')\n  }\n}\n</script>\n\n<style scoped>\n.categories-header {\n  margin-bottom: 0;\n}\n\n.categories-header>div {\n  text-align: center;\n}\n\n.list-complete-enter,\n.list-complete-leave-active {\n  opacity: 0;\n  transition: all .2s;\n}\n\n.check-group {\n  margin-left: 10px\n}\n\n.concil-criterias-header-acoes-tit {\n  width: 8.5vw;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n\n.criterias-header-acoes-tit {\n  width: 5vw;\n  text-align: right;\n  padding: 0px 5px 0px 0px;\n}\n\n.crit-font-sized {\n  font-size: 1.06vh;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1095 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7dbbcb98","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/form/formSearch/FormSearch.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.search-button {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/form/formSearch/FormSearch.vue?43063302"],"names":[],"mappings":";AAsEA;EACA,eAAA;CACA","file":"FormSearch.vue","sourcesContent":["<template src='./formSearch.pug' lang='pug'></template>\n\n<script>\nimport ButtonSearch from '../../buttons/buttonSearch/ButtonSearch'\n\nexport default {\n  name: 'FormSearch',\n\n  components: {\n    ButtonSearch\n  },\n\n  props: {\n    fn: {\n      type: Function,\n      required: true\n    },\n    isDisabled: {\n      type: Boolean,\n      required: true\n    },\n    getMessages: {\n      type: Function,\n      default: () => []\n    },\n    interval: {\n      type: Number,\n      default: 2500\n    },\n    hasExportFile: {\n      type: Boolean,\n      required: true\n    },\n    exportFileFlag: {\n      type: Boolean\n    },\n    showLoadingFullPage: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      isExporting: this.exportFileFlag,\n      color: {checked: '#40b9bb', unchecked: '#E5E5E5'}\n    }\n  },\n\n  methods: {\n    send () {\n      if (!this.showLoadingFullPage) {\n        this.fn()\n        return\n      }\n\n      const params = {\n        messages: this.getMessages(),\n        interval: this.interval\n      }\n      this.$store.dispatch('loadingFullPage', params)\n      this.fn().finally(() => {\n        this.$store.dispatch('fullPageLoaded')\n      })\n    }\n  }\n}\n</script>\n\n<style>\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1096 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7fa5a10b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/classificationCriteria/ClassificationCriteria.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.attribute > .att-field[data-v-7fa5a10b] {\n  display: inline-block;\n}\n.list-complete-item[data-v-7fa5a10b]:hover {\n  cursor: move;\n  background-color: #f5f5f5;\n}\n.list-complete-item[data-v-7fa5a10b] {\n  padding-top: 18px;\n  padding-bottom: 18px;\n  height: auto;\n  word-wrap: break-word;\n  min-height: 58px;\n  border: 1px solid #ddd;\n  transition: all 1s;\n}\n.fa.action[data-v-7fa5a10b] {\n  margin: 0;\n}\n.att-field.order[data-v-7fa5a10b] {\n  margin-left: 30px;\n}\n.att-field.buttons[data-v-7fa5a10b] {\n  padding-right: 7px;\n}\n", "", {"version":3,"sources":["/./client/components/registration/conciliationPlan/classificationCriteria/ClassificationCriteria.vue?6f31b462"],"names":[],"mappings":";AAyCA;EACA,sBAAA;CACA;AAEA;EACA,aAAA;EACA,0BAAA;CACA;AAEA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA","file":"ClassificationCriteria.vue","sourcesContent":["<template src='./classificationCriteria.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'ClassificationCriteria',\n\n  props: {\n    criteria: {\n      type: Object,\n      required: true\n    },\n    order: {\n      type: Number,\n      required: true\n    },\n    handleEdit: {\n      type: Function,\n      required: true\n    },\n    handleRemove: {\n      type: Function,\n      required: true\n    }\n  },\n\n  computed: {\n    btnEditTitle () {\n      return this.criteria.criterioEmUso\n        ? this.$t('planoConciliacao.validacao.criterioEmUsoEditar')\n        : this.$t('planoConciliacao.labels.editar')\n    },\n    btnRemoveTitle () {\n      return this.criteria.criterioEmUso\n        ? this.$t('planoConciliacao.validacao.criterioEmUsoExcluir')\n        : this.$t('planoConciliacao.labels.remover')\n    }\n  }\n}\n</script>\n\n<style scoped>\n.attribute > .att-field {\n  display: inline-block;\n}\n\n.list-complete-item:hover {\n  cursor: move;\n  background-color: #f5f5f5;\n}\n\n.list-complete-item {\n  padding-top: 18px;\n  padding-bottom: 18px;\n  height: auto;\n  word-wrap: break-word;\n  min-height: 58px;\n  border: 1px solid #ddd;\n  transition: all 1s;\n}\n\n.fa.action {\n  margin: 0;\n}\n\n.att-field.order {\n  margin-left: 30px;\n}\n\n.att-field.buttons {\n  padding-right: 7px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1097 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-885acbc0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/EntryManager.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.VueTables__table {\n  margin-bottom: 1px!important;\n}\n.entry-table {\n  max-height: 237px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-width: 98%;\n}\n.manage-value {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 3vh !important;\n  text-transform: initial !important;\n}\n.manage-date {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 2vh !important;\n  text-transform: initial !important;\n}\ntd.align-right {\n  text-align: right;\n}\n", "", {"version":3,"sources":["/./client/components/reports/manualConciliation/EntryManager.vue?69648d52"],"names":[],"mappings":";AA2JA;EACA,6BAAA;CACA;AAEA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,mBAAA;EACA,6BAAA;EACA,4CAAA;EACA,0BAAA;EACA,mCAAA;CACA;AAEA;EACA,mBAAA;EACA,6BAAA;EACA,4CAAA;EACA,0BAAA;EACA,mCAAA;CACA;AAEA;EACA,kBAAA;CACA","file":"EntryManager.vue","sourcesContent":["<template lang=\"pug\" src=\"./entryManager.pug\"></template>\n\n<script>\nimport moment from 'moment'\nimport language from '../../../../build/language/index'\nimport customSorter from '../../../utils/customSorter.js'\nimport { maskThousand } from '../../../utils/numberMasker.js'\n\nmoment.locale(language.getDatePickerLanguage())\n\nexport default {\n  name: 'EntryManager',\n\n  props: {\n    entriesList: {\n      type: Array,\n      required: true\n    },\n    isInternal: {type: Boolean,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      sumAmount: 0.00,\n      columns: ['dtLanc', 'valor', 'situacao', 'acoes'],\n      options: {\n        columnsClasses: {'acoes': 'col-md-1', 'dtLanc': 'col-md-2', 'valor': 'col-md-2 align-right', 'situacao': 'col-md-2'},\n        headings: {\n          dtLanc: this.$t('conciliacaoManual.labels.data'),\n          valor: this.$t('conciliacaoManual.labels.valor'),\n          situacao: this.$t('conciliacaoManual.labels.situacao'),\n          acoes: ''\n        },\n        sortIcon: {\n          is: ''\n        },\n        templates: {\n          dtLanc: (h, row) => {\n            let date = row.dtLanc ? row.dtLanc : row.data\n            return moment(date).format('DD/MM/YYYY')\n          },\n\n          valor: (h, row) => {\n            return maskThousand(row.valor)\n          },\n\n          situacao: (h, row) => {\n            return row.situacao === 'A'\n              ? this.$t('statusConciliacao.aberto')\n              : row.situacao === 'C'\n              ? this.$t('statusConciliacao.conciliado')\n              : row.situacao === 'M'\n              ? this.$t('statusConciliacao.conciliadoManualmente')\n              : row.situacao === 'D'\n              ? this.$t('statusConciliacao.divergente')\n              : row.situacao === 'N'\n              ? this.$t('statusConciliacao.naoAplicavel')\n              : ' - '\n          }\n        },\n        filterable: false,\n        perPage: 9999,\n        perPageValues: [],\n        texts: {\n          count: '',\n          noResults: this.isInternal\n            ? this.$t('conciliacaoManual.erro.nenhumLancamentoInterno')\n            : this.$t('conciliacaoManual.erro.nenhumLancamentoBancario')\n        },\n        sortable: ['dtLanc', 'valor', 'situacao'],\n        pagination: {},\n        customSorting: {\n          dtLanc: function (ascending) {\n            return function (a, b) {\n              a.nDate = a.dtLanc ? a.dtLanc : a.data\n              b.nDate = b.dtLanc ? b.dtLanc : b.data\n              return customSorter.dateSorter(ascending, a, b, 'nDate')\n            }\n          }\n        }\n      }\n    }\n  },\n\n  computed: {\n    totalAmountOfEntries () {\n      return this.entriesList.length\n    },\n\n    sum () {\n      let valueF = 0.00\n      this.entriesList.forEach(entry => {\n        valueF += entry.valor\n      })\n      this.sumAmount = valueF\n\n      return maskThousand(valueF)\n    },\n\n    rangeDate () {\n      let startDate = new Date('01/01/9999')\n      let endDate = new Date('01/01/1900')\n      this.entriesList.forEach(entry => {\n        let date = entry.dtLanc ? entry.dtLanc : entry.data\n        if (moment(date).isBefore(startDate)) {\n          startDate = date\n        }\n\n        if (moment(date).isAfter(endDate)) {\n          endDate = date\n        }\n      })\n\n      return this.totalAmountOfEntries > 0\n      ? startDate === endDate\n      ? moment(startDate).format('DD/MM/YYYY')\n      : moment(startDate).format('DD/MM/YYYY') + '<br/>' + this.$t('dateRange.labels.ate') + '<br/>' + moment(endDate).format('DD/MM/YYYY')\n      : ' - '\n    }\n  },\n\n  watch: {\n    sum () {\n      let action = this.isInternal ? 'updateTotalAmountForInternalEntries' : 'updateTotalAmountForBankEntries'\n      this.$store.dispatch(action, this.sumAmount)\n        .then(() => {\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    }\n  },\n\n  methods: {\n    removeEntry (entry) {\n      // Remover da lista e do vuex\n      let action = this.isInternal ? 'removeFinMov' : 'removeBankStat'\n      let flag = this.isInternal ? 'hasPendingFinMov' : 'hasPendingBankStat'\n\n      this.$store.dispatch(action, entry)\n        .then(() => {\n          // Remonta a respectiva grid, para evitar problemas quando as entradas estão ordenadas\n          action === 'removeFinMov' ? window.Grids[0].Reload() : window.Grids[1].Reload()\n\n          this.$store.dispatch(flag, true)\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n        })\n    }\n  }\n}\n</script>\n\n<style>\n.VueTables__table {\n  margin-bottom: 1px!important;\n}\n\n.entry-table {\n  max-height: 237px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-width: 98%;\n}\n\n.manage-value {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 3vh !important;\n  text-transform: initial !important;;\n}\n\n.manage-date {\n  text-align: center;\n  font-weight: bold !important;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 2vh !important;\n  text-transform: initial !important;;\n}\n\ntd.align-right {\n  text-align: right;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1098 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-8bfa890c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/multiSelectModal/MultiSelectModal.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.filterButton[data-v-8bfa890c] {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search[data-v-8bfa890c] {\n  width: 53.5%;\n}\n.search-button[data-v-8bfa890c] {\n  min-width: 7vw;\n}\n.checkbox[data-v-8bfa890c] {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.func-group-labels[data-v-8bfa890c] {\n  color: #515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n.select-columns[data-v-8bfa890c] {\n  margin-bottom: 15px;\n}\n.multiselect-modal-input[data-v-8bfa890c] {\n  width: 20px !important;\n}\n.multiselect-modal-input-row[data-v-8bfa890c] {\n  margin-left: 5px !important;\n  margin-right: 3px !important;\n}\n.multiselect-modal-input-header[data-v-8bfa890c] {\n  margin: 0px 3px -5px 5px !important;\n}\n.flex-column[data-v-8bfa890c] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.group-title[data-v-8bfa890c] {\n  background-color: transparent;\n  color: #27466D;\n  font-weight: bold;\n  text-align: left;\n  border: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding-left: 0;\n}\n.group-card[data-v-8bfa890c] {\n  width: 100%;\n  margin-bottom: 0;\n  border: none;\n}\n.no-margin[data-v-8bfa890c] {\n  margin: 0;\n}\n.padded[data-v-8bfa890c] {\n  padding: 10px;\n}\n.margin-bottom[data-v-8bfa890c] {\n  margin-bottom: 10px;\n}\n.scrollable[data-v-8bfa890c] {\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden\n}\n", "", {"version":3,"sources":["/./client/components/modals/multiSelectModal/MultiSelectModal.vue?1f3d0480"],"names":[],"mappings":";AAgWA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,eAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,iBAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,uBAAA;CACA;AAEA;EACA,4BAAA;EACA,6BAAA;CACA;AAEA;EACA,oCAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,2BAAA;MAAA,uBAAA;CACA;AAEA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EAAA,cAAA;EACA,uBAAA;MAAA,oBAAA;EACA,uBAAA;MAAA,+BAAA;EACA,gBAAA;CACA;AAEA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,cAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;CACA","file":"MultiSelectModal.vue","sourcesContent":["<template src=\"./multiSelectModal.pug\" lang=\"pug\"></template>\n\n<script>\nimport BetterModal from '../betterModal/BetterModal'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'MultiSelectModal',\n\n  components: {\n    BetterModal,\n    ButtonPrimary\n  },\n\n  props: {\n    id: {\n      type: String,\n      required: true\n    },\n    data: {\n      type: Object,\n      required: true\n    },\n    dynamicColumns: {\n      type: Array,\n      default: () => []\n    },\n    objProperties: {\n      type: Object,\n      default: () => {\n        return {\n          id: 'id',\n          name: 'nome'\n        }\n      }\n    },\n    groups: {\n      type: Array,\n      default: () => []\n    },\n    groupingOptions: {\n      type: Object\n    }\n  },\n\n  data () {\n    return {\n      isEveryItemSelected: this.data.selectedItems.length === 0,\n      initialSelection: [...this.data.selectedItems],\n      selectedItems: [...this.data.selectedItems],\n      hasComputedComponentFunctions: false,\n      dataView: this.data.values,\n      currentSavedDynamicColumns: [...this.dynamicColumns.map(dynamic => dynamic.column)],\n      grouped: false,\n      isServerRequest: false,\n      showInactiveAccounts: this.data.considerInactiveAccounts\n    }\n  },\n\n  watch: {\n    dynamicColumns: {\n      handler () {\n        this.removeDynamicColumns()\n        for (const dynamic of this.dynamicColumns) {\n          this.data.columns.push(dynamic.column)\n          this.data.options.sortable.push(dynamic.column)\n          this.data.options.headings[dynamic.column] = dynamic.heading\n          this.data.options.templates[dynamic.column] = dynamic.template\n          this.currentSavedDynamicColumns.push(dynamic.column)\n        }\n      },\n      deep: true\n    },\n    'data.values': {\n      handler () {\n        if (!this.data.options.requestFunction) {\n          return\n        }\n        this.updateDataItemsState()\n      },\n      deep: true\n    },\n    selectedItems: {\n      handler () {\n        if (this.groups.length > 1 && this.groupingOptions && this.selectedItems.length === this.data.values.length) {\n          this.selectedItems = []\n        }\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    groupTheData () {\n      if (this.groups.length <= 1) {\n        return\n      }\n      const groupingHash = {}\n\n      const groupByProp = this.groupingOptions.prop.split('.')\n      const groupIdProp = this.groupingOptions.groupIdProp\n      const groupIdValueFallback = this.groupingOptions.defaultIdGroup\n\n      this.groups.forEach(group => {\n        group.dataView = []\n        if (!groupingHash[group[groupIdProp]]) {\n          groupingHash[group[groupIdProp]] = group\n        }\n      })\n      this.data.values.forEach(data => {\n        let groupingIdentifier = data\n        for (const prop of groupByProp) {\n          groupingIdentifier = groupingIdentifier[prop]\n          if (!groupingIdentifier) {\n            break\n          }\n        }\n        groupingHash[groupingIdentifier || groupIdValueFallback].dataView.push(data)\n      })\n    },\n\n    removeDynamicColumns () {\n      for (const current of this.currentSavedDynamicColumns) {\n        const index = this.data.columns.findIndex(column => column === current)\n        if (index === -1) {\n          continue\n        }\n        this.data.columns.splice(index, 1)\n        this.data.options.sortable.splice(index, 1)\n        delete this.data.options.headings[current]\n        delete this.data.options.templates[current]\n      }\n    },\n\n    defineCheckConditions () {\n      if (this.data.columns[0] !== 'check') {\n        this.data.columns.unshift('check')\n      }\n\n      this.updateDataItemsState()\n    },\n\n    updateDataItemsState () {\n      const defaultState = !this.data.options.requestFunction\n      this.dataView = this.data.values.map(value => {\n        const selected = this.selectedItems.find(selected => selected[this.objProperties.id] === value[this.objProperties.id])\n        value.checked = (this.selectedItems.length === 0 && defaultState) || !!selected\n        return value\n      })\n\n      this.isEveryItemSelected = this.data.values.every(value => value.checked)\n    },\n\n    toggleAllItens () {\n      this.isEveryItemSelected = !this.isEveryItemSelected\n      this.dataView = this.dataView.map(value => {\n        value.checked = this.isEveryItemSelected\n        const index = this.selectedItems.findIndex(selected => selected[this.objProperties.id] === value[this.objProperties.id])\n        if (index > -1 && !this.isEveryItemSelected) {\n          this.selectedItems.splice(index, 1)\n        } else if (index === -1 && this.isEveryItemSelected && this.isServerRequest) {\n          this.selectedItems.push(value)\n        }\n        return value\n      })\n      if (this.isEveryItemSelected && !this.isServerRequest) {\n        this.selectedItems = []\n      }\n    },\n\n    toggleAllGroupItens (groupIndex) {\n      const group = this.groups[groupIndex]\n      group.isEveryItemSelected = !group.isEveryItemSelected\n\n      let ignoreSearchingInSelected = false\n      if (!group.isEveryItemSelected && this.selectedItems.length === 0) {\n        for (const g of this.groups) {\n          if (g.id !== group.id) {\n            this.selectedItems.push(...g.dataView)\n          }\n        }\n        ignoreSearchingInSelected = true\n      }\n\n      group.dataView = group.dataView.map(value => {\n        value.checked = group.isEveryItemSelected\n\n        if (ignoreSearchingInSelected) {\n          return value\n        }\n\n        const index = this.selectedItems.findIndex(selected => selected[this.objProperties.id] === value[this.objProperties.id])\n        if (index > -1 && !group.isEveryItemSelected) {\n          this.selectedItems.splice(index, 1)\n        } else if (index === -1 && group.isEveryItemSelected) {\n          this.selectedItems.push(value)\n        }\n        return value\n      })\n      this.$set(this.groups, groupIndex, group)\n    },\n\n    toggleGrouped () {\n      this.grouped = !this.grouped\n\n      if (this.grouped) {\n        this.groups.forEach(group => {\n          group.isEveryItemSelected = this.selectedItems === 0 || group.dataView.every(item => item.checked)\n        })\n      } else {\n        this.isEveryItemSelected = this.selectedItems === 0 || this.dataView.every(item => item.checked)\n      }\n    },\n\n    selectItem (item) {\n      const stateSelected = !item.checked\n      this.dataView = this.dataView.map(value => {\n        if (value[this.objProperties.id] === item[this.objProperties.id]) {\n          value.checked = stateSelected\n        }\n        return value\n      })\n\n      if (stateSelected) {\n        this.selectedItems.push(item)\n      } else {\n        const index = this.selectedItems.findIndex(selected => selected[this.objProperties.id] === item[this.objProperties.id])\n        if (index > -1) {\n          this.selectedItems.splice(index, 1)\n        }\n      }\n\n      if (this.data.options.requestFunction) {\n        this.isEveryItemSelected = false\n      } else {\n        if (this.selectedItems.length === 0 || this.selectedItems.length !== this.data.values.length) {\n          this.selectedItems = this.dataView.filter(value => value.checked)\n          this.isEveryItemSelected = false\n        } else if (this.selectedItems.length === this.data.values.length) {\n          this.selectedItems = []\n          this.isEveryItemSelected = true\n        }\n      }\n    },\n\n    selectGroupItem (groupIndex, item) {\n      const group = this.groups[groupIndex]\n      const stateSelected = !item.checked\n      group.dataView = group.dataView.map(value => {\n        if (value[this.objProperties.id] === item[this.objProperties.id]) {\n          value.checked = stateSelected\n        }\n        return value\n      })\n\n      if (stateSelected) {\n        this.selectedItems.push(item)\n      } else {\n        if (this.selectedItems.length === 0) {\n          for (const g of this.groups) {\n            for (const i of g.dataView) {\n              if (i[this.objProperties.id] !== item[this.objProperties.id]) {\n                this.selectedItems.push(i)\n              }\n            }\n          }\n        } else {\n          const index = this.selectedItems.findIndex(selected => selected[this.objProperties.id] === item[this.objProperties.id])\n          if (index > -1) {\n            this.selectedItems.splice(index, 1)\n          }\n        }\n      }\n      group.isEveryItemSelected = group.dataView.every(i => i.checked)\n      this.$set(this.groups, groupIndex, group)\n    },\n\n    toggleInactiveAccounts () {\n      this.showInactiveAccounts = !this.showInactiveAccounts\n      this.showAccountsInactive()\n    },\n\n    showAccountsInactive () {\n      if (this.showInactiveAccounts) {\n        this.dataView = this.data.allBankAccounts\n        this.data.values = this.dataView\n        if (this.grouped && this.groups.length > 1) {\n          this.groups.forEach((group, index) => {\n            group.isEveryItemSelected = true\n            this.toggleAllGroupItens(index)\n          })\n        } else {\n          this.isEveryItemSelected = true\n          this.toggleAllItens()\n        }\n      } else {\n        this.isEveryItemSelected = true\n        this.toggleAllItens()\n        this.dataView = this.data.allBankAccounts.filter((bankAccount) => {\n          return bankAccount.ativo\n        })\n        this.data.values = this.dataView\n      }\n      this.groupTheData()\n    },\n\n    apply () {\n      if (this.data.allBankAccounts) {\n        if ((this.selectedItems.length === 0 && this.showInactiveAccounts) || this.data.allBankAccounts.length === this.data.values.length) {\n          this.data.considerInactiveAccounts = true\n        } else {\n          this.data.considerInactiveAccounts = false\n        }\n      }\n      this.data.selectedItems = this.selectedItems\n      this.closeModal()\n    },\n\n    closeModal () {\n      this.$emit('close-modal')\n    },\n\n    searchGroupItens (groupIndex) {\n      const group = this.groups[groupIndex]\n\n      if (group.selected) {\n        group.selected = false\n        this.$set(this.groups, groupIndex, group)\n        return\n      }\n\n      this.groups.forEach(g => {\n        this.$set(g, 'selected', false)\n      })\n\n      group.selected = true\n      group.isEveryItemSelected = group.dataView.every(i => i.checked)\n\n      this.$set(this.groups, groupIndex, group)\n    }\n  },\n\n  created () {\n    this.defineCheckConditions()\n    this.groupTheData()\n    this.hasComputedComponentFunctions = true\n    this.isServerRequest = !!this.data.options.requestFunction\n  }\n}\n</script>\n\n<style scoped>\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search {\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n\n.checkbox {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.func-group-labels {\n  color: #515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n\n.select-columns {\n  margin-bottom: 15px;\n}\n\n.multiselect-modal-input {\n  width: 20px !important;\n}\n\n.multiselect-modal-input-row {\n  margin-left: 5px !important;\n  margin-right: 3px !important;\n}\n\n.multiselect-modal-input-header {\n  margin: 0px 3px -5px 5px !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.group-title {\n  background-color: transparent;\n  color: #27466D;\n  font-weight: bold;\n  text-align: left;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 0;\n}\n\n.group-card {\n  width: 100%;\n  margin-bottom: 0;\n  border: none;\n}\n\n.no-margin {\n  margin: 0;\n}\n\n.padded {\n  padding: 10px;\n}\n\n.margin-bottom {\n  margin-bottom: 10px;\n}\n\n.scrollable {\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1099 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-9db5d5f8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/bankAccounts/New.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.note-card {\n  font-family: 'Inter', serif;\n  font-style: italic;\n  font-size: 12px;\n  color: #666;\n  padding-top: 20px;\n}\n.date-picker {\n  border: none;\n  height: 26px;\n  margin-top: 5px;\n}\n.margin-datepicker-error-msg {\n  margin-top: 10px;\n  display: inline-block;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/bankAccounts/New.vue?7835aae1"],"names":[],"mappings":";AAmbA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;CACA;AAEA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;CACA;AAEA;EACA,iBAAA;EACA,sBAAA;CACA","file":"New.vue","sourcesContent":["<template src='./new.pug' lang='pug'></template>\n\n<script>\nimport _ from 'underscore'\nimport vSelect from 'vue-select'\nimport { TheMask } from 'vue-the-mask'\nimport { Money } from 'v-money'\nimport Datepicker from 'vuejs-datepicker'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport idioma from '../../../../../build/language/index'\nimport customSorter from '../../../../utils/customSorter.js'\nimport customValidator from '../../../../utils/customValidator.js'\nimport looseDeepEqual from '../../../../utils/looseDeepEqual'\nimport PATHS from '../../../../router/routesMap.js'\nimport BelvoWidget from './BelvoWidget.vue'\nimport { getPluggyConnectorCodeByCdBankPersonType } from '../../../../enum/pluggyConnectorsMap.js'\nimport axios from '../../../../../build/http-requests/axios-common.js'\n\nexport default {\n  name: 'BankAccountsNew',\n\n  components: {\n    vSelect,\n    TheMask,\n    Money,\n    Datepicker,\n    PageTitle,\n    FilterPortlet,\n    ButtonPrimary,\n    BelvoWidget\n  },\n\n  data () {\n    return {\n      requestSent: false,\n      banks: [],\n      establishmentsGroup: [],\n      bankSelected: null,\n      bankAccount: {\n        bank: null,\n        name: null,\n        accountNumber: null,\n        agency: null,\n        startBalance: '',\n        startBalanceDate: null,\n        agencyDigit: null,\n        accountDigit: null,\n        ativo: true,\n        group: null,\n        inUse: false,\n        ofdaAtivo: false\n      },\n      operator: {\n        accessProfileId: null\n      },\n      profiles: [],\n      inputAgencyDigit: null,\n      inputAccountDigit: null,\n      maskTokens: {\n        D: {\n          pattern: /[0-9]/\n        },\n        X: {\n          pattern: /\\w/\n        }\n      },\n      idioma: idioma,\n      invalid: null,\n      moneyMask: {},\n      inputDate: null,\n      belvoToken: {},\n      enableOfdaForm: false,\n      ofdaAccountType: 'PF',\n      hasLinkIdUpdated: false\n    }\n  },\n\n  computed: {\n    bankAccountToEdit () {\n      return this.$store.getters.bankAccounttoEditId\n    },\n    portletTitle () {\n      return this.bankAccountToEdit\n        ? this.$t('contaBancaria.titulos.editarContaBancaria')\n        : this.$t('contaBancaria.titulos.novaContaBancaria')\n    },\n    banksList () {\n      return _.sortBy(this.banks, function (item) {\n        return customSorter.cleanLowerString(item.nome)\n      }, 'asc')\n    },\n    datePickerLanguage () {\n      return this.idioma.getDatePickerLanguageObject()\n    },\n    moneyMaskLength () {\n      return this.idioma.getDatePickerLanguage() === 'pt-br' ? 24 : 23\n    },\n    establishmentsGroupList () {\n      return _.sortBy(this.establishmentsGroup, function (item) {\n        return customSorter.cleanLowerString(item.nome)\n      }, 'asc')\n    },\n    stylizeGroupLabel () {\n      return (option) => {\n        let result = null\n        if (typeof option === 'object') {\n          if (this.label && option[this.label]) {\n            result = option[this.label]\n          } else {\n            result = option['nome']\n          }\n        } else {\n          result = option + ' (' + this.$t('inputTag.labels.novo') + ')'\n        }\n        return result\n      }\n    },\n    groupInput () {\n      return this.bankAccount.group\n    },\n    showOpenFinance () {\n      return this.$store.getters.allowedFuncionalities.includes(4007)\n    }\n  },\n\n  watch: {\n    bankAccount: {\n      handler () {\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.bankAccount))\n      },\n      deep: true\n    },\n    groupInput () {\n      if (this.bankAccount.group && !this.bankAccount.group.nome) {\n        this.bankAccount.group = {nome: this.bankAccount.group}\n      }\n      if (this.bankAccount.group && this.bankAccount.group.nome && this.bankAccount.group.nome.length > 20) {\n        this.bankAccount.group.nome = this.bankAccount.group.nome.slice(0, 20)\n      } else {\n        this.bankAccount.group = this.bankAccount.group\n      }\n    }\n  },\n\n  methods: {\n    handleGroupChange (group) {\n      this.bankAccount.group = group\n    },\n\n    loadBanks () {\n      this.$store.dispatch('getBanks')\n        .then((response) => {\n          this.banks = response.data.data\n          this.banks.forEach(bank => {\n            bank.label = bank.codigo + '-' + bank.nomeFantasia\n          })\n          if (this.bankAccountToEdit) {\n            this.loadBankAccount()\n          } else {\n            this.defaultObject = { ...this.bankAccount }\n          }\n        })\n    },\n\n    newBankAccount () {\n      let accountCopy = {...this.bankAccount}\n      accountCopy.id = this.bankAccountToEdit\n      if (typeof accountCopy.startBalance === 'string' && accountCopy.startBalance === '') {\n        // seta para zero para indicar que o campo esta vazio (quando em conjunto com a data vazia)\n        accountCopy.startBalance = 0\n      } else {\n        accountCopy.startBalance = this.removeBankAccountMask()\n      }\n      accountCopy.ofdaAtivo = this.enableOfdaForm\n      this.requestSent = true\n      this.$store.dispatch('newBankAccount', accountCopy)\n        .then((response) => {\n          this.$root.$refs.notification.success(response.data.message)\n          this.$store.dispatch('setHasUnsavedChanges', false)\n          if (this.enableOfdaForm) {\n            this.openPluggyWidget()\n          } else {\n            this.$router.push(PATHS.LIST_BANK_ACCOUNTS)\n          }\n        })\n        .catch((error) => {\n          // volta o valor alterado na chamada da requisicao para vazio\n          if (typeof this.bankAccount.startBalance === 'number' && this.bankAccount.startBalance === 0) {\n            this.bankAccount.startBalance = ''\n          }\n          this.$root.$refs.notification.error(error.message)\n        })\n        .finally(() => {\n          this.requestSent = false\n        })\n    },\n\n    removeBankAccountMask () {\n      let splittedStartBalance = this.bankAccount.startBalance.toString().split(' ')\n\n      if (this.bankAccount.startBalance && splittedStartBalance.length > 1) {\n        return splittedStartBalance[1].replace(/[.,]/g, '').replace(/(\\d{2})$/, '.$1')\n      }\n      return this.bankAccount.startBalance.replace(/[.,]/g, '').replace(/(\\d{2})$/, '.$1')\n    },\n\n    loadBankAccount () {\n      let self = this\n      this.$store.dispatch('getBankAccount', this.bankAccountToEdit)\n        .then((response) => {\n          self.bankAccount.bank = {}\n          let bankAccountLoaded = response.data.data\n          self.bankAccount.name = bankAccountLoaded.nome\n          self.bankAccount.agency = bankAccountLoaded.numAgencia\n          self.bankAccount.agencyDigit = bankAccountLoaded.digAgencia\n          self.bankAccount.accountDigit = bankAccountLoaded.digConta\n          self.bankAccount.accountNumber = bankAccountLoaded.conta\n          self.bankAccount.bank.codigo = bankAccountLoaded.banco ? bankAccountLoaded.banco.codigo : null\n          self.bankAccount.bank.nome = bankAccountLoaded.banco ? bankAccountLoaded.banco.nome : null\n          self.bankAccount.bank.label = bankAccountLoaded.banco.codigo + '-' + bankAccountLoaded.banco.nomeFantasia\n          self.bankAccount.startBalance = bankAccountLoaded.saldoInicial !== null ? bankAccountLoaded.saldoInicial.toFixed(2) : ''\n          self.bankAccount.startBalanceDate = bankAccountLoaded.dataSaldoInicial\n          self.bankAccount.ativo = bankAccountLoaded.ativo\n          self.bankAccount.group = bankAccountLoaded.grupo\n          self.bankAccount.inUse = bankAccountLoaded.contaEmUso\n          self.bankAccount.linkId = bankAccountLoaded.linkId\n          self.bankAccount.institutionOFDA = bankAccountLoaded.institutionOFDA\n          self.bankAccount.optIn = {...bankAccountLoaded.optIn}\n          self.defaultObject = { ...self.bankAccount }\n        })\n    },\n\n    validate (event) {\n      event.preventDefault()\n      this.$validator.validateAll('formNew')\n        .then((result) => {\n          if (result && this.isBalanceFieldsValid()) {\n            this.newBankAccount()\n          } else {\n            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'contaBancaria.erro.salvar')\n          }\n        })\n    },\n\n    back () {\n      this.$router.push(PATHS.LIST_BANK_ACCOUNTS)\n    },\n\n    uniCharCode (event) {\n      if (event) {\n        let char = event.which || event.keyCode\n        // Se o caracter inserido for diferente de 0 a 9 ou X, não deixa cadastrar\n        if (!((char >= 96 && char <= 105) || char === 16 || char === 88 || (char >= 48 && char <= 57)) || (event.shiftKey && event.key !== 'X')) {\n          if (event.currentTarget.id === 'agencyDigit') {\n            this.inputAgencyDigit.value = null\n            this.bankAccount.agencyDigit = null\n          } else {\n            this.inputAccountDigit.value = null\n            this.bankAccount.accountDigit = null\n          }\n        }\n      }\n    },\n\n    isBalanceFieldsValid () {\n      let isValid = (this.$refs.money.$el.value !== '' && this.bankAccount.startBalanceDate !== null) ||\n          (this.$refs.money.$el.value === '' && this.bankAccount.startBalanceDate == null)\n\n      if (!isValid) {\n        if (this.$refs.money.$el.value === '') {\n          this.errors.add('startBalance', 'balance')\n          this.errors.remove('startBalanceDate')\n        } else {\n          this.errors.add('startBalanceDate', 'balance')\n          this.errors.remove('startBalance')\n        }\n      } else {\n        this.errors.remove('startBalance')\n        this.errors.remove('startBalanceDate')\n      }\n      return isValid\n    },\n\n    // Evento para interação com o datepicker\n    input () {\n      this.validateDate()\n    },\n\n    validateDate () {\n      let isValid = this.inputDate.value.length === 10 &&\n        customValidator.isValidDate(this.inputDate.value)\n      if (!isValid) {\n        this.$refs.startBalanceDate.$children\n          .find(item => !!item.id).typedDate = ''\n      }\n    },\n\n    loadEstablishmentGroups () {\n      this.$store.dispatch('getEstablishmentGroups')\n        .then((response) => {\n          this.establishmentsGroup = response\n        })\n        .catch((error) => {\n          this.$root.$refs.notification.error(error.message)\n        })\n    },\n\n    getlinkIdLoaded () {\n      return this.bankAccount !== null ? this.bankAccount.linkId : null\n    },\n\n    loadScript (src) {\n      return new Promise((resolve, reject) => {\n        if (window.PluggyConnect) {\n          return resolve() // Já carregado\n        }\n\n        const script = document.createElement('script')\n        script.src = src\n        script.async = true\n        script.onload = resolve\n        script.onerror = reject\n        document.head.appendChild(script)\n      })\n    },\n\n    openPluggyWidget () {\n      let self = this\n      this.loadScript('https://cdn.pluggy.ai/pluggy-connect/v2.8.2/pluggy-connect.js')\n      axios.post('/ofda/generatePluggyAccessToken', {}).then((response) => {\n        let userToken = response.data\n        let widgetConfig = {\n          connectToken: userToken.accessToken,\n          includeSandbox: false,\n          onSuccess: (connection) => {\n            this.startLinkUpdate(connection)\n          },\n          onEvent: (event) => {\n            switch (event.event) {\n              case 'ITEM_RESPONSE':\n                if (!self.hasLinkIdUpdated) {\n                  self.hasLinkIdUpdated = true\n                  if (self.bankAccount) {\n                    self.registerLink(event.item)\n                  }\n                }\n                break\n              default:\n                break\n            }\n          },\n          onClose: () => {\n            this.$router.push(PATHS.LIST_BANK_ACCOUNTS)\n          }\n        }\n\n        let connectorIds = getPluggyConnectorCodeByCdBankPersonType(this.bankAccount.bank.codigo, this.ofdaAccountType)\n        if (connectorIds.length === 1) {\n          widgetConfig.selectedConnectorId = connectorIds[0]\n        } else {\n          widgetConfig.connectorIds = connectorIds\n        }\n\n        self.pluggyInstance = new window.PluggyConnect(widgetConfig)\n        self.pluggyInstance.init()\n      }).catch((err) => {\n        self.$root.$refs.notification.error(err.message)\n      })\n    },\n\n    registerLink (item) {\n      let account = {\n        id: this.bankAccountToEdit,\n        bank: this.bankAccount.bank,\n        name: this.bankAccount.name,\n        accountNumber: this.bankAccount.accountNumber,\n        agency: this.bankAccount.agency,\n        linkId: item.id,\n        linkIdOld: this.bankAccount && this.bankAccount.optIn ? this.bankAccount.optIn.linkId : null,\n        institutionOFDA: item.connector.id\n      }\n\n      axios.post('/bankAccounts/linkAccoutToOFDA', account).then((responseSaveAcc) => {\n        this.$root.$refs.notification.info('ItemId associado ao optIn da conta com sucesso.')\n      }).catch(() => {\n        this.$root.$refs.notification.error('Erro ao associar ItemId a conta bancaria.')\n      })\n    },\n\n    startLinkUpdate () {\n      let account = {...this.bankAccount}\n      account.id = this.bankAccountToEdit\n      account.startBalance = null\n\n      axios.post('/bankAccounts/activateOptIn', account).then((responseSaveAcc) => {\n        this.$root.$refs.notification.info('Ativação do opt-in realizada com sucesso.')\n      }).catch(() => {\n        this.$root.$refs.notification.error('Erro ao iniciar ativação do opt-in.')\n      })\n    }\n  },\n\n  mounted () {\n    this.inputAgencyDigit = document.getElementById('agencyDigit')\n    this.inputAgencyDigit.addEventListener('keyup', this.uniCharCode, event)\n    this.inputAccountDigit = document.getElementById('accountDigit')\n    this.inputAccountDigit.addEventListener('keyup', this.uniCharCode, event)\n    this.moneyMask = this.idioma.getMoneyMaskByLanguage()\n    setTimeout(() => {\n      this.inputDate = document.getElementById('startBalanceDate')\n      if (this.inputDate) {\n        this.inputDate.setAttribute('autocomplete', 'off')\n        this.inputDate.addEventListener('blur', () => {\n          this.validateDate()\n        })\n      }\n    }, 100)\n  },\n\n  created () {\n    this.loadBanks()\n    this.loadEstablishmentGroups()\n  },\n\n  beforeDestroy () {\n    this.$store.dispatch('setHasUnsavedChanges', false)\n    this.$store.dispatch('cleanBankAccountToEdit')\n  }\n}\n\n</script>\n\n<style>\n.note-card {\n  font-family: 'Inter', serif;\n  font-style: italic;\n  font-size: 12px;\n  color: #666;\n  padding-top: 20px;\n}\n\n.date-picker {\n  border: none;\n  height: 26px;\n  margin-top: 5px;\n}\n\n.margin-datepicker-error-msg {\n  margin-top: 10px;\n  display: inline-block;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1100 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-a0986062","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/conciliationSummary/CalendarDetailBox.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.detail-header-center {\r\n  text-align: center;\r\n  padding-top: 15px;\n}\n.detail-header {\r\n  padding-top: 15px;\n}\n.detail-title {\r\n  font-family: 'Inter', sans-serif !important;\r\n  text-transform: initial !important;\r\n  font-size: 18px !important;\r\n  color: #1d436a !important;\n}\n.detail-highlight {\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-size: 14px !important;\r\n  font-weight: 400 !important;\r\n  text-transform: initial !important;\r\n  margin-right: 1vh;\n}\n.detail-highlight-header {\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-size: 16px !important;\r\n  font-weight: bold !important;\r\n  text-transform: initial !important;\n}\n.margin-container-96 {\r\n  margin-top: 15px;\r\n  width: 96%;\n}\n.calendar-data-table-det {\r\n  display: block;\r\n  overflow-x: scroll;\n}\n.sem-lancamentos {\r\n  font-size: 18px;\r\n  color: rgb(0, 172, 230);\n}\n.left-bordered-div {\r\n  width: 99%;\r\n  height: 5vh;\r\n  padding-top: 1.1vh;\r\n  margin-bottom: 1vh;\r\n  border-left: 12px solid;\r\n  border-top: 1px solid lightgray;\r\n  border-right: 1px solid lightgray;\r\n  border-bottom: 1px solid lightgray;\r\n  border-radius: 10px;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\n}\n.transp-bordered-div {\r\n  width: 99%;\r\n  height: 5vh;\r\n  padding-top: 1.6vh;\r\n  border: 12px solid transparent;\r\n  border-radius: 10px;\r\n  margin-bottom: 10px;\n}\n.calendar-data-table .table-responsive {\r\n  border-radius: 10px !important;\n}\n.calendar-data-table {\r\n  font-family: 'Inter', sans-serif !important;\n}\n.calendar-data-table .table-bordered {\r\n  border: 1px solid #dddddd;\n}\n.calendar-data-table thead:first-child {\r\n  background-color: #fff;\r\n  color: #000 !important;\r\n  font-weight: bold;\r\n  height: 4vh;\n}\n.calendar-data-table tbody>tr {\r\n  background-color: #ffffff;\n}\n.calendar-data-table tbody>tr:hover {\r\n  background-color: #f3f8fe;\n}\n.calendar-data-table .pagination>.active>a {\r\n  background-color: #1c3b60;\r\n  border-color: #1c3b60;\r\n  color: #fff;\n}\n.calendar-data-table .pagination>li>a {\r\n  color: #1c3b60;\n}\n.calendar-data-table .pagination>li:first-child>a {\r\n  color: #1c3b60;\n}\n.calendar-data-table .pagination>li:last-child>a {\r\n  color: #1c3b60;\n}\n.calendar-data-table .pagination {\r\n  margin: 5px 0;\n}\n.table-cell-center {\r\n  height: 4vh;\r\n  text-align: center;\n}\n.table-cell-rigth {\r\n  height: 4vh;\r\n  text-align: right;\n}\n.text-rigth {\r\n  text-align: right;\n}\r\n", "", {"version":3,"sources":["/./client/components/reports/conciliationSummary/CalendarDetailBox.vue?4340068d"],"names":[],"mappings":";AAyYA;EACA,mBAAA;EACA,kBAAA;CACA;AACA;EACA,kBAAA;CACA;AACA;EACA,4CAAA;EACA,mCAAA;EACA,2BAAA;EACA,0BAAA;CACA;AACA;EACA,4CAAA;EACA,2BAAA;EACA,4BAAA;EACA,mCAAA;EACA,kBAAA;CACA;AACA;EACA,4CAAA;EACA,2BAAA;EACA,6BAAA;EACA,mCAAA;CACA;AACA;EACA,iBAAA;EACA,WAAA;CACA;AACA;EACA,eAAA;EACA,mBAAA;CACA;AACA;EACA,gBAAA;EACA,wBAAA;CACA;AACA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gCAAA;EACA,kCAAA;EACA,mCAAA;EACA,oBAAA;EACA,2BAAA;MAAA,sBAAA;CACA;AACA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,oBAAA;EACA,oBAAA;CACA;AACA;EACA,+BAAA;CACA;AAEA;EACA,4CAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;CACA;AACA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;EACA,sBAAA;EACA,YAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,cAAA;CACA;AACA;EACA,YAAA;EACA,mBAAA;CACA;AACA;EACA,YAAA;EACA,kBAAA;CACA;AACA;EACA,kBAAA;CACA","file":"CalendarDetailBox.vue","sourcesContent":["<template src='./calendarDetailBox.pug' lang='pug'></template>\r\n\r\n<script>\r\nimport moment from 'moment'\r\nimport language from '../../../../build/language/index'\r\nimport { maskThousand, maskThousandNoFixed } from '../../../utils/numberMasker.js'\r\nimport { VueTabs, VTab } from 'vue-nav-tabs'\r\nimport LoadingPlaceholder from '../../loading/LoadingPlaceholder'\r\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\r\nimport Toogle from '../../buttons/toogle/Toogle'\r\nimport BetterInputTag from '../../input/betterInputTag/BetterInputTag'\r\n\r\nmoment.locale(language.getDatePickerLanguage())\r\n\r\nexport default {\r\n  name: 'CalendarDetailBox',\r\n\r\n  components: {\r\n    VueTabs,\r\n    VTab,\r\n    ButtonPrimary,\r\n    Toogle,\r\n    BetterInputTag\r\n  },\r\n\r\n  props: {\r\n    startDate: {\r\n      type: Date,\r\n      required: true\r\n    },\r\n    endDate: {\r\n      type: Date,\r\n      required: true\r\n    },\r\n    conciliacaoData: {\r\n      type: Array,\r\n      required: true\r\n    },\r\n    filteredCategory: {\r\n      type: Object\r\n    },\r\n    setCategory: {\r\n      type: Function,\r\n      required: true,\r\n      default: () => null\r\n    }\r\n  },\r\n\r\n  watch: {\r\n    conciliacaoData: {\r\n      handler () {\r\n        this.handleChangeSelection ? this.handleChangeSelection() : null\r\n      },\r\n      deep: true\r\n    },\r\n    startDate: {\r\n      handler () {\r\n        this.handleChangeSelection ? this.handleChangeSelection() : null\r\n      },\r\n      deep: true\r\n    },\r\n    filteredCategory: {\r\n      handler () {\r\n        this.handleChangeSelection ? this.handleChangeSelection() : null\r\n      },\r\n      deep: true\r\n    }\r\n  },\r\n\r\n  data () {\r\n    return {\r\n      conciliationSummary: [],\r\n      accountsTable: {\r\n        columns: ['conta', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],\r\n        options: {\r\n          columnsClasses: {\r\n            'situacao': 'col-2 limit-char table-cell-center',\r\n            'conta': 'col-2 limit-char table-cell-center',\r\n            'valorMovFinan': 'col-2 limit-char table-cell-rigth',\r\n            'valorMovBanc': 'col-2 limit-char table-cell-rigth',\r\n            'diferenca': 'col-2 limit-char table-cell-rigth'\r\n          },\r\n          headings: {\r\n            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),\r\n            conta: this.$t('contaBancaria.labels.numeroConta'),\r\n            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),\r\n            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),\r\n            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')\r\n          },\r\n          templates: {\r\n            situacao: LoadingPlaceholder,\r\n            conta: LoadingPlaceholder,\r\n            valorMovFinan: LoadingPlaceholder,\r\n            valorMovBanc: LoadingPlaceholder,\r\n            diferenca: LoadingPlaceholder\r\n          },\r\n          filterable: [],\r\n          filterByColumn: false,\r\n          sortable: [],\r\n          sortIcon: {\r\n            is: ''\r\n          },\r\n          pagination: { chunk: 5 },\r\n          perPageValues: [],\r\n          perPage: 10,\r\n          texts: {\r\n            count: '',\r\n            noResults: this.$t('dataTable.labels.semResultados')\r\n          }\r\n        },\r\n        data: []\r\n      },\r\n      establishmentsTable: {\r\n        columns: ['estabelecimento', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],\r\n        options: {\r\n          columnsClasses: {\r\n            'situacao': 'col-2 limit-char table-cell-center',\r\n            'estabelecimento': 'col-2 limit-char table-cell-center',\r\n            'valorMovFinan': 'col-2 limit-char table-cell-rigth',\r\n            'valorMovBanc': 'col-2 limit-char table-cell-rigth',\r\n            'diferenca': 'col-2 limit-char table-cell-rigth'\r\n          },\r\n          headings: {\r\n            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),\r\n            estabelecimento: this.$t('estabelecimentos.labels.estabelecimento'),\r\n            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),\r\n            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),\r\n            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')\r\n          },\r\n          templates: {\r\n            situacao: LoadingPlaceholder,\r\n            estabelecimento: LoadingPlaceholder,\r\n            valorMovFinan: LoadingPlaceholder,\r\n            valorMovBanc: LoadingPlaceholder,\r\n            diferenca: LoadingPlaceholder\r\n          },\r\n          filterable: [],\r\n          filterByColumn: false,\r\n          sortable: [],\r\n          sortIcon: {\r\n            is: ''\r\n          },\r\n          pagination: { chunk: 5 },\r\n          perPageValues: [],\r\n          perPage: 10,\r\n          texts: {\r\n            count: '',\r\n            noResults: this.$t('dataTable.labels.semResultados')\r\n          }\r\n        },\r\n        data: []\r\n      },\r\n      categoriesTable: {\r\n        columns: ['categoria', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],\r\n        options: {\r\n          columnsClasses: {\r\n            'situacao': 'col-2 limit-char table-cell-center',\r\n            'categoria': 'col-2 limit-char table-cell-center',\r\n            'valorMovFinan': 'col-2 limit-char table-cell-rigth',\r\n            'valorMovBanc': 'col-2 limit-char table-cell-rigth',\r\n            'diferenca': 'col-2 limit-char table-cell-rigth'\r\n          },\r\n          headings: {\r\n            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),\r\n            categoria: this.$t('planoConciliacao.labels.categoria'),\r\n            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),\r\n            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),\r\n            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')\r\n          },\r\n          templates: {\r\n            situacao: LoadingPlaceholder,\r\n            categoria: LoadingPlaceholder,\r\n            valorMovFinan: LoadingPlaceholder,\r\n            valorMovBanc: LoadingPlaceholder,\r\n            diferenca: LoadingPlaceholder\r\n          },\r\n          filterable: [],\r\n          filterByColumn: false,\r\n          sortable: [],\r\n          sortIcon: {\r\n            is: ''\r\n          },\r\n          pagination: { chunk: 5 },\r\n          perPageValues: [],\r\n          perPage: 10,\r\n          texts: {\r\n            count: '',\r\n            noResults: this.$t('dataTable.labels.semResultados')\r\n          }\r\n        },\r\n        data: []\r\n      },\r\n      situationList: [\r\n        {\r\n          id: 'A',\r\n          nome: this.$t('statusConciliacao.aberto'),\r\n          color: '#FFD54F',\r\n          prioridade: 1\r\n        },\r\n        {\r\n          id: 'C',\r\n          nome: this.$t('statusConciliacao.conciliado'),\r\n          color: '#81C784',\r\n          prioridade: 3\r\n        },\r\n        {\r\n          id: 'M',\r\n          nome: this.$t('calendarioConciliacao.detalhe.conciliadoManualmente'),\r\n          color: '#4DB6AC',\r\n          prioridade: 4\r\n        },\r\n        {\r\n          id: 'D',\r\n          nome: this.$t('statusConciliacao.divergente'),\r\n          color: '#E57373',\r\n          prioridade: 2\r\n        },\r\n        {\r\n          id: 'N',\r\n          nome: this.$t('statusConciliacao.naoAplicavel'),\r\n          color: '#7EC1F7',\r\n          prioridade: 5\r\n        },\r\n        {\r\n          id: 'T',\r\n          nome: this.$t('calendarioConciliacao.detalhe.total'),\r\n          color: '#7EC1F7',\r\n          prioridade: 6\r\n        }\r\n      ],\r\n      templatesWhenIsLoaded: {\r\n        conta: (h, row) => row.conta,\r\n        estabelecimento: (h, row) => row.estabelecimento,\r\n        categoria: (h, row) => row.categoria,\r\n        situacao: (h, row) => this.getConciliationLabel(row.situacao),\r\n        valorMovFinan: (h, row) => this.getVlTotal(row.valorMovFinan),\r\n        valorMovBanc: (h, row) => this.getVlTotal(row.valorMovBanc),\r\n        diferenca: (h, row) => this.getVlTotal(Number(row.valorMovBanc - row.valorMovFinan).toFixed(2))\r\n      },\r\n      isPreparingData: true,\r\n      showSummary: true\r\n    }\r\n  },\r\n\r\n  computed: {\r\n    getFormatedCurrentDate () {\r\n      let label\r\n      if (moment.utc(this.startDate).startOf('day').isSame(moment.utc(this.endDate).startOf('day'))) {\r\n        label = moment.utc(this.startDate).format('LL')\r\n      } else {\r\n        label = moment.utc(this.startDate).format('LL') + ' ' + this.$t('dateRange.labels.ate') + ' ' + moment.utc(this.endDate).format('LL')\r\n      }\r\n      return label\r\n    },\r\n    isComponentReady () {\r\n      return !this.isPreparingData\r\n    },\r\n    handleChangeSelection () {\r\n      this.isPreparingData = true\r\n      this.generatePeriodSummary()\r\n      this.generateGroupByAccount()\r\n      this.generateGroupByEstablishment()\r\n      this.generateGroupByCategory()\r\n      this.isPreparingData = false\r\n    }\r\n  },\r\n\r\n  methods: {\r\n    generatePeriodSummary () {\r\n      this.conciliationSummary = []\r\n      let baseData = this.conciliacaoData.filter((item) => {\r\n        return (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&\r\n              moment.utc(item.dataMin).isBetween(moment.utc(this.startDate).startOf('day'), moment.utc(this.endDate).endOf('day'), undefined, '[]')\r\n      })\r\n      let total = {\r\n        situacao: 'T',\r\n        movFinanAmount: 0,\r\n        movBancAmount: 0,\r\n        percent: 100\r\n      }\r\n      baseData.map(item => {\r\n        let summaryIndex = this.conciliationSummary.findIndex(el => el.situacao === item.situacao)\r\n\r\n        total.movFinanAmount += item.totalMovFinan\r\n        total.movBancAmount += item.totalExtrato\r\n\r\n        if (summaryIndex >= 0) {\r\n          let summary = this.conciliationSummary.at(summaryIndex)\r\n          summary.movFinanAmount += item.totalMovFinan\r\n          summary.movBancAmount += item.totalExtrato\r\n          this.conciliationSummary.splice(summaryIndex, 1, summary)\r\n        } else {\r\n          let summary = {\r\n            situacao: item.situacao,\r\n            movFinanAmount: item.totalMovFinan,\r\n            movBancAmount: item.totalExtrato\r\n          }\r\n          this.conciliationSummary.push(summary)\r\n        }\r\n      })\r\n      if (this.conciliationSummary && this.conciliationSummary.length > 0) {\r\n        this.conciliationSummary.map(item => {\r\n          item.percent = (total.movFinanAmount + total.movBancAmount) !== 0\r\n            ? (100 * (item.movFinanAmount + item.movBancAmount)) / (total.movFinanAmount + total.movBancAmount)\r\n            : 'N/A'\r\n        })\r\n        this.conciliationSummary.push(total)\r\n        this.conciliationSummary.sort((a, b) => this.getPrioridadeByStatus(a.situacao) - this.getPrioridadeByStatus(b.situacao))\r\n      }\r\n    },\r\n    generateGroupBy (field) {\r\n      let groupedBy = []\r\n      let baseData = this.conciliacaoData.filter((item) => {\r\n        return (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&\r\n              moment.utc(item.dataMin).isBetween(moment.utc(this.startDate).startOf('day'), moment.utc(this.endDate).endOf('day'), undefined, '[]')\r\n      })\r\n      baseData.map(item => {\r\n        let summaryIndex = groupedBy.findIndex(el => el.situacao === item.situacao && (field ? el[field] === item[field] : true))\r\n        if (summaryIndex >= 0) {\r\n          let summary = groupedBy.at(summaryIndex)\r\n          summary.valorMovFinan += item.totalMovFinan\r\n          summary.valorMovBanc += item.totalExtrato\r\n          groupedBy.splice(summaryIndex, 1, summary)\r\n        } else {\r\n          let summary = {\r\n            situacao: item.situacao,\r\n            conta: item.conta,\r\n            estabelecimento: item.estabelecimento,\r\n            categoria: item.categoria,\r\n            valorMovFinan: item.totalMovFinan,\r\n            valorMovBanc: item.totalExtrato\r\n          }\r\n          groupedBy.push(summary)\r\n        }\r\n      })\r\n      return groupedBy\r\n    },\r\n    generateGroupByAccount () {\r\n      this.accountsTable.data = this.generateGroupBy('conta')\r\n      this.accountsTable.options.templates = this.templatesWhenIsLoaded\r\n    },\r\n    generateGroupByEstablishment () {\r\n      this.establishmentsTable.data = this.generateGroupBy('estabelecimento')\r\n      this.establishmentsTable.options.templates = this.templatesWhenIsLoaded\r\n    },\r\n    generateGroupByCategory () {\r\n      this.categoriesTable.data = this.generateGroupBy('categoria')\r\n      this.categoriesTable.options.templates = this.templatesWhenIsLoaded\r\n    },\r\n    getVlTotal (value) {\r\n      return 'R$ ' + maskThousand(value)\r\n    },\r\n    getConciliationLabel (status) {\r\n      let label = ' - '\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.nome\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    getColorByStatus (status) {\r\n      let label = ' - '\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.color\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    getPrioridadeByStatus (status) {\r\n      let label = -1\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.prioridade\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    formatPercent (value) {\r\n      if (!isNaN(value)) {\r\n        let result = Number(value)\r\n        return maskThousandNoFixed((result % 1 !== 0 ? result.toFixed(2) : result)) + '%'\r\n      }\r\n      return value\r\n    },\r\n    handleToogle (selected) {\r\n      this.showSummary = selected\r\n    }\r\n  }\r\n}\r\n</script>\r\n<style>\r\n.detail-header-center {\r\n  text-align: center;\r\n  padding-top: 15px;\r\n}\r\n.detail-header {\r\n  padding-top: 15px;\r\n}\r\n.detail-title {\r\n  font-family: 'Inter', sans-serif !important;\r\n  text-transform: initial !important;\r\n  font-size: 18px !important;\r\n  color: #1d436a !important;\r\n}\r\n.detail-highlight {\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-size: 14px !important;\r\n  font-weight: 400 !important;\r\n  text-transform: initial !important;\r\n  margin-right: 1vh;\r\n}\r\n.detail-highlight-header {\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-size: 16px !important;\r\n  font-weight: bold !important;\r\n  text-transform: initial !important;\r\n}\r\n.margin-container-96 {\r\n  margin-top: 15px;\r\n  width: 96%;\r\n}\r\n.calendar-data-table-det {\r\n  display: block;\r\n  overflow-x: scroll;\r\n}\r\n.sem-lancamentos {\r\n  font-size: 18px;\r\n  color: rgb(0, 172, 230);\r\n}\r\n.left-bordered-div {\r\n  width: 99%;\r\n  height: 5vh;\r\n  padding-top: 1.1vh;\r\n  margin-bottom: 1vh;\r\n  border-left: 12px solid;\r\n  border-top: 1px solid lightgray;\r\n  border-right: 1px solid lightgray;\r\n  border-bottom: 1px solid lightgray;\r\n  border-radius: 10px;\r\n  align-content: center;\r\n}\r\n.transp-bordered-div {\r\n  width: 99%;\r\n  height: 5vh;\r\n  padding-top: 1.6vh;\r\n  border: 12px solid transparent;\r\n  border-radius: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n.calendar-data-table .table-responsive {\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.calendar-data-table {\r\n  font-family: 'Inter', sans-serif !important;\r\n}\r\n\r\n.calendar-data-table .table-bordered {\r\n  border: 1px solid #dddddd;\r\n}\r\n\r\n.calendar-data-table thead:first-child {\r\n  background-color: #fff;\r\n  color: #000 !important;\r\n  font-weight: bold;\r\n  height: 4vh;\r\n}\r\n.calendar-data-table tbody>tr {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.calendar-data-table tbody>tr:hover {\r\n  background-color: #f3f8fe;\r\n}\r\n\r\n.calendar-data-table .pagination>.active>a {\r\n  background-color: #1c3b60;\r\n  border-color: #1c3b60;\r\n  color: #fff;\r\n}\r\n\r\n.calendar-data-table .pagination>li>a {\r\n  color: #1c3b60;\r\n}\r\n\r\n.calendar-data-table .pagination>li:first-child>a {\r\n  color: #1c3b60;\r\n}\r\n\r\n.calendar-data-table .pagination>li:last-child>a {\r\n  color: #1c3b60;\r\n}\r\n\r\n.calendar-data-table .pagination {\r\n  margin: 5px 0;\r\n}\r\n.table-cell-center {\r\n  height: 4vh;\r\n  text-align: center;\r\n}\r\n.table-cell-rigth {\r\n  height: 4vh;\r\n  text-align: right;\r\n}\r\n.text-rigth {\r\n  text-align: right;\r\n}\r\n</style>\r\n<style  scoped>\r\n.div-tag {\r\n  border-radius: 10px;\r\n  background-color: #0068AB25;\r\n  margin: 15px 0px 15px 15px;\r\n  line-height: 20px;\r\n  padding-left: 1vh;\r\n  width: fit-content;\r\n  height: 2.5vh;\r\n  padding-top: 0.2vh;\r\n}\r\n.div-tag > input {\r\n  outline: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  font-size: 13px;\r\n  margin: 5px;\r\n  min-width: 55px;\r\n}\r\n.div-tag > span {\r\n  color: #1c3b60;\r\n  text-align: center;\r\n}\r\n\r\n.div-tag > span > a {\r\n  text-decoration: none;\r\n  color: #1c3b60;\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  padding: 7px;\r\n  height: 10px;\r\n  vertical-align: top;\r\n}\r\n.padding-icon {\r\n  padding-left: 0.7vh;\r\n  padding-right: 0.7vh;\r\n  color: #0068AB !important;\r\n  cursor: pointer;\r\n}\r\n.icon-info {\r\n  font-size: 15px;\r\n  color: gray;\r\n}\r\n</style>"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1101 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-a0986062","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./client/components/reports/conciliationSummary/CalendarDetailBox.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.div-tag[data-v-a0986062] {\r\n  border-radius: 10px;\r\n  background-color: #0068AB25;\r\n  margin: 15px 0px 15px 15px;\r\n  line-height: 20px;\r\n  padding-left: 1vh;\r\n  width: fit-content;\r\n  height: 2.5vh;\r\n  padding-top: 0.2vh;\n}\n.div-tag > input[data-v-a0986062] {\r\n  outline: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  font-size: 13px;\r\n  margin: 5px;\r\n  min-width: 55px;\n}\n.div-tag > span[data-v-a0986062] {\r\n  color: #1c3b60;\r\n  text-align: center;\n}\n.div-tag > span > a[data-v-a0986062] {\r\n  text-decoration: none;\r\n  color: #1c3b60;\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  padding: 7px;\r\n  height: 10px;\r\n  vertical-align: top;\n}\n.padding-icon[data-v-a0986062] {\r\n  padding-left: 0.7vh;\r\n  padding-right: 0.7vh;\r\n  color: #0068AB !important;\r\n  cursor: pointer;\n}\n.icon-info[data-v-a0986062] {\r\n  font-size: 15px;\r\n  color: gray;\n}\r\n", "", {"version":3,"sources":["/./client/components/reports/conciliationSummary/CalendarDetailBox.vue?4340068d"],"names":[],"mappings":";AA+fA;EACA,oBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;CACA;AACA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;CACA;AACA;EACA,eAAA;EACA,mBAAA;CACA;AAEA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;CACA;AACA;EACA,oBAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;CACA;AACA;EACA,gBAAA;EACA,YAAA;CACA","file":"CalendarDetailBox.vue","sourcesContent":["<template src='./calendarDetailBox.pug' lang='pug'></template>\r\n\r\n<script>\r\nimport moment from 'moment'\r\nimport language from '../../../../build/language/index'\r\nimport { maskThousand, maskThousandNoFixed } from '../../../utils/numberMasker.js'\r\nimport { VueTabs, VTab } from 'vue-nav-tabs'\r\nimport LoadingPlaceholder from '../../loading/LoadingPlaceholder'\r\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\r\nimport Toogle from '../../buttons/toogle/Toogle'\r\nimport BetterInputTag from '../../input/betterInputTag/BetterInputTag'\r\n\r\nmoment.locale(language.getDatePickerLanguage())\r\n\r\nexport default {\r\n  name: 'CalendarDetailBox',\r\n\r\n  components: {\r\n    VueTabs,\r\n    VTab,\r\n    ButtonPrimary,\r\n    Toogle,\r\n    BetterInputTag\r\n  },\r\n\r\n  props: {\r\n    startDate: {\r\n      type: Date,\r\n      required: true\r\n    },\r\n    endDate: {\r\n      type: Date,\r\n      required: true\r\n    },\r\n    conciliacaoData: {\r\n      type: Array,\r\n      required: true\r\n    },\r\n    filteredCategory: {\r\n      type: Object\r\n    },\r\n    setCategory: {\r\n      type: Function,\r\n      required: true,\r\n      default: () => null\r\n    }\r\n  },\r\n\r\n  watch: {\r\n    conciliacaoData: {\r\n      handler () {\r\n        this.handleChangeSelection ? this.handleChangeSelection() : null\r\n      },\r\n      deep: true\r\n    },\r\n    startDate: {\r\n      handler () {\r\n        this.handleChangeSelection ? this.handleChangeSelection() : null\r\n      },\r\n      deep: true\r\n    },\r\n    filteredCategory: {\r\n      handler () {\r\n        this.handleChangeSelection ? this.handleChangeSelection() : null\r\n      },\r\n      deep: true\r\n    }\r\n  },\r\n\r\n  data () {\r\n    return {\r\n      conciliationSummary: [],\r\n      accountsTable: {\r\n        columns: ['conta', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],\r\n        options: {\r\n          columnsClasses: {\r\n            'situacao': 'col-2 limit-char table-cell-center',\r\n            'conta': 'col-2 limit-char table-cell-center',\r\n            'valorMovFinan': 'col-2 limit-char table-cell-rigth',\r\n            'valorMovBanc': 'col-2 limit-char table-cell-rigth',\r\n            'diferenca': 'col-2 limit-char table-cell-rigth'\r\n          },\r\n          headings: {\r\n            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),\r\n            conta: this.$t('contaBancaria.labels.numeroConta'),\r\n            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),\r\n            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),\r\n            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')\r\n          },\r\n          templates: {\r\n            situacao: LoadingPlaceholder,\r\n            conta: LoadingPlaceholder,\r\n            valorMovFinan: LoadingPlaceholder,\r\n            valorMovBanc: LoadingPlaceholder,\r\n            diferenca: LoadingPlaceholder\r\n          },\r\n          filterable: [],\r\n          filterByColumn: false,\r\n          sortable: [],\r\n          sortIcon: {\r\n            is: ''\r\n          },\r\n          pagination: { chunk: 5 },\r\n          perPageValues: [],\r\n          perPage: 10,\r\n          texts: {\r\n            count: '',\r\n            noResults: this.$t('dataTable.labels.semResultados')\r\n          }\r\n        },\r\n        data: []\r\n      },\r\n      establishmentsTable: {\r\n        columns: ['estabelecimento', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],\r\n        options: {\r\n          columnsClasses: {\r\n            'situacao': 'col-2 limit-char table-cell-center',\r\n            'estabelecimento': 'col-2 limit-char table-cell-center',\r\n            'valorMovFinan': 'col-2 limit-char table-cell-rigth',\r\n            'valorMovBanc': 'col-2 limit-char table-cell-rigth',\r\n            'diferenca': 'col-2 limit-char table-cell-rigth'\r\n          },\r\n          headings: {\r\n            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),\r\n            estabelecimento: this.$t('estabelecimentos.labels.estabelecimento'),\r\n            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),\r\n            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),\r\n            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')\r\n          },\r\n          templates: {\r\n            situacao: LoadingPlaceholder,\r\n            estabelecimento: LoadingPlaceholder,\r\n            valorMovFinan: LoadingPlaceholder,\r\n            valorMovBanc: LoadingPlaceholder,\r\n            diferenca: LoadingPlaceholder\r\n          },\r\n          filterable: [],\r\n          filterByColumn: false,\r\n          sortable: [],\r\n          sortIcon: {\r\n            is: ''\r\n          },\r\n          pagination: { chunk: 5 },\r\n          perPageValues: [],\r\n          perPage: 10,\r\n          texts: {\r\n            count: '',\r\n            noResults: this.$t('dataTable.labels.semResultados')\r\n          }\r\n        },\r\n        data: []\r\n      },\r\n      categoriesTable: {\r\n        columns: ['categoria', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],\r\n        options: {\r\n          columnsClasses: {\r\n            'situacao': 'col-2 limit-char table-cell-center',\r\n            'categoria': 'col-2 limit-char table-cell-center',\r\n            'valorMovFinan': 'col-2 limit-char table-cell-rigth',\r\n            'valorMovBanc': 'col-2 limit-char table-cell-rigth',\r\n            'diferenca': 'col-2 limit-char table-cell-rigth'\r\n          },\r\n          headings: {\r\n            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),\r\n            categoria: this.$t('planoConciliacao.labels.categoria'),\r\n            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),\r\n            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),\r\n            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')\r\n          },\r\n          templates: {\r\n            situacao: LoadingPlaceholder,\r\n            categoria: LoadingPlaceholder,\r\n            valorMovFinan: LoadingPlaceholder,\r\n            valorMovBanc: LoadingPlaceholder,\r\n            diferenca: LoadingPlaceholder\r\n          },\r\n          filterable: [],\r\n          filterByColumn: false,\r\n          sortable: [],\r\n          sortIcon: {\r\n            is: ''\r\n          },\r\n          pagination: { chunk: 5 },\r\n          perPageValues: [],\r\n          perPage: 10,\r\n          texts: {\r\n            count: '',\r\n            noResults: this.$t('dataTable.labels.semResultados')\r\n          }\r\n        },\r\n        data: []\r\n      },\r\n      situationList: [\r\n        {\r\n          id: 'A',\r\n          nome: this.$t('statusConciliacao.aberto'),\r\n          color: '#FFD54F',\r\n          prioridade: 1\r\n        },\r\n        {\r\n          id: 'C',\r\n          nome: this.$t('statusConciliacao.conciliado'),\r\n          color: '#81C784',\r\n          prioridade: 3\r\n        },\r\n        {\r\n          id: 'M',\r\n          nome: this.$t('calendarioConciliacao.detalhe.conciliadoManualmente'),\r\n          color: '#4DB6AC',\r\n          prioridade: 4\r\n        },\r\n        {\r\n          id: 'D',\r\n          nome: this.$t('statusConciliacao.divergente'),\r\n          color: '#E57373',\r\n          prioridade: 2\r\n        },\r\n        {\r\n          id: 'N',\r\n          nome: this.$t('statusConciliacao.naoAplicavel'),\r\n          color: '#7EC1F7',\r\n          prioridade: 5\r\n        },\r\n        {\r\n          id: 'T',\r\n          nome: this.$t('calendarioConciliacao.detalhe.total'),\r\n          color: '#7EC1F7',\r\n          prioridade: 6\r\n        }\r\n      ],\r\n      templatesWhenIsLoaded: {\r\n        conta: (h, row) => row.conta,\r\n        estabelecimento: (h, row) => row.estabelecimento,\r\n        categoria: (h, row) => row.categoria,\r\n        situacao: (h, row) => this.getConciliationLabel(row.situacao),\r\n        valorMovFinan: (h, row) => this.getVlTotal(row.valorMovFinan),\r\n        valorMovBanc: (h, row) => this.getVlTotal(row.valorMovBanc),\r\n        diferenca: (h, row) => this.getVlTotal(Number(row.valorMovBanc - row.valorMovFinan).toFixed(2))\r\n      },\r\n      isPreparingData: true,\r\n      showSummary: true\r\n    }\r\n  },\r\n\r\n  computed: {\r\n    getFormatedCurrentDate () {\r\n      let label\r\n      if (moment.utc(this.startDate).startOf('day').isSame(moment.utc(this.endDate).startOf('day'))) {\r\n        label = moment.utc(this.startDate).format('LL')\r\n      } else {\r\n        label = moment.utc(this.startDate).format('LL') + ' ' + this.$t('dateRange.labels.ate') + ' ' + moment.utc(this.endDate).format('LL')\r\n      }\r\n      return label\r\n    },\r\n    isComponentReady () {\r\n      return !this.isPreparingData\r\n    },\r\n    handleChangeSelection () {\r\n      this.isPreparingData = true\r\n      this.generatePeriodSummary()\r\n      this.generateGroupByAccount()\r\n      this.generateGroupByEstablishment()\r\n      this.generateGroupByCategory()\r\n      this.isPreparingData = false\r\n    }\r\n  },\r\n\r\n  methods: {\r\n    generatePeriodSummary () {\r\n      this.conciliationSummary = []\r\n      let baseData = this.conciliacaoData.filter((item) => {\r\n        return (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&\r\n              moment.utc(item.dataMin).isBetween(moment.utc(this.startDate).startOf('day'), moment.utc(this.endDate).endOf('day'), undefined, '[]')\r\n      })\r\n      let total = {\r\n        situacao: 'T',\r\n        movFinanAmount: 0,\r\n        movBancAmount: 0,\r\n        percent: 100\r\n      }\r\n      baseData.map(item => {\r\n        let summaryIndex = this.conciliationSummary.findIndex(el => el.situacao === item.situacao)\r\n\r\n        total.movFinanAmount += item.totalMovFinan\r\n        total.movBancAmount += item.totalExtrato\r\n\r\n        if (summaryIndex >= 0) {\r\n          let summary = this.conciliationSummary.at(summaryIndex)\r\n          summary.movFinanAmount += item.totalMovFinan\r\n          summary.movBancAmount += item.totalExtrato\r\n          this.conciliationSummary.splice(summaryIndex, 1, summary)\r\n        } else {\r\n          let summary = {\r\n            situacao: item.situacao,\r\n            movFinanAmount: item.totalMovFinan,\r\n            movBancAmount: item.totalExtrato\r\n          }\r\n          this.conciliationSummary.push(summary)\r\n        }\r\n      })\r\n      if (this.conciliationSummary && this.conciliationSummary.length > 0) {\r\n        this.conciliationSummary.map(item => {\r\n          item.percent = (total.movFinanAmount + total.movBancAmount) !== 0\r\n            ? (100 * (item.movFinanAmount + item.movBancAmount)) / (total.movFinanAmount + total.movBancAmount)\r\n            : 'N/A'\r\n        })\r\n        this.conciliationSummary.push(total)\r\n        this.conciliationSummary.sort((a, b) => this.getPrioridadeByStatus(a.situacao) - this.getPrioridadeByStatus(b.situacao))\r\n      }\r\n    },\r\n    generateGroupBy (field) {\r\n      let groupedBy = []\r\n      let baseData = this.conciliacaoData.filter((item) => {\r\n        return (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&\r\n              moment.utc(item.dataMin).isBetween(moment.utc(this.startDate).startOf('day'), moment.utc(this.endDate).endOf('day'), undefined, '[]')\r\n      })\r\n      baseData.map(item => {\r\n        let summaryIndex = groupedBy.findIndex(el => el.situacao === item.situacao && (field ? el[field] === item[field] : true))\r\n        if (summaryIndex >= 0) {\r\n          let summary = groupedBy.at(summaryIndex)\r\n          summary.valorMovFinan += item.totalMovFinan\r\n          summary.valorMovBanc += item.totalExtrato\r\n          groupedBy.splice(summaryIndex, 1, summary)\r\n        } else {\r\n          let summary = {\r\n            situacao: item.situacao,\r\n            conta: item.conta,\r\n            estabelecimento: item.estabelecimento,\r\n            categoria: item.categoria,\r\n            valorMovFinan: item.totalMovFinan,\r\n            valorMovBanc: item.totalExtrato\r\n          }\r\n          groupedBy.push(summary)\r\n        }\r\n      })\r\n      return groupedBy\r\n    },\r\n    generateGroupByAccount () {\r\n      this.accountsTable.data = this.generateGroupBy('conta')\r\n      this.accountsTable.options.templates = this.templatesWhenIsLoaded\r\n    },\r\n    generateGroupByEstablishment () {\r\n      this.establishmentsTable.data = this.generateGroupBy('estabelecimento')\r\n      this.establishmentsTable.options.templates = this.templatesWhenIsLoaded\r\n    },\r\n    generateGroupByCategory () {\r\n      this.categoriesTable.data = this.generateGroupBy('categoria')\r\n      this.categoriesTable.options.templates = this.templatesWhenIsLoaded\r\n    },\r\n    getVlTotal (value) {\r\n      return 'R$ ' + maskThousand(value)\r\n    },\r\n    getConciliationLabel (status) {\r\n      let label = ' - '\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.nome\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    getColorByStatus (status) {\r\n      let label = ' - '\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.color\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    getPrioridadeByStatus (status) {\r\n      let label = -1\r\n      this.situationList.map(item => {\r\n        if (item.id === status) {\r\n          label = item.prioridade\r\n        }\r\n      })\r\n      return label\r\n    },\r\n    formatPercent (value) {\r\n      if (!isNaN(value)) {\r\n        let result = Number(value)\r\n        return maskThousandNoFixed((result % 1 !== 0 ? result.toFixed(2) : result)) + '%'\r\n      }\r\n      return value\r\n    },\r\n    handleToogle (selected) {\r\n      this.showSummary = selected\r\n    }\r\n  }\r\n}\r\n</script>\r\n<style>\r\n.detail-header-center {\r\n  text-align: center;\r\n  padding-top: 15px;\r\n}\r\n.detail-header {\r\n  padding-top: 15px;\r\n}\r\n.detail-title {\r\n  font-family: 'Inter', sans-serif !important;\r\n  text-transform: initial !important;\r\n  font-size: 18px !important;\r\n  color: #1d436a !important;\r\n}\r\n.detail-highlight {\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-size: 14px !important;\r\n  font-weight: 400 !important;\r\n  text-transform: initial !important;\r\n  margin-right: 1vh;\r\n}\r\n.detail-highlight-header {\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-size: 16px !important;\r\n  font-weight: bold !important;\r\n  text-transform: initial !important;\r\n}\r\n.margin-container-96 {\r\n  margin-top: 15px;\r\n  width: 96%;\r\n}\r\n.calendar-data-table-det {\r\n  display: block;\r\n  overflow-x: scroll;\r\n}\r\n.sem-lancamentos {\r\n  font-size: 18px;\r\n  color: rgb(0, 172, 230);\r\n}\r\n.left-bordered-div {\r\n  width: 99%;\r\n  height: 5vh;\r\n  padding-top: 1.1vh;\r\n  margin-bottom: 1vh;\r\n  border-left: 12px solid;\r\n  border-top: 1px solid lightgray;\r\n  border-right: 1px solid lightgray;\r\n  border-bottom: 1px solid lightgray;\r\n  border-radius: 10px;\r\n  align-content: center;\r\n}\r\n.transp-bordered-div {\r\n  width: 99%;\r\n  height: 5vh;\r\n  padding-top: 1.6vh;\r\n  border: 12px solid transparent;\r\n  border-radius: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n.calendar-data-table .table-responsive {\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.calendar-data-table {\r\n  font-family: 'Inter', sans-serif !important;\r\n}\r\n\r\n.calendar-data-table .table-bordered {\r\n  border: 1px solid #dddddd;\r\n}\r\n\r\n.calendar-data-table thead:first-child {\r\n  background-color: #fff;\r\n  color: #000 !important;\r\n  font-weight: bold;\r\n  height: 4vh;\r\n}\r\n.calendar-data-table tbody>tr {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.calendar-data-table tbody>tr:hover {\r\n  background-color: #f3f8fe;\r\n}\r\n\r\n.calendar-data-table .pagination>.active>a {\r\n  background-color: #1c3b60;\r\n  border-color: #1c3b60;\r\n  color: #fff;\r\n}\r\n\r\n.calendar-data-table .pagination>li>a {\r\n  color: #1c3b60;\r\n}\r\n\r\n.calendar-data-table .pagination>li:first-child>a {\r\n  color: #1c3b60;\r\n}\r\n\r\n.calendar-data-table .pagination>li:last-child>a {\r\n  color: #1c3b60;\r\n}\r\n\r\n.calendar-data-table .pagination {\r\n  margin: 5px 0;\r\n}\r\n.table-cell-center {\r\n  height: 4vh;\r\n  text-align: center;\r\n}\r\n.table-cell-rigth {\r\n  height: 4vh;\r\n  text-align: right;\r\n}\r\n.text-rigth {\r\n  text-align: right;\r\n}\r\n</style>\r\n<style  scoped>\r\n.div-tag {\r\n  border-radius: 10px;\r\n  background-color: #0068AB25;\r\n  margin: 15px 0px 15px 15px;\r\n  line-height: 20px;\r\n  padding-left: 1vh;\r\n  width: fit-content;\r\n  height: 2.5vh;\r\n  padding-top: 0.2vh;\r\n}\r\n.div-tag > input {\r\n  outline: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  font-size: 13px;\r\n  margin: 5px;\r\n  min-width: 55px;\r\n}\r\n.div-tag > span {\r\n  color: #1c3b60;\r\n  text-align: center;\r\n}\r\n\r\n.div-tag > span > a {\r\n  text-decoration: none;\r\n  color: #1c3b60;\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  padding: 7px;\r\n  height: 10px;\r\n  vertical-align: top;\r\n}\r\n.padding-icon {\r\n  padding-left: 0.7vh;\r\n  padding-right: 0.7vh;\r\n  color: #0068AB !important;\r\n  cursor: pointer;\r\n}\r\n.icon-info {\r\n  font-size: 15px;\r\n  color: gray;\r\n}\r\n</style>"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1102 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-b0335380","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/RemittanceIntegrationCreationModal.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n#main-container.main-container {\n  padding-right: 15px;\n  padding-left: 15px;\n  padding-top: 15px;\n}\n#statuses-container {\n  margin-top: 10px;\n}\n.modal-lg {\n  width: 75vw;\n}\n.modal .modal-content {\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n.form-style {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-bottom: 15px;\n}\n.control-label {\n  margin-top: 15;\n}\n", "", {"version":3,"sources":["/./client/components/integration/remittanceIntegration/RemittanceIntegrationCreationModal.vue?1286edc2"],"names":[],"mappings":";AAuGA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,sBAAA;MAAA,wBAAA;EACA,2BAAA;MAAA,uBAAA;EACA,qBAAA;CACA;AAEA;EACA,eAAA;CACA","file":"RemittanceIntegrationCreationModal.vue","sourcesContent":["<template src='./remittanceIntegrationCreationModal.pug' lang='pug'></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport ConfirmModal from '../../modals/confirmModal/ConfirmModal'\nimport BetterModal from '../../modals/betterModal/BetterModal'\nimport DateRange from '../../input/dateRange/DateRange'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\n\nexport default {\n  name: 'RemittanceIntegrationCreationModal',\n\n  components: {\n    vSelect,\n    ConfirmModal,\n    BetterModal,\n    DateRange,\n    ButtonPrimary\n  },\n\n  props: {\n    show: {\n      type: Boolean,\n      default: false\n    },\n    remittanceTypes: {\n      type: Array,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      firstDate: new Date(),\n      finalDate: new Date(),\n      hasRemittance: false,\n      isLoadingData: false,\n      remittance: {\n        type: '',\n        period: {},\n        comments: ''\n      },\n      modal: {\n        text: {\n          title: this.$t('remessaIntegracao.remessa.gerar.modal.titulo'),\n          subtitle: this.$t('remessaIntegracao.remessa.gerar.modal.subtitulo')\n        }\n      }\n    }\n  },\n\n  methods: {\n    clearRemittance () {\n      this.remittance = {\n        type: '',\n        period: {},\n        comments: ''\n      }\n    },\n\n    validate () {\n      return new Promise(resolve => {\n        this.$validator.validateAll().then(result => {\n          if (result) {\n            this.$store.dispatch('validateRemittancePeriod', this.remittance)\n              .then(hasRemittance => {\n                this.hasRemittance = hasRemittance\n                $('#confirmRemittanceCreation').modal('show')\n              })\n            resolve()\n          }\n        })\n      })\n    },\n\n    create () {\n      this.closeModalConfirm()\n      this.isLoadingData = true\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('createRemittance', this.remittance)\n          .then(response => {\n            this.clearRemittance()\n            this.isLoadingData = false\n            this.$root.$refs.notification.success('remessaIntegracao.mensagem.sucesso')\n            this.$emit('close-modal')\n            resolve()\n          })\n          .catch(error => {\n            this.$root.$refs.notification.error(error)\n            this.isLoadingData = false\n            reject()\n          })\n      })\n    },\n\n    closeModalConfirm () {\n      $('#confirmRemittanceCreation').modal('hide')\n    }\n  }\n}\n</script>\n\n<style lang='css' scopped>\n#main-container.main-container {\n  padding-right: 15px;\n  padding-left: 15px;\n  padding-top: 15px;\n}\n\n#statuses-container {\n  margin-top: 10px;\n}\n\n.modal-lg {\n  width: 75vw;\n}\n\n.modal .modal-content {\n  border-left: none;\n  border-bottom: none;\n  border-right: none;\n}\n\n.form-style {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding-bottom: 15px;\n}\n\n.control-label {\n  margin-top: 15;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1103 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-b8e2c004","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/loading/LoadingPlaceholder.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.row {\n  margin-left: 0;\n}\n", "", {"version":3,"sources":["/./client/components/loading/LoadingPlaceholder.vue?0250a37f"],"names":[],"mappings":";AAgCA;EACA,eAAA;CACA","file":"LoadingPlaceholder.vue","sourcesContent":["<template lang=\"pug\">\n  content-placeholder(:rows=\"placeholderRows\")\n</template>\n\n<script>\nimport ContentPlaceholder from 'vue-content-placeholder'\n\nexport default {\n  name: 'LoadingPlaceholder',\n\n  components: {\n    ContentPlaceholder\n  },\n\n  data () {\n    return {\n      placeholderRows: [{\n        height: '1.5rem',\n        boxes: [[0, this.generateRandomWidthBetween(40, 100)]]\n      }]\n    }\n  },\n\n  methods: {\n    generateRandomWidthBetween (min, max) {\n      return (Math.floor(Math.random() * (max - min + 1)) + min) + '%'\n    }\n  }\n}\n</script>\n\n<style>\n.row {\n  margin-left: 0;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1104 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-bb3b5fcc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/confirmModal/ConfirmModal.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.confirm[data-v-bb3b5fcc] {\n  z-index: 10000 !important;\n  -webkit-backdrop-filter: brightness(0.5);\n          backdrop-filter: brightness(0.5);\n}\n.confirm-modal-header[data-v-bb3b5fcc] {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #1b3c65;\n  color: #fff;\n  padding: 0.5vh 0vh 0.5vh 1vh;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n.confirm-modal-header h1[data-v-bb3b5fcc] {\n  font-size: 3vh;\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n.confirm-content[data-v-bb3b5fcc] {\n  border-radius: 0px !important;\n  border-bottom-left-radius: 10px !important;\n  border-bottom-right-radius: 10px !important;\n}\n.confirm-text[data-v-bb3b5fcc] {\n  font-size: 2vh;\n  text-align: left;\n  color: #1a3b5f;\n}\n.confirm-dialog[data-v-bb3b5fcc] {\n  width: 28vw !important;\n}\n.confirm-buttom[data-v-bb3b5fcc] {\n  font-size: 1.7vh !important;\n  min-width: 80px !important;\n}\n.confirm-footer[data-v-bb3b5fcc] {\n  padding: 0px 20px 0px 20px !important;\n}\n.flex[data-v-bb3b5fcc] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n}\n", "", {"version":3,"sources":["/./client/components/modals/confirmModal/ConfirmModal.vue?62b2d54a"],"names":[],"mappings":";AAmBA;EACA,0BAAA;EACA,yCAAA;UAAA,iCAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;CACA;AAEA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;CACA;AAEA;EACA,8BAAA;EACA,2CAAA;EACA,4CAAA;CACA;AACA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;CACA;AAEA;EACA,uBAAA;CACA;AAEA;EACA,4BAAA;EACA,2BAAA;CACA;AACA;EACA,sCAAA;CACA;AAEA;EACA,qBAAA;EAAA,cAAA;EACA,uBAAA;MAAA,+BAAA;EACA,uBAAA;MAAA,oBAAA;CACA","file":"ConfirmModal.vue","sourcesContent":["<template src='./confirmModal.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'ConfirmDialog',\n\n  props: [\n    'id'\n  ],\n\n  methods: {\n    closeModal () {\n      $('#' + this.id).modal('hide')\n    }\n  }\n}\n</script>\n\n<style scoped>\n.confirm {\n  z-index: 10000 !important;\n  backdrop-filter: brightness(0.5);\n}\n\n.confirm-modal-header {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #1b3c65;\n  color: #fff;\n  padding: 0.5vh 0vh 0.5vh 1vh;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.confirm-modal-header h1 {\n  font-size: 3vh;\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\n.confirm-content {\n  border-radius: 0px !important;\n  border-bottom-left-radius: 10px !important;\n  border-bottom-right-radius: 10px !important;\n}\n.confirm-text {\n  font-size: 2vh;\n  text-align: left;\n  color: #1a3b5f;\n}\n\n.confirm-dialog {\n  width: 28vw !important;\n}\n\n.confirm-buttom {\n  font-size: 1.7vh !important;\n  min-width: 80px !important;\n}\n.confirm-footer {\n  padding: 0px 20px 0px 20px !important;\n}\n\n.flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1105 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-bb3e89cc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/digitalWalletBalance/DigitalWalletBalance.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.input-button>button[data-v-bb3e89cc] {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n#logDeAuditoriaWrapper[data-v-bb3e89cc] {\n  width: 100%;\n}\n#divTreeGridAuditoria[data-v-bb3e89cc] {\n  min-width: 100%;\n  min-height: 500px;\n}\n.check[data-v-bb3e89cc] {\n  text-align: center;\n}\n.filterButton[data-v-bb3e89cc] {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search[data-v-bb3e89cc] {\n  width: 53.5%;\n}\n.search-button[data-v-bb3e89cc] {\n  min-width: 7vw;\n}\n", "", {"version":3,"sources":["/./client/components/views/reports/digitalWalletBalance/DigitalWalletBalance.vue?f2d73540"],"names":[],"mappings":";AA0MA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA","file":"DigitalWalletBalance.vue","sourcesContent":["<template src='./digitalWalletBalance.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport BetterInputTag from '../../../input/betterInputTag/BetterInputTag'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport axios from '../../../../../build/http-requests/axios-common.js'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\nimport selectTag from '../../../../events/selectTag'\n\nexport default {\n  name: 'DigitalWalletBalance',\n\n  components: {\n    MultiSelectModal,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    BetterInputTag,\n    ButtonPrimary,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      inputTagsProps: {\n        digitalWallets: {\n          id: 'id',\n          name: 'nome'\n        }\n      },\n      data: {\n        digitalWallets: {\n          titles: {\n            main: this.$t('saldoCarteiraDigital.labels.carteirasDigitais'),\n            sub: this.$t('saldoCarteiraDigital.labels.selecionarCarteirasDigitais')\n          },\n          selectedItems: [],\n          columns: ['nome'],\n          values: [],\n          options: {\n            columnsClasses: { nome: 'col-md-12' },\n            perPage: 5,\n            headings: {\n              nome: this.$t('saldoCarteiraDigital.labels.nome')\n            },\n            filterable: ['nome'],\n            filterByColumn: true,\n            perPageValues: [],\n            texts: {\n              count: this.$t('dataTable.labels.contagem'),\n              noResults: this.$t('dataTable.labels.semResultados'),\n              filterBy: '',\n              filterPlaceholder: this.$t('dataTable.labels.filtrar')\n            },\n            sortable: ['nome'],\n            sortIcon: {\n              is: ''\n            },\n            pagination: { chunk: 5 },\n            orderBy: {\n              ascending: true,\n              column: 'nome'\n            },\n            customSorting: {\n              nome: (asc) => {\n                return (a, b) => {\n                  if (asc) {\n                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())\n                  }\n                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())\n                }\n              }\n            },\n            templates: {\n              nome: (h, row) => {\n                return row.nome\n              }\n            }\n          }\n        }\n      },\n      shown: {\n        digitalWallets: false\n      },\n      defaultTags: {\n        digitalWallets: [{\n          id: '-1',\n          nome: this.$t('inputTag.labels.todos')\n        }]\n      },\n      gridId: '#SaldoCarteiraDigital',\n      treeGridCfg: {},\n      DIGITAL_WALLET_MODAL: 'digitalWalletsModal',\n      audit: {},\n      dateRange: {},\n      digitalWalletsSelected: [],\n      digitalWalletsTags: [this.$t('inputTag.labels.todos')],\n      firstDate: new Date(),\n      finalDate: new Date(),\n      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      filter: {\n        entityId: null\n      },\n      result: {},\n      treeGridFileName: 'SaldoCarteiraDigital',\n      error: false,\n      msgError: '',\n      disableSearchButton: false,\n      idsItensSelected: []\n    }\n  },\n\n  methods: {\n    validate () {\n      const self = this\n      return new Promise(resolve => {\n        self.$validator.validateAll().then((result) => {\n          if (result && self.$refs.dateRange.validate()) {\n            self.showTreegrid = true\n            startTreeGridLoading(self.gridId)\n            self.search().finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    search () {\n      this.disableSearchButton = true\n      let filter = {\n        inicio: this.dateRange.fromDate,\n        fim: this.dateRange.toDate,\n        idsCategorias: this.data.digitalWallets.selectedItems.map(selected => selected.id).filter(categories => categories !== '-1'),\n        lang: language.getCookieByName('language')\n      }\n\n      return new Promise((resolve, reject) => {\n        axios.post('/digitalWalletBalance/', { filter: filter }).then((response) => {\n          if (window.Grids[0]) {\n            window.DisposeGrids()\n          }\n          this.result = response.data\n          this.treeGridCfg = response.data.Cfg.Layout\n          this.showTreegrid = true\n          stopTreeGridLoading(this.gridId)\n          this.disableSearchButton = false\n          resolve()\n        }).catch((error) => {\n          this.$root.$refs.notification.error(error)\n          stopTreeGridLoading(this.gridId)\n          this.disableSearchButton = false\n          reject()\n        })\n      })\n    },\n\n    openSelectDigitalWalletsModal () {\n      if (this.data.digitalWallets.values.length > 0) {\n        this.shown.digitalWallets = true\n        return\n      }\n      this.$store.dispatch('getCategories', {\n        url: '/digitalWalletBalance/loadCategories',\n        flTipoCategoria: 'W',\n        validarUso: false\n      })\n        .then((response) => {\n          this.data.digitalWallets.values = response.data\n          this.shown.digitalWallets = true\n        })\n    },\n\n    closeModal () {\n      this.shown.digitalWallets = false\n    }\n  },\n\n  mounted () {\n    selectTag.$on('tagsSelected', (tags, idsItensSelected) => {\n      this.digitalWalletsTags = tags\n      this.idsItensSelected = idsItensSelected\n    })\n  }\n}\n</script>\n\n<style lang='css' scoped>\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.check {\n  text-align: center;\n}\n\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search {\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1106 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-c75fdef8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/filterPortlet/FilterPortlet.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.ui-widget-content[data-v-c75fdef8] {\n  font-family: 'Inter', sans-serif;\n  border: 1px solid #ddd;\n  background: #fff;\n  color: #444;\n  padding: 10px 30px 20px 30px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.ui-widget-content a[data-v-c75fdef8] {\n  color: #444;\n}\n.ui-widget-header[data-v-c75fdef8] {\n  text-transform: uppercase;\n  text-shadow: #fff 1px 1px 0;\n}\n.ui-widget-header[data-v-c75fdef8],\n#tooltip[data-v-c75fdef8] {\n  border: 1px solid #c6c6c6;\n  background: #ddd;\n  color: #444;\n  padding: 10px;\n}\n.ui-widget-header a[data-v-c75fdef8] {\n  color: #444;\n}\n.ui-widget-header-new-layout>.ui-widget-header-titulo[data-v-c75fdef8] {\n  float: left;\n  background-color: #39b8bb;\n  padding: 10px 11px 10px 11px;\n  text-transform: initial;\n  font-size: 14px;\n}\n.ui-widget-header-new-layout[data-v-c75fdef8] {\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  font-weight: bold;\n  text-transform: uppercase;\n  text-shadow: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  height: 40px;\n}\n.ui-widget-header-new-layout[data-v-c75fdef8],\n#tooltip[data-v-c75fdef8] {\n  background: #17375f;\n  color: #fff;\n  padding: 10px 10px 10px 30px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.ui-widget-header-new-layout a[data-v-c75fdef8] {\n  color: #fff;\n}\n.ui-widget-header-new-layout>span.ui-icon-circle-arrow-s[data-v-c75fdef8] {\n  background-size: 18px;\n  background-repeat: no-repeat;\n  background-color: #34537b;\n  background-position: center;\n  transition: background-image 0.2s ease-in-out;\n  height: 100%;\n  margin: 0 !important;\n  padding: 0 12px;\n  top: 0px !important;\n  right: 0 !important;\n}\n.ui-widget-header-new-layout>span.ui-icon-circle-arrow-n[data-v-c75fdef8] {\n  background-size: 18px;\n  background-repeat: no-repeat;\n  background-color: #34537b;\n  background-position: center;\n  transition: background-image 0.2s ease-in-out;\n  height: 100%;\n  margin: 0 !important;\n  padding: 0 12px;\n  top: 0px !important;\n  right: 0 !important;\n}\n.ui-widget-header-new-layout>span.ui-icon-gear[data-v-c75fdef8] {\n  background-size: 18px;\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: background-image 0.2s ease-in-out;\n  height: 100%;\n  margin: 0 !important;\n  padding: 0 12px;\n  top: 0px !important;\n  right: 40px !important;\n}\n.ui-widget-container-titulo[data-v-c75fdef8] {\n  float: left;\n  background-color: #17375f;\n  text-transform: initial !important;\n  color: #ffffff !important;\n  font-size: 14px !important;\n  font-weight: bold !important;\n}\n.portlet[data-v-c75fdef8] {\n  border-radius: 25px;\n}\n", "", {"version":3,"sources":["/./client/components/layout/filterPortlet/FilterPortlet.vue?638354c7"],"names":[],"mappings":";AAqBA;EACA,iCAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,4BAAA;CACA;AAEA;;EAEA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,YAAA;EACA,0BAAA;EACA,6BAAA;EACA,wBAAA;EACA,gBAAA;CACA;AAEA;EACA,iCAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;CACA;AAEA;;EAEA,oBAAA;EACA,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,sBAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,8CAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;CACA;AAEA;EACA,sBAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,8CAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;CACA;AAEA;EACA,sBAAA;EACA,6BAAA;EACA,4BAAA;EAEA,8CAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;CACA;AAEA;EACA,YAAA;EACA,0BAAA;EACA,mCAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;CACA;AAEA;EACA,oBAAA;CACA","file":"FilterPortlet.vue","sourcesContent":["<template src='./filterPortlet.pug' lang='pug'></template>\n\n<script>\nexport default {\n  name: 'FilterPortlet',\n\n  props: {\n    portletTitle: {\n      default: function () {\n        return this.$t('filterPortlet.defaultTitle')\n      }\n    },\n    showHeader: {\n      type: Boolean,\n      default: true\n    }\n  }\n}\n</script>\n\n<style scoped>\n.ui-widget-content {\n  font-family: 'Inter', sans-serif;\n  border: 1px solid #ddd;\n  background: #fff;\n  color: #444;\n  padding: 10px 30px 20px 30px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.ui-widget-content a {\n  color: #444;\n}\n\n.ui-widget-header {\n  text-transform: uppercase;\n  text-shadow: #fff 1px 1px 0;\n}\n\n.ui-widget-header,\n#tooltip {\n  border: 1px solid #c6c6c6;\n  background: #ddd;\n  color: #444;\n  padding: 10px;\n}\n\n.ui-widget-header a {\n  color: #444;\n}\n\n.ui-widget-header-new-layout>.ui-widget-header-titulo {\n  float: left;\n  background-color: #39b8bb;\n  padding: 10px 11px 10px 11px;\n  text-transform: initial;\n  font-size: 14px;\n}\n\n.ui-widget-header-new-layout {\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  font-weight: bold;\n  text-transform: uppercase;\n  text-shadow: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  height: 40px;\n}\n\n.ui-widget-header-new-layout,\n#tooltip {\n  background: #17375f;\n  color: #fff;\n  padding: 10px 10px 10px 30px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.ui-widget-header-new-layout a {\n  color: #fff;\n}\n\n.ui-widget-header-new-layout>span.ui-icon-circle-arrow-s {\n  background-size: 18px;\n  background-repeat: no-repeat;\n  background-color: #34537b;\n  background-position: center;\n  -webkit-transition: background-image 0.2s ease-in-out;\n  transition: background-image 0.2s ease-in-out;\n  height: 100%;\n  margin: 0 !important;\n  padding: 0 12px;\n  top: 0px !important;\n  right: 0 !important;\n}\n\n.ui-widget-header-new-layout>span.ui-icon-circle-arrow-n {\n  background-size: 18px;\n  background-repeat: no-repeat;\n  background-color: #34537b;\n  background-position: center;\n  -webkit-transition: background-image 0.2s ease-in-out;\n  transition: background-image 0.2s ease-in-out;\n  height: 100%;\n  margin: 0 !important;\n  padding: 0 12px;\n  top: 0px !important;\n  right: 0 !important;\n}\n\n.ui-widget-header-new-layout>span.ui-icon-gear {\n  background-size: 18px;\n  background-repeat: no-repeat;\n  background-position: center;\n  -webkit-transition: background-image 0.2s ease-in-out;\n  transition: background-image 0.2s ease-in-out;\n  height: 100%;\n  margin: 0 !important;\n  padding: 0 12px;\n  top: 0px !important;\n  right: 40px !important;\n}\n\n.ui-widget-container-titulo {\n  float: left;\n  background-color: #17375f;\n  text-transform: initial !important;\n  color: #ffffff !important;\n  font-size: 14px !important;\n  font-weight: bold !important;\n}\n\n.portlet {\n  border-radius: 25px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1107 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-c76a377a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/TreeViewPlans.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.treeview {\n  font-family: 'Inter', sans-serif;\n}\n.padding-left-children {\n  padding-left: 50px;\n}\n.padding-left-children-item {\n  padding-left: 25px;\n}\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: none;\n}\n.treeRowBg {\n  background: #ffffff !important;\n  font-weight: bold;\n  color: #000000;\n}\n.treeRow .btn-white {\n  color: #000000;\n}\n.treeview.vue-drag-tree > div > .treeview > .treeRow {\n  background: #f6f6f6;\n  color: #414141;\n}\n.item {\n  cursor: pointer;\n}\n.bold {\n  font-weight: bold;\n}\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n.treeMargin {\n  margin-left: 0px;\n}\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n.nodeClicked {\n  -ms-transform: rotate(90deg);\n      transform: rotate(90deg);\n}\n", "", {"version":3,"sources":["/./client/components/registration/conciliationPlan/TreeViewPlans.vue?ba9d273c"],"names":[],"mappings":";AAmRA;EACA,iCAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;CACA;AAEA;EACA,WAAA;EACA,YAAA;EACA,YAAA;CACA;AAEA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;CACA;AAEA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,oBAAA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,eAAA;CACA;AAEA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,sCAAA;CACA;AAEA;EACA,6BAAA;MAAA,yBAAA;CACA","file":"TreeViewPlans.vue","sourcesContent":["<script>\nlet id = 1000\nlet fromData = ''\nlet toData = ''\nlet fromParentModelChildren = ''\nlet nodeClicked = null\n\nexport default {\n  name: 'TreeViewPlans',\n\n  data: function () {\n    return {\n      open: false,\n      isClicked: false\n    }\n  },\n\n  props: {\n    model: Object,\n    buttonsTitle: Object,\n    clickFunction: Function,\n    clickRemoveFunction: {\n      type: Function,\n      default: null\n    },\n    showRemove: {\n      type: Boolean,\n      default: false\n    },\n    id: String,\n    father: Object,\n    defaultText: String,\n    currentHighlight: Boolean,\n    hoverColor: String,\n    highlightColor: String,\n    spaceLeft: String,\n    styleObj: Object\n  },\n\n  template: `<div class=\"treeview\">\n              <div :id='model.id' draggable='false' @dragstart='dragStart' @dragover='dragOver' @dragenter='dragEnter' @dragleave='dragLeave' @drop='drop' @dragend='dragEnd' class='col-xs-12 col-sm-12 col-md-12 treeRow pl-0' :class=\"[model.parent ? 'treeRowBg' : '']\" @mouseover='mouseOver' @mouseout='mouseOut' :style='styleObj'>\n                <div class=\"pull-left pl-0 text-left\" style=\"padding-top:3px!important\">\n                  <div v-if=\"model.children\" style=\"min-width:33px;\"></div>\n                  <button style=\"width:23px; float:left;\" v-if=\"!isClicked && model.children && model.children.length > 0\" :title=\"[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : '']\" @click=\"toggle\" class=\"fa fa-chevron-down px-0 action btn-white\"></button>\n                  <button style=\"width:23px; float:left;\" v-if=\"isClicked && model.children && model.children.length > 0\" :title=\"[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : '']\" @click=\"toggle\" class=\"fa fa-chevron-up px-0 action btn-white\"></button>\n                </div>\n\n                <div :style='spaceLeft' class=\"col-xs-3 col-sm-3 col-md-3 col-lg-4\" :class=\"[model.parent || model.isMidSection ? 'pl-0' : 'padding-left-children']\">\n                  {{model.isMidSection ? this.$t(model.planName) : model.planName}}\n                </div>\n                <div class=\"col-xs-2 col-sm-2 col-md-3 col-lg-2\" :class=\"[model.parent ? 'pl-0' : 'padding-left-children-item']\">{{model.order}}</div>\n                <div class=\"col-xs-2 col-sm-2 col-md-3 col-lg-2\" :class=\"[model.parent ? 'pl-0' : 'padding-left-children-item']\" v-html=\"$t(model.isRelevant != null ? (model.isRelevant ? 'planoConciliacao.labels.relevante' : 'planoConciliacao.labels.irrelevante') : null)\"></div>\n                <div class=\"col-xs-2 col-sm-2 col-md-3 col-lg-2\" :class=\"[model.parent ? 'pl-0' : 'padding-left-children-item']\" v-html=\"$t(model.isActive != null ? (model.isActive ? 'planoConciliacao.labels.ativo' : 'planoConciliacao.labels.inativo') : null)\"></div>\n\n                <div v-if='model.parent' class=\"pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-2\" style=\"padding-top:3px!important\">\n                  <button v-if='showRemove' :disabled='model.emUso' style=\"width:23px; float:right;\" @click=\"clickRemoveFunction(model.id)\" :title=\"[model.emUso ? (buttonsTitle && buttonsTitle.removeBloq ? buttonsTitle.removeBloq : '') : (buttonsTitle && buttonsTitle.remove ? buttonsTitle.remove : '')]\" class=\"fa fa-times action btn-white pr-0\"></button>\n                  <button style=\"width:23px; float:right;\" id=\"buttonEdit\" @click=\"clickAction('buttonEdit')\" :title=\"[buttonsTitle && buttonsTitle.config ? buttonsTitle.config : '']\" class=\"fa fa-cog action btn-white pr-0\"></button>\n                </div>\n\n              </div>\n\n              <div class=\"clear\"></div>\n\n              <div v-show=\"open\" v-if=\"isFolder\">\n                <item v-for=\"model in orderedNumbers\" :spaceLeft='model.marginLeft' :clickFunction='clickFunction' :id='model.id' :father=\"model\" :model=\"model\" :key='model.id' :currentHighlight='currentHighlight' :defaultText='defaultText' :hoverColor='hoverColor' :highlightColor='highlightColor'>\n                </item>\n              </div>\n            </div>`,\n\n  computed: {\n    orderedNumbers () {\n      return this.model.children.sort((a, b) => Number(a.order) - Number(b.order))\n    },\n    isFolder () {\n      return this.model.children &&\n        this.model.children.length > 0\n    }\n  },\n\n  methods: {\n    clickAction (idButton) {\n      let isEdit = (idButton === 'buttonEdit')\n      this.clickFunction(this.id, this.father, isEdit)\n    },\n\n    toggle () {\n      if (this.isFolder) {\n        this.open = !this.open\n      }\n      let rootTree = this.findRoot()\n\n      this.isClicked = !this.isClicked\n\n      if (this.currentHighlight) {\n        if (nodeClicked !== this.model.id) {\n          let treeParent = rootTree.$parent\n          let nodeStack = [treeParent.$children[0]]\n          while (nodeStack.length !== 0) {\n            let item = nodeStack.shift()\n            item.styleObj.background = 'white'\n            if (item.$children && item.$children.length > 0) {\n              nodeStack = nodeStack.concat(item.$children)\n            }\n          }\n          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF'\n          nodeClicked = this.model.id\n        }\n      }\n    },\n\n    exchangeData (rootCom, from, to) {\n      if (!to || !from || typeof to === 'string' || from.id === to.id) {\n        return\n      }\n\n      from = JSON.parse(JSON.stringify(from))\n      to = JSON.parse(JSON.stringify(to))\n      // copy\n      let treeData = JSON.parse(JSON.stringify(this.model))\n      let nodeStack = [treeData]\n      let status = 0\n\n      try {\n        while (!(status === 2)) {\n          let item = nodeStack.shift()\n          if (item.id === from.id) {\n            item.id = to.id\n            item.name = to.name\n            if (to.children && to.children.length > 0) {\n              item['children'] = to.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.id === to.id) {\n            item.id = from.id\n            item.name = from.name\n            if (from.children && from.children.length > 0) {\n              item['children'] = from.children\n            } else {\n              item.children = []\n            }\n            status++\n            continue\n          }\n          if (item.children && item.children.length > 0) {\n            nodeStack = nodeStack.concat(item.children)\n          }\n        }\n      } catch (e) {\n        return\n      }\n      rootCom.assignData(treeData)\n    },\n\n    changeType () {\n      if (this.currentHighlight) {\n        nodeClicked = this.model.id\n      }\n      if (!this.isFolder) {\n        this.$set(this.model, 'children', [])\n        this.addChild()\n        this.open = true\n        this.isClicked = true\n      }\n    },\n\n    mouseOver (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2'\n        }\n      }\n    },\n\n    mouseOut (e) {\n      if (this.styleObj) {\n        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {\n          e.target.style.background = 'white'\n        }\n      }\n    },\n\n    findRoot () {\n      let ok = false\n      let that = this\n      while (!ok) {\n        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {\n          ok = true\n          break\n        }\n        that = that.$parent\n      }\n      return that\n    },\n\n    addChild () {\n      this.model.children.push({\n        name: this.defaultText ? this.defaultText : 'New Node',\n        id: id++\n      })\n    },\n\n    removeChild (id) {\n      let parentModelChildren = this.$parent.model.children\n      for (let index in parentModelChildren) {\n        if (parentModelChildren[index].id === id) {\n          parentModelChildren = parentModelChildren.splice(index, 1)\n          break\n        }\n      }\n    },\n\n    dragStart (e) {\n      e.dataTransfer.effectAllowed = 'move'\n      e.dataTransfer.setData('nottext', e.target.innerHTML)\n      return true\n    },\n\n    dragEnd (e) {\n      fromData = undefined\n      toData = undefined\n      fromParentModelChildren = undefined\n    },\n\n    dragOver (e) {\n      e.preventDefault()\n      return true\n    },\n\n    dragOverPlus (e) {\n      e.preventDefault()\n    },\n\n    dragEnterPlus (e) {\n    },\n\n    dragEnter (e) {\n      toData = this.model\n      let rootTree = this.findRoot()\n      rootTree.exchangeData(rootTree.$parent, fromData, toData)\n    },\n\n    dragLeave (e) {\n      fromData = this.model\n      fromParentModelChildren = this.$parent.model.children\n    },\n\n    drop (e) {\n\n    },\n\n    dropPlus (e) {\n      if (this.model.hasOwnProperty('children')) {\n        this.model.children.push(fromData)\n      } else {\n        this.model.children = [fromData]\n      }\n      for (let i in fromParentModelChildren) {\n        if (fromParentModelChildren[i].id === fromData.id) {\n          fromParentModelChildren.splice(i, 1)\n        }\n      }\n    }\n  },\n\n  beforeCreate () {\n    this.$options.components.item = require('./TreeViewPlans')\n  }\n}\n</script>\n\n<style>\n.treeview {\n  font-family: 'Inter', sans-serif;\n}\n\n.padding-left-children {\n  padding-left: 50px;\n}\n\n.padding-left-children-item {\n  padding-left: 25px;\n}\n\nbutton.buttons-actions-treeview {\n  width:23px;\n  float:right;\n}\n\n.no-button-chevron {\n  width:32px;\n  float:right;\n  height:14px;\n}\n\n.treeRow {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: none;\n}\n\n.treeRowBg {\n  background: #ffffff !important;\n  font-weight: bold;\n  color: #000000;\n}\n\n.treeRow .btn-white {\n  color: #000000;\n}\n\n.treeview.vue-drag-tree > div > .treeview > .treeRow {\n  background: #f6f6f6;\n  color: #414141;\n}\n\n.item {\n  cursor: pointer;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.treeNodeText {\n  margin: 2px;\n  padding: 0.2rem 0.5rem;\n  width: fit-content;\n  background: #F9FAFC;\n  font-size: 18px;\n  color: #324057;\n}\n\n.treeMargin {\n  margin-left: 0px;\n}\n\n.changeTree {\n  width: 1rem;\n  color: #324057;\n}\n\n.vue-drag-node-icon {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  padding-right: 3px;\n  border-left: 6px solid black;\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  border-right: 0 solid yellow;\n  transition: transform .3s ease-in-out;\n}\n\n.nodeClicked {\n  transform: rotate(90deg);\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1108 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-d0189532","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/categories/CategorieModal.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.radio-wallet {\n  margin-top: 0;\n}\n.datepicker-wrapper-wallet > .vdp-datepicker__calendar {\n  bottom: 100% !important;\n}\n", "", {"version":3,"sources":["/./client/components/registration/categories/CategorieModal.vue?c8ff2038"],"names":[],"mappings":";AAyQA;EACA,cAAA;CACA;AAEA;EACA,wBAAA;CACA","file":"CategorieModal.vue","sourcesContent":["<template src='./categorieModal.pug' lang='pug'></template>\n\n<script>\nimport { Money } from 'v-money'\nimport Datepicker from 'vuejs-datepicker'\nimport BetterModal from '../../modals/betterModal/BetterModal'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport looseDeepEqual from '../../../utils/looseDeepEqual.js'\nimport idioma from '../../../../build/language/index'\nimport customValidator from '../../../utils/customValidator'\nimport { convertToUTC } from '../../../utils/dateUtils'\n\nexport default {\n  name: 'CategorieModal',\n\n  components: {\n    BetterModal,\n    ButtonPrimary,\n    Money,\n    Datepicker\n  },\n\n  props: {\n    idEditingCategory: {\n      type: String,\n      default: null\n    },\n    subCategoryParent: {\n      type: Object,\n      default: null\n    },\n    categories: {\n      type: Array,\n      default: () => []\n    },\n    lastCategoryOrder: {\n      type: Number,\n      default: 0\n    }\n  },\n\n  data () {\n    return {\n      requestSent: false,\n      category: {\n        description: null,\n        accountingId: null,\n        type: '',\n        emUso: false,\n        initialBalance: '',\n        initialBalanceDate: null\n      },\n      parentCategory: null,\n      creatingNumber: 0,\n      titles: {\n        main: '',\n        sub: ''\n      },\n      idioma: idioma,\n      moneyMask: {},\n      inputDate: null,\n      disabledDates: {\n        to: new Date('January 01, 2010')\n      }\n    }\n  },\n\n  computed: {\n    datePickerLanguage () {\n      return this.idioma.getDatePickerLanguageObject()\n    },\n    moneyMaskLength () {\n      return this.idioma.getDatePickerLanguage() === 'pt-br' ? 21 : 20\n    }\n  },\n\n  watch: {\n    category: {\n      handler () {\n        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.category))\n        if (this.category.type !== '' && this.category.type !== 'W') {\n          this.category.initialBalance = ''\n          this.category.initialBalanceDate = null\n        }\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    createOrder () {\n      if (!this.parentCategory) {\n        if (this.categories.length > 0) {\n          const lastCategory = this.categories[this.categories.length - 1]\n          if ('number' in lastCategory) {\n            return parseInt(lastCategory.number) + 1\n          }\n        }\n        return 1\n      }\n      if (this.parentCategory.children && this.parentCategory.children.length > 0) {\n        const lastChildCategory = this.parentCategory.children[this.parentCategory.children.length - 1]\n        if ('number' in lastChildCategory) {\n          return this.parentCategory.number + '.' + (parseInt(lastChildCategory.number.split('.').pop()) + 1)\n        }\n      }\n      return this.parentCategory.number + '.' + 1\n    },\n\n    defineTitles () {\n      if (this.idEditingCategory) {\n        if (this.parentCategory) {\n          this.titles.main = this.$t('categoria.modal.titulo.edicaoSubCategoria')\n          this.titles.sub = this.$t('categoria.modal.subtitulo.edicaoSubCategoria')\n        } else {\n          this.titles.main = this.$t('categoria.modal.titulo.edicaoCategoria')\n          this.titles.sub = this.$t('categoria.modal.subtitulo.edicaoCategoria')\n        }\n      } else {\n        if (this.parentCategory) {\n          this.titles.main = this.$t('categoria.modal.titulo.novaSubCategoria')\n          this.titles.sub = this.$t('categoria.modal.subtitulo.novaSubCategoria')\n        } else {\n          this.titles.main = this.$t('categoria.modal.titulo.novaCategoria')\n          this.titles.sub = this.$t('categoria.modal.subtitulo.novaCategoria')\n        }\n      }\n    },\n\n    validate () {\n      this.$validator.validateAll()\n        .then((result) => {\n          if (result && this.isWalletFieldsValid()) {\n            this.save()\n          } else {\n            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', this.getTitleError())\n          }\n        })\n    },\n\n    isWalletFieldsValid () {\n      let isValid = this.category.type !== 'W' || (this.category.type === 'W' && (this.$refs.money.$el.value !== '' && this.category.initialBalanceDate !== null))\n\n      if (!isValid) {\n        if (this.$refs.money.$el.value === '') {\n          this.errors.add('initialBalance', 'balance')\n          this.errors.remove('initialBalanceDate')\n        } else {\n          this.errors.add('initialBalanceDate', 'balance')\n          this.errors.remove('initialBalance')\n        }\n      } else {\n        this.errors.remove('initialBalance')\n        this.errors.remove('initialBalanceDate')\n      }\n      return isValid\n    },\n\n    getTitleError () {\n      if (this.parentCategory) {\n        return 'categoria.subCategoria.erro.salvar'\n      }\n      return 'categoria.erro.salvar'\n    },\n\n    save () {\n      this.requestSent = true\n      this.$store.dispatch('saveCategorie', this.createSavingObject())\n        .then((response) => {\n          this.$root.$refs.notification.success(response.data.message)\n          this.$emit('close-modal')\n        })\n        .catch(error => {\n          this.$root.$refs.notification.error(error.message)\n        })\n        .finally(() => {\n          this.requestSent = false\n        })\n    },\n\n    createSavingObject () {\n      return {\n        id: this.category.id,\n        categoriaPai: {\n          id: this.parentCategory ? this.parentCategory.id : null\n        },\n        nome: this.category.description,\n        numero: this.creatingNumber,\n        tipo: this.category.type !== 'null' ? this.category.type : null,\n        idContabil: this.category.accountingId,\n        ordem: this.lastCategoryOrder + 1,\n        saldoInicial: typeof this.category.initialBalance === 'string' && this.category.initialBalance === '' ? null : this.removeBankAccountMask(),\n        dataSaldoInicial: convertToUTC(this.category.initialBalanceDate)\n      }\n    },\n\n    removeBankAccountMask () {\n      let splittedInitialBalance = this.category.initialBalance.toString().split(' ')\n\n      if (this.category.initialBalance && splittedInitialBalance.length > 1) {\n        return splittedInitialBalance[1].replace(/[.,]/g, '').replace(/(\\d{2})$/, '.$1')\n      }\n      return this.category.initialBalance.replace(/[.,]/g, '').replace(/(\\d{2})$/, '.$1')\n    },\n\n    validateDate () {\n      let isValid = this.inputDate.value.length === 10 && customValidator.isValidDate(this.inputDate.value)\n      if (!isValid) {\n        this.category.initialBalanceDate = null\n      } else {\n        this.errors.remove('initialBalanceDate')\n      }\n    }\n\n  },\n\n  async created () {\n    if (this.subCategoryParent) {\n      this.parentCategory = { ...this.subCategoryParent }\n    }\n    if (!this.idEditingCategory) {\n      this.defineTitles()\n      this.creatingNumber = this.createOrder()\n      this.defaultObject = { ...this.category }\n      return\n    }\n\n    try {\n      const response = await this.$store.dispatch('getCategorie', this.idEditingCategory)\n      this.category = response.data\n      if (this.category && this.category.fatherCategory) {\n        this.parentCategory = { ...this.category.fatherCategory }\n      } else {\n        this.parentCategory = null\n      }\n      this.creatingNumber = this.category.number\n      this.category.initialBalance = this.category.type === 'W' ? this.category.initialBalance.toFixed(2) : ''\n      this.category.initialBalanceDate = this.category.type === 'W' ? this.category.initialBalanceDate : null\n      this.defaultObject = { ...this.category }\n      this.defineTitles()\n    } catch (err) {\n      this.$root.$refs.notification.error(err.data)\n    }\n  },\n\n  mounted () {\n    this.moneyMask = this.idioma.getMoneyMaskByLanguage()\n    setTimeout(() => {\n      this.inputDate = document.getElementById('initialBalanceDate')\n      if (this.inputDate) {\n        this.inputDate.setAttribute('autocomplete', 'off')\n        this.inputDate.addEventListener('blur', () => {\n          this.validateDate()\n        })\n      }\n    }, 100)\n  },\n\n  beforeDestroy () {\n    this.$store.dispatch('setHasUnsavedChanges', false)\n  }\n}\n</script>\n\n<style>\n.radio-wallet {\n  margin-top: 0;\n}\n\n.datepicker-wrapper-wallet > .vdp-datepicker__calendar {\n  bottom: 100% !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1109 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-db7bdbc6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/toogle/Toogle.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.toogle-primary[data-v-db7bdbc6] {\r\n  background-color: #1c3b60;\r\n  color: #fff;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  border-radius: 4px;\n}\n.toogle-secondary[data-v-db7bdbc6] {\r\n  color: #666;\r\n  background-color: #fff;\r\n  border-color: #999;\n}\n.toogle-secondary[data-v-db7bdbc6]:hover {\r\n  color: #666;\r\n  background-color: #EFEFEF;\r\n  border-color: #999;\n}\n.toogle-secondary[disabled][data-v-db7bdbc6] {\r\n  background-color: #EFEFEF;\r\n  border: 1px solid #ccc;\r\n  color: #666;\n}\n.toogle-secondary[disabled][data-v-db7bdbc6]:hover {\r\n  background-color: #EFEFEF;\r\n  border: 1px solid #ccc;\n}\r\n", "", {"version":3,"sources":["/./client/components/buttons/toogle/Toogle.vue?479fe206"],"names":[],"mappings":";AA6CA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;CACA;AAEA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;CACA;AAEA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;CACA;AAEA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;EACA,0BAAA;EACA,uBAAA;CACA","file":"Toogle.vue","sourcesContent":["<template src='./toogle.pug' lang='pug'></template>\r\n\r\n<script>\r\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\r\n\r\nexport default {\r\n  name: 'Toogle',\r\n\r\n  props: {\r\n    labelLeft: {\r\n      type: String\r\n    },\r\n    labelRight: {\r\n      type: String\r\n    },\r\n    idLeft: {\r\n      type: String,\r\n      required: true\r\n    },\r\n    idRight: {\r\n      type: String,\r\n      required: true\r\n    },\r\n    handleSelection: { // Evento retornacá TRUE caso o toogle selecionado seja o da esquerda\r\n      type: Function,\r\n      required: false\r\n    },\r\n    isActive: {\r\n      type: Boolean,\r\n      default: false\r\n    }\r\n  },\r\n\r\n  methods: {\r\n    trackEvent (idSelected) {\r\n      trackAnalyticsEvent(this, 'toogle-click', 'toogle-component', this[idSelected])\r\n      if (typeof this.handleSelection !== 'undefined') {\r\n        this.handleSelection(idSelected === 'idLeft')\r\n      }\r\n    }\r\n  }\r\n}\r\n</script>\r\n\r\n<style lang='css' scoped>\r\n.toogle-primary {\r\n  background-color: #1c3b60;\r\n  color: #fff;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  border-radius: 4px;\r\n}\r\n\r\n.toogle-secondary {\r\n  color: #666;\r\n  background-color: #fff;\r\n  border-color: #999;\r\n}\r\n\r\n.toogle-secondary:hover {\r\n  color: #666;\r\n  background-color: #EFEFEF;\r\n  border-color: #999;\r\n}\r\n\r\n.toogle-secondary[disabled] {\r\n  background-color: #EFEFEF;\r\n  border: 1px solid #ccc;\r\n  color: #666;\r\n}\r\n\r\n.toogle-secondary[disabled]:hover {\r\n  background-color: #EFEFEF;\r\n  border: 1px solid #ccc;\r\n}\r\n</style>\r\n\r\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1110 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-dd048d2a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/treeGrid/TreeGrid.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.alertGrid {\n  font-style: italic;\n  font-size: 12px;\n  color: #666;\n  padding-top: 20px;\n}\n#botoesExportacoes {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n#TreeGrid {\n  min-width: 100%;\n  min-height: 500px;\n}\n.treeGridModal {\n  min-height: 50vh;\n  max-width: 100%;\n}\n.treeGridCols {\n  padding-left: 0;\n  padding-right: 0;\n}\ntd.GOCellSpaceEdit.GOText {\n  min-width: 50px !important;\n}\n.COMain {\n  font-family: 'Inter', sans-serif;\n}\n\n/*Tabs topo*/\n.COTabHtml,\n.COTabHtml1,\nCOTabHtmlIcon1 {\n  font-size: 13px;\n  font-family: 'Inter', sans-serif;\nfont-weight: 500;\n  white-space: nowrap;\n  text-align: center;\n  padding: 9px 8px 7px 8px!important;\n  border-left: none;\n  background: #DEEAF0;\n  color: #092446;\n  /*border:1px solid #999;*/\n  border-bottom: none;\n  border-top: 3px solid #FAFAFA;\n}\n.COTabHtml1 {\n  background: #092446!important;\n  border-top: 3px solid #31C1DA;\n  /*border: 1px solid #005e78;*/\n  border-bottom: none;\n  color: #FFF;\n}\n.COTabHtml1:hover {\n  background: #092446!important;\n  /*border: 1px solid #005e78;*/\n  border-bottom: none;\n  color: #FFF;\n}\n.COTabHtml:hover {\n  background: #bbd3df!important;\n  /*border: 1px solid #005e78;*/\n  border-bottom: 1px solid #005e78;\n  border-bottom: none;\n  color: #092446;\n}\n.CORowAbove,\n.CORowBelow {\n  margin-left: 1px;\n}\n\n/*Cabeçalho*/\n.COCellHeader {\n  background: #1C3B60;\n}\n.COBig .CORowSpaceFirst .COSolidRow {\n  padding-top: 0px\n}\n.COHeadLeft,\n.COHeadMid,\n.COHeadRight {\n  margin-top: -0.02px;\n}\n.COPickMY {\n  background: #1C3B60;\n}\n\n/*Botões*/\nu.COToolSpaceButton,\n.COMain .COToolSpaceIconInner {\n  padding: 4px 0px 4px 0px;\n  min-width: 60px !important;\n  text-align: center;\n  background: #EEE;\n  border: 1px solid #CCC;\n  color: #666;\n}\nu.COToolSpaceButton:hover {\n  background: #F1F1F1;\n  color: #000;\n  font-weight: normal;\n}\nu.COToolButtonButton1,\nu.COToolSpaceButton1,\nu.COToolButtonButton1:active,\nu.COToolSpaceButton1:active {\n  background: #1C3B60;\n  color: #FFF;\n  font-weight: bold;\n  min-width: 60px;\n  padding-right: 0px;\n  padding-left: 0px;\n}\n\n/*Barra de agrupamento*/\n.COHeaderGroupCustom {\n  font-size: 13px;\n  font-family: 'Inter', sans-serif;\n  color: #96ACC5;\n  padding-left: 10px;\n  cursor: default;\n  white-space: nowrap;\n  font-style: italic;\n  background-color: #FFF;\n}\n.COHeaderGroup {\n  border: 1px solid #96ACC5 !important;\n  border-left: none;\n  font-family: 'Inter', sans-serif;\n  background-color: #D2DEEC;\n  cursor: move;\n}\n.COHeaderGroup>div {\n  font-weight: normal;\n}\n\n/*Barra de busca*/\n.COMain i {\n  color: #96ACC5;\n}\n\n/*Conteúdo das tabelas*/\n.COClassReadOnly {\n  color: #333;\n}\n.COHoverRowBackground {\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  background: #AAA;\n}\n.COFocusRowBackground {\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  background: #AAA;\n}\n\n/*Cor de fundo das linhas selecionadas com o radio button*/\n.COClassSelected {\n  background-color: #DEEAF0\n}\n\n/*Cor alternada do fundo*/\n.COColorAlternate {\n  background-color: #CCC;\n}\n\n/*Cor de fundo das linhas ao se marcar a linha*/\n.COColorFound1 {\n  background-color: #FFDFBF;\n}\n.COColorFound2 {\n  background-color: #F7D9FF;\n}\n.COColorFound3 {\n  background-color: #D1FFDB;\n}\n.COToolbarRow tr td:last-child {\n  display: none;\n}\n.COToolHtml1,\n.COToolHtmlIcon1 {\n  color: #40b9bb;\n}\n\n/*Caixa de configurações da grid*/\n.COMenuHead {\n  color: white;\n  background: #1C3B60\n}\n.CODialogButton {\n  background: #EEE;\n  border: 1px solid #EEE;\n  color: #666;\n}\n.CODialogButton:hover {\n  background: #F1F1F1;\n  border: 1px solid #F1F1F1;\n  color: #000;\n}\n.CODialogButton:active {\n  background: #1C3B60;\n  color: #FFF;\n  font-weight: bold;\n}\n.CODialogButton:active {\n  background: #1C3B60;\n  color: #FFF;\n  font-weight: bold;\n}\n.COChildPart {\n  border-bottom: 1px solid #DDD;\n}\n.COSection, .COSectionFF3 {\n  contain: none;\n}\n#TreeGridWrapper table > tbody > tr, th, td {\n  vertical-align: top !important;\n}\n\n/* alteracoes da versao 14.1.3 */\n.COCellSpace, .COCellSpaceIcon, .COCellSpaceButton, .COCellSpaceButtonIcon, .COCellSpaceButtonButton, .COCellSpacePanel,\n.COCellSpaceBool, .COCellSpaceRadio, .COCellSpaceSelect, .COCellSpaceEdit {\n  border-left: none;\n  border-right: none;\n}\n.COMenuBody { margin: 0 !important; width: auto !important; border: none !important;\n}\n.COCfgMenuOuter, .COColumnsMenuOuter { padding: 0 !important;\n}\n.COCfgMenuHead, .COColumnsMenuHead { border-color: #1c3b60 !important;\n}\n.COMenuFoot { border: none !important;\n}\n.CORowSpace0 .COSolidRow, .CORowSpace1 .COSolidRow, .CORowSpace2 .COSolidRow, .CORowSpace3 .COSolidRow {\n  margin: 0 !important;\n}\nu.COToolButtonButton1, u.COToolSpaceButton1, u.COToolButtonButton1:active, u.COToolSpaceButton1:active {\n  min-width: 60px !important;\n}\n.COMenuCursorIcon { background: none !important;\n}\n.COGroupRow, .COSearchRow, .COPagerRow, .COToolbar1Row, .COToolbar2Row, .COToolbar3Row,\n.COTopbarRow, .COTopbar1Row, .COTopbar2Row, .COTopbar3Row, .COTabberRow {\n  border-top: none !important;\n  border-bottom: none !important;\n}\n.COHeadMid, .COBodyMid, .COFootMid { border-left: none !important;\n}\n.COHoverRowBackground { opacity:0.1; filter:alpha(opacity=10); background:#888;\n}\n.COHoverRowBorder { padding: 0 !important;\n}\n.COHoverCellBorder { padding: 0 !important; border: 0 !important;\n}\n.COFocusRowBackground { background: transparent !important;\n}\n.COFocusCellBorder { padding: 0 !important; border: 0 !important;\n}\n.COFocusCellSpaceBorder { border: none !important;\n}\n.COFocusCellCorner { background: transparent !important;\n}\n.COColorSelected,.COColorSelectedCell { background-color:#FFFFA6 !important\n}\n.COColorNoFocus { background-color: #fff;\n}\n.COColorReadOnly { background-color: #fff;\n}\n.CODropCols { padding: 0 2px 0 2px !important;\n}\n.COTreeImageIE { padding-bottom: 15px !important; display: inline !important;\n}\n.COCellSpace, .COCellSpaceIcon, .COCellSpaceButton, .COCellSpaceButtonIcon, .COCellSpaceButtonButton, .COCellSpacePanel,\n.COCellSpaceBool, .COCellSpaceRadio, .COCellSpaceSelect, .COCellSpaceEdit {\n  vertical-align: middle !important;\n}\n.COMainTable { border: 0 !important;\n}\n.COHeaderGroupCustom { border: 1px solid #cdd8e4;\n}\n.COMenuCursorIcon { background: none !important;\n}\n.COMenuHoverIcon { background: none !important;\n}\n.COMenuBody { padding: 0 !important;\n}\n.alertGrid { font-family: 'Inter', serif;\n}\n.COTreeImageIE { padding-bottom: auto !important;\n} /* Corrige um bug no Chrome */\n.COOverflowDisable { background-color: transparent !important;\n}\n.COEditCellBorder{ border: none !important;\n}\n.COEditCellInput { background-color: inherit !important;\n}\n.COEditCellSpaceBorder { border: none !important;\n}\n.COFocusRowBackground { opacity: 0.3 !important; background-color: #AAA !important;\n}\n.TSTree {\n  overflow: visible !important;\n}\n.COPageFirst { border-top: 1px solid #DDD;\n}\ntd.COCellBase.COType.COHtml.COCell.CONoLeft {\n  vertical-align: middle !important;\n}\n", "", {"version":3,"sources":["/./client/components/treeGrid/TreeGrid.vue?78ed4ab4"],"names":[],"mappings":";AAyVA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;CACA;AACA;EACA,kBAAA;EACA,qBAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,iBAAA;EACA,gBAAA;CACA;AAEA;EACA,gBAAA;EACA,iBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA;EACA,iCAAA;CACA;;AAEA,aAAA;AAEA;;;EAGA,gBAAA;EACA,iCAAA;AACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,8BAAA;CACA;AAEA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,oBAAA;EACA,YAAA;CACA;AAEA;EACA,8BAAA;EACA,8BAAA;EACA,oBAAA;EACA,YAAA;CACA;AAEA;EACA,8BAAA;EACA,8BAAA;EACA,iCAAA;EACA,oBAAA;EACA,eAAA;CACA;AAEA;;EAEA,iBAAA;CACA;;AAEA,aAAA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,gBAAA;CACA;AAEA;;;EAGA,oBAAA;CACA;AAEA;EACA,oBAAA;CACA;;AAEA,UAAA;AAEA;;EAEA,yBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;EACA,oBAAA;EACA,YAAA;EACA,oBAAA;CACA;AAEA;;;;EAIA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;CACA;;AAEA,wBAAA;AAEA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;CACA;AAEA;EACA,qCAAA;EACA,kBAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;CACA;AAEA;EACA,oBAAA;CACA;;AAEA,kBAAA;AAEA;EACA,eAAA;CACA;;AAEA,wBAAA;AAEA;EACA,YAAA;CACA;AAEA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;CACA;AAEA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;CACA;;AAEA,2DAAA;AAEA;EACA,yBAAA;CACA;;AAEA,0BAAA;AAEA;EACA,uBAAA;CACA;;AAEA,gDAAA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,cAAA;CACA;AAEA;;EAEA,eAAA;CACA;;AAEA,kCAAA;AAEA;EACA,aAAA;EACA,mBAAA;CACA;AAEA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;CACA;AAEA;EACA,oBAAA;EACA,0BAAA;EACA,YAAA;CACA;AAEA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;CACA;AAEA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;CACA;AAEA;EACA,8BAAA;CACA;AAEA;EACA,cAAA;CACA;AAEA;EACA,+BAAA;CACA;;AAEA,iCAAA;AAEA;;EAEA,kBAAA;EACA,mBAAA;CACA;AAEA,cAAA,qBAAA,CAAA,uBAAA,CAAA,wBAAA;CAAA;AAEA,uCAAA,sBAAA;CAAA;AAEA,qCAAA,iCAAA;CAAA;AAEA,cAAA,wBAAA;CAAA;AAEA;EACA,qBAAA;CACA;AAEA;EACA,2BAAA;CACA;AAEA,oBAAA,4BAAA;CAAA;AAEA;;EAEA,4BAAA;EACA,+BAAA;CACA;AAEA,qCAAA,6BAAA;CAAA;AAEA,wBAAA,YAAA,CAAA,yBAAA,CAAA,gBAAA;CAAA;AACA,oBAAA,sBAAA;CAAA;AACA,qBAAA,sBAAA,CAAA,qBAAA;CAAA;AAEA,wBAAA,mCAAA;CAAA;AACA,qBAAA,sBAAA,CAAA,qBAAA;CAAA;AACA,0BAAA,wBAAA;CAAA;AACA,qBAAA,mCAAA;CAAA;AAEA,wCAAA,mCAAA;CAAA;AAEA,kBAAA,uBAAA;CAAA;AACA,mBAAA,uBAAA;CAAA;AAEA,cAAA,gCAAA;CAAA;AAEA,iBAAA,gCAAA,CAAA,2BAAA;CAAA;AAEA;;EAEA,kCAAA;CACA;AAEA,eAAA,qBAAA;CAAA;AAEA,uBAAA,0BAAA;CAAA;AAEA,oBAAA,4BAAA;CAAA;AACA,mBAAA,4BAAA;CAAA;AAEA,cAAA,sBAAA;CAAA;AAEA,aAAA,4BAAA;CAAA;AAEA,iBAAA,gCAAA;CAAA,CAAA,8BAAA;AAEA,qBAAA,yCAAA;CAAA;AAEA,mBAAA,wBAAA;CAAA;AAEA,mBAAA,qCAAA;CAAA;AAEA,yBAAA,wBAAA;CAAA;AAEA,wBAAA,wBAAA,CAAA,kCAAA;CAAA;AAEA;EACA,6BAAA;CACA;AAEA,eAAA,2BAAA;CAAA;AAEA;EACA,kCAAA;CACA","file":"TreeGrid.vue","sourcesContent":["<template src='./treeGrid.pug' lang='pug'></template>\n\n<script>\nimport moment from 'moment'\nimport MassTaskModal from '../modals/massTaskModal/MassTaskModal'\nimport MassDeclassifyModal from '../modals/massDeclassifyModal/MassDeclassifyModal'\nimport ButtonPrimary from '../buttons/buttonPrimary/ButtonPrimary'\nimport language from '../../../build/language'\n\nconst formatter = new Intl.NumberFormat(language.getDatePickerLanguage()).format\n\nexport default {\n  name: 'TreeGrid',\n\n  components: {\n    MassTaskModal,\n    ButtonPrimary,\n    MassDeclassifyModal\n  },\n\n  props: {\n    gridId: {\n      type: String\n    },\n    result: {\n      type: Object,\n      required: true\n    },\n    exportUrl: {\n      type: String,\n      required: true\n    },\n    treeGridFileName: {\n      type: String,\n      required: true\n    },\n    treeGridLayoutPath: {\n      type: String\n    },\n    cfgObj: {\n      type: Object,\n      required: false\n    },\n    showExportButton: {\n      type: Boolean,\n      default: true\n    },\n    showMassTaskAction: {\n      type: Boolean,\n      default: false\n    },\n    showAnnulledMovementButton: {\n      type: Boolean,\n      default: false\n    },\n    showExcluirRemessaButton: {\n      type: Boolean,\n      default: false\n    },\n    showHrTopGrid: {\n      type: Boolean,\n      default: true\n    },\n    showAlert: {\n      type: Boolean,\n      default: false\n    },\n    showMassDeclassifyAction: {\n      type: Boolean,\n      default: false\n    },\n    alertMessage: {\n      type: String,\n      required: false\n    },\n    treeGridModal: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  data () {\n    return {\n      lancamentosSelecionados: {\n        arrayIdExtBancSelecionado: [],\n        arrayIdMovFinSelecionado: [],\n        arrayLinhaSelecionada: []\n      }\n    }\n  },\n\n  computed: {\n    allowMassTask () {\n      // 209 é o código para funcionalidade de criação de tarefas\n      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(209) >= 0\n    },\n\n    showMassTaskButton () {\n      return this.showMassTaskAction && this.allowMassTask\n    },\n\n    showMassDeclassifyButton () {\n      return this.showMassDeclassifyAction\n    },\n\n    treeGridResult () {\n      return this.result\n    },\n\n    btnId () {\n      return `btnExportarXls-${this.gridId}`\n    },\n\n    btnTarefaEmMassaId () {\n      return `btnIniciarTarefaEmMAssa-${this.gridId}`\n    },\n\n    modalTarefaEmMassaId () {\n      return `modalIniciarTarefaEmMAssa-${this.gridId}`\n    },\n\n    btnDesclassificarEmMassaId () {\n      return `btnIniciarDesclassificarEmMassa-${this.gridId}`\n    },\n\n    modalDesclassificarEmMassaId () {\n      return `modalIniciarDesclassificarEmMassa-${this.gridId}`\n    },\n\n    btnAnulacaoContaLancamentoId () {\n      return `btnIniciarAnulacaoContaLancamento-${this.gridId}`\n    },\n\n    btnExcluir () {\n      return `btnExcluirRemessas-${this.gridId}`\n    },\n\n    gridItemId () {\n      switch (this.gridId) {\n        case 'ExtratoConta':\n          return 'IdLancamento'\n        case 'RelatorioConciliacao':\n          return 'IdConciliacaoLote'\n        case 'MovimentoFinanceiro':\n          return 'IdMovimentacao'\n        case 'RemessasIntegracao':\n          return 'IdMov'\n      }\n    },\n\n    labelBtnAnulacaoContaLancamento () {\n      return this.gridId === 'LancamentoDuplicado' ? this.$t('analiseDuplicidade.labels.anularLancamento') : this.$t('analiseDuplicidade.labels.reverterAnulacao')\n    }\n  },\n\n  watch: {\n    treeGridResult () {\n      this.createTreeGrid()\n    }\n  },\n\n  methods: {\n    exportarXls () {\n      window.Grids[0].Source.Export.Type = ''\n      window.Grids[0].ActionExport()\n    },\n\n    createTreeGrid () {\n      let treegridCfg = {\n        Text: {\n          Url: '../assets/grid/Text-' + language.getCookieByName('language') + '.xml'\n        },\n        Layout: {\n          Url: '../assets/treegridLayouts/' + this.treeGridLayoutPath + '/config-' + language.getCookieByName('language') + '.js'\n        },\n        Data: {\n          Data: this.result\n        },\n        Export: {\n          Url: this.exportUrl + '?treeGridFileName=' + this.treeGridFileName\n        }\n      }\n      if (this.cfgObj) {\n        treegridCfg.Layout = {}\n        treegridCfg.Layout.Data = this.cfgObj\n      }\n      window.TreeGrid(treegridCfg, this.gridId)\n      window.Grids.OnClickButtonExport = function (G) {\n        window.Grids[0].Source.Export.Type = ''\n        window.Grids[0].ActionExport()\n        return true\n      }\n      // Correção no momento da exportação para campos do tipo data\n      window.Grids.OnGetExportValue = function (G, row, col, str) {\n        if (G.ExportFormat === 'csv') {\n          if (G.GetType(row, col) === 'Date') {\n            if (window.Get(row, col)) {\n              return moment(window.Get(row, col)).utc().format('L')\n            }\n          } else {\n            return window.Get(row, col, str)\n          }\n        } else if (G.ExportFormat === 'xlsx') {\n          if (typeof str === 'number' && /^id/i.test(col)) {\n            return str.toString().length >= 15 ? 'ㅤ' + formatter(str) : formatter(str)\n          }\n        } else if (G.ExportFormat === 'xls') {\n          if (typeof str === 'number' && /^id/i.test(col)) {\n            return str.toString().length >= 15 ? 'ㅤ' + formatter(str) : formatter(str)\n          }\n        }\n      }\n    },\n\n    openModalMassTask () {\n      this.lancamentosSelecionados = {\n        arrayIdExtBancSelecionado: [],\n        arrayIdMovBancSelecionado: [],\n        arrayIdMovFinSelecionado: [],\n        arrayLinhaSelecionada: []\n      }\n\n      // Percorre a grid verificando os checks selecionados\n      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {\n        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {\n          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {\n            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador\n            linha._isVue = true\n            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)\n            // habilitando novamente apos a recursao\n            linha._isVue = false\n          }\n        }\n      }\n      $('#' + this.modalTarefaEmMassaId).modal({ backdrop: 'static', keyboard: false })\n    },\n\n    openModalMassDeclassify () {\n      this.lancamentosSelecionados = {\n        arrayIdExtBancSelecionado: [],\n        arrayIdMovBancSelecionado: [],\n        arrayIdMovFinSelecionado: [],\n        arrayLinhaSelecionada: []\n      }\n\n      // Percorre a grid verificando os checks selecionados\n      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {\n        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {\n          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {\n            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador\n            linha._isVue = true\n            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)\n            // habilitando novamente apos a recursao\n            linha._isVue = false\n          }\n        }\n      }\n      $('#' + this.modalDesclassificarEmMassaId).modal({ backdrop: 'static', keyboard: false })\n    },\n\n    annulMovements () {\n      this.lancamentosSelecionados = {\n        arrayIdExtBancSelecionado: [],\n        arrayLinhaSelecionada: []\n      }\n\n      // Percorre a grid verificando os checks selecionados\n      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {\n        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {\n          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {\n            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador\n            linha._isVue = true\n            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)\n            // habilitando novamente apos a recursao\n            linha._isVue = false\n          }\n        }\n      }\n      this.$emit('annulMovements', {\n        idsContaLancamento: this.lancamentosSelecionados.arrayIdExtBancSelecionado,\n        flAnulado: this.gridId === 'LancamentoDuplicado' ? 1 : 0,\n        flRevertido: this.gridId === 'LancamentoDuplicado' ? 0 : 1\n      })\n    },\n\n    excluirRemessas () {\n      this.lancamentosSelecionados = {\n        arrayIdRemessaIntegracao: [],\n        arrayLinhaSelecionada: []\n      }\n\n      if (window.Grids[this.gridId] && window.Grids[this.gridId].Body) {\n        for (var corpo = window.Grids[this.gridId].Body.firstChild; corpo; corpo = corpo.nextSibling) {\n          for (var linha = corpo.firstChild; linha; linha = linha.nextSibling) {\n            // desabilitando a criacao de watchers pelo Vue para evitar estouro de pilha do navegador\n            linha._isVue = true\n            this.lancamentosSelecionados = this.salvaVendasSolicitadas(linha, this.lancamentosSelecionados)\n            // habilitando novamente apos a recursao\n            linha._isVue = false\n          }\n        }\n      }\n      this.$emit('remittanceRemoval', this.lancamentosSelecionados)\n    },\n\n    // Dado uma linha da grid, percorre todas as linhas filhas e retorna um array contendo o id das vendas selecionadas\n    salvaVendasSolicitadas (linha, lancamentosSelecionados) {\n      // se a linha possuir filho, ou seja, for um grupo.\n      if (linha.firstChild) {\n        for (var linhaFilha = linha.firstChild; linhaFilha; linhaFilha = linhaFilha.nextSibling) {\n          lancamentosSelecionados = this.salvaVendasSolicitadas(linhaFilha, lancamentosSelecionados)\n        }\n      } else if (linha.Kind === 'Data' && linha['Check'] && linha['Check'] === 1) {\n        // se a linha estiver com o check selecionado\n        if (this.gridId === 'ExtratoConta') {\n          lancamentosSelecionados.arrayIdExtBancSelecionado.push(linha[this.gridItemId])\n          if (linha['SituacaoConcil'] === 'A') {\n            lancamentosSelecionados.arrayIdMovBancSelecionado.push(linha[this.gridItemId])\n          }\n        } else if (this.gridId === 'MovimentoFinanceiro') {\n          lancamentosSelecionados.arrayIdMovFinSelecionado.push(linha[this.gridItemId])\n        } else if (this.gridId === 'RemessasIntegracao') {\n          lancamentosSelecionados.arrayIdRemessaIntegracao.push(linha[this.gridItemId])\n        } else {\n          linha['IdContaLancamento']\n          ? lancamentosSelecionados.arrayIdExtBancSelecionado.push(linha['IdContaLancamento'])\n          : lancamentosSelecionados.arrayIdMovFinSelecionado.push(linha['IdMovFinanceiro'])\n        }\n        lancamentosSelecionados.arrayLinhaSelecionada.push(linha)\n      }\n      return lancamentosSelecionados\n    }\n  },\n\n  destroyed () {\n    if (!this.treeGridModal) {\n      window.DisposeGrids()\n    } else if (this.cfgObj && this.cfgObj.Cfg && this.cfgObj.Cfg.id) {\n      window.Grids[this.cfgObj.Cfg.id].Dispose()\n    }\n  }\n}\n</script>\n\n<style lang='css'>\n.alertGrid {\n  font-style: italic;\n  font-size: 12px;\n  color: #666;\n  padding-top: 20px;\n}\n#botoesExportacoes {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n#TreeGrid {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.treeGridModal {\n  min-height: 50vh;\n  max-width: 100%;\n}\n\n.treeGridCols {\n  padding-left: 0;\n  padding-right: 0;\n}\n\ntd.GOCellSpaceEdit.GOText {\n  min-width: 50px !important;\n}\n\n.COMain {\n  font-family: 'Inter', sans-serif;\n}\n\n/*Tabs topo*/\n\n.COTabHtml,\n.COTabHtml1,\nCOTabHtmlIcon1 {\n  font-size: 13px;\n  font-family: 'Inter', sans-serif;\nfont-weight: 500;\n  white-space: nowrap;\n  text-align: center;\n  padding: 9px 8px 7px 8px!important;\n  border-left: none;\n  background: #DEEAF0;\n  color: #092446;\n  /*border:1px solid #999;*/\n  border-bottom: none;\n  border-top: 3px solid #FAFAFA;\n}\n\n.COTabHtml1 {\n  background: #092446!important;\n  border-top: 3px solid #31C1DA;\n  /*border: 1px solid #005e78;*/\n  border-bottom: none;\n  color: #FFF;\n}\n\n.COTabHtml1:hover {\n  background: #092446!important;\n  /*border: 1px solid #005e78;*/\n  border-bottom: none;\n  color: #FFF;\n}\n\n.COTabHtml:hover {\n  background: #bbd3df!important;\n  /*border: 1px solid #005e78;*/\n  border-bottom: 1px solid #005e78;\n  border-bottom: none;\n  color: #092446;\n}\n\n.CORowAbove,\n.CORowBelow {\n  margin-left: 1px;\n}\n\n/*Cabeçalho*/\n\n.COCellHeader {\n  background: #1C3B60;\n}\n\n.COBig .CORowSpaceFirst .COSolidRow {\n  padding-top: 0px\n}\n\n.COHeadLeft,\n.COHeadMid,\n.COHeadRight {\n  margin-top: -0.02px;\n}\n\n.COPickMY {\n  background: #1C3B60;\n}\n\n/*Botões*/\n\nu.COToolSpaceButton,\n.COMain .COToolSpaceIconInner {\n  padding: 4px 0px 4px 0px;\n  min-width: 60px !important;\n  text-align: center;\n  background: #EEE;\n  border: 1px solid #CCC;\n  color: #666;\n}\n\nu.COToolSpaceButton:hover {\n  background: #F1F1F1;\n  color: #000;\n  font-weight: normal;\n}\n\nu.COToolButtonButton1,\nu.COToolSpaceButton1,\nu.COToolButtonButton1:active,\nu.COToolSpaceButton1:active {\n  background: #1C3B60;\n  color: #FFF;\n  font-weight: bold;\n  min-width: 60px;\n  padding-right: 0px;\n  padding-left: 0px;\n}\n\n/*Barra de agrupamento*/\n\n.COHeaderGroupCustom {\n  font-size: 13px;\n  font-family: 'Inter', sans-serif;\n  color: #96ACC5;\n  padding-left: 10px;\n  cursor: default;\n  white-space: nowrap;\n  font-style: italic;\n  background-color: #FFF;\n}\n\n.COHeaderGroup {\n  border: 1px solid #96ACC5 !important;\n  border-left: none;\n  font-family: 'Inter', sans-serif;\n  background-color: #D2DEEC;\n  cursor: move;\n}\n\n.COHeaderGroup>div {\n  font-weight: normal;\n}\n\n/*Barra de busca*/\n\n.COMain i {\n  color: #96ACC5;\n}\n\n/*Conteúdo das tabelas*/\n\n.COClassReadOnly {\n  color: #333;\n}\n\n.COHoverRowBackground {\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  background: #AAA;\n}\n\n.COFocusRowBackground {\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  background: #AAA;\n}\n\n/*Cor de fundo das linhas selecionadas com o radio button*/\n\n.COClassSelected {\n  background-color: #DEEAF0\n}\n\n/*Cor alternada do fundo*/\n\n.COColorAlternate {\n  background-color: #CCC;\n}\n\n/*Cor de fundo das linhas ao se marcar a linha*/\n\n.COColorFound1 {\n  background-color: #FFDFBF;\n}\n\n.COColorFound2 {\n  background-color: #F7D9FF;\n}\n\n.COColorFound3 {\n  background-color: #D1FFDB;\n}\n\n.COToolbarRow tr td:last-child {\n  display: none;\n}\n\n.COToolHtml1,\n.COToolHtmlIcon1 {\n  color: #40b9bb;\n}\n\n/*Caixa de configurações da grid*/\n\n.COMenuHead {\n  color: white;\n  background: #1C3B60\n}\n\n.CODialogButton {\n  background: #EEE;\n  border: 1px solid #EEE;\n  color: #666;\n}\n\n.CODialogButton:hover {\n  background: #F1F1F1;\n  border: 1px solid #F1F1F1;\n  color: #000;\n}\n\n.CODialogButton:active {\n  background: #1C3B60;\n  color: #FFF;\n  font-weight: bold;\n}\n\n.CODialogButton:active {\n  background: #1C3B60;\n  color: #FFF;\n  font-weight: bold;\n}\n\n.COChildPart {\n  border-bottom: 1px solid #DDD;\n}\n\n.COSection, .COSectionFF3 {\n  contain: none;\n}\n\n#TreeGridWrapper table > tbody > tr, th, td {\n  vertical-align: top !important;\n}\n\n/* alteracoes da versao 14.1.3 */\n\n.COCellSpace, .COCellSpaceIcon, .COCellSpaceButton, .COCellSpaceButtonIcon, .COCellSpaceButtonButton, .COCellSpacePanel,\n.COCellSpaceBool, .COCellSpaceRadio, .COCellSpaceSelect, .COCellSpaceEdit {\n  border-left: none;\n  border-right: none;\n}\n\n.COMenuBody { margin: 0 !important; width: auto !important; border: none !important; }\n\n.COCfgMenuOuter, .COColumnsMenuOuter { padding: 0 !important; }\n\n.COCfgMenuHead, .COColumnsMenuHead { border-color: #1c3b60 !important; }\n\n.COMenuFoot { border: none !important; }\n\n.CORowSpace0 .COSolidRow, .CORowSpace1 .COSolidRow, .CORowSpace2 .COSolidRow, .CORowSpace3 .COSolidRow {\n  margin: 0 !important;\n}\n\nu.COToolButtonButton1, u.COToolSpaceButton1, u.COToolButtonButton1:active, u.COToolSpaceButton1:active {\n  min-width: 60px !important;\n}\n\n.COMenuCursorIcon { background: none !important; }\n\n.COGroupRow, .COSearchRow, .COPagerRow, .COToolbar1Row, .COToolbar2Row, .COToolbar3Row,\n.COTopbarRow, .COTopbar1Row, .COTopbar2Row, .COTopbar3Row, .COTabberRow {\n  border-top: none !important;\n  border-bottom: none !important;\n}\n\n.COHeadMid, .COBodyMid, .COFootMid { border-left: none !important; }\n\n.COHoverRowBackground { opacity:0.1; filter:alpha(opacity=10); background:#888; }\n.COHoverRowBorder { padding: 0 !important; }\n.COHoverCellBorder { padding: 0 !important; border: 0 !important; }\n\n.COFocusRowBackground { background: transparent !important; }\n.COFocusCellBorder { padding: 0 !important; border: 0 !important; }\n.COFocusCellSpaceBorder { border: none !important; }\n.COFocusCellCorner { background: transparent !important; }\n\n.COColorSelected,.COColorSelectedCell { background-color:#FFFFA6 !important }\n\n.COColorNoFocus { background-color: #fff; }\n.COColorReadOnly { background-color: #fff; }\n\n.CODropCols { padding: 0 2px 0 2px !important; }\n\n.COTreeImageIE { padding-bottom: 15px !important; display: inline !important; }\n\n.COCellSpace, .COCellSpaceIcon, .COCellSpaceButton, .COCellSpaceButtonIcon, .COCellSpaceButtonButton, .COCellSpacePanel,\n.COCellSpaceBool, .COCellSpaceRadio, .COCellSpaceSelect, .COCellSpaceEdit {\n  vertical-align: middle !important;\n}\n\n.COMainTable { border: 0 !important; }\n\n.COHeaderGroupCustom { border: 1px solid #cdd8e4; }\n\n.COMenuCursorIcon { background: none !important; }\n.COMenuHoverIcon { background: none !important; }\n\n.COMenuBody { padding: 0 !important; }\n\n.alertGrid { font-family: 'Inter', serif; }\n\n.COTreeImageIE { padding-bottom: auto !important; } /* Corrige um bug no Chrome */\n\n.COOverflowDisable { background-color: transparent !important; }\n\n.COEditCellBorder{ border: none !important; }\n\n.COEditCellInput { background-color: inherit !important; }\n\n.COEditCellSpaceBorder { border: none !important; }\n\n.COFocusRowBackground { opacity: 0.3 !important; background-color: #AAA !important; }\n\n.TSTree {\n  overflow: visible !important;\n}\n\n.COPageFirst { border-top: 1px solid #DDD; }\n\ntd.COCellBase.COType.COHtml.COCell.CONoLeft {\n  vertical-align: middle !important;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1111 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-ddae9a96","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/attributesSet/NewAtributeModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.alert-icon[data-v-ddae9a96] {\n  margin-right: 10px;\n  color: red;\n  font-size: 20px;\n}\n.alert-text[data-v-ddae9a96] {\n  color: red;\n  font-size: 15px;\n}\n.att-field-hint[data-v-ddae9a96] {\n  margin: 0 auto;\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  padding-left: 0 !important;\n  color: #b7b7b7;\n}\nspan.info-span[data-v-ddae9a96] {\n  font-style: italic;\n  margin-left: 5px;\n}\nspan.hint-span[data-v-ddae9a96] {\n  font-style: italic;\n}\n.to-upper[data-v-ddae9a96] {\n  text-transform: uppercase;\n}\n", "", {"version":3,"sources":["/./client/components/registration/attributesSet/NewAtributeModal.vue?4c9f36a9"],"names":[],"mappings":";AAuMA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,WAAA;EACA,gBAAA;CACA;AAEA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;CACA;AAEA;EACA,mBAAA;EACA,iBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,0BAAA;CACA","file":"NewAtributeModal.vue","sourcesContent":["<template src='./newAtributeModal.pug' lang='pug'></template>\n\n<script>\nimport vSelect from 'vue-select'\nimport InputTag from 'vue-input-tag'\nimport BetterModal from '../../modals/betterModal/BetterModal'\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport { normalize, removeNonAlphanumeric } from '../../../utils/stringUtils.js'\n\nexport default {\n  name: 'NewAtributeModal',\n\n  components: {\n    vSelect,\n    InputTag,\n    BetterModal,\n    ButtonPrimary\n  },\n\n  props: {\n    editingAttribute: {\n      type: Object\n    },\n    attributesList: {\n      type: Array,\n      default: () => []\n    }\n  },\n\n  data () {\n    return {\n      isEditing: false,\n      attributeTypeHint: '',\n      types: [],\n      possibleValues: [],\n      availableFields: {\n        value: false,\n        mask: false,\n        validation: false\n      },\n      attribute: {\n        name: '',\n        description: null,\n        type: {\n          key: '',\n          description: ''\n        },\n        possibleValues: [],\n        inUse: false\n      },\n      tagsPossibleValue: [],\n      typesValues: {\n        COMBO: {\n          hintText: this.$t('conjuntoAtributo.infos.combo'),\n          availableFields: {\n            value: true,\n            mask: false,\n            validation: false\n          }\n        },\n        NUMBER: {\n          hintText: this.$t('conjuntoAtributo.infos.numerico'),\n          availableFields: {\n            value: false,\n            mask: true,\n            validation: true\n          }\n        },\n        STRING: {\n          hintText: this.$t('conjuntoAtributo.infos.texto'),\n          availableFields: {\n            value: false,\n            mask: true,\n            validation: true\n          }\n        },\n        DATE: {\n          hintText: this.$t('conjuntoAtributo.infos.datepicker'),\n          availableFields: {\n            value: false,\n            mask: false,\n            validation: false\n          }\n        }\n      }\n    }\n  },\n\n  watch: {\n    attribute: {\n      handler () {\n        this.possibleValuesChanged(null)\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    handleIdentifier (evnt) {\n      this.attribute.name = removeNonAlphanumeric(normalize(this.attribute.name)).toUpperCase()\n    },\n\n    validate () {\n      const self = this\n      this.$validator.validateAll()\n        .then((result) => {\n          if (result) {\n            self.save()\n          } else {\n            self.$root.$refs.notification.error('conjuntoAtributo.erro.camposObrigatorios')\n          }\n        })\n    },\n\n    save () {\n      if (this.attribute.type.key === 'COMBO') {\n        this.attribute.possibleValues = [...this.possibleValues]\n      } else {\n        this.attribute.possibleValues = []\n      }\n\n      let newList = [...this.attributesList]\n\n      if (this.isEditing) {\n        const index = this.attributesList.findIndex(att => att === this.editingAttribute)\n        if (index === -1) {\n          throw new Error('Not found')\n        }\n        newList.splice(index, 1, this.attribute)\n      } else {\n        newList.push(this.attribute)\n      }\n      this.$emit('update-list-attributes', newList)\n      this.close()\n    },\n\n    toggleAditionalFields (selectedType) {\n      if (!selectedType || !selectedType.key || !selectedType.description) {\n        return\n      }\n\n      if (!this.attribute.type) {\n        this.attribute.type = {}\n      }\n\n      this.attribute.type.key = selectedType.key\n      this.attribute.type.description = selectedType.description\n\n      const typeValues = this.typesValues[selectedType.key]\n      if (!typeValues) {\n        return\n      }\n\n      this.availableFields = { ...typeValues.availableFields }\n    },\n\n    possibleValuesChanged (list) {\n      if (!list) {\n        list = [...this.attribute.possibleValues]\n      }\n      this.tagsPossibleValue = [...list]\n      this.possibleValues = list.map(value => {\n        return {\n          id: null,\n          value\n        }\n      })\n    },\n\n    close () {\n      this.$emit('close-modal')\n    }\n  },\n\n  created () {\n    this.$store.dispatch('loadAttributeTypes')\n      .then(types => {\n        this.types = types.map(type => {\n          type.key = type.tipo\n          type.description = this.$t(type.descricao)\n          return type\n        })\n      })\n      .catch(error => this.$root.$refs.notification.error(error.message))\n    if (this.editingAttribute) {\n      this.isEditing = true\n      this.attribute = { ...this.editingAttribute }\n      this.attribute.type.description = this.$t(this.attribute.type.description)\n      this.attribute.possibleValues = this.editingAttribute.possibleValues.map(tag => tag.value)\n      this.tagsPossibleValue = [...this.attribute.possibleValues]\n      this.possibleValues = this.editingAttribute.possibleValues\n      this.toggleAditionalFields(this.editingAttribute.type)\n    }\n    this.defaultObject = { ...this.attribute }\n  }\n}\n</script>\n\n<style scoped>\n.alert-icon {\n  margin-right: 10px;\n  color: red;\n  font-size: 20px;\n}\n\n.alert-text {\n  color: red;\n  font-size: 15px;\n}\n\n.att-field-hint {\n  margin: 0 auto;\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  padding-left: 0 !important;\n  color: #b7b7b7;\n}\n\nspan.info-span {\n  font-style: italic;\n  margin-left: 5px;\n}\n\nspan.hint-span {\n  font-style: italic;\n}\n\n.to-upper {\n  text-transform: uppercase;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1112 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-e804536c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/bankAccounts/BelvoWidget.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.open-finance {\n  font-family: 'Inter', sans-serif;\n  text-transform: initial !important;\n  font-size: 15px;\n  color: #147d96;\n}\n.open-finance-box{\n  border: 2px solid #147d96;\n  border-radius: 10px;\n  padding-left: 1vh;\n  padding-right: 1vh;\n  padding-top: 1vh;\n}\n.open-finance.primary {\n  background-color: #147d96 !important;\n  color: #fff;\n}\n", "", {"version":3,"sources":["/./client/components/views/registration/bankAccounts/BelvoWidget.vue?62ad6740"],"names":[],"mappings":";AAsJA;EACA,iCAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;CACA;AAEA;EACA,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;CACA;AAEA;EACA,qCAAA;EACA,YAAA;CACA","file":"BelvoWidget.vue","sourcesContent":["<template src='./belvoWidget.pug' lang='pug' />\n<script>\n\nimport axios from '../../../../../build/http-requests/axios-common.js'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport customValidator from '../../../../utils/customValidator.js'\nimport { getBelvoInstitutionsByCdBankPersonType } from '../../../../enum/codigoBancoBelvo.js'\nimport { TheMask } from 'vue-the-mask'\nimport { ToggleButton } from 'vue-js-toggle-button'\nimport { Validator } from 'vee-validate'\nimport PATHS from '../../../../router/routesMap.js'\n\nexport default {\n  name: 'BelvoWidget',\n\n  props: {\n    showOpenFinance: {\n      type: Boolean,\n      default: false\n    },\n    bankAccount: {\n      type: Object,\n      required: true\n    },\n    linkOFDA: {\n      type: String\n    }\n  },\n\n  components: {\n    ButtonPrimary,\n    TheMask,\n    ToggleButton\n  },\n\n  watch: {\n    bankAccount: {\n      handler () {\n        this.enableOfdaForm = !!(this.bankAccount && this.bankAccount.optIn && this.bankAccount.optIn.id)\n      },\n      deep: true\n    }\n  },\n\n  data () {\n    return {\n      belvoToken: {},\n      cpf: null,\n      cnpj: null,\n      requisitante: '',\n      empresa: '',\n      tipoConta: 'PF',\n      link: null,\n      enableOfdaForm: false\n    }\n  },\n\n  methods: {\n    activeWidgetBelvo () {\n      let institutionsList = getBelvoInstitutionsByCdBankPersonType(this.bankAccount.bank.codigo, this.tipoConta)\n      if (institutionsList.length <= 0) {\n        this.$root.$refs.notification.warning(this.$t('ofda.nenhumaInstituicaoHomologada'))\n        this.$store.dispatch('setHasUnsavedChanges', false)\n        this.$store.dispatch('cleanBankAccountToEdit')\n        location.href = PATHS.LIST_BANK_ACCOUNTS\n      } else {\n        return new Promise((resolve, reject) => {\n          let body = {\n            user: {\n              name: this.requisitante,\n              registration: this.cpf\n            },\n            bankAccountData: this.bankAccount.bank.codigo + '|' + this.bankAccount.agency + '|' + this.bankAccount.accountNumber\n          }\n\n          if (this.tipoConta === 'PJ') {\n            body.company = {\n              name: this.empresa,\n              registration: this.cnpj\n            }\n          }\n\n          axios.post('/ofda/generateOFDAAccess', body).then((response) => {\n            this.belvoToken = response.data\n            this.createWidget()\n            resolve()\n          }).catch((err) => {\n            this.$root.$refs.notification.error(err.message)\n            reject()\n          })\n        })\n      }\n    },\n\n    createWidget () {\n      const successCallbackFunction = (link, institution) => {\n      }\n      const onExitCallbackFunction = (data) => {\n      }\n      const onEventCallbackFunction = (data) => {\n      }\n\n      const config = {\n        integration_type: 'openfinance',\n        callback: (link, institution) => successCallbackFunction(link, institution),\n        onExit: (data) => onExitCallbackFunction(data),\n        onEvent: (data) => onEventCallbackFunction(data),\n        country_codes: ['BR'],\n        locale: 'pt',\n        institutions: getBelvoInstitutionsByCdBankPersonType(this.bankAccount.bank.codigo, this.tipoConta),\n        show_close_dialog: true,\n        show_abandon_survey: true,\n        institution_types: ['retail', 'business']\n      }\n      window.belvoSDK.createWidget(this.belvoToken.access, config).build()\n    },\n\n    loadScript (src) {\n      const node = document.createElement('script')\n      node.src = src\n      node.type = 'text/javascript'\n      node.async = true\n      // Assign the callback which will create the Widget\n      node.onload = this.createWidget\n      // Add script to document body\n      document.body.appendChild(node)\n    }\n  },\n\n  created () {\n    this.requisitante = this.$store.getters.user\n    this.empresa = this.$store.getters.clientName\n\n    Validator.extend('cnpjValido', {\n      getMessage: field => this.$t('estabelecimentos.erro.cnpjInvalido'),\n      validate: value => customValidator.validateCnpj(value)\n    })\n\n    Validator.extend('cpfValido', {\n      getMessage: field => this.$t('estabelecimentos.erro.cpfInvalido'),\n      validate: value => customValidator.validateCpf(value)\n    })\n  },\n\n  mounted () {\n    this.loadScript('https://cdn.belvo.io/belvo-widget-1-stable.js')\n  }\n}\n</script>\n<style>\n.open-finance {\n  font-family: 'Inter', sans-serif;\n  text-transform: initial !important;\n  font-size: 15px;\n  color: #147d96;\n}\n\n.open-finance-box{\n  border: 2px solid #147d96;\n  border-radius: 10px;\n  padding-left: 1vh;\n  padding-right: 1vh;\n  padding-top: 1vh;\n}\n\n.open-finance.primary {\n  background-color: #147d96 !important;\n  color: #fff;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1113 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-ea2dd414","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/betterModal/BetterModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.modal-mask {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, .5);\n  display: table;\n  transition: opacity .3s ease;\n}\n.bring-back {\n  z-index: 254 !important;\n}\n.modal-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n.modal-container {\n  border-radius: 3px;\n  margin: 0px auto;\n  background-color: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);\n  transition: all .3s ease;\n  font-family: Helvetica, Arial, sans-serif;\n}\n.modal-header {\n  padding: 0 15px 0;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  border-bottom: 2px solid #d0d0d0;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.modal-header h1 {\n  font-size: 2em;\n  margin-top: 15px;\n  margin-bottom: 0px;\n}\n.modal-header h4 {\n  margin-top: 5px;\n  margin-left: 2px;\n  margin-bottom: 10px;\n}\n.modal-header button {\n  color: #b1b1b1;\n  margin: 15px 10px 0px 0px !important;\n  font-size: 40px;\n  opacity: 1 !important;\n}\n.modal-header button:hover {\n  color: #1b3c65;\n}\n.modal-default-button {\n  float: right;\n}\n.modal-footer .modal-tabbed {\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n\n/*\n * The following styles are auto-applied to elements with\n * transition=\"modal\" when their visibility is toggled\n * by Vue.js.\n *\n * You can easily play with the modal transition by editing\n * these styles.\n */\n.modal-enter {\n  opacity: 0;\n}\n.modal-leave-active {\n  opacity: 0;\n}\n.modal-enter .modal-container,\n.modal-leave-active .modal-container {\n  -ms-transform: translateY(-100px);\n      transform: translateY(-100px);\n}\n", "", {"version":3,"sources":["/./client/components/modals/betterModal/BetterModal.vue?e32b5844"],"names":[],"mappings":";AAuEA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,6BAAA;CACA;AAEA;EACA,wBAAA;CACA;AAEA;EACA,oBAAA;EACA,uBAAA;CACA;AAEA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yCAAA;EACA,yBAAA;EACA,0CAAA;CACA;AAEA;EACA,kBAAA;EACA,iCAAA;AACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;EACA,4BAAA;EACA,6BAAA;CACA;AAEA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;CACA;AAEA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;CACA;AAEA;EACA,eAAA;EACA,qCAAA;EACA,gBAAA;EACA,sBAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,+BAAA;EACA,gCAAA;CACA;;AAEA;;;;;;;GAOA;AACA;EACA,WAAA;CACA;AAEA;EACA,WAAA;CACA;AAEA;;EAGA,kCAAA;MAAA,8BAAA;CACA","file":"BetterModal.vue","sourcesContent":["<template src='./betterModal.pug' lang='pug'></template>\n\n<script>\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport { trackAnalyticsEvent } from '../../../utils/analytics.js'\nimport { AutoFocus } from '../../../utils/directives.js'\nimport popExitingConfirmation from '../../../utils/popExitingConfirmation.js'\n\nexport default {\n  name: 'BetterModal',\n\n  components: {\n    ButtonPrimary\n  },\n\n  props: {\n    closable: {\n      type: Boolean,\n      default: false\n    },\n    id: {\n      type: String,\n      required: true\n    },\n    checkForUnsavedChanges: {\n      type: Boolean,\n      default: false\n    },\n    defaultCloseButton: {\n      type: Boolean,\n      default: false\n    },\n    tabbedModal: {\n      type: Boolean,\n      default: false\n    },\n    showFooter: {\n      type: Boolean,\n      default: true\n    },\n    bringBack: {\n      type: Boolean,\n      default: false\n    }\n  },\n\n  directives: {\n    AutoFocus\n  },\n\n  computed: {\n    hasUnsavedChanges () {\n      return this.$store.getters.hasUnsavedChanges\n    }\n  },\n\n  methods: {\n    close () {\n      if (this.checkForUnsavedChanges && this.hasUnsavedChanges && !popExitingConfirmation()) {\n        return\n      }\n      trackAnalyticsEvent(this, 'close-modal', 'titlebar-close-modal-click', this.id)\n      if (this.closable) {\n        this.$emit('close-modal')\n      }\n    }\n  }\n}\n</script>\n\n<style>\n.modal-mask {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, .5);\n  display: table;\n  transition: opacity .3s ease;\n}\n\n.bring-back {\n  z-index: 254 !important;\n}\n\n.modal-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.modal-container {\n  border-radius: 3px;\n  margin: 0px auto;\n  background-color: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);\n  transition: all .3s ease;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n.modal-header {\n  padding: 0 15px 0;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  background-color: #fff;\n  color: #1b3c65;\n  border-bottom: 2px solid #d0d0d0;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.modal-header h1 {\n  font-size: 2em;\n  margin-top: 15px;\n  margin-bottom: 0px;\n}\n\n.modal-header h4 {\n  margin-top: 5px;\n  margin-left: 2px;\n  margin-bottom: 10px;\n}\n\n.modal-header button {\n  color: #b1b1b1;\n  margin: 15px 10px 0px 0px !important;\n  font-size: 40px;\n  opacity: 1 !important;\n}\n\n.modal-header button:hover {\n  color: #1b3c65;\n}\n\n.modal-default-button {\n  float: right;\n}\n\n.modal-footer .modal-tabbed {\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n}\n\n/*\n * The following styles are auto-applied to elements with\n * transition=\"modal\" when their visibility is toggled\n * by Vue.js.\n *\n * You can easily play with the modal transition by editing\n * these styles.\n */\n.modal-enter {\n  opacity: 0;\n}\n\n.modal-leave-active {\n  opacity: 0;\n}\n\n.modal-enter .modal-container,\n.modal-leave-active .modal-container {\n  -webkit-transform: translateY(-100px);\n  transform: translateY(-100px);\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1114 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-eb2dd9ec","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/unauthorized/Unauthorized.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.vertical-center {\n  /* Make it a flex container */\n  display: -ms-flexbox;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.bg-tela-login:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n.bg-tela-login:after {\n  bottom: 0;\n}\n.bg-tela-login {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: linear-gradient(to right, #223768, #00C3BE);\n  height: auto !important;\n  min-height: 100vh;\n}\n.middle-white-box {\n  height: 485px;\n  width: 774px;\n  background-color: #FFF;\n  display: table;\n  text-align: center;\n}\n.not-found-img {\n  width: 245px;\n  height: 287px;\n}\n.image-container {\n  display: table-cell;\n}\n.image-container img {\n  display: block;\n  margin: 1.5vh auto;\n}\np.big-txt {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #646464;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\np.md-txt {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #646464;\n  font-size: 16px;\n  margin: 0.5vh auto;\n}\n", "", {"version":3,"sources":["/./client/components/views/unauthorized/Unauthorized.vue?7191b862"],"names":[],"mappings":";AAkCA;EACA,8BAAA;EAGA,qBAAA;EAEA,cAAA;;EAEA,gDAAA;EAIA,uBAAA;EACA,oBAAA;;EAEA,YAAA;EAIA,sBAAA;EAEA,wBAAA;CACA;AAEA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;CACA;AAEA;EACA,UAAA;CACA;AAEA;EACA,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oBAAA;EAIA,wDAAA;EACA,wBAAA;EACA,kBAAA;CACA;AAEA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;CACA;AAEA;EACA,aAAA;EACA,cAAA;CACA;AAEA;EACA,oBAAA;CACA;AAEA;EACA,eAAA;EACA,mBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,iCAAA;AACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;CACA","file":"Unauthorized.vue","sourcesContent":["<template src=\"./unauthorized.pug\" lang=\"pug\"></template>\n\n<script>\nimport ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'\nimport PATHS from '../../../router/routesMap.js'\n\nexport default {\n  name: 'Unauthorized',\n\n  components: {\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      imageNotFound: require('../../../assets/notFound/forbidden.png')\n    }\n  },\n\n  computed: {\n    client () {\n      return this.$store.getters.client\n    }\n  },\n\n  methods: {\n    goHome () {\n      location.href = this.client ? PATHS.HOME : PATHS.LOGIN\n    }\n  }\n}\n</script>\n\n<style>\n.vertical-center {\n  /* Make it a flex container */\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -moz-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n\n  width: 100%;\n\n  -webkit-box-pack: center;\n  -moz-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n}\n\n.bg-tela-login:after {\n  content: \"\";\n  position: fixed;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  left: 0;\n  right: 0;\n  height: 8px;\n}\n\n.bg-tela-login:after {\n  bottom: 0;\n}\n\n.bg-tela-login {\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-color: #223768;\n  background: #223768;\n  background: -webkit-linear-gradient(left, #1C3B65, #40B9BB);\n  background: -o-linear-gradient(right, #223768, #00C3BE);\n  background: -moz-linear-gradient(right, #223768, #00C3BE);\n  background: linear-gradient(to right, #223768, #00C3BE);\n  height: auto !important;\n  min-height: 100vh;\n}\n\n.middle-white-box {\n  height: 485px;\n  width: 774px;\n  background-color: #FFF;\n  display: table;\n  text-align: center;\n}\n\n.not-found-img {\n  width: 245px;\n  height: 287px;\n}\n\n.image-container {\n  display: table-cell;\n}\n\n.image-container img {\n  display: block;\n  margin: 1.5vh auto;\n}\n\np.big-txt {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #646464;\n  font-size: 21px;\n  margin: 1.5vh auto;\n}\n\np.md-txt {\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  color: #646464;\n  font-size: 16px;\n  margin: 0.5vh auto;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1115 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-eb88efa0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/index/Index.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.isLoadingDataGeneral {\n  background: url(" + __webpack_require__(/*! ../../../assets/loading-gif/loading.svg */ 67) + ") 50% 50% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.8;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  transition: all 5s ease-in-out;\n}\n.inicial-bg {\n  height: 80vh;\n  background: url(" + __webpack_require__(/*! ../../../assets/logos_equals/logo_equals_inicial.svg */ 1139) + ") center no-repeat;\n  margin: auto;\n  position: absolute;\n  right: 40vw;\n}\n.highcharts-no-data>span {\n  font-family: 'Inter', sans-serif !important;\n  font-size: 18px !important;\n  text-align: center;\n  color: #4a4a4a;\n}\n.highcharts-no-data>span>i {\n  font-size: 6em;\n  color: rgba(119, 119, 119, 0.35);\n  padding-bottom: 40px;\n}\n.highcharts-button {\n  cursor: pointer!important;\n}\n.highcharts-yaxis .highcharts-axis-line {\n  stroke-width: 2px;\n}\n@media sen and (min-width: 992px) {\n.inicial-bg {\n    width: 20%;\n}\n}\n@media screen and (max-width: 991px) and (min-width: 560px) {\n.inicial-bg {\n    width: 40%;\n}\n}\n@media screen and (max-width: 559px) {\n.inicial-bg {\n    width: 90%;\n}\n}\n", "", {"version":3,"sources":["/./client/components/views/index/Index.vue?78cf4451"],"names":[],"mappings":";AAs0BA;EACA,4DAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAKA,+BAAA;CACA;AAEA;EACA,aAAA;EACA,2DAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;CACA;AAEA;EACA,4CAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;CACA;AAEA;EACA,eAAA;EACA,iCAAA;EACA,qBAAA;CACA;AAEA;EACA,0BAAA;CACA;AAEA;EACA,kBAAA;CACA;AAEA;AACA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;CACA;AAEA;AACA;IACA,WAAA;CACA;CACA","file":"Index.vue","sourcesContent":["<template src=\"./index.pug\" lang=\"pug\"></template>\n\n<script>\nimport moment from 'moment'\nimport vSelect from 'vue-select'\nimport Draggable from 'vuedraggable'\nimport Dashboard from '../../dashboard/Dashboard'\nimport { getCharts } from './config'\nimport language from '../../../../build/language/index'\nimport GraficoIdEnum from '../../../enum/graficoId'\nimport FiltroPeriodoEnum from '../../../enum/filtroPeriodo'\n\nexport default {\n  name: 'Index',\n\n  components: {\n    vSelect,\n    Draggable,\n    Dashboard\n  },\n\n  data () {\n    return {\n      doneLoading: false,\n      clientId: null,\n      windowWidth: null,\n      minWindowWidth: 1024,\n      itermedWindowWidth: 1320,\n      intervalLoadGadgets: null,\n      isLoadingGadgets: false,\n      view: false,\n      gadgets: [],\n      charts: getCharts(),\n      dashboardCharts: [],\n      hasPendingRequest: false,\n      canLoad: {\n        ChartConciliationSituationSummary: {\n          state: false,\n          alreadyLoaded: false,\n          load: this.loadDataConciliationSituationSummary,\n          currentRequest: null\n        },\n        DailyBankStatment: {\n          state: false,\n          alreadyLoaded: false,\n          load: this.loadDataDailyBankStatment,\n          currentRequest: null\n        },\n        ChartAllotmentDistributionConciliation: {\n          state: false,\n          alreadyLoaded: false,\n          load: this.loadBatchReconciliationDistribution,\n          currentRequest: null\n        },\n        GadgetTasks: {\n          state: false,\n          alreadyLoaded: false,\n          load: this.loadDataTasks,\n          currentRequest: null\n        },\n        ChartFinancialSummary: {\n          state: false,\n          alreadyLoaded: false,\n          load: this.loadDataFinancialSummary,\n          currentRequest: null\n        },\n        DigitalWalletBalance: {\n          state: false,\n          alreadyLoaded: false,\n          load: this.loadDataDigitalWalletBalance,\n          currentRequest: null\n        }\n      }\n    }\n  },\n\n  computed: {\n    /* Globais */\n\n    client () {\n      return this.$store.getters.client\n    },\n\n    allowedFuncionalities () {\n      return this.$store.getters.allowedFuncionalities\n    },\n\n    isLoadingDataGeneral () {\n      return this.$store.getters.isLoadingData\n    },\n\n    availableGadgets () {\n      return this.$store.getters.availableGadgets\n    },\n\n    /* Filtros do gráfico Distribuição de conciliação */\n\n    periodFilterConcSitSummary () {\n      return this.$store.getters.periodFilterConcSitSummary\n    },\n\n    planSelectedFilterConcSitSummary () {\n      return this.$store.getters.planSelectedFilterConcSitSummary\n    },\n\n    typeFilterConcSituationSummary () {\n      return this.$store.getters.typeFilterConcSituationSummary\n    },\n\n    mainCategorySelectedFilterConcSitSummary () {\n      return this.$store.getters.mainCategorySelectedFilterConcSitSummary\n    },\n\n    /* Filtros do gráfico Lançamentos conciliados */\n\n    periodFilterAllotmentDistribution () {\n      return this.$store.getters.periodFilterAllotmentDistribution\n    },\n\n    planSelectedFilterBatch () {\n      return this.$store.getters.planSelectedFilterBatch\n    },\n\n    typeSelectedFilterBatch () {\n      return this.$store.getters.typeSelectedFilterBatch\n    },\n\n    mainCategorySelectedFilterBatch () {\n      return this.$store.getters.mainCategorySelectedFilterBatch\n    },\n\n    /* Filtros do gráfico Resumo financeiro */\n\n    periodFilterFinancialSummary () {\n      return this.$store.getters.periodFilterFinancialSummary\n    },\n\n    mainCategorySelectedFilterFinancialSummary () {\n      return this.$store.getters.mainCategorySelectedFilterFinancialSummary\n    },\n\n    /* Filtros do gráfico Saldo bancário */\n\n    periodFilterBankBalance () {\n      return this.$store.getters.periodFilterBankBalance\n    },\n\n    accountSelectedBankBalance () {\n      return this.$store.getters.accountSelectedBankBalance\n    },\n\n    /* Filtros do gráfico Saldo carteira digital */\n\n    periodFilterDigitalWalletBalance () {\n      return this.$store.getters.periodFilterDigitalWalletBalance\n    },\n\n    categorySelectedDigitalWalletBalance () {\n      return this.$store.getters.categorySelectedDigitalWalletBalance\n    }\n  },\n\n  watch: {\n    /* Globais */\n\n    client () {\n      this.loadHome()\n    },\n\n    canLoad: {\n      handler () {\n        for (const key in this.canLoad) {\n          if (this.canLoad[key].alreadyLoaded) {\n            continue\n          }\n          if (this.canLoad[key].state) {\n            this.canLoad[key].load()\n          } else {\n            this.stopLoadingGadget(key)\n          }\n        }\n      },\n      deep: true\n    },\n\n    /* Filtros do gráfico Distribuição de conciliação */\n\n    periodFilterConcSitSummary: {\n      handler (newVal, oldVal) {\n        let isNewisNewLoading = newVal.id !== oldVal.id ||\n        (\n          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&\n          (\n            newVal.fromDate !== oldVal.fromDate ||\n            newVal.toDate !== oldVal.toDate\n          )\n        )\n        this.handleConciliationSituationSummary(!isNewisNewLoading)\n      },\n      deep: true\n    },\n\n    planSelectedFilterConcSitSummary: {\n      handler (newVal, oldVal) {\n        this.handleConciliationSituationSummary(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    typeFilterConcSituationSummary: {\n      handler (newVal, oldVal) {\n        this.handleConciliationSituationSummary(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    mainCategorySelectedFilterConcSitSummary: {\n      handler (newVal, oldVal) {\n        this.handleConciliationSituationSummary(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    /* Filtros do gráfico Lançamentos conciliados */\n\n    periodFilterAllotmentDistribution: {\n      handler (newVal, oldVal) {\n        let isNewisNewLoading = newVal.id !== oldVal.id ||\n        (\n          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&\n          (\n            newVal.fromDate !== oldVal.fromDate ||\n            newVal.toDate !== oldVal.toDate\n          )\n        )\n        this.handleReconciliationDistribution(!isNewisNewLoading)\n      },\n      deep: true\n    },\n\n    planSelectedFilterBatch: {\n      handler (newVal, oldVal) {\n        this.handleReconciliationDistribution(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    typeSelectedFilterBatch: {\n      handler (newVal, oldVal) {\n        this.handleReconciliationDistribution(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    mainCategorySelectedFilterBatch: {\n      handler (newVal, oldVal) {\n        this.handleReconciliationDistribution(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    /* Filtros do gráfico Resumo financeiro */\n\n    periodFilterFinancialSummary: {\n      handler (newVal, oldVal) {\n        const currentRequest = this.canLoad.ChartFinancialSummary.currentRequest\n        let isNewLoading = true\n        if (currentRequest) {\n          if (currentRequest.periodo === newVal.id && newVal.id === FiltroPeriodoEnum.PERSONALIZADO) {\n            if (newVal.fromDate !== currentRequest.dataInicio || newVal.toDate !== currentRequest.dataFim) {\n              this.canLoad.ChartFinancialSummary.currentRequest = null\n            } else {\n              isNewLoading = false\n            }\n          } else if (currentRequest.periodo === newVal.id) {\n            return\n          } else {\n            this.canLoad.ChartFinancialSummary.currentRequest = null\n          }\n        }\n        this.canLoad.ChartFinancialSummary.alreadyLoaded = !isNewLoading\n        this.canLoad.ChartFinancialSummary.state = this.periodFilterFinancialSummary && this.periodFilterFinancialSummary.id\n      },\n      deep: true\n    },\n\n    mainCategorySelectedFilterFinancialSummary: {\n      handler (newVal, oldVal) {\n        this.handleFinancialSummary(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    /* Filtros do gráfico Saldo bancário */\n\n    periodFilterBankBalance: {\n      handler (newVal, oldVal) {\n        let isNewisNewLoading = newVal.id !== oldVal.id ||\n        (\n          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&\n          (\n            newVal.fromDate !== oldVal.fromDate ||\n            newVal.toDate !== oldVal.toDate\n          )\n        )\n        this.handleBankBalance(!isNewisNewLoading)\n      },\n      deep: true\n    },\n\n    accountSelectedBankBalance: {\n      handler (newVal, oldVal) {\n        this.handleBankBalance(newVal.id === oldVal.id)\n      },\n      deep: true\n    },\n\n    /* Filtros do gráfico Saldo carteira digital */\n\n    periodFilterDigitalWalletBalance: {\n      handler (newVal, oldVal) {\n        let isNewisNewLoading = newVal.id !== oldVal.id ||\n        (\n          newVal.id === FiltroPeriodoEnum.PERSONALIZADO &&\n          (\n            newVal.fromDate !== oldVal.fromDate ||\n            newVal.toDate !== oldVal.toDate\n          )\n        )\n        this.handleDigitalWalletBalance(!isNewisNewLoading)\n      },\n      deep: true\n    },\n\n    categorySelectedDigitalWalletBalance: {\n      handler (newVal, oldVal) {\n        this.handleDigitalWalletBalance(newVal.id === oldVal.id)\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    /* Globais */\n\n    loadHome () {\n      this.resetGadgets()\n      this.hasPendingRequest = true\n      this.$store.dispatch('loadingData').then(() => {\n        this.loadGadgets().then(() => {\n          this.canLoad.GadgetTasks.state = true\n          this.hasPendingRequest = false\n          this.$store.dispatch('dataLoaded')\n        })\n      })\n    },\n\n    loadGadgets () {\n      const self = this\n      return new Promise((resolve, reject) => {\n        Promise.all([this.loadPlans(), this.loadMainCategories()])\n          .then(() => {\n            self.$store.dispatch('getGadgets')\n              .then((response) => {\n                self.handleGadgetsChange()\n                resolve()\n              }).catch(() => {\n                self.gadgets = []\n                self.view = false\n                reject()\n              })\n          }).catch((error) => {\n            reject(error)\n          })\n      })\n    },\n\n    handleGadgetsChange () {\n      this.view = false\n      this.windowWidth = window.innerWidth\n\n      this.dashboardCharts = []\n\n      if (!this.intervalLoadGadgets) {\n        this.intervalLoadGadgets = setInterval(function () {\n          if (!this.hasPendingRequest && this.allowedFuncionalities && this.allowedFuncionalities.length > 0) {\n            this.loadHome()\n          }\n        }.bind(this), 600000)\n      }\n\n      for (const gadget of this.availableGadgets) {\n        let idGadget = gadget.funcionalidade.idFuncionalidade\n        let container = null\n        let order = null\n\n        if (gadget && gadget.gadgetParam && gadget.gadgetParam.length > 0) {\n          // Pega a configuração de qual container está\n          container = Number(gadget.gadgetParam.find(param => param.nome === 'container').valor)\n\n          // Pega a configuração de ordem\n          order = gadget.gadgetParam.find(param => param.nome === 'ordemExibicao').valor\n        }\n\n        // Encontra o gráfico pelo id, para setar as configurações\n        const index = this.charts.findIndex(chart => chart.idChart === idGadget)\n        if (index === -1) {\n          continue\n        }\n        const chartFound = this.charts[index]\n        chartFound.container = container === 1 ? 'chartFull' : 'chartMiddle'\n        chartFound.order = Number(order)\n\n        this.dashboardCharts.push(chartFound)\n        this.canLoad[chartFound.idChartTemplate].state = true\n      }\n      this.dashboardCharts.sort((a, b) => a.order - b.order)\n      this.doneLoading = true\n      this.view = this.availableGadgets.length > 0\n      this.$store.dispatch('setDashboardDateFilter', {\n        id: FiltroPeriodoEnum.ULTIMOS_TRINTA_DIAS,\n        label: this.$t('dashboard.filtro.data.ultimosTrintaDias')\n      })\n    },\n\n    stopLoadingGadget (idChart) {\n      const chartConfig = this.charts.find(chart => chart.idChartTemplate === idChart)\n      if (chartConfig.series) {\n        chartConfig.series = []\n      }\n      if (chartConfig.xAxis) {\n        chartConfig.xAxis.categories = []\n      }\n      chartConfig.isLoadingData = false\n    },\n\n    resetGadgets () {\n      this.$store.dispatch('cancelDashboardRequests')\n      this.gadgets = []\n      this.view = false\n      clearInterval(this.intervalLoadGadgets)\n      this.intervalLoadGadgets = null\n      for (const key in this.canLoad) {\n        this.canLoad[key].alreadyLoaded = false\n        this.canLoad[key].state = false\n      }\n    },\n\n    loadPlans () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('getPlans', '/dashboard/listPlans').then((response) => {\n          this.$store.dispatch('setPlansDashboard', response.data.data)\n          resolve()\n        }).catch((error) => {\n          reject(error)\n        })\n      })\n    },\n\n    loadMainCategories () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('getMainCategories', '/dashboard/listMainCategories').then((response) => {\n          this.$store.dispatch('setMainCategoriesDashboard', response.data)\n          resolve()\n        }).catch((error) => {\n          reject(error)\n        })\n      })\n    },\n\n    /* Gráfico Distribuição de conciliação */\n\n    handleConciliationSituationSummary (alreadyLoaded) {\n      const currentRequest = this.canLoad.ChartConciliationSituationSummary.currentRequest\n      if (currentRequest) {\n        if (currentRequest.idPlanoConciliacao === this.planSelectedFilterConcSitSummary.id &&\n          (currentRequest.tipo || 'TD') === this.typeFilterConcSituationSummary.id &&\n          (currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterConcSitSummary.id &&\n          alreadyLoaded) {\n          return\n        }\n        this.canLoad.ChartConciliationSituationSummary.currentRequest = null\n      }\n      this.canLoad.ChartConciliationSituationSummary.alreadyLoaded = alreadyLoaded\n      this.canLoad.ChartConciliationSituationSummary.state = this.periodFilterConcSitSummary &&\n        this.periodFilterConcSitSummary.id &&\n        this.planSelectedFilterConcSitSummary &&\n        this.planSelectedFilterConcSitSummary.id &&\n        this.typeFilterConcSituationSummary &&\n        this.typeFilterConcSituationSummary.id &&\n        this.mainCategorySelectedFilterConcSitSummary &&\n        this.mainCategorySelectedFilterConcSitSummary.id\n    },\n\n    loadDataConciliationSituationSummary () {\n      const self = this\n      return new Promise((resolve, reject) => {\n        // Verifica se possui permissão na lista de gadgets disponíveis\n        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.RESUMO_SITUACAO_CONCILIACAO)\n        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'ChartConciliationSituationSummary')\n\n        if (!gadget || !self.planSelectedFilterConcSitSummary.id || !self.periodFilterConcSitSummary.id) {\n          chartConfig.series = []\n          chartConfig.xAxis.categories = []\n          chartConfig.isLoadingData = false\n          return resolve()\n        }\n\n        self.canLoad.ChartConciliationSituationSummary.alreadyLoaded = true\n\n        chartConfig.isLoadingData = true\n        const filterConciliationSituationSummary = {\n          idPlanoConciliacao: self.planSelectedFilterConcSitSummary.id,\n          tipo: self.typeFilterConcSituationSummary.id !== 'TD' ? self.typeFilterConcSituationSummary.id : null,\n          idCategoriaPai: self.mainCategorySelectedFilterConcSitSummary.id !== 'TD' ? self.mainCategorySelectedFilterConcSitSummary.id : null,\n          periodo: self.periodFilterConcSitSummary.id,\n          dataInicio: self.periodFilterConcSitSummary.fromDate,\n          dataFim: self.periodFilterConcSitSummary.toDate,\n          lang: language.getCookieByName('language')\n        }\n\n        self.canLoad.ChartConciliationSituationSummary.currentRequest = filterConciliationSituationSummary\n\n        self.$store.dispatch('getDataConciliationSituationSummary', filterConciliationSituationSummary)\n          .then((response) => {\n            chartConfig.series = response.data.series\n            chartConfig.xAxis.categories = response.data.xAxis\n            resolve()\n          }).catch(() => {\n            chartConfig.series = []\n            chartConfig.xAxis.categories = []\n            reject()\n          }).finally(() => {\n            chartConfig.isLoadingData = false\n          })\n      })\n    },\n\n    /* Gráfico Lançamentos conciliados */\n\n    handleReconciliationDistribution (alreadyLoaded) {\n      const currentRequest = this.canLoad.ChartAllotmentDistributionConciliation.currentRequest\n      if (currentRequest) {\n        if (currentRequest.idPlanoConciliacao === this.planSelectedFilterBatch.id &&\n          (currentRequest.tipo || 'TD') === this.typeSelectedFilterBatch.id &&\n          (currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterBatch.id &&\n          alreadyLoaded) {\n          return\n        }\n        this.canLoad.ChartAllotmentDistributionConciliation.currentRequest = null\n      }\n      this.canLoad.ChartAllotmentDistributionConciliation.alreadyLoaded = alreadyLoaded\n      this.canLoad.ChartAllotmentDistributionConciliation.state = this.periodFilterAllotmentDistribution && this.periodFilterAllotmentDistribution.id &&\n        this.planSelectedFilterBatch && this.planSelectedFilterBatch.id &&\n        this.typeSelectedFilterBatch && this.typeSelectedFilterBatch.id &&\n        this.mainCategorySelectedFilterBatch && this.mainCategorySelectedFilterBatch.id\n    },\n\n    loadBatchReconciliationDistribution () {\n      const self = this\n      return new Promise((resolve, reject) => {\n        // Verifica se possui permissão na lista de gadgets disponíveis\n        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.DISTRIBUICAO_CONCILIACAO_LOTE)\n        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'ChartAllotmentDistributionConciliation')\n\n        if (!gadget || !self.periodFilterAllotmentDistribution.id || !self.planSelectedFilterBatch.id) {\n          chartConfig.series = []\n          chartConfig.isLoadingData = false\n          self.isLoadingDataBatchReconciliationDistribution = false\n          return resolve()\n        }\n\n        self.canLoad.ChartAllotmentDistributionConciliation.alreadyLoaded = true\n\n        chartConfig.isLoadingData = true\n        const filterAllotmentDistribution = {\n          idPlanoConciliacao: self.planSelectedFilterBatch.id,\n          tipo: self.typeSelectedFilterBatch.id !== 'TD' ? self.typeSelectedFilterBatch.id : null,\n          idCategoriaPai: self.mainCategorySelectedFilterBatch.id !== 'TD' ? self.mainCategorySelectedFilterBatch.id : null,\n          periodo: self.periodFilterAllotmentDistribution.id,\n          dataInicio: self.periodFilterAllotmentDistribution.fromDate,\n          dataFim: self.periodFilterAllotmentDistribution.toDate,\n          lang: language.getCookieByName('language')\n        }\n\n        self.canLoad.ChartAllotmentDistributionConciliation.currentRequest = filterAllotmentDistribution\n\n        self.$store.dispatch('getDataAllotmentDistributionSummary', filterAllotmentDistribution)\n          .then(response => {\n            chartConfig.series = response.data.series\n            resolve()\n          })\n          .catch(() => {\n            chartConfig.series = []\n            reject()\n          })\n          .finally(() => {\n            chartConfig.isLoadingData = false\n          })\n      })\n    },\n\n    /* Gráfico Resumo financeiro */\n\n    handleFinancialSummary (alreadyLoaded) {\n      const currentRequest = this.canLoad.ChartFinancialSummary.currentRequest\n      if (currentRequest) {\n        if ((currentRequest.idCategoriaPai || 'TD') === this.mainCategorySelectedFilterFinancialSummary.id &&\n          alreadyLoaded) {\n          return\n        }\n        this.canLoad.ChartFinancialSummary.currentRequest = null\n      }\n      this.canLoad.ChartFinancialSummary.alreadyLoaded = alreadyLoaded\n      this.canLoad.ChartFinancialSummary.state = this.periodFilterFinancialSummary &&\n        this.periodFilterFinancialSummary.id &&\n        this.mainCategorySelectedFilterFinancialSummary &&\n        this.mainCategorySelectedFilterFinancialSummary.id\n    },\n\n    loadDataFinancialSummary () {\n      const self = this\n      return new Promise((resolve, reject) => {\n        // Verifica se possui permissão na lista de gadgets disponíveis\n        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.RESUMO_FINANCEIRO_PLANO_CONCILIACAO)\n        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'ChartFinancialSummary')\n\n        if (!gadget || !self.periodFilterFinancialSummary.id) {\n          chartConfig.isLoadingData = false\n          chartConfig.series = []\n          chartConfig.xAxis.categories = []\n          return resolve()\n        }\n\n        self.canLoad.ChartFinancialSummary.alreadyLoaded = true\n\n        chartConfig.isLoadingData = true\n        const filterFinancialSummary = {\n          tipo: 'MF',\n          idCategoriaPai: self.mainCategorySelectedFilterFinancialSummary.id !== 'TD' ? self.mainCategorySelectedFilterFinancialSummary.id : null,\n          periodo: self.periodFilterFinancialSummary.id,\n          dataInicio: self.periodFilterFinancialSummary.fromDate,\n          dataFim: self.periodFilterFinancialSummary.toDate,\n          lang: language.getCookieByName('language')\n        }\n\n        self.canLoad.ChartFinancialSummary.currentRequest = filterFinancialSummary\n\n        self.$store.dispatch('getDataFinancialSummary', filterFinancialSummary)\n          .then((response) => {\n            chartConfig.series = response.data.series\n            chartConfig.xAxis.categories = response.data.xAxis\n            resolve()\n          }).catch(() => {\n            chartConfig.series = []\n            chartConfig.xAxis.categories = []\n            reject()\n          })\n          .finally(() => {\n            chartConfig.isLoadingData = false\n          })\n      })\n    },\n\n    /* Gráfico Saldo bancário */\n\n    handleBankBalance (alreadyLoaded) {\n      const currentRequest = this.canLoad.DailyBankStatment.currentRequest\n      if (currentRequest) {\n        if (currentRequest.idConta === this.accountSelectedBankBalance.id && alreadyLoaded) {\n          return\n        }\n        this.canLoad.DailyBankStatment.currentRequest = null\n      }\n      this.canLoad.DailyBankStatment.alreadyLoaded = alreadyLoaded\n      this.canLoad.DailyBankStatment.state = this.periodFilterBankBalance && this.periodFilterBankBalance.id && this.accountSelectedBankBalance && typeof this.accountSelectedBankBalance.id !== 'undefined'\n    },\n\n    loadDataDailyBankStatment () {\n      const self = this\n      return new Promise((resolve, reject) => {\n        // Verifica se possui permissão na lista de gadgets disponíveis\n        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.SALDO_BANCARIO)\n        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'DailyBankStatment')\n\n        if (!gadget || !self.periodFilterBankBalance.id || typeof self.accountSelectedBankBalance.id === 'undefined') {\n          chartConfig.series = []\n          chartConfig.xAxis.categories = []\n          chartConfig.isLoadingData = false\n          return resolve()\n        }\n\n        self.canLoad.DailyBankStatment.alreadyLoaded = true\n\n        let idGrupo\n        // Tratamento para mandar 0 para o MS ao inves de -1\n        if (self.accountSelectedBankBalance.tipo === 'GRUPO') {\n          idGrupo = self.accountSelectedBankBalance.id > 0 ? self.accountSelectedBankBalance.id : 0\n        }\n\n        chartConfig.isLoadingData = true\n        const filterDailyBank = {\n          idConta: (self.accountSelectedBankBalance.tipo === 'CONTA_BANCARIA') ? self.accountSelectedBankBalance.id : null,\n          idGrupo: (self.accountSelectedBankBalance.tipo === 'GRUPO') ? idGrupo : null,\n          periodo: self.periodFilterBankBalance.id,\n          dataInicio: self.periodFilterBankBalance.fromDate,\n          dataFim: self.periodFilterBankBalance.toDate,\n          lang: language.getCookieByName('language')\n        }\n\n        self.canLoad.DailyBankStatment.currentRequest = filterDailyBank\n\n        this.$store.dispatch('getDataDailyBankStatment', filterDailyBank)\n          .then(response => {\n            chartConfig.series = response.data.series\n            chartConfig.xAxis.categories = response.data.xAxis\n            resolve()\n          })\n          .catch((error) => {\n            chartConfig.series = []\n            chartConfig.xAxis.categories = []\n            if (error && error.message === 'user.cancelled') {\n              resolve()\n            } else {\n              reject()\n            }\n          }).finally(() => {\n            chartConfig.isLoadingData = false\n          })\n      })\n    },\n\n    /* Gráfico de tarefas */\n\n    loadDataTasks () {\n      const self = this\n      return new Promise((resolve, reject) => {\n        // Verifica se possui permissão na lista de gadgets disponíveis\n        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.GADGET_TAREFAS)\n        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'GadgetTasks')\n\n        if (!gadget) {\n          return resolve()\n        }\n\n        self.canLoad.GadgetTasks.alreadyLoaded = true\n\n        chartConfig.isLoadingData = true\n        self.$store.dispatch('getDataTasks')\n          .then(response => {\n            const tasks = response.data\n            tasks.dataProximoVencimento = tasks.dataProximoVencimento ? moment(tasks.dataProximoVencimento).format('L') : null\n            chartConfig.data = tasks\n            resolve()\n          })\n          .catch(() => {\n            reject()\n          }).finally(() => {\n            chartConfig.isLoadingData = false\n          })\n      })\n    },\n\n    /* Gráfico Saldo carteira digital */\n\n    handleDigitalWalletBalance (alreadyLoaded) {\n      const currentRequest = this.canLoad.DigitalWalletBalance.currentRequest\n      if (currentRequest) {\n        if (currentRequest.idCategoria === this.categorySelectedDigitalWalletBalance.id && alreadyLoaded) {\n          return\n        }\n        this.canLoad.DigitalWalletBalance.currentRequest = null\n      }\n      this.canLoad.DigitalWalletBalance.alreadyLoaded = alreadyLoaded\n      this.canLoad.DigitalWalletBalance.state = this.periodFilterDigitalWalletBalance && this.periodFilterDigitalWalletBalance.id && this.categorySelectedDigitalWalletBalance && typeof this.categorySelectedDigitalWalletBalance.id !== 'undefined'\n    },\n\n    loadDataDigitalWalletBalance () {\n      const self = this\n      return new Promise((resolve, reject) => {\n        // Verifica se possui permissão na lista de gadgets disponíveis\n        const gadget = self.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.SALDO_CARTEIRA_DIGITAL)\n        const chartConfig = self.charts.find(chart => chart.idChartTemplate === 'DigitalWalletBalance')\n\n        if (!gadget || !self.periodFilterDigitalWalletBalance.id || typeof self.categorySelectedDigitalWalletBalance.id === 'undefined') {\n          chartConfig.series = []\n          chartConfig.xAxis.categories = []\n          chartConfig.isLoadingData = false\n          return resolve()\n        }\n\n        self.canLoad.DigitalWalletBalance.alreadyLoaded = true\n\n        chartConfig.isLoadingData = true\n        const filterDigitalWalletBalance = {\n          idCategoria: self.categorySelectedDigitalWalletBalance.id !== 'TD' ? self.categorySelectedDigitalWalletBalance.id : null,\n          periodo: self.periodFilterDigitalWalletBalance.id,\n          dataInicio: self.periodFilterDigitalWalletBalance.fromDate,\n          dataFim: self.periodFilterDigitalWalletBalance.toDate,\n          lang: language.getCookieByName('language')\n        }\n\n        self.canLoad.DigitalWalletBalance.currentRequest = filterDigitalWalletBalance\n\n        this.$store.dispatch('getDataDigitalWalletBalance', filterDigitalWalletBalance)\n          .then(response => {\n            chartConfig.series = response.data.series\n            chartConfig.xAxis.categories = response.data.xAxis\n            resolve()\n          })\n          .catch((error) => {\n            chartConfig.series = []\n            chartConfig.xAxis.categories = []\n            if (error && error.message === 'user.cancelled') {\n              resolve()\n            } else {\n              reject()\n            }\n          }).finally(() => {\n            chartConfig.isLoadingData = false\n          })\n      })\n    }\n  },\n\n  mounted () {\n    if (this.client && this.allowedFuncionalities && this.allowedFuncionalities.length > 0) {\n      this.loadHome()\n    }\n  },\n\n  beforeDestroy () {\n    this.$store.dispatch('cleanGadgetsFilters')\n  }\n}\n</script>\n\n<style>\n.isLoadingDataGeneral {\n  background: url(../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.8;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  -webkit-transition: all 5s ease-in-out;\n  -moz-transition: all 5s ease-in-out;\n  -ms-transition: all 5s ease-in-out;\n  -o-transition: all 5s ease-in-out;\n  transition: all 5s ease-in-out;\n}\n\n.inicial-bg {\n  height: 80vh;\n  background: url(../../../assets/logos_equals/logo_equals_inicial.svg) center no-repeat;\n  margin: auto;\n  position: absolute;\n  right: 40vw;\n}\n\n.highcharts-no-data>span {\n  font-family: 'Inter', sans-serif !important;\n  font-size: 18px !important;\n  text-align: center;\n  color: #4a4a4a;\n}\n\n.highcharts-no-data>span>i {\n  font-size: 6em;\n  color: rgba(119, 119, 119, 0.35);\n  padding-bottom: 40px;\n}\n\n.highcharts-button {\n  cursor: pointer!important;\n}\n\n.highcharts-yaxis .highcharts-axis-line {\n  stroke-width: 2px;\n}\n\n@media sen and (min-width: 992px) {\n  .inicial-bg {\n    width: 20%;\n  }\n}\n\n@media screen and (max-width: 991px) and (min-width: 560px) {\n  .inicial-bg {\n    width: 40%;\n  }\n}\n\n@media screen and (max-width: 559px) {\n  .inicial-bg {\n    width: 90%;\n  }\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1116 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-ec141a1a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/modals/ApplyModal.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.confirm-dialog-header {\n  color: red;\n}\n", "", {"version":3,"sources":["/./client/components/reports/manualConciliation/modals/ApplyModal.vue?640ce9a8"],"names":[],"mappings":";AAyOA;EACA,WAAA;CACA","file":"ApplyModal.vue","sourcesContent":["<template src=\"./applyModal.pug\" lang=\"pug\"></template>\n\n<script>\nimport ConfirmModal from '../../../modals/confirmModal/ConfirmModal'\nimport ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'\nimport { verifyReaplyConcByTimeAsync, verifyReaplyConcTimeout } from '../../../../utils/verifyReaplyConcByTimeAsync'\n\nexport default {\n  name: 'ApplyModal',\n\n  components: {\n    ConfirmModal,\n    ButtonPrimary\n  },\n\n  data () {\n    return {\n      disableButton: false,\n      isJustification: false\n    }\n  },\n\n  computed: {\n    allotmentId () {\n      return this.$store.getters.idAllotment\n    },\n\n    totalAmountForInternalEntries () {\n      return this.$store.getters.totalAmountForInternalEntries\n    },\n\n    totalAmountForBankEntries () {\n      return this.$store.getters.totalAmountForBankEntries\n    },\n\n    totalAmountToJustify () {\n      return this.calculateTotalToJustify()\n    },\n\n    totalDivergence () {\n      let value = Number(Number(this.totalAmountForBankEntries) - Number(this.totalAmountForInternalEntries) - Number(this.totalAmountToJustify)).toFixed(2)\n      return Number(value).toFixed(2)\n    },\n\n    finMovAdded () {\n      return this.$store.getters.finMovAdded\n    },\n\n    bankStatAdded () {\n      return this.$store.getters.bankStatAdded\n    },\n\n    arrayJustify () {\n      return this.$store.getters.arrayJustify\n    }\n  },\n\n  watch: {\n    arrayJustify () {\n      this.isJustification = this.$store.getters.arrayJustify.length > 0\n    }\n  },\n\n  methods: {\n    // Criação de lotes\n    confirmApplyAllotment () {\n      this.$store.dispatch('loadingData').then(() => {\n        this.disableButton = true\n        let reaplicarConciliacao = this.$store.getters.isReaplyConciliation\n        let data = {\n          idLote: this.allotmentId,\n          idsMovFinanceira: this.generateArrayWithIds(this.finMovAdded),\n          idsMovBancaria: this.generateArrayWithIds(this.bankStatAdded),\n          valorDivergencia: this.totalDivergence,\n          dataBase: new Date(),\n          reaplicarConciliacao: reaplicarConciliacao\n        }\n        this.$store.dispatch('applyConciliation', data)\n          .then((response) => {\n            if (reaplicarConciliacao) {\n              // Alterando mensagem do loading\n              this.$store.dispatch('setLoadingMessage', 'conciliacaoManual.labels.conciliacaoAutomatica')\n              this.$store.dispatch('reaplyConciliation', data)\n                .catch((error) => {\n                  this.confirmApplyAllotmentError(error)\n                })\n              // Verificando situacao da conciliacao\n              verifyReaplyConcByTimeAsync(\n                () => this.$store.dispatch('verifyReaplyConciliation', data),\n                this.confirmApplyAllotmentSuccess,\n                this.confirmApplyAllotmentError,\n                verifyReaplyConcTimeout)\n            } else {\n              this.confirmApplyAllotmentSuccess(response)\n            }\n          })\n          .catch((error) => {\n            this.confirmApplyAllotmentError(error)\n          })\n      })\n    },\n\n    // Acao tomada no sucesso da Criacao de lotes\n    confirmApplyAllotmentSuccess (response) {\n      this.disableButton = false\n      // se for reaplicacao de conciliacao\n      if (response.data.data === true) {\n        this.$root.$refs.notification.global('S', this.$t(response.data.message))\n      } else {\n        this.$root.$refs.notification.global('S', response.data.data\n          ? (this.totalDivergence === 0.00 || this.totalDivergence === '0.00')\n            ? this.$t('conciliacaoManual.sucesso.loteConciliadoOk', {id: response.data.data})\n            : this.$t('conciliacaoManual.sucesso.loteDivergenteOk', {id: response.data.data})\n          : this.$t(response.data.message))\n      }\n      this.$store.dispatch('cleanEditState')\n      this.closeModal()\n      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true)\n      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true)\n      this.$store.dispatch('dataLoaded')\n    },\n\n    // Acao tomada no erro da Criacao de lotes\n    confirmApplyAllotmentError (error = {}) {\n      this.disableButton = false\n      this.closeModal()\n      this.$store.dispatch('dataLoaded')\n      this.$root.$refs.notification.global('E', error && error.data && error.data.message\n        ? this.$t(error.data.message)\n          : error && error.message\n          ? this.$t(error.message)\n        : this.$t('GENERAL'))\n    },\n\n    // Justificativa\n    confirmJustify () {\n      let reaplicarConciliacao = this.$store.getters.isReaplyConciliation\n      let data = {\n        idsMovFinanceira: this.generateArrayWithIds(this.finMovAdded),\n        idsMovBancaria: this.generateArrayWithIds(this.bankStatAdded),\n        idsPlanosConciliacao: this.$store.getters.arrayConciliationPlan,\n        valorDivergencia: this.totalDivergence,\n        idsMotivosOcorrencia: this.generateArrayIdsOcurrence(this.arrayJustify),\n        justificativas: this.arrayJustify,\n        dataBase: new Date(),\n        reaplicarConciliacao: reaplicarConciliacao\n      }\n      this.$store.dispatch('loadingData').then(() => {\n        this.disableButton = true\n        this.$store.dispatch('justifyConciliation', data)\n          .then((response) => {\n            if (reaplicarConciliacao) {\n              // Alterando mensagem do loading\n              this.$store.dispatch('setLoadingMessage', 'conciliacaoManual.labels.conciliacaoAutomatica')\n              this.$store.dispatch('reaplyConciliation', data)\n                .catch((error) => {\n                  this.confirmJustifyError(error)\n                })\n              // Verificando situacao da conciliacao\n              verifyReaplyConcByTimeAsync(\n                () => this.$store.dispatch('verifyReaplyConciliation', data),\n                this.confirmJustifySuccess,\n                this.confirmJustifyError,\n                verifyReaplyConcTimeout)\n            } else {\n              this.confirmJustifySuccess(response)\n            }\n          })\n          .catch((error) => {\n            this.confirmJustifyError(error)\n          })\n      })\n    },\n\n    // Acao tomada no sucesso da Justificativa\n    confirmJustifySuccess (response) {\n      this.disableButton = false\n      this.$store.dispatch('cleanEditState')\n      this.closeModal()\n\n      this.$root.$refs.notification.global('S', response.data.data\n        ? this.$t(response.data.message, {id: response.data.data}) : this.$t(response.data.message))\n      this.$store.dispatch('hasToUpdateMAnualConcilSearch', true)\n      this.$store.dispatch('setNeedSearchManualConciliationTransactions', true)\n      this.$store.dispatch('', false)\n      this.$store.dispatch('dataLoaded')\n    },\n\n    // Acao tomada no erro da Justificativa\n    confirmJustifyError (error = {}) {\n      this.disableButton = false\n      this.closeModal()\n      this.$root.$refs.notification.global('E', error && error.data && error.data.message\n        ? this.$t(error.data.message)\n          : error && error.message\n          ? this.$t(error.message)\n        : this.$t('GENERAL'))\n      this.$store.dispatch('dataLoaded')\n    },\n\n    generateArrayIdsOcurrence (list) {\n      let result = []\n      list.forEach(item => {\n        result.push(item.idMotivoOcorrencia)\n      })\n      return result\n    },\n\n    closeModal () {\n      $('#applyModal').modal('hide')\n    },\n\n    calculateTotalToJustify () {\n      let value = 0.00\n      this.arrayJustify.forEach(justify => {\n        value += justify.valor\n      })\n      return value\n    },\n\n    generateArrayWithIds (list) {\n      let result = []\n      list.forEach(item => {\n        result.push(item.idMovimentacao ? item.idMovimentacao\n          : item.idMovBank ? item.idMovBank : item.id)\n      })\n      return result\n    }\n  }\n}\n</script>\n\n<style>\n.confirm-dialog-header {\n  color: red;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1117 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-f46bd904","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/filter/FiltersCommon.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.filters-common[data-v-f46bd904] {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row nowrap;\n      flex-flow: row nowrap;\n  margin-left: 10px;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 1em;\n  cursor: pointer;\n  letter-spacing: 0.01em;\n}\n", "", {"version":3,"sources":["/./client/components/dashboard/filter/FiltersCommon.vue?5154ac10"],"names":[],"mappings":";AA6BA;EACA,YAAA;EACA,qBAAA;EAAA,cAAA;EACA,0BAAA;MAAA,sBAAA;EACA,kBAAA;EACA,4CAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;CACA","file":"FiltersCommon.vue","sourcesContent":["<template src=\"./filtersCommon.pug\" lang=\"pug\"></template>\n\n<script>\nimport FilterCommon from './FilterCommon'\n\nexport default {\n  name: 'FiltersCommon',\n\n  components: {\n    FilterCommon\n  },\n\n  props: {\n    data: {\n      type: Array,\n      required: true\n    }\n  },\n\n  data () {\n    return {\n      quantity: this.data.filter(d => d.options.length > 0).length,\n      sortedData: this.data.sort((a, b) => a.order - b.order)\n    }\n  }\n}\n</script>\n\n<style scoped>\n.filters-common {\n  width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  margin-left: 10px;\n  font-family: 'Inter', sans-serif !important;\n  font-size: 1em;\n  cursor: pointer;\n  letter-spacing: 0.01em;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1118 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-f99f3a28","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/financialMovement/FinancialMovement.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n.check {\n  text-align: center;\n}\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n.col-search {\n  width: 53.5%;\n}\n.search-button {\n  min-width: 7vw;\n}\n.checkbox {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.func-group-labels {\n  color: #515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n.status-filter {\n  margin-right: 3vw;\n  min-width: 100px;\n}\n", "", {"version":3,"sources":["/./client/components/views/reports/financialMovement/FinancialMovement.vue?6d6e7631"],"names":[],"mappings":";AAsXA;EACA,mBAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;CACA;AAEA;EACA,YAAA;CACA;AAEA;EACA,gBAAA;EACA,kBAAA;CACA;AAEA;EACA,mBAAA;CACA;AAEA;EACA,WAAA;EACA,uBAAA;CACA;AAEA;EACA,aAAA;CACA;AAEA;EACA,eAAA;CACA;AAEA;EACA,gBAAA;EACA,mBAAA;CACA;AAEA;EACA,eAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,iBAAA;CACA;AAEA;EACA,kBAAA;EACA,iBAAA;CACA","file":"FinancialMovement.vue","sourcesContent":["<template src='./financialMovement.pug' lang='pug'></template>\n\n<script>\nimport GridDetailsModal from '../../../modals/gridDetailsModal/GridDetailsModal'\nimport PageTitle from '../../../layout/pageTitle/PageTitle'\nimport FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'\nimport FormSearch from '../../../form/formSearch/FormSearch'\nimport DateRange from '../../../input/dateRange/DateRange'\nimport InputEstablishment from '../../../input/inputEstablishment/InputEstablishment'\nimport TreeGrid from '../../../treeGrid/TreeGrid'\nimport { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'\nimport language from '../../../../../build/language/index'\nimport { trackAnalyticsEvent } from '../../../../utils/analytics.js'\nimport { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'\nimport { generateFinMovFromRow } from '../../../../utils/transformationData.js'\nimport closeModal from '../../../../events/closeModal'\nimport FunctionalitieIdEnum from '../../../../enum/funcionalidadeId'\n\nexport default {\n  name: 'FinancialMovement',\n\n  components: {\n    GridDetailsModal,\n    PageTitle,\n    FilterPortlet,\n    FormSearch,\n    DateRange,\n    InputEstablishment,\n    TreeGrid\n  },\n\n  data () {\n    return {\n      establishimentsUrls: {\n        establishments: 'financialMovements/establishment/list',\n        attributes: '/financialMovements/loadEstablishmentAtt'\n      },\n      selectedEstablishments: [],\n      isAdvancedSearch: true,\n      gridId: '#MovimentoFinanceiro',\n      treeGridCfg: {},\n      audit: {},\n      dateRange: {},\n      situationList: [\n        {\n          id: 'A',\n          nome: this.$t('statusConciliacao.aberto'),\n          checked: true\n        },\n        {\n          id: 'C',\n          nome: this.$t('statusConciliacao.conciliado'),\n          checked: true\n        },\n        {\n          id: 'M',\n          nome: this.$t('statusConciliacao.conciliadoManualmente'),\n          checked: true\n        },\n        {\n          id: 'D',\n          nome: this.$t('statusConciliacao.divergente'),\n          checked: true\n        },\n        {\n          id: 'N',\n          nome: this.$t('statusConciliacao.naoAplicavel'),\n          checked: true\n        }\n      ],\n      selectedStatuses: ['A', 'C', 'M', 'D', 'N'],\n      firstDate: new Date(),\n      finalDate: new Date(),\n      showTreegrid: false,\n      exportUrl: EXPORT_TREEGRID,\n      filter: {\n        entityId: null\n      },\n      result: {},\n      treeGridFileName: 'MovimentosFinanceiros',\n      dataTableColumns: [],\n      disableSearchButton: false,\n      detailsObj: {\n        establishtmentValue: {},\n        mainValuesList: [],\n        monetaryValuesList: [],\n        statusValuesList: [],\n        integrationValuesList: [],\n        idProcessamento: -1\n      },\n      finMovGridModalId: '',\n      isOpenDetailsModal: false,\n      firstTime: true,\n      titleModal: null,\n      subTitleModal: null,\n      columnsClasses: {},\n      orderBy: {},\n      headings: {},\n      templates: {},\n      customSorting: {},\n      sortable: [],\n      firstTimePlan: true,\n      firstTimeEstableshment: true,\n      modalDetailsTabs: [],\n      attList: [],\n      filterable: [],\n      columnsFilterable: [],\n      showCustomColumns: false,\n      isExportFile: false\n    }\n  },\n\n  computed: {\n    idsFilterEstablishments () {\n      return this.$store.getters.idsFilterEstablishments\n    }\n  },\n\n  watch: {\n    situationList: {\n      handler (val) {\n        this.selectedStatuses = []\n        val.forEach(st => {\n          if (st.checked) {\n            this.selectedStatuses.push(st.id)\n          }\n        })\n      },\n      deep: true\n    }\n  },\n\n  methods: {\n    resetFilter () {\n      this.selectedEstablishments = []\n      this.situationList.forEach(situation => {\n        situation.checked = true\n      })\n    },\n\n    getLoadingMessages () {\n      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']\n    },\n\n    validate () {\n      let self = this\n      let promise = null\n      return new Promise(resolve => {\n        self.$validator.validateAll().then((result) => {\n          if (result && self.$refs.dateRange.validate()) {\n            if (self.isExportFile) {\n              promise = self.download()\n            } else {\n              self.showTreegrid = true\n              startTreeGridLoading(self.gridId, self.getLoadingMessages())\n              promise = self.search()\n            }\n            promise.finally(() => {\n              resolve()\n            })\n          } else {\n            resolve()\n          }\n        })\n      })\n    },\n\n    mountFilters () {\n      this.disableSearchButton = true\n      let filter = {\n        inicio: this.dateRange.fromDate,\n        fim: this.dateRange.toDate,\n        idsPlanosConciliacao: [],\n        idsEstabelecimentos: this.selectedEstablishments.map(selected => selected.id),\n        situacoesConciliacao: this.selectedStatuses,\n        lang: language.getCookieByName('language')\n      }\n\n      return filter\n    },\n\n    download () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchFinancialMovementsToFile', { filter: this.mountFilters() })\n        .then(() => {\n          this.disableSearchButton = false\n          resolve()\n        }).catch((error) => {\n          this.error = true\n          this.msgError = error.body\n          this.$root.$refs.notification.error('GENERAL')\n          this.disableSearchButton = false\n          reject()\n        })\n      })\n    },\n\n    search () {\n      return new Promise((resolve, reject) => {\n        this.$store.dispatch('searchFinancialMovements', { filter: this.mountFilters() })\n          .then((response) => {\n            if (window.Grids[0]) {\n              window.DisposeGrids()\n            }\n            this.result = response.data\n            this.treeGridCfg = response.data.Cfg.Layout\n            window.Grids.abrirModalDetalhes = (row) => {\n              this.finMovGridModalId = 'finMovGridModalIdMov-' + row.IdMovimentacao\n              trackAnalyticsEvent(this, 'row-click', 'movimento-financeiro-grid-details', row.IdMovimentacao)\n              this.detailsObj = generateFinMovFromRow(row)\n              this.detailsObj.statusLancamento = row.SituacaoConciliacao\n              this.generateModalTabs()\n              setTimeout(() => {\n                this.showDetailsModal()\n                window.Grids[0].Disable()\n              }, 100)\n            }\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            resolve()\n          }).catch((error) => {\n            this.$root.$refs.notification.error(error)\n            stopTreeGridLoading(this.gridId)\n            this.disableSearchButton = false\n            reject()\n          })\n      })\n    },\n\n    showDetailsModal () {\n      this.isOpenDetailsModal = true\n    },\n\n    closeDetailsModal () {\n      this.isOpenDetailsModal = false\n    },\n\n    generateModalTabs () {\n      let tabs = []\n      // push tab details\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabDetails',\n        idTabContent: 'tab-details-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tadDetailsGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabDetalhes'),\n        icon: 'icon=\"tab-icon-font fa fa-info-circle',\n        type: 'TabDetails',\n        props: {\n          establishtmentValue: this.detailsObj.establishtmentValue,\n          mainValuesList: this.detailsObj.mainValuesList,\n          statusValuesList: this.detailsObj.statusValuesList,\n          monetaryValuesList: this.detailsObj.monetaryValuesList,\n          commentary: this.detailsObj.commentary\n        }\n      })\n\n      if (this.detailsObj.idProcessamento) {\n        // push tab details\n        tabs.push({\n          idFunctionalitie: null,\n          idTabRoot: 'gridDetailsModal-tabIntegrations',\n          idTabContent: 'tab-integrations-id',\n          idLanc: this.detailsObj.mainValuesList[0].value,\n          tabRef: 'tadIntegrationGridModal',\n          title: this.$t('modalDetalhesLanc.titulos.tabIntegracoes'),\n          icon: 'tab-icon-font fa fa-share-alt',\n          type: 'TabIntegrations',\n          props: {\n            loadIntegration: this.findIntegration,\n            establishtmentValue: this.detailsObj.establishtmentValue,\n            idProcessamento: this.detailsObj.idProcessamento,\n            integrationValuesList: this.detailsObj.integrationValuesList\n          }\n        })\n      }\n\n      // push tab historic\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabHistoric',\n        idTabContent: 'tab-historic-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tabHisotiricGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabHistorico'),\n        icon: 'tab-icon-font fa fa-hourglass',\n        type: 'TabHistoric',\n        props: {\n          loadHistoric: this.findFinancialMovementHistory,\n          idLancamento: this.detailsObj.mainValuesList[0].value\n        }\n      })\n\n      // push tab allotment\n      tabs.push({\n        idFunctionalitie: null,\n        idTabRoot: 'gridDetailsModal-tabAllotment',\n        idTabContent: 'tab-allotment-id',\n        idLanc: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tadAllotmentGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabLote'),\n        icon: 'tab-icon-font fa fa-cubes',\n        type: 'TabAllotment',\n        props: {\n          getAllotment: this.findFinancialMovementAllotment,\n          idMovimento: this.detailsObj.mainValuesList[0].value,\n          tipoMovimento: 'MovFin'\n        }\n      })\n\n      // push tab tasks\n      tabs.push({\n        idFunctionalitie: FunctionalitieIdEnum.TAREFAS,\n        idTabRoot: 'gridDetailsModal-tabTasks',\n        idTabContent: 'tab-tasks-id',\n        idMovimento: this.detailsObj.mainValuesList[0].value,\n        tabRef: 'tabTasksGridModal',\n        title: this.$t('modalDetalhesLanc.titulos.tabTarefas'),\n        icon: 'tab-icon-font fa fa-tasks',\n        type: 'TabTasks',\n        props: {\n          idMovimento: this.detailsObj.mainValuesList[0].value,\n          tipoMovimento: 'MovFin',\n          statusMovimento: this.detailsObj.statusLancamento\n        }\n      })\n      this.modalDetailsTabs = tabs\n    },\n\n    findFinancialMovementHistory (id) {\n      let data = {\n        idFinancialMovement: id,\n        url: '/financialMovements/history'\n      }\n      return this.$store.dispatch('getHistoricFinancialMovement', data)\n    },\n\n    findFinancialMovementAllotment (id) {\n      let data = {\n        idFinancialMovement: id,\n        url: '/financialMovements/getAllotmentByMovFinId'\n      }\n      return this.$store.dispatch('getAllotmentByMovementId', data)\n    },\n\n    findIntegration (id) {\n      let data = {\n        idProcessamento: id,\n        url: '/processedFiles/getProcessedFilesById'\n      }\n      return this.$store.dispatch('getProcessedFiles', data)\n    }\n  },\n\n  mounted () {\n    // Listener para evento de atualização de dados dentro da modal de detalhes,\n    // o que requer uma nova consulta para o relatório\n    const self = this\n    closeModal.$on('modalDetaisClose', (flag) => {\n      if (flag) {\n        self.showTreegrid = true\n        startTreeGridLoading(self.gridId, self.getLoadingMessages())\n        self.search()\n        // Altera a flag que recarrega a treegrid após o recarregamento\n        // para impedir que ela seja recarregada sempre após a primeira vez\n        closeModal.$emit('taskChange', false)\n      }\n    })\n  }\n}\n</script>\n\n<style>\n.input-button>button {\n  margin: 24px 0 0 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  height: 36px;\n  float: left;\n}\n\n#logDeAuditoriaWrapper {\n  width: 100%;\n}\n\n#divTreeGridAuditoria {\n  min-width: 100%;\n  min-height: 500px;\n}\n\n.check {\n  text-align: center;\n}\n\n.filterButton {\n  width: 3vw;\n  margin: 0px !important;\n}\n\n.col-search {\n  width: 53.5%;\n}\n\n.search-button {\n  min-width: 7vw;\n}\n\n.checkbox {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.func-group-labels {\n  color: #515151;\n  font-size: 13px !important;\n  text-transform: initial !important;\n  font-weight: normal !important;\n  padding-top: 1px;\n}\n\n.status-filter {\n  margin-right: 3vw;\n  min-width: 100px;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1119 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-fd19de7a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/loading/LoadingFullPage.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../~/css-loader/lib/css-base.js */ 7)();
// imports


// module
exports.push([module.i, "\n.isLoadingFullPage {\n  background: url(" + __webpack_require__(/*! ../../assets/loading-gif/loading.svg */ 67) + ") 50% 50% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.8;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  transition: all 5s ease-in-out;\n}\n.spanLoading {\n  color: #13556A;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 25px;\n  position: fixed;\n  top: 49%;\n  margin-top: 80px;\n  width: 100%;\n  text-align: center;\n  z-index: 1000000;\n}\n", "", {"version":3,"sources":["/./client/components/loading/LoadingFullPage.vue?1ec10412"],"names":[],"mappings":";AAoDA;EACA,4DAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EAKA,+BAAA;CACA;AAEA;EACA,eAAA;EACA,iCAAA;AACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;CACA","file":"LoadingFullPage.vue","sourcesContent":["<template lang=\"pug\">\n  div\n    .isLoadingFullPage\n    span.spanLoading(v-if='!!message' v-html='message')\n</template>\n\n<script>\nexport default {\n  name: 'LoadingFullPage',\n\n  data () {\n    return {\n      message: '',\n      interval: null\n    }\n  },\n\n  computed: {\n    loadingFullPageMessages () {\n      return this.$store.getters.loadingFullPageMessages\n    },\n\n    intervalBetweenMessages () {\n      return this.$store.getters.intervalBetweenMessages\n    }\n  },\n\n  created () {\n    let counter = 1\n    const intervalBetweenMessages = this.intervalBetweenMessages\n    const messages = this.loadingFullPageMessages\n    const length = messages.length\n    if (length === 0) {\n      return\n    }\n\n    const translatedMessages = messages.map(this.$t)\n    this.message = translatedMessages[0]\n    this.interval = setInterval(() => {\n      this.message = translatedMessages[counter % length]\n      ++counter\n    }, intervalBetweenMessages)\n  },\n\n  beforeDestroy () {\n    this.message = ''\n    clearInterval(this.interval)\n  }\n}\n</script>\n\n<style>\n.isLoadingFullPage {\n  background: url(../../assets/loading-gif/loading.svg) 50% 50% no-repeat;\n  background-color: #EEE;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99999;\n  opacity: 0.8;\n  overflow-y: hidden;\n  cursor: wait;\n  background-size: 150px;\n  -webkit-transition: all 5s ease-in-out;\n  -moz-transition: all 5s ease-in-out;\n  -ms-transition: all 5s ease-in-out;\n  -o-transition: all 5s ease-in-out;\n  transition: all 5s ease-in-out;\n}\n\n.spanLoading {\n  color: #13556A;\n  font-family: 'Inter', sans-serif;\nfont-weight: 700;\n  font-size: 25px;\n  position: fixed;\n  top: 49%;\n  margin-top: 80px;\n  width: 100%;\n  text-align: center;\n  z-index: 1000000;\n}\n</style>\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 1120 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/dayspan-vuetify/dist/lib/dayspan-vuetify.min.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(/*! dayspan */ 489),__webpack_require__(/*! vue */ 31)):"function"==typeof define&&define.amd?define(["dayspan","vue"],t):"object"==typeof exports?exports["dayspan-vuetify"]=t(require("dayspan"),require("vue")):e["dayspan-vuetify"]=t(e.dayspan,e.vue)}(this,function(e,t){return function(e){function t(a){if(n[a])return n[a].exports;var s=n[a]={i:a,l:!1,exports:{}};return e[a].call(s.exports,s,s.exports,t),s.l=!0,s.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,a){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:a})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=56)}([function(e,t){e.exports=__webpack_require__(/*! dayspan */ 489)},function(e,t){e.exports=function(e,t,n,a,s){var i,r=e=e||{},l=typeof e.default;"object"!==l&&"function"!==l||(i=e,r=e.default);var o="function"==typeof r?r.options:r;t&&(o.render=t.render,o.staticRenderFns=t.staticRenderFns),a&&(o._scopeId=a);var d;if(s?(d=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),n&&n.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(s)},o._ssrRegister=d):n&&(d=n),d){var c=o.functional,u=c?o.render:o.beforeCreate;c?o.render=function(e,t){return d.call(t),u(e,t)}:o.beforeCreate=u?[].concat(u,d):[d]}return{esModule:i,exports:r,options:o}}},function(e,t,n){"use strict";var a=n(0);n.n(a);t.a={props:{schedule:{required:!0,type:a.Schedule}},computed:{frequency:{get:function(){return this.property?this.schedule[this.property].input:null},set:function(e){this.property&&this.schedule.setFrequency(this.property,e)}},type:{get:function(){return this.getFrequencyType(this.frequency)},set:function(e){var t=this;this.$dayspan.getPermission("changeExistingType",function(){t.setFrequencyType(e)})}},isAny:function(){return"any"===this.type},isOneOf:function(){return"oneof"===this.type},isEvery:function(){return"every"===this.type}},watch:{property:"onPropertyChange"},methods:{getCustomFrequencyType:function(e){},setCustomFrequencyType:function(e){},getFrequencyType:function(e){var t=this.getCustomFrequencyType(e);return t||(e?a.Functions.isArray(e)?"oneof":a.Functions.isFrequencyValueEvery(e)?"every":"unknown":"any")},setFrequencyType:function(e){switch(e){case"any":this.frequency=null;break;case"oneof":a.Functions.isArray(this.frequency)||(this.frequency=[]);break;case"every":a.Functions.isFrequencyValueEvery(this.frequency)||(this.frequency={every:2});break;default:this.setCustomFrequencyType(e)}},onPropertyChange:function(e,t){var n=[];if(t){var a=this.schedule[t].input;a&&(n=a),this.schedule.setFrequency(t,null)}this.schedule.setFrequency(e,n)},getOffsets:function(e,t,n,a){for(var s=[],i=n||0,r=a||0,l=i;l<e;l++)s.push({text:t[l],value:l+r});return s},findType:function(e){for(var t=0;t<e.length;t++){var n=e[t];if(this.schedule[n.property].input)return n}return e[0]}}}},function(e,t,n){e.exports=!n(8)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(132),s=n.n(a);n.d(t,"DsGestures",function(){return s.a});var i=n(125),r=n.n(i);n.d(t,"DsDay",function(){return r.a});var l=n(127),o=n.n(l);n.d(t,"DsDayRow",function(){return o.a});var d=n(129),c=n.n(d);n.d(t,"DsDaysView",function(){return c.a});var u=n(128),h=n.n(u);n.d(t,"DsDayTimes",function(){return h.a});var v=n(126),f=n.n(v);n.d(t,"DsDayPicker",function(){return f.a});var p=n(113),y=n.n(p);n.d(t,"DsAgenda",function(){return y.a});var m=n(114),_=n.n(m);n.d(t,"DsAgendaDay",function(){return _.a});var g=n(115),b=n.n(g);n.d(t,"DsAgendaEvent",function(){return b.a});var D=n(116),x=n.n(D);n.d(t,"DsCalendar",function(){return x.a});var $=n(117),E=n.n($);n.d(t,"DsCalendarApp",function(){return E.a});var C=n(118),w=n.n(C);n.d(t,"DsCalendarEvent",function(){return w.a});var k=n(123),S=n.n(k);n.d(t,"DsCalendarEventTime",function(){return S.a});var P=n(119),T=n.n(P);n.d(t,"DsCalendarEventChip",function(){return T.a});var O=n(122),M=n.n(O);n.d(t,"DsCalendarEventPopover",function(){return M.a});var F=n(121),A=n.n(F);n.d(t,"DsCalendarEventPlaceholder",function(){return A.a});var q=n(120),R=n.n(q);n.d(t,"DsCalendarEventCreatePopover",function(){return R.a});var B=n(124),L=n.n(B);n.d(t,"DsCalendarEventTimePlaceholder",function(){return L.a});var W=n(130),V=n.n(W);n.d(t,"DsEvent",function(){return V.a});var I=n(131),H=n.n(I);n.d(t,"DsEventDialog",function(){return H.a});var j=n(134),U=n.n(j);n.d(t,"DsSchedule",function(){return U.a});var Y=n(143),N=n.n(Y);n.d(t,"DsScheduleSpan",function(){return N.a});var z=n(146),G=n.n(z);n.d(t,"DsScheduleType",function(){return G.a});var X=n(144),K=n.n(X);n.d(t,"DsScheduleTime",function(){return K.a});var Q=n(145),J=n.n(Q);n.d(t,"DsScheduleTimes",function(){return J.a});var Z=n(135),ee=n.n(Z);n.d(t,"DsScheduleActions",function(){return ee.a});var te=n(136),ne=n.n(te);n.d(t,"DsScheduleForecast",function(){return ne.a});var ae=n(142),se=n.n(ae);n.d(t,"DsScheduleModifier",function(){return se.a});var ie=n(147),re=n.n(ie);n.d(t,"DsScheduleTypeCustom",function(){return re.a});var le=n(148),oe=n.n(le);n.d(t,"DsScheduleTypeCustomDialog",function(){return oe.a});var de=n(2);n.d(t,"DsScheduleFrequency",function(){return de.a});var ce=n(137),ue=n.n(ce);n.d(t,"DsScheduleFrequencyDay",function(){return ue.a});var he=n(140),ve=n.n(he);n.d(t,"DsScheduleFrequencyWeek",function(){return ve.a});var fe=n(141),pe=n.n(fe);n.d(t,"DsScheduleFrequencyYear",function(){return pe.a});var ye=n(139),me=n.n(ye);n.d(t,"DsScheduleFrequencyMonth",function(){return me.a});var _e=n(138),ge=n.n(_e);n.d(t,"DsScheduleFrequencyDayOfWeek",function(){return ge.a});var be=n(151),De=n.n(be);n.d(t,"DsWeeksView",function(){return De.a});var xe=n(150),$e=n.n(xe);n.d(t,"DsWeekHeader",function(){return $e.a});var Ee=n(149),Ce=n.n(Ee);n.d(t,"DsWeekDayHeader",function(){return Ce.a});var we=n(133),ke=n.n(we);n.d(t,"DsIdentifierChip",function(){return ke.a})},function(e,t,n){"use strict";function a(e,t){if(!c.Functions.isObject(e))return t;if(c.Functions.isObject(t))for(var n in t){var s=t[n];n in e?a(e[n],s):e[n]=s}return e}function s(e,t){var n={data:{},methods:{},computed:{}};return i(e,t.data,n,n.data),i(e,t.computed,n,n.computed),i(e,t.methods,n,n.methods),n}function i(e,t,n,s){for(var i in t)e.data&&i in e.data?(n.data[i]=e.data[i],a(n.data[i],t[i])):e.computed&&i in e.computed?(n.computed[i]=e.computed[i],a(n.computed[i],t[i])):e.methods&&i in e.methods?(n.methods[i]=e.methods[i],a(n.methods[i],t[i])):s[i]=t[i]}function r(e,t){return a(e,t)!==t}function l(){return this.$dayspan.defaults[this.$options.name]}function o(e){return function(t,n,a,s,i){return a&&a.$scopedSlots&&(t.scopedSlots=a.$scopedSlots,delete a.$scopedSlots),e.apply(this,arguments)}}function d(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"",a=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(c.Functions.isArray(t)&&c.Functions.isArray(e)&&t.length===e.length)for(var s=0;s<t.length;s++){var i=t[s];c.Functions.isObject(i)||c.Functions.isArray(i)?d(e[s],i,n+"["+s+"]",a):e[s]=i}else if(c.Functions.isObject(t)&&c.Functions.isObject(e))for(var r in t){var l=t[r];c.Functions.isObject(l)||c.Functions.isArray(l)?d(e[r],l,n+"."+r,a):e[r]=l}else if(a)throw"Incompatible locale data at "+n}t.f=a,t.a=s,t.b=r,t.c=l,t.d=o,t.e=d;var c=n(0);n.n(c)},function(e,t){var n=e.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){var a=n(64),s=n(70),i=n(72),r=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(a(e),t=i(t,!0),a(n),s)try{return r(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){"use strict";var a=n(6),s=n(53),i=n(5);t.a={install:function(e,t){for(var r in i)e.component(r,i[r]);var l=new e(t?n.i(a.a)(t,s.a):s.a);e.$dayspan=l,e.prototype.$dayspan=l,e.prototype.$dsValidate=a.b,e.prototype.$dsDefaults=a.c,e.prototype._b=n.i(a.d)(e.prototype._b),l.init()}}},function(e,t){},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsAgenda",props:{calendar:{required:!0,type:a.Calendar},readOnly:{type:Boolean,default:!1}},data:function(e){return{placeholder:null,placeholderForCreate:!1}},computed:{eventDays:function(){return this.calendar.days.filter(this.hasEvents)}},methods:{hasEvents:function(e){return e.events.length>0}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsAgendaDay",props:{day:{required:!0,type:a.CalendarDay},calendar:{required:!0,type:a.Calendar},readOnly:{type:Boolean,default:!1},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1}},computed:{classes:function(){return{"ds-day-today":this.day.currentDay,"ds-day-past":this.day.currentOffset<0,"ds-day-future":this.day.currentOffset>0,"ds-first-day-day":1===this.day.dayOfMonth,"ds-out-calendar":!this.day.inCalendar}},hasPlaceholder:function(){return this.placeholder&&this.placeholder.time.matchesDay(this.day)},visibleEvents:function(){return this.day.events.filter(this.isVisible)}},methods:{isVisible:function(e){return!this.$dayspan.features.hideOnMove||!this.placeholder||this.placeholder.event!==e.event},add:function(){this.$emit("add",this.day)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsAgendaEvent",props:{calendarEvent:{required:!0,type:a.CalendarEvent},calendar:{required:!0,type:a.Calendar},readOnly:{type:Boolean,default:!1},first:{type:Boolean,default:!1},siblings:{type:Number,default:1},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},popoverProps:{validate:function(e){return this.$dsValidate(e,"popoverProps")},default:function(){return this.$dsDefaults().popoverProps}}},computed:{slotData:function(){return{readOnly:this.readOnly,calendarEvent:this.calendarEvent,calendar:this.calendar,details:this.details,first:this.first,siblings:this.siblings,firstLine:this.firstLine,secondLine:this.secondLine,when:this.when,viewDay:this.viewDay,edit:this.edit,editCheck:this.editCheck}},contentClass:function(){return this.$dayspan.fullscreenPopovers?"ds-fullscreen":""},hasPopover:function(){return!!this.$scopedSlots.eventPopover},classes:function(){return{"ds-first-event":this.first}},details:function(){return this.calendarEvent.event.data},firstLine:function(){return this.calendarEvent.day.format(this.formats.firstLine)},secondLine:function(){return this.calendarEvent.day.format(this.formats.secondLine)},when:function(){return this.$dayspan.getEventAgendaWhen(this.calendarEvent,this.labels,this.formats)}},data:function(e){return{menu:!1}},methods:{close:function(){this.menu=!1},edit:function(){this.$emit("edit",this.calendarEvent)},editCheck:function(e){this.hasPopover?this.menu=!this.menu:this.edit()},viewDay:function(){this.$emit("view-day",this.calendarEvent.day)},getEvent:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return a.Functions.extend({type:e,calendarEvent:this.calendarEvent,calendar:this.calendar,details:this.details,left:0===t.button,right:1===t.button,handled:!1,$event:t,$vm:this,$element:this.$el},n)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendar",props:{calendar:{type:a.Calendar},handleAdd:{type:Boolean,default:function(){return this.$dsDefaults().handleAdd}},handleMove:{type:Boolean,default:function(){return this.$dsDefaults().handleMove}},readOnly:{type:Boolean,default:!1}},data:function(e){return{placeholder:null,placeholderForCreate:!1,addStart:null}},watch:{"$dayspan.today":"refreshCurrent"},computed:{type:function(){return this.calendar?this.calendar.type:null},size:function(){return this.calendar?this.calendar.size:null},isDay:function(){return this.type===a.Units.DAY},isWeek:function(){return this.type===a.Units.WEEK},isMonth:function(){return this.type===a.Units.MONTH},isYear:function(){return this.type===a.Units.YEAR},adding:function(){return!(!this.addStart||!this.placeholder)},canAdd:function(){return this.$dayspan.features.drag&&this.handleAdd&&!this.readOnly&&!this.$dayspan.readOnly},canMove:function(){return this.$dayspan.features.move&&this.handleMove&&!this.readOnly&&!this.$dayspan.readOnly}},methods:{refreshCurrent:function(){this.calendar.refreshCurrent(this.$dayspan.today)},mouseDown:function(e){if(this.canAdd&&e.left){var t=e.time,n=this.getEvent("adding",{mouseEvent:e,placeholder:this.$dayspan.getPlaceholderEventForAdd(t)});this.$emit("adding",n),!n.handled&&n.placeholder&&(this.addStart=t,this.placeholderForCreate=!1,this.placeholder=n.placeholder,this.placeholder.event.schedule=a.Schedule.forTime(t,t.asTime()),this.placeholder.fullDay=!1)}},mouseDownDay:function(e){if(this.canAdd&&e.left){var t=e.day,n=this.getEvent("adding",{mouseEvent:e,placeholder:this.$dayspan.getPlaceholderEventForAdd(t)});this.$emit("adding",n),!n.handled&&n.placeholder&&(this.addStart=t,this.placeholderForCreate=!1,this.placeholder=n.placeholder,this.placeholder.event.schedule=a.Schedule.forDay(t),this.placeholder.fullDay=!0)}},mouseUp:function(e){this.addEnd&&this.finishAdd(e),this.moving&&this.finishMove(e),this.readyToMove=!1},finishAdd:function(e){var t=this.getEvent("added",{mouseEvent:e,placeholder:this.placeholder,span:this.placeholder.time});this.$emit("added",t),t.handled||t.clearPlaceholder(),this.endAdd()},finishMove:function(e){var t=this.placeholder.time,n=this.movingEvent.calendarEvent.time,a=t.start.sameMinute(n.start),s=t.start.sameDay(n.start),i="mouse-up-day"===e.type;if(i&&!s||!i&&!a){var r=this.getEvent("moved",{mouseEvent:e,movingEvent:this.movingEvent,calendarEvent:this.movingEvent.calendarEvent,target:this.placeholder.time});this.$emit("moved",r),r.handled||r.clearPlaceholder()}else this.clearPlaceholder();this.endMove()},mouseMoveDay:function(e){if(this.adding&&e.left){this.addEnd=e.day;var t=this.addStart.min(this.addEnd),n=this.addStart.max(this.addEnd);this.placeholder.day=t.start(),this.placeholder.time.start=t,this.placeholder.time.end=n.end(),this.placeholder.event.schedule=a.Schedule.forDay(this.placeholder.start,this.placeholder.time.days(a.Op.UP)),this.updatePlaceholderRow(this.placeholder)}if(this.mouseMoveCheckReady(),this.moving){var s=e.day;this.placeholder.day=s,this.placeholder.time.start=s,this.placeholder.time.end=s.next(this.placeholder.schedule.durationInDays).end(),this.updatePlaceholderRow(this.placeholder)}this.mouseMoveCheckEnd(e)},mouseMove:function(e){if(this.adding&&e.left){this.addEnd=e.timeDrag;var t=this.addStart.min(this.addEnd),n=this.addStart.max(this.addEnd);this.placeholder.day=t.start(),this.placeholder.time.start=t,this.placeholder.time.end=n,this.placeholder.event.schedule=a.Schedule.forSpan(this.placeholder.time)}if(this.mouseMoveCheckReady(),this.moving){var s=e.time;s=s.relative(-this.movingEvent.offset),s=this.$dayspan.roundTime(s,this.$dayspan.rounding.drag),this.placeholder.day=s.start(),this.placeholder.time.start=s,this.placeholder.time.end=s.relative(this.movingDuration)}this.mouseMoveCheckEnd(e)},mouseMoveCheckEnd:function(e){!this.moving||e.left||this.placeholderForCreate||(this.endMove(),this.clearPlaceholder()),!this.adding||e.left||this.placeholderForCreate||(this.endAdd(),this.clearPlaceholder())},mouseDownEvent:function(e){this.canMove&&e.left&&(this.readyToMove=!0,this.movingEvent=e)},mouseMoveCheckReady:function(){if(this.readyToMove){var e=this.movingEvent,t=e.calendarEvent,n=this.getEvent("moving",{calendarEvent:t,moveEvent:e,placeholder:this.$dayspan.getPlaceholderEventForMove(t)});this.$emit("moving",n),!n.handled&&n.placeholder&&(this.moving=!0,this.movingDuration=t.time.millis(),this.placeholderForCreate=!1,this.placeholder=n.placeholder),this.readyToMove=!1}},endMove:function(){this.moving=!1,this.movingEvent=null},endAdd:function(){this.addStart=null,this.addEnd=null},updatePlaceholderRow:function(e){var t=0;this.calendar.iterateDays().iterate(function(n){e.time.matchesDay(n)&&(t=n.iterateEvents().reduce(t,function(e,t){return Math.max(e.row+1,t)},function(t){return t.event!==e.event}))}),e.row=t},addPlaceholder:function(e,t,n){var s=this.$dayspan.getPlaceholderEventForAdd(e),i=s.time;t?(i.end=i.end.end(),s.event.schedule=a.Schedule.forDay(i.start),s.fullDay=!0):(i.end=i.end.nextHour(),s.event.schedule=a.Schedule.forSpan(i),s.fullDay=!1),this.updatePlaceholderRow(s),this.placeholder=s,this.placeholderForCreate=!n},clearPlaceholder:function(){this.placeholder=null,this.placeholderForCreate=!1},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,calendar:this.calendar,clearPlaceholder:this.clearPlaceholder,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendarApp",props:{events:{type:Array},calendar:{type:a.Calendar,default:function(){return a.Calendar.months()}},readOnly:{type:Boolean,default:!1},types:{type:Array,default:function(){return this.$dsDefaults().types}},allowsAddToday:{type:Boolean,default:function(){return this.$dsDefaults().allowsAddToday}},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},styles:{validate:function(e){return this.$dsValidate(e,"styles")},default:function(){return this.$dsDefaults().styles}},optionsDialog:{validate:function(e){return this.$dsValidate(e,"optionsDialog")},default:function(){return this.$dsDefaults().optionsDialog}},promptDialog:{validate:function(e){return this.$dsValidate(e,"promptDialog")},default:function(){return this.$dsDefaults().promptDialog}}},data:function(e){return{drawer:null,optionsVisible:!1,options:[],promptVisible:!1,promptQuestion:"",promptCallback:null}},watch:{events:"applyEvents",calendar:"applyEvents"},computed:{currentType:{get:function(){var e=this;return this.types.find(function(t){return t.type===e.calendar.type&&t.size===e.calendar.size})||this.types[0]},set:function(e){this.rebuild(void 0,!0,e)}},summary:function(){if(this.$vuetify.breakpoint.xs)return this.calendar.start.format(this.formats.xs);var e=this.$vuetify.breakpoint.mdAndUp;return this.calendar.summary(!1,!e,!1,!e)},todayDate:function(){return this.$dayspan.today.format(this.formats.today)},nextLabel:function(){return this.labels.next(this.currentType)},prevLabel:function(){return this.labels.prev(this.currentType)},toolbarStyle:function(){return this.$vuetify.breakpoint.lgAndUp?this.styles.toolbar.large:this.styles.toolbar.small},hasCreatePopover:function(){return!!this.$scopedSlots.eventCreatePopover},canAddDay:function(){return this.$dayspan.features.addDay&&!this.readOnly&&!this.$dayspan.readOnly},canAddTime:function(){return this.$dayspan.features.addTime&&!this.readOnly&&!this.$dayspan.readOnly}},mounted:function(){var e=this;this.$dayspan.promptOpen||(this.$dayspan.promptOpen=function(t,n){e.promptVisible=!1,e.promptQuestion=t,e.promptCallback=n,e.promptVisible=!0})},methods:{setState:function(e){e.eventSorter=e.listTimes?a.Sorts.List([a.Sorts.FullDay,a.Sorts.Start]):a.Sorts.Start,this.calendar.set(e),this.triggerChange()},applyEvents:function(){this.events&&(this.calendar.removeEvents(),this.calendar.addEvents(this.events))},isType:function(e,t){var n=this.calendar;return n.type===e.type&&n.size===e.size&&(!t||n.span.matchesDay(t))},rebuild:function(e,t,n){var a=n||this.currentType||this.types[2];if(!this.isType(a,e)||t){var s={type:a.type,size:a.size,around:e,eventsOutside:!0,preferToday:!1,listTimes:a.listTimes,updateRows:a.updateRows,updateColumns:a.listTimes,fill:!a.listTimes,otherwiseFocus:a.focus,repeatCovers:a.repeat};this.setState(s)}},next:function(){this.calendar.unselect().next(),this.triggerChange()},prev:function(){this.calendar.unselect().prev(),this.triggerChange()},setToday:function(){this.rebuild(this.$dayspan.today)},viewDay:function(e){this.rebuild(e,!1,this.types[0])},edit:function(e){this.$refs.eventDialog.edit(e)},editPlaceholder:function(e){var t=e.calendarEvent,n=e.details,a=this.$refs.eventDialog,s=this.$refs.calendar;a.addPlaceholder(t,n),a.$once("close",s.clearPlaceholder)},add:function(e){if(this.canAddDay){var t=this.$refs.eventDialog,n=this.$refs.calendar,a=!this.hasCreatePopover;n.addPlaceholder(e,!0,a),a&&(t.add(e),t.$once("close",n.clearPlaceholder))}},addAt:function(e){if(this.canAddTime){var t=this.$refs.eventDialog,n=this.$refs.calendar,a=!this.hasCreatePopover,s=e.day.withHour(e.hour);n.addPlaceholder(s,!1,a),a&&(t.addAt(e.day,e.hour),t.$once("close",n.clearPlaceholder))}},addToday:function(){if(this.canAddDay){var e=this.$refs.eventDialog,t=this.$refs.calendar,n=!this.hasCreatePopover||!t,a=this.$dayspan.today;if(!this.calendar.filled.matchesDay(a)){var s=this.calendar.days[0],i=this.calendar.days[this.calendar.days.length-1];a=Math.abs(s.currentOffset)<Math.abs(i.currentOffset)?s:i}t&&t.addPlaceholder(a,!0,n),n&&(e.add(a),t&&e.$once("close",t.clearPlaceholder))}},handleAdd:function(e){var t=this.$refs.eventDialog,n=this.$refs.calendar;e.handled=!0,this.hasCreatePopover?n.placeholderForCreate=!0:(e.placeholder.fullDay?t.add(e.span.start,e.span.days(a.Op.UP)):t.addSpan(e.span),t.$once("close",e.clearPlaceholder))},handleMove:function(e){var t=this,n=e.calendarEvent,a=e.target,s=a.start,i=n.time.start,r=n.schedule,l=[];e.handled=!0;var o={cancel:function(){e.clearPlaceholder()},single:function(){n.move(s),t.eventsRefresh(),e.clearPlaceholder(),t.$emit("event-update",n.event)},instance:function(){n.move(s),t.eventsRefresh(),e.clearPlaceholder(),t.$emit("event-update",n.event)},duplicate:function(){r.setExcluded(s,!1),t.eventsRefresh(),e.clearPlaceholder(),t.$emit("event-update",n.event)},all:function(){r.moveTime(i.asTime(),s.asTime()),t.eventsRefresh(),e.clearPlaceholder(),t.$emit("event-update",n.event)}};l.push({text:this.labels.moveCancel,callback:o.cancel}),r.isSingleEvent()?(l.push({text:this.labels.moveSingleEvent,callback:o.single}),this.$dayspan.features.moveDuplicate&&l.push({text:this.labels.moveDuplicate,callback:o.duplicate})):(this.$dayspan.features.moveInstance&&l.push({text:this.labels.moveOccurrence,callback:o.instance}),this.$dayspan.features.moveDuplicate&&l.push({text:this.labels.moveDuplicate,callback:o.duplicate}),this.$dayspan.features.moveAll&&!r.isFullDay()&&s.sameDay(i)&&l.push({text:this.labels.moveAll,callback:o.all})),this.options=l,this.optionsVisible=!0},chooseOption:function(e){e&&e.callback(),this.optionsVisible=!1},choosePrompt:function(e){this.promptCallback(e),this.promptVisible=!1},eventFinish:function(e){this.triggerChange()},eventsRefresh:function(){this.calendar.refreshEvents(),this.triggerChange()},triggerChange:function(){this.$emit("change",{calendar:this.calendar})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendarEvent",props:{calendarEvent:{required:!0,type:a.CalendarEvent},calendar:{required:!0,type:a.Calendar},index:{type:Number,default:function(){return this.$dsDefaults().index}},popoverProps:{validate:function(e){return this.$dsValidate(e,"popoverProps")},default:function(){return this.$dsDefaults().popoverProps}},isPlaceholderWithDay:{type:a.Day}},computed:{style:function(){return this.isPlaceholderWithDay?this.$dayspan.getStylePlaceholderFull(this.details,this.calendarEvent,this.index,this.isPlaceholderWithDay):this.$dayspan.getStyleFull(this.details,this.calendarEvent,this.index)},contentClass:function(){return this.$dayspan.fullscreenPopovers?"ds-fullscreen":""},sameDayEvents:function(){return this.calendarEvent.event.schedule.iterateSpans(this.calendarEvent.day,!0).list()},hasPrefix:function(){return!this.calendarEvent.fullDay&&this.sameDayEvents.length>0},hasIcon:function(){return!(!this.$dayspan.supports.icon||!this.details.icon)},getPrefix:function(){return this.$dayspan.getPrefix(this.calendarEvent,this.sameDayEvents)},showName:function(){return this.isPlaceholderWithDay?this.isPlaceholderWithDay.sameDay(this.calendarEvent.start):this.calendarEvent.starting||this.calendar&&!this.calendar.filled.contains(this.calendarEvent.time.start)&&this.calendar.filled.start.sameDay(this.calendarEvent.day)},hasPopover:function(){return!!this.$scopedSlots.eventPopover},details:function(){return this.calendarEvent.event.data}},data:function(e){return{menu:!1}},methods:{close:function(){this.menu=!1},edit:function(){this.handlesEvents()&&this.$emit("edit",this.calendarEvent)},editCheck:function(e){this.handlesEvents(e)&&(this.hasPopover?this.menu=!this.menu:this.edit())},mouseEnterEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-enter-event",this.getEvent("mouse-enter-event",e))},mouseLeaveEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-leave-event",this.getEvent("mouse-leave-event",e))},mouseDownEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-down-event",this.getEvent("mouse-down-event",e))},mouseUpEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-up-event",this.getEvent("mouse-up-event",e))},handlesEvents:function(e){var t=!this.isPlaceholderWithDay;return t&&e&&e.stopPropagation(),t},getEvent:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return a.Functions.extend({type:e,calendarEvent:this.calendarEvent,calendar:this.calendar,details:this.details,left:0===t.button,right:1===t.button,handled:!1,$event:t,$vm:this,$element:this.$el},n)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendarEventChip",props:{time:{required:!0,type:a.Day},day:{type:a.Day},canExclude:{type:Boolean,default:function(){return this.$dsDefaults().canExclude}},colors:{validate:function(e){return this.$dsValidate(e,"colors")},default:function(){return this.$dsDefaults().colors}},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}}},computed:{aroundDay:function(){return this.day||this.$dayspan.today},same:function(){return this.aroundDay.sameDay(this.time)},background:function(){return this.same?this.colors.sameBackground:""},foreground:function(){return this.same?this.colors.sameForeground:""},text:function(){return this.time.format(this.formats.fullDay)}},methods:{exclude:function(){this.$emit("exclude",this.time)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(61),s=n.n(a),i=n(0);n.n(i);t.default={name:"dsCalendarEventCreatePopover",props:{calendarEvent:{required:!0,type:i.CalendarEvent},calendar:{required:!0,type:i.Calendar},close:{type:Function},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}},icons:{validate:function(e){return this.$dsValidate(e,"icons")},default:function(){return this.$dsDefaults().icons}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},prompts:{validate:function(e){return this.$dsValidate(e,"prompts")},default:function(){return this.$dsDefaults().prompts}},busyOptions:{type:Array,default:function(){return this.$dsDefaults().busyOptions}}},computed:{slotData:function(){return{calendarEvent:this.calendarEvent,calendar:this.calendar,close:this.close,details:this.details}},classes:function(){return{"ds-event-cancelled":this.calendarEvent.cancelled}},styleHeader:function(){return{backgroundColor:this.details.color,color:this.details.forecolor}},styleText:function(){return{color:this.details.forecolor}},startDate:function(){return this.calendarEvent.start.format(this.formats.start)},busyness:function(){return this.details.busy?this.labels.busy:this.labels.free},isValid:function(){return this.$dayspan.isValidEvent(this.details,this.calendarEvent.schedule,this.calendarEvent)},occurs:function(){return this.$dayspan.getEventOccurrence(this.calendarEvent.schedule,this.calendarEvent.start,this.labels,this.formats)}},data:function(e){return{details:e.buildDetails()}},methods:{edit:function(){var e=this.getEvent("create-edit");this.$emit("create-edit",e),this.finishEvent(e)},save:function(){var e=this.getEvent("creating");this.$emit("creating",e),!e.handled&&e.details&&e.calendarEvent&&(e.created=e.calendarEvent.event,this.$dayspan.setEventDetails(e.details,e.created.data,e.created,e.calendarEvent),e.calendar&&(e.calendar.addEvent(e.created),e.added=!0),this.$emit("created",e),e.calendar&&e.refresh&&e.calendar.refreshEvents(),e.handled=!0,this.$emit("event-create",e.created)),this.finishEvent(e)},finishEvent:function(e){e.close&&(this.close(),this.$emit("create-popover-closed",e))},buildDetails:function(){var e=this.$dayspan.copyEventDetails(this.calendarEvent.event.data);return e.title="",e},getEvent:function(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return i.Functions.extend((t={type:e,calendarEvent:this.calendarEvent,calendar:this.calendar,close:this.close,details:this.details,handled:!1,added:!1,refresh:!0},s()(t,"close",!0),s()(t,"$vm",this),s()(t,"$element",this.$el),t),n)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendarEventPlaceholder",props:{placeholder:{required:!0,type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1},calendar:{required:!0,type:a.Calendar},day:{type:a.Day},index:{type:Number,default:0},popoverProps:{validate:function(e){return this.$dsValidate(e,"popoverProps")},default:function(){return this.$dsDefaults().popoverProps}}},computed:{hasPopover:function(){return!!this.$scopedSlots.eventCreatePopover},contentClass:function(){return this.$dayspan.fullscreenPopovers?"ds-fullscreen":""},isStart:function(){return this.placeholder.day.sameDay(this.day)},autoOpen:function(){return this.hasPopover&&this.placeholderForCreate&&this.isStart}},data:function(e){return{menu:!1}},watch:{menu:"triggerClearPlaceholder",placeholderForCreate:"openPopover"},mounted:function(){this.autoOpen&&(this.menu=!0)},methods:{close:function(){this.menu=!1},openPopover:function(e){this.isStart&&(this.menu=e)},triggerClearPlaceholder:function(e){e||this.$emit("clear-placeholder")}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendarEventPopover",props:{calendarEvent:{required:!0,type:a.CalendarEvent},calendar:{required:!0,type:a.Calendar},readOnly:{type:Boolean,default:!1},edit:{type:Function},allowEditOnReadOnly:{type:Boolean,default:function(){return this.$dsDefaults().allowEditOnReadOnly}},close:{type:Function},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},computed:{slotData:function(){return{calendarEvent:this.calendarEvent,calendar:this.calendar,edit:this.edit,close:this.close,details:this.details,readOnly:this.readOnly}},classes:function(){return{"ds-event-cancelled":this.calendarEvent.cancelled}},styleHeader:function(){return{backgroundColor:this.details.color,color:this.details.forecolor}},styleButton:function(){return{color:this.details.forecolor}},startDate:function(){return this.calendarEvent.start.format(this.formats.start)},busyness:function(){return this.details.busy?this.labels.busy:this.labels.free},hasBusy:function(){return"boolean"==typeof this.details.busy},occurs:function(){return this.$dayspan.getEventOccurrence(this.calendarEvent.schedule,this.calendarEvent.start,this.labels,this.formats)},details:function(){return this.calendarEvent.event.data},allowEdit:function(){return this.allowEditOnReadOnly||!this.isReadOnly},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly||this.details.readonly}},data:function(e){return{}},methods:{}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendarEventTime",props:{calendarEvent:{required:!0,type:a.CalendarEvent},calendar:{required:!0,type:a.Calendar},popoverProps:{validate:function(e){return this.$dsValidate(e,"popoverProps")},default:function(){return this.$dsDefaults().popoverProps}},isPlaceholderWithDay:{type:a.Day}},computed:{style:function(){return this.isPlaceholderWithDay?this.$dayspan.getStylePlaceholderTimed(this.details,this.calendarEvent,this.isPlaceholderWithDay):this.$dayspan.getStyleTimed(this.details,this.calendarEvent)},showName:function(){return this.calendarEvent.starting||this.calendar&&!this.calendar.span.contains(this.calendarEvent.time.start)},hasPopover:function(){return!!this.$scopedSlots.eventPopover},hasIcon:function(){return!(!this.$dayspan.supports.icon||!this.details.icon)},contentClass:function(){return this.$dayspan.fullscreenPopovers?"ds-fullscreen":""},details:function(){return this.calendarEvent.event.data}},data:function(e){return{menu:!1}},methods:{close:function(){this.menu=!1},edit:function(){this.handlesEvents()&&this.$emit("edit",this.calendarEvent)},editCheck:function(e){this.handlesEvents(e)&&(this.hasPopover?this.menu=!this.menu:this.edit())},mouseEnterEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-enter-event",this.getEvent("mouse-enter-event",e))},mouseLeaveEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-leave-event",this.getEvent("mouse-leave-event",e))},mouseDownEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-down-event",this.getEvent("mouse-down-event",e))},mouseUpEvent:function(e){this.handlesEvents(e)&&this.$emit("mouse-up-event",this.getEvent("mouse-up-event",e))},handlesEvents:function(e){var t=!this.isPlaceholderWithDay;return t&&e&&e.stopPropagation(),t},getEvent:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return a.Functions.extend({type:e,calendarEvent:this.calendarEvent,calendar:this.calendar,details:this.details,offset:this.getRelativeTimeAt(t),left:0===t.button,right:1===t.button,handled:!1,$event:t,$vm:this,$element:this.$el},n)},getRelativeTimeAt:function(e){var t=this.$el.getBoundingClientRect();return(e.clientY-t.y)/this.$dayspan.dayHeight*a.Constants.MILLIS_IN_DAY}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsCalendarEventTimePlaceholder",props:{placeholder:{required:!0,type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1},calendar:{required:!0,type:a.Calendar},day:{type:a.Day},popoverProps:{validate:function(e){return this.$dsValidate(e,"popoverProps")},default:function(){return this.$dsDefaults().popoverProps}}},computed:{hasPopover:function(){return!!this.$scopedSlots.eventCreatePopover},contentClass:function(){return this.$dayspan.fullscreenPopovers?"ds-fullscreen":""},isStart:function(){return this.placeholder.day.sameDay(this.day)},autoOpen:function(){return this.hasPopover&&this.placeholderForCreate&&this.isStart}},data:function(e){return{menu:!1}},watch:{menu:"triggerClearPlaceholder",placeholderForCreate:"openPopover"},mounted:function(){this.autoOpen&&(this.menu=!0)},methods:{close:function(){this.menu=!1},openPopover:function(e){this.isStart&&(this.menu=e)},triggerClearPlaceholder:function(e){e||this.$emit("clear-placeholder")}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsDay",props:{day:{required:!0,type:a.Day},calendar:{required:!0,type:a.Calendar},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}}},computed:{classesDay:function(){return{"ds-today":this.day.currentDay,"ds-first-day-day":1===this.day.dayOfMonth,"ds-out-calendar":!this.day.inCalendar}},classesHeader:function(){return{"ds-out-calendar":!this.day.inCalendar}},classesDayOfMonth:function(){return{"ds-today-dom":this.day.currentDay}},showMonth:function(){return 1===this.day.dayOfMonth},dayOfMonth:function(){return this.day.dayOfMonth},month:function(){return this.day.format(this.formats.month)},hasPlaceholder:function(){return this.placeholder&&this.placeholder.time.matchesDay(this.day)},visibleEvents:function(){return this.day.events.filter(this.isVisible)}},methods:{isVisible:function(e){return!this.$dayspan.features.hideOnMove||!this.placeholder||this.placeholder.event!==e.event},add:function(){this.$emit("add",this.day)},viewDay:function(e){this.$emit("view-day",this.day)},mouseEnterDay:function(e){this.$emit("mouse-enter-day",this.day)},mouseLeaveDay:function(e){this.$emit("mouse-leave-day",this.day)},mouseMoveDay:function(e){this.$emit("mouse-move-day",this.getEvent("mouse-move-day",e))},mouseDownDay:function(e){this.$emit("mouse-down-day",this.getEvent("mouse-down-day",e))},mouseUpDay:function(e){this.$emit("mouse-up-day",this.getEvent("mouse-up-day",e))},getEvent:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return a.Functions.extend({type:e,day:this.day,calendar:this.calendar,left:0===t.button&&t.buttons>0,right:1===t.button&&t.buttons>0,handled:!1,$event:t,$vm:this,$element:this.$el},n)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsDayPicker",props:{span:{required:!0,type:a.DaySpan},highlightSpan:{type:Boolean,default:!1},weekdays:{type:Array,default:function(){return this.$dsDefaults().weekdays}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},data:function(e){return{month:e.getMonth()}},computed:{summary:function(){return this.month?this.month.summary(!1,!1,!1,!1):""}},watch:{span:{deep:!0,handler:"resetMonth"}},methods:{isHighlighted:function(e){return this.highlightSpan&&this.span.matchesDay(e)},getMonthStart:function(){return this.span&&this.span.start?this.span.start:this.$dayspan.today},resetMonth:function(){this.span.matchesMonth(this.month.start)||(this.month=this.getMonth())},getMonth:function(){return a.Calendar.months(1,this.getMonthStart(),0,{fill:!0,minimumSize:42})},pick:function(e){this.$emit("picked",e)},prev:function(){var e=this.getEvent("prev",{next:!1,prev:!0});this.$emit("prev",e),e.handled||(e.month.prev(),e.handled=!0),this.$emit("change",e)},next:function(){var e=this.getEvent("next",{next:!0,prev:!1});this.$emit("next",e),e.handled||(e.month.next(),e.handled=!0),this.$emit("change",e)},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,span:this.span,month:this.month,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsDayRow",props:{days:{required:!0,type:Array},calendar:{required:!0,type:a.Calendar},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1}},methods:{}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsDayTimes",props:{day:{required:!0,type:a.CalendarDay},calendar:{required:!0,type:a.Calendar},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1}},computed:{classesDay:function(){return{"ds-day-today":this.day.currentDay,"ds-day-past":this.day.currentOffset<0,"ds-day-future":this.day.currentOffset>0}},nowLine:function(){return this.$dayspan.getStyleNow()},hasPlaceholder:function(){return this.placeholder&&!this.placeholder.fullDay&&this.placeholder.time.matchesDay(this.day)}},methods:{isVisible:function(e){return!e.fullDay&&(!this.$dayspan.features.hideOnMove||!this.placeholder||this.placeholder.event!==e.event)},addAt:function(e){this.$emit("add-at",{day:this.day,hour:e-1})},mouseEnterDay:function(e){this.$emit("mouse-enter-day",this.day)},mouseLeaveDay:function(e){this.$emit("mouse-leave-day",this.day)},mouseMove:function(e){var t=this.getTimeAt(e,this.$dayspan.rounding.move),n=this.getTimeAt(e,this.$dayspan.rounding.add,!0),a=this.getEvent("mouse-move",e,{time:t,timeDrag:n});this.$emit("mouse-move",a)},mouseDown:function(e){var t=this.getTimeAt(e,this.$dayspan.rounding.add),n=this.getEvent("mouse-down",e,{time:t});this.$emit("mouse-down",n)},mouseUp:function(e){var t=this.getTimeAt(e,this.$dayspan.rounding.add,!0),n=this.getEvent("mouse-up",e,{time:t});this.$emit("mouse-up",n)},getEvent:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return a.Functions.extend({type:e,day:this.day,left:0===t.button&&t.buttons>0,right:1===t.button&&t.buttons>0,handled:!1,$event:t,$vm:this,$element:this.$el},n)},getTimeAt:function(e,t,n){var s=this.$el.getBoundingClientRect(),i=(e.clientY-s.y)/s.height,r=Math.round(a.Constants.MILLIS_IN_DAY*i),l=this.day.start().relative(r);return t&&(l=this.$dayspan.roundTime(l,t,n)),l}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsDaysView",props:{calendar:{required:!0,type:a.Calendar},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1},scrollToFirst:{type:Boolean,default:function(){return this.$dsDefaults().scrollToFirst}},scrollBuffer:{type:Number,default:function(){return this.$dsDefaults().scrollBuffer}},hours:{type:Array,default:function(){return this.$dsDefaults().hours}}},computed:{dayHeight:function(){return{height:this.$dayspan.dayHeight+"px"}},hourClasses:function(){var e=this.$dayspan.now.hour;return this.hours.map(function(t,n){return{"ds-same-hour":n===e,"ds-past-hour":n<e}})}},data:function(e){return{scrollPush:0}},watch:{"calendar.start":"scrollToEvent"},mounted:function(){this.scrollToEvent(),this.scrollPush=this.getScrollPush()},methods:{scrollToEvent:function(){if(this.scrollToFirst){var e=a.Constants.MINUTES_IN_DAY,t=this.calendar.iterateDays().reduce(e,function(e,t){return e.iterateEvents().reduce(t,function(e,t){return Math.min(t,e.start.hour*a.Constants.MINUTES_IN_HOUR+e.start.minute)},function(e){return!e.fullDay})});if(e!==t){var n=(t-this.scrollBuffer)/a.Constants.MINUTES_IN_HOUR,s=n*this.$dayspan.hourHeight;this.$refs.scrollArea.scrollTop=Math.floor(s)}}},getScrollPush:function(){var e=this.$refs.scrollArea,t=this.$refs.pane;return e&&t?e.offsetWidth-t.offsetWidth:0}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsEvent",props:{targetSchedule:{required:!0,type:a.Schedule},targetDetails:{type:Object,required:!0},calendarEvent:{type:a.CalendarEvent},calendar:{type:a.Calendar},day:{type:a.Day},readOnly:{type:Boolean,default:!1},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},hasTitle:{type:Boolean,default:function(){return this.$dsDefaults().hasTitle}},hasCancel:{type:Boolean,default:function(){return this.$dsDefaults().hasCancel}},hasSave:{type:Boolean,default:function(){return this.$dsDefaults().hasSave}},hasTabs:{type:Boolean,default:function(){return this.$dsDefaults().hasTabs}},hasDetails:{type:Boolean,default:function(){return this.$dsDefaults().hasDetails}},hasForecast:{type:Boolean,default:function(){return this.$dsDefaults().hasForecast}},hasExclusions:{type:Boolean,default:function(){return this.$dsDefaults().hasExclusions}},hasInclusions:{type:Boolean,default:function(){return this.$dsDefaults().hasInclusions}},hasCancelled:{type:Boolean,default:function(){return this.$dsDefaults().hasCancelled}},busyOptions:{type:Array,default:function(){return this.$dsDefaults().busyOptions}}},data:function(e){return{tab:"details",schedule:new a.Schedule,details:e.$dayspan.getDefaultEventDetails()}},watch:{targetSchedule:{handler:"updateSchedule",immediate:!0},targetDetails:{handler:"updateDetails",immediate:!0}},computed:{slotData:function(){return{targetSchedule:this.targetSchedule,targetDetails:this.targetDetails,schedule:this.schedule,details:this.details,busyOptions:this.busyOptions,day:this.day,calendar:this.calendar,calendarEvent:this.calendarEvent,labels:this.labels,readOnly:this.readOnly}},classes:function(){return{"ds-has-cancel":this.hasCancel,"ds-event-small":this.$vuetify.breakpoint.smAndDown}},canSave:function(){return this.$dayspan.isValidEvent(this.details,this.schedule,this.calenderEvent)},repeats:function(){return!this.schedule.isSingleEvent()},showTitle:function(){return this.$dayspan.supports.title&&this.hasTitle},showCancels:function(){return this.$dayspan.features.cancel&&this.repeats&&this.hasCancelled&&!this.schedule.cancel.isEmpty()},showForecast:function(){return this.$dayspan.features.forecast&&this.repeats&&this.hasForecast},showExclusions:function(){return this.$dayspan.features.exclude&&this.repeats&&this.hasExclusions&&!this.schedule.exclude.isEmpty()},showInclusions:function(){return this.$dayspan.features.include&&this.repeats&&this.hasInclusions&&!this.schedule.include.isEmpty()},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},methods:{save:function(){var e=this.getEvent("save");this.$emit("save",e),e.handled||(e.target&&e.schedule&&e.target.set(e.schedule),e.calendarEvent?(this.$dayspan.setEventDetails(e.details,e.targetDetails,e.calendarEvent.event,e.calendarEvent),this.$emit("update",e),this.$emit("event-update",e.calendarEvent.event)):e.create&&(e.created=this.$dayspan.createEvent(e.details,e.schedule),e.calendar&&(e.calendar.addEvent(e.created),e.added=!0),this.$emit("create",e)),e.calendar&&e.refresh&&e.calendar.refreshEvents(),e.handled=!0,e.created&&this.$emit("event-create",e.created)),this.$emit("saved",e)},actioned:function(e){this.$emit("actioned",e)},cancel:function(){this.$emit("cancel",this.getEvent("cancel"))},updateSchedule:function(e){this.schedule=e.clone(),this.tab="details"},updateDetails:function(e){this.details=this.$dayspan.copyEventDetails(e),this.tab="details"},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,day:this.day,schedule:this.schedule,target:this.targetSchedule,details:this.details,targetDetails:this.targetDetails,calendar:this.calendar,calendarEvent:this.calendarEvent,handled:!1,refresh:!0,create:!0,added:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsEventDialog",props:{calendar:{type:a.Calendar},dialogProps:{validate:function(e){return this.$dsValidate(e,"dialogProps")},default:function(){return this.$dsDefaults().dialogProps}},readOnly:{type:Boolean,default:!1}},data:function(e){return{open:!1,calendarEvent:null,details:null,schedule:null,day:null}},computed:{},methods:{addToday:function(){this.add(this.$dayspan.today)},add:function(e,t){this.addSchedule(e,a.Schedule.forDay(e,t))},addAt:function(e,t){this.addSchedule(e,a.Schedule.forTime(e,t))},addSpan:function(e){this.addSchedule(e.start,a.Schedule.forSpan(e))},addPlaceholder:function(e,t){this.addSchedule(e.start,e.schedule,t||e.event.data)},addSchedule:function(e,t,n){this.day=e,this.calendarEvent=null,this.details=n||this.$dayspan.getDefaultEventDetails(),this.schedule=t,this.finishOpen()},edit:function(e){this.day=e.start,this.calendarEvent=e,this.details=e.event.data||this.$dayspan.getDefaultEventDetails(),this.schedule=e.schedule,this.finishOpen()},finishOpen:function(){var e=this.getEvent("open");this.$emit("open",e),e.open&&(this.open=!0)},eventCreate:function(e){this.$emit("event-create",e)},eventUpdate:function(e){this.$emit("event-update",e)},eventRemove:function(e){this.$emit("event-remove",e)},actioned:function(e){e.hide=!0,this.$emit("actioned",e),this.finishClose(e)},cancel:function(e){e.hide=!0,this.$emit("cancel",e),this.finishClose(e)},saved:function(e){e.hide=!0,this.$emit("saved",e),this.finishClose(e)},finishClose:function(e){e.hide&&(this.open=!1,this.$emit("close",e)),this.schedule=null,this.details=null},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,day:this.day,schedule:this.schedule,calendar:this.calendar,calendarEvent:this.calendarEvent,handled:!1,open:!0,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"dsGestures",props:{minDistance:{type:Number,default:function(){return this.$dsDefaults().minDistance}},maxDistance:{type:Number,default:function(){return this.$dsDefaults().maxDistance}},maxWander:{type:Number,default:function(){return this.$dsDefaults().maxWander}}},methods:{start:function(e){this.starting=this.getPoint(e)},move:function(e){this.checkGesture(this.getPoint(e),this.maxDistance)},end:function(e){this.checkGesture(this.getPoint(e),this.minDistance)},checkGesture:function(e,t){var n=this.starting;if(!n)return!1;var a=e.x-n.x,s=e.y-n.y,i=a*a;if(i>t*t){var r=(Math.sqrt(i),a<0?-a:a),l=s<0?-s:s;r>l?r*this.maxWander>l&&(a<0?this.$emit("swipeleft",r):this.$emit("swiperight",r),this.$emit("swipex",a)):l*this.maxWander>r&&(s<0?this.$emit("swipeup",l):this.$emit("swipedown",l),this.$emit("swipey",s)),this.starting=null}},getPoint:function(e){var t=e.touches[0]||e.changedTouches[0];return{x:t.clientX,y:t.clientY}}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsIdentifierChip",props:{identifier:{required:!0,validator:function(e){return"string"==typeof e||"number"==typeof e}},description:{type:String,default:function(){return this.$dsDefaults().description}},short:{type:Boolean,default:function(){return this.$dsDefaults().short}},canRemove:{type:Boolean,default:function(){return this.$dsDefaults().canRemove}}},computed:{text:function(){return a.Identifier.find(this.identifier).describe(this.identifier,this.short)}},methods:{remove:function(){this.$emit("remove",this.identifier)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsSchedule",props:{schedule:{required:!0,type:a.Schedule},day:{type:a.Day},readOnly:{type:Boolean,default:!1},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},allowsRange:{type:Boolean,default:function(){return this.$dsDefaults().allowsRange}}},data:function(e){return{}},computed:{showRange:function(){return this.allowsRange&&!this.schedule.isSingleEvent()},classes:function(){return{"ds-schedule-small":this.$vuetify.breakpoint.smAndDown}},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},methods:{custom:function(){this.$refs.customScheduler.edit(this.schedule,this.day)},setType:function(e){this.$emit("type",e)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleActions",props:{schedule:{required:!0,type:a.Schedule},calendarEvent:{required:!0,type:a.CalendarEvent},calendar:{type:a.Calendar},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},allowRemove:{type:Boolean,default:function(){return this.$dsDefaults().allowRemove}},allowExclude:{type:Boolean,default:function(){return this.$dsDefaults().allowExclude}},allowCancel:{type:Boolean,default:function(){return this.$dsDefaults().allowCancel}},allowUncancel:{type:Boolean,default:function(){return this.$dsDefaults().allowUncancel}},allowMove:{type:Boolean,default:function(){return this.$dsDefaults().allowMove}},allowInclude:{type:Boolean,default:function(){return this.$dsDefaults().allowInclude}},allowSetStart:{type:Boolean,default:function(){return this.$dsDefaults().allowSetStart}},allowSetEnd:{type:Boolean,default:function(){return this.$dsDefaults().allowSetEnd}}},data:function(e){return{movingDate:!1,movingTime:!1,includingDate:!1,includingTime:!1,targetDate:null,targetTime:null}},computed:{repeats:function(){return!this.schedule.isSingleEvent()},event:function(){return this.calendarEvent.event},canRemove:function(){return this.allowRemove},canExclude:function(){return this.allowExclude&&this.repeats},canCancel:function(){return this.allowCancel&&!this.calendarEvent.cancelled},canUncancel:function(){return this.allowUncancel&&this.calendarEvent.cancelled},canMove:function(){return this.allowMove},canInclude:function(){return this.allowInclude},canSetStart:function(){return this.allowSetStart},canSetEnd:function(){return this.allowSetEnd},moving:function(){return this.movingDate||this.movingTime},including:function(){return this.includingDate||this.includingTime}},methods:{remove:function(){var e=this;this.$dayspan.getPermission("actionRemove",function(){var t=e.getEvent("remove");e.$emit("remove",t),!t.handled&&t.calendar&&(t.calendar.removeEvent(t.event),t.handled=!0),e.$emit("finish",t),e.$emit("event-remove",t.event)})},exclude:function(){var e=this;this.$dayspan.getPermission("actionExclude",function(){var t=e.getEvent("exclude");e.$emit("exclude",t),!t.handled&&t.calendarEvent&&(t.calendarEvent.exclude(),t.refresh&&t.calendar&&t.calendar.refreshEvents(),t.handled=!0),e.$emit("finish",t),e.$emit("event-update",t.event)})},cancel:function(){var e=this;this.$dayspan.getPermission("actionCancel",function(){var t=e.getEvent("cancel");e.$emit("cancel",t),!t.handled&&t.calendarEvent&&(t.calendarEvent.cancel(!0),t.refresh&&t.calendar&&t.calendar.refreshEvents(),t.handled=!0),e.$emit("finish",t),e.$emit("event-update",t.event)})},uncancel:function(){var e=this;this.$dayspan.getPermission("actionUncancel",function(){var t=e.getEvent("uncancel");e.$emit("uncancel",t),!t.handled&&t.calendarEvent&&(t.calendarEvent.cancel(!1),t.refresh&&t.calendar&&t.calendar.refreshEvents(),t.handled=!0),e.$emit("finish",t),e.$emit("event-update",t.event)})},setStart:function(){var e=this;this.$dayspan.getPermission("actionSetStart",function(){var t=e.getEvent("set-start");e.$emit("set-start",t),!t.handled&&t.calendarEvent&&(t.calendarEvent.schedule.start=t.calendarEvent.day.start(),t.refresh&&t.calendar&&t.calendar.refreshEvents(),t.handled=!0),e.$emit("finish",t),e.$emit("event-update",t.event)})},setEnd:function(){var e=this;this.$dayspan.getPermission("actionSetEnd",function(){var t=e.getEvent("set-end");e.$emit("set-end",t),!t.handled&&t.calendarEvent&&(t.calendarEvent.schedule.end=t.calendarEvent.day.end(),t.refresh&&t.calendar&&t.calendar.refreshEvents(),t.handled=!0),e.$emit("finish",t),e.$emit("event-update",t.event)})},getTarget:function(){if(!this.targetDate)return null;var e=a.Day.parse(this.targetDate);if(e&&this.targetTime){var t=a.Time.parse(this.targetTime);t&&(e=e.withTime(t))}return e},setTarget:function(){this.targetDate=this.calendarEvent.start.format("YYYY-MM-DD"),this.targetTime=this.calendarEvent.start.format("HH:mm")},moveStart:function(){this.setTarget(),this.movingDate=!0},moveEnd:function(){var e=this;if(this.movingDate&&(this.movingDate=!1,!this.schedule.isFullDay()))return void(this.movingTime=!0);this.movingTime&&(this.movingTime=!1);var t=this.getTarget();t&&this.$dayspan.getPermission("actionMove",function(){var n=e.getEvent("move",{target:t});e.$emit("move",n),!n.handled&&n.calendarEvent&&n.target&&(n.calendarEvent.move(n.target),n.calendar&&n.calendar.refreshEvents(),n.handled=!0),e.$emit("finish",n),e.$emit("event-update",n.event)})},includeStart:function(){this.setTarget(),this.includingDate=!0},includeEnd:function(){var e=this;if(this.includingDate&&(this.includingDate=!1,!this.schedule.isFullDay()))return void(this.includingTime=!0);this.includingTime&&(this.includingTime=!1);var t=this.getTarget();t&&this.$dayspan.getPermission("actionInclude",function(){var n=e.getEvent("include",{target:t});e.$emit("include",n),!n.handled&&n.calendarEvent&&n.calendarEvent.schedule&&n.target&&(n.calendarEvent.schedule.setExcluded(n.target,!1),n.calendar&&n.calendar.refreshEvents(),n.handled=!0),e.$emit("finish",n),e.$emit("event-update",n.event)})},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,schedule:this.schedule,calendar:this.calendar,calendarEvent:this.calendarEvent,event:this.event,handled:!1,refresh:!0,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleForecast",props:{schedule:{required:!0,type:a.Schedule},day:{type:a.Day},readOnly:{type:Boolean,default:!1},canExclude:{type:Boolean,default:function(){return this.$dsDefaults().canExclude}},hasDescription:{type:Boolean,default:function(){return this.$dsDefaults().hasDescription}},defaultSize:{type:Number,default:function(){return this.$dsDefaults().defaultSize}},sizeMax:{type:Number,default:function(){return this.$dsDefaults().sizeMax}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},data:function(e){return{size:e.defaultSize}},computed:{sizeInput:{get:function(){return this.size},set:function(e){this.size=Math.max(1,Math.min(Math.floor(e),this.sizeMax))}},aroundDay:function(){return this.day||this.$dayspan.today},forecast:function(){return this.schedule.forecast(this.aroundDay,!1,this.size).map(function(e){return e[1]}).list()},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},watch:{forecast:{handler:"triggerChange",immediate:!0}},methods:{triggerChange:function(){this.$emit("change",this.getEvent("change"))},exclude:function(e){var t=this.getEvent("exclude",{time:e});!t.handled&&t.schedule&&(t.schedule.setExcluded(t.time),t.handled=!0)},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,schedule:this.schedule,size:this.size,forecast:this.forecast,day:this.day,aroundDay:this.aroundDay,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=(n.n(a),n(2));t.default={name:"dsScheduleFrequencyDay",mixins:[s.a],props:{options:{default:function(){return this.$dsDefaults().options}},types:{default:function(){return this.$dsDefaults().types}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},data:function(e){return{chosenType:null,property:"dayOfMonth"}},watch:{schedule:{immediate:!0,deep:!0,handler:"updateProperty"},chosenType:"onTypeChange"},computed:{oneOfs:function(){return this.getOffsets(this.chosenType.max,a.Suffix.CACHE,this.chosenType.min,this.chosenType.offset)},offsets:function(){return this.getOffsets(this.frequency.every+1,a.Suffix.CACHE,this.chosenType.min,this.chosenType.offset)}},methods:{updateProperty:function(){this.chosenType=this.findType(this.types)},onTypeChange:function(e,t){this.property=e.property}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=(n.n(a),n(2));t.default={name:"dsScheduleFrequencyDayOfWeek",mixins:[s.a],props:{options:{default:function(){return this.$dsDefaults().options}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},weekdays:{type:Array,default:function(){return this.$dsDefaults().weekdays}}},data:function(e){return{property:"dayOfWeek"}},computed:{isSimple:function(){return"any"===this.type||"weekday"===this.type||"weekend"===this.type},oneOfs:function(){return this.weekdays.map(function(e,t){return{text:e,value:t}})},offsets:function(){return this.getOffsets(this.frequency.every,this.weekdays)}},methods:{getCustomFrequencyType:function(e){return e&&a.Functions.isArrayEquals(e,a.Weekday.WEEK)?"weekday":e&&a.Functions.isArrayEquals(e,a.Weekday.ENDS)?"weekend":void 0},setCustomFrequencyType:function(e){switch(e){case"weekday":this.frequency=a.Weekday.WEEK;break;case"weekend":this.frequency=a.Weekday.ENDS}}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(2);t.default={name:"dsScheduleFrequencyMonth",mixins:[a.a],props:{options:{default:function(){return this.$dsDefaults().options}},months:{type:Array,default:function(){return this.$dsDefaults().months}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},data:function(e){return{property:"month"}},computed:{oneOfs:function(){return this.months.map(function(e,t){return{text:e,value:t}})},offsets:function(){return this.getOffsets(this.frequency.every,this.months)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=(n.n(a),n(2));t.default={name:"dsScheduleFrequencyWeek",mixins:[s.a],props:{options:{default:function(){return this.$dsDefaults().options}},types:{default:function(){return this.$dsDefaults().types}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},data:function(e){return{chosenType:null,property:"weekspanOfMonth"}},watch:{schedule:{immediate:!0,deep:!0,handler:"updateProperty"},chosenType:"onTypeChange"},computed:{oneOfs:function(){return this.getOffsets(this.chosenType.max,a.Suffix.CACHE,this.chosenType.min,this.chosenType.offset)},offsets:function(){return this.getOffsets(this.frequency.every+1,a.Suffix.CACHE)}},methods:{updateProperty:function(){this.chosenType=this.findType(this.types)},onTypeChange:function(e,t){this.property=e.property}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),s=(n.n(a),n(2));t.default={name:"dsScheduleFrequencyYear",mixins:[s.a],props:{day:{type:a.Day},lookback:{type:Number,default:function(){return this.$dsDefaults().lookback}},lookahead:{type:Number,default:function(){return this.$dsDefaults().lookahead}},options:{default:function(){return this.$dsDefaults().options}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},data:function(e){return{property:"year"}},computed:{currentYear:function(){return(this.schedule.start||this.day||this.$dayspan.today).year},oneOfs:function(){for(var e=this.currentYear,t=e-this.lookback,n=e+this.lookahead,a=[],s=t;s<=n;s++)a.push({text:s,value:s});return a},offsets:function(){for(var e=this.frequency.every,t=this.currentYear,n=[],a=0;a<e;a++)n.push({text:t+a,value:a});return n}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleModifier",props:{modifier:{required:!0,type:a.ScheduleModifier},readOnly:{type:Boolean,default:!1},canRemove:{type:Boolean,default:function(){return this.$dsDefaults().canRemove}},description:{type:String,default:function(){return this.$dsDefaults().description}}},data:function(e){return{}},computed:{identifiers:function(){return this.modifier.identifiers(function(e){return e}).list()},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},methods:{remove:function(e){var t=this.getEvent("remove",{identifier:e});!t.handled&&t.modifier&&(t.modifier.map[e]=!1,t.handled=!0),this.$emit("change",t)},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,modifier:this.modifier,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleSpan",props:{schedule:{required:!0,type:a.Schedule},day:{type:a.Day},readOnly:{type:Boolean,default:!1},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}}},data:function(e){return{startMenu:!1,endMenu:!1}},computed:{hasStart:function(){return!!this.schedule.start},hasEnd:function(){return!!this.schedule.end},startSpan:function(){var e=this.schedule.start||this.day;return e?a.DaySpan.point(e):null},startText:function(){return this.schedule.start?this.schedule.start.format(this.formats.start):this.labels.startless},endSpan:function(){var e=this.schedule.end||this.day;return e?a.DaySpan.point(e):null},endText:function(){return this.schedule.end?this.schedule.end.format(this.formats.end):this.labels.endless},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},methods:{setStart:function(e){var t=this.getEvent("start",{start:e});this.$emit("start",t),!t.handled&&t.schedule&&(t.schedule.start=t.start,t.handled=!0),this.startMenu=!1,this.$emit("change",t)},setEnd:function(e){var t=this.getEvent("end",{end:e});this.$emit("end",t),!t.handled&&t.schedule&&(t.schedule.end=t.end,t.handled=!0),this.endMenu=!1,this.$emit("change",t)},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,schedule:this.schedule,day:this.day,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleTime",props:{value:{required:!0,type:a.Time},readOnly:{type:Boolean,default:!1},index:{type:Number,default:function(){return this.$dsDefaults().index}},mutate:{type:Boolean,default:function(){return this.$dsDefaults().mutate}},showAdd:{type:Boolean,default:function(){return this.$dsDefaults().showAdd}},showRemove:{type:Boolean,default:function(){return this.$dsDefaults().showRemove}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},colors:{validate:function(e){return this.$dsValidate(e,"colors")},default:function(){return this.$dsDefaults().colors}},icons:{validate:function(e){return this.$dsValidate(e,"icons")},default:function(){return this.$dsDefaults().icons}}},data:function(e){return{}},computed:{time:{get:function(){return this.value.format("HH:mm")},set:function(e){this.setTime(e)}},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},methods:{addTime:function(){this.$emit("add",this.getEvent("add"))},removeTime:function(){this.$emit("remove",this.getEvent("remove"))},setTime:function(e){var t=a.Time.parse(e);if(t){var n=this.getEvent("change",{next:t});this.$emit("change",n),n.handled||(n.mutate&&(n.time.set(n.next),t=n.next),this.$emit("input",t))}},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,time:this.value,index:this.index,mutate:this.mutate,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleTimes",props:{schedule:{required:!0,type:a.Schedule},readOnly:{type:Boolean,default:!1},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}},defaultTime:{type:String,default:function(){return this.$dsDefaults().defaultTime}}},computed:{durationOptions:function(){var e=1===this.schedule.duration,t=[{text:e?this.labels.minute:this.labels.minutes,value:"minutes"},{text:e?this.labels.hour:this.labels.hours,value:"hours"}],n=[{text:e?this.labels.day:this.labels.days,value:"days"},{text:e?this.labels.week:this.labels.weeks,value:"weeks"},{text:e?this.labels.month:this.labels.months,value:"months"}];return this.allDay?n:t.concat(n)},hasTimes:function(){return this.schedule.times.length>1},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},data:function(e){return{allDay:!1}},watch:{schedule:{handler:"updateAllDay",immediate:!0},allDay:"updateScheduleAllDay"},methods:{updateAllDay:function(){this.allDay=this.schedule.isFullDay()},updateScheduleAllDay:function(e){var t=this;this.schedule.isFullDay()!==e&&this.$dayspan.getPermission("toggleAllDay",function(n){t.schedule.setFullDay(e),t.triggerChange()},function(){t.allDay=!e})},changeTime:function(e){e.schedule=this.schedule,e.updated=!1,this.$emit("update",e),!e.handled&&e.schedule&&(e.updated=e.schedule.moveTime(e.time,e.next),e.handled=!0),this.$emit("change",e)},addTime:function(e){e.time=a.Time.parse(this.defaultTime),e.schedule=this.schedule,e.time&&(this.$emit("add",e),!e.handled&&e.schedule&&(e.schedule.times.push(e.time),e.handled=!0),this.$emit("change",e))},removeTime:function(e){var t=this;this.$dayspan.getPermission("removeExistingTime",function(){e.schedule=t.schedule,t.$emit("remove",e),!e.handled&&e.schedule&&e.time&&(e.handled=e.schedule.removeTime(e.time)),t.$emit("change",e)})},isLastTime:function(e){return e===this.schedule.times.length-1},triggerChange:function(){this.$emit("change",this.getEvent("change"))},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,schedule:this.schedule,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleType",props:{day:{required:!0,type:a.Day},schedule:{required:!0,type:a.Schedule},readOnly:{type:Boolean,default:!1},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}}},data:function(){return{type:""}},watch:{schedule:{handler:"updateType",immediate:!0},type:"applyType"},computed:{hideHint:function(){return"none"!==this.type&&"custom"!==this.type},typeHint:function(){return"none"===this.type?this.day.format(this.formats.date):"custom"===this.type?this.$dayspan.getScheduleDescription(this.schedule):""},types:function(){var e=this;return this.day?a.Patterns.filter(function(e){return e.listed}).map(function(t){return{label:t.describe(e.day),value:t.name}}):[]},customIcon:function(){return"custom"===this.type?"edit":""},isReadOnly:function(){return this.readOnly||this.$dayspan.readOnly}},methods:{applyType:function(e,t){if(this.applying){if("custom"===t&&(this.schedule.end=null),e){var n=a.Pattern.withName(e);n&&n.apply(this.schedule,this.day)}"none"===e&&this.schedule.adjustDefinedSpan()}this.$emit("change",e)},custom:function(){this.$emit("custom",this)},updateType:function(){this.applying=!1,this.type=this.determineType(),this.applying=!0},determineType:function(){var e=a.Pattern.findMatch(this.schedule);return e?e.name:"custom"}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleTypeCustom",props:{day:{required:!0,type:a.Day},schedule:{required:!0,type:a.Schedule}},data:function(e){return{}},computed:{customDescription:function(){return this.$dayspan.getScheduleDescription(this.schedule)}},methods:{}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsScheduleTypeCustomDialog",props:{dialogProps:{validate:function(e){return this.$dsValidate(e,"dialogProps")},default:function(){return this.$dsDefaults().dialogProps}},labels:{validate:function(e){return this.$dsValidate(e,"labels")},default:function(){return this.$dsDefaults().labels}}},data:function(e){return{visible:!1,original:null,copy:null,day:null}},computed:{hasData:function(){return!!this.copy},aroundDay:function(){return this.day||this.$dayspan.today}},methods:{edit:function(e,t){this.original=e,this.copy=e.clone(),this.day=t,this.visible=!0,this.$emit("show",this.getEvent("show"))},create:function(){this.original=null,this.copy=new a.Schedule,this.day=null,this.visible=!0,this.$emit("show",this.getEvent("show"))},save:function(){var e=this.getEvent("save");this.$emit("save",e),!e.handled&&e.target&&e.schedule&&(e.target.set(e.schedule),e.handled=!0),this.finish(e)},hide:function(){this.finish(this.getEvent("hide"))},cancel:function(){var e=this.getEvent("cancel");this.$emit("cancel",e),this.finish(e)},finish:function(e){e.hide&&this.visible&&(this.visible=!1,this.$emit("hide",e))},getEvent:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return a.Functions.extend({type:e,target:this.original,schedule:this.copy,day:this.day,hide:!0,handled:!1,$vm:this,$element:this.$el},t)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsWeekDayHeader",props:{day:{required:!0,type:a.CalendarDay},calendar:{required:!0,type:a.Calendar},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1},formats:{validate:function(e){return this.$dsValidate(e,"formats")},default:function(){return this.$dsDefaults().formats}}},computed:{classesDay:function(){return{"ds-day-today":this.day.currentDay,"ds-day-past":this.day.currentOffset<0,"ds-day-future":this.day.currentOffset>0}},dayOfMonth:function(){return this.day.dayOfMonth},weekday:function(){return this.day.format(this.formats.weekday)},hasPlaceholder:function(){return this.placeholder&&this.placeholder.time.matchesDay(this.day)&&this.placeholder.fullDay},visibleEvents:function(){return this.day.events.filter(this.isVisible)}},methods:{isVisible:function(e){return!!e.fullDay&&(!this.$dayspan.features.hideOnMove||!this.placeholder||this.placeholder.event!==e.event)},add:function(){this.$emit("add",this.day)},viewDay:function(e){this.$emit("view-day",this.day)},mouseEnterDay:function(e){this.$emit("mouse-enter-day",this.day)},mouseLeaveDay:function(e){this.$emit("mouse-leave-day",this.day)},mouseMoveDay:function(e){this.$emit("mouse-move-day",this.getEvent("mouse-move-day",e))},mouseDownDay:function(e){this.$emit("mouse-down-day",this.getEvent("mouse-down-day",e))},mouseUpDay:function(e){this.$emit("mouse-up-day",this.getEvent("mouse-up-day",e))},getEvent:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return a.Functions.extend({type:e,day:this.day,calendar:this.calendar,left:0===t.button&&t.buttons>0,right:1===t.button&&t.buttons>0,handled:!1,$event:t,$vm:this,$element:this.$el},n)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsWeekHeader",props:{days:{required:!0,type:Array},calendar:{required:!0,type:a.Calendar},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1},scrollPush:{type:Number,default:0}},computed:{style:function(){return{marginRight:this.scrollPush+"px"}}},methods:{}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(0);n.n(a);t.default={name:"dsWeeksView",props:{calendar:{required:!0,type:a.Calendar},placeholder:{type:a.CalendarEvent},placeholderForCreate:{type:Boolean,default:!1},weekdays:{type:Array,default:function(){return this.$dsDefaults().weekdays}}},computed:{rows:function(){return Math.floor(this.calendar.days.length/7)}},methods:{daysAtRow:function(e,t){var n=(e-1)*t;return this.calendar.days.slice(n,n+t)},weekdayClasses:function(e){return{"ds-week-header-today":this.$dayspan.today.dayOfWeek===e}}}}},function(e,t,n){"use strict";t.a=[{text:0,value:"#F44336"},{text:0,value:"#E91E63"},{text:0,value:"#9C27B0"},{text:0,value:"#673AB7"},{text:0,value:"#3F51B5"},{text:0,value:"#2196F3"},{text:0,value:"#1976d2"},{text:0,value:"#03A9F4"},{text:0,value:"#00BCD4"},{text:0,value:"#009688"},{text:0,value:"#4CAF50"},{text:0,value:"#8BC34A"},{text:0,value:"#CDDC39"},{text:0,value:"#FFEB3B"},{text:0,value:"#FFC107"},{text:0,value:"#FF9800"},{text:0,value:"#FF5722"},{text:0,value:"#795548"},{text:0,value:"#607D8B"},{text:0,value:"#9E9E9E"},{text:0,value:"#000000"}]},function(e,t,n){"use strict";var a=n(0),s=(n.n(a),n(54)),i=n(52),r=n(55),l=n(58),o=n(6),d=n(191),c=n.n(d);t.a={data:{version:"0.3.0",readOnly:!1,today:a.Day.today(),tomorrow:a.Day.tomorrow(),now:a.Day.now(),timeout:null,refreshInterval:a.Constants.MILLIS_IN_MINUTE,dayPadding:5,dayHeight:960,columnOffset:10,eventHeight:21,hourHeight:40,inactiveBlendTarget:{r:255,g:255,b:255},inactiveBlendAmount:.5,placeholderBlendAmount:.2,placeholderBlendTarget:{r:255,g:255,b:255},rounding:{move:1,add:15*a.Constants.MILLIS_IN_MINUTE,drag:15*a.Constants.MILLIS_IN_MINUTE},supports:{title:!0,description:!0,color:!0,location:!0,calendar:!0,busy:!0,icon:!0,guests:!1},features:{exclude:!0,include:!0,cancel:!0,move:!0,moveDuplicate:!0,moveInstance:!0,moveAll:!0,drag:!0,forecast:!0,addDay:!0,addTime:!0,hideOnMove:!0},prompt:{actionRemove:!0,actionExclude:!0,actionCancel:!0,actionUncancel:!0,actionMove:!0,actionInclude:!0,actionSetStart:!0,actionSetEnd:!0,move:!0,toggleAllDay:!0,removeExistingTime:!0},promptOpen:null,promptLabels:{actionRemove:0,actionExclude:0,actionCancel:0,actionUncancel:0,actionSetStart:0,actionSetEnd:0,actionMove:0,actionInclude:0,move:0,toggleAllDay:0,removeExistingTime:0},placeholder:{noTitle:0},patterns:{lastDay:0,lastDayOfMonth:0,lastWeekday:0},colors:i.a,icons:r.a,defaults:s.a,locales:l.a,currentLocale:l.b},computed:{fullscreenPopovers:function(){return this.$vuetify.breakpoint.xs},fullscreenDialogs:function(){return this.$vuetify.breakpoint.xs}},methods:{normalizeLocaleName:function(e){return e.toLowerCase()},getLocale:function(e){return this.locales[this.normalizeLocaleName(e)]},setLocale:function(e,t){var a=this.getLocale(e);if(!a&&t)throw"No locale exists with the name "+e;a&&(n.i(o.e)(this,a,e),this.currentLocale=e)},addLocale:function(e,t){this.locales[this.normalizeLocaleName(e)]=t},addLocales:function(e,t){var n=this;e.forEach(function(e){return n.addLocale(e,t)})},updateLocale:function(e,t){var a=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],s=this.getLocale(e);if(!s)throw"No locale exists with the name "+e;n.i(o.e)(s,t,"",a)},init:function(){this.setLocale(this.currentLocale,!0),this.startRefreshTimes(),this.addPatterns()},setEventDetails:function(e,t,n,a){n.data=c.a.util.extend(t,e)},copyEventDetails:function(e){return n.i(o.f)({},e)},createEventData:function(e,t){return n.i(o.f)({},e)},createEvent:function(e,t,n){return a.Parse.event({schedule:t,data:this.createEventData(e,t)})},addPatterns:function(){var e=this;a.Patterns.unshift(a.PatternMap.lastDay=new a.Pattern("lastDay",!1,function(t){return e.patterns.lastDay(t)},{lastDayOfMonth:[1]})),a.Patterns.unshift(a.PatternMap.lastDayOfMonth=new a.Pattern("lastDayOfMonth",!1,function(t){return e.patterns.lastDayOfMonth(t)},{month:1,lastDayOfMonth:[1]})),a.Patterns.unshift(a.PatternMap.lastWeekday=new a.Pattern("lastWeekday",!1,function(t){return e.patterns.lastWeekday(t)},{lastWeekspanOfMonth:[0],dayOfWeek:1,month:1}))},getDefaultEventDetails:function(){return{title:"",description:"",location:"",color:this.getDefaultEventColor(),forecolor:"#ffffff",calendar:"",busy:!0,icon:""}},getDefaultEventColor:function(){return this.colors[Math.floor(this.colors.length*Math.random())].value},isValidEvent:function(e,t,n){return!!e.title},requiresPermission:function(e){return!!(this.prompt[e]&&this.promptLabels[e]&&this.promptOpen)},getPermission:function(e,t,n){var a=this.prompt[e],s=this.promptLabels[e];a&&s&&this.promptOpen?this.promptOpen(s,function(e){e?t(!0):n&&n()}):t(!1)},getPrefix:function(e,t){return 1===t.length?t[0].start.format("ha"):"("+t.length+")"},getScheduleDescription:function(e){return e.describe("event",!1,!1,!1,!1)},getEventOccurrence:function(e,t,n,s){var i=this.getEventDuration(e,n);if(e.isSingleEvent())return e.isFullDay()?i:t.asTime().format(s.time);var r=a.Pattern.findMatch(e,!1);if(r&&"custom"!==r.name){var l="";return"none"!==r.name&&(l=r.describe(t)),e.isFullDay()||(l&&(l+=" at "),l+=e.describeArray(e.times,function(e){return e.format(s.time)})),l+=" ("+i+")"}return e.describe("event",!1).substring(20)+" ("+i+")"},getEventAgendaWhen:function(e,t,n){var a="",s=e.schedule;return e.fullDay?a+=t.allDay:a+=s.describeArray(s.times,function(e){return e.format(n.time)}),1!==s.duration&&this.$vuetify.breakpoint.smAndUp&&(a+=" ("+this.getEventDuration(s,t)+")"),a},getEventDuration:function(e,t){var n=t[e.durationUnit],a=e.duration;return a+" "+(1===a?n[0]:n[1])},getPlaceholderEventDetails:function(){var e=this.getDefaultEventDetails();return e.title=this.placeholder.noTitle,e},getPlaceholderEventForAdd:function(e){var t=this.getPlaceholderEventDetails(),n=new a.Schedule({}),s=e.timeIdentifier,i=this.createEvent(t,n,!0),r=a.DaySpan.point(e),l=e.start();return new a.CalendarEvent(s,i,r,l)},getPlaceholderEventForMove:function(e){var t=new a.CalendarEvent(e.id,e.event,e.time,e.day);return t.time=new a.DaySpan(e.start,e.end),t.col=0,t.row=0,t},getStyleFull:function(e,t,n){var a=t.time.start.isBefore(this.today),s=t.cancelled,i=this.getStyleColor(e,t),r=this.getStyleColor(e,t,a,s);return{top:(t.row-(n||0))*this.eventHeight+"px",backgroundColor:r,color:e.forecolor,left:t.starting?"0px":"-5px",right:t.ending?"0px":"-6px",textDecoration:s?"line-through":"inherit",textDecorationColor:s?i:"inherit"}},getStyleTimed:function(e,t){var n=t.time.end.isBefore(this.now),a=t.cancelled,s=t.getTimeBounds(this.dayHeight,1,this.columnOffset),i=(this.getStyleColor(e,t),this.getStyleColor(e,t,n,a));return{top:s.top+"px",height:s.height+"px",left:s.left+"%",width:100-s.left+"%",backgroundColor:i,marginLeft:t.starting?0:"-5px",marginRight:t.ending?0:"-5px",textDecoration:a?"line-through":"inherit",textDecorationColor:a?i:"inherit"}},getStylePopover:function(e,t){},getStyleNowBorder:function(){return"black solid 3px"},getStyleNow:function(){return{position:"absolute",left:"0px",right:"-1px",top:this.now.asTime().toMilliseconds()/a.Constants.MILLIS_IN_DAY*this.dayHeight-1+"px",borderTop:this.getStyleNowBorder()}},getStyleColor:function(e,t,n,a){var s=e.color;return(n||a)&&(s=this.blend(s,this.inactiveBlendAmount,this.inactiveBlendTarget)),s},getStylePlaceholderTimed:function(e,t,n){var a=t.time.getBounds(n,this.dayHeight),s=this.getStyleColor(e,t);return{top:a.top+"px",height:a.height+"px",left:"0px",right:"0px",marginRight:"-1px",backgroundColor:this.blend(s,this.placeholderBlendAmount,this.placeholderBlendTarget)}},getStylePlaceholderFull:function(e,t,n,a){var s=(this.getStyleColor(e,t),this.getStyleColor(e,t)),i=t.time.start.sameDay(a),r=t.time.end.sameDay(a);return{top:(t.row-(n||0))*this.eventHeight+"px",color:e.forecolor,left:i?"0px":"-5px",right:r?"0px":"-6px",backgroundColor:this.blend(s,this.placeholderBlendAmount,this.placeholderBlendTarget)}},parseColor:function(e){if(a.Functions.isObject(e))return e;var t=/#(\w\w)(\w\w)(\w\w)/.exec(e);if(!t)throw"Colors must be in the format of #rrggbb";return{r:parseInt(t[1],16),g:parseInt(t[2],16),b:parseInt(t[3],16)}},clampComponent:function(e){return Math.max(0,Math.min(255,Math.floor(e)))},clampColor:function(e,t){var n=t||e;return n.r=this.clampComponent(e.r),n.g=this.clampComponent(e.g),n.b=this.clampComponent(e.b),n},formatComponent:function(e){var t=e.toString(16);return 1===t.length?"0"+t:t},formatColor:function(e){return"#"+this.formatComponent(e.r)+this.formatComponent(e.g)+this.formatComponent(e.b)},blend:function(e,t,n){var a=this.parseColor(e),s=this.parseColor(n),i={r:s.r+(a.r-s.r)*t,g:s.g+(a.g-s.g)*t,b:s.b+(a.b-s.b)*t};return this.clampColor(i),this.formatColor(i)},roundTime:function(e,t,n){var a=e.time,s=a%t,i=-s;return n&&0!==i&&(i+=t),e.relative(i)},startRefreshTimes:function(){var e=this;this.timeout=setTimeout(function(){e.refreshTimes(),e.startRefreshTimes()},this.refreshInterval)},stopRefreshTimes:function(){clearTimeout(this.timeout),this.timeout=null},refreshTimes:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=a.Day.today();t.sameDay(this.today)&&!e||(this.today=t,this.tomorrow=a.Day.tomorrow()),this.now=a.Day.now()}}}},function(e,t,n){"use strict";var a=n(0);n.n(a);t.a={dsCalendar:{handleAdd:!0,handleMove:!0},dsDay:{formats:{month:0}},dsCalendarApp:{allowsAddToday:!0,types:[{id:"D",label:0,shortcut:"D",type:a.Units.DAY,size:1,focus:.4999,repeat:!0,listTimes:!0,updateRows:!0,schedule:!1},{id:"W",label:0,shortcut:"W",type:a.Units.WEEK,size:1,focus:.4999,repeat:!0,listTimes:!0,updateRows:!0,schedule:!1},{id:"M",label:0,shortcut:"M",type:a.Units.MONTH,size:1,focus:.4999,repeat:!0,listTimes:!1,updateRows:!0,schedule:!1},{id:"Y",label:0,shortcut:"Y",type:a.Units.YEAR,size:1,focus:.4999,repeat:!0,listTimes:!1,updateRows:!0,schedule:!1},{id:"S",label:0,shortcut:"S",type:a.Units.DAY,size:92,focus:0,repeat:!1,listTimes:!1,updateRows:!1,schedule:!0},{id:"X",label:0,shortcut:"X",type:a.Units.DAY,size:4,focus:.4999,repeat:!0,listTimes:!0,updateRows:!0,schedule:!1}],formats:{today:0,xs:0},labels:{next:0,prev:0,moveCancel:0,moveSingleEvent:0,moveOccurrence:0,moveAll:0,moveDuplicate:0,promptConfirm:0,promptCancel:0,today:0,todayIcon:"today"},styles:{toolbar:{small:{width:"auto"},large:{width:"300px"}}},optionsDialog:{maxWidth:"300px",persistent:!0},promptDialog:{maxWidth:"300px",persistent:!0}},dsAgenda:{},dsAgendaDay:{},dsAgendaEvent:{popoverProps:{closeOnContentClick:!1,offsetOverflow:!0,offsetY:!0,maxWidth:500},formats:{firstLine:0,secondLine:0,start:0,time:0},labels:{allDay:0,options:0,close:0,day:[0,0],days:[0,0],minute:[0,0],minutes:[0,0],hour:[0,0],hours:[0,0],week:[0,0],weeks:[0,0],second:[0,0],seconds:[0,0],busy:0,free:0}},dsCalendarEvent:{index:0,popoverProps:{nudgeWidth:200,closeOnContentClick:!1,offsetOverflow:!0,offsetX:!0,maxWidth:500}},dsCalendarEventChip:{canExclude:!0,colors:{sameForeground:"white",sameBackground:"primary"},formats:{fullDay:0,timed:0}},dsCalendarEventPopover:{allowEditOnReadOnly:!0,formats:{start:0,time:0},labels:{allDay:0,options:0,close:0,day:[0,0],days:[0,0],minute:[0,0],minutes:[0,0],hour:[0,0],hours:[0,0],week:[0,0],weeks:[0,0],second:[0,0],seconds:[0,0],busy:0,free:0}},dsCalendarEventCreatePopover:{prompts:{description:!0,color:!0,location:!0,calendar:!0,busy:!0,icon:!0,guests:!1},formats:{start:0,time:0},icons:{save:"save",close:"close",edit:"edit"},labels:{title:0,allDay:0,close:0,save:0,day:[0,0],days:[0,0],minute:[0,0],minutes:[0,0],hour:[0,0],hours:[0,0],week:[0,0],weeks:[0,0],second:[0,0],seconds:[0,0],busy:0,free:0,location:0,description:0,calendar:0},busyOptions:[{value:!0,text:0},{value:!1,text:0}]},dsCalendarEventPlaceholder:{popoverProps:{nudgeWidth:200,closeOnContentClick:!1,closeOnClick:!0,offsetOverflow:!0,offsetX:!0,maxWidth:500}},dsCalendarEventTimePlaceholder:{popoverProps:{nudgeWidth:200,closeOnContentClick:!1,closeOnClick:!0,offsetOverflow:!0,offsetX:!0,maxWidth:500}},dsCalendarEventTime:{placeholderStyle:!1,disabled:!1,popoverProps:{nudgeWidth:200,closeOnContentClick:!1,offsetOverflow:!0,offsetX:!0,maxWidth:500}},dsIdentifierChip:{description:"",short:!0,canRemove:!0},dsSchedule:{allowsRange:!0,labels:{editCustom:0}},dsEvent:{hasTitle:!0,hasCancel:!0,hasSave:!0,canSave:!0,hasTabs:!0,hasDetails:!0,hasForecast:!0,hasExclusions:!0,hasInclusions:!0,hasCancelled:!0,labels:{moreActions:0,cancel:0,save:0,title:0,exclusions:0,inclusions:0,cancelled:0,edit:0,add:0,location:0,description:0,calendar:0,tabs:{details:0,forecast:0,removed:0,added:0,cancelled:0}},busyOptions:[{value:!0,text:0},{value:!1,text:0}]},dsScheduleActions:{allowRemove:!0,allowExclude:!0,allowCancel:!0,allowUncancel:!0,allowMove:!0,allowInclude:!0,allowSetStart:!0,allowSetEnd:!0,labels:{remove:0,exclude:0,cancel:0,uncancel:0,move:0,include:0,setStart:0,setEnd:0}},dsEventDialog:{dialogProps:{persistent:!0,lazy:!0,maxWidth:"800px"}},dsScheduleForecast:{canExclude:!0,hasDescription:!0,defaultSize:5,sizeMax:100,labels:{prefix:0,suffix:0}},dsScheduleFrequencyDay:{labels:{type:0},options:[{text:0,value:"any"},{text:0,value:"oneof"},{text:0,value:"every"}],types:[{text:0,property:"dayOfMonth",max:32,min:1},{text:0,property:"lastDayOfMonth",max:32,min:1},{text:0,property:"dayOfYear",max:367,min:1,offset:-1}]},dsScheduleFrequencyDayOfWeek:{weekdays:[0,0,0,0,0,0,0],labels:{type:0},options:[{text:0,value:"any"},{text:0,value:"oneof"},{text:0,value:"every"},{text:0,value:"weekend"},{text:0,value:"weekday"}]},dsScheduleFrequencyMonth:{months:[0,0,0,0,0,0,0,0,0,0,0,0],labels:{type:0},options:[{text:0,value:"any"},{text:0,value:"oneof"},{text:0,value:"every"}]},dsScheduleFrequencyWeek:{labels:{type:0},options:[{text:0,value:"any"},{text:0,value:"oneof"},{text:0,value:"every"}],types:[{text:0,property:"weekOfMonth",max:6},{text:0,property:"weekspanOfMonth",max:7,min:1,offset:-1},{text:0,property:"fullWeekOfMonth",max:6},{text:0,property:"lastWeekspanOfMonth",max:7,min:1,offset:-1},{text:0,property:"lastFullWeekOfMonth",max:6},{text:0,property:"weekOfYear",max:54},{text:0,property:"weekspanOfYear",max:53,min:1,offset:-1},{text:0,property:"fullWeekOfYear",max:54},{text:0,property:"lastWeekspanOfYear",max:53,min:1,offset:-1},{text:0,property:"lastFullWeekOfYear",max:54}]},dsScheduleFrequencyYear:{lookback:5,lookahead:20,labels:{type:0},options:[{text:0,value:"any"},{text:0,value:"oneof"},{text:0,value:"every"}]},dsScheduleModifier:{canRemove:!0,description:""},dsScheduleSpan:{labels:{startless:0,endless:0},formats:{start:0,end:0}},dsScheduleTime:{index:-1,mutate:!0,showAdd:!1,showRemove:!1,labels:{remove:0,add:0},colors:{add:"secondary",remove:"secondary"},icons:{add:"add",remove:"remove"}},dsScheduleTimes:{defaultTime:"08:00",labels:{all:0,minute:0,minutes:0,hour:0,hours:0,day:0,days:0,week:0,weeks:0,month:0,months:0,second:0,seconds:0}},dsScheduleType:{formats:{date:0}},dsScheduleTypeCustomDialog:{dialogProps:{maxWidth:"600px",persistent:!0,lazy:!0},labels:{save:0,cancel:0}},dsDayPicker:{weekdays:[0,0,0,0,0,0,0],labels:{prevMonth:0,nextMonth:0}},dsWeekDayHeader:{formats:{weekday:0}},dsWeeksView:{weekdays:[0,0,0,0,0,0,0]},dsDaysView:{scrollToFirst:!0,scrollBuffer:60,hours:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},dsGestures:{minDistance:50,maxDistance:200,maxWander:.1}}},function(e,t,n){"use strict";t.a=[{text:0,value:"alarm"},{text:0,value:"star"},{text:0,value:"favorite"},{text:0,value:"flash_on"},{text:0,value:"assignment"},{text:0,value:"warning"},{text:0,value:"attach_money"},{text:0,value:"payment"},{text:0,value:"home"},{text:0,value:"play_circle_outline"},{text:0,value:"email"},{text:0,value:"phone"},{text:0,value:"insert_chart"},{text:0,value:"directions_bike"},{text:0,value:"card_travel"}]},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var a=n(12),s=(n.n(a),n(11)),i=n(5);n.d(t,"DsGestures",function(){return i.DsGestures}),n.d(t,"DsDay",function(){return i.DsDay}),n.d(t,"DsDayRow",function(){return i.DsDayRow}),n.d(t,"DsDaysView",function(){return i.DsDaysView}),n.d(t,"DsDayTimes",function(){return i.DsDayTimes}),n.d(t,"DsDayPicker",function(){return i.DsDayPicker}),n.d(t,"DsAgenda",function(){return i.DsAgenda}),n.d(t,"DsAgendaDay",function(){return i.DsAgendaDay}),n.d(t,"DsAgendaEvent",function(){return i.DsAgendaEvent}),n.d(t,"DsCalendar",function(){return i.DsCalendar}),n.d(t,"DsCalendarApp",function(){return i.DsCalendarApp}),n.d(t,"DsCalendarEvent",function(){return i.DsCalendarEvent}),n.d(t,"DsCalendarEventTime",function(){return i.DsCalendarEventTime}),n.d(t,"DsCalendarEventChip",function(){return i.DsCalendarEventChip}),n.d(t,"DsCalendarEventPopover",function(){return i.DsCalendarEventPopover}),n.d(t,"DsCalendarEventPlaceholder",function(){return i.DsCalendarEventPlaceholder}),n.d(t,"DsCalendarEventCreatePopover",function(){return i.DsCalendarEventCreatePopover}),n.d(t,"DsCalendarEventTimePlaceholder",function(){return i.DsCalendarEventTimePlaceholder}),n.d(t,"DsEvent",function(){return i.DsEvent}),n.d(t,"DsEventDialog",function(){return i.DsEventDialog}),n.d(t,"DsSchedule",function(){return i.DsSchedule}),n.d(t,"DsScheduleSpan",function(){return i.DsScheduleSpan}),n.d(t,"DsScheduleType",function(){return i.DsScheduleType}),n.d(t,"DsScheduleTime",function(){return i.DsScheduleTime}),n.d(t,"DsScheduleTimes",function(){return i.DsScheduleTimes}),n.d(t,"DsScheduleActions",function(){return i.DsScheduleActions}),n.d(t,"DsScheduleForecast",function(){return i.DsScheduleForecast}),n.d(t,"DsScheduleModifier",function(){return i.DsScheduleModifier}),n.d(t,"DsScheduleTypeCustom",function(){return i.DsScheduleTypeCustom}),n.d(t,"DsScheduleTypeCustomDialog",function(){return i.DsScheduleTypeCustomDialog}),n.d(t,"DsScheduleFrequency",function(){return i.DsScheduleFrequency}),n.d(t,"DsScheduleFrequencyDay",function(){return i.DsScheduleFrequencyDay}),n.d(t,"DsScheduleFrequencyWeek",function(){return i.DsScheduleFrequencyWeek}),n.d(t,"DsScheduleFrequencyYear",function(){return i.DsScheduleFrequencyYear}),n.d(t,"DsScheduleFrequencyMonth",function(){return i.DsScheduleFrequencyMonth}),n.d(t,"DsScheduleFrequencyDayOfWeek",function(){return i.DsScheduleFrequencyDayOfWeek}),n.d(t,"DsWeeksView",function(){return i.DsWeeksView}),n.d(t,"DsWeekHeader",function(){return i.DsWeekHeader}),n.d(t,"DsWeekDayHeader",function(){return i.DsWeekDayHeader}),n.d(t,"DsIdentifierChip",function(){return i.DsIdentifierChip}),t.default=s.a},function(e,t,n){"use strict";t.a={promptLabels:{actionRemove:"Are you sure you want to remove this event?",actionExclude:"Are you sure you want to remove this event occurrence?",actionCancel:"Are you sure you want to cancel this event?",actionUncancel:"Are you sure you want to uncancel this event?",actionSetStart:"Are you sure you want to set this occurrence as the first?",actionSetEnd:"Are you sure you want to set this occurrence as the last?",actionMove:"Are you sure you want to move this event?",actionInclude:"Are you sure you want to add an event occurrence?",move:"Are you sure you want to move this event?",toggleAllDay:"Are you sure you want to change whether this event occurs all day?",removeExistingTime:"Are you sure you want to remove all event occurrences at this time?"},placeholder:{noTitle:"(no title)"},patterns:{lastDay:function(e){return"Last day of the month"},lastDayOfMonth:function(e){return"Last day of "+e.format("MMMM")},lastWeekday:function(e){return"Last "+e.format("dddd")+" in "+e.format("MMMM")}},colors:[{text:"Red"},{text:"Pink"},{text:"Purple"},{text:"Deep Purple"},{text:"Indigo"},{text:"Blue"},{text:"Glue"},{text:"Light Blue"},{text:"Cyan"},{text:"Teal"},{text:"Green"},{text:"Light Green"},{text:"Lime"},{text:"Yellow"},{text:"Amber"},{text:"Orange"},{text:"Deep Orange"},{text:"Brown"},{text:"Blue Gray"},{text:"Gray"},{text:"Black"}],icons:[{text:"Alarm"},{text:"Star"},{text:"Love"},{text:"Action"},{text:"Assignment"},{text:"Warning"},{text:"Money"},{text:"Charge"},{text:"Home"},{text:"Play"},{text:"Email"},{text:"Phone"},{text:"Chart"},{text:"Biking"},{text:"Travel"}],defaults:{dsDay:{formats:{month:"MMM"}},dsCalendarApp:{types:[{label:"Day"},{label:"Week"},{label:"Month"},{label:"Year"},{label:"Schedule"},{label:"4 days"}],formats:{today:"dddd, MMMM D",xs:"MMM"},labels:{next:function(e){return e?"Next "+e.label.toLowerCase():"Next"},prev:function(e){return e?"Previous "+e.label.toLowerCase():"Previous"},moveCancel:"Cancel move",moveSingleEvent:"Move event",moveOccurrence:"Move just this event occurrence",moveAll:"Move all event occurrences",moveDuplicate:"Add event occurrence",promptConfirm:"Yes",promptCancel:"No",today:"TODAY"}},dsAgendaEvent:{formats:{firstLine:"ddd",secondLine:"MMM Do",start:"dddd, MMMM D",time:"h:mm a"},labels:{allDay:"All day",options:"Options",close:"Close",day:["day","days"],days:["day","days"],minute:["minute","minutes"],minutes:["minute","minutes"],hour:["hour","hours"],hours:["hour","hours"],week:["week","weeks"],weeks:["week","weeks"],second:["second","seconds"],seconds:["second","seconds"],busy:"Busy",free:"Free"}},dsCalendarEventChip:{formats:{fullDay:"ddd MMM Do YYYY",timed:"ddd MMM Do YYYY"}},dsCalendarEventPopover:{formats:{start:"dddd, MMMM D",time:"h:mm a"},labels:{allDay:"All day",options:"Options",close:"Close",day:["day","days"],days:["day","days"],minute:["minute","minutes"],minutes:["minute","minutes"],hour:["hour","hours"],hours:["hour","hours"],week:["week","weeks"],weeks:["week","weeks"],second:["second","seconds"],seconds:["second","seconds"],busy:"Busy",free:"Free"}},dsCalendarEventCreatePopover:{formats:{start:"dddd, MMMM D",time:"h:mm a"},labels:{title:"Add title",allDay:"All day",close:"Close",save:"Save",day:["day","days"],days:["day","days"],minute:["minute","minutes"],minutes:["minute","minutes"],hour:["hour","hours"],hours:["hour","hours"],week:["week","weeks"],weeks:["week","weeks"],second:["second","seconds"],seconds:["second","seconds"],busy:"Busy",free:"Free",location:"Add location",description:"Add description",calendar:"Calendar"},busyOptions:[{text:"Busy"},{text:"Free"}]},dsSchedule:{labels:{editCustom:"Edit"}},dsEvent:{labels:{moreActions:"More actions...",cancel:"Cancel event changes",save:"Save",title:"Title",exclusions:"These are events or spans of time where a normally occurring event was excluded from the schedule. Events are excluded here if an event occurrence is moved.",inclusions:"These are events or spans of time where events were added outside the normally occurring schedule. Events are added here if an event occurrence is moved.",cancelled:"These are events or spans of time where events were cancelled.",edit:"Edit event",add:"Add event",location:"Add location",description:"Add description",calendar:"Calendar",tabs:{details:"Event Details",forecast:"Forecast",removed:"Removed",added:"Added",cancelled:"Cancelled"}},busyOptions:[{text:"Busy"},{text:"Free"}]},dsScheduleActions:{labels:{remove:"Remove this event",exclude:"Remove this occurrence",cancel:"Cancel this occurrence",uncancel:"Undo cancellation",move:"Move this occurrence",include:"Add new occurrence",setStart:"Set as first occurrence",setEnd:"Set as last occurrence",pickerOk:"OK",pickerCancel:"Cancel"}},dsScheduleForecast:{labels:{prefix:"The forecast shows previous & next",suffix:"event occurrences within a years time."}},dsScheduleFrequencyDay:{labels:{type:"Days"},options:[{text:"Any day"},{text:"On the following days..."},{text:"Every _ days starting on _"}],types:[{text:"Day of the month"},{text:"Last day of the month"},{text:"Day of the year"}]},dsScheduleFrequencyDayOfWeek:{weekdays:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],labels:{type:"Days of week"},options:[{text:"Any day of the week"},{text:"On the following days of the week..."},{text:"Every _ weekday starting on _"},{text:"Weekends"},{text:"Weekdays"}]},dsScheduleFrequencyMonth:{labels:{type:"Months"},months:["January","February","March","April","May","June","July","August","September","October","November","December"],options:[{text:"Any month"},{text:"On the following months..."},{text:"Every _ months starting on _"}]},dsScheduleFrequencyWeek:{labels:{type:"Weeks"},options:[{text:"Any week"},{text:"On the following weeks..."},{text:"Every _ weeks starting on _"}],types:[{text:"Week of the month (first week has a Thursday)"},{text:"Weekspan of the month (starts on first day of month)"},{text:"Full week of the month (0th = the week before if any)"},{text:"Last weekspan of the month (starts on last day of month)"},{text:"Last full week of the month (0th = the week after if any)"},{text:"Week of the year (first week has a Thursday)"},{text:"Weekspan of the year (starts on first day of year)"},{text:"Full week of the year (0th = the week before if any)"},{text:"Last weekspan of the year (starts on last day of year)"},{text:"Last full week of the year (0th = the week after if any)"}]},dsScheduleFrequencyYear:{labels:{type:"Years"},options:[{text:"Any year"},{text:"On the following years..."},{text:"Every _ years starting on _"}]},dsScheduleSpan:{labels:{startless:"Beginning of Time",endless:"End of Time"},formats:{start:"MMMM Do, YYYY",end:"MMMM Do, YYYY"}},dsScheduleTime:{labels:{remove:"Remove time",add:"Add time"}},dsScheduleTimes:{labels:{all:"All day",minute:"minute",minutes:"minutes",hour:"hour",hours:"hours",day:"day",days:"days",week:"week",weeks:"weeks",month:"month",months:"months",second:"second",seconds:"seconds"}},dsScheduleType:{formats:{date:"LL"}},dsScheduleTypeCustomDialog:{labels:{save:"Save",cancel:"Cancel"}},dsWeekDayHeader:{formats:{weekday:"ddd"}},dsWeeksView:{weekdays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},dsDaysView:{hours:["    ","1am","2am","3am","4am","5am","6am","7am","8am","9am","10am","11am","12pm","1pm","2pm","3pm","4pm","5pm","6pm","7pm","8pm","9pm","10pm","11pm"]},dsDayPicker:{weekdays:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],labels:{prevMonth:"Previous month",nextMonth:"Next month"}}}}},function(e,t,n){"use strict";n.d(t,"b",function(){return s});var a=n(57);n(59);t.a={en:a.a,"en-US":a.a};var s="en"},function(e,t,n){"use strict"},function(e,t,n){e.exports={default:n(62),__esModule:!0}},function(e,t,n){"use strict";t.__esModule=!0;var a=n(60),s=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default=function(e,t,n){return t in e?(0,s.default)(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},function(e,t,n){n(73);var a=n(7).Object;e.exports=function(e,t,n){return a.defineProperty(e,t,n)}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){var a=n(4);e.exports=function(e){if(!a(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){var a=n(63);e.exports=function(e,t,n){if(a(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,a){return e.call(t,n,a)};case 3:return function(n,a,s){return e.call(t,n,a,s)}}return function(){return e.apply(t,arguments)}}},function(e,t,n){var a=n(4),s=n(9).document,i=a(s)&&a(s.createElement);e.exports=function(e){return i?s.createElement(e):{}}},function(e,t,n){var a=n(9),s=n(7),i=n(65),r=n(69),l=n(68),o=function(e,t,n){var d,c,u,h=e&o.F,v=e&o.G,f=e&o.S,p=e&o.P,y=e&o.B,m=e&o.W,_=v?s:s[t]||(s[t]={}),g=_.prototype,b=v?a:f?a[t]:(a[t]||{}).prototype;v&&(n=t);for(d in n)(c=!h&&b&&void 0!==b[d])&&l(_,d)||(u=c?b[d]:n[d],_[d]=v&&"function"!=typeof b[d]?n[d]:y&&c?i(u,a):m&&b[d]==u?function(e){var t=function(t,n,a){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,a)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(u):p&&"function"==typeof u?i(Function.call,u):u,p&&((_.virtual||(_.virtual={}))[d]=u,e&o.R&&g&&!g[d]&&r(g,d,u)))};o.F=1,o.G=2,o.S=4,o.P=8,o.B=16,o.W=32,o.U=64,o.R=128,e.exports=o},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var a=n(10),s=n(71);e.exports=n(3)?function(e,t,n){return a.f(e,t,s(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){e.exports=!n(3)&&!n(8)(function(){return 7!=Object.defineProperty(n(66)("div"),"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var a=n(4);e.exports=function(e,t){if(!a(e))return e;var n,s;if(t&&"function"==typeof(n=e.toString)&&!a(s=n.call(e)))return s;if("function"==typeof(n=e.valueOf)&&!a(s=n.call(e)))return s;if(!t&&"function"==typeof(n=e.toString)&&!a(s=n.call(e)))return s;throw TypeError("Can't convert object to primitive value")}},function(e,t,n){var a=n(67);a(a.S+a.F*!n(3),"Object",{defineProperty:n(10).f})},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){function a(e){n(103)}var s=n(1)(n(13),n(181),a,"data-v-8262ea58",null);e.exports=s.exports},function(e,t,n){function a(e){n(97)}var s=n(1)(n(14),n(175),a,"data-v-64bbe350",null);e.exports=s.exports},function(e,t,n){function a(e){n(91)}var s=n(1)(n(15),n(169),a,"data-v-52125556",null);e.exports=s.exports},function(e,t,n){function a(e){n(92)}var s=n(1)(n(16),n(170),a,"data-v-5325b506",null);e.exports=s.exports},function(e,t,n){function a(e){n(93)}var s=n(1)(n(17),n(171),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(87)}var s=n(1)(n(18),n(165),a,"data-v-46108b38",null);e.exports=s.exports},function(e,t,n){function a(e){n(94)}var s=n(1)(n(19),n(172),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(78)}var s=n(1)(n(20),n(156),a,"data-v-0b314bb5",null);e.exports=s.exports},function(e,t,n){function a(e){n(82)}var s=n(1)(n(21),n(160),a,"data-v-26705f1f",null);e.exports=s.exports},function(e,t,n){function a(e){n(99)}var s=n(1)(n(22),n(177),a,"data-v-7461b951",null);e.exports=s.exports},function(e,t,n){function a(e){n(102)}var s=n(1)(n(23),n(180),a,"data-v-7a377cd1",null);e.exports=s.exports},function(e,t,n){function a(e){n(75)}var s=n(1)(n(24),n(153),a,"data-v-01c6c692",null);e.exports=s.exports},function(e,t,n){function a(e){n(89)}var s=n(1)(n(25),n(167),a,"data-v-4c181404",null);e.exports=s.exports},function(e,t,n){function a(e){n(85)}var s=n(1)(n(26),n(163),a,"data-v-36e040b2",null);e.exports=s.exports},function(e,t,n){function a(e){n(112)}var s=n(1)(n(27),n(190),a,"data-v-eb16c334",null);e.exports=s.exports},function(e,t,n){function a(e){n(101)}var s=n(1)(n(28),n(179),a,"data-v-74cb2e5c",null);e.exports=s.exports},function(e,t,n){function a(e){n(83)}var s=n(1)(n(29),n(161),a,"data-v-30ccf664",null);e.exports=s.exports},function(e,t,n){function a(e){n(77)}var s=n(1)(n(30),n(155),a,"data-v-0b1da002",null);e.exports=s.exports},function(e,t,n){function a(e){n(95)}var s=n(1)(n(31),n(173),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(84)}var s=n(1)(n(32),n(162),a,"data-v-33b6bfdc",null);e.exports=s.exports},function(e,t,n){function a(e){n(88)}var s=n(1)(n(33),n(166),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(106)}var s=n(1)(n(34),n(184),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(110)}var s=n(1)(n(35),n(188),a,"data-v-e0472c64",null);e.exports=s.exports},function(e,t,n){function a(e){n(98)}var s=n(1)(n(36),n(176),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(96)}var s=n(1)(n(37),n(174),a,"data-v-602b721f",null);e.exports=s.exports},function(e,t,n){function a(e){n(74)}var s=n(1)(n(38),n(152),a,"data-v-01507dea",null);e.exports=s.exports},function(e,t,n){function a(e){n(80)}var s=n(1)(n(39),n(158),a,"data-v-18793043",null);e.exports=s.exports},function(e,t,n){function a(e){n(79)}var s=n(1)(n(40),n(157),a,"data-v-0fac0c01",null);e.exports=s.exports},function(e,t,n){function a(e){n(90)}var s=n(1)(n(41),n(168),a,"data-v-4e04b06c",null);e.exports=s.exports},function(e,t,n){function a(e){n(104)}var s=n(1)(n(42),n(182),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(107)}var s=n(1)(n(43),n(185),a,"data-v-b104ba6e",null);e.exports=s.exports},function(e,t,n){function a(e){n(105)}var s=n(1)(n(44),n(183),a,"data-v-9de2f668",null);e.exports=s.exports},function(e,t,n){function a(e){n(100)}var s=n(1)(n(45),n(178),a,"data-v-746db5d7",null);e.exports=s.exports},function(e,t,n){function a(e){n(76)}var s=n(1)(n(46),n(154),a,"data-v-0490c2b9",null);e.exports=s.exports},function(e,t,n){function a(e){n(111)}var s=n(1)(n(47),n(189),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(109)}var s=n(1)(n(48),n(187),a,null,null);e.exports=s.exports},function(e,t,n){function a(e){n(81)}var s=n(1)(n(49),n(159),a,"data-v-238290c6",null);e.exports=s.exports},function(e,t,n){function a(e){n(108)}var s=n(1)(n(50),n(186),a,"data-v-dc94a82e",null);e.exports=s.exports},function(e,t,n){function a(e){n(86)}var s=n(1)(n(51),n(164),a,"data-v-45f856ac",null);e.exports=s.exports},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-layout",{attrs:{row:"",wrap:""}},[n("v-flex",{attrs:{xs7:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",label:e.labels.type,items:e.options},model:{value:e.type,callback:function(t){e.type=t},expression:"type"}})],1),e._v(" "),e.isSimple?n("v-flex",{attrs:{xs5:""}}):e._e(),e._v(" "),e.isOneOf?n("v-flex",{staticClass:"pl-1",attrs:{xs5:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",multiple:"",items:e.oneOfs},model:{value:e.frequency,callback:function(t){e.frequency=t},expression:"frequency"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs2:""}},[n("v-text-field",{attrs:{type:"number","hide-details":"",solo:"",flat:""},model:{value:e.frequency.every,callback:function(t){e.$set(e.frequency,"every",e._n(t))},expression:"frequency.every"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs3:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",items:e.offsets},model:{value:e.frequency.offset,callback:function(t){e.$set(e.frequency,"offset",e._n(t))},expression:"frequency.offset"}})],1):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-menu",e._b({staticClass:"ds-calendar-event-placeholder",attrs:{"content-class":e.contentClass,disabled:!e.hasPopover},model:{value:e.menu,callback:function(t){e.menu=t},expression:"menu"}},"v-menu",e.popoverProps,!1),[n("ds-calendar-event-time",e._b({attrs:{slot:"activator","is-placeholder-with-day":e.day,"calendar-event":e.placeholder,calendar:e.calendar},slot:"activator"},"ds-calendar-event-time",{$scopedSlots:e.$scopedSlots},!1)),e._v(" "),e._t("eventCreatePopover",null,null,{placeholder:e.placeholder,calendar:e.calendar,day:e.day,close:e.close})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("v-select",{attrs:{"single-line":"",solo:"",flat:"","persistent-hint":"",items:e.types,hint:e.typeHint,"hide-details":e.hideHint,"append-outer-icon":e.customIcon,disabled:e.isReadOnly,"item-text":"label","item-value":"value"},on:{"click:append-outer":e.custom},model:{value:e.type,callback:function(t){e.type=t},expression:"type"}})},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-event",class:e.classes},[n("div",{staticClass:"ds-event-header ds-event-area"},[e.hasCancel?n("div",{staticClass:"ds-event-cancel"},[e._t("scheduleCancel",[n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"ds-button",attrs:{slot:"activator",icon:""},on:{click:e.cancel},slot:"activator"},[n("v-icon",{attrs:{dark:""}},[e._v("clear")])],1),e._v(" "),n("span",{domProps:{innerHTML:e._s(e.labels.cancel)}})],1)],null,{cancel:e.cancel,labels:e.labels})],2):e._e(),e._v(" "),n("div",{staticClass:"ds-event-actions"},[e._t("scheduleSave",[e.isReadOnly?e._e():n("v-btn",{staticClass:"ds-button-tall ml-3 mt-0 mb-2",attrs:{depressed:"",color:"primary",disabled:!e.canSave},on:{click:function(t){return t.stopPropagation(),e.save(t)}}},[n("span",{domProps:{innerHTML:e._s(e.labels.save)}})])],null,{hasSave:e.hasSave,save:e.save,labels:e.labels,readOnly:e.readOnly}),e._v(" "),e._t("scheduleActions",[e.calendarEvent&&!e.isReadOnly?n("ds-schedule-actions",e._g(e._b({attrs:{schedule:e.schedule,"calendar-event":e.calendarEvent,calendar:e.calendar},on:{finish:e.actioned}},"ds-schedule-actions",{$scopedSlots:e.$scopedSlots},!1),e.$listeners),[n("v-btn",{staticClass:"ds-button-tall ml-1 mt-0 mb-2",attrs:{depressed:""}},[e._v("\n             "+e._s(e.labels.moreActions)+"\n          ")])],1):e._e()],null,{calendarEvent:e.calendarEvent,schedule:e.schedule,calendar:e.calendar,actioned:e.actioned,readOnly:e.readOnly})],2),e._v(" "),e._t("scheduleTitle",[n("v-text-field",{staticClass:"ds-event-title",attrs:{"single-line":"","hide-details":"",solo:"",flat:"",label:e.labels.title,readonly:e.isReadOnly},model:{value:e.details.title,callback:function(t){e.$set(e.details,"title",t)},expression:"details.title"}})],null,{schedule:e.schedule,schedule:e.schedule,calendarEvent:e.calendarEvent,details:e.details})],2),e._v(" "),n("div",{staticClass:"ds-event-body ds-event-area"},[e._t("schedule",[n("ds-schedule",{attrs:{schedule:e.schedule,day:e.day,"read-only":e.readOnly}})],null,e.slotData)],2),e._v(" "),e.hasTabs?n("v-layout",{attrs:{row:""}},[n("v-flex",{staticClass:"mt-2",attrs:{xs12:""}},[n("v-tabs",{staticClass:"text--primary",model:{value:e.tab,callback:function(t){e.tab=t},expression:"tab"}},[e.hasDetails?n("v-tab",{attrs:{href:"#details"}},[e._v("\n          "+e._s(e.labels.tabs.details)+"\n        ")]):e._e(),e._v(" "),e.showForecast?n("v-tab",{attrs:{href:"#forecast"}},[e._v("\n          "+e._s(e.labels.tabs.forecast)+"\n        ")]):e._e(),e._v(" "),e.showExclusions?n("v-tab",{attrs:{href:"#exclusions"}},[e._v("\n          "+e._s(e.labels.tabs.removed)+"\n        ")]):e._e(),e._v(" "),e.showInclusions?n("v-tab",{attrs:{href:"#inclusions"}},[e._v("\n          "+e._s(e.labels.tabs.added)+"\n        ")]):e._e(),e._v(" "),e.showCancels?n("v-tab",{attrs:{href:"#cancelled"}},[e._v("\n          "+e._s(e.labels.tabs.cancelled)+"\n        ")]):e._e(),e._v(" "),e._t("eventTabsExtra",null,null,e.slotData),e._v(" "),e.hasDetails?n("v-tab-item",{attrs:{value:"details"}},[n("v-card",{attrs:{flat:""}},[n("v-card-text",[e._t("eventDetailsLocation",[e.$dayspan.supports.location?n("v-text-field",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","prepend-icon":"location_on",label:e.labels.location,readonly:e.isReadOnly},model:{value:e.details.location,callback:function(t){e.$set(e.details,"location",t)},expression:"details.location"}}):e._e()],null,e.slotData),e._v(" "),e._t("eventDetailsDescription",[e.$dayspan.supports.description?n("v-textarea",{attrs:{"hide-details":"","single-line":"",solo:"",flat:"","prepend-icon":"subject",label:e.labels.description,readonly:e.isReadOnly},model:{value:e.details.description,callback:function(t){e.$set(e.details,"description",t)},expression:"details.description"}}):e._e()],null,e.slotData),e._v(" "),e._t("eventDetailsCalendar",[e.$dayspan.supports.calendar?n("v-text-field",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"",readonly:"","prepend-icon":"event",label:e.labels.calendar,readonly:e.isReadOnly},model:{value:e.details.calendar,callback:function(t){e.$set(e.details,"calendar",t)},expression:"details.calendar"}}):e._e()],null,e.slotData),e._v(" "),e._t("eventDetailsColor",[e.$dayspan.supports.color?n("v-select",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","prepend-icon":"invert_colors",items:e.$dayspan.colors,color:e.details.color,disabled:e.isReadOnly},scopedSlots:e._u([{key:"item",fn:function(t){var a=t.item;return[n("v-list-tile-content",[n("div",{staticClass:"ds-color-option",style:{backgroundColor:a.value},domProps:{textContent:e._s(a.text)}})])]}}]),model:{value:e.details.color,callback:function(t){e.$set(e.details,"color",t)},expression:"details.color"}}):e._e()],null,e.slotData),e._v(" "),e._t("eventDetailsIcon",[e.$dayspan.supports.icon?n("v-select",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","prepend-icon":e.details.icon||"help",items:e.$dayspan.icons,disabled:e.isReadOnly},scopedSlots:e._u([{key:"item",fn:function(t){var a=t.item;return[n("v-list-tile-avatar",[n("v-icon",[e._v(e._s(a.value))])],1),e._v(" "),n("v-list-tile-content",[e._v("\n                      "+e._s(a.text)+"\n                    ")])]}}]),model:{value:e.details.icon,callback:function(t){e.$set(e.details,"icon",t)},expression:"details.icon"}}):e._e()],null,e.slotData),e._v(" "),e._t("eventDetailsBusy",[e.$dayspan.supports.busy?n("v-select",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","prepend-icon":"work",items:e.busyOptions,disabled:e.isReadOnly},model:{value:e.details.busy,callback:function(t){e.$set(e.details,"busy",t)},expression:"details.busy"}}):e._e()],null,e.slotData),e._v(" "),e._t("eventDetailsExtra",null,null,e.slotData)],2)],1)],1):e._e(),e._v(" "),e.showForecast?n("v-tab-item",{attrs:{value:"forecast",lazy:""}},[n("v-card",{attrs:{flat:""}},[n("v-card-text",[e._t("eventForecast",[n("ds-schedule-forecast",{attrs:{schedule:e.schedule,day:e.day,"read-only":e.readOnly}})],null,e.slotData)],2)],1)],1):e._e(),e._v(" "),e.showExclusions?n("v-tab-item",{attrs:{value:"exclusions",lazy:""}},[n("v-card",{attrs:{flat:""}},[n("v-card-text",[e._t("eventExclusions",[n("ds-schedule-modifier",{attrs:{description:e.labels.exclusions,modifier:e.schedule.exclude,"read-only":e.readOnly}})],null,e.slotData)],2)],1)],1):e._e(),e._v(" "),e.showInclusions?n("v-tab-item",{attrs:{value:"inclusions",lazy:""}},[n("v-card",{attrs:{flat:""}},[n("v-card-text",[e._t("eventInclusions",[n("ds-schedule-modifier",{attrs:{description:e.labels.inclusions,modifier:e.schedule.include,"read-only":e.readOnly}})],null,e.slotData)],2)],1)],1):e._e(),e._v(" "),e.showCancels?n("v-tab-item",{attrs:{value:"cancelled",lazy:""}},[n("v-card",{attrs:{flat:""}},[n("v-card-text",[e._t("eventCancels",[n("ds-schedule-modifier",{attrs:{description:e.labels.cancelled,modifier:e.schedule.cancel,"read-only":e.readOnly}})],null,e.slotData)],2)],1)],1):e._e(),e._v(" "),e._t("eventTabItemsExtra",null,null,e.slotData)],2)],1)],1):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-card",{staticClass:"ds-calendar-event-popover-card",class:e.classes},[n("v-toolbar",{style:e.styleHeader,attrs:{extended:"",flat:""}},[n("v-toolbar-title",{attrs:{slot:"extension"},slot:"extension"},[n("v-text-field",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"",autofocus:"",label:e.labels.title},model:{value:e.details.title,callback:function(t){e.$set(e.details,"title",t)},expression:"details.title"}})],1),e._v(" "),e.details.readonly?e._e():n("v-btn",{attrs:{color:"secondary",small:"",absolute:"",bottom:"",left:"",fab:"",icon:""},on:{click:e.edit}},[n("v-icon",[e._v(e._s(e.icons.edit))])],1),e._v(" "),e._t("eventCreatePopoverToolbarLeft",null,null,e.slotData),e._v(" "),n("v-spacer"),e._v(" "),e._t("eventCreatePopoverToolbarRight",null,null,e.slotData),e._v(" "),e._t("eventCreatePopoverToolbarSave",[n("v-btn",{staticClass:"ds-create-popover-save",style:e.styleText,attrs:{flat:"",disabled:!e.isValid},on:{click:e.save}},[n("v-icon",{attrs:{left:""}},[e._v(e._s(e.icons.save))]),e._v(" "),n("span",[e._v(e._s(e.labels.save))])],1)],null,e.slotData),e._v(" "),e._t("eventCreatePopoverToolbarClose",[n("v-btn",{style:e.styleText,attrs:{icon:""},on:{click:e.close}},[n("v-icon",[e._v(e._s(e.icons.close))])],1)],null,e.slotData)],2),e._v(" "),n("v-card-text",[e._t("eventCreatePopoverBodyTop",null,null,e.slotData),e._v(" "),n("v-list",[n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("access_time")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventCreatePopoverOccurs",[n("v-list-tile-title",[e._v(e._s(e.startDate))]),e._v(" "),n("v-list-tile-sub-title",[e._v(e._s(e.occurs))])],null,e.slotData)],2)],1),e._v(" "),e.prompts.location&&e.$dayspan.supports.location?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("location_on")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventCreatePopoverLocation",[n("v-text-field",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","full-width":"",label:e.labels.location},model:{value:e.details.location,callback:function(t){e.$set(e.details,"location",t)},expression:"details.location"}})],null,e.slotData)],2)],1):e._e(),e._v(" "),e.prompts.description&&e.$dayspan.supports.description?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("subject")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventCreatePopoverDescription",[n("v-textarea",{attrs:{"hide-details":"","single-line":"",solo:"",flat:"","full-width":"",label:e.labels.description},model:{value:e.details.description,callback:function(t){e.$set(e.details,"description",t)},expression:"details.description"}})],null,e.slotData)],2)],1):e._e(),e._v(" "),e.prompts.calendar&&e.$dayspan.supports.calendar?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("event")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventCreatePopoverCalendar",[n("v-text-field",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","full-width":"",label:e.labels.calendar},model:{value:e.details.calendar,callback:function(t){e.$set(e.details,"calendar",t)},expression:"details.calendar"}})],null,e.slotData)],2)],1):e._e(),e._v(" "),e.prompts.color&&e.$dayspan.supports.color?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("invert_colors")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventCreatePopoverColor",[n("v-select",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","full-width":"",items:e.$dayspan.colors,color:e.details.color},scopedSlots:e._u([{key:"item",fn:function(t){var a=t.item;return[n("v-list-tile-content",[n("div",{staticClass:"ds-color-option",style:{backgroundColor:a.value},domProps:{textContent:e._s(a.text)}})])]}}]),model:{value:e.details.color,callback:function(t){e.$set(e.details,"color",t)},expression:"details.color"}})],null,e.slotData)],2)],1):e._e(),e._v(" "),e.prompts.icon&&e.$dayspan.supports.icon?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v(e._s(e.details.icon||"help"))])],1),e._v(" "),n("v-list-tile-content",[e._t("eventCreatePopoverIcon",[n("v-select",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","full-width":"",items:e.$dayspan.icons},scopedSlots:e._u([{key:"item",fn:function(t){var a=t.item;return[n("v-list-tile-avatar",[n("v-icon",[e._v(e._s(a.value))])],1),e._v(" "),n("v-list-tile-content",[e._v("\n                "+e._s(a.text)+"\n              ")])]}}]),model:{value:e.details.icon,callback:function(t){e.$set(e.details,"icon",t)},expression:"details.icon"}})],null,e.slotData)],2)],1):e._e(),e._v(" "),e.prompts.busy&&e.$dayspan.supports.busy?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("work")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventCreatePopoverBusy",[n("v-select",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"","full-width":"",items:e.busyOptions},model:{value:e.details.busy,callback:function(t){e.$set(e.details,"busy",t)},expression:"details.busy"}})],null,e.slotData)],2)],1):e._e()],1),e._v(" "),e._t("eventCreatePopoverBodyBottom",null,null,e.slotData)],2),e._v(" "),e._t("eventCreatePopoverActions",null,null,e.slotData)],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-layout",{attrs:{row:"",wrap:""}},[n("v-flex",{attrs:{xs7:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",label:e.labels.type,items:e.options},model:{value:e.type,callback:function(t){e.type=t},expression:"type"}})],1),e._v(" "),e.isAny?n("v-flex",{attrs:{xs5:""}}):e._e(),e._v(" "),e.isAny?e._e():n("v-flex",{staticClass:"pl-1",attrs:{xs5:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"","return-object":"",items:e.types},model:{value:e.chosenType,callback:function(t){e.chosenType=t},expression:"chosenType"}})],1),e._v(" "),e.isOneOf?n("v-flex",{staticClass:"pl-1",attrs:{xs5:"","offset-xs7":""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",multiple:"",items:e.oneOfs},model:{value:e.frequency,callback:function(t){e.frequency=t},expression:"frequency"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs2:"","offset-xs7":""}},[n("v-text-field",{attrs:{type:"number","hide-details":"",solo:"",flat:""},model:{value:e.frequency.every,callback:function(t){e.$set(e.frequency,"every",e._n(t))},expression:"frequency.every"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs3:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",items:e.offsets},model:{value:e.frequency.offset,callback:function(t){e.$set(e.frequency,"offset",e._n(t))},expression:"frequency.offset"}})],1):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-layout",{attrs:{row:"",wrap:""}},[n("v-flex",{attrs:{xs7:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",label:e.labels.type,items:e.options},model:{value:e.type,callback:function(t){e.type=t},expression:"type"}})],1),e._v(" "),e.isAny?n("v-flex",{attrs:{xs5:""}}):e._e(),e._v(" "),e.isOneOf?n("v-flex",{staticClass:"pl-1",attrs:{xs5:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",multiple:"",items:e.oneOfs},model:{value:e.frequency,callback:function(t){e.frequency=t},expression:"frequency"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs2:""}},[n("v-text-field",{attrs:{type:"number","hide-details":"",solo:"",flat:""},model:{value:e.frequency.every,callback:function(t){e.$set(e.frequency,"every",e._n(t))},expression:"frequency.every"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs3:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",items:e.offsets},model:{value:e.frequency.offset,callback:function(t){e.$set(e.frequency,"offset",e._n(t))},expression:"frequency.offset"}})],1):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-day",class:e.classesDay,on:{mouseenter:e.mouseEnterDay,mouseleave:e.mouseLeaveDay,mousemove:function(t){return t.stopPropagation(),e.mouseMoveDay(t)},mousedown:e.mouseDownDay,mouseup:e.mouseUpDay,click:function(t){return t.stopPropagation(),e.add(t)},dragstart:function(e){e.preventDefault()}}},[n("div",{staticClass:"ds-week-weekday"},[e._v("\n    "+e._s(e.weekday)+"\n  ")]),e._v(" "),n("a",{staticClass:"ds-week-date",on:{click:function(t){return t.stopPropagation(),t.preventDefault(),e.viewDay(t)},mousedown:function(e){e.stopPropagation()}}},[e._v("\n    "+e._s(e.dayOfMonth)+"\n  ")]),e._v(" "),n("div",{staticClass:"ds-all-events"},[e._l(e.visibleEvents,function(t,a){return[n("ds-calendar-event",e._g(e._b({key:t.id,attrs:{"calendar-event":t,index:a,calendar:e.calendar}},"ds-calendar-event",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))]}),e._v(" "),e.hasPlaceholder?n("div",[n("ds-calendar-event-placeholder",e._g(e._b({attrs:{day:e.day,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate,calendar:e.calendar,index:e.visibleEvents.length}},"ds-calendar-event-placeholder",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],1):e._e()],2)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-menu",e._b({staticClass:"ds-calendar-event-menu",attrs:{"content-class":e.contentClass,disabled:!e.hasPopover},model:{value:e.menu,callback:function(t){e.menu=t},expression:"menu"}},"v-menu",e.popoverProps,!1),[n("ds-calendar-event",e._b({attrs:{slot:"activator","is-placeholder-with-day":e.day,"calendar-event":e.placeholder,calendar:e.calendar,index:e.index},slot:"activator"},"ds-calendar-event",{$scopedSlots:e.$scopedSlots},!1)),e._v(" "),e._t("eventCreatePopover",null,null,{placeholder:e.placeholder,calendar:e.calendar,day:e.day,index:e.index,close:e.close})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-week-view-container"},[n("ds-week-header",e._g(e._b({attrs:{calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate,days:e.calendar.days,"scroll-push":e.scrollPush}},"ds-week-header",{$scopedSlots:e.$scopedSlots},!1),e.$listeners)),e._v(" "),n("div",{staticClass:"ds-week-view-bottom"},[n("div",{ref:"scrollArea",staticClass:"ds-week-view-scrollable"},[n("div",{ref:"pane",staticClass:"ds-week-view-pane",style:e.dayHeight},[n("div",{staticClass:"ds-week"},[n("div",{staticClass:"ds-hour-list"},e._l(e.hours,function(t,a){return n("div",{staticClass:"ds-hour",class:e.hourClasses[a]},[n("div",{staticClass:"ds-hour-text"},[e._v(e._s(t))])])})),e._v(" "),e._l(e.calendar.days,function(t){return[n("ds-day-times",e._g(e._b({key:t.dayIdentifier,attrs:{day:t,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate,calendar:e.calendar}},"ds-day-times",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))]})],2)])])])],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("div",{staticClass:"ds-gesture-container",on:{touchstart:e.start,touchmove:e.move,touchend:e.end}},[e._t("default")],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-day-picker"},[n("div",{staticClass:"ds-week-header mb-2"},[n("div",{staticClass:"subtitle py-1 pl-2 ds-light-forecolor"},[e._v("\n      "+e._s(e.summary)+"\n    ")]),e._v(" "),n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"ds-light-forecolor ma-0",attrs:{slot:"activator",small:"",icon:"",depressed:""},on:{click:e.prev},slot:"activator"},[n("v-icon",[e._v("keyboard_arrow_left")])],1),e._v(" "),n("span",[e._v(e._s(e.labels.prevMonth))])],1),e._v(" "),n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"ds-light-forecolor ma-0",attrs:{slot:"activator",small:"",icon:"",depressed:""},on:{click:e.next},slot:"activator"},[n("v-icon",[e._v("keyboard_arrow_right")])],1),e._v(" "),n("span",[e._v(e._s(e.labels.nextMonth))])],1)],1),e._v(" "),n("div",{staticClass:"ds-week-subheader ds-light-forecolor"},e._l(e.weekdays,function(t){return n("div",{key:t,staticClass:"ds-weekday"},[n("v-tooltip",{attrs:{bottom:""}},[n("span",{attrs:{slot:"activator"},slot:"activator"},[e._v(e._s(t.charAt(0)))]),e._v(" "),n("span",[e._v(e._s(t))])])],1)})),e._v(" "),n("div",{staticClass:"ds-week"},e._l(e.month.days,function(t){return n("div",{key:t.dayIdentifier,staticClass:"ds-day-pick"},[n("v-btn",{staticClass:"ma-0",class:{"btn--active":t.currentDay,"ds-light-forecolor":!t.inCalendar,primary:e.isHighlighted(t)},attrs:{small:"",icon:"",depressed:""},on:{click:function(n){e.pick(t)}}},[e._v("\n        "+e._s(t.dayOfMonth)+"\n      ")])],1)}))])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-month"},[n("div",{staticClass:"ds-week-header"},e._l(e.weekdays,function(t,a){return n("div",{key:t,staticClass:"ds-week-header-day",class:e.weekdayClasses(a)},[e._v("\n\n      "+e._s(t)+"\n\n    ")])})),e._v(" "),e._l(e.rows,function(t){return n("ds-day-row",e._g(e._b({key:t,attrs:{days:e.daysAtRow(t,7),calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate}},"ds-day-row",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-menu",e._b({staticClass:"ds-calendar-event-menu",attrs:{"content-class":e.contentClass,disabled:!e.hasPopover},model:{value:e.menu,callback:function(t){e.menu=t},expression:"menu"}},"v-menu",e.popoverProps,!1),[n("div",{staticClass:"ds-calendar-event",style:e.style,attrs:{slot:"activator"},on:{click:function(t){return t.stopPropagation(),e.editCheck(t)},mouseenter:e.mouseEnterEvent,mouseleave:e.mouseLeaveEvent,mousedown:e.mouseDownEvent,mouseup:e.mouseUpEvent},slot:"activator"},[e.showName?n("span",[e._t("eventTitle",[e.hasIcon?n("v-icon",{staticClass:"ds-ev-icon",style:{color:e.details.forecolor},attrs:{size:"14"}},[e._v("\n          "+e._s(e.details.icon)+"\n        ")]):e._e(),e._v(" "),e.hasPrefix?n("span",[e._v("\n          "+e._s(e.getPrefix)+"\n        ")]):e._e(),e._v(" "),n("strong",{staticClass:"ds-ev-title"},[e._v(e._s(e.details.title))]),e._v(" "),n("span",{staticClass:"ds-ev-description"},[e._v(e._s(e.details.description))])],null,{calendarEvent:e.calendarEvent,hasPrefix:e.hasPrefix,getPrefix:e.getPrefix,details:e.details})],2):n("span",[e._t("eventEmpty",[e._v(" ")],null,{calendarEvent:e.calendarEvent,details:e.details})],2)]),e._v(" "),e._t("eventPopover",null,null,{calendarEvent:e.calendarEvent,calendar:e.calendar,edit:e.edit,details:e.details,close:e.close})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-chip",{attrs:{label:"",close:e.canRemove},on:{input:e.remove}},[n("strong",{domProps:{innerHTML:e._s(e.text)}}),e._v(" "),n("span",{domProps:{innerHTML:e._s(e.description)}})])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-day",class:e.classesDay,on:{mouseenter:e.mouseEnterDay,mouseleave:e.mouseLeaveDay,mousemove:function(t){return t.stopPropagation(),e.mouseMoveDay(t)},mousedown:e.mouseDownDay,mouseup:e.mouseUpDay,click:function(t){return t.stopPropagation(),e.add(t)},dragstart:function(e){e.preventDefault()}}},[n("div",{class:e.classesHeader},[n("a",{staticClass:"ds-dom",class:e.classesDayOfMonth,attrs:{href:""},on:{click:function(t){return t.stopPropagation(),t.preventDefault(),e.viewDay(t)},mousedown:function(e){e.stopPropagation()}}},[e._v("\n      "+e._s(e.dayOfMonth)+"\n    ")]),e._v(" "),e.showMonth?n("span",{staticClass:"ds-first-day"},[e._v("\n      "+e._s(e.month)+"\n    ")]):e._e()]),e._v(" "),e._l(e.visibleEvents,function(t,a){return[n("ds-calendar-event",e._g(e._b({key:t.id,attrs:{"calendar-event":t,calendar:e.calendar,index:a}},"ds-calendar-event",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))]}),e._v(" "),e.hasPlaceholder?n("div",[n("ds-calendar-event-placeholder",e._g(e._b({attrs:{day:e.day,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate,calendar:e.calendar,index:e.visibleEvents.length}},"ds-calendar-event-placeholder",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],1):e._e()],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-layout",{attrs:{row:"",wrap:""}},[n("v-flex",{attrs:{xs7:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",label:e.labels.type,items:e.options},model:{value:e.type,callback:function(t){e.type=t},expression:"type"}})],1),e._v(" "),e.isAny?n("v-flex",{attrs:{xs5:""}}):e._e(),e._v(" "),e.isOneOf?n("v-flex",{staticClass:"pl-1",attrs:{xs5:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",multiple:"",items:e.oneOfs},model:{value:e.frequency,callback:function(t){e.frequency=t},expression:"frequency"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs2:""}},[n("v-text-field",{attrs:{type:"number","hide-details":"",solo:"",flat:""},model:{value:e.frequency.every,callback:function(t){e.$set(e.frequency,"every",e._n(t))},expression:"frequency.every"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs3:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",items:e.offsets},model:{value:e.frequency.offset,callback:function(t){e.$set(e.frequency,"offset",e._n(t))},expression:"frequency.offset"}})],1):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("tr",{staticClass:"ds-agenda-event",class:e.classes},[e.first?n("td",{staticClass:"ds-agenda-lines",attrs:{rowspan:e.siblings}},[e._t("agendaDayDate",[n("div",{staticClass:"ds-agenda-line-first"},[e._v("\n        "+e._s(e.firstLine)+"\n      ")]),e._v(" "),n("div",{staticClass:"ds-agenda-line-second",on:{click:function(t){return t.stopPropagation(),e.viewDay(t)}}},[e._v("\n        "+e._s(e.secondLine)+"\n      ")])],null,e.slotData)],2):e._e(),e._v(" "),n("td",{staticClass:"ds-agenda-when",on:{click:function(e){e.stopPropagation()}}},[e._t("agendaEventWhen",[e._v("\n\n      "+e._s(e.when)+"\n\n    ")],null,e.slotData)],2),e._v(" "),n("td",{staticClass:"ds-agenda-details",on:{click:function(t){return t.stopPropagation(),e.editCheck(t)}}},[n("v-menu",e._b({staticClass:"ds-calendar-event-menu",attrs:{"content-class":e.contentClass,disabled:!e.hasPopover},model:{value:e.menu,callback:function(t){e.menu=t},expression:"menu"}},"v-menu",e.popoverProps,!1),[n("div",{staticClass:"ds-agenda-activator",attrs:{slot:"activator"},slot:"activator"},[e._t("agendaEventDetails",[e.details.icon?n("v-icon",{staticClass:"ds-details-icon",attrs:{size:"16"}},[e._v("\n            "+e._s(e.details.icon)+"\n          ")]):e._e(),e._v(" "),n("strong",{domProps:{innerHTML:e._s(e.details.title)}}),e._v(" "),n("span",{staticClass:"ds-details-description",domProps:{innerHTML:e._s(e.details.description)}})],null,e.slotData)],2),e._v(" "),e._t("eventPopover",null,null,{readOnly:e.readOnly,calendarEvent:e.calendarEvent,calendar:e.calendar,edit:e.edit,details:e.details,close:e.close})],2)],1)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-calendar"},[e.isYear?n("div",{staticClass:"ds-month-view ds-year-view"},[n("ds-weeks-view",e._g(e._b({staticClass:"ds-expand",attrs:{calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate},on:{"mouse-move-day":e.mouseMoveDay,"mouse-down-day":e.mouseDownDay,"mouse-up-day":e.mouseUp,"mouse-up-event":e.mouseUp,"mouse-down-event":e.mouseDownEvent,"clear-placeholder":e.clearPlaceholder}},"ds-weeks-view",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],1):e._e(),e._v(" "),e.isMonth?n("div",{staticClass:"ds-month-view"},[n("ds-weeks-view",e._g(e._b({staticClass:"ds-expand",attrs:{calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate},on:{"mouse-move-day":e.mouseMoveDay,"mouse-down-day":e.mouseDownDay,"mouse-up-day":e.mouseUp,"mouse-up-event":e.mouseUp,"mouse-down-event":e.mouseDownEvent,"clear-placeholder":e.clearPlaceholder}},"ds-weeks-view",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],1):e._e(),e._v(" "),e.isWeek||e.isDay?n("div",{staticClass:"ds-week-view"},[n("ds-days-view",e._g(e._b({attrs:{calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate},on:{"mouse-move":e.mouseMove,"mouse-down":e.mouseDown,"mouse-up":e.mouseUp,"mouse-down-event":e.mouseDownEvent,"mouse-move-day":e.mouseMoveDay,"mouse-down-day":e.mouseDownDay,"mouse-up-day":e.mouseUp,"mouse-up-event":e.mouseUp,"clear-placeholder":e.clearPlaceholder}},"ds-days-view",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],1):e._e()])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-expand ds-calendar-app"},[n("v-navigation-drawer",{attrs:{fixed:"",app:"",clipped:e.$vuetify.breakpoint.lgAndUp},model:{value:e.drawer,callback:function(t){e.drawer=t},expression:"drawer"}},[e._t("drawerTop"),e._v(" "),e._t("drawerPicker",[e.calendar?n("div",{staticClass:"pa-3"},[n("ds-day-picker",{attrs:{span:e.calendar.span},on:{picked:e.rebuild}})],1):e._e()],{calendar:e.calendar,picked:e.rebuild}),e._v(" "),e._t("drawerBottom")],2),e._v(" "),n("v-toolbar",{staticClass:"ds-app-calendar-toolbar",attrs:{app:"",flat:"",fixed:"",color:"white","clipped-left":e.$vuetify.breakpoint.lgAndUp}},[n("v-toolbar-title",{staticClass:"ml-0",style:e.toolbarStyle},[n("v-toolbar-side-icon",{on:{click:function(t){t.stopPropagation(),e.drawer=!e.drawer}}}),e._v(" "),n("span",{staticClass:"hidden-sm-and-down"},[e._t("title",null,{calendar:e.calendar})],2)],1),e._v(" "),e._t("today",[n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"ds-skinny-button",attrs:{slot:"activator",depressed:"",icon:e.$vuetify.breakpoint.smAndDown},on:{click:e.setToday},slot:"activator"},[e.$vuetify.breakpoint.mdAndUp?n("span",[e._v(e._s(e.labels.today))]):n("v-icon",[e._v(e._s(e.labels.todayIcon))])],1),e._v(" "),n("span",[e._v(e._s(e.todayDate))])],1)],null,{setToday:e.setToday,todayDate:e.todayDate,calendar:e.calendar}),e._v(" "),e._t("prev",[n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"ds-light-forecolor ds-skinny-button",attrs:{slot:"activator",icon:"",depressed:""},on:{click:e.prev},slot:"activator"},[n("v-icon",[e._v("keyboard_arrow_left")])],1),e._v(" "),n("span",[e._v(e._s(e.prevLabel))])],1)],null,{prev:e.prev,prevLabel:e.prevLabel,calendar:e.calendar}),e._v(" "),e._t("next",[n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"ds-light-forecolor ds-skinny-button",attrs:{slot:"activator",icon:"",depressed:""},on:{click:e.next},slot:"activator"},[n("v-icon",[e._v("keyboard_arrow_right")])],1),e._v(" "),n("span",[e._v(e._s(e.nextLabel))])],1)],null,{next:e.next,nextLabel:e.nextLabel,calendar:e.calendar}),e._v(" "),e._t("summary",[n("h1",{staticClass:"title ds-light-forecolor"},[e._v("\n        "+e._s(e.summary)+"\n      ")])],null,{summary:e.summary,calendar:e.calendar}),e._v(" "),n("v-spacer"),e._v(" "),e._t("view",[n("v-menu",[n("v-btn",{attrs:{slot:"activator",flat:""},slot:"activator"},[e._v("\n          "+e._s(e.currentType.label)+"\n          "),n("v-icon",[e._v("arrow_drop_down")])],1),e._v(" "),n("v-list",e._l(e.types,function(t){return n("v-list-tile",{key:t.id,on:{click:function(n){e.currentType=t}}},[n("v-list-tile-content",[n("v-list-tile-title",[e._v(e._s(t.label))])],1),e._v(" "),n("v-list-tile-action",[e._v(e._s(t.shortcut))])],1)}))],1)],null,{currentType:e.currentType,types:e.types}),e._v(" "),e._t("menuRight")],2),e._v(" "),n("v-content",{staticClass:"ds-expand"},[n("v-container",{staticClass:"ds-calendar-container",attrs:{fluid:"","fill-height":""}},[n("ds-gestures",{on:{swipeleft:e.next,swiperight:e.prev}},[e.currentType.schedule?n("div",{staticClass:"ds-expand"},[e._t("calendarAppAgenda",[n("ds-agenda",e._g(e._b({attrs:{"read-only":e.readOnly,calendar:e.calendar},on:{add:e.add,edit:e.edit,"view-day":e.viewDay}},"ds-agenda",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],null,{$scopedSlots:e.$scopedSlots,$listeners:e.$listeners,calendar:e.calendar,add:e.add,edit:e.edit,viewDay:e.viewDay})],2):n("div",{staticClass:"ds-expand"},[e._t("calendarAppCalendar",[n("ds-calendar",e._g(e._b({ref:"calendar",attrs:{calendar:e.calendar,"read-only":e.readOnly},on:{add:e.add,"add-at":e.addAt,edit:e.edit,"view-day":e.viewDay,added:e.handleAdd,moved:e.handleMove}},"ds-calendar",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],null,{$scopedSlots:e.$scopedSlots,$listeners:e.$listeners,calendar:e.calendar,add:e.add,addAt:e.addAt,edit:e.edit,viewDay:e.viewDay,handleAdd:e.handleAdd,handleMove:e.handleMove})],2)]),e._v(" "),e._t("calendarAppEventDialog",[n("ds-event-dialog",e._g(e._b({ref:"eventDialog",attrs:{calendar:e.calendar,"read-only":e.readOnly},on:{saved:e.eventFinish,actioned:e.eventFinish}},"ds-event-dialog",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],null,{$scopedSlots:e.$scopedSlots,$listeners:e.$listeners,calendar:e.calendar,eventFinish:e.eventFinish}),e._v(" "),e._t("calendarAppOptions",[n("v-dialog",e._b({ref:"optionsDialog",attrs:{fullscreen:e.$dayspan.fullscreenDialogs},model:{value:e.optionsVisible,callback:function(t){e.optionsVisible=t},expression:"optionsVisible"}},"v-dialog",e.optionsDialog,!1),[n("v-list",[e._l(e.options,function(t){return[n("v-list-tile",{key:t.text,on:{click:function(n){e.chooseOption(t)}}},[e._v("\n                "+e._s(t.text)+"\n              ")])]})],2)],1)],null,{optionsVisible:e.optionsVisible,optionsDialog:e.optionsDialog,options:e.options,chooseOption:e.chooseOption}),e._v(" "),e._t("calendarAppPrompt",[n("v-dialog",e._b({ref:"promptDialog",model:{value:e.promptVisible,callback:function(t){e.promptVisible=t},expression:"promptVisible"}},"v-dialog",e.promptDialog,!1),[n("v-card",[n("v-card-title",[e._v(e._s(e.promptQuestion))]),e._v(" "),n("v-card-actions",[n("v-btn",{attrs:{color:"primary",flat:""},on:{click:function(t){e.choosePrompt(!0)}}},[e._v("\n                "+e._s(e.labels.promptConfirm)+"\n              ")]),e._v(" "),n("v-spacer"),e._v(" "),n("v-btn",{attrs:{color:"secondary",flat:""},on:{click:function(t){e.choosePrompt(!1)}}},[e._v("\n                "+e._s(e.labels.promptCancel)+"\n              ")])],1)],1)],1)],null,{promptVisible:e.promptVisible,promptDialog:e.promptDialog,promptQuestion:e.promptQuestion,choosePrompt:e.choosePrompt}),e._v(" "),e._t("calendarAppAdd",[e.readOnly?e._e():n("v-fab-transition",[n("v-btn",{staticClass:"ds-add-event-today",attrs:{color:"primary",fixed:"",bottom:"",right:"",fab:""},on:{click:e.addToday},model:{value:e.allowsAddToday,callback:function(t){e.allowsAddToday=t},expression:"allowsAddToday"}},[n("v-icon",[e._v("add")])],1)],1)],null,{allowsAddToday:e.allowsAddToday,addToday:e.addToday}),e._v(" "),e._t("containerInside",null,null,{events:e.events,calendar:e.calendar})],2)],1)],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-chip",{attrs:{label:"",close:e.canExclude,color:e.background,"text-color":e.foreground},on:{input:e.exclude}},[n("strong",[e._v(e._s(e.text))])])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-dialog",e._b({attrs:{fullscreen:e.$dayspan.fullscreenDialogs},model:{value:e.open,callback:function(t){e.open=t},expression:"open"}},"v-dialog",e.dialogProps,!1),[e.schedule&&e.details?n("v-card",[n("v-card-text",[n("ds-event",e._b({attrs:{"target-details":e.details,"target-schedule":e.schedule,calendar:e.calendar,"calendar-event":e.calendarEvent,day:e.day,"read-only":e.readOnly},on:{saved:e.saved,cancel:e.cancel,actioned:e.actioned,"event-create":e.eventCreate,"event-update":e.eventUpdate,"event-remove":e.eventRemove}},"ds-event",{$scopedSlots:e.$scopedSlots},!1))],1)],1):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-layout",{attrs:{row:"",wrap:""}},[n("v-flex",{attrs:{xs7:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",label:e.labels.type,items:e.options},model:{value:e.type,callback:function(t){e.type=t},expression:"type"}})],1),e._v(" "),e.isAny?n("v-flex",{attrs:{xs5:""}}):e._e(),e._v(" "),e.isAny?e._e():n("v-flex",{staticClass:"pl-1",attrs:{xs5:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"","return-object":"",items:e.types},model:{value:e.chosenType,callback:function(t){e.chosenType=t},expression:"chosenType"}})],1),e._v(" "),e.isOneOf?n("v-flex",{staticClass:"pl-1",attrs:{xs5:"","offset-xs7":""}},[n("v-select",{attrs:{"hide-details":"",multiple:"",solo:"",flat:"",items:e.oneOfs},model:{value:e.frequency,callback:function(t){e.frequency=t},expression:"frequency"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs2:"","offset-xs7":""}},[n("v-text-field",{attrs:{type:"number","hide-details":"",solo:"",flat:""},model:{value:e.frequency.every,callback:function(t){e.$set(e.frequency,"every",e._n(t))},expression:"frequency.every"}})],1):e._e(),e._v(" "),e.isEvery?n("v-flex",{staticClass:"pl-1",attrs:{xs3:""}},[n("v-select",{attrs:{"hide-details":"",solo:"",flat:"",items:e.offsets},model:{value:e.frequency.offset,callback:function(t){e.$set(e.frequency,"offset",e._n(t))},expression:"frequency.offset"}})],1):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("tbody",{staticClass:"ds-agenda-day",class:e.classes,on:{click:function(t){return t.stopPropagation(),e.add(t)}}},[e._l(e.visibleEvents,function(t,a){return[n("ds-agenda-event",e._g(e._b({key:t.id,attrs:{"read-only":e.readOnly,"calendar-event":t,calendar:e.calendar,first:0===a,siblings:e.visibleEvents.length}},"ds-agenda-event",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))]})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",[e.hasDescription?n("div",{staticClass:"pb-3"},[n("span",{domProps:{innerHTML:e._s(e.labels.prefix)}}),e._v(" "),n("v-text-field",{staticClass:"ds-textfield inline small",attrs:{type:"number","single-line":"","hide-details":""},model:{value:e.sizeInput,callback:function(t){e.sizeInput=e._n(t)},expression:"sizeInput"}}),e._v(" "),n("span",{domProps:{innerHTML:e._s(e.labels.suffix)}})],1):e._e(),e._v(" "),e._l(e.forecast,function(t){return[n("ds-calendar-event-chip",{key:t.time,attrs:{day:e.aroundDay,time:t,"can-exclude":e.canExclude&&!e.isReadOnly},on:{exclude:e.exclude}})]})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-card",{staticClass:"ds-calendar-event-popover-card",class:e.classes},[n("v-toolbar",{style:e.styleHeader,attrs:{extended:"",flat:""}},[n("v-toolbar-title",{attrs:{slot:"extension"},slot:"extension"},[e._v("\n     "+e._s(e.details.title)+"\n     "),e.details.icon?n("v-icon",{style:e.styleButton},[e._v("\n       "+e._s(e.details.icon)+"\n     ")]):e._e()],1),e._v(" "),e.allowEdit?n("v-btn",{attrs:{color:"secondary",small:"",absolute:"",bottom:"",left:"",fab:"",icon:""},on:{click:e.edit}},[n("v-icon",[e._v("edit")])],1):e._e(),e._v(" "),e._t("eventPopoverToolbarLeft",null,null,e.slotData),e._v(" "),n("v-spacer"),e._v(" "),e._t("eventPopoverToolbarRight",null,null,e.slotData),e._v(" "),e._t("eventPopoverToolbarActions",[e.isReadOnly?e._e():n("v-tooltip",{attrs:{bottom:""}},[n("ds-schedule-actions",e._g(e._b({attrs:{slot:"activator",schedule:e.calendarEvent.schedule,"calendar-event":e.calendarEvent,calendar:e.calendar},slot:"activator"},"ds-schedule-actions",{$scopedSlots:e.$scopedSlots},!1),e.$listeners),[n("v-btn",{style:e.styleButton,attrs:{icon:""}},[n("v-icon",[e._v("more_vert")])],1)],1),e._v(" "),n("span",[e._v(e._s(e.labels.options))])],1)],null,e.slotData),e._v(" "),e._t("eventPopoverToolbarClose",[n("v-btn",{style:e.styleButton,attrs:{icon:""},on:{click:e.close}},[n("v-icon",[e._v("close")])],1)],null,e.slotData)],2),e._v(" "),n("v-card-text",[e._t("eventPopoverBodyTop",null,null,e.slotData),e._v(" "),n("v-list",{attrs:{dense:""}},[n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("access_time")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventPopoverOccurs",[n("v-list-tile-title",[e._v(e._s(e.startDate))]),e._v(" "),n("v-list-tile-sub-title",[e._v(e._s(e.occurs))])],null,e.slotData)],2)],1),e._v(" "),e.details.location?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("location_on")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventPopoverLocation",[n("v-list-tile-title",[n("span",{domProps:{innerHTML:e._s(e.details.location)}})])],null,e.slotData)],2)],1):e._e(),e._v(" "),e.details.description?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("subject")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventPopoverDescription",[n("v-list-tile-title",[n("span",{domProps:{innerHTML:e._s(e.details.description)}})])],null,e.slotData)],2)],1):e._e(),e._v(" "),e.details.notify?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("notifications")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventPopoverNotifications",[n("v-list-tile-title",[n("span",{domProps:{innerHTML:e._s(e.details.notify)}})])],null,e.slotData)],2)],1):e._e(),e._v(" "),e.details.calendar?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("event")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventPopoverCalendar",[n("v-list-tile-title",[n("span",{domProps:{innerHTML:e._s(e.details.calendar)}})])],null,e.slotData)],2)],1):e._e(),e._v(" "),e.hasBusy?n("v-list-tile",[n("v-list-tile-avatar",[n("v-icon",[e._v("work")])],1),e._v(" "),n("v-list-tile-content",[e._t("eventPopoverBusy",[n("v-list-tile-title",[e._v(e._s(e.busyness))])],null,e.slotData)],2)],1):e._e()],1),e._v(" "),e._t("eventPopoverBodyBottom",null,null,e.slotData)],2),e._v(" "),e._t("eventPopoverActions",null,null,e.slotData)],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-schedule-times"},[n("div",{staticClass:"ds-time-row"},[n("div",{staticClass:"ds-time-cell"},[n("v-checkbox",{ref:"allDayCheckbox",staticClass:"ma-2",attrs:{"hide-details":"",label:e.labels.all,readonly:e.isReadOnly},model:{value:e.allDay,callback:function(t){e.allDay=t},expression:"allDay"}})],1),e._v(" "),n("div",{staticClass:"ds-time-cell"},[n("v-text-field",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"",type:"number",disabled:e.isReadOnly},on:{input:e.triggerChange},model:{value:e.schedule.duration,callback:function(t){e.$set(e.schedule,"duration",e._n(t))},expression:"schedule.duration"}})],1),e._v(" "),n("div",{staticClass:"ds-time-cell"},[n("v-select",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"",items:e.durationOptions,disabled:e.isReadOnly},on:{input:e.triggerChange},model:{value:e.schedule.durationUnit,callback:function(t){e.$set(e.schedule,"durationUnit",t)},expression:"schedule.durationUnit"}})],1)]),e._v(" "),e.allDay?e._e():n("div",e._l(e.schedule.times,function(t,a){return n("div",{staticClass:"ds-time-row"},[n("div",{staticClass:"ds-time-cell"}),e._v(" "),n("ds-schedule-time",{key:a,staticClass:"ds-time-cell double",attrs:{index:a,"show-add":e.isLastTime(a),"show-remove":e.hasTimes,value:e.schedule.times[a],"read-only":e.readOnly},on:{add:e.addTime,remove:e.removeTime,change:e.changeTime}})],1)}))])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-day",class:e.classesDay,on:{mouseenter:e.mouseEnterDay,mouseleave:e.mouseLeaveDay,mousemove:function(t){return t.stopPropagation(),e.mouseMove(t)},mousedown:e.mouseDown,mouseup:e.mouseUp,dragstart:function(e){e.preventDefault()}}},[e._l(24,function(t){return n("div",{staticClass:"ds-hour",on:{click:function(n){n.stopPropagation(),e.addAt(t)}}})}),e._v(" "),e._l(e.day.events,function(t,a){return[e.isVisible(t)?n("ds-calendar-event-time",e._g(e._b({key:t.id,attrs:{"calendar-event":t,calendar:e.calendar}},"ds-calendar-event-time",{$scopedSlots:e.$scopedSlots},!1),e.$listeners)):e._e()]}),e._v(" "),e.day.currentDay?n("div",{style:e.nowLine}):e._e(),e._v(" "),e.hasPlaceholder?n("div",[n("ds-calendar-event-time-placeholder",e._g(e._b({attrs:{day:e.day,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate,calendar:e.calendar}},"ds-calendar-event-time-placeholder",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))],1):e._e()],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-menu",e._b({staticClass:"ds-calendar-event",style:e.style,attrs:{"content-class":e.contentClass,disabled:!e.hasPopover},model:{value:e.menu,callback:function(t){e.menu=t},expression:"menu"}},"v-menu",e.popoverProps,!1),[n("div",{staticClass:"ds-calendar-event-span",attrs:{slot:"activator"},on:{click:e.editCheck,mouseenter:e.mouseEnterEvent,mouseleave:e.mouseLeaveEvent,mousedown:e.mouseDownEvent,mouseup:e.mouseUpEvent},slot:"activator"},[e.showName?n("span",[e._t("eventTimeTitle",[e.hasIcon?n("v-icon",{staticClass:"ds-ev-icon",style:{color:e.details.forecolor},attrs:{size:"14"}},[e._v("\n          "+e._s(e.details.icon)+"\n        ")]):e._e(),e._v(" "),n("strong",{staticClass:"ds-ev-title"},[e._v(e._s(e.details.title))]),e._v(" "),n("span",{staticClass:"ds-ev-description"},[e._v(e._s(e.details.description))])],null,{calendarEvent:e.calendarEvent,details:e.details})],2):n("span",[e._t("eventTimeEmpty",null,null,{calendarEvent:e.calendarEvent,details:e.details})],2)]),e._v(" "),e._t("eventPopover",null,null,{calendarEvent:e.calendarEvent,calendar:e.calendar,edit:e.edit,details:e.details,close:e.close})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("table",{staticClass:"ds-agenda-table"},[e._m(0),e._v(" "),e._l(e.eventDays,function(t){return[n("ds-agenda-day",e._g(e._b({key:t.dayIdentifier,attrs:{"read-only":e.readOnly,day:t,calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate}},"ds-agenda-day",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))]})],2)},staticRenderFns:[function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("colgroup",[n("col",{staticClass:"column-day"}),e._v(" "),n("col",{staticClass:"column-when"}),e._v(" "),n("col",{staticClass:"column-event"})])}]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",[e.description?n("div",{staticClass:"pb-3",domProps:{innerHTML:e._s(e.description)}}):e._e(),e._v(" "),e._l(e.identifiers,function(t){return[n("ds-identifier-chip",{key:t,attrs:{identifier:t,"can-remove":e.canRemove&&!e.isReadOnly},on:{remove:e.remove}})]})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-time-row"},[n("div",{staticClass:"ds-time-cell"},[n("v-text-field",{attrs:{"single-line":"","hide-details":"",solo:"",flat:"",type:"time",readonly:e.isReadOnly},model:{value:e.time,callback:function(t){e.time=t},expression:"time"}})],1),e._v(" "),n("div",{staticClass:"ds-time-cell"},[e.showRemove&&!e.isReadOnly?n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"action-remove",attrs:{slot:"activator",icon:"",color:e.colors.remove},on:{click:e.removeTime},slot:"activator"},[n("v-icon",[e._v(e._s(e.icons.remove))])],1),e._v(" "),n("span",{domProps:{innerHTML:e._s(e.labels.remove)}})],1):e._e(),e._v(" "),e.showAdd&&!e.isReadOnly?n("v-tooltip",{attrs:{bottom:""}},[n("v-btn",{staticClass:"action-add",attrs:{slot:"activator",icon:"",color:e.colors.add},on:{click:e.addTime},slot:"activator"},[n("v-icon",[e._v(e._s(e.icons.add))])],1),e._v(" "),n("span",{domProps:{innerHTML:e._s(e.labels.add)}})],1):e._e()],1)])},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-schedule",class:e.classes},[e.showRange?n("div",{staticClass:"ds-schedule-span"},[e._t("scheduleSpan",[n("ds-schedule-span",{attrs:{schedule:e.schedule,day:e.day,"read-only":e.readOnly}})],null,{schedule:e.schedule,day:e.day})],2):e._e(),e._v(" "),n("div",{staticClass:"ds-schedule-type-line"},[n("div",{staticClass:"ds-schedule-type"},[e._t("scheduleType",[n("ds-schedule-type",{attrs:{day:e.day,schedule:e.schedule,"read-only":e.readOnly},on:{change:e.setType,custom:e.custom}})],null,{schedule:e.schedule,day:e.day,setType:e.setType,custom:e.custom})],2)]),e._v(" "),n("v-layout",{attrs:{row:"",wrap:""}},[n("v-flex",{attrs:{xs12:""}},[e._t("scheduleTimes",[n("ds-schedule-times",{attrs:{schedule:e.schedule,"read-only":e.readOnly}})],null,{schedule:e.schedule,day:e.day})],2),e._v(" "),e.isReadOnly?e._e():n("v-flex",{attrs:{xs12:""}},[e._t("scheduleFooter",null,null,{schedule:e.schedule,day:e.day}),e._v(" "),n("ds-schedule-type-custom-dialog",e._b({ref:"customScheduler"},"ds-schedule-type-custom-dialog",{$scopedSlots:e.$scopedSlots},!1))],2)],1)],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("span",[n("v-menu",{attrs:{"offset-y":"","close-on-content-click":!1,"nudge-width":60,disabled:e.isReadOnly},model:{value:e.startMenu,callback:function(t){e.startMenu=t},expression:"startMenu"}},[n("v-btn",{staticClass:"ds-button-tall ma-0 mb-2",attrs:{slot:"activator",depressed:""},slot:"activator"},[e._v("\n      "+e._s(e.startText)+"\n    ")]),e._v(" "),n("div",{staticClass:"ds-span-menu"},[n("ds-day-picker",{attrs:{"highlight-span":e.hasStart,span:e.startSpan},on:{picked:e.setStart}}),e._v(" "),e.hasStart?n("v-btn",{staticClass:"mb-0",attrs:{block:"",flat:""},on:{click:function(t){e.setStart(null)}}},[n("span",{domProps:{innerHTML:e._s(e.labels.startless)}})]):e._e()],1)],1),e._v("\n\n    to  \n\n  "),n("v-menu",{attrs:{"offset-y":"","close-on-content-click":!1,"nudge-width":60,disabled:e.isReadOnly},model:{value:e.endMenu,callback:function(t){e.endMenu=t},expression:"endMenu"}},[n("v-btn",{staticClass:"ds-button-tall ma-0 mb-2",attrs:{slot:"activator",depressed:""},slot:"activator"},[e._v("\n      "+e._s(e.endText)+"\n    ")]),e._v(" "),n("div",{staticClass:"ds-span-menu"},[n("ds-day-picker",{attrs:{"highlight-span":e.hasEnd,span:e.endSpan},on:{picked:e.setEnd}}),e._v(" "),e.hasEnd?n("v-btn",{staticClass:"mb-0",attrs:{block:"",flat:""},on:{click:function(t){e.setEnd(null)}}},[n("span",{domProps:{innerHTML:e._s(e.labels.endless)}})]):e._e()],1)],1)],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-week-header",style:e.style},[n("div",{staticClass:"ds-hour-list"}),e._v(" "),e._l(e.days,function(t){return[n("ds-week-day-header",e._g(e._b({attrs:{day:t,calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate}},"ds-week-day-header",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))]})],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-dialog",e._b({attrs:{fullscreen:e.$dayspan.fullscreenDialogs},model:{value:e.visible,callback:function(t){e.visible=t},expression:"visible"}},"v-dialog",e.dialogProps,!1),[e.hasData?n("v-card",[e._t("scheduleTypeCustomHeader",null,null,{original:e.original,copy:e.copy,aroundDay:e.aroundDay,day:e.day}),e._v(" "),n("v-card-text",[e._t("scheduleTypeCustomBody",[n("ds-schedule-type-custom",{attrs:{schedule:e.copy,day:e.aroundDay}})],null,{original:e.original,copy:e.copy,aroundDay:e.aroundDay,day:e.day})],2),e._v(" "),n("v-divider"),e._v(" "),n("v-card-actions",[e._t("scheduleTypeCustomActions",[n("v-spacer"),e._v(" "),n("v-btn",{attrs:{color:"secondary"},on:{click:function(t){return t.stopPropagation(),e.cancel(t)}}},[n("span",{domProps:{innerHTML:e._s(e.labels.cancel)}})]),e._v(" "),n("v-btn",{attrs:{color:"primary"},on:{click:function(t){return t.stopPropagation(),e.save(t)}}},[n("span",{domProps:{innerHTML:e._s(e.labels.save)}})])],null,{original:e.original,copy:e.copy,aroundDay:e.aroundDay,day:e.day,cancel:e.cancel,save:e.save,labels:e.labels})],2)],2):e._e()],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("v-menu",{attrs:{bottom:"",left:""}},[n("template",{slot:"activator"},[e._t("default")],2),e._v(" "),n("v-list",[e.canRemove?n("v-list-tile",{on:{click:e.remove}},[n("v-list-tile-title",{domProps:{innerHTML:e._s(e.labels.remove)}})],1):e._e(),e._v(" "),e.canExclude?n("v-list-tile",{on:{click:e.exclude}},[n("v-list-tile-title",{domProps:{innerHTML:e._s(e.labels.exclude)}})],1):e._e(),e._v(" "),e.canCancel?n("v-list-tile",{on:{click:e.cancel}},[n("v-list-tile-title",{domProps:{innerHTML:e._s(e.labels.cancel)}})],1):e._e(),e._v(" "),e.canUncancel?n("v-list-tile",{on:{click:e.uncancel}},[n("v-list-tile-title",{domProps:{innerHTML:e._s(e.labels.uncancel)}})],1):e._e(),e._v(" "),e.canSetStart?n("v-list-tile",{on:{click:e.setStart}},[n("v-list-tile-title",{domProps:{innerHTML:e._s(e.labels.setStart)}})],1):e._e(),e._v(" "),e.canSetEnd?n("v-list-tile",{on:{click:e.setEnd}},[n("v-list-tile-title",{domProps:{innerHTML:e._s(e.labels.setEnd)}})],1):e._e(),e._v(" "),e.canMove?n("v-list-tile",{on:{click:e.moveStart}},[n("v-menu",{attrs:{lazy:"","offset-y":"","full-width":"",transition:"scale-transition","min-width":"290px",color:"primary","close-on-content-click":!1,"nudge-right":40},model:{value:e.moving,callback:function(t){e.moving=t},expression:"moving"}},[n("v-list-tile-title",{attrs:{slot:"activator"},slot:"activator"},[n("span",{domProps:{innerHTML:e._s(e.labels.move)}})]),e._v(" "),e.movingDate?n("v-date-picker",{attrs:{"no-title":"",scrollable:""},model:{value:e.targetDate,callback:function(t){e.targetDate=t},expression:"targetDate"}},[n("v-spacer"),e._v(" "),n("v-btn",{attrs:{flat:"",color:"primary"},on:{click:function(t){e.movingDate=!1}}},[e._v(e._s(e.labels.pickerCancel))]),e._v(" "),n("v-btn",{attrs:{flat:"",color:"primary"},on:{click:e.moveEnd}},[e._v(e._s(e.labels.pickerOk))])],1):e._e(),e._v(" "),e.movingTime?n("v-time-picker",{attrs:{"no-title":"",scrollable:""},model:{value:e.targetTime,callback:function(t){e.targetTime=t},expression:"targetTime"}},[n("v-spacer"),e._v(" "),n("v-btn",{attrs:{color:"primary"},on:{click:function(t){e.movingTime=!1}}},[e._v(e._s(e.labels.pickerCancel))]),e._v(" "),n("v-btn",{attrs:{color:"primary"},on:{click:e.moveEnd}},[e._v(e._s(e.labels.pickerOk))])],1):e._e()],1)],1):e._e(),e._v(" "),e.canInclude?n("v-list-tile",{on:{click:e.includeStart}},[n("v-menu",{attrs:{lazy:"","offset-y":"","full-width":"",transition:"scale-transition","min-width":"290px",color:"primary","close-on-content-click":!1,"nudge-right":40},model:{value:e.including,callback:function(t){e.including=t},expression:"including"}},[n("v-list-tile-title",{attrs:{slot:"activator"},slot:"activator"},[n("span",{domProps:{innerHTML:e._s(e.labels.include)}})]),e._v(" "),e.includingDate?n("v-date-picker",{attrs:{"no-title":"",scrollable:""},model:{value:e.targetDate,callback:function(t){e.targetDate=t},expression:"targetDate"}},[n("v-spacer"),e._v(" "),n("v-btn",{attrs:{color:"primary"},on:{click:function(t){e.includingDate=!1}}},[e._v(e._s(e.labels.pickerCancel))]),e._v(" "),n("v-btn",{attrs:{color:"primary"},on:{click:e.includeEnd}},[e._v(e._s(e.labels.pickerOk))])],1):e._e(),e._v(" "),e.includingTime?n("v-time-picker",{attrs:{"no-title":"",scrollable:""},model:{value:e.targetTime,callback:function(t){e.targetTime=t},expression:"targetTime"}},[n("v-spacer"),e._v(" "),n("v-btn",{attrs:{color:"primary"},on:{click:function(t){e.includingTime=!1}}},[e._v(e._s(e.labels.pickerCancel))]),e._v(" "),n("v-btn",{attrs:{color:"primary"},on:{click:e.includeEnd}},[e._v(e._s(e.labels.pickerOk))])],1):e._e()],1)],1):e._e(),e._v(" "),e._t("scheduleActionsAdditional",null,null,{schedule:e.schedule,calendarEvent:e.calendarEvent,calendar:e.calendar})],2)],2)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",[n("div",{staticClass:"pa-3"},[e._v("\n    "+e._s(e.customDescription)+"\n  ")]),e._v(" "),n("ds-schedule-frequency-year",{attrs:{day:e.day,schedule:e.schedule}}),e._v(" "),n("ds-schedule-frequency-month",{attrs:{schedule:e.schedule}}),e._v(" "),n("ds-schedule-frequency-week",{attrs:{schedule:e.schedule}}),e._v(" "),n("ds-schedule-frequency-day-of-week",{attrs:{schedule:e.schedule}}),e._v(" "),n("ds-schedule-frequency-day",{attrs:{schedule:e.schedule}})],1)},staticRenderFns:[]}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"ds-week"},[e._l(e.days,function(t,a){return[n("ds-day",e._g(e._b({key:a,attrs:{day:t,calendar:e.calendar,placeholder:e.placeholder,"placeholder-for-create":e.placeholderForCreate}},"ds-day",{$scopedSlots:e.$scopedSlots},!1),e.$listeners))]})],2)},staticRenderFns:[]}},function(e,t){e.exports=__webpack_require__(/*! vue */ 31)}])});
//# sourceMappingURL=dayspan-vuetify.min.js.map

/***/ }),
/* 1121 */
/* exports provided: Calendar */
/* exports used: Calendar */
/*!***********************************!*\
  !*** ./~/dayspan/lib/Calendar.js ***!
  \***********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Calendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Day__ = __webpack_require__(/*! ./Day */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DaySpan__ = __webpack_require__(/*! ./DaySpan */ 189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Operation__ = __webpack_require__(/*! ./Operation */ 151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Units__ = __webpack_require__(/*! ./Units */ 191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Parse__ = __webpack_require__(/*! ./Parse */ 152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(/*! ./Constants */ 98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CalendarDay__ = __webpack_require__(/*! ./CalendarDay */ 485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CalendarEvent__ = __webpack_require__(/*! ./CalendarEvent */ 486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Iterator__ = __webpack_require__(/*! ./Iterator */ 150);











/**
 * A collection of [[CalendarDay]]s, the events on the calendar, and all
 * [[CalendarEvent]]s generated based on the events.
 *
 * @typeparam T The type of data stored in the [[Event]] class.
 * @typeparam M The type of metadata stored in the schedule.
 */
var Calendar = (function () {
    /**
     * Creates a new calendar given a span, type, size, moving functions, and
     * optionally some default properties for the calendar.
     *
     * @param start The first day on the calendar.
     * @param end The last day on the calendar.
     * @param type The calendar type used for describing the calendar and splitting it.
     * @param size The number of calendar types in this calendar.
     * @param moveStart The function to move the start day.
     * @param moveEnd The function to move the end by.
     * @param input The default properties for this calendar.
     * @see [[Calendar.start]]
     * @see [[Calendar.end]]
     * @see [[Calendar.type]]
     * @see [[Calendar.size]]
     * @see [[Calendar.moveStart]]
     * @see [[Calendar.moveEnd]]
     */
    function Calendar(start, end, type, size, moveStart, moveEnd, input) {
        /**
         * If the calendar should be filled in so the first day of the calendar is
         * Sunday and the last day is Saturday.
         */
        this.fill = false;
        /**
         * The minimum number of days in the calendar no matter what the type or size
         * is. This can be used to display a month with a constant number of weeks -
         * because not all months contain the same number of weeks.
         */
        this.minimumSize = 0;
        /**
         * When `true` a [[CalendarEvent]] instance exists on each [[CalendarDay]]
         * the event covers even if the event didn't start on that day.
         */
        this.repeatCovers = true;
        /**
         * When `true` an event instance will be created for each time specified on
         * the schedule. If the schedule specifies an all day event then only one
         * event is added to a day. This is typically done when displaying days or
         * weeks and events can be displayed on a timeline.
         */
        this.listTimes = false;
        /**
         * When `true` events will be added to days "outside" the calendar. Days
         * outside the calendar are days filled in when [[Calendar.fill]] is `true`.
         * More specifically days that are in [[Calendar.filled]] and not in
         * [[Calendar.span]].
         */
        this.eventsOutside = false;
        /**
         * When `true` [[CalendarEvent.row]] will be set so when visually displaying
         * the event with others multi-day events will align and not overlap.
         */
        this.updateRows = false;
        /**
         * When `true` [[CalendarEvent.col]] will be set so when visually displaying
         * the event based on start and end time any events that overlap with each
         * other will be "indented" to see the event below it.
         */
        this.updateColumns = false;
        /**
         * The function (if any) which sorts the events on a calendar day.
         */
        this.eventSorter = null;
        /**
         * A function to use when parsing meta input into the desired type.
         *
         * @param input The input to parse.
         * @returns The meta parsed from the given input, if any.
         */
        this.parseMeta = (function (x) { return x; });
        /**
         * A function to use when parsing meta input into the desired type.
         *
         * @param input The input to parse.
         * @returns The meta parsed from the given input, if any.
         */
        this.parseData = (function (x) { return x; });
        /**
         * A selection of days on the calendar. If no days are selected this is `null`.
         * This is merely used to keep the selection flags in [[CalendarDay]] updated
         * via [[Calendar.refreshSelection]].
         */
        this.selection = null;
        /**
         * The array of days in this calendar and their events.
         */
        this.days = [];
        /**
         * The array of scheduled events added to the calendar.
         */
        this.events = [];
        /**
         * The array of visible events on the calendar. This is built based on the
         * span of the schedule in the given event and also the [[Event.visible]] flag.
         */
        this.visible = [];
        this.span = new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
        this.filled = new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
        this.type = type;
        this.size = size;
        this.moveStart = moveStart;
        this.moveEnd = moveEnd;
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(input)) {
            this.set(input);
        }
        else {
            this.refresh();
        }
    }
    /**
     * Changes the calendar possibly morphing it to a different type or size if
     * specified in the given input. If the type and size are not morphed then
     * the following properties may be updated:
     *
     * - [[Calendar.fill]]
     * - [[Calendar.minimumSize]]
     * - [[Calendar.repeatCovers]]
     * - [[Calendar.listTimes]]
     * - [[Calendar.eventsOutside]]
     * - [[Calendar.updateRows]]
     * - [[Calendar.updateColumns]]
     * - [[Calendar.eventSorter]]
     * - [[Calendar.events]]
     * - [[Calendar.parseData]]
     * - [[Calendar.parseMeta]]
     *
     * If [[CalendarInput.delayRefresh]] is not given with `true` then
     * [[Calendar.refresh]] will be called once the calendar properties have been
     * updated.
     *
     * @param input The new properties for this calendar to overwrite with.
     */
    Calendar.prototype.set = function (input) {
        var typeChange = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(input.type) && input.type !== this.type;
        var sizeChange = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(input.size) && input.size !== this.size;
        if (typeChange || sizeChange) {
            var focus_1 = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.otherwiseFocus, 0.4999);
            var prefer = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.preferToday, true);
            var size = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.size, this.size);
            var type = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.type, this.type);
            var around = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.around, this.days[Math.floor((this.days.length - 1) * focus_1)]);
            var today = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today();
            if (!around || (prefer && this.span.matchesDay(today))) {
                around = today;
            }
            var meta = Calendar.TYPES[type];
            var start = meta.getStart(__WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].parse(around), size, focus_1);
            var end = meta.getEnd(start, size, focus_1);
            this.span.start = start;
            this.span.end = end;
            this.type = type;
            this.size = size;
            this.moveStart = meta.moveStart;
            this.moveEnd = meta.moveEnd;
        }
        else if (input.around) {
            var focus_2 = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.otherwiseFocus, 0.4999);
            var around = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].parse(input.around);
            var type = this.type;
            var size = this.size;
            var meta = Calendar.TYPES[type];
            var start = meta.getStart(around, size, focus_2);
            var end = meta.getEnd(start, size, focus_2);
            this.span.start = start;
            this.span.end = end;
        }
        this.fill = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.fill, this.fill);
        this.minimumSize = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.minimumSize, this.minimumSize);
        this.repeatCovers = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.repeatCovers, this.repeatCovers);
        this.listTimes = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.listTimes, this.listTimes);
        this.eventsOutside = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.eventsOutside, this.eventsOutside);
        this.updateRows = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.updateRows, this.updateRows);
        this.updateColumns = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.updateColumns, this.updateColumns);
        this.eventSorter = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.eventSorter, this.eventSorter);
        this.parseMeta = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.parseMeta, this.parseMeta);
        this.parseData = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].coalesce(input.parseData, this.parseData);
        if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(input.events)) {
            this.setEvents(input.events, true);
        }
        if (!input.delayRefresh) {
            this.refresh();
        }
        return this;
    };
    /**
     * Sets the [[Calendar.minimumSize]] value and returns `this` for method
     * chaining.
     *
     * @param minimumSize The new value.
     */
    Calendar.prototype.withMinimumSize = function (minimumSize) {
        this.minimumSize = minimumSize;
        this.refresh();
        return this;
    };
    /**
     * Sets the [[Calendar.repeatCovers]] value and returns `this` for method
     * chaining.
     *
     * @param repeatCovers The new value.
     */
    Calendar.prototype.withRepeatCovers = function (repeatCovers) {
        this.repeatCovers = repeatCovers;
        this.refreshEvents();
        return this;
    };
    /**
     * Sets the [[Calendar.listTimes]] value and returns `this` for method
     * chaining.
     *
     * @param listTimes The new value.
     */
    Calendar.prototype.withListTimes = function (listTimes) {
        this.listTimes = listTimes;
        this.refreshEvents();
        return this;
    };
    /**
     * Sets the [[Calendar.eventsOutside]] value and returns `this` for method
     * chaining.
     *
     * @param eventsOutside The new value.
     */
    Calendar.prototype.withEventsOutside = function (eventsOutside) {
        this.eventsOutside = eventsOutside;
        this.refreshEvents();
        return this;
    };
    /**
     * Sets the [[Calendar.updateRows]] value and returns `this` for method
     * chaining.
     *
     * @param updateRows The new value.
     * @param refresh If the rows should be updated now if `updateRows` is `true`.
     */
    Calendar.prototype.withUpdateRows = function (updateRows, refresh) {
        if (refresh === void 0) { refresh = true; }
        this.updateRows = updateRows;
        if (refresh && updateRows) {
            this.refreshRows();
        }
        return this;
    };
    /**
     * Sets the [[Calendar.updateColumns]] value and returns `this` for method
     * chaining.
     *
     * @param updateColumns The new value.
     * @param refresh If the columns should be updated now if `updateColumns` is
     *    `true`.
     */
    Calendar.prototype.withUpdateColumns = function (updateColumns, refresh) {
        if (refresh === void 0) { refresh = true; }
        this.updateColumns = updateColumns;
        if (refresh && updateColumns) {
            this.refreshColumns();
        }
        return this;
    };
    Object.defineProperty(Calendar.prototype, "start", {
        /**
         * Returns the start day of the calendar. If this calendar is filled, this
         * may not represent the very first day in the calendar.
         */
        get: function () {
            return this.span.start;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Calendar.prototype, "end", {
        /**
         * Returns the end day of the calendar. If this calendar is filled, this
         * may not represent the very last day in the calendar.
         */
        get: function () {
            return this.span.end;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the summary of the span of time this calendar represents.
     *
     * @param dayOfWeek [[DaySpan.summary]]
     * @param short [[DaySpan.summary]]
     * @param repeat [[DaySpan.summary]]
     * @param contextual [[DaySpan.summary]]
     * @param delimiter [[DaySpan.summary]]
     * @see [[DaySpan.summary]]
     */
    Calendar.prototype.summary = function (dayOfWeek, short, repeat, contextual, delimiter) {
        if (dayOfWeek === void 0) { dayOfWeek = true; }
        if (short === void 0) { short = false; }
        if (repeat === void 0) { repeat = false; }
        if (contextual === void 0) { contextual = true; }
        if (delimiter === void 0) { delimiter = ' - '; }
        return this.span.summary(this.type, dayOfWeek, short, repeat, contextual, delimiter);
    };
    /**
     * Splits up this calendar into an iterable collection of calendars. The
     * resulting iterator will return `size / by` number of calendars.
     *
     * @param by The new size of the resulting calendars. If the the size of the
     *    current calendar is not divisible by this value the resulting calendars
     *    may cover more or less than this calendar covers.
     * @returns An iterator for the calendars produced.
     */
    Calendar.prototype.split = function (by) {
        var _this = this;
        if (by === void 0) { by = 1; }
        return new __WEBPACK_IMPORTED_MODULE_9__Iterator__["b" /* Iterator */](function (iterator) {
            var start = _this.start;
            var end = _this.moveEnd(_this.end, by - _this.size);
            for (var i = 0; i < _this.size; i++) {
                var calendar = new Calendar(start, end, _this.type, by, _this.moveStart, _this.moveEnd, _this);
                if (iterator.act(calendar) === __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop) {
                    return;
                }
                start = _this.moveStart(start, by);
                end = _this.moveEnd(end, by);
            }
        });
    };
    /**
     * Refreshes the days and events in this calendar based on the start and end
     * days, the calendar properties, and its eventss.
     *
     * @param today The current day to update the calendar days via
     *    [[CalendarDay.updateCurrent]].
     */
    Calendar.prototype.refresh = function (today) {
        if (today === void 0) { today = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today(); }
        this.length = this.span.days(__WEBPACK_IMPORTED_MODULE_3__Operation__["a" /* Op */].UP, true);
        this.resetDays();
        this.refreshCurrent(today);
        this.refreshSelection();
        this.refreshVisible();
        this.refreshEvents();
        return this;
    };
    /**
     * Updates the [[Calendar.filled]] span based on [[Calendar.start]],
     * [[Calendar.end]], and [[Calendar.fill]] properties.
     */
    Calendar.prototype.resetFilled = function () {
        this.filled.start = this.fill ? this.start.startOfWeek() : this.start;
        this.filled.end = this.fill ? this.end.endOfWeek() : this.end;
        return this;
    };
    /**
     * Updates [[Calendar.days]] to match the span of days in the calendar.
     */
    Calendar.prototype.resetDays = function () {
        this.resetFilled();
        var days = this.days;
        var filled = this.filled;
        var current = filled.start;
        var daysBetween = filled.days(__WEBPACK_IMPORTED_MODULE_3__Operation__["a" /* Op */].UP);
        var total = Math.max(this.minimumSize, daysBetween);
        for (var i = 0; i < total; i++) {
            var day = days[i];
            if (!day || !day.sameDay(current)) {
                day = new __WEBPACK_IMPORTED_MODULE_7__CalendarDay__["a" /* CalendarDay */](current.date);
                if (i < days.length) {
                    days.splice(i, 1, day);
                }
                else {
                    days.push(day);
                }
            }
            day.inCalendar = this.span.contains(day);
            current = current.next();
        }
        if (days.length > total) {
            days.splice(total, days.length - total);
        }
        return this;
    };
    /**
     * Updates the list of visible schedules.
     */
    Calendar.prototype.refreshVisible = function () {
        var start = this.filled.start;
        var end = this.filled.end;
        this.visible = this.events.filter(function (e) {
            return e.visible && e.schedule.matchesRange(start, end);
        });
        return this;
    };
    /**
     * Updates the days with the current day via [[CalendarDay.updateCurrent]].
     *
     * @param today The new current day.
     */
    Calendar.prototype.refreshCurrent = function (today) {
        if (today === void 0) { today = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today(); }
        this.iterateDays().iterate(function (d) {
            d.updateCurrent(today);
        });
        return this;
    };
    /**
     * Updates the selection flags in [[CalendarDay]] based on the
     * [[Calendar.selection]] property.
     */
    Calendar.prototype.refreshSelection = function () {
        var _this = this;
        this.iterateDays().iterate(function (d) {
            if (_this.selection) {
                d.updateSelected(_this.selection);
            }
            else {
                d.clearSelected();
            }
        });
        return this;
    };
    /**
     * Updates the [[CalendarDay.events]] based on the events in this calendar
     * and the following properties:
     *
     * - [[Calendar.eventsForDay]]
     * - [[Calendar.eventsOutside]]
     * - [[Calendar.listTimes]]
     * - [[Calendar.repeatCovers]]
     * - [[Calendar.updateRows]]
     * - [[Calendar.updateColumns]]
     */
    Calendar.prototype.refreshEvents = function () {
        var _this = this;
        this.iterateDays().iterate(function (d) {
            if (d.inCalendar || _this.eventsOutside) {
                d.events = _this.eventsForDay(d, _this.listTimes, _this.repeatCovers);
            }
        });
        if (this.updateRows) {
            this.refreshRows();
        }
        if (this.updateColumns) {
            this.refreshColumns();
        }
        return this;
    };
    /**
     * Refreshes the [[CalendarEvent.row]] property as described in the link.
     */
    Calendar.prototype.refreshRows = function () {
        var eventToRow = {};
        var onlyFullDay = this.listTimes;
        this.iterateDays().iterate(function (d) {
            if (d.dayOfWeek === 0) {
                eventToRow = {};
            }
            var used = {};
            for (var _i = 0, _a = d.events; _i < _a.length; _i++) {
                var event_1 = _a[_i];
                if (onlyFullDay && !event_1.fullDay) {
                    continue;
                }
                if (event_1.id in eventToRow) {
                    used[event_1.row = eventToRow[event_1.id]] = true;
                }
            }
            var rowIndex = 0;
            for (var _b = 0, _c = d.events; _b < _c.length; _b++) {
                var event_2 = _c[_b];
                if ((onlyFullDay && !event_2.fullDay) || event_2.id in eventToRow) {
                    continue;
                }
                while (used[rowIndex]) {
                    rowIndex++;
                }
                eventToRow[event_2.id] = event_2.row = rowIndex;
                rowIndex++;
            }
        });
        return this;
    };
    /**
     * Refreshes the [[CalendarEvent.col]] property as described in the link.
     */
    Calendar.prototype.refreshColumns = function () {
        this.iterateDays().iterate(function (d) {
            var markers = [];
            for (var _i = 0, _a = d.events; _i < _a.length; _i++) {
                var event_3 = _a[_i];
                if (!event_3.fullDay) {
                    markers.push({
                        time: event_3.time.start.time,
                        event: event_3,
                        start: true,
                        parent: null
                    });
                    markers.push({
                        time: event_3.time.end.time - 1,
                        event: event_3,
                        start: false,
                        parent: null
                    });
                }
            }
            markers.sort(function (a, b) {
                return a.time - b.time;
            });
            var parent = null;
            for (var _b = 0, markers_1 = markers; _b < markers_1.length; _b++) {
                var marker = markers_1[_b];
                if (marker.start) {
                    marker.parent = parent;
                    parent = marker;
                }
                else if (parent) {
                    parent = parent.parent;
                }
            }
            for (var _c = 0, markers_2 = markers; _c < markers_2.length; _c++) {
                var marker = markers_2[_c];
                if (marker.start) {
                    marker.event.col = marker.parent ? marker.parent.event.col + 1 : 0;
                }
            }
        });
        return this;
    };
    /**
     * Gets the calendar day for the given day.
     *
     * @param input The day to get the calendar day for.
     * @returns The reference to the calendar day, or null if the given input
     *    is not on this calendar.
     */
    Calendar.prototype.getDay = function (input) {
        var parsed = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].parse(input);
        if (parsed) {
            var dayCount = parsed.start().daysBetween(this.days[0], __WEBPACK_IMPORTED_MODULE_3__Operation__["a" /* Op */].DOWN, false);
            return this.days[dayCount];
        }
        return null;
    };
    /**
     * Iterates over all days in this calendar and passes each day to `iterator`.
     *
     * @param iterator The function to pass [[CalendarDay]]s to.
     */
    Calendar.prototype.iterateDays = function () {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_9__Iterator__["b" /* Iterator */](function (iterator) {
            var days = _this.days;
            for (var i = 0; i < days.length; i++) {
                switch (iterator.act(days[i])) {
                    case __WEBPACK_IMPORTED_MODULE_9__Iterator__["a" /* IteratorAction */].Stop:
                        return;
                }
            }
        });
    };
    /**
     * Returns the events for the given day optionally looking at schedule times,
     * optionally looking at events which cover multiple days, and optionally
     * sorted with the given function.
     *
     * @param day The day to find events for.
     * @param getTimes When `true` an event is added to the result for each time
     *    specified in the schedule.
     * @param covers When `true` events which don't start on the given day but do
     *    overlap are added to the result.
     * @param sorter The function to sort the events by, if any.
     * @returns An array of events that occurred on the given day.
     */
    Calendar.prototype.eventsForDay = function (day, getTimes, covers, sorter) {
        if (getTimes === void 0) { getTimes = true; }
        if (covers === void 0) { covers = true; }
        if (sorter === void 0) { sorter = this.eventSorter; }
        var events = [];
        var entries = this.visible;
        var _loop_1 = function (entryIndex) {
            var entry = entries[entryIndex];
            var schedule = entry.schedule;
            var eventId = entryIndex * __WEBPACK_IMPORTED_MODULE_6__Constants__["a" /* Constants */].MAX_EVENTS_PER_DAY;
            var timeIndex = 0;
            schedule.iterateSpans(day, covers).iterate(function (span, iterator) {
                events.push(new __WEBPACK_IMPORTED_MODULE_8__CalendarEvent__["a" /* CalendarEvent */](eventId + timeIndex++, entry, span, day));
                if (!getTimes) {
                    iterator.stop();
                }
            });
        };
        for (var entryIndex = 0; entryIndex < entries.length; entryIndex++) {
            _loop_1(entryIndex);
        }
        if (sorter) {
            events.sort(sorter);
        }
        return events;
    };
    /**
     * Finds the event given one of the ways to identify the event.
     *
     * @param input The value to use to search for an event.
     * @returns The refrence to the event or null if not found.
     */
    Calendar.prototype.findEvent = function (id) {
        for (var _i = 0, _a = this.events; _i < _a.length; _i++) {
            var event_4 = _a[_i];
            if (event_4 === id || event_4.schedule === id || event_4.data === id || event_4.id === id) {
                return event_4;
            }
        }
        return null;
    };
    /**
     * Removes the list of events if they exist in the calendar.
     *
     * @param events The array of events to remove if they exist. If no
     *    events are passed (via `null`) then all events will be removed
     *    from the calendar.
     * @param delayRefresh When `true` the [[Calendar.refreshEvents]] will not be
     *    called after the events are removed.
     * @see [[Calendar.removeEvent]]
     * @see [[Calendar.refreshEvents]]
     */
    Calendar.prototype.removeEvents = function (events, delayRefresh) {
        if (events === void 0) { events = null; }
        if (delayRefresh === void 0) { delayRefresh = false; }
        if (events) {
            for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
                var event_5 = events_1[_i];
                this.removeEvent(event_5, true);
            }
        }
        else {
            this.events = [];
        }
        this.refreshVisible();
        if (!delayRefresh) {
            this.refreshEvents();
        }
        return this;
    };
    /**
     * Removes the given event if it exists on the calendar.
     *
     * @param event The event to remove if it exists.
     * @param delayRefresh When `true` the [[Calendar.refreshEvents]] will not be
     *    called after the event is removed.
     * @see [[Calendar.refreshEvents]]
     */
    Calendar.prototype.removeEvent = function (event, delayRefresh) {
        if (delayRefresh === void 0) { delayRefresh = false; }
        var found = this.findEvent(event);
        if (found) {
            this.events.splice(this.events.indexOf(found), 1);
            this.refreshVisible();
            if (!delayRefresh) {
                this.refreshEvents();
            }
        }
        return this;
    };
    /**
     * Adds the given event to this calendar if it doesn't exist already (or
     * `allowDuplicates` is `true`).
     *
     * @param event The event to add to the calendar.
     * @param allowDuplicates If an event can be added more than once.
     * @param delayRefresh When `true` the [[Calendar.refreshEvents]] will not be
     *    called after the event is added.
     * @see [[Calendar.refreshEvents]]
     */
    Calendar.prototype.addEvent = function (event, allowDuplicates, delayRefresh) {
        if (allowDuplicates === void 0) { allowDuplicates = false; }
        if (delayRefresh === void 0) { delayRefresh = false; }
        var parsed = __WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].event(event, this.parseData, this.parseMeta);
        if (!allowDuplicates) {
            var existing = this.findEvent(parsed);
            if (existing) {
                return this;
            }
        }
        this.events.push(parsed);
        this.refreshVisible();
        if (!delayRefresh) {
            this.refreshEvents();
        }
        return this;
    };
    /**
     * Adds the given events to this calendar if they don't exist already (or
     * `allowDuplicates` is `true`).
     *
     * @param events The events to add to the calendar.
     * @param allowDuplicates If an event can be added more than once.
     * @param delayRefresh When `true` the [[Calendar.refreshEvents]] will not be
     *    called after the events are added.
     * @see [[Calendar.refreshEvents]]
     */
    Calendar.prototype.addEvents = function (events, allowDuplicates, delayRefresh) {
        if (allowDuplicates === void 0) { allowDuplicates = false; }
        if (delayRefresh === void 0) { delayRefresh = false; }
        for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
            var event_6 = events_2[_i];
            this.addEvent(event_6, allowDuplicates, true);
        }
        if (!delayRefresh) {
            this.refreshEvents();
        }
        return this;
    };
    /**
     * Sets the given events to this calendar replacing the current list of
     * events.
     *
     * @param events The events to set to the calendar.
     * @param delayRefresh When `true` the [[Calendar.refreshEvents]] will not be
     *    called after the events are added.
     * @see [[Calendar.refreshEvents]]
     */
    Calendar.prototype.setEvents = function (events, delayRefresh) {
        if (delayRefresh === void 0) { delayRefresh = false; }
        var parsedEvents = [];
        for (var i = 0; i < events.length; i++) {
            var parsed = __WEBPACK_IMPORTED_MODULE_5__Parse__["a" /* Parse */].event(events[i], this.parseData, this.parseMeta);
            if (parsed) {
                parsedEvents.push(parsed);
            }
        }
        this.events = parsedEvents;
        this.refreshVisible();
        if (!delayRefresh) {
            this.refreshEvents();
        }
        return this;
    };
    /**
     * Sets the selection point or range of the calendar and updates the flags
     * in the days.
     *
     * @param start The start of the selection.
     * @param end The end of the selection.
     * @see [[Calendar.refreshSelection]]
     */
    Calendar.prototype.select = function (start, end) {
        if (end === void 0) { end = start; }
        this.selection = new __WEBPACK_IMPORTED_MODULE_2__DaySpan__["a" /* DaySpan */](start, end);
        this.refreshSelection();
        return this;
    };
    /**
     * Sets the selection of the calendar to nothing.
     *
     * @see [[Calendar.refreshSelection]]
     */
    Calendar.prototype.unselect = function () {
        this.selection = null;
        this.refreshSelection();
        return this;
    };
    /**
     * Shifts the calendar days by the given amount.
     *
     * @param jump The amount to shift the calendar by.
     * @param delayRefresh When `true` [[Calendar.refresh]] will not be called
     *    after calendar is moved.
     */
    Calendar.prototype.move = function (jump, delayRefresh) {
        if (jump === void 0) { jump = this.size; }
        if (delayRefresh === void 0) { delayRefresh = false; }
        this.span.start = this.moveStart(this.start, jump);
        this.span.end = this.moveEnd(this.end, jump);
        if (!delayRefresh) {
            this.refresh();
        }
        return this;
    };
    /**
     * Moves the calenndar to the next set of days.
     *
     * @param jump The amount to shift the calendar by.
     * @param delayRefresh When `true` [[Calendar.refresh]] will not be called
     *    after calendar is moved.
     */
    Calendar.prototype.next = function (jump, delayRefresh) {
        if (jump === void 0) { jump = this.size; }
        if (delayRefresh === void 0) { delayRefresh = false; }
        return this.move(jump, delayRefresh);
    };
    /**
     * Moves the calenndar to the previous set of days.
     *
     * @param jump The amount to shift the calendar by.
     * @param delayRefresh When `true` [[Calendar.refresh]] will not be called
     *    after calendar is moved.
     */
    Calendar.prototype.prev = function (jump, delayRefresh) {
        if (jump === void 0) { jump = this.size; }
        if (delayRefresh === void 0) { delayRefresh = false; }
        return this.move(-jump, delayRefresh);
    };
    /**
     * Converts this calendar to input which can be used to later recreate this
     * calendar. The only properties of the calendar which will be loss is the
     * [[Calendar.eventSorter]] property because it is a function.
     *
     * @param plain If the returned input should be plain objects as opposed
     *    to [[Day]] and [[Event]] instances.
     * @param plainData A function to convert [[Event.data]] to a plain object if
     *    it is not already.
     * @param plainMeta A function to convert values in [[Schedule.meta]] to plain
     *    objects if they are not alreday.
     * @returns The input generated from this calendar.
     */
    Calendar.prototype.toInput = function (plain, plainData, plainMeta) {
        if (plain === void 0) { plain = false; }
        if (plainData === void 0) { plainData = function (d) { return d; }; }
        if (plainMeta === void 0) { plainMeta = function (m) { return m; }; }
        var out = {};
        out.type = this.type;
        out.size = this.size;
        out.fill = this.fill;
        out.minimumSize = this.minimumSize;
        out.repeatCovers = this.repeatCovers;
        out.listTimes = this.listTimes;
        out.eventsOutside = this.eventsOutside;
        out.updateRows = this.updateRows;
        out.updateColumns = this.updateColumns;
        out.around = plain ? this.span.start.time : this.span.start;
        out.events = [];
        for (var _i = 0, _a = this.events; _i < _a.length; _i++) {
            var event_7 = _a[_i];
            if (plain) {
                var plainEvent = {};
                if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(event_7.id)) {
                    plainEvent.id = event_7.id;
                }
                if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(event_7.data)) {
                    plainEvent.data = plainData(event_7.data);
                }
                if (!event_7.visible) {
                    plainEvent.visible = event_7.visible;
                }
                plainEvent.schedule = event_7.schedule.toInput();
                var meta = plainEvent.schedule.meta;
                if (meta) {
                    for (var identifier in meta) {
                        meta[identifier] = plainMeta(meta[identifier]);
                    }
                }
                out.events.push(plainEvent);
            }
            else {
                out.events.push(event_7);
            }
        }
        return out;
    };
    /**
     * Creates a calendar based on the given input.
     *
     * @param input The input which has at least the `type` specified.
     * @returns A new calendar instance.
     */
    Calendar.fromInput = function (input) {
        var initial = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today();
        return new Calendar(initial, initial, null, 1, null, null, input);
    };
    /**
     * Creates a calendar based around a given unit optionally focused around a
     * given day.
     *
     * @param type The unit of the calendar.
     * @param days The number of units in the calendar.
     * @param around The day to focus the calendar on.
     * @param focus The value which describes how months are added around the given
     *    day. The default value will center the calendar around the given day.
     *    When the value is `0` the given day is the first day in the calendar,
     *    and when the value is `1` the given day is the last day in the calendar.
     * @param input The default properties for the calendar.
     * @returns A new calendar instance.
     */
    Calendar.forType = function (type, size, around, focus, input) {
        if (size === void 0) { size = 1; }
        if (around === void 0) { around = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today(); }
        if (focus === void 0) { focus = 0.49999; }
        var meta = this.TYPES[type];
        var start = meta.getStart(around, size, focus);
        var end = meta.getEnd(start, size, focus);
        return new Calendar(start, end, type, size, meta.moveStart, meta.moveEnd, input || meta.defaultInput);
    };
    /**
     * Creates a calendar based around days optionally focused around a given day.
     *
     * @param days The number of days in the calendar.
     * @param around The day to focus the calendar on.
     * @param focus The value which describes how days are added around the given
     *    day. The default value will center the calendar around the given day.
     *    When the value is `0` the given day is the first day in the calendar,
     *    and when the value is `1` the given day is the last day in the calendar.
     * @param input The default properties for the calendar.
     * @returns A new calendar instance.
     * @see [[Calendar.forType]]
     */
    Calendar.days = function (days, around, focus, input) {
        if (days === void 0) { days = 1; }
        if (around === void 0) { around = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today(); }
        if (focus === void 0) { focus = 0.4999; }
        return this.forType(__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].DAY, days, around, focus, input);
    };
    /**
     * Creates a calendar based around weeks optionally focused around a given day.
     *
     * @param days The number of weeks in the calendar.
     * @param around The day to focus the calendar on.
     * @param focus The value which describes how weeks are added around the given
     *    day. The default value will center the calendar around the given day.
     *    When the value is `0` the given day is the first day in the calendar,
     *    and when the value is `1` the given day is the last day in the calendar.
     * @param input The default properties for the calendar.
     * @returns A new calendar instance.
     * @see [[Calendar.forType]]
     */
    Calendar.weeks = function (weeks, around, focus, input) {
        if (weeks === void 0) { weeks = 1; }
        if (around === void 0) { around = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today(); }
        if (focus === void 0) { focus = 0.4999; }
        return this.forType(__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].WEEK, weeks, around, focus, input);
    };
    /**
     * Creates a calendar based around months optionally focused around a given day.
     *
     * @param days The number of months in the calendar.
     * @param around The day to focus the calendar on.
     * @param focus The value which describes how months are added around the given
     *    day. The default value will center the calendar around the given day.
     *    When the value is `0` the given day is the first day in the calendar,
     *    and when the value is `1` the given day is the last day in the calendar.
     * @param input The default properties for the calendar.
     * @returns A new calendar instance.
     * @see [[Calendar.forType]]
     */
    Calendar.months = function (months, around, focus, input) {
        if (months === void 0) { months = 1; }
        if (around === void 0) { around = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today(); }
        if (focus === void 0) { focus = 0.4999; }
        return this.forType(__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].MONTH, months, around, focus, input);
    };
    /**
     * Creates a calendar based around years optionally focused around a given day.
     *
     * @param days The number of years in the calendar.
     * @param around The day to focus the calendar on.
     * @param focus The value which describes how years are added around the given
     *    day. The default value will center the calendar around the given day.
     *    When the value is `0` the given day is the first day in the calendar,
     *    and when the value is `1` the given day is the last day in the calendar.
     * @param input The default properties for the calendar.
     * @returns A new calendar instance.
     * @see [[Calendar.forType]]
     */
    Calendar.years = function (years, around, focus, input) {
        if (years === void 0) { years = 1; }
        if (around === void 0) { around = __WEBPACK_IMPORTED_MODULE_1__Day__["a" /* Day */].today(); }
        if (focus === void 0) { focus = 0.4999; }
        return this.forType(__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].YEAR, years, around, focus, input);
    };
    /**
     * A map of functions and properties by [[Units]] used to create or morph
     * Calendars.
     */
    Calendar.TYPES = (_a = {},
        _a[__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].DAY] = {
            getStart: function (around, size, focus) {
                return around.start().relativeDays(-Math.floor(size * focus));
            },
            getEnd: function (start, size, focus) {
                return start.relativeDays(size - 1).end();
            },
            moveStart: function (day, amount) {
                return day.relativeDays(amount);
            },
            moveEnd: function (day, amount) {
                return day.relativeDays(amount);
            },
            defaultInput: undefined
        },
        _a[__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].WEEK] = {
            getStart: function (around, size, focus) {
                return around.start().startOfWeek().relativeWeeks(-Math.floor(size * focus));
            },
            getEnd: function (start, size, focus) {
                return start.relativeWeeks(size - 1).endOfWeek();
            },
            moveStart: function (day, amount) {
                return day.relativeWeeks(amount);
            },
            moveEnd: function (day, amount) {
                return day.relativeWeeks(amount);
            },
            defaultInput: undefined
        },
        _a[__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].MONTH] = {
            getStart: function (around, size, focus) {
                return around.start().startOfMonth().relativeMonths(-Math.floor(size * focus));
            },
            getEnd: function (start, size, focus) {
                return start.relativeMonths(size - 1).endOfMonth();
            },
            moveStart: function (day, amount) {
                return day.relativeMonths(amount);
            },
            moveEnd: function (day, amount) {
                return day.startOfMonth().relativeMonths(amount).endOfMonth();
            },
            defaultInput: { fill: true }
        },
        _a[__WEBPACK_IMPORTED_MODULE_4__Units__["a" /* Units */].YEAR] = {
            getStart: function (around, size, focus) {
                return around.start().startOfYear().relativeYears(-Math.floor(size * focus));
            },
            getEnd: function (start, size, focus) {
                return start.relativeYears(size - 1).endOfYear();
            },
            moveStart: function (day, amount) {
                return day.relativeYears(amount);
            },
            moveEnd: function (day, amount) {
                return day.relativeYears(amount);
            },
            defaultInput: { fill: true }
        },
        _a);
    return Calendar;
}());

var _a;
//# sourceMappingURL=Calendar.js.map

/***/ }),
/* 1122 */
/* exports provided: Month */
/* exports used: Month */
/*!********************************!*\
  !*** ./~/dayspan/lib/Month.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Month; });

/**
 * The months in a year.
 */
var Month = (function () {
    function Month() {
    }
    Month.JANUARY = 0;
    Month.FEBRUARY = 1;
    Month.MARCH = 2;
    Month.APRIL = 3;
    Month.MAY = 4;
    Month.JUNE = 5;
    Month.JULY = 6;
    Month.AUGUST = 7;
    Month.SEPTEMBER = 8;
    Month.OCTOBER = 9;
    Month.NOVEMBER = 10;
    Month.DECEMBER = 11;
    /**
     * The full list of months in a year.
     */
    Month.LIST = [
        Month.JANUARY,
        Month.FEBRUARY,
        Month.MARCH,
        Month.APRIL,
        Month.MAY,
        Month.JUNE,
        Month.JULY,
        Month.AUGUST,
        Month.SEPTEMBER,
        Month.OCTOBER,
        Month.NOVEMBER,
        Month.DECEMBER
    ];
    return Month;
}());

//# sourceMappingURL=Month.js.map

/***/ }),
/* 1123 */
/* exports provided: Pattern, Patterns, PatternMap */
/* exports used: Pattern, Patterns, PatternMap */
/*!**********************************!*\
  !*** ./~/dayspan/lib/Pattern.js ***!
  \**********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Patterns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PatternMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Functions__ = __webpack_require__(/*! ./Functions */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Suffix__ = __webpack_require__(/*! ./Suffix */ 278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Weekday__ = __webpack_require__(/*! ./Weekday */ 488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Schedule__ = __webpack_require__(/*! ./Schedule */ 276);





/**
 * A class which helps describe [[ScheduleInput]] if it matches a pattern.
 */
var Pattern = (function () {
    /**
     * Creates a new pattern.
     *
     * @param name The unique name of the pattern.
     * @param listed If the pattern is "listed" [[Pattern.listed]].
     * @param describe A function to describe the pattern given a [[Day]].
     * @param rules The rules which describe how to detect and apply the pattern
     *    to schedule input.
     */
    function Pattern(name, listed, describe, rules) {
        this.name = name;
        this.listed = listed;
        this.describe = describe;
        this.rules = rules;
    }
    /**
     * Applies this pattern to a [[Schedule]] or [[ScheduleInput]] removing and
     * adding any necessary properties from the input to match this pattern -
     * based around the day provided.
     *
     * @param schedule The schedule to update to match this pattern.
     * @param day The day to base the schedule on.
     * @returns The reference to the input passed in.
     */
    Pattern.prototype.apply = function (schedule, day) {
        if (schedule instanceof __WEBPACK_IMPORTED_MODULE_3__Schedule__["a" /* Schedule */]) {
            this.applyGeneric(day, function (prop, frequency) { return schedule.setFrequency(prop, frequency); }, function (prop) { return schedule.setFrequency(prop); });
            schedule.updateChecks();
        }
        else {
            this.applyGeneric(day, function (prop, frequency) { return schedule[prop] = frequency; }, function (prop) { return delete schedule[prop]; });
        }
        return schedule;
    };
    /**
     * Applies this pattern to any object provided they implement the
     * `setFrequency` and `removeFrequency` functions.
     *
     * @param day The day to base the schedule on.
     * @param setFrequency The function which sets the frequency on the object.
     * @param removeFrequency The function to remove a frequency from the object.
     */
    Pattern.prototype.applyGeneric = function (day, setFrequency, removeFrequency) {
        for (var _i = 0, _a = Pattern.PROPS; _i < _a.length; _i++) {
            var prop = _a[_i];
            var rule = this.rules[prop];
            // Should have one value
            if (rule === 1) {
                setFrequency(prop, [day[prop]]);
            }
            // Can be any of the values in the array
            if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(rule)) {
                setFrequency(prop, rule);
            }
            // Must not be present
            if (!__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(rule)) {
                removeFrequency(prop);
            }
        }
    };
    /**
     * Determines whether the given [[Schedule]] or [[ScheduleInput]] matches this
     * pattern. Optionally a day can be provided to make sure the day matches the
     * schedule and pattern together.
     *
     * @param schedule The schedule input to test.
     * @param exactlyWith A day to further validate against for matching.
     * @returns `true` if the schedule was a match to this pattern with the
     *    day if one was provided, otherwise `false`.
     */
    Pattern.prototype.isMatch = function (schedule, exactlyWith) {
        if (schedule instanceof __WEBPACK_IMPORTED_MODULE_3__Schedule__["a" /* Schedule */]) {
            return this.isMatchGeneric(function (prop) { return schedule[prop].input; }, exactlyWith);
        }
        else {
            return this.isMatchGeneric(function (prop) { return schedule[prop]; }, exactlyWith);
        }
    };
    /**
     * Determines whether the given input matches this pattern. Optionally a day
     * can be provided to make sure the day matches the schedule and pattern
     * together.
     *
     * @param input The schedule input to test.
     * @param exactlyWith A day to further validate against for matching.
     * @returns `true` if the schedule input was a match to this pattern with the
     *    day if one was provided, otherwise `false`.
     */
    Pattern.prototype.isMatchGeneric = function (getFrequency, exactlyWith) {
        var exactly = __WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(exactlyWith);
        for (var _i = 0, _a = Pattern.PROPS; _i < _a.length; _i++) {
            var prop = _a[_i];
            var rule = this.rules[prop];
            var curr = getFrequency(prop);
            // Optional, skip it
            if (rule === false) {
                continue;
            }
            // Requires any value
            if (rule === true && !curr) {
                return false;
            }
            // Must not be present
            if (!__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isDefined(rule) && curr) {
                return false;
            }
            // Must be an array of the same size
            if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isNumber(rule)) {
                if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(curr) && curr.length === rule) {
                    if (exactly && curr.indexOf(exactlyWith[prop]) === -1) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            // Must be an array of the same values
            if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(rule)) {
                if (!__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isArray(curr)) {
                    return false;
                }
                if (rule.length !== curr.length) {
                    return false;
                }
                for (var i = 0; i < rule.length; i++) {
                    if (rule[i] !== curr[i]) {
                        return false;
                    }
                }
                if (exactly && rule.indexOf(exactlyWith[prop]) === -1) {
                    return false;
                }
            }
            // Must be an object with same over & offset.
            if (__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isObject(rule)) {
                if (!__WEBPACK_IMPORTED_MODULE_0__Functions__["a" /* Functions */].isObject(curr)) {
                    return false;
                }
                var ruleOffset = rule.offset || 0;
                var currOffset = curr.offset || 0;
                if (currOffset !== ruleOffset || curr.every !== rule.every) {
                    return false;
                }
                if (exactly && (exactlyWith[prop] % rule.every) !== ruleOffset) {
                    return false;
                }
            }
        }
        return true;
    };
    /**
     * Returns the pattern with the given name if one exists. If you add your own
     * patterns make sure to add them to [[PatternMap]].
     *
     * @param name The name of the pattern to return.
     * @return The instance to the pattern with the same name.
     */
    Pattern.withName = function (name) {
        return PatternMap[name];
    };
    /**
     * Finds a matching pattern to the given input searching through [[Patterns]]
     * for matches. Optionally it will only look at patterns where listed = `true`.
     *
     * @param input The schedule input to use.
     * @param listedOnly When `true` only patterns with [[Pattern.listed]] set to
     *    `true` will be looked at, otherwise all patterns are looked at.
     * @param exactlyWith  A day to further validate against for matching.
     * @see [[Pattern.isMatch]]
     */
    Pattern.findMatch = function (input, listedOnly, exactlyWith) {
        if (listedOnly === void 0) { listedOnly = true; }
        for (var _i = 0, Patterns_1 = Patterns; _i < Patterns_1.length; _i++) {
            var pattern = Patterns_1[_i];
            if ((pattern.listed || !listedOnly) && pattern.isMatch(input, exactlyWith)) {
                return pattern;
            }
        }
        return null;
    };
    /**
     * The properties in the [[ScheduleInput]] which are compared against the
     * rules of a pattern.
     */
    Pattern.PROPS = [
        'dayOfWeek', 'dayOfMonth', 'lastDayOfMonth', 'dayOfYear',
        'month', 'week', 'year',
        'weekOfYear', 'weekspanOfYear', 'fullWeekOfYear', 'lastWeekspanOfYear', 'lastFullWeekOfYear',
        'weekOfMonth', 'weekspanOfMonth', 'fullWeekOfMonth', 'lastWeekspanOfMonth', 'lastFullWeekOfMonth'
    ];
    return Pattern;
}());

/**
 * The list of patterns that can be searched through for matches to schedule
 * input.
 *
 * @see [[Pattern.findMatch]]
 */
var Patterns = [
    new Pattern('none', true, function (day) { return 'Does not repeat'; }, {
        year: 1,
        month: 1,
        dayOfMonth: 1
    }),
    new Pattern('daily', true, function (day) { return 'Daily'; }, {}),
    new Pattern('weekly', true, function (day) { return 'Weekly on ' + day.format('dddd'); }, {
        dayOfWeek: 1
    }),
    new Pattern('monthlyWeek', true, function (day) { return 'Monthly on the ' + __WEBPACK_IMPORTED_MODULE_1__Suffix__["a" /* Suffix */].CACHE[day.weekspanOfMonth + 1] + ' ' + day.format('dddd'); }, {
        dayOfWeek: 1,
        weekspanOfMonth: 1
    }),
    new Pattern('annually', true, function (day) { return 'Annually on ' + day.format('MMMM Do'); }, {
        month: 1,
        dayOfMonth: 1
    }),
    new Pattern('annuallyMonthWeek', true, function (day) { return 'Annually on the ' + __WEBPACK_IMPORTED_MODULE_1__Suffix__["a" /* Suffix */].CACHE[day.weekspanOfMonth + 1] + ' ' + day.format('dddd') + ' of ' + day.format('MMMM'); }, {
        month: 1,
        dayOfWeek: 1,
        weekspanOfMonth: 1
    }),
    new Pattern('weekday', true, function (day) { return 'Every weekday (Monday to Friday)'; }, {
        dayOfWeek: [__WEBPACK_IMPORTED_MODULE_2__Weekday__["a" /* Weekday */].MONDAY, __WEBPACK_IMPORTED_MODULE_2__Weekday__["a" /* Weekday */].TUESDAY, __WEBPACK_IMPORTED_MODULE_2__Weekday__["a" /* Weekday */].WEDNESDAY, __WEBPACK_IMPORTED_MODULE_2__Weekday__["a" /* Weekday */].THURSDAY, __WEBPACK_IMPORTED_MODULE_2__Weekday__["a" /* Weekday */].FRIDAY]
    }),
    new Pattern('monthly', true, function (day) { return 'Monthly on the ' + day.format('Do') + ' day'; }, {
        dayOfMonth: 1
    }),
    new Pattern('custom', true, function (day) { return 'Custom...'; }, {
        dayOfWeek: false,
        dayOfMonth: false,
        lastDayOfMonth: false,
        dayOfYear: false,
        year: false,
        month: false,
        week: false,
        weekOfYear: false,
        weekspanOfYear: false,
        fullWeekOfYear: false,
        lastWeekspanOfYear: false,
        lastFullWeekOfYear: false,
        weekOfMonth: false,
        weekspanOfMonth: false,
        fullWeekOfMonth: false,
        lastWeekspanOfMonth: false,
        lastFullWeekOfMonth: false
    })
];
/**
 * The map of patterns keyed by their name.
 *
 * @see [[Pattern.withName]]
 */
var PatternMap = {};
for (var _i = 0, Patterns_2 = Patterns; _i < Patterns_2.length; _i++) {
    var pattern = Patterns_2[_i];
    PatternMap[pattern.name] = pattern;
}
//# sourceMappingURL=Pattern.js.map

/***/ }),
/* 1124 */
/* exports provided: Sorts */
/* exports used: Sorts */
/*!*******************************!*\
  !*** ./~/dayspan/lib/Sort.js ***!
  \*******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sorts; });

/**
 * A class with [[SortEvent]] functions and functions which accept other
 * [[SortEvent]]s and return a new [[SortEvent]].
 *
 * ```typescript
 * // Sorts full day events first, then events in descending order based on start time.
 * Sorts.List([Sorts.FullDay, Sorts.Desc(Sorts.Start)]);
 * ```
 */
var Sorts = (function () {
    function Sorts() {
    }
    /**
     * Sorts the two events by their start time - the earliest event being first
     * in order.
     *
     * @param a The first event.
     * @param b The second event.
     * @returns The difference in time between the start of `a` and `b`.
     * @see [[CalendarEvent.time]]
     */
    Sorts.Start = function (a, b) {
        return a.time.start.time - b.time.start.time;
    };
    /**
     * Sorts the two events by their end time - the earliest to end being first
     * in order.
     *
     * @param a The first event.
     * @param b The second event.
     * @returns The difference in time between the end of `a` and `b`.
     * @see [[CalendarEvent.time]]
     */
    Sorts.End = function (a, b) {
        return a.time.end.time - b.time.end.time;
    };
    /**
     * Sorts the two events placing the full day events before the timed events.
     *
     * @param a The first event.
     * @param b The second event.
     * @returns If both are timed or both are full day then `0` is returned,
     *    otherwise `-1` is returned if `a` is full day and `1` is returned if
     *    `b` is full day.
     * @see [[CalendarEvent.fullDay]]
     */
    Sorts.FullDay = function (a, b) {
        var af = a.fullDay ? 0 : 1;
        var bf = b.fullDay ? 0 : 1;
        return af - bf;
    };
    /**
     * Sorts the two events placing the shorter events before the longer events.
     * Full day or multiple day events actually take up a day and will be ordered
     * last.
     *
     * @param a The first event.
     * @param b The second event.
     * @returns The difference in milliseconds between `a` and `b`.
     * @see [[CalendarEvent.time]]
     * @see [[DaySpan.millis]]
     */
    Sorts.Duration = function (a, b) {
        return a.time.millis() - b.time.millis();
    };
    /**
     * Returns a [[SortEvent]] that effectively orders the given sorter in the
     * opposite (often descending) order.
     *
     * @param sorter The sorter to reverse.
     * @returns A new sorter which reverses the one passed in.
     */
    Sorts.Desc = function (sorter) {
        return function (a, b) {
            return sorter(b, a);
        };
    };
    /**
     * Returns a [[SortEvent]] that orders the events based on a string in each
     * event. A function must be supplied which takes an event of type `T` and
     * returns a string.
     *
     * @param getString A function which returns a string from the event.
     * @returns A sorter which sorts strings alphabetically.
     */
    Sorts.Alphabetical = function (getString) {
        return function (a, b) {
            var as = getString(a.event) || '';
            var bs = getString(b.event) || '';
            return as.localeCompare(bs);
        };
    };
    /**
     * Returns a [[SortEvent]] that orders events based on a number in each event.
     * A function must be supplied which takes an event of type `T` and returns
     * a number.
     *
     * @param getOrder A function which returns a number from the event.
     * @returns A sorter which sorts events based on a number in ascending order.
     */
    Sorts.Ordered = function (getOrder) {
        return function (a, b) {
            var ao = getOrder(a.event);
            var bo = getOrder(b.event);
            return ao - bo;
        };
    };
    /**
     * Returns a [[SortEvent]] that orders events based on an array of sorters.
     * The first sorter which returns a non-zero result is used.
     *
     * @param sorters A list of sorting functions to test one at a time.
     * @returns A sorter which sorts based on a list of sorters.
     */
    Sorts.List = function (sorters) {
        return function (a, b) {
            for (var _i = 0, sorters_1 = sorters; _i < sorters_1.length; _i++) {
                var sorter = sorters_1[_i];
                var compare = sorter(a, b);
                if (compare !== 0) {
                    return compare;
                }
            }
            return 0;
        };
    };
    return Sorts;
}());

//# sourceMappingURL=Sort.js.map

/***/ }),
/* 1125 */
/* no static exports found */
/* all exports used */
/*!*****************************!*\
  !*** ./~/debounce/index.js ***!
  \*****************************/
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 1126 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./client/assets/fonts/fonts.css ***!
  \***************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./client/template/assets/plugins/jquery-scrollbar/jquery.scrollbar.css ***!
  \******************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./client/template/pages/css/pages.css ***!
  \*********************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/bootstrap-vue/dist/bootstrap-vue.css ***!
  \************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/bootstrap/dist/css/bootstrap.min.css ***!
  \************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/font-awesome/css/font-awesome.css ***!
  \*********************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./~/reset-css/reset.css ***!
  \*******************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./~/toastr/build/toastr.min.css ***!
  \***************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./~/vue-select/dist/vue-select.css ***!
  \******************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./client/assets/icones_app/arrow.svg ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow.svg?dfa259b4c9d006b475d61fd27a8a6e20";

/***/ }),
/* 1136 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./client/assets/icones_app/bandeira_azul.svg ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bandeira_azul.svg?5c7d47f57e291176f21e02d9a725d989";

/***/ }),
/* 1137 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./client/assets/icones_app/cobranca_zaul.svg ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cobranca_zaul.svg?54d397b4d428138cb989cfbb28550b2f";

/***/ }),
/* 1138 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./client/assets/icones_app/extrato_azul.svg ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "extrato_azul.svg?d928506c6864eb4b024a9fa085bd3555";

/***/ }),
/* 1139 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./client/assets/logos_equals/logo_equals_inicial.svg ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_equals_inicial.svg?2f21141425abb979746f279fc112e316";

/***/ }),
/* 1140 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./client/assets/logos_equals/logo_equals_quadrado.svg ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_equals_quadrado.svg?b176262c1ad86ac6fea2c75fefc2e8cd";

/***/ }),
/* 1141 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/highcharts-grouped-categories/grouped-categories.js ***!
  \***************************************************************/
/***/ (function(module, exports) {

/* global Highcharts module */
(function (factory) {
	if (typeof module === 'object' && module.exports) {
		module.exports = factory;
	} else {
		factory(Highcharts);
	}
}(function (HC) {
	'use strict';
	/**
	 * Grouped Categories v1.3.2 (2023-06-05)
	 *
	 * (c) 2012-2023 Black Label
	 *
	 * License: Creative Commons Attribution (CC)
	 */

	/* jshint expr:true, boss:true */
	var UNDEFINED = void 0,
		mathRound = Math.round,
		mathMin = Math.min,
		mathMax = Math.max,
		merge = HC.merge,
		pick = HC.pick,
		each = HC.each,

		// cache prototypes
		axisProto = HC.Axis.prototype,
		tickProto = HC.Tick.prototype,

		// cache original methods
		protoAxisInit = axisProto.init,
		protoAxisRender = axisProto.render,
		protoAxisSetCategories = axisProto.setCategories,
		protoTickGetLabelSize = tickProto.getLabelSize,
		protoTickAddLabel = tickProto.addLabel,
		protoTickDestroy = tickProto.destroy,
		protoTickRender = tickProto.render;

	function deepClone(thing) {
		return JSON.parse(JSON.stringify(thing));
	}

	function Category(obj, parent) {
		this.userOptions = deepClone(obj);
		this.name = obj.name || obj;
		this.parent = parent;

		return this;
	}

	Category.prototype.toString = function () {
		var parts = [],
			cat = this;

		while (cat) {
			parts.push(cat.name);
			cat = cat.parent;
		}

		return parts.join(', ');
	};

	// returns sum of an array
	function sum(arr) {
		var l = arr.length,
			x = 0;

		while (l--) {
			x += arr[l];
		}

		return x;
	}

	// Adds category leaf to array
	function addLeaf(out, cat, parent) {
		out.unshift(new Category(cat, parent));

		while (parent) {
			parent.leaves = parent.leaves ? (parent.leaves + 1) : 1;
			parent = parent.parent;
		}
	}

	// Builds reverse category tree
	function buildTree(cats, out, options, parent, depth) {
		var len = cats.length,
			cat;

		depth = depth ? depth : 0;
		options.depth = options.depth ? options.depth : 0;

		while (len--) {
			cat = cats[len];
			
			if (cat.categories) {
				if (parent) {
					cat.parent = parent;
				}
				buildTree(cat.categories, out, options, cat, depth + 1);
			} else {
				addLeaf(out, cat, parent);
			}
		}
		options.depth = mathMax(options.depth, depth);
	}

	// Pushes part of grid to path
	function addGridPart(path, d, width) {
		// Based on crispLine from HC (#65)
		if (d[0] === d[2]) {
			d[0] = d[2] = mathRound(d[0]) - (width % 2 / 2);
		}
		if (d[1] === d[3]) {
			d[1] = d[3] = mathRound(d[1]) + (width % 2 / 2);
		}

		path.push(
			'M',
			d[0], d[1],
			'L',
			d[2], d[3]
		);
	}

	// Returns tick position
	function tickPosition(tick, pos) {
		return tick.getPosition(tick.axis.horiz, pos, tick.axis.tickmarkOffset);
	}

	function walk(arr, key, fn) {
		var l = arr.length,
			children;

		while (l--) {
			children = arr[l][key];

			if (children) {
				walk(children, key, fn);
			}
			fn(arr[l]);
		}
	}

	// Create local function `fontMetrics` to provide compatibility with HC 11 (#200)
	function fontMetrics(fontSize, elem) {
		if ((HC.SVGRenderer.styledMode || !/px/.test(fontSize)) &&
			(HC.win.getComputedStyle) // old IE doesn't support it
		) {
			fontSize = elem && HC.SVGElement.prototype.getStyle.call(elem, 'font-size');
		} else {
			fontSize = fontSize ||
				// When the elem is a DOM element (#5932)
				(elem && elem.style && elem.style.fontSize) ||
				// Fall back on the renderer style default
				(HC.SVGRenderer.style && HC.SVGRenderer.style.fontSize);
		}
		// Handle different units
		if (/px/.test(fontSize)) {
			fontSize = HC.pInt(fontSize);
		} else {
			fontSize = 12;
		}
		// Empirical values found by comparing font size and bounding box
		// height. Applies to the default font family.
		// https://jsfiddle.net/highcharts/7xvn7/
		var lineHeight = (fontSize < 24 ?
				fontSize + 3 :
				Math.round(fontSize * 1.2)),
			baseline = Math.round(lineHeight * 0.8);
		return {
			h: lineHeight,
			b: baseline,
			f: fontSize
		};
	}

	//
	// Axis prototype
	//

	axisProto.init = function (chart, options, coll) {
		// default behaviour
		protoAxisInit.call(this, chart, options, coll);

		if (typeof options === 'object' && options.categories) {
			this.setupGroups(options);
		}
	};

	// setup required axis options
	axisProto.setupGroups = function (options) {
		var categories = deepClone(options.categories),
			reverseTree = [],
			stats = {},
			labelOptions = this.options.labels,
			userAttr = labelOptions.groupedOptions,
			css = labelOptions.style;

		// build categories tree
		buildTree(categories, reverseTree, stats);

		// set axis properties
		this.categoriesTree = categories;
		this.categories = reverseTree;
		this.isGrouped = stats.depth !== 0;
		this.labelsDepth = stats.depth;
		this.labelsSizes = [];
		this.labelsGridPath = [];
		this.tickLength = options.tickLength || this.tickLength || null;
		// #66: tickWidth for x axis defaults to 1, for y to 0
		this.tickWidth = pick(options.tickWidth, this.isXAxis ? 1 : 0);
		this.directionFactor = [-1, 1, 1, -1][this.side];
		this.options.lineWidth = pick(options.lineWidth, 1);
		// #85: align labels vertically
		this.groupFontHeights = [];
		for (var i = 0; i <= stats.depth; i++) {
			var hasOptions = userAttr && userAttr[i - 1],
				mergedCSS = hasOptions && userAttr[i - 1].style ? merge(css, userAttr[i - 1].style) : css;
			this.groupFontHeights[i] = Math.round(fontMetrics(mergedCSS ? mergedCSS.fontSize : 0).b * 0.3);
		}
	};


	axisProto.render = function () {
		// clear grid path
		if (this.isGrouped) {
			this.labelsGridPath = [];
		}

		// cache original tick length
		if (this.originalTickLength === UNDEFINED) {
			this.originalTickLength = this.options.tickLength;
		}

		// use default tickLength for not-grouped axis
		// and generate grid on grouped axes,
		// use tiny number to force highcharts to hide tick
		this.options.tickLength = this.isGrouped ? 0.001 : this.originalTickLength;

		protoAxisRender.call(this);

		if (!this.isGrouped) {
			if (this.labelsGrid) {
				this.labelsGrid.attr({
					visibility: 'hidden'
				});
			}
			return false;
		}

		var axis = this,
			options = axis.options,
			top = axis.top,
			left = axis.left,
			right = left + axis.width,
			bottom = top + axis.height,
			visible = axis.hasVisibleSeries || axis.hasData,
			depth = axis.labelsDepth,
			grid = axis.labelsGrid,
			horiz = axis.horiz,
			d = axis.labelsGridPath,
			i = options.drawHorizontalBorders === false ? (depth + 1) : 0,
			offset = axis.opposite ? (horiz ? top : right) : (horiz ? bottom : left),
			tickWidth = axis.tickWidth,
			part;

		if (axis.userTickLength) {
			depth -= 1;
		}

		// render grid path for the first time
		if (!grid) {
			grid = axis.labelsGrid = axis.chart.renderer.path()
			.attr({
				// #58: use tickWidth/tickColor instead of lineWidth/lineColor:
				strokeWidth: tickWidth, // < 4.0.3
				'stroke-width': tickWidth, // 4.0.3+ #30
				stroke: options.tickColor || '' // for styled mode (tickColor === undefined)
			})
			.add(axis.axisGroup);
			// for styled mode - add class
			if (!options.tickColor) {
				grid.addClass('highcharts-tick');
			}
		}

		// go through every level and draw horizontal grid line
		while (i <= depth) {
			offset += axis.groupSize(i);

			part = horiz ?
				[left, offset, right, offset] :
				[offset, top, offset, bottom];

			addGridPart(d, part, tickWidth);
			i++;
		}

		// draw grid path
		grid.attr({
			d: d,
			visibility: visible ? 'visible' : 'hidden'
		});

		axis.labelGroup.attr({
			visibility: visible ? 'visible' : 'hidden'
		});


		walk(axis.categoriesTree, 'categories', function (group) {
			var tick = group.tick;

			if (!tick) {
				return false;
			}
			if (tick.startAt + tick.leaves - 1 < axis.min || tick.startAt > axis.max) {
				tick.label.hide();
				tick.destroyed = 0;
			} else {
				tick.label.attr({
					visibility: visible ? 'visible' : 'hidden'
				});
			}
			return true;
		});
		return true;
	};

	axisProto.setCategories = function (newCategories, doRedraw) {
		if (this.categories) {
			this.cleanGroups();
		}
		this.setupGroups({
			categories: newCategories
		});
		this.categories = this.userOptions.categories = newCategories;
		protoAxisSetCategories.call(this, this.categories, doRedraw);
	};

	// cleans old categories
	axisProto.cleanGroups = function () {
		var ticks = this.ticks,
			n;

		for (n in ticks) {
			if (ticks[n].parent) {
				delete ticks[n].parent;
			}
		}
		walk(this.categoriesTree, 'categories', function (group) {
			var tick = group.tick;
			
			if (!tick) {
				return false;
			}
			tick.label.destroy();
			
			each(tick, function (v, i) {
				delete tick[i];
			});
			delete group.tick;
			
			return true;
		});
		this.labelsGrid = null;
	};

	// keeps size of each categories level
	axisProto.groupSize = function (level, position) {
		var positions = this.labelsSizes,
			direction = this.directionFactor,
			groupedOptions = this.options.labels.groupedOptions ? this.options.labels.groupedOptions[level - 1] : false,
			userXY = 0;

		if (groupedOptions) {
			if (direction === -1) {
				userXY = groupedOptions.x ? groupedOptions.x : 0;
			} else {
				userXY = groupedOptions.y ? groupedOptions.y : 0;
			}
		}

		if (position !== UNDEFINED) {
			positions[level] = mathMax(positions[level] || 0, position + 10 + Math.abs(userXY));
		}

		if (level === true) {
			return sum(positions) * direction;
		} else if (positions[level]) {
			return positions[level] * direction;
		}

		return 0;
	};

	//
	// Tick prototype
	//

	// Override methods prototypes
	tickProto.addLabel = function () {
		var tick = this,
			axis = tick.axis,
			labelOptions = pick(
				tick.options && tick.options.labels,
				axis.options.labels
			),
			category,
			formatter;
		
		protoTickAddLabel.call(tick);
		
		if (!axis.categories || !(category = axis.categories[tick.pos])) {
			return false;
		}
		
		// set label text - but applied after formatter #46
		if (tick.label) {
			formatter = function (ctx) {
				if (labelOptions.formatter) {
					return labelOptions.formatter.call(ctx, ctx);
				}
				if (labelOptions.format) {
					ctx.text = axis.defaultLabelFormatter.call(ctx);
					return HC.format(labelOptions.format, ctx, axis.chart);
				}
				return axis.defaultLabelFormatter.call(ctx, ctx);
			};

			tick.label.attr('text', formatter({
				axis: axis,
				chart: axis.chart,
				isFirst: tick.isFirst,
				isLast: tick.isLast,
				value: category.name,
				pos: tick.pos
			}));

			// update with new text length, since textSetter removes the size caches when text changes. #137
			tick.label.textPxLength = tick.label.getBBox().width;
		}
		
		// create elements for parent categories
		if (axis.isGrouped && axis.options.labels.enabled) {
			tick.addGroupedLabels(category);
		}
		return true;
	};

	// render ancestor label
	tickProto.addGroupedLabels = function (category) {
		var tick = this,
			axis = this.axis,
			chart = axis.chart,
			options = axis.options.labels,
			useHTML = options.useHTML,
			css = options.style,
			userAttr = options.groupedOptions,
			attr = {
				align: 'center',
				rotation: options.rotation,
				x: 0,
				y: 0
			},
			size = axis.horiz ? 'height' : 'width',
			depth = 0,
			label;


		while (tick) {
			if (depth > 0 && !category.tick) {
				// render label element
				this.value = category.name;
				var name = options.formatter ? options.formatter.call(this, category) : category.name,
					hasOptions = userAttr && userAttr[depth - 1],
					mergedAttrs = hasOptions ? merge(attr, userAttr[depth - 1]) : attr,
					mergedCSS = hasOptions && userAttr[depth - 1].style ? merge(css, userAttr[depth - 1].style) : css;

				// #63: style is passed in CSS and not as an attribute
				delete mergedAttrs.style;

				label = chart.renderer.text(name, 0, 0, useHTML)
					.attr(mergedAttrs)
					.add(axis.labelGroup);

				// css should only be set for non styledMode configuration. #167
				if (label && !chart.styledMode) {
					label.css(mergedCSS);
				}

				// tick properties
				tick.startAt = this.pos;
				tick.childCount = category.categories.length;
				tick.leaves = category.leaves;
				tick.visible = this.childCount;
				tick.label = label;
				tick.labelOffsets = {
					x: mergedAttrs.x,
					y: mergedAttrs.y
				};

				// link tick with category
				category.tick = tick;
			}

			// set level size, #93
			if (tick && tick.label) {
				axis.groupSize(depth, tick.label.getBBox()[size]);
			}

			// go up to the parent category
			category = category.parent;

			if (category) {
				tick = tick.parent = category.tick || {};
			} else {
				tick = null;
			}

			depth++;
		}
	};

	// set labels position & render categories grid
	tickProto.render = function (index, old, opacity) {
		protoTickRender.call(this, index, old, opacity);

		var treeCat = this.axis.categories && this.axis.categories[this.pos];

		if (!this.axis.isGrouped || !treeCat || this.pos > this.axis.max) {
			return;
		}

		var tick = this,
			group = tick,
			axis = tick.axis,
			tickPos = tick.pos,
			isFirst = tick.isFirst,
			max = axis.max,
			min = axis.min,
			horiz = axis.horiz,
			grid = axis.labelsGridPath,
			size = axis.groupSize(0),
			tickWidth = axis.tickWidth,
			xy = tickPosition(tick, tickPos),
			start = horiz ? xy.y : xy.x,
			baseLine = fontMetrics(axis.options.labels.style ? axis.options.labels.style.fontSize : 0).b,
			depth = 1,
			reverseCrisp = ((horiz && xy.x === axis.pos + axis.len) || (!horiz && xy.y === axis.pos)) ? -1 : 0, // adjust grid lines for edges
			gridAttrs,
			lvlSize,
			minPos,
			maxPos,
			attrs,
			bBox;

		// render grid for "normal" categories (first-level), render left grid line only for the first category
		if (isFirst) {
			gridAttrs = horiz ?
				[axis.left, xy.y, axis.left, xy.y + axis.groupSize(true)] : axis.isXAxis ?
					[xy.x, axis.top, xy.x + axis.groupSize(true), axis.top] : [xy.x, axis.top + axis.len, xy.x + axis.groupSize(true), axis.top + axis.len];

			addGridPart(grid, gridAttrs, tickWidth);
		}

		if (horiz && axis.left < xy.x) {
			addGridPart(grid, [xy.x - reverseCrisp, xy.y, xy.x - reverseCrisp, xy.y + size], tickWidth);
		} else if (!horiz && axis.top <= xy.y) {
			addGridPart(grid, [xy.x, xy.y + reverseCrisp, xy.x + size, xy.y + reverseCrisp], tickWidth);
		}

		size = start + size;

		function fixOffset(tCat) {
			var ret = 0;
			if (isFirst) {
				ret = tCat.parent.categories.indexOf(tCat.name);
				ret = ret < 0 ? 0 : ret;
				return ret;
			}
			return ret;
		}


		while (group.parent) {
			group = group.parent;
			
			var fix = fixOffset(treeCat),
				userX = group.labelOffsets.x,
				userY = group.labelOffsets.y;
			
			minPos = tickPosition(tick, mathMax(group.startAt - 1, min - 1));
			maxPos = tickPosition(tick, mathMin(group.startAt + group.leaves - 1 - fix, max));
			bBox = group.label.getBBox(true);
			lvlSize = axis.groupSize(depth);
			// check if on the edge to adjust
			reverseCrisp = ((horiz && maxPos.x === axis.pos + axis.len) || (!horiz && maxPos.y === axis.pos)) ? -1 : 0;
			
			attrs = horiz ? {
				x: (minPos.x + maxPos.x) / 2 + userX,
				y: size + axis.groupFontHeights[depth] + lvlSize / 2 + userY / 2
			} : {
				x: size + lvlSize / 2 + userX,
				y: (minPos.y + maxPos.y - bBox.height) / 2 + baseLine + userY
			};
			
			if (!isNaN(attrs.x) && !isNaN(attrs.y)) {
				group.label.attr(attrs);

				if (grid) {
					if (horiz && axis.left < maxPos.x) {
						addGridPart(grid, [maxPos.x - reverseCrisp, size, maxPos.x - reverseCrisp, size + lvlSize], tickWidth);
					} else if (!horiz && axis.top <= maxPos.y) {
						addGridPart(grid, [size, maxPos.y + reverseCrisp, size + lvlSize, maxPos.y + reverseCrisp], tickWidth);
					}
				}
			}

			size += lvlSize;
			depth++;
		}
	};

	tickProto.destroy = function () {
		var group = this.parent;

		while (group) {
			group.destroyed = group.destroyed ? (group.destroyed + 1) : 1;
			group = group.parent;
		}

		protoTickDestroy.call(this);
	};

	// return size of the label (height for horizontal, width for vertical axes)
	tickProto.getLabelSize = function () {
		if (this.axis.isGrouped === true) {
			// #72, getBBox might need recalculating when chart is tall
			var size = protoTickGetLabelSize.call(this) + 10,
				topLabelSize = this.axis.labelsSizes[0];
			if (topLabelSize < size) {
				this.axis.labelsSizes[0] = size;
			}
			return sum(this.axis.labelsSizes);
		}
		return protoTickGetLabelSize.call(this);
	};
	
	// Since datasorting is not supported by the plugin,
	// override replaceMovedLabel method, #146.
	HC.wrap(HC.Tick.prototype, 'replaceMovedLabel', function (proceed) {
		if (!this.axis.isGrouped) {
			proceed.apply(this, Array.prototype.slice.call(arguments, 1));
		}
	});

}));


/***/ }),
/* 1142 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/highcharts-no-data-to-display/no-data-to-display.js ***!
  \***************************************************************/
/***/ (function(module, exports) {

/*
 Highcharts JS v6.0.4 (2017-12-15)
 Plugin for displaying a message when there is no data visible in chart.

 (c) 2010-2017 Highsoft AS
 Author: Oystein Moseng

 License: www.highcharts.com/license
*/
(function(c){"object"===typeof module&&module.exports?module.exports=c:c(Highcharts)})(function(c){(function(d){var c=d.seriesTypes,e=d.Chart.prototype,f=d.getOptions(),g=d.extend,h=d.each;g(f.lang,{noData:"No data to display"});f.noData={position:{x:0,y:0,align:"center",verticalAlign:"middle"}};f.noData.style={fontWeight:"bold",fontSize:"12px",color:"#666666"};h("bubble gauge heatmap pie sankey treemap waterfall".split(" "),function(b){c[b]&&(c[b].prototype.hasData=function(){return!!this.points.length})});
d.Series.prototype.hasData=function(){return this.visible&&void 0!==this.dataMax&&void 0!==this.dataMin};e.showNoData=function(b){var a=this.options;b=b||a.lang.noData;a=a.noData;this.noDataLabel||(this.noDataLabel=this.renderer.label(b,0,0,null,null,null,a.useHTML,null,"no-data"),this.noDataLabel.attr(a.attr).css(a.style),this.noDataLabel.add(),this.noDataLabel.align(g(this.noDataLabel.getBBox(),a.position),!1,"plotBox"))};e.hideNoData=function(){this.noDataLabel&&(this.noDataLabel=this.noDataLabel.destroy())};
e.hasData=function(){for(var b=this.series,a=b.length;a--;)if(b[a].hasData()&&!b[a].options.isInternal)return!0;return this.loadingShown};d.addEvent(e,"render",function(){this.hasData()?this.hideNoData():this.showNoData()})})(c)});


/***/ }),
/* 1143 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./~/highcharts/modules/exporting.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v8.2.2 (2020-10-22)

 Exporting module

 (c) 2010-2019 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(e){"object"===typeof module&&module.exports?(e["default"]=e,module.exports=e): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! highcharts */ 280)], __WEBPACK_AMD_DEFINE_RESULT__ = function(q){e(q);e.Highcharts=q;return e}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):e("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(e){function q(e,l,g,k){e.hasOwnProperty(l)||(e[l]=k.apply(null,g))}e=e?e._modules:{};q(e,"Extensions/FullScreen.js",[e["Core/Chart/Chart.js"],e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,l,g){var k=g.addEvent;
g=function(){function e(f){this.chart=f;this.isOpen=!1;f=f.renderTo;this.browserProps||("function"===typeof f.requestFullscreen?this.browserProps={fullscreenChange:"fullscreenchange",requestFullscreen:"requestFullscreen",exitFullscreen:"exitFullscreen"}:f.mozRequestFullScreen?this.browserProps={fullscreenChange:"mozfullscreenchange",requestFullscreen:"mozRequestFullScreen",exitFullscreen:"mozCancelFullScreen"}:f.webkitRequestFullScreen?this.browserProps={fullscreenChange:"webkitfullscreenchange",
requestFullscreen:"webkitRequestFullScreen",exitFullscreen:"webkitExitFullscreen"}:f.msRequestFullscreen&&(this.browserProps={fullscreenChange:"MSFullscreenChange",requestFullscreen:"msRequestFullscreen",exitFullscreen:"msExitFullscreen"}))}e.prototype.close=function(){var f=this.chart;if(this.isOpen&&this.browserProps&&f.container.ownerDocument instanceof Document)f.container.ownerDocument[this.browserProps.exitFullscreen]();this.unbindFullscreenEvent&&this.unbindFullscreenEvent();this.isOpen=!1;
this.setButtonText()};e.prototype.open=function(){var f=this,e=f.chart;if(f.browserProps){f.unbindFullscreenEvent=k(e.container.ownerDocument,f.browserProps.fullscreenChange,function(){f.isOpen?(f.isOpen=!1,f.close()):(f.isOpen=!0,f.setButtonText())});var g=e.renderTo[f.browserProps.requestFullscreen]();if(g)g["catch"](function(){alert("Full screen is not supported inside a frame.")});k(e,"destroy",f.unbindFullscreenEvent)}};e.prototype.setButtonText=function(){var f,e=this.chart,g=e.exportDivElements,
k=e.options.exporting,l=null===(f=null===k||void 0===k?void 0:k.buttons)||void 0===f?void 0:f.contextButton.menuItems;f=e.options.lang;(null===k||void 0===k?0:k.menuItemDefinitions)&&(null===f||void 0===f?0:f.exitFullscreen)&&f.viewFullscreen&&l&&g&&g.length&&(g[l.indexOf("viewFullscreen")].innerHTML=this.isOpen?f.exitFullscreen:k.menuItemDefinitions.viewFullscreen.text||f.viewFullscreen)};e.prototype.toggle=function(){this.isOpen?this.close():this.open()};return e}();l.Fullscreen=g;k(e,"beforeRender",
function(){this.fullscreen=new l.Fullscreen(this)});return l.Fullscreen});q(e,"Mixins/Navigation.js",[],function(){return{initUpdate:function(e){e.navigation||(e.navigation={updates:[],update:function(e,g){this.updates.forEach(function(k){k.update.call(k.context,e,g)})}})},addUpdate:function(e,l){l.navigation||this.initUpdate(l);l.navigation.updates.push({update:e,context:l})}}});q(e,"Extensions/Exporting.js",[e["Core/Chart/Chart.js"],e["Mixins/Navigation.js"],e["Core/Globals.js"],e["Core/Options.js"],
e["Core/Renderer/SVG/SVGRenderer.js"],e["Core/Utilities.js"]],function(e,l,g,k,q,f){var A=g.doc,H=g.isTouchDevice,y=g.win;k=k.defaultOptions;var v=f.addEvent,r=f.css,x=f.createElement,D=f.discardElement,z=f.extend,I=f.find,C=f.fireEvent,J=f.isObject,p=f.merge,E=f.objectEach,t=f.pick,K=f.removeEvent,L=f.uniqueKey,F=y.navigator.userAgent,G=g.Renderer.prototype.symbols,M=/Edge\/|Trident\/|MSIE /.test(F),N=/firefox/i.test(F);z(k.lang,{viewFullscreen:"View in full screen",exitFullscreen:"Exit from full screen",
printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"});k.navigation||(k.navigation={});p(!0,k.navigation,{buttonOptions:{theme:{},symbolSize:14,symbolX:12.5,symbolY:10.5,align:"right",buttonSpacing:3,height:22,verticalAlign:"top",width:24}});p(!0,k.navigation,{menuStyle:{border:"1px solid #999999",background:"#ffffff",padding:"5px 0"},menuItemStyle:{padding:"0.5em 1em",
color:"#333333",background:"none",fontSize:H?"14px":"11px",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#335cad",color:"#ffffff"},buttonOptions:{symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{padding:5}}});k.exporting={type:"image/png",url:"https://export.highcharts.com/",printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",titleKey:"contextButtonTitle",menuItems:"viewFullscreen printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")}},
menuItemDefinitions:{viewFullscreen:{textKey:"viewFullscreen",onclick:function(){this.fullscreen.toggle()}},printChart:{textKey:"printChart",onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",
onclick:function(){this.exportChart({type:"image/svg+xml"})}}}};g.post=function(a,b,c){var d=x("form",p({method:"post",action:a,enctype:"multipart/form-data"},c),{display:"none"},A.body);E(b,function(a,b){x("input",{type:"hidden",name:b,value:a},null,d)});d.submit();D(d)};g.isSafari&&g.win.matchMedia("print").addListener(function(a){g.printingChart&&(a.matches?g.printingChart.beforePrint():g.printingChart.afterPrint())});z(e.prototype,{sanitizeSVG:function(a,b){var c=a.indexOf("</svg>")+6,d=a.substr(c);
a=a.substr(0,c);b&&b.exporting&&b.exporting.allowHTML&&d&&(d='<foreignObject x="0" y="0" width="'+b.chart.width+'" height="'+b.chart.height+'"><body xmlns="http://www.w3.org/1999/xhtml">'+d.replace(/(<(?:img|br).*?(?=>))>/g,"$1 />")+"</body></foreignObject>",a=a.replace("</svg>",d+"</svg>"));a=a.replace(/zIndex="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(.*?)("|&quot;);?\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,
'<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+:)href=/g," xlink:href=").replace(/\n/," ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g,"\u00a0").replace(/&shy;/g,"\u00ad");this.ieSanitizeSVG&&(a=this.ieSanitizeSVG(a));return a},getChartHTML:function(){this.styledMode&&this.inlineStyles();return this.container.innerHTML},getSVG:function(a){var b,c=p(this.options,a);c.plotOptions=p(this.userOptions.plotOptions,
a&&a.plotOptions);c.time=p(this.userOptions.time,a&&a.time);var d=x("div",null,{position:"absolute",top:"-9999em",width:this.chartWidth+"px",height:this.chartHeight+"px"},A.body);var f=this.renderTo.style.width;var w=this.renderTo.style.height;f=c.exporting.sourceWidth||c.chart.width||/px$/.test(f)&&parseInt(f,10)||(c.isGantt?800:600);w=c.exporting.sourceHeight||c.chart.height||/px$/.test(w)&&parseInt(w,10)||400;z(c.chart,{animation:!1,renderTo:d,forExport:!0,renderer:"SVGRenderer",width:f,height:w});
c.exporting.enabled=!1;delete c.data;c.series=[];this.series.forEach(function(a){b=p(a.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:a.visible});b.isInternal||c.series.push(b)});this.axes.forEach(function(a){a.userOptions.internalKey||(a.userOptions.internalKey=L())});var g=new e(c,this.callback);a&&["xAxis","yAxis","series"].forEach(function(b){var d={};a[b]&&(d[b]=a[b],g.update(d))});this.axes.forEach(function(a){var b=I(g.axes,function(b){return b.options.internalKey===
a.userOptions.internalKey}),d=a.getExtremes(),c=d.userMin;d=d.userMax;b&&("undefined"!==typeof c&&c!==b.min||"undefined"!==typeof d&&d!==b.max)&&b.setExtremes(c,d,!0,!1)});f=g.getChartHTML();C(this,"getSVG",{chartCopy:g});f=this.sanitizeSVG(f,c);c=null;g.destroy();D(d);return f},getSVGForExport:function(a,b){var c=this.options.exporting;return this.getSVG(p({chart:{borderRadius:0}},c.chartOptions,b,{exporting:{sourceWidth:a&&a.sourceWidth||c.sourceWidth,sourceHeight:a&&a.sourceHeight||c.sourceHeight}}))},
getFilename:function(){var a=this.userOptions.title&&this.userOptions.title.text,b=this.options.exporting.filename;if(b)return b.replace(/\//g,"-");"string"===typeof a&&(b=a.toLowerCase().replace(/<\/?[^>]+(>|$)/g,"").replace(/[\s_]+/g,"-").replace(/[^a-z0-9\-]/g,"").replace(/^[\-]+/g,"").replace(/[\-]+/g,"-").substr(0,24).replace(/[\-]+$/g,""));if(!b||5>b.length)b="chart";return b},exportChart:function(a,b){b=this.getSVGForExport(a,b);a=p(this.options.exporting,a);g.post(a.url,{filename:a.filename?
a.filename.replace(/\//g,"-"):this.getFilename(),type:a.type,width:a.width||0,scale:a.scale,svg:b},a.formAttributes)},moveContainers:function(a){(this.fixedDiv?[this.fixedDiv,this.scrollingContainer]:[this.container]).forEach(function(b){a.appendChild(b)})},beforePrint:function(){var a=A.body,b=this.options.exporting.printMaxWidth,c={childNodes:a.childNodes,origDisplay:[],resetParams:void 0};this.isPrinting=!0;this.pointer.reset(null,0);C(this,"beforePrint");b&&this.chartWidth>b&&(c.resetParams=[this.options.chart.width,
void 0,!1],this.setSize(b,void 0,!1));[].forEach.call(c.childNodes,function(a,b){1===a.nodeType&&(c.origDisplay[b]=a.style.display,a.style.display="none")});this.moveContainers(a);this.printReverseInfo=c},afterPrint:function(){if(this.printReverseInfo){var a=this.printReverseInfo.childNodes,b=this.printReverseInfo.origDisplay,c=this.printReverseInfo.resetParams;this.moveContainers(this.renderTo);[].forEach.call(a,function(a,c){1===a.nodeType&&(a.style.display=b[c]||"")});this.isPrinting=!1;c&&this.setSize.apply(this,
c);delete this.printReverseInfo;delete g.printingChart;C(this,"afterPrint")}},print:function(){var a=this;a.isPrinting||(g.printingChart=a,g.isSafari||a.beforePrint(),setTimeout(function(){y.focus();y.print();g.isSafari||setTimeout(function(){a.afterPrint()},1E3)},1))},contextMenu:function(a,b,c,d,e,g,k){var h=this,w=h.options.navigation,l=h.chartWidth,B=h.chartHeight,n="cache-"+a,m=h[n],u=Math.max(e,g);if(!m){h.exportContextMenu=h[n]=m=x("div",{className:a},{position:"absolute",zIndex:1E3,padding:u+
"px",pointerEvents:"auto"},h.fixedDiv||h.container);var p=x("ul",{className:"highcharts-menu"},{listStyle:"none",margin:0,padding:0},m);h.styledMode||r(p,z({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},w.menuStyle));m.hideMenu=function(){r(m,{display:"none"});k&&k.setState(0);h.openMenu=!1;r(h.renderTo,{overflow:"hidden"});f.clearTimeout(m.hideTimer);C(h,"exportMenuHidden")};h.exportEvents.push(v(m,"mouseleave",function(){m.hideTimer=y.setTimeout(m.hideMenu,
500)}),v(m,"mouseenter",function(){f.clearTimeout(m.hideTimer)}),v(A,"mouseup",function(b){h.pointer.inClass(b.target,a)||m.hideMenu()}),v(m,"click",function(){h.openMenu&&m.hideMenu()}));b.forEach(function(a){"string"===typeof a&&(a=h.options.exporting.menuItemDefinitions[a]);if(J(a,!0)){if(a.separator)var b=x("hr",null,null,p);else"viewData"===a.textKey&&h.isDataTableVisible&&(a.textKey="hideData"),b=x("li",{className:"highcharts-menu-item",onclick:function(b){b&&b.stopPropagation();m.hideMenu();
a.onclick&&a.onclick.apply(h,arguments)},innerHTML:a.text||h.options.lang[a.textKey]},null,p),h.styledMode||(b.onmouseover=function(){r(this,w.menuItemHoverStyle)},b.onmouseout=function(){r(this,w.menuItemStyle)},r(b,z({cursor:"pointer"},w.menuItemStyle)));h.exportDivElements.push(b)}});h.exportDivElements.push(p,m);h.exportMenuWidth=m.offsetWidth;h.exportMenuHeight=m.offsetHeight}b={display:"block"};c+h.exportMenuWidth>l?b.right=l-c-e-u+"px":b.left=c-u+"px";d+g+h.exportMenuHeight>B&&"top"!==k.alignOptions.verticalAlign?
b.bottom=B-d-u+"px":b.top=d+g-u+"px";r(m,b);r(h.renderTo,{overflow:""});h.openMenu=!0;C(h,"exportMenuShown")},addButton:function(a){var b=this,c=b.renderer,d=p(b.options.navigation.buttonOptions,a),e=d.onclick,f=d.menuItems,g=d.symbolSize||12;b.btnCount||(b.btnCount=0);b.exportDivElements||(b.exportDivElements=[],b.exportSVGElements=[]);if(!1!==d.enabled){var h=d.theme,k=h.states,l=k&&k.hover;k=k&&k.select;var B;b.styledMode||(h.fill=t(h.fill,"#ffffff"),h.stroke=t(h.stroke,"none"));delete h.states;
e?B=function(a){a&&a.stopPropagation();e.call(b,a)}:f&&(B=function(a){a&&a.stopPropagation();b.contextMenu(n.menuClassName,f,n.translateX,n.translateY,n.width,n.height,n);n.setState(2)});d.text&&d.symbol?h.paddingLeft=t(h.paddingLeft,25):d.text||z(h,{width:d.width,height:d.height,padding:0});b.styledMode||(h["stroke-linecap"]="round",h.fill=t(h.fill,"#ffffff"),h.stroke=t(h.stroke,"none"));var n=c.button(d.text,0,0,B,h,l,k).addClass(a.className).attr({title:t(b.options.lang[d._titleKey||d.titleKey],
"")});n.menuClassName=a.menuClassName||"highcharts-menu-"+b.btnCount++;if(d.symbol){var m=c.symbol(d.symbol,d.symbolX-g/2,d.symbolY-g/2,g,g,{width:g,height:g}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(n);b.styledMode||m.attr({stroke:d.symbolStroke,fill:d.symbolFill,"stroke-width":d.symbolStrokeWidth||1})}n.add(b.exportingGroup).align(z(d,{width:n.width,x:t(d.x,b.buttonOffset)}),!0,"spacingBox");b.buttonOffset+=(n.width+d.buttonSpacing)*("right"===d.align?-1:1);b.exportSVGElements.push(n,
m)}},destroyExport:function(a){var b=a?a.target:this;a=b.exportSVGElements;var c=b.exportDivElements,d=b.exportEvents,e;a&&(a.forEach(function(a,d){a&&(a.onclick=a.ontouchstart=null,e="cache-"+a.menuClassName,b[e]&&delete b[e],b.exportSVGElements[d]=a.destroy())}),a.length=0);b.exportingGroup&&(b.exportingGroup.destroy(),delete b.exportingGroup);c&&(c.forEach(function(a,d){f.clearTimeout(a.hideTimer);K(a,"mouseleave");b.exportDivElements[d]=a.onmouseout=a.onmouseover=a.ontouchstart=a.onclick=null;
D(a)}),c.length=0);d&&(d.forEach(function(a){a()}),d.length=0)}});q.prototype.inlineToAttributes="fill stroke strokeLinecap strokeLinejoin strokeWidth textAnchor x y".split(" ");q.prototype.inlineBlacklist=[/-/,/^(clipPath|cssText|d|height|width)$/,/^font$/,/[lL]ogical(Width|Height)$/,/perspective/,/TapHighlightColor/,/^transition/,/^length$/];q.prototype.unstyledElements=["clipPath","defs","desc"];e.prototype.inlineStyles=function(){function a(a){return a.replace(/([A-Z])/g,function(a,b){return"-"+
b.toLowerCase()})}function b(c){function n(b,g){u=q=!1;if(f){for(r=f.length;r--&&!q;)q=f[r].test(g);u=!q}"transform"===g&&"none"===b&&(u=!0);for(r=e.length;r--&&!u;)u=e[r].test(g)||"function"===typeof b;u||w[g]===b&&"svg"!==c.nodeName||h[c.nodeName][g]===b||(d&&-1===d.indexOf(g)?m+=a(g)+":"+b+";":b&&c.setAttribute(a(g),b))}var m="",u,q,r;if(1===c.nodeType&&-1===g.indexOf(c.nodeName)){var t=y.getComputedStyle(c,null);var w="svg"===c.nodeName?{}:y.getComputedStyle(c.parentNode,null);if(!h[c.nodeName]){k=
l.getElementsByTagName("svg")[0];var v=l.createElementNS(c.namespaceURI,c.nodeName);k.appendChild(v);h[c.nodeName]=p(y.getComputedStyle(v,null));"text"===c.nodeName&&delete h.text.fill;k.removeChild(v)}if(N||M)for(var x in t)n(t[x],x);else E(t,n);m&&(t=c.getAttribute("style"),c.setAttribute("style",(t?t+";":"")+m));"svg"===c.nodeName&&c.setAttribute("stroke-width","1px");"text"!==c.nodeName&&[].forEach.call(c.children||c.childNodes,b)}}var c=this.renderer,d=c.inlineToAttributes,e=c.inlineBlacklist,
f=c.inlineWhitelist,g=c.unstyledElements,h={},k;c=A.createElement("iframe");r(c,{width:"1px",height:"1px",visibility:"hidden"});A.body.appendChild(c);var l=c.contentWindow.document;l.open();l.write('<svg xmlns="http://www.w3.org/2000/svg"></svg>');l.close();b(this.container.querySelector("svg"));k.parentNode.remove();c.remove()};G.menu=function(a,b,c,d){return[["M",a,b+2.5],["L",a+c,b+2.5],["M",a,b+d/2+.5],["L",a+c,b+d/2+.5],["M",a,b+d-1.5],["L",a+c,b+d-1.5]]};G.menuball=function(a,b,c,d){a=[];d=
d/3-2;return a=a.concat(this.circle(c-d,b,d,d),this.circle(c-d,b+d+4,d,d),this.circle(c-d,b+2*(d+4),d,d))};e.prototype.renderExporting=function(){var a=this,b=a.options.exporting,c=b.buttons,d=a.isDirtyExporting||!a.exportSVGElements;a.buttonOffset=0;a.isDirtyExporting&&a.destroyExport();d&&!1!==b.enabled&&(a.exportEvents=[],a.exportingGroup=a.exportingGroup||a.renderer.g("exporting-group").attr({zIndex:3}).add(),E(c,function(b){a.addButton(b)}),a.isDirtyExporting=!1);v(a,"destroy",a.destroyExport)};
v(e,"init",function(){var a=this;a.exporting={update:function(b,c){a.isDirtyExporting=!0;p(!0,a.options.exporting,b);t(c,!0)&&a.redraw()}};l.addUpdate(function(b,c){a.isDirtyExporting=!0;p(!0,a.options.navigation,b);t(c,!0)&&a.redraw()},a)});e.prototype.callbacks.push(function(a){a.renderExporting();v(a,"redraw",a.renderExporting)})});q(e,"masters/modules/exporting.src.js",[],function(){})});
//# sourceMappingURL=exporting.js.map

/***/ }),
/* 1144 */
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./~/moment/locale ^\.\/.*$ ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 493,
	"./af.js": 493,
	"./ar": 501,
	"./ar-dz": 494,
	"./ar-dz.js": 494,
	"./ar-kw": 495,
	"./ar-kw.js": 495,
	"./ar-ly": 496,
	"./ar-ly.js": 496,
	"./ar-ma": 497,
	"./ar-ma.js": 497,
	"./ar-ps": 498,
	"./ar-ps.js": 498,
	"./ar-sa": 499,
	"./ar-sa.js": 499,
	"./ar-tn": 500,
	"./ar-tn.js": 500,
	"./ar.js": 501,
	"./az": 502,
	"./az.js": 502,
	"./be": 503,
	"./be.js": 503,
	"./bg": 504,
	"./bg.js": 504,
	"./bm": 505,
	"./bm.js": 505,
	"./bn": 507,
	"./bn-bd": 506,
	"./bn-bd.js": 506,
	"./bn.js": 507,
	"./bo": 508,
	"./bo.js": 508,
	"./br": 509,
	"./br.js": 509,
	"./bs": 510,
	"./bs.js": 510,
	"./ca": 511,
	"./ca.js": 511,
	"./cs": 512,
	"./cs.js": 512,
	"./cv": 513,
	"./cv.js": 513,
	"./cy": 514,
	"./cy.js": 514,
	"./da": 515,
	"./da.js": 515,
	"./de": 518,
	"./de-at": 516,
	"./de-at.js": 516,
	"./de-ch": 517,
	"./de-ch.js": 517,
	"./de.js": 518,
	"./dv": 519,
	"./dv.js": 519,
	"./el": 520,
	"./el.js": 520,
	"./en-au": 521,
	"./en-au.js": 521,
	"./en-ca": 522,
	"./en-ca.js": 522,
	"./en-gb": 523,
	"./en-gb.js": 523,
	"./en-ie": 524,
	"./en-ie.js": 524,
	"./en-il": 525,
	"./en-il.js": 525,
	"./en-in": 526,
	"./en-in.js": 526,
	"./en-nz": 527,
	"./en-nz.js": 527,
	"./en-sg": 528,
	"./en-sg.js": 528,
	"./eo": 529,
	"./eo.js": 529,
	"./es": 533,
	"./es-do": 530,
	"./es-do.js": 530,
	"./es-mx": 531,
	"./es-mx.js": 531,
	"./es-us": 532,
	"./es-us.js": 532,
	"./es.js": 533,
	"./et": 534,
	"./et.js": 534,
	"./eu": 535,
	"./eu.js": 535,
	"./fa": 536,
	"./fa.js": 536,
	"./fi": 537,
	"./fi.js": 537,
	"./fil": 538,
	"./fil.js": 538,
	"./fo": 539,
	"./fo.js": 539,
	"./fr": 542,
	"./fr-ca": 540,
	"./fr-ca.js": 540,
	"./fr-ch": 541,
	"./fr-ch.js": 541,
	"./fr.js": 542,
	"./fy": 543,
	"./fy.js": 543,
	"./ga": 544,
	"./ga.js": 544,
	"./gd": 545,
	"./gd.js": 545,
	"./gl": 546,
	"./gl.js": 546,
	"./gom-deva": 547,
	"./gom-deva.js": 547,
	"./gom-latn": 548,
	"./gom-latn.js": 548,
	"./gu": 549,
	"./gu.js": 549,
	"./he": 550,
	"./he.js": 550,
	"./hi": 551,
	"./hi.js": 551,
	"./hr": 552,
	"./hr.js": 552,
	"./hu": 553,
	"./hu.js": 553,
	"./hy-am": 554,
	"./hy-am.js": 554,
	"./id": 555,
	"./id.js": 555,
	"./is": 556,
	"./is.js": 556,
	"./it": 558,
	"./it-ch": 557,
	"./it-ch.js": 557,
	"./it.js": 558,
	"./ja": 559,
	"./ja.js": 559,
	"./jv": 560,
	"./jv.js": 560,
	"./ka": 561,
	"./ka.js": 561,
	"./kk": 562,
	"./kk.js": 562,
	"./km": 563,
	"./km.js": 563,
	"./kn": 564,
	"./kn.js": 564,
	"./ko": 565,
	"./ko.js": 565,
	"./ku": 567,
	"./ku-kmr": 566,
	"./ku-kmr.js": 566,
	"./ku.js": 567,
	"./ky": 568,
	"./ky.js": 568,
	"./lb": 569,
	"./lb.js": 569,
	"./lo": 570,
	"./lo.js": 570,
	"./lt": 571,
	"./lt.js": 571,
	"./lv": 572,
	"./lv.js": 572,
	"./me": 573,
	"./me.js": 573,
	"./mi": 574,
	"./mi.js": 574,
	"./mk": 575,
	"./mk.js": 575,
	"./ml": 576,
	"./ml.js": 576,
	"./mn": 577,
	"./mn.js": 577,
	"./mr": 578,
	"./mr.js": 578,
	"./ms": 580,
	"./ms-my": 579,
	"./ms-my.js": 579,
	"./ms.js": 580,
	"./mt": 581,
	"./mt.js": 581,
	"./my": 582,
	"./my.js": 582,
	"./nb": 583,
	"./nb.js": 583,
	"./ne": 584,
	"./ne.js": 584,
	"./nl": 586,
	"./nl-be": 585,
	"./nl-be.js": 585,
	"./nl.js": 586,
	"./nn": 587,
	"./nn.js": 587,
	"./oc-lnc": 588,
	"./oc-lnc.js": 588,
	"./pa-in": 589,
	"./pa-in.js": 589,
	"./pl": 590,
	"./pl.js": 590,
	"./pt": 592,
	"./pt-br": 591,
	"./pt-br.js": 591,
	"./pt.js": 592,
	"./ro": 593,
	"./ro.js": 593,
	"./ru": 594,
	"./ru.js": 594,
	"./sd": 595,
	"./sd.js": 595,
	"./se": 596,
	"./se.js": 596,
	"./si": 597,
	"./si.js": 597,
	"./sk": 598,
	"./sk.js": 598,
	"./sl": 599,
	"./sl.js": 599,
	"./sq": 600,
	"./sq.js": 600,
	"./sr": 602,
	"./sr-cyrl": 601,
	"./sr-cyrl.js": 601,
	"./sr.js": 602,
	"./ss": 603,
	"./ss.js": 603,
	"./sv": 604,
	"./sv.js": 604,
	"./sw": 605,
	"./sw.js": 605,
	"./ta": 606,
	"./ta.js": 606,
	"./te": 607,
	"./te.js": 607,
	"./tet": 608,
	"./tet.js": 608,
	"./tg": 609,
	"./tg.js": 609,
	"./th": 610,
	"./th.js": 610,
	"./tk": 611,
	"./tk.js": 611,
	"./tl-ph": 612,
	"./tl-ph.js": 612,
	"./tlh": 613,
	"./tlh.js": 613,
	"./tr": 614,
	"./tr.js": 614,
	"./tzl": 615,
	"./tzl.js": 615,
	"./tzm": 617,
	"./tzm-latn": 616,
	"./tzm-latn.js": 616,
	"./tzm.js": 617,
	"./ug-cn": 618,
	"./ug-cn.js": 618,
	"./uk": 619,
	"./uk.js": 619,
	"./ur": 620,
	"./ur.js": 620,
	"./uz": 622,
	"./uz-latn": 621,
	"./uz-latn.js": 621,
	"./uz.js": 622,
	"./vi": 623,
	"./vi.js": 623,
	"./x-pseudo": 624,
	"./x-pseudo.js": 624,
	"./yo": 625,
	"./yo.js": 625,
	"./zh-cn": 626,
	"./zh-cn.js": 626,
	"./zh-hk": 627,
	"./zh-hk.js": 627,
	"./zh-mo": 628,
	"./zh-mo.js": 628,
	"./zh-tw": 629,
	"./zh-tw.js": 629
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1144;

/***/ }),
/* 1145 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/print-html-element/dist/print-html-element.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["printHtmlElement"] = factory();
	else
		root["printHtmlElement"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';

	/*
	* Print HTML Element
	*
	* Copyright (c) 2015 Philip Da Silva
	*
	* Forked from jQuery.printElement (https://github.com/erikzaadi/jQueryPlugins/tree/master/jQuery.printElement)
	*
	* Licensed under the MIT license:
	*   http://www.opensource.org/licenses/mit-license.php
	*/

	function PrintHtmlElement() {
	    function printElement(element, opts) {
	        var elementHtml = element.outerHTML;

	        _print(elementHtml, opts);
	    }

	    function printHtml(html, opts) {
	        _print(html, opts);
	    }

	    function _print(html, opts) {
	        opts = opts || {};
	        opts = {
	            printMode: opts.printMode || '',
	            pageTitle: opts.pageTitle || '',
	            templateString: opts.templateString || '',
	            popupProperties: opts.popupProperties || '',
	            stylesheets: opts.stylesheets || null,
	            styles: opts.styles || null
	        };

	        // Get markup to be printed
	        var markup = _getMarkup(html, opts),
	            printWindow,
	            printIframe,
	            printDocument,
	            printElementID;

	        if (opts.printMode.toLowerCase() === 'popup') {
	            printWindow = window.open('about:blank', 'printElementWindow', opts.popupProperties);
	            printDocument = printWindow.document;
	        } else {
	            //The random ID is to overcome a safari bug
	            // http://www.cjboco.com.sharedcopy.com/post.cfm/442dc92cd1c0ca10a5c35210b8166882.html
	            printElementID = 'printElement_' + Math.round(Math.random() * 99999).toString();

	            printIframe = document.createElement('iframe');
	            printIframe.setAttribute('id', printElementID);
	            printIframe.setAttribute('src', 'about:blank');
	            printIframe.setAttribute('frameBorder', '0');
	            printIframe.setAttribute('scrolling', 'no');
	            printIframe.setAttribute('style', 'position:fixed;bottom:100%;right:100%;');

	            document.body.appendChild(printIframe);

	            printDocument = printIframe.contentWindow || printIframe.contentDocument;
	            if (printDocument.document) {
	                printDocument = printDocument.document;
	            }

	            printIframe = document.frames ? document.frames[printElementID] : document.getElementById(printElementID);
	            printWindow = printIframe.contentWindow || printIframe;
	        }

	        focus();
	        printDocument.open();

	        // SetTimeout fixes Issue #9 (iframe printMode does not work in firefox)
	        setTimeout(function () {
	            printDocument.write(markup);
	            printDocument.close();
	        });

	        _callPrint(printWindow, printIframe);
	    }

	    function _callPrint(printWindow, iframe) {
	        if (printWindow && printWindow.printPage) {
	            printWindow.printPage();

	            if (iframe) {
	                // Remove iframe after printing
	                document.body.removeChild(iframe);
	            }
	        } else {
	            setTimeout(function () {
	                _callPrint(printWindow, iframe);
	            }, 50);
	        }
	    }

	    function _getBaseHref() {
	        var port = window.location.port ? ':' + window.location.port : '';
	        return window.location.protocol + '//' + window.location.hostname + port + window.location.pathname;
	    }

	    function _getMarkup(elementHtml, opts) {
	        var template = opts.templateString,
	            templateRegex = new RegExp(/{{\s*printBody\s*}}/gi),
	            stylesheets,
	            styles,
	            html = [];

	        if (template && templateRegex.test(template)) {
	            elementHtml = template.replace(templateRegex, elementHtml);
	        }

	        html.push('<html><head><title>' + (opts.pageTitle || '') + '</title>');

	        // If stylesheet URL's or list of stylesheet URL's are specified, override page stylesheets
	        if (opts.stylesheets) {
	            stylesheets = Array.isArray(opts.stylesheets) ? opts.stylesheets : [opts.stylesheets];
	        } else {
	            stylesheets = Array.prototype.slice.call(document.getElementsByTagName('link')).map(function (link) {
	                return link.href;
	            });
	        }

	        stylesheets.forEach(function (href) {
	            html.push('<link rel="stylesheet" href="' + href + '">');
	        });

	        // If inline styles or list of inline styles are specified, override inline styles
	        if (opts.styles) {
	            styles = Array.isArray(opts.styles) ? opts.styles : [opts.styles];
	        } else {
	            styles = Array.prototype.slice.call(document.getElementsByTagName('style')).map(function (style) {
	                return style.innerHTML;
	            });
	        }

	        styles.forEach(function (style) {
	            html.push('<style type="text/css">' + style + '</style>');
	        });

	        // Ensure that relative links work
	        html.push('<base href="' + _getBaseHref() + '" />');
	        html.push('</head><body class="pe-body">');
	        html.push(elementHtml);
	        html.push('<script type="text/javascript">function printPage(){focus();print();' + (opts.printMode.toLowerCase() == 'popup' ? 'close();' : '') + '}</script>');
	        html.push('</body></html>');

	        return html.join('');
	    }

	    return {
	        printElement: printElement,
	        printHtml: printHtml
	    };
	};

	module.exports = PrintHtmlElement();

/***/ }
/******/ ])
});
;

/***/ }),
/* 1146 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/regenerator-runtime/runtime-module.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(/*! ./runtime */ 1147);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/global.js */ 102)))

/***/ }),
/* 1147 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./~/regenerator-runtime/runtime.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/global.js */ 102)))

/***/ }),
/* 1148 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./~/setimmediate/setImmediate.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/global.js */ 102), __webpack_require__(/*! ./../process/browser.js */ 281)))

/***/ }),
/* 1149 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/smoothscroll-polyfill/dist/smoothscroll.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

/*
 * smoothscroll polyfill - v0.3.5
 * https://iamdustan.github.io/smoothscroll
 * 2016 (c) Dustan Kasten, Jeremias Menichelli - MIT License
 */

(function(w, d, undefined) {
  'use strict';

  /*
   * aliases
   * w: window global object
   * d: document
   * undefined: undefined
   */

  // polyfill
  function polyfill() {
    // return when scrollBehavior interface is supported
    if ('scrollBehavior' in d.documentElement.style) {
      return;
    }

    /*
     * globals
     */
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    /*
     * object gathering original scroll methods
     */
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    /*
     * define timing method
     */
    var now = w.performance && w.performance.now
      ? w.performance.now.bind(w.performance) : Date.now;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} x
     * @returns {Boolean}
     */
    function shouldBailOut(x) {
      if (typeof x !== 'object'
            || x === null
            || x.behavior === undefined
            || x.behavior === 'auto'
            || x.behavior === 'instant') {
        // first arg not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof x === 'object'
            && x.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError('behavior not valid');
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;
      var hasScrollableSpace;
      var hasVisibleOverflow;

      do {
        el = el.parentNode;

        // set condition variables
        isBody = el === d.body;
        hasScrollableSpace =
          el.clientHeight < el.scrollHeight ||
          el.clientWidth < el.scrollWidth;
        hasVisibleOverflow =
          w.getComputedStyle(el, null).overflow === 'visible';
      } while (!isBody && !(hasScrollableSpace && !hasVisibleOverflow));

      isBody = hasScrollableSpace = hasVisibleOverflow = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    /*
     * ORIGINAL METHODS OVERRIDES
     */

    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scroll.call(
          w,
          arguments[0].left || arguments[0],
          arguments[0].top || arguments[1]
        );
        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left,
        ~~arguments[0].top
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left || arguments[0],
          arguments[0].top || arguments[1]
        );
        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.elScroll.call(
            this,
            arguments[0].left || arguments[0],
            arguments[0].top || arguments[1]
        );
        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
          this,
          this,
          typeof left === 'number' ? left : this.scrollLeft,
          typeof top === 'number' ? top : this.scrollTop
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      var arg0 = arguments[0];

      if (typeof arg0 === 'object') {
        this.scroll({
          left: arg0.left + this.scrollLeft,
          top: arg0.top + this.scrollTop,
          behavior: arg0.behavior
        });
      } else {
        this.scroll(
          this.scrollLeft + arg0,
          this.scrollTop + arguments[1]
        );
      }
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );
        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );
        // reveal parent in viewport
        w.scrollBy({
          left: parentRects.left,
          top: parentRects.top,
          behavior: 'smooth'
        });
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }
})(window, document);


/***/ }),
/* 1150 */
/* exports provided: default, MultiDrag, Sortable, Swap */
/* all exports used */
/*!**********************************************!*\
  !*** ./~/sortablejs/modular/sortable.esm.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),
/* 1151 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/timers-browserify/main.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ 1148);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../webpack/buildin/global.js */ 102)))

/***/ }),
/* 1152 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./~/tiny-cookie/tiny-cookie.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * tiny-cookie - A tiny cookie manipulation plugin
 * https://github.com/Alex1990/tiny-cookie
 * Under the MIT license | (c) Alex Chao
 */

!(function(root, factory) {

  // Uses CommonJS, AMD or browser global to create a jQuery plugin.
  // See: https://github.com/umdjs/umd
  if (true) {
    // Expose this plugin as an AMD module. Register an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node/CommonJS module
    module.exports = factory();
  } else {
    // Browser globals 
    root.Cookie = factory();
  }

}(this, function() {

  'use strict';

  // The public function which can get/set/remove cookie.
  function Cookie(key, value, opts) {
    if (value === void 0) {
      return Cookie.get(key);
    } else if (value === null) {
      Cookie.remove(key);
    } else {
      Cookie.set(key, value, opts);
    }
  }

  // Check if the cookie is enabled.
  Cookie.enabled = function() {
    var key = '__test_key';
    var enabled;

    document.cookie = key + '=1';
    enabled = !!document.cookie;

    if (enabled) Cookie.remove(key);

    return enabled;
  };

  // Get the cookie value by the key.
  Cookie.get = function(key, raw) {
    if (typeof key !== 'string' || !key) return null;

    key = '(?:^|; )' + escapeRe(key) + '(?:=([^;]*?))?(?:;|$)';

    var reKey = new RegExp(key);
    var res = reKey.exec(document.cookie);

    return res !== null ? (raw ? res[1] : decodeURIComponent(res[1])) : null;
  };

  // Get the cookie's value without decoding.
  Cookie.getRaw = function(key) {
    return Cookie.get(key, true);
  };

  // Set a cookie.
  Cookie.set = function(key, value, raw, opts) {
    if (raw !== true) {
      opts = raw;
      raw = false;
    }
    opts = opts ? convert(opts) : convert({});
    var cookie = key + '=' + (raw ? value : encodeURIComponent(value)) + opts;
    document.cookie = cookie;
  };

  // Set a cookie without encoding the value.
  Cookie.setRaw = function(key, value, opts) {
    Cookie.set(key, value, true, opts);
  };

  // Remove a cookie by the specified key.
  Cookie.remove = function(key) {
    Cookie.set(key, 'a', { expires: new Date() });
  };

  // Helper function
  // ---------------

  // Escape special characters.
  function escapeRe(str) {
    return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
  }

  // Convert an object to a cookie option string.
  function convert(opts) {
    var res = '';

    for (var p in opts) {
      if (opts.hasOwnProperty(p)) {

        if (p === 'expires') {
          var expires = opts[p];
          if (typeof expires !== 'object') {
            expires += typeof expires === 'number' ? 'D' : '';
            expires = computeExpires(expires);
          }
          opts[p] = expires.toUTCString();
        }

        if (p === 'secure') {
          if (opts[p]) {
            res += ';' + p;
          }

          continue;
        }

        res += ';' + p + '=' + opts[p];
      }
    }

    if (!opts.hasOwnProperty('path')) {
      res += ';path=/';
    }

    return res;
  }

  // Return a future date by the given string.
  function computeExpires(str) {
    var expires = new Date();
    var lastCh = str.charAt(str.length - 1);
    var value = parseInt(str, 10);

    switch (lastCh) {
      case 'Y': expires.setFullYear(expires.getFullYear() + value); break;
      case 'M': expires.setMonth(expires.getMonth() + value); break;
      case 'D': expires.setDate(expires.getDate() + value); break;
      case 'h': expires.setHours(expires.getHours() + value); break;
      case 'm': expires.setMinutes(expires.getMinutes() + value); break;
      case 's': expires.setSeconds(expires.getSeconds() + value); break;
      default: expires = new Date(str);
    }

    return expires;
  }

  return Cookie;

}));


/***/ }),
/* 1153 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./~/toastr/toastr.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
(function (define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! jquery */ 16)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.4',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass);

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,
                    closeOnHover: true,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    closeClass: 'toast-close-button',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false,
                    progressClass: 'toast-progress',
                    rtl: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null) {
                        source = '';
                    }

                    return source
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setRTL();
                    setSequence();
                    setAria();
                }

                function setAria() {
                    var ariaValue = '';
                    switch (map.iconClass) {
                        case 'toast-success':
                        case 'toast-info':
                            ariaValue =  'polite';
                            break;
                        default:
                            ariaValue = 'assertive';
                    }
                    $toastElement.attr('aria-live', ariaValue);
                }

                function handleEvents() {
                    if (options.closeOnHover) {
                        $toastElement.hover(stickAround, delayedHideToast);
                    }

                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }

                            if (options.onCloseClick) {
                                options.onCloseClick(event);
                            }

                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        var suffix = map.title;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.title);
                        }
                        $titleElement.append(suffix).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        var suffix = map.message;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.message);
                        }
                        $messageElement.append(suffix).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass(options.closeClass).attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass(options.progressClass);
                        $toastElement.prepend($progressElement);
                    }
                }

                function setRTL() {
                    if (options.rtl) {
                        $toastElement.addClass('rtl');
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            clearTimeout(intervalId);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(/*! !webpack amd define */ 1731)));


/***/ }),
/* 1154 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/true-json-bigint/index.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

var json_stringify = __webpack_require__(/*! ./lib/stringify.js */ 1156).stringify;
var json_parse     = __webpack_require__(/*! ./lib/parse.js */ 1155);

module.exports = function(options) {
    return  {
        parse: json_parse(options),
        stringify: json_stringify
    }
};
//create the default method members with no options applied for backwards compatibility
module.exports.parse = json_parse();
module.exports.stringify = json_stringify;


/***/ }),
/* 1155 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./~/true-json-bigint/lib/parse.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

var BigNumber = null;
/*
    json_parse.js
    2012-06-20

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    This file creates a json_parse function.
    During create you can (optionally) specify some behavioural switches

        require('json-bigint')(options)

            The optional options parameter holds switches that drive certain
            aspects of the parsing process:
            * options.strict = true will warn about duplicate-key usage in the json.
              The default (strict = false) will silently ignore those and overwrite
              values for keys that are in duplicate use.

    The resulting function follows this signature:
        json_parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = json_parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

    This is a reference implementation. You are free to copy, modify, or
    redistribute.

    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.
*/

/*members "", "\"", "\/", "\\", at, b, call, charAt, f, fromCharCode,
    hasOwnProperty, message, n, name, prototype, push, r, t, text
*/

var json_parse = function (options) {
    "use strict";

// This is a function that can parse a JSON text, producing a JavaScript
// data structure. It is a simple, recursive descent parser. It does not use
// eval or regular expressions, so it can be used as a model for implementing
// a JSON parser in other languages.

// We are defining the function inside of another function to avoid creating
// global variables.


// Default options one can override by passing options to the parse()
    var _options = {
        "strict": false,  // not being strict means do not generate syntax errors for "duplicate key"
        "storeAsString": false // toggles whether the values should be stored as BigNumber (default) or a string
    };


// If there are options, then use them to override the default _options
    if (options !== undefined && options !== null) {
        if (options.strict === true) {
            _options.strict = true;
        }
        if (options.storeAsString === true) {
            _options.storeAsString = true;
        }
    }


    var at,     // The index of the current character
        ch,     // The current character
        escapee = {
            '"':  '"',
            '\\': '\\',
            '/':  '/',
            b:    '\b',
            f:    '\f',
            n:    '\n',
            r:    '\r',
            t:    '\t'
        },
        text,

        error = function (m) {

// Call error when something is wrong.

            throw {
                name:    'SyntaxError',
                message: m,
                at:      at,
                text:    text
            };
        },

        next = function (c) {

// If a c parameter is provided, verify that it matches the current character.

            if (c && c !== ch) {
                error("Expected '" + c + "' instead of '" + ch + "'");
            }

// Get the next character. When there are no more characters,
// return the empty string.

            ch = text.charAt(at);
            at += 1;
            return ch;
        },

        number = function () {
// Parse a number value.

            var number,
                string = '';

            if (ch === '-') {
                string = '-';
                next('-');
            }
            while (ch >= '0' && ch <= '9') {
                string += ch;
                next();
            }
            if (ch === '.') {
                string += '.';
                while (next() && ch >= '0' && ch <= '9') {
                    string += ch;
                }
            }
            if (ch === 'e' || ch === 'E') {
                string += ch;
                next();
                if (ch === '-' || ch === '+') {
                    string += ch;
                    next();
                }
                while (ch >= '0' && ch <= '9') {
                    string += ch;
                    next();
                }
            }
            number = +string;

            if (BigNumber == null)
                BigNumber = __webpack_require__(/*! bignumber.js */ 324);
            var bigNumberValue = new BigNumber(string);
            if (!bigNumberValue.isFinite()) {
                error("Bad number");
            } else {
                //if (number > 9007199254740992 || number < -9007199254740992)
                // Bignumber has stricter check: everything with length > 15 digits disallowed
                if (bigNumberValue.toFixed().length > 15)
                   return (_options.storeAsString === true) ? string : bigNumberValue;
                return number;
            }
        },

        string = function () {

// Parse a string value.

            var hex,
                i,
                string = '',
                uffff;

// When parsing for string values, we must look for " and \ characters.

            if (ch === '"') {
                while (next()) {
                    if (ch === '"') {
                        next();
                        return string;
                    }
                    if (ch === '\\') {
                        next();
                        if (ch === 'u') {
                            uffff = 0;
                            for (i = 0; i < 4; i += 1) {
                                hex = parseInt(next(), 16);
                                if (!isFinite(hex)) {
                                    break;
                                }
                                uffff = uffff * 16 + hex;
                            }
                            string += String.fromCharCode(uffff);
                        } else if (typeof escapee[ch] === 'string') {
                            string += escapee[ch];
                        } else {
                            break;
                        }
                    } else {
                        string += ch;
                    }
                }
            }
            error("Bad string");
        },

        white = function () {

// Skip whitespace.

            while (ch && ch <= ' ') {
                next();
            }
        },

        word = function () {

// true, false, or null.

            switch (ch) {
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
            }
            error("Unexpected '" + ch + "'");
        },

        value,  // Place holder for the value function.

        array = function () {

// Parse an array value.

            var array = [];

            if (ch === '[') {
                next('[');
                white();
                if (ch === ']') {
                    next(']');
                    return array;   // empty array
                }
                while (ch) {
                    array.push(value());
                    white();
                    if (ch === ']') {
                        next(']');
                        return array;
                    }
                    next(',');
                    white();
                }
            }
            error("Bad array");
        },

        object = function () {

// Parse an object value.

            var key,
                object = {};

            if (ch === '{') {
                next('{');
                white();
                if (ch === '}') {
                    next('}');
                    return object;   // empty object
                }
                while (ch) {
                    key = string();
                    white();
                    next(':');
                    if (_options.strict === true && Object.hasOwnProperty.call(object, key)) {
                        error('Duplicate key "' + key + '"');
                    }
                    object[key] = value();
                    white();
                    if (ch === '}') {
                        next('}');
                        return object;
                    }
                    next(',');
                    white();
                }
            }
            error("Bad object");
        };

    value = function () {

// Parse a JSON value. It could be an object, an array, a string, a number,
// or a word.

        white();
        switch (ch) {
        case '{':
            return object();
        case '[':
            return array();
        case '"':
            return string();
        case '-':
            return number();
        default:
            return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

// Return the json_parse function. It will have access to all of the above
// functions and variables.

    return function (source, reviver) {
        var result;

        text = source + '';
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) {
            error("Syntax error");
        }

// If there is a reviver function, we recursively walk the new structure,
// passing each name/value pair to the reviver function for possible
// transformation, starting with a temporary root object that holds the result
// in an empty key. If there is not a reviver function, we simply return the
// result.

        return typeof reviver === 'function'
            ? (function walk(holder, key) {
                var k, v, value = holder[key];
                if (value && typeof value === 'object') {
                    Object.keys(value).forEach(function(k) {
                        v = walk(value, k);
                        if (v !== undefined) {
                            value[k] = v;
                        } else {
                            delete value[k];
                        }
                    });
                }
                return reviver.call(holder, key, value);
            }({'': result}, ''))
            : result;
    };
}

module.exports = json_parse;


/***/ }),
/* 1156 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/true-json-bigint/lib/stringify.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

var BigNumber = __webpack_require__(/*! bignumber.js */ 324);

/*
    json2.js
    2013-05-26

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    See http://www.JSON.org/js.html


    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.


    This file creates a global JSON object containing two methods: stringify
    and parse.

        JSON.stringify(value, replacer, space)
            value       any JavaScript value, usually an object or array.

            replacer    an optional parameter that determines how object
                        values are stringified for objects. It can be a
                        function or an array of strings.

            space       an optional parameter that specifies the indentation
                        of nested structures. If it is omitted, the text will
                        be packed without extra whitespace. If it is a number,
                        it will specify the number of spaces to indent at each
                        level. If it is a string (such as '\t' or '&nbsp;'),
                        it contains the characters used to indent at each level.

            This method produces a JSON text from a JavaScript value.

            When an object value is found, if the object contains a toJSON
            method, its toJSON method will be called and the result will be
            stringified. A toJSON method does not serialize: it returns the
            value represented by the name/value pair that should be serialized,
            or undefined if nothing should be serialized. The toJSON method
            will be passed the key associated with the value, and this will be
            bound to the value

            For example, this would serialize Dates as ISO strings.

                Date.prototype.toJSON = function (key) {
                    function f(n) {
                        // Format integers to have at least two digits.
                        return n < 10 ? '0' + n : n;
                    }

                    return this.getUTCFullYear()   + '-' +
                         f(this.getUTCMonth() + 1) + '-' +
                         f(this.getUTCDate())      + 'T' +
                         f(this.getUTCHours())     + ':' +
                         f(this.getUTCMinutes())   + ':' +
                         f(this.getUTCSeconds())   + 'Z';
                };

            You can provide an optional replacer method. It will be passed the
            key and value of each member, with this bound to the containing
            object. The value that is returned from your method will be
            serialized. If your method returns undefined, then the member will
            be excluded from the serialization.

            If the replacer parameter is an array of strings, then it will be
            used to select the members to be serialized. It filters the results
            such that only members with keys listed in the replacer array are
            stringified.

            Values that do not have JSON representations, such as undefined or
            functions, will not be serialized. Such values in objects will be
            dropped; in arrays they will be replaced with null. You can use
            a replacer function to replace those with JSON values.
            JSON.stringify(undefined) returns undefined.

            The optional space parameter produces a stringification of the
            value that is filled with line breaks and indentation to make it
            easier to read.

            If the space parameter is a non-empty string, then that string will
            be used for indentation. If the space parameter is a number, then
            the indentation will be that many spaces.

            Example:

            text = JSON.stringify(['e', {pluribus: 'unum'}]);
            // text is '["e",{"pluribus":"unum"}]'


            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

            text = JSON.stringify([new Date()], function (key, value) {
                return this[key] instanceof Date ?
                    'Date(' + this[key] + ')' : value;
            });
            // text is '["Date(---current time---)"]'


        JSON.parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = JSON.parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
                var d;
                if (typeof value === 'string' &&
                        value.slice(0, 5) === 'Date(' &&
                        value.slice(-1) === ')') {
                    d = new Date(value.slice(5, -1));
                    if (d) {
                        return d;
                    }
                }
                return value;
            });


    This is a reference implementation. You are free to copy, modify, or
    redistribute.
*/

/*jslint evil: true, regexp: true */

/*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

var JSON = module.exports;

(function () {
    'use strict';

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? '0' + n : n;
    }

    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        gap,
        indent,
        meta = {    // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"' : '\\"',
            '\\': '\\\\'
        },
        rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
            var c = meta[a];
            return typeof c === 'string'
                ? c
                : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i,          // The loop counter.
            k,          // The member key.
            v,          // The member value.
            length,
            mind = gap,
            partial,
            value = holder[key],
            isBigNumber = value != null && (value instanceof BigNumber || BigNumber.isBigNumber(value));

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === 'function') {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case 'string':
            if (isBigNumber) {
                return value;
            } else {
                return quote(value);
            }

        case 'number':

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value) ? String(value) : 'null';

        case 'boolean':
        case 'null':

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce 'null'. The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is 'object', we might be dealing with an object or an array or
// null.

        case 'object':

// Due to a specification blunder in ECMAScript, typeof null is 'object',
// so watch out for that case.

            if (!value) {
                return 'null';
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === '[object Array]') {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || 'null';
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? '[]'
                    : gap
                    ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']'
                    : '[' + partial.join(',') + ']';
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === 'object') {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === 'string') {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                Object.keys(value).forEach(function(k) {
                    var v = str(k, value);
                    if (v) {
                        partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                });
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? '{}'
                : gap
                ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}'
                : '{' + partial.join(',') + '}';
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== 'function') {
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = '';
            indent = '';

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === 'number') {
                for (i = 0; i < space; i += 1) {
                    indent += ' ';
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === 'string') {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== 'function' &&
                    (typeof replacer !== 'object' ||
                    typeof replacer.length !== 'number')) {
                throw new Error('JSON.stringify');
            }

// Make a fake root object containing our value under the key of ''.
// Return the result of stringifying the value.

            return str('', {'': value});
        };
    }
}());


/***/ }),
/* 1157 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/_hasObjectTag.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Object'));


/***/ }),
/* 1158 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/_isBufferLike.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__ = __webpack_require__(/*! ./_createSizePropertyCheck.js */ 640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getByteLength_js__ = __webpack_require__(/*! ./_getByteLength.js */ 284);



// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createSizePropertyCheck_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__getByteLength_js__["a" /* default */]));


/***/ }),
/* 1159 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/_keyInObj.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyInObj;
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function keyInObj(value, key, obj) {
  return key in obj;
}


/***/ }),
/* 1160 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/_toBufferView.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toBufferView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getByteLength_js__ = __webpack_require__(/*! ./_getByteLength.js */ 284);


// Internal function to wrap or shallow-copy an ArrayBuffer,
// typed array or DataView to a new view, reusing the buffer.
function toBufferView(bufferSource) {
  return new Uint8Array(
    bufferSource.buffer || bufferSource,
    bufferSource.byteOffset || 0,
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getByteLength_js__["a" /* default */])(bufferSource)
  );
}


/***/ }),
/* 1161 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./~/underscore/modules/_unescapeMap.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invert_js__ = __webpack_require__(/*! ./invert.js */ 658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(/*! ./_escapeMap.js */ 641);



// Internal list of HTML entities for unescaping.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__invert_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 1162 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/after.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = after;
// Returns a function that will only be executed on and after the Nth call.
function after(times, func) {
  return function() {
    if (--times < 1) {
      return func.apply(this, arguments);
    }
  };
}


/***/ }),
/* 1163 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/bindAll.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatten_js__ = __webpack_require__(/*! ./_flatten.js */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bind_js__ = __webpack_require__(/*! ./bind.js */ 645);




// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__flatten_js__["a" /* default */])(keys, false, false);
  var index = keys.length;
  if (index < 1) throw new Error('bindAll must be passed function names');
  while (index--) {
    var key = keys[index];
    obj[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__bind_js__["a" /* default */])(obj[key], obj);
  }
  return obj;
}));


/***/ }),
/* 1164 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/chain.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);


// Start chaining a wrapped Underscore object.
function chain(obj) {
  var instance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */])(obj);
  instance._chain = true;
  return instance;
}


/***/ }),
/* 1165 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/chunk.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chunk;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);


// Chunk a single array into multiple arrays, each containing `count` or fewer
// items.
function chunk(array, count) {
  if (count == null || count < 1) return [];
  var result = [];
  var i = 0, length = array.length;
  while (i < length) {
    result.push(__WEBPACK_IMPORTED_MODULE_0__setup_js__["d" /* slice */].call(array, i, i += count));
  }
  return result;
}


/***/ }),
/* 1166 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/clone.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(/*! ./isObject.js */ 117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(/*! ./isArray.js */ 116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extend_js__ = __webpack_require__(/*! ./extend.js */ 650);




// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(obj)) return obj;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) ? obj.slice() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__extend_js__["a" /* default */])({}, obj);
}


/***/ }),
/* 1167 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/compact.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compact;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(/*! ./filter.js */ 158);


// Trim out all falsy values from an array.
function compact(array) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(array, Boolean);
}


/***/ }),
/* 1168 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/compose.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function compose() {
  var args = arguments;
  var start = args.length - 1;
  return function() {
    var i = start;
    var result = args[start].apply(this, arguments);
    while (i--) result = args[i].call(this, result);
    return result;
  };
}


/***/ }),
/* 1169 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/countBy.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(/*! ./_group.js */ 192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(/*! ./_has.js */ 99);



// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key]++; else result[key] = 1;
}));


/***/ }),
/* 1170 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/create.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(/*! ./_baseCreate.js */ 632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extendOwn_js__ = __webpack_require__(/*! ./extendOwn.js */ 286);



// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(prototype);
  if (props) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__extendOwn_js__["a" /* default */])(result, props);
  return result;
}


/***/ }),
/* 1171 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/debounce.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now_js__ = __webpack_require__(/*! ./now.js */ 294);



// When a sequence of calls of the returned function ends, the argument
// function is triggered. The end of a sequence is defined by the `wait`
// parameter. If `immediate` is passed, the argument function will be
// triggered at the beginning of the sequence instead of at the end.
function debounce(func, wait, immediate) {
  var timeout, previous, args, result, context;

  var later = function() {
    var passed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])() - previous;
    if (wait > passed) {
      timeout = setTimeout(later, wait - passed);
    } else {
      timeout = null;
      if (!immediate) result = func.apply(context, args);
      // This check is needed because `func` can recursively invoke `debounced`.
      if (!timeout) args = context = null;
    }
  };

  var debounced = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(_args) {
    context = this;
    args = _args;
    previous = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__now_js__["a" /* default */])();
    if (!timeout) {
      timeout = setTimeout(later, wait);
      if (immediate) result = func.apply(context, args);
    }
    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = args = context = null;
  };

  return debounced;
}


/***/ }),
/* 1172 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/defer.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(/*! ./partial.js */ 194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__delay_js__ = __webpack_require__(/*! ./delay.js */ 648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);




// Defers a function, scheduling it to run after the current call stack has
// cleared.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__delay_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__underscore_js__["a" /* default */], 1));


/***/ }),
/* 1173 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/escape.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(/*! ./_createEscaper.js */ 636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escapeMap_js__ = __webpack_require__(/*! ./_escapeMap.js */ 641);



// Function for escaping strings to HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__escapeMap_js__["a" /* default */]));


/***/ }),
/* 1174 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/every.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = every;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);




// Determine whether all of the elements pass a truth test.
function every(obj, predicate, context) {
  predicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (!predicate(obj[currentKey], currentKey, obj)) return false;
  }
  return true;
}


/***/ }),
/* 1175 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/findWhere.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findWhere;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__find_js__ = __webpack_require__(/*! ./find.js */ 651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(/*! ./matcher.js */ 193);



// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
function findWhere(obj, attrs) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__find_js__["a" /* default */])(obj, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 1176 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/first.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = first;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__initial_js__ = __webpack_require__(/*! ./initial.js */ 657);


// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `_.map`.
function first(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[0];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__initial_js__["a" /* default */])(array, array.length - n);
}


/***/ }),
/* 1177 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/flatten.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = flatten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flatten_js__ = __webpack_require__(/*! ./_flatten.js */ 127);


// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten(array, depth) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__flatten_js__["a" /* default */])(array, depth, false);
}


/***/ }),
/* 1178 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/groupBy.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(/*! ./_group.js */ 192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_js__ = __webpack_require__(/*! ./_has.js */ 99);



// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__has_js__["a" /* default */])(result, key)) result[key].push(value); else result[key] = [value];
}));


/***/ }),
/* 1179 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/has.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = has;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(/*! ./_has.js */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(/*! ./_toPath.js */ 155);



// Shortcut function for checking if an object has a given property directly on
// itself (in other words, not on a prototype). Unlike the internal `has`
// function, this public version can also traverse nested properties.
function has(obj, path) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  for (var i = 0; i < length; i++) {
    var key = path[i];
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(obj, key)) return false;
    obj = obj[key];
  }
  return !!length;
}


/***/ }),
/* 1180 */
/* exports provided: default */
/* exports used: default */
/*!***********************************************!*\
  !*** ./~/underscore/modules/index-default.js ***!
  \***********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(/*! ./index.js */ 289);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```



// Add all of the Underscore functions to the wrapper object.
var _ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index_js__["mixin"])(__WEBPACK_IMPORTED_MODULE_0__index_js__);
// Legacy Node.js API.
_._ = _;
// Export the Underscore API.
/* harmony default export */ __webpack_exports__["a"] = (_);


/***/ }),
/* 1181 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/indexBy.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(/*! ./_group.js */ 192);


// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, key) {
  result[key] = value;
}));


/***/ }),
/* 1182 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************!*\
  !*** ./~/underscore/modules/intersection.js ***!
  \**********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intersection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contains_js__ = __webpack_require__(/*! ./contains.js */ 157);



// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array) {
  var result = [];
  var argsLength = arguments.length;
  for (var i = 0, length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(array); i < length; i++) {
    var item = array[i];
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(result, item)) continue;
    var j;
    for (j = 1; j < argsLength; j++) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__contains_js__["a" /* default */])(arguments[j], item)) break;
    }
    if (j === argsLength) result.push(item);
  }
  return result;
}


/***/ }),
/* 1183 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/invoke.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(/*! ./map.js */ 128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepGet_js__ = __webpack_require__(/*! ./_deepGet.js */ 283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toPath_js__ = __webpack_require__(/*! ./_toPath.js */ 155);






// Invoke a method (with arguments) on every item in a collection.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, path, args) {
  var contextPath, func;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(path)) {
    func = path;
  } else {
    path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toPath_js__["a" /* default */])(path);
    contextPath = path.slice(0, -1);
    path = path[path.length - 1];
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(context) {
    var method = func;
    if (!method) {
      if (contextPath && contextPath.length) {
        context = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__deepGet_js__["a" /* default */])(context, contextPath);
      }
      if (context == null) return void 0;
      method = context[path];
    }
    return method == null ? method : method.apply(context, args);
  });
}));


/***/ }),
/* 1184 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/isDate.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Date'));


/***/ }),
/* 1185 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/isElement.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isElement;
// Is a given value a DOM element?
function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}


/***/ }),
/* 1186 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/isEmpty.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(/*! ./isArray.js */ 116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(/*! ./isString.js */ 292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArguments_js__ = __webpack_require__(/*! ./isArguments.js */ 290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);






// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty(obj) {
  if (obj == null) return true;
  // Skip the more expensive `toString`-based type checks if `obj` has no
  // `.length`.
  var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(obj);
  if (typeof length == 'number' && (
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(obj) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(obj) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArguments_js__["a" /* default */])(obj)
  )) return length === 0;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__keys_js__["a" /* default */])(obj)) === 0;
}


/***/ }),
/* 1187 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/isEqual.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getByteLength_js__ = __webpack_require__(/*! ./_getByteLength.js */ 284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__ = __webpack_require__(/*! ./isTypedArray.js */ 665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__ = __webpack_require__(/*! ./_stringTagBug.js */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isDataView_js__ = __webpack_require__(/*! ./isDataView.js */ 291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__has_js__ = __webpack_require__(/*! ./_has.js */ 99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toBufferView_js__ = __webpack_require__(/*! ./_toBufferView.js */ 1160);











// We use this string twice, so give it a name for minification.
var tagDataView = '[object DataView]';

// Internal recursive comparison function for `_.isEqual`.
function eq(a, b, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) return a !== 0 || 1 / a === 1 / b;
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) return false;
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) return b !== b;
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
  return deepEq(a, b, aStack, bStack);
}

// Internal recursive comparison function for `_.isEqual`.
function deepEq(a, b, aStack, bStack) {
  // Unwrap any wrapped objects.
  if (a instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) a = a._wrapped;
  if (b instanceof __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]) b = b._wrapped;
  // Compare `[[Class]]` names.
  var className = __WEBPACK_IMPORTED_MODULE_1__setup_js__["l" /* toString */].call(a);
  if (className !== __WEBPACK_IMPORTED_MODULE_1__setup_js__["l" /* toString */].call(b)) return false;
  // Work around a bug in IE 10 - Edge 13.
  if (__WEBPACK_IMPORTED_MODULE_5__stringTagBug_js__["b" /* hasStringTagBug */] && className == '[object Object]' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(a)) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isDataView_js__["a" /* default */])(b)) return false;
    className = tagDataView;
  }
  switch (className) {
    // These types are compared by value.
    case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case '[object String]':
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return '' + a === '' + b;
    case '[object Number]':
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) return +b !== +b;
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case '[object Date]':
    case '[object Boolean]':
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case '[object Symbol]':
      return __WEBPACK_IMPORTED_MODULE_1__setup_js__["n" /* SymbolProto */].valueOf.call(a) === __WEBPACK_IMPORTED_MODULE_1__setup_js__["n" /* SymbolProto */].valueOf.call(b);
    case '[object ArrayBuffer]':
    case tagDataView:
      // Coerce to typed array so we can fall through.
      return deepEq(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(a), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__toBufferView_js__["a" /* default */])(b), aStack, bStack);
  }

  var areArrays = className === '[object Array]';
  if (!areArrays && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isTypedArray_js__["a" /* default */])(a)) {
      var byteLength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(a);
      if (byteLength !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getByteLength_js__["a" /* default */])(b)) return false;
      if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
      areArrays = true;
  }
  if (!areArrays) {
    if (typeof a != 'object' || typeof b != 'object') return false;

    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(aCtor) && aCtor instanceof aCtor &&
                             __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isFunction_js__["a" /* default */])(bCtor) && bCtor instanceof bCtor)
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) return bStack[length] === b;
  }

  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);

  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) return false;
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], aStack, bStack)) return false;
    }
  } else {
    // Deep compare objects.
    var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(a), key;
    length = _keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__keys_js__["a" /* default */])(b).length !== length) return false;
    while (length--) {
      // Deep compare each member
      key = _keys[length];
      if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__has_js__["a" /* default */])(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}

// Perform a deep comparison to check if two objects are equal.
function isEqual(a, b) {
  return eq(a, b);
}


/***/ }),
/* 1188 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/isError.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Error'));


/***/ }),
/* 1189 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/isFinite.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFinite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(/*! ./isSymbol.js */ 664);



// Is a given object a finite number?
function isFinite(obj) {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(obj) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setup_js__["r" /* _isFinite */])(obj) && !isNaN(parseFloat(obj));
}


/***/ }),
/* 1190 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/isMap.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(/*! ./_stringTagBug.js */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(/*! ./_methodFingerprint.js */ 285);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["a" /* isIE11 */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["d" /* mapMethods */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Map'));


/***/ }),
/* 1191 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/isNull.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNull;
// Is a given value equal to null?
function isNull(obj) {
  return obj === null;
}


/***/ }),
/* 1192 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/isRegExp.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('RegExp'));


/***/ }),
/* 1193 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/isSet.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(/*! ./_stringTagBug.js */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(/*! ./_methodFingerprint.js */ 285);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["a" /* isIE11 */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["b" /* setMethods */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('Set'));


/***/ }),
/* 1194 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/isWeakMap.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__ = __webpack_require__(/*! ./_stringTagBug.js */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__ = __webpack_require__(/*! ./_methodFingerprint.js */ 285);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__stringTagBug_js__["a" /* isIE11 */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["a" /* ie11fingerprint */])(__WEBPACK_IMPORTED_MODULE_2__methodFingerprint_js__["c" /* weakMapMethods */]) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakMap'));


/***/ }),
/* 1195 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/isWeakSet.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tagTester_js__ = __webpack_require__(/*! ./_tagTester.js */ 50);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tagTester_js__["a" /* default */])('WeakSet'));


/***/ }),
/* 1196 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/last.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = last;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest_js__ = __webpack_require__(/*! ./rest.js */ 672);


// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[array.length - 1];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__rest_js__["a" /* default */])(array, Math.max(0, array.length - n));
}


/***/ }),
/* 1197 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./~/underscore/modules/lastIndexOf.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__ = __webpack_require__(/*! ./findLastIndex.js */ 653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__ = __webpack_require__(/*! ./_createIndexFinder.js */ 637);



// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createIndexFinder_js__["a" /* default */])(-1, __WEBPACK_IMPORTED_MODULE_0__findLastIndex_js__["a" /* default */]));


/***/ }),
/* 1198 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/mapObject.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);



// Returns the results of applying the `iteratee` to each element of `obj`.
// In contrast to `_.map` it returns an object.
function mapObject(obj, iteratee, context) {
  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj),
      length = _keys.length,
      results = {};
  for (var index = 0; index < length; index++) {
    var currentKey = _keys[index];
    results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}


/***/ }),
/* 1199 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/memoize.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_js__ = __webpack_require__(/*! ./_has.js */ 99);


// Memoize an expensive function by storing its results.
function memoize(func, hasher) {
  var memoize = function(key) {
    var cache = memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__has_js__["a" /* default */])(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  memoize.cache = {};
  return memoize;
}


/***/ }),
/* 1200 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/min.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values_js__ = __webpack_require__(/*! ./values.js */ 129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__each_js__ = __webpack_require__(/*! ./each.js */ 115);





// Return the minimum element (or element-based computation).
function min(obj, iteratee, context) {
  var result = Infinity, lastComputed = Infinity,
      value, computed;
  if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
    obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__values_js__["a" /* default */])(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value < result) {
        result = value;
      }
    }
  } else {
    iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(iteratee, context);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__each_js__["a" /* default */])(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}


/***/ }),
/* 1201 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/mixin.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mixin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(/*! ./each.js */ 115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_js__ = __webpack_require__(/*! ./functions.js */ 654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chainResult_js__ = __webpack_require__(/*! ./_chainResult.js */ 634);






// Add your own custom functions to the Underscore object.
function mixin(obj) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__functions_js__["a" /* default */])(obj), function(name) {
    var func = __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */][name] = obj[name];
    __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
      var args = [this._wrapped];
      __WEBPACK_IMPORTED_MODULE_3__setup_js__["c" /* push */].apply(args, arguments);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__chainResult_js__["a" /* default */])(this, func.apply(__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */], args));
    };
  });
  return __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */];
}


/***/ }),
/* 1202 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/object.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = object;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getLength_js__ = __webpack_require__(/*! ./_getLength.js */ 68);


// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of `_.pairs`.
function object(list, values) {
  var result = {};
  for (var i = 0, length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getLength_js__["a" /* default */])(list); i < length; i++) {
    if (values) {
      result[list[i]] = values[i];
    } else {
      result[list[i][0]] = list[i][1];
    }
  }
  return result;
}


/***/ }),
/* 1203 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/omit.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__negate_js__ = __webpack_require__(/*! ./negate.js */ 293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map_js__ = __webpack_require__(/*! ./map.js */ 128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flatten_js__ = __webpack_require__(/*! ./_flatten.js */ 127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains_js__ = __webpack_require__(/*! ./contains.js */ 157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pick_js__ = __webpack_require__(/*! ./pick.js */ 670);








// Return a copy of the object without the disallowed properties.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(obj, keys) {
  var iteratee = keys[0], context;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isFunction_js__["a" /* default */])(iteratee)) {
    iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__negate_js__["a" /* default */])(iteratee);
    if (keys.length > 1) context = keys[1];
  } else {
    keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__map_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__flatten_js__["a" /* default */])(keys, false, false), String);
    iteratee = function(value, key) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__contains_js__["a" /* default */])(keys, key);
    };
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pick_js__["a" /* default */])(obj, iteratee, context);
}));


/***/ }),
/* 1204 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/once.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(/*! ./partial.js */ 194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__before_js__ = __webpack_require__(/*! ./before.js */ 644);



// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__before_js__["a" /* default */], 2));


/***/ }),
/* 1205 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/pairs.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pairs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);


// Convert an object into a list of `[key, value]` pairs.
// The opposite of `_.object` with one argument.
function pairs(obj) {
  var _keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__keys_js__["a" /* default */])(obj);
  var length = _keys.length;
  var pairs = Array(length);
  for (var i = 0; i < length; i++) {
    pairs[i] = [_keys[i], obj[_keys[i]]];
  }
  return pairs;
}


/***/ }),
/* 1206 */
/* exports provided: default */
/* exports used: default */
/*!*******************************************!*\
  !*** ./~/underscore/modules/partition.js ***!
  \*******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_js__ = __webpack_require__(/*! ./_group.js */ 192);


// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__group_js__["a" /* default */])(function(result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true));


/***/ }),
/* 1207 */
/* exports provided: default */
/* exports used: default */
/*!********************************************!*\
  !*** ./~/underscore/modules/propertyOf.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = propertyOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(/*! ./noop.js */ 669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(/*! ./get.js */ 655);



// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) return __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */];
  return function(path) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(obj, path);
  };
}


/***/ }),
/* 1208 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/range.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function range(start, stop, step) {
  if (stop == null) {
    stop = start || 0;
    start = 0;
  }
  if (!step) {
    step = stop < start ? -1 : 1;
  }

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var idx = 0; idx < length; idx++, start += step) {
    range[idx] = start;
  }

  return range;
}


/***/ }),
/* 1209 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/reduce.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(/*! ./_createReduce.js */ 639);


// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(1));


/***/ }),
/* 1210 */
/* exports provided: default */
/* exports used: default */
/*!*********************************************!*\
  !*** ./~/underscore/modules/reduceRight.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduce_js__ = __webpack_require__(/*! ./_createReduce.js */ 639);


// The right-associative version of reduce, also known as `foldr`.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createReduce_js__["a" /* default */])(-1));


/***/ }),
/* 1211 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/reject.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(/*! ./filter.js */ 158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__negate_js__ = __webpack_require__(/*! ./negate.js */ 293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);




// Return all the elements for which a truth test fails.
function reject(obj, predicate, context) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__negate_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cb_js__["a" /* default */])(predicate)), context);
}


/***/ }),
/* 1212 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/result.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = result;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(/*! ./isFunction.js */ 69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPath_js__ = __webpack_require__(/*! ./_toPath.js */ 155);



// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result(obj, path, fallback) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toPath_js__["a" /* default */])(path);
  var length = path.length;
  if (!length) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(fallback) ? fallback.call(obj) : fallback;
  }
  for (var i = 0; i < length; i++) {
    var prop = obj == null ? void 0 : obj[path[i]];
    if (prop === void 0) {
      prop = fallback;
      i = length; // Ensure we don't continue iterating.
    }
    obj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(prop) ? prop.call(obj) : prop;
  }
  return obj;
}


/***/ }),
/* 1213 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/shuffle.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sample_js__ = __webpack_require__(/*! ./sample.js */ 673);


// Shuffle a collection.
function shuffle(obj) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sample_js__["a" /* default */])(obj, Infinity);
}


/***/ }),
/* 1214 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/size.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = size;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);



// Return the number of elements in a collection.
function size(obj) {
  if (obj == null) return 0;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(obj) ? obj.length : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(obj).length;
}


/***/ }),
/* 1215 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/some.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = some;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(/*! ./_isArrayLike.js */ 62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(/*! ./keys.js */ 44);




// Determine if at least one element in the object passes a truth test.
function some(obj, predicate, context) {
  predicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(predicate, context);
  var _keys = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(obj) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (predicate(obj[currentKey], currentKey, obj)) return true;
  }
  return false;
}


/***/ }),
/* 1216 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/underscore/modules/sortBy.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortBy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cb_js__ = __webpack_require__(/*! ./_cb.js */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pluck_js__ = __webpack_require__(/*! ./pluck.js */ 295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map_js__ = __webpack_require__(/*! ./map.js */ 128);




// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj, iteratee, context) {
  var index = 0;
  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cb_js__["a" /* default */])(iteratee, context);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__pluck_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__map_js__["a" /* default */])(obj, function(value, key, list) {
    return {
      value: value,
      index: index++,
      criteria: iteratee(value, key, list)
    };
  }).sort(function(left, right) {
    var a = left.criteria;
    var b = right.criteria;
    if (a !== b) {
      if (a > b || a === void 0) return 1;
      if (a < b || b === void 0) return -1;
    }
    return left.index - right.index;
  }), 'value');
}


/***/ }),
/* 1217 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/tap.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tap;
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}


/***/ }),
/* 1218 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/template.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = template;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaults_js__ = __webpack_require__(/*! ./defaults.js */ 647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__templateSettings_js__ = __webpack_require__(/*! ./templateSettings.js */ 675);




// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch = /(.)^/;

// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes = {
  "'": "'",
  '\\': '\\',
  '\r': 'r',
  '\n': 'n',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

function escapeChar(match) {
  return '\\' + escapes[match];
}

// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var bareIdentifier = /^\s*(\w|\$)+\s*$/;

// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
function template(text, settings, oldSettings) {
  if (!settings && oldSettings) settings = oldSettings;
  settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaults_js__["a" /* default */])({}, settings, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */].templateSettings);

  // Combine delimiters into one regular expression via alternation.
  var matcher = RegExp([
    (settings.escape || noMatch).source,
    (settings.interpolate || noMatch).source,
    (settings.evaluate || noMatch).source
  ].join('|') + '|$', 'g');

  // Compile the template source, escaping string literals appropriately.
  var index = 0;
  var source = "__p+='";
  text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
    source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
    index = offset + match.length;

    if (escape) {
      source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
    } else if (interpolate) {
      source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
    } else if (evaluate) {
      source += "';\n" + evaluate + "\n__p+='";
    }

    // Adobe VMs need the match returned to produce the correct offset.
    return match;
  });
  source += "';\n";

  var argument = settings.variable;
  if (argument) {
    // Insure against third-party code injection. (CVE-2021-23358)
    if (!bareIdentifier.test(argument)) throw new Error(
      'variable is not a bare identifier: ' + argument
    );
  } else {
    // If a variable is not specified, place data values in local scope.
    source = 'with(obj||{}){\n' + source + '}\n';
    argument = 'obj';
  }

  source = "var __t,__p='',__j=Array.prototype.join," +
    "print=function(){__p+=__j.call(arguments,'');};\n" +
    source + 'return __p;\n';

  var render;
  try {
    render = new Function(argument, '_', source);
  } catch (e) {
    e.source = source;
    throw e;
  }

  var template = function(data) {
    return render.call(this, data, __WEBPACK_IMPORTED_MODULE_1__underscore_js__["a" /* default */]);
  };

  // Provide the compiled source as a convenience for precompilation.
  template.source = 'function(' + argument + '){\n' + source + '}';

  return template;
}


/***/ }),
/* 1219 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/throttle.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__now_js__ = __webpack_require__(/*! ./now.js */ 294);


// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function() {
    previous = options.leading === false ? 0 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function() {
    var _now = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__now_js__["a" /* default */])();
    if (!previous && options.leading === false) previous = _now;
    var remaining = wait - (_now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = _now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function() {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}


/***/ }),
/* 1220 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/times.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = times;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__ = __webpack_require__(/*! ./_optimizeCb.js */ 153);


// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__optimizeCb_js__["a" /* default */])(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}


/***/ }),
/* 1221 */
/* exports provided: default */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./~/underscore/modules/underscore-array-methods.js ***!
  \**********************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__underscore_js__ = __webpack_require__(/*! ./underscore.js */ 64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(/*! ./each.js */ 115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setup_js__ = __webpack_require__(/*! ./_setup.js */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chainResult_js__ = __webpack_require__(/*! ./_chainResult.js */ 634);





// Add all mutator `Array` functions to the wrapper.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["b" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) {
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) {
        delete obj[0];
      }
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

// Add all accessor `Array` functions to the wrapper.
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */])(['concat', 'join', 'slice'], function(name) {
  var method = __WEBPACK_IMPORTED_MODULE_2__setup_js__["b" /* ArrayProto */][name];
  __WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */].prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) obj = method.apply(obj, arguments);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__chainResult_js__["a" /* default */])(this, obj);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__underscore_js__["a" /* default */]);


/***/ }),
/* 1222 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/unescape.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createEscaper_js__ = __webpack_require__(/*! ./_createEscaper.js */ 636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__ = __webpack_require__(/*! ./_unescapeMap.js */ 1161);



// Function for unescaping strings from HTML interpolation.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createEscaper_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unescapeMap_js__["a" /* default */]));


/***/ }),
/* 1223 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/union.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uniq_js__ = __webpack_require__(/*! ./uniq.js */ 678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flatten_js__ = __webpack_require__(/*! ./_flatten.js */ 127);




// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(arrays) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__uniq_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__flatten_js__["a" /* default */])(arrays, true, true));
}));


/***/ }),
/* 1224 */
/* exports provided: default */
/* exports used: default */
/*!******************************************!*\
  !*** ./~/underscore/modules/uniqueId.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniqueId;
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}


/***/ }),
/* 1225 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/underscore/modules/where.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = where;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter_js__ = __webpack_require__(/*! ./filter.js */ 158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matcher_js__ = __webpack_require__(/*! ./matcher.js */ 193);



// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
function where(obj, attrs) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__filter_js__["a" /* default */])(obj, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__matcher_js__["a" /* default */])(attrs));
}


/***/ }),
/* 1226 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./~/underscore/modules/without.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__difference_js__ = __webpack_require__(/*! ./difference.js */ 649);



// Return a version of the array that does not contain the specified value(s).
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(function(array, otherArrays) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__difference_js__["a" /* default */])(array, otherArrays);
}));


/***/ }),
/* 1227 */
/* exports provided: default */
/* exports used: default */
/*!**************************************!*\
  !*** ./~/underscore/modules/wrap.js ***!
  \**************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partial_js__ = __webpack_require__(/*! ./partial.js */ 194);


// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__partial_js__["a" /* default */])(wrapper, func);
}


/***/ }),
/* 1228 */
/* exports provided: default */
/* exports used: default */
/*!*************************************!*\
  !*** ./~/underscore/modules/zip.js ***!
  \*************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__restArguments_js__ = __webpack_require__(/*! ./restArguments.js */ 63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unzip_js__ = __webpack_require__(/*! ./unzip.js */ 679);



// Zip together multiple lists into a single array -- elements that share
// an index go together.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__restArguments_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__unzip_js__["a" /* default */]));


/***/ }),
/* 1229 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./client/assets/login/img/ambiente-seguro-es.png ***!
  \********************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1230 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./client/assets/login/img/ambiente-seguro-in.png ***!
  \********************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1231 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./client/assets/login/img/ambiente-seguro-pt.png ***!
  \********************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1232 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/assets/login/img/borda-body-bottom.png ***!
  \*******************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAAICAYAAADp9wbEAAAAAXNSR0IArs4c6QAAAQFJREFUeAHt2KENgFAQA1BgKQZhG3ZiChRBMAFBYsB/BzPUnHqnr2nyZPt5v7/OESBAgACBQOB53+W6zimIeCVAgAABAt16HFtrbURBgAABAgRSgSEN+CdAgAABAgQIECBAgAABAgQIECBQKWDAqtTWRYAAAQIECBAgQIAAAQIECBAgEAsYsGIyAQIECBAgQIAAAQIECBAgQIAAgUoBA1alti4CBAgQIECAAAECBAgQIECAAIFYwIAVkwkQIECAAAECBAgQIECAAAECBAhUChiwKrV1ESBAgAABAgQIECBAgAABAgQIxAIGrJhMgAABAgQIECBAgAABAgQIECBAoFLgB50OD+XIlcVvAAAAAElFTkSuQmCC"

/***/ }),
/* 1233 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./client/assets/login/img/certificado-saae18-es.png ***!
  \***********************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1234 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./client/assets/login/img/certificado-saae18-in.png ***!
  \***********************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1235 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./client/assets/login/img/certificado-saae18-pt.png ***!
  \***********************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1236 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/assets/login/img/gestao-financeira-inteligente-es.png ***!
  \**********************************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1237 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/assets/login/img/gestao-financeira-inteligente-in.png ***!
  \**********************************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1238 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/assets/login/img/gestao-financeira-inteligente-pt.png ***!
  \**********************************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1239 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/assets/login/img/premio-br-week-es.png ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fb343314e2836c883acc883900723994.png";

/***/ }),
/* 1240 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/assets/login/img/premio-br-week-in.png ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7ca856ad121ef25d15f7356a2138f587.png";

/***/ }),
/* 1241 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/assets/login/img/premio-br-week-pt.png ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fdab1bde6111a4cdad40cb1a29b696dc.png";

/***/ }),
/* 1242 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./client/assets/logos_equals/logo_equals_branco.png ***!
  \***********************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1243 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./client/assets/notFound/forbidden.png ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bff66eabff86c866b7fbd983aac975dd.png";

/***/ }),
/* 1244 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./client/assets/notFound/notFound.png ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f5b1adc8987277fa74a360ce6e5e22b.png";

/***/ }),
/* 1245 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./client/assets/vue-tables-2/lupa-active.png ***!
  \****************************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAvJJREFUSA2tVs1PU0EQn9nXUkkoPXhAAUFNxAMxsV48iAfFkxfoxUQ8gJoYE8NF/wE9evHgR2JMBEKixnAQ7yKJ4MFwoJcawUSCtE168KDF1NKPcaZ1X/e9vodPZJNmZ387M783szO7RfAZh89dixULpWHC6hAC9BNAp6iynGU5haReR1rDs1/ePPnu48IBs13zOHB6bLhShccA1NG8ayKYsxRc31iYmjVRL9lB1DV4Yy8Vf94HohEvZV8M4QVG2sYzc4+++enYREICxc0kEXT7KW+HI0IaIm3H/ciUNqbi5oNmEswrxDsKrPMtYdwvP5EF49PKa1uZxVZ8mJgp1yKqnwm9cm3Mt0RCl9fePl03cS0fOnu1d6tYnuTCOKMxmS2FCa8zQ6muX4WtFfPgmX0+vTg1iIjsx38QEXYPjM05yTC3p7XlqLsalZSwSSIpkUj+RiL0oiO6zjRSR92n8wOV9IkJKYR7fuky9bQsumKj1zK7fQrGOtAvgj1IfbDloILLpskn+1Gc31rHa5+hcHVZy0Fnt43bp/ixyzuo0yB6XEJFt56kLmuC5ZKKm+sgcpMN4me3naQu5QCxetKxDrJosqFVt5mSW9gEqwQ3pRlNbDtZdMXG1EFUC+ZaZCVXPfdBrrFB0VrHczM2MG9JGlZ0uaCjWkPuvNi+3mm91nPN2W5eQQrUePr95ENNoGf7qzsHRp8DwUW9UZ/lUuVm5D7RJVw7eD6TeroakWg7RGs0szjhHZEo/e8zoYn4Ca6AUpey7yZf2hgLll7k15YK7UcGpqFSkvfomMZ3MHNvUiJ68MRKfj1pV7SdOtNh0KdcDp6r9i4h/iCoTHDq7Q93R+ZJJKRef06Qi4wdcI/QqpSwVFdq5vaW6HedunKBsCLn7EnmSyTG/zr+kD1jspBty2fGkQ812O2dnQv5jeVUe0/8E0edYC/6HlVM3KcXO/fusswsTs0g4AiTlfUWR1Td1Yi04/zX5MdYT3yJyfqYJGOBdes3DJ8t+3TjYKEAAAAASUVORK5CYII="

/***/ }),
/* 1246 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./client/assets/vue-tables-2/lupa.png ***!
  \*********************************************/
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAArdJREFUSA2tVr+PEkEUZhcCFGwsLIzGxILCAAVQWV9sjM2dxZ3xLIzdNTb6F1x5zRXaWGlichpj4d0fYCysTEyA4iBiKEyICYWFLgUQF/w+Mm+cHXc4yDEJN+/X975582Zmz0s5Rq/XuzAcDrdms9kmQir4XVGhPzCfep53UigUjovF4i9lXzh5Sd5Go7GFRM9BcinJLzbEDBCzV6/Xj8XmmmNEnU7n4mg0eorgXRfAYX+Tz+cflUqlnw5/ShORZDweN7HCq67gRXZU18/lcjUXmS9gVPLMJgE4hH8/nU7fzmazl/mjTJvyCTxFLHNogyXMK2JPYH9v+pDoIxI/LJfL3027yO12+9pkMnkJgg2xqflOUs88nq4wDL8CoBtPkmq1ehPzzEoSU4HxWq3WB5MMmEEQBNft0+irI2yShKzkLBIyMkbFcovngwtmTtFl9uHgPdED+qFru3SQITCWGMPEfsVy0sfDwMuoB5r9WStLCgmYWE6mIZHc+HlagBpzYYU/CZhYTqbSx3uFvGeGYuvGdhCJ+HbpEUVRXStLCjYGh+SbDSXRqWkE6IapLyPbGFTUtXE+2E9MI/THvIymbZHMWGLMGN/3P5k6ZZ9PPQIH4sBqAnXj9TsoPntGrKdiA/EhVz+TybwSXWafNxiAPTFwhr7BG7+oMvrsV0HlOKhUKhMzH2W9arx3r6HfMwOwuhCkh7wncoTZePaE2wWfrkRw2LYHeL7+q0gTnfczIUSYIyzifq1We2vY/t0jfkf4PYGTlZ1npFHpUbPZvGsm0RWZxhU+5X3gDlDB7+l0+gJy2sgTqyyRiMGOf07Y5C5W3OUR5umSxqOCHdi5G4lkTiKSrToU2RFwGQMbQd5cKxGTY9u3MbEyk+wLn6C1DnzG3yHhLn5/JDF6OF17RZIcl/kWerav9Cd/AbpIRvQuPbBQAAAAAElFTkSuQmCC"

/***/ }),
/* 1247 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/vue-analytics/dist/vue-analytics.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ }),
/* 1248 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./~/vue-content-placeholder/dist/vue-content-placeholder.min.js ***!
  \***********************************************************************/
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

eval("\n/* styles */\n__webpack_require__(8)\n\nvar Component = __webpack_require__(6)(\n  /* script */\n  __webpack_require__(1),\n  /* template */\n  __webpack_require__(7),\n  /* scopeId */\n  \"data-v-6af9bdec\",\n  /* cssModules */\n  null\n)\nComponent.options.__file = \"/Volumes/DevelopOnly/Github/vue-content-placeholder/src/ContentPlaceholder.vue\"\nif (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== \"default\" && key !== \"__esModule\"})) {console.error(\"named exports are not supported in *.vue files.\")}\nif (Component.options.functional) {console.error(\"[vue-loader] ContentPlaceholder.vue: functional components are not supported with templates, they should use render functions.\")}\n\n/* hot reload */\nif (false) {(function () {\n  var hotAPI = require(\"vue-hot-reload-api\")\n  hotAPI.install(require(\"vue\"), false)\n  if (!hotAPI.compatible) return\n  module.hot.accept()\n  if (!module.hot.data) {\n    hotAPI.createRecord(\"data-v-6af9bdec\", Component.options)\n  } else {\n    hotAPI.reload(\"data-v-6af9bdec\", Component.options)\n  }\n})()}\n\nmodule.exports = Component.exports\n\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///0\n");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _utils = __webpack_require__(3);\n\nexports.default = {\n  data: function data() {\n    return {};\n  },\n\n  props: {\n    rows: {\n      type: Array,\n      required: true\n    },\n    size: {\n      type: String,\n      default: '250%'\n    }\n  },\n  computed: {\n    formattedRows: function formattedRows() {\n      return (0, _utils.formatRows)(this.rows);\n    }\n  }\n}; //\n//\n//\n//\n//\n//\n//\n//\n//\n//\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8vQ29udGVudFBsYWNlaG9sZGVyLnZ1ZT8yNzdjIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQWFBOzs7d0JBRUE7V0FFQTtBQUNBOzs7O1lBR0E7Z0JBRUE7QUFIQTs7WUFLQTtlQUdBO0FBSkE7QUFMQTs7NENBV0E7eUNBQ0E7QUFFQTtBQUpBO0FBZkEiLCJmaWxlIjoiMS5qcyIsInNvdXJjZXNDb250ZW50IjpbIjx0ZW1wbGF0ZT5cbiAgPGRpdiBjbGFzcz1cImFuaW1hdGVkLWJhY2tncm91bmRcIiA6c3R5bGU9XCJ7YmFja2dyb3VuZFNpemU6IHNpemV9XCI+XG4gICAgPGRpdiBjbGFzcz1cInJvd1wiIDpzdHlsZT1cIntoZWlnaHQ6IHJvdy5oZWlnaHR9XCIgdi1mb3I9XCJyb3cgaW4gZm9ybWF0dGVkUm93c1wiPlxuICAgICAgPGRpdiA6c3R5bGU9XCJib3guc3R5bGVcIiB2LWZvcj1cImJveCBpbiByb3cuYm94ZXNcIj5cbiAgICAgICAgPGRpdiB2LWlmPVwiYm94LnN1YkNsYXNzXCIgOmNsYXNzPVwiYm94LnN1YkNsYXNzXCI+PC9kaXY+XG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgPC9kaXY+XG48L3RlbXBsYXRlPlxuXG48c2NyaXB0PlxuaW1wb3J0IHsgZm9ybWF0Um93cyB9IGZyb20gJy4vdXRpbHMnXG5cbmV4cG9ydCBkZWZhdWx0IHtcbiAgZGF0YSAoKSB7XG4gICAgcmV0dXJuIHtcbiAgICB9XG4gIH0sXG4gIHByb3BzOiB7XG4gICAgcm93czoge1xuICAgICAgdHlwZTogQXJyYXksXG4gICAgICByZXF1aXJlZDogdHJ1ZVxuICAgIH0sXG4gICAgc2l6ZToge1xuICAgICAgdHlwZTogU3RyaW5nLFxuICAgICAgZGVmYXVsdDogJzI1MCUnXG4gICAgfVxuICB9LFxuICBjb21wdXRlZDoge1xuICAgIGZvcm1hdHRlZFJvd3MgKCkge1xuICAgICAgcmV0dXJuIGZvcm1hdFJvd3ModGhpcy5yb3dzKVxuICAgIH1cbiAgfVxufVxuPC9zY3JpcHQ+XG5cbjxzdHlsZSBzY29wZWQ+XG4uYm94IHtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIG1hcmdpbi1ib3R0b206IDA7XG4gIGJhY2tncm91bmQtY29sb3I6IHdoaXRlO1xuICBvdmVyZmxvdzogaGlkZGVuO1xufVxuXG4ucm93e1xuICB3aWR0aDogMTAwJTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleDogMCAxIGF1dG87XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGZsZXgtd3JhcDogd3JhcDtcbn1cblxuQGtleWZyYW1lcyBwbGFjZUhvbGRlclNoaW1tZXJ7XG4gIDAle1xuICAgIGJhY2tncm91bmQtcG9zaXRpb246IDEwMCUgMFxuICB9XG4gIDEwMCV7XG4gICAgYmFja2dyb3VuZC1wb3NpdGlvbjogLTEwMCUgMFxuICB9XG59XG5cbi5hbmltYXRlZC1iYWNrZ3JvdW5kIHtcbiAgYW5pbWF0aW9uLWR1cmF0aW9uOiAxcztcbiAgYW5pbWF0aW9uLWZpbGwtbW9kZTogZm9yd2FyZHM7XG4gIGFuaW1hdGlvbi1pdGVyYXRpb24tY291bnQ6IGluZmluaXRlO1xuICBhbmltYXRpb24tbmFtZTogcGxhY2VIb2xkZXJTaGltbWVyO1xuICBhbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOiBsaW5lYXI7XG4gIGJhY2tncm91bmQ6ICNmNmY3Zjg7XG4gIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgI2VlZWVlZSA4JSwgI2RkZGRkZCAxOCUsICNlZWVlZWUgMzMlKTtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xufVxuPC9zdHlsZT5cblxuXG5cbi8vIFdFQlBBQ0sgRk9PVEVSIC8vXG4vLyBDb250ZW50UGxhY2Vob2xkZXIudnVlPzI5Zjk5NTMwIl0sInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///1\n");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _ContentPlaceholder = __webpack_require__(0);\n\nvar _ContentPlaceholder2 = _interopRequireDefault(_ContentPlaceholder);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nexports.default = _ContentPlaceholder2.default;\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8vLi9zcmMvaW5kZXguanM/OTU1MiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSIsImZpbGUiOiIyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbnRlbnRQbGFjZWhvbGRlciBmcm9tICcuL0NvbnRlbnRQbGFjZWhvbGRlci52dWUnXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRlbnRQbGFjZWhvbGRlclxuXG5cblxuLy8gV0VCUEFDSyBGT09URVIgLy9cbi8vIC4vc3JjL2luZGV4LmpzIl0sInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///2\n");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nfunction isFlexBasis(str) {\n  return Number(str).toString() === str.toString();\n}\n\nfunction isWidth(str) {\n  var cssSuffix = ['px', '%', 'em', 'rem'];\n  var checkState = false;\n  cssSuffix.forEach(function (suffix) {\n    if (Number(str.split(suffix)[0]) && str.split(suffix)[1] === '' && str.split(suffix).length === 2) {\n      checkState = true;\n    }\n  });\n  return checkState;\n}\n\nfunction getBoxStyle(left, width, last) {\n  var arr = [];\n  if (left !== 0) {\n    if (isFlexBasis(left)) {\n      arr.push({ style: 'flex-grow: ' + left + '; flex-shrink: 0; flex-basis: 0;', subClass: 'box' });\n    } else if (isWidth(left)) {\n      arr.push({ style: 'flex-grow: 0; flex-shrink: 0; flex-basis: ' + left + ';', subClass: 'box' });\n    }\n  }\n  if (isFlexBasis(width)) {\n    arr.push({ style: 'flex-grow: ' + width + '; flex-shrink: 0; flex-basis: 0;' });\n  } else if (isWidth(width)) {\n    arr.push({ style: 'flex-grow: 0; flex-shrink: 0; flex-basis: ' + width + ';' });\n  }\n  if (last) {\n    arr.push({ style: 'flex-grow: 1; flex-shrink: 0; flex-basis: 0;', subClass: 'box' });\n  }\n  return arr;\n}\n\nfunction formatRows(rows) {\n  var rowArr = [];\n  rows.forEach(function (row) {\n    var boxArr = [];\n    var rowObj = {};\n    // Add height\n    rowObj.height = row.height;\n    // Add style\n    row.boxes.forEach(function (box, index) {\n      if (index === row.boxes.length - 1) {\n        boxArr = boxArr.concat(getBoxStyle(box[0], box[1], true));\n      } else {\n        boxArr = boxArr.concat(getBoxStyle(box[0], box[1]));\n      }\n    });\n    rowObj.boxes = boxArr;\n    rowArr.push(rowObj);\n  });\n  return rowArr;\n}\n\nmodule.exports = {\n  isFlexBasis: isFlexBasis,\n  isWidth: isWidth,\n  getBoxStyle: getBoxStyle,\n  formatRows: formatRows\n};\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///3\n");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

eval("exports = module.exports = __webpack_require__(5)();\n// imports\n\n\n// module\nexports.push([module.i, \"\\n.box[data-v-6af9bdec] {\\n  box-sizing: border-box;\\n  position: relative;\\n  height: 100%;\\n  margin-bottom: 0;\\n  background-color: white;\\n  overflow: hidden;\\n}\\n.row[data-v-6af9bdec]{\\n  width: 100%;\\n  box-sizing: border-box;\\n  display: flex;\\n  flex: 0 1 auto;\\n  flex-direction: row;\\n  flex-wrap: wrap;\\n}\\n@keyframes placeHolderShimmer{\\n0%{\\n    background-position: 100% 0\\n}\\n100%{\\n    background-position: -100% 0\\n}\\n}\\n.animated-background[data-v-6af9bdec] {\\n  animation-duration: 1s;\\n  animation-fill-mode: forwards;\\n  animation-iteration-count: infinite;\\n  animation-name: placeHolderShimmer;\\n  animation-timing-function: linear;\\n  background: #f6f7f8;\\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\\n  position: relative;\\n}\\n\", \"\", {\"version\":3,\"sources\":[\"/./src/ContentPlaceholder.vue?29f99530\"],\"names\":[],\"mappings\":\";AAqCA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;CACA;AAEA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;CACA;AAEA;AACA;IACA,2BAAA;CACA;AACA;IACA,4BAAA;CACA;CACA;AAEA;EACA,uBAAA;EACA,8BAAA;EACA,oCAAA;EACA,mCAAA;EACA,kCAAA;EACA,oBAAA;EACA,4EAAA;EACA,mBAAA;CACA\",\"file\":\"ContentPlaceholder.vue\",\"sourcesContent\":[\"<template>\\n  <div class=\\\"animated-background\\\" :style=\\\"{backgroundSize: size}\\\">\\n    <div class=\\\"row\\\" :style=\\\"{height: row.height}\\\" v-for=\\\"row in formattedRows\\\">\\n      <div :style=\\\"box.style\\\" v-for=\\\"box in row.boxes\\\">\\n        <div v-if=\\\"box.subClass\\\" :class=\\\"box.subClass\\\"></div>\\n      </div>\\n    </div>\\n  </div>\\n</template>\\n\\n<script>\\nimport { formatRows } from './utils'\\n\\nexport default {\\n  data () {\\n    return {\\n    }\\n  },\\n  props: {\\n    rows: {\\n      type: Array,\\n      required: true\\n    },\\n    size: {\\n      type: String,\\n      default: '250%'\\n    }\\n  },\\n  computed: {\\n    formattedRows () {\\n      return formatRows(this.rows)\\n    }\\n  }\\n}\\n</script>\\n\\n<style scoped>\\n.box {\\n  box-sizing: border-box;\\n  position: relative;\\n  height: 100%;\\n  margin-bottom: 0;\\n  background-color: white;\\n  overflow: hidden;\\n}\\n\\n.row{\\n  width: 100%;\\n  box-sizing: border-box;\\n  display: flex;\\n  flex: 0 1 auto;\\n  flex-direction: row;\\n  flex-wrap: wrap;\\n}\\n\\n@keyframes placeHolderShimmer{\\n  0%{\\n    background-position: 100% 0\\n  }\\n  100%{\\n    background-position: -100% 0\\n  }\\n}\\n\\n.animated-background {\\n  animation-duration: 1s;\\n  animation-fill-mode: forwards;\\n  animation-iteration-count: infinite;\\n  animation-name: placeHolderShimmer;\\n  animation-timing-function: linear;\\n  background: #f6f7f8;\\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\\n  position: relative;\\n}\\n</style>\\n\"],\"sourceRoot\":\"webpack://\"}]);\n\n// exports\n\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///4\n");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

eval("/*\r\n\tMIT License http://www.opensource.org/licenses/mit-license.php\r\n\tAuthor Tobias Koppers @sokra\r\n*/\r\n// css base code, injected by the css-loader\r\nmodule.exports = function() {\r\n\tvar list = [];\r\n\r\n\t// return the list of modules as css string\r\n\tlist.toString = function toString() {\r\n\t\tvar result = [];\r\n\t\tfor(var i = 0; i < this.length; i++) {\r\n\t\t\tvar item = this[i];\r\n\t\t\tif(item[2]) {\r\n\t\t\t\tresult.push(\"@media \" + item[2] + \"{\" + item[1] + \"}\");\r\n\t\t\t} else {\r\n\t\t\t\tresult.push(item[1]);\r\n\t\t\t}\r\n\t\t}\r\n\t\treturn result.join(\"\");\r\n\t};\r\n\r\n\t// import a list of modules into the list\r\n\tlist.i = function(modules, mediaQuery) {\r\n\t\tif(typeof modules === \"string\")\r\n\t\t\tmodules = [[null, modules, \"\"]];\r\n\t\tvar alreadyImportedModules = {};\r\n\t\tfor(var i = 0; i < this.length; i++) {\r\n\t\t\tvar id = this[i][0];\r\n\t\t\tif(typeof id === \"number\")\r\n\t\t\t\talreadyImportedModules[id] = true;\r\n\t\t}\r\n\t\tfor(i = 0; i < modules.length; i++) {\r\n\t\t\tvar item = modules[i];\r\n\t\t\t// skip already imported module\r\n\t\t\t// this implementation is not 100% perfect for weird media query combinations\r\n\t\t\t//  when a module is imported multiple times with different media queries.\r\n\t\t\t//  I hope this will never occur (Hey this way we have smaller bundles)\r\n\t\t\tif(typeof item[0] !== \"number\" || !alreadyImportedModules[item[0]]) {\r\n\t\t\t\tif(mediaQuery && !item[2]) {\r\n\t\t\t\t\titem[2] = mediaQuery;\r\n\t\t\t\t} else if(mediaQuery) {\r\n\t\t\t\t\titem[2] = \"(\" + item[2] + \") and (\" + mediaQuery + \")\";\r\n\t\t\t\t}\r\n\t\t\t\tlist.push(item);\r\n\t\t\t}\r\n\t\t}\r\n\t};\r\n\treturn list;\r\n};\r\n\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8vLi9+L2Nzcy1sb2FkZXIvbGliL2Nzcy1iYXNlLmpzP2RhMDQiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUE7QUFDQTtBQUNBO0FBQ0EsZ0JBQWdCLGlCQUFpQjtBQUNqQztBQUNBO0FBQ0Esd0NBQXdDLGdCQUFnQjtBQUN4RCxJQUFJO0FBQ0o7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsZ0JBQWdCLGlCQUFpQjtBQUNqQztBQUNBO0FBQ0E7QUFDQTtBQUNBLFlBQVksb0JBQW9CO0FBQ2hDO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSxLQUFLO0FBQ0w7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiI1LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLypcclxuXHRNSVQgTGljZW5zZSBodHRwOi8vd3d3Lm9wZW5zb3VyY2Uub3JnL2xpY2Vuc2VzL21pdC1saWNlbnNlLnBocFxyXG5cdEF1dGhvciBUb2JpYXMgS29wcGVycyBAc29rcmFcclxuKi9cclxuLy8gY3NzIGJhc2UgY29kZSwgaW5qZWN0ZWQgYnkgdGhlIGNzcy1sb2FkZXJcclxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbigpIHtcclxuXHR2YXIgbGlzdCA9IFtdO1xyXG5cclxuXHQvLyByZXR1cm4gdGhlIGxpc3Qgb2YgbW9kdWxlcyBhcyBjc3Mgc3RyaW5nXHJcblx0bGlzdC50b1N0cmluZyA9IGZ1bmN0aW9uIHRvU3RyaW5nKCkge1xyXG5cdFx0dmFyIHJlc3VsdCA9IFtdO1xyXG5cdFx0Zm9yKHZhciBpID0gMDsgaSA8IHRoaXMubGVuZ3RoOyBpKyspIHtcclxuXHRcdFx0dmFyIGl0ZW0gPSB0aGlzW2ldO1xyXG5cdFx0XHRpZihpdGVtWzJdKSB7XHJcblx0XHRcdFx0cmVzdWx0LnB1c2goXCJAbWVkaWEgXCIgKyBpdGVtWzJdICsgXCJ7XCIgKyBpdGVtWzFdICsgXCJ9XCIpO1xyXG5cdFx0XHR9IGVsc2Uge1xyXG5cdFx0XHRcdHJlc3VsdC5wdXNoKGl0ZW1bMV0pO1xyXG5cdFx0XHR9XHJcblx0XHR9XHJcblx0XHRyZXR1cm4gcmVzdWx0LmpvaW4oXCJcIik7XHJcblx0fTtcclxuXHJcblx0Ly8gaW1wb3J0IGEgbGlzdCBvZiBtb2R1bGVzIGludG8gdGhlIGxpc3RcclxuXHRsaXN0LmkgPSBmdW5jdGlvbihtb2R1bGVzLCBtZWRpYVF1ZXJ5KSB7XHJcblx0XHRpZih0eXBlb2YgbW9kdWxlcyA9PT0gXCJzdHJpbmdcIilcclxuXHRcdFx0bW9kdWxlcyA9IFtbbnVsbCwgbW9kdWxlcywgXCJcIl1dO1xyXG5cdFx0dmFyIGFscmVhZHlJbXBvcnRlZE1vZHVsZXMgPSB7fTtcclxuXHRcdGZvcih2YXIgaSA9IDA7IGkgPCB0aGlzLmxlbmd0aDsgaSsrKSB7XHJcblx0XHRcdHZhciBpZCA9IHRoaXNbaV1bMF07XHJcblx0XHRcdGlmKHR5cGVvZiBpZCA9PT0gXCJudW1iZXJcIilcclxuXHRcdFx0XHRhbHJlYWR5SW1wb3J0ZWRNb2R1bGVzW2lkXSA9IHRydWU7XHJcblx0XHR9XHJcblx0XHRmb3IoaSA9IDA7IGkgPCBtb2R1bGVzLmxlbmd0aDsgaSsrKSB7XHJcblx0XHRcdHZhciBpdGVtID0gbW9kdWxlc1tpXTtcclxuXHRcdFx0Ly8gc2tpcCBhbHJlYWR5IGltcG9ydGVkIG1vZHVsZVxyXG5cdFx0XHQvLyB0aGlzIGltcGxlbWVudGF0aW9uIGlzIG5vdCAxMDAlIHBlcmZlY3QgZm9yIHdlaXJkIG1lZGlhIHF1ZXJ5IGNvbWJpbmF0aW9uc1xyXG5cdFx0XHQvLyAgd2hlbiBhIG1vZHVsZSBpcyBpbXBvcnRlZCBtdWx0aXBsZSB0aW1lcyB3aXRoIGRpZmZlcmVudCBtZWRpYSBxdWVyaWVzLlxyXG5cdFx0XHQvLyAgSSBob3BlIHRoaXMgd2lsbCBuZXZlciBvY2N1ciAoSGV5IHRoaXMgd2F5IHdlIGhhdmUgc21hbGxlciBidW5kbGVzKVxyXG5cdFx0XHRpZih0eXBlb2YgaXRlbVswXSAhPT0gXCJudW1iZXJcIiB8fCAhYWxyZWFkeUltcG9ydGVkTW9kdWxlc1tpdGVtWzBdXSkge1xyXG5cdFx0XHRcdGlmKG1lZGlhUXVlcnkgJiYgIWl0ZW1bMl0pIHtcclxuXHRcdFx0XHRcdGl0ZW1bMl0gPSBtZWRpYVF1ZXJ5O1xyXG5cdFx0XHRcdH0gZWxzZSBpZihtZWRpYVF1ZXJ5KSB7XHJcblx0XHRcdFx0XHRpdGVtWzJdID0gXCIoXCIgKyBpdGVtWzJdICsgXCIpIGFuZCAoXCIgKyBtZWRpYVF1ZXJ5ICsgXCIpXCI7XHJcblx0XHRcdFx0fVxyXG5cdFx0XHRcdGxpc3QucHVzaChpdGVtKTtcclxuXHRcdFx0fVxyXG5cdFx0fVxyXG5cdH07XHJcblx0cmV0dXJuIGxpc3Q7XHJcbn07XHJcblxuXG5cbi8vLy8vLy8vLy8vLy8vLy8vL1xuLy8gV0VCUEFDSyBGT09URVJcbi8vIC4vfi9jc3MtbG9hZGVyL2xpYi9jc3MtYmFzZS5qc1xuLy8gbW9kdWxlIGlkID0gNVxuLy8gbW9kdWxlIGNodW5rcyA9IDAiXSwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///5\n");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

eval("// this module is a runtime utility for cleaner component module output and will\n// be included in the final webpack user bundle\n\nmodule.exports = function normalizeComponent (\n  rawScriptExports,\n  compiledTemplate,\n  scopeId,\n  cssModules\n) {\n  var esModule\n  var scriptExports = rawScriptExports = rawScriptExports || {}\n\n  // ES6 modules interop\n  var type = typeof rawScriptExports.default\n  if (type === 'object' || type === 'function') {\n    esModule = rawScriptExports\n    scriptExports = rawScriptExports.default\n  }\n\n  // Vue.extend constructor export interop\n  var options = typeof scriptExports === 'function'\n    ? scriptExports.options\n    : scriptExports\n\n  // render functions\n  if (compiledTemplate) {\n    options.render = compiledTemplate.render\n    options.staticRenderFns = compiledTemplate.staticRenderFns\n  }\n\n  // scopedId\n  if (scopeId) {\n    options._scopeId = scopeId\n  }\n\n  // inject cssModules\n  if (cssModules) {\n    var computed = Object.create(options.computed || null)\n    Object.keys(cssModules).forEach(function (key) {\n      var module = cssModules[key]\n      computed[key] = function () { return module }\n    })\n    options.computed = computed\n  }\n\n  return {\n    esModule: esModule,\n    exports: scriptExports,\n    options: options\n  }\n}\n\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///6\n");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

eval("module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;\n  return _c('div', {\n    staticClass: \"animated-background\",\n    style: ({\n      backgroundSize: _vm.size\n    })\n  }, _vm._l((_vm.formattedRows), function(row) {\n    return _c('div', {\n      staticClass: \"row\",\n      style: ({\n        height: row.height\n      })\n    }, _vm._l((row.boxes), function(box) {\n      return _c('div', {\n        style: (box.style)\n      }, [(box.subClass) ? _c('div', {\n        class: box.subClass\n      }) : _vm._e()])\n    }))\n  }))\n},staticRenderFns: []}\nmodule.exports.render._withStripped = true\nif (false) {\n  module.hot.accept()\n  if (module.hot.data) {\n     require(\"vue-hot-reload-api\").rerender(\"data-v-6af9bdec\", module.exports)\n  }\n}\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8vLi9zcmMvQ29udGVudFBsYWNlaG9sZGVyLnZ1ZT8wZjA5Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGdCQUFnQixtQkFBbUIsYUFBYSwwQkFBMEI7QUFDMUU7QUFDQTtBQUNBO0FBQ0E7QUFDQSxLQUFLO0FBQ0wsR0FBRztBQUNIO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsT0FBTztBQUNQLEtBQUs7QUFDTDtBQUNBO0FBQ0EsT0FBTztBQUNQO0FBQ0EsT0FBTztBQUNQLEtBQUs7QUFDTCxHQUFHO0FBQ0gsQ0FBQztBQUNEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6IjcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJtb2R1bGUuZXhwb3J0cz17cmVuZGVyOmZ1bmN0aW9uICgpe3ZhciBfdm09dGhpczt2YXIgX2g9X3ZtLiRjcmVhdGVFbGVtZW50O3ZhciBfYz1fdm0uX3NlbGYuX2N8fF9oO1xuICByZXR1cm4gX2MoJ2RpdicsIHtcbiAgICBzdGF0aWNDbGFzczogXCJhbmltYXRlZC1iYWNrZ3JvdW5kXCIsXG4gICAgc3R5bGU6ICh7XG4gICAgICBiYWNrZ3JvdW5kU2l6ZTogX3ZtLnNpemVcbiAgICB9KVxuICB9LCBfdm0uX2woKF92bS5mb3JtYXR0ZWRSb3dzKSwgZnVuY3Rpb24ocm93KSB7XG4gICAgcmV0dXJuIF9jKCdkaXYnLCB7XG4gICAgICBzdGF0aWNDbGFzczogXCJyb3dcIixcbiAgICAgIHN0eWxlOiAoe1xuICAgICAgICBoZWlnaHQ6IHJvdy5oZWlnaHRcbiAgICAgIH0pXG4gICAgfSwgX3ZtLl9sKChyb3cuYm94ZXMpLCBmdW5jdGlvbihib3gpIHtcbiAgICAgIHJldHVybiBfYygnZGl2Jywge1xuICAgICAgICBzdHlsZTogKGJveC5zdHlsZSlcbiAgICAgIH0sIFsoYm94LnN1YkNsYXNzKSA/IF9jKCdkaXYnLCB7XG4gICAgICAgIGNsYXNzOiBib3guc3ViQ2xhc3NcbiAgICAgIH0pIDogX3ZtLl9lKCldKVxuICAgIH0pKVxuICB9KSlcbn0sc3RhdGljUmVuZGVyRm5zOiBbXX1cbm1vZHVsZS5leHBvcnRzLnJlbmRlci5fd2l0aFN0cmlwcGVkID0gdHJ1ZVxuaWYgKG1vZHVsZS5ob3QpIHtcbiAgbW9kdWxlLmhvdC5hY2NlcHQoKVxuICBpZiAobW9kdWxlLmhvdC5kYXRhKSB7XG4gICAgIHJlcXVpcmUoXCJ2dWUtaG90LXJlbG9hZC1hcGlcIikucmVyZW5kZXIoXCJkYXRhLXYtNmFmOWJkZWNcIiwgbW9kdWxlLmV4cG9ydHMpXG4gIH1cbn1cblxuXG4vLy8vLy8vLy8vLy8vLy8vLy9cbi8vIFdFQlBBQ0sgRk9PVEVSXG4vLyAuL34vdnVlLWxvYWRlci9saWIvdGVtcGxhdGUtY29tcGlsZXI/e1wiaWRcIjpcImRhdGEtdi02YWY5YmRlY1wifSEuL34vdnVlLWxvYWRlci9saWIvc2VsZWN0b3IuanM/dHlwZT10ZW1wbGF0ZSZpbmRleD0wIS4vc3JjL0NvbnRlbnRQbGFjZWhvbGRlci52dWVcbi8vIG1vZHVsZSBpZCA9IDdcbi8vIG1vZHVsZSBjaHVua3MgPSAwIl0sInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///7\n");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

eval("// style-loader: Adds some css to the DOM by adding a <style> tag\n\n// load the styles\nvar content = __webpack_require__(4);\nif(typeof content === 'string') content = [[module.i, content, '']];\nif(content.locals) module.exports = content.locals;\n// add the styles to the DOM\nvar update = __webpack_require__(9)(\"8e87d99a\", content, false);\n// Hot Module Replacement\nif(false) {\n // When the styles change, update the <style> tags\n if(!content.locals) {\n   module.hot.accept(\"!!../node_modules/css-loader/index.js?sourceMap!../node_modules/vue-loader/lib/style-compiler/index.js?{\\\"id\\\":\\\"data-v-6af9bdec\\\",\\\"scoped\\\":true,\\\"hasInlineConfig\\\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContentPlaceholder.vue\", function() {\n     var newContent = require(\"!!../node_modules/css-loader/index.js?sourceMap!../node_modules/vue-loader/lib/style-compiler/index.js?{\\\"id\\\":\\\"data-v-6af9bdec\\\",\\\"scoped\\\":true,\\\"hasInlineConfig\\\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContentPlaceholder.vue\");\n     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];\n     update(newContent);\n   });\n }\n // When the module is disposed, remove the <style> tags\n module.hot.dispose(function() { update(); });\n}\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///8\n");

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

eval("/*\n  MIT License http://www.opensource.org/licenses/mit-license.php\n  Author Tobias Koppers @sokra\n  Modified by Evan You @yyx990803\n*/\n\nvar hasDocument = typeof document !== 'undefined'\n\nif (typeof DEBUG !== 'undefined' && DEBUG) {\n  if (!hasDocument) {\n    throw new Error(\n    'vue-style-loader cannot be used in a non-browser environment. ' +\n    \"Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.\"\n  ) }\n}\n\nvar listToStyles = __webpack_require__(10)\n\n/*\ntype StyleObject = {\n  id: number;\n  parts: Array<StyleObjectPart>\n}\n\ntype StyleObjectPart = {\n  css: string;\n  media: string;\n  sourceMap: ?string\n}\n*/\n\nvar stylesInDom = {/*\n  [id: number]: {\n    id: number,\n    refs: number,\n    parts: Array<(obj?: StyleObjectPart) => void>\n  }\n*/}\n\nvar head = hasDocument && (document.head || document.getElementsByTagName('head')[0])\nvar singletonElement = null\nvar singletonCounter = 0\nvar isProduction = false\nvar noop = function () {}\n\n// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>\n// tags it will allow on a page\nvar isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())\n\nmodule.exports = function (parentId, list, _isProduction) {\n  isProduction = _isProduction\n\n  var styles = listToStyles(parentId, list)\n  addStylesToDom(styles)\n\n  return function update (newList) {\n    var mayRemove = []\n    for (var i = 0; i < styles.length; i++) {\n      var item = styles[i]\n      var domStyle = stylesInDom[item.id]\n      domStyle.refs--\n      mayRemove.push(domStyle)\n    }\n    if (newList) {\n      styles = listToStyles(parentId, newList)\n      addStylesToDom(styles)\n    } else {\n      styles = []\n    }\n    for (var i = 0; i < mayRemove.length; i++) {\n      var domStyle = mayRemove[i]\n      if (domStyle.refs === 0) {\n        for (var j = 0; j < domStyle.parts.length; j++) {\n          domStyle.parts[j]()\n        }\n        delete stylesInDom[domStyle.id]\n      }\n    }\n  }\n}\n\nfunction addStylesToDom (styles /* Array<StyleObject> */) {\n  for (var i = 0; i < styles.length; i++) {\n    var item = styles[i]\n    var domStyle = stylesInDom[item.id]\n    if (domStyle) {\n      domStyle.refs++\n      for (var j = 0; j < domStyle.parts.length; j++) {\n        domStyle.parts[j](item.parts[j])\n      }\n      for (; j < item.parts.length; j++) {\n        domStyle.parts.push(addStyle(item.parts[j]))\n      }\n      if (domStyle.parts.length > item.parts.length) {\n        domStyle.parts.length = item.parts.length\n      }\n    } else {\n      var parts = []\n      for (var j = 0; j < item.parts.length; j++) {\n        parts.push(addStyle(item.parts[j]))\n      }\n      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }\n    }\n  }\n}\n\nfunction createStyleElement () {\n  var styleElement = document.createElement('style')\n  styleElement.type = 'text/css'\n  head.appendChild(styleElement)\n  return styleElement\n}\n\nfunction addStyle (obj /* StyleObjectPart */) {\n  var update, remove\n  var styleElement = document.querySelector('style[data-vue-ssr-id~=\"' + obj.id + '\"]')\n\n  if (styleElement) {\n    if (isProduction) {\n      // has SSR styles and in production mode.\n      // simply do nothing.\n      return noop\n    } else {\n      // has SSR styles but in dev mode.\n      // for some reason Chrome can't handle source map in server-rendered\n      // style tags - source maps in <style> only works if the style tag is\n      // created and inserted dynamically. So we remove the server rendered\n      // styles and inject new ones.\n      styleElement.parentNode.removeChild(styleElement)\n    }\n  }\n\n  if (isOldIE) {\n    // use singleton mode for IE9.\n    var styleIndex = singletonCounter++\n    styleElement = singletonElement || (singletonElement = createStyleElement())\n    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)\n    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)\n  } else {\n    // use multi-style-tag mode in all other cases\n    styleElement = createStyleElement()\n    update = applyToTag.bind(null, styleElement)\n    remove = function () {\n      styleElement.parentNode.removeChild(styleElement)\n    }\n  }\n\n  update(obj)\n\n  return function updateStyle (newObj /* StyleObjectPart */) {\n    if (newObj) {\n      if (newObj.css === obj.css &&\n          newObj.media === obj.media &&\n          newObj.sourceMap === obj.sourceMap) {\n        return\n      }\n      update(obj = newObj)\n    } else {\n      remove()\n    }\n  }\n}\n\nvar replaceText = (function () {\n  var textStore = []\n\n  return function (index, replacement) {\n    textStore[index] = replacement\n    return textStore.filter(Boolean).join('\\n')\n  }\n})()\n\nfunction applyToSingletonTag (styleElement, index, remove, obj) {\n  var css = remove ? '' : obj.css\n\n  if (styleElement.styleSheet) {\n    styleElement.styleSheet.cssText = replaceText(index, css)\n  } else {\n    var cssNode = document.createTextNode(css)\n    var childNodes = styleElement.childNodes\n    if (childNodes[index]) styleElement.removeChild(childNodes[index])\n    if (childNodes.length) {\n      styleElement.insertBefore(cssNode, childNodes[index])\n    } else {\n      styleElement.appendChild(cssNode)\n    }\n  }\n}\n\nfunction applyToTag (styleElement, obj) {\n  var css = obj.css\n  var media = obj.media\n  var sourceMap = obj.sourceMap\n\n  if (media) {\n    styleElement.setAttribute('media', media)\n  }\n\n  if (sourceMap) {\n    // https://developer.chrome.com/devtools/docs/javascript-debugging\n    // this makes source maps inside style tags work properly in Chrome\n    css += '\\n/*# sourceURL=' + sourceMap.sources[0] + ' */'\n    // http://stackoverflow.com/a/26603875\n    css += '\\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'\n  }\n\n  if (styleElement.styleSheet) {\n    styleElement.styleSheet.cssText = css\n  } else {\n    while (styleElement.firstChild) {\n      styleElement.removeChild(styleElement.firstChild)\n    }\n    styleElement.appendChild(document.createTextNode(css))\n  }\n}\n\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///9\n");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

eval("/**\n * Translates the list format produced by css-loader into something\n * easier to manipulate.\n */\nmodule.exports = function listToStyles (parentId, list) {\n  var styles = []\n  var newStyles = {}\n  for (var i = 0; i < list.length; i++) {\n    var item = list[i]\n    var id = item[0]\n    var css = item[1]\n    var media = item[2]\n    var sourceMap = item[3]\n    var part = {\n      id: parentId + ':' + i,\n      css: css,\n      media: media,\n      sourceMap: sourceMap\n    }\n    if (!newStyles[id]) {\n      styles.push(newStyles[id] = { id: id, parts: [part] })\n    } else {\n      newStyles[id].parts.push(part)\n    }\n  }\n  return styles\n}\n\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly8vLi9+L3Z1ZS1zdHlsZS1sb2FkZXIvbGliL2xpc3RUb1N0eWxlcy5qcz9lNmFjIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsaUJBQWlCLGlCQUFpQjtBQUNsQztBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSxtQ0FBbUMsd0JBQXdCO0FBQzNELEtBQUs7QUFDTDtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6IjEwLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBUcmFuc2xhdGVzIHRoZSBsaXN0IGZvcm1hdCBwcm9kdWNlZCBieSBjc3MtbG9hZGVyIGludG8gc29tZXRoaW5nXG4gKiBlYXNpZXIgdG8gbWFuaXB1bGF0ZS5cbiAqL1xubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiBsaXN0VG9TdHlsZXMgKHBhcmVudElkLCBsaXN0KSB7XG4gIHZhciBzdHlsZXMgPSBbXVxuICB2YXIgbmV3U3R5bGVzID0ge31cbiAgZm9yICh2YXIgaSA9IDA7IGkgPCBsaXN0Lmxlbmd0aDsgaSsrKSB7XG4gICAgdmFyIGl0ZW0gPSBsaXN0W2ldXG4gICAgdmFyIGlkID0gaXRlbVswXVxuICAgIHZhciBjc3MgPSBpdGVtWzFdXG4gICAgdmFyIG1lZGlhID0gaXRlbVsyXVxuICAgIHZhciBzb3VyY2VNYXAgPSBpdGVtWzNdXG4gICAgdmFyIHBhcnQgPSB7XG4gICAgICBpZDogcGFyZW50SWQgKyAnOicgKyBpLFxuICAgICAgY3NzOiBjc3MsXG4gICAgICBtZWRpYTogbWVkaWEsXG4gICAgICBzb3VyY2VNYXA6IHNvdXJjZU1hcFxuICAgIH1cbiAgICBpZiAoIW5ld1N0eWxlc1tpZF0pIHtcbiAgICAgIHN0eWxlcy5wdXNoKG5ld1N0eWxlc1tpZF0gPSB7IGlkOiBpZCwgcGFydHM6IFtwYXJ0XSB9KVxuICAgIH0gZWxzZSB7XG4gICAgICBuZXdTdHlsZXNbaWRdLnBhcnRzLnB1c2gocGFydClcbiAgICB9XG4gIH1cbiAgcmV0dXJuIHN0eWxlc1xufVxuXG5cblxuLy8vLy8vLy8vLy8vLy8vLy8vXG4vLyBXRUJQQUNLIEZPT1RFUlxuLy8gLi9+L3Z1ZS1zdHlsZS1sb2FkZXIvbGliL2xpc3RUb1N0eWxlcy5qc1xuLy8gbW9kdWxlIGlkID0gMTBcbi8vIG1vZHVsZSBjaHVua3MgPSAwIl0sInNvdXJjZVJvb3QiOiIifQ==\n//# sourceURL=webpack-internal:///10\n");

/***/ })
/******/ ]);

/***/ }),
/* 1249 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./~/vue-cookie/src/vue-cookie.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

(function () {
    Number.isInteger = Number.isInteger || function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    };
    var Cookie = __webpack_require__(/*! tiny-cookie */ 1152);

    var VueCookie = {

        install: function (Vue) {
            Vue.prototype.$cookie = this;
            Vue.cookie = this;
        },
        set: function (name, value, daysOrOptions) {
            var opts = daysOrOptions;
            if(Number.isInteger(daysOrOptions)) {
                opts = {expires: daysOrOptions};
            }
            return Cookie.set(name, value, opts);
        },

        get: function (name) {
            return Cookie.get(name);
        },

        delete: function (name, options) {
            var opts = {expires: -1};
            if(options !== undefined) {
                opts = Object.assign(options, opts);
            }
            this.set(name, '', opts);
        }
    };

    if (true) {
        module.exports = VueCookie;
    } else if (typeof define == "function" && define.amd) {
        define([], function(){ return VueCookie; })
    } else if (window.Vue) {
        window.VueCookie = VueCookie;
        Vue.use(VueCookie);
    }

})();


/***/ }),
/* 1250 */
/* exports provided: mergeData */
/* exports used: mergeData */
/*!*****************************************************!*\
  !*** ./~/vue-functional-data-merge/dist/lib.esm.js ***!
  \*****************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return a; });
var e=function(){return(e=Object.assign||function(e){for(var t,r=1,s=arguments.length;r<s;r++)for(var a in t=arguments[r])Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e}).apply(this,arguments)},t={kebab:/-(\w)/g,styleProp:/:(.*)/,styleList:/;(?![^(]*\))/g};function r(e,t){return t?t.toUpperCase():""}function s(e){for(var s,a={},c=0,o=e.split(t.styleList);c<o.length;c++){var n=o[c].split(t.styleProp),i=n[0],l=n[1];(i=i.trim())&&("string"==typeof l&&(l=l.trim()),a[(s=i,s.replace(t.kebab,r))]=l)}return a}function a(){for(var t,r,a={},c=arguments.length;c--;)for(var o=0,n=Object.keys(arguments[c]);o<n.length;o++)switch(t=n[o]){case"class":case"style":case"directives":if(Array.isArray(a[t])||(a[t]=[]),"style"===t){var i=void 0;i=Array.isArray(arguments[c].style)?arguments[c].style:[arguments[c].style];for(var l=0;l<i.length;l++){var y=i[l];"string"==typeof y&&(i[l]=s(y))}arguments[c].style=i}a[t]=a[t].concat(arguments[c][t]);break;case"staticClass":if(!arguments[c][t])break;void 0===a[t]&&(a[t]=""),a[t]&&(a[t]+=" "),a[t]+=arguments[c][t].trim();break;case"on":case"nativeOn":a[t]||(a[t]={});for(var p=0,f=Object.keys(arguments[c][t]||{});p<f.length;p++)r=f[p],a[t][r]?a[t][r]=[].concat(a[t][r],arguments[c][t][r]):a[t][r]=arguments[c][t][r];break;case"attrs":case"props":case"domProps":case"scopedSlots":case"staticStyle":case"hook":case"transition":a[t]||(a[t]={}),a[t]=e({},arguments[c][t],a[t]);break;case"slot":case"key":case"ref":case"tag":case"show":case"keepAlive":default:a[t]||(a[t]=arguments[c][t])}return a}
//# sourceMappingURL=lib.esm.js.map


/***/ }),
/* 1251 */
/* exports provided: default */
/* exports used: default */
/*!***************************************!*\
  !*** ./~/vue-highcharts/src/clone.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clone;
// eslint-disable-next-line consistent-return
function clone(obj) {
  var copy;
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  if (obj instanceof Array) {
    copy = [];
    for (var i = obj.length - 1; i >= 0; i--) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }
  /* istanbul ignore else */
  if (obj instanceof Object) {
    copy = {};
    for (var key in obj) {
      copy[key] = clone(obj[key]);
    }
    return copy;
  }
}


/***/ }),
/* 1252 */
/* exports provided: default */
/* exports used: default */
/*!****************************************!*\
  !*** ./~/vue-highcharts/src/create.js ***!
  \****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clone_js__ = __webpack_require__(/*! ./clone.js */ 1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constructors_js__ = __webpack_require__(/*! ./constructors.js */ 687);



function render(createElement) {
  return createElement('div');
}

function create(name, Highcharts) {
  var ctor = Highcharts[__WEBPACK_IMPORTED_MODULE_1__constructors_js__["a" /* default */][name]];
  if (!ctor) {
    return Highcharts.win
      ? null
      // When running in server, Highcharts will not be instanced,
      // so there're no constructors in Highcharts,
      // to avoid unmated content during SSR, it returns minimum component.
      : { render: render };
  }
  return {
    name: name,
    props: {
      options: { type: Object, required: true }
    },
    watch: {
      options: {
        handler: function () {
          this.$_h_render();
        },
        deep: true
      }
    },
    mounted: function () {
      this.$_h_render();
    },
    beforeDestroy: function () {
      this.chart.destroy();
    },
    methods: {
      $_h_render: function () {
        this.chart = ctor(this.$el, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__clone_js__["a" /* default */])(this.options));
      }
    },
    render: render
  };
}


/***/ }),
/* 1253 */
/* exports provided: default, genComponent */
/* all exports used */
/*!***************************************!*\
  !*** ./~/vue-highcharts/src/index.js ***!
  \***************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts__ = __webpack_require__(/*! highcharts */ 280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constructors_js__ = __webpack_require__(/*! ./constructors.js */ 687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_js__ = __webpack_require__(/*! ./create.js */ 1252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "genComponent", function() { return __WEBPACK_IMPORTED_MODULE_2__create_js__["a"]; });




function install(Vue, options) {
  var Highcharts = (options && options.Highcharts) || __WEBPACK_IMPORTED_MODULE_0_highcharts___default.a;
  for (var name in __WEBPACK_IMPORTED_MODULE_1__constructors_js__["a" /* default */]) {
    var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__create_js__["a" /* default */])(name, Highcharts);
    component && Vue.component(name, component);
  }
}

if (typeof window !== 'undefined' && window.Vue && window.Highcharts) {
  install(window.Vue, window.Highcharts);
}




/***/ }),
/* 1254 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./~/vue-js-popover/dist/index.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(/*! vue */ 31)):"function"==typeof define&&define.amd?define(["vue"],t):"object"==typeof exports?exports["vue-js-popover"]=t(require("vue")):e["vue-js-popover"]=t(e.vue)}(window,function(n){return i={},r.m=o=[function(e,t,n){var o=n(3);"string"==typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);(0,n(6).default)("24dd245c",o,!0,{})},function(e,t){e.exports=n},function(e,t,n){"use strict";var o=n(0);n.n(o).a},function(e,t,n){(e.exports=n(4)(!1)).push([e.i,".vue-popover{display:block;position:absolute;background:#fff;box-shadow:0px 4px 20px 0px rgba(52,73,94,0.2);padding:5px;border-radius:5px;z-index:998}.vue-popover:before{display:block;position:absolute;width:0;height:0;content:''}.vue-popover.dropdown-position-bottom:before{border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #fff;top:-6px;left:calc(50% - 6px);filter:drop-shadow(0px -2px 2px rgba(52,73,94,0.1))}.vue-popover.dropdown-position-top:before{border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid #fff;bottom:-6px;left:calc(50% - 6px);filter:drop-shadow(0px 2px 2px rgba(52,73,94,0.1))}.vue-popover.dropdown-position-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;border-left:6px solid #fff;right:-6px;top:calc(50% - 6px);filter:drop-shadow(2px 0px 2px rgba(52,73,94,0.1))}.vue-popover.dropdown-position-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;border-right:6px solid #fff;left:-6px;top:calc(50% - 6px);filter:drop-shadow(-2px 0px 2px rgba(52,73,94,0.1))}\n",""])},function(e,t,n){"use strict";e.exports=function(n){var s=[];return s.toString=function(){return this.map(function(e){var t=function(e,t){var n=e[1]||"",o=e[3];if(!o)return n;if(t&&"function"==typeof btoa){var r=function(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}(o),i=o.sources.map(function(e){return"/*# sourceURL="+o.sourceRoot+e+" */"});return[n].concat(i).concat([r]).join("\n")}return[n].join("\n")}(e,n);return e[2]?"@media "+e[2]+"{"+t+"}":t}).join("")},s.i=function(e,t){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},o=0;o<this.length;o++){var r=this[o][0];null!=r&&(n[r]=!0)}for(o=0;o<e.length;o++){var i=e[o];null!=i[0]&&n[i[0]]||(t&&!i[2]?i[2]=t:t&&(i[2]="("+i[2]+") and ("+t+")"),s.push(i))}},s}},function(e,t,n){"use strict";n.r(t);var o=n(1),r=new(n.n(o).a);function y(e){return function(e){if(Array.isArray(e))return i(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return i(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return i(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function i(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,o=new Array(t);n<t;n++)o[n]=e[n];return o}function s(t,e){var n,o=Object.keys(t);return Object.getOwnPropertySymbols&&(n=Object.getOwnPropertySymbols(t),e&&(n=n.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),o.push.apply(o,n)),o}function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var g={left:[-1,0],right:[1,0],top:[0,1],bottom:[0,-1]},u={name:"Popover",props:{name:{type:String,required:!0},delay:{type:Number,default:0},transition:{type:String},width:{type:Number,default:180},pointer:{type:Boolean,default:!0},event:{type:String,default:"click"},anchor:{type:Number,default:.5,validator:function(e){return 0<=e&&e<=1}}},data:function(){return{visible:!1,zIndex:1,positionClass:"",fixedParents:[],position:{left:0,top:0}}},mounted:function(){r.$on(this.showEventName,this.showEventListener),r.$on(this.hideEventName,this.hideEventListener)},beforeDestroy:function(){r.$off(this.showEventName,this.showEventListener),r.$off(this.hideEventName,this.hideEventListener)},computed:{showEventName:function(){return"show:".concat(this.event)},hideEventName:function(){return"hide:".concat(this.event)},className:function(){return["vue-popover",this.pointer&&this.positionClass]},style:function(){var e=this.width,t=this.zIndex,n=0<this.fixedParents.length,o=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?s(Object(n),!0).forEach(function(e){a(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}({width:"".concat(e,"px"),zIndex:t},this.position);return n&&(o.position="fixed"),o}},methods:{showEventListener:function(t){var e,n,o=this;this.visible?r.$emit(this.hideEventName):(e=t.name,n=t.position,e===this.name&&(this.timeout=setTimeout(function(){o.positionClass="dropdown-position-".concat(n),o.visible=!0,o.$nextTick(function(){o.$emit("show",t),o.$nextTick(function(){var e=o.getDropdownPosition(t);o.position={left:"".concat(e.left,"px"),top:"".concat(e.top,"px")}})})},Math.max(this.delay,0))))},hideEventListener:function(e){this.timeout&&clearTimeout(this.timeout),this.visible&&(this.visible=!1,this.$emit("hide",e))},getDropdownPosition:function(e){var t,n=e.target,o=e.position,r=g[o],i=this.$refs.dropdown,s=n.getBoundingClientRect(),a=i.getBoundingClientRect();this.fixedParents=(t=[],function(e,t){for(var n=e;t&&n.parentNode&&"BODY"!==n.parentNode.tagName;)t(n),n=n.parentNode}(n,function(e){"fixed"===window.getComputedStyle(e).position&&t.push(e)}),t);var u=e.zIndex?e.zIndex:function(e){return(0<arguments.length&&void 0!==e?e:[]).reduce(function(e,t){var n=parseInt(getComputedStyle(t)["z-index"])||1;return Math.max(e,n)},1)}([n].concat(y(this.fixedParents)))+1;this.zIndex=u;var p,c,d=s.left,l=s.top;0===this.fixedParents.length&&(p=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop,c=window.pageXOffset||document.documentElement.scrollLeft||document.body.scrollLeft,d=s.left+c,l=s.top+p);var f=.5*(a.height+s.height),v=d-.5*(a.width-s.width),h=l+s.height-f,m=.5*r[0]*(a.width+s.width),b=r[1]*f;return this.pointer&&(m+=6*r[0],b+=6*r[1]),{left:Math.round(v+m),top:Math.round(h-b)}}}};n(2);function p(e,t,n,o,r,i,s,a){var u,p,c,d="function"==typeof e?e.options:e;return t&&(d.render=t,d.staticRenderFns=n,d._compiled=!0),o&&(d.functional=!0),i&&(d._scopeId="data-v-"+i),s?(u=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(s)},d._ssrRegister=u):r&&(u=a?function(){r.call(this,(d.functional?this.parent:this).$root.$options.shadowRoot)}:r),u&&(d.functional?(d._injectStyles=u,p=d.render,d.render=function(e,t){return u.call(t),p(e,t)}):(c=d.beforeCreate,d.beforeCreate=c?[].concat(c,u):[u])),{exports:e,options:d}}var c=p(u,function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("transition",{attrs:{name:e.transition}},[e.visible?n("div",{ref:"dropdown",class:e.className,style:e.style,attrs:{"data-popover":this.name},on:{click:function(e){e.stopPropagation()}}},[e._t("default")],2):e._e()])},[],!1,null,null,null).exports,d=p({name:"Tooltip",props:{event:{type:String,default:"hover"},pointer:{type:Boolean,default:!1},width:{type:Number,default:160}},data:function(){return{value:""}}},function(){var t=this,e=t.$createElement;return(t._self._c||e)("popover",{attrs:{name:"tooltip",pointer:t.pointer,width:t.width,event:t.event},on:{show:function(e){t.value=e.value}}},[t._v("\n  "+t._s(t.value)+"\n")])},[],!1,null,null,null).exports;function l(t,e){var n,o=Object.keys(t);return Object.getOwnPropertySymbols&&(n=Object.getOwnPropertySymbols(t),e&&(n=n.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),o.push.apply(o,n)),o}function f(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?l(Object(n),!0).forEach(function(e){v(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}function v(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function h(e){return(h="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function m(e){var t,n=e.arg,o=void 0===n?"":n,r=e.modifiers,i=void 0===r?{}:r,s=e.value,a=void 0===s?{}:s,u=Object.keys(i);return{name:"object"===h(a)&&a.name?a.name:o,position:(t=u,(Array.isArray(t)&&0<t.length?t[0]:null)||a.position||"bottom"),value:a}}function b(n,o){function e(e){r.$emit("show:click",f(f({},o),{},{target:n,srcEvent:e})),document.addEventListener("click",function e(t){r.$emit("hide:click",f(f({},o),{},{target:n,srcEvent:t})),document.removeEventListener("click",e)}),e.stopPropagation()}n.addEventListener("click",e),n.$popoverRemoveClickHandlers=function(){n.removeEventListener("click",e)}}function x(t,n){function e(e){r.$emit("show:hover",f(f({},n),{},{target:t,srcEvent:e}))}function o(e){r.$emit("hide:hover",f(f({},n),{},{target:t,srcEvent:e}))}t.addEventListener("mouseenter",e),t.addEventListener("mouseleave",o),t.$popoverRemoveHoverHandlers=function(){t.removeEventListener("mouseenter",e),t.removeEventListener("mouseleave",o)}}t.default={install:function(e,t){var n=1<arguments.length&&void 0!==t?t:{};document.addEventListener("resize",function(e){r.$emit("hide",{srcEvent:e})}),e.component("Popover",c),e.directive("popover",{bind:function(e,t){var n=m(t);b(e,n),x(e,n)},unbind:function(e){e.$popoverRemoveHoverHandlers(),e.$popoverRemoveClickHandlers()}}),n.tooltip&&e.component("Tooltip",d)}}},function(e,t,n){"use strict";function u(e,t){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],s=i[0],a={id:e+":"+r,css:i[1],media:i[2],sourceMap:i[3]};o[s]?o[s].parts.push(a):n.push(o[s]={id:s,parts:[a]})}return n}n.r(t),n.d(t,"default",function(){return v});var o="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!o)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var p={},r=o&&(document.head||document.getElementsByTagName("head")[0]),i=null,s=0,c=!1,a=function(){},d=null,l="data-vue-ssr-id",f="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function v(s,e,t,n){c=t,d=n||{};var a=u(s,e);return h(a),function(e){for(var t=[],n=0;n<a.length;n++){var o=a[n];(r=p[o.id]).refs--,t.push(r)}e?h(a=u(s,e)):a=[];for(var r,n=0;n<t.length;n++){if(0===(r=t[n]).refs){for(var i=0;i<r.parts.length;i++)r.parts[i]();delete p[r.id]}}}}function h(e){for(var t=0;t<e.length;t++){var n=e[t],o=p[n.id];if(o){o.refs++;for(var r=0;r<o.parts.length;r++)o.parts[r](n.parts[r]);for(;r<n.parts.length;r++)o.parts.push(b(n.parts[r]));o.parts.length>n.parts.length&&(o.parts.length=n.parts.length)}else{for(var i=[],r=0;r<n.parts.length;r++)i.push(b(n.parts[r]));p[n.id]={id:n.id,refs:1,parts:i}}}}function m(){var e=document.createElement("style");return e.type="text/css",r.appendChild(e),e}function b(t){var e,n,o,r=document.querySelector("style["+l+'~="'+t.id+'"]');if(r){if(c)return a;r.parentNode.removeChild(r)}return o=f?(e=s++,r=i=i||m(),n=x.bind(null,r,e,!1),x.bind(null,r,e,!0)):(r=m(),n=function(e,t){var n=t.css,o=t.media,r=t.sourceMap;o&&e.setAttribute("media",o);d.ssrId&&e.setAttribute(l,t.id);r&&(n+="\n/*# sourceURL="+r.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");if(e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}.bind(null,r),function(){r.parentNode.removeChild(r)}),n(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;n(t=e)}else o()}}var y,g=(y=[],function(e,t){return y[e]=t,y.filter(Boolean).join("\n")});function x(e,t,n,o){var r,i,s=n?"":o.css;e.styleSheet?e.styleSheet.cssText=g(t,s):(r=document.createTextNode(s),(i=e.childNodes)[t]&&e.removeChild(i[t]),i.length?e.insertBefore(r,i[t]):e.appendChild(r))}}],r.c=i,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="/dist/",r(r.s=5);function r(e){if(i[e])return i[e].exports;var t=i[e]={i:e,l:!1,exports:{}};return o[e].call(t.exports,t,t.exports,r),t.l=!0,t.exports}var o,i});
//# sourceMappingURL=index.js.map

/***/ }),
/* 1255 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./client/components/administration/auditLog/AuditModal.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-265147fb","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./AuditModal.vue */ 1491)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./AuditModal.vue */ 796),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-265147fb"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./auditModal.pug */ 1382),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/administration/auditLog/AuditModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AuditModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-265147fb", Component.options)
  } else {
    hotAPI.reload("data-v-265147fb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1256 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./client/components/buttons/buttonApplication/ButtonApplication.vue ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-081ec6ca","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./ButtonApplication.vue */ 1476)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ButtonApplication.vue */ 797),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-081ec6ca"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./buttonApplication.pug */ 1361),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/buttons/buttonApplication/ButtonApplication.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ButtonApplication.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-081ec6ca", Component.options)
  } else {
    hotAPI.reload("data-v-081ec6ca", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1257 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./client/components/buttons/buttonPrint/ButtonPrint.vue ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2b0b37d6","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./ButtonPrint.vue */ 1495)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ButtonPrint.vue */ 799),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2b0b37d6"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./buttonPrint.pug */ 1386),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/buttons/buttonPrint/ButtonPrint.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ButtonPrint.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b0b37d6", Component.options)
  } else {
    hotAPI.reload("data-v-2b0b37d6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1258 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./client/components/buttons/buttonSearch/ButtonSearch.vue ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2e8324c6","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./ButtonSearch.vue */ 1499)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ButtonSearch.vue */ 800),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2e8324c6"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./buttonSearch.pug */ 1392),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/buttons/buttonSearch/ButtonSearch.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ButtonSearch.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2e8324c6", Component.options)
  } else {
    hotAPI.reload("data-v-2e8324c6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1259 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./client/components/buttons/toogle/Toogle.vue ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-db7bdbc6","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Toogle.vue */ 1554)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Toogle.vue */ 801),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-db7bdbc6"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./toogle.pug */ 1460),
  /* scopeId */
  "data-v-db7bdbc6",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/buttons/toogle/Toogle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Toogle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db7bdbc6", Component.options)
  } else {
    hotAPI.reload("data-v-db7bdbc6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1260 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./client/components/calendarView/CalendarView.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-09c1836a","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarView.vue */ 1477)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarView.vue */ 802),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-09c1836a"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./calendarView.pug */ 1362),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/calendarView/CalendarView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CalendarView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09c1836a", Component.options)
  } else {
    hotAPI.reload("data-v-09c1836a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1261 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./client/components/dashboard/Dashboard.vue ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-style-loader!css-loader!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-632aab56","scoped":false,"hasInlineConfig":false}!sass-loader!../../../~/vue-loader/lib/selector?type=styles&index=0!./Dashboard.vue */ 1580)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./Dashboard.vue */ 803),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-632aab56"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./dashboard.pug */ 1421),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/Dashboard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Dashboard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-632aab56", Component.options)
  } else {
    hotAPI.reload("data-v-632aab56", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1262 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./client/components/dashboard/chart/Chart.vue ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-style-loader!css-loader!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-40c8036e","scoped":false,"hasInlineConfig":false}!sass-loader!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Chart.vue */ 1578)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Chart.vue */ 804),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-40c8036e"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./chart.pug */ 1402),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/chart/Chart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Chart.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40c8036e", Component.options)
  } else {
    hotAPI.reload("data-v-40c8036e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1263 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************!*\
  !*** ./client/components/dashboard/chartFilter/AllotmentDistributionConciliation.vue ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./AllotmentDistributionConciliation.vue */ 805),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2d3a6a80"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./AllotmentDistributionConciliation.vue */ 1389),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/chartFilter/AllotmentDistributionConciliation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AllotmentDistributionConciliation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d3a6a80", Component.options)
  } else {
    hotAPI.reload("data-v-2d3a6a80", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1264 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./client/components/dashboard/chartFilter/ConciliationSituationSummary.vue ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ConciliationSituationSummary.vue */ 806),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-124f2540"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./ConciliationSituationSummary.vue */ 1369),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/chartFilter/ConciliationSituationSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConciliationSituationSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-124f2540", Component.options)
  } else {
    hotAPI.reload("data-v-124f2540", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1265 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./client/components/dashboard/chartFilter/DailyBankStatment.vue ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./DailyBankStatment.vue */ 807),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-57b95c2f"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./DailyBankStatment.vue */ 1415),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/chartFilter/DailyBankStatment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DailyBankStatment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-57b95c2f", Component.options)
  } else {
    hotAPI.reload("data-v-57b95c2f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1266 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./client/components/dashboard/chartFilter/DigitalWalletBalance.vue ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./DigitalWalletBalance.vue */ 808),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-46f2f433"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./DigitalWalletBalance.vue */ 1409),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/chartFilter/DigitalWalletBalance.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DigitalWalletBalance.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46f2f433", Component.options)
  } else {
    hotAPI.reload("data-v-46f2f433", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1267 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/components/dashboard/chartFilter/FinancialSummary.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./FinancialSummary.vue */ 809),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-737e48a5"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./FinancialSummary.vue */ 1435),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/chartFilter/FinancialSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FinancialSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-737e48a5", Component.options)
  } else {
    hotAPI.reload("data-v-737e48a5", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1268 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./client/components/dashboard/filter/FilterCommon.vue ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-65f48b0a","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./FilterCommon.vue */ 1525)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./FilterCommon.vue */ 810),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-65f48b0a"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./filterCommon.pug */ 1426),
  /* scopeId */
  "data-v-65f48b0a",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/filter/FilterCommon.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FilterCommon.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65f48b0a", Component.options)
  } else {
    hotAPI.reload("data-v-65f48b0a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1269 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./client/components/dashboard/gadget/TaskGadget.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-30421256","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TaskGadget.vue */ 1500)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TaskGadget.vue */ 812),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-30421256"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./taskGadget.pug */ 1393),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/gadget/TaskGadget.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TaskGadget.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30421256", Component.options)
  } else {
    hotAPI.reload("data-v-30421256", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1270 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./client/components/dashboard/gadget/TaskGadgetTabContent.vue ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-style-loader!css-loader!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-7b55184e","scoped":false,"hasInlineConfig":false}!sass-loader!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TaskGadgetTabContent.vue */ 1581)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TaskGadgetTabContent.vue */ 813),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7b55184e"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./taskGadgetTabContent.pug */ 1444),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/dashboard/gadget/TaskGadgetTabContent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TaskGadgetTabContent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b55184e", Component.options)
  } else {
    hotAPI.reload("data-v-7b55184e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1271 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./client/components/input/dynamicInput/DynamicInput.vue ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-15fd6674","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./DynamicInput.vue */ 1484)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./DynamicInput.vue */ 817),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-15fd6674"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./dynamicInput.pug */ 1373),
  /* scopeId */
  "data-v-15fd6674",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/input/dynamicInput/DynamicInput.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DynamicInput.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-15fd6674", Component.options)
  } else {
    hotAPI.reload("data-v-15fd6674", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1272 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************!*\
  !*** ./client/components/integration/remittanceIntegration/RemittanceIntegrationCreationModal.vue ***!
  \****************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-b0335380","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./RemittanceIntegrationCreationModal.vue */ 1547)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./RemittanceIntegrationCreationModal.vue */ 819),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-b0335380"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./remittanceIntegrationCreationModal.pug */ 1452),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/integration/remittanceIntegration/RemittanceIntegrationCreationModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RemittanceIntegrationCreationModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b0335380", Component.options)
  } else {
    hotAPI.reload("data-v-b0335380", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1273 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************!*\
  !*** ./client/components/integration/remittanceIntegration/RemittanceIntegrationModal.vue ***!
  \********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-5e2ad742","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./RemittanceIntegrationModal.vue */ 1518)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./RemittanceIntegrationModal.vue */ 820),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5e2ad742"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./remittanceIntegrationModal.pug */ 1418),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/integration/remittanceIntegration/RemittanceIntegrationModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RemittanceIntegrationModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5e2ad742", Component.options)
  } else {
    hotAPI.reload("data-v-5e2ad742", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1274 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./client/components/integration/remittanceIntegration/TabRemittanceDetail.vue ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-17392d8c","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabRemittanceDetail.vue */ 1486)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TabRemittanceDetail.vue */ 821),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-17392d8c"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabRemittanceDetail.pug */ 1375),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/integration/remittanceIntegration/TabRemittanceDetail.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabRemittanceDetail.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17392d8c", Component.options)
  } else {
    hotAPI.reload("data-v-17392d8c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1275 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./client/components/integration/remittanceIntegration/TabRemittanceReport.vue ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-6fc77e22","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabRemittanceReport.vue */ 1530)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TabRemittanceReport.vue */ 822),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6fc77e22"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabRemittanceReport.pug */ 1432),
  /* scopeId */
  "data-v-6fc77e22",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/integration/remittanceIntegration/TabRemittanceReport.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabRemittanceReport.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6fc77e22", Component.options)
  } else {
    hotAPI.reload("data-v-6fc77e22", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1276 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./client/components/layout/headerBar/HeaderBar.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0d6d05cc","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./HeaderBar.vue */ 1480)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./HeaderBar.vue */ 824),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0d6d05cc"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./headerBar.pug */ 1365),
  /* scopeId */
  "data-v-0d6d05cc",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/layout/headerBar/HeaderBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HeaderBar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d6d05cc", Component.options)
  } else {
    hotAPI.reload("data-v-0d6d05cc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1277 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/components/layout/menu/SidebarMenu.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-style-loader!css-loader!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1b8ade6c","scoped":false,"hasInlineConfig":false}!sass-loader!../../../../~/vue-loader/lib/selector?type=styles&index=0!./SidebarMenu.vue */ 1577)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./SidebarMenu.vue */ 825),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1b8ade6c"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./sidebarMenu.pug */ 1377),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/layout/menu/SidebarMenu.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SidebarMenu.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b8ade6c", Component.options)
  } else {
    hotAPI.reload("data-v-1b8ade6c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1278 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./client/components/layout/menu/SuspendedMenu.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-07ceb7ab","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./SuspendedMenu.vue */ 1475)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./SuspendedMenu.vue */ 826),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-07ceb7ab"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./suspendedMenu.pug */ 1360),
  /* scopeId */
  "data-v-07ceb7ab",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/layout/menu/SuspendedMenu.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SuspendedMenu.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07ceb7ab", Component.options)
  } else {
    hotAPI.reload("data-v-07ceb7ab", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1279 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./client/components/layout/menu/TopBar.vue ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-style-loader!css-loader!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-54cd97fd","scoped":false,"hasInlineConfig":false}!sass-loader!../../../../~/vue-loader/lib/selector?type=styles&index=0!./TopBar.vue */ 1579)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TopBar.vue */ 827),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-54cd97fd"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./topBar.pug */ 1414),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/layout/menu/TopBar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TopBar.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-54cd97fd", Component.options)
  } else {
    hotAPI.reload("data-v-54cd97fd", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1280 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/components/loading/LoadingFullPage.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-fd19de7a","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./LoadingFullPage.vue */ 1564)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./LoadingFullPage.vue */ 829),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-fd19de7a"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../~/vue-loader/lib/selector?type=template&index=0!./LoadingFullPage.vue */ 1472),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/loading/LoadingFullPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoadingFullPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fd19de7a", Component.options)
  } else {
    hotAPI.reload("data-v-fd19de7a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1281 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./client/components/modals/changeApplicationModal/ChangeApplicationModal.vue ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-72f81e1a","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./ChangeApplicationModal.vue */ 1532)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ChangeApplicationModal.vue */ 832),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-72f81e1a"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./changeApplicationModal.pug */ 1434),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/changeApplicationModal/ChangeApplicationModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChangeApplicationModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72f81e1a", Component.options)
  } else {
    hotAPI.reload("data-v-72f81e1a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1282 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./client/components/modals/clientModal/ClientModal.vue ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0049b780","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./ClientModal.vue */ 1473)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./ClientModal.vue */ 833),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0049b780"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./clientModal.pug */ 1356),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/clientModal/ClientModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ClientModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0049b780", Component.options)
  } else {
    hotAPI.reload("data-v-0049b780", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1283 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************!*\
  !*** ./client/components/modals/gridDetailsModal/tabClassification/TabClassification.vue ***!
  \*******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-63472d8e","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabClassification.vue */ 1522)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./TabClassification.vue */ 837),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-63472d8e"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabClassification.pug */ 1423),
  /* scopeId */
  "data-v-63472d8e",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/gridDetailsModal/tabClassification/TabClassification.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabClassification.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-63472d8e", Component.options)
  } else {
    hotAPI.reload("data-v-63472d8e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1284 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************!*\
  !*** ./client/components/modals/gridDetailsModal/tabDetails/TabDetails.vue ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0affa294","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabDetails.vue */ 1479)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./TabDetails.vue */ 838),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0affa294"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabDetails.pug */ 1364),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/gridDetailsModal/tabDetails/TabDetails.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabDetails.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0affa294", Component.options)
  } else {
    hotAPI.reload("data-v-0affa294", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1285 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************!*\
  !*** ./client/components/modals/gridDetailsModal/tabHistoric/TabHistoric.vue ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-66125f00","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabHistoric.vue */ 1526)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./TabHistoric.vue */ 839),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-66125f00"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabHistoric.pug */ 1427),
  /* scopeId */
  "data-v-66125f00",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/gridDetailsModal/tabHistoric/TabHistoric.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabHistoric.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-66125f00", Component.options)
  } else {
    hotAPI.reload("data-v-66125f00", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1286 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************!*\
  !*** ./client/components/modals/gridDetailsModal/tabIntegrations/TabIntegrations.vue ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-37139c00","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabIntegrations.vue */ 1504)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./TabIntegrations.vue */ 840),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-37139c00"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabIntegrations.pug */ 1398),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/gridDetailsModal/tabIntegrations/TabIntegrations.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabIntegrations.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37139c00", Component.options)
  } else {
    hotAPI.reload("data-v-37139c00", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1287 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./client/components/modals/gridDetailsModal/tabTasks/TabTasks.vue ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1d6ea436","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./TabTasks.vue */ 1488)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./TabTasks.vue */ 841),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1d6ea436"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./tabTasks.pug */ 1378),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/gridDetailsModal/tabTasks/TabTasks.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TabTasks.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d6ea436", Component.options)
  } else {
    hotAPI.reload("data-v-1d6ea436", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1288 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./client/components/modals/massDeclassifyModal/MassDeclassifyModal.vue ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2a9b0864","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./MassDeclassifyModal.vue */ 1494)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MassDeclassifyModal.vue */ 842),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2a9b0864"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./massDeclassifyModal.pug */ 1384),
  /* scopeId */
  "data-v-2a9b0864",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/massDeclassifyModal/MassDeclassifyModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MassDeclassifyModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a9b0864", Component.options)
  } else {
    hotAPI.reload("data-v-2a9b0864", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1289 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./client/components/modals/massTaskModal/MassTaskModal.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-33983fa4","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./MassTaskModal.vue */ 1501)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MassTaskModal.vue */ 843),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-33983fa4"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./massTaskModal.pug */ 1395),
  /* scopeId */
  "data-v-33983fa4",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/massTaskModal/MassTaskModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MassTaskModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33983fa4", Component.options)
  } else {
    hotAPI.reload("data-v-33983fa4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1290 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./client/components/modals/myAccountModal/MyAccountModal.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-74c6103a","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./MyAccountModal.vue */ 1535)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MyAccountModal.vue */ 846),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-74c6103a"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./myAccountModal.pug */ 1438),
  /* scopeId */
  "data-v-74c6103a",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/modals/myAccountModal/MyAccountModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MyAccountModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74c6103a", Component.options)
  } else {
    hotAPI.reload("data-v-74c6103a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1291 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./client/components/notification/Notification.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-248a974b","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./Notification.vue */ 1490)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./Notification.vue */ 847),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-248a974b"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../~/vue-loader/lib/selector?type=template&index=0!./Notification.vue */ 1381),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/notification/Notification.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Notification.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-248a974b", Component.options)
  } else {
    hotAPI.reload("data-v-248a974b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1292 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./client/components/registration/attributesSet/Attribute.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0a21cc36","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Attribute.vue */ 1478)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Attribute.vue */ 848),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0a21cc36"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./attribute.pug */ 1363),
  /* scopeId */
  "data-v-0a21cc36",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/attributesSet/Attribute.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Attribute.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0a21cc36", Component.options)
  } else {
    hotAPI.reload("data-v-0a21cc36", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1293 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./client/components/registration/attributesSet/NewAtributeModal.vue ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-ddae9a96","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./NewAtributeModal.vue */ 1556)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./NewAtributeModal.vue */ 849),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-ddae9a96"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./newAtributeModal.pug */ 1462),
  /* scopeId */
  "data-v-ddae9a96",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/attributesSet/NewAtributeModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NewAtributeModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ddae9a96", Component.options)
  } else {
    hotAPI.reload("data-v-ddae9a96", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1294 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/components/registration/categories/CategorieModal.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-d0189532","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./CategorieModal.vue */ 1553)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./CategorieModal.vue */ 851),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-d0189532"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./categorieModal.pug */ 1459),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/categories/CategorieModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CategorieModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0189532", Component.options)
  } else {
    hotAPI.reload("data-v-d0189532", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1295 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** ./client/components/registration/conciliationPlan/classificationCriteria/ClassificationCriteria.vue ***!
  \***********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-7fa5a10b","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./ClassificationCriteria.vue */ 1541)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ClassificationCriteria.vue */ 854),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7fa5a10b"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./classificationCriteria.pug */ 1447),
  /* scopeId */
  "data-v-7fa5a10b",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/conciliationPlan/classificationCriteria/ClassificationCriteria.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ClassificationCriteria.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7fa5a10b", Component.options)
  } else {
    hotAPI.reload("data-v-7fa5a10b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1296 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************!*\
  !*** ./client/components/registration/conciliationPlan/classificationCriteria/ConciliationField.vue ***!
  \******************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ConciliationField.vue */ 855),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-cb1d6a18"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./conciliationField.pug */ 1458),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/conciliationPlan/classificationCriteria/ConciliationField.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConciliationField.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cb1d6a18", Component.options)
  } else {
    hotAPI.reload("data-v-cb1d6a18", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1297 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************!*\
  !*** ./client/components/registration/conciliationPlan/classificationCriteria/NewClassificationCriteria.vue ***!
  \**************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-72a54622","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./NewClassificationCriteria.vue */ 1531)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./NewClassificationCriteria.vue */ 856),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-72a54622"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./newClassificationCriteria.pug */ 1433),
  /* scopeId */
  "data-v-72a54622",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/conciliationPlan/classificationCriteria/NewClassificationCriteria.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NewClassificationCriteria.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72a54622", Component.options)
  } else {
    hotAPI.reload("data-v-72a54622", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1298 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************!*\
  !*** ./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCritFields.vue ***!
  \*********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4ab25a9f","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./ConciliationCritFields.vue */ 1512)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ConciliationCritFields.vue */ 857),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4ab25a9f"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./conciliationCritFields.pug */ 1411),
  /* scopeId */
  "data-v-4ab25a9f",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCritFields.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConciliationCritFields.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ab25a9f", Component.options)
  } else {
    hotAPI.reload("data-v-4ab25a9f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1299 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCriteria.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1a206fcb","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./ConciliationCriteria.vue */ 1487)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ConciliationCriteria.vue */ 858),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1a206fcb"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./conciliationCriteria.pug */ 1376),
  /* scopeId */
  "data-v-1a206fcb",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCriteria.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConciliationCriteria.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a206fcb", Component.options)
  } else {
    hotAPI.reload("data-v-1a206fcb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1300 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************!*\
  !*** ./client/components/registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria.vue ***!
  \**********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2b0e21fa","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./NewConciliationCriteria.vue */ 1496)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./NewConciliationCriteria.vue */ 859),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2b0e21fa"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./newConciliationCriteria.pug */ 1387),
  /* scopeId */
  "data-v-2b0e21fa",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NewConciliationCriteria.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b0e21fa", Component.options)
  } else {
    hotAPI.reload("data-v-2b0e21fa", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1301 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./client/components/registration/establishments/MoveEstablishmentModal.vue ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./MoveEstablishmentModal.vue */ 860),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-e1db8ad0"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./moveEstablishmentModal.pug */ 1463),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/registration/establishments/MoveEstablishmentModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MoveEstablishmentModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e1db8ad0", Component.options)
  } else {
    hotAPI.reload("data-v-e1db8ad0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1302 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************!*\
  !*** ./client/components/reports/conciliationSummary/CalendarDetailBox.vue ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-a0986062","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarDetailBox.vue */ 1545)
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-a0986062","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=1!./CalendarDetailBox.vue */ 1546)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarDetailBox.vue */ 861),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-a0986062"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./calendarDetailBox.pug */ 1451),
  /* scopeId */
  "data-v-a0986062",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/conciliationSummary/CalendarDetailBox.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CalendarDetailBox.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a0986062", Component.options)
  } else {
    hotAPI.reload("data-v-a0986062", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1303 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./client/components/reports/conciliationSummary/CalendarSummary.vue ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-58825cfb","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./CalendarSummary.vue */ 1516)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./CalendarSummary.vue */ 862),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-58825cfb"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./calendarSummary.pug */ 1416),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/conciliationSummary/CalendarSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CalendarSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58825cfb", Component.options)
  } else {
    hotAPI.reload("data-v-58825cfb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1304 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./client/components/reports/duplicateMovementsAnalysis/AnnulledMovements.vue ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./AnnulledMovements.vue */ 863),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2be5b59b"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./annulledMovements.pug */ 1388),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/duplicateMovementsAnalysis/AnnulledMovements.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AnnulledMovements.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2be5b59b", Component.options)
  } else {
    hotAPI.reload("data-v-2be5b59b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1305 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./client/components/reports/duplicateMovementsAnalysis/DuplicateMovements.vue ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./DuplicateMovements.vue */ 864),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1238adbf"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./duplicateMovements.pug */ 1368),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/duplicateMovementsAnalysis/DuplicateMovements.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DuplicateMovements.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1238adbf", Component.options)
  } else {
    hotAPI.reload("data-v-1238adbf", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1306 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./client/components/reports/manualConciliation/Allotment.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0e4ca9a2","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Allotment.vue */ 1481)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Allotment.vue */ 865),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0e4ca9a2"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./allotment.pug */ 1366),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/Allotment.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Allotment.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0e4ca9a2", Component.options)
  } else {
    hotAPI.reload("data-v-0e4ca9a2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1307 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./client/components/reports/manualConciliation/EntryManager.vue ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-885acbc0","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./EntryManager.vue */ 1542)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./EntryManager.vue */ 866),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-885acbc0"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./entryManager.pug */ 1448),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/EntryManager.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EntryManager.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-885acbc0", Component.options)
  } else {
    hotAPI.reload("data-v-885acbc0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1308 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./client/components/reports/manualConciliation/Justifications.vue ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2dcfce74","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Justifications.vue */ 1497)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Justifications.vue */ 867),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2dcfce74"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./justifications.pug */ 1390),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/Justifications.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Justifications.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2dcfce74", Component.options)
  } else {
    hotAPI.reload("data-v-2dcfce74", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1309 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************!*\
  !*** ./client/components/reports/manualConciliation/PendingConciliations.vue ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-61521a9e","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./PendingConciliations.vue */ 1520)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./PendingConciliations.vue */ 868),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-61521a9e"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./pendingConciliations.pug */ 1420),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/PendingConciliations.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PendingConciliations.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61521a9e", Component.options)
  } else {
    hotAPI.reload("data-v-61521a9e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1310 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./client/components/reports/manualConciliation/SelectedEntries.vue ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-7947ef80","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./SelectedEntries.vue */ 1538)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./SelectedEntries.vue */ 869),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7947ef80"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./selectedEntries.pug */ 1442),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/SelectedEntries.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SelectedEntries.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7947ef80", Component.options)
  } else {
    hotAPI.reload("data-v-7947ef80", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1311 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./client/components/reports/manualConciliation/modals/ApplyModal.vue ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-ec141a1a","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./ApplyModal.vue */ 1561)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ApplyModal.vue */ 870),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-ec141a1a"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./applyModal.pug */ 1469),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/modals/ApplyModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ApplyModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ec141a1a", Component.options)
  } else {
    hotAPI.reload("data-v-ec141a1a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1312 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./client/components/reports/manualConciliation/modals/JustifyModal.vue ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-52cce311","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./JustifyModal.vue */ 1515)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./JustifyModal.vue */ 871),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-52cce311"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./justifyModal.pug */ 1413),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/modals/JustifyModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] JustifyModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52cce311", Component.options)
  } else {
    hotAPI.reload("data-v-52cce311", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1313 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************!*\
  !*** ./client/components/reports/manualConciliation/modals/ReopenAllotmentModal.vue ***!
  \**************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ReopenAllotmentModal.vue */ 872),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-40d3dc5a"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./reopenAllotmentModal.pug */ 1403),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/reports/manualConciliation/modals/ReopenAllotmentModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ReopenAllotmentModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40d3dc5a", Component.options)
  } else {
    hotAPI.reload("data-v-40d3dc5a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1314 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./client/components/step/StepProgress.vue ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-style-loader!css-loader!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-c5e6e690","scoped":true,"hasInlineConfig":false}!sass-loader?indentedSyntax!../../../~/vue-loader/lib/selector?type=styles&index=0!./StepProgress.vue */ 1582)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./StepProgress.vue */ 873),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-c5e6e690"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./stepProgress.pug */ 1456),
  /* scopeId */
  "data-v-c5e6e690",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/step/StepProgress.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] StepProgress.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c5e6e690", Component.options)
  } else {
    hotAPI.reload("data-v-c5e6e690", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1315 */
/* no static exports found */
/* all exports used */
/*!*****************************************!*\
  !*** ./client/components/views/App.vue ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-103c15fc","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 1482)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./App.vue */ 876),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-103c15fc"}!../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 1367),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-103c15fc", Component.options)
  } else {
    hotAPI.reload("data-v-103c15fc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1316 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./client/components/views/administration/accessProfile/List.vue ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 877),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7a1a5a18"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1443),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/administration/accessProfile/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a1a5a18", Component.options)
  } else {
    hotAPI.reload("data-v-7a1a5a18", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1317 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/components/views/administration/accessProfile/New.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-0643cdba","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./New.vue */ 1474)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./New.vue */ 878),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0643cdba"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./new.pug */ 1359),
  /* scopeId */
  "data-v-0643cdba",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/administration/accessProfile/New.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] New.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0643cdba", Component.options)
  } else {
    hotAPI.reload("data-v-0643cdba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1318 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./client/components/views/administration/assignment/List.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-6021cb38","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./List.vue */ 1519)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 879),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6021cb38"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1419),
  /* scopeId */
  "data-v-6021cb38",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/administration/assignment/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6021cb38", Component.options)
  } else {
    hotAPI.reload("data-v-6021cb38", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1319 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/components/views/administration/auditLog/AuditLog.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-3b9486da","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./AuditLog.vue */ 1505)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./AuditLog.vue */ 880),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3b9486da"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./auditLog.pug */ 1401),
  /* scopeId */
  "data-v-3b9486da",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/administration/auditLog/AuditLog.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AuditLog.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3b9486da", Component.options)
  } else {
    hotAPI.reload("data-v-3b9486da", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1320 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./client/components/views/administration/operator/List.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-35506d6d","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./List.vue */ 1503)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 881),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-35506d6d"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1397),
  /* scopeId */
  "data-v-35506d6d",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/administration/operator/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35506d6d", Component.options)
  } else {
    hotAPI.reload("data-v-35506d6d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1321 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./client/components/views/administration/operator/New.vue ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./New.vue */ 882),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2afc8021"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./new.pug */ 1385),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/administration/operator/New.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] New.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2afc8021", Component.options)
  } else {
    hotAPI.reload("data-v-2afc8021", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1322 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./client/components/views/home/Home.vue ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-632d0eea","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 1521)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 883),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-632d0eea"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 1422),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/home/Home.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Home.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-632d0eea", Component.options)
  } else {
    hotAPI.reload("data-v-632d0eea", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1323 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./client/components/views/index/Index.vue ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-eb88efa0","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Index.vue */ 1560)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Index.vue */ 884),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-eb88efa0"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./index.pug */ 1468),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/index/Index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eb88efa0", Component.options)
  } else {
    hotAPI.reload("data-v-eb88efa0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1324 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./client/components/views/integration/fileUpload/FileUpload.vue ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-style-loader!css-loader!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-01f4a2a2","scoped":false,"hasInlineConfig":false}!sass-loader!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./FileUpload.vue */ 1576)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./FileUpload.vue */ 885),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-01f4a2a2"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./fileUpload.pug */ 1357),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/integration/fileUpload/FileUpload.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FileUpload.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01f4a2a2", Component.options)
  } else {
    hotAPI.reload("data-v-01f4a2a2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1325 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************!*\
  !*** ./client/components/views/integration/processedFiles/ProcessedFiles.vue ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-6f5ddfa2","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./ProcessedFiles.vue */ 1529)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ProcessedFiles.vue */ 886),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6f5ddfa2"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./processedFiles.pug */ 1431),
  /* scopeId */
  "data-v-6f5ddfa2",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/integration/processedFiles/ProcessedFiles.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ProcessedFiles.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6f5ddfa2", Component.options)
  } else {
    hotAPI.reload("data-v-6f5ddfa2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1326 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************!*\
  !*** ./client/components/views/integration/remittanceIntegration/RemittanceIntegration.vue ***!
  \*********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./RemittanceIntegration.vue */ 887),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-05d5d57d"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./remittanceIntegration.pug */ 1358),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/integration/remittanceIntegration/RemittanceIntegration.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RemittanceIntegration.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-05d5d57d", Component.options)
  } else {
    hotAPI.reload("data-v-05d5d57d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1327 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./client/components/views/login/CadastrarSenha.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-6bd12989","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./CadastrarSenha.vue */ 1528)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./CadastrarSenha.vue */ 888),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6bd12989"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./cadastrarSenha.pug */ 1430),
  /* scopeId */
  "data-v-6bd12989",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/login/CadastrarSenha.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CadastrarSenha.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6bd12989", Component.options)
  } else {
    hotAPI.reload("data-v-6bd12989", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1328 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./client/components/views/login/Login.vue ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-5cb3e11e","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Login.vue */ 1517)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Login.vue */ 889),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5cb3e11e"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./login.pug */ 1417),
  /* scopeId */
  "data-v-5cb3e11e",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/login/Login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5cb3e11e", Component.options)
  } else {
    hotAPI.reload("data-v-5cb3e11e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1329 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./client/components/views/login/LoginEmulado.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./LoginEmulado.vue */ 890),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1418f482"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./LoginEmulado.vue */ 1371),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/login/LoginEmulado.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoginEmulado.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1418f482", Component.options)
  } else {
    hotAPI.reload("data-v-1418f482", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1330 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./client/components/views/login/TrocaAplicacao.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./TrocaAplicacao.vue */ 891),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-30c3725a"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../~/vue-loader/lib/selector?type=template&index=0!./TrocaAplicacao.vue */ 1394),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/login/TrocaAplicacao.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TrocaAplicacao.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30c3725a", Component.options)
  } else {
    hotAPI.reload("data-v-30c3725a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1331 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./client/components/views/notFound/NotFound.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-73ba95ea","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./NotFound.vue */ 1533)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./NotFound.vue */ 892),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-73ba95ea"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./notFound.pug */ 1436),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/notFound/NotFound.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NotFound.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-73ba95ea", Component.options)
  } else {
    hotAPI.reload("data-v-73ba95ea", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1332 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./client/components/views/registration/attributesSet/List.vue ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 893),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2de24fd3"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1391),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/attributesSet/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2de24fd3", Component.options)
  } else {
    hotAPI.reload("data-v-2de24fd3", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1333 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./client/components/views/registration/attributesSet/New.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-7511b8fb","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./New.vue */ 1536)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./New.vue */ 894),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7511b8fb"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./new.pug */ 1439),
  /* scopeId */
  "data-v-7511b8fb",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/attributesSet/New.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] New.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7511b8fb", Component.options)
  } else {
    hotAPI.reload("data-v-7511b8fb", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1334 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./client/components/views/registration/bankAccounts/BelvoWidget.vue ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-e804536c","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./BelvoWidget.vue */ 1557)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./BelvoWidget.vue */ 895),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-e804536c"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./belvoWidget.pug */ 1465),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/bankAccounts/BelvoWidget.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BelvoWidget.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e804536c", Component.options)
  } else {
    hotAPI.reload("data-v-e804536c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1335 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./client/components/views/registration/bankAccounts/List.vue ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-743a74ea","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./List.vue */ 1534)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 896),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-743a74ea"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1437),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/bankAccounts/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-743a74ea", Component.options)
  } else {
    hotAPI.reload("data-v-743a74ea", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1336 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./client/components/views/registration/bankAccounts/New.vue ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-9db5d5f8","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./New.vue */ 1544)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./New.vue */ 897),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-9db5d5f8"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./new.pug */ 1450),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/bankAccounts/New.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] New.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9db5d5f8", Component.options)
  } else {
    hotAPI.reload("data-v-9db5d5f8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1337 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./client/components/views/registration/bankAccounts/OfdaDeepLink.vue ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./OfdaDeepLink.vue */ 898),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-143783f4"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../../../~/vue-loader/lib/selector?type=template&index=0!./OfdaDeepLink.vue */ 1372),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/bankAccounts/OfdaDeepLink.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OfdaDeepLink.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-143783f4", Component.options)
  } else {
    hotAPI.reload("data-v-143783f4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1338 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./client/components/views/registration/categories/List.vue ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-648087e0","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./List.vue */ 1523)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 899),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-648087e0"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1424),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/categories/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-648087e0", Component.options)
  } else {
    hotAPI.reload("data-v-648087e0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1339 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./client/components/views/registration/conciliationPlan/List.vue ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-66984113","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./List.vue */ 1527)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 900),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-66984113"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1428),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/conciliationPlan/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-66984113", Component.options)
  } else {
    hotAPI.reload("data-v-66984113", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1340 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./client/components/views/registration/conciliationPlan/New.vue ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-7d8ec08a","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./New.vue */ 1539)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./New.vue */ 901),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7d8ec08a"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./new.pug */ 1445),
  /* scopeId */
  "data-v-7d8ec08a",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/conciliationPlan/New.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] New.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d8ec08a", Component.options)
  } else {
    hotAPI.reload("data-v-7d8ec08a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1341 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/components/views/registration/establishments/List.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4485b970","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./List.vue */ 1507)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 902),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4485b970"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1405),
  /* scopeId */
  "data-v-4485b970",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/establishments/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4485b970", Component.options)
  } else {
    hotAPI.reload("data-v-4485b970", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1342 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./client/components/views/registration/establishments/Move.vue ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./Move.vue */ 903),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-23d119ba"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./move.pug */ 1380),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/establishments/Move.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Move.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23d119ba", Component.options)
  } else {
    hotAPI.reload("data-v-23d119ba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1343 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./client/components/views/registration/establishments/New.vue ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-33bc27be","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./New.vue */ 1502)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./New.vue */ 904),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-33bc27be"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./new.pug */ 1396),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/establishments/New.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] New.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33bc27be", Component.options)
  } else {
    hotAPI.reload("data-v-33bc27be", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1344 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./client/components/views/registration/occurrenceReason/List.vue ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./List.vue */ 905),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3a5894d2"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./list.pug */ 1400),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/occurrenceReason/List.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] List.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a5894d2", Component.options)
  } else {
    hotAPI.reload("data-v-3a5894d2", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1345 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./client/components/views/registration/occurrenceReason/New.vue ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./New.vue */ 906),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-758aea92"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./new.pug */ 1440),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/registration/occurrenceReason/New.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] New.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-758aea92", Component.options)
  } else {
    hotAPI.reload("data-v-758aea92", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1346 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./client/components/views/reports/bankBalance/BankBalance.vue ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-28cf8108","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./BankBalance.vue */ 1492)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./BankBalance.vue */ 907),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-28cf8108"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./bankBalance.pug */ 1383),
  /* scopeId */
  "data-v-28cf8108",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/bankBalance/BankBalance.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BankBalance.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28cf8108", Component.options)
  } else {
    hotAPI.reload("data-v-28cf8108", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1347 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./client/components/views/reports/bankStatement/BankStatement.vue ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-65d81ebc","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./BankStatement.vue */ 1524)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./BankStatement.vue */ 908),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-65d81ebc"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./bankStatement.pug */ 1425),
  /* scopeId */
  "data-v-65d81ebc",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/bankStatement/BankStatement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BankStatement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-65d81ebc", Component.options)
  } else {
    hotAPI.reload("data-v-65d81ebc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1348 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************!*\
  !*** ./client/components/views/reports/conciliationReport/ConciliationReport.vue ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4b893cfa","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./ConciliationReport.vue */ 1513)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ConciliationReport.vue */ 909),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4b893cfa"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./conciliationReport.pug */ 1412),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/conciliationReport/ConciliationReport.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConciliationReport.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b893cfa", Component.options)
  } else {
    hotAPI.reload("data-v-4b893cfa", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1349 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./client/components/views/reports/conciliationSummary/ConciliationSummary.vue ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ConciliationSummary.vue */ 910),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-e2bf9bb0"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./conciliationSummary.pug */ 1464),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/conciliationSummary/ConciliationSummary.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ConciliationSummary.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e2bf9bb0", Component.options)
  } else {
    hotAPI.reload("data-v-e2bf9bb0", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1350 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************!*\
  !*** ./client/components/views/reports/digitalWalletBalance/DigitalWalletBalance.vue ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-bb3e89cc","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./DigitalWalletBalance.vue */ 1550)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./DigitalWalletBalance.vue */ 911),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-bb3e89cc"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./digitalWalletBalance.pug */ 1455),
  /* scopeId */
  "data-v-bb3e89cc",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/digitalWalletBalance/DigitalWalletBalance.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DigitalWalletBalance.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bb3e89cc", Component.options)
  } else {
    hotAPI.reload("data-v-bb3e89cc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1351 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************!*\
  !*** ./client/components/views/reports/duplicateMovementsAnalysis/DuplicateMovementsAnalysis.vue ***!
  \***************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./DuplicateMovementsAnalysis.vue */ 912),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-385bbd4c"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./duplicateMovementsAnalysis.pug */ 1399),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/duplicateMovementsAnalysis/DuplicateMovementsAnalysis.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DuplicateMovementsAnalysis.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-385bbd4c", Component.options)
  } else {
    hotAPI.reload("data-v-385bbd4c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1352 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************!*\
  !*** ./client/components/views/reports/financialMovement/FinancialMovement.vue ***!
  \*********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-f99f3a28","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./FinancialMovement.vue */ 1563)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./FinancialMovement.vue */ 913),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-f99f3a28"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./financialMovement.pug */ 1471),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/financialMovement/FinancialMovement.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FinancialMovement.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f99f3a28", Component.options)
  } else {
    hotAPI.reload("data-v-f99f3a28", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1353 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************!*\
  !*** ./client/components/views/reports/manualConciliation/ManualConciliation.vue ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1e61ffba","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./ManualConciliation.vue */ 1489)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./ManualConciliation.vue */ 914),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1e61ffba"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./manualConciliation.pug */ 1379),
  /* scopeId */
  "data-v-1e61ffba",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/manualConciliation/ManualConciliation.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ManualConciliation.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1e61ffba", Component.options)
  } else {
    hotAPI.reload("data-v-1e61ffba", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1354 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************!*\
  !*** ./client/components/views/reports/occurrenceReport/OccurrenceReport.vue ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-475e994c","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector?type=styles&index=0!./OccurrenceReport.vue */ 1511)

var Component = __webpack_require__(/*! ../../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../../~/vue-loader/lib/selector?type=script&index=0!./OccurrenceReport.vue */ 915),
  /* template */
  __webpack_require__(/*! !../../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-475e994c"}!../../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./occurrenceReport.pug */ 1410),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/reports/occurrenceReport/OccurrenceReport.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] OccurrenceReport.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-475e994c", Component.options)
  } else {
    hotAPI.reload("data-v-475e994c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1355 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./client/components/views/unauthorized/Unauthorized.vue ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !vue-loader/~/vue-style-loader!css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-eb2dd9ec","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./Unauthorized.vue */ 1559)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 5)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./Unauthorized.vue */ 916),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-eb2dd9ec"}!../../../../~/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!./unauthorized.pug */ 1467),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/views/unauthorized/Unauthorized.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Unauthorized.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eb2dd9ec", Component.options)
  } else {
    hotAPI.reload("data-v-eb2dd9ec", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 1356 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0049b780"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/clientModal/clientModal.pug ***!
  \************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "id": "client-modal",
      "size": "modal-md",
      "data-backdrop": "static",
      "data-keyboard": "true",
      "closable": _vm.client !== null,
      "closeFunction": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "page-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalCliente.labels.clientes'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalCliente.titulos.selecioneCliente'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-client-table', {
    staticClass: "data-table select-client-table custom-data-table table-thead-cursor-pointer",
    attrs: {
      "data": _vm.clients,
      "columns": _vm.columns,
      "options": _vm.options,
      "show-pagination": false
    },
    on: {
      "row-click": _vm.rowClick
    },
    scopedSlots: _vm._u([{
      key: "nomeFantasia",
      fn: function(props) {
        return [_c('div', {
          staticClass: "pull-left"
        }, [_c('label', {
          class: props.row.id === _vm.client ? 'selector-selected' : 'selector-unselected'
        }, [_vm._v(_vm._s(props.row.nomeFantasia))])]), _c('div', {
          staticClass: "pull-right"
        }, [_c('label', {
          class: props.row.id === _vm.client ? 'selector-selected' : 'selector-unselected'
        }, [_c('i', {
          staticClass: "selector-icon fa fa-check"
        }), _c('span', {
          domProps: {
            "innerHTML": _vm._s(props.row.id === _vm.client ? _vm.$t('modalCliente.labels.selecionado') : _vm.$t('modalCliente.labels.selecionar'))
          }
        })])])]
      }
    }])
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0049b780", module.exports)
  }
}

/***/ }),
/* 1357 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-01f4a2a2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/integration/fileUpload/fileUpload.pug ***!
  \*********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "FileUploadWrapper"
    }
  }, [(!_vm.isLoadingData) ? _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('uploadArquivo.titulos.titulo'),
      "subTitle": _vm.$t('uploadArquivo.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('uploadArquivo.titulos.tituloFilter')
    }
  }, [_c('div', {
    attrs: {
      "slot": "filters",
      "thumbnailWidth": "73px",
      "thumbnailHeight": "53px"
    },
    slot: "filters"
  }, [_c('dropzone', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.permissionUploadFile),
      expression: "permissionUploadFile"
    }],
    ref: "fileUploadDZ",
    attrs: {
      "id": "fileUploader",
      "url": _vm.uploadUrl,
      "use-font-awesome": "use-font-awesome",
      "duplicate-check": "duplicate-check",
      "use-custom-dropzone-options": _vm.useCustomDropzoneOptions,
      "dropzone-options": _vm.dropzoneOptions,
      "preview-template": _vm.fileListTemplate
    },
    on: {
      "vdropzone-file-added": _vm.updateQueuedFiles,
      "vdropzone-removed-file": _vm.verifyDropzoneEmpty,
      "vdropzone-error": _vm.showErrorMessage,
      "vdropzone-success": _vm.saveAuditLog
    }
  }, [(_vm.showInnerMessage) ? _c('div', {
    staticClass: "dz-inner",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('uploadArquivo.uploader.dzInnerMessage'))
    }
  }) : _vm._e(), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "layout"
    },
    domProps: {
      "value": _vm.layouts
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.permissionUploadFile),
      expression: "!permissionUploadFile"
    }],
    staticClass: "dz-default dz-message text-center upload-disabled"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-ban icon-upload-disabled"
  }), _c('p', {
    staticClass: "txt-upload-disabled",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('uploadArquivo.uploader.envioDesabilitado'))
    }
  })])])], 1)]), _c('label', {
    staticClass: "upload-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.permissionUploadFile ? 'uploadArquivo.titulos.mensagemFilter' : 'uploadArquivo.titulos.mensagemFilterDisabled'))
    }
  })], 1)])])]) : (_vm.isLoadingData) ? _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01f4a2a2", module.exports)
  }
}

/***/ }),
/* 1358 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d5d57d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/integration/remittanceIntegration/remittanceIntegration.pug ***!
  \*******************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "remittanceIntegration"
    }
  }, [_c('confirm-modal', {
    attrs: {
      "id": "confirmRemittanceRemoval"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.mensagem.confirmarExclusao'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoveRemittance",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmacaoModalCreateRemittance",
      "clickFunction": _vm.removeRemittance
    }
  })], 1)]), _c('remittance-integration-modal', {
    attrs: {
      "show": _vm.shown.detail,
      "remittance": _vm.remittance,
      "showRemovalButton": _vm.canRemoveRemittance
    },
    on: {
      "close-modal": _vm.closeDetailModal
    }
  }), _c('remittance-integration-creation-modal', {
    attrs: {
      "show": _vm.shown.new,
      "remittance-types": _vm.cleanRemittanceTypes
    },
    on: {
      "close-modal": _vm.closeNewRemittanceModal
    }
  }), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t("remessaIntegracao.titulos.titulo"),
      "subTitle": _vm.$t("remessaIntegracao.titulos.subtitulo")
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "id": "btnNovaRemessa",
      "label": _vm.$t("remessaIntegracao.labels.novoArquivo"),
      "clickFunction": _vm.loadNewRemittanceModal
    },
    slot: "new-button"
  })], 1), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t("remessaIntegracao.titulos.filtro")
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "exportFileFlag": _vm.isExportFile,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    on: {
      "update-flagExportingFile": function($event) {
        _vm.isExportFile = !_vm.isExportFile
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 365,
      "disableDateRange": _vm.disableDateRange
    },
    model: {
      value: (_vm.filters.period),
      callback: function($$v) {
        _vm.$set(_vm.filters, "period", $$v)
      },
      expression: "filters.period"
    }
  })], 1), _c('div', {
    staticClass: "row"
  }), _c('div', {
    staticClass: "row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.labels.consultaPor'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has("remessaRadioButton")),
      expression: "errors.has(\"remessaRadioButton\")"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("validacao.campoObrigatorio"))
    }
  }), _c('div', {
    staticClass: "radio radio-success no-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.origin),
      expression: "filters.origin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ("required"),
      expression: "\"required\""
    }],
    staticClass: "input",
    attrs: {
      "id": "dataGeracaoRadio-RemessaIntegracao",
      "type": "radio",
      "name": "remessaRadioButton",
      "value": "G",
      "checked": "checked",
      "disabled": _vm.disableDateRange
    },
    domProps: {
      "checked": _vm._q(_vm.filters.origin, "G")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filters, "origin", "G")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "dataGeracaoRadio-RemessaIntegracao"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.dataGeracao"))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.origin),
      expression: "filters.origin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ("required"),
      expression: "\"required\""
    }],
    staticClass: "input",
    attrs: {
      "id": "periodoMovimentacaoRadio-RemessaIntegracao",
      "type": "radio",
      "name": "remessaRadioButton",
      "value": "M",
      "disabled": _vm.disableDateRange
    },
    domProps: {
      "checked": _vm._q(_vm.filters.origin, "M")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.filters, "origin", "M")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "periodoMovimentacaoRadio-RemessaIntegracao"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.periodoMovimentacao"))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "remittenceType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.tipoRemessa"))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "input",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('filters.type')
    },
    attrs: {
      "id": "remittenceType",
      "value": _vm.filters.type,
      "options": _vm.remittenceTypes,
      "label": "nome",
      "placeholder": _vm.$t("validacao.select.placeholder"),
      "data-vv-name": "filters.type",
      "name": "remittenceType",
      "disabled": _vm.filters.remittenceIds.length > 0
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("estabelecimentos.labels.nenhumResultado"))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule("filters.type", "required")),
      expression: "errors.firstByRule(\"filters.type\", \"required\")"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("validacao.campoObrigatorio"))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.idsRemessa"))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.filters.remittenceIds,
      "read-only": false,
      "typeable": true,
      "type-only": true,
      "type-only-options": {
        isNumericOnly: true
      },
      "place-holders": {
        input: "remessaIntegracao.labels.digiteIdRemessa"
      },
      "disable-input": _vm.filters.sequenceNumber.length > 0
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.filters, "remittenceIds", $event)
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.numeroSequencia"))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.filters.sequenceNumber,
      "read-only": false,
      "typeable": true,
      "type-only": true,
      "type-only-options": {
        isNumericOnly: true
      },
      "place-holders": {
        input: "remessaIntegracao.labels.digiteNumeroSequencia"
      },
      "disable-input": _vm.filters.remittenceIds.length > 0
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.filters, "sequenceNumber", $event)
      }
    }
  })], 1)])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGrid),
      expression: "showGrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "RemessasIntegracao",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "remessaIntegracao",
      "cfgObj": _vm.treeGridCfg,
      "showExcluirRemessaButton": _vm.canRemoveRemittance
    },
    on: {
      "remittanceRemoval": _vm.remittanceRemoval
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05d5d57d", module.exports)
  }
}

/***/ }),
/* 1359 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0643cdba"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/accessProfile/new.pug ***!
  \********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('administracao.perfilAcesso.titulos.perfisAcesso'),
      "subTitle": _vm.pageTitleSubTitle
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.filterPortletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.newProfile.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [(!_vm.isMasterProfile(_vm.profileToEditId)) ? _c('step-progress', {
    attrs: {
      "steps": _vm.steps,
      "current-step": _vm.currentStep
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }]
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "profileName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.perfilInfo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.name),
      expression: "profile.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('profileName')
    },
    attrs: {
      "type": "text",
      "id": "profileName",
      "name": "profileName",
      "maxlength": "40",
      "readonly": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "value": (_vm.profile.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('profileName')),
      expression: "errors.has('profileName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidade'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('div', {
    staticClass: "radio radio-success mt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.visibility),
      expression: "profile.visibility"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "visibilityAll",
      "name": "visibility",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.profile.visibility, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.profile, "visibility", "0")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "visibilityAll"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.visibility),
      expression: "profile.visibility"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "visibilitySome",
      "name": "visibility",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.profile.visibility, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.profile, "visibility", "1")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "visibilitySome"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaAlguns'))
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('visibility')),
      expression: "errors.has('visibility')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.funcionalidades'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('div', {
    staticClass: "boxed-container"
  }, [_c('div', {
    staticClass: "px-0 checkbox check-success"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "selectAllFunctionalities",
      "name": "selectAllFunctionalities",
      "disabled": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "checked": _vm.allFunctionalitiesSelected
    },
    on: {
      "click": function($event) {
        return _vm.selectAllFunctionalities()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "selectAllFunctionalities"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.selecionarTodos'))
    }
  })]), _c('div', {
    staticClass: "row row-filter-small"
  }, _vm._l((_vm.functionalitiesGroups), function(functionalityGroup, index) {
    return _c('div', [(functionalityGroup.funcionalidades && functionalityGroup.funcionalidades.length > 0) ? _c('div', [_c('div', {
      staticClass: "group-checkbox checkbox check-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (functionalityGroup.checked),
        expression: "functionalityGroup.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": functionalityGroup.id,
        "name": "functionalityGroup",
        "disabled": _vm.isMasterProfile(_vm.profileToEditId)
      },
      domProps: {
        "checked": Array.isArray(functionalityGroup.checked) ? _vm._i(functionalityGroup.checked, null) > -1 : (functionalityGroup.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = functionalityGroup.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(functionalityGroup, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(functionalityGroup, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(functionalityGroup, "checked", $$c)
          }
        }, function($event) {
          return _vm.selectFunctionalityGroup(functionalityGroup)
        }]
      }
    }), _c('label', {
      staticClass: "func-group-title",
      attrs: {
        "for": functionalityGroup.id
      },
      on: {
        "click": function($event) {
          return _vm.trackEventOnFunctionalityGroup(functionalityGroup.nome)
        }
      }
    }, [_c('i', {
      class: _vm.getGroupIcon(functionalityGroup.id)
    }), _c('span', {
      staticClass: "func-group-title-label"
    }, [_vm._v(_vm._s(functionalityGroup.nome))]), (functionalityGroup.id == 35) ? _c('i', {
      staticClass: "fa fa-info-circle info-icon",
      attrs: {
        "title": _vm.$t('administracao.perfilAcesso.labels.hintEmularAcesso')
      }
    }) : _vm._e()])]), _c('div', {
      staticClass: "col-xs-10 check-group bottom-bordered"
    }), _c('div', {
      staticClass: "col-xs-10"
    }, _vm._l((functionalityGroup.funcionalidades), function(functionality, idx) {
      return _c('div', {
        staticClass: "check-group func-padded"
      }, [_c('div', {
        staticClass: "checkbox check-success",
        class: _vm.getCheckFuncContainerClass(idx)
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (functionality.checked),
          expression: "functionality.checked"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "type": "checkbox",
          "id": functionality.id,
          "name": "functionality",
          "disabled": _vm.isMasterProfile(_vm.profileToEditId)
        },
        domProps: {
          "checked": Array.isArray(functionality.checked) ? _vm._i(functionality.checked, null) > -1 : (functionality.checked)
        },
        on: {
          "change": [function($event) {
            var $$a = functionality.checked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(functionality, "checked", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(functionality, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(functionality, "checked", $$c)
            }
          }, function($event) {
            return _vm.selectFunctionality(functionality)
          }]
        }
      }), _c('label', {
        staticClass: "func-group-labels",
        attrs: {
          "for": functionality.id
        },
        on: {
          "click": function($event) {
            return _vm.trackEventOnFunctionality(functionality.nome)
          }
        }
      }, [_vm._v(_vm._s(functionality.nome))])])])
    }), 0), _c('br'), _c('br')]) : _vm._e()])
  }), 0)]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('functionality')),
      expression: "errors.has('functionality')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }]
  }, [_c('div', {
    attrs: {
      "id": "establishments"
    }
  }, [_c('v-client-table', {
    ref: "table",
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.establishments.establishments,
      "columns": _vm.establishments.columns,
      "options": _vm.establishments.options
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(props) {
        return [_c('div', {
          staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-row"
        }, [_c('input', {
          attrs: {
            "type": "checkbox",
            "id": ("check-establishment-" + (props.row["id"])),
            "name": "checkEstablishment",
            "disabled": _vm.isMasterProfile(_vm.profileToEditId)
          },
          domProps: {
            "checked": props.row.checked
          },
          on: {
            "click": function($event) {
              return _vm.selectEstablishment(props.row)
            }
          }
        }), _c('label', {
          staticClass: "func-group-labels",
          attrs: {
            "for": ("check-establishment-" + (props.row["id"]))
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "h__check"
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-header"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "allEstablishmentsSelected",
      "name": "allEstablishmentsSelected",
      "disabled": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "checked": _vm.establishments.allEstablishmentsSelected
    },
    on: {
      "click": function($event) {
        return _vm.selectAllEstablishments()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "allEstablishmentsSelected"
    }
  })])])], 2)], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }]
  }, [_c('div', {
    attrs: {
      "id": "accounts"
    }
  }, [_c('v-client-table', {
    ref: "table",
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.bankAccounts.accounts,
      "columns": _vm.bankAccounts.columns,
      "options": _vm.bankAccounts.options
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(props) {
        return [_c('div', {
          staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-row"
        }, [_c('input', {
          attrs: {
            "type": "checkbox",
            "id": ("check-bankAccount-" + (props.row["id"])),
            "name": "checkBankAccount",
            "disabled": _vm.isMasterProfile(_vm.profileToEditId)
          },
          domProps: {
            "checked": props.row.checked
          },
          on: {
            "click": function($event) {
              return _vm.selectBankAccount(props.row)
            }
          }
        }), _c('label', {
          staticClass: "func-group-labels",
          attrs: {
            "for": ("check-bankAccount-" + (props.row["id"]))
          }
        })])]
      }
    }])
  }, [_c('template', {
    slot: "h__check"
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0 checkbox-table-input checkbox-table-input-header"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "allBankAccountsSelected",
      "name": "allBankAccountsSelected",
      "disabled": _vm.isMasterProfile(_vm.profileToEditId)
    },
    domProps: {
      "checked": _vm.bankAccounts.allBankAccountsSelected
    },
    on: {
      "click": function($event) {
        return _vm.selectAllBankAccounts()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "allBankAccountsSelected"
    }
  })])]), _c('template', {
    slot: "filter__banco"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'banco')
      }
    }
  })]), _c('template', {
    slot: "filter__agencia"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'agencia')
      }
    }
  })]), _c('template', {
    slot: "filter__conta"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'conta')
      }
    }
  })])], 2)], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }]
  }, [_c('div', {
    attrs: {
      "id": "confirmation"
    }
  }, [_c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.perfilInfo'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-6 pl-0"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidade'))
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 row-filter-small"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.profile.name))])]), _c('div', {
    staticClass: "col-xs-6 row-filter-small pl-0"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.profile.visibility === '0' ? _vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos') : _vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaAlguns')))])])]), _c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.funcionalidades'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small d-flex flex-wrap"
  }, _vm._l((_vm.functionalitiesGroups), function(functionalityGroup, index) {
    return _c('div', {
      staticClass: "col-xs-4 row-filter-small pl-0"
    }, [(functionalityGroup.funcionalidades && functionalityGroup.funcionalidades.length > 0) ? _c('div', [_c('p', {
      staticClass: "func-group-title mb-5"
    }, [_c('i', {
      class: _vm.getGroupIcon(functionalityGroup.id)
    }), _c('span', {
      staticClass: "func-group-title-label"
    }, [_vm._v(_vm._s(functionalityGroup.nome) + ":")])]), _vm._l((_vm.profile.functionalitiesSelected), function(functionality) {
      return _c('div', [(functionalityGroup.id === functionality.grupoFuncionalidade.id) ? _c('p', {
        staticClass: "mb-0"
      }, [_vm._v(_vm._s(functionality.nome))]) : _vm._e()])
    })], 2) : _vm._e()])
  }), 0), _c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.etapas.estabelecimentos'))
    }
  })])])]), (_vm.profile.establishmentsSelected.length > 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.profile.establishmentsSelected), function(establishment) {
    return _c('div', {
      staticClass: "col-xs-6 row-filter-small pl-0"
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('estabelecimentos.labels.nome')) + " (" + _vm._s(_vm.$t('estabelecimentos.labels.nomeFantasia')) + "): " + _vm._s(establishment.nome) + " (" + _vm._s(establishment.nomeFantasia) + ")")]), _c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('estabelecimentos.labels.cnpj')) + ": " + _vm._s(establishment.cnpj))])])
  }), 0) : _c('div', {
    staticClass: "row-filter-small"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos'))
    }
  })]), _c('div', {
    staticClass: "row row-filter-small p-5 bg-gray"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.etapas.contasBancarias'))
    }
  })])])]), (_vm.profile.bankAccountsSelected.length > 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.profile.bankAccountsSelected), function(bankAccount) {
    return _c('div', {
      staticClass: "col-xs-6 row-filter-small pl-0"
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('contaBancaria.labels.nome')) + " (" + _vm._s(_vm.$t('contaBancaria.labels.banco')) + "): " + _vm._s(bankAccount.nome) + " (" + _vm._s(bankAccount.banco.nomeFantasia) + ")")]), _c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('contaBancaria.labels.agencia')) + ": " + _vm._s(bankAccount.numAgencia) + _vm._s(bankAccount.digAgencia ? '-' + bankAccount.digAgencia : ''))]), _c('p', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(_vm.$t('contaBancaria.labels.numeroConta')) + ": " + _vm._s(bankAccount.conta) + _vm._s(bankAccount.digConta ? '-' + bankAccount.digConta : ''))])])
  }), 0) : _c('div', {
    staticClass: "row-filter-small"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.perfilAcesso.labels.visibilidadeAcessaTodos'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMasterProfile(_vm.profileToEditId) || _vm.currentStep === 3),
      expression: "isMasterProfile(profileToEditId) || currentStep === 3"
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "id": "btnSaveProfile",
      "label": _vm.$t('administracao.perfilAcesso.labels.salvar'),
      "disabled": _vm.isMasterProfile(_vm.profileToEditId) || _vm.requestSaveProfileSent
    }
  }), _c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMasterProfile(_vm.profileToEditId) && _vm.currentStep !== 3),
      expression: "!isMasterProfile(profileToEditId) && currentStep !== 3"
    }],
    staticClass: "pull-right",
    attrs: {
      "id": "btnNextStep",
      "label": _vm.$t('administracao.perfilAcesso.labels.proximo'),
      "clickFunction": _vm.nextStep
    }
  }), _c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "pull-right",
    attrs: {
      "id": "btnCancel",
      "customClass": "secondary",
      "label": _vm.$t('administracao.perfilAcesso.labels.cancelar'),
      "clickFunction": _vm.back
    }
  }), _c('button-primary', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMasterProfile(_vm.profileToEditId) && _vm.currentStep !== 0),
      expression: "!isMasterProfile(profileToEditId) && currentStep !== 0"
    }],
    staticClass: "pull-right",
    attrs: {
      "id": "btnBackStep",
      "customClass": "secondary",
      "label": _vm.$t('administracao.perfilAcesso.labels.voltar'),
      "clickFunction": _vm.backStep
    }
  })], 1)])], 1)])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0643cdba", module.exports)
  }
}

/***/ }),
/* 1360 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ceb7ab"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/menu/suspendedMenu.pug ***!
  \*******************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "suspended-menu-wrapper"
    }
  }, [_c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:suspended-menu.bottom",
      arg: "suspended-menu",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "cursor-pointer"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('popover', {
    attrs: {
      "name": "suspended-menu"
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.openMyAccountModal()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.minhaConta'))
    }
  })])]), (!_vm.blockClientSelectButton) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.openClientModal()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.clientes'))
    }
  })])]) : _vm._e(), (_vm.applicationList.length > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.openAppChangeModal()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.apps'))
    }
  })])]) : _vm._e(), _c('li', {
    staticClass: "logout",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('div', {
    staticClass: "clickable-item"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('menu.suspenso.logout'))
    }
  }), _c('i', {
    staticClass: "fa fa-power-off",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07ceb7ab", module.exports)
  }
}

/***/ }),
/* 1361 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-081ec6ca"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonApplication/buttonApplication.pug ***!
  \*************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    class: _vm.btnWidth,
    attrs: {
      "id": "Botao-Aplicacao-Wrapper"
    },
    on: {
      "click": _vm.btnClickFunction
    }
  }, [_c('div', [_c('div', {
    staticClass: "img-troca-app",
    class: _vm.btnActive ? 'rounded-div-active' : 'rounded-div',
    attrs: {
      "name": 'rounded-div-image-' + _vm.btnAppId
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.btnImg,
      "width": "65",
      "height": "65"
    }
  })]), _c('span', {
    class: _vm.btnActive ? 'mark' : 'transp-mark',
    domProps: {
      "innerHTML": _vm._s(_vm.$t('trocaApp.labels.voceAqui'))
    }
  })]), _c('h4', {
    class: _vm.btnActive ? 'app-font bold' : 'app-font',
    domProps: {
      "innerHTML": _vm._s(_vm.btnDesc)
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-081ec6ca", module.exports)
  }
}

/***/ }),
/* 1362 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-09c1836a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/calendarView/calendarView.pug ***!
  \*******************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendarView"
    }
  }, [_c('div', {
    staticClass: "row margin-box-filter"
  }, [_c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "display": "grid"
    }
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.periodo'))
    }
  }), _c('datepicker', {
    ref: "calendaViewMonthPicker",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "id": "monthPickerCalendarSummary",
      "language": _vm.monthPickerLanguage,
      "format": "MMMM/yyyy",
      "full-month-name": "full-month-name",
      "input-class": {
        "calendar-month-picker": true
      },
      "wrapper-class": {
        "datepicker-wrapper": true
      },
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "open-date": _vm.monthPick,
      "minimum-view": "month",
      "maximum-view": "year",
      "disabled": _vm.isLoadingData || _vm.isUpdatingInfo
    },
    on: {
      "click": function () {
        _vm.console.log('on input click')
      }
    },
    model: {
      value: (_vm.monthPick),
      callback: function($$v) {
        _vm.monthPick = $$v
      },
      expression: "monthPick"
    }
  })], 1), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.situacao'))
    }
  }), _c('v-select', {
    attrs: {
      "options": _vm.orderedStatusList,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "statusSelected",
      "disabled": _vm.isLoadingData || _vm.isUpdatingInfo,
      "clearable": false
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.filteredStatus)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-flex"
          }
        }, [_c('div', {
          staticClass: "square-5",
          style: ({
            'background': _vm.getColorByStatus(option.id)
          })
        }), _c('span', {
          domProps: {
            "innerHTML": _vm._s(option.nome)
          }
        })])]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-flex"
          }
        }, [_c('div', {
          staticClass: "square-5",
          style: ({
            'background': _vm.getColorByStatus(option.id)
          })
        }), _c('span', {
          domProps: {
            "innerHTML": _vm._s(option.nome)
          }
        })])]
      }
    }]),
    model: {
      value: (_vm.filteredStatus),
      callback: function($$v) {
        _vm.filteredStatus = $$v
      },
      expression: "filteredStatus"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.categoria'))
    }
  }), _c('v-select', {
    attrs: {
      "options": _vm.categories,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "categorySelected",
      "disabled": _vm.isLoadingData || _vm.isUpdatingInfo,
      "clearable": false
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.filteredCategory)
      }
    },
    model: {
      value: (_vm.filteredCategory),
      callback: function($$v) {
        _vm.filteredCategory = $$v
      },
      expression: "filteredCategory"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]), (_vm.isLoadingData || _vm.isUpdatingInfo) ? _c('div', {
    staticClass: "loadingData"
  }) : _c('div', {
    staticClass: "row"
  }, [(_vm.calendarData) ? _c('div', {
    staticClass: "row ds-calendar",
    attrs: {
      "id": "weekDaysHeader"
    }
  }, [_c('div', {
    staticClass: "ds-month-view"
  }, [_c('div', {
    staticClass: "week-header"
  }, [_c('div', {
    staticClass: "week-column-day-header"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.dom'))
    }
  })]), _c('div', {
    staticClass: "week-column-day-header"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.seg'))
    }
  })]), _c('div', {
    staticClass: "week-column-day-header"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.ter'))
    }
  })]), _c('div', {
    staticClass: "week-column-day-header"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.qua'))
    }
  })]), _c('div', {
    staticClass: "week-column-day-header"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.qui'))
    }
  })]), _c('div', {
    staticClass: "week-column-day-header"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.sex'))
    }
  })]), _c('div', {
    staticClass: "week-column-day-header"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.labels.sab'))
    }
  })])]), _vm._l((_vm.calendarData.weeks), function(week) {
    return _c('div', {
      staticClass: "ds-week"
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "ds-day",
        class: day.selected ? 'selected-day' : '',
        attrs: {
          "id": _vm.getReferenceFromDay(day.date)
        },
        on: {
          "click": function($event) {
            return _vm.handleClickDay(day.date)
          },
          "mouseover": function($event) {
            return _vm.handleMouseOver(day.date, true)
          },
          "mouseleave": function($event) {
            return _vm.handleMouseOver(day.date, false)
          }
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('span', {
        class: day.selected ? 'label-today' : '',
        domProps: {
          "innerHTML": _vm._s(_vm.formatDateGetDay(day.date ? day.date : null))
        }
      })]), _vm._l((day.summary), function(sum) {
        return (sum.status === _vm.filteredStatus.id) ? _c('div', {
          staticClass: "row detail-line-position"
        }, [_c('div', {
          staticClass: "col-xs-12"
        }, [_c('span', {
          staticClass: "label-indicador-status",
          staticStyle: {
            "border-bottom": "2px solid"
          },
          style: ({
            'border-color': _vm.getColorByStatus(sum.status)
          }),
          domProps: {
            "innerHTML": _vm._s(_vm.getConciliationLabel(sum.status))
          }
        })]), _c('div', {
          staticClass: "col-xs-12"
        }, [_c('span', {
          staticClass: "label-indicador-percent",
          domProps: {
            "innerHTML": _vm._s(_vm.formatPercent(sum.percent))
          }
        })])]) : _vm._e()
      })], 2)
    }), 0)
  })], 2)]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09c1836a", module.exports)
  }
}

/***/ }),
/* 1363 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a21cc36"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/attributesSet/attribute.pug ***!
  \******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-complete-item attribute row text-center"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "badge att-field order"
  }, [_vm._v(_vm._s(_vm.order))])]), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "att-field name bold"
  }, [_vm._v(_vm._s(_vm.name))])]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "att-field description"
  }, [_vm._v(_vm._s(_vm.description))])]), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "att-field type",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(("" + (_vm.type.description))))
    }
  })]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "att-field possibleValues"
  }, [_vm._v(_vm._s(_vm.transformedPossibleValues))])]), _c('div', {
    staticClass: "col-md-1 text-right"
  }, [_c('div', {
    staticClass: "att-field buttons"
  }, [_c('button', {
    staticClass: "fa fa-pencil action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit(_vm.order)
      }
    }
  }), _c('button', {
    staticClass: "fa fa-times action",
    attrs: {
      "type": "button",
      "disabled": _vm.inUse,
      "title": _vm.btnRemoveTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleRemove(_vm.order)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a21cc36", module.exports)
  }
}

/***/ }),
/* 1364 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0affa294"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabDetails/tabDetails.pug ***!
  \***************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-details-wrapper"
    }
  }, [_c('div', {
    staticClass: "main-container",
    attrs: {
      "id": "main-detail-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "main-value-detail-container"
    }
  }, [(_vm.establishtmentValue) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.title))]), _c('h4', {
    staticClass: "tab-detail-value"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.value))])]) : _vm._e(), _vm._l((_vm.mainValuesList), function(mainValue, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('h4', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(mainValue.title))]), _c('h4', {
      staticClass: "tab-detail-value"
    }, [_vm._v(_vm._s(mainValue.value))])]), (index > 1 && (index + 1) % 3 === 0) ? _c('div', {
      staticClass: "clear"
    }) : _vm._e()])
  }), (_vm.commentary) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.commentary.title))]), _c('h4', {
    staticClass: "tab-detail-value"
  }, [_vm._v(_vm._s(_vm.commentary.value))])]) : _vm._e()], 2), _c('div', {
    staticClass: "status-container",
    attrs: {
      "id": "statuses-container"
    }
  }, _vm._l((_vm.statusValuesList), function(statusValue, index) {
    return _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_c('h4', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(statusValue.title))]), _c('h4', {
      class: statusValue.class
    }, [_vm._v(_vm._s(statusValue.value))])]), ((index + 1) % 2 === 0) ? _c('div', {
      staticClass: "clear"
    }) : _vm._e()])
  }), 0)]), _c('div', {
    attrs: {
      "id": "footer-monetary-detail-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 monetary-container"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, _vm._l((_vm.monetaryValuesList), function(monetaryValue, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('h4', {
      staticClass: "tab-detail-value"
    }, [_vm._v(_vm._s(monetaryValue.title))]), _c('h4', {
      class: monetaryValue.class
    }, [_vm._v(_vm._s(monetaryValue.value))])]), ((index + 1) % 3 === 0) ? _c('div', {
      staticClass: "clear"
    }) : _vm._e()])
  }), 0)]), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0affa294", module.exports)
  }
}

/***/ }),
/* 1365 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d6d05cc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/headerBar/headerBar.pug ***!
  \********************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerBar-title-wrapper col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "fields-wrapper col-xs-12 col-sm-12 col-md-10 col-lg-10 pull-right px-0"
  }, [_vm._t("fields")], 2), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [(_vm.subTitle) ? _c('h4', {
    staticClass: "subtitle-headerBar"
  }, [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d6d05cc", module.exports)
  }
}

/***/ }),
/* 1366 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e4ca9a2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/allotment.pug ***!
  \******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "allotmentWrapper"
    }
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('h4', {
    staticClass: "pending-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridLotes'))
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegridLot),
      expression: "showTreegridLot"
    }],
    staticClass: "row"
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "concManualLotes",
      "result": _vm.resultLot,
      "treeGridLayoutPath": "auditoria",
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "concManualLotes",
      "cfgObj": _vm.treeGridCfgLot,
      "showExportButton": false,
      "showHrTopGrid": false
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e4ca9a2", module.exports)
  }
}

/***/ }),
/* 1367 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-103c15fc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/App.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoadingFullPage) ? _c('div', [_c('loading-full-page')], 1) : _vm._e(), _c('router-view'), _c('notification', {
    ref: "notification"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-103c15fc", module.exports)
  }
}

/***/ }),
/* 1368 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1238adbf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/duplicateMovementsAnalysis/duplicateMovements.pug ***!
  \***********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "duplicateMovements"
    }
  }, [_c('div', {
    staticClass: "row pt-5"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('analiseDuplicidade.labels.camposAvaliados.titulo'))
    }
  }), _vm._l((_vm.comparableFieldsList), function(status, idx) {
    return _c('div', [_c('div', {
      staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.checked),
        expression: "status.checked"
      }],
      attrs: {
        "id": status.id,
        "type": "checkbox",
        "name": "status"
      },
      domProps: {
        "checked": Array.isArray(status.checked) ? _vm._i(status.checked, null) > -1 : (status.checked)
      },
      on: {
        "change": function($event) {
          var $$a = status.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(status, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(status, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(status, "checked", $$c)
          }
        }
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": status.id
      }
    }, [_vm._v(_vm._s(status.nome))])])])
  })], 2)]), _c('div', {
    staticClass: "row row-filter-small mr-0 pb-5"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.buscar'),
      "id": "btnBuscarDuplicado",
      "clickFunction": _vm.validate,
      "disabled": _vm.disableSearchButton
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1238adbf", module.exports)
  }
}

/***/ }),
/* 1369 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-124f2540"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/dashboard/chartFilter/ConciliationSituationSummary.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('filters-common', {
    attrs: {
      "data": _vm.filters
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-124f2540", module.exports)
  }
}

/***/ }),
/* 1370 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-13215916"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/modal/modal.pug ***!
  \************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": [_vm.id],
      "data-controls-modal": [_vm.id],
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.trackEvent.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-center"
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: [_vm.size ? _vm.size : 'modal-lg']
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "concil-modal-header"
  }, [(_vm.closeFunction && _vm.closable) ? _c('div', [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.trackEvent
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._t("header")], 2), _c('div', {
    class: _vm.bodyClass
  }, [_vm._t("body")], 2), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13215916", module.exports)
  }
}

/***/ }),
/* 1371 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1418f482"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/login/LoginEmulado.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1418f482", module.exports)
  }
}

/***/ }),
/* 1372 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-143783f4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/registration/bankAccounts/OfdaDeepLink.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [(_vm.isLoadingData) ? _c('div', {
    staticClass: "loadingData"
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-143783f4", module.exports)
  }
}

/***/ }),
/* 1373 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fd6674"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/input/dynamicInput/dynamicInput.pug ***!
  \*************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dynamicFormWrapper"
    }
  }, [(_vm.defineInput === 1) ? _c('div', {
    attrs: {
      "id": "dynamicTextWrapper"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.defineId
    },
    domProps: {
      "innerHTML": _vm._s(_vm.inputName)
    }
  }), _c('input', {
    staticClass: "form-control",
    class: {
      'is-danger-dynamic': _vm.invalid
    },
    attrs: {
      "id": _vm.defineId,
      "name": _vm.defineId,
      "type": "text",
      "maxLength": "100"
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "~keyup": function($event) {
        return _vm.trackEvent.apply(null, arguments)
      }
    }
  })]) : (_vm.defineInput === 2) ? _c('div', {
    attrs: {
      "id": "dynamicNumberWrapper"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.defineId
    },
    domProps: {
      "innerHTML": _vm._s(_vm.inputName)
    }
  }), _c('input', {
    staticClass: "form-control",
    class: {
      'is-danger-dynamic': _vm.invalid
    },
    attrs: {
      "id": _vm.defineId,
      "name": _vm.defineId,
      "type": "number"
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "~keyup": function($event) {
        return _vm.trackEvent.apply(null, arguments)
      }
    }
  })]) : (_vm.defineInput === 3) ? _c('div', {
    attrs: {
      "id": "dynamicDateWrapper"
    }
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.inputName)
    }
  }), _c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('datepicker', {
    staticClass: "col-xs-6 date-picker-dynamic",
    class: {
      'is-danger-dynamic': _vm.invalid
    },
    attrs: {
      "id": _vm.defineId,
      "language": _vm.datePickerLanguage,
      "format": 'dd/MM/yyyy',
      "value": _vm.inputValue,
      "full-month-name": "full-month-name",
      "input-class": "date-picker",
      "wrapper-class": "datepicker-wrapper",
      "calendar-button": "calendar-button",
      "typeable": "typeable",
      "calendar-button-icon": "fa fa-calendar",
      "disabled-dates": {
        to: _vm.toDate,
        from: _vm.fromDate
      }
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.inputDate)
      },
      "~keyup": function($event) {
        return _vm.trackEvent.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputDate),
      callback: function($$v) {
        _vm.inputDate = $$v
      },
      expression: "inputDate"
    }
  })], 1)]) : (_vm.defineInput === 0) ? _c('div', {
    attrs: {
      "id": "dynamicNumberWrapper"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.defineId
    },
    domProps: {
      "innerHTML": _vm._s(_vm.inputName)
    }
  }), _c('the-mask', {
    staticClass: "form-control",
    class: {
      'is-danger-dynamic': _vm.invalid
    },
    attrs: {
      "id": _vm.defineId,
      "name": _vm.defineId,
      "mask": _vm.inputMask,
      "value": _vm.inputValue
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.inputMaskModel)
      },
      "~keyup": function($event) {
        return _vm.trackEvent.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputMaskModel),
      callback: function($$v) {
        _vm.inputMaskModel = $$v
      },
      expression: "inputMaskModel"
    }
  })], 1) : (_vm.defineInput === 4) ? _c('div', {
    attrs: {
      "id": "dynamicSelectWrapper"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.defineId
    },
    domProps: {
      "innerHTML": _vm._s(_vm.inputName)
    }
  }), _c('v-select', {
    attrs: {
      "value": _vm.inputValue,
      "options": _vm.inputTipoValores,
      "label": "valor",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "planSelected",
      "id": _vm.defineId,
      "name": _vm.defineId
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', _vm.inputValueSelect)
      }
    },
    model: {
      value: (_vm.inputValueSelect),
      callback: function($$v) {
        _vm.inputValueSelect = $$v
      },
      expression: "inputValueSelect"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invalid),
      expression: "invalid"
    }],
    staticClass: "col-xs-12 px-0"
  }, [_c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15fd6674", module.exports)
  }
}

/***/ }),
/* 1374 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-169f7ba6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/input/betterInputTag/betterInputTag.pug ***!
  \*****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "better-input-tag",
    class: {
      "full-radius": _vm.typeOnly,
      "possibilities-list-open": _vm.showingPossibilities && !_vm.typeOnly,
      "possibilities-list-closed": _vm.showingPossibilities && !_vm.typeOnly,
      "disable-input": _vm.disableInput
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.boxClicked.apply(null, arguments)
      }
    }
  }, [_vm._l((_vm.tags), function(tag, index) {
    return (_vm.tags.length > 0) ? _c('span', {
      class: _vm.paddingClass
    }, [_vm._v(_vm._s(tag[_vm.props.name])), (!_vm.readOnly && !_vm.disableInput) ? _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeTag(index)
        }
      }
    }, [_vm._v("x")]) : _vm._e()]) : _vm._e()
  }), _vm._l((_vm.defaultTagsIfEmpty), function(tag, index) {
    return (_vm.tags.length === 0 && _vm.defaultTagsIfEmpty.length > 0) ? _c('span', {
      staticClass: "full-padding"
    }, [_vm._v(_vm._s(tag[_vm.props.name]))]) : _vm._e()
  }), (_vm.inputExists) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tag),
      expression: "tag"
    }],
    attrs: {
      "placeholder": _vm.$t(_vm.placeHolders.input),
      "title": _vm.$t(_vm.placeHolders.input),
      "disabled": _vm.disableInput
    },
    domProps: {
      "value": (_vm.tag)
    },
    on: {
      "focus": _vm.showPossibilities,
      "blur": _vm.close,
      "keydown": _vm.handleKey,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tag = $event.target.value
      }
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showingPossibilities) ? _c('div', {
    staticClass: "possibilities-list col-md-12 px-0"
  }, _vm._l((_vm.possibilities), function(item, index) {
    return _c('div', {
      staticClass: "possibilities-list-item",
      class: item.__blocked ? "blocked" : _vm.highlightedIndex === index ? "highlighted" : "",
      on: {
        "mousedown": function($event) {
          return _vm.addTag(item)
        },
        "mouseover": function($event) {
          return _vm.handleMouse(item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item[_vm.props.name]))])])
  }), 0) : _vm._e()])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-169f7ba6", module.exports)
  }
}

/***/ }),
/* 1375 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-17392d8c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/integration/remittanceIntegration/tabRemittanceDetail.pug ***!
  \***********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "tab-remittance-detail"
    }
  }, [_c('div', {
    class: {
      'remittance-detail': _vm.showRemovalButton
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-10 margin-container"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.nomeArquivo'))
    }
  }), _c('h4', {
    staticClass: "detail-value break-all"
  }, [_vm._v(_vm._s(_vm.remittance.nomeArquivo))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.idRemessa'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.id))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.resultado'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.resultado.' + _vm.remittance.situacao)))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.usuario'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.usuario ? _vm.remittance.usuario.nome : '-'))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.conteudo'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.movFinanConfig.nome))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.sequencia'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.sequencia))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.periodoContabil'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.remittance.periodoContabil ? _vm.remittance.periodoContabil.anoMesFormatado : '-'))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataMovimentacaoInicial'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDate(_vm.remittance.dataMovimentoInicial)))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataMovimentacaoFinal'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDate(_vm.remittance.dataMovimentoFinal)))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataGeracaoArquivo'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDateFull(_vm.remittance.dataCriacao)))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.dataBase'))
    }
  }), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.handleDate(_vm.remittance.dataBase)))])])]), _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.remessa.detalhar.tab.observacao'))
    }
  }), _c('h4', {
    staticClass: "detail-value font-default"
  }, [_vm._v(_vm._s(_vm.remittance.observacao))])])])])]), (_vm.showRemovalButton) ? _c('div', {
    staticClass: "tab-footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('remessaIntegracao.titulos.excluirRemessa'),
      "id": "btnExcluirArquivo",
      "clickFunction": _vm.openModalConfirm
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17392d8c", module.exports)
  }
}

/***/ }),
/* 1376 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a206fcb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/conciliationCriteria/conciliationCriteria.pug ***!
  \*****************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-complete-item attribute row text-center"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "badge att-field order"
  }, [_vm._v(_vm._s(_vm.order))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "att-field description"
  }, [_vm._v(_vm._s(_vm.criteria.descricao))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "att-field status"
  }, [_vm._v(_vm._s(_vm.$t(_vm.criteria.ativo != null ? (_vm.criteria.ativo ? 'planoConciliacao.labels.ativo' : 'planoConciliacao.labels.inativo') : null)))])]), _c('div', {
    staticClass: "col-md-2 pull-right"
  }, [_c('div', {
    staticClass: "att-field buttons"
  }, [_c('button', {
    staticClass: "fa fa-pencil action",
    attrs: {
      "type": "button",
      "title": _vm.btnEditTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit(_vm.criteria)
      }
    }
  }), _c('button', {
    staticClass: "fa fa-times action",
    attrs: {
      "type": "button",
      "disabled": _vm.criteria.criterioEmUso,
      "title": _vm.btnRemoveTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleRemove(_vm.criteria)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a206fcb", module.exports)
  }
}

/***/ }),
/* 1377 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b8ade6c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/menu/sidebarMenu.pug ***!
  \*****************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu-lateral"
    }
  }, [_c('div', {
    staticClass: "page-sidebar",
    attrs: {
      "data-pages": "sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-overlay-slide from-top",
    attrs: {
      "id": "appMenu"
    }
  }), _c('div', {
    staticClass: "sidebar-header"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.home
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearSelectedMenuItem()
      }
    }
  })], 1), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('ul', [(_vm.isLoadingData) ? _c('li', {
    staticClass: "loading-functionalities"
  }, [_c('img', {
    attrs: {
      "src": _vm.loadingGif
    }
  })]) : _vm._l((_vm.functionalitiesGroup), function(grupo) {
    return _c('li', {
      class: {
        "active": grupo.active,
        "selected": grupo.selected
      },
      attrs: {
        "id": grupo.key
      }
    }, [_c('a', {
      staticClass: "group",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.groupClicked(grupo)
        }
      }
    }, [_c('div', {
      staticClass: "group-icon"
    }, [_c('i', {
      staticClass: "fa",
      class: grupo.icone
    })]), _c('p', {
      staticClass: "group-text"
    }, [_vm._v(_vm._s(grupo.text))])]), _c('ul', {
      staticClass: "group-options",
      class: grupo.selected ? "is-expanded" : "is-collapsed"
    }, [_c('span', {
      staticClass: "group-options-title"
    }, [_vm._v(_vm._s(grupo.text))]), _vm._l((grupo.funcionalidades), function(funcionalidade) {
      return _c('li', {
        class: {
          "active": funcionalidade.active
        }
      }, [_c('router-link', {
        attrs: {
          "to": funcionalidade.path
        },
        nativeOn: {
          "click": function($event) {
            return _vm.functClicked(funcionalidade, grupo)
          }
        }
      }, [_vm._v(_vm._s(funcionalidade.text))])], 1)
    })], 2)])
  })], 2)]), _c('div', {
    staticClass: "abrir-menu sidebar-bottom",
    attrs: {
      "data-toggle": "sidebar"
    },
    on: {
      "click": function($event) {
        return _vm.openCloseSidebarMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.isOpen ? "fa-chevron-left" : "fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b8ade6c", module.exports)
  }
}

/***/ }),
/* 1378 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6ea436"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabTasks/tabTasks.pug ***!
  \***********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-tasks-wrapper"
    }
  }, [(_vm.isLoadingTaskData) ? _c('div', {
    staticClass: "col-md-12 col-sm-10",
    attrs: {
      "id": "tasks-loading"
    }
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : (_vm.noTasksBonded) ? _c('div', [_c('div', {
    staticClass: "vertical-center loading-center"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_vm._m(0), _c('br'), _c('p', {
    staticClass: "big-txt-allotment",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.labels.msgNenhumaTarefa'))
    }
  }), (_vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "primary",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabTarefas.labels.iniciarTarefa'),
      "faIcon": "",
      "id": "btnTabLoteConcManual",
      "clickFunction": _vm.startTask,
      "customClass": "big-primary"
    }
  }) : _vm._e()], 1)])]) : (_vm.createEditTask) ? _c('div', {
    attrs: {
      "id": "create-edit-task-form"
    }
  }, [(!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-8"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTask.nome),
      expression: "currentTask.nome"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskName')
    },
    attrs: {
      "type": "text",
      "id": "taskName",
      "name": "taskName",
      "maxlength": "100",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.currentTask.nome)
    },
    on: {
      "change": function($event) {
        return _vm.setTask('nome', _vm.currentTask.nome)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTask, "nome", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('taskName', 'required')),
      expression: "errors.firstByRule('taskName', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.tipoVinculo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.tipoVinculo.nome),
      expression: "task.tipoVinculo.nome"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskType')
    },
    attrs: {
      "type": "text",
      "id": "taskType",
      "name": "taskType",
      "maxlength": "2",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.task.tipoVinculo.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task.tipoVinculo, "nome", $event.target.value)
      }
    }
  })])]) : _vm._e(), (!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskDes"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.descricao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTask.descricao),
      expression: "currentTask.descricao"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskDes')
    },
    attrs: {
      "type": "text",
      "id": "taskDes",
      "name": "taskDes",
      "maxlength": "1000",
      "rows": "2",
      "cols": "130"
    },
    domProps: {
      "value": (_vm.currentTask.descricao)
    },
    on: {
      "change": function($event) {
        return _vm.setTask('descricao', _vm.currentTask.descricao)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTask, "descricao", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('taskDes')),
      expression: "errors.has('taskDes')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]) : _vm._e(), (!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12 position-initial"
  }, [_c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituation"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.situacao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('task.situacao')
    },
    attrs: {
      "value": _vm.task.situacao,
      "options": _vm.tarefaStatuses,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "task.situacao",
      "id": "taskSituation",
      "name": "taskSituation",
      "disabled": _vm.task.id ? true : false
    },
    on: {
      "input": _vm.selectSituacao
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('task.situacao')),
      expression: "errors.has('task.situacao')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-3 position-initial"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.dtVencimento'))
    }
  }), _c('div', {
    staticClass: "col-xs-12 px-0 position-initial"
  }, [_c('datepicker', {
    ref: "dataVencimento",
    staticClass: "col-xs-12 date-picker-default",
    class: {
      'is-danger-dynamic': _vm.invalid,
      'is-danger': _vm.erroDataDeVencimento
    },
    attrs: {
      "id": "dataVencimento",
      "language": _vm.datePickerLanguage,
      "format": 'dd/MM/yyyy',
      "full-month-name": "full-month-name",
      "input-class": "input-date-picker",
      "wrapper-class": "datepicker-wrapper",
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "disabledDates": {
        to: _vm.toDate,
        from: _vm.fromDate
      },
      "typeable": "typeable",
      "vMaskPattern": "##/##/####"
    },
    on: {
      "input": _vm.dataDeVencimentoValida
    },
    model: {
      value: (_vm.task.dataVencimento),
      callback: function($$v) {
        _vm.$set(_vm.task, "dataVencimento", $$v)
      },
      expression: "task.dataVencimento"
    }
  })], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erroDataDeVencimento),
      expression: "erroDataDeVencimento"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefa.validacao.dtVencimentoInvalida'))
    }
  })]), _c('div', {
    staticClass: "form-group col-xs-5"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskResp"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.responsavel'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('task.responsavel')
    },
    attrs: {
      "options": _vm.operators,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "id": "taskResp",
      "name": "taskResp",
      "data-vv-name": "task.responsavel"
    },
    model: {
      value: (_vm.task.responsavel),
      callback: function($$v) {
        _vm.$set(_vm.task, "responsavel", $$v)
      },
      expression: "task.responsavel"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('task.responsavel')),
      expression: "errors.has('task.responsavel')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]) : _vm._e(), (!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.tipoMovimento != 'MovBan') ? _c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituationAuto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.autoConc'))
    }
  }), _c('v-select', {
    attrs: {
      "multiple": "multiple",
      "options": _vm.concilStatuses,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "task.situacao",
      "id": "taskSituationAuto",
      "name": "taskSituationAuto"
    },
    on: {
      "input": _vm.changeAutoConcludeList
    },
    model: {
      value: (_vm.task.conclusaoAutomatica),
      callback: function($$v) {
        _vm.$set(_vm.task, "conclusaoAutomatica", $$v)
      },
      expression: "task.conclusaoAutomatica"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.enviarEmail),
      expression: "task.enviarEmail"
    }],
    attrs: {
      "id": "checkEnviarEmail",
      "type": "checkbox",
      "name": "checkEnviarEmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.task.enviarEmail) ? _vm._i(_vm.task.enviarEmail, null) > -1 : (_vm.task.enviarEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.task.enviarEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.task, "enviarEmail", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.task, "enviarEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.task, "enviarEmail", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "enviar-e-mail-automa",
    attrs: {
      "for": "checkEnviarEmail"
    }
  }, [_vm._v(_vm._s(_vm.messageEmail))])])])])]) : _vm._e(), (_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.idMovimento === -1 || _vm.idMovimento === '-1') ? _c('div', {
    staticClass: "col-xs-12 warning-area"
  }, [_c('h4', {
    staticClass: "detail-allotment-value font-default warning-text"
  }, [_vm._v(_vm._s(_vm.hintNoMovment))])]) : _vm._e(), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colNome'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.nome))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colTipo'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.tipoVinculo.nome))])]), _c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colConclAuto'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.conclusoesAutomaticas))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colRes'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.responsavel.nome))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colData'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.task.dataVencimento)))])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.descricao))])])]) : _vm._e(), (_vm.task.historico) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.titulos.historicoAcoes'))
    }
  }), _c('div', {
    staticClass: "historicoTarefaFundo"
  }, _vm._l((_vm.task.historico), function(hist) {
    return _c('div', [_c('tree-view-historic', {
      attrs: {
        "model": hist,
        "father": hist,
        "id": hist.id.toString(),
        "buttonsTitle": _vm.treeViewButtonTitle
      }
    })], 1)
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), (_vm.showActionButtons) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(!_vm.canReopenTask && !_vm.isVisualisingTask && _vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.salvar'),
      "id": "btnCriarTarefaTabTasks",
      "clickFunction": _vm.validate,
      "disabled": _vm.disabledBtnSaveTask
    }
  }) : _vm._e(), (_vm.canReopenTask && _vm.isVisualisingTask && _vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabTarefas.labels.reabrir'),
      "id": "btnReabrirTarefaTabTasks",
      "clickFunction": _vm.reopenTask
    }
  }) : _vm._e(), (_vm.isVisualisingTask && _vm.canEditTask) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabTarefas.labels.editarTarefa'),
      "id": "btnEditarTarefaTabTasks",
      "clickFunction": _vm.manageTask
    }
  }) : _vm._e(), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.isVisualisingTask ? _vm.$t('login.labels.voltar') : _vm.$t('conjuntoAtributo.labels.cancelar'),
      "id": "btnFecharModalDetalhesTabTasks",
      "customClass": "secondary",
      "clickFunction": _vm.isVisualisingTask || !_vm.task.id ? _vm.cancelManagement : _vm.goBack
    }
  })], 1) : _vm._e()]) : (_vm.withTaskBonded) ? _c('div', {
    staticClass: "px-0",
    staticStyle: {
      "padding-top": "21px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-9 px-0"
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.taskDetailsHeaderTitle)
    }
  })]), _c('div', {
    staticClass: "col-xs-3 pull-right"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.taskDetailsHeaderButton,
      "id": "btnCriarTarefaTabTasks",
      "clickFunction": _vm.viewOldTask
    }
  })], 1)]), (_vm.hasActiveTask && _vm.activeTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colNome'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.nome))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colTipo'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.tipoVinculo.nome))])]), _c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colConclAuto'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.conclusoesAutomaticas))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    staticStyle: {
      "margin-bottom": "0px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colRes'))
    }
  }), _c('tr', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    }
  }, [_c('td', [_c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.responsavel.nome))])]), (_vm.canAssignToTask) ? _c('td', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [(_vm.canPerformTaskAction) ? _c('button-primary', {
    staticStyle: {
      "min-width": "22px",
      "padding": "0px",
      "margin": "0px"
    },
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabTarefas.labels.assumirTarefa'),
      "faIcon": "fa fa-exchange",
      "id": "btnAssumirTarefaTabTarefas",
      "clickFunction": _vm.assignTaskToLoggedUser
    }
  }) : _vm._e()], 1) : _vm._e()])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colData'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.dueDateFormatted))])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.descricao))])])]) : _vm._e(), (_vm.hasActiveTask && _vm.canPerformTaskAction) ? _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "ocurrence-task-form"
    }
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.titulos.atualizarStatus'))
    }
  }), _c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituation"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.situacao'))
    }
  }), _c('v-select', {
    attrs: {
      "options": _vm.tarefaStatuses,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "taskOcurrence.situacao",
      "id": "taskSituation",
      "name": "taskSituation"
    },
    on: {
      "input": _vm.onSituationChanged
    },
    model: {
      value: (_vm.taskOcurrence.situacao),
      callback: function($$v) {
        _vm.$set(_vm.taskOcurrence, "situacao", $$v)
      },
      expression: "taskOcurrence.situacao"
    }
  })], 1), _c('div', {
    staticClass: "col-md-8 col-sm-8 col-xs-11"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskDes"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'))
    }
  })]), _c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskOcurrence.observacaoHistorico),
      expression: "taskOcurrence.observacaoHistorico"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskDes')
    },
    attrs: {
      "type": "text",
      "id": "taskDes",
      "name": "taskDes",
      "maxlength": "4000",
      "rows": "2",
      "cols": "130"
    },
    domProps: {
      "value": (_vm.taskOcurrence.observacaoHistorico)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.taskOcurrence, "observacaoHistorico", $event.target.value)
      }, _vm.onDescriptionChanged]
    }
  })]), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [(_vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabTarefas.labels.salvarOcorrencia'),
      "faIcon": "fa fa-check",
      "disabled": _vm.disabledBtnChangeStatusTask,
      "id": "btnSalvarOcorrenciaTarefa",
      "clickFunction": _vm.updateTaskStatus
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.titulos.historicoTarefas'))
    }
  }), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.taskHistory,
      "columns": _vm.columns,
      "options": _vm.options,
      "name": "histTarefas"
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [_c('button', {
          staticClass: "fa fa-eye action table-icon",
          attrs: {
            "title": _vm.tipAcaoDetalhes
          },
          on: {
            "click": function($event) {
              return _vm.viewOldTask(props.row)
            }
          }
        })]
      }
    }])
  })], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "id": "video-player",
      "loop": "loop",
      "autoplay": "autoplay"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3-sa-east-1.amazonaws.com/midias-banking/Tarefas.mp4",
      "type": "video/mp4"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d6ea436", module.exports)
  }
}

/***/ }),
/* 1379 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e61ffba"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/manualConciliation/manualConciliation.pug ***!
  \*********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "manualConciliationWrapper"
    }
  }, [(_vm.isLoadingDataActionsManualConciliation) ? _c('div', {
    class: [_vm.isLoadingDataActionsManualConciliationStatic ? 'isLoadingManualConciliationActionsStatic' : 'isLoadingManualConciliationActions']
  }, [(!_vm.isLoadingDataActionsManualConciliationStatic) ? _c('span', {
    staticClass: "spanLoading",
    attrs: {
      "id": "spin",
      "data-content": _vm.getKeyTranslated('conciliacaoManual.labels.emProcessamento'),
      "data-content2": _vm.getKeyTranslated('conciliacaoManual.labels.aguarde')
    }
  }) : _vm._e(), (_vm.isLoadingDataActionsManualConciliationStatic) ? _c('span', {
    staticClass: "spanLoading",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.aguarde'))
    }
  }) : _vm._e()]) : _vm._e(), (_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), (_vm.shown.categories) ? _c('multi-select-modal', {
    attrs: {
      "id": "categoriesModal",
      "data": _vm.data.categories
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('modal', {
    attrs: {
      "id": "detalhesLoteConcManual",
      "closeFunction": _vm.closeAllotmentDetailsModal,
      "closable": "true",
      "bodyClass": "tabbed-modal-body"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modalAllotmentDetails.title)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modalAllotmentDetails.subtitle)
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('tab-allotment', {
    ref: "tabAllotmentManualConcilModal",
    attrs: {
      "dadosLote": _vm.allotmentDetailsModalObj
    }
  })], 1)]), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('conciliacaoManual.titulos.titulo'),
      "subTitle": _vm.$t('conciliacaoManual.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('conciliacaoManual.titulos.filtro')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), (false) ? _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "selectPlan"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('movimentosFinanceiros.labels.planosConciliacao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.errors.has('planSelected')
    },
    attrs: {
      "disabled": _vm.disableSelectPlan,
      "options": _vm.plans,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "planSelected",
      "id": "selectPlan",
      "name": "selectPlan"
    },
    on: {
      "input": _vm.selectPlan
    },
    model: {
      value: (_vm.planSelected),
      callback: function($$v) {
        _vm.planSelected = $$v
      },
      expression: "planSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('planSelected', 'required')),
      expression: "errors.firstByRule('planSelected', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "value": true,
      "color": {
        "checked": "#40b9bb",
        "unchecked": "#E5E5E5"
      },
      "height": 20,
      "width": 40
    },
    on: {
      "change": _vm.resetFilter
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.pesquisaAvancada'))
    }
  })], 1)]), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankAccountsSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('relatorioConciliacao.labels.selecaoContaBancaria'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarContasBancarias-ConciliacaoManual",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])]), _c('input-establishment', {
    attrs: {
      "id": "establishmentsFilterManualConciliation",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "categorieSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.titulos.titulo'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.categories.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.categories,
      "props": _vm.inputTagsProps.categories
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.categories, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('categoria.labels.selecionarCategoria'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarCategorias-RelatorioDeConciliacao",
      "clickFunction": _vm.openSelectCategoriesModal
    }
  })], 1)])])], 1) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTabs),
      expression: "showTabs"
    }],
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('vue-tabs', {
    attrs: {
      "id": "tab-navigation"
    },
    on: {
      "tab-change": _vm.loadAllotments
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-conciliacoes-pendentes",
      "title": _vm.$t('conciliacaoManual.titulos.abaLancamentos')
    }
  }, [_c('pending-conciliations', {
    ref: "pendingConciliationsBox",
    attrs: {
      "id": "pendingConciliationsBox",
      "resultMov": _vm.resultMov,
      "resultExt": _vm.resultExt,
      "treeGridCfgMov": _vm.treeGridCfgMov,
      "treeGridCfgExt": _vm.treeGridCfgExt,
      "showTreegridMov": _vm.showTreegridMov,
      "showTreegridExt": _vm.showTreegridExt
    }
  })], 1), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-lotes",
      "title": _vm.$t('conciliacaoManual.titulos.abaLotes')
    }
  }, [_c('allotment', {
    ref: "allotmentsBox",
    attrs: {
      "resultLot": _vm.resultLot,
      "treeGridCfgLot": _vm.treeGridCfgLot,
      "showTreegridLot": _vm.showTreegridLot
    }
  })], 1)], 1)], 1), _c('filter-portlet', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTabs),
      expression: "showTabs"
    }],
    staticClass: "row-filter-big",
    attrs: {
      "showHeader": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('selected-entries', {
    ref: "selectedEntries"
  })], 1)])], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e61ffba", module.exports)
  }
}

/***/ }),
/* 1380 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d119ba"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/establishments/move.pug ***!
  \********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('move-establishment-modal'), _c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('estabelecimentos.labels.estabelecimentos'),
      "subTitle": _vm.$t('estabelecimentos.labels.cadastre')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('estabelecimentos.labels.moverEstabelecimento')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentOriginSelector"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.estabelecimentoOrigem'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishmentOriginSelector')
    },
    attrs: {
      "id": "establishmentOriginSelector",
      "name": "establishmentOriginSelector",
      "value": "id",
      "label": "nome",
      "placeholder": _vm.$t('estabelecimentos.labels.filtro.buscar'),
      "options": _vm.establishmentList
    },
    on: {
      "search": _vm.loadEstablishments
    },
    nativeOn: {
      "change": function($event) {
        return _vm.handleClearList.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(((option.nome !== null ? option.nome : '') + " - " + (option.cnpj !== null ? option.cnpj : '')))
          }
        })]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(((option.nome !== null ? option.nome : '') + " - " + (option.cnpj !== null ? option.cnpj : '')))
          }
        })]
      }
    }]),
    model: {
      value: (_vm.establishmentOrigin),
      callback: function($$v) {
        _vm.establishmentOrigin = $$v
      },
      expression: "establishmentOrigin"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentOriginSelector')),
      expression: "errors.has('establishmentOriginSelector')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentDestinySelector"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.estabelecimentoDestino'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishmentDestinySelector')
    },
    attrs: {
      "id": "establishmentDestinySelector",
      "name": "establishmentDestinySelector",
      "value": "id",
      "label": "nome",
      "placeholder": _vm.$t('estabelecimentos.labels.filtro.buscar'),
      "options": _vm.establishmentList
    },
    on: {
      "search": _vm.loadEstablishments
    },
    nativeOn: {
      "change": function($event) {
        return _vm.handleClearList.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(((option.nome !== null ? option.nome : '') + " - " + (option.cnpj !== null ? option.cnpj : '')))
          }
        })]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(((option.nome !== null ? option.nome : '') + " - " + (option.cnpj !== null ? option.cnpj : '')))
          }
        })]
      }
    }]),
    model: {
      value: (_vm.establishmentDestiny),
      callback: function($$v) {
        _vm.establishmentDestiny = $$v
      },
      expression: "establishmentDestiny"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentDestinySelector')),
      expression: "errors.has('establishmentDestinySelector')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.establishmentOrigin != null && _vm.establishmentDestiny != null && _vm.establishmentOrigin.id == _vm.establishmentDestiny.id),
      expression: "establishmentOrigin != null && establishmentDestiny != null && establishmentOrigin.id == establishmentDestiny.id"
    }],
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.origemDestinoIguais'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.excluirEstabelecimentoOrigem'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deleteEstablishmentOrigin')),
      expression: "errors.has('deleteEstablishmentOrigin')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteEstablishmentOrigin),
      expression: "deleteEstablishmentOrigin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "yes",
      "name": "deleteEstablishmentOrigin"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.deleteEstablishmentOrigin, true)
    },
    on: {
      "change": function($event) {
        _vm.deleteEstablishmentOrigin = true
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "yes"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.sim'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteEstablishmentOrigin),
      expression: "deleteEstablishmentOrigin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "no",
      "name": "deleteEstablishmentOrigin"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.deleteEstablishmentOrigin, false)
    },
    on: {
      "change": function($event) {
        _vm.deleteEstablishmentOrigin = false
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "no"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nao'))
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t("estabelecimentos.labels.mover"),
      "id": "btnMoverEstabelecimento",
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t("estabelecimentos.labels.cancelar"),
      "id": "btnVoltarMoverEstabelecimento",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])])])])], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23d119ba", module.exports)
  }
}

/***/ }),
/* 1381 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-248a974b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/notification/Notification.vue ***!
  \************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-248a974b", module.exports)
  }
}

/***/ }),
/* 1382 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-265147fb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/administration/auditLog/auditModal.pug ***!
  \****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "id": "auditModal",
      "closable": "true"
    }
  }, [_c('div', {
    staticClass: "printable",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.titulo'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.subtitulo'))
    }
  })]), _c('div', {
    staticClass: "printable",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.nomeUsuario'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.userName))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.login'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.login))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.perfilAcesso'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.accessProfile))])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.funcionalidade'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.functionality))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.transacaoRealizada'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.transaction))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.dataTransacao'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.transactionDate))])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.ipAcesso'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.ip))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.estacaoTrabalho'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.workStation))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.entidade'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.entity))])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "modal-auditoria-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalLogAuditoria.idEntidade'))
    }
  }), _c('p', {
    staticClass: "modal-auditoria-left-txt"
  }, [_vm._v(_vm._s(_vm.entityId))])])]), _c('br'), _c('div', {
    staticClass: "col-md-12 col-sm-12 tree-view"
  }, [_c('ul', {
    attrs: {
      "id": "treeView"
    }
  }, [_c('li')])])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-print', {
    staticClass: "pull-right"
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('dataTable.labels.acaoFechar'),
      "customClass": "secondary",
      "id": "btnFecharModalLogsDeAuditoria",
      "clickFunction": _vm.closeModal
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-265147fb", module.exports)
  }
}

/***/ }),
/* 1383 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-28cf8108"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/bankBalance/bankBalance.pug ***!
  \*******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bankStatementWrapper"
    }
  }, [(_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts,
      "groups": _vm.groups,
      "groupingOptions": _vm.groupingOptions
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('saldoBancario.titulos.saldoBancario'),
      "subTitle": _vm.$t('saldoBancario.titulos.visualize')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('saldoBancario.titulos.filtroTitulo')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 121,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('saldoBancario.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('saldoBancario.labels.selecionarContasBancarias'),
      "id": "btnSelecionarContasBancarias",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "SaldoConta",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "saldoBancario",
      "treeGridLayoutPath": "bankBalance",
      "showMassTaskAction": false,
      "showAlert": true,
      "alertMessage": _vm.$t('saldoBancario.labels.alertaGrid'),
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28cf8108", module.exports)
  }
}

/***/ }),
/* 1384 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9b0864"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/massDeclassifyModal/massDeclassifyModal.pug ***!
  \****************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('confirm-modal', {
    attrs: {
      "id": "confirmDeclassifyMass"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('desclassificacaoEmMassa.labels.confirmacao'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('desclassificacaoEmMassa.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharConfirmacaoDesclassificar",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('desclassificacaoEmMassa.labels.sim'),
      "id": "btnConfirmacaoModalDesclassificar",
      "clickFunction": _vm.validateD
    }
  })], 1)]), _c('modal', {
    attrs: {
      "id": _vm.id,
      "closeFunction": _vm.trackCloseEvent
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modalTitle)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modalSubtitle)
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingData),
      expression: "isLoadingData"
    }],
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "loadingData"
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoadingData),
      expression: "!isLoadingData"
    }]
  }, [_c('h4', {
    staticClass: "declassify-title",
    staticStyle: {
      "margin-top": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.portletForm)
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-6 px-0"
  })]), _c('h4', {
    staticClass: "declassify-title",
    domProps: {
      "innerHTML": _vm._s(_vm.portletTable)
    }
  }), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.items,
      "columns": _vm.columns,
      "options": _vm.options,
      "name": "lancSelecionados"
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [_c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-times action",
          staticStyle: {
            "color": "black"
          },
          attrs: {
            "title": _vm.$t('desclassificacaoEmMassa.labels.removerLancamento')
          },
          on: {
            "click": function($event) {
              return _vm.removeEntry(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('desclassificacaoEmMassa.labels.desclassificar'),
      "id": "btnDeclassificarLancEmMassa",
      "clickFunction": _vm.openModalConfirm,
      "disabled": !_vm.enableSave,
      "title": !_vm.enableSave ? _vm.$t('desclassificacaoEmMassa.labels.desclassificarInvalido') : ''
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('desclassificacaoEmMassa.labels.fechar'),
      "id": "btnFecharModalDesclassificarEmMassa",
      "customClass": "secondary",
      "clickFunction": _vm.trackCloseEvent
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a9b0864", module.exports)
  }
}

/***/ }),
/* 1385 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2afc8021"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/operator/new.pug ***!
  \***************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('administracao.operadores.titulos.operadores'),
      "subTitle": _vm.$t('administracao.operadores.titulos.cadastroSubTitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.filterPortletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operatorName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.operadores.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operator.name),
      expression: "operator.name"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('operatorName')
    },
    attrs: {
      "type": "text",
      "id": "operatorName",
      "name": "operatorName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.operator.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operator, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('operatorName')),
      expression: "errors.has('operatorName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operatorEmail"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.operadores.labels.email'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          email: true
        }
      }),
      expression: "{ rules: {required: true, email: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operator.email),
      expression: "operator.email"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('operatorEmail')
    },
    attrs: {
      "type": "text",
      "id": "operatorEmail",
      "name": "operatorEmail"
    },
    domProps: {
      "value": (_vm.operator.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.operator, "email", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('operatorEmail', 'email')),
      expression: "errors.firstByRule('operatorEmail', 'email')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.emailInvalido'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('operatorEmail', 'required')),
      expression: "errors.firstByRule('operatorEmail', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operatorAccessProfile"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.operadores.labels.perfilAcesso'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('operator.accessProfile')
    },
    attrs: {
      "options": _vm.profileList,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "operator.accessProfile",
      "id": "operatorAccessProfile",
      "name": "operatorAccessProfile"
    },
    on: {
      "input": _vm.setOperatorProfile
    },
    model: {
      value: (_vm.operator.accessProfile),
      callback: function($$v) {
        _vm.$set(_vm.operator, "accessProfile", $$v)
      },
      expression: "operator.accessProfile"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('operator.accessProfile', 'required')),
      expression: "errors.firstByRule('operator.accessProfile', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabHistorico.labels.status'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operator.status),
      expression: "operator.status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "active"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.operator.status, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.operator, "status", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "active"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.operadores.labels.ativo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.operator.status),
      expression: "operator.status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "inactive"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.operator.status, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.operator, "status", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inactive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.operadores.labels.inativo'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.salvar'),
      "id": "btnSalvarOperador",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.cancelar'),
      "id": "btnVoltarNovoOperador",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2afc8021", module.exports)
  }
}

/***/ }),
/* 1386 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0b37d6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonPrint/buttonPrint.pug ***!
  \*************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalLogAuditoria.imprimir'),
      "id": "btnImprimirDetalhes",
      "clickFunction": _vm.print
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b0b37d6", module.exports)
  }
}

/***/ }),
/* 1387 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0e21fa"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/conciliationCriteria/newConciliationCriteria.pug ***!
  \********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.novoCriterio'),
      "subTitle": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.novoCriterioInfo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.novoCriterioPortlet')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.criteriaConcil.criterioEmUso),
      expression: "criteriaConcil.criterioEmUso"
    }],
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon alert-icon"
  }), _c('span', {
    staticClass: "alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.validacao.criterioConcilEmUsoEditar'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.detalheCriterio'))
    }
  }), _c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "concilDesc"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricaoCriterio'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.descricao),
      expression: "criteriaConcil.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "concilDesc",
      "name": "concilDesc",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.criteriaConcil.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteriaConcil, "descricao", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('concilDesc', 'required')),
      expression: "errors.firstByRule('concilDesc', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.ativo),
      expression: "criteriaConcil.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "concilStatus",
      "id": "concilActive"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.criteriaConcil.ativo, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteriaConcil, "ativo", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "concilActive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.ativo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.ativo),
      expression: "criteriaConcil.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "concilStatus",
      "id": "concilInactive"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.criteriaConcil.ativo, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteriaConcil, "ativo", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "concilInactive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.inativo'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.abrangencia'))
    }
  }), _c('br'), _c('input-establishment', {
    attrs: {
      "id": "establishmentsFilter",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments,
      "disabled": _vm.criteriaConcil.criterioEmUso
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "diasMinimo"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.diasMinimo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.diasDiferencaMin),
      expression: "criteriaConcil.diasDiferencaMin"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "number",
      "id": "diasMinimo",
      "name": "diasMinimo",
      "oninput": "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);",
      "onkeydown": "return event.keyCode !== 69 && event.keyCode !== 187 && event.keyCode !== 189 && event.keyCode !== 109 && event.keyCode !== 107 && event.keyCode !== 106 && event.keyCode !== 111",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.criteriaConcil.diasDiferencaMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteriaConcil, "diasDiferencaMin", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('diasMinimo', 'required')),
      expression: "errors.firstByRule('diasMinimo', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "diasMaximo"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.diasMaximo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteriaConcil.diasDiferencaMax),
      expression: "criteriaConcil.diasDiferencaMax"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "number",
      "id": "diasMaximo",
      "name": "diasMaximo",
      "oninput": "javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);",
      "onkeydown": "return event.keyCode !== 69 && event.keyCode !== 187 && event.keyCode !== 189 && event.keyCode !== 109 && event.keyCode !== 107 && event.keyCode !== 106 && event.keyCode !== 111",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "maxlength": "3"
    },
    domProps: {
      "value": (_vm.criteriaConcil.diasDiferencaMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteriaConcil, "diasDiferencaMax", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('diasMaximo', 'required')),
      expression: "errors.firstByRule('diasMaximo', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('br'), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "valorDiferenca"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.valorDiferenca'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('money', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "valorDiferenca",
      "name": "valorDiferenca",
      "maxlength": 14,
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "onkeydown": "$event.key === '-' ? $event.preventDefault() : null"
    },
    model: {
      value: (_vm.criteriaConcil.valorDiferencaMax),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "valorDiferencaMax", $$v)
      },
      expression: "criteriaConcil.valorDiferencaMax"
    }
  }, 'money', _vm.moneyMask, false)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('valorDiferenca', 'required')),
      expression: "errors.firstByRule('valorDiferenca', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "valorDivergencia"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.valorDivergencia'))
    }
  }), _c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "valorDivergencia",
      "name": "valorDivergencia",
      "maxlength": 14,
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "onkeydown": "$event.key === '-' ? $event.preventDefault() : null"
    },
    model: {
      value: (_vm.criteriaConcil.valorDivergenciaMax),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "valorDivergenciaMax", $$v)
      },
      expression: "criteriaConcil.valorDivergenciaMax"
    }
  }, 'money', _vm.moneyMask, false))], 1)]), _c('br'), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReason"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.motivoOcorrencia'))
    }
  }), _c('v-select', {
    key: "occurrenceReason",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.occurrenceReasons,
      "id": "occurrenceReason",
      "name": "occurrenceReason",
      "data-vv-name": "criteriaConcil.motivoOcorrencia",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "label": "descricao"
    },
    model: {
      value: (_vm.criteriaConcil.motivoOcorrencia),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "motivoOcorrencia", $$v)
      },
      expression: "criteriaConcil.motivoOcorrencia"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "criteriaConcilBank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.banco'))
    }
  }), _c('v-select', {
    key: "criteriaConcilBank",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.banks,
      "id": "critBank",
      "name": "critBank",
      "data-vv-name": "criteriaConcil.banco",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    on: {
      "input": _vm.changeCritBank
    },
    model: {
      value: (_vm.criteriaConcil.banco),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "banco", $$v)
      },
      expression: "criteriaConcil.banco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "criteriaConcilAccount"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conta'))
    }
  }), _c('v-select', {
    key: "criteriaConcilAccount",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.filteredAccounts,
      "id": "critAccount",
      "name": "critAccount",
      "data-vv-name": "criteriaConcil.conta",
      "disabled": _vm.criteriaConcil.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    model: {
      value: (_vm.criteriaConcil.conta),
      callback: function($$v) {
        _vm.$set(_vm.criteriaConcil, "conta", $$v)
      },
      expression: "criteriaConcil.conta"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('br')], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.campoAplicacao'))
    }
  }), _c('button-primary', {
    staticClass: "marged-button",
    attrs: {
      "title": _vm.$t('planoConciliacao.labels.adicionar'),
      "faIcon": "fa fa-plus",
      "id": "btnAddCampoConciliacao",
      "clickFunction": _vm.addConciliationField,
      "disabled": _vm.criteriaConcil.criterioEmUso
    }
  }), _c('br'), _vm._l((_vm.criteriaConcil.conciliacaoCampos), function(field) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('conciliation-crit-field', {
      key: 'critConcilField' + field.key != undefined && field.key != null ? field.key : field.id,
      ref: 'critConcilField' + field.key != undefined && field.key != null ? field.key : field.id,
      refInFor: true,
      attrs: {
        "id": 'critConcilField' + field.key != undefined && field.key != null ? field.key : field.id,
        "conciliationField": field,
        "disabled": _vm.criteriaConcil.criterioEmUso,
        "mfFieldList": _vm.mfFieldList,
        "mbFieldList": _vm.mbFieldList,
        "attributesCfgMfList": _vm.attributesCfgMfList,
        "attributesMfList": _vm.attributesMfList,
        "conciliationFieldList": _vm.criteriaConcil.conciliacaoCampos
      },
      on: {
        "remove-field-from-criteria-concil": _vm.removeConciliationField,
        "change-conc-field-cfg-mf": _vm.changeFieldAttCfgMf,
        "change-conc-field-att-name-mf": _vm.changeFieldAttNameMf,
        "change-conc-field-mf": _vm.changeFieldAttConciliationFieldMf,
        "change-conc-field-mb": _vm.changeFieldAttConciliationFieldMb,
        "update-attributes-list": _vm.updateAttibutesList
      }
    })], 1)
  })], 2)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.adicionar'),
      "id": "btnAddCriterioComciliacao",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.voltar'),
      "id": "btnRetornaEdicaoPlanoConcil",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmDivergMax"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.modalConfirmaDivergenciaMaxNula'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.modalOpcaoCancelar'),
      "customClass": "secondary",
      "id": "btnFecharModalConfirmaMaxDivergenciaNula",
      "clickFunction": _vm.closeModal
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-button",
    attrs: {
      "label": _vm.$t('planoConciliacao.titulos.criteriosConciliacao.modalOpcaoConfirmar'),
      "id": "btnConfirmarModalConfirmaMaxDivergenciaNula",
      "clickFunction": _vm.confirmAdd
    }
  })], 1)])], 1)])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b0e21fa", module.exports)
  }
}

/***/ }),
/* 1388 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be5b59b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/duplicateMovementsAnalysis/annulledMovements.pug ***!
  \**********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "annulledMovements"
    }
  }, [(_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row pt-5"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankAccountsSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('analiseDuplicidade.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('analiseDuplicidade.labels.selecionarContasBancarias'),
      "id": "btnSelecionarContasBancarias-AnaliseDuplicidade",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-small mr-0 pb-5"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.buscar'),
      "id": "btnBuscarAnulado",
      "clickFunction": _vm.validate,
      "disabled": _vm.disableSearchButton
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2be5b59b", module.exports)
  }
}

/***/ }),
/* 1389 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d3a6a80"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/dashboard/chartFilter/AllotmentDistributionConciliation.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('filters-common', {
    attrs: {
      "data": _vm.filters
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d3a6a80", module.exports)
  }
}

/***/ }),
/* 1390 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dcfce74"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/justifications.pug ***!
  \***********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "justifications"
    }
  }, [(this.arrayJustify.length > 0) ? _c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.justifications,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [_c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-times action",
          staticStyle: {
            "color": "#4a4a4a"
          },
          on: {
            "click": function($event) {
              return _vm.removeJustify(props.row)
            }
          }
        })])]
      }
    }], null, false, 1653133628)
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2dcfce74", module.exports)
  }
}

/***/ }),
/* 1391 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de24fd3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/attributesSet/list.pug ***!
  \*******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('conjuntoAtributo.titulos.titulo'),
      "subTitle": _vm.$t('conjuntoAtributo.titulos.subtitulo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('conjuntoAtributo.labels.novoConjunto'),
      "id": "btnCriarNovoConjuntoAtributo",
      "clickFunction": _vm.newAttribute,
      "title": _vm.attributesSet && _vm.attributesSet.length == _vm.linkTypes.length ? _vm.$t('conjuntoAtributo.labels.cadastroBloquado') : _vm.$t('conjuntoAtributo.labels.cadastro'),
      "disabled": !_vm.canCreate
    },
    slot: "new-button"
  }), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    attrs: {
      "id": "attributesSet"
    }
  }, [(_vm.attributesSet && _vm.attributesSet.length > 0) ? _c('div', [_c('div', {
    staticClass: "categories-header att-header"
  }, [_c('div', {
    staticClass: "categories-header-column-left col-xs-3 col-sm-3 col-md-3 col-lg-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.nome'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipoVinculo'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-4 col-lg-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.quantidadeAtributos'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-xs-4 col-sm-2 col-md-1 col-lg-1"
  }, [_c('div', {
    staticClass: "categories-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _vm._l((_vm.attributesSet), function(attributeSet) {
    return _c('div', [_c('vue-drag-tree', {
      staticClass: "vue-drag-tree",
      attrs: {
        "model": attributeSet,
        "clickFunction": _vm.createEditAttribute,
        "clickRemoveFunction": _vm.handleRemove,
        "showRemove": true,
        "father": attributeSet,
        "id": attributeSet.id,
        "buttonsTitle": _vm.treeViewButtonTitle,
        "current-highlight": false,
        "default-text": null,
        "hover-color": "lightblue"
      }
    }), _c('div', {
      staticClass: "clear"
    })], 1)
  })], 2) : _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.resultadoVazio'))
    }
  })])])], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveAttSet"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverPlan",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverAttCfg",
      "clickFunction": _vm.removeAttSet
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2de24fd3", module.exports)
  }
}

/***/ }),
/* 1392 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8324c6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonSearch/buttonSearch.pug ***!
  \***************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-primary', {
    staticClass: "search-button pull-right",
    attrs: {
      "id": "search-button",
      "label": _vm.$t("logDeAuditoria.labels.buscar"),
      "disabled": _vm.isDisabled,
      "type": "submit"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e8324c6", module.exports)
  }
}

/***/ }),
/* 1393 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-30421256"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/gadget/taskGadget.pug ***!
  \*********************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gadgetTasks"
  }, [(_vm.isLoadingDataTaskGadget) ? _c('div', {
    staticClass: "loadingData"
  }) : _c('vue-tabs', {
    attrs: {
      "id": "tab-navigation",
      "centered": "centered"
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-tarefas-pendentes-dashboard",
      "title": _vm.$t("estatistica.tarefa.labels.naoConcluida"),
      "icon": "fa fa-clock-o fa-task-gadget"
    }
  }, [(_vm.hasData.tarefasPendentes) ? _c('task-gadget-tab-content', {
    attrs: {
      "data": _vm.data,
      "quantidadeMovFin": _vm.data.quantidadePendenteMovFin,
      "quantidadeMovBan": _vm.data.quantidadePendenteMovBan,
      "totalQuantidade": _vm.data.totalQuantidadePendente,
      "isPendentTab": true
    }
  }) : _vm._e(), _c('div', {
    staticClass: "clear"
  })], 1), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-tarefas-conciliadas-dashboard",
      "title": _vm.$t("estatistica.tarefa.labels.concluida"),
      "icon": "fa fa-check fa-task-gadget"
    }
  }, [(_vm.hasData.tarefasConciliadas) ? _c('task-gadget-tab-content', {
    attrs: {
      "data": _vm.data,
      "quantidadeMovFin": _vm.data.quantidadeConcluidaMovFin,
      "quantidadeMovBan": _vm.data.quantidadeConcluidaMovBan,
      "totalQuantidade": _vm.data.totalQuantidadeConcluida,
      "isPendentTab": false
    }
  }) : _vm._e(), _c('div', {
    staticClass: "clear"
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30421256", module.exports)
  }
}

/***/ }),
/* 1394 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-30c3725a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/login/TrocaAplicacao.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30c3725a", module.exports)
  }
}

/***/ }),
/* 1395 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-33983fa4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/massTaskModal/massTaskModal.pug ***!
  \****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('confirm-modal', {
    attrs: {
      "id": "confirmMassTask"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.tarefasMistas'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharConfirmacaoTarefasMistas",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmacaoModalCreateRemittance",
      "clickFunction": _vm.validate
    }
  })], 1)]), _c('modal', {
    attrs: {
      "id": _vm.id,
      "closeFunction": _vm.trackCloseEvent
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modalTitle)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modalSubtitle)
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingData),
      expression: "isLoadingData"
    }],
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "loadingData"
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoadingData),
      expression: "!isLoadingData"
    }]
  }, [_c('h4', {
    staticClass: "task-title",
    staticStyle: {
      "margin-top": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.portletForm)
    }
  }), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-8 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.task.nome),
      expression: "task.nome"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskName')
    },
    attrs: {
      "type": "text",
      "id": "taskName",
      "name": "taskName",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.task.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "nome", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('taskName', 'required')),
      expression: "errors.firstByRule('taskName', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "form-group col-xs-4 pr-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.tipoVinculo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.tipoVinculo.descricao),
      expression: "task.tipoVinculo.descricao"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskType')
    },
    attrs: {
      "type": "text",
      "id": "taskType",
      "name": "taskType",
      "maxlength": "2",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.task.tipoVinculo.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task.tipoVinculo, "descricao", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 pl-0 pr-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskDes"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.descricao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.task.descricao),
      expression: "task.descricao"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskDes')
    },
    attrs: {
      "type": "text",
      "id": "taskDes",
      "name": "taskDes",
      "maxlength": "1000",
      "rows": "2",
      "cols": "130"
    },
    domProps: {
      "value": (_vm.task.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "descricao", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('taskDes')),
      expression: "errors.has('taskDes')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituation"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.situacao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('task.situacao')
    },
    attrs: {
      "options": _vm.tarefaStatuses,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "task.situacao",
      "id": "taskSituation",
      "name": "taskSituation"
    },
    model: {
      value: (_vm.task.situacao),
      callback: function($$v) {
        _vm.$set(_vm.task, "situacao", $$v)
      },
      expression: "task.situacao"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('task.situacao')),
      expression: "errors.has('task.situacao')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.dtVencimento'))
    }
  }), _c('datepicker', {
    ref: "dtVencimento",
    staticClass: "col-xs-12 date-picker-default",
    class: {
      'is-danger-dynamic': _vm.invalid,
      'is-danger': _vm.erroDataDeVencimento
    },
    attrs: {
      "id": "dtVencimento",
      "language": _vm.datePickerLanguage,
      "format": 'dd/MM/yyyy',
      "full-month-name": "full-month-name",
      "input-class": "input-date-picker",
      "wrapper-class": "datepicker-wrapper",
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "disabledDates": {
        to: _vm.toDate,
        from: _vm.fromDate
      },
      "typeable": "typeable",
      "vMaskPattern": "##/##/####"
    },
    on: {
      "input": _vm.input,
      "~keyup": function($event) {
        return _vm.trackEvent.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.task.dtVencimento),
      callback: function($$v) {
        _vm.$set(_vm.task, "dtVencimento", $$v)
      },
      expression: "task.dtVencimento"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erroDataDeVencimento),
      expression: "erroDataDeVencimento"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefa.validacao.dtVencimentoInvalida'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-5 pr-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskResp"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.responsavel'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('task.responsavel')
    },
    attrs: {
      "options": _vm.operators,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "id": "taskResp",
      "name": "taskResp",
      "data-vv-name": "task.responsavel"
    },
    model: {
      value: (_vm.task.responsavel),
      callback: function($$v) {
        _vm.$set(_vm.task, "responsavel", $$v)
      },
      expression: "task.responsavel"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('task.responsavel')),
      expression: "errors.has('task.responsavel')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.gridId != 'ExtratoConta' && _vm.listIdMov.length > 0) ? _c('div', {
    staticClass: "form-group col-xs-6 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituationAuto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.autoConc'))
    }
  }), _c('i', {
    staticClass: "fa fa-info-circle icon-margin-left",
    attrs: {
      "title": _vm.$t('tarefaEmMassa.labels.tarefasMistas')
    }
  }), _c('v-select', {
    attrs: {
      "multiple": "multiple",
      "options": _vm.concilStatusesTransformed,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "task.situacao",
      "id": "taskSituationAuto",
      "name": "taskSituationAuto"
    },
    model: {
      value: (_vm.task.conclusaoAutomatica),
      callback: function($$v) {
        _vm.$set(_vm.task, "conclusaoAutomatica", $$v)
      },
      expression: "task.conclusaoAutomatica"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "form-group col-xs-6 px-0"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "checkbox check-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.enviarEmail),
      expression: "task.enviarEmail"
    }],
    attrs: {
      "id": "checkEnviarEmail",
      "type": "checkbox",
      "name": "checkEnviarEmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.task.enviarEmail) ? _vm._i(_vm.task.enviarEmail, null) > -1 : (_vm.task.enviarEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.task.enviarEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.task, "enviarEmail", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.task, "enviarEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.task, "enviarEmail", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "enviar-e-mail-automa",
    attrs: {
      "for": "checkEnviarEmail"
    }
  }, [_vm._v(_vm._s(_vm.messageEmail))])])])])]), _c('h4', {
    staticClass: "task-title",
    domProps: {
      "innerHTML": _vm._s(_vm.portletTable)
    }
  }), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.items,
      "columns": _vm.columns,
      "options": _vm.options,
      "name": "lancSelecionados"
    },
    scopedSlots: _vm._u([{
      key: "flag",
      fn: function(props) {
        return [_c('div', {
          staticClass: "actions"
        }, [(_vm.displayTaskAlert(props.row)) ? _c('div', {
          staticClass: "fa fa-exclamation-triangle action",
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "title": _vm.alertTooltipMessage(props.row)
          }
        }) : _vm._e()])]
      }
    }, {
      key: "acoes",
      fn: function(props) {
        return [_c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-times action",
          staticStyle: {
            "color": "black"
          },
          attrs: {
            "title": _vm.$t('tarefaEmMassa.labels.removerLanc')
          },
          on: {
            "click": function($event) {
              return _vm.removeEntry(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.salvar'),
      "id": "btnSlavarTarefaEmMass",
      "clickFunction": _vm.verifySave,
      "disabled": !_vm.enableSave
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('dataTable.labels.acaoFechar'),
      "id": "btnFecharModalContasBancarias",
      "customClass": "secondary",
      "clickFunction": _vm.trackCloseEvent
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33983fa4", module.exports)
  }
}

/***/ }),
/* 1396 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-33bc27be"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/establishments/new.pug ***!
  \*******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper",
    attrs: {
      "id": "NewEstablishmentWrapper"
    }
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('estabelecimentos.labels.estabelecimentos'),
      "subTitle": _vm.$t('estabelecimentos.labels.cadastre')
    }
  }), _c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('vue-tabs', {
    attrs: {
      "id": "tab-navigation"
    },
    model: {
      value: (_vm.tabMain),
      callback: function($$v) {
        _vm.tabMain = $$v
      },
      expression: "tabMain"
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-conciliacoes-pendentes",
      "title": _vm.tabEstab
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.establishment.nome),
      expression: "establishment.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          max: 50
        }
      }),
      expression: "{ rules: { required: true, max: 50 } }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishmentName')
    },
    attrs: {
      "type": "text",
      "id": "establishmentName",
      "name": "establishmentName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.establishment.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.establishment, "nome", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentName')),
      expression: "errors.has('establishmentName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.nome'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentFantasyName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nomeFantasia'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.establishment.nomeFantasia),
      expression: "establishment.nomeFantasia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          max: 50
        }
      }),
      expression: "{ rules: { max: 50 } }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishmentFantasyName')
    },
    attrs: {
      "type": "text",
      "id": "establishmentFantasyName",
      "name": "establishmentFantasyName",
      "maxlength": "51"
    },
    domProps: {
      "value": (_vm.establishment.nomeFantasia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.establishment, "nomeFantasia", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentFantasyName')),
      expression: "errors.has('establishmentFantasyName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.nomeFantasia'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentCnpj"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.cnpj'))
    }
  }), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          min: 14,
          max: 14
        }
      }),
      expression: "{ rules: { min: 14, max: 14 } }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishmentCnpj'),
      'is-danger': _vm.errors.has('establishmentCnpjInvalid')
    },
    attrs: {
      "id": "establishmentCnpj",
      "name": "establishmentCnpj",
      "mask": "XX.XXX.XXX/XXXX-XX"
    },
    on: {
      "input": function($event) {
        _vm.establishment.cnpj = _vm.establishment.cnpj.toUpperCase()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.verifyCnpj.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.establishment.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.establishment, "cnpj", $$v)
      },
      expression: "establishment.cnpj"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentCnpj')),
      expression: "errors.has('establishmentCnpj')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.cnpj'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentCnpjInvalid')),
      expression: "errors.has('establishmentCnpjInvalid')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.cnpjInvalido'))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentUf"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.uf'))
    }
  }), _c('v-select', {
    ref: "ufSelect",
    attrs: {
      "id": "ufSelector",
      "options": _vm.uf
    },
    on: {
      "input": _vm.updateCities
    },
    model: {
      value: (_vm.establishment.uf),
      callback: function($$v) {
        _vm.$set(_vm.establishment, "uf", $$v)
      },
      expression: "establishment.uf"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentCity"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.cidade'))
    }
  }), _c('v-select', {
    ref: "citySelect",
    attrs: {
      "id": "citySelector",
      "options": _vm.cities,
      "label": "nome"
    },
    on: {
      "input": _vm.changeCities
    },
    model: {
      value: (_vm.establishment.cidade),
      callback: function($$v) {
        _vm.$set(_vm.establishment, "cidade", $$v)
      },
      expression: "establishment.cidade"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentGroups"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.grupoDeEstabelecimentos'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishment.grupo')
    },
    attrs: {
      "taggable": "taggable",
      "options": _vm.establishmentsGroupList,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "establishment.grupo",
      "id": "operatorAccessProfile",
      "name": "operatorAccessProfile",
      "getOptionLabel": _vm.stylizeGroupLabel
    },
    model: {
      value: (_vm.establishment.grupo),
      callback: function($$v) {
        _vm.$set(_vm.establishment, "grupo", $$v)
      },
      expression: "establishment.grupo"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('establishment.grupo', 'required')),
      expression: "errors.firstByRule('establishment.grupo', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputEstabelecimentoValidator),
      expression: "inputEstabelecimentoValidator"
    }],
    staticClass: "help is-warning",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.grupoEstabelecimentosInput'))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.situacao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.establishment.situacao),
      expression: "establishment.situacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "active"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.establishment.situacao, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.establishment, "situacao", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "active"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.ativo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.establishment.situacao),
      expression: "establishment.situacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "inactive"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.establishment.situacao, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.establishment, "situacao", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inactive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.inativo'))
    }
  }), (_vm.attributesList.length <= 0) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('estabelecimentos.labels.salvar'),
      "faIcon": "",
      "id": "btnSalvarEstabelecimento",
      "clickFunction": _vm.validate,
      "disabled": _vm.requestSent
    }
  }) : _vm._e(), (_vm.attributesList.length > 0) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('estabelecimentos.labels.btnProximo'),
      "faIcon": "",
      "id": "btnEstabelecimentosProximaAba",
      "clickFunction": _vm.nextToAtt
    }
  }) : _vm._e(), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.cancelar'),
      "faIcon": "",
      "id": "btnEstabelecimentosVoltarAba",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])])]), (_vm.attributesLoaded && _vm.attributesList.length > 0) ? _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-lotes",
      "title": _vm.tabAtt
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentNameTabAtt"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.E'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.establishment.nome),
      expression: "establishment.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "establishmentNameTabAtt",
      "name": "establishmentNameTabAtt",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.establishment.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.establishment, "nome", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "dynamic-box"
  }, [_vm._l((_vm.attributesList), function(att, idx) {
    return (_vm.attributesList.length > 0) ? _c('div', {
      staticClass: "row row-filter-small"
    }, [_c('dynamic-input', {
      staticClass: "col-xs-10",
      attrs: {
        "inputName": att.descricaoAtributo,
        "inputTag": att.nomeAtributo,
        "inputType": att.tipo,
        "inputValue": att.valorOriginal,
        "inputMask": att.mascaraApresentacao ? att.mascaraApresentacao : null,
        "inputValidator": att.validacao ? att.validacao : null,
        "inputTipoValores": att.atributoTipoValores ? att.atributoTipoValores : null
      },
      on: {
        "input-invalid": function($event) {
          att.invalid = $event
        }
      },
      model: {
        value: (att.valorOriginal),
        callback: function($$v) {
          _vm.$set(att, "valorOriginal", $$v)
        },
        expression: "att.valorOriginal"
      }
    })], 1) : _vm._e()
  }), (_vm.attributesList.length == 0) ? _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.semAtributos'))
    }
  })]) : _vm._e()], 2), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('estabelecimentos.labels.salvar'),
      "faIcon": "",
      "id": "btnSalvarEstabelecimento",
      "clickFunction": _vm.validate,
      "disabled": _vm.requestSent
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.voltar'),
      "faIcon": "",
      "id": "btnVoltarSalvarEstabelecimento",
      "clickFunction": _vm.backToEstab,
      "customClass": "secondary"
    }
  })], 1)])]) : _vm._e()], 1)], 1)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33bc27be", module.exports)
  }
}

/***/ }),
/* 1397 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-35506d6d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/operator/list.pug ***!
  \****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('administracao.operadores.titulos.operadores'),
      "subTitle": _vm.$t('administracao.operadores.titulos.listagemSubtitlo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('administracao.operadores.labels.novoOperador'),
      "id": "btnNovoOperador",
      "clickFunction": _vm.newProfile
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "profiles"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.operators,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "disabled": !_vm.canEditOperator(props.row.perfilAcesso),
            "title": !_vm.canEditOperator(props.row.perfilAcesso) ? _vm.$t('administracao.perfilAcesso.validacao.naoPodeEditar') : ''
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__email"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'email')
      }
    }
  })]), _c('template', {
    slot: "filter__nomePerfilAcesso"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'nomePerfilAcesso')
      }
    }
  })]), _c('template', {
    slot: "filter__situacao"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'situacao')
      }
    }
  })])], 2)], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35506d6d", module.exports)
  }
}

/***/ }),
/* 1398 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-37139c00"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabIntegrations/tabIntegrations.pug ***!
  \*************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-integration-wrapper"
    }
  }, [_c('div', {
    staticClass: "main-container",
    attrs: {
      "id": "main-integrations-container"
    }
  }, [(_vm.establishtmentValue) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.title))]), _c('h4', {
    staticClass: "detail-value"
  }, [_vm._v(_vm._s(_vm.establishtmentValue.value))])]) : _vm._e(), _vm._l((_vm.integrationValuesList), function(mainValue) {
    return _c('div', {
      staticClass: "col-xs-4"
    }, [_c('h4', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(mainValue.title))]), _c('h4', {
      class: mainValue.class
    }, [_vm._v(_vm._s(mainValue.value))])])
  })], 2), _c('div', {
    attrs: {
      "id": "monetary-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.processedFiles,
      "columns": _vm.columns,
      "options": _vm.options
    }
  })], 1)]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer-monetary-container"
    }
  }, [_c('div', {
    staticClass: "clear"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37139c00", module.exports)
  }
}

/***/ }),
/* 1399 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-385bbd4c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/duplicateMovementsAnalysis/duplicateMovementsAnalysis.pug ***!
  \*************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "duplicateMovementsAnalysis"
    }
  }, [_c('confirm-modal', {
    attrs: {
      "id": "confirmUpdateAnnulledField"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.labelConfirmacaoAnulacao)
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalUpdateAnulledField",
      "clickFunction": _vm.annulMovementsCloseModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('analiseDuplicidade.labels.sim'),
      "id": "btnConfirmacaoModalUpdateAnulledField",
      "clickFunction": _vm.annulMovements,
      "disabled": _vm.disableConfirmButton
    }
  })], 1)]), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('analiseDuplicidade.titulos.titulo'),
      "subTitle": _vm.$t('analiseDuplicidade.titulos.subtitulo')
    }
  }), _c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('vue-tabs', {
    attrs: {
      "id": "tab-navigation"
    },
    on: {
      "tab-change": _vm.handleTabChange
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-analise-duplicados",
      "title": _vm.$t('analiseDuplicidade.labels.listaDuplicado')
    }
  }, [(_vm.currentTab === 'tabDuplicated') ? _c('duplicate-movements', {
    attrs: {
      "disableSearchButton": _vm.disableSearchButton
    },
    on: {
      "search-movements": _vm.searchMovements
    }
  }) : _vm._e()], 1), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-analise-anulados",
      "title": _vm.$t('analiseDuplicidade.labels.listaAnulado')
    }
  }, [(_vm.currentTab === 'tabAnnulled') ? _c('annulled-movements', {
    attrs: {
      "disableSearchButton": _vm.disableSearchButton
    },
    on: {
      "search-movements": _vm.searchMovements
    }
  }) : _vm._e()], 1)], 1)], 1), (_vm.showTreegrid) ? _c('div', [_c('tree-grid', {
    attrs: {
      "gridId": _vm.searchData.gridId,
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "AnaliseDuplicidade",
      "treeGridLayoutPath": "duplicateMovements",
      "cfgObj": _vm.treeGridCfg,
      "showAnnulledMovementButton": true,
      "showAlert": true,
      "alertMessage": _vm.labelAlertaAnulacao
    },
    on: {
      "annulMovements": _vm.annulMovementsOpenModalConfirm
    }
  })], 1) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-385bbd4c", module.exports)
  }
}

/***/ }),
/* 1400 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5894d2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/occurrenceReason/list.pug ***!
  \**********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('motivoOcorrencia.titulos.listagemTitulo'),
      "subTitle": _vm.$t('motivoOcorrencia.titulos.listagemSubtitulo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('motivoOcorrencia.labels.novo'),
      "id": "btnNovoMotivoDeOcorrencia",
      "clickFunction": _vm.newOccurrence
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "occurrenceReasons"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.reasons,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "title": _vm.$t('motivoOcorrencia.labels.editar')
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        }), _c('button', {
          staticClass: "fa fa-times action",
          attrs: {
            "disabled": props.row.emUso,
            "title": props.row.emUso ? _vm.$t('motivoOcorrencia.labels.removeBloqueio') : _vm.$t('motivoOcorrencia.labels.remover')
          },
          on: {
            "click": function($event) {
              return _vm.handleRemove(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__categoria"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'categoria')
      }
    }
  })])], 2)], 1)], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveOccurrence"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverOcorrencia",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverOcorrencia",
      "clickFunction": _vm.removeOccurrence
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a5894d2", module.exports)
  }
}

/***/ }),
/* 1401 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b9486da"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/auditLog/auditLog.pug ***!
  \********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logDeAuditoriaWrapper"
    }
  }, [(_vm.shown.operators) ? _c('multi-select-modal', {
    attrs: {
      "id": "operatorsModal",
      "data": _vm.data.operators,
      "objProperties": _vm.inputTagsProps.operators
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), (_vm.shown.functionalities) ? _c('multi-select-modal', {
    attrs: {
      "id": "functionalitiesModal",
      "data": _vm.data.functionalities,
      "objProperties": _vm.inputTagsProps.functionalities
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), (_vm.shown.entities) ? _c('multi-select-modal', {
    attrs: {
      "id": "entitiesModal",
      "data": _vm.data.entities,
      "objProperties": _vm.inputTagsProps.entities
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('audit-modal', {
    attrs: {
      "audit": _vm.audit
    }
  }), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('logDeAuditoria.labels.logDeAuditoria'),
      "subTitle": _vm.$t('logDeAuditoria.titulos.listagemSubtitlo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('logDeAuditoria.titulos.filtroTitulo')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 200
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "value": true,
      "color": {
        "checked": "#40b9bb",
        "unchecked": "#E5E5E5"
      },
      "height": 20,
      "width": 40
    },
    on: {
      "change": _vm.resetFilter
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.pesquisaAvancada'))
    }
  })], 1)]), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "selectedOperators"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('logDeAuditoria.labels.operadores'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.operators.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.operators,
      "props": _vm.inputTagsProps.operators
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.operators, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('logDeAuditoria.labels.selecionarOperador'),
      "faIcon": "fa fa-search",
      "id": "btnAbrirModalOperadores-LogsDeAuditoria",
      "clickFunction": _vm.openSelectOperatorsModal
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "selectedFunctionalities"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('logDeAuditoria.labels.funcionalidades'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.functionalities.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.functionalities,
      "props": _vm.inputTagsProps.functionalities
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.functionalities, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('logDeAuditoria.labels.selecionarFuncionalidades'),
      "faIcon": "fa fa-search",
      "id": "btnAbrirModalFuncionalidades-LogsDeAuditoria",
      "clickFunction": _vm.openSelectFunctionalitiesModal
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "selectedEntities"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('logDeAuditoria.labels.entidades'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.entities.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.entities,
      "props": _vm.inputTagsProps.entities
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.entities, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectEntitiesModal,
      "id": "btnAbrirModalEntidades-LogsDeAuditoria",
      "title": _vm.$t('logDeAuditoria.labels.selecionarEntidades')
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "entityId"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('logDeAuditoria.labels.identificacaoUnica'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.entityId),
      expression: "filter.entityId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('entityId')
    },
    attrs: {
      "type": "text",
      "id": "entityId",
      "name": "entityId"
    },
    domProps: {
      "value": (_vm.filter.entityId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "entityId", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('entityId')),
      expression: "errors.has('entityId')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.somenteNumeros'))
    }
  })])])]) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "auditLogGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "logAuditoria",
      "treeGridLayoutPath": "auditoria"
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b9486da", module.exports)
  }
}

/***/ }),
/* 1402 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c8036e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/chart/chart.pug ***!
  \***************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-chart pr-0"
  }, [_c('div', {
    staticClass: "dashboard-top"
  }, [_c('div', {
    staticClass: "dashboard-top-chart-name",
    class: _vm.getClassChartTitle(_vm.chart),
    attrs: {
      "title": _vm.chart.chartTitle
    }
  }, [_vm._v(_vm._s(_vm.chart.chartTitle))]), _c('div', {
    staticClass: "dashboard-action-bar px-0",
    class: _vm.getClassChartFilter(_vm.chart)
  }, [(_vm.chart.idChartTemplate === 'ChartConciliationSituationSummary') ? _c('div', {
    staticClass: "chart-content px-0"
  }, [_c('conciliation-situation-summary-filter'), _c('button', {
    staticClass: "button-content top",
    attrs: {
      "data-toggle": "collapse",
      "data-target": _vm.chart.idChartTemplate
    },
    on: {
      "click": _vm.collapseContent
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up",
    class: _vm.chart.isCollapsed ? "closed" : "open"
  })])], 1) : _vm._e(), (_vm.chart.idChartTemplate === 'ChartFinancialSummary') ? _c('div', {
    staticClass: "chart-content px-0"
  }, [_c('financial-summary-filter'), _c('button', {
    staticClass: "button-content top",
    attrs: {
      "data-toggle": "collapse",
      "data-target": _vm.chart.idChartTemplate
    },
    on: {
      "click": _vm.collapseContent
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up",
    class: _vm.chart.isCollapsed ? "closed" : "open"
  })])], 1) : _vm._e(), (_vm.chart.idChartTemplate === 'ChartAllotmentDistributionConciliation') ? _c('div', {
    staticClass: "chart-content px-0"
  }, [_c('allotment-distribution-filter'), _c('button', {
    staticClass: "button-content top",
    attrs: {
      "data-toggle": "collapse",
      "data-target": _vm.chart.idChartTemplate
    },
    on: {
      "click": _vm.collapseContent
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up",
    class: _vm.chart.isCollapsed ? "closed" : "open"
  })])], 1) : _vm._e(), (_vm.chart.idChartTemplate === 'DailyBankStatment') ? _c('div', {
    staticClass: "chart-content px-0"
  }, [_c('daily-bank-statment-filter'), _c('button', {
    staticClass: "button-content top",
    attrs: {
      "data-toggle": "collapse",
      "data-target": _vm.chart.idChartTemplate
    },
    on: {
      "click": _vm.collapseContent
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up",
    class: _vm.chart.isCollapsed ? "closed" : "open"
  })])], 1) : _vm._e(), (_vm.chart.idChartTemplate === 'GadgetTasks') ? _c('div', {
    staticClass: "chart-content px-0"
  }, [_c('button', {
    staticClass: "button-content top",
    attrs: {
      "data-toggle": "collapse",
      "data-target": _vm.chart.idChartTemplate
    },
    on: {
      "click": _vm.collapseContent
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up",
    class: _vm.chart.isCollapsed ? "closed" : "open"
  })])]) : _vm._e(), (_vm.chart.idChartTemplate === 'DigitalWalletBalance') ? _c('div', {
    staticClass: "chart-content px-0"
  }, [_c('digital-wallet-balance-filter'), _c('button', {
    staticClass: "button-content top",
    attrs: {
      "data-toggle": "collapse",
      "data-target": _vm.chart.idChartTemplate
    },
    on: {
      "click": _vm.collapseContent
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up",
    class: _vm.chart.isCollapsed ? "closed" : "open"
  })])], 1) : _vm._e(), _c('div', {
    staticClass: "clear"
  })])]), (_vm.chart.isLoadingData) ? _c('div', {
    staticClass: "loadingData"
  }) : _vm._e(), (_vm.showChart && !_vm.chart.isLoadingData && (_vm.chart.idChartTemplate !== "GadgetTasks")) ? _c('highcharts', {
    ref: "highcharts",
    staticClass: "collapse in",
    attrs: {
      "id": _vm.chart.idChartTemplate,
      "options": _vm.chart
    }
  }) : _vm._e(), (_vm.showChart && !_vm.chart.isLoadingData && _vm.chart.idChartTemplate === "GadgetTasks") ? _c('task-gadget', {
    staticClass: "collapse in",
    attrs: {
      "id": _vm.chart.idChartTemplate,
      "data": _vm.chart.data,
      "isLoadingDataTaskGadget": _vm.chart.isLoadingData
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.chart.isCollapsed),
      expression: "!chart.isCollapsed"
    }],
    staticClass: "dashboard-action-bar px-0"
  }, [_c('div', {
    staticClass: "chart-content"
  }, [_c('button', {
    staticClass: "button-content bottom",
    on: {
      "click": _vm.resize
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    class: _vm.chart.container
  })])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40c8036e", module.exports)
  }
}

/***/ }),
/* 1403 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-40d3dc5a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/modals/reopenAllotmentModal.pug ***!
  \************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm-modal', {
    attrs: {
      "id": "reopenAllotmentModal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.reabrirLote'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.acaoFechar'),
      "customClass": "secondary",
      "id": "btnFecharModalReabrirLote",
      "clickFunction": _vm.closeModal,
      "disabled": _vm.disableButton
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.acaoConfirmar'),
      "id": "btnConfirmacaoReabrirLote",
      "clickFunction": _vm.confirmReopenAllotment,
      "disabled": _vm.disableButton
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40d3dc5a", module.exports)
  }
}

/***/ }),
/* 1404 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4140c414"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabAllotment/tabAllotment.pug ***!
  \*******************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-allotment-wrapper"
    }
  }, [(!_vm.isLoadingData) ? _c('div', {
    staticClass: "tab-allotment-detail-id"
  }, [(_vm.hasAllotment) ? _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "margin-container",
    attrs: {
      "id": "header-value-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.idLote'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.allotmentId))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.qtdMovFin'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.allotment.countMovFin))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.qtdMovBan'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.allotment.countMovBan))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.periodo'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.dateRangeAllotment))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.critConcil'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.criteria))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.situacaoLote'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value",
    class: _vm.allotmentStatus.classe
  }, [_vm._v(_vm._s(_vm.allotmentStatus.valor))])])]), _c('div', {
    staticClass: "col-xs-12 margin-container",
    staticStyle: {
      "padding": "0px 10px 0px 10px"
    },
    attrs: {
      "id": "datatable-container"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.allotmentEntries,
      "columns": _vm.columns,
      "options": _vm.options
    }
  })], 1)]) : _vm._e(), (!_vm.isLoadingData && !_vm.hasAllotment) ? _c('div', [_c('div', {
    staticClass: "vertical-center loading-center"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_vm._m(0), _c('br'), _c('p', {
    staticClass: "big-txt-allotment",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.lancamentoSemVinculo'))
    }
  }), (_vm.canConciliate) ? _c('button-primary', {
    staticClass: "primary",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabLotes.labels.concilarManualmente'),
      "faIcon": "",
      "id": "btnTabLoteConcManual",
      "clickFunction": _vm.goManualConcil,
      "customClass": "big-primary"
    }
  }) : _vm._e()], 1)])]) : _vm._e()]) : _vm._e(), (!_vm.isLoadingData && _vm.hasAllotment) ? _c('div', {
    attrs: {
      "id": "footer-monetary-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 monetary-container"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-value",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.vlMovFin'))
    }
  }), _c('h4', {
    staticClass: "detail-status",
    class: _vm.totalMovFin > 0 ? 'font-C' : _vm.totalMovFin < 0 ? 'font-D' : 'font-N'
  }, [_vm._v(_vm._s(_vm.totalMovFinTransformed))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-value",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.vlMovExt'))
    }
  }), _c('h4', {
    staticClass: "detail-status",
    class: _vm.totalMovExt > 0 ? 'font-C' : _vm.totalMovExt < 0 ? 'font-D' : 'font-N'
  }, [_vm._v(_vm._s(_vm.totalMovExtTransformed))])]), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h4', {
    staticClass: "detail-value",
    staticStyle: {
      "margin-bottom": "0px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabLotes.labels.vlDivergencia'))
    }
  }), _c('tr', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    }
  }, [_c('td', [_c('h4', {
    staticClass: "detail-status",
    class: _vm.totalDivergencia != 0 ? 'font-D' : 'font-N'
  }, [_vm._v(_vm._s(_vm.totalDivergenciaTransformed))])]), (_vm.canGoToManualConcil) ? _c('td', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button-primary', {
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabLotes.labels.concilarManualmente'),
      "faIcon": "fa fa-handshake-o",
      "id": "btnTabLoteConcManualDivergence",
      "clickFunction": _vm.goManualConcil
    }
  })], 1) : _vm._e()])])])]), _c('div', {
    staticClass: "clear"
  })]) : (_vm.isLoadingData) ? _c('div', {
    staticClass: "col-md-12 col-sm-10",
    attrs: {
      "id": "allotment-loading"
    }
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "id": "video-player",
      "loop": "loop",
      "autoplay": "autoplay"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3-sa-east-1.amazonaws.com/midias-banking/Lotes.mp4",
      "type": "video/mp4"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4140c414", module.exports)
  }
}

/***/ }),
/* 1405 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4485b970"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/establishments/list.pug ***!
  \********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper",
    attrs: {
      "id": "listEstablishmentsWrapper"
    }
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('estabelecimentos.labels.estabelecimentos'),
      "subTitle": _vm.$t('estabelecimentos.labels.visualizacao')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('estabelecimentos.labels.novoEstabelecimento'),
      "id": "btnNovoEstabelecimento",
      "clickFunction": _vm.newEstablishment
    },
    slot: "new-button"
  }), _c('button-primary', {
    staticClass: "pull-right margin-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('estabelecimentos.labels.moverEstabelecimento'),
      "id": "btnMoverEstabelecimento",
      "clickFunction": _vm.moveEstablishment
    },
    slot: "new-button"
  })], 1), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('estabelecimentos.labels.filtroTitulo')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nome'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.nome),
      expression: "filter.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          max: 50
        }
      }),
      expression: "{ rules: { max: 50 } }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishmentName')
    },
    attrs: {
      "type": "text",
      "id": "establishmentName",
      "name": "establishmentName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.filter.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "nome", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentName')),
      expression: "errors.has('establishmentName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.nome'))
    }
  })]), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentCnpj"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.cnpj'))
    }
  }), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          min: 14,
          max: 14
        }
      }),
      expression: "{ rules: { min: 14, max: 14} }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('establishmentCnpj')
    },
    attrs: {
      "id": "establishmentCnpj",
      "name": "establishmentCnpj",
      "mask": "XX.XXX.XXX/XXXX-XX"
    },
    on: {
      "input": function($event) {
        _vm.filter.cnpj = _vm.filter.cnpj.toUpperCase()
      }
    },
    model: {
      value: (_vm.filter.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.filter, "cnpj", $$v)
      },
      expression: "filter.cnpj"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('establishmentCnpj')),
      expression: "errors.has('establishmentCnpj')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.cnpj'))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('estabelecimentos.labels.pesquisar'),
      "id": "btnProcurarEstabelecimentos",
      "type": "submit",
      "clickFunction": _vm.validate,
      "disabled": _vm.disableSearchButton
    }
  })], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "establishmentsGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "Estabelecimentos",
      "treeGridLayoutPath": "establishments",
      "showAlert": true,
      "cfgObj": _vm.treeGridCfg,
      "alertMessage": _vm.$t('estabelecimentos.labels.alertaGrid')
    }
  })], 1)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4485b970", module.exports)
  }
}

/***/ }),
/* 1406 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-44a5b89a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/gridDetailsModal.pug ***!
  \**********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOpen) ? _c('better-modal', {
    attrs: {
      "closable": true,
      "id": _vm.id,
      "tabbedModal": true,
      "showFooter": false
    },
    on: {
      "close-modal": _vm.trackEvent,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.trackEvent.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header",
      "id": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modalTitle)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modalSubtitle)
    }
  })]), _c('div', {
    staticClass: "tabbed-modal-body",
    attrs: {
      "slot": "body",
      "id": "body"
    },
    slot: "body"
  }, [_vm._t("default", null, {
    "tabs": "tabs"
  }), _c('vue-tabs', {
    ref: "tabRouter",
    attrs: {
      "id": "tabbed-modal",
      "direction": "vertical"
    },
    on: {
      "tab-change": _vm.handleTabChange
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return (_vm.verifyTabAuthorization(tab.idFunctionalitie)) ? _c('v-tab', {
      key: tab.idTabRoot,
      ref: tab.tabRef,
      refInFor: true,
      staticClass: "tab",
      attrs: {
        "id": tab.idTabRoot,
        "title": tab.idTabRoot
      }
    }, [_c('div', {
      staticClass: "tab-left",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('i', {
      class: tab.icon
    }), _c('span', {
      staticClass: "title title_center",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    })]), _c(tab.type, _vm._b({
      tag: "component",
      attrs: {
        "id": tab.idTabContent
      }
    }, 'component', tab.props, false))], 1) : _vm._e()
  }), 1)], 2)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44a5b89a", module.exports)
  }
}

/***/ }),
/* 1407 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-44b39af4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/input/dateRange/dateRange.pug ***!
  \*******************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayLabel),
      expression: "displayLabel"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('logDeAuditoria.labels.periodo'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 fix-aligment pr-0"
  }, [_c('div', {
    staticClass: "pull-left px-0"
  }, [_c('datepicker', {
    ref: "datePickerFromDate",
    class: {
      "is-danger": _vm.invalid
    },
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "id": "datePickerFromDate",
      "language": _vm.datePickerLanguage,
      "format": "dd/MM/yyyy",
      "full-month-name": "full-month-name",
      "input-class": {
        "date-picker": true,
        "disable-datepicker": _vm.disableDateRange
      },
      "wrapper-class": {
        "datepicker-wrapper": true,
        "disable-datepicker": _vm.disableDateRange
      },
      "calendar-class": {
        "disable-datepicker": _vm.disableDateRange
      },
      "disabled": _vm.disableDateRange,
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "typeable": "typeable",
      "open-date": _vm.initialFromDate,
      "vMaskPattern": "##/##/####"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('dateRange.labels.ate'))
    }
  }), _c('datepicker', {
    ref: "datePickerToDate",
    class: {
      "is-danger": _vm.invalid
    },
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "id": "datePickerToDate",
      "language": _vm.datePickerLanguage,
      "format": "dd/MM/yyyy",
      "full-month-name": "full-month-name",
      "input-class": {
        "date-picker": true,
        "disable-datepicker": _vm.disableDateRange
      },
      "wrapper-class": {
        "datepicker-wrapper": true,
        "second-date-picker": true,
        "disable-datepicker": _vm.disableDateRange
      },
      "calendar-class": {
        "disable-datepicker": _vm.disableDateRange
      },
      "disabled": _vm.disableDateRange,
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "typeable": "typeable",
      "open-date": _vm.initialToDate,
      "vMaskPattern": "##/##/####"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 col-sm-1 col-md-1 col-lg-1 px-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayAction),
      expression: "displayAction"
    }],
    staticClass: "col-xs-1 input-button"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "id": "btnSelecionarDatas",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.action,
      "disabled": _vm.invalid
    }
  })], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInvalid),
      expression: "isInvalid"
    }],
    staticClass: "col-xs-12 px-0"
  }, [_c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44b39af4", module.exports)
  }
}

/***/ }),
/* 1408 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4672dfff"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonPrimary/buttonPrimary.pug ***!
  \*****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-info common",
    class: [_vm.customClass ? _vm.customClass : 'primary'],
    style: ({
      width: _vm.width
    }),
    attrs: {
      "id": [_vm.id],
      "type": [_vm.type],
      "title": [_vm.title],
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.trackEvent
    }
  }, [_c('i', {
    class: [_vm.faIcon]
  }), (_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4672dfff", module.exports)
  }
}

/***/ }),
/* 1409 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f2f433"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/dashboard/chartFilter/DigitalWalletBalance.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('filters-common', {
    attrs: {
      "data": _vm.filters
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46f2f433", module.exports)
  }
}

/***/ }),
/* 1410 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-475e994c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/occurrenceReport/occurrenceReport.pug ***!
  \*****************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "manualConciliationWrapper"
    }
  }, [(_vm.shown.occurrenceReason) ? _c('multi-select-modal', {
    attrs: {
      "id": "occurrenceReasonModal",
      "data": _vm.data.occurrenceReason
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('relatorioOcorrencia.titulos.titulo'),
      "subTitle": _vm.$t('relatorioOcorrencia.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('relatorioOcorrencia.titulos.filtro')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 200
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "value": true,
      "color": {
        "checked": "#40b9bb",
        "unchecked": "#E5E5E5"
      },
      "height": 20,
      "width": 40
    },
    on: {
      "change": _vm.resetFilter
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.pesquisaAvancada'))
    }
  })], 1)]), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioOcorrencia.labels.motivoOcorrencia'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.occurrenceReason.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.occurrenceReason,
      "props": _vm.inputTagsProps.occurrenceReason
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.occurrenceReason, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('relatorioOcorrencia.labels.selecaoMotivoOcorrencia'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarMotivosDeOcorrencia-Ocorrencias",
      "clickFunction": _vm.openSelectOccurrencesModal
    }
  })], 1)])]), _c('input-establishment', {
    attrs: {
      "id": "establishmentsFilterOccurrenceReport",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "occurrenceReportGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "RelatorioOcorrencia",
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-475e994c", module.exports)
  }
}

/***/ }),
/* 1411 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ab25a9f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/conciliationCriteria/conciliationCritFields.pug ***!
  \*******************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-filter-small col-xs-12"
  }, [_c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon info-icon-text"
  }), _c('span', {
    staticClass: "info-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.linkCamposConcil'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-11"
  }, [_c('div', {
    staticClass: "col-xs-11",
    staticStyle: {
      "padding-left": "7px",
      "padding-roght": "7px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'mfField' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.movFinan'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mfFieldList,
      "label": "nome",
      "id": 'mfField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'mfField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.conciliacaoCampoMovFinan",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMfField
    },
    model: {
      value: (_vm.field.conciliacaoCampoMovFinan),
      callback: function($$v) {
        _vm.$set(_vm.field, "conciliacaoCampoMovFinan", $$v)
      },
      expression: "field.conciliacaoCampoMovFinan"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), (_vm.errors.firstByRule('field.conciliacaoCampoMovFinan', 'required')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()], 1), (_vm.field.conciliacaoCampoMovFinan && _vm.field.conciliacaoCampoMovFinan.tipo === 'A') ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'attributeCfgMf' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conjuntoAtributo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mfCfgList,
      "label": "attibuteSetName",
      "id": 'attributeCfgMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'attributeCfgMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.atributo.atributoCfg",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMfAttCfg
    },
    model: {
      value: (_vm.field.atributo.atributoCfg),
      callback: function($$v) {
        _vm.$set(_vm.field.atributo, "atributoCfg", $$v)
      },
      expression: "field.atributo.atributoCfg"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('field.atributo.atributoCfg', 'required')),
      expression: "errors.firstByRule('field.atributo.atributoCfg', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1) : _vm._e(), (_vm.field.conciliacaoCampoMovFinan && _vm.field.conciliacaoCampoMovFinan.tipo === 'A') ? _c('div', {
    staticClass: "col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'attributeMf' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.atributo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mfAttList,
      "label": "attibuteSetName",
      "id": 'attributeMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'attributeMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.atributo.nomeAtributo",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMfAtt
    },
    model: {
      value: (_vm.field.atributo.nomeAtributo),
      callback: function($$v) {
        _vm.$set(_vm.field.atributo, "nomeAtributo", $$v)
      },
      expression: "field.atributo.nomeAtributo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), (_vm.errors.firstByRule('field.atributo.nomeAtributo', 'required')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()], 1) : _vm._e()]), _c('div', {
    staticClass: "col-xs-11",
    staticStyle: {
      "padding-left": "7px",
      "padding-roght": "7px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'mbField' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.movBan'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mbFieldList,
      "label": "nome",
      "id": 'mbField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'mbField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.conciliacaoCampoMovBancario",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMbField
    },
    model: {
      value: (_vm.field.conciliacaoCampoMovBancario),
      callback: function($$v) {
        _vm.$set(_vm.field, "conciliacaoCampoMovBancario", $$v)
      },
      expression: "field.conciliacaoCampoMovBancario"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), (_vm.errors.firstByRule('field.conciliacaoCampoMovBancario', 'required')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()], 1)])]), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "height": "10vh"
    }
  }, [_c('button-primary', {
    staticClass: "marged-button",
    staticStyle: {
      "border-radius": "50%",
      "border": "none",
      "margin": "6vh 10px 10px 0",
      "font-size": "30px"
    },
    attrs: {
      "title": _vm.$t('planoConciliacao.labels.remover'),
      "faIcon": "fa fa-times-circle",
      "id": 'btnRemoveField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "clickFunction": _vm.removeField,
      "customClass": "secondary",
      "disabled": _vm.disabled
    }
  })], 1), _c('br'), _c('br')])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ab25a9f", module.exports)
  }
}

/***/ }),
/* 1412 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b893cfa"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/conciliationReport/conciliationReport.pug ***!
  \*********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "conciliationReportWrapper"
    }
  }, [_c('grid-details-modal', {
    attrs: {
      "id": _vm.concReportGridModalId,
      "closable": true,
      "tabs": _vm.modalDetailsTabs,
      "isOpen": _vm.isOpenDetailsModal
    },
    on: {
      "closeDetailsModal": _vm.closeDetailsModal
    }
  }), (_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), (_vm.shown.categories) ? _c('multi-select-modal', {
    attrs: {
      "id": "categoriesModal",
      "data": _vm.data.categories
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('relatorioConciliacao.titulos.titulo'),
      "subTitle": _vm.$t('relatorioConciliacao.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('relatorioConciliacao.titulos.tituloFiltro')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "hasExportFile": true,
      "showLoadingFullPage": false,
      "exportFileFlag": _vm.isExportFile
    },
    on: {
      "update-flagExportingFile": function($event) {
        _vm.isExportFile = !_vm.isExportFile
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "value": true,
      "color": {
        "checked": "#40b9bb",
        "unchecked": "#E5E5E5"
      },
      "height": 20,
      "width": 40
    },
    on: {
      "change": _vm.resetFilter
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.pesquisaAvancada'))
    }
  })], 1)]), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankAccountsSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('relatorioConciliacao.labels.selecaoContaBancaria'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarContasBancarias-RelatorioDeConciliacao",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])]), _c('input-establishment', {
    attrs: {
      "id": "establishmentsFilterConciliationReport",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "categorieSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.titulos.titulo'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.categories.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.categories,
      "props": _vm.inputTagsProps.categories
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.categories, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('categoria.labels.selecionarCategoria'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarCategorias-RelatorioDeConciliacao",
      "clickFunction": _vm.openSelectCategoriesModal
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.statusConciliacao'))
    }
  }), _vm._l((_vm.situationList), function(status, idx) {
    return _c('div', [_c('div', {
      staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.checked),
        expression: "status.checked"
      }],
      attrs: {
        "id": status.id,
        "type": "checkbox",
        "name": "status"
      },
      domProps: {
        "checked": Array.isArray(status.checked) ? _vm._i(status.checked, null) > -1 : (status.checked)
      },
      on: {
        "change": function($event) {
          var $$a = status.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(status, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(status, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(status, "checked", $$c)
          }
        }
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": status.id
      }
    }, [_vm._v(_vm._s(status.nome))])])])
  })], 2)])], 1) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "RelatorioConciliacao",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "RelatorioConciliacao",
      "treeGridLayoutPath": "conciliationReport",
      "showMassTaskAction": true,
      "showAlert": true,
      "cfgObj": _vm.treeGridCfg,
      "alertMessage": _vm.$t('relatorioConciliacao.labels.alertaGrid')
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b893cfa", module.exports)
  }
}

/***/ }),
/* 1413 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-52cce311"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/modals/justifyModal.pug ***!
  \****************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "id": "justifyModal",
      "closeFunction": _vm.closeModal,
      "closable": "true",
      "size": "modal-new-attribute"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.justificativa'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.selecionarMotivo'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.finMovAdded.length > 0 && _vm.bankStatAdded.length > 0),
      expression: "finMovAdded.length > 0 && bankStatAdded.length > 0"
    }],
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-md-3 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "valueJustify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.valorJustificar'))
    }
  }), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTotal),
      expression: "!isTotal"
    }],
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('money', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('valueJustify')
    },
    attrs: {
      "disabled": _vm.isTotal,
      "maxlength": "14",
      "id": "valueJustify",
      "name": "valueJustify"
    },
    model: {
      value: (_vm.valueJustify),
      callback: function($$v) {
        _vm.valueJustify = $$v
      },
      expression: "valueJustify"
    }
  }, 'money', _vm.money, false)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('valueJustify', 'required')),
      expression: "errors.firstByRule('valueJustify', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('valueJustify', 'numeric')),
      expression: "errors.firstByRule('valueJustify', 'numeric')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.somenteNumeros'))
    }
  })], 1), _c('div', {
    staticClass: "col-md-3 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justifyType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.justificar'))
    }
  }), _c('div', {
    staticClass: "radio radio-success",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "disabled": _vm.finMovAdded.length === 0 || _vm.bankStatAdded.length === 0
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isTotal),
      expression: "isTotal"
    }],
    attrs: {
      "disabled": _vm.finMovAdded.length === 0 || _vm.bankStatAdded.length === 0,
      "type": "radio",
      "name": "status",
      "id": "parcial"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isTotal, false)
    },
    on: {
      "change": function($event) {
        _vm.isTotal = false
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "parcial"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.parcial'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isTotal),
      expression: "isTotal"
    }],
    attrs: {
      "disabled": _vm.finMovAdded.length === 0 || _vm.bankStatAdded.length === 0,
      "type": "radio",
      "name": "status",
      "id": "total"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isTotal, true)
    },
    on: {
      "change": function($event) {
        _vm.isTotal = true
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "total"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.total'))
    }
  })])]), _c('div', {
    staticClass: "col-md-3 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "valueDivergence"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.divergencia'))
    }
  }), _c('h4', {
    staticClass: "text-left",
    class: _vm.getValueClass(_vm.totalDivergenceTransformed)
  }, [_vm._v(_vm._s(_vm.totalDivergenceTransformed))])]), _c('div', {
    staticClass: "col-md-3 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "notJustifiedValue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.naoJustificado'))
    }
  }), _c('i', {
    staticClass: "fa fa-info-circle icon-margin-left",
    attrs: {
      "title": _vm.$t('conciliacaoManual.labels.tooltipJustificativa')
    }
  }), _c('h4', {
    staticClass: "text-left",
    class: _vm.getValueClass(_vm.totalNotJustified),
    attrs: {
      "id": "labelTotalNotJustified"
    }
  }, [_vm._v(_vm._s(_vm.totalNotJustified))])])]), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-md-12 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "selectedOccurrenceReason"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.titulos.cadastroTitulo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "col-md-12 pl-0"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('selectedOccurrenceReason')
    },
    attrs: {
      "options": _vm.occurrenceReasons,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "selectedOccurrenceReason",
      "id": "selectedOccurrenceReason",
      "name": "selectedOccurrenceReason"
    },
    model: {
      value: (_vm.selectedOccurrenceReason),
      callback: function($$v) {
        _vm.selectedOccurrenceReason = $$v
      },
      expression: "selectedOccurrenceReason"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('selectedOccurrenceReason', 'required')),
      expression: "errors.firstByRule('selectedOccurrenceReason', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-md-12 pl-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "commentary"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.comentario'))
    }
  })]), _c('div', {
    staticClass: "col-md-12 pl-0"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.commentary),
      expression: "commentary"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('accountName')
    },
    attrs: {
      "type": "text",
      "id": "commentary",
      "name": "commentary",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.commentary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentary = $event.target.value
      }
    }
  })])])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    attrs: {
      "label": _vm.$t('dataTable.labels.acaoFechar'),
      "customClass": "secondary",
      "id": "btnFecharModalJustificarLote",
      "clickFunction": _vm.closeModal,
      "disabled": _vm.disableButton
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.justificar'),
      "disabled": !_vm.itsAbleToJustify,
      "id": "btnConfirmacaoJustificarLote",
      "clickFunction": _vm.confirmJustifyAllotment
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52cce311", module.exports)
  }
}

/***/ }),
/* 1414 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-54cd97fd"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/menu/topBar.pug ***!
  \************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "pull-left full-height visible-sm visible-xs"
  }, [_c('div', {
    staticClass: "sm-action-bar"
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "sidebar"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.isOpen ? "fa-chevron-left" : "fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _c('div', {
    staticClass: "aplicacao-nome-topo"
  }, [_c('router-link', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": _vm.home
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearSelectedMenuItem.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("banking")])])], 1), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "visible-lg visible-md m-t-10"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "user-info pull-right"
  }, [_c('span', {
    staticClass: "user-info-username"
  }, [_vm._v(_vm._s(_vm.username))]), _c('hr', {
    staticClass: "separador-informacoes"
  }), _c('span', {
    staticClass: "user-info-client"
  }, [_vm._v(_vm._s(_vm.clientActive))])])]), _c('div', {
    staticClass: "inline"
  }, [_c('div', {
    staticClass: "top-user-icons inline pull-right"
  }, [_c('suspended-menu')], 1)])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54cd97fd", module.exports)
  }
}

/***/ }),
/* 1415 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-57b95c2f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/dashboard/chartFilter/DailyBankStatment.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('filters-common', {
    attrs: {
      "data": _vm.filters
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57b95c2f", module.exports)
  }
}

/***/ }),
/* 1416 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-58825cfb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/conciliationSummary/calendarSummary.pug ***!
  \*************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendaSummary"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('calendar-view', {
    attrs: {
      "setStartDate": _vm.setStartDate,
      "setEndDate": _vm.setEndDate,
      "setMonth": _vm.handleMonthChange,
      "monthToShow": _vm.selectedMonth,
      "conciliacaoData": _vm.conciliacaoData,
      "isLoadingData": _vm.isLoadingData,
      "categories": _vm.categories,
      "selectedCategory": _vm.selectedCategory,
      "setCategory": _vm.setCategory
    }
  })], 1), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('calendar-detail-box', {
    attrs: {
      "startDate": _vm.selectedStartDate,
      "endDate": _vm.selectedEndDate,
      "conciliacaoData": _vm.conciliacaoData,
      "parentLoadingData": _vm.isLoadingData,
      "filteredCategory": _vm.selectedCategory,
      "setCategory": _vm.setCategory
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58825cfb", module.exports)
  }
}

/***/ }),
/* 1417 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb3e11e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/login/login.pug ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inicial-bodies col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2 px-0"
  }, [_c('div', {
    staticClass: "inicial-body2 inicial-body-step-2 is-showing"
  }, [_c('div', {
    staticClass: "formulario-login-topo"
  }, [_c('div', {
    staticClass: "formulario-login-topo-logo"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logoEqualsLoginPng,
      "alt": "EQUALS"
    }
  })]), _c('button', {
    staticClass: "btn btn-idioma",
    staticStyle: {
      "z-index": "2",
      "position": "relative"
    },
    attrs: {
      "title": _vm.$t('login.titulos.abrirSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.escolherIdioma()
      }
    }
  }, [(!_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e(), (_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaAtivoPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abrirIdiomas && !_vm.logadoSuccess),
      expression: "abrirIdiomas && !logadoSuccess"
    }],
    staticClass: "escolhaIdiomas col-sm-12 px-0"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "pull-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.idioma'))
    }
  }), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-pt btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('pt')
      }
    }
  }, [_vm._v("PT")]), _c('button', {
    staticClass: "btn-in btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.eng')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('in')
      }
    }
  }, [_vm._v("ENG")]), _c('button', {
    staticClass: "btn-es btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.esp')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('es')
      }
    }
  }, [_vm._v("ESP")])]), _c('button', {
    staticClass: "btn btn-fechar-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.fecharSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.fecharEscolherIdioma()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fecharPng,
      "width": "23",
      "height": "23"
    }
  })])])])]), (!_vm.logadoSuccess) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formulario-login"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "45px",
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userPng
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginInputLog",
      "type": "text",
      "placeholder": _vm.$t('login.placeholders.usuario'),
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), (_vm.logadoError) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.erro.login'))
    }
  }) : _vm._e(), (_vm.campoUsernameVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailVazio'))
    }
  }) : _vm._e(), (_vm.campoUsernameInvalido) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailInvalido'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.passwordPng
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginSenha",
      "placeholder": _vm.$t('login.placeholders.senha'),
      "type": "password",
      "name": "password",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), (_vm.logadoError) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.erro.senha'))
    }
  }) : _vm._e(), (_vm.campoPassVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.senhaVazia'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "recuperarSenha"
  }, [_c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.esqueceuSenha'))
    },
    on: {
      "click": _vm.trocaTelaRecuperarSenha
    }
  })]), (_vm.isProbableABot) ? _c('div', {
    staticClass: "recaptcha-form"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.PUBLIC_KEY,
      "size": "normal"
    },
    on: {
      "verify": _vm.onVerifyLogin
    }
  })], 1) : _vm._e()]), _c('button', {
    staticClass: "btn button-login",
    attrs: {
      "type": "submit",
      "title": _vm.$t('login.titulos.entrar'),
      "disabled": _vm.disableLoginButton
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.entrar'))
    }
  })]) : _vm._e(), (_vm.logadoSuccess) ? _c('div', {
    staticClass: "formulario-login logado"
  }, [_c('img', {
    attrs: {
      "src": _vm.logadoOkPng,
      "width": "89",
      "height": "89"
    }
  }), _c('div', {
    staticClass: "logado-ok",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.sucesso.login'))
    }
  }), _c('div', {
    staticClass: "bem-vindo",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.bemVindo'))
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "inicial-body3 inicial-body-step-3",
    staticStyle: {
      "border": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid rgba(255, 255, 255, 1)"
    }
  }, [_c('div', {
    staticClass: "formulario-login-topo"
  }, [_c('div', {
    staticClass: "formulario-login-topo-logo"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": _vm.logoEqualsLoginPng,
      "alt": "EQUALS"
    }
  })]), _c('button', {
    staticClass: "btn btn-idioma",
    attrs: {
      "title": _vm.$t('login.titulos.abrirSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.escolherIdioma()
      }
    }
  }, [(!_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e(), (_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaAtivoPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abrirIdiomas),
      expression: "abrirIdiomas"
    }],
    staticClass: "escolhaIdiomas col-sm-12 px-0"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "pull-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.idioma'))
    }
  }), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-pt btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('pt')
      }
    }
  }, [_vm._v("PT")]), _c('button', {
    staticClass: "btn-in btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('in')
      }
    }
  }, [_vm._v("ENG")]), _c('button', {
    staticClass: "btn-es btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('es')
      }
    }
  }, [_vm._v("ESP")])]), _c('button', {
    staticClass: "btn btn-fechar-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.fecharSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.fecharEscolherIdioma()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fecharPng,
      "width": "23",
      "height": "23"
    }
  })])])])]), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.recoverPassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formulario-login"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "45px",
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userPng
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "loginInputRec",
      "type": "text",
      "placeholder": _vm.$t('login.placeholders.usuario')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), (_vm.campoUsernameInvalido) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailInvalido'))
    }
  }) : _vm._e(), (_vm.campoUsernameVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailVazio'))
    }
  }) : _vm._e()]), _c('form', {
    staticClass: "recaptcha-form",
    attrs: {
      "action": "?",
      "method": "POST"
    }
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.PUBLIC_KEY,
      "size": "normal"
    },
    on: {
      "verify": _vm.onVerify
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    on: {
      "onclick": _vm.recoverPassword
    }
  })])], 1)]), _c('button', {
    staticClass: "btn button-login",
    attrs: {
      "type": "submit",
      "title": _vm.$t('login.titulos.recuperarSenha'),
      "disabled": _vm.disableRecoveryButton
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.recuperarSenha'))
    }
  })])]), _c('button', {
    staticClass: "btn button2",
    attrs: {
      "title": _vm.$t('login.titulos.voltar')
    },
    on: {
      "click": function($event) {
        return _vm.trocaTelaVoltar()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.voltarPng,
      "width": "33",
      "height": "33"
    }
  }), _c('span', {
    staticClass: "text-white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.voltar'))
    }
  })])]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "img-bottom"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("ambiente-seguro-")
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-6 text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("premio-br-week-")
    }
  })]), _c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("certificado-saae18-")
    }
  })])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5cb3e11e", module.exports)
  }
}

/***/ }),
/* 1418 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e2ad742"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/integration/remittanceIntegration/remittanceIntegrationModal.pug ***!
  \******************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('better-modal', {
    attrs: {
      "closable": true,
      "id": "remittanceDetailModal",
      "tabbedModal": true,
      "showFooter": false,
      "bringBack": true
    },
    on: {
      "close-modal": _vm.closeModal,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header",
      "id": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modal.text.title)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modal.text.subtitle)
    }
  })]), _c('div', {
    staticClass: "tabbed-modal-body",
    attrs: {
      "slot": "body",
      "id": "body"
    },
    slot: "body"
  }, [_vm._t("default", function() {
    return [_c('vue-tabs', {
      ref: "tabRouter",
      attrs: {
        "id": "tabbed-modal",
        "direction": "vertical"
      },
      model: {
        value: (_vm.tabName),
        callback: function($$v) {
          _vm.tabName = $$v
        },
        expression: "tabName"
      }
    }, _vm._l((_vm.tabs), function(tab) {
      return (_vm.verifyTabAuthorization(tab)) ? _c('v-tab', {
        key: tab.idTabRoot,
        ref: tab.tabRef,
        refInFor: true,
        staticClass: "tab",
        attrs: {
          "id": tab.idTabRoot,
          "title": tab.idTabRoot
        }
      }, [_c('div', {
        staticClass: "tab-left",
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_c('i', {
        class: tab.icon
      }), _c('span', {
        staticClass: "title title_center",
        domProps: {
          "innerHTML": _vm._s(tab.title)
        }
      })]), _c(tab.type, _vm._b({
        tag: "component",
        attrs: {
          "id": tab.idTabContent
        }
      }, 'component', tab.props, false))], 1) : _vm._e()
    }), 1)]
  }, {
    "tabs": "tabs"
  })], 2)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5e2ad742", module.exports)
  }
}

/***/ }),
/* 1419 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6021cb38"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/assignment/list.pug ***!
  \******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assignmentWrapper"
    }
  }, [_c('grid-details-modal', {
    attrs: {
      "id": _vm.modalId,
      "closable": true,
      "tabs": _vm.modalDetailsTabs,
      "defaultTab": _vm.defaultTab,
      "labelModalTitle": _vm.modalTitle,
      "labelModalSubTitle": _vm.modalSubTitle,
      "isOpen": _vm.isOpenDetailsModal
    },
    on: {
      "closeDetailsModal": _vm.closeDetailsModal
    }
  }), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('consultaTarefa.titulos.titulo'),
      "subTitle": _vm.$t('consultaTarefa.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('consultaTarefa.titulos.filtroTitulo')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-6 pl-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "selectQueryBase"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.baseConsulta'))
    }
  })]), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 px-0"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.queryBaseOptions,
      "label": "label",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "queryBaseSelected",
      "id": "queryBaseSelect",
      "name": "queryBaseSelect"
    },
    on: {
      "input": _vm.showDatePicker
    },
    model: {
      value: (_vm.queryBaseSelected),
      callback: function($$v) {
        _vm.queryBaseSelected = $$v
      },
      expression: "queryBaseSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)])]), (_vm.showDate) ? _c('div', {
    staticClass: "col-xs-6 px-0"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 200,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row-filter-small col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', [_c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter spaced-bottom-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignCheck),
      expression: "assignCheck"
    }],
    attrs: {
      "id": "assignedToMe",
      "type": "checkbox",
      "name": "assign"
    },
    domProps: {
      "checked": Array.isArray(_vm.assignCheck) ? _vm._i(_vm.assignCheck, null) > -1 : (_vm.assignCheck)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.assignCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.assignCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.assignCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.assignCheck = $$c
        }
      }, _vm.trackCheckBox]
    }
  }), _c('label', {
    staticClass: "control-label func-group-labels check-atribuidas",
    attrs: {
      "for": "assignedToMe"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.atribuidas'))
    }
  })])])])]), _c('div', {
    staticClass: "row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-6 pl-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "typeLinkSelect"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.origem'))
    }
  })]), _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 px-0"
  }, [_c('v-select', {
    attrs: {
      "multiple": "multiple",
      "options": _vm.filteredOriginOptions,
      "label": "label",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "typeLinkSelected",
      "id": "typeLinkSelect",
      "name": "typeLinkSelect"
    },
    on: {
      "input": _vm.trackOrigem
    },
    model: {
      value: (_vm.typeLinkSelected),
      callback: function($$v) {
        _vm.typeLinkSelected = $$v
      },
      expression: "typeLinkSelected"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)])]), _c('div', {
    staticClass: "row-filter-small col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consultaTarefa.labels.situacaoLabel'))
    }
  }), _vm._l((_vm.situationList), function(situation, idx) {
    return _c('div', [_c('div', {
      staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (situation.checked),
        expression: "situation.checked"
      }],
      attrs: {
        "id": situation.id,
        "type": "checkbox",
        "name": "situation"
      },
      domProps: {
        "checked": Array.isArray(situation.checked) ? _vm._i(situation.checked, null) > -1 : (situation.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = situation.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(situation, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(situation, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(situation, "checked", $$c)
          }
        }, function($event) {
          return _vm.trackCheckBoxSituacao(situation.nome)
        }]
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": situation.id
      }
    }, [_vm._v(_vm._s(situation.nome))])])])
  })], 2)]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('button-primary', {
    staticClass: "search-button pull-right",
    attrs: {
      "label": _vm.$t('logDeAuditoria.labels.buscar'),
      "id": "btnConsultaTarefas",
      "type": "submit",
      "disabled": _vm.disableSearchButton
    }
  })], 1)])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "assignmentGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "Tarefas",
      "treeGridLayoutPath": "",
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6021cb38", module.exports)
  }
}

/***/ }),
/* 1420 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-61521a9e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/pendingConciliations.pug ***!
  \*****************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending-conciliation-box",
    attrs: {
      "id": "pending-conciliations-wrapper"
    }
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 pending-box grey-right-border"
  }, [_c('h4', {
    staticClass: "pending-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridMovimentosFinanceiros'))
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegridMov),
      expression: "showTreegridMov"
    }],
    staticClass: "row"
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "concManualMovFin",
      "result": _vm.resultMov,
      "treeGridLayoutPath": "bankStatement",
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "concManualMovFin",
      "cfgObj": _vm.treeGridCfgMov,
      "showExportButton": false,
      "showHrTopGrid": false
    }
  }), _c('div', {
    staticClass: "clear"
  }), (_vm.showHideButtonAddAllMovFin) ? _c('button', {
    staticClass: "btn btn-info common button-addAll",
    attrs: {
      "id": "btnAddAllMovFin",
      "type": "button"
    },
    on: {
      "click": [function($event) {
        $event.preventDefault();
        return _vm.startLoading.apply(null, arguments)
      }, _vm.addAllRowsFinMov]
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down pull-right icon-button-addAll-right"
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.adicionarTodos'))
    }
  })]) : _vm._e()], 1)]), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', {
    staticClass: "pending-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridExtratoBancario'))
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegridExt),
      expression: "showTreegridExt"
    }],
    staticClass: "row"
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "concManualExtBanc",
      "result": _vm.resultExt,
      "treeGridLayoutPath": "auditoria",
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "concManualExtBanc",
      "cfgObj": _vm.treeGridCfgExt,
      "showExportButton": false,
      "showHrTopGrid": false
    }
  }), _c('div', {
    staticClass: "clear"
  }), (_vm.showHideButtonAddAllBankStat) ? _c('button', {
    staticClass: "btn btn-info common button-addAll",
    attrs: {
      "id": "btnAddAllBankStat",
      "type": "button"
    },
    on: {
      "click": [function($event) {
        $event.preventDefault();
        return _vm.startLoading.apply(null, arguments)
      }, _vm.addAllRowsBankStat]
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down pull-right icon-button-addAll-right"
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.adicionarTodos'))
    }
  })]) : _vm._e()], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61521a9e", module.exports)
  }
}

/***/ }),
/* 1421 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-632aab56"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/dashboard.pug ***!
  \*************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-bar', {
    attrs: {
      "title": _vm.$t('dashboard.titulos.portlet'),
      "subTitle": _vm.$t('dashboard.titulos.portlet')
    }
  }, [_c('div', {
    attrs: {
      "slot": "fields"
    },
    slot: "fields"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "style-chooser",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('filter.periodType')
    },
    attrs: {
      "options": _vm.periodList,
      "clearable": false,
      "id": "periodType",
      "name": "periodType",
      "value": "id"
    },
    on: {
      "input": _vm.onPeriodChanged
    },
    model: {
      value: (_vm.filter.periodType),
      callback: function($$v) {
        _vm.$set(_vm.filter, "periodType", $$v)
      },
      expression: "filter.periodType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('filter.periodType')),
      expression: "errors.has('filter.periodType')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('date-range', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDateRange()),
      expression: "showDateRange()"
    }],
    ref: "dateRange",
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6 px-0",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable,
      "displayLabel": false,
      "displayAction": true,
      "action": _vm.setCustomRangeFilter
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _c('br'), _c('draggable', {
    attrs: {
      "list": _vm.charts,
      "handle": ".dashboard-top"
    },
    on: {
      "end": _vm.saveDashboard
    }
  }, _vm._l((_vm.charts), function(chart, index) {
    return _c('chart', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.configChartShow(chart)),
        expression: "configChartShow(chart)"
      }],
      key: chart.idChartTemplate + chart.container,
      staticClass: "chart-item",
      class: chart.container === "chartFull" ? "col-md-12" : "col-md-6",
      attrs: {
        "chart": chart,
        "id": chart.idChart,
        "showTaskGadget": chart.showTaskGadget
      },
      on: {
        "onResize": function($event) {
          return _vm.resize(index, chart)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-632aab56", module.exports)
  }
}

/***/ }),
/* 1422 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-632d0eea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/home/Home.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-wrapper"
    }
  }, [_c('top-bar'), _c('sidebar-menu'), _c('client-modal', {
    attrs: {
      "auto-open": true
    }
  }), _c('my-account-modal'), _c('change-application-modal'), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-632d0eea", module.exports)
  }
}

/***/ }),
/* 1423 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-63472d8e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabClassification/tabClassification.pug ***!
  \*****************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-details-wrapper"
    }
  }, [(_vm.isLoadingData) ? _c('div', {
    staticClass: "col-md-12 col-sm-10",
    attrs: {
      "id": "tasks-loading"
    }
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : (!_vm.isLoadingData) ? _c('div', {
    staticClass: "main-container",
    attrs: {
      "id": "main-detail-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "main-value-detail-container"
    }
  }, _vm._l((_vm.valuesList), function(mainValue, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('h4', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(mainValue.title))]), _c('h4', {
      staticClass: "tab-detail-value"
    }, [_vm._v(_vm._s(mainValue.value))])]), (index > 1 && (index + 1) % 3 === 0) ? _c('div', {
      staticClass: "clear"
    }) : _vm._e()])
  }), 0), _c('div', {
    staticClass: "status-container bordered",
    attrs: {
      "id": "statuses-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('br'), _c('h4', {
    staticClass: "tab-detail-value"
  }, [_vm._v(_vm._s(_vm.titleFormClassif)), _c('i', {
    staticClass: "fa fa-info-circle icon-margin-left",
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabClassif.tooltipClassificacao')
    }
  })])]), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('h4', {
    staticClass: "detail-title"
  }, [_vm._v(_vm._s(_vm.$t('modalDetalhesLanc.tabClassif.critClassif')) + " " + _vm._s(_vm.defineClassificationLabel))])]), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankMovPlan"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.details.titulos.planoConciliacao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    key: "bankMovPlan",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('bankMov.planoConciliacao')
    },
    attrs: {
      "options": _vm.conciliationPlans,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "bankMov.planoConciliacao",
      "id": "bankMovPlan",
      "name": "bankMovPlan",
      "disabled": _vm.conciliationPlansLenght
    },
    on: {
      "input": _vm.bindConciliationPlan
    },
    model: {
      value: (_vm.bankMov.planoConciliacao),
      callback: function($$v) {
        _vm.$set(_vm.bankMov, "planoConciliacao", $$v)
      },
      expression: "bankMov.planoConciliacao"
    }
  }), (!_vm.existsConciliationPlans) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabClassif.infos.semPlanoConciliacao'))
    }
  }) : _vm._e(), (_vm.existsConciliationPlans) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bankMov.planoConciliacao')),
      expression: "errors.has('bankMov.planoConciliacao')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e(), _c('br')], 1), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankMovCategory"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.details.titulos.dsCat'))
    }
  }), _c('v-select', {
    key: "bankMovCategory",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.categories,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "bankMov.categoria",
      "id": "bankMovCategory",
      "name": "bankMovCategory",
      "disabled": _vm.bankMov.situacaoConciliacao !== 'A'
    },
    model: {
      value: (_vm.bankMov.categoria),
      callback: function($$v) {
        _vm.$set(_vm.bankMov, "categoria", $$v)
      },
      expression: "bankMov.categoria"
    }
  }), _c('br')], 1), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankMovEstablishment"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.details.titulos.estabelecimento'))
    }
  }), _c('i', {
    staticClass: "fa fa-info-circle icon-margin-left",
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabClassif.tooltipEstab')
    }
  }), _c('v-select', {
    class: {
      'input': true
    },
    attrs: {
      "id": "bankMovEstablishment",
      "name": "bankMovEstablishment",
      "value": "id",
      "label": "nome",
      "placeholder": _vm.$t('estabelecimentos.labels.filtro.buscar'),
      "options": _vm.establishments,
      "disabled": _vm.bankMov.situacaoConciliacao !== 'A'
    },
    on: {
      "search": _vm.loadEstablishments
    },
    nativeOn: {
      "change": function($event) {
        return _vm.handleClearList.apply(null, arguments)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(((option.nome !== null ? option.nome : '') + " - " + (option.cnpj !== null ? option.cnpj : '')))
          }
        })]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(((option.nome !== null ? option.nome : '') + " - " + (option.cnpj !== null ? option.cnpj : '')))
          }
        })]
      }
    }]),
    model: {
      value: (_vm.bankMov.estabelecimento),
      callback: function($$v) {
        _vm.$set(_vm.bankMov, "estabelecimento", $$v)
      },
      expression: "bankMov.estabelecimento"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('br')], 1), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('div', {
    staticClass: "input-button pull-right"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.enableRemove ? _vm.$t('modalDetalhesLanc.tabClassif.btnEdit') : _vm.$t('modalDetalhesLanc.tabClassif.btnSalvar'),
      "id": "btnSalvarClassif",
      "clickFunction": _vm.validate,
      "disabled": _vm.bankMov.situacaoConciliacao !== 'A'
    }
  }), (_vm.enableRemove) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabClassif.btnRemover'),
      "id": "btnRemoverClassif",
      "customClass": "danger",
      "clickFunction": _vm.remove
    }
  }) : _vm._e()], 1)])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-63472d8e", module.exports)
  }
}

/***/ }),
/* 1424 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-648087e0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/categories/list.pug ***!
  \****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('categoria.titulos.titulo'),
      "subTitle": _vm.$t('categoria.titulos.subtitulo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('categoria.labels.novaCategoria'),
      "id": "btnCriarNovaCategoria",
      "clickFunction": _vm.createEditCategory
    },
    slot: "new-button"
  }), _c('div', {
    staticClass: "clear"
  })], 1), _c('div', {
    attrs: {
      "id": "categories"
    }
  }, [(_vm.isLoadingDataGeneral) ? _c('div', {
    staticClass: "isLoadingDataGeneral"
  }) : _vm._e(), (_vm.categories && _vm.categories.length > 0) ? _c('div', [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-xs-5 col-sm-7 col-md-6 col-lg-4 categories-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.descricao'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 categories-type",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.tipo'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 categories-initial-balance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.saldoInicial'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-2 categories-initial-balance-date",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.dataSaldoInicial'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-1"
  }, [_c('div', {
    staticClass: "categories-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _vm._l((_vm.categories), function(category) {
    return _c('div', [_c('vue-drag-tree', {
      staticClass: "vue-drag-tree",
      attrs: {
        "model": category,
        "clickFunction": _vm.createEditCategory,
        "clickRemoveFunction": _vm.handleRemove,
        "showRemove": true,
        "father": category,
        "id": category.id,
        "buttonsTitle": _vm.treeViewButtonTitle,
        "current-highlight": false,
        "default-text": null,
        "hover-color": "lightblue"
      }
    }), _c('div', {
      staticClass: "clear"
    })], 1)
  })], 2) : _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.resultadoVazio'))
    }
  })])])], 1)]), (_vm.shown) ? _c('categorie-modal', {
    attrs: {
      "idEditingCategory": _vm.idEditingCategory,
      "subCategoryParent": _vm.parentCategory,
      "categories": _vm.categories,
      "lastCategoryOrder": _vm.lastCategoryOrder
    },
    on: {
      "close-modal": function($event) {
        _vm.shown = false
      }
    }
  }) : _vm._e(), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveCategory"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverCategory",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "disabled": _vm.requestSentRemove,
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverCategory",
      "clickFunction": _vm.removeCategory
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-648087e0", module.exports)
  }
}

/***/ }),
/* 1425 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-65d81ebc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/bankStatement/bankStatement.pug ***!
  \***********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bankStatementWrapper"
    }
  }, [_c('grid-details-modal', {
    attrs: {
      "id": _vm.bankStatGridModalId,
      "closable": true,
      "tabs": _vm.modalDetailsTabs,
      "isOpen": _vm.isOpenDetailsModal
    },
    on: {
      "closeDetailsModal": _vm.closeDetailsModal
    }
  }), (_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts,
      "groups": _vm.groups,
      "groupingOptions": _vm.groupingOptions
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('extratoBancario.titulos.extratoBancario'),
      "subTitle": _vm.$t('extratoBancario.titulos.visualize')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('extratoBancario.titulos.filtroTitulo')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "hasExportFile": true,
      "exportFileFlag": _vm.isExportFile,
      "showLoadingFullPage": false
    },
    on: {
      "update-flagExportingFile": function($event) {
        _vm.isExportFile = !_vm.isExportFile
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 100,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('extratoBancario.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('extratoBancario.labels.selecionarContasBancarias'),
      "id": "btnSelecionarContasBancarias",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.labels.consultaPor'))
    }
  }), _c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryNotClassif),
      expression: "queryNotClassif"
    }],
    attrs: {
      "id": "notClassif",
      "type": "checkbox",
      "disabled": _vm.queryNotClassif && !_vm.queryOnlyClassif,
      "name": "notClassif"
    },
    domProps: {
      "checked": Array.isArray(_vm.queryNotClassif) ? _vm._i(_vm.queryNotClassif, null) > -1 : (_vm.queryNotClassif)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.queryNotClassif,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.queryNotClassif = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.queryNotClassif = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.queryNotClassif = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "notClassif"
    }
  }, [_vm._v(_vm._s(_vm.$t('extratoBancario.labels.consultaApenasNaoClassif')))])]), _c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter",
    staticStyle: {
      "marginTop": "1px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryOnlyClassif),
      expression: "queryOnlyClassif"
    }],
    attrs: {
      "id": "onlyClassif",
      "type": "checkbox",
      "disabled": _vm.queryOnlyClassif && !_vm.queryNotClassif,
      "name": "onlyClassif"
    },
    domProps: {
      "checked": Array.isArray(_vm.queryOnlyClassif) ? _vm._i(_vm.queryOnlyClassif, null) > -1 : (_vm.queryOnlyClassif)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.queryOnlyClassif,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.queryOnlyClassif = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.queryOnlyClassif = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.queryOnlyClassif = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "onlyClassif"
    }
  }, [_vm._v(_vm._s(_vm.$t('extratoBancario.labels.consultaApenasClassif')))])])])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "ExtratoConta",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "extratoBancario",
      "showMassDeclassifyAction": true,
      "showMassTaskAction": true,
      "showAlert": true,
      "cfgObj": _vm.treeGridCfg,
      "alertMessage": _vm.$t('extratoBancario.labels.alertaGrid')
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65d81ebc", module.exports)
  }
}

/***/ }),
/* 1426 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-65f48b0a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/filter/filterCommon.pug ***!
  \***********************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasData) ? _c('div', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "filter-common",
    class: _vm.shown ? "open" : "closed"
  }, [_c('div', {
    staticClass: "filter-common-selected",
    class: _vm.disabled ? "disabled" : "",
    attrs: {
      "title": _vm.getTitle(_vm.selected.label)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "filter-common-selected-text"
  }, [_vm._v(_vm._s(_vm.selected.label))]), _c('i', {
    staticClass: "filter-common-arrow"
  })]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.hasGroups) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shown),
      expression: "shown"
    }],
    staticClass: "filter-common-list"
  }, _vm._l((_vm.getDisplayOptions()), function(value, index) {
    return _c('div', {
      staticClass: "filter-common-list-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.select(value)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(value.label))])])
  }), 0)]) : _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shown),
      expression: "shown"
    }],
    staticClass: "filter-common-list"
  }, _vm._l((_vm.options), function(group, index) {
    return _c('div', [(_vm.getDisplayOptions(group).length > 0) ? _c('div', [_c('div', {
      staticClass: "group-title"
    }, [_c('span', [_vm._v(_vm._s(group.groupName))])]), _c('hr', {
      staticClass: "magin-small"
    }), _vm._l((_vm.getDisplayOptions(group)), function(value) {
      return _c('div', {
        staticClass: "filter-group-list-item",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.select(value)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(value.label))])])
    })], 2) : _vm._e()])
  }), 0)])])], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65f48b0a", module.exports)
  }
}

/***/ }),
/* 1427 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-66125f00"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabHistoric/tabHistoric.pug ***!
  \*****************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-modal-content-full",
    attrs: {
      "id": "tab-historic-wrapper"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : _vm._e(), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historicEmpty),
      expression: "historicEmpty"
    }],
    staticClass: "empty-value",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabHistorico.labels.resultadoVazio'))
    }
  })]), _vm._l((_vm.historics), function(historic, $index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.historicEmpty),
        expression: "!historicEmpty"
      }],
      staticClass: "historic-line col-md-12 col-sm-10"
    }, [_c('div', {
      staticClass: "historic-line-date"
    }, [_c('ul', {
      class: _vm.isFirst($index) ? 'historic-line-date-ul-first' : 'historic-line-date-ul'
    }, [_c('li', [_c('b', [_vm._v(_vm._s(historic.data) + " ")]), _vm._v("- " + _vm._s(historic.hora))])]), _c('div', {
      class: _vm.getClassContent($index)
    }, [_c('div', {
      class: _vm.isFirst($index) ? 'historic-line-data-content-first' : 'historic-line-data-content'
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabHistorico.labels.responsavel'))
      }
    }), _c('b', [_vm._v(_vm._s(historic.usuario))])]), _c('div', {
      staticClass: "col-md-3"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabHistorico.labels.status'))
      }
    }), _c('b', {
      class: _vm.getStyleByStatus(historic.status),
      domProps: {
        "innerHTML": _vm._s(_vm.$t(_vm.getLabelStatus(historic.status)))
      }
    })]), _c('div', {
      staticClass: "col-md-3"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabHistorico.labels.idLote'))
      }
    }), _c('b', [_vm._v(_vm._s(historic.idLote))])]), _c('div', {
      staticClass: "col-md-3"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabHistorico.labels.acao'))
      }
    }), _c('b', {
      domProps: {
        "innerHTML": _vm._s(historic.acao ? _vm.$t(_vm.getKeyAction(historic.acao)) : ' - ')
      }
    })]), _c('div', {
      staticClass: "clear"
    })])])])])
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66125f00", module.exports)
  }
}

/***/ }),
/* 1428 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-66984113"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/conciliationPlan/list.pug ***!
  \**********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.planosConciliacao'),
      "subTitle": _vm.$t('planoConciliacao.titulos.visualizacao')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('planoConciliacao.labels.novoPlano'),
      "id": "btnNovoPlanoDeConciliacao",
      "clickFunction": _vm.newPlan,
      "title": _vm.plans && _vm.plans.length > 0 ? _vm.$t('planoConciliacao.labels.cadastroPlanoBloquado') : _vm.$t('planoConciliacao.labels.cadastroPlano'),
      "disabled": _vm.plans && _vm.plans.length > 0
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "plans"
    }
  }, [(_vm.plans && _vm.plans.length > 0) ? _c('div', [_c('div', {
    staticClass: "plans-header"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-4 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.nomePlano'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-2 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-2 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevancia'))
    }
  }), _c('div', {
    staticClass: "col-xs-2 col-sm-2 col-md-3 col-lg-2 plans-header-column-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-1"
  }, [_c('div', {
    staticClass: "plans-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _vm._l((_vm.plans), function(plan) {
    return _c('div', [_c('vue-drag-tree', {
      staticClass: "vue-drag-tree",
      attrs: {
        "model": plan,
        "clickFunction": _vm.createEditPlan,
        "clickRemoveFunction": _vm.handleRemove,
        "showRemove": true,
        "father": plan,
        "id": plan.id,
        "buttonsTitle": _vm.treeViewButtonTitle,
        "current-highlight": false,
        "default-text": null,
        "hover-color": "lightblue"
      }
    }), _c('div', {
      staticClass: "clear"
    })], 1)
  })], 2) : _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.resultadoVazio'))
    }
  })])])], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemovePlan"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverPlan",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverPlan",
      "clickFunction": _vm.removePlan
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66984113", module.exports)
  }
}

/***/ }),
/* 1429 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-676cf406"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/input/inputEstablishment/inputEstablishment.pug ***!
  \*************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "establishmentFilter"
    }
  }, [(_vm.canShowModal) ? _c('div', {
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [(_vm.shown) ? _c('multi-select-modal', {
    attrs: {
      "id": _vm.id,
      "data": _vm.establishments,
      "dynamicColumns": _vm.dynamicColumns
    },
    on: {
      "update:data": function($event) {
        _vm.establishments = $event
      },
      "close-modal": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "m-b-15",
    attrs: {
      "slot": "dynamicColumnsInput"
    },
    slot: "dynamicColumnsInput"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "search"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.selecaoColunas'))
    }
  }), _c('v-select', {
    attrs: {
      "multiple": "multiple",
      "id": "search",
      "name": "search",
      "label": "nomeDefinido",
      "index": "id",
      "options": _vm.attributesList,
      "placeholder": _vm.$t('estabelecimentos.placeholders.selecaoColunas'),
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.updateColumns,
      "search:blur": function($event) {
        return _vm.changeClickedInputState(false)
      },
      "search:focus": function($event) {
        return _vm.changeClickedInputState(true)
      }
    },
    model: {
      value: (_vm.noop),
      callback: function($$v) {
        _vm.noop = $$v
      },
      expression: "noop"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.estabelecimentos'))
    }
  }), _c('i', {
    staticClass: "fa fa-info-circle icon-margin-left",
    attrs: {
      "title": _vm.$t('estabelecimentos.labels.tooltipInfo')
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.establishments.selectedItems,
      "read-only": false,
      "typeable": true,
      "defaultTagsIfEmpty": _vm.defaultTags,
      "props": _vm.inputTagsProps,
      "possibleTagsSearchTexts": _vm.possibleTagsSearchTexts,
      "fnGetDataFromServer": _vm.getEstablishmentsFromServerDefault,
      "disabled": _vm.disabled,
      "disableInput": _vm.disabled
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.establishments, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('movimentosFinanceiros.labels.selecionarEstabelecimentos'),
      "faIcon": _vm.icon,
      "id": _vm.id + '-btn',
      "clickFunction": _vm.open,
      "disabled": _vm.disabled
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-676cf406", module.exports)
  }
}

/***/ }),
/* 1430 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd12989"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/login/cadastrarSenha.pug ***!
  \********************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inicial-bodies col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2 px-0"
  }, [_c('div', {
    staticClass: "inicial-body2 inicial-body-step-2 is-showing"
  }, [_c('div', {
    staticClass: "formulario-login-topo"
  }, [_c('img', {
    staticClass: "pull-left logo-equals",
    attrs: {
      "src": _vm.logoEqualsLoginPng,
      "alt": "EQUALS"
    }
  }), _c('button', {
    staticClass: "btn btn-idioma",
    attrs: {
      "title": _vm.$t('login.titulos.abrirSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.escolherIdioma()
      }
    }
  }, [(!_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e(), (_vm.abrirIdiomas) ? _c('img', {
    attrs: {
      "src": _vm.idiomaAtivoPng,
      "width": "37",
      "height": "37"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.abrirIdiomas),
      expression: "abrirIdiomas"
    }],
    staticClass: "escolhaIdiomas col-sm-12 px-0"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('p', {
    staticClass: "pull-left",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.idioma'))
    }
  }), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn-pt btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.pt')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('pt')
      }
    }
  }, [_vm._v("PT")]), _c('button', {
    staticClass: "btn-in btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.eng')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('in')
      }
    }
  }, [_vm._v("ENG")]), _c('button', {
    staticClass: "btn-es btn btn-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.esp')
    },
    on: {
      "click": function($event) {
        return _vm.trocarIdioma('es')
      }
    }
  }, [_vm._v("ESP")])]), _c('button', {
    staticClass: "btn btn-fechar-escolher-idioma",
    attrs: {
      "type": "button",
      "title": _vm.$t('login.titulos.fecharSelecaoDeIdioma')
    },
    on: {
      "click": function($event) {
        return _vm.fecharEscolherIdioma()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.fecharPng,
      "width": "23",
      "height": "23"
    }
  })])])])]), (!_vm.success) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.cadastrar.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formulario-login"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nome",
      "type": "text",
      "placeholder": _vm.$t('login.placeholders.usuario')
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), (_vm.campoUsernamaVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailVazio'))
    }
  }) : _vm._e(), (_vm.campoUsernameInvalido) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.emailInvalido'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "senha",
      "placeholder": _vm.$t('login.placeholders.senha'),
      "type": "password"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), (_vm.campoPassVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.senhaVazia'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPass),
      expression: "confirmPass"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "confirmaSenha",
      "placeholder": _vm.$t('login.placeholders.confirmarSenha'),
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPass = $event.target.value
      }
    }
  }), (_vm.campoConfirmPassVazio) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.confirmacaoDeSenha'))
    }
  }) : _vm._e(), (_vm.senhaDiferente) ? _c('div', {
    staticClass: "erro-login",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.validacao.senhasDiferentes'))
    }
  }) : _vm._e()])]), _c('button', {
    staticClass: "btn button-login",
    attrs: {
      "type": "submit",
      "title": _vm.$t('login.titulos.cadastrarSenha'),
      "disabled": _vm.disableCreateButton
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.labels.cadastrarSenha'))
    }
  })]) : _vm._e(), (_vm.success) ? _c('div', {
    staticClass: "formulario-login logado"
  }, [_c('img', {
    attrs: {
      "src": _vm.logadoOkPng,
      "width": "89",
      "height": "89"
    }
  }), _c('div', {
    staticClass: "logado-ok",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.sucesso.login'))
    }
  }), _c('div', {
    staticClass: "bem-vindo",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.sucesso.cadastrarSenha'))
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "img-bottom"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("ambiente-seguro-")
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-6 text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("premio-br-week-")
    }
  })]), _c('div', {
    staticClass: "col-md-3 col-sm-3 text-center",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.carregarImagem("certificado-saae18-")
    }
  })])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bd12989", module.exports)
  }
}

/***/ }),
/* 1431 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f5ddfa2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/integration/processedFiles/processedFiles.pug ***!
  \*****************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "processedArchives"
    }
  }, [_c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('arquivosProcessados.titulos.titulo'),
      "subTitle": _vm.$t('arquivosProcessados.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('arquivosProcessados.titulos.filtro')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 365
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('archivesPeriodLimited', 'required')),
      expression: "errors.firstByRule('archivesPeriodLimited', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('arquivosProcessados.erros.periodoLimitado'))
    }
  })], 1), _c('div', {
    staticClass: "row"
  })])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "processedFilesGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "arquivosProcessados",
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f5ddfa2", module.exports)
  }
}

/***/ }),
/* 1432 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fc77e22"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/integration/remittanceIntegration/tabRemittanceReport.pug ***!
  \***********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'remittance-detail': _vm.showRemovalButton
    },
    attrs: {
      "id": "tab-remittance-report"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showGrid),
      expression: "showGrid"
    }],
    staticClass: "margin-container col-md-12"
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "remittanceReportGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "resumoRemesDisposaIntegracao",
      "cfgObj": _vm.treeGridCfg,
      "treeGridModal": true,
      "showHrTopGrid": false
    }
  })], 1)]), (_vm.showRemovalButton) ? _c('div', {
    staticClass: "tab-footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('remessaIntegracao.titulos.excluirRemessa'),
      "id": "btnExcluirArquivo",
      "clickFunction": _vm.openModalConfirm
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6fc77e22", module.exports)
  }
}

/***/ }),
/* 1433 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-72a54622"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/classificationCriteria/newClassificationCriteria.pug ***!
  \************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.criteriosClassificacao.novoCriterio'),
      "subTitle": _vm.$t('planoConciliacao.titulos.criteriosClassificacao.novoCriterioInfo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('planoConciliacao.titulos.criteriosClassificacao.novoCriterioPortlet')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.criteria.criterioEmUso),
      expression: "criteria.criterioEmUso"
    }],
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon alert-icon"
  }), _c('span', {
    staticClass: "alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.validacao.criterioEmUsoEditar'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.detalheCriterio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "criteriaCategory"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.associacaoCategoria'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    key: "criteriaCategory",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('criteria.categoria')
    },
    attrs: {
      "options": _vm.categories,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "criteria.categoria",
      "id": "criteriaCategory",
      "name": "criteriaCategory",
      "disabled": _vm.criteria.criterioEmUso
    },
    on: {
      "input": _vm.setValuesFieldsCategory
    },
    model: {
      value: (_vm.criteria.categoria),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "categoria", $$v)
      },
      expression: "criteria.categoria"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('criteria.categoria', 'required')),
      expression: "errors.firstByRule('criteria.categoria', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critDesc"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricaoCriterio'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.descricao),
      expression: "criteria.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critDesc",
      "name": "critDesc",
      "data-vv-name": "criteria.descricao",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.criteria.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "descricao", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('criteria.descricao', 'required')),
      expression: "errors.firstByRule('criteria.descricao', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.ativo),
      expression: "criteria.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "active"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.criteria.ativo, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "ativo", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "active"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.ativo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.ativo),
      expression: "criteria.ativo"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "inactive"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.criteria.ativo, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "ativo", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inactive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.inativo'))
    }
  })]), _c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevancia'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.relevante),
      expression: "criteria.relevante"
    }],
    attrs: {
      "type": "radio",
      "name": "relevancia",
      "id": "relevante",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.criteria.relevante, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "relevante", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "relevante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevante'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.relevante),
      expression: "criteria.relevante"
    }],
    attrs: {
      "type": "radio",
      "name": "relevancia",
      "id": "irrelevante",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.criteria.relevante, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.criteria, "relevante", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "irrelevante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.irrelevante'))
    }
  }), _c('br')])])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.aplicarCriterio'))
    }
  }), _c('br'), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critHist"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.mascaraHistorico'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.historico),
      expression: "criteria.historico"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critHist",
      "name": "critHist",
      "maxlength": "250",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": (_vm.criteria.historico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "historico", $event.target.value)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critCompl"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.mascaraComplemento'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.complemento),
      expression: "criteria.complemento"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critCompl",
      "name": "critCompl",
      "maxlength": "50",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": (_vm.criteria.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "complemento", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critCodHist"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.codigoHistorico'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.criteria.codigoHistorico),
      expression: "criteria.codigoHistorico"
    }],
    staticClass: "form-control",
    class: {
      'input': true
    },
    attrs: {
      "type": "text",
      "id": "critCodHist",
      "name": "critCodHist",
      "maxlength": "4",
      "disabled": _vm.criteria.criterioEmUso
    },
    domProps: {
      "value": (_vm.criteria.codigoHistorico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.criteria, "codigoHistorico", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critFebraban"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.febraban'))
    }
  }), _c('v-select', {
    key: "critFebraban",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.febraban,
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "criteria.categoriaFebraban",
      "id": "critFebraban",
      "name": "critFebraban",
      "disabled": _vm.criteria.criterioEmUso
    },
    model: {
      value: (_vm.criteria.categoriaFebraban),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "categoriaFebraban", $$v)
      },
      expression: "criteria.categoriaFebraban"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critBank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.banco'))
    }
  }), _c('v-select', {
    key: "critBank",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.banks,
      "id": "critBank",
      "name": "critBank",
      "data-vv-name": "criteria.banco",
      "disabled": _vm.criteria.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    on: {
      "input": _vm.filterAccounts
    },
    model: {
      value: (_vm.criteria.banco),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "banco", $$v)
      },
      expression: "criteria.banco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "critAccount"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conta'))
    }
  }), _c('v-select', {
    key: "critAccount",
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.filteredAccounts,
      "id": "critAccount",
      "name": "critAccount",
      "data-vv-name": "criteria.conta",
      "disabled": _vm.criteria.criterioEmUso,
      "placeholder": _vm.$t('validacao.select.placeholder')
    },
    model: {
      value: (_vm.criteria.conta),
      callback: function($$v) {
        _vm.$set(_vm.criteria, "conta", $$v)
      },
      expression: "criteria.conta"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('br')], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.chaveRelacionamento'))
    }
  }), _c('button-primary', {
    staticClass: "marged-button",
    attrs: {
      "title": _vm.$t('planoConciliacao.labels.adicionar'),
      "faIcon": "fa fa-plus",
      "id": "btnAddCampoClassificacao",
      "clickFunction": _vm.addClassificationField,
      "disabled": _vm.criteria.criterioEmUso
    }
  }), _c('br'), _vm._l((_vm.criteria.classificacaoCampos), function(field) {
    return _c('div', [_c('conciliation-field', {
      key: field.key != undefined && field.key != null ? field.key : field.id,
      ref: field.key != undefined && field.key != null ? field.key : field.id,
      refInFor: true,
      attrs: {
        "conciliationField": field,
        "attributesCfg": _vm.attributesCfg,
        "attributes": field.idAtributoCfg != null && field.idAtributoCfg.children ? field.idAtributoCfg.children : [],
        "conciliationFields": _vm.conciliationFields,
        "disabled": _vm.criteria.criterioEmUso
      },
      on: {
        "remove-field-from-criteria": _vm.removeClassificationField,
        "change-conc-field-cfg": _vm.changeFieldAttCfg,
        "change-conc-field-att-name": _vm.changeFieldAttName,
        "change-conc-field": _vm.changeFieldAttConciliationField
      }
    })], 1)
  })], 2)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.adicionar'),
      "id": "btnAddCriterioClassificacao",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.voltar'),
      "id": "btnRetornaEdicaoPlano",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72a54622", module.exports)
  }
}

/***/ }),
/* 1434 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-72f81e1a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/changeApplicationModal/changeApplicationModal.pug ***!
  \**********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "id": "modal-troca-app",
      "size": _vm.aplicacoes.length <= 2 ? 'modal-md' : 'modal-lg',
      "data-backdrop": "static",
      "tabindex": "-1",
      "closable": true,
      "closeFunction": _vm.closeModal
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('trocaApp.titulos.titulo'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('trocaApp.titulos.subtitulo'))
    }
  })]), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, _vm._l((_vm.aplicacoes), function(app) {
    return _c('button-application', {
      key: app.id,
      attrs: {
        "data": app,
        "btnDesc": app.descricao,
        "btnImg": app.imagem,
        "btnActive": app.active,
        "btnClickFunction": app.click,
        "btnWidth": _vm.calcWidth(app),
        "btnAppId": app.id
      }
    })
  }), 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72f81e1a", module.exports)
  }
}

/***/ }),
/* 1435 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-737e48a5"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/dashboard/chartFilter/FinancialSummary.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('filters-common', {
    attrs: {
      "data": _vm.filters
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-737e48a5", module.exports)
  }
}

/***/ }),
/* 1436 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ba95ea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/notFound/notFound.pug ***!
  \*****************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "middle-white-box"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "not-found-img",
    attrs: {
      "src": _vm.imageNotFound
    }
  }), _c('br'), _c('p', {
    staticClass: "big-txt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('naoEncontrado.labels.mensagem'))
    }
  }), _c('button-primary', {
    attrs: {
      "label": _vm.$t('naoEncontrado.labels.voltarHome'),
      "faIcon": "",
      "clickFunction": _vm.goHome,
      "id": "btn404VoltarParaHome",
      "customClass": "big-primary"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-73ba95ea", module.exports)
  }
}

/***/ }),
/* 1437 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-743a74ea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/bankAccounts/list.pug ***!
  \******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('contaBancaria.titulos.contasBancarias'),
      "subTitle": _vm.$t('contaBancaria.labels.visualizacao')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('contaBancaria.labels.novaConta'),
      "id": "btnNovaContaBancaria",
      "clickFunction": _vm.newBankAccount
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "accounts"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.bankAccounts,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "title": _vm.$t('contaBancaria.labels.editar')
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        }), _c('button', {
          staticClass: "fa fa-times action",
          attrs: {
            "disabled": props.row.contaEmUso,
            "title": props.row.contaEmUso ? _vm.$t('contaBancaria.labels.deleteBloqueado') : _vm.$t('contaBancaria.labels.delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleRemove(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__banco"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'banco')
      }
    }
  })]), _c('template', {
    slot: "filter__agencia"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'agencia')
      }
    }
  })]), _c('template', {
    slot: "filter__conta"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'conta')
      }
    }
  })]), _c('template', {
    slot: "filter__status"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'status')
      }
    }
  })])], 2)], 1)], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveBankAccount"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverBankAccount",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "disabled": _vm.requestSentRemove,
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverBankAccount",
      "clickFunction": _vm.remove
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-743a74ea", module.exports)
  }
}

/***/ }),
/* 1438 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c6103a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/myAccountModal/myAccountModal.pug ***!
  \******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "id": "my-account-modal",
      "size": "modal-md",
      "data-backdrop": "static",
      "tabindex": "-1",
      "closable": true,
      "closeFunction": _vm.closeModal
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.labels.minhaConta'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.labels.subtitulo'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label label-bold bold",
    attrs: {
      "for": "name"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.labels.nome'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('clientName')
    },
    attrs: {
      "type": "text",
      "id": "clientName",
      "name": "clientName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientName')),
      expression: "errors.has('clientName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12 row-filter-medium"
  }, [_c('label', {
    staticClass: "control-label label-bold bold",
    attrs: {
      "for": "email"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.labels.email'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "control-label",
    attrs: {
      "id": "email"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.email)
    }
  })]), _c('div', {
    staticClass: "col-xs-12 row-filter-medium"
  }, [_c('label', {
    staticClass: "control-label label-bold bold",
    attrs: {
      "for": "profile"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.labels.perfil'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('span', {
    staticClass: "control-label",
    attrs: {
      "id": "profile"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.accessProfileName)
    }
  })]), _c('div', {
    staticClass: "col-xs-12 row-filter-medium"
  }, [_c('label', {
    staticClass: "control-label label-bold bold",
    attrs: {
      "for": "current-password"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.changingPassword ? 'modalMinhaConta.labels.senhaAtual' : 'modalMinhaConta.labels.senha'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changingPassword),
      expression: "!changingPassword"
    }],
    staticClass: "control-label bold"
  }, [_vm._v("********")]), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changingPassword),
      expression: "!changingPassword"
    }],
    attrs: {
      "id": "edit-password-btn",
      "title": _vm.$t('modalMinhaConta.titulo.mudarSenha')
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changingPassword),
      expression: "changingPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.changingPassword
        }
      }),
      expression: "{ rules: { required: changingPassword } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPassword),
      expression: "currentPassword"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('current-password')
    },
    attrs: {
      "id": "current-password",
      "name": "current-password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.currentPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPassword = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('current-password')),
      expression: "errors.has('current-password')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changingPassword),
      expression: "changingPassword"
    }],
    attrs: {
      "id": "password-container"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-medium"
  }, [_c('label', {
    staticClass: "control-label label-bold bold",
    attrs: {
      "for": "new-password"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.labels.novaSenha'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.changingPassword
        }
      }),
      expression: "{ rules: { required: changingPassword } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': (_vm.errors.has('new-password') || _vm.differentNewPassword)
    },
    attrs: {
      "id": "new-password",
      "name": "new-password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default form-control btn-change-password",
    class: {
      'input': true,
      'is-danger': (_vm.errors.has('new-password') || _vm.differentNewPassword)
    },
    attrs: {
      "id": "show-password-btn",
      "type": "button",
      "title": _vm.$t('modalMinhaConta.titulo.mostrarSenha')
    },
    on: {
      "click": function($event) {
        return _vm.showPassword('new-password', '#show-password-btn > i')
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.hidePasswordIcon,
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-password')),
      expression: "errors.has('new-password')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12 row-filter-medium"
  }, [_c('label', {
    staticClass: "control-label label-bold bold",
    attrs: {
      "for": "confirm-new-password"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.labels.confirmarSenha'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: _vm.changingPassword
        }
      }),
      expression: "{ rules: { required: changingPassword } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmNewPassword),
      expression: "confirmNewPassword"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': (_vm.errors.has('confirm-new-password') || _vm.differentNewPassword)
    },
    attrs: {
      "id": "confirm-new-password",
      "name": "confirm-new-password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmNewPassword = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default form-control btn-change-password",
    class: {
      'input': true,
      'is-danger': (_vm.errors.has('confirm-new-password') || _vm.differentNewPassword)
    },
    attrs: {
      "id": "show-new-password-btn",
      "type": "button",
      "title": _vm.$t('modalMinhaConta.titulo.mostrarSenha')
    },
    on: {
      "click": function($event) {
        return _vm.showPassword('confirm-new-password', '#show-new-password-btn > i')
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.hidePasswordIcon,
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirm-new-password')),
      expression: "errors.has('confirm-new-password')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.differentNewPassword),
      expression: "differentNewPassword"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalMinhaConta.validacao.senhasDiferentes'))
    }
  })])])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row-filter-medium"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalMinhaConta.labels.salvar'),
      "id": "btnSalvarMinhaConta",
      "disabled": _vm.saveBtnDisabled,
      "clickFunction": _vm.validate
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalMinhaConta.labels.fechar'),
      "id": "btnVoltarSalvarMinhaConta",
      "clickFunction": _vm.closeModal,
      "customClass": "secondary"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74c6103a", module.exports)
  }
}

/***/ }),
/* 1439 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7511b8fb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/attributesSet/new.pug ***!
  \******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-attributes-set-wrapper"
    }
  }, [_c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('conjuntoAtributo.titulos.titulo'),
      "subTitle": _vm.$t('conjuntoAtributo.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('conjuntoAtributo.titulos.cadastroDeConjunto')
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 row-filter-small",
    staticStyle: {
      "min-height": "83px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeSetName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.nomeDoConjunto'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.attributeSet.name),
      expression: "attributeSet.name"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('attributeSetName')
    },
    staticStyle: {
      "height": "36px !important"
    },
    attrs: {
      "type": "text",
      "id": "attributeSetName",
      "name": "attributeSetName",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.attributeSet.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attributeSet, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attributeSetName')),
      expression: "errors.has('attributeSetName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "form-group col-xs-6 row-filter-small",
    staticStyle: {
      "min-height": "83px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "linkType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipoDeVinculo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('linkType')
    },
    attrs: {
      "options": _vm.attTypesAviable,
      "label": "description",
      "id": "linkType",
      "name": "linkType",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "disabled": this.attributeSetToEdit != null
    },
    model: {
      value: (_vm.attributeSet.linkType),
      callback: function($$v) {
        _vm.$set(_vm.attributeSet, "linkType", $$v)
      },
      expression: "attributeSet.linkType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('linkType')),
      expression: "errors.has('linkType')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributes && _vm.attributes.length > 0),
      expression: "attributes && attributes.length > 0"
    }],
    staticClass: "hint pull-left row-filter-medium"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.atributos'))
    }
  }), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.arrasteParaReordenar'))
    }
  })]), _c('div', {
    staticClass: "pull-right row-filter-medium"
  }, [_c('button-primary', {
    attrs: {
      "label": _vm.$t('conjuntoAtributo.titulos.adicionarAtributo'),
      "id": "btnAbrirModalAdicionarAtributo",
      "clickFunction": _vm.createOrEditAttribute
    }
  })], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributes && _vm.attributes.length > 0),
      expression: "attributes && attributes.length > 0"
    }],
    staticClass: "row-filter-small",
    attrs: {
      "id": "attributes-list"
    }
  }, [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-md-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.identificador'))
    }
  }), _c('div', {
    staticClass: "col-md-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.nome'))
    }
  }), _c('div', {
    staticClass: "col-md-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipo'))
    }
  }), _c('div', {
    staticClass: "col-md-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.valoresPossiveis'))
    }
  }), _c('div', {
    staticClass: "pull-right px-0 text-right col-md-1"
  }, [_c('div', {
    staticClass: "categories-header-acoes-tit px-0 text-right",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _c('div', {
    staticClass: "attributes-list"
  }, [(_vm.attributes.length > 0) ? _c('draggable', {
    attrs: {
      "list": _vm.attributes
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.attributes), function(att, index) {
    return _c('attribute', {
      key: att.name,
      attrs: {
        "order": index + 1,
        "name": att.name,
        "description": att.description,
        "type": att.type,
        "possibleValues": att.possibleValues,
        "mask": att.mask,
        "validation": att.validation,
        "inUse": att.inUse,
        "handleEdit": _vm.createOrEditAttribute,
        "handleRemove": _vm.removeAttributeHandler
      }
    })
  }), 1)], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('conjuntoAtributo.labels.salvar'),
      "id": "btnSalvarConjuntoEstabelecimentos",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('conjuntoAtributo.labels.cancelar'),
      "id": "btnVoltarListagemAtributos",
      "customClass": "secondary",
      "clickFunction": _vm.backToList
    }
  })], 1)])])], 1)])]), (_vm.shown) ? _c('new-attribute-modal', {
    attrs: {
      "editingAttribute": _vm.editingAttribute,
      "attributesList": _vm.attributes
    },
    on: {
      "close-modal": function($event) {
        _vm.shown = false
      },
      "update-list-attributes": _vm.updateAttributesList
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7511b8fb", module.exports)
  }
}

/***/ }),
/* 1440 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-758aea92"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/occurrenceReason/new.pug ***!
  \*********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('motivoOcorrencia.titulos.cadastroTitulo'),
      "subTitle": _vm.$t('motivoOcorrencia.titulos.cadastroSubtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.filterPortletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReasonInitials"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.sigla'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrenceReason.initials),
      expression: "occurrenceReason.initials"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('occurrenceReasonInitials')
    },
    attrs: {
      "type": "text",
      "id": "occurrenceReasonInitials",
      "name": "occurrenceReasonInitials",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.occurrenceReason.initials)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrenceReason, "initials", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('occurrenceReasonInitials')),
      expression: "errors.has('occurrenceReasonInitials')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReasonDescription"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.descricao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.occurrenceReason.description),
      expression: "occurrenceReason.description"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('occurrenceReasonDescription')
    },
    attrs: {
      "type": "text",
      "id": "occurrenceReasonDescription",
      "name": "occurrenceReasonDescription",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.occurrenceReason.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.occurrenceReason, "description", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('occurrenceReasonDescription', 'required')),
      expression: "errors.firstByRule('occurrenceReasonDescription', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceReasonCategory"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('motivoOcorrencia.labels.categoria'))
    }
  }), _c('v-select', {
    class: {
      'input': true,
      'is-danger': _vm.errors.has('occurrenceReason.category')
    },
    attrs: {
      "options": _vm.categories,
      "label": "label",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "occurrenceReason.category",
      "id": "occurrenceReasonCategory",
      "name": "occurrenceReasonCategory"
    },
    on: {
      "input": _vm.setOcurrencyCategory
    },
    model: {
      value: (_vm.occurrenceReason.category),
      callback: function($$v) {
        _vm.$set(_vm.occurrenceReason, "category", $$v)
      },
      expression: "occurrenceReason.category"
    }
  })], 1)]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.salvar'),
      "id": "btnSalvarMotivoDeOcorrencia",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('administracao.perfilAcesso.labels.cancelar'),
      "clickFunction": _vm.back,
      "id": "btnVoltarSalvarMotivoDeOcorrencia",
      "customClass": "secondary"
    }
  })], 1)])])])], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-758aea92", module.exports)
  }
}

/***/ }),
/* 1441 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-777d8892"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/pageTitle/pageTitle.pug ***!
  \********************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-wrapper"
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_vm._t("new-button")], 2), _c('h1', {
    staticClass: "primary-title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.subTitle) ? _c('h4', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-777d8892", module.exports)
  }
}

/***/ }),
/* 1442 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7947ef80"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/selectedEntries.pug ***!
  \************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending-conciliation-box",
    attrs: {
      "id": "selected-entries-wrapper"
    }
  }, [_c('reopen-allotment-modal'), _c('apply-modal'), _c('justify-modal'), _c('h4', {
    staticClass: "pending-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.portletSelecionados'))
    }
  }), (_vm.allotmentId != null && _vm.allotmentMovementRemoved == null) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "pending-title",
    staticStyle: {
      "color": "#00ace6 !important",
      "font-size": "18px",
      "padding-right": "15px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.loteSelecionado'))
    }
  }), _c('span', {
    staticClass: "span-tag"
  }, [_vm._v(_vm._s(_vm.allotmentId)), _c('button', {
    staticClass: "close-tag-btn close-tag-span fa fa-times action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeAllotment
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 row-flex"
  }, [_c('div', {
    staticClass: "col-xs-6 grey-right-border col-flex"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "pending-title-manual-conciliation bold pull-left",
    staticStyle: {
      "color": "#00ace6 !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridMovimentosFinanceiros'))
    }
  }), (_vm.internalEntries.length > 0) ? _c('a', {
    staticClass: "pull-right clear-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.limpar'))
    },
    on: {
      "click": function($event) {
        return _vm.clearMovTable()
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('entry-manager', {
    ref: "entryManagerInternal",
    attrs: {
      "entriesList": _vm.internalEntries,
      "isInternal": true
    }
  })], 1)]), _c('div', {
    staticClass: "col-xs-6 col-flex"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "pending-title-manual-conciliation bold pull-left",
    staticStyle: {
      "color": "#00ace6 !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.gridExtratoBancario'))
    }
  }), (_vm.bankEntries.length > 0) ? _c('a', {
    staticClass: "pull-right clear-link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.limpar'))
    },
    on: {
      "click": function($event) {
        return _vm.clearBankTable()
      }
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('entry-manager', {
    ref: "entryManagerBank",
    attrs: {
      "entriesList": _vm.bankEntries,
      "isInternal": false
    }
  })], 1)])]), _c('div', {
    staticClass: "col-xs-12 row-flex"
  }, [_c('div', {
    staticClass: "col-xs-6 grey-right-border total-values col-flex"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.totalLancamentos'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.periodo'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.valorTotalInterno'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1vh"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    domProps: {
      "innerHTML": _vm._s(_vm.totalAmoutOfEntriesMov)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-date",
    domProps: {
      "innerHTML": _vm._s(_vm.rangeDateMov)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    staticStyle: {
      "color": "#00ace6"
    },
    attrs: {
      "title": _vm.sumMov
    },
    domProps: {
      "innerHTML": _vm._s(_vm.sumMov)
    }
  })])])]), _c('div', {
    staticClass: "col-xs-6 total-values col-flex"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.valorTotalBancario'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.periodo'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "control-label bold",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.totalLancamentos'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "1vh"
    }
  }, [_c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    staticStyle: {
      "color": "#00ace6"
    },
    attrs: {
      "title": _vm.sumBank
    },
    domProps: {
      "innerHTML": _vm._s(_vm.sumBank)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-date",
    domProps: {
      "innerHTML": _vm._s(_vm.rangeDateBank)
    }
  })]), _c('div', {
    staticClass: "col-xs-4 centered"
  }, [_c('label', {
    staticClass: "manage-value",
    domProps: {
      "innerHTML": _vm._s(_vm.totalAmountOfEntriesBank)
    }
  })])])])]), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "border-top": "solid 2px #cccccc"
    }
  }, [_c('h4', {
    staticClass: "pending-divergence",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.divergencia'))
    }
  }), _c('h4', {
    class: _vm.getDivergenceAmoutClass()
  }, [_vm._v(_vm._s(_vm.totalTransformed))])]), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrayJustify && _vm.arrayJustify.length > 0),
      expression: "arrayJustify && arrayJustify.length > 0"
    }],
    staticClass: "col-xs-12 row-flex"
  }, [_c('div', {
    staticClass: "col-xs-12 col-flex"
  }, [_c('h4', {
    staticClass: "pending-title-manual-conciliation bold",
    staticStyle: {
      "color": "#00ace6 !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.arrayJustify.length > 1 ? _vm.$t('conciliacaoManual.titulos.justificativas') : _vm.$t('conciliacaoManual.titulos.justificativa'))
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('justifications', {
    ref: "justification"
  })], 1)])]), _c('br'), _c('div', {
    staticClass: "col-xs-12 centered"
  }, [_c('button-primary', {
    staticClass: "search-button",
    staticStyle: {
      "margin-right": "0px !important"
    },
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.reabrir'),
      "id": "btnReabrirLote",
      "clickFunction": _vm.reaopenAllotment,
      "disabled": !_vm.canReopen,
      "customClass": "secondary"
    }
  }), _c('button-primary', {
    staticClass: "search-button",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.aplicar'),
      "id": "btnAplicarLote",
      "customClass": "mid-button",
      "clickFunction": _vm.applyConciliation,
      "disabled": !_vm.canConciliate
    }
  }), _c('button-primary', {
    staticClass: "search-button",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.justificar'),
      "id": "btnJustificarLote",
      "clickFunction": _vm.justifyAllotment,
      "disabled": !_vm.divergentInstance,
      "customClass": "secondary"
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "col-xs-12 checkbox-centered"
  }, [_c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter spaced-bottom-top"
  }, [(_vm.verifyAuthorizationResumeProcess) ? _c('input', {
    attrs: {
      "id": "automaticProcessing",
      "type": "checkbox",
      "disabled": !_vm.canResumeConciliation,
      "name": "automaticProcessing"
    },
    domProps: {
      "value": _vm.resumeAutomaticProcessing
    },
    on: {
      "change": _vm.changeReaplyConciliation
    }
  }) : _vm._e(), (_vm.verifyAuthorizationResumeProcess) ? _c('label', {
    staticClass: "control-label func-group-labels check-atribuidas",
    attrs: {
      "for": "automaticProcessing"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.labels.reaplicarConciliacao'))
    }
  }) : _vm._e()])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7947ef80", module.exports)
  }
}

/***/ }),
/* 1443 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1a5a18"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/accessProfile/list.pug ***!
  \*********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('administracao.perfilAcesso.titulos.perfisAcesso'),
      "subTitle": _vm.$t('administracao.perfilAcesso.titulos.listagemSubtitlo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('administracao.perfilAcesso.labels.novoPerfil'),
      "clickFunction": _vm.newProfile,
      "id": "btnNovoPerfilDeAcesso"
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "profiles"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.profiles,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "title": _vm.isMasterProfile(props.row.id) ? _vm.$t('administracao.perfilAcesso.validacao.naoPodeEditar') : ''
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__nome"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'nome')
      }
    }
  })])], 2)], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a1a5a18", module.exports)
  }
}

/***/ }),
/* 1444 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b55184e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/gadget/taskGadgetTabContent.pug ***!
  \*******************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 boxTarefas"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "col-md-4 boxQtde boxBorderRight"
  }, [_c('span', {
    staticClass: "valorQtde"
  }, [_vm._v(_vm._s(_vm.quantidadeMovFin))]), _c('br'), _c('label', {
    staticClass: "valorQtdeTxt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.movFinanceira'))
    }
  })]), _c('div', {
    staticClass: "col-md-4 boxQtde boxBorderRight"
  }, [_c('span', {
    staticClass: "valorQtde"
  }, [_vm._v(_vm._s(_vm.quantidadeMovBan))]), _c('br'), _c('label', {
    staticClass: "valorQtdeTxt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.movBancaria'))
    }
  })]), _c('div', {
    staticClass: "col-md-4 boxQtde"
  }, [_c('span', {
    staticClass: "valorQtde"
  }, [_vm._v(_vm._s(_vm.totalQuantidade))]), _c('br'), _c('label', {
    staticClass: "valorQtdeTxt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.total'))
    }
  })])]), _c('div', {
    staticClass: "clear"
  }), (_vm.isPendentTab) ? _c('div', [_c('div', {
    staticClass: "alerta"
  }, [(_vm.data && _vm.data.quantidadeVencidas && _vm.data.quantidadeVencidas > 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "badge badge-custom-tasks"
  }, [_vm._v(_vm._s(_vm.data.quantidadeVencidas))]), _c('div', {
    staticClass: "alerta-text"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.quantidadeVencidas === 1 ? _vm.$t('estatistica.tarefa.labels.alertaVencidasSingular') : _vm.$t('estatistica.tarefa.labels.alertaVencidasPlural'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("estatistica.tarefa.labels.verQuaisSao"))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.redirectToTasks(("" + _vm.naoConcluido), ("" + _vm.tipoNaoConcluido))
      }
    }
  })])]) : _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.alertaSemTarefasVencidas'))
    }
  })])]), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getTextNextExpiration())
    }
  })])])])]) : _c('div', [_c('div', {
    staticClass: "alerta text-center"
  }, [(_vm.data && _vm.data.totalQuantidadeConcluida && _vm.data.totalQuantidadeConcluida > 0) ? _c('div', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.redirectToTasks(("" + _vm.concluido), ("" + _vm.tipoConcluido))
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('estatistica.tarefa.tooltip.concluidas')))])]) : _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.semTarefasConcluidas'))
    }
  })])])]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b55184e", module.exports)
  }
}

/***/ }),
/* 1445 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d8ec08a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/conciliationPlan/new.pug ***!
  \*********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isManagingClassCriteria && !_vm.isManagingConcilCriteria),
      expression: "!isManagingClassCriteria && !isManagingConcilCriteria"
    }],
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('planoConciliacao.titulos.planosConciliacao'),
      "subTitle": _vm.$t('planoConciliacao.titulos.cadastroSubtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.portletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "planName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.nomePlano'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.planName),
      expression: "planName"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('planName')
    },
    attrs: {
      "type": "text",
      "id": "planName",
      "name": "planName",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.planName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.planName = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('planName')),
      expression: "errors.has('planName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('br')])]), _c('vue-tabs', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-right": "0px !important"
    },
    attrs: {
      "id": "tab-navigation"
    },
    model: {
      value: (_vm.tabMain),
      callback: function($$v) {
        _vm.tabMain = $$v
      },
      expression: "tabMain"
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-criterio-classificacai",
      "title": _vm.tabClass
    }
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "hint pull-left row-filter-medium"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterios'))
    }
  }), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classificationCriterias && _vm.classificationCriterias.length > 0),
      expression: "classificationCriterias && classificationCriterias.length > 0"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterioReordenar'))
    }
  })]), _c('div', {
    staticClass: "pull-right row-filter-medium"
  }, [_c('button-primary', {
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.addCriterio'),
      "id": "btnManageCriteria",
      "clickFunction": _vm.createOrEditCriteria
    }
  })], 1), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.classificationCriterias && _vm.classificationCriterias.length > 0),
      expression: "classificationCriterias && classificationCriterias.length > 0"
    }],
    staticClass: "row-filter-small",
    attrs: {
      "id": "criterias-list"
    }
  }, [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-md-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricao'))
    }
  }), _c('div', {
    staticClass: "col-md-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.relevancia'))
    }
  }), _c('div', {
    staticClass: "col-md-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.tipo'))
    }
  }), _c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "pull-right col-md-1"
  }, [_c('div', {
    staticClass: "criterias-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _c('div', {
    staticClass: "criterias-list"
  }, [(_vm.classificationCriterias.length > 0) ? _c('draggable', {
    attrs: {
      "list": _vm.classificationCriterias
    },
    on: {
      "planCriteriaAdded": _vm.updateCriteriasList,
      "change": _vm.changeClassifOrder
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.classificationCriterias), function(crit, index) {
    return _c('classificationCriteria', {
      key: crit.ordem + '|' + index,
      attrs: {
        "order": index + 1,
        "criteria": crit,
        "handleEdit": _vm.createOrEditCriteria,
        "handleRemove": _vm.removeCriteriaHandler
      }
    })
  }), 1)], 1) : _vm._e()], 1)])])])]), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-criterio-classificacai",
      "title": _vm.tabConcil
    }
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "hint pull-left row-filter-medium"
  }, [_c('span', {
    staticClass: "bold large-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterios'))
    }
  }), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.conciliationCriterias && _vm.conciliationCriterias.length > 0),
      expression: "conciliationCriterias && conciliationCriterias.length > 0"
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.criterioReordenar'))
    }
  })]), _c('div', {
    staticClass: "pull-right row-filter-medium"
  }, [_c('button-primary', {
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.addCriterio'),
      "id": "btnManageConcilCriteria",
      "clickFunction": _vm.createOrEditConcilCriteria
    }
  })], 1), _c('br'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.conciliationCriterias && _vm.conciliationCriterias.length > 0),
      expression: "conciliationCriterias && conciliationCriterias.length > 0"
    }],
    staticClass: "row-filter-small",
    attrs: {
      "id": "criterias-list"
    }
  }, [_c('div', {
    staticClass: "categories-header"
  }, [_c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.ordem'))
    }
  }), _c('div', {
    staticClass: "col-md-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.descricao'))
    }
  }), _c('div', {
    staticClass: "col-md-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.status'))
    }
  }), _c('div', {
    staticClass: "pull-right col-md-2"
  }, [_c('div', {
    staticClass: "concil-criterias-header-acoes-tit",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.acoes'))
    }
  })])]), _c('div', {
    staticClass: "criterias-list"
  }, [(_vm.conciliationCriterias.length > 0) ? _c('draggable', {
    attrs: {
      "list": _vm.conciliationCriterias
    },
    on: {
      "planCriteriaAdded": _vm.updateCriteriasList,
      "change": _vm.changeConcilOrder
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list-complete"
    }
  }, _vm._l((_vm.conciliationCriterias), function(crit, index) {
    return _c('conciliationCriteria', {
      key: crit.ordem + '|' + index,
      attrs: {
        "order": index + 1,
        "criteria": crit,
        "handleEdit": _vm.createOrEditConcilCriteria,
        "handleRemove": _vm.removeConcilCriteriaHandler
      }
    })
  }), 1)], 1) : _vm._e()], 1)])])])])], 1), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.salvar'),
      "id": "btnSalvarPlanoDeConciliacao",
      "disabled": _vm.requestSent,
      "type": "submit"
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.voltar'),
      "id": "btnVoltarSalvarPlanoDeConciliacao",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])], 1)])], 1)])]), _c('newClassificationCriteria', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isManagingClassCriteria),
      expression: "isManagingClassCriteria"
    }],
    attrs: {
      "criteriaToEdit": _vm.criteriaToEdit,
      "categories": _vm.categories,
      "febraban": _vm.febraban,
      "banks": _vm.banks,
      "accounts": _vm.accounts,
      "attributesCfg": _vm.attributesCfgClassif,
      "conciliationFields": _vm.conciliationFieldsBanking
    },
    on: {
      "change-managing-plan": _vm.changeManagingClassCriteria,
      "add-criteria-to-plan": _vm.updateCriteriasList,
      "finish-load-attributes-cfg": _vm.updateCriteriasAttCfg,
      "finish-load-conciliationFields": _vm.updateCriteriasConcFields
    }
  }), _c('newConciliationCriteria', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isManagingConcilCriteria),
      expression: "isManagingConcilCriteria"
    }],
    attrs: {
      "concilCriteriaToEdit": _vm.concilCriteriaToEdit,
      "banks": _vm.banks,
      "accounts": _vm.accounts,
      "attributesCfg": _vm.attributesCfg,
      "conciliationFields": _vm.conciliationFields,
      "occurrenceReasons": _vm.occurrenceReasons
    },
    on: {
      "change-managing-plan-concil": _vm.changeManagingConcilCriteria,
      "add-concil-criteria-to-plan": _vm.updateConcilCriteriasList
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d8ec08a", module.exports)
  }
}

/***/ }),
/* 1446 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dbbcb98"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/form/formSearch/formSearch.pug ***!
  \********************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.send.apply(null, arguments)
      }
    }
  }, [_vm._t("default"), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button-search', {
    attrs: {
      "isDisabled": _vm.isDisabled
    }
  })], 1), (_vm.hasExportFile) ? _c('div', {
    staticClass: "pull-right export-file"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "color": _vm.color,
      "labels": false,
      "height": 20,
      "width": 40
    },
    on: {
      "change": function($event) {
        return _vm.$emit("update-flagExportingFile")
      }
    },
    model: {
      value: (_vm.isExporting),
      callback: function($$v) {
        _vm.isExporting = $$v
      },
      expression: "isExporting"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("relatorioConciliacao.labels.exportarArquivo"))
    }
  })], 1) : _vm._e()])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dbbcb98", module.exports)
  }
}

/***/ }),
/* 1447 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa5a10b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/classificationCriteria/classificationCriteria.pug ***!
  \*********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-complete-item attribute row text-center"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "badge att-field order"
  }, [_vm._v(_vm._s(_vm.order))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "att-field description"
  }, [_vm._v(_vm._s(_vm.criteria.descricao))])]), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "att-field relevancy"
  }, [_vm._v(_vm._s(_vm.$t(_vm.criteria.relevante != null ? (_vm.criteria.relevante ? 'planoConciliacao.labels.relevante' : 'planoConciliacao.labels.irrelevante') : null)))])]), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "att-field type"
  }, [_vm._v(_vm._s(_vm.criteria.tipoLancamento ? _vm.$t('planoConciliacao.labels.tipoLancamento.' + _vm.criteria.tipoLancamento) : _vm.criteria.categoria.tipo == null ? _vm.$t('planoConciliacao.labels.tipoLancamento.' + _vm.criteria.categoria.tipo) : null))])]), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "att-field status"
  }, [_vm._v(_vm._s(_vm.$t(_vm.criteria.ativo != null ? (_vm.criteria.ativo ? 'planoConciliacao.labels.ativo' : 'planoConciliacao.labels.inativo') : null)))])]), _c('div', {
    staticClass: "col-md-1 pull-right"
  }, [_c('div', {
    staticClass: "att-field buttons"
  }, [_c('button', {
    staticClass: "fa fa-pencil action",
    attrs: {
      "type": "button",
      "title": _vm.btnEditTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit(_vm.criteria)
      }
    }
  }), _c('button', {
    staticClass: "fa fa-times action",
    attrs: {
      "type": "button",
      "disabled": _vm.criteria.criterioEmUso,
      "title": _vm.btnRemoveTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleRemove(_vm.criteria)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7fa5a10b", module.exports)
  }
}

/***/ }),
/* 1448 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-885acbc0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/entryManager.pug ***!
  \*********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "entries"
    }
  }, [_c('v-client-table', {
    staticClass: "entry-table data-table custom-data-table",
    attrs: {
      "data": _vm.entriesList,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [_c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-times action",
          staticStyle: {
            "color": "#4a4a4a"
          },
          on: {
            "click": function($event) {
              return _vm.removeEntry(props.row)
            }
          }
        })])]
      }
    }])
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-885acbc0", module.exports)
  }
}

/***/ }),
/* 1449 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bfa890c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/multiSelectModal/multiSelectModal.pug ***!
  \**********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('better-modal', {
    attrs: {
      "closable": true,
      "id": _vm.id
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.titles.main)
    }
  }), (_vm.data.titles.sub) ? _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.data.titles.sub)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "scrollable",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row margin-bottom"
  }, [(_vm.groups.length > 1) ? _c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grouped),
      expression: "grouped"
    }],
    attrs: {
      "id": "grouped",
      "type": "checkbox",
      "name": "grouped"
    },
    domProps: {
      "checked": Array.isArray(_vm.grouped) ? _vm._i(_vm.grouped, null) > -1 : (_vm.grouped)
    },
    on: {
      "click": _vm.toggleGrouped,
      "change": function($event) {
        var $$a = _vm.grouped,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grouped = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grouped = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grouped = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "grouped"
    }
  }, [_vm._v(_vm._s(_vm.$t('dataTable.labels.visualizacaoPorGrupos')))])]) : _vm._e(), (_vm.data.showToggleInactiveAccounts) ? _c('div', {
    staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showInactiveAccounts),
      expression: "showInactiveAccounts"
    }],
    attrs: {
      "id": "showInactiveAccounts",
      "type": "checkbox",
      "name": "showInactiveAccounts"
    },
    domProps: {
      "checked": Array.isArray(_vm.showInactiveAccounts) ? _vm._i(_vm.showInactiveAccounts, null) > -1 : (_vm.showInactiveAccounts)
    },
    on: {
      "click": _vm.toggleInactiveAccounts,
      "change": function($event) {
        var $$a = _vm.showInactiveAccounts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showInactiveAccounts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showInactiveAccounts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showInactiveAccounts = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "showInactiveAccounts"
    }
  }, [_vm._v(_vm._s(_vm.$t('dataTable.labels.mostrarContasInativas')))])]) : _vm._e()]), (_vm.grouped && _vm.groups.length > 1) ? _c('div', {
    staticClass: "flex-column",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.groups), function(group, groupIndex) {
    return _c('b-card', {
      key: groupIndex,
      staticClass: "group-card",
      attrs: {
        "no-body": "no-body"
      }
    }, [(group.dataView.length !== 0) ? _c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      }
    }, [_c('b-button', {
      staticClass: "group-title",
      attrs: {
        "block": "block",
        "variant": "light",
        "v-b-toggle": ("collapse-" + (group.id))
      },
      on: {
        "click": function($event) {
          return _vm.searchGroupItens(groupIndex)
        }
      }
    }, [_vm._v(_vm._s(group[_vm.groupingOptions.headerNameProp])), (group.selected) ? _c('i', {
      staticClass: "fa fa-chevron-up"
    }) : _c('i', {
      staticClass: "fa fa-chevron-down"
    })])], 1) : _vm._e(), (group.dataView.length !== 0) ? _c('b-collapse', {
      attrs: {
        "accordion": "groups",
        "role": "tabpanel",
        "visible": group.selected,
        "id": ("collapse-" + (group.id))
      }
    }, [_c('b-card-body', {
      staticClass: "padded"
    }, [(group.isLoadingData) ? _c('div', {
      staticClass: "loadingData"
    }) : _vm._e(), (_vm.hasComputedComponentFunctions && !_vm.data.options.requestFunction && !group.isLoadingData) ? _c('v-client-table', {
      ref: "table",
      refInFor: true,
      staticClass: "data-table custom-data-table",
      attrs: {
        "data": group.dataView,
        "columns": _vm.data.columns,
        "options": _vm.data.options
      },
      scopedSlots: _vm._u([{
        key: "check",
        fn: function(props) {
          return [_c('div', {
            staticClass: "checkbox check-success pl-0 multiselect-modal-input multiselect-modal-input-row"
          }, [_c('input', {
            attrs: {
              "id": "check-" + props.row[_vm.objProperties.id],
              "type": "checkbox",
              "name": "select"
            },
            domProps: {
              "checked": props.row.checked
            },
            on: {
              "click": function($event) {
                return _vm.selectGroupItem(groupIndex, props.row)
              }
            }
          }), _c('label', {
            staticClass: "func-group-labels",
            attrs: {
              "for": "check-" + props.row[_vm.objProperties.id]
            }
          })])]
        }
      }], null, true)
    }, [_c('template', {
      slot: "h__check"
    }, [_c('div', {
      staticClass: "checkbox check-success pl-0 multiselect-modal-input multiselect-modal-input-header"
    }, [_c('input', {
      attrs: {
        "id": "allGroupSelected-" + group.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": group.isEveryItemSelected
      },
      on: {
        "click": function($event) {
          return _vm.toggleAllGroupItens(groupIndex)
        }
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": "allGroupSelected-" + group.id
      }
    })])])], 2) : _vm._e()], 1)], 1) : _vm._e(), (group.dataView.length !== 0) ? _c('hr', {
      staticClass: "no-margin"
    }) : _vm._e()], 1)
  }), 1) : _vm._e(), (!_vm.grouped) ? _c('div', [_vm._t("dynamicColumnsInput"), (_vm.hasComputedComponentFunctions && !_vm.data.options.requestFunction) ? _c('v-client-table', {
    ref: "table",
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.dataView,
      "columns": _vm.data.columns,
      "options": _vm.data.options
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(props) {
        return [_c('div', {
          staticClass: "checkbox check-success pl-0 multiselect-modal-input multiselect-modal-input-row"
        }, [_c('input', {
          attrs: {
            "id": "check-" + props.row[_vm.objProperties.id],
            "type": "checkbox",
            "name": "select"
          },
          domProps: {
            "checked": props.row.checked
          },
          on: {
            "click": function($event) {
              return _vm.selectItem(props.row)
            }
          }
        }), _c('label', {
          staticClass: "func-group-labels",
          attrs: {
            "for": "check-" + props.row[_vm.objProperties.id]
          }
        })])]
      }
    }], null, false, 3405726286)
  }, [_c('template', {
    slot: "h__check"
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0 multiselect-modal-input multiselect-modal-input-header"
  }, [_c('input', {
    attrs: {
      "id": "allSelected",
      "type": "checkbox",
      "name": "allSelected"
    },
    domProps: {
      "checked": _vm.isEveryItemSelected
    },
    on: {
      "click": function($event) {
        return _vm.toggleAllItens()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "allSelected"
    }
  })])])], 2) : _vm._e(), (_vm.hasComputedComponentFunctions && _vm.data.options.requestFunction) ? _c('v-server-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "columns": _vm.data.columns,
      "options": _vm.data.options
    },
    scopedSlots: _vm._u([{
      key: "check",
      fn: function(props) {
        return [_c('div', {
          staticClass: "checkbox check-success pl-0 multiselect-modal-input multiselect-modal-input-row"
        }, [_c('input', {
          attrs: {
            "id": "check-" + props.row[_vm.objProperties.id],
            "type": "checkbox",
            "name": "select"
          },
          domProps: {
            "checked": props.row.checked
          },
          on: {
            "click": function($event) {
              return _vm.selectItem(props.row)
            }
          }
        }), _c('label', {
          staticClass: "func-group-labels",
          attrs: {
            "for": "check-" + props.row[_vm.objProperties.id]
          }
        })])]
      }
    }], null, false, 3405726286)
  }, [_c('template', {
    slot: "h__check"
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0 multiselect-modal-input multiselect-modal-input-header"
  }, [_c('input', {
    attrs: {
      "id": "allSelected",
      "type": "checkbox",
      "name": "allSelected"
    },
    domProps: {
      "checked": _vm.isEveryItemSelected
    },
    on: {
      "click": function($event) {
        return _vm.toggleAllItens()
      }
    }
  }), _c('label', {
    staticClass: "func-group-labels",
    attrs: {
      "for": "allSelected"
    }
  })])])], 2) : _vm._e()], 2) : _vm._e()]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "id": "applySelections",
      "label": _vm.$t('dataTable.labels.acaoAplicar'),
      "clickFunction": _vm.apply
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "id": "cancelSelections",
      "label": _vm.$t('dataTable.labels.acaoFechar'),
      "customClass": "secondary",
      "clickFunction": _vm.closeModal
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8bfa890c", module.exports)
  }
}

/***/ }),
/* 1450 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-9db5d5f8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/bankAccounts/new.pug ***!
  \*****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('contaBancaria.titulos.contaBancaria'),
      "subTitle": _vm.$t('contaBancaria.titulos.cadastroSubtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.portletTitle
    }
  }, [_c('form', {
    attrs: {
      "slot": "filters",
      "data-vv-scope": "formNew"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "accountName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('administracao.operadores.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.bankAccount.name),
      expression: "bankAccount.name"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('accountName')
    },
    attrs: {
      "type": "text",
      "id": "accountName",
      "name": "accountName",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.bankAccount.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankAccount, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('accountName')),
      expression: "errors.has('accountName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "accountBank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.banco'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('accountBank')
    },
    attrs: {
      "options": _vm.banks,
      "id": "accountBank",
      "name": "accountBank",
      "value": "codigo",
      "value": _vm.bankAccount.bank,
      "disabled": _vm.bankAccount.inUse
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.bankAccount, "bank", $event)
      }
    },
    model: {
      value: (_vm.bankAccount.bank),
      callback: function($$v) {
        _vm.$set(_vm.bankAccount, "bank", $$v)
      },
      expression: "bankAccount.bank"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('accountBank')),
      expression: "errors.has('accountBank')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-7"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "agency"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.agencia'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          numeric: true
        }
      }),
      expression: "{ rules: {required: true, numeric: true} }"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('agency')
    },
    attrs: {
      "id": "agency",
      "name": "agency",
      "mask": "DDDD",
      "tokens": _vm.maskTokens,
      "disabled": _vm.bankAccount.inUse
    },
    model: {
      value: (_vm.bankAccount.agency),
      callback: function($$v) {
        _vm.$set(_vm.bankAccount, "agency", $$v)
      },
      expression: "bankAccount.agency"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('agency', 'required')),
      expression: "errors.firstByRule('agency', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('agency', 'numeric')),
      expression: "errors.firstByRule('agency', 'numeric')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.somenteNumeros'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "agencyDigit"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.digitoAgencia'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankAccount.agencyDigit),
      expression: "bankAccount.agencyDigit"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('agencyDigit')
    },
    attrs: {
      "type": "text",
      "id": "agencyDigit",
      "name": "agencyDigit",
      "maxlength": "1",
      "disabled": _vm.bankAccount.inUse
    },
    domProps: {
      "value": (_vm.bankAccount.agencyDigit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankAccount, "agencyDigit", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-7"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "accountNumber"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.numeroConta'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} }"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('accountNumber')
    },
    attrs: {
      "id": "accountNumber",
      "name": "accountNumber",
      "mask": "XXXXXXXXXXXXXXXXXXXXXXXX",
      "tokens": _vm.maskTokens,
      "disabled": _vm.bankAccount.inUse
    },
    model: {
      value: (_vm.bankAccount.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.bankAccount, "accountNumber", $$v)
      },
      expression: "bankAccount.accountNumber"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('accountNumber', 'required')),
      expression: "errors.firstByRule('accountNumber', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('accountNumber', 'numeric')),
      expression: "errors.firstByRule('accountNumber', 'numeric')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.somenteNumeros'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "accountDigit"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.digitoConta'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankAccount.accountDigit),
      expression: "bankAccount.accountDigit"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('accountDigit')
    },
    attrs: {
      "type": "text",
      "id": "accountDigit",
      "name": "accountDigit",
      "maxlength": "1",
      "disabled": _vm.bankAccount.inUse
    },
    domProps: {
      "value": (_vm.bankAccount.accountDigit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankAccount, "accountDigit", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "establishmentGroups"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.grupoDeEstabelecimentos'))
    }
  }), _c('v-select', {
    staticClass: "input",
    attrs: {
      "id": "operatorAccessProfile",
      "options": _vm.establishmentsGroupList,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "name": "operatorAccessProfile",
      "getOptionLabel": _vm.stylizeGroupLabel,
      "taggable": "taggable"
    },
    on: {
      "change": _vm.handleGroupChange
    },
    model: {
      value: (_vm.bankAccount.group),
      callback: function($$v) {
        _vm.$set(_vm.bankAccount, "group", $$v)
      },
      expression: "bankAccount.group"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })])], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "startBalance"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.saldoInicial'))
    }
  }), _c('money', _vm._b({
    ref: "money",
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('startBalance')
    },
    attrs: {
      "type": "text",
      "id": "startBalance",
      "name": "startBalance",
      "maxlength": _vm.moneyMaskLength
    },
    model: {
      value: (_vm.bankAccount.startBalance),
      callback: function($$v) {
        _vm.$set(_vm.bankAccount, "startBalance", $$v)
      },
      expression: "bankAccount.startBalance"
    }
  }, 'money', _vm.moneyMask, false)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('startBalance')),
      expression: "errors.has('startBalance')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.validacao.saldoVazio'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-3"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "startBalanceDate"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.dataSaldo'))
    }
  })]), _c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('datepicker', {
    ref: "startBalanceDate",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('startBalanceDate')
    },
    attrs: {
      "id": "startBalanceDate",
      "language": _vm.datePickerLanguage,
      "format": 'dd/MM/yyyy',
      "full-month-name": "full-month-name",
      "input-class": "date-picker",
      "wrapper-class": "datepicker-wrapper",
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "typeable": "typeable",
      "vMaskPattern": "##/##/####"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: (_vm.bankAccount.startBalanceDate),
      callback: function($$v) {
        _vm.$set(_vm.bankAccount, "startBalanceDate", $$v)
      },
      expression: "bankAccount.startBalanceDate"
    }
  })], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('startBalanceDate')),
      expression: "errors.has('startBalanceDate')"
    }],
    staticClass: "help is-danger margin-datepicker-error-msg",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.validacao.dataSaldoVazio'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.status'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('div', {
    staticClass: "radio radio-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankAccount.ativo),
      expression: "bankAccount.ativo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "active"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.bankAccount.ativo, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.bankAccount, "ativo", true)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "active"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.ativa'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankAccount.ativo),
      expression: "bankAccount.ativo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "inactive"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.bankAccount.ativo, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.bankAccount, "ativo", false)
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inactive"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.inativa'))
    }
  })])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bankAccount.inUse),
      expression: "bankAccount.inUse"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('span', {
    staticClass: "note-card",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.contaEmUso'))
    }
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOpenFinance),
      expression: "showOpenFinance"
    }],
    staticClass: "row col-xs-10"
  }, [_c('label', {
    staticClass: "control-label open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.titulo'))
    }
  }), (!_vm.bankAccount.optIn || _vm.bankAccount.optIn.statusAceite !== "1") ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('toggle-button', {
    attrs: {
      "color": "#147d96",
      "sync": true
    },
    model: {
      value: (_vm.enableOfdaForm),
      callback: function($$v) {
        _vm.enableOfdaForm = $$v
      },
      expression: "enableOfdaForm"
    }
  }), _c('label', {
    staticClass: "control-label open-finance",
    staticStyle: {
      "margin-left": "0.5vh"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.compartilhar'))
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableOfdaForm),
      expression: "enableOfdaForm"
    }],
    staticClass: "col-xs-12 open-finance-box"
  }, [_c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoConta'))
    }
  }), _c('div', {
    staticClass: "radio radio-success no-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ofdaAccountType),
      expression: "ofdaAccountType"
    }],
    attrs: {
      "type": "radio",
      "name": "ofdaAccountType",
      "id": "ofdaAccountTypePf"
    },
    domProps: {
      "value": 'PF',
      "checked": _vm._q(_vm.ofdaAccountType, 'PF')
    },
    on: {
      "change": function($event) {
        _vm.ofdaAccountType = 'PF'
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "ofdaAccountTypePf"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoContaPf'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ofdaAccountType),
      expression: "ofdaAccountType"
    }],
    attrs: {
      "type": "radio",
      "name": "ofdaAccountType",
      "id": "ofdaAccountTypePj"
    },
    domProps: {
      "value": 'PJ',
      "checked": _vm._q(_vm.ofdaAccountType, 'PJ')
    },
    on: {
      "change": function($event) {
        _vm.ofdaAccountType = 'PJ'
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "ofdaAccountTypePj"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoContaPj'))
    }
  })])])])]) : _vm._e(), (_vm.bankAccount.optIn && _vm.bankAccount.optIn.statusAceite === "1") ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.jaAutorizado'))
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t("administracao.perfilAcesso.labels.salvar"),
      "id": "btnSalvarContaBancaria",
      "type": "submit",
      "disabled": _vm.requestSent
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t("administracao.perfilAcesso.labels.voltar"),
      "id": "btnVoltarSalvarContaBancaria",
      "clickFunction": _vm.back,
      "customClass": "secondary"
    }
  })], 1)])])])], 1)]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "belvo"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9db5d5f8", module.exports)
  }
}

/***/ }),
/* 1451 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0986062"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/conciliationSummary/calendarDetailBox.pug ***!
  \***************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendaDetailBox"
    }
  }, [(!_vm.isComponentReady) ? _c('div', {
    staticClass: "loadingData"
  }) : _vm._e(), (_vm.isComponentReady) ? _c('div', {
    staticStyle: {
      "margin-right": "25px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.conciliationSummary && _vm.conciliationSummary.length > 0 ? 'col-xs-8 detail-header' : 'detail-header-center'
  }, [_c('label', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.getFormatedCurrentDate)
    }
  })]), (_vm.conciliationSummary && _vm.conciliationSummary.length > 0) ? _c('div', {
    staticClass: "col-xs-4 detail-header"
  }, [_c('toogle', {
    attrs: {
      "labelLeft": _vm.$t('calendarioConciliacao.detalhe.resumo'),
      "labelRight": _vm.$t('calendarioConciliacao.detalhe.detalhe'),
      "idLeft": 'calendarConciliacaoResumo',
      "idRight": 'calendarConciliacaoDetalhe',
      "handleSelection": _vm.handleToogle,
      "isActive": _vm.showSummary
    }
  })], 1) : _vm._e()]), (_vm.filteredCategory && _vm.filteredCategory.id !== '-1') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "div-tag"
  }, [(_vm.filteredCategory && _vm.filteredCategory.id !== '-1') ? _c('span', [_vm._v(_vm._s(_vm.filteredCategory.nome)), _c('i', {
    staticClass: "padding-icon",
    class: 'fa fa-times-circle',
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setCategory(null)
      }
    }
  })]) : _vm._e()])]) : _vm._e(), (_vm.conciliationSummary && _vm.conciliationSummary.length > 0) ? _c('div', {
    staticClass: "row"
  }, [(_vm.showSummary) ? _c('div', [_c('div', {
    staticClass: "row transp-bordered-div"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', {
    staticClass: "detail-highlight-header",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.detalhe.situacao'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 text-rigth"
  }, [_c('label', {
    staticClass: "detail-highlight-header",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.detalhe.vlMovFinan'))
    }
  })]), _c('div', {
    staticClass: "col-xs-4 text-rigth"
  }, [_c('label', {
    staticClass: "detail-highlight-header",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.detalhe.vlMovBanc'))
    }
  })]), _c('div', {
    staticClass: "col-xs-2 text-rigth",
    staticStyle: {
      "padding-left": "35px"
    }
  }, [_c('label', {
    staticClass: "detail-highlight-header",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.detalhe.percent'))
    }
  }), _c('i', {
    staticClass: "icon-info fa fa-info-circle icon-margin-left",
    attrs: {
      "title": _vm.$t('calendarioConciliacao.alerta.tooltipPercent')
    }
  })])]), _vm._l((_vm.conciliationSummary), function(resume) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "row left-bordered-div",
      style: ({
        "border-left-color": _vm.getColorByStatus(resume.situacao)
      })
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('label', {
      staticClass: "detail-highlight",
      style: ({
        "font-size": resume && resume.situacao == "M" ? "11px !important" : "14px !important"
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.getConciliationLabel(resume.situacao))
      }
    })]), _c('div', {
      staticClass: "col-xs-4 text-rigth"
    }, [_c('label', {
      staticClass: "detail-highlight",
      domProps: {
        "innerHTML": _vm._s(_vm.getVlTotal(resume.movFinanAmount))
      }
    })]), _c('div', {
      staticClass: "col-xs-4 text-rigth"
    }, [_c('label', {
      staticClass: "detail-highlight",
      domProps: {
        "innerHTML": _vm._s(_vm.getVlTotal(resume.movBancAmount))
      }
    })]), _c('div', {
      staticClass: "col-xs-2 text-rigth"
    }, [_c('label', {
      staticClass: "detail-highlight",
      domProps: {
        "innerHTML": _vm._s(_vm.formatPercent(resume.percent))
      }
    })])])])
  })], 2) : _c('div', [_c('div', {
    staticClass: "row margin-container-96"
  }, [_c('vue-tabs', {
    attrs: {
      "id": "tab-navigation"
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-conta",
      "title": _vm.$t('planoConciliacao.labels.conta')
    }
  }, [_c('div', {
    staticClass: "row pt-5"
  }, [_c('v-client-table', {
    staticClass: "data-table calendar-data-table",
    attrs: {
      "data": _vm.accountsTable.data,
      "columns": _vm.accountsTable.columns,
      "options": _vm.accountsTable.options
    }
  })], 1)]), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-estab",
      "title": _vm.$t('estabelecimentos.labels.estabelecimento')
    }
  }, [_c('div', {
    staticClass: "row pt-5"
  }, [_c('v-client-table', {
    staticClass: "data-table calendar-data-table",
    attrs: {
      "data": _vm.establishmentsTable.data,
      "columns": _vm.establishmentsTable.columns,
      "options": _vm.establishmentsTable.options
    }
  })], 1)]), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-cat",
      "title": _vm.$t('planoConciliacao.labels.categoria')
    }
  }, [_c('div', {
    staticClass: "row pt-5"
  }, [_c('v-client-table', {
    staticClass: "data-table calendar-data-table",
    attrs: {
      "data": _vm.categoriesTable.data,
      "columns": _vm.categoriesTable.columns,
      "options": _vm.categoriesTable.options
    }
  })], 1)])], 1)], 1)])]) : _vm._e(), (!_vm.conciliationSummary || _vm.conciliationSummary.length == 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_c('span', {
    staticClass: "sem-lancamentos",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('calendarioConciliacao.detalhe.semLancamentos'))
    }
  })])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a0986062", module.exports)
  }
}

/***/ }),
/* 1452 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0335380"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/integration/remittanceIntegration/remittanceIntegrationCreationModal.pug ***!
  \**************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('confirm-modal', {
    attrs: {
      "id": "confirmRemittanceCreation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.hasRemittance) ? _c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.mensagem.periodoExistente'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.mensagem.confirmar'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalCreateRemittance",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmacaoModalCreateRemittance",
      "clickFunction": _vm.create
    }
  })], 1)]), (_vm.show) ? _c('better-modal', {
    attrs: {
      "closable": true,
      "id": "remittanceCreationModal"
    },
    on: {
      "close-modal": function($event) {
        return _vm.$emit("close-modal")
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit("close-modal")
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header",
      "id": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modal.text.title)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modal.text.subtitle)
    }
  })]), _c('div', {
    attrs: {
      "slot": "body",
      "id": "body"
    },
    slot: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingData),
      expression: "isLoadingData"
    }],
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "loadingData"
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoadingData),
      expression: "!isLoadingData"
    }]
  }, [_c('form', {
    staticClass: "form-style",
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "remittanceType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.tipoRemessa"))
    }
  }), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('remittance.type')
    },
    attrs: {
      "value": _vm.remittance.type,
      "options": _vm.remittanceTypes,
      "label": "nome",
      "placeholder": _vm.$t("validacao.select.placeholder"),
      "data-vv-name": "remittance.type",
      "name": "remittenceType"
    },
    model: {
      value: (_vm.remittance.type),
      callback: function($$v) {
        _vm.$set(_vm.remittance, "type", $$v)
      },
      expression: "remittance.type"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('remittance.type', 'required')),
      expression: "errors.firstByRule('remittance.type', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 365
    },
    model: {
      value: (_vm.remittance.period),
      callback: function($$v) {
        _vm.$set(_vm.remittance, "period", $$v)
      },
      expression: "remittance.period"
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "remittanceType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.comentariosAdicionais"))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remittance.comments),
      expression: "remittance.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "comments",
      "name": "comments",
      "maxlength": "1000",
      "rows": "2",
      "cols": "130"
    },
    domProps: {
      "value": (_vm.remittance.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remittance, "comments", $event.target.value)
      }
    }
  })])], 1)])]), (!_vm.isLoadingData) ? _c('div', {
    attrs: {
      "slot": "footer",
      "id": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.gerar'),
      "id": "btnGerarArquivo",
      "clickFunction": _vm.validate
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b0335380", module.exports)
  }
}

/***/ }),
/* 1453 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8e2c004"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/loading/LoadingPlaceholder.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-placeholder', {
    attrs: {
      "rows": _vm.placeholderRows
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b8e2c004", module.exports)
  }
}

/***/ }),
/* 1454 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb3b5fcc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/confirmModal/confirmModal.pug ***!
  \**************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal confirm fade",
    attrs: {
      "id": [_vm.id],
      "role": "dialog",
      "tabindex": "-1"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-center"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "confirm-dialog modal-content"
  }, [_c('div', {
    staticClass: "concil-modal-header flex"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conciliacaoManual.titulos.confirmacao'))
    }
  }), _c('div', [_c('button', {
    staticClass: "close",
    staticStyle: {
      "margin-top": "0px !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("×")])])]), _c('div', {
    staticClass: "modal-content confirm-content"
  }, [_vm._t("body"), _c('div', {
    staticClass: "modal-footer confirm-footer"
  }, [_vm._t("footer")], 2)], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bb3b5fcc", module.exports)
  }
}

/***/ }),
/* 1455 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb3e89cc"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/digitalWalletBalance/digitalWalletBalance.pug ***!
  \*************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "walletStatementWrapper"
    }
  }, [(_vm.shown.digitalWallets) ? _c('multi-select-modal', {
    attrs: {
      "id": "digitalWalletsModal",
      "data": _vm.data.digitalWallets
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('saldoCarteiraDigital.titulos.saldoCarteiraDigital'),
      "subTitle": _vm.$t('saldoCarteiraDigital.titulos.visualize')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('saldoCarteiraDigital.titulos.filtroTitulo')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 31,
      "finalDateDisableFrom": _vm.finalDateDisable
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('saldoCarteiraDigital.labels.carteirasDigitais'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.digitalWallets.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.digitalWallets,
      "props": _vm.inputTagsProps.digitalWallets
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.digitalWallets, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filter-input-tag",
    attrs: {
      "title": _vm.$t('saldoCarteiraDigital.labels.selecionarCarteirasDigitais'),
      "id": "btnSelecionarCarteirasDigitais",
      "faIcon": "fa fa-search",
      "clickFunction": _vm.openSelectDigitalWalletsModal
    }
  })], 1)])])])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "SaldoCarteiraDigital",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "SaldoCarteiraDigital",
      "treeGridLayoutPath": "digitalWalletBalance",
      "showMassTaskAction": false,
      "showAlert": true,
      "alertMessage": _vm.$t('saldoCarteiraDigital.labels.alertaGrid'),
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bb3e89cc", module.exports)
  }
}

/***/ }),
/* 1456 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5e6e690"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/step/stepProgress.pug ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-progress__wrapper"
  }, [_c('div', {
    staticClass: "step-progress__wrapper-before",
    style: ({
      "background-color": _vm.passiveColor,
      height: _vm.lineThickness + "px"
    })
  }), _c('div', {
    staticClass: "step-progress__bar"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      staticClass: "step-progress__step",
      class: {
        "step-progress__step--active": index === _vm.currentStep,
        "step-progress__step--valid": index < _vm.currentStep
      },
      style: ({
        "--activeColor": _vm.activeColor,
        "--passiveColor": _vm.passiveColor,
        "--activeBorder": _vm.activeThickness + "px",
        "--passiveBorder": _vm.passiveThickness + "px"
      })
    }, [_c('div', {
      staticClass: "step-progress__step-icon",
      class: _vm.iconClass
    }), _c('div', {
      staticClass: "step-progress__step-label"
    }, [_vm._v(_vm._s(step))])])
  }), 0), _c('div', {
    staticClass: "step-progress__wrapper-after",
    style: ({
      transform: "scaleX(" + _vm.scaleX + ") translateY(-50%) perspective(1000px)",
      "background-color": _vm.activeColor,
      height: _vm.lineThickness + "px"
    })
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c5e6e690", module.exports)
  }
}

/***/ }),
/* 1457 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-c75fdef8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/layout/filterPortlet/filterPortlet.pug ***!
  \****************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet"
  }, [(_vm.showHeader) ? _c('div', {
    staticClass: "ui-widget-header ui-widget-header-new-layout"
  }, [_c('label', {
    staticClass: "ui-widget-container-titulo",
    attrs: {
      "for": "ui-widget-header.ui-widget-header-new-layout"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.portletTitle)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "ui-widget-content"
  }, [_vm._t("filters")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c75fdef8", module.exports)
  }
}

/***/ }),
/* 1458 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb1d6a18"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/classificationCriteria/conciliationField.pug ***!
  \****************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'concFieldAttCfg' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conjuntoAtributo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.attributesCfg,
      "label": "attibuteSetName",
      "id": 'concFieldAttCfg' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id),
      "name": 'concFieldAttCfg' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id),
      "data-vv-name": "conciliationField.idAtributoCfg",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeAttCfg
    },
    model: {
      value: (_vm.conciliationField.idAtributoCfg),
      callback: function($$v) {
        _vm.$set(_vm.conciliationField, "idAtributoCfg", $$v)
      },
      expression: "conciliationField.idAtributoCfg"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('conciliationField.idAtributoCfg', 'required')),
      expression: "errors.firstByRule('conciliationField.idAtributoCfg', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'concFieldAtt' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.atributo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.attributes,
      "label": "attibuteSetName",
      "id": 'concFieldAtt' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id),
      "name": 'concFieldAtt' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id),
      "data-vv-name": "conciliationField.nomeAtributo",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeAttName
    },
    model: {
      value: (_vm.conciliationField.nomeAtributo),
      callback: function($$v) {
        _vm.$set(_vm.conciliationField, "nomeAtributo", $$v)
      },
      expression: "conciliationField.nomeAtributo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('conciliationField.nomeAtributo', 'required')),
      expression: "errors.firstByRule('conciliationField.nomeAtributo', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'concFieldBond' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conciliacaoCampo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.conciliationFields,
      "id": 'concFieldBond' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id),
      "name": 'concFieldBond' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id),
      "data-vv-name": "conciliationField.conciliacaoCampo",
      "disabled": _vm.disabled,
      "label": "nome"
    },
    on: {
      "input": _vm.changeConcField
    },
    model: {
      value: (_vm.conciliationField.conciliacaoCampo),
      callback: function($$v) {
        _vm.$set(_vm.conciliationField, "conciliacaoCampo", $$v)
      },
      expression: "conciliationField.conciliacaoCampo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('conciliationField.conciliacaoCampo', 'required')),
      expression: "errors.firstByRule('conciliationField.conciliacaoCampo', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('button-primary', {
    staticClass: "marged-button",
    staticStyle: {
      "border-radius": "50%",
      "border": "none",
      "margin": "30px 10px 10px 0",
      "font-size": "30px"
    },
    attrs: {
      "title": _vm.$t('planoConciliacao.labels.remover'),
      "faIcon": "fa fa-times-circle",
      "id": 'btnRemoveField' + (_vm.conciliationField.key ? _vm.conciliationField.key : _vm.conciliationField.id),
      "clickFunction": _vm.removeField,
      "customClass": "secondary",
      "disabled": _vm.disabled
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cb1d6a18", module.exports)
  }
}

/***/ }),
/* 1459 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0189532"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/categories/categorieModal.pug ***!
  \********************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('better-modal', {
    attrs: {
      "closable": true,
      "id": "categorieModal",
      "checkForUnsavedChanges": true,
      "defaultCloseButton": true
    },
    on: {
      "close-modal": function($event) {
        return _vm.$emit("close-modal")
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.titles.main)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.titles.sub)
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [(_vm.parentCategory) ? _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.categoriaPai'))
    }
  }), _c('br'), _c('label', {
    staticClass: "control-label"
  }, [_c('b', [_vm._v(_vm._s(_vm.parentCategory.number) + " " + _vm._s(_vm.parentCategory.description))])])])]) : _vm._e(), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "categorieName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.descricao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.creatingNumber))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.category.description),
      expression: "category.description"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('categorieName')
    },
    attrs: {
      "type": "text",
      "name": "categorieName",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.category.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.category, "description", $event.target.value)
      }
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('categorieName')),
      expression: "errors.has('categorieName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "categorieIdContabil"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.idContabil'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.accountingId),
      expression: "category.accountingId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "categorieIdContabil",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.category.accountingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.category, "accountingId", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.modal.labels.tipo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('div', {
    staticClass: "radio radio-success radio-wallet"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.type),
      expression: "category.type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "typeCategory",
      "value": "C",
      "id": "credit",
      "disabled": _vm.category.emUso
    },
    domProps: {
      "checked": _vm._q(_vm.category.type, "C")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.category, "type", "C")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "credit"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.credito'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.type),
      expression: "category.type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "typeCategory",
      "value": "D",
      "id": "debit",
      "disabled": _vm.category.emUso
    },
    domProps: {
      "checked": _vm._q(_vm.category.type, "D")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.category, "type", "D")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "debit"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.debito'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.type),
      expression: "category.type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "typeCategory",
      "value": "A",
      "id": "creditDebit",
      "disabled": _vm.category.emUso
    },
    domProps: {
      "checked": _vm._q(_vm.category.type, "A")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.category, "type", "A")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "creditDebit"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.creditoDebito'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.type),
      expression: "category.type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "typeCategory",
      "value": "W",
      "id": "wallet",
      "disabled": _vm.category.emUso
    },
    domProps: {
      "checked": _vm._q(_vm.category.type, "W")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.category, "type", "W")
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "wallet"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.carteiraDigital'))
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('typeCategory')),
      expression: "errors.has('typeCategory')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category.type === 'W'),
      expression: "category.type === 'W'"
    }],
    staticClass: "row row-filter-small"
  }, [_c('div', {
    staticClass: "form-group col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "initialBalance"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.saldoInicial'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('money', _vm._b({
    ref: "money",
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('initialBalance')
    },
    attrs: {
      "type": "text",
      "id": "initialBalance",
      "name": "initialBalance",
      "maxlength": _vm.moneyMaskLength
    },
    model: {
      value: (_vm.category.initialBalance),
      callback: function($$v) {
        _vm.$set(_vm.category, "initialBalance", $$v)
      },
      expression: "category.initialBalance"
    }
  }, 'money', _vm.moneyMask, false)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('initialBalance')),
      expression: "errors.has('initialBalance')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.validacao.saldoVazio'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-3"
  }, [_c('div', {
    staticClass: "col-xs-0 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "initialBalanceDate"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.labels.dataSaldo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "col-xs-0 px-0"
  }, [_c('datepicker', {
    class: {
      'input': true,
      'is-danger': _vm.errors.has('initialBalanceDate')
    },
    attrs: {
      "id": "initialBalanceDate",
      "language": _vm.datePickerLanguage,
      "format": 'dd/MM/yyyy',
      "disabled-dates": _vm.disabledDates,
      "full-month-name": "full-month-name",
      "input-class": "date-picker",
      "wrapper-class": "datepicker-wrapper datepicker-wrapper-wallet",
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "typeable": "typeable",
      "vMaskPattern": "##/##/####"
    },
    model: {
      value: (_vm.category.initialBalanceDate),
      callback: function($$v) {
        _vm.$set(_vm.category, "initialBalanceDate", $$v)
      },
      expression: "category.initialBalanceDate"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('initialBalanceDate')),
      expression: "errors.has('initialBalanceDate')"
    }],
    staticClass: "help is-danger margin-datepicker-error-msg",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.validacao.dataSaldoVazio'))
    }
  })], 1)])])])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.requestSent,
      "label": _vm.$t("categoria.modal.labels.salvar"),
      "customClass": "primary",
      "id": "btnSalvarCategoria",
      "type": "submit",
      "clickFunction": _vm.validate
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d0189532", module.exports)
  }
}

/***/ }),
/* 1460 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-db7bdbc6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/toogle/toogle.pug ***!
  \***************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn common",
    class: [_vm.isActive ? 'toogle-primary' : 'toogle-secondary'],
    attrs: {
      "id": [_vm.idLeft],
      "type": "'button'"
    },
    on: {
      "click": function () { return _vm.trackEvent('idLeft'); }
    }
  }, [(_vm.labelLeft) ? _c('span', [_vm._v(_vm._s(_vm.labelLeft))]) : _vm._e()]), _c('button', {
    staticClass: "btn common",
    class: [_vm.isActive ? 'toogle-secondary' : 'toogle-primary'],
    attrs: {
      "id": [_vm.idRight],
      "type": "'button'"
    },
    on: {
      "click": function () { return _vm.trackEvent('idRight'); }
    }
  }, [(_vm.labelRight) ? _c('span', [_vm._v(_vm._s(_vm.labelRight))]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db7bdbc6", module.exports)
  }
}

/***/ }),
/* 1461 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd048d2a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/treeGrid/treeGrid.pug ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "TreeGridWrapper"
    }
  }, [(_vm.showMassTaskButton) ? _c('mass-task-modal', {
    attrs: {
      "id": _vm.modalTarefaEmMassaId,
      "gridId": _vm.gridId,
      "listIdExt": _vm.lancamentosSelecionados.arrayIdExtBancSelecionado,
      "listIdMov": _vm.lancamentosSelecionados.arrayIdMovFinSelecionado,
      "listRows": _vm.lancamentosSelecionados.arrayLinhaSelecionada
    }
  }) : _vm._e(), (_vm.showMassDeclassifyButton) ? _c('mass-declassify-modal', {
    attrs: {
      "id": _vm.modalDesclassificarEmMassaId,
      "gridId": _vm.gridId,
      "listIdExt": _vm.lancamentosSelecionados.arrayIdExtBancSelecionado,
      "listRowsD": _vm.lancamentosSelecionados.arrayLinhaSelecionada
    }
  }) : _vm._e(), (_vm.showHrTopGrid) ? _c('hr') : _vm._e(), _c('div', {
    staticClass: "col-md-12 treeGridCols"
  }, [(!_vm.treeGridModal) ? _c('div', {
    staticStyle: {
      "height": "500px",
      "max-width": "100%"
    },
    attrs: {
      "id": _vm.gridId
    }
  }) : _vm._e(), (_vm.treeGridModal) ? _c('div', {
    staticClass: "treeGridModal",
    attrs: {
      "id": _vm.gridId
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "div"
  }, [(_vm.showAlert) ? _c('div', {
    staticClass: "col-md-8 px-0"
  }, [_c('div', {
    staticClass: "alertGrid",
    domProps: {
      "innerHTML": _vm._s(_vm.alertMessage)
    }
  })]) : _vm._e(), (_vm.showExportButton || _vm.showExcluirRemessaButton) ? _c('div', {
    staticClass: "pull-right",
    attrs: {
      "id": "botoesExportacoes"
    }
  }, [(_vm.showMassDeclassifyButton) ? _c('button-primary', {
    staticClass: "search-button",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "label": _vm.$t('desclassificacaoEmMassa.titulos.botao'),
      "id": _vm.btnDesclassificarEmMassaId,
      "clickFunction": _vm.openModalMassDeclassify,
      "disabled": "disabled"
    }
  }) : _vm._e(), (_vm.showMassTaskButton) ? _c('button-primary', {
    staticClass: "search-button",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "label": _vm.$t('tarefaEmMassa.titulos.titulo'),
      "id": _vm.btnTarefaEmMassaId,
      "clickFunction": _vm.openModalMassTask,
      "disabled": "disabled"
    }
  }) : _vm._e(), (_vm.showAnnulledMovementButton) ? _c('button-primary', {
    staticClass: "search-button",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "label": _vm.labelBtnAnulacaoContaLancamento,
      "id": _vm.btnAnulacaoContaLancamentoId,
      "clickFunction": _vm.annulMovements,
      "disabled": "disabled"
    }
  }) : _vm._e(), (_vm.showExcluirRemessaButton) ? _c('button-primary', {
    staticClass: "search-button",
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "label": _vm.$t('remessaIntegracao.titulos.excluirRemessas'),
      "id": _vm.btnExcluir,
      "clickFunction": _vm.excluirRemessas,
      "disabled": "disabled"
    }
  }) : _vm._e(), _c('button-primary', {
    staticClass: "search-button",
    attrs: {
      "label": _vm.$t('botoesExportacoes.titulos.tooltipExport'),
      "id": _vm.btnId,
      "clickFunction": _vm.exportarXls
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dd048d2a", module.exports)
  }
}

/***/ }),
/* 1462 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddae9a96"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/attributesSet/newAtributeModal.pug ***!
  \*************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('better-modal', {
    attrs: {
      "closable": true,
      "id": "attributesModal",
      "checkForUnsavedChanges": false
    },
    on: {
      "close-modal": function($event) {
        return _vm.$emit("close-modal")
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.novoAtributo'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.cadastre'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attribute.inUse),
      expression: "attribute.inUse"
    }],
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon alert-icon"
  }), _c('span', {
    staticClass: "alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.validacao.atributoEmUsoEditar'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.identificador'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.name),
      expression: "attribute.name"
    }],
    staticClass: "form-control to-upper",
    class: {
      'is-danger': _vm.errors.has('attributeName')
    },
    attrs: {
      "type": "text",
      "id": "attributeName",
      "name": "attributeName",
      "maxlength": "20",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.name)
    },
    on: {
      "keyup": _vm.handleIdentifier,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attributeName')),
      expression: "errors.has('attributeName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeDescription"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.description),
      expression: "attribute.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('attributeDescription')
    },
    attrs: {
      "type": "text",
      "id": "attributeDescription",
      "name": "attributeDescription",
      "maxlength": "50",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "description", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attributeDescription')),
      expression: "errors.has('attributeDescription')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "type"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('attribute.type')
    },
    attrs: {
      "options": _vm.types,
      "id": "type",
      "name": "type",
      "label": "description",
      "data-vv-name": "attribute.type",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "disabled": _vm.attribute.inUse
    },
    on: {
      "input": _vm.toggleAditionalFields
    },
    model: {
      value: (_vm.attribute.type),
      callback: function($$v) {
        _vm.$set(_vm.attribute, "type", $$v)
      },
      expression: "attribute.type"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('attribute.type', 'required')),
      expression: "errors.firstByRule('attribute.type', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributeTypeHint),
      expression: "attributeTypeHint"
    }],
    staticClass: "col-xs-6 att-field-hint",
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "info-span",
    domProps: {
      "innerHTML": _vm._s(_vm.attributeTypeHint)
    }
  })])]), (_vm.availableFields.value) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "possibleValues"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.valoresPossiveis'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input-tag', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    class: {
      "input": true,
      "is-danger": _vm.errors.has("attribute.possibleValues")
    },
    attrs: {
      "tags": _vm.attribute.possibleValues,
      "id": "possibleValues",
      "name": "possibleValues",
      "value": "possibleValues.value",
      "disabled": _vm.attribute.inUse
    },
    on: {
      "input": _vm.possibleValuesChanged
    },
    model: {
      value: (_vm.tagsPossibleValue),
      callback: function($$v) {
        _vm.tagsPossibleValue = $$v
      },
      expression: "tagsPossibleValue"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attribute.possibleValues')),
      expression: "errors.has('attribute.possibleValues')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "col-xs-12 att-field-hint row-filter-small",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticClass: "hint-span",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.infos.dicaCombo'))
    }
  })])]) : _vm._e(), (_vm.availableFields.mask) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeMask"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.mascara'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.mask),
      expression: "attribute.mask"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "attributeMask",
      "type": "text",
      "name": "attributeMask",
      "maxlength": "40",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.mask)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "mask", $event.target.value)
      }
    }
  })])]) : _vm._e(), (_vm.availableFields.validation) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeValidation"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.validacao'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.validation),
      expression: "attribute.validation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "attributeValidation",
      "type": "text",
      "name": "attributeValidation",
      "maxlength": "200",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.validation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "validation", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "col-xs-12 att-field-hint row-filter-small",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticClass: "hint-span",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.infos.validacao'))
    }
  })])]) : _vm._e()])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "id": "btnCriarNovoAtributo",
      "clickFunction": _vm.validate,
      "label": _vm.$t('conjuntoAtributo.labels.adicionar'),
      "disabled": _vm.attribute.inUse
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "id": "btnFecharModalDeNovoAtributo",
      "label": _vm.$t('conjuntoAtributo.labels.cancelar'),
      "customClass": "secondary",
      "clickFunction": _vm.close
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ddae9a96", module.exports)
  }
}

/***/ }),
/* 1463 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1db8ad0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/establishments/moveEstablishmentModal.pug ***!
  \********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm-modal', {
    attrs: {
      "id": "moveEstablishmentModal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t(_vm.textModal))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('estabelecimentos.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalMoveEstablishment",
      "clickFunction": _vm.closeModal,
      "disabled": _vm.disableButton
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('estabelecimentos.labels.sim'),
      "id": "btnConfirmacaoMoveEstablishment",
      "clickFunction": _vm.confirmMoveEstablishment,
      "disabled": _vm.disableButton
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e1db8ad0", module.exports)
  }
}

/***/ }),
/* 1464 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2bf9bb0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/conciliationSummary/conciliationSummary.pug ***!
  \***********************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "conciliationSummaryWrapper"
    }
  }, [(_vm.shown.bankAccounts) ? _c('multi-select-modal', {
    attrs: {
      "id": "bankAccountsModal",
      "data": _vm.data.bankAccounts
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), (_vm.shown.categories) ? _c('multi-select-modal', {
    attrs: {
      "id": "categoriesModal",
      "data": _vm.data.categories
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('resumoConciliacao.titulos.titulo'),
      "subTitle": _vm.$t('resumoConciliacao.titulos.subtitulo')
    }
  }), _c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('vue-tabs', {
    attrs: {
      "id": "tab-navigation"
    },
    on: {
      "tab-change": _vm.handleTabChange
    }
  }, [(_vm.showCalendarTab) ? _c('v-tab', {
    key: "calendarSummary",
    ref: "calendarSummary",
    staticClass: "tab",
    attrs: {
      "title": _vm.$t('resumoConciliacao.labels.calendario'),
      "id": "calendarSummary"
    }
  }, [_c('calendar-summary')], 1) : _vm._e(), (_vm.showReportTab) ? _c('v-tab', {
    key: "reportSummary",
    ref: "reportSummary",
    staticClass: "tab",
    attrs: {
      "title": _vm.$t('resumoConciliacao.labels.relatorio'),
      "id": "reportSummary"
    }
  }, [_c('div', {
    staticClass: "row pt-5"
  }, [_c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('resumoConciliacao.titulos.tituloFiltro')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "hasExportFile": true,
      "showLoadingFullPage": false,
      "exportFileFlag": _vm.isExportFile
    },
    on: {
      "update-flagExportingFile": function($event) {
        _vm.isExportFile = !_vm.isExportFile
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('resumoConciliacao.labels.dataBase'))
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }), _c('div', {
    staticClass: "radio radio-success no-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoMovimetacao),
      expression: "tipoMovimetacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resumoRadioBtn",
      "id": "radioButtonFilterMovFinanceiro-ResumoConciliacao",
      "checked": "checked",
      "value": "M"
    },
    domProps: {
      "checked": _vm._q(_vm.tipoMovimetacao, "M")
    },
    on: {
      "change": function($event) {
        _vm.tipoMovimetacao = "M"
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "radioButtonFilterMovFinanceiro-ResumoConciliacao"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('resumoConciliacao.labels.movimentosFinanceiros'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoMovimetacao),
      expression: "tipoMovimetacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resumoRadioBtn",
      "id": "radioButtonFilterExtBancario-ResumoConciliacao",
      "value": "F"
    },
    domProps: {
      "checked": _vm._q(_vm.tipoMovimetacao, "F")
    },
    on: {
      "change": function($event) {
        _vm.tipoMovimetacao = "F"
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "radioButtonFilterExtBancario-ResumoConciliacao"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('resumoConciliacao.labels.extratoBancario'))
    }
  })])])]), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 365
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "value": true,
      "color": {
        "checked": "#40b9bb",
        "unchecked": "#E5E5E5"
      },
      "height": 20,
      "width": 40
    },
    on: {
      "change": _vm.resetFilter
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.pesquisaAvancada'))
    }
  })], 1)]), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bankAccountsSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.contasBancarias'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.bankAccounts.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.bankAccounts,
      "props": _vm.inputTagsProps.bankAccounts
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.bankAccounts, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('relatorioConciliacao.labels.selecaoContaBancaria'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarContasBancarias-RelatorioDeConciliacao",
      "clickFunction": _vm.openSelectBankAccountsModal
    }
  })], 1)])]), _c('input-establishment', {
    attrs: {
      "id": "establishmentsFilterConciliationSummary",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "categorieSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('categoria.titulos.titulo'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.categories.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.categories,
      "props": _vm.inputTagsProps.categories
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.categories, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('categoria.labels.selecionarCategoria'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarCategorias-ResumoDeConciliacao",
      "clickFunction": _vm.openSelectCategoriesModal
    }
  })], 1)])]), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.statusConciliacao'))
    }
  }), _vm._l((_vm.situationList), function(status, idx) {
    return _c('div', [_c('div', {
      staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.checked),
        expression: "status.checked"
      }],
      attrs: {
        "id": status.id,
        "type": "checkbox",
        "name": "status"
      },
      domProps: {
        "checked": Array.isArray(status.checked) ? _vm._i(status.checked, null) > -1 : (status.checked)
      },
      on: {
        "change": function($event) {
          var $$a = status.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(status, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(status, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(status, "checked", $$c)
          }
        }
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": status.id
      }
    }, [_vm._v(_vm._s(status.nome))])])])
  })], 2)])], 1) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "conciliationSummaryGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "ResumoConciliacao",
      "treeGridLayoutPath": "conciliationSummary",
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)]) : _vm._e()], 1)], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e2bf9bb0", module.exports)
  }
}

/***/ }),
/* 1465 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-e804536c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/bankAccounts/belvoWidget.pug ***!
  \*************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOpenFinance),
      expression: "showOpenFinance"
    }],
    staticClass: "row col-xs-10"
  }, [_c('label', {
    staticClass: "control-label open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.titulo'))
    }
  }), (!_vm.bankAccount.optIn || !((!!_vm.bankAccount.optIn.belvoLinkId && _vm.bankAccount.optIn.statusAceite === "2") || _vm.bankAccount.optIn.statusAceite === "1")) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('toggle-button', {
    attrs: {
      "color": "#147d96",
      "sync": true
    },
    model: {
      value: (_vm.enableOfdaForm),
      callback: function($$v) {
        _vm.enableOfdaForm = $$v
      },
      expression: "enableOfdaForm"
    }
  }), _c('label', {
    staticClass: "control-label open-finance",
    staticStyle: {
      "margin-left": "0.5vh"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.compartilhar'))
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableOfdaForm),
      expression: "enableOfdaForm"
    }],
    staticClass: "col-xs-12 open-finance-box"
  }, [_c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoConta'))
    }
  }), _c('div', {
    staticClass: "radio radio-success no-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoConta),
      expression: "tipoConta"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoConta",
      "id": "tipoContaPf"
    },
    domProps: {
      "value": 'PF',
      "checked": _vm._q(_vm.tipoConta, 'PF')
    },
    on: {
      "change": function($event) {
        _vm.tipoConta = 'PF'
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "tipoContaPf"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoContaPf'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoConta),
      expression: "tipoConta"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoConta",
      "id": "tipoContaPj"
    },
    domProps: {
      "value": 'PJ',
      "checked": _vm._q(_vm.tipoConta, 'PJ')
    },
    on: {
      "change": function($event) {
        _vm.tipoConta = 'PJ'
      }
    }
  }), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "tipoContaPj"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.tipoContaPj'))
    }
  })])]), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "requisitante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.requisitante'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requisitante),
      expression: "requisitante"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('requisitante', 'formOFDA')
    },
    attrs: {
      "id": "requisitante",
      "name": "requisitante",
      "data-vv-scope": "formOFDA"
    },
    domProps: {
      "value": (_vm.requisitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requisitante = $event.target.value
      }
    }
  }), (_vm.errors.has('requisitante', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "cpfRequisitante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.cpfRequisitante'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          digits: 11,
          cpfValido: true
        }
      }),
      expression: "{ rules: { required: true, digits: 11, cpfValido: true} }"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('cpfRequisitante', 'formOFDA')
    },
    attrs: {
      "id": "cpfRequisitante",
      "name": "cpfRequisitante",
      "mask": "###.###.###-##",
      "data-vv-scope": "formOFDA"
    },
    model: {
      value: (_vm.cpf),
      callback: function($$v) {
        _vm.cpf = $$v
      },
      expression: "cpf"
    }
  }), (_vm.errors.has('cpfRequisitante', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.cpfInvalido'))
    }
  }) : _vm._e()], 1), (_vm.tipoConta === 'PJ') ? _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "empresa"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.empresa'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empresa),
      expression: "empresa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('empresa', 'formOFDA')
    },
    attrs: {
      "id": "empresa",
      "name": "empresa",
      "data-vv-scope": "formOFDA"
    },
    domProps: {
      "value": (_vm.empresa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.empresa = $event.target.value
      }
    }
  }), (_vm.errors.has('empresa', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', {
    staticClass: "open-finance",
    attrs: {
      "for": "cnpjRequisitante"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.cnpjRequisitante'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          min: 14,
          max: 14,
          cnpjValido: true
        }
      }),
      expression: "{ rules: { required: true, min: 14, max: 14, cnpjValido: true} }"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('cnpjRequisitante', 'formOFDA')
    },
    attrs: {
      "id": "cnpjRequisitante",
      "name": "cnpjRequisitante",
      "mask": "XX.XXX.XXX/XXXX-XX",
      "data-vv-scope": "formOFDA"
    },
    model: {
      value: (_vm.cnpj),
      callback: function($$v) {
        _vm.cnpj = $$v
      },
      expression: "cnpj"
    }
  }), (_vm.errors.has('cnpjRequisitante', 'formOFDA')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.erro.cnpjInvalido'))
    }
  }) : _vm._e()], 1)]) : _vm._e()])])]) : _vm._e(), (_vm.bankAccount.optIn && ((!!_vm.bankAccount.optIn.belvoLinkId && _vm.bankAccount.optIn.statusAceite === "2") || _vm.bankAccount.optIn.statusAceite === "1")) ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label open-finance",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('ofda.jaAutorizado'))
    }
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e804536c", module.exports)
  }
}

/***/ }),
/* 1466 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea2dd414"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/betterModal/betterModal.pug ***!
  \************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (true),
      expression: "true"
    }],
    staticClass: "modal-mask",
    class: {
      "bring-back": _vm.bringBack
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-lg"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.closable) ? _c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._t("header")], 2), (_vm.tabbedModal) ? _c('div', {
    staticClass: "modal-tabbed"
  }, [_vm._t("body")], 2) : _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), (_vm.showFooter) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer"), (_vm.defaultCloseButton) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "disabled": false,
      "label": _vm.$t("dataTable.labels.acaoFechar"),
      "customClass": "secondary",
      "id": _vm.id + "ButtonClose",
      "clickFunction": _vm.close
    }
  }) : _vm._e()], 2) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ea2dd414", module.exports)
  }
}

/***/ }),
/* 1467 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb2dd9ec"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/unauthorized/unauthorized.pug ***!
  \*************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "middle-white-box"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "not-found-img",
    attrs: {
      "src": _vm.imageNotFound
    }
  }), _c('br'), _c('p', {
    staticClass: "big-txt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('naoAutorizado.labels.mensagem'))
    }
  }), _c('button-primary', {
    attrs: {
      "label": _vm.$t('naoAutorizado.labels.voltarHome'),
      "faIcon": "",
      "id": "btn403VoltarHome",
      "clickFunction": _vm.goHome,
      "customClass": "big-primary"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eb2dd9ec", module.exports)
  }
}

/***/ }),
/* 1468 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb88efa0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/index/index.pug ***!
  \***********************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoadingDataGeneral) ? _c('div', {
    staticClass: "isLoadingDataGeneral"
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.view && _vm.$store.getters.allowedFuncionalities && _vm.doneLoading) ? _c('div', {
    staticClass: "container-fluid center-img-inicial px-0"
  }, [_c('dashboard', {
    attrs: {
      "charts": _vm.dashboardCharts
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eb88efa0", module.exports)
  }
}

/***/ }),
/* 1469 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec141a1a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/modals/applyModal.pug ***!
  \**************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm-modal', {
    attrs: {
      "id": "applyModal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.totalDivergence == 0 ? _vm.$t('conciliacaoManual.labels.conciliacaoDeLote') : _vm.$t('conciliacaoManual.labels.conciliacaoDeLoteDivergente'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.acaoFechar'),
      "customClass": "secondary",
      "id": "btnFecharModalAplicarLote",
      "clickFunction": _vm.closeModal,
      "disabled": _vm.disableButton
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.acaoConfirmar'),
      "id": "btnConfirmacaoAplicarLote",
      "clickFunction": _vm.isJustification ? _vm.confirmJustify : _vm.confirmApplyAllotment,
      "disabled": _vm.disableButton
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ec141a1a", module.exports)
  }
}

/***/ }),
/* 1470 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-f46bd904"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/filter/filtersCommon.pug ***!
  \************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters-common"
  }, _vm._l((_vm.sortedData), function(value) {
    return (value.options.length > 0) ? _c('filter-common', {
      key: value.id,
      attrs: {
        "data": value.label,
        "options": value.options,
        "onChange": value.onChange,
        "disabled": value.disabled,
        "quantity": _vm.quantity,
        "hasGroups": value.hasGroups
      }
    }) : _vm._e()
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f46bd904", module.exports)
  }
}

/***/ }),
/* 1471 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-f99f3a28"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/financialMovement/financialMovement.pug ***!
  \*******************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "financialMovementsWrapper"
    }
  }, [_c('grid-details-modal', {
    attrs: {
      "id": _vm.finMovGridModalId,
      "closable": true,
      "tabs": _vm.modalDetailsTabs,
      "isOpen": _vm.isOpenDetailsModal
    },
    on: {
      "closeDetailsModal": _vm.closeDetailsModal
    }
  }), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('movimentosFinanceiros.titulos.titulo'),
      "subTitle": _vm.$t('movimentosFinanceiros.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('movimentosFinanceiros.titulos.filtroTitulo')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "hasExportFile": true,
      "showLoadingFullPage": false,
      "exportFileFlag": _vm.isExportFile
    },
    on: {
      "update-flagExportingFile": function($event) {
        _vm.isExportFile = !_vm.isExportFile
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 100
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "value": true,
      "color": {
        "checked": "#40b9bb",
        "unchecked": "#E5E5E5"
      },
      "height": 20,
      "width": 40
    },
    on: {
      "change": _vm.resetFilter
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.pesquisaAvancada'))
    }
  })], 1)]), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "row"
  }, [_c('input-establishment', {
    attrs: {
      "id": "establishmentsFilterFinancialMovement",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('movimentosFinanceiros.labels.conciliacao'))
    }
  }), _vm._l((_vm.situationList), function(status, idx) {
    return _c('div', [_c('div', {
      staticClass: "checkbox check-success col-xs-1 pl-0 status-filter"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.checked),
        expression: "status.checked"
      }],
      attrs: {
        "id": status.id,
        "type": "checkbox",
        "name": "status"
      },
      domProps: {
        "checked": Array.isArray(status.checked) ? _vm._i(status.checked, null) > -1 : (status.checked)
      },
      on: {
        "change": function($event) {
          var $$a = status.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(status, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(status, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(status, "checked", $$c)
          }
        }
      }
    }), _c('label', {
      staticClass: "func-group-labels",
      attrs: {
        "for": status.id
      }
    }, [_vm._v(_vm._s(status.nome))])])])
  })], 2)])], 1) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "MovimentoFinanceiro",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "MovimentosFinanceiros",
      "showMassTaskAction": true,
      "showAlert": true,
      "cfgObj": _vm.treeGridCfg,
      "alertMessage": _vm.$t('movimentosFinanceiros.labels.alertaGrid')
    }
  })], 1)], 1)])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f99f3a28", module.exports)
  }
}

/***/ }),
/* 1472 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd19de7a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/loading/LoadingFullPage.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "isLoadingFullPage"
  }), (!!_vm.message) ? _c('span', {
    staticClass: "spanLoading",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fd19de7a", module.exports)
  }
}

/***/ }),
/* 1473 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0049b780","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/clientModal/ClientModal.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-0049b780","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ClientModal.vue */ 1028);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("721e8f8a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0049b780\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClientModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0049b780\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClientModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1474 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0643cdba","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/accessProfile/New.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-0643cdba","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./New.vue */ 1029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("d6c58f80", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0643cdba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0643cdba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1475 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-07ceb7ab","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/menu/SuspendedMenu.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-07ceb7ab","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./SuspendedMenu.vue */ 1030);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("37b1f6a5", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-07ceb7ab\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SuspendedMenu.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-07ceb7ab\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SuspendedMenu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1476 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-081ec6ca","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonApplication/ButtonApplication.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-081ec6ca","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ButtonApplication.vue */ 1031);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("7ce60eb8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-081ec6ca\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonApplication.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-081ec6ca\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonApplication.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1477 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-09c1836a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/calendarView/CalendarView.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-09c1836a","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./CalendarView.vue */ 1032);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("44e64ae6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-09c1836a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarView.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-09c1836a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarView.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1478 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0a21cc36","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/attributesSet/Attribute.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-0a21cc36","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Attribute.vue */ 1033);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("82b32b12", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0a21cc36\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Attribute.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0a21cc36\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Attribute.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1479 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0affa294","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabDetails/TabDetails.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-0affa294","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabDetails.vue */ 1034);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("6b9472bc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0affa294\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabDetails.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0affa294\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabDetails.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1480 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0d6d05cc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/headerBar/HeaderBar.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-0d6d05cc","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./HeaderBar.vue */ 1035);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("b7c0993e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0d6d05cc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HeaderBar.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0d6d05cc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HeaderBar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1481 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-0e4ca9a2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/Allotment.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-0e4ca9a2","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Allotment.vue */ 1036);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("fd156bc4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0e4ca9a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Allotment.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-0e4ca9a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Allotment.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1482 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-103c15fc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/App.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-103c15fc","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./App.vue */ 1037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("7b90e5c6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-103c15fc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-103c15fc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1483 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-13215916","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/modal/Modal.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-13215916","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Modal.vue */ 1038);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("41b5d1f8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-13215916\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-13215916\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1484 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-15fd6674","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/input/dynamicInput/DynamicInput.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-15fd6674","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./DynamicInput.vue */ 1039);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("669a7a2c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-15fd6674\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DynamicInput.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-15fd6674\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DynamicInput.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1485 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-169f7ba6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/input/betterInputTag/BetterInputTag.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-169f7ba6","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./BetterInputTag.vue */ 1040);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("009b4bc2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-169f7ba6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BetterInputTag.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-169f7ba6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BetterInputTag.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1486 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-17392d8c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/TabRemittanceDetail.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-17392d8c","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabRemittanceDetail.vue */ 1041);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("78a6193c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-17392d8c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabRemittanceDetail.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-17392d8c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabRemittanceDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1487 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-1a206fcb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCriteria.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-1a206fcb","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationCriteria.vue */ 1042);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2fc8dac6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1a206fcb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationCriteria.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1a206fcb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationCriteria.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1488 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-1d6ea436","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabTasks/TabTasks.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-1d6ea436","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabTasks.vue */ 1043);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("687af796", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1d6ea436\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabTasks.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1d6ea436\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabTasks.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1489 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-1e61ffba","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/manualConciliation/ManualConciliation.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-1e61ffba","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ManualConciliation.vue */ 1044);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("683fcaf2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1e61ffba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManualConciliation.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1e61ffba\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ManualConciliation.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1490 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-248a974b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/notification/Notification.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-248a974b","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Notification.vue */ 1045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("81dd7ab8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-248a974b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Notification.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-248a974b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Notification.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1491 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-265147fb","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/administration/auditLog/AuditModal.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-265147fb","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./AuditModal.vue */ 1046);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("b118715c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-265147fb\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AuditModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-265147fb\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AuditModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1492 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-28cf8108","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/bankBalance/BankBalance.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-28cf8108","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./BankBalance.vue */ 1047);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("67f48b3b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-28cf8108\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BankBalance.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-28cf8108\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BankBalance.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1493 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-292a2a0b","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/treeViewHistoric/TreeviewHistoric.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-292a2a0b","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TreeviewHistoric.vue */ 1048);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("cf4f08e6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-292a2a0b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeviewHistoric.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-292a2a0b\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeviewHistoric.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1494 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2a9b0864","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/massDeclassifyModal/MassDeclassifyModal.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-2a9b0864","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./MassDeclassifyModal.vue */ 1049);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("7c743e8a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2a9b0864\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MassDeclassifyModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2a9b0864\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MassDeclassifyModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1495 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b0b37d6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonPrint/ButtonPrint.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-2b0b37d6","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ButtonPrint.vue */ 1050);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("09c8bfc8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2b0b37d6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonPrint.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2b0b37d6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonPrint.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1496 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b0e21fa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/NewConciliationCriteria.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-2b0e21fa","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./NewConciliationCriteria.vue */ 1051);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("0179a817", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2b0e21fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NewConciliationCriteria.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2b0e21fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NewConciliationCriteria.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1497 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2dcfce74","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/Justifications.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-2dcfce74","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Justifications.vue */ 1052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2e098f90", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2dcfce74\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Justifications.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2dcfce74\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Justifications.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1498 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2df64858","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/attributesSet/TreeViewAtt.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-2df64858","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TreeViewAtt.vue */ 1053);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("34bd4328", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2df64858\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeViewAtt.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2df64858\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeViewAtt.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1499 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2e8324c6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonSearch/ButtonSearch.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-2e8324c6","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ButtonSearch.vue */ 1054);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("6203e3a4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2e8324c6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonSearch.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-2e8324c6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonSearch.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1500 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-30421256","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/gadget/TaskGadget.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-30421256","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TaskGadget.vue */ 1055);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("5ca80851", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30421256\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TaskGadget.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-30421256\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TaskGadget.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1501 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-33983fa4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/massTaskModal/MassTaskModal.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-33983fa4","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./MassTaskModal.vue */ 1056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("3a1a4a51", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-33983fa4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MassTaskModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-33983fa4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MassTaskModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1502 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-33bc27be","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/establishments/New.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-33bc27be","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./New.vue */ 1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2b471937", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-33bc27be\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-33bc27be\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1503 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-35506d6d","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/operator/List.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-35506d6d","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./List.vue */ 1058);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("39e94cec", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-35506d6d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-35506d6d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1504 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-37139c00","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabIntegrations/TabIntegrations.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-37139c00","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabIntegrations.vue */ 1059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("4d8af72c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37139c00\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabIntegrations.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-37139c00\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabIntegrations.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1505 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-3b9486da","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/auditLog/AuditLog.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-3b9486da","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./AuditLog.vue */ 1060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("1c4dd52b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3b9486da\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AuditLog.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-3b9486da\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AuditLog.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1506 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4140c414","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabAllotment/TabAllotment.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-4140c414","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabAllotment.vue */ 1061);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("12848f4a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4140c414\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabAllotment.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4140c414\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabAllotment.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1507 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4485b970","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/establishments/List.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-4485b970","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./List.vue */ 1062);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2fb95f5e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4485b970\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4485b970\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1508 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-44a5b89a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/GridDetailsModal.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-44a5b89a","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./GridDetailsModal.vue */ 1063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("34370586", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-44a5b89a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GridDetailsModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-44a5b89a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GridDetailsModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1509 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-44b39af4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/input/dateRange/DateRange.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-44b39af4","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./DateRange.vue */ 1064);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("355bb6d9", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-44b39af4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DateRange.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-44b39af4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DateRange.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1510 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4672dfff","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/buttonPrimary/ButtonPrimary.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-4672dfff","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ButtonPrimary.vue */ 1065);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("17765bcf", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4672dfff\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonPrimary.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4672dfff\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ButtonPrimary.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1511 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-475e994c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/occurrenceReport/OccurrenceReport.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-475e994c","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./OccurrenceReport.vue */ 1066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("63477fbf", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-475e994c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OccurrenceReport.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-475e994c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OccurrenceReport.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1512 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4ab25a9f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/conciliationCriteria/ConciliationCritFields.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-4ab25a9f","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationCritFields.vue */ 1067);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("10db7742", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4ab25a9f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationCritFields.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4ab25a9f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationCritFields.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1513 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4b893cfa","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/conciliationReport/ConciliationReport.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-4b893cfa","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationReport.vue */ 1068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("35635730", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b893cfa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationReport.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4b893cfa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConciliationReport.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1514 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-4dcb5a70","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/categories/TreeviewCategories.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-4dcb5a70","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TreeviewCategories.vue */ 1069);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("721df5cc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4dcb5a70\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeviewCategories.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-4dcb5a70\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeviewCategories.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1515 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-52cce311","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/modals/JustifyModal.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-52cce311","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./JustifyModal.vue */ 1070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("13bd5944", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-52cce311\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JustifyModal.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-52cce311\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./JustifyModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1516 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-58825cfb","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/conciliationSummary/CalendarSummary.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-58825cfb","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./CalendarSummary.vue */ 1071);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("9f6165c0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-58825cfb\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarSummary.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-58825cfb\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarSummary.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1517 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-5cb3e11e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/login/Login.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-5cb3e11e","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue */ 1072);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2bbfc014", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5cb3e11e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5cb3e11e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1518 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-5e2ad742","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/RemittanceIntegrationModal.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-5e2ad742","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./RemittanceIntegrationModal.vue */ 1073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("194ff904", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5e2ad742\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RemittanceIntegrationModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-5e2ad742\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RemittanceIntegrationModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1519 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6021cb38","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/administration/assignment/List.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-6021cb38","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./List.vue */ 1074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("6440802e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6021cb38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6021cb38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1520 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-61521a9e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/PendingConciliations.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-61521a9e","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./PendingConciliations.vue */ 1075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("9a694f66", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-61521a9e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PendingConciliations.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-61521a9e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PendingConciliations.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1521 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-632d0eea","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/home/Home.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-632d0eea","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue */ 1076);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("4970b9f4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-632d0eea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-632d0eea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1522 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-63472d8e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabClassification/TabClassification.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-63472d8e","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabClassification.vue */ 1077);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2696932a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-63472d8e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabClassification.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-63472d8e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabClassification.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1523 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-648087e0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/categories/List.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-648087e0","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./List.vue */ 1078);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("43550ce8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-648087e0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-648087e0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1524 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-65d81ebc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/bankStatement/BankStatement.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-65d81ebc","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./BankStatement.vue */ 1079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("6be2360a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65d81ebc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BankStatement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65d81ebc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BankStatement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1525 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-65f48b0a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/filter/FilterCommon.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-65f48b0a","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./FilterCommon.vue */ 1080);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("83f8142e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65f48b0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FilterCommon.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-65f48b0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FilterCommon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1526 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-66125f00","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/gridDetailsModal/tabHistoric/TabHistoric.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-66125f00","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabHistoric.vue */ 1081);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("e3ee89c2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-66125f00\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabHistoric.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-66125f00\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabHistoric.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1527 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-66984113","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/conciliationPlan/List.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-66984113","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./List.vue */ 1082);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("4daa2aca", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-66984113\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-66984113\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1528 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6bd12989","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/login/CadastrarSenha.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-6bd12989","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./CadastrarSenha.vue */ 1083);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("32cb3436", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6bd12989\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CadastrarSenha.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6bd12989\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CadastrarSenha.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1529 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6f5ddfa2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/integration/processedFiles/ProcessedFiles.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-6f5ddfa2","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ProcessedFiles.vue */ 1084);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("5f4749d8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6f5ddfa2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProcessedFiles.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6f5ddfa2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProcessedFiles.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1530 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-6fc77e22","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/TabRemittanceReport.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-6fc77e22","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TabRemittanceReport.vue */ 1085);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("629442ea", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6fc77e22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabRemittanceReport.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-6fc77e22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TabRemittanceReport.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1531 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-72a54622","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/classificationCriteria/NewClassificationCriteria.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-72a54622","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./NewClassificationCriteria.vue */ 1086);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("bd370a22", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-72a54622\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NewClassificationCriteria.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-72a54622\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NewClassificationCriteria.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1532 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-72f81e1a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/changeApplicationModal/ChangeApplicationModal.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-72f81e1a","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ChangeApplicationModal.vue */ 1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("a29b7fae", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-72f81e1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeApplicationModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-72f81e1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ChangeApplicationModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1533 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-73ba95ea","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/notFound/NotFound.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-73ba95ea","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./NotFound.vue */ 1088);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("1b0a7dee", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-73ba95ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotFound.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-73ba95ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NotFound.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1534 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-743a74ea","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/bankAccounts/List.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-743a74ea","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./List.vue */ 1089);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("38a0fd64", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-743a74ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-743a74ea\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1535 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-74c6103a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/myAccountModal/MyAccountModal.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-74c6103a","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./MyAccountModal.vue */ 1090);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("47bc3b6a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-74c6103a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MyAccountModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-74c6103a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MyAccountModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1536 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7511b8fb","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/attributesSet/New.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-7511b8fb","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./New.vue */ 1091);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("d94be116", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7511b8fb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7511b8fb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1537 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-777d8892","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/pageTitle/PageTitle.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-777d8892","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./PageTitle.vue */ 1092);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("93acd706", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-777d8892\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PageTitle.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-777d8892\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PageTitle.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1538 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7947ef80","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/SelectedEntries.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-7947ef80","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./SelectedEntries.vue */ 1093);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("5c7b9c5c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7947ef80\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelectedEntries.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7947ef80\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SelectedEntries.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1539 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7d8ec08a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/conciliationPlan/New.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-7d8ec08a","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./New.vue */ 1094);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2a2cc335", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7d8ec08a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7d8ec08a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1540 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7dbbcb98","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/form/formSearch/FormSearch.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-7dbbcb98","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./FormSearch.vue */ 1095);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("5a4ebe84", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7dbbcb98\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FormSearch.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7dbbcb98\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FormSearch.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1541 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-7fa5a10b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/classificationCriteria/ClassificationCriteria.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-7fa5a10b","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ClassificationCriteria.vue */ 1096);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("47cad82f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7fa5a10b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClassificationCriteria.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7fa5a10b\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ClassificationCriteria.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1542 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-885acbc0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/EntryManager.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-885acbc0","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./EntryManager.vue */ 1097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("074aba22", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-885acbc0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EntryManager.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-885acbc0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EntryManager.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1543 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-8bfa890c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/multiSelectModal/MultiSelectModal.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-8bfa890c","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./MultiSelectModal.vue */ 1098);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("1d0f05ba", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8bfa890c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MultiSelectModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-8bfa890c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MultiSelectModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1544 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-9db5d5f8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/bankAccounts/New.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-9db5d5f8","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./New.vue */ 1099);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("556d4c0f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9db5d5f8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-9db5d5f8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./New.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1545 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-a0986062","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/conciliationSummary/CalendarDetailBox.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-a0986062","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./CalendarDetailBox.vue */ 1100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("238747e2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a0986062\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarDetailBox.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a0986062\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CalendarDetailBox.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1546 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-a0986062","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./client/components/reports/conciliationSummary/CalendarDetailBox.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-a0986062","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=1!./CalendarDetailBox.vue */ 1101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2ead7fa7", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a0986062\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./CalendarDetailBox.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-a0986062\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./CalendarDetailBox.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1547 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-b0335380","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/integration/remittanceIntegration/RemittanceIntegrationCreationModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-b0335380","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./RemittanceIntegrationCreationModal.vue */ 1102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("65d934f1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b0335380\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RemittanceIntegrationCreationModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b0335380\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RemittanceIntegrationCreationModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1548 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-b8e2c004","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/loading/LoadingPlaceholder.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-b8e2c004","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./LoadingPlaceholder.vue */ 1103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("071c25ca", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b8e2c004\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoadingPlaceholder.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b8e2c004\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoadingPlaceholder.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1549 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-bb3b5fcc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/confirmModal/ConfirmModal.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-bb3b5fcc","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ConfirmModal.vue */ 1104);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("709cd887", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bb3b5fcc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfirmModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bb3b5fcc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfirmModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1550 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-bb3e89cc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/digitalWalletBalance/DigitalWalletBalance.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-bb3e89cc","scoped":true,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./DigitalWalletBalance.vue */ 1105);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("73455477", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bb3e89cc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DigitalWalletBalance.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-bb3e89cc\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./DigitalWalletBalance.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1551 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-c75fdef8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/filterPortlet/FilterPortlet.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-c75fdef8","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./FilterPortlet.vue */ 1106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("16fe2fd4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c75fdef8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FilterPortlet.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c75fdef8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FilterPortlet.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1552 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-c76a377a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/conciliationPlan/TreeViewPlans.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-c76a377a","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TreeViewPlans.vue */ 1107);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("c482454a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c76a377a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeViewPlans.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c76a377a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeViewPlans.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1553 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-d0189532","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/categories/CategorieModal.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-d0189532","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./CategorieModal.vue */ 1108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("6e918f86", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d0189532\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CategorieModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-d0189532\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CategorieModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1554 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-db7bdbc6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/buttons/toogle/Toogle.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-db7bdbc6","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Toogle.vue */ 1109);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("505be02e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-db7bdbc6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Toogle.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-db7bdbc6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Toogle.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1555 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-dd048d2a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/treeGrid/TreeGrid.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-dd048d2a","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TreeGrid.vue */ 1110);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("2f93b343", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-dd048d2a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeGrid.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-dd048d2a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TreeGrid.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1556 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-ddae9a96","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/registration/attributesSet/NewAtributeModal.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-ddae9a96","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./NewAtributeModal.vue */ 1111);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("7f39a18c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ddae9a96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NewAtributeModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ddae9a96\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NewAtributeModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1557 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-e804536c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/registration/bankAccounts/BelvoWidget.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-e804536c","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./BelvoWidget.vue */ 1112);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("7c3341ec", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-e804536c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BelvoWidget.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-e804536c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BelvoWidget.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1558 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-ea2dd414","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/modals/betterModal/BetterModal.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-ea2dd414","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./BetterModal.vue */ 1113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("6783a55e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ea2dd414\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BetterModal.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ea2dd414\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BetterModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1559 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-eb2dd9ec","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/unauthorized/Unauthorized.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-eb2dd9ec","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Unauthorized.vue */ 1114);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("1b408ada", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-eb2dd9ec\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Unauthorized.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-eb2dd9ec\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Unauthorized.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1560 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-eb88efa0","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/index/Index.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-eb88efa0","scoped":false,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Index.vue */ 1115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("51e9a910", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-eb88efa0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Index.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-eb88efa0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1561 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-ec141a1a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/reports/manualConciliation/modals/ApplyModal.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-ec141a1a","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./ApplyModal.vue */ 1116);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("4c0ff226", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ec141a1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApplyModal.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-ec141a1a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ApplyModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1562 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-f46bd904","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/filter/FiltersCommon.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader?sourceMap!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-f46bd904","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./FiltersCommon.vue */ 1117);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("9ad8c3a6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f46bd904\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FiltersCommon.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?sourceMap!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f46bd904\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FiltersCommon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1563 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-f99f3a28","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/reports/financialMovement/FinancialMovement.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader?sourceMap!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-f99f3a28","scoped":false,"hasInlineConfig":false}!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./FinancialMovement.vue */ 1118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("424b3b0a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f99f3a28\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FinancialMovement.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?sourceMap!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-f99f3a28\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FinancialMovement.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1564 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-fd19de7a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/loading/LoadingFullPage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader?sourceMap!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-fd19de7a","scoped":false,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./LoadingFullPage.vue */ 1119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-loader/~/vue-style-loader/lib/addStylesClient.js */ 8)("a5b3ae36", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fd19de7a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoadingFullPage.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-fd19de7a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoadingFullPage.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1565 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-loader/~/vue-style-loader/lib/listToStyles.js ***!
  \*************************************************************/
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 1566 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-pagination-2/compiled/Pagination.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _template = __webpack_require__(/*! ./template */ 1570);

var _template2 = _interopRequireDefault(_template);

var _RenderlessPagination = __webpack_require__(/*! ./RenderlessPagination */ 1567);

var _RenderlessPagination2 = _interopRequireDefault(_RenderlessPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Pagination',
    components: { RenderlessPagination: _RenderlessPagination2.default },
    provide: function provide() {
        var _this = this;

        return {
            Page: function Page() {
                return _this.value;
            },
            perPage: function perPage() {
                return _this.perPage;
            },
            records: function records() {
                return _this.records;
            }
        };
    },
    render: function render(h) {
        return h('renderless-pagination', { scopedSlots: {
                default: function _default(props) {
                    return props.override ? h(props.override, {
                        attrs: { props: props }
                    }) : (0, _template2.default)(props)(h);
                }
            }
        });
    },

    props: {
        value: {
            type: Number,
            required: true,
            validator: function validator(val) {
                return val > 0;
            }
        },
        records: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            default: 25
        },
        options: {
            type: Object
        }
    },
    data: function data() {
        return {
            aProps: {
                role: "button"
            }
        };
    }
};
module.exports = exports['default'];

/***/ }),
/* 1567 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-pagination-2/compiled/RenderlessPagination.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _config = __webpack_require__(/*! ./config */ 1568);

var _config2 = _interopRequireDefault(_config);

var _merge = __webpack_require__(/*! merge */ 57);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    inject: ['Page', 'records', 'perPage'],
    props: {
        itemClass: {
            required: false,
            default: 'VuePagination__pagination-item'
        }
    },
    render: function render() {
        var _this = this;

        return this.$scopedSlots.default({
            override: this.opts.template,
            showPagination: this.totalPages > 1,
            pages: this.pages,
            pageEvents: function pageEvents(page) {
                return {
                    click: function click() {
                        return _this.setPage(page);
                    },
                    keydown: function keydown(e) {
                        if (e.key === 'ArrowRight') {
                            _this.next();
                        }

                        if (e.key === 'ArrowLeft') {
                            _this.prev();
                        }
                    }
                };
            },
            activeClass: this.activeClass,
            hasEdgeNav: this.opts.edgeNavigation && this.totalChunks > 1,
            setPage: this.setPage,
            setFirstPage: this.setPage.bind(this, 1),
            setLastPage: this.setPage.bind(this, this.totalPages),
            hasChunksNav: this.opts.chunksNavigation === 'fixed',
            setPrevChunk: this.prevChunk,
            setNextChunk: this.nextChunk,
            setPrevPage: this.prev,
            firstPageProps: {
                class: this.Theme.link,
                disabled: this.page === 1
            },
            lastPageProps: {
                class: this.Theme.link,
                disabled: this.page === this.totalPages
            },
            prevProps: {
                class: this.Theme.link,
                disabled: !!this.allowedPageClass(this.page - 1)
            },
            nextProps: {
                class: this.Theme.link,
                disabled: !!this.allowedPageClass(this.page + 1)
            },
            pageClasses: function pageClasses(page) {
                return _this.itemClass + ' ' + _this.Theme.item + ' ' + _this.activeClass(page);
            },
            prevChunkProps: {
                class: this.Theme.link,
                disabled: !this.allowedChunk(-1)
            },
            nextChunkProps: {
                class: this.Theme.link,
                disabled: !this.allowedChunk(1)
            },
            setNextPage: this.next,
            theme: {
                nav: this.Theme.nav,
                list: 'VuePagination__pagination ' + this.Theme.list,
                item: this.Theme.item,
                disabled: this.Theme.disabled,
                prev: this.itemClass + ' ' + this.itemClass + '-prev-page ' + this.Theme.item + ' ' + this.Theme.prev + ' ' + this.allowedPageClass(this.page - 1),
                next: this.itemClass + '  ' + this.itemClass + '-next-page ' + this.Theme.item + ' ' + this.Theme.next + ' ' + this.allowedPageClass(this.page + 1),
                prevChunk: this.itemClass + ' ' + this.Theme.item + ' ' + this.Theme.prev + ' ' + this.itemClass + '-prev-chunk ' + this.allowedChunkClass(-1),
                nextChunk: this.itemClass + ' ' + this.Theme.item + ' ' + this.Theme.next + ' ' + this.itemClass + '-next-chunk ' + this.allowedChunkClass(1),
                firstPage: this.itemClass + ' ' + this.Theme.item + ' ' + (this.page === 1 ? this.Theme.disabled : '') + ' ' + this.itemClass + '-first-page',
                lastPage: this.itemClass + ' ' + this.Theme.item + ' ' + (this.page === this.totalPages ? this.Theme.disabled : '') + ' ' + this.itemClass + '-last-page',
                link: this.Theme.link,
                page: this.itemClass + ' ' + this.Theme.item,
                wrapper: this.Theme.wrapper,
                count: 'VuePagination__count ' + this.Theme.count
            },
            hasRecords: this.hasRecords,
            count: this.count,
            texts: this.opts.texts,
            opts: this.opts,
            allowedChunkClass: this.allowedChunkClass,
            allowedPageClass: this.allowedPageClass,
            setChunk: this.setChunk,
            prev: this.prev,
            next: this.next,
            totalPages: this.totalPages,
            totalChunks: this.totalChunks,
            page: this.Page(),
            records: this.records(),
            perPage: this.perPage(),
            formatNumber: this.formatNumber
        });
    },

    data: function data() {
        return {
            firstPage: this.$parent.value,
            For: this.$parent.for,
            Options: this.$parent.options
        };
    },
    watch: {
        page: function page(val) {
            if (this.opts.chunksNavigation === 'scroll' && this.allowedPage(val) && !this.inDisplay(val)) {
                if (val === this.totalPages) {
                    var first = val - this.opts.chunk + 1;
                    this.firstPage = first >= 1 ? first : 1;
                } else {
                    this.firstPage = val;
                }
            }

            this.$parent.$emit('paginate', val);
        }
    },
    computed: {
        Records: function Records() {
            return this.records();
        },
        PerPage: function PerPage() {
            return this.perPage();
        },
        opts: function opts() {
            return _merge2.default.recursive((0, _config2.default)(), this.Options);
        },
        Theme: function Theme() {

            if (_typeof(this.opts.theme) === 'object') {
                return this.opts.theme;
            }

            var themes = {
                bootstrap3: __webpack_require__(/*! ./themes/bootstrap3 */ 1571),
                bootstrap4: __webpack_require__(/*! ./themes/bootstrap4 */ 1572),
                bulma: __webpack_require__(/*! ./themes/bulma */ 1573)
            };

            if (_typeof(themes[this.opts.theme]) === undefined) {
                throw 'vue-pagination-2: the theme ' + this.opts.theme + ' does not exist';
            }

            return themes[this.opts.theme];
        },
        page: function page() {
            return this.Page();
        },

        pages: function pages() {

            if (!this.Records) return [];

            return range(this.paginationStart, this.pagesInCurrentChunk);
        },
        totalPages: function totalPages() {
            return this.Records ? Math.ceil(this.Records / this.PerPage) : 1;
        },
        totalChunks: function totalChunks() {
            return Math.ceil(this.totalPages / this.opts.chunk);
        },
        currentChunk: function currentChunk() {
            return Math.ceil(this.page / this.opts.chunk);
        },
        paginationStart: function paginationStart() {
            if (this.opts.chunksNavigation === 'scroll') {
                return this.firstPage;
            }

            return (this.currentChunk - 1) * this.opts.chunk + 1;
        },
        pagesInCurrentChunk: function pagesInCurrentChunk() {
            return this.paginationStart + this.opts.chunk <= this.totalPages ? this.opts.chunk : this.totalPages - this.paginationStart + 1;
        },
        hasRecords: function hasRecords() {
            return parseInt(this.Records) > 0;
        },

        count: function count() {

            if (/{page}/.test(this.opts.texts.count)) {

                if (this.totalPages <= 1) return '';

                return this.opts.texts.count.replace('{page}', this.page).replace('{pages}', this.totalPages);
            }

            var parts = this.opts.texts.count.split('|');
            var from = (this.page - 1) * this.PerPage + 1;
            var to = this.page == this.totalPages ? this.Records : from + this.PerPage - 1;
            var i = Math.min(this.Records == 1 ? 2 : this.totalPages == 1 ? 1 : 0, parts.length - 1);

            return parts[i].replace('{count}', this.formatNumber(this.Records)).replace('{from}', this.formatNumber(from)).replace('{to}', this.formatNumber(to));
        }
    },
    methods: {
        setPage: function setPage(page) {
            if (this.allowedPage(page)) {
                this.paginate(page);
            }
        },
        paginate: function paginate(page) {
            var _this2 = this;

            this.$parent.$emit('input', page);

            this.$nextTick(function () {
                if (_this2.$el) {
                    var el = _this2.$el.querySelector('li.' + _this2.Theme.active + ' a');
                    if (el) {
                        el.focus();
                    }
                }
            });
        },

        next: function next() {
            return this.setPage(this.page + 1);
        },
        prev: function prev() {
            return this.setPage(this.page - 1);
        },
        inDisplay: function inDisplay(page) {

            var start = this.firstPage;
            var end = start + this.opts.chunk - 1;

            return page >= start && page <= end;
        },

        nextChunk: function nextChunk() {
            return this.setChunk(1);
        },
        prevChunk: function prevChunk() {
            return this.setChunk(-1);
        },
        setChunk: function setChunk(direction) {
            this.setPage((this.currentChunk - 1 + direction) * this.opts.chunk + 1);
        },
        allowedPage: function allowedPage(page) {
            return page >= 1 && page <= this.totalPages;
        },
        allowedChunk: function allowedChunk(direction) {
            return direction == 1 && this.currentChunk < this.totalChunks || direction == -1 && this.currentChunk > 1;
        },
        allowedPageClass: function allowedPageClass(direction) {
            return this.allowedPage(direction) ? '' : this.Theme.disabled;
        },
        allowedChunkClass: function allowedChunkClass(direction) {
            return this.allowedChunk(direction) ? '' : this.Theme.disabled;
        },
        activeClass: function activeClass(page) {
            return this.page == page ? this.Theme.active : '';
        },
        formatNumber: function formatNumber(num) {

            if (!this.opts.format) return num;

            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
};


function range(start, count) {
    return Array.apply(0, Array(count)).map(function (element, index) {
        return index + start;
    });
}
module.exports = exports['default'];

/***/ }),
/* 1568 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/vue-pagination-2/compiled/config.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        format: true,
        chunk: 10,
        chunksNavigation: 'fixed',
        edgeNavigation: false,
        theme: 'bootstrap3',
        template: null,
        texts: {
            count: 'Showing {from} to {to} of {count} records|{count} records|One record',
            first: 'First',
            last: 'Last',
            nextPage: '>',
            nextChunk: '>>',
            prevPage: '<',
            prevChunk: '<<'
        }
    };
};

module.exports = exports['default'];

/***/ }),
/* 1569 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/vue-pagination-2/compiled/main.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = __webpack_require__(/*! ./Pagination */ 1566);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pagination2.default;
module.exports = exports['default'];

/***/ }),
/* 1570 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/vue-pagination-2/compiled/template.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (props) {

    return function (h) {

        var theme = this.theme;
        var prevChunk = '';
        var nextChunk = '';
        var firstPage = '';
        var lastPage = '';
        var items = this.pages.map(function (page) {

            return h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + this.activeClass(page),
                    on: {
                        'click': this.setPage.bind(this, page)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link + ' ' + this.activeClass(page),
                        attrs: { role: 'button' }
                    },
                    [this.formatNumber(page)]
                )]
            );
        }.bind(this));

        if (this.opts.edgeNavigation && this.totalChunks > 1) {
            firstPage = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + (this.page === 1 ? theme.disabled : '') + ' VuePagination__pagination-item-first-page',
                    on: {
                        'click': this.setPage.bind(this, 1)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: this.page === 1 }
                    },
                    [this.opts.texts.first]
                )]
            );

            lastPage = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + (this.page === this.totalPages ? theme.disabled : '') + ' VuePagination__pagination-item-last-page',
                    on: {
                        'click': this.setPage.bind(this, this.totalPages)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: this.page === this.totalPages }
                    },
                    [this.opts.texts.last]
                )]
            );
        }

        if (this.opts.chunksNavigation === 'fixed') {

            prevChunk = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.prev + ' VuePagination__pagination-item-prev-chunk ' + this.allowedChunkClass(-1),
                    on: {
                        'click': this.setChunk.bind(this, -1)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: !!this.allowedChunkClass(-1) }
                    },
                    [this.opts.texts.prevChunk]
                )]
            );

            nextChunk = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.next + ' VuePagination__pagination-item-next-chunk ' + this.allowedChunkClass(1),
                    on: {
                        'click': this.setChunk.bind(this, 1)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: !!this.allowedChunkClass(1) }
                    },
                    [this.opts.texts.nextChunk]
                )]
            );
        }

        return h(
            'div',
            { 'class': 'VuePagination ' + theme.wrapper },
            [h(
                'nav',
                { 'class': '' + theme.nav },
                [h(
                    'ul',
                    {
                        directives: [{
                            name: 'show',
                            value: this.totalPages > 1
                        }],

                        'class': theme.list + ' VuePagination__pagination' },
                    [firstPage, prevChunk, h(
                        'li',
                        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.prev + ' VuePagination__pagination-item-prev-page ' + this.allowedPageClass(this.page - 1),
                            on: {
                                'click': this.prev.bind(this)
                            }
                        },
                        [h(
                            'a',
                            { 'class': theme.link,
                                attrs: { disabled: !!this.allowedPageClass(this.page - 1)
                                }
                            },
                            [this.opts.texts.prevPage]
                        )]
                    ), items, h(
                        'li',
                        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.next + ' VuePagination__pagination-item-next-page ' + this.allowedPageClass(this.page + 1),
                            on: {
                                'click': this.next.bind(this)
                            }
                        },
                        [h(
                            'a',
                            { 'class': theme.link,
                                attrs: { disabled: !!this.allowedPageClass(this.page + 1)
                                }
                            },
                            [this.opts.texts.nextPage]
                        )]
                    ), nextChunk, lastPage]
                ), h(
                    'p',
                    {
                        directives: [{
                            name: 'show',
                            value: parseInt(this.records)
                        }],

                        'class': 'VuePagination__count ' + theme.count },
                    [this.count]
                )]
            )]
        );
    }.bind(props);
};

/***/ }),
/* 1571 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-pagination-2/compiled/themes/bootstrap3.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active',
    disabled: 'disabled'
};

/***/ }),
/* 1572 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-pagination-2/compiled/themes/bootstrap4.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active',
    disabled: 'disabled'
};

/***/ }),
/* 1573 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-pagination-2/compiled/themes/bulma.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    nav: '',
    count: '',
    wrapper: 'pagination',
    list: 'pagination-list',
    item: '',
    link: 'pagination-link',
    next: '',
    prev: '',
    active: 'is-current',
    disabled: '' // uses the disabled HTML attirbute
};

/***/ }),
/* 1574 */
/* exports provided: default */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/vue-recaptcha/dist/vue-recaptcha.es.js ***!
  \**************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var VueRecaptcha = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": false
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  beforeMount: function beforeMount() {
    if (this.loadRecaptchaScript) {
      if (!document.getElementById(this.recaptchaScriptId)) {
        // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
        var script = document.createElement('script');
        script.id = this.recaptchaScriptId;
        script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();

    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    });

    var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;

      _this.$emit('render', id);
    });
  },
  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    },
    emitError: function emitError() {
      this.$emit('error');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots["default"]);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (VueRecaptcha);


/***/ }),
/* 1575 */
/* exports provided: default */
/* all exports used */
/*!*********************************************!*\
  !*** ./~/vue-router/dist/vue-router.esm.js ***!
  \*********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if ("production-oci" !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production-oci" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (true) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("production-oci" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (true) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production-oci" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production-oci" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["default"] = (VueRouter);


/***/ }),
/* 1576 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-01f4a2a2","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/views/integration/fileUpload/FileUpload.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../../~/css-loader!../../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-01f4a2a2","scoped":false,"hasInlineConfig":false}!../../../../../~/sass-loader/lib/loader.js!../../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./FileUpload.vue */ 1020);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../../~/vue-style-loader/lib/addStylesClient.js */ 118)("43f35146", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-01f4a2a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileUpload.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-01f4a2a2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FileUpload.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1577 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-1b8ade6c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/menu/SidebarMenu.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-1b8ade6c","scoped":false,"hasInlineConfig":false}!../../../../~/sass-loader/lib/loader.js!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./SidebarMenu.vue */ 1021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-style-loader/lib/addStylesClient.js */ 118)("2320cf48", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1b8ade6c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarMenu.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-1b8ade6c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SidebarMenu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1578 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-40c8036e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/chart/Chart.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-40c8036e","scoped":false,"hasInlineConfig":false}!../../../../~/sass-loader/lib/loader.js!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Chart.vue */ 1022);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-style-loader/lib/addStylesClient.js */ 118)("9735d874", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-40c8036e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Chart.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-40c8036e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Chart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1579 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-54cd97fd","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/layout/menu/TopBar.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-54cd97fd","scoped":false,"hasInlineConfig":false}!../../../../~/sass-loader/lib/loader.js!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TopBar.vue */ 1023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-style-loader/lib/addStylesClient.js */ 118)("316dba46", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-54cd97fd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TopBar.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-54cd97fd\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TopBar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1580 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-632aab56","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/Dashboard.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-632aab56","scoped":false,"hasInlineConfig":false}!../../../~/sass-loader/lib/loader.js!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue */ 1024);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-style-loader/lib/addStylesClient.js */ 118)("d4c20028", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-632aab56\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-632aab56\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1581 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-7b55184e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/dashboard/gadget/TaskGadgetTabContent.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../~/css-loader!../../../../~/vue-loader/lib/style-compiler?{"id":"data-v-7b55184e","scoped":false,"hasInlineConfig":false}!../../../../~/sass-loader/lib/loader.js!../../../../~/vue-loader/lib/selector.js?type=styles&index=0!./TaskGadgetTabContent.vue */ 1025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../~/vue-style-loader/lib/addStylesClient.js */ 118)("596c160e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7b55184e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TaskGadgetTabContent.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-7b55184e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TaskGadgetTabContent.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1582 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/vue-style-loader!./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-c5e6e690","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/step/StepProgress.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../~/css-loader!../../../~/vue-loader/lib/style-compiler?{"id":"data-v-c5e6e690","scoped":true,"hasInlineConfig":false}!../../../~/sass-loader/lib/loader.js?indentedSyntax!../../../~/vue-loader/lib/selector.js?type=styles&index=0!./StepProgress.vue */ 1026);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../~/vue-style-loader/lib/addStylesClient.js */ 118)("05e89521", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c5e6e690\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?indentedSyntax!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StepProgress.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-c5e6e690\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?indentedSyntax!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./StepProgress.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1583 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/vue-style-loader/lib/listToStyles.js ***!
  \************************************************/
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 1584 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtChildRow.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLChildRow = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLChildRow */ 1602));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtChildRow',
  props: ['row', 'index'],
  components: {
    RLChildRow: _RLChildRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-child-row", {
      attrs: {
        row: this.row,
        index: this.index
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": 'VueTables__child-row ' + props["class"]
          }, [h("td", {
            attrs: {
              colspan: props.colspan
            }
          }, [props.childRow])]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1585 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtChildRowToggler.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLChildRowToggler = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLChildRowToggler */ 1603));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtChildRowToggler',
  props: ['rowId'],
  components: {
    RLChildRowToggler: _RLChildRowToggler["default"]
  },
  render: function render(h) {
    return h("r-l-child-row-toggler", {
      attrs: {
        "row-id": this.rowId
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("td", {
            attrs: {
              tabindex: props.tabIndex
            },
            on: {
              "keypress": function keypress(e) {
                if (e.key === 'Enter') {
                  props.toggle();
                }
              },
              "click": props.toggle
            }
          }, [props.toggleable ? h("span", {
            "class": "VueTables__child-row-toggler " + props["class"]()
          }) : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1586 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtClientTable.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _VtPerPageSelector = _interopRequireDefault(__webpack_require__(/*! ./VtPerPageSelector */ 699));

var _VtTable = _interopRequireDefault(__webpack_require__(/*! ./VtTable */ 700));

var _VtPagination = _interopRequireDefault(__webpack_require__(/*! ./VtPagination */ 698));

var _VtDropdownPagination = _interopRequireDefault(__webpack_require__(/*! ./VtDropdownPagination */ 696));

var _VtGenericFilter = _interopRequireDefault(__webpack_require__(/*! ./VtGenericFilter */ 697));

var _VtColumnsDropdown = _interopRequireDefault(__webpack_require__(/*! ./VtColumnsDropdown */ 695));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtClientTable',
  components: {
    VtPerPageSelector: _VtPerPageSelector["default"],
    VtTable: _VtTable["default"],
    VtPagination: _VtPagination["default"],
    VtDropdownPagination: _VtDropdownPagination["default"],
    VtColumnsDropdown: _VtColumnsDropdown["default"],
    VtGenericFilter: _VtGenericFilter["default"]
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    options: {
      type: Object,
      required: false,
      "default": function _default() {
        return {};
      }
    }
  },
  methods: {
    setLoadingState: function setLoadingState(isLoading) {
      this.$refs.table.loading = isLoading;
    },
    setFilter: function setFilter(val) {
      this.$refs.table.setFilter(val);
    },
    setPage: function setPage(val) {
      this.$refs.table.setPage(val);
    },
    setOrder: function setOrder(column, asc) {
      this.$refs.table.setOrder(column, asc);
    },
    setLimit: function setLimit(limit) {
      this.$refs.table.setLimit(limit);
    },
    toggleChildRow: function toggleChildRow(rowId) {
      this.$refs.table.toggleChildRow(rowId);
    },
    getOpenChildRows: function getOpenChildRows() {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.$refs.table.getOpenChildRows(rows);
    },
    resetQuery: function resetQuery() {
      this.$refs.table.resetQuery();
    },
    setCustomFilters: function setCustomFilters(params) {
      var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.$refs.table.setCustomFilters(params, sendRequest);
    }
  },
  computed: {
    filteredData: function filteredData() {
      return this.$refs.table.filteredData;
    },
    allFilteredData: function allFilteredData() {
      return this.$refs.table.allFilteredData;
    },
    filtersCount: function filtersCount() {
      return this.$refs.table.filtersCount;
    }
  },
  provide: function provide() {
    var _this = this;

    return {
      scopedSlots: function scopedSlots() {
        return _this.$scopedSlots;
      },
      slots: function slots() {
        return _this.$slots;
      }
    };
  },
  model: {
    prop: "data"
  },
  render: function render(h) {
    return h("r-l-client-table", {
      attrs: {
        data: this.data,
        columns: this.columns,
        name: this.name,
        options: this.options
      },
      ref: "table",
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables VueTables--" + props.source
          }, [h("div", {
            "class": props.theme.row
          }, [h("div", {
            "class": props.theme.column
          }, [!props.opts.filterByColumn && props.opts.filterable ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.left, " VueTables__search")
          }, [props.slots.beforeFilter, h("vt-generic-filter", {
            ref: "genericFilter"
          }), props.slots.afterFilter]) : '', props.slots.afterFilterWrapper, props.perPageValues.length > 1 || props.opts.alwaysShowPerPageSelect ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__limit")
          }, [props.slots.beforeLimit, h("vt-per-page-selector"), props.slots.afterLimit]) : '', props.opts.pagination.dropdown && props.totalPages > 1 ? h("div", {
            "class": "VueTables__pagination-wrapper"
          }, [h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__dropdown-pagination")
          }, [h("vt-dropdown-pagination")])]) : '', props.opts.columnsDropdown ? h("div", {
            "class": "VueTables__columns-dropdown-wrapper ".concat(props.theme.right, " ").concat(props.theme.dropdown.container)
          }, [h("vt-columns-dropdown")]) : ''])]), props.slots.beforeTable, h("div", {
            "class": "table-responsive"
          }, [h("vt-table", {
            ref: "vt_table"
          })]), props.slots.afterTable, props.opts.pagination.show ? h("vt-pagination") : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1587 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtDateFilter.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLDateFilter = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLDateFilter */ 1605));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtDateFilter',
  props: ['column'],
  components: {
    RLDateFilter: _RLDateFilter["default"]
  },
  render: function render(h) {
    var _this = this;

    return h("r-l-date-filter", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__date-filter",
            attrs: {
              id: 'VueTables__' + _this.column + '-filter'
            }
          }, [h("span", {
            "class": "VueTables__filter-placeholder"
          }, [props.placeholder])]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1588 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtFiltersRow.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLFiltersRow = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLFiltersRow */ 1607));

var _VtTextFilter = _interopRequireDefault(__webpack_require__(/*! ./VtTextFilter */ 1600));

var _VtListFilter = _interopRequireDefault(__webpack_require__(/*! ./VtListFilter */ 1591));

var _VtDateFilter = _interopRequireDefault(__webpack_require__(/*! ./VtDateFilter */ 1587));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default2 = {
  name: 'VtFiltersRow',
  components: {
    RLFiltersRow: _RLFiltersRow["default"],
    VtTextFilter: _VtTextFilter["default"],
    VtListFilter: _VtListFilter["default"],
    VtDateFilter: _VtDateFilter["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-filters-row", {
      scopedSlots: {
        "default": function _default(props) {
          var filters = [];
          if (props.hasChildRow && props.opts.childRowTogglerFirst && props.opts.showChildRowToggler) filters.push(h("th"));
          props.columns.map(function (column) {
            var filter = '';

            if (props.filterable(column)) {
              filter = h(props.filterType(column), {
                props: {
                  column: column
                }
              });
            }

            if (typeof props.slots["filter__".concat(column)] !== 'undefined') {
              filter = filter ? h("div", [filter, props.slots["filter__".concat(column)]]) : props.slots["filter__".concat(column)];
            }

            filters.push(h("th", {
              "class": props.columnClass(column)
            }, [!!filter ? h("div", _defineProperty({
              "class": "VueTables__column-filter"
            }, "class", 'VueTables__' + column + '-filter-wrapper'), [filter]) : '']));
          });
          if (props.hasChildRow && !props.opts.childRowTogglerFirst && props.opts.showChildRowToggler) filters.push(h("th"));
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": "VueTables__filters-row"
          }, [filters]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1589 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtGroupRow.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLGroupRow = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLGroupRow */ 1609));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtGroupRow',
  components: {
    RLGroupRow: _RLGroupRow["default"]
  },
  props: ['row'],
  render: function render() {
    var h = arguments[0];
    return h("r-l-group-row", {
      attrs: {
        row: this.row
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": props.theme.groupTr,
            on: {
              "click": props.toggleGroupDirection
            }
          }, [h("td", {
            attrs: {
              colspan: props.colspan
            }
          }, [props.canToggleGroup ? h("button", {
            "class": props.theme.button,
            on: {
              "click": props.toggleGroup.bind(this, props.groupValue)
            }
          }, [props.groupValue, h("span", {
            "class": props.groupToggleIcon(props.groupValue)
          })]) : '', !props.canToggleGroup ? h("span", [props.groupValue]) : '', props.slot])]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1590 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtHeadingsRow.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLHeadingsRow = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLHeadingsRow */ 1610));

var _VtTableHeading = _interopRequireDefault(__webpack_require__(/*! ./VtTableHeading */ 1598));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtHeadingsRow',
  components: {
    RLHeadingsRow: _RLHeadingsRow["default"],
    VtTableHeading: _VtTableHeading["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-headings-row", {
      scopedSlots: {
        "default": function _default(props) {
          if (props.override) {
            return h(props.override, {
              attrs: {
                props: props
              }
            });
          }

          var headings = [];

          if (props.childRowTogglerFirst) {
            headings.push(h("th"));
          }

          props.columns.map(function (column) {
            headings.push(h("vt-table-heading", {
              attrs: {
                column: column
              }
            }));
          });

          if (props.childRowTogglerLast) {
            headings.push(h("th"));
          }

          return h("tr", [headings]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1591 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtListFilter.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLListFilter = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLListFilter */ 1611));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtListFilter',
  props: ['column'],
  components: {
    RLListFilter: _RLListFilter["default"]
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("r-l-list-filter", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          var options = [];
          var selected;
          props.items.map(function (option) {
            selected = String(option.id) === String(props.query[_this.column]) && props.query[_this.column] !== '';
            options.push(h("option", {
              domProps: {
                "value": option.id,
                "selected": selected
              }
            }, [option.text]));
          });
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__list-filter",
            attrs: {
              id: 'VueTables__' + _this.column + '-filter'
            }
          }, [h("select", {
            "class": props.theme.select,
            on: {
              "change": props.search(false)
            },
            attrs: {
              name: props.name
            },
            domProps: {
              "value": props.value
            }
          }, [h("option", {
            attrs: {
              value: ""
            }
          }, [props.defaultOption]), options])]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1592 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtNoResultsRow.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLNoResultsRow = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLNoResultsRow */ 1612));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtNoResultsRow',
  components: {
    RLNoResultsRow: _RLNoResultsRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-no-results-row", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": "VueTables__no-results"
          }, [h("td", {
            "class": "text-center",
            attrs: {
              tabindex: props.tabIndex,
              colspan: props.colspan
            }
          }, [props.display(props.message)])]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1593 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtServerTable.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _VtPerPageSelector = _interopRequireDefault(__webpack_require__(/*! ./VtPerPageSelector */ 699));

var _VtTable = _interopRequireDefault(__webpack_require__(/*! ./VtTable */ 700));

var _VtPagination = _interopRequireDefault(__webpack_require__(/*! ./VtPagination */ 698));

var _VtDropdownPagination = _interopRequireDefault(__webpack_require__(/*! ./VtDropdownPagination */ 696));

var _VtGenericFilter = _interopRequireDefault(__webpack_require__(/*! ./VtGenericFilter */ 697));

var _VtColumnsDropdown = _interopRequireDefault(__webpack_require__(/*! ./VtColumnsDropdown */ 695));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtServerTable',
  components: {
    VtPerPageSelector: _VtPerPageSelector["default"],
    VtTable: _VtTable["default"],
    VtPagination: _VtPagination["default"],
    VtDropdownPagination: _VtDropdownPagination["default"],
    VtColumnsDropdown: _VtColumnsDropdown["default"],
    VtGenericFilter: _VtGenericFilter["default"]
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    options: {
      type: Object,
      required: false,
      "default": function _default() {
        return {};
      }
    }
  },
  computed: {
    customQueries: {
      get: function get() {
        return this.$refs.table.customQueries;
      },
      set: function set(val) {
        this.$refs.table.customQueries = val;
      }
    },
    data: function data() {
      return this.$refs.table.tableData;
    },
    filtersCount: function filtersCount() {
      return this.$refs.table.filtersCount;
    }
  },
  methods: {
    refresh: function refresh() {
      this.$refs.table.refresh();
    },
    getData: function getData() {
      return this.$refs.table.getData();
    },
    setFilter: function setFilter(val) {
      this.$refs.table.setFilter(val);
    },
    setPage: function setPage(val) {
      this.$refs.table.setPage(val);
    },
    setOrder: function setOrder(column, asc) {
      this.$refs.table.setOrder(column, asc);
    },
    setLimit: function setLimit(limit) {
      this.$refs.table.setLimit(limit);
    },
    toggleChildRow: function toggleChildRow(rowId) {
      this.$refs.table.toggleChildRow(rowId);
    },
    getOpenChildRows: function getOpenChildRows() {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.$refs.table.getOpenChildRows(rows);
    },
    getResponseData: function getResponseData(response) {
      return this.$refs.table.getResponseData(response);
    },
    resetQuery: function resetQuery() {
      this.$refs.table.resetQuery();
    },
    getRequestParams: function getRequestParams() {
      return this.$refs.table.getRequestParams();
    },
    setRequestParams: function setRequestParams(params) {
      var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.$refs.table.setRequestParams(params, sendRequest);
    },
    setCustomFilters: function setCustomFilters(params) {
      var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.$refs.table.setCustomFilters(params, sendRequest);
    },
    resetCustomFilters: __webpack_require__(/*! ../methods/reset-custom-filters */ 1689)
  },
  provide: function provide() {
    var _this = this;

    return {
      scopedSlots: function scopedSlots() {
        return _this.$scopedSlots;
      },
      slots: function slots() {
        return _this.$slots;
      }
    };
  },
  model: {
    prop: "data"
  },
  render: function render(h) {
    return h("r-l-server-table", {
      attrs: {
        url: this.url,
        columns: this.columns,
        name: this.name,
        options: this.options
      },
      ref: "table",
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables VueTables--" + props.source
          }, [h("div", {
            "class": props.theme.row
          }, [h("div", {
            "class": props.theme.column
          }, [!props.opts.filterByColumn && props.opts.filterable ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.left, " VueTables__search")
          }, [props.slots.beforeFilter, h("vt-generic-filter", {
            ref: "genericFilter"
          }), props.slots.afterFilter]) : '', props.slots.afterFilterWrapper, props.perPageValues.length > 1 || props.opts.alwaysShowPerPageSelect ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__limit")
          }, [props.slots.beforeLimit, h("vt-per-page-selector"), props.slots.afterLimit]) : '', props.opts.pagination.dropdown && props.totalPages > 1 ? h("div", {
            "class": "VueTables__pagination-wrapper"
          }, [h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__dropdown-pagination")
          }, [h("vt-dropdown-pagination")])]) : '', props.opts.columnsDropdown ? h("div", {
            "class": "VueTables__columns-dropdown-wrapper ".concat(props.theme.right, " ").concat(props.theme.dropdown.container)
          }, [h("vt-columns-dropdown")]) : ''])]), props.slots.beforeTable, h("div", {
            "class": "table-responsive"
          }, [h("vt-table", {
            ref: "vt_table"
          })]), props.slots.afterTable, props.opts.pagination.show ? h("vt-pagination") : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1594 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtSortControl.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLSortControl = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLSortControl */ 1615));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtSortControl',
  components: {
    RLSortControl: _RLSortControl["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-sort-control", {
      scopedSlots: {
        "default": function _default(props) {
          return props.sortable ? props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("span", {
            "class": props["class"]
          }) : '';
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1595 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtTableBody.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableBody = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLTableBody */ 1617));

var _VtNoResultsRow = _interopRequireDefault(__webpack_require__(/*! ./VtNoResultsRow */ 1592));

var _VtTableRow = _interopRequireDefault(__webpack_require__(/*! ./VtTableRow */ 1599));

var _VtGroupRow = _interopRequireDefault(__webpack_require__(/*! ./VtGroupRow */ 1589));

var _VtChildRow = _interopRequireDefault(__webpack_require__(/*! ./VtChildRow */ 1584));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableBody',
  components: {
    RLTableBody: _RLTableBody["default"],
    VtNoResultsRow: _VtNoResultsRow["default"],
    VtTableRow: _VtTableRow["default"],
    VtChildRow: _VtChildRow["default"],
    VtGroupRow: _VtGroupRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-body", {
      scopedSlots: {
        "default": function _default(props) {
          var rows = [];
          var currentGroup;
          props.data.forEach(function (row, index) {
            if (props.groupBy && props.source === 'client' && row[props.groupBy] !== currentGroup) {
              rows.push(h("vt-group-row", {
                attrs: {
                  row: row
                }
              }));
              currentGroup = row[props.groupBy];
            }

            if (props.canToggleGroups && props.collapsedGroups.includes(currentGroup)) {
              return;
            }

            rows.push(h("vt-table-row", {
              attrs: {
                row: row,
                index: props.initialIndex + index + 1
              }
            }));

            if (props.hasChildRow && props.openChildRows.includes(row[props.uniqueRowId])) {
              rows.push(h("vt-child-row", {
                attrs: {
                  row: row,
                  index: props.initialIndex + index + 1
                }
              }));
            }
          });
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tbody", [props.slots.prependBody, props.data.length === 0 ? h("vt-no-results-row") : '', rows, props.slots.appendBody]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1596 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtTableCell.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableCell = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLTableCell */ 1618));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableCell',
  props: ['column'],
  components: {
    RLTableCell: _RLTableCell["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-cell", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("td", {
            attrs: {
              tabindex: props.tabIndex
            },
            "class": props.classes
          }, [props.content]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1597 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtTableHead.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableHead = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLTableHead */ 1619));

var _VtHeadingsRow = _interopRequireDefault(__webpack_require__(/*! ./VtHeadingsRow */ 1590));

var _VtFiltersRow = _interopRequireDefault(__webpack_require__(/*! ./VtFiltersRow */ 1588));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableHead',
  components: {
    RLTableHead: _RLTableHead["default"],
    VtHeadingsRow: _VtHeadingsRow["default"],
    VtFiltersRow: _VtFiltersRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-head", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("thead", [props.slots.prependHead, h("vt-headings-row"), props.slots.beforeFilters, props.opts.filterByColumn && props.opts.filterable ? h("vt-filters-row") : '', props.slots.afterFilters]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1598 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtTableHeading.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableHeading = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLTableHeading */ 1620));

var _VtSortControl = _interopRequireDefault(__webpack_require__(/*! ./VtSortControl */ 1594));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableHeading',
  props: ['column'],
  components: {
    RLTableHeading: _RLTableHeading["default"],
    VtSortControl: _VtSortControl["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-heading", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("th", {
            on: {
              "keypress": props.thEvents.keypress,
              "click": props.thEvents.click
            },
            "class": props.thAttrs["class"],
            attrs: {
              title: props.thAttrs.title,
              tabindex: props.thAttrs.tabIndex
            }
          }, [h("span", {
            "class": "VueTables__heading",
            attrs: {
              title: props.title
            }
          }, [props.heading]), h("vt-sort-control")]);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1599 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtTableRow.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__(/*! babel-helper-vue-jsx-merge-props */ 742));

var _RLTableRow = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLTableRow */ 1621));

var _VtTableCell = _interopRequireDefault(__webpack_require__(/*! ./VtTableCell */ 1596));

var _VtChildRowToggler = _interopRequireDefault(__webpack_require__(/*! ./VtChildRowToggler */ 1585));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableRow',
  props: ['row', 'index'],
  components: {
    RLTableRow: _RLTableRow["default"],
    VtTableCell: _VtTableCell["default"],
    VtChildRowToggler: _VtChildRowToggler["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-row", {
      attrs: {
        row: this.row,
        index: this.index
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", (0, _babelHelperVueJsxMergeProps["default"])([{
            "class": "VueTables__row " + props.rowAttrs["class"]
          }, {
            attrs: props.rowAttrs.attrs
          }, {
            on: {
              "click": props.rowEvents.click,
              "dblclick": props.rowEvents.click
            }
          }]), [props.childRowTogglerFirst ? h("vt-child-row-toggler", {
            attrs: {
              "row-id": props.rowId
            }
          }) : '', props.columns.map(function (column) {
            return h("vt-table-cell", {
              attrs: {
                column: column
              }
            });
          }), props.childRowTogglerLast ? h("vt-child-row-toggler", {
            attrs: {
              "row-id": props.rowId
            }
          }) : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1600 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/VtTextFilter.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTextFilter = _interopRequireDefault(__webpack_require__(/*! ./renderless/RLTextFilter */ 1622));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTextFilter',
  props: ['column'],
  components: {
    RLTextFilter: _RLTextFilter["default"]
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("r-l-text-filter", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("input", {
            on: {
              "keyup": props.search(props.debounce)
            },
            "class": props.theme.input,
            attrs: {
              name: props.getColumnName(_this.column),
              type: "text",
              placeholder: props.display('filterBy', {
                column: props.getHeading(_this.column)
              }),
              autocomplete: "off"
            }
          });
        }
      }
    });
  }
};
exports["default"] = _default2;

/***/ }),
/* 1601 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/dropdown-wrapper.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h, classes, columns, display) {
  if (classes.framework === 'bulma') {
    return h("div", {
      "class": classes.menu,
      style: display ? 'display:block' : 'display:none'
    }, [h("div", {
      "class": classes.content
    }, [columns])]);
  }

  if (classes.framework === 'bootstrap4') {
    return h("div", {
      "class": classes.menu,
      style: display ? 'display:block' : 'display:none'
    }, [columns]);
  }

  return h("ul", {
    "class": classes.menu,
    style: display ? 'display:block' : 'display:none'
  }, [columns]);
};

/***/ }),
/* 1602 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLChildRow.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLChildRow',
  props: ['row', 'index'],
  inject: ['colspan', 'scopedSlots', 'getChildRowTemplate', 'opts', 'componentsOverride'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      childRow: this.getChildRowTemplate(h, this.row, this.index, this.scopedSlots()['child_row']),
      colspan: this.colspan(),
      "class": this.opts().rowClassCallback ? this.opts().rowClassCallback(this.row) : '',
      override: this.componentsOverride.childRow
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1603 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLChildRowToggler.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLChildRowToggler',
  props: ['rowId'],
  inject: ['toggleChildRow', 'opts', 'childRowTogglerClass', 'componentsOverride', 'tabIndex', 'row'],
  render: function render(h) {
    var toggleable = this.isToggleable(this.opts().disabledChildRows);
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      "class": this.childRowTogglerClass.bind(this, this.rowId),
      toggle: toggleable ? this.toggleChildRow.bind(this, this.rowId) : function () {},
      override: this.componentsOverride.childRowToggler,
      tabIndex: this.tabIndex(),
      toggleable: toggleable
    });
  },
  methods: {
    isToggleable: function isToggleable(callback) {
      if (!callback) {
        return true;
      }

      return !callback(this.row());
    }
  }
};
exports["default"] = _default;

/***/ }),
/* 1604 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLColumnsDropdown.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLColumnsDropdown',
  inject: ['getHeading', 'display', 'opts', 'theme', 'allColumns', 'onlyColumn', 'toggleColumn', 'toggleColumnsDropdown', 'displayColumnsDropdown', 'origColumns', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      getHeading: this.getHeading,
      display: this.display,
      onlyColumn: this.onlyColumn,
      toggleColumn: this.toggleColumn,
      toggleColumnsDropdown: this.toggleColumnsDropdown,
      displayColumnsDropdown: this.displayColumnsDropdown(),
      origColumns: this.origColumns,
      columns: this.allColumns(),
      override: this.componentsOverride.columnsDropdown
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1605 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLDateFilter.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLDateFilter',
  inject: ['getHeading', 'display', 'componentsOverride', 'opts'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      column: this.column,
      placeholder: this.display('filterBy', {
        column: this.getHeading(this.column)
      }),
      display: this.display,
      override: this.componentsOverride.dateFilter
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1606 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLDropdownPagination.js ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: "RLDropdownPagination",
  inject: ['limit', 'count', 'theme', 'page', 'setPage', 'totalPages', 'componentsOverride', 'id', 'opts'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      name: this.id,
      setPage: this.setPage,
      page: this.page(),
      records: this.count(),
      perPage: parseInt(this.limit()),
      theme: this.theme,
      totalPages: this.totalPages(),
      override: this.componentsOverride.dropdownPagination
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1607 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLFiltersRow.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLFiltersRow',
  inject: ['opts', 'theme', 'allColumns', 'filterable', 'filterType', 'slots', 'columnClass', 'hasChildRow', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      columns: this.allColumns(),
      filterable: this.filterable,
      filterType: this.filterType,
      slots: this.slots(),
      columnClass: this.columnClass,
      hasChildRow: this.hasChildRow(),
      override: this.componentsOverride.filtersRow
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1608 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLGenericFilter.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLGenericFilter',
  inject: ['opts', 'theme', 'source', 'search', 'query', 'display', 'id', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      search: this.search,
      query: this.query(),
      display: this.display,
      id: this.id,
      override: this.componentsOverride.genericFilter
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1609 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLGroupRow.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLGroupRow',
  props: ['row'],
  inject: ['colspan', 'opts', 'theme', 'toggleGroupDirection', 'toggleGroup', 'groupToggleIcon', 'getGroupSlot', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      colspan: this.colspan(),
      toggleGroupDirection: this.toggleGroupDirection,
      canToggleGroup: this.opts().toggleGroups,
      toggleGroup: this.toggleGroup,
      groupValue: this.row[this.opts().groupBy],
      groupToggleIcon: this.groupToggleIcon,
      slot: this.getGroupSlot(this.row[this.opts().groupBy]),
      override: this.componentsOverride.groupRow
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1610 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLHeadingsRow.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLHeadingRow',
  inject: ['opts', 'theme', 'hasChildRow', 'allColumns', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      override: this.componentsOverride.headingsRow,
      opts: this.opts(),
      columns: this.allColumns(),
      hasChildRow: this.hasChildRow,
      childRowTogglerFirst: this.hasChildRow() && this.opts().showChildRowToggler && this.opts().childRowTogglerFirst,
      childRowTogglerLast: this.hasChildRow() && this.opts().showChildRowToggler && !this.opts().childRowTogglerFirst
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1611 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLListFilter.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLListFilter',
  inject: ['search', 'query', 'theme', 'getHeading', 'display', 'getColumnName', 'opts', 'componentsOverride'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      search: this.search,
      query: this.query(),
      getHeading: this.getHeading,
      display: this.display,
      items: this.opts().listColumns[this.column].filter(function (item) {
        return !item.hide;
      }),
      defaultOption: this.display('defaultOption', {
        column: this.opts().headings[this.column] ? this.opts().headings[this.column] : this.column
      }),
      name: this.getColumnName(this.column),
      value: this.query()[this.column],
      column: this.column,
      override: this.componentsOverride.listFilter
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1612 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLNoResultsRow.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLNoResultsRow',
  inject: ['colspan', 'display', 'componentsOverride', 'loading', 'initialRequestSent', 'tabIndex', 'opts'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      colspan: this.colspan(),
      display: this.display,
      tabIndex: this.tabIndex(),
      loading: this.loading(),
      initialRequestSent: this.initialRequestSent(),
      message: this.message,
      override: this.componentsOverride.noResultsRow
    });
  },
  computed: {
    message: function message() {
      if (this.loading()) {
        return 'loading';
      }

      if (!this.opts().sendInitialRequest && !this.initialRequestSent()) {
        return 'noRequest';
      }

      return 'noResults';
    }
  }
};
exports["default"] = _default;

/***/ }),
/* 1613 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLPagination.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  name: "RLPagination",
  inject: ['opts', 'count', 'limit', 'vuex', 'name', 'id', 'theme', 'page', 'setPage', 'totalPages', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      setPage: this.setPage,
      options: this.opts().pagination,
      infiniteScroll: this.opts().infiniteScroll,
      page: this.page(),
      records: this.count(),
      perPage: parseInt(this.limit()),
      name: this.vuex ? this.name : this.id,
      vuex: this.vuex,
      theme: this.theme,
      texts: this.opts().texts,
      totalPages: this.totalPages(),
      optionsObj: {
        theme: (0, _merge["default"])(this.theme.pagination, {
          wrapper: "".concat(this.theme.row, " ").concat(this.theme.column, " ").concat(this.theme.contentCenter),
          count: "".concat(this.theme.center, " ").concat(this.theme.column)
        }),
        chunk: this.opts().pagination.chunk,
        chunksNavigation: this.opts().pagination.nav,
        edgeNavigation: this.opts().pagination.edge,
        texts: {
          count: this.opts().texts.count,
          first: this.opts().texts.first,
          last: this.opts().texts.last
        }
      },
      override: this.componentsOverride.pagination
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1614 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLPerPageSelector.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: "RLPerPageSelector",
  inject: ['opts', 'limit', 'setLimit', 'perPageValues', 'id', 'theme', 'display', 'componentsOverride'],
  render: function render() {
    var _this = this;

    return this.$scopedSlots["default"]({
      opts: this.opts(),
      perPageValues: this.perPageValues(),
      theme: this.theme,
      limit: this.limit(),
      setLimit: this.setLimit,
      id: this.id,
      selectClass: this.theme.select,
      display: this.display,
      selectAttrs: {
        id: "VueTables__limit_".concat(this.id),
        "class": this.theme.select,
        value: this.limit()
      },
      selectEvents: {
        change: function change(e) {
          return _this.setLimit(e);
        }
      },
      override: this.componentsOverride.perPageSelector
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1615 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLSortControl.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLSortControl',
  inject: ['opts', 'column', 'theme', 'sortable', 'hasMultiSort', 'orderBy', 'userMultiSorting', 'sortableChevronClass', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      sortable: this.sortable(this.column()),
      "class": "VueTables__sort-icon ".concat(this.theme.right, " ").concat(this.sortableChevronClass(this.column())),
      sortStatus: this.sortStatus,
      override: this.componentsOverride.sortControl
    });
  },
  computed: {
    OrderBy: function OrderBy() {
      return this.orderBy();
    },
    UserMultiSorting: function UserMultiSorting() {
      return this.userMultiSorting();
    },
    sortStatus: function sortStatus() {
      var _this = this;

      if (this.hasMultiSort && this.OrderBy.column && this.UserMultiSorting[this.OrderBy.column]) {
        var col = this.UserMultiSorting[this.OrderBy.column].filter(function (c) {
          return c.column === _this.column();
        })[0];
        if (col) return {
          sorted: true,
          asc: col.ascending
        };
      }

      if (this.column() === this.OrderBy.column) {
        return {
          sorted: true,
          asc: this.OrderBy.ascending
        };
      }

      return {
        sorted: false,
        asc: false
      };
    }
  },
  methods: {}
};
exports["default"] = _default;

/***/ }),
/* 1616 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLTable.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTable',
  inject: ['opts', 'theme', 'colspan', 'slots', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      tableAttrs: {
        summary: this.opts().summary,
        "class": "VueTables__table ".concat(this.opts().skin ? this.opts().skin : this.theme.table)
      },
      slots: this.slots(),
      colspan: this.colspan(),
      caption: this.opts().caption,
      override: this.componentsOverride.table
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1617 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLTableBody.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableBody',
  inject: ['opts', 'theme', 'source', 'filteredData', 'tableData', 'colspan', 'openChildRows', 'collapsedGroups', 'scopedSlots', 'slots', 'componentsOverride', 'page', 'limit'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      source: this.source,
      canToggleGroups: this.opts().toggleGroups,
      collapsedGroups: this.collapsedGroups(),
      data: this.source === 'client' ? this.filteredData() : this.tableData(),
      colspan: this.colspan(),
      loading: true,
      hasChildRow: this.opts().childRow || this.scopedSlots()['child_row'],
      openChildRows: this.openChildRows(),
      uniqueRowId: this.opts().uniqueKey,
      groupBy: this.opts().groupBy,
      slots: this.slots(),
      override: this.componentsOverride.tableBody,
      initialIndex: (this.page() - 1) * this.limit()
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1618 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLTableCell.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  name: 'RLTableCell',
  inject: ['row', 'scopedSlots', 'theme', 'orderBy', 'opts', 'render', 'index', 'setEditingCell', 'updateValue', 'revertValue', 'editing', 'getValue', 'columnClass', 'cellClasses', 'componentsOverride', 'isListFilter', 'optionText', 'source', 'dateFormat', 'formatDate', 'tabIndex'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      row: this.Row,
      column: this.column,
      content: this.content(h),
      classes: "".concat(this.theme.td, " ").concat(this.columnClass(this.column), " ").concat(this.cellClasses(this.column, this.Row), " ").concat(this.sortedClass(this.column)).trim(),
      tabIndex: this.tabIndex(),
      override: this.componentsOverride.tableCell
    });
  },
  computed: {
    Row: function Row() {
      return this.row();
    },
    options: function options() {
      return this.opts();
    }
  },
  methods: {
    content: function content(h) {
      if (this.options.templates[this.column]) {
        return this.render(this.Row, this.column, this.index(), h);
      }

      if (this.scopedSlots()[this.column]) {
        var data = {
          row: this.Row,
          column: this.column,
          index: this.index()
        };

        if (this.options.editableColumns.includes(this.column)) {
          data = (0, _merge["default"])(data, this.getEditFunctions());
        }

        return this.scopedSlots()[this.column](data);
      }

      return this.formatCellContent(this.getValue(this.Row, this.column), this.column);
    },
    sortedClass: function sortedClass(column) {
      if (!this.options.addSortedClassToCells) return '';
      return this.orderBy().column === column ? "".concat(column, "-sorted-") + (this.orderBy().ascending ? 'asc' : 'desc') : '';
    },
    formatCellContent: function formatCellContent(value, column) {
      if (this.source === 'client' && this.options.dateColumns.includes(column)) {
        return this.formatDate(value, this.dateFormat(column));
      }

      if (this.isListFilter(column)) {
        return this.optionText(value, column);
      }

      return value;
    },
    isEditing: function isEditing() {
      return function () {
        var _this = this;

        return this.editing().find(function (e) {
          return e.id === _this.Row[_this.options.uniqueKey] && e.column === _this.column;
        });
      }.bind(this);
    },
    getEditFunctions: function getEditFunctions() {
      return {
        update: this.updateValue(this.Row, this.column),
        isEditing: this.isEditing(),
        setEditing: this.setEditingCell(this.Row, this.column),
        revertValue: this.revertValue(this.Row, this.column)
      };
    }
  }
};
exports["default"] = _default;

/***/ }),
/* 1619 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLTableHead.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableHead',
  inject: ['opts', 'slots', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      slots: this.slots(),
      override: this.componentsOverride.tableHead
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1620 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLTableHeading.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableHeading',
  props: ['column'],
  provide: function provide() {
    var _this = this;

    return {
      column: function column() {
        return _this.column;
      }
    };
  },
  inject: ['opts', 'theme', 'sortableClass', 'getHeadingTooltip', 'getHeading', 'orderByColumn', 'componentsOverride', 'tabIndex'],
  render: function render(h) {
    var _this2 = this;

    return this.$scopedSlots["default"]({
      opts: this.opts(),
      thAttrs: {
        "class": this.sortableClass(this.column),
        tabIndex: this.tabIndex(),
        title: this.getHeadingTooltip(this.column)
      },
      thEvents: {
        keypress: function keypress(e) {
          if (e.key === "Enter") {
            this.orderByColumn(this.column, e);
          }
        },
        click: function click(e) {
          if (e.target.className !== "resize-handle") {
            _this2.orderByColumn(_this2.column, e);
          }
        }
      },
      spanAttrs: {
        title: this.getHeadingTooltip(this.column)
      },
      heading: this.getHeading(this.column, h),
      override: this.componentsOverride.tableHeading
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1621 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLTableRow.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableRow',
  props: ['row', 'index'],
  inject: ['allColumns', 'opts', 'rowWasClicked', 'hasChildRow', 'componentsOverride'],
  provide: function provide() {
    var _this = this;

    return {
      row: function row() {
        return _this.row;
      },
      index: function index() {
        return _this.index;
      }
    };
  },
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      columns: this.allColumns(),
      hasChildRow: this.hasChildRow(),
      rowId: this.row[this.opts().uniqueKey],
      rowAttrs: {
        "class": this.opts().rowClassCallback ? this.opts().rowClassCallback(this.row) : '',
        attrs: this.opts().rowAttributesCallback ? this.opts().rowAttributesCallback(this.row) : {}
      },
      rowEvents: {
        click: this.rowWasClicked.bind(this, this.row, this.index),
        dblclick: this.rowWasClicked.bind(this, this.row, this.index)
      },
      childRowTogglerFirst: this.hasChildRow() && this.opts().showChildRowToggler && this.opts().childRowTogglerFirst,
      childRowTogglerLast: this.hasChildRow() && this.opts().showChildRowToggler && !this.opts().childRowTogglerFirst,
      override: this.componentsOverride.tableRow
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1622 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/components/renderless/RLTextFilter.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTextFilter',
  inject: ['opts', 'search', 'query', 'theme', 'getHeading', 'display', 'getColumnName', 'componentsOverride'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      column: this.column,
      debounce: this.opts().debounce,
      theme: this.theme,
      search: this.search,
      query: this.query(),
      getHeading: this.getHeading,
      getColumnName: this.getColumnName,
      display: this.display,
      override: this.componentsOverride.textFilter
    });
  }
};
exports["default"] = _default;

/***/ }),
/* 1623 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/all-columns.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  var display = this.columnsDisplay; // default - return all columns

  if (!display && !this.userControlsColumns) {
    return this.Columns.filter(function (col) {
      return _this._shouldShowColumnOnInit(col);
    });
  } // user toggled columns - return user selected columns


  if (this.userControlsColumns) {
    return this.columns.filter(function (column) {
      return _this.userColumnsDisplay.includes(column);
    });
  }

  if (this.opts.ssr) return this.Columns; // developer defined columns display

  return this.Columns.filter(function (column) {
    if (!_this._shouldShowColumnOnInit(column)) {
      return false;
    }

    if (!display[column]) return true;
    var range = display[column];
    var operator = range[2];
    var inRange = (!range[0] || _this.windowWidth >= range[0]) && (!range[1] || _this.windowWidth < range[1]);
    return operator == 'not' ? !inRange : inRange;
  });
};

/***/ }),
/* 1624 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/colspan.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.hasChildRow ? this.allColumns.length + 1 : this.allColumns.length;
};

/***/ }),
/* 1625 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/custom-q.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return JSON.stringify(this.customQueries);
};

/***/ }),
/* 1626 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/datepicker-columns.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var intersect = __webpack_require__(/*! array-intersect */ 304)["default"];

module.exports = function () {
  if (this.opts.filterable === true) {
    return this.opts.dateColumns;
  }

  if (this.opts.filterable === false) {
    return [];
  }

  return intersect(this.opts.filterable, this.opts.dateColumns);
};

/***/ }),
/* 1627 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/filterable-columns.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.opts.filterable && this.opts.filterable.length ? this.opts.filterable : this.Columns;
};

/***/ }),
/* 1628 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/filtered-data.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var clone = __webpack_require__(/*! lodash.clonedeep */ 492);

module.exports = function () {
  this.dispatch('loading');
  var data = clone(this.tableData);
  var column = this.orderBy.column;
  data = this.search(data);

  if (column) {
    // dummy var to force compilation
    if (this.time) this.time = this.time;
    data = this.opts.sortingAlgorithm.call(this, data, column ? column : this.opts.groupBy);
  } else if (this.opts.groupBy) {
    data = this.opts.sortingAlgorithm.call(this, data, this.opts.groupBy);
  }

  if (this.vuex) {
    if (this.count != data.length) this.commit('SET_COUNT', data.length);
  } else {
    this.count = data.length;
  }

  var offset = (this.page - 1) * this.limit;
  this.allFilteredData = JSON.parse(JSON.stringify(data));
  this.dispatch('loaded');
  return data.splice(offset, this.limit);
};

/***/ }),
/* 1629 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/filtered-query.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function () {
  if (_typeof(this.query) !== 'object' || this.opts.sendEmptyFilters) {
    return this.query;
  }

  var result = {};

  for (var key in this.query) {
    if (this.query[key] !== '' && this.filterable(key)) {
      result[key] = this.query[key];
    }
  }

  return result;
};

/***/ }),
/* 1630 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/has-child-row.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return !!(this.opts.childRow || this.$parent.$scopedSlots.child_row);
};

/***/ }),
/* 1631 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/has-generic-filter.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function () {
  return !this.opts.filterByColumn && (typeof this.opts.filterable === 'boolean' && this.opts.filterable || _typeof(this.opts.filterable) === 'object' && this.opts.filterable.length);
};

/***/ }),
/* 1632 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/list-columns-object.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var columns = Object.keys(this.opts.listColumns);
  var res = {};
  columns.forEach(function (column) {
    res[column] = {};
    this.opts.listColumns[column].forEach(function (item) {
      res[column][item.id] = item.text;
    });
  }.bind(this));
  return res;
};

/***/ }),
/* 1633 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/opts.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var defaults = __webpack_require__(/*! ../config/defaults */ 1639)();

  return this.initOptions(defaults, this.globalOptions, this.options);
};

/***/ }),
/* 1634 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/per-page-values.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  var perpageValues = [];
  this.opts.perPageValues.every(function (value) {
    var isLastEntry = value >= _this.count;
    perpageValues.push(value);
    return !isLastEntry;
  });
  return perpageValues;
};

/***/ }),
/* 1635 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/q.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.opts.filterByColumn ? JSON.stringify(this.query) : this.query;
};

/***/ }),
/* 1636 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/storage.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (typeof localStorage === 'undefined') return {};
  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};

/***/ }),
/* 1637 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/table-data.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.data;
};

/***/ }),
/* 1638 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/computed/templates-keys.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return Object.keys(this.opts.templates);
};

/***/ }),
/* 1639 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/vue-tables-2/compiled/config/defaults.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    alwaysShowPerPageSelect: false,
    hidePerPageSelect: false,
    dateColumns: [],
    listColumns: {},
    datepickerOptions: {
      locale: {
        cancelLabel: "Clear"
      }
    },
    datepickerPerColumnOptions: {},
    initialPage: 1,
    perPage: 10,
    perPageValues: [10, 25, 50, 100],
    groupBy: false,
    collapseGroups: false,
    destroyEventBus: false,
    sendEmptyFilters: false,
    params: {},
    sortable: true,
    filterable: true,
    groupMeta: [],
    initFilters: {},
    sendInitialRequest: true,
    customFilters: [],
    templates: {},
    debounce: 250,
    dateFormat: "DD/MM/YYYY",
    dateFormatPerColumn: {},
    toMomentFormat: false,
    skin: false,
    columnsDisplay: {},
    columnsDropdown: false,
    texts: {
      count: "Showing {from} to {to} of {count} records|{count} records|One record",
      first: "First",
      last: "Last",
      filter: "Filter:",
      filterPlaceholder: "Search query",
      limit: "Records:",
      page: "Page:",
      noResults: "No matching records",
      noRequest: "Please select at least one filter to fetch results",
      filterBy: "Filter by {column}",
      loading: "Loading...",
      defaultOption: "Select {column}",
      columns: "Columns"
    },
    sortIcon: {
      is: "glyphicon-sort",
      base: "glyphicon",
      up: "glyphicon-chevron-up",
      down: "glyphicon-chevron-down"
    },
    addSortedClassToCells: false,
    sortingAlgorithm: function sortingAlgorithm(data, column) {
      return data.sort(this.getSortFn(column));
    },
    filterAlgorithm: {},
    customSorting: {},
    multiSorting: {},
    clientMultiSorting: true,
    serverMultiSorting: false,
    filterByColumn: false,
    highlightMatches: false,
    orderBy: false,
    descOrderColumns: [],
    footerHeadings: false,
    headings: {},
    headingsTooltips: {},
    pagination: {
      show: true,
      dropdown: false,
      chunk: 10,
      edge: false,
      align: "center",
      nav: "fixed"
    },
    childRow: false,
    childRowTogglerFirst: true,
    disabledChildRows: false,
    showChildRowToggler: true,
    uniqueKey: "id",
    requestFunction: false,
    requestAdapter: function requestAdapter(data) {
      return data;
    },
    responseAdapter: function responseAdapter(resp) {
      var data = this.getResponseData(resp);
      return {
        data: data.data,
        count: data.count
      };
    },
    requestKeys: {
      query: "query",
      limit: "limit",
      orderBy: "orderBy",
      ascending: "ascending",
      page: "page",
      byColumn: "byColumn"
    },
    rowClassCallback: false,
    preserveState: false,
    saveState: false,
    storage: "local",
    columnsClasses: {},
    summary: false,
    caption: false,
    cellClasses: {},
    visibleColumns: false,
    hiddenColumns: false,
    resizableColumns: true,
    editableColumns: [],
    tabbable: true,
    infiniteScroll: false,
    componentsOverride: {}
  };
};

/***/ }),
/* 1640 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/filters/custom-filters.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, customFilters, customQueries) {
  var passing;
  return data.filter(function (row) {
    passing = true;
    customFilters.forEach(function (filter) {
      var value = customQueries[filter.name];
      if (value && !filter.callback(row, value)) passing = false;
    });
    return passing;
  });
};

/***/ }),
/* 1641 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/filters/format-date.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var validMoment = __webpack_require__(/*! ../helpers/is-valid-moment-object */ 703);

module.exports = function (value, dateFormat) {
  if (!validMoment(value)) return value;
  return value.format(dateFormat);
};

/***/ }),
/* 1642 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./~/vue-tables-2/compiled/filters/highlight-matches.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value, column, h) {
  var query = this.opts.filterByColumn ? this.query[column] : this.query;
  if (!query) return value;
  query = new RegExp("(" + escapeRegex(query) + ")", "i");
  return h("span", {
    "class": 'VueTables__highlight'
  }, matches(value, query, h));
};

function matches(value, query, h) {
  var pieces = String(value).split(query);
  return pieces.map(function (piece) {
    if (query.test(piece)) {
      return h("b", {}, piece);
    }

    return piece;
  });
}

function escapeRegex(s) {
  return typeof s === 'string' ? s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : s;
}

;

/***/ }),
/* 1643 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/filters/option-text.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value, column) {
  var list = this.listColumnsObject[column];
  if (typeof list[value] == 'undefined') return value;
  return list[value];
};

/***/ }),
/* 1644 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/helpers/is-empty.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (obj) {
  // null and undefined are "empty"
  if (obj == null) return true; // Assume if it has a length property with a non-zero value
  // that that property is correct.

  if (obj.length > 0) return false;
  if (obj.length === 0) return true; // Otherwise, does it have any properties of its own?

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
  }

  return true;
};

/***/ }),
/* 1645 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/helpers/object-filled-keys-count.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (obj) {
  var count = 0;

  for (var prop in obj) {
    var isDateRange = _typeof(obj[prop]) == 'object';
    if (isDateRange || obj[prop] && (!isNaN(obj[prop]) || obj[prop].trim())) count++;
  }

  return count;
};

/***/ }),
/* 1646 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/vue-tables-2/compiled/helpers/ucfirst.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/***/ }),
/* 1647 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/cell-classes.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column, row) {
  if (!this.opts.cellClasses[column]) return '';
  return this.opts.cellClasses[column].filter(function (item) {
    return item.condition(row);
  }).map(function (item) {
    return item["class"];
  }).join(' ');
};

/***/ }),
/* 1648 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/child-row-toggler-class.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (rowId) {
  return this.openChildRows.includes(rowId) ? 'VueTables__child-row-toggler--open' : 'VueTables__child-row-toggler--closed';
};

/***/ }),
/* 1649 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/client-search.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var object_filled_keys_count = __webpack_require__(/*! ../helpers/object-filled-keys-count */ 1645);

var is_valid_moment_object = __webpack_require__(/*! ../helpers/is-valid-moment-object */ 703);

var filterByCustomFilters = __webpack_require__(/*! ../filters/custom-filters */ 1640);

module.exports = function (data, e) {
  if (e) {
    var _query = this.query;
    this.setPage(1, true);
    var name = this.getName(e.target.name);
    var value = _typeof(e.target.value) === 'object' ? e.target.value : '' + e.target.value;

    if (name) {
      _query[name] = value;
    } else {
      _query = value;
    }

    this.vuex ? this.commit('SET_FILTER', _query) : this.query = _query;
    this.updateState('query', _query);

    if (name) {
      this.dispatch('filter', {
        name: name,
        value: value
      });
      this.dispatch("filter::".concat(name), value);
    } else {
      this.dispatch('filter', value);
    }
  }

  var query = this.query;
  var totalQueries = !query ? 0 : 1;
  if (!this.opts) return data;

  if (this.opts.filterByColumn) {
    totalQueries = object_filled_keys_count(query);
  }

  var value;
  var found;
  var currentQuery;
  var dateFormat;
  var filterByDate;
  var isListFilter;
  var data = filterByCustomFilters(data, this.opts.customFilters, this.customQueries);
  if (!totalQueries) return data;
  return data.filter(function (row, index) {
    found = 0;
    this.filterableColumns.forEach(function (column) {
      filterByDate = this.opts.dateColumns.indexOf(column) > -1 && this.opts.filterByColumn;
      isListFilter = this.isListFilter(column) && this.opts.filterByColumn;
      dateFormat = this.dateFormat(column);
      value = this._getValue(row, column);

      if (is_valid_moment_object(value) && !filterByDate) {
        value = value.format(dateFormat);
      }

      currentQuery = this.opts.filterByColumn ? query[column] : query;
      currentQuery = setCurrentQuery(currentQuery);

      if (currentQuery) {
        if (this.opts.filterAlgorithm[column]) {
          if (this.opts.filterAlgorithm[column].call(this.$parent.$parent, row, this.opts.filterByColumn ? query[column] : query)) found++;
        } else {
          if (foundMatch(currentQuery, value, isListFilter)) found++;
        }
      }
    }.bind(this));
    return found >= totalQueries;
  }.bind(this));
};

function setCurrentQuery(query) {
  if (!query) return '';
  if (typeof query == 'string') return query.toLowerCase(); // Date Range

  return query;
}

function foundMatch(query, value, isListFilter) {
  if (['string', 'number', 'boolean'].indexOf(_typeof(value)) > -1) {
    value = String(value).toLowerCase();
  } // List Filter


  if (isListFilter) {
    return value == query;
  } //Text Filter


  if (typeof value === 'string') {
    return value.indexOf(query) > -1;
  } // Date range


  if (is_valid_moment_object(value)) {
    var start = moment(query.start, 'YYYY-MM-DD HH:mm:ss');
    var end = moment(query.end, 'YYYY-MM-DD HH:mm:ss');
    return value >= start && value <= end;
  }

  if (_typeof(value) === 'object') {
    for (var key in value) {
      if (foundMatch(query, value[key])) return true;
    }

    return false;
  }

  return value >= start && value <= end;
}

/***/ }),
/* 1650 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/column-class.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var c = this.opts.columnsClasses;
  return c.hasOwnProperty(column) ? c[column] : '';
};

/***/ }),
/* 1651 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/currently-sorted.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var userMultiSort = Object.keys(this.userMultiSorting);
  if (!userMultiSort.length || this.orderBy.column === column) return this.orderBy.column === column;
  return !!this.userMultiSorting[userMultiSort[0]].filter(function (col) {
    return col.column == column;
  }).length;
};

/***/ }),
/* 1652 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/date-format.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (this.opts.dateFormatPerColumn.hasOwnProperty(column)) {
    return this.opts.dateFormatPerColumn[column];
  }

  return this.opts.dateFormat;
};

/***/ }),
/* 1653 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/default-sort.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column, ascending) {
  var multiIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var sort = this.defaultSort;
  var multiSort = this.userMultiSorting[this.currentlySorting.column] ? this.userMultiSorting[this.currentlySorting.column] : this.opts.multiSorting[this.currentlySorting.column];
  var asc = this.currentlySorting.ascending;
  var self = this;
  return function (a, b) {
    var aVal = self._getValue(a, column) || '';
    var bVal = self._getValue(b, column) || '';
    var dir = ascending ? 1 : -1;
    var secondaryAsc;
    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();

    if (aVal === bVal && multiSort && multiSort[multiIndex + 1]) {
      var sortData = multiSort[multiIndex + 1];

      if (typeof sortData.ascending !== 'undefined') {
        secondaryAsc = sortData.ascending;
      } else {
        secondaryAsc = sortData.matchDir ? asc : !asc;
      }

      return sort(sortData.column, secondaryAsc, multiIndex + 1)(a, b);
    }

    return aVal > bVal ? dir : -dir;
  };
};

/***/ }),
/* 1654 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/dispatch.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__(/*! ../bus */ 160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (event, payload) {
  if (this.vuex) {
    if (event.split('::').length > 1) return;
    this.commit(event.toUpperCase().replace('-', '_'), payload);
  }

  this.$parent.$emit(event, payload);

  _bus["default"].$emit("vue-tables.".concat(event), payload);

  if (this.name) {
    _bus["default"].$emit("vue-tables.".concat(this.name, ".").concat(event), payload);
  }
};

/***/ }),
/* 1655 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/display.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (text, replacements) {
  if (!this.opts.texts) return '';
  var text = this.opts.texts[text];
  if (replacements) for (var key in replacements) {
    // console.log(key)
    text = text.replace('{' + key + '}', replacements[key]);
  }
  return text;
};

/***/ }),
/* 1656 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/filter-type.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (!this.opts.filterable) return false;
  if (this.isTextFilter(column)) return 'vt-text-filter';
  if (this.isDateFilter(column)) return 'vt-date-filter';
  if (this.isListFilter(column)) return 'vt-list-filter';
};

/***/ }),
/* 1657 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/filterable.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (!this.opts.filterable) return false;
  return typeof this.opts.filterable == 'boolean' && this.opts.filterable || this.opts.filterable.indexOf(column) > -1;
};

/***/ }),
/* 1658 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-child-row-template.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h, row, index, scopedSlot) {
  // scoped slot
  if (scopedSlot) return scopedSlot({
    row: row,
    index: index
  });
  var childRow = this.opts.childRow; // function

  if (typeof childRow === 'function') return childRow.apply(this, [h, row]); // component

  return h(childRow, {
    attrs: {
      data: row
    }
  });
};

/***/ }),
/* 1659 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-column-name.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return 'vf__' + column.split('.').join('@@@');
};

/***/ }),
/* 1660 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-data.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (promiseOnly) {
  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var emitLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!this.opts.sendInitialRequest && !this.initialRequestSent) {
    this.initialRequestSent = true;
    this.loading = true;
  }

  var data = this.opts.requestAdapter(this.getRequestParams(additionalData));

  if (emitLoading) {
    this.dispatch('loading', data);
  }

  var promise = this.sendRequest(data);
  if (promiseOnly) return promise;
  return promise.then(function (response) {
    if (typeof response !== 'undefined') {
      this.loading = false;
      return this.setData(response);
    } else {
      return false;
    }
  }.bind(this));
};

/***/ }),
/* 1661 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-group-slot.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
  if (this.$parent.$scopedSlots && this.$parent.$scopedSlots['__group_meta']) {
    var data = this.opts.groupMeta.find(function (val) {
      return val.value === value;
    });
    if (!data) return '';
    return this.$parent.$scopedSlots['__group_meta'](data);
  }

  return '';
};

/***/ }),
/* 1662 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-heading-tooltip.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value, h) {
  if (typeof value !== 'string') return '';
  var derivedHeadingTooltip = '';
  if (!this.opts.headingsTooltips.hasOwnProperty(value)) return derivedHeadingTooltip;

  if (typeof this.opts.headingsTooltips[value] === 'function') {
    if (h) return this.opts.headingsTooltips[value].call(this.$parent, h);
    return derivedHeadingTooltip;
  }

  return this.opts.headingsTooltips[value];
};

/***/ }),
/* 1663 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-heading.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ucfirst = _interopRequireDefault(__webpack_require__(/*! ../helpers/ucfirst */ 1646));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (value, h) {
  if (typeof value !== 'string') return '';

  if (typeof this.$parent.$slots["h__".concat(value)] !== 'undefined') {
    return this.$parent.$slots["h__".concat(value)];
  }

  var derivedHeading = (0, _ucfirst["default"])(value.split("_").join(" "));
  if (!this.opts.headings.hasOwnProperty(value)) return derivedHeading;

  if (typeof this.opts.headings[value] === 'function') {
    if (h) return this.opts.headings[value].call(this.$parent, h);
    return derivedHeading;
  }

  return this.opts.headings[value];
};

/***/ }),
/* 1664 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-initial-date-range.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (typeof this.opts.initFilters[column] !== 'undefined') {
    return this.opts.initFilters[column];
  }

  if (typeof this.query[column] !== 'undefined' && this.query[column].start) {
    return {
      start: moment(this.query[column].start, 'YYYY-MM-DD HH:mm:ss'),
      end: moment(this.query[column].end, 'YYYY-MM-DD HH:mm:ss')
    };
  }

  return false;
};

/***/ }),
/* 1665 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-name.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (name) {
  if (!name) return name;
  name = name.split('__');
  name.shift();
  return name.join('__').split('@@@').join('.');
};

/***/ }),
/* 1666 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-open-child-rows.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!this.opts.childRow || typeof this.opts.childRow === 'function') {
    throw new Error('vue-tables-2: Child row undefined or not a component');
  }

  var Rows = rows ? this.openChildRows.filter(function (row) {
    return rows.includes(row);
  }) : this.openChildRows;
  if (!Rows.length) return [];
  return this.$parent.$refs.vt_table.$refs.vt_table_body.$children[0].$children.filter(function (child) {
    return child.$options.name === 'VtChildRow' && Rows.includes(child.$children[0].$children[0].data[_this.opts.uniqueKey]);
  }).map(function (child) {
    return child.$children[0].$children[0];
  });
};

/***/ }),
/* 1667 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-request-params.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var merge = __webpack_require__(/*! merge */ 57);

module.exports = function () {
  var _data;

  var additionalData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = this.opts.requestKeys;
  var data = (_data = {}, _defineProperty(_data, keys.query, this.filteredQuery), _defineProperty(_data, keys.limit, this.limit), _defineProperty(_data, keys.ascending, this.orderBy.ascending ? 1 : 0), _defineProperty(_data, keys.page, parseInt(this.page)), _defineProperty(_data, keys.byColumn, this.opts.filterByColumn ? 1 : 0), _data);
  if (this.orderBy.hasOwnProperty('column') && this.orderBy.column) data[keys.orderBy] = this.orderBy.column;
  data = merge(data, this.opts.params, this.customQueries, additionalData);

  if (this.hasMultiSort && this.orderBy.column && this.userMultiSorting[this.orderBy.column]) {
    data.multiSort = this.userMultiSorting[this.orderBy.column];
  }

  return data;
};

/***/ }),
/* 1668 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-response-data.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (response) {
  if (typeof axios !== 'undefined') return response.data;
  return response;
};

/***/ }),
/* 1669 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-sort-fn.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var ascending = this.orderBy.ascending;
  this.currentlySorting = {
    column: column,
    ascending: ascending
  };
  if (typeof this.opts.customSorting[column] == 'undefined') return this.defaultSort(column, ascending);
  return this.opts.customSorting[column](ascending);
};

/***/ }),
/* 1670 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/get-value.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (row, column) {
  if (column.indexOf('.') === -1) return row[column];
  var p = column.split('.');
  var value = row[p[0]];
  if (!value) return '';

  for (var i = 1; i < p.length; i++) {
    value = value[p[i]]; // If the nested structure doesn't exist return an empty string

    if (typeof value === 'undefined') return '';
  }

  return value;
};

/***/ }),
/* 1671 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/has-date-filters.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var intersection = __webpack_require__(/*! array-intersect */ 304)["default"];

module.exports = function () {
  var opts = this.opts;
  return opts.dateColumns.length && opts.filterByColumn && (typeof opts.filterable == 'boolean' && opts.filterable || _typeof(opts.filterable) == 'object' && intersection(opts.filterable, opts.dateColumns).length);
};

/***/ }),
/* 1672 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/init-custom-filters.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var customQueries = {};
  var init = this.opts.initFilters;
  var key;
  this.opts.customFilters.forEach(function (filter) {
    key = this.source == 'client' ? filter.name : filter;
    customQueries[key] = init.hasOwnProperty(key) ? init[key] : '';
  }.bind(this));
  return customQueries;
};

/***/ }),
/* 1673 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/init-date-filters.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var merge = __webpack_require__(/*! merge */ 57);

module.exports = function () {
  if (typeof $ === 'undefined' || typeof $(this.$el).daterangepicker === 'undefined') {
    console.error('Date filters require jquery and daterangepicker');
    return;
  }

  var el;
  var that = this;
  var query = this.vuex ? JSON.parse(JSON.stringify(this.query)) : this.query;
  var columnOptions;
  var dpOptions;

  var search = function search(query, e) {
    return that.source == 'client' ? that.search(that.data, e) : that.serverSearch(query, e);
  };

  var datepickerOptions = merge.recursive(this.opts.datepickerOptions, {
    autoUpdateInput: false,
    singleDatePicker: false
  });
  that.datepickerColumns.forEach(function (column) {
    var range = that._getInitialDateRange(column);

    if (range) {
      that._setDatepickerText(column, range.start, range.end);

      range = {
        startDate: range.start,
        endDate: range.end
      };
    } else {
      range = {};
    }

    el = $(that.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter");
    columnOptions = typeof that.opts.datepickerPerColumnOptions[column] !== 'undefined' ? that.opts.datepickerPerColumnOptions[column] : {};
    columnOptions = merge.recursive(columnOptions, {
      locale: {
        format: that.dateFormat(column)
      }
    });
    dpOptions = merge(true, datepickerOptions);

    if (columnOptions.ranges === false) {
      dpOptions.ranges = {};
    }

    var drp = el.data('daterangerpicker');

    if (drp) {
      drp.remove();
    }

    el.daterangepicker(merge.recursive(dpOptions, columnOptions, range));
    el.on('apply.daterangepicker', function (ev, picker) {
      query[column] = {
        start: picker.startDate.format('YYYY-MM-DD HH:mm:ss'),
        end: picker.endDate.format('YYYY-MM-DD HH:mm:ss')
      };
      if (!that.vuex) that.query = query;

      that._setDatepickerText(column, picker.startDate, picker.endDate);

      that.updateState('query', query);
      search(query, {
        target: {
          name: that._getColumnName(column),
          value: query[column]
        }
      });
    });
    el.on('cancel.daterangepicker', function (ev, picker) {
      query[column] = '';
      if (!that.vuex) that.query = query;
      picker.setStartDate(moment());
      picker.setEndDate(moment());
      that.updateState('query', query);
      $(this).html("<span class='VueTables__filter-placeholder'>" + that.display('filterBy', {
        column: that.getHeading(column)
      }) + "</span>");
      search(query, {
        target: {
          name: that._getColumnName(column),
          value: query[column]
        }
      });
    });
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 1674 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/init-options.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(/*! merge */ 57);

module.exports = function (defaults, globalOptions, localOptions) {
  if (globalOptions) defaults = merge.recursive(defaults, globalOptions);
  localOptions = merge.recursive(defaults, localOptions);
  return localOptions;
};

/***/ }),
/* 1675 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/init-order-by.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (!this.opts.orderBy) return;
  this.orderBy.column = this.opts.orderBy.column;
  this.orderBy.ascending = this.opts.orderBy.hasOwnProperty('ascending') ? this.opts.orderBy.ascending : true;
};

/***/ }),
/* 1676 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/init-query.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function () {
  var init = this.opts.initFilters;
  if (!this.opts.filterByColumn) return init.hasOwnProperty('GENERIC') ? init.GENERIC : '';
  var query = {};
  var filterable = this.opts.filterable && _typeof(this.opts.filterable) == 'object' ? this.opts.filterable : this.columns;
  filterable.forEach(function (column) {
    query[column] = getInitialValue(init, column);
  }.bind(this));
  return query;
};

function getInitialValue(init, column) {
  if (!init.hasOwnProperty(column)) return '';
  if (typeof init[column].start == 'undefined') return init[column];
  return {
    start: init[column].start.format('YYYY-MM-DD HH:mm:ss'),
    end: init[column].end.format('YYYY-MM-DD HH:mm:ss')
  };
}

/***/ }),
/* 1677 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/init-state.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var state = {
    page: 1,
    query: this.query,
    orderBy: this.orderBy,
    perPage: this.opts.perPage,
    customQueries: this.customQueries
  };
  this.storage.setItem(this.stateKey, JSON.stringify(state));
  return state;
};

/***/ }),
/* 1678 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/initial-order-ascending.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return !this.opts.descOrderColumns.includes(column);
};

/***/ }),
/* 1679 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/is-date-filter.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) > -1;
};

/***/ }),
/* 1680 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/is-list-filter.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.opts.listColumns.hasOwnProperty(column);
};

/***/ }),
/* 1681 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/is-text-filter.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) == -1 && !this.opts.listColumns.hasOwnProperty(column);
};

/***/ }),
/* 1682 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/on-pagination.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (page) {
  if (this.vuex) return;
  this.setPage(page);
  this.dispatch('pagination', page);
};

/***/ }),
/* 1683 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/only-column.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.userColumnsDisplay.length === 1 && this.userColumnsDisplay[0] === column;
};

/***/ }),
/* 1684 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/order-by-column.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (colName, ev) {
  if (!this.sortable(colName)) return;
  this.setPage(1, true);

  if (ev && ev.shiftKey && this.orderBy.column && this.hasMultiSort) {
    this.setUserMultiSort(colName);
  } else {
    this.userMultiSorting = {};
    this.orderBy.ascending = colName == this.orderBy.column ? !this.orderBy.ascending : this._initialOrderAscending(colName);
    this.orderBy.column = colName;
    this.updateState('orderBy', this.orderBy);
    this.dispatch('sorted', JSON.parse(JSON.stringify(this.orderBy)));
  }

  if (this.source == 'server') {
    this.getData();
  }
};

/***/ }),
/* 1685 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/refresh.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  this.serverSearch();
};

/***/ }),
/* 1686 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/register-client-filters.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__(/*! ../bus */ 160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
  var _this = this;

  var event = 'vue-tables';
  if (this.name) event += '.' + this.name;
  this.opts.customFilters.forEach(function (filter) {
    _bus["default"].$off("".concat(event, ".filter::").concat(filter.name));

    _bus["default"].$on("".concat(event, ".filter::").concat(filter.name), function (value) {
      _this.setPage(1);

      _this.customQueries[filter.name] = value;

      _this.updateState('customQueries', _this.customQueries);
    });
  });
};

/***/ }),
/* 1687 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/register-server-filters.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__(/*! ../bus */ 160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
  var event = 'vue-tables';
  if (this.name) event += '.' + this.name;
  this.opts.customFilters.forEach(function (filter) {
    _bus["default"].$off("".concat(event, ".filter::").concat(filter));

    _bus["default"].$on("".concat(event, ".filter::").concat(filter), function (value) {
      this.customQueries[filter] = value;
      this.updateState('customQueries', this.customQueries);
      this.refresh();
    }.bind(this));
  }.bind(this));
};

/***/ }),
/* 1688 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/render.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (row, column, index, h) {
  var value = this._getValue(row, column);

  if (this.templatesKeys.indexOf(column) == -1) {
    if (typeof value === 'undefined' || !this.opts.highlightMatches || this.filterableColumns.indexOf(column) === -1) {
      return value;
    }

    return this.highlightMatch(value, column, h);
  }

  var template = this.opts.templates[column];
  template = typeof template == 'function' ? template.apply(this.$root, [h, row, index, column]) : h(template, {
    attrs: {
      data: row,
      column: column,
      index: index
    }
  });
  return template;
};

/***/ }),
/* 1689 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/reset-custom-filters.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  for (var key in this.$refs.table.customQueries) {
    this.$refs.table.customQueries[key] = null;
  }

  this.$refs.table.updateState('customQueries', this.customQueries);
  this.$refs.table.refresh();
};

/***/ }),
/* 1690 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/reset-query.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (this.opts.filterByColumn) {
    var query = {};

    for (var key in this.query) {
      query[key] = '';
    }
  } else {
    var query = '';
  }

  this.setFilter(query);
};

/***/ }),
/* 1691 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/revert-value.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function _revertVal(row, column) {
  return function () {
    var _this = this;

    row[column] = this.editing.find(function (e) {
      return e.id === row[_this.opts.uniqueKey];
    }).originalValue;
  }.bind(this);
};

/***/ }),
/* 1692 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/row-was-clicked.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (row, index, event) {
  var data;
  var id = this.opts.uniqueKey;

  if (this.source == 'client' && typeof row[id] !== 'undefined') {
    data = this.tableData.filter(function (r) {
      return row[id] === r[id];
    })[0];
  } else {
    data = row;
  }

  this.dispatch('row-click', {
    row: data,
    index: index,
    event: event
  });
};

/***/ }),
/* 1693 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/search.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _debounce = _interopRequireDefault(__webpack_require__(/*! debounce */ 1125));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (debounceVal) {
  var search = this.source === 'client' ? this.search.bind(this, this.data) : this.serverSearch.bind(this);

  if (!debounceVal) {
    return search;
  }

  var debouncedSearch = (0, _debounce["default"])(search, debounceVal);
  return function (e) {
    // ignore tab
    if (e.keyCode === 9) return; // search immediately on enter

    if (e.keyCode === 13) {
      debouncedSearch.clear();
      search.apply(void 0, arguments);
    } else {
      debouncedSearch.apply(void 0, arguments);
    }
  };
};

/***/ }),
/* 1694 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/send-request.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

module.exports = function (data) {
  if (typeof this.opts.requestFunction === 'function') {
    return this.opts.requestFunction.call(this, data);
  }

  if (typeof axios !== 'undefined') return axios.get(this.url, {
    params: data
  })["catch"](function (e) {
    this.dispatch('error', e);
  }.bind(this));
  if (typeof this.$http !== 'undefined') return this.$http.get(this.url, {
    params: data
  }).then(function (data) {
    return data.json();
  }.bind(this), function (e) {
    this.dispatch('error', e);
  }.bind(this));
  if (typeof $ != 'undefined') return $.getJSON(this.url, data).fail(function (e) {
    this.dispatch('error', e);
  }.bind(this));
  throw "vue-tables: No supported ajax library was found. (jQuery, axios or vue-resource). To use a different library you can write your own request function (see the `requestFunction` option)";
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 1695 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-columns-dropdown-close-listener.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  if (this.opts.columnsDropdown) {
    var stopProp = function stopProp(e) {
      return e.stopPropagation();
    };

    var handler = function handler() {
      if (_this.displayColumnsDropdown) {
        _this.displayColumnsDropdown = false;
      }
    };

    this.$refs.columnsdropdown.addEventListener('click', stopProp);
    document.addEventListener('click', handler);
    this.$once('hook:beforeDestroy', function () {
      document.removeEventListener('click', handler);

      _this.$refs.columnsdropdown.removeEventListener('click', stopProp);
    });
  }
};

/***/ }),
/* 1696 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-custom-filters.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (filters) {
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  for (var key in filters) {
    this.customQueries[key] = filters[key];
  }

  this.updateState('customQueries', this.customQueries);

  if (this.source === 'server' && sendRequest) {
    this.getData();
  }
};

/***/ }),
/* 1697 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-data.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (response) {
  var data = this.opts.responseAdapter.call(this, response);
  this.data = data.data;

  if (isNaN(data.count)) {
    console.error("vue-tables-2: invalid 'count' property. Expected number, got ".concat(_typeof(data.count)));
    console.error('count equals', data.count);
    throw new Error();
  }

  this.count = parseInt(data.count);
  setTimeout(function () {
    this.dispatch('loaded', response);
  }.bind(this), 0);
};

/***/ }),
/* 1698 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-datepicker-text.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

module.exports = function (column, start, end) {
  var dateFormat = this.dateFormat(column);
  var el = typeof column === 'string' ? $(this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter") : column;
  el.text(start.format(dateFormat) + " - " + end.format(dateFormat));
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 1699 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-editing-cell.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function _setEditingCell(row, column) {
  return function (editing) {
    var _this = this;

    if (editing) {
      this.editing.push({
        id: row[this.opts.uniqueKey],
        column: column,
        originalValue: row[column]
      });
    } else {
      this.editing = this.editing.filter(function (e) {
        return e.id !== row[_this.opts.uniqueKey];
      });
    }
  }.bind(this);
};

/***/ }),
/* 1700 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-filter.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(/*! merge */ 57);

module.exports = function (filter) {
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!this.opts.filterable) {
    console.warn("vue-tables-2: Unable to set filter. Filtering is disabled (filterable: false)");
    return;
  }

  ;

  if (this.opts.filterByColumn && typeof filter === 'string') {
    console.warn("vue-tables-2: Unable to set filter. Filter value must be an object (`filterByColumn` is set to `true`)");
    return;
  }

  ;

  if (!this.opts.filterByColumn && typeof filter !== 'string') {
    console.warn("vue-tables-2: Unable to set filter. Filter value must be a string (`filterByColumn` is set to `false`)");
    return;
  }

  ;
  var mergedFilter = this.opts.filterByColumn ? merge(true, this.query, filter) : filter;

  if (this.vuex) {
    this.commit('SET_FILTER', mergedFilter);
  } else {
    this.query = mergedFilter;
    this.setPage(1, true);
  }

  this.updateState('query', mergedFilter);

  this._setFiltersDOM(filter);

  if (this.source == 'server' && sendRequest) {
    this.getData();
  }
};

/***/ }),
/* 1701 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-filters-dom.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (query) {
  var el;

  if (this.opts.filterByColumn) {
    for (var column in query) {
      var columnName = this._getColumnName(column);

      if (this.isDateFilter(column)) {
        if (query[column] && _typeof(query[column]) === 'object') {
          var start = typeof query[column].start === 'string' ? moment(query[column].start, 'YYYY-MM-DD') : query[column].start;
          var end = typeof query[column].end === 'string' ? moment(query[column].end, 'YYYY-MM-DD') : query[column].end;

          this._setDatepickerText(column, start, end);
        } else {
          $(this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter").html("<span class='VueTables__filter-placeholder'>" + this.display('filterBy', {
            column: this.getHeading(column)
          }) + "</span>");
        }

        continue;
      }

      el = this.$el.querySelector("[name='".concat(columnName.replace("'", "\\'"), "']"));

      if (el) {
        el.value = query[column];
      } else if (this.columns.indexOf(column) === -1) {
        console.error("vue-tables-2: Error in setting filter value. Column '".concat(column, "' does not exist."));
      }
    }
  } else {
    var el = this.$el.querySelector('.VueTables__search__input');
    if (el) el.value = query;
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 1702 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-limit.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  this.limit = _typeof(e) === 'object' ? e.target.value : e;
  this.updateState('perPage', this.limit);
  this.dispatch('limit', parseInt(this.limit));

  if (sendRequest) {
    this.setPage(1);
  }
};

/***/ }),
/* 1703 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-order.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column, ascending) {
  var sendRequest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  this.orderBy.column = column;
  this.orderBy.ascending = ascending;
  this.updateState('orderBy', {
    column: column,
    ascending: ascending
  });

  if (this.source == 'server' && sendRequest) {
    this.getData();
  }
};

/***/ }),
/* 1704 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-page.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (page) {
  var preventRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  page = parseInt(page);
  this.page = page > 0 ? page : 1;
  this.updateState('page', page);
  this.dispatch('pagination', page);
  if (this.source == 'server' && !preventRequest) this.getData();
};

/***/ }),
/* 1705 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-request-params.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (params.page) {
    this.setPage(params.page, true);
  }

  if (params.limit) {
    this.setLimit(params.limit, false);
  }

  if (params.order) {
    this.setOrder(params.order.column, params.order.ascending, false);
  }

  if (params.filters) {
    this.setFilter(params.filters, false);
  }

  if (params.customFilters) {
    this.setCustomFilters(params.customFilters, false);
  }

  if (sendRequest) {
    this.getData();
  }
};

/***/ }),
/* 1706 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/set-user-multi-sort.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (secondaryCol) {
  var primaryCol = this.orderBy.column;
  var primaryAsc = this.orderBy.ascending;
  if (!this.userMultiSorting[primaryCol]) this.$set(this.userMultiSorting, primaryCol, []);
  var multi = this.userMultiSorting[primaryCol];

  if (primaryCol === secondaryCol) {
    if (!multi.length || primaryAsc) {
      // primary is the only sorted column or is ascending
      this.orderBy.ascending = !this.orderBy.ascending;
    } else {
      // remove primary column and make secondary primary
      this.orderBy = multi.shift();
      this.userMultiSorting = {};
      this.$set(this.userMultiSorting, this.orderBy.column, multi);
    }
  } else {
    var secondary = multi.filter(function (col) {
      return col.column == secondaryCol;
    })[0];

    if (secondary) {
      if (!secondary.ascending) {
        // remove sort
        this.$set(this.userMultiSorting, primaryCol, multi.filter(function (col) {
          return col.column != secondaryCol;
        }));
        if (!this.userMultiSorting[primaryCol].length) this.userMultiSorting = {};
      } else {
        // change direction
        secondary.ascending = !secondary.ascending;
      }
    } else {
      // add sort
      multi.push({
        column: secondaryCol,
        ascending: true
      });
    }
  } // force re-compilation of the filteredData computed property


  this.time = Date.now();
  this.dispatch('sorted', getMultiSortData(this.orderBy, this.userMultiSorting));
};

function getMultiSortData(main, secondary) {
  var cols = [JSON.parse(JSON.stringify(main))];
  cols = cols.concat(secondary[main.column]);
  return cols;
}

;

/***/ }),
/* 1707 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/should-show-column-on-init.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (this.opts.visibleColumns) {
    return this.opts.visibleColumns.includes(column);
  }

  if (this.opts.hiddenColumns) {
    return !this.opts.hiddenColumns.includes(column);
  }

  return true;
};

/***/ }),
/* 1708 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/sortable-chevron-class.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var cls = this.opts.sortIcon.base + ' ';
  if (!this.sortable(column)) return;

  if (this.opts.sortIcon.is && !this._currentlySorted(column)) {
    cls += this.opts.sortIcon.is + ' ';
  }

  if (this.hasMultiSort && this.orderBy.column && this.userMultiSorting[this.orderBy.column]) {
    var col = this.userMultiSorting[this.orderBy.column].filter(function (c) {
      return c.column === column;
    })[0];
    if (col) cls += col.ascending ? this.opts.sortIcon.up : this.opts.sortIcon.down;
  }

  if (column == this.orderBy.column) {
    cls += this.orderBy.ascending == 1 ? this.opts.sortIcon.up : this.opts.sortIcon.down;
  }

  return cls;
};

/***/ }),
/* 1709 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/sortable-class.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var c = this.sortable(column) ? 'VueTables__sortable ' : '';
  c += this.columnClass(column);

  if (this.orderBy.column === column) {
    c += "".concat(column, "-sorted-") + (this.orderBy.ascending ? 'asc' : 'desc');
  }

  return c;
};

/***/ }),
/* 1710 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/sortable.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var sortAll = typeof this.opts.sortable == 'boolean' && this.opts.sortable;
  if (sortAll) return true;
  return this.opts.sortable.indexOf(column) > -1;
};

/***/ }),
/* 1711 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/toggle-child-row.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (rowId, e) {
  if (e) e.stopPropagation();

  if (this.openChildRows.includes(rowId)) {
    var index = this.openChildRows.indexOf(rowId);
    this.openChildRows.splice(index, 1);
  } else {
    this.openChildRows.push(rowId);
  }
};

/***/ }),
/* 1712 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/toggle-column.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var _this = this;

  if (!this.userControlsColumns) {
    this.userColumnsDisplay = JSON.parse(JSON.stringify(this.allColumns));
    this.userControlsColumns = true;
  }

  if (this.userColumnsDisplay.includes(column)) {
    // can't have no columns
    if (this.userColumnsDisplay.length === 1) return;
    var index = this.userColumnsDisplay.indexOf(column);
    this.userColumnsDisplay.splice(index, 1);
  } else {
    this.userColumnsDisplay.push(column);
  }

  this.updateState('userControlsColumns', true);
  this.updateState('userColumnsDisplay', this.userColumnsDisplay);
  this.$nextTick(function () {
    _this._setFiltersDOM(_this.query);

    if (_this.userColumnsDisplay.includes(column) && _this.opts.dateColumns.includes(column)) {
      _this.initDateFilters();
    }
  });
};

/***/ }),
/* 1713 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/toggle-columns-dropdown.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  this.displayColumnsDropdown = !this.displayColumnsDropdown;
};

/***/ }),
/* 1714 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/toggle-group-direction.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (this.orderBy.column != this.opts.groupBy) {
    this.setOrder(this.opts.groupBy, true);
  } else {
    this.setOrder(this.opts.groupBy, !this.orderBy.ascending);
  }
};

/***/ }),
/* 1715 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/transform-date-strings-to-moment.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  this.data.forEach(function (row, index) {
    this.opts.dateColumns.forEach(function (column) {
      row[column] = row[column] ? moment(row[column], this.opts.toMomentFormat) : '';
    }.bind(this));
  }.bind(this));
};

/***/ }),
/* 1716 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/update-state.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (key, value) {
  if (!this.opts.saveState || !this.activeState) return;

  try {
    var currentState = JSON.parse(this.storage.getItem(this.stateKey));
  } catch (e) {
    var currentState = this.initState();
  }

  currentState[key] = value;
  this.storage.setItem(this.stateKey, JSON.stringify(currentState));
};

/***/ }),
/* 1717 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./~/vue-tables-2/compiled/methods/update-value.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var clone = __webpack_require__(/*! lodash.clonedeep */ 492);

module.exports = function _updateValue(row, column) {
  return function (e) {
    var _this = this;

    var oldVal = row[column];
    row[column] = getValue(e);
    var data = clone(this.data).map(function (r) {
      if (r[_this.opts.uniqueKey] === row[_this.opts.uniqueKey]) {
        return row;
      }

      return r;
    });
    this.dispatch('input', data);
    this.dispatch('update', {
      row: row,
      column: column,
      oldVal: oldVal,
      newVal: row[column]
    });
  }.bind(this);
};

function getValue(val) {
  if (val.target) {
    return val.target.type === 'checkbox' ? val.target.checked : val.target.value;
  }

  return val;
}

/***/ }),
/* 1718 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/mixins/before-destroy.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _bus = _interopRequireDefault(__webpack_require__(/*! ../bus */ 160));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
  var _this = this;

  var el;

  if (this.opts.destroyEventBus) {
    _bus["default"].$off();

    _bus["default"].$destroy();
  }

  if (this.vuex && !this.opts.preserveState) {
    this.$store.unregisterModule(this.name);
  }

  if (this.opts.filterByColumn) {
    this.datepickerColumns.forEach(function (column) {
      el = $(_this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter").data('daterangepicker');
      if (el) el.remove();
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 1719 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/vue-tables-2/compiled/mixins/computed.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  listColumnsObject: __webpack_require__(/*! ../computed/list-columns-object */ 1632),
  allColumns: __webpack_require__(/*! ../computed/all-columns */ 1623),
  templatesKeys: __webpack_require__(/*! ../computed/templates-keys */ 1638),
  opts: __webpack_require__(/*! ../computed/opts */ 1633),
  tableData: __webpack_require__(/*! ../computed/table-data */ 1637),
  storage: __webpack_require__(/*! ../computed/storage */ 1636),
  filterableColumns: __webpack_require__(/*! ../computed/filterable-columns */ 1627),
  datepickerColumns: __webpack_require__(/*! ../computed/datepicker-columns */ 1626),
  hasChildRow: __webpack_require__(/*! ../computed/has-child-row */ 1630),
  colspan: __webpack_require__(/*! ../computed/colspan */ 1624),
  hasGenericFilter: __webpack_require__(/*! ../computed/has-generic-filter */ 1631),
  perPageValues: __webpack_require__(/*! ../computed/per-page-values */ 1634),
  filtersCount: function filtersCount() {
    return this.opts.filterByColumn ? Object.values(this.query).filter(function (val) {
      return !!val;
    }).length : !!this.query ? 1 : 0;
  },
  stateKey: function stateKey() {
    var key = this.name ? this.name : this.id;
    return 'vuetables_' + key;
  },
  Page: function Page() {
    return this.page;
  },
  tabIndex: function tabIndex() {
    return this.opts.tabbable ? 0 : -1;
  }
};

/***/ }),
/* 1720 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-tables-2/compiled/mixins/methods.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  initQuery: __webpack_require__(/*! ../methods/init-query */ 1676),
  resetQuery: __webpack_require__(/*! ../methods/reset-query */ 1690),
  initCustomFilters: __webpack_require__(/*! ../methods/init-custom-filters */ 1672),
  initOptions: __webpack_require__(/*! ../methods/init-options */ 1674),
  sortableClass: __webpack_require__(/*! ../methods/sortable-class */ 1709),
  sortableChevronClass: __webpack_require__(/*! ../methods/sortable-chevron-class */ 1708),
  display: __webpack_require__(/*! ../methods/display */ 1655),
  orderByColumn: __webpack_require__(/*! ../methods/order-by-column */ 1684),
  getHeading: __webpack_require__(/*! ../methods/get-heading */ 1663),
  getHeadingTooltip: __webpack_require__(/*! ../methods/get-heading-tooltip */ 1662),
  sortable: __webpack_require__(/*! ../methods/sortable */ 1710),
  serverSearch: __webpack_require__(/*! ../methods/server-search */ 705),
  initOrderBy: __webpack_require__(/*! ../methods/init-order-by */ 1675),
  initDateFilters: __webpack_require__(/*! ../methods/init-date-filters */ 1673),
  setFilter: __webpack_require__(/*! ../methods/set-filter */ 1700),
  setPage: __webpack_require__(/*! ../methods/set-page */ 1704),
  setOrder: __webpack_require__(/*! ../methods/set-order */ 1703),
  filterable: __webpack_require__(/*! ../methods/filterable */ 1657),
  isTextFilter: __webpack_require__(/*! ../methods/is-text-filter */ 1681),
  isDateFilter: __webpack_require__(/*! ../methods/is-date-filter */ 1679),
  isListFilter: __webpack_require__(/*! ../methods/is-list-filter */ 1680),
  highlightMatch: __webpack_require__(/*! ../filters/highlight-matches */ 1642),
  formatDate: __webpack_require__(/*! ../filters/format-date */ 1641),
  hasDateFilters: __webpack_require__(/*! ../methods/has-date-filters */ 1671),
  optionText: __webpack_require__(/*! ../filters/option-text */ 1643),
  render: __webpack_require__(/*! ../methods/render */ 1688),
  rowWasClicked: __webpack_require__(/*! ../methods/row-was-clicked */ 1692),
  setLimit: __webpack_require__(/*! ../methods/set-limit */ 1702),
  getOpenChildRows: __webpack_require__(/*! ../methods/get-open-child-rows */ 1666),
  dispatch: __webpack_require__(/*! ../methods/dispatch */ 1654),
  toggleChildRow: __webpack_require__(/*! ../methods/toggle-child-row */ 1711),
  childRowTogglerClass: __webpack_require__(/*! ../methods/child-row-toggler-class */ 1648),
  sendRequest: __webpack_require__(/*! ../methods/send-request */ 1694),
  getResponseData: __webpack_require__(/*! ../methods/get-response-data */ 1668),
  getSortFn: __webpack_require__(/*! ../methods/get-sort-fn */ 1669),
  initState: __webpack_require__(/*! ../methods/init-state */ 1677),
  updateState: __webpack_require__(/*! ../methods/update-state */ 1716),
  columnClass: __webpack_require__(/*! ../methods/column-class */ 1650),
  getName: __webpack_require__(/*! ../methods/get-name */ 1665),
  toggleColumn: __webpack_require__(/*! ../methods/toggle-column */ 1712),
  setUserMultiSort: __webpack_require__(/*! ../methods/set-user-multi-sort */ 1706),
  _cellClasses: __webpack_require__(/*! ../methods/cell-classes */ 1647),
  _setFiltersDOM: __webpack_require__(/*! ../methods/set-filters-dom */ 1701),
  _currentlySorted: __webpack_require__(/*! ../methods/currently-sorted */ 1651),
  _getChildRowTemplate: __webpack_require__(/*! ../methods/get-child-row-template */ 1658),
  _toggleColumnsDropdown: __webpack_require__(/*! ../methods/toggle-columns-dropdown */ 1713),
  _onlyColumn: __webpack_require__(/*! ../methods/only-column */ 1683),
  _onPagination: __webpack_require__(/*! ../methods/on-pagination */ 1682),
  _toggleGroupDirection: __webpack_require__(/*! ../methods/toggle-group-direction */ 1714),
  _getInitialDateRange: __webpack_require__(/*! ../methods/get-initial-date-range */ 1664),
  _setDatepickerText: __webpack_require__(/*! ../methods/set-datepicker-text */ 1698),
  _initialOrderAscending: __webpack_require__(/*! ../methods/initial-order-ascending */ 1678),
  dateFormat: __webpack_require__(/*! ../methods/date-format */ 1652),
  _setColumnsDropdownCloseListener: __webpack_require__(/*! ../methods/set-columns-dropdown-close-listener */ 1695),
  _getValue: __webpack_require__(/*! ../methods/get-value */ 1670),
  _getColumnName: __webpack_require__(/*! ../methods/get-column-name */ 1659),
  _shouldShowColumnOnInit: __webpack_require__(/*! ../methods/should-show-column-on-init */ 1707),
  _setEditingCell: __webpack_require__(/*! ../methods/set-editing-cell */ 1699),
  _revertValue: __webpack_require__(/*! ../methods/revert-value */ 1691),
  _updateValue: __webpack_require__(/*! ../methods/update-value */ 1717),
  _filterType: __webpack_require__(/*! ../methods/filter-type */ 1656),
  _search: __webpack_require__(/*! ../methods/search */ 1693),
  setCustomFilters: __webpack_require__(/*! ../methods/set-custom-filters */ 1696)
};

/***/ }),
/* 1721 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./~/vue-tables-2/compiled/state/mutations.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(self) {
  var _ref, _merge$recursive;

  var extra = self.source == 'server' ? (_ref = {}, _defineProperty(_ref, "".concat(self.name, "/SET_DATA"), function SET_DATA(state, response) {
    var data = self.opts.responseAdapter.call(self, response);
    state.data = data.data;
    state.count = parseInt(data.count);
  }), _defineProperty(_ref, "".concat(self.name, "/ERROR"), function ERROR(state, payload) {}), _defineProperty(_ref, "".concat(self.name, "/SET_COUNT"), function SET_COUNT(state, count) {
    state.count = count;
  }), _ref) : _defineProperty({}, "".concat(self.name, "/SET_COUNT"), function SET_COUNT(state, count) {
    state.count = count;
  });
  return _merge["default"].recursive(true, (_merge$recursive = {}, _defineProperty(_merge$recursive, "".concat(self.name, "/PAGINATE"), function PAGINATE(state, page) {
    if (page === 0) {
      page = 1;
    }

    state.page = page;
    self.updateState('page', page);
    if (self.source == 'server') self.getData();
    self.commit('PAGINATION', page);
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_FILTER"), function SET_FILTER(state, filter) {
    state.page = 1;
    self.updateState('page', 1);
    state.query = filter;

    if (self.source == 'server') {
      self.getData();
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/PAGINATION"), function PAGINATION(state, page) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_CUSTOM_FILTER"), function SET_CUSTOM_FILTER(state, _ref3) {
    var filter = _ref3.filter,
        value = _ref3.value;
    state.customQueries[filter] = value;
    state.page = 1;
    self.updateState('page', 1);
    self.updateState('customQueries', state.customQueries);

    if (self.source == 'server') {
      self.getData();
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_STATE"), function SET_STATE(state, _ref4) {
    var page = _ref4.page,
        query = _ref4.query,
        customQueries = _ref4.customQueries,
        limit = _ref4.limit,
        orderBy = _ref4.orderBy;

    if (customQueries) {
      state.customQueries = customQueries;
    }

    if (typeof query !== 'undefined') {
      state.query = query;
    }

    if (page) {
      state.page = page;
    }

    if (limit) {
      state.limit = limit;
    }

    if (typeof orderBy !== 'undefined') {
      state.ascending = orderBy.ascending;
      state.sortBy = orderBy.column;
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_LIMIT"), function SET_LIMIT(state, limit) {
    state.page = 1;
    self.updateState('page', 1);
    state.limit = limit;
    if (self.source == 'server') self.getData();
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SORT"), function SORT(state, _ref5) {
    var column = _ref5.column,
        ascending = _ref5.ascending;
    state.ascending = ascending;
    state.sortBy = column;
    if (self.source == 'server') self.getData();
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_CLIENT_DATA"), function SET_CLIENT_DATA(state, data) {
    state.data = data;
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SORTED"), function SORTED(state, data) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/ROW_CLICK"), function ROW_CLICK(state, row) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/FILTER"), function FILTER(state, row) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/LIMIT"), function LIMIT(state, limit) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/INPUT"), function INPUT(state, payload) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/UPDATE"), function UPDATE(state, payload) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/LOADING"), function LOADING(state, payload) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/LOADED"), function LOADED(state, payload) {}), _merge$recursive), extra);
}

/***/ }),
/* 1722 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./~/vue-tables-2/compiled/state/register-module.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _state = _interopRequireDefault(__webpack_require__(/*! ./state */ 1723));

var _mutations = _interopRequireDefault(__webpack_require__(/*! ./mutations */ 1721));

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (self) {
  var Module = {
    state: (0, _state["default"])(self),
    mutations: (0, _mutations["default"])(self)
  };
  var hasModule = self.$store.hasModule ? self.$store.hasModule(self.name) : self.$store.state && self.$store.state[self.name];

  if (hasModule) {
    Module.state = _merge["default"].recursive(Module.state, self.$store.state[self.name]);
    self.$store.unregisterModule(self.name);
  }

  self.$store.registerModule(self.name, Module);
};

/***/ }),
/* 1723 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./~/vue-tables-2/compiled/state/state.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(self) {
  var state = {
    page: self.opts.initialPage ? self.opts.initialPage : 1,
    limit: self.opts.perPage,
    count: self.source == 'server' ? 0 : self.data.length,
    columns: self.columns,
    data: self.source == 'client' ? self.data : [],
    query: self.initQuery(),
    customQueries: self.initCustomFilters(),
    sortBy: self.opts.orderBy && self.opts.orderBy.column ? self.opts.orderBy.column : false,
    ascending: self.opts.orderBy && self.opts.orderBy.hasOwnProperty('ascending') ? self.opts.orderBy.ascending : true
  };

  if (typeof self.$store.state[self.name] !== 'undefined') {
    return (0, _merge["default"])(true, self.$store.state[self.name], state);
  }

  return state;
}

/***/ }),
/* 1724 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-tables-2/compiled/v-client-table.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vuex = _interopRequireDefault(__webpack_require__(/*! ./state/vuex */ 711));

var _normal = _interopRequireDefault(__webpack_require__(/*! ./state/normal */ 710));

var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

var _table = _interopRequireDefault(__webpack_require__(/*! ./table */ 712));

var _data2 = _interopRequireDefault(__webpack_require__(/*! ./state/data */ 709));

var _resizeableColumns = _interopRequireDefault(__webpack_require__(/*! ./helpers/resizeable-columns */ 704));

var _VtClientTable = _interopRequireDefault(__webpack_require__(/*! ./components/VtClientTable */ 1586));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _data = __webpack_require__(/*! ./mixins/data */ 707);

var _created = __webpack_require__(/*! ./mixins/created */ 706);

var provide = __webpack_require__(/*! ./mixins/provide */ 708);

var themes = {
  bootstrap3: __webpack_require__(/*! ./themes/bootstrap3 */ 713)(),
  bootstrap4: __webpack_require__(/*! ./themes/bootstrap4 */ 714)(),
  bulma: __webpack_require__(/*! ./themes/bulma */ 715)()
};

exports.install = function (Vue, globalOptions, useVuex) {
  var theme = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "bootstrap3";
  var componentsOverride = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var client = _merge["default"].recursive(true, (0, _table["default"])(), {
    name: "r-l-client-table",
    render: __webpack_require__(/*! ./components/renderless/RLDataTable */ 701),
    provide: provide,
    props: {
      columns: {
        type: Array,
        required: true
      },
      data: {
        type: Array,
        required: true
      },
      name: {
        type: String,
        required: false
      },
      options: {
        type: Object,
        required: false,
        "default": function _default() {
          return {};
        }
      }
    },
    created: function created() {
      _created(this);

      if (this.opts.toMomentFormat) this.transformDateStringsToMoment();

      if (!this.vuex) {
        this.initOrderBy();
        this.query = this.initQuery();
        this.customQueries = this.initCustomFilters();
      }
    },
    mounted: function mounted() {
      var _this = this;

      this._setFiltersDOM(this.query);

      if (this.opts.resizableColumns) {
        (0, _resizeableColumns["default"])(this.$el.querySelector("table"), this.hasChildRow, this.opts.childRowTogglerFirst);
      } // this._setColumnsDropdownCloseListener();


      if (!this.vuex) {
        this.registerClientFilters();
        if (this.options.initialPage) this.setPage(this.options.initialPage);
      }

      if (this.opts.groupBy && !this.opts.orderBy) {
        this.orderBy.column = this.opts.groupBy;
      }

      this.loadState();

      if (this.hasDateFilters()) {
        this.initDateFilters();
      } // listen for data being removed
      // and nav to last page if current page is greater than total pages


      this.$watch('data', function () {
        if (_this.page > _this.totalPages) {
          _this.setPage(_this.totalPages);
        }

        if (_this.vuex) {
          _this.commit('SET_CLIENT_DATA', _this.data);
        }
      });
    },
    model: {
      prop: "data"
    },
    data: function data() {
      return _merge["default"].recursive(_data(), {
        source: "client",
        loading: false,
        theme: typeof theme === 'string' ? themes[theme] : theme(),
        globalOptions: globalOptions,
        componentsOverride: componentsOverride,
        currentlySorting: {},
        time: Date.now()
      }, (0, _data2["default"])(useVuex, "client", this.options.initialPage));
    },
    computed: {
      q: __webpack_require__(/*! ./computed/q */ 1635),
      customQ: __webpack_require__(/*! ./computed/custom-q */ 1625),
      totalPages: __webpack_require__(/*! ./computed/total-pages */ 702),
      filteredData: __webpack_require__(/*! ./computed/filtered-data */ 1628),
      hasMultiSort: function hasMultiSort() {
        return this.opts.clientMultiSorting;
      }
    },
    methods: {
      transformDateStringsToMoment: __webpack_require__(/*! ./methods/transform-date-strings-to-moment */ 1715),
      registerClientFilters: __webpack_require__(/*! ./methods/register-client-filters */ 1686),
      search: __webpack_require__(/*! ./methods/client-search */ 1649),
      defaultSort: __webpack_require__(/*! ./methods/default-sort */ 1653),
      getGroupSlot: __webpack_require__(/*! ./methods/get-group-slot */ 1661),
      toggleGroup: function toggleGroup(group, e) {
        e.stopPropagation();
        var i = this.collapsedGroups.indexOf(group);

        if (i >= 0) {
          this.collapsedGroups.splice(i, 1);
        } else {
          this.collapsedGroups.push(group);
        }
      },
      groupToggleIcon: function groupToggleIcon(group) {
        var cls = this.opts.sortIcon.base + " ";
        cls += this.collapsedGroups.indexOf(group) > -1 ? this.opts.sortIcon.down : this.opts.sortIcon.up;
        return cls;
      },
      loadState: function loadState() {
        if (!this.opts.saveState) return;

        if (!this.storage.getItem(this.stateKey)) {
          this.initState();
          this.activeState = true;
          return;
        }

        var state = JSON.parse(this.storage.getItem(this.stateKey));
        if (this.opts.filterable) this.setFilter(state.query);
        this.setOrder(state.orderBy.column, state.orderBy.ascending);

        if (this.vuex) {
          this.commit("SET_LIMIT", parseInt(state.perPage));
        } else {
          this.limit = parseInt(state.perPage);
        }

        this.setPage(state.page);
        this.activeState = true;

        if (state.userControlsColumns) {
          this.userColumnsDisplay = state.userColumnsDisplay;
          this.userControlsColumns = state.userControlsColumns;
        } // TODO: Custom Queries

      }
    }
  });

  var state = useVuex ? (0, _vuex["default"])() : (0, _normal["default"])();
  client = _merge["default"].recursive(client, state);
  Vue.component("r-l-client-table", client);
  Vue.component("v-client-table", _VtClientTable["default"]);
  return _VtClientTable["default"];
};

/***/ }),
/* 1725 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./~/vue-tables-2/compiled/v-server-table.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _merge = _interopRequireDefault(__webpack_require__(/*! merge */ 57));

var _data2 = _interopRequireDefault(__webpack_require__(/*! ./state/data */ 709));

var _vuex = _interopRequireDefault(__webpack_require__(/*! ./state/vuex */ 711));

var _normal = _interopRequireDefault(__webpack_require__(/*! ./state/normal */ 710));

var _table = _interopRequireDefault(__webpack_require__(/*! ./table */ 712));

var _resizeableColumns = _interopRequireDefault(__webpack_require__(/*! ./helpers/resizeable-columns */ 704));

var _VtServerTable = _interopRequireDefault(__webpack_require__(/*! ./components/VtServerTable */ 1593));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _data = __webpack_require__(/*! ./mixins/data */ 707);

var _created = __webpack_require__(/*! ./mixins/created */ 706);

var provide = __webpack_require__(/*! ./mixins/provide */ 708);

var themes = {
  bootstrap3: __webpack_require__(/*! ./themes/bootstrap3 */ 713)(),
  bootstrap4: __webpack_require__(/*! ./themes/bootstrap4 */ 714)(),
  bulma: __webpack_require__(/*! ./themes/bulma */ 715)()
};

exports.install = function (Vue, globalOptions, useVuex) {
  var theme = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "bootstrap3";
  var componentsOverride = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var state = useVuex ? (0, _vuex["default"])("server") : (0, _normal["default"])();

  var server = _merge["default"].recursive(true, (0, _table["default"])(), {
    name: "r-l-server-table",
    render: __webpack_require__(/*! ./components/renderless/RLDataTable */ 701),
    props: {
      columns: {
        type: Array,
        required: true
      },
      url: {
        type: String
      },
      name: {
        type: String,
        required: false
      },
      options: {
        type: Object,
        required: false,
        "default": function _default() {
          return {};
        }
      }
    },
    provide: provide,
    created: function created() {
      if (!this.opts.requestFunction && !this.url) {
        throw 'vue-tables-2: you must provide either a "url" prop or a custom request function. Aborting';
      }

      _created(this);

      if (!this.vuex) {
        this.query = this.initQuery();
        this.initOrderBy();
        this.customQueries = this.initCustomFilters();
      }

      if (this.opts.sendInitialRequest) {
        this.loadState();
        this.getData(true).then(function (response) {
          if (typeof response === 'undefined') return;
          this.setData(response);
          this.loading = false;

          if (this.hasDateFilters()) {
            setTimeout(function () {
              this.initDateFilters();
            }.bind(this), 0);
          }
        }.bind(this));
      } else {
        this.loading = false;
      }
    },
    mounted: function mounted() {
      this._setFiltersDOM(this.query);

      if (this.opts.resizableColumns) {
        (0, _resizeableColumns["default"])(this.$el.querySelector("table"), this.hasChildRow, this.opts.childRowTogglerFirst, this.opts.resizableColumns);
      } // this._setColumnsDropdownCloseListener();


      if (this.vuex) return;
      this.registerServerFilters();
      if (this.options.initialPage) this.setPage(this.options.initialPage, true);
    },
    data: function data() {
      return _merge["default"].recursive(_data(), {
        source: "server",
        loading: true,
        initialRequestSent: false,
        lastKeyStrokeAt: false,
        globalOptions: globalOptions,
        componentsOverride: componentsOverride,
        theme: typeof theme === 'string' ? themes[theme] : theme()
      }, (0, _data2["default"])(useVuex, "server", this.options.initialPage));
    },
    methods: {
      refresh: __webpack_require__(/*! ./methods/refresh */ 1685),
      getData: __webpack_require__(/*! ./methods/get-data */ 1660),
      setData: __webpack_require__(/*! ./methods/set-data */ 1697),
      serverSearch: __webpack_require__(/*! ./methods/server-search */ 705),
      registerServerFilters: __webpack_require__(/*! ./methods/register-server-filters */ 1687),
      getRequestParams: __webpack_require__(/*! ./methods/get-request-params */ 1667),
      setRequestParams: __webpack_require__(/*! ./methods/set-request-params */ 1705),
      loadState: function loadState() {
        var _this = this;

        if (!this.opts.saveState) return;

        if (!this.storage.getItem(this.stateKey)) {
          this.initState();
          this.activeState = true;
          return;
        }

        var state = JSON.parse(this.storage.getItem(this.stateKey));

        if (this.vuex) {
          this.commit("SET_STATE", {
            query: state.query,
            customQueries: state.customQueries,
            page: state.page,
            limit: parseInt(state.perPage),
            orderBy: state.orderBy
          });
        } else {
          this.page = state.page;
          this.query = state.query;
          this.customQueries = state.customQueries;
          this.limit = parseInt(state.perPage);
          this.orderBy = state.orderBy;
        }

        if (!this.opts.pagination.dropdown && this.$refs.pagination) {
          setTimeout(function () {
            _this.$refs.pagination.Page = state.page;
          }, 0);
        }

        if (this.opts.filterable) {
          setTimeout(function () {
            _this._setFiltersDOM(state.query);
          }, 0);
        }

        this.activeState = true;
      }
    },
    watch: {
      url: function url() {
        this.refresh();
      }
    },
    computed: {
      totalPages: __webpack_require__(/*! ./computed/total-pages */ 702),
      filteredQuery: __webpack_require__(/*! ./computed/filtered-query */ 1629),
      hasMultiSort: function hasMultiSort() {
        return this.opts.serverMultiSorting;
      }
    }
  }, state);

  Vue.component("r-l-server-table", server);
  Vue.component("v-server-table", _VtServerTable["default"]);
  return _VtServerTable["default"];
};

/***/ }),
/* 1726 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./~/vue2-dropzone/dist/vue2-dropzone.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["vue2-dropzone"]=t():e["vue2-dropzone"]=t()}(this,function(){return function(e){function t(n){if(i[n])return i[n].exports;var o=i[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var i={};return t.m=e,t.c=i,t.p="",t(0)}([function(e,t,i){var n,o,r={};i(8),n=i(2),o=i(6),e.exports=n||{},e.exports.__esModule&&(e.exports=e.exports.default);var s="function"==typeof e.exports?e.exports.options||(e.exports.options={}):e.exports;o&&(s.template=o),s.computed||(s.computed={}),Object.keys(r).forEach(function(e){var t=r[e];s.computed[e]=function(){return t}})},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var i=this[t];i[2]?e.push("@media "+i[2]+"{"+i[1]+"}"):e.push(i[1])}return e.join("")},e.i=function(t,i){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},o=0;o<this.length;o++){var r=this[o][0];"number"==typeof r&&(n[r]=!0)}for(o=0;o<t.length;o++){var s=t[o];"number"==typeof s[0]&&n[s[0]]||(i&&!s[2]?s[2]=i:i&&(s[2]="("+s[2]+") and ("+i+")"),e.push(s))}},e}},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={props:{id:{type:String,required:!0},url:{type:String,required:!0},clickable:{type:[Boolean,String],default:!0},confirm:{type:Function,default:void 0},paramName:{type:String,default:"file"},acceptedFileTypes:{type:String},thumbnailHeight:{type:Number,default:200},thumbnailWidth:{type:Number,default:200},showRemoveLink:{type:Boolean,default:!0},maxFileSizeInMB:{type:Number,default:2},maxNumberOfFiles:{type:Number,default:5},autoProcessQueue:{type:Boolean,default:!0},useFontAwesome:{type:Boolean,default:!1},headers:{type:Object},language:{type:Object,default:function(){return{}}},previewTemplate:{type:Function,default:function(e){return'\n                    <div class="dz-preview dz-file-preview">\n                        <div class="dz-image" style="width: '+e.thumbnailWidth+"px;height: "+e.thumbnailHeight+'px">\n                        <img data-dz-thumbnail /></div>\n                        <div class="dz-details">\n                            <div class="dz-size"><span data-dz-size></span></div>\n                            <div class="dz-filename"><span data-dz-name></span></div>\n                        </div>\n                        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n                        <div class="dz-error-message"><span data-dz-errormessage></span></div>\n                        <div class="dz-success-mark">'+e.doneIcon+'</div>\n                        <div class="dz-error-mark">'+e.errorIcon+"</div>\n                    </div>\n                "}},useCustomDropzoneOptions:{type:Boolean,default:!1},dropzoneOptions:{type:Object,default:function(){return{}}},resizeWidth:{type:Number,default:null},resizeHeight:{type:Number,default:null},resizeMimeType:{type:String,default:null},resizeQuality:{type:Number,default:.8},resizeMethod:{type:String,default:"contain"},uploadMultiple:{type:Boolean,default:!1},duplicateCheck:{type:Boolean,default:!1},parallelUploads:{type:Number,default:2},timeout:{type:Number,default:3e4},method:{type:String,default:"POST"},withCredentials:{type:Boolean,default:!1},capture:{type:String,default:null},hiddenInputContainer:{type:String,default:"body"}},methods:{manuallyAddFile:function(e,t,i,n,o){this.dropzone.emit("addedfile",e),this.dropzone.emit("thumbnail",e,t),this.dropzone.createThumbnailFromUrl(e,t,i,n),this.dropzone.emit("complete",e),"undefined"!=typeof o.dontSubstractMaxFiles&&o.dontSubstractMaxFiles||(this.dropzone.options.maxFiles=this.dropzone.options.maxFiles-1),"undefined"!=typeof o.addToFiles&&o.addToFiles&&this.dropzone.files.push(e),this.$emit("vdropzone-file-added-manually",e)},setOption:function(e,t){this.dropzone.options[e]=t},removeAllFiles:function(){this.dropzone.removeAllFiles(!0)},processQueue:function(){var e=this.dropzone;this.dropzone.processQueue(),this.dropzone.on("success",function(){e.options.autoProcessQueue=!0}),this.dropzone.on("queuecomplete",function(){e.options.autoProcessQueue=!1})},removeFile:function(e){this.dropzone.removeFile(e)},getAcceptedFiles:function(){return this.dropzone.getAcceptedFiles()},getRejectedFiles:function(){return this.dropzone.getRejectedFiles()},getUploadingFiles:function(){return this.dropzone.getUploadingFiles()},getQueuedFiles:function(){return this.dropzone.getQueuedFiles()},getProp:function(e,t){return this.useCustomDropzoneOptions&&void 0!==t&&null!==t&&""!==t?t:e}},computed:{languageSettings:function(){var e={dictDefaultMessage:"<br>Drop files here to upload",dictCancelUpload:"Cancel upload",dictCancelUploadConfirmation:"Are you sure you want to cancel this upload?",dictFallbackMessage:"Your browser does not support drag and drop file uploads.",dictFallbackText:"Please use the fallback form below to upload your files like in the olden days.",dictFileTooBig:"File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",dictInvalidFileType:"You can't upload files of this type.",dictMaxFilesExceeded:"You can not upload any more files. (max: {{maxFiles}})",dictRemoveFile:"Remove",dictRemoveFileConfirmation:null,dictResponseError:"Server responded with {{statusCode}} code."};for(var t in this.language)e[t]=this.language[t];if(this.useCustomDropzoneOptions&&this.dropzoneOptions.language)for(var i in this.dropzoneOptions.language)e[i]=this.dropzoneOptions.language[i];return e},cloudIcon:function(){return this.useFontAwesome?'<i class="fa fa-cloud-upload"></i>':'<i class="material-icons">cloud_upload</i>'},doneIcon:function(){return this.useFontAwesome?'<i class="fa fa-check"></i>':' <i class="material-icons">done</i>'},errorIcon:function(){return this.useFontAwesome?'<i class="fa fa-close"></i>':' <i class="material-icons">error</i>'}},mounted:function(){if(!this.$isServer){var e=i(5);e.autoDiscover=!1,this.confirm&&(e.confirm=this.getProp(this.confirm,this.dropzoneOptions.confirm));var t=document.getElementById(this.id);this.dropzone=new e(t,{clickable:this.getProp(this.clickable,this.dropzoneOptions.clickable),paramName:this.getProp(this.paramName,this.dropzoneOptions.paramName),thumbnailWidth:this.getProp(this.thumbnailWidth,this.dropzoneOptions.thumbnailWidth),thumbnailHeight:this.getProp(this.thumbnailHeight,this.dropzoneOptions.thumbnailHeight),maxFiles:this.getProp(this.maxNumberOfFiles,this.dropzoneOptions.maxNumberOfFiles),maxFilesize:this.getProp(this.maxFileSizeInMB,this.dropzoneOptions.maxFileSizeInMB),addRemoveLinks:this.getProp(this.showRemoveLink,this.dropzoneOptions.showRemoveLink),acceptedFiles:this.getProp(this.acceptedFileTypes,this.dropzoneOptions.acceptedFileTypes),autoProcessQueue:this.getProp(this.autoProcessQueue,this.dropzoneOptions.autoProcessQueue),headers:this.getProp(this.headers,this.dropzoneOptions.headers),previewTemplate:this.previewTemplate(this),dictDefaultMessage:this.cloudIcon+this.languageSettings.dictDefaultMessage,dictCancelUpload:this.languageSettings.dictCancelUpload,dictCancelUploadConfirmation:this.languageSettings.dictCancelUploadConfirmation,dictFallbackMessage:this.languageSettings.dictFallbackMessage,dictFallbackText:this.languageSettings.dictFallbackText,dictFileTooBig:this.languageSettings.dictFileTooBig,dictInvalidFileType:this.languageSettings.dictInvalidFileType,dictMaxFilesExceeded:this.languageSettings.dictMaxFilesExceeded,dictRemoveFile:this.languageSettings.dictRemoveFile,dictRemoveFileConfirmation:this.languageSettings.dictRemoveFileConfirmation,dictResponseError:this.languageSettings.dictResponseError,resizeWidth:this.getProp(this.resizeWidth,this.dropzoneOptions.resizeWidth),resizeHeight:this.getProp(this.resizeHeight,this.dropzoneOptions.resizeHeight),resizeMimeType:this.getProp(this.resizeMimeType,this.dropzoneOptions.resizeMimeType),resizeQuality:this.getProp(this.resizeQuality,this.dropzoneOptions.resizeQuality),resizeMethod:this.getProp(this.resizeMethod,this.dropzoneOptions.resizeMethod),uploadMultiple:this.getProp(this.uploadMultiple,this.dropzoneOptions.uploadMultiple),parallelUploads:this.getProp(this.parallelUploads,this.dropzoneOptions.parallelUploads),timeout:this.getProp(this.timeout,this.dropzoneOptions.timeout),method:this.getProp(this.method,this.dropzoneOptions.method),capture:this.getProp(this.capture,this.dropzoneOptions.capture),hiddenInputContainer:this.getProp(this.hiddenInputContainer,this.dropzoneOptions.hiddenInputContainer),withCredentials:this.getProp(this.withCredentials,this.dropzoneOptions.withCredentials)});var n=this;this.dropzone.on("thumbnail",function(e,t){n.$emit("vdropzone-thumbnail",e,t)}),this.dropzone.on("addedfile",function(e){if(n.duplicateCheck&&this.files.length){var t,i;for(t=0,i=this.files.length;t<i-1;t++)this.files[t].name===e.name&&(this.removeFile(e),n.$emit("duplicate-file",e))}n.$emit("vdropzone-file-added",e)}),this.dropzone.on("addedfiles",function(e){n.$emit("vdropzone-files-added",e)}),this.dropzone.on("removedfile",function(e){n.$emit("vdropzone-removed-file",e)}),this.dropzone.on("success",function(e,t){n.$emit("vdropzone-success",e,t)}),this.dropzone.on("successmultiple",function(e,t){n.$emit("vdropzone-success-multiple",e,t)}),this.dropzone.on("error",function(e,t,i){n.$emit("vdropzone-error",e,t,i)}),this.dropzone.on("sending",function(e,t,i){n.$emit("vdropzone-sending",e,t,i)}),this.dropzone.on("sendingmultiple",function(e,t,i){n.$emit("vdropzone-sending-multiple",e,t,i)}),this.dropzone.on("queuecomplete",function(e,t,i){n.$emit("vdropzone-queue-complete",e,t,i)}),this.dropzone.on("totaluploadprogress",function(e,t,i){n.$emit("vdropzone-total-upload-progress",e,t,i)}),n.$emit("vdropzone-mounted")}},beforeDestroy:function(){this.dropzone.destroy()}}},function(e,t,i){t=e.exports=i(1)(),t.push([e.id,'@-webkit-keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%,70%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-40px);transform:translateY(-40px)}}@keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%,70%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-40px);transform:translateY(-40px)}}@-webkit-keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);transform:scale(1)}}.dropzone,.dropzone *{box-sizing:border-box}.dropzone{min-height:150px;border:2px solid rgba(0,0,0,.3);background:#fff;padding:20px}.dropzone.dz-clickable{cursor:pointer}.dropzone.dz-clickable *{cursor:default}.dropzone.dz-clickable .dz-message,.dropzone.dz-clickable .dz-message *{cursor:pointer}.dropzone.dz-started .dz-message{display:none}.dropzone.dz-drag-hover{border-style:solid}.dropzone.dz-drag-hover .dz-message{opacity:.5}.dropzone .dz-message{text-align:center;margin:2em 0}.dropzone .dz-preview{position:relative;display:inline-block;vertical-align:top;margin:16px;min-height:100px}.dropzone .dz-preview:hover{z-index:1000}.dropzone .dz-preview.dz-file-preview .dz-image{border-radius:20px;background:#999;background:linear-gradient(180deg,#eee,#ddd)}.dropzone .dz-preview.dz-file-preview .dz-details{opacity:1}.dropzone .dz-preview.dz-image-preview{background:#fff}.dropzone .dz-preview.dz-image-preview .dz-details{transition:opacity .2s linear}.dropzone .dz-preview .dz-remove{font-size:14px;text-align:center;display:block;cursor:pointer;border:none}.dropzone .dz-preview .dz-remove:hover{text-decoration:underline}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview .dz-details{z-index:20;position:absolute;top:0;left:0;opacity:0;font-size:13px;min-width:100%;max-width:100%;padding:2em 1em;text-align:center;color:rgba(0,0,0,.9);line-height:150%}.dropzone .dz-preview .dz-details .dz-size{margin-bottom:1em;font-size:16px}.dropzone .dz-preview .dz-details .dz-filename{white-space:nowrap}.dropzone .dz-preview .dz-details .dz-filename:hover span{border:1px solid hsla(0,0%,78%,.8);background-color:hsla(0,0%,100%,.8)}.dropzone .dz-preview .dz-details .dz-filename:not(:hover){overflow:hidden;text-overflow:ellipsis}.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:1px solid transparent}.dropzone .dz-preview .dz-details .dz-filename span,.dropzone .dz-preview .dz-details .dz-size span{background-color:hsla(0,0%,100%,.4);padding:0 .4em;border-radius:3px}.dropzone .dz-preview:hover .dz-image img{-webkit-transform:scale(1.05);transform:scale(1.05);-webkit-filter:blur(8px);filter:blur(8px)}.dropzone .dz-preview .dz-image{border-radius:20px;overflow:hidden;width:120px;height:120px;position:relative;display:block;z-index:10}.dropzone .dz-preview .dz-image img{display:block}.dropzone .dz-preview.dz-success .dz-success-mark{-webkit-animation:passing-through 3s cubic-bezier(.77,0,.175,1);animation:passing-through 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview.dz-error .dz-error-mark{opacity:1;-webkit-animation:slide-in 3s cubic-bezier(.77,0,.175,1);animation:slide-in 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{pointer-events:none;opacity:0;z-index:500;position:absolute;display:block;top:50%;left:50%;margin-left:-27px;margin-top:-27px}.dropzone .dz-preview .dz-error-mark svg,.dropzone .dz-preview .dz-success-mark svg{display:block;width:54px;height:54px}.dropzone .dz-preview.dz-processing .dz-progress{opacity:1;transition:all .2s linear}.dropzone .dz-preview.dz-complete .dz-progress{opacity:0;transition:opacity .4s ease-in}.dropzone .dz-preview:not(.dz-processing) .dz-progress{-webkit-animation:pulse 6s ease infinite;animation:pulse 6s ease infinite}.dropzone .dz-preview .dz-progress{opacity:1;z-index:1000;pointer-events:none;position:absolute;height:16px;left:50%;top:50%;margin-top:-8px;width:80px;margin-left:-40px;background:hsla(0,0%,100%,.9);-webkit-transform:scale(1);border-radius:8px;overflow:hidden}.dropzone .dz-preview .dz-progress .dz-upload{background:#333;background:linear-gradient(180deg,#666,#444);position:absolute;top:0;left:0;bottom:0;width:0;transition:width .3s ease-in-out}.dropzone .dz-preview.dz-error .dz-error-message{display:block}.dropzone .dz-preview.dz-error:hover .dz-error-message{opacity:1;pointer-events:auto}.dropzone .dz-preview .dz-error-message{pointer-events:none;z-index:1000;position:absolute;display:block;display:none;opacity:0;transition:opacity .3s ease;border-radius:8px;font-size:13px;top:130px;left:-10px;width:140px;background:#be2626;background:linear-gradient(180deg,#be2626,#a92222);padding:.5em 1.2em;color:#fff}.dropzone .dz-preview .dz-error-message:after{content:"";position:absolute;top:-6px;left:64px;width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #be2626}',""])},function(e,t,i){t=e.exports=i(1)(),t.i(i(3),""),t.push([e.id,".vue-dropzone{border:2px solid #e5e5e5;font-family:Arial,sans-serif;letter-spacing:.2px;color:#777;transition:background-color .2s linear}.vue-dropzone:hover{background-color:#f6f6f6}.vue-dropzone i{color:#ccc}.vue-dropzone .dz-preview .dz-image{border-radius:0}.vue-dropzone .dz-preview .dz-image:hover img{-webkit-transform:none;transform:none;-webkit-filter:none}.vue-dropzone .dz-preview .dz-details{bottom:0;top:0;color:#fff;background-color:rgba(33,150,243,.8);transition:opacity .2s linear;text-align:left}.vue-dropzone .dz-preview .dz-details .dz-filename span,.vue-dropzone .dz-preview .dz-details .dz-size span{background-color:transparent}.vue-dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:none}.vue-dropzone .dz-preview .dz-details .dz-filename:hover span{background-color:transparent;border:none}.vue-dropzone .dz-preview .dz-progress .dz-upload{background:#ccc}.vue-dropzone .dz-preview .dz-remove{position:absolute;z-index:30;color:#fff;margin-left:15px;padding:10px;top:inherit;bottom:15px;border:2px solid #fff;text-decoration:none;text-transform:uppercase;font-size:.8rem;font-weight:800;letter-spacing:1.1px;opacity:0}.vue-dropzone .dz-preview:hover .dz-remove{opacity:1}.vue-dropzone .dz-preview .dz-error-mark,.vue-dropzone .dz-preview .dz-success-mark{margin-left:auto!important;margin-top:auto!important;width:100%!important;top:35%!important;left:0}.vue-dropzone .dz-preview .dz-error-mark i,.vue-dropzone .dz-preview .dz-success-mark i{color:#fff!important;font-size:5rem!important}.vue-dropzone .dz-preview .dz-error-message{top:75%;left:15%}",""])},function(e,t,i){(function(e){(function(){var t,i,n,o,r,s,a,l,d,p=[].slice,u=function(e,t){function i(){this.constructor=e}for(var n in t)c.call(t,n)&&(e[n]=t[n]);return i.prototype=t.prototype,e.prototype=new i,e.__super__=t.prototype,e},c={}.hasOwnProperty;l=function(){},i=function(){function e(){}return e.prototype.addEventListener=e.prototype.on,e.prototype.on=function(e,t){return this._callbacks=this._callbacks||{},this._callbacks[e]||(this._callbacks[e]=[]),this._callbacks[e].push(t),this},e.prototype.emit=function(){var e,t,i,n,o,r;if(n=arguments[0],e=2<=arguments.length?p.call(arguments,1):[],this._callbacks=this._callbacks||{},i=this._callbacks[n])for(o=0,r=i.length;o<r;o++)t=i[o],t.apply(this,e);return this},e.prototype.removeListener=e.prototype.off,e.prototype.removeAllListeners=e.prototype.off,e.prototype.removeEventListener=e.prototype.off,e.prototype.off=function(e,t){var i,n,o,r,s;if(!this._callbacks||0===arguments.length)return this._callbacks={},this;if(n=this._callbacks[e],!n)return this;if(1===arguments.length)return delete this._callbacks[e],this;for(o=r=0,s=n.length;r<s;o=++r)if(i=n[o],i===t){n.splice(o,1);break}return this},e}(),t=function(e){function t(e,i){var n,r,s;if(this.element=e,this.version=t.version,this.defaultOptions.previewTemplate=this.defaultOptions.previewTemplate.replace(/\n*/g,""),this.clickableElements=[],this.listeners=[],this.files=[],"string"==typeof this.element&&(this.element=document.querySelector(this.element)),!this.element||null==this.element.nodeType)throw new Error("Invalid dropzone element.");if(this.element.dropzone)throw new Error("Dropzone already attached.");if(t.instances.push(this),this.element.dropzone=this,n=null!=(s=t.optionsForElement(this.element))?s:{},this.options=o({},this.defaultOptions,n,null!=i?i:{}),this.options.forceFallback||!t.isBrowserSupported())return this.options.fallback.call(this);if(null==this.options.url&&(this.options.url=this.element.getAttribute("action")),!this.options.url)throw new Error("No URL provided.");if(this.options.acceptedFiles&&this.options.acceptedMimeTypes)throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");this.options.acceptedMimeTypes&&(this.options.acceptedFiles=this.options.acceptedMimeTypes,delete this.options.acceptedMimeTypes),null!=this.options.renameFilename&&(this.options.renameFile=function(e){return function(t){return e.options.renameFilename.call(e,t.name,t)}}(this)),this.options.method=this.options.method.toUpperCase(),(r=this.getExistingFallback())&&r.parentNode&&r.parentNode.removeChild(r),this.options.previewsContainer!==!1&&(this.options.previewsContainer?this.previewsContainer=t.getElement(this.options.previewsContainer,"previewsContainer"):this.previewsContainer=this.element),this.options.clickable&&(this.options.clickable===!0?this.clickableElements=[this.element]:this.clickableElements=t.getElements(this.options.clickable,"clickable")),this.init()}var o,r;return u(t,e),t.prototype.Emitter=i,t.prototype.events=["drop","dragstart","dragend","dragenter","dragover","dragleave","addedfile","addedfiles","removedfile","thumbnail","error","errormultiple","processing","processingmultiple","uploadprogress","totaluploadprogress","sending","sendingmultiple","success","successmultiple","canceled","canceledmultiple","complete","completemultiple","reset","maxfilesexceeded","maxfilesreached","queuecomplete"],t.prototype.defaultOptions={url:null,method:"post",withCredentials:!1,timeout:3e4,parallelUploads:2,uploadMultiple:!1,maxFilesize:256,paramName:"file",createImageThumbnails:!0,maxThumbnailFilesize:10,thumbnailWidth:120,thumbnailHeight:120,thumbnailMethod:"crop",resizeWidth:null,resizeHeight:null,resizeMimeType:null,resizeQuality:.8,resizeMethod:"contain",filesizeBase:1e3,maxFiles:null,params:{},headers:null,clickable:!0,ignoreHiddenFiles:!0,acceptedFiles:null,acceptedMimeTypes:null,autoProcessQueue:!0,autoQueue:!0,addRemoveLinks:!1,previewsContainer:null,hiddenInputContainer:"body",capture:null,renameFilename:null,renameFile:null,forceFallback:!1,dictDefaultMessage:"Drop files here to upload",dictFallbackMessage:"Your browser does not support drag'n'drop file uploads.",dictFallbackText:"Please use the fallback form below to upload your files like in the olden days.",dictFileTooBig:"File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",dictInvalidFileType:"You can't upload files of this type.",dictResponseError:"Server responded with {{statusCode}} code.",dictCancelUpload:"Cancel upload",dictCancelUploadConfirmation:"Are you sure you want to cancel this upload?",dictRemoveFile:"Remove file",dictRemoveFileConfirmation:null,dictMaxFilesExceeded:"You can not upload any more files.",dictFileSizeUnits:{tb:"TB",gb:"GB",mb:"MB",kb:"KB",b:"b"},init:function(){return l},accept:function(e,t){return t()},fallback:function(){var e,i,n,o,r,s;for(this.element.className=this.element.className+" dz-browser-not-supported",r=this.element.getElementsByTagName("div"),i=0,n=r.length;i<n;i++)e=r[i],/(^| )dz-message($| )/.test(e.className)&&(o=e,e.className="dz-message");return o||(o=t.createElement('<div class="dz-message"><span></span></div>'),this.element.appendChild(o)),s=o.getElementsByTagName("span")[0],s&&(null!=s.textContent?s.textContent=this.options.dictFallbackMessage:null!=s.innerText&&(s.innerText=this.options.dictFallbackMessage)),this.element.appendChild(this.getFallbackForm())},resize:function(e,t,i,n){var o,r,s;if(o={srcX:0,srcY:0,srcWidth:e.width,srcHeight:e.height},r=e.width/e.height,null==t&&null==i?(t=o.srcWidth,i=o.srcHeight):null==t?t=i*r:null==i&&(i=t/r),t=Math.min(t,o.srcWidth),i=Math.min(i,o.srcHeight),s=t/i,o.srcWidth>t||o.srcHeight>i)if("crop"===n)r>s?(o.srcHeight=e.height,o.srcWidth=o.srcHeight*s):(o.srcWidth=e.width,o.srcHeight=o.srcWidth/s);else{if("contain"!==n)throw new Error("Unknown resizeMethod '"+n+"'");r>s?i=t/r:t=i*r}return o.srcX=(e.width-o.srcWidth)/2,o.srcY=(e.height-o.srcHeight)/2,o.trgWidth=t,o.trgHeight=i,o},transformFile:function(e,t){return(this.options.resizeWidth||this.options.resizeHeight)&&e.type.match(/image.*/)?this.resizeImage(e,this.options.resizeWidth,this.options.resizeHeight,this.options.resizeMethod,t):t(e)},previewTemplate:'<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Check</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Error</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>',drop:function(e){return this.element.classList.remove("dz-drag-hover")},dragstart:l,dragend:function(e){return this.element.classList.remove("dz-drag-hover")},dragenter:function(e){return this.element.classList.add("dz-drag-hover")},dragover:function(e){return this.element.classList.add("dz-drag-hover")},dragleave:function(e){return this.element.classList.remove("dz-drag-hover")},paste:l,reset:function(){return this.element.classList.remove("dz-started")},addedfile:function(e){var i,n,o,r,s,a,l,d,p,u,c,h,f;if(this.element===this.previewsContainer&&this.element.classList.add("dz-started"),this.previewsContainer){for(e.previewElement=t.createElement(this.options.previewTemplate.trim()),e.previewTemplate=e.previewElement,this.previewsContainer.appendChild(e.previewElement),d=e.previewElement.querySelectorAll("[data-dz-name]"),i=0,r=d.length;i<r;i++)l=d[i],l.textContent=e.name;for(p=e.previewElement.querySelectorAll("[data-dz-size]"),n=0,s=p.length;n<s;n++)l=p[n],l.innerHTML=this.filesize(e.size);for(this.options.addRemoveLinks&&(e._removeLink=t.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>'+this.options.dictRemoveFile+"</a>"),e.previewElement.appendChild(e._removeLink)),c=function(i){return function(n){return n.preventDefault(),n.stopPropagation(),e.status===t.UPLOADING?t.confirm(i.options.dictCancelUploadConfirmation,function(){return i.removeFile(e)}):i.options.dictRemoveFileConfirmation?t.confirm(i.options.dictRemoveFileConfirmation,function(){return i.removeFile(e)}):i.removeFile(e)}}(this),u=e.previewElement.querySelectorAll("[data-dz-remove]"),f=[],o=0,a=u.length;o<a;o++)h=u[o],f.push(h.addEventListener("click",c));return f}},removedfile:function(e){var t;return e.previewElement&&null!=(t=e.previewElement)&&t.parentNode.removeChild(e.previewElement),this._updateMaxFilesReachedClass()},thumbnail:function(e,t){var i,n,o,r;if(e.previewElement){for(e.previewElement.classList.remove("dz-file-preview"),o=e.previewElement.querySelectorAll("[data-dz-thumbnail]"),i=0,n=o.length;i<n;i++)r=o[i],r.alt=e.name,r.src=t;return setTimeout(function(t){return function(){return e.previewElement.classList.add("dz-image-preview")}}(this),1)}},error:function(e,t){var i,n,o,r,s;if(e.previewElement){for(e.previewElement.classList.add("dz-error"),"String"!=typeof t&&t.error&&(t=t.error),r=e.previewElement.querySelectorAll("[data-dz-errormessage]"),s=[],i=0,n=r.length;i<n;i++)o=r[i],s.push(o.textContent=t);return s}},errormultiple:l,processing:function(e){if(e.previewElement&&(e.previewElement.classList.add("dz-processing"),e._removeLink))return e._removeLink.textContent=this.options.dictCancelUpload},processingmultiple:l,uploadprogress:function(e,t,i){var n,o,r,s,a;if(e.previewElement){for(s=e.previewElement.querySelectorAll("[data-dz-uploadprogress]"),a=[],n=0,o=s.length;n<o;n++)r=s[n],"PROGRESS"===r.nodeName?a.push(r.value=t):a.push(r.style.width=t+"%");return a}},totaluploadprogress:l,sending:l,sendingmultiple:l,success:function(e){if(e.previewElement)return e.previewElement.classList.add("dz-success")},successmultiple:l,canceled:function(e){return this.emit("error",e,"Upload canceled.")},canceledmultiple:l,complete:function(e){if(e._removeLink&&(e._removeLink.textContent=this.options.dictRemoveFile),e.previewElement)return e.previewElement.classList.add("dz-complete")},completemultiple:l,maxfilesexceeded:l,maxfilesreached:l,queuecomplete:l,addedfiles:l},o=function(){var e,t,i,n,o,r,s;for(r=arguments[0],o=2<=arguments.length?p.call(arguments,1):[],e=0,i=o.length;e<i;e++){n=o[e];for(t in n)s=n[t],r[t]=s}return r},t.prototype.getAcceptedFiles=function(){var e,t,i,n,o;for(n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],e.accepted&&o.push(e);return o},t.prototype.getRejectedFiles=function(){var e,t,i,n,o;for(n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],e.accepted||o.push(e);return o},t.prototype.getFilesWithStatus=function(e){var t,i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)t=o[i],t.status===e&&r.push(t);return r},t.prototype.getQueuedFiles=function(){return this.getFilesWithStatus(t.QUEUED)},t.prototype.getUploadingFiles=function(){return this.getFilesWithStatus(t.UPLOADING)},t.prototype.getAddedFiles=function(){return this.getFilesWithStatus(t.ADDED)},t.prototype.getActiveFiles=function(){var e,i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)e=o[i],e.status!==t.UPLOADING&&e.status!==t.QUEUED||r.push(e);return r},t.prototype.init=function(){var e,i,n,o,r,s,a;for("form"===this.element.tagName&&this.element.setAttribute("enctype","multipart/form-data"),this.element.classList.contains("dropzone")&&!this.element.querySelector(".dz-message")&&this.element.appendChild(t.createElement('<div class="dz-default dz-message"><span>'+this.options.dictDefaultMessage+"</span></div>")),this.clickableElements.length&&(a=function(e){return function(){return e.hiddenFileInput&&e.hiddenFileInput.parentNode.removeChild(e.hiddenFileInput),e.hiddenFileInput=document.createElement("input"),e.hiddenFileInput.setAttribute("type","file"),(null==e.options.maxFiles||e.options.maxFiles>1)&&e.hiddenFileInput.setAttribute("multiple","multiple"),e.hiddenFileInput.className="dz-hidden-input",null!=e.options.acceptedFiles&&e.hiddenFileInput.setAttribute("accept",e.options.acceptedFiles),null!=e.options.capture&&e.hiddenFileInput.setAttribute("capture",e.options.capture),
e.hiddenFileInput.style.visibility="hidden",e.hiddenFileInput.style.position="absolute",e.hiddenFileInput.style.top="0",e.hiddenFileInput.style.left="0",e.hiddenFileInput.style.height="0",e.hiddenFileInput.style.width="0",document.querySelector(e.options.hiddenInputContainer).appendChild(e.hiddenFileInput),e.hiddenFileInput.addEventListener("change",function(){var t,i,n,o;if(i=e.hiddenFileInput.files,i.length)for(n=0,o=i.length;n<o;n++)t=i[n],e.addFile(t);return e.emit("addedfiles",i),a()})}}(this))(),this.URL=null!=(r=window.URL)?r:window.webkitURL,s=this.events,i=0,n=s.length;i<n;i++)e=s[i],this.on(e,this.options[e]);return this.on("uploadprogress",function(e){return function(){return e.updateTotalUploadProgress()}}(this)),this.on("removedfile",function(e){return function(){return e.updateTotalUploadProgress()}}(this)),this.on("canceled",function(e){return function(t){return e.emit("complete",t)}}(this)),this.on("complete",function(e){return function(t){if(0===e.getAddedFiles().length&&0===e.getUploadingFiles().length&&0===e.getQueuedFiles().length)return setTimeout(function(){return e.emit("queuecomplete")},0)}}(this)),o=function(e){return e.stopPropagation(),e.preventDefault?e.preventDefault():e.returnValue=!1},this.listeners=[{element:this.element,events:{dragstart:function(e){return function(t){return e.emit("dragstart",t)}}(this),dragenter:function(e){return function(t){return o(t),e.emit("dragenter",t)}}(this),dragover:function(e){return function(t){var i;try{i=t.dataTransfer.effectAllowed}catch(e){}return t.dataTransfer.dropEffect="move"===i||"linkMove"===i?"move":"copy",o(t),e.emit("dragover",t)}}(this),dragleave:function(e){return function(t){return e.emit("dragleave",t)}}(this),drop:function(e){return function(t){return o(t),e.drop(t)}}(this),dragend:function(e){return function(t){return e.emit("dragend",t)}}(this)}}],this.clickableElements.forEach(function(e){return function(i){return e.listeners.push({element:i,events:{click:function(n){return(i!==e.element||n.target===e.element||t.elementInside(n.target,e.element.querySelector(".dz-message")))&&e.hiddenFileInput.click(),!0}}})}}(this)),this.enable(),this.options.init.call(this)},t.prototype.destroy=function(){var e;return this.disable(),this.removeAllFiles(!0),(null!=(e=this.hiddenFileInput)?e.parentNode:void 0)&&(this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput),this.hiddenFileInput=null),delete this.element.dropzone,t.instances.splice(t.instances.indexOf(this),1)},t.prototype.updateTotalUploadProgress=function(){var e,t,i,n,o,r,s,a;if(s=0,r=0,e=this.getActiveFiles(),e.length){for(o=this.getActiveFiles(),i=0,n=o.length;i<n;i++)t=o[i],s+=t.upload.bytesSent,r+=t.upload.total;a=100*s/r}else a=100;return this.emit("totaluploadprogress",a,r,s)},t.prototype._getParamName=function(e){return"function"==typeof this.options.paramName?this.options.paramName(e):""+this.options.paramName+(this.options.uploadMultiple?"["+e+"]":"")},t.prototype._renameFile=function(e){return"function"!=typeof this.options.renameFile?e.name:this.options.renameFile(e)},t.prototype.getFallbackForm=function(){var e,i,n,o;return(e=this.getExistingFallback())?e:(n='<div class="dz-fallback">',this.options.dictFallbackText&&(n+="<p>"+this.options.dictFallbackText+"</p>"),n+='<input type="file" name="'+this._getParamName(0)+'" '+(this.options.uploadMultiple?'multiple="multiple"':void 0)+' /><input type="submit" value="Upload!"></div>',i=t.createElement(n),"FORM"!==this.element.tagName?(o=t.createElement('<form action="'+this.options.url+'" enctype="multipart/form-data" method="'+this.options.method+'"></form>'),o.appendChild(i)):(this.element.setAttribute("enctype","multipart/form-data"),this.element.setAttribute("method",this.options.method)),null!=o?o:i)},t.prototype.getExistingFallback=function(){var e,t,i,n,o,r;for(t=function(e){var t,i,n;for(i=0,n=e.length;i<n;i++)if(t=e[i],/(^| )fallback($| )/.test(t.className))return t},o=["div","form"],i=0,n=o.length;i<n;i++)if(r=o[i],e=t(this.element.getElementsByTagName(r)))return e},t.prototype.setupEventListeners=function(){var e,t,i,n,o,r,s;for(r=this.listeners,s=[],i=0,n=r.length;i<n;i++)e=r[i],s.push(function(){var i,n;i=e.events,n=[];for(t in i)o=i[t],n.push(e.element.addEventListener(t,o,!1));return n}());return s},t.prototype.removeEventListeners=function(){var e,t,i,n,o,r,s;for(r=this.listeners,s=[],i=0,n=r.length;i<n;i++)e=r[i],s.push(function(){var i,n;i=e.events,n=[];for(t in i)o=i[t],n.push(e.element.removeEventListener(t,o,!1));return n}());return s},t.prototype.disable=function(){var e,t,i,n,o;for(this.clickableElements.forEach(function(e){return e.classList.remove("dz-clickable")}),this.removeEventListeners(),n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],o.push(this.cancelUpload(e));return o},t.prototype.enable=function(){return this.clickableElements.forEach(function(e){return e.classList.add("dz-clickable")}),this.setupEventListeners()},t.prototype.filesize=function(e){var t,i,n,o,r,s,a,l;if(r=0,s="b",e>0){for(l=["tb","gb","mb","kb","b"],i=n=0,o=l.length;n<o;i=++n)if(a=l[i],t=Math.pow(this.options.filesizeBase,4-i)/10,e>=t){r=e/Math.pow(this.options.filesizeBase,4-i),s=a;break}r=Math.round(10*r)/10}return"<strong>"+r+"</strong> "+this.options.dictFileSizeUnits[s]},t.prototype._updateMaxFilesReachedClass=function(){return null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(this.getAcceptedFiles().length===this.options.maxFiles&&this.emit("maxfilesreached",this.files),this.element.classList.add("dz-max-files-reached")):this.element.classList.remove("dz-max-files-reached")},t.prototype.drop=function(e){var t,i;e.dataTransfer&&(this.emit("drop",e),t=e.dataTransfer.files,this.emit("addedfiles",t),t.length&&(i=e.dataTransfer.items,i&&i.length&&null!=i[0].webkitGetAsEntry?this._addFilesFromItems(i):this.handleFiles(t)))},t.prototype.paste=function(e){var t,i;if(null!=(null!=e&&null!=(i=e.clipboardData)?i.items:void 0))return this.emit("paste",e),t=e.clipboardData.items,t.length?this._addFilesFromItems(t):void 0},t.prototype.handleFiles=function(e){var t,i,n,o;for(o=[],i=0,n=e.length;i<n;i++)t=e[i],o.push(this.addFile(t));return o},t.prototype._addFilesFromItems=function(e){var t,i,n,o,r;for(r=[],n=0,o=e.length;n<o;n++)i=e[n],null!=i.webkitGetAsEntry&&(t=i.webkitGetAsEntry())?t.isFile?r.push(this.addFile(i.getAsFile())):t.isDirectory?r.push(this._addFilesFromDirectory(t,t.name)):r.push(void 0):null!=i.getAsFile&&(null==i.kind||"file"===i.kind)?r.push(this.addFile(i.getAsFile())):r.push(void 0);return r},t.prototype._addFilesFromDirectory=function(e,t){var i,n,o;return i=e.createReader(),n=function(e){return"undefined"!=typeof console&&null!==console&&"function"==typeof console.log?console.log(e):void 0},(o=function(e){return function(){return i.readEntries(function(i){var n,r,s;if(i.length>0){for(r=0,s=i.length;r<s;r++)n=i[r],n.isFile?n.file(function(i){if(!e.options.ignoreHiddenFiles||"."!==i.name.substring(0,1))return i.fullPath=t+"/"+i.name,e.addFile(i)}):n.isDirectory&&e._addFilesFromDirectory(n,t+"/"+n.name);o()}return null},n)}}(this))()},t.prototype.accept=function(e,i){return e.size>1024*this.options.maxFilesize*1024?i(this.options.dictFileTooBig.replace("{{filesize}}",Math.round(e.size/1024/10.24)/100).replace("{{maxFilesize}}",this.options.maxFilesize)):t.isValidFile(e,this.options.acceptedFiles)?null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(i(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}",this.options.maxFiles)),this.emit("maxfilesexceeded",e)):this.options.accept.call(this,e,i):i(this.options.dictInvalidFileType)},t.prototype.addFile=function(e){return e.upload={progress:0,total:e.size,bytesSent:0,filename:this._renameFile(e)},this.files.push(e),e.status=t.ADDED,this.emit("addedfile",e),this._enqueueThumbnail(e),this.accept(e,function(t){return function(i){return i?(e.accepted=!1,t._errorProcessing([e],i)):(e.accepted=!0,t.options.autoQueue&&t.enqueueFile(e)),t._updateMaxFilesReachedClass()}}(this))},t.prototype.enqueueFiles=function(e){var t,i,n;for(i=0,n=e.length;i<n;i++)t=e[i],this.enqueueFile(t);return null},t.prototype.enqueueFile=function(e){if(e.status!==t.ADDED||e.accepted!==!0)throw new Error("This file can't be queued because it has already been processed or was rejected.");if(e.status=t.QUEUED,this.options.autoProcessQueue)return setTimeout(function(e){return function(){return e.processQueue()}}(this),0)},t.prototype._thumbnailQueue=[],t.prototype._processingThumbnail=!1,t.prototype._enqueueThumbnail=function(e){if(this.options.createImageThumbnails&&e.type.match(/image.*/)&&e.size<=1024*this.options.maxThumbnailFilesize*1024)return this._thumbnailQueue.push(e),setTimeout(function(e){return function(){return e._processThumbnailQueue()}}(this),0)},t.prototype._processThumbnailQueue=function(){var e;if(!this._processingThumbnail&&0!==this._thumbnailQueue.length)return this._processingThumbnail=!0,e=this._thumbnailQueue.shift(),this.createThumbnail(e,this.options.thumbnailWidth,this.options.thumbnailHeight,this.options.thumbnailMethod,!0,function(t){return function(i){return t.emit("thumbnail",e,i),t._processingThumbnail=!1,t._processThumbnailQueue()}}(this))},t.prototype.removeFile=function(e){if(e.status===t.UPLOADING&&this.cancelUpload(e),this.files=d(this.files,e),this.emit("removedfile",e),0===this.files.length)return this.emit("reset")},t.prototype.removeAllFiles=function(e){var i,n,o,r;for(null==e&&(e=!1),r=this.files.slice(),n=0,o=r.length;n<o;n++)i=r[n],(i.status!==t.UPLOADING||e)&&this.removeFile(i);return null},t.prototype.resizeImage=function(e,i,o,r,s){return this.createThumbnail(e,i,o,r,!1,function(i){return function(o,r){var a,l;return null===r?s(e):(a=i.options.resizeMimeType,null==a&&(a=e.type),l=r.toDataURL(a,i.options.resizeQuality),"image/jpeg"!==a&&"image/jpg"!==a||(l=n.restore(e.dataURL,l)),s(t.dataURItoBlob(l)))}}(this))},t.prototype.createThumbnail=function(e,t,i,n,o,r){var s;return s=new FileReader,s.onload=function(a){return function(){return e.dataURL=s.result,"image/svg+xml"===e.type?void(null!=r&&r(s.result)):a.createThumbnailFromUrl(e,t,i,n,o,r)}}(this),s.readAsDataURL(e)},t.prototype.createThumbnailFromUrl=function(e,t,i,n,o,r,s){var l;return l=document.createElement("img"),s&&(l.crossOrigin=s),l.onload=function(s){return function(){var d;return d=function(e){return e(1)},"undefined"!=typeof EXIF&&null!==EXIF&&o&&(d=function(e){return EXIF.getData(l,function(){return e(EXIF.getTag(this,"Orientation"))})}),d(function(o){var d,p,u,c,h,f,m,g;switch(e.width=l.width,e.height=l.height,m=s.options.resize.call(s,e,t,i,n),d=document.createElement("canvas"),p=d.getContext("2d"),d.width=m.trgWidth,d.height=m.trgHeight,o>4&&(d.width=m.trgHeight,d.height=m.trgWidth),o){case 2:p.translate(d.width,0),p.scale(-1,1);break;case 3:p.translate(d.width,d.height),p.rotate(Math.PI);break;case 4:p.translate(0,d.height),p.scale(1,-1);break;case 5:p.rotate(.5*Math.PI),p.scale(1,-1);break;case 6:p.rotate(.5*Math.PI),p.translate(0,-d.height);break;case 7:p.rotate(.5*Math.PI),p.translate(d.width,-d.height),p.scale(-1,1);break;case 8:p.rotate(-.5*Math.PI),p.translate(-d.width,0)}if(a(p,l,null!=(u=m.srcX)?u:0,null!=(c=m.srcY)?c:0,m.srcWidth,m.srcHeight,null!=(h=m.trgX)?h:0,null!=(f=m.trgY)?f:0,m.trgWidth,m.trgHeight),g=d.toDataURL("image/png"),null!=r)return r(g,d)})}}(this),null!=r&&(l.onerror=r),l.src=e.dataURL},t.prototype.processQueue=function(){var e,t,i,n;if(t=this.options.parallelUploads,i=this.getUploadingFiles().length,e=i,!(i>=t)&&(n=this.getQueuedFiles(),n.length>0)){if(this.options.uploadMultiple)return this.processFiles(n.slice(0,t-i));for(;e<t;){if(!n.length)return;this.processFile(n.shift()),e++}}},t.prototype.processFile=function(e){return this.processFiles([e])},t.prototype.processFiles=function(e){var i,n,o;for(n=0,o=e.length;n<o;n++)i=e[n],i.processing=!0,i.status=t.UPLOADING,this.emit("processing",i);return this.options.uploadMultiple&&this.emit("processingmultiple",e),this.uploadFiles(e)},t.prototype._getFilesWithXhr=function(e){var t,i;return i=function(){var i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)t=o[i],t.xhr===e&&r.push(t);return r}.call(this)},t.prototype.cancelUpload=function(e){var i,n,o,r,s,a,l;if(e.status===t.UPLOADING){for(n=this._getFilesWithXhr(e.xhr),o=0,s=n.length;o<s;o++)i=n[o],i.status=t.CANCELED;for(e.xhr.abort(),r=0,a=n.length;r<a;r++)i=n[r],this.emit("canceled",i);this.options.uploadMultiple&&this.emit("canceledmultiple",n)}else(l=e.status)!==t.ADDED&&l!==t.QUEUED||(e.status=t.CANCELED,this.emit("canceled",e),this.options.uploadMultiple&&this.emit("canceledmultiple",[e]));if(this.options.autoProcessQueue)return this.processQueue()},r=function(){var e,t;return t=arguments[0],e=2<=arguments.length?p.call(arguments,1):[],"function"==typeof t?t.apply(this,e):t},t.prototype.uploadFile=function(e){return this.uploadFiles([e])},t.prototype.uploadFiles=function(e){var i,n,s,a,l,d,p,u,c,h,f,m,g,v,z,b,y,w,F,x,k,E,C,T,S,M,A,L,I,O,U,N,P,R,D,_,B;for(B=new XMLHttpRequest,g=0,y=e.length;g<y;g++)s=e[g],s.xhr=B;E=r(this.options.method,e),D=r(this.options.url,e),B.open(E,D,!0),B.timeout=r(this.options.timeout,e),B.withCredentials=!!this.options.withCredentials,N=null,l=function(t){return function(){var i,n,o;for(o=[],i=0,n=e.length;i<n;i++)s=e[i],o.push(t._errorProcessing(e,N||t.options.dictResponseError.replace("{{statusCode}}",B.status),B));return o}}(this),R=function(t){return function(i){var n,o,r,a,l,d,p,u,c;if(null!=i)for(u=100*i.loaded/i.total,o=0,a=e.length;o<a;o++)s=e[o],s.upload.progress=u,s.upload.total=i.total,s.upload.bytesSent=i.loaded;else{for(n=!0,u=100,r=0,l=e.length;r<l;r++)s=e[r],100===s.upload.progress&&s.upload.bytesSent===s.upload.total||(n=!1),s.upload.progress=u,s.upload.bytesSent=s.upload.total;if(n)return}for(c=[],p=0,d=e.length;p<d;p++)s=e[p],c.push(t.emit("uploadprogress",s,u,s.upload.bytesSent));return c}}(this),B.onload=function(i){return function(n){var o;if(e[0].status!==t.CANCELED&&4===B.readyState){if("arraybuffer"!==B.responseType&&"blob"!==B.responseType&&(N=B.responseText,B.getResponseHeader("content-type")&&~B.getResponseHeader("content-type").indexOf("application/json")))try{N=JSON.parse(N)}catch(e){n=e,N="Invalid JSON response from server."}return R(),200<=(o=B.status)&&o<300?i._finished(e,N,n):l()}}}(this),B.onerror=function(i){return function(){if(e[0].status!==t.CANCELED)return l()}}(this),S=null!=(M=B.upload)?M:B,S.onprogress=R,u={Accept:"application/json","Cache-Control":"no-cache","X-Requested-With":"XMLHttpRequest"},this.options.headers&&o(u,this.options.headers);for(d in u)p=u[d],p&&B.setRequestHeader(d,p);if(a=new FormData,this.options.params){A=this.options.params;for(z in A)_=A[z],a.append(z,_)}for(v=0,w=e.length;v<w;v++)s=e[v],this.emit("sending",s,B,a);if(this.options.uploadMultiple&&this.emit("sendingmultiple",e,B,a),"FORM"===this.element.tagName)for(L=this.element.querySelectorAll("input, textarea, select, button"),b=0,F=L.length;b<F;b++)if(h=L[b],f=h.getAttribute("name"),m=h.getAttribute("type"),"SELECT"===h.tagName&&h.hasAttribute("multiple"))for(I=h.options,k=0,x=I.length;k<x;k++)T=I[k],T.selected&&a.append(f,T.value);else(!m||"checkbox"!==(O=m.toLowerCase())&&"radio"!==O||h.checked)&&a.append(f,h.value);for(i=0,P=[],c=C=0,U=e.length-1;0<=U?C<=U:C>=U;c=0<=U?++C:--C)n=function(t){return function(n,o,r){return function(n){if(a.append(o,n,r),++i===e.length)return t.submitRequest(B,a,e)}}}(this),P.push(this.options.transformFile.call(this,e[c],n(e[c],this._getParamName(c),e[c].upload.filename)));return P},t.prototype.submitRequest=function(e,t,i){return e.send(t)},t.prototype._finished=function(e,i,n){var o,r,s;for(r=0,s=e.length;r<s;r++)o=e[r],o.status=t.SUCCESS,this.emit("success",o,i,n),this.emit("complete",o);if(this.options.uploadMultiple&&(this.emit("successmultiple",e,i,n),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()},t.prototype._errorProcessing=function(e,i,n){var o,r,s;for(r=0,s=e.length;r<s;r++)o=e[r],o.status=t.ERROR,this.emit("error",o,i,n),this.emit("complete",o);if(this.options.uploadMultiple&&(this.emit("errormultiple",e,i,n),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()},t}(i),t.version="5.1.1",t.options={},t.optionsForElement=function(e){return e.getAttribute("id")?t.options[o(e.getAttribute("id"))]:void 0},t.instances=[],t.forElement=function(e){if("string"==typeof e&&(e=document.querySelector(e)),null==(null!=e?e.dropzone:void 0))throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");return e.dropzone},t.autoDiscover=!0,t.discover=function(){var e,i,n,o,r,s;for(document.querySelectorAll?n=document.querySelectorAll(".dropzone"):(n=[],e=function(e){var t,i,o,r;for(r=[],i=0,o=e.length;i<o;i++)t=e[i],/(^| )dropzone($| )/.test(t.className)?r.push(n.push(t)):r.push(void 0);return r},e(document.getElementsByTagName("div")),e(document.getElementsByTagName("form"))),s=[],o=0,r=n.length;o<r;o++)i=n[o],t.optionsForElement(i)!==!1?s.push(new t(i)):s.push(void 0);return s},t.blacklistedBrowsers=[/opera.*Macintosh.*version\/12/i],t.isBrowserSupported=function(){var e,i,n,o,r;if(e=!0,window.File&&window.FileReader&&window.FileList&&window.Blob&&window.FormData&&document.querySelector)if("classList"in document.createElement("a"))for(o=t.blacklistedBrowsers,i=0,n=o.length;i<n;i++)r=o[i],r.test(navigator.userAgent)&&(e=!1);else e=!1;else e=!1;return e},t.dataURItoBlob=function(e){var t,i,n,o,r,s,a;for(i=atob(e.split(",")[1]),s=e.split(",")[0].split(":")[1].split(";")[0],t=new ArrayBuffer(i.length),o=new Uint8Array(t),n=r=0,a=i.length;0<=a?r<=a:r>=a;n=0<=a?++r:--r)o[n]=i.charCodeAt(n);return new Blob([t],{type:s})},d=function(e,t){var i,n,o,r;for(r=[],n=0,o=e.length;n<o;n++)i=e[n],i!==t&&r.push(i);return r},o=function(e){return e.replace(/[\-_](\w)/g,function(e){return e.charAt(1).toUpperCase()})},t.createElement=function(e){var t;return t=document.createElement("div"),t.innerHTML=e,t.childNodes[0]},t.elementInside=function(e,t){if(e===t)return!0;for(;e=e.parentNode;)if(e===t)return!0;return!1},t.getElement=function(e,t){var i;if("string"==typeof e?i=document.querySelector(e):null!=e.nodeType&&(i=e),null==i)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector or a plain HTML element.");return i},t.getElements=function(e,t){var i,n,o,r,s,a,l,d;if(e instanceof Array){o=[];try{for(r=0,a=e.length;r<a;r++)n=e[r],o.push(this.getElement(n,t))}catch(e){i=e,o=null}}else if("string"==typeof e)for(o=[],d=document.querySelectorAll(e),s=0,l=d.length;s<l;s++)n=d[s],o.push(n);else null!=e.nodeType&&(o=[e]);if(null==o||!o.length)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");return o},t.confirm=function(e,t,i){return window.confirm(e)?t():null!=i?i():void 0},t.isValidFile=function(e,t){var i,n,o,r,s;if(!t)return!0;for(t=t.split(","),r=e.type,i=r.replace(/\/.*$/,""),n=0,o=t.length;n<o;n++)if(s=t[n],s=s.trim(),"."===s.charAt(0)){if(e.name.toLowerCase().indexOf(s.toLowerCase(),e.name.length-s.length)!==-1)return!0}else if(/\/\*$/.test(s)){if(i===s.replace(/\/.*$/,""))return!0}else if(r===s)return!0;return!1},"undefined"!=typeof jQuery&&null!==jQuery&&(jQuery.fn.dropzone=function(e){return this.each(function(){return new t(this,e)})}),"undefined"!=typeof e&&null!==e?e.exports=t:window.Dropzone=t,t.ADDED="added",t.QUEUED="queued",t.ACCEPTED=t.QUEUED,t.UPLOADING="uploading",t.PROCESSING=t.UPLOADING,t.CANCELED="canceled",t.ERROR="error",t.SUCCESS="success",s=function(e){var t,i,n,o,r,s,a,l,d,p;for(a=e.naturalWidth,s=e.naturalHeight,i=document.createElement("canvas"),i.width=1,i.height=s,n=i.getContext("2d"),n.drawImage(e,0,0),o=n.getImageData(1,0,1,s).data,p=0,r=s,l=s;l>p;)t=o[4*(l-1)+3],0===t?r=l:p=l,l=r+p>>1;return d=l/s,0===d?1:d},a=function(e,t,i,n,o,r,a,l,d,p){var u;return u=s(t),e.drawImage(t,i,n,o,r,a,l,d,p/u)},n=function(){function e(){}return e.KEY_STR="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",e.encode64=function(e){var t,i,n,o,r,s,a,l,d;for(d="",t=void 0,i=void 0,n="",o=void 0,r=void 0,s=void 0,a="",l=0;;)if(t=e[l++],i=e[l++],n=e[l++],o=t>>2,r=(3&t)<<4|i>>4,s=(15&i)<<2|n>>6,a=63&n,isNaN(i)?s=a=64:isNaN(n)&&(a=64),d=d+this.KEY_STR.charAt(o)+this.KEY_STR.charAt(r)+this.KEY_STR.charAt(s)+this.KEY_STR.charAt(a),t=i=n="",o=r=s=a="",!(l<e.length))break;return d},e.restore=function(e,t){var i,n,o;return e.match("data:image/jpeg;base64,")?(n=this.decode64(e.replace("data:image/jpeg;base64,","")),o=this.slice2Segments(n),i=this.exifManipulation(t,o),"data:image/jpeg;base64,"+this.encode64(i)):t},e.exifManipulation=function(e,t){var i,n,o;return n=this.getExifArray(t),o=this.insertExif(e,n),i=new Uint8Array(o)},e.getExifArray=function(e){var t,i;for(t=void 0,i=0;i<e.length;){if(t=e[i],255===t[0]&225===t[1])return t;i++}return[]},e.insertExif=function(e,t){var i,n,o,r,s,a;return r=e.replace("data:image/jpeg;base64,",""),o=this.decode64(r),a=o.indexOf(255,3),s=o.slice(0,a),n=o.slice(a),i=s,i=i.concat(t),i=i.concat(n)},e.slice2Segments=function(e){var t,i,n,o,r;for(i=0,r=[];;){if(255===e[i]&218===e[i+1])break;if(255===e[i]&216===e[i+1]?i+=2:(n=256*e[i+2]+e[i+3],t=i+n+2,o=e.slice(i,t),r.push(o),i=t),i>e.length)break}return r},e.decode64=function(e){var t,i,n,o,r,s,a,l,d,p,u;for(u="",n=void 0,o=void 0,r="",s=void 0,a=void 0,l=void 0,d="",p=0,i=[],t=/[^A-Za-z0-9\+\/\=]/g,t.exec(e)&&console.warning("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."),e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");;)if(s=this.KEY_STR.indexOf(e.charAt(p++)),a=this.KEY_STR.indexOf(e.charAt(p++)),l=this.KEY_STR.indexOf(e.charAt(p++)),d=this.KEY_STR.indexOf(e.charAt(p++)),n=s<<2|a>>4,o=(15&a)<<4|l>>2,r=(3&l)<<6|d,i.push(n),64!==l&&i.push(o),64!==d&&i.push(r),n=o=r="",s=a=l=d="",!(p<e.length))break;return i},e}(),r=function(e,t){var i,n,o,r,s,a,l,d,p;if(o=!1,p=!0,n=e.document,d=n.documentElement,i=n.addEventListener?"addEventListener":"attachEvent",l=n.addEventListener?"removeEventListener":"detachEvent",a=n.addEventListener?"":"on",r=function(i){if("readystatechange"!==i.type||"complete"===n.readyState)return("load"===i.type?e:n)[l](a+i.type,r,!1),!o&&(o=!0)?t.call(e,i.type||i):void 0},s=function(){var e;try{d.doScroll("left")}catch(t){return e=t,void setTimeout(s,50)}return r("poll")},"complete"!==n.readyState){if(n.createEventObject&&d.doScroll){try{p=!e.frameElement}catch(e){}p&&s()}return n[i](a+"DOMContentLoaded",r,!1),n[i](a+"readystatechange",r,!1),e[i](a+"load",r,!1)}},t._autoDiscoverFunction=function(){if(t.autoDiscover)return t.discover()},r(window,t._autoDiscoverFunction)}).call(this)}).call(t,i(9)(e))},function(e,t){e.exports=' <form :action=url class="vue-dropzone dropzone" :id=id> <slot></slot> </form> '},function(e,t,i){function n(e,t){for(var i=0;i<e.length;i++){var n=e[i],o=u[n.id];if(o){o.refs++;for(var r=0;r<o.parts.length;r++)o.parts[r](n.parts[r]);for(;r<n.parts.length;r++)o.parts.push(l(n.parts[r],t))}else{for(var s=[],r=0;r<n.parts.length;r++)s.push(l(n.parts[r],t));u[n.id]={id:n.id,refs:1,parts:s}}}}function o(e){for(var t=[],i={},n=0;n<e.length;n++){var o=e[n],r=o[0],s=o[1],a=o[2],l=o[3],d={css:s,media:a,sourceMap:l};i[r]?i[r].parts.push(d):t.push(i[r]={id:r,parts:[d]})}return t}function r(e,t){var i=f(),n=v[v.length-1];if("top"===e.insertAt)n?n.nextSibling?i.insertBefore(t,n.nextSibling):i.appendChild(t):i.insertBefore(t,i.firstChild),v.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");i.appendChild(t)}}function s(e){e.parentNode.removeChild(e);var t=v.indexOf(e);t>=0&&v.splice(t,1)}function a(e){var t=document.createElement("style");return t.type="text/css",r(e,t),t}function l(e,t){var i,n,o;if(t.singleton){var r=g++;i=m||(m=a(t)),n=d.bind(null,i,r,!1),o=d.bind(null,i,r,!0)}else i=a(t),n=p.bind(null,i),o=function(){s(i)};return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else o()}}function d(e,t,i,n){var o=i?"":n.css;if(e.styleSheet)e.styleSheet.cssText=z(t,o);else{var r=document.createTextNode(o),s=e.childNodes;s[t]&&e.removeChild(s[t]),s.length?e.insertBefore(r,s[t]):e.appendChild(r)}}function p(e,t){var i=t.css,n=t.media,o=t.sourceMap;if(n&&e.setAttribute("media",n),o&&(i+="\n/*# sourceURL="+o.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),e.styleSheet)e.styleSheet.cssText=i;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(i))}}var u={},c=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},h=c(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),f=c(function(){return document.head||document.getElementsByTagName("head")[0]}),m=null,g=0,v=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=h()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var i=o(e);return n(i,t),function(e){for(var r=[],s=0;s<i.length;s++){var a=i[s],l=u[a.id];l.refs--,r.push(l)}if(e){var d=o(e);n(d,t)}for(var s=0;s<r.length;s++){var l=r[s];if(0===l.refs){for(var p=0;p<l.parts.length;p++)l.parts[p]();delete u[l.id]}}}};var z=function(){var e=[];return function(t,i){return e[t]=i,e.filter(Boolean).join("\n")}}()},function(e,t,i){var n=i(4);"string"==typeof n&&(n=[[e.id,n,""]]);i(7)(n,{});n.locals&&(e.exports=n.locals)},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children=[],e.webpackPolyfill=1),e}}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! jquery */ 16)))

/***/ }),
/* 1727 */
/* exports provided: af, ar, bg, bs, ca, cs, da, de, ee, el, en, es, fa, fi, fo, fr, ge, he, hr, hu, id, is, it, ja, ko, lb, lt, lv, mn, nbNO, nl, pl, ptBR, ro, ru, sk, slSI, srCYRL, sr, sv, th, tr, uk, ur, vi, zh */
/* all exports used */
/*!*************************************************!*\
  !*** ./~/vuejs-datepicker/dist/locale/index.js ***!
  \*************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "af", function() { return af; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ar", function() { return language; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bg", function() { return bg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bs", function() { return bs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ca", function() { return ca; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cs", function() { return cs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "da", function() { return da; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "de", function() { return de; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ee", function() { return ee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "el", function() { return el; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return en; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return es; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fa", function() { return fa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fi", function() { return fi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fo", function() { return fo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fr", function() { return fr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ge", function() { return ge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "he", function() { return language$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hr", function() { return hr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hu", function() { return hu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "id", function() { return id; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "it", function() { return it; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ja", function() { return language$2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ko", function() { return language$3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return lb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lt", function() { return language$4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lv", function() { return lv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mn", function() { return language$5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nbNO", function() { return nbNO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nl", function() { return nl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pl", function() { return pl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ptBR", function() { return ptBR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ro", function() { return ro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ru", function() { return ru; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sk", function() { return sk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "slSI", function() { return slSI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "srCYRL", function() { return srCYRL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sr", function() { return sr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sv", function() { return sv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "th", function() { return th; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tr", function() { return tr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uk", function() { return uk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ur", function() { return language$6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vi", function() { return vi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zh", function() { return language$7; });
var Language=function(e,a,r,n){this.language=e,this.months=a,this.monthsAbbr=r,this.days=n,this.rtl=!1,this.ymd=!1,this.yearSuffix=""},prototypeAccessors={language:{configurable:!0},months:{configurable:!0},monthsAbbr:{configurable:!0},days:{configurable:!0}};prototypeAccessors.language.get=function(){return this._language},prototypeAccessors.language.set=function(e){if("string"!=typeof e)throw new TypeError("Language must be a string");this._language=e},prototypeAccessors.months.get=function(){return this._months},prototypeAccessors.months.set=function(e){if(12!==e.length)throw new RangeError("There must be 12 months for "+this.language+" language");this._months=e},prototypeAccessors.monthsAbbr.get=function(){return this._monthsAbbr},prototypeAccessors.monthsAbbr.set=function(e){if(12!==e.length)throw new RangeError("There must be 12 abbreviated months for "+this.language+" language");this._monthsAbbr=e},prototypeAccessors.days.get=function(){return this._days},prototypeAccessors.days.set=function(e){if(7!==e.length)throw new RangeError("There must be 7 days for "+this.language+" language");this._days=e},Object.defineProperties(Language.prototype,prototypeAccessors);var af=new Language("Afrikaans",["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["So.","Ma.","Di.","Wo.","Do.","Vr.","Sa."]),language=new Language("Arabic",["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["أحد","إثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"]);language.rtl=!0;var bg=new Language("Bulgarian",["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],["Ян","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),bs=new Language("Bosnian",["Januar","Februar","Mart","April","Maj","Juni","Juli","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),ca=new Language("Catalan",["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],["Gen","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Oct","Nov","Des"],["Diu","Dil","Dmr","Dmc","Dij","Div","Dis"]),cs=new Language("Czech",["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],["led","úno","bře","dub","kvě","čer","čec","srp","zář","říj","lis","pro"],["ne","po","út","st","čt","pá","so"]),da=new Language("Danish",["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sø","Ma","Ti","On","To","Fr","Lø"]),de=new Language("German",["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."]),ee=new Language("Estonian",["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"],["P","E","T","K","N","R","L"]),el=new Language("Greek",["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάϊος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"]),en=new Language("English",["January","February","March","April","May","June","July","August","September","October","November","December"],["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]),es=new Language("Spanish",["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"]),fa=new Language("Persian",["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],["فرو","ارد","خرد","تیر","مرد","شهر","مهر","آبا","آذر","دی","بهم","اسف"],["یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"]),fi=new Language("Finnish",["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],["su","ma","ti","ke","to","pe","la"]),fo=new Language("Faroese",["Januar","Februar","Mars","Apríl","Mai","Juni","Juli","August","Septembur","Oktobur","Novembur","Desembur"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sun","Mán","Týs","Mik","Hós","Frí","Ley"]),fr=new Language("French",["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"],["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]),ge=new Language("Georgia",["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"],["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"]),language$1=new Language("Hebrew",["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"],["א","ב","ג","ד","ה","ו","ש"]);language$1.rtl=!0;var hr=new Language("Croatian",["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),hu=new Language("Hungarian",["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],["Jan","Febr","Márc","Ápr","Máj","Jún","Júl","Aug","Szept","Okt","Nov","Dec"],["Vas","Hét","Ke","Sze","Csü","Pén","Szo"]),id=new Language("Indonesian",["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"],["Min","Sen","Sel","Rab","Kam","Jum","Sab"]),is=new Language("Icelandic",["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],["Jan","Feb","Mars","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],["Sun","Mán","Þri","Mið","Fim","Fös","Lau"]),it=new Language("Italian",["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]),language$2=new Language("Japanese",["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["日","月","火","水","木","金","土"]);language$2.yearSuffix="年",language$2.ymd=!0;var language$3=new Language("Korean",["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["일","월","화","수","목","금","토"]);language$3.yearSuffix="년";var lb=new Language("Luxembourgish",["Januar","Februar","Mäerz","Abrëll","Mäi","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mäe","Abr","Mäi","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mé.","Dë.","Më.","Do.","Fr.","Sa."]),language$4=new Language("Lithuanian",["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"]);language$4.ymd=!0;var lv=new Language("Latvian",["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],["Sv","Pr","Ot","Tr","Ce","Pk","Se"]),language$5=new Language("Mongolia",["1 дүгээр сар","2 дугаар сар","3 дугаар сар","4 дүгээр сар","5 дугаар сар","6 дугаар сар","7 дугаар сар","8 дугаар сар","9 дүгээр сар","10 дугаар сар","11 дүгээр сар","12 дугаар сар"],["1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар"],["Ня","Да","Мя","Лх","Пү","Ба","Бя"]);language$5.ymd=!0;var nbNO=new Language("Norwegian Bokmål",["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sø","Ma","Ti","On","To","Fr","Lø"]),nl=new Language("Dutch",["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],["jan","feb","maa","apr","mei","jun","jul","aug","sep","okt","nov","dec"],["zo","ma","di","wo","do","vr","za"]),pl=new Language("Polish",["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"],["Nd","Pn","Wt","Śr","Czw","Pt","Sob"]),ptBR=new Language("Brazilian",["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]),ro=new Language("Romanian",["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"],["D","L","Ma","Mi","J","V","S"]),ru=new Language("Russian",["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],["Янв","Февр","Март","Апр","Май","Июнь","Июль","Авг","Сент","Окт","Нояб","Дек"],["Вс","Пн","Вт","Ср","Чт","Пт","Сб"]),sk=new Language("Slovakian",["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],["jan","feb","mar","apr","máj","jún","júl","aug","sep","okt","nov","dec"],["ne","po","ut","st","št","pi","so"]),slSI=new Language("Sloveian",["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]),srCYRL=new Language("Serbian in Cyrillic script",["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],["Нед","Пон","Уто","Сре","Чет","Пет","Суб"]),sr=new Language("Serbian",["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sre","Čet","Pet","Sub"]),sv=new Language("Swedish",["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]),th=new Language("Thai",["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],["อา","จ","อ","พ","พฤ","ศ","ส"]),tr=new Language("Turkish",["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],["Paz","Pzt","Sal","Çar","Per","Cum","Cmt"]),uk=new Language("Ukraine",["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],["Січ","Лют","Бер","Квіт","Трав","Чер","Лип","Серп","Вер","Жовт","Лист","Груд"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),language$6=new Language("Urdu",["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["اتوار","پیر","منگل","بدھ","جمعرات","جمعہ","ہفتہ"]);language$6.rtl=!0;var vi=new Language("Vietnamese",["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],["T 01","T 02","T 03","T 04","T 05","T 06","T 07","T 08","T 09","T 10","T 11","T 12"],["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"]),language$7=new Language("Chinese",["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["日","一","二","三","四","五","六"]);language$7.yearSuffix="年";


/***/ }),
/* 1728 */
/* exports provided: default */
/* all exports used */
/*!******************************************!*\
  !*** ./~/vuex-i18n/dist/vuex-i18n.es.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/* vuex-i18n-store defines a vuex module to store locale translations. Make sure
** to also include the file vuex-i18n.js to enable easy access to localized
** strings in your vue components.
*/
// define a simple vuex module to handle locale translations
var i18nVuexModule = {
  namespaced: true,
  state: {
    locale: null,
    fallback: null,
    translations: {}
  },
  mutations: {
    // set the current locale
    SET_LOCALE: function SET_LOCALE(state, payload) {
      state.locale = payload.locale;
    },
    // add a new locale
    ADD_LOCALE: function ADD_LOCALE(state, payload) {
      // reduce the given translations to a single-depth tree
      var translations = flattenTranslations(payload.translations);

      if (state.translations.hasOwnProperty(payload.locale)) {
        // get the existing translations
        var existingTranslations = state.translations[payload.locale]; // merge the translations

        state.translations[payload.locale] = Object.assign({}, existingTranslations, translations);
      } else {
        // just set the locale if it does not yet exist
        state.translations[payload.locale] = translations;
      } // make sure to notify vue of changes (this might break with new vue versions)


      try {
        if (state.translations.__ob__) {
          state.translations.__ob__.dep.notify();
        }
      } catch (ex) {}
    },
    // replace existing locale information with new translations
    REPLACE_LOCALE: function REPLACE_LOCALE(state, payload) {
      // reduce the given translations to a single-depth tree
      var translations = flattenTranslations(payload.translations); // replace the translations entirely

      state.translations[payload.locale] = translations; // make sure to notify vue of changes (this might break with new vue versions)

      try {
        if (state.translations.__ob__) {
          state.translations.__ob__.dep.notify();
        }
      } catch (ex) {}
    },
    // remove a locale from the store
    REMOVE_LOCALE: function REMOVE_LOCALE(state, payload) {
      // check if the given locale is present in the state
      if (state.translations.hasOwnProperty(payload.locale)) {
        // check if the current locale is the given locale to remvoe
        if (state.locale === payload.locale) {
          // reset the current locale
          state.locale = null;
        } // create a copy of the translations object


        var translationCopy = Object.assign({}, state.translations); // remove the given locale

        delete translationCopy[payload.locale]; // set the state to the new object

        state.translations = translationCopy;
      }
    },
    SET_FALLBACK_LOCALE: function SET_FALLBACK_LOCALE(state, payload) {
      state.fallback = payload.locale;
    }
  },
  actions: {
    // set the current locale
    setLocale: function setLocale(context, payload) {
      context.commit({
        type: 'SET_LOCALE',
        locale: payload.locale
      });
    },
    // add or extend a locale with translations
    addLocale: function addLocale(context, payload) {
      context.commit({
        type: 'ADD_LOCALE',
        locale: payload.locale,
        translations: payload.translations
      });
    },
    // replace locale information
    replaceLocale: function replaceLocale(context, payload) {
      context.commit({
        type: 'REPLACE_LOCALE',
        locale: payload.locale,
        translations: payload.translations
      });
    },
    // remove the given locale translations
    removeLocale: function removeLocale(context, payload) {
      context.commit({
        type: 'REMOVE_LOCALE',
        locale: payload.locale,
        translations: payload.translations
      });
    },
    setFallbackLocale: function setFallbackLocale(context, payload) {
      context.commit({
        type: 'SET_FALLBACK_LOCALE',
        locale: payload.locale
      });
    }
  }
}; // flattenTranslations will convert object trees for translations into a
// single-depth object tree

var flattenTranslations = function flattenTranslations(translations) {
  var toReturn = {};

  for (var i in translations) {
    // check if the property is present
    if (!translations.hasOwnProperty(i)) {
      continue;
    } // get the type of the property


    var objType = _typeof(translations[i]); // allow unflattened array of strings


    if (isArray(translations[i])) {
      var count = translations[i].length;

      for (var index = 0; index < count; index++) {
        var itemType = _typeof(translations[i][index]);

        if (itemType !== 'string') {
          console.warn('i18n:', 'currently only arrays of strings are fully supported', translations[i]);
          break;
        }
      }

      toReturn[i] = translations[i];
    } else if (objType == 'object' && objType !== null) {
      var flatObject = flattenTranslations(translations[i]);

      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = translations[i];
    }
  }

  return toReturn;
}; // check if the given object is an array


function isArray(obj) {
  return !!obj && Array === obj.constructor;
}

var plurals = {
  getTranslationIndex: function getTranslationIndex(languageCode, n) {
    switch (languageCode) {
      case 'ay': // Aymará

      case 'bo': // Tibetan

      case 'cgg': // Chiga

      case 'dz': // Dzongkha

      case 'fa': // Persian

      case 'id': // Indonesian

      case 'ja': // Japanese

      case 'jbo': // Lojban

      case 'ka': // Georgian

      case 'kk': // Kazakh

      case 'km': // Khmer

      case 'ko': // Korean

      case 'ky': // Kyrgyz

      case 'lo': // Lao

      case 'ms': // Malay

      case 'my': // Burmese

      case 'sah': // Yakut

      case 'su': // Sundanese

      case 'th': // Thai

      case 'tt': // Tatar

      case 'ug': // Uyghur

      case 'vi': // Vietnamese

      case 'wo': // Wolof

      case 'zh':
        // Chinese
        // 1 form
        return 0;

      case 'is':
        // Icelandic
        // 2 forms
        return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;

      case 'jv':
        // Javanese
        // 2 forms
        return n !== 0 ? 1 : 0;

      case 'mk':
        // Macedonian
        // 2 forms
        return n === 1 || n % 10 === 1 ? 0 : 1;

      case 'ach': // Acholi

      case 'ak': // Akan

      case 'am': // Amharic

      case 'arn': // Mapudungun

      case 'br': // Breton

      case 'fil': // Filipino

      case 'fr': // French

      case 'gun': // Gun

      case 'ln': // Lingala

      case 'mfe': // Mauritian Creole

      case 'mg': // Malagasy

      case 'mi': // Maori

      case 'oc': // Occitan

      case 'pt_BR': // Brazilian Portuguese

      case 'tg': // Tajik

      case 'ti': // Tigrinya

      case 'tr': // Turkish

      case 'uz': // Uzbek

      case 'wa': // Walloon

      /* eslint-disable */

      /* Disable "Duplicate case label" because there are 2 forms of Chinese plurals */

      case 'zh':
        // Chinese

        /* eslint-enable */
        // 2 forms
        return n > 1 ? 1 : 0;

      case 'lv':
        // Latvian
        // 3 forms
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2;

      case 'lt':
        // Lithuanian
        // 3 forms
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'be': // Belarusian

      case 'bs': // Bosnian

      case 'hr': // Croatian

      case 'ru': // Russian

      case 'sr': // Serbian

      case 'uk':
        // Ukrainian
        // 3 forms
        return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'mnk':
        // Mandinka
        // 3 forms
        return n === 0 ? 0 : n === 1 ? 1 : 2;

      case 'ro':
        // Romanian
        // 3 forms
        return n === 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2;

      case 'pl':
        // Polish
        // 3 forms
        return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'cs': // Czech

      case 'sk':
        // Slovak
        // 3 forms
        return n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;

      case 'csb':
        // Kashubian
        // 3 forms
        return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;

      case 'sl':
        // Slovenian
        // 4 forms
        return n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3;

      case 'mt':
        // Maltese
        // 4 forms
        return n === 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3;

      case 'gd':
        // Scottish Gaelic
        // 4 forms
        return n === 1 || n === 11 ? 0 : n === 2 || n === 12 ? 1 : n > 2 && n < 20 ? 2 : 3;

      case 'cy':
        // Welsh
        // 4 forms
        return n === 1 ? 0 : n === 2 ? 1 : n !== 8 && n !== 11 ? 2 : 3;

      case 'kw':
        // Cornish
        // 4 forms
        return n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3;

      case 'ga':
        // Irish
        // 5 forms
        return n === 1 ? 0 : n === 2 ? 1 : n > 2 && n < 7 ? 2 : n > 6 && n < 11 ? 3 : 4;

      case 'ar':
        // Arabic
        // 6 forms
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;

      default:
        // Everything else
        return n !== 1 ? 1 : 0;
    }
  }
};

var VuexI18nPlugin = {}; // internationalization plugin for vue js using vuex

VuexI18nPlugin.install = function install(Vue, store, config) {
  // TODO: remove this block for next major update (API break)
  if (typeof arguments[2] === 'string' || typeof arguments[3] === 'string') {
    console.warn('i18n: Registering the plugin vuex-i18n with a string for `moduleName` or `identifiers` is deprecated. Use a configuration object instead.', 'https://github.com/dkfbasel/vuex-i18n#setup');
    config = {
      moduleName: arguments[2],
      identifiers: arguments[3]
    };
  } // merge default options with user supplied options


  config = Object.assign({
    warnings: true,
    moduleName: 'i18n',
    identifiers: ['{', '}'],
    preserveState: false,
    translateFilterName: 'translate',
    translateInFilterName: 'translateIn',
    onTranslationNotFound: function onTranslationNotFound() {}
  }, config); // define module name and identifiers as constants to prevent any changes

  var moduleName = config.moduleName;
  var identifiers = config.identifiers;
  var translateFilterName = config.translateFilterName;
  var translateInFilterName = config.translateInFilterName; // initialize the onTranslationNotFound function and make sure it is actually
  // a function

  var onTranslationNotFound = config.onTranslationNotFound;

  if (typeof onTranslationNotFound !== 'function') {
    console.error('i18n: i18n config option onTranslationNotFound must be a function');

    onTranslationNotFound = function onTranslationNotFound() {};
  } // register the i18n module in the vuex store
  // preserveState can be used via configuration if server side rendering is used


  store.registerModule(moduleName, i18nVuexModule, {
    preserveState: config.preserveState
  }); // check if the plugin was correctly initialized

  if (store.state.hasOwnProperty(moduleName) === false) {
    console.error('i18n: i18n vuex module is not correctly initialized. Please check the module name:', moduleName); // always return the key if module is not initialized correctly

    Vue.prototype.$i18n = function (key) {
      return key;
    };

    Vue.prototype.$getLanguage = function () {
      return null;
    };

    Vue.prototype.$setLanguage = function () {
      console.error('i18n: i18n vuex module is not correctly initialized');
    };

    return;
  }

  var render = renderFn(identifiers, config.warnings); // get localized string from store. note that we pass the arguments passed
  // to the function directly to the translateInLanguage function

  var translate = function $t() {
    // get the current language from the store
    var locale = store.state[moduleName].locale;
    return translateInLanguage.apply(void 0, [locale].concat(Array.prototype.slice.call(arguments)));
  }; // get localized string from store in a given language if available.
  // there are two possible signatures for the function.
  // we will check the arguments to make up the options passed.
  // 1: locale, key, options, pluralization
  // 2: locale, key, defaultValue, options, pluralization


  var translateInLanguage = function translateInLanguage(locale) {
    // read the function arguments
    var args = arguments; // initialize options

    var key = '';
    var defaultValue = '';
    var options = {};
    var pluralization = null;
    var count = args.length; // check if a default value was specified and fill options accordingly

    if (count >= 3 && typeof args[2] === 'string') {
      key = args[1];
      defaultValue = args[2];

      if (count > 3) {
        options = args[3];
      }

      if (count > 4) {
        pluralization = args[4];
      }
    } else {
      key = args[1]; // default value was not specified and is therefore the same as the key

      defaultValue = key;

      if (count > 2) {
        options = args[2];
      }

      if (count > 3) {
        pluralization = args[3];
      }
    } // return the default value if the locale is not set (could happen on initialization)


    if (!locale) {
      if (config.warnings) console.warn('i18n: i18n locale is not set when trying to access translations:', key);
      return defaultValue;
    } // get the translations from the store


    var translations = store.state[moduleName].translations; // get the last resort fallback from the store

    var fallback = store.state[moduleName].fallback; // split locale by - to support partial fallback for regional locales
    // like de-CH, en-UK

    var localeRegional = locale.split('-'); // flag for translation to exist or not

    var translationExists = true; // check if the language exists in the store. return the key if not

    if (translations.hasOwnProperty(locale) === false) {
      translationExists = false; // check if the key exists in the store. return the key if not
    } else if (translations[locale].hasOwnProperty(key) === false) {
      translationExists = false;
    } // return the value from the store


    if (translationExists === true) {
      return render(locale, translations[locale][key], options, pluralization);
    } // check if a regional locale translation would be available for the key
    // i.e. de for de-CH


    if (localeRegional.length > 1 && translations.hasOwnProperty(localeRegional[0]) === true && translations[localeRegional[0]].hasOwnProperty(key) === true) {
      return render(localeRegional[0], translations[localeRegional[0]][key], options, pluralization);
    } // invoke a method if a translation is not found


    var asyncTranslation = onTranslationNotFound(locale, key, defaultValue); // resolve async translations by updating the store

    if (asyncTranslation) {
      Promise.resolve(asyncTranslation).then(function (value) {
        var additionalTranslations = {};
        additionalTranslations[key] = value;
        addLocale(locale, additionalTranslations);
      });
    } // check if a vaild fallback exists in the store.
    // return the default value if not


    if (translations.hasOwnProperty(fallback) === false) {
      return render(locale, defaultValue, options, pluralization);
    } // check if the key exists in the fallback locale in the store.
    // return the default value if not


    if (translations[fallback].hasOwnProperty(key) === false) {
      return render(fallback, defaultValue, options, pluralization);
    }

    return render(locale, translations[fallback][key], options, pluralization);
  }; // add a filter function to translate in a given locale (i.e. {{ 'something' | translateIn('en') }})


  var translateInLanguageFilter = function translateInLanguageFilter(key, locale) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return translateInLanguage.apply(void 0, [locale, key].concat(args));
  }; // check if the given key exists in the current locale


  var checkKeyExists = function checkKeyExists(key) {
    var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fallback';
    // get the current language from the store
    var locale = store.state[moduleName].locale;
    var fallback = store.state[moduleName].fallback;
    var translations = store.state[moduleName].translations; // check the current translation

    if (translations.hasOwnProperty(locale) && translations[locale].hasOwnProperty(key)) {
      return true;
    }

    if (scope == 'strict') {
      return false;
    } // check any localized translations


    var localeRegional = locale.split('-');

    if (localeRegional.length > 1 && translations.hasOwnProperty(localeRegional[0]) && translations[localeRegional[0]].hasOwnProperty(key)) {
      return true;
    }

    if (scope == 'locale') {
      return false;
    } // check if a fallback locale exists


    if (translations.hasOwnProperty(fallback) && translations[fallback].hasOwnProperty(key)) {
      return true;
    } // key does not exist in the store


    return false;
  }; // set fallback locale


  var setFallbackLocale = function setFallbackLocale(locale) {
    store.dispatch({
      type: "".concat(moduleName, "/setFallbackLocale"),
      locale: locale
    });
  }; // set the current locale


  var setLocale = function setLocale(locale) {
    store.dispatch({
      type: "".concat(moduleName, "/setLocale"),
      locale: locale
    });
  }; // get the current locale


  var getLocale = function getLocale() {
    return store.state[moduleName].locale;
  }; // get all available locales


  var getLocales = function getLocales() {
    return Object.keys(store.state[moduleName].translations);
  }; // add predefined translations to the store (keeping existing information)


  var addLocale = function addLocale(locale, translations) {
    return store.dispatch({
      type: "".concat(moduleName, "/addLocale"),
      locale: locale,
      translations: translations
    });
  }; // replace all locale information in the store


  var replaceLocale = function replaceLocale(locale, translations) {
    return store.dispatch({
      type: "".concat(moduleName, "/replaceLocale"),
      locale: locale,
      translations: translations
    });
  }; // remove the givne locale from the store


  var removeLocale = function removeLocale(locale) {
    if (store.state[moduleName].translations.hasOwnProperty(locale)) {
      store.dispatch({
        type: "".concat(moduleName, "/removeLocale"),
        locale: locale
      });
    }
  }; // we are phasing out the exists function


  var phaseOutExistsFn = function phaseOutExistsFn(locale) {
    if (config.warnings) console.warn('i18n: $i18n.exists is depreceated. Please use $i18n.localeExists instead. It provides exactly the same functionality.');
    return checkLocaleExists(locale);
  }; // check if the given locale is already loaded


  var checkLocaleExists = function checkLocaleExists(locale) {
    return store.state[moduleName].translations.hasOwnProperty(locale);
  }; // register vue prototype methods


  Vue.prototype.$i18n = {
    locale: getLocale,
    locales: getLocales,
    set: setLocale,
    add: addLocale,
    replace: replaceLocale,
    remove: removeLocale,
    fallback: setFallbackLocale,
    localeExists: checkLocaleExists,
    keyExists: checkKeyExists,
    translate: translate,
    translateIn: translateInLanguage,
    exists: phaseOutExistsFn
  }; // register global methods

  Vue.i18n = {
    locale: getLocale,
    locales: getLocales,
    set: setLocale,
    add: addLocale,
    replace: replaceLocale,
    remove: removeLocale,
    fallback: setFallbackLocale,
    translate: translate,
    translateIn: translateInLanguage,
    localeExists: checkLocaleExists,
    keyExists: checkKeyExists,
    exists: phaseOutExistsFn
  }; // register the translation function on the vue instance directly

  Vue.prototype.$t = translate; // register the specific language translation function on the vue instance directly

  Vue.prototype.$tlang = translateInLanguage; // register a filter function for translations

  Vue.filter(translateFilterName, translate);
  Vue.filter(translateInFilterName, translateInLanguageFilter);
}; // renderFn will initialize a function to render the variable substitutions in
// the translation string. identifiers specify the tags will be used to find
// variable substitutions, i.e. {test} or {{test}}, note that we are using a
// closure to avoid recompilation of the regular expression to match tags on
// every render cycle.


var renderFn = function renderFn(identifiers) {
  var warnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (identifiers == null || identifiers.length != 2) {
    console.warn('i18n: You must specify the start and end character identifying variable substitutions');
  } // construct a regular expression ot find variable substitutions, i.e. {test}


  var matcher = new RegExp('' + identifiers[0] + '{1}(\\w{1}|\\w.+?)' + identifiers[1] + '{1}', 'g'); // define the replacement function

  var replace = function replace(translation, replacements) {
    // check if the object has a replace property
    if (!translation.replace) {
      return translation;
    }

    return translation.replace(matcher, function (placeholder) {
      // remove the identifiers (can be set on the module level)
      var key = placeholder.replace(identifiers[0], '').replace(identifiers[1], '');

      if (replacements[key] !== undefined) {
        return replacements[key];
      } // warn user that the placeholder has not been found


      if (warnings) {
        console.group ? console.group('i18n: Not all placeholders found') : console.warn('i18n: Not all placeholders found');
        console.warn('Text:', translation);
        console.warn('Placeholder:', placeholder);

        if (console.groupEnd) {
          console.groupEnd();
        }
      } // return the original placeholder


      return placeholder;
    });
  }; // the render function will replace variable substitutions and prepare the
  // translations for rendering


  var render = function render(locale, translation) {
    var replacements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var pluralization = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    // get the type of the property
    var objType = _typeof(translation);

    var pluralizationType = _typeof(pluralization);

    var resolvePlaceholders = function resolvePlaceholders() {
      if (isArray$1(translation)) {
        // replace the placeholder elements in all sub-items
        return translation.map(function (item) {
          return replace(item, replacements, false);
        });
      } else if (objType === 'string') {
        return replace(translation, replacements, true);
      }
    }; // return translation item directly


    if (pluralization === null) {
      return resolvePlaceholders();
    } // check if pluralization value is countable


    if (pluralizationType !== 'number') {
      if (warnings) console.warn('i18n: pluralization is not a number');
      return resolvePlaceholders();
    } // --- handle pluralizations ---
    // replace all placeholders


    var resolvedTranslation = resolvePlaceholders(); // initialize pluralizations

    var pluralizations = null; // if translations are already an array and have more than one entry,
    // we will not perform a split operation on :::

    if (isArray$1(resolvedTranslation) && resolvedTranslation.length > 0) {
      pluralizations = resolvedTranslation;
    } else {
      // split translation strings by ::: to find create the pluralization array
      pluralizations = resolvedTranslation.split(':::');
    } // determine the pluralization version to use by locale


    var index = plurals.getTranslationIndex(locale, pluralization); // check if the specified index is present in the pluralization

    if (typeof pluralizations[index] === 'undefined') {
      if (warnings) {
        console.warn('i18n: pluralization not provided in locale', translation, locale, index);
      } // return the first element of the pluralization by default


      return pluralizations[0].trim();
    } // return the requested item from the pluralizations


    return pluralizations[index].trim();
  }; // return the render function to the caller


  return render;
}; // check if the given object is an array


function isArray$1(obj) {
  return !!obj && Array === obj.constructor;
}

// import the vuex module for localization

var index = {
  store: i18nVuexModule,
  plugin: VuexI18nPlugin
};

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 1729 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************!*\
  !*** ./~/vuex-persistedstate/dist/vuex-persistedstate.es.js ***!
  \**************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var r=function(r){return function(r){return!!r&&"object"==typeof r}(r)&&!function(r){var t=Object.prototype.toString.call(r);return"[object RegExp]"===t||"[object Date]"===t||function(r){return r.$$typeof===e}(r)}(r)},e="function"==typeof Symbol&&Symbol.for?Symbol.for("react.element"):60103;function t(r,e){return!1!==e.clone&&e.isMergeableObject(r)?c(Array.isArray(r)?[]:{},r,e):r}function n(r,e,n){return r.concat(e).map(function(r){return t(r,n)})}function o(r){return Object.keys(r).concat(function(r){return Object.getOwnPropertySymbols?Object.getOwnPropertySymbols(r).filter(function(e){return r.propertyIsEnumerable(e)}):[]}(r))}function u(r,e){try{return e in r}catch(r){return!1}}function c(e,i,a){(a=a||{}).arrayMerge=a.arrayMerge||n,a.isMergeableObject=a.isMergeableObject||r,a.cloneUnlessOtherwiseSpecified=t;var f=Array.isArray(i);return f===Array.isArray(e)?f?a.arrayMerge(e,i,a):function(r,e,n){var i={};return n.isMergeableObject(r)&&o(r).forEach(function(e){i[e]=t(r[e],n)}),o(e).forEach(function(o){(function(r,e){return u(r,e)&&!(Object.hasOwnProperty.call(r,e)&&Object.propertyIsEnumerable.call(r,e))})(r,o)||(i[o]=u(r,o)&&n.isMergeableObject(e[o])?function(r,e){if(!e.customMerge)return c;var t=e.customMerge(r);return"function"==typeof t?t:c}(o,n)(r[o],e[o],n):t(e[o],n))}),i}(e,i,a):t(i,a)}c.all=function(r,e){if(!Array.isArray(r))throw new Error("first argument should be an array");return r.reduce(function(r,t){return c(r,t,e)},{})};var i=c;function a(r,e,t){return void 0===(r=(e.split?e.split("."):e).reduce(function(r,e){return r&&r[e]},r))?t:r}/* harmony default export */ __webpack_exports__["default"] = (function(r,e,t){function n(r,e,t){try{return(t=e.getItem(r))&&void 0!==t?JSON.parse(t):void 0}catch(r){}}if(e=(r=r||{}).storage||window&&window.localStorage,t=r.key||"vuex",!function(r){try{return r.setItem("@@",1),r.removeItem("@@"),!0}catch(r){}return!1}(e))throw new Error("Invalid storage instance given");var o,u=function(){return a(r,"getState",n)(t,e)};return r.fetchBeforeUse&&(o=u()),function(n){r.fetchBeforeUse||(o=u()),"object"==typeof o&&null!==o&&(n.replaceState(i(n.state,o,{arrayMerge:r.arrayMerger||function(r,e){return e},clone:!1})),(r.rehydrated||function(){})(n)),(r.subscriber||function(r){return function(e){return r.subscribe(e)}})(n)(function(n,o){(r.filter||function(){return!0})(n)&&(r.setState||function(r,e,t){return t.setItem(r,JSON.stringify(e))})(t,(r.reducer||function(r,e){return 0===e.length?r:e.reduce(function(e,t){return function(r,e,t,n){return(e=e.split?e.split("."):e).slice(0,-1).reduce(function(r,e){return r[e]=r[e]||{}},r)[e.pop()]=t,r}(e,t,a(r,t))},{})})(o,r.paths||[]),e)})}});
//# sourceMappingURL=vuex-persistedstate.es.js.map


/***/ }),
/* 1730 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./~/vuex-router-sync/index.js ***!
  \*************************************/
/***/ (function(module, exports) {

exports.sync = function (store, router, options) {
  var moduleName = (options || {}).moduleName || 'route'

  store.registerModule(moduleName, {
    namespaced: true,
    state: cloneRoute(router.currentRoute),
    mutations: {
      'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
        store.state[moduleName] = cloneRoute(transition.to, transition.from)
      }
    }
  })

  var isTimeTraveling = false
  var currentPath

  // sync router on store change
  var storeUnwatch = store.watch(
    function (state) { return state[moduleName]; },
    function (route) {
      var fullPath = route.fullPath;
      if (fullPath === currentPath) {
        return
      }
      if (currentPath != null) {
        isTimeTraveling = true
        router.push(route)
      }
      currentPath = fullPath
    },
    { sync: true }
  )

  // sync store on router navigation
  var afterEachUnHook = router.afterEach(function (to, from) {
    if (isTimeTraveling) {
      isTimeTraveling = false
      return
    }
    currentPath = to.fullPath
    store.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
  })

  return function unsync () {
    // On unsync, remove router hook
    if (afterEachUnHook != null) {
      afterEachUnHook()
    }

    // On unsync, remove store watch
    if (storeUnwatch != null) {
      storeUnwatch()
    }

    // On unsync, unregister Module with store
    store.unregisterModule(moduleName)
  }
}

function cloneRoute (to, from) {
  var clone = {
    name: to.name,
    path: to.path,
    hash: to.hash,
    query: to.query,
    params: to.params,
    fullPath: to.fullPath,
    meta: to.meta
  }
  if (from) {
    clone.from = cloneRoute(from)
  }
  return Object.freeze(clone)
}



/***/ }),
/* 1731 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** (webpack)/buildin/amd-define.js ***!
  \***************************************/
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1732 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** multi ./client/index.js ./client/template/pages/js/pages.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./client/index.js */716);
module.exports = __webpack_require__(/*! ./client/template/pages/js/pages.js */717);


/***/ })
],[1732]);


// WEBPACK FOOTER //
// main.a630db9e.js